// @ts-nocheck

import { gql } from '@apollo/client'

import { graphql, type GraphQLResponseResolver, type RequestHandlerOptions } from 'msw'
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };

type RevealType<T extends string[], U, Nullable extends boolean = false> = T extends [infer First, ...infer Rest]
  ? Rest extends string[]
    ? First extends keyof U
      ? RevealType<
        Rest,
        NonNullable<U[First]>,
        Nullable extends true ? true : undefined extends U[First] ? true : false
      >
      : never
    : never
  : (true extends Nullable ? (U | null | undefined) : U)

type RemoveArrayAndNull<T> = T extends Array<any>
  ? NonNullable<T[number]>
  : NonNullable<T>

export type DataTableSource<T, S> = {
  identifier: string
  query: any
  projections: DataTableProjection<T, S>[]
  resolver: {
    dataSource: (data: any) => any
    edges: (data: any) => any
    fields: Exact<Record<keyof T, (data: any) => any>>
  },
  sort: {
    default?: S,
    fields: S[],
  },
  variables?: any
}

export const ProjectionKind = {
  Path: 'path',
  Custom: 'custom',
  Decorative: 'decorative',
} as const

type DataTableProjectionFixed = {
  // If the projection sticky, we need to enforce that is fixed
  sticky: true
  fixed: true
} | {
  fixed?: boolean
}

type DataTableProjectionBase = {
  width?: number
  colSpan?: number
  identifier: string
  justifyContent?: JustifyContent
  textAlign?: TextAlign
} & DataTableProjectionFixed

type DataTableProjectionColumn = {
  title: string
  hidden?: boolean
  tooltip?: string
}

type DataTableProjectionPath<T> = DataTableProjectionBase & DataTableProjectionColumn & {
  kind: typeof ProjectionKind.Path,
  path: keyof T
}

type DataTableProjectionCustom<T, S extends string, P extends keyof T> = DataTableProjectionBase & DataTableProjectionColumn & {
  kind: typeof ProjectionKind.Custom,
  render: (object: Pick<T, P>, index: number) => React.ReactNode
  template: string
  sortBy?: S
}

type DataTableProjectionDecorative<T, P extends keyof T> = DataTableProjectionBase & {
  kind: typeof ProjectionKind.Decorative,
  render: (object: Pick<T, P>, index: number) => React.ReactNode
}

export type DataTableProjection<T, S extends string> =
  | DataTableProjectionPath<T>
  | DataTableProjectionCustom<T, S, (keyof T)>
  | DataTableProjectionDecorative<T, (keyof T)>

export const FilterType = {
  String: 'string',
  Integer: 'integer',
  Date: 'date',
  Boolean: 'boolean',
  Entity: 'entity'
} as const

export type SingleChoiceFilter<Value> = {
  kind: 'SingleChoice',
  operation: 'eq' | 'notEq' | 'in' | 'gt' | 'gteq' | 'lt' | 'lteq',
  options: {
    label: string,
    value: Value | Value[],
    component?: React.ReactNode,
  }[],
  value?: Value
}

export type DocumentsFolderChoiceFilter<Value> = {
  kind: 'DocumentsFolderChoice',
  operation: 'eq',
  options: Folder[],
  value?: Value
}

export type DatePickerFilter = DatePicker | DateTimePicker

export type DatePicker = {
  kind: 'DatePicker'
} & (
  | {
      operation: 'eq'
      value?: string
    }
  | {
      operation: 'between'
      value?: [string, string]
    }
)

export type DateTimePicker = {
  kind: 'DateTimePicker'
} & (
  | {
      operation: 'eq'
      value?: string
    }
  | {
      operation: 'between'
      value?: [string, string]
    }
)

export type MultipleChoiceFilter<Value> = {
  kind: 'MultipleChoice',
  operation: 'in',
  options: {
    label: string,
    value: Value,
    component?: React.ReactNode,
  }[],
  value?: Value[],
  hideSearch?: boolean
}

export type SearchFilter = {
  kind: 'SearchFilter',
  operation: 'contains',
  value?: string
}

export type EntityFilter = {
  kind: 'Entity',
  operation: 'in',
  component: () => React.ReactNode,
  value?: unknown
  nameAttribute: string
}

export type EmployeeFilter = {
  kind: 'Employee',
  operation: 'in',
  value?: unknown
  nameAttribute?: string
}

export type RangeFilter = {
  kind: 'RangePicker',
  operation: 'between',
  value?: [number, number]
  range: [number, number]
}

export type FreeField<Value> = {
  kind: 'FreeField',
  operation: 'eq',
  value?: Value,
  description?: string
  validation?: (value: string) => boolean
  errorMessage?: string
  options?: {
    label: string,
    value: Value,
    component?: React.ReactNode,
  }[],
}

export type IntegerFilterCategory = MultipleChoiceFilter<number> | SingleChoiceFilter<number> | DocumentsFolderChoiceFilter<number> | FreeField<number> | RangeFilter

export type StringFilterCategory = SingleChoiceFilter<string> | MultipleChoiceFilter<string> | SearchFilter | FreeField<string>

export type DateFilterCategory = DatePickerFilter // | OtherFilter

export type BooleanFilterCategory = SingleChoiceFilter<boolean>

export type EntityFilterCategory = EntityFilter | EmployeeFilter

type DataTableFilterBase<T> = {
  identifier: string
  title: string
  default?: boolean
  path: keyof T
  onUpdateValue?: (filter?: Filter<T>) => void
}

export type DataTableStringFilter<T> = DataTableFilterBase<T> & {
  type: typeof FilterType.String,
  categories: StringFilterCategory[]
}

export type DataTableIntegerFilter<T> = DataTableFilterBase<T> & {
  type: typeof FilterType.Integer,
  categories: IntegerFilterCategory[]
}

export type DataTableDateFilter<T> = DataTableFilterBase<T> & {
  type: typeof FilterType.Date,
  categories: DateFilterCategory[]
}

export type DataTableBooleanFilter<T> = DataTableFilterBase<T> & {
  type: typeof FilterType.Boolean,
  categories: BooleanFilterCategory[]
}

export type DataTableEntityFilter<T> = DataTableFilterBase<T> & {
  type: typeof FilterType.Entity
  categories: EntityFilterCategory[]
}

export type DataTableFilter<T> =
  | DataTableDateFilter<T>
  | DataTableStringFilter<T>
  | DataTableIntegerFilter<T>
  | DataTableBooleanFilter<T>
  | DataTableEntityFilter<T>

export type Export = 'csv' | 'xlsx' | false

/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /**
   * Represents non-fractional signed whole numeric values. Since the value may
   * exceed the size of a 32-bit integer, it's encoded as a string.
   */
  BigInt: any;
  /** A file to be uploaded */
  File: any;
  /** An ISO 8601-encoded date */
  ISO8601Date: string;
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: any;
};

/** Autogenerated return type of AcceptAtsOfferLetter. */
export type AcceptAtsOfferLetterPayload = {
  __typename?: 'AcceptAtsOfferLetterPayload';
  errors: Array<MutationError>;
  offerLetter?: Maybe<AtsOfferLetter>;
};

/** Autogenerated return type of AcceptCronofyschedulingCalendarSync. */
export type AcceptCronofyschedulingCalendarSyncPayload = {
  __typename?: 'AcceptCronofyschedulingCalendarSyncPayload';
  calendarSync?: Maybe<CronofySchedulingCalendarSync>;
  errors: Array<MutationError>;
};

export type AccessAffiliationEnum =
  | 'employee'
  | 'external'
  | 'partner';

export type AccessRoleEnum =
  | 'admin'
  | 'basic';

/** A group of settings related to the account (tenant) at Factorial */
export type AccountSettingsCategory = {
  __typename?: 'AccountSettingsCategory';
  icon: Scalars['String'];
  id: Scalars['String'];
  settings: Array<AccountSettingsSetting>;
  settingsConnection: AccountSettingsSettingConnection;
  title: Scalars['String'];
};


/** A group of settings related to the account (tenant) at Factorial */
export type AccountSettingsCategorySettingsArgs = {
  companyId: Scalars['Int'];
  ids?: InputMaybe<Array<Scalars['String']>>;
};


/** A group of settings related to the account (tenant) at Factorial */
export type AccountSettingsCategorySettingsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for AccountSettingsCategory. */
export type AccountSettingsCategoryConnection = {
  __typename?: 'AccountSettingsCategoryConnection';
  /** A list of edges. */
  edges: Array<AccountSettingsCategoryEdge>;
  /** A list of nodes. */
  nodes: Array<AccountSettingsCategory>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AccountSettingsCategoryEdge = {
  __typename?: 'AccountSettingsCategoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AccountSettingsCategory;
};

/** Settings related to the account (tenant) to expose to users so they can configure Factorial */
export type AccountSettingsSetting = {
  __typename?: 'AccountSettingsSetting';
  category: AccountSettingsCategory;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  categoryId: Scalars['String'];
  description: Scalars['String'];
  hidden: Scalars['Boolean'];
  icon: Scalars['String'];
  id: Scalars['String'];
  keywords?: Maybe<Array<Scalars['String']>>;
  missingInformation: Scalars['Boolean'];
  title: Scalars['String'];
  url: Scalars['String'];
};

/** The connection type for AccountSettingsSetting. */
export type AccountSettingsSettingConnection = {
  __typename?: 'AccountSettingsSettingConnection';
  /** A list of edges. */
  edges: Array<AccountSettingsSettingEdge>;
  /** A list of nodes. */
  nodes: Array<AccountSettingsSetting>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AccountSettingsSettingEdge = {
  __typename?: 'AccountSettingsSettingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AccountSettingsSetting;
};

/** Autogenerated return type of ActivateBankingCard. */
export type ActivateBankingCardPayload = {
  __typename?: 'ActivateBankingCardPayload';
  card?: Maybe<BankingCard>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of ActivateCompanyPageCompaniesCompany. */
export type ActivateCompanyPageCompaniesCompanyPayload = {
  __typename?: 'ActivateCompanyPageCompaniesCompanyPayload';
  company?: Maybe<CompaniesCompany>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of ActivateFeatureTeamsTeamChart. */
export type ActivateFeatureTeamsTeamChartPayload = {
  __typename?: 'ActivateFeatureTeamsTeamChartPayload';
  errors: Array<MutationError>;
  teamChart?: Maybe<TeamsTeamChart>;
};

/** Autogenerated return type of ActivateProjectmanagementProject. */
export type ActivateProjectmanagementProjectPayload = {
  __typename?: 'ActivateProjectmanagementProjectPayload';
  errors: Array<MutationError>;
  project?: Maybe<ProjectManagementProject>;
};

/** A repository to retrieve the current logs */
export type ActivityLogLog = {
  __typename?: 'ActivityLogLog';
  authorEmployeeId?: Maybe<Scalars['Int']>;
  authorId?: Maybe<Scalars['Int']>;
  avatar?: Maybe<Scalars['String']>;
  changes: Array<Scalars['String']>;
  description: Scalars['String'];
  id?: Maybe<Scalars['Int']>;
  link?: Maybe<Scalars['String']>;
  logDate: Scalars['ISO8601DateTime'];
  parentResourceId?: Maybe<Scalars['Int']>;
  source: Scalars['String'];
};

/** The connection type for ActivityLogLog. */
export type ActivityLogLogConnection = {
  __typename?: 'ActivityLogLogConnection';
  /** A list of edges. */
  edges: Array<ActivityLogLogEdge>;
  /** A list of nodes. */
  nodes: Array<ActivityLogLog>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ActivityLogLogEdge = {
  __typename?: 'ActivityLogLogEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ActivityLogLog;
};

/** Autogenerated return type of AddAudioChunkMeetingsTranscriptionSession. */
export type AddAudioChunkMeetingsTranscriptionSessionPayload = {
  __typename?: 'AddAudioChunkMeetingsTranscriptionSessionPayload';
  errors: Array<MutationError>;
  transcriptionSessions?: Maybe<Array<MeetingsTranscriptionSession>>;
};

export type AddCardSoftwaremanagementSoftwareSetupCardholderDataInput = {
  dateOfBirth: Scalars['ISO8601Date'];
  email?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phoneCountryCode: Scalars['String'];
  phoneNumber: Scalars['String'];
};

/** Autogenerated return type of AddCardSoftwaremanagementSoftwareSetup. */
export type AddCardSoftwaremanagementSoftwareSetupPayload = {
  __typename?: 'AddCardSoftwaremanagementSoftwareSetupPayload';
  errors: Array<MutationError>;
  softwareSetup?: Maybe<SoftwareManagementSoftwareSetup>;
};

/** Autogenerated return type of AddCompetenciesJobcatalogRole. */
export type AddCompetenciesJobcatalogRolePayload = {
  __typename?: 'AddCompetenciesJobcatalogRolePayload';
  errors: Array<MutationError>;
  role?: Maybe<JobCatalogRole>;
};

/** Autogenerated return type of AddCompetencyJobcatalogRole. */
export type AddCompetencyJobcatalogRolePayload = {
  __typename?: 'AddCompetencyJobcatalogRolePayload';
  errors: Array<MutationError>;
  role?: Maybe<JobCatalogRole>;
};

/** Autogenerated return type of AddEmployeesAttendanceEmployeesPolicy. */
export type AddEmployeesAttendanceEmployeesPolicyPayload = {
  __typename?: 'AddEmployeesAttendanceEmployeesPolicyPayload';
  employeesPolicy?: Maybe<AttendanceEmployeesPolicy>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of AddFaviconAtsCompany. */
export type AddFaviconAtsCompanyPayload = {
  __typename?: 'AddFaviconAtsCompanyPayload';
  company?: Maybe<AtsCompany>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of AddLegalEntitiesJobcatalogRole. */
export type AddLegalEntitiesJobcatalogRolePayload = {
  __typename?: 'AddLegalEntitiesJobcatalogRolePayload';
  errors: Array<MutationError>;
  role?: Maybe<JobCatalogRole>;
};

/** Autogenerated return type of AddMembersPermissionsPermissionGroup. */
export type AddMembersPermissionsPermissionGroupPayload = {
  __typename?: 'AddMembersPermissionsPermissionGroupPayload';
  errors: Array<MutationError>;
  permissionGroup?: Maybe<PermissionsPermissionGroup>;
};

/** Autogenerated return type of AddOneononesTalkingPoint. */
export type AddOneononesTalkingPointPayload = {
  __typename?: 'AddOneononesTalkingPointPayload';
  errors: Array<MutationError>;
  talkingPoint?: Maybe<OneOnOnesTalkingPoint>;
};

/** Autogenerated return type of AddPaymentRequestsBankingPayment. */
export type AddPaymentRequestsBankingPaymentPayload = {
  __typename?: 'AddPaymentRequestsBankingPaymentPayload';
  errors: Array<MutationError>;
  payment?: Maybe<BankingPayment>;
};

/** Autogenerated return type of AddPeersPerformanceReviewProcessTarget. */
export type AddPeersPerformanceReviewProcessTargetPayload = {
  __typename?: 'AddPeersPerformanceReviewProcessTargetPayload';
  errors: Array<MutationError>;
  reviewProcessTarget?: Maybe<PerformanceReviewProcessTarget>;
};

/** Autogenerated return type of AddPerformanceAgreementActionItem. */
export type AddPerformanceAgreementActionItemPayload = {
  __typename?: 'AddPerformanceAgreementActionItemPayload';
  agreementActionItem?: Maybe<PerformanceAgreementActionItem>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of AddResultConceptItemsPayrollResult. */
export type AddResultConceptItemsPayrollResultPayload = {
  __typename?: 'AddResultConceptItemsPayrollResultPayload';
  errors: Array<MutationError>;
  result?: Maybe<PayrollResult>;
};

export type AddResultConceptItemsPayrollResultResultConceptItemsInput = {
  amount: Scalars['Int'];
  employeeId: Scalars['Int'];
  payrollConceptId: Scalars['Int'];
};

/** Autogenerated return type of AddSupervisorsJobcatalogRole. */
export type AddSupervisorsJobcatalogRolePayload = {
  __typename?: 'AddSupervisorsJobcatalogRolePayload';
  errors: Array<MutationError>;
  role?: Maybe<JobCatalogRole>;
};

/** Autogenerated return type of AddTagAtsCandidate. */
export type AddTagAtsCandidatePayload = {
  __typename?: 'AddTagAtsCandidatePayload';
  candidate?: Maybe<AtsCandidate>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of AddToPayrollExpensesExpensableGroup. */
export type AddToPayrollExpensesExpensableGroupPayload = {
  __typename?: 'AddToPayrollExpensesExpensableGroupPayload';
  errors: Array<MutationError>;
  expensableGroup?: Maybe<ExpensesExpensableGroup>;
};

/** Autogenerated return type of AddTrainingRequestPerformanceAgreement. */
export type AddTrainingRequestPerformanceAgreementPayload = {
  __typename?: 'AddTrainingRequestPerformanceAgreementPayload';
  agreement?: Maybe<PerformanceAgreement>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of AddTransfersBankingPayment. */
export type AddTransfersBankingPaymentPayload = {
  __typename?: 'AddTransfersBankingPaymentPayload';
  errors: Array<MutationError>;
  payment?: Maybe<BankingPayment>;
};

/** Autogenerated return type of AggregateCompensationsPayrollRunEmployeesCompensation. */
export type AggregateCompensationsPayrollRunEmployeesCompensationPayload = {
  __typename?: 'AggregateCompensationsPayrollRunEmployeesCompensationPayload';
  errors: Array<MutationError>;
  payrollRunEmployeesCompensation?: Maybe<CompensationsPayrollRunEmployeesCompensation>;
};

export type AlertSource = ExpensesExpensable | FinanceSpendingPolicy | FinanceSpendingPolicyRuleGroup;

export type AlertTarget = ExpensesExpensable | FinanceSpendingPolicyRuleGroup;

export type AmountStrategy = ContractsFixedAmountStrategy | ContractsVariableAmountStrategy;

export type AnalyticsContextlessPolicies = {
  __typename?: 'AnalyticsContextlessPolicies';
  sidebarSeeAnalyticsInsightsSubLevelItem: ContextlessPolicyResolution;
  sidebarSeeAnalyticsReportsSubLevelItem: ContextlessPolicyResolution;
  sidebarSeeAnalyticsTopLevelItem: ContextlessPolicyResolution;
};

export type AnalyticsFormatHint = {
  __typename?: 'AnalyticsFormatHint';
  columnDisplayName: Scalars['String'];
  formatHint: IrisValueObjectsFormatHintEnum;
};

export type AnalyticsFormatHintInput = {
  columnDisplayName: Scalars['String'];
  formatHint: IrisValueObjectsFormatHintEnum;
};

export type AnalyticsPosition = {
  __typename?: 'AnalyticsPosition';
  height: Scalars['Int'];
  width: Scalars['Int'];
  x: Scalars['Int'];
  y: Scalars['Int'];
};

export type AnalyticsPositionInput = {
  height: Scalars['Int'];
  width: Scalars['Int'];
  x: Scalars['Int'];
  y: Scalars['Int'];
};

/** A collection of business metrics in various representations. */
export type AnalyticsReport = {
  __typename?: 'AnalyticsReport';
  author?: Maybe<EmployeesEmployeeName>;
  /**
   * Employee ID of the user who created the report
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  authorId: Scalars['String'];
  /** Time the report was created */
  createdAt: Scalars['ISO8601DateTime'];
  datasource?: Maybe<IrisFactTable>;
  /**
   * ID of the datasource from which the report data is derived
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  datasourceId: Scalars['String'];
  description: Scalars['String'];
  filters?: Maybe<AnalyticsReportFilters>;
  formatHints: Array<AnalyticsFormatHint>;
  /** This report's ID */
  id: Scalars['String'];
  /** User defined name */
  name: Scalars['String'];
  /** Time the report was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
  widgets: Array<AnalyticsWidget>;
};


/** A collection of business metrics in various representations. */
export type AnalyticsReportAuthorArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  afterEmployeeId?: InputMaybe<Scalars['Int']>;
  beforeEmployeeId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  reporteesOrLed?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyId?: InputMaybe<Scalars['Int']>;
  verb?: InputMaybe<Scalars['String']>;
  withActiveContract?: Scalars['Boolean'];
};


/** A collection of business metrics in various representations. */
export type AnalyticsReportDatasourceArgs = {
  companyId: Scalars['Int'];
};

/** The connection type for AnalyticsReport. */
export type AnalyticsReportConnection = {
  __typename?: 'AnalyticsReportConnection';
  /** A list of edges. */
  edges: Array<AnalyticsReportEdge>;
  /** A list of nodes. */
  nodes: Array<AnalyticsReport>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AnalyticsReportEdge = {
  __typename?: 'AnalyticsReportEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AnalyticsReport;
};

/** the filter for the reports resource */
export type AnalyticsReportFilter = {
  authorId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  datasourceId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<AnalyticsReportFilterConditions>>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type AnalyticsReportFilterConditions = {
  authorId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  datasourceId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type AnalyticsReportFilters = {
  __typename?: 'AnalyticsReportFilters';
  dateRange?: Maybe<AnalyticsTraceabilityTimeRange>;
  jsonLogicFilters: Scalars['String'];
  snapshotDate?: Maybe<Scalars['ISO8601DateTime']>;
};

export type AnalyticsReportFiltersInput = {
  dateRange?: InputMaybe<AnalyticsTraceabilityTimeRangeInput>;
  jsonLogicFilters: Scalars['String'];
  snapshotDate?: InputMaybe<Scalars['ISO8601DateTime']>;
};

export type AnalyticsTraceabilityTimeRange = {
  __typename?: 'AnalyticsTraceabilityTimeRange';
  from: Scalars['ISO8601DateTime'];
  to: Scalars['ISO8601DateTime'];
};

export type AnalyticsTraceabilityTimeRangeInput = {
  from: Scalars['ISO8601DateTime'];
  to: Scalars['ISO8601DateTime'];
};

export type AnalyticsWidget = {
  __typename?: 'AnalyticsWidget';
  description: Scalars['String'];
  name: Scalars['String'];
  position: AnalyticsPosition;
  query: Scalars['String'];
};

export type AnalyticsWidgetInput = {
  description: Scalars['String'];
  name: Scalars['String'];
  position: AnalyticsPositionInput;
  query: Scalars['String'];
};

/** A repository to retrieve the accesses */
export type ApiCoreAccess = {
  __typename?: 'ApiCoreAccess';
  _policies?: Maybe<ApiCoreAccessPolicies>;
  _policiesCollection?: Maybe<Array<PermissionsPolicyResolution>>;
  _policiesConnection: PermissionsPolicyResolutionConnection;
  affiliation: ApiCoreEntitiesAccessAffiliationEnum;
  analyticsConsent?: Maybe<Scalars['Boolean']>;
  avatar?: Maybe<Scalars['String']>;
  avatarFull?: Maybe<Scalars['String']>;
  company: ApiCoreCompany;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  companyId: Scalars['Int'];
  current: Scalars['Boolean'];
  discoverabilityWidgetValue?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  employee?: Maybe<EmployeesEmployee>;
  employeeName?: Maybe<EmployeesEmployeeName>;
  firstDayOfWeek?: Maybe<ApiCoreEntitiesAccessWeekdayEnum>;
  firstName: Scalars['String'];
  fullName: Scalars['String'];
  id: Scalars['Int'];
  invitedOn?: Maybe<Scalars['ISO8601Date']>;
  isConfirmed: Scalars['Boolean'];
  isDeactivated: Scalars['Boolean'];
  isStaff: Scalars['Boolean'];
  lastName: Scalars['String'];
  locale: Scalars['String'];
  npsAttempt: Scalars['Int'];
  npsDue: Scalars['Boolean'];
  permissionGroup?: Maybe<PermissionsPermissionGroup>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  permissionGroupId?: Maybe<Scalars['Int']>;
  personalInfo?: Maybe<UsersPersonalInfo>;
  timeFormat?: Maybe<Scalars['Int']>;
  /** User ID */
  userId: Scalars['Int'];
  /** User ID for relationship matching */
  userIds: Scalars['Int'];
};


/** A repository to retrieve the accesses */
export type ApiCoreAccess_PoliciesCollectionArgs = {
  ids: Array<ApiCoreAccessPoliciesEnum>;
};


/** A repository to retrieve the accesses */
export type ApiCoreAccess_PoliciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** A repository to retrieve the accesses */
export type ApiCoreAccessEmployeeArgs = {
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** A repository to retrieve the accesses */
export type ApiCoreAccessEmployeeNameArgs = {
  afterEmployeeId?: InputMaybe<Scalars['Int']>;
  beforeEmployeeId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  reporteesOrLed?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyId?: InputMaybe<Scalars['Int']>;
  verb?: InputMaybe<Scalars['String']>;
  withActiveContract?: Scalars['Boolean'];
};


/** A repository to retrieve the accesses */
export type ApiCoreAccessPermissionGroupArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  membersEditable?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for ApiCoreAccess. */
export type ApiCoreAccessConnection = {
  __typename?: 'ApiCoreAccessConnection';
  /** A list of edges. */
  edges: Array<ApiCoreAccessEdge>;
  /** A list of nodes. */
  nodes: Array<ApiCoreAccess>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ApiCoreAccessEdge = {
  __typename?: 'ApiCoreAccessEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ApiCoreAccess;
};

/** the filter for the accesses resource */
export type ApiCoreAccessFilter = {
  firstName?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntegerFilter>;
  or?: InputMaybe<Array<ApiCoreAccessFilterConditions>>;
  userId?: InputMaybe<IntegerFilter>;
  userIds?: InputMaybe<IntegerFilter>;
};

export type ApiCoreAccessFilterConditions = {
  firstName?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntegerFilter>;
  userId?: InputMaybe<IntegerFilter>;
  userIds?: InputMaybe<IntegerFilter>;
};

export type ApiCoreAccessPolicies = {
  __typename?: 'ApiCoreAccessPolicies';
  become: PermissionsPolicyResolution;
  invite: PermissionsPolicyResolution;
  update: PermissionsPolicyResolution;
  updateAvatar: PermissionsPolicyResolution;
};

export type ApiCoreAccessPoliciesEnum =
  | 'become'
  | 'invite'
  | 'update'
  | 'update_avatar';

/** A repository to retrieve attachments */
export type ApiCoreAttachment = {
  __typename?: 'ApiCoreAttachment';
  contentType: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  filename: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  recordId: Scalars['Int'];
  recordType: Scalars['String'];
  url: Scalars['String'];
};

/** The connection type for ApiCoreAttachment. */
export type ApiCoreAttachmentConnection = {
  __typename?: 'ApiCoreAttachmentConnection';
  /** A list of edges. */
  edges: Array<ApiCoreAttachmentEdge>;
  /** A list of nodes. */
  nodes: Array<ApiCoreAttachment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ApiCoreAttachmentEdge = {
  __typename?: 'ApiCoreAttachmentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ApiCoreAttachment;
};

/** A repository to retrieve company information */
export type ApiCoreCompany = {
  __typename?: 'ApiCoreCompany';
  bodyFont?: Maybe<Scalars['String']>;
  brandColor?: Maybe<Scalars['String']>;
  countryFactorialDomain?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  currency?: Maybe<Scalars['String']>;
  headerFont?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  industry?: Maybe<Scalars['String']>;
  legalEntities: Array<CompaniesLegalEntity>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  legalEntityIds: Array<Scalars['Int']>;
  legalName?: Maybe<Scalars['String']>;
  legalentitiesConnection: CompaniesLegalEntityConnection;
  locale?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  numberEmployees: Scalars['Int'];
  publicEmail?: Maybe<Scalars['String']>;
  publicUrl?: Maybe<Scalars['String']>;
  size: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
  subscription: BillingSubscription;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  subscriptionId?: Maybe<Scalars['Int']>;
  timeSettingsCustomTimeRangeCategories: Array<TimeSettingsCustomTimeRangeCategory>;
  timeSettingsCustomTimeRangeCategoriesConnection: TimeSettingsCustomTimeRangeCategoryConnection;
  tin?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
  workspaceLogo?: Maybe<Scalars['String']>;
};


/** A repository to retrieve company information */
export type ApiCoreCompanyLegalEntitiesArgs = {
  companiesIds?: InputMaybe<Array<Scalars['Int']>>;
  countryIds?: InputMaybe<Array<Scalars['String']>>;
  employeesIds?: InputMaybe<Array<Scalars['Int']>>;
  excludeCountries?: InputMaybe<Array<Scalars['String']>>;
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


/** A repository to retrieve company information */
export type ApiCoreCompanyLegalentitiesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companiesIds?: InputMaybe<Array<Scalars['Int']>>;
  countryIds?: InputMaybe<Array<Scalars['String']>>;
  employeesIds?: InputMaybe<Array<Scalars['Int']>>;
  excludeCountries?: InputMaybe<Array<Scalars['String']>>;
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


/** A repository to retrieve company information */
export type ApiCoreCompanyTimeSettingsCustomTimeRangeCategoriesArgs = {
  active?: Scalars['Boolean'];
  categoryType?: InputMaybe<TimeSettingsEnumsCategoryTypeEnum>;
  companyId?: InputMaybe<Scalars['Int']>;
  default?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** A repository to retrieve company information */
export type ApiCoreCompanyTimeSettingsCustomTimeRangeCategoriesConnectionArgs = {
  active?: Scalars['Boolean'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  categoryType?: InputMaybe<TimeSettingsEnumsCategoryTypeEnum>;
  companyId?: InputMaybe<Scalars['Int']>;
  default?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for ApiCoreCompany. */
export type ApiCoreCompanyConnection = {
  __typename?: 'ApiCoreCompanyConnection';
  /** A list of edges. */
  edges: Array<ApiCoreCompanyEdge>;
  /** A list of nodes. */
  nodes: Array<ApiCoreCompany>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ApiCoreCompanyEdge = {
  __typename?: 'ApiCoreCompanyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ApiCoreCompany;
};

export type ApiCoreContextlessPolicies = {
  __typename?: 'ApiCoreContextlessPolicies';
  accessCreateExternal: ContextlessPolicyResolution;
  accessDownloadLeaves: ContextlessPolicyResolution;
  accessEnpsCreateForms: ContextlessPolicyResolution;
  accessEnpsSeeForms: ContextlessPolicyResolution;
  accessReadOrgChart: ContextlessPolicyResolution;
  accessReadPeopleChart: ContextlessPolicyResolution;
  accessSurveysSeeForms: ContextlessPolicyResolution;
  companyCreateLegalEntities: ContextlessPolicyResolution;
  companyManageAdmins: ContextlessPolicyResolution;
  companyManageCustomNotifications: ContextlessPolicyResolution;
  companyManageCustomization: ContextlessPolicyResolution;
  companyManagePermissions: ContextlessPolicyResolution;
  companySeeEmployeeProfile: ContextlessPolicyResolution;
  companySeeLegalEntityEmployees: ContextlessPolicyResolution;
  customTablesBulkImport: ContextlessPolicyResolution;
  employeeCreate: ContextlessPolicyResolution;
  manageDiscoverabilityWidget: ContextlessPolicyResolution;
  seeAllSettingsPages: ContextlessPolicyResolution;
  seeReferralProgramPage: ContextlessPolicyResolution;
  sidebarSeeSettingsTopLevelItem: ContextlessPolicyResolution;
};

/** A repository to retrieve the currencies supported in Factorial products */
export type ApiCoreCurrency = {
  __typename?: 'ApiCoreCurrency';
  isoCode: Scalars['String'];
  name: Scalars['String'];
  priority: Scalars['Int'];
  symbol: Scalars['String'];
};

/** The connection type for ApiCoreCurrency. */
export type ApiCoreCurrencyConnection = {
  __typename?: 'ApiCoreCurrencyConnection';
  /** A list of edges. */
  edges: Array<ApiCoreCurrencyEdge>;
  /** A list of nodes. */
  nodes: Array<ApiCoreCurrency>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ApiCoreCurrencyEdge = {
  __typename?: 'ApiCoreCurrencyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ApiCoreCurrency;
};

/** A repository to retrieve the current session information */
export type ApiCoreCurrent = {
  __typename?: 'ApiCoreCurrent';
  access: ApiCoreAccess;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  accessId: Scalars['Int'];
  analyticsConsent?: Maybe<Scalars['Boolean']>;
  company: ApiCoreCompany;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  companyId: Scalars['Int'];
  email?: Maybe<Scalars['String']>;
  employee: EmployeesEmployee;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  employeeId: Scalars['Int'];
  isAdminBecome: Scalars['Boolean'];
  isStaffBecome: Scalars['Boolean'];
};


/** A repository to retrieve the current session information */
export type ApiCoreCurrentAccessArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** A repository to retrieve the current session information */
export type ApiCoreCurrentEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for ApiCoreCurrent. */
export type ApiCoreCurrentConnection = {
  __typename?: 'ApiCoreCurrentConnection';
  /** A list of edges. */
  edges: Array<ApiCoreCurrentEdge>;
  /** A list of nodes. */
  nodes: Array<ApiCoreCurrent>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ApiCoreCurrentEdge = {
  __typename?: 'ApiCoreCurrentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ApiCoreCurrent;
};

export type ApiCoreEntitiesAccessAffiliationEnum =
  | 'employee'
  | 'external'
  | 'partner';

export type ApiCoreEntitiesAccessWeekdayEnum =
  | 'friday'
  | 'monday'
  | 'saturday'
  | 'sunday'
  | 'thursday'
  | 'tuesday'
  | 'wednesday';

/** A repository to retrieve the available modules */
export type ApiCoreModuleRegistry = {
  __typename?: 'ApiCoreModuleRegistry';
  id: Scalars['String'];
};

/** The connection type for ApiCoreModuleRegistry. */
export type ApiCoreModuleRegistryConnection = {
  __typename?: 'ApiCoreModuleRegistryConnection';
  /** A list of edges. */
  edges: Array<ApiCoreModuleRegistryEdge>;
  /** A list of nodes. */
  nodes: Array<ApiCoreModuleRegistry>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ApiCoreModuleRegistryEdge = {
  __typename?: 'ApiCoreModuleRegistryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ApiCoreModuleRegistry;
};

export type ApiPublicContextlessPolicies = {
  __typename?: 'ApiPublicContextlessPolicies';
  coreApiKeyManage: ContextlessPolicyResolution;
};

/** Autogenerated return type of AppendCompetenciesCompetencyLevel. */
export type AppendCompetenciesCompetencyLevelPayload = {
  __typename?: 'AppendCompetenciesCompetencyLevelPayload';
  competencyLevel?: Maybe<CompetenciesCompetencyLevel>;
  errors: Array<MutationError>;
};

export type ApplicationsAtsAnswersInput = {
  questionId: Scalars['Int'];
  value: Scalars['String'];
};

export type ApplyAtsApplicationAnswersInput = {
  atsQuestionId: Scalars['Int'];
};

/** Autogenerated return type of ApplyAtsApplication. */
export type ApplyAtsApplicationPayload = {
  __typename?: 'ApplyAtsApplicationPayload';
  application?: Maybe<AtsApplication>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of ApplyAtsCandidate. */
export type ApplyAtsCandidatePayload = {
  __typename?: 'ApplyAtsCandidatePayload';
  candidate?: Maybe<AtsCandidate>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of ApplyRoleTemplatePermissionsPermissionGroup. */
export type ApplyRoleTemplatePermissionsPermissionGroupPayload = {
  __typename?: 'ApplyRoleTemplatePermissionsPermissionGroupPayload';
  errors: Array<MutationError>;
  permissionGroup?: Maybe<PermissionsPermissionGroup>;
};

/** Autogenerated return type of ApplyTemplateShiftmanagementSchedule. */
export type ApplyTemplateShiftmanagementSchedulePayload = {
  __typename?: 'ApplyTemplateShiftmanagementSchedulePayload';
  errors: Array<MutationError>;
  schedule?: Maybe<ShiftManagementSchedule>;
};

export type Approvable = AtsRequisition | AttendanceEditTimesheetRequest | AttendanceOvertimeRequest | BankingCard | ContractsContractVersion | ContractsContractVersionRequest | ExpensesExpensable | IntegrationsJoinOrder | ProcurementPurchaseRequest | ShiftManagementSwapShift | TimeoffLeave | TrainingsTrainingRequest;

/** Approvals access approval flow */
export type ApprovalsAccessApprovalFlow = {
  __typename?: 'ApprovalsAccessApprovalFlow';
  approvalGroupId: Scalars['Int'];
  default: Scalars['Boolean'];
  id: Scalars['Int'];
  name: Scalars['String'];
  onApprovalFlowChange: Scalars['String'];
};

/** The connection type for ApprovalsAccessApprovalFlow. */
export type ApprovalsAccessApprovalFlowConnection = {
  __typename?: 'ApprovalsAccessApprovalFlowConnection';
  /** A list of edges. */
  edges: Array<ApprovalsAccessApprovalFlowEdge>;
  /** A list of nodes. */
  nodes: Array<ApprovalsAccessApprovalFlow>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ApprovalsAccessApprovalFlowEdge = {
  __typename?: 'ApprovalsAccessApprovalFlowEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ApprovalsAccessApprovalFlow;
};

/** Approvals approval flow */
export type ApprovalsApprovalFlow = {
  __typename?: 'ApprovalsApprovalFlow';
  approvalGroupId: Scalars['Int'];
  default: Scalars['Boolean'];
  id: Scalars['Int'];
  name: Scalars['String'];
  onApprovalFlowChange: Scalars['String'];
  steps: Array<ApprovalsApprovalStep>;
  stepsConnection: ApprovalsApprovalStepConnection;
};


/** Approvals approval flow */
export type ApprovalsApprovalFlowStepsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Approvals approval flow */
export type ApprovalsApprovalFlowStepsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for ApprovalsApprovalFlow. */
export type ApprovalsApprovalFlowConnection = {
  __typename?: 'ApprovalsApprovalFlowConnection';
  /** A list of edges. */
  edges: Array<ApprovalsApprovalFlowEdge>;
  /** A list of nodes. */
  nodes: Array<ApprovalsApprovalFlow>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ApprovalsApprovalFlowEdge = {
  __typename?: 'ApprovalsApprovalFlowEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ApprovalsApprovalFlow;
};

export type ApprovalsApprovalFlowOnApprovalFlowChangeEnum =
  | 'donothing'
  | 'resetall';

/** Approvals approval group */
export type ApprovalsApprovalGroup = {
  __typename?: 'ApprovalsApprovalGroup';
  autoApproved: Scalars['Boolean'];
  category: ApprovalsValueObjectsApprovalCategoryEnum;
  companyId: Scalars['Int'];
  default: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  domainConfigurationRules: Array<ApprovalsDomainConfigurationRule>;
  domainConfigurationRulesStatus: ApprovalsDomainConfigurationRulesConfigurationStatusEnum;
  flows: Array<ApprovalsApprovalFlow>;
  flowsConnection: ApprovalsApprovalFlowConnection;
  groupMemberships: Array<ApprovalsApprovalGroupMembership>;
  groupMembershipsConnection: ApprovalsApprovalGroupMembershipConnection;
  id: Scalars['Int'];
  name: Scalars['String'];
  rulesConfiguration: Array<ApprovalsRulesConfiguration>;
  rulesConfigurationConnection: ApprovalsRulesConfigurationConnection;
};


/** Approvals approval group */
export type ApprovalsApprovalGroupFlowsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Approvals approval group */
export type ApprovalsApprovalGroupFlowsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Approvals approval group */
export type ApprovalsApprovalGroupGroupMembershipsArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  approvalGroupId?: InputMaybe<Scalars['Int']>;
  autoApprovalGroup?: InputMaybe<Scalars['Boolean']>;
  category?: InputMaybe<ApprovalsValueObjectsApprovalCategoryEnum>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


/** Approvals approval group */
export type ApprovalsApprovalGroupGroupMembershipsConnectionArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  after?: InputMaybe<Scalars['String']>;
  approvalGroupId?: InputMaybe<Scalars['Int']>;
  autoApprovalGroup?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<ApprovalsValueObjectsApprovalCategoryEnum>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Approvals approval group */
export type ApprovalsApprovalGroupRulesConfigurationArgs = {
  approvalGroupId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Approvals approval group */
export type ApprovalsApprovalGroupRulesConfigurationConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  approvalGroupId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for ApprovalsApprovalGroup. */
export type ApprovalsApprovalGroupConnection = {
  __typename?: 'ApprovalsApprovalGroupConnection';
  /** A list of edges. */
  edges: Array<ApprovalsApprovalGroupEdge>;
  /** A list of nodes. */
  nodes: Array<ApprovalsApprovalGroup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ApprovalsApprovalGroupEdge = {
  __typename?: 'ApprovalsApprovalGroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ApprovalsApprovalGroup;
};

/** the filter for the approval_groups resource */
export type ApprovalsApprovalGroupFilter = {
  id?: InputMaybe<IntegerFilter>;
  name?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<ApprovalsApprovalGroupFilterConditions>>;
};

export type ApprovalsApprovalGroupFilterConditions = {
  id?: InputMaybe<IntegerFilter>;
  name?: InputMaybe<StringFilter>;
};

/** Approvals approval group membership */
export type ApprovalsApprovalGroupMembership = {
  __typename?: 'ApprovalsApprovalGroupMembership';
  access?: Maybe<ApiCoreAccess>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  accessId: Scalars['Int'];
  approvalGroup?: Maybe<ApprovalsApprovalGroup>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  approvalGroupId: Scalars['Int'];
  employee?: Maybe<EmployeesEmployeeName>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  employeeId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
};


/** Approvals approval group membership */
export type ApprovalsApprovalGroupMembershipAccessArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** Approvals approval group membership */
export type ApprovalsApprovalGroupMembershipApprovalGroupArgs = {
  accessId?: Array<Scalars['Int']>;
  autoApproved?: Scalars['Boolean'];
  category?: InputMaybe<ApprovalsValueObjectsApprovalCategoryEnum>;
  search?: InputMaybe<Scalars['String']>;
};


/** Approvals approval group membership */
export type ApprovalsApprovalGroupMembershipEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  afterEmployeeId?: InputMaybe<Scalars['Int']>;
  beforeEmployeeId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  reporteesOrLed?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyId?: InputMaybe<Scalars['Int']>;
  verb?: InputMaybe<Scalars['String']>;
  withActiveContract?: Scalars['Boolean'];
};

/** The connection type for ApprovalsApprovalGroupMembership. */
export type ApprovalsApprovalGroupMembershipConnection = {
  __typename?: 'ApprovalsApprovalGroupMembershipConnection';
  /** A list of edges. */
  edges: Array<ApprovalsApprovalGroupMembershipEdge>;
  /** A list of nodes. */
  nodes: Array<ApprovalsApprovalGroupMembership>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ApprovalsApprovalGroupMembershipEdge = {
  __typename?: 'ApprovalsApprovalGroupMembershipEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ApprovalsApprovalGroupMembership;
};

/** the filter for the approval_group_memberships resource */
export type ApprovalsApprovalGroupMembershipFilter = {
  id?: InputMaybe<IntegerFilter>;
  or?: InputMaybe<Array<ApprovalsApprovalGroupMembershipFilterConditions>>;
};

export type ApprovalsApprovalGroupMembershipFilterConditions = {
  id?: InputMaybe<IntegerFilter>;
};

/** Approvals approval step */
export type ApprovalsApprovalStep = {
  __typename?: 'ApprovalsApprovalStep';
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  approvalFlowId: Scalars['Int'];
  approvers: Array<ApprovalsApprovalStepApprover>;
  approversConnection: ApprovalsApprovalStepApproverConnection;
  flow?: Maybe<ApprovalsApprovalFlow>;
  id: Scalars['Int'];
  position?: Maybe<Scalars['Int']>;
};


/** Approvals approval step */
export type ApprovalsApprovalStepApproversArgs = {
  approvalFlowIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Approvals approval step */
export type ApprovalsApprovalStepApproversConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  approvalFlowIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Approvals approval step */
export type ApprovalsApprovalStepFlowArgs = {
  approvalGroupIds?: InputMaybe<Array<Scalars['Int']>>;
};

/** Approvals approval step approver */
export type ApprovalsApprovalStepApprover = {
  __typename?: 'ApprovalsApprovalStepApprover';
  access?: Maybe<ApiCoreAccess>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  accessId?: Maybe<Scalars['Int']>;
  accessIds?: Maybe<Array<Scalars['Int']>>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  approvalStepId: Scalars['Int'];
  approvalStepPosition: Scalars['Int'];
  approvalStepStrategy: Scalars['String'];
  groupableId?: Maybe<Scalars['Int']>;
  groupableType?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  step?: Maybe<ApprovalsApprovalStep>;
  strategy: Scalars['String'];
};


/** Approvals approval step approver */
export type ApprovalsApprovalStepApproverAccessArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** Approvals approval step approver */
export type ApprovalsApprovalStepApproverStepArgs = {
  approvalFlowIds?: InputMaybe<Array<Scalars['Int']>>;
};

/** The connection type for ApprovalsApprovalStepApprover. */
export type ApprovalsApprovalStepApproverConnection = {
  __typename?: 'ApprovalsApprovalStepApproverConnection';
  /** A list of edges. */
  edges: Array<ApprovalsApprovalStepApproverEdge>;
  /** A list of nodes. */
  nodes: Array<ApprovalsApprovalStepApprover>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ApprovalsApprovalStepApproverEdge = {
  __typename?: 'ApprovalsApprovalStepApproverEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ApprovalsApprovalStepApprover;
};

/** The connection type for ApprovalsApprovalStep. */
export type ApprovalsApprovalStepConnection = {
  __typename?: 'ApprovalsApprovalStepConnection';
  /** A list of edges. */
  edges: Array<ApprovalsApprovalStepEdge>;
  /** A list of nodes. */
  nodes: Array<ApprovalsApprovalStep>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ApprovalsApprovalStepEdge = {
  __typename?: 'ApprovalsApprovalStepEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ApprovalsApprovalStep;
};

export type ApprovalsContextlessPolicies = {
  __typename?: 'ApprovalsContextlessPolicies';
  approvalFlowsView: ContextlessPolicyResolution;
  approvalGroupMembershipsAssign: ContextlessPolicyResolution;
  approvalGroupMembershipsView: ContextlessPolicyResolution;
  approvalGroupsCreate: ContextlessPolicyResolution;
  approvalGroupsDelete: ContextlessPolicyResolution;
  approvalGroupsEdit: ContextlessPolicyResolution;
  approvalStepApproversEdit: ContextlessPolicyResolution;
  approvalStepApproversView: ContextlessPolicyResolution;
  globalApproverUse: ContextlessPolicyResolution;
};

export type ApprovalsDomainConfigurationInputTypeEnum =
  | 'cents'
  | 'selector'
  | 'single_choice';

export type ApprovalsDomainConfigurationInputWithEnum =
  | 'full'
  | 'half';

export type ApprovalsDomainConfigurationOperationsEnum =
  | 'greaterthan'
  | 'includes'
  | 'lessthan'
  | 'nooperation';

export type ApprovalsDomainConfigurationRule = {
  __typename?: 'ApprovalsDomainConfigurationRule';
  identifier: Scalars['String'];
  inputType: ApprovalsDomainConfigurationInputTypeEnum;
  inputWidth: ApprovalsDomainConfigurationInputWithEnum;
  label: Scalars['String'];
  mandatory: Scalars['Boolean'];
  operation: ApprovalsDomainConfigurationOperationsEnum;
  parentRuleIdentifier?: Maybe<Scalars['String']>;
  selectorOptions: Array<ApprovalsRuleConfigurationSelectorOption>;
};

export type ApprovalsDomainConfigurationRulesConfigurationStatusEnum =
  | 'disabled'
  | 'enabled'
  | 'upgrade_plan';

export type ApprovalsDtosMaterializedApprovalFlowsRepresentationEnum =
  | 'location'
  | 'permissions_group';

export type ApprovalsEntitiesEmailDetailBlockTypeEnum =
  | 'date'
  | 'daterange'
  | 'datetime'
  | 'integer'
  | 'string';

/** Approval limits */
export type ApprovalsLimit = {
  __typename?: 'ApprovalsLimit';
  available: Scalars['Boolean'];
  category: Scalars['String'];
  company?: Maybe<ApiCoreCompany>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  companyId: Scalars['Int'];
  feature: Scalars['String'];
  id: Scalars['String'];
};

/** The connection type for ApprovalsLimit. */
export type ApprovalsLimitConnection = {
  __typename?: 'ApprovalsLimitConnection';
  /** A list of edges. */
  edges: Array<ApprovalsLimitEdge>;
  /** A list of nodes. */
  nodes: Array<ApprovalsLimit>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ApprovalsLimitEdge = {
  __typename?: 'ApprovalsLimitEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ApprovalsLimit;
};

export type ApprovalsMaterializedApprovalFlowStatusEnum =
  | 'approved'
  | 'changes_requested'
  | 'rejected'
  | 'requestedinformation'
  | 'running'
  | 'stopped';

/** Approvals materialized approval step */
export type ApprovalsMaterializedApprovalStep = {
  __typename?: 'ApprovalsMaterializedApprovalStep';
  approvalStep?: Maybe<ApprovalsApprovalStep>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  approvalStepId: Scalars['Int'];
  id: Scalars['Int'];
  materializedApprovalFlow?: Maybe<ApprovalsMaterializedApprovalsFlow>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  materializedApprovalFlowId: Scalars['Int'];
  stepApprovers: Array<ApprovalsMaterializedApprovalStepApprover>;
  stepApproversConnection: ApprovalsMaterializedApprovalStepApproverConnection;
};


/** Approvals materialized approval step */
export type ApprovalsMaterializedApprovalStepApprovalStepArgs = {
  approvalFlowIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Approvals materialized approval step */
export type ApprovalsMaterializedApprovalStepMaterializedApprovalFlowArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  ownerId?: InputMaybe<Scalars['Int']>;
  resourceIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceType?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ApprovalsMaterializedApprovalFlowStatusEnum>;
};


/** Approvals materialized approval step */
export type ApprovalsMaterializedApprovalStepStepApproversArgs = {
  approvalFlowIds?: InputMaybe<Array<Scalars['Int']>>;
  approverStatus?: InputMaybe<ApprovalsMaterializedApprovalStepApproverApproverStatusEnum>;
  employeeId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Approvals materialized approval step */
export type ApprovalsMaterializedApprovalStepStepApproversConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  approvalFlowIds?: InputMaybe<Array<Scalars['Int']>>;
  approverStatus?: InputMaybe<ApprovalsMaterializedApprovalStepApproverApproverStatusEnum>;
  before?: InputMaybe<Scalars['String']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** Approvals materialized approval step approver */
export type ApprovalsMaterializedApprovalStepApprover = {
  __typename?: 'ApprovalsMaterializedApprovalStepApprover';
  access?: Maybe<ApiCoreAccess>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  accessId?: Maybe<Scalars['Int']>;
  approvalFlow: ApprovalsMaterializedApprovalsFlow;
  approvalStepApprover: ApprovalsApprovalStepApprover;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  approvalStepApproverId: Scalars['Int'];
  employee?: Maybe<EmployeesEmployeeName>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  employeeId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  materializedApprovalStepId: Scalars['Int'];
  selectionCriteria?: Maybe<Scalars['String']>;
  status: ApprovalsMaterializedApprovalStepApproverApproverStatusEnum;
  updatedAt: Scalars['ISO8601DateTime'];
};


/** Approvals materialized approval step approver */
export type ApprovalsMaterializedApprovalStepApproverAccessArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** Approvals materialized approval step approver */
export type ApprovalsMaterializedApprovalStepApproverApprovalFlowArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  ownerId?: InputMaybe<Scalars['Int']>;
  resourceIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceType?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ApprovalsMaterializedApprovalFlowStatusEnum>;
};


/** Approvals materialized approval step approver */
export type ApprovalsMaterializedApprovalStepApproverApprovalStepApproverArgs = {
  approvalFlowIds?: InputMaybe<Array<Scalars['Int']>>;
  approvalStepIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Approvals materialized approval step approver */
export type ApprovalsMaterializedApprovalStepApproverEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  afterEmployeeId?: InputMaybe<Scalars['Int']>;
  beforeEmployeeId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  reporteesOrLed?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyId?: InputMaybe<Scalars['Int']>;
  verb?: InputMaybe<Scalars['String']>;
  withActiveContract?: Scalars['Boolean'];
};

export type ApprovalsMaterializedApprovalStepApproverApproverStatusEnum =
  | 'approved'
  | 'changes_requested'
  | 'ignored'
  | 'pending'
  | 'rejected'
  | 'requestedinformation'
  | 'stopped'
  | 'waiting_changes';

/** The connection type for ApprovalsMaterializedApprovalStepApprover. */
export type ApprovalsMaterializedApprovalStepApproverConnection = {
  __typename?: 'ApprovalsMaterializedApprovalStepApproverConnection';
  /** A list of edges. */
  edges: Array<ApprovalsMaterializedApprovalStepApproverEdge>;
  /** A list of nodes. */
  nodes: Array<ApprovalsMaterializedApprovalStepApprover>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ApprovalsMaterializedApprovalStepApproverEdge = {
  __typename?: 'ApprovalsMaterializedApprovalStepApproverEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ApprovalsMaterializedApprovalStepApprover;
};

/** The connection type for ApprovalsMaterializedApprovalStep. */
export type ApprovalsMaterializedApprovalStepConnection = {
  __typename?: 'ApprovalsMaterializedApprovalStepConnection';
  /** A list of edges. */
  edges: Array<ApprovalsMaterializedApprovalStepEdge>;
  /** A list of nodes. */
  nodes: Array<ApprovalsMaterializedApprovalStep>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ApprovalsMaterializedApprovalStepEdge = {
  __typename?: 'ApprovalsMaterializedApprovalStepEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ApprovalsMaterializedApprovalStep;
};

/** Approvals materialized approvals flow */
export type ApprovalsMaterializedApprovalsFlow = {
  __typename?: 'ApprovalsMaterializedApprovalsFlow';
  _policies?: Maybe<ApprovalsMaterializedApprovalsFlowPolicies>;
  _policiesCollection?: Maybe<Array<PermissionsPolicyResolution>>;
  _policiesConnection: PermissionsPolicyResolutionConnection;
  actionType?: Maybe<Scalars['String']>;
  approvable?: Maybe<Approvable>;
  approvalFlow?: Maybe<ApprovalsApprovalFlow>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  approvalFlowId: Scalars['Int'];
  authorEmployeeId?: Maybe<Scalars['Int']>;
  authorId: Scalars['Int'];
  autoApprovalDescription?: Maybe<Scalars['String']>;
  emailDetailBlocks: Array<Scalars['String']>;
  expiresAt: Scalars['ISO8601DateTime'];
  finalDecisionAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['Int'];
  overrideApproverEmployeeId?: Maybe<Scalars['Int']>;
  overrideApproverId?: Maybe<Scalars['Int']>;
  owner?: Maybe<ApiCoreAccess>;
  ownerEmployee?: Maybe<EmployeesEmployeeName>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  ownerEmployeeId?: Maybe<Scalars['Int']>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  ownerId: Scalars['Int'];
  reason?: Maybe<Scalars['String']>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  resourceId: Scalars['Int'];
  resourceType: Scalars['String'];
  resourceUrl: Scalars['String'];
  rulesDecision?: Maybe<Scalars['String']>;
  status: ApprovalsMaterializedApprovalFlowStatusEnum;
  steps: Array<ApprovalsMaterializedApprovalStep>;
  stepsConnection: ApprovalsMaterializedApprovalStepConnection;
};


/** Approvals materialized approvals flow */
export type ApprovalsMaterializedApprovalsFlow_PoliciesCollectionArgs = {
  ids: Array<ApprovalsMaterializedApprovalsFlowPoliciesEnum>;
};


/** Approvals materialized approvals flow */
export type ApprovalsMaterializedApprovalsFlow_PoliciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Approvals materialized approvals flow */
export type ApprovalsMaterializedApprovalsFlowApprovalFlowArgs = {
  approvalGroupIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Approvals materialized approvals flow */
export type ApprovalsMaterializedApprovalsFlowOwnerArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** Approvals materialized approvals flow */
export type ApprovalsMaterializedApprovalsFlowOwnerEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  afterEmployeeId?: InputMaybe<Scalars['Int']>;
  beforeEmployeeId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  reporteesOrLed?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyId?: InputMaybe<Scalars['Int']>;
  verb?: InputMaybe<Scalars['String']>;
  withActiveContract?: Scalars['Boolean'];
};


/** Approvals materialized approvals flow */
export type ApprovalsMaterializedApprovalsFlowStepsArgs = {
  approvalStepIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Approvals materialized approvals flow */
export type ApprovalsMaterializedApprovalsFlowStepsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  approvalStepIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for ApprovalsMaterializedApprovalsFlow. */
export type ApprovalsMaterializedApprovalsFlowConnection = {
  __typename?: 'ApprovalsMaterializedApprovalsFlowConnection';
  /** A list of edges. */
  edges: Array<ApprovalsMaterializedApprovalsFlowEdge>;
  /** A list of nodes. */
  nodes: Array<ApprovalsMaterializedApprovalsFlow>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ApprovalsMaterializedApprovalsFlowEdge = {
  __typename?: 'ApprovalsMaterializedApprovalsFlowEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ApprovalsMaterializedApprovalsFlow;
};

export type ApprovalsMaterializedApprovalsFlowPolicies = {
  __typename?: 'ApprovalsMaterializedApprovalsFlowPolicies';
  approveOrReject: PermissionsPolicyResolution;
};

export type ApprovalsMaterializedApprovalsFlowPoliciesEnum =
  | 'approve_or_reject';

/** Approvals rule */
export type ApprovalsRule = {
  __typename?: 'ApprovalsRule';
  id: Scalars['Int'];
  identifier: Scalars['String'];
  inputType: ApprovalsDomainConfigurationInputTypeEnum;
  label: Scalars['String'];
  labeledValue?: Maybe<Scalars['String']>;
  operation: ApprovalsDomainConfigurationOperationsEnum;
  ruleConfiguration?: Maybe<ApprovalsRulesConfiguration>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  rulesConfigurationId: Scalars['Int'];
  value: Array<Scalars['String']>;
};


/** Approvals rule */
export type ApprovalsRuleRuleConfigurationArgs = {
  approvalGroupId?: InputMaybe<Scalars['Int']>;
  approvalGroupIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type ApprovalsRuleConfigurationSelectorOption = {
  __typename?: 'ApprovalsRuleConfigurationSelectorOption';
  label: Scalars['String'];
  parentId?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** The connection type for ApprovalsRule. */
export type ApprovalsRuleConnection = {
  __typename?: 'ApprovalsRuleConnection';
  /** A list of edges. */
  edges: Array<ApprovalsRuleEdge>;
  /** A list of nodes. */
  nodes: Array<ApprovalsRule>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ApprovalsRuleEdge = {
  __typename?: 'ApprovalsRuleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ApprovalsRule;
};

/** Approvals rules configuration */
export type ApprovalsRulesConfiguration = {
  __typename?: 'ApprovalsRulesConfiguration';
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  approvalFlowId?: Maybe<Scalars['Int']>;
  approvalGroupId: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  flow?: Maybe<ApprovalsApprovalFlow>;
  id: Scalars['Int'];
  name: Scalars['String'];
  onRulesMet: ApprovalsValueObjectsRulesConfigurationRuleDecisionEnum;
  position?: Maybe<Scalars['Int']>;
  rules: Array<ApprovalsRule>;
  rulesConnection: ApprovalsRuleConnection;
};


/** Approvals rules configuration */
export type ApprovalsRulesConfigurationFlowArgs = {
  approvalGroupIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Approvals rules configuration */
export type ApprovalsRulesConfigurationRulesArgs = {
  category: ApprovalsValueObjectsApprovalCategoryEnum;
  companyId: Scalars['Int'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Approvals rules configuration */
export type ApprovalsRulesConfigurationRulesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  category: ApprovalsValueObjectsApprovalCategoryEnum;
  companyId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for ApprovalsRulesConfiguration. */
export type ApprovalsRulesConfigurationConnection = {
  __typename?: 'ApprovalsRulesConfigurationConnection';
  /** A list of edges. */
  edges: Array<ApprovalsRulesConfigurationEdge>;
  /** A list of nodes. */
  nodes: Array<ApprovalsRulesConfiguration>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ApprovalsRulesConfigurationEdge = {
  __typename?: 'ApprovalsRulesConfigurationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ApprovalsRulesConfiguration;
};

/** An approval process. */
export type ApprovalsV2ApprovalProcess = {
  __typename?: 'ApprovalsV2ApprovalProcess';
  createdAt: Scalars['ISO8601DateTime'];
  decision?: Maybe<ApprovalsV2ValueObjectsApprovalProcessDecisionEnum>;
  decisionReason?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  requesterId: Scalars['Int'];
  resource?: Maybe<Approvable>;
  resourceId: Scalars['Int'];
  resourceOwner: EmployeesEmployee;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  resourceOwnerId: Scalars['Int'];
  resourceType: Scalars['String'];
  reviewRequests: Array<ApprovalsV2ReviewRequest>;
  reviewRequestsConnection: ApprovalsV2ReviewRequestConnection;
  updatedAt: Scalars['ISO8601DateTime'];
  useCase: Scalars['String'];
  workflowExecutionId?: Maybe<Scalars['Int']>;
};


/** An approval process. */
export type ApprovalsV2ApprovalProcessResourceOwnerArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** An approval process. */
export type ApprovalsV2ApprovalProcessReviewRequestsArgs = {
  handlerExecutionIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  pending?: InputMaybe<Scalars['Boolean']>;
  reviewerIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** An approval process. */
export type ApprovalsV2ApprovalProcessReviewRequestsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  handlerExecutionIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  reviewerIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
};

export type ApprovalsV2ApprovalTimelineEntry = {
  __typename?: 'ApprovalsV2ApprovalTimelineEntry';
  actionGroup?: Maybe<Scalars['String']>;
  assigneeNames?: Maybe<Array<Scalars['String']>>;
  assignees?: Maybe<Array<ApprovalsV2TimelineEntryAssignee>>;
  decisionReason?: Maybe<Scalars['String']>;
  dueOn?: Maybe<Scalars['ISO8601Date']>;
  employeeSegmentName?: Maybe<Scalars['String']>;
  status: ApprovalsV2ValueObjectsApprovalTimelineEntryStatusEnum;
  time: Scalars['ISO8601DateTime'];
  title: Scalars['String'];
  type: ApprovalsV2ValueObjectsApprovalTimelineEntryTypeEnum;
};

/** An strategy to resolve an employee segment. */
export type ApprovalsV2EmployeeSegmentsStrategy = {
  __typename?: 'ApprovalsV2EmployeeSegmentsStrategy';
  description: Scalars['String'];
  label: Scalars['String'];
  name: Scalars['String'];
};

/** The connection type for ApprovalsV2EmployeeSegmentsStrategy. */
export type ApprovalsV2EmployeeSegmentsStrategyConnection = {
  __typename?: 'ApprovalsV2EmployeeSegmentsStrategyConnection';
  /** A list of edges. */
  edges: Array<ApprovalsV2EmployeeSegmentsStrategyEdge>;
  /** A list of nodes. */
  nodes: Array<ApprovalsV2EmployeeSegmentsStrategy>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ApprovalsV2EmployeeSegmentsStrategyEdge = {
  __typename?: 'ApprovalsV2EmployeeSegmentsStrategyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ApprovalsV2EmployeeSegmentsStrategy;
};

/** A review request. */
export type ApprovalsV2ReviewRequest = {
  __typename?: 'ApprovalsV2ReviewRequest';
  approvalProcess?: Maybe<ApprovalsV2ApprovalProcess>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  approvalProcessId: Scalars['Int'];
  companyId: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  decision?: Maybe<ApprovalsV2ValueObjectsReviewRequestDecisionEnum>;
  decisionReason?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  reviewedAt?: Maybe<Scalars['ISO8601DateTime']>;
  reviewedById?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['ISO8601DateTime'];
  workflowsHandlerExecutionId: Scalars['Int'];
};


/** A review request. */
export type ApprovalsV2ReviewRequestApprovalProcessArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  decision?: InputMaybe<Scalars['String']>;
  requesterId?: InputMaybe<Scalars['Int']>;
  resourceIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceType?: InputMaybe<Scalars['String']>;
  useCase?: InputMaybe<Scalars['String']>;
};

/** The connection type for ApprovalsV2ReviewRequest. */
export type ApprovalsV2ReviewRequestConnection = {
  __typename?: 'ApprovalsV2ReviewRequestConnection';
  /** A list of edges. */
  edges: Array<ApprovalsV2ReviewRequestEdge>;
  /** A list of nodes. */
  nodes: Array<ApprovalsV2ReviewRequest>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ApprovalsV2ReviewRequestEdge = {
  __typename?: 'ApprovalsV2ReviewRequestEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ApprovalsV2ReviewRequest;
};

export type ApprovalsV2TimelineEntryAssignee = {
  __typename?: 'ApprovalsV2TimelineEntryAssignee';
  employeeId?: Maybe<Scalars['Int']>;
  peopleGroupName?: Maybe<Scalars['String']>;
};

export type ApprovalsV2ValueObjectsApprovalProcessDecisionEnum =
  | 'approved'
  | 'rejected';

export type ApprovalsV2ValueObjectsApprovalTimelineEntryStatusEnum =
  | 'changesrequested'
  | 'completed'
  | 'future'
  | 'rejected'
  | 'running';

export type ApprovalsV2ValueObjectsApprovalTimelineEntryTypeEnum =
  | 'action'
  | 'cannot_resolve'
  | 'start';

export type ApprovalsV2ValueObjectsReviewRequestDecisionEnum =
  | 'approved'
  | 'changes_requested'
  | 'rejected';

export type ApprovalsValueObjectsApprovalCategoryEnum =
  | 'ats'
  | 'contracts'
  | 'expenses'
  | 'premium_portals'
  | 'purchases'
  | 'shift_management'
  | 'software'
  | 'time_tracking'
  | 'timeoff'
  | 'trainings';

export type ApprovalsValueObjectsRulesConfigurationRuleDecisionEnum =
  | 'auto_approve'
  | 'custom_approval_flow'
  | 'default_approval_flow'
  | 'do_nothing'
  | 'restarted'
  | 'start_approval_flow';

/** Autogenerated return type of ApproveAllTimeoffLeave. */
export type ApproveAllTimeoffLeavePayload = {
  __typename?: 'ApproveAllTimeoffLeavePayload';
  errors: Array<MutationError>;
  leave?: Maybe<TimeoffLeave>;
};

/** Autogenerated return type of ApproveApprovalsMaterializedApprovalStepApprover. */
export type ApproveApprovalsMaterializedApprovalStepApproverPayload = {
  __typename?: 'ApproveApprovalsMaterializedApprovalStepApproverPayload';
  errors: Array<MutationError>;
  materializedApprovalStepApprover?: Maybe<ApprovalsMaterializedApprovalStepApprover>;
};

/** Autogenerated return type of ApproveApprovalsMaterializedApprovalsFlow. */
export type ApproveApprovalsMaterializedApprovalsFlowPayload = {
  __typename?: 'ApproveApprovalsMaterializedApprovalsFlowPayload';
  errors: Array<MutationError>;
  materializedApprovalsFlow?: Maybe<ApprovalsMaterializedApprovalsFlow>;
};

/** Autogenerated return type of ApproveAtsRequisition. */
export type ApproveAtsRequisitionPayload = {
  __typename?: 'ApproveAtsRequisitionPayload';
  errors: Array<MutationError>;
  requisition?: Maybe<AtsRequisition>;
};

/** Autogenerated return type of ApproveAttendanceOvertimeRequest. */
export type ApproveAttendanceOvertimeRequestPayload = {
  __typename?: 'ApproveAttendanceOvertimeRequestPayload';
  errors: Array<MutationError>;
  overtimeRequest?: Maybe<AttendanceOvertimeRequest>;
};

/** Autogenerated return type of ApproveBankingCard. */
export type ApproveBankingCardPayload = {
  __typename?: 'ApproveBankingCardPayload';
  card?: Maybe<BankingCard>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of ApproveContractsContractVersionRequest. */
export type ApproveContractsContractVersionRequestPayload = {
  __typename?: 'ApproveContractsContractVersionRequestPayload';
  contractVersionRequest?: Maybe<ContractsContractVersionRequest>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of ApproveExpensesExpensableGroup. */
export type ApproveExpensesExpensableGroupPayload = {
  __typename?: 'ApproveExpensesExpensableGroupPayload';
  errors: Array<MutationError>;
  expensableGroup?: Maybe<ExpensesExpensableGroup>;
};

/** Autogenerated return type of ApproveIntegrationsjoinOrder. */
export type ApproveIntegrationsjoinOrderPayload = {
  __typename?: 'ApproveIntegrationsjoinOrderPayload';
  errors: Array<MutationError>;
  order?: Maybe<IntegrationsJoinOrder>;
};

/** Autogenerated return type of ApproveProcurementPurchaseRequest. */
export type ApproveProcurementPurchaseRequestPayload = {
  __typename?: 'ApproveProcurementPurchaseRequestPayload';
  errors: Array<MutationError>;
  purchaseRequest?: Maybe<ProcurementPurchaseRequest>;
};

/** Autogenerated return type of ApproveShiftmanagementSwapShift. */
export type ApproveShiftmanagementSwapShiftPayload = {
  __typename?: 'ApproveShiftmanagementSwapShiftPayload';
  errors: Array<MutationError>;
  swapShift?: Maybe<ShiftManagementSwapShift>;
};

/** Autogenerated return type of ApproveTimeoffLeave. */
export type ApproveTimeoffLeavePayload = {
  __typename?: 'ApproveTimeoffLeavePayload';
  errors: Array<MutationError>;
  leave?: Maybe<TimeoffLeave>;
};

/** Autogenerated return type of ApproveTrainingsTrainingRequest. */
export type ApproveTrainingsTrainingRequestPayload = {
  __typename?: 'ApproveTrainingsTrainingRequestPayload';
  errors: Array<MutationError>;
  trainingRequest?: Maybe<TrainingsTrainingRequest>;
};

/** Autogenerated return type of ArchiveAtsConversation. */
export type ArchiveAtsConversationPayload = {
  __typename?: 'ArchiveAtsConversationPayload';
  conversation?: Maybe<AtsConversation>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of ArchiveAtsCvBulkUpload. */
export type ArchiveAtsCvBulkUploadPayload = {
  __typename?: 'ArchiveAtsCvBulkUploadPayload';
  cvBulkUpload?: Maybe<AtsCvBulkUpload>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of ArchiveCompensationsCycle. */
export type ArchiveCompensationsCyclePayload = {
  __typename?: 'ArchiveCompensationsCyclePayload';
  cycle?: Maybe<CompensationsCycle>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of ArchiveContractsFranceFrenchContractType. */
export type ArchiveContractsFranceFrenchContractTypePayload = {
  __typename?: 'ArchiveContractsFranceFrenchContractTypePayload';
  errors: Array<MutationError>;
  frenchContractType?: Maybe<ContractsFrenchContractType>;
};

/** Autogenerated return type of ArchiveContractsFranceFrenchLevel. */
export type ArchiveContractsFranceFrenchLevelPayload = {
  __typename?: 'ArchiveContractsFranceFrenchLevelPayload';
  errors: Array<MutationError>;
  frenchLevel?: Maybe<ContractsFrenchLevel>;
};

/** Autogenerated return type of ArchiveContractsFranceFrenchMutual. */
export type ArchiveContractsFranceFrenchMutualPayload = {
  __typename?: 'ArchiveContractsFranceFrenchMutualPayload';
  errors: Array<MutationError>;
  frenchMutual?: Maybe<ContractsFrenchMutual>;
};

/** Autogenerated return type of ArchiveContractsFranceFrenchProfessionalCategory. */
export type ArchiveContractsFranceFrenchProfessionalCategoryPayload = {
  __typename?: 'ArchiveContractsFranceFrenchProfessionalCategoryPayload';
  errors: Array<MutationError>;
  frenchProfessionalCategory?: Maybe<ContractsFrenchProfessionalCategory>;
};

/** Autogenerated return type of ArchiveContractsFranceFrenchStep. */
export type ArchiveContractsFranceFrenchStepPayload = {
  __typename?: 'ArchiveContractsFranceFrenchStepPayload';
  errors: Array<MutationError>;
  frenchStep?: Maybe<ContractsFrenchStep>;
};

/** Autogenerated return type of ArchiveContractsFranceFrenchWorkType. */
export type ArchiveContractsFranceFrenchWorkTypePayload = {
  __typename?: 'ArchiveContractsFranceFrenchWorkTypePayload';
  errors: Array<MutationError>;
  frenchWorkType?: Maybe<ContractsFrenchWorkType>;
};

/** Autogenerated return type of ArchiveContractsGermanyGermanContractType. */
export type ArchiveContractsGermanyGermanContractTypePayload = {
  __typename?: 'ArchiveContractsGermanyGermanContractTypePayload';
  errors: Array<MutationError>;
  germanContractType?: Maybe<ContractsGermanContractType>;
};

/** Autogenerated return type of ArchiveContractsPortugalPortugueseContractType. */
export type ArchiveContractsPortugalPortugueseContractTypePayload = {
  __typename?: 'ArchiveContractsPortugalPortugueseContractTypePayload';
  errors: Array<MutationError>;
  portugueseContractType?: Maybe<ContractsPortugueseContractType>;
};

/** Autogenerated return type of ArchiveContractsSpainSpanishContractType. */
export type ArchiveContractsSpainSpanishContractTypePayload = {
  __typename?: 'ArchiveContractsSpainSpanishContractTypePayload';
  errors: Array<MutationError>;
  spanishContractType?: Maybe<ContractsSpanishContractType>;
};

/** Autogenerated return type of ArchiveContractsSpainSpanishEducationLevel. */
export type ArchiveContractsSpainSpanishEducationLevelPayload = {
  __typename?: 'ArchiveContractsSpainSpanishEducationLevelPayload';
  errors: Array<MutationError>;
  spanishEducationLevel?: Maybe<ContractsSpanishEducationLevel>;
};

/** Autogenerated return type of ArchiveContractsSpainSpanishProfessionalCategory. */
export type ArchiveContractsSpainSpanishProfessionalCategoryPayload = {
  __typename?: 'ArchiveContractsSpainSpanishProfessionalCategoryPayload';
  errors: Array<MutationError>;
  spanishProfessionalCategory?: Maybe<ContractsSpanishProfessionalCategory>;
};

/** Autogenerated return type of ArchiveContractsSpainSpanishWorkingDayType. */
export type ArchiveContractsSpainSpanishWorkingDayTypePayload = {
  __typename?: 'ArchiveContractsSpainSpanishWorkingDayTypePayload';
  errors: Array<MutationError>;
  spanishWorkingDayType?: Maybe<ContractsSpanishWorkingDayType>;
};

/** Autogenerated return type of ArchiveContractsTaxonomy. */
export type ArchiveContractsTaxonomyPayload = {
  __typename?: 'ArchiveContractsTaxonomyPayload';
  errors: Array<MutationError>;
  taxonomy?: Maybe<ContractsTaxonomy>;
};

/** Autogenerated return type of ArchiveExpensesRateConfiguration. */
export type ArchiveExpensesRateConfigurationPayload = {
  __typename?: 'ArchiveExpensesRateConfigurationPayload';
  errors: Array<MutationError>;
  rateConfiguration?: Maybe<ExpensesRateConfiguration>;
};

/** Autogenerated return type of ArchiveFinanceBudget. */
export type ArchiveFinanceBudgetPayload = {
  __typename?: 'ArchiveFinanceBudgetPayload';
  budget?: Maybe<FinanceBudget>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of ArchiveFinanceQuote. */
export type ArchiveFinanceQuotePayload = {
  __typename?: 'ArchiveFinanceQuotePayload';
  errors: Array<MutationError>;
  quote?: Maybe<FinanceQuote>;
};

/** Autogenerated return type of ArchiveFinanceSerialSequenceCreditNoteSequence. */
export type ArchiveFinanceSerialSequenceCreditNoteSequencePayload = {
  __typename?: 'ArchiveFinanceSerialSequenceCreditNoteSequencePayload';
  creditNoteSequence?: Maybe<FinanceCreditNoteSequence>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of ArchiveFinanceSerialSequenceSalesInvoiceSequence. */
export type ArchiveFinanceSerialSequenceSalesInvoiceSequencePayload = {
  __typename?: 'ArchiveFinanceSerialSequenceSalesInvoiceSequencePayload';
  errors: Array<MutationError>;
  salesInvoiceSequence?: Maybe<FinanceSalesInvoiceSequence>;
};

/** Autogenerated return type of ArchiveFormsForm. */
export type ArchiveFormsFormPayload = {
  __typename?: 'ArchiveFormsFormPayload';
  errors: Array<MutationError>;
  form?: Maybe<FormsForm>;
};

/** Autogenerated return type of ArchiveJobcatalogLevel. */
export type ArchiveJobcatalogLevelPayload = {
  __typename?: 'ArchiveJobcatalogLevelPayload';
  errors: Array<MutationError>;
  level?: Maybe<JobCatalogLevel>;
};

/** Autogenerated return type of ArchiveJobcatalogRole. */
export type ArchiveJobcatalogRolePayload = {
  __typename?: 'ArchiveJobcatalogRolePayload';
  errors: Array<MutationError>;
  role?: Maybe<JobCatalogRole>;
};

/** Autogenerated return type of ArchiveLocationsWorkArea. */
export type ArchiveLocationsWorkAreaPayload = {
  __typename?: 'ArchiveLocationsWorkAreaPayload';
  errors: Array<MutationError>;
  workArea?: Maybe<LocationsWorkArea>;
};

/** Autogenerated return type of ArchivePayrollPolicy. */
export type ArchivePayrollPolicyPayload = {
  __typename?: 'ArchivePayrollPolicyPayload';
  errors: Array<MutationError>;
  policy?: Maybe<PayrollPolicy>;
};

/** Autogenerated return type of ArchivePostsGroup. */
export type ArchivePostsGroupPayload = {
  __typename?: 'ArchivePostsGroupPayload';
  errors: Array<MutationError>;
  group?: Maybe<PostsGroup>;
};

/** Autogenerated return type of ArchiveProcessesProcess. */
export type ArchiveProcessesProcessPayload = {
  __typename?: 'ArchiveProcessesProcessPayload';
  errors: Array<MutationError>;
  process?: Maybe<ProcessesProcess>;
};

/** Autogenerated return type of ArchiveSaleFinanceFinancialDocument. */
export type ArchiveSaleFinanceFinancialDocumentPayload = {
  __typename?: 'ArchiveSaleFinanceFinancialDocumentPayload';
  errors: Array<MutationError>;
  financialDocument?: Maybe<FinanceFinancialDocument>;
};

/** Autogenerated return type of ArchiveSurveysSurvey. */
export type ArchiveSurveysSurveyPayload = {
  __typename?: 'ArchiveSurveysSurveyPayload';
  errors: Array<MutationError>;
  survey?: Maybe<SurveysSurvey>;
};

/** Autogenerated return type of ArchiveWorkingconditionsGroup. */
export type ArchiveWorkingconditionsGroupPayload = {
  __typename?: 'ArchiveWorkingconditionsGroupPayload';
  errors: Array<MutationError>;
  group?: Maybe<WorkingConditionsGroup>;
};

/** An answer to custom question for an application in the ATS */
export type AtsAnswer = {
  __typename?: 'AtsAnswer';
  /** Identifier of the application */
  atsApplicationId: Scalars['Int'];
  /** Identifier of the question */
  atsQuestionId?: Maybe<Scalars['Int']>;
  /** Created date of the answer */
  createdAt: Scalars['ISO8601DateTime'];
  files: Array<ApiCoreAttachment>;
  filesConnection: ApiCoreAttachmentConnection;
  /** Identifier of the answer */
  id: Scalars['Int'];
  /** Question label of the answer */
  originalQuestionLabel: Scalars['String'];
  /** Original type of the question */
  originalQuestionType: AtsQuestionTypeEnum;
  /** Last updated date of the answer */
  updatedAt: Scalars['ISO8601DateTime'];
  /** Value of the answer */
  value?: Maybe<Scalars['String']>;
};


/** An answer to custom question for an application in the ATS */
export type AtsAnswerFilesArgs = {
  attachmentName?: InputMaybe<Scalars['String']>;
};


/** An answer to custom question for an application in the ATS */
export type AtsAnswerFilesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  attachmentName?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for AtsAnswer. */
export type AtsAnswerConnection = {
  __typename?: 'AtsAnswerConnection';
  /** A list of edges. */
  edges: Array<AtsAnswerEdge>;
  /** A list of nodes. */
  nodes: Array<AtsAnswer>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AtsAnswerEdge = {
  __typename?: 'AtsAnswerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AtsAnswer;
};

/** An application for a job in the ATS */
export type AtsApplication = {
  __typename?: 'AtsApplication';
  answers: Array<AtsAnswer>;
  answersConnection: AtsAnswerConnection;
  applicationPhase: AtsApplicationPhase;
  applicationSource?: Maybe<AtsCandidateSource>;
  assessment?: Maybe<AtsAssessment>;
  /**
   * Application phase id
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  atsApplicationPhaseId?: Maybe<Scalars['Int']>;
  atsApplicationPhaseName?: Maybe<Scalars['String']>;
  atsApplicationPhasePosition?: Maybe<Scalars['Int']>;
  atsApplicationPhaseType: AtsApplicationPhaseTypeEnum;
  /**
   * Candidate id of the application
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  atsCandidateId: Scalars['Int'];
  atsCandidateSourceName?: Maybe<Scalars['String']>;
  /** Application conversation id */
  atsConversationId?: Maybe<Scalars['Int']>;
  atsFiles: Array<AtsFile>;
  /**
   * Job posting id of the application
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  atsJobPostingId: Scalars['Int'];
  atsJobPostingTitle: Scalars['String'];
  atsRejectionReason?: Maybe<Scalars['String']>;
  /**
   * Application rejection reason id
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  atsRejectionReasonId?: Maybe<Scalars['Int']>;
  atsfilesConnection: AtsFileConnection;
  candidate: AtsCandidate;
  /** Company id of the application */
  companyId: Scalars['Int'];
  conversation?: Maybe<AtsConversation>;
  /** Application cover letter */
  coverLetter?: Maybe<Scalars['String']>;
  /** Application created at date */
  createdAt: Scalars['ISO8601DateTime'];
  cv?: Maybe<AtsFileAttachment>;
  /** Disqualified reason */
  disqualifiedReason?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  employee?: Maybe<EmployeesEmployee>;
  /**
   * Employee id of the application
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  employeeId?: Maybe<Scalars['Int']>;
  feedbacks: Array<AtsFeedback>;
  feedbacksConnection: AtsFeedbackConnection;
  files: Array<ApiCoreAttachment>;
  filesConnection: ApiCoreAttachmentConnection;
  firstName: Scalars['String'];
  fullName: Scalars['String'];
  /** Id of the application */
  id: Scalars['Int'];
  /** Integrations join order id if comes from premium posting */
  integrationsJoinOrderId?: Maybe<Scalars['Int']>;
  jobPosting: AtsJobPosting;
  lastName: Scalars['String'];
  /** Application medium */
  medium?: Maybe<Scalars['String']>;
  offerLetter?: Maybe<AtsOfferLetter>;
  openAiFeedbackTopMatchRating?: Maybe<OpenAiFeedback>;
  personalUrl?: Maybe<Scalars['String']>;
  /** Candidate phone of the application */
  phone?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  photoThumbnail?: Maybe<Scalars['String']>;
  /** Qualified of the application */
  qualified?: Maybe<Scalars['Boolean']>;
  /** Application average rating */
  ratingAverage?: Maybe<Scalars['Int']>;
  rejectionReason?: Maybe<AtsRejectionReason>;
  relatedJobPosting: AtsRelatedJobPosting;
  /**
   * Application source id
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  sourceId?: Maybe<Scalars['Int']>;
  summary?: Maybe<AtsApplicationSummary>;
  talentPool: Scalars['Boolean'];
};


/** An application for a job in the ATS */
export type AtsApplicationAnswersArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** An application for a job in the ATS */
export type AtsApplicationAnswersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** An application for a job in the ATS */
export type AtsApplicationApplicationPhaseArgs = {
  atsJobPostingId?: InputMaybe<Scalars['Int']>;
  atsJobPostingIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** An application for a job in the ATS */
export type AtsApplicationApplicationSourceArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


/** An application for a job in the ATS */
export type AtsApplicationAssessmentArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** An application for a job in the ATS */
export type AtsApplicationAtsFilesArgs = {
  atsApplicationId?: InputMaybe<Scalars['Int']>;
  atsCandidateId?: InputMaybe<Scalars['Int']>;
  atsCandidateIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceId?: InputMaybe<Scalars['Int']>;
  resourceIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceType?: InputMaybe<Scalars['String']>;
};


/** An application for a job in the ATS */
export type AtsApplicationAtsfilesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  atsApplicationId?: InputMaybe<Scalars['Int']>;
  atsCandidateId?: InputMaybe<Scalars['Int']>;
  atsCandidateIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  resourceId?: InputMaybe<Scalars['Int']>;
  resourceIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceType?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


/** An application for a job in the ATS */
export type AtsApplicationCandidateArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  atsTagIds?: InputMaybe<Array<Scalars['Int']>>;
  consent?: InputMaybe<Array<Scalars['String']>>;
  contractType?: InputMaybe<Scalars['String']>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['Int']>;
  jobPostingIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  minimumAverageRating?: InputMaybe<Scalars['Float']>;
  rejectionReasonIds?: InputMaybe<Array<Scalars['Int']>>;
  remote?: InputMaybe<Scalars['Boolean']>;
  scheduleType?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Array<Scalars['String']>>;
  sourceIds?: InputMaybe<Array<Scalars['Int']>>;
  talentPool?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** An application for a job in the ATS */
export type AtsApplicationConversationArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeLastMessage?: Scalars['Boolean'];
  watcher?: InputMaybe<Scalars['Boolean']>;
};


/** An application for a job in the ATS */
export type AtsApplicationEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** An application for a job in the ATS */
export type AtsApplicationFeedbacksArgs = {
  atsApplicationId?: InputMaybe<Scalars['Int']>;
  atsCandidateId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  publicFeedbacks?: InputMaybe<Scalars['Boolean']>;
};


/** An application for a job in the ATS */
export type AtsApplicationFeedbacksConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  atsApplicationId?: InputMaybe<Scalars['Int']>;
  atsCandidateId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  publicFeedbacks?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Sort>;
};


/** An application for a job in the ATS */
export type AtsApplicationFilesArgs = {
  attachmentName?: InputMaybe<Scalars['String']>;
};


/** An application for a job in the ATS */
export type AtsApplicationFilesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  attachmentName?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** An application for a job in the ATS */
export type AtsApplicationJobPostingArgs = {
  hiringManagerAccessIds?: InputMaybe<Array<Scalars['Int']>>;
  id?: InputMaybe<Scalars['Int']>;
  includeActiveJobs?: InputMaybe<Scalars['Boolean']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  locationId?: InputMaybe<Scalars['Int']>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  status?: InputMaybe<AtsJobPostingStatusesEnum>;
  statuses?: InputMaybe<Array<AtsJobPostingStatusesEnum>>;
  teamId?: InputMaybe<Scalars['Int']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  title?: InputMaybe<Scalars['String']>;
};


/** An application for a job in the ATS */
export type AtsApplicationOfferLetterArgs = {
  atsJobPostingId?: InputMaybe<Scalars['Int']>;
};


/** An application for a job in the ATS */
export type AtsApplicationOpenAiFeedbackTopMatchRatingArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
  resourceIds?: InputMaybe<Array<Scalars['String']>>;
};


/** An application for a job in the ATS */
export type AtsApplicationRejectionReasonArgs = {
  atsApplicationIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** An application for a job in the ATS */
export type AtsApplicationRelatedJobPostingArgs = {
  status?: InputMaybe<Enum>;
};

export type AtsApplicationAuthorTypeEnum =
  | 'access'
  | 'company'
  | 'user';

/** The connection type for AtsApplication. */
export type AtsApplicationConnection = {
  __typename?: 'AtsApplicationConnection';
  /** A list of edges. */
  edges: Array<AtsApplicationEdge>;
  /** A list of nodes. */
  nodes: Array<AtsApplication>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AtsApplicationEdge = {
  __typename?: 'AtsApplicationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AtsApplication;
};

/** the filter for the applications resource */
export type AtsApplicationFilter = {
  atsApplicationPhasePosition?: InputMaybe<IntegerFilter>;
  atsCandidateSourceName?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntegerFilter>;
  or?: InputMaybe<Array<AtsApplicationFilterConditions>>;
  ratingAverage?: InputMaybe<IntegerFilter>;
};

export type AtsApplicationFilterConditions = {
  atsApplicationPhasePosition?: InputMaybe<IntegerFilter>;
  atsCandidateSourceName?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntegerFilter>;
  ratingAverage?: InputMaybe<IntegerFilter>;
};

/** Ats application participant */
export type AtsApplicationParticipant = {
  __typename?: 'AtsApplicationParticipant';
  accessId: Scalars['Int'];
  atsApplicationId: Scalars['Int'];
  id: Scalars['String'];
};

/** The connection type for AtsApplicationParticipant. */
export type AtsApplicationParticipantConnection = {
  __typename?: 'AtsApplicationParticipantConnection';
  /** A list of edges. */
  edges: Array<AtsApplicationParticipantEdge>;
  /** A list of nodes. */
  nodes: Array<AtsApplicationParticipant>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AtsApplicationParticipantEdge = {
  __typename?: 'AtsApplicationParticipantEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AtsApplicationParticipant;
};

/** Phases defined for an specific job opening. Are related to a Hiring Stage, but can be different for different job openings */
export type AtsApplicationPhase = {
  __typename?: 'AtsApplicationPhase';
  activeApplicationsCount?: Maybe<Scalars['Int']>;
  /** Active application count */
  applicationsCount?: Maybe<Scalars['Int']>;
  /**
   * Hiring stage identifier
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  atsHiringStageId?: Maybe<Scalars['Int']>;
  /** Job posting of the application phase */
  atsJobPostingId: Scalars['Int'];
  /** If the application phase is editable */
  editable: Scalars['Boolean'];
  hiringStage?: Maybe<AtsHiringStage>;
  /** Identifier of the application Phase */
  id: Scalars['Int'];
  /** Name of the application phase */
  name: Scalars['String'];
  /** Application phase type */
  phaseType: AtsApplicationPhaseTypeEnum;
  /** Position of the application phase */
  position: Scalars['Int'];
};


/** Phases defined for an specific job opening. Are related to a Hiring Stage, but can be different for different job openings */
export type AtsApplicationPhaseHiringStageArgs = {
  atsApplicationPhaseId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** The connection type for AtsApplicationPhase. */
export type AtsApplicationPhaseConnection = {
  __typename?: 'AtsApplicationPhaseConnection';
  /** A list of edges. */
  edges: Array<AtsApplicationPhaseEdge>;
  /** A list of nodes. */
  nodes: Array<AtsApplicationPhase>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AtsApplicationPhaseEdge = {
  __typename?: 'AtsApplicationPhaseEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AtsApplicationPhase;
};

export type AtsApplicationPhaseTypeEnum =
  | 'assessment'
  | 'hired'
  | 'initial'
  | 'interview'
  | 'normal'
  | 'offer'
  | 'screening';

/** Automatically summary generated for an application */
export type AtsApplicationSummary = {
  __typename?: 'AtsApplicationSummary';
  application: AtsApplication;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  atsApplicationId: Scalars['Int'];
  atsJobPostingId: Scalars['Int'];
  details: Scalars['String'];
  latencyHours?: Maybe<Scalars['Float']>;
  processedAt: Scalars['ISO8601DateTime'];
  score: Scalars['Int'];
  topMatch: Scalars['Boolean'];
  updatedAt: Scalars['ISO8601DateTime'];
};


/** Automatically summary generated for an application */
export type AtsApplicationSummaryApplicationArgs = {
  afterApplicationId?: InputMaybe<Scalars['Int']>;
  atsAnswers?: InputMaybe<Array<ApplicationsAtsAnswersInput>>;
  atsApplicationPhaseId?: InputMaybe<Scalars['Int']>;
  atsCandidateId?: InputMaybe<Scalars['Int']>;
  atsCandidateIds?: InputMaybe<Array<Scalars['Int']>>;
  atsJobPostingId?: InputMaybe<Scalars['Int']>;
  atsRejectionReasonIds?: InputMaybe<Array<Scalars['Int']>>;
  atsTagsIds?: InputMaybe<Array<Scalars['Int']>>;
  beforeApplicationId?: InputMaybe<Scalars['Int']>;
  includeRatingAverages?: InputMaybe<Scalars['Boolean']>;
  qualified?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};

/** The connection type for AtsApplicationSummary. */
export type AtsApplicationSummaryConnection = {
  __typename?: 'AtsApplicationSummaryConnection';
  /** A list of edges. */
  edges: Array<AtsApplicationSummaryEdge>;
  /** A list of nodes. */
  nodes: Array<AtsApplicationSummary>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AtsApplicationSummaryEdge = {
  __typename?: 'AtsApplicationSummaryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AtsApplicationSummary;
};

/** Insights for the candidates gender received by a company */
export type AtsApplicationsGenderInsight = {
  __typename?: 'AtsApplicationsGenderInsight';
  gender?: Maybe<AtsCandidateGenderOptionsEnum>;
  hired: Scalars['Int'];
  notInitial: Scalars['Int'];
  total: Scalars['Int'];
};

/** The connection type for AtsApplicationsGenderInsight. */
export type AtsApplicationsGenderInsightConnection = {
  __typename?: 'AtsApplicationsGenderInsightConnection';
  /** A list of edges. */
  edges: Array<AtsApplicationsGenderInsightEdge>;
  /** A list of nodes. */
  nodes: Array<AtsApplicationsGenderInsight>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AtsApplicationsGenderInsightEdge = {
  __typename?: 'AtsApplicationsGenderInsightEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AtsApplicationsGenderInsight;
};

/** Insights for source of the applications received by a company */
export type AtsApplicationsSourceInsight = {
  __typename?: 'AtsApplicationsSourceInsight';
  hired: Scalars['Int'];
  notInitial: Scalars['Int'];
  source?: Maybe<AtsCandidateSource>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  sourceId?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};


/** Insights for source of the applications received by a company */
export type AtsApplicationsSourceInsightSourceArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};

/** The connection type for AtsApplicationsSourceInsight. */
export type AtsApplicationsSourceInsightConnection = {
  __typename?: 'AtsApplicationsSourceInsightConnection';
  /** A list of edges. */
  edges: Array<AtsApplicationsSourceInsightEdge>;
  /** A list of nodes. */
  nodes: Array<AtsApplicationsSourceInsight>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AtsApplicationsSourceInsightEdge = {
  __typename?: 'AtsApplicationsSourceInsightEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AtsApplicationsSourceInsight;
};

/** Application assessment */
export type AtsAssessment = {
  __typename?: 'AtsAssessment';
  application: AtsApplication;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  atsApplicationId: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  reportUrl?: Maybe<Scalars['String']>;
  status: AtsAssessmentStatusesEnum;
  updatedAt: Scalars['ISO8601DateTime'];
};


/** Application assessment */
export type AtsAssessmentApplicationArgs = {
  afterApplicationId?: InputMaybe<Scalars['Int']>;
  atsAnswers?: InputMaybe<Array<ApplicationsAtsAnswersInput>>;
  atsApplicationPhaseId?: InputMaybe<Scalars['Int']>;
  atsCandidateId?: InputMaybe<Scalars['Int']>;
  atsCandidateIds?: InputMaybe<Array<Scalars['Int']>>;
  atsJobPostingId?: InputMaybe<Scalars['Int']>;
  atsRejectionReasonIds?: InputMaybe<Array<Scalars['Int']>>;
  atsTagsIds?: InputMaybe<Array<Scalars['Int']>>;
  beforeApplicationId?: InputMaybe<Scalars['Int']>;
  includeRatingAverages?: InputMaybe<Scalars['Boolean']>;
  qualified?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};

/** The connection type for AtsAssessment. */
export type AtsAssessmentConnection = {
  __typename?: 'AtsAssessmentConnection';
  /** A list of edges. */
  edges: Array<AtsAssessmentEdge>;
  /** A list of nodes. */
  nodes: Array<AtsAssessment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AtsAssessmentEdge = {
  __typename?: 'AtsAssessmentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AtsAssessment;
};

export type AtsAssessmentStatusesEnum =
  | 'completed'
  | 'failed_to_process'
  | 'pending_to_complete'
  | 'pending_to_create';

/** A Candidate in the ATS */
export type AtsCandidate = {
  __typename?: 'AtsCandidate';
  activeApplicationCount?: Maybe<Scalars['Int']>;
  applications: Array<AtsApplication>;
  applicationsConnection: AtsApplicationConnection;
  atsFiles: Array<AtsFile>;
  /**
   * list of job posting identifiers.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  atsJobPostingIds?: Maybe<Array<Scalars['Int']>>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  atsTagIds?: Maybe<Array<Scalars['Int']>>;
  atsfilesConnection: AtsFileConnection;
  candidateSource?: Maybe<AtsCandidateSource>;
  /** company identifier. */
  companyId?: Maybe<Scalars['Int']>;
  /** date when the consent expires. */
  consentExpirationDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** date when the consent was given. */
  consentGivenAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** consent to talent pool. */
  consentToTalentPool?: Maybe<Scalars['Boolean']>;
  /** creation date of the candidate. */
  createdAt: Scalars['ISO8601DateTime'];
  duplicateIdentificationsAsMatched: Array<AtsCandidateDuplicatesIdentification>;
  duplicateIdentificationsAsSource: Array<AtsCandidateDuplicatesIdentification>;
  duplicateidentificationsasmatchedConnection: AtsCandidateDuplicatesIdentificationConnection;
  duplicateidentificationsassourceConnection: AtsCandidateDuplicatesIdentificationConnection;
  /** email of the candidate. */
  email?: Maybe<Scalars['String']>;
  files: Array<ApiCoreAttachment>;
  filesConnection: ApiCoreAttachmentConnection;
  /** name of the candidate. */
  firstName: Scalars['String'];
  /** full name of the candidate. */
  fullName: Scalars['String'];
  /** gender of the candidate. */
  gender?: Maybe<AtsCandidateGenderOptionsEnum>;
  /** identifier of the candidate. */
  id: Scalars['Int'];
  /** date when the candidate became inactive. */
  inactiveSince?: Maybe<Scalars['ISO8601DateTime']>;
  jobPostings: Array<AtsJobPosting>;
  jobpostingsConnection: AtsJobPostingConnection;
  /** last name of the candidate. */
  lastName: Scalars['String'];
  /**
   * specifies additional details related to the source of the candidate, such as
   * the referrer name for example if the source is referred.
   */
  medium?: Maybe<Scalars['String']>;
  /** personal web resource from the candidate. */
  personalUrl?: Maybe<Scalars['String']>;
  /** phone number of the candidate. */
  phoneNumber?: Maybe<Scalars['String']>;
  ratingAverage?: Maybe<Scalars['Float']>;
  /** score of the candidate. */
  score?: Maybe<Scalars['Float']>;
  searchResult?: Maybe<SearchResult>;
  searchable?: Maybe<Scalars['String']>;
  /**
   * candidate source identifier, refers to ats/candidate_sources endpoint.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  sourceId?: Maybe<Scalars['Int']>;
  tags: Array<AtsTag>;
  tagsConnection: AtsTagConnection;
  /** is the candidate part of talent pool? */
  talentPool: Scalars['Boolean'];
  /** last update of the candidate. */
  updatedAt: Scalars['ISO8601DateTime'];
};


/** A Candidate in the ATS */
export type AtsCandidateApplicationsArgs = {
  afterApplicationId?: InputMaybe<Scalars['Int']>;
  atsAnswers?: InputMaybe<Array<ApplicationsAtsAnswersInput>>;
  atsApplicationPhaseId?: InputMaybe<Scalars['Int']>;
  atsCandidateId?: InputMaybe<Scalars['Int']>;
  atsJobPostingId?: InputMaybe<Scalars['Int']>;
  atsRejectionReasonIds?: InputMaybe<Array<Scalars['Int']>>;
  atsTagsIds?: InputMaybe<Array<Scalars['Int']>>;
  beforeApplicationId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeRatingAverages?: InputMaybe<Scalars['Boolean']>;
  qualified?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};


/** A Candidate in the ATS */
export type AtsCandidateApplicationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  afterApplicationId?: InputMaybe<Scalars['Int']>;
  atsAnswers?: InputMaybe<Array<ApplicationsAtsAnswersInput>>;
  atsApplicationPhaseId?: InputMaybe<Scalars['Int']>;
  atsCandidateId?: InputMaybe<Scalars['Int']>;
  atsJobPostingId?: InputMaybe<Scalars['Int']>;
  atsRejectionReasonIds?: InputMaybe<Array<Scalars['Int']>>;
  atsTagsIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  beforeApplicationId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeRatingAverages?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  qualified?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


/** A Candidate in the ATS */
export type AtsCandidateAtsFilesArgs = {
  atsApplicationId?: InputMaybe<Scalars['Int']>;
  atsApplicationIds?: InputMaybe<Array<Scalars['Int']>>;
  atsCandidateId?: InputMaybe<Scalars['Int']>;
  resourceId?: InputMaybe<Scalars['Int']>;
  resourceIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceType?: InputMaybe<Scalars['String']>;
};


/** A Candidate in the ATS */
export type AtsCandidateAtsfilesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  atsApplicationId?: InputMaybe<Scalars['Int']>;
  atsApplicationIds?: InputMaybe<Array<Scalars['Int']>>;
  atsCandidateId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  resourceId?: InputMaybe<Scalars['Int']>;
  resourceIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceType?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


/** A Candidate in the ATS */
export type AtsCandidateCandidateSourceArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


/** A Candidate in the ATS */
export type AtsCandidateDuplicateIdentificationsAsMatchedArgs = {
  candidateMatchedId?: InputMaybe<Scalars['Int']>;
  candidateSourceId?: InputMaybe<Scalars['Int']>;
  candidateSourceIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  minScore?: InputMaybe<Scalars['Float']>;
};


/** A Candidate in the ATS */
export type AtsCandidateDuplicateIdentificationsAsSourceArgs = {
  candidateMatchedId?: InputMaybe<Scalars['Int']>;
  candidateMatchedIds?: InputMaybe<Array<Scalars['Int']>>;
  candidateSourceId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  minScore?: InputMaybe<Scalars['Float']>;
};


/** A Candidate in the ATS */
export type AtsCandidateDuplicateidentificationsasmatchedConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  candidateMatchedId?: InputMaybe<Scalars['Int']>;
  candidateSourceId?: InputMaybe<Scalars['Int']>;
  candidateSourceIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  minScore?: InputMaybe<Scalars['Float']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** A Candidate in the ATS */
export type AtsCandidateDuplicateidentificationsassourceConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  candidateMatchedId?: InputMaybe<Scalars['Int']>;
  candidateMatchedIds?: InputMaybe<Array<Scalars['Int']>>;
  candidateSourceId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  minScore?: InputMaybe<Scalars['Float']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** A Candidate in the ATS */
export type AtsCandidateFilesArgs = {
  attachmentName?: InputMaybe<Scalars['String']>;
};


/** A Candidate in the ATS */
export type AtsCandidateFilesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  attachmentName?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** A Candidate in the ATS */
export type AtsCandidateJobPostingsArgs = {
  hiringManagerAccessIds?: InputMaybe<Array<Scalars['Int']>>;
  id?: InputMaybe<Scalars['Int']>;
  includeActiveJobs?: InputMaybe<Scalars['Boolean']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  locationId?: InputMaybe<Scalars['Int']>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  status?: InputMaybe<AtsJobPostingStatusesEnum>;
  statuses?: InputMaybe<Array<AtsJobPostingStatusesEnum>>;
  teamId?: InputMaybe<Scalars['Int']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  title?: InputMaybe<Scalars['String']>;
};


/** A Candidate in the ATS */
export type AtsCandidateJobpostingsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  hiringManagerAccessIds?: InputMaybe<Array<Scalars['Int']>>;
  id?: InputMaybe<Scalars['Int']>;
  includeActiveJobs?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  locationId?: InputMaybe<Scalars['Int']>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  status?: InputMaybe<AtsJobPostingStatusesEnum>;
  statuses?: InputMaybe<Array<AtsJobPostingStatusesEnum>>;
  teamId?: InputMaybe<Scalars['Int']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  title?: InputMaybe<Scalars['String']>;
};


/** A Candidate in the ATS */
export type AtsCandidateTagsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for AtsCandidate. */
export type AtsCandidateConnection = {
  __typename?: 'AtsCandidateConnection';
  /** A list of edges. */
  edges: Array<AtsCandidateEdge>;
  /** A list of nodes. */
  nodes: Array<AtsCandidate>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** Candidate duplicates identification records */
export type AtsCandidateDuplicatesIdentification = {
  __typename?: 'AtsCandidateDuplicatesIdentification';
  /**
   * identifier of the matched candidate in the pair.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  candidateMatchedId: Scalars['Int'];
  /**
   * identifier of the source candidate in the pair.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  candidateSourceId: Scalars['Int'];
  company: ApiCoreCompany;
  /**
   * company identifier.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  companyId: Scalars['Int'];
  /** creation date of the duplicate identification record. */
  createdAt: Scalars['ISO8601DateTime'];
  /** identifier of the duplicate identification record. */
  id: Scalars['Int'];
  matchedCandidate: AtsCandidate;
  /** detailed scores from individual matchers. Each matcher contains source and matched resource information. */
  matchersScores: Array<AtsMatcherScore>;
  /** similarity score between the two candidates (0.0 to 1.0). */
  score: Scalars['Float'];
  sourceCandidate: AtsCandidate;
  /** last update of the duplicate identification record. */
  updatedAt: Scalars['ISO8601DateTime'];
};


/** Candidate duplicates identification records */
export type AtsCandidateDuplicatesIdentificationMatchedCandidateArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  atsTagIds?: InputMaybe<Array<Scalars['Int']>>;
  consent?: InputMaybe<Array<Scalars['String']>>;
  contractType?: InputMaybe<Scalars['String']>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['Int']>;
  jobPostingIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  minimumAverageRating?: InputMaybe<Scalars['Float']>;
  rejectionReasonIds?: InputMaybe<Array<Scalars['Int']>>;
  remote?: InputMaybe<Scalars['Boolean']>;
  scheduleType?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Array<Scalars['String']>>;
  sourceIds?: InputMaybe<Array<Scalars['Int']>>;
  talentPool?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Candidate duplicates identification records */
export type AtsCandidateDuplicatesIdentificationSourceCandidateArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  atsTagIds?: InputMaybe<Array<Scalars['Int']>>;
  consent?: InputMaybe<Array<Scalars['String']>>;
  contractType?: InputMaybe<Scalars['String']>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['Int']>;
  jobPostingIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  minimumAverageRating?: InputMaybe<Scalars['Float']>;
  rejectionReasonIds?: InputMaybe<Array<Scalars['Int']>>;
  remote?: InputMaybe<Scalars['Boolean']>;
  scheduleType?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Array<Scalars['String']>>;
  sourceIds?: InputMaybe<Array<Scalars['Int']>>;
  talentPool?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
};

/** The connection type for AtsCandidateDuplicatesIdentification. */
export type AtsCandidateDuplicatesIdentificationConnection = {
  __typename?: 'AtsCandidateDuplicatesIdentificationConnection';
  /** A list of edges. */
  edges: Array<AtsCandidateDuplicatesIdentificationEdge>;
  /** A list of nodes. */
  nodes: Array<AtsCandidateDuplicatesIdentification>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AtsCandidateDuplicatesIdentificationEdge = {
  __typename?: 'AtsCandidateDuplicatesIdentificationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AtsCandidateDuplicatesIdentification;
};

/** the filter for the candidate_duplicates_identifications resource */
export type AtsCandidateDuplicatesIdentificationFilter = {
  candidateMatchedId?: InputMaybe<IntegerFilter>;
  candidateSourceId?: InputMaybe<IntegerFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntegerFilter>;
  matchersScores?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<AtsCandidateDuplicatesIdentificationFilterConditions>>;
  score?: InputMaybe<NumberFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type AtsCandidateDuplicatesIdentificationFilterConditions = {
  candidateMatchedId?: InputMaybe<IntegerFilter>;
  candidateSourceId?: InputMaybe<IntegerFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntegerFilter>;
  matchersScores?: InputMaybe<StringFilter>;
  score?: InputMaybe<NumberFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

/** An edge in a connection. */
export type AtsCandidateEdge = {
  __typename?: 'AtsCandidateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AtsCandidate;
};

/** candidate_email_actions */
export type AtsCandidateEmailAction = {
  __typename?: 'AtsCandidateEmailAction';
  actionType: AtsCandidateEmailActionTypesEnum;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  atsApplicationPhaseIds: Array<Scalars['Int']>;
  atsApplicationPhases: Array<AtsApplicationPhase>;
  atsApplicationPhasesConnection: AtsApplicationPhaseConnection;
  atsJobPosting: AtsJobPosting;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  atsJobPostingId: Scalars['Int'];
  atsMessageTemplate: AtsMessageTemplate;
  createdAt: Scalars['ISO8601DateTime'];
  delay: AtsCandidateEmailActionDelaysEnum;
  emailFrom: AtsCandidateEmailActionSenderOptionsEnum;
  enabled: Scalars['Boolean'];
  files: Array<AtsFile>;
  filesConnection: AtsFileConnection;
  id: Scalars['Int'];
  messageContent: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};


/** candidate_email_actions */
export type AtsCandidateEmailActionAtsApplicationPhasesArgs = {
  atsJobPostingId?: InputMaybe<Scalars['Int']>;
  atsJobPostingIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** candidate_email_actions */
export type AtsCandidateEmailActionAtsApplicationPhasesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  atsJobPostingId?: InputMaybe<Scalars['Int']>;
  atsJobPostingIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** candidate_email_actions */
export type AtsCandidateEmailActionAtsJobPostingArgs = {
  hiringManagerAccessIds?: InputMaybe<Array<Scalars['Int']>>;
  id?: InputMaybe<Scalars['Int']>;
  includeActiveJobs?: InputMaybe<Scalars['Boolean']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  locationId?: InputMaybe<Scalars['Int']>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  status?: InputMaybe<AtsJobPostingStatusesEnum>;
  statuses?: InputMaybe<Array<AtsJobPostingStatusesEnum>>;
  teamId?: InputMaybe<Scalars['Int']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  title?: InputMaybe<Scalars['String']>;
};


/** candidate_email_actions */
export type AtsCandidateEmailActionAtsMessageTemplateArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


/** candidate_email_actions */
export type AtsCandidateEmailActionFilesArgs = {
  atsApplicationId?: InputMaybe<Scalars['Int']>;
  atsApplicationIds?: InputMaybe<Array<Scalars['Int']>>;
  atsCandidateId?: InputMaybe<Scalars['Int']>;
  atsCandidateIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceId?: InputMaybe<Scalars['Int']>;
};


/** candidate_email_actions */
export type AtsCandidateEmailActionFilesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  atsApplicationId?: InputMaybe<Scalars['Int']>;
  atsApplicationIds?: InputMaybe<Array<Scalars['Int']>>;
  atsCandidateId?: InputMaybe<Scalars['Int']>;
  atsCandidateIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  resourceId?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for AtsCandidateEmailAction. */
export type AtsCandidateEmailActionConnection = {
  __typename?: 'AtsCandidateEmailActionConnection';
  /** A list of edges. */
  edges: Array<AtsCandidateEmailActionEdge>;
  /** A list of nodes. */
  nodes: Array<AtsCandidateEmailAction>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type AtsCandidateEmailActionDelaysEnum =
  | 'four_hours'
  | 'next_monday_at_nine_am'
  | 'now'
  | 'six_hours'
  | 'today_at_six_pm'
  | 'tomorrow_at_nine_am'
  | 'two_hours';

/** An edge in a connection. */
export type AtsCandidateEmailActionEdge = {
  __typename?: 'AtsCandidateEmailActionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AtsCandidateEmailAction;
};

export type AtsCandidateEmailActionSenderOptionsEnum =
  | 'conversation'
  | 'no_reply';

export type AtsCandidateEmailActionTypesEnum =
  | 'phase_changed'
  | 'reject';

/** the filter for the candidates resource */
export type AtsCandidateFilter = {
  consent?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  firstName?: InputMaybe<StringFilter>;
  fullName?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntegerFilter>;
  jobPostingId?: InputMaybe<IntegerFilter>;
  jobPostingLegalEntityId?: InputMaybe<IntegerFilter>;
  jobPostingLocationId?: InputMaybe<IntegerFilter>;
  jobPostingTeamId?: InputMaybe<IntegerFilter>;
  lastName?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<AtsCandidateFilterConditions>>;
  ratingAverage?: InputMaybe<NumberFilter>;
  rejectionReasonId?: InputMaybe<IntegerFilter>;
  score?: InputMaybe<NumberFilter>;
  sourceId?: InputMaybe<IntegerFilter>;
  status?: InputMaybe<StringFilter>;
  tagIds?: InputMaybe<IntegerFilter>;
};

export type AtsCandidateFilterConditions = {
  consent?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  firstName?: InputMaybe<StringFilter>;
  fullName?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntegerFilter>;
  jobPostingId?: InputMaybe<IntegerFilter>;
  jobPostingLegalEntityId?: InputMaybe<IntegerFilter>;
  jobPostingLocationId?: InputMaybe<IntegerFilter>;
  jobPostingTeamId?: InputMaybe<IntegerFilter>;
  lastName?: InputMaybe<StringFilter>;
  ratingAverage?: InputMaybe<NumberFilter>;
  rejectionReasonId?: InputMaybe<IntegerFilter>;
  score?: InputMaybe<NumberFilter>;
  sourceId?: InputMaybe<IntegerFilter>;
  status?: InputMaybe<StringFilter>;
  tagIds?: InputMaybe<IntegerFilter>;
};

export type AtsCandidateGenderOptionsEnum =
  | 'female'
  | 'male'
  | 'other'
  | 'unanswered';

/** Ats candidate import */
export type AtsCandidateImport = {
  __typename?: 'AtsCandidateImport';
  success: Scalars['Boolean'];
};

/** Candidates Smart Search Recommendation */
export type AtsCandidateRecommendation = {
  __typename?: 'AtsCandidateRecommendation';
  activeApplicationCount?: Maybe<Scalars['Int']>;
  atsJobPostingIds?: Maybe<Array<Scalars['Int']>>;
  atsTagIds?: Maybe<Array<Scalars['Int']>>;
  companyId?: Maybe<Scalars['Int']>;
  consentExpirationDate?: Maybe<Scalars['ISO8601DateTime']>;
  consentGivenAt?: Maybe<Scalars['ISO8601DateTime']>;
  consentToTalentPool?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['ISO8601DateTime'];
  email?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  fullName: Scalars['String'];
  gender?: Maybe<AtsCandidateGenderOptionsEnum>;
  id: Scalars['Int'];
  inactiveSince?: Maybe<Scalars['ISO8601DateTime']>;
  lastName: Scalars['String'];
  medium?: Maybe<Scalars['String']>;
  personalUrl?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  ratingAverage?: Maybe<Scalars['Float']>;
  searchResult?: Maybe<SearchResult>;
  searchable?: Maybe<Scalars['String']>;
  sourceId?: Maybe<Scalars['Int']>;
  talentPool: Scalars['Boolean'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for AtsCandidateRecommendation. */
export type AtsCandidateRecommendationConnection = {
  __typename?: 'AtsCandidateRecommendationConnection';
  /** A list of edges. */
  edges: Array<AtsCandidateRecommendationEdge>;
  /** A list of nodes. */
  nodes: Array<AtsCandidateRecommendation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AtsCandidateRecommendationEdge = {
  __typename?: 'AtsCandidateRecommendationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AtsCandidateRecommendation;
};

/** Source to be used for candidate and application */
export type AtsCandidateSource = {
  __typename?: 'AtsCandidateSource';
  /** category of the source. */
  category: AtsCandidateSourceCategoriesEnum;
  company: ApiCoreCompany;
  /**
   * identifier of the company.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  companyId: Scalars['Int'];
  editable: Scalars['Boolean'];
  /** identifier of the source. */
  id: Scalars['Int'];
  /** Translated label of the source if it is a default one, or name otherwise */
  label: Scalars['String'];
  /** name of the source. */
  name: Scalars['String'];
};

export type AtsCandidateSourceCategoriesEnum =
  | 'agency_or_external_recruiter'
  | 'event'
  | 'internal'
  | 'job_board'
  | 'manually_added'
  | 'organic'
  | 'referral'
  | 'social_media'
  | 'system';

/** The connection type for AtsCandidateSource. */
export type AtsCandidateSourceConnection = {
  __typename?: 'AtsCandidateSourceConnection';
  /** A list of edges. */
  edges: Array<AtsCandidateSourceEdge>;
  /** A list of nodes. */
  nodes: Array<AtsCandidateSource>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AtsCandidateSourceEdge = {
  __typename?: 'AtsCandidateSourceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AtsCandidateSource;
};

/** the filter for the candidate_sources resource */
export type AtsCandidateSourceFilter = {
  category?: InputMaybe<StringFilter>;
  editable?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<AtsCandidateSourceFilterConditions>>;
};

export type AtsCandidateSourceFilterConditions = {
  category?: InputMaybe<StringFilter>;
  editable?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
};

/** Ats company */
export type AtsCompany = {
  __typename?: 'AtsCompany';
  activeJobPostingsCount: Scalars['Int'];
  aiMatchingEnabled?: Maybe<Scalars['Boolean']>;
  atsCareersHeaderId: Scalars['Int'];
  atsTrialLimit?: Maybe<Scalars['ISO8601DateTime']>;
  candidateSummaryEnabled?: Maybe<Scalars['Boolean']>;
  companyId: Scalars['Int'];
  id: Scalars['Int'];
  jobPostingsCount: Scalars['Int'];
  jobsUrl?: Maybe<Scalars['String']>;
  joinDirectApplyEnabled?: Maybe<Scalars['Boolean']>;
  joinEnabled?: Maybe<Scalars['Boolean']>;
  legalNoticeCustomUrl?: Maybe<Scalars['String']>;
  legalNoticeCustomUrlActive: Scalars['Boolean'];
  linkedinId?: Maybe<Scalars['String']>;
  locale: Scalars['String'];
  planJobPostingsLimit?: Maybe<Scalars['Int']>;
  privacyPolicyCustomUrl?: Maybe<Scalars['String']>;
  privacyPolicyCustomUrlActive: Scalars['Boolean'];
  privacyPolicyRecipients?: Maybe<Scalars['String']>;
  publicCareersPageActive?: Maybe<Scalars['Boolean']>;
  referralsEnabled?: Maybe<Scalars['Boolean']>;
  requisitionsEnabled?: Maybe<Scalars['Boolean']>;
  showFactorialAts?: Maybe<Scalars['Boolean']>;
  showFactorialBadge: Scalars['Boolean'];
  showPrivacyPolicy: Scalars['Boolean'];
  showTeamInJobOpenings?: Maybe<Scalars['Boolean']>;
  showWorkplaceTypeInJobOpenings?: Maybe<Scalars['Boolean']>;
  talentPoolByDefault: Scalars['Boolean'];
};

/** The connection type for AtsCompany. */
export type AtsCompanyConnection = {
  __typename?: 'AtsCompanyConnection';
  /** A list of edges. */
  edges: Array<AtsCompanyEdge>;
  /** A list of nodes. */
  nodes: Array<AtsCompany>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AtsCompanyEdge = {
  __typename?: 'AtsCompanyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AtsCompany;
};

export type AtsContextlessPolicies = {
  __typename?: 'AtsContextlessPolicies';
  callCandidate: ContextlessPolicyResolution;
  createJobPostings: ContextlessPolicyResolution;
  dashboardWidgetOpenPositionsVisible: ContextlessPolicyResolution;
  manageAtsSettings: ContextlessPolicyResolution;
  manageJobPostings: ContextlessPolicyResolution;
  managementEnabled: ContextlessPolicyResolution;
  messageTemplatesManageCompanyMessageTemplates: ContextlessPolicyResolution;
  requisitionsManage: ContextlessPolicyResolution;
  requisitionsUse: ContextlessPolicyResolution;
  salaryManage: ContextlessPolicyResolution;
  seeActiveJobsLimit: ContextlessPolicyResolution;
  sidebarSeeRecruitmentCandidatesSubLevelItem: ContextlessPolicyResolution;
  sidebarSeeRecruitmentInboxSubLevelItem: ContextlessPolicyResolution;
  sidebarSeeRecruitmentInsightsSubLevelItem: ContextlessPolicyResolution;
  sidebarSeeRecruitmentJobsSubLevelItem: ContextlessPolicyResolution;
  sidebarSeeRecruitmentOpenPositionsSubLevelItem: ContextlessPolicyResolution;
  sidebarSeeRecruitmentPurchaseRequestsSubLevelItem: ContextlessPolicyResolution;
  sidebarSeeRecruitmentTopLevelItem: ContextlessPolicyResolution;
  useAts: ContextlessPolicyResolution;
};

/** Contract types for job postings */
export type AtsContractType = {
  __typename?: 'AtsContractType';
  country: Scalars['String'];
  id: AtsContractTypesEnum;
  label: Scalars['String'];
};

/** The connection type for AtsContractType. */
export type AtsContractTypeConnection = {
  __typename?: 'AtsContractTypeConnection';
  /** A list of edges. */
  edges: Array<AtsContractTypeEdge>;
  /** A list of nodes. */
  nodes: Array<AtsContractType>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AtsContractTypeEdge = {
  __typename?: 'AtsContractTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AtsContractType;
};

export type AtsContractTypesEnum =
  | 'a_tempo_parcial'
  | 'a_termo_certo'
  | 'a_termo_incerto'
  | 'alternant'
  | 'apprendistato'
  | 'apprenticeship'
  | 'apprentissage'
  | 'clt'
  | 'com_pluralidade_de_empregadores'
  | 'de_curta_duracao'
  | 'de_muita_curta_duracao'
  | 'estagio'
  | 'fixed_discontinued'
  | 'freelance'
  | 'indefinite'
  | 'interim'
  | 'intern'
  | 'jovem_aprendiz'
  | 'minijob'
  | 'other'
  | 'per_hour'
  | 'pj'
  | 'pre_reforma'
  | 'promessa_de_trabalho'
  | 'recibos_verdes'
  | 'sem_termo'
  | 'teletrabalho'
  | 'temporary'
  | 'training'
  | 'vendor_contractor'
  | 'volunteer'
  | 'werkstudent';

/** Ats conversation */
export type AtsConversation = {
  __typename?: 'AtsConversation';
  application: AtsApplication;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  atsApplicationId: Scalars['Int'];
  atsLastMessageId?: Maybe<Scalars['Int']>;
  conversationStatus?: Maybe<AtsConversationStatus>;
  id: Scalars['Int'];
  lastMessage?: Maybe<AtsMessage>;
  messages: Array<AtsMessage>;
  messagesConnection: AtsMessageConnection;
  read: Scalars['Boolean'];
  replyEmail: Scalars['String'];
};


/** Ats conversation */
export type AtsConversationApplicationArgs = {
  afterApplicationId?: InputMaybe<Scalars['Int']>;
  atsAnswers?: InputMaybe<Array<ApplicationsAtsAnswersInput>>;
  atsApplicationPhaseId?: InputMaybe<Scalars['Int']>;
  atsCandidateId?: InputMaybe<Scalars['Int']>;
  atsCandidateIds?: InputMaybe<Array<Scalars['Int']>>;
  atsJobPostingId?: InputMaybe<Scalars['Int']>;
  atsRejectionReasonIds?: InputMaybe<Array<Scalars['Int']>>;
  atsTagsIds?: InputMaybe<Array<Scalars['Int']>>;
  beforeApplicationId?: InputMaybe<Scalars['Int']>;
  includeRatingAverages?: InputMaybe<Scalars['Boolean']>;
  qualified?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};


/** Ats conversation */
export type AtsConversationConversationStatusArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  atsConversationId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};


/** Ats conversation */
export type AtsConversationLastMessageArgs = {
  atsConversationId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Ats conversation */
export type AtsConversationMessagesArgs = {
  atsConversationId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  lastPerConversation?: Scalars['Boolean'];
};


/** Ats conversation */
export type AtsConversationMessagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  atsConversationId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  lastPerConversation?: Scalars['Boolean'];
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for AtsConversation. */
export type AtsConversationConnection = {
  __typename?: 'AtsConversationConnection';
  /** A list of edges. */
  edges: Array<AtsConversationEdge>;
  /** A list of nodes. */
  nodes: Array<AtsConversation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AtsConversationEdge = {
  __typename?: 'AtsConversationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AtsConversation;
};

/** Conversation status for an access */
export type AtsConversationStatus = {
  __typename?: 'AtsConversationStatus';
  accessId: Scalars['Int'];
  archivedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  atsConversationId: Scalars['Int'];
  conversation?: Maybe<AtsConversation>;
  id: Scalars['Int'];
  lastReadAt?: Maybe<Scalars['ISO8601DateTime']>;
};


/** Conversation status for an access */
export type AtsConversationStatusConversationArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  atsApplicationIds?: InputMaybe<Array<Scalars['Int']>>;
  id?: InputMaybe<Scalars['Int']>;
  includeLastMessage?: Scalars['Boolean'];
  watcher?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for AtsConversationStatus. */
export type AtsConversationStatusConnection = {
  __typename?: 'AtsConversationStatusConnection';
  /** A list of edges. */
  edges: Array<AtsConversationStatusEdge>;
  /** A list of nodes. */
  nodes: Array<AtsConversationStatus>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AtsConversationStatusEdge = {
  __typename?: 'AtsConversationStatusEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AtsConversationStatus;
};

/** CV bulk upload batch */
export type AtsCvBulkUpload = {
  __typename?: 'AtsCvBulkUpload';
  access?: Maybe<ApiCoreAccess>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  accessId?: Maybe<Scalars['Int']>;
  atsApplicationPhaseId?: Maybe<Scalars['Int']>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  atsCandidateSourceId?: Maybe<Scalars['Int']>;
  atsJobPostingId?: Maybe<Scalars['Int']>;
  candidateSource?: Maybe<AtsCandidateSource>;
  company: ApiCoreCompany;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  companyId: Scalars['Int'];
  files: Array<AtsFile>;
  filesConnection: AtsFileConnection;
  id: Scalars['Int'];
  status: AtsCvBulkUploadStatusesEnum;
};


/** CV bulk upload batch */
export type AtsCvBulkUploadAccessArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** CV bulk upload batch */
export type AtsCvBulkUploadCandidateSourceArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


/** CV bulk upload batch */
export type AtsCvBulkUploadFilesArgs = {
  atsApplicationId?: InputMaybe<Scalars['Int']>;
  atsApplicationIds?: InputMaybe<Array<Scalars['Int']>>;
  atsCandidateId?: InputMaybe<Scalars['Int']>;
  atsCandidateIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceId?: InputMaybe<Scalars['Int']>;
};


/** CV bulk upload batch */
export type AtsCvBulkUploadFilesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  atsApplicationId?: InputMaybe<Scalars['Int']>;
  atsApplicationIds?: InputMaybe<Array<Scalars['Int']>>;
  atsCandidateId?: InputMaybe<Scalars['Int']>;
  atsCandidateIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  resourceId?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for AtsCvBulkUpload. */
export type AtsCvBulkUploadConnection = {
  __typename?: 'AtsCvBulkUploadConnection';
  /** A list of edges. */
  edges: Array<AtsCvBulkUploadEdge>;
  /** A list of nodes. */
  nodes: Array<AtsCvBulkUpload>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AtsCvBulkUploadEdge = {
  __typename?: 'AtsCvBulkUploadEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AtsCvBulkUpload;
};

export type AtsCvBulkUploadStatusesEnum =
  | 'archived'
  | 'cancelled'
  | 'cancelling'
  | 'completed'
  | 'processing';

/** Ats data retention configuration */
export type AtsDataRetentionConfiguration = {
  __typename?: 'AtsDataRetentionConfiguration';
  atsCompanyId: Scalars['Int'];
  autoDeletionEnabled: Scalars['Boolean'];
  company?: Maybe<ApiCoreCompany>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  companyId?: Maybe<Scalars['Int']>;
  consentLimitEnabled: Scalars['Boolean'];
  consentRenewalEmailBody?: Maybe<Scalars['String']>;
  consentRenewalEmailEnabled: Scalars['Boolean'];
  consentRenewalEmailSubject?: Maybe<Scalars['String']>;
  defaultRetentionLimit: Scalars['Int'];
  eraseRejectedCandidates: Scalars['Boolean'];
  gracePeriodBeforeDeletion: Scalars['Int'];
  id: Scalars['Int'];
  notifyExpiredPermissions: Scalars['Boolean'];
  talentPoolRetentionLimit: Scalars['Int'];
};

/** The connection type for AtsDataRetentionConfiguration. */
export type AtsDataRetentionConfigurationConnection = {
  __typename?: 'AtsDataRetentionConfigurationConnection';
  /** A list of edges. */
  edges: Array<AtsDataRetentionConfigurationEdge>;
  /** A list of nodes. */
  nodes: Array<AtsDataRetentionConfiguration>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AtsDataRetentionConfigurationEdge = {
  __typename?: 'AtsDataRetentionConfigurationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AtsDataRetentionConfiguration;
};

export type AtsEntitiesInsightsDataSourceIdEnum =
  | 'applications'
  | 'job_postings';

export type AtsEntitiesInsightsJobPostingsInsightIdEnum =
  | 'hire_time'
  | 'job_postings'
  | 'job_postings_with_hiring'
  | 'last_updated_at'
  | 'new_job_postings'
  | 'offer_time';

/** A set of questions to evaluate an application for a job */
export type AtsEvaluationForm = {
  __typename?: 'AtsEvaluationForm';
  /**
   * Id of the job posting that the evaluation form is associated with.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  atsJobPostingId?: Maybe<Scalars['Int']>;
  basedOn?: Maybe<AtsEvaluationForm>;
  /**
   * Id of the evaluation form that this evaluation form is related.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  basedOnId?: Maybe<Scalars['Int']>;
  company: ApiCoreCompany;
  /**
   * Id of the company that the evaluation form belongs to.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  companyId: Scalars['Int'];
  /** date and time when the evaluation form was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** Id of the evaluation form. */
  id: Scalars['Int'];
  jobPosting?: Maybe<AtsJobPosting>;
  /** Name of the evaluation form. */
  name: Scalars['String'];
  /** List of questions in the evaluation form. */
  questions: Array<AtsEvaluationFormQuestion>;
  /** date and time when the evaluation form was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};


/** A set of questions to evaluate an application for a job */
export type AtsEvaluationFormBasedOnArgs = {
  atsJobPostingId?: InputMaybe<Scalars['Int']>;
  atsJobPostingIds?: InputMaybe<Array<Scalars['Int']>>;
  template?: InputMaybe<Scalars['Boolean']>;
};


/** A set of questions to evaluate an application for a job */
export type AtsEvaluationFormJobPostingArgs = {
  hiringManagerAccessIds?: InputMaybe<Array<Scalars['Int']>>;
  id?: InputMaybe<Scalars['Int']>;
  includeActiveJobs?: InputMaybe<Scalars['Boolean']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  locationId?: InputMaybe<Scalars['Int']>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  status?: InputMaybe<AtsJobPostingStatusesEnum>;
  statuses?: InputMaybe<Array<AtsJobPostingStatusesEnum>>;
  teamId?: InputMaybe<Scalars['Int']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  title?: InputMaybe<Scalars['String']>;
};

export type AtsEvaluationFormAnswer = {
  __typename?: 'AtsEvaluationFormAnswer';
  note?: Maybe<Scalars['String']>;
  questionId: Scalars['String'];
  score: Scalars['Int'];
};

/** The connection type for AtsEvaluationForm. */
export type AtsEvaluationFormConnection = {
  __typename?: 'AtsEvaluationFormConnection';
  /** A list of edges. */
  edges: Array<AtsEvaluationFormEdge>;
  /** A list of nodes. */
  nodes: Array<AtsEvaluationForm>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AtsEvaluationFormEdge = {
  __typename?: 'AtsEvaluationFormEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AtsEvaluationForm;
};

export type AtsEvaluationFormQuestion = {
  __typename?: 'AtsEvaluationFormQuestion';
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  text: Scalars['String'];
};

export type AtsEvaluationFormQuestionInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  text: Scalars['String'];
};

/** Favourite job postings of a certain user */
export type AtsFavouriteJobPosting = {
  __typename?: 'AtsFavouriteJobPosting';
  atsJobPosting: AtsJobPosting;
  /**
   * job posting identifier
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  atsJobPostingId: Scalars['Int'];
  author: ApiCoreAccess;
  /**
   * author identifier
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  authorId: Scalars['Int'];
  /** creation date time */
  createdAt: Scalars['ISO8601DateTime'];
  /** favourite job posting identifier */
  id: Scalars['Int'];
  /** last update date time */
  updatedAt: Scalars['ISO8601DateTime'];
};


/** Favourite job postings of a certain user */
export type AtsFavouriteJobPostingAtsJobPostingArgs = {
  hiringManagerAccessIds?: InputMaybe<Array<Scalars['Int']>>;
  id?: InputMaybe<Scalars['Int']>;
  includeActiveJobs?: InputMaybe<Scalars['Boolean']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  locationId?: InputMaybe<Scalars['Int']>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  status?: InputMaybe<AtsJobPostingStatusesEnum>;
  statuses?: InputMaybe<Array<AtsJobPostingStatusesEnum>>;
  teamId?: InputMaybe<Scalars['Int']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  title?: InputMaybe<Scalars['String']>;
};


/** Favourite job postings of a certain user */
export type AtsFavouriteJobPostingAuthorArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for AtsFavouriteJobPosting. */
export type AtsFavouriteJobPostingConnection = {
  __typename?: 'AtsFavouriteJobPostingConnection';
  /** A list of edges. */
  edges: Array<AtsFavouriteJobPostingEdge>;
  /** A list of nodes. */
  nodes: Array<AtsFavouriteJobPosting>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AtsFavouriteJobPostingEdge = {
  __typename?: 'AtsFavouriteJobPostingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AtsFavouriteJobPosting;
};

/** the filter for the favourite_job_postings resource */
export type AtsFavouriteJobPostingFilter = {
  atsJobPostingId?: InputMaybe<IntegerFilter>;
  authorId?: InputMaybe<IntegerFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  or?: InputMaybe<Array<AtsFavouriteJobPostingFilterConditions>>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type AtsFavouriteJobPostingFilterConditions = {
  atsJobPostingId?: InputMaybe<IntegerFilter>;
  authorId?: InputMaybe<IntegerFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

/** Application feedback */
export type AtsFeedback = {
  __typename?: 'AtsFeedback';
  access?: Maybe<ApiCoreAccess>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  accessId?: Maybe<Scalars['Int']>;
  application?: Maybe<AtsApplication>;
  applicationPhase?: Maybe<AtsApplicationPhase>;
  /**
   * the ID of the application related to the feedback.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  atsApplicationId?: Maybe<Scalars['Int']>;
  /**
   * the ID of the phase within the application related to the feedback.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  atsApplicationPhaseId?: Maybe<Scalars['Int']>;
  /**
   * the ID of the candidate to whom the feedback is associated.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  atsCandidateId: Scalars['Int'];
  /** the ID of the evaluation form to which the feedback belongs if the evaluation forms feature is active. */
  atsEvaluationFormsId?: Maybe<Scalars['Int']>;
  atsFiles: Array<AtsFile>;
  atsfilesConnection: AtsFileConnection;
  attachments: Array<ApiCoreAttachment>;
  attachmentsConnection: ApiCoreAttachmentConnection;
  candidate: AtsCandidate;
  /** the date and time when the feedback entry was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** the description of the feedback provided. */
  description?: Maybe<Scalars['String']>;
  /** the answers from the evaluation form, if this feedback is related to an evaluation form. */
  evaluationFormAnswers?: Maybe<Array<AtsEvaluationFormAnswer>>;
  /** the ID of the feedback entry. */
  id: Scalars['Int'];
  /** the overall rating from 1 to 5 for the candidate's application. */
  rating?: Maybe<Scalars['Int']>;
  /** the visibility status of the feedback */
  visibility?: Maybe<Scalars['String']>;
};


/** Application feedback */
export type AtsFeedbackAccessArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** Application feedback */
export type AtsFeedbackApplicationArgs = {
  afterApplicationId?: InputMaybe<Scalars['Int']>;
  atsAnswers?: InputMaybe<Array<ApplicationsAtsAnswersInput>>;
  atsApplicationPhaseId?: InputMaybe<Scalars['Int']>;
  atsCandidateId?: InputMaybe<Scalars['Int']>;
  atsCandidateIds?: InputMaybe<Array<Scalars['Int']>>;
  atsJobPostingId?: InputMaybe<Scalars['Int']>;
  atsRejectionReasonIds?: InputMaybe<Array<Scalars['Int']>>;
  atsTagsIds?: InputMaybe<Array<Scalars['Int']>>;
  beforeApplicationId?: InputMaybe<Scalars['Int']>;
  includeRatingAverages?: InputMaybe<Scalars['Boolean']>;
  qualified?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};


/** Application feedback */
export type AtsFeedbackApplicationPhaseArgs = {
  atsJobPostingId?: InputMaybe<Scalars['Int']>;
  atsJobPostingIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Application feedback */
export type AtsFeedbackAtsFilesArgs = {
  atsApplicationId?: InputMaybe<Scalars['Int']>;
  atsApplicationIds?: InputMaybe<Array<Scalars['Int']>>;
  atsCandidateId?: InputMaybe<Scalars['Int']>;
  atsCandidateIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceId?: InputMaybe<Scalars['Int']>;
};


/** Application feedback */
export type AtsFeedbackAtsfilesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  atsApplicationId?: InputMaybe<Scalars['Int']>;
  atsApplicationIds?: InputMaybe<Array<Scalars['Int']>>;
  atsCandidateId?: InputMaybe<Scalars['Int']>;
  atsCandidateIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  resourceId?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Application feedback */
export type AtsFeedbackAttachmentsArgs = {
  attachmentName?: InputMaybe<Scalars['String']>;
};


/** Application feedback */
export type AtsFeedbackAttachmentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  attachmentName?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Application feedback */
export type AtsFeedbackCandidateArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  atsTagIds?: InputMaybe<Array<Scalars['Int']>>;
  consent?: InputMaybe<Array<Scalars['String']>>;
  contractType?: InputMaybe<Scalars['String']>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['Int']>;
  jobPostingIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  minimumAverageRating?: InputMaybe<Scalars['Float']>;
  rejectionReasonIds?: InputMaybe<Array<Scalars['Int']>>;
  remote?: InputMaybe<Scalars['Boolean']>;
  scheduleType?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Array<Scalars['String']>>;
  sourceIds?: InputMaybe<Array<Scalars['Int']>>;
  talentPool?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
};

/** The connection type for AtsFeedback. */
export type AtsFeedbackConnection = {
  __typename?: 'AtsFeedbackConnection';
  /** A list of edges. */
  edges: Array<AtsFeedbackEdge>;
  /** A list of nodes. */
  nodes: Array<AtsFeedback>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AtsFeedbackEdge = {
  __typename?: 'AtsFeedbackEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AtsFeedback;
};

/** the filter for the feedbacks resource */
export type AtsFeedbackFilter = {
  createdAt?: InputMaybe<DateTimeFilter>;
  or?: InputMaybe<Array<AtsFeedbackFilterConditions>>;
};

export type AtsFeedbackFilterConditions = {
  createdAt?: InputMaybe<DateTimeFilter>;
};

export type AtsFeedbackVisibilityEnum =
  | 'public'
  | 'restricted';

/** Files related to ATS resources */
export type AtsFile = {
  __typename?: 'AtsFile';
  application?: Maybe<AtsApplication>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  atsApplicationId?: Maybe<Scalars['Int']>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  atsCandidateId?: Maybe<Scalars['Int']>;
  atsJobPostingId?: Maybe<Scalars['Int']>;
  authorFullName?: Maybe<Scalars['String']>;
  authorId: Scalars['Int'];
  authorType: AtsFileOptionsTypesAuthorEnum;
  candidate?: Maybe<AtsCandidate>;
  category?: Maybe<AtsFileOptionsCategoriesEnum>;
  company: ApiCoreCompany;
  createdAt: Scalars['ISO8601DateTime'];
  file: AtsFileAttachment;
  id: Scalars['Int'];
  preview?: Maybe<AtsFileAttachment>;
  processingError?: Maybe<AtsFileOptionsErrorsEnum>;
  resourceId: Scalars['Int'];
  resourceType: AtsFileOptionsTypesResourceEnum;
  textContent?: Maybe<Scalars['String']>;
};


/** Files related to ATS resources */
export type AtsFileApplicationArgs = {
  afterApplicationId?: InputMaybe<Scalars['Int']>;
  atsAnswers?: InputMaybe<Array<ApplicationsAtsAnswersInput>>;
  atsApplicationPhaseId?: InputMaybe<Scalars['Int']>;
  atsCandidateId?: InputMaybe<Scalars['Int']>;
  atsCandidateIds?: InputMaybe<Array<Scalars['Int']>>;
  atsJobPostingId?: InputMaybe<Scalars['Int']>;
  atsRejectionReasonIds?: InputMaybe<Array<Scalars['Int']>>;
  atsTagsIds?: InputMaybe<Array<Scalars['Int']>>;
  beforeApplicationId?: InputMaybe<Scalars['Int']>;
  includeRatingAverages?: InputMaybe<Scalars['Boolean']>;
  qualified?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};


/** Files related to ATS resources */
export type AtsFileCandidateArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  atsTagIds?: InputMaybe<Array<Scalars['Int']>>;
  consent?: InputMaybe<Array<Scalars['String']>>;
  contractType?: InputMaybe<Scalars['String']>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['Int']>;
  jobPostingIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  minimumAverageRating?: InputMaybe<Scalars['Float']>;
  rejectionReasonIds?: InputMaybe<Array<Scalars['Int']>>;
  remote?: InputMaybe<Scalars['Boolean']>;
  scheduleType?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Array<Scalars['String']>>;
  sourceIds?: InputMaybe<Array<Scalars['Int']>>;
  talentPool?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type AtsFileAttachment = {
  __typename?: 'AtsFileAttachment';
  byteSize: Scalars['Int'];
  contentType: Scalars['String'];
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  filename: Scalars['String'];
  url: Scalars['String'];
};

/** The connection type for AtsFile. */
export type AtsFileConnection = {
  __typename?: 'AtsFileConnection';
  /** A list of edges. */
  edges: Array<AtsFileEdge>;
  /** A list of nodes. */
  nodes: Array<AtsFile>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AtsFileEdge = {
  __typename?: 'AtsFileEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AtsFile;
};

export type AtsFileOptionsCategoriesEnum =
  | 'cover_letter'
  | 'cv'
  | 'none'
  | 'photo';

export type AtsFileOptionsErrorsEnum =
  | 'candidate_creation_failed'
  | 'candidate_data_not_found'
  | 'cv_bulk_upload_cancelled'
  | 'file_conversion_failed'
  | 'file_could_not_be_processed'
  | 'text_extraction_failed'
  | 'unsupported_format';

export type AtsFileOptionsTypesAuthorEnum =
  | 'access'
  | 'candidate'
  | 'company'
  | 'user';

export type AtsFileOptionsTypesResourceEnum =
  | 'application'
  | 'candidate'
  | 'candidate_email_action'
  | 'cv_bulk_upload'
  | 'feedback'
  | 'offer_letter_template';

/** Ats hiring manager */
export type AtsHiringManager = {
  __typename?: 'AtsHiringManager';
  access?: Maybe<ApiCoreAccess>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  accessId: Scalars['Int'];
  atsJobPostingId: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  hiringRole: AtsHiringRolesEnum;
  hiringRoleLabel: Scalars['String'];
  id: Scalars['Int'];
};


/** Ats hiring manager */
export type AtsHiringManagerAccessArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for AtsHiringManager. */
export type AtsHiringManagerConnection = {
  __typename?: 'AtsHiringManagerConnection';
  /** A list of edges. */
  edges: Array<AtsHiringManagerEdge>;
  /** A list of nodes. */
  nodes: Array<AtsHiringManager>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AtsHiringManagerEdge = {
  __typename?: 'AtsHiringManagerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AtsHiringManager;
};

/** hiring_phases */
export type AtsHiringPhase = {
  __typename?: 'AtsHiringPhase';
  atsHiringStage: AtsHiringStage;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  atsHiringStageId: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['String'];
  position: Scalars['Int'];
};


/** hiring_phases */
export type AtsHiringPhaseAtsHiringStageArgs = {
  atsApplicationPhaseId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** The connection type for AtsHiringPhase. */
export type AtsHiringPhaseConnection = {
  __typename?: 'AtsHiringPhaseConnection';
  /** A list of edges. */
  edges: Array<AtsHiringPhaseEdge>;
  /** A list of nodes. */
  nodes: Array<AtsHiringPhase>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AtsHiringPhaseEdge = {
  __typename?: 'AtsHiringPhaseEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AtsHiringPhase;
};

export type AtsHiringRolesEnum =
  | 'editor'
  | 'owner'
  | 'reviewer';

/** Logical grouping for phases used for all job openings */
export type AtsHiringStage = {
  __typename?: 'AtsHiringStage';
  company: ApiCoreCompany;
  /**
   * Company identifier of the hiring stage
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  companyId: Scalars['Int'];
  hiringPhases: Array<AtsHiringPhase>;
  hiringPhasesConnection: AtsHiringPhaseConnection;
  /** Identifier of the hiring stage */
  id: Scalars['Int'];
  /** Label of the hiring stage */
  label: Scalars['String'];
  /** Name of the hiring stage */
  name: AtsHiringStageNamesEnum;
  /** Position of the hiring stage */
  position: Scalars['Int'];
};


/** Logical grouping for phases used for all job openings */
export type AtsHiringStageHiringPhasesArgs = {
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Logical grouping for phases used for all job openings */
export type AtsHiringStageHiringPhasesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for AtsHiringStage. */
export type AtsHiringStageConnection = {
  __typename?: 'AtsHiringStageConnection';
  /** A list of edges. */
  edges: Array<AtsHiringStageEdge>;
  /** A list of nodes. */
  nodes: Array<AtsHiringStage>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AtsHiringStageEdge = {
  __typename?: 'AtsHiringStageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AtsHiringStage;
};

/** the filter for the hiring_stages resource */
export type AtsHiringStageFilter = {
  id?: InputMaybe<IntegerFilter>;
  name?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<AtsHiringStageFilterConditions>>;
  position?: InputMaybe<IntegerFilter>;
};

export type AtsHiringStageFilterConditions = {
  id?: InputMaybe<IntegerFilter>;
  name?: InputMaybe<StringFilter>;
  position?: InputMaybe<IntegerFilter>;
};

export type AtsHiringStageNamesEnum =
  | 'assessment'
  | 'hired'
  | 'interview'
  | 'new'
  | 'offer'
  | 'screening';

/** Ats hiring stage options */
export type AtsHiringStageOption = {
  __typename?: 'AtsHiringStageOption';
  editable: Scalars['Boolean'];
  label: Scalars['String'];
  name: AtsHiringStageNamesEnum;
};

/** The connection type for AtsHiringStageOption. */
export type AtsHiringStageOptionConnection = {
  __typename?: 'AtsHiringStageOptionConnection';
  /** A list of edges. */
  edges: Array<AtsHiringStageOptionEdge>;
  /** A list of nodes. */
  nodes: Array<AtsHiringStageOption>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AtsHiringStageOptionEdge = {
  __typename?: 'AtsHiringStageOptionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AtsHiringStageOption;
};

/** Insights for the hiring stages of a company */
export type AtsHiringStagesInsight = {
  __typename?: 'AtsHiringStagesInsight';
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  atsHiringStageId: Scalars['Int'];
  averageMinutes: Scalars['Int'];
  candidatesAmount: Scalars['Int'];
  candidatesAmountNow: Scalars['Int'];
  hiringStage?: Maybe<AtsHiringStage>;
  medianMinutes: Scalars['Int'];
};


/** Insights for the hiring stages of a company */
export type AtsHiringStagesInsightHiringStageArgs = {
  atsApplicationPhaseId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** The connection type for AtsHiringStagesInsight. */
export type AtsHiringStagesInsightConnection = {
  __typename?: 'AtsHiringStagesInsightConnection';
  /** A list of edges. */
  edges: Array<AtsHiringStagesInsightEdge>;
  /** A list of nodes. */
  nodes: Array<AtsHiringStagesInsight>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AtsHiringStagesInsightEdge = {
  __typename?: 'AtsHiringStagesInsightEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AtsHiringStagesInsight;
};

/** A certain ats integration */
export type AtsIntegration = {
  __typename?: 'AtsIntegration';
  companyId: Scalars['Int'];
  id: Scalars['Int'];
  integrationName: Scalars['String'];
  integrationValue: Scalars['String'];
};

/** The connection type for AtsIntegration. */
export type AtsIntegrationConnection = {
  __typename?: 'AtsIntegrationConnection';
  /** A list of edges. */
  edges: Array<AtsIntegrationEdge>;
  /** A list of nodes. */
  nodes: Array<AtsIntegration>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AtsIntegrationEdge = {
  __typename?: 'AtsIntegrationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AtsIntegration;
};

/** Ats Interviews Scheduling relationships */
export type AtsInterview = {
  __typename?: 'AtsInterview';
  access: ApiCoreAccess;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  accessId: Scalars['Int'];
  application: AtsApplication;
  applicationPhase: AtsApplicationPhase;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  atsApplicationId: Scalars['Int'];
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  atsApplicationPhaseId: Scalars['Int'];
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  atsCandidateId: Scalars['Int'];
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  atsMessageId?: Maybe<Scalars['Int']>;
  candidate: AtsCandidate;
  companyId: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  customLocation?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  endsAt: Scalars['ISO8601DateTime'];
  id: Scalars['Int'];
  interviewAttendees: Array<AtsInterviewAttendee>;
  interviewType: AtsInterviewOptionsTypesEnum;
  interviewattendeesConnection: AtsInterviewAttendeeConnection;
  message?: Maybe<AtsMessage>;
  startsAt: Scalars['ISO8601DateTime'];
  status: AtsInterviewOptionsStatusesEnum;
  timezone: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
  url?: Maybe<Scalars['String']>;
  workSpaceId?: Maybe<Scalars['Int']>;
};


/** Ats Interviews Scheduling relationships */
export type AtsInterviewAccessArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** Ats Interviews Scheduling relationships */
export type AtsInterviewApplicationArgs = {
  afterApplicationId?: InputMaybe<Scalars['Int']>;
  atsAnswers?: InputMaybe<Array<ApplicationsAtsAnswersInput>>;
  atsApplicationPhaseId?: InputMaybe<Scalars['Int']>;
  atsCandidateId?: InputMaybe<Scalars['Int']>;
  atsCandidateIds?: InputMaybe<Array<Scalars['Int']>>;
  atsJobPostingId?: InputMaybe<Scalars['Int']>;
  atsRejectionReasonIds?: InputMaybe<Array<Scalars['Int']>>;
  atsTagsIds?: InputMaybe<Array<Scalars['Int']>>;
  beforeApplicationId?: InputMaybe<Scalars['Int']>;
  includeRatingAverages?: InputMaybe<Scalars['Boolean']>;
  qualified?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};


/** Ats Interviews Scheduling relationships */
export type AtsInterviewApplicationPhaseArgs = {
  atsJobPostingId?: InputMaybe<Scalars['Int']>;
  atsJobPostingIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Ats Interviews Scheduling relationships */
export type AtsInterviewCandidateArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  atsTagIds?: InputMaybe<Array<Scalars['Int']>>;
  consent?: InputMaybe<Array<Scalars['String']>>;
  contractType?: InputMaybe<Scalars['String']>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['Int']>;
  jobPostingIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  minimumAverageRating?: InputMaybe<Scalars['Float']>;
  rejectionReasonIds?: InputMaybe<Array<Scalars['Int']>>;
  remote?: InputMaybe<Scalars['Boolean']>;
  scheduleType?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Array<Scalars['String']>>;
  sourceIds?: InputMaybe<Array<Scalars['Int']>>;
  talentPool?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Ats Interviews Scheduling relationships */
export type AtsInterviewInterviewAttendeesArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Ats Interviews Scheduling relationships */
export type AtsInterviewInterviewattendeesConnectionArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Ats Interviews Scheduling relationships */
export type AtsInterviewMessageArgs = {
  atsConversationId?: InputMaybe<Scalars['Int']>;
  atsConversationIds?: InputMaybe<Array<Scalars['Int']>>;
  id?: InputMaybe<Scalars['Int']>;
  lastPerConversation?: Scalars['Boolean'];
};

/** Ats Interview Attendees relationships */
export type AtsInterviewAttendee = {
  __typename?: 'AtsInterviewAttendee';
  access?: Maybe<ApiCoreAccess>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  accessId?: Maybe<Scalars['Int']>;
  atsInterviewId: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  email?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  status: AtsInterviewAttendeeStatusesEnum;
  updatedAt: Scalars['ISO8601DateTime'];
};


/** Ats Interview Attendees relationships */
export type AtsInterviewAttendeeAccessArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for AtsInterviewAttendee. */
export type AtsInterviewAttendeeConnection = {
  __typename?: 'AtsInterviewAttendeeConnection';
  /** A list of edges. */
  edges: Array<AtsInterviewAttendeeEdge>;
  /** A list of nodes. */
  nodes: Array<AtsInterviewAttendee>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AtsInterviewAttendeeEdge = {
  __typename?: 'AtsInterviewAttendeeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AtsInterviewAttendee;
};

export type AtsInterviewAttendeeStatusesEnum =
  | 'accepted'
  | 'declined'
  | 'needs_action'
  | 'tentative'
  | 'unknown';

/** The connection type for AtsInterview. */
export type AtsInterviewConnection = {
  __typename?: 'AtsInterviewConnection';
  /** A list of edges. */
  edges: Array<AtsInterviewEdge>;
  /** A list of nodes. */
  nodes: Array<AtsInterview>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AtsInterviewEdge = {
  __typename?: 'AtsInterviewEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AtsInterview;
};

export type AtsInterviewOptionsStatusesEnum =
  | 'cancelled'
  | 'completed'
  | 'processing'
  | 'rejected'
  | 'scheduled';

export type AtsInterviewOptionsTypesEnum =
  | 'in_person'
  | 'online'
  | 'telephone';

/** Job Postings */
export type AtsJobPosting = {
  __typename?: 'AtsJobPosting';
  _policies?: Maybe<AtsJobPostingPolicies>;
  _policiesCollection?: Maybe<Array<PermissionsPolicyResolution>>;
  _policiesConnection: PermissionsPolicyResolutionConnection;
  activeApplicationsCount: Scalars['Int'];
  allowInternalApply?: Maybe<Scalars['Boolean']>;
  allowReferral?: Maybe<Scalars['Boolean']>;
  applicationPhases: Array<AtsApplicationPhase>;
  applicationphasesConnection: AtsApplicationPhaseConnection;
  applicationsCount: Scalars['Int'];
  /** Identifier of the ATS company associated with the job posting */
  atsCompanyId: Scalars['Int'];
  /** Identifier of the company associated with the job posting */
  companyId: Scalars['Int'];
  contractType?: Maybe<AtsContractTypesEnum>;
  contractTypeLabel?: Maybe<Scalars['String']>;
  /** Requirement for the cover letter (e.g, mandatory, optional, do_not_ask) */
  coverLetterRequirement: AtsJobRequirementsOptionsEnum;
  /** Date in ISO 8601 format when the job posting was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** Requirement for the CV (e.g, mandatory, optional, do_not_ask) */
  cvRequirement: AtsJobRequirementsOptionsEnum;
  /** Description of the job posting */
  description?: Maybe<Scalars['String']>;
  genderRequirement?: Maybe<AtsJobRequirementsOptionsEnum>;
  /** Indicates whether the salary information for the job posting should be hidden from applicants. */
  hideSalary?: Maybe<Scalars['Boolean']>;
  hiringManagers: Array<AtsHiringManager>;
  hiringmanagersConnection: AtsHiringManagerConnection;
  /** Unique identifier for the job posting */
  id: Scalars['Int'];
  jobCatalogNodeLevelsUuid?: Maybe<Scalars['String']>;
  jobCatalogNodeRolesUuid?: Maybe<Scalars['String']>;
  legalEntity?: Maybe<CompaniesLegalEntity>;
  /**
   * Identifier of the legal entity associated with the job posting
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  legalEntityId?: Maybe<Scalars['Int']>;
  location?: Maybe<LocationsLocation>;
  /**
   * Identifier of the location associated with the job posting
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  locationId?: Maybe<Scalars['Int']>;
  newEditor?: Maybe<Scalars['Boolean']>;
  /** The number of vacancies for the job posting */
  numberOfVacancies?: Maybe<Scalars['Int']>;
  /** Requirement for the personal URL (e.g, mandatory, optional, do_not_ask) */
  personalUrlRequirement: AtsJobRequirementsOptionsEnum;
  /** Requirement for the phone number (e.g, mandatory, optional, do_not_ask) */
  phoneRequirement: AtsJobRequirementsOptionsEnum;
  /** Requirement for the phone number (e.g, mandatory, optional, do_not_ask) */
  photoRequirement: AtsJobRequirementsOptionsEnum;
  previewToken?: Maybe<Scalars['String']>;
  /** Published date in ISO 8601 format of the job. If never been published the value will be null */
  publishedAt?: Maybe<Scalars['ISO8601DateTime']>;
  questions: Array<AtsQuestion>;
  questionsConnection: AtsQuestionConnection;
  /** Indicates if the job posting is remote */
  remote: Scalars['Boolean'];
  requisition?: Maybe<AtsRequisition>;
  /** The format of the salary (e.g., range, fixed_amount) */
  salaryFormat?: Maybe<AtsJobPostingSalaryFormatEnum>;
  /** The minimum salary amount in cents */
  salaryFromAmountInCents?: Maybe<Scalars['Int']>;
  /** The period of the salary (e.g., annual, monthly, daily) */
  salaryPeriod: AtsJobPostingSalaryPeriodEnum;
  salaryPermission?: Maybe<Scalars['Boolean']>;
  /** The maximum salary amount in cents */
  salaryToAmountInCents?: Maybe<Scalars['Int']>;
  /** The schedule type of the job posting (e.g., full_time, part_time) */
  scheduleType?: Maybe<OnboardingEntitiesWorkScheduleTimeEnum>;
  /** The start date of the job posting */
  startDate?: Maybe<Scalars['ISO8601Date']>;
  /** The current status of the job posting (e.g., draft, published, archived) */
  status: AtsJobPostingStatusesEnum;
  team?: Maybe<TeamsTeam>;
  /**
   * Identifier of the team associated with the job posting
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  teamId?: Maybe<Scalars['Int']>;
  /** Title of the job posting */
  title: Scalars['String'];
  /** If published, the public URL of the job posting. Otherwise will be null */
  url?: Maybe<Scalars['String']>;
  workplaceType?: Maybe<AtsWorkplaceTypesEnum>;
  workplaceTypeLabel?: Maybe<Scalars['String']>;
};


/** Job Postings */
export type AtsJobPosting_PoliciesCollectionArgs = {
  ids: Array<AtsJobPostingPoliciesEnum>;
};


/** Job Postings */
export type AtsJobPosting_PoliciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Job Postings */
export type AtsJobPostingApplicationPhasesArgs = {
  atsJobPostingId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Job Postings */
export type AtsJobPostingApplicationphasesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  atsJobPostingId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Job Postings */
export type AtsJobPostingHiringManagersArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  atsJobPostingId?: InputMaybe<Scalars['Int']>;
  uniqueByAccess?: InputMaybe<Scalars['Boolean']>;
};


/** Job Postings */
export type AtsJobPostingHiringmanagersConnectionArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  atsJobPostingId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  uniqueByAccess?: InputMaybe<Scalars['Boolean']>;
};


/** Job Postings */
export type AtsJobPostingLegalEntityArgs = {
  companiesIds?: InputMaybe<Array<Scalars['Int']>>;
  countryIds?: InputMaybe<Array<Scalars['String']>>;
  employeesIds?: InputMaybe<Array<Scalars['Int']>>;
  excludeCountries?: InputMaybe<Array<Scalars['String']>>;
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


/** Job Postings */
export type AtsJobPostingLocationArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  main?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};


/** Job Postings */
export type AtsJobPostingQuestionsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Job Postings */
export type AtsJobPostingQuestionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Job Postings */
export type AtsJobPostingRequisitionArgs = {
  hiringManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  recruiterIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Array<Scalars['String']>>;
  workplaceIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Job Postings */
export type AtsJobPostingTeamArgs = {
  mainTeam?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  withMembers?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for AtsJobPosting. */
export type AtsJobPostingConnection = {
  __typename?: 'AtsJobPostingConnection';
  /** A list of edges. */
  edges: Array<AtsJobPostingEdge>;
  /** A list of nodes. */
  nodes: Array<AtsJobPosting>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AtsJobPostingEdge = {
  __typename?: 'AtsJobPostingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AtsJobPosting;
};

/** the filter for the job_postings resource */
export type AtsJobPostingFilter = {
  contractType?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  or?: InputMaybe<Array<AtsJobPostingFilterConditions>>;
  publishedAt?: InputMaybe<DateTimeFilter>;
  scheduleType?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  workplaceType?: InputMaybe<StringFilter>;
};

export type AtsJobPostingFilterConditions = {
  contractType?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  publishedAt?: InputMaybe<DateTimeFilter>;
  scheduleType?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  workplaceType?: InputMaybe<StringFilter>;
};

export type AtsJobPostingPolicies = {
  __typename?: 'AtsJobPostingPolicies';
  manage: PermissionsPolicyResolution;
};

export type AtsJobPostingPoliciesEnum =
  | 'manage';

export type AtsJobPostingSalaryFormatEnum =
  | 'fixed_amount'
  | 'range';

export type AtsJobPostingSalaryPeriodEnum =
  | 'annual'
  | 'daily'
  | 'monthly';

export type AtsJobPostingScheduleTypesEnum =
  | 'full_time'
  | 'part_time';

export type AtsJobPostingStatusesEnum =
  | 'archived'
  | 'cancelled'
  | 'deleted'
  | 'draft'
  | 'published'
  | 'unlisted';

/** Insights for the job postings of a company */
export type AtsJobPostingsInsight = {
  __typename?: 'AtsJobPostingsInsight';
  averageMinutes?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['ISO8601DateTime']>;
  id: AtsEntitiesInsightsJobPostingsInsightIdEnum;
  medianMinutes?: Maybe<Scalars['Int']>;
};

/** The connection type for AtsJobPostingsInsight. */
export type AtsJobPostingsInsightConnection = {
  __typename?: 'AtsJobPostingsInsightConnection';
  /** A list of edges. */
  edges: Array<AtsJobPostingsInsightEdge>;
  /** A list of nodes. */
  nodes: Array<AtsJobPostingsInsight>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AtsJobPostingsInsightEdge = {
  __typename?: 'AtsJobPostingsInsightEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AtsJobPostingsInsight;
};

export type AtsJobRequirementsOptionsEnum =
  | 'do_not_ask'
  | 'mandatory'
  | 'optional';

/** Last update date for different insights data sources */
export type AtsLastUpdatedAtInsight = {
  __typename?: 'AtsLastUpdatedAtInsight';
  date?: Maybe<Scalars['ISO8601DateTime']>;
  id: AtsEntitiesInsightsDataSourceIdEnum;
};

/** The connection type for AtsLastUpdatedAtInsight. */
export type AtsLastUpdatedAtInsightConnection = {
  __typename?: 'AtsLastUpdatedAtInsightConnection';
  /** A list of edges. */
  edges: Array<AtsLastUpdatedAtInsightEdge>;
  /** A list of nodes. */
  nodes: Array<AtsLastUpdatedAtInsight>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AtsLastUpdatedAtInsightEdge = {
  __typename?: 'AtsLastUpdatedAtInsightEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AtsLastUpdatedAtInsight;
};

export type AtsMatcherScore = {
  __typename?: 'AtsMatcherScore';
  matchedResourceId: Scalars['Int'];
  matchedResourceType: Scalars['String'];
  matcherName: Scalars['String'];
  sourceResourceId: Scalars['Int'];
  sourceResourceType: Scalars['String'];
};

/** Ats message */
export type AtsMessage = {
  __typename?: 'AtsMessage';
  access?: Maybe<ApiCoreAccess>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  atsConversationId: Scalars['Int'];
  attachments: Array<AtsFileAttachment>;
  content: Scalars['String'];
  conversation: AtsConversation;
  createdAt: Scalars['ISO8601DateTime'];
  delayedUntil?: Maybe<Scalars['ISO8601DateTime']>;
  deliveredAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['Int'];
  lastErrorAt?: Maybe<Scalars['ISO8601DateTime']>;
  openedAt?: Maybe<Scalars['ISO8601DateTime']>;
  sentAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  sentById: Scalars['Int'];
  sentByType: Scalars['String'];
  topic: Scalars['String'];
};


/** Ats message */
export type AtsMessageAccessArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** Ats message */
export type AtsMessageConversationArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  atsApplicationIds?: InputMaybe<Array<Scalars['Int']>>;
  id?: InputMaybe<Scalars['Int']>;
  includeLastMessage?: Scalars['Boolean'];
  watcher?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for AtsMessage. */
export type AtsMessageConnection = {
  __typename?: 'AtsMessageConnection';
  /** A list of edges. */
  edges: Array<AtsMessageEdge>;
  /** A list of nodes. */
  nodes: Array<AtsMessage>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AtsMessageEdge = {
  __typename?: 'AtsMessageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AtsMessage;
};

export type AtsMessageSendersEnum =
  | 'candidate'
  | 'user';

/** Ats message template */
export type AtsMessageTemplate = {
  __typename?: 'AtsMessageTemplate';
  access?: Maybe<ApiCoreAccess>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  accessId: Scalars['Int'];
  authorAvatar?: Maybe<Scalars['String']>;
  authorFullName?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  company: ApiCoreCompany;
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['Int'];
  name: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
  visibility: AtsMessageTemplateVisibilityEnum;
};


/** Ats message template */
export type AtsMessageTemplateAccessArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for AtsMessageTemplate. */
export type AtsMessageTemplateConnection = {
  __typename?: 'AtsMessageTemplateConnection';
  /** A list of edges. */
  edges: Array<AtsMessageTemplateEdge>;
  /** A list of nodes. */
  nodes: Array<AtsMessageTemplate>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AtsMessageTemplateEdge = {
  __typename?: 'AtsMessageTemplateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AtsMessageTemplate;
};

/** the filter for the message_templates resource */
export type AtsMessageTemplateFilter = {
  id?: InputMaybe<IntegerFilter>;
  name?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<AtsMessageTemplateFilterConditions>>;
  visibility?: InputMaybe<StringFilter>;
};

export type AtsMessageTemplateFilterConditions = {
  id?: InputMaybe<IntegerFilter>;
  name?: InputMaybe<StringFilter>;
  visibility?: InputMaybe<StringFilter>;
};

export type AtsMessageTemplateVisibilityEnum =
  | 'company'
  | 'personal';

/** An offer letter for an application in the ATS */
export type AtsOfferLetter = {
  __typename?: 'AtsOfferLetter';
  access?: Maybe<ApiCoreAccess>;
  application: AtsApplication;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  atsApplicationId: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  customMessage: Scalars['String'];
  declinedReason?: Maybe<Scalars['String']>;
  document: AtsFileAttachment;
  id: Scalars['Int'];
  notificationRead: Scalars['Boolean'];
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  sentById?: Maybe<Scalars['Int']>;
  signatureUrl?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};


/** An offer letter for an application in the ATS */
export type AtsOfferLetterAccessArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** An offer letter for an application in the ATS */
export type AtsOfferLetterApplicationArgs = {
  afterApplicationId?: InputMaybe<Scalars['Int']>;
  atsAnswers?: InputMaybe<Array<ApplicationsAtsAnswersInput>>;
  atsApplicationPhaseId?: InputMaybe<Scalars['Int']>;
  atsCandidateId?: InputMaybe<Scalars['Int']>;
  atsCandidateIds?: InputMaybe<Array<Scalars['Int']>>;
  atsJobPostingId?: InputMaybe<Scalars['Int']>;
  atsRejectionReasonIds?: InputMaybe<Array<Scalars['Int']>>;
  atsTagsIds?: InputMaybe<Array<Scalars['Int']>>;
  beforeApplicationId?: InputMaybe<Scalars['Int']>;
  includeRatingAverages?: InputMaybe<Scalars['Boolean']>;
  qualified?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};

/** The connection type for AtsOfferLetter. */
export type AtsOfferLetterConnection = {
  __typename?: 'AtsOfferLetterConnection';
  /** A list of edges. */
  edges: Array<AtsOfferLetterEdge>;
  /** A list of nodes. */
  nodes: Array<AtsOfferLetter>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AtsOfferLetterEdge = {
  __typename?: 'AtsOfferLetterEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AtsOfferLetter;
};

/** Offer letter templates for ATS */
export type AtsOfferLetterTemplate = {
  __typename?: 'AtsOfferLetterTemplate';
  /** Whether this template is currently active */
  active: Scalars['Boolean'];
  company: ApiCoreCompany;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  companyId: Scalars['Int'];
  /** Array of contract types this template applies to (from Ats::ContractTypes enum) */
  contractTypes?: Maybe<Array<AtsContractTypesEnum>>;
  /** Array of country codes this template applies to */
  countryCodes?: Maybe<Array<RegionFinderCountryEnum>>;
  /** Creation date time */
  createdAt: Scalars['ISO8601DateTime'];
  /** Description of the offer letter template */
  description?: Maybe<Scalars['String']>;
  documentsTemplate?: Maybe<DocumentsTemplate>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  documentsTemplateId?: Maybe<Scalars['Int']>;
  /** Offer letter template identifier */
  id: Scalars['Int'];
  /** Array of ISO 639-1 language codes this template supports */
  languageCodes?: Maybe<Array<Scalars['String']>>;
  legalEntity?: Maybe<CompaniesLegalEntity>;
  /**
   * Legal entity identifier this template belongs to
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  legalEntityId?: Maybe<Scalars['Int']>;
  /** Name of the offer letter template */
  name: Scalars['String'];
  /** Array of schedule types this template applies to (from Ats::ScheduleTypes enum) */
  scheduleTypes?: Maybe<Array<AtsJobPostingScheduleTypesEnum>>;
  /** Array of tags for categorizing this template */
  tags?: Maybe<Array<Scalars['String']>>;
  team?: Maybe<TeamsTeam>;
  /**
   * Team identifier this template belongs to
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  teamId?: Maybe<Scalars['Int']>;
  /** Last update date time */
  updatedAt: Scalars['ISO8601DateTime'];
  /** Array of workplace types this template applies to (from Ats::WorkplaceTypes enum) */
  workplaceTypes?: Maybe<Array<AtsWorkplaceTypesEnum>>;
};


/** Offer letter templates for ATS */
export type AtsOfferLetterTemplateDocumentsTemplateArgs = {
  documentType?: InputMaybe<Scalars['String']>;
};


/** Offer letter templates for ATS */
export type AtsOfferLetterTemplateLegalEntityArgs = {
  companiesIds?: InputMaybe<Array<Scalars['Int']>>;
  countryIds?: InputMaybe<Array<Scalars['String']>>;
  employeesIds?: InputMaybe<Array<Scalars['Int']>>;
  excludeCountries?: InputMaybe<Array<Scalars['String']>>;
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


/** Offer letter templates for ATS */
export type AtsOfferLetterTemplateTeamArgs = {
  mainTeam?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  withMembers?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for AtsOfferLetterTemplate. */
export type AtsOfferLetterTemplateConnection = {
  __typename?: 'AtsOfferLetterTemplateConnection';
  /** A list of edges. */
  edges: Array<AtsOfferLetterTemplateEdge>;
  /** A list of nodes. */
  nodes: Array<AtsOfferLetterTemplate>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AtsOfferLetterTemplateEdge = {
  __typename?: 'AtsOfferLetterTemplateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AtsOfferLetterTemplate;
};

/** the filter for the offer_letter_templates resource */
export type AtsOfferLetterTemplateFilter = {
  legalEntityId?: InputMaybe<IntegerFilter>;
  name?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<AtsOfferLetterTemplateFilterConditions>>;
  teamId?: InputMaybe<IntegerFilter>;
};

export type AtsOfferLetterTemplateFilterConditions = {
  legalEntityId?: InputMaybe<IntegerFilter>;
  name?: InputMaybe<StringFilter>;
  teamId?: InputMaybe<IntegerFilter>;
};

/** open_application_setting */
export type AtsOpenApplicationSetting = {
  __typename?: 'AtsOpenApplicationSetting';
  companyId: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  cvRequirement: AtsJobRequirementsOptionsEnum;
  enabled: Scalars['Boolean'];
  genderRequirement: AtsJobRequirementsOptionsEnum;
  id: Scalars['Int'];
  personalUrlRequirement: AtsJobRequirementsOptionsEnum;
  phoneRequirement: AtsJobRequirementsOptionsEnum;
  photoRequirement: AtsJobRequirementsOptionsEnum;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for AtsOpenApplicationSetting. */
export type AtsOpenApplicationSettingConnection = {
  __typename?: 'AtsOpenApplicationSettingConnection';
  /** A list of edges. */
  edges: Array<AtsOpenApplicationSettingEdge>;
  /** A list of nodes. */
  nodes: Array<AtsOpenApplicationSetting>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AtsOpenApplicationSettingEdge = {
  __typename?: 'AtsOpenApplicationSettingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AtsOpenApplicationSetting;
};

/** Open positions */
export type AtsOpenPosition = {
  __typename?: 'AtsOpenPosition';
  allowInternalApply: Scalars['Boolean'];
  allowReferral: Scalars['Boolean'];
  createdAt: Scalars['ISO8601DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  location?: Maybe<LocationsLocation>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  locationId?: Maybe<Scalars['Int']>;
  publishedAt: Scalars['ISO8601DateTime'];
  team?: Maybe<TeamsTeam>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  teamId?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
  workplaceType?: Maybe<Scalars['String']>;
};


/** Open positions */
export type AtsOpenPositionLocationArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  main?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};


/** Open positions */
export type AtsOpenPositionTeamArgs = {
  mainTeam?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  withMembers?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for AtsOpenPosition. */
export type AtsOpenPositionConnection = {
  __typename?: 'AtsOpenPositionConnection';
  /** A list of edges. */
  edges: Array<AtsOpenPositionEdge>;
  /** A list of nodes. */
  nodes: Array<AtsOpenPosition>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AtsOpenPositionEdge = {
  __typename?: 'AtsOpenPositionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AtsOpenPosition;
};

/** Manage Open Positions by Location in Factorial */
export type AtsOpenPositionsLocation = {
  __typename?: 'AtsOpenPositionsLocation';
  id: Scalars['String'];
  openPositionsCount: Scalars['Int'];
};

/** The connection type for AtsOpenPositionsLocation. */
export type AtsOpenPositionsLocationConnection = {
  __typename?: 'AtsOpenPositionsLocationConnection';
  /** A list of edges. */
  edges: Array<AtsOpenPositionsLocationEdge>;
  /** A list of nodes. */
  nodes: Array<AtsOpenPositionsLocation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AtsOpenPositionsLocationEdge = {
  __typename?: 'AtsOpenPositionsLocationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AtsOpenPositionsLocation;
};

/** Purchase request job postings */
export type AtsPurchaseRequestJobPosting = {
  __typename?: 'AtsPurchaseRequestJobPosting';
  id: Scalars['Int'];
  title: Scalars['String'];
};

/** The connection type for AtsPurchaseRequestJobPosting. */
export type AtsPurchaseRequestJobPostingConnection = {
  __typename?: 'AtsPurchaseRequestJobPostingConnection';
  /** A list of edges. */
  edges: Array<AtsPurchaseRequestJobPostingEdge>;
  /** A list of nodes. */
  nodes: Array<AtsPurchaseRequestJobPosting>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AtsPurchaseRequestJobPostingEdge = {
  __typename?: 'AtsPurchaseRequestJobPostingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AtsPurchaseRequestJobPosting;
};

/** Custom questions in a job opening */
export type AtsQuestion = {
  __typename?: 'AtsQuestion';
  /**
   * job posting identifier.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  atsJobPostingId: Scalars['Int'];
  /** if the question autodisqualifies the candidate depending on it's response. */
  autoDisqualify: Scalars['Boolean'];
  /** creation date */
  createdAt: Scalars['ISO8601DateTime'];
  /** question identifier */
  id: Scalars['Int'];
  jobPosting: AtsJobPosting;
  /** text of the question. */
  label: Scalars['String'];
  /** is the question mandatory or not */
  mandatory: Scalars['Boolean'];
  /** options for the question. */
  options?: Maybe<Array<AtsQuestionOption>>;
  /** position of the question in the list. */
  position: Scalars['Int'];
  /** type of the question. */
  questionType: AtsQuestionTypeEnum;
  /** last update date */
  updatedAt: Scalars['ISO8601DateTime'];
};


/** Custom questions in a job opening */
export type AtsQuestionJobPostingArgs = {
  hiringManagerAccessIds?: InputMaybe<Array<Scalars['Int']>>;
  id?: InputMaybe<Scalars['Int']>;
  includeActiveJobs?: InputMaybe<Scalars['Boolean']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  locationId?: InputMaybe<Scalars['Int']>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  status?: InputMaybe<AtsJobPostingStatusesEnum>;
  statuses?: InputMaybe<Array<AtsJobPostingStatusesEnum>>;
  teamId?: InputMaybe<Scalars['Int']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  title?: InputMaybe<Scalars['String']>;
};

/** The connection type for AtsQuestion. */
export type AtsQuestionConnection = {
  __typename?: 'AtsQuestionConnection';
  /** A list of edges. */
  edges: Array<AtsQuestionEdge>;
  /** A list of nodes. */
  nodes: Array<AtsQuestion>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AtsQuestionEdge = {
  __typename?: 'AtsQuestionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AtsQuestion;
};

/** the filter for the questions resource */
export type AtsQuestionFilter = {
  createdAt?: InputMaybe<DateTimeFilter>;
  or?: InputMaybe<Array<AtsQuestionFilterConditions>>;
  position?: InputMaybe<IntegerFilter>;
};

export type AtsQuestionFilterConditions = {
  createdAt?: InputMaybe<DateTimeFilter>;
  position?: InputMaybe<IntegerFilter>;
};

export type AtsQuestionOption = {
  __typename?: 'AtsQuestionOption';
  disqualifies?: Maybe<Scalars['Boolean']>;
  text: Scalars['String'];
};

export type AtsQuestionOptionInput = {
  disqualifies?: InputMaybe<Scalars['Boolean']>;
  text: Scalars['String'];
};

/** Custom question templates */
export type AtsQuestionTemplate = {
  __typename?: 'AtsQuestionTemplate';
  /** if the question autodisqualifies the candidate depending on it's response. */
  autoDisqualify: Scalars['Boolean'];
  company: ApiCoreCompany;
  /** question identifier */
  id: Scalars['Int'];
  /** text of the question. */
  label: Scalars['String'];
  /** is the question mandatory or not */
  mandatory: Scalars['Boolean'];
  /** options for the question. */
  options?: Maybe<Array<AtsQuestionOption>>;
  /** type of the question. */
  questionType: AtsQuestionTypeEnum;
};

/** The connection type for AtsQuestionTemplate. */
export type AtsQuestionTemplateConnection = {
  __typename?: 'AtsQuestionTemplateConnection';
  /** A list of edges. */
  edges: Array<AtsQuestionTemplateEdge>;
  /** A list of nodes. */
  nodes: Array<AtsQuestionTemplate>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AtsQuestionTemplateEdge = {
  __typename?: 'AtsQuestionTemplateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AtsQuestionTemplate;
};

/** the filter for the question_templates resource */
export type AtsQuestionTemplateFilter = {
  autoDisqualify?: InputMaybe<BooleanFilter>;
  label?: InputMaybe<StringFilter>;
  mandatory?: InputMaybe<BooleanFilter>;
  or?: InputMaybe<Array<AtsQuestionTemplateFilterConditions>>;
  questionType?: InputMaybe<StringFilter>;
};

export type AtsQuestionTemplateFilterConditions = {
  autoDisqualify?: InputMaybe<BooleanFilter>;
  label?: InputMaybe<StringFilter>;
  mandatory?: InputMaybe<BooleanFilter>;
  questionType?: InputMaybe<StringFilter>;
};

export type AtsQuestionTypeEnum =
  | 'file'
  | 'long_text'
  | 'multiple_choice'
  | 'single_choice'
  | 'text';

/** Company Referrals */
export type AtsReferral = {
  __typename?: 'AtsReferral';
  access: ApiCoreAccess;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  accessId: Scalars['Int'];
  application: AtsApplication;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  atsApplicationId: Scalars['Int'];
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  atsCandidateId: Scalars['Int'];
  candidate: AtsCandidate;
  company: ApiCoreCompany;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  companyId: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['Int'];
  updatedAt: Scalars['ISO8601DateTime'];
};


/** Company Referrals */
export type AtsReferralAccessArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** Company Referrals */
export type AtsReferralApplicationArgs = {
  afterApplicationId?: InputMaybe<Scalars['Int']>;
  atsAnswers?: InputMaybe<Array<ApplicationsAtsAnswersInput>>;
  atsApplicationPhaseId?: InputMaybe<Scalars['Int']>;
  atsCandidateId?: InputMaybe<Scalars['Int']>;
  atsCandidateIds?: InputMaybe<Array<Scalars['Int']>>;
  atsJobPostingId?: InputMaybe<Scalars['Int']>;
  atsRejectionReasonIds?: InputMaybe<Array<Scalars['Int']>>;
  atsTagsIds?: InputMaybe<Array<Scalars['Int']>>;
  beforeApplicationId?: InputMaybe<Scalars['Int']>;
  includeRatingAverages?: InputMaybe<Scalars['Boolean']>;
  qualified?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};


/** Company Referrals */
export type AtsReferralCandidateArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  atsTagIds?: InputMaybe<Array<Scalars['Int']>>;
  consent?: InputMaybe<Array<Scalars['String']>>;
  contractType?: InputMaybe<Scalars['String']>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['Int']>;
  jobPostingIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  minimumAverageRating?: InputMaybe<Scalars['Float']>;
  rejectionReasonIds?: InputMaybe<Array<Scalars['Int']>>;
  remote?: InputMaybe<Scalars['Boolean']>;
  scheduleType?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Array<Scalars['String']>>;
  sourceIds?: InputMaybe<Array<Scalars['Int']>>;
  talentPool?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
};

/** The connection type for AtsReferral. */
export type AtsReferralConnection = {
  __typename?: 'AtsReferralConnection';
  /** A list of edges. */
  edges: Array<AtsReferralEdge>;
  /** A list of nodes. */
  nodes: Array<AtsReferral>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AtsReferralEdge = {
  __typename?: 'AtsReferralEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AtsReferral;
};

/** Company Rejection Reasons */
export type AtsRejectionReason = {
  __typename?: 'AtsRejectionReason';
  application: Array<AtsApplication>;
  applicationConnection: AtsApplicationConnection;
  /** Company identifier of the rejection reason */
  companyId: Scalars['Int'];
  /** Rejection reason created date */
  createdAt: Scalars['ISO8601DateTime'];
  /** Decision maker of the rejection reason */
  decisionMaker: AtsRejectionReasonDecisionMakersEnum;
  /** Rejection reason identifier */
  id: Scalars['Int'];
  /** Reason of the rejection */
  reason: Scalars['String'];
  rrCode?: Maybe<Scalars['String']>;
  /** Rejection reason updated date */
  updatedAt: Scalars['ISO8601DateTime'];
};


/** Company Rejection Reasons */
export type AtsRejectionReasonApplicationArgs = {
  afterApplicationId?: InputMaybe<Scalars['Int']>;
  atsAnswers?: InputMaybe<Array<ApplicationsAtsAnswersInput>>;
  atsApplicationPhaseId?: InputMaybe<Scalars['Int']>;
  atsCandidateId?: InputMaybe<Scalars['Int']>;
  atsCandidateIds?: InputMaybe<Array<Scalars['Int']>>;
  atsJobPostingId?: InputMaybe<Scalars['Int']>;
  atsTagsIds?: InputMaybe<Array<Scalars['Int']>>;
  beforeApplicationId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeRatingAverages?: InputMaybe<Scalars['Boolean']>;
  qualified?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};


/** Company Rejection Reasons */
export type AtsRejectionReasonApplicationConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  afterApplicationId?: InputMaybe<Scalars['Int']>;
  atsAnswers?: InputMaybe<Array<ApplicationsAtsAnswersInput>>;
  atsApplicationPhaseId?: InputMaybe<Scalars['Int']>;
  atsCandidateId?: InputMaybe<Scalars['Int']>;
  atsCandidateIds?: InputMaybe<Array<Scalars['Int']>>;
  atsJobPostingId?: InputMaybe<Scalars['Int']>;
  atsTagsIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  beforeApplicationId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeRatingAverages?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  qualified?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for AtsRejectionReason. */
export type AtsRejectionReasonConnection = {
  __typename?: 'AtsRejectionReasonConnection';
  /** A list of edges. */
  edges: Array<AtsRejectionReasonEdge>;
  /** A list of nodes. */
  nodes: Array<AtsRejectionReason>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type AtsRejectionReasonDecisionMakersEnum =
  | 'candidate'
  | 'company';

/** An edge in a connection. */
export type AtsRejectionReasonEdge = {
  __typename?: 'AtsRejectionReasonEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AtsRejectionReason;
};

/** the filter for the rejection_reasons resource */
export type AtsRejectionReasonFilter = {
  decisionMaker?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<AtsRejectionReasonFilterConditions>>;
  reason?: InputMaybe<StringFilter>;
};

export type AtsRejectionReasonFilterConditions = {
  decisionMaker?: InputMaybe<StringFilter>;
  reason?: InputMaybe<StringFilter>;
};

/** Candidate applications non sensitive information */
export type AtsRelatedCandidateApplication = {
  __typename?: 'AtsRelatedCandidateApplication';
  applicationPhase: AtsApplicationPhase;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  atsApplicationPhaseId?: Maybe<Scalars['Int']>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  atsJobPostingId: Scalars['Int'];
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  atsRejectionReasonId?: Maybe<Scalars['Int']>;
  candidate: AtsCandidate;
  companyId: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['Int'];
  qualified?: Maybe<Scalars['Boolean']>;
  rejectionReason?: Maybe<AtsRejectionReason>;
  relatedJobPosting: AtsRelatedJobPosting;
};


/** Candidate applications non sensitive information */
export type AtsRelatedCandidateApplicationApplicationPhaseArgs = {
  atsJobPostingId?: InputMaybe<Scalars['Int']>;
  atsJobPostingIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Candidate applications non sensitive information */
export type AtsRelatedCandidateApplicationCandidateArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  atsTagIds?: InputMaybe<Array<Scalars['Int']>>;
  consent?: InputMaybe<Array<Scalars['String']>>;
  contractType?: InputMaybe<Scalars['String']>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['Int']>;
  jobPostingIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  minimumAverageRating?: InputMaybe<Scalars['Float']>;
  rejectionReasonIds?: InputMaybe<Array<Scalars['Int']>>;
  remote?: InputMaybe<Scalars['Boolean']>;
  scheduleType?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Array<Scalars['String']>>;
  sourceIds?: InputMaybe<Array<Scalars['Int']>>;
  talentPool?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Candidate applications non sensitive information */
export type AtsRelatedCandidateApplicationRejectionReasonArgs = {
  atsApplicationIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Candidate applications non sensitive information */
export type AtsRelatedCandidateApplicationRelatedJobPostingArgs = {
  status?: InputMaybe<Enum>;
};

/** The connection type for AtsRelatedCandidateApplication. */
export type AtsRelatedCandidateApplicationConnection = {
  __typename?: 'AtsRelatedCandidateApplicationConnection';
  /** A list of edges. */
  edges: Array<AtsRelatedCandidateApplicationEdge>;
  /** A list of nodes. */
  nodes: Array<AtsRelatedCandidateApplication>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AtsRelatedCandidateApplicationEdge = {
  __typename?: 'AtsRelatedCandidateApplicationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AtsRelatedCandidateApplication;
};

/** Job Postings information related to applications */
export type AtsRelatedJobPosting = {
  __typename?: 'AtsRelatedJobPosting';
  _policies?: Maybe<AtsRelatedJobPostingPolicies>;
  _policiesCollection?: Maybe<Array<PermissionsPolicyResolution>>;
  _policiesConnection: PermissionsPolicyResolutionConnection;
  atsCompanyId: Scalars['Int'];
  companyId: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  hiringManagers: Array<AtsHiringManager>;
  hiringmanagersConnection: AtsHiringManagerConnection;
  id: Scalars['Int'];
  location?: Maybe<LocationsLocation>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  locationId?: Maybe<Scalars['Int']>;
  publishedAt?: Maybe<Scalars['ISO8601DateTime']>;
  status: AtsJobPostingStatusesEnum;
  title: Scalars['String'];
};


/** Job Postings information related to applications */
export type AtsRelatedJobPosting_PoliciesCollectionArgs = {
  ids: Array<AtsRelatedJobPostingPoliciesEnum>;
};


/** Job Postings information related to applications */
export type AtsRelatedJobPosting_PoliciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Job Postings information related to applications */
export type AtsRelatedJobPostingHiringManagersArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  atsJobPostingId?: InputMaybe<Scalars['Int']>;
  uniqueByAccess?: InputMaybe<Scalars['Boolean']>;
};


/** Job Postings information related to applications */
export type AtsRelatedJobPostingHiringmanagersConnectionArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  atsJobPostingId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  uniqueByAccess?: InputMaybe<Scalars['Boolean']>;
};


/** Job Postings information related to applications */
export type AtsRelatedJobPostingLocationArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  main?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};

/** The connection type for AtsRelatedJobPosting. */
export type AtsRelatedJobPostingConnection = {
  __typename?: 'AtsRelatedJobPostingConnection';
  /** A list of edges. */
  edges: Array<AtsRelatedJobPostingEdge>;
  /** A list of nodes. */
  nodes: Array<AtsRelatedJobPosting>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AtsRelatedJobPostingEdge = {
  __typename?: 'AtsRelatedJobPostingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AtsRelatedJobPosting;
};

export type AtsRelatedJobPostingPolicies = {
  __typename?: 'AtsRelatedJobPostingPolicies';
  manage: PermissionsPolicyResolution;
};

export type AtsRelatedJobPostingPoliciesEnum =
  | 'manage';

/** Request to create a job posting */
export type AtsRequisition = {
  __typename?: 'AtsRequisition';
  /**
   * Identifier of the job posting associated with the requisition
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  atsJobPostingId?: Maybe<Scalars['Int']>;
  author: ApiCoreAccess;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  authorId: Scalars['Int'];
  company: ApiCoreCompany;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  companyId: Scalars['Int'];
  contractType?: Maybe<Scalars['String']>;
  /** The date and time when the requisition was created. */
  createdAt: Scalars['ISO8601DateTime'];
  currentApproverIds?: Maybe<Array<Scalars['Int']>>;
  hiringManager?: Maybe<ApiCoreAccess>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  hiringManagerId: Scalars['Int'];
  id: Scalars['Int'];
  jobCatalogNodeLevelsUuid?: Maybe<Scalars['String']>;
  jobCatalogNodeRolesUuid?: Maybe<Scalars['String']>;
  jobPosting?: Maybe<AtsJobPosting>;
  /** The title of the job posting. */
  jobPostingTitle: Scalars['String'];
  materializedApprovalFlow?: Maybe<ApprovalsMaterializedApprovalsFlow>;
  note?: Maybe<Scalars['String']>;
  numberOfPositions?: Maybe<Scalars['Int']>;
  reason: AtsRequisitionReasonsEnum;
  recruiter?: Maybe<ApiCoreAccess>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  recruiterId: Scalars['Int'];
  salaryFrom?: Maybe<Scalars['Int']>;
  salaryPeriod?: Maybe<Scalars['String']>;
  salaryTo?: Maybe<Scalars['Int']>;
  scheduleType?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['ISO8601Date']>;
  /** The status of the requisition. */
  status: AtsRequisitionStatusesEnum;
  team?: Maybe<TeamsTeam>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  teamId?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['ISO8601DateTime'];
  workplace?: Maybe<LocationsLocation>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  workplaceId?: Maybe<Scalars['Int']>;
};


/** Request to create a job posting */
export type AtsRequisitionAuthorArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** Request to create a job posting */
export type AtsRequisitionHiringManagerArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** Request to create a job posting */
export type AtsRequisitionJobPostingArgs = {
  hiringManagerAccessIds?: InputMaybe<Array<Scalars['Int']>>;
  id?: InputMaybe<Scalars['Int']>;
  includeActiveJobs?: InputMaybe<Scalars['Boolean']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  locationId?: InputMaybe<Scalars['Int']>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  status?: InputMaybe<AtsJobPostingStatusesEnum>;
  statuses?: InputMaybe<Array<AtsJobPostingStatusesEnum>>;
  teamId?: InputMaybe<Scalars['Int']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  title?: InputMaybe<Scalars['String']>;
};


/** Request to create a job posting */
export type AtsRequisitionMaterializedApprovalFlowArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  ownerId?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<ApprovalsMaterializedApprovalFlowStatusEnum>;
};


/** Request to create a job posting */
export type AtsRequisitionRecruiterArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** Request to create a job posting */
export type AtsRequisitionTeamArgs = {
  mainTeam?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  withMembers?: InputMaybe<Scalars['Boolean']>;
};


/** Request to create a job posting */
export type AtsRequisitionWorkplaceArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  main?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};

/** The connection type for AtsRequisition. */
export type AtsRequisitionConnection = {
  __typename?: 'AtsRequisitionConnection';
  /** A list of edges. */
  edges: Array<AtsRequisitionEdge>;
  /** A list of nodes. */
  nodes: Array<AtsRequisition>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AtsRequisitionEdge = {
  __typename?: 'AtsRequisitionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AtsRequisition;
};

/** the filter for the requisitions resource */
export type AtsRequisitionFilter = {
  createdAt?: InputMaybe<DateTimeFilter>;
  jobPostingTitle?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<AtsRequisitionFilterConditions>>;
  status?: InputMaybe<StringFilter>;
};

export type AtsRequisitionFilterConditions = {
  createdAt?: InputMaybe<DateTimeFilter>;
  jobPostingTitle?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
};

export type AtsRequisitionReasonsEnum =
  | 'backfill'
  | 'new_position';

export type AtsRequisitionStatusesEnum =
  | 'approved'
  | 'cancelled'
  | 'pending'
  | 'rejected';

/** Salary condition */
export type AtsSalaryCondition = {
  __typename?: 'AtsSalaryCondition';
  gross?: Maybe<Scalars['Int']>;
  max?: Maybe<Scalars['Int']>;
  min?: Maybe<Scalars['Int']>;
  periodicity: Scalars['String'];
};

/** The connection type for AtsSalaryCondition. */
export type AtsSalaryConditionConnection = {
  __typename?: 'AtsSalaryConditionConnection';
  /** A list of edges. */
  edges: Array<AtsSalaryConditionEdge>;
  /** A list of nodes. */
  nodes: Array<AtsSalaryCondition>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AtsSalaryConditionEdge = {
  __typename?: 'AtsSalaryConditionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AtsSalaryCondition;
};

/** Company Tags */
export type AtsTag = {
  __typename?: 'AtsTag';
  companyId: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['Int'];
  name: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for AtsTag. */
export type AtsTagConnection = {
  __typename?: 'AtsTagConnection';
  /** A list of edges. */
  edges: Array<AtsTagEdge>;
  /** A list of nodes. */
  nodes: Array<AtsTag>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AtsTagEdge = {
  __typename?: 'AtsTagEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AtsTag;
};

/** Repo to process the upsell of a plan */
export type AtsUpsell = {
  __typename?: 'AtsUpsell';
  companyId: Scalars['Int'];
  newAddon: BillingValueObjectsAtsAddonEnum;
};

/** Client tokens to use with the HAPI Elements */
export type AtsVonqClientToken = {
  __typename?: 'AtsVonqClientToken';
  clientId: Scalars['String'];
  token: Scalars['String'];
};

export type AtsWorkplaceTypesEnum =
  | 'hybrid'
  | 'onsite'
  | 'remote';

/** Autogenerated return type of Ats_job_posting_generate_draft_subscription. */
export type Ats_Job_Posting_Generate_Draft_SubscriptionPayload = {
  __typename?: 'Ats_job_posting_generate_draft_subscriptionPayload';
  jobPosting?: Maybe<Job_Posting_Generate_Draft_Type>;
};

/** Autogenerated return type of AttachValuesCustomresourcesResource. */
export type AttachValuesCustomresourcesResourcePayload = {
  __typename?: 'AttachValuesCustomresourcesResourcePayload';
  errors: Array<MutationError>;
  resource?: Maybe<CustomResourcesResource>;
};

export type AttachmentsFileAttachment = {
  __typename?: 'AttachmentsFileAttachment';
  byteSize: Scalars['Int'];
  contentType: Scalars['String'];
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  filename: Scalars['String'];
  url: Scalars['String'];
};

/** Aggregate Shift locations */
export type AttendanceAggregateShiftLocation = {
  __typename?: 'AttendanceAggregateShiftLocation';
  employeeId: Scalars['Float'];
  shiftLocationsCount: Scalars['Float'];
};

/** The connection type for AttendanceAggregateShiftLocation. */
export type AttendanceAggregateShiftLocationConnection = {
  __typename?: 'AttendanceAggregateShiftLocationConnection';
  /** A list of edges. */
  edges: Array<AttendanceAggregateShiftLocationEdge>;
  /** A list of nodes. */
  nodes: Array<AttendanceAggregateShiftLocation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AttendanceAggregateShiftLocationEdge = {
  __typename?: 'AttendanceAggregateShiftLocationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AttendanceAggregateShiftLocation;
};

/** Aggregated Bank of Hours balance for an employee over a given period */
export type AttendanceAggregatedBalance = {
  __typename?: 'AttendanceAggregatedBalance';
  /**
   * List of balance pools (for example Bank of Hours, Time Off or Payroll) that
   * store how extra time is distributed and compensated.
   */
  balancePools: Array<AttendanceBalancePool>;
  /** (Deprecated) Alias of daily_balance_from_planning kept for backwards compatibility. */
  dailyBalance: Scalars['String'];
  /** Net balance between worked time and contract hours for the period, in minutes. */
  dailyBalanceFromContract: Scalars['Float'];
  /**
   * Net balance between worked time and planned time for the period, in minutes,
   * used as the base for Extra Hours and the Bank of Hours.
   */
  dailyBalanceFromPlanning: Scalars['Float'];
  /** Employee ID this aggregated balance belongs to. */
  employeeId: Scalars['Int'];
  /** End date of the accumulation period (ISO 8601, inclusive). */
  endOn: Scalars['ISO8601Date'];
  /** ID of the aggregated balance. It combines employee_id and date. */
  id: Scalars['String'];
  /** Start date of the accumulation period (ISO 8601, inclusive). */
  startOn: Scalars['ISO8601Date'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for AttendanceAggregatedBalance. */
export type AttendanceAggregatedBalanceConnection = {
  __typename?: 'AttendanceAggregatedBalanceConnection';
  /** A list of edges. */
  edges: Array<AttendanceAggregatedBalanceEdge>;
  /** A list of nodes. */
  nodes: Array<AttendanceAggregatedBalance>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AttendanceAggregatedBalanceEdge = {
  __typename?: 'AttendanceAggregatedBalanceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AttendanceAggregatedBalance;
};

export type AttendanceAggregatedBalanceInput = {
  balancePools: Array<AttendanceBalancePoolInput>;
  dailyBalanceFromContract: Scalars['String'];
  dailyBalanceFromPlanning: Scalars['String'];
  employeeId: Scalars['Int'];
  endOn: Scalars['ISO8601Date'];
  id: Scalars['String'];
  startOn: Scalars['ISO8601Date'];
  updatedAt: Scalars['ISO8601DateTime'];
};

export type AttendanceAggregatedBalanceSubscription = {
  __typename?: 'AttendanceAggregatedBalanceSubscription';
  balancePools: Array<AttendanceBalancePoolSubscription>;
  dailyBalance: Scalars['String'];
  dailyBalanceFromContract: Scalars['String'];
  dailyBalanceFromPlanning: Scalars['String'];
  employeeId: Scalars['Int'];
  endOn: Scalars['ISO8601Date'];
  id: Scalars['String'];
  startOn: Scalars['ISO8601Date'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Attendance aggregated worked time per employee and date range */
export type AttendanceAggregatedWorkedTime = {
  __typename?: 'AttendanceAggregatedWorkedTime';
  approvedExtraTimeMinutes: Scalars['Int'];
  /** Total rounded break minutes applied to worked time over the requested period. */
  breaksMinutesRounded: Scalars['Int'];
  /** Sum of days in half-day units for the requested period (e.g. 1.5 for three half days). */
  dailyDays: Scalars['Float'];
  /** Total effective worked minutes over the requested period, including paid absences where applicable. */
  effectiveWorkedMinutes: Scalars['Int'];
  employee?: Maybe<AttendanceEmployee>;
  /**
   * Employee ID this aggregated worked time belongs to.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  employeeId: Scalars['Int'];
  /** Total extra time minutes (Extra Hours) over the requested period. */
  extraTimeMinutes: Scalars['Int'];
  /** ID of the aggregated worked time. It combines employee_id and date. */
  id: Scalars['String'];
  /** Total raw worked minutes over the requested period (before multipliers). */
  minutes: Scalars['Int'];
  /** Total worked minutes after applying multipliers from special hours and compensation rules over the requested period. */
  multipliedMinutes: Scalars['Int'];
  /** Total minutes of paid absences (paid leaves) over the requested period. */
  paidAbsencesMinutes: Scalars['Int'];
  /** Total minutes of paid breaks over the requested period. */
  paidBreaksMinutes: Scalars['Int'];
  /** Total regular worked minutes (non-extra) over the requested period. */
  regularMinutes: Scalars['Int'];
  /** Total tracked time minutes (clock-in/clock-out) over the requested period. */
  trackedMinutes: Scalars['Int'];
  /** Sum of all minutes from worked time blocks with timeType regular. */
  workedRegularMinutes: Scalars['Int'];
  /** Detailed list of worked time blocks used to build the aggregation, including time category and multiplier metadata. */
  workedTimeBlocks: Array<AttendanceWorkedTimeBlock>;
};

/** The connection type for AttendanceAggregatedWorkedTime. */
export type AttendanceAggregatedWorkedTimeConnection = {
  __typename?: 'AttendanceAggregatedWorkedTimeConnection';
  /** A list of edges. */
  edges: Array<AttendanceAggregatedWorkedTimeEdge>;
  /** A list of nodes. */
  nodes: Array<AttendanceAggregatedWorkedTime>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AttendanceAggregatedWorkedTimeEdge = {
  __typename?: 'AttendanceAggregatedWorkedTimeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AttendanceAggregatedWorkedTime;
};

/** Fetch employee automatic break rules */
export type AttendanceAutomaticBreakRule = {
  __typename?: 'AttendanceAutomaticBreakRule';
  accumulatedPeriodLength: Scalars['Int'];
  attendanceBreakSettingId: Scalars['Int'];
  breakDuration: Scalars['Int'];
  id: Scalars['Int'];
  periodLength: Scalars['Int'];
  timeSettingsBreakConfigurationId?: Maybe<Scalars['Int']>;
};

/** The connection type for AttendanceAutomaticBreakRule. */
export type AttendanceAutomaticBreakRuleConnection = {
  __typename?: 'AttendanceAutomaticBreakRuleConnection';
  /** A list of edges. */
  edges: Array<AttendanceAutomaticBreakRuleEdge>;
  /** A list of nodes. */
  nodes: Array<AttendanceAutomaticBreakRule>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AttendanceAutomaticBreakRuleEdge = {
  __typename?: 'AttendanceAutomaticBreakRuleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AttendanceAutomaticBreakRule;
};

export type AttendanceAutomaticRule = {
  __typename?: 'AttendanceAutomaticRule';
  breakDuration?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  periodLength?: Maybe<Scalars['Int']>;
  timeSettingsBreakConfigurationId?: Maybe<Scalars['Int']>;
};

/** Fetch employee balance and their Hour Pool status */
export type AttendanceBalance = {
  __typename?: 'AttendanceBalance';
  accumulationEndOn: Scalars['ISO8601Date'];
  accumulationStartOn: Scalars['ISO8601Date'];
  balancePools: Array<AttendanceBalancePool>;
  /** Complementary time minutes */
  complementaryTimeMinutes: Scalars['Float'];
  dailyBalance: Scalars['String'];
  dailyBalanceFromContract: Scalars['String'];
  dailyBalanceFromPlanning: Scalars['String'];
  date: Scalars['ISO8601Date'];
  employeeId: Scalars['Int'];
  extraTimeCalculated: Scalars['Boolean'];
  extraTimeCalculationOn: Scalars['ISO8601Date'];
  /** ID to specify the balance it includes the employee_id and date */
  id: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Attendance balance breakdown */
export type AttendanceBalanceBreakdown = {
  __typename?: 'AttendanceBalanceBreakdown';
  accumulationEnabled: Scalars['Boolean'];
  balanceMinutes: Scalars['String'];
  employeeId: Scalars['Int'];
  endAt: Scalars['ISO8601Date'];
  overtimePools: AttendanceOvertimePools;
  rawBalanceMinutes: Scalars['String'];
  startAt: Scalars['ISO8601Date'];
};

/** The connection type for AttendanceBalanceBreakdown. */
export type AttendanceBalanceBreakdownConnection = {
  __typename?: 'AttendanceBalanceBreakdownConnection';
  /** A list of edges. */
  edges: Array<AttendanceBalanceBreakdownEdge>;
  /** A list of nodes. */
  nodes: Array<AttendanceBalanceBreakdown>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AttendanceBalanceBreakdownEdge = {
  __typename?: 'AttendanceBalanceBreakdownEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AttendanceBalanceBreakdown;
};

/** Balance carryover rules that define when and how time balances are reset or carried to a new cycle */
export type AttendanceBalanceCarryover = {
  __typename?: 'AttendanceBalanceCarryover';
  attendanceEmployeesSettingId: Scalars['Int'];
  /** Date from which this carryover configuration becomes effective (ISO 8601 date). */
  effectiveAt: Scalars['ISO8601Date'];
  /** Number of reset periods grouped together when using accumulating cycles (for example every 3 months). */
  frequencyNumber?: Maybe<Scalars['Int']>;
  /** Unique identifier of the balance carryover configuration. */
  id?: Maybe<Scalars['Int']>;
  /** How often balances are reset or carried over (for example never, weekly, monthly or yearly). */
  resetFrequency: AttendanceEnumsBalanceCarryoverResetFrequencyEnum;
  /** Reference point used to start counting cycles, such as beginning_of_year. */
  startReference: Scalars['String'];
};

/** The connection type for AttendanceBalanceCarryover. */
export type AttendanceBalanceCarryoverConnection = {
  __typename?: 'AttendanceBalanceCarryoverConnection';
  /** A list of edges. */
  edges: Array<AttendanceBalanceCarryoverEdge>;
  /** A list of nodes. */
  nodes: Array<AttendanceBalanceCarryover>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AttendanceBalanceCarryoverEdge = {
  __typename?: 'AttendanceBalanceCarryoverEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AttendanceBalanceCarryover;
};

/** The connection type for AttendanceBalance. */
export type AttendanceBalanceConnection = {
  __typename?: 'AttendanceBalanceConnection';
  /** A list of edges. */
  edges: Array<AttendanceBalanceEdge>;
  /** A list of nodes. */
  nodes: Array<AttendanceBalance>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AttendanceBalanceEdge = {
  __typename?: 'AttendanceBalanceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AttendanceBalance;
};

export type AttendanceBalanceInput = {
  accumulationEndOn: Scalars['ISO8601Date'];
  accumulationStartOn: Scalars['ISO8601Date'];
  balancePools: Array<AttendanceBalancePoolInput>;
  dailyBalance: Scalars['String'];
  dailyBalanceFromContract: Scalars['String'];
  dailyBalanceFromPlanning: Scalars['String'];
  date: Scalars['ISO8601Date'];
  employeeId: Scalars['Int'];
  extraTimeCalculated: Scalars['Boolean'];
  extraTimeCalculationOn: Scalars['ISO8601Date'];
  id: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

export type AttendanceBalanceOvertimePool = {
  __typename?: 'AttendanceBalanceOvertimePool';
  capacity: Scalars['String'];
  enabled: Scalars['Boolean'];
  minutes: Scalars['String'];
  previousMinutes: Scalars['String'];
  previousTransfers: Scalars['String'];
  transfers: Scalars['String'];
  type: AttendanceEnumsPoolTypeEnum;
  unlimited: Scalars['Boolean'];
  updateFrequency: AttendanceEnumsOvertimePoolUpdateFrequencyEnum;
};

export type AttendanceBalancePool = {
  __typename?: 'AttendanceBalancePool';
  transfers: Array<AttendanceTimeBlock>;
  type: AttendanceEnumsPoolTypeEnum;
  usages: Array<AttendanceTimeBlock>;
};

export type AttendanceBalancePoolInput = {
  transfers: Array<AttendanceTimeBlockInput>;
  type: AttendanceEnumsPoolTypeEnum;
  usages: Array<AttendanceTimeBlockInput>;
};

export type AttendanceBalancePoolSubscription = {
  __typename?: 'AttendanceBalancePoolSubscription';
  transfers: Array<AttendanceTimeBlockSubscription>;
  type: AttendanceEnumsPoolTypeEnum;
  usages: Array<AttendanceTimeBlockSubscription>;
};

export type AttendanceBalanceSubscription = {
  __typename?: 'AttendanceBalanceSubscription';
  accumulationEndOn: Scalars['ISO8601Date'];
  accumulationStartOn: Scalars['ISO8601Date'];
  balancePools: Array<AttendanceBalancePoolSubscription>;
  complementaryTimeMinutes: Scalars['Float'];
  dailyBalance: Scalars['String'];
  dailyBalanceFromContract: Scalars['String'];
  dailyBalanceFromPlanning: Scalars['String'];
  date: Scalars['ISO8601Date'];
  employeeId: Scalars['Int'];
  extraTimeCalculated: Scalars['Boolean'];
  extraTimeCalculationOn: Scalars['ISO8601Date'];
  id: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Break configurations attendance */
export type AttendanceBreakConfiguration = {
  __typename?: 'AttendanceBreakConfiguration';
  /** Id of the attendance employee setting */
  attendanceEmployeesSettingId: Scalars['Int'];
  /** Status of the break configuration if enabled or not */
  enabled: Scalars['Boolean'];
  id: Scalars['Int'];
  /** Name of the break configuration */
  name?: Maybe<Scalars['String']>;
  /** Check the break configuration is paid or not */
  paid?: Maybe<Scalars['Boolean']>;
  timeSettingsBreakConfiguration?: Maybe<TimeSettingsBreakConfiguration>;
  /**
   * Id of the time settings break configuration
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  timeSettingsBreakConfigurationId: Scalars['Int'];
};


/** Break configurations attendance */
export type AttendanceBreakConfigurationTimeSettingsBreakConfigurationArgs = {
  active?: Scalars['Boolean'];
};

/** The connection type for AttendanceBreakConfiguration. */
export type AttendanceBreakConfigurationConnection = {
  __typename?: 'AttendanceBreakConfigurationConnection';
  /** A list of edges. */
  edges: Array<AttendanceBreakConfigurationEdge>;
  /** A list of nodes. */
  nodes: Array<AttendanceBreakConfiguration>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AttendanceBreakConfigurationEdge = {
  __typename?: 'AttendanceBreakConfigurationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AttendanceBreakConfiguration;
};

/** Fetch breaks enabled over a given range */
export type AttendanceBreakConfigurationsForDate = {
  __typename?: 'AttendanceBreakConfigurationsForDate';
  breakConfigurations: Array<AttendanceDayBreak>;
  date: Scalars['ISO8601Date'];
};

/** The connection type for AttendanceBreakConfigurationsForDate. */
export type AttendanceBreakConfigurationsForDateConnection = {
  __typename?: 'AttendanceBreakConfigurationsForDateConnection';
  /** A list of edges. */
  edges: Array<AttendanceBreakConfigurationsForDateEdge>;
  /** A list of nodes. */
  nodes: Array<AttendanceBreakConfigurationsForDate>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AttendanceBreakConfigurationsForDateEdge = {
  __typename?: 'AttendanceBreakConfigurationsForDateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AttendanceBreakConfigurationsForDate;
};

/** Break Duration Rule */
export type AttendanceBreakDurationRule = {
  __typename?: 'AttendanceBreakDurationRule';
  attendanceBreakSettingId: Scalars['Int'];
  id: Scalars['Int'];
  minimalDuration: Scalars['Int'];
  periodLength: Scalars['Int'];
};

/** The connection type for AttendanceBreakDurationRule. */
export type AttendanceBreakDurationRuleConnection = {
  __typename?: 'AttendanceBreakDurationRuleConnection';
  /** A list of edges. */
  edges: Array<AttendanceBreakDurationRuleEdge>;
  /** A list of nodes. */
  nodes: Array<AttendanceBreakDurationRule>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AttendanceBreakDurationRuleEdge = {
  __typename?: 'AttendanceBreakDurationRuleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AttendanceBreakDurationRule;
};

/** Break settings that define how breaks are generated, enforced and validated for an employees setting */
export type AttendanceBreakSetting = {
  __typename?: 'AttendanceBreakSetting';
  attendanceAutomaticBreakRules: Array<AttendanceAutomaticBreakRule>;
  attendanceBreakDurationRules: Array<AttendanceBreakDurationRule>;
  attendanceEmployeesSettingId: Scalars['Int'];
  attendanceautomaticbreakrulesConnection: AttendanceAutomaticBreakRuleConnection;
  attendancebreakdurationrulesConnection: AttendanceBreakDurationRuleConnection;
  automaticBreakRulesAttributes: Array<AttendanceAutomaticRule>;
  /** Source used to generate automatic breaks (for example rules or planned_hours). */
  automaticBreakSource: AttendanceEnumsBreakSourceEnum;
  /** Whether breaks are created automatically based on rules (true) or only manually (false). */
  automaticBreaks?: Maybe<Scalars['Boolean']>;
  /** Minimal duration in minutes that a break must have to be considered valid. */
  baseMinimalDuration?: Maybe<Scalars['Int']>;
  /** How violations of break rules are handled, such as no_action or blocking clock‑ins. */
  breakViolationsHandling?: Maybe<AttendanceEnumsBreakViolationsHandlingEnum>;
  durationRulesAttributes: Array<AttendanceDurationRule>;
  /** Unique identifier of the break setting. */
  id: Scalars['Int'];
  /** Whether employees can create and manage breaks manually. */
  manualBreaks: Scalars['Boolean'];
  /** When enabled, rest time rules are applied to enforce minimal rest between shifts. */
  restTime?: Maybe<Scalars['Boolean']>;
};


/** Break settings that define how breaks are generated, enforced and validated for an employees setting */
export type AttendanceBreakSettingAttendanceAutomaticBreakRulesArgs = {
  breakSettingId?: InputMaybe<Scalars['Int']>;
};


/** Break settings that define how breaks are generated, enforced and validated for an employees setting */
export type AttendanceBreakSettingAttendanceBreakDurationRulesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Break settings that define how breaks are generated, enforced and validated for an employees setting */
export type AttendanceBreakSettingAttendanceautomaticbreakrulesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  breakSettingId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Break settings that define how breaks are generated, enforced and validated for an employees setting */
export type AttendanceBreakSettingAttendancebreakdurationrulesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for AttendanceBreakSetting. */
export type AttendanceBreakSettingConnection = {
  __typename?: 'AttendanceBreakSettingConnection';
  /** A list of edges. */
  edges: Array<AttendanceBreakSettingEdge>;
  /** A list of nodes. */
  nodes: Array<AttendanceBreakSetting>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AttendanceBreakSettingEdge = {
  __typename?: 'AttendanceBreakSettingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AttendanceBreakSetting;
};

/** Break Shifts repository that handles breaks actions */
export type AttendanceBreakShift = {
  __typename?: 'AttendanceBreakShift';
  attendancePeriodId: Scalars['Int'];
  automaticClockIn?: Maybe<Scalars['Boolean']>;
  automaticClockOut?: Maybe<Scalars['Boolean']>;
  clockIn?: Maybe<Scalars['ISO8601DateTime']>;
  clockInOffset?: Maybe<Scalars['String']>;
  clockInWithSeconds?: Maybe<Scalars['ISO8601DateTime']>;
  clockOut?: Maybe<Scalars['ISO8601DateTime']>;
  clockOutOffset?: Maybe<Scalars['String']>;
  companyId: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  crossesMidnight: Scalars['Boolean'];
  date: Scalars['ISO8601Date'];
  employee?: Maybe<AttendanceEmployee>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  employeeId: Scalars['Int'];
  halfDay?: Maybe<AttendanceShiftHalfDayTypesEnum>;
  id: Scalars['Int'];
  inLocationAccuracy?: Maybe<Scalars['Float']>;
  inLocationLatitude?: Maybe<Scalars['Float']>;
  inLocationLongitude?: Maybe<Scalars['Float']>;
  inSource?: Maybe<Scalars['String']>;
  isOvernight: Scalars['Boolean'];
  locationType?: Maybe<AttendanceShiftLocationTypeEnum>;
  minutes: Scalars['Int'];
  observations?: Maybe<Scalars['String']>;
  outLocationAccuracy?: Maybe<Scalars['Float']>;
  outLocationLatitude?: Maybe<Scalars['Float']>;
  outLocationLongitude?: Maybe<Scalars['Float']>;
  outSource?: Maybe<Scalars['String']>;
  periodId: Scalars['Int'];
  projectWorkerId?: Maybe<Scalars['Int']>;
  referenceDate: Scalars['ISO8601Date'];
  showPlusOneDay: Scalars['Boolean'];
  subprojectId?: Maybe<Scalars['Int']>;
  timeSettingsBreakConfiguration?: Maybe<TimeSettingsBreakConfiguration>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  timeSettingsBreakConfigurationId?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['ISO8601DateTime'];
  workable?: Maybe<Scalars['Boolean']>;
  workplace?: Maybe<LocationsLocation>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  workplaceId?: Maybe<Scalars['Int']>;
};


/** Break Shifts repository that handles breaks actions */
export type AttendanceBreakShiftTimeSettingsBreakConfigurationArgs = {
  active?: Scalars['Boolean'];
};


/** Break Shifts repository that handles breaks actions */
export type AttendanceBreakShiftWorkplaceArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  main?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};

/** Handles clock operations */
export type AttendanceClockInOut = {
  __typename?: 'AttendanceClockInOut';
  attendancePeriodId: Scalars['Int'];
  automaticClockIn?: Maybe<Scalars['Boolean']>;
  automaticClockOut?: Maybe<Scalars['Boolean']>;
  clockIn?: Maybe<Scalars['ISO8601DateTime']>;
  clockInOffset?: Maybe<Scalars['String']>;
  clockInWithSeconds?: Maybe<Scalars['ISO8601DateTime']>;
  clockOut?: Maybe<Scalars['ISO8601DateTime']>;
  clockOutOffset?: Maybe<Scalars['String']>;
  companyId: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  crossesMidnight: Scalars['Boolean'];
  date: Scalars['ISO8601Date'];
  employee?: Maybe<AttendanceEmployee>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  employeeId: Scalars['Int'];
  halfDay?: Maybe<AttendanceShiftHalfDayTypesEnum>;
  id: Scalars['Int'];
  inLocationAccuracy?: Maybe<Scalars['Float']>;
  inLocationLatitude?: Maybe<Scalars['Float']>;
  inLocationLongitude?: Maybe<Scalars['Float']>;
  inSource?: Maybe<Scalars['String']>;
  isOvernight: Scalars['Boolean'];
  locationType?: Maybe<AttendanceShiftLocationTypeEnum>;
  minutes: Scalars['Int'];
  observations?: Maybe<Scalars['String']>;
  outLocationAccuracy?: Maybe<Scalars['Float']>;
  outLocationLatitude?: Maybe<Scalars['Float']>;
  outLocationLongitude?: Maybe<Scalars['Float']>;
  outSource?: Maybe<Scalars['String']>;
  periodId: Scalars['Int'];
  projectWorkerId?: Maybe<Scalars['Int']>;
  referenceDate: Scalars['ISO8601Date'];
  showPlusOneDay: Scalars['Boolean'];
  subprojectId?: Maybe<Scalars['Int']>;
  timeSettingsBreakConfiguration?: Maybe<TimeSettingsBreakConfiguration>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  timeSettingsBreakConfigurationId?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['ISO8601DateTime'];
  workable?: Maybe<Scalars['Boolean']>;
  workplace?: Maybe<LocationsLocation>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  workplaceId?: Maybe<Scalars['Int']>;
};


/** Handles clock operations */
export type AttendanceClockInOutTimeSettingsBreakConfigurationArgs = {
  active?: Scalars['Boolean'];
};


/** Handles clock operations */
export type AttendanceClockInOutWorkplaceArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  main?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};

/** Attendance Company Settings Versions */
export type AttendanceCompanySettingsVersion = {
  __typename?: 'AttendanceCompanySettingsVersion';
  companyId: Scalars['Int'];
  effectiveOn: Scalars['ISO8601Date'];
  id?: Maybe<Scalars['Int']>;
  overnightShiftsCalculationMethod: AttendanceCompanySettingsVersionCalculationMethodEnum;
};

export type AttendanceCompanySettingsVersionCalculationMethodEnum =
  | 'beginning_shift'
  | 'calendar_day'
  | 'legacy';

/** The connection type for AttendanceCompanySettingsVersion. */
export type AttendanceCompanySettingsVersionConnection = {
  __typename?: 'AttendanceCompanySettingsVersionConnection';
  /** A list of edges. */
  edges: Array<AttendanceCompanySettingsVersionEdge>;
  /** A list of nodes. */
  nodes: Array<AttendanceCompanySettingsVersion>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AttendanceCompanySettingsVersionEdge = {
  __typename?: 'AttendanceCompanySettingsVersionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AttendanceCompanySettingsVersion;
};

/** Attendance Company Settings Version Histories */
export type AttendanceCompanySettingsVersionHistory = {
  __typename?: 'AttendanceCompanySettingsVersionHistory';
  companyId: Scalars['Int'];
  companySettingsVersionId?: Maybe<Scalars['Int']>;
  date: Scalars['ISO8601Date'];
  overnightShiftsCalculationMethod: AttendanceCompanySettingsVersionCalculationMethodEnum;
};

/** The connection type for AttendanceCompanySettingsVersionHistory. */
export type AttendanceCompanySettingsVersionHistoryConnection = {
  __typename?: 'AttendanceCompanySettingsVersionHistoryConnection';
  /** A list of edges. */
  edges: Array<AttendanceCompanySettingsVersionHistoryEdge>;
  /** A list of nodes. */
  nodes: Array<AttendanceCompanySettingsVersionHistory>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AttendanceCompanySettingsVersionHistoryEdge = {
  __typename?: 'AttendanceCompanySettingsVersionHistoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AttendanceCompanySettingsVersionHistory;
};

/** A repository to retrieve time compensations (only Payroll ones for now) */
export type AttendanceCompensation = {
  __typename?: 'AttendanceCompensation';
  authorId?: Maybe<Scalars['Int']>;
  companyId: Scalars['Int'];
  compensatedAt: Scalars['ISO8601DateTime'];
  compensationType: Scalars['String'];
  employeeId: Scalars['Int'];
  endOn: Scalars['ISO8601Date'];
  equivalentMinutesInCents: Scalars['Int'];
  minutes: Scalars['Int'];
  rawMinutesInCents: Scalars['Int'];
  sourceId: Scalars['Int'];
  sourceType: Scalars['String'];
  startOn: Scalars['ISO8601Date'];
  timeSettingsCustomTimeRangeCategoryId?: Maybe<Scalars['Int']>;
};

/** A repository to retrieve time compensations blocks */
export type AttendanceCompensationBlock = {
  __typename?: 'AttendanceCompensationBlock';
  balanceDates: Array<Scalars['ISO8601Date']>;
  categoryId?: Maybe<Scalars['Int']>;
  categoryName: Scalars['String'];
  companyId: Scalars['String'];
  compensationPool: AttendanceEntitiesCompensationBlockCompensationPoolEnum;
  compensationType: AttendanceEntitiesCompensationBlockCompensationTypeEnum;
  employeeId: Scalars['String'];
  endOn: Scalars['ISO8601Date'];
  equivalentMinutesInCents: Scalars['Int'];
  id: Scalars['String'];
  minutes: Scalars['Int'];
  rawMinutesInCents: Scalars['Int'];
  selectionKey: Scalars['String'];
  startOn: Scalars['ISO8601Date'];
  status: AttendanceEntitiesCompensationBlockStatusEnum;
};

/** The connection type for AttendanceCompensationBlock. */
export type AttendanceCompensationBlockConnection = {
  __typename?: 'AttendanceCompensationBlockConnection';
  /** A list of edges. */
  edges: Array<AttendanceCompensationBlockEdge>;
  /** A list of nodes. */
  nodes: Array<AttendanceCompensationBlock>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AttendanceCompensationBlockEdge = {
  __typename?: 'AttendanceCompensationBlockEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AttendanceCompensationBlock;
};

/** The connection type for AttendanceCompensation. */
export type AttendanceCompensationConnection = {
  __typename?: 'AttendanceCompensationConnection';
  /** A list of edges. */
  edges: Array<AttendanceCompensationEdge>;
  /** A list of nodes. */
  nodes: Array<AttendanceCompensation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AttendanceCompensationEdge = {
  __typename?: 'AttendanceCompensationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AttendanceCompensation;
};

/** Query the lifecycle status of compensation periods for employees */
export type AttendanceCompensationPeriodStatus = {
  __typename?: 'AttendanceCompensationPeriodStatus';
  employeeId: Scalars['Int'];
  status: AttendanceValueObjectsCompensationPeriodStatusStatusEnum;
};

/** The connection type for AttendanceCompensationPeriodStatus. */
export type AttendanceCompensationPeriodStatusConnection = {
  __typename?: 'AttendanceCompensationPeriodStatusConnection';
  /** A list of edges. */
  edges: Array<AttendanceCompensationPeriodStatusEdge>;
  /** A list of nodes. */
  nodes: Array<AttendanceCompensationPeriodStatus>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AttendanceCompensationPeriodStatusEdge = {
  __typename?: 'AttendanceCompensationPeriodStatusEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AttendanceCompensationPeriodStatus;
};

export type AttendanceCompensationResponse = {
  __typename?: 'AttendanceCompensationResponse';
  authorId?: Maybe<Scalars['Int']>;
  employeeId?: Maybe<Scalars['Int']>;
  equivalentMinutesInCents?: Maybe<Scalars['Int']>;
  error?: Maybe<Scalars['String']>;
  minutes?: Maybe<Scalars['Int']>;
  rawMinutesInCents?: Maybe<Scalars['Int']>;
  sourceId?: Maybe<Scalars['Int']>;
  sourceType?: Maybe<Scalars['String']>;
  timeSettingsCustomTimeRangeCategoryId?: Maybe<Scalars['Int']>;
};

export type AttendanceContextlessPolicies = {
  __typename?: 'AttendanceContextlessPolicies';
  accessEditSettings: ContextlessPolicyResolution;
  brazilianExportAccess: ContextlessPolicyResolution;
  companyApproveAttendance: ContextlessPolicyResolution;
  companyCalendarAccess: ContextlessPolicyResolution;
  companyReadAttendance: ContextlessPolicyResolution;
  companySeeClockedIn: ContextlessPolicyResolution;
  companySeeOthers: ContextlessPolicyResolution;
  companySeeOwned: ContextlessPolicyResolution;
  dashboardWidgetSeeAttendanceWidget: ContextlessPolicyResolution;
  dashboardWidgetTimeTrackingVisible: ContextlessPolicyResolution;
  dashboardWidgetWhoIsInVisible: ContextlessPolicyResolution;
  shiftAutofill: ContextlessPolicyResolution;
  sidebarSeeAttendanceCompanyTopLevelItem: ContextlessPolicyResolution;
  sidebarSeeAttendanceEmployeeTopLevelItem: ContextlessPolicyResolution;
  sidebarSeeAttendanceTimeTrackingAdminSubLevelItem: ContextlessPolicyResolution;
  sidebarSeeAttendanceTopLevelItem: ContextlessPolicyResolution;
};

/** Employees inside attendance domain */
export type AttendanceCustomPeriodEmployee = {
  __typename?: 'AttendanceCustomPeriodEmployee';
  _policies?: Maybe<AttendanceCustomPeriodEmployeePolicies>;
  _policiesCollection?: Maybe<Array<PermissionsPolicyResolution>>;
  _policiesConnection: PermissionsPolicyResolutionConnection;
  access: ApiCoreAccess;
  /**
   * access_id associated to the employee.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  accessId: Scalars['Int'];
  /** number of pending alerts within the selected range */
  alertsCount?: Maybe<Scalars['Int']>;
  /** attendable of the employee. */
  attendable: Scalars['Boolean'];
  attendanceAggregatedBalance: Array<AttendanceAggregatedBalance>;
  attendanceAggregatedBalanceConnection: AttendanceAggregatedBalanceConnection;
  attendanceAggregatedWorkedTime?: Maybe<AttendanceAggregatedWorkedTime>;
  attendanceBalances: Array<AttendanceBalance>;
  attendanceBalancesConnection: AttendanceBalanceConnection;
  attendanceCompensations: Array<AttendanceCompensation>;
  attendanceCompensationsConnection: AttendanceCompensationConnection;
  attendanceCycles: Array<AttendanceCycle>;
  attendanceCyclesConnection: AttendanceCycleConnection;
  attendanceEmployeesPolicy?: Maybe<AttendanceEmployeesPolicy>;
  /**
   * attendance employees policy id of the employee.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  attendanceEmployeesPolicyId?: Maybe<Scalars['Int']>;
  attendanceEstimatedTimes: Array<AttendanceEstimatedTime>;
  attendanceEstimatedTimesConnection: AttendanceEstimatedTimeConnection;
  attendanceReviewsStats: Array<AttendanceReviewsStat>;
  attendanceReviewsStatsConnection: AttendanceReviewsStatConnection;
  attendanceWorkedBreaks: Array<AttendanceWorkedBreak>;
  attendanceWorkedBreaksConnection: AttendanceWorkedBreakConnection;
  attendanceWorkedTimes: Array<AttendanceWorkedTime>;
  attendanceWorkedTimesConnection: AttendanceWorkedTimeConnection;
  /** company id of the employee. */
  companyId: Scalars['Int'];
  /** count of the employee. */
  count: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  /** employee group id of the employee. */
  employeeGroupId: Scalars['Int'];
  /** name of the employee. */
  firstName: Scalars['String'];
  /** full name of the employee. */
  fullName: Scalars['String'];
  /** id of the employee. */
  id?: Maybe<Scalars['Int']>;
  /** national identifier number. */
  identifier?: Maybe<Scalars['String']>;
  /** type of identifier (ex passport). */
  identifierType?: Maybe<Scalars['String']>;
  /** last name of the employee. */
  lastName: Scalars['String'];
  /** location id of the employee. */
  locationId: Scalars['Int'];
  /** manager id of the employee. */
  managerId?: Maybe<Scalars['Int']>;
  preferredName?: Maybe<Scalars['String']>;
  referenceContract?: Maybe<ContractsReferenceContract>;
  regularAccessStartsOn?: Maybe<Scalars['ISO8601Date']>;
  /** status of the employee's attendance review. */
  reviewStatus?: Maybe<AttendanceStateResolverStateEnum>;
  terminatedOn?: Maybe<Scalars['ISO8601Date']>;
  timeInsightsInconsistencies: Array<TimeInsightsInconsistency>;
  timeInsightsInconsistenciesConnection: TimeInsightsInconsistencyConnection;
  /** timeoff manager id of the employee. */
  timeoffManagerId?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['ISO8601DateTime'];
};


/** Employees inside attendance domain */
export type AttendanceCustomPeriodEmployee_PoliciesCollectionArgs = {
  ids: Array<AttendanceCustomPeriodEmployeePoliciesEnum>;
};


/** Employees inside attendance domain */
export type AttendanceCustomPeriodEmployee_PoliciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Employees inside attendance domain */
export type AttendanceCustomPeriodEmployeeAccessArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** Employees inside attendance domain */
export type AttendanceCustomPeriodEmployeeAttendanceAggregatedBalanceArgs = {
  endOn: Scalars['ISO8601Date'];
  ids?: InputMaybe<Array<Scalars['String']>>;
  startOn: Scalars['ISO8601Date'];
};


/** Employees inside attendance domain */
export type AttendanceCustomPeriodEmployeeAttendanceAggregatedBalanceConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endOn: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startOn: Scalars['ISO8601Date'];
};


/** Employees inside attendance domain */
export type AttendanceCustomPeriodEmployeeAttendanceAggregatedWorkedTimeArgs = {
  endOn: Scalars['ISO8601Date'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  startOn: Scalars['ISO8601Date'];
};


/** Employees inside attendance domain */
export type AttendanceCustomPeriodEmployeeAttendanceBalancesArgs = {
  disableAccumulation?: Scalars['Boolean'];
  endOn: Scalars['ISO8601Date'];
  ids?: InputMaybe<Array<Scalars['String']>>;
  startOn: Scalars['ISO8601Date'];
};


/** Employees inside attendance domain */
export type AttendanceCustomPeriodEmployeeAttendanceBalancesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  disableAccumulation?: Scalars['Boolean'];
  endOn: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startOn: Scalars['ISO8601Date'];
};


/** Employees inside attendance domain */
export type AttendanceCustomPeriodEmployeeAttendanceCompensationsArgs = {
  endOn?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  startOn?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Employees inside attendance domain */
export type AttendanceCustomPeriodEmployeeAttendanceCompensationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endOn?: InputMaybe<Scalars['ISO8601Date']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startOn?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Employees inside attendance domain */
export type AttendanceCustomPeriodEmployeeAttendanceCyclesArgs = {
  endOn: Scalars['ISO8601Date'];
  startOn: Scalars['ISO8601Date'];
};


/** Employees inside attendance domain */
export type AttendanceCustomPeriodEmployeeAttendanceCyclesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endOn: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startOn: Scalars['ISO8601Date'];
};


/** Employees inside attendance domain */
export type AttendanceCustomPeriodEmployeeAttendanceEstimatedTimesArgs = {
  endOn: Scalars['ISO8601Date'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeNonAttendableEmployees?: Scalars['Boolean'];
  startOn: Scalars['ISO8601Date'];
};


/** Employees inside attendance domain */
export type AttendanceCustomPeriodEmployeeAttendanceEstimatedTimesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endOn: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeNonAttendableEmployees?: Scalars['Boolean'];
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startOn: Scalars['ISO8601Date'];
};


/** Employees inside attendance domain */
export type AttendanceCustomPeriodEmployeeAttendanceReviewsStatsArgs = {
  endOn?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  reviewedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  startOn?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Employees inside attendance domain */
export type AttendanceCustomPeriodEmployeeAttendanceReviewsStatsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endOn?: InputMaybe<Scalars['ISO8601Date']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  reviewedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  sortOrder?: InputMaybe<Sort>;
  startOn?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Employees inside attendance domain */
export type AttendanceCustomPeriodEmployeeAttendanceWorkedBreaksArgs = {
  endOn: Scalars['ISO8601Date'];
  paid?: InputMaybe<Scalars['Boolean']>;
  startOn: Scalars['ISO8601Date'];
};


/** Employees inside attendance domain */
export type AttendanceCustomPeriodEmployeeAttendanceWorkedBreaksConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endOn: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  paid?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Sort>;
  startOn: Scalars['ISO8601Date'];
};


/** Employees inside attendance domain */
export type AttendanceCustomPeriodEmployeeAttendanceWorkedTimesArgs = {
  endOn?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  includeNonAttendableEmployees?: Scalars['Boolean'];
  includeTimeRangeCategory?: Scalars['Boolean'];
  startOn?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Employees inside attendance domain */
export type AttendanceCustomPeriodEmployeeAttendanceWorkedTimesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endOn?: InputMaybe<Scalars['ISO8601Date']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  includeNonAttendableEmployees?: Scalars['Boolean'];
  includeTimeRangeCategory?: Scalars['Boolean'];
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startOn?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Employees inside attendance domain */
export type AttendanceCustomPeriodEmployeeReferenceContractArgs = {
  activeBetween?: InputMaybe<ReferenceContractsActiveBetweenInput>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  effectiveOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  endsOnGt?: InputMaybe<Scalars['ISO8601Date']>;
  endsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  frContractTypeIds?: InputMaybe<Array<Scalars['Int']>>;
  frMutualIds?: InputMaybe<Array<Scalars['Int']>>;
  frWorkTypeIds?: InputMaybe<Array<Scalars['Int']>>;
  includeDenormalizedData?: Scalars['Boolean'];
  includeEducationLevel?: Scalars['Boolean'];
  jobCatalogLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  jobCatalogTreeNodeUuids?: InputMaybe<Array<Scalars['String']>>;
  onDate?: InputMaybe<Scalars['ISO8601Date']>;
  payrollPolicyId?: InputMaybe<Scalars['Int']>;
  startsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  startsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedBecauseRelatedModels?: InputMaybe<Scalars['Boolean']>;
  withPayroll?: InputMaybe<Scalars['Boolean']>;
  withTranslations?: InputMaybe<Scalars['Boolean']>;
};


/** Employees inside attendance domain */
export type AttendanceCustomPeriodEmployeeTimeInsightsInconsistenciesArgs = {
  endOn?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  inconsistencyTypes?: InputMaybe<Array<TimeInsightsValueObjectsInconsistencyTypeEnum>>;
  shiftIds?: InputMaybe<Array<Scalars['Int']>>;
  startOn?: InputMaybe<Scalars['ISO8601Date']>;
  state?: InputMaybe<TimeInsightsEntitiesInconsistencyStateEnum>;
};


/** Employees inside attendance domain */
export type AttendanceCustomPeriodEmployeeTimeInsightsInconsistenciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endOn?: InputMaybe<Scalars['ISO8601Date']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  inconsistencyTypes?: InputMaybe<Array<TimeInsightsValueObjectsInconsistencyTypeEnum>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  shiftIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
  startOn?: InputMaybe<Scalars['ISO8601Date']>;
  state?: InputMaybe<TimeInsightsEntitiesInconsistencyStateEnum>;
};

/** The connection type for AttendanceCustomPeriodEmployee. */
export type AttendanceCustomPeriodEmployeeConnection = {
  __typename?: 'AttendanceCustomPeriodEmployeeConnection';
  aggregate?: Maybe<AttendanceCustomPeriodEmployeesAggregate>;
  /** A list of edges. */
  edges: Array<AttendanceCustomPeriodEmployeeEdge>;
  /** A list of nodes. */
  nodes: Array<AttendanceCustomPeriodEmployee>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AttendanceCustomPeriodEmployeeEdge = {
  __typename?: 'AttendanceCustomPeriodEmployeeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AttendanceCustomPeriodEmployee;
};

/** the filter for the custom_period_employees resource */
export type AttendanceCustomPeriodEmployeeFilter = {
  alertsCount?: InputMaybe<IntegerFilter>;
  count?: InputMaybe<IntegerFilter>;
  firstName?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntegerFilter>;
  lastName?: InputMaybe<StringFilter>;
  locationId?: InputMaybe<IntegerFilter>;
  or?: InputMaybe<Array<AttendanceCustomPeriodEmployeeFilterConditions>>;
  reviewStatus?: InputMaybe<StringFilter>;
  timeoffManagerId?: InputMaybe<IntegerFilter>;
};

export type AttendanceCustomPeriodEmployeeFilterConditions = {
  alertsCount?: InputMaybe<IntegerFilter>;
  count?: InputMaybe<IntegerFilter>;
  firstName?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntegerFilter>;
  lastName?: InputMaybe<StringFilter>;
  locationId?: InputMaybe<IntegerFilter>;
  reviewStatus?: InputMaybe<StringFilter>;
  timeoffManagerId?: InputMaybe<IntegerFilter>;
};

export type AttendanceCustomPeriodEmployeePolicies = {
  __typename?: 'AttendanceCustomPeriodEmployeePolicies';
  approveTimesheet: PermissionsPolicyResolution;
};

export type AttendanceCustomPeriodEmployeePoliciesEnum =
  | 'approveTimesheet';

/** Attendance custom_period_employees aggregates */
export type AttendanceCustomPeriodEmployeesAggregate = {
  __typename?: 'AttendanceCustomPeriodEmployeesAggregate';
  average?: Maybe<AttendanceCustomPeriodEmployeesConnectionAggregateAverage>;
  count?: Maybe<Scalars['Int']>;
  maximum?: Maybe<AttendanceCustomPeriodEmployeesConnectionAggregateMaximum>;
  minimum?: Maybe<AttendanceCustomPeriodEmployeesConnectionAggregateMinimum>;
  sum?: Maybe<AttendanceCustomPeriodEmployeesConnectionAggregateSum>;
  terms?: Maybe<AttendanceCustomPeriodEmployeesConnectionAggregateTerms>;
};

export type AttendanceCustomPeriodEmployeesAggregateTerms = {
  __typename?: 'AttendanceCustomPeriodEmployeesAggregateTerms';
  average?: Maybe<AttendanceCustomPeriodEmployeesConnectionAggregateTermsAverageFields>;
  count?: Maybe<Array<Scalars['Int']>>;
  maximum?: Maybe<AttendanceCustomPeriodEmployeesConnectionAggregateTermsMaximumFields>;
  minimum?: Maybe<AttendanceCustomPeriodEmployeesConnectionAggregateTermsMinimumFields>;
  sum?: Maybe<AttendanceCustomPeriodEmployeesConnectionAggregateTermsSumFields>;
  values: Array<Scalars['String']>;
};

/** average function */
export type AttendanceCustomPeriodEmployeesConnectionAggregateAverage = {
  __typename?: 'AttendanceCustomPeriodEmployeesConnectionAggregateAverage';
  alertsCount?: Maybe<Scalars['Float']>;
  count?: Maybe<Scalars['Float']>;
};

/** maximum function */
export type AttendanceCustomPeriodEmployeesConnectionAggregateMaximum = {
  __typename?: 'AttendanceCustomPeriodEmployeesConnectionAggregateMaximum';
  alertsCount?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['Int']>;
};

/** minimum function */
export type AttendanceCustomPeriodEmployeesConnectionAggregateMinimum = {
  __typename?: 'AttendanceCustomPeriodEmployeesConnectionAggregateMinimum';
  alertsCount?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['Int']>;
};

/** sum function */
export type AttendanceCustomPeriodEmployeesConnectionAggregateSum = {
  __typename?: 'AttendanceCustomPeriodEmployeesConnectionAggregateSum';
  alertsCount?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['Int']>;
};

/** terms function */
export type AttendanceCustomPeriodEmployeesConnectionAggregateTerms = {
  __typename?: 'AttendanceCustomPeriodEmployeesConnectionAggregateTerms';
  alertsCount?: Maybe<AttendanceCustomPeriodEmployeesAggregateTerms>;
  count?: Maybe<AttendanceCustomPeriodEmployeesAggregateTerms>;
  firstName?: Maybe<AttendanceCustomPeriodEmployeesAggregateTerms>;
  lastName?: Maybe<AttendanceCustomPeriodEmployeesAggregateTerms>;
  locationId?: Maybe<AttendanceCustomPeriodEmployeesAggregateTerms>;
  reviewStatus?: Maybe<AttendanceCustomPeriodEmployeesAggregateTerms>;
  timeoffManagerId?: Maybe<AttendanceCustomPeriodEmployeesAggregateTerms>;
};

/** average function */
export type AttendanceCustomPeriodEmployeesConnectionAggregateTermsAverageFields = {
  __typename?: 'AttendanceCustomPeriodEmployeesConnectionAggregateTermsAVERAGEFields';
  alertsCount?: Maybe<Array<Scalars['Float']>>;
  count?: Maybe<Array<Scalars['Float']>>;
};

/** maximum function */
export type AttendanceCustomPeriodEmployeesConnectionAggregateTermsMaximumFields = {
  __typename?: 'AttendanceCustomPeriodEmployeesConnectionAggregateTermsMAXIMUMFields';
  alertsCount?: Maybe<Array<Scalars['Int']>>;
  count?: Maybe<Array<Scalars['Int']>>;
};

/** minimum function */
export type AttendanceCustomPeriodEmployeesConnectionAggregateTermsMinimumFields = {
  __typename?: 'AttendanceCustomPeriodEmployeesConnectionAggregateTermsMINIMUMFields';
  alertsCount?: Maybe<Array<Scalars['Int']>>;
  count?: Maybe<Array<Scalars['Int']>>;
};

/** sum function */
export type AttendanceCustomPeriodEmployeesConnectionAggregateTermsSumFields = {
  __typename?: 'AttendanceCustomPeriodEmployeesConnectionAggregateTermsSUMFields';
  alertsCount?: Maybe<Array<Scalars['Int']>>;
  count?: Maybe<Array<Scalars['Int']>>;
};

/** Custom time ranges that define how worked time is categorized (regular time, overtime, and which pool it contributes to) */
export type AttendanceCustomTimeRange = {
  __typename?: 'AttendanceCustomTimeRange';
  attendanceCustomTimeRangeCategoryId?: Maybe<Scalars['Int']>;
  attendanceEmployeesSettingId: Scalars['Int'];
  /** Specific date this range applies to. */
  date?: Maybe<Scalars['ISO8601Date']>;
  /** Day this range applies to. Can be a weekday (for example monday) or bank_holiday. */
  day?: Maybe<AttendanceCustomTimeRangeDayEnum>;
  /** End time of the range in HH:MM format. When null together with start_time, the range represents a full‑day base range. */
  endTime?: Maybe<Scalars['ISO8601DateTime']>;
  /**
   * Minutes after applying the multiplier, expressed in cents of minutes. Used to
   * compute how much this range contributes to balances.
   */
  equivalentMinutesInCents: Scalars['Int'];
  /** Unique identifier of the custom time range. */
  id: Scalars['Int'];
  /** Name of the custom time range, reused from the linked time settings category. */
  name: Scalars['String'];
  /** Balance pool this time contributes to (for example timeoff, payroll or virtual pools). */
  poolType: AttendanceEnumsPoolTypeEnum;
  /** Raw minutes tracked in this range, expressed in cents of minutes (minutes * 100) before applying any multipliers. */
  rawMinutesInCents: Scalars['Int'];
  /** Start time of the range in HH:MM format. When null together with end_time, the range represents a full‑day base range. */
  startTime?: Maybe<Scalars['ISO8601DateTime']>;
  timeSettingsCustomTimeRangeCategoryId: Scalars['Int'];
  /** Time category for this range, such as regular, overtime or any_time, used to determine how minutes are classified. */
  timeType: TimeSettingsEnumsTimeTypeEnum;
};

/** Custom Time Range Categories */
export type AttendanceCustomTimeRangeCategory = {
  __typename?: 'AttendanceCustomTimeRangeCategory';
  attendanceEmployeesSettingId: Scalars['Int'];
  equivalentMinutesInCents: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['String'];
  rawMinutesInCents: Scalars['Int'];
  timeSettingsCustomTimeRangeCategory?: Maybe<TimeSettingsCustomTimeRangeCategory>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  timeSettingsCustomTimeRangeCategoryId: Scalars['Int'];
  timeType: TimeSettingsEnumsTimeTypeEnum;
};


/** Custom Time Range Categories */
export type AttendanceCustomTimeRangeCategoryTimeSettingsCustomTimeRangeCategoryArgs = {
  active?: Scalars['Boolean'];
  categoryType?: InputMaybe<TimeSettingsEnumsCategoryTypeEnum>;
  companyId?: InputMaybe<Scalars['Int']>;
  default?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for AttendanceCustomTimeRangeCategory. */
export type AttendanceCustomTimeRangeCategoryConnection = {
  __typename?: 'AttendanceCustomTimeRangeCategoryConnection';
  /** A list of edges. */
  edges: Array<AttendanceCustomTimeRangeCategoryEdge>;
  /** A list of nodes. */
  nodes: Array<AttendanceCustomTimeRangeCategory>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AttendanceCustomTimeRangeCategoryEdge = {
  __typename?: 'AttendanceCustomTimeRangeCategoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AttendanceCustomTimeRangeCategory;
};

/** The connection type for AttendanceCustomTimeRange. */
export type AttendanceCustomTimeRangeConnection = {
  __typename?: 'AttendanceCustomTimeRangeConnection';
  /** A list of edges. */
  edges: Array<AttendanceCustomTimeRangeEdge>;
  /** A list of nodes. */
  nodes: Array<AttendanceCustomTimeRange>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type AttendanceCustomTimeRangeDayEnum =
  | 'bank_holiday'
  | 'friday'
  | 'monday'
  | 'saturday'
  | 'sunday'
  | 'thursday'
  | 'tuesday'
  | 'wednesday';

/** An edge in a connection. */
export type AttendanceCustomTimeRangeEdge = {
  __typename?: 'AttendanceCustomTimeRangeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AttendanceCustomTimeRange;
};

/** Fetch employee attendance cycles */
export type AttendanceCycle = {
  __typename?: 'AttendanceCycle';
  employeeId: Scalars['Int'];
  endDate: Scalars['ISO8601Date'];
  startDate: Scalars['ISO8601Date'];
};

/** The connection type for AttendanceCycle. */
export type AttendanceCycleConnection = {
  __typename?: 'AttendanceCycleConnection';
  /** A list of edges. */
  edges: Array<AttendanceCycleEdge>;
  /** A list of nodes. */
  nodes: Array<AttendanceCycle>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AttendanceCycleEdge = {
  __typename?: 'AttendanceCycleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AttendanceCycle;
};

export type AttendanceDayBreak = {
  __typename?: 'AttendanceDayBreak';
  name: Scalars['String'];
  paid?: Maybe<Scalars['Boolean']>;
  timeSettingsBreakConfigurationId?: Maybe<Scalars['Int']>;
};

export type AttendanceDurationRule = {
  __typename?: 'AttendanceDurationRule';
  id?: Maybe<Scalars['Int']>;
  minimalDuration?: Maybe<Scalars['Int']>;
  periodLength?: Maybe<Scalars['Int']>;
};

/** Edit Timesheet Requests */
export type AttendanceEditTimesheetRequest = {
  __typename?: 'AttendanceEditTimesheetRequest';
  /** Status of the edit timesheet request */
  approved?: Maybe<Scalars['Boolean']>;
  attendanceShift?: Maybe<AttendanceShift>;
  /**
   * Id of the shift for the request
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  attendanceShiftId?: Maybe<Scalars['Int']>;
  /** Clock in of the shift */
  clockIn?: Maybe<Scalars['String']>;
  /** Clock out of the shift */
  clockOut?: Maybe<Scalars['String']>;
  /** Date of the shift */
  date?: Maybe<Scalars['ISO8601Date']>;
  /** Id of the shift's employee */
  employeeId: Scalars['Int'];
  /** Unique identifier for the edit timesheet request */
  id: Scalars['Int'];
  /** Location of the shift */
  locationType?: Maybe<AttendanceShiftLocationTypeEnum>;
  /** Additional observations for the shift */
  observations?: Maybe<Scalars['String']>;
  /** Approve or reject reason */
  reason?: Maybe<Scalars['String']>;
  /** Reference date for the shift */
  referenceDate?: Maybe<Scalars['ISO8601Date']>;
  /** Type of the request */
  requestType: AttendanceEditTimesheetRequestRequestTypeEnum;
  timeSettingsBreakConfiguration?: Maybe<TimeSettingsBreakConfiguration>;
  /**
   * Id of the type of break for the request
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  timeSettingsBreakConfigurationId?: Maybe<Scalars['Int']>;
  /** Indicates if the shift is workable or a break */
  workable?: Maybe<Scalars['Boolean']>;
};


/** Edit Timesheet Requests */
export type AttendanceEditTimesheetRequestAttendanceShiftArgs = {
  breaksWithTimeConfiguration?: InputMaybe<Scalars['Boolean']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endOn?: InputMaybe<Scalars['ISO8601Date']>;
  halfDay?: Scalars['Boolean'];
  lastWorkingShift?: InputMaybe<Scalars['Boolean']>;
  latestShift?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortCreatedAtAsc?: Scalars['Boolean'];
  startOn?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAt?: InputMaybe<Scalars['ISO8601Date']>;
  workable?: InputMaybe<Scalars['Boolean']>;
};


/** Edit Timesheet Requests */
export type AttendanceEditTimesheetRequestTimeSettingsBreakConfigurationArgs = {
  active?: Scalars['Boolean'];
};

/** The connection type for AttendanceEditTimesheetRequest. */
export type AttendanceEditTimesheetRequestConnection = {
  __typename?: 'AttendanceEditTimesheetRequestConnection';
  /** A list of edges. */
  edges: Array<AttendanceEditTimesheetRequestEdge>;
  /** A list of nodes. */
  nodes: Array<AttendanceEditTimesheetRequest>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AttendanceEditTimesheetRequestEdge = {
  __typename?: 'AttendanceEditTimesheetRequestEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AttendanceEditTimesheetRequest;
};

export type AttendanceEditTimesheetRequestRequestTypeEnum =
  | 'create_shift'
  | 'delete_shift'
  | 'update_shift';

/** Employees inside attendance domain */
export type AttendanceEmployee = {
  __typename?: 'AttendanceEmployee';
  _policies?: Maybe<AttendanceEmployeePolicies>;
  _policiesCollection?: Maybe<Array<PermissionsPolicyResolution>>;
  _policiesConnection: PermissionsPolicyResolutionConnection;
  access: ApiCoreAccess;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  accessId: Scalars['Int'];
  attendable: Scalars['Boolean'];
  attendanceAggregatedBalance: Array<AttendanceAggregatedBalance>;
  attendanceAggregatedBalanceConnection: AttendanceAggregatedBalanceConnection;
  attendanceAggregatedWorkedTime?: Maybe<AttendanceAggregatedWorkedTime>;
  attendanceBalances: Array<AttendanceBalance>;
  attendanceBalancesConnection: AttendanceBalanceConnection;
  attendanceCompensationBlocks: Array<AttendanceCompensationBlock>;
  attendanceCompensationBlocksConnection: AttendanceCompensationBlockConnection;
  attendanceCompensations: Array<AttendanceCompensation>;
  attendanceCompensationsConnection: AttendanceCompensationConnection;
  attendanceCycles: Array<AttendanceCycle>;
  attendanceCyclesConnection: AttendanceCycleConnection;
  attendanceEditTimesheetRequests: Array<AttendanceEditTimesheetRequest>;
  attendanceEditTimesheetRequestsConnection: AttendanceEditTimesheetRequestConnection;
  attendanceEmployeesPolicy?: Maybe<AttendanceEmployeesPolicy>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  attendanceEmployeesPolicyId?: Maybe<Scalars['Int']>;
  attendanceEstimatedTimes: Array<AttendanceEstimatedTime>;
  attendanceEstimatedTimesConnection: AttendanceEstimatedTimeConnection;
  attendanceReviewsStats: Array<AttendanceReviewsStat>;
  attendanceReviewsStatsConnection: AttendanceReviewsStatConnection;
  attendanceShifts: Array<AttendanceShift>;
  attendanceShiftsConnection: AttendanceShiftConnection;
  attendanceWorkedBreaks: Array<AttendanceWorkedBreak>;
  attendanceWorkedBreaksConnection: AttendanceWorkedBreakConnection;
  attendanceWorkedTimes: Array<AttendanceWorkedTime>;
  attendanceWorkedTimesConnection: AttendanceWorkedTimeConnection;
  companyId: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  employeeGroupId: Scalars['Int'];
  employeeName?: Maybe<EmployeesEmployeeName>;
  id: Scalars['Int'];
  identifier?: Maybe<Scalars['String']>;
  identifierType?: Maybe<Scalars['String']>;
  locationId: Scalars['Int'];
  managerId?: Maybe<Scalars['Int']>;
  openShift?: Maybe<AttendanceOpenShift>;
  preferredName?: Maybe<Scalars['String']>;
  regularAccessStartsOn?: Maybe<Scalars['ISO8601Date']>;
  terminatedOn?: Maybe<Scalars['ISO8601Date']>;
  timeoffManagerId?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['ISO8601DateTime'];
  yearlyTimeInfo?: Maybe<AttendanceYearlyTimeInfo>;
};


/** Employees inside attendance domain */
export type AttendanceEmployee_PoliciesCollectionArgs = {
  ids: Array<AttendanceEmployeePoliciesEnum>;
};


/** Employees inside attendance domain */
export type AttendanceEmployee_PoliciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Employees inside attendance domain */
export type AttendanceEmployeeAccessArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** Employees inside attendance domain */
export type AttendanceEmployeeAttendanceAggregatedBalanceArgs = {
  endOn: Scalars['ISO8601Date'];
  ids?: InputMaybe<Array<Scalars['String']>>;
  startOn: Scalars['ISO8601Date'];
};


/** Employees inside attendance domain */
export type AttendanceEmployeeAttendanceAggregatedBalanceConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endOn: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startOn: Scalars['ISO8601Date'];
};


/** Employees inside attendance domain */
export type AttendanceEmployeeAttendanceAggregatedWorkedTimeArgs = {
  endOn: Scalars['ISO8601Date'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  startOn: Scalars['ISO8601Date'];
};


/** Employees inside attendance domain */
export type AttendanceEmployeeAttendanceBalancesArgs = {
  disableAccumulation?: Scalars['Boolean'];
  endOn: Scalars['ISO8601Date'];
  ids?: InputMaybe<Array<Scalars['String']>>;
  startOn: Scalars['ISO8601Date'];
};


/** Employees inside attendance domain */
export type AttendanceEmployeeAttendanceBalancesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  disableAccumulation?: Scalars['Boolean'];
  endOn: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startOn: Scalars['ISO8601Date'];
};


/** Employees inside attendance domain */
export type AttendanceEmployeeAttendanceCompensationBlocksArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  endOn: Scalars['ISO8601Date'];
  ids?: InputMaybe<Array<Scalars['String']>>;
  startOn: Scalars['ISO8601Date'];
};


/** Employees inside attendance domain */
export type AttendanceEmployeeAttendanceCompensationBlocksConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
  endOn: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startOn: Scalars['ISO8601Date'];
};


/** Employees inside attendance domain */
export type AttendanceEmployeeAttendanceCompensationsArgs = {
  endOn?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  startOn?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Employees inside attendance domain */
export type AttendanceEmployeeAttendanceCompensationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endOn?: InputMaybe<Scalars['ISO8601Date']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startOn?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Employees inside attendance domain */
export type AttendanceEmployeeAttendanceCyclesArgs = {
  endOn: Scalars['ISO8601Date'];
  startOn: Scalars['ISO8601Date'];
};


/** Employees inside attendance domain */
export type AttendanceEmployeeAttendanceCyclesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endOn: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startOn: Scalars['ISO8601Date'];
};


/** Employees inside attendance domain */
export type AttendanceEmployeeAttendanceEditTimesheetRequestsArgs = {
  attendanceShiftIds?: InputMaybe<Array<Scalars['Int']>>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  date?: InputMaybe<Scalars['String']>;
  endOn?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  pending?: InputMaybe<Scalars['Boolean']>;
  shiftId?: InputMaybe<Scalars['Int']>;
  startOn?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Employees inside attendance domain */
export type AttendanceEmployeeAttendanceEditTimesheetRequestsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  attendanceShiftIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  date?: InputMaybe<Scalars['String']>;
  endOn?: InputMaybe<Scalars['ISO8601Date']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  shiftId?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startOn?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Employees inside attendance domain */
export type AttendanceEmployeeAttendanceEstimatedTimesArgs = {
  endOn: Scalars['ISO8601Date'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeNonAttendableEmployees?: Scalars['Boolean'];
  startOn: Scalars['ISO8601Date'];
};


/** Employees inside attendance domain */
export type AttendanceEmployeeAttendanceEstimatedTimesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endOn: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeNonAttendableEmployees?: Scalars['Boolean'];
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startOn: Scalars['ISO8601Date'];
};


/** Employees inside attendance domain */
export type AttendanceEmployeeAttendanceReviewsStatsArgs = {
  endOn?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  reviewedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  startOn?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Employees inside attendance domain */
export type AttendanceEmployeeAttendanceReviewsStatsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endOn?: InputMaybe<Scalars['ISO8601Date']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  reviewedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  sortOrder?: InputMaybe<Sort>;
  startOn?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Employees inside attendance domain */
export type AttendanceEmployeeAttendanceShiftsArgs = {
  breaksWithTimeConfiguration?: InputMaybe<Scalars['Boolean']>;
  endOn?: InputMaybe<Scalars['ISO8601Date']>;
  halfDay?: Scalars['Boolean'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  lastWorkingShift?: InputMaybe<Scalars['Boolean']>;
  latestShift?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortCreatedAtAsc?: Scalars['Boolean'];
  startOn?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAt?: InputMaybe<Scalars['ISO8601Date']>;
  workable?: InputMaybe<Scalars['Boolean']>;
};


/** Employees inside attendance domain */
export type AttendanceEmployeeAttendanceShiftsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  breaksWithTimeConfiguration?: InputMaybe<Scalars['Boolean']>;
  endOn?: InputMaybe<Scalars['ISO8601Date']>;
  first?: InputMaybe<Scalars['Int']>;
  halfDay?: Scalars['Boolean'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  lastWorkingShift?: InputMaybe<Scalars['Boolean']>;
  latestShift?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortCreatedAtAsc?: Scalars['Boolean'];
  sortOrder?: InputMaybe<Sort>;
  startOn?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAt?: InputMaybe<Scalars['ISO8601Date']>;
  workable?: InputMaybe<Scalars['Boolean']>;
};


/** Employees inside attendance domain */
export type AttendanceEmployeeAttendanceWorkedBreaksArgs = {
  endOn: Scalars['ISO8601Date'];
  paid?: InputMaybe<Scalars['Boolean']>;
  startOn: Scalars['ISO8601Date'];
};


/** Employees inside attendance domain */
export type AttendanceEmployeeAttendanceWorkedBreaksConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endOn: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  paid?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Sort>;
  startOn: Scalars['ISO8601Date'];
};


/** Employees inside attendance domain */
export type AttendanceEmployeeAttendanceWorkedTimesArgs = {
  endOn?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  includeNonAttendableEmployees?: Scalars['Boolean'];
  includeTimeRangeCategory?: Scalars['Boolean'];
  startOn?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Employees inside attendance domain */
export type AttendanceEmployeeAttendanceWorkedTimesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endOn?: InputMaybe<Scalars['ISO8601Date']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  includeNonAttendableEmployees?: Scalars['Boolean'];
  includeTimeRangeCategory?: Scalars['Boolean'];
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startOn?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Employees inside attendance domain */
export type AttendanceEmployeeEmployeeNameArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  afterEmployeeId?: InputMaybe<Scalars['Int']>;
  beforeEmployeeId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  reporteesOrLed?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyId?: InputMaybe<Scalars['Int']>;
  verb?: InputMaybe<Scalars['String']>;
  withActiveContract?: Scalars['Boolean'];
};


/** Employees inside attendance domain */
export type AttendanceEmployeeYearlyTimeInfoArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
  referenceDate: Scalars['ISO8601Date'];
};

/** The connection type for AttendanceEmployee. */
export type AttendanceEmployeeConnection = {
  __typename?: 'AttendanceEmployeeConnection';
  /** A list of edges. */
  edges: Array<AttendanceEmployeeEdge>;
  /** A list of nodes. */
  nodes: Array<AttendanceEmployee>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AttendanceEmployeeEdge = {
  __typename?: 'AttendanceEmployeeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AttendanceEmployee;
};

export type AttendanceEmployeePolicies = {
  __typename?: 'AttendanceEmployeePolicies';
  deleteAttendance: PermissionsPolicyResolution;
  editAttendance: PermissionsPolicyResolution;
  seeAttendance: PermissionsPolicyResolution;
};

export type AttendanceEmployeePoliciesEnum =
  | 'deleteAttendance'
  | 'editAttendance'
  | 'seeAttendance';

/** Employees attendance policies that group employees under a shared configuration */
export type AttendanceEmployeesPolicy = {
  __typename?: 'AttendanceEmployeesPolicy';
  activeEmployeeIds: Array<Scalars['Int']>;
  attendanceEmployeesSettings: Array<AttendanceEmployeesSetting>;
  attendanceEmployeesSettingsConnection: AttendanceEmployeesSettingConnection;
  /** Whether this is the default employees policy applied when employees are first added to attendance. */
  default?: Maybe<Scalars['Boolean']>;
  /** Optional description explaining when to use this employees policy. */
  description?: Maybe<Scalars['String']>;
  employeeIds: Array<Scalars['Int']>;
  /** Whether this policy is currently active and can be assigned to employees. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** Unique identifier of the employees policy. */
  id?: Maybe<Scalars['Int']>;
  /** Human readable name of the employees policy. */
  name: Scalars['String'];
};


/** Employees attendance policies that group employees under a shared configuration */
export type AttendanceEmployeesPolicyAttendanceEmployeesSettingsArgs = {
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  customTimeRangeCategoryIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  employeesPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  endOn?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  ignoreDependencies?: InputMaybe<Scalars['Boolean']>;
  ignoreOvertimePools?: Scalars['Boolean'];
  includesEmployeeIds?: Scalars['Boolean'];
  startOn?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Employees attendance policies that group employees under a shared configuration */
export type AttendanceEmployeesPolicyAttendanceEmployeesSettingsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  customTimeRangeCategoryIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  employeesPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  endOn?: InputMaybe<Scalars['ISO8601Date']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  ignoreDependencies?: InputMaybe<Scalars['Boolean']>;
  ignoreOvertimePools?: Scalars['Boolean'];
  includesEmployeeIds?: Scalars['Boolean'];
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startOn?: InputMaybe<Scalars['ISO8601Date']>;
};

/** The connection type for AttendanceEmployeesPolicy. */
export type AttendanceEmployeesPolicyConnection = {
  __typename?: 'AttendanceEmployeesPolicyConnection';
  /** A list of edges. */
  edges: Array<AttendanceEmployeesPolicyEdge>;
  /** A list of nodes. */
  nodes: Array<AttendanceEmployeesPolicy>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AttendanceEmployeesPolicyEdge = {
  __typename?: 'AttendanceEmployeesPolicyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AttendanceEmployeesPolicy;
};

/** the filter for the employees_policies resource */
export type AttendanceEmployeesPolicyFilter = {
  id?: InputMaybe<IntegerFilter>;
  or?: InputMaybe<Array<AttendanceEmployeesPolicyFilterConditions>>;
};

export type AttendanceEmployeesPolicyFilterConditions = {
  id?: InputMaybe<IntegerFilter>;
};

/** Read, create and update employees attendance policy versions and their effective dates */
export type AttendanceEmployeesSetting = {
  __typename?: 'AttendanceEmployeesSetting';
  allowManualAllocation: Scalars['Boolean'];
  attendanceBreakSetting?: Maybe<AttendanceBreakSetting>;
  attendanceEmployeesPolicy: AttendanceEmployeesPolicy;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  attendanceEmployeesPolicyId?: Maybe<Scalars['Int']>;
  autofillTimesheet: Scalars['Boolean'];
  balanceCarryover?: Maybe<AttendanceBalanceCarryover>;
  balanceCarryoverId?: Maybe<Scalars['Int']>;
  balancePayrollCompensation: Scalars['Boolean'];
  breakSettingId?: Maybe<Scalars['Int']>;
  companyId: Scalars['Int'];
  complementaryHoursBaseline: AttendanceEmployeesSettingComplementaryHoursBaselineEnum;
  customTimeRanges: Array<AttendanceCustomTimeRange>;
  customtimerangesConnection: AttendanceCustomTimeRangeConnection;
  desktopClockin: Scalars['Boolean'];
  editTimesheetAuthorization: Scalars['Boolean'];
  effectiveAt?: Maybe<Scalars['ISO8601Date']>;
  employeeAccessSearchField: AttendanceEmployeesSettingEmployeeAccessSearchFieldEnum;
  employeeIds: Array<Scalars['Int']>;
  enableBreaks: Scalars['Boolean'];
  enableClockInLocation: Scalars['Boolean'];
  enableComplementaryHours: Scalars['Boolean'];
  extraHoursBaseline: AttendanceEmployeesSettingExtraHoursBaselineEnum;
  extraHoursRange: Array<AttendanceExtraHoursRange>;
  extraHoursTransferFrequency: AttendanceEmployeesSettingExtraHoursTransferFrequencyEnum;
  extraTimeCompensationFrequency: AttendanceEnumsOvertimePoolUpdateFrequencyEnum;
  extrahoursrangeConnection: AttendanceExtraHoursRangeConnection;
  faceRecognition: Scalars['Boolean'];
  forgotClockOut: AttendanceEmployeesSettingForgotClockOutOptionEnum;
  forgotClockOutToleranceMinutes: Scalars['Int'];
  geofencing: Scalars['Boolean'];
  geolocation: Scalars['Boolean'];
  geolocationBlock: Scalars['Boolean'];
  id: Scalars['Int'];
  idClockSharedDevice: Scalars['Boolean'];
  missingClockInAlert: Scalars['Boolean'];
  mobileClockin: Scalars['Boolean'];
  overtimeAuthorization: Scalars['Boolean'];
  overtimePools: Array<AttendanceOvertimePool>;
  overtimepoolsConnection: AttendanceOvertimePoolConnection;
  payrollCompensation: Scalars['Boolean'];
  publicToken?: Maybe<Scalars['String']>;
  qrCodeClockin: Scalars['Boolean'];
  specialHoursRegularHoursCompensation: Scalars['Boolean'];
  timeoffCompensation: Scalars['Boolean'];
  toleranceSettingId?: Maybe<Scalars['Int']>;
};


/** Read, create and update employees attendance policy versions and their effective dates */
export type AttendanceEmployeesSettingAttendanceBreakSettingArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Read, create and update employees attendance policy versions and their effective dates */
export type AttendanceEmployeesSettingBalanceCarryoverArgs = {
  attendanceEmployeesSettingId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};


/** Read, create and update employees attendance policy versions and their effective dates */
export type AttendanceEmployeesSettingCustomTimeRangesArgs = {
  attendanceEmployeesSettingId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  timeSettingsCompanyId?: InputMaybe<Scalars['Int']>;
};


/** Read, create and update employees attendance policy versions and their effective dates */
export type AttendanceEmployeesSettingCustomtimerangesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  attendanceEmployeesSettingId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  timeSettingsCompanyId?: InputMaybe<Scalars['Int']>;
};


/** Read, create and update employees attendance policy versions and their effective dates */
export type AttendanceEmployeesSettingExtraHoursRangeArgs = {
  attendanceEmployeesSettingId?: InputMaybe<Scalars['Int']>;
  employeeType?: InputMaybe<AttendanceEnumsEmployeeTypeEnum>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Read, create and update employees attendance policy versions and their effective dates */
export type AttendanceEmployeesSettingExtrahoursrangeConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  attendanceEmployeesSettingId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  employeeType?: InputMaybe<AttendanceEnumsEmployeeTypeEnum>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Read, create and update employees attendance policy versions and their effective dates */
export type AttendanceEmployeesSettingOvertimePoolsArgs = {
  attendanceEmployeesSettingId?: InputMaybe<Scalars['Int']>;
  currentOn?: InputMaybe<Scalars['ISO8601Date']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  employeesPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Read, create and update employees attendance policy versions and their effective dates */
export type AttendanceEmployeesSettingOvertimepoolsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  attendanceEmployeesSettingId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  currentOn?: InputMaybe<Scalars['ISO8601Date']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  employeesPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

export type AttendanceEmployeesSettingComplementaryHoursBaselineEnum =
  | 'contract_hours'
  | 'planned_hours';

/** The connection type for AttendanceEmployeesSetting. */
export type AttendanceEmployeesSettingConnection = {
  __typename?: 'AttendanceEmployeesSettingConnection';
  /** A list of edges. */
  edges: Array<AttendanceEmployeesSettingEdge>;
  /** A list of nodes. */
  nodes: Array<AttendanceEmployeesSetting>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AttendanceEmployeesSettingEdge = {
  __typename?: 'AttendanceEmployeesSettingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AttendanceEmployeesSetting;
};

export type AttendanceEmployeesSettingEmployeeAccessSearchFieldEnum =
  | 'employee_company_identifier'
  | 'personal_identifier';

export type AttendanceEmployeesSettingExtraHoursBaselineEnum =
  | 'contract_hours'
  | 'planned_hours';

export type AttendanceEmployeesSettingExtraHoursTransferFrequencyEnum =
  | 'daily'
  | 'monthly'
  | 'weekly';

export type AttendanceEmployeesSettingForgotClockOutOptionEnum =
  | 'clock_out_reminder'
  | 'disabled'
  | 'missing_clock_out';

/** Employees Settings Events */
export type AttendanceEmployeesSettingsEvent = {
  __typename?: 'AttendanceEmployeesSettingsEvent';
  accessId: Scalars['Int'];
  employeesSettingId: Scalars['Int'];
  eventType: Scalars['String'];
  fullName: Scalars['String'];
  timestamp: Scalars['String'];
};

/** The connection type for AttendanceEmployeesSettingsEvent. */
export type AttendanceEmployeesSettingsEventConnection = {
  __typename?: 'AttendanceEmployeesSettingsEventConnection';
  /** A list of edges. */
  edges: Array<AttendanceEmployeesSettingsEventEdge>;
  /** A list of nodes. */
  nodes: Array<AttendanceEmployeesSettingsEvent>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AttendanceEmployeesSettingsEventEdge = {
  __typename?: 'AttendanceEmployeesSettingsEventEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AttendanceEmployeesSettingsEvent;
};

export type AttendanceEntitiesCompensationBlockCompensationPoolEnum =
  | 'balance'
  | 'payroll'
  | 'timeoff';

export type AttendanceEntitiesCompensationBlockCompensationTypeEnum =
  | 'extra_hours'
  | 'extra_hours_from_bank_of_hours'
  | 'special_hours';

export type AttendanceEntitiesCompensationBlockStatusEnum =
  | 'available'
  | 'compensated'
  | 'pending';

export type AttendanceEnumsBalanceCarryoverResetFrequencyEnum =
  | 'custom_period'
  | 'monthly'
  | 'never'
  | 'weekly'
  | 'yearly';

export type AttendanceEnumsBreakSourceEnum =
  | 'planned_hours'
  | 'rules';

export type AttendanceEnumsBreakViolationsHandlingEnum =
  | 'autofix'
  | 'no_action';

export type AttendanceEnumsDayTypeEnum =
  | 'bank_holiday'
  | 'saturday'
  | 'sunday'
  | 'workday';

export type AttendanceEnumsEmployeeTypeEnum =
  | 'full_time'
  | 'part_time';

export type AttendanceEnumsExtraHoursRangeBaselineEnum =
  | 'contract_hours'
  | 'effective_hours';

export type AttendanceEnumsOvertimePoolNegativeTransfersEnum =
  | 'limited'
  | 'none'
  | 'unlimited';

export type AttendanceEnumsOvertimePoolUpdateFrequencyEnum =
  | 'at_cycle_end'
  | 'daily'
  | 'monthly'
  | 'on_approval'
  | 'weekly'
  | 'yearly';

export type AttendanceEnumsOvertimeRequestStatusEnum =
  | 'approved'
  | 'none'
  | 'pending'
  | 'rejected';

export type AttendanceEnumsPoolTypeEnum =
  | 'balance'
  | 'buffer'
  | 'complementary_buffer'
  | 'discarded'
  | 'payroll'
  | 'timeoff'
  | 'virtual_payroll'
  | 'virtual_timeoff';

export type AttendanceEnumsShiftSourceEnum =
  | 'api'
  | 'desktop'
  | 'face_recognition'
  | 'mobile'
  | 'mobile_geolocation'
  | 'qr_code'
  | 'shared_device'
  | 'system';

export type AttendanceEnumsTimeUnitEnum =
  | 'half_day'
  | 'minute'
  | 'none';

/**
 * Estimated time is used in attendance to know how many time is planned for
 * employee/date to work. From this resource we get the original planned time, how
 * this time has been affected by bank holidays and leaves and the planned shifts
 * and breaks in case there are.
 */
export type AttendanceEstimatedTime = {
  __typename?: 'AttendanceEstimatedTime';
  absencesMinutes: Scalars['Float'];
  breaks: Array<AttendancePlannedBreakBlock>;
  companyId: Scalars['Int'];
  contractMinutes: Scalars['Float'];
  date: Scalars['ISO8601Date'];
  employee: AttendanceEmployee;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  employeeId: Scalars['Int'];
  /** Type of the employee. Could be full time or part time. */
  employeeType: AttendanceEnumsEmployeeTypeEnum;
  estimatedHalfDays: Scalars['Int'];
  /** Amount of minutes the employee has to work without taking into consideration time off leaves and bank holidays. */
  expectedMinutes: Scalars['Float'];
  /** ID to specify the estimation time it includes the employee_id and date */
  id: Scalars['String'];
  /** Amount of minutes the employee has to work. */
  minutes: Scalars['Float'];
  offDays: Array<AttendanceOffDay>;
  /** Amount of overtime minutes the employee has to work (only available with Shift Management). */
  overtimeMinutes: Scalars['Float'];
  overtimeRequestMinutes: Scalars['Float'];
  overtimeRequestStatus: AttendanceEnumsOvertimeRequestStatusEnum;
  overtimeRequestsEnabled: Scalars['Boolean'];
  /** Amount of regular minutes the employee has to work. */
  regularMinutes: Scalars['Float'];
  shifts: Array<TimePlanningEstimatedShift>;
  /** Source of the estimated time. Could be employee's contract, work schedule or shift management. */
  source: AttendanceValueObjectsEstimatedTimeSourcesEnum;
  timeUnit: AttendanceEnumsTimeUnitEnum;
};

/** The connection type for AttendanceEstimatedTime. */
export type AttendanceEstimatedTimeConnection = {
  __typename?: 'AttendanceEstimatedTimeConnection';
  /** A list of edges. */
  edges: Array<AttendanceEstimatedTimeEdge>;
  /** A list of nodes. */
  nodes: Array<AttendanceEstimatedTime>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AttendanceEstimatedTimeEdge = {
  __typename?: 'AttendanceEstimatedTimeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AttendanceEstimatedTime;
};

/** Export */
export type AttendanceExport = {
  __typename?: 'AttendanceExport';
  endOn: Scalars['ISO8601Date'];
  startOn: Scalars['ISO8601Date'];
};

/** Extra hours ranges that define how blocks of extra time are multiplied and to which pool they are sent */
export type AttendanceExtraHoursRange = {
  __typename?: 'AttendanceExtraHoursRange';
  attendanceEmployeesSettingId: Scalars['Int'];
  /** Baseline used for this range, for example effective_hours or contract_hours. */
  baseline?: Maybe<AttendanceEnumsExtraHoursRangeBaselineEnum>;
  default: Scalars['Boolean'];
  /** Employee type this range applies to, such as Full_Time or Part_Time. */
  employeeType: AttendanceEnumsEmployeeTypeEnum;
  equivalentMinutesInCents: Scalars['Int'];
  /** First minute (inclusive) of the extra time tranche where this range starts to apply. */
  fromMinute: Scalars['Int'];
  /** Unique identifier of the extra hours range. */
  id: Scalars['Int'];
  /** Name of the range, usually describing the tranche of extra time or the applied multiplier. */
  name: Scalars['String'];
  /** Pool where extra time from this range is accumulated (for example timeoff, payroll or virtual pools). */
  poolType: AttendanceEnumsPoolTypeEnum;
  rawMinutesInCents: Scalars['Int'];
  timeSettingsCustomTimeRangeCategory?: Maybe<TimeSettingsCustomTimeRangeCategory>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  timeSettingsCustomTimeRangeCategoryId?: Maybe<Scalars['Int']>;
  /** Last minute (inclusive) of the tranche. When null, the range applies to all minutes above from_minute. */
  toMinute?: Maybe<Scalars['Int']>;
  /** Whether this range has no upper limit and can accumulate arbitrary minutes. */
  unlimited: Scalars['Boolean'];
};


/** Extra hours ranges that define how blocks of extra time are multiplied and to which pool they are sent */
export type AttendanceExtraHoursRangeTimeSettingsCustomTimeRangeCategoryArgs = {
  active?: Scalars['Boolean'];
  categoryType?: InputMaybe<TimeSettingsEnumsCategoryTypeEnum>;
  companyId?: InputMaybe<Scalars['Int']>;
  default?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for AttendanceExtraHoursRange. */
export type AttendanceExtraHoursRangeConnection = {
  __typename?: 'AttendanceExtraHoursRangeConnection';
  /** A list of edges. */
  edges: Array<AttendanceExtraHoursRangeEdge>;
  /** A list of nodes. */
  nodes: Array<AttendanceExtraHoursRange>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AttendanceExtraHoursRangeEdge = {
  __typename?: 'AttendanceExtraHoursRangeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AttendanceExtraHoursRange;
};

/** A repository that returns google maps sigend url from a raw url */
export type AttendanceGoogleMapsSignedUrl = {
  __typename?: 'AttendanceGoogleMapsSignedUrl';
  rawUrl: Scalars['String'];
  signedUrl: Scalars['String'];
};

/** The connection type for AttendanceGoogleMapsSignedUrl. */
export type AttendanceGoogleMapsSignedUrlConnection = {
  __typename?: 'AttendanceGoogleMapsSignedUrlConnection';
  /** A list of edges. */
  edges: Array<AttendanceGoogleMapsSignedUrlEdge>;
  /** A list of nodes. */
  nodes: Array<AttendanceGoogleMapsSignedUrl>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AttendanceGoogleMapsSignedUrlEdge = {
  __typename?: 'AttendanceGoogleMapsSignedUrlEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AttendanceGoogleMapsSignedUrl;
};

export type AttendanceGridRoundingBiasEnum =
  | 'balanced'
  | 'company'
  | 'neutral';

/** Read half day shift statistics for an employee in a given year */
export type AttendanceHalfDayShift = {
  __typename?: 'AttendanceHalfDayShift';
  /** Number of half day shifts worked (raw count, divide by 2 for days) */
  halfDayWorked: Scalars['Int'];
  /** Remaining work days (total - worked_days - paid_absences, minimum 0) */
  remainingWorkDays: Scalars['Int'];
  /** Total annual days allowed (fr_jours_par_an from contract) */
  total: Scalars['Int'];
  /** Total paid absence days taken */
  totalPaidAbsences: Scalars['Int'];
};

/** The connection type for AttendanceHalfDayShift. */
export type AttendanceHalfDayShiftConnection = {
  __typename?: 'AttendanceHalfDayShiftConnection';
  /** A list of edges. */
  edges: Array<AttendanceHalfDayShiftEdge>;
  /** A list of nodes. */
  nodes: Array<AttendanceHalfDayShift>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AttendanceHalfDayShiftEdge = {
  __typename?: 'AttendanceHalfDayShiftEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AttendanceHalfDayShift;
};

/** Attendance incident aggregate shift location */
export type AttendanceIncidentAggregateShiftLocation = {
  __typename?: 'AttendanceIncidentAggregateShiftLocation';
  employeeId: Scalars['Int'];
  shiftLocationsCount: Scalars['Int'];
};

/** The connection type for AttendanceIncidentAggregateShiftLocation. */
export type AttendanceIncidentAggregateShiftLocationConnection = {
  __typename?: 'AttendanceIncidentAggregateShiftLocationConnection';
  /** A list of edges. */
  edges: Array<AttendanceIncidentAggregateShiftLocationEdge>;
  /** A list of nodes. */
  nodes: Array<AttendanceIncidentAggregateShiftLocation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AttendanceIncidentAggregateShiftLocationEdge = {
  __typename?: 'AttendanceIncidentAggregateShiftLocationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AttendanceIncidentAggregateShiftLocation;
};

/** Compensation and supplements creation via time domain */
export type AttendanceManualCompensation = {
  __typename?: 'AttendanceManualCompensation';
  errors: Array<AttendanceCompensationResponse>;
  successes: Array<AttendanceCompensationResponse>;
};

/** Email reminder */
export type AttendanceMessage = {
  __typename?: 'AttendanceMessage';
  message: Scalars['String'];
};

export type AttendanceOffDay = {
  __typename?: 'AttendanceOffDay';
  color: Scalars['String'];
  date: Scalars['ISO8601Date'];
  dayType: AttendanceValueObjectsOffDayDayTypeEnum;
  endAt: Scalars['ISO8601DateTime'];
  hoursAmount?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  leaveTypeId?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  startAt: Scalars['ISO8601DateTime'];
  type?: Maybe<AttendanceValueObjectsOffDayOffDayTypeEnum>;
  workable: Scalars['Boolean'];
};

/** Gets current open shift */
export type AttendanceOpenShift = {
  __typename?: 'AttendanceOpenShift';
  /** Indicates if the shift is automatic or not */
  automaticClockIn: Scalars['Boolean'];
  /** Clock in time from the shift. Ignore the date part. */
  clockIn: Scalars['ISO8601DateTime'];
  clockInOffset?: Maybe<Scalars['String']>;
  /** For open shifts, this field is null. */
  clockOut?: Maybe<Scalars['ISO8601DateTime']>;
  /** Date of the open shift. */
  date: Scalars['ISO8601Date'];
  /** Employee identifier from the open shift. */
  employeeId: Scalars['Int'];
  /** Open Shift identifier. */
  id: Scalars['Int'];
  /** String representing the location type of the shift. Examples work_from_home, office, etc. */
  locationType?: Maybe<Scalars['String']>;
  /** Reference date for the shift */
  referenceDate: Scalars['ISO8601Date'];
  /** Status of the shift */
  status: AttendanceShiftStatusEnum;
  timeSettingsBreakConfiguration?: Maybe<TimeSettingsBreakConfiguration>;
  /**
   * If the shift is a break, this field will have the break configuration id.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  timeSettingsBreakConfigurationId?: Maybe<Scalars['Int']>;
  /** Indicates if the shift is a break or a workable shift. */
  workable: Scalars['Boolean'];
  /** Identifier for the workplace assinged to the shift. */
  workplaceId?: Maybe<Scalars['Int']>;
};


/** Gets current open shift */
export type AttendanceOpenShiftTimeSettingsBreakConfigurationArgs = {
  active?: Scalars['Boolean'];
};

/** The connection type for AttendanceOpenShift. */
export type AttendanceOpenShiftConnection = {
  __typename?: 'AttendanceOpenShiftConnection';
  /** A list of edges. */
  edges: Array<AttendanceOpenShiftEdge>;
  /** A list of nodes. */
  nodes: Array<AttendanceOpenShift>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AttendanceOpenShiftEdge = {
  __typename?: 'AttendanceOpenShiftEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AttendanceOpenShift;
};

/** Overtime pools that store accumulated extra time, its capacity and transfer rules */
export type AttendanceOvertimePool = {
  __typename?: 'AttendanceOvertimePool';
  attendanceEmployeesSettingId: Scalars['Int'];
  /** Maximum capacity of the pool expressed in minutes. Ignored when unlimited_capacity is true. */
  capacity: Scalars['Float'];
  /** Unique identifier of the overtime pool. */
  id: Scalars['Int'];
  /** How negative transfers are handled when moving time between pools. */
  negativeTransfers: AttendanceEnumsOvertimePoolNegativeTransfersEnum;
  overflowTargetPoolId?: Maybe<Scalars['Int']>;
  /** Type of pool, for example timeoff, payroll, virtual_timeoff or virtual_payroll. */
  poolType: AttendanceEnumsPoolTypeEnum;
  /** When true, the pool has no capacity limit and can accumulate unlimited minutes. */
  unlimitedCapacity: Scalars['Boolean'];
  /** How often the pool is updated or settled (for example daily, weekly, monthly, yearly, at_cycle_end or on_approval). */
  updateFrequency: AttendanceEnumsOvertimePoolUpdateFrequencyEnum;
};

/** The connection type for AttendanceOvertimePool. */
export type AttendanceOvertimePoolConnection = {
  __typename?: 'AttendanceOvertimePoolConnection';
  /** A list of edges. */
  edges: Array<AttendanceOvertimePoolEdge>;
  /** A list of nodes. */
  nodes: Array<AttendanceOvertimePool>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AttendanceOvertimePoolEdge = {
  __typename?: 'AttendanceOvertimePoolEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AttendanceOvertimePool;
};

export type AttendanceOvertimePools = {
  __typename?: 'AttendanceOvertimePools';
  balance: AttendanceBalanceOvertimePool;
  discarded: AttendanceBalanceOvertimePool;
  payroll: AttendanceBalanceOvertimePool;
  timeoff: AttendanceBalanceOvertimePool;
};

/** Overtime requests */
export type AttendanceOvertimeRequest = {
  __typename?: 'AttendanceOvertimeRequest';
  approver: Scalars['Boolean'];
  approverFullName?: Maybe<Scalars['String']>;
  approverId?: Maybe<Scalars['Int']>;
  authorId: Scalars['Int'];
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  date: Scalars['ISO8601Date'];
  description?: Maybe<Scalars['String']>;
  employeeId: Scalars['Int'];
  hoursAmountInCents: Scalars['Int'];
  id: Scalars['Int'];
  /** Defines if the overtime request can be edited */
  isEditable: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
  status: AttendanceEnumsOvertimeRequestStatusEnum;
};

/** The connection type for AttendanceOvertimeRequest. */
export type AttendanceOvertimeRequestConnection = {
  __typename?: 'AttendanceOvertimeRequestConnection';
  /** A list of edges. */
  edges: Array<AttendanceOvertimeRequestEdge>;
  /** A list of nodes. */
  nodes: Array<AttendanceOvertimeRequest>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AttendanceOvertimeRequestEdge = {
  __typename?: 'AttendanceOvertimeRequestEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AttendanceOvertimeRequest;
};

/** Payroll Compensation */
export type AttendancePayrollCompensation = {
  __typename?: 'AttendancePayrollCompensation';
  attendanceEmployeesSettingId?: Maybe<Scalars['Int']>;
  compensationEnabled: Scalars['Boolean'];
  id: Scalars['String'];
};

/** The connection type for AttendancePayrollCompensation. */
export type AttendancePayrollCompensationConnection = {
  __typename?: 'AttendancePayrollCompensationConnection';
  /** A list of edges. */
  edges: Array<AttendancePayrollCompensationEdge>;
  /** A list of nodes. */
  nodes: Array<AttendancePayrollCompensation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AttendancePayrollCompensationEdge = {
  __typename?: 'AttendancePayrollCompensationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AttendancePayrollCompensation;
};

/** Attendance Periods */
export type AttendancePeriod = {
  __typename?: 'AttendancePeriod';
  employeeId: Scalars['Int'];
  id: Scalars['Int'];
  month: Scalars['Int'];
  state: Scalars['String'];
  year: Scalars['Int'];
};

/** The connection type for AttendancePeriod. */
export type AttendancePeriodConnection = {
  __typename?: 'AttendancePeriodConnection';
  /** A list of edges. */
  edges: Array<AttendancePeriodEdge>;
  /** A list of nodes. */
  nodes: Array<AttendancePeriod>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AttendancePeriodEdge = {
  __typename?: 'AttendancePeriodEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AttendancePeriod;
};

export type AttendancePlannedBreakBlock = {
  __typename?: 'AttendancePlannedBreakBlock';
  breakConfigurationId: Scalars['Int'];
  breakConfigurationName: Scalars['String'];
  breakConfigurationPaid: Scalars['Boolean'];
  breakType: TimePlanningPlannedBreakBreakTypeEnum;
  duration: Scalars['Int'];
  endAt: Scalars['ISO8601DateTime'];
  shiftId?: Maybe<Scalars['Int']>;
  startAt: Scalars['ISO8601DateTime'];
  timezone: Scalars['String'];
};

/** Attendance review is the dates that have been approved in the timesheet. */
export type AttendanceReview = {
  __typename?: 'AttendanceReview';
  /** Author of the review */
  authorId: Scalars['Int'];
  /** Date reviewed */
  date: Scalars['ISO8601Date'];
  /** Employee identifier */
  employeeId: Scalars['Int'];
  id: Scalars['Int'];
  /** Reviewed at (ISO 8601 format string) */
  reviewedAt: Scalars['String'];
};

/** The connection type for AttendanceReview. */
export type AttendanceReviewConnection = {
  __typename?: 'AttendanceReviewConnection';
  /** A list of edges. */
  edges: Array<AttendanceReviewEdge>;
  /** A list of nodes. */
  nodes: Array<AttendanceReview>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AttendanceReviewEdge = {
  __typename?: 'AttendanceReviewEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AttendanceReview;
};

/** Attendance Reviews Stats */
export type AttendanceReviewsStat = {
  __typename?: 'AttendanceReviewsStat';
  approvedDates: Array<Scalars['ISO8601Date']>;
  employee?: Maybe<AttendanceEmployee>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  employeeId: Scalars['Int'];
  id: Scalars['String'];
  state: AttendanceStateResolverStateEnum;
};

/** The connection type for AttendanceReviewsStat. */
export type AttendanceReviewsStatConnection = {
  __typename?: 'AttendanceReviewsStatConnection';
  /** A list of edges. */
  edges: Array<AttendanceReviewsStatEdge>;
  /** A list of nodes. */
  nodes: Array<AttendanceReviewsStat>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AttendanceReviewsStatEdge = {
  __typename?: 'AttendanceReviewsStatEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AttendanceReviewsStat;
};

/** Shift operations */
export type AttendanceShift = {
  __typename?: 'AttendanceShift';
  attendancePeriodId: Scalars['Int'];
  automaticClockIn?: Maybe<Scalars['Boolean']>;
  automaticClockOut?: Maybe<Scalars['Boolean']>;
  /** Time when the employee clocked in */
  clockIn?: Maybe<Scalars['ISO8601DateTime']>;
  clockInOffset?: Maybe<Scalars['String']>;
  /** Clock in time with seconds */
  clockInWithSeconds?: Maybe<Scalars['ISO8601DateTime']>;
  /** Time when the employee clocked out */
  clockOut?: Maybe<Scalars['ISO8601DateTime']>;
  clockOutOffset?: Maybe<Scalars['String']>;
  /** Identifier for the company */
  companyId: Scalars['Int'];
  /** Timestamp when the shift record was created */
  createdAt: Scalars['ISO8601DateTime'];
  crossesMidnight: Scalars['Boolean'];
  /** Date of the shift */
  date: Scalars['ISO8601Date'];
  day: Scalars['Int'];
  editTimesheetRequest: Array<AttendanceEditTimesheetRequest>;
  editTimesheetRequestConnection: AttendanceEditTimesheetRequestConnection;
  employee?: Maybe<AttendanceEmployee>;
  /**
   * Identifier for the employee assigned to the shift
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  employeeId: Scalars['Int'];
  /** Indicates which worked part of the day */
  halfDay?: Maybe<AttendanceShiftHalfDayTypesEnum>;
  /** Unique identifier for the shift */
  id: Scalars['Int'];
  /** Accuracy of the clock-in location */
  inLocationAccuracy?: Maybe<Scalars['Float']>;
  /** Latitude of the clock-in location */
  inLocationLatitude?: Maybe<Scalars['Float']>;
  /** Longitude of the clock-in location */
  inLocationLongitude?: Maybe<Scalars['Float']>;
  /** Source of the clock-in time */
  inSource?: Maybe<Scalars['String']>;
  isOvernight: Scalars['Boolean'];
  /** Type of location for the shift */
  locationType?: Maybe<AttendanceShiftLocationTypeEnum>;
  /** Number in minutes of the shift */
  minutes: Scalars['Int'];
  /** Additional observations about the shift */
  observations?: Maybe<Scalars['String']>;
  /** Accuracy of the clock-out location */
  outLocationAccuracy?: Maybe<Scalars['Float']>;
  /** Latitude of the clock-out location */
  outLocationLatitude?: Maybe<Scalars['Float']>;
  /** Longitude of the clock-out location */
  outLocationLongitude?: Maybe<Scalars['Float']>;
  /** Source of the clock-out time */
  outSource?: Maybe<Scalars['String']>;
  periodId: Scalars['Int'];
  projectManagementTimeRecords: Array<ProjectManagementTimeRecord>;
  projectManagementTimeRecordsConnection: ProjectManagementTimeRecordConnection;
  projectWorkerId?: Maybe<Scalars['Int']>;
  /** Reference date for the shift */
  referenceDate: Scalars['ISO8601Date'];
  shiftLocations: Array<AttendanceShiftLocation>;
  shiftLocationsConnection: AttendanceShiftLocationConnection;
  showPlusOneDay: Scalars['Boolean'];
  subprojectId?: Maybe<Scalars['Int']>;
  timeSettingsBreakConfiguration?: Maybe<TimeSettingsBreakConfiguration>;
  /**
   * Identifier for the break configuration
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  timeSettingsBreakConfigurationId?: Maybe<Scalars['Int']>;
  /** Timestamp when the shift record was updated */
  updatedAt: Scalars['ISO8601DateTime'];
  /** Indicates if the shift is workable */
  workable?: Maybe<Scalars['Boolean']>;
  workplace?: Maybe<LocationsLocation>;
  /**
   * Identifier for the location
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  workplaceId?: Maybe<Scalars['Int']>;
};


/** Shift operations */
export type AttendanceShiftEditTimesheetRequestArgs = {
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  date?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endOn?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  pending?: InputMaybe<Scalars['Boolean']>;
  shiftId?: InputMaybe<Scalars['Int']>;
  startOn?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Shift operations */
export type AttendanceShiftEditTimesheetRequestConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  date?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endOn?: InputMaybe<Scalars['ISO8601Date']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  shiftId?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startOn?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Shift operations */
export type AttendanceShiftProjectManagementTimeRecordsArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  month?: InputMaybe<Scalars['Int']>;
  projectWorkerIds?: InputMaybe<Array<Scalars['Int']>>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  subprojectIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
  year?: InputMaybe<Scalars['Int']>;
};


/** Shift operations */
export type AttendanceShiftProjectManagementTimeRecordsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  month?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  projectWorkerIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  subprojectIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
  year?: InputMaybe<Scalars['Int']>;
};


/** Shift operations */
export type AttendanceShiftShiftLocationsArgs = {
  dateFrom?: InputMaybe<Scalars['ISO8601Date']>;
  dateTo?: InputMaybe<Scalars['ISO8601Date']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  shiftIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Shift operations */
export type AttendanceShiftShiftLocationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  dateFrom?: InputMaybe<Scalars['ISO8601Date']>;
  dateTo?: InputMaybe<Scalars['ISO8601Date']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  shiftIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
};


/** Shift operations */
export type AttendanceShiftTimeSettingsBreakConfigurationArgs = {
  active?: Scalars['Boolean'];
};


/** Shift operations */
export type AttendanceShiftWorkplaceArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  main?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};

/** The connection type for AttendanceShift. */
export type AttendanceShiftConnection = {
  __typename?: 'AttendanceShiftConnection';
  /** A list of edges. */
  edges: Array<AttendanceShiftEdge>;
  /** A list of nodes. */
  nodes: Array<AttendanceShift>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AttendanceShiftEdge = {
  __typename?: 'AttendanceShiftEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AttendanceShift;
};

export type AttendanceShiftEvent = {
  __typename?: 'AttendanceShiftEvent';
  eventType: Scalars['String'];
};

export type AttendanceShiftHalfDayTypesEnum =
  | 'beginning_of_day'
  | 'end_of_day';

export type AttendanceShiftIncidenceShiftActionEnum =
  | 'break_end'
  | 'break_start'
  | 'clock_in'
  | 'clock_out';

/** Attendance shift location */
export type AttendanceShiftLocation = {
  __typename?: 'AttendanceShiftLocation';
  actionTime: Scalars['String'];
  attendanceShiftId: Scalars['Int'];
  date: Scalars['ISO8601Date'];
  employeeLatitude: Scalars['String'];
  employeeLocationAccuracy: Scalars['String'];
  employeeLongitude: Scalars['String'];
  id: Scalars['Int'];
  isIncident: Scalars['Boolean'];
  outOfRadius: Scalars['Boolean'];
  shiftAction: Scalars['String'];
  workplaceLatitude?: Maybe<Scalars['String']>;
  workplaceLongitude?: Maybe<Scalars['String']>;
  workplaceMissingInfo: Scalars['Boolean'];
  workplaceName?: Maybe<Scalars['String']>;
  workplaceRadius: Scalars['String'];
};

/** The connection type for AttendanceShiftLocation. */
export type AttendanceShiftLocationConnection = {
  __typename?: 'AttendanceShiftLocationConnection';
  /** A list of edges. */
  edges: Array<AttendanceShiftLocationEdge>;
  /** A list of nodes. */
  nodes: Array<AttendanceShiftLocation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AttendanceShiftLocationEdge = {
  __typename?: 'AttendanceShiftLocationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AttendanceShiftLocation;
};

export type AttendanceShiftLocationTypeEnum =
  | 'business_trip'
  | 'office'
  | 'work_from_home';

export type AttendanceShiftStatusEnum =
  | 'closed'
  | 'created'
  | 'opened';

/** Attendance shift version history */
export type AttendanceShiftVersionHistory = {
  __typename?: 'AttendanceShiftVersionHistory';
  authorName?: Maybe<Scalars['String']>;
  event: AttendanceShiftEvent;
};

/** The connection type for AttendanceShiftVersionHistory. */
export type AttendanceShiftVersionHistoryConnection = {
  __typename?: 'AttendanceShiftVersionHistoryConnection';
  /** A list of edges. */
  edges: Array<AttendanceShiftVersionHistoryEdge>;
  /** A list of nodes. */
  nodes: Array<AttendanceShiftVersionHistory>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AttendanceShiftVersionHistoryEdge = {
  __typename?: 'AttendanceShiftVersionHistoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AttendanceShiftVersionHistory;
};

export type AttendanceStateResolverStateEnum =
  | 'approved'
  | 'in_progress'
  | 'pending';

export type AttendanceTimeBlock = {
  __typename?: 'AttendanceTimeBlock';
  _uniqueKey?: Maybe<Scalars['String']>;
  equivalentMinutesInCents?: Maybe<Scalars['Int']>;
  minutes?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  rawMinutesInCents?: Maybe<Scalars['Int']>;
  sourcePoolType: AttendanceEnumsPoolTypeEnum;
  timeSettingsCustomTimeRangeCategoryId?: Maybe<Scalars['Int']>;
};

export type AttendanceTimeBlockInput = {
  _uniqueKey?: InputMaybe<Scalars['String']>;
  equivalentMinutesInCents?: InputMaybe<Scalars['Int']>;
  minutes?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  rawMinutesInCents?: InputMaybe<Scalars['Int']>;
  sourcePoolType: AttendanceEnumsPoolTypeEnum;
  timeSettingsCustomTimeRangeCategoryId?: InputMaybe<Scalars['Int']>;
};

export type AttendanceTimeBlockSubscription = {
  __typename?: 'AttendanceTimeBlockSubscription';
  _uniqueKey?: Maybe<Scalars['String']>;
  equivalentMinutesInCents?: Maybe<Scalars['Int']>;
  minutes?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  rawMinutesInCents?: Maybe<Scalars['Int']>;
  sourcePoolType: AttendanceEnumsPoolTypeEnum;
  timeSettingsCustomTimeRangeCategoryId?: Maybe<Scalars['Int']>;
};

/** Tolerance Settings */
export type AttendanceToleranceSetting = {
  __typename?: 'AttendanceToleranceSetting';
  aboveEstimated?: Maybe<Scalars['Int']>;
  attendanceEmployeesSettingId: Scalars['Int'];
  belowEstimated?: Maybe<Scalars['Int']>;
  clockInAfter?: Maybe<Scalars['Int']>;
  clockInBefore?: Maybe<Scalars['Int']>;
  clockInRoundUpEnabled?: Maybe<Scalars['Boolean']>;
  clockInRoundingEnabled: Scalars['Boolean'];
  clockOutAfter?: Maybe<Scalars['Int']>;
  clockOutBefore?: Maybe<Scalars['Int']>;
  clockOutRoundingEnabled: Scalars['Boolean'];
  effectiveAt: Scalars['ISO8601Date'];
  gridRounding: Scalars['Boolean'];
  gridRoundingBias?: Maybe<AttendanceGridRoundingBiasEnum>;
  id?: Maybe<Scalars['Int']>;
  shiftsToleranceEnabled: Scalars['Boolean'];
  toleranceType: Scalars['String'];
  workedHoursRoundingEnabled: Scalars['Boolean'];
  workedHoursToleranceEnabled: Scalars['Boolean'];
};

/** The connection type for AttendanceToleranceSetting. */
export type AttendanceToleranceSettingConnection = {
  __typename?: 'AttendanceToleranceSettingConnection';
  /** A list of edges. */
  edges: Array<AttendanceToleranceSettingEdge>;
  /** A list of nodes. */
  nodes: Array<AttendanceToleranceSetting>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AttendanceToleranceSettingEdge = {
  __typename?: 'AttendanceToleranceSettingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AttendanceToleranceSetting;
};

export type AttendanceValueObjectsCompensationPeriodStatusStatusEnum =
  | 'finished'
  | 'in_progress'
  | 'incompatible_period'
  | 'not_started';

export type AttendanceValueObjectsEstimatedTimeSourcesEnum =
  | 'contract_hours'
  | 'none'
  | 'shift_management'
  | 'work_schedule';

export type AttendanceValueObjectsOffDayDayTypeEnum =
  | 'beggining_of_day'
  | 'beginning_of_day'
  | 'end_of_day'
  | 'full'
  | 'hourly';

export type AttendanceValueObjectsOffDayOffDayTypeEnum =
  | 'bank_holiday'
  | 'leave';

/** Fetch worked time in breaks over a given range and a subset of employees */
export type AttendanceWorkedBreak = {
  __typename?: 'AttendanceWorkedBreak';
  date: Scalars['ISO8601Date'];
  employeeId: Scalars['Int'];
  minutes: Scalars['Int'];
  paid: Scalars['Boolean'];
  timeSettingsBreakConfiguration?: Maybe<TimeSettingsBreakConfiguration>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  timeSettingsBreakConfigurationId?: Maybe<Scalars['Int']>;
  trackedMinutes: Scalars['Int'];
};


/** Fetch worked time in breaks over a given range and a subset of employees */
export type AttendanceWorkedBreakTimeSettingsBreakConfigurationArgs = {
  active?: Scalars['Boolean'];
};

/** The connection type for AttendanceWorkedBreak. */
export type AttendanceWorkedBreakConnection = {
  __typename?: 'AttendanceWorkedBreakConnection';
  /** A list of edges. */
  edges: Array<AttendanceWorkedBreakEdge>;
  /** A list of nodes. */
  nodes: Array<AttendanceWorkedBreak>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AttendanceWorkedBreakEdge = {
  __typename?: 'AttendanceWorkedBreakEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AttendanceWorkedBreak;
};

/** Attendance worked time */
export type AttendanceWorkedTime = {
  __typename?: 'AttendanceWorkedTime';
  /** Approved extra time minutes (only blocks with extra_hour=true and approved=true) */
  approvedExtraTimeMinutes: Scalars['Int'];
  breaksMinutesRounded?: Maybe<Scalars['Int']>;
  companyId: Scalars['Int'];
  date: Scalars['ISO8601Date'];
  dayType: AttendanceEnumsDayTypeEnum;
  /** Total effective worked minutes */
  effectiveWorkedMinutes: Scalars['Int'];
  employee: AttendanceEmployee;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  employeeId: Scalars['Int'];
  extraTimeMinutes: Scalars['Int'];
  /** ID to specify the worked time it includes the employee_id and date */
  id: Scalars['String'];
  minutes: Scalars['Int'];
  multipliedMinutes: Scalars['Int'];
  paidAbsencesMinutes: Scalars['Int'];
  /** Paid breaks minutes */
  paidBreaksMinutes: Scalars['Int'];
  pendingMinutes: Scalars['Int'];
  /** Regular minutes worked */
  regularMinutes: Scalars['Int'];
  timeUnit: AttendanceEnumsTimeUnitEnum;
  toleranceMinutesRounded?: Maybe<Scalars['Int']>;
  trackedMinutes: Scalars['Int'];
  /** Net difference between worked and tracked minutes (positive = added, negative = discarded) */
  trackedMinutesDelta: Scalars['Int'];
  workedTimeBlocks: Array<AttendanceWorkedTimeBlock>;
};

export type AttendanceWorkedTimeBlock = {
  __typename?: 'AttendanceWorkedTimeBlock';
  approved: Scalars['Boolean'];
  complementaryHour: Scalars['Boolean'];
  date: Scalars['ISO8601Date'];
  employeeId: Scalars['Int'];
  equivalentMinutesInCents?: Maybe<Scalars['Int']>;
  extraHour: Scalars['Boolean'];
  inSchedule: Scalars['Boolean'];
  minutes: Scalars['Int'];
  poolType?: Maybe<AttendanceEnumsPoolTypeEnum>;
  rawMinutesInCents?: Maybe<Scalars['Int']>;
  timeRangeCategoryId?: Maybe<Scalars['Int']>;
  timeRangeCategoryName?: Maybe<Scalars['String']>;
  timeSettingsBreakConfigurationId?: Maybe<Scalars['Int']>;
  timeType: TimeSettingsEnumsTimeTypeEnum;
  workable: Scalars['Boolean'];
};

export type AttendanceWorkedTimeBlockInput = {
  approved: Scalars['Boolean'];
  complementaryHour: Scalars['Boolean'];
  date: Scalars['ISO8601Date'];
  employeeId: Scalars['Int'];
  equivalentMinutesInCents?: InputMaybe<Scalars['Int']>;
  extraHour: Scalars['Boolean'];
  inSchedule: Scalars['Boolean'];
  minutes: Scalars['Int'];
  poolType?: InputMaybe<AttendanceEnumsPoolTypeEnum>;
  rawMinutesInCents?: InputMaybe<Scalars['Int']>;
  timeRangeCategoryId?: InputMaybe<Scalars['Int']>;
  timeRangeCategoryName?: InputMaybe<Scalars['String']>;
  timeSettingsBreakConfigurationId?: InputMaybe<Scalars['Int']>;
  timeType: TimeSettingsEnumsTimeTypeEnum;
  workable: Scalars['Boolean'];
};

export type AttendanceWorkedTimeBlockSubscription = {
  __typename?: 'AttendanceWorkedTimeBlockSubscription';
  approved: Scalars['Boolean'];
  complementaryHour: Scalars['Boolean'];
  date: Scalars['ISO8601Date'];
  employeeId: Scalars['Int'];
  equivalentMinutesInCents?: Maybe<Scalars['Int']>;
  extraHour: Scalars['Boolean'];
  inSchedule: Scalars['Boolean'];
  minutes: Scalars['Int'];
  poolType?: Maybe<AttendanceEnumsPoolTypeEnum>;
  rawMinutesInCents?: Maybe<Scalars['Int']>;
  timeRangeCategoryId?: Maybe<Scalars['Int']>;
  timeRangeCategoryName?: Maybe<Scalars['String']>;
  timeSettingsBreakConfigurationId?: Maybe<Scalars['Int']>;
  timeType: TimeSettingsEnumsTimeTypeEnum;
  workable: Scalars['Boolean'];
};

/** The connection type for AttendanceWorkedTime. */
export type AttendanceWorkedTimeConnection = {
  __typename?: 'AttendanceWorkedTimeConnection';
  /** A list of edges. */
  edges: Array<AttendanceWorkedTimeEdge>;
  /** A list of nodes. */
  nodes: Array<AttendanceWorkedTime>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AttendanceWorkedTimeEdge = {
  __typename?: 'AttendanceWorkedTimeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AttendanceWorkedTime;
};

export type AttendanceWorkedTimeInput = {
  breaksMinutesRounded?: InputMaybe<Scalars['Int']>;
  companyId: Scalars['Int'];
  date: Scalars['ISO8601Date'];
  dayType: AttendanceEnumsDayTypeEnum;
  employeeId: Scalars['Int'];
  minutes: Scalars['Int'];
  multipliedMinutes: Scalars['Int'];
  paidAbsencesMinutes: Scalars['Int'];
  pendingMinutes: Scalars['Int'];
  timeUnit: AttendanceEnumsTimeUnitEnum;
  toleranceMinutesRounded?: InputMaybe<Scalars['Int']>;
  trackedMinutes: Scalars['Int'];
  workedTimeBlocks: Array<AttendanceWorkedTimeBlockInput>;
};

export type AttendanceWorkedTimeSubscription = {
  __typename?: 'AttendanceWorkedTimeSubscription';
  approvedExtraTimeMinutes: Scalars['Int'];
  breaksMinutesRounded?: Maybe<Scalars['Int']>;
  companyId: Scalars['Int'];
  date: Scalars['ISO8601Date'];
  dayType: AttendanceEnumsDayTypeEnum;
  effectiveWorkedMinutes: Scalars['Int'];
  employeeId: Scalars['Int'];
  extraTimeMinutes: Scalars['Int'];
  id: Scalars['String'];
  minutes: Scalars['Int'];
  multipliedMinutes: Scalars['Int'];
  paidAbsencesMinutes: Scalars['Int'];
  paidBreaksMinutes: Scalars['Int'];
  pendingMinutes: Scalars['Int'];
  regularMinutes: Scalars['Int'];
  timeUnit: AttendanceEnumsTimeUnitEnum;
  toleranceMinutesRounded?: Maybe<Scalars['Int']>;
  trackedMinutes: Scalars['Int'];
  trackedMinutesDelta: Scalars['Int'];
  workedTimeBlocks: Array<AttendanceWorkedTimeBlockSubscription>;
};

/** Read yearly time info for the given employees */
export type AttendanceYearlyTimeInfo = {
  __typename?: 'AttendanceYearlyTimeInfo';
  /**
   * Employee ID
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  employeeId: Scalars['Int'];
  employees?: Maybe<EmployeesEmployee>;
  /** Unique identifier */
  id: Scalars['String'];
  /** Legal entity cycle end date */
  legalEntityCycleEndDate: Scalars['ISO8601Date'];
  /** Legal entity cycle start date */
  legalEntityCycleStartDate: Scalars['ISO8601Date'];
  /** Recommended hours */
  recommendedHours: Scalars['Int'];
  /** Worked minutes */
  workedMinutes: Scalars['Int'];
};


/** Read yearly time info for the given employees */
export type AttendanceYearlyTimeInfoEmployeesArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for AttendanceYearlyTimeInfo. */
export type AttendanceYearlyTimeInfoConnection = {
  __typename?: 'AttendanceYearlyTimeInfoConnection';
  /** A list of edges. */
  edges: Array<AttendanceYearlyTimeInfoEdge>;
  /** A list of nodes. */
  nodes: Array<AttendanceYearlyTimeInfo>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AttendanceYearlyTimeInfoEdge = {
  __typename?: 'AttendanceYearlyTimeInfoEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AttendanceYearlyTimeInfo;
};

/** Autogenerated return type of Attendance_aggregated_balance_refresh_subscription. */
export type Attendance_Aggregated_Balance_Refresh_SubscriptionPayload = {
  __typename?: 'Attendance_aggregated_balance_refresh_subscriptionPayload';
  aggregatedBalance?: Maybe<Aggregated_Balance_Refresh_Type>;
};

/** Autogenerated return type of Attendance_balance_refresh_subscription. */
export type Attendance_Balance_Refresh_SubscriptionPayload = {
  __typename?: 'Attendance_balance_refresh_subscriptionPayload';
  balance?: Maybe<Balance_Refresh_Type>;
};

/** Autogenerated return type of Attendance_worked_time_refresh_subscription. */
export type Attendance_Worked_Time_Refresh_SubscriptionPayload = {
  __typename?: 'Attendance_worked_time_refresh_subscriptionPayload';
  workedTime?: Maybe<Worked_Time_Refresh_Type>;
};

export type AuditLogContextlessPolicies = {
  __typename?: 'AuditLogContextlessPolicies';
  seeAuditLog: ContextlessPolicyResolution;
};

/** Autogenerated return type of AugmentWithAiOneononesMeeting. */
export type AugmentWithAiOneononesMeetingPayload = {
  __typename?: 'AugmentWithAiOneononesMeetingPayload';
  errors: Array<MutationError>;
  meeting?: Maybe<OneOnOnesMeeting>;
};

/** Authentication-related actions accessible from accesses */
export type AuthenticationAccess = {
  __typename?: 'AuthenticationAccess';
  _policies?: Maybe<AuthenticationAccessPolicies>;
  _policiesCollection?: Maybe<Array<PermissionsPolicyResolution>>;
  _policiesConnection: PermissionsPolicyResolutionConnection;
  id: Scalars['Int'];
  mfaEnabled?: Maybe<Scalars['Boolean']>;
};


/** Authentication-related actions accessible from accesses */
export type AuthenticationAccess_PoliciesCollectionArgs = {
  ids: Array<AuthenticationAccessPoliciesEnum>;
};


/** Authentication-related actions accessible from accesses */
export type AuthenticationAccess_PoliciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for AuthenticationAccess. */
export type AuthenticationAccessConnection = {
  __typename?: 'AuthenticationAccessConnection';
  /** A list of edges. */
  edges: Array<AuthenticationAccessEdge>;
  /** A list of nodes. */
  nodes: Array<AuthenticationAccess>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AuthenticationAccessEdge = {
  __typename?: 'AuthenticationAccessEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AuthenticationAccess;
};

export type AuthenticationAccessPolicies = {
  __typename?: 'AuthenticationAccessPolicies';
  disableMfa: PermissionsPolicyResolution;
};

export type AuthenticationAccessPoliciesEnum =
  | 'disable_mfa';

export type AuthenticationContextlessPolicies = {
  __typename?: 'AuthenticationContextlessPolicies';
  accessCreateExternal: ContextlessPolicyResolution;
  accessEditExternal: ContextlessPolicyResolution;
};

/** Company Owned Domains */
export type AuthenticationDomain = {
  __typename?: 'AuthenticationDomain';
  companyId: Scalars['Int'];
  domainName: Scalars['String'];
  id: Scalars['Int'];
  lastVerifiedAt?: Maybe<Scalars['ISO8601DateTime']>;
  legacy: Scalars['Boolean'];
  status: AuthenticationDomainStatusEnum;
  verificationToken?: Maybe<Scalars['String']>;
};

/** The connection type for AuthenticationDomain. */
export type AuthenticationDomainConnection = {
  __typename?: 'AuthenticationDomainConnection';
  /** A list of edges. */
  edges: Array<AuthenticationDomainEdge>;
  /** A list of nodes. */
  nodes: Array<AuthenticationDomain>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AuthenticationDomainEdge = {
  __typename?: 'AuthenticationDomainEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: AuthenticationDomain;
};

export type AuthenticationDomainStatusEnum =
  | 'missing_token'
  | 'unverified'
  | 'verified';

export type AuthorizationsDataInput = {
  action: BankingValueObjectsAuthorizationActionEnum;
  targetId: Scalars['Int'];
};

/** Autogenerated return type of AuthorizeIntegrationsdatevlaudsOauthToken. */
export type AuthorizeIntegrationsdatevlaudsOauthTokenPayload = {
  __typename?: 'AuthorizeIntegrationsdatevlaudsOauthTokenPayload';
  errors: Array<MutationError>;
  oauthToken?: Maybe<IntegrationsDatevLaudsOauthToken>;
};

/** Autogenerated return type of AutofillAttendanceShift. */
export type AutofillAttendanceShiftPayload = {
  __typename?: 'AutofillAttendanceShiftPayload';
  errors: Array<MutationError>;
  shifts?: Maybe<Array<AttendanceShift>>;
};

export type AutomationsContextlessPolicies = {
  __typename?: 'AutomationsContextlessPolicies';
  manageCustomNotifications: ContextlessPolicyResolution;
};

export type BalancesByPeriodsPeriodsInput = {
  endAt: Scalars['String'];
  startAt: Scalars['String'];
};

/** A repository to retrieve banking accounts */
export type BankingAccount = {
  __typename?: 'BankingAccount';
  accessValidUntil?: Maybe<Scalars['ISO8601Date']>;
  bankAccounts: Array<BankingBankAccount>;
  bankAccountsConnection: BankingBankAccountConnection;
  bankAddress: Scalars['String'];
  companyName: Scalars['String'];
  externalId: Scalars['String'];
  id: Scalars['Int'];
  institution?: Maybe<BankingInstitution>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  institutionId?: Maybe<Scalars['String']>;
  legalEntity: CompaniesLegalEntity;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  legalEntityId: Scalars['Int'];
  onboarding: BankingOnboarding;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  onboardingId: Scalars['Int'];
  payoutBankAccounts: Array<BankingPayoutBankAccount>;
  payoutBankAccountsConnection: BankingPayoutBankAccountConnection;
  provider: BankingValueObjectsProviderEnum;
  providerConfiguration?: Maybe<BankingProviderConfiguration>;
};


/** A repository to retrieve banking accounts */
export type BankingAccountBankAccountsArgs = {
  accountNumberTypes?: InputMaybe<Array<BankingEntitiesBankAccountNumberFormatEnum>>;
  currency?: InputMaybe<Scalars['String']>;
  externalIds?: InputMaybe<Array<Scalars['String']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  providers?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  service?: InputMaybe<BankingProvidersServicesEnumEnum>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


/** A repository to retrieve banking accounts */
export type BankingAccountBankAccountsConnectionArgs = {
  accountNumberTypes?: InputMaybe<Array<BankingEntitiesBankAccountNumberFormatEnum>>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  externalIds?: InputMaybe<Array<Scalars['String']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  providers?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  service?: InputMaybe<BankingProvidersServicesEnumEnum>;
  sortOrder?: InputMaybe<Sort>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


/** A repository to retrieve banking accounts */
export type BankingAccountInstitutionArgs = {
  countries?: InputMaybe<Array<Scalars['String']>>;
  name?: InputMaybe<Scalars['String']>;
};


/** A repository to retrieve banking accounts */
export type BankingAccountLegalEntityArgs = {
  companiesIds?: InputMaybe<Array<Scalars['Int']>>;
  countryIds?: InputMaybe<Array<Scalars['String']>>;
  employeesIds?: InputMaybe<Array<Scalars['Int']>>;
  excludeCountries?: InputMaybe<Array<Scalars['String']>>;
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


/** A repository to retrieve banking accounts */
export type BankingAccountOnboardingArgs = {
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  source?: InputMaybe<BankingValueObjectsOnboardingCreationSourceValueEnum>;
  statuses?: InputMaybe<Array<BankingValueObjectsOnboardingStatusEnum>>;
  swanDocumentsCollectionId?: InputMaybe<Scalars['String']>;
};


/** A repository to retrieve banking accounts */
export type BankingAccountPayoutBankAccountsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** A repository to retrieve banking accounts */
export type BankingAccountPayoutBankAccountsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** A repository to retrieve banking accounts */
export type BankingAccountProviderConfigurationArgs = {
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  service?: InputMaybe<BankingProvidersServicesEnumEnum>;
};

/** The connection type for BankingAccount. */
export type BankingAccountConnection = {
  __typename?: 'BankingAccountConnection';
  /** A list of edges. */
  edges: Array<BankingAccountEdge>;
  /** A list of nodes. */
  nodes: Array<BankingAccount>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type BankingAccountEdge = {
  __typename?: 'BankingAccountEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BankingAccount;
};

/** A banking authorization tells the user if their current authorization with the bank is valid. */
export type BankingAuthorization = {
  __typename?: 'BankingAuthorization';
  authorizationUrl?: Maybe<Scalars['String']>;
  expired: Scalars['Boolean'];
  id: Scalars['String'];
};

/** The connection type for BankingAuthorization. */
export type BankingAuthorizationConnection = {
  __typename?: 'BankingAuthorizationConnection';
  /** A list of edges. */
  edges: Array<BankingAuthorizationEdge>;
  /** A list of nodes. */
  nodes: Array<BankingAuthorization>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type BankingAuthorizationEdge = {
  __typename?: 'BankingAuthorizationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BankingAuthorization;
};

/** Bank Account represent a bank account that can be used to perform transactions, review balances and more. */
export type BankingBankAccount = {
  __typename?: 'BankingBankAccount';
  account: BankingAccount;
  /** Account alias. */
  accountAlias?: Maybe<Scalars['String']>;
  /** Account balance in cents. */
  accountBalanceCents: Scalars['Int'];
  /** Account number. */
  accountNumber: Scalars['String'];
  /** Account number type. */
  accountNumberType: BankingEntitiesBankAccountNumberFormatEnum;
  accountResource?: Maybe<FinanceLedgerAccountResource>;
  /** Available balance in cents. */
  availableBalanceCents: Scalars['Int'];
  bankAccountMembership?: Maybe<BankingBankAccountMembership>;
  /** Bank name. */
  bankName?: Maybe<Scalars['String']>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  bankingAccountId: Scalars['Int'];
  /** Beneficiary name. */
  beneficiaryName?: Maybe<Scalars['String']>;
  /** Bank Identifier Code. */
  bic?: Maybe<Scalars['String']>;
  cardholders: Array<BankingCardholder>;
  cardholdersConnection: BankingCardholderConnection;
  /** Country. */
  country: Scalars['String'];
  /** Currency. */
  currency: Scalars['String'];
  /** External ID for the bank account. */
  externalId: Scalars['String'];
  finishSetupDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** International Bank Account Number. */
  iban?: Maybe<Scalars['String']>;
  /** Factorial unique identifier. */
  id: Scalars['Int'];
  lastSynchronisedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Factorial unique identifier of the legal entity. */
  legalEntityId?: Maybe<Scalars['Int']>;
  lowBalanceThresholdCents: Scalars['Int'];
  /** Pending balance in cents. */
  pendingBalanceCents: Scalars['Int'];
  /** Routing number. */
  routingNumber?: Maybe<Scalars['String']>;
  /** Sort code. */
  sortCode?: Maybe<Scalars['String']>;
  transactions: Array<BankingTransaction>;
  transactionsConnection: BankingTransactionConnection;
  /** Last updated date. */
  updatedAt: Scalars['ISO8601DateTime'];
};


/** Bank Account represent a bank account that can be used to perform transactions, review balances and more. */
export type BankingBankAccountAccountArgs = {
  externalId?: InputMaybe<Scalars['String']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  provider?: InputMaybe<Scalars['String']>;
  providers?: InputMaybe<Array<Scalars['String']>>;
  source?: InputMaybe<BankingValueObjectsOnboardingCreationSourceValueEnum>;
};


/** Bank Account represent a bank account that can be used to perform transactions, review balances and more. */
export type BankingBankAccountAccountResourceArgs = {
  financeAccountIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Bank Account represent a bank account that can be used to perform transactions, review balances and more. */
export type BankingBankAccountBankAccountMembershipArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Bank Account represent a bank account that can be used to perform transactions, review balances and more. */
export type BankingBankAccountCardholdersArgs = {
  creationSource?: InputMaybe<BankingValueObjectsCardCreationSourceEnum>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Bank Account represent a bank account that can be used to perform transactions, review balances and more. */
export type BankingBankAccountCardholdersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  creationSource?: InputMaybe<BankingValueObjectsCardCreationSourceEnum>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Bank Account represent a bank account that can be used to perform transactions, review balances and more. */
export type BankingBankAccountTransactionsArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']>>;
  accounted?: InputMaybe<Scalars['Boolean']>;
  cardPaymentIds?: InputMaybe<Array<Scalars['Int']>>;
  currency?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['ISO8601DateTime']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  incomeTransactions?: InputMaybe<Scalars['Boolean']>;
  outcomeTransactions?: InputMaybe<Scalars['Boolean']>;
  reconciled?: InputMaybe<Scalars['Boolean']>;
  reconciliationStatus?: InputMaybe<BankingValueObjectsReconciliationStatusEnum>;
  status?: InputMaybe<BankingEntitiesTransactionStatusEnum>;
  to?: InputMaybe<Scalars['ISO8601DateTime']>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Bank Account represent a bank account that can be used to perform transactions, review balances and more. */
export type BankingBankAccountTransactionsConnectionArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']>>;
  accounted?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  cardPaymentIds?: InputMaybe<Array<Scalars['Int']>>;
  currency?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['ISO8601DateTime']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  incomeTransactions?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  outcomeTransactions?: InputMaybe<Scalars['Boolean']>;
  reconciled?: InputMaybe<Scalars['Boolean']>;
  reconciliationStatus?: InputMaybe<BankingValueObjectsReconciliationStatusEnum>;
  sortOrder?: InputMaybe<Sort>;
  status?: InputMaybe<BankingEntitiesTransactionStatusEnum>;
  to?: InputMaybe<Scalars['ISO8601DateTime']>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};

/** The connection type for BankingBankAccount. */
export type BankingBankAccountConnection = {
  __typename?: 'BankingBankAccountConnection';
  aggregate?: Maybe<BankingBankAccountsAggregate>;
  /** A list of edges. */
  edges: Array<BankingBankAccountEdge>;
  /** A list of nodes. */
  nodes: Array<BankingBankAccount>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type BankingBankAccountEdge = {
  __typename?: 'BankingBankAccountEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BankingBankAccount;
};

/** the filter for the bank_accounts resource */
export type BankingBankAccountFilter = {
  accountAlias?: InputMaybe<StringFilter>;
  accountBalanceCents?: InputMaybe<IntegerFilter>;
  accountNumber?: InputMaybe<StringFilter>;
  currency?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<BankingBankAccountFilterConditions>>;
};

export type BankingBankAccountFilterConditions = {
  accountAlias?: InputMaybe<StringFilter>;
  accountBalanceCents?: InputMaybe<IntegerFilter>;
  accountNumber?: InputMaybe<StringFilter>;
  currency?: InputMaybe<StringFilter>;
};

/** A repository to retrieve banking bank account memberships */
export type BankingBankAccountMembership = {
  __typename?: 'BankingBankAccountMembership';
  bankAccount: BankingBankAccount;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  bankAccountId: Scalars['Int'];
  companyId: Scalars['Int'];
  id: Scalars['Int'];
  members: Array<PeopleGroupsPeopleGroupMembership>;
  membersConnection: PeopleGroupsPeopleGroupMembershipConnection;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  peopleGroupId: Scalars['Int'];
};


/** A repository to retrieve banking bank account memberships */
export type BankingBankAccountMembershipBankAccountArgs = {
  accountNumberTypes?: InputMaybe<Array<BankingEntitiesBankAccountNumberFormatEnum>>;
  bankingAccountIds?: InputMaybe<Array<Scalars['Int']>>;
  currency?: InputMaybe<Scalars['String']>;
  externalIds?: InputMaybe<Array<Scalars['String']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  providers?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  service?: InputMaybe<BankingProvidersServicesEnumEnum>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


/** A repository to retrieve banking bank account memberships */
export type BankingBankAccountMembershipMembersArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  companyId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** A repository to retrieve banking bank account memberships */
export type BankingBankAccountMembershipMembersConnectionArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for BankingBankAccountMembership. */
export type BankingBankAccountMembershipConnection = {
  __typename?: 'BankingBankAccountMembershipConnection';
  /** A list of edges. */
  edges: Array<BankingBankAccountMembershipEdge>;
  /** A list of nodes. */
  nodes: Array<BankingBankAccountMembership>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type BankingBankAccountMembershipEdge = {
  __typename?: 'BankingBankAccountMembershipEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BankingBankAccountMembership;
};

/** A bank account number like an IBAN, Account number + sort code, etc. */
export type BankingBankAccountNumber = {
  __typename?: 'BankingBankAccountNumber';
  /** Account number */
  accountNumber: Scalars['String'];
  /** Company identifier */
  companyId: Scalars['Int'];
  /** Additional banking information, depending on the selected format. */
  complementaryData?: Maybe<Scalars['String']>;
  /** The format of the account number. */
  format: BankingEntitiesBankAccountNumberFormatEnum;
  /** Employee id. */
  id: Scalars['String'];
};

/** The connection type for BankingBankAccountNumber. */
export type BankingBankAccountNumberConnection = {
  __typename?: 'BankingBankAccountNumberConnection';
  /** A list of edges. */
  edges: Array<BankingBankAccountNumberEdge>;
  /** A list of nodes. */
  nodes: Array<BankingBankAccountNumber>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type BankingBankAccountNumberEdge = {
  __typename?: 'BankingBankAccountNumberEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BankingBankAccountNumber;
};

/** Banking bank_accounts aggregates */
export type BankingBankAccountsAggregate = {
  __typename?: 'BankingBankAccountsAggregate';
  average?: Maybe<BankingBankAccountsConnectionAggregateAverage>;
  count?: Maybe<Scalars['Int']>;
  maximum?: Maybe<BankingBankAccountsConnectionAggregateMaximum>;
  minimum?: Maybe<BankingBankAccountsConnectionAggregateMinimum>;
  sum?: Maybe<BankingBankAccountsConnectionAggregateSum>;
  terms?: Maybe<BankingBankAccountsConnectionAggregateTerms>;
};

export type BankingBankAccountsAggregateTerms = {
  __typename?: 'BankingBankAccountsAggregateTerms';
  average?: Maybe<BankingBankAccountsConnectionAggregateTermsAverageFields>;
  count?: Maybe<Array<Scalars['Int']>>;
  maximum?: Maybe<BankingBankAccountsConnectionAggregateTermsMaximumFields>;
  minimum?: Maybe<BankingBankAccountsConnectionAggregateTermsMinimumFields>;
  sum?: Maybe<BankingBankAccountsConnectionAggregateTermsSumFields>;
  values: Array<Scalars['String']>;
};

/** average function */
export type BankingBankAccountsConnectionAggregateAverage = {
  __typename?: 'BankingBankAccountsConnectionAggregateAverage';
  accountBalanceCents?: Maybe<Scalars['Float']>;
};

/** maximum function */
export type BankingBankAccountsConnectionAggregateMaximum = {
  __typename?: 'BankingBankAccountsConnectionAggregateMaximum';
  accountBalanceCents?: Maybe<Scalars['Int']>;
};

/** minimum function */
export type BankingBankAccountsConnectionAggregateMinimum = {
  __typename?: 'BankingBankAccountsConnectionAggregateMinimum';
  accountBalanceCents?: Maybe<Scalars['Int']>;
};

/** sum function */
export type BankingBankAccountsConnectionAggregateSum = {
  __typename?: 'BankingBankAccountsConnectionAggregateSum';
  accountBalanceCents?: Maybe<Scalars['Int']>;
};

/** terms function */
export type BankingBankAccountsConnectionAggregateTerms = {
  __typename?: 'BankingBankAccountsConnectionAggregateTerms';
  accountAlias?: Maybe<BankingBankAccountsAggregateTerms>;
  accountBalanceCents?: Maybe<BankingBankAccountsAggregateTerms>;
  accountNumber?: Maybe<BankingBankAccountsAggregateTerms>;
  currency?: Maybe<BankingBankAccountsAggregateTerms>;
};

/** average function */
export type BankingBankAccountsConnectionAggregateTermsAverageFields = {
  __typename?: 'BankingBankAccountsConnectionAggregateTermsAVERAGEFields';
  accountBalanceCents?: Maybe<Array<Scalars['Float']>>;
};

/** maximum function */
export type BankingBankAccountsConnectionAggregateTermsMaximumFields = {
  __typename?: 'BankingBankAccountsConnectionAggregateTermsMAXIMUMFields';
  accountBalanceCents?: Maybe<Array<Scalars['Int']>>;
};

/** minimum function */
export type BankingBankAccountsConnectionAggregateTermsMinimumFields = {
  __typename?: 'BankingBankAccountsConnectionAggregateTermsMINIMUMFields';
  accountBalanceCents?: Maybe<Array<Scalars['Int']>>;
};

/** sum function */
export type BankingBankAccountsConnectionAggregateTermsSumFields = {
  __typename?: 'BankingBankAccountsConnectionAggregateTermsSUMFields';
  accountBalanceCents?: Maybe<Array<Scalars['Int']>>;
};

/** A Factorial Card */
export type BankingCard = {
  __typename?: 'BankingCard';
  _policies?: Maybe<BankingCardPolicies>;
  _policiesCollection?: Maybe<Array<PermissionsPolicyResolution>>;
  _policiesConnection: PermissionsPolicyResolutionConnection;
  alias?: Maybe<Scalars['String']>;
  applePayEnabled: Scalars['Boolean'];
  approval?: Maybe<ApprovalsMaterializedApprovalsFlow>;
  bankAccount: BankingBankAccount;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  bankAccountId: Scalars['Int'];
  cardLimit: BankingCardLimit;
  cardPayments: Array<BankingCardPayment>;
  cardPaymentsConnection: BankingCardPaymentConnection;
  cardholder: BankingCardholder;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  cardholderId: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  creationSource: BankingValueObjectsCardCreationSourceEnum;
  description?: Maybe<Scalars['String']>;
  expMonth: Scalars['Int'];
  expYear: Scalars['Int'];
  externalAccountId: Scalars['String'];
  externalId: Scalars['String'];
  fullName: Scalars['String'];
  googlePayEnabled: Scalars['Boolean'];
  id: Scalars['Int'];
  last4?: Maybe<Scalars['String']>;
  ownerId: Scalars['Int'];
  phoneNumber: Scalars['String'];
  primaryAccountIdentifier?: Maybe<Scalars['String']>;
  provider: BankingValueObjectsProviderEnum;
  shipping?: Maybe<BankingCardShipping>;
  softwareSetup?: Maybe<SoftwareManagementSoftwareSetup>;
  status: BankingValueObjectsCardStatusEnum;
  type: BankingValueObjectsCardTypeEnum;
};


/** A Factorial Card */
export type BankingCard_PoliciesCollectionArgs = {
  ids: Array<BankingCardPoliciesEnum>;
};


/** A Factorial Card */
export type BankingCard_PoliciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** A Factorial Card */
export type BankingCardApprovalArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  ownerId?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<ApprovalsMaterializedApprovalFlowStatusEnum>;
};


/** A Factorial Card */
export type BankingCardBankAccountArgs = {
  accountNumberTypes?: InputMaybe<Array<BankingEntitiesBankAccountNumberFormatEnum>>;
  bankingAccountIds?: InputMaybe<Array<Scalars['Int']>>;
  currency?: InputMaybe<Scalars['String']>;
  externalIds?: InputMaybe<Array<Scalars['String']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  providers?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  service?: InputMaybe<BankingProvidersServicesEnumEnum>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


/** A Factorial Card */
export type BankingCardCardPaymentsArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']>>;
  calculatedLabel?: InputMaybe<BankingEntitiesCardPaymentCalculatedLabelEnum>;
  externalIds?: InputMaybe<Array<Scalars['String']>>;
  from?: InputMaybe<Scalars['ISO8601DateTime']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<BankingEntitiesCardPaymentStatusEnum>;
  to?: InputMaybe<Scalars['ISO8601DateTime']>;
};


/** A Factorial Card */
export type BankingCardCardPaymentsConnectionArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']>>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  calculatedLabel?: InputMaybe<BankingEntitiesCardPaymentCalculatedLabelEnum>;
  externalIds?: InputMaybe<Array<Scalars['String']>>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['ISO8601DateTime']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  status?: InputMaybe<BankingEntitiesCardPaymentStatusEnum>;
  to?: InputMaybe<Scalars['ISO8601DateTime']>;
};


/** A Factorial Card */
export type BankingCardCardholderArgs = {
  bankAccountIds?: InputMaybe<Array<Scalars['Int']>>;
  creationSource?: InputMaybe<BankingValueObjectsCardCreationSourceEnum>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** A Factorial Card */
export type BankingCardSoftwareSetupArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  vendorIds?: InputMaybe<Array<Scalars['Int']>>;
  withoutCard?: InputMaybe<Scalars['Boolean']>;
};

export type BankingCardCategoryEnum =
  | 'accommodation'
  | 'airlines'
  | 'car_rental_agencies'
  | 'fuel'
  | 'internet'
  | 'laundry'
  | 'office_supplies'
  | 'other'
  | 'parking'
  | 'passport_visa_fees'
  | 'phone'
  | 'private_transport'
  | 'public_transport'
  | 'rail_travel'
  | 'refreshments'
  | 'restaurants'
  | 'subscriptions'
  | 'taxis'
  | 'tolls'
  | 'training'
  | 'transport';

/** The connection type for BankingCard. */
export type BankingCardConnection = {
  __typename?: 'BankingCardConnection';
  /** A list of edges. */
  edges: Array<BankingCardEdge>;
  /** A list of nodes. */
  nodes: Array<BankingCard>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type BankingCardEdge = {
  __typename?: 'BankingCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BankingCard;
};

/** A secret to retrieve secure card information from our providers */
export type BankingCardEphemeralKey = {
  __typename?: 'BankingCardEphemeralKey';
  associatedObjects: Array<BankingEphemeralKeyAssociatedObject>;
  card: BankingCard;
  created: Scalars['Int'];
  expires: Scalars['Int'];
  id: Scalars['String'];
  livemode: Scalars['Boolean'];
  objectName: Scalars['String'];
  secret: Scalars['String'];
};


/** A secret to retrieve secure card information from our providers */
export type BankingCardEphemeralKeyCardArgs = {
  bankAccountIds?: InputMaybe<Array<Scalars['Int']>>;
  cardholderIds?: InputMaybe<Array<Scalars['Int']>>;
  creationSource?: InputMaybe<BankingValueObjectsCardCreationSourceEnum>;
  last4?: InputMaybe<Scalars['String']>;
  ownerIds?: InputMaybe<Array<Scalars['Int']>>;
  requestedWithoutApprovalFlow?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<BankingValueObjectsCardStatusEnum>;
};

/** the filter for the cards resource */
export type BankingCardFilter = {
  cardholderId?: InputMaybe<IntegerFilter>;
  creationSource?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntegerFilter>;
  or?: InputMaybe<Array<BankingCardFilterConditions>>;
  status?: InputMaybe<StringFilter>;
  type?: InputMaybe<StringFilter>;
};

export type BankingCardFilterConditions = {
  cardholderId?: InputMaybe<IntegerFilter>;
  creationSource?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntegerFilter>;
  status?: InputMaybe<StringFilter>;
  type?: InputMaybe<StringFilter>;
};

/** The limits of a Factorial Card in terms of money spent */
export type BankingCardLimit = {
  __typename?: 'BankingCardLimit';
  _policies?: Maybe<BankingCardLimitPolicies>;
  _policiesCollection?: Maybe<Array<PermissionsPolicyResolution>>;
  _policiesConnection: PermissionsPolicyResolutionConnection;
  card: BankingCard;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  cardId: Scalars['Int'];
  categories?: Maybe<Array<BankingCardCategoryEnum>>;
  categoriesNew: Array<Scalars['String']>;
  currency: Scalars['String'];
  id: Scalars['Int'];
  limitForCurrentPeriod?: Maybe<Scalars['Int']>;
  limitType?: Maybe<BankingCardLimitTypeEnum>;
  ownerId: Scalars['Int'];
  paymentCategories: Array<BankingCardPaymentCategory>;
  paymentcategoriesConnection: BankingCardPaymentCategoryConnection;
  period?: Maybe<BankingCardLimitPeriodEnum>;
  remainingForCurrentPeriod?: Maybe<Scalars['Int']>;
  spentDuringCurrentPeriod: Scalars['Int'];
};


/** The limits of a Factorial Card in terms of money spent */
export type BankingCardLimit_PoliciesCollectionArgs = {
  ids: Array<BankingCardLimitPoliciesEnum>;
};


/** The limits of a Factorial Card in terms of money spent */
export type BankingCardLimit_PoliciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** The limits of a Factorial Card in terms of money spent */
export type BankingCardLimitCardArgs = {
  bankAccountIds?: InputMaybe<Array<Scalars['Int']>>;
  cardholderIds?: InputMaybe<Array<Scalars['Int']>>;
  creationSource?: InputMaybe<BankingValueObjectsCardCreationSourceEnum>;
  last4?: InputMaybe<Scalars['String']>;
  ownerIds?: InputMaybe<Array<Scalars['Int']>>;
  requestedWithoutApprovalFlow?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<BankingValueObjectsCardStatusEnum>;
};


/** The limits of a Factorial Card in terms of money spent */
export type BankingCardLimitPaymentcategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for BankingCardLimit. */
export type BankingCardLimitConnection = {
  __typename?: 'BankingCardLimitConnection';
  /** A list of edges. */
  edges: Array<BankingCardLimitEdge>;
  /** A list of nodes. */
  nodes: Array<BankingCardLimit>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type BankingCardLimitEdge = {
  __typename?: 'BankingCardLimitEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BankingCardLimit;
};

export type BankingCardLimitPeriodEnum =
  | 'daily'
  | 'monthly'
  | 'weekly'
  | 'yearly';

export type BankingCardLimitPolicies = {
  __typename?: 'BankingCardLimitPolicies';
  update: PermissionsPolicyResolution;
};

export type BankingCardLimitPoliciesEnum =
  | 'update';

export type BankingCardLimitTypeEnum =
  | 'allow'
  | 'block';

/** A card payment triggered when the card is used. */
export type BankingCardPayment = {
  __typename?: 'BankingCardPayment';
  /** The amount of the card payment. */
  amountCents: Scalars['Int'];
  /** Whether the card payment was approved. */
  approved: Scalars['Boolean'];
  calculatedLabel: BankingEntitiesCardPaymentCalculatedLabelEnum;
  card: BankingCard;
  /**
   * The ID of the card.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  cardId: Scalars['Int'];
  /** The date and time the card payment was created in factorial */
  createdAt: Scalars['ISO8601DateTime'];
  /** The currency of the card payment. */
  currency: Scalars['String'];
  /** The exchange rate of the card payment. */
  exchangeRate: Scalars['Float'];
  expense?: Maybe<ExpensesExpense>;
  /** The date and time the card payment was created in the external system. */
  externalCreatedAt: Scalars['ISO8601DateTime'];
  externalId: Scalars['String'];
  /** The ID of the card payment. */
  id: Scalars['Int'];
  /** The amount of the merchant. */
  merchantAmountCents: Scalars['Int'];
  merchantCategoryCode?: Maybe<Scalars['String']>;
  /** The currency of the merchant. */
  merchantCurrency: Scalars['String'];
  /** The name of the merchant. */
  merchantName: Scalars['String'];
  /** The reason the card payment was rejected. */
  rejectedReason?: Maybe<BankingEntitiesCardPaymentRejectedReasonEnum>;
  softwarePayment?: Maybe<SoftwareManagementSoftwarePayment>;
  /** The status of the card payment. */
  status: BankingEntitiesCardPaymentStatusEnum;
  transactions: Array<BankingTransaction>;
  transactionsConnection: BankingTransactionConnection;
  /** The type of the card payment. */
  type: BankingEntitiesCardPaymentTypeEnum;
};


/** A card payment triggered when the card is used. */
export type BankingCardPaymentCardArgs = {
  bankAccountIds?: InputMaybe<Array<Scalars['Int']>>;
  cardholderIds?: InputMaybe<Array<Scalars['Int']>>;
  creationSource?: InputMaybe<BankingValueObjectsCardCreationSourceEnum>;
  last4?: InputMaybe<Scalars['String']>;
  ownerIds?: InputMaybe<Array<Scalars['Int']>>;
  requestedWithoutApprovalFlow?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<BankingValueObjectsCardStatusEnum>;
};


/** A card payment triggered when the card is used. */
export type BankingCardPaymentExpenseArgs = {
  bookEntryIds?: InputMaybe<Array<Scalars['Int']>>;
  cardIds?: InputMaybe<Array<Scalars['Int']>>;
  disputeIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  expensesExpensableIds?: InputMaybe<Array<Scalars['Int']>>;
  externalAuthorizationIds?: InputMaybe<Array<Scalars['String']>>;
  from?: InputMaybe<Scalars['ISO8601DateTime']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeAttachments?: Scalars['Boolean'];
  includeManualDrafts?: Scalars['Boolean'];
  includeReimbursableData?: InputMaybe<Scalars['Boolean']>;
  to?: InputMaybe<Scalars['ISO8601DateTime']>;
};


/** A card payment triggered when the card is used. */
export type BankingCardPaymentSoftwarePaymentArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  softwareSetupId?: InputMaybe<Scalars['Int']>;
};


/** A card payment triggered when the card is used. */
export type BankingCardPaymentTransactionsArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']>>;
  accounted?: InputMaybe<Scalars['Boolean']>;
  currency?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['ISO8601DateTime']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  incomeTransactions?: InputMaybe<Scalars['Boolean']>;
  outcomeTransactions?: InputMaybe<Scalars['Boolean']>;
  reconciled?: InputMaybe<Scalars['Boolean']>;
  reconciliationStatus?: InputMaybe<BankingValueObjectsReconciliationStatusEnum>;
  status?: InputMaybe<BankingEntitiesTransactionStatusEnum>;
  to?: InputMaybe<Scalars['ISO8601DateTime']>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


/** A card payment triggered when the card is used. */
export type BankingCardPaymentTransactionsConnectionArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']>>;
  accounted?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['ISO8601DateTime']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  incomeTransactions?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  outcomeTransactions?: InputMaybe<Scalars['Boolean']>;
  reconciled?: InputMaybe<Scalars['Boolean']>;
  reconciliationStatus?: InputMaybe<BankingValueObjectsReconciliationStatusEnum>;
  sortOrder?: InputMaybe<Sort>;
  status?: InputMaybe<BankingEntitiesTransactionStatusEnum>;
  to?: InputMaybe<Scalars['ISO8601DateTime']>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};

/** Represents a card payment category */
export type BankingCardPaymentCategory = {
  __typename?: 'BankingCardPaymentCategory';
  id: Scalars['String'];
  label: Scalars['String'];
};

/** The connection type for BankingCardPaymentCategory. */
export type BankingCardPaymentCategoryConnection = {
  __typename?: 'BankingCardPaymentCategoryConnection';
  /** A list of edges. */
  edges: Array<BankingCardPaymentCategoryEdge>;
  /** A list of nodes. */
  nodes: Array<BankingCardPaymentCategory>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type BankingCardPaymentCategoryEdge = {
  __typename?: 'BankingCardPaymentCategoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BankingCardPaymentCategory;
};

/** The connection type for BankingCardPayment. */
export type BankingCardPaymentConnection = {
  __typename?: 'BankingCardPaymentConnection';
  aggregate?: Maybe<BankingCardPaymentsAggregate>;
  /** A list of edges. */
  edges: Array<BankingCardPaymentEdge>;
  /** A list of nodes. */
  nodes: Array<BankingCardPayment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type BankingCardPaymentEdge = {
  __typename?: 'BankingCardPaymentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BankingCardPayment;
};

/** the filter for the card_payments resource */
export type BankingCardPaymentFilter = {
  amountCents?: InputMaybe<IntegerFilter>;
  calculatedLabel?: InputMaybe<StringFilter>;
  currency?: InputMaybe<StringFilter>;
  externalCreatedAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntegerFilter>;
  merchantAmountCents?: InputMaybe<IntegerFilter>;
  merchantCurrency?: InputMaybe<StringFilter>;
  merchantName?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<BankingCardPaymentFilterConditions>>;
};

export type BankingCardPaymentFilterConditions = {
  amountCents?: InputMaybe<IntegerFilter>;
  calculatedLabel?: InputMaybe<StringFilter>;
  currency?: InputMaybe<StringFilter>;
  externalCreatedAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntegerFilter>;
  merchantAmountCents?: InputMaybe<IntegerFilter>;
  merchantCurrency?: InputMaybe<StringFilter>;
  merchantName?: InputMaybe<StringFilter>;
};

/** Banking card_payments aggregates */
export type BankingCardPaymentsAggregate = {
  __typename?: 'BankingCardPaymentsAggregate';
  average?: Maybe<BankingCardPaymentsConnectionAggregateAverage>;
  count?: Maybe<Scalars['Int']>;
  maximum?: Maybe<BankingCardPaymentsConnectionAggregateMaximum>;
  minimum?: Maybe<BankingCardPaymentsConnectionAggregateMinimum>;
  sum?: Maybe<BankingCardPaymentsConnectionAggregateSum>;
  terms?: Maybe<BankingCardPaymentsConnectionAggregateTerms>;
};

export type BankingCardPaymentsAggregateTerms = {
  __typename?: 'BankingCardPaymentsAggregateTerms';
  average?: Maybe<BankingCardPaymentsConnectionAggregateTermsAverageFields>;
  count?: Maybe<Array<Scalars['Int']>>;
  maximum?: Maybe<BankingCardPaymentsConnectionAggregateTermsMaximumFields>;
  minimum?: Maybe<BankingCardPaymentsConnectionAggregateTermsMinimumFields>;
  sum?: Maybe<BankingCardPaymentsConnectionAggregateTermsSumFields>;
  values: Array<Scalars['String']>;
};

/** average function */
export type BankingCardPaymentsConnectionAggregateAverage = {
  __typename?: 'BankingCardPaymentsConnectionAggregateAverage';
  amountCents?: Maybe<Scalars['Float']>;
  merchantAmountCents?: Maybe<Scalars['Float']>;
};

/** maximum function */
export type BankingCardPaymentsConnectionAggregateMaximum = {
  __typename?: 'BankingCardPaymentsConnectionAggregateMaximum';
  amountCents?: Maybe<Scalars['Int']>;
  merchantAmountCents?: Maybe<Scalars['Int']>;
};

/** minimum function */
export type BankingCardPaymentsConnectionAggregateMinimum = {
  __typename?: 'BankingCardPaymentsConnectionAggregateMinimum';
  amountCents?: Maybe<Scalars['Int']>;
  merchantAmountCents?: Maybe<Scalars['Int']>;
};

/** sum function */
export type BankingCardPaymentsConnectionAggregateSum = {
  __typename?: 'BankingCardPaymentsConnectionAggregateSum';
  amountCents?: Maybe<Scalars['Int']>;
  merchantAmountCents?: Maybe<Scalars['Int']>;
};

/** terms function */
export type BankingCardPaymentsConnectionAggregateTerms = {
  __typename?: 'BankingCardPaymentsConnectionAggregateTerms';
  amountCents?: Maybe<BankingCardPaymentsAggregateTerms>;
  calculatedLabel?: Maybe<BankingCardPaymentsAggregateTerms>;
  currency?: Maybe<BankingCardPaymentsAggregateTerms>;
  externalCreatedAt?: Maybe<BankingCardPaymentsAggregateTerms>;
  merchantAmountCents?: Maybe<BankingCardPaymentsAggregateTerms>;
  merchantCurrency?: Maybe<BankingCardPaymentsAggregateTerms>;
  merchantName?: Maybe<BankingCardPaymentsAggregateTerms>;
};


/** terms function */
export type BankingCardPaymentsConnectionAggregateTermsExternalCreatedAtArgs = {
  period?: InputMaybe<GroupByDateFieldsPeriods>;
};

/** average function */
export type BankingCardPaymentsConnectionAggregateTermsAverageFields = {
  __typename?: 'BankingCardPaymentsConnectionAggregateTermsAVERAGEFields';
  amountCents?: Maybe<Array<Scalars['Float']>>;
  merchantAmountCents?: Maybe<Array<Scalars['Float']>>;
};

/** maximum function */
export type BankingCardPaymentsConnectionAggregateTermsMaximumFields = {
  __typename?: 'BankingCardPaymentsConnectionAggregateTermsMAXIMUMFields';
  amountCents?: Maybe<Array<Scalars['Int']>>;
  merchantAmountCents?: Maybe<Array<Scalars['Int']>>;
};

/** minimum function */
export type BankingCardPaymentsConnectionAggregateTermsMinimumFields = {
  __typename?: 'BankingCardPaymentsConnectionAggregateTermsMINIMUMFields';
  amountCents?: Maybe<Array<Scalars['Int']>>;
  merchantAmountCents?: Maybe<Array<Scalars['Int']>>;
};

/** sum function */
export type BankingCardPaymentsConnectionAggregateTermsSumFields = {
  __typename?: 'BankingCardPaymentsConnectionAggregateTermsSUMFields';
  amountCents?: Maybe<Array<Scalars['Int']>>;
  merchantAmountCents?: Maybe<Array<Scalars['Int']>>;
};

export type BankingCardPolicies = {
  __typename?: 'BankingCardPolicies';
  activate: PermissionsPolicyResolution;
  approve: PermissionsPolicyResolution;
  cancel: PermissionsPolicyResolution;
  changeAlias: PermissionsPolicyResolution;
  createEphemeralKey: PermissionsPolicyResolution;
  deactivate: PermissionsPolicyResolution;
  reactivate: PermissionsPolicyResolution;
  reject: PermissionsPolicyResolution;
};

export type BankingCardPoliciesEnum =
  | 'activate'
  | 'approve'
  | 'cancel'
  | 'change_alias'
  | 'create_ephemeral_key'
  | 'deactivate'
  | 'reactivate'
  | 'reject';

export type BankingCardShipping = {
  __typename?: 'BankingCardShipping';
  address?: Maybe<BankingCardShippingAddress>;
  carrier?: Maybe<Scalars['String']>;
  sentAt?: Maybe<Scalars['ISO8601DateTime']>;
  status?: Maybe<BankingValueObjectsCardShippingStatusEnum>;
  trackingNumber?: Maybe<Scalars['String']>;
  trackingUrl?: Maybe<Scalars['String']>;
};

export type BankingCardShippingAddress = {
  __typename?: 'BankingCardShippingAddress';
  city: Scalars['String'];
  country: Scalars['String'];
  fullName?: Maybe<Scalars['String']>;
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode: Scalars['String'];
  state?: Maybe<Scalars['String']>;
};

/** Cardholders for factorial cards */
export type BankingCardholder = {
  __typename?: 'BankingCardholder';
  _policies?: Maybe<BankingCardholderPolicies>;
  _policiesCollection?: Maybe<Array<PermissionsPolicyResolution>>;
  _policiesConnection: PermissionsPolicyResolutionConnection;
  bankAccountId: Scalars['Int'];
  cards: Array<BankingCard>;
  cardsConnection: BankingCardConnection;
  currency: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  employee?: Maybe<EmployeesEmployeeName>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  employeeId: Scalars['Int'];
  externalId: Scalars['String'];
  id: Scalars['Int'];
  phoneCountryCode?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};


/** Cardholders for factorial cards */
export type BankingCardholder_PoliciesCollectionArgs = {
  ids: Array<BankingCardholderPoliciesEnum>;
};


/** Cardholders for factorial cards */
export type BankingCardholder_PoliciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Cardholders for factorial cards */
export type BankingCardholderCardsArgs = {
  bankAccountIds?: InputMaybe<Array<Scalars['Int']>>;
  creationSource?: InputMaybe<BankingValueObjectsCardCreationSourceEnum>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last4?: InputMaybe<Scalars['String']>;
  ownerIds?: InputMaybe<Array<Scalars['Int']>>;
  requestedWithoutApprovalFlow?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<BankingValueObjectsCardStatusEnum>;
};


/** Cardholders for factorial cards */
export type BankingCardholderCardsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  bankAccountIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  creationSource?: InputMaybe<BankingValueObjectsCardCreationSourceEnum>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  last4?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  ownerIds?: InputMaybe<Array<Scalars['Int']>>;
  requestedWithoutApprovalFlow?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Sort>;
  status?: InputMaybe<BankingValueObjectsCardStatusEnum>;
};


/** Cardholders for factorial cards */
export type BankingCardholderEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  afterEmployeeId?: InputMaybe<Scalars['Int']>;
  beforeEmployeeId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  reporteesOrLed?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyId?: InputMaybe<Scalars['Int']>;
  verb?: InputMaybe<Scalars['String']>;
  withActiveContract?: Scalars['Boolean'];
};

/** The connection type for BankingCardholder. */
export type BankingCardholderConnection = {
  __typename?: 'BankingCardholderConnection';
  /** A list of edges. */
  edges: Array<BankingCardholderEdge>;
  /** A list of nodes. */
  nodes: Array<BankingCardholder>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type BankingCardholderEdge = {
  __typename?: 'BankingCardholderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BankingCardholder;
};

export type BankingCardholderPolicies = {
  __typename?: 'BankingCardholderPolicies';
  changePhone: PermissionsPolicyResolution;
};

export type BankingCardholderPoliciesEnum =
  | 'change_phone';

/** A banking consent is an authorization to execute some action by the user. */
export type BankingConsent = {
  __typename?: 'BankingConsent';
  consentUrl: Scalars['String'];
  externalId: Scalars['String'];
  id: Scalars['Int'];
  purpose: BankingEntitiesConsentPurposeEnum;
  redirectUrl: Scalars['String'];
  status: BankingEntitiesConsentStatusEnum;
};

/** The connection type for BankingConsent. */
export type BankingConsentConnection = {
  __typename?: 'BankingConsentConnection';
  /** A list of edges. */
  edges: Array<BankingConsentEdge>;
  /** A list of nodes. */
  nodes: Array<BankingConsent>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type BankingConsentEdge = {
  __typename?: 'BankingConsentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BankingConsent;
};

export type BankingContextlessPolicies = {
  __typename?: 'BankingContextlessPolicies';
  bankAccountRead: ContextlessPolicyResolution;
  bankAccountsManage: ContextlessPolicyResolution;
  bankAccountsSeeDetailPage: ContextlessPolicyResolution;
  cardPaymentRead: ContextlessPolicyResolution;
  consentChangeStatus: ContextlessPolicyResolution;
  consentRead: ContextlessPolicyResolution;
  paymentManage: ContextlessPolicyResolution;
  payoutBankAccountRead: ContextlessPolicyResolution;
  reconciliationBulkManage: ContextlessPolicyResolution;
  reconciliationRead: ContextlessPolicyResolution;
  reconciliationSuggestionConfirmOrReject: ContextlessPolicyResolution;
  reconciliationsSeeFinancialDocumentsPage: ContextlessPolicyResolution;
  reconciliationsSeeJournalEntriesPage: ContextlessPolicyResolution;
  transactionCategorize: ContextlessPolicyResolution;
  transactionRead: ContextlessPolicyResolution;
};

/** A banking dispute */
export type BankingDispute = {
  __typename?: 'BankingDispute';
  amountCents: Scalars['Int'];
  currency: Scalars['String'];
  disputedTransaction: BankingTransaction;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  disputedTransactionId: Scalars['Int'];
  expense?: Maybe<ExpensesExpense>;
  externalCreatedAt: Scalars['ISO8601DateTime'];
  externalId: Scalars['String'];
  id: Scalars['Int'];
  refundTransaction?: Maybe<BankingTransaction>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  refundTransactionId?: Maybe<Scalars['Int']>;
  status: BankingValueObjectsDisputeStatusEnum;
};


/** A banking dispute */
export type BankingDisputeDisputedTransactionArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']>>;
  accounted?: InputMaybe<Scalars['Boolean']>;
  cardPaymentIds?: InputMaybe<Array<Scalars['Int']>>;
  currency?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['ISO8601DateTime']>;
  incomeTransactions?: InputMaybe<Scalars['Boolean']>;
  outcomeTransactions?: InputMaybe<Scalars['Boolean']>;
  reconciled?: InputMaybe<Scalars['Boolean']>;
  reconciliationStatus?: InputMaybe<BankingValueObjectsReconciliationStatusEnum>;
  status?: InputMaybe<BankingEntitiesTransactionStatusEnum>;
  to?: InputMaybe<Scalars['ISO8601DateTime']>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


/** A banking dispute */
export type BankingDisputeExpenseArgs = {
  bookEntryIds?: InputMaybe<Array<Scalars['Int']>>;
  cardIds?: InputMaybe<Array<Scalars['Int']>>;
  cardPaymentIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  expensesExpensableIds?: InputMaybe<Array<Scalars['Int']>>;
  externalAuthorizationIds?: InputMaybe<Array<Scalars['String']>>;
  from?: InputMaybe<Scalars['ISO8601DateTime']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeAttachments?: Scalars['Boolean'];
  includeManualDrafts?: Scalars['Boolean'];
  includeReimbursableData?: InputMaybe<Scalars['Boolean']>;
  to?: InputMaybe<Scalars['ISO8601DateTime']>;
};


/** A banking dispute */
export type BankingDisputeRefundTransactionArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']>>;
  accounted?: InputMaybe<Scalars['Boolean']>;
  cardPaymentIds?: InputMaybe<Array<Scalars['Int']>>;
  currency?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['ISO8601DateTime']>;
  incomeTransactions?: InputMaybe<Scalars['Boolean']>;
  outcomeTransactions?: InputMaybe<Scalars['Boolean']>;
  reconciled?: InputMaybe<Scalars['Boolean']>;
  reconciliationStatus?: InputMaybe<BankingValueObjectsReconciliationStatusEnum>;
  status?: InputMaybe<BankingEntitiesTransactionStatusEnum>;
  to?: InputMaybe<Scalars['ISO8601DateTime']>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};

/** The connection type for BankingDispute. */
export type BankingDisputeConnection = {
  __typename?: 'BankingDisputeConnection';
  /** A list of edges. */
  edges: Array<BankingDisputeEdge>;
  /** A list of nodes. */
  nodes: Array<BankingDispute>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type BankingDisputeEdge = {
  __typename?: 'BankingDisputeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BankingDispute;
};

export type BankingDtosReconciliationFullExportExportFormatsEnum =
  | 'csv'
  | 'xlsx';

export type BankingEntitiesBankAccountNumberFormatEnum =
  | 'bank_name_and_account_number'
  | 'clabe'
  | 'iban'
  | 'other'
  | 'routing_number_and_account_number'
  | 'sort_code_and_account_number';

export type BankingEntitiesBeneficiariableTypeEnum =
  | 'employee'
  | 'finance_contact';

export type BankingEntitiesCardPaymentCalculatedLabelEnum =
  | 'complete'
  | 'decline'
  | 'refund'
  | 'reverse'
  | 'withhold';

export type BankingEntitiesCardPaymentRejectedReasonEnum =
  | 'account_compliance_disabled'
  | 'account_disabled'
  | 'account_inactive'
  | 'authentication_failed'
  | 'authorization_controls'
  | 'card_active'
  | 'card_canceled'
  | 'card_expired'
  | 'card_inactive'
  | 'cardholder_blocked'
  | 'cardholder_inactive'
  | 'cardholder_verification_required'
  | 'incorrect_cvc'
  | 'incorrect_expiry'
  | 'insecure_authorization_method'
  | 'insufficient_funds'
  | 'not_allowed'
  | 'pin_blocked'
  | 'spending_controls'
  | 'suspected_fraud'
  | 'verification_failed'
  | 'webhook_approved'
  | 'webhook_declined'
  | 'webhook_error'
  | 'webhook_timeout';

export type BankingEntitiesCardPaymentStatusEnum =
  | 'closed'
  | 'pending'
  | 'rejected'
  | 'reversed';

export type BankingEntitiesCardPaymentTypeEnum =
  | 'payment'
  | 'refund';

export type BankingEntitiesConsentPurposeEnum =
  | 'account_membership'
  | 'payment';

export type BankingEntitiesConsentStatusEnum =
  | 'accepted'
  | 'canceled'
  | 'expired'
  | 'init'
  | 'pending';

export type BankingEntitiesPaymentStatusEnum =
  | 'done'
  | 'in_progress'
  | 'init'
  | 'paid'
  | 'partially_paid'
  | 'pending_consent'
  | 'rejected'
  | 'rejected_consent';

export type BankingEntitiesTransactionRejectionReasonEnum =
  | 'card_error'
  | 'creditor_error'
  | 'debtor_error'
  | 'factorial_error'
  | 'provider_error'
  | 'rejected_consent'
  | 'technical_error'
  | 'transfer_error'
  | 'unknown_error';

export type BankingEntitiesTransactionStatusEnum =
  | 'done'
  | 'in_progress'
  | 'init'
  | 'rejected';

export type BankingEntitiesTransactionTypeEnum =
  | 'card_payment'
  | 'card_refund'
  | 'dispute'
  | 'fees'
  | 'incoming'
  | 'incoming_transfer'
  | 'outgoing'
  | 'outgoing_transfer'
  | 'payment'
  | 'payroll'
  | 'topup'
  | 'unknown';

export type BankingEphemeralKeyAssociatedObject = {
  __typename?: 'BankingEphemeralKeyAssociatedObject';
  id: Scalars['String'];
  type: Scalars['String'];
};

export type BankingFile = {
  __typename?: 'BankingFile';
  byteSize: Scalars['Int'];
  contentType?: Maybe<Scalars['String']>;
  filename: Scalars['String'];
  id: Scalars['Int'];
  url?: Maybe<Scalars['String']>;
};

/** A repository to read all the banking institutions available to create an account */
export type BankingInstitution = {
  __typename?: 'BankingInstitution';
  bic: Scalars['String'];
  countries: Array<Scalars['String']>;
  id: Scalars['String'];
  logo: Scalars['String'];
  name: Scalars['String'];
  transactionTotalDays: Scalars['Int'];
};

/** The connection type for BankingInstitution. */
export type BankingInstitutionConnection = {
  __typename?: 'BankingInstitutionConnection';
  /** A list of edges. */
  edges: Array<BankingInstitutionEdge>;
  /** A list of nodes. */
  nodes: Array<BankingInstitution>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type BankingInstitutionEdge = {
  __typename?: 'BankingInstitutionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BankingInstitution;
};

/** A banking onboarding is the process of connecting a user to a banking provider */
export type BankingOnboarding = {
  __typename?: 'BankingOnboarding';
  author?: Maybe<ApiCoreAccess>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  authorAccessId?: Maybe<Scalars['Int']>;
  authorEmployee?: Maybe<EmployeesEmployeeName>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  authorId?: Maybe<Scalars['Int']>;
  creationSource: BankingValueObjectsOnboardingCreationSourceValueEnum;
  deadline?: Maybe<Scalars['ISO8601DateTime']>;
  externalId: Scalars['String'];
  id: Scalars['Int'];
  institution?: Maybe<BankingInstitution>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  institutionId?: Maybe<Scalars['String']>;
  legalEntity: CompaniesLegalEntity;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  legalEntityId: Scalars['Int'];
  onboardingUrl?: Maybe<Scalars['String']>;
  provider: BankingValueObjectsProviderEnum;
  status: BankingValueObjectsOnboardingStatusEnum;
};


/** A banking onboarding is the process of connecting a user to a banking provider */
export type BankingOnboardingAuthorArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** A banking onboarding is the process of connecting a user to a banking provider */
export type BankingOnboardingAuthorEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  afterEmployeeId?: InputMaybe<Scalars['Int']>;
  beforeEmployeeId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  reporteesOrLed?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyId?: InputMaybe<Scalars['Int']>;
  verb?: InputMaybe<Scalars['String']>;
  withActiveContract?: Scalars['Boolean'];
};


/** A banking onboarding is the process of connecting a user to a banking provider */
export type BankingOnboardingInstitutionArgs = {
  countries?: InputMaybe<Array<Scalars['String']>>;
  name?: InputMaybe<Scalars['String']>;
};


/** A banking onboarding is the process of connecting a user to a banking provider */
export type BankingOnboardingLegalEntityArgs = {
  companiesIds?: InputMaybe<Array<Scalars['Int']>>;
  countryIds?: InputMaybe<Array<Scalars['String']>>;
  employeesIds?: InputMaybe<Array<Scalars['Int']>>;
  excludeCountries?: InputMaybe<Array<Scalars['String']>>;
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};

/** The connection type for BankingOnboarding. */
export type BankingOnboardingConnection = {
  __typename?: 'BankingOnboardingConnection';
  /** A list of edges. */
  edges: Array<BankingOnboardingEdge>;
  /** A list of nodes. */
  nodes: Array<BankingOnboarding>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type BankingOnboardingEdge = {
  __typename?: 'BankingOnboardingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BankingOnboarding;
};

/** A banking payment */
export type BankingPayment = {
  __typename?: 'BankingPayment';
  account?: Maybe<BankingBankAccount>;
  amountCents: Scalars['Int'];
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  bankAccountId: Scalars['Int'];
  currency: Scalars['String'];
  date: Scalars['ISO8601DateTime'];
  description?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['ISO8601DateTime']>;
  fullName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  label: Scalars['String'];
  paymentExecutions: Array<BankingPaymentExecution>;
  paymentExecutionsConnection: BankingPaymentExecutionConnection;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  requestedById: Scalars['Int'];
  requester?: Maybe<EmployeesEmployee>;
  status: BankingEntitiesPaymentStatusEnum;
};


/** A banking payment */
export type BankingPaymentAccountArgs = {
  accountNumberTypes?: InputMaybe<Array<BankingEntitiesBankAccountNumberFormatEnum>>;
  bankingAccountIds?: InputMaybe<Array<Scalars['Int']>>;
  currency?: InputMaybe<Scalars['String']>;
  externalIds?: InputMaybe<Array<Scalars['String']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  providers?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  service?: InputMaybe<BankingProvidersServicesEnumEnum>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


/** A banking payment */
export type BankingPaymentPaymentExecutionsArgs = {
  consentIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** A banking payment */
export type BankingPaymentPaymentExecutionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  consentIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** A banking payment */
export type BankingPaymentRequesterArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for BankingPayment. */
export type BankingPaymentConnection = {
  __typename?: 'BankingPaymentConnection';
  aggregate?: Maybe<BankingPaymentsAggregate>;
  /** A list of edges. */
  edges: Array<BankingPaymentEdge>;
  /** A list of nodes. */
  nodes: Array<BankingPayment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type BankingPaymentEdge = {
  __typename?: 'BankingPaymentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BankingPayment;
};

/** A banking payment execution is created when someone executes a payment. */
export type BankingPaymentExecution = {
  __typename?: 'BankingPaymentExecution';
  account: BankingBankAccount;
  amountCents: Scalars['Int'];
  consent?: Maybe<BankingConsent>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  consentId?: Maybe<Scalars['Int']>;
  currency: Scalars['String'];
  date: Scalars['ISO8601DateTime'];
  executedAt?: Maybe<Scalars['ISO8601DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  paidAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  paidById?: Maybe<Scalars['Int']>;
  payer?: Maybe<EmployeesEmployee>;
  payment: BankingPayment;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  paymentId: Scalars['Int'];
  sepaFile?: Maybe<ApiCoreAttachment>;
  sepaGeneratedAt?: Maybe<Scalars['ISO8601Date']>;
  status: BankingEntitiesPaymentStatusEnum;
  transfers: Array<BankingTransfer>;
  transfersConnection: BankingTransferConnection;
};


/** A banking payment execution is created when someone executes a payment. */
export type BankingPaymentExecutionAccountArgs = {
  accountNumberTypes?: InputMaybe<Array<BankingEntitiesBankAccountNumberFormatEnum>>;
  bankingAccountIds?: InputMaybe<Array<Scalars['Int']>>;
  currency?: InputMaybe<Scalars['String']>;
  externalIds?: InputMaybe<Array<Scalars['String']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  providers?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  service?: InputMaybe<BankingProvidersServicesEnumEnum>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


/** A banking payment execution is created when someone executes a payment. */
export type BankingPaymentExecutionPayerArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** A banking payment execution is created when someone executes a payment. */
export type BankingPaymentExecutionPaymentArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']>>;
  currencies?: InputMaybe<Array<Scalars['String']>>;
  dueThisWeek?: InputMaybe<Scalars['Boolean']>;
  onTime?: InputMaybe<Scalars['Boolean']>;
  onlyInit?: InputMaybe<Scalars['Boolean']>;
  overdue?: InputMaybe<Scalars['Boolean']>;
  requestedByIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<BankingEntitiesPaymentStatusEnum>>;
};


/** A banking payment execution is created when someone executes a payment. */
export type BankingPaymentExecutionSepaFileArgs = {
  attachmentName?: InputMaybe<Scalars['String']>;
};


/** A banking payment execution is created when someone executes a payment. */
export type BankingPaymentExecutionTransfersArgs = {
  currencies?: InputMaybe<Array<Scalars['String']>>;
  dueDateRange?: InputMaybe<DateRangeInput>;
  dueThisWeek?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  onTime?: InputMaybe<Scalars['Boolean']>;
  onlyPending?: InputMaybe<Scalars['Boolean']>;
  overdue?: InputMaybe<Scalars['Boolean']>;
  paymentRequestItemIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


/** A banking payment execution is created when someone executes a payment. */
export type BankingPaymentExecutionTransfersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  currencies?: InputMaybe<Array<Scalars['String']>>;
  dueDateRange?: InputMaybe<DateRangeInput>;
  dueThisWeek?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onTime?: InputMaybe<Scalars['Boolean']>;
  onlyPending?: InputMaybe<Scalars['Boolean']>;
  overdue?: InputMaybe<Scalars['Boolean']>;
  paymentRequestItemIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for BankingPaymentExecution. */
export type BankingPaymentExecutionConnection = {
  __typename?: 'BankingPaymentExecutionConnection';
  /** A list of edges. */
  edges: Array<BankingPaymentExecutionEdge>;
  /** A list of nodes. */
  nodes: Array<BankingPaymentExecution>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type BankingPaymentExecutionEdge = {
  __typename?: 'BankingPaymentExecutionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BankingPaymentExecution;
};

/** the filter for the payments resource */
export type BankingPaymentFilter = {
  amountCents?: InputMaybe<IntegerFilter>;
  currency?: InputMaybe<StringFilter>;
  date?: InputMaybe<DateTimeFilter>;
  dueDate?: InputMaybe<DateTimeFilter>;
  label?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<BankingPaymentFilterConditions>>;
  requestedById?: InputMaybe<IntegerFilter>;
  status?: InputMaybe<StringFilter>;
};

export type BankingPaymentFilterConditions = {
  amountCents?: InputMaybe<IntegerFilter>;
  currency?: InputMaybe<StringFilter>;
  date?: InputMaybe<DateTimeFilter>;
  dueDate?: InputMaybe<DateTimeFilter>;
  label?: InputMaybe<StringFilter>;
  requestedById?: InputMaybe<IntegerFilter>;
  status?: InputMaybe<StringFilter>;
};

/** A banking payment request */
export type BankingPaymentRequest = {
  __typename?: 'BankingPaymentRequest';
  amountCents: Scalars['Int'];
  companyId: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  currency: Scalars['String'];
  dueDate: Scalars['ISO8601DateTime'];
  id: Scalars['Int'];
  label: Scalars['String'];
  lineItems: Array<BankingPaymentRequestItem>;
  lineItemsConnection: BankingPaymentRequestItemConnection;
  requester: EmployeesEmployee;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  requesterId: Scalars['Int'];
  status: BankingValueObjectsPaymentRequestStatusEnum;
};


/** A banking payment request */
export type BankingPaymentRequestLineItemsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** A banking payment request */
export type BankingPaymentRequestLineItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** A banking payment request */
export type BankingPaymentRequestRequesterArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for BankingPaymentRequest. */
export type BankingPaymentRequestConnection = {
  __typename?: 'BankingPaymentRequestConnection';
  aggregate?: Maybe<BankingPaymentRequestsAggregate>;
  /** A list of edges. */
  edges: Array<BankingPaymentRequestEdge>;
  /** A list of nodes. */
  nodes: Array<BankingPaymentRequest>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type BankingPaymentRequestEdge = {
  __typename?: 'BankingPaymentRequestEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BankingPaymentRequest;
};

/** the filter for the payment_requests resource */
export type BankingPaymentRequestFilter = {
  amountCents?: InputMaybe<IntegerFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<StringFilter>;
  dueDate?: InputMaybe<DateTimeFilter>;
  label?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<BankingPaymentRequestFilterConditions>>;
  requesterId?: InputMaybe<IntegerFilter>;
  status?: InputMaybe<StringFilter>;
};

export type BankingPaymentRequestFilterConditions = {
  amountCents?: InputMaybe<IntegerFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<StringFilter>;
  dueDate?: InputMaybe<DateTimeFilter>;
  label?: InputMaybe<StringFilter>;
  requesterId?: InputMaybe<IntegerFilter>;
  status?: InputMaybe<StringFilter>;
};

/** A banking payment request item */
export type BankingPaymentRequestItem = {
  __typename?: 'BankingPaymentRequestItem';
  amountCents: Scalars['Int'];
  bankingBeneficiaryId: Scalars['Int'];
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  bankingPaymentRequestId: Scalars['Int'];
  beneficiaryAccountNumber: Scalars['String'];
  beneficiaryName: Scalars['String'];
  companyId: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['Int'];
  paymentRequest: BankingPaymentRequest;
  sourceId: Scalars['Int'];
  sourceType: BankingValueObjectsPaymentRequestSourceTypeEnum;
  status: BankingValueObjectsPaymentRequestItemStatusEnum;
  transfers: Array<BankingTransfer>;
  transfersConnection: BankingTransferConnection;
};


/** A banking payment request item */
export type BankingPaymentRequestItemPaymentRequestArgs = {
  requesterIds?: InputMaybe<Array<Scalars['Int']>>;
  statuses?: InputMaybe<Array<BankingValueObjectsPaymentRequestStatusEnum>>;
};


/** A banking payment request item */
export type BankingPaymentRequestItemTransfersArgs = {
  currencies?: InputMaybe<Array<Scalars['String']>>;
  dueDateRange?: InputMaybe<DateRangeInput>;
  dueThisWeek?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  onTime?: InputMaybe<Scalars['Boolean']>;
  onlyPending?: InputMaybe<Scalars['Boolean']>;
  overdue?: InputMaybe<Scalars['Boolean']>;
  paymentExecutionIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


/** A banking payment request item */
export type BankingPaymentRequestItemTransfersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  currencies?: InputMaybe<Array<Scalars['String']>>;
  dueDateRange?: InputMaybe<DateRangeInput>;
  dueThisWeek?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onTime?: InputMaybe<Scalars['Boolean']>;
  onlyPending?: InputMaybe<Scalars['Boolean']>;
  overdue?: InputMaybe<Scalars['Boolean']>;
  paymentExecutionIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for BankingPaymentRequestItem. */
export type BankingPaymentRequestItemConnection = {
  __typename?: 'BankingPaymentRequestItemConnection';
  aggregate?: Maybe<BankingPaymentRequestItemsAggregate>;
  /** A list of edges. */
  edges: Array<BankingPaymentRequestItemEdge>;
  /** A list of nodes. */
  nodes: Array<BankingPaymentRequestItem>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type BankingPaymentRequestItemEdge = {
  __typename?: 'BankingPaymentRequestItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BankingPaymentRequestItem;
};

/** the filter for the payment_request_items resource */
export type BankingPaymentRequestItemFilter = {
  amountCents?: InputMaybe<IntegerFilter>;
  bankingPaymentRequestId?: InputMaybe<IntegerFilter>;
  beneficiaryAccountNumber?: InputMaybe<StringFilter>;
  beneficiaryName?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  or?: InputMaybe<Array<BankingPaymentRequestItemFilterConditions>>;
  sourceId?: InputMaybe<IntegerFilter>;
  sourceType?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
};

export type BankingPaymentRequestItemFilterConditions = {
  amountCents?: InputMaybe<IntegerFilter>;
  bankingPaymentRequestId?: InputMaybe<IntegerFilter>;
  beneficiaryAccountNumber?: InputMaybe<StringFilter>;
  beneficiaryName?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  sourceId?: InputMaybe<IntegerFilter>;
  sourceType?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
};

/** Banking payment_request_items aggregates */
export type BankingPaymentRequestItemsAggregate = {
  __typename?: 'BankingPaymentRequestItemsAggregate';
  average?: Maybe<BankingPaymentRequestItemsConnectionAggregateAverage>;
  count?: Maybe<Scalars['Int']>;
  maximum?: Maybe<BankingPaymentRequestItemsConnectionAggregateMaximum>;
  minimum?: Maybe<BankingPaymentRequestItemsConnectionAggregateMinimum>;
  sum?: Maybe<BankingPaymentRequestItemsConnectionAggregateSum>;
  terms?: Maybe<BankingPaymentRequestItemsConnectionAggregateTerms>;
};

export type BankingPaymentRequestItemsAggregateTerms = {
  __typename?: 'BankingPaymentRequestItemsAggregateTerms';
  average?: Maybe<BankingPaymentRequestItemsConnectionAggregateTermsAverageFields>;
  count?: Maybe<Array<Scalars['Int']>>;
  maximum?: Maybe<BankingPaymentRequestItemsConnectionAggregateTermsMaximumFields>;
  minimum?: Maybe<BankingPaymentRequestItemsConnectionAggregateTermsMinimumFields>;
  sum?: Maybe<BankingPaymentRequestItemsConnectionAggregateTermsSumFields>;
  values: Array<Scalars['String']>;
};

/** average function */
export type BankingPaymentRequestItemsConnectionAggregateAverage = {
  __typename?: 'BankingPaymentRequestItemsConnectionAggregateAverage';
  amountCents?: Maybe<Scalars['Float']>;
};

/** maximum function */
export type BankingPaymentRequestItemsConnectionAggregateMaximum = {
  __typename?: 'BankingPaymentRequestItemsConnectionAggregateMaximum';
  amountCents?: Maybe<Scalars['Int']>;
};

/** minimum function */
export type BankingPaymentRequestItemsConnectionAggregateMinimum = {
  __typename?: 'BankingPaymentRequestItemsConnectionAggregateMinimum';
  amountCents?: Maybe<Scalars['Int']>;
};

/** sum function */
export type BankingPaymentRequestItemsConnectionAggregateSum = {
  __typename?: 'BankingPaymentRequestItemsConnectionAggregateSum';
  amountCents?: Maybe<Scalars['Int']>;
};

/** terms function */
export type BankingPaymentRequestItemsConnectionAggregateTerms = {
  __typename?: 'BankingPaymentRequestItemsConnectionAggregateTerms';
  amountCents?: Maybe<BankingPaymentRequestItemsAggregateTerms>;
  bankingPaymentRequestId?: Maybe<BankingPaymentRequestItemsAggregateTerms>;
  beneficiaryAccountNumber?: Maybe<BankingPaymentRequestItemsAggregateTerms>;
  beneficiaryName?: Maybe<BankingPaymentRequestItemsAggregateTerms>;
  createdAt?: Maybe<BankingPaymentRequestItemsAggregateTerms>;
  sourceId?: Maybe<BankingPaymentRequestItemsAggregateTerms>;
  sourceType?: Maybe<BankingPaymentRequestItemsAggregateTerms>;
  status?: Maybe<BankingPaymentRequestItemsAggregateTerms>;
};


/** terms function */
export type BankingPaymentRequestItemsConnectionAggregateTermsCreatedAtArgs = {
  period?: InputMaybe<GroupByDateFieldsPeriods>;
};

/** average function */
export type BankingPaymentRequestItemsConnectionAggregateTermsAverageFields = {
  __typename?: 'BankingPaymentRequestItemsConnectionAggregateTermsAVERAGEFields';
  amountCents?: Maybe<Array<Scalars['Float']>>;
};

/** maximum function */
export type BankingPaymentRequestItemsConnectionAggregateTermsMaximumFields = {
  __typename?: 'BankingPaymentRequestItemsConnectionAggregateTermsMAXIMUMFields';
  amountCents?: Maybe<Array<Scalars['Int']>>;
};

/** minimum function */
export type BankingPaymentRequestItemsConnectionAggregateTermsMinimumFields = {
  __typename?: 'BankingPaymentRequestItemsConnectionAggregateTermsMINIMUMFields';
  amountCents?: Maybe<Array<Scalars['Int']>>;
};

/** sum function */
export type BankingPaymentRequestItemsConnectionAggregateTermsSumFields = {
  __typename?: 'BankingPaymentRequestItemsConnectionAggregateTermsSUMFields';
  amountCents?: Maybe<Array<Scalars['Int']>>;
};

/** Banking payment_requests aggregates */
export type BankingPaymentRequestsAggregate = {
  __typename?: 'BankingPaymentRequestsAggregate';
  average?: Maybe<BankingPaymentRequestsConnectionAggregateAverage>;
  count?: Maybe<Scalars['Int']>;
  maximum?: Maybe<BankingPaymentRequestsConnectionAggregateMaximum>;
  minimum?: Maybe<BankingPaymentRequestsConnectionAggregateMinimum>;
  sum?: Maybe<BankingPaymentRequestsConnectionAggregateSum>;
  terms?: Maybe<BankingPaymentRequestsConnectionAggregateTerms>;
};

export type BankingPaymentRequestsAggregateTerms = {
  __typename?: 'BankingPaymentRequestsAggregateTerms';
  average?: Maybe<BankingPaymentRequestsConnectionAggregateTermsAverageFields>;
  count?: Maybe<Array<Scalars['Int']>>;
  maximum?: Maybe<BankingPaymentRequestsConnectionAggregateTermsMaximumFields>;
  minimum?: Maybe<BankingPaymentRequestsConnectionAggregateTermsMinimumFields>;
  sum?: Maybe<BankingPaymentRequestsConnectionAggregateTermsSumFields>;
  values: Array<Scalars['String']>;
};

/** average function */
export type BankingPaymentRequestsConnectionAggregateAverage = {
  __typename?: 'BankingPaymentRequestsConnectionAggregateAverage';
  amountCents?: Maybe<Scalars['Float']>;
};

/** maximum function */
export type BankingPaymentRequestsConnectionAggregateMaximum = {
  __typename?: 'BankingPaymentRequestsConnectionAggregateMaximum';
  amountCents?: Maybe<Scalars['Int']>;
};

/** minimum function */
export type BankingPaymentRequestsConnectionAggregateMinimum = {
  __typename?: 'BankingPaymentRequestsConnectionAggregateMinimum';
  amountCents?: Maybe<Scalars['Int']>;
};

/** sum function */
export type BankingPaymentRequestsConnectionAggregateSum = {
  __typename?: 'BankingPaymentRequestsConnectionAggregateSum';
  amountCents?: Maybe<Scalars['Int']>;
};

/** terms function */
export type BankingPaymentRequestsConnectionAggregateTerms = {
  __typename?: 'BankingPaymentRequestsConnectionAggregateTerms';
  amountCents?: Maybe<BankingPaymentRequestsAggregateTerms>;
  createdAt?: Maybe<BankingPaymentRequestsAggregateTerms>;
  currency?: Maybe<BankingPaymentRequestsAggregateTerms>;
  dueDate?: Maybe<BankingPaymentRequestsAggregateTerms>;
  label?: Maybe<BankingPaymentRequestsAggregateTerms>;
  requesterId?: Maybe<BankingPaymentRequestsAggregateTerms>;
  status?: Maybe<BankingPaymentRequestsAggregateTerms>;
};


/** terms function */
export type BankingPaymentRequestsConnectionAggregateTermsCreatedAtArgs = {
  period?: InputMaybe<GroupByDateFieldsPeriods>;
};


/** terms function */
export type BankingPaymentRequestsConnectionAggregateTermsDueDateArgs = {
  period?: InputMaybe<GroupByDateFieldsPeriods>;
};

/** average function */
export type BankingPaymentRequestsConnectionAggregateTermsAverageFields = {
  __typename?: 'BankingPaymentRequestsConnectionAggregateTermsAVERAGEFields';
  amountCents?: Maybe<Array<Scalars['Float']>>;
};

/** maximum function */
export type BankingPaymentRequestsConnectionAggregateTermsMaximumFields = {
  __typename?: 'BankingPaymentRequestsConnectionAggregateTermsMAXIMUMFields';
  amountCents?: Maybe<Array<Scalars['Int']>>;
};

/** minimum function */
export type BankingPaymentRequestsConnectionAggregateTermsMinimumFields = {
  __typename?: 'BankingPaymentRequestsConnectionAggregateTermsMINIMUMFields';
  amountCents?: Maybe<Array<Scalars['Int']>>;
};

/** sum function */
export type BankingPaymentRequestsConnectionAggregateTermsSumFields = {
  __typename?: 'BankingPaymentRequestsConnectionAggregateTermsSUMFields';
  amountCents?: Maybe<Array<Scalars['Int']>>;
};

/** Banking payments aggregates */
export type BankingPaymentsAggregate = {
  __typename?: 'BankingPaymentsAggregate';
  average?: Maybe<BankingPaymentsConnectionAggregateAverage>;
  count?: Maybe<Scalars['Int']>;
  maximum?: Maybe<BankingPaymentsConnectionAggregateMaximum>;
  minimum?: Maybe<BankingPaymentsConnectionAggregateMinimum>;
  sum?: Maybe<BankingPaymentsConnectionAggregateSum>;
  terms?: Maybe<BankingPaymentsConnectionAggregateTerms>;
};

export type BankingPaymentsAggregateTerms = {
  __typename?: 'BankingPaymentsAggregateTerms';
  average?: Maybe<BankingPaymentsConnectionAggregateTermsAverageFields>;
  count?: Maybe<Array<Scalars['Int']>>;
  maximum?: Maybe<BankingPaymentsConnectionAggregateTermsMaximumFields>;
  minimum?: Maybe<BankingPaymentsConnectionAggregateTermsMinimumFields>;
  sum?: Maybe<BankingPaymentsConnectionAggregateTermsSumFields>;
  values: Array<Scalars['String']>;
};

/** average function */
export type BankingPaymentsConnectionAggregateAverage = {
  __typename?: 'BankingPaymentsConnectionAggregateAverage';
  amountCents?: Maybe<Scalars['Float']>;
};

/** maximum function */
export type BankingPaymentsConnectionAggregateMaximum = {
  __typename?: 'BankingPaymentsConnectionAggregateMaximum';
  amountCents?: Maybe<Scalars['Int']>;
};

/** minimum function */
export type BankingPaymentsConnectionAggregateMinimum = {
  __typename?: 'BankingPaymentsConnectionAggregateMinimum';
  amountCents?: Maybe<Scalars['Int']>;
};

/** sum function */
export type BankingPaymentsConnectionAggregateSum = {
  __typename?: 'BankingPaymentsConnectionAggregateSum';
  amountCents?: Maybe<Scalars['Int']>;
};

/** terms function */
export type BankingPaymentsConnectionAggregateTerms = {
  __typename?: 'BankingPaymentsConnectionAggregateTerms';
  amountCents?: Maybe<BankingPaymentsAggregateTerms>;
  currency?: Maybe<BankingPaymentsAggregateTerms>;
  date?: Maybe<BankingPaymentsAggregateTerms>;
  dueDate?: Maybe<BankingPaymentsAggregateTerms>;
  fullName?: Maybe<BankingPaymentsAggregateTerms>;
  label?: Maybe<BankingPaymentsAggregateTerms>;
  requestedById?: Maybe<BankingPaymentsAggregateTerms>;
  status?: Maybe<BankingPaymentsAggregateTerms>;
};


/** terms function */
export type BankingPaymentsConnectionAggregateTermsDateArgs = {
  period?: InputMaybe<GroupByDateFieldsPeriods>;
};


/** terms function */
export type BankingPaymentsConnectionAggregateTermsDueDateArgs = {
  period?: InputMaybe<GroupByDateFieldsPeriods>;
};

/** average function */
export type BankingPaymentsConnectionAggregateTermsAverageFields = {
  __typename?: 'BankingPaymentsConnectionAggregateTermsAVERAGEFields';
  amountCents?: Maybe<Array<Scalars['Float']>>;
};

/** maximum function */
export type BankingPaymentsConnectionAggregateTermsMaximumFields = {
  __typename?: 'BankingPaymentsConnectionAggregateTermsMAXIMUMFields';
  amountCents?: Maybe<Array<Scalars['Int']>>;
};

/** minimum function */
export type BankingPaymentsConnectionAggregateTermsMinimumFields = {
  __typename?: 'BankingPaymentsConnectionAggregateTermsMINIMUMFields';
  amountCents?: Maybe<Array<Scalars['Int']>>;
};

/** sum function */
export type BankingPaymentsConnectionAggregateTermsSumFields = {
  __typename?: 'BankingPaymentsConnectionAggregateTermsSUMFields';
  amountCents?: Maybe<Array<Scalars['Int']>>;
};

/** A repository to retrieve banking payout bank accounts */
export type BankingPayoutBankAccount = {
  __typename?: 'BankingPayoutBankAccount';
  account: BankingAccount;
  accountNumber: Scalars['String'];
  bankName?: Maybe<Scalars['String']>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  bankingAccountId: Scalars['Int'];
  country: Scalars['String'];
  currency: Scalars['String'];
  externalId: Scalars['String'];
  id?: Maybe<Scalars['Int']>;
};


/** A repository to retrieve banking payout bank accounts */
export type BankingPayoutBankAccountAccountArgs = {
  externalId?: InputMaybe<Scalars['String']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  provider?: InputMaybe<Scalars['String']>;
  providers?: InputMaybe<Array<Scalars['String']>>;
  source?: InputMaybe<BankingValueObjectsOnboardingCreationSourceValueEnum>;
};

/** The connection type for BankingPayoutBankAccount. */
export type BankingPayoutBankAccountConnection = {
  __typename?: 'BankingPayoutBankAccountConnection';
  /** A list of edges. */
  edges: Array<BankingPayoutBankAccountEdge>;
  /** A list of nodes. */
  nodes: Array<BankingPayoutBankAccount>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type BankingPayoutBankAccountEdge = {
  __typename?: 'BankingPayoutBankAccountEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BankingPayoutBankAccount;
};

/** A repository to retrieve provider configurations */
export type BankingProviderConfiguration = {
  __typename?: 'BankingProviderConfiguration';
  countries: Array<Scalars['String']>;
  id: Scalars['String'];
  legalEntityId: Scalars['Int'];
  services: Array<BankingProvidersServicesEnumEnum>;
};

/** The connection type for BankingProviderConfiguration. */
export type BankingProviderConfigurationConnection = {
  __typename?: 'BankingProviderConfigurationConnection';
  /** A list of edges. */
  edges: Array<BankingProviderConfigurationEdge>;
  /** A list of nodes. */
  nodes: Array<BankingProviderConfiguration>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type BankingProviderConfigurationEdge = {
  __typename?: 'BankingProviderConfigurationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BankingProviderConfiguration;
};

export type BankingProvidersServicesEnumEnum =
  | 'bank_account_removal'
  | 'bank_aggregation'
  | 'card_management'
  | 'external_bank_account'
  | 'external_provider'
  | 'import_data'
  | 'onboarding'
  | 'payment_management'
  | 'payout_bank_account'
  | 'sepa_payment_management';

/** reconciliation */
export type BankingReconciliation = {
  __typename?: 'BankingReconciliation';
  financialDocument?: Maybe<FinanceFinancialDocument>;
  id: Scalars['Int'];
  reconcilableCurrency?: Maybe<Scalars['String']>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  reconcilableId?: Maybe<Scalars['Int']>;
  reconcilableReconciledAmountCents?: Maybe<Scalars['Int']>;
  reconcilableType?: Maybe<BankingValueObjectsReconcilableTypeEnum>;
  reconciliationType?: Maybe<BankingValueObjectsReconcilationTypeEnum>;
  transaction: BankingTransaction;
  transactionCurrency: Scalars['String'];
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  transactionId: Scalars['Int'];
  transactionReconciledAmountCents: Scalars['Int'];
};


/** reconciliation */
export type BankingReconciliationFinancialDocumentArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  currency?: InputMaybe<Scalars['String']>;
  dealId?: InputMaybe<Scalars['Int']>;
  documentTypes?: InputMaybe<Array<FinanceValueObjectsFinancialDocumentTypeEnum>>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  issuerName?: InputMaybe<Scalars['String']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  operationTypes?: InputMaybe<Array<FinanceValueObjectsFinancialDocumentOperationTypeEnum>>;
  parentFinancialDocumentIds?: InputMaybe<Array<Scalars['Int']>>;
  projectId?: InputMaybe<Scalars['Int']>;
  reconcilable?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<FinanceValueObjectsInvoiceStatusEnum>>;
  toDate?: InputMaybe<Scalars['ISO8601Date']>;
  toDueDate?: InputMaybe<Scalars['ISO8601Date']>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
  vendorId?: InputMaybe<Scalars['Int']>;
};


/** reconciliation */
export type BankingReconciliationTransactionArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']>>;
  accounted?: InputMaybe<Scalars['Boolean']>;
  cardPaymentIds?: InputMaybe<Array<Scalars['Int']>>;
  currency?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['ISO8601DateTime']>;
  incomeTransactions?: InputMaybe<Scalars['Boolean']>;
  outcomeTransactions?: InputMaybe<Scalars['Boolean']>;
  reconciled?: InputMaybe<Scalars['Boolean']>;
  reconciliationStatus?: InputMaybe<BankingValueObjectsReconciliationStatusEnum>;
  status?: InputMaybe<BankingEntitiesTransactionStatusEnum>;
  to?: InputMaybe<Scalars['ISO8601DateTime']>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};

/** The connection type for BankingReconciliation. */
export type BankingReconciliationConnection = {
  __typename?: 'BankingReconciliationConnection';
  /** A list of edges. */
  edges: Array<BankingReconciliationEdge>;
  /** A list of nodes. */
  nodes: Array<BankingReconciliation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type BankingReconciliationEdge = {
  __typename?: 'BankingReconciliationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BankingReconciliation;
};

/** A suggestion to match a banking transaction with a reconcilable */
export type BankingReconciliationSuggestion = {
  __typename?: 'BankingReconciliationSuggestion';
  confidencePercentage: Scalars['Int'];
  financialDocument?: Maybe<FinanceFinancialDocument>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  financialDocumentId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  invoiceId?: Maybe<Scalars['Int']>;
  paymentExecution?: Maybe<BankingPaymentExecution>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  paymentExecutionId?: Maybe<Scalars['Int']>;
  reconcilableId: Scalars['Int'];
  reconcilableType: BankingValueObjectsReconcilableTypeEnum;
  transaction: BankingTransaction;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  transactionId: Scalars['Int'];
};


/** A suggestion to match a banking transaction with a reconcilable */
export type BankingReconciliationSuggestionFinancialDocumentArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  currency?: InputMaybe<Scalars['String']>;
  dealId?: InputMaybe<Scalars['Int']>;
  documentTypes?: InputMaybe<Array<FinanceValueObjectsFinancialDocumentTypeEnum>>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  issuerName?: InputMaybe<Scalars['String']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  operationTypes?: InputMaybe<Array<FinanceValueObjectsFinancialDocumentOperationTypeEnum>>;
  parentFinancialDocumentIds?: InputMaybe<Array<Scalars['Int']>>;
  projectId?: InputMaybe<Scalars['Int']>;
  reconcilable?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<FinanceValueObjectsInvoiceStatusEnum>>;
  toDate?: InputMaybe<Scalars['ISO8601Date']>;
  toDueDate?: InputMaybe<Scalars['ISO8601Date']>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
  vendorId?: InputMaybe<Scalars['Int']>;
};


/** A suggestion to match a banking transaction with a reconcilable */
export type BankingReconciliationSuggestionPaymentExecutionArgs = {
  consentIds?: InputMaybe<Array<Scalars['Int']>>;
  paymentIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** A suggestion to match a banking transaction with a reconcilable */
export type BankingReconciliationSuggestionTransactionArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']>>;
  accounted?: InputMaybe<Scalars['Boolean']>;
  cardPaymentIds?: InputMaybe<Array<Scalars['Int']>>;
  currency?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['ISO8601DateTime']>;
  incomeTransactions?: InputMaybe<Scalars['Boolean']>;
  outcomeTransactions?: InputMaybe<Scalars['Boolean']>;
  reconciled?: InputMaybe<Scalars['Boolean']>;
  reconciliationStatus?: InputMaybe<BankingValueObjectsReconciliationStatusEnum>;
  status?: InputMaybe<BankingEntitiesTransactionStatusEnum>;
  to?: InputMaybe<Scalars['ISO8601DateTime']>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};

/** The connection type for BankingReconciliationSuggestion. */
export type BankingReconciliationSuggestionConnection = {
  __typename?: 'BankingReconciliationSuggestionConnection';
  /** A list of edges. */
  edges: Array<BankingReconciliationSuggestionEdge>;
  /** A list of nodes. */
  nodes: Array<BankingReconciliationSuggestion>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type BankingReconciliationSuggestionEdge = {
  __typename?: 'BankingReconciliationSuggestionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BankingReconciliationSuggestion;
};

/** A banking transaction represents a movement of money between accounts. */
export type BankingTransaction = {
  __typename?: 'BankingTransaction';
  /** Amount in cents. */
  amountCents: Scalars['Int'];
  /** Balance after the transaction in cents. */
  balanceAfterCents?: Maybe<Scalars['Int']>;
  bankAccount: BankingBankAccount;
  /**
   * Factorial Banking Bank Account unique identifier.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  bankAccountId: Scalars['Int'];
  /** Booking date of the transaction. */
  bookingDate: Scalars['ISO8601DateTime'];
  cardPayment?: Maybe<BankingCardPayment>;
  /**
   * Factorial unique identifier of the card payment.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  cardPaymentId: Scalars['Int'];
  category?: Maybe<FinanceCustomCategory>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  categoryId?: Maybe<Scalars['Int']>;
  /** Currency. */
  currency: Scalars['String'];
  /** Description of the transaction. */
  description?: Maybe<Scalars['String']>;
  dispute?: Maybe<BankingDispute>;
  externalId: Scalars['String'];
  fullyReconciledAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Factorial unique identifier. */
  id: Scalars['Int'];
  journalEntry?: Maybe<FinanceJournalEntry>;
  proofOfTransfer?: Maybe<BankingFile>;
  reconciliationSuggestions: Array<BankingReconciliationSuggestion>;
  reconciliationSuggestionsConnection: BankingReconciliationSuggestionConnection;
  reconciliations: Array<BankingReconciliation>;
  reconciliationsConnection: BankingReconciliationConnection;
  rejectionReason?: Maybe<BankingEntitiesTransactionRejectionReasonEnum>;
  snoozedUntil?: Maybe<Scalars['ISO8601DateTime']>;
  status: BankingEntitiesTransactionStatusEnum;
  /** Type of transaction. */
  type: BankingEntitiesTransactionTypeEnum;
  /** Date when the transaction was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  /** Value date of the transaction. */
  valueDate: Scalars['ISO8601DateTime'];
};


/** A banking transaction represents a movement of money between accounts. */
export type BankingTransactionBankAccountArgs = {
  accountNumberTypes?: InputMaybe<Array<BankingEntitiesBankAccountNumberFormatEnum>>;
  bankingAccountIds?: InputMaybe<Array<Scalars['Int']>>;
  currency?: InputMaybe<Scalars['String']>;
  externalIds?: InputMaybe<Array<Scalars['String']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  providers?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  service?: InputMaybe<BankingProvidersServicesEnumEnum>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


/** A banking transaction represents a movement of money between accounts. */
export type BankingTransactionCardPaymentArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']>>;
  calculatedLabel?: InputMaybe<BankingEntitiesCardPaymentCalculatedLabelEnum>;
  cardIds?: InputMaybe<Array<Scalars['Int']>>;
  externalIds?: InputMaybe<Array<Scalars['String']>>;
  from?: InputMaybe<Scalars['ISO8601DateTime']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<BankingEntitiesCardPaymentStatusEnum>;
  to?: InputMaybe<Scalars['ISO8601DateTime']>;
};


/** A banking transaction represents a movement of money between accounts. */
export type BankingTransactionCategoryArgs = {
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  factorialCategoryIdentifier?: InputMaybe<Scalars['String']>;
  parentCategoryIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


/** A banking transaction represents a movement of money between accounts. */
export type BankingTransactionDisputeArgs = {
  bankAccountIds?: InputMaybe<Array<Scalars['Int']>>;
  externalIds?: InputMaybe<Array<Scalars['String']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** A banking transaction represents a movement of money between accounts. */
export type BankingTransactionJournalEntryArgs = {
  bankTransactionIds?: InputMaybe<Array<Scalars['Int']>>;
  financialDocumentIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  invoiceIds?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  publishedFrom?: InputMaybe<Scalars['ISO8601Date']>;
  status?: InputMaybe<FinanceValueObjectsJournalEntryStatusEnum>;
  types?: InputMaybe<Array<FinanceValueObjectsJournalEntryTypeEnum>>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


/** A banking transaction represents a movement of money between accounts. */
export type BankingTransactionReconciliationSuggestionsArgs = {
  companyId: Scalars['Int'];
  financialDocumentIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  invoiceIds?: InputMaybe<Array<Scalars['Int']>>;
  paymentExecutionIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** A banking transaction represents a movement of money between accounts. */
export type BankingTransactionReconciliationSuggestionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  financialDocumentIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  invoiceIds?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  paymentExecutionIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
};


/** A banking transaction represents a movement of money between accounts. */
export type BankingTransactionReconciliationsArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
  reconcilableIds?: InputMaybe<Array<Scalars['Int']>>;
  reconcilableType?: InputMaybe<Scalars['String']>;
};


/** A banking transaction represents a movement of money between accounts. */
export type BankingTransactionReconciliationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  reconcilableIds?: InputMaybe<Array<Scalars['Int']>>;
  reconcilableType?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for BankingTransaction. */
export type BankingTransactionConnection = {
  __typename?: 'BankingTransactionConnection';
  aggregate?: Maybe<BankingTransactionsAggregate>;
  /** A list of edges. */
  edges: Array<BankingTransactionEdge>;
  /** A list of nodes. */
  nodes: Array<BankingTransaction>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type BankingTransactionEdge = {
  __typename?: 'BankingTransactionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BankingTransaction;
};

/** the filter for the transactions resource */
export type BankingTransactionFilter = {
  amountCents?: InputMaybe<IntegerFilter>;
  bankAccountId?: InputMaybe<IntegerFilter>;
  bookingDate?: InputMaybe<DateTimeFilter>;
  cardCreationSource?: InputMaybe<StringFilter>;
  currency?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<BankingTransactionFilterConditions>>;
  reconciledStatus?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
  type?: InputMaybe<StringFilter>;
  valueDate?: InputMaybe<DateTimeFilter>;
};

export type BankingTransactionFilterConditions = {
  amountCents?: InputMaybe<IntegerFilter>;
  bankAccountId?: InputMaybe<IntegerFilter>;
  bookingDate?: InputMaybe<DateTimeFilter>;
  cardCreationSource?: InputMaybe<StringFilter>;
  currency?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  reconciledStatus?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
  type?: InputMaybe<StringFilter>;
  valueDate?: InputMaybe<DateTimeFilter>;
};

/** Banking Account Transaction Import Result */
export type BankingTransactionImportResult = {
  __typename?: 'BankingTransactionImportResult';
  added: Scalars['Int'];
  duplicated: Scalars['Int'];
};

/** Banking Account Transaction Import Template */
export type BankingTransactionImportTemplate = {
  __typename?: 'BankingTransactionImportTemplate';
  fileInBase64: Scalars['String'];
  fileName: Scalars['String'];
  fileType: Scalars['String'];
};

/** Banking transactions aggregates */
export type BankingTransactionsAggregate = {
  __typename?: 'BankingTransactionsAggregate';
  average?: Maybe<BankingTransactionsConnectionAggregateAverage>;
  count?: Maybe<Scalars['Int']>;
  maximum?: Maybe<BankingTransactionsConnectionAggregateMaximum>;
  minimum?: Maybe<BankingTransactionsConnectionAggregateMinimum>;
  sum?: Maybe<BankingTransactionsConnectionAggregateSum>;
  terms?: Maybe<BankingTransactionsConnectionAggregateTerms>;
};

export type BankingTransactionsAggregateTerms = {
  __typename?: 'BankingTransactionsAggregateTerms';
  average?: Maybe<BankingTransactionsConnectionAggregateTermsAverageFields>;
  count?: Maybe<Array<Scalars['Int']>>;
  maximum?: Maybe<BankingTransactionsConnectionAggregateTermsMaximumFields>;
  minimum?: Maybe<BankingTransactionsConnectionAggregateTermsMinimumFields>;
  sum?: Maybe<BankingTransactionsConnectionAggregateTermsSumFields>;
  values: Array<Scalars['String']>;
};

/** average function */
export type BankingTransactionsConnectionAggregateAverage = {
  __typename?: 'BankingTransactionsConnectionAggregateAverage';
  amountCents?: Maybe<Scalars['Float']>;
};

/** maximum function */
export type BankingTransactionsConnectionAggregateMaximum = {
  __typename?: 'BankingTransactionsConnectionAggregateMaximum';
  amountCents?: Maybe<Scalars['Int']>;
};

/** minimum function */
export type BankingTransactionsConnectionAggregateMinimum = {
  __typename?: 'BankingTransactionsConnectionAggregateMinimum';
  amountCents?: Maybe<Scalars['Int']>;
};

/** sum function */
export type BankingTransactionsConnectionAggregateSum = {
  __typename?: 'BankingTransactionsConnectionAggregateSum';
  amountCents?: Maybe<Scalars['Int']>;
};

/** terms function */
export type BankingTransactionsConnectionAggregateTerms = {
  __typename?: 'BankingTransactionsConnectionAggregateTerms';
  amountCents?: Maybe<BankingTransactionsAggregateTerms>;
  bankAccountId?: Maybe<BankingTransactionsAggregateTerms>;
  bookingDate?: Maybe<BankingTransactionsAggregateTerms>;
  currency?: Maybe<BankingTransactionsAggregateTerms>;
  description?: Maybe<BankingTransactionsAggregateTerms>;
  status?: Maybe<BankingTransactionsAggregateTerms>;
  type?: Maybe<BankingTransactionsAggregateTerms>;
  valueDate?: Maybe<BankingTransactionsAggregateTerms>;
};


/** terms function */
export type BankingTransactionsConnectionAggregateTermsBookingDateArgs = {
  period?: InputMaybe<GroupByDateFieldsPeriods>;
};


/** terms function */
export type BankingTransactionsConnectionAggregateTermsValueDateArgs = {
  period?: InputMaybe<GroupByDateFieldsPeriods>;
};

/** average function */
export type BankingTransactionsConnectionAggregateTermsAverageFields = {
  __typename?: 'BankingTransactionsConnectionAggregateTermsAVERAGEFields';
  amountCents?: Maybe<Array<Scalars['Float']>>;
};

/** maximum function */
export type BankingTransactionsConnectionAggregateTermsMaximumFields = {
  __typename?: 'BankingTransactionsConnectionAggregateTermsMAXIMUMFields';
  amountCents?: Maybe<Array<Scalars['Int']>>;
};

/** minimum function */
export type BankingTransactionsConnectionAggregateTermsMinimumFields = {
  __typename?: 'BankingTransactionsConnectionAggregateTermsMINIMUMFields';
  amountCents?: Maybe<Array<Scalars['Int']>>;
};

/** sum function */
export type BankingTransactionsConnectionAggregateTermsSumFields = {
  __typename?: 'BankingTransactionsConnectionAggregateTermsSUMFields';
  amountCents?: Maybe<Array<Scalars['Int']>>;
};

/** A banking transfer is part of a payment execution, and represents a movement of money between accounts. */
export type BankingTransfer = {
  __typename?: 'BankingTransfer';
  accountNumber: Scalars['String'];
  amountCents: Scalars['Int'];
  beneficiaryName: Scalars['String'];
  companyId: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  currency: Scalars['String'];
  dueDate: Scalars['ISO8601DateTime'];
  id: Scalars['Int'];
  label: Scalars['String'];
  legalEntityId: Scalars['Int'];
  paymentExecution?: Maybe<BankingPaymentExecution>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  paymentExecutionId?: Maybe<Scalars['Int']>;
  paymentRequestItem?: Maybe<BankingPaymentRequestItem>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  paymentRequestItemId: Scalars['Int'];
  rejectionReason?: Maybe<BankingEntitiesTransactionRejectionReasonEnum>;
  requester?: Maybe<EmployeesEmployee>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  requesterId: Scalars['Int'];
  sourceId: Scalars['Int'];
  sourceType: BankingValueObjectsTransferSourceTypeEnum;
  status: BankingValueObjectsTransferStatusEnum;
  transaction?: Maybe<BankingTransaction>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  transactionId?: Maybe<Scalars['Int']>;
};


/** A banking transfer is part of a payment execution, and represents a movement of money between accounts. */
export type BankingTransferPaymentExecutionArgs = {
  consentIds?: InputMaybe<Array<Scalars['Int']>>;
  paymentIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** A banking transfer is part of a payment execution, and represents a movement of money between accounts. */
export type BankingTransferPaymentRequestItemArgs = {
  bankingPaymentRequestIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** A banking transfer is part of a payment execution, and represents a movement of money between accounts. */
export type BankingTransferRequesterArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** A banking transfer is part of a payment execution, and represents a movement of money between accounts. */
export type BankingTransferTransactionArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']>>;
  accounted?: InputMaybe<Scalars['Boolean']>;
  cardPaymentIds?: InputMaybe<Array<Scalars['Int']>>;
  currency?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['ISO8601DateTime']>;
  incomeTransactions?: InputMaybe<Scalars['Boolean']>;
  outcomeTransactions?: InputMaybe<Scalars['Boolean']>;
  reconciled?: InputMaybe<Scalars['Boolean']>;
  reconciliationStatus?: InputMaybe<BankingValueObjectsReconciliationStatusEnum>;
  status?: InputMaybe<BankingEntitiesTransactionStatusEnum>;
  to?: InputMaybe<Scalars['ISO8601DateTime']>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};

/** The connection type for BankingTransfer. */
export type BankingTransferConnection = {
  __typename?: 'BankingTransferConnection';
  aggregate?: Maybe<BankingTransfersAggregate>;
  /** A list of edges. */
  edges: Array<BankingTransferEdge>;
  /** A list of nodes. */
  nodes: Array<BankingTransfer>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type BankingTransferEdge = {
  __typename?: 'BankingTransferEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BankingTransfer;
};

/** the filter for the transfers resource */
export type BankingTransferFilter = {
  accountNumber?: InputMaybe<StringFilter>;
  amountCents?: InputMaybe<IntegerFilter>;
  beneficiaryName?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<StringFilter>;
  dueDate?: InputMaybe<DateTimeFilter>;
  legalEntityId?: InputMaybe<IntegerFilter>;
  or?: InputMaybe<Array<BankingTransferFilterConditions>>;
  paymentRequestItemId?: InputMaybe<IntegerFilter>;
  rejectionReason?: InputMaybe<StringFilter>;
  requesterId?: InputMaybe<IntegerFilter>;
  sourceId?: InputMaybe<IntegerFilter>;
  sourceType?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
};

export type BankingTransferFilterConditions = {
  accountNumber?: InputMaybe<StringFilter>;
  amountCents?: InputMaybe<IntegerFilter>;
  beneficiaryName?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<StringFilter>;
  dueDate?: InputMaybe<DateTimeFilter>;
  legalEntityId?: InputMaybe<IntegerFilter>;
  paymentRequestItemId?: InputMaybe<IntegerFilter>;
  rejectionReason?: InputMaybe<StringFilter>;
  requesterId?: InputMaybe<IntegerFilter>;
  sourceId?: InputMaybe<IntegerFilter>;
  sourceType?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
};

/** Banking transfers aggregates */
export type BankingTransfersAggregate = {
  __typename?: 'BankingTransfersAggregate';
  average?: Maybe<BankingTransfersConnectionAggregateAverage>;
  count?: Maybe<Scalars['Int']>;
  maximum?: Maybe<BankingTransfersConnectionAggregateMaximum>;
  minimum?: Maybe<BankingTransfersConnectionAggregateMinimum>;
  sum?: Maybe<BankingTransfersConnectionAggregateSum>;
  terms?: Maybe<BankingTransfersConnectionAggregateTerms>;
};

export type BankingTransfersAggregateTerms = {
  __typename?: 'BankingTransfersAggregateTerms';
  average?: Maybe<BankingTransfersConnectionAggregateTermsAverageFields>;
  count?: Maybe<Array<Scalars['Int']>>;
  maximum?: Maybe<BankingTransfersConnectionAggregateTermsMaximumFields>;
  minimum?: Maybe<BankingTransfersConnectionAggregateTermsMinimumFields>;
  sum?: Maybe<BankingTransfersConnectionAggregateTermsSumFields>;
  values: Array<Scalars['String']>;
};

/** average function */
export type BankingTransfersConnectionAggregateAverage = {
  __typename?: 'BankingTransfersConnectionAggregateAverage';
  amountCents?: Maybe<Scalars['Float']>;
};

/** maximum function */
export type BankingTransfersConnectionAggregateMaximum = {
  __typename?: 'BankingTransfersConnectionAggregateMaximum';
  amountCents?: Maybe<Scalars['Int']>;
};

/** minimum function */
export type BankingTransfersConnectionAggregateMinimum = {
  __typename?: 'BankingTransfersConnectionAggregateMinimum';
  amountCents?: Maybe<Scalars['Int']>;
};

/** sum function */
export type BankingTransfersConnectionAggregateSum = {
  __typename?: 'BankingTransfersConnectionAggregateSum';
  amountCents?: Maybe<Scalars['Int']>;
};

/** terms function */
export type BankingTransfersConnectionAggregateTerms = {
  __typename?: 'BankingTransfersConnectionAggregateTerms';
  accountNumber?: Maybe<BankingTransfersAggregateTerms>;
  amountCents?: Maybe<BankingTransfersAggregateTerms>;
  beneficiaryName?: Maybe<BankingTransfersAggregateTerms>;
  createdAt?: Maybe<BankingTransfersAggregateTerms>;
  currency?: Maybe<BankingTransfersAggregateTerms>;
  dueDate?: Maybe<BankingTransfersAggregateTerms>;
  legalEntityId?: Maybe<BankingTransfersAggregateTerms>;
  paymentRequestItemId?: Maybe<BankingTransfersAggregateTerms>;
  rejectionReason?: Maybe<BankingTransfersAggregateTerms>;
  requesterId?: Maybe<BankingTransfersAggregateTerms>;
  sourceId?: Maybe<BankingTransfersAggregateTerms>;
  sourceType?: Maybe<BankingTransfersAggregateTerms>;
  status?: Maybe<BankingTransfersAggregateTerms>;
};


/** terms function */
export type BankingTransfersConnectionAggregateTermsCreatedAtArgs = {
  period?: InputMaybe<GroupByDateFieldsPeriods>;
};


/** terms function */
export type BankingTransfersConnectionAggregateTermsDueDateArgs = {
  period?: InputMaybe<GroupByDateFieldsPeriods>;
};

/** average function */
export type BankingTransfersConnectionAggregateTermsAverageFields = {
  __typename?: 'BankingTransfersConnectionAggregateTermsAVERAGEFields';
  amountCents?: Maybe<Array<Scalars['Float']>>;
};

/** maximum function */
export type BankingTransfersConnectionAggregateTermsMaximumFields = {
  __typename?: 'BankingTransfersConnectionAggregateTermsMAXIMUMFields';
  amountCents?: Maybe<Array<Scalars['Int']>>;
};

/** minimum function */
export type BankingTransfersConnectionAggregateTermsMinimumFields = {
  __typename?: 'BankingTransfersConnectionAggregateTermsMINIMUMFields';
  amountCents?: Maybe<Array<Scalars['Int']>>;
};

/** sum function */
export type BankingTransfersConnectionAggregateTermsSumFields = {
  __typename?: 'BankingTransfersConnectionAggregateTermsSUMFields';
  amountCents?: Maybe<Array<Scalars['Int']>>;
};

export type BankingValueObjectsAuthorizationActionEnum =
  | 'bind_account_membership';

export type BankingValueObjectsCardCreationSourceEnum =
  | 'expenses'
  | 'procurement'
  | 'salary'
  | 'software';

export type BankingValueObjectsCardSendingTypeEnum =
  | 'cardholder'
  | 'company';

export type BankingValueObjectsCardShippingStatusEnum =
  | 'canceled'
  | 'delivered'
  | 'failure'
  | 'pending'
  | 'returned'
  | 'shipped';

export type BankingValueObjectsCardStatusEnum =
  | 'active'
  | 'approved'
  | 'canceled'
  | 'inactive'
  | 'pending'
  | 'rejected'
  | 'requested';

export type BankingValueObjectsCardTypeEnum =
  | 'physical'
  | 'single_use'
  | 'virtual';

export type BankingValueObjectsDisputeStatusEnum =
  | 'lost'
  | 'pending'
  | 'won';

export type BankingValueObjectsOnboardingCreationSourceValueEnum =
  | 'accounts_payable'
  | 'benefits'
  | 'expenses'
  | 'expensescombined'
  | 'finance'
  | 'payments'
  | 'salary_advance'
  | 'software';

export type BankingValueObjectsOnboardingStatusEnum =
  | 'completed'
  | 'in_review'
  | 'missing_information'
  | 'pending'
  | 'rejected'
  | 'verification_pending';

export type BankingValueObjectsPaymentRequestItemStatusEnum =
  | 'in_payment'
  | 'in_progress'
  | 'init'
  | 'paid'
  | 'rejected';

export type BankingValueObjectsPaymentRequestSourceTypeEnum =
  | 'compensation'
  | 'expensable'
  | 'invoice'
  | 'payroll'
  | 'salary_advance_request';

export type BankingValueObjectsPaymentRequestStatusEnum =
  | 'in_payment'
  | 'in_progress'
  | 'init'
  | 'paid';

export type BankingValueObjectsProviderEnum =
  | 'fake'
  | 'go_cardless'
  | 'manual'
  | 'stripe'
  | 'swan';

export type BankingValueObjectsReconcilableTypeEnum =
  | 'invoice'
  | 'payment_execution';

export type BankingValueObjectsReconcilationTypeEnum =
  | 'normal'
  | 'skipped';

export type BankingValueObjectsReconciliationStatusEnum =
  | 'pending'
  | 'reconciled'
  | 'snoozed';

export type BankingValueObjectsTransferSourceTypeEnum =
  | 'compensation'
  | 'expensable'
  | 'invoice'
  | 'payroll'
  | 'salary_advance_request';

export type BankingValueObjectsTransferStatusEnum =
  | 'in_progress'
  | 'init'
  | 'paid'
  | 'rejected';

/** Benefit Balance */
export type BenefitsBenefitBalance = {
  __typename?: 'BenefitsBenefitBalance';
  availableCents: Scalars['Int'];
  category: BenefitsValueObjectsBenefitTransactionCategoryEnum;
  cycleResetDate: Scalars['ISO8601Date'];
  limitCents: Scalars['Int'];
};

/** The connection type for BenefitsBenefitBalance. */
export type BenefitsBenefitBalanceConnection = {
  __typename?: 'BenefitsBenefitBalanceConnection';
  /** A list of edges. */
  edges: Array<BenefitsBenefitBalanceEdge>;
  /** A list of nodes. */
  nodes: Array<BenefitsBenefitBalance>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type BenefitsBenefitBalanceEdge = {
  __typename?: 'BenefitsBenefitBalanceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BenefitsBenefitBalance;
};

/** Benefit Compensation */
export type BenefitsBenefitCompensation = {
  __typename?: 'BenefitsBenefitCompensation';
  amountCents: Scalars['Int'];
  amountCentsCompanyExempt?: Maybe<Scalars['Int']>;
  amountCentsCompanyNonexempt?: Maybe<Scalars['Int']>;
  amountCentsEmployeeExempt?: Maybe<Scalars['Int']>;
  amountCentsEmployeeNonexempt?: Maybe<Scalars['Int']>;
  category: BenefitsValueObjectsBenefitTransactionCategoryEnum;
  createdAt: Scalars['ISO8601DateTime'];
  currency: Scalars['String'];
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  employeeId: Scalars['Int'];
  employeeName?: Maybe<EmployeesEmployeeName>;
  id: Scalars['Int'];
};


/** Benefit Compensation */
export type BenefitsBenefitCompensationEmployeeNameArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  afterEmployeeId?: InputMaybe<Scalars['Int']>;
  beforeEmployeeId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  reporteesOrLed?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyId?: InputMaybe<Scalars['Int']>;
  verb?: InputMaybe<Scalars['String']>;
  withActiveContract?: Scalars['Boolean'];
};

/** The connection type for BenefitsBenefitCompensation. */
export type BenefitsBenefitCompensationConnection = {
  __typename?: 'BenefitsBenefitCompensationConnection';
  /** A list of edges. */
  edges: Array<BenefitsBenefitCompensationEdge>;
  /** A list of nodes. */
  nodes: Array<BenefitsBenefitCompensation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type BenefitsBenefitCompensationEdge = {
  __typename?: 'BenefitsBenefitCompensationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BenefitsBenefitCompensation;
};

/** Benefit Employee */
export type BenefitsBenefitEmployee = {
  __typename?: 'BenefitsBenefitEmployee';
  activeBenefits: Array<BenefitsValueObjectsBenefitTransactionCategoryEnum>;
  employee?: Maybe<EmployeesEmployee>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  employeeId: Scalars['Int'];
  employeeName?: Maybe<EmployeesEmployeeName>;
};


/** Benefit Employee */
export type BenefitsBenefitEmployeeEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Benefit Employee */
export type BenefitsBenefitEmployeeEmployeeNameArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  afterEmployeeId?: InputMaybe<Scalars['Int']>;
  beforeEmployeeId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  reporteesOrLed?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyId?: InputMaybe<Scalars['Int']>;
  verb?: InputMaybe<Scalars['String']>;
  withActiveContract?: Scalars['Boolean'];
};

/** The connection type for BenefitsBenefitEmployee. */
export type BenefitsBenefitEmployeeConnection = {
  __typename?: 'BenefitsBenefitEmployeeConnection';
  /** A list of edges. */
  edges: Array<BenefitsBenefitEmployeeEdge>;
  /** A list of nodes. */
  nodes: Array<BenefitsBenefitEmployee>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type BenefitsBenefitEmployeeEdge = {
  __typename?: 'BenefitsBenefitEmployeeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BenefitsBenefitEmployee;
};

/** Benefit Settings */
export type BenefitsBenefitSetting = {
  __typename?: 'BenefitsBenefitSetting';
  resetDay: Scalars['Int'];
};

/** The connection type for BenefitsBenefitSetting. */
export type BenefitsBenefitSettingConnection = {
  __typename?: 'BenefitsBenefitSettingConnection';
  /** A list of edges. */
  edges: Array<BenefitsBenefitSettingEdge>;
  /** A list of nodes. */
  nodes: Array<BenefitsBenefitSetting>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type BenefitsBenefitSettingEdge = {
  __typename?: 'BenefitsBenefitSettingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BenefitsBenefitSetting;
};

/** Benefit Transaction */
export type BenefitsBenefitTransaction = {
  __typename?: 'BenefitsBenefitTransaction';
  amountCents: Scalars['Int'];
  category: BenefitsValueObjectsBenefitTransactionCategoryEnum;
  companyId: Scalars['Int'];
  compensationStatus: BenefitsValueObjectsBenefitTransactionCompensationStatusEnum;
  concept: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  currency: Scalars['String'];
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  employeeId: Scalars['Int'];
  employeeName?: Maybe<EmployeesEmployeeName>;
  id: Scalars['Int'];
  settledAt?: Maybe<Scalars['ISO8601DateTime']>;
  updatedAt: Scalars['ISO8601DateTime'];
};


/** Benefit Transaction */
export type BenefitsBenefitTransactionEmployeeNameArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  afterEmployeeId?: InputMaybe<Scalars['Int']>;
  beforeEmployeeId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  reporteesOrLed?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyId?: InputMaybe<Scalars['Int']>;
  verb?: InputMaybe<Scalars['String']>;
  withActiveContract?: Scalars['Boolean'];
};

/** The connection type for BenefitsBenefitTransaction. */
export type BenefitsBenefitTransactionConnection = {
  __typename?: 'BenefitsBenefitTransactionConnection';
  /** A list of edges. */
  edges: Array<BenefitsBenefitTransactionEdge>;
  /** A list of nodes. */
  nodes: Array<BenefitsBenefitTransaction>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type BenefitsBenefitTransactionEdge = {
  __typename?: 'BenefitsBenefitTransactionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BenefitsBenefitTransaction;
};

/** the filter for the benefit_transactions resource */
export type BenefitsBenefitTransactionFilter = {
  amountCents?: InputMaybe<IntegerFilter>;
  category?: InputMaybe<StringFilter>;
  compensationStatus?: InputMaybe<StringFilter>;
  concept?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  or?: InputMaybe<Array<BenefitsBenefitTransactionFilterConditions>>;
};

export type BenefitsBenefitTransactionFilterConditions = {
  amountCents?: InputMaybe<IntegerFilter>;
  category?: InputMaybe<StringFilter>;
  compensationStatus?: InputMaybe<StringFilter>;
  concept?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
};

/** Childcare Requests */
export type BenefitsChildcareRequest = {
  __typename?: 'BenefitsChildcareRequest';
  childcareUrl: Scalars['String'];
  companyId: Scalars['Int'];
  employeeId: Scalars['Int'];
  id: Scalars['Int'];
};

export type BenefitsContextlessPolicies = {
  __typename?: 'BenefitsContextlessPolicies';
  benefitsActive: ContextlessPolicyResolution;
  canChangeCycleDay: ContextlessPolicyResolution;
  sidebarSeeBenefitsTopLevelItem: ContextlessPolicyResolution;
  sidebarSeeMyBenefitsTopLevelItem: ContextlessPolicyResolution;
};

/** Employee Activation */
export type BenefitsEmployeeActivation = {
  __typename?: 'BenefitsEmployeeActivation';
  alreadyHasCard: Array<Scalars['Int']>;
  missingBirthday: Array<Scalars['Int']>;
  missingCountryCode: Array<Scalars['Int']>;
  missingIdentifier: Array<Scalars['Int']>;
  missingPhone: Array<Scalars['Int']>;
  notInPayroll: Array<Scalars['Int']>;
  notWithinCountry: Array<Scalars['Int']>;
  otherErrors: Array<Scalars['Int']>;
  successfulEmployees: Array<Scalars['Int']>;
};

export type BenefitsFile = {
  __typename?: 'BenefitsFile';
  byteSize: Scalars['Int'];
  contentType?: Maybe<Scalars['String']>;
  filename: Scalars['String'];
  id: Scalars['Int'];
  url?: Maybe<Scalars['String']>;
};

/** Healthcare Enrollment */
export type BenefitsHealthcareEnrollment = {
  __typename?: 'BenefitsHealthcareEnrollment';
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  effectiveDate?: Maybe<Scalars['ISO8601Date']>;
  email?: Maybe<Scalars['String']>;
  employeeId: Scalars['Int'];
  enrolledAt: Scalars['ISO8601DateTime'];
  firstName: Scalars['String'];
  healthcarePlanId: Scalars['Int'];
  id: Scalars['Int'];
  lastName: Scalars['String'];
  phoneNumber?: Maybe<Scalars['String']>;
  relationshipToEmployee: BenefitsValueObjectsBenefitMembersMemberTypeEnum;
  status: BenefitsValueObjectsBenefitStatusEnum;
  taxId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for BenefitsHealthcareEnrollment. */
export type BenefitsHealthcareEnrollmentConnection = {
  __typename?: 'BenefitsHealthcareEnrollmentConnection';
  /** A list of edges. */
  edges: Array<BenefitsHealthcareEnrollmentEdge>;
  /** A list of nodes. */
  nodes: Array<BenefitsHealthcareEnrollment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type BenefitsHealthcareEnrollmentEdge = {
  __typename?: 'BenefitsHealthcareEnrollmentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BenefitsHealthcareEnrollment;
};

/** the filter for the healthcare_enrollments resource */
export type BenefitsHealthcareEnrollmentFilter = {
  effectiveDate?: InputMaybe<DateFilter>;
  email?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringFilter>;
  lastName?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<BenefitsHealthcareEnrollmentFilterConditions>>;
  phoneNumber?: InputMaybe<StringFilter>;
  relationshipToEmployee?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
  taxId?: InputMaybe<StringFilter>;
};

export type BenefitsHealthcareEnrollmentFilterConditions = {
  effectiveDate?: InputMaybe<DateFilter>;
  email?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringFilter>;
  lastName?: InputMaybe<StringFilter>;
  phoneNumber?: InputMaybe<StringFilter>;
  relationshipToEmployee?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
  taxId?: InputMaybe<StringFilter>;
};

/** Healthcare Plan */
export type BenefitsHealthcarePlan = {
  __typename?: 'BenefitsHealthcarePlan';
  allowPreExistingConditions: Scalars['Boolean'];
  company?: Maybe<CompaniesCompany>;
  coveredDependentCostCents?: Maybe<Scalars['Int']>;
  coveredEmployeeCostCents: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  dependentCostCents?: Maybe<Scalars['Int']>;
  employeeCostCents: Scalars['Int'];
  id: Scalars['Int'];
  planDocument?: Maybe<BenefitsFile>;
  planName: Scalars['String'];
  providerName: Scalars['String'];
  renewalDate: Scalars['ISO8601Date'];
  updatedAt: Scalars['ISO8601DateTime'];
  waitingPeriodMonths: Scalars['Int'];
};


/** Healthcare Plan */
export type BenefitsHealthcarePlanCompanyArgs = {
  forBookkeepers?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** The connection type for BenefitsHealthcarePlan. */
export type BenefitsHealthcarePlanConnection = {
  __typename?: 'BenefitsHealthcarePlanConnection';
  /** A list of edges. */
  edges: Array<BenefitsHealthcarePlanEdge>;
  /** A list of nodes. */
  nodes: Array<BenefitsHealthcarePlan>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type BenefitsHealthcarePlanEdge = {
  __typename?: 'BenefitsHealthcarePlanEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BenefitsHealthcarePlan;
};

/** Spending Limit Override */
export type BenefitsSpendingLimitOverride = {
  __typename?: 'BenefitsSpendingLimitOverride';
  amountCents: Scalars['Int'];
  category: BenefitsValueObjectsBenefitTransactionCategoryEnum;
  companyId: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  employeeId: Scalars['Int'];
  expiresAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['Int'];
};

/** Benefit Training Costs */
export type BenefitsTrainingCost = {
  __typename?: 'BenefitsTrainingCost';
  effectiveDate?: Maybe<Scalars['ISO8601Date']>;
  employeeId: Scalars['Int'];
  id: Scalars['Int'];
  numberPayslips?: Maybe<Scalars['Int']>;
  paymentOption: BenefitsValueObjectsTrainingsPaymentOptionEnum;
  priceCents: Scalars['Int'];
  trainingRequest?: Maybe<TrainingsTrainingRequest>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  trainingRequestId: Scalars['Int'];
};


/** Benefit Training Costs */
export type BenefitsTrainingCostTrainingRequestArgs = {
  allowdrafts?: Scalars['Boolean'];
  authorId?: InputMaybe<Scalars['Int']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  employeesOrAuthor?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<TrainingsTrainingRequestStatusEnum>;
};

export type BenefitsValueObjectsBenefitMembersMemberTypeEnum =
  | 'child'
  | 'employee'
  | 'other_family'
  | 'other_non_family'
  | 'partner'
  | 'spouse';

export type BenefitsValueObjectsBenefitMembersSexEnum =
  | 'female'
  | 'male';

export type BenefitsValueObjectsBenefitStatusEnum =
  | 'active'
  | 'inactive'
  | 'pending'
  | 'requested';

export type BenefitsValueObjectsBenefitTransactionCategoryEnum =
  | 'childcare'
  | 'healthcare'
  | 'meals'
  | 'training'
  | 'transportation'
  | 'unsupported'
  | 'wellness';

export type BenefitsValueObjectsBenefitTransactionCompensationStatusEnum =
  | 'completed'
  | 'discarded'
  | 'pending'
  | 'ready'
  | 'reversed';

export type BenefitsValueObjectsTrainingsPaymentOptionEnum =
  | 'from_salary'
  | 'paid_by_company';

export type BigMoney = {
  __typename?: 'BigMoney';
  cents: Scalars['BigInt'];
  currency: Scalars['String'];
};

export type BigMoneyInput = {
  cents: Scalars['BigInt'];
  currency: Scalars['String'];
};

export type BillingAddonItemInput = {
  itemPriceId: Scalars['String'];
  module: Scalars['String'];
  seats: Scalars['Int'];
};

export type BillingAdyenPaymentMethodInput = {
  brand?: InputMaybe<Scalars['String']>;
  encryptedCardNumber?: InputMaybe<Scalars['String']>;
  encryptedExpiryMonth?: InputMaybe<Scalars['String']>;
  encryptedExpiryYear?: InputMaybe<Scalars['String']>;
  encryptedSecurityCode?: InputMaybe<Scalars['String']>;
  holderName?: InputMaybe<Scalars['String']>;
  issuerCountry?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};

/** churn_request */
export type BillingChurnRequest = {
  __typename?: 'BillingChurnRequest';
  id: Scalars['Int'];
  mainChurnReason: Scalars['String'];
  secondaryChurnReason: Scalars['String'];
};

/** The connection type for BillingChurnRequest. */
export type BillingChurnRequestConnection = {
  __typename?: 'BillingChurnRequestConnection';
  /** A list of edges. */
  edges: Array<BillingChurnRequestEdge>;
  /** A list of nodes. */
  nodes: Array<BillingChurnRequest>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type BillingChurnRequestEdge = {
  __typename?: 'BillingChurnRequestEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BillingChurnRequest;
};

export type BillingContextlessPolicies = {
  __typename?: 'BillingContextlessPolicies';
  subscriptionManageSubscription: ContextlessPolicyResolution;
  subscriptionPurchaseSubscription: ContextlessPolicyResolution;
  subscriptionUpgradeSubscription: ContextlessPolicyResolution;
};

export type BillingCpBankAccountDetails = {
  __typename?: 'BillingCpBankAccountDetails';
  accountType: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  last4: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  nameOnAccount: Scalars['String'];
};

export type BillingCpCardDetails = {
  __typename?: 'BillingCpCardDetails';
  brand?: Maybe<Scalars['String']>;
  expiryMonth: Scalars['Int'];
  expiryYear: Scalars['Int'];
  firstName?: Maybe<Scalars['String']>;
  fundingType?: Maybe<Scalars['String']>;
  iin: Scalars['String'];
  last4: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  maskedNumber: Scalars['String'];
};

/** Billing Customer Portal Chat. The resource represent a Chat with potentially some other data provided by us. */
export type BillingCpChat = {
  __typename?: 'BillingCpChat';
  conversationId: Scalars['String'];
  id: Scalars['String'];
  response?: Maybe<Scalars['String']>;
};

/** Billing Customer Portal Invoice. The resource represent a Chargebee Invoice with potentially some other data provided by us. */
export type BillingCpCollectNow = {
  __typename?: 'BillingCpCollectNow';
  createdAt: Scalars['Int'];
  expiresAt: Scalars['Int'];
  id: Scalars['String'];
  state: Scalars['String'];
  type: Scalars['String'];
  url: Scalars['String'];
};

/** cp credit notes */
export type BillingCpCreditNote = {
  __typename?: 'BillingCpCreditNote';
  amountAllocated?: Maybe<Scalars['Int']>;
  amountAvailable?: Maybe<Scalars['Int']>;
  amountRefunded?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['Int']>;
  createdReasonCode: Scalars['String'];
  currencyCode: Scalars['String'];
  customerId: Scalars['String'];
  date?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  reasonCode?: Maybe<Scalars['String']>;
  referenceInvoiceId?: Maybe<Scalars['String']>;
  refundedAt?: Maybe<Scalars['Int']>;
  status: Scalars['String'];
  total?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['Int']>;
};

/** The connection type for BillingCpCreditNote. */
export type BillingCpCreditNoteConnection = {
  __typename?: 'BillingCpCreditNoteConnection';
  /** A list of edges. */
  edges: Array<BillingCpCreditNoteEdge>;
  /** A list of nodes. */
  nodes: Array<BillingCpCreditNote>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type BillingCpCreditNoteEdge = {
  __typename?: 'BillingCpCreditNoteEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BillingCpCreditNote;
};

/**
 * Billing Customer Portal Credit Note Pdf. The resource represent a Chargebee
 * Credit Note Pdf that contains a download url and a valid till date.
 */
export type BillingCpCreditNotePdf = {
  __typename?: 'BillingCpCreditNotePdf';
  downloadUrl: Scalars['String'];
  validTill: Scalars['Int'];
};

/** The connection type for BillingCpCreditNotePdf. */
export type BillingCpCreditNotePdfConnection = {
  __typename?: 'BillingCpCreditNotePdfConnection';
  /** A list of edges. */
  edges: Array<BillingCpCreditNotePdfEdge>;
  /** A list of nodes. */
  nodes: Array<BillingCpCreditNotePdf>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type BillingCpCreditNotePdfEdge = {
  __typename?: 'BillingCpCreditNotePdfEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BillingCpCreditNotePdf;
};

export type BillingCpCustomer = {
  __typename?: 'BillingCpCustomer';
  billingAddress: BillingCpCustomerBillingAddress;
  companyName?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  vatNumber?: Maybe<Scalars['String']>;
};

export type BillingCpCustomerBillingAddress = {
  __typename?: 'BillingCpCustomerBillingAddress';
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

/** Billing Customer Portal Invoice Pdf in a zip file. */
export type BillingCpDownloadZip = {
  __typename?: 'BillingCpDownloadZip';
  contentType?: Maybe<Scalars['String']>;
  fileData?: Maybe<Scalars['String']>;
  filename?: Maybe<Scalars['String']>;
};

export type BillingCpEmployeeHistory = {
  __typename?: 'BillingCpEmployeeHistory';
  accessId: Scalars['Int'];
  name: Scalars['String'];
  status?: Maybe<Scalars['String']>;
};

/** cp export invoices */
export type BillingCpExportInvoice = {
  __typename?: 'BillingCpExportInvoice';
  downloadUrl?: Maybe<Scalars['String']>;
  exportId?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

/** Billing Customer Portal Invoice. The resource represent a Chargebee Invoice with potentially some other data provided by us. */
export type BillingCpInvoice = {
  __typename?: 'BillingCpInvoice';
  amountDue: Scalars['Int'];
  amountPaid: Scalars['Int'];
  currencyCode: Scalars['String'];
  date: Scalars['Int'];
  discounts?: Maybe<Array<BillingCpInvoiceDiscount>>;
  dueDate?: Maybe<Scalars['Int']>;
  generatedAt: Scalars['Int'];
  id: Scalars['String'];
  lineItemDiscounts?: Maybe<Array<BillingCpInvoiceLineItemDiscount>>;
  lineItems?: Maybe<Array<BillingCpInvoiceLineItem>>;
  netTermDays?: Maybe<Scalars['Int']>;
  status: BillingEntitiesCpInvoiceStatusEnum;
  subscriptionId?: Maybe<Scalars['String']>;
  total: Scalars['Int'];
};

/** The connection type for BillingCpInvoice. */
export type BillingCpInvoiceConnection = {
  __typename?: 'BillingCpInvoiceConnection';
  /** A list of edges. */
  edges: Array<BillingCpInvoiceEdge>;
  /** A list of nodes. */
  nodes: Array<BillingCpInvoice>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type BillingCpInvoiceDiscount = {
  __typename?: 'BillingCpInvoiceDiscount';
  amount: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  discountPercentage?: Maybe<Scalars['Float']>;
  discountType?: Maybe<Scalars['String']>;
  entityId?: Maybe<Scalars['String']>;
  entityType: Scalars['String'];
};

/** An edge in a connection. */
export type BillingCpInvoiceEdge = {
  __typename?: 'BillingCpInvoiceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BillingCpInvoice;
};

export type BillingCpInvoiceEstimate = {
  __typename?: 'BillingCpInvoiceEstimate';
  amountDue?: Maybe<Scalars['Int']>;
  amountPaid?: Maybe<Scalars['Int']>;
  creditsApplied?: Maybe<Scalars['Int']>;
  currencyCode: Scalars['String'];
  discounts?: Maybe<Array<BillingCpInvoiceDiscount>>;
  lineItemDiscounts?: Maybe<Array<BillingCpInvoiceLineItemDiscount>>;
  lineItems?: Maybe<Array<BillingCpInvoiceLineItem>>;
  priceType: Scalars['String'];
  recurring: Scalars['Boolean'];
  subTotal?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

export type BillingCpInvoiceLineItem = {
  __typename?: 'BillingCpInvoiceLineItem';
  amount?: Maybe<Scalars['Int']>;
  dateFrom: Scalars['Int'];
  dateTo: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  discountAmount?: Maybe<Scalars['Int']>;
  entityId?: Maybe<Scalars['String']>;
  entityType: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  itemLevelDiscountAmount?: Maybe<Scalars['Int']>;
  pricingModel?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  unitAmount: Scalars['Int'];
};

export type BillingCpInvoiceLineItemDiscount = {
  __typename?: 'BillingCpInvoiceLineItemDiscount';
  discountAmount: Scalars['Int'];
  discountType: Scalars['String'];
  entityId?: Maybe<Scalars['String']>;
  lineItemId: Scalars['String'];
};

/**
 * Billing Customer Portal Invoice Pdf. The resource represent a Chargebee Invoice
 * Pdf that contains a download url and a valid till date.
 */
export type BillingCpInvoicePdf = {
  __typename?: 'BillingCpInvoicePdf';
  downloadUrl: Scalars['String'];
  validTill: Scalars['Int'];
};

/** The connection type for BillingCpInvoicePdf. */
export type BillingCpInvoicePdfConnection = {
  __typename?: 'BillingCpInvoicePdfConnection';
  /** A list of edges. */
  edges: Array<BillingCpInvoicePdfEdge>;
  /** A list of nodes. */
  nodes: Array<BillingCpInvoicePdf>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type BillingCpInvoicePdfEdge = {
  __typename?: 'BillingCpInvoicePdfEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BillingCpInvoicePdf;
};

/** Billing Customer Portal Next Renewal Estimate. The resource represent a Chargebee Estimate with values of next invoice */
export type BillingCpNextBillingEstimate = {
  __typename?: 'BillingCpNextBillingEstimate';
  invoiceEstimate?: Maybe<BillingCpInvoiceEstimate>;
  subscriptionEstimate?: Maybe<BillingCpSubscriptionEstimate>;
};

/** The connection type for BillingCpNextBillingEstimate. */
export type BillingCpNextBillingEstimateConnection = {
  __typename?: 'BillingCpNextBillingEstimateConnection';
  /** A list of edges. */
  edges: Array<BillingCpNextBillingEstimateEdge>;
  /** A list of nodes. */
  nodes: Array<BillingCpNextBillingEstimate>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type BillingCpNextBillingEstimateEdge = {
  __typename?: 'BillingCpNextBillingEstimateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BillingCpNextBillingEstimate;
};

/** Billing Customer Portal create payment intent. */
export type BillingCpPaymentIntent = {
  __typename?: 'BillingCpPaymentIntent';
  amount: Scalars['Int'];
  createdAt: Scalars['Int'];
  currencyCode: Scalars['String'];
  expiresAt: Scalars['Int'];
  gatewayAccountId: Scalars['String'];
  id: Scalars['String'];
  modifiedAt: Scalars['Int'];
  paymentMethodType?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  updatedAt: Scalars['Int'];
};

/** Billing Customer Portal invoice generate payment link. */
export type BillingCpPaymentLink = {
  __typename?: 'BillingCpPaymentLink';
  paymentLink: Scalars['String'];
};

/** cp payment methods */
export type BillingCpPaymentMethod = {
  __typename?: 'BillingCpPaymentMethod';
  bankAccount?: Maybe<BillingCpBankAccountDetails>;
  card?: Maybe<BillingCpCardDetails>;
  createdAt: Scalars['Int'];
  customerId: Scalars['String'];
  deleted: Scalars['Boolean'];
  gateway: Scalars['String'];
  gatewayAccountId: Scalars['String'];
  id: Scalars['String'];
  isPrimary: Scalars['Boolean'];
  issuingCountry?: Maybe<Scalars['String']>;
  referenceId: Scalars['String'];
  status: BillingEntitiesCpPaymentMethodPaymentSourceStatusEnum;
  type: BillingEntitiesCpPaymentMethodPaymentSourceTypeEnum;
  updatedAt: Scalars['Int'];
};

/** The connection type for BillingCpPaymentMethod. */
export type BillingCpPaymentMethodConnection = {
  __typename?: 'BillingCpPaymentMethodConnection';
  /** A list of edges. */
  edges: Array<BillingCpPaymentMethodEdge>;
  /** A list of nodes. */
  nodes: Array<BillingCpPaymentMethod>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type BillingCpPaymentMethodEdge = {
  __typename?: 'BillingCpPaymentMethodEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BillingCpPaymentMethod;
};

/** Billing Customer Portal Seat History. The resource represent a Seat History for a given subscription */
export type BillingCpSeatHistory = {
  __typename?: 'BillingCpSeatHistory';
  companyId: Scalars['String'];
  date: Scalars['String'];
  employees: Array<BillingCpEmployeeHistory>;
};

/** The connection type for BillingCpSeatHistory. */
export type BillingCpSeatHistoryConnection = {
  __typename?: 'BillingCpSeatHistoryConnection';
  /** A list of edges. */
  edges: Array<BillingCpSeatHistoryEdge>;
  /** A list of nodes. */
  nodes: Array<BillingCpSeatHistory>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type BillingCpSeatHistoryEdge = {
  __typename?: 'BillingCpSeatHistoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BillingCpSeatHistory;
};

/** cp_subscription */
export type BillingCpSubscription = {
  __typename?: 'BillingCpSubscription';
  activatedAt?: Maybe<Scalars['Int']>;
  billingPeriod?: Maybe<Scalars['Int']>;
  billingPeriodUnit?: Maybe<Scalars['String']>;
  chargebeeCustomerPortal?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Int']>;
  currencyCode: Scalars['String'];
  currentTermEnd?: Maybe<Scalars['Int']>;
  currentTermStart?: Maybe<Scalars['Int']>;
  customer: BillingCpCustomer;
  discounts?: Maybe<Array<BillingCustomerPortalDiscount>>;
  dueBannerState: BillingCustomerPortalDueBannerState;
  dueInvoicesCount?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  nextBillingAt?: Maybe<Scalars['Int']>;
  startedAt?: Maybe<Scalars['Int']>;
  status: Scalars['String'];
  subscriptionItems?: Maybe<Array<BillingCustomerPortalSubscriptionItem>>;
  totalAmount: Scalars['Int'];
};

/** cp subscription admin */
export type BillingCpSubscriptionAdmin = {
  __typename?: 'BillingCpSubscriptionAdmin';
  customer: BillingCpCustomer;
  id: Scalars['String'];
};

/** The connection type for BillingCpSubscription. */
export type BillingCpSubscriptionConnection = {
  __typename?: 'BillingCpSubscriptionConnection';
  /** A list of edges. */
  edges: Array<BillingCpSubscriptionEdge>;
  /** A list of nodes. */
  nodes: Array<BillingCpSubscription>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** Billing Customer Portal add contact to subscription */
export type BillingCpSubscriptionContact = {
  __typename?: 'BillingCpSubscriptionContact';
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  label?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  sendAccountEmail: Scalars['Boolean'];
  sendBillingEmail: Scalars['Boolean'];
};

/** The connection type for BillingCpSubscriptionContact. */
export type BillingCpSubscriptionContactConnection = {
  __typename?: 'BillingCpSubscriptionContactConnection';
  /** A list of edges. */
  edges: Array<BillingCpSubscriptionContactEdge>;
  /** A list of nodes. */
  nodes: Array<BillingCpSubscriptionContact>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type BillingCpSubscriptionContactEdge = {
  __typename?: 'BillingCpSubscriptionContactEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BillingCpSubscriptionContact;
};

/** An edge in a connection. */
export type BillingCpSubscriptionEdge = {
  __typename?: 'BillingCpSubscriptionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BillingCpSubscription;
};

export type BillingCpSubscriptionEstimate = {
  __typename?: 'BillingCpSubscriptionEstimate';
  currencyCode: Scalars['String'];
  nextBillingAt?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
};

export type BillingCustomerAccessInput = {
  customerCompanyId: Scalars['Int'];
  subscriptionId?: InputMaybe<Scalars['String']>;
};

export type BillingCustomerAccessSubscription = {
  __typename?: 'BillingCustomerAccessSubscription';
  customerCompanyId: Scalars['Int'];
  subscriptionId?: Maybe<Scalars['String']>;
};

/** customer_portal */
export type BillingCustomerPortal = {
  __typename?: 'BillingCustomerPortal';
  activatedAt?: Maybe<Scalars['Int']>;
  billingPeriod?: Maybe<Scalars['Int']>;
  billingPeriodUnit?: Maybe<Scalars['String']>;
  chargebeeCustomerPortal?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Int']>;
  currencyCode: Scalars['String'];
  currentTermEnd?: Maybe<Scalars['Int']>;
  currentTermStart?: Maybe<Scalars['Int']>;
  customer: BillingCpCustomer;
  discounts?: Maybe<Array<BillingCustomerPortalDiscount>>;
  dueBannerState: BillingCustomerPortalDueBannerState;
  dueInvoicesCount?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  nextBillingAt?: Maybe<Scalars['Int']>;
  startedAt?: Maybe<Scalars['Int']>;
  status: Scalars['String'];
  subscriptionItems?: Maybe<Array<BillingCustomerPortalSubscriptionItem>>;
  totalAmount: Scalars['Int'];
};

export type BillingCustomerPortalDiscount = {
  __typename?: 'BillingCustomerPortalDiscount';
  amount?: Maybe<Scalars['Int']>;
  appliedCount: Scalars['Int'];
  applyOn: Scalars['String'];
  applyTill?: Maybe<Scalars['Int']>;
  createdAt: Scalars['Int'];
  currencyCode?: Maybe<Scalars['String']>;
  durationType: Scalars['String'];
  id: Scalars['String'];
  invoiceName?: Maybe<Scalars['String']>;
  itemPriceId?: Maybe<Scalars['String']>;
  percentage?: Maybe<Scalars['Float']>;
  period?: Maybe<Scalars['Int']>;
  periodUnit?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type BillingCustomerPortalDueBannerState = {
  __typename?: 'BillingCustomerPortalDueBannerState';
  daysToBlock?: Maybe<Scalars['Int']>;
  status: Scalars['String'];
};

export type BillingCustomerPortalSubscriptionItem = {
  __typename?: 'BillingCustomerPortalSubscriptionItem';
  amount: Scalars['Int'];
  itemName?: Maybe<Scalars['String']>;
  itemPriceId: Scalars['String'];
  itemType: Scalars['String'];
  pricingModel?: Maybe<Scalars['String']>;
  seats: Scalars['Int'];
  unitPrice: Scalars['Int'];
};

/** cp due payments updated */
export type BillingDuePaymentsUpdate = {
  __typename?: 'BillingDuePaymentsUpdate';
  country: Scalars['String'];
  dueInvoicesCount: Scalars['Int'];
  subscriptionId: Scalars['String'];
};

export type BillingEntitiesCpInvoiceStatusEnum =
  | 'not_paid'
  | 'paid'
  | 'payment_due'
  | 'pending'
  | 'posted'
  | 'voided';

export type BillingEntitiesCpPaymentMethodPaymentSourceStatusEnum =
  | 'expired'
  | 'invalid'
  | 'valid';

export type BillingEntitiesCpPaymentMethodPaymentSourceTypeEnum =
  | 'bank_account'
  | 'card'
  | 'direct_debit';

export type BillingEstimateDiscount = {
  __typename?: 'BillingEstimateDiscount';
  amount?: Maybe<Scalars['Float']>;
  discountPercentage?: Maybe<Scalars['Float']>;
  discountType?: Maybe<Scalars['String']>;
  lineItemId?: Maybe<Scalars['String']>;
  period?: Maybe<Scalars['Int']>;
  periodUnit?: Maybe<Scalars['String']>;
};

/** estimate_prorate */
export type BillingEstimateProrate = {
  __typename?: 'BillingEstimateProrate';
  amount?: Maybe<Scalars['Float']>;
  currency?: Maybe<Scalars['String']>;
  discounts: Array<BillingEstimateDiscount>;
};

/** Billing Customer Portal headquarter */
export type BillingHeadquarter = {
  __typename?: 'BillingHeadquarter';
  country: Scalars['String'];
  id: Scalars['String'];
};

/** The connection type for BillingHeadquarter. */
export type BillingHeadquarterConnection = {
  __typename?: 'BillingHeadquarterConnection';
  /** A list of edges. */
  edges: Array<BillingHeadquarterEdge>;
  /** A list of nodes. */
  nodes: Array<BillingHeadquarter>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type BillingHeadquarterEdge = {
  __typename?: 'BillingHeadquarterEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BillingHeadquarter;
};

/** paying companies */
export type BillingPayingCompany = {
  __typename?: 'BillingPayingCompany';
  companyId?: Maybe<Scalars['Int']>;
  companyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  subscriptionId?: Maybe<Scalars['String']>;
};

/** The connection type for BillingPayingCompany. */
export type BillingPayingCompanyConnection = {
  __typename?: 'BillingPayingCompanyConnection';
  /** A list of edges. */
  edges: Array<BillingPayingCompanyEdge>;
  /** A list of nodes. */
  nodes: Array<BillingPayingCompany>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type BillingPayingCompanyEdge = {
  __typename?: 'BillingPayingCompanyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BillingPayingCompany;
};

/** A repository to retrieve subscriptions data. */
export type BillingSubscription = {
  __typename?: 'BillingSubscription';
  atsPlan?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['Int']>;
  createdAt: Scalars['ISO8601DateTime'];
  currentCycleQuantity?: Maybe<Scalars['Int']>;
  employeesLimit: Scalars['Int'];
  expensesQuantityCeiling?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  inExpiredFreeTrial: Scalars['Boolean'];
  inFreeTrial: Scalars['Boolean'];
  isF25Plan?: Maybe<Scalars['Boolean']>;
  isLegacy?: Maybe<Scalars['Boolean']>;
  isPre2022Legacy?: Maybe<Scalars['Boolean']>;
  observations?: Maybe<Scalars['String']>;
  paymentGatewayId?: Maybe<Scalars['String']>;
  plan: Scalars['String'];
  planFamily?: Maybe<Scalars['String']>;
  seatCount: Scalars['Int'];
};

/** The connection type for BillingSubscription. */
export type BillingSubscriptionConnection = {
  __typename?: 'BillingSubscriptionConnection';
  /** A list of edges. */
  edges: Array<BillingSubscriptionEdge>;
  /** A list of nodes. */
  nodes: Array<BillingSubscription>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type BillingSubscriptionEdge = {
  __typename?: 'BillingSubscriptionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BillingSubscription;
};

/** A repository to retrieve subscriptions items from a subscription. */
export type BillingSubscriptionItem = {
  __typename?: 'BillingSubscriptionItem';
  itemIds?: Maybe<Array<Scalars['String']>>;
};

/** The connection type for BillingSubscriptionItem. */
export type BillingSubscriptionItemConnection = {
  __typename?: 'BillingSubscriptionItemConnection';
  /** A list of edges. */
  edges: Array<BillingSubscriptionItemEdge>;
  /** A list of nodes. */
  nodes: Array<BillingSubscriptionItem>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type BillingSubscriptionItemEdge = {
  __typename?: 'BillingSubscriptionItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BillingSubscriptionItem;
};

/** upgrade_line_item */
export type BillingUpgradeLineItem = {
  __typename?: 'BillingUpgradeLineItem';
  action: Scalars['String'];
  newAddonsIds: Array<Scalars['String']>;
  oldAddonsIds: Array<Scalars['String']>;
  pdfUrl?: Maybe<Scalars['String']>;
};

/** upgrade_subscription */
export type BillingUpgradeSubscription = {
  __typename?: 'BillingUpgradeSubscription';
  newAddonsIds: Array<Scalars['String']>;
  oldAddonsIds: Array<Scalars['String']>;
  pdfUrl?: Maybe<Scalars['String']>;
};

export type BillingUpsellInfoInput = {
  billingDate: Scalars['String'];
  billingPeriod: Scalars['String'];
  currency: Scalars['String'];
  itemName: Scalars['String'];
  lineItemId: Scalars['String'];
  moduleRequested: Scalars['String'];
  priceFixed?: InputMaybe<Scalars['Float']>;
  pricePerSeat?: InputMaybe<Scalars['Float']>;
  priceStairstep?: InputMaybe<Scalars['Float']>;
  proratedPrice?: InputMaybe<Scalars['Float']>;
  requestSource?: InputMaybe<Scalars['String']>;
  requestSourceCategory?: InputMaybe<Scalars['String']>;
  requestSourceComponent?: InputMaybe<Scalars['String']>;
  seats: Scalars['Int'];
  totalPrice: Scalars['Float'];
  upsellRequestType?: InputMaybe<Scalars['String']>;
};

export type BillingValueObjectsAtsAddonEnum =
  | 'ats_5_jobs'
  | 'ats_10_jobs'
  | 'ats_unlimited_jobs';

/** Autogenerated return type of Billing_cp_chat_chat_subscription. */
export type Billing_Cp_Chat_Chat_SubscriptionPayload = {
  __typename?: 'Billing_cp_chat_chat_subscriptionPayload';
  cpChat?: Maybe<Cp_Chat_Chat_Type>;
};

/** Autogenerated return type of Billing_cp_export_invoice_initiate_export_subscription. */
export type Billing_Cp_Export_Invoice_Initiate_Export_SubscriptionPayload = {
  __typename?: 'Billing_cp_export_invoice_initiate_export_subscriptionPayload';
  cpExportInvoice?: Maybe<Cp_Export_Invoice_Initiate_Export_Type>;
};

/** Autogenerated return type of Billing_due_payments_update_payment_count_updated_subscription. */
export type Billing_Due_Payments_Update_Payment_Count_Updated_SubscriptionPayload = {
  __typename?: 'Billing_due_payments_update_payment_count_updated_subscriptionPayload';
  duePaymentsUpdate?: Maybe<Due_Payments_Update_Payment_Count_Updated_Type>;
};

/** Bookkeepers */
export type BookkeepersManagementBookkeeper = {
  __typename?: 'BookkeepersManagementBookkeeper';
  access?: Maybe<ApiCoreAccess>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  accessId: Scalars['Int'];
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


/** Bookkeepers */
export type BookkeepersManagementBookkeeperAccessArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};

/** Bookkeepers management bookkeeper access */
export type BookkeepersManagementBookkeeperAccess = {
  __typename?: 'BookkeepersManagementBookkeeperAccess';
  access?: Maybe<ApiCoreAccess>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  accessId: Scalars['Int'];
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


/** Bookkeepers management bookkeeper access */
export type BookkeepersManagementBookkeeperAccessAccessArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};

/** Bookkeepers management bookkeeper company */
export type BookkeepersManagementBookkeeperCompany = {
  __typename?: 'BookkeepersManagementBookkeeperCompany';
  active: Scalars['Boolean'];
  companyId: Scalars['Int'];
  companyName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The connection type for BookkeepersManagementBookkeeperCompany. */
export type BookkeepersManagementBookkeeperCompanyConnection = {
  __typename?: 'BookkeepersManagementBookkeeperCompanyConnection';
  /** A list of edges. */
  edges: Array<BookkeepersManagementBookkeeperCompanyEdge>;
  /** A list of nodes. */
  nodes: Array<BookkeepersManagementBookkeeperCompany>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type BookkeepersManagementBookkeeperCompanyEdge = {
  __typename?: 'BookkeepersManagementBookkeeperCompanyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BookkeepersManagementBookkeeperCompany;
};

/** The connection type for BookkeepersManagementBookkeeper. */
export type BookkeepersManagementBookkeeperConnection = {
  __typename?: 'BookkeepersManagementBookkeeperConnection';
  /** A list of edges. */
  edges: Array<BookkeepersManagementBookkeeperEdge>;
  /** A list of nodes. */
  nodes: Array<BookkeepersManagementBookkeeper>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** BookkeeperCustomers */
export type BookkeepersManagementBookkeeperCustomer = {
  __typename?: 'BookkeepersManagementBookkeeperCustomer';
  bookkeeperCompanyId: Scalars['Int'];
  bookkeepersCount: Scalars['Int'];
  customerCompanyId: Scalars['Int'];
  customerCompanyName: Scalars['String'];
  customerSince?: Maybe<Scalars['ISO8601Date']>;
  id: Scalars['Int'];
  permissionsGroupId?: Maybe<Scalars['Int']>;
};

/** The connection type for BookkeepersManagementBookkeeperCustomer. */
export type BookkeepersManagementBookkeeperCustomerConnection = {
  __typename?: 'BookkeepersManagementBookkeeperCustomerConnection';
  /** A list of edges. */
  edges: Array<BookkeepersManagementBookkeeperCustomerEdge>;
  /** A list of nodes. */
  nodes: Array<BookkeepersManagementBookkeeperCustomer>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type BookkeepersManagementBookkeeperCustomerEdge = {
  __typename?: 'BookkeepersManagementBookkeeperCustomerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BookkeepersManagementBookkeeperCustomer;
};

/** An edge in a connection. */
export type BookkeepersManagementBookkeeperEdge = {
  __typename?: 'BookkeepersManagementBookkeeperEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BookkeepersManagementBookkeeper;
};

export type BookkeepersManagementContextlessPolicies = {
  __typename?: 'BookkeepersManagementContextlessPolicies';
  seePayrollIncidencesSettings: ContextlessPolicyResolution;
};

/** Incidences */
export type BookkeepersManagementIncidence = {
  __typename?: 'BookkeepersManagementIncidence';
  /** identifier of company related. */
  companyId: Scalars['Int'];
  /** Date in which incidence (aka employee update) was created. */
  createdAt: Scalars['String'];
  customName?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['String']>;
  employee?: Maybe<EmployeesEmployee>;
  employeeFirstName?: Maybe<Scalars['String']>;
  /**
   * identifier of employee related.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  employeeId?: Maybe<Scalars['Int']>;
  employeeLastName?: Maybe<Scalars['String']>;
  /** The date the incidence (aka employee update) end. */
  endsOn?: Maybe<Scalars['ISO8601Date']>;
  /** Boolean that indicates if the incidence (aka employee update) has unread messages. */
  hasMessage?: Maybe<Scalars['Boolean']>;
  /** identifier of the incidence (aka employee update). */
  id: Scalars['Int'];
  /** Boolean that indicates if the incidence (aka employee update) has been reopened. */
  isReopened: Scalars['Boolean'];
  legalEntity?: Maybe<CompaniesLegalEntity>;
  /**
   * identifier of legal entity related.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  legalEntityId: Scalars['Int'];
  legalEntityName?: Maybe<Scalars['String']>;
  /** Indicate the message sender on the incidence (aka employee update). It can be any of 'bookkeeper', 'admin' */
  messageFrom?: Maybe<Scalars['String']>;
  /**
   * name of the incidence (aka employee update). It also represent the incidence
   * type. For example a new hire incidence will be
   */
  name: Scalars['String'];
  /** The date the incidence (aka employee update) was read. */
  readAt?: Maybe<Scalars['String']>;
  ruleEvaluation?: Maybe<BookkeepersManagementIncidenceRuleEvaluation>;
  /** The date the incidence (aka employee update) starts. */
  startsOn?: Maybe<Scalars['ISO8601Date']>;
  status: Scalars['String'];
  /**
   * The incidence (aka employee update) is also related to a another resource, for
   * example for a leave target, the target identifier will be the leave id.
   */
  targetId: Scalars['Int'];
  /**
   * The incidence (aka employee update) is also related to a another resource, for
   * example a leave. This is the target type. The other types are Employee,
   * Contracts::ContractVersion, BookkeepersManagement::ManualIncidence,
   * Finance::CostCenterMembership.
   */
  targetType: Scalars['String'];
  taskStatuses: Array<BookkeepersManagementTaskStatus>;
  taskstatusesConnection: BookkeepersManagementTaskStatusConnection;
};


/** Incidences */
export type BookkeepersManagementIncidenceEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Incidences */
export type BookkeepersManagementIncidenceLegalEntityArgs = {
  companiesIds?: InputMaybe<Array<Scalars['Int']>>;
  countryIds?: InputMaybe<Array<Scalars['String']>>;
  employeesIds?: InputMaybe<Array<Scalars['Int']>>;
  excludeCountries?: InputMaybe<Array<Scalars['String']>>;
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


/** Incidences */
export type BookkeepersManagementIncidenceTaskStatusesArgs = {
  incidenceId?: InputMaybe<Scalars['Int']>;
  taskTypeId?: InputMaybe<Scalars['Int']>;
};


/** Incidences */
export type BookkeepersManagementIncidenceTaskstatusesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  incidenceId?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  taskTypeId?: InputMaybe<Scalars['Int']>;
};

/** Bookkeepers management incidence change */
export type BookkeepersManagementIncidenceChange = {
  __typename?: 'BookkeepersManagementIncidenceChange';
  category: Scalars['String'];
  changes: Array<BookkeepersManagementIncidenceFieldChange>;
};

/** The connection type for BookkeepersManagementIncidenceChange. */
export type BookkeepersManagementIncidenceChangeConnection = {
  __typename?: 'BookkeepersManagementIncidenceChangeConnection';
  /** A list of edges. */
  edges: Array<BookkeepersManagementIncidenceChangeEdge>;
  /** A list of nodes. */
  nodes: Array<BookkeepersManagementIncidenceChange>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type BookkeepersManagementIncidenceChangeEdge = {
  __typename?: 'BookkeepersManagementIncidenceChangeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BookkeepersManagementIncidenceChange;
};

/** The connection type for BookkeepersManagementIncidence. */
export type BookkeepersManagementIncidenceConnection = {
  __typename?: 'BookkeepersManagementIncidenceConnection';
  /** A list of edges. */
  edges: Array<BookkeepersManagementIncidenceEdge>;
  /** A list of nodes. */
  nodes: Array<BookkeepersManagementIncidence>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type BookkeepersManagementIncidenceEdge = {
  __typename?: 'BookkeepersManagementIncidenceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BookkeepersManagementIncidence;
};

export type BookkeepersManagementIncidenceFieldChange = {
  __typename?: 'BookkeepersManagementIncidenceFieldChange';
  field: Scalars['String'];
  label: Scalars['String'];
  newValue?: Maybe<Scalars['String']>;
  oldValue?: Maybe<Scalars['String']>;
};

/** Incidence message stats */
export type BookkeepersManagementIncidenceMessageStat = {
  __typename?: 'BookkeepersManagementIncidenceMessageStat';
  additionalCompensationChange: Scalars['Int'];
  address: Scalars['Int'];
  bank: Scalars['Int'];
  contract: Scalars['Int'];
  costCenter: Scalars['Int'];
  customLeave: Scalars['Int'];
  email: Scalars['Int'];
  gender: Scalars['Int'];
  hiring: Scalars['Int'];
  id: Scalars['String'];
  irpf: Scalars['Int'];
  legalEntity: Scalars['Int'];
  manualIncidence: Scalars['Int'];
  name: Scalars['Int'];
  nationality: Scalars['Int'];
  otherContractUpdates: Scalars['Int'];
  parental: Scalars['Int'];
  residence: Scalars['Int'];
  salaryUpdate: Scalars['Int'];
  sick: Scalars['Int'];
  status: Scalars['String'];
  termination: Scalars['Int'];
  workScheduleUpdate: Scalars['Int'];
  workplace: Scalars['Int'];
};

/** The connection type for BookkeepersManagementIncidenceMessageStat. */
export type BookkeepersManagementIncidenceMessageStatConnection = {
  __typename?: 'BookkeepersManagementIncidenceMessageStatConnection';
  /** A list of edges. */
  edges: Array<BookkeepersManagementIncidenceMessageStatEdge>;
  /** A list of nodes. */
  nodes: Array<BookkeepersManagementIncidenceMessageStat>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type BookkeepersManagementIncidenceMessageStatEdge = {
  __typename?: 'BookkeepersManagementIncidenceMessageStatEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BookkeepersManagementIncidenceMessageStat;
};

/** Incidence options set by companies */
export type BookkeepersManagementIncidenceOption = {
  __typename?: 'BookkeepersManagementIncidenceOption';
  companyId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  incidenceName: Scalars['String'];
  leaveTypeId?: Maybe<Scalars['Int']>;
  needsValidation: Scalars['Boolean'];
  trackIncidence: Scalars['Boolean'];
};

/** The connection type for BookkeepersManagementIncidenceOption. */
export type BookkeepersManagementIncidenceOptionConnection = {
  __typename?: 'BookkeepersManagementIncidenceOptionConnection';
  /** A list of edges. */
  edges: Array<BookkeepersManagementIncidenceOptionEdge>;
  /** A list of nodes. */
  nodes: Array<BookkeepersManagementIncidenceOption>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type BookkeepersManagementIncidenceOptionEdge = {
  __typename?: 'BookkeepersManagementIncidenceOptionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BookkeepersManagementIncidenceOption;
};

/** Bookkeepers management incidence payroll integration status */
export type BookkeepersManagementIncidencePayrollIntegrationStatus = {
  __typename?: 'BookkeepersManagementIncidencePayrollIntegrationStatus';
  incidenceId: Scalars['Int'];
  status: PayrollIntegrationsBaseEntitiesSyncStatusEnum;
};

/** The connection type for BookkeepersManagementIncidencePayrollIntegrationStatus. */
export type BookkeepersManagementIncidencePayrollIntegrationStatusConnection = {
  __typename?: 'BookkeepersManagementIncidencePayrollIntegrationStatusConnection';
  /** A list of edges. */
  edges: Array<BookkeepersManagementIncidencePayrollIntegrationStatusEdge>;
  /** A list of nodes. */
  nodes: Array<BookkeepersManagementIncidencePayrollIntegrationStatus>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type BookkeepersManagementIncidencePayrollIntegrationStatusEdge = {
  __typename?: 'BookkeepersManagementIncidencePayrollIntegrationStatusEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BookkeepersManagementIncidencePayrollIntegrationStatus;
};

/** Incidence Rules that must be met before an incidence should be sent to the bookkeeper */
export type BookkeepersManagementIncidenceRule = {
  __typename?: 'BookkeepersManagementIncidenceRule';
  companyId: Scalars['Int'];
  enforced: Scalars['Boolean'];
  enforcement: BookkeepersManagementValueObjectsIncidenceRuleEnforcementEnum;
  field: Scalars['String'];
  id: Scalars['Int'];
  incidenceType: Scalars['String'];
};

/** The connection type for BookkeepersManagementIncidenceRule. */
export type BookkeepersManagementIncidenceRuleConnection = {
  __typename?: 'BookkeepersManagementIncidenceRuleConnection';
  /** A list of edges. */
  edges: Array<BookkeepersManagementIncidenceRuleEdge>;
  /** A list of nodes. */
  nodes: Array<BookkeepersManagementIncidenceRule>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type BookkeepersManagementIncidenceRuleEdge = {
  __typename?: 'BookkeepersManagementIncidenceRuleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BookkeepersManagementIncidenceRule;
};

/** Evaluation results for Incidence Rules that must be met before an incidence can be sent to the bookkeeper */
export type BookkeepersManagementIncidenceRuleEvaluation = {
  __typename?: 'BookkeepersManagementIncidenceRuleEvaluation';
  id: Scalars['Int'];
  incidence?: Maybe<BookkeepersManagementIncidence>;
  missingFields: Array<BookkeepersManagementMissingField>;
  validity: BookkeepersManagementValueObjectsIncidenceRuleValidityEnum;
};


/** Evaluation results for Incidence Rules that must be met before an incidence can be sent to the bookkeeper */
export type BookkeepersManagementIncidenceRuleEvaluationIncidenceArgs = {
  containsMessage?: InputMaybe<Scalars['Boolean']>;
  customLeaveName?: InputMaybe<Array<Scalars['String']>>;
  direction?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endsOn?: InputMaybe<Scalars['ISO8601Date']>;
  legalEntitiesIds?: InputMaybe<Array<Scalars['Int']>>;
  messageFrom?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
  startsOn?: InputMaybe<Scalars['ISO8601Date']>;
  status?: InputMaybe<Array<Scalars['String']>>;
  type?: InputMaybe<Array<Scalars['String']>>;
  workplaceIds?: InputMaybe<Array<Scalars['Int']>>;
};

/** The connection type for BookkeepersManagementIncidenceRuleEvaluation. */
export type BookkeepersManagementIncidenceRuleEvaluationConnection = {
  __typename?: 'BookkeepersManagementIncidenceRuleEvaluationConnection';
  /** A list of edges. */
  edges: Array<BookkeepersManagementIncidenceRuleEvaluationEdge>;
  /** A list of nodes. */
  nodes: Array<BookkeepersManagementIncidenceRuleEvaluation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type BookkeepersManagementIncidenceRuleEvaluationEdge = {
  __typename?: 'BookkeepersManagementIncidenceRuleEvaluationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BookkeepersManagementIncidenceRuleEvaluation;
};

/** Incidence stats */
export type BookkeepersManagementIncidenceStat = {
  __typename?: 'BookkeepersManagementIncidenceStat';
  additionalCompensationChange: Scalars['Int'];
  address: Scalars['Int'];
  bank: Scalars['Int'];
  contract: Scalars['Int'];
  costCenter: Scalars['Int'];
  customLeave: Scalars['Int'];
  email: Scalars['Int'];
  gender: Scalars['Int'];
  hiring: Scalars['Int'];
  id: Scalars['String'];
  irpf: Scalars['Int'];
  legalEntity: Scalars['Int'];
  manualIncidence: Scalars['Int'];
  name: Scalars['Int'];
  nationality: Scalars['Int'];
  otherContractUpdates: Scalars['Int'];
  parental: Scalars['Int'];
  residence: Scalars['Int'];
  salaryUpdate: Scalars['Int'];
  sick: Scalars['Int'];
  status: Scalars['String'];
  termination: Scalars['Int'];
  workScheduleUpdate: Scalars['Int'];
  workplace: Scalars['Int'];
};

/** The connection type for BookkeepersManagementIncidenceStat. */
export type BookkeepersManagementIncidenceStatConnection = {
  __typename?: 'BookkeepersManagementIncidenceStatConnection';
  /** A list of edges. */
  edges: Array<BookkeepersManagementIncidenceStatEdge>;
  /** A list of nodes. */
  nodes: Array<BookkeepersManagementIncidenceStat>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type BookkeepersManagementIncidenceStatEdge = {
  __typename?: 'BookkeepersManagementIncidenceStatEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BookkeepersManagementIncidenceStat;
};

export type BookkeepersManagementMissingField = {
  __typename?: 'BookkeepersManagementMissingField';
  field: Scalars['String'];
  severity: BookkeepersManagementValueObjectsIncidenceRuleEnforcementEnum;
};

/** Payroll cycle variable export */
export type BookkeepersManagementPayrollCycleVariableExport = {
  __typename?: 'BookkeepersManagementPayrollCycleVariableExport';
  success: Scalars['Boolean'];
};

/** Document attached to incidences task */
export type BookkeepersManagementTaskDocument = {
  __typename?: 'BookkeepersManagementTaskDocument';
  access?: Maybe<ApiCoreAccess>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  authorId?: Maybe<Scalars['Int']>;
  createdAt: Scalars['ISO8601DateTime'];
  documentFilename?: Maybe<Scalars['String']>;
  documentId: Scalars['Int'];
  documentType?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  incidenceId: Scalars['Int'];
  taskTypeId: Scalars['Int'];
};


/** Document attached to incidences task */
export type BookkeepersManagementTaskDocumentAccessArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for BookkeepersManagementTaskDocument. */
export type BookkeepersManagementTaskDocumentConnection = {
  __typename?: 'BookkeepersManagementTaskDocumentConnection';
  /** A list of edges. */
  edges: Array<BookkeepersManagementTaskDocumentEdge>;
  /** A list of nodes. */
  nodes: Array<BookkeepersManagementTaskDocument>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type BookkeepersManagementTaskDocumentEdge = {
  __typename?: 'BookkeepersManagementTaskDocumentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BookkeepersManagementTaskDocument;
};

/** Status of incidences task */
export type BookkeepersManagementTaskStatus = {
  __typename?: 'BookkeepersManagementTaskStatus';
  accessName?: Maybe<Scalars['String']>;
  completed: Scalars['Boolean'];
  id: Scalars['Int'];
  incidenceId: Scalars['Int'];
  taskType?: Maybe<BookkeepersManagementTaskType>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  taskTypeId: Scalars['Int'];
  updatedAt: Scalars['String'];
};


/** Status of incidences task */
export type BookkeepersManagementTaskStatusTaskTypeArgs = {
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  incidenceName?: InputMaybe<Scalars['String']>;
};

/** The connection type for BookkeepersManagementTaskStatus. */
export type BookkeepersManagementTaskStatusConnection = {
  __typename?: 'BookkeepersManagementTaskStatusConnection';
  /** A list of edges. */
  edges: Array<BookkeepersManagementTaskStatusEdge>;
  /** A list of nodes. */
  nodes: Array<BookkeepersManagementTaskStatus>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type BookkeepersManagementTaskStatusEdge = {
  __typename?: 'BookkeepersManagementTaskStatusEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BookkeepersManagementTaskStatus;
};

/** Bookkeepers management task type */
export type BookkeepersManagementTaskType = {
  __typename?: 'BookkeepersManagementTaskType';
  companyId: Scalars['Int'];
  folderId?: Maybe<Scalars['Int']>;
  folderIdentifier?: Maybe<Scalars['String']>;
  folderType?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  identifier?: Maybe<Scalars['String']>;
  incidenceName?: Maybe<Scalars['String']>;
  leaveTypeId?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
  translatedTitle: Scalars['String'];
};

/** The connection type for BookkeepersManagementTaskType. */
export type BookkeepersManagementTaskTypeConnection = {
  __typename?: 'BookkeepersManagementTaskTypeConnection';
  /** A list of edges. */
  edges: Array<BookkeepersManagementTaskTypeEdge>;
  /** A list of nodes. */
  nodes: Array<BookkeepersManagementTaskType>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type BookkeepersManagementTaskTypeEdge = {
  __typename?: 'BookkeepersManagementTaskTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BookkeepersManagementTaskType;
};

export type BookkeepersManagementValueObjectsIncidenceRuleEnforcementEnum =
  | 'blockage'
  | 'recommendation';

export type BookkeepersManagementValueObjectsIncidenceRuleValidityEnum =
  | 'blocked'
  | 'valid'
  | 'warning';

export type BooleanFilter = {
  eq?: InputMaybe<Scalars['Boolean']>;
  notEq?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated return type of BreakEndAttendanceBreakShift. */
export type BreakEndAttendanceBreakShiftPayload = {
  __typename?: 'BreakEndAttendanceBreakShiftPayload';
  breakShift?: Maybe<AttendanceBreakShift>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of BreakEndAttendanceShift. */
export type BreakEndAttendanceShiftPayload = {
  __typename?: 'BreakEndAttendanceShiftPayload';
  errors: Array<MutationError>;
  shift?: Maybe<AttendanceShift>;
};

/** Autogenerated return type of BreakStartAttendanceBreakShift. */
export type BreakStartAttendanceBreakShiftPayload = {
  __typename?: 'BreakStartAttendanceBreakShiftPayload';
  breakShift?: Maybe<AttendanceBreakShift>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of BreakStartAttendanceShift. */
export type BreakStartAttendanceShiftPayload = {
  __typename?: 'BreakStartAttendanceShiftPayload';
  errors: Array<MutationError>;
  shift?: Maybe<AttendanceShift>;
};

/** Autogenerated return type of BuildPayrollResult. */
export type BuildPayrollResultPayload = {
  __typename?: 'BuildPayrollResultPayload';
  errors: Array<MutationError>;
  result?: Maybe<PayrollResult>;
};

export type BuildPayrollResultResultConceptItemsInput = {
  amount: Scalars['Int'];
  employeeId: Scalars['Int'];
  payrollConceptId: Scalars['Int'];
};

/** Autogenerated return type of BulkActivateBenefitsEmployeeActivation. */
export type BulkActivateBenefitsEmployeeActivationPayload = {
  __typename?: 'BulkActivateBenefitsEmployeeActivationPayload';
  employeeActivation?: Maybe<BenefitsEmployeeActivation>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of BulkAddToGroupExpensesExpensable. */
export type BulkAddToGroupExpensesExpensablePayload = {
  __typename?: 'BulkAddToGroupExpensesExpensablePayload';
  errors: Array<MutationError>;
  expensables?: Maybe<Array<ExpensesExpensable>>;
};

/** Autogenerated return type of BulkAddToPayrollExpensesExpensable. */
export type BulkAddToPayrollExpensesExpensablePayload = {
  __typename?: 'BulkAddToPayrollExpensesExpensablePayload';
  errors: Array<MutationError>;
  expensables?: Maybe<Array<ExpensesExpensable>>;
};

/** Autogenerated return type of BulkApproveApprovalsMaterializedApprovalsFlow. */
export type BulkApproveApprovalsMaterializedApprovalsFlowPayload = {
  __typename?: 'BulkApproveApprovalsMaterializedApprovalsFlowPayload';
  errors: Array<MutationError>;
  materializedApprovalsFlows?: Maybe<Array<ApprovalsMaterializedApprovalsFlow>>;
};

/** Autogenerated return type of BulkApproveApprovalsv2ReviewRequest. */
export type BulkApproveApprovalsv2ReviewRequestPayload = {
  __typename?: 'BulkApproveApprovalsv2ReviewRequestPayload';
  errors: Array<MutationError>;
  reviewRequests?: Maybe<Array<ApprovalsV2ReviewRequest>>;
};

/** Autogenerated return type of BulkApproveExpensesExpensable. */
export type BulkApproveExpensesExpensablePayload = {
  __typename?: 'BulkApproveExpensesExpensablePayload';
  errors: Array<MutationError>;
  expensables?: Maybe<Array<ExpensesExpensable>>;
};

/** Autogenerated return type of BulkAssignApprovalsApprovalGroupMembership. */
export type BulkAssignApprovalsApprovalGroupMembershipPayload = {
  __typename?: 'BulkAssignApprovalsApprovalGroupMembershipPayload';
  approvalGroupMemberships?: Maybe<Array<ApprovalsApprovalGroupMembership>>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of BulkAssignContractsPayrollPolicy. */
export type BulkAssignContractsPayrollPolicyPayload = {
  __typename?: 'BulkAssignContractsPayrollPolicyPayload';
  errors: Array<MutationError>;
  payrollPolicy?: Maybe<ContractsPayrollPolicy>;
};

export type BulkAssignEmployeesTimeoffPolicyMappingsInput = {
  _destroy: Scalars['Boolean'];
  newAllowanceId: Scalars['Int'];
  originalAllowanceId: Scalars['Int'];
};

/** Autogenerated return type of BulkAssignEmployeesTimeoffPolicy. */
export type BulkAssignEmployeesTimeoffPolicyPayload = {
  __typename?: 'BulkAssignEmployeesTimeoffPolicyPayload';
  errors: Array<MutationError>;
  policy?: Maybe<TimeoffPolicy>;
};

export type BulkAssignJobcatalogNodeAttributeAttributesInput = {
  attributeCompetency?: InputMaybe<JobCatalogCompetencyAttributeInput>;
  attributeId: Scalars['String'];
  attributeItManagementAsset?: InputMaybe<JobCatalogItManagementAssetAttributeInput>;
  attributeSalaryRange?: InputMaybe<JobCatalogSalaryRangeAttributeInput>;
  attributeWorkingConditions?: InputMaybe<JobCatalogWorkingConditionsAttributeInput>;
};

/** Autogenerated return type of BulkAssignJobcatalogNodeAttribute. */
export type BulkAssignJobcatalogNodeAttributePayload = {
  __typename?: 'BulkAssignJobcatalogNodeAttributePayload';
  errors: Array<MutationError>;
  nodeAttributes?: Maybe<Array<JobCatalogNodeAttribute>>;
};

/** Autogenerated return type of BulkAssignLocationsEmployeesLocation. */
export type BulkAssignLocationsEmployeesLocationPayload = {
  __typename?: 'BulkAssignLocationsEmployeesLocationPayload';
  employeesLocations?: Maybe<Array<LocationsEmployeesLocation>>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of BulkAssignProjectmanagementProjectRole. */
export type BulkAssignProjectmanagementProjectRolePayload = {
  __typename?: 'BulkAssignProjectmanagementProjectRolePayload';
  errors: Array<MutationError>;
  projectRoles?: Maybe<Array<ProjectManagementProjectRole>>;
};

/** Autogenerated return type of BulkAssignProjectmanagementProjectWorker. */
export type BulkAssignProjectmanagementProjectWorkerPayload = {
  __typename?: 'BulkAssignProjectmanagementProjectWorkerPayload';
  errors: Array<MutationError>;
  projectWorkers?: Maybe<Array<ProjectManagementProjectWorker>>;
};

/** Autogenerated return type of BulkAssignToEmployeeGroupEmployeesEmployee. */
export type BulkAssignToEmployeeGroupEmployeesEmployeePayload = {
  __typename?: 'BulkAssignToEmployeeGroupEmployeesEmployeePayload';
  employees?: Maybe<Array<EmployeesEmployee>>;
  errors: Array<MutationError>;
};

export type BulkAssignToJobCatalogTreeCompetenciesCompetencyAssignmentsInput = {
  competencyId: Scalars['Int'];
  competencyLevelId?: InputMaybe<Scalars['Int']>;
  nodeUuid: Scalars['String'];
};

/** Autogenerated return type of BulkAssignToJobCatalogTreeCompetenciesCompetency. */
export type BulkAssignToJobCatalogTreeCompetenciesCompetencyPayload = {
  __typename?: 'BulkAssignToJobCatalogTreeCompetenciesCompetencyPayload';
  competencies?: Maybe<Array<CompetenciesCompetency>>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of BulkAssignTrainingsTrainingClassMembership. */
export type BulkAssignTrainingsTrainingClassMembershipPayload = {
  __typename?: 'BulkAssignTrainingsTrainingClassMembershipPayload';
  errors: Array<MutationError>;
  trainingClassMemberships?: Maybe<Array<TrainingsTrainingClassMembership>>;
};

export type BulkAssignmentsFinanceCostCenterMembershipMembershipsToCreateInput = {
  companyId: Scalars['Int'];
  costCenterId: Scalars['Int'];
  employeeId: Scalars['Int'];
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  percentage: Scalars['Float'];
  startDate: Scalars['ISO8601Date'];
};

export type BulkAssignmentsFinanceCostCenterMembershipMembershipsToUpdateInput = {
  costCenterId: Scalars['Int'];
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  id: Scalars['Int'];
  markedForDeletion: Scalars['Boolean'];
  percentage: Scalars['Float'];
  startDate: Scalars['ISO8601Date'];
};

/** Autogenerated return type of BulkAssignmentsFinanceCostCenterMembership. */
export type BulkAssignmentsFinanceCostCenterMembershipPayload = {
  __typename?: 'BulkAssignmentsFinanceCostCenterMembershipPayload';
  costCenterMemberships?: Maybe<Array<FinanceCostCenterMembership>>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of BulkCancelSpacecontrolBooking. */
export type BulkCancelSpacecontrolBookingPayload = {
  __typename?: 'BulkCancelSpacecontrolBookingPayload';
  bookings?: Maybe<Array<SpaceControlBooking>>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of BulkChangeAssignmentProjectmanagementProject. */
export type BulkChangeAssignmentProjectmanagementProjectPayload = {
  __typename?: 'BulkChangeAssignmentProjectmanagementProjectPayload';
  errors: Array<MutationError>;
  projects?: Maybe<Array<ProjectManagementProject>>;
};

/** Autogenerated return type of BulkChangeOwnershipItmanagementItAsset. */
export type BulkChangeOwnershipItmanagementItAssetPayload = {
  __typename?: 'BulkChangeOwnershipItmanagementItAssetPayload';
  errors: Array<MutationError>;
  itAssets?: Maybe<Array<ItManagementItAsset>>;
};

/** Autogenerated return type of BulkClientAssignmentProjectmanagementProject. */
export type BulkClientAssignmentProjectmanagementProjectPayload = {
  __typename?: 'BulkClientAssignmentProjectmanagementProjectPayload';
  errors: Array<MutationError>;
  projects?: Maybe<Array<ProjectManagementProject>>;
};

/** Autogenerated return type of BulkCopyShiftmanagementSchedule. */
export type BulkCopyShiftmanagementSchedulePayload = {
  __typename?: 'BulkCopyShiftmanagementSchedulePayload';
  errors: Array<MutationError>;
  schedule?: Maybe<ShiftManagementSchedule>;
};

/** Autogenerated return type of BulkCopyShiftmanagementUnassignedShift. */
export type BulkCopyShiftmanagementUnassignedShiftPayload = {
  __typename?: 'BulkCopyShiftmanagementUnassignedShiftPayload';
  errors: Array<MutationError>;
  unassignedShifts?: Maybe<Array<ShiftManagementUnassignedShift>>;
};

export type BulkCreateAtsFileFilesInput = {
  attachment: Scalars['File'];
  category?: InputMaybe<AtsFileOptionsCategoriesEnum>;
};

/** Autogenerated return type of BulkCreateAtsFile. */
export type BulkCreateAtsFilePayload = {
  __typename?: 'BulkCreateAtsFilePayload';
  errors: Array<MutationError>;
  files?: Maybe<Array<AtsFile>>;
};

/** Autogenerated return type of BulkCreateAtsHiringManager. */
export type BulkCreateAtsHiringManagerPayload = {
  __typename?: 'BulkCreateAtsHiringManagerPayload';
  errors: Array<MutationError>;
  hiringManagers?: Maybe<Array<AtsHiringManager>>;
};

/** Autogenerated return type of BulkCreateAtsInterviewAttendee. */
export type BulkCreateAtsInterviewAttendeePayload = {
  __typename?: 'BulkCreateAtsInterviewAttendeePayload';
  errors: Array<MutationError>;
  interviewAttendees?: Maybe<Array<AtsInterviewAttendee>>;
};

/** Autogenerated return type of BulkCreateAtsMessage. */
export type BulkCreateAtsMessagePayload = {
  __typename?: 'BulkCreateAtsMessagePayload';
  errors: Array<MutationError>;
  message?: Maybe<AtsMessage>;
};

export type BulkCreateAttendanceCompensationBlockBlockSelectionsInput = {
  endOn: Scalars['ISO8601Date'];
  selectionKey: Scalars['String'];
  startOn: Scalars['ISO8601Date'];
};

/** Autogenerated return type of BulkCreateAttendanceCompensationBlock. */
export type BulkCreateAttendanceCompensationBlockPayload = {
  __typename?: 'BulkCreateAttendanceCompensationBlockPayload';
  compensationBlock?: Maybe<AttendanceCompensationBlock>;
  errors: Array<MutationError>;
};

export type BulkCreateAttendanceCustomTimeRangeCustomTimeRangesInput = {
  attendanceCustomTimeRangeCategoryId?: InputMaybe<Scalars['Int']>;
  attendanceEmployeesSettingId: Scalars['Int'];
  date?: InputMaybe<Scalars['ISO8601Date']>;
  day?: InputMaybe<AttendanceCustomTimeRangeDayEnum>;
  endTime?: InputMaybe<Scalars['ISO8601DateTime']>;
  equivalentMinutesInCents?: InputMaybe<Scalars['Int']>;
  poolType: AttendanceEnumsPoolTypeEnum;
  rawMinutesInCents?: InputMaybe<Scalars['Int']>;
  startTime?: InputMaybe<Scalars['ISO8601DateTime']>;
  timeSettingsCustomTimeRangeCategoryId: Scalars['Int'];
};

/** Autogenerated return type of BulkCreateAttendanceCustomTimeRange. */
export type BulkCreateAttendanceCustomTimeRangePayload = {
  __typename?: 'BulkCreateAttendanceCustomTimeRangePayload';
  customTimeRanges?: Maybe<Array<AttendanceCustomTimeRange>>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of BulkCreateAttendanceReview. */
export type BulkCreateAttendanceReviewPayload = {
  __typename?: 'BulkCreateAttendanceReviewPayload';
  errors: Array<MutationError>;
  reviews?: Maybe<Array<AttendanceReview>>;
};

/** Autogenerated return type of BulkCreateAttendanceShift. */
export type BulkCreateAttendanceShiftPayload = {
  __typename?: 'BulkCreateAttendanceShiftPayload';
  errors: Array<MutationError>;
  shifts?: Maybe<Array<AttendanceShift>>;
};

export type BulkCreateAttendanceShiftShiftsInput = {
  accuracy?: InputMaybe<Scalars['Float']>;
  clockIn?: InputMaybe<Scalars['ISO8601DateTime']>;
  clockOffset?: InputMaybe<Scalars['String']>;
  clockOut?: InputMaybe<Scalars['ISO8601DateTime']>;
  date: Scalars['ISO8601Date'];
  day?: InputMaybe<Scalars['Int']>;
  editTimesheetRequestId?: InputMaybe<Scalars['Int']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  halfDay?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['Float']>;
  locationType?: InputMaybe<AttendanceShiftLocationTypeEnum>;
  longitude?: InputMaybe<Scalars['Float']>;
  observations?: InputMaybe<Scalars['String']>;
  precisionGranted?: InputMaybe<Scalars['Boolean']>;
  referenceDate?: InputMaybe<Scalars['ISO8601Date']>;
  source?: InputMaybe<AttendanceEnumsShiftSourceEnum>;
  timeSettingsBreakConfigurationId?: InputMaybe<Scalars['Int']>;
  workable?: InputMaybe<Scalars['Boolean']>;
};

export type BulkCreateBenefitsHealthcareEnrollmentExistingProfilesInput = {
  employeeId: Scalars['Int'];
  memberId: Scalars['Int'];
};

export type BulkCreateBenefitsHealthcareEnrollmentNewProfilesInput = {
  addressLine1: Scalars['String'];
  addressLine2?: InputMaybe<Scalars['String']>;
  birthday: Scalars['ISO8601Date'];
  city: Scalars['String'];
  companyId: Scalars['Int'];
  email: Scalars['String'];
  employeeId: Scalars['Int'];
  firstName: Scalars['String'];
  iban: Scalars['String'];
  lastName: Scalars['String'];
  memberType: BenefitsValueObjectsBenefitMembersMemberTypeEnum;
  phoneNumber: Scalars['String'];
  postalCode: Scalars['String'];
  province: Scalars['String'];
  sex: BenefitsValueObjectsBenefitMembersSexEnum;
  taxIdNumber: Scalars['String'];
  taxIdType: Scalars['String'];
};

/** Autogenerated return type of BulkCreateBenefitsHealthcareEnrollment. */
export type BulkCreateBenefitsHealthcareEnrollmentPayload = {
  __typename?: 'BulkCreateBenefitsHealthcareEnrollmentPayload';
  errors: Array<MutationError>;
  healthcareEnrollments?: Maybe<Array<BenefitsHealthcareEnrollment>>;
};

/** Autogenerated return type of BulkCreateCompensationsEmployeesCompensation. */
export type BulkCreateCompensationsEmployeesCompensationPayload = {
  __typename?: 'BulkCreateCompensationsEmployeesCompensationPayload';
  employeesCompensations?: Maybe<Array<CompensationsEmployeesCompensation>>;
  errors: Array<MutationError>;
};

export type BulkCreateCompensationsFileFilesInput = {
  file: Scalars['File'];
  fileCategoryId: Scalars['Int'];
};

/** Autogenerated return type of BulkCreateCompensationsFile. */
export type BulkCreateCompensationsFilePayload = {
  __typename?: 'BulkCreateCompensationsFilePayload';
  errors: Array<MutationError>;
  files?: Maybe<Array<CompensationsFile>>;
};

export type BulkCreateCompetenciesCompetencyCompetenciesInput = {
  competencyGroupId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  everyone?: InputMaybe<Scalars['Boolean']>;
  factorialCompetencyUuid?: InputMaybe<Scalars['String']>;
  jobCatalogTreeNodeUuids?: InputMaybe<Array<Scalars['String']>>;
  levels?: InputMaybe<Array<BulkCreateCompetenciesCompetencyLevelsInput>>;
  name: Scalars['String'];
  roleIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type BulkCreateCompetenciesCompetencyLevelLevelsInput = {
  description: Scalars['String'];
  name: Scalars['String'];
  position: Scalars['Int'];
};

/** Autogenerated return type of BulkCreateCompetenciesCompetencyLevel. */
export type BulkCreateCompetenciesCompetencyLevelPayload = {
  __typename?: 'BulkCreateCompetenciesCompetencyLevelPayload';
  competencyLevels?: Maybe<Array<CompetenciesCompetencyLevel>>;
  errors: Array<MutationError>;
};

export type BulkCreateCompetenciesCompetencyLevelsInput = {
  description: Scalars['String'];
  jobCatalogTreeNodeUuids?: InputMaybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  position: Scalars['Int'];
};

/** Autogenerated return type of BulkCreateCompetenciesCompetency. */
export type BulkCreateCompetenciesCompetencyPayload = {
  __typename?: 'BulkCreateCompetenciesCompetencyPayload';
  competencies?: Maybe<Array<CompetenciesCompetency>>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of BulkCreateContractsAdditionalCompensation. */
export type BulkCreateContractsAdditionalCompensationPayload = {
  __typename?: 'BulkCreateContractsAdditionalCompensationPayload';
  additionalCompensations?: Maybe<Array<ContractsAdditionalCompensation>>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of BulkCreateContractsTaxonomy. */
export type BulkCreateContractsTaxonomyPayload = {
  __typename?: 'BulkCreateContractsTaxonomyPayload';
  errors: Array<MutationError>;
  taxonomies?: Maybe<Array<ContractsTaxonomy>>;
};

export type BulkCreateDocumentsDocumentCustomFieldsInput = {
  resourceId: Scalars['String'];
  value: Scalars['String'];
};

/** Autogenerated return type of BulkCreateDocumentsDocument. */
export type BulkCreateDocumentsDocumentPayload = {
  __typename?: 'BulkCreateDocumentsDocumentPayload';
  documents?: Maybe<Array<DocumentsDocument>>;
  errors: Array<MutationError>;
};

export type BulkCreateDocumentsDocumentSigneeStampsInput = {
  fileId: Scalars['Int'];
  height: Scalars['Float'];
  left: Scalars['Float'];
  page: Scalars['Int'];
  signeeId: Scalars['Int'];
  top: Scalars['Float'];
  width: Scalars['Float'];
};

/** Autogenerated return type of BulkCreateDocumentsDownloadUrl. */
export type BulkCreateDocumentsDownloadUrlPayload = {
  __typename?: 'BulkCreateDocumentsDownloadUrlPayload';
  downloadUrls?: Maybe<Array<DocumentsDownloadUrl>>;
  errors: Array<MutationError>;
};

export type BulkCreateDocumentsUploadProcessOperationOperationsInput = {
  fileId: Scalars['Int'];
  operationType: DocumentsUploadProcessOperationTypesEnum;
  page: Scalars['Int'];
  targetFileId?: InputMaybe<Scalars['Int']>;
  targetId?: InputMaybe<Scalars['Int']>;
  targetPage?: InputMaybe<Scalars['Int']>;
  targetType?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of BulkCreateDocumentsUploadProcessOperation. */
export type BulkCreateDocumentsUploadProcessOperationPayload = {
  __typename?: 'BulkCreateDocumentsUploadProcessOperationPayload';
  errors: Array<MutationError>;
  uploadProcessOperations?: Maybe<Array<DocumentsUploadProcessOperation>>;
};

/** Autogenerated return type of BulkCreateEsignatureRequest. */
export type BulkCreateEsignatureRequestPayload = {
  __typename?: 'BulkCreateEsignatureRequestPayload';
  errors: Array<MutationError>;
  requests?: Maybe<Array<EsignatureRequest>>;
};

/** Autogenerated return type of BulkCreateFinanceBudgetAllocation. */
export type BulkCreateFinanceBudgetAllocationPayload = {
  __typename?: 'BulkCreateFinanceBudgetAllocationPayload';
  budgetAllocations?: Maybe<Array<FinanceBudgetAllocation>>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of BulkCreateFinanceContactDocument. */
export type BulkCreateFinanceContactDocumentPayload = {
  __typename?: 'BulkCreateFinanceContactDocumentPayload';
  contactDocuments?: Maybe<Array<FinanceContactDocument>>;
  errors: Array<MutationError>;
};

export type BulkCreateFinanceCostCenterMembershipMembershipsInput = {
  companyId: Scalars['Int'];
  costCenterId: Scalars['Int'];
  employeeId: Scalars['Int'];
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  percentage: Scalars['Float'];
  startDate: Scalars['ISO8601Date'];
};

/** Autogenerated return type of BulkCreateFinanceCostCenterMembership. */
export type BulkCreateFinanceCostCenterMembershipPayload = {
  __typename?: 'BulkCreateFinanceCostCenterMembershipPayload';
  costCenterMemberships?: Maybe<Array<FinanceCostCenterMembership>>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of BulkCreateFormsAnswer. */
export type BulkCreateFormsAnswerPayload = {
  __typename?: 'BulkCreateFormsAnswerPayload';
  answers?: Maybe<Array<FormsAnswer>>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of BulkCreateFormsMaterializedForm. */
export type BulkCreateFormsMaterializedFormPayload = {
  __typename?: 'BulkCreateFormsMaterializedFormPayload';
  errors: Array<MutationError>;
  materializedForms?: Maybe<Array<FormsMaterializedForm>>;
};

/** Autogenerated return type of BulkCreateFormsMembership. */
export type BulkCreateFormsMembershipPayload = {
  __typename?: 'BulkCreateFormsMembershipPayload';
  errors: Array<MutationError>;
  memberships?: Maybe<Array<FormsMembership>>;
};

/** Autogenerated return type of BulkCreateGoalsMetric. */
export type BulkCreateGoalsMetricPayload = {
  __typename?: 'BulkCreateGoalsMetricPayload';
  errors: Array<MutationError>;
  metrics?: Maybe<Array<GoalsMetric>>;
};

/** Autogenerated return type of BulkCreateJobcatalogRole. */
export type BulkCreateJobcatalogRolePayload = {
  __typename?: 'BulkCreateJobcatalogRolePayload';
  errors: Array<MutationError>;
  role?: Maybe<JobCatalogRole>;
};

export type BulkCreateJobcatalogRoleRolesInput = {
  companyId: Scalars['Int'];
  description?: InputMaybe<Scalars['String']>;
  legalEntitiesIds: Array<Scalars['Int']>;
  levelNames?: InputMaybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  supervisorsIds?: InputMaybe<Array<Scalars['Int']>>;
};

/** Autogenerated return type of BulkCreateMeetingsAttendee. */
export type BulkCreateMeetingsAttendeePayload = {
  __typename?: 'BulkCreateMeetingsAttendeePayload';
  attendees?: Maybe<Array<MeetingsAttendee>>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of BulkCreateOneononesTask. */
export type BulkCreateOneononesTaskPayload = {
  __typename?: 'BulkCreateOneononesTaskPayload';
  errors: Array<MutationError>;
  tasks?: Maybe<Array<OneOnOnesTask>>;
};

/** Autogenerated return type of BulkCreatePayrollSupplementAttendanceManualCompensation. */
export type BulkCreatePayrollSupplementAttendanceManualCompensationPayload = {
  __typename?: 'BulkCreatePayrollSupplementAttendanceManualCompensationPayload';
  errors: Array<MutationError>;
  manualCompensation?: Maybe<AttendanceManualCompensation>;
};

/** Autogenerated return type of BulkCreatePerformanceReviewOwner. */
export type BulkCreatePerformanceReviewOwnerPayload = {
  __typename?: 'BulkCreatePerformanceReviewOwnerPayload';
  errors: Array<MutationError>;
  reviewOwners?: Maybe<Array<PerformanceReviewOwner>>;
};

/** Autogenerated return type of BulkCreatePerformanceReviewProcessTarget. */
export type BulkCreatePerformanceReviewProcessTargetPayload = {
  __typename?: 'BulkCreatePerformanceReviewProcessTargetPayload';
  errors: Array<MutationError>;
  reviewProcessTargets?: Maybe<Array<PerformanceReviewProcessTarget>>;
};

export type BulkCreateProcessesItemAssigneeItemAssigneesInput = {
  assigneeIds: Array<Scalars['Int']>;
  assigneeStrategy: Scalars['String'];
  itemId: Scalars['Int'];
};

/** Autogenerated return type of BulkCreateProcessesItemAssignee. */
export type BulkCreateProcessesItemAssigneePayload = {
  __typename?: 'BulkCreateProcessesItemAssigneePayload';
  errors: Array<MutationError>;
  itemAssignees?: Maybe<Array<ProcessesItemAssignee>>;
};

export type BulkCreateProcessesItemItemsInput = {
  actionConfiguration?: InputMaybe<Scalars['String']>;
  actionConfigurationIdentifier?: InputMaybe<Scalars['String']>;
  assigneeIds?: InputMaybe<Array<Scalars['Int']>>;
  assigneeStrategy?: InputMaybe<Scalars['String']>;
  configurationId?: InputMaybe<Scalars['Int']>;
  configurationType?: InputMaybe<Scalars['String']>;
  dataCollectionConfiguration?: InputMaybe<ProcessesDataCollectionConfigurationInput>;
  instruction?: InputMaybe<Scalars['String']>;
  mandatory?: InputMaybe<Scalars['Boolean']>;
  offsetAmount?: InputMaybe<Scalars['Int']>;
  offsetDirection?: InputMaybe<Scalars['String']>;
  position: Scalars['Int'];
  referenceFieldKey?: InputMaybe<Scalars['String']>;
  signatureDocuments?: InputMaybe<BulkCreateProcessesItemSignatureDocumentsInput>;
  stepId?: InputMaybe<Scalars['Int']>;
  taskType?: InputMaybe<Scalars['String']>;
  taskTypeConfiguration?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of BulkCreateProcessesItem. */
export type BulkCreateProcessesItemPayload = {
  __typename?: 'BulkCreateProcessesItemPayload';
  errors: Array<MutationError>;
  items?: Maybe<Array<ProcessesItem>>;
};

export type BulkCreateProcessesItemSignatureDocumentsInput = {
  filesToAdd?: InputMaybe<Array<Scalars['File']>>;
  filesToRemove?: InputMaybe<Array<Scalars['Int']>>;
};

/** Autogenerated return type of BulkCreateProcessesMaterializedProcess. */
export type BulkCreateProcessesMaterializedProcessPayload = {
  __typename?: 'BulkCreateProcessesMaterializedProcessPayload';
  errors: Array<MutationError>;
  materializedProcesses?: Maybe<Array<ProcessesMaterializedProcess>>;
};

/** Autogenerated return type of BulkCreateProcessesResourceRelationship. */
export type BulkCreateProcessesResourceRelationshipPayload = {
  __typename?: 'BulkCreateProcessesResourceRelationshipPayload';
  errors: Array<MutationError>;
  resourceRelationship?: Maybe<ProcessesResourceRelationship>;
};

export type BulkCreateProcessesStepItemsInput = {
  actionConfiguration?: InputMaybe<Scalars['String']>;
  actionConfigurationIdentifier?: InputMaybe<Scalars['String']>;
  assigneeIds?: InputMaybe<Array<Scalars['Int']>>;
  assigneeStrategy?: InputMaybe<Scalars['String']>;
  configurationId?: InputMaybe<Scalars['Int']>;
  configurationType?: InputMaybe<Scalars['String']>;
  dataCollectionConfiguration?: InputMaybe<ProcessesDataCollectionConfigurationInput>;
  instruction?: InputMaybe<Scalars['String']>;
  mandatory?: InputMaybe<Scalars['Boolean']>;
  offsetAmount?: InputMaybe<Scalars['Int']>;
  offsetDirection?: InputMaybe<Scalars['String']>;
  position: Scalars['Int'];
  referenceFieldKey?: InputMaybe<Scalars['String']>;
  signatureDocuments?: InputMaybe<BulkCreateProcessesStepSignatureDocumentsInput>;
  stepId?: InputMaybe<Scalars['Int']>;
  taskType?: InputMaybe<Scalars['String']>;
  taskTypeConfiguration?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of BulkCreateProcessesStep. */
export type BulkCreateProcessesStepPayload = {
  __typename?: 'BulkCreateProcessesStepPayload';
  errors: Array<MutationError>;
  steps?: Maybe<Array<ProcessesStep>>;
};

export type BulkCreateProcessesStepSignatureDocumentsInput = {
  filesToAdd?: InputMaybe<Array<Scalars['File']>>;
  filesToRemove?: InputMaybe<Array<Scalars['Int']>>;
};

export type BulkCreateProcessesStepStepsInput = {
  items?: InputMaybe<Array<BulkCreateProcessesStepItemsInput>>;
  name: Scalars['String'];
  offsetAmount?: InputMaybe<Scalars['Int']>;
  offsetDirection?: InputMaybe<Scalars['String']>;
  position: Scalars['Int'];
  processId?: InputMaybe<Scalars['Int']>;
  progressionCondition?: InputMaybe<Scalars['String']>;
  progressionConditionResourceKey?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of BulkCreateProjectmanagementPlannedRecord. */
export type BulkCreateProjectmanagementPlannedRecordPayload = {
  __typename?: 'BulkCreateProjectmanagementPlannedRecordPayload';
  errors: Array<MutationError>;
  plannedRecords?: Maybe<Array<ProjectManagementPlannedRecord>>;
};

/** Autogenerated return type of BulkCreateProjectmanagementProjectDocument. */
export type BulkCreateProjectmanagementProjectDocumentPayload = {
  __typename?: 'BulkCreateProjectmanagementProjectDocumentPayload';
  errors: Array<MutationError>;
  projectDocuments?: Maybe<Array<ProjectManagementProjectDocument>>;
};

/** Autogenerated return type of BulkCreateProjectmanagementProjectWorker. */
export type BulkCreateProjectmanagementProjectWorkerPayload = {
  __typename?: 'BulkCreateProjectmanagementProjectWorkerPayload';
  errors: Array<MutationError>;
  projectWorkers?: Maybe<Array<ProjectManagementProjectWorker>>;
};

/** Autogenerated return type of BulkCreateProjectmanagementRate. */
export type BulkCreateProjectmanagementRatePayload = {
  __typename?: 'BulkCreateProjectmanagementRatePayload';
  errors: Array<MutationError>;
  rates?: Maybe<Array<ProjectManagementRate>>;
};

export type BulkCreateProjectmanagementRateRatesInput = {
  billingRateCents: Scalars['Int'];
  currency: Scalars['String'];
  profitabilityPercentageCents: Scalars['Int'];
  projectId?: InputMaybe<Scalars['Int']>;
  referenceRateId?: InputMaybe<Scalars['Int']>;
  resourceId: Scalars['Int'];
  resourceType: Scalars['String'];
};

/** Autogenerated return type of BulkCreateShiftmanagementRestDay. */
export type BulkCreateShiftmanagementRestDayPayload = {
  __typename?: 'BulkCreateShiftmanagementRestDayPayload';
  errors: Array<MutationError>;
  restDays?: Maybe<Array<ShiftManagementRestDay>>;
};

export type BulkCreateShiftmanagementRestDayRestDaysInput = {
  companyId: Scalars['Int'];
  date: Scalars['ISO8601DateTime'];
  employeeId: Scalars['Int'];
};

/** Autogenerated return type of BulkCreateShiftmanagementShift. */
export type BulkCreateShiftmanagementShiftPayload = {
  __typename?: 'BulkCreateShiftmanagementShiftPayload';
  errors: Array<MutationError>;
  shifts?: Maybe<Array<ShiftManagementShift>>;
};

export type BulkCreateShiftmanagementShiftPlannedBreaksInput = {
  breakConfigurationId: Scalars['Int'];
  breakType?: InputMaybe<Scalars['String']>;
  dayConfigurationId?: InputMaybe<Scalars['Int']>;
  defaultShiftId?: InputMaybe<Scalars['Int']>;
  duration?: InputMaybe<Scalars['Int']>;
  endAt?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  shiftConfigurationId?: InputMaybe<Scalars['Int']>;
  shiftId?: InputMaybe<Scalars['Int']>;
  startAt?: InputMaybe<Scalars['String']>;
};

export type BulkCreateShiftmanagementShiftShiftsInput = {
  authorId?: InputMaybe<Scalars['Int']>;
  companyId: Scalars['Int'];
  creationMode?: InputMaybe<ShiftManagementEnumsShiftCreationModeEnum>;
  defaultShiftId?: InputMaybe<Scalars['Int']>;
  employeeId: Scalars['Int'];
  endAt: Scalars['ISO8601DateTime'];
  extraHours?: InputMaybe<Scalars['Boolean']>;
  leaveId?: InputMaybe<Scalars['Int']>;
  locationId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  startAt: Scalars['ISO8601DateTime'];
  state?: InputMaybe<ShiftManagementEnumsShiftStateEnum>;
  templateWeekId?: InputMaybe<Scalars['Int']>;
  unassignedShiftId?: InputMaybe<Scalars['Int']>;
  workAreaId?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of BulkCreateShiftmanagementUnassignedShift. */
export type BulkCreateShiftmanagementUnassignedShiftPayload = {
  __typename?: 'BulkCreateShiftmanagementUnassignedShiftPayload';
  errors: Array<MutationError>;
  unassignedShifts?: Maybe<Array<ShiftManagementUnassignedShift>>;
};

export type BulkCreateShiftmanagementUnassignedShiftUnassignedShiftsInput = {
  allCompany: Scalars['Boolean'];
  companyId: Scalars['Int'];
  counter: Scalars['Int'];
  defaultShiftId?: InputMaybe<Scalars['Int']>;
  endAt: Scalars['ISO8601DateTime'];
  extraHours?: InputMaybe<Scalars['Boolean']>;
  jobCatalogRolesIds: Array<Scalars['Int']>;
  jobCatalogTreeRoleUuids: Array<Scalars['String']>;
  locationId?: InputMaybe<Scalars['Int']>;
  locationsIdsVisibilities: Array<Scalars['Int']>;
  notes?: InputMaybe<Scalars['String']>;
  startAt: Scalars['ISO8601DateTime'];
  teamsIdsVisibilities: Array<Scalars['Int']>;
  workAreaId?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of BulkCreateSoftwaremanagementEmployeeSoftwareMembership. */
export type BulkCreateSoftwaremanagementEmployeeSoftwareMembershipPayload = {
  __typename?: 'BulkCreateSoftwaremanagementEmployeeSoftwareMembershipPayload';
  employeeSoftwareMemberships?: Maybe<Array<SoftwareManagementEmployeeSoftwareMembership>>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of BulkCreateSpacecontrolBooking. */
export type BulkCreateSpacecontrolBookingPayload = {
  __typename?: 'BulkCreateSpacecontrolBookingPayload';
  bookings?: Maybe<Array<SpaceControlBooking>>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of BulkCreateTasksTask. */
export type BulkCreateTasksTaskPayload = {
  __typename?: 'BulkCreateTasksTaskPayload';
  errors: Array<MutationError>;
  tasks?: Maybe<Array<TasksTask>>;
};

/** Autogenerated return type of BulkCreateTimeBlockSupplementAttendanceManualCompensation. */
export type BulkCreateTimeBlockSupplementAttendanceManualCompensationPayload = {
  __typename?: 'BulkCreateTimeBlockSupplementAttendanceManualCompensationPayload';
  errors: Array<MutationError>;
  manualCompensation?: Maybe<AttendanceManualCompensation>;
};

export type BulkCreateTimeBlockSupplementAttendanceManualCompensationTimeBlocksInput = {
  contractsTaxonomyId?: InputMaybe<Scalars['Int']>;
  employeeId: Scalars['Int'];
  equivalentMinutesInCents: Scalars['Int'];
  minutesInCents: Scalars['Int'];
  rawMinutesInCents: Scalars['Int'];
  sourceId?: InputMaybe<Scalars['Int']>;
  sourceType?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of BulkCreateTimeoffCurrentPolicyAssignment. */
export type BulkCreateTimeoffCurrentPolicyAssignmentPayload = {
  __typename?: 'BulkCreateTimeoffCurrentPolicyAssignmentPayload';
  currentPolicyAssignments?: Maybe<Array<TimeoffCurrentPolicyAssignment>>;
  errors: Array<MutationError>;
};

export type BulkCreateTimeoffLeaveApprovalConditionConditionsInput = {
  conditionType: Scalars['String'];
  enabled: Scalars['Boolean'];
};

/** Autogenerated return type of BulkCreateTimeoffLeaveApprovalCondition. */
export type BulkCreateTimeoffLeaveApprovalConditionPayload = {
  __typename?: 'BulkCreateTimeoffLeaveApprovalConditionPayload';
  errors: Array<MutationError>;
  leaveApprovalCondition?: Maybe<TimeoffLeaveApprovalCondition>;
};

/** Autogenerated return type of BulkCreateTimeplanningPlannedBreak. */
export type BulkCreateTimeplanningPlannedBreakPayload = {
  __typename?: 'BulkCreateTimeplanningPlannedBreakPayload';
  errors: Array<MutationError>;
  plannedBreaks?: Maybe<Array<TimePlanningPlannedBreak>>;
};

export type BulkCreateTimeplanningPlannedBreakPlannedBreaksInput = {
  breakConfigurationId: Scalars['Int'];
  breakType?: InputMaybe<Scalars['String']>;
  dayConfigurationId?: InputMaybe<Scalars['Int']>;
  defaultShiftId?: InputMaybe<Scalars['Int']>;
  duration?: InputMaybe<Scalars['Int']>;
  endAt?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  shiftConfigurationId?: InputMaybe<Scalars['Int']>;
  shiftId?: InputMaybe<Scalars['Int']>;
  startAt?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of BulkCreateTimeplanningPlanningVersion. */
export type BulkCreateTimeplanningPlanningVersionPayload = {
  __typename?: 'BulkCreateTimeplanningPlanningVersionPayload';
  errors: Array<MutationError>;
  planningVersions?: Maybe<Array<TimePlanningPlanningVersion>>;
};

/** Autogenerated return type of BulkCreateTrainingsSessionAccessMembership. */
export type BulkCreateTrainingsSessionAccessMembershipPayload = {
  __typename?: 'BulkCreateTrainingsSessionAccessMembershipPayload';
  errors: Array<MutationError>;
  sessionAccessMemberships?: Maybe<Array<TrainingsSessionAccessMembership>>;
};

/** Autogenerated return type of BulkCreateTrainingsSessionInstructor. */
export type BulkCreateTrainingsSessionInstructorPayload = {
  __typename?: 'BulkCreateTrainingsSessionInstructorPayload';
  errors: Array<MutationError>;
  sessionInstructors?: Maybe<Array<TrainingsSessionInstructor>>;
};

/** Autogenerated return type of BulkCreateTrainingsTrainingClassMembership. */
export type BulkCreateTrainingsTrainingClassMembershipPayload = {
  __typename?: 'BulkCreateTrainingsTrainingClassMembershipPayload';
  errors: Array<MutationError>;
  trainingClassMemberships?: Maybe<Array<TrainingsTrainingClassMembership>>;
};

/** Autogenerated return type of BulkCreateTrainingsTrainingMembershipFile. */
export type BulkCreateTrainingsTrainingMembershipFilePayload = {
  __typename?: 'BulkCreateTrainingsTrainingMembershipFilePayload';
  errors: Array<MutationError>;
  trainingMembershipFiles?: Maybe<Array<TrainingsTrainingMembershipFile>>;
};

/** Autogenerated return type of BulkCreateTrainingsTrainingMembership. */
export type BulkCreateTrainingsTrainingMembershipPayload = {
  __typename?: 'BulkCreateTrainingsTrainingMembershipPayload';
  errors: Array<MutationError>;
  trainingMemberships?: Maybe<Array<TrainingsTrainingMembership>>;
};

export type BulkCreateUpdateFinanceCostCenterMembershipMembershipsInput = {
  costCenterId: Scalars['Int'];
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  id?: InputMaybe<Scalars['Int']>;
  percentage: Scalars['Float'];
  startDate: Scalars['ISO8601Date'];
};

/** Autogenerated return type of BulkCreateUpdateFinanceCostCenterMembership. */
export type BulkCreateUpdateFinanceCostCenterMembershipPayload = {
  __typename?: 'BulkCreateUpdateFinanceCostCenterMembershipPayload';
  costCenterMemberships?: Maybe<Array<FinanceCostCenterMembership>>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of BulkCudShiftmanagementShiftConfiguration. */
export type BulkCudShiftmanagementShiftConfigurationPayload = {
  __typename?: 'BulkCudShiftmanagementShiftConfigurationPayload';
  errors: Array<MutationError>;
  shiftConfiguration?: Maybe<ShiftManagementShiftConfiguration>;
};

export type BulkCudShiftmanagementShiftConfigurationShiftConfigurationsInput = {
  dayType?: InputMaybe<Scalars['String']>;
  endAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  startAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  weekday: Scalars['Int'];
};

/** Autogenerated return type of BulkCudTimeplanningPlannedBreak. */
export type BulkCudTimeplanningPlannedBreakPayload = {
  __typename?: 'BulkCudTimeplanningPlannedBreakPayload';
  errors: Array<MutationError>;
  plannedBreaks?: Maybe<Array<TimePlanningPlannedBreak>>;
};

export type BulkCudTimeplanningPlannedBreakPlannedBreaksInput = {
  breakConfigurationId: Scalars['Int'];
  breakType?: InputMaybe<Scalars['String']>;
  dayConfigurationId?: InputMaybe<Scalars['Int']>;
  defaultShiftId?: InputMaybe<Scalars['Int']>;
  duration?: InputMaybe<Scalars['Int']>;
  endAt?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  shiftConfigurationId?: InputMaybe<Scalars['Int']>;
  shiftId?: InputMaybe<Scalars['Int']>;
  startAt?: InputMaybe<Scalars['String']>;
};

export type BulkCudTimeplanningPlannedBreakPlannedBreaksParamsInput = {
  dayConfigurationId?: InputMaybe<Scalars['Int']>;
  defaultShiftId?: InputMaybe<Scalars['Int']>;
  plannedBreaks: Array<BulkCudTimeplanningPlannedBreakPlannedBreaksInput>;
  shiftConfigurationId?: InputMaybe<Scalars['Int']>;
  shiftId?: InputMaybe<Scalars['Int']>;
};

export type BulkCudWorkscheduleDayConfigurationDayConfigurationsInput = {
  durationInSeconds: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  startAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  weekday: Scalars['String'];
};

/** Autogenerated return type of BulkCudWorkscheduleDayConfiguration. */
export type BulkCudWorkscheduleDayConfigurationPayload = {
  __typename?: 'BulkCudWorkscheduleDayConfigurationPayload';
  dayConfiguration?: Maybe<WorkScheduleDayConfiguration>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of BulkDeleteArchivedWorkscheduleSchedule. */
export type BulkDeleteArchivedWorkscheduleSchedulePayload = {
  __typename?: 'BulkDeleteArchivedWorkscheduleSchedulePayload';
  errors: Array<MutationError>;
  schedules?: Maybe<Array<WorkScheduleSchedule>>;
};

/** Autogenerated return type of BulkDeleteAtsCandidate. */
export type BulkDeleteAtsCandidatePayload = {
  __typename?: 'BulkDeleteAtsCandidatePayload';
  candidates?: Maybe<Array<AtsCandidate>>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of BulkDeleteAtsQuestionTemplate. */
export type BulkDeleteAtsQuestionTemplatePayload = {
  __typename?: 'BulkDeleteAtsQuestionTemplatePayload';
  errors: Array<MutationError>;
  questionTemplates?: Maybe<Array<AtsQuestionTemplate>>;
};

/** Autogenerated return type of BulkDeleteAttendanceCustomTimeRange. */
export type BulkDeleteAttendanceCustomTimeRangePayload = {
  __typename?: 'BulkDeleteAttendanceCustomTimeRangePayload';
  customTimeRanges?: Maybe<Array<AttendanceCustomTimeRange>>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of BulkDeleteBankingTransfer. */
export type BulkDeleteBankingTransferPayload = {
  __typename?: 'BulkDeleteBankingTransferPayload';
  errors: Array<MutationError>;
  transfers?: Maybe<Array<BankingTransfer>>;
};

/** Autogenerated return type of BulkDeleteCompensationsEmployeesCompensation. */
export type BulkDeleteCompensationsEmployeesCompensationPayload = {
  __typename?: 'BulkDeleteCompensationsEmployeesCompensationPayload';
  employeesCompensations?: Maybe<Array<CompensationsEmployeesCompensation>>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of BulkDeleteCostcentersAllocation. */
export type BulkDeleteCostcentersAllocationPayload = {
  __typename?: 'BulkDeleteCostcentersAllocationPayload';
  allocations?: Maybe<Array<CostCentersAllocation>>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of BulkDeleteCostcentersAssignment. */
export type BulkDeleteCostcentersAssignmentPayload = {
  __typename?: 'BulkDeleteCostcentersAssignmentPayload';
  assignments?: Maybe<Array<CostCentersAssignment>>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of BulkDeleteDocumentsUploadProcessOperation. */
export type BulkDeleteDocumentsUploadProcessOperationPayload = {
  __typename?: 'BulkDeleteDocumentsUploadProcessOperationPayload';
  errors: Array<MutationError>;
  uploadProcessOperations?: Maybe<Array<DocumentsUploadProcessOperation>>;
};

/** Autogenerated return type of BulkDeleteFinanceBudgetAllocation. */
export type BulkDeleteFinanceBudgetAllocationPayload = {
  __typename?: 'BulkDeleteFinanceBudgetAllocationPayload';
  budgetAllocation?: Maybe<FinanceBudgetAllocation>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of BulkDeleteFinanceCostCenterMembership. */
export type BulkDeleteFinanceCostCenterMembershipPayload = {
  __typename?: 'BulkDeleteFinanceCostCenterMembershipPayload';
  costCenterMemberships?: Maybe<Array<FinanceCostCenterMembership>>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of BulkDeleteHandbookpagesPage. */
export type BulkDeleteHandbookpagesPagePayload = {
  __typename?: 'BulkDeleteHandbookpagesPagePayload';
  errors: Array<MutationError>;
  pages?: Maybe<Array<HandbookPagesPage>>;
};

/** Autogenerated return type of BulkDeleteIntegrationsdatevlaudsRequest. */
export type BulkDeleteIntegrationsdatevlaudsRequestPayload = {
  __typename?: 'BulkDeleteIntegrationsdatevlaudsRequestPayload';
  errors: Array<MutationError>;
  request?: Maybe<IntegrationsDatevLaudsRequest>;
};

/** Autogenerated return type of BulkDeleteItmanagementItAsset. */
export type BulkDeleteItmanagementItAssetPayload = {
  __typename?: 'BulkDeleteItmanagementItAssetPayload';
  errors: Array<MutationError>;
  itAssets?: Maybe<Array<ItManagementItAsset>>;
};

/** Autogenerated return type of BulkDeleteMeetingsAttendee. */
export type BulkDeleteMeetingsAttendeePayload = {
  __typename?: 'BulkDeleteMeetingsAttendeePayload';
  attendees?: Maybe<Array<MeetingsAttendee>>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of BulkDeleteMembershipAnswersFormsAnswer. */
export type BulkDeleteMembershipAnswersFormsAnswerPayload = {
  __typename?: 'BulkDeleteMembershipAnswersFormsAnswerPayload';
  answers?: Maybe<Array<FormsAnswer>>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of BulkDeletePayrollSupplementAttendanceManualCompensation. */
export type BulkDeletePayrollSupplementAttendanceManualCompensationPayload = {
  __typename?: 'BulkDeletePayrollSupplementAttendanceManualCompensationPayload';
  errors: Array<MutationError>;
  manualCompensation?: Maybe<AttendanceManualCompensation>;
};

/** Autogenerated return type of BulkDeleteProjectmanagementGlobalTimeRecord. */
export type BulkDeleteProjectmanagementGlobalTimeRecordPayload = {
  __typename?: 'BulkDeleteProjectmanagementGlobalTimeRecordPayload';
  errors: Array<MutationError>;
  globalTimeRecords?: Maybe<Array<ProjectManagementGlobalTimeRecord>>;
};

/** Autogenerated return type of BulkDeleteProjectmanagementTimeRecord. */
export type BulkDeleteProjectmanagementTimeRecordPayload = {
  __typename?: 'BulkDeleteProjectmanagementTimeRecordPayload';
  errors: Array<MutationError>;
  timeRecords?: Maybe<Array<ProjectManagementTimeRecord>>;
};

/** Autogenerated return type of BulkDeleteShiftmanagementRestDay. */
export type BulkDeleteShiftmanagementRestDayPayload = {
  __typename?: 'BulkDeleteShiftmanagementRestDayPayload';
  errors: Array<MutationError>;
  restDays?: Maybe<Array<ShiftManagementRestDay>>;
};

/** Autogenerated return type of BulkDeleteShiftmanagementShift. */
export type BulkDeleteShiftmanagementShiftPayload = {
  __typename?: 'BulkDeleteShiftmanagementShiftPayload';
  errors: Array<MutationError>;
  shifts?: Maybe<Array<ShiftManagementShift>>;
};

/** Autogenerated return type of BulkDeleteShiftmanagementUnassignedShift. */
export type BulkDeleteShiftmanagementUnassignedShiftPayload = {
  __typename?: 'BulkDeleteShiftmanagementUnassignedShiftPayload';
  errors: Array<MutationError>;
  unassignedShifts?: Maybe<Array<ShiftManagementUnassignedShift>>;
};

/** Autogenerated return type of BulkDeleteTasksTask. */
export type BulkDeleteTasksTaskPayload = {
  __typename?: 'BulkDeleteTasksTaskPayload';
  errors: Array<MutationError>;
  tasks?: Maybe<Array<TasksTask>>;
};

/** Autogenerated return type of BulkDeleteTimeinsightsInconsistency. */
export type BulkDeleteTimeinsightsInconsistencyPayload = {
  __typename?: 'BulkDeleteTimeinsightsInconsistencyPayload';
  errors: Array<MutationError>;
  inconsistency?: Maybe<TimeInsightsInconsistency>;
};

/** Autogenerated return type of BulkDeleteTrainingsSessionInstructor. */
export type BulkDeleteTrainingsSessionInstructorPayload = {
  __typename?: 'BulkDeleteTrainingsSessionInstructorPayload';
  errors: Array<MutationError>;
  sessionInstructors?: Maybe<Array<TrainingsSessionInstructor>>;
};

/** Autogenerated return type of BulkDeleteTrainingsTrainingClassMembership. */
export type BulkDeleteTrainingsTrainingClassMembershipPayload = {
  __typename?: 'BulkDeleteTrainingsTrainingClassMembershipPayload';
  errors: Array<MutationError>;
  trainingClassMemberships?: Maybe<Array<TrainingsTrainingClassMembership>>;
};

/** Autogenerated return type of BulkDeleteTrainingsTraining. */
export type BulkDeleteTrainingsTrainingPayload = {
  __typename?: 'BulkDeleteTrainingsTrainingPayload';
  errors: Array<MutationError>;
  trainings?: Maybe<Array<TrainingsTraining>>;
};

/** Autogenerated return type of BulkDeleteTrialTrialEmployee. */
export type BulkDeleteTrialTrialEmployeePayload = {
  __typename?: 'BulkDeleteTrialTrialEmployeePayload';
  errors: Array<MutationError>;
  trialEmployees?: Maybe<Array<TrialTrialEmployee>>;
};

/** Autogenerated return type of BulkDestroyAttendanceReview. */
export type BulkDestroyAttendanceReviewPayload = {
  __typename?: 'BulkDestroyAttendanceReviewPayload';
  errors: Array<MutationError>;
  reviews?: Maybe<Array<AttendanceReview>>;
};

/** Autogenerated return type of BulkDestroyAttendanceShift. */
export type BulkDestroyAttendanceShiftPayload = {
  __typename?: 'BulkDestroyAttendanceShiftPayload';
  errors: Array<MutationError>;
  shifts?: Maybe<Array<AttendanceShift>>;
};

/** Autogenerated return type of BulkDestroyDocumentsUploadProcessDocument. */
export type BulkDestroyDocumentsUploadProcessDocumentPayload = {
  __typename?: 'BulkDestroyDocumentsUploadProcessDocumentPayload';
  errors: Array<MutationError>;
  uploadProcessDocuments?: Maybe<Array<DocumentsUploadProcessDocument>>;
};

/** Autogenerated return type of BulkDestroyLegalEntitySupplementsPayrollSupplement. */
export type BulkDestroyLegalEntitySupplementsPayrollSupplementPayload = {
  __typename?: 'BulkDestroyLegalEntitySupplementsPayrollSupplementPayload';
  errors: Array<MutationError>;
  supplement?: Maybe<PayrollSupplement>;
};

/** Autogenerated return type of BulkDestroyPayrollResultLabelConceptMapping. */
export type BulkDestroyPayrollResultLabelConceptMappingPayload = {
  __typename?: 'BulkDestroyPayrollResultLabelConceptMappingPayload';
  errors: Array<MutationError>;
  resultLabelConceptMappings?: Maybe<Array<PayrollResultLabelConceptMapping>>;
};

/** Autogenerated return type of BulkDestroyPayrollSupplementValidation. */
export type BulkDestroyPayrollSupplementValidationPayload = {
  __typename?: 'BulkDestroyPayrollSupplementValidationPayload';
  errors: Array<MutationError>;
  supplementValidation?: Maybe<PayrollSupplementValidation>;
};

/** Autogenerated return type of BulkDestroyProjectmanagementProjectTask. */
export type BulkDestroyProjectmanagementProjectTaskPayload = {
  __typename?: 'BulkDestroyProjectmanagementProjectTaskPayload';
  errors: Array<MutationError>;
  projectTasks?: Maybe<Array<ProjectManagementProjectTask>>;
};

/** Autogenerated return type of BulkDestroyTrainingsSessionAccessMembership. */
export type BulkDestroyTrainingsSessionAccessMembershipPayload = {
  __typename?: 'BulkDestroyTrainingsSessionAccessMembershipPayload';
  errors: Array<MutationError>;
  sessionAccessMemberships?: Maybe<Array<TrainingsSessionAccessMembership>>;
};

/** Autogenerated return type of BulkDestroyTrainingsTrainingMembership. */
export type BulkDestroyTrainingsTrainingMembershipPayload = {
  __typename?: 'BulkDestroyTrainingsTrainingMembershipPayload';
  errors: Array<MutationError>;
  trainingMemberships?: Maybe<Array<TrainingsTrainingMembership>>;
};

/** Autogenerated return type of BulkDiscardFinanceSpendingAlertSpendingAlert. */
export type BulkDiscardFinanceSpendingAlertSpendingAlertPayload = {
  __typename?: 'BulkDiscardFinanceSpendingAlertSpendingAlertPayload';
  errors: Array<MutationError>;
  spendingAlerts?: Maybe<Array<FinanceSpendingAlert>>;
};

/** Autogenerated return type of BulkDisqualifyAtsApplication. */
export type BulkDisqualifyAtsApplicationPayload = {
  __typename?: 'BulkDisqualifyAtsApplicationPayload';
  applications?: Maybe<Array<AtsApplication>>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of BulkDocumentCreatePayrollPayrollDocument. */
export type BulkDocumentCreatePayrollPayrollDocumentPayload = {
  __typename?: 'BulkDocumentCreatePayrollPayrollDocumentPayload';
  errors: Array<MutationError>;
  payrollDocument?: Maybe<PayrollPayrollDocument>;
};

/** Autogenerated return type of BulkDuplicateProjectmanagementProjectTask. */
export type BulkDuplicateProjectmanagementProjectTaskPayload = {
  __typename?: 'BulkDuplicateProjectmanagementProjectTaskPayload';
  errors: Array<MutationError>;
  projectTasks?: Maybe<Array<ProjectManagementProjectTask>>;
};

/** Autogenerated return type of BulkGenerateShiftmanagementUnassignedShift. */
export type BulkGenerateShiftmanagementUnassignedShiftPayload = {
  __typename?: 'BulkGenerateShiftmanagementUnassignedShiftPayload';
  errors: Array<MutationError>;
  unassignedShifts?: Maybe<Array<ShiftManagementUnassignedShift>>;
};

/** Autogenerated return type of BulkInitiatePerformanceAgreement. */
export type BulkInitiatePerformanceAgreementPayload = {
  __typename?: 'BulkInitiatePerformanceAgreementPayload';
  agreements?: Maybe<Array<PerformanceAgreement>>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of BulkManageBankingReconciliation. */
export type BulkManageBankingReconciliationPayload = {
  __typename?: 'BulkManageBankingReconciliationPayload';
  errors: Array<MutationError>;
  reconciliations?: Maybe<Array<BankingReconciliation>>;
};

export type BulkManageBankingReconciliationReconcilableInput = {
  id: Scalars['Int'];
  type: BankingValueObjectsReconcilableTypeEnum;
};

export type BulkManageBankingReconciliationReconciliationsInput = {
  reconcilable: BulkManageBankingReconciliationReconcilableInput;
  reconcilableCurrency: Scalars['String'];
  reconcilableReconciledAmountCents: Scalars['Int'];
  transactionCurrency: Scalars['String'];
  transactionId: Scalars['Int'];
  transactionReconciledAmountCents: Scalars['Int'];
};

/** Autogenerated return type of BulkManageFinanceReconciliation. */
export type BulkManageFinanceReconciliationPayload = {
  __typename?: 'BulkManageFinanceReconciliationPayload';
  errors: Array<MutationError>;
  reconciliations?: Maybe<Array<FinanceReconciliation>>;
};

export type BulkManageFinanceReconciliationReconcilableInput = {
  id: Scalars['Int'];
  type: FinanceValueObjectsReconcilableTypeEnum;
};

export type BulkManageFinanceReconciliationReconciliationsInput = {
  journalLineId: Scalars['Int'];
  journalLineReconciledAmountCents: Scalars['Int'];
  reconcilable: BulkManageFinanceReconciliationReconcilableInput;
  reconcilableReconciledAmountCents: Scalars['Int'];
};

/** Autogenerated return type of BulkMarkAsTasksInboxTask. */
export type BulkMarkAsTasksInboxTaskPayload = {
  __typename?: 'BulkMarkAsTasksInboxTaskPayload';
  errors: Array<MutationError>;
  inboxTasks?: Maybe<Array<TasksInboxTask>>;
};

/** Autogenerated return type of BulkMoveApprovalsApprovalGroupMembership. */
export type BulkMoveApprovalsApprovalGroupMembershipPayload = {
  __typename?: 'BulkMoveApprovalsApprovalGroupMembershipPayload';
  approvalGroupMemberships?: Maybe<Array<ApprovalsApprovalGroupMembership>>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of BulkMoveToPhaseAtsApplication. */
export type BulkMoveToPhaseAtsApplicationPayload = {
  __typename?: 'BulkMoveToPhaseAtsApplicationPayload';
  applications?: Maybe<Array<AtsApplication>>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of BulkPatchShiftmanagementShift. */
export type BulkPatchShiftmanagementShiftPayload = {
  __typename?: 'BulkPatchShiftmanagementShiftPayload';
  errors: Array<MutationError>;
  shifts?: Maybe<Array<ShiftManagementShift>>;
};

export type BulkPatchShiftmanagementShiftPlannedBreaksInput = {
  breakConfigurationId: Scalars['Int'];
  breakType?: InputMaybe<Scalars['String']>;
  dayConfigurationId?: InputMaybe<Scalars['Int']>;
  defaultShiftId?: InputMaybe<Scalars['Int']>;
  duration?: InputMaybe<Scalars['Int']>;
  endAt?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  shiftConfigurationId?: InputMaybe<Scalars['Int']>;
  shiftId?: InputMaybe<Scalars['Int']>;
  startAt?: InputMaybe<Scalars['String']>;
};

export type BulkProcessProjectmanagementTimeRecordItemsInput = {
  attendanceShiftId?: InputMaybe<Scalars['Int']>;
  projectWorkerId?: InputMaybe<Scalars['Int']>;
  subprojectId?: InputMaybe<Scalars['Int']>;
  timeRecordId?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of BulkProcessProjectmanagementTimeRecord. */
export type BulkProcessProjectmanagementTimeRecordPayload = {
  __typename?: 'BulkProcessProjectmanagementTimeRecordPayload';
  errors: Array<MutationError>;
  timeRecords?: Maybe<Array<ProjectManagementTimeRecord>>;
};

/** Autogenerated return type of BulkPublishHandbookpagesPage. */
export type BulkPublishHandbookpagesPagePayload = {
  __typename?: 'BulkPublishHandbookpagesPagePayload';
  errors: Array<MutationError>;
  pages?: Maybe<Array<HandbookPagesPage>>;
};

/** Autogenerated return type of BulkReadyToReviewExpensesExpensable. */
export type BulkReadyToReviewExpensesExpensablePayload = {
  __typename?: 'BulkReadyToReviewExpensesExpensablePayload';
  errors: Array<MutationError>;
  expensables?: Maybe<Array<ExpensesExpensable>>;
};

/** Autogenerated return type of BulkRejectApprovalsMaterializedApprovalsFlow. */
export type BulkRejectApprovalsMaterializedApprovalsFlowPayload = {
  __typename?: 'BulkRejectApprovalsMaterializedApprovalsFlowPayload';
  errors: Array<MutationError>;
  materializedApprovalsFlows?: Maybe<Array<ApprovalsMaterializedApprovalsFlow>>;
};

/** Autogenerated return type of BulkRejectApprovalsv2ReviewRequest. */
export type BulkRejectApprovalsv2ReviewRequestPayload = {
  __typename?: 'BulkRejectApprovalsv2ReviewRequestPayload';
  errors: Array<MutationError>;
  reviewRequests?: Maybe<Array<ApprovalsV2ReviewRequest>>;
};

/** Autogenerated return type of BulkRejectExpensesExpensable. */
export type BulkRejectExpensesExpensablePayload = {
  __typename?: 'BulkRejectExpensesExpensablePayload';
  errors: Array<MutationError>;
  expensables?: Maybe<Array<ExpensesExpensable>>;
};

/** Autogenerated return type of BulkRemoveFromGroupExpensesExpensable. */
export type BulkRemoveFromGroupExpensesExpensablePayload = {
  __typename?: 'BulkRemoveFromGroupExpensesExpensablePayload';
  errors: Array<MutationError>;
  expensables?: Maybe<Array<ExpensesExpensable>>;
};

/** Autogenerated return type of BulkRemoveFromPayrollExpensesExpensable. */
export type BulkRemoveFromPayrollExpensesExpensablePayload = {
  __typename?: 'BulkRemoveFromPayrollExpensesExpensablePayload';
  errors: Array<MutationError>;
  expensables?: Maybe<Array<ExpensesExpensable>>;
};

/** Autogenerated return type of BulkRequestChangesApprovalsv2ReviewRequest. */
export type BulkRequestChangesApprovalsv2ReviewRequestPayload = {
  __typename?: 'BulkRequestChangesApprovalsv2ReviewRequestPayload';
  errors: Array<MutationError>;
  reviewRequests?: Maybe<Array<ApprovalsV2ReviewRequest>>;
};

/** Autogenerated return type of BulkResendSignatureEsignatureSignature. */
export type BulkResendSignatureEsignatureSignaturePayload = {
  __typename?: 'BulkResendSignatureEsignatureSignaturePayload';
  errors: Array<MutationError>;
  signatures?: Maybe<Array<EsignatureSignature>>;
};

/** Autogenerated return type of BulkRestartReviewExpensesExpensable. */
export type BulkRestartReviewExpensesExpensablePayload = {
  __typename?: 'BulkRestartReviewExpensesExpensablePayload';
  errors: Array<MutationError>;
  expensables?: Maybe<Array<ExpensesExpensable>>;
};

/** Autogenerated return type of BulkRevertPaidExpensesExpensable. */
export type BulkRevertPaidExpensesExpensablePayload = {
  __typename?: 'BulkRevertPaidExpensesExpensablePayload';
  errors: Array<MutationError>;
  expensables?: Maybe<Array<ExpensesExpensable>>;
};

/** Autogenerated return type of BulkSendToPayFinanceFinancialDocument. */
export type BulkSendToPayFinanceFinancialDocumentPayload = {
  __typename?: 'BulkSendToPayFinanceFinancialDocumentPayload';
  errors: Array<MutationError>;
  financialDocuments?: Maybe<Array<FinanceFinancialDocument>>;
};

/** Autogenerated return type of BulkSendToPayWithSepaExpensesExpensable. */
export type BulkSendToPayWithSepaExpensesExpensablePayload = {
  __typename?: 'BulkSendToPayWithSepaExpensesExpensablePayload';
  errors: Array<MutationError>;
  expensables?: Maybe<Array<ExpensesExpensable>>;
};

/** Autogenerated return type of BulkSetToPaidExpensesExpensable. */
export type BulkSetToPaidExpensesExpensablePayload = {
  __typename?: 'BulkSetToPaidExpensesExpensablePayload';
  errors: Array<MutationError>;
  expensables?: Maybe<Array<ExpensesExpensable>>;
};

/** Autogenerated return type of BulkTerminateFinanceCostCenterMembership. */
export type BulkTerminateFinanceCostCenterMembershipPayload = {
  __typename?: 'BulkTerminateFinanceCostCenterMembershipPayload';
  costCenterMemberships?: Maybe<Array<FinanceCostCenterMembership>>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of BulkUpdateAtsApplication. */
export type BulkUpdateAtsApplicationPayload = {
  __typename?: 'BulkUpdateAtsApplicationPayload';
  applications?: Maybe<Array<AtsApplication>>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of BulkUpdateAtsQuestion. */
export type BulkUpdateAtsQuestionPayload = {
  __typename?: 'BulkUpdateAtsQuestionPayload';
  errors: Array<MutationError>;
  questions?: Maybe<Array<AtsQuestion>>;
};

export type BulkUpdateAtsQuestionQuestionsInput = {
  autoDisqualify?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  label?: InputMaybe<Scalars['String']>;
  mandatory?: InputMaybe<Scalars['Boolean']>;
  options?: InputMaybe<Array<AtsQuestionOptionInput>>;
  position?: InputMaybe<Scalars['Int']>;
};

export type BulkUpdateAttendanceCustomTimeRangeCustomTimeRangesInput = {
  attendanceCustomTimeRangeCategoryId?: InputMaybe<Scalars['Int']>;
  attendanceEmployeesSettingId?: InputMaybe<Scalars['Int']>;
  date?: InputMaybe<Scalars['ISO8601Date']>;
  day?: InputMaybe<AttendanceCustomTimeRangeDayEnum>;
  endTime?: InputMaybe<Scalars['ISO8601DateTime']>;
  equivalentMinutesInCents?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  poolType?: InputMaybe<AttendanceEnumsPoolTypeEnum>;
  rawMinutesInCents?: InputMaybe<Scalars['Int']>;
  startTime?: InputMaybe<Scalars['ISO8601DateTime']>;
  timeSettingsCustomTimeRangeCategoryId?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of BulkUpdateAttendanceCustomTimeRange. */
export type BulkUpdateAttendanceCustomTimeRangePayload = {
  __typename?: 'BulkUpdateAttendanceCustomTimeRangePayload';
  customTimeRanges?: Maybe<Array<AttendanceCustomTimeRange>>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of BulkUpdateAttendanceOvertimePool. */
export type BulkUpdateAttendanceOvertimePoolPayload = {
  __typename?: 'BulkUpdateAttendanceOvertimePoolPayload';
  errors: Array<MutationError>;
  overtimePools?: Maybe<Array<AttendanceOvertimePool>>;
};

/** Autogenerated return type of BulkUpdateBookkeepersmanagementIncidence. */
export type BulkUpdateBookkeepersmanagementIncidencePayload = {
  __typename?: 'BulkUpdateBookkeepersmanagementIncidencePayload';
  errors: Array<MutationError>;
  incidences?: Maybe<Array<BookkeepersManagementIncidence>>;
};

/** Autogenerated return type of BulkUpdateCatalogTrainingsTraining. */
export type BulkUpdateCatalogTrainingsTrainingPayload = {
  __typename?: 'BulkUpdateCatalogTrainingsTrainingPayload';
  errors: Array<MutationError>;
  trainings?: Maybe<Array<TrainingsTraining>>;
};

export type BulkUpdateCompensationsEmployeesCompensationEmployeeCompensationsInput = {
  amount: Scalars['Int'];
  id: Scalars['Int'];
};

/** Autogenerated return type of BulkUpdateCompensationsEmployeesCompensation. */
export type BulkUpdateCompensationsEmployeesCompensationPayload = {
  __typename?: 'BulkUpdateCompensationsEmployeesCompensationPayload';
  employeesCompensations?: Maybe<Array<CompensationsEmployeesCompensation>>;
  errors: Array<MutationError>;
};

export type BulkUpdateDashboardCompanyLinkLinksInput = {
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  order: Scalars['Int'];
  url: Scalars['String'];
};

/** Autogenerated return type of BulkUpdateDashboardCompanyLink. */
export type BulkUpdateDashboardCompanyLinkPayload = {
  __typename?: 'BulkUpdateDashboardCompanyLinkPayload';
  companyLink?: Maybe<DashboardCompanyLink>;
  errors: Array<MutationError>;
};

export type BulkUpdateDocumentsDocumentDocumentsInput = {
  distributionMethod?: InputMaybe<Scalars['String']>;
  documentId: Scalars['Int'];
  employeeId: Scalars['Int'];
  isPendingAssignment: Scalars['Boolean'];
  public: Scalars['Boolean'];
  requestEsignature: Scalars['Boolean'];
  signees: Array<Scalars['Int']>;
};

/** Autogenerated return type of BulkUpdateDocumentsDocument. */
export type BulkUpdateDocumentsDocumentPayload = {
  __typename?: 'BulkUpdateDocumentsDocumentPayload';
  documents?: Maybe<Array<DocumentsDocument>>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of BulkUpdateFinanceBudgetAllocation. */
export type BulkUpdateFinanceBudgetAllocationPayload = {
  __typename?: 'BulkUpdateFinanceBudgetAllocationPayload';
  budgetAllocations?: Maybe<Array<FinanceBudgetAllocation>>;
  errors: Array<MutationError>;
};

export type BulkUpdateFinanceCostCenterMembershipMembershipsInput = {
  costCenterId: Scalars['Int'];
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  id: Scalars['Int'];
  percentage: Scalars['Float'];
  startDate: Scalars['ISO8601Date'];
};

/** Autogenerated return type of BulkUpdateFinanceCostCenterMembership. */
export type BulkUpdateFinanceCostCenterMembershipPayload = {
  __typename?: 'BulkUpdateFinanceCostCenterMembershipPayload';
  costCenterMemberships?: Maybe<Array<FinanceCostCenterMembership>>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of BulkUpdateFolderDocumentsDocument. */
export type BulkUpdateFolderDocumentsDocumentPayload = {
  __typename?: 'BulkUpdateFolderDocumentsDocumentPayload';
  documents?: Maybe<Array<DocumentsDocument>>;
  errors: Array<MutationError>;
};

export type BulkUpdateJobcatalogLevelChangesInput = {
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of BulkUpdateJobcatalogLevel. */
export type BulkUpdateJobcatalogLevelPayload = {
  __typename?: 'BulkUpdateJobcatalogLevelPayload';
  errors: Array<MutationError>;
  levels?: Maybe<Array<JobCatalogLevel>>;
};

/** Autogenerated return type of BulkUpdateNotificationStatusDocumentsDocument. */
export type BulkUpdateNotificationStatusDocumentsDocumentPayload = {
  __typename?: 'BulkUpdateNotificationStatusDocumentsDocumentPayload';
  documents?: Maybe<Array<DocumentsDocument>>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of BulkUpdateProcessesConfigurationTaskConfigurationFile. */
export type BulkUpdateProcessesConfigurationTaskConfigurationFilePayload = {
  __typename?: 'BulkUpdateProcessesConfigurationTaskConfigurationFilePayload';
  errors: Array<MutationError>;
  taskConfigurationFiles?: Maybe<Array<ProcessesTaskConfigurationFile>>;
};

export type BulkUpdateProcessesItemItemsInput = {
  assigneeIds?: InputMaybe<Array<Scalars['Int']>>;
  assigneeStrategy: Scalars['String'];
  dataCollectionConfiguration?: InputMaybe<ProcessesDataCollectionConfigurationInput>;
  id: Scalars['Int'];
  instruction?: InputMaybe<Scalars['String']>;
  mandatory?: InputMaybe<Scalars['Boolean']>;
  offsetAmount?: InputMaybe<Scalars['Int']>;
  offsetDirection?: InputMaybe<Scalars['String']>;
  position: Scalars['Int'];
  referenceFieldKey?: InputMaybe<Scalars['String']>;
  signatureDocuments?: InputMaybe<BulkUpdateProcessesItemSignatureDocumentsInput>;
  stepId?: InputMaybe<Scalars['Int']>;
  taskType?: InputMaybe<Scalars['String']>;
  taskTypeConfiguration?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of BulkUpdateProcessesItem. */
export type BulkUpdateProcessesItemPayload = {
  __typename?: 'BulkUpdateProcessesItemPayload';
  errors: Array<MutationError>;
  items?: Maybe<Array<ProcessesItem>>;
};

export type BulkUpdateProcessesItemSignatureDocumentsInput = {
  filesToAdd?: InputMaybe<Array<Scalars['File']>>;
  filesToRemove?: InputMaybe<Array<Scalars['Int']>>;
};

/** Autogenerated return type of BulkUpdateProcessesStep. */
export type BulkUpdateProcessesStepPayload = {
  __typename?: 'BulkUpdateProcessesStepPayload';
  errors: Array<MutationError>;
  steps?: Maybe<Array<ProcessesStep>>;
};

export type BulkUpdateProcessesStepStepsInput = {
  archived?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  offsetAmount?: InputMaybe<Scalars['Int']>;
  offsetDirection?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  progressionCondition?: InputMaybe<Scalars['String']>;
  progressionConditionResourceKey?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of BulkUpdateSpacecontrolBooking. */
export type BulkUpdateSpacecontrolBookingPayload = {
  __typename?: 'BulkUpdateSpacecontrolBookingPayload';
  bookings?: Maybe<Array<SpaceControlBooking>>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of BulkUpdateTasksTaskFile. */
export type BulkUpdateTasksTaskFilePayload = {
  __typename?: 'BulkUpdateTasksTaskFilePayload';
  errors: Array<MutationError>;
  taskFiles?: Maybe<Array<TasksTaskFile>>;
};

/** Autogenerated return type of BulkUpdateTasksTask. */
export type BulkUpdateTasksTaskPayload = {
  __typename?: 'BulkUpdateTasksTaskPayload';
  errors: Array<MutationError>;
  tasks?: Maybe<Array<TasksTask>>;
};

export type BulkUpdateTasksTaskTasksInput = {
  assigneeIds?: InputMaybe<Array<Scalars['Int']>>;
  content?: InputMaybe<Scalars['String']>;
  dueOn?: InputMaybe<Scalars['ISO8601Date']>;
  id: Scalars['Int'];
  identifier?: InputMaybe<TasksValueObjectsTaskIdentifierEnum>;
  name?: InputMaybe<Scalars['String']>;
  startsOn?: InputMaybe<Scalars['ISO8601Date']>;
  status?: InputMaybe<TasksValueObjectsTaskStatusEnum>;
};

/** Autogenerated return type of BulkUpdateTasksUploadDocumentTaskFile. */
export type BulkUpdateTasksUploadDocumentTaskFilePayload = {
  __typename?: 'BulkUpdateTasksUploadDocumentTaskFilePayload';
  errors: Array<MutationError>;
  uploadDocumentTaskFiles?: Maybe<Array<TasksUploadDocumentTaskFile>>;
};

export type BulkUpdateTimeoffLeaveApprovalConditionConditionsInput = {
  conditionType?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
};

/** Autogenerated return type of BulkUpdateTimeoffLeaveApprovalCondition. */
export type BulkUpdateTimeoffLeaveApprovalConditionPayload = {
  __typename?: 'BulkUpdateTimeoffLeaveApprovalConditionPayload';
  errors: Array<MutationError>;
  leaveApprovalCondition?: Maybe<TimeoffLeaveApprovalCondition>;
};

/** Autogenerated return type of BulkUpdateTrainingsSessionAttendance. */
export type BulkUpdateTrainingsSessionAttendancePayload = {
  __typename?: 'BulkUpdateTrainingsSessionAttendancePayload';
  errors: Array<MutationError>;
  sessionAttendances?: Maybe<Array<TrainingsSessionAttendance>>;
};

/** Autogenerated return type of BulkUpdateTrainingsSessionInstructor. */
export type BulkUpdateTrainingsSessionInstructorPayload = {
  __typename?: 'BulkUpdateTrainingsSessionInstructorPayload';
  errors: Array<MutationError>;
  sessionInstructors?: Maybe<Array<TrainingsSessionInstructor>>;
};

/** Autogenerated return type of BulkUpdateVisibilityDocumentsDocument. */
export type BulkUpdateVisibilityDocumentsDocumentPayload = {
  __typename?: 'BulkUpdateVisibilityDocumentsDocumentPayload';
  documents?: Maybe<Array<DocumentsDocument>>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of BulkUpsertBenefitsSpendingLimitOverride. */
export type BulkUpsertBenefitsSpendingLimitOverridePayload = {
  __typename?: 'BulkUpsertBenefitsSpendingLimitOverridePayload';
  errors: Array<MutationError>;
  spendingLimitOverrides?: Maybe<Array<BenefitsSpendingLimitOverride>>;
};

export type BulkUpsertBenefitsSpendingLimitOverrideSpendingLimitOverridesInput = {
  amountCents: Scalars['Int'];
  category: BenefitsValueObjectsBenefitTransactionCategoryEnum;
  companyId: Scalars['Int'];
  employeeId: Scalars['Int'];
  expiresAt?: InputMaybe<Scalars['ISO8601DateTime']>;
};

export type BulkUpsertCostcentersAssignmentAssignmentsToCreateInput = {
  costCenterId: Scalars['Int'];
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  percentage: Scalars['Float'];
  resourceId: Scalars['Int'];
  resourceType: Scalars['String'];
  startDate: Scalars['ISO8601Date'];
};

export type BulkUpsertCostcentersAssignmentAssignmentsToUpdateInput = {
  costCenterId: Scalars['Int'];
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  id: Scalars['Int'];
  markedForDeletion: Scalars['Boolean'];
  percentage: Scalars['Float'];
  startDate: Scalars['ISO8601Date'];
};

/** Autogenerated return type of BulkUpsertCostcentersAssignment. */
export type BulkUpsertCostcentersAssignmentPayload = {
  __typename?: 'BulkUpsertCostcentersAssignmentPayload';
  assignments?: Maybe<Array<CostCentersAssignment>>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of BulkUpsertTeamsMembership. */
export type BulkUpsertTeamsMembershipPayload = {
  __typename?: 'BulkUpsertTeamsMembershipPayload';
  errors: Array<MutationError>;
  memberships?: Maybe<Array<TeamsMembership>>;
};

export type BulkUpsertWorkingconditionsItemItemsInput = {
  dataType: Scalars['String'];
  name: Scalars['String'];
  value: Scalars['String'];
};

/** Autogenerated return type of BulkUpsertWorkingconditionsItem. */
export type BulkUpsertWorkingconditionsItemPayload = {
  __typename?: 'BulkUpsertWorkingconditionsItemPayload';
  errors: Array<MutationError>;
  items?: Maybe<Array<WorkingConditionsItem>>;
};

export type CalculateExpensesPerDiemDayExclusionsInput = {
  date: Scalars['ISO8601Date'];
  excludedConcepts: Array<ExpensesValueObjectsPerDiemCalculationExcludedConceptEnum>;
};

export type CalculateExpensesPerDiemDestinationsInput = {
  arrivalDatetime: Scalars['ISO8601DateTime'];
  locationData: ExpensesLocationDataInput;
};

/** Autogenerated return type of CalculateExpensesPerDiem. */
export type CalculateExpensesPerDiemPayload = {
  __typename?: 'CalculateExpensesPerDiemPayload';
  errors: Array<MutationError>;
  perDiem?: Maybe<ExpensesPerDiem>;
};

export type CalculateExpensesPerDiemRateParamsInput = {
  rateConfigurationId: Scalars['Int'];
  totalAmountCents: Scalars['Int'];
  totalDays: Scalars['Int'];
};

/** Calendar Event */
export type CalendarCalendarEvent = {
  __typename?: 'CalendarCalendarEvent';
  employee?: Maybe<EmployeesEmployee>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  employeeId?: Maybe<Scalars['Int']>;
  endsAt?: Maybe<Scalars['ISO8601DateTime']>;
  eventType: Scalars['String'];
  id: Scalars['String'];
  leave?: Maybe<TimeoffLeave>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  leaveId?: Maybe<Scalars['Int']>;
  post?: Maybe<PostsPost>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  postId?: Maybe<Scalars['Int']>;
  shiftManagement?: Maybe<ShiftManagementShift>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  shiftManagementId?: Maybe<Scalars['Int']>;
  startsAt: Scalars['ISO8601DateTime'];
  task?: Maybe<TasksTask>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  taskId?: Maybe<Scalars['Int']>;
  trainingSession?: Maybe<TrainingsSession>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  trainingSessionId?: Maybe<Scalars['Int']>;
};


/** Calendar Event */
export type CalendarCalendarEventEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Calendar Event */
export type CalendarCalendarEventLeaveArgs = {
  approved?: InputMaybe<Scalars['Boolean']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  from?: InputMaybe<Scalars['ISO8601Date']>;
  includeAllPendingApprovals?: InputMaybe<Scalars['Boolean']>;
  includeAllRelations?: InputMaybe<Scalars['Boolean']>;
  includeDeletedLeaves?: Scalars['Boolean'];
  includeDuration?: InputMaybe<Scalars['Boolean']>;
  includeLeaveType?: InputMaybe<Scalars['Boolean']>;
  includePending?: InputMaybe<Scalars['Boolean']>;
  leaveType?: InputMaybe<Array<Scalars['String']>>;
  leaveTypeId?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  to?: InputMaybe<Scalars['ISO8601Date']>;
  typeIsPayable?: InputMaybe<Scalars['Boolean']>;
  typeIsWorkable?: InputMaybe<Scalars['Boolean']>;
};


/** Calendar Event */
export type CalendarCalendarEventPostArgs = {
  from?: InputMaybe<Scalars['ISO8601Date']>;
  groups?: InputMaybe<Array<Scalars['Int']>>;
  id?: InputMaybe<Scalars['Int']>;
  isMobile?: InputMaybe<Scalars['Boolean']>;
  noPagination?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  postsPerPage?: InputMaybe<Scalars['Int']>;
  publishedAt?: InputMaybe<Scalars['ISO8601Date']>;
  scheduledPosts?: InputMaybe<Scalars['Boolean']>;
  startsFrom?: InputMaybe<Scalars['ISO8601Date']>;
  startsUntil?: InputMaybe<Scalars['ISO8601Date']>;
  truncateDescription?: InputMaybe<Scalars['Boolean']>;
  types?: InputMaybe<Array<Scalars['String']>>;
  until?: InputMaybe<Scalars['ISO8601Date']>;
  withCoverImage?: InputMaybe<Scalars['Boolean']>;
  withReactions?: InputMaybe<Scalars['Boolean']>;
};


/** Calendar Event */
export type CalendarCalendarEventShiftManagementArgs = {
  effectiveLocationIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endAt?: InputMaybe<Scalars['String']>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  locationsWorkAreaIds?: InputMaybe<Array<Scalars['Int']>>;
  onlyPublished?: InputMaybe<Scalars['Boolean']>;
  onlyStates?: InputMaybe<Array<ShiftManagementEnumsShiftStateEnum>>;
  splitOvernightShifts?: InputMaybe<Scalars['Boolean']>;
  startAt?: InputMaybe<Scalars['String']>;
  withoutIds?: InputMaybe<Array<Scalars['Int']>>;
  withoutWorkArea?: InputMaybe<Scalars['Boolean']>;
};


/** Calendar Event */
export type CalendarCalendarEventTaskArgs = {
  alreadyDue?: InputMaybe<Scalars['Boolean']>;
  assigneeId?: InputMaybe<Scalars['Int']>;
  assigneeRole?: InputMaybe<TasksValueObjectsTaskInvolvementRolesEnum>;
  authorId?: InputMaybe<Scalars['Int']>;
  category?: InputMaybe<TasksValueObjectsTaskCategoryEnum>;
  companyId?: InputMaybe<Scalars['Int']>;
  documentId?: InputMaybe<Scalars['Int']>;
  dueOn?: InputMaybe<Scalars['ISO8601Date']>;
  identifier?: InputMaybe<TasksValueObjectsTaskIdentifierEnum>;
  involveeId?: InputMaybe<Scalars['Int']>;
  mandatory?: InputMaybe<Scalars['Boolean']>;
  processId?: InputMaybe<Scalars['Int']>;
  processIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  startsOn?: InputMaybe<Scalars['ISO8601Date']>;
  status?: InputMaybe<TasksTaskStatusEnum>;
  taskStatus?: InputMaybe<TasksValueObjectsTaskStatusEnum>;
};


/** Calendar Event */
export type CalendarCalendarEventTrainingSessionArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  active?: InputMaybe<Scalars['Boolean']>;
  modality?: InputMaybe<Scalars['String']>;
  next?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  startAfter?: InputMaybe<Scalars['String']>;
  startBefore?: InputMaybe<Scalars['String']>;
  startsAt?: InputMaybe<Array<Scalars['String']>>;
  trainingClassIds?: InputMaybe<Array<Scalars['String']>>;
  trainingId?: InputMaybe<Scalars['Int']>;
  trainingIds?: InputMaybe<Array<Scalars['Int']>>;
};

/** The connection type for CalendarCalendarEvent. */
export type CalendarCalendarEventConnection = {
  __typename?: 'CalendarCalendarEventConnection';
  /** A list of edges. */
  edges: Array<CalendarCalendarEventEdge>;
  /** A list of nodes. */
  nodes: Array<CalendarCalendarEvent>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CalendarCalendarEventEdge = {
  __typename?: 'CalendarCalendarEventEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CalendarCalendarEvent;
};

/** the filter for the calendar_events resource */
export type CalendarCalendarEventFilter = {
  id?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<CalendarCalendarEventFilterConditions>>;
  startsAt?: InputMaybe<DateTimeFilter>;
};

export type CalendarCalendarEventFilterConditions = {
  id?: InputMaybe<StringFilter>;
  startsAt?: InputMaybe<DateTimeFilter>;
};

export type CalendarContextlessPolicies = {
  __typename?: 'CalendarContextlessPolicies';
  sidebarSeeCalendarCalendarSubLevelItem: ContextlessPolicyResolution;
};

export type CalendarValueObjectsEventTypeEnum =
  | 'birthday'
  | 'firstday'
  | 'leave'
  | 'post'
  | 'shiftmanagement'
  | 'task'
  | 'trainingsession'
  | 'workiversary';

/** Autogenerated return type of CanDeleteJobcatalogTree. */
export type CanDeleteJobcatalogTreePayload = {
  __typename?: 'CanDeleteJobcatalogTreePayload';
  errors: Array<MutationError>;
  tree?: Maybe<JobCatalogTree>;
};

/** Autogenerated return type of CancelAtsInterview. */
export type CancelAtsInterviewPayload = {
  __typename?: 'CancelAtsInterviewPayload';
  errors: Array<MutationError>;
  interview?: Maybe<AtsInterview>;
};

/** Autogenerated return type of CancelAtsMessage. */
export type CancelAtsMessagePayload = {
  __typename?: 'CancelAtsMessagePayload';
  errors: Array<MutationError>;
  message?: Maybe<AtsMessage>;
};

/** Autogenerated return type of CancelAtsOfferLetter. */
export type CancelAtsOfferLetterPayload = {
  __typename?: 'CancelAtsOfferLetterPayload';
  errors: Array<MutationError>;
  offerLetter?: Maybe<AtsOfferLetter>;
};

/** Autogenerated return type of CancelAtsRequisition. */
export type CancelAtsRequisitionPayload = {
  __typename?: 'CancelAtsRequisitionPayload';
  errors: Array<MutationError>;
  requisition?: Maybe<AtsRequisition>;
};

/** Autogenerated return type of CancelBankingCard. */
export type CancelBankingCardPayload = {
  __typename?: 'CancelBankingCardPayload';
  card?: Maybe<BankingCard>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CancelDocumentsUploadProcess. */
export type CancelDocumentsUploadProcessPayload = {
  __typename?: 'CancelDocumentsUploadProcessPayload';
  errors: Array<MutationError>;
  uploadProcess?: Maybe<DocumentsUploadProcess>;
};

/** Autogenerated return type of CancelIntegrationsjoinOrder. */
export type CancelIntegrationsjoinOrderPayload = {
  __typename?: 'CancelIntegrationsjoinOrderPayload';
  errors: Array<MutationError>;
  order?: Maybe<IntegrationsJoinOrder>;
};

/** Autogenerated return type of CategorizeBankingTransaction. */
export type CategorizeBankingTransactionPayload = {
  __typename?: 'CategorizeBankingTransactionPayload';
  errors: Array<MutationError>;
  transaction?: Maybe<BankingTransaction>;
};

/** Autogenerated return type of ChangeAliasBankingCard. */
export type ChangeAliasBankingCardPayload = {
  __typename?: 'ChangeAliasBankingCardPayload';
  card?: Maybe<BankingCard>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of ChangeAssignmentProjectmanagementProject. */
export type ChangeAssignmentProjectmanagementProjectPayload = {
  __typename?: 'ChangeAssignmentProjectmanagementProjectPayload';
  errors: Array<MutationError>;
  project?: Maybe<ProjectManagementProject>;
};

/** Autogenerated return type of ChangeBillableRateProjectmanagementProject. */
export type ChangeBillableRateProjectmanagementProjectPayload = {
  __typename?: 'ChangeBillableRateProjectmanagementProjectPayload';
  errors: Array<MutationError>;
  project?: Maybe<ProjectManagementProject>;
};

export type ChangeBillableRateProjectmanagementProjectRatesInput = {
  billingRateCents: Scalars['Int'];
  currency: Scalars['String'];
  profitabilityPercentageCents: Scalars['Int'];
  projectId?: InputMaybe<Scalars['Int']>;
  referenceRateId?: InputMaybe<Scalars['Int']>;
  resourceId: Scalars['Int'];
  resourceType: Scalars['String'];
};

/** Autogenerated return type of ChangeGeneralInformationCompaniesCompany. */
export type ChangeGeneralInformationCompaniesCompanyPayload = {
  __typename?: 'ChangeGeneralInformationCompaniesCompanyPayload';
  company?: Maybe<CompaniesCompany>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of ChangeHiringStageAtsApplicationPhase. */
export type ChangeHiringStageAtsApplicationPhasePayload = {
  __typename?: 'ChangeHiringStageAtsApplicationPhasePayload';
  applicationPhase?: Maybe<AtsApplicationPhase>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of ChangeLocaleCompaniesCompany. */
export type ChangeLocaleCompaniesCompanyPayload = {
  __typename?: 'ChangeLocaleCompaniesCompanyPayload';
  company?: Maybe<CompaniesCompany>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of ChangeOwnershipItmanagementItAsset. */
export type ChangeOwnershipItmanagementItAssetPayload = {
  __typename?: 'ChangeOwnershipItmanagementItAssetPayload';
  errors: Array<MutationError>;
  itAsset?: Maybe<ItManagementItAsset>;
};

/** Autogenerated return type of ChangePhoneBankingCardholder. */
export type ChangePhoneBankingCardholderPayload = {
  __typename?: 'ChangePhoneBankingCardholderPayload';
  cardholder?: Maybe<BankingCardholder>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of ChangeSlugCompaniesCompany. */
export type ChangeSlugCompaniesCompanyPayload = {
  __typename?: 'ChangeSlugCompaniesCompanyPayload';
  company?: Maybe<CompaniesCompany>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of ChangeStatusBankingConsent. */
export type ChangeStatusBankingConsentPayload = {
  __typename?: 'ChangeStatusBankingConsentPayload';
  consent?: Maybe<BankingConsent>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of ChangeStatusBenefitsHealthcareEnrollment. */
export type ChangeStatusBenefitsHealthcareEnrollmentPayload = {
  __typename?: 'ChangeStatusBenefitsHealthcareEnrollmentPayload';
  errors: Array<MutationError>;
  healthcareEnrollment?: Maybe<BenefitsHealthcareEnrollment>;
};

/** Autogenerated return type of ChangeStatusIntegrationsjoinJobPosting. */
export type ChangeStatusIntegrationsjoinJobPostingPayload = {
  __typename?: 'ChangeStatusIntegrationsjoinJobPostingPayload';
  errors: Array<MutationError>;
  jobPosting?: Maybe<IntegrationsJoinJobPosting>;
};

/** Autogenerated return type of ChangeStatusIntegrationsjoinOrder. */
export type ChangeStatusIntegrationsjoinOrderPayload = {
  __typename?: 'ChangeStatusIntegrationsjoinOrderPayload';
  errors: Array<MutationError>;
  order?: Maybe<IntegrationsJoinOrder>;
};

/** Autogenerated return type of ChangeStatusPayrollPolicyPeriod. */
export type ChangeStatusPayrollPolicyPeriodPayload = {
  __typename?: 'ChangeStatusPayrollPolicyPeriodPayload';
  errors: Array<MutationError>;
  policyPeriod?: Maybe<PayrollPolicyPeriod>;
};

/** Autogenerated return type of ChangeStatusProjectmanagementProject. */
export type ChangeStatusProjectmanagementProjectPayload = {
  __typename?: 'ChangeStatusProjectmanagementProjectPayload';
  errors: Array<MutationError>;
  project?: Maybe<ProjectManagementProject>;
};

/** Autogenerated return type of ChatBillingCpChat. */
export type ChatBillingCpChatPayload = {
  __typename?: 'ChatBillingCpChatPayload';
  cpChat?: Maybe<BillingCpChat>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of ClockInAttendanceClockInOut. */
export type ClockInAttendanceClockInOutPayload = {
  __typename?: 'ClockInAttendanceClockInOutPayload';
  clockInOut?: Maybe<AttendanceClockInOut>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of ClockInAttendanceShift. */
export type ClockInAttendanceShiftPayload = {
  __typename?: 'ClockInAttendanceShiftPayload';
  errors: Array<MutationError>;
  shift?: Maybe<AttendanceShift>;
};

/** Autogenerated return type of ClockOutAttendanceClockInOut. */
export type ClockOutAttendanceClockInOutPayload = {
  __typename?: 'ClockOutAttendanceClockInOutPayload';
  clockInOut?: Maybe<AttendanceClockInOut>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of ClockOutAttendanceShift. */
export type ClockOutAttendanceShiftPayload = {
  __typename?: 'ClockOutAttendanceShiftPayload';
  errors: Array<MutationError>;
  shift?: Maybe<AttendanceShift>;
};

/** Autogenerated return type of ClosePayrollResult. */
export type ClosePayrollResultPayload = {
  __typename?: 'ClosePayrollResultPayload';
  errors: Array<MutationError>;
  result?: Maybe<PayrollResult>;
};

/** Autogenerated return type of CloseProjectmanagementProject. */
export type CloseProjectmanagementProjectPayload = {
  __typename?: 'CloseProjectmanagementProjectPayload';
  errors: Array<MutationError>;
  project?: Maybe<ProjectManagementProject>;
};

/** Coffre fort numerique status */
export type CoffreFortNumeriqueStatus = {
  __typename?: 'CoffreFortNumeriqueStatus';
  id: Scalars['Int'];
  lastResponse?: Maybe<Scalars['String']>;
  state: Scalars['String'];
  stateUpdatedAt: Scalars['ISO8601DateTime'];
  stateableId: Scalars['Int'];
  stateableType: Scalars['String'];
};

/** The connection type for CoffreFortNumeriqueStatus. */
export type CoffreFortNumeriqueStatusConnection = {
  __typename?: 'CoffreFortNumeriqueStatusConnection';
  /** A list of edges. */
  edges: Array<CoffreFortNumeriqueStatusEdge>;
  /** A list of nodes. */
  nodes: Array<CoffreFortNumeriqueStatus>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CoffreFortNumeriqueStatusEdge = {
  __typename?: 'CoffreFortNumeriqueStatusEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CoffreFortNumeriqueStatus;
};

/** saml_provider */
export type CognitoSamlProvider = {
  __typename?: 'CognitoSamlProvider';
  companyId: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['String'];
};

/** The connection type for CognitoSamlProvider. */
export type CognitoSamlProviderConnection = {
  __typename?: 'CognitoSamlProviderConnection';
  /** A list of edges. */
  edges: Array<CognitoSamlProviderEdge>;
  /** A list of nodes. */
  nodes: Array<CognitoSamlProvider>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CognitoSamlProviderEdge = {
  __typename?: 'CognitoSamlProviderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CognitoSamlProvider;
};

/** comment */
export type CommentsComment = {
  __typename?: 'CommentsComment';
  author?: Maybe<ApiCoreAccess>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  authorId: Scalars['Int'];
  companyId: Scalars['Int'];
  content: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  groupedReactions: Array<ReactionsGroupedReaction>;
  groupedReactionsConnection: ReactionsGroupedReactionConnection;
  id: Scalars['Int'];
  mentionedAccessIds?: Maybe<Array<Scalars['Int']>>;
  reactions: Array<ReactionsReaction>;
  reactionsConnection: ReactionsReactionConnection;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  resourceId: Scalars['Int'];
  resourceType: Scalars['String'];
};


/** comment */
export type CommentsCommentAuthorArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** comment */
export type CommentsCommentGroupedReactionsArgs = {
  authorId?: InputMaybe<Scalars['Int']>;
  companyId: Scalars['Int'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  textCode?: InputMaybe<Scalars['String']>;
};


/** comment */
export type CommentsCommentGroupedReactionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  authorId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  textCode?: InputMaybe<Scalars['String']>;
};


/** comment */
export type CommentsCommentReactionsArgs = {
  authorId?: InputMaybe<Scalars['Int']>;
  companyId: Scalars['Int'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  textCode?: InputMaybe<Scalars['String']>;
};


/** comment */
export type CommentsCommentReactionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  authorId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  textCode?: InputMaybe<Scalars['String']>;
};

/** The connection type for CommentsComment. */
export type CommentsCommentConnection = {
  __typename?: 'CommentsCommentConnection';
  /** A list of edges. */
  edges: Array<CommentsCommentEdge>;
  /** A list of nodes. */
  nodes: Array<CommentsComment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CommentsCommentEdge = {
  __typename?: 'CommentsCommentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CommentsComment;
};

/** The company resource */
export type CompaniesCompany = {
  __typename?: 'CompaniesCompany';
  bodyFont?: Maybe<Scalars['String']>;
  brandColor?: Maybe<Scalars['String']>;
  countryFactorialDomain?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  employeeCompanyIdentifierStrategy?: Maybe<Scalars['String']>;
  headerFont?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  industry?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  numberEmployees: Scalars['Int'];
  publicEmail?: Maybe<Scalars['String']>;
  publicUrl?: Maybe<Scalars['String']>;
  regularAccessDelayInDays?: Maybe<Scalars['Int']>;
  size: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
  subscription: BillingSubscription;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  subscriptionId?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['ISO8601DateTime'];
  workspaceLogo?: Maybe<Scalars['String']>;
};

/** The connection type for CompaniesCompany. */
export type CompaniesCompanyConnection = {
  __typename?: 'CompaniesCompanyConnection';
  /** A list of edges. */
  edges: Array<CompaniesCompanyEdge>;
  /** A list of nodes. */
  nodes: Array<CompaniesCompany>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CompaniesCompanyEdge = {
  __typename?: 'CompaniesCompanyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CompaniesCompany;
};

/** Insight in order to count the headcount per legal entity */
export type CompaniesEmployeesPerLegalEntity = {
  __typename?: 'CompaniesEmployeesPerLegalEntity';
  count: Scalars['Int'];
  legalName: Scalars['String'];
};

/** The connection type for CompaniesEmployeesPerLegalEntity. */
export type CompaniesEmployeesPerLegalEntityConnection = {
  __typename?: 'CompaniesEmployeesPerLegalEntityConnection';
  /** A list of edges. */
  edges: Array<CompaniesEmployeesPerLegalEntityEdge>;
  /** A list of nodes. */
  nodes: Array<CompaniesEmployeesPerLegalEntity>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CompaniesEmployeesPerLegalEntityEdge = {
  __typename?: 'CompaniesEmployeesPerLegalEntityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CompaniesEmployeesPerLegalEntity;
};

/** A repository to retrieve features available for a company */
export type CompaniesFeatureAvailability = {
  __typename?: 'CompaniesFeatureAvailability';
  additionalUnitPrice: Scalars['String'];
  available: Scalars['Boolean'];
  companyId: Scalars['Int'];
  currencyCode: Scalars['String'];
  description: Scalars['String'];
  externalProductIds: Array<Scalars['String']>;
  humanName: Scalars['String'];
  id: Scalars['String'];
  module: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
  usage?: Maybe<Scalars['Int']>;
  usageLimit?: Maybe<Scalars['Int']>;
};

/** The connection type for CompaniesFeatureAvailability. */
export type CompaniesFeatureAvailabilityConnection = {
  __typename?: 'CompaniesFeatureAvailabilityConnection';
  /** A list of edges. */
  edges: Array<CompaniesFeatureAvailabilityEdge>;
  /** A list of nodes. */
  nodes: Array<CompaniesFeatureAvailability>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CompaniesFeatureAvailabilityEdge = {
  __typename?: 'CompaniesFeatureAvailabilityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CompaniesFeatureAvailability;
};

/** the filter for the feature_availabilities resource */
export type CompaniesFeatureAvailabilityFilter = {
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<CompaniesFeatureAvailabilityFilterConditions>>;
};

export type CompaniesFeatureAvailabilityFilterConditions = {
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
};

/** Companies gender */
export type CompaniesGender = {
  __typename?: 'CompaniesGender';
  id: Scalars['Int'];
  name: Scalars['String'];
  translatedName: Scalars['String'];
};

/** The connection type for CompaniesGender. */
export type CompaniesGenderConnection = {
  __typename?: 'CompaniesGenderConnection';
  /** A list of edges. */
  edges: Array<CompaniesGenderEdge>;
  /** A list of nodes. */
  nodes: Array<CompaniesGender>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CompaniesGenderEdge = {
  __typename?: 'CompaniesGenderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CompaniesGender;
};

/** A repository to retrieve legal entities */
export type CompaniesLegalEntity = {
  __typename?: 'CompaniesLegalEntity';
  /** Address line 1 of the legal entity */
  addressLine1?: Maybe<Scalars['String']>;
  /** Address line 2 of the legal entity */
  addressLine2?: Maybe<Scalars['String']>;
  /** AEAT (Spanish Tax Agency) reporting period frequency. Spain-specific: monthly, quarterly, or annual tax filing period. */
  aeatClosingPeriodFrequency?: Maybe<Scalars['String']>;
  /** Bank account number (IBAN) associated with this legal entity. Used for payroll and financial transactions. */
  bankAccount?: Maybe<Scalars['String']>;
  bankingAccounts: Array<BankingAccount>;
  bankingAccountsConnection: BankingAccountConnection;
  bankingOnboardings: Array<BankingOnboarding>;
  bankingOnboardingsConnection: BankingOnboardingConnection;
  bankingProviderConfigurations: Array<BankingProviderConfiguration>;
  bankingProviderConfigurationsConnection: BankingProviderConfigurationConnection;
  /** City of the legal entity */
  city?: Maybe<Scalars['String']>;
  company: ApiCoreCompany;
  /**
   * company identifier
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  companyId: Scalars['Int'];
  contractTaxonomies: Array<ContractsTaxonomy>;
  contractTaxonomiesConnection: ContractsTaxonomyConnection;
  /** Type of contract versioning used by this legal entity. Defines how contract changes are tracked and versioned. */
  contractVersionType?: Maybe<Scalars['String']>;
  /** country code of the legal entity */
  country: Scalars['String'];
  /** The currency code in ISO 4217 format */
  currency: Scalars['String'];
  customFields: Array<CustomFieldsResourceField>;
  customFieldsConnection: CustomFieldsResourceFieldConnection;
  /** Default constant value used as a multiplier for each country's labor cost */
  defaultLaborCostMultiplier?: Maybe<Scalars['String']>;
  employeeGroups: Array<EmployeesEmployeeGroup>;
  employeeGroupsConnection: EmployeesEmployeeGroupConnection;
  financeAccounts: Array<FinanceAccount>;
  financeAccountsConnection: FinanceAccountConnection;
  /** identifier of the legal entity */
  id: Scalars['Int'];
  /** Primary address line for billing. Street address where invoices should be sent. */
  invoiceeAddressLine1?: Maybe<Scalars['String']>;
  /** City for billing address. Used in invoice generation and correspondence. */
  invoiceeCity?: Maybe<Scalars['String']>;
  /** Country code for billing address. ISO 3166-1 alpha-2 format (ES, FR, etc.). */
  invoiceeCountry?: Maybe<Scalars['String']>;
  /** Email address for sending invoices. Primary contact for billing communications. */
  invoiceeEmail?: Maybe<Scalars['String']>;
  /** First name of the billing contact person. Person receiving invoices for Factorial services. */
  invoiceeFirstName?: Maybe<Scalars['String']>;
  /** Last name of the billing contact person. Used for invoice correspondence. */
  invoiceeLastName?: Maybe<Scalars['String']>;
  /** Phone number of billing contact. Used for urgent billing matters. */
  invoiceePhoneNumber?: Maybe<Scalars['String']>;
  /** Postal/ZIP code for billing address. Required for proper invoice formatting. */
  invoiceePostalCode?: Maybe<Scalars['String']>;
  /** State/province for billing address. Required for some countries' invoice formats. */
  invoiceeState?: Maybe<Scalars['String']>;
  legalGenders: Array<CompaniesLegalGender>;
  legalGendersConnection: CompaniesLegalGenderConnection;
  /** Legal name of the legal entity */
  legalName: Scalars['String'];
  /** Whether this is the main legal entity for the company. Only one legal entity can be main per company. */
  main: Scalars['Boolean'];
  /** Postal code of the legal entity */
  postalCode?: Maybe<Scalars['String']>;
  /**
   * First surname/last name of the legal representative. Used in official
   * documents and legal contexts, especially Spain/Latin America.
   */
  representativeFirstSurname?: Maybe<Scalars['String']>;
  /**
   * Identification number (ID/passport/NIE) of the legal representative. Required
   * for legal documentation and official filings.
   */
  representativeIdentifier?: Maybe<Scalars['String']>;
  /** Job title of the legal representative (CEO, Managing Director, etc.). Appears on official documents and contracts. */
  representativeJobTitle?: Maybe<Scalars['String']>;
  /** First name/given name of the legal representative. Person authorized to sign on behalf of the legal entity. */
  representativeName?: Maybe<Scalars['String']>;
  /** Second surname of the legal representative. Common in Spanish-speaking countries. Used in official documentation. */
  representativeSecondSurname?: Maybe<Scalars['String']>;
  signedDocumentsTerms: Array<ExpensesSignedDocumentsTerm>;
  signedDocumentsTermsConnection: ExpensesSignedDocumentsTermConnection;
  /**
   * SIRET number (France-specific). System for identifying French establishments.
   * 14-digit identifier for each French establishment.
   */
  siret?: Maybe<Scalars['String']>;
  spanishContractTypes: Array<ContractsSpanishContractType>;
  spanishContractTypesConnection: ContractsSpanishContractTypeConnection;
  spanishEducationLevels: Array<ContractsSpanishEducationLevel>;
  spanishEducationLevelsConnection: ContractsSpanishEducationLevelConnection;
  /** State of the legal entity */
  state?: Maybe<Scalars['String']>;
  /** SWIFT/BIC code for the legal entity's bank. International bank identifier code for wire transfers. */
  swift?: Maybe<Scalars['String']>;
  /** Tax identification number */
  tin?: Maybe<Scalars['String']>;
};


/** A repository to retrieve legal entities */
export type CompaniesLegalEntityBankingAccountsArgs = {
  externalId?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  provider?: InputMaybe<Scalars['String']>;
  providers?: InputMaybe<Array<Scalars['String']>>;
  source?: InputMaybe<BankingValueObjectsOnboardingCreationSourceValueEnum>;
};


/** A repository to retrieve legal entities */
export type CompaniesLegalEntityBankingAccountsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  provider?: InputMaybe<Scalars['String']>;
  providers?: InputMaybe<Array<Scalars['String']>>;
  sortOrder?: InputMaybe<Sort>;
  source?: InputMaybe<BankingValueObjectsOnboardingCreationSourceValueEnum>;
};


/** A repository to retrieve legal entities */
export type CompaniesLegalEntityBankingOnboardingsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  source?: InputMaybe<BankingValueObjectsOnboardingCreationSourceValueEnum>;
  statuses?: InputMaybe<Array<BankingValueObjectsOnboardingStatusEnum>>;
  swanDocumentsCollectionId?: InputMaybe<Scalars['String']>;
};


/** A repository to retrieve legal entities */
export type CompaniesLegalEntityBankingOnboardingsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  source?: InputMaybe<BankingValueObjectsOnboardingCreationSourceValueEnum>;
  statuses?: InputMaybe<Array<BankingValueObjectsOnboardingStatusEnum>>;
  swanDocumentsCollectionId?: InputMaybe<Scalars['String']>;
};


/** A repository to retrieve legal entities */
export type CompaniesLegalEntityBankingProviderConfigurationsArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
  service?: InputMaybe<BankingProvidersServicesEnumEnum>;
};


/** A repository to retrieve legal entities */
export type CompaniesLegalEntityBankingProviderConfigurationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  service?: InputMaybe<BankingProvidersServicesEnumEnum>;
  sortOrder?: InputMaybe<Sort>;
};


/** A repository to retrieve legal entities */
export type CompaniesLegalEntityContractTaxonomiesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
};


/** A repository to retrieve legal entities */
export type CompaniesLegalEntityContractTaxonomiesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** A repository to retrieve legal entities */
export type CompaniesLegalEntityCustomFieldsArgs = {
  fieldIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  schemaIds?: InputMaybe<Array<Scalars['Int']>>;
  usageGroupSlugs?: InputMaybe<Array<Scalars['String']>>;
};


/** A repository to retrieve legal entities */
export type CompaniesLegalEntityCustomFieldsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  fieldIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  schemaIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
  usageGroupSlugs?: InputMaybe<Array<Scalars['String']>>;
};


/** A repository to retrieve legal entities */
export type CompaniesLegalEntityEmployeeGroupsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** A repository to retrieve legal entities */
export type CompaniesLegalEntityEmployeeGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** A repository to retrieve legal entities */
export type CompaniesLegalEntityFinanceAccountsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeDisabled?: Scalars['Boolean'];
  number?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Array<Scalars['String']>>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


/** A repository to retrieve legal entities */
export type CompaniesLegalEntityFinanceAccountsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeDisabled?: Scalars['Boolean'];
  last?: InputMaybe<Scalars['Int']>;
  number?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  types?: InputMaybe<Array<Scalars['String']>>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


/** A repository to retrieve legal entities */
export type CompaniesLegalEntityLegalGendersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** A repository to retrieve legal entities */
export type CompaniesLegalEntitySignedDocumentsTermsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  organization?: InputMaybe<Scalars['String']>;
};


/** A repository to retrieve legal entities */
export type CompaniesLegalEntitySignedDocumentsTermsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  organization?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


/** A repository to retrieve legal entities */
export type CompaniesLegalEntitySpanishContractTypesArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
};


/** A repository to retrieve legal entities */
export type CompaniesLegalEntitySpanishContractTypesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** A repository to retrieve legal entities */
export type CompaniesLegalEntitySpanishEducationLevelsArgs = {
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
};


/** A repository to retrieve legal entities */
export type CompaniesLegalEntitySpanishEducationLevelsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for CompaniesLegalEntity. */
export type CompaniesLegalEntityConnection = {
  __typename?: 'CompaniesLegalEntityConnection';
  /** A list of edges. */
  edges: Array<CompaniesLegalEntityEdge>;
  /** A list of nodes. */
  nodes: Array<CompaniesLegalEntity>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CompaniesLegalEntityEdge = {
  __typename?: 'CompaniesLegalEntityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CompaniesLegalEntity;
};

/** the filter for the legal_entities resource */
export type CompaniesLegalEntityFilter = {
  legalName?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<CompaniesLegalEntityFilterConditions>>;
};

export type CompaniesLegalEntityFilterConditions = {
  legalName?: InputMaybe<StringFilter>;
};

/** Companies legal gender */
export type CompaniesLegalGender = {
  __typename?: 'CompaniesLegalGender';
  gender: CompaniesGender;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  genderId: Scalars['Int'];
  legalEntity: CompaniesLegalEntity;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  legalEntityId: Scalars['Int'];
};


/** Companies legal gender */
export type CompaniesLegalGenderLegalEntityArgs = {
  companiesIds?: InputMaybe<Array<Scalars['Int']>>;
  countryIds?: InputMaybe<Array<Scalars['String']>>;
  employeesIds?: InputMaybe<Array<Scalars['Int']>>;
  excludeCountries?: InputMaybe<Array<Scalars['String']>>;
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};

/** The connection type for CompaniesLegalGender. */
export type CompaniesLegalGenderConnection = {
  __typename?: 'CompaniesLegalGenderConnection';
  /** A list of edges. */
  edges: Array<CompaniesLegalGenderEdge>;
  /** A list of nodes. */
  nodes: Array<CompaniesLegalGender>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CompaniesLegalGenderEdge = {
  __typename?: 'CompaniesLegalGenderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CompaniesLegalGender;
};

/** A repository to manage company logos */
export type CompaniesLogo = {
  __typename?: 'CompaniesLogo';
  byteSize?: Maybe<Scalars['Int']>;
  contentType?: Maybe<Scalars['String']>;
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  url?: Maybe<Scalars['String']>;
};

/** Companies module availability */
export type CompaniesModuleAvailability = {
  __typename?: 'CompaniesModuleAvailability';
  available: Scalars['Boolean'];
  companyId: Scalars['Int'];
  id: Scalars['String'];
};

/** The connection type for CompaniesModuleAvailability. */
export type CompaniesModuleAvailabilityConnection = {
  __typename?: 'CompaniesModuleAvailabilityConnection';
  /** A list of edges. */
  edges: Array<CompaniesModuleAvailabilityEdge>;
  /** A list of nodes. */
  nodes: Array<CompaniesModuleAvailability>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CompaniesModuleAvailabilityEdge = {
  __typename?: 'CompaniesModuleAvailabilityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CompaniesModuleAvailability;
};

/** A repository to retrieve the subscription overload active for a company */
export type CompaniesSubscriptionOverload = {
  __typename?: 'CompaniesSubscriptionOverload';
  addonIds: Array<Scalars['String']>;
  authorId?: Maybe<Scalars['Int']>;
  companyId: Scalars['Int'];
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  expirationDate: Scalars['ISO8601Date'];
  id: Scalars['Int'];
  overloadReason: Scalars['String'];
  planId?: Maybe<Scalars['String']>;
};

/** The connection type for CompaniesSubscriptionOverload. */
export type CompaniesSubscriptionOverloadConnection = {
  __typename?: 'CompaniesSubscriptionOverloadConnection';
  /** A list of edges. */
  edges: Array<CompaniesSubscriptionOverloadEdge>;
  /** A list of nodes. */
  nodes: Array<CompaniesSubscriptionOverload>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CompaniesSubscriptionOverloadEdge = {
  __typename?: 'CompaniesSubscriptionOverloadEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CompaniesSubscriptionOverload;
};

/** Company values */
export type CompanyPageCompanyValue = {
  __typename?: 'CompanyPageCompanyValue';
  description: Scalars['String'];
  id: Scalars['Int'];
  title: Scalars['String'];
};

/** The connection type for CompanyPageCompanyValue. */
export type CompanyPageCompanyValueConnection = {
  __typename?: 'CompanyPageCompanyValueConnection';
  /** A list of edges. */
  edges: Array<CompanyPageCompanyValueEdge>;
  /** A list of nodes. */
  nodes: Array<CompanyPageCompanyValue>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CompanyPageCompanyValueEdge = {
  __typename?: 'CompanyPageCompanyValueEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CompanyPageCompanyValue;
};

export type CompanyPageContextlessPolicies = {
  __typename?: 'CompanyPageContextlessPolicies';
  manageCompanyPage: ContextlessPolicyResolution;
};

/** Company perks */
export type CompanyPagePerk = {
  __typename?: 'CompanyPagePerk';
  categoryType: CompanyPagePerkCategoryTypeEnum;
  description: Scalars['String'];
  id: Scalars['Int'];
  title: Scalars['String'];
};

export type CompanyPagePerkCategoryTypeEnum =
  | 'fitness'
  | 'food'
  | 'health'
  | 'learning'
  | 'other'
  | 'time'
  | 'transport';

/** The connection type for CompanyPagePerk. */
export type CompanyPagePerkConnection = {
  __typename?: 'CompanyPagePerkConnection';
  /** A list of edges. */
  edges: Array<CompanyPagePerkEdge>;
  /** A list of nodes. */
  nodes: Array<CompanyPagePerk>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CompanyPagePerkEdge = {
  __typename?: 'CompanyPagePerkEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CompanyPagePerk;
};

export type CompensationsAmountStrategy = CompensationsFixedAmountStrategy | CompensationsVariableAmountStrategy;

/** compensation_settings */
export type CompensationsCompensationSetting = {
  __typename?: 'CompensationsCompensationSetting';
  company?: Maybe<CompaniesCompany>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  companyId: Scalars['Int'];
  id: Scalars['Int'];
  pendingCompensationsAlertDay?: Maybe<Scalars['Int']>;
};


/** compensation_settings */
export type CompensationsCompensationSettingCompanyArgs = {
  forBookkeepers?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** The connection type for CompensationsCompensationSetting. */
export type CompensationsCompensationSettingConnection = {
  __typename?: 'CompensationsCompensationSettingConnection';
  /** A list of edges. */
  edges: Array<CompensationsCompensationSettingEdge>;
  /** A list of nodes. */
  nodes: Array<CompensationsCompensationSetting>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CompensationsCompensationSettingEdge = {
  __typename?: 'CompensationsCompensationSettingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CompensationsCompensationSetting;
};

/** Compensations concept */
export type CompensationsConcept = {
  __typename?: 'CompensationsConcept';
  /** The category of the concept */
  category?: Maybe<PayrollValueObjectsConceptCategoryEnum>;
  /** The company identifier of the concept */
  companyId: Scalars['Int'];
  /** Whether the concept is a default or a custom concept */
  default: Scalars['Boolean'];
  /** The description of the concept */
  description: Scalars['String'];
  /** The identifier of the concept */
  id: Scalars['Int'];
  /** The label of the concept */
  label: Scalars['String'];
  laborCost?: Maybe<Scalars['Boolean']>;
  /** The name of the concept */
  name: Scalars['String'];
  /** The translated name of the concept if it is a default concept. */
  translatedName: Scalars['String'];
  /** The name of the unit of the concept */
  unitName?: Maybe<Scalars['String']>;
  /** The type of the unit of the concept */
  unitType?: Maybe<PayrollValueObjectsConceptUnitTypeEnum>;
};

/** The connection type for CompensationsConcept. */
export type CompensationsConceptConnection = {
  __typename?: 'CompensationsConceptConnection';
  /** A list of edges. */
  edges: Array<CompensationsConceptEdge>;
  /** A list of nodes. */
  nodes: Array<CompensationsConcept>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CompensationsConceptEdge = {
  __typename?: 'CompensationsConceptEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CompensationsConcept;
};

export type CompensationsContextlessPolicies = {
  __typename?: 'CompensationsContextlessPolicies';
  compensationActivityManage: ContextlessPolicyResolution;
  employeeCompensationBulkImport: ContextlessPolicyResolution;
  employeeCompensationExport: ContextlessPolicyResolution;
  payrollConceptsEdit: ContextlessPolicyResolution;
  payrollResultImport: ContextlessPolicyResolution;
  payrollRunToggleLockStatus: ContextlessPolicyResolution;
  settingsSeeCompensationsSettings: ContextlessPolicyResolution;
  sidebarSeeCompensationsInHouseActivationSubLevelItem: ContextlessPolicyResolution;
  sidebarSeeCompensationsIncidencesSubLevelItem: ContextlessPolicyResolution;
  sidebarSeeCompensationsTopLevelItem: ContextlessPolicyResolution;
};

/** Current compensations payroll run status */
export type CompensationsCurrentCompensationsPayrollRun = {
  __typename?: 'CompensationsCurrentCompensationsPayrollRun';
  eligibilities: Array<CompensationsReimbursementEligibility>;
  openToCompensate: Scalars['Boolean'];
};

/** The connection type for CompensationsCurrentCompensationsPayrollRun. */
export type CompensationsCurrentCompensationsPayrollRunConnection = {
  __typename?: 'CompensationsCurrentCompensationsPayrollRunConnection';
  /** A list of edges. */
  edges: Array<CompensationsCurrentCompensationsPayrollRunEdge>;
  /** A list of nodes. */
  nodes: Array<CompensationsCurrentCompensationsPayrollRun>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CompensationsCurrentCompensationsPayrollRunEdge = {
  __typename?: 'CompensationsCurrentCompensationsPayrollRunEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CompensationsCurrentCompensationsPayrollRun;
};

/** Compensation Cycles */
export type CompensationsCycle = {
  __typename?: 'CompensationsCycle';
  company?: Maybe<CompaniesCompany>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  companyId: Scalars['Int'];
  country?: Maybe<Scalars['String']>;
  countryLabel?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  firstPayment?: Maybe<Scalars['ISO8601Date']>;
  id: Scalars['Int'];
  legalEntitiesLabel?: Maybe<Scalars['String']>;
  peopleGroupId?: Maybe<Scalars['Int']>;
  recurrence: Scalars['String'];
};


/** Compensation Cycles */
export type CompensationsCycleCompanyArgs = {
  forBookkeepers?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** The connection type for CompensationsCycle. */
export type CompensationsCycleConnection = {
  __typename?: 'CompensationsCycleConnection';
  /** A list of edges. */
  edges: Array<CompensationsCycleEdge>;
  /** A list of nodes. */
  nodes: Array<CompensationsCycle>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CompensationsCycleEdge = {
  __typename?: 'CompensationsCycleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CompensationsCycle;
};

/** Compensation Cycles by employee */
export type CompensationsCyclesByEmployee = {
  __typename?: 'CompensationsCyclesByEmployee';
  company?: Maybe<CompaniesCompany>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  companyId: Scalars['Int'];
  country?: Maybe<Scalars['String']>;
  countryLabel?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  firstPayment?: Maybe<Scalars['ISO8601Date']>;
  id: Scalars['Int'];
  legalEntitiesLabel?: Maybe<Scalars['String']>;
  peopleGroupId?: Maybe<Scalars['Int']>;
  recurrence: Scalars['String'];
};


/** Compensation Cycles by employee */
export type CompensationsCyclesByEmployeeCompanyArgs = {
  forBookkeepers?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** The connection type for CompensationsCyclesByEmployee. */
export type CompensationsCyclesByEmployeeConnection = {
  __typename?: 'CompensationsCyclesByEmployeeConnection';
  /** A list of edges. */
  edges: Array<CompensationsCyclesByEmployeeEdge>;
  /** A list of nodes. */
  nodes: Array<CompensationsCyclesByEmployee>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CompensationsCyclesByEmployeeEdge = {
  __typename?: 'CompensationsCyclesByEmployeeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CompensationsCyclesByEmployee;
};

/** element_payroll_concepts */
export type CompensationsElementPayrollConcept = {
  __typename?: 'CompensationsElementPayrollConcept';
  compensationsPayrollRun?: Maybe<CompensationsPayrollRun>;
  id: Scalars['Int'];
  label: Scalars['String'];
  name: Scalars['String'];
  payrollConceptId: Scalars['Int'];
  payrollConceptUnit: Scalars['String'];
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  payrollRunId: Scalars['Int'];
  resultType: Scalars['String'];
};


/** element_payroll_concepts */
export type CompensationsElementPayrollConceptCompensationsPayrollRunArgs = {
  afterPayrollRunId?: InputMaybe<Scalars['Int']>;
  beforePayrollRunId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  countries?: InputMaybe<Array<Scalars['String']>>;
  currencies?: InputMaybe<Array<Scalars['String']>>;
  cycleIds?: InputMaybe<Array<Scalars['Int']>>;
  resultType?: InputMaybe<CompensationsValueObjectsResultTypeEnum>;
  startsOnGte?: InputMaybe<Scalars['ISO8601Date']>;
  startsOnLte?: InputMaybe<Scalars['ISO8601Date']>;
  status?: InputMaybe<CompensationsValueObjectsPayrollRunStatusEnum>;
  statuses?: InputMaybe<Array<Scalars['String']>>;
};

/** The connection type for CompensationsElementPayrollConcept. */
export type CompensationsElementPayrollConceptConnection = {
  __typename?: 'CompensationsElementPayrollConceptConnection';
  /** A list of edges. */
  edges: Array<CompensationsElementPayrollConceptEdge>;
  /** A list of nodes. */
  nodes: Array<CompensationsElementPayrollConcept>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CompensationsElementPayrollConceptEdge = {
  __typename?: 'CompensationsElementPayrollConceptEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CompensationsElementPayrollConcept;
};

/** Employees Compensations */
export type CompensationsEmployeesCompensation = {
  __typename?: 'CompensationsEmployeesCompensation';
  _policies?: Maybe<CompensationsEmployeesCompensationPolicies>;
  _policiesCollection?: Maybe<Array<PermissionsPolicyResolution>>;
  _policiesConnection: PermissionsPolicyResolutionConnection;
  amountIsOverwritten: Scalars['Boolean'];
  amountOverwritten?: Maybe<Scalars['Int']>;
  amountStrategyId: Scalars['Int'];
  amountStrategyType: CompensationsValueObjectsAmountStrategyTypeEnum;
  company?: Maybe<CompaniesCompany>;
  compensationsAmountStrategy?: Maybe<CompensationsAmountStrategy>;
  createdAt: Scalars['ISO8601DateTime'];
  createdByEmployee?: Maybe<EmployeesEmployeeName>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  createdByEmployeeId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  lastUpdatedByEmployee?: Maybe<EmployeesEmployeeName>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  lastUpdatedByEmployeeId?: Maybe<Scalars['Int']>;
  payrollConcept?: Maybe<PayrollConcept>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  payrollConceptId: Scalars['Int'];
  payrollRun?: Maybe<CompensationsPayrollRun>;
  payrollRunEmployeeId: Scalars['Int'];
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  payrollRunId: Scalars['Int'];
  resultType?: Maybe<CompensationsValueObjectsResultTypeEnum>;
  sourceId?: Maybe<Scalars['Int']>;
  sourceType?: Maybe<CompensationsValueObjectsEmployeeCompensationSourceTypeEnum>;
  updatedAt: Scalars['ISO8601DateTime'];
  validations: Array<CompensationsEmployeesCompensationsValidation>;
  validationsConnection: CompensationsEmployeesCompensationsValidationConnection;
};


/** Employees Compensations */
export type CompensationsEmployeesCompensation_PoliciesCollectionArgs = {
  ids: Array<CompensationsEmployeesCompensationPoliciesEnum>;
};


/** Employees Compensations */
export type CompensationsEmployeesCompensation_PoliciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Employees Compensations */
export type CompensationsEmployeesCompensationCompanyArgs = {
  forBookkeepers?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};


/** Employees Compensations */
export type CompensationsEmployeesCompensationCreatedByEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  afterEmployeeId?: InputMaybe<Scalars['Int']>;
  beforeEmployeeId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  reporteesOrLed?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyId?: InputMaybe<Scalars['Int']>;
  verb?: InputMaybe<Scalars['String']>;
  withActiveContract?: Scalars['Boolean'];
};


/** Employees Compensations */
export type CompensationsEmployeesCompensationLastUpdatedByEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  afterEmployeeId?: InputMaybe<Scalars['Int']>;
  beforeEmployeeId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  reporteesOrLed?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyId?: InputMaybe<Scalars['Int']>;
  verb?: InputMaybe<Scalars['String']>;
  withActiveContract?: Scalars['Boolean'];
};


/** Employees Compensations */
export type CompensationsEmployeesCompensationPayrollConceptArgs = {
  categories?: InputMaybe<Array<PayrollValueObjectsConceptCategoryEnum>>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  default?: InputMaybe<Scalars['Boolean']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  names?: InputMaybe<Array<Scalars['String']>>;
  policyPeriodId?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  unitTypes?: InputMaybe<Array<PayrollValueObjectsConceptUnitTypeEnum>>;
  withActiveStatus?: InputMaybe<Scalars['Boolean']>;
};


/** Employees Compensations */
export type CompensationsEmployeesCompensationPayrollRunArgs = {
  afterPayrollRunId?: InputMaybe<Scalars['Int']>;
  beforePayrollRunId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  countries?: InputMaybe<Array<Scalars['String']>>;
  currencies?: InputMaybe<Array<Scalars['String']>>;
  cycleIds?: InputMaybe<Array<Scalars['Int']>>;
  resultType?: InputMaybe<CompensationsValueObjectsResultTypeEnum>;
  startsOnGte?: InputMaybe<Scalars['ISO8601Date']>;
  startsOnLte?: InputMaybe<Scalars['ISO8601Date']>;
  status?: InputMaybe<CompensationsValueObjectsPayrollRunStatusEnum>;
  statuses?: InputMaybe<Array<Scalars['String']>>;
};


/** Employees Compensations */
export type CompensationsEmployeesCompensationValidationsArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  payrollRunEmployeeCompensationIds?: InputMaybe<Array<Scalars['Int']>>;
  payrollRunIds?: InputMaybe<Array<Scalars['Int']>>;
  validationType?: InputMaybe<Array<CompensationsValueObjectsEmployeeCompensationValidationTypeEnum>>;
};


/** Employees Compensations */
export type CompensationsEmployeesCompensationValidationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  payrollRunEmployeeCompensationIds?: InputMaybe<Array<Scalars['Int']>>;
  payrollRunIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
  validationType?: InputMaybe<Array<CompensationsValueObjectsEmployeeCompensationValidationTypeEnum>>;
};

/** The connection type for CompensationsEmployeesCompensation. */
export type CompensationsEmployeesCompensationConnection = {
  __typename?: 'CompensationsEmployeesCompensationConnection';
  /** A list of edges. */
  edges: Array<CompensationsEmployeesCompensationEdge>;
  /** A list of nodes. */
  nodes: Array<CompensationsEmployeesCompensation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CompensationsEmployeesCompensationEdge = {
  __typename?: 'CompensationsEmployeesCompensationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CompensationsEmployeesCompensation;
};

export type CompensationsEmployeesCompensationPolicies = {
  __typename?: 'CompensationsEmployeesCompensationPolicies';
  editCompensations: PermissionsPolicyResolution;
};

export type CompensationsEmployeesCompensationPoliciesEnum =
  | 'editCompensations';

/** Employee Compensation Validations */
export type CompensationsEmployeesCompensationsValidation = {
  __typename?: 'CompensationsEmployeesCompensationsValidation';
  company?: Maybe<CompaniesCompany>;
  compensationsPayrollRunEmployeeCompensation?: Maybe<CompensationsPayrollRunEmployeesCompensation>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  compensationsPayrollRunEmployeeCompensationId?: Maybe<Scalars['Int']>;
  dismissedByEmployee?: Maybe<EmployeesEmployee>;
  employeeCompensation?: Maybe<CompensationsEmployeesCompensation>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  employeeCompensationId: Scalars['Int'];
  id: Scalars['Int'];
  isDismissable: Scalars['Boolean'];
  sourceId: Scalars['Int'];
  sourceType: Scalars['String'];
  validationType: CompensationsValueObjectsEmployeeCompensationValidationTypeEnum;
};


/** Employee Compensation Validations */
export type CompensationsEmployeesCompensationsValidationCompanyArgs = {
  forBookkeepers?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};


/** Employee Compensation Validations */
export type CompensationsEmployeesCompensationsValidationCompensationsPayrollRunEmployeeCompensationArgs = {
  fromDate?: InputMaybe<Scalars['ISO8601Date']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  payrollConceptId?: InputMaybe<Scalars['Int']>;
  payrollConceptIds?: InputMaybe<Array<Scalars['Int']>>;
  payrollRunEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  payrollRunIds?: InputMaybe<Array<Scalars['Int']>>;
  resultType?: InputMaybe<CompensationsValueObjectsResultTypeEnum>;
  toDate?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Employee Compensation Validations */
export type CompensationsEmployeesCompensationsValidationDismissedByEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Employee Compensation Validations */
export type CompensationsEmployeesCompensationsValidationEmployeeCompensationArgs = {
  payrollConceptIds?: InputMaybe<Array<Scalars['Int']>>;
  payrollRunEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  payrollRunIds?: InputMaybe<Array<Scalars['Int']>>;
  resultType?: InputMaybe<CompensationsValueObjectsResultTypeEnum>;
  sourceIds?: InputMaybe<Array<Scalars['Int']>>;
  sourceType?: InputMaybe<Scalars['String']>;
};

/** The connection type for CompensationsEmployeesCompensationsValidation. */
export type CompensationsEmployeesCompensationsValidationConnection = {
  __typename?: 'CompensationsEmployeesCompensationsValidationConnection';
  /** A list of edges. */
  edges: Array<CompensationsEmployeesCompensationsValidationEdge>;
  /** A list of nodes. */
  nodes: Array<CompensationsEmployeesCompensationsValidation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CompensationsEmployeesCompensationsValidationEdge = {
  __typename?: 'CompensationsEmployeesCompensationsValidationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CompensationsEmployeesCompensationsValidation;
};

/** Files used for Bookkeepers from Professionals and the HR manager from Compensations. */
export type CompensationsFile = {
  __typename?: 'CompensationsFile';
  company?: Maybe<CompaniesCompany>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  companyId: Scalars['Int'];
  compensationsPayrollRunId: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  createdBy?: Maybe<ApiCoreAccess>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  createdById?: Maybe<Scalars['Int']>;
  deleted: Scalars['Boolean'];
  downloadUrl?: Maybe<Scalars['String']>;
  fileCategoryId: Scalars['Int'];
  fileName: Scalars['String'];
  id: Scalars['Int'];
  mimeType: Scalars['String'];
  status: CompensationsValueObjectsFileStatusEnum;
  updatedAt: Scalars['ISO8601DateTime'];
};


/** Files used for Bookkeepers from Professionals and the HR manager from Compensations. */
export type CompensationsFileCompanyArgs = {
  forBookkeepers?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};


/** Files used for Bookkeepers from Professionals and the HR manager from Compensations. */
export type CompensationsFileCreatedByArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};

/** File categories used for Bookkeepers from Professionals and the HR manager from Compensations. */
export type CompensationsFileCategory = {
  __typename?: 'CompensationsFileCategory';
  active: Scalars['Boolean'];
  categoryType: CompensationsValueObjectsFileCategoryTypeEnum;
  company?: Maybe<CompaniesCompany>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  companyId: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  files: Array<CompensationsFile>;
  filesConnection: CompensationsFileConnection;
  id: Scalars['Int'];
};


/** File categories used for Bookkeepers from Professionals and the HR manager from Compensations. */
export type CompensationsFileCategoryCompanyArgs = {
  forBookkeepers?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};


/** File categories used for Bookkeepers from Professionals and the HR manager from Compensations. */
export type CompensationsFileCategoryFilesArgs = {
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  payrollRunIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** File categories used for Bookkeepers from Professionals and the HR manager from Compensations. */
export type CompensationsFileCategoryFilesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  payrollRunIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for CompensationsFileCategory. */
export type CompensationsFileCategoryConnection = {
  __typename?: 'CompensationsFileCategoryConnection';
  /** A list of edges. */
  edges: Array<CompensationsFileCategoryEdge>;
  /** A list of nodes. */
  nodes: Array<CompensationsFileCategory>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CompensationsFileCategoryEdge = {
  __typename?: 'CompensationsFileCategoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CompensationsFileCategory;
};

/** The connection type for CompensationsFile. */
export type CompensationsFileConnection = {
  __typename?: 'CompensationsFileConnection';
  /** A list of edges. */
  edges: Array<CompensationsFileEdge>;
  /** A list of nodes. */
  nodes: Array<CompensationsFile>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CompensationsFileEdge = {
  __typename?: 'CompensationsFileEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CompensationsFile;
};

/** Fixed amount strategies */
export type CompensationsFixedAmountStrategy = {
  __typename?: 'CompensationsFixedAmountStrategy';
  amount?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  parentId?: Maybe<Scalars['Int']>;
  unitName?: Maybe<Scalars['String']>;
  unitSymbol?: Maybe<Scalars['String']>;
};

/** The connection type for CompensationsFixedAmountStrategy. */
export type CompensationsFixedAmountStrategyConnection = {
  __typename?: 'CompensationsFixedAmountStrategyConnection';
  /** A list of edges. */
  edges: Array<CompensationsFixedAmountStrategyEdge>;
  /** A list of nodes. */
  nodes: Array<CompensationsFixedAmountStrategy>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CompensationsFixedAmountStrategyEdge = {
  __typename?: 'CompensationsFixedAmountStrategyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CompensationsFixedAmountStrategy;
};

/** Payment Requests */
export type CompensationsPaymentRequest = {
  __typename?: 'CompensationsPaymentRequest';
  companyId: Scalars['Int'];
  currency: Scalars['String'];
  id: Scalars['Int'];
  label: Scalars['String'];
  payrollRunId: Scalars['Int'];
  requesterId: Scalars['Int'];
};

/** Payment Request Items */
export type CompensationsPaymentRequestItem = {
  __typename?: 'CompensationsPaymentRequestItem';
  amountCents: Scalars['Int'];
  employeeId: Scalars['Int'];
  id: Scalars['Int'];
  paymentRequestId: Scalars['Int'];
  status: CompensationsValueObjectsPaymentRequestStatusEnum;
};

/** The connection type for CompensationsPaymentRequestItem. */
export type CompensationsPaymentRequestItemConnection = {
  __typename?: 'CompensationsPaymentRequestItemConnection';
  /** A list of edges. */
  edges: Array<CompensationsPaymentRequestItemEdge>;
  /** A list of nodes. */
  nodes: Array<CompensationsPaymentRequestItem>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CompensationsPaymentRequestItemEdge = {
  __typename?: 'CompensationsPaymentRequestItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CompensationsPaymentRequestItem;
};

/** Payment Request Pending Items */
export type CompensationsPaymentRequestPendingItem = {
  __typename?: 'CompensationsPaymentRequestPendingItem';
  amountCents: Scalars['Int'];
  employeeId: Scalars['Int'];
  id: Scalars['Int'];
  payrollRunId: Scalars['Int'];
};

/** The connection type for CompensationsPaymentRequestPendingItem. */
export type CompensationsPaymentRequestPendingItemConnection = {
  __typename?: 'CompensationsPaymentRequestPendingItemConnection';
  /** A list of edges. */
  edges: Array<CompensationsPaymentRequestPendingItemEdge>;
  /** A list of nodes. */
  nodes: Array<CompensationsPaymentRequestPendingItem>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CompensationsPaymentRequestPendingItemEdge = {
  __typename?: 'CompensationsPaymentRequestPendingItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CompensationsPaymentRequestPendingItem;
};

/** payroll_concept_statuses */
export type CompensationsPayrollConceptStatus = {
  __typename?: 'CompensationsPayrollConceptStatus';
  companyId: Scalars['Int'];
  enabled: Scalars['Boolean'];
  id: Scalars['Int'];
  payrollConcept: PayrollConcept;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  payrollConceptId: Scalars['Int'];
};


/** payroll_concept_statuses */
export type CompensationsPayrollConceptStatusPayrollConceptArgs = {
  categories?: InputMaybe<Array<PayrollValueObjectsConceptCategoryEnum>>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  default?: InputMaybe<Scalars['Boolean']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  names?: InputMaybe<Array<Scalars['String']>>;
  policyPeriodId?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  unitTypes?: InputMaybe<Array<PayrollValueObjectsConceptUnitTypeEnum>>;
  withActiveStatus?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for CompensationsPayrollConceptStatus. */
export type CompensationsPayrollConceptStatusConnection = {
  __typename?: 'CompensationsPayrollConceptStatusConnection';
  /** A list of edges. */
  edges: Array<CompensationsPayrollConceptStatusEdge>;
  /** A list of nodes. */
  nodes: Array<CompensationsPayrollConceptStatus>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CompensationsPayrollConceptStatusEdge = {
  __typename?: 'CompensationsPayrollConceptStatusEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CompensationsPayrollConceptStatus;
};

/** payroll_runs */
export type CompensationsPayrollRun = {
  __typename?: 'CompensationsPayrollRun';
  comments: Array<CommentsComment>;
  commentsConnection: CommentsCommentConnection;
  company?: Maybe<CompaniesCompany>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  companyId: Scalars['Int'];
  cycle?: Maybe<CompensationsCycle>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  cycleId?: Maybe<Scalars['Int']>;
  elementPayrollConcepts: Array<CompensationsElementPayrollConcept>;
  elementPayrollConceptsConnection: CompensationsElementPayrollConceptConnection;
  employeePayrollRuns: Array<CompensationsPayrollRunEmployee>;
  employeePayrollRunsConnection: CompensationsPayrollRunEmployeeConnection;
  endsOn: Scalars['ISO8601Date'];
  id: Scalars['Int'];
  label: Scalars['String'];
  lockedAt?: Maybe<Scalars['ISO8601DateTime']>;
  lockedByAccessId?: Maybe<Scalars['Int']>;
  /** List of access IDs for participants */
  payrollRunParticipants: Array<Scalars['Int']>;
  payrollRunTotals: Array<CompensationsPayrollRunTotal>;
  payrollRunTotalsConnection: CompensationsPayrollRunTotalConnection;
  startsOn: Scalars['ISO8601Date'];
  status: Scalars['String'];
};


/** payroll_runs */
export type CompensationsPayrollRunCommentsArgs = {
  companyId: Scalars['Int'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  upToAndIncluding?: InputMaybe<Scalars['Int']>;
};


/** payroll_runs */
export type CompensationsPayrollRunCommentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  upToAndIncluding?: InputMaybe<Scalars['Int']>;
};


/** payroll_runs */
export type CompensationsPayrollRunCompanyArgs = {
  forBookkeepers?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};


/** payroll_runs */
export type CompensationsPayrollRunCycleArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  country?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  recurrence?: InputMaybe<Scalars['String']>;
};


/** payroll_runs */
export type CompensationsPayrollRunElementPayrollConceptsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  validationTypes?: InputMaybe<Array<CompensationsValueObjectsEmployeeCompensationValidationTypeEnum>>;
  workplaceIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** payroll_runs */
export type CompensationsPayrollRunElementPayrollConceptsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  validationTypes?: InputMaybe<Array<CompensationsValueObjectsEmployeeCompensationValidationTypeEnum>>;
  workplaceIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** payroll_runs */
export type CompensationsPayrollRunEmployeePayrollRunsArgs = {
  employeeStatus?: InputMaybe<Array<CompensationsValueObjectsEmployeeStatusEnum>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  integrationsAgreggatedSyncableStates?: InputMaybe<Array<IntegrationsAgreggatedSyncableStateValuesEnum>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  payrollRunId?: InputMaybe<Scalars['Int']>;
  resultType?: InputMaybe<CompensationsValueObjectsResultTypeEnum>;
  search?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  validationTypes?: InputMaybe<Array<CompensationsValueObjectsEmployeeCompensationValidationTypeEnum>>;
  workplaceIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** payroll_runs */
export type CompensationsPayrollRunEmployeePayrollRunsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeStatus?: InputMaybe<Array<CompensationsValueObjectsEmployeeStatusEnum>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  integrationsAgreggatedSyncableStates?: InputMaybe<Array<IntegrationsAgreggatedSyncableStateValuesEnum>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  payrollRunId?: InputMaybe<Scalars['Int']>;
  resultType?: InputMaybe<CompensationsValueObjectsResultTypeEnum>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  validationTypes?: InputMaybe<Array<CompensationsValueObjectsEmployeeCompensationValidationTypeEnum>>;
  workplaceIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** payroll_runs */
export type CompensationsPayrollRunPayrollRunTotalsArgs = {
  employeeStatus?: InputMaybe<Array<CompensationsValueObjectsEmployeeStatusEnum>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  integrationsAgreggatedSyncableStates?: InputMaybe<Array<IntegrationsAgreggatedSyncableStateValuesEnum>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  payrollRunId?: InputMaybe<Scalars['Int']>;
  resultType?: InputMaybe<CompensationsValueObjectsResultTypeEnum>;
  search?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  totalAmountInCents?: InputMaybe<Scalars['BigInt']>;
  validationTypes?: InputMaybe<Array<CompensationsValueObjectsEmployeeCompensationValidationTypeEnum>>;
  workplaceIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** payroll_runs */
export type CompensationsPayrollRunPayrollRunTotalsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeStatus?: InputMaybe<Array<CompensationsValueObjectsEmployeeStatusEnum>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  integrationsAgreggatedSyncableStates?: InputMaybe<Array<IntegrationsAgreggatedSyncableStateValuesEnum>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  payrollRunId?: InputMaybe<Scalars['Int']>;
  resultType?: InputMaybe<CompensationsValueObjectsResultTypeEnum>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  totalAmountInCents?: InputMaybe<Scalars['BigInt']>;
  validationTypes?: InputMaybe<Array<CompensationsValueObjectsEmployeeCompensationValidationTypeEnum>>;
  workplaceIds?: InputMaybe<Array<Scalars['Int']>>;
};

/** The connection type for CompensationsPayrollRun. */
export type CompensationsPayrollRunConnection = {
  __typename?: 'CompensationsPayrollRunConnection';
  /** A list of edges. */
  edges: Array<CompensationsPayrollRunEdge>;
  /** A list of nodes. */
  nodes: Array<CompensationsPayrollRun>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CompensationsPayrollRunEdge = {
  __typename?: 'CompensationsPayrollRunEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CompensationsPayrollRun;
};

/** payroll_run_employees */
export type CompensationsPayrollRunEmployee = {
  __typename?: 'CompensationsPayrollRunEmployee';
  baseSalary?: Maybe<Scalars['String']>;
  company?: Maybe<CompaniesCompany>;
  compensations: Array<CompensationsPayrollRunEmployeesCompensation>;
  compensationsConnection: CompensationsPayrollRunEmployeesCompensationConnection;
  employee?: Maybe<EmployeesEmployee>;
  fullName: Scalars['String'];
  id: Scalars['Int'];
  legalEntity?: Maybe<CompaniesLegalEntity>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  legalEntityId?: Maybe<Scalars['Int']>;
  payrollRun?: Maybe<CompensationsPayrollRun>;
  team?: Maybe<TeamsTeam>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  teamId?: Maybe<Scalars['Int']>;
  workplaceId?: Maybe<Scalars['Int']>;
};


/** payroll_run_employees */
export type CompensationsPayrollRunEmployeeCompanyArgs = {
  forBookkeepers?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};


/** payroll_run_employees */
export type CompensationsPayrollRunEmployeeCompensationsArgs = {
  fromDate?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  payrollConceptId?: InputMaybe<Scalars['Int']>;
  payrollConceptIds?: InputMaybe<Array<Scalars['Int']>>;
  payrollRunIds?: InputMaybe<Array<Scalars['Int']>>;
  resultType?: InputMaybe<CompensationsValueObjectsResultTypeEnum>;
  toDate?: InputMaybe<Scalars['ISO8601Date']>;
};


/** payroll_run_employees */
export type CompensationsPayrollRunEmployeeCompensationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  fromDate?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  payrollConceptId?: InputMaybe<Scalars['Int']>;
  payrollConceptIds?: InputMaybe<Array<Scalars['Int']>>;
  payrollRunIds?: InputMaybe<Array<Scalars['Int']>>;
  resultType?: InputMaybe<CompensationsValueObjectsResultTypeEnum>;
  sortOrder?: InputMaybe<Sort>;
  toDate?: InputMaybe<Scalars['ISO8601Date']>;
};


/** payroll_run_employees */
export type CompensationsPayrollRunEmployeeEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** payroll_run_employees */
export type CompensationsPayrollRunEmployeeLegalEntityArgs = {
  companiesIds?: InputMaybe<Array<Scalars['Int']>>;
  countryIds?: InputMaybe<Array<Scalars['String']>>;
  employeesIds?: InputMaybe<Array<Scalars['Int']>>;
  excludeCountries?: InputMaybe<Array<Scalars['String']>>;
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


/** payroll_run_employees */
export type CompensationsPayrollRunEmployeePayrollRunArgs = {
  afterPayrollRunId?: InputMaybe<Scalars['Int']>;
  beforePayrollRunId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  countries?: InputMaybe<Array<Scalars['String']>>;
  currencies?: InputMaybe<Array<Scalars['String']>>;
  cycleIds?: InputMaybe<Array<Scalars['Int']>>;
  resultType?: InputMaybe<CompensationsValueObjectsResultTypeEnum>;
  startsOnGte?: InputMaybe<Scalars['ISO8601Date']>;
  startsOnLte?: InputMaybe<Scalars['ISO8601Date']>;
  status?: InputMaybe<CompensationsValueObjectsPayrollRunStatusEnum>;
  statuses?: InputMaybe<Array<Scalars['String']>>;
};


/** payroll_run_employees */
export type CompensationsPayrollRunEmployeeTeamArgs = {
  mainTeam?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  withMembers?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for CompensationsPayrollRunEmployee. */
export type CompensationsPayrollRunEmployeeConnection = {
  __typename?: 'CompensationsPayrollRunEmployeeConnection';
  /** A list of edges. */
  edges: Array<CompensationsPayrollRunEmployeeEdge>;
  /** A list of nodes. */
  nodes: Array<CompensationsPayrollRunEmployee>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CompensationsPayrollRunEmployeeEdge = {
  __typename?: 'CompensationsPayrollRunEmployeeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CompensationsPayrollRunEmployee;
};

/** the filter for the payroll_run_employees resource */
export type CompensationsPayrollRunEmployeeFilter = {
  fullName?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<CompensationsPayrollRunEmployeeFilterConditions>>;
};

export type CompensationsPayrollRunEmployeeFilterConditions = {
  fullName?: InputMaybe<StringFilter>;
};

/** Payroll Run Employees Compensations */
export type CompensationsPayrollRunEmployeesCompensation = {
  __typename?: 'CompensationsPayrollRunEmployeesCompensation';
  amount?: Maybe<Scalars['Int']>;
  amountStrategyId: Scalars['Int'];
  amountStrategyType: CompensationsValueObjectsAmountStrategyTypeEnum;
  company?: Maybe<CompaniesCompany>;
  compensationsAmountStrategy?: Maybe<CompensationsAmountStrategy>;
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['Int'];
  isOverridden?: Maybe<Scalars['Boolean']>;
  legalEntityId?: Maybe<Scalars['Int']>;
  payrollConcept?: Maybe<PayrollConcept>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  payrollConceptId: Scalars['Int'];
  payrollRunEmployeeId: Scalars['Int'];
  payrollRunId: Scalars['Int'];
  resultType: Scalars['String'];
  syncableState: Array<IntegrationsSyncableState>;
  syncableStateConnection: IntegrationsSyncableStateConnection;
  updatedAt: Scalars['ISO8601DateTime'];
  validations: Array<CompensationsEmployeesCompensationsValidation>;
  validationsConnection: CompensationsEmployeesCompensationsValidationConnection;
};


/** Payroll Run Employees Compensations */
export type CompensationsPayrollRunEmployeesCompensationCompanyArgs = {
  forBookkeepers?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};


/** Payroll Run Employees Compensations */
export type CompensationsPayrollRunEmployeesCompensationPayrollConceptArgs = {
  categories?: InputMaybe<Array<PayrollValueObjectsConceptCategoryEnum>>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  default?: InputMaybe<Scalars['Boolean']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  names?: InputMaybe<Array<Scalars['String']>>;
  policyPeriodId?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  unitTypes?: InputMaybe<Array<PayrollValueObjectsConceptUnitTypeEnum>>;
  withActiveStatus?: InputMaybe<Scalars['Boolean']>;
};


/** Payroll Run Employees Compensations */
export type CompensationsPayrollRunEmployeesCompensationSyncableStateArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  marketplaceIntegrationId?: InputMaybe<Scalars['Int']>;
};


/** Payroll Run Employees Compensations */
export type CompensationsPayrollRunEmployeesCompensationSyncableStateConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  marketplaceIntegrationId?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Payroll Run Employees Compensations */
export type CompensationsPayrollRunEmployeesCompensationValidationsArgs = {
  employeeCompensationIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  payrollRunEmployeeCompensationIds?: InputMaybe<Array<Scalars['Int']>>;
  payrollRunIds?: InputMaybe<Array<Scalars['Int']>>;
  validationType?: InputMaybe<Array<CompensationsValueObjectsEmployeeCompensationValidationTypeEnum>>;
};


/** Payroll Run Employees Compensations */
export type CompensationsPayrollRunEmployeesCompensationValidationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeCompensationIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  payrollRunEmployeeCompensationIds?: InputMaybe<Array<Scalars['Int']>>;
  payrollRunIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
  validationType?: InputMaybe<Array<CompensationsValueObjectsEmployeeCompensationValidationTypeEnum>>;
};

/** The connection type for CompensationsPayrollRunEmployeesCompensation. */
export type CompensationsPayrollRunEmployeesCompensationConnection = {
  __typename?: 'CompensationsPayrollRunEmployeesCompensationConnection';
  /** A list of edges. */
  edges: Array<CompensationsPayrollRunEmployeesCompensationEdge>;
  /** A list of nodes. */
  nodes: Array<CompensationsPayrollRunEmployeesCompensation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CompensationsPayrollRunEmployeesCompensationEdge = {
  __typename?: 'CompensationsPayrollRunEmployeesCompensationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CompensationsPayrollRunEmployeesCompensation;
};

/** payroll_run_totals */
export type CompensationsPayrollRunTotal = {
  __typename?: 'CompensationsPayrollRunTotal';
  compensationsPayrollRun?: Maybe<CompensationsPayrollRun>;
  id: Scalars['Int'];
  payrollConceptId: Scalars['Int'];
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  payrollRunId: Scalars['Int'];
  resultType: CompensationsValueObjectsResultTypeEnum;
  totalAmountInCents: Scalars['BigInt'];
};


/** payroll_run_totals */
export type CompensationsPayrollRunTotalCompensationsPayrollRunArgs = {
  afterPayrollRunId?: InputMaybe<Scalars['Int']>;
  beforePayrollRunId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  countries?: InputMaybe<Array<Scalars['String']>>;
  currencies?: InputMaybe<Array<Scalars['String']>>;
  cycleIds?: InputMaybe<Array<Scalars['Int']>>;
  resultType?: InputMaybe<CompensationsValueObjectsResultTypeEnum>;
  startsOnGte?: InputMaybe<Scalars['ISO8601Date']>;
  startsOnLte?: InputMaybe<Scalars['ISO8601Date']>;
  status?: InputMaybe<CompensationsValueObjectsPayrollRunStatusEnum>;
  statuses?: InputMaybe<Array<Scalars['String']>>;
};

/** The connection type for CompensationsPayrollRunTotal. */
export type CompensationsPayrollRunTotalConnection = {
  __typename?: 'CompensationsPayrollRunTotalConnection';
  /** A list of edges. */
  edges: Array<CompensationsPayrollRunTotalEdge>;
  /** A list of nodes. */
  nodes: Array<CompensationsPayrollRunTotal>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CompensationsPayrollRunTotalEdge = {
  __typename?: 'CompensationsPayrollRunTotalEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CompensationsPayrollRunTotal;
};

/** reimbursable_payroll_concept */
export type CompensationsReimbursablePayrollConcept = {
  __typename?: 'CompensationsReimbursablePayrollConcept';
  company?: Maybe<CompaniesCompany>;
  id: Scalars['Int'];
  payrollConcept?: Maybe<PayrollConcept>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  payrollConceptId: Scalars['Int'];
  reimbursable?: Maybe<FinanceCustomCategory>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  reimbursableId: Scalars['Int'];
  reimbursableType: Scalars['String'];
};


/** reimbursable_payroll_concept */
export type CompensationsReimbursablePayrollConceptCompanyArgs = {
  forBookkeepers?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};


/** reimbursable_payroll_concept */
export type CompensationsReimbursablePayrollConceptPayrollConceptArgs = {
  categories?: InputMaybe<Array<PayrollValueObjectsConceptCategoryEnum>>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  default?: InputMaybe<Scalars['Boolean']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  names?: InputMaybe<Array<Scalars['String']>>;
  policyPeriodId?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  unitTypes?: InputMaybe<Array<PayrollValueObjectsConceptUnitTypeEnum>>;
  withActiveStatus?: InputMaybe<Scalars['Boolean']>;
};


/** reimbursable_payroll_concept */
export type CompensationsReimbursablePayrollConceptReimbursableArgs = {
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  factorialCategoryIdentifier?: InputMaybe<Scalars['String']>;
  parentCategoryIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};

/** The connection type for CompensationsReimbursablePayrollConcept. */
export type CompensationsReimbursablePayrollConceptConnection = {
  __typename?: 'CompensationsReimbursablePayrollConceptConnection';
  /** A list of edges. */
  edges: Array<CompensationsReimbursablePayrollConceptEdge>;
  /** A list of nodes. */
  nodes: Array<CompensationsReimbursablePayrollConcept>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CompensationsReimbursablePayrollConceptEdge = {
  __typename?: 'CompensationsReimbursablePayrollConceptEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CompensationsReimbursablePayrollConcept;
};

export type CompensationsReimbursementEligibility = {
  __typename?: 'CompensationsReimbursementEligibility';
  cycleId?: Maybe<Scalars['Int']>;
  cycleLabel?: Maybe<Scalars['String']>;
  employeeId: Scalars['Int'];
  openToCompensate: Scalars['Boolean'];
  payrollRunId?: Maybe<Scalars['Int']>;
  payrollRunLabel?: Maybe<Scalars['String']>;
};

export type CompensationsValueObjectsAmountStrategyTypeEnum =
  | 'compensations_fixed_amount_strategy'
  | 'compensations_variable_amount_strategy';

export type CompensationsValueObjectsEmployeeCompensationSourceTypeEnum =
  | 'benefits_compensation'
  | 'compensations_compensationpolicy'
  | 'expenses_expensable'
  | 'expenses_expense'
  | 'expenses_mileage'
  | 'timesettings_customtimerangecategory';

export type CompensationsValueObjectsEmployeeCompensationValidationTypeEnum =
  | 'above_limit'
  | 'discrepancy'
  | 'pending_to_define';

export type CompensationsValueObjectsEmployeeStatusEnum =
  | 'active'
  | 'inactive_last_3_months'
  | 'inactive_this_month';

export type CompensationsValueObjectsFileCategoryTypeEnum =
  | 'exported'
  | 'others'
  | 'payment_method'
  | 'payroll_result'
  | 'payslips';

export type CompensationsValueObjectsFileStatusEnum =
  | 'imported'
  | 'pending';

export type CompensationsValueObjectsPaymentRequestStatusEnum =
  | 'in_progress'
  | 'paid';

export type CompensationsValueObjectsPayrollRunStatusEnum =
  | 'calculation'
  | 'closed'
  | 'completed'
  | 'in_preparation'
  | 'in_review'
  | 'open'
  | 'opened';

export type CompensationsValueObjectsResultTypeEnum =
  | 'compensation'
  | 'payroll_result';

/** Variable amount strategies */
export type CompensationsVariableAmountStrategy = {
  __typename?: 'CompensationsVariableAmountStrategy';
  amount?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  parentId?: Maybe<Scalars['Int']>;
  unitName?: Maybe<Scalars['String']>;
  unitSymbol?: Maybe<Scalars['String']>;
  upperLimit?: Maybe<Scalars['Int']>;
};

/** The connection type for CompensationsVariableAmountStrategy. */
export type CompensationsVariableAmountStrategyConnection = {
  __typename?: 'CompensationsVariableAmountStrategyConnection';
  /** A list of edges. */
  edges: Array<CompensationsVariableAmountStrategyEdge>;
  /** A list of nodes. */
  nodes: Array<CompensationsVariableAmountStrategy>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CompensationsVariableAmountStrategyEdge = {
  __typename?: 'CompensationsVariableAmountStrategyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CompensationsVariableAmountStrategy;
};

/** Autogenerated return type of Compensations_payroll_run_data_updated_subscription. */
export type Compensations_Payroll_Run_Data_Updated_SubscriptionPayload = {
  __typename?: 'Compensations_payroll_run_data_updated_subscriptionPayload';
  payrollRun?: Maybe<Payroll_Run_Data_Updated_Type>;
};

/** Assessments */
export type CompetenciesAssessment = {
  __typename?: 'CompetenciesAssessment';
  assessmentGroup?: Maybe<CompetenciesAssessmentGroup>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  assessmentGroupId: Scalars['Int'];
  competency?: Maybe<CompetenciesCompetency>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  competencyId: Scalars['Int'];
  competencyLevel?: Maybe<CompetenciesCompetencyLevel>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  competencyLevelId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  normalizedScore: Scalars['Float'];
  scaleMax: Scalars['Int'];
  scaleMin: Scalars['Int'];
  score: Scalars['Int'];
};


/** Assessments */
export type CompetenciesAssessmentAssessmentGroupArgs = {
  targetEmployeeIds?: InputMaybe<Array<Scalars['String']>>;
};


/** Assessments */
export type CompetenciesAssessmentCompetencyArgs = {
  competencyGroupIds?: InputMaybe<Array<Scalars['String']>>;
  everyone?: InputMaybe<Scalars['Boolean']>;
  roleIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  withDeleted?: InputMaybe<Scalars['Boolean']>;
};


/** Assessments */
export type CompetenciesAssessmentCompetencyLevelArgs = {
  competencyIds?: InputMaybe<Array<Scalars['Int']>>;
};

/** The connection type for CompetenciesAssessment. */
export type CompetenciesAssessmentConnection = {
  __typename?: 'CompetenciesAssessmentConnection';
  /** A list of edges. */
  edges: Array<CompetenciesAssessmentEdge>;
  /** A list of nodes. */
  nodes: Array<CompetenciesAssessment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CompetenciesAssessmentEdge = {
  __typename?: 'CompetenciesAssessmentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CompetenciesAssessment;
};

/** Assessment groups */
export type CompetenciesAssessmentGroup = {
  __typename?: 'CompetenciesAssessmentGroup';
  assessments: Array<CompetenciesAssessment>;
  assessmentsConnection: CompetenciesAssessmentConnection;
  authorEmployeeId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  publishedAt: Scalars['ISO8601DateTime'];
  reviewEvaluation?: Maybe<PerformanceReviewEvaluation>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  reviewEvaluationId?: Maybe<Scalars['Int']>;
  targetEmployeeId: Scalars['Int'];
};


/** Assessment groups */
export type CompetenciesAssessmentGroupAssessmentsArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};


/** Assessment groups */
export type CompetenciesAssessmentGroupAssessmentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Assessment groups */
export type CompetenciesAssessmentGroupReviewEvaluationArgs = {
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  performanceReviewProcessIds?: InputMaybe<Array<Scalars['Int']>>;
  published?: InputMaybe<Scalars['Boolean']>;
  reviewProcessTargetIds?: InputMaybe<Array<Scalars['String']>>;
  reviewerIds?: InputMaybe<Array<Scalars['Int']>>;
  reviewerStrategies?: InputMaybe<Array<PerformanceReviewerStrategiesStrategyEnum>>;
  targetAccessIds?: InputMaybe<Array<Scalars['Int']>>;
  withTargetsManagedByFilter?: InputMaybe<ReviewEvaluationsWithTargetsManagedByFilterInput>;
};

/** The connection type for CompetenciesAssessmentGroup. */
export type CompetenciesAssessmentGroupConnection = {
  __typename?: 'CompetenciesAssessmentGroupConnection';
  /** A list of edges. */
  edges: Array<CompetenciesAssessmentGroupEdge>;
  /** A list of nodes. */
  nodes: Array<CompetenciesAssessmentGroup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CompetenciesAssessmentGroupEdge = {
  __typename?: 'CompetenciesAssessmentGroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CompetenciesAssessmentGroup;
};

/** the filter for the assessment_groups resource */
export type CompetenciesAssessmentGroupFilter = {
  or?: InputMaybe<Array<CompetenciesAssessmentGroupFilterConditions>>;
  publishedAt?: InputMaybe<DateTimeFilter>;
};

export type CompetenciesAssessmentGroupFilterConditions = {
  publishedAt?: InputMaybe<DateTimeFilter>;
};

/** Competencies competencies */
export type CompetenciesCompetency = {
  __typename?: 'CompetenciesCompetency';
  companyId: Scalars['Int'];
  competencyGroup?: Maybe<CompetenciesCompetencyGroup>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  competencyGroupId?: Maybe<Scalars['String']>;
  competencyLevels: Array<CompetenciesCompetencyLevel>;
  competencyLevelsConnection: CompetenciesCompetencyLevelConnection;
  description?: Maybe<Scalars['String']>;
  everyone: Scalars['Boolean'];
  factorialCompetencyUuid?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  jobCatalogRoleLevels?: Maybe<CompetenciesCompetencyJobCatalogNode>;
  name: Scalars['String'];
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  roleIds?: Maybe<Array<Scalars['Int']>>;
  roles: Array<JobCatalogRole>;
  rolesConnection: JobCatalogRoleConnection;
};


/** Competencies competencies */
export type CompetenciesCompetencyCompetencyGroupArgs = {
  search?: InputMaybe<Scalars['String']>;
};


/** Competencies competencies */
export type CompetenciesCompetencyCompetencyLevelsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Competencies competencies */
export type CompetenciesCompetencyCompetencyLevelsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Competencies competencies */
export type CompetenciesCompetencyRolesArgs = {
  includeArchived?: Scalars['Boolean'];
  jobCatalogLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  legalEntitiesIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Competencies competencies */
export type CompetenciesCompetencyRolesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  includeArchived?: Scalars['Boolean'];
  jobCatalogLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntitiesIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for CompetenciesCompetency. */
export type CompetenciesCompetencyConnection = {
  __typename?: 'CompetenciesCompetencyConnection';
  /** A list of edges. */
  edges: Array<CompetenciesCompetencyEdge>;
  /** A list of nodes. */
  nodes: Array<CompetenciesCompetency>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CompetenciesCompetencyEdge = {
  __typename?: 'CompetenciesCompetencyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CompetenciesCompetency;
};

/** the filter for the competencies resource */
export type CompetenciesCompetencyFilter = {
  competencyGroupId?: InputMaybe<StringFilter>;
  everyone?: InputMaybe<BooleanFilter>;
  id?: InputMaybe<IntegerFilter>;
  name?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<CompetenciesCompetencyFilterConditions>>;
  roleIds?: InputMaybe<StringFilter>;
};

export type CompetenciesCompetencyFilterConditions = {
  competencyGroupId?: InputMaybe<StringFilter>;
  everyone?: InputMaybe<BooleanFilter>;
  id?: InputMaybe<IntegerFilter>;
  name?: InputMaybe<StringFilter>;
  roleIds?: InputMaybe<StringFilter>;
};

/** Competency groups */
export type CompetenciesCompetencyGroup = {
  __typename?: 'CompetenciesCompetencyGroup';
  company?: Maybe<ApiCoreCompany>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  companyId: Scalars['Int'];
  competencies: Array<CompetenciesCompetency>;
  competenciesConnection: CompetenciesCompetencyConnection;
  id: Scalars['String'];
  name: Scalars['String'];
};


/** Competency groups */
export type CompetenciesCompetencyGroupCompetenciesArgs = {
  everyone?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  roleIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  withDeleted?: InputMaybe<Scalars['Boolean']>;
};


/** Competency groups */
export type CompetenciesCompetencyGroupCompetenciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  everyone?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  roleIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  withDeleted?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for CompetenciesCompetencyGroup. */
export type CompetenciesCompetencyGroupConnection = {
  __typename?: 'CompetenciesCompetencyGroupConnection';
  /** A list of edges. */
  edges: Array<CompetenciesCompetencyGroupEdge>;
  /** A list of nodes. */
  nodes: Array<CompetenciesCompetencyGroup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CompetenciesCompetencyGroupEdge = {
  __typename?: 'CompetenciesCompetencyGroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CompetenciesCompetencyGroup;
};

/** the filter for the competency_groups resource */
export type CompetenciesCompetencyGroupFilter = {
  name?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<CompetenciesCompetencyGroupFilterConditions>>;
};

export type CompetenciesCompetencyGroupFilterConditions = {
  name?: InputMaybe<StringFilter>;
};

/** Competency job catalog nodes */
export type CompetenciesCompetencyJobCatalogNode = {
  __typename?: 'CompetenciesCompetencyJobCatalogNode';
  id: Scalars['Int'];
  nodeUuids: Array<Scalars['String']>;
};

/** The connection type for CompetenciesCompetencyJobCatalogNode. */
export type CompetenciesCompetencyJobCatalogNodeConnection = {
  __typename?: 'CompetenciesCompetencyJobCatalogNodeConnection';
  /** A list of edges. */
  edges: Array<CompetenciesCompetencyJobCatalogNodeEdge>;
  /** A list of nodes. */
  nodes: Array<CompetenciesCompetencyJobCatalogNode>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CompetenciesCompetencyJobCatalogNodeEdge = {
  __typename?: 'CompetenciesCompetencyJobCatalogNodeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CompetenciesCompetencyJobCatalogNode;
};

/** Competency levels */
export type CompetenciesCompetencyLevel = {
  __typename?: 'CompetenciesCompetencyLevel';
  competencyId: Scalars['Int'];
  description: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  position: Scalars['Int'];
};

/** The connection type for CompetenciesCompetencyLevel. */
export type CompetenciesCompetencyLevelConnection = {
  __typename?: 'CompetenciesCompetencyLevelConnection';
  /** A list of edges. */
  edges: Array<CompetenciesCompetencyLevelEdge>;
  /** A list of nodes. */
  nodes: Array<CompetenciesCompetencyLevel>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CompetenciesCompetencyLevelEdge = {
  __typename?: 'CompetenciesCompetencyLevelEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CompetenciesCompetencyLevel;
};

/** the filter for the competency_levels resource */
export type CompetenciesCompetencyLevelFilter = {
  name?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<CompetenciesCompetencyLevelFilterConditions>>;
};

export type CompetenciesCompetencyLevelFilterConditions = {
  name?: InputMaybe<StringFilter>;
};

export type CompetenciesContextlessPolicies = {
  __typename?: 'CompetenciesContextlessPolicies';
  competenciesManage: ContextlessPolicyResolution;
  competencyGroupsManage: ContextlessPolicyResolution;
  sidebarSeePerformanceCompetenciesSubLevelItem: ContextlessPolicyResolution;
};

export type CompetenciesEntitiesJobCatalogTreeSuggestionStatusEnum =
  | 'completed'
  | 'failed'
  | 'processing';

/** Factorial competencies */
export type CompetenciesFactorialCompetency = {
  __typename?: 'CompetenciesFactorialCompetency';
  description?: Maybe<Scalars['String']>;
  importance: Scalars['Int'];
  name: Scalars['String'];
  uuid: Scalars['String'];
};

/** The connection type for CompetenciesFactorialCompetency. */
export type CompetenciesFactorialCompetencyConnection = {
  __typename?: 'CompetenciesFactorialCompetencyConnection';
  /** A list of edges. */
  edges: Array<CompetenciesFactorialCompetencyEdge>;
  /** A list of nodes. */
  nodes: Array<CompetenciesFactorialCompetency>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CompetenciesFactorialCompetencyEdge = {
  __typename?: 'CompetenciesFactorialCompetencyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CompetenciesFactorialCompetency;
};

/** Competencies job catalog node suggestions */
export type CompetenciesJobCatalogNodeSuggestion = {
  __typename?: 'CompetenciesJobCatalogNodeSuggestion';
  description?: Maybe<Scalars['String']>;
  importance: Scalars['Int'];
  name: Scalars['String'];
  uuid: Scalars['String'];
};

/** The connection type for CompetenciesJobCatalogNodeSuggestion. */
export type CompetenciesJobCatalogNodeSuggestionConnection = {
  __typename?: 'CompetenciesJobCatalogNodeSuggestionConnection';
  /** A list of edges. */
  edges: Array<CompetenciesJobCatalogNodeSuggestionEdge>;
  /** A list of nodes. */
  nodes: Array<CompetenciesJobCatalogNodeSuggestion>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CompetenciesJobCatalogNodeSuggestionEdge = {
  __typename?: 'CompetenciesJobCatalogNodeSuggestionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CompetenciesJobCatalogNodeSuggestion;
};

/** Competencies job catalog tree suggestions */
export type CompetenciesJobCatalogTreeSuggestion = {
  __typename?: 'CompetenciesJobCatalogTreeSuggestion';
  id: Scalars['Int'];
  status: CompetenciesEntitiesJobCatalogTreeSuggestionStatusEnum;
};

/** The connection type for CompetenciesJobCatalogTreeSuggestion. */
export type CompetenciesJobCatalogTreeSuggestionConnection = {
  __typename?: 'CompetenciesJobCatalogTreeSuggestionConnection';
  /** A list of edges. */
  edges: Array<CompetenciesJobCatalogTreeSuggestionEdge>;
  /** A list of nodes. */
  nodes: Array<CompetenciesJobCatalogTreeSuggestion>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CompetenciesJobCatalogTreeSuggestionEdge = {
  __typename?: 'CompetenciesJobCatalogTreeSuggestionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CompetenciesJobCatalogTreeSuggestion;
};

/** Manage Categories in Complaints */
export type ComplaintsCategory = {
  __typename?: 'ComplaintsCategory';
  company: ApiCoreCompany;
  /**
   * ID of the company
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  companyId: Scalars['Int'];
  /** Whether the category is enabled */
  enabled: Scalars['Boolean'];
  error?: Maybe<Scalars['Boolean']>;
  /** Unique identifier of the category */
  id: Scalars['Int'];
  /** Name of the category */
  name: Scalars['String'];
};

/** The connection type for ComplaintsCategory. */
export type ComplaintsCategoryConnection = {
  __typename?: 'ComplaintsCategoryConnection';
  /** A list of edges. */
  edges: Array<ComplaintsCategoryEdge>;
  /** A list of nodes. */
  nodes: Array<ComplaintsCategory>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ComplaintsCategoryEdge = {
  __typename?: 'ComplaintsCategoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ComplaintsCategory;
};

/** Manages the complaints */
export type ComplaintsComplaint = {
  __typename?: 'ComplaintsComplaint';
  /** The date and time by which the complaint should be acknowledged (7 days from creation) */
  acknowledgeDueAt: Scalars['ISO8601DateTime'];
  /** The date and time the complaint was acknowledged */
  acknowledgedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The date and time the complaint was archived */
  archivedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Whether the complaint is blocked (completed, discarded, or archived) */
  blocked: Scalars['Boolean'];
  category?: Maybe<ComplaintsCategory>;
  /**
   * The ID of the category this complaint belongs to
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  categoryId?: Maybe<Scalars['Int']>;
  company?: Maybe<ApiCoreCompany>;
  /** The email of the complainer */
  complainerEmail?: Maybe<Scalars['String']>;
  /** The name of the complainer */
  complainerName?: Maybe<Scalars['String']>;
  /** The relationship of the complainer */
  complainerRelationship?: Maybe<Scalars['String']>;
  /** The date and time the complaint was completed */
  completedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The date and time the complaint was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** The date and time the complaint was soft deleted */
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The description/content of the complaint */
  description: Scalars['String'];
  /** The date and time the complaint was discarded */
  discardedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The date and time by which the complaint should be resolved (3 months from creation) */
  dueAt: Scalars['ISO8601DateTime'];
  /** The ID of the complaint */
  id: Scalars['Int'];
  /** Unique identifier for the complaint */
  identifier: Scalars['String'];
  /** The timestamp of the last update to the complaint or its messages */
  lastUpdate: Scalars['String'];
  messages: Array<ComplaintsMessage>;
  messagesConnection: ComplaintsMessageConnection;
  notes: Array<ComplaintsNote>;
  notesConnection: ComplaintsNoteConnection;
  /** The date and time when the complaint was read */
  readAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Current status of the complaint (created, acknowledged, completed, discarded, archived) */
  status: Scalars['String'];
  /** The date and time the complaint was updated */
  updatedAt: Scalars['ISO8601DateTime'];
};


/** Manages the complaints */
export type ComplaintsComplaintCategoryArgs = {
  onlyEnabled?: Scalars['Boolean'];
};


/** Manages the complaints */
export type ComplaintsComplaintMessagesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Manages the complaints */
export type ComplaintsComplaintMessagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Manages the complaints */
export type ComplaintsComplaintNotesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for ComplaintsComplaint. */
export type ComplaintsComplaintConnection = {
  __typename?: 'ComplaintsComplaintConnection';
  /** A list of edges. */
  edges: Array<ComplaintsComplaintEdge>;
  /** A list of nodes. */
  nodes: Array<ComplaintsComplaint>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ComplaintsComplaintEdge = {
  __typename?: 'ComplaintsComplaintEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ComplaintsComplaint;
};

/** the filter for the complaints resource */
export type ComplaintsComplaintFilter = {
  categoryId?: InputMaybe<IntegerFilter>;
  complainerName?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  identifier?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<ComplaintsComplaintFilterConditions>>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ComplaintsComplaintFilterConditions = {
  categoryId?: InputMaybe<IntegerFilter>;
  complainerName?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  identifier?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ComplaintsContextlessPolicies = {
  __typename?: 'ComplaintsContextlessPolicies';
  hasComplaints: ContextlessPolicyResolution;
  manageComplaints: ContextlessPolicyResolution;
  sidebarSeeComplaintsTopLevelItem: ContextlessPolicyResolution;
  use: ContextlessPolicyResolution;
};

/** Manages the messages for a complaint */
export type ComplaintsMessage = {
  __typename?: 'ComplaintsMessage';
  access?: Maybe<ApiCoreAccess>;
  /**
   * The ID of the access that created the message
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  accessId?: Maybe<Scalars['Int']>;
  company: ApiCoreCompany;
  complaint: ComplaintsComplaint;
  complaintIds: Array<Scalars['Int']>;
  /**
   * The ID of the complaint that the message belongs to
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  complaintsComplaintsId: Scalars['Int'];
  /** The IDs of complaints that have this message */
  complaintsComplaintsIds: Array<Scalars['Int']>;
  /** The date and time the message was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** The ID of the message */
  id: Scalars['Int'];
  /** Whether this is a company message (internal) or from complainer */
  isCompanyMessage: Scalars['Boolean'];
  messageFiles: Array<ComplaintsMessageFile>;
  messagefilesConnection: ComplaintsMessageFileConnection;
  /** The text content of the message */
  text: Scalars['String'];
  /** The date and time the message was updated */
  updatedAt: Scalars['ISO8601DateTime'];
};


/** Manages the messages for a complaint */
export type ComplaintsMessageAccessArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** Manages the messages for a complaint */
export type ComplaintsMessageComplaintArgs = {
  id?: InputMaybe<Scalars['Int']>;
  identifier?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  showDeleted?: InputMaybe<Scalars['Boolean']>;
  statuses?: InputMaybe<Array<ComplaintsStatusEnum>>;
};


/** Manages the messages for a complaint */
export type ComplaintsMessageMessageFilesArgs = {
  complaintIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Manages the messages for a complaint */
export type ComplaintsMessageMessagefilesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  complaintIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for ComplaintsMessage. */
export type ComplaintsMessageConnection = {
  __typename?: 'ComplaintsMessageConnection';
  /** A list of edges. */
  edges: Array<ComplaintsMessageEdge>;
  /** A list of nodes. */
  nodes: Array<ComplaintsMessage>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ComplaintsMessageEdge = {
  __typename?: 'ComplaintsMessageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ComplaintsMessage;
};

/** Manages the files attached to complaint messages */
export type ComplaintsMessageFile = {
  __typename?: 'ComplaintsMessageFile';
  company: ApiCoreCompany;
  /** The MIME type of the file */
  contentType: Scalars['String'];
  /** The date and time the file was uploaded */
  createdAt: Scalars['String'];
  /** The original filename of the uploaded file */
  filename: Scalars['String'];
  /** The ID of the message file */
  id: Scalars['Int'];
  message: ComplaintsMessage;
  /**
   * The ID of the message this file belongs to
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  messageId: Scalars['Int'];
  /** The IDs of messages that have this file */
  messageIds: Array<Scalars['Int']>;
  /** The path to the stored file */
  path: Scalars['String'];
  /** The date and time the file was last updated */
  updatedAt: Scalars['String'];
};


/** Manages the files attached to complaint messages */
export type ComplaintsMessageFileMessageArgs = {
  complaintsComplaintsIds?: InputMaybe<Array<Scalars['Int']>>;
};

/** The connection type for ComplaintsMessageFile. */
export type ComplaintsMessageFileConnection = {
  __typename?: 'ComplaintsMessageFileConnection';
  /** A list of edges. */
  edges: Array<ComplaintsMessageFileEdge>;
  /** A list of nodes. */
  nodes: Array<ComplaintsMessageFile>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ComplaintsMessageFileEdge = {
  __typename?: 'ComplaintsMessageFileEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ComplaintsMessageFile;
};

/** the filter for the message_files resource */
export type ComplaintsMessageFileFilter = {
  contentType?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<StringFilter>;
  filename?: InputMaybe<StringFilter>;
  messageIds?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<ComplaintsMessageFileFilterConditions>>;
  path?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<StringFilter>;
};

export type ComplaintsMessageFileFilterConditions = {
  contentType?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<StringFilter>;
  filename?: InputMaybe<StringFilter>;
  messageIds?: InputMaybe<StringFilter>;
  path?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<StringFilter>;
};

/** the filter for the messages resource */
export type ComplaintsMessageFilter = {
  complaintsComplaintsIds?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  isCompanyMessage?: InputMaybe<BooleanFilter>;
  or?: InputMaybe<Array<ComplaintsMessageFilterConditions>>;
  text?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ComplaintsMessageFilterConditions = {
  complaintsComplaintsIds?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  isCompanyMessage?: InputMaybe<BooleanFilter>;
  text?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

/** Manages the notes for a complaint */
export type ComplaintsNote = {
  __typename?: 'ComplaintsNote';
  company: ApiCoreCompany;
  /**
   * The ID of the company that the note belongs to
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  companyId: Scalars['Int'];
  complaint: ComplaintsComplaint;
  /**
   * The ID of the complaint that the note belongs to
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  complaintId: Scalars['Int'];
  /** The date and time the note was created */
  createdAt: Scalars['ISO8601DateTime'];
  employee: EmployeesEmployee;
  /**
   * The ID of the employee that created the note
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  employeeId: Scalars['Int'];
  /** The ID of the note */
  id: Scalars['Int'];
  /** The text of the note */
  text: Scalars['String'];
  /** The date and time the note was updated */
  updatedAt: Scalars['ISO8601DateTime'];
};


/** Manages the notes for a complaint */
export type ComplaintsNoteComplaintArgs = {
  id?: InputMaybe<Scalars['Int']>;
  identifier?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  showDeleted?: InputMaybe<Scalars['Boolean']>;
  statuses?: InputMaybe<Array<ComplaintsStatusEnum>>;
};


/** Manages the notes for a complaint */
export type ComplaintsNoteEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for ComplaintsNote. */
export type ComplaintsNoteConnection = {
  __typename?: 'ComplaintsNoteConnection';
  /** A list of edges. */
  edges: Array<ComplaintsNoteEdge>;
  /** A list of nodes. */
  nodes: Array<ComplaintsNote>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ComplaintsNoteEdge = {
  __typename?: 'ComplaintsNoteEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ComplaintsNote;
};

/** the filter for the notes resource */
export type ComplaintsNoteFilter = {
  createdAt?: InputMaybe<DateTimeFilter>;
  or?: InputMaybe<Array<ComplaintsNoteFilterConditions>>;
};

export type ComplaintsNoteFilterConditions = {
  createdAt?: InputMaybe<DateTimeFilter>;
};

export type ComplaintsStatusEnum =
  | 'acknowledged'
  | 'archived'
  | 'completed'
  | 'created'
  | 'discarded';

/** Autogenerated return type of Complaints_category_update_subscription. */
export type Complaints_Category_Update_SubscriptionPayload = {
  __typename?: 'Complaints_category_update_subscriptionPayload';
  category?: Maybe<ComplaintsCategory>;
};

/** Autogenerated return type of CompleteCompensationsPayrollRun. */
export type CompleteCompensationsPayrollRunPayload = {
  __typename?: 'CompleteCompensationsPayrollRunPayload';
  errors: Array<MutationError>;
  payrollRun?: Maybe<CompensationsPayrollRun>;
};

/** Autogenerated return type of ConfirmBankingReconciliationSuggestion. */
export type ConfirmBankingReconciliationSuggestionPayload = {
  __typename?: 'ConfirmBankingReconciliationSuggestionPayload';
  errors: Array<MutationError>;
  reconciliationSuggestion?: Maybe<BankingReconciliationSuggestion>;
};

/** Autogenerated return type of ConfirmFinanceReconciliationSuggestion. */
export type ConfirmFinanceReconciliationSuggestionPayload = {
  __typename?: 'ConfirmFinanceReconciliationSuggestionPayload';
  errors: Array<MutationError>;
  reconciliationSuggestion?: Maybe<FinanceReconciliationSuggestion>;
};

/** Autogenerated return type of ConfirmProjectmanagementimporterProjectsImport. */
export type ConfirmProjectmanagementimporterProjectsImportPayload = {
  __typename?: 'ConfirmProjectmanagementimporterProjectsImportPayload';
  errors: Array<MutationError>;
  projectsImport?: Maybe<ProjectManagementImporterProjectsImport>;
};

export type Contentable = TrainingsContentBlockPage | TrainingsContentBlockQuiz | TrainingsContentBlockVideo;

/** All the contextless policies names */
export type ContextlessPoliciesEnum =
  | 'Analytics_sidebarSeeAnalyticsInsightsSubLevelItem'
  | 'Analytics_sidebarSeeAnalyticsReportsSubLevelItem'
  | 'Analytics_sidebarSeeAnalyticsTopLevelItem'
  | 'ApiCore_accessCreateExternal'
  | 'ApiCore_accessDownloadLeaves'
  | 'ApiCore_accessEnpsCreateForms'
  | 'ApiCore_accessEnpsSeeForms'
  | 'ApiCore_accessReadOrgChart'
  | 'ApiCore_accessReadPeopleChart'
  | 'ApiCore_accessSurveysSeeForms'
  | 'ApiCore_companyCreateLegalEntities'
  | 'ApiCore_companyManageAdmins'
  | 'ApiCore_companyManageCustomNotifications'
  | 'ApiCore_companyManageCustomization'
  | 'ApiCore_companyManagePermissions'
  | 'ApiCore_companySeeEmployeeProfile'
  | 'ApiCore_companySeeLegalEntityEmployees'
  | 'ApiCore_customTablesBulkImport'
  | 'ApiCore_employeeCreate'
  | 'ApiCore_manageDiscoverabilityWidget'
  | 'ApiCore_seeAllSettingsPages'
  | 'ApiCore_seeReferralProgramPage'
  | 'ApiCore_sidebarSeeSettingsTopLevelItem'
  | 'ApiPublic_coreApiKeyManage'
  | 'Approvals_approvalFlowsView'
  | 'Approvals_approvalGroupMembershipsAssign'
  | 'Approvals_approvalGroupMembershipsView'
  | 'Approvals_approvalGroupsCreate'
  | 'Approvals_approvalGroupsDelete'
  | 'Approvals_approvalGroupsEdit'
  | 'Approvals_approvalStepApproversEdit'
  | 'Approvals_approvalStepApproversView'
  | 'Approvals_globalApproverUse'
  | 'Ats_callCandidate'
  | 'Ats_createJobPostings'
  | 'Ats_dashboardWidgetOpenPositionsVisible'
  | 'Ats_manageAtsSettings'
  | 'Ats_manageJobPostings'
  | 'Ats_managementEnabled'
  | 'Ats_messageTemplatesManageCompanyMessageTemplates'
  | 'Ats_requisitionsManage'
  | 'Ats_requisitionsUse'
  | 'Ats_salaryManage'
  | 'Ats_seeActiveJobsLimit'
  | 'Ats_sidebarSeeRecruitmentCandidatesSubLevelItem'
  | 'Ats_sidebarSeeRecruitmentInboxSubLevelItem'
  | 'Ats_sidebarSeeRecruitmentInsightsSubLevelItem'
  | 'Ats_sidebarSeeRecruitmentJobsSubLevelItem'
  | 'Ats_sidebarSeeRecruitmentOpenPositionsSubLevelItem'
  | 'Ats_sidebarSeeRecruitmentPurchaseRequestsSubLevelItem'
  | 'Ats_sidebarSeeRecruitmentTopLevelItem'
  | 'Ats_useAts'
  | 'Attendance_accessEditSettings'
  | 'Attendance_brazilianExportAccess'
  | 'Attendance_companyApproveAttendance'
  | 'Attendance_companyCalendarAccess'
  | 'Attendance_companyReadAttendance'
  | 'Attendance_companySeeClockedIn'
  | 'Attendance_companySeeOthers'
  | 'Attendance_companySeeOwned'
  | 'Attendance_dashboardWidgetSeeAttendanceWidget'
  | 'Attendance_dashboardWidgetTimeTrackingVisible'
  | 'Attendance_dashboardWidgetWhoIsInVisible'
  | 'Attendance_shiftAutofill'
  | 'Attendance_sidebarSeeAttendanceCompanyTopLevelItem'
  | 'Attendance_sidebarSeeAttendanceEmployeeTopLevelItem'
  | 'Attendance_sidebarSeeAttendanceTimeTrackingAdminSubLevelItem'
  | 'Attendance_sidebarSeeAttendanceTopLevelItem'
  | 'AuditLog_seeAuditLog'
  | 'Authentication_accessCreateExternal'
  | 'Authentication_accessEditExternal'
  | 'Automations_manageCustomNotifications'
  | 'Banking_bankAccountRead'
  | 'Banking_bankAccountsManage'
  | 'Banking_bankAccountsSeeDetailPage'
  | 'Banking_cardPaymentRead'
  | 'Banking_consentChangeStatus'
  | 'Banking_consentRead'
  | 'Banking_paymentManage'
  | 'Banking_payoutBankAccountRead'
  | 'Banking_reconciliationBulkManage'
  | 'Banking_reconciliationRead'
  | 'Banking_reconciliationSuggestionConfirmOrReject'
  | 'Banking_reconciliationsSeeFinancialDocumentsPage'
  | 'Banking_reconciliationsSeeJournalEntriesPage'
  | 'Banking_transactionCategorize'
  | 'Banking_transactionRead'
  | 'Benefits_benefitsActive'
  | 'Benefits_canChangeCycleDay'
  | 'Benefits_sidebarSeeBenefitsTopLevelItem'
  | 'Benefits_sidebarSeeMyBenefitsTopLevelItem'
  | 'Billing_subscriptionManageSubscription'
  | 'Billing_subscriptionPurchaseSubscription'
  | 'Billing_subscriptionUpgradeSubscription'
  | 'BookkeepersManagement_seePayrollIncidencesSettings'
  | 'Calendar_sidebarSeeCalendarCalendarSubLevelItem'
  | 'CompanyPage_manageCompanyPage'
  | 'Compensations_compensationActivityManage'
  | 'Compensations_employeeCompensationBulkImport'
  | 'Compensations_employeeCompensationExport'
  | 'Compensations_payrollConceptsEdit'
  | 'Compensations_payrollResultImport'
  | 'Compensations_payrollRunToggleLockStatus'
  | 'Compensations_settingsSeeCompensationsSettings'
  | 'Compensations_sidebarSeeCompensationsInHouseActivationSubLevelItem'
  | 'Compensations_sidebarSeeCompensationsIncidencesSubLevelItem'
  | 'Compensations_sidebarSeeCompensationsTopLevelItem'
  | 'Competencies_competenciesManage'
  | 'Competencies_competencyGroupsManage'
  | 'Competencies_sidebarSeePerformanceCompetenciesSubLevelItem'
  | 'Complaints_hasComplaints'
  | 'Complaints_manageComplaints'
  | 'Complaints_sidebarSeeComplaintsTopLevelItem'
  | 'Complaints_use'
  | 'ContractsImporter_contractsImporterImportContracts'
  | 'Contracts_contractBulkCreateAdditionalCompensationType'
  | 'Contracts_contractEditContractVersion'
  | 'Contracts_contractEditContractsSettings'
  | 'Contracts_contractPromote'
  | 'Contracts_contractSeeAdditionalCompensation'
  | 'Contracts_contractSeeContractType'
  | 'Contracts_contractSeeEndDate'
  | 'Contracts_contractSeeGrossSalary'
  | 'Contracts_contractSeeJobTitle'
  | 'Contracts_contractSeePayroll'
  | 'Contracts_contractSeePendingPromotions'
  | 'Contracts_contractSeeStartDate'
  | 'Contracts_contractSeeTrialPeriod'
  | 'Contracts_contractSeeTrialPeriodEndDate'
  | 'Contracts_contractSeeWorkingDayType'
  | 'Contracts_contractSeeWorkingHours'
  | 'Contracts_sidebarSeeProfileContractsSubLevelItem'
  | 'Contracts_weeksPerMonthConfigurationCreate'
  | 'Contracts_weeksPerMonthConfigurationRead'
  | 'Contracts_weeksPerMonthConfigurationUpdate'
  | 'Contracts_weeksPerMonthConfigurationUpsert'
  | 'CostCenters_costCentersManageCostCenters'
  | 'CostCenters_costCentersSeeCostCenters'
  | 'CostCenters_featuresCostCenterManagement'
  | 'CustomFields_companyCreateCustomFields'
  | 'CustomFields_fieldCreate'
  | 'CustomFields_fieldDocumentsCreate'
  | 'CustomerPortal_subscriptionManageSubscription'
  | 'Dashboard_dashboardWidgetCompanyLinksVisible'
  | 'Dashboard_sidebarSeeDashboardTopLevelItem'
  | 'Documents_companyEditInternalDocuments'
  | 'Documents_companyEditPublicDocuments'
  | 'Documents_companyManageEmployeesFolders'
  | 'Documents_companyManageFolders'
  | 'Documents_companyManagePublicCompanyFolders'
  | 'Documents_companySeeInternalDocuments'
  | 'Documents_companySeePublicDocuments'
  | 'Documents_companyUseCompanyDocuments'
  | 'Documents_employeeEditAnyEmployeeFolder'
  | 'Documents_employeeEditDocuments'
  | 'Documents_employeeEditDocumentsTrashBin'
  | 'Documents_employeeManageAnyEmployeeFolder'
  | 'Documents_employeeManageDefaultEmployeeFolder'
  | 'Documents_employeeSeeEmployeeFiles'
  | 'Documents_sidebarSeeDocumentsDocumentsSubLevelItem'
  | 'Documents_sidebarSeeDocumentsTopLevelItem'
  | 'Documents_sidebarSeeFilesBulkFilesSubLevelItem'
  | 'Documents_sidebarSeeFilesDocumentTemplatesSubLevelItem'
  | 'Documents_sidebarSeeFilesEmployeeFilesSubLevelItem'
  | 'Documents_sidebarSeeFilesManagementDocumentsSubLevelItem'
  | 'Documents_sidebarSeeFilesPublicDocumentsSubLevelItem'
  | 'Documents_sidebarSeeFilesTopLevelItem'
  | 'Documents_sidebarSeeTrash'
  | 'Documents_templateManageDocumentTemplates'
  | 'Documents_withoutFolderEverybodyEditEmployeeDocumentsWithoutFolder'
  | 'EmployeeOnboarding_sidebarSeeEmployeeOnboardingTopLevelItem'
  | 'Employees_addCustomTableRecords'
  | 'Employees_assignEmployeeManager'
  | 'Employees_assignEmployeePermissionGroup'
  | 'Employees_assignEmployeeToWorkflow'
  | 'Employees_editEmployeesInBulkButton'
  | 'Employees_employeeSeeAggregatedPersonalInfo'
  | 'Employees_exportEmployees'
  | 'Employees_exportOrgChart'
  | 'Employees_inviteEmployee'
  | 'Employees_manageCustomTableSettings'
  | 'Employees_removeCustomTableRecords'
  | 'Employees_seeAdminWelcomeSpace'
  | 'Employees_seeEmployeeLegalGender'
  | 'Employees_seeFormerEmployees'
  | 'Employees_seeFutureEmployees'
  | 'Employees_sidebarSeeEmployeesOrgChartSubLevelItem'
  | 'Employees_sidebarSeeEmployeesTopLevelItem'
  | 'Employees_sidebarSeeProfileContractVersionsSubLevelItem'
  | 'Employees_sidebarSeeProfileCustomTablesSubLevelItem'
  | 'Employees_sidebarSeeProfilePersonalSubLevelItem'
  | 'Employees_sidebarSeeProfilePlanningVersionsSubLevelItem'
  | 'Employees_sidebarSeeProfileTopLevelItem'
  | 'EngagementInsights_sidebarSeeEngagementInsightsSubLevelItem'
  | 'EngagementInsights_sidebarSeeEngagementTopLevelItem'
  | 'Engagement_seePulseDashboard'
  | 'Engagement_settingsManage'
  | 'Enps_createForms'
  | 'Enps_manageEnps'
  | 'Enps_sidebarSeeEngagementEnpsSubLevelItem'
  | 'Expenses_cardManageCards'
  | 'Expenses_cardRequestSingleUseCards'
  | 'Expenses_expenseCreateExpenses'
  | 'Expenses_expenseCreateExpensesForOthers'
  | 'Expenses_expenseCustomizeSettings'
  | 'Expenses_expenseManageExpensables'
  | 'Expenses_expenseManageExpenses'
  | 'Expenses_expenseOverrideApprovalFlow'
  | 'Expenses_expenseRestartApprovalFlow'
  | 'Expenses_expenseSeeEmployeeLegalEntity'
  | 'Expenses_expenseSendToReimburseThroughPayments'
  | 'Expenses_expenseSendToReimburseThroughPayroll'
  | 'Expenses_expenseSetToPaid'
  | 'Expenses_internalExpenseViewerEnabledContextless'
  | 'Expenses_recommendationsEnabledContextless'
  | 'Expenses_settingsSeeExpensesSettings'
  | 'Expenses_sidebarSeeExpensesBudgetsSubLevelItem'
  | 'Expenses_sidebarSeeExpensesExpensesSubLevelItem'
  | 'Expenses_sidebarSeeExpensesProcurementPurchaseOrderSubLevelItem'
  | 'Expenses_sidebarSeeExpensesProcurementPurchaseRequestSubLevelItem'
  | 'Expenses_sidebarSeeExpensesReportsSubLevelItem'
  | 'Expenses_sidebarSeeExpensesSpendingPoliciesSubLevelItem'
  | 'Expenses_sidebarSeeExpensesSubModule'
  | 'Expenses_sidebarSeeExpensesTopLevelItem'
  | 'Expenses_sidebarSeeMyExpensesMyCardsSubLevelItem'
  | 'Expenses_sidebarSeeMyExpensesMyExpensesSubLevelItem'
  | 'Expenses_sidebarSeeMyExpensesTopLevelItem'
  | 'Features_featureRead'
  | 'Features_featureReset'
  | 'Features_featureToggle'
  | 'Feedbacks_sidebarSeePerformanceFeedbacksSubLevelItem'
  | 'Finance_accountingManageAccountResources'
  | 'Finance_accountingManageAccounts'
  | 'Finance_accountingManageCustomCategoriesAccounts'
  | 'Finance_accountingSeeAccounts'
  | 'Finance_accountingSeePurchaseAccounts'
  | 'Finance_accountingSeeSalesAccounts'
  | 'Finance_budgetsCreateBudgets'
  | 'Finance_budgetsManageBudgets'
  | 'Finance_budgetsSeeBudgets'
  | 'Finance_complianceExtraFieldDefaultSettingsManage'
  | 'Finance_complianceSnapshotsSeeComplianceSnapshot'
  | 'Finance_contactsCreateOrUpdate'
  | 'Finance_contactsDelete'
  | 'Finance_contactsManageBasicData'
  | 'Finance_contactsManagePaymentData'
  | 'Finance_contactsSee'
  | 'Finance_contactsSeeTaxIdType'
  | 'Finance_costCenterMembershipsBulkImportCostCenterMemberships'
  | 'Finance_costCenterMembershipsEmployeeSeeCostCenterMemberships'
  | 'Finance_costCentersManageCostCenters'
  | 'Finance_costCentersSeeCostCenters'
  | 'Finance_customDimensionsManage'
  | 'Finance_customDimensionsSee'
  | 'Finance_financialDocumentsCreatePurchase'
  | 'Finance_financialDocumentsCreateSale'
  | 'Finance_financialDocumentsManagePurchase'
  | 'Finance_financialDocumentsManageSales'
  | 'Finance_financialDocumentsSeeComplianceExtraFieldConfigs'
  | 'Finance_financialSequencesManage'
  | 'Finance_journalEntriesManage'
  | 'Finance_journalEntriesManagePurchase'
  | 'Finance_journalEntriesManagePurchaseInAccountsPayable'
  | 'Finance_quotesCreate'
  | 'Finance_salesDocumentTemplatesManage'
  | 'Finance_settingsSeeAccountingSettings'
  | 'Finance_settingsSeeAccountingSettingsCustomCategories'
  | 'Finance_settingsSeeAccountingSettingsLedgerAccounts'
  | 'Finance_settingsSeeAccountingSettingsTaxTypes'
  | 'Finance_settingsSeeAnalyticalDimensionsSettings'
  | 'Finance_settingsSeeCostCentersSettings'
  | 'Finance_settingsSeeFinanceCategory'
  | 'Finance_settingsSeeSalesSettings'
  | 'Finance_sidebarSeeFinanceAccountingSubLevelItem'
  | 'Finance_sidebarSeeFinanceAccountsSubLevelItem'
  | 'Finance_sidebarSeeFinanceCardsSubLevelItem'
  | 'Finance_sidebarSeeFinanceClientsSubLevelItem'
  | 'Finance_sidebarSeeFinanceDealsSubLevelItem'
  | 'Finance_sidebarSeeFinanceFinancialWorkspaceSubLevelItem'
  | 'Finance_sidebarSeeFinanceInvoicesSubLevelItem'
  | 'Finance_sidebarSeeFinanceOverviewSubLevelItem'
  | 'Finance_sidebarSeeFinancePaymentsSubLevelItem'
  | 'Finance_sidebarSeeFinanceQuotesSubLevelItem'
  | 'Finance_sidebarSeeFinanceTopLevelItem'
  | 'Finance_sidebarSeeFinanceVendorsSubLevelItem'
  | 'Finance_spendingPoliciesSee'
  | 'Finance_spendingPolicyCreate'
  | 'Finance_spendingPolicyDelete'
  | 'Finance_spendingPolicyUpdate'
  | 'Finance_taxTypeCreate'
  | 'Finance_taxTypeUpdate'
  | 'FinancialWorkspace_compensationsSee'
  | 'FinancialWorkspace_expensesSee'
  | 'FinancialWorkspace_payrollSee'
  | 'FinancialWorkspace_seeAllCompanyData'
  | 'FinancialWorkspace_seeFinancialWorkspace'
  | 'Goals_createMetricGroup'
  | 'Goals_sidebarSeePerformanceGoalsV2SubLevelItem'
  | 'HandbookPages_editHandbookPages'
  | 'HandbookPages_seeHandbookPages'
  | 'InAppComms_canSeeInAppComms'
  | 'IntegrationsBase_seeAppStore'
  | 'IntegrationsJoin_ordersManageRequests'
  | 'IntegrationsJoin_useJoinIntegration'
  | 'Intercom_allowIntercom'
  | 'Iris_aiAnalyticsAiAnalyticsEnabled'
  | 'Iris_aiAnalyticsSeeAiAnalytics'
  | 'Iris_aiAnalyticsSidebarSeeAiReportsSubLevelItem'
  | 'ItManagement_manageIt'
  | 'ItManagement_settingsSeeItManagementSettings'
  | 'ItManagement_sidebarSeeDeviceCatalogItem'
  | 'ItManagement_sidebarSeeFactorialItItem'
  | 'ItManagement_sidebarSeeItManagementItem'
  | 'JobCatalog_createJob'
  | 'JobCatalog_editJob'
  | 'JobCatalog_jobCatalogTreeManage'
  | 'JobCatalog_jobCatalogTreeReimport'
  | 'JobCatalog_jobCatalogTreeSee'
  | 'JobCatalog_seeJobCatalog'
  | 'JobCatalog_sidebarSeeEmployeesJobCatalogSubLevelItem'
  | 'Kudos_sidebarSeeKudosTopLevelItem'
  | 'Locations_locationManage'
  | 'Locations_workAreaManage'
  | 'Marketplace_installationInstallCompanyWideIntegration'
  | 'Marketplace_marketplaceSeeMarketplace'
  | 'Marketplace_sidebarSeeMarketplaceAppStoreSubLevelItem'
  | 'Marketplace_sidebarSeeMarketplaceSubLevelItem'
  | 'Meetings_seeAdvancedMeetings'
  | 'Meetings_seeMeetings'
  | 'Modules_marketplaceRevampSeeMarketplaceRevamp'
  | 'Modules_moduleManageModule'
  | 'Modules_sidebarSeeModulesSubLevelItem'
  | 'Notifications_dashboardWidgetPendingNotificationsVisible'
  | 'Notifications_sidebarSeeNotificationsTopLevelItem'
  | 'Nps_showNpsWidget'
  | 'OauthApplicationPolicy_manageOauthApplication'
  | 'OnboardingImporter_importCustomTables'
  | 'OnboardingImporter_importEmployees'
  | 'Onboarding_sidebarSeeOnboardingTopLevelItem'
  | 'OneOnOnes_commandBarCreateOneOnOne'
  | 'OneOnOnes_fullVisibility'
  | 'OneOnOnes_sidebarSeePerformanceOneOnOnesSubLevelItem'
  | 'OpenAi_useOne'
  | 'Pages_seeCompanyPages'
  | 'PayrollIntegrations_managePayrollIntegrationCodes'
  | 'Payroll_companyManagePayroll'
  | 'Payroll_conceptsManageLaborCost'
  | 'Payroll_createSupplementsFromExpenses'
  | 'Payroll_downloadPayrollData'
  | 'Payroll_editSupplements'
  | 'Payroll_managePayrollIncidences'
  | 'Payroll_managePayrollPolicies'
  | 'Payroll_periodChangePayrollPeriodStatus'
  | 'Payroll_resultsSeeCompanyPayrollResults'
  | 'Payroll_resultsSeeOwnPayrollResults'
  | 'Payroll_seeCompanySepaGenerator'
  | 'Payroll_seePayrollIssues'
  | 'Payroll_seeSupplements'
  | 'Payroll_settingsSeePayrollSettings'
  | 'Payroll_sidebarSeeMyPayrollTopLevelItem'
  | 'Payroll_sidebarSeePayrollBundleCycleSubLevelItem'
  | 'Payroll_sidebarSeePayrollBundleInHouseActivationSubLevelItem'
  | 'Payroll_sidebarSeePayrollBundleIncidencesSubLevelItem'
  | 'Payroll_sidebarSeePayrollBundleSalaryCardSubLevelItem'
  | 'Payroll_sidebarSeePayrollBundleTopLevelItem'
  | 'Payroll_supplementsImportSupplements'
  | 'Payroll_supplementsSeeEverybody'
  | 'Payroll_supplementsSeeOwned'
  | 'Payroll_supplementsSeeReportees'
  | 'Payroll_supplementsSeeTeam'
  | 'Payroll_upsellSeeActivationPromo'
  | 'Payroll_usePayroll'
  | 'PeopleChart_sidebarSeeEmployeesPeopleChartSubLevelItem'
  | 'PerformanceCycles_cycleManage'
  | 'PerformanceCycles_cycleRead'
  | 'PerformanceCycles_sidebarSeePerformanceCyclesSubLevelItem'
  | 'Performance_createCustomTemplate'
  | 'Performance_createReviewProcessContextless'
  | 'Performance_manageProcessTemplates'
  | 'Performance_reviewProcessFullVisibilityContextless'
  | 'Performance_seePerformanceAnalytics'
  | 'Performance_seePerformanceAnalyticsPage'
  | 'Performance_seeProcessTemplates'
  | 'Performance_settingsSeePerformanceReviewProcessSettings'
  | 'Performance_sidebarSeeAnalyticsSubLevelItem'
  | 'Performance_sidebarSeePerformanceReviewProcessSubLevelItem'
  | 'Performance_sidebarSeePerformanceTopLevelItem'
  | 'Permissions_commandBarSeeInsights'
  | 'Permissions_editExternalUsers'
  | 'Permissions_groupAssignEmployees'
  | 'Permissions_groupCreate'
  | 'Permissions_groupCreateExternalUsers'
  | 'Permissions_groupDuplicate'
  | 'Permissions_groupEdit'
  | 'Permissions_insightsSeeInsights'
  | 'Permissions_permissionsRead'
  | 'Permissions_roleTemplateApply'
  | 'Positions_managePosition'
  | 'Posts_dashboardWidgetNextEventsVisible'
  | 'Posts_groupCanPostSomewhere'
  | 'Posts_groupCreate'
  | 'Posts_postsManage'
  | 'Processes_processEditProcesses'
  | 'Processes_sidebarSeeProcessesCustomSubLevelItem'
  | 'Processes_sidebarSeeProcessesOffboardingSubLevelItem'
  | 'Processes_sidebarSeeProcessesOnboardingSubLevelItem'
  | 'Processes_sidebarSeeProcessesTopLevelItem'
  | 'Procurement_featuresPurchaseOrders'
  | 'Procurement_featuresPurchaseRequests'
  | 'Procurement_purchaseOrderManage'
  | 'Procurement_purchaseOrderRead'
  | 'Procurement_purchaseRequestCreate'
  | 'Procurement_purchaseRequestManage'
  | 'Procurement_purchaseRequestManageSettings'
  | 'Procurement_purchaseRequestRead'
  | 'Procurement_settingsManage'
  | 'Procurement_settingsSeeProcurementSettings'
  | 'Procurement_sidebarSeeMyExpensesPurchaseRequestSubLevelItem'
  | 'ProductUpdates_seeWaitlistBanners'
  | 'ProductUpdates_shareProductUpdate'
  | 'ProductUpdates_sidebarSeeProductUpdatesSubLevelItem'
  | 'ProductUpdates_upsellButtonSeeUpsellButton'
  | 'ProjectManagement_commandBarManageProjects'
  | 'ProjectManagement_expenseRecordLink'
  | 'ProjectManagement_expenseRecordRead'
  | 'ProjectManagement_flexibleTimeRecordRead'
  | 'ProjectManagement_globalTimeRecordRead'
  | 'ProjectManagement_pagesSeeContributorsList'
  | 'ProjectManagement_pagesSeeContributorsListUpsell'
  | 'ProjectManagement_pagesSeeJobsAndRates'
  | 'ProjectManagement_pagesSeeJobsAndRatesUpsell'
  | 'ProjectManagement_pagesSeeProjectsRoot'
  | 'ProjectManagement_pagesSeeScheduleContributors'
  | 'ProjectManagement_pagesSeeScheduleContributorsUpsell'
  | 'ProjectManagement_projectCreate'
  | 'ProjectManagement_projectInvoiceManageInvoices'
  | 'ProjectManagement_projectManage'
  | 'ProjectManagement_projectSeeCost'
  | 'ProjectManagement_projectSeeLaborCost'
  | 'ProjectManagement_projectSoftDelete'
  | 'ProjectManagement_projectTaskManage'
  | 'ProjectManagement_projectWorkerRead'
  | 'ProjectManagement_rateManage'
  | 'ProjectManagement_sidebarSeeMyProjectsTopLevelItem'
  | 'ProjectManagement_sidebarSeeProjectsTopLevelItem'
  | 'ProjectManagement_subprojectHoursDistributionRead'
  | 'ProjectManagement_subprojectRead'
  | 'ProjectManagement_timeRecordRead'
  | 'Reports_commandBarUseReports'
  | 'Reports_useReports'
  | 'SalaryAdvance_manageSalaryAdvance'
  | 'SalaryAdvance_salaryAdvanceEnabled'
  | 'SecuritySettings_updateCompanyConfig'
  | 'ShiftManagement_accessManageShifts'
  | 'ShiftManagement_accessManageTemplates'
  | 'ShiftManagement_accessManageUnassignedShifts'
  | 'ShiftManagement_accessSeeTimeInsights'
  | 'ShiftManagement_defaultShiftManage'
  | 'ShiftManagement_insightsSeeEverybody'
  | 'ShiftManagement_shiftCreateEverybody'
  | 'ShiftManagement_shiftCreateReportees'
  | 'ShiftManagement_shiftCreateSelf'
  | 'ShiftManagement_shiftCreateTeam'
  | 'ShiftManagement_shiftSeeEverybody'
  | 'ShiftManagement_shiftSeeReportees'
  | 'ShiftManagement_shiftSeeSelf'
  | 'ShiftManagement_shiftSeeTeam'
  | 'ShiftManagement_sidebarSeeShiftsTopLevelItem'
  | 'ShiftManagement_swapShiftCreate'
  | 'ShiftManagement_unassignedShiftCreateEverybody'
  | 'ShiftManagement_unassignedShiftCreateReportees'
  | 'ShiftManagement_unassignedShiftCreateSelf'
  | 'ShiftManagement_unassignedShiftCreateTeam'
  | 'SoftwareManagement_manageSoftware'
  | 'SoftwareManagement_settingsSeeSoftwareSettings'
  | 'SoftwareManagement_sidebarSeeSoftwareSubModule'
  | 'SoftwareManagement_sidebarSeeSoftwareTopLevelItem'
  | 'SpaceControl_bookingCancelEverybody'
  | 'SpaceControl_bookingCancelSelf'
  | 'SpaceControl_bookingEditEverybody'
  | 'SpaceControl_bookingEditSelf'
  | 'SpaceControl_bookingSeeEverybody'
  | 'SpaceControl_bookingSeeOwned'
  | 'SpaceControl_sidebarSeeSpaceControlTopLevelItem'
  | 'SpaceControl_workSpaceCreate'
  | 'SpaceControl_workSpaceDelete'
  | 'SpaceControl_workSpaceRead'
  | 'SpaceControl_workSpaceUpdate'
  | 'Surveys_createForms'
  | 'Surveys_createSurveyTemplates'
  | 'Surveys_sidebarSeeEngagementSurveysSubLevelItem'
  | 'Surveys_sidebarSeeSmartSurveysSubLevelItem'
  | 'Surveys_surveyCreateEverybody'
  | 'Surveys_surveyCreateOwned'
  | 'Surveys_surveyCreateReportees'
  | 'Surveys_surveyCreateTeam'
  | 'Surveys_surveysCreateSurvey'
  | 'Surveys_v2ManageSurveys'
  | 'Tasks_showProjectsUpsellModal'
  | 'Tasks_sidebarSeeTasksTopLevelItem'
  | 'Teams_companySeeTeams'
  | 'Teams_companySeeTeamsSection'
  | 'Teams_dashboardWidgetTeamsBelongToVisible'
  | 'Teams_dashboardWidgetTeamsDirectReportsVisible'
  | 'Teams_sidebarSeeCalendarTeamViewSubLevelItem'
  | 'Teams_sidebarSeeEmployeesTeamsSubLevelItem'
  | 'Teams_teamCreate'
  | 'Teams_teamManage'
  | 'TimeBalance_accessSeeTimeBalanceExport'
  | 'TimeBalance_exportSeeEverybody'
  | 'TimePlanning_planningVersionCreateEverybody'
  | 'TimePlanning_planningVersionCreateOwned'
  | 'TimePlanning_planningVersionCreateReportees'
  | 'TimePlanning_planningVersionCreateTeam'
  | 'TimePlanning_planningVersionSeeOwned'
  | 'TimeSettings_manageBreakConfigurations'
  | 'TimeSettings_manageTimeRangeCategories'
  | 'Timeoff_companyManageTimeoff'
  | 'Timeoff_dashboardWidgetUpcomingAbsencesVisible'
  | 'Timeoff_dashboardWidgetUpcomingHolidaysVisible'
  | 'Timeoff_sidebarSeeTimeoffTopLevelItem'
  | 'Trainings_insightRead'
  | 'Trainings_settingsManageSettings'
  | 'Trainings_sidebarSeeMyRequestsSubLevelItem'
  | 'Trainings_sidebarSeeMyTrainingsTopLevelItem'
  | 'Trainings_sidebarSeeTrainingsCatalogSubLevelItem'
  | 'Trainings_sidebarSeeTrainingsTopLevelItem'
  | 'Trainings_trainingCreate'
  | 'Trainings_trainingsAccessManagementSpace'
  | 'Trainings_trainingsRequestsCreate'
  | 'Trainings_trainingsSeeCatalog'
  | 'Trial_companyOnboardingShowCompanyOnboarding'
  | 'Trial_trialEmployeeBulkDelete'
  | 'UniversalImporter_importResources'
  | 'Upsell_canJoinOneWaitlist'
  | 'Upsell_canRequestUpsell'
  | 'Upsell_canSeeBlackFridayPromo'
  | 'WorkSchedule_manageCompanySchedules';

/** Contextless policies resolution for the current domain. */
export type ContextlessPolicyResolution = {
  __typename?: 'ContextlessPolicyResolution';
  can: Scalars['Boolean'];
};

/** Autogenerated return type of ContinueApprovalsMaterializedApprovalsFlow. */
export type ContinueApprovalsMaterializedApprovalsFlowPayload = {
  __typename?: 'ContinueApprovalsMaterializedApprovalsFlowPayload';
  errors: Array<MutationError>;
  materializedApprovalsFlow?: Maybe<ApprovalsMaterializedApprovalsFlow>;
};

export type ContractsActivityPeriod = {
  __typename?: 'ContractsActivityPeriod';
  activeDaysCount: Scalars['Int'];
  currentYearActiveDaysCount: Scalars['Int'];
  endDate?: Maybe<Scalars['ISO8601Date']>;
  startDate: Scalars['ISO8601Date'];
};

/** Additional compensations for a contract */
export type ContractsAdditionalCompensation = {
  __typename?: 'ContractsAdditionalCompensation';
  amountStrategy?: Maybe<AmountStrategy>;
  amountStrategyId: Scalars['Int'];
  amountStrategyType: ContractsValueObjectsAmountStrategyTypeEnum;
  contractVersionId: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  firstPaymentOn?: Maybe<Scalars['ISO8601Date']>;
  id: Scalars['Int'];
  payrollConcept?: Maybe<PayrollConcept>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  payrollConceptId: Scalars['Int'];
  recurrence?: Maybe<Scalars['String']>;
  recurrenceName?: Maybe<Scalars['String']>;
};


/** Additional compensations for a contract */
export type ContractsAdditionalCompensationPayrollConceptArgs = {
  categories?: InputMaybe<Array<PayrollValueObjectsConceptCategoryEnum>>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  default?: InputMaybe<Scalars['Boolean']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  names?: InputMaybe<Array<Scalars['String']>>;
  policyPeriodId?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  unitTypes?: InputMaybe<Array<PayrollValueObjectsConceptUnitTypeEnum>>;
  withActiveStatus?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for ContractsAdditionalCompensation. */
export type ContractsAdditionalCompensationConnection = {
  __typename?: 'ContractsAdditionalCompensationConnection';
  /** A list of edges. */
  edges: Array<ContractsAdditionalCompensationEdge>;
  /** A list of nodes. */
  nodes: Array<ContractsAdditionalCompensation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ContractsAdditionalCompensationEdge = {
  __typename?: 'ContractsAdditionalCompensationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ContractsAdditionalCompensation;
};

export type ContractsAdditionalCompensationRecurrenceEnum =
  | 'every_2_months'
  | 'every_3_months'
  | 'every_4_months'
  | 'every_5_months'
  | 'every_6_months'
  | 'every_7_months'
  | 'every_8_months'
  | 'every_9_months'
  | 'every_10_months'
  | 'every_11_months'
  | 'every_12_months'
  | 'monthly';

export type ContractsAnnualWorkingTimeDistributionEnum =
  | 'limit_daily_hours'
  | 'limit_workdays';

export type ContractsBankHolidayTreatmentEnum =
  | 'non_workable'
  | 'workable';

/** Contracts compensation */
export type ContractsCompensation = {
  __typename?: 'ContractsCompensation';
  /**
   * Value paid on each recurrence, stored in the smallest currency unit (for
   * example cents). Required unless the compensation type is `undefined`
   */
  amount?: Maybe<Scalars['BigInt']>;
  /** Human-readable hint about the payroll formula used (for example "current period" or "average of last 3 months") */
  calculation?: Maybe<Scalars['String']>;
  /** Required field. You can only use the following options: fixed, undefined, up_to, per_worked_day, per_worked_hour */
  compensationType?: Maybe<Scalars['String']>;
  contractApprovalStatus: Scalars['String'];
  contractVersionId: Scalars['Int'];
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  contractsTaxonomyId: Scalars['Int'];
  currency?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  /** Date of the first payout; differs from `starts_on` when payroll scheduling or accrual rules delay payment */
  firstPaymentOn?: Maybe<Scalars['ISO8601Date']>;
  id: Scalars['Int'];
  minimumAmountOfHours?: Maybe<Scalars['Int']>;
  /** Compensation expected minimum amount of hours in cents */
  minimumAmountOfHoursInCents?: Maybe<Scalars['Int']>;
  payrollPolicy?: Maybe<ContractsPayrollPolicy>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  payrollPolicyId?: Maybe<Scalars['Int']>;
  /**
   * Frequency (monthly, yearly, one_time) to determine how often the employee is
   * paid. Could be empty, use `recurrence_count` in that case
   */
  recurrence?: Maybe<Scalars['String']>;
  /**
   * How much time will pass between payments. If recurrence is empty, assume
   * months. For example, 12 here means compensation is paid yearly
   */
  recurrenceCount?: Maybe<Scalars['Int']>;
  startsOn?: Maybe<Scalars['ISO8601Date']>;
  syncWithSupplements?: Maybe<Scalars['Boolean']>;
  taxonomy?: Maybe<ContractsTaxonomy>;
  timeCondition?: Maybe<ContractsValueObjectsTimeConditionEnum>;
  /** In which unit compensation is paid */
  unit: Scalars['String'];
  /**
   * Annualized projection of the configured recurrence and amount so HR can
   * compare heterogeneous compensations (bonuses, allowances, hourly pay) on a
   * common yearly basis. Can be empty if recurrence is not easily prorated (more
   * than 6 months, for example)
   */
  yearlyEquivalentAmount?: Maybe<Scalars['BigInt']>;
};


/** Contracts compensation */
export type ContractsCompensationPayrollPolicyArgs = {
  contractVersionIds?: InputMaybe<Array<Scalars['Int']>>;
  payrollPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Contracts compensation */
export type ContractsCompensationTaxonomyArgs = {
  legalEntityId?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
};

/** The connection type for ContractsCompensation. */
export type ContractsCompensationConnection = {
  __typename?: 'ContractsCompensationConnection';
  /** A list of edges. */
  edges: Array<ContractsCompensationEdge>;
  /** A list of nodes. */
  nodes: Array<ContractsCompensation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ContractsCompensationEdge = {
  __typename?: 'ContractsCompensationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ContractsCompensation;
};

/** compensations_rollout */
export type ContractsCompensationsRollout = {
  __typename?: 'ContractsCompensationsRollout';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['String'];
  metadataAddedCompensationsCount?: Maybe<Scalars['Int']>;
  metadataRemovedCompensationsCount?: Maybe<Scalars['Int']>;
};

export type ContractsCompensationsTypesEnum =
  | 'fixed'
  | 'per_worked_day'
  | 'per_worked_hour'
  | 'undefined'
  | 'up_to';

export type ContractsContextlessPolicies = {
  __typename?: 'ContractsContextlessPolicies';
  contractBulkCreateAdditionalCompensationType: ContextlessPolicyResolution;
  contractEditContractVersion: ContextlessPolicyResolution;
  contractEditContractsSettings: ContextlessPolicyResolution;
  contractPromote: ContextlessPolicyResolution;
  contractSeeAdditionalCompensation: ContextlessPolicyResolution;
  contractSeeContractType: ContextlessPolicyResolution;
  contractSeeEndDate: ContextlessPolicyResolution;
  contractSeeGrossSalary: ContextlessPolicyResolution;
  contractSeeJobTitle: ContextlessPolicyResolution;
  contractSeePayroll: ContextlessPolicyResolution;
  contractSeePendingPromotions: ContextlessPolicyResolution;
  contractSeeStartDate: ContextlessPolicyResolution;
  contractSeeTrialPeriod: ContextlessPolicyResolution;
  contractSeeTrialPeriodEndDate: ContextlessPolicyResolution;
  contractSeeWorkingDayType: ContextlessPolicyResolution;
  contractSeeWorkingHours: ContextlessPolicyResolution;
  sidebarSeeProfileContractsSubLevelItem: ContextlessPolicyResolution;
  weeksPerMonthConfigurationCreate: ContextlessPolicyResolution;
  weeksPerMonthConfigurationRead: ContextlessPolicyResolution;
  weeksPerMonthConfigurationUpdate: ContextlessPolicyResolution;
  weeksPerMonthConfigurationUpsert: ContextlessPolicyResolution;
};

/** Contracts contract */
export type ContractsContract = {
  __typename?: 'ContractsContract';
  activityPeriods: Array<ContractsContractActivityGroup>;
  activityPeriodsConnection: ContractsContractActivityGroupConnection;
  company?: Maybe<CompaniesCompany>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  companyId: Scalars['Int'];
  contractTypeId?: Maybe<Scalars['Int']>;
  contractTypeType?: Maybe<Scalars['String']>;
  contractVersions: Array<ContractsContractVersion>;
  contractVersionsConnection: ContractsContractVersionConnection;
  /** country */
  country: Scalars['String'];
  employee?: Maybe<EmployeesEmployee>;
  /**
   * employee identifier
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  employeeId: Scalars['Int'];
  /** contract end date */
  endsOn?: Maybe<Scalars['ISO8601Date']>;
  /** contract identifier */
  id: Scalars['Int'];
  isDiscontinuous: Scalars['Boolean'];
  legalEntity?: Maybe<CompaniesLegalEntity>;
  /**
   * legal entity identifier
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  legalEntityId: Scalars['Int'];
  schedule: ContractsValueObjectsContractScheduleEnum;
  /** contract start date */
  startsOn: Scalars['ISO8601Date'];
  status?: Maybe<ContractsContractStatus>;
};


/** Contracts contract */
export type ContractsContractActivityPeriodsArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Contracts contract */
export type ContractsContractActivityPeriodsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Contracts contract */
export type ContractsContractCompanyArgs = {
  forBookkeepers?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};


/** Contracts contract */
export type ContractsContractContractVersionsArgs = {
  activeOn?: InputMaybe<Scalars['ISO8601Date']>;
  activeOrUpcomingOn?: InputMaybe<Scalars['ISO8601Date']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  contractIds?: InputMaybe<Array<Scalars['Int']>>;
  date?: InputMaybe<Scalars['ISO8601Date']>;
  effectiveOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  effectiveOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endsOnGt?: InputMaybe<Scalars['ISO8601Date']>;
  endsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  endsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  esEducationLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  forfaitJours?: Scalars['Boolean'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeDenormalizedData?: Scalars['Boolean'];
  jobCatalogTreeNodeUuids?: InputMaybe<Array<Scalars['String']>>;
  levelIds?: InputMaybe<Array<Scalars['Int']>>;
  startsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  startsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  upcomingOn?: InputMaybe<Scalars['ISO8601Date']>;
  withFallback?: Scalars['Boolean'];
  withHasPayrollPolicies?: InputMaybe<Scalars['Boolean']>;
  withMetadata?: Scalars['Boolean'];
  withOldestEffectiveOn?: InputMaybe<Scalars['Boolean']>;
  withPayroll?: InputMaybe<Scalars['Boolean']>;
  withSalaryAmount?: InputMaybe<Scalars['Boolean']>;
  withoutSalaryAmountOrSalaryFrequency?: InputMaybe<Scalars['Boolean']>;
};


/** Contracts contract */
export type ContractsContractContractVersionsConnectionArgs = {
  activeOn?: InputMaybe<Scalars['ISO8601Date']>;
  activeOrUpcomingOn?: InputMaybe<Scalars['ISO8601Date']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  contractIds?: InputMaybe<Array<Scalars['Int']>>;
  date?: InputMaybe<Scalars['ISO8601Date']>;
  effectiveOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  effectiveOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endsOnGt?: InputMaybe<Scalars['ISO8601Date']>;
  endsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  endsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  esEducationLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  forfaitJours?: Scalars['Boolean'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeDenormalizedData?: Scalars['Boolean'];
  jobCatalogTreeNodeUuids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  levelIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  startsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  upcomingOn?: InputMaybe<Scalars['ISO8601Date']>;
  withFallback?: Scalars['Boolean'];
  withHasPayrollPolicies?: InputMaybe<Scalars['Boolean']>;
  withMetadata?: Scalars['Boolean'];
  withOldestEffectiveOn?: InputMaybe<Scalars['Boolean']>;
  withPayroll?: InputMaybe<Scalars['Boolean']>;
  withSalaryAmount?: InputMaybe<Scalars['Boolean']>;
  withoutSalaryAmountOrSalaryFrequency?: InputMaybe<Scalars['Boolean']>;
};


/** Contracts contract */
export type ContractsContractEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Contracts contract */
export type ContractsContractLegalEntityArgs = {
  companiesIds?: InputMaybe<Array<Scalars['Int']>>;
  countryIds?: InputMaybe<Array<Scalars['String']>>;
  employeesIds?: InputMaybe<Array<Scalars['Int']>>;
  excludeCountries?: InputMaybe<Array<Scalars['String']>>;
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};

export type ContractsContractActivity = {
  __typename?: 'ContractsContractActivity';
  activeDaysCount: Scalars['Int'];
  activityPeriods: Array<ContractsActivityPeriod>;
  contractId: Scalars['Int'];
  currentYearActiveDaysCount: Scalars['Int'];
  endDate?: Maybe<Scalars['ISO8601Date']>;
  startDate: Scalars['ISO8601Date'];
};

/** Contracts activity period groups */
export type ContractsContractActivityGroup = {
  __typename?: 'ContractsContractActivityGroup';
  changes?: Maybe<ContractsContractVersionChange>;
  contract?: Maybe<ContractsContract>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  contractId: Scalars['Int'];
  contractVersionIds: Array<Scalars['Int']>;
  periods: Array<ContractsPeriod>;
  referenceVersionId: Scalars['Int'];
  schedule: ContractsValueObjectsContractScheduleEnum;
};


/** Contracts activity period groups */
export type ContractsContractActivityGroupChangesArgs = {
  employeeId: Scalars['Int'];
};


/** Contracts activity period groups */
export type ContractsContractActivityGroupContractArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  startsOn?: InputMaybe<Scalars['ISO8601Date']>;
};

/** The connection type for ContractsContractActivityGroup. */
export type ContractsContractActivityGroupConnection = {
  __typename?: 'ContractsContractActivityGroupConnection';
  /** A list of edges. */
  edges: Array<ContractsContractActivityGroupEdge>;
  /** A list of nodes. */
  nodes: Array<ContractsContractActivityGroup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ContractsContractActivityGroupEdge = {
  __typename?: 'ContractsContractActivityGroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ContractsContractActivityGroup;
};

/** The connection type for ContractsContract. */
export type ContractsContractConnection = {
  __typename?: 'ContractsContractConnection';
  /** A list of edges. */
  edges: Array<ContractsContractEdge>;
  /** A list of nodes. */
  nodes: Array<ContractsContract>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ContractsContractEdge = {
  __typename?: 'ContractsContractEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ContractsContract;
};

/** the filter for the contracts resource */
export type ContractsContractFilter = {
  or?: InputMaybe<Array<ContractsContractFilterConditions>>;
  startsOn?: InputMaybe<DateFilter>;
};

export type ContractsContractFilterConditions = {
  startsOn?: InputMaybe<DateFilter>;
};

/** Contracts contract status */
export type ContractsContractStatus = {
  __typename?: 'ContractsContractStatus';
  contract?: Maybe<ContractsContract>;
  id: Scalars['Int'];
  isActive: Scalars['Boolean'];
  isPausable: Scalars['Boolean'];
  isResumable: Scalars['Boolean'];
};


/** Contracts contract status */
export type ContractsContractStatusContractArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  startsOn?: InputMaybe<Scalars['ISO8601Date']>;
};

/** The connection type for ContractsContractStatus. */
export type ContractsContractStatusConnection = {
  __typename?: 'ContractsContractStatusConnection';
  /** A list of edges. */
  edges: Array<ContractsContractStatusEdge>;
  /** A list of nodes. */
  nodes: Array<ContractsContractStatus>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ContractsContractStatusEdge = {
  __typename?: 'ContractsContractStatusEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ContractsContractStatus;
};

/** Contract templates define country-specific settings used in contract versions */
export type ContractsContractTemplate = {
  __typename?: 'ContractsContractTemplate';
  /** ID of the company this template belongs to */
  companyId?: Maybe<Scalars['Int']>;
  /** Type of contract version (e.g., es for Spain, fr for France) */
  contractVersionType?: Maybe<Scalars['String']>;
  frenchContractType: Array<ContractsFrenchContractType>;
  frenchContractTypeConnection: ContractsFrenchContractTypeConnection;
  frenchLevel: Array<ContractsFrenchLevel>;
  frenchLevelConnection: ContractsFrenchLevelConnection;
  frenchMutual: Array<ContractsFrenchMutual>;
  frenchMutualConnection: ContractsFrenchMutualConnection;
  frenchProfessionalCategory: Array<ContractsFrenchProfessionalCategory>;
  frenchProfessionalCategoryConnection: ContractsFrenchProfessionalCategoryConnection;
  frenchStep: Array<ContractsFrenchStep>;
  frenchStepConnection: ContractsFrenchStepConnection;
  frenchWorkType: Array<ContractsFrenchWorkType>;
  frenchWorkTypeConnection: ContractsFrenchWorkTypeConnection;
  germanContractType: Array<ContractsGermanContractType>;
  germanContractTypeConnection: ContractsGermanContractTypeConnection;
  /** Unique identifier for the contract template */
  id: Scalars['Int'];
  portugueseContractType: Array<ContractsPortugueseContractType>;
  portugueseContractTypeConnection: ContractsPortugueseContractTypeConnection;
  spanishContractType: Array<ContractsSpanishContractType>;
  spanishContractTypeConnection: ContractsSpanishContractTypeConnection;
  spanishEducationLevel: Array<ContractsSpanishEducationLevel>;
  spanishEducationLevelConnection: ContractsSpanishEducationLevelConnection;
  spanishProfessionalCategory: Array<ContractsSpanishProfessionalCategory>;
  spanishProfessionalCategoryConnection: ContractsSpanishProfessionalCategoryConnection;
  spanishWorkingDayType: Array<ContractsSpanishWorkingDayType>;
  spanishWorkingDayTypeConnection: ContractsSpanishWorkingDayTypeConnection;
};


/** Contract templates define country-specific settings used in contract versions */
export type ContractsContractTemplateFrenchContractTypeArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
};


/** Contract templates define country-specific settings used in contract versions */
export type ContractsContractTemplateFrenchContractTypeConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Contract templates define country-specific settings used in contract versions */
export type ContractsContractTemplateFrenchLevelArgs = {
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Scalars['String']>;
  legalEntityIds?: InputMaybe<Scalars['String']>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
};


/** Contract templates define country-specific settings used in contract versions */
export type ContractsContractTemplateFrenchLevelConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Scalars['String']>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Contract templates define country-specific settings used in contract versions */
export type ContractsContractTemplateFrenchMutualArgs = {
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Scalars['String']>;
  legalEntityIds?: InputMaybe<Scalars['String']>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
};


/** Contract templates define country-specific settings used in contract versions */
export type ContractsContractTemplateFrenchMutualConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Scalars['String']>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Contract templates define country-specific settings used in contract versions */
export type ContractsContractTemplateFrenchProfessionalCategoryArgs = {
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Scalars['String']>;
  legalEntityIds?: InputMaybe<Scalars['String']>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
};


/** Contract templates define country-specific settings used in contract versions */
export type ContractsContractTemplateFrenchProfessionalCategoryConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Scalars['String']>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Contract templates define country-specific settings used in contract versions */
export type ContractsContractTemplateFrenchStepArgs = {
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Scalars['String']>;
  legalEntityIds?: InputMaybe<Scalars['String']>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
};


/** Contract templates define country-specific settings used in contract versions */
export type ContractsContractTemplateFrenchStepConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Scalars['String']>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Contract templates define country-specific settings used in contract versions */
export type ContractsContractTemplateFrenchWorkTypeArgs = {
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Scalars['String']>;
  legalEntityIds?: InputMaybe<Scalars['String']>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
};


/** Contract templates define country-specific settings used in contract versions */
export type ContractsContractTemplateFrenchWorkTypeConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Scalars['String']>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Contract templates define country-specific settings used in contract versions */
export type ContractsContractTemplateGermanContractTypeArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
};


/** Contract templates define country-specific settings used in contract versions */
export type ContractsContractTemplateGermanContractTypeConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Contract templates define country-specific settings used in contract versions */
export type ContractsContractTemplatePortugueseContractTypeArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
};


/** Contract templates define country-specific settings used in contract versions */
export type ContractsContractTemplatePortugueseContractTypeConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Contract templates define country-specific settings used in contract versions */
export type ContractsContractTemplateSpanishContractTypeArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
};


/** Contract templates define country-specific settings used in contract versions */
export type ContractsContractTemplateSpanishContractTypeConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Contract templates define country-specific settings used in contract versions */
export type ContractsContractTemplateSpanishEducationLevelArgs = {
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
};


/** Contract templates define country-specific settings used in contract versions */
export type ContractsContractTemplateSpanishEducationLevelConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Contract templates define country-specific settings used in contract versions */
export type ContractsContractTemplateSpanishProfessionalCategoryArgs = {
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
  withArchived?: Scalars['Boolean'];
};


/** Contract templates define country-specific settings used in contract versions */
export type ContractsContractTemplateSpanishProfessionalCategoryConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  withArchived?: Scalars['Boolean'];
};


/** Contract templates define country-specific settings used in contract versions */
export type ContractsContractTemplateSpanishWorkingDayTypeArgs = {
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Scalars['String']>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
};


/** Contract templates define country-specific settings used in contract versions */
export type ContractsContractTemplateSpanishWorkingDayTypeConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Scalars['String']>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for ContractsContractTemplate. */
export type ContractsContractTemplateConnection = {
  __typename?: 'ContractsContractTemplateConnection';
  /** A list of edges. */
  edges: Array<ContractsContractTemplateEdge>;
  /** A list of nodes. */
  nodes: Array<ContractsContractTemplate>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ContractsContractTemplateEdge = {
  __typename?: 'ContractsContractTemplateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ContractsContractTemplate;
};

/** Contracts contract version */
export type ContractsContractVersion = {
  __typename?: 'ContractsContractVersion';
  _policies?: Maybe<ContractsContractVersionPolicies>;
  _policiesCollection?: Maybe<Array<PermissionsPolicyResolution>>;
  _policiesConnection: PermissionsPolicyResolutionConnection;
  a3JobPosition?: Maybe<ContractsSpanishA3innuvaJobPosition>;
  a3TariffGroup?: Maybe<PayrollIntegrationsA3innuvaTariffGroup>;
  actionType?: Maybe<Scalars['String']>;
  additionalCompensations: Array<ContractsAdditionalCompensation>;
  additionalCompensationsConnection: ContractsAdditionalCompensationConnection;
  adjustedDailyMinutes?: Maybe<Scalars['Int']>;
  annualWorkdaysCount?: Maybe<Scalars['Int']>;
  /** Allows companies to define how annual working hours are spread across the year to ensure compliance with legal limits. */
  annualWorkingTimeDistribution?: Maybe<ContractsAnnualWorkingTimeDistributionEnum>;
  approvalActionType?: Maybe<Scalars['String']>;
  approvalAuthorId?: Maybe<Scalars['Int']>;
  approvalRequestCreatedAt?: Maybe<Scalars['ISO8601Date']>;
  approversIds?: Maybe<Array<Scalars['Int']>>;
  /** Defines whether a bank holiday should be considered as a workable or non-workable day. */
  bankHolidayTreatment: ContractsBankHolidayTreatmentEnum;
  /** identifier for company. */
  companyId: Scalars['Int'];
  compensations: Array<ContractsCompensation>;
  compensationsConnection: ContractsCompensationConnection;
  contract?: Maybe<ContractsContract>;
  contractVersionChanges?: Maybe<ContractsContractVersionChange>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  contractsContractId?: Maybe<Scalars['Int']>;
  /** the group of cotization of the employee. */
  contractsEsTariffGroupId?: Maybe<Scalars['Int']>;
  /** nationality country code of the employee (Spain ES, United Kingdom GB). */
  country?: Maybe<Scalars['String']>;
  /** the date the contract version was created. */
  createdAt: Scalars['ISO8601DateTime'];
  createdByAvatar?: Maybe<Scalars['String']>;
  createdByName?: Maybe<Scalars['String']>;
  deActivityType?: Maybe<Scalars['Int']>;
  /**
   * contract type identifier.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  deContractTypeId?: Maybe<Scalars['Int']>;
  deContractTypeName?: Maybe<Scalars['String']>;
  deEmploymentType?: Maybe<Scalars['Int']>;
  deFlatRateTax?: Maybe<Scalars['Int']>;
  dePersonalKeyGroupId?: Maybe<Scalars['Int']>;
  dePersonalKeyGroupName?: Maybe<Scalars['String']>;
  /** the day the specific contract starts, in case of hiring the same than starts_on. */
  effectiveOn: Scalars['ISO8601Date'];
  employee?: Maybe<EmployeesEmployee>;
  /**
   * employee identifier, refers to /employees/employees endpoint.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  employeeId: Scalars['Int'];
  /** the day the employee is terminated. It has nothing to do with trial period, these are concepts totally unrelated. */
  endsOn?: Maybe<Scalars['ISO8601Date']>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  esA3innuvaJobPositionId?: Maybe<Scalars['Int']>;
  esA3innuvaJobPositionName?: Maybe<Scalars['String']>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  esAgreementCodeId?: Maybe<Scalars['Int']>;
  esAgreementCodeName?: Maybe<Scalars['String']>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  esClassificationId?: Maybe<Scalars['Int']>;
  esClassificationName?: Maybe<Scalars['String']>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  esCnoOccupationId?: Maybe<Scalars['Int']>;
  esCnoOccupationName?: Maybe<Scalars['String']>;
  /** observations of the contract. */
  esContractObservations?: Maybe<Scalars['String']>;
  /**
   * contract type identifier.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  esContractTypeId?: Maybe<Scalars['Int']>;
  esContractTypeName?: Maybe<Scalars['String']>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  esContributionTypeId?: Maybe<Scalars['Int']>;
  esContributionTypeName?: Maybe<Scalars['String']>;
  /** the group of cotization of the employee. */
  esCotizationGroup?: Maybe<Scalars['Int']>;
  /**
   * education level identifier.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  esEducationLevelId?: Maybe<Scalars['Int']>;
  esEducationLevelName?: Maybe<Scalars['String']>;
  /** flag that indicates if the contract has teleworking. */
  esHasTeleworkingContract?: Maybe<Scalars['Boolean']>;
  /** the job description of the employee. */
  esJobDescription?: Maybe<Scalars['String']>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  esOccupationCodeId?: Maybe<Scalars['Int']>;
  esOccupationCodeName?: Maybe<Scalars['String']>;
  /**
   * professional category identifier.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  esProfessionalCategoryId?: Maybe<Scalars['Int']>;
  esProfessionalCategoryName?: Maybe<Scalars['String']>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  esRegimeId?: Maybe<Scalars['Int']>;
  esRegimeName?: Maybe<Scalars['String']>;
  esTariffGroupId?: Maybe<Scalars['Int']>;
  esTariffGroupName?: Maybe<Scalars['String']>;
  /**
   * working day type identifier.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  esWorkingDayTypeId?: Maybe<Scalars['Int']>;
  esWorkingDayTypeName?: Maybe<Scalars['String']>;
  /** coefficient for france contracts. */
  frCoefficient?: Maybe<Scalars['String']>;
  /**
   * contract type identifier.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  frContractTypeId?: Maybe<Scalars['Int']>;
  frContractTypeName?: Maybe<Scalars['String']>;
  /** employee type. */
  frEmployeeType?: Maybe<Scalars['String']>;
  /** flag that indicates if the employee is allowed to work within the framework of a fixed number of days. */
  frForfaitJours: Scalars['Boolean'];
  /** the number of days the employee is allowed to work. */
  frJoursParAn?: Maybe<Scalars['Int']>;
  frJoursParAnCents?: Maybe<Scalars['Int']>;
  /**
   * level identifier.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  frLevelId?: Maybe<Scalars['Int']>;
  frLevelName?: Maybe<Scalars['String']>;
  /**
   * mutual identifier.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  frMutualId?: Maybe<Scalars['Int']>;
  frMutualName?: Maybe<Scalars['String']>;
  /**
   * professional category identifier.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  frProfessionalCategoryId?: Maybe<Scalars['Int']>;
  frProfessionalCategoryName?: Maybe<Scalars['String']>;
  /**
   * step identifier.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  frStepId?: Maybe<Scalars['Int']>;
  frStepName?: Maybe<Scalars['String']>;
  /**
   * work type identifier.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  frWorkTypeId?: Maybe<Scalars['Int']>;
  frWorkTypeName?: Maybe<Scalars['String']>;
  franceContractType?: Maybe<ContractsFrenchContractType>;
  franceLevel?: Maybe<ContractsFrenchLevel>;
  franceMutual?: Maybe<ContractsFrenchMutual>;
  franceProfessionalCategory?: Maybe<ContractsFrenchProfessionalCategory>;
  franceStep?: Maybe<ContractsFrenchStep>;
  franceWorkingDayType?: Maybe<ContractsFrenchWorkType>;
  germanyContractType?: Maybe<ContractsGermanContractType>;
  /** boolean that indicates if the employee asociated to this contract belongs to a payroll policy. */
  hasPayroll: Scalars['Boolean'];
  hasPayrollPolicies?: Maybe<Scalars['Boolean']>;
  /** a flag that indicates if the contract version has ever had a trial period. */
  hasTrialPeriod?: Maybe<Scalars['Boolean']>;
  /** identifier for the contract version. */
  id?: Maybe<Scalars['Int']>;
  /** whether it is the reference contract today or not. It is important to remark that reference contract doesn't mean active */
  isReference?: Maybe<Scalars['Boolean']>;
  jobCatalogLevel?: Maybe<JobCatalogLevel>;
  /**
   * job catalog level identifier, refers to /job_catalog/levels endpoint.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  jobCatalogLevelId?: Maybe<Scalars['Int']>;
  jobCatalogLevelName?: Maybe<Scalars['String']>;
  /** the role of the employee in the job catalog. */
  jobCatalogRole?: Maybe<Scalars['String']>;
  /** the role id of the employee in the job catalog. */
  jobCatalogRoleId?: Maybe<Scalars['Int']>;
  jobCatalogTreeLevel?: Maybe<JobCatalogTreeNode>;
  /**
   * the uuid node in the job catalog tree. For now it only supports level nodes.
   * From this point in the job catalog tree you can get the full ancestor path to
   * the root node including the role. Refer to job_catalog/tree_nodes endpoint.
   */
  jobCatalogTreeNodeUuid?: Maybe<Scalars['String']>;
  /** job title of the employee. */
  jobTitle?: Maybe<Scalars['String']>;
  /** the maximum amount of hours the employee can work in a year. */
  maxLegalYearlyHours?: Maybe<Scalars['Int']>;
  /** the maximum amount of days the employee can work in a row. */
  maxWorkDaysInRow?: Maybe<Scalars['Int']>;
  /** the maximum amount of minutes the employee can work in a day. */
  maxWorkMinutesPerDay?: Maybe<Scalars['Int']>;
  /** the maximum amount of hours the employee can work in a week. */
  maximumWeeklyHours?: Maybe<Scalars['Int']>;
  /** the minimum amount of hours the employee must rest in a row. */
  minRestHoursInRow?: Maybe<Scalars['Int']>;
  /** the minimum amount of minutes the employee must rest between working periods. */
  minRestMinutesBetweenDays?: Maybe<Scalars['Int']>;
  partTime: Scalars['Boolean'];
  payrollPolicy?: Maybe<ContractsPayrollPolicy>;
  portugalContractType?: Maybe<ContractsPortugueseContractType>;
  /**
   * contract type identifier.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  ptContractTypeId?: Maybe<Scalars['Int']>;
  ptContractTypeName?: Maybe<Scalars['String']>;
  requestDetails?: Maybe<Scalars['String']>;
  /** the amount of money the employee earns in cents. */
  salaryAmount?: Maybe<Scalars['BigInt']>;
  /** the frequency of the salary payment. */
  salaryFrequency?: Maybe<Scalars['String']>;
  spainAgreementCode?: Maybe<ContractsSpanishAgreementCode>;
  spainClassification?: Maybe<ContractsSpanishClassification>;
  spainCnoOccupation?: Maybe<ContractsSpanishCnoOccupation>;
  spainContractType?: Maybe<ContractsSpanishContractType>;
  spainContributionType?: Maybe<ContractsSpanishContributionType>;
  spainEducationLevel?: Maybe<ContractsSpanishEducationLevel>;
  spainOccupationCode?: Maybe<ContractsSpanishOccupationCode>;
  spainProfessionalCategory?: Maybe<ContractsSpanishProfessionalCategory>;
  spainRegime?: Maybe<ContractsSpanishRegime>;
  spainWorkingDayType?: Maybe<ContractsSpanishWorkingDayType>;
  /** the day the employee is hired. */
  startsOn?: Maybe<Scalars['ISO8601Date']>;
  status: Scalars['String'];
  /**
   * when the trial period ends. If there is no date, it means that the employee
   * has never been in trial. This date is not related with the end date of a contract.
   */
  trialPeriodEndsOn?: Maybe<Scalars['ISO8601Date']>;
  /** the date of the last contract version updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  values: Array<CustomFieldsValue>;
  valuesConnection: CustomFieldsValueConnection;
  versionApplication?: Maybe<WorkingConditionsVersionApplication>;
  /** the amount of hours the employee works. */
  workingHours?: Maybe<Scalars['Int']>;
  /** the frequency of the working hours. */
  workingHoursFrequency?: Maybe<Scalars['String']>;
  /**
   * Working time percentage in cents (e.g., when an employee is working part-time,
   * the percentage of full-time hours they are working).
   */
  workingTimePercentageInCents?: Maybe<Scalars['Int']>;
  /** the days of the week the employee works. */
  workingWeekDays?: Maybe<Scalars['String']>;
};


/** Contracts contract version */
export type ContractsContractVersion_PoliciesCollectionArgs = {
  ids: Array<ContractsContractVersionPoliciesEnum>;
};


/** Contracts contract version */
export type ContractsContractVersion_PoliciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Contracts contract version */
export type ContractsContractVersionA3JobPositionArgs = {
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Contracts contract version */
export type ContractsContractVersionAdditionalCompensationsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Contracts contract version */
export type ContractsContractVersionAdditionalCompensationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Contracts contract version */
export type ContractsContractVersionCompensationsArgs = {
  calculation?: InputMaybe<Scalars['String']>;
  compensationTypes?: InputMaybe<Array<Scalars['String']>>;
  contractApprovalStatus?: InputMaybe<Array<Scalars['String']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  notIds?: InputMaybe<Array<Scalars['Int']>>;
  occurringAt?: InputMaybe<Scalars['ISO8601Date']>;
  occurringFrequency?: InputMaybe<Scalars['String']>;
  occursAt?: InputMaybe<Scalars['ISO8601Date']>;
  payrollPolicyId?: InputMaybe<Scalars['Int']>;
  syncWithSupplements?: InputMaybe<Scalars['Boolean']>;
};


/** Contracts contract version */
export type ContractsContractVersionCompensationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  calculation?: InputMaybe<Scalars['String']>;
  compensationTypes?: InputMaybe<Array<Scalars['String']>>;
  contractApprovalStatus?: InputMaybe<Array<Scalars['String']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  notIds?: InputMaybe<Array<Scalars['Int']>>;
  occurringAt?: InputMaybe<Scalars['ISO8601Date']>;
  occurringFrequency?: InputMaybe<Scalars['String']>;
  occursAt?: InputMaybe<Scalars['ISO8601Date']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  payrollPolicyId?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  syncWithSupplements?: InputMaybe<Scalars['Boolean']>;
};


/** Contracts contract version */
export type ContractsContractVersionContractArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  startsOn?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Contracts contract version */
export type ContractsContractVersionContractVersionChangesArgs = {
  employeeId: Scalars['Int'];
};


/** Contracts contract version */
export type ContractsContractVersionEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Contracts contract version */
export type ContractsContractVersionFranceContractTypeArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
};


/** Contracts contract version */
export type ContractsContractVersionFranceLevelArgs = {
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Scalars['String']>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
};


/** Contracts contract version */
export type ContractsContractVersionFranceMutualArgs = {
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Scalars['String']>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
};


/** Contracts contract version */
export type ContractsContractVersionFranceProfessionalCategoryArgs = {
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Scalars['String']>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
};


/** Contracts contract version */
export type ContractsContractVersionFranceStepArgs = {
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Scalars['String']>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
};


/** Contracts contract version */
export type ContractsContractVersionFranceWorkingDayTypeArgs = {
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Scalars['String']>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
};


/** Contracts contract version */
export type ContractsContractVersionGermanyContractTypeArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
};


/** Contracts contract version */
export type ContractsContractVersionJobCatalogLevelArgs = {
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  includeArchived?: Scalars['Boolean'];
  includeArchivedRole?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  roleIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Contracts contract version */
export type ContractsContractVersionJobCatalogTreeLevelArgs = {
  ancestorIds?: InputMaybe<Array<Scalars['Int']>>;
  ancestorUuids?: InputMaybe<Array<Scalars['String']>>;
  attributeTypeIds?: InputMaybe<Array<Scalars['String']>>;
  attributeTypes?: InputMaybe<Array<JobCatalogEnumsJobCatalogTreeAttributeTypesEnum>>;
  id?: InputMaybe<Scalars['Int']>;
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  includeFullPath?: InputMaybe<Scalars['Boolean']>;
  nodeType?: InputMaybe<JobCatalogEnumsJobCatalogTreeNodeTypesEnum>;
  nodeUuids?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
};


/** Contracts contract version */
export type ContractsContractVersionPayrollPolicyArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  payrollPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Contracts contract version */
export type ContractsContractVersionPortugalContractTypeArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
};


/** Contracts contract version */
export type ContractsContractVersionSpainAgreementCodeArgs = {
  legalEntityIds?: InputMaybe<Scalars['String']>;
};


/** Contracts contract version */
export type ContractsContractVersionSpainClassificationArgs = {
  legalEntityIds?: InputMaybe<Scalars['String']>;
};


/** Contracts contract version */
export type ContractsContractVersionSpainCnoOccupationArgs = {
  legalEntityIds?: InputMaybe<Scalars['String']>;
};


/** Contracts contract version */
export type ContractsContractVersionSpainContractTypeArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
};


/** Contracts contract version */
export type ContractsContractVersionSpainContributionTypeArgs = {
  legalEntityIds?: InputMaybe<Scalars['String']>;
};


/** Contracts contract version */
export type ContractsContractVersionSpainEducationLevelArgs = {
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
};


/** Contracts contract version */
export type ContractsContractVersionSpainOccupationCodeArgs = {
  legalEntityIds?: InputMaybe<Scalars['String']>;
};


/** Contracts contract version */
export type ContractsContractVersionSpainProfessionalCategoryArgs = {
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
  withArchived?: Scalars['Boolean'];
};


/** Contracts contract version */
export type ContractsContractVersionSpainRegimeArgs = {
  legalEntityIds?: InputMaybe<Scalars['String']>;
};


/** Contracts contract version */
export type ContractsContractVersionSpainWorkingDayTypeArgs = {
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Scalars['String']>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
};


/** Contracts contract version */
export type ContractsContractVersionValuesArgs = {
  contractsVersionsIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  fieldId?: InputMaybe<Scalars['Int']>;
  identifiers?: InputMaybe<Array<Scalars['String']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  instanceId?: InputMaybe<Scalars['Int']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  updatedAtGteq?: InputMaybe<Scalars['String']>;
  usageGroupId?: InputMaybe<Scalars['Int']>;
  usageGroupSlugs?: InputMaybe<Array<Scalars['String']>>;
  value?: InputMaybe<Scalars['String']>;
};


/** Contracts contract version */
export type ContractsContractVersionValuesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  contractsVersionsIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  fieldId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  identifiers?: InputMaybe<Array<Scalars['String']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  instanceId?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  updatedAtGteq?: InputMaybe<Scalars['String']>;
  usageGroupId?: InputMaybe<Scalars['Int']>;
  usageGroupSlugs?: InputMaybe<Array<Scalars['String']>>;
  value?: InputMaybe<Scalars['String']>;
};


/** Contracts contract version */
export type ContractsContractVersionVersionApplicationArgs = {
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  workingConditionVersionIds?: InputMaybe<Array<Scalars['Int']>>;
};

/** Contracts contract version changes */
export type ContractsContractVersionChange = {
  __typename?: 'ContractsContractVersionChange';
  changes?: Maybe<ContractsContractVersionChange>;
  contractVersion?: Maybe<ContractsContractVersion>;
  firstContractVersion: Scalars['Boolean'];
  id: Scalars['Int'];
  updates: Array<ContractsContractVersionUpdate>;
};


/** Contracts contract version changes */
export type ContractsContractVersionChangeChangesArgs = {
  employeeId: Scalars['Int'];
};


/** Contracts contract version changes */
export type ContractsContractVersionChangeContractVersionArgs = {
  activeOn?: InputMaybe<Scalars['ISO8601Date']>;
  activeOrUpcomingOn?: InputMaybe<Scalars['ISO8601Date']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  contractIds?: InputMaybe<Array<Scalars['Int']>>;
  date?: InputMaybe<Scalars['ISO8601Date']>;
  effectiveOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  effectiveOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endsOnGt?: InputMaybe<Scalars['ISO8601Date']>;
  endsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  endsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  esEducationLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  forfaitJours?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  jobCatalogTreeNodeUuids?: InputMaybe<Array<Scalars['String']>>;
  levelIds?: InputMaybe<Array<Scalars['Int']>>;
  startsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  startsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  upcomingOn?: InputMaybe<Scalars['ISO8601Date']>;
  withFallback?: Scalars['Boolean'];
  withHasPayrollPolicies?: InputMaybe<Scalars['Boolean']>;
  withMetadata?: Scalars['Boolean'];
  withOldestEffectiveOn?: InputMaybe<Scalars['Boolean']>;
  withPayroll?: InputMaybe<Scalars['Boolean']>;
  withSalaryAmount?: InputMaybe<Scalars['Boolean']>;
  withoutSalaryAmountOrSalaryFrequency?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for ContractsContractVersionChange. */
export type ContractsContractVersionChangeConnection = {
  __typename?: 'ContractsContractVersionChangeConnection';
  /** A list of edges. */
  edges: Array<ContractsContractVersionChangeEdge>;
  /** A list of nodes. */
  nodes: Array<ContractsContractVersionChange>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ContractsContractVersionChangeEdge = {
  __typename?: 'ContractsContractVersionChangeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ContractsContractVersionChange;
};

/** The connection type for ContractsContractVersion. */
export type ContractsContractVersionConnection = {
  __typename?: 'ContractsContractVersionConnection';
  /** A list of edges. */
  edges: Array<ContractsContractVersionEdge>;
  /** A list of nodes. */
  nodes: Array<ContractsContractVersion>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ContractsContractVersionEdge = {
  __typename?: 'ContractsContractVersionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ContractsContractVersion;
};

/** the filter for the contract_versions resource */
export type ContractsContractVersionFilter = {
  effectiveOn?: InputMaybe<DateFilter>;
  or?: InputMaybe<Array<ContractsContractVersionFilterConditions>>;
};

export type ContractsContractVersionFilterConditions = {
  effectiveOn?: InputMaybe<DateFilter>;
};

/** Contracts contract version flow */
export type ContractsContractVersionFlow = {
  __typename?: 'ContractsContractVersionFlow';
  actionType?: Maybe<Scalars['String']>;
  annualWorkingTimeDistribution?: Maybe<ContractsAnnualWorkingTimeDistributionEnum>;
  bankHolidayTreatment: ContractsBankHolidayTreatmentEnum;
  contractVersionId: Scalars['Int'];
  contractsEsTariffGroupId?: Maybe<Scalars['Int']>;
  country?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601Date'];
  createdByAvatar?: Maybe<Scalars['String']>;
  createdByName?: Maybe<Scalars['String']>;
  deActivityType?: Maybe<Scalars['Int']>;
  deContractTypeId?: Maybe<Scalars['Int']>;
  deEmploymentType?: Maybe<Scalars['Int']>;
  deFlatRateTax?: Maybe<Scalars['Int']>;
  dePersonalKeyGroupId?: Maybe<Scalars['Int']>;
  effectiveOn: Scalars['ISO8601Date'];
  employeeId: Scalars['Int'];
  endsOn?: Maybe<Scalars['ISO8601Date']>;
  esA3innuvaJobPositionId?: Maybe<Scalars['Int']>;
  esA3innuvaJobPositionName?: Maybe<Scalars['String']>;
  esAgreementCodeId?: Maybe<Scalars['Int']>;
  esAgreementCodeName?: Maybe<Scalars['String']>;
  esClassificationId?: Maybe<Scalars['Int']>;
  esClassificationName?: Maybe<Scalars['String']>;
  esCnoOccupationId?: Maybe<Scalars['Int']>;
  esCnoOccupationName?: Maybe<Scalars['String']>;
  esContractObservations?: Maybe<Scalars['String']>;
  esContractTypeId?: Maybe<Scalars['Int']>;
  esContractTypeName?: Maybe<Scalars['String']>;
  esContributionTypeId?: Maybe<Scalars['Int']>;
  esContributionTypeName?: Maybe<Scalars['String']>;
  esCotizationGroup?: Maybe<Scalars['Int']>;
  esEducationLevelId?: Maybe<Scalars['Int']>;
  esEducationLevelName?: Maybe<Scalars['String']>;
  esHasTeleworkingContract?: Maybe<Scalars['Boolean']>;
  esJobDescription?: Maybe<Scalars['String']>;
  esOccupationCodeId?: Maybe<Scalars['Int']>;
  esOccupationCodeName?: Maybe<Scalars['String']>;
  esProfessionalCategoryId?: Maybe<Scalars['Int']>;
  esProfessionalCategoryName?: Maybe<Scalars['String']>;
  esRegimeId?: Maybe<Scalars['Int']>;
  esRegimeName?: Maybe<Scalars['String']>;
  esTariffGroupId?: Maybe<Scalars['Int']>;
  esTariffGroupName?: Maybe<Scalars['String']>;
  esWorkingDayTypeId?: Maybe<Scalars['Int']>;
  esWorkingDayTypeName?: Maybe<Scalars['String']>;
  frCoefficient?: Maybe<Scalars['String']>;
  frContractTypeId?: Maybe<Scalars['Int']>;
  frContractTypeName?: Maybe<Scalars['String']>;
  frEmployeeType?: Maybe<Scalars['String']>;
  frForfaitJours: Scalars['Boolean'];
  frJoursParAn?: Maybe<Scalars['Int']>;
  frJoursParAnCents?: Maybe<Scalars['Int']>;
  frLevelId?: Maybe<Scalars['Int']>;
  frMutualId?: Maybe<Scalars['Int']>;
  frMutualName?: Maybe<Scalars['String']>;
  frProfessionalCategoryId?: Maybe<Scalars['Int']>;
  frProfessionalCategoryName?: Maybe<Scalars['String']>;
  frStepId?: Maybe<Scalars['Int']>;
  frWorkTypeId?: Maybe<Scalars['Int']>;
  frWorkTypeName?: Maybe<Scalars['String']>;
  hasPayroll: Scalars['Boolean'];
  hasPayrollPolicies?: Maybe<Scalars['Boolean']>;
  hasTrialPeriod?: Maybe<Scalars['Boolean']>;
  jobCatalogLevel?: Maybe<Scalars['String']>;
  jobCatalogLevelId?: Maybe<Scalars['Int']>;
  jobCatalogLevelName?: Maybe<Scalars['String']>;
  jobCatalogRole?: Maybe<Scalars['String']>;
  jobCatalogTreeNodeUuid?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  maxLegalYearlyHours?: Maybe<Scalars['Int']>;
  maxWorkDaysInRow?: Maybe<Scalars['Int']>;
  maxWorkMinutesPerDay?: Maybe<Scalars['Int']>;
  maximumWeeklyHours?: Maybe<Scalars['Int']>;
  minRestHoursInRow?: Maybe<Scalars['Int']>;
  minRestMinutesBetweenDays?: Maybe<Scalars['Int']>;
  ptContractTypeId?: Maybe<Scalars['Int']>;
  salaryAmount?: Maybe<Scalars['Int']>;
  salaryFrequency?: Maybe<Scalars['String']>;
  startsOn?: Maybe<Scalars['ISO8601Date']>;
  trialPeriodEndsOn?: Maybe<Scalars['ISO8601Date']>;
  updatedAt: Scalars['ISO8601Date'];
  workingHours?: Maybe<Scalars['Int']>;
  workingHoursFrequency?: Maybe<Scalars['String']>;
  workingTimePercentageInCents?: Maybe<Scalars['Int']>;
  workingWeekDays?: Maybe<Scalars['String']>;
};

export type ContractsContractVersionHistoryActionTypeEnum =
  | 'evolution'
  | 'fix'
  | 'promotion';

/** Contracts contract version meta data */
export type ContractsContractVersionMetaDatum = {
  __typename?: 'ContractsContractVersionMetaDatum';
  /** the action that has been performed on the contract version ex:promotion / evolution / null. */
  actionType?: Maybe<Scalars['String']>;
  contractVersion?: Maybe<ContractsContractVersion>;
  /**
   * identifier for the contract version.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  contractVersionId: Scalars['Int'];
};


/** Contracts contract version meta data */
export type ContractsContractVersionMetaDatumContractVersionArgs = {
  activeOn?: InputMaybe<Scalars['ISO8601Date']>;
  activeOrUpcomingOn?: InputMaybe<Scalars['ISO8601Date']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  contractIds?: InputMaybe<Array<Scalars['Int']>>;
  date?: InputMaybe<Scalars['ISO8601Date']>;
  effectiveOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  effectiveOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endsOnGt?: InputMaybe<Scalars['ISO8601Date']>;
  endsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  endsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  esEducationLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  forfaitJours?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  jobCatalogTreeNodeUuids?: InputMaybe<Array<Scalars['String']>>;
  levelIds?: InputMaybe<Array<Scalars['Int']>>;
  startsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  startsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  upcomingOn?: InputMaybe<Scalars['ISO8601Date']>;
  withFallback?: Scalars['Boolean'];
  withHasPayrollPolicies?: InputMaybe<Scalars['Boolean']>;
  withMetadata?: Scalars['Boolean'];
  withOldestEffectiveOn?: InputMaybe<Scalars['Boolean']>;
  withPayroll?: InputMaybe<Scalars['Boolean']>;
  withSalaryAmount?: InputMaybe<Scalars['Boolean']>;
  withoutSalaryAmountOrSalaryFrequency?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for ContractsContractVersionMetaDatum. */
export type ContractsContractVersionMetaDatumConnection = {
  __typename?: 'ContractsContractVersionMetaDatumConnection';
  /** A list of edges. */
  edges: Array<ContractsContractVersionMetaDatumEdge>;
  /** A list of nodes. */
  nodes: Array<ContractsContractVersionMetaDatum>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ContractsContractVersionMetaDatumEdge = {
  __typename?: 'ContractsContractVersionMetaDatumEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ContractsContractVersionMetaDatum;
};

export type ContractsContractVersionPolicies = {
  __typename?: 'ContractsContractVersionPolicies';
  delete: PermissionsPolicyResolution;
  edit: PermissionsPolicyResolution;
  promote: PermissionsPolicyResolution;
  seeAdditionalCompensation: PermissionsPolicyResolution;
  seeContractExtraInfo: PermissionsPolicyResolution;
  seeContractType: PermissionsPolicyResolution;
  seeEndDate: PermissionsPolicyResolution;
  seeGrossSalary: PermissionsPolicyResolution;
  seeJobTitle: PermissionsPolicyResolution;
  seePayrollPolicy: PermissionsPolicyResolution;
  seeStartDate: PermissionsPolicyResolution;
  seeTrialPeriod: PermissionsPolicyResolution;
  seeTrialPeriodEndDate: PermissionsPolicyResolution;
  seeWorkingDayType: PermissionsPolicyResolution;
  seeWorkingHours: PermissionsPolicyResolution;
};

export type ContractsContractVersionPoliciesEnum =
  | 'delete'
  | 'edit'
  | 'promote'
  | 'see_additional_compensation'
  | 'see_contract_extra_info'
  | 'see_contract_type'
  | 'see_end_date'
  | 'see_gross_salary'
  | 'see_job_title'
  | 'see_payroll_policy'
  | 'see_start_date'
  | 'see_trial_period'
  | 'see_trial_period_end_date'
  | 'see_working_day_type'
  | 'see_working_hours';

/** Allows to read, creates, aprove, reject and delete requests for contract versions */
export type ContractsContractVersionRequest = {
  __typename?: 'ContractsContractVersionRequest';
  _policies?: Maybe<ContractsContractVersionRequestPolicies>;
  _policiesCollection?: Maybe<Array<PermissionsPolicyResolution>>;
  _policiesConnection: PermissionsPolicyResolutionConnection;
  actionType?: Maybe<Scalars['String']>;
  adjustedDailyMinutes?: Maybe<Scalars['Int']>;
  approvalActionType?: Maybe<Scalars['String']>;
  approvalAuthor?: Maybe<EmployeesEmployee>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  approvalAuthorId?: Maybe<Scalars['Int']>;
  approvalRequestCreatedAt?: Maybe<Scalars['ISO8601Date']>;
  approversIds?: Maybe<Array<Scalars['Int']>>;
  country?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601Date'];
  createdByAvatar?: Maybe<Scalars['String']>;
  createdByName?: Maybe<Scalars['String']>;
  deActivityType?: Maybe<Scalars['Int']>;
  deContractTypeId?: Maybe<Scalars['Int']>;
  deEmploymentType?: Maybe<Scalars['Int']>;
  deFlatRateTax?: Maybe<Scalars['Int']>;
  dePersonalKeyGroupId?: Maybe<Scalars['Int']>;
  effectiveOn: Scalars['ISO8601Date'];
  employee?: Maybe<EmployeesEmployee>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  employeeId: Scalars['Int'];
  employeeName?: Maybe<EmployeesEmployeeName>;
  endsOn?: Maybe<Scalars['ISO8601Date']>;
  esA3innuvaJobPositionId?: Maybe<Scalars['Int']>;
  esA3innuvaJobPositionName?: Maybe<Scalars['String']>;
  esAgreementCodeId?: Maybe<Scalars['Int']>;
  esAgreementCodeName?: Maybe<Scalars['String']>;
  esClassificationId?: Maybe<Scalars['Int']>;
  esClassificationName?: Maybe<Scalars['String']>;
  esCnoOccupationId?: Maybe<Scalars['Int']>;
  esCnoOccupationName?: Maybe<Scalars['String']>;
  esContractObservations?: Maybe<Scalars['String']>;
  esContractTypeId?: Maybe<Scalars['Int']>;
  esContractTypeName?: Maybe<Scalars['String']>;
  esContributionTypeId?: Maybe<Scalars['Int']>;
  esContributionTypeName?: Maybe<Scalars['String']>;
  esCotizationGroup?: Maybe<Scalars['Int']>;
  esEducationLevelId?: Maybe<Scalars['Int']>;
  esEducationLevelName?: Maybe<Scalars['String']>;
  esHasTeleworkingContract?: Maybe<Scalars['Boolean']>;
  esJobDescription?: Maybe<Scalars['String']>;
  esOccupationCodeId?: Maybe<Scalars['Int']>;
  esOccupationCodeName?: Maybe<Scalars['String']>;
  esProfessionalCategoryId?: Maybe<Scalars['Int']>;
  esProfessionalCategoryName?: Maybe<Scalars['String']>;
  esRegimeId?: Maybe<Scalars['Int']>;
  esRegimeName?: Maybe<Scalars['String']>;
  esTariffGroupId?: Maybe<Scalars['Int']>;
  esTariffGroupName?: Maybe<Scalars['String']>;
  esWorkingDayTypeId?: Maybe<Scalars['Int']>;
  esWorkingDayTypeName?: Maybe<Scalars['String']>;
  frCoefficient?: Maybe<Scalars['String']>;
  frContractTypeId?: Maybe<Scalars['Int']>;
  frContractTypeName?: Maybe<Scalars['String']>;
  frEmployeeType?: Maybe<Scalars['String']>;
  frForfaitJours: Scalars['Boolean'];
  frJoursParAn?: Maybe<Scalars['Int']>;
  frJoursParAnCents?: Maybe<Scalars['Int']>;
  frLevelId?: Maybe<Scalars['Int']>;
  frMutualId?: Maybe<Scalars['Int']>;
  frMutualName?: Maybe<Scalars['String']>;
  frProfessionalCategoryId?: Maybe<Scalars['Int']>;
  frProfessionalCategoryName?: Maybe<Scalars['String']>;
  frStepId?: Maybe<Scalars['Int']>;
  frWorkTypeId?: Maybe<Scalars['Int']>;
  frWorkTypeName?: Maybe<Scalars['String']>;
  hasPayroll: Scalars['Boolean'];
  hasPayrollPolicies?: Maybe<Scalars['Boolean']>;
  hasTrialPeriod?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  jobCatalogLevel?: Maybe<Scalars['String']>;
  jobCatalogLevelId?: Maybe<Scalars['Int']>;
  jobCatalogLevelName?: Maybe<Scalars['String']>;
  jobCatalogRole?: Maybe<Scalars['String']>;
  jobCatalogRoleId?: Maybe<Scalars['Int']>;
  jobCatalogTreeNodeUuid?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  maxLegalYearlyHours?: Maybe<Scalars['Int']>;
  maximumWeeklyHours?: Maybe<Scalars['Int']>;
  payrollPolicy?: Maybe<ContractsPayrollPolicy>;
  ptContractTypeId?: Maybe<Scalars['Int']>;
  requestDetails?: Maybe<Scalars['String']>;
  salaryAmount?: Maybe<Scalars['Int']>;
  salaryFrequency?: Maybe<Scalars['String']>;
  startsOn?: Maybe<Scalars['ISO8601Date']>;
  status: Scalars['String'];
  trialPeriodEndsOn?: Maybe<Scalars['ISO8601Date']>;
  updatedAt: Scalars['ISO8601Date'];
  workingHours?: Maybe<Scalars['Int']>;
  workingHoursFrequency?: Maybe<Scalars['String']>;
  workingWeekDays?: Maybe<Scalars['String']>;
};


/** Allows to read, creates, aprove, reject and delete requests for contract versions */
export type ContractsContractVersionRequest_PoliciesCollectionArgs = {
  ids: Array<ContractsContractVersionRequestPoliciesEnum>;
};


/** Allows to read, creates, aprove, reject and delete requests for contract versions */
export type ContractsContractVersionRequest_PoliciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Allows to read, creates, aprove, reject and delete requests for contract versions */
export type ContractsContractVersionRequestApprovalAuthorArgs = {
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Allows to read, creates, aprove, reject and delete requests for contract versions */
export type ContractsContractVersionRequestEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Allows to read, creates, aprove, reject and delete requests for contract versions */
export type ContractsContractVersionRequestEmployeeNameArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  afterEmployeeId?: InputMaybe<Scalars['Int']>;
  beforeEmployeeId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  reporteesOrLed?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyId?: InputMaybe<Scalars['Int']>;
  verb?: InputMaybe<Scalars['String']>;
  withActiveContract?: Scalars['Boolean'];
};


/** Allows to read, creates, aprove, reject and delete requests for contract versions */
export type ContractsContractVersionRequestPayrollPolicyArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  payrollPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
};

/** The connection type for ContractsContractVersionRequest. */
export type ContractsContractVersionRequestConnection = {
  __typename?: 'ContractsContractVersionRequestConnection';
  /** A list of edges. */
  edges: Array<ContractsContractVersionRequestEdge>;
  /** A list of nodes. */
  nodes: Array<ContractsContractVersionRequest>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ContractsContractVersionRequestEdge = {
  __typename?: 'ContractsContractVersionRequestEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ContractsContractVersionRequest;
};

export type ContractsContractVersionRequestPolicies = {
  __typename?: 'ContractsContractVersionRequestPolicies';
  promote: PermissionsPolicyResolution;
};

export type ContractsContractVersionRequestPoliciesEnum =
  | 'promote';

export type ContractsContractVersionUpdate = {
  __typename?: 'ContractsContractVersionUpdate';
  field: Scalars['String'];
  newValue: Scalars['String'];
  oldValue?: Maybe<Scalars['String']>;
};

/** Employee activity */
export type ContractsEmployeeActivity = {
  __typename?: 'ContractsEmployeeActivity';
  activeDaysCount: Scalars['Int'];
  contractActivities: Array<ContractsContractActivity>;
  contractsCount: Scalars['Int'];
  currentYearActiveDaysCount: Scalars['Int'];
  employeeId: Scalars['Int'];
};

/** The connection type for ContractsEmployeeActivity. */
export type ContractsEmployeeActivityConnection = {
  __typename?: 'ContractsEmployeeActivityConnection';
  /** A list of edges. */
  edges: Array<ContractsEmployeeActivityEdge>;
  /** A list of nodes. */
  nodes: Array<ContractsEmployeeActivity>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ContractsEmployeeActivityEdge = {
  __typename?: 'ContractsEmployeeActivityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ContractsEmployeeActivity;
};

/** Fixed amount strategy for a additional compensation */
export type ContractsFixedAmountStrategy = {
  __typename?: 'ContractsFixedAmountStrategy';
  additionalCompensationId: Scalars['Int'];
  amount?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  unitName?: Maybe<Scalars['String']>;
};

/** The connection type for ContractsFixedAmountStrategy. */
export type ContractsFixedAmountStrategyConnection = {
  __typename?: 'ContractsFixedAmountStrategyConnection';
  /** A list of edges. */
  edges: Array<ContractsFixedAmountStrategyEdge>;
  /** A list of nodes. */
  nodes: Array<ContractsFixedAmountStrategy>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ContractsFixedAmountStrategyEdge = {
  __typename?: 'ContractsFixedAmountStrategyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ContractsFixedAmountStrategy;
};

/** Available contract types in France */
export type ContractsFrenchContractType = {
  __typename?: 'ContractsFrenchContractType';
  archivedAt?: Maybe<Scalars['ISO8601DateTime']>;
  contractsContractTemplateId?: Maybe<Scalars['Int']>;
  default?: Maybe<Scalars['Boolean']>;
  /** identifier for the contract type */
  id: Scalars['Int'];
  legalEntity?: Maybe<CompaniesLegalEntity>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  legalEntityId?: Maybe<Scalars['Int']>;
  /** Contract type name */
  name: Scalars['String'];
};


/** Available contract types in France */
export type ContractsFrenchContractTypeLegalEntityArgs = {
  companiesIds?: InputMaybe<Array<Scalars['Int']>>;
  countryIds?: InputMaybe<Array<Scalars['String']>>;
  employeesIds?: InputMaybe<Array<Scalars['Int']>>;
  excludeCountries?: InputMaybe<Array<Scalars['String']>>;
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};

/** The connection type for ContractsFrenchContractType. */
export type ContractsFrenchContractTypeConnection = {
  __typename?: 'ContractsFrenchContractTypeConnection';
  /** A list of edges. */
  edges: Array<ContractsFrenchContractTypeEdge>;
  /** A list of nodes. */
  nodes: Array<ContractsFrenchContractType>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ContractsFrenchContractTypeEdge = {
  __typename?: 'ContractsFrenchContractTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ContractsFrenchContractType;
};

/** French levels used in contracts */
export type ContractsFrenchLevel = {
  __typename?: 'ContractsFrenchLevel';
  archivedAt?: Maybe<Scalars['ISO8601DateTime']>;
  contractsContractTemplateId?: Maybe<Scalars['Int']>;
  default?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  legalEntity?: Maybe<CompaniesLegalEntity>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  legalEntityId?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
};


/** French levels used in contracts */
export type ContractsFrenchLevelLegalEntityArgs = {
  companiesIds?: InputMaybe<Array<Scalars['Int']>>;
  countryIds?: InputMaybe<Array<Scalars['String']>>;
  employeesIds?: InputMaybe<Array<Scalars['Int']>>;
  excludeCountries?: InputMaybe<Array<Scalars['String']>>;
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};

/** The connection type for ContractsFrenchLevel. */
export type ContractsFrenchLevelConnection = {
  __typename?: 'ContractsFrenchLevelConnection';
  /** A list of edges. */
  edges: Array<ContractsFrenchLevelEdge>;
  /** A list of nodes. */
  nodes: Array<ContractsFrenchLevel>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ContractsFrenchLevelEdge = {
  __typename?: 'ContractsFrenchLevelEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ContractsFrenchLevel;
};

/** French mutuals used in contracts */
export type ContractsFrenchMutual = {
  __typename?: 'ContractsFrenchMutual';
  archivedAt?: Maybe<Scalars['ISO8601DateTime']>;
  contractsContractTemplateId?: Maybe<Scalars['Int']>;
  default?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  legalEntity?: Maybe<CompaniesLegalEntity>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  legalEntityId?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
};


/** French mutuals used in contracts */
export type ContractsFrenchMutualLegalEntityArgs = {
  companiesIds?: InputMaybe<Array<Scalars['Int']>>;
  countryIds?: InputMaybe<Array<Scalars['String']>>;
  employeesIds?: InputMaybe<Array<Scalars['Int']>>;
  excludeCountries?: InputMaybe<Array<Scalars['String']>>;
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};

/** The connection type for ContractsFrenchMutual. */
export type ContractsFrenchMutualConnection = {
  __typename?: 'ContractsFrenchMutualConnection';
  /** A list of edges. */
  edges: Array<ContractsFrenchMutualEdge>;
  /** A list of nodes. */
  nodes: Array<ContractsFrenchMutual>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ContractsFrenchMutualEdge = {
  __typename?: 'ContractsFrenchMutualEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ContractsFrenchMutual;
};

/** French professional categories used in contracts */
export type ContractsFrenchProfessionalCategory = {
  __typename?: 'ContractsFrenchProfessionalCategory';
  archivedAt?: Maybe<Scalars['ISO8601DateTime']>;
  contractsContractTemplateId?: Maybe<Scalars['Int']>;
  default?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  legalEntity?: Maybe<CompaniesLegalEntity>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  legalEntityId?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
};


/** French professional categories used in contracts */
export type ContractsFrenchProfessionalCategoryLegalEntityArgs = {
  companiesIds?: InputMaybe<Array<Scalars['Int']>>;
  countryIds?: InputMaybe<Array<Scalars['String']>>;
  employeesIds?: InputMaybe<Array<Scalars['Int']>>;
  excludeCountries?: InputMaybe<Array<Scalars['String']>>;
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};

/** The connection type for ContractsFrenchProfessionalCategory. */
export type ContractsFrenchProfessionalCategoryConnection = {
  __typename?: 'ContractsFrenchProfessionalCategoryConnection';
  /** A list of edges. */
  edges: Array<ContractsFrenchProfessionalCategoryEdge>;
  /** A list of nodes. */
  nodes: Array<ContractsFrenchProfessionalCategory>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ContractsFrenchProfessionalCategoryEdge = {
  __typename?: 'ContractsFrenchProfessionalCategoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ContractsFrenchProfessionalCategory;
};

/** French steps used in contracts */
export type ContractsFrenchStep = {
  __typename?: 'ContractsFrenchStep';
  archivedAt?: Maybe<Scalars['ISO8601DateTime']>;
  contractsContractTemplateId?: Maybe<Scalars['Int']>;
  default?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  legalEntity?: Maybe<CompaniesLegalEntity>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  legalEntityId?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
};


/** French steps used in contracts */
export type ContractsFrenchStepLegalEntityArgs = {
  companiesIds?: InputMaybe<Array<Scalars['Int']>>;
  countryIds?: InputMaybe<Array<Scalars['String']>>;
  employeesIds?: InputMaybe<Array<Scalars['Int']>>;
  excludeCountries?: InputMaybe<Array<Scalars['String']>>;
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};

/** The connection type for ContractsFrenchStep. */
export type ContractsFrenchStepConnection = {
  __typename?: 'ContractsFrenchStepConnection';
  /** A list of edges. */
  edges: Array<ContractsFrenchStepEdge>;
  /** A list of nodes. */
  nodes: Array<ContractsFrenchStep>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ContractsFrenchStepEdge = {
  __typename?: 'ContractsFrenchStepEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ContractsFrenchStep;
};

/** French work types used in contracts */
export type ContractsFrenchWorkType = {
  __typename?: 'ContractsFrenchWorkType';
  archivedAt?: Maybe<Scalars['ISO8601DateTime']>;
  contractsContractTemplateId?: Maybe<Scalars['Int']>;
  default?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  legalEntity?: Maybe<CompaniesLegalEntity>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  legalEntityId?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
};


/** French work types used in contracts */
export type ContractsFrenchWorkTypeLegalEntityArgs = {
  companiesIds?: InputMaybe<Array<Scalars['Int']>>;
  countryIds?: InputMaybe<Array<Scalars['String']>>;
  employeesIds?: InputMaybe<Array<Scalars['Int']>>;
  excludeCountries?: InputMaybe<Array<Scalars['String']>>;
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};

/** The connection type for ContractsFrenchWorkType. */
export type ContractsFrenchWorkTypeConnection = {
  __typename?: 'ContractsFrenchWorkTypeConnection';
  /** A list of edges. */
  edges: Array<ContractsFrenchWorkTypeEdge>;
  /** A list of nodes. */
  nodes: Array<ContractsFrenchWorkType>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ContractsFrenchWorkTypeEdge = {
  __typename?: 'ContractsFrenchWorkTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ContractsFrenchWorkType;
};

/** Available contract types in Germany */
export type ContractsGermanContractType = {
  __typename?: 'ContractsGermanContractType';
  archivedAt?: Maybe<Scalars['ISO8601DateTime']>;
  contractsContractTemplateId?: Maybe<Scalars['Int']>;
  default?: Maybe<Scalars['Boolean']>;
  /** identifier for the contract type */
  id: Scalars['Int'];
  legalEntity?: Maybe<CompaniesLegalEntity>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  legalEntityId?: Maybe<Scalars['Int']>;
  /** Contract type name */
  name: Scalars['String'];
};


/** Available contract types in Germany */
export type ContractsGermanContractTypeLegalEntityArgs = {
  companiesIds?: InputMaybe<Array<Scalars['Int']>>;
  countryIds?: InputMaybe<Array<Scalars['String']>>;
  employeesIds?: InputMaybe<Array<Scalars['Int']>>;
  excludeCountries?: InputMaybe<Array<Scalars['String']>>;
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};

/** The connection type for ContractsGermanContractType. */
export type ContractsGermanContractTypeConnection = {
  __typename?: 'ContractsGermanContractTypeConnection';
  /** A list of edges. */
  edges: Array<ContractsGermanContractTypeEdge>;
  /** A list of nodes. */
  nodes: Array<ContractsGermanContractType>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ContractsGermanContractTypeEdge = {
  __typename?: 'ContractsGermanContractTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ContractsGermanContractType;
};

/** Headcount by month */
export type ContractsHeadcountCategorical = {
  __typename?: 'ContractsHeadcountCategorical';
  categories: Array<Scalars['String']>;
  series: Array<Scalars['Int']>;
};

/** The connection type for ContractsHeadcountCategorical. */
export type ContractsHeadcountCategoricalConnection = {
  __typename?: 'ContractsHeadcountCategoricalConnection';
  /** A list of edges. */
  edges: Array<ContractsHeadcountCategoricalEdge>;
  /** A list of nodes. */
  nodes: Array<ContractsHeadcountCategorical>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ContractsHeadcountCategoricalEdge = {
  __typename?: 'ContractsHeadcountCategoricalEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ContractsHeadcountCategorical;
};

export type ContractsImporterContextlessPolicies = {
  __typename?: 'ContractsImporterContextlessPolicies';
  contractsImporterImportContracts: ContextlessPolicyResolution;
};

/** Joiners Insights */
export type ContractsJoiner = {
  __typename?: 'ContractsJoiner';
  employeeIds: Array<Scalars['Int']>;
  endDate: Scalars['String'];
  joiners: Scalars['Int'];
  startDate: Scalars['String'];
};

/** The connection type for ContractsJoiner. */
export type ContractsJoinerConnection = {
  __typename?: 'ContractsJoinerConnection';
  /** A list of edges. */
  edges: Array<ContractsJoinerEdge>;
  /** A list of nodes. */
  nodes: Array<ContractsJoiner>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ContractsJoinerEdge = {
  __typename?: 'ContractsJoinerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ContractsJoiner;
};

/** Leavers Insights */
export type ContractsLeaver = {
  __typename?: 'ContractsLeaver';
  employeeIds: Array<Scalars['Int']>;
  endDate: Scalars['String'];
  leavers: Scalars['Int'];
  startDate: Scalars['String'];
};

/** The connection type for ContractsLeaver. */
export type ContractsLeaverConnection = {
  __typename?: 'ContractsLeaverConnection';
  /** A list of edges. */
  edges: Array<ContractsLeaverEdge>;
  /** A list of nodes. */
  nodes: Array<ContractsLeaver>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ContractsLeaverEdge = {
  __typename?: 'ContractsLeaverEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ContractsLeaver;
};

/** Headcount by month */
export type ContractsMonthlyHeadcount = {
  __typename?: 'ContractsMonthlyHeadcount';
  employeeIds: Array<Scalars['Int']>;
  endDate: Scalars['String'];
  headcount: Scalars['Int'];
  startDate: Scalars['String'];
};

/** The connection type for ContractsMonthlyHeadcount. */
export type ContractsMonthlyHeadcountConnection = {
  __typename?: 'ContractsMonthlyHeadcountConnection';
  /** A list of edges. */
  edges: Array<ContractsMonthlyHeadcountEdge>;
  /** A list of nodes. */
  nodes: Array<ContractsMonthlyHeadcount>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ContractsMonthlyHeadcountEdge = {
  __typename?: 'ContractsMonthlyHeadcountEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ContractsMonthlyHeadcount;
};

/** Contracts payroll policy */
export type ContractsPayrollPolicy = {
  __typename?: 'ContractsPayrollPolicy';
  contractVersionId: Scalars['Int'];
  id: Scalars['Int'];
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  payrollPolicyId: Scalars['Int'];
  policy?: Maybe<PayrollPolicy>;
};


/** Contracts payroll policy */
export type ContractsPayrollPolicyPolicyArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  default?: InputMaybe<Scalars['Boolean']>;
  includeArchived?: Scalars['Boolean'];
};

/** Contracts payroll policy assignment eligible employee */
export type ContractsPayrollPolicyAssignmentEligibleEmployee = {
  __typename?: 'ContractsPayrollPolicyAssignmentEligibleEmployee';
  employeeId: Scalars['Int'];
};

/** The connection type for ContractsPayrollPolicyAssignmentEligibleEmployee. */
export type ContractsPayrollPolicyAssignmentEligibleEmployeeConnection = {
  __typename?: 'ContractsPayrollPolicyAssignmentEligibleEmployeeConnection';
  /** A list of edges. */
  edges: Array<ContractsPayrollPolicyAssignmentEligibleEmployeeEdge>;
  /** A list of nodes. */
  nodes: Array<ContractsPayrollPolicyAssignmentEligibleEmployee>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ContractsPayrollPolicyAssignmentEligibleEmployeeEdge = {
  __typename?: 'ContractsPayrollPolicyAssignmentEligibleEmployeeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ContractsPayrollPolicyAssignmentEligibleEmployee;
};

/** The connection type for ContractsPayrollPolicy. */
export type ContractsPayrollPolicyConnection = {
  __typename?: 'ContractsPayrollPolicyConnection';
  /** A list of edges. */
  edges: Array<ContractsPayrollPolicyEdge>;
  /** A list of nodes. */
  nodes: Array<ContractsPayrollPolicy>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ContractsPayrollPolicyEdge = {
  __typename?: 'ContractsPayrollPolicyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ContractsPayrollPolicy;
};

/** Gets the employees on a contract Payroll policy */
export type ContractsPayrollPolicyEmployee = {
  __typename?: 'ContractsPayrollPolicyEmployee';
  contractVersion?: Maybe<ContractsContractVersion>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  contractVersionId: Scalars['Int'];
  employee?: Maybe<EmployeesEmployee>;
  employeeFirstName?: Maybe<Scalars['String']>;
  employeeFullName?: Maybe<Scalars['String']>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  employeeId: Scalars['Int'];
  employeeLastName?: Maybe<Scalars['String']>;
  payrollPolicy?: Maybe<PayrollPolicy>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  payrollPolicyId: Scalars['Int'];
};


/** Gets the employees on a contract Payroll policy */
export type ContractsPayrollPolicyEmployeeContractVersionArgs = {
  activeOn?: InputMaybe<Scalars['ISO8601Date']>;
  activeOrUpcomingOn?: InputMaybe<Scalars['ISO8601Date']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  contractIds?: InputMaybe<Array<Scalars['Int']>>;
  date?: InputMaybe<Scalars['ISO8601Date']>;
  effectiveOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  effectiveOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endsOnGt?: InputMaybe<Scalars['ISO8601Date']>;
  endsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  endsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  esEducationLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  forfaitJours?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  jobCatalogTreeNodeUuids?: InputMaybe<Array<Scalars['String']>>;
  levelIds?: InputMaybe<Array<Scalars['Int']>>;
  startsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  startsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  upcomingOn?: InputMaybe<Scalars['ISO8601Date']>;
  withFallback?: Scalars['Boolean'];
  withHasPayrollPolicies?: InputMaybe<Scalars['Boolean']>;
  withMetadata?: Scalars['Boolean'];
  withOldestEffectiveOn?: InputMaybe<Scalars['Boolean']>;
  withPayroll?: InputMaybe<Scalars['Boolean']>;
  withSalaryAmount?: InputMaybe<Scalars['Boolean']>;
  withoutSalaryAmountOrSalaryFrequency?: InputMaybe<Scalars['Boolean']>;
};


/** Gets the employees on a contract Payroll policy */
export type ContractsPayrollPolicyEmployeeEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Gets the employees on a contract Payroll policy */
export type ContractsPayrollPolicyEmployeePayrollPolicyArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  default?: InputMaybe<Scalars['Boolean']>;
  includeArchived?: Scalars['Boolean'];
};

/** The connection type for ContractsPayrollPolicyEmployee. */
export type ContractsPayrollPolicyEmployeeConnection = {
  __typename?: 'ContractsPayrollPolicyEmployeeConnection';
  /** A list of edges. */
  edges: Array<ContractsPayrollPolicyEmployeeEdge>;
  /** A list of nodes. */
  nodes: Array<ContractsPayrollPolicyEmployee>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ContractsPayrollPolicyEmployeeEdge = {
  __typename?: 'ContractsPayrollPolicyEmployeeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ContractsPayrollPolicyEmployee;
};

/** the filter for the payroll_policy_employees resource */
export type ContractsPayrollPolicyEmployeeFilter = {
  employeeId?: InputMaybe<IntegerFilter>;
  or?: InputMaybe<Array<ContractsPayrollPolicyEmployeeFilterConditions>>;
};

export type ContractsPayrollPolicyEmployeeFilterConditions = {
  employeeId?: InputMaybe<IntegerFilter>;
};

export type ContractsPeriod = {
  __typename?: 'ContractsPeriod';
  contractVersionId?: Maybe<Scalars['Int']>;
  from: Scalars['ISO8601Date'];
  schedule: ContractsValueObjectsContractScheduleEnum;
  to?: Maybe<Scalars['ISO8601Date']>;
  type: ContractsValueObjectsContractActivityGroupsTypeEnum;
};

/** Available contract types in Portugal */
export type ContractsPortugueseContractType = {
  __typename?: 'ContractsPortugueseContractType';
  archivedAt?: Maybe<Scalars['ISO8601DateTime']>;
  contractsContractTemplateId?: Maybe<Scalars['Int']>;
  default?: Maybe<Scalars['Boolean']>;
  /** identifier for the contract type */
  id: Scalars['Int'];
  legalEntityId?: Maybe<Scalars['Int']>;
  /** Contract type name */
  name: Scalars['String'];
};

/** The connection type for ContractsPortugueseContractType. */
export type ContractsPortugueseContractTypeConnection = {
  __typename?: 'ContractsPortugueseContractTypeConnection';
  /** A list of edges. */
  edges: Array<ContractsPortugueseContractTypeEdge>;
  /** A list of nodes. */
  nodes: Array<ContractsPortugueseContractType>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ContractsPortugueseContractTypeEdge = {
  __typename?: 'ContractsPortugueseContractTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ContractsPortugueseContractType;
};

/** Promotions Insights */
export type ContractsPromotion = {
  __typename?: 'ContractsPromotion';
  approved: Scalars['Int'];
  pending: Scalars['Int'];
  rejected: Scalars['Int'];
  team: Scalars['String'];
};

/** The connection type for ContractsPromotion. */
export type ContractsPromotionConnection = {
  __typename?: 'ContractsPromotionConnection';
  /** A list of edges. */
  edges: Array<ContractsPromotionEdge>;
  /** A list of nodes. */
  nodes: Array<ContractsPromotion>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ContractsPromotionEdge = {
  __typename?: 'ContractsPromotionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ContractsPromotion;
};

/** Manager's promotion insights */
export type ContractsPromotionEmployeeOverview = {
  __typename?: 'ContractsPromotionEmployeeOverview';
  promotionEmployees: Array<EmployeesEmployee>;
  promotionemployeesConnection: EmployeesEmployeeConnection;
  promotions: Array<Scalars['Int']>;
  promotionsDates: Array<Scalars['ISO8601Date']>;
  total: Scalars['Int'];
  totalLastYear: Scalars['Int'];
};


/** Manager's promotion insights */
export type ContractsPromotionEmployeeOverviewPromotionEmployeesArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Manager's promotion insights */
export type ContractsPromotionEmployeeOverviewPromotionemployeesConnectionArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  after?: InputMaybe<Scalars['String']>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Sort>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for ContractsPromotionEmployeeOverview. */
export type ContractsPromotionEmployeeOverviewConnection = {
  __typename?: 'ContractsPromotionEmployeeOverviewConnection';
  /** A list of edges. */
  edges: Array<ContractsPromotionEmployeeOverviewEdge>;
  /** A list of nodes. */
  nodes: Array<ContractsPromotionEmployeeOverview>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ContractsPromotionEmployeeOverviewEdge = {
  __typename?: 'ContractsPromotionEmployeeOverviewEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ContractsPromotionEmployeeOverview;
};

/** Promotions Stats Insights */
export type ContractsPromotionStat = {
  __typename?: 'ContractsPromotionStat';
  approvedPrevMonth: Scalars['Int'];
  requestedPrevMonth: Scalars['Int'];
};

/** The connection type for ContractsPromotionStat. */
export type ContractsPromotionStatConnection = {
  __typename?: 'ContractsPromotionStatConnection';
  /** A list of edges. */
  edges: Array<ContractsPromotionStatEdge>;
  /** A list of nodes. */
  nodes: Array<ContractsPromotionStat>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ContractsPromotionStatEdge = {
  __typename?: 'ContractsPromotionStatEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ContractsPromotionStat;
};

/** Promotions by month */
export type ContractsPromotionsByMonthCategorical = {
  __typename?: 'ContractsPromotionsByMonthCategorical';
  categories: Array<Scalars['String']>;
  series: Array<Scalars['Float']>;
};

/** The connection type for ContractsPromotionsByMonthCategorical. */
export type ContractsPromotionsByMonthCategoricalConnection = {
  __typename?: 'ContractsPromotionsByMonthCategoricalConnection';
  /** A list of edges. */
  edges: Array<ContractsPromotionsByMonthCategoricalEdge>;
  /** A list of nodes. */
  nodes: Array<ContractsPromotionsByMonthCategorical>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ContractsPromotionsByMonthCategoricalEdge = {
  __typename?: 'ContractsPromotionsByMonthCategoricalEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ContractsPromotionsByMonthCategorical;
};

/** Promotions dates */
export type ContractsPromotionsDate = {
  __typename?: 'ContractsPromotionsDate';
  approved: Scalars['Int'];
  approvedContractVersionsIds: Array<Scalars['Int']>;
  date: Scalars['ISO8601Date'];
  rejected: Scalars['Int'];
  running: Scalars['Int'];
};

/** The connection type for ContractsPromotionsDate. */
export type ContractsPromotionsDateConnection = {
  __typename?: 'ContractsPromotionsDateConnection';
  /** A list of edges. */
  edges: Array<ContractsPromotionsDateEdge>;
  /** A list of nodes. */
  nodes: Array<ContractsPromotionsDate>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ContractsPromotionsDateEdge = {
  __typename?: 'ContractsPromotionsDateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ContractsPromotionsDate;
};

/** Promotion single value */
export type ContractsPromotionsSingleValue = {
  __typename?: 'ContractsPromotionsSingleValue';
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  value: Scalars['Float'];
};

/** The connection type for ContractsPromotionsSingleValue. */
export type ContractsPromotionsSingleValueConnection = {
  __typename?: 'ContractsPromotionsSingleValueConnection';
  /** A list of edges. */
  edges: Array<ContractsPromotionsSingleValueEdge>;
  /** A list of nodes. */
  nodes: Array<ContractsPromotionsSingleValue>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ContractsPromotionsSingleValueEdge = {
  __typename?: 'ContractsPromotionsSingleValueEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ContractsPromotionsSingleValue;
};

/** Contracts reference contract */
export type ContractsReferenceContract = {
  __typename?: 'ContractsReferenceContract';
  _policies?: Maybe<ContractsReferenceContractPolicies>;
  _policiesCollection?: Maybe<Array<PermissionsPolicyResolution>>;
  _policiesConnection: PermissionsPolicyResolutionConnection;
  /**
   * Type of action that created this contract version (hire, promotion, amendment,
   * etc.). Used for audit trails and workflow tracking.
   */
  actionType?: Maybe<Scalars['String']>;
  additionalCompensations: Array<ContractsAdditionalCompensation>;
  additionalCompensationsConnection: ContractsAdditionalCompensationConnection;
  /**
   * Calculated daily working minutes adjusted for part-time percentage and annual
   * distribution. Derived field used for time tracking calculations.
   */
  adjustedDailyMinutes?: Maybe<Scalars['Int']>;
  /** Total number of workdays in the year based on working schedule and bank holidays. Used for annual hour limit calculations. */
  annualWorkdaysCount?: Maybe<Scalars['Int']>;
  /** Allows companies to define how annual working hours are spread across the year to ensure compliance with legal limits. */
  annualWorkingTimeDistribution?: Maybe<ContractsAnnualWorkingTimeDistributionEnum>;
  /** Type of action being approved (contract creation, modification, termination). Used in approval workflows. */
  approvalActionType?: Maybe<Scalars['String']>;
  /** User ID of the person who initiated the approval request for this contract change. */
  approvalAuthorId?: Maybe<Scalars['Int']>;
  /** Timestamp when the approval request was created. ISO 8601 format. Used for tracking approval timelines. */
  approvalRequestCreatedAt?: Maybe<Scalars['ISO8601Date']>;
  /** Array of user IDs who are/were approvers for this contract change. Used in approval workflows. */
  approversIds?: Maybe<Array<Scalars['Int']>>;
  /** Defines whether a bank holiday should be considered as a workable or non-workable day. */
  bankHolidayTreatment: ContractsBankHolidayTreatmentEnum;
  /** identifier for company. */
  companyId: Scalars['Int'];
  compensations: Array<ContractsCompensation>;
  compensationsConnection: ContractsCompensationConnection;
  contract?: Maybe<ContractsContract>;
  /**
   * ID of the parent contract containing this version. References
   * contracts.contract. Contracts have multiple versions over time.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  contractsContractId?: Maybe<Scalars['Int']>;
  /** the group of cotization of the employee. */
  contractsEsTariffGroupId?: Maybe<Scalars['Int']>;
  /** nationality country code of the employee (Spain ES, United Kingdom GB). */
  country?: Maybe<Scalars['String']>;
  /** the date the contract version was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** Avatar URL/ID of the user who created this contract version. Used for UI display. */
  createdByAvatar?: Maybe<Scalars['String']>;
  /** Name of the user who created this contract version. Denormalized for display purposes. */
  createdByName?: Maybe<Scalars['String']>;
  /** German activity type classification. Germany-specific field for categorizing the type of work performed. */
  deActivityType?: Maybe<Scalars['Int']>;
  /** contract type identifier. */
  deContractTypeId?: Maybe<Scalars['Int']>;
  /**
   * Denormalized display name for German contract type. Cached for performance.
   * Use de_contract_type_id for authoritative data.
   */
  deContractTypeName?: Maybe<Scalars['String']>;
  /** German employment type classification. Germany-specific field indicating the nature of employment relationship. */
  deEmploymentType?: Maybe<Scalars['Int']>;
  /** Whether German flat-rate taxation applies. Germany-specific flag for simplified tax calculation. */
  deFlatRateTax?: Maybe<Scalars['Int']>;
  /** German personal key group ID. Germany-specific identifier for payroll and social security classification. */
  dePersonalKeyGroupId?: Maybe<Scalars['Int']>;
  /**
   * Denormalized display name for German personal key group. Cached for
   * performance. Use de_personal_key_group_id for authoritative data.
   */
  dePersonalKeyGroupName?: Maybe<Scalars['String']>;
  /** the day the specific contract starts, in case of hiring the same than starts_on. */
  effectiveOn: Scalars['ISO8601Date'];
  employee: EmployeesEmployee;
  /**
   * employee identifier, refers to /employees/employees endpoint.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  employeeId: Scalars['Int'];
  /** the day the employee is terminated. It has nothing to do with trial period, these are concepts totally unrelated. */
  endsOn?: Maybe<Scalars['ISO8601Date']>;
  /** A3Innuva job position ID for payroll system integration. Spain-specific field for A3 payroll software. */
  esA3innuvaJobPositionId?: Maybe<Scalars['Int']>;
  /**
   * Denormalized display name for A3Innuva job position. Cached for performance.
   * Use es_a3innuva_job_position_id for authoritative data.
   */
  esA3innuvaJobPositionName?: Maybe<Scalars['String']>;
  /** Spanish collective agreement code ID. Spain-specific field referencing the applicable collective labor agreement. */
  esAgreementCodeId?: Maybe<Scalars['Int']>;
  /**
   * Denormalized display name for Spanish collective agreement. Cached for
   * performance. Use es_agreement_code_id for authoritative data.
   */
  esAgreementCodeName?: Maybe<Scalars['String']>;
  /** Spanish professional classification ID. Spain-specific field for categorizing employee's professional level. */
  esClassificationId?: Maybe<Scalars['Int']>;
  /**
   * Denormalized display name for Spanish professional classification. Cached for
   * performance. Use es_classification_id for authoritative data.
   */
  esClassificationName?: Maybe<Scalars['String']>;
  /**
   * Spanish CNO (National Occupation Classification) ID. Spain-specific
   * standardized occupation code for statistics and reporting.
   */
  esCnoOccupationId?: Maybe<Scalars['Int']>;
  /**
   * Denormalized display name for Spanish CNO occupation. Cached for performance.
   * Use es_cno_occupation_id for authoritative data.
   */
  esCnoOccupationName?: Maybe<Scalars['String']>;
  /** observations of the contract. */
  esContractObservations?: Maybe<Scalars['String']>;
  /** contract type identifier. */
  esContractTypeId?: Maybe<Scalars['Int']>;
  /**
   * Denormalized display name for Spanish contract type. Cached for performance.
   * Use es_contract_type_id for authoritative data.
   */
  esContractTypeName?: Maybe<Scalars['String']>;
  /** Spanish Social Security contribution type ID. Spain-specific field for social security classification. */
  esContributionTypeId?: Maybe<Scalars['Int']>;
  /**
   * Denormalized display name for Spanish contribution type. Cached for
   * performance. Use es_contribution_type_id for authoritative data.
   */
  esContributionTypeName?: Maybe<Scalars['String']>;
  /** the group of cotization of the employee. */
  esCotizationGroup?: Maybe<Scalars['Int']>;
  /** education level identifier. */
  esEducationLevelId?: Maybe<Scalars['Int']>;
  /**
   * Denormalized display name for Spanish education level. Cached for performance.
   * Use es_education_level_id for authoritative data.
   */
  esEducationLevelName?: Maybe<Scalars['String']>;
  /** flag that indicates if the contract has teleworking. */
  esHasTeleworkingContract?: Maybe<Scalars['Boolean']>;
  /** the job description of the employee. */
  esJobDescription?: Maybe<Scalars['String']>;
  /** Spanish occupation code ID. Spain-specific field for job classification in official registries. */
  esOccupationCodeId?: Maybe<Scalars['Int']>;
  /**
   * Denormalized display name for Spanish occupation code. Cached for performance.
   * Use es_occupation_code_id for authoritative data.
   */
  esOccupationCodeName?: Maybe<Scalars['String']>;
  /** professional category identifier. */
  esProfessionalCategoryId?: Maybe<Scalars['Int']>;
  /**
   * Denormalized display name for Spanish professional category. Cached for
   * performance. Use es_professional_category_id for authoritative data.
   */
  esProfessionalCategoryName?: Maybe<Scalars['String']>;
  /** Spanish Social Security regime ID. Spain-specific field indicating the social security system applicable to this contract. */
  esRegimeId?: Maybe<Scalars['Int']>;
  /**
   * Denormalized display name for Spanish social security regime. Cached for
   * performance. Use es_regime_id for authoritative data.
   */
  esRegimeName?: Maybe<Scalars['String']>;
  /** Spanish tariff group ID for social security contributions. Spain-specific field determining contribution rates. */
  esTariffGroupId?: Maybe<Scalars['Int']>;
  /** Denormalized display name for Spanish tariff group. Cached for performance. Use es_tariff_group_id for authoritative data. */
  esTariffGroupName?: Maybe<Scalars['String']>;
  /** working day type identifier. */
  esWorkingDayTypeId?: Maybe<Scalars['Int']>;
  /**
   * Denormalized display name for Spanish working day type. Cached for
   * performance. Use es_working_day_type_id for authoritative data.
   */
  esWorkingDayTypeName?: Maybe<Scalars['String']>;
  /** coefficient for france contracts. */
  frCoefficient?: Maybe<Scalars['String']>;
  /** contract type identifier. */
  frContractTypeId?: Maybe<Scalars['Int']>;
  /**
   * Denormalized display name for French contract type. Cached for performance.
   * Use fr_contract_type_id for authoritative data.
   */
  frContractTypeName?: Maybe<Scalars['String']>;
  /** employee type. */
  frEmployeeType?: Maybe<Scalars['String']>;
  /** flag that indicates if the employee is allowed to work within the framework of a fixed number of days. */
  frForfaitJours: Scalars['Boolean'];
  /** the number of days the employee is allowed to work. */
  frJoursParAn?: Maybe<Scalars['Int']>;
  /**
   * French annual working days in cents. For 218 days, value is 21800.
   * France-specific field with decimal precision for part-time calculations.
   */
  frJoursParAnCents?: Maybe<Scalars['Int']>;
  /** level identifier. */
  frLevelId?: Maybe<Scalars['Int']>;
  /** Denormalized display name for French level. Cached for performance. Use fr_level_id for authoritative data. */
  frLevelName?: Maybe<Scalars['String']>;
  /** mutual identifier. */
  frMutualId?: Maybe<Scalars['Int']>;
  /** Denormalized display name for French mutual insurance. Cached for performance. Use fr_mutual_id for authoritative data. */
  frMutualName?: Maybe<Scalars['String']>;
  /** professional category identifier. */
  frProfessionalCategoryId?: Maybe<Scalars['Int']>;
  /**
   * Denormalized display name for French professional category. Cached for
   * performance. Use fr_professional_category_id for authoritative data.
   */
  frProfessionalCategoryName?: Maybe<Scalars['String']>;
  /** step identifier. */
  frStepId?: Maybe<Scalars['Int']>;
  /** Denormalized display name for French step. Cached for performance. Use fr_step_id for authoritative data. */
  frStepName?: Maybe<Scalars['String']>;
  /** work type identifier. */
  frWorkTypeId?: Maybe<Scalars['Int']>;
  /** Denormalized display name for French work type. Cached for performance. Use fr_work_type_id for authoritative data. */
  frWorkTypeName?: Maybe<Scalars['String']>;
  /** boolean that indicates if the employee asociated to this contract belongs to a payroll policy. */
  hasPayroll: Scalars['Boolean'];
  /** Whether this contract has associated payroll policies. Indicates if payroll processing is configured for this contract. */
  hasPayrollPolicies?: Maybe<Scalars['Boolean']>;
  /** a flag that indicates if the contract version has ever had a trial period. */
  hasTrialPeriod?: Maybe<Scalars['Boolean']>;
  /** identifier for the contract version. */
  id?: Maybe<Scalars['Int']>;
  /** whether it is the reference contract today or not. It is important to remark that reference contract doesn't mean active */
  isReference?: Maybe<Scalars['Boolean']>;
  jobCatalogLevel?: Maybe<JobCatalogLevel>;
  /**
   * job catalog level identifier, refers to /job_catalog/levels endpoint.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  jobCatalogLevelId?: Maybe<Scalars['Int']>;
  /**
   * Denormalized/cached name of the job catalog level. Performance optimization.
   * For authoritative data, use job_catalog_level_id.
   */
  jobCatalogLevelName?: Maybe<Scalars['String']>;
  /**
   * Denormalized/cached name of the job catalog role. Performance optimization
   * field that may be slightly stale. For authoritative data, use
   * job_catalog_role_id.
   */
  jobCatalogRole?: Maybe<Scalars['String']>;
  /** Job catalog role identifier. Critical for 'Who is X role?' queries. References /job_catalog/roles endpoint. */
  jobCatalogRoleId?: Maybe<Scalars['Int']>;
  jobCatalogTreeLevel?: Maybe<JobCatalogTreeNode>;
  /**
   * the uuid node in the job catalog tree. For now it only supports level nodes.
   * From this point in the job catalog tree you can get the full ancestor path to
   * the root node including the role. Refer to job_catalog/tree_nodes endpoint.
   */
  jobCatalogTreeNodeUuid?: Maybe<Scalars['String']>;
  /** job title of the employee. */
  jobTitle?: Maybe<Scalars['String']>;
  /** the maximum amount of hours the employee can work in a year. */
  maxLegalYearlyHours?: Maybe<Scalars['Int']>;
  /** the maximum amount of days the employee can work in a row. */
  maxWorkDaysInRow?: Maybe<Scalars['Int']>;
  /** the maximum amount of minutes the employee can work in a day. */
  maxWorkMinutesPerDay?: Maybe<Scalars['Int']>;
  /** the maximum amount of hours the employee can work in a week. */
  maximumWeeklyHours?: Maybe<Scalars['Int']>;
  /** the minimum amount of hours the employee must rest in a row. */
  minRestHoursInRow?: Maybe<Scalars['Int']>;
  /** the minimum amount of minutes the employee must rest between working periods. */
  minRestMinutesBetweenDays?: Maybe<Scalars['Int']>;
  /**
   * Whether this is a part-time contract. True when
   * working_time_percentage_in_cents is less than 100%. Derived field for convenience.
   */
  partTime: Scalars['Boolean'];
  payrollPolicy?: Maybe<ContractsPayrollPolicy>;
  /** contract type identifier. */
  ptContractTypeId?: Maybe<Scalars['Int']>;
  /**
   * Denormalized display name for Portuguese contract type. Cached for
   * performance. Use pt_contract_type_id for authoritative data.
   */
  ptContractTypeName?: Maybe<Scalars['String']>;
  /** Details about the approval request for this contract change. Complex object containing request context and history. */
  requestDetails?: Maybe<Scalars['String']>;
  /** the amount of money the employee earns in cents. */
  salaryAmount?: Maybe<Scalars['BigInt']>;
  /** the frequency of the salary payment. */
  salaryFrequency?: Maybe<Scalars['String']>;
  /** the day the employee is hired. */
  startsOn?: Maybe<Scalars['ISO8601Date']>;
  /** Approval status of this contract version (pending, approved, rejected). Used in approval workflow systems. */
  status: Scalars['String'];
  /**
   * when the trial period ends. If there is no date, it means that the employee
   * has never been in trial. This date is not related with the end date of a contract.
   */
  trialPeriodEndsOn?: Maybe<Scalars['ISO8601Date']>;
  /** the date of the last contract version updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  /** the amount of hours the employee works. */
  workingHours?: Maybe<Scalars['Int']>;
  /** the frequency of the working hours. */
  workingHoursFrequency?: Maybe<Scalars['String']>;
  /**
   * Working time percentage in cents (e.g., when an employee is working part-time,
   * the percentage of full-time hours they are working).
   */
  workingTimePercentageInCents?: Maybe<Scalars['Int']>;
  /** the days of the week the employee works. */
  workingWeekDays?: Maybe<Scalars['String']>;
};


/** Contracts reference contract */
export type ContractsReferenceContract_PoliciesCollectionArgs = {
  ids: Array<ContractsReferenceContractPoliciesEnum>;
};


/** Contracts reference contract */
export type ContractsReferenceContract_PoliciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Contracts reference contract */
export type ContractsReferenceContractAdditionalCompensationsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Contracts reference contract */
export type ContractsReferenceContractAdditionalCompensationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Contracts reference contract */
export type ContractsReferenceContractCompensationsArgs = {
  calculation?: InputMaybe<Scalars['String']>;
  compensationTypes?: InputMaybe<Array<Scalars['String']>>;
  contractApprovalStatus?: InputMaybe<Array<Scalars['String']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  notIds?: InputMaybe<Array<Scalars['Int']>>;
  occurringAt?: InputMaybe<Scalars['ISO8601Date']>;
  occurringFrequency?: InputMaybe<Scalars['String']>;
  occursAt?: InputMaybe<Scalars['ISO8601Date']>;
  payrollPolicyId?: InputMaybe<Scalars['Int']>;
  syncWithSupplements?: InputMaybe<Scalars['Boolean']>;
};


/** Contracts reference contract */
export type ContractsReferenceContractCompensationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  calculation?: InputMaybe<Scalars['String']>;
  compensationTypes?: InputMaybe<Array<Scalars['String']>>;
  contractApprovalStatus?: InputMaybe<Array<Scalars['String']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  notIds?: InputMaybe<Array<Scalars['Int']>>;
  occurringAt?: InputMaybe<Scalars['ISO8601Date']>;
  occurringFrequency?: InputMaybe<Scalars['String']>;
  occursAt?: InputMaybe<Scalars['ISO8601Date']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  payrollPolicyId?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  syncWithSupplements?: InputMaybe<Scalars['Boolean']>;
};


/** Contracts reference contract */
export type ContractsReferenceContractContractArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  startsOn?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Contracts reference contract */
export type ContractsReferenceContractEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Contracts reference contract */
export type ContractsReferenceContractJobCatalogLevelArgs = {
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  includeArchived?: Scalars['Boolean'];
  includeArchivedRole?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  roleIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Contracts reference contract */
export type ContractsReferenceContractJobCatalogTreeLevelArgs = {
  ancestorIds?: InputMaybe<Array<Scalars['Int']>>;
  ancestorUuids?: InputMaybe<Array<Scalars['String']>>;
  attributeTypeIds?: InputMaybe<Array<Scalars['String']>>;
  attributeTypes?: InputMaybe<Array<JobCatalogEnumsJobCatalogTreeAttributeTypesEnum>>;
  id?: InputMaybe<Scalars['Int']>;
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  includeFullPath?: InputMaybe<Scalars['Boolean']>;
  nodeType?: InputMaybe<JobCatalogEnumsJobCatalogTreeNodeTypesEnum>;
  nodeUuids?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
};


/** Contracts reference contract */
export type ContractsReferenceContractPayrollPolicyArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  payrollPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
};

/** The connection type for ContractsReferenceContract. */
export type ContractsReferenceContractConnection = {
  __typename?: 'ContractsReferenceContractConnection';
  /** A list of edges. */
  edges: Array<ContractsReferenceContractEdge>;
  /** A list of nodes. */
  nodes: Array<ContractsReferenceContract>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ContractsReferenceContractEdge = {
  __typename?: 'ContractsReferenceContractEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ContractsReferenceContract;
};

export type ContractsReferenceContractPolicies = {
  __typename?: 'ContractsReferenceContractPolicies';
  delete: PermissionsPolicyResolution;
  edit: PermissionsPolicyResolution;
  promote: PermissionsPolicyResolution;
  seeAdditionalCompensation: PermissionsPolicyResolution;
  seeContractType: PermissionsPolicyResolution;
  seeEndDate: PermissionsPolicyResolution;
  seeExtraInfo: PermissionsPolicyResolution;
  seeGrossSalary: PermissionsPolicyResolution;
  seeJobTitle: PermissionsPolicyResolution;
  seePayrollPolicy: PermissionsPolicyResolution;
  seeStartDate: PermissionsPolicyResolution;
  seeTrialPeriod: PermissionsPolicyResolution;
  seeTrialPeriodEndDate: PermissionsPolicyResolution;
  seeWorkingDayType: PermissionsPolicyResolution;
  seeWorkingHours: PermissionsPolicyResolution;
};

export type ContractsReferenceContractPoliciesEnum =
  | 'delete'
  | 'edit'
  | 'promote'
  | 'see_additional_compensation'
  | 'see_contract_type'
  | 'see_end_date'
  | 'see_extra_info'
  | 'see_gross_salary'
  | 'see_job_title'
  | 'see_payroll_policy'
  | 'see_start_date'
  | 'see_trial_period'
  | 'see_trial_period_end_date'
  | 'see_working_day_type'
  | 'see_working_hours';

/** Contracts spanish a3innuva job position */
export type ContractsSpanishA3innuvaJobPosition = {
  __typename?: 'ContractsSpanishA3innuvaJobPosition';
  id: Scalars['Int'];
  legalEntityId: Scalars['Int'];
  name: Scalars['String'];
};

/** The connection type for ContractsSpanishA3innuvaJobPosition. */
export type ContractsSpanishA3innuvaJobPositionConnection = {
  __typename?: 'ContractsSpanishA3innuvaJobPositionConnection';
  /** A list of edges. */
  edges: Array<ContractsSpanishA3innuvaJobPositionEdge>;
  /** A list of nodes. */
  nodes: Array<ContractsSpanishA3innuvaJobPosition>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ContractsSpanishA3innuvaJobPositionEdge = {
  __typename?: 'ContractsSpanishA3innuvaJobPositionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ContractsSpanishA3innuvaJobPosition;
};

/** Contracts spanish agreement code */
export type ContractsSpanishAgreementCode = {
  __typename?: 'ContractsSpanishAgreementCode';
  id: Scalars['Int'];
  legalEntityId: Scalars['Int'];
  name: Scalars['String'];
};

/** The connection type for ContractsSpanishAgreementCode. */
export type ContractsSpanishAgreementCodeConnection = {
  __typename?: 'ContractsSpanishAgreementCodeConnection';
  /** A list of edges. */
  edges: Array<ContractsSpanishAgreementCodeEdge>;
  /** A list of nodes. */
  nodes: Array<ContractsSpanishAgreementCode>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ContractsSpanishAgreementCodeEdge = {
  __typename?: 'ContractsSpanishAgreementCodeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ContractsSpanishAgreementCode;
};

/** Contracts spanish classification */
export type ContractsSpanishClassification = {
  __typename?: 'ContractsSpanishClassification';
  id: Scalars['Int'];
  legalEntityId: Scalars['Int'];
  name: Scalars['String'];
};

/** The connection type for ContractsSpanishClassification. */
export type ContractsSpanishClassificationConnection = {
  __typename?: 'ContractsSpanishClassificationConnection';
  /** A list of edges. */
  edges: Array<ContractsSpanishClassificationEdge>;
  /** A list of nodes. */
  nodes: Array<ContractsSpanishClassification>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ContractsSpanishClassificationEdge = {
  __typename?: 'ContractsSpanishClassificationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ContractsSpanishClassification;
};

/** Contracts spanish cno occupation */
export type ContractsSpanishCnoOccupation = {
  __typename?: 'ContractsSpanishCnoOccupation';
  archivedAt?: Maybe<Scalars['ISO8601DateTime']>;
  default?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  legalEntityId: Scalars['Int'];
  name: Scalars['String'];
};

/** The connection type for ContractsSpanishCnoOccupation. */
export type ContractsSpanishCnoOccupationConnection = {
  __typename?: 'ContractsSpanishCnoOccupationConnection';
  /** A list of edges. */
  edges: Array<ContractsSpanishCnoOccupationEdge>;
  /** A list of nodes. */
  nodes: Array<ContractsSpanishCnoOccupation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ContractsSpanishCnoOccupationEdge = {
  __typename?: 'ContractsSpanishCnoOccupationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ContractsSpanishCnoOccupation;
};

/** Available contract types in Spain */
export type ContractsSpanishContractType = {
  __typename?: 'ContractsSpanishContractType';
  archivedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The contract template identifier. Refers to contracts/contract_templates. */
  contractsContractTemplateId?: Maybe<Scalars['Int']>;
  /** This contract type is a predefined one */
  default?: Maybe<Scalars['Boolean']>;
  /** identifier for the contract type */
  id: Scalars['Int'];
  legalEntity?: Maybe<CompaniesLegalEntity>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  legalEntityId?: Maybe<Scalars['Int']>;
  /** The name of the contract type */
  name: Scalars['String'];
};


/** Available contract types in Spain */
export type ContractsSpanishContractTypeLegalEntityArgs = {
  companiesIds?: InputMaybe<Array<Scalars['Int']>>;
  countryIds?: InputMaybe<Array<Scalars['String']>>;
  employeesIds?: InputMaybe<Array<Scalars['Int']>>;
  excludeCountries?: InputMaybe<Array<Scalars['String']>>;
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};

/** The connection type for ContractsSpanishContractType. */
export type ContractsSpanishContractTypeConnection = {
  __typename?: 'ContractsSpanishContractTypeConnection';
  /** A list of edges. */
  edges: Array<ContractsSpanishContractTypeEdge>;
  /** A list of nodes. */
  nodes: Array<ContractsSpanishContractType>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ContractsSpanishContractTypeEdge = {
  __typename?: 'ContractsSpanishContractTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ContractsSpanishContractType;
};

/** Contracts spanish contribution type */
export type ContractsSpanishContributionType = {
  __typename?: 'ContractsSpanishContributionType';
  archivedAt?: Maybe<Scalars['ISO8601DateTime']>;
  default?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  legalEntityId: Scalars['Int'];
  name: Scalars['String'];
};

/** The connection type for ContractsSpanishContributionType. */
export type ContractsSpanishContributionTypeConnection = {
  __typename?: 'ContractsSpanishContributionTypeConnection';
  /** A list of edges. */
  edges: Array<ContractsSpanishContributionTypeEdge>;
  /** A list of nodes. */
  nodes: Array<ContractsSpanishContributionType>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ContractsSpanishContributionTypeEdge = {
  __typename?: 'ContractsSpanishContributionTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ContractsSpanishContributionType;
};

/** Education Levels in Spain */
export type ContractsSpanishEducationLevel = {
  __typename?: 'ContractsSpanishEducationLevel';
  archivedAt?: Maybe<Scalars['ISO8601DateTime']>;
  contractVersion: Array<ContractsContractVersion>;
  /** Contract template identifier, refers to contracts/contract_templates */
  contractsContractTemplateId: Scalars['Int'];
  contractversionConnection: ContractsContractVersionConnection;
  /** Whether the education level is a predefined value */
  default?: Maybe<Scalars['Boolean']>;
  /** Education level identifier */
  id: Scalars['Int'];
  legalEntity?: Maybe<CompaniesLegalEntity>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  legalEntityId?: Maybe<Scalars['Int']>;
  /** education level name */
  name: Scalars['String'];
};


/** Education Levels in Spain */
export type ContractsSpanishEducationLevelContractVersionArgs = {
  activeOn?: InputMaybe<Scalars['ISO8601Date']>;
  activeOrUpcomingOn?: InputMaybe<Scalars['ISO8601Date']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  contractIds?: InputMaybe<Array<Scalars['Int']>>;
  date?: InputMaybe<Scalars['ISO8601Date']>;
  effectiveOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  effectiveOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endsOnGt?: InputMaybe<Scalars['ISO8601Date']>;
  endsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  endsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  forfaitJours?: Scalars['Boolean'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeDenormalizedData?: Scalars['Boolean'];
  jobCatalogTreeNodeUuids?: InputMaybe<Array<Scalars['String']>>;
  levelIds?: InputMaybe<Array<Scalars['Int']>>;
  startsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  startsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  upcomingOn?: InputMaybe<Scalars['ISO8601Date']>;
  withFallback?: Scalars['Boolean'];
  withHasPayrollPolicies?: InputMaybe<Scalars['Boolean']>;
  withMetadata?: Scalars['Boolean'];
  withOldestEffectiveOn?: InputMaybe<Scalars['Boolean']>;
  withPayroll?: InputMaybe<Scalars['Boolean']>;
  withSalaryAmount?: InputMaybe<Scalars['Boolean']>;
  withoutSalaryAmountOrSalaryFrequency?: InputMaybe<Scalars['Boolean']>;
};


/** Education Levels in Spain */
export type ContractsSpanishEducationLevelContractversionConnectionArgs = {
  activeOn?: InputMaybe<Scalars['ISO8601Date']>;
  activeOrUpcomingOn?: InputMaybe<Scalars['ISO8601Date']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  contractIds?: InputMaybe<Array<Scalars['Int']>>;
  date?: InputMaybe<Scalars['ISO8601Date']>;
  effectiveOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  effectiveOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endsOnGt?: InputMaybe<Scalars['ISO8601Date']>;
  endsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  endsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  first?: InputMaybe<Scalars['Int']>;
  forfaitJours?: Scalars['Boolean'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeDenormalizedData?: Scalars['Boolean'];
  jobCatalogTreeNodeUuids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  levelIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  startsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  upcomingOn?: InputMaybe<Scalars['ISO8601Date']>;
  withFallback?: Scalars['Boolean'];
  withHasPayrollPolicies?: InputMaybe<Scalars['Boolean']>;
  withMetadata?: Scalars['Boolean'];
  withOldestEffectiveOn?: InputMaybe<Scalars['Boolean']>;
  withPayroll?: InputMaybe<Scalars['Boolean']>;
  withSalaryAmount?: InputMaybe<Scalars['Boolean']>;
  withoutSalaryAmountOrSalaryFrequency?: InputMaybe<Scalars['Boolean']>;
};


/** Education Levels in Spain */
export type ContractsSpanishEducationLevelLegalEntityArgs = {
  companiesIds?: InputMaybe<Array<Scalars['Int']>>;
  countryIds?: InputMaybe<Array<Scalars['String']>>;
  employeesIds?: InputMaybe<Array<Scalars['Int']>>;
  excludeCountries?: InputMaybe<Array<Scalars['String']>>;
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};

/** The connection type for ContractsSpanishEducationLevel. */
export type ContractsSpanishEducationLevelConnection = {
  __typename?: 'ContractsSpanishEducationLevelConnection';
  /** A list of edges. */
  edges: Array<ContractsSpanishEducationLevelEdge>;
  /** A list of nodes. */
  nodes: Array<ContractsSpanishEducationLevel>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ContractsSpanishEducationLevelEdge = {
  __typename?: 'ContractsSpanishEducationLevelEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ContractsSpanishEducationLevel;
};

/** Contracts spanish occupation code */
export type ContractsSpanishOccupationCode = {
  __typename?: 'ContractsSpanishOccupationCode';
  id: Scalars['Int'];
  legalEntityId: Scalars['Int'];
  name: Scalars['String'];
};

/** The connection type for ContractsSpanishOccupationCode. */
export type ContractsSpanishOccupationCodeConnection = {
  __typename?: 'ContractsSpanishOccupationCodeConnection';
  /** A list of edges. */
  edges: Array<ContractsSpanishOccupationCodeEdge>;
  /** A list of nodes. */
  nodes: Array<ContractsSpanishOccupationCode>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ContractsSpanishOccupationCodeEdge = {
  __typename?: 'ContractsSpanishOccupationCodeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ContractsSpanishOccupationCode;
};

/** Spanish professional categories used in contracts */
export type ContractsSpanishProfessionalCategory = {
  __typename?: 'ContractsSpanishProfessionalCategory';
  archivedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Contract template identifier, refers to contracts/contract_templates */
  contractsContractTemplateId: Scalars['Int'];
  /** Whether the professional category is a predefined value */
  default?: Maybe<Scalars['Boolean']>;
  /** Professional category identifier */
  id: Scalars['Int'];
  legalEntity?: Maybe<CompaniesLegalEntity>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  legalEntityId?: Maybe<Scalars['Int']>;
  /** Professional category name */
  name: Scalars['String'];
};


/** Spanish professional categories used in contracts */
export type ContractsSpanishProfessionalCategoryLegalEntityArgs = {
  companiesIds?: InputMaybe<Array<Scalars['Int']>>;
  countryIds?: InputMaybe<Array<Scalars['String']>>;
  employeesIds?: InputMaybe<Array<Scalars['Int']>>;
  excludeCountries?: InputMaybe<Array<Scalars['String']>>;
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};

/** The connection type for ContractsSpanishProfessionalCategory. */
export type ContractsSpanishProfessionalCategoryConnection = {
  __typename?: 'ContractsSpanishProfessionalCategoryConnection';
  /** A list of edges. */
  edges: Array<ContractsSpanishProfessionalCategoryEdge>;
  /** A list of nodes. */
  nodes: Array<ContractsSpanishProfessionalCategory>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ContractsSpanishProfessionalCategoryEdge = {
  __typename?: 'ContractsSpanishProfessionalCategoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ContractsSpanishProfessionalCategory;
};

/** Contracts spanish regime */
export type ContractsSpanishRegime = {
  __typename?: 'ContractsSpanishRegime';
  id: Scalars['Int'];
  legalEntityId: Scalars['Int'];
  name: Scalars['String'];
};

/** The connection type for ContractsSpanishRegime. */
export type ContractsSpanishRegimeConnection = {
  __typename?: 'ContractsSpanishRegimeConnection';
  /** A list of edges. */
  edges: Array<ContractsSpanishRegimeEdge>;
  /** A list of nodes. */
  nodes: Array<ContractsSpanishRegime>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ContractsSpanishRegimeEdge = {
  __typename?: 'ContractsSpanishRegimeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ContractsSpanishRegime;
};

/** Spanish working day types used in contracts */
export type ContractsSpanishWorkingDayType = {
  __typename?: 'ContractsSpanishWorkingDayType';
  archivedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Contract template identifier, refers to contracts/contract_templates */
  contractsContractTemplateId?: Maybe<Scalars['Int']>;
  /** Whether the Working day type is a predefined value */
  default?: Maybe<Scalars['Boolean']>;
  /** Working day type identifier */
  id: Scalars['Int'];
  legalEntity?: Maybe<CompaniesLegalEntity>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  legalEntityId?: Maybe<Scalars['Int']>;
  /** Working day type name */
  name: Scalars['String'];
};


/** Spanish working day types used in contracts */
export type ContractsSpanishWorkingDayTypeLegalEntityArgs = {
  companiesIds?: InputMaybe<Array<Scalars['Int']>>;
  countryIds?: InputMaybe<Array<Scalars['String']>>;
  employeesIds?: InputMaybe<Array<Scalars['Int']>>;
  excludeCountries?: InputMaybe<Array<Scalars['String']>>;
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};

/** The connection type for ContractsSpanishWorkingDayType. */
export type ContractsSpanishWorkingDayTypeConnection = {
  __typename?: 'ContractsSpanishWorkingDayTypeConnection';
  /** A list of edges. */
  edges: Array<ContractsSpanishWorkingDayTypeEdge>;
  /** A list of nodes. */
  nodes: Array<ContractsSpanishWorkingDayType>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ContractsSpanishWorkingDayTypeEdge = {
  __typename?: 'ContractsSpanishWorkingDayTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ContractsSpanishWorkingDayType;
};

/** Contracts taxonomy */
export type ContractsTaxonomy = {
  __typename?: 'ContractsTaxonomy';
  archived: Scalars['Boolean'];
  default: Scalars['Boolean'];
  id: Scalars['Int'];
  legalEntityId: Scalars['Int'];
  name: Scalars['String'];
};

/** The connection type for ContractsTaxonomy. */
export type ContractsTaxonomyConnection = {
  __typename?: 'ContractsTaxonomyConnection';
  /** A list of edges. */
  edges: Array<ContractsTaxonomyEdge>;
  /** A list of nodes. */
  nodes: Array<ContractsTaxonomy>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ContractsTaxonomyEdge = {
  __typename?: 'ContractsTaxonomyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ContractsTaxonomy;
};

/** Possible kinds of terminations available */
export type ContractsTerminationType = {
  __typename?: 'ContractsTerminationType';
  country?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  employee: Array<EmployeesEmployee>;
  employeeConnection: EmployeesEmployeeConnection;
  id?: Maybe<Scalars['Int']>;
  isDeprecated: Scalars['Boolean'];
  slug: Scalars['String'];
  terminationReasonType?: Maybe<Scalars['String']>;
};


/** Possible kinds of terminations available */
export type ContractsTerminationTypeEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Possible kinds of terminations available */
export type ContractsTerminationTypeEmployeeConnectionArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  after?: InputMaybe<Scalars['String']>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Sort>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for ContractsTerminationType. */
export type ContractsTerminationTypeConnection = {
  __typename?: 'ContractsTerminationTypeConnection';
  /** A list of edges. */
  edges: Array<ContractsTerminationTypeEdge>;
  /** A list of nodes. */
  nodes: Array<ContractsTerminationType>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ContractsTerminationTypeEdge = {
  __typename?: 'ContractsTerminationTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ContractsTerminationType;
};

/** Contracts time balance */
export type ContractsTimeBalance = {
  __typename?: 'ContractsTimeBalance';
  /** Contract end date */
  contractEndDate?: Maybe<Scalars['ISO8601Date']>;
  /** Contract start date */
  contractStartDate?: Maybe<Scalars['ISO8601Date']>;
  /** Employee ID */
  employeeId: Scalars['Int'];
  /** Unique identifier for the time balance */
  id: Scalars['String'];
  /** Max range legal hours */
  maxRangeLegalHours?: Maybe<Scalars['Int']>;
  /** Max weekly legal hours */
  maxWeeklyLegalHours?: Maybe<Scalars['Int']>;
  /** Max yearly legal hours */
  maxYearlyLegalHours?: Maybe<Scalars['Int']>;
  /** Position */
  position?: Maybe<Scalars['String']>;
  /** Recommended yearly hours */
  recommendedYearlyHours?: Maybe<Scalars['Int']>;
};

/** The connection type for ContractsTimeBalance. */
export type ContractsTimeBalanceConnection = {
  __typename?: 'ContractsTimeBalanceConnection';
  /** A list of edges. */
  edges: Array<ContractsTimeBalanceEdge>;
  /** A list of nodes. */
  nodes: Array<ContractsTimeBalance>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ContractsTimeBalanceEdge = {
  __typename?: 'ContractsTimeBalanceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ContractsTimeBalance;
};

/** Turnover by month */
export type ContractsTurnoverCategorical = {
  __typename?: 'ContractsTurnoverCategorical';
  categories: Array<Scalars['String']>;
  series: Array<Scalars['Float']>;
};

/** The connection type for ContractsTurnoverCategorical. */
export type ContractsTurnoverCategoricalConnection = {
  __typename?: 'ContractsTurnoverCategoricalConnection';
  /** A list of edges. */
  edges: Array<ContractsTurnoverCategoricalEdge>;
  /** A list of nodes. */
  nodes: Array<ContractsTurnoverCategorical>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ContractsTurnoverCategoricalEdge = {
  __typename?: 'ContractsTurnoverCategoricalEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ContractsTurnoverCategorical;
};

/** Turnover Single Value */
export type ContractsTurnoverSingleValue = {
  __typename?: 'ContractsTurnoverSingleValue';
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  value: Scalars['Float'];
};

/** The connection type for ContractsTurnoverSingleValue. */
export type ContractsTurnoverSingleValueConnection = {
  __typename?: 'ContractsTurnoverSingleValueConnection';
  /** A list of edges. */
  edges: Array<ContractsTurnoverSingleValueEdge>;
  /** A list of nodes. */
  nodes: Array<ContractsTurnoverSingleValue>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ContractsTurnoverSingleValueEdge = {
  __typename?: 'ContractsTurnoverSingleValueEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ContractsTurnoverSingleValue;
};

export type ContractsValueObjectsAmountStrategyTypeEnum =
  | 'contracts_fixed_amount_strategy'
  | 'contracts_variable_amount_strategy';

export type ContractsValueObjectsContractActivityGroupsTypeEnum =
  | 'activity'
  | 'inactivity';

export type ContractsValueObjectsContractScheduleEnum =
  | 'expired'
  | 'ongoing'
  | 'upcoming';

export type ContractsValueObjectsTimeConditionEnum =
  | 'custom'
  | 'full_day'
  | 'half_day';

/** Variable amount strategy for a additional compensation */
export type ContractsVariableAmountStrategy = {
  __typename?: 'ContractsVariableAmountStrategy';
  additionalCompensationId: Scalars['Int'];
  amount?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  unitName?: Maybe<Scalars['String']>;
  upperLimit?: Maybe<Scalars['Int']>;
};

/** The connection type for ContractsVariableAmountStrategy. */
export type ContractsVariableAmountStrategyConnection = {
  __typename?: 'ContractsVariableAmountStrategyConnection';
  /** A list of edges. */
  edges: Array<ContractsVariableAmountStrategyEdge>;
  /** A list of nodes. */
  nodes: Array<ContractsVariableAmountStrategy>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ContractsVariableAmountStrategyEdge = {
  __typename?: 'ContractsVariableAmountStrategyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ContractsVariableAmountStrategy;
};

/** Weeks per month configuration */
export type ContractsWeeksPerMonthConfiguration = {
  __typename?: 'ContractsWeeksPerMonthConfiguration';
  id: Scalars['Int'];
  legalEntityId: Scalars['Int'];
  weeksPerMonth: ContractsWeeksPerMonthConfigurationOptionEnum;
};

/** The connection type for ContractsWeeksPerMonthConfiguration. */
export type ContractsWeeksPerMonthConfigurationConnection = {
  __typename?: 'ContractsWeeksPerMonthConfigurationConnection';
  /** A list of edges. */
  edges: Array<ContractsWeeksPerMonthConfigurationEdge>;
  /** A list of nodes. */
  nodes: Array<ContractsWeeksPerMonthConfiguration>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ContractsWeeksPerMonthConfigurationEdge = {
  __typename?: 'ContractsWeeksPerMonthConfigurationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ContractsWeeksPerMonthConfiguration;
};

export type ContractsWeeksPerMonthConfigurationOptionEnum =
  | 'days_in_a_year_based'
  | 'weeks_in_a_year_based';

/** Autogenerated return type of ConvertFinanceMoney. */
export type ConvertFinanceMoneyPayload = {
  __typename?: 'ConvertFinanceMoneyPayload';
  errors: Array<MutationError>;
  money?: Maybe<FinanceMoney>;
};

/** Autogenerated return type of ConvertToInvoiceFinanceQuote. */
export type ConvertToInvoiceFinanceQuotePayload = {
  __typename?: 'ConvertToInvoiceFinanceQuotePayload';
  errors: Array<MutationError>;
  quote?: Maybe<FinanceQuote>;
};

/** Autogenerated return type of ConvertToProjectFinanceQuote. */
export type ConvertToProjectFinanceQuotePayload = {
  __typename?: 'ConvertToProjectFinanceQuotePayload';
  errors: Array<MutationError>;
  quote?: Maybe<FinanceQuote>;
};

/** Autogenerated return type of CopyTasksTask. */
export type CopyTasksTaskPayload = {
  __typename?: 'CopyTasksTaskPayload';
  errors: Array<MutationError>;
  task?: Maybe<TasksTask>;
};

/** Cost center allocations */
export type CostCentersAllocation = {
  __typename?: 'CostCentersAllocation';
  id: Scalars['Int'];
  referenceId: Scalars['Int'];
  referenceType: Scalars['String'];
  resourceId: Scalars['Int'];
  resourceType: Scalars['String'];
};

/** The connection type for CostCentersAllocation. */
export type CostCentersAllocationConnection = {
  __typename?: 'CostCentersAllocationConnection';
  /** A list of edges. */
  edges: Array<CostCentersAllocationEdge>;
  /** A list of nodes. */
  nodes: Array<CostCentersAllocation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CostCentersAllocationEdge = {
  __typename?: 'CostCentersAllocationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CostCentersAllocation;
};

/** Cost center assignments */
export type CostCentersAssignment = {
  __typename?: 'CostCentersAssignment';
  costCenter: CostCentersCostCenter;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  costCenterId: Scalars['Int'];
  endDate?: Maybe<Scalars['ISO8601Date']>;
  id: Scalars['Int'];
  percentage: Scalars['Float'];
  resourceId: Scalars['Int'];
  resourceType: Scalars['String'];
  startDate: Scalars['ISO8601Date'];
};


/** Cost center assignments */
export type CostCentersAssignmentCostCenterArgs = {
  activesOnDate?: InputMaybe<Scalars['ISO8601Date']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityMissingAssignmentsFor?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<CostCentersValueObjectsCostCenterStatusEnum>>;
};

/** The connection type for CostCentersAssignment. */
export type CostCentersAssignmentConnection = {
  __typename?: 'CostCentersAssignmentConnection';
  /** A list of edges. */
  edges: Array<CostCentersAssignmentEdge>;
  /** A list of nodes. */
  nodes: Array<CostCentersAssignment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CostCentersAssignmentEdge = {
  __typename?: 'CostCentersAssignmentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CostCentersAssignment;
};

/** Cost center configurations */
export type CostCentersConfiguration = {
  __typename?: 'CostCentersConfiguration';
  company: ApiCoreCompany;
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['Int'];
  processedAt?: Maybe<Scalars['ISO8601DateTime']>;
  processingStatus: CostCentersValueObjectsProcessingStatusEnum;
  structure: CostCentersValueObjectsStructureEnum;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for CostCentersConfiguration. */
export type CostCentersConfigurationConnection = {
  __typename?: 'CostCentersConfigurationConnection';
  /** A list of edges. */
  edges: Array<CostCentersConfigurationEdge>;
  /** A list of nodes. */
  nodes: Array<CostCentersConfiguration>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CostCentersConfigurationEdge = {
  __typename?: 'CostCentersConfigurationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CostCentersConfiguration;
};

/** the filter for the configurations resource */
export type CostCentersConfigurationFilter = {
  or?: InputMaybe<Array<CostCentersConfigurationFilterConditions>>;
  processingStatus?: InputMaybe<StringFilter>;
  structure?: InputMaybe<StringFilter>;
};

export type CostCentersConfigurationFilterConditions = {
  processingStatus?: InputMaybe<StringFilter>;
  structure?: InputMaybe<StringFilter>;
};

export type CostCentersContextlessPolicies = {
  __typename?: 'CostCentersContextlessPolicies';
  costCentersManageCostCenters: ContextlessPolicyResolution;
  costCentersSeeCostCenters: ContextlessPolicyResolution;
  featuresCostCenterManagement: ContextlessPolicyResolution;
};

/** Cost centers */
export type CostCentersCostCenter = {
  __typename?: 'CostCentersCostCenter';
  assignments: Array<CostCentersAssignment>;
  assignmentsConnection: CostCentersAssignmentConnection;
  code?: Maybe<Scalars['String']>;
  company: ApiCoreCompany;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  companyId: Scalars['Int'];
  deactivationDate?: Maybe<Scalars['ISO8601Date']>;
  description?: Maybe<Scalars['String']>;
  hasAssignments?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  legalEntity?: Maybe<CompaniesLegalEntity>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  legalEntityId?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  status: CostCentersValueObjectsCostCenterStatusEnum;
};


/** Cost centers */
export type CostCentersCostCenterAssignmentsArgs = {
  activeOn?: InputMaybe<Scalars['ISO8601Date']>;
  applyingOn?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyNextUpcoming?: InputMaybe<Scalars['Boolean']>;
  resourceIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceType?: InputMaybe<Scalars['String']>;
};


/** Cost centers */
export type CostCentersCostCenterAssignmentsConnectionArgs = {
  activeOn?: InputMaybe<Scalars['ISO8601Date']>;
  after?: InputMaybe<Scalars['String']>;
  applyingOn?: InputMaybe<Scalars['ISO8601Date']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyNextUpcoming?: InputMaybe<Scalars['Boolean']>;
  resourceIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceType?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Cost centers */
export type CostCentersCostCenterLegalEntityArgs = {
  companiesIds?: InputMaybe<Array<Scalars['Int']>>;
  countryIds?: InputMaybe<Array<Scalars['String']>>;
  employeesIds?: InputMaybe<Array<Scalars['Int']>>;
  excludeCountries?: InputMaybe<Array<Scalars['String']>>;
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};

/** The connection type for CostCentersCostCenter. */
export type CostCentersCostCenterConnection = {
  __typename?: 'CostCentersCostCenterConnection';
  /** A list of edges. */
  edges: Array<CostCentersCostCenterEdge>;
  /** A list of nodes. */
  nodes: Array<CostCentersCostCenter>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CostCentersCostCenterEdge = {
  __typename?: 'CostCentersCostCenterEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CostCentersCostCenter;
};

/** the filter for the cost_centers resource */
export type CostCentersCostCenterFilter = {
  code?: InputMaybe<StringFilter>;
  legalEntityId?: InputMaybe<IntegerFilter>;
  name?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<CostCentersCostCenterFilterConditions>>;
};

export type CostCentersCostCenterFilterConditions = {
  code?: InputMaybe<StringFilter>;
  legalEntityId?: InputMaybe<IntegerFilter>;
  name?: InputMaybe<StringFilter>;
};

/** Cost center distributions */
export type CostCentersDistribution = {
  __typename?: 'CostCentersDistribution';
  allocationId?: Maybe<Scalars['Int']>;
  allocationReferenceId?: Maybe<Scalars['Int']>;
  allocationReferenceType?: Maybe<Scalars['String']>;
  assignmentId: Scalars['Int'];
  costCenter: CostCentersCostCenter;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  costCenterId: Scalars['Int'];
  percentage: Scalars['Float'];
  resourceId: Scalars['Int'];
  resourceType: Scalars['String'];
};


/** Cost center distributions */
export type CostCentersDistributionCostCenterArgs = {
  activesOnDate?: InputMaybe<Scalars['ISO8601Date']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityMissingAssignmentsFor?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<CostCentersValueObjectsCostCenterStatusEnum>>;
};

/** The connection type for CostCentersDistribution. */
export type CostCentersDistributionConnection = {
  __typename?: 'CostCentersDistributionConnection';
  /** A list of edges. */
  edges: Array<CostCentersDistributionEdge>;
  /** A list of nodes. */
  nodes: Array<CostCentersDistribution>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CostCentersDistributionEdge = {
  __typename?: 'CostCentersDistributionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CostCentersDistribution;
};

/** Legal entities without resource assignments */
export type CostCentersUndistributedLegalEntity = {
  __typename?: 'CostCentersUndistributedLegalEntity';
  id: Scalars['Int'];
  legalName: Scalars['String'];
  remaining: Scalars['Int'];
};

/** The connection type for CostCentersUndistributedLegalEntity. */
export type CostCentersUndistributedLegalEntityConnection = {
  __typename?: 'CostCentersUndistributedLegalEntityConnection';
  /** A list of edges. */
  edges: Array<CostCentersUndistributedLegalEntityEdge>;
  /** A list of nodes. */
  nodes: Array<CostCentersUndistributedLegalEntity>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CostCentersUndistributedLegalEntityEdge = {
  __typename?: 'CostCentersUndistributedLegalEntityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CostCentersUndistributedLegalEntity;
};

export type CostCentersValueObjectsCostCenterStatusEnum =
  | 'active'
  | 'inactive';

export type CostCentersValueObjectsProcessingStatusEnum =
  | 'completed'
  | 'failed'
  | 'pending'
  | 'processing';

export type CostCentersValueObjectsStructureEnum =
  | 'job_catalog_family'
  | 'job_catalog_function'
  | 'job_catalog_role'
  | 'workplace';

/** Autogenerated return type of CountPostsPost. */
export type CountPostsPostPayload = {
  __typename?: 'CountPostsPostPayload';
  errors: Array<MutationError>;
  post?: Maybe<PostsPost>;
};

/** Autogenerated return type of CreateAnalyticsReport. */
export type CreateAnalyticsReportPayload = {
  __typename?: 'CreateAnalyticsReportPayload';
  errors: Array<MutationError>;
  report?: Maybe<AnalyticsReport>;
};

/** Autogenerated return type of CreateApicoreAccess. */
export type CreateApicoreAccessPayload = {
  __typename?: 'CreateApicoreAccessPayload';
  access?: Maybe<ApiCoreAccess>;
  errors: Array<MutationError>;
};

export type CreateApprovalsApprovalFlowApproversInput = {
  accessId?: InputMaybe<Scalars['Int']>;
  groupableId?: InputMaybe<Scalars['Int']>;
  groupableType?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  strategy: Scalars['String'];
};

/** Autogenerated return type of CreateApprovalsApprovalFlow. */
export type CreateApprovalsApprovalFlowPayload = {
  __typename?: 'CreateApprovalsApprovalFlowPayload';
  approvalFlow?: Maybe<ApprovalsApprovalFlow>;
  errors: Array<MutationError>;
};

export type CreateApprovalsApprovalFlowStepsInput = {
  approverIdsToBeDeleted?: InputMaybe<Array<Scalars['Int']>>;
  approvers: Array<CreateApprovalsApprovalFlowApproversInput>;
  id?: InputMaybe<Scalars['Int']>;
  position: Scalars['Int'];
  strategy?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of CreateApprovalsApprovalGroup. */
export type CreateApprovalsApprovalGroupPayload = {
  __typename?: 'CreateApprovalsApprovalGroupPayload';
  approvalGroup?: Maybe<ApprovalsApprovalGroup>;
  errors: Array<MutationError>;
};

export type CreateApprovalsRulesConfigurationApprovalFlowInput = {
  approvalGroupId?: InputMaybe<Scalars['Int']>;
  default: Scalars['Boolean'];
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  onApprovalFlowChange?: InputMaybe<ApprovalsApprovalFlowOnApprovalFlowChangeEnum>;
  stepIdsToBeDeleted: Array<Scalars['Int']>;
  steps: Array<CreateApprovalsRulesConfigurationStepsInput>;
};

export type CreateApprovalsRulesConfigurationApproversInput = {
  accessId?: InputMaybe<Scalars['Int']>;
  groupableId?: InputMaybe<Scalars['Int']>;
  groupableType?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  strategy: Scalars['String'];
};

/** Autogenerated return type of CreateApprovalsRulesConfiguration. */
export type CreateApprovalsRulesConfigurationPayload = {
  __typename?: 'CreateApprovalsRulesConfigurationPayload';
  errors: Array<MutationError>;
  rulesConfiguration?: Maybe<ApprovalsRulesConfiguration>;
};

export type CreateApprovalsRulesConfigurationRulesInput = {
  identifier: Scalars['String'];
  inputType: ApprovalsDomainConfigurationInputTypeEnum;
  label: Scalars['String'];
  operation: ApprovalsDomainConfigurationOperationsEnum;
  value: Array<Scalars['String']>;
};

export type CreateApprovalsRulesConfigurationStepsInput = {
  approverIdsToBeDeleted?: InputMaybe<Array<Scalars['Int']>>;
  approvers: Array<CreateApprovalsRulesConfigurationApproversInput>;
  id?: InputMaybe<Scalars['Int']>;
  position: Scalars['Int'];
  strategy?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of CreateAtsAnswer. */
export type CreateAtsAnswerPayload = {
  __typename?: 'CreateAtsAnswerPayload';
  answer?: Maybe<AtsAnswer>;
  errors: Array<MutationError>;
};

export type CreateAtsApplicationAnswersInput = {
  atsQuestionId: Scalars['Int'];
};

/** Autogenerated return type of CreateAtsApplicationParticipant. */
export type CreateAtsApplicationParticipantPayload = {
  __typename?: 'CreateAtsApplicationParticipantPayload';
  applicationParticipant?: Maybe<AtsApplicationParticipant>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateAtsApplication. */
export type CreateAtsApplicationPayload = {
  __typename?: 'CreateAtsApplicationPayload';
  application?: Maybe<AtsApplication>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateAtsApplicationPhase. */
export type CreateAtsApplicationPhasePayload = {
  __typename?: 'CreateAtsApplicationPhasePayload';
  applicationPhase?: Maybe<AtsApplicationPhase>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateAtsAssessment. */
export type CreateAtsAssessmentPayload = {
  __typename?: 'CreateAtsAssessmentPayload';
  assessment?: Maybe<AtsAssessment>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateAtsCandidateDuplicatesIdentification. */
export type CreateAtsCandidateDuplicatesIdentificationPayload = {
  __typename?: 'CreateAtsCandidateDuplicatesIdentificationPayload';
  candidateDuplicatesIdentification?: Maybe<AtsCandidateDuplicatesIdentification>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateAtsCandidateEmailAction. */
export type CreateAtsCandidateEmailActionPayload = {
  __typename?: 'CreateAtsCandidateEmailActionPayload';
  candidateEmailAction?: Maybe<AtsCandidateEmailAction>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateAtsCandidateImport. */
export type CreateAtsCandidateImportPayload = {
  __typename?: 'CreateAtsCandidateImportPayload';
  candidateImport?: Maybe<AtsCandidateImport>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateAtsCandidate. */
export type CreateAtsCandidatePayload = {
  __typename?: 'CreateAtsCandidatePayload';
  candidate?: Maybe<AtsCandidate>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateAtsCandidateSource. */
export type CreateAtsCandidateSourcePayload = {
  __typename?: 'CreateAtsCandidateSourcePayload';
  candidateSource?: Maybe<AtsCandidateSource>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateAtsCvBulkUpload. */
export type CreateAtsCvBulkUploadPayload = {
  __typename?: 'CreateAtsCvBulkUploadPayload';
  cvBulkUpload?: Maybe<AtsCvBulkUpload>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateAtsEvaluationForm. */
export type CreateAtsEvaluationFormPayload = {
  __typename?: 'CreateAtsEvaluationFormPayload';
  errors: Array<MutationError>;
  evaluationForm?: Maybe<AtsEvaluationForm>;
};

/** Autogenerated return type of CreateAtsFavouriteJobPosting. */
export type CreateAtsFavouriteJobPostingPayload = {
  __typename?: 'CreateAtsFavouriteJobPostingPayload';
  errors: Array<MutationError>;
  favouriteJobPosting?: Maybe<AtsFavouriteJobPosting>;
};

export type CreateAtsFeedbackEvaluationFormAnswersInput = {
  note?: InputMaybe<Scalars['String']>;
  questionId: Scalars['String'];
  score: Scalars['Int'];
};

/** Autogenerated return type of CreateAtsFeedback. */
export type CreateAtsFeedbackPayload = {
  __typename?: 'CreateAtsFeedbackPayload';
  errors: Array<MutationError>;
  feedback?: Maybe<AtsFeedback>;
};

/** Autogenerated return type of CreateAtsHiringManager. */
export type CreateAtsHiringManagerPayload = {
  __typename?: 'CreateAtsHiringManagerPayload';
  errors: Array<MutationError>;
  hiringManager?: Maybe<AtsHiringManager>;
};

/** Autogenerated return type of CreateAtsHiringPhase. */
export type CreateAtsHiringPhasePayload = {
  __typename?: 'CreateAtsHiringPhasePayload';
  errors: Array<MutationError>;
  hiringPhase?: Maybe<AtsHiringPhase>;
};

/** Autogenerated return type of CreateAtsHiringStage. */
export type CreateAtsHiringStagePayload = {
  __typename?: 'CreateAtsHiringStagePayload';
  errors: Array<MutationError>;
  hiringStage?: Maybe<AtsHiringStage>;
};

/** Autogenerated return type of CreateAtsIntegration. */
export type CreateAtsIntegrationPayload = {
  __typename?: 'CreateAtsIntegrationPayload';
  errors: Array<MutationError>;
  integration?: Maybe<AtsIntegration>;
};

/** Autogenerated return type of CreateAtsInterview. */
export type CreateAtsInterviewPayload = {
  __typename?: 'CreateAtsInterviewPayload';
  errors: Array<MutationError>;
  interview?: Maybe<AtsInterview>;
};

/** Autogenerated return type of CreateAtsJobPosting. */
export type CreateAtsJobPostingPayload = {
  __typename?: 'CreateAtsJobPostingPayload';
  errors: Array<MutationError>;
  jobPosting?: Maybe<AtsJobPosting>;
};

/** Autogenerated return type of CreateAtsMessage. */
export type CreateAtsMessagePayload = {
  __typename?: 'CreateAtsMessagePayload';
  errors: Array<MutationError>;
  message?: Maybe<AtsMessage>;
};

/** Autogenerated return type of CreateAtsMessageTemplate. */
export type CreateAtsMessageTemplatePayload = {
  __typename?: 'CreateAtsMessageTemplatePayload';
  errors: Array<MutationError>;
  messageTemplate?: Maybe<AtsMessageTemplate>;
};

/** Autogenerated return type of CreateAtsOfferLetter. */
export type CreateAtsOfferLetterPayload = {
  __typename?: 'CreateAtsOfferLetterPayload';
  errors: Array<MutationError>;
  offerLetter?: Maybe<AtsOfferLetter>;
};

/** Autogenerated return type of CreateAtsOfferLetterTemplate. */
export type CreateAtsOfferLetterTemplatePayload = {
  __typename?: 'CreateAtsOfferLetterTemplatePayload';
  errors: Array<MutationError>;
  offerLetterTemplate?: Maybe<AtsOfferLetterTemplate>;
};

/** Autogenerated return type of CreateAtsOpenApplicationSetting. */
export type CreateAtsOpenApplicationSettingPayload = {
  __typename?: 'CreateAtsOpenApplicationSettingPayload';
  errors: Array<MutationError>;
  openApplicationSetting?: Maybe<AtsOpenApplicationSetting>;
};

/** Autogenerated return type of CreateAtsQuestion. */
export type CreateAtsQuestionPayload = {
  __typename?: 'CreateAtsQuestionPayload';
  errors: Array<MutationError>;
  question?: Maybe<AtsQuestion>;
};

/** Autogenerated return type of CreateAtsQuestionTemplate. */
export type CreateAtsQuestionTemplatePayload = {
  __typename?: 'CreateAtsQuestionTemplatePayload';
  errors: Array<MutationError>;
  questionTemplate?: Maybe<AtsQuestionTemplate>;
};

/** Autogenerated return type of CreateAtsReferral. */
export type CreateAtsReferralPayload = {
  __typename?: 'CreateAtsReferralPayload';
  errors: Array<MutationError>;
  referral?: Maybe<AtsReferral>;
};

/** Autogenerated return type of CreateAtsRejectionReason. */
export type CreateAtsRejectionReasonPayload = {
  __typename?: 'CreateAtsRejectionReasonPayload';
  errors: Array<MutationError>;
  rejectionReason?: Maybe<AtsRejectionReason>;
};

/** Autogenerated return type of CreateAtsRequisition. */
export type CreateAtsRequisitionPayload = {
  __typename?: 'CreateAtsRequisitionPayload';
  errors: Array<MutationError>;
  requisition?: Maybe<AtsRequisition>;
};

/** Autogenerated return type of CreateAtsTag. */
export type CreateAtsTagPayload = {
  __typename?: 'CreateAtsTagPayload';
  errors: Array<MutationError>;
  tag?: Maybe<AtsTag>;
};

/** Autogenerated return type of CreateAtsVonqClientToken. */
export type CreateAtsVonqClientTokenPayload = {
  __typename?: 'CreateAtsVonqClientTokenPayload';
  errors: Array<MutationError>;
  vonqClientToken?: Maybe<AtsVonqClientToken>;
};

/** Autogenerated return type of CreateAttendanceBalanceCarryover. */
export type CreateAttendanceBalanceCarryoverPayload = {
  __typename?: 'CreateAttendanceBalanceCarryoverPayload';
  balanceCarryover?: Maybe<AttendanceBalanceCarryover>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateAttendanceBreakConfiguration. */
export type CreateAttendanceBreakConfigurationPayload = {
  __typename?: 'CreateAttendanceBreakConfigurationPayload';
  breakConfiguration?: Maybe<AttendanceBreakConfiguration>;
  errors: Array<MutationError>;
};

export type CreateAttendanceBreakSettingAutomaticBreakRulesAttributesInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  breakDuration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  periodLength?: InputMaybe<Scalars['Int']>;
  timeSettingsBreakConfigurationId?: InputMaybe<Scalars['Int']>;
};

export type CreateAttendanceBreakSettingDurationRulesAttributesInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  minimalDuration?: InputMaybe<Scalars['Int']>;
  periodLength?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of CreateAttendanceBreakSetting. */
export type CreateAttendanceBreakSettingPayload = {
  __typename?: 'CreateAttendanceBreakSettingPayload';
  breakSetting?: Maybe<AttendanceBreakSetting>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateAttendanceCompanySettingsVersion. */
export type CreateAttendanceCompanySettingsVersionPayload = {
  __typename?: 'CreateAttendanceCompanySettingsVersionPayload';
  companySettingsVersion?: Maybe<AttendanceCompanySettingsVersion>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateAttendanceCustomTimeRangeCategory. */
export type CreateAttendanceCustomTimeRangeCategoryPayload = {
  __typename?: 'CreateAttendanceCustomTimeRangeCategoryPayload';
  customTimeRangeCategory?: Maybe<AttendanceCustomTimeRangeCategory>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateAttendanceEditTimesheetRequest. */
export type CreateAttendanceEditTimesheetRequestPayload = {
  __typename?: 'CreateAttendanceEditTimesheetRequestPayload';
  editTimesheetRequest?: Maybe<AttendanceEditTimesheetRequest>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateAttendanceEmployeesPolicy. */
export type CreateAttendanceEmployeesPolicyPayload = {
  __typename?: 'CreateAttendanceEmployeesPolicyPayload';
  employeesPolicy?: Maybe<AttendanceEmployeesPolicy>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateAttendanceExport. */
export type CreateAttendanceExportPayload = {
  __typename?: 'CreateAttendanceExportPayload';
  errors: Array<MutationError>;
  export?: Maybe<AttendanceExport>;
};

/** Autogenerated return type of CreateAttendanceExtraHoursRange. */
export type CreateAttendanceExtraHoursRangePayload = {
  __typename?: 'CreateAttendanceExtraHoursRangePayload';
  errors: Array<MutationError>;
  extraHoursRange?: Maybe<AttendanceExtraHoursRange>;
};

/** Autogenerated return type of CreateAttendanceMessage. */
export type CreateAttendanceMessagePayload = {
  __typename?: 'CreateAttendanceMessagePayload';
  errors: Array<MutationError>;
  message?: Maybe<AttendanceMessage>;
};

/** Autogenerated return type of CreateAttendanceOvertimeRequest. */
export type CreateAttendanceOvertimeRequestPayload = {
  __typename?: 'CreateAttendanceOvertimeRequestPayload';
  errors: Array<MutationError>;
  overtimeRequest?: Maybe<AttendanceOvertimeRequest>;
};

/** Autogenerated return type of CreateAttendanceShift. */
export type CreateAttendanceShiftPayload = {
  __typename?: 'CreateAttendanceShiftPayload';
  errors: Array<MutationError>;
  shift?: Maybe<AttendanceShift>;
};

/** Autogenerated return type of CreateAttendanceToleranceSetting. */
export type CreateAttendanceToleranceSettingPayload = {
  __typename?: 'CreateAttendanceToleranceSettingPayload';
  errors: Array<MutationError>;
  toleranceSetting?: Maybe<AttendanceToleranceSetting>;
};

/** Autogenerated return type of CreateAuthenticationDomain. */
export type CreateAuthenticationDomainPayload = {
  __typename?: 'CreateAuthenticationDomainPayload';
  domain?: Maybe<AuthenticationDomain>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateBankingCardEphemeralKey. */
export type CreateBankingCardEphemeralKeyPayload = {
  __typename?: 'CreateBankingCardEphemeralKeyPayload';
  cardEphemeralKey?: Maybe<BankingCardEphemeralKey>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateBankingPayment. */
export type CreateBankingPaymentPayload = {
  __typename?: 'CreateBankingPaymentPayload';
  errors: Array<MutationError>;
  payment?: Maybe<BankingPayment>;
};

export type CreateBankingPaymentRequestItemsInput = {
  amountCents: Scalars['Int'];
  beneficiariableAccountNumber: Scalars['String'];
  beneficiariableId: Scalars['Int'];
  beneficiariableType: BankingEntitiesBeneficiariableTypeEnum;
  sourceId: Scalars['Int'];
  sourceType: BankingValueObjectsPaymentRequestSourceTypeEnum;
};

/** Autogenerated return type of CreateBankingPaymentRequest. */
export type CreateBankingPaymentRequestPayload = {
  __typename?: 'CreateBankingPaymentRequestPayload';
  errors: Array<MutationError>;
  paymentRequest?: Maybe<BankingPaymentRequest>;
};

/** Autogenerated return type of CreateBenefitsChildcareRequest. */
export type CreateBenefitsChildcareRequestPayload = {
  __typename?: 'CreateBenefitsChildcareRequestPayload';
  childcareRequest?: Maybe<BenefitsChildcareRequest>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateBenefitsHealthcarePlan. */
export type CreateBenefitsHealthcarePlanPayload = {
  __typename?: 'CreateBenefitsHealthcarePlanPayload';
  errors: Array<MutationError>;
  healthcarePlan?: Maybe<BenefitsHealthcarePlan>;
};

/** Autogenerated return type of CreateBenefitsTrainingCost. */
export type CreateBenefitsTrainingCostPayload = {
  __typename?: 'CreateBenefitsTrainingCostPayload';
  errors: Array<MutationError>;
  trainingCost?: Maybe<BenefitsTrainingCost>;
};

/** Autogenerated return type of CreateBillingChurnRequest. */
export type CreateBillingChurnRequestPayload = {
  __typename?: 'CreateBillingChurnRequestPayload';
  churnRequest?: Maybe<BillingChurnRequest>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateBillingCpCollectNow. */
export type CreateBillingCpCollectNowPayload = {
  __typename?: 'CreateBillingCpCollectNowPayload';
  cpCollectNow?: Maybe<BillingCpCollectNow>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateBillingCpPaymentIntent. */
export type CreateBillingCpPaymentIntentPayload = {
  __typename?: 'CreateBillingCpPaymentIntentPayload';
  cpPaymentIntent?: Maybe<BillingCpPaymentIntent>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateBillingCpPaymentLink. */
export type CreateBillingCpPaymentLinkPayload = {
  __typename?: 'CreateBillingCpPaymentLinkPayload';
  cpPaymentLink?: Maybe<BillingCpPaymentLink>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateBillingCpPaymentMethod. */
export type CreateBillingCpPaymentMethodPayload = {
  __typename?: 'CreateBillingCpPaymentMethodPayload';
  cpPaymentMethod?: Maybe<BillingCpPaymentMethod>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateBillingCpSubscriptionContact. */
export type CreateBillingCpSubscriptionContactPayload = {
  __typename?: 'CreateBillingCpSubscriptionContactPayload';
  cpSubscriptionContact?: Maybe<BillingCpSubscriptionContact>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateBillingEstimateProrate. */
export type CreateBillingEstimateProratePayload = {
  __typename?: 'CreateBillingEstimateProratePayload';
  errors: Array<MutationError>;
  estimateProrate?: Maybe<BillingEstimateProrate>;
};

/** Autogenerated return type of CreateBillingUpgradeLineItem. */
export type CreateBillingUpgradeLineItemPayload = {
  __typename?: 'CreateBillingUpgradeLineItemPayload';
  errors: Array<MutationError>;
  upgradeLineItem?: Maybe<BillingUpgradeLineItem>;
};

/** Autogenerated return type of CreateBillingUpgradeSubscription. */
export type CreateBillingUpgradeSubscriptionPayload = {
  __typename?: 'CreateBillingUpgradeSubscriptionPayload';
  errors: Array<MutationError>;
  upgradeSubscription?: Maybe<BillingUpgradeSubscription>;
};

/** Autogenerated return type of CreateBookkeepersmanagementBookkeeperAccess. */
export type CreateBookkeepersmanagementBookkeeperAccessPayload = {
  __typename?: 'CreateBookkeepersmanagementBookkeeperAccessPayload';
  bookkeeperAccess?: Maybe<BookkeepersManagementBookkeeperAccess>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateBookkeepersmanagementBookkeeperCompany. */
export type CreateBookkeepersmanagementBookkeeperCompanyPayload = {
  __typename?: 'CreateBookkeepersmanagementBookkeeperCompanyPayload';
  bookkeeperCompany?: Maybe<BookkeepersManagementBookkeeperCompany>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateBookkeepersmanagementBookkeeperCustomer. */
export type CreateBookkeepersmanagementBookkeeperCustomerPayload = {
  __typename?: 'CreateBookkeepersmanagementBookkeeperCustomerPayload';
  bookkeeperCustomer?: Maybe<BookkeepersManagementBookkeeperCustomer>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateBookkeepersmanagementBookkeeper. */
export type CreateBookkeepersmanagementBookkeeperPayload = {
  __typename?: 'CreateBookkeepersmanagementBookkeeperPayload';
  bookkeeper?: Maybe<BookkeepersManagementBookkeeper>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateBookkeepersmanagementOptionIncidenceOption. */
export type CreateBookkeepersmanagementOptionIncidenceOptionPayload = {
  __typename?: 'CreateBookkeepersmanagementOptionIncidenceOptionPayload';
  errors: Array<MutationError>;
  incidenceOption?: Maybe<BookkeepersManagementIncidenceOption>;
};

/** Autogenerated return type of CreateBookkeepersmanagementOptionIncidenceRule. */
export type CreateBookkeepersmanagementOptionIncidenceRulePayload = {
  __typename?: 'CreateBookkeepersmanagementOptionIncidenceRulePayload';
  errors: Array<MutationError>;
  incidenceRule?: Maybe<BookkeepersManagementIncidenceRule>;
};

/** Autogenerated return type of CreateBookkeepersmanagementTaskTaskDocument. */
export type CreateBookkeepersmanagementTaskTaskDocumentPayload = {
  __typename?: 'CreateBookkeepersmanagementTaskTaskDocumentPayload';
  errors: Array<MutationError>;
  taskDocument?: Maybe<BookkeepersManagementTaskDocument>;
};

/** Autogenerated return type of CreateBookkeepersmanagementTaskTaskStatus. */
export type CreateBookkeepersmanagementTaskTaskStatusPayload = {
  __typename?: 'CreateBookkeepersmanagementTaskTaskStatusPayload';
  errors: Array<MutationError>;
  taskStatus?: Maybe<BookkeepersManagementTaskStatus>;
};

export type CreateByFixContractsCompensationsRolloutCompensationEmployeeMapsInput = {
  compensationTemplate: CreateByFixContractsCompensationsRolloutCompensationTemplateInput;
  employeeIds: Array<Scalars['Int']>;
};

export type CreateByFixContractsCompensationsRolloutCompensationTemplateInput = {
  amount?: InputMaybe<Scalars['Int']>;
  calculation?: InputMaybe<Scalars['String']>;
  compensationType: ContractsCompensationsTypesEnum;
  contractsTaxonomyId: Scalars['Int'];
  description?: InputMaybe<Scalars['String']>;
  firstPaymentOn?: InputMaybe<Scalars['ISO8601Date']>;
  minimumAmountOfHours?: InputMaybe<Scalars['Int']>;
  minimumAmountOfHoursInCents?: InputMaybe<Scalars['Int']>;
  recurrence?: InputMaybe<Scalars['String']>;
  recurrenceCount?: InputMaybe<Scalars['Int']>;
  startsOn?: InputMaybe<Scalars['ISO8601Date']>;
  syncWithSupplements?: InputMaybe<Scalars['Boolean']>;
  timeCondition?: InputMaybe<ContractsValueObjectsTimeConditionEnum>;
  unit?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of CreateByFixContractsCompensationsRollout. */
export type CreateByFixContractsCompensationsRolloutPayload = {
  __typename?: 'CreateByFixContractsCompensationsRolloutPayload';
  compensationsRollout?: Maybe<ContractsCompensationsRollout>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateCognitoSamlProvider. */
export type CreateCognitoSamlProviderPayload = {
  __typename?: 'CreateCognitoSamlProviderPayload';
  errors: Array<MutationError>;
  samlProvider?: Maybe<CognitoSamlProvider>;
};

/** Autogenerated return type of CreateCommentCompensationsPayrollRun. */
export type CreateCommentCompensationsPayrollRunPayload = {
  __typename?: 'CreateCommentCompensationsPayrollRunPayload';
  errors: Array<MutationError>;
  payrollRun?: Maybe<CompensationsPayrollRun>;
};

/** Autogenerated return type of CreateCommentExpensesExpensable. */
export type CreateCommentExpensesExpensablePayload = {
  __typename?: 'CreateCommentExpensesExpensablePayload';
  errors: Array<MutationError>;
  expensable?: Maybe<ExpensesExpensable>;
};

/** Autogenerated return type of CreateCommentProcurementPurchaseRequest. */
export type CreateCommentProcurementPurchaseRequestPayload = {
  __typename?: 'CreateCommentProcurementPurchaseRequestPayload';
  errors: Array<MutationError>;
  purchaseRequest?: Maybe<ProcurementPurchaseRequest>;
};

/** Autogenerated return type of CreateCommentTasksTask. */
export type CreateCommentTasksTaskPayload = {
  __typename?: 'CreateCommentTasksTaskPayload';
  errors: Array<MutationError>;
  task?: Maybe<TasksTask>;
};

/** Autogenerated return type of CreateCompaniesLegalEntity. */
export type CreateCompaniesLegalEntityPayload = {
  __typename?: 'CreateCompaniesLegalEntityPayload';
  errors: Array<MutationError>;
  legalEntity?: Maybe<CompaniesLegalEntity>;
};

/** Autogenerated return type of CreateCompaniesSubscriptionOverload. */
export type CreateCompaniesSubscriptionOverloadPayload = {
  __typename?: 'CreateCompaniesSubscriptionOverloadPayload';
  errors: Array<MutationError>;
  subscriptionOverload?: Maybe<CompaniesSubscriptionOverload>;
};

/** Autogenerated return type of CreateCompanypagePerk. */
export type CreateCompanypagePerkPayload = {
  __typename?: 'CreateCompanypagePerkPayload';
  errors: Array<MutationError>;
  perk?: Maybe<CompanyPagePerk>;
};

/** Autogenerated return type of CreateCompensationsCycle. */
export type CreateCompensationsCyclePayload = {
  __typename?: 'CreateCompensationsCyclePayload';
  cycle?: Maybe<CompensationsCycle>;
  errors: Array<MutationError>;
};

export type CreateCompensationsCyclePeopleGroupInput = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  country?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
};

/** Autogenerated return type of CreateCompensationsEmployeesCompensationsValidation. */
export type CreateCompensationsEmployeesCompensationsValidationPayload = {
  __typename?: 'CreateCompensationsEmployeesCompensationsValidationPayload';
  employeesCompensationsValidation?: Maybe<CompensationsEmployeesCompensationsValidation>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateCompensationsPayrollConceptStatus. */
export type CreateCompensationsPayrollConceptStatusPayload = {
  __typename?: 'CreateCompensationsPayrollConceptStatusPayload';
  errors: Array<MutationError>;
  payrollConceptStatus?: Maybe<CompensationsPayrollConceptStatus>;
};

/** Autogenerated return type of CreateCompetenciesCompetencyGroup. */
export type CreateCompetenciesCompetencyGroupPayload = {
  __typename?: 'CreateCompetenciesCompetencyGroupPayload';
  competencyGroup?: Maybe<CompetenciesCompetencyGroup>;
  errors: Array<MutationError>;
};

export type CreateCompetenciesCompetencyLevelsInput = {
  description: Scalars['String'];
  jobCatalogTreeNodeUuids?: InputMaybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  position: Scalars['Int'];
};

/** Autogenerated return type of CreateCompetenciesCompetency. */
export type CreateCompetenciesCompetencyPayload = {
  __typename?: 'CreateCompetenciesCompetencyPayload';
  competency?: Maybe<CompetenciesCompetency>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateComplaintsCategory. */
export type CreateComplaintsCategoryPayload = {
  __typename?: 'CreateComplaintsCategoryPayload';
  category?: Maybe<ComplaintsCategory>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateComplaintsMessage. */
export type CreateComplaintsMessagePayload = {
  __typename?: 'CreateComplaintsMessagePayload';
  errors: Array<MutationError>;
  message?: Maybe<ComplaintsMessage>;
};

/** Autogenerated return type of CreateComplaintsNote. */
export type CreateComplaintsNotePayload = {
  __typename?: 'CreateComplaintsNotePayload';
  errors: Array<MutationError>;
  note?: Maybe<ComplaintsNote>;
};

/** Autogenerated return type of CreateContractsCompensation. */
export type CreateContractsCompensationPayload = {
  __typename?: 'CreateContractsCompensationPayload';
  compensation?: Maybe<ContractsCompensation>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateContractsContractTemplate. */
export type CreateContractsContractTemplatePayload = {
  __typename?: 'CreateContractsContractTemplatePayload';
  contractTemplate?: Maybe<ContractsContractTemplate>;
  errors: Array<MutationError>;
};

export type CreateContractsContractVersionCompensationsInput = {
  amount?: InputMaybe<Scalars['Int']>;
  calculation?: InputMaybe<Scalars['String']>;
  compensationType?: InputMaybe<Scalars['String']>;
  contractsTaxonomyId: Scalars['Int'];
  description?: InputMaybe<Scalars['String']>;
  firstPaymentOn?: InputMaybe<Scalars['ISO8601Date']>;
  minimumAmountOfHours?: InputMaybe<Scalars['Int']>;
  minimumAmountOfHoursInCents?: InputMaybe<Scalars['Int']>;
  payrollPolicyId?: InputMaybe<Scalars['Int']>;
  recurrence?: InputMaybe<Scalars['String']>;
  recurrenceCount?: InputMaybe<Scalars['Int']>;
  startsOn?: InputMaybe<Scalars['ISO8601Date']>;
  syncWithSupplements?: InputMaybe<Scalars['Boolean']>;
  timeCondition?: InputMaybe<ContractsValueObjectsTimeConditionEnum>;
  unit?: InputMaybe<Scalars['String']>;
};

export type CreateContractsContractVersionNewAdditionalCompensationsInput = {
  amount?: InputMaybe<Scalars['Int']>;
  amountStrategyType: Scalars['String'];
  contractVersionId: Scalars['Int'];
  description?: InputMaybe<Scalars['String']>;
  firstPaymentOn?: InputMaybe<Scalars['ISO8601Date']>;
  id?: InputMaybe<Scalars['Int']>;
  payrollConceptId: Scalars['Int'];
  recurrence?: InputMaybe<Scalars['String']>;
  upperLimit?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of CreateContractsContractVersion. */
export type CreateContractsContractVersionPayload = {
  __typename?: 'CreateContractsContractVersionPayload';
  contractVersion?: Maybe<ContractsContractVersion>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateContractsFranceFrenchContractType. */
export type CreateContractsFranceFrenchContractTypePayload = {
  __typename?: 'CreateContractsFranceFrenchContractTypePayload';
  errors: Array<MutationError>;
  frenchContractType?: Maybe<ContractsFrenchContractType>;
};

/** Autogenerated return type of CreateContractsFranceFrenchLevel. */
export type CreateContractsFranceFrenchLevelPayload = {
  __typename?: 'CreateContractsFranceFrenchLevelPayload';
  errors: Array<MutationError>;
  frenchLevel?: Maybe<ContractsFrenchLevel>;
};

/** Autogenerated return type of CreateContractsFranceFrenchMutual. */
export type CreateContractsFranceFrenchMutualPayload = {
  __typename?: 'CreateContractsFranceFrenchMutualPayload';
  errors: Array<MutationError>;
  frenchMutual?: Maybe<ContractsFrenchMutual>;
};

/** Autogenerated return type of CreateContractsFranceFrenchProfessionalCategory. */
export type CreateContractsFranceFrenchProfessionalCategoryPayload = {
  __typename?: 'CreateContractsFranceFrenchProfessionalCategoryPayload';
  errors: Array<MutationError>;
  frenchProfessionalCategory?: Maybe<ContractsFrenchProfessionalCategory>;
};

/** Autogenerated return type of CreateContractsFranceFrenchStep. */
export type CreateContractsFranceFrenchStepPayload = {
  __typename?: 'CreateContractsFranceFrenchStepPayload';
  errors: Array<MutationError>;
  frenchStep?: Maybe<ContractsFrenchStep>;
};

/** Autogenerated return type of CreateContractsFranceFrenchWorkType. */
export type CreateContractsFranceFrenchWorkTypePayload = {
  __typename?: 'CreateContractsFranceFrenchWorkTypePayload';
  errors: Array<MutationError>;
  frenchWorkType?: Maybe<ContractsFrenchWorkType>;
};

/** Autogenerated return type of CreateContractsGermanyGermanContractType. */
export type CreateContractsGermanyGermanContractTypePayload = {
  __typename?: 'CreateContractsGermanyGermanContractTypePayload';
  errors: Array<MutationError>;
  germanContractType?: Maybe<ContractsGermanContractType>;
};

/** Autogenerated return type of CreateContractsPayrollPolicy. */
export type CreateContractsPayrollPolicyPayload = {
  __typename?: 'CreateContractsPayrollPolicyPayload';
  errors: Array<MutationError>;
  payrollPolicy?: Maybe<ContractsPayrollPolicy>;
};

/** Autogenerated return type of CreateContractsPortugalPortugueseContractType. */
export type CreateContractsPortugalPortugueseContractTypePayload = {
  __typename?: 'CreateContractsPortugalPortugueseContractTypePayload';
  errors: Array<MutationError>;
  portugueseContractType?: Maybe<ContractsPortugueseContractType>;
};

/** Autogenerated return type of CreateContractsSpainSpanishContractType. */
export type CreateContractsSpainSpanishContractTypePayload = {
  __typename?: 'CreateContractsSpainSpanishContractTypePayload';
  errors: Array<MutationError>;
  spanishContractType?: Maybe<ContractsSpanishContractType>;
};

/** Autogenerated return type of CreateContractsSpainSpanishEducationLevel. */
export type CreateContractsSpainSpanishEducationLevelPayload = {
  __typename?: 'CreateContractsSpainSpanishEducationLevelPayload';
  errors: Array<MutationError>;
  spanishEducationLevel?: Maybe<ContractsSpanishEducationLevel>;
};

/** Autogenerated return type of CreateContractsSpainSpanishProfessionalCategory. */
export type CreateContractsSpainSpanishProfessionalCategoryPayload = {
  __typename?: 'CreateContractsSpainSpanishProfessionalCategoryPayload';
  errors: Array<MutationError>;
  spanishProfessionalCategory?: Maybe<ContractsSpanishProfessionalCategory>;
};

/** Autogenerated return type of CreateContractsSpainSpanishWorkingDayType. */
export type CreateContractsSpainSpanishWorkingDayTypePayload = {
  __typename?: 'CreateContractsSpainSpanishWorkingDayTypePayload';
  errors: Array<MutationError>;
  spanishWorkingDayType?: Maybe<ContractsSpanishWorkingDayType>;
};

/** Autogenerated return type of CreateContractsTaxonomy. */
export type CreateContractsTaxonomyPayload = {
  __typename?: 'CreateContractsTaxonomyPayload';
  errors: Array<MutationError>;
  taxonomy?: Maybe<ContractsTaxonomy>;
};

/** Autogenerated return type of CreateContractsTerminationType. */
export type CreateContractsTerminationTypePayload = {
  __typename?: 'CreateContractsTerminationTypePayload';
  errors: Array<MutationError>;
  terminationType?: Maybe<ContractsTerminationType>;
};

/** Autogenerated return type of CreateContractsWeeksPerMonthConfiguration. */
export type CreateContractsWeeksPerMonthConfigurationPayload = {
  __typename?: 'CreateContractsWeeksPerMonthConfigurationPayload';
  errors: Array<MutationError>;
  weeksPerMonthConfiguration?: Maybe<ContractsWeeksPerMonthConfiguration>;
};

/** Autogenerated return type of CreateCostcentersAllocation. */
export type CreateCostcentersAllocationPayload = {
  __typename?: 'CreateCostcentersAllocationPayload';
  allocation?: Maybe<CostCentersAllocation>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateCostcentersConfiguration. */
export type CreateCostcentersConfigurationPayload = {
  __typename?: 'CreateCostcentersConfigurationPayload';
  configuration?: Maybe<CostCentersConfiguration>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateCostcentersCostCenter. */
export type CreateCostcentersCostCenterPayload = {
  __typename?: 'CreateCostcentersCostCenterPayload';
  costCenter?: Maybe<CostCentersCostCenter>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateCronofyschedulingCalendarSync. */
export type CreateCronofyschedulingCalendarSyncPayload = {
  __typename?: 'CreateCronofyschedulingCalendarSyncPayload';
  calendarSync?: Maybe<CronofySchedulingCalendarSync>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateCustomfieldsField. */
export type CreateCustomfieldsFieldPayload = {
  __typename?: 'CreateCustomfieldsFieldPayload';
  errors: Array<MutationError>;
  field?: Maybe<CustomFieldsField>;
};

/** Autogenerated return type of CreateCustomfieldsOption. */
export type CreateCustomfieldsOptionPayload = {
  __typename?: 'CreateCustomfieldsOptionPayload';
  errors: Array<MutationError>;
  option?: Maybe<CustomFieldsOption>;
};

/** Autogenerated return type of CreateCustomfieldsResourceField. */
export type CreateCustomfieldsResourceFieldPayload = {
  __typename?: 'CreateCustomfieldsResourceFieldPayload';
  errors: Array<MutationError>;
  resourceField?: Maybe<CustomFieldsResourceField>;
};

/** Autogenerated return type of CreateCustomfieldsValue. */
export type CreateCustomfieldsValuePayload = {
  __typename?: 'CreateCustomfieldsValuePayload';
  errors: Array<MutationError>;
  value?: Maybe<CustomFieldsValue>;
};

/** Autogenerated return type of CreateCustomresourcesResource. */
export type CreateCustomresourcesResourcePayload = {
  __typename?: 'CreateCustomresourcesResourcePayload';
  errors: Array<MutationError>;
  resource?: Maybe<CustomResourcesResource>;
};

/** Autogenerated return type of CreateCustomresourcesSchema. */
export type CreateCustomresourcesSchemaPayload = {
  __typename?: 'CreateCustomresourcesSchemaPayload';
  errors: Array<MutationError>;
  schema?: Maybe<CustomResourcesSchema>;
};

/** Autogenerated return type of CreateCustomresourcesValue. */
export type CreateCustomresourcesValuePayload = {
  __typename?: 'CreateCustomresourcesValuePayload';
  errors: Array<MutationError>;
  value?: Maybe<CustomResourcesValue>;
};

/** Autogenerated return type of CreateDashboardCompanyLink. */
export type CreateDashboardCompanyLinkPayload = {
  __typename?: 'CreateDashboardCompanyLinkPayload';
  companyLink?: Maybe<DashboardCompanyLink>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateDashboardWidgetsConfiguration. */
export type CreateDashboardWidgetsConfigurationPayload = {
  __typename?: 'CreateDashboardWidgetsConfigurationPayload';
  errors: Array<MutationError>;
  widgetsConfiguration?: Maybe<DashboardWidgetsConfiguration>;
};

/** Autogenerated return type of CreateDefaultsTimeoffLeaveType. */
export type CreateDefaultsTimeoffLeaveTypePayload = {
  __typename?: 'CreateDefaultsTimeoffLeaveTypePayload';
  errors: Array<MutationError>;
  leaveType?: Maybe<TimeoffLeaveType>;
};

/** Autogenerated return type of CreateDirectuploadsDirectUpload. */
export type CreateDirectuploadsDirectUploadPayload = {
  __typename?: 'CreateDirectuploadsDirectUploadPayload';
  directUpload?: Maybe<DirectUploadsDirectUpload>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateDocumentsDocument. */
export type CreateDocumentsDocumentPayload = {
  __typename?: 'CreateDocumentsDocumentPayload';
  document?: Maybe<DocumentsDocument>;
  errors: Array<MutationError>;
};

export type CreateDocumentsDocumentSigneeStampsInput = {
  fileId: Scalars['Int'];
  height: Scalars['Float'];
  left: Scalars['Float'];
  page: Scalars['Int'];
  signeeId: Scalars['Int'];
  top: Scalars['Float'];
  width: Scalars['Float'];
};

/** Autogenerated return type of CreateDocumentsFolder. */
export type CreateDocumentsFolderPayload = {
  __typename?: 'CreateDocumentsFolderPayload';
  errors: Array<MutationError>;
  folder?: Maybe<DocumentsFolder>;
};

/** Autogenerated return type of CreateDocumentsTemplate. */
export type CreateDocumentsTemplatePayload = {
  __typename?: 'CreateDocumentsTemplatePayload';
  errors: Array<MutationError>;
  template?: Maybe<DocumentsTemplate>;
};

/** Autogenerated return type of CreateDocumentsUploadProcess. */
export type CreateDocumentsUploadProcessPayload = {
  __typename?: 'CreateDocumentsUploadProcessPayload';
  errors: Array<MutationError>;
  uploadProcess?: Maybe<DocumentsUploadProcess>;
};

/** Autogenerated return type of CreateEmployeesEmployeeGroup. */
export type CreateEmployeesEmployeeGroupPayload = {
  __typename?: 'CreateEmployeesEmployeeGroupPayload';
  employeeGroup?: Maybe<EmployeesEmployeeGroup>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateEmployeesEmployee. */
export type CreateEmployeesEmployeePayload = {
  __typename?: 'CreateEmployeesEmployeePayload';
  employee?: Maybe<EmployeesEmployee>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateEngagementEmployeePulse. */
export type CreateEngagementEmployeePulsePayload = {
  __typename?: 'CreateEngagementEmployeePulsePayload';
  employeePulse?: Maybe<EngagementEmployeePulse>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateEphemeralKeysExpensesCard. */
export type CreateEphemeralKeysExpensesCardPayload = {
  __typename?: 'CreateEphemeralKeysExpensesCardPayload';
  card?: Maybe<ExpensesCard>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateExpensesClosingPeriodFrequency. */
export type CreateExpensesClosingPeriodFrequencyPayload = {
  __typename?: 'CreateExpensesClosingPeriodFrequencyPayload';
  closingPeriodFrequency?: Maybe<ExpensesClosingPeriodFrequency>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateExpensesClosingPeriod. */
export type CreateExpensesClosingPeriodPayload = {
  __typename?: 'CreateExpensesClosingPeriodPayload';
  closingPeriod?: Maybe<ExpensesClosingPeriod>;
  errors: Array<MutationError>;
};

export type CreateExpensesExpensableAllocationInput = {
  id?: InputMaybe<Scalars['Int']>;
  referenceId: Scalars['Int'];
  referenceType: Scalars['String'];
};

export type CreateExpensesExpensableAssignmentsInput = {
  assignmentsToCreate: Array<CreateExpensesExpensableAssignmentsToCreateInput>;
  assignmentsToUpdate: Array<CreateExpensesExpensableAssignmentsToUpdateInput>;
};

export type CreateExpensesExpensableAssignmentsToCreateInput = {
  costCenterId: Scalars['Int'];
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  percentage: Scalars['Float'];
  startDate: Scalars['ISO8601Date'];
};

export type CreateExpensesExpensableAssignmentsToUpdateInput = {
  costCenterId: Scalars['Int'];
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  id: Scalars['Int'];
  markedForDeletion: Scalars['Boolean'];
  percentage: Scalars['Float'];
  startDate: Scalars['ISO8601Date'];
};

export type CreateExpensesExpensableConceptsInput = {
  accommodationProvided: Scalars['Boolean'];
  breakfastProvided: Scalars['Boolean'];
  date: Scalars['ISO8601Date'];
  dinnerProvided: Scalars['Boolean'];
  lunchProvided: Scalars['Boolean'];
};

export type CreateExpensesExpensableCostCentersInput = {
  allocation?: InputMaybe<CreateExpensesExpensableAllocationInput>;
  assignments?: InputMaybe<CreateExpensesExpensableAssignmentsInput>;
};

export type CreateExpensesExpensableDestinationsInput = {
  administrativeAreaLevel1?: InputMaybe<Scalars['String']>;
  administrativeAreaLevel2?: InputMaybe<Scalars['String']>;
  arrivalDate: Scalars['ISO8601DateTime'];
  country?: InputMaybe<Scalars['String']>;
  locality?: InputMaybe<Scalars['String']>;
  locationName: Scalars['String'];
};

export type CreateExpensesExpensableExpenseInput = {
  accessToken?: InputMaybe<Scalars['String']>;
  amountCents?: InputMaybe<Scalars['Int']>;
  budgetId?: InputMaybe<Scalars['Int']>;
  cardPaymentId?: InputMaybe<Scalars['Int']>;
  category?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['Int']>;
  companyId: Scalars['Int'];
  creationType?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  disputeId?: InputMaybe<Scalars['Int']>;
  documentNumber?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<Scalars['String']>;
  effectiveOn?: InputMaybe<Scalars['ISO8601DateTime']>;
  employeeId: Scalars['Int'];
  exchangeRate?: InputMaybe<Scalars['Float']>;
  expensesCardId?: InputMaybe<Scalars['Int']>;
  externalAuthorizationId?: InputMaybe<Scalars['String']>;
  files: Array<Scalars['File']>;
  groupId?: InputMaybe<Scalars['Int']>;
  internalReference?: InputMaybe<Scalars['String']>;
  mcc?: InputMaybe<Scalars['String']>;
  merchantName?: InputMaybe<Scalars['String']>;
  merchantTin?: InputMaybe<Scalars['String']>;
  payment?: InputMaybe<ExpensesValueObjectsPaymentOptionsEnum>;
  paymentMethod?: InputMaybe<Scalars['String']>;
  projects?: InputMaybe<Array<ExpensesProjectInput>>;
  reference?: InputMaybe<Scalars['String']>;
  signedDocumentId?: InputMaybe<Scalars['Int']>;
  signedForOrganization?: InputMaybe<Scalars['String']>;
  statusUpdatedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  subcategory?: InputMaybe<Scalars['String']>;
  taxes: Array<CreateExpensesExpensableTaxesInput>;
};

/** Autogenerated return type of CreateExpensesExpensableGroup. */
export type CreateExpensesExpensableGroupPayload = {
  __typename?: 'CreateExpensesExpensableGroupPayload';
  errors: Array<MutationError>;
  expensableGroup?: Maybe<ExpensesExpensableGroup>;
};

export type CreateExpensesExpensableMileageNewInput = {
  amountCents?: InputMaybe<Scalars['Int']>;
  budgetId?: InputMaybe<Scalars['Int']>;
  calculatedMileage?: InputMaybe<Scalars['Int']>;
  categoryId?: InputMaybe<Scalars['Int']>;
  companyId: Scalars['Int'];
  currency?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  destinationLatitude?: InputMaybe<Scalars['Float']>;
  destinationLongitude?: InputMaybe<Scalars['Float']>;
  effectiveOn?: InputMaybe<Scalars['ISO8601DateTime']>;
  employeeId: Scalars['Int'];
  files: Array<Scalars['File']>;
  from?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['Int']>;
  internalReference?: InputMaybe<Scalars['String']>;
  mileage?: InputMaybe<Scalars['Int']>;
  originLatitude?: InputMaybe<Scalars['Float']>;
  originLongitude?: InputMaybe<Scalars['Float']>;
  projects?: InputMaybe<Array<ExpensesProjectInput>>;
  rate?: InputMaybe<Scalars['String']>;
  roundTrip?: InputMaybe<Scalars['Boolean']>;
  signedForOrganization?: InputMaybe<Scalars['String']>;
  subcategory?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
  units?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of CreateExpensesExpensable. */
export type CreateExpensesExpensablePayload = {
  __typename?: 'CreateExpensesExpensablePayload';
  errors: Array<MutationError>;
  expensable?: Maybe<ExpensesExpensable>;
};

export type CreateExpensesExpensablePerDiemInput = {
  amountCents?: InputMaybe<Scalars['Int']>;
  budgetId?: InputMaybe<Scalars['Int']>;
  categoryId?: InputMaybe<Scalars['Int']>;
  companyId: Scalars['Int'];
  currency?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  employeeId: Scalars['Int'];
  endDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  files: Array<Scalars['File']>;
  from?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['Int']>;
  internalReference?: InputMaybe<Scalars['String']>;
  projects?: InputMaybe<Array<ExpensesProjectInput>>;
  rates: Array<CreateExpensesExpensableRatesInput>;
  signedForOrganization?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  subcategory?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
};

export type CreateExpensesExpensablePerDiemNewInput = {
  budgetId?: InputMaybe<Scalars['Int']>;
  categoryId?: InputMaybe<Scalars['Int']>;
  companyId: Scalars['Int'];
  concepts?: InputMaybe<Array<CreateExpensesExpensableConceptsInput>>;
  currency?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  destinations?: InputMaybe<Array<CreateExpensesExpensableDestinationsInput>>;
  employeeId: Scalars['Int'];
  endDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  files: Array<Scalars['File']>;
  from?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['Int']>;
  internalReference?: InputMaybe<Scalars['String']>;
  projects?: InputMaybe<Array<ExpensesProjectInput>>;
  startDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  subcategory?: InputMaybe<Scalars['String']>;
};

export type CreateExpensesExpensableRatesInput = {
  rateConfigurationId: Scalars['Int'];
  totalAmountCents: Scalars['Int'];
  totalDays: Scalars['Int'];
};

export type CreateExpensesExpensableTaxesInput = {
  amount?: InputMaybe<Scalars['Int']>;
  baseAmount?: InputMaybe<Scalars['Int']>;
  percentage?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<ExpensesCustomizationExpenseTaxesTypesEnum>;
};

/** Autogenerated return type of CreateExpensesPolicyWorkflow. */
export type CreateExpensesPolicyWorkflowPayload = {
  __typename?: 'CreateExpensesPolicyWorkflowPayload';
  errors: Array<MutationError>;
  policyWorkflow?: Maybe<ExpensesPolicyWorkflow>;
};

/** Autogenerated return type of CreateExpensesRateConfiguration. */
export type CreateExpensesRateConfigurationPayload = {
  __typename?: 'CreateExpensesRateConfigurationPayload';
  errors: Array<MutationError>;
  rateConfiguration?: Maybe<ExpensesRateConfiguration>;
};

/** Autogenerated return type of CreateExpensesRecommendationResult. */
export type CreateExpensesRecommendationResultPayload = {
  __typename?: 'CreateExpensesRecommendationResultPayload';
  errors: Array<MutationError>;
  recommendationResult?: Maybe<ExpensesRecommendationResult>;
};

/** Autogenerated return type of CreateExpensesSignedDocumentsTerm. */
export type CreateExpensesSignedDocumentsTermPayload = {
  __typename?: 'CreateExpensesSignedDocumentsTermPayload';
  errors: Array<MutationError>;
  signedDocumentsTerm?: Maybe<ExpensesSignedDocumentsTerm>;
};

/** Autogenerated return type of CreateExternalApicoreAccess. */
export type CreateExternalApicoreAccessPayload = {
  __typename?: 'CreateExternalApicoreAccessPayload';
  access?: Maybe<ApiCoreAccess>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateFacerecognitionEmployeePicture. */
export type CreateFacerecognitionEmployeePicturePayload = {
  __typename?: 'CreateFacerecognitionEmployeePicturePayload';
  employeePicture?: Maybe<FaceRecognitionEmployeePicture>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateFeedbacksFeedbackEntry. */
export type CreateFeedbacksFeedbackEntryPayload = {
  __typename?: 'CreateFeedbacksFeedbackEntryPayload';
  errors: Array<MutationError>;
  feedbackEntry?: Maybe<FeedbacksFeedbackEntry>;
};

/** Autogenerated return type of CreateFeedbacksFeedbackRequest. */
export type CreateFeedbacksFeedbackRequestPayload = {
  __typename?: 'CreateFeedbacksFeedbackRequestPayload';
  errors: Array<MutationError>;
  feedbackRequest?: Maybe<FeedbacksFeedbackRequest>;
};

/** Autogenerated return type of CreateFileUpdatedLogDocumentsLog. */
export type CreateFileUpdatedLogDocumentsLogPayload = {
  __typename?: 'CreateFileUpdatedLogDocumentsLogPayload';
  errors: Array<MutationError>;
  log?: Maybe<DocumentsLog>;
};

/** Autogenerated return type of CreateFinanceAccount. */
export type CreateFinanceAccountPayload = {
  __typename?: 'CreateFinanceAccountPayload';
  account?: Maybe<FinanceAccount>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateFinanceBudgetAllocation. */
export type CreateFinanceBudgetAllocationPayload = {
  __typename?: 'CreateFinanceBudgetAllocationPayload';
  budgetAllocation?: Maybe<FinanceBudgetAllocation>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateFinanceBudget. */
export type CreateFinanceBudgetPayload = {
  __typename?: 'CreateFinanceBudgetPayload';
  budget?: Maybe<FinanceBudget>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateFinanceContact. */
export type CreateFinanceContactPayload = {
  __typename?: 'CreateFinanceContactPayload';
  contact?: Maybe<FinanceContact>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateFinanceCostCenter. */
export type CreateFinanceCostCenterPayload = {
  __typename?: 'CreateFinanceCostCenterPayload';
  costCenter?: Maybe<FinanceCostCenter>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateFinanceCustomCategory. */
export type CreateFinanceCustomCategoryPayload = {
  __typename?: 'CreateFinanceCustomCategoryPayload';
  customCategory?: Maybe<FinanceCustomCategory>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateFinanceCustomDimension. */
export type CreateFinanceCustomDimensionPayload = {
  __typename?: 'CreateFinanceCustomDimensionPayload';
  customDimension?: Maybe<FinanceCustomDimension>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateFinanceCustomDimensionValue. */
export type CreateFinanceCustomDimensionValuePayload = {
  __typename?: 'CreateFinanceCustomDimensionValuePayload';
  customDimensionValue?: Maybe<FinanceCustomDimensionValue>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateFinanceDeal. */
export type CreateFinanceDealPayload = {
  __typename?: 'CreateFinanceDealPayload';
  deal?: Maybe<FinanceDeal>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateFinanceFinancialDocumentAssociation. */
export type CreateFinanceFinancialDocumentAssociationPayload = {
  __typename?: 'CreateFinanceFinancialDocumentAssociationPayload';
  errors: Array<MutationError>;
  financialDocumentAssociation?: Maybe<FinanceFinancialDocumentAssociation>;
};

export type CreateFinanceJournalEntryLinesInput = {
  accountId: Scalars['Int'];
  creditAmountCents: Scalars['Int'];
  debitAmountCents: Scalars['Int'];
  externalId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of CreateFinanceJournalEntry. */
export type CreateFinanceJournalEntryPayload = {
  __typename?: 'CreateFinanceJournalEntryPayload';
  errors: Array<MutationError>;
  journalEntry?: Maybe<FinanceJournalEntry>;
};

/** Autogenerated return type of CreateFinanceQuote. */
export type CreateFinanceQuotePayload = {
  __typename?: 'CreateFinanceQuotePayload';
  errors: Array<MutationError>;
  quote?: Maybe<FinanceQuote>;
};

/** Autogenerated return type of CreateFinanceSalesDocumentTemplate. */
export type CreateFinanceSalesDocumentTemplatePayload = {
  __typename?: 'CreateFinanceSalesDocumentTemplatePayload';
  errors: Array<MutationError>;
  salesDocumentTemplate?: Maybe<FinanceSalesDocumentTemplate>;
};

/** Autogenerated return type of CreateFinanceSerialSequenceCreditNoteSequence. */
export type CreateFinanceSerialSequenceCreditNoteSequencePayload = {
  __typename?: 'CreateFinanceSerialSequenceCreditNoteSequencePayload';
  creditNoteSequence?: Maybe<FinanceCreditNoteSequence>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateFinanceSerialSequenceSalesInvoiceSequence. */
export type CreateFinanceSerialSequenceSalesInvoiceSequencePayload = {
  __typename?: 'CreateFinanceSerialSequenceSalesInvoiceSequencePayload';
  errors: Array<MutationError>;
  salesInvoiceSequence?: Maybe<FinanceSalesInvoiceSequence>;
};

/** Autogenerated return type of CreateFinanceSpendingAlertSpendingAlert. */
export type CreateFinanceSpendingAlertSpendingAlertPayload = {
  __typename?: 'CreateFinanceSpendingAlertSpendingAlertPayload';
  errors: Array<MutationError>;
  spendingAlert?: Maybe<FinanceSpendingAlert>;
};

export type CreateFinanceSpendingPolicySpendingPolicyChildrenInput = {
  description: Scalars['String'];
  rules: Array<CreateFinanceSpendingPolicySpendingPolicyRulesInput>;
};

/** Autogenerated return type of CreateFinanceSpendingPolicySpendingPolicy. */
export type CreateFinanceSpendingPolicySpendingPolicyPayload = {
  __typename?: 'CreateFinanceSpendingPolicySpendingPolicyPayload';
  errors: Array<MutationError>;
  spendingPolicy?: Maybe<FinanceSpendingPolicy>;
};

export type CreateFinanceSpendingPolicySpendingPolicyPeopleGroupInput = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
};

/** Autogenerated return type of CreateFinanceSpendingPolicySpendingPolicyRuleGroup. */
export type CreateFinanceSpendingPolicySpendingPolicyRuleGroupPayload = {
  __typename?: 'CreateFinanceSpendingPolicySpendingPolicyRuleGroupPayload';
  errors: Array<MutationError>;
  spendingPolicyRuleGroup?: Maybe<FinanceSpendingPolicyRuleGroup>;
};

export type CreateFinanceSpendingPolicySpendingPolicyRuleGroupRulesInput = {
  identifier: Scalars['String'];
  value: Array<Scalars['String']>;
};

export type CreateFinanceSpendingPolicySpendingPolicyRuleGroupsInput = {
  children: Array<CreateFinanceSpendingPolicySpendingPolicyChildrenInput>;
  description?: InputMaybe<Scalars['String']>;
  rules: Array<CreateFinanceSpendingPolicySpendingPolicyRulesInput>;
};

export type CreateFinanceSpendingPolicySpendingPolicyRulesInput = {
  identifier: Scalars['String'];
  value: Array<Scalars['String']>;
};

/** Autogenerated return type of CreateFinanceTaxRate. */
export type CreateFinanceTaxRatePayload = {
  __typename?: 'CreateFinanceTaxRatePayload';
  errors: Array<MutationError>;
  taxRate?: Maybe<FinanceTaxRate>;
};

export type CreateFinanceTaxTypeLedgerAccountAssignmentsInput = {
  ledgerAccountId: Scalars['Int'];
  ledgerAccountResourceId?: InputMaybe<Scalars['Int']>;
  legalEntityId: Scalars['Int'];
  operationType?: InputMaybe<FinanceValueObjectsLedgerAccountOperationTypeEnum>;
};

/** Autogenerated return type of CreateFinanceTaxType. */
export type CreateFinanceTaxTypePayload = {
  __typename?: 'CreateFinanceTaxTypePayload';
  errors: Array<MutationError>;
  taxType?: Maybe<FinanceTaxType>;
};

export type CreateFinanceTaxTypeTaxRatesInput = {
  amount?: InputMaybe<Scalars['Float']>;
  description?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  rate?: InputMaybe<Scalars['Float']>;
  taxTypeId?: InputMaybe<Scalars['Int']>;
};

export type CreateFinancialworkspaceSettingLaborCostConceptsInput = {
  conceptId: Scalars['Int'];
  laborCostCalculationType: FinancialWorkspaceValueObjectsLaborCostCalculationTypeEnum;
};

/** Autogenerated return type of CreateFinancialworkspaceSetting. */
export type CreateFinancialworkspaceSettingPayload = {
  __typename?: 'CreateFinancialworkspaceSettingPayload';
  errors: Array<MutationError>;
  setting?: Maybe<FinancialWorkspaceSetting>;
};

/** Autogenerated return type of CreateForCardsBankingOnboarding. */
export type CreateForCardsBankingOnboardingPayload = {
  __typename?: 'CreateForCardsBankingOnboardingPayload';
  errors: Array<MutationError>;
  onboarding?: Maybe<BankingOnboarding>;
};

/** Autogenerated return type of CreateForExpenseFinanceFinancialDocument. */
export type CreateForExpenseFinanceFinancialDocumentPayload = {
  __typename?: 'CreateForExpenseFinanceFinancialDocumentPayload';
  errors: Array<MutationError>;
  financialDocument?: Maybe<FinanceFinancialDocument>;
};

/** Autogenerated return type of CreateForExternalBankBankingOnboarding. */
export type CreateForExternalBankBankingOnboardingPayload = {
  __typename?: 'CreateForExternalBankBankingOnboardingPayload';
  errors: Array<MutationError>;
  onboarding?: Maybe<BankingOnboarding>;
};

/** Autogenerated return type of CreateForPaymentsBankingOnboarding. */
export type CreateForPaymentsBankingOnboardingPayload = {
  __typename?: 'CreateForPaymentsBankingOnboardingPayload';
  errors: Array<MutationError>;
  onboarding?: Maybe<BankingOnboarding>;
};

/** Autogenerated return type of CreateFormsAnswer. */
export type CreateFormsAnswerPayload = {
  __typename?: 'CreateFormsAnswerPayload';
  answer?: Maybe<FormsAnswer>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateFormsCycle. */
export type CreateFormsCyclePayload = {
  __typename?: 'CreateFormsCyclePayload';
  cycle?: Maybe<FormsCycle>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateFormsElement. */
export type CreateFormsElementPayload = {
  __typename?: 'CreateFormsElementPayload';
  element?: Maybe<FormsElement>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateFormsForm. */
export type CreateFormsFormPayload = {
  __typename?: 'CreateFormsFormPayload';
  errors: Array<MutationError>;
  form?: Maybe<FormsForm>;
};

/** Autogenerated return type of CreateFormsQuestion. */
export type CreateFormsQuestionPayload = {
  __typename?: 'CreateFormsQuestionPayload';
  errors: Array<MutationError>;
  question?: Maybe<FormsQuestion>;
};

/** Autogenerated return type of CreateFormsSchedule. */
export type CreateFormsSchedulePayload = {
  __typename?: 'CreateFormsSchedulePayload';
  errors: Array<MutationError>;
  schedule?: Maybe<FormsSchedule>;
};

/** Autogenerated return type of CreateFromApplicationsAtsApplication. */
export type CreateFromApplicationsAtsApplicationPayload = {
  __typename?: 'CreateFromApplicationsAtsApplicationPayload';
  applications?: Maybe<Array<AtsApplication>>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateFromCandidatesAtsApplication. */
export type CreateFromCandidatesAtsApplicationPayload = {
  __typename?: 'CreateFromCandidatesAtsApplicationPayload';
  applications?: Maybe<Array<AtsApplication>>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateFromCandidatesRecommendationsAtsApplication. */
export type CreateFromCandidatesRecommendationsAtsApplicationPayload = {
  __typename?: 'CreateFromCandidatesRecommendationsAtsApplicationPayload';
  applications?: Maybe<Array<AtsApplication>>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateFromDocumentExpensesExpensable. */
export type CreateFromDocumentExpensesExpensablePayload = {
  __typename?: 'CreateFromDocumentExpensesExpensablePayload';
  errors: Array<MutationError>;
  expensable?: Maybe<ExpensesExpensable>;
};

/** Autogenerated return type of CreateFromEmployeeAtsApplication. */
export type CreateFromEmployeeAtsApplicationPayload = {
  __typename?: 'CreateFromEmployeeAtsApplicationPayload';
  application?: Maybe<AtsApplication>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateFromEmployeesAtsApplication. */
export type CreateFromEmployeesAtsApplicationPayload = {
  __typename?: 'CreateFromEmployeesAtsApplicationPayload';
  applications?: Maybe<Array<AtsApplication>>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateFromEmployeesAtsCandidate. */
export type CreateFromEmployeesAtsCandidatePayload = {
  __typename?: 'CreateFromEmployeesAtsCandidatePayload';
  candidates?: Maybe<Array<AtsCandidate>>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateFromPredefinedTemplatePerformanceReviewProcessCustomTemplate. */
export type CreateFromPredefinedTemplatePerformanceReviewProcessCustomTemplatePayload = {
  __typename?: 'CreateFromPredefinedTemplatePerformanceReviewProcessCustomTemplatePayload';
  errors: Array<MutationError>;
  reviewProcessCustomTemplate?: Maybe<PerformanceReviewProcessCustomTemplate>;
};

/** Autogenerated return type of CreateFromQuestionReportsReport. */
export type CreateFromQuestionReportsReportPayload = {
  __typename?: 'CreateFromQuestionReportsReportPayload';
  errors: Array<MutationError>;
  report?: Maybe<ReportsReport>;
};

/** Autogenerated return type of CreateFromReviewProcessPerformanceReviewProcessCustomTemplate. */
export type CreateFromReviewProcessPerformanceReviewProcessCustomTemplatePayload = {
  __typename?: 'CreateFromReviewProcessPerformanceReviewProcessCustomTemplatePayload';
  errors: Array<MutationError>;
  reviewProcessCustomTemplate?: Maybe<PerformanceReviewProcessCustomTemplate>;
};

/** Autogenerated return type of CreateFromSyncScanFileFinanceFinancialDocument. */
export type CreateFromSyncScanFileFinanceFinancialDocumentPayload = {
  __typename?: 'CreateFromSyncScanFileFinanceFinancialDocumentPayload';
  errors: Array<MutationError>;
  financialDocument?: Maybe<FinanceFinancialDocument>;
};

/** Autogenerated return type of CreateFromTemplateAtsQuestion. */
export type CreateFromTemplateAtsQuestionPayload = {
  __typename?: 'CreateFromTemplateAtsQuestionPayload';
  errors: Array<MutationError>;
  questions?: Maybe<Array<AtsQuestion>>;
};

/** Autogenerated return type of CreateFromTemplateDocumentsDocument. */
export type CreateFromTemplateDocumentsDocumentPayload = {
  __typename?: 'CreateFromTemplateDocumentsDocumentPayload';
  document?: Maybe<DocumentsDocument>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateFromTemplatePerformanceReviewProcess. */
export type CreateFromTemplatePerformanceReviewProcessPayload = {
  __typename?: 'CreateFromTemplatePerformanceReviewProcessPayload';
  errors: Array<MutationError>;
  reviewProcess?: Maybe<PerformanceReviewProcess>;
};

/** Autogenerated return type of CreateFromTemplateTrainingsTrainingMembershipFile. */
export type CreateFromTemplateTrainingsTrainingMembershipFilePayload = {
  __typename?: 'CreateFromTemplateTrainingsTrainingMembershipFilePayload';
  errors: Array<MutationError>;
  trainingMembershipFile?: Maybe<TrainingsTrainingMembershipFile>;
};

/** Autogenerated return type of CreateFromTextOneononesExternalNote. */
export type CreateFromTextOneononesExternalNotePayload = {
  __typename?: 'CreateFromTextOneononesExternalNotePayload';
  errors: Array<MutationError>;
  externalNote?: Maybe<OneOnOnesExternalNote>;
};

/** Autogenerated return type of CreateGoalsMetricGroup. */
export type CreateGoalsMetricGroupPayload = {
  __typename?: 'CreateGoalsMetricGroupPayload';
  errors: Array<MutationError>;
  metricGroup?: Maybe<GoalsMetricGroup>;
};

/** Autogenerated return type of CreateGoalsMetric. */
export type CreateGoalsMetricPayload = {
  __typename?: 'CreateGoalsMetricPayload';
  errors: Array<MutationError>;
  metric?: Maybe<GoalsMetric>;
};

/** Autogenerated return type of CreateHandbookpagesPage. */
export type CreateHandbookpagesPagePayload = {
  __typename?: 'CreateHandbookpagesPagePayload';
  errors: Array<MutationError>;
  page?: Maybe<HandbookPagesPage>;
};

/** Autogenerated return type of CreateHolidaysCompanyHoliday. */
export type CreateHolidaysCompanyHolidayPayload = {
  __typename?: 'CreateHolidaysCompanyHolidayPayload';
  companyHoliday?: Maybe<HolidaysCompanyHoliday>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateImportersImporterActivity. */
export type CreateImportersImporterActivityPayload = {
  __typename?: 'CreateImportersImporterActivityPayload';
  errors: Array<MutationError>;
  importerActivity?: Maybe<ImportersImporterActivity>;
};

/** Autogenerated return type of CreateImportersImporterProcess. */
export type CreateImportersImporterProcessPayload = {
  __typename?: 'CreateImportersImporterProcessPayload';
  errors: Array<MutationError>;
  importerProcess?: Maybe<ImportersImporterProcess>;
};

/** Autogenerated return type of CreateInBulkEmployeesEmployee. */
export type CreateInBulkEmployeesEmployeePayload = {
  __typename?: 'CreateInBulkEmployeesEmployeePayload';
  employee?: Maybe<EmployeesEmployee>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateIntegrationsSyncRunOutput. */
export type CreateIntegrationsSyncRunOutputPayload = {
  __typename?: 'CreateIntegrationsSyncRunOutputPayload';
  errors: Array<MutationError>;
  syncRunOutput?: Maybe<IntegrationsSyncRunOutput>;
};

export type CreateIntegrationsSyncRunParametersInput = {
  key: Scalars['String'];
  value: Scalars['String'];
};

/** Autogenerated return type of CreateIntegrationsSyncRun. */
export type CreateIntegrationsSyncRunPayload = {
  __typename?: 'CreateIntegrationsSyncRunPayload';
  errors: Array<MutationError>;
  syncRun?: Maybe<IntegrationsSyncRun>;
};

/** Autogenerated return type of CreateIntegrationsdatevlaudsEmployeeExport. */
export type CreateIntegrationsdatevlaudsEmployeeExportPayload = {
  __typename?: 'CreateIntegrationsdatevlaudsEmployeeExportPayload';
  employeeExport?: Maybe<IntegrationsDatevLaudsEmployeeExport>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateIntegrationsdatevlaudsEmployeeImport. */
export type CreateIntegrationsdatevlaudsEmployeeImportPayload = {
  __typename?: 'CreateIntegrationsdatevlaudsEmployeeImportPayload';
  employeeImport?: Maybe<IntegrationsDatevLaudsEmployeeImport>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateIntegrationsdatevlaudsExport. */
export type CreateIntegrationsdatevlaudsExportPayload = {
  __typename?: 'CreateIntegrationsdatevlaudsExportPayload';
  errors: Array<MutationError>;
  export?: Maybe<IntegrationsDatevLaudsExport>;
};

/** Autogenerated return type of CreateIntegrationsdatevlaudsRequest. */
export type CreateIntegrationsdatevlaudsRequestPayload = {
  __typename?: 'CreateIntegrationsdatevlaudsRequestPayload';
  errors: Array<MutationError>;
  request?: Maybe<IntegrationsDatevLaudsRequest>;
};

/** Autogenerated return type of CreateIntegrationsindeedAccount. */
export type CreateIntegrationsindeedAccountPayload = {
  __typename?: 'CreateIntegrationsindeedAccountPayload';
  account?: Maybe<IntegrationsIndeedAccount>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateIntegrationsindeedApplication. */
export type CreateIntegrationsindeedApplicationPayload = {
  __typename?: 'CreateIntegrationsindeedApplicationPayload';
  application?: Maybe<IntegrationsIndeedApplication>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateIntegrationsinfojobsOffer. */
export type CreateIntegrationsinfojobsOfferPayload = {
  __typename?: 'CreateIntegrationsinfojobsOfferPayload';
  errors: Array<MutationError>;
  offer?: Maybe<IntegrationsInfojobsOffer>;
};

/** Autogenerated return type of CreateIntegrationsjoinJobPosting. */
export type CreateIntegrationsjoinJobPostingPayload = {
  __typename?: 'CreateIntegrationsjoinJobPostingPayload';
  errors: Array<MutationError>;
  jobPosting?: Maybe<IntegrationsJoinJobPosting>;
};

/** Autogenerated return type of CreateIntegrationsjoinJoinCompany. */
export type CreateIntegrationsjoinJoinCompanyPayload = {
  __typename?: 'CreateIntegrationsjoinJoinCompanyPayload';
  errors: Array<MutationError>;
  joinCompany?: Maybe<IntegrationsJoinJoinCompany>;
};

/** Autogenerated return type of CreateIntegrationsjoinOffice. */
export type CreateIntegrationsjoinOfficePayload = {
  __typename?: 'CreateIntegrationsjoinOfficePayload';
  errors: Array<MutationError>;
  office?: Maybe<IntegrationsJoinOffice>;
};

/** Autogenerated return type of CreateIntegrationsjoinOrder. */
export type CreateIntegrationsjoinOrderPayload = {
  __typename?: 'CreateIntegrationsjoinOrderPayload';
  errors: Array<MutationError>;
  order?: Maybe<IntegrationsJoinOrder>;
};

/** Autogenerated return type of CreateItmanagementDocumentTemplate. */
export type CreateItmanagementDocumentTemplatePayload = {
  __typename?: 'CreateItmanagementDocumentTemplatePayload';
  documentTemplate?: Maybe<ItManagementDocumentTemplate>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateItmanagementItAssetModel. */
export type CreateItmanagementItAssetModelPayload = {
  __typename?: 'CreateItmanagementItAssetModelPayload';
  errors: Array<MutationError>;
  itAssetModel?: Maybe<ItManagementItAssetModel>;
};

/** Autogenerated return type of CreateItmanagementItAsset. */
export type CreateItmanagementItAssetPayload = {
  __typename?: 'CreateItmanagementItAssetPayload';
  errors: Array<MutationError>;
  itAsset?: Maybe<ItManagementItAsset>;
};

/** Autogenerated return type of CreateItmanagementOrder. */
export type CreateItmanagementOrderPayload = {
  __typename?: 'CreateItmanagementOrderPayload';
  errors: Array<MutationError>;
  order?: Maybe<ItManagementOrder>;
};

/** Autogenerated return type of CreateJobcatalogLevel. */
export type CreateJobcatalogLevelPayload = {
  __typename?: 'CreateJobcatalogLevelPayload';
  errors: Array<MutationError>;
  level?: Maybe<JobCatalogLevel>;
};

/** Autogenerated return type of CreateJobcatalogNodeAttribute. */
export type CreateJobcatalogNodeAttributePayload = {
  __typename?: 'CreateJobcatalogNodeAttributePayload';
  errors: Array<MutationError>;
  nodeAttribute?: Maybe<JobCatalogNodeAttribute>;
};

/** Autogenerated return type of CreateJobcatalogRole. */
export type CreateJobcatalogRolePayload = {
  __typename?: 'CreateJobcatalogRolePayload';
  errors: Array<MutationError>;
  role?: Maybe<JobCatalogRole>;
};

/** Autogenerated return type of CreateJobcatalogSalaryRange. */
export type CreateJobcatalogSalaryRangePayload = {
  __typename?: 'CreateJobcatalogSalaryRangePayload';
  errors: Array<MutationError>;
  salaryRange?: Maybe<JobCatalogSalaryRange>;
};

/** Autogenerated return type of CreateJobcatalogTreeNode. */
export type CreateJobcatalogTreeNodePayload = {
  __typename?: 'CreateJobcatalogTreeNodePayload';
  errors: Array<MutationError>;
  treeNode?: Maybe<JobCatalogTreeNode>;
};

/** Autogenerated return type of CreateJobcatalogTree. */
export type CreateJobcatalogTreePayload = {
  __typename?: 'CreateJobcatalogTreePayload';
  errors: Array<MutationError>;
  tree?: Maybe<JobCatalogTree>;
};

/** Autogenerated return type of CreateKudosKudosSent. */
export type CreateKudosKudosSentPayload = {
  __typename?: 'CreateKudosKudosSentPayload';
  errors: Array<MutationError>;
  kudosSent?: Maybe<KudosKudosSent>;
};

/** Autogenerated return type of CreateLayoutFavourite. */
export type CreateLayoutFavouritePayload = {
  __typename?: 'CreateLayoutFavouritePayload';
  errors: Array<MutationError>;
  favourite?: Maybe<LayoutFavourite>;
};

/** Autogenerated return type of CreateLocationsLocation. */
export type CreateLocationsLocationPayload = {
  __typename?: 'CreateLocationsLocationPayload';
  errors: Array<MutationError>;
  location?: Maybe<LocationsLocation>;
};

/** Autogenerated return type of CreateLocationsWorkArea. */
export type CreateLocationsWorkAreaPayload = {
  __typename?: 'CreateLocationsWorkAreaPayload';
  errors: Array<MutationError>;
  workArea?: Maybe<LocationsWorkArea>;
};

/** Autogenerated return type of CreateManualBankingBankAccount. */
export type CreateManualBankingBankAccountPayload = {
  __typename?: 'CreateManualBankingBankAccountPayload';
  bankAccount?: Maybe<BankingBankAccount>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateManuallyItmanagementItAssetDocument. */
export type CreateManuallyItmanagementItAssetDocumentPayload = {
  __typename?: 'CreateManuallyItmanagementItAssetDocumentPayload';
  errors: Array<MutationError>;
  itAssetDocument?: Maybe<ItManagementItAssetDocument>;
};

/** Autogenerated return type of CreateMarketingTrialAction. */
export type CreateMarketingTrialActionPayload = {
  __typename?: 'CreateMarketingTrialActionPayload';
  errors: Array<MutationError>;
  trialAction?: Maybe<MarketingTrialAction>;
};

/** Autogenerated return type of CreateMarketingUserSegmentation. */
export type CreateMarketingUserSegmentationPayload = {
  __typename?: 'CreateMarketingUserSegmentationPayload';
  errors: Array<MutationError>;
  userSegmentation?: Maybe<MarketingUserSegmentation>;
};

/** Autogenerated return type of CreateMarketplaceCompanyInstallation. */
export type CreateMarketplaceCompanyInstallationPayload = {
  __typename?: 'CreateMarketplaceCompanyInstallationPayload';
  companyInstallation?: Maybe<MarketplaceCompanyInstallation>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateMeetingsMeeting. */
export type CreateMeetingsMeetingPayload = {
  __typename?: 'CreateMeetingsMeetingPayload';
  errors: Array<MutationError>;
  meeting?: Maybe<MeetingsMeeting>;
};

/** Autogenerated return type of CreateMeetingsSetting. */
export type CreateMeetingsSettingPayload = {
  __typename?: 'CreateMeetingsSettingPayload';
  errors: Array<MutationError>;
  setting?: Maybe<MeetingsSetting>;
};

/** Autogenerated return type of CreateMeetingsTemplate. */
export type CreateMeetingsTemplatePayload = {
  __typename?: 'CreateMeetingsTemplatePayload';
  errors: Array<MutationError>;
  template?: Maybe<MeetingsTemplate>;
};

/** Autogenerated return type of CreateMeetingsTranscriptionSession. */
export type CreateMeetingsTranscriptionSessionPayload = {
  __typename?: 'CreateMeetingsTranscriptionSessionPayload';
  errors: Array<MutationError>;
  transcriptionSession?: Maybe<MeetingsTranscriptionSession>;
};

/** Autogenerated return type of CreateModuleTrialCompaniesSubscriptionOverload. */
export type CreateModuleTrialCompaniesSubscriptionOverloadPayload = {
  __typename?: 'CreateModuleTrialCompaniesSubscriptionOverloadPayload';
  errors: Array<MutationError>;
  subscriptionOverload?: Maybe<CompaniesSubscriptionOverload>;
};

/** Autogenerated return type of CreateModulesEmailModuleRequest. */
export type CreateModulesEmailModuleRequestPayload = {
  __typename?: 'CreateModulesEmailModuleRequestPayload';
  emailModuleRequest?: Maybe<ModulesEmailModuleRequest>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateModulesModuleRequest. */
export type CreateModulesModuleRequestPayload = {
  __typename?: 'CreateModulesModuleRequestPayload';
  errors: Array<MutationError>;
  moduleRequest?: Maybe<ModulesModuleRequest>;
};

/** Autogenerated return type of CreateNpsSurveyResponseIntent. */
export type CreateNpsSurveyResponseIntentPayload = {
  __typename?: 'CreateNpsSurveyResponseIntentPayload';
  errors: Array<MutationError>;
  surveyResponseIntent?: Maybe<NpsSurveyResponseIntent>;
};

/** Autogenerated return type of CreateNpsSurveyResponse. */
export type CreateNpsSurveyResponsePayload = {
  __typename?: 'CreateNpsSurveyResponsePayload';
  errors: Array<MutationError>;
  surveyResponse?: Maybe<NpsSurveyResponse>;
};

/** Autogenerated return type of CreateOneononesInsight. */
export type CreateOneononesInsightPayload = {
  __typename?: 'CreateOneononesInsightPayload';
  errors: Array<MutationError>;
  insight?: Maybe<OneOnOnesInsight>;
};

/** Autogenerated return type of CreateOneononesMeeting. */
export type CreateOneononesMeetingPayload = {
  __typename?: 'CreateOneononesMeetingPayload';
  errors: Array<MutationError>;
  meeting?: Maybe<OneOnOnesMeeting>;
};

/** Autogenerated return type of CreateOneononesTask. */
export type CreateOneononesTaskPayload = {
  __typename?: 'CreateOneononesTaskPayload';
  errors: Array<MutationError>;
  task?: Maybe<OneOnOnesTask>;
};

/** Autogenerated return type of CreateOpenaiFeedback. */
export type CreateOpenaiFeedbackPayload = {
  __typename?: 'CreateOpenaiFeedbackPayload';
  errors: Array<MutationError>;
  feedback?: Maybe<OpenAiFeedback>;
};

/** Autogenerated return type of CreatePagesPage. */
export type CreatePagesPagePayload = {
  __typename?: 'CreatePagesPagePayload';
  errors: Array<MutationError>;
  page?: Maybe<PagesPage>;
};

/** Autogenerated return type of CreatePayrollConcept. */
export type CreatePayrollConceptPayload = {
  __typename?: 'CreatePayrollConceptPayload';
  concept?: Maybe<PayrollConcept>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreatePayrollExpensesCategoriesContractsTaxonomy. */
export type CreatePayrollExpensesCategoriesContractsTaxonomyPayload = {
  __typename?: 'CreatePayrollExpensesCategoriesContractsTaxonomyPayload';
  errors: Array<MutationError>;
  expensesCategoriesContractsTaxonomy?: Maybe<PayrollExpensesCategoriesContractsTaxonomy>;
};

/** Autogenerated return type of CreatePayrollFamilySituation. */
export type CreatePayrollFamilySituationPayload = {
  __typename?: 'CreatePayrollFamilySituationPayload';
  errors: Array<MutationError>;
  familySituation?: Maybe<PayrollFamilySituation>;
};

/** Autogenerated return type of CreatePayrollInhouseActivation. */
export type CreatePayrollInhouseActivationPayload = {
  __typename?: 'CreatePayrollInhouseActivationPayload';
  errors: Array<MutationError>;
  inhouseActivation?: Maybe<PayrollInhouseActivation>;
};

/** Autogenerated return type of CreatePayrollOnboarding. */
export type CreatePayrollOnboardingPayload = {
  __typename?: 'CreatePayrollOnboardingPayload';
  errors: Array<MutationError>;
  onboarding?: Maybe<PayrollOnboarding>;
};

export type CreatePayrollOnboardingPolicyInput = {
  companyId: Scalars['Int'];
  country?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  default?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  recurrence: Scalars['String'];
  startsOn: Scalars['ISO8601Date'];
};

export type CreatePayrollOnboardingPolicyWithEmployeesInput = {
  employeeIds: Array<Scalars['String']>;
  policy: CreatePayrollOnboardingPolicyInput;
};

/** Autogenerated return type of CreatePayrollPayrollDocument. */
export type CreatePayrollPayrollDocumentPayload = {
  __typename?: 'CreatePayrollPayrollDocumentPayload';
  errors: Array<MutationError>;
  payrollDocument?: Maybe<PayrollPayrollDocument>;
};

/** Autogenerated return type of CreatePayrollPayrollSummaryImport. */
export type CreatePayrollPayrollSummaryImportPayload = {
  __typename?: 'CreatePayrollPayrollSummaryImportPayload';
  errors: Array<MutationError>;
  payrollSummaryImport?: Maybe<PayrollPayrollSummaryImport>;
};

/** Autogenerated return type of CreatePayrollPolicy. */
export type CreatePayrollPolicyPayload = {
  __typename?: 'CreatePayrollPolicyPayload';
  errors: Array<MutationError>;
  policy?: Maybe<PayrollPolicy>;
};

/** Autogenerated return type of CreatePayrollReimbursableSupplementTaxonomy. */
export type CreatePayrollReimbursableSupplementTaxonomyPayload = {
  __typename?: 'CreatePayrollReimbursableSupplementTaxonomyPayload';
  errors: Array<MutationError>;
  reimbursableSupplementTaxonomy?: Maybe<PayrollReimbursableSupplementTaxonomy>;
};

/** Autogenerated return type of CreatePayrollResultLabelConceptMapping. */
export type CreatePayrollResultLabelConceptMappingPayload = {
  __typename?: 'CreatePayrollResultLabelConceptMappingPayload';
  errors: Array<MutationError>;
  resultLabelConceptMapping?: Maybe<PayrollResultLabelConceptMapping>;
};

/** Autogenerated return type of CreatePayrollResult. */
export type CreatePayrollResultPayload = {
  __typename?: 'CreatePayrollResultPayload';
  errors: Array<MutationError>;
  result?: Maybe<PayrollResult>;
};

export type CreatePayrollResultResultConceptItemsInput = {
  amount: Scalars['BigInt'];
  employeeId: Scalars['Int'];
  payrollConceptId: Scalars['Int'];
};

/** Autogenerated return type of CreatePayrollSupplementBulkImport. */
export type CreatePayrollSupplementBulkImportPayload = {
  __typename?: 'CreatePayrollSupplementBulkImportPayload';
  errors: Array<MutationError>;
  supplementBulkImport?: Maybe<PayrollSupplementBulkImport>;
};

export type CreatePayrollSupplementBulkImportSupplementsInput = {
  amountInCents: Scalars['Int'];
  contractsTaxonomyId: Scalars['Int'];
  effectiveOn: Scalars['ISO8601Date'];
  employeeId: Scalars['Int'];
  payrollPolicyPeriodId: Scalars['Int'];
  unit: Scalars['String'];
};

/** Autogenerated return type of CreatePayrollSupplementObservation. */
export type CreatePayrollSupplementObservationPayload = {
  __typename?: 'CreatePayrollSupplementObservationPayload';
  errors: Array<MutationError>;
  supplementObservation?: Maybe<PayrollSupplementObservation>;
};

/** Autogenerated return type of CreatePayrollSupplement. */
export type CreatePayrollSupplementPayload = {
  __typename?: 'CreatePayrollSupplementPayload';
  errors: Array<MutationError>;
  supplement?: Maybe<PayrollSupplement>;
};

/** Autogenerated return type of CreatePayrollSupplementValidation. */
export type CreatePayrollSupplementValidationPayload = {
  __typename?: 'CreatePayrollSupplementValidationPayload';
  errors: Array<MutationError>;
  supplementValidation?: Maybe<PayrollSupplementValidation>;
};

/** Autogenerated return type of CreatePayrollemployeesEmployeeDatum. */
export type CreatePayrollemployeesEmployeeDatumPayload = {
  __typename?: 'CreatePayrollemployeesEmployeeDatumPayload';
  employeeDatum?: Maybe<PayrollEmployeesEmployeeDatum>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreatePayrollemployeesIdentifier. */
export type CreatePayrollemployeesIdentifierPayload = {
  __typename?: 'CreatePayrollemployeesIdentifierPayload';
  errors: Array<MutationError>;
  identifier?: Maybe<PayrollEmployeesIdentifier>;
};

/** Autogenerated return type of CreatePayrollexporterExport. */
export type CreatePayrollexporterExportPayload = {
  __typename?: 'CreatePayrollexporterExportPayload';
  errors: Array<MutationError>;
  export?: Maybe<PayrollExporterExport>;
};

/** Autogenerated return type of CreatePayrollintegrationsBaseCode. */
export type CreatePayrollintegrationsBaseCodePayload = {
  __typename?: 'CreatePayrollintegrationsBaseCodePayload';
  code?: Maybe<PayrollIntegrationsBaseCode>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreatePerformanceReviewProcess. */
export type CreatePerformanceReviewProcessPayload = {
  __typename?: 'CreatePerformanceReviewProcessPayload';
  errors: Array<MutationError>;
  reviewProcess?: Maybe<PerformanceReviewProcess>;
};

/** Autogenerated return type of CreatePerformancecyclesCycle. */
export type CreatePerformancecyclesCyclePayload = {
  __typename?: 'CreatePerformancecyclesCyclePayload';
  cycle?: Maybe<PerformanceCyclesCycle>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreatePermissionsPermissionGroup. */
export type CreatePermissionsPermissionGroupPayload = {
  __typename?: 'CreatePermissionsPermissionGroupPayload';
  errors: Array<MutationError>;
  permissionGroup?: Maybe<PermissionsPermissionGroup>;
};

export type CreatePhysicalBankingCardCardholderDataInput = {
  dateOfBirth: Scalars['ISO8601Date'];
  email?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phoneCountryCode: Scalars['String'];
  phoneNumber: Scalars['String'];
};

/** Autogenerated return type of CreatePhysicalBankingCard. */
export type CreatePhysicalBankingCardPayload = {
  __typename?: 'CreatePhysicalBankingCardPayload';
  card?: Maybe<BankingCard>;
  errors: Array<MutationError>;
};

export type CreatePhysicalBankingCardShippingInput = {
  addressLine1: Scalars['String'];
  addressLine2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  companyEmployeeFullName?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  companyPhoneCountryCode?: InputMaybe<Scalars['String']>;
  companyPhoneNumber?: InputMaybe<Scalars['String']>;
  country: Scalars['String'];
  postalCode: Scalars['String'];
  sendingType: BankingValueObjectsCardSendingTypeEnum;
  state?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of CreatePositionsPosition. */
export type CreatePositionsPositionPayload = {
  __typename?: 'CreatePositionsPositionPayload';
  errors: Array<MutationError>;
  position?: Maybe<PositionsPosition>;
};

/** Autogenerated return type of CreatePostsComment. */
export type CreatePostsCommentPayload = {
  __typename?: 'CreatePostsCommentPayload';
  comment?: Maybe<PostsComment>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreatePostsGroup. */
export type CreatePostsGroupPayload = {
  __typename?: 'CreatePostsGroupPayload';
  errors: Array<MutationError>;
  group?: Maybe<PostsGroup>;
};

/** Autogenerated return type of CreatePostsPost. */
export type CreatePostsPostPayload = {
  __typename?: 'CreatePostsPostPayload';
  errors: Array<MutationError>;
  post?: Maybe<PostsPost>;
};

/** Autogenerated return type of CreatePostsReaction. */
export type CreatePostsReactionPayload = {
  __typename?: 'CreatePostsReactionPayload';
  errors: Array<MutationError>;
  reaction?: Maybe<PostsReaction>;
};

export type CreateProcessesActionItemInput = {
  actionConfiguration?: InputMaybe<Scalars['String']>;
  actionConfigurationIdentifier?: InputMaybe<Scalars['String']>;
  assigneeIds?: InputMaybe<Array<Scalars['Int']>>;
  assigneeStrategy?: InputMaybe<Scalars['String']>;
  configurationId?: InputMaybe<Scalars['Int']>;
  configurationType?: InputMaybe<Scalars['String']>;
  dataCollectionConfiguration?: InputMaybe<ProcessesDataCollectionConfigurationInput>;
  instruction?: InputMaybe<Scalars['String']>;
  mandatory?: InputMaybe<Scalars['Boolean']>;
  offsetAmount?: InputMaybe<Scalars['Int']>;
  offsetDirection?: InputMaybe<Scalars['String']>;
  position: Scalars['Int'];
  referenceFieldKey?: InputMaybe<Scalars['String']>;
  signatureDocuments?: InputMaybe<CreateProcessesActionSignatureDocumentsInput>;
  stepId?: InputMaybe<Scalars['Int']>;
  taskType?: InputMaybe<Scalars['String']>;
  taskTypeConfiguration?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of CreateProcessesAction. */
export type CreateProcessesActionPayload = {
  __typename?: 'CreateProcessesActionPayload';
  action?: Maybe<ProcessesAction>;
  errors: Array<MutationError>;
};

export type CreateProcessesActionSignatureDocumentsInput = {
  filesToAdd?: InputMaybe<Array<Scalars['File']>>;
  filesToRemove?: InputMaybe<Array<Scalars['Int']>>;
};

/** Autogenerated return type of CreateProcessesItemAssignee. */
export type CreateProcessesItemAssigneePayload = {
  __typename?: 'CreateProcessesItemAssigneePayload';
  errors: Array<MutationError>;
  itemAssignee?: Maybe<ProcessesItemAssignee>;
};

/** Autogenerated return type of CreateProcessesItem. */
export type CreateProcessesItemPayload = {
  __typename?: 'CreateProcessesItemPayload';
  errors: Array<MutationError>;
  item?: Maybe<ProcessesItem>;
};

export type CreateProcessesItemSignatureDocumentsInput = {
  filesToAdd?: InputMaybe<Array<Scalars['File']>>;
  filesToRemove?: InputMaybe<Array<Scalars['Int']>>;
};

/** Autogenerated return type of CreateProcessesMaterializedAssignee. */
export type CreateProcessesMaterializedAssigneePayload = {
  __typename?: 'CreateProcessesMaterializedAssigneePayload';
  errors: Array<MutationError>;
  materializedAssignee?: Maybe<ProcessesMaterializedAssignee>;
};

/** Autogenerated return type of CreateProcessesMaterializedItem. */
export type CreateProcessesMaterializedItemPayload = {
  __typename?: 'CreateProcessesMaterializedItemPayload';
  errors: Array<MutationError>;
  materializedItem?: Maybe<ProcessesMaterializedItem>;
};

/** Autogenerated return type of CreateProcessesMaterializedProcess. */
export type CreateProcessesMaterializedProcessPayload = {
  __typename?: 'CreateProcessesMaterializedProcessPayload';
  errors: Array<MutationError>;
  materializedProcess?: Maybe<ProcessesMaterializedProcess>;
};

/** Autogenerated return type of CreateProcessesMaterializedStep. */
export type CreateProcessesMaterializedStepPayload = {
  __typename?: 'CreateProcessesMaterializedStepPayload';
  errors: Array<MutationError>;
  materializedStep?: Maybe<ProcessesMaterializedStep>;
};

export type CreateProcessesProcessItemsInput = {
  actionConfiguration?: InputMaybe<Scalars['String']>;
  actionConfigurationIdentifier?: InputMaybe<Scalars['String']>;
  assigneeIds?: InputMaybe<Array<Scalars['Int']>>;
  assigneeStrategy?: InputMaybe<Scalars['String']>;
  configurationId?: InputMaybe<Scalars['Int']>;
  configurationType?: InputMaybe<Scalars['String']>;
  dataCollectionConfiguration?: InputMaybe<ProcessesDataCollectionConfigurationInput>;
  instruction?: InputMaybe<Scalars['String']>;
  mandatory?: InputMaybe<Scalars['Boolean']>;
  offsetAmount?: InputMaybe<Scalars['Int']>;
  offsetDirection?: InputMaybe<Scalars['String']>;
  position: Scalars['Int'];
  referenceFieldKey?: InputMaybe<Scalars['String']>;
  signatureDocuments?: InputMaybe<CreateProcessesProcessSignatureDocumentsInput>;
  stepId?: InputMaybe<Scalars['Int']>;
  taskType?: InputMaybe<Scalars['String']>;
  taskTypeConfiguration?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of CreateProcessesProcess. */
export type CreateProcessesProcessPayload = {
  __typename?: 'CreateProcessesProcessPayload';
  errors: Array<MutationError>;
  process?: Maybe<ProcessesProcess>;
};

export type CreateProcessesProcessSignatureDocumentsInput = {
  filesToAdd?: InputMaybe<Array<Scalars['File']>>;
  filesToRemove?: InputMaybe<Array<Scalars['Int']>>;
};

export type CreateProcessesProcessStepsInput = {
  items?: InputMaybe<Array<CreateProcessesProcessItemsInput>>;
  name: Scalars['String'];
  offsetAmount?: InputMaybe<Scalars['Int']>;
  offsetDirection?: InputMaybe<Scalars['String']>;
  position: Scalars['Int'];
  processId?: InputMaybe<Scalars['Int']>;
  progressionCondition?: InputMaybe<Scalars['String']>;
  progressionConditionResourceKey?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of CreateProcessesResourceRelationship. */
export type CreateProcessesResourceRelationshipPayload = {
  __typename?: 'CreateProcessesResourceRelationshipPayload';
  errors: Array<MutationError>;
  resourceRelationship?: Maybe<ProcessesResourceRelationship>;
};

export type CreateProcessesStepItemsInput = {
  actionConfiguration?: InputMaybe<Scalars['String']>;
  actionConfigurationIdentifier?: InputMaybe<Scalars['String']>;
  assigneeIds?: InputMaybe<Array<Scalars['Int']>>;
  assigneeStrategy?: InputMaybe<Scalars['String']>;
  configurationId?: InputMaybe<Scalars['Int']>;
  configurationType?: InputMaybe<Scalars['String']>;
  dataCollectionConfiguration?: InputMaybe<ProcessesDataCollectionConfigurationInput>;
  instruction?: InputMaybe<Scalars['String']>;
  mandatory?: InputMaybe<Scalars['Boolean']>;
  offsetAmount?: InputMaybe<Scalars['Int']>;
  offsetDirection?: InputMaybe<Scalars['String']>;
  position: Scalars['Int'];
  referenceFieldKey?: InputMaybe<Scalars['String']>;
  signatureDocuments?: InputMaybe<CreateProcessesStepSignatureDocumentsInput>;
  stepId?: InputMaybe<Scalars['Int']>;
  taskType?: InputMaybe<Scalars['String']>;
  taskTypeConfiguration?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of CreateProcessesStep. */
export type CreateProcessesStepPayload = {
  __typename?: 'CreateProcessesStepPayload';
  errors: Array<MutationError>;
  step?: Maybe<ProcessesStep>;
};

export type CreateProcessesStepSignatureDocumentsInput = {
  filesToAdd?: InputMaybe<Array<Scalars['File']>>;
  filesToRemove?: InputMaybe<Array<Scalars['Int']>>;
};

/** Autogenerated return type of CreateProcurementPurchaseRequest. */
export type CreateProcurementPurchaseRequestPayload = {
  __typename?: 'CreateProcurementPurchaseRequestPayload';
  errors: Array<MutationError>;
  purchaseRequest?: Maybe<ProcurementPurchaseRequest>;
};

/** Autogenerated return type of CreateProcurementType. */
export type CreateProcurementTypePayload = {
  __typename?: 'CreateProcurementTypePayload';
  errors: Array<MutationError>;
  type?: Maybe<ProcurementType>;
};

/** Autogenerated return type of CreateProductupdatesHeaderView. */
export type CreateProductupdatesHeaderViewPayload = {
  __typename?: 'CreateProductupdatesHeaderViewPayload';
  errors: Array<MutationError>;
  headerView?: Maybe<ProductUpdatesHeaderView>;
};

/** Autogenerated return type of CreateProductupdatesSharedUpdate. */
export type CreateProductupdatesSharedUpdatePayload = {
  __typename?: 'CreateProductupdatesSharedUpdatePayload';
  errors: Array<MutationError>;
  sharedUpdate?: Maybe<ProductUpdatesSharedUpdate>;
};

/** Autogenerated return type of CreateProductupdatesSubscription. */
export type CreateProductupdatesSubscriptionPayload = {
  __typename?: 'CreateProductupdatesSubscriptionPayload';
  errors: Array<MutationError>;
  subscription?: Maybe<ProductUpdatesSubscription>;
};

/** Autogenerated return type of CreateProductupdatesWaitlist. */
export type CreateProductupdatesWaitlistPayload = {
  __typename?: 'CreateProductupdatesWaitlistPayload';
  errors: Array<MutationError>;
  waitlist?: Maybe<ProductUpdatesWaitlist>;
};

/** Autogenerated return type of CreateProjectmanagementBudgetStrategy. */
export type CreateProjectmanagementBudgetStrategyPayload = {
  __typename?: 'CreateProjectmanagementBudgetStrategyPayload';
  budgetStrategy?: Maybe<ProjectManagementBudgetStrategy>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateProjectmanagementFavouriteProject. */
export type CreateProjectmanagementFavouriteProjectPayload = {
  __typename?: 'CreateProjectmanagementFavouriteProjectPayload';
  errors: Array<MutationError>;
  favouriteProject?: Maybe<ProjectManagementFavouriteProject>;
};

/** Autogenerated return type of CreateProjectmanagementFixedCostPlanning. */
export type CreateProjectmanagementFixedCostPlanningPayload = {
  __typename?: 'CreateProjectmanagementFixedCostPlanningPayload';
  errors: Array<MutationError>;
  fixedCostPlanning?: Maybe<ProjectManagementFixedCostPlanning>;
};

/** Autogenerated return type of CreateProjectmanagementFixedTimeBudget. */
export type CreateProjectmanagementFixedTimeBudgetPayload = {
  __typename?: 'CreateProjectmanagementFixedTimeBudgetPayload';
  errors: Array<MutationError>;
  fixedTimeBudget?: Maybe<ProjectManagementFixedTimeBudget>;
};

/** Autogenerated return type of CreateProjectmanagementFlexibleTimeRecordComment. */
export type CreateProjectmanagementFlexibleTimeRecordCommentPayload = {
  __typename?: 'CreateProjectmanagementFlexibleTimeRecordCommentPayload';
  errors: Array<MutationError>;
  flexibleTimeRecordComment?: Maybe<ProjectManagementFlexibleTimeRecordComment>;
};

/** Autogenerated return type of CreateProjectmanagementFlexibleTimeRecord. */
export type CreateProjectmanagementFlexibleTimeRecordPayload = {
  __typename?: 'CreateProjectmanagementFlexibleTimeRecordPayload';
  errors: Array<MutationError>;
  flexibleTimeRecord?: Maybe<ProjectManagementFlexibleTimeRecord>;
};

/** Autogenerated return type of CreateProjectmanagementProject. */
export type CreateProjectmanagementProjectPayload = {
  __typename?: 'CreateProjectmanagementProjectPayload';
  errors: Array<MutationError>;
  project?: Maybe<ProjectManagementProject>;
};

/** Autogenerated return type of CreateProjectmanagementProjectTask. */
export type CreateProjectmanagementProjectTaskPayload = {
  __typename?: 'CreateProjectmanagementProjectTaskPayload';
  errors: Array<MutationError>;
  projectTask?: Maybe<ProjectManagementProjectTask>;
};

/** Autogenerated return type of CreateProjectmanagementProjectWorker. */
export type CreateProjectmanagementProjectWorkerPayload = {
  __typename?: 'CreateProjectmanagementProjectWorkerPayload';
  errors: Array<MutationError>;
  projectWorker?: Maybe<ProjectManagementProjectWorker>;
};

/** Autogenerated return type of CreateProjectmanagementRate. */
export type CreateProjectmanagementRatePayload = {
  __typename?: 'CreateProjectmanagementRatePayload';
  errors: Array<MutationError>;
  rate?: Maybe<ProjectManagementRate>;
};

/** Autogenerated return type of CreateProjectmanagementSubproject. */
export type CreateProjectmanagementSubprojectPayload = {
  __typename?: 'CreateProjectmanagementSubprojectPayload';
  errors: Array<MutationError>;
  subproject?: Maybe<ProjectManagementSubproject>;
};

/** Autogenerated return type of CreateProjectmanagementTimeRecord. */
export type CreateProjectmanagementTimeRecordPayload = {
  __typename?: 'CreateProjectmanagementTimeRecordPayload';
  errors: Array<MutationError>;
  timeRecord?: Maybe<ProjectManagementTimeRecord>;
};

/** Autogenerated return type of CreateProjectmanagementUpsellNotificationMessage. */
export type CreateProjectmanagementUpsellNotificationMessagePayload = {
  __typename?: 'CreateProjectmanagementUpsellNotificationMessagePayload';
  errors: Array<MutationError>;
  upsellNotificationMessage?: Maybe<ProjectManagementUpsellNotificationMessage>;
};

export type CreatePromoteRequestContractsContractVersionRequestAdditionalCompensationsInput = {
  amount?: InputMaybe<Scalars['Int']>;
  calculation?: InputMaybe<Scalars['String']>;
  compensationType?: InputMaybe<Scalars['String']>;
  contractsTaxonomyId: Scalars['Int'];
  description?: InputMaybe<Scalars['String']>;
  firstPaymentOn?: InputMaybe<Scalars['ISO8601Date']>;
  id?: InputMaybe<Scalars['Int']>;
  minimumAmountOfHours?: InputMaybe<Scalars['Int']>;
  minimumAmountOfHoursInCents?: InputMaybe<Scalars['Int']>;
  payrollPolicyId?: InputMaybe<Scalars['Int']>;
  recurrence?: InputMaybe<Scalars['String']>;
  recurrenceCount?: InputMaybe<Scalars['Int']>;
  startsOn?: InputMaybe<Scalars['ISO8601Date']>;
  syncWithSupplements?: InputMaybe<Scalars['Boolean']>;
  timeCondition?: InputMaybe<ContractsValueObjectsTimeConditionEnum>;
  unit?: InputMaybe<Scalars['String']>;
};

export type CreatePromoteRequestContractsContractVersionRequestNewAdditionalCompensationsInput = {
  amount?: InputMaybe<Scalars['Int']>;
  amountStrategyType: Scalars['String'];
  contractVersionId: Scalars['Int'];
  description?: InputMaybe<Scalars['String']>;
  firstPaymentOn?: InputMaybe<Scalars['ISO8601Date']>;
  id?: InputMaybe<Scalars['Int']>;
  payrollConceptId: Scalars['Int'];
  recurrence?: InputMaybe<Scalars['String']>;
  upperLimit?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of CreatePromoteRequestContractsContractVersionRequest. */
export type CreatePromoteRequestContractsContractVersionRequestPayload = {
  __typename?: 'CreatePromoteRequestContractsContractVersionRequestPayload';
  contractVersionRequest?: Maybe<ContractsContractVersionRequest>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateReportsContent. */
export type CreateReportsContentPayload = {
  __typename?: 'CreateReportsContentPayload';
  content?: Maybe<ReportsContent>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateReportsDashboard. */
export type CreateReportsDashboardPayload = {
  __typename?: 'CreateReportsDashboardPayload';
  dashboard?: Maybe<ReportsDashboard>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateReportsExportInsight. */
export type CreateReportsExportInsightPayload = {
  __typename?: 'CreateReportsExportInsightPayload';
  errors: Array<MutationError>;
  exportInsight?: Maybe<ReportsExportInsight>;
};

/** Autogenerated return type of CreateReportsFavourite. */
export type CreateReportsFavouritePayload = {
  __typename?: 'CreateReportsFavouritePayload';
  errors: Array<MutationError>;
  favourite?: Maybe<ReportsFavourite>;
};

/** Autogenerated return type of CreateReportsRefresh. */
export type CreateReportsRefreshPayload = {
  __typename?: 'CreateReportsRefreshPayload';
  errors: Array<MutationError>;
  refresh?: Maybe<ReportsRefresh>;
};

/** Autogenerated return type of CreateReportsReport. */
export type CreateReportsReportPayload = {
  __typename?: 'CreateReportsReportPayload';
  errors: Array<MutationError>;
  report?: Maybe<ReportsReport>;
};

/** Autogenerated return type of CreateReportsValidateProjection. */
export type CreateReportsValidateProjectionPayload = {
  __typename?: 'CreateReportsValidateProjectionPayload';
  errors: Array<MutationError>;
  validateProjection?: Maybe<ReportsValidateProjection>;
};

/** Autogenerated return type of CreateSalaryadvanceRequest. */
export type CreateSalaryadvanceRequestPayload = {
  __typename?: 'CreateSalaryadvanceRequestPayload';
  errors: Array<MutationError>;
  request?: Maybe<SalaryAdvanceRequest>;
};

/** Autogenerated return type of CreateShiftmanagementAutoSchedulerExecution. */
export type CreateShiftmanagementAutoSchedulerExecutionPayload = {
  __typename?: 'CreateShiftmanagementAutoSchedulerExecutionPayload';
  autoSchedulerExecution?: Maybe<ShiftManagementAutoSchedulerExecution>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateShiftmanagementDefaultShift. */
export type CreateShiftmanagementDefaultShiftPayload = {
  __typename?: 'CreateShiftmanagementDefaultShiftPayload';
  defaultShift?: Maybe<ShiftManagementDefaultShift>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateShiftmanagementShift. */
export type CreateShiftmanagementShiftPayload = {
  __typename?: 'CreateShiftmanagementShiftPayload';
  errors: Array<MutationError>;
  shift?: Maybe<ShiftManagementShift>;
};

/** Autogenerated return type of CreateShiftmanagementSwapShift. */
export type CreateShiftmanagementSwapShiftPayload = {
  __typename?: 'CreateShiftmanagementSwapShiftPayload';
  errors: Array<MutationError>;
  swapShift?: Maybe<ShiftManagementSwapShift>;
};

/** Autogenerated return type of CreateShiftmanagementTemplate. */
export type CreateShiftmanagementTemplatePayload = {
  __typename?: 'CreateShiftmanagementTemplatePayload';
  errors: Array<MutationError>;
  template?: Maybe<ShiftManagementTemplate>;
};

/** Autogenerated return type of CreateShiftmanagementTemplateWeek. */
export type CreateShiftmanagementTemplateWeekPayload = {
  __typename?: 'CreateShiftmanagementTemplateWeekPayload';
  errors: Array<MutationError>;
  templateWeek?: Maybe<ShiftManagementTemplateWeek>;
};

/** Autogenerated return type of CreateShiftmanagementUnassignedShift. */
export type CreateShiftmanagementUnassignedShiftPayload = {
  __typename?: 'CreateShiftmanagementUnassignedShiftPayload';
  errors: Array<MutationError>;
  unassignedShift?: Maybe<ShiftManagementUnassignedShift>;
};

/** Autogenerated return type of CreateSimpleFinanceLineItem. */
export type CreateSimpleFinanceLineItemPayload = {
  __typename?: 'CreateSimpleFinanceLineItemPayload';
  errors: Array<MutationError>;
  lineItem?: Maybe<FinanceLineItem>;
};

export type CreateSingleUseBankingCardCardholderDataInput = {
  dateOfBirth: Scalars['ISO8601Date'];
  email?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phoneCountryCode: Scalars['String'];
  phoneNumber: Scalars['String'];
};

/** Autogenerated return type of CreateSingleUseBankingCard. */
export type CreateSingleUseBankingCardPayload = {
  __typename?: 'CreateSingleUseBankingCardPayload';
  card?: Maybe<BankingCard>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateSoftwaremanagementCustomSoftware. */
export type CreateSoftwaremanagementCustomSoftwarePayload = {
  __typename?: 'CreateSoftwaremanagementCustomSoftwarePayload';
  customSoftware?: Maybe<SoftwareManagementCustomSoftware>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateSoftwaremanagementEmployeeSoftwareMembership. */
export type CreateSoftwaremanagementEmployeeSoftwareMembershipPayload = {
  __typename?: 'CreateSoftwaremanagementEmployeeSoftwareMembershipPayload';
  employeeSoftwareMembership?: Maybe<SoftwareManagementEmployeeSoftwareMembership>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateSoftwaremanagementSoftwarePayment. */
export type CreateSoftwaremanagementSoftwarePaymentPayload = {
  __typename?: 'CreateSoftwaremanagementSoftwarePaymentPayload';
  errors: Array<MutationError>;
  softwarePayment?: Maybe<SoftwareManagementSoftwarePayment>;
};

export type CreateSoftwaremanagementSoftwareSetupCardholderDataInput = {
  dateOfBirth: Scalars['ISO8601Date'];
  email?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phoneCountryCode: Scalars['String'];
  phoneNumber: Scalars['String'];
};

/** Autogenerated return type of CreateSoftwaremanagementSoftwareSetup. */
export type CreateSoftwaremanagementSoftwareSetupPayload = {
  __typename?: 'CreateSoftwaremanagementSoftwareSetupPayload';
  errors: Array<MutationError>;
  softwareSetup?: Maybe<SoftwareManagementSoftwareSetup>;
};

/** Autogenerated return type of CreateSpacecontrolWorkAreaMap. */
export type CreateSpacecontrolWorkAreaMapPayload = {
  __typename?: 'CreateSpacecontrolWorkAreaMapPayload';
  errors: Array<MutationError>;
  workAreaMap?: Maybe<SpaceControlWorkAreaMap>;
};

/** Autogenerated return type of CreateSpacecontrolWorkSpace. */
export type CreateSpacecontrolWorkSpacePayload = {
  __typename?: 'CreateSpacecontrolWorkSpacePayload';
  errors: Array<MutationError>;
  workSpace?: Maybe<SpaceControlWorkSpace>;
};

/** Autogenerated return type of CreateSurveysEditor. */
export type CreateSurveysEditorPayload = {
  __typename?: 'CreateSurveysEditorPayload';
  editor?: Maybe<SurveysEditor>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateSurveysSurvey. */
export type CreateSurveysSurveyPayload = {
  __typename?: 'CreateSurveysSurveyPayload';
  errors: Array<MutationError>;
  survey?: Maybe<SurveysSurvey>;
};

/** Autogenerated return type of CreateTaskCommentReactionTasksTask. */
export type CreateTaskCommentReactionTasksTaskPayload = {
  __typename?: 'CreateTaskCommentReactionTasksTaskPayload';
  errors: Array<MutationError>;
  task?: Maybe<TasksTask>;
};

/** Autogenerated return type of CreateTasksTaskFile. */
export type CreateTasksTaskFilePayload = {
  __typename?: 'CreateTasksTaskFilePayload';
  errors: Array<MutationError>;
  taskFile?: Maybe<TasksTaskFile>;
};

/** Autogenerated return type of CreateTasksTask. */
export type CreateTasksTaskPayload = {
  __typename?: 'CreateTasksTaskPayload';
  errors: Array<MutationError>;
  task?: Maybe<TasksTask>;
};

/** Autogenerated return type of CreateTeamsMembership. */
export type CreateTeamsMembershipPayload = {
  __typename?: 'CreateTeamsMembershipPayload';
  errors: Array<MutationError>;
  membership?: Maybe<TeamsMembership>;
};

/** Autogenerated return type of CreateTeamsTeam. */
export type CreateTeamsTeamPayload = {
  __typename?: 'CreateTeamsTeamPayload';
  errors: Array<MutationError>;
  team?: Maybe<TeamsTeam>;
};

/** Autogenerated return type of CreateTimeoffAllowanceIncidence. */
export type CreateTimeoffAllowanceIncidencePayload = {
  __typename?: 'CreateTimeoffAllowanceIncidencePayload';
  allowanceIncidence?: Maybe<TimeoffAllowanceIncidence>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateTimeoffAllowance. */
export type CreateTimeoffAllowancePayload = {
  __typename?: 'CreateTimeoffAllowancePayload';
  allowance?: Maybe<TimeoffAllowance>;
  errors: Array<MutationError>;
};

export type CreateTimeoffAllowanceTenurePeriodsInput = {
  adjustmentInCents?: InputMaybe<Scalars['Int']>;
  balanceType: TimeoffAllowanceTenurePeriodBalanceTypeEnum;
  maxCapInCents?: InputMaybe<Scalars['Int']>;
  periodLength: Scalars['Int'];
  periodType: TimeoffAllowanceTenurePeriodPeriodTypeEnum;
  tempId?: InputMaybe<Scalars['Int']>;
  timeWorkedBasedHoursAccruedInCents?: InputMaybe<Scalars['Int']>;
  timeWorkedBasedPerHoursWorkedInCents?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of CreateTimeoffBlockedPeriod. */
export type CreateTimeoffBlockedPeriodPayload = {
  __typename?: 'CreateTimeoffBlockedPeriodPayload';
  blockedPeriod?: Maybe<TimeoffBlockedPeriod>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateTimeoffLeaveApprovalRule. */
export type CreateTimeoffLeaveApprovalRulePayload = {
  __typename?: 'CreateTimeoffLeaveApprovalRulePayload';
  errors: Array<MutationError>;
  leaveApprovalRule?: Maybe<TimeoffLeaveApprovalRule>;
};

/** Autogenerated return type of CreateTimeoffLeave. */
export type CreateTimeoffLeavePayload = {
  __typename?: 'CreateTimeoffLeavePayload';
  errors: Array<MutationError>;
  leave?: Maybe<TimeoffLeave>;
};

/** Autogenerated return type of CreateTimeoffLeaveType. */
export type CreateTimeoffLeaveTypePayload = {
  __typename?: 'CreateTimeoffLeaveTypePayload';
  errors: Array<MutationError>;
  leaveType?: Maybe<TimeoffLeaveType>;
};

/** Autogenerated return type of CreateTimeoffPolicyAssignment. */
export type CreateTimeoffPolicyAssignmentPayload = {
  __typename?: 'CreateTimeoffPolicyAssignmentPayload';
  errors: Array<MutationError>;
  policyAssignment?: Maybe<TimeoffPolicyAssignment>;
};

/** Autogenerated return type of CreateTimeoffPolicy. */
export type CreateTimeoffPolicyPayload = {
  __typename?: 'CreateTimeoffPolicyPayload';
  errors: Array<MutationError>;
  policy?: Maybe<TimeoffPolicy>;
};

/** Autogenerated return type of CreateTimeplanningPlanningVersion. */
export type CreateTimeplanningPlanningVersionPayload = {
  __typename?: 'CreateTimeplanningPlanningVersionPayload';
  errors: Array<MutationError>;
  planningVersion?: Maybe<TimePlanningPlanningVersion>;
};

/** Autogenerated return type of CreateTimesettingsBreakConfiguration. */
export type CreateTimesettingsBreakConfigurationPayload = {
  __typename?: 'CreateTimesettingsBreakConfigurationPayload';
  breakConfiguration?: Maybe<TimeSettingsBreakConfiguration>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateTimesettingsCustomTimeRangeCategory. */
export type CreateTimesettingsCustomTimeRangeCategoryPayload = {
  __typename?: 'CreateTimesettingsCustomTimeRangeCategoryPayload';
  customTimeRangeCategory?: Maybe<TimeSettingsCustomTimeRangeCategory>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateTimesettingsSplitCustomTimeRangeCategory. */
export type CreateTimesettingsSplitCustomTimeRangeCategoryPayload = {
  __typename?: 'CreateTimesettingsSplitCustomTimeRangeCategoryPayload';
  errors: Array<MutationError>;
  splitCustomTimeRangeCategory?: Maybe<TimeSettingsSplitCustomTimeRangeCategory>;
};

/** Autogenerated return type of CreateTrainingsCategoryMapConfigItem. */
export type CreateTrainingsCategoryMapConfigItemPayload = {
  __typename?: 'CreateTrainingsCategoryMapConfigItemPayload';
  categoryMapConfigItem?: Maybe<TrainingsCategoryMapConfigItem>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateTrainingsCategoryMapConfig. */
export type CreateTrainingsCategoryMapConfigPayload = {
  __typename?: 'CreateTrainingsCategoryMapConfigPayload';
  categoryMapConfig?: Maybe<TrainingsCategoryMapConfig>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateTrainingsCategory. */
export type CreateTrainingsCategoryPayload = {
  __typename?: 'CreateTrainingsCategoryPayload';
  category?: Maybe<TrainingsCategory>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateTrainingsCompletionConfiguration. */
export type CreateTrainingsCompletionConfigurationPayload = {
  __typename?: 'CreateTrainingsCompletionConfigurationPayload';
  completionConfiguration?: Maybe<TrainingsCompletionConfiguration>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateTrainingsContentBlockProgress. */
export type CreateTrainingsContentBlockProgressPayload = {
  __typename?: 'CreateTrainingsContentBlockProgressPayload';
  contentBlockProgress?: Maybe<TrainingsContentBlockProgress>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateTrainingsEmployeeRelatorioUnicoField. */
export type CreateTrainingsEmployeeRelatorioUnicoFieldPayload = {
  __typename?: 'CreateTrainingsEmployeeRelatorioUnicoFieldPayload';
  employeeRelatorioUnicoField?: Maybe<TrainingsEmployeeRelatorioUnicoField>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateTrainingsLearningPlatform. */
export type CreateTrainingsLearningPlatformPayload = {
  __typename?: 'CreateTrainingsLearningPlatformPayload';
  errors: Array<MutationError>;
  learningPlatform?: Maybe<TrainingsLearningPlatform>;
};

/** Autogenerated return type of CreateTrainingsReminder. */
export type CreateTrainingsReminderPayload = {
  __typename?: 'CreateTrainingsReminderPayload';
  errors: Array<MutationError>;
  reminder?: Maybe<TrainingsReminder>;
};

/** Autogenerated return type of CreateTrainingsSessionFile. */
export type CreateTrainingsSessionFilePayload = {
  __typename?: 'CreateTrainingsSessionFilePayload';
  errors: Array<MutationError>;
  sessionFile?: Maybe<TrainingsSessionFile>;
};

/** Autogenerated return type of CreateTrainingsSession. */
export type CreateTrainingsSessionPayload = {
  __typename?: 'CreateTrainingsSessionPayload';
  errors: Array<MutationError>;
  session?: Maybe<TrainingsSession>;
};

/** Autogenerated return type of CreateTrainingsSessionRelatorioUnicoField. */
export type CreateTrainingsSessionRelatorioUnicoFieldPayload = {
  __typename?: 'CreateTrainingsSessionRelatorioUnicoFieldPayload';
  errors: Array<MutationError>;
  sessionRelatorioUnicoField?: Maybe<TrainingsSessionRelatorioUnicoField>;
};

export type CreateTrainingsSessionRemindersInput = {
  content?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  scheduledAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  sessionId?: InputMaybe<Scalars['Int']>;
  timeframe?: InputMaybe<TrainingsReminderTimeframeEnum>;
};

export type CreateTrainingsSessionSessionInstructorsInput = {
  companyId: Scalars['Int'];
  employeeIds: Array<Scalars['String']>;
  sessionId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of CreateTrainingsSetting. */
export type CreateTrainingsSettingPayload = {
  __typename?: 'CreateTrainingsSettingPayload';
  errors: Array<MutationError>;
  setting?: Maybe<TrainingsSetting>;
};

export type CreateTrainingsTrainingAttachmentsInput = {
  authorId: Scalars['Int'];
  file: Scalars['File'];
  title?: InputMaybe<Scalars['String']>;
  visibility?: InputMaybe<Scalars['Boolean']>;
};

export type CreateTrainingsTrainingClassAttachmentsInput = {
  authorId: Scalars['Int'];
  file?: InputMaybe<Scalars['File']>;
  signedId?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  visibility?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated return type of CreateTrainingsTrainingClassFile. */
export type CreateTrainingsTrainingClassFilePayload = {
  __typename?: 'CreateTrainingsTrainingClassFilePayload';
  errors: Array<MutationError>;
  trainingClassFile?: Maybe<TrainingsTrainingClassFile>;
};

/** Autogenerated return type of CreateTrainingsTrainingClassLink. */
export type CreateTrainingsTrainingClassLinkPayload = {
  __typename?: 'CreateTrainingsTrainingClassLinkPayload';
  errors: Array<MutationError>;
  trainingClassLink?: Maybe<TrainingsTrainingClassLink>;
};

/** Autogenerated return type of CreateTrainingsTrainingClass. */
export type CreateTrainingsTrainingClassPayload = {
  __typename?: 'CreateTrainingsTrainingClassPayload';
  errors: Array<MutationError>;
  trainingClass?: Maybe<TrainingsTrainingClass>;
};

export type CreateTrainingsTrainingClassRemindersInput = {
  content?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  scheduledAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  sessionId?: InputMaybe<Scalars['Int']>;
  timeframe?: InputMaybe<TrainingsReminderTimeframeEnum>;
};

export type CreateTrainingsTrainingClassSessionInstructorsInput = {
  companyId: Scalars['Int'];
  employeeIds: Array<Scalars['String']>;
  sessionId?: InputMaybe<Scalars['String']>;
};

export type CreateTrainingsTrainingClassSessionRelatorioInput = {
  trainingSchedule: Scalars['String'];
};

export type CreateTrainingsTrainingClassTrainingSessionsInput = {
  description?: InputMaybe<Scalars['String']>;
  dueDate?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['String']>;
  endsAt?: InputMaybe<Scalars['String']>;
  endsAtHour?: InputMaybe<Scalars['String']>;
  frequency?: InputMaybe<TrainingsSessionFrequencyEnum>;
  hours?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  link?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  minutes?: InputMaybe<Scalars['Int']>;
  modality?: InputMaybe<TrainingsSessionModalityEnum>;
  name: Scalars['String'];
  recurrent: Scalars['Boolean'];
  reminders: Array<CreateTrainingsTrainingClassRemindersInput>;
  schedule?: InputMaybe<TrainingsSessionScheduleEnum>;
  sessionInstructors: CreateTrainingsTrainingClassSessionInstructorsInput;
  sessionRelatorio?: InputMaybe<CreateTrainingsTrainingClassSessionRelatorioInput>;
  startDate?: InputMaybe<Scalars['String']>;
  startsAt?: InputMaybe<Scalars['String']>;
  startsAtHour?: InputMaybe<Scalars['String']>;
  subsidized?: InputMaybe<Scalars['Boolean']>;
  trainingId: Scalars['Int'];
};

export type CreateTrainingsTrainingCompletionConfigurationInput = {
  attendancePercentage?: InputMaybe<Scalars['Int']>;
  knowledgeTestRequired: Scalars['Boolean'];
  moduleCompletedPercentage?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of CreateTrainingsTrainingFile. */
export type CreateTrainingsTrainingFilePayload = {
  __typename?: 'CreateTrainingsTrainingFilePayload';
  errors: Array<MutationError>;
  trainingFile?: Maybe<TrainingsTrainingFile>;
};

/** Autogenerated return type of CreateTrainingsTrainingLink. */
export type CreateTrainingsTrainingLinkPayload = {
  __typename?: 'CreateTrainingsTrainingLinkPayload';
  errors: Array<MutationError>;
  trainingLink?: Maybe<TrainingsTrainingLink>;
};

/** Autogenerated return type of CreateTrainingsTraining. */
export type CreateTrainingsTrainingPayload = {
  __typename?: 'CreateTrainingsTrainingPayload';
  errors: Array<MutationError>;
  training?: Maybe<TrainingsTraining>;
};

/** Autogenerated return type of CreateTrainingsTrainingRelatorioUnicoField. */
export type CreateTrainingsTrainingRelatorioUnicoFieldPayload = {
  __typename?: 'CreateTrainingsTrainingRelatorioUnicoFieldPayload';
  errors: Array<MutationError>;
  trainingRelatorioUnicoField?: Maybe<TrainingsTrainingRelatorioUnicoField>;
};

/** Autogenerated return type of CreateTrainingsTrainingRequest. */
export type CreateTrainingsTrainingRequestPayload = {
  __typename?: 'CreateTrainingsTrainingRequestPayload';
  errors: Array<MutationError>;
  trainingRequest?: Maybe<TrainingsTrainingRequest>;
};

/** Autogenerated return type of CreateUniversalexportsConfiguration. */
export type CreateUniversalexportsConfigurationPayload = {
  __typename?: 'CreateUniversalexportsConfigurationPayload';
  configuration?: Maybe<UniversalExportsConfiguration>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateUniversalexportsExport. */
export type CreateUniversalexportsExportPayload = {
  __typename?: 'CreateUniversalexportsExportPayload';
  errors: Array<MutationError>;
  export?: Maybe<UniversalExportsExport>;
};

/** Autogenerated return type of CreateUpsellAddLineItem. */
export type CreateUpsellAddLineItemPayload = {
  __typename?: 'CreateUpsellAddLineItemPayload';
  addLineItem?: Maybe<UpsellAddLineItem>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateUpsellJoinOneWaitlist. */
export type CreateUpsellJoinOneWaitlistPayload = {
  __typename?: 'CreateUpsellJoinOneWaitlistPayload';
  errors: Array<MutationError>;
  joinOneWaitlist?: Maybe<UpsellJoinOneWaitlist>;
};

/** Autogenerated return type of CreateUpsellUpsellDiscount. */
export type CreateUpsellUpsellDiscountPayload = {
  __typename?: 'CreateUpsellUpsellDiscountPayload';
  errors: Array<MutationError>;
  upsellDiscount?: Maybe<UpsellUpsellDiscount>;
};

/** Autogenerated return type of CreateUpsellUpsellRequest. */
export type CreateUpsellUpsellRequestPayload = {
  __typename?: 'CreateUpsellUpsellRequestPayload';
  errors: Array<MutationError>;
  upsellRequest?: Maybe<UpsellUpsellRequest>;
};

/** Autogenerated return type of CreateValidatingSalesClientFinanceContact. */
export type CreateValidatingSalesClientFinanceContactPayload = {
  __typename?: 'CreateValidatingSalesClientFinanceContactPayload';
  contact?: Maybe<FinanceContact>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateVersionAttendanceEmployeesSetting. */
export type CreateVersionAttendanceEmployeesSettingPayload = {
  __typename?: 'CreateVersionAttendanceEmployeesSettingPayload';
  employeesSetting?: Maybe<AttendanceEmployeesSetting>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateVersionWorkflowsWorkflow. */
export type CreateVersionWorkflowsWorkflowPayload = {
  __typename?: 'CreateVersionWorkflowsWorkflowPayload';
  errors: Array<MutationError>;
  workflow?: Maybe<WorkflowsWorkflow>;
};

export type CreateVirtualBankingCardCardholderDataInput = {
  dateOfBirth: Scalars['ISO8601Date'];
  email?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phoneCountryCode: Scalars['String'];
  phoneNumber: Scalars['String'];
};

/** Autogenerated return type of CreateVirtualBankingCard. */
export type CreateVirtualBankingCardPayload = {
  __typename?: 'CreateVirtualBankingCardPayload';
  card?: Maybe<BankingCard>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateWithAsyncScanFileFinanceFinancialDocument. */
export type CreateWithAsyncScanFileFinanceFinancialDocumentPayload = {
  __typename?: 'CreateWithAsyncScanFileFinanceFinancialDocumentPayload';
  errors: Array<MutationError>;
  financialDocument?: Maybe<FinanceFinancialDocument>;
};

/** Autogenerated return type of CreateWithContractEmployeesEmployee. */
export type CreateWithContractEmployeesEmployeePayload = {
  __typename?: 'CreateWithContractEmployeesEmployeePayload';
  employee?: Maybe<EmployeesEmployee>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateWithEmployeesPayrollPolicy. */
export type CreateWithEmployeesPayrollPolicyPayload = {
  __typename?: 'CreateWithEmployeesPayrollPolicyPayload';
  errors: Array<MutationError>;
  policy?: Maybe<PayrollPolicy>;
};

export type CreateWithEmployeesPayrollPolicyPolicyInput = {
  companyId: Scalars['Int'];
  country?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  default?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  recurrence: Scalars['String'];
  startsOn: Scalars['ISO8601Date'];
};

/** Autogenerated return type of CreateWithItemsCompensationsPaymentRequest. */
export type CreateWithItemsCompensationsPaymentRequestPayload = {
  __typename?: 'CreateWithItemsCompensationsPaymentRequestPayload';
  errors: Array<MutationError>;
  paymentRequests?: Maybe<Array<CompensationsPaymentRequest>>;
};

export type CreateWithPayrollPolicyContractsContractVersionCompensationsInput = {
  amount?: InputMaybe<Scalars['Int']>;
  calculation?: InputMaybe<Scalars['String']>;
  compensationType?: InputMaybe<Scalars['String']>;
  contractsTaxonomyId: Scalars['Int'];
  description?: InputMaybe<Scalars['String']>;
  firstPaymentOn?: InputMaybe<Scalars['ISO8601Date']>;
  minimumAmountOfHours?: InputMaybe<Scalars['Int']>;
  minimumAmountOfHoursInCents?: InputMaybe<Scalars['Int']>;
  payrollPolicyId?: InputMaybe<Scalars['Int']>;
  recurrence?: InputMaybe<Scalars['String']>;
  recurrenceCount?: InputMaybe<Scalars['Int']>;
  startsOn?: InputMaybe<Scalars['ISO8601Date']>;
  syncWithSupplements?: InputMaybe<Scalars['Boolean']>;
  timeCondition?: InputMaybe<ContractsValueObjectsTimeConditionEnum>;
  unit?: InputMaybe<Scalars['String']>;
};

export type CreateWithPayrollPolicyContractsContractVersionCreateContractVersionDtoInput = {
  actionType?: InputMaybe<ContractsContractVersionHistoryActionTypeEnum>;
  allowNilPayrollPolicy: Scalars['Boolean'];
  annualWorkingTimeDistribution?: InputMaybe<ContractsAnnualWorkingTimeDistributionEnum>;
  bankHolidayTreatment?: InputMaybe<ContractsBankHolidayTreatmentEnum>;
  compensations?: InputMaybe<Array<CreateWithPayrollPolicyContractsContractVersionCompensationsInput>>;
  contractsDeContractTypeId?: InputMaybe<Scalars['Int']>;
  contractsEsA3innuvaJobPositionId?: InputMaybe<Scalars['Int']>;
  contractsEsAgreementCodeId?: InputMaybe<Scalars['Int']>;
  contractsEsClassificationId?: InputMaybe<Scalars['Int']>;
  contractsEsCnoOccupationId?: InputMaybe<Scalars['Int']>;
  contractsEsContractTypeId?: InputMaybe<Scalars['Int']>;
  contractsEsContributionTypeId?: InputMaybe<Scalars['Int']>;
  contractsEsEducationLevelId?: InputMaybe<Scalars['Int']>;
  contractsEsOccupationCodeId?: InputMaybe<Scalars['Int']>;
  contractsEsProfessionalCategoryId?: InputMaybe<Scalars['Int']>;
  contractsEsRegimeId?: InputMaybe<Scalars['Int']>;
  contractsEsTariffGroupId?: InputMaybe<Scalars['Int']>;
  contractsEsWorkingDayTypeId?: InputMaybe<Scalars['Int']>;
  contractsFrContractTypeId?: InputMaybe<Scalars['Int']>;
  contractsFrLevelId?: InputMaybe<Scalars['Int']>;
  contractsFrMutualId?: InputMaybe<Scalars['Int']>;
  contractsFrProfessionalCategoryId?: InputMaybe<Scalars['Int']>;
  contractsFrStepId?: InputMaybe<Scalars['Int']>;
  contractsFrWorkTypeId?: InputMaybe<Scalars['Int']>;
  contractsPtContractTypeId?: InputMaybe<Scalars['Int']>;
  copyCurrentContractVersion?: InputMaybe<Scalars['Boolean']>;
  deActivityType?: InputMaybe<Scalars['Int']>;
  deEmploymentType?: InputMaybe<Scalars['Int']>;
  deFlatRateTax?: InputMaybe<Scalars['Int']>;
  dePersonalKeyGroupId?: InputMaybe<Scalars['Int']>;
  effectiveOn: Scalars['ISO8601Date'];
  employeeId: Scalars['Int'];
  endsOn?: InputMaybe<Scalars['ISO8601Date']>;
  esContractObservations?: InputMaybe<Scalars['String']>;
  esCotizationGroup?: InputMaybe<Scalars['Int']>;
  esHasTeleworkingContract?: InputMaybe<Scalars['Boolean']>;
  esJobDescription?: InputMaybe<Scalars['String']>;
  frCoefficient?: InputMaybe<Scalars['String']>;
  frEmployeeType?: InputMaybe<Scalars['String']>;
  frForfaitJours?: InputMaybe<Scalars['Boolean']>;
  frJoursParAn?: InputMaybe<Scalars['Int']>;
  frJoursParAnCents?: InputMaybe<Scalars['Int']>;
  hasPayroll?: InputMaybe<Scalars['Boolean']>;
  hasTrialPeriod?: InputMaybe<Scalars['Boolean']>;
  isDiscontinuous?: InputMaybe<Scalars['Boolean']>;
  jobCatalogLevelId?: InputMaybe<Scalars['Int']>;
  jobCatalogTreeNodeUuid?: InputMaybe<Scalars['String']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  maxLegalYearlyHours?: InputMaybe<Scalars['Int']>;
  maxWorkDaysInRow?: InputMaybe<Scalars['Int']>;
  maxWorkMinutesPerDay?: InputMaybe<Scalars['Int']>;
  maximumWeeklyHours?: InputMaybe<Scalars['Int']>;
  minRestHoursInRow?: InputMaybe<Scalars['Int']>;
  minRestMinutesBetweenDays?: InputMaybe<Scalars['Int']>;
  newAdditionalCompensations: Array<CreateWithPayrollPolicyContractsContractVersionNewAdditionalCompensationsInput>;
  payrollPolicyId?: InputMaybe<Scalars['Int']>;
  requestDetails?: InputMaybe<Scalars['String']>;
  salaryAmount?: InputMaybe<Scalars['Int']>;
  salaryFrequency?: InputMaybe<Scalars['String']>;
  startsOn: Scalars['ISO8601Date'];
  trialPeriodEndsOn?: InputMaybe<Scalars['ISO8601Date']>;
  workingHours?: InputMaybe<Scalars['Int']>;
  workingHoursFrequency?: InputMaybe<Scalars['String']>;
  workingTimePercentageInCents?: InputMaybe<Scalars['Int']>;
  workingWeekDays?: InputMaybe<Scalars['String']>;
};

export type CreateWithPayrollPolicyContractsContractVersionNewAdditionalCompensationsInput = {
  amount?: InputMaybe<Scalars['Int']>;
  amountStrategyType: Scalars['String'];
  contractVersionId: Scalars['Int'];
  description?: InputMaybe<Scalars['String']>;
  firstPaymentOn?: InputMaybe<Scalars['ISO8601Date']>;
  id?: InputMaybe<Scalars['Int']>;
  payrollConceptId: Scalars['Int'];
  recurrence?: InputMaybe<Scalars['String']>;
  upperLimit?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of CreateWithPayrollPolicyContractsContractVersion. */
export type CreateWithPayrollPolicyContractsContractVersionPayload = {
  __typename?: 'CreateWithPayrollPolicyContractsContractVersionPayload';
  contractVersion?: Maybe<ContractsContractVersion>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CreateWithoutDocumentBankingReconciliation. */
export type CreateWithoutDocumentBankingReconciliationPayload = {
  __typename?: 'CreateWithoutDocumentBankingReconciliationPayload';
  errors: Array<MutationError>;
  reconciliation?: Maybe<BankingReconciliation>;
};

/** Autogenerated return type of CreateWorkflowProcurementType. */
export type CreateWorkflowProcurementTypePayload = {
  __typename?: 'CreateWorkflowProcurementTypePayload';
  errors: Array<MutationError>;
  type?: Maybe<ProcurementType>;
};

/** Autogenerated return type of CreateWorkflowsWorkflowNodeFile. */
export type CreateWorkflowsWorkflowNodeFilePayload = {
  __typename?: 'CreateWorkflowsWorkflowNodeFilePayload';
  errors: Array<MutationError>;
  workflowNodeFile?: Maybe<WorkflowsWorkflowNodeFile>;
};

/** Autogenerated return type of CreateWorkflowsWorkflow. */
export type CreateWorkflowsWorkflowPayload = {
  __typename?: 'CreateWorkflowsWorkflowPayload';
  errors: Array<MutationError>;
  workflow?: Maybe<WorkflowsWorkflow>;
};

/** Autogenerated return type of CreateWorkingconditionsItem. */
export type CreateWorkingconditionsItemPayload = {
  __typename?: 'CreateWorkingconditionsItemPayload';
  errors: Array<MutationError>;
  item?: Maybe<WorkingConditionsItem>;
};

/** Autogenerated return type of CreateWorkingconditionsPeopleAssignment. */
export type CreateWorkingconditionsPeopleAssignmentPayload = {
  __typename?: 'CreateWorkingconditionsPeopleAssignmentPayload';
  errors: Array<MutationError>;
  peopleAssignment?: Maybe<WorkingConditionsPeopleAssignment>;
};

/** Autogenerated return type of CreateWorkingconditionsVersion. */
export type CreateWorkingconditionsVersionPayload = {
  __typename?: 'CreateWorkingconditionsVersionPayload';
  errors: Array<MutationError>;
  version?: Maybe<WorkingConditionsVersion>;
};

/** Autogenerated return type of CreateWorkscheduleOverlapPeriod. */
export type CreateWorkscheduleOverlapPeriodPayload = {
  __typename?: 'CreateWorkscheduleOverlapPeriodPayload';
  errors: Array<MutationError>;
  overlapPeriod?: Maybe<WorkScheduleOverlapPeriod>;
};

/** Autogenerated return type of CreateWorkscheduleSchedule. */
export type CreateWorkscheduleSchedulePayload = {
  __typename?: 'CreateWorkscheduleSchedulePayload';
  errors: Array<MutationError>;
  schedule?: Maybe<WorkScheduleSchedule>;
};

/** A sync with a calendar using cronofy services */
export type CronofySchedulingCalendarSync = {
  __typename?: 'CronofySchedulingCalendarSync';
  access: ApiCoreAccess;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  accessId: Scalars['Int'];
  accountId?: Maybe<Scalars['String']>;
  calendarId?: Maybe<Scalars['String']>;
  company: ApiCoreCompany;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  companyId: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  elementToken?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  oauthUrl?: Maybe<Scalars['String']>;
  profileId?: Maybe<Scalars['String']>;
  profileName?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  sub?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};


/** A sync with a calendar using cronofy services */
export type CronofySchedulingCalendarSyncAccessArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for CronofySchedulingCalendarSync. */
export type CronofySchedulingCalendarSyncConnection = {
  __typename?: 'CronofySchedulingCalendarSyncConnection';
  /** A list of edges. */
  edges: Array<CronofySchedulingCalendarSyncEdge>;
  /** A list of nodes. */
  nodes: Array<CronofySchedulingCalendarSync>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CronofySchedulingCalendarSyncEdge = {
  __typename?: 'CronofySchedulingCalendarSyncEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CronofySchedulingCalendarSync;
};

/** Autogenerated return type of CurrentAttendanceCompanySettingsVersion. */
export type CurrentAttendanceCompanySettingsVersionPayload = {
  __typename?: 'CurrentAttendanceCompanySettingsVersionPayload';
  companySettingsVersion?: Maybe<AttendanceCompanySettingsVersion>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of CurrentTimebalanceTimeCondition. */
export type CurrentTimebalanceTimeConditionPayload = {
  __typename?: 'CurrentTimebalanceTimeConditionPayload';
  errors: Array<MutationError>;
  timeCondition?: Maybe<TimeBalanceTimeCondition>;
};

export type CustomFieldsContextlessPolicies = {
  __typename?: 'CustomFieldsContextlessPolicies';
  companyCreateCustomFields: ContextlessPolicyResolution;
  fieldCreate: ContextlessPolicyResolution;
  fieldDocumentsCreate: ContextlessPolicyResolution;
};

/**
 * Set up custom fields that will appear in the employee dashboard. You will be
 * able to track more information from your employees.
 */
export type CustomFieldsField = {
  __typename?: 'CustomFieldsField';
  choiceOptions?: Maybe<Array<Scalars['String']>>;
  editable: Scalars['Boolean'];
  /** The type of the field's value */
  fieldType: CustomFieldsFieldTypeEnum;
  /** Field identifier */
  id: Scalars['Int'];
  identifier: Scalars['String'];
  /** Field label */
  labelText: Scalars['String'];
  /** Legal entity id where this field belongs */
  legalEntityId?: Maybe<Scalars['Int']>;
  /** Legal entity name where this field belongs */
  legalEntityName?: Maybe<Scalars['String']>;
  /** Maximum value in range field type */
  maxValue?: Maybe<Scalars['Int']>;
  /** Minimum value in range field type */
  minValue?: Maybe<Scalars['Int']>;
  options: Array<CustomFieldsOption>;
  optionsConnection: CustomFieldsOptionConnection;
  /** Field position within employee profile */
  position?: Maybe<Scalars['Int']>;
  /** Requirement to fill this field */
  required?: Maybe<Scalars['Boolean']>;
  resourceFields: Array<CustomFieldsResourceField>;
  resourceFieldsConnection: CustomFieldsResourceFieldConnection;
  /** Custom field slug */
  slug?: Maybe<Scalars['String']>;
  usageGroup: CustomFieldsUsageGroup;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  usageGroupId?: Maybe<Scalars['Int']>;
  usageGroupSlug: Scalars['String'];
  value: Array<CustomFieldsValue>;
  valueConnection: CustomFieldsValueConnection;
  visible: Scalars['Boolean'];
};


/**
 * Set up custom fields that will appear in the employee dashboard. You will be
 * able to track more information from your employees.
 */
export type CustomFieldsFieldOptionsArgs = {
  fieldableIds?: InputMaybe<Array<Scalars['Int']>>;
  fieldableType?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  withArchived?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Set up custom fields that will appear in the employee dashboard. You will be
 * able to track more information from your employees.
 */
export type CustomFieldsFieldOptionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  fieldableIds?: InputMaybe<Array<Scalars['Int']>>;
  fieldableType?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  withArchived?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Set up custom fields that will appear in the employee dashboard. You will be
 * able to track more information from your employees.
 */
export type CustomFieldsFieldResourceFieldsArgs = {
  fieldableIds?: InputMaybe<Array<Scalars['Int']>>;
  fieldableType?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  schemaIds?: InputMaybe<Array<Scalars['Int']>>;
  usageGroupSlugs?: InputMaybe<Array<Scalars['String']>>;
};


/**
 * Set up custom fields that will appear in the employee dashboard. You will be
 * able to track more information from your employees.
 */
export type CustomFieldsFieldResourceFieldsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  fieldableIds?: InputMaybe<Array<Scalars['Int']>>;
  fieldableType?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  schemaIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
  usageGroupSlugs?: InputMaybe<Array<Scalars['String']>>;
};


/**
 * Set up custom fields that will appear in the employee dashboard. You will be
 * able to track more information from your employees.
 */
export type CustomFieldsFieldUsageGroupArgs = {
  fieldsIds?: InputMaybe<Array<Scalars['Int']>>;
  slugs?: InputMaybe<Array<Scalars['String']>>;
};


/**
 * Set up custom fields that will appear in the employee dashboard. You will be
 * able to track more information from your employees.
 */
export type CustomFieldsFieldValueArgs = {
  contractsVersionsIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  fieldId?: InputMaybe<Scalars['Int']>;
  identifiers?: InputMaybe<Array<Scalars['String']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  instanceId?: InputMaybe<Scalars['Int']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  updatedAtGteq?: InputMaybe<Scalars['String']>;
  usageGroupId?: InputMaybe<Scalars['Int']>;
  usageGroupSlugs?: InputMaybe<Array<Scalars['String']>>;
  valuableIds?: InputMaybe<Array<Scalars['Int']>>;
  valuableType?: InputMaybe<CustomFieldsValueObjectsValuableTypeEnum>;
  value?: InputMaybe<Scalars['String']>;
};


/**
 * Set up custom fields that will appear in the employee dashboard. You will be
 * able to track more information from your employees.
 */
export type CustomFieldsFieldValueConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  contractsVersionsIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  fieldId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  identifiers?: InputMaybe<Array<Scalars['String']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  instanceId?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  updatedAtGteq?: InputMaybe<Scalars['String']>;
  usageGroupId?: InputMaybe<Scalars['Int']>;
  usageGroupSlugs?: InputMaybe<Array<Scalars['String']>>;
  valuableIds?: InputMaybe<Array<Scalars['Int']>>;
  valuableType?: InputMaybe<CustomFieldsValueObjectsValuableTypeEnum>;
  value?: InputMaybe<Scalars['String']>;
};

/** The connection type for CustomFieldsField. */
export type CustomFieldsFieldConnection = {
  __typename?: 'CustomFieldsFieldConnection';
  /** A list of edges. */
  edges: Array<CustomFieldsFieldEdge>;
  /** A list of nodes. */
  nodes: Array<CustomFieldsField>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CustomFieldsFieldEdge = {
  __typename?: 'CustomFieldsFieldEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CustomFieldsField;
};

export type CustomFieldsFieldTypeEnum =
  | 'cents'
  | 'checkbox'
  | 'date'
  | 'long_text'
  | 'money'
  | 'multiple_choice'
  | 'rating'
  | 'single_choice'
  | 'text';

/** Options for single or multiple choice custom fields */
export type CustomFieldsOption = {
  __typename?: 'CustomFieldsOption';
  field?: Maybe<CustomFieldsField>;
  /**
   * Custom Fields identifier
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  fieldId?: Maybe<Scalars['Int']>;
  /** Option identifier */
  id: Scalars['Int'];
  /** Flag to make the option available */
  isActive?: Maybe<Scalars['Boolean']>;
  /** Title for option */
  label?: Maybe<Scalars['String']>;
  /** Option value */
  value?: Maybe<Scalars['String']>;
};


/** Options for single or multiple choice custom fields */
export type CustomFieldsOptionFieldArgs = {
  authorId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  fieldType?: InputMaybe<CustomFieldsFieldTypeEnum>;
  identifiers?: InputMaybe<Array<Scalars['String']>>;
  instanceId?: InputMaybe<Scalars['Int']>;
  label?: InputMaybe<Scalars['String']>;
  modelSlug?: InputMaybe<Scalars['String']>;
  relatedEmployeeId?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  usageGroupId?: InputMaybe<Scalars['Int']>;
  usageGroupSlugs?: InputMaybe<Array<Scalars['String']>>;
};

/** The connection type for CustomFieldsOption. */
export type CustomFieldsOptionConnection = {
  __typename?: 'CustomFieldsOptionConnection';
  /** A list of edges. */
  edges: Array<CustomFieldsOptionEdge>;
  /** A list of nodes. */
  nodes: Array<CustomFieldsOption>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CustomFieldsOptionEdge = {
  __typename?: 'CustomFieldsOptionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CustomFieldsOption;
};

/** Handle schema custom fields */
export type CustomFieldsResourceField = {
  __typename?: 'CustomFieldsResourceField';
  field?: Maybe<CustomFieldsField>;
  /**
   * Custom Field identifier
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  fieldId?: Maybe<Scalars['Int']>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  fieldableId?: Maybe<Scalars['Int']>;
  fieldableType?: Maybe<Scalars['String']>;
  /** Resource field identifier */
  id: Scalars['Int'];
  legalEntity?: Maybe<CompaniesLegalEntity>;
  position?: Maybe<Scalars['Int']>;
};


/** Handle schema custom fields */
export type CustomFieldsResourceFieldFieldArgs = {
  authorId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  fieldType?: InputMaybe<CustomFieldsFieldTypeEnum>;
  identifiers?: InputMaybe<Array<Scalars['String']>>;
  instanceId?: InputMaybe<Scalars['Int']>;
  label?: InputMaybe<Scalars['String']>;
  modelSlug?: InputMaybe<Scalars['String']>;
  relatedEmployeeId?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  usageGroupId?: InputMaybe<Scalars['Int']>;
  usageGroupSlugs?: InputMaybe<Array<Scalars['String']>>;
};


/** Handle schema custom fields */
export type CustomFieldsResourceFieldLegalEntityArgs = {
  companiesIds?: InputMaybe<Array<Scalars['Int']>>;
  countryIds?: InputMaybe<Array<Scalars['String']>>;
  employeesIds?: InputMaybe<Array<Scalars['Int']>>;
  excludeCountries?: InputMaybe<Array<Scalars['String']>>;
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};

/** The connection type for CustomFieldsResourceField. */
export type CustomFieldsResourceFieldConnection = {
  __typename?: 'CustomFieldsResourceFieldConnection';
  /** A list of edges. */
  edges: Array<CustomFieldsResourceFieldEdge>;
  /** A list of nodes. */
  nodes: Array<CustomFieldsResourceField>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CustomFieldsResourceFieldEdge = {
  __typename?: 'CustomFieldsResourceFieldEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CustomFieldsResourceField;
};

/** Usage group for custom fields */
export type CustomFieldsUsageGroup = {
  __typename?: 'CustomFieldsUsageGroup';
  advancedPermissions?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  slug: Scalars['String'];
};

/** The connection type for CustomFieldsUsageGroup. */
export type CustomFieldsUsageGroupConnection = {
  __typename?: 'CustomFieldsUsageGroupConnection';
  /** A list of edges. */
  edges: Array<CustomFieldsUsageGroupEdge>;
  /** A list of nodes. */
  nodes: Array<CustomFieldsUsageGroup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CustomFieldsUsageGroupEdge = {
  __typename?: 'CustomFieldsUsageGroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CustomFieldsUsageGroup;
};

/** Custom fields value */
export type CustomFieldsValue = {
  __typename?: 'CustomFieldsValue';
  booleanValue?: Maybe<Scalars['Boolean']>;
  /** Custom field number value */
  centsValue?: Maybe<Scalars['BigInt']>;
  /** The unique identifier of the custom field */
  customFieldIdentifier: Scalars['String'];
  /** Custom field date value */
  dateValue?: Maybe<Scalars['ISO8601Date']>;
  field: CustomFieldsField;
  /**
   * The identifier of the custom field
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  fieldId: Scalars['Int'];
  fieldType?: Maybe<Scalars['String']>;
  /** Unique identifier for the custom field value */
  id: Scalars['Int'];
  /** The label of the custom field */
  label?: Maybe<Scalars['String']>;
  /** Custom field text value */
  longTextValue?: Maybe<Scalars['String']>;
  multipleChoiceValue?: Maybe<Array<Scalars['String']>>;
  numberValue?: Maybe<Scalars['Int']>;
  /** Whether the custom field is required */
  required?: Maybe<Scalars['Boolean']>;
  /** Custom field single choice value */
  singleChoiceValue?: Maybe<Scalars['String']>;
  /** The date and time the custom field value was last updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The identifier of the usage group */
  usageGroupId?: Maybe<Scalars['Int']>;
  /** The slug of the usage group */
  usageGroupSlug?: Maybe<Scalars['String']>;
  /** The identifier of the object that owns this custom field value */
  valuableId: Scalars['Int'];
  /** The type of the object that owns this custom field value */
  valuableType: Scalars['String'];
};


/** Custom fields value */
export type CustomFieldsValueFieldArgs = {
  authorId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  fieldType?: InputMaybe<CustomFieldsFieldTypeEnum>;
  identifiers?: InputMaybe<Array<Scalars['String']>>;
  instanceId?: InputMaybe<Scalars['Int']>;
  label?: InputMaybe<Scalars['String']>;
  modelSlug?: InputMaybe<Scalars['String']>;
  relatedEmployeeId?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  usageGroupId?: InputMaybe<Scalars['Int']>;
  usageGroupSlugs?: InputMaybe<Array<Scalars['String']>>;
};

/** The connection type for CustomFieldsValue. */
export type CustomFieldsValueConnection = {
  __typename?: 'CustomFieldsValueConnection';
  /** A list of edges. */
  edges: Array<CustomFieldsValueEdge>;
  /** A list of nodes. */
  nodes: Array<CustomFieldsValue>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CustomFieldsValueEdge = {
  __typename?: 'CustomFieldsValueEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CustomFieldsValue;
};

export type CustomFieldsValueObjectsValuableTypeEnum =
  | 'contracts_contractversion'
  | 'customresources_value'
  | 'document'
  | 'employee';

/** Handles resources for values (custom tables) each value have an associated resource the attachable (like Employee) */
export type CustomResourcesResource = {
  __typename?: 'CustomResourcesResource';
  /** The id of the Attachable */
  attachableId: Scalars['Int'];
  /** Attachable type (the type of the attachable) */
  attachableType: Scalars['String'];
  /** The id of the Resource */
  id: Scalars['Int'];
  resourceValues: Array<CustomResourcesValue>;
  resourceValuesConnection: CustomResourcesValueConnection;
  /** The id of the Schema this resource belongs to */
  schemaId: Scalars['Int'];
};


/** Handles resources for values (custom tables) each value have an associated resource the attachable (like Employee) */
export type CustomResourcesResourceResourceValuesArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Handles resources for values (custom tables) each value have an associated resource the attachable (like Employee) */
export type CustomResourcesResourceResourceValuesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for CustomResourcesResource. */
export type CustomResourcesResourceConnection = {
  __typename?: 'CustomResourcesResourceConnection';
  /** A list of edges. */
  edges: Array<CustomResourcesResourceEdge>;
  /** A list of nodes. */
  nodes: Array<CustomResourcesResource>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CustomResourcesResourceEdge = {
  __typename?: 'CustomResourcesResourceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CustomResourcesResource;
};

export type CustomResourcesResourceValuesInput = {
  fieldId: Scalars['Int'];
  value: Scalars['String'];
  valueId?: InputMaybe<Scalars['Int']>;
};

/** Handles custom tables */
export type CustomResourcesSchema = {
  __typename?: 'CustomResourcesSchema';
  billingSubscriptionAddonId?: Maybe<Scalars['Int']>;
  /** Company identifier where this schema belongs */
  companyId: Scalars['Int'];
  customFieldsUsageGroupId: Scalars['Int'];
  customResourcesTopicId: Scalars['Int'];
  effectiveAtId?: Maybe<Scalars['Int']>;
  fields: Array<CustomFieldsResourceField>;
  fieldsConnection: CustomFieldsResourceFieldConnection;
  /** Manages visibility of the schema */
  hidden: Scalars['Boolean'];
  /** Schema identifier */
  id: Scalars['Int'];
  index: Scalars['Int'];
  label: Scalars['String'];
  /** Schema name */
  name: Scalars['String'];
  /** Schema position within employee profile */
  position?: Maybe<Scalars['Int']>;
  reportable: Scalars['Boolean'];
  resources: Array<CustomResourcesResource>;
  resourcesConnection: CustomResourcesResourceConnection;
  topicName: Scalars['String'];
};


/** Handles custom tables */
export type CustomResourcesSchemaFieldsArgs = {
  fieldIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  schemaIds?: InputMaybe<Array<Scalars['Int']>>;
  usageGroupSlugs?: InputMaybe<Array<Scalars['String']>>;
};


/** Handles custom tables */
export type CustomResourcesSchemaFieldsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  fieldIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  schemaIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
  usageGroupSlugs?: InputMaybe<Array<Scalars['String']>>;
};


/** Handles custom tables */
export type CustomResourcesSchemaResourcesArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Handles custom tables */
export type CustomResourcesSchemaResourcesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for CustomResourcesSchema. */
export type CustomResourcesSchemaConnection = {
  __typename?: 'CustomResourcesSchemaConnection';
  /** A list of edges. */
  edges: Array<CustomResourcesSchemaEdge>;
  /** A list of nodes. */
  nodes: Array<CustomResourcesSchema>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CustomResourcesSchemaEdge = {
  __typename?: 'CustomResourcesSchemaEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CustomResourcesSchema;
};

/** Handles values for schemas (custom tables) */
export type CustomResourcesValue = {
  __typename?: 'CustomResourcesValue';
  /** The id of the attached resource like an employee */
  attachableId?: Maybe<Scalars['Int']>;
  customValues: Array<CustomFieldsValue>;
  customValuesConnection: CustomFieldsValueConnection;
  /** Value identifier */
  id: Scalars['Int'];
  /** The identifier of the resource that owns the resource value */
  resourceId: Scalars['Int'];
};


/** Handles values for schemas (custom tables) */
export type CustomResourcesValueCustomValuesArgs = {
  contractsVersionsIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  fieldId?: InputMaybe<Scalars['Int']>;
  identifiers?: InputMaybe<Array<Scalars['String']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  instanceId?: InputMaybe<Scalars['Int']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  updatedAtGteq?: InputMaybe<Scalars['String']>;
  usageGroupId?: InputMaybe<Scalars['Int']>;
  usageGroupSlugs?: InputMaybe<Array<Scalars['String']>>;
  value?: InputMaybe<Scalars['String']>;
};


/** Handles values for schemas (custom tables) */
export type CustomResourcesValueCustomValuesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  contractsVersionsIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  fieldId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  identifiers?: InputMaybe<Array<Scalars['String']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  instanceId?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  updatedAtGteq?: InputMaybe<Scalars['String']>;
  usageGroupId?: InputMaybe<Scalars['Int']>;
  usageGroupSlugs?: InputMaybe<Array<Scalars['String']>>;
  value?: InputMaybe<Scalars['String']>;
};

/** The connection type for CustomResourcesValue. */
export type CustomResourcesValueConnection = {
  __typename?: 'CustomResourcesValueConnection';
  /** A list of edges. */
  edges: Array<CustomResourcesValueEdge>;
  /** A list of nodes. */
  nodes: Array<CustomResourcesValue>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CustomResourcesValueEdge = {
  __typename?: 'CustomResourcesValueEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CustomResourcesValue;
};

/** Pricing Addons from DatoCMS */
export type CustomerPortalAddon = {
  __typename?: 'CustomerPortalAddon';
  addons: Array<CustomerPortalPricingPlan>;
  id: Scalars['String'];
};

/** The connection type for CustomerPortalAddon. */
export type CustomerPortalAddonConnection = {
  __typename?: 'CustomerPortalAddonConnection';
  /** A list of edges. */
  edges: Array<CustomerPortalAddonEdge>;
  /** A list of nodes. */
  nodes: Array<CustomerPortalAddon>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CustomerPortalAddonEdge = {
  __typename?: 'CustomerPortalAddonEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CustomerPortalAddon;
};

export type CustomerPortalChargebeeAddon = {
  __typename?: 'CustomerPortalChargebeeAddon';
  addonId: Scalars['String'];
  chargeType: Scalars['String'];
  currencyCode: Scalars['String'];
  maxSeats?: Maybe<Scalars['Int']>;
  minSeats?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  period: Scalars['Int'];
  periodUnit: Scalars['String'];
  price?: Maybe<Scalars['Int']>;
  pricingModel: Scalars['String'];
  seatUnit?: Maybe<Scalars['String']>;
  selectedCountries?: Maybe<Array<Scalars['String']>>;
  tiers?: Maybe<Array<CustomerPortalChargebeeTier>>;
};

export type CustomerPortalChargebeePlan = {
  __typename?: 'CustomerPortalChargebeePlan';
  chargeType: Scalars['String'];
  currencyCode: Scalars['String'];
  maxSeats?: Maybe<Scalars['Int']>;
  minSeats?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  period: Scalars['Int'];
  periodUnit: Scalars['String'];
  planId: Scalars['String'];
  price: Scalars['Int'];
  pricingModel: Scalars['String'];
  tiers?: Maybe<Array<CustomerPortalChargebeeTier>>;
};

export type CustomerPortalChargebeeTier = {
  __typename?: 'CustomerPortalChargebeeTier';
  endingUnit?: Maybe<Scalars['Int']>;
  price: Scalars['Int'];
  startingUnit: Scalars['Int'];
};

export type CustomerPortalContextlessPolicies = {
  __typename?: 'CustomerPortalContextlessPolicies';
  subscriptionManageSubscription: ContextlessPolicyResolution;
};

export type CustomerPortalDatoCmsFeature = {
  __typename?: 'CustomerPortalDatoCmsFeature';
  featureStatus: Scalars['String'];
  highlightInModules?: Maybe<Scalars['Boolean']>;
  onlyShowIn?: Maybe<Array<CustomerPortalOnlyShowIn>>;
  title: Scalars['String'];
  tooltip?: Maybe<Scalars['String']>;
};

export type CustomerPortalF25PricingPlan = {
  __typename?: 'CustomerPortalF25PricingPlan';
  description: Scalars['String'];
  id: Scalars['String'];
  internalTitle?: Maybe<Scalars['String']>;
  isCorePlan: Scalars['Boolean'];
  regions: Array<CustomerPortalRegion>;
  title: Scalars['String'];
};

export type CustomerPortalOnlyShowIn = {
  __typename?: 'CustomerPortalOnlyShowIn';
  code: Scalars['String'];
};

/** Pricing Plans from DatoCMS */
export type CustomerPortalPlan = {
  __typename?: 'CustomerPortalPlan';
  allCorePlans: Array<CustomerPortalPricingPlan>;
  allF25Plans: Array<CustomerPortalF25PricingPlan>;
  allNormalPlans: Array<CustomerPortalPricingPlan>;
  id: Scalars['String'];
};

/** The connection type for CustomerPortalPlan. */
export type CustomerPortalPlanConnection = {
  __typename?: 'CustomerPortalPlanConnection';
  /** A list of edges. */
  edges: Array<CustomerPortalPlanEdge>;
  /** A list of nodes. */
  nodes: Array<CustomerPortalPlan>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CustomerPortalPlanEdge = {
  __typename?: 'CustomerPortalPlanEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CustomerPortalPlan;
};

export type CustomerPortalPricingPlan = {
  __typename?: 'CustomerPortalPricingPlan';
  description: Scalars['String'];
  id: Scalars['String'];
  internalTitle?: Maybe<Scalars['String']>;
  regions: Array<CustomerPortalRegion>;
  title: Scalars['String'];
};

export type CustomerPortalRegion = {
  __typename?: 'CustomerPortalRegion';
  chargebeeAddons?: Maybe<Array<CustomerPortalChargebeeAddon>>;
  chargebeePlans?: Maybe<Array<CustomerPortalChargebeePlan>>;
  features: Array<CustomerPortalDatoCmsFeature>;
};

/** Dashboard company link */
export type DashboardCompanyLink = {
  __typename?: 'DashboardCompanyLink';
  id: Scalars['Int'];
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  url: Scalars['String'];
};

/** The connection type for DashboardCompanyLink. */
export type DashboardCompanyLinkConnection = {
  __typename?: 'DashboardCompanyLinkConnection';
  /** A list of edges. */
  edges: Array<DashboardCompanyLinkEdge>;
  /** A list of nodes. */
  nodes: Array<DashboardCompanyLink>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type DashboardCompanyLinkEdge = {
  __typename?: 'DashboardCompanyLinkEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: DashboardCompanyLink;
};

export type DashboardContextlessPolicies = {
  __typename?: 'DashboardContextlessPolicies';
  dashboardWidgetCompanyLinksVisible: ContextlessPolicyResolution;
  sidebarSeeDashboardTopLevelItem: ContextlessPolicyResolution;
};

/** Dashboard widget */
export type DashboardWidget = {
  __typename?: 'DashboardWidget';
  configuration: Scalars['String'];
  description: Scalars['String'];
  icon: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  required: Scalars['Boolean'];
};

/** The connection type for DashboardWidget. */
export type DashboardWidgetConnection = {
  __typename?: 'DashboardWidgetConnection';
  /** A list of edges. */
  edges: Array<DashboardWidgetEdge>;
  /** A list of nodes. */
  nodes: Array<DashboardWidget>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type DashboardWidgetEdge = {
  __typename?: 'DashboardWidgetEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: DashboardWidget;
};

/** Dashboard widgets configuration */
export type DashboardWidgetsConfiguration = {
  __typename?: 'DashboardWidgetsConfiguration';
  authorId: Scalars['Int'];
  companyId: Scalars['Int'];
  configuration: Scalars['String'];
  editable?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  updatedBy?: Maybe<Scalars['Int']>;
};

/** The connection type for DashboardWidgetsConfiguration. */
export type DashboardWidgetsConfigurationConnection = {
  __typename?: 'DashboardWidgetsConfigurationConnection';
  /** A list of edges. */
  edges: Array<DashboardWidgetsConfigurationEdge>;
  /** A list of nodes. */
  nodes: Array<DashboardWidgetsConfiguration>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type DashboardWidgetsConfigurationEdge = {
  __typename?: 'DashboardWidgetsConfigurationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: DashboardWidgetsConfiguration;
};

export type DataDispatcherAllowedValue = {
  __typename?: 'DataDispatcherAllowedValue';
  country?: Maybe<Scalars['String']>;
  default?: Maybe<Scalars['Boolean']>;
  key: Scalars['String'];
  legalEntityIds?: Maybe<Array<Scalars['Int']>>;
  name?: Maybe<Scalars['String']>;
  validations?: Maybe<Array<DataDispatcherValidation>>;
  value: Scalars['String'];
};

export type DataDispatcherAllowedValueInput = {
  country?: InputMaybe<Scalars['String']>;
  default?: InputMaybe<Scalars['Boolean']>;
  key: Scalars['String'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  name?: InputMaybe<Scalars['String']>;
  validations?: InputMaybe<Array<DataDispatcherValidationInput>>;
  value: Scalars['String'];
};

export type DataDispatcherCapabilityFilterInput = {
  capability: DataDispatcherValueObjectsCapabilitiesCapabilityEnum;
  rules?: InputMaybe<Array<DataDispatcherCapabilityFilterRuleInput>>;
};

export type DataDispatcherCapabilityFilterRuleInput = {
  key: Scalars['String'];
  operation?: InputMaybe<DataDispatcherValueObjectsCapabilitiesFilterOperationEnum>;
  values?: InputMaybe<Array<Scalars['String']>>;
};

export type DataDispatcherChange = {
  __typename?: 'DataDispatcherChange';
  field: Scalars['String'];
};

export type DataDispatcherChangeHistory = {
  __typename?: 'DataDispatcherChangeHistory';
  changedAt: Scalars['ISO8601DateTime'];
  changes: Array<DataDispatcherChange>;
};

/** Data schema generator */
export type DataDispatcherDataSchema = {
  __typename?: 'DataDispatcherDataSchema';
  allowedValues?: Maybe<Array<DataDispatcherAllowedValue>>;
  category?: Maybe<Scalars['String']>;
  fieldName: Scalars['String'];
  fieldType: Scalars['String'];
  format?: Maybe<Scalars['String']>;
  group?: Maybe<Scalars['String']>;
  hidden: Scalars['Boolean'];
  label: Scalars['String'];
  metadata?: Maybe<Array<DataDispatcherMetadata>>;
  position?: Maybe<Scalars['Int']>;
  required: Scalars['Boolean'];
  schemaMapper: Scalars['String'];
  section?: Maybe<Scalars['String']>;
  transformations?: Maybe<Array<Scalars['String']>>;
};

/** The connection type for DataDispatcherDataSchema. */
export type DataDispatcherDataSchemaConnection = {
  __typename?: 'DataDispatcherDataSchemaConnection';
  /** A list of edges. */
  edges: Array<DataDispatcherDataSchemaEdge>;
  /** A list of nodes. */
  nodes: Array<DataDispatcherDataSchema>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type DataDispatcherDataSchemaEdge = {
  __typename?: 'DataDispatcherDataSchemaEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: DataDispatcherDataSchema;
};

export type DataDispatcherFieldSet = {
  __typename?: 'DataDispatcherFieldSet';
  error?: Maybe<Scalars['String']>;
  fieldName: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};

export type DataDispatcherFieldSetInput = {
  error?: InputMaybe<Scalars['String']>;
  fieldName: Scalars['String'];
  fieldValue?: InputMaybe<Scalars['String']>;
};

export type DataDispatcherFilterCondition = {
  __typename?: 'DataDispatcherFilterCondition';
  field: Scalars['String'];
  values: Array<Scalars['String']>;
};

export type DataDispatcherFilterConditionInput = {
  field: Scalars['String'];
  values: Array<Scalars['String']>;
};

export type DataDispatcherMetadata = {
  __typename?: 'DataDispatcherMetadata';
  key: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type DataDispatcherMetadataInput = {
  key: Scalars['String'];
  value?: InputMaybe<Scalars['String']>;
};

export type DataDispatcherValidation = {
  __typename?: 'DataDispatcherValidation';
  conditions: Array<DataDispatcherFilterCondition>;
  errorMessage: Scalars['String'];
  operator: Scalars['String'];
};

export type DataDispatcherValidationInput = {
  conditions: Array<DataDispatcherFilterConditionInput>;
  errorMessage: Scalars['String'];
  operator: Scalars['String'];
};

export type DataDispatcherValueObjectsCapabilitiesCapabilityEnum =
  | 'cost_center_assignment_importer'
  | 'employee_compensations'
  | 'employee_creation'
  | 'employee_importer'
  | 'german_employee'
  | 'payroll_updates'
  | 'universal_importer';

export type DataDispatcherValueObjectsCapabilitiesFilterOperationEnum =
  | 'equals'
  | 'include'
  | 'none_or_any'
  | 'none_or_include';

/** Autogenerated return type of DataUpdatedCompensationsPayrollRun. */
export type DataUpdatedCompensationsPayrollRunPayload = {
  __typename?: 'DataUpdatedCompensationsPayrollRunPayload';
  errors: Array<MutationError>;
  payrollRun?: Maybe<CompensationsPayrollRun>;
};

export type DateFilter = {
  between?: InputMaybe<Array<Scalars['ISO8601Date']>>;
  eq?: InputMaybe<Scalars['ISO8601Date']>;
  gt?: InputMaybe<Scalars['ISO8601Date']>;
  gteq?: InputMaybe<Scalars['ISO8601Date']>;
  lt?: InputMaybe<Scalars['ISO8601Date']>;
  lteq?: InputMaybe<Scalars['ISO8601Date']>;
  notEq?: InputMaybe<Scalars['ISO8601Date']>;
};

export type DateRangeInput = {
  from: Scalars['ISO8601Date'];
  to: Scalars['ISO8601Date'];
};

export type DateTimeFilter = {
  between?: InputMaybe<Array<Scalars['ISO8601DateTime']>>;
  eq?: InputMaybe<Scalars['ISO8601DateTime']>;
  gt?: InputMaybe<Scalars['ISO8601DateTime']>;
  gteq?: InputMaybe<Scalars['ISO8601DateTime']>;
  lt?: InputMaybe<Scalars['ISO8601DateTime']>;
  lteq?: InputMaybe<Scalars['ISO8601DateTime']>;
  notEq?: InputMaybe<Scalars['ISO8601DateTime']>;
};

/** Autogenerated return type of DeactivateApicoreAccess. */
export type DeactivateApicoreAccessPayload = {
  __typename?: 'DeactivateApicoreAccessPayload';
  access?: Maybe<ApiCoreAccess>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DeactivateBankingCard. */
export type DeactivateBankingCardPayload = {
  __typename?: 'DeactivateBankingCardPayload';
  card?: Maybe<BankingCard>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DeactivateTimeplanningPlanningVersion. */
export type DeactivateTimeplanningPlanningVersionPayload = {
  __typename?: 'DeactivateTimeplanningPlanningVersionPayload';
  errors: Array<MutationError>;
  planningVersion?: Maybe<TimePlanningPlanningVersion>;
};

/** Autogenerated return type of DeclineAtsOfferLetter. */
export type DeclineAtsOfferLetterPayload = {
  __typename?: 'DeclineAtsOfferLetterPayload';
  errors: Array<MutationError>;
  offerLetter?: Maybe<AtsOfferLetter>;
};

/** Autogenerated return type of DeleteAnalyticsReport. */
export type DeleteAnalyticsReportPayload = {
  __typename?: 'DeleteAnalyticsReportPayload';
  errors: Array<MutationError>;
  report?: Maybe<AnalyticsReport>;
};

/** Autogenerated return type of DeleteApprovalsApprovalGroup. */
export type DeleteApprovalsApprovalGroupPayload = {
  __typename?: 'DeleteApprovalsApprovalGroupPayload';
  approvalGroup?: Maybe<ApprovalsApprovalGroup>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DeleteApprovalsRulesConfiguration. */
export type DeleteApprovalsRulesConfigurationPayload = {
  __typename?: 'DeleteApprovalsRulesConfigurationPayload';
  errors: Array<MutationError>;
  rulesConfiguration?: Maybe<ApprovalsRulesConfiguration>;
};

/** Autogenerated return type of DeleteAtsApplicationParticipant. */
export type DeleteAtsApplicationParticipantPayload = {
  __typename?: 'DeleteAtsApplicationParticipantPayload';
  applicationParticipant?: Maybe<AtsApplicationParticipant>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DeleteAtsApplication. */
export type DeleteAtsApplicationPayload = {
  __typename?: 'DeleteAtsApplicationPayload';
  application?: Maybe<AtsApplication>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DeleteAtsApplicationPhase. */
export type DeleteAtsApplicationPhasePayload = {
  __typename?: 'DeleteAtsApplicationPhasePayload';
  applicationPhase?: Maybe<AtsApplicationPhase>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DeleteAtsAssessment. */
export type DeleteAtsAssessmentPayload = {
  __typename?: 'DeleteAtsAssessmentPayload';
  assessment?: Maybe<AtsAssessment>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DeleteAtsCandidateDuplicatesIdentification. */
export type DeleteAtsCandidateDuplicatesIdentificationPayload = {
  __typename?: 'DeleteAtsCandidateDuplicatesIdentificationPayload';
  candidateDuplicatesIdentification?: Maybe<AtsCandidateDuplicatesIdentification>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DeleteAtsCandidateEmailAction. */
export type DeleteAtsCandidateEmailActionPayload = {
  __typename?: 'DeleteAtsCandidateEmailActionPayload';
  candidateEmailAction?: Maybe<AtsCandidateEmailAction>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DeleteAtsCandidate. */
export type DeleteAtsCandidatePayload = {
  __typename?: 'DeleteAtsCandidatePayload';
  candidate?: Maybe<AtsCandidate>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DeleteAtsCandidateSource. */
export type DeleteAtsCandidateSourcePayload = {
  __typename?: 'DeleteAtsCandidateSourcePayload';
  candidateSource?: Maybe<AtsCandidateSource>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DeleteAtsEvaluationForm. */
export type DeleteAtsEvaluationFormPayload = {
  __typename?: 'DeleteAtsEvaluationFormPayload';
  errors: Array<MutationError>;
  evaluationForm?: Maybe<AtsEvaluationForm>;
};

/** Autogenerated return type of DeleteAtsFavouriteJobPosting. */
export type DeleteAtsFavouriteJobPostingPayload = {
  __typename?: 'DeleteAtsFavouriteJobPostingPayload';
  errors: Array<MutationError>;
  favouriteJobPosting?: Maybe<AtsFavouriteJobPosting>;
};

/** Autogenerated return type of DeleteAtsFeedback. */
export type DeleteAtsFeedbackPayload = {
  __typename?: 'DeleteAtsFeedbackPayload';
  errors: Array<MutationError>;
  feedback?: Maybe<AtsFeedback>;
};

/** Autogenerated return type of DeleteAtsFile. */
export type DeleteAtsFilePayload = {
  __typename?: 'DeleteAtsFilePayload';
  errors: Array<MutationError>;
  file?: Maybe<AtsFile>;
};

/** Autogenerated return type of DeleteAtsHiringPhase. */
export type DeleteAtsHiringPhasePayload = {
  __typename?: 'DeleteAtsHiringPhasePayload';
  errors: Array<MutationError>;
  hiringPhase?: Maybe<AtsHiringPhase>;
};

/** Autogenerated return type of DeleteAtsHiringStage. */
export type DeleteAtsHiringStagePayload = {
  __typename?: 'DeleteAtsHiringStagePayload';
  errors: Array<MutationError>;
  hiringStage?: Maybe<AtsHiringStage>;
};

/** Autogenerated return type of DeleteAtsIntegration. */
export type DeleteAtsIntegrationPayload = {
  __typename?: 'DeleteAtsIntegrationPayload';
  errors: Array<MutationError>;
  integration?: Maybe<AtsIntegration>;
};

/** Autogenerated return type of DeleteAtsJobPosting. */
export type DeleteAtsJobPostingPayload = {
  __typename?: 'DeleteAtsJobPostingPayload';
  errors: Array<MutationError>;
  jobPosting?: Maybe<AtsJobPosting>;
};

/** Autogenerated return type of DeleteAtsMessageTemplate. */
export type DeleteAtsMessageTemplatePayload = {
  __typename?: 'DeleteAtsMessageTemplatePayload';
  errors: Array<MutationError>;
  messageTemplate?: Maybe<AtsMessageTemplate>;
};

/** Autogenerated return type of DeleteAtsOfferLetter. */
export type DeleteAtsOfferLetterPayload = {
  __typename?: 'DeleteAtsOfferLetterPayload';
  errors: Array<MutationError>;
  offerLetter?: Maybe<AtsOfferLetter>;
};

/** Autogenerated return type of DeleteAtsOfferLetterTemplate. */
export type DeleteAtsOfferLetterTemplatePayload = {
  __typename?: 'DeleteAtsOfferLetterTemplatePayload';
  errors: Array<MutationError>;
  offerLetterTemplate?: Maybe<AtsOfferLetterTemplate>;
};

/** Autogenerated return type of DeleteAtsOpenApplicationSetting. */
export type DeleteAtsOpenApplicationSettingPayload = {
  __typename?: 'DeleteAtsOpenApplicationSettingPayload';
  errors: Array<MutationError>;
  openApplicationSetting?: Maybe<AtsOpenApplicationSetting>;
};

/** Autogenerated return type of DeleteAtsQuestion. */
export type DeleteAtsQuestionPayload = {
  __typename?: 'DeleteAtsQuestionPayload';
  errors: Array<MutationError>;
  question?: Maybe<AtsQuestion>;
};

/** Autogenerated return type of DeleteAtsQuestionTemplate. */
export type DeleteAtsQuestionTemplatePayload = {
  __typename?: 'DeleteAtsQuestionTemplatePayload';
  errors: Array<MutationError>;
  questionTemplate?: Maybe<AtsQuestionTemplate>;
};

/** Autogenerated return type of DeleteAtsReferral. */
export type DeleteAtsReferralPayload = {
  __typename?: 'DeleteAtsReferralPayload';
  errors: Array<MutationError>;
  referral?: Maybe<AtsReferral>;
};

/** Autogenerated return type of DeleteAtsRejectionReason. */
export type DeleteAtsRejectionReasonPayload = {
  __typename?: 'DeleteAtsRejectionReasonPayload';
  errors: Array<MutationError>;
  rejectionReason?: Maybe<AtsRejectionReason>;
};

/** Autogenerated return type of DeleteAtsRequisition. */
export type DeleteAtsRequisitionPayload = {
  __typename?: 'DeleteAtsRequisitionPayload';
  errors: Array<MutationError>;
  requisition?: Maybe<AtsRequisition>;
};

/** Autogenerated return type of DeleteAtsTag. */
export type DeleteAtsTagPayload = {
  __typename?: 'DeleteAtsTagPayload';
  errors: Array<MutationError>;
  tag?: Maybe<AtsTag>;
};

/** Autogenerated return type of DeleteAttendanceCompanySettingsVersion. */
export type DeleteAttendanceCompanySettingsVersionPayload = {
  __typename?: 'DeleteAttendanceCompanySettingsVersionPayload';
  companySettingsVersion?: Maybe<AttendanceCompanySettingsVersion>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DeleteAttendanceCustomTimeRangeCategory. */
export type DeleteAttendanceCustomTimeRangeCategoryPayload = {
  __typename?: 'DeleteAttendanceCustomTimeRangeCategoryPayload';
  customTimeRangeCategory?: Maybe<AttendanceCustomTimeRangeCategory>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DeleteAttendanceEditTimesheetRequest. */
export type DeleteAttendanceEditTimesheetRequestPayload = {
  __typename?: 'DeleteAttendanceEditTimesheetRequestPayload';
  editTimesheetRequest?: Maybe<AttendanceEditTimesheetRequest>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DeleteAttendanceEmployeesPolicy. */
export type DeleteAttendanceEmployeesPolicyPayload = {
  __typename?: 'DeleteAttendanceEmployeesPolicyPayload';
  employeesPolicy?: Maybe<AttendanceEmployeesPolicy>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DeleteAttendanceExtraHoursRange. */
export type DeleteAttendanceExtraHoursRangePayload = {
  __typename?: 'DeleteAttendanceExtraHoursRangePayload';
  errors: Array<MutationError>;
  extraHoursRange?: Maybe<AttendanceExtraHoursRange>;
};

/** Autogenerated return type of DeleteAttendanceOvertimeRequest. */
export type DeleteAttendanceOvertimeRequestPayload = {
  __typename?: 'DeleteAttendanceOvertimeRequestPayload';
  errors: Array<MutationError>;
  overtimeRequest?: Maybe<AttendanceOvertimeRequest>;
};

/** Autogenerated return type of DeleteAttendanceShift. */
export type DeleteAttendanceShiftPayload = {
  __typename?: 'DeleteAttendanceShiftPayload';
  errors: Array<MutationError>;
  shift?: Maybe<AttendanceShift>;
};

/** Autogenerated return type of DeleteAuthenticationDomain. */
export type DeleteAuthenticationDomainPayload = {
  __typename?: 'DeleteAuthenticationDomainPayload';
  domain?: Maybe<AuthenticationDomain>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DeleteBankingBankAccount. */
export type DeleteBankingBankAccountPayload = {
  __typename?: 'DeleteBankingBankAccountPayload';
  bankAccount?: Maybe<BankingBankAccount>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DeleteBankingOnboarding. */
export type DeleteBankingOnboardingPayload = {
  __typename?: 'DeleteBankingOnboardingPayload';
  errors: Array<MutationError>;
  onboarding?: Maybe<BankingOnboarding>;
};

/** Autogenerated return type of DeleteBankingPayment. */
export type DeleteBankingPaymentPayload = {
  __typename?: 'DeleteBankingPaymentPayload';
  errors: Array<MutationError>;
  payment?: Maybe<BankingPayment>;
};

/** Autogenerated return type of DeleteBankingPaymentRequest. */
export type DeleteBankingPaymentRequestPayload = {
  __typename?: 'DeleteBankingPaymentRequestPayload';
  errors: Array<MutationError>;
  paymentRequest?: Maybe<BankingPaymentRequest>;
};

/** Autogenerated return type of DeleteBillingCpPaymentMethod. */
export type DeleteBillingCpPaymentMethodPayload = {
  __typename?: 'DeleteBillingCpPaymentMethodPayload';
  cpPaymentMethod?: Maybe<BillingCpPaymentMethod>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DeleteBillingCpSubscriptionContact. */
export type DeleteBillingCpSubscriptionContactPayload = {
  __typename?: 'DeleteBillingCpSubscriptionContactPayload';
  cpSubscriptionContact?: Maybe<BillingCpSubscriptionContact>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DeleteBillingSubscription. */
export type DeleteBillingSubscriptionPayload = {
  __typename?: 'DeleteBillingSubscriptionPayload';
  errors: Array<MutationError>;
  subscription?: Maybe<BillingSubscription>;
};

/** Autogenerated return type of DeleteBookkeepersmanagementBookkeeperAccess. */
export type DeleteBookkeepersmanagementBookkeeperAccessPayload = {
  __typename?: 'DeleteBookkeepersmanagementBookkeeperAccessPayload';
  bookkeeperAccess?: Maybe<BookkeepersManagementBookkeeperAccess>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DeleteBookkeepersmanagementBookkeeperCustomer. */
export type DeleteBookkeepersmanagementBookkeeperCustomerPayload = {
  __typename?: 'DeleteBookkeepersmanagementBookkeeperCustomerPayload';
  bookkeeperCustomer?: Maybe<BookkeepersManagementBookkeeperCustomer>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DeleteBookkeepersmanagementBookkeeper. */
export type DeleteBookkeepersmanagementBookkeeperPayload = {
  __typename?: 'DeleteBookkeepersmanagementBookkeeperPayload';
  bookkeeper?: Maybe<BookkeepersManagementBookkeeper>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DeleteBookkeepersmanagementTaskTaskDocument. */
export type DeleteBookkeepersmanagementTaskTaskDocumentPayload = {
  __typename?: 'DeleteBookkeepersmanagementTaskTaskDocumentPayload';
  errors: Array<MutationError>;
  taskDocument?: Maybe<BookkeepersManagementTaskDocument>;
};

/** Autogenerated return type of DeleteByFlexibleTimeRecordProjectmanagementFlexibleTimeRecordComment. */
export type DeleteByFlexibleTimeRecordProjectmanagementFlexibleTimeRecordCommentPayload = {
  __typename?: 'DeleteByFlexibleTimeRecordProjectmanagementFlexibleTimeRecordCommentPayload';
  errors: Array<MutationError>;
  flexibleTimeRecordComment?: Maybe<ProjectManagementFlexibleTimeRecordComment>;
};

/** Autogenerated return type of DeleteCompanypagePerk. */
export type DeleteCompanypagePerkPayload = {
  __typename?: 'DeleteCompanypagePerkPayload';
  errors: Array<MutationError>;
  perk?: Maybe<CompanyPagePerk>;
};

/** Autogenerated return type of DeleteCompensationsCycle. */
export type DeleteCompensationsCyclePayload = {
  __typename?: 'DeleteCompensationsCyclePayload';
  cycle?: Maybe<CompensationsCycle>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DeleteCompensationsEmployeesCompensation. */
export type DeleteCompensationsEmployeesCompensationPayload = {
  __typename?: 'DeleteCompensationsEmployeesCompensationPayload';
  employeesCompensation?: Maybe<CompensationsEmployeesCompensation>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DeleteCompensationsEmployeesCompensationsValidation. */
export type DeleteCompensationsEmployeesCompensationsValidationPayload = {
  __typename?: 'DeleteCompensationsEmployeesCompensationsValidationPayload';
  employeesCompensationsValidation?: Maybe<CompensationsEmployeesCompensationsValidation>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DeleteCompensationsFile. */
export type DeleteCompensationsFilePayload = {
  __typename?: 'DeleteCompensationsFilePayload';
  errors: Array<MutationError>;
  file?: Maybe<CompensationsFile>;
};

/** Autogenerated return type of DeleteCompensationsReimbursablePayrollConcept. */
export type DeleteCompensationsReimbursablePayrollConceptPayload = {
  __typename?: 'DeleteCompensationsReimbursablePayrollConceptPayload';
  errors: Array<MutationError>;
  reimbursablePayrollConcept?: Maybe<CompensationsReimbursablePayrollConcept>;
};

/** Autogenerated return type of DeleteCompetenciesCompetencyGroup. */
export type DeleteCompetenciesCompetencyGroupPayload = {
  __typename?: 'DeleteCompetenciesCompetencyGroupPayload';
  competencyGroup?: Maybe<CompetenciesCompetencyGroup>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DeleteCompetenciesCompetencyLevel. */
export type DeleteCompetenciesCompetencyLevelPayload = {
  __typename?: 'DeleteCompetenciesCompetencyLevelPayload';
  competencyLevel?: Maybe<CompetenciesCompetencyLevel>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DeleteCompetenciesCompetency. */
export type DeleteCompetenciesCompetencyPayload = {
  __typename?: 'DeleteCompetenciesCompetencyPayload';
  competency?: Maybe<CompetenciesCompetency>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DeleteComplaintsCategory. */
export type DeleteComplaintsCategoryPayload = {
  __typename?: 'DeleteComplaintsCategoryPayload';
  category?: Maybe<ComplaintsCategory>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DeleteComplaintsNote. */
export type DeleteComplaintsNotePayload = {
  __typename?: 'DeleteComplaintsNotePayload';
  errors: Array<MutationError>;
  note?: Maybe<ComplaintsNote>;
};

/** Autogenerated return type of DeleteContractSoftwaremanagementSoftwareSetup. */
export type DeleteContractSoftwaremanagementSoftwareSetupPayload = {
  __typename?: 'DeleteContractSoftwaremanagementSoftwareSetupPayload';
  errors: Array<MutationError>;
  softwareSetup?: Maybe<SoftwareManagementSoftwareSetup>;
};

/** Autogenerated return type of DeleteContractsCompensation. */
export type DeleteContractsCompensationPayload = {
  __typename?: 'DeleteContractsCompensationPayload';
  compensation?: Maybe<ContractsCompensation>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DeleteContractsContractVersion. */
export type DeleteContractsContractVersionPayload = {
  __typename?: 'DeleteContractsContractVersionPayload';
  contractVersion?: Maybe<ContractsContractVersion>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DeleteContractsContractVersionRequest. */
export type DeleteContractsContractVersionRequestPayload = {
  __typename?: 'DeleteContractsContractVersionRequestPayload';
  contractVersionRequest?: Maybe<ContractsContractVersionRequest>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DeleteCostcentersCostCenter. */
export type DeleteCostcentersCostCenterPayload = {
  __typename?: 'DeleteCostcentersCostCenterPayload';
  costCenter?: Maybe<CostCentersCostCenter>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DeleteCustomRangeProjectmanagementPlannedRecord. */
export type DeleteCustomRangeProjectmanagementPlannedRecordPayload = {
  __typename?: 'DeleteCustomRangeProjectmanagementPlannedRecordPayload';
  errors: Array<MutationError>;
  plannedRecords?: Maybe<Array<ProjectManagementPlannedRecord>>;
};

/** Autogenerated return type of DeleteCustomfieldsField. */
export type DeleteCustomfieldsFieldPayload = {
  __typename?: 'DeleteCustomfieldsFieldPayload';
  errors: Array<MutationError>;
  field?: Maybe<CustomFieldsField>;
};

/** Autogenerated return type of DeleteCustomresourcesValue. */
export type DeleteCustomresourcesValuePayload = {
  __typename?: 'DeleteCustomresourcesValuePayload';
  errors: Array<MutationError>;
  value?: Maybe<CustomResourcesValue>;
};

/** Autogenerated return type of DeleteDocumentsDocument. */
export type DeleteDocumentsDocumentPayload = {
  __typename?: 'DeleteDocumentsDocumentPayload';
  document?: Maybe<DocumentsDocument>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DeleteDocumentsTemplate. */
export type DeleteDocumentsTemplatePayload = {
  __typename?: 'DeleteDocumentsTemplatePayload';
  errors: Array<MutationError>;
  template?: Maybe<DocumentsTemplate>;
};

/** Autogenerated return type of DeleteEmployeesEmployeeGroup. */
export type DeleteEmployeesEmployeeGroupPayload = {
  __typename?: 'DeleteEmployeesEmployeeGroupPayload';
  employeeGroup?: Maybe<EmployeesEmployeeGroup>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DeleteExpensesExpensableGroup. */
export type DeleteExpensesExpensableGroupPayload = {
  __typename?: 'DeleteExpensesExpensableGroupPayload';
  errors: Array<MutationError>;
  expensableGroup?: Maybe<ExpensesExpensableGroup>;
};

/** Autogenerated return type of DeleteExpensesExpensable. */
export type DeleteExpensesExpensablePayload = {
  __typename?: 'DeleteExpensesExpensablePayload';
  errors: Array<MutationError>;
  expensable?: Maybe<ExpensesExpensable>;
};

/** Autogenerated return type of DeleteFinanceAccount. */
export type DeleteFinanceAccountPayload = {
  __typename?: 'DeleteFinanceAccountPayload';
  account?: Maybe<FinanceAccount>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DeleteFinanceComplianceExtraFieldDefaultSetting. */
export type DeleteFinanceComplianceExtraFieldDefaultSettingPayload = {
  __typename?: 'DeleteFinanceComplianceExtraFieldDefaultSettingPayload';
  complianceExtraFieldDefaultSetting?: Maybe<FinanceComplianceExtraFieldDefaultSetting>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DeleteFinanceContact. */
export type DeleteFinanceContactPayload = {
  __typename?: 'DeleteFinanceContactPayload';
  contact?: Maybe<FinanceContact>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DeleteFinanceCostCenter. */
export type DeleteFinanceCostCenterPayload = {
  __typename?: 'DeleteFinanceCostCenterPayload';
  costCenter?: Maybe<FinanceCostCenter>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DeleteFinanceCustomDimension. */
export type DeleteFinanceCustomDimensionPayload = {
  __typename?: 'DeleteFinanceCustomDimensionPayload';
  customDimension?: Maybe<FinanceCustomDimension>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DeleteFinanceCustomDimensionValue. */
export type DeleteFinanceCustomDimensionValuePayload = {
  __typename?: 'DeleteFinanceCustomDimensionValuePayload';
  customDimensionValue?: Maybe<FinanceCustomDimensionValue>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DeleteFinanceFinancialDocument. */
export type DeleteFinanceFinancialDocumentPayload = {
  __typename?: 'DeleteFinanceFinancialDocumentPayload';
  errors: Array<MutationError>;
  financialDocument?: Maybe<FinanceFinancialDocument>;
};

/** Autogenerated return type of DeleteFinanceSalesDocumentTemplate. */
export type DeleteFinanceSalesDocumentTemplatePayload = {
  __typename?: 'DeleteFinanceSalesDocumentTemplatePayload';
  errors: Array<MutationError>;
  salesDocumentTemplate?: Maybe<FinanceSalesDocumentTemplate>;
};

/** Autogenerated return type of DeleteFinanceSerialSequenceCreditNoteSequence. */
export type DeleteFinanceSerialSequenceCreditNoteSequencePayload = {
  __typename?: 'DeleteFinanceSerialSequenceCreditNoteSequencePayload';
  creditNoteSequence?: Maybe<FinanceCreditNoteSequence>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DeleteFinanceSerialSequenceSalesInvoiceSequence. */
export type DeleteFinanceSerialSequenceSalesInvoiceSequencePayload = {
  __typename?: 'DeleteFinanceSerialSequenceSalesInvoiceSequencePayload';
  errors: Array<MutationError>;
  salesInvoiceSequence?: Maybe<FinanceSalesInvoiceSequence>;
};

/** Autogenerated return type of DeleteFinanceSpendingPolicySpendingPolicy. */
export type DeleteFinanceSpendingPolicySpendingPolicyPayload = {
  __typename?: 'DeleteFinanceSpendingPolicySpendingPolicyPayload';
  errors: Array<MutationError>;
  spendingPolicy?: Maybe<FinanceSpendingPolicy>;
};

/** Autogenerated return type of DeleteFinanceSpendingPolicySpendingPolicyRuleGroup. */
export type DeleteFinanceSpendingPolicySpendingPolicyRuleGroupPayload = {
  __typename?: 'DeleteFinanceSpendingPolicySpendingPolicyRuleGroupPayload';
  errors: Array<MutationError>;
  spendingPolicyRuleGroup?: Maybe<FinanceSpendingPolicyRuleGroup>;
};

/** Autogenerated return type of DeleteFinanceTaxRate. */
export type DeleteFinanceTaxRatePayload = {
  __typename?: 'DeleteFinanceTaxRatePayload';
  errors: Array<MutationError>;
  taxRate?: Maybe<FinanceTaxRate>;
};

/** Autogenerated return type of DeleteFinanceTaxType. */
export type DeleteFinanceTaxTypePayload = {
  __typename?: 'DeleteFinanceTaxTypePayload';
  errors: Array<MutationError>;
  taxType?: Maybe<FinanceTaxType>;
};

/** Autogenerated return type of DeleteFormsElement. */
export type DeleteFormsElementPayload = {
  __typename?: 'DeleteFormsElementPayload';
  element?: Maybe<FormsElement>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DeleteFormsForm. */
export type DeleteFormsFormPayload = {
  __typename?: 'DeleteFormsFormPayload';
  errors: Array<MutationError>;
  form?: Maybe<FormsForm>;
};

/** Autogenerated return type of DeleteGoalsMetricGroup. */
export type DeleteGoalsMetricGroupPayload = {
  __typename?: 'DeleteGoalsMetricGroupPayload';
  errors: Array<MutationError>;
  metricGroup?: Maybe<GoalsMetricGroup>;
};

/** Autogenerated return type of DeleteGoalsMetric. */
export type DeleteGoalsMetricPayload = {
  __typename?: 'DeleteGoalsMetricPayload';
  errors: Array<MutationError>;
  metric?: Maybe<GoalsMetric>;
};

/** Autogenerated return type of DeleteHandbookpagesPage. */
export type DeleteHandbookpagesPagePayload = {
  __typename?: 'DeleteHandbookpagesPagePayload';
  errors: Array<MutationError>;
  page?: Maybe<HandbookPagesPage>;
};

/** Autogenerated return type of DeleteIntegrationsdatevlaudsOauthToken. */
export type DeleteIntegrationsdatevlaudsOauthTokenPayload = {
  __typename?: 'DeleteIntegrationsdatevlaudsOauthTokenPayload';
  errors: Array<MutationError>;
  oauthToken?: Maybe<IntegrationsDatevLaudsOauthToken>;
};

/** Autogenerated return type of DeleteIntegrationsinfojobsOffer. */
export type DeleteIntegrationsinfojobsOfferPayload = {
  __typename?: 'DeleteIntegrationsinfojobsOfferPayload';
  errors: Array<MutationError>;
  offer?: Maybe<IntegrationsInfojobsOffer>;
};

/** Autogenerated return type of DeleteIntegrationsjoinJobPosting. */
export type DeleteIntegrationsjoinJobPostingPayload = {
  __typename?: 'DeleteIntegrationsjoinJobPostingPayload';
  errors: Array<MutationError>;
  jobPosting?: Maybe<IntegrationsJoinJobPosting>;
};

/** Autogenerated return type of DeleteIntegrationsjoinJoinCompany. */
export type DeleteIntegrationsjoinJoinCompanyPayload = {
  __typename?: 'DeleteIntegrationsjoinJoinCompanyPayload';
  errors: Array<MutationError>;
  joinCompany?: Maybe<IntegrationsJoinJoinCompany>;
};

/** Autogenerated return type of DeleteIntegrationsjoinOffice. */
export type DeleteIntegrationsjoinOfficePayload = {
  __typename?: 'DeleteIntegrationsjoinOfficePayload';
  errors: Array<MutationError>;
  office?: Maybe<IntegrationsJoinOffice>;
};

/** Autogenerated return type of DeleteItmanagementDocumentTemplate. */
export type DeleteItmanagementDocumentTemplatePayload = {
  __typename?: 'DeleteItmanagementDocumentTemplatePayload';
  documentTemplate?: Maybe<ItManagementDocumentTemplate>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DeleteItmanagementItAssetDocument. */
export type DeleteItmanagementItAssetDocumentPayload = {
  __typename?: 'DeleteItmanagementItAssetDocumentPayload';
  errors: Array<MutationError>;
  itAssetDocument?: Maybe<ItManagementItAssetDocument>;
};

/** Autogenerated return type of DeleteItmanagementItAsset. */
export type DeleteItmanagementItAssetPayload = {
  __typename?: 'DeleteItmanagementItAssetPayload';
  errors: Array<MutationError>;
  itAsset?: Maybe<ItManagementItAsset>;
};

/** Autogenerated return type of DeleteJobcatalogExpectation. */
export type DeleteJobcatalogExpectationPayload = {
  __typename?: 'DeleteJobcatalogExpectationPayload';
  errors: Array<MutationError>;
  expectation?: Maybe<JobCatalogExpectation>;
};

/** Autogenerated return type of DeleteJobcatalogNodeAttribute. */
export type DeleteJobcatalogNodeAttributePayload = {
  __typename?: 'DeleteJobcatalogNodeAttributePayload';
  errors: Array<MutationError>;
  nodeAttribute?: Maybe<JobCatalogNodeAttribute>;
};

/** Autogenerated return type of DeleteJobcatalogTreeNode. */
export type DeleteJobcatalogTreeNodePayload = {
  __typename?: 'DeleteJobcatalogTreeNodePayload';
  errors: Array<MutationError>;
  treeNode?: Maybe<JobCatalogTreeNode>;
};

/** Autogenerated return type of DeleteJobcatalogTree. */
export type DeleteJobcatalogTreePayload = {
  __typename?: 'DeleteJobcatalogTreePayload';
  errors: Array<MutationError>;
  tree?: Maybe<JobCatalogTree>;
};

/** Autogenerated return type of DeleteLayoutFavourite. */
export type DeleteLayoutFavouritePayload = {
  __typename?: 'DeleteLayoutFavouritePayload';
  errors: Array<MutationError>;
  favourite?: Maybe<LayoutFavourite>;
};

/** Autogenerated return type of DeleteLocationsLocation. */
export type DeleteLocationsLocationPayload = {
  __typename?: 'DeleteLocationsLocationPayload';
  errors: Array<MutationError>;
  location?: Maybe<LocationsLocation>;
};

/** Autogenerated return type of DeleteMarketplaceCompanyInstallation. */
export type DeleteMarketplaceCompanyInstallationPayload = {
  __typename?: 'DeleteMarketplaceCompanyInstallationPayload';
  companyInstallation?: Maybe<MarketplaceCompanyInstallation>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DeleteMeetingsMeeting. */
export type DeleteMeetingsMeetingPayload = {
  __typename?: 'DeleteMeetingsMeetingPayload';
  errors: Array<MutationError>;
  meeting?: Maybe<MeetingsMeeting>;
};

/** Autogenerated return type of DeleteMeetingsTemplate. */
export type DeleteMeetingsTemplatePayload = {
  __typename?: 'DeleteMeetingsTemplatePayload';
  errors: Array<MutationError>;
  template?: Maybe<MeetingsTemplate>;
};

/** Autogenerated return type of DeleteOneononesMeeting. */
export type DeleteOneononesMeetingPayload = {
  __typename?: 'DeleteOneononesMeetingPayload';
  errors: Array<MutationError>;
  meeting?: Maybe<OneOnOnesMeeting>;
};

/** Autogenerated return type of DeleteOpenaiFeedback. */
export type DeleteOpenaiFeedbackPayload = {
  __typename?: 'DeleteOpenaiFeedbackPayload';
  errors: Array<MutationError>;
  feedback?: Maybe<OpenAiFeedback>;
};

/** Autogenerated return type of DeletePagesPage. */
export type DeletePagesPagePayload = {
  __typename?: 'DeletePagesPagePayload';
  errors: Array<MutationError>;
  page?: Maybe<PagesPage>;
};

/** Autogenerated return type of DeletePayrollResult. */
export type DeletePayrollResultPayload = {
  __typename?: 'DeletePayrollResultPayload';
  errors: Array<MutationError>;
  result?: Maybe<PayrollResult>;
};

/** Autogenerated return type of DeletePayrollSupplementObservation. */
export type DeletePayrollSupplementObservationPayload = {
  __typename?: 'DeletePayrollSupplementObservationPayload';
  errors: Array<MutationError>;
  supplementObservation?: Maybe<PayrollSupplementObservation>;
};

/** Autogenerated return type of DeletePayrollSupplement. */
export type DeletePayrollSupplementPayload = {
  __typename?: 'DeletePayrollSupplementPayload';
  errors: Array<MutationError>;
  supplement?: Maybe<PayrollSupplement>;
};

/** Autogenerated return type of DeletePayrollSupplementValidation. */
export type DeletePayrollSupplementValidationPayload = {
  __typename?: 'DeletePayrollSupplementValidationPayload';
  errors: Array<MutationError>;
  supplementValidation?: Maybe<PayrollSupplementValidation>;
};

/** Autogenerated return type of DeletePayrollemployeesIdentifier. */
export type DeletePayrollemployeesIdentifierPayload = {
  __typename?: 'DeletePayrollemployeesIdentifierPayload';
  errors: Array<MutationError>;
  identifier?: Maybe<PayrollEmployeesIdentifier>;
};

/** Autogenerated return type of DeletePayrollintegrationsA3innuvaOauthToken. */
export type DeletePayrollintegrationsA3innuvaOauthTokenPayload = {
  __typename?: 'DeletePayrollintegrationsA3innuvaOauthTokenPayload';
  errors: Array<MutationError>;
  oauthToken?: Maybe<PayrollIntegrationsA3innuvaOauthToken>;
};

/** Autogenerated return type of DeletePayrollintegrationsBaseCode. */
export type DeletePayrollintegrationsBaseCodePayload = {
  __typename?: 'DeletePayrollintegrationsBaseCodePayload';
  code?: Maybe<PayrollIntegrationsBaseCode>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DeletePerformanceAgreementActionItem. */
export type DeletePerformanceAgreementActionItemPayload = {
  __typename?: 'DeletePerformanceAgreementActionItemPayload';
  agreementActionItem?: Maybe<PerformanceAgreementActionItem>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DeletePerformanceReviewOwner. */
export type DeletePerformanceReviewOwnerPayload = {
  __typename?: 'DeletePerformanceReviewOwnerPayload';
  errors: Array<MutationError>;
  reviewOwner?: Maybe<PerformanceReviewOwner>;
};

/** Autogenerated return type of DeletePerformanceReviewProcessCustomTemplate. */
export type DeletePerformanceReviewProcessCustomTemplatePayload = {
  __typename?: 'DeletePerformanceReviewProcessCustomTemplatePayload';
  errors: Array<MutationError>;
  reviewProcessCustomTemplate?: Maybe<PerformanceReviewProcessCustomTemplate>;
};

/** Autogenerated return type of DeletePerformanceReviewProcess. */
export type DeletePerformanceReviewProcessPayload = {
  __typename?: 'DeletePerformanceReviewProcessPayload';
  errors: Array<MutationError>;
  reviewProcess?: Maybe<PerformanceReviewProcess>;
};

/** Autogenerated return type of DeletePerformanceReviewProcessTarget. */
export type DeletePerformanceReviewProcessTargetPayload = {
  __typename?: 'DeletePerformanceReviewProcessTargetPayload';
  errors: Array<MutationError>;
  reviewProcessTarget?: Maybe<PerformanceReviewProcessTarget>;
};

/** Autogenerated return type of DeletePerformanceScoreConfiguration. */
export type DeletePerformanceScoreConfigurationPayload = {
  __typename?: 'DeletePerformanceScoreConfigurationPayload';
  errors: Array<MutationError>;
  scoreConfiguration?: Maybe<PerformanceScoreConfiguration>;
};

/** Autogenerated return type of DeletePerformancecyclesCycle. */
export type DeletePerformancecyclesCyclePayload = {
  __typename?: 'DeletePerformancecyclesCyclePayload';
  cycle?: Maybe<PerformanceCyclesCycle>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DeletePermissionsPermissionGroup. */
export type DeletePermissionsPermissionGroupPayload = {
  __typename?: 'DeletePermissionsPermissionGroupPayload';
  errors: Array<MutationError>;
  permissionGroup?: Maybe<PermissionsPermissionGroup>;
};

/** Autogenerated return type of DeletePositionsPosition. */
export type DeletePositionsPositionPayload = {
  __typename?: 'DeletePositionsPositionPayload';
  errors: Array<MutationError>;
  position?: Maybe<PositionsPosition>;
};

/** Autogenerated return type of DeletePostsComment. */
export type DeletePostsCommentPayload = {
  __typename?: 'DeletePostsCommentPayload';
  comment?: Maybe<PostsComment>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DeletePostsGroup. */
export type DeletePostsGroupPayload = {
  __typename?: 'DeletePostsGroupPayload';
  errors: Array<MutationError>;
  group?: Maybe<PostsGroup>;
};

/** Autogenerated return type of DeletePostsPost. */
export type DeletePostsPostPayload = {
  __typename?: 'DeletePostsPostPayload';
  errors: Array<MutationError>;
  post?: Maybe<PostsPost>;
};

/** Autogenerated return type of DeletePostsReaction. */
export type DeletePostsReactionPayload = {
  __typename?: 'DeletePostsReactionPayload';
  errors: Array<MutationError>;
  reaction?: Maybe<PostsReaction>;
};

/** Autogenerated return type of DeleteProcurementPurchaseRequest. */
export type DeleteProcurementPurchaseRequestPayload = {
  __typename?: 'DeleteProcurementPurchaseRequestPayload';
  errors: Array<MutationError>;
  purchaseRequest?: Maybe<ProcurementPurchaseRequest>;
};

/** Autogenerated return type of DeleteProcurementType. */
export type DeleteProcurementTypePayload = {
  __typename?: 'DeleteProcurementTypePayload';
  errors: Array<MutationError>;
  type?: Maybe<ProcurementType>;
};

/** Autogenerated return type of DeleteProductupdatesSubscription. */
export type DeleteProductupdatesSubscriptionPayload = {
  __typename?: 'DeleteProductupdatesSubscriptionPayload';
  errors: Array<MutationError>;
  subscription?: Maybe<ProductUpdatesSubscription>;
};

/** Autogenerated return type of DeleteProjectmanagementBudgetStrategy. */
export type DeleteProjectmanagementBudgetStrategyPayload = {
  __typename?: 'DeleteProjectmanagementBudgetStrategyPayload';
  budgetStrategy?: Maybe<ProjectManagementBudgetStrategy>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DeleteProjectmanagementFavouriteProject. */
export type DeleteProjectmanagementFavouriteProjectPayload = {
  __typename?: 'DeleteProjectmanagementFavouriteProjectPayload';
  errors: Array<MutationError>;
  favouriteProject?: Maybe<ProjectManagementFavouriteProject>;
};

/** Autogenerated return type of DeleteProjectmanagementFixedCostPlanning. */
export type DeleteProjectmanagementFixedCostPlanningPayload = {
  __typename?: 'DeleteProjectmanagementFixedCostPlanningPayload';
  errors: Array<MutationError>;
  fixedCostPlanning?: Maybe<ProjectManagementFixedCostPlanning>;
};

/** Autogenerated return type of DeleteProjectmanagementFixedTimeBudget. */
export type DeleteProjectmanagementFixedTimeBudgetPayload = {
  __typename?: 'DeleteProjectmanagementFixedTimeBudgetPayload';
  errors: Array<MutationError>;
  fixedTimeBudget?: Maybe<ProjectManagementFixedTimeBudget>;
};

/** Autogenerated return type of DeleteProjectmanagementFlexibleTimeRecord. */
export type DeleteProjectmanagementFlexibleTimeRecordPayload = {
  __typename?: 'DeleteProjectmanagementFlexibleTimeRecordPayload';
  errors: Array<MutationError>;
  flexibleTimeRecord?: Maybe<ProjectManagementFlexibleTimeRecord>;
};

/** Autogenerated return type of DeleteProjectmanagementPlannedRecord. */
export type DeleteProjectmanagementPlannedRecordPayload = {
  __typename?: 'DeleteProjectmanagementPlannedRecordPayload';
  errors: Array<MutationError>;
  plannedRecord?: Maybe<ProjectManagementPlannedRecord>;
};

/** Autogenerated return type of DeleteProjectmanagementRate. */
export type DeleteProjectmanagementRatePayload = {
  __typename?: 'DeleteProjectmanagementRatePayload';
  errors: Array<MutationError>;
  rate?: Maybe<ProjectManagementRate>;
};

/** Autogenerated return type of DeleteProjectmanagementSubproject. */
export type DeleteProjectmanagementSubprojectPayload = {
  __typename?: 'DeleteProjectmanagementSubprojectPayload';
  errors: Array<MutationError>;
  subproject?: Maybe<ProjectManagementSubproject>;
};

/** Autogenerated return type of DeleteProjectmanagementTimeRecord. */
export type DeleteProjectmanagementTimeRecordPayload = {
  __typename?: 'DeleteProjectmanagementTimeRecordPayload';
  errors: Array<MutationError>;
  timeRecord?: Maybe<ProjectManagementTimeRecord>;
};

/** Autogenerated return type of DeleteReportsDashboard. */
export type DeleteReportsDashboardPayload = {
  __typename?: 'DeleteReportsDashboardPayload';
  dashboard?: Maybe<ReportsDashboard>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DeleteReportsFavourite. */
export type DeleteReportsFavouritePayload = {
  __typename?: 'DeleteReportsFavouritePayload';
  errors: Array<MutationError>;
  favourite?: Maybe<ReportsFavourite>;
};

/** Autogenerated return type of DeleteReportsReport. */
export type DeleteReportsReportPayload = {
  __typename?: 'DeleteReportsReportPayload';
  errors: Array<MutationError>;
  report?: Maybe<ReportsReport>;
};

/** Autogenerated return type of DeleteShiftmanagementDefaultShift. */
export type DeleteShiftmanagementDefaultShiftPayload = {
  __typename?: 'DeleteShiftmanagementDefaultShiftPayload';
  defaultShift?: Maybe<ShiftManagementDefaultShift>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DeleteShiftmanagementShift. */
export type DeleteShiftmanagementShiftPayload = {
  __typename?: 'DeleteShiftmanagementShiftPayload';
  errors: Array<MutationError>;
  shift?: Maybe<ShiftManagementShift>;
};

/** Autogenerated return type of DeleteShiftmanagementSwapShift. */
export type DeleteShiftmanagementSwapShiftPayload = {
  __typename?: 'DeleteShiftmanagementSwapShiftPayload';
  errors: Array<MutationError>;
  swapShift?: Maybe<ShiftManagementSwapShift>;
};

/** Autogenerated return type of DeleteShiftmanagementTemplate. */
export type DeleteShiftmanagementTemplatePayload = {
  __typename?: 'DeleteShiftmanagementTemplatePayload';
  errors: Array<MutationError>;
  template?: Maybe<ShiftManagementTemplate>;
};

/** Autogenerated return type of DeleteShiftmanagementTemplateWeek. */
export type DeleteShiftmanagementTemplateWeekPayload = {
  __typename?: 'DeleteShiftmanagementTemplateWeekPayload';
  errors: Array<MutationError>;
  templateWeek?: Maybe<ShiftManagementTemplateWeek>;
};

/** Autogenerated return type of DeleteShiftmanagementUnassignedShift. */
export type DeleteShiftmanagementUnassignedShiftPayload = {
  __typename?: 'DeleteShiftmanagementUnassignedShiftPayload';
  errors: Array<MutationError>;
  unassignedShift?: Maybe<ShiftManagementUnassignedShift>;
};

/** Autogenerated return type of DeleteSoftwaremanagementEmployeeSoftwareMembership. */
export type DeleteSoftwaremanagementEmployeeSoftwareMembershipPayload = {
  __typename?: 'DeleteSoftwaremanagementEmployeeSoftwareMembershipPayload';
  employeeSoftwareMembership?: Maybe<SoftwareManagementEmployeeSoftwareMembership>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DeleteSoftwaremanagementSoftwareSetup. */
export type DeleteSoftwaremanagementSoftwareSetupPayload = {
  __typename?: 'DeleteSoftwaremanagementSoftwareSetupPayload';
  errors: Array<MutationError>;
  softwareSetup?: Maybe<SoftwareManagementSoftwareSetup>;
};

/** Autogenerated return type of DeleteSpacecontrolWorkAreaMap. */
export type DeleteSpacecontrolWorkAreaMapPayload = {
  __typename?: 'DeleteSpacecontrolWorkAreaMapPayload';
  errors: Array<MutationError>;
  workAreaMap?: Maybe<SpaceControlWorkAreaMap>;
};

/** Autogenerated return type of DeleteSpacecontrolWorkAreaMapSpaceLocation. */
export type DeleteSpacecontrolWorkAreaMapSpaceLocationPayload = {
  __typename?: 'DeleteSpacecontrolWorkAreaMapSpaceLocationPayload';
  errors: Array<MutationError>;
  workAreaMapSpaceLocation?: Maybe<SpaceControlWorkAreaMapSpaceLocation>;
};

/** Autogenerated return type of DeleteSpacecontrolWorkSpace. */
export type DeleteSpacecontrolWorkSpacePayload = {
  __typename?: 'DeleteSpacecontrolWorkSpacePayload';
  errors: Array<MutationError>;
  workSpace?: Maybe<SpaceControlWorkSpace>;
};

/** Autogenerated return type of DeleteSurveysEditor. */
export type DeleteSurveysEditorPayload = {
  __typename?: 'DeleteSurveysEditorPayload';
  editor?: Maybe<SurveysEditor>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DeleteSurveysSurvey. */
export type DeleteSurveysSurveyPayload = {
  __typename?: 'DeleteSurveysSurveyPayload';
  errors: Array<MutationError>;
  survey?: Maybe<SurveysSurvey>;
};

/** Autogenerated return type of DeleteTaskCommentReactionTasksTask. */
export type DeleteTaskCommentReactionTasksTaskPayload = {
  __typename?: 'DeleteTaskCommentReactionTasksTaskPayload';
  errors: Array<MutationError>;
  task?: Maybe<TasksTask>;
};

/** Autogenerated return type of DeleteTasksTaskFile. */
export type DeleteTasksTaskFilePayload = {
  __typename?: 'DeleteTasksTaskFilePayload';
  errors: Array<MutationError>;
  taskFile?: Maybe<TasksTaskFile>;
};

/** Autogenerated return type of DeleteTasksTask. */
export type DeleteTasksTaskPayload = {
  __typename?: 'DeleteTasksTaskPayload';
  errors: Array<MutationError>;
  task?: Maybe<TasksTask>;
};

/** Autogenerated return type of DeleteTeamsMembership. */
export type DeleteTeamsMembershipPayload = {
  __typename?: 'DeleteTeamsMembershipPayload';
  errors: Array<MutationError>;
  membership?: Maybe<TeamsMembership>;
};

/** Autogenerated return type of DeleteTeamsTeam. */
export type DeleteTeamsTeamPayload = {
  __typename?: 'DeleteTeamsTeamPayload';
  errors: Array<MutationError>;
  team?: Maybe<TeamsTeam>;
};

/** Autogenerated return type of DeleteTimeinsightsInconsistency. */
export type DeleteTimeinsightsInconsistencyPayload = {
  __typename?: 'DeleteTimeinsightsInconsistencyPayload';
  errors: Array<MutationError>;
  inconsistency?: Maybe<TimeInsightsInconsistency>;
};

/** Autogenerated return type of DeleteTimeoffAllowanceIncidence. */
export type DeleteTimeoffAllowanceIncidencePayload = {
  __typename?: 'DeleteTimeoffAllowanceIncidencePayload';
  allowanceIncidence?: Maybe<TimeoffAllowanceIncidence>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DeleteTimeoffAllowance. */
export type DeleteTimeoffAllowancePayload = {
  __typename?: 'DeleteTimeoffAllowancePayload';
  allowance?: Maybe<TimeoffAllowance>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DeleteTimeoffBlockedPeriod. */
export type DeleteTimeoffBlockedPeriodPayload = {
  __typename?: 'DeleteTimeoffBlockedPeriodPayload';
  blockedPeriod?: Maybe<TimeoffBlockedPeriod>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DeleteTimeoffLeaveApprovalRule. */
export type DeleteTimeoffLeaveApprovalRulePayload = {
  __typename?: 'DeleteTimeoffLeaveApprovalRulePayload';
  errors: Array<MutationError>;
  leaveApprovalRule?: Maybe<TimeoffLeaveApprovalRule>;
};

/** Autogenerated return type of DeleteTimeoffLeave. */
export type DeleteTimeoffLeavePayload = {
  __typename?: 'DeleteTimeoffLeavePayload';
  errors: Array<MutationError>;
  leave?: Maybe<TimeoffLeave>;
};

/** Autogenerated return type of DeleteTimeoffPolicyAssignment. */
export type DeleteTimeoffPolicyAssignmentPayload = {
  __typename?: 'DeleteTimeoffPolicyAssignmentPayload';
  errors: Array<MutationError>;
  policyAssignment?: Maybe<TimeoffPolicyAssignment>;
};

/** Autogenerated return type of DeleteTimeoffPolicy. */
export type DeleteTimeoffPolicyPayload = {
  __typename?: 'DeleteTimeoffPolicyPayload';
  errors: Array<MutationError>;
  policy?: Maybe<TimeoffPolicy>;
};

/** Autogenerated return type of DeleteTimeplanningPlanningVersion. */
export type DeleteTimeplanningPlanningVersionPayload = {
  __typename?: 'DeleteTimeplanningPlanningVersionPayload';
  errors: Array<MutationError>;
  planningVersion?: Maybe<TimePlanningPlanningVersion>;
};

/** Autogenerated return type of DeleteTrainingsCategoryMapConfigItem. */
export type DeleteTrainingsCategoryMapConfigItemPayload = {
  __typename?: 'DeleteTrainingsCategoryMapConfigItemPayload';
  categoryMapConfigItem?: Maybe<TrainingsCategoryMapConfigItem>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DeleteTrainingsCategory. */
export type DeleteTrainingsCategoryPayload = {
  __typename?: 'DeleteTrainingsCategoryPayload';
  category?: Maybe<TrainingsCategory>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DeleteTrainingsLearningPlatform. */
export type DeleteTrainingsLearningPlatformPayload = {
  __typename?: 'DeleteTrainingsLearningPlatformPayload';
  errors: Array<MutationError>;
  learningPlatform?: Maybe<TrainingsLearningPlatform>;
};

/** Autogenerated return type of DeleteTrainingsReminder. */
export type DeleteTrainingsReminderPayload = {
  __typename?: 'DeleteTrainingsReminderPayload';
  errors: Array<MutationError>;
  reminder?: Maybe<TrainingsReminder>;
};

/** Autogenerated return type of DeleteTrainingsSessionFile. */
export type DeleteTrainingsSessionFilePayload = {
  __typename?: 'DeleteTrainingsSessionFilePayload';
  errors: Array<MutationError>;
  sessionFile?: Maybe<TrainingsSessionFile>;
};

/** Autogenerated return type of DeleteTrainingsSession. */
export type DeleteTrainingsSessionPayload = {
  __typename?: 'DeleteTrainingsSessionPayload';
  errors: Array<MutationError>;
  session?: Maybe<TrainingsSession>;
};

/** Autogenerated return type of DeleteTrainingsTrainingClassFile. */
export type DeleteTrainingsTrainingClassFilePayload = {
  __typename?: 'DeleteTrainingsTrainingClassFilePayload';
  errors: Array<MutationError>;
  trainingClassFile?: Maybe<TrainingsTrainingClassFile>;
};

/** Autogenerated return type of DeleteTrainingsTrainingClassLink. */
export type DeleteTrainingsTrainingClassLinkPayload = {
  __typename?: 'DeleteTrainingsTrainingClassLinkPayload';
  errors: Array<MutationError>;
  trainingClassLink?: Maybe<TrainingsTrainingClassLink>;
};

/** Autogenerated return type of DeleteTrainingsTrainingClass. */
export type DeleteTrainingsTrainingClassPayload = {
  __typename?: 'DeleteTrainingsTrainingClassPayload';
  errors: Array<MutationError>;
  trainingClass?: Maybe<TrainingsTrainingClass>;
};

/** Autogenerated return type of DeleteTrainingsTrainingFile. */
export type DeleteTrainingsTrainingFilePayload = {
  __typename?: 'DeleteTrainingsTrainingFilePayload';
  errors: Array<MutationError>;
  trainingFile?: Maybe<TrainingsTrainingFile>;
};

/** Autogenerated return type of DeleteTrainingsTrainingLink. */
export type DeleteTrainingsTrainingLinkPayload = {
  __typename?: 'DeleteTrainingsTrainingLinkPayload';
  errors: Array<MutationError>;
  trainingLink?: Maybe<TrainingsTrainingLink>;
};

/** Autogenerated return type of DeleteTrainingsTrainingMembershipFile. */
export type DeleteTrainingsTrainingMembershipFilePayload = {
  __typename?: 'DeleteTrainingsTrainingMembershipFilePayload';
  errors: Array<MutationError>;
  trainingMembershipFile?: Maybe<TrainingsTrainingMembershipFile>;
};

/** Autogenerated return type of DeleteTrainingsTraining. */
export type DeleteTrainingsTrainingPayload = {
  __typename?: 'DeleteTrainingsTrainingPayload';
  errors: Array<MutationError>;
  training?: Maybe<TrainingsTraining>;
};

/** Autogenerated return type of DeleteTrainingsTrainingRequest. */
export type DeleteTrainingsTrainingRequestPayload = {
  __typename?: 'DeleteTrainingsTrainingRequestPayload';
  errors: Array<MutationError>;
  trainingRequest?: Maybe<TrainingsTrainingRequest>;
};

/** Autogenerated return type of DeleteWithAltAllowanceTimeoffAllowance. */
export type DeleteWithAltAllowanceTimeoffAllowancePayload = {
  __typename?: 'DeleteWithAltAllowanceTimeoffAllowancePayload';
  allowance?: Maybe<TimeoffAllowance>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DeleteWorkflowsWorkflowNodeFile. */
export type DeleteWorkflowsWorkflowNodeFilePayload = {
  __typename?: 'DeleteWorkflowsWorkflowNodeFilePayload';
  errors: Array<MutationError>;
  workflowNodeFile?: Maybe<WorkflowsWorkflowNodeFile>;
};

/** Autogenerated return type of DeleteWorkscheduleOverlapPeriod. */
export type DeleteWorkscheduleOverlapPeriodPayload = {
  __typename?: 'DeleteWorkscheduleOverlapPeriodPayload';
  errors: Array<MutationError>;
  overlapPeriod?: Maybe<WorkScheduleOverlapPeriod>;
};

/** Autogenerated return type of DeleteWorkspaceLogoCompaniesLogo. */
export type DeleteWorkspaceLogoCompaniesLogoPayload = {
  __typename?: 'DeleteWorkspaceLogoCompaniesLogoPayload';
  errors: Array<MutationError>;
  logo?: Maybe<CompaniesLogo>;
};

/** Autogenerated return type of DestroyAtsHiringManager. */
export type DestroyAtsHiringManagerPayload = {
  __typename?: 'DestroyAtsHiringManagerPayload';
  errors: Array<MutationError>;
  hiringManager?: Maybe<AtsHiringManager>;
};

/** Autogenerated return type of DestroyDashboardCompanyLink. */
export type DestroyDashboardCompanyLinkPayload = {
  __typename?: 'DestroyDashboardCompanyLinkPayload';
  companyLink?: Maybe<DashboardCompanyLink>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DestroyDocumentsFolder. */
export type DestroyDocumentsFolderPayload = {
  __typename?: 'DestroyDocumentsFolderPayload';
  errors: Array<MutationError>;
  folder?: Maybe<DocumentsFolder>;
};

/** Autogenerated return type of DestroyEsignatureSignature. */
export type DestroyEsignatureSignaturePayload = {
  __typename?: 'DestroyEsignatureSignaturePayload';
  errors: Array<MutationError>;
  signature?: Maybe<EsignatureSignature>;
};

/** Autogenerated return type of DestroyFacerecognitionEmployeePicture. */
export type DestroyFacerecognitionEmployeePicturePayload = {
  __typename?: 'DestroyFacerecognitionEmployeePicturePayload';
  employeePicture?: Maybe<FaceRecognitionEmployeePicture>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DestroyHolidaysCompanyHoliday. */
export type DestroyHolidaysCompanyHolidayPayload = {
  __typename?: 'DestroyHolidaysCompanyHolidayPayload';
  companyHoliday?: Maybe<HolidaysCompanyHoliday>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DestroyJobcatalogLevel. */
export type DestroyJobcatalogLevelPayload = {
  __typename?: 'DestroyJobcatalogLevelPayload';
  errors: Array<MutationError>;
  level?: Maybe<JobCatalogLevel>;
};

/** Autogenerated return type of DestroyJobcatalogRole. */
export type DestroyJobcatalogRolePayload = {
  __typename?: 'DestroyJobcatalogRolePayload';
  errors: Array<MutationError>;
  role?: Maybe<JobCatalogRole>;
};

/** Autogenerated return type of DestroyJobcatalogSalaryRange. */
export type DestroyJobcatalogSalaryRangePayload = {
  __typename?: 'DestroyJobcatalogSalaryRangePayload';
  errors: Array<MutationError>;
  salaryRange?: Maybe<JobCatalogSalaryRange>;
};

/** Autogenerated return type of DestroyPayrollPayrollDocument. */
export type DestroyPayrollPayrollDocumentPayload = {
  __typename?: 'DestroyPayrollPayrollDocumentPayload';
  errors: Array<MutationError>;
  payrollDocument?: Maybe<PayrollPayrollDocument>;
};

/** Autogenerated return type of DestroyProcessesItemAssignee. */
export type DestroyProcessesItemAssigneePayload = {
  __typename?: 'DestroyProcessesItemAssigneePayload';
  errors: Array<MutationError>;
  itemAssignee?: Maybe<ProcessesItemAssignee>;
};

/** Autogenerated return type of DestroyProcessesItem. */
export type DestroyProcessesItemPayload = {
  __typename?: 'DestroyProcessesItemPayload';
  errors: Array<MutationError>;
  item?: Maybe<ProcessesItem>;
};

/** Autogenerated return type of DestroyProcessesMaterializedAssignee. */
export type DestroyProcessesMaterializedAssigneePayload = {
  __typename?: 'DestroyProcessesMaterializedAssigneePayload';
  errors: Array<MutationError>;
  materializedAssignee?: Maybe<ProcessesMaterializedAssignee>;
};

/** Autogenerated return type of DestroyProcessesMaterializedItem. */
export type DestroyProcessesMaterializedItemPayload = {
  __typename?: 'DestroyProcessesMaterializedItemPayload';
  errors: Array<MutationError>;
  materializedItem?: Maybe<ProcessesMaterializedItem>;
};

/** Autogenerated return type of DestroyProcessesMaterializedProcess. */
export type DestroyProcessesMaterializedProcessPayload = {
  __typename?: 'DestroyProcessesMaterializedProcessPayload';
  errors: Array<MutationError>;
  materializedProcess?: Maybe<ProcessesMaterializedProcess>;
};

/** Autogenerated return type of DestroyProcessesMaterializedStep. */
export type DestroyProcessesMaterializedStepPayload = {
  __typename?: 'DestroyProcessesMaterializedStepPayload';
  errors: Array<MutationError>;
  materializedStep?: Maybe<ProcessesMaterializedStep>;
};

/** Autogenerated return type of DestroyProcessesStep. */
export type DestroyProcessesStepPayload = {
  __typename?: 'DestroyProcessesStepPayload';
  errors: Array<MutationError>;
  step?: Maybe<ProcessesStep>;
};

/** Autogenerated return type of DetailsExpensesCard. */
export type DetailsExpensesCardPayload = {
  __typename?: 'DetailsExpensesCardPayload';
  card?: Maybe<ExpensesCard>;
  errors: Array<MutationError>;
};

/** A repo to create tentant scoped RoR direct uploads */
export type DirectUploadsDirectUpload = {
  __typename?: 'DirectUploadsDirectUpload';
  headers: Array<DirectUploadsHeader>;
  signedId: Scalars['String'];
  url: Scalars['String'];
};

export type DirectUploadsHeader = {
  __typename?: 'DirectUploadsHeader';
  name: Scalars['String'];
  value: Scalars['String'];
};

/** Autogenerated return type of DisableFinanceAccount. */
export type DisableFinanceAccountPayload = {
  __typename?: 'DisableFinanceAccountPayload';
  account?: Maybe<FinanceAccount>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DisableFinanceCustomCategory. */
export type DisableFinanceCustomCategoryPayload = {
  __typename?: 'DisableFinanceCustomCategoryPayload';
  customCategory?: Maybe<FinanceCustomCategory>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DisableIntegrationsinfojobsOffer. */
export type DisableIntegrationsinfojobsOfferPayload = {
  __typename?: 'DisableIntegrationsinfojobsOfferPayload';
  errors: Array<MutationError>;
  offer?: Maybe<IntegrationsInfojobsOffer>;
};

/** Autogenerated return type of DisableMfaAuthenticationAccess. */
export type DisableMfaAuthenticationAccessPayload = {
  __typename?: 'DisableMfaAuthenticationAccessPayload';
  access?: Maybe<AuthenticationAccess>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DisableWorkflowsWorkflow. */
export type DisableWorkflowsWorkflowPayload = {
  __typename?: 'DisableWorkflowsWorkflowPayload';
  errors: Array<MutationError>;
  workflow?: Maybe<WorkflowsWorkflow>;
};

/** Autogenerated return type of DiscardOutdatedTasksInboxTask. */
export type DiscardOutdatedTasksInboxTaskPayload = {
  __typename?: 'DiscardOutdatedTasksInboxTaskPayload';
  errors: Array<MutationError>;
  inboxTask?: Maybe<TasksInboxTask>;
};

/** Autogenerated return type of DistributeDocumentsUploadProcess. */
export type DistributeDocumentsUploadProcessPayload = {
  __typename?: 'DistributeDocumentsUploadProcessPayload';
  errors: Array<MutationError>;
  uploadProcess?: Maybe<DocumentsUploadProcess>;
};

export type DocumentNotificationStatusEnum =
  | 'declined_pending'
  | 'viewed';

export type DocumentSplitUploadTypesEnum =
  | 'combine'
  | 'do_not_touch'
  | 'manual_per_file'
  | 'manual_per_page'
  | 'split';

export type DocumentStatusesEnum =
  | 'filled'
  | 'to_fill';

export type DocumentsContextlessPolicies = {
  __typename?: 'DocumentsContextlessPolicies';
  companyEditInternalDocuments: ContextlessPolicyResolution;
  companyEditPublicDocuments: ContextlessPolicyResolution;
  companyManageEmployeesFolders: ContextlessPolicyResolution;
  companyManageFolders: ContextlessPolicyResolution;
  companyManagePublicCompanyFolders: ContextlessPolicyResolution;
  companySeeInternalDocuments: ContextlessPolicyResolution;
  companySeePublicDocuments: ContextlessPolicyResolution;
  companyUseCompanyDocuments: ContextlessPolicyResolution;
  employeeEditAnyEmployeeFolder: ContextlessPolicyResolution;
  employeeEditDocuments: ContextlessPolicyResolution;
  employeeEditDocumentsTrashBin: ContextlessPolicyResolution;
  employeeManageAnyEmployeeFolder: ContextlessPolicyResolution;
  employeeManageDefaultEmployeeFolder: ContextlessPolicyResolution;
  employeeSeeEmployeeFiles: ContextlessPolicyResolution;
  sidebarSeeDocumentsDocumentsSubLevelItem: ContextlessPolicyResolution;
  sidebarSeeDocumentsTopLevelItem: ContextlessPolicyResolution;
  sidebarSeeFilesBulkFilesSubLevelItem: ContextlessPolicyResolution;
  sidebarSeeFilesDocumentTemplatesSubLevelItem: ContextlessPolicyResolution;
  sidebarSeeFilesEmployeeFilesSubLevelItem: ContextlessPolicyResolution;
  sidebarSeeFilesManagementDocumentsSubLevelItem: ContextlessPolicyResolution;
  sidebarSeeFilesPublicDocumentsSubLevelItem: ContextlessPolicyResolution;
  sidebarSeeFilesTopLevelItem: ContextlessPolicyResolution;
  sidebarSeeTrash: ContextlessPolicyResolution;
  templateManageDocumentTemplates: ContextlessPolicyResolution;
  withoutFolderEverybodyEditEmployeeDocumentsWithoutFolder: ContextlessPolicyResolution;
};

/** Documents */
export type DocumentsDocument = {
  __typename?: 'DocumentsDocument';
  _policies?: Maybe<DocumentsDocumentPolicies>;
  _policiesCollection?: Maybe<Array<PermissionsPolicyResolution>>;
  _policiesConnection: PermissionsPolicyResolutionConnection;
  arCreatedAt?: Maybe<Scalars['Int']>;
  author?: Maybe<ApiCoreAccess>;
  /**
   * access identifier of the author, refers to /employees/employees endpoint.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  authorId?: Maybe<Scalars['Int']>;
  company: ApiCoreCompany;
  /**
   * company identifier, refers to /api/me endpoint.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  companyId?: Maybe<Scalars['Int']>;
  /** document content type. */
  contentType?: Maybe<Scalars['String']>;
  /** creation date of the document. */
  createdAt: Scalars['ISO8601DateTime'];
  /** deletion date of the document. */
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
  employee?: Maybe<EmployeesEmployee>;
  /**
   * employee identifier associated to the document.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  employeeId?: Maybe<Scalars['Int']>;
  /** document extension. */
  extension?: Maybe<Scalars['String']>;
  file?: Maybe<Scalars['String']>;
  /** document file size in bytes. */
  fileSize?: Maybe<Scalars['BigInt']>;
  fileUrl: Scalars['String'];
  /** name of the document. */
  filename: Scalars['String'];
  folder?: Maybe<DocumentsFolder>;
  /**
   * folder identifier, references to documents/folders endpoint.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  folderId?: Maybe<Scalars['Int']>;
  fromTemplate?: Maybe<Scalars['Boolean']>;
  /** document identifier. */
  id: Scalars['Int'];
  incidenceMessageId?: Maybe<Scalars['Int']>;
  /** flag that indicates if the document is a company document. */
  isCompanyDocument?: Maybe<Scalars['Boolean']>;
  /** flag that indicates if the document is a management document. */
  isManagementDocument?: Maybe<Scalars['Boolean']>;
  /** flag that indicates if the document is pending assignment. */
  isPendingAssignment?: Maybe<Scalars['Boolean']>;
  /** leave identifier associated to the document, refers to /timeoff/leaves endpoint. */
  leaveId?: Maybe<Scalars['Int']>;
  notificationStatus?: Maybe<Scalars['String']>;
  permissionUpdate: Scalars['Boolean'];
  /** flag to indicate if the document is public. */
  public: Scalars['Boolean'];
  /** document signature status. */
  signatureStatus?: Maybe<DocumentsSignatureStatusEnum>;
  /** list of signee access identifiers associated to the document, refers to /employees/employees endpoint. */
  signees?: Maybe<Array<Scalars['Int']>>;
  /** document space. */
  space: Scalars['String'];
  status?: Maybe<DocumentStatusesEnum>;
  template?: Maybe<DocumentsTemplate>;
  templateId?: Maybe<Scalars['Int']>;
  type: Scalars['String'];
  /** last update date of the document. */
  updatedAt: Scalars['ISO8601DateTime'];
  values: Array<CustomFieldsValue>;
  valuesConnection: CustomFieldsValueConnection;
};


/** Documents */
export type DocumentsDocument_PoliciesCollectionArgs = {
  ids: Array<DocumentsDocumentPoliciesEnum>;
};


/** Documents */
export type DocumentsDocument_PoliciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Documents */
export type DocumentsDocumentAuthorArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** Documents */
export type DocumentsDocumentEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Documents */
export type DocumentsDocumentFolderArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  ascendantFolderId?: InputMaybe<Scalars['Int']>;
  billingSubscriptionAddonId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['Int']>;
  descendantFolderId?: InputMaybe<Scalars['Int']>;
  employee?: InputMaybe<Scalars['Boolean']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  mobileRequest?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  parentFolderId?: InputMaybe<Scalars['Int']>;
  parentFolderIds?: InputMaybe<Array<Scalars['Int']>>;
  rootFolders?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Scalars['String']>;
  space?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  withCounters?: InputMaybe<Scalars['Boolean']>;
  withUnfilteredCounters?: InputMaybe<Scalars['Boolean']>;
};


/** Documents */
export type DocumentsDocumentTemplateArgs = {
  documentType?: InputMaybe<Scalars['String']>;
};


/** Documents */
export type DocumentsDocumentValuesArgs = {
  contractsVersionsIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  fieldId?: InputMaybe<Scalars['Int']>;
  identifiers?: InputMaybe<Array<Scalars['String']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  instanceId?: InputMaybe<Scalars['Int']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  updatedAtGteq?: InputMaybe<Scalars['String']>;
  usageGroupId?: InputMaybe<Scalars['Int']>;
  usageGroupSlugs?: InputMaybe<Array<Scalars['String']>>;
  value?: InputMaybe<Scalars['String']>;
};


/** Documents */
export type DocumentsDocumentValuesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  contractsVersionsIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  fieldId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  identifiers?: InputMaybe<Array<Scalars['String']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  instanceId?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  updatedAtGteq?: InputMaybe<Scalars['String']>;
  usageGroupId?: InputMaybe<Scalars['Int']>;
  usageGroupSlugs?: InputMaybe<Array<Scalars['String']>>;
  value?: InputMaybe<Scalars['String']>;
};

/** The connection type for DocumentsDocument. */
export type DocumentsDocumentConnection = {
  __typename?: 'DocumentsDocumentConnection';
  /** A list of edges. */
  edges: Array<DocumentsDocumentEdge>;
  /** A list of nodes. */
  nodes: Array<DocumentsDocument>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type DocumentsDocumentEdge = {
  __typename?: 'DocumentsDocumentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: DocumentsDocument;
};

/** the filter for the documents resource */
export type DocumentsDocumentFilter = {
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeFilter>;
  deletedBy?: InputMaybe<IntegerFilter>;
  employee?: InputMaybe<IntegerFilter>;
  employeeStatus?: InputMaybe<IntegerFilter>;
  filename?: InputMaybe<StringFilter>;
  folder?: InputMaybe<IntegerFilter>;
  legalEntity?: InputMaybe<IntegerFilter>;
  location?: InputMaybe<IntegerFilter>;
  or?: InputMaybe<Array<DocumentsDocumentFilterConditions>>;
  published?: InputMaybe<BooleanFilter>;
  signatureStatus?: InputMaybe<StringFilter>;
  team?: InputMaybe<IntegerFilter>;
};

export type DocumentsDocumentFilterConditions = {
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeFilter>;
  deletedBy?: InputMaybe<IntegerFilter>;
  employee?: InputMaybe<IntegerFilter>;
  employeeStatus?: InputMaybe<IntegerFilter>;
  filename?: InputMaybe<StringFilter>;
  folder?: InputMaybe<IntegerFilter>;
  legalEntity?: InputMaybe<IntegerFilter>;
  location?: InputMaybe<IntegerFilter>;
  published?: InputMaybe<BooleanFilter>;
  signatureStatus?: InputMaybe<StringFilter>;
  team?: InputMaybe<IntegerFilter>;
};

export type DocumentsDocumentPolicies = {
  __typename?: 'DocumentsDocumentPolicies';
  edit: PermissionsPolicyResolution;
};

export type DocumentsDocumentPoliciesEnum =
  | 'edit';

/** DownloadUrl */
export type DocumentsDownloadUrl = {
  __typename?: 'DocumentsDownloadUrl';
  /** document identifier. */
  id: Scalars['Int'];
  /** temporal document url. */
  url: Scalars['String'];
};

/** Editable Employee Document Folders */
export type DocumentsEditableEmployeeFolder = {
  __typename?: 'DocumentsEditableEmployeeFolder';
  _policies?: Maybe<DocumentsEditableEmployeeFolderPolicies>;
  _policiesCollection?: Maybe<Array<PermissionsPolicyResolution>>;
  _policiesConnection: PermissionsPolicyResolutionConnection;
  active: Scalars['Boolean'];
  billingSubscriptionAddonId?: Maybe<Scalars['Int']>;
  companyId?: Maybe<Scalars['Int']>;
  counterDocuments: Scalars['Int'];
  counterSubfolders: Scalars['Int'];
  id: Scalars['Int'];
  identifier?: Maybe<Scalars['String']>;
  isCompany: Scalars['Boolean'];
  isEmployee: Scalars['Boolean'];
  isExpense: Scalars['Boolean'];
  isReadonly: Scalars['Boolean'];
  managePermission?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  parentFolder?: Maybe<DocumentsFolder>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  parentFolderId?: Maybe<Scalars['Int']>;
  rootParentFolder?: Maybe<DocumentsFolder>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  rootParentFolderId?: Maybe<Scalars['Int']>;
  showOnly: Scalars['Boolean'];
  slug?: Maybe<Scalars['String']>;
  space: Scalars['String'];
  type?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};


/** Editable Employee Document Folders */
export type DocumentsEditableEmployeeFolder_PoliciesCollectionArgs = {
  ids: Array<DocumentsEditableEmployeeFolderPoliciesEnum>;
};


/** Editable Employee Document Folders */
export type DocumentsEditableEmployeeFolder_PoliciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Editable Employee Document Folders */
export type DocumentsEditableEmployeeFolderParentFolderArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  ascendantFolderId?: InputMaybe<Scalars['Int']>;
  billingSubscriptionAddonId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['Int']>;
  descendantFolderId?: InputMaybe<Scalars['Int']>;
  employee?: InputMaybe<Scalars['Boolean']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  mobileRequest?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  parentFolderId?: InputMaybe<Scalars['Int']>;
  parentFolderIds?: InputMaybe<Array<Scalars['Int']>>;
  rootFolders?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Scalars['String']>;
  space?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  withCounters?: InputMaybe<Scalars['Boolean']>;
  withUnfilteredCounters?: InputMaybe<Scalars['Boolean']>;
};


/** Editable Employee Document Folders */
export type DocumentsEditableEmployeeFolderRootParentFolderArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  ascendantFolderId?: InputMaybe<Scalars['Int']>;
  billingSubscriptionAddonId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['Int']>;
  descendantFolderId?: InputMaybe<Scalars['Int']>;
  employee?: InputMaybe<Scalars['Boolean']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  mobileRequest?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  parentFolderId?: InputMaybe<Scalars['Int']>;
  parentFolderIds?: InputMaybe<Array<Scalars['Int']>>;
  rootFolders?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Scalars['String']>;
  space?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  withCounters?: InputMaybe<Scalars['Boolean']>;
  withUnfilteredCounters?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for DocumentsEditableEmployeeFolder. */
export type DocumentsEditableEmployeeFolderConnection = {
  __typename?: 'DocumentsEditableEmployeeFolderConnection';
  /** A list of edges. */
  edges: Array<DocumentsEditableEmployeeFolderEdge>;
  /** A list of nodes. */
  nodes: Array<DocumentsEditableEmployeeFolder>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type DocumentsEditableEmployeeFolderEdge = {
  __typename?: 'DocumentsEditableEmployeeFolderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: DocumentsEditableEmployeeFolder;
};

export type DocumentsEditableEmployeeFolderPolicies = {
  __typename?: 'DocumentsEditableEmployeeFolderPolicies';
  editEmployeeFolderForEverybody: PermissionsPolicyResolution;
  editEmployeeFolderForOthers: PermissionsPolicyResolution;
};

export type DocumentsEditableEmployeeFolderPoliciesEnum =
  | 'edit_employee_folder_for_everybody'
  | 'edit_employee_folder_for_others';

/** Employee Document Folders */
export type DocumentsEmployeeFolder = {
  __typename?: 'DocumentsEmployeeFolder';
  _policies?: Maybe<DocumentsEmployeeFolderPolicies>;
  _policiesCollection?: Maybe<Array<PermissionsPolicyResolution>>;
  _policiesConnection: PermissionsPolicyResolutionConnection;
  employeeId: Scalars['Int'];
  folder?: Maybe<DocumentsFolder>;
  folderId: Scalars['Int'];
  id: Scalars['String'];
};


/** Employee Document Folders */
export type DocumentsEmployeeFolder_PoliciesCollectionArgs = {
  ids: Array<DocumentsEmployeeFolderPoliciesEnum>;
};


/** Employee Document Folders */
export type DocumentsEmployeeFolder_PoliciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Employee Document Folders */
export type DocumentsEmployeeFolderFolderArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  ascendantFolderId?: InputMaybe<Scalars['Int']>;
  billingSubscriptionAddonId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['Int']>;
  descendantFolderId?: InputMaybe<Scalars['Int']>;
  employee?: InputMaybe<Scalars['Boolean']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  mobileRequest?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  parentFolderId?: InputMaybe<Scalars['Int']>;
  parentFolderIds?: InputMaybe<Array<Scalars['Int']>>;
  rootFolders?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Scalars['String']>;
  space?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  withCounters?: InputMaybe<Scalars['Boolean']>;
  withUnfilteredCounters?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for DocumentsEmployeeFolder. */
export type DocumentsEmployeeFolderConnection = {
  __typename?: 'DocumentsEmployeeFolderConnection';
  /** A list of edges. */
  edges: Array<DocumentsEmployeeFolderEdge>;
  /** A list of nodes. */
  nodes: Array<DocumentsEmployeeFolder>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type DocumentsEmployeeFolderEdge = {
  __typename?: 'DocumentsEmployeeFolderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: DocumentsEmployeeFolder;
};

export type DocumentsEmployeeFolderPolicies = {
  __typename?: 'DocumentsEmployeeFolderPolicies';
  edit: PermissionsPolicyResolution;
};

export type DocumentsEmployeeFolderPoliciesEnum =
  | 'edit';

export type DocumentsFileData = {
  __typename?: 'DocumentsFileData';
  contentType: Scalars['String'];
  fileId: Scalars['Int'];
  filename: Scalars['String'];
  pages: Scalars['Int'];
};

/** Document Folders */
export type DocumentsFolder = {
  __typename?: 'DocumentsFolder';
  _policies?: Maybe<DocumentsFolderPolicies>;
  _policiesCollection?: Maybe<Array<PermissionsPolicyResolution>>;
  _policiesConnection: PermissionsPolicyResolutionConnection;
  /** Whether the folder is active or not */
  active: Scalars['Boolean'];
  billingSubscriptionAddonId?: Maybe<Scalars['Int']>;
  company?: Maybe<ApiCoreCompany>;
  /**
   * Company ID of the folder
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  companyId?: Maybe<Scalars['Int']>;
  counterDocuments: Scalars['Int'];
  counterSubfolders: Scalars['Int'];
  /** Folder ID */
  id: Scalars['Int'];
  identifier?: Maybe<Scalars['String']>;
  isCompany: Scalars['Boolean'];
  isEmployee: Scalars['Boolean'];
  isExpense: Scalars['Boolean'];
  isReadonly: Scalars['Boolean'];
  managePermission?: Maybe<Scalars['Boolean']>;
  /** Folder name */
  name: Scalars['String'];
  parentFolder?: Maybe<DocumentsFolder>;
  /**
   * Id of the parent folder
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  parentFolderId?: Maybe<Scalars['Int']>;
  resourceFields: Array<CustomFieldsResourceField>;
  resourceFieldsConnection: CustomFieldsResourceFieldConnection;
  rootParentFolder?: Maybe<DocumentsFolder>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  rootParentFolderId?: Maybe<Scalars['Int']>;
  showOnly: Scalars['Boolean'];
  slug?: Maybe<Scalars['String']>;
  /** The space of the folder is related to the place where the folder is displayed. */
  space: Scalars['String'];
  subfolders: Array<DocumentsFolder>;
  subfoldersConnection: DocumentsFolderConnection;
  type?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};


/** Document Folders */
export type DocumentsFolder_PoliciesCollectionArgs = {
  ids: Array<DocumentsFolderPoliciesEnum>;
};


/** Document Folders */
export type DocumentsFolder_PoliciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Document Folders */
export type DocumentsFolderParentFolderArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  ascendantFolderId?: InputMaybe<Scalars['Int']>;
  billingSubscriptionAddonId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['Int']>;
  descendantFolderId?: InputMaybe<Scalars['Int']>;
  employee?: InputMaybe<Scalars['Boolean']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  mobileRequest?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  parentFolderId?: InputMaybe<Scalars['Int']>;
  parentFolderIds?: InputMaybe<Array<Scalars['Int']>>;
  rootFolders?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Scalars['String']>;
  space?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  withCounters?: InputMaybe<Scalars['Boolean']>;
  withUnfilteredCounters?: InputMaybe<Scalars['Boolean']>;
};


/** Document Folders */
export type DocumentsFolderResourceFieldsArgs = {
  fieldIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  schemaIds?: InputMaybe<Array<Scalars['Int']>>;
  usageGroupSlugs?: InputMaybe<Array<Scalars['String']>>;
};


/** Document Folders */
export type DocumentsFolderResourceFieldsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  fieldIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  schemaIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
  usageGroupSlugs?: InputMaybe<Array<Scalars['String']>>;
};


/** Document Folders */
export type DocumentsFolderRootParentFolderArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  ascendantFolderId?: InputMaybe<Scalars['Int']>;
  billingSubscriptionAddonId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['Int']>;
  descendantFolderId?: InputMaybe<Scalars['Int']>;
  employee?: InputMaybe<Scalars['Boolean']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  mobileRequest?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  parentFolderId?: InputMaybe<Scalars['Int']>;
  parentFolderIds?: InputMaybe<Array<Scalars['Int']>>;
  rootFolders?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Scalars['String']>;
  space?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  withCounters?: InputMaybe<Scalars['Boolean']>;
  withUnfilteredCounters?: InputMaybe<Scalars['Boolean']>;
};


/** Document Folders */
export type DocumentsFolderSubfoldersArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  ascendantFolderId?: InputMaybe<Scalars['Int']>;
  billingSubscriptionAddonId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['Int']>;
  descendantFolderId?: InputMaybe<Scalars['Int']>;
  employee?: InputMaybe<Scalars['Boolean']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  mobileRequest?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  parentFolderId?: InputMaybe<Scalars['Int']>;
  rootFolders?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Scalars['String']>;
  space?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  withCounters?: InputMaybe<Scalars['Boolean']>;
  withUnfilteredCounters?: InputMaybe<Scalars['Boolean']>;
};


/** Document Folders */
export type DocumentsFolderSubfoldersConnectionArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  ascendantFolderId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  billingSubscriptionAddonId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['Int']>;
  descendantFolderId?: InputMaybe<Scalars['Int']>;
  employee?: InputMaybe<Scalars['Boolean']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  mobileRequest?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  parentFolderId?: InputMaybe<Scalars['Int']>;
  rootFolders?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  space?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  withCounters?: InputMaybe<Scalars['Boolean']>;
  withUnfilteredCounters?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for DocumentsFolder. */
export type DocumentsFolderConnection = {
  __typename?: 'DocumentsFolderConnection';
  /** A list of edges. */
  edges: Array<DocumentsFolderEdge>;
  /** A list of nodes. */
  nodes: Array<DocumentsFolder>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type DocumentsFolderEdge = {
  __typename?: 'DocumentsFolderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: DocumentsFolder;
};

/** the filter for the folders resource */
export type DocumentsFolderFilter = {
  name?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<DocumentsFolderFilterConditions>>;
};

export type DocumentsFolderFilterConditions = {
  name?: InputMaybe<StringFilter>;
};

export type DocumentsFolderPolicies = {
  __typename?: 'DocumentsFolderPolicies';
  editEmployeeFolderForEverybody: PermissionsPolicyResolution;
  editEmployeeFolderForOthers: PermissionsPolicyResolution;
};

export type DocumentsFolderPoliciesEnum =
  | 'edit_employee_folder_for_everybody'
  | 'edit_employee_folder_for_others';

/** Documents log */
export type DocumentsLog = {
  __typename?: 'DocumentsLog';
  createdAt: Scalars['ISO8601DateTime'];
  documentId: Scalars['Int'];
  id: Scalars['Int'];
  logType: Scalars['String'];
  payload: Scalars['String'];
};

/** The connection type for DocumentsLog. */
export type DocumentsLogConnection = {
  __typename?: 'DocumentsLogConnection';
  /** A list of edges. */
  edges: Array<DocumentsLogEdge>;
  /** A list of nodes. */
  nodes: Array<DocumentsLog>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type DocumentsLogEdge = {
  __typename?: 'DocumentsLogEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: DocumentsLog;
};

export type DocumentsSignatureStatusEnum =
  | 'bounced_email'
  | 'cancelled'
  | 'completed'
  | 'declined'
  | 'error'
  | 'expired'
  | 'partially_signed'
  | 'pending';

/** Documents template */
export type DocumentsTemplate = {
  __typename?: 'DocumentsTemplate';
  company: ApiCoreCompany;
  documentType?: Maybe<Scalars['String']>;
  extension: Scalars['String'];
  fileSize?: Maybe<Scalars['Int']>;
  filename: Scalars['String'];
  fillable: Scalars['Boolean'];
  id: Scalars['Int'];
  mimetype: Scalars['String'];
  name: Scalars['String'];
  systemTemplate: Scalars['Boolean'];
  url?: Maybe<Scalars['String']>;
  values: Array<Scalars['String']>;
};

/** The connection type for DocumentsTemplate. */
export type DocumentsTemplateConnection = {
  __typename?: 'DocumentsTemplateConnection';
  /** A list of edges. */
  edges: Array<DocumentsTemplateEdge>;
  /** A list of nodes. */
  nodes: Array<DocumentsTemplate>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type DocumentsTemplateEdge = {
  __typename?: 'DocumentsTemplateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: DocumentsTemplate;
};

/** Documents upload process */
export type DocumentsUploadProcess = {
  __typename?: 'DocumentsUploadProcess';
  active: Scalars['Boolean'];
  additionalSigners: Array<ApiCoreAccess>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  additionalSignersAccessIds?: Maybe<Array<Scalars['Int']>>;
  additionalSignersConnection: ApiCoreAccessConnection;
  combineFileName?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  currentDocumentsCount?: Maybe<Scalars['Int']>;
  distributionWorkflow?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  esignatureRequest?: Maybe<Scalars['Boolean']>;
  expectedDocumentsCount?: Maybe<Scalars['Int']>;
  filesData?: Maybe<Array<DocumentsFileData>>;
  folderId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  numberSplitPages?: Maybe<Scalars['Int']>;
  ownerId: Scalars['Int'];
  status: DocumentsUploadProcessStatusesEnum;
  updatedAt: Scalars['ISO8601DateTime'];
  uploadType: DocumentSplitUploadTypesEnum;
};


/** Documents upload process */
export type DocumentsUploadProcessAdditionalSignersArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** Documents upload process */
export type DocumentsUploadProcessAdditionalSignersConnectionArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  external?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for DocumentsUploadProcess. */
export type DocumentsUploadProcessConnection = {
  __typename?: 'DocumentsUploadProcessConnection';
  /** A list of edges. */
  edges: Array<DocumentsUploadProcessEdge>;
  /** A list of nodes. */
  nodes: Array<DocumentsUploadProcess>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** Documents upload process document */
export type DocumentsUploadProcessDocument = {
  __typename?: 'DocumentsUploadProcessDocument';
  additionalSigners: Array<ApiCoreAccess>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  additionalSignersAccessIds: Array<Scalars['Int']>;
  additionalSignersConnection: ApiCoreAccessConnection;
  createdAt: Scalars['ISO8601DateTime'];
  documentId: Scalars['Int'];
  id: Scalars['Int'];
  matchedEmployeeId?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['ISO8601DateTime'];
  uploadProcessId: Scalars['Int'];
};


/** Documents upload process document */
export type DocumentsUploadProcessDocumentAdditionalSignersArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** Documents upload process document */
export type DocumentsUploadProcessDocumentAdditionalSignersConnectionArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  external?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for DocumentsUploadProcessDocument. */
export type DocumentsUploadProcessDocumentConnection = {
  __typename?: 'DocumentsUploadProcessDocumentConnection';
  /** A list of edges. */
  edges: Array<DocumentsUploadProcessDocumentEdge>;
  /** A list of nodes. */
  nodes: Array<DocumentsUploadProcessDocument>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type DocumentsUploadProcessDocumentEdge = {
  __typename?: 'DocumentsUploadProcessDocumentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: DocumentsUploadProcessDocument;
};

/** An edge in a connection. */
export type DocumentsUploadProcessEdge = {
  __typename?: 'DocumentsUploadProcessEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: DocumentsUploadProcess;
};

/** Documents upload process file url */
export type DocumentsUploadProcessFileUrl = {
  __typename?: 'DocumentsUploadProcessFileUrl';
  fileId: Scalars['Int'];
  url: Scalars['String'];
};

/** The connection type for DocumentsUploadProcessFileUrl. */
export type DocumentsUploadProcessFileUrlConnection = {
  __typename?: 'DocumentsUploadProcessFileUrlConnection';
  /** A list of edges. */
  edges: Array<DocumentsUploadProcessFileUrlEdge>;
  /** A list of nodes. */
  nodes: Array<DocumentsUploadProcessFileUrl>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type DocumentsUploadProcessFileUrlEdge = {
  __typename?: 'DocumentsUploadProcessFileUrlEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: DocumentsUploadProcessFileUrl;
};

/** Documents upload process operation */
export type DocumentsUploadProcessOperation = {
  __typename?: 'DocumentsUploadProcessOperation';
  accessId?: Maybe<Scalars['Int']>;
  companyId: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  employee?: Maybe<EmployeesEmployee>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  employeeId?: Maybe<Scalars['Int']>;
  fileId: Scalars['Int'];
  id: Scalars['Int'];
  operationType: DocumentsUploadProcessOperationTypesEnum;
  page: Scalars['Int'];
  targetFileId?: Maybe<Scalars['Int']>;
  targetId?: Maybe<Scalars['Int']>;
  targetPage?: Maybe<Scalars['Int']>;
  targetType?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
  uploadProcessId: Scalars['Int'];
};


/** Documents upload process operation */
export type DocumentsUploadProcessOperationEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for DocumentsUploadProcessOperation. */
export type DocumentsUploadProcessOperationConnection = {
  __typename?: 'DocumentsUploadProcessOperationConnection';
  /** A list of edges. */
  edges: Array<DocumentsUploadProcessOperationEdge>;
  /** A list of nodes. */
  nodes: Array<DocumentsUploadProcessOperation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type DocumentsUploadProcessOperationEdge = {
  __typename?: 'DocumentsUploadProcessOperationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: DocumentsUploadProcessOperation;
};

export type DocumentsUploadProcessOperationTypesEnum =
  | 'discard'
  | 'employee_assignment'
  | 'merge';

export type DocumentsUploadProcessStatusesEnum =
  | 'canceled'
  | 'completed'
  | 'error'
  | 'in_distribution'
  | 'in_progress'
  | 'ready';

/** Autogenerated return type of Documents_upload_process_processed_documents_count_subscription. */
export type Documents_Upload_Process_Processed_Documents_Count_SubscriptionPayload = {
  __typename?: 'Documents_upload_process_processed_documents_count_subscriptionPayload';
  uploadProcess?: Maybe<Upload_Process_Processed_Documents_Count_Type>;
};

/** Autogenerated return type of DownloadAuditTrailEsignatureSignature. */
export type DownloadAuditTrailEsignatureSignaturePayload = {
  __typename?: 'DownloadAuditTrailEsignatureSignaturePayload';
  errors: Array<MutationError>;
  signature?: Maybe<EsignatureSignature>;
};

/** Autogenerated return type of DownloadCompensationsFile. */
export type DownloadCompensationsFilePayload = {
  __typename?: 'DownloadCompensationsFilePayload';
  errors: Array<MutationError>;
  file?: Maybe<CompensationsFile>;
};

/** Autogenerated return type of DownloadFacerecognitionEmployeePicture. */
export type DownloadFacerecognitionEmployeePicturePayload = {
  __typename?: 'DownloadFacerecognitionEmployeePicturePayload';
  employeePicture?: Maybe<FaceRecognitionEmployeePicture>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DownloadZipBillingCpDownloadZip. */
export type DownloadZipBillingCpDownloadZipPayload = {
  __typename?: 'DownloadZipBillingCpDownloadZipPayload';
  cpDownloadZips?: Maybe<Array<BillingCpDownloadZip>>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DraftPerformanceReviewEvaluationAnswer. */
export type DraftPerformanceReviewEvaluationAnswerPayload = {
  __typename?: 'DraftPerformanceReviewEvaluationAnswerPayload';
  errors: Array<MutationError>;
  reviewEvaluationAnswer?: Maybe<PerformanceReviewEvaluationAnswer>;
};

/** Autogenerated return type of DraftTemplateFormsForm. */
export type DraftTemplateFormsFormPayload = {
  __typename?: 'DraftTemplateFormsFormPayload';
  errors: Array<MutationError>;
  form?: Maybe<FormsForm>;
};

/** Autogenerated return type of DropShiftmanagementShift. */
export type DropShiftmanagementShiftPayload = {
  __typename?: 'DropShiftmanagementShiftPayload';
  errors: Array<MutationError>;
  shift?: Maybe<ShiftManagementShift>;
};

/** Autogenerated return type of DuplicateAtsJobPosting. */
export type DuplicateAtsJobPostingPayload = {
  __typename?: 'DuplicateAtsJobPostingPayload';
  errors: Array<MutationError>;
  jobPosting?: Maybe<AtsJobPosting>;
};

/** Autogenerated return type of DuplicateCompetenciesCompetency. */
export type DuplicateCompetenciesCompetencyPayload = {
  __typename?: 'DuplicateCompetenciesCompetencyPayload';
  competency?: Maybe<CompetenciesCompetency>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of DuplicateFinanceQuote. */
export type DuplicateFinanceQuotePayload = {
  __typename?: 'DuplicateFinanceQuotePayload';
  errors: Array<MutationError>;
  quote?: Maybe<FinanceQuote>;
};

/** Autogenerated return type of DuplicateFormsForm. */
export type DuplicateFormsFormPayload = {
  __typename?: 'DuplicateFormsFormPayload';
  errors: Array<MutationError>;
  forms?: Maybe<Array<FormsForm>>;
};

/** Autogenerated return type of DuplicatePerformanceReviewProcessCustomTemplate. */
export type DuplicatePerformanceReviewProcessCustomTemplatePayload = {
  __typename?: 'DuplicatePerformanceReviewProcessCustomTemplatePayload';
  errors: Array<MutationError>;
  reviewProcessCustomTemplate?: Maybe<PerformanceReviewProcessCustomTemplate>;
};

/** Autogenerated return type of DuplicatePerformanceReviewProcess. */
export type DuplicatePerformanceReviewProcessPayload = {
  __typename?: 'DuplicatePerformanceReviewProcessPayload';
  errors: Array<MutationError>;
  reviewProcess?: Maybe<PerformanceReviewProcess>;
};

/** Autogenerated return type of DuplicatePermissionsPermissionGroup. */
export type DuplicatePermissionsPermissionGroupPayload = {
  __typename?: 'DuplicatePermissionsPermissionGroupPayload';
  errors: Array<MutationError>;
  permissionGroup?: Maybe<PermissionsPermissionGroup>;
};

/** Autogenerated return type of DuplicateProcessesProcess. */
export type DuplicateProcessesProcessPayload = {
  __typename?: 'DuplicateProcessesProcessPayload';
  errors: Array<MutationError>;
  process?: Maybe<ProcessesProcess>;
};

/** Autogenerated return type of DuplicateProcessesStep. */
export type DuplicateProcessesStepPayload = {
  __typename?: 'DuplicateProcessesStepPayload';
  errors: Array<MutationError>;
  step?: Maybe<ProcessesStep>;
};

/** Autogenerated return type of DuplicateProcurementType. */
export type DuplicateProcurementTypePayload = {
  __typename?: 'DuplicateProcurementTypePayload';
  errors: Array<MutationError>;
  type?: Maybe<ProcurementType>;
};

/** Autogenerated return type of DuplicateProjectmanagementProject. */
export type DuplicateProjectmanagementProjectPayload = {
  __typename?: 'DuplicateProjectmanagementProjectPayload';
  errors: Array<MutationError>;
  project?: Maybe<ProjectManagementProject>;
};

/** Autogenerated return type of DuplicateSaleFinanceFinancialDocument. */
export type DuplicateSaleFinanceFinancialDocumentPayload = {
  __typename?: 'DuplicateSaleFinanceFinancialDocumentPayload';
  errors: Array<MutationError>;
  financialDocument?: Maybe<FinanceFinancialDocument>;
};

/** Autogenerated return type of DuplicateSurveysSurvey. */
export type DuplicateSurveysSurveyPayload = {
  __typename?: 'DuplicateSurveysSurveyPayload';
  errors: Array<MutationError>;
  survey?: Maybe<SurveysSurvey>;
};

/** Autogenerated return type of DuplicateTrainingsTrainingClass. */
export type DuplicateTrainingsTrainingClassPayload = {
  __typename?: 'DuplicateTrainingsTrainingClassPayload';
  errors: Array<MutationError>;
  trainingClass?: Maybe<TrainingsTrainingClass>;
};

/** Autogenerated return type of DuplicateTrainingsTraining. */
export type DuplicateTrainingsTrainingPayload = {
  __typename?: 'DuplicateTrainingsTrainingPayload';
  errors: Array<MutationError>;
  training?: Maybe<TrainingsTraining>;
};

/** Autogenerated return type of DuplicateWorkingconditionsGroup. */
export type DuplicateWorkingconditionsGroupPayload = {
  __typename?: 'DuplicateWorkingconditionsGroupPayload';
  errors: Array<MutationError>;
  group?: Maybe<WorkingConditionsGroup>;
};

/** Autogenerated return type of EditFinanceCostCenter. */
export type EditFinanceCostCenterPayload = {
  __typename?: 'EditFinanceCostCenterPayload';
  costCenter?: Maybe<FinanceCostCenter>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of EditFinanceCustomDimensionValue. */
export type EditFinanceCustomDimensionValuePayload = {
  __typename?: 'EditFinanceCustomDimensionValuePayload';
  customDimensionValue?: Maybe<FinanceCustomDimensionValue>;
  errors: Array<MutationError>;
};

export type EmployeeDataSchemaInput = {
  allowedValues?: InputMaybe<Array<DataDispatcherAllowedValueInput>>;
  category?: InputMaybe<Scalars['String']>;
  fieldName: Scalars['String'];
  fieldType: Scalars['String'];
  format?: InputMaybe<Scalars['String']>;
  group?: InputMaybe<Scalars['String']>;
  hidden: Scalars['Boolean'];
  label: Scalars['String'];
  metadata?: InputMaybe<Array<DataDispatcherMetadataInput>>;
  position?: InputMaybe<Scalars['Int']>;
  required: Scalars['Boolean'];
  schemaMapper: Scalars['String'];
  section?: InputMaybe<Scalars['String']>;
  transformations?: InputMaybe<Array<Scalars['String']>>;
};

export type EmployeeOnboardingContextlessPolicies = {
  __typename?: 'EmployeeOnboardingContextlessPolicies';
  sidebarSeeEmployeeOnboardingTopLevelItem: ContextlessPolicyResolution;
};

/** Employee Onboarding */
export type EmployeeOnboardingEmployeeOnboarding = {
  __typename?: 'EmployeeOnboardingEmployeeOnboarding';
  employeeId: Scalars['Int'];
  id: Scalars['Int'];
  materializedProcess?: Maybe<ProcessesMaterializedProcess>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  materializedProcessId: Scalars['Int'];
};


/** Employee Onboarding */
export type EmployeeOnboardingEmployeeOnboardingMaterializedProcessArgs = {
  includeItemsCount?: InputMaybe<Scalars['Boolean']>;
  itemResources?: InputMaybe<Scalars['String']>;
  materializedTasksAccessId?: InputMaybe<Scalars['Int']>;
  processId?: InputMaybe<Scalars['Int']>;
  processIds?: InputMaybe<Array<Scalars['Int']>>;
  resources?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  withPendingMandatoryTasks?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for EmployeeOnboardingEmployeeOnboarding. */
export type EmployeeOnboardingEmployeeOnboardingConnection = {
  __typename?: 'EmployeeOnboardingEmployeeOnboardingConnection';
  /** A list of edges. */
  edges: Array<EmployeeOnboardingEmployeeOnboardingEdge>;
  /** A list of nodes. */
  nodes: Array<EmployeeOnboardingEmployeeOnboarding>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type EmployeeOnboardingEmployeeOnboardingEdge = {
  __typename?: 'EmployeeOnboardingEmployeeOnboardingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: EmployeeOnboardingEmployeeOnboarding;
};

export type EmployeeSortDirectionEnum =
  | 'asc'
  | 'desc';

export type EmployeeSortOptionsEnum =
  | 'first_name'
  | 'job'
  | 'last_name'
  | 'seniority';

/** Employee update absences */
export type EmployeeUpdatesAbsence = {
  __typename?: 'EmployeeUpdatesAbsence';
  /** Indicates if the absence is approved */
  approved?: Maybe<Scalars['Boolean']>;
  /** A description of the absence */
  description?: Maybe<Scalars['String']>;
  /** Full name of the employee */
  employeeFullName?: Maybe<Scalars['String']>;
  /** Employee id of the absence */
  employeeId?: Maybe<Scalars['Int']>;
  /** The end date of the absence */
  finishOn?: Maybe<Scalars['ISO8601Date']>;
  /** Indicates if the absence is taken as a half-day */
  halfDay?: Maybe<Scalars['String']>;
  /** The total number of hours taken for the absence, represented in cents */
  hoursAmountInCents?: Maybe<Scalars['Int']>;
  /** Identifier of the absence employee update */
  id: Scalars['Int'];
  /** The id of the leave type */
  leaveTypeId?: Maybe<Scalars['Int']>;
  /** The name of the leave type */
  leaveTypeName?: Maybe<Scalars['String']>;
  /** The previous end date of the absence */
  prevFinishOn?: Maybe<Scalars['ISO8601Date']>;
  /** The previous start date of the absence */
  prevStartOn?: Maybe<Scalars['ISO8601Date']>;
  /** The start date of the absence */
  startOn?: Maybe<Scalars['ISO8601Date']>;
  /** The status of the employee update. */
  status: Scalars['String'];
};

/** The connection type for EmployeeUpdatesAbsence. */
export type EmployeeUpdatesAbsenceConnection = {
  __typename?: 'EmployeeUpdatesAbsenceConnection';
  /** A list of edges. */
  edges: Array<EmployeeUpdatesAbsenceEdge>;
  /** A list of nodes. */
  nodes: Array<EmployeeUpdatesAbsence>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type EmployeeUpdatesAbsenceEdge = {
  __typename?: 'EmployeeUpdatesAbsenceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: EmployeeUpdatesAbsence;
};

/** Employee update in contract changes */
export type EmployeeUpdatesContractChange = {
  __typename?: 'EmployeeUpdatesContractChange';
  compensationIds?: Maybe<Array<Scalars['Int']>>;
  /** The country on the contract change */
  country?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  /** The contract type id on the contract change */
  deContractTypeId?: Maybe<Scalars['Int']>;
  /** The contract type name on the contract change */
  deContractTypeName?: Maybe<Scalars['String']>;
  /** The effective date of the contract */
  effectiveOn: Scalars['ISO8601Date'];
  /** The employee id */
  employeeId: Scalars['Int'];
  /** The end date of the contract */
  endsOn?: Maybe<Scalars['ISO8601Date']>;
  /** The contract observations on the contract change */
  esContractObservations?: Maybe<Scalars['String']>;
  /** The contract type id on the contract change */
  esContractTypeId?: Maybe<Scalars['Int']>;
  /** The contract type name on the contract change */
  esContractTypeName?: Maybe<Scalars['String']>;
  /** The cotization group on the contract change */
  esCotizationGroup?: Maybe<Scalars['Int']>;
  /** The education level id on the contract change */
  esEducationLevelId?: Maybe<Scalars['Int']>;
  /** The teleworking status on the contract change */
  esHasTeleworkingContract?: Maybe<Scalars['Boolean']>;
  /** The job description on the contract change */
  esJobDescription?: Maybe<Scalars['String']>;
  /** The professional category id on the contract change */
  esProfessionalCategoryId?: Maybe<Scalars['Int']>;
  /** The trial period end date on the contract change */
  esTrialPeriodEndsOn?: Maybe<Scalars['ISO8601Date']>;
  /** The working day type id on the contract change */
  esWorkingDayTypeId?: Maybe<Scalars['Int']>;
  /** The coefficient on the contract change */
  frCoefficient?: Maybe<Scalars['String']>;
  /** The contract type id on the contract change */
  frContractTypeId?: Maybe<Scalars['Int']>;
  /** The contract type name on the contract change */
  frContractTypeName?: Maybe<Scalars['String']>;
  /** The employee type on the contract change */
  frEmployeeType?: Maybe<Scalars['String']>;
  /** The forfait jours status on the contract change */
  frForfaitJours: Scalars['Boolean'];
  /** The jours par an on the contract change */
  frJoursParAn?: Maybe<Scalars['Int']>;
  /** The level id on the contract change */
  frLevelId?: Maybe<Scalars['Int']>;
  /** The level name on the contract change */
  frLevelName?: Maybe<Scalars['String']>;
  /** The mutual id on the contract change */
  frMutualId?: Maybe<Scalars['Int']>;
  /** The mutual name on the contract change */
  frMutualName?: Maybe<Scalars['String']>;
  /** The professional category id on the contract change */
  frProfessionalCategoryId?: Maybe<Scalars['Int']>;
  /** The professional category name on the contract change */
  frProfessionalCategoryName?: Maybe<Scalars['String']>;
  /** The step id on the contract change */
  frStepId?: Maybe<Scalars['Int']>;
  /** The step name on the contract change */
  frStepName?: Maybe<Scalars['String']>;
  /** The work type id on the contract change */
  frWorkTypeId?: Maybe<Scalars['Int']>;
  /** The work type name on the contract change */
  frWorkTypeName?: Maybe<Scalars['String']>;
  /** The payrollable status of the employee on the contract change */
  hasPayroll: Scalars['Boolean'];
  /** The id of the contract change incidence */
  id: Scalars['Int'];
  /** The job level on the contract change */
  jobLevel?: Maybe<Scalars['String']>;
  /** The job role on the contract change */
  jobRole?: Maybe<Scalars['String']>;
  /** The job title on the contract change */
  jobTitle?: Maybe<Scalars['String']>;
  /** The contract type id on the contract change */
  ptContractTypeId?: Maybe<Scalars['Int']>;
  /** The contract type name on the contract change */
  ptContractTypeName?: Maybe<Scalars['String']>;
  /** The salary amount on the contract change in cents. */
  salaryAmount?: Maybe<Scalars['Int']>;
  /** The salary payment frequency on the contract change */
  salaryFrequency?: Maybe<Scalars['String']>;
  /** The start date of the contract */
  startsOn?: Maybe<Scalars['ISO8601Date']>;
  /** The status of the contract change incidence */
  status: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
  /** The working hours on the contract change */
  workingHours?: Maybe<Scalars['Int']>;
  /** The working hours frequency on the contract change */
  workingHoursFrequency?: Maybe<Scalars['String']>;
  /** The working week days on the contract change */
  workingWeekDays?: Maybe<Scalars['String']>;
};

/** The connection type for EmployeeUpdatesContractChange. */
export type EmployeeUpdatesContractChangeConnection = {
  __typename?: 'EmployeeUpdatesContractChangeConnection';
  /** A list of edges. */
  edges: Array<EmployeeUpdatesContractChangeEdge>;
  /** A list of nodes. */
  nodes: Array<EmployeeUpdatesContractChange>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type EmployeeUpdatesContractChangeEdge = {
  __typename?: 'EmployeeUpdatesContractChangeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: EmployeeUpdatesContractChange;
};

/** Employee update for hirings */
export type EmployeeUpdatesNewHire = {
  __typename?: 'EmployeeUpdatesNewHire';
  /** address of the employee. */
  address: Scalars['String'];
  /** bank account number of the employee. */
  bankAccount?: Maybe<Scalars['String']>;
  /** The birth name of the new hire */
  birthName?: Maybe<Scalars['String']>;
  /** city of the employee. */
  city?: Maybe<Scalars['String']>;
  contractEffectiveDate?: Maybe<Scalars['ISO8601Date']>;
  contractEndDate?: Maybe<Scalars['ISO8601Date']>;
  /** country code of the employee (Spain ES, United Kingdom GB). */
  country?: Maybe<Scalars['String']>;
  /** birthday of the employee. */
  dateOfBirth?: Maybe<Scalars['ISO8601Date']>;
  /** The employee id of the new hire */
  employeeId: Scalars['Int'];
  /** name of the employee. */
  firstName: Scalars['String'];
  /** gender of the employee (male | female). */
  gender?: Maybe<Scalars['String']>;
  /** The id of the new hire incidence */
  id: Scalars['Int'];
  /** national identifier number. */
  identifier?: Maybe<Scalars['String']>;
  /** type of identifier (ex passport). */
  identifierType?: Maybe<Scalars['String']>;
  /** job title of the employee. */
  jobTitle?: Maybe<Scalars['String']>;
  /** last name of the employee. */
  lastName: Scalars['String'];
  /** The legal entity id of the new hire */
  legalEntityId?: Maybe<Scalars['Int']>;
  /** manager id of the employee, you can get the manager id from employees endpoint. */
  managerId?: Maybe<Scalars['Int']>;
  /** nationality country code of the employee (Spain ES, United Kingdom GB). */
  nationality?: Maybe<Scalars['String']>;
  /** payroll identifier. */
  payrollIdentifier?: Maybe<Scalars['String']>;
  /** phone number of the employee. */
  phoneNumber?: Maybe<Scalars['String']>;
  /** postal code of the employee. */
  postalCode?: Maybe<Scalars['String']>;
  /** salary amount in cents. */
  salaryAmountInCents?: Maybe<Scalars['Int']>;
  salaryFrequency?: Maybe<Scalars['String']>;
  /** social security number of the employee. */
  socialSecurityNumber?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['ISO8601Date']>;
  /** state/province/region of the employee. */
  state?: Maybe<Scalars['String']>;
  /** The status of the new hire incidence */
  status: Scalars['String'];
  taxId?: Maybe<Scalars['String']>;
  /** personal email of the employee. */
  workEmail?: Maybe<Scalars['String']>;
  workingHours?: Maybe<Scalars['Int']>;
  workingHoursFrequency?: Maybe<Scalars['String']>;
  /** workplace id of the employee. */
  workplaceId?: Maybe<Scalars['Int']>;
};

/** The connection type for EmployeeUpdatesNewHire. */
export type EmployeeUpdatesNewHireConnection = {
  __typename?: 'EmployeeUpdatesNewHireConnection';
  /** A list of edges. */
  edges: Array<EmployeeUpdatesNewHireEdge>;
  /** A list of nodes. */
  nodes: Array<EmployeeUpdatesNewHire>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type EmployeeUpdatesNewHireEdge = {
  __typename?: 'EmployeeUpdatesNewHireEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: EmployeeUpdatesNewHire;
};

/** Employee update summaries */
export type EmployeeUpdatesPersonalChange = {
  __typename?: 'EmployeeUpdatesPersonalChange';
  /** address line 1 of the employee. */
  addressLine1?: Maybe<Scalars['String']>;
  /** address line 1 of the employee. */
  addressLine2?: Maybe<Scalars['String']>;
  /** bank account number of the employee. */
  bankNumber?: Maybe<Scalars['String']>;
  /** city of the employee. */
  city?: Maybe<Scalars['String']>;
  /** country code of the employee (Spain ES, United Kingdom GB). */
  country?: Maybe<Scalars['String']>;
  /** birthday of the employee. */
  dateOfBirth?: Maybe<Scalars['ISO8601Date']>;
  /** The employee id of the new hire */
  employeeId: Scalars['Int'];
  /** name of the employee. */
  firstName: Scalars['String'];
  /** gender of the employee (male | female). */
  gender?: Maybe<Scalars['String']>;
  /** The id of the new hire incidence */
  id: Scalars['Int'];
  /** national identifier number. */
  identifier?: Maybe<Scalars['String']>;
  /** type of identifier (ex passport). */
  identifierType?: Maybe<Scalars['String']>;
  /** job title of the employee. */
  jobTitle?: Maybe<Scalars['String']>;
  /** last name of the employee. */
  lastName: Scalars['String'];
  /** nationality country code of the employee (Spain ES, United Kingdom GB). */
  nationality?: Maybe<Scalars['String']>;
  /** phone number of the employee. */
  phoneNumber?: Maybe<Scalars['String']>;
  /** postal code of the employee. */
  postalCode?: Maybe<Scalars['String']>;
  /** social security number of the employee. */
  socialSecurityNumber?: Maybe<Scalars['String']>;
  /** state/province/region of the employee. */
  state?: Maybe<Scalars['String']>;
  /** The status of the new hire incidence */
  status: Scalars['String'];
  taxId?: Maybe<Scalars['String']>;
  /** personal email of the employee. */
  workEmail?: Maybe<Scalars['String']>;
  /** workplace id of the employee. */
  workplaceId?: Maybe<Scalars['Int']>;
};

/** The connection type for EmployeeUpdatesPersonalChange. */
export type EmployeeUpdatesPersonalChangeConnection = {
  __typename?: 'EmployeeUpdatesPersonalChangeConnection';
  /** A list of edges. */
  edges: Array<EmployeeUpdatesPersonalChangeEdge>;
  /** A list of nodes. */
  nodes: Array<EmployeeUpdatesPersonalChange>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type EmployeeUpdatesPersonalChangeEdge = {
  __typename?: 'EmployeeUpdatesPersonalChangeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: EmployeeUpdatesPersonalChange;
};

/** Employee update summaries */
export type EmployeeUpdatesSummary = {
  __typename?: 'EmployeeUpdatesSummary';
  createdAt: Scalars['String'];
  employeeId?: Maybe<Scalars['Int']>;
  endsOn?: Maybe<Scalars['ISO8601Date']>;
  id: Scalars['Int'];
  legalEntityId: Scalars['Int'];
  startsOn?: Maybe<Scalars['ISO8601Date']>;
  status: Scalars['String'];
  type: Scalars['String'];
};

/** The connection type for EmployeeUpdatesSummary. */
export type EmployeeUpdatesSummaryConnection = {
  __typename?: 'EmployeeUpdatesSummaryConnection';
  /** A list of edges. */
  edges: Array<EmployeeUpdatesSummaryEdge>;
  /** A list of nodes. */
  nodes: Array<EmployeeUpdatesSummary>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type EmployeeUpdatesSummaryEdge = {
  __typename?: 'EmployeeUpdatesSummaryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: EmployeeUpdatesSummary;
};

/** the filter for the summaries resource */
export type EmployeeUpdatesSummaryFilter = {
  id?: InputMaybe<IntegerFilter>;
  or?: InputMaybe<Array<EmployeeUpdatesSummaryFilterConditions>>;
};

export type EmployeeUpdatesSummaryFilterConditions = {
  id?: InputMaybe<IntegerFilter>;
};

/** Employee update terminations */
export type EmployeeUpdatesTermination = {
  __typename?: 'EmployeeUpdatesTermination';
  employeeId: Scalars['Int'];
  id: Scalars['Int'];
  legalEntityId?: Maybe<Scalars['Int']>;
  status: Scalars['String'];
  terminatedOn?: Maybe<Scalars['ISO8601Date']>;
  terminationObservations?: Maybe<Scalars['String']>;
  terminationReason?: Maybe<Scalars['String']>;
  terminationReasonType?: Maybe<Scalars['String']>;
  /** The description of the termination type. */
  terminationTypeDescription?: Maybe<Scalars['String']>;
};

/** The connection type for EmployeeUpdatesTermination. */
export type EmployeeUpdatesTerminationConnection = {
  __typename?: 'EmployeeUpdatesTerminationConnection';
  /** A list of edges. */
  edges: Array<EmployeeUpdatesTerminationEdge>;
  /** A list of nodes. */
  nodes: Array<EmployeeUpdatesTermination>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type EmployeeUpdatesTerminationEdge = {
  __typename?: 'EmployeeUpdatesTerminationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: EmployeeUpdatesTermination;
};

/** Insight in order to get headcount by employees's age */
export type EmployeesAgeHeadcount = {
  __typename?: 'EmployeesAgeHeadcount';
  age: Scalars['Int'];
  count: Scalars['Int'];
};

/** The connection type for EmployeesAgeHeadcount. */
export type EmployeesAgeHeadcountConnection = {
  __typename?: 'EmployeesAgeHeadcountConnection';
  /** A list of edges. */
  edges: Array<EmployeesAgeHeadcountEdge>;
  /** A list of nodes. */
  nodes: Array<EmployeesAgeHeadcount>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type EmployeesAgeHeadcountEdge = {
  __typename?: 'EmployeesAgeHeadcountEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: EmployeesAgeHeadcount;
};

/** Autogenerated return type of EmployeesByMonthTeamsHistoricalTeam. */
export type EmployeesByMonthTeamsHistoricalTeamPayload = {
  __typename?: 'EmployeesByMonthTeamsHistoricalTeamPayload';
  errors: Array<MutationError>;
  historicalTeam?: Maybe<TeamsHistoricalTeam>;
};

export type EmployeesContextlessPolicies = {
  __typename?: 'EmployeesContextlessPolicies';
  addCustomTableRecords: ContextlessPolicyResolution;
  assignEmployeeManager: ContextlessPolicyResolution;
  assignEmployeePermissionGroup: ContextlessPolicyResolution;
  assignEmployeeToWorkflow: ContextlessPolicyResolution;
  editEmployeesInBulkButton: ContextlessPolicyResolution;
  employeeSeeAggregatedPersonalInfo: ContextlessPolicyResolution;
  exportEmployees: ContextlessPolicyResolution;
  exportOrgChart: ContextlessPolicyResolution;
  inviteEmployee: ContextlessPolicyResolution;
  manageCustomTableSettings: ContextlessPolicyResolution;
  removeCustomTableRecords: ContextlessPolicyResolution;
  seeAdminWelcomeSpace: ContextlessPolicyResolution;
  seeEmployeeLegalGender: ContextlessPolicyResolution;
  seeFormerEmployees: ContextlessPolicyResolution;
  seeFutureEmployees: ContextlessPolicyResolution;
  sidebarSeeEmployeesOrgChartSubLevelItem: ContextlessPolicyResolution;
  sidebarSeeEmployeesTopLevelItem: ContextlessPolicyResolution;
  sidebarSeeProfileContractVersionsSubLevelItem: ContextlessPolicyResolution;
  sidebarSeeProfileCustomTablesSubLevelItem: ContextlessPolicyResolution;
  sidebarSeeProfilePersonalSubLevelItem: ContextlessPolicyResolution;
  sidebarSeeProfilePlanningVersionsSubLevelItem: ContextlessPolicyResolution;
  sidebarSeeProfileTopLevelItem: ContextlessPolicyResolution;
};

/** Employee */
export type EmployeesEmployee = {
  __typename?: 'EmployeesEmployee';
  _policies?: Maybe<EmployeesEmployeePolicies>;
  _policiesCollection?: Maybe<Array<PermissionsPolicyResolution>>;
  _policiesConnection: PermissionsPolicyResolutionConnection;
  access: ApiCoreAccess;
  /**
   * access_id associated to the employee.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  accessId: Scalars['Int'];
  /** status of the employee, true when active, false when terminated. */
  active?: Maybe<Scalars['Boolean']>;
  /** address of the employee. */
  addressLine1?: Maybe<Scalars['String']>;
  /** secondary address of the employee. */
  addressLine2?: Maybe<Scalars['String']>;
  /**
   * Employment affiliation type indicating relationship to company (employee,
   * contractor, consultant, etc.). Enum value from Access::Affiliation.
   */
  affiliation?: Maybe<AccessAffiliationEnum>;
  /** age of the employee. */
  ageNumber?: Maybe<Scalars['Int']>;
  allowanceStats: Array<TimeoffAllowanceStat>;
  allowanceStatsConnection: TimeoffAllowanceStatConnection;
  /** employee included in a time tracking policy. */
  attendable: Scalars['Boolean'];
  /**
   * Attendance tracking policy ID assigned to this employee. Note: This field
   * belongs to attendance module and should be moved. References
   * attendance.employees_policy.
   */
  attendanceEmployeesPolicyId?: Maybe<Scalars['Int']>;
  authenticationAccess?: Maybe<AuthenticationAccess>;
  avatar?: Maybe<ApiCoreAttachment>;
  /** ID of the employee's profile avatar image. References uploaded file for profile picture. Null if no custom avatar set. */
  avatarId?: Maybe<Scalars['Int']>;
  /** bank account number of the employee. */
  bankNumber?: Maybe<Scalars['String']>;
  /** bank number format. */
  bankNumberFormat?: Maybe<BankingEntitiesBankAccountNumberFormatEnum>;
  bankingCardholder?: Maybe<BankingCardholder>;
  /** Birthname of the employee. */
  birthName?: Maybe<Scalars['String']>;
  /** birthday of the employee. */
  birthdayOn?: Maybe<Scalars['ISO8601Date']>;
  /** Birthplace of the employee. */
  birthplace?: Maybe<Scalars['String']>;
  /** city of the employee. */
  city?: Maybe<Scalars['String']>;
  /**
   * Confirmed email address for company communications and notifications. Separate
   * from login email, used for internal company announcements.
   */
  communicationsEmail?: Maybe<Scalars['String']>;
  company: ApiCoreCompany;
  /**
   * id of the company to which the employee belongs (not editable).
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  companyId: Scalars['Int'];
  /** identity number or string used inside a company to internally identify the employee. */
  companyIdentifier?: Maybe<Scalars['String']>;
  /** name of the employee contact. */
  contactName?: Maybe<Scalars['String']>;
  /** phone number of the employee contact . */
  contactNumber?: Maybe<Scalars['String']>;
  contractVersions: Array<ContractsContractVersion>;
  contractversionsConnection: ContractsContractVersionConnection;
  costCenterAssignments: Array<CostCentersAssignment>;
  costcenterassignmentsConnection: CostCentersAssignmentConnection;
  /** country code of the employee (Spain ES, United Kingdom GB). */
  country?: Maybe<Scalars['String']>;
  /** Country of birth of the employee. */
  countryOfBirth?: Maybe<Scalars['String']>;
  /** creation date of the employee. */
  createdAt: Scalars['ISO8601DateTime'];
  defaultLocation?: Maybe<LocationsLocation>;
  /**
   * officially certified level of disability granted by public administration for
   * individuals with physical or mental impairments, expressed in cents
   */
  disabilityPercentageCents?: Maybe<Scalars['Int']>;
  /**
   * Employee's preference for appearing in company directory and people search
   * features. When false, employee opts out of discovery features.
   */
  discoverabilityWidgetValue?: Maybe<Scalars['Boolean']>;
  /** personal email of the employee. */
  email?: Maybe<Scalars['String']>;
  employeeGroup?: Maybe<EmployeesEmployeeGroup>;
  /**
   * Employee group classification ID for organizational segmentation. Used for
   * custom grouping, reporting, and policy assignment.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  employeeGroupId?: Maybe<Scalars['Int']>;
  employeeName?: Maybe<EmployeesEmployeeName>;
  /**
   * Array of all location IDs the employee is assigned to (not just default
   * location). References locations/locations endpoint.
   */
  employeesLocationIds?: Maybe<Array<Scalars['Int']>>;
  /**
   * Alternative Spanish IRPF field in cents. Spain-specific income tax retention.
   * Note: System has duplicate IRPF fields; consolidation planned.
   */
  esIrpfCents?: Maybe<Scalars['Int']>;
  faceRecognitionEmployeesPictures: Array<FaceRecognitionEmployeePicture>;
  faceRecognitionEmployeesPicturesConnection: FaceRecognitionEmployeePictureConnection;
  financeCostCenterMemberships: Array<FinanceCostCenterMembership>;
  financeCustomDimensionMemberships: Array<FinanceCustomDimensionMembership>;
  financecostcentermembershipsConnection: FinanceCostCenterMembershipConnection;
  financecustomdimensionmembershipsConnection: FinanceCustomDimensionMembershipConnection;
  /** name of the employee. */
  firstName: Scalars['String'];
  folders: Array<DocumentsEmployeeFolder>;
  foldersConnection: DocumentsEmployeeFolderConnection;
  /** full name of the employee. */
  fullName: Scalars['String'];
  /** gender of the employee (male | female). */
  gender?: Maybe<Scalars['String']>;
  goalsEmployee?: Maybe<GoalsEmployee>;
  /**
   * Whether the employee has graduated from restricted/onboarding access to
   * regular platform access. True when all access restrictions are lifted.
   */
  hasRegularAccess: Scalars['Boolean'];
  /**
   * Whether the employee has a valid work permit (for foreign workers). Critical
   * for legal compliance and employment eligibility verification.
   */
  hasWorkPermit?: Maybe<Scalars['Boolean']>;
  /** id of the employee. */
  id: Scalars['Int'];
  /** national identifier number. */
  identifier?: Maybe<Scalars['String']>;
  /** identifier expiration date */
  identifierExpirationDate?: Maybe<Scalars['ISO8601Date']>;
  /** type of identifier (ex passport). */
  identifierType?: Maybe<Scalars['String']>;
  /**
   * Spanish income tax retention percentage in cents (IRPF - Impuesto sobre la
   * Renta de las Personas Físicas). For 15% retention, value is 1500.
   * Spain-specific field.
   */
  irpfCents?: Maybe<Scalars['Int']>;
  /** is the employee being terminated? */
  isTerminating: Scalars['Boolean'];
  /**
   * Whether the employee has completed platform onboarding and joined the system.
   * False for invited but unconfirmed employees. True once account is activated.
   */
  joined?: Maybe<Scalars['Boolean']>;
  /** last name of the employee. */
  lastName: Scalars['String'];
  leaves: Array<TimeoffLeave>;
  leavesConnection: TimeoffLeaveConnection;
  legalEntity?: Maybe<CompaniesLegalEntity>;
  /**
   * legal entity of the employee, references to companies/legal_entities.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  legalEntityId?: Maybe<Scalars['Int']>;
  /**
   * location id of the employee, references to locations/locations.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  locationId: Scalars['Int'];
  /**
   * Denormalized/cached name of the employee's default location. Improves
   * performance by avoiding additional lookups. May be slightly stale.
   */
  locationName?: Maybe<Scalars['String']>;
  locations: Array<LocationsEmployeesLocation>;
  locationsConnection: LocationsEmployeesLocationConnection;
  /** email associated to the session. */
  loginEmail?: Maybe<Scalars['String']>;
  manager?: Maybe<EmployeesEmployee>;
  /**
   * manager id of the employee, you can get the manager id from employees endpoint.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  managerId?: Maybe<Scalars['Int']>;
  memberships: Array<TeamsMembership>;
  membershipsConnection: TeamsMembershipConnection;
  /** nationality country code of the employee (Spain ES, United Kingdom GB). */
  nationality?: Maybe<Scalars['String']>;
  payrollPolicyEmployee?: Maybe<ContractsPayrollPolicyEmployee>;
  /** whether the employee is eligible for payroll processing. */
  payrollable: Scalars['Boolean'];
  /** personal email of the employee. */
  personalEmail?: Maybe<Scalars['String']>;
  /**
   * International dialing code for the employee's phone number (e.g., '+34' for
   * Spain, '+44' for UK). Used for proper phone number formatting.
   */
  phoneCode?: Maybe<Scalars['String']>;
  /** phone number of the employee. */
  phoneNumber?: Maybe<Scalars['String']>;
  /** postal code of the employee. */
  postalCode?: Maybe<Scalars['String']>;
  /** nickname of the employee or a name that defines the employee better. */
  preferredName?: Maybe<Scalars['String']>;
  /** pronouns that an employee uses to define themselves. */
  pronouns?: Maybe<Scalars['String']>;
  referenceContract?: Maybe<ContractsReferenceContract>;
  /** hiring date of the employee (start date of reference contract) */
  referenceContractStartsOn: Scalars['ISO8601Date'];
  /**
   * Date when employee's regular platform access begins (transitions from
   * restricted/onboarding access). ISO 8601 date format. Null if no restriction.
   */
  regularAccessStartsOn: Scalars['ISO8601Date'];
  reports: Array<EmployeesEmployee>;
  reportsConnection: EmployeesEmployeeConnection;
  /** date since when the employee is working in the company. */
  seniorityCalculationDate?: Maybe<Scalars['ISO8601Date']>;
  /** whether the employee wants to share their birthday. */
  shareBirthday?: Maybe<Scalars['Boolean']>;
  /** social security number of the employee. */
  socialSecurityNumber?: Maybe<Scalars['String']>;
  /** state/province/region of the employee. */
  state?: Maybe<Scalars['String']>;
  /**
   * Whether the current user is the direct manager of this employee. Used for
   * permission checks and manager dashboards. Contextual to current user.
   */
  supervisedByCurrent?: Maybe<Scalars['Boolean']>;
  supplements: Array<PayrollSupplement>;
  supplementsConnection: PayrollSupplementConnection;
  /** code to identify banks and financial institutions globally. */
  swiftBic?: Maybe<Scalars['String']>;
  /**
   * Tax identification number for the employee in their jurisdiction. Used for tax
   * reporting and payroll compliance. Format varies by country.
   */
  taxId?: Maybe<Scalars['String']>;
  taxResidence?: Maybe<HiringVersionsTaxResidence>;
  /** Array of team IDs the employee is a member of. Represents all team memberships. References teams/team endpoint. */
  teamIds?: Maybe<Array<Scalars['Int']>>;
  /** termination date of the employee. */
  terminatedOn?: Maybe<Scalars['ISO8601Date']>;
  /** observations about the termination. */
  terminationObservations?: Maybe<Scalars['String']>;
  /** A reason for the termination. */
  terminationReason?: Maybe<Scalars['String']>;
  /** termination reason type of the employee */
  terminationReasonType?: Maybe<Scalars['String']>;
  terminationType?: Maybe<ContractsTerminationType>;
  /** The description of the termination type. */
  terminationTypeDescription?: Maybe<Scalars['String']>;
  /**
   * Termination type category ID from predefined classification list. Provides
   * structured termination categorization for reporting and analytics.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  terminationTypeId?: Maybe<Scalars['Int']>;
  timeoffAllowanceIncidences: Array<TimeoffAllowanceIncidence>;
  timeoffManager?: Maybe<EmployeesEmployee>;
  /**
   * Timeoff manager id of the employee.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  timeoffManagerId?: Maybe<Scalars['Int']>;
  timeoffPolicy?: Maybe<TimeoffPolicy>;
  timeoffPolicyAssignments: Array<TimeoffPolicyAssignment>;
  /**
   * Time-off policy ID assigned to this employee. Determines vacation accrual, PTO
   * rules, and leave entitlements. References timeoff.policy.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  timeoffPolicyId?: Maybe<Scalars['Int']>;
  /**
   * Whether the current user is the time-off manager for this employee. Used for
   * permission checks and UI filtering. Contextual to current user.
   */
  timeoffSupervisedByCurrent?: Maybe<Scalars['Boolean']>;
  timeoffallowanceincidencesConnection: TimeoffAllowanceIncidenceConnection;
  timeoffpolicyassignmentsConnection: TimeoffPolicyAssignmentConnection;
  /** unconfirmed communications email address for the employee. */
  unconfirmedCommunicationsEmail?: Maybe<Scalars['String']>;
  /**
   * New email address pending confirmation. When employee requests email change,
   * new email stored here until verified. Null if no pending change.
   */
  unconfirmedEmail?: Maybe<Scalars['String']>;
  upcomingLeaves: Array<TimeoffUpcomingLeave>;
  upcomingLeavesConnection: TimeoffUpcomingLeaveConnection;
  upcomingTeamLeaves: Array<TimeoffUpcomingLeave>;
  upcomingTeamLeavesConnection: TimeoffUpcomingLeaveConnection;
  /** date of last modification of the employee */
  updatedAt: Scalars['ISO8601DateTime'];
  values: Array<CustomFieldsValue>;
  valuesConnection: CustomFieldsValueConnection;
  yearlyTimeInfo: Array<AttendanceYearlyTimeInfo>;
  yearlytimeinfoConnection: AttendanceYearlyTimeInfoConnection;
};


/** Employee */
export type EmployeesEmployee_PoliciesCollectionArgs = {
  ids: Array<EmployeesEmployeePoliciesEnum>;
};


/** Employee */
export type EmployeesEmployee_PoliciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Employee */
export type EmployeesEmployeeAccessArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** Employee */
export type EmployeesEmployeeAllowanceStatsArgs = {
  allowanceIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  referenceDate?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Employee */
export type EmployeesEmployeeAllowanceStatsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  allowanceIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  referenceDate?: InputMaybe<Scalars['ISO8601Date']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Employee */
export type EmployeesEmployeeAuthenticationAccessArgs = {
  includeMfaStatus?: Scalars['Boolean'];
};


/** Employee */
export type EmployeesEmployeeAvatarArgs = {
  attachmentName?: InputMaybe<Scalars['String']>;
};


/** Employee */
export type EmployeesEmployeeBankingCardholderArgs = {
  bankAccountIds?: InputMaybe<Array<Scalars['Int']>>;
  creationSource?: InputMaybe<BankingValueObjectsCardCreationSourceEnum>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Employee */
export type EmployeesEmployeeContractVersionsArgs = {
  activeOn?: InputMaybe<Scalars['ISO8601Date']>;
  activeOrUpcomingOn?: InputMaybe<Scalars['ISO8601Date']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  contractIds?: InputMaybe<Array<Scalars['Int']>>;
  date?: InputMaybe<Scalars['ISO8601Date']>;
  effectiveOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  effectiveOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  endsOnGt?: InputMaybe<Scalars['ISO8601Date']>;
  endsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  endsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  esEducationLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  forfaitJours?: Scalars['Boolean'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeDenormalizedData?: Scalars['Boolean'];
  jobCatalogTreeNodeUuids?: InputMaybe<Array<Scalars['String']>>;
  levelIds?: InputMaybe<Array<Scalars['Int']>>;
  startsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  startsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  upcomingOn?: InputMaybe<Scalars['ISO8601Date']>;
  withFallback?: Scalars['Boolean'];
  withHasPayrollPolicies?: InputMaybe<Scalars['Boolean']>;
  withMetadata?: Scalars['Boolean'];
  withOldestEffectiveOn?: InputMaybe<Scalars['Boolean']>;
  withPayroll?: InputMaybe<Scalars['Boolean']>;
  withSalaryAmount?: InputMaybe<Scalars['Boolean']>;
  withoutSalaryAmountOrSalaryFrequency?: InputMaybe<Scalars['Boolean']>;
};


/** Employee */
export type EmployeesEmployeeContractversionsConnectionArgs = {
  activeOn?: InputMaybe<Scalars['ISO8601Date']>;
  activeOrUpcomingOn?: InputMaybe<Scalars['ISO8601Date']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  contractIds?: InputMaybe<Array<Scalars['Int']>>;
  date?: InputMaybe<Scalars['ISO8601Date']>;
  effectiveOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  effectiveOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  endsOnGt?: InputMaybe<Scalars['ISO8601Date']>;
  endsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  endsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  esEducationLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  forfaitJours?: Scalars['Boolean'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeDenormalizedData?: Scalars['Boolean'];
  jobCatalogTreeNodeUuids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  levelIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  startsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  upcomingOn?: InputMaybe<Scalars['ISO8601Date']>;
  withFallback?: Scalars['Boolean'];
  withHasPayrollPolicies?: InputMaybe<Scalars['Boolean']>;
  withMetadata?: Scalars['Boolean'];
  withOldestEffectiveOn?: InputMaybe<Scalars['Boolean']>;
  withPayroll?: InputMaybe<Scalars['Boolean']>;
  withSalaryAmount?: InputMaybe<Scalars['Boolean']>;
  withoutSalaryAmountOrSalaryFrequency?: InputMaybe<Scalars['Boolean']>;
};


/** Employee */
export type EmployeesEmployeeCostCenterAssignmentsArgs = {
  activeOn?: InputMaybe<Scalars['ISO8601Date']>;
  applyingOn?: InputMaybe<Scalars['ISO8601Date']>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyNextUpcoming?: InputMaybe<Scalars['Boolean']>;
};


/** Employee */
export type EmployeesEmployeeCostcenterassignmentsConnectionArgs = {
  activeOn?: InputMaybe<Scalars['ISO8601Date']>;
  after?: InputMaybe<Scalars['String']>;
  applyingOn?: InputMaybe<Scalars['ISO8601Date']>;
  before?: InputMaybe<Scalars['String']>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyNextUpcoming?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Employee */
export type EmployeesEmployeeDefaultLocationArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  main?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};


/** Employee */
export type EmployeesEmployeeEmployeeGroupArgs = {
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Employee */
export type EmployeesEmployeeEmployeeNameArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  afterEmployeeId?: InputMaybe<Scalars['Int']>;
  beforeEmployeeId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  reporteesOrLed?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyId?: InputMaybe<Scalars['Int']>;
  verb?: InputMaybe<Scalars['String']>;
  withActiveContract?: Scalars['Boolean'];
};


/** Employee */
export type EmployeesEmployeeFaceRecognitionEmployeesPicturesArgs = {
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  status?: InputMaybe<Scalars['String']>;
};


/** Employee */
export type EmployeesEmployeeFaceRecognitionEmployeesPicturesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  status?: InputMaybe<Scalars['String']>;
};


/** Employee */
export type EmployeesEmployeeFinanceCostCenterMembershipsArgs = {
  activeOn?: InputMaybe<Scalars['ISO8601Date']>;
  applyingOn?: InputMaybe<Scalars['ISO8601Date']>;
  companyId?: InputMaybe<Scalars['Int']>;
  costCenterId?: InputMaybe<Scalars['Int']>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeId?: InputMaybe<Scalars['Int']>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
};


/** Employee */
export type EmployeesEmployeeFinanceCustomDimensionMembershipsArgs = {
  activeOn?: InputMaybe<Scalars['ISO8601Date']>;
  customDimensionValueIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeId?: InputMaybe<Scalars['Int']>;
  tenant?: InputMaybe<FinanceTenantInput>;
};


/** Employee */
export type EmployeesEmployeeFinancecostcentermembershipsConnectionArgs = {
  activeOn?: InputMaybe<Scalars['ISO8601Date']>;
  after?: InputMaybe<Scalars['String']>;
  applyingOn?: InputMaybe<Scalars['ISO8601Date']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  costCenterId?: InputMaybe<Scalars['Int']>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Employee */
export type EmployeesEmployeeFinancecustomdimensionmembershipsConnectionArgs = {
  activeOn?: InputMaybe<Scalars['ISO8601Date']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  customDimensionValueIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  tenant?: InputMaybe<FinanceTenantInput>;
};


/** Employee */
export type EmployeesEmployeeFoldersArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Employee */
export type EmployeesEmployeeFoldersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Employee */
export type EmployeesEmployeeGoalsEmployeeArgs = {
  noCycle?: InputMaybe<Scalars['Boolean']>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyAssignable?: InputMaybe<Scalars['Boolean']>;
  onlyDirectReports?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};


/** Employee */
export type EmployeesEmployeeLeavesArgs = {
  approved?: InputMaybe<Scalars['Boolean']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeAllPendingApprovals?: InputMaybe<Scalars['Boolean']>;
  includeAllRelations?: InputMaybe<Scalars['Boolean']>;
  includeDeletedLeaves?: Scalars['Boolean'];
  includeDuration?: InputMaybe<Scalars['Boolean']>;
  includeLeaveType?: InputMaybe<Scalars['Boolean']>;
  includePending?: InputMaybe<Scalars['Boolean']>;
  leaveType?: InputMaybe<Array<Scalars['String']>>;
  leaveTypeId?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  to?: InputMaybe<Scalars['ISO8601Date']>;
  typeIsPayable?: InputMaybe<Scalars['Boolean']>;
  typeIsWorkable?: InputMaybe<Scalars['Boolean']>;
};


/** Employee */
export type EmployeesEmployeeLeavesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  approved?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeAllPendingApprovals?: InputMaybe<Scalars['Boolean']>;
  includeAllRelations?: InputMaybe<Scalars['Boolean']>;
  includeDeletedLeaves?: Scalars['Boolean'];
  includeDuration?: InputMaybe<Scalars['Boolean']>;
  includeLeaveType?: InputMaybe<Scalars['Boolean']>;
  includePending?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  leaveType?: InputMaybe<Array<Scalars['String']>>;
  leaveTypeId?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Sort>;
  to?: InputMaybe<Scalars['ISO8601Date']>;
  typeIsPayable?: InputMaybe<Scalars['Boolean']>;
  typeIsWorkable?: InputMaybe<Scalars['Boolean']>;
};


/** Employee */
export type EmployeesEmployeeLegalEntityArgs = {
  companiesIds?: InputMaybe<Array<Scalars['Int']>>;
  countryIds?: InputMaybe<Array<Scalars['String']>>;
  employeesIds?: InputMaybe<Array<Scalars['Int']>>;
  excludeCountries?: InputMaybe<Array<Scalars['String']>>;
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


/** Employee */
export type EmployeesEmployeeLocationsArgs = {
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Employee */
export type EmployeesEmployeeLocationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Employee */
export type EmployeesEmployeeManagerArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Employee */
export type EmployeesEmployeeMembershipsArgs = {
  activeEmployees?: Scalars['Boolean'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  lead?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  sortByLeads?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Employee */
export type EmployeesEmployeeMembershipsConnectionArgs = {
  activeEmployees?: Scalars['Boolean'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  lead?: InputMaybe<Scalars['Boolean']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortByLeads?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Sort>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Employee */
export type EmployeesEmployeePayrollPolicyEmployeeArgs = {
  allowUpcomingContracts?: InputMaybe<Scalars['Boolean']>;
  fromDate?: InputMaybe<Scalars['ISO8601Date']>;
  onDate?: InputMaybe<Scalars['ISO8601Date']>;
  payrollPolicyId?: InputMaybe<Scalars['Int']>;
  payrollPolicyPeriodId?: InputMaybe<Scalars['Int']>;
  toDate?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Employee */
export type EmployeesEmployeeReferenceContractArgs = {
  activeBetween?: InputMaybe<ReferenceContractsActiveBetweenInput>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  effectiveOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  endsOnGt?: InputMaybe<Scalars['ISO8601Date']>;
  endsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  frContractTypeIds?: InputMaybe<Array<Scalars['Int']>>;
  frMutualIds?: InputMaybe<Array<Scalars['Int']>>;
  frWorkTypeIds?: InputMaybe<Array<Scalars['Int']>>;
  includeDenormalizedData?: Scalars['Boolean'];
  includeEducationLevel?: Scalars['Boolean'];
  jobCatalogLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  jobCatalogTreeNodeUuids?: InputMaybe<Array<Scalars['String']>>;
  onDate?: InputMaybe<Scalars['ISO8601Date']>;
  payrollPolicyId?: InputMaybe<Scalars['Int']>;
  startsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  startsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedBecauseRelatedModels?: InputMaybe<Scalars['Boolean']>;
  withPayroll?: InputMaybe<Scalars['Boolean']>;
  withTranslations?: InputMaybe<Scalars['Boolean']>;
};


/** Employee */
export type EmployeesEmployeeReportsArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Employee */
export type EmployeesEmployeeReportsConnectionArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  after?: InputMaybe<Scalars['String']>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Sort>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Employee */
export type EmployeesEmployeeSupplementsArgs = {
  compensationId?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  policyPeriodIds?: Array<Scalars['Int']>;
  sourceIds?: InputMaybe<Array<Scalars['Int']>>;
  sourceType?: InputMaybe<Scalars['String']>;
  taxonomyIds?: InputMaybe<Array<Scalars['Int']>>;
  to?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Employee */
export type EmployeesEmployeeSupplementsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  compensationId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  policyPeriodIds?: Array<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  sourceIds?: InputMaybe<Array<Scalars['Int']>>;
  sourceType?: InputMaybe<Scalars['String']>;
  taxonomyIds?: InputMaybe<Array<Scalars['Int']>>;
  to?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Employee */
export type EmployeesEmployeeTerminationTypeArgs = {
  country?: InputMaybe<Scalars['String']>;
};


/** Employee */
export type EmployeesEmployeeTimeoffAllowanceIncidencesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  timeoffAllowanceIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Employee */
export type EmployeesEmployeeTimeoffManagerArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Employee */
export type EmployeesEmployeeTimeoffPolicyArgs = {
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Employee */
export type EmployeesEmployeeTimeoffPolicyAssignmentsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Employee */
export type EmployeesEmployeeTimeoffallowanceincidencesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  timeoffAllowanceIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Employee */
export type EmployeesEmployeeTimeoffpolicyassignmentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Employee */
export type EmployeesEmployeeUpcomingLeavesArgs = {
  futureDays: Scalars['Int'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Employee */
export type EmployeesEmployeeUpcomingLeavesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  futureDays: Scalars['Int'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Employee */
export type EmployeesEmployeeUpcomingTeamLeavesArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  futureDays: Scalars['Int'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Employee */
export type EmployeesEmployeeUpcomingTeamLeavesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  futureDays: Scalars['Int'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Employee */
export type EmployeesEmployeeValuesArgs = {
  contractsVersionsIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  fieldId?: InputMaybe<Scalars['Int']>;
  identifiers?: InputMaybe<Array<Scalars['String']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  instanceId?: InputMaybe<Scalars['Int']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  updatedAtGteq?: InputMaybe<Scalars['String']>;
  usageGroupId?: InputMaybe<Scalars['Int']>;
  usageGroupSlugs?: InputMaybe<Array<Scalars['String']>>;
  value?: InputMaybe<Scalars['String']>;
};


/** Employee */
export type EmployeesEmployeeValuesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  contractsVersionsIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  fieldId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  identifiers?: InputMaybe<Array<Scalars['String']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  instanceId?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  updatedAtGteq?: InputMaybe<Scalars['String']>;
  usageGroupId?: InputMaybe<Scalars['Int']>;
  usageGroupSlugs?: InputMaybe<Array<Scalars['String']>>;
  value?: InputMaybe<Scalars['String']>;
};


/** Employee */
export type EmployeesEmployeeYearlyTimeInfoArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
  referenceDate: Scalars['ISO8601Date'];
};


/** Employee */
export type EmployeesEmployeeYearlytimeinfoConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  referenceDate: Scalars['ISO8601Date'];
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for EmployeesEmployee. */
export type EmployeesEmployeeConnection = {
  __typename?: 'EmployeesEmployeeConnection';
  /** A list of edges. */
  edges: Array<EmployeesEmployeeEdge>;
  /** A list of nodes. */
  nodes: Array<EmployeesEmployee>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type EmployeesEmployeeEdge = {
  __typename?: 'EmployeesEmployeeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: EmployeesEmployee;
};

/** the filter for the employees resource */
export type EmployeesEmployeeFilter = {
  city?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntegerFilter>;
  lastName?: InputMaybe<StringFilter>;
  locationId?: InputMaybe<IntegerFilter>;
  or?: InputMaybe<Array<EmployeesEmployeeFilterConditions>>;
  referenceContractStartsOn?: InputMaybe<DateFilter>;
  terminatedOn?: InputMaybe<DateFilter>;
  timeoffManagerId?: InputMaybe<IntegerFilter>;
};

export type EmployeesEmployeeFilterConditions = {
  city?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntegerFilter>;
  lastName?: InputMaybe<StringFilter>;
  locationId?: InputMaybe<IntegerFilter>;
  referenceContractStartsOn?: InputMaybe<DateFilter>;
  terminatedOn?: InputMaybe<DateFilter>;
  timeoffManagerId?: InputMaybe<IntegerFilter>;
};

/** Employees employee group */
export type EmployeesEmployeeGroup = {
  __typename?: 'EmployeesEmployeeGroup';
  employeeNames: Array<EmployeesEmployeeName>;
  employeeNamesConnection: EmployeesEmployeeNameConnection;
  employees: Array<EmployeesEmployee>;
  employeesConnection: EmployeesEmployeeConnection;
  id: Scalars['Int'];
  legalEntityId: Scalars['Int'];
  main: Scalars['Boolean'];
  name: Scalars['String'];
};


/** Employees employee group */
export type EmployeesEmployeeGroupEmployeeNamesArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  afterEmployeeId?: InputMaybe<Scalars['Int']>;
  beforeEmployeeId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  reporteesOrLed?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyId?: InputMaybe<Scalars['Int']>;
  verb?: InputMaybe<Scalars['String']>;
  withActiveContract?: Scalars['Boolean'];
};


/** Employees employee group */
export type EmployeesEmployeeGroupEmployeeNamesConnectionArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  after?: InputMaybe<Scalars['String']>;
  afterEmployeeId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  beforeEmployeeId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  reporteesOrLed?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyId?: InputMaybe<Scalars['Int']>;
  verb?: InputMaybe<Scalars['String']>;
  withActiveContract?: Scalars['Boolean'];
};


/** Employees employee group */
export type EmployeesEmployeeGroupEmployeesArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Employees employee group */
export type EmployeesEmployeeGroupEmployeesConnectionArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  after?: InputMaybe<Scalars['String']>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  first?: InputMaybe<Scalars['Int']>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Sort>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for EmployeesEmployeeGroup. */
export type EmployeesEmployeeGroupConnection = {
  __typename?: 'EmployeesEmployeeGroupConnection';
  /** A list of edges. */
  edges: Array<EmployeesEmployeeGroupEdge>;
  /** A list of nodes. */
  nodes: Array<EmployeesEmployeeGroup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type EmployeesEmployeeGroupEdge = {
  __typename?: 'EmployeesEmployeeGroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: EmployeesEmployeeGroup;
};

/** Employee names */
export type EmployeesEmployeeName = {
  __typename?: 'EmployeesEmployeeName';
  access: ApiCoreAccess;
  /**
   * access_id associated to the employee.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  accessId: Scalars['Int'];
  avatar?: Maybe<ApiCoreAttachment>;
  avatarId?: Maybe<Scalars['Int']>;
  benefitCompensations: Array<BenefitsBenefitCompensation>;
  benefitCompensationsConnection: BenefitsBenefitCompensationConnection;
  companyId: Scalars['Int'];
  defaultLocation?: Maybe<LocationsLocation>;
  employeeGroupId?: Maybe<Scalars['Int']>;
  /** name of the employee. */
  firstName: Scalars['String'];
  /** full name of the employee. */
  fullName: Scalars['String'];
  /** id of the employee. */
  id: Scalars['Int'];
  /** last name of the employee. */
  lastName: Scalars['String'];
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  locationId: Scalars['Int'];
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  managerId?: Maybe<Scalars['Int']>;
  managerName?: Maybe<EmployeesEmployeeName>;
  /** nickname of the employee or a name that defines the employee better. */
  preferredName?: Maybe<Scalars['String']>;
  teamMemberships: Array<TeamsMembership>;
  teamMembershipsConnection: TeamsMembershipConnection;
  upcomingLeaves: Array<TimeoffUpcomingLeave>;
  upcomingLeavesConnection: TimeoffUpcomingLeaveConnection;
};


/** Employee names */
export type EmployeesEmployeeNameAccessArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** Employee names */
export type EmployeesEmployeeNameAvatarArgs = {
  attachmentName?: InputMaybe<Scalars['String']>;
};


/** Employee names */
export type EmployeesEmployeeNameBenefitCompensationsArgs = {
  categories?: InputMaybe<Array<BenefitsValueObjectsBenefitTransactionCategoryEnum>>;
  createdAfter?: InputMaybe<Scalars['ISO8601DateTime']>;
  createdBefore?: InputMaybe<Scalars['ISO8601DateTime']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Employee names */
export type EmployeesEmployeeNameBenefitCompensationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  categories?: InputMaybe<Array<BenefitsValueObjectsBenefitTransactionCategoryEnum>>;
  createdAfter?: InputMaybe<Scalars['ISO8601DateTime']>;
  createdBefore?: InputMaybe<Scalars['ISO8601DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Employee names */
export type EmployeesEmployeeNameDefaultLocationArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  main?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};


/** Employee names */
export type EmployeesEmployeeNameManagerNameArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  afterEmployeeId?: InputMaybe<Scalars['Int']>;
  beforeEmployeeId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  reporteesOrLed?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyId?: InputMaybe<Scalars['Int']>;
  verb?: InputMaybe<Scalars['String']>;
  withActiveContract?: Scalars['Boolean'];
};


/** Employee names */
export type EmployeesEmployeeNameTeamMembershipsArgs = {
  activeEmployees?: Scalars['Boolean'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  lead?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  sortByLeads?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Employee names */
export type EmployeesEmployeeNameTeamMembershipsConnectionArgs = {
  activeEmployees?: Scalars['Boolean'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  lead?: InputMaybe<Scalars['Boolean']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortByLeads?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Sort>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Employee names */
export type EmployeesEmployeeNameUpcomingLeavesArgs = {
  futureDays: Scalars['Int'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Employee names */
export type EmployeesEmployeeNameUpcomingLeavesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  futureDays: Scalars['Int'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for EmployeesEmployeeName. */
export type EmployeesEmployeeNameConnection = {
  __typename?: 'EmployeesEmployeeNameConnection';
  /** A list of edges. */
  edges: Array<EmployeesEmployeeNameEdge>;
  /** A list of nodes. */
  nodes: Array<EmployeesEmployeeName>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type EmployeesEmployeeNameEdge = {
  __typename?: 'EmployeesEmployeeNameEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: EmployeesEmployeeName;
};

/** the filter for the employee_names resource */
export type EmployeesEmployeeNameFilter = {
  firstName?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntegerFilter>;
  lastName?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<EmployeesEmployeeNameFilterConditions>>;
};

export type EmployeesEmployeeNameFilterConditions = {
  firstName?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntegerFilter>;
  lastName?: InputMaybe<StringFilter>;
};

export type EmployeesEmployeePolicies = {
  __typename?: 'EmployeesEmployeePolicies';
  addCustomTablesRecords: PermissionsPolicyResolution;
  approveLeaves: PermissionsPolicyResolution;
  bulkAssignLocations: PermissionsPolicyResolution;
  createEauRequestOauthToken: PermissionsPolicyResolution;
  createExpenseCardFor: PermissionsPolicyResolution;
  createLeaves: PermissionsPolicyResolution;
  editAttendance: PermissionsPolicyResolution;
  editCompanyIdentifier: PermissionsPolicyResolution;
  editContract: PermissionsPolicyResolution;
  editEmployeeDocumentsWithoutFolder: PermissionsPolicyResolution;
  editInBulk: PermissionsPolicyResolution;
  editManager: PermissionsPolicyResolution;
  editPersonalInfo: PermissionsPolicyResolution;
  editPlanningVersions: PermissionsPolicyResolution;
  editPolicyAssignments: PermissionsPolicyResolution;
  editSeniorityCalculationDate: PermissionsPolicyResolution;
  electronicSickLeave: PermissionsPolicyResolution;
  inviteEmployeeToApp: PermissionsPolicyResolution;
  manageCostCenterMembershipsFor: PermissionsPolicyResolution;
  manageFinanceCustomDimensionsFor: PermissionsPolicyResolution;
  manageIncidences: PermissionsPolicyResolution;
  manageLeavesDocuments: PermissionsPolicyResolution;
  manageTasks: PermissionsPolicyResolution;
  readCompanyIdentifier: PermissionsPolicyResolution;
  readLeaves: PermissionsPolicyResolution;
  readPersonalInfo: PermissionsPolicyResolution;
  readSeniorityCalculationDate: PermissionsPolicyResolution;
  registerFlexibleTracking: PermissionsPolicyResolution;
  removeCustomTablesRecords: PermissionsPolicyResolution;
  seeAnyEmployeeDocumentsByFolder: PermissionsPolicyResolution;
  seeAttendance: PermissionsPolicyResolution;
  seeContract: PermissionsPolicyResolution;
  seeContractType: PermissionsPolicyResolution;
  seeCostCenterMembershipsFor: PermissionsPolicyResolution;
  seeDocuments: PermissionsPolicyResolution;
  seeEmployeeCompetenciesAssessments: PermissionsPolicyResolution;
  seeEmployeeDocumentsWithoutFolder: PermissionsPolicyResolution;
  seeEmployeePerformanceTab: PermissionsPolicyResolution;
  seeEmployeeTalentPage: PermissionsPolicyResolution;
  seeEmployeeTrainings: PermissionsPolicyResolution;
  seeFinanceCustomDimensionsFor: PermissionsPolicyResolution;
  seeFutureEmployees: PermissionsPolicyResolution;
  seePlanningVersions: PermissionsPolicyResolution;
  seeSalary: PermissionsPolicyResolution;
  seeTerminateEmployeesInfo: PermissionsPolicyResolution;
  seeTrainings: PermissionsPolicyResolution;
  seeWorkingHours: PermissionsPolicyResolution;
  sharePreferredName: PermissionsPolicyResolution;
  shareProfileEmail: PermissionsPolicyResolution;
  terminateEmployees: PermissionsPolicyResolution;
  updateLeaves: PermissionsPolicyResolution;
};

export type EmployeesEmployeePoliciesEnum =
  | 'addCustomTablesRecords'
  | 'approveLeaves'
  | 'bulkAssignLocations'
  | 'createEauRequestOauthToken'
  | 'createExpenseCardFor'
  | 'createLeaves'
  | 'editAttendance'
  | 'editCompanyIdentifier'
  | 'editContract'
  | 'editEmployeeDocumentsWithoutFolder'
  | 'editInBulk'
  | 'editManager'
  | 'editPersonalInfo'
  | 'editPlanningVersions'
  | 'editPolicyAssignments'
  | 'editSeniorityCalculationDate'
  | 'electronicSickLeave'
  | 'inviteEmployeeToApp'
  | 'manageCostCenterMembershipsFor'
  | 'manageFinanceCustomDimensionsFor'
  | 'manageIncidences'
  | 'manageLeavesDocuments'
  | 'manageTasks'
  | 'readCompanyIdentifier'
  | 'readLeaves'
  | 'readPersonalInfo'
  | 'readSeniorityCalculationDate'
  | 'registerFlexibleTracking'
  | 'removeCustomTablesRecords'
  | 'seeAnyEmployeeDocumentsByFolder'
  | 'seeAttendance'
  | 'seeContract'
  | 'seeContractType'
  | 'seeCostCenterMembershipsFor'
  | 'seeDocuments'
  | 'seeEmployeeCompetenciesAssessments'
  | 'seeEmployeeDocumentsWithoutFolder'
  | 'seeEmployeePerformanceTab'
  | 'seeEmployeeTalentPage'
  | 'seeEmployeeTrainings'
  | 'seeFinanceCustomDimensionsFor'
  | 'seeFutureEmployees'
  | 'seePlanningVersions'
  | 'seeSalary'
  | 'seeTerminateEmployeesInfo'
  | 'seeTrainings'
  | 'seeWorkingHours'
  | 'sharePreferredName'
  | 'shareProfileEmail'
  | 'terminateEmployees'
  | 'updateLeaves';

export type EmployeesEmployeeSelectorFiltersInput = {
  jobRole?: InputMaybe<Array<Scalars['String']>>;
  legalEntity?: InputMaybe<Array<Scalars['Int']>>;
  onlyManagers?: InputMaybe<Scalars['Boolean']>;
  reportingTo?: InputMaybe<Array<Scalars['Int']>>;
  team?: InputMaybe<Array<Scalars['Int']>>;
  timeoffManager?: InputMaybe<Array<Scalars['Int']>>;
  workplace?: InputMaybe<Array<Scalars['Int']>>;
};

export type EmployeesEmployeeSelectorInput = {
  excludedIds?: InputMaybe<Array<Scalars['Int']>>;
  filters?: InputMaybe<EmployeesEmployeeSelectorFiltersInput>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeInactive?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<EmployeesValueObjectsEmployeeSelectorTypeEnumEnum>;
};

export type EmployeesEmployeeSourceInput = {
  sourceId?: InputMaybe<Scalars['String']>;
  sourceType?: InputMaybe<Scalars['String']>;
};

export type EmployeesFranceContractFieldsInput = {
  contractTypeId?: InputMaybe<Scalars['Int']>;
  professionalCategoryId?: InputMaybe<Scalars['Int']>;
};

/** Headcount by gender */
export type EmployeesGenderHeadcount = {
  __typename?: 'EmployeesGenderHeadcount';
  genderName: Scalars['String'];
  headcount: Scalars['Int'];
};

/** Headcount by gender */
export type EmployeesGenderHeadcountCategorical = {
  __typename?: 'EmployeesGenderHeadcountCategorical';
  categories: Array<Scalars['String']>;
  series: Array<Scalars['Int']>;
};

/** The connection type for EmployeesGenderHeadcountCategorical. */
export type EmployeesGenderHeadcountCategoricalConnection = {
  __typename?: 'EmployeesGenderHeadcountCategoricalConnection';
  /** A list of edges. */
  edges: Array<EmployeesGenderHeadcountCategoricalEdge>;
  /** A list of nodes. */
  nodes: Array<EmployeesGenderHeadcountCategorical>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type EmployeesGenderHeadcountCategoricalEdge = {
  __typename?: 'EmployeesGenderHeadcountCategoricalEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: EmployeesGenderHeadcountCategorical;
};

/** The connection type for EmployeesGenderHeadcount. */
export type EmployeesGenderHeadcountConnection = {
  __typename?: 'EmployeesGenderHeadcountConnection';
  /** A list of edges. */
  edges: Array<EmployeesGenderHeadcountEdge>;
  /** A list of nodes. */
  nodes: Array<EmployeesGenderHeadcount>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type EmployeesGenderHeadcountEdge = {
  __typename?: 'EmployeesGenderHeadcountEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: EmployeesGenderHeadcount;
};

export type EmployeesGermanyContractFieldsInput = {
  contractTypeId?: InputMaybe<Scalars['Int']>;
};

export type EmployeesGrossSalaryHoursHoursInput = {
  date: Scalars['ISO8601Date'];
  hours: Scalars['String'];
};

export type EmployeesPortugalContractFieldsInput = {
  contractTypeId?: InputMaybe<Scalars['Int']>;
};

/** Employee reportees */
export type EmployeesReportee = {
  __typename?: 'EmployeesReportee';
  accessId: Scalars['Int'];
  active?: Maybe<Scalars['Boolean']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  affiliation?: Maybe<AccessAffiliationEnum>;
  ageNumber?: Maybe<Scalars['Int']>;
  attendable: Scalars['Boolean'];
  attendanceEmployeesPolicyId?: Maybe<Scalars['Int']>;
  avatarId?: Maybe<Scalars['Int']>;
  bankNumber?: Maybe<Scalars['String']>;
  bankNumberFormat?: Maybe<BankingEntitiesBankAccountNumberFormatEnum>;
  birthName?: Maybe<Scalars['String']>;
  birthdayOn?: Maybe<Scalars['ISO8601Date']>;
  birthplace?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  communicationsEmail?: Maybe<Scalars['String']>;
  companyId: Scalars['Int'];
  companyIdentifier?: Maybe<Scalars['String']>;
  contactName?: Maybe<Scalars['String']>;
  contactNumber?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  countryOfBirth?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  disabilityPercentageCents?: Maybe<Scalars['Int']>;
  discoverabilityWidgetValue?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  employeeGroupId?: Maybe<Scalars['Int']>;
  employeesLocationIds?: Maybe<Array<Scalars['Int']>>;
  esIrpfCents?: Maybe<Scalars['Int']>;
  firstName: Scalars['String'];
  fullName: Scalars['String'];
  gender?: Maybe<Scalars['String']>;
  hasRegularAccess: Scalars['Boolean'];
  hasWorkPermit?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  identifier?: Maybe<Scalars['String']>;
  identifierExpirationDate?: Maybe<Scalars['ISO8601Date']>;
  identifierType?: Maybe<Scalars['String']>;
  irpfCents?: Maybe<Scalars['Int']>;
  isTerminating: Scalars['Boolean'];
  joined?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  legalEntityId?: Maybe<Scalars['Int']>;
  locationId: Scalars['Int'];
  locationName?: Maybe<Scalars['String']>;
  loginEmail?: Maybe<Scalars['String']>;
  managerId?: Maybe<Scalars['Int']>;
  nationality?: Maybe<Scalars['String']>;
  payrollable: Scalars['Boolean'];
  personalEmail?: Maybe<Scalars['String']>;
  phoneCode?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  pronouns?: Maybe<Scalars['String']>;
  regularAccessStartsOn?: Maybe<Scalars['ISO8601Date']>;
  seniorityCalculationDate?: Maybe<Scalars['ISO8601Date']>;
  shareBirthday?: Maybe<Scalars['Boolean']>;
  socialSecurityNumber?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  supervisedByCurrent?: Maybe<Scalars['Boolean']>;
  swiftBic?: Maybe<Scalars['String']>;
  taxId?: Maybe<Scalars['String']>;
  teamIds?: Maybe<Array<Scalars['Int']>>;
  terminatedOn?: Maybe<Scalars['ISO8601Date']>;
  terminationObservations?: Maybe<Scalars['String']>;
  terminationReason?: Maybe<Scalars['String']>;
  terminationReasonType?: Maybe<Scalars['String']>;
  terminationTypeDescription?: Maybe<Scalars['String']>;
  terminationTypeId?: Maybe<Scalars['Int']>;
  timeoffManagerId?: Maybe<Scalars['Int']>;
  timeoffPolicyId?: Maybe<Scalars['Int']>;
  timeoffSupervisedByCurrent?: Maybe<Scalars['Boolean']>;
  unconfirmedCommunicationsEmail?: Maybe<Scalars['String']>;
  unconfirmedEmail?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for EmployeesReportee. */
export type EmployeesReporteeConnection = {
  __typename?: 'EmployeesReporteeConnection';
  /** A list of edges. */
  edges: Array<EmployeesReporteeEdge>;
  /** A list of nodes. */
  nodes: Array<EmployeesReportee>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type EmployeesReporteeEdge = {
  __typename?: 'EmployeesReporteeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: EmployeesReportee;
};

export type EmployeesSpainContractFieldsInput = {
  contractTypeId?: InputMaybe<Scalars['Int']>;
  contributionTypeId?: InputMaybe<Scalars['Int']>;
  professionalCategoryId?: InputMaybe<Scalars['Int']>;
  workingDayTypeId?: InputMaybe<Scalars['Int']>;
};

export type EmployeesSpanishEmployeeFieldsInput = {
  socialSecurityNumber?: InputMaybe<Scalars['String']>;
};

export type EmployeesTaxResidenceFieldsInput = {
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  cityOfBirth?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  countryOfBirth?: InputMaybe<Scalars['String']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  identifier?: InputMaybe<Scalars['String']>;
  isResident?: InputMaybe<Scalars['Boolean']>;
  noResidentEndDate?: InputMaybe<Scalars['ISO8601Date']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

/** Headcount by team */
export type EmployeesTeamHeadcount = {
  __typename?: 'EmployeesTeamHeadcount';
  headcount: Scalars['Int'];
  teamName: Scalars['String'];
};

/** The connection type for EmployeesTeamHeadcount. */
export type EmployeesTeamHeadcountConnection = {
  __typename?: 'EmployeesTeamHeadcountConnection';
  /** A list of edges. */
  edges: Array<EmployeesTeamHeadcountEdge>;
  /** A list of nodes. */
  nodes: Array<EmployeesTeamHeadcount>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type EmployeesTeamHeadcountEdge = {
  __typename?: 'EmployeesTeamHeadcountEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: EmployeesTeamHeadcount;
};

export type EmployeesValueObjectsEmployeeSelectorTypeEnumEnum =
  | 'all'
  | 'manual';

/** Autogenerated return type of EnableFinanceAccount. */
export type EnableFinanceAccountPayload = {
  __typename?: 'EnableFinanceAccountPayload';
  account?: Maybe<FinanceAccount>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of EnableFinanceCustomCategory. */
export type EnableFinanceCustomCategoryPayload = {
  __typename?: 'EnableFinanceCustomCategoryPayload';
  customCategory?: Maybe<FinanceCustomCategory>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of EnableIntegrationsinfojobsOffer. */
export type EnableIntegrationsinfojobsOfferPayload = {
  __typename?: 'EnableIntegrationsinfojobsOfferPayload';
  errors: Array<MutationError>;
  offer?: Maybe<IntegrationsInfojobsOffer>;
};

/** Autogenerated return type of EnableTrialCompaniesSubscriptionOverload. */
export type EnableTrialCompaniesSubscriptionOverloadPayload = {
  __typename?: 'EnableTrialCompaniesSubscriptionOverloadPayload';
  errors: Array<MutationError>;
  subscriptionOverload?: Maybe<CompaniesSubscriptionOverload>;
};

/** Autogenerated return type of EnabledForAccessFeaturesFeatureMembership. */
export type EnabledForAccessFeaturesFeatureMembershipPayload = {
  __typename?: 'EnabledForAccessFeaturesFeatureMembershipPayload';
  errors: Array<MutationError>;
  featureMembership?: Maybe<FeaturesFeatureMembership>;
};

/** Autogenerated return type of EnabledForEmployeeFeaturesFeatureMembership. */
export type EnabledForEmployeeFeaturesFeatureMembershipPayload = {
  __typename?: 'EnabledForEmployeeFeaturesFeatureMembershipPayload';
  errors: Array<MutationError>;
  featureMembership?: Maybe<FeaturesFeatureMembership>;
};

/** Autogenerated return type of EndFinanceCustomDimensionMembership. */
export type EndFinanceCustomDimensionMembershipPayload = {
  __typename?: 'EndFinanceCustomDimensionMembershipPayload';
  customDimensionMembership?: Maybe<FinanceCustomDimensionMembership>;
  errors: Array<MutationError>;
};

export type EngagementContextlessPolicies = {
  __typename?: 'EngagementContextlessPolicies';
  seePulseDashboard: ContextlessPolicyResolution;
  settingsManage: ContextlessPolicyResolution;
};

export type EngagementDtosEmployeePulseInsightGroupsGroupByEnum =
  | 'gender'
  | 'legal_entity'
  | 'manager'
  | 'nationality'
  | 'team'
  | 'workspace';

/** Employee current pulse */
export type EngagementEmployeeCurrentPulse = {
  __typename?: 'EngagementEmployeeCurrentPulse';
  id: Scalars['Int'];
  pulse?: Maybe<EngagementEmployeePulse>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  pulseId?: Maybe<Scalars['Int']>;
  showPrompt: Scalars['Boolean'];
};


/** Employee current pulse */
export type EngagementEmployeeCurrentPulsePulseArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  dateRange?: InputMaybe<DateRangeInput>;
  managedOnly?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for EngagementEmployeeCurrentPulse. */
export type EngagementEmployeeCurrentPulseConnection = {
  __typename?: 'EngagementEmployeeCurrentPulseConnection';
  /** A list of edges. */
  edges: Array<EngagementEmployeeCurrentPulseEdge>;
  /** A list of nodes. */
  nodes: Array<EngagementEmployeeCurrentPulse>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type EngagementEmployeeCurrentPulseEdge = {
  __typename?: 'EngagementEmployeeCurrentPulseEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: EngagementEmployeeCurrentPulse;
};

/** employee_pulse */
export type EngagementEmployeePulse = {
  __typename?: 'EngagementEmployeePulse';
  access?: Maybe<ApiCoreAccess>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  accessId: Scalars['Int'];
  comment?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  fullName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  /** When the pulse was submitted. */
  submittedDate?: Maybe<Scalars['ISO8601DateTime']>;
  tags: Array<EngagementPulseTag>;
  tagsConnection: EngagementPulseTagConnection;
  updatedAt: Scalars['ISO8601DateTime'];
  value: Scalars['Int'];
};


/** employee_pulse */
export type EngagementEmployeePulseAccessArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** employee_pulse */
export type EngagementEmployeePulseTagsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** employee_pulse */
export type EngagementEmployeePulseTagsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for EngagementEmployeePulse. */
export type EngagementEmployeePulseConnection = {
  __typename?: 'EngagementEmployeePulseConnection';
  aggregate?: Maybe<EngagementEmployeePulsesAggregate>;
  /** A list of edges. */
  edges: Array<EngagementEmployeePulseEdge>;
  /** A list of nodes. */
  nodes: Array<EngagementEmployeePulse>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type EngagementEmployeePulseEdge = {
  __typename?: 'EngagementEmployeePulseEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: EngagementEmployeePulse;
};

/** the filter for the employee_pulses resource */
export type EngagementEmployeePulseFilter = {
  or?: InputMaybe<Array<EngagementEmployeePulseFilterConditions>>;
  submittedDate?: InputMaybe<DateTimeFilter>;
  value?: InputMaybe<IntegerFilter>;
};

export type EngagementEmployeePulseFilterConditions = {
  submittedDate?: InputMaybe<DateTimeFilter>;
  value?: InputMaybe<IntegerFilter>;
};

/** Employee pulse insights */
export type EngagementEmployeePulseInsight = {
  __typename?: 'EngagementEmployeePulseInsight';
  accessId: Scalars['Int'];
  gender?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  legalEntityId?: Maybe<Scalars['Int']>;
  managerId?: Maybe<Scalars['Int']>;
  nationality?: Maybe<Scalars['String']>;
  teamId?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['Int']>;
  workspace?: Maybe<Scalars['Int']>;
};

/** The connection type for EngagementEmployeePulseInsight. */
export type EngagementEmployeePulseInsightConnection = {
  __typename?: 'EngagementEmployeePulseInsightConnection';
  aggregate?: Maybe<EngagementEmployeePulseInsightsAggregate>;
  /** A list of edges. */
  edges: Array<EngagementEmployeePulseInsightEdge>;
  /** A list of nodes. */
  nodes: Array<EngagementEmployeePulseInsight>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type EngagementEmployeePulseInsightEdge = {
  __typename?: 'EngagementEmployeePulseInsightEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: EngagementEmployeePulseInsight;
};

/** the filter for the employee_pulse_insights resource */
export type EngagementEmployeePulseInsightFilter = {
  employeeId?: InputMaybe<IntegerFilter>;
  gender?: InputMaybe<StringFilter>;
  legalEntityId?: InputMaybe<IntegerFilter>;
  managerId?: InputMaybe<IntegerFilter>;
  nationality?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<EngagementEmployeePulseInsightFilterConditions>>;
  teamId?: InputMaybe<IntegerFilter>;
  tenureDate?: InputMaybe<StringFilter>;
  value?: InputMaybe<IntegerFilter>;
  workspace?: InputMaybe<IntegerFilter>;
};

export type EngagementEmployeePulseInsightFilterConditions = {
  employeeId?: InputMaybe<IntegerFilter>;
  gender?: InputMaybe<StringFilter>;
  legalEntityId?: InputMaybe<IntegerFilter>;
  managerId?: InputMaybe<IntegerFilter>;
  nationality?: InputMaybe<StringFilter>;
  teamId?: InputMaybe<IntegerFilter>;
  tenureDate?: InputMaybe<StringFilter>;
  value?: InputMaybe<IntegerFilter>;
  workspace?: InputMaybe<IntegerFilter>;
};

/** Employee pulse insight groups */
export type EngagementEmployeePulseInsightGroup = {
  __typename?: 'EngagementEmployeePulseInsightGroup';
  counts: Array<Scalars['Int']>;
  groups: Array<Scalars['String']>;
  value: Scalars['String'];
};

/** The connection type for EngagementEmployeePulseInsightGroup. */
export type EngagementEmployeePulseInsightGroupConnection = {
  __typename?: 'EngagementEmployeePulseInsightGroupConnection';
  /** A list of edges. */
  edges: Array<EngagementEmployeePulseInsightGroupEdge>;
  /** A list of nodes. */
  nodes: Array<EngagementEmployeePulseInsightGroup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type EngagementEmployeePulseInsightGroupEdge = {
  __typename?: 'EngagementEmployeePulseInsightGroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: EngagementEmployeePulseInsightGroup;
};

/** Engagement employee_pulse_insights aggregates */
export type EngagementEmployeePulseInsightsAggregate = {
  __typename?: 'EngagementEmployeePulseInsightsAggregate';
  average?: Maybe<EngagementEmployeePulseInsightsConnectionAggregateAverage>;
  count?: Maybe<Scalars['Int']>;
  maximum?: Maybe<EngagementEmployeePulseInsightsConnectionAggregateMaximum>;
  minimum?: Maybe<EngagementEmployeePulseInsightsConnectionAggregateMinimum>;
  sum?: Maybe<EngagementEmployeePulseInsightsConnectionAggregateSum>;
  terms?: Maybe<EngagementEmployeePulseInsightsConnectionAggregateTerms>;
};

export type EngagementEmployeePulseInsightsAggregateTerms = {
  __typename?: 'EngagementEmployeePulseInsightsAggregateTerms';
  average?: Maybe<EngagementEmployeePulseInsightsConnectionAggregateTermsAverageFields>;
  count?: Maybe<Array<Scalars['Int']>>;
  maximum?: Maybe<EngagementEmployeePulseInsightsConnectionAggregateTermsMaximumFields>;
  minimum?: Maybe<EngagementEmployeePulseInsightsConnectionAggregateTermsMinimumFields>;
  sum?: Maybe<EngagementEmployeePulseInsightsConnectionAggregateTermsSumFields>;
  values: Array<Scalars['String']>;
};

/** average function */
export type EngagementEmployeePulseInsightsConnectionAggregateAverage = {
  __typename?: 'EngagementEmployeePulseInsightsConnectionAggregateAverage';
  value?: Maybe<Scalars['Float']>;
  workspace?: Maybe<Scalars['Float']>;
};

/** maximum function */
export type EngagementEmployeePulseInsightsConnectionAggregateMaximum = {
  __typename?: 'EngagementEmployeePulseInsightsConnectionAggregateMaximum';
  value?: Maybe<Scalars['Int']>;
  workspace?: Maybe<Scalars['Int']>;
};

/** minimum function */
export type EngagementEmployeePulseInsightsConnectionAggregateMinimum = {
  __typename?: 'EngagementEmployeePulseInsightsConnectionAggregateMinimum';
  value?: Maybe<Scalars['Int']>;
  workspace?: Maybe<Scalars['Int']>;
};

/** sum function */
export type EngagementEmployeePulseInsightsConnectionAggregateSum = {
  __typename?: 'EngagementEmployeePulseInsightsConnectionAggregateSum';
  value?: Maybe<Scalars['Int']>;
  workspace?: Maybe<Scalars['Int']>;
};

/** terms function */
export type EngagementEmployeePulseInsightsConnectionAggregateTerms = {
  __typename?: 'EngagementEmployeePulseInsightsConnectionAggregateTerms';
  gender?: Maybe<EngagementEmployeePulseInsightsAggregateTerms>;
  legalEntityId?: Maybe<EngagementEmployeePulseInsightsAggregateTerms>;
  managerId?: Maybe<EngagementEmployeePulseInsightsAggregateTerms>;
  nationality?: Maybe<EngagementEmployeePulseInsightsAggregateTerms>;
  teamId?: Maybe<EngagementEmployeePulseInsightsAggregateTerms>;
  value?: Maybe<EngagementEmployeePulseInsightsAggregateTerms>;
  workspace?: Maybe<EngagementEmployeePulseInsightsAggregateTerms>;
};

/** average function */
export type EngagementEmployeePulseInsightsConnectionAggregateTermsAverageFields = {
  __typename?: 'EngagementEmployeePulseInsightsConnectionAggregateTermsAVERAGEFields';
  value?: Maybe<Array<Scalars['Float']>>;
  workspace?: Maybe<Array<Scalars['Float']>>;
};

/** maximum function */
export type EngagementEmployeePulseInsightsConnectionAggregateTermsMaximumFields = {
  __typename?: 'EngagementEmployeePulseInsightsConnectionAggregateTermsMAXIMUMFields';
  value?: Maybe<Array<Scalars['Int']>>;
  workspace?: Maybe<Array<Scalars['Int']>>;
};

/** minimum function */
export type EngagementEmployeePulseInsightsConnectionAggregateTermsMinimumFields = {
  __typename?: 'EngagementEmployeePulseInsightsConnectionAggregateTermsMINIMUMFields';
  value?: Maybe<Array<Scalars['Int']>>;
  workspace?: Maybe<Array<Scalars['Int']>>;
};

/** sum function */
export type EngagementEmployeePulseInsightsConnectionAggregateTermsSumFields = {
  __typename?: 'EngagementEmployeePulseInsightsConnectionAggregateTermsSUMFields';
  value?: Maybe<Array<Scalars['Int']>>;
  workspace?: Maybe<Array<Scalars['Int']>>;
};

/** Employee pulse medians */
export type EngagementEmployeePulseMedian = {
  __typename?: 'EngagementEmployeePulseMedian';
  accessId: Scalars['Int'];
  id: Scalars['Int'];
  value: Scalars['Int'];
};

/** The connection type for EngagementEmployeePulseMedian. */
export type EngagementEmployeePulseMedianConnection = {
  __typename?: 'EngagementEmployeePulseMedianConnection';
  /** A list of edges. */
  edges: Array<EngagementEmployeePulseMedianEdge>;
  /** A list of nodes. */
  nodes: Array<EngagementEmployeePulseMedian>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type EngagementEmployeePulseMedianEdge = {
  __typename?: 'EngagementEmployeePulseMedianEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: EngagementEmployeePulseMedian;
};

/** Engagement employee_pulse_summaries aggregates */
export type EngagementEmployeePulseSummariesAggregate = {
  __typename?: 'EngagementEmployeePulseSummariesAggregate';
  average?: Maybe<EngagementEmployeePulseSummariesConnectionAggregateAverage>;
  count?: Maybe<Scalars['Int']>;
  maximum?: Maybe<EngagementEmployeePulseSummariesConnectionAggregateMaximum>;
  minimum?: Maybe<EngagementEmployeePulseSummariesConnectionAggregateMinimum>;
  sum?: Maybe<EngagementEmployeePulseSummariesConnectionAggregateSum>;
  terms?: Maybe<EngagementEmployeePulseSummariesConnectionAggregateTerms>;
};

export type EngagementEmployeePulseSummariesAggregateTerms = {
  __typename?: 'EngagementEmployeePulseSummariesAggregateTerms';
  average?: Maybe<EngagementEmployeePulseSummariesConnectionAggregateTermsAverageFields>;
  count?: Maybe<Array<Scalars['Int']>>;
  maximum?: Maybe<EngagementEmployeePulseSummariesConnectionAggregateTermsMaximumFields>;
  minimum?: Maybe<EngagementEmployeePulseSummariesConnectionAggregateTermsMinimumFields>;
  sum?: Maybe<EngagementEmployeePulseSummariesConnectionAggregateTermsSumFields>;
  values: Array<Scalars['String']>;
};

/** average function */
export type EngagementEmployeePulseSummariesConnectionAggregateAverage = {
  __typename?: 'EngagementEmployeePulseSummariesConnectionAggregateAverage';
  value?: Maybe<Scalars['Float']>;
};

/** maximum function */
export type EngagementEmployeePulseSummariesConnectionAggregateMaximum = {
  __typename?: 'EngagementEmployeePulseSummariesConnectionAggregateMaximum';
  value?: Maybe<Scalars['Int']>;
};

/** minimum function */
export type EngagementEmployeePulseSummariesConnectionAggregateMinimum = {
  __typename?: 'EngagementEmployeePulseSummariesConnectionAggregateMinimum';
  value?: Maybe<Scalars['Int']>;
};

/** sum function */
export type EngagementEmployeePulseSummariesConnectionAggregateSum = {
  __typename?: 'EngagementEmployeePulseSummariesConnectionAggregateSum';
  value?: Maybe<Scalars['Int']>;
};

/** terms function */
export type EngagementEmployeePulseSummariesConnectionAggregateTerms = {
  __typename?: 'EngagementEmployeePulseSummariesConnectionAggregateTerms';
  fullName?: Maybe<EngagementEmployeePulseSummariesAggregateTerms>;
  submittedDate?: Maybe<EngagementEmployeePulseSummariesAggregateTerms>;
  value?: Maybe<EngagementEmployeePulseSummariesAggregateTerms>;
};


/** terms function */
export type EngagementEmployeePulseSummariesConnectionAggregateTermsSubmittedDateArgs = {
  period?: InputMaybe<GroupByDateFieldsPeriods>;
};

/** average function */
export type EngagementEmployeePulseSummariesConnectionAggregateTermsAverageFields = {
  __typename?: 'EngagementEmployeePulseSummariesConnectionAggregateTermsAVERAGEFields';
  value?: Maybe<Array<Scalars['Float']>>;
};

/** maximum function */
export type EngagementEmployeePulseSummariesConnectionAggregateTermsMaximumFields = {
  __typename?: 'EngagementEmployeePulseSummariesConnectionAggregateTermsMAXIMUMFields';
  value?: Maybe<Array<Scalars['Int']>>;
};

/** minimum function */
export type EngagementEmployeePulseSummariesConnectionAggregateTermsMinimumFields = {
  __typename?: 'EngagementEmployeePulseSummariesConnectionAggregateTermsMINIMUMFields';
  value?: Maybe<Array<Scalars['Int']>>;
};

/** sum function */
export type EngagementEmployeePulseSummariesConnectionAggregateTermsSumFields = {
  __typename?: 'EngagementEmployeePulseSummariesConnectionAggregateTermsSUMFields';
  value?: Maybe<Array<Scalars['Int']>>;
};

/** employee_pulse_summary */
export type EngagementEmployeePulseSummary = {
  __typename?: 'EngagementEmployeePulseSummary';
  access?: Maybe<ApiCoreAccess>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  accessId: Scalars['Int'];
  comment?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  fullName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  /** When the pulse was submitted. */
  submittedDate?: Maybe<Scalars['ISO8601DateTime']>;
  tags: Array<EngagementPulseTag>;
  tagsConnection: EngagementPulseTagConnection;
  updatedAt: Scalars['ISO8601DateTime'];
  value: Scalars['Int'];
};


/** employee_pulse_summary */
export type EngagementEmployeePulseSummaryAccessArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** employee_pulse_summary */
export type EngagementEmployeePulseSummaryTagsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** employee_pulse_summary */
export type EngagementEmployeePulseSummaryTagsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for EngagementEmployeePulseSummary. */
export type EngagementEmployeePulseSummaryConnection = {
  __typename?: 'EngagementEmployeePulseSummaryConnection';
  aggregate?: Maybe<EngagementEmployeePulseSummariesAggregate>;
  /** A list of edges. */
  edges: Array<EngagementEmployeePulseSummaryEdge>;
  /** A list of nodes. */
  nodes: Array<EngagementEmployeePulseSummary>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type EngagementEmployeePulseSummaryEdge = {
  __typename?: 'EngagementEmployeePulseSummaryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: EngagementEmployeePulseSummary;
};

/** the filter for the employee_pulse_summaries resource */
export type EngagementEmployeePulseSummaryFilter = {
  managerId?: InputMaybe<IntegerFilter>;
  or?: InputMaybe<Array<EngagementEmployeePulseSummaryFilterConditions>>;
  submittedDate?: InputMaybe<DateTimeFilter>;
  tag?: InputMaybe<StringFilter>;
  teamId?: InputMaybe<IntegerFilter>;
  value?: InputMaybe<IntegerFilter>;
};

export type EngagementEmployeePulseSummaryFilterConditions = {
  managerId?: InputMaybe<IntegerFilter>;
  submittedDate?: InputMaybe<DateTimeFilter>;
  tag?: InputMaybe<StringFilter>;
  teamId?: InputMaybe<IntegerFilter>;
  value?: InputMaybe<IntegerFilter>;
};

/** Employee pulse topic insights */
export type EngagementEmployeePulseTopicInsight = {
  __typename?: 'EngagementEmployeePulseTopicInsight';
  categories: Array<Scalars['String']>;
  id: Scalars['String'];
  series: Array<Scalars['Int']>;
  topicName: Scalars['String'];
};

/** The connection type for EngagementEmployeePulseTopicInsight. */
export type EngagementEmployeePulseTopicInsightConnection = {
  __typename?: 'EngagementEmployeePulseTopicInsightConnection';
  /** A list of edges. */
  edges: Array<EngagementEmployeePulseTopicInsightEdge>;
  /** A list of nodes. */
  nodes: Array<EngagementEmployeePulseTopicInsight>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type EngagementEmployeePulseTopicInsightEdge = {
  __typename?: 'EngagementEmployeePulseTopicInsightEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: EngagementEmployeePulseTopicInsight;
};

/** Engagement employee_pulses aggregates */
export type EngagementEmployeePulsesAggregate = {
  __typename?: 'EngagementEmployeePulsesAggregate';
  average?: Maybe<EngagementEmployeePulsesConnectionAggregateAverage>;
  count?: Maybe<Scalars['Int']>;
  maximum?: Maybe<EngagementEmployeePulsesConnectionAggregateMaximum>;
  minimum?: Maybe<EngagementEmployeePulsesConnectionAggregateMinimum>;
  sum?: Maybe<EngagementEmployeePulsesConnectionAggregateSum>;
  terms?: Maybe<EngagementEmployeePulsesConnectionAggregateTerms>;
};

export type EngagementEmployeePulsesAggregateTerms = {
  __typename?: 'EngagementEmployeePulsesAggregateTerms';
  average?: Maybe<EngagementEmployeePulsesConnectionAggregateTermsAverageFields>;
  count?: Maybe<Array<Scalars['Int']>>;
  maximum?: Maybe<EngagementEmployeePulsesConnectionAggregateTermsMaximumFields>;
  minimum?: Maybe<EngagementEmployeePulsesConnectionAggregateTermsMinimumFields>;
  sum?: Maybe<EngagementEmployeePulsesConnectionAggregateTermsSumFields>;
  values: Array<Scalars['String']>;
};

/** average function */
export type EngagementEmployeePulsesConnectionAggregateAverage = {
  __typename?: 'EngagementEmployeePulsesConnectionAggregateAverage';
  value?: Maybe<Scalars['Float']>;
};

/** maximum function */
export type EngagementEmployeePulsesConnectionAggregateMaximum = {
  __typename?: 'EngagementEmployeePulsesConnectionAggregateMaximum';
  value?: Maybe<Scalars['Int']>;
};

/** minimum function */
export type EngagementEmployeePulsesConnectionAggregateMinimum = {
  __typename?: 'EngagementEmployeePulsesConnectionAggregateMinimum';
  value?: Maybe<Scalars['Int']>;
};

/** sum function */
export type EngagementEmployeePulsesConnectionAggregateSum = {
  __typename?: 'EngagementEmployeePulsesConnectionAggregateSum';
  value?: Maybe<Scalars['Int']>;
};

/** terms function */
export type EngagementEmployeePulsesConnectionAggregateTerms = {
  __typename?: 'EngagementEmployeePulsesConnectionAggregateTerms';
  fullName?: Maybe<EngagementEmployeePulsesAggregateTerms>;
  submittedDate?: Maybe<EngagementEmployeePulsesAggregateTerms>;
  value?: Maybe<EngagementEmployeePulsesAggregateTerms>;
};


/** terms function */
export type EngagementEmployeePulsesConnectionAggregateTermsSubmittedDateArgs = {
  period?: InputMaybe<GroupByDateFieldsPeriods>;
};

/** average function */
export type EngagementEmployeePulsesConnectionAggregateTermsAverageFields = {
  __typename?: 'EngagementEmployeePulsesConnectionAggregateTermsAVERAGEFields';
  value?: Maybe<Array<Scalars['Float']>>;
};

/** maximum function */
export type EngagementEmployeePulsesConnectionAggregateTermsMaximumFields = {
  __typename?: 'EngagementEmployeePulsesConnectionAggregateTermsMAXIMUMFields';
  value?: Maybe<Array<Scalars['Int']>>;
};

/** minimum function */
export type EngagementEmployeePulsesConnectionAggregateTermsMinimumFields = {
  __typename?: 'EngagementEmployeePulsesConnectionAggregateTermsMINIMUMFields';
  value?: Maybe<Array<Scalars['Int']>>;
};

/** sum function */
export type EngagementEmployeePulsesConnectionAggregateTermsSumFields = {
  __typename?: 'EngagementEmployeePulsesConnectionAggregateTermsSUMFields';
  value?: Maybe<Array<Scalars['Int']>>;
};

/** Engagement insights climate survey insight */
export type EngagementInsightsClimateSurveyInsight = {
  __typename?: 'EngagementInsightsClimateSurveyInsight';
  enoughAnswers: Scalars['Boolean'];
  formId: Scalars['Int'];
  formStartOn: Scalars['String'];
  formStatus: Scalars['String'];
  participants: Scalars['Int'];
  respondents: Scalars['Int'];
  score?: Maybe<Scalars['Float']>;
  surveyCategoryScores: Array<EngagementInsightsSurveyCategoryScore>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for EngagementInsightsClimateSurveyInsight. */
export type EngagementInsightsClimateSurveyInsightConnection = {
  __typename?: 'EngagementInsightsClimateSurveyInsightConnection';
  /** A list of edges. */
  edges: Array<EngagementInsightsClimateSurveyInsightEdge>;
  /** A list of nodes. */
  nodes: Array<EngagementInsightsClimateSurveyInsight>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type EngagementInsightsClimateSurveyInsightEdge = {
  __typename?: 'EngagementInsightsClimateSurveyInsightEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: EngagementInsightsClimateSurveyInsight;
};

export type EngagementInsightsContextlessPolicies = {
  __typename?: 'EngagementInsightsContextlessPolicies';
  sidebarSeeEngagementInsightsSubLevelItem: ContextlessPolicyResolution;
  sidebarSeeEngagementTopLevelItem: ContextlessPolicyResolution;
};

/** Engagement insights enps insight */
export type EngagementInsightsEnpsInsight = {
  __typename?: 'EngagementInsightsEnpsInsight';
  detractors?: Maybe<Scalars['Int']>;
  enoughAnswers: Scalars['Boolean'];
  formId: Scalars['Int'];
  formStartOn: Scalars['String'];
  formStatus: Scalars['String'];
  participants: Scalars['Int'];
  passives?: Maybe<Scalars['Int']>;
  promoters?: Maybe<Scalars['Int']>;
  respondents: Scalars['Int'];
  score?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for EngagementInsightsEnpsInsight. */
export type EngagementInsightsEnpsInsightConnection = {
  __typename?: 'EngagementInsightsEnpsInsightConnection';
  /** A list of edges. */
  edges: Array<EngagementInsightsEnpsInsightEdge>;
  /** A list of nodes. */
  nodes: Array<EngagementInsightsEnpsInsight>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type EngagementInsightsEnpsInsightEdge = {
  __typename?: 'EngagementInsightsEnpsInsightEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: EngagementInsightsEnpsInsight;
};

export type EngagementInsightsSurveyCategoryScore = {
  __typename?: 'EngagementInsightsSurveyCategoryScore';
  name: Scalars['String'];
  score?: Maybe<Scalars['Float']>;
};

/** pulse_tag */
export type EngagementPulseTag = {
  __typename?: 'EngagementPulseTag';
  categoryDescription: Scalars['String'];
  categoryName: Scalars['String'];
  employeePulseId: Scalars['Int'];
  explanation: Scalars['String'];
  id: Scalars['Int'];
  key: Scalars['String'];
  quote: Scalars['String'];
  signalDescription: Scalars['String'];
  signalName: Scalars['String'];
};

/** The connection type for EngagementPulseTag. */
export type EngagementPulseTagConnection = {
  __typename?: 'EngagementPulseTagConnection';
  /** A list of edges. */
  edges: Array<EngagementPulseTagEdge>;
  /** A list of nodes. */
  nodes: Array<EngagementPulseTag>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type EngagementPulseTagEdge = {
  __typename?: 'EngagementPulseTagEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: EngagementPulseTag;
};

/** Settings for the engagement module */
export type EngagementSetting = {
  __typename?: 'EngagementSetting';
  days?: Maybe<Array<EngagementSettingDaysEnum>>;
  employeePulseEnabled: Scalars['Boolean'];
  frequency?: Maybe<EngagementSettingFrequencyEnum>;
  id: Scalars['Int'];
  question?: Maybe<Scalars['String']>;
  questionType?: Maybe<EngagementSettingQuestionTypeEnum>;
};

/** The connection type for EngagementSetting. */
export type EngagementSettingConnection = {
  __typename?: 'EngagementSettingConnection';
  /** A list of edges. */
  edges: Array<EngagementSettingEdge>;
  /** A list of nodes. */
  nodes: Array<EngagementSetting>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type EngagementSettingDaysEnum =
  | 'friday'
  | 'monday'
  | 'saturday'
  | 'sunday'
  | 'thursday'
  | 'tuesday'
  | 'wednesday';

/** An edge in a connection. */
export type EngagementSettingEdge = {
  __typename?: 'EngagementSettingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: EngagementSetting;
};

export type EngagementSettingFrequencyEnum =
  | 'daily'
  | 'specificdays';

export type EngagementSettingQuestionTypeEnum =
  | 'custom'
  | 'daily_question'
  | 'weekly_question';

export type EnpsContextlessPolicies = {
  __typename?: 'EnpsContextlessPolicies';
  createForms: ContextlessPolicyResolution;
  manageEnps: ContextlessPolicyResolution;
  sidebarSeeEngagementEnpsSubLevelItem: ContextlessPolicyResolution;
};

/** Autogenerated return type of EnqueueCompanyJobsForPublishingIntegrationsjoinJobPosting. */
export type EnqueueCompanyJobsForPublishingIntegrationsjoinJobPostingPayload = {
  __typename?: 'EnqueueCompanyJobsForPublishingIntegrationsjoinJobPostingPayload';
  errors: Array<MutationError>;
  jobPosting?: Maybe<IntegrationsJoinJobPosting>;
};

export type Enum =
  | 'archived'
  | 'cancelled'
  | 'draft'
  | 'published'
  | 'unlisted';

/** Esignature requests */
export type EsignatureRequest = {
  __typename?: 'EsignatureRequest';
  createdAt: Scalars['ISO8601DateTime'];
  documentId: Scalars['Int'];
  id: Scalars['Int'];
  requester?: Maybe<ApiCoreAccess>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  requesterId: Scalars['Int'];
  signee: ApiCoreAccess;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  signeeId: Scalars['Int'];
};


/** Esignature requests */
export type EsignatureRequestRequesterArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** Esignature requests */
export type EsignatureRequestSigneeArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for EsignatureRequest. */
export type EsignatureRequestConnection = {
  __typename?: 'EsignatureRequestConnection';
  /** A list of edges. */
  edges: Array<EsignatureRequestEdge>;
  /** A list of nodes. */
  nodes: Array<EsignatureRequest>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type EsignatureRequestEdge = {
  __typename?: 'EsignatureRequestEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: EsignatureRequest;
};

/** Esignature signatures */
export type EsignatureSignature = {
  __typename?: 'EsignatureSignature';
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  accessId: Scalars['Int'];
  bounced: Scalars['Boolean'];
  data?: Maybe<Scalars['String']>;
  declined: Scalars['Boolean'];
  document?: Maybe<DocumentsDocument>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  documentId: Scalars['Int'];
  folder?: Maybe<DocumentsFolder>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  folderId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  pending: Scalars['Boolean'];
  registeredAt?: Maybe<Scalars['ISO8601DateTime']>;
  remoteUrl?: Maybe<Scalars['String']>;
  signed: Scalars['Boolean'];
  signee: ApiCoreAccess;
  status: Scalars['String'];
};


/** Esignature signatures */
export type EsignatureSignatureDocumentArgs = {
  afterDate?: InputMaybe<Scalars['ISO8601Date']>;
  beforeDate?: InputMaybe<Scalars['ISO8601Date']>;
  byBookkeeperDocuments?: InputMaybe<Scalars['Boolean']>;
  byPendingAssignment?: Scalars['Boolean'];
  byTrashBin?: Scalars['Boolean'];
  byWithoutFolder?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['Int']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  excludedType?: InputMaybe<Scalars['String']>;
  folderId?: InputMaybe<Scalars['Int']>;
  fromEmployees?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  incidenceId?: InputMaybe<Scalars['Int']>;
  includeTrashBin?: InputMaybe<Scalars['Boolean']>;
  leaveId?: InputMaybe<Scalars['Int']>;
  payrollHiringId?: InputMaybe<Scalars['Int']>;
  relationships?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  sort?: Scalars['String'];
  space?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};


/** Esignature signatures */
export type EsignatureSignatureFolderArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  ascendantFolderId?: InputMaybe<Scalars['Int']>;
  billingSubscriptionAddonId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['Int']>;
  descendantFolderId?: InputMaybe<Scalars['Int']>;
  employee?: InputMaybe<Scalars['Boolean']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  mobileRequest?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  parentFolderId?: InputMaybe<Scalars['Int']>;
  parentFolderIds?: InputMaybe<Array<Scalars['Int']>>;
  rootFolders?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Scalars['String']>;
  space?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  withCounters?: InputMaybe<Scalars['Boolean']>;
  withUnfilteredCounters?: InputMaybe<Scalars['Boolean']>;
};


/** Esignature signatures */
export type EsignatureSignatureSigneeArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for EsignatureSignature. */
export type EsignatureSignatureConnection = {
  __typename?: 'EsignatureSignatureConnection';
  /** A list of edges. */
  edges: Array<EsignatureSignatureEdge>;
  /** A list of nodes. */
  nodes: Array<EsignatureSignature>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type EsignatureSignatureEdge = {
  __typename?: 'EsignatureSignatureEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: EsignatureSignature;
};

/** Autogenerated return type of EstimatePerformanceReviewEvaluationEstimatedScore. */
export type EstimatePerformanceReviewEvaluationEstimatedScorePayload = {
  __typename?: 'EstimatePerformanceReviewEvaluationEstimatedScorePayload';
  errors: Array<MutationError>;
  reviewEvaluationEstimatedScore?: Maybe<PerformanceReviewEvaluationEstimatedScore>;
};

export type ExpensablesByResourcesInput = {
  id: Scalars['Int'];
  resourceType: Scalars['String'];
};

/** Represents a timeline of an expense approval flow */
export type ExpensesApprovalsTimeline = {
  __typename?: 'ExpensesApprovalsTimeline';
  entries: Array<ApprovalsV2ApprovalTimelineEntry>;
  expensableId: Scalars['Int'];
};

/** The connection type for ExpensesApprovalsTimeline. */
export type ExpensesApprovalsTimelineConnection = {
  __typename?: 'ExpensesApprovalsTimelineConnection';
  /** A list of edges. */
  edges: Array<ExpensesApprovalsTimelineEdge>;
  /** A list of nodes. */
  nodes: Array<ExpensesApprovalsTimeline>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ExpensesApprovalsTimelineEdge = {
  __typename?: 'ExpensesApprovalsTimelineEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ExpensesApprovalsTimeline;
};

/** Factorial card records */
export type ExpensesCard = {
  __typename?: 'ExpensesCard';
  approvalFlowId?: Maybe<Scalars['Int']>;
  approvalStatus?: Maybe<Scalars['String']>;
  cardAlias?: Maybe<Scalars['String']>;
  cardType: ExpensesValueObjectsCardTypeEnum;
  cardholder: BankingCardholder;
  createdAt: Scalars['ISO8601DateTime'];
  currency: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  details?: Maybe<ExpensesCardDetails>;
  expMonth: Scalars['Int'];
  expYear: Scalars['Int'];
  expensesAccountExternalId: Scalars['String'];
  expensesAccountId: Scalars['Int'];
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  expensesCardholderId: Scalars['Int'];
  externalId: Scalars['String'];
  fullName: Scalars['String'];
  id: Scalars['Int'];
  last4?: Maybe<Scalars['String']>;
  monthlyLimit?: Maybe<Scalars['Int']>;
  ownerId: Scalars['Int'];
  ownerType: Scalars['String'];
  pending: Scalars['Boolean'];
  phoneNumber: Scalars['String'];
  provider: Scalars['String'];
  rejectionReason?: Maybe<Scalars['String']>;
  requested: Scalars['Boolean'];
  shippingAddress?: Maybe<ExpensesShippingAddress>;
  shippingCarrier?: Maybe<Scalars['String']>;
  shippingSentAt?: Maybe<Scalars['ISO8601DateTime']>;
  shippingStatus?: Maybe<Scalars['String']>;
  shippingTrackingNumber?: Maybe<Scalars['String']>;
  shippingTrackingUrl?: Maybe<Scalars['String']>;
  softwareName?: Maybe<Scalars['String']>;
  spendingControls?: Maybe<ExpensesSpendingControl>;
  spendingLimit?: Maybe<ExpensesSpendingLimit>;
  status: Scalars['String'];
};


/** Factorial card records */
export type ExpensesCardCardholderArgs = {
  bankAccountIds?: InputMaybe<Array<Scalars['Int']>>;
  creationSource?: InputMaybe<BankingValueObjectsCardCreationSourceEnum>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
};

/** The connection type for ExpensesCard. */
export type ExpensesCardConnection = {
  __typename?: 'ExpensesCardConnection';
  /** A list of edges. */
  edges: Array<ExpensesCardEdge>;
  /** A list of nodes. */
  nodes: Array<ExpensesCard>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ExpensesCardDetails = {
  __typename?: 'ExpensesCardDetails';
  id: Scalars['Int'];
  spentDuringCurentPeriod?: Maybe<Scalars['Int']>;
  spentThisMonth?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ExpensesCardEdge = {
  __typename?: 'ExpensesCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ExpensesCard;
};

export type ExpensesCardWithoutSensitiveInfo = {
  __typename?: 'ExpensesCardWithoutSensitiveInfo';
  cardType: Scalars['String'];
  last4?: Maybe<Scalars['String']>;
};

/** Expenses category */
export type ExpensesCategory = {
  __typename?: 'ExpensesCategory';
  id: Scalars['String'];
  label: Scalars['String'];
  mcc?: Maybe<Array<Scalars['String']>>;
};

/** The connection type for ExpensesCategory. */
export type ExpensesCategoryConnection = {
  __typename?: 'ExpensesCategoryConnection';
  /** A list of edges. */
  edges: Array<ExpensesCategoryEdge>;
  /** A list of nodes. */
  nodes: Array<ExpensesCategory>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ExpensesCategoryEdge = {
  __typename?: 'ExpensesCategoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ExpensesCategory;
};

/** Closing period records */
export type ExpensesClosingPeriod = {
  __typename?: 'ExpensesClosingPeriod';
  closeFrom: Scalars['ISO8601Date'];
  closeTo: Scalars['ISO8601Date'];
  id: Scalars['Int'];
  legalEntityId: Scalars['Int'];
  securityHash: Scalars['String'];
};

/** The connection type for ExpensesClosingPeriod. */
export type ExpensesClosingPeriodConnection = {
  __typename?: 'ExpensesClosingPeriodConnection';
  /** A list of edges. */
  edges: Array<ExpensesClosingPeriodEdge>;
  /** A list of nodes. */
  nodes: Array<ExpensesClosingPeriod>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ExpensesClosingPeriodEdge = {
  __typename?: 'ExpensesClosingPeriodEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ExpensesClosingPeriod;
};

/** Closing period frequency records */
export type ExpensesClosingPeriodFrequency = {
  __typename?: 'ExpensesClosingPeriodFrequency';
  companyId: Scalars['Int'];
  frequency: ExpensesValueObjectsClosingPeriodFrequenciesEnum;
  id: Scalars['Int'];
  legalEntityId: Scalars['Int'];
  organization: ExpensesValueObjectsTaxAgencyOrganizationsEnum;
};

/** The connection type for ExpensesClosingPeriodFrequency. */
export type ExpensesClosingPeriodFrequencyConnection = {
  __typename?: 'ExpensesClosingPeriodFrequencyConnection';
  /** A list of edges. */
  edges: Array<ExpensesClosingPeriodFrequencyEdge>;
  /** A list of nodes. */
  nodes: Array<ExpensesClosingPeriodFrequency>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ExpensesClosingPeriodFrequencyEdge = {
  __typename?: 'ExpensesClosingPeriodFrequencyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ExpensesClosingPeriodFrequency;
};

/** Represents per diem rates defined for a company */
export type ExpensesCompanyPerDiemRate = {
  __typename?: 'ExpensesCompanyPerDiemRate';
  amountFullCents?: Maybe<Scalars['Int']>;
  amountOvernightCents?: Maybe<Scalars['Int']>;
  amountPartialCents?: Maybe<Scalars['Int']>;
  companyId: Scalars['Int'];
  id?: Maybe<Scalars['Int']>;
  officialPerDiemRateId?: Maybe<Scalars['Int']>;
  validFrom: Scalars['ISO8601Date'];
  validTo?: Maybe<Scalars['ISO8601Date']>;
};

/** The connection type for ExpensesCompanyPerDiemRate. */
export type ExpensesCompanyPerDiemRateConnection = {
  __typename?: 'ExpensesCompanyPerDiemRateConnection';
  /** A list of edges. */
  edges: Array<ExpensesCompanyPerDiemRateEdge>;
  /** A list of nodes. */
  nodes: Array<ExpensesCompanyPerDiemRate>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ExpensesCompanyPerDiemRateEdge = {
  __typename?: 'ExpensesCompanyPerDiemRateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ExpensesCompanyPerDiemRate;
};

export type ExpensesContextlessPolicies = {
  __typename?: 'ExpensesContextlessPolicies';
  cardManageCards: ContextlessPolicyResolution;
  cardRequestSingleUseCards: ContextlessPolicyResolution;
  expenseCreateExpenses: ContextlessPolicyResolution;
  expenseCreateExpensesForOthers: ContextlessPolicyResolution;
  expenseCustomizeSettings: ContextlessPolicyResolution;
  expenseManageExpensables: ContextlessPolicyResolution;
  expenseManageExpenses: ContextlessPolicyResolution;
  expenseOverrideApprovalFlow: ContextlessPolicyResolution;
  expenseRestartApprovalFlow: ContextlessPolicyResolution;
  expenseSeeEmployeeLegalEntity: ContextlessPolicyResolution;
  expenseSendToReimburseThroughPayments: ContextlessPolicyResolution;
  expenseSendToReimburseThroughPayroll: ContextlessPolicyResolution;
  expenseSetToPaid: ContextlessPolicyResolution;
  internalExpenseViewerEnabledContextless: ContextlessPolicyResolution;
  recommendationsEnabledContextless: ContextlessPolicyResolution;
  settingsSeeExpensesSettings: ContextlessPolicyResolution;
  sidebarSeeExpensesBudgetsSubLevelItem: ContextlessPolicyResolution;
  sidebarSeeExpensesExpensesSubLevelItem: ContextlessPolicyResolution;
  sidebarSeeExpensesProcurementPurchaseOrderSubLevelItem: ContextlessPolicyResolution;
  sidebarSeeExpensesProcurementPurchaseRequestSubLevelItem: ContextlessPolicyResolution;
  sidebarSeeExpensesReportsSubLevelItem: ContextlessPolicyResolution;
  sidebarSeeExpensesSpendingPoliciesSubLevelItem: ContextlessPolicyResolution;
  sidebarSeeExpensesSubModule: ContextlessPolicyResolution;
  sidebarSeeExpensesTopLevelItem: ContextlessPolicyResolution;
  sidebarSeeMyExpensesMyCardsSubLevelItem: ContextlessPolicyResolution;
  sidebarSeeMyExpensesMyExpensesSubLevelItem: ContextlessPolicyResolution;
  sidebarSeeMyExpensesTopLevelItem: ContextlessPolicyResolution;
};

export type ExpensesCustomizationConfigFieldTypeEnum =
  | 'cents'
  | 'date'
  | 'file'
  | 'long_text'
  | 'single_choice'
  | 'tax_type'
  | 'text';

export type ExpensesCustomizationConfigResourceTypeEnum =
  | 'expense'
  | 'mileage'
  | 'perdiem';

export type ExpensesCustomizationExpenseTaxesTypesEnum =
  | 'vat';

/** Customizate fields for the expenses forms */
export type ExpensesCustomizationField = {
  __typename?: 'ExpensesCustomizationField';
  documentType: ExpensesValueObjectsCustomizationDocumentTypeEnum;
  editableEnabled: Scalars['Boolean'];
  editableMandatory: Scalars['Boolean'];
  editableOptions: Scalars['Boolean'];
  enabled: Scalars['Boolean'];
  fieldType: ExpensesCustomizationConfigFieldTypeEnum;
  id: Scalars['String'];
  identifier: Scalars['String'];
  mandatory: Scalars['Boolean'];
  options: Scalars['String'];
  resourceType: ExpensesCustomizationConfigResourceTypeEnum;
  upgradeRequired: Scalars['Boolean'];
};

/** The connection type for ExpensesCustomizationField. */
export type ExpensesCustomizationFieldConnection = {
  __typename?: 'ExpensesCustomizationFieldConnection';
  /** A list of edges. */
  edges: Array<ExpensesCustomizationFieldEdge>;
  /** A list of nodes. */
  nodes: Array<ExpensesCustomizationField>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ExpensesCustomizationFieldEdge = {
  __typename?: 'ExpensesCustomizationFieldEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ExpensesCustomizationField;
};

export type ExpensesDtosRateConfigurationPeopleGroupStrategyEnum =
  | 'legal_entities'
  | 'manual_selection';

export type ExpensesDtosSignedInvoicesExportFormatsEnum =
  | 'csv'
  | 'xlsx';

export type ExpensesEntitiesExpensableReimbursementMethodEnum =
  | 'payroll'
  | 'sepa_transfer'
  | 'unknown';

export type ExpensesEntitiesExpensableResourceTypeEnum =
  | 'expense'
  | 'mileage'
  | 'perdiem';

export type ExpensesEntitiesExpensableStatusEnum =
  | 'approved'
  | 'changes_requested'
  | 'draft'
  | 'in_payroll'
  | 'paid'
  | 'pending'
  | 'rejected'
  | 'reversed'
  | 'sent_to_pay';

export type ExpensesEntitiesExpenseCreationTypeEnum =
  | 'automatic'
  | 'manual'
  | 'travelperk';

/** Represents an expensable resource, which can be a regular expense or a mileage expense. */
export type ExpensesExpensable = {
  __typename?: 'ExpensesExpensable';
  _policies?: Maybe<ExpensesExpensablePolicies>;
  _policiesCollection?: Maybe<Array<PermissionsPolicyResolution>>;
  _policiesConnection: PermissionsPolicyResolutionConnection;
  /** The optional amount in cents */
  amount?: Maybe<Scalars['BigInt']>;
  approvalFlowReason?: Maybe<Scalars['String']>;
  approvalProcess?: Maybe<ApprovalsV2ApprovalProcess>;
  approvalStepApproverId?: Maybe<Scalars['Int']>;
  /** The id of the budget */
  budgetId?: Maybe<Scalars['Int']>;
  bugdetMovement?: Maybe<FinanceBudgetMovement>;
  comments: Array<CommentsComment>;
  commentsConnection: CommentsCommentConnection;
  company: ApiCoreCompany;
  /**
   * The ID of the company that owns the expensable
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  companyId: Scalars['Int'];
  compensation?: Maybe<CompensationsEmployeesCompensation>;
  costCenterDistribution: Array<CostCentersDistribution>;
  costCenterDistributionConnection: CostCentersDistributionConnection;
  /** The ids of the cost centers */
  costCenterIds: Array<Scalars['Int']>;
  /** The date and time when the expensable was created */
  createdAt: Scalars['ISO8601DateTime'];
  creationSource?: Maybe<Scalars['String']>;
  /** The currency code in ISO 4217 format */
  currency: Scalars['String'];
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  currentApproverIds?: Maybe<Array<Scalars['Int']>>;
  currentApprovers: Array<ApiCoreAccess>;
  currentApproversConnection: ApiCoreAccessConnection;
  currentUserApprovalStatus?: Maybe<Scalars['String']>;
  /** The optional description of the expensable */
  description?: Maybe<Scalars['String']>;
  /** The optional date and time when the expensable was effective */
  effectiveOn?: Maybe<Scalars['ISO8601DateTime']>;
  /**
   * The ID of the employee that owns the expensable
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  employeeId: Scalars['Int'];
  expensableGroup?: Maybe<ExpensesExpensableGroup>;
  expense?: Maybe<ExpensesExpense>;
  /**
   * The optional ID of the expense that the expensable belongs to
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  expenseId?: Maybe<Scalars['Int']>;
  /**
   * The optional ID of the group that the expensable belongs to
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  groupId?: Maybe<Scalars['Int']>;
  /** Unique identifier for the expensable */
  id: Scalars['Int'];
  /** The optional internal reference of the expensable */
  internalReference?: Maybe<Scalars['String']>;
  /** The optional ID of the legal entity that the expensable belongs to */
  legalEntityId?: Maybe<Scalars['Int']>;
  materializedApprovalFlowId?: Maybe<Scalars['Int']>;
  materializedStepApproverId?: Maybe<Scalars['Int']>;
  mileage?: Maybe<ExpensesMileage>;
  /** The optional ID of the mileage that the expensable belongs to */
  mileageId?: Maybe<Scalars['Int']>;
  owner?: Maybe<EmployeesEmployee>;
  /** The optional date and time when the expensable was set as paid */
  paidAt?: Maybe<Scalars['ISO8601DateTime']>;
  perDiem?: Maybe<ExpensesPerDiem>;
  /** The optional ID of the per_diem that the expensable belongs to */
  perDiemId?: Maybe<Scalars['Int']>;
  preview?: Maybe<ExpensesFile>;
  /** The id of the project */
  projectId?: Maybe<Scalars['Int']>;
  projects: Array<ProjectManagementExpenseRecord>;
  projectsConnection: ProjectManagementExpenseRecordConnection;
  readyToReviewIssues?: Maybe<ExpensesExpensableReadyToReviewIssue>;
  /** The optional reimbursable amount in cents */
  reimbursableAmount?: Maybe<Scalars['BigInt']>;
  /** The optional reimbursable currency code in ISO 4217 format */
  reimbursableCurrency?: Maybe<Scalars['String']>;
  /** The optional reimbursement method */
  reimbursementMethod?: Maybe<ExpensesEntitiesExpensableReimbursementMethodEnum>;
  reporter?: Maybe<EmployeesEmployee>;
  /**
   * The optional ID of the employee that reported the expensable
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  reporterId?: Maybe<Scalars['Int']>;
  /** The optional date and time when the expensable was requested for review */
  reviewRequestAt?: Maybe<Scalars['ISO8601DateTime']>;
  spendingAlertTypes?: Maybe<Array<Scalars['String']>>;
  spendingAlertsSource: Array<FinanceSpendingAlert>;
  spendingAlertsSourceConnection: FinanceSpendingAlertConnection;
  spendingAlertsTarget: Array<FinanceSpendingAlert>;
  spendingAlertsTargetConnection: FinanceSpendingAlertConnection;
  /**
   * The status of the expensable. Can be pending, approved, paid, archived,
   * in_review, rejected, reversed, draft, or in_payroll
   */
  status: ExpensesEntitiesExpensableStatusEnum;
  /** The optional date and time when the status was last updated */
  statusUpdatedAt: Scalars['ISO8601DateTime'];
  supplement?: Maybe<PayrollSupplement>;
  syncableState: Array<IntegrationsSyncableState>;
  syncableStateConnection: IntegrationsSyncableStateConnection;
  /** Type of the expensable. Can be either "expense" or "mileage" or "perdiem" */
  type: ExpensesEntitiesExpensableResourceTypeEnum;
  /** The date and time when the expensable was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
};


/** Represents an expensable resource, which can be a regular expense or a mileage expense. */
export type ExpensesExpensable_PoliciesCollectionArgs = {
  ids: Array<ExpensesExpensablePoliciesEnum>;
};


/** Represents an expensable resource, which can be a regular expense or a mileage expense. */
export type ExpensesExpensable_PoliciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Represents an expensable resource, which can be a regular expense or a mileage expense. */
export type ExpensesExpensableApprovalProcessArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  decision?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  requesterId?: InputMaybe<Scalars['Int']>;
  useCase?: InputMaybe<Scalars['String']>;
};


/** Represents an expensable resource, which can be a regular expense or a mileage expense. */
export type ExpensesExpensableBugdetMovementArgs = {
  budgetId?: InputMaybe<Array<Scalars['Int']>>;
  budgetIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeId?: InputMaybe<Scalars['Int']>;
  excludeDrafts?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  periodEnd?: InputMaybe<Scalars['ISO8601DateTime']>;
  periodStart?: InputMaybe<Scalars['ISO8601DateTime']>;
  search?: InputMaybe<Scalars['String']>;
};


/** Represents an expensable resource, which can be a regular expense or a mileage expense. */
export type ExpensesExpensableCommentsArgs = {
  companyId: Scalars['Int'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  upToAndIncluding?: InputMaybe<Scalars['Int']>;
};


/** Represents an expensable resource, which can be a regular expense or a mileage expense. */
export type ExpensesExpensableCommentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  upToAndIncluding?: InputMaybe<Scalars['Int']>;
};


/** Represents an expensable resource, which can be a regular expense or a mileage expense. */
export type ExpensesExpensableCompensationArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  payrollConceptIds?: InputMaybe<Array<Scalars['Int']>>;
  payrollRunEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  payrollRunIds?: InputMaybe<Array<Scalars['Int']>>;
  resultType?: InputMaybe<CompensationsValueObjectsResultTypeEnum>;
};


/** Represents an expensable resource, which can be a regular expense or a mileage expense. */
export type ExpensesExpensableCostCenterDistributionArgs = {
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Represents an expensable resource, which can be a regular expense or a mileage expense. */
export type ExpensesExpensableCostCenterDistributionConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Represents an expensable resource, which can be a regular expense or a mileage expense. */
export type ExpensesExpensableCurrentApproversArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** Represents an expensable resource, which can be a regular expense or a mileage expense. */
export type ExpensesExpensableCurrentApproversConnectionArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  external?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** Represents an expensable resource, which can be a regular expense or a mileage expense. */
export type ExpensesExpensableExpensableGroupArgs = {
  byStatus?: InputMaybe<ExpensesEntitiesExpensableStatusEnum>;
  companyId?: InputMaybe<Scalars['Int']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  from?: InputMaybe<Scalars['ISO8601DateTime']>;
  includeAttachments?: Scalars['Boolean'];
  includeDrafts?: Scalars['Boolean'];
  search?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['ISO8601DateTime']>;
};


/** Represents an expensable resource, which can be a regular expense or a mileage expense. */
export type ExpensesExpensableExpenseArgs = {
  bookEntryIds?: InputMaybe<Array<Scalars['Int']>>;
  cardIds?: InputMaybe<Array<Scalars['Int']>>;
  cardPaymentIds?: InputMaybe<Array<Scalars['Int']>>;
  disputeIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  externalAuthorizationIds?: InputMaybe<Array<Scalars['String']>>;
  from?: InputMaybe<Scalars['ISO8601DateTime']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeAttachments?: Scalars['Boolean'];
  includeManualDrafts?: Scalars['Boolean'];
  to?: InputMaybe<Scalars['ISO8601DateTime']>;
};


/** Represents an expensable resource, which can be a regular expense or a mileage expense. */
export type ExpensesExpensableMileageArgs = {
  cardIds?: InputMaybe<Array<Scalars['Int']>>;
  cardPaymentIds?: InputMaybe<Array<Scalars['Int']>>;
  disputeIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  externalAuthorizationIds?: InputMaybe<Array<Scalars['String']>>;
  from?: InputMaybe<Scalars['ISO8601DateTime']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeAttachments?: Scalars['Boolean'];
  includeManualDrafts?: Scalars['Boolean'];
  to?: InputMaybe<Scalars['ISO8601DateTime']>;
};


/** Represents an expensable resource, which can be a regular expense or a mileage expense. */
export type ExpensesExpensableOwnerArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Represents an expensable resource, which can be a regular expense or a mileage expense. */
export type ExpensesExpensablePerDiemArgs = {
  employeeId?: InputMaybe<Scalars['Int']>;
  endDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  excludeDrafts?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  startDate?: InputMaybe<Scalars['ISO8601DateTime']>;
};


/** Represents an expensable resource, which can be a regular expense or a mileage expense. */
export type ExpensesExpensableProjectsArgs = {
  employeeUserNameLike?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  imputableProjectIds?: InputMaybe<Array<Scalars['Int']>>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  projectWorkerIds?: InputMaybe<Array<Scalars['Int']>>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  subprojectIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Represents an expensable resource, which can be a regular expense or a mileage expense. */
export type ExpensesExpensableProjectsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeUserNameLike?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  imputableProjectIds?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  projectWorkerIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  subprojectIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Represents an expensable resource, which can be a regular expense or a mileage expense. */
export type ExpensesExpensableReporterArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Represents an expensable resource, which can be a regular expense or a mileage expense. */
export type ExpensesExpensableSpendingAlertsSourceArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  expensableIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeDiscarded?: InputMaybe<Scalars['Boolean']>;
};


/** Represents an expensable resource, which can be a regular expense or a mileage expense. */
export type ExpensesExpensableSpendingAlertsSourceConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
  expensableIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeDiscarded?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Represents an expensable resource, which can be a regular expense or a mileage expense. */
export type ExpensesExpensableSpendingAlertsTargetArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  expensableIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeDiscarded?: InputMaybe<Scalars['Boolean']>;
};


/** Represents an expensable resource, which can be a regular expense or a mileage expense. */
export type ExpensesExpensableSpendingAlertsTargetConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
  expensableIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeDiscarded?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Represents an expensable resource, which can be a regular expense or a mileage expense. */
export type ExpensesExpensableSupplementArgs = {
  compensationId?: InputMaybe<Scalars['Int']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  from?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  policyPeriodIds?: Array<Scalars['Int']>;
  taxonomyIds?: InputMaybe<Array<Scalars['Int']>>;
  to?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Represents an expensable resource, which can be a regular expense or a mileage expense. */
export type ExpensesExpensableSyncableStateArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  marketplaceIntegrationId?: InputMaybe<Scalars['Int']>;
};


/** Represents an expensable resource, which can be a regular expense or a mileage expense. */
export type ExpensesExpensableSyncableStateConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  marketplaceIntegrationId?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

export type ExpensesExpensableAggregationTotal = {
  __typename?: 'ExpensesExpensableAggregationTotal';
  fullyNonReimbursableCount: Scalars['Int'];
  fullyReimbursableCount: Scalars['Int'];
  nonReimbursableAmount: Scalars['Int'];
  nonReimbursableCount: Scalars['Int'];
  reimbursableAmount: Scalars['Int'];
  reimbursableCount: Scalars['Int'];
  totalAmount: Scalars['Int'];
  totalCount: Scalars['Int'];
};

/** The connection type for ExpensesExpensable. */
export type ExpensesExpensableConnection = {
  __typename?: 'ExpensesExpensableConnection';
  aggregate?: Maybe<ExpensesExpensablesAggregate>;
  /** A list of edges. */
  edges: Array<ExpensesExpensableEdge>;
  /** A list of nodes. */
  nodes: Array<ExpensesExpensable>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ExpensesExpensableEdge = {
  __typename?: 'ExpensesExpensableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ExpensesExpensable;
};

/** the filter for the expensables resource */
export type ExpensesExpensableFilter = {
  amount?: InputMaybe<StringFilter>;
  approvedAt?: InputMaybe<DateFilter>;
  category?: InputMaybe<StringFilter>;
  categoryId?: InputMaybe<IntegerFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  creationType?: InputMaybe<StringFilter>;
  currency?: InputMaybe<StringFilter>;
  documentType?: InputMaybe<StringFilter>;
  effectiveOn?: InputMaybe<DateTimeFilter>;
  internalReference?: InputMaybe<StringFilter>;
  legalEntity?: InputMaybe<IntegerFilter>;
  or?: InputMaybe<Array<ExpensesExpensableFilterConditions>>;
  owner?: InputMaybe<IntegerFilter>;
  pendingApproval?: InputMaybe<StringFilter>;
  project?: InputMaybe<IntegerFilter>;
  reimbursable?: InputMaybe<BooleanFilter>;
  reimbursableAmount?: InputMaybe<StringFilter>;
  reimbursableCurrency?: InputMaybe<StringFilter>;
  reimbursementMethod?: InputMaybe<StringFilter>;
  reportedBy?: InputMaybe<StringFilter>;
  reviewRequestAt?: InputMaybe<DateTimeFilter>;
  spendingAlertType?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
  subcategory?: InputMaybe<StringFilter>;
  subcategoryId?: InputMaybe<IntegerFilter>;
  subproject?: InputMaybe<IntegerFilter>;
  team?: InputMaybe<IntegerFilter>;
  type?: InputMaybe<StringFilter>;
};

export type ExpensesExpensableFilterConditions = {
  amount?: InputMaybe<StringFilter>;
  approvedAt?: InputMaybe<DateFilter>;
  category?: InputMaybe<StringFilter>;
  categoryId?: InputMaybe<IntegerFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  creationType?: InputMaybe<StringFilter>;
  currency?: InputMaybe<StringFilter>;
  documentType?: InputMaybe<StringFilter>;
  effectiveOn?: InputMaybe<DateTimeFilter>;
  internalReference?: InputMaybe<StringFilter>;
  legalEntity?: InputMaybe<IntegerFilter>;
  owner?: InputMaybe<IntegerFilter>;
  pendingApproval?: InputMaybe<StringFilter>;
  project?: InputMaybe<IntegerFilter>;
  reimbursable?: InputMaybe<BooleanFilter>;
  reimbursableAmount?: InputMaybe<StringFilter>;
  reimbursableCurrency?: InputMaybe<StringFilter>;
  reimbursementMethod?: InputMaybe<StringFilter>;
  reportedBy?: InputMaybe<StringFilter>;
  reviewRequestAt?: InputMaybe<DateTimeFilter>;
  spendingAlertType?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
  subcategory?: InputMaybe<StringFilter>;
  subcategoryId?: InputMaybe<IntegerFilter>;
  subproject?: InputMaybe<IntegerFilter>;
  team?: InputMaybe<IntegerFilter>;
  type?: InputMaybe<StringFilter>;
};

export type ExpensesExpensableFiltersInput = {
  creationType?: InputMaybe<ExpensesValueObjectsCreationTypeEnum>;
  currency: Scalars['String'];
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
};

/** Represents an group of expensables */
export type ExpensesExpensableGroup = {
  __typename?: 'ExpensesExpensableGroup';
  _policies?: Maybe<ExpensesExpensableGroupPolicies>;
  _policiesCollection?: Maybe<Array<PermissionsPolicyResolution>>;
  _policiesConnection: PermissionsPolicyResolutionConnection;
  addableToPayroll: Scalars['Boolean'];
  amount?: Maybe<Scalars['BigInt']>;
  anyAutomaticExpense: Scalars['Boolean'];
  anyMissingPayrollCategory: Scalars['Boolean'];
  companyId: Scalars['Int'];
  currency?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  employeeId?: Maybe<Scalars['Int']>;
  expensables: Array<ExpensesExpensable>;
  expensablesConnection: ExpensesExpensableConnection;
  expensablesCount: Scalars['Int'];
  files: Array<ExpensesFile>;
  id: Scalars['Int'];
  name: Scalars['String'];
  notReimbursableAmount?: Maybe<Scalars['BigInt']>;
  notReimbursableCurrency?: Maybe<Scalars['String']>;
  owner?: Maybe<EmployeesEmployee>;
  payableWithSepa: Scalars['Boolean'];
  reimbursableAmount?: Maybe<Scalars['BigInt']>;
  reimbursableCurrency?: Maybe<Scalars['String']>;
  removableFromPayroll: Scalars['Boolean'];
  restartable: Scalars['Boolean'];
  revertablePaid: Scalars['Boolean'];
  reviewRequestAt?: Maybe<Scalars['ISO8601DateTime']>;
  reviewable: Scalars['Boolean'];
  settableAsPaid: Scalars['Boolean'];
  status: ExpensesEntitiesExpensableStatusEnum;
};


/** Represents an group of expensables */
export type ExpensesExpensableGroup_PoliciesCollectionArgs = {
  ids: Array<ExpensesExpensableGroupPoliciesEnum>;
};


/** Represents an group of expensables */
export type ExpensesExpensableGroup_PoliciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Represents an group of expensables */
export type ExpensesExpensableGroupExpensablesArgs = {
  byResources?: InputMaybe<Array<ExpensablesByResourcesInput>>;
  categories?: InputMaybe<Array<Scalars['String']>>;
  companyId?: InputMaybe<Scalars['Int']>;
  creationType?: InputMaybe<Array<Scalars['String']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  from?: InputMaybe<Scalars['ISO8601DateTime']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeAttachments?: Scalars['Boolean'];
  includeGrouped?: Scalars['Boolean'];
  includeManualDrafts?: Scalars['Boolean'];
  onlyGrouped?: InputMaybe<Scalars['Boolean']>;
  perDiemEndDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  perDiemStartDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  reporterIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Array<ExpensesEntitiesExpensableStatusEnum>>;
  to?: InputMaybe<Scalars['ISO8601DateTime']>;
  withReimbursableCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** Represents an group of expensables */
export type ExpensesExpensableGroupExpensablesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  byResources?: InputMaybe<Array<ExpensablesByResourcesInput>>;
  categories?: InputMaybe<Array<Scalars['String']>>;
  companyId?: InputMaybe<Scalars['Int']>;
  creationType?: InputMaybe<Array<Scalars['String']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['ISO8601DateTime']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeAttachments?: Scalars['Boolean'];
  includeGrouped?: Scalars['Boolean'];
  includeManualDrafts?: Scalars['Boolean'];
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyGrouped?: InputMaybe<Scalars['Boolean']>;
  perDiemEndDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  perDiemStartDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  reporterIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  status?: InputMaybe<Array<ExpensesEntitiesExpensableStatusEnum>>;
  to?: InputMaybe<Scalars['ISO8601DateTime']>;
  withReimbursableCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** Represents an group of expensables */
export type ExpensesExpensableGroupOwnerArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for ExpensesExpensableGroup. */
export type ExpensesExpensableGroupConnection = {
  __typename?: 'ExpensesExpensableGroupConnection';
  /** A list of edges. */
  edges: Array<ExpensesExpensableGroupEdge>;
  /** A list of nodes. */
  nodes: Array<ExpensesExpensableGroup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ExpensesExpensableGroupEdge = {
  __typename?: 'ExpensesExpensableGroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ExpensesExpensableGroup;
};

/** the filter for the expensable_groups resource */
export type ExpensesExpensableGroupFilter = {
  category?: InputMaybe<StringFilter>;
  currency?: InputMaybe<StringFilter>;
  legalEntity?: InputMaybe<IntegerFilter>;
  or?: InputMaybe<Array<ExpensesExpensableGroupFilterConditions>>;
  owner?: InputMaybe<IntegerFilter>;
  pendingApproval?: InputMaybe<StringFilter>;
  reimbursable?: InputMaybe<BooleanFilter>;
  reportedBy?: InputMaybe<StringFilter>;
  reviewRequestAt?: InputMaybe<DateTimeFilter>;
  status?: InputMaybe<StringFilter>;
  subcategory?: InputMaybe<StringFilter>;
};

export type ExpensesExpensableGroupFilterConditions = {
  category?: InputMaybe<StringFilter>;
  currency?: InputMaybe<StringFilter>;
  legalEntity?: InputMaybe<IntegerFilter>;
  owner?: InputMaybe<IntegerFilter>;
  pendingApproval?: InputMaybe<StringFilter>;
  reimbursable?: InputMaybe<BooleanFilter>;
  reportedBy?: InputMaybe<StringFilter>;
  reviewRequestAt?: InputMaybe<DateTimeFilter>;
  status?: InputMaybe<StringFilter>;
  subcategory?: InputMaybe<StringFilter>;
};

export type ExpensesExpensableGroupPolicies = {
  __typename?: 'ExpensesExpensableGroupPolicies';
  destroy: PermissionsPolicyResolution;
  edit: PermissionsPolicyResolution;
};

export type ExpensesExpensableGroupPoliciesEnum =
  | 'destroy'
  | 'edit';

/** expensable_groups_setting */
export type ExpensesExpensableGroupsSetting = {
  __typename?: 'ExpensesExpensableGroupsSetting';
  companyId: Scalars['Int'];
  enabled: Scalars['Boolean'];
  id: Scalars['String'];
};

/** The connection type for ExpensesExpensableGroupsSetting. */
export type ExpensesExpensableGroupsSettingConnection = {
  __typename?: 'ExpensesExpensableGroupsSettingConnection';
  /** A list of edges. */
  edges: Array<ExpensesExpensableGroupsSettingEdge>;
  /** A list of nodes. */
  nodes: Array<ExpensesExpensableGroupsSetting>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ExpensesExpensableGroupsSettingEdge = {
  __typename?: 'ExpensesExpensableGroupsSettingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ExpensesExpensableGroupsSetting;
};

export type ExpensesExpensablePolicies = {
  __typename?: 'ExpensesExpensablePolicies';
  destroy: PermissionsPolicyResolution;
  edit: PermissionsPolicyResolution;
};

export type ExpensesExpensablePoliciesEnum =
  | 'destroy'
  | 'edit';

/** expensable_ready_to_review_issue */
export type ExpensesExpensableReadyToReviewIssue = {
  __typename?: 'ExpensesExpensableReadyToReviewIssue';
  expensableId: Scalars['Int'];
  issues: Array<ExpensesSerializableIssue>;
};

/** The connection type for ExpensesExpensableReadyToReviewIssue. */
export type ExpensesExpensableReadyToReviewIssueConnection = {
  __typename?: 'ExpensesExpensableReadyToReviewIssueConnection';
  /** A list of edges. */
  edges: Array<ExpensesExpensableReadyToReviewIssueEdge>;
  /** A list of nodes. */
  nodes: Array<ExpensesExpensableReadyToReviewIssue>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ExpensesExpensableReadyToReviewIssueEdge = {
  __typename?: 'ExpensesExpensableReadyToReviewIssueEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ExpensesExpensableReadyToReviewIssue;
};

/** Expenses expensables aggregates */
export type ExpensesExpensablesAggregate = {
  __typename?: 'ExpensesExpensablesAggregate';
  average?: Maybe<ExpensesExpensablesConnectionAggregateAverage>;
  count?: Maybe<Scalars['Int']>;
  maximum?: Maybe<ExpensesExpensablesConnectionAggregateMaximum>;
  minimum?: Maybe<ExpensesExpensablesConnectionAggregateMinimum>;
  sum?: Maybe<ExpensesExpensablesConnectionAggregateSum>;
  terms?: Maybe<ExpensesExpensablesConnectionAggregateTerms>;
};

export type ExpensesExpensablesAggregateTerms = {
  __typename?: 'ExpensesExpensablesAggregateTerms';
  average?: Maybe<ExpensesExpensablesConnectionAggregateTermsAverageFields>;
  count?: Maybe<Array<Scalars['Int']>>;
  maximum?: Maybe<ExpensesExpensablesConnectionAggregateTermsMaximumFields>;
  minimum?: Maybe<ExpensesExpensablesConnectionAggregateTermsMinimumFields>;
  sum?: Maybe<ExpensesExpensablesConnectionAggregateTermsSumFields>;
  values: Array<Scalars['String']>;
};

/** expensables_by_approval_status */
export type ExpensesExpensablesByApprovalStatus = {
  __typename?: 'ExpensesExpensablesByApprovalStatus';
  approved: ExpensesExpensableAggregationTotal;
  inPayroll: ExpensesExpensableAggregationTotal;
  paid: ExpensesExpensableAggregationTotal;
  pending: ExpensesExpensableAggregationTotal;
  rejected: ExpensesExpensableAggregationTotal;
  sentToPay: ExpensesExpensableAggregationTotal;
  totalCount: Scalars['Int'];
  totalCountIncludingMismatches: Scalars['Int'];
  waitingForChanges: ExpensesExpensableAggregationTotal;
};

/** The connection type for ExpensesExpensablesByApprovalStatus. */
export type ExpensesExpensablesByApprovalStatusConnection = {
  __typename?: 'ExpensesExpensablesByApprovalStatusConnection';
  /** A list of edges. */
  edges: Array<ExpensesExpensablesByApprovalStatusEdge>;
  /** A list of nodes. */
  nodes: Array<ExpensesExpensablesByApprovalStatus>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ExpensesExpensablesByApprovalStatusEdge = {
  __typename?: 'ExpensesExpensablesByApprovalStatusEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ExpensesExpensablesByApprovalStatus;
};

/** Expenses expensables by category total */
export type ExpensesExpensablesByCategoryTotal = {
  __typename?: 'ExpensesExpensablesByCategoryTotal';
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  categoryId: Scalars['Int'];
  customCategory: FinanceCustomCategory;
  /** Sum of the amount of expensable by category */
  totalAmount: Scalars['BigInt'];
};


/** Expenses expensables by category total */
export type ExpensesExpensablesByCategoryTotalCustomCategoryArgs = {
  categoryLevel: FinanceValueObjectsCategoryLevelEnum;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  factorialCategoryIdentifier?: InputMaybe<Scalars['String']>;
  parentCategoryIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  statuses: Array<FinanceValueObjectsCategoryStatusEnum>;
  type: FinanceValueObjectsCategoryTypeEnum;
};

/** The connection type for ExpensesExpensablesByCategoryTotal. */
export type ExpensesExpensablesByCategoryTotalConnection = {
  __typename?: 'ExpensesExpensablesByCategoryTotalConnection';
  /** A list of edges. */
  edges: Array<ExpensesExpensablesByCategoryTotalEdge>;
  /** A list of nodes. */
  nodes: Array<ExpensesExpensablesByCategoryTotal>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ExpensesExpensablesByCategoryTotalEdge = {
  __typename?: 'ExpensesExpensablesByCategoryTotalEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ExpensesExpensablesByCategoryTotal;
};

/** the filter for the expensables_by_category_totals resource */
export type ExpensesExpensablesByCategoryTotalFilter = {
  or?: InputMaybe<Array<ExpensesExpensablesByCategoryTotalFilterConditions>>;
  totalAmount?: InputMaybe<StringFilter>;
};

export type ExpensesExpensablesByCategoryTotalFilterConditions = {
  totalAmount?: InputMaybe<StringFilter>;
};

/** Expenses expensables by cost center */
export type ExpensesExpensablesByCostCenter = {
  __typename?: 'ExpensesExpensablesByCostCenter';
  costCenter: FinanceCostCenter;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  costCenterId: Scalars['Int'];
  /** Total amount of the expensable */
  totalAmount: Scalars['BigInt'];
};


/** Expenses expensables by cost center */
export type ExpensesExpensablesByCostCenterCostCenterArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  includeActivesOnDate?: InputMaybe<Scalars['ISO8601Date']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};

/** The connection type for ExpensesExpensablesByCostCenter. */
export type ExpensesExpensablesByCostCenterConnection = {
  __typename?: 'ExpensesExpensablesByCostCenterConnection';
  /** A list of edges. */
  edges: Array<ExpensesExpensablesByCostCenterEdge>;
  /** A list of nodes. */
  nodes: Array<ExpensesExpensablesByCostCenter>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ExpensesExpensablesByCostCenterEdge = {
  __typename?: 'ExpensesExpensablesByCostCenterEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ExpensesExpensablesByCostCenter;
};

/** the filter for the expensables_by_cost_centers resource */
export type ExpensesExpensablesByCostCenterFilter = {
  or?: InputMaybe<Array<ExpensesExpensablesByCostCenterFilterConditions>>;
  totalAmount?: InputMaybe<StringFilter>;
};

export type ExpensesExpensablesByCostCenterFilterConditions = {
  totalAmount?: InputMaybe<StringFilter>;
};

/** Expenses expensables by employee */
export type ExpensesExpensablesByEmployee = {
  __typename?: 'ExpensesExpensablesByEmployee';
  employee: EmployeesEmployee;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  employeeId: Scalars['Int'];
  /** Total amount of the expensable */
  totalAmount: Scalars['BigInt'];
};


/** Expenses expensables by employee */
export type ExpensesExpensablesByEmployeeEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for ExpensesExpensablesByEmployee. */
export type ExpensesExpensablesByEmployeeConnection = {
  __typename?: 'ExpensesExpensablesByEmployeeConnection';
  /** A list of edges. */
  edges: Array<ExpensesExpensablesByEmployeeEdge>;
  /** A list of nodes. */
  nodes: Array<ExpensesExpensablesByEmployee>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ExpensesExpensablesByEmployeeEdge = {
  __typename?: 'ExpensesExpensablesByEmployeeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ExpensesExpensablesByEmployee;
};

/** the filter for the expensables_by_employees resource */
export type ExpensesExpensablesByEmployeeFilter = {
  or?: InputMaybe<Array<ExpensesExpensablesByEmployeeFilterConditions>>;
  totalAmount?: InputMaybe<StringFilter>;
};

export type ExpensesExpensablesByEmployeeFilterConditions = {
  totalAmount?: InputMaybe<StringFilter>;
};

/** Expensables by month */
export type ExpensesExpensablesByMonth = {
  __typename?: 'ExpensesExpensablesByMonth';
  currency: Scalars['String'];
  month: Scalars['Int'];
  totalAmount: Scalars['BigInt'];
  year: Scalars['Int'];
};

/** The connection type for ExpensesExpensablesByMonth. */
export type ExpensesExpensablesByMonthConnection = {
  __typename?: 'ExpensesExpensablesByMonthConnection';
  /** A list of edges. */
  edges: Array<ExpensesExpensablesByMonthEdge>;
  /** A list of nodes. */
  nodes: Array<ExpensesExpensablesByMonth>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ExpensesExpensablesByMonthEdge = {
  __typename?: 'ExpensesExpensablesByMonthEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ExpensesExpensablesByMonth;
};

/** Expensables by team */
export type ExpensesExpensablesByTeam = {
  __typename?: 'ExpensesExpensablesByTeam';
  id: Scalars['Int'];
  team: TeamsTeam;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  teamId: Scalars['Int'];
  /** Total amount of the expensable */
  totalAmount: Scalars['BigInt'];
};


/** Expensables by team */
export type ExpensesExpensablesByTeamTeamArgs = {
  mainTeam?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  withMembers?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for ExpensesExpensablesByTeam. */
export type ExpensesExpensablesByTeamConnection = {
  __typename?: 'ExpensesExpensablesByTeamConnection';
  /** A list of edges. */
  edges: Array<ExpensesExpensablesByTeamEdge>;
  /** A list of nodes. */
  nodes: Array<ExpensesExpensablesByTeam>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ExpensesExpensablesByTeamEdge = {
  __typename?: 'ExpensesExpensablesByTeamEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ExpensesExpensablesByTeam;
};

/** the filter for the expensables_by_teams resource */
export type ExpensesExpensablesByTeamFilter = {
  or?: InputMaybe<Array<ExpensesExpensablesByTeamFilterConditions>>;
  totalAmount?: InputMaybe<StringFilter>;
};

export type ExpensesExpensablesByTeamFilterConditions = {
  totalAmount?: InputMaybe<StringFilter>;
};

/** average function */
export type ExpensesExpensablesConnectionAggregateAverage = {
  __typename?: 'ExpensesExpensablesConnectionAggregateAverage';
  amount?: Maybe<Scalars['Float']>;
  reimbursableAmount?: Maybe<Scalars['Float']>;
};

/** maximum function */
export type ExpensesExpensablesConnectionAggregateMaximum = {
  __typename?: 'ExpensesExpensablesConnectionAggregateMaximum';
  amount?: Maybe<Scalars['Int']>;
  reimbursableAmount?: Maybe<Scalars['Int']>;
};

/** minimum function */
export type ExpensesExpensablesConnectionAggregateMinimum = {
  __typename?: 'ExpensesExpensablesConnectionAggregateMinimum';
  amount?: Maybe<Scalars['Int']>;
  reimbursableAmount?: Maybe<Scalars['Int']>;
};

/** sum function */
export type ExpensesExpensablesConnectionAggregateSum = {
  __typename?: 'ExpensesExpensablesConnectionAggregateSum';
  amount?: Maybe<Scalars['Int']>;
  reimbursableAmount?: Maybe<Scalars['Int']>;
};

/** terms function */
export type ExpensesExpensablesConnectionAggregateTerms = {
  __typename?: 'ExpensesExpensablesConnectionAggregateTerms';
  amount?: Maybe<ExpensesExpensablesAggregateTerms>;
  createdAt?: Maybe<ExpensesExpensablesAggregateTerms>;
  currency?: Maybe<ExpensesExpensablesAggregateTerms>;
  effectiveOn?: Maybe<ExpensesExpensablesAggregateTerms>;
  reimbursableAmount?: Maybe<ExpensesExpensablesAggregateTerms>;
  reimbursableCurrency?: Maybe<ExpensesExpensablesAggregateTerms>;
  reimbursementMethod?: Maybe<ExpensesExpensablesAggregateTerms>;
  reviewRequestAt?: Maybe<ExpensesExpensablesAggregateTerms>;
  status?: Maybe<ExpensesExpensablesAggregateTerms>;
  type?: Maybe<ExpensesExpensablesAggregateTerms>;
};


/** terms function */
export type ExpensesExpensablesConnectionAggregateTermsCreatedAtArgs = {
  period?: InputMaybe<GroupByDateFieldsPeriods>;
};


/** terms function */
export type ExpensesExpensablesConnectionAggregateTermsEffectiveOnArgs = {
  period?: InputMaybe<GroupByDateFieldsPeriods>;
};


/** terms function */
export type ExpensesExpensablesConnectionAggregateTermsReviewRequestAtArgs = {
  period?: InputMaybe<GroupByDateFieldsPeriods>;
};

/** average function */
export type ExpensesExpensablesConnectionAggregateTermsAverageFields = {
  __typename?: 'ExpensesExpensablesConnectionAggregateTermsAVERAGEFields';
  amount?: Maybe<Array<Scalars['Float']>>;
  reimbursableAmount?: Maybe<Array<Scalars['Float']>>;
};

/** maximum function */
export type ExpensesExpensablesConnectionAggregateTermsMaximumFields = {
  __typename?: 'ExpensesExpensablesConnectionAggregateTermsMAXIMUMFields';
  amount?: Maybe<Array<Scalars['Int']>>;
  reimbursableAmount?: Maybe<Array<Scalars['Int']>>;
};

/** minimum function */
export type ExpensesExpensablesConnectionAggregateTermsMinimumFields = {
  __typename?: 'ExpensesExpensablesConnectionAggregateTermsMINIMUMFields';
  amount?: Maybe<Array<Scalars['Int']>>;
  reimbursableAmount?: Maybe<Array<Scalars['Int']>>;
};

/** sum function */
export type ExpensesExpensablesConnectionAggregateTermsSumFields = {
  __typename?: 'ExpensesExpensablesConnectionAggregateTermsSUMFields';
  amount?: Maybe<Array<Scalars['Int']>>;
  reimbursableAmount?: Maybe<Array<Scalars['Int']>>;
};

/** Represents an expense */
export type ExpensesExpense = {
  __typename?: 'ExpensesExpense';
  /** The access token of the expense */
  accessToken?: Maybe<Scalars['String']>;
  adeArchived: Scalars['Boolean'];
  /** The optional amount in cents */
  amount?: Maybe<Scalars['BigInt']>;
  bookEntryId?: Maybe<Scalars['Int']>;
  /** The id of the budget associated with this expense */
  budgetId?: Maybe<Scalars['Int']>;
  /** The card of the expense */
  card?: Maybe<ExpensesCardWithoutSensitiveInfo>;
  cardId: Scalars['Int'];
  cardPayment?: Maybe<BankingCardPayment>;
  /**
   * The id of the card payment
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  cardPaymentId?: Maybe<Scalars['Int']>;
  /** The category of the expense */
  category?: Maybe<ExpensesExpenseCategory>;
  /** The id of the category */
  categoryId?: Maybe<Scalars['Int']>;
  categoryName: Scalars['String'];
  /** The id of the expense's company */
  companyId: Scalars['Int'];
  /** Array of cost center IDs associated with this expense */
  costCenterIds: Array<Scalars['Int']>;
  /** How the expense was created, one of 'manual', 'automatic' or 'travelperk' */
  creationType: ExpensesEntitiesExpenseCreationTypeEnum;
  /** The currency of the expense */
  currency: Scalars['String'];
  /** The description of the expense */
  description?: Maybe<Scalars['String']>;
  dispute?: Maybe<BankingDispute>;
  /**
   * The id of the dispute
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  disputeId?: Maybe<Scalars['Int']>;
  /** The id of the document */
  documentId?: Maybe<Scalars['Int']>;
  /** Number of the financial document associated to the expense */
  documentNumber?: Maybe<Scalars['String']>;
  /** Type of the financial document associated to the expense */
  documentType?: Maybe<Scalars['String']>;
  /** The date when the expense was made */
  effectiveOn: Scalars['ISO8601DateTime'];
  employee?: Maybe<EmployeesEmployee>;
  /**
   * The id of the expense's owner
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  employeeId?: Maybe<Scalars['Int']>;
  employeeName?: Maybe<EmployeesEmployeeName>;
  /** The exchange rate of the payment */
  exchangeRate?: Maybe<Scalars['Float']>;
  expensable: ExpensesExpensable;
  /** The id of the card */
  expensesCardId?: Maybe<Scalars['Int']>;
  /**
   * The id of the expensable
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  expensesExpensableId?: Maybe<Scalars['Int']>;
  /** The id of the external authorization */
  externalAuthorizationId?: Maybe<Scalars['String']>;
  /** The files of the expense */
  files: Array<ExpensesFile>;
  financialDocumentAssociation?: Maybe<FinanceFinancialDocumentAssociation>;
  /** The id of the expense */
  id?: Maybe<Scalars['Int']>;
  journalDraftEntry?: Maybe<FinanceJournalDraftEntry>;
  journalEntry?: Maybe<FinanceJournalEntry>;
  ledgerAccount?: Maybe<FinanceAccount>;
  /**
   * The id of the ledger account
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  ledgerAccountId?: Maybe<Scalars['Int']>;
  /** The name of the merchant */
  merchantName?: Maybe<Scalars['String']>;
  /** The tax identification number of the merchant */
  merchantTin?: Maybe<Scalars['String']>;
  /** The date and time when the expense was paid */
  paidAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The payment of the expense */
  payment?: Maybe<ExpensesValueObjectsPaymentOptionsEnum>;
  /** The method of the payment */
  paymentMethod?: Maybe<Scalars['String']>;
  /** The id of the project associated with this expense */
  projectId?: Maybe<Scalars['Int']>;
  /** The reference of the expense */
  reference?: Maybe<Scalars['String']>;
  /** The optional reimbursable amount in cents */
  reimbursableAmount?: Maybe<Scalars['BigInt']>;
  /** The currency of the reimbursable amount */
  reimbursableCurrency?: Maybe<Scalars['String']>;
  resourceKey: Scalars['String'];
  resourceType: Scalars['String'];
  /** The date and time when the expense was reviewed */
  reviewRequestAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The signed document of the expense */
  signedDocument?: Maybe<ExpensesSignedDocumentFile>;
  /** The status of the expense */
  status: ExpensesEntitiesExpensableStatusEnum;
  /** The date and time when the status was updated */
  statusUpdatedAt: Scalars['ISO8601DateTime'];
  /** The subcategory of the expense */
  subcategory?: Maybe<Scalars['String']>;
  /** The taxes of the expense */
  taxes: Array<ExpensesTax>;
  /** The user merchant of the expense */
  userMerchant?: Maybe<Scalars['String']>;
};


/** Represents an expense */
export type ExpensesExpenseCardPaymentArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']>>;
  calculatedLabel?: InputMaybe<BankingEntitiesCardPaymentCalculatedLabelEnum>;
  cardIds?: InputMaybe<Array<Scalars['Int']>>;
  externalIds?: InputMaybe<Array<Scalars['String']>>;
  from?: InputMaybe<Scalars['ISO8601DateTime']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<BankingEntitiesCardPaymentStatusEnum>;
  to?: InputMaybe<Scalars['ISO8601DateTime']>;
};


/** Represents an expense */
export type ExpensesExpenseDisputeArgs = {
  bankAccountIds?: InputMaybe<Array<Scalars['Int']>>;
  externalIds?: InputMaybe<Array<Scalars['String']>>;
  refundTransactionIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Represents an expense */
export type ExpensesExpenseEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Represents an expense */
export type ExpensesExpenseEmployeeNameArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  afterEmployeeId?: InputMaybe<Scalars['Int']>;
  beforeEmployeeId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  reporteesOrLed?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyId?: InputMaybe<Scalars['Int']>;
  verb?: InputMaybe<Scalars['String']>;
  withActiveContract?: Scalars['Boolean'];
};


/** Represents an expense */
export type ExpensesExpenseExpensableArgs = {
  byResources?: InputMaybe<Array<ExpensablesByResourcesInput>>;
  categories?: InputMaybe<Array<Scalars['String']>>;
  companyId?: InputMaybe<Scalars['Int']>;
  creationType?: InputMaybe<Array<Scalars['String']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  from?: InputMaybe<Scalars['ISO8601DateTime']>;
  groupIds?: InputMaybe<Array<Scalars['Int']>>;
  includeAttachments?: Scalars['Boolean'];
  onlyGrouped?: InputMaybe<Scalars['Boolean']>;
  perDiemEndDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  perDiemStartDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  reporterIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Array<ExpensesEntitiesExpensableStatusEnum>>;
  to?: InputMaybe<Scalars['ISO8601DateTime']>;
  withReimbursableCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** Represents an expense */
export type ExpensesExpenseFinancialDocumentAssociationArgs = {
  financialDocumentIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Represents an expense */
export type ExpensesExpenseJournalDraftEntryArgs = {
  bankTransactionIds?: InputMaybe<Array<Scalars['Int']>>;
  companyId?: InputMaybe<Scalars['Int']>;
  financialDocumentIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  invoiceIds?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  statuses?: InputMaybe<Array<FinanceValueObjectsJournalDraftEntryStatusEnum>>;
};


/** Represents an expense */
export type ExpensesExpenseJournalEntryArgs = {
  bankTransactionIds?: InputMaybe<Array<Scalars['Int']>>;
  financialDocumentIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  invoiceIds?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  publishedFrom?: InputMaybe<Scalars['ISO8601Date']>;
  status?: InputMaybe<FinanceValueObjectsJournalEntryStatusEnum>;
  types?: InputMaybe<Array<FinanceValueObjectsJournalEntryTypeEnum>>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Represents an expense */
export type ExpensesExpenseLedgerAccountArgs = {
  includeDisabled?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  number?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Array<Scalars['String']>>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};

export type ExpensesExpenseCategory = {
  __typename?: 'ExpensesExpenseCategory';
  id: Scalars['String'];
  name: Scalars['String'];
};

/** The connection type for ExpensesExpense. */
export type ExpensesExpenseConnection = {
  __typename?: 'ExpensesExpenseConnection';
  /** A list of edges. */
  edges: Array<ExpensesExpenseEdge>;
  /** A list of nodes. */
  nodes: Array<ExpensesExpense>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ExpensesExpenseCreationTypeEnum =
  | 'automatic'
  | 'manual'
  | 'travelperk';

/** An edge in a connection. */
export type ExpensesExpenseEdge = {
  __typename?: 'ExpensesExpenseEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ExpensesExpense;
};

/** the filter for the expenses resource */
export type ExpensesExpenseFilter = {
  amount?: InputMaybe<StringFilter>;
  categoryId?: InputMaybe<IntegerFilter>;
  or?: InputMaybe<Array<ExpensesExpenseFilterConditions>>;
};

export type ExpensesExpenseFilterConditions = {
  amount?: InputMaybe<StringFilter>;
  categoryId?: InputMaybe<IntegerFilter>;
};

/** Legacy expenses subscription to overwrite some porduct limtis */
export type ExpensesExpensesSubscription = {
  __typename?: 'ExpensesExpensesSubscription';
  canCreatePhysicalCards: Scalars['Boolean'];
  canCreateSingleUseCards: Scalars['Boolean'];
  canCreateVirtualCards: Scalars['Boolean'];
  companyId: Scalars['Int'];
  customApprovalPolicyCreationLimit?: Maybe<Scalars['Int']>;
  customForexFeesDiscountRate?: Maybe<Scalars['Int']>;
  customPhysicalCardCreationLimit?: Maybe<Scalars['Int']>;
  customVirtualCardCreationLimit?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  planName: Scalars['String'];
};

/** The connection type for ExpensesExpensesSubscription. */
export type ExpensesExpensesSubscriptionConnection = {
  __typename?: 'ExpensesExpensesSubscriptionConnection';
  /** A list of edges. */
  edges: Array<ExpensesExpensesSubscriptionEdge>;
  /** A list of nodes. */
  nodes: Array<ExpensesExpensesSubscription>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ExpensesExpensesSubscriptionEdge = {
  __typename?: 'ExpensesExpensesSubscriptionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ExpensesExpensesSubscription;
};

export type ExpensesFile = {
  __typename?: 'ExpensesFile';
  byteSize: Scalars['Int'];
  contentType?: Maybe<Scalars['String']>;
  filename: Scalars['String'];
  id: Scalars['Int'];
  url?: Maybe<Scalars['String']>;
};

export type ExpensesFlag = {
  __typename?: 'ExpensesFlag';
  description: Scalars['String'];
  title: Scalars['String'];
};

/** Internal expense viewer for recommendation validation */
export type ExpensesInternalExpenseViewer = {
  __typename?: 'ExpensesInternalExpenseViewer';
  amount?: Maybe<Scalars['Int']>;
  approvalFlowReason?: Maybe<Scalars['String']>;
  approvalStepApproverId?: Maybe<Scalars['Int']>;
  budgetId?: Maybe<Scalars['Int']>;
  companyId: Scalars['Int'];
  costCenterIds: Array<Scalars['Int']>;
  createdAt: Scalars['ISO8601DateTime'];
  creationSource?: Maybe<Scalars['String']>;
  currency: Scalars['String'];
  currentApproverIds?: Maybe<Array<Scalars['Int']>>;
  currentUserApprovalStatus?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  effectiveOn?: Maybe<Scalars['ISO8601DateTime']>;
  employeeId: Scalars['Int'];
  expense?: Maybe<ExpensesExpense>;
  expenseId?: Maybe<Scalars['Int']>;
  groupId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  internalReference?: Maybe<Scalars['String']>;
  legalEntityId?: Maybe<Scalars['Int']>;
  materializedApprovalFlowId?: Maybe<Scalars['Int']>;
  materializedStepApproverId?: Maybe<Scalars['Int']>;
  mileageId?: Maybe<Scalars['Int']>;
  paidAt?: Maybe<Scalars['ISO8601DateTime']>;
  perDiemId?: Maybe<Scalars['Int']>;
  preview?: Maybe<ExpensesFile>;
  projectId?: Maybe<Scalars['Int']>;
  reimbursableAmount?: Maybe<Scalars['Int']>;
  reimbursableCurrency?: Maybe<Scalars['String']>;
  reimbursementMethod?: Maybe<ExpensesEntitiesExpensableReimbursementMethodEnum>;
  reporterId?: Maybe<Scalars['Int']>;
  reviewRequestAt?: Maybe<Scalars['ISO8601DateTime']>;
  spendingAlertTypes?: Maybe<Array<Scalars['String']>>;
  status: ExpensesEntitiesExpensableStatusEnum;
  statusUpdatedAt: Scalars['ISO8601DateTime'];
  type: ExpensesEntitiesExpensableResourceTypeEnum;
  updatedAt: Scalars['ISO8601DateTime'];
};


/** Internal expense viewer for recommendation validation */
export type ExpensesInternalExpenseViewerExpenseArgs = {
  bookEntryIds?: InputMaybe<Array<Scalars['Int']>>;
  cardIds?: InputMaybe<Array<Scalars['Int']>>;
  cardPaymentIds?: InputMaybe<Array<Scalars['Int']>>;
  disputeIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  externalAuthorizationIds?: InputMaybe<Array<Scalars['String']>>;
  from?: InputMaybe<Scalars['ISO8601DateTime']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeAttachments?: Scalars['Boolean'];
  includeManualDrafts?: Scalars['Boolean'];
  to?: InputMaybe<Scalars['ISO8601DateTime']>;
};

export type ExpensesLocationDataInput = {
  administrativeAreaLevel1?: InputMaybe<Scalars['String']>;
  administrativeAreaLevel2?: InputMaybe<Scalars['String']>;
  country: Scalars['String'];
  locality?: InputMaybe<Scalars['String']>;
};

/** Represents a mileage */
export type ExpensesMileage = {
  __typename?: 'ExpensesMileage';
  /** The amount in cents */
  amount?: Maybe<Scalars['BigInt']>;
  /** The id of the budget associated with this mileage */
  budgetId?: Maybe<Scalars['Int']>;
  /** The calculated mileage between origin and destination in decameters/10-milers */
  calculatedMileage?: Maybe<Scalars['Int']>;
  /** The category of the mileage */
  category?: Maybe<ExpensesExpenseCategory>;
  /** The ID of the category */
  categoryId?: Maybe<Scalars['Int']>;
  /** The ID of the company that owns the mileage */
  companyId: Scalars['Int'];
  /** Array of cost center IDs associated with this mileage */
  costCenterIds: Array<Scalars['Int']>;
  /** The currency code in ISO 4217 format */
  currency: Scalars['String'];
  /** The description of the mileage */
  description?: Maybe<Scalars['String']>;
  /** The latitude of the destination of the mileage */
  destinationLatitude?: Maybe<Scalars['String']>;
  /** The longitude of the destination of the mileage */
  destinationLongitude?: Maybe<Scalars['String']>;
  /** The date when the mileage was effective */
  effectiveOn?: Maybe<Scalars['ISO8601DateTime']>;
  employee?: Maybe<EmployeesEmployee>;
  /**
   * The ID of the employee that owns the mileage
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  employeeId?: Maybe<Scalars['Int']>;
  expensable: ExpensesExpensable;
  /**
   * The ID of the expensable associated with this mileage
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  expensesExpensableId?: Maybe<Scalars['Int']>;
  /** The files associated with the mileage */
  files: Array<ExpensesFile>;
  /** The origin location */
  from?: Maybe<Scalars['String']>;
  /** Unique identifier for the mileage */
  id: Scalars['Int'];
  ledgerAccount?: Maybe<FinanceAccount>;
  /**
   * The ID of the ledger account
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  ledgerAccountId?: Maybe<Scalars['Int']>;
  /** The mileage distance */
  mileage?: Maybe<Scalars['Int']>;
  /** The latitude of the origin of the mileage */
  originLatitude?: Maybe<Scalars['String']>;
  /** The longitude of the origin of the mileage */
  originLongitude?: Maybe<Scalars['String']>;
  /** The date when the mileage was paid */
  paidAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The payment method */
  payment: ExpensesValueObjectsPaymentOptionsEnum;
  /** The id of the project associated with this mileage */
  projectId?: Maybe<Scalars['Int']>;
  /** The rate per unit */
  rate?: Maybe<Scalars['String']>;
  /** The amount to be reimbursed for the mileage in cents. */
  reimbursableAmount?: Maybe<Scalars['Int']>;
  /** The currency for the reimbursable amount. */
  reimbursableCurrency?: Maybe<Scalars['String']>;
  /** The date when the mileage was requested for review */
  reviewRequestAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Indicates if the mileage is a round trip */
  roundTrip?: Maybe<Scalars['Boolean']>;
  /** The status of the mileage */
  status: Scalars['String'];
  /** The subcategory of the mileage */
  subcategory?: Maybe<Scalars['String']>;
  /** The destination location */
  to?: Maybe<Scalars['String']>;
  /** The units for the mileage */
  units?: Maybe<Scalars['String']>;
};


/** Represents a mileage */
export type ExpensesMileageEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Represents a mileage */
export type ExpensesMileageExpensableArgs = {
  byResources?: InputMaybe<Array<ExpensablesByResourcesInput>>;
  categories?: InputMaybe<Array<Scalars['String']>>;
  companyId?: InputMaybe<Scalars['Int']>;
  creationType?: InputMaybe<Array<Scalars['String']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  from?: InputMaybe<Scalars['ISO8601DateTime']>;
  groupIds?: InputMaybe<Array<Scalars['Int']>>;
  includeAttachments?: Scalars['Boolean'];
  includeGrouped?: Scalars['Boolean'];
  includeManualDrafts?: Scalars['Boolean'];
  onlyGrouped?: InputMaybe<Scalars['Boolean']>;
  perDiemEndDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  perDiemStartDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  reporterIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Array<ExpensesEntitiesExpensableStatusEnum>>;
  to?: InputMaybe<Scalars['ISO8601DateTime']>;
  withReimbursableCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** Represents a mileage */
export type ExpensesMileageLedgerAccountArgs = {
  includeDisabled?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  number?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Array<Scalars['String']>>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};

/** The connection type for ExpensesMileage. */
export type ExpensesMileageConnection = {
  __typename?: 'ExpensesMileageConnection';
  /** A list of edges. */
  edges: Array<ExpensesMileageEdge>;
  /** A list of nodes. */
  nodes: Array<ExpensesMileage>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ExpensesMileageEdge = {
  __typename?: 'ExpensesMileageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ExpensesMileage;
};

/** the filter for the mileages resource */
export type ExpensesMileageFilter = {
  amount?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<ExpensesMileageFilterConditions>>;
};

export type ExpensesMileageFilterConditions = {
  amount?: InputMaybe<StringFilter>;
};

/** Represents official per diem rates from government regulations */
export type ExpensesOfficialPerDiemRate = {
  __typename?: 'ExpensesOfficialPerDiemRate';
  activeCompanyPerDiemRate?: Maybe<ExpensesCompanyPerDiemRate>;
  administrativeAreaLevel1?: Maybe<Scalars['String']>;
  administrativeAreaLevel2?: Maybe<Scalars['String']>;
  amountFullCents: Scalars['Int'];
  amountOvernightCents: Scalars['Int'];
  amountPartialCents: Scalars['Int'];
  country: Scalars['String'];
  currency: Scalars['String'];
  destinationCountry: Scalars['String'];
  id?: Maybe<Scalars['Int']>;
  isFallbackDestination: Scalars['Boolean'];
  locality?: Maybe<Scalars['String']>;
  validFrom: Scalars['ISO8601Date'];
  validTo: Scalars['ISO8601Date'];
};


/** Represents official per diem rates from government regulations */
export type ExpensesOfficialPerDiemRateActiveCompanyPerDiemRateArgs = {
  companyId: Scalars['Int'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};

/** The connection type for ExpensesOfficialPerDiemRate. */
export type ExpensesOfficialPerDiemRateConnection = {
  __typename?: 'ExpensesOfficialPerDiemRateConnection';
  /** A list of edges. */
  edges: Array<ExpensesOfficialPerDiemRateEdge>;
  /** A list of nodes. */
  nodes: Array<ExpensesOfficialPerDiemRate>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ExpensesOfficialPerDiemRateEdge = {
  __typename?: 'ExpensesOfficialPerDiemRateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ExpensesOfficialPerDiemRate;
};

/** Pending closing period records */
export type ExpensesPendingClosingPeriod = {
  __typename?: 'ExpensesPendingClosingPeriod';
  id: Scalars['String'];
  invoicesCount: Scalars['Int'];
  period: Scalars['Int'];
  year: Scalars['Int'];
};

/** The connection type for ExpensesPendingClosingPeriod. */
export type ExpensesPendingClosingPeriodConnection = {
  __typename?: 'ExpensesPendingClosingPeriodConnection';
  /** A list of edges. */
  edges: Array<ExpensesPendingClosingPeriodEdge>;
  /** A list of nodes. */
  nodes: Array<ExpensesPendingClosingPeriod>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ExpensesPendingClosingPeriodEdge = {
  __typename?: 'ExpensesPendingClosingPeriodEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ExpensesPendingClosingPeriod;
};

/** Represents a per diem */
export type ExpensesPerDiem = {
  __typename?: 'ExpensesPerDiem';
  /** The amount of the per diem. */
  amount?: Maybe<Scalars['BigInt']>;
  /** The id of the budget associated with this per diem */
  budgetId?: Maybe<Scalars['Int']>;
  /** The category of the per diem. */
  category?: Maybe<ExpensesExpenseCategory>;
  /** The ID of the company the per diem is for. */
  companyId: Scalars['Int'];
  /** Array of cost center IDs associated with this per diem */
  costCenterIds: Array<Scalars['Int']>;
  /** The currency for the reimbursable amount. */
  currency: Scalars['String'];
  /** The description of the per diem. */
  description?: Maybe<Scalars['String']>;
  /** The date the per diem is effective on. */
  effectiveOn?: Maybe<Scalars['ISO8601DateTime']>;
  employee?: Maybe<EmployeesEmployee>;
  /**
   * The ID of the employee the per diem is for.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  employeeId?: Maybe<Scalars['Int']>;
  /** The end date of the per diem. */
  endDate?: Maybe<Scalars['ISO8601DateTime']>;
  expensable: ExpensesExpensable;
  /**
   * The ID of the expensable the per diem is for.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  expensesExpensableId?: Maybe<Scalars['Int']>;
  /** The files attached to the per diem. */
  files: Array<ExpensesFile>;
  /** The location the per diem is from. */
  from?: Maybe<Scalars['String']>;
  /** The ID of the per diem. */
  id: Scalars['Int'];
  ledgerAccount?: Maybe<FinanceAccount>;
  /**
   * The ID of the ledger account the per diem is for.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  ledgerAccountId?: Maybe<Scalars['Int']>;
  /** The date the per diem was paid. */
  paidAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The payment method for the per diem. */
  payment: ExpensesValueObjectsPaymentOptionsEnum;
  perDiemRates: Array<ExpensesPerDiemRate>;
  perDiemRatesConnection: ExpensesPerDiemRateConnection;
  /** The id of the project associated with this per diem */
  projectId?: Maybe<Scalars['Int']>;
  /** The amount to be reimbursed by the per diem in cents. */
  reimbursableAmount?: Maybe<Scalars['Int']>;
  /** The currency for the reimbursable amount. */
  reimbursableCurrency?: Maybe<Scalars['String']>;
  /** The date the per diem was requested for review. */
  reviewRequestAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The start date of the per diem. */
  startDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** The status of the per diem. */
  status: ExpensesEntitiesExpensableStatusEnum;
  /** The subcategory of the per diem. */
  subcategory?: Maybe<Scalars['String']>;
  /** The location the per diem is to. */
  to?: Maybe<Scalars['String']>;
};


/** Represents a per diem */
export type ExpensesPerDiemEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Represents a per diem */
export type ExpensesPerDiemExpensableArgs = {
  byResources?: InputMaybe<Array<ExpensablesByResourcesInput>>;
  categories?: InputMaybe<Array<Scalars['String']>>;
  companyId?: InputMaybe<Scalars['Int']>;
  creationType?: InputMaybe<Array<Scalars['String']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  from?: InputMaybe<Scalars['ISO8601DateTime']>;
  groupIds?: InputMaybe<Array<Scalars['Int']>>;
  includeAttachments?: Scalars['Boolean'];
  includeGrouped?: Scalars['Boolean'];
  includeManualDrafts?: Scalars['Boolean'];
  onlyGrouped?: InputMaybe<Scalars['Boolean']>;
  perDiemEndDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  perDiemStartDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  reporterIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Array<ExpensesEntitiesExpensableStatusEnum>>;
  to?: InputMaybe<Scalars['ISO8601DateTime']>;
  withReimbursableCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** Represents a per diem */
export type ExpensesPerDiemLedgerAccountArgs = {
  includeDisabled?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  number?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Array<Scalars['String']>>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Represents a per diem */
export type ExpensesPerDiemPerDiemRatesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Represents a per diem */
export type ExpensesPerDiemPerDiemRatesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for ExpensesPerDiem. */
export type ExpensesPerDiemConnection = {
  __typename?: 'ExpensesPerDiemConnection';
  /** A list of edges. */
  edges: Array<ExpensesPerDiemEdge>;
  /** A list of nodes. */
  nodes: Array<ExpensesPerDiem>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ExpensesPerDiemEdge = {
  __typename?: 'ExpensesPerDiemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ExpensesPerDiem;
};

/** the filter for the per_diems resource */
export type ExpensesPerDiemFilter = {
  amount?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<ExpensesPerDiemFilterConditions>>;
};

export type ExpensesPerDiemFilterConditions = {
  amount?: InputMaybe<StringFilter>;
};

/** Represents a per diem rate */
export type ExpensesPerDiemRate = {
  __typename?: 'ExpensesPerDiemRate';
  expensesPerDiemId: Scalars['Int'];
  id?: Maybe<Scalars['Int']>;
  rateConfiguration: ExpensesRateConfiguration;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  rateConfigurationId: Scalars['Int'];
  totalAmountCents?: Maybe<Scalars['Int']>;
  totalDays?: Maybe<Scalars['Int']>;
};


/** Represents a per diem rate */
export type ExpensesPerDiemRateRateConfigurationArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  archivedOnly?: InputMaybe<Scalars['Boolean']>;
  companyId: Scalars['Int'];
  currency?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceType?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};

/** The connection type for ExpensesPerDiemRate. */
export type ExpensesPerDiemRateConnection = {
  __typename?: 'ExpensesPerDiemRateConnection';
  /** A list of edges. */
  edges: Array<ExpensesPerDiemRateEdge>;
  /** A list of nodes. */
  nodes: Array<ExpensesPerDiemRate>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ExpensesPerDiemRateEdge = {
  __typename?: 'ExpensesPerDiemRateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ExpensesPerDiemRate;
};

export type ExpensesPolicyComplianceResult = {
  __typename?: 'ExpensesPolicyComplianceResult';
  flags?: Maybe<Array<ExpensesFlag>>;
  relevantPolicies?: Maybe<Array<Scalars['String']>>;
};

/** Workflow for managing policies related to expenses */
export type ExpensesPolicyWorkflow = {
  __typename?: 'ExpensesPolicyWorkflow';
  id: Scalars['Int'];
};

/** The connection type for ExpensesPolicyWorkflow. */
export type ExpensesPolicyWorkflowConnection = {
  __typename?: 'ExpensesPolicyWorkflowConnection';
  /** A list of edges. */
  edges: Array<ExpensesPolicyWorkflowEdge>;
  /** A list of nodes. */
  nodes: Array<ExpensesPolicyWorkflow>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ExpensesPolicyWorkflowEdge = {
  __typename?: 'ExpensesPolicyWorkflowEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ExpensesPolicyWorkflow;
};

export type ExpensesProjectInput = {
  projectWorkerId: Scalars['Int'];
  subprojectId?: InputMaybe<Scalars['Int']>;
};

/** Represents the company rates used for expensable reimbursement (Per Diem) */
export type ExpensesRateConfiguration = {
  __typename?: 'ExpensesRateConfiguration';
  accessIds: Array<Scalars['Int']>;
  activeUntil?: Maybe<Scalars['ISO8601DateTime']>;
  amountCents?: Maybe<Scalars['Int']>;
  archivedAt?: Maybe<Scalars['ISO8601DateTime']>;
  companyId: Scalars['Int'];
  currency: Scalars['String'];
  id: Scalars['Int'];
  legalEntities: Array<CompaniesLegalEntity>;
  legalEntitiesConnection: CompaniesLegalEntityConnection;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  legalEntityIds: Array<Scalars['Int']>;
  membershipIds: Array<Scalars['Int']>;
  name: Scalars['String'];
  rate?: Maybe<Scalars['Float']>;
  rateAssignees: Array<ExpensesRateConfigurationAssignee>;
  rateAssigneesConnection: ExpensesRateConfigurationAssigneeConnection;
  strategy: ExpensesDtosRateConfigurationPeopleGroupStrategyEnum;
};


/** Represents the company rates used for expensable reimbursement (Per Diem) */
export type ExpensesRateConfigurationLegalEntitiesArgs = {
  companiesIds?: InputMaybe<Array<Scalars['Int']>>;
  countryIds?: InputMaybe<Array<Scalars['String']>>;
  employeesIds?: InputMaybe<Array<Scalars['Int']>>;
  excludeCountries?: InputMaybe<Array<Scalars['String']>>;
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


/** Represents the company rates used for expensable reimbursement (Per Diem) */
export type ExpensesRateConfigurationLegalEntitiesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companiesIds?: InputMaybe<Array<Scalars['Int']>>;
  countryIds?: InputMaybe<Array<Scalars['String']>>;
  employeesIds?: InputMaybe<Array<Scalars['Int']>>;
  excludeCountries?: InputMaybe<Array<Scalars['String']>>;
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Represents the company rates used for expensable reimbursement (Per Diem) */
export type ExpensesRateConfigurationRateAssigneesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


/** Represents the company rates used for expensable reimbursement (Per Diem) */
export type ExpensesRateConfigurationRateAssigneesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};

/** Represents the assignees of rate configurations */
export type ExpensesRateConfigurationAssignee = {
  __typename?: 'ExpensesRateConfigurationAssignee';
  avatar?: Maybe<Scalars['String']>;
  fullName: Scalars['String'];
  id: Scalars['Int'];
  rateId: Scalars['Int'];
};

/** The connection type for ExpensesRateConfigurationAssignee. */
export type ExpensesRateConfigurationAssigneeConnection = {
  __typename?: 'ExpensesRateConfigurationAssigneeConnection';
  /** A list of edges. */
  edges: Array<ExpensesRateConfigurationAssigneeEdge>;
  /** A list of nodes. */
  nodes: Array<ExpensesRateConfigurationAssignee>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ExpensesRateConfigurationAssigneeEdge = {
  __typename?: 'ExpensesRateConfigurationAssigneeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ExpensesRateConfigurationAssignee;
};

/** The connection type for ExpensesRateConfiguration. */
export type ExpensesRateConfigurationConnection = {
  __typename?: 'ExpensesRateConfigurationConnection';
  /** A list of edges. */
  edges: Array<ExpensesRateConfigurationEdge>;
  /** A list of nodes. */
  nodes: Array<ExpensesRateConfiguration>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ExpensesRateConfigurationEdge = {
  __typename?: 'ExpensesRateConfigurationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ExpensesRateConfiguration;
};

/** the filter for the rate_configurations resource */
export type ExpensesRateConfigurationFilter = {
  amountCents?: InputMaybe<IntegerFilter>;
  archivedAt?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<StringFilter>;
  employeeIds?: InputMaybe<IntegerFilter>;
  id?: InputMaybe<IntegerFilter>;
  legalEntityIds?: InputMaybe<IntegerFilter>;
  name?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<ExpensesRateConfigurationFilterConditions>>;
  rate?: InputMaybe<NumberFilter>;
};

export type ExpensesRateConfigurationFilterConditions = {
  amountCents?: InputMaybe<IntegerFilter>;
  archivedAt?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<StringFilter>;
  employeeIds?: InputMaybe<IntegerFilter>;
  id?: InputMaybe<IntegerFilter>;
  legalEntityIds?: InputMaybe<IntegerFilter>;
  name?: InputMaybe<StringFilter>;
  rate?: InputMaybe<NumberFilter>;
};

/** Expenses recommendation result */
export type ExpensesRecommendationResult = {
  __typename?: 'ExpensesRecommendationResult';
  aiResponse?: Maybe<ExpensesPolicyComplianceResult>;
  companyId: Scalars['Int'];
  humanComment?: Maybe<Scalars['String']>;
  humanValidation?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
};

export type ExpensesSerializableIssue = {
  __typename?: 'ExpensesSerializableIssue';
  fieldName: Scalars['String'];
  type: ExpensesValueObjectsValidationsSerializableIssueTypeEnum;
};

export type ExpensesShippingAddress = {
  __typename?: 'ExpensesShippingAddress';
  city: Scalars['String'];
  country: Scalars['String'];
  fullName?: Maybe<Scalars['String']>;
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  postalCode: Scalars['String'];
  state: Scalars['String'];
};

/** Expenses signed document */
export type ExpensesSignedDocument = {
  __typename?: 'ExpensesSignedDocument';
  createdAt: Scalars['ISO8601DateTime'];
  documentOrigin?: Maybe<ExpensesValueObjectsDocumentOriginEnum>;
  files: Array<ApiCoreAttachment>;
  filesConnection: ApiCoreAttachmentConnection;
  id: Scalars['Int'];
  signedForOrganization: Scalars['String'];
  signing?: Maybe<Scalars['Boolean']>;
};


/** Expenses signed document */
export type ExpensesSignedDocumentFilesArgs = {
  attachmentName?: InputMaybe<Scalars['String']>;
};


/** Expenses signed document */
export type ExpensesSignedDocumentFilesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  attachmentName?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

export type ExpensesSignedDocumentFile = {
  __typename?: 'ExpensesSignedDocumentFile';
  createdAt: Scalars['ISO8601DateTime'];
  file?: Maybe<ExpensesFile>;
  id: Scalars['Int'];
  originalFiles: Array<ExpensesFile>;
  signedForOrganization: Scalars['String'];
  signing: Scalars['Boolean'];
};

/** Expenses signed documents term */
export type ExpensesSignedDocumentsTerm = {
  __typename?: 'ExpensesSignedDocumentsTerm';
  accepted: Scalars['Boolean'];
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['Int'];
  legalEntityId: Scalars['Int'];
  organization: Scalars['String'];
};

/** The connection type for ExpensesSignedDocumentsTerm. */
export type ExpensesSignedDocumentsTermConnection = {
  __typename?: 'ExpensesSignedDocumentsTermConnection';
  /** A list of edges. */
  edges: Array<ExpensesSignedDocumentsTermEdge>;
  /** A list of nodes. */
  nodes: Array<ExpensesSignedDocumentsTerm>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ExpensesSignedDocumentsTermEdge = {
  __typename?: 'ExpensesSignedDocumentsTermEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ExpensesSignedDocumentsTerm;
};

/** Signed Invoices from Expensables */
export type ExpensesSignedInvoice = {
  __typename?: 'ExpensesSignedInvoice';
  accountingDate?: Maybe<Scalars['ISO8601DateTime']>;
  amount: Scalars['Int'];
  beenTampered: Scalars['Boolean'];
  closed: Scalars['Boolean'];
  currency: Scalars['String'];
  discountAmount?: Maybe<Scalars['Int']>;
  documentDate?: Maybe<Scalars['ISO8601DateTime']>;
  emitterName?: Maybe<Scalars['String']>;
  emitterTin?: Maybe<Scalars['String']>;
  expensesClosingPeriod?: Maybe<ExpensesClosingPeriod>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  expensesClosingPeriodId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  invoiceType?: Maybe<Scalars['String']>;
  legalEntity?: Maybe<CompaniesLegalEntity>;
  missingRequiredData: Scalars['Boolean'];
  number?: Maybe<Scalars['String']>;
  parentExpense?: Maybe<ExpensesExpense>;
  parentExpenseStatus: Scalars['String'];
  parentSignedDocument?: Maybe<ExpensesSignedDocument>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  receiverLegalEntityId?: Maybe<Scalars['Int']>;
  receiverName?: Maybe<Scalars['String']>;
  receiverTin?: Maybe<Scalars['String']>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  signedDocumentId?: Maybe<Scalars['Int']>;
  taxes?: Maybe<ExpensesSignedInvoiceTaxes>;
};


/** Signed Invoices from Expensables */
export type ExpensesSignedInvoiceExpensesClosingPeriodArgs = {
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Signed Invoices from Expensables */
export type ExpensesSignedInvoiceLegalEntityArgs = {
  companiesIds?: InputMaybe<Array<Scalars['Int']>>;
  countryIds?: InputMaybe<Array<Scalars['String']>>;
  employeesIds?: InputMaybe<Array<Scalars['Int']>>;
  excludeCountries?: InputMaybe<Array<Scalars['String']>>;
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


/** Signed Invoices from Expensables */
export type ExpensesSignedInvoiceParentExpenseArgs = {
  cardIds?: InputMaybe<Array<Scalars['Int']>>;
  cardPaymentIds?: InputMaybe<Array<Scalars['Int']>>;
  disputeIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  expensesExpensableIds?: InputMaybe<Array<Scalars['Int']>>;
  externalAuthorizationIds?: InputMaybe<Array<Scalars['String']>>;
  from?: InputMaybe<Scalars['ISO8601DateTime']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeAttachments?: Scalars['Boolean'];
  includeReimbursableData?: InputMaybe<Scalars['Boolean']>;
  to?: InputMaybe<Scalars['ISO8601DateTime']>;
};

/** The connection type for ExpensesSignedInvoice. */
export type ExpensesSignedInvoiceConnection = {
  __typename?: 'ExpensesSignedInvoiceConnection';
  /** A list of edges. */
  edges: Array<ExpensesSignedInvoiceEdge>;
  /** A list of nodes. */
  nodes: Array<ExpensesSignedInvoice>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ExpensesSignedInvoiceEdge = {
  __typename?: 'ExpensesSignedInvoiceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ExpensesSignedInvoice;
};

/** Export Signed Invoices from Expensables */
export type ExpensesSignedInvoiceExport = {
  __typename?: 'ExpensesSignedInvoiceExport';
  success: Scalars['Boolean'];
};

/** the filter for the signed_invoices resource */
export type ExpensesSignedInvoiceFilter = {
  accountingDate?: InputMaybe<DateTimeFilter>;
  amount?: InputMaybe<IntegerFilter>;
  emitterName?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<ExpensesSignedInvoiceFilterConditions>>;
  parentExpenseStatus?: InputMaybe<StringFilter>;
};

export type ExpensesSignedInvoiceFilterConditions = {
  accountingDate?: InputMaybe<DateTimeFilter>;
  amount?: InputMaybe<IntegerFilter>;
  emitterName?: InputMaybe<StringFilter>;
  parentExpenseStatus?: InputMaybe<StringFilter>;
};

export type ExpensesSignedInvoiceTax = {
  __typename?: 'ExpensesSignedInvoiceTax';
  amount?: Maybe<Scalars['Int']>;
  baseAmount?: Maybe<Scalars['Int']>;
  percentage?: Maybe<Scalars['Float']>;
};

export type ExpensesSignedInvoiceTaxes = {
  __typename?: 'ExpensesSignedInvoiceTaxes';
  equalizationTax?: Maybe<ExpensesSignedInvoiceTax>;
  irpf?: Maybe<ExpensesSignedInvoiceTax>;
  vats: Array<ExpensesSignedInvoiceTax>;
};

export type ExpensesSpendingControl = {
  __typename?: 'ExpensesSpendingControl';
  allowedCategories?: Maybe<Array<Scalars['String']>>;
  blockedCategories?: Maybe<Array<Scalars['String']>>;
  spendingLimits: Array<ExpensesSpendingLimit>;
  spendingLimitsCurrency: Scalars['String'];
};

export type ExpensesSpendingLimit = {
  __typename?: 'ExpensesSpendingLimit';
  amount: Scalars['Int'];
  categories: Array<ExpensesExpenseCategory>;
  interval: ExpensesValueObjectsSpendingLimitIntervalEnum;
  resetsOn?: Maybe<Scalars['ISO8601DateTime']>;
};

export type ExpensesTax = {
  __typename?: 'ExpensesTax';
  amount?: Maybe<Scalars['Int']>;
  baseAmount?: Maybe<Scalars['Int']>;
  percentage?: Maybe<Scalars['Float']>;
  type: ExpensesCustomizationExpenseTaxesTypesEnum;
};

export type ExpensesValueObjectsCardTypeEnum =
  | 'physical'
  | 'single_use'
  | 'virtual';

export type ExpensesValueObjectsClosingPeriodFrequenciesEnum =
  | 'monthly'
  | 'quarterly';

export type ExpensesValueObjectsCreationTypeEnum =
  | 'automatic'
  | 'manual'
  | 'travelperk';

export type ExpensesValueObjectsCustomizationDocumentTypeEnum =
  | 'default'
  | 'invoice';

export type ExpensesValueObjectsDocumentOriginEnum =
  | 'camera'
  | 'file';

export type ExpensesValueObjectsPaymentOptionsEnum =
  | 'not_reimbursable'
  | 'reimbursable';

export type ExpensesValueObjectsPerDiemCalculationExcludedConceptEnum =
  | 'accommodation'
  | 'breakfast'
  | 'dinner'
  | 'lunch';

export type ExpensesValueObjectsSpendingLimitIntervalEnum =
  | 'daily'
  | 'monthly'
  | 'weekly'
  | 'yearly';

export type ExpensesValueObjectsTaxAgencyOrganizationsEnum =
  | 'aeat'
  | 'urssaf';

export type ExpensesValueObjectsValidationsSerializableIssueTypeEnum =
  | 'invalidvalue'
  | 'missingfield';

/** Autogenerated return type of ExpireIntegrationsindeedJobPosting. */
export type ExpireIntegrationsindeedJobPostingPayload = {
  __typename?: 'ExpireIntegrationsindeedJobPostingPayload';
  errors: Array<MutationError>;
  jobPosting?: Maybe<IntegrationsIndeedJobPosting>;
};

/** Autogenerated return type of ExpireOnUninstallIntegrationsindeedJobPosting. */
export type ExpireOnUninstallIntegrationsindeedJobPostingPayload = {
  __typename?: 'ExpireOnUninstallIntegrationsindeedJobPostingPayload';
  errors: Array<MutationError>;
  jobPosting?: Maybe<IntegrationsIndeedJobPosting>;
};

/** Autogenerated return type of ExportBankingReconciliation. */
export type ExportBankingReconciliationPayload = {
  __typename?: 'ExportBankingReconciliationPayload';
  errors: Array<MutationError>;
  reconciliation?: Maybe<BankingReconciliation>;
};

/** Autogenerated return type of ExportCsvOneononesExport. */
export type ExportCsvOneononesExportPayload = {
  __typename?: 'ExportCsvOneononesExportPayload';
  errors: Array<MutationError>;
  export?: Maybe<OneOnOnesExport>;
};

/** Autogenerated return type of ExportExpensesSignedInvoiceExport. */
export type ExportExpensesSignedInvoiceExportPayload = {
  __typename?: 'ExportExpensesSignedInvoiceExportPayload';
  errors: Array<MutationError>;
  signedInvoiceExport?: Maybe<ExpensesSignedInvoiceExport>;
};

/** Autogenerated return type of ExportExpensesSignedInvoice. */
export type ExportExpensesSignedInvoicePayload = {
  __typename?: 'ExportExpensesSignedInvoicePayload';
  errors: Array<MutationError>;
  signedInvoice?: Maybe<ExpensesSignedInvoice>;
};

/** Autogenerated return type of ExportFinanceCustomDimensionMembership. */
export type ExportFinanceCustomDimensionMembershipPayload = {
  __typename?: 'ExportFinanceCustomDimensionMembershipPayload';
  customDimensionMembership?: Maybe<FinanceCustomDimensionMembership>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of ExportFinancialworkspaceExportExportFinanceFactSummary. */
export type ExportFinancialworkspaceExportExportFinanceFactSummaryPayload = {
  __typename?: 'ExportFinancialworkspaceExportExportFinanceFactSummaryPayload';
  errors: Array<MutationError>;
  exportFinanceFactSummary?: Maybe<FinancialWorkspaceExportFinanceFactSummary>;
};

/** Autogenerated return type of ExportFinancialworkspaceExportExportGrossSalary. */
export type ExportFinancialworkspaceExportExportGrossSalaryPayload = {
  __typename?: 'ExportFinancialworkspaceExportExportGrossSalaryPayload';
  errors: Array<MutationError>;
  exportGrossSalary?: Maybe<FinancialWorkspaceExportGrossSalary>;
};

/** Autogenerated return type of ExportFinancialworkspaceExportExportPayrollLineItem. */
export type ExportFinancialworkspaceExportExportPayrollLineItemPayload = {
  __typename?: 'ExportFinancialworkspaceExportExportPayrollLineItemPayload';
  errors: Array<MutationError>;
  exportPayrollLineItem?: Maybe<FinancialWorkspaceExportPayrollLineItem>;
};

/** Autogenerated return type of ExportPdfExpensesExpensableGroup. */
export type ExportPdfExpensesExpensableGroupPayload = {
  __typename?: 'ExportPdfExpensesExpensableGroupPayload';
  errors: Array<MutationError>;
  expensableGroups?: Maybe<Array<ExpensesExpensableGroup>>;
};

/** Autogenerated return type of ExportPerformanceReviewProcess. */
export type ExportPerformanceReviewProcessPayload = {
  __typename?: 'ExportPerformanceReviewProcessPayload';
  errors: Array<MutationError>;
  reviewProcess?: Maybe<PerformanceReviewProcess>;
};

/** Autogenerated return type of ExportTrainingsFundaeFinishGroup. */
export type ExportTrainingsFundaeFinishGroupPayload = {
  __typename?: 'ExportTrainingsFundaeFinishGroupPayload';
  errors: Array<MutationError>;
  fundaeFinishGroups?: Maybe<Array<TrainingsFundaeFinishGroup>>;
};

/** Fetch employee pictures */
export type FaceRecognitionEmployeePicture = {
  __typename?: 'FaceRecognitionEmployeePicture';
  contentType: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  employeeId: Scalars['Int'];
  filename: Scalars['String'];
  id: Scalars['Int'];
  status: Scalars['String'];
  url: Scalars['String'];
};

/** The connection type for FaceRecognitionEmployeePicture. */
export type FaceRecognitionEmployeePictureConnection = {
  __typename?: 'FaceRecognitionEmployeePictureConnection';
  /** A list of edges. */
  edges: Array<FaceRecognitionEmployeePictureEdge>;
  /** A list of nodes. */
  nodes: Array<FaceRecognitionEmployeePicture>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FaceRecognitionEmployeePictureEdge = {
  __typename?: 'FaceRecognitionEmployeePictureEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FaceRecognitionEmployeePicture;
};

export type FeaturesContextlessPolicies = {
  __typename?: 'FeaturesContextlessPolicies';
  featureRead: ContextlessPolicyResolution;
  featureReset: ContextlessPolicyResolution;
  featureToggle: ContextlessPolicyResolution;
};

/** A feature allows a company to do certain actions on Factorial */
export type FeaturesFeature = {
  __typename?: 'FeaturesFeature';
  company: ApiCoreCompany;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  companyId: Scalars['Int'];
  enabled: Scalars['Boolean'];
  id: Scalars['String'];
  label?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  overrideId?: Maybe<Scalars['Int']>;
};

/** The connection type for FeaturesFeature. */
export type FeaturesFeatureConnection = {
  __typename?: 'FeaturesFeatureConnection';
  /** A list of edges. */
  edges: Array<FeaturesFeatureEdge>;
  /** A list of nodes. */
  nodes: Array<FeaturesFeature>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FeaturesFeatureEdge = {
  __typename?: 'FeaturesFeatureEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FeaturesFeature;
};

/** Manages what access has a specific feature */
export type FeaturesFeatureMembership = {
  __typename?: 'FeaturesFeatureMembership';
  companyId: Scalars['Int'];
  featureId: Scalars['String'];
  id: Scalars['Int'];
  members: Array<PeopleGroupsPeopleGroupMembership>;
  membersConnection: PeopleGroupsPeopleGroupMembershipConnection;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  peopleGroupId: Scalars['Int'];
};


/** Manages what access has a specific feature */
export type FeaturesFeatureMembershipMembersArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  companyId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Manages what access has a specific feature */
export type FeaturesFeatureMembershipMembersConnectionArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for FeaturesFeatureMembership. */
export type FeaturesFeatureMembershipConnection = {
  __typename?: 'FeaturesFeatureMembershipConnection';
  /** A list of edges. */
  edges: Array<FeaturesFeatureMembershipEdge>;
  /** A list of nodes. */
  nodes: Array<FeaturesFeatureMembership>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FeaturesFeatureMembershipEdge = {
  __typename?: 'FeaturesFeatureMembershipEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FeaturesFeatureMembership;
};

/** Autogenerated return type of FeedbackBillingCpChat. */
export type FeedbackBillingCpChatPayload = {
  __typename?: 'FeedbackBillingCpChatPayload';
  cpChat?: Maybe<BillingCpChat>;
  errors: Array<MutationError>;
};

export type FeedbacksContextlessPolicies = {
  __typename?: 'FeedbacksContextlessPolicies';
  sidebarSeePerformanceFeedbacksSubLevelItem: ContextlessPolicyResolution;
};

/** feedback_entry */
export type FeedbacksFeedbackEntry = {
  __typename?: 'FeedbacksFeedbackEntry';
  author: ApiCoreAccess;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  authorId: Scalars['Int'];
  createdAt: Scalars['String'];
  feedback: Scalars['String'];
  id: Scalars['Int'];
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  receiverIds: Array<Scalars['Int']>;
  receivers: Array<ApiCoreAccess>;
  receiversConnection: ApiCoreAccessConnection;
  visibility: FeedbacksFeedbackEntryVisibilityEnum;
};


/** feedback_entry */
export type FeedbacksFeedbackEntryAuthorArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** feedback_entry */
export type FeedbacksFeedbackEntryReceiversArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** feedback_entry */
export type FeedbacksFeedbackEntryReceiversConnectionArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  external?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for FeedbacksFeedbackEntry. */
export type FeedbacksFeedbackEntryConnection = {
  __typename?: 'FeedbacksFeedbackEntryConnection';
  /** A list of edges. */
  edges: Array<FeedbacksFeedbackEntryEdge>;
  /** A list of nodes. */
  nodes: Array<FeedbacksFeedbackEntry>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FeedbacksFeedbackEntryEdge = {
  __typename?: 'FeedbacksFeedbackEntryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FeedbacksFeedbackEntry;
};

/** the filter for the feedback_entries resource */
export type FeedbacksFeedbackEntryFilter = {
  authorId?: InputMaybe<IntegerFilter>;
  or?: InputMaybe<Array<FeedbacksFeedbackEntryFilterConditions>>;
};

export type FeedbacksFeedbackEntryFilterConditions = {
  authorId?: InputMaybe<IntegerFilter>;
};

export type FeedbacksFeedbackEntryVisibilityEnum =
  | 'manager_only'
  | 'private'
  | 'private_and_manager';

/** feedback_request */
export type FeedbacksFeedbackRequest = {
  __typename?: 'FeedbacksFeedbackRequest';
  author: ApiCoreAccess;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  authorId: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  description: Scalars['String'];
  entryVisibility: FeedbacksFeedbackEntryVisibilityEnum;
  id: Scalars['Int'];
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  receiverIds: Array<Scalars['Int']>;
  receivers: Array<ApiCoreAccess>;
  receiversConnection: ApiCoreAccessConnection;
};


/** feedback_request */
export type FeedbacksFeedbackRequestAuthorArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** feedback_request */
export type FeedbacksFeedbackRequestReceiversArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** feedback_request */
export type FeedbacksFeedbackRequestReceiversConnectionArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  external?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for FeedbacksFeedbackRequest. */
export type FeedbacksFeedbackRequestConnection = {
  __typename?: 'FeedbacksFeedbackRequestConnection';
  /** A list of edges. */
  edges: Array<FeedbacksFeedbackRequestEdge>;
  /** A list of nodes. */
  nodes: Array<FeedbacksFeedbackRequest>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FeedbacksFeedbackRequestEdge = {
  __typename?: 'FeedbacksFeedbackRequestEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FeedbacksFeedbackRequest;
};

/** Autogenerated return type of FetchAtsApplication. */
export type FetchAtsApplicationPayload = {
  __typename?: 'FetchAtsApplicationPayload';
  application?: Maybe<AtsApplication>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of FetchAtsJobPosting. */
export type FetchAtsJobPostingPayload = {
  __typename?: 'FetchAtsJobPostingPayload';
  errors: Array<MutationError>;
  jobPosting?: Maybe<AtsJobPosting>;
};

/** Autogenerated return type of FetchPositionsPosition. */
export type FetchPositionsPositionPayload = {
  __typename?: 'FetchPositionsPositionPayload';
  errors: Array<MutationError>;
  position?: Maybe<PositionsPosition>;
};

/** Autogenerated return type of FillDocumentDocumentsDocument. */
export type FillDocumentDocumentsDocumentPayload = {
  __typename?: 'FillDocumentDocumentsDocumentPayload';
  document?: Maybe<DocumentsDocument>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of FilterApprovalsMaterializedApprovalsFlow. */
export type FilterApprovalsMaterializedApprovalsFlowPayload = {
  __typename?: 'FilterApprovalsMaterializedApprovalsFlowPayload';
  errors: Array<MutationError>;
  materializedApprovalsFlow?: Maybe<ApprovalsMaterializedApprovalsFlow>;
};

/** Autogenerated return type of FilterTasksTaskFile. */
export type FilterTasksTaskFilePayload = {
  __typename?: 'FilterTasksTaskFilePayload';
  errors: Array<MutationError>;
  taskFile?: Maybe<TasksTaskFile>;
};

/** Ledger account refers to a structured entity that represents an account within a general ledger system. */
export type FinanceAccount = {
  __typename?: 'FinanceAccount';
  balance: Scalars['Int'];
  creditAmount: Scalars['Int'];
  currency: Scalars['String'];
  debitAmount: Scalars['Int'];
  /** Whether the ledger account is disabled */
  disabled: Scalars['Boolean'];
  /** Id of the ledger account on the external system */
  externalId?: Maybe<Scalars['String']>;
  /** Unique identifier in factorial for the ledger account */
  id: Scalars['Int'];
  journalEntries: Array<FinanceJournalEntry>;
  journalEntriesConnection: FinanceJournalEntryConnection;
  journalLines: Array<FinanceJournalLine>;
  journalLinesConnection: FinanceJournalLineConnection;
  legalEntity: CompaniesLegalEntity;
  /**
   * Legal entity ID of the ledger account
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  legalEntityId: Scalars['Int'];
  /** Name of the ledger account */
  name?: Maybe<Scalars['String']>;
  /** Number of the ledger account */
  number: Scalars['String'];
  /** Type of the ledger account */
  type: FinanceValueObjectsAccountTypeEnum;
  /** Last updated date of the ledger account */
  updatedAt: Scalars['ISO8601DateTime'];
};


/** Ledger account refers to a structured entity that represents an account within a general ledger system. */
export type FinanceAccountJournalEntriesArgs = {
  bankTransactionIds?: InputMaybe<Array<Scalars['Int']>>;
  financialDocumentIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  invoiceIds?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  publishedFrom?: InputMaybe<Scalars['ISO8601Date']>;
  status?: InputMaybe<FinanceValueObjectsJournalEntryStatusEnum>;
  types?: InputMaybe<Array<FinanceValueObjectsJournalEntryTypeEnum>>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Ledger account refers to a structured entity that represents an account within a general ledger system. */
export type FinanceAccountJournalEntriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  bankTransactionIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  financialDocumentIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  invoiceIds?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  publishedFrom?: InputMaybe<Scalars['ISO8601Date']>;
  sortOrder?: InputMaybe<Sort>;
  status?: InputMaybe<FinanceValueObjectsJournalEntryStatusEnum>;
  types?: InputMaybe<Array<FinanceValueObjectsJournalEntryTypeEnum>>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Ledger account refers to a structured entity that represents an account within a general ledger system. */
export type FinanceAccountJournalLinesArgs = {
  balanceTypes?: InputMaybe<Array<FinanceValueObjectsLedgerAccountBalanceTypeEnum>>;
  bankAccountIds?: InputMaybe<Array<Scalars['Int']>>;
  bySuspenseAccount?: InputMaybe<Scalars['Boolean']>;
  currency?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  excludingJournalEntryTypes?: InputMaybe<Array<FinanceValueObjectsJournalEntryTypeEnum>>;
  financialDocumentIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  journalEntryIds?: InputMaybe<Array<Scalars['Int']>>;
  journalEntryTypes?: InputMaybe<Array<FinanceValueObjectsJournalEntryTypeEnum>>;
  reconcilable?: InputMaybe<Scalars['Boolean']>;
  reconciliationStatus?: InputMaybe<FinanceValueObjectsReconciliationStatusEnum>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Ledger account refers to a structured entity that represents an account within a general ledger system. */
export type FinanceAccountJournalLinesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  balanceTypes?: InputMaybe<Array<FinanceValueObjectsLedgerAccountBalanceTypeEnum>>;
  bankAccountIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  bySuspenseAccount?: InputMaybe<Scalars['Boolean']>;
  currency?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  excludingJournalEntryTypes?: InputMaybe<Array<FinanceValueObjectsJournalEntryTypeEnum>>;
  financialDocumentIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  journalEntryIds?: InputMaybe<Array<Scalars['Int']>>;
  journalEntryTypes?: InputMaybe<Array<FinanceValueObjectsJournalEntryTypeEnum>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  reconcilable?: InputMaybe<Scalars['Boolean']>;
  reconciliationStatus?: InputMaybe<FinanceValueObjectsReconciliationStatusEnum>;
  sortOrder?: InputMaybe<Sort>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Ledger account refers to a structured entity that represents an account within a general ledger system. */
export type FinanceAccountLegalEntityArgs = {
  companiesIds?: InputMaybe<Array<Scalars['Int']>>;
  countryIds?: InputMaybe<Array<Scalars['String']>>;
  employeesIds?: InputMaybe<Array<Scalars['Int']>>;
  excludeCountries?: InputMaybe<Array<Scalars['String']>>;
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};

/** The connection type for FinanceAccount. */
export type FinanceAccountConnection = {
  __typename?: 'FinanceAccountConnection';
  /** A list of edges. */
  edges: Array<FinanceAccountEdge>;
  /** A list of nodes. */
  nodes: Array<FinanceAccount>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FinanceAccountEdge = {
  __typename?: 'FinanceAccountEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FinanceAccount;
};

/** the filter for the accounts resource */
export type FinanceAccountFilter = {
  externalId?: InputMaybe<StringFilter>;
  legalEntity?: InputMaybe<IntegerFilter>;
  legalEntityId?: InputMaybe<IntegerFilter>;
  name?: InputMaybe<StringFilter>;
  number?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<FinanceAccountFilterConditions>>;
  type?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type FinanceAccountFilterConditions = {
  externalId?: InputMaybe<StringFilter>;
  legalEntity?: InputMaybe<IntegerFilter>;
  legalEntityId?: InputMaybe<IntegerFilter>;
  name?: InputMaybe<StringFilter>;
  number?: InputMaybe<StringFilter>;
  type?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

/** Finance account import */
export type FinanceAccountImport = {
  __typename?: 'FinanceAccountImport';
  added: Scalars['Int'];
  disabled: Scalars['Int'];
  legalEntity: CompaniesLegalEntity;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  legalEntityId: Scalars['Int'];
  received: Scalars['Int'];
  updated: Scalars['Int'];
};


/** Finance account import */
export type FinanceAccountImportLegalEntityArgs = {
  companiesIds?: InputMaybe<Array<Scalars['Int']>>;
  countryIds?: InputMaybe<Array<Scalars['String']>>;
  employeesIds?: InputMaybe<Array<Scalars['Int']>>;
  excludeCountries?: InputMaybe<Array<Scalars['String']>>;
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};

/** Finance account import template */
export type FinanceAccountImportTemplate = {
  __typename?: 'FinanceAccountImportTemplate';
  fileInBase64: Scalars['String'];
  fileName: Scalars['String'];
  fileType: Scalars['String'];
  id: Scalars['String'];
};

/** The connection type for FinanceAccountImportTemplate. */
export type FinanceAccountImportTemplateConnection = {
  __typename?: 'FinanceAccountImportTemplateConnection';
  /** A list of edges. */
  edges: Array<FinanceAccountImportTemplateEdge>;
  /** A list of nodes. */
  nodes: Array<FinanceAccountImportTemplate>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FinanceAccountImportTemplateEdge = {
  __typename?: 'FinanceAccountImportTemplateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FinanceAccountImportTemplate;
};

/** Accounting Settings default configurations */
export type FinanceAccountingSetting = {
  __typename?: 'FinanceAccountingSetting';
  /** ID of the associated Company. */
  companyId: Scalars['Int'];
  defaultAccountForBanks?: Maybe<FinanceAccount>;
  /**
   * Default account for banks.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  defaultAccountForBanksId?: Maybe<Scalars['Int']>;
  defaultAccountForBenefits?: Maybe<FinanceAccount>;
  /**
   * Default account for benefits.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  defaultAccountForBenefitsId?: Maybe<Scalars['Int']>;
  defaultAccountForClients?: Maybe<FinanceAccount>;
  /**
   * Default account for clients.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  defaultAccountForClientsId?: Maybe<Scalars['Int']>;
  defaultAccountForEmployees?: Maybe<FinanceAccount>;
  /**
   * Default account for employees.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  defaultAccountForEmployeesId?: Maybe<Scalars['Int']>;
  defaultAccountForExpenses?: Maybe<FinanceAccount>;
  /**
   * Default account for expenses.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  defaultAccountForExpensesId?: Maybe<Scalars['Int']>;
  defaultAccountForPurchaseInvoices?: Maybe<FinanceAccount>;
  /**
   * Default account for purchase invoices.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  defaultAccountForPurchaseInvoicesId?: Maybe<Scalars['Int']>;
  defaultAccountForSaleInvoices?: Maybe<FinanceAccount>;
  /**
   * Default account for sale invoices.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  defaultAccountForSaleInvoicesId?: Maybe<Scalars['Int']>;
  defaultAccountForSuspense?: Maybe<FinanceAccount>;
  /**
   * Default suspense account.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  defaultAccountForSuspenseId?: Maybe<Scalars['Int']>;
  defaultAccountForVendors?: Maybe<FinanceAccount>;
  /**
   * Default account for vendors.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  defaultAccountForVendorsId?: Maybe<Scalars['Int']>;
  /** External ID for the accounting setting. */
  externalId?: Maybe<Scalars['String']>;
  /** Identifier for the AccountingSetting. */
  id: Scalars['Int'];
  /** ID of the associated Legal Entity. */
  legalEntityId: Scalars['Int'];
  /** Timestamp when the accounting setting was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};


/** Accounting Settings default configurations */
export type FinanceAccountingSettingDefaultAccountForBanksArgs = {
  includeDisabled?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  number?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Array<Scalars['String']>>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Accounting Settings default configurations */
export type FinanceAccountingSettingDefaultAccountForBenefitsArgs = {
  includeDisabled?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  number?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Array<Scalars['String']>>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Accounting Settings default configurations */
export type FinanceAccountingSettingDefaultAccountForClientsArgs = {
  includeDisabled?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  number?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Array<Scalars['String']>>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Accounting Settings default configurations */
export type FinanceAccountingSettingDefaultAccountForEmployeesArgs = {
  includeDisabled?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  number?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Array<Scalars['String']>>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Accounting Settings default configurations */
export type FinanceAccountingSettingDefaultAccountForExpensesArgs = {
  includeDisabled?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  number?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Array<Scalars['String']>>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Accounting Settings default configurations */
export type FinanceAccountingSettingDefaultAccountForPurchaseInvoicesArgs = {
  includeDisabled?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  number?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Array<Scalars['String']>>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Accounting Settings default configurations */
export type FinanceAccountingSettingDefaultAccountForSaleInvoicesArgs = {
  includeDisabled?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  number?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Array<Scalars['String']>>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Accounting Settings default configurations */
export type FinanceAccountingSettingDefaultAccountForSuspenseArgs = {
  includeDisabled?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  number?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Array<Scalars['String']>>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Accounting Settings default configurations */
export type FinanceAccountingSettingDefaultAccountForVendorsArgs = {
  includeDisabled?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  number?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Array<Scalars['String']>>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};

/** The connection type for FinanceAccountingSetting. */
export type FinanceAccountingSettingConnection = {
  __typename?: 'FinanceAccountingSettingConnection';
  /** A list of edges. */
  edges: Array<FinanceAccountingSettingEdge>;
  /** A list of nodes. */
  nodes: Array<FinanceAccountingSetting>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FinanceAccountingSettingEdge = {
  __typename?: 'FinanceAccountingSettingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FinanceAccountingSetting;
};

/** the filter for the accounting_settings resource */
export type FinanceAccountingSettingFilter = {
  or?: InputMaybe<Array<FinanceAccountingSettingFilterConditions>>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type FinanceAccountingSettingFilterConditions = {
  updatedAt?: InputMaybe<DateTimeFilter>;
};

/** budget */
export type FinanceBudget = {
  __typename?: 'FinanceBudget';
  _policies?: Maybe<FinanceBudgetPolicies>;
  _policiesCollection?: Maybe<Array<PermissionsPolicyResolution>>;
  _policiesConnection: PermissionsPolicyResolutionConnection;
  active: Scalars['Boolean'];
  allocatedAmountCents: Scalars['BigInt'];
  amountCents: Scalars['BigInt'];
  archived: Scalars['Boolean'];
  availableAmountCents: Scalars['BigInt'];
  budgetAllocations: Array<FinanceBudgetAllocation>;
  budgetAllocationsConnection: FinanceBudgetAllocationConnection;
  budgetMovements: Array<FinanceBudgetMovement>;
  budgetMovementsConnection: FinanceBudgetMovementConnection;
  createdAt: Scalars['ISO8601DateTime'];
  currency: Scalars['String'];
  currentPeriodEnd?: Maybe<Scalars['ISO8601DateTime']>;
  currentPeriodStart: Scalars['ISO8601DateTime'];
  currentStatus: FinanceValueObjectsBudgetStatusEnum;
  description?: Maybe<Scalars['String']>;
  effectiveFrom: Scalars['ISO8601DateTime'];
  effectiveUntil?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['Int'];
  legalEntityId: Scalars['Int'];
  name: Scalars['String'];
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  ownerEmployeeIds: Array<Scalars['Int']>;
  ownerEmployees: Array<EmployeesEmployee>;
  ownerEmployeesConnection: EmployeesEmployeeConnection;
  pendingAmountCents: Scalars['BigInt'];
  periodEnd?: Maybe<Scalars['ISO8601DateTime']>;
  periodStart: Scalars['ISO8601DateTime'];
  periodStatus: FinanceValueObjectsBudgetStatusEnum;
  periodicity: FinanceValueObjectsBudgetPeriodicityEnum;
  spentAmountCents: Scalars['BigInt'];
  started: Scalars['Boolean'];
  totalAllocatedAmountCents: Scalars['BigInt'];
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  viewerEmployeeIds: Array<Scalars['Int']>;
  viewerEmployees: Array<EmployeesEmployee>;
  viewerEmployeesConnection: EmployeesEmployeeConnection;
};


/** budget */
export type FinanceBudget_PoliciesCollectionArgs = {
  ids: Array<FinanceBudgetPoliciesEnum>;
};


/** budget */
export type FinanceBudget_PoliciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** budget */
export type FinanceBudgetBudgetAllocationsArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  excludeDrafts?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  periodEnd?: InputMaybe<Scalars['ISO8601DateTime']>;
  periodStart?: InputMaybe<Scalars['ISO8601DateTime']>;
  search?: InputMaybe<Scalars['String']>;
};


/** budget */
export type FinanceBudgetBudgetAllocationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  excludeDrafts?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  periodEnd?: InputMaybe<Scalars['ISO8601DateTime']>;
  periodStart?: InputMaybe<Scalars['ISO8601DateTime']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


/** budget */
export type FinanceBudgetBudgetMovementsArgs = {
  budgetId?: InputMaybe<Array<Scalars['Int']>>;
  employeeId?: InputMaybe<Scalars['Int']>;
  excludeDrafts?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  periodEnd?: InputMaybe<Scalars['ISO8601DateTime']>;
  periodStart?: InputMaybe<Scalars['ISO8601DateTime']>;
  resourceIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceType?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


/** budget */
export type FinanceBudgetBudgetMovementsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  budgetId?: InputMaybe<Array<Scalars['Int']>>;
  employeeId?: InputMaybe<Scalars['Int']>;
  excludeDrafts?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  periodEnd?: InputMaybe<Scalars['ISO8601DateTime']>;
  periodStart?: InputMaybe<Scalars['ISO8601DateTime']>;
  resourceIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceType?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


/** budget */
export type FinanceBudgetOwnerEmployeesArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** budget */
export type FinanceBudgetOwnerEmployeesConnectionArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  after?: InputMaybe<Scalars['String']>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Sort>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** budget */
export type FinanceBudgetViewerEmployeesArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** budget */
export type FinanceBudgetViewerEmployeesConnectionArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  after?: InputMaybe<Scalars['String']>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Sort>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};

/** budget_allocation */
export type FinanceBudgetAllocation = {
  __typename?: 'FinanceBudgetAllocation';
  amountCents?: Maybe<Scalars['Int']>;
  availableAmountCents?: Maybe<Scalars['Int']>;
  budget?: Maybe<FinanceBudget>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  budgetId: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  employee?: Maybe<EmployeesEmployee>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  employeeId: Scalars['Int'];
  id: Scalars['Int'];
  reportedAmountCents: Scalars['Int'];
  status?: Maybe<FinanceValueObjectsAllocationStatusEnum>;
};


/** budget_allocation */
export type FinanceBudgetAllocationBudgetArgs = {
  effectiveAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  extendedVisibility?: InputMaybe<Scalars['Boolean']>;
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  includeInactive?: InputMaybe<Scalars['Boolean']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  onlyArchived?: InputMaybe<Scalars['Boolean']>;
  ownerOrViewerEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  periodStart?: InputMaybe<Scalars['ISO8601DateTime']>;
};


/** budget_allocation */
export type FinanceBudgetAllocationEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for FinanceBudgetAllocation. */
export type FinanceBudgetAllocationConnection = {
  __typename?: 'FinanceBudgetAllocationConnection';
  /** A list of edges. */
  edges: Array<FinanceBudgetAllocationEdge>;
  /** A list of nodes. */
  nodes: Array<FinanceBudgetAllocation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FinanceBudgetAllocationEdge = {
  __typename?: 'FinanceBudgetAllocationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FinanceBudgetAllocation;
};

/** the filter for the budget_allocations resource */
export type FinanceBudgetAllocationFilter = {
  accessTeam?: InputMaybe<IntegerFilter>;
  amountCents?: InputMaybe<IntegerFilter>;
  id?: InputMaybe<IntegerFilter>;
  or?: InputMaybe<Array<FinanceBudgetAllocationFilterConditions>>;
};

export type FinanceBudgetAllocationFilterConditions = {
  accessTeam?: InputMaybe<IntegerFilter>;
  amountCents?: InputMaybe<IntegerFilter>;
  id?: InputMaybe<IntegerFilter>;
};

/** The connection type for FinanceBudget. */
export type FinanceBudgetConnection = {
  __typename?: 'FinanceBudgetConnection';
  /** A list of edges. */
  edges: Array<FinanceBudgetEdge>;
  /** A list of nodes. */
  nodes: Array<FinanceBudget>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FinanceBudgetEdge = {
  __typename?: 'FinanceBudgetEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FinanceBudget;
};

/** A movement of funds in or out of a budget */
export type FinanceBudgetMovement = {
  __typename?: 'FinanceBudgetMovement';
  amountCents?: Maybe<Scalars['Int']>;
  budget?: Maybe<FinanceBudget>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  budgetId: Scalars['Int'];
  convertedAt?: Maybe<Scalars['ISO8601DateTime']>;
  effectiveAt: Scalars['ISO8601DateTime'];
  employee?: Maybe<EmployeesEmployee>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  employeeId: Scalars['Int'];
  exchangeRate?: Maybe<Scalars['Float']>;
  expensable?: Maybe<ExpensesExpensable>;
  id: Scalars['Int'];
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  resourceId: Scalars['Int'];
  resourceType: Scalars['String'];
  sourceCurrency: Scalars['String'];
  targetCurrency: Scalars['String'];
};


/** A movement of funds in or out of a budget */
export type FinanceBudgetMovementBudgetArgs = {
  effectiveAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  onlyArchived?: InputMaybe<Scalars['Boolean']>;
  ownerOrViewerEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  periodStart?: InputMaybe<Scalars['ISO8601DateTime']>;
};


/** A movement of funds in or out of a budget */
export type FinanceBudgetMovementEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** A movement of funds in or out of a budget */
export type FinanceBudgetMovementExpensableArgs = {
  byResources?: InputMaybe<Array<ExpensablesByResourcesInput>>;
  categories?: InputMaybe<Array<Scalars['String']>>;
  companyId?: InputMaybe<Scalars['Int']>;
  creationType?: InputMaybe<Array<Scalars['String']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  from?: InputMaybe<Scalars['ISO8601DateTime']>;
  groupIds?: InputMaybe<Array<Scalars['Int']>>;
  includeAttachments?: Scalars['Boolean'];
  includeManualDrafts?: Scalars['Boolean'];
  onlyGrouped?: InputMaybe<Scalars['Boolean']>;
  perDiemEndDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  perDiemStartDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  reporterIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Array<ExpensesEntitiesExpensableStatusEnum>>;
  to?: InputMaybe<Scalars['ISO8601DateTime']>;
  withReimbursableCurrency?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for FinanceBudgetMovement. */
export type FinanceBudgetMovementConnection = {
  __typename?: 'FinanceBudgetMovementConnection';
  /** A list of edges. */
  edges: Array<FinanceBudgetMovementEdge>;
  /** A list of nodes. */
  nodes: Array<FinanceBudgetMovement>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FinanceBudgetMovementEdge = {
  __typename?: 'FinanceBudgetMovementEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FinanceBudgetMovement;
};

/** the filter for the budget_movements resource */
export type FinanceBudgetMovementFilter = {
  amountCents?: InputMaybe<IntegerFilter>;
  effectiveAt?: InputMaybe<DateTimeFilter>;
  employeeId?: InputMaybe<IntegerFilter>;
  expensableCategory?: InputMaybe<StringFilter>;
  expensableStatus?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntegerFilter>;
  or?: InputMaybe<Array<FinanceBudgetMovementFilterConditions>>;
};

export type FinanceBudgetMovementFilterConditions = {
  amountCents?: InputMaybe<IntegerFilter>;
  effectiveAt?: InputMaybe<DateTimeFilter>;
  employeeId?: InputMaybe<IntegerFilter>;
  expensableCategory?: InputMaybe<StringFilter>;
  expensableStatus?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntegerFilter>;
};

/** Budget with limited information for general viewing purposes (e.g. reporting an expense) */
export type FinanceBudgetOption = {
  __typename?: 'FinanceBudgetOption';
  /** Currency of the budget option */
  currency: Scalars['String'];
  /** Description of the budget option */
  description?: Maybe<Scalars['String']>;
  /** Unique identifier for the budget option */
  id: Scalars['Int'];
  legalEntity: CompaniesLegalEntity;
  /**
   * Legal entity ID of the budget option
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  legalEntityId: Scalars['Int'];
  /** Name of the budget option */
  name: Scalars['String'];
};


/** Budget with limited information for general viewing purposes (e.g. reporting an expense) */
export type FinanceBudgetOptionLegalEntityArgs = {
  companiesIds?: InputMaybe<Array<Scalars['Int']>>;
  countryIds?: InputMaybe<Array<Scalars['String']>>;
  employeesIds?: InputMaybe<Array<Scalars['Int']>>;
  excludeCountries?: InputMaybe<Array<Scalars['String']>>;
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};

/** The connection type for FinanceBudgetOption. */
export type FinanceBudgetOptionConnection = {
  __typename?: 'FinanceBudgetOptionConnection';
  /** A list of edges. */
  edges: Array<FinanceBudgetOptionEdge>;
  /** A list of nodes. */
  nodes: Array<FinanceBudgetOption>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FinanceBudgetOptionEdge = {
  __typename?: 'FinanceBudgetOptionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FinanceBudgetOption;
};

/** the filter for the budget_options resource */
export type FinanceBudgetOptionFilter = {
  currency?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntegerFilter>;
  legalEntityId?: InputMaybe<IntegerFilter>;
  name?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<FinanceBudgetOptionFilterConditions>>;
};

export type FinanceBudgetOptionFilterConditions = {
  currency?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntegerFilter>;
  legalEntityId?: InputMaybe<IntegerFilter>;
  name?: InputMaybe<StringFilter>;
};

export type FinanceBudgetPolicies = {
  __typename?: 'FinanceBudgetPolicies';
  update: PermissionsPolicyResolution;
};

export type FinanceBudgetPoliciesEnum =
  | 'update';

/** Represents a category */
export type FinanceCategory = {
  __typename?: 'FinanceCategory';
  /** Company ID (internal use) */
  companyId: Scalars['Int'];
  /** Default translated label for the category */
  defaultLabel: Scalars['String'];
  /** Whether the category is deleted (internal use) */
  deleted: Scalars['Boolean'];
  /** Whether the category is enabled */
  enabled: Scalars['Boolean'];
  /** Unique identifier for the category */
  id: Scalars['Int'];
  /** System identifier for the category */
  identifier: Scalars['String'];
  /** Custom label for the category */
  label: Scalars['String'];
  /**
   * Parent category ID (null for main categories)
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  parentCategoryId?: Maybe<Scalars['Int']>;
  /** Display position of the category */
  position?: Maybe<Scalars['Int']>;
  /** Whether the category is protected (internal use) */
  protected: Scalars['Boolean'];
  subcategories: Array<FinanceCategory>;
  subcategoriesConnection: FinanceCategoryConnection;
  /** Whether the category is visible */
  visible: Scalars['Boolean'];
};


/** Represents a category */
export type FinanceCategorySubcategoriesArgs = {
  categoryLevel?: InputMaybe<FinanceValueObjectsCategoryLevelEnum>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  factorialCategoryIdentifier?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<FinanceValueObjectsCategoryStatusEnum>>;
  type?: InputMaybe<FinanceValueObjectsCategoryTypeEnum>;
};


/** Represents a category */
export type FinanceCategorySubcategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  categoryLevel?: InputMaybe<FinanceValueObjectsCategoryLevelEnum>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  factorialCategoryIdentifier?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  statuses?: InputMaybe<Array<FinanceValueObjectsCategoryStatusEnum>>;
  type?: InputMaybe<FinanceValueObjectsCategoryTypeEnum>;
};

/** The connection type for FinanceCategory. */
export type FinanceCategoryConnection = {
  __typename?: 'FinanceCategoryConnection';
  /** A list of edges. */
  edges: Array<FinanceCategoryEdge>;
  /** A list of nodes. */
  nodes: Array<FinanceCategory>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FinanceCategoryEdge = {
  __typename?: 'FinanceCategoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FinanceCategory;
};

/** the filter for the categories resource */
export type FinanceCategoryFilter = {
  companyId?: InputMaybe<IntegerFilter>;
  defaultLabel?: InputMaybe<StringFilter>;
  deleted?: InputMaybe<BooleanFilter>;
  enabled?: InputMaybe<BooleanFilter>;
  id?: InputMaybe<IntegerFilter>;
  identifier?: InputMaybe<StringFilter>;
  label?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<FinanceCategoryFilterConditions>>;
  parentCategoryId?: InputMaybe<IntegerFilter>;
  position?: InputMaybe<IntegerFilter>;
  protected?: InputMaybe<BooleanFilter>;
  visible?: InputMaybe<BooleanFilter>;
};

export type FinanceCategoryFilterConditions = {
  companyId?: InputMaybe<IntegerFilter>;
  defaultLabel?: InputMaybe<StringFilter>;
  deleted?: InputMaybe<BooleanFilter>;
  enabled?: InputMaybe<BooleanFilter>;
  id?: InputMaybe<IntegerFilter>;
  identifier?: InputMaybe<StringFilter>;
  label?: InputMaybe<StringFilter>;
  parentCategoryId?: InputMaybe<IntegerFilter>;
  position?: InputMaybe<IntegerFilter>;
  protected?: InputMaybe<BooleanFilter>;
  visible?: InputMaybe<BooleanFilter>;
};

export type FinanceCategoryLedgerAccountInput = {
  ledgerAccountId: Scalars['Int'];
  ledgerAccountResourceId?: InputMaybe<Scalars['Int']>;
  legalEntityId: Scalars['Int'];
};

export type FinanceComplianceExtraFieldAllowedValue = {
  __typename?: 'FinanceComplianceExtraFieldAllowedValue';
  label: Scalars['String'];
  value: Scalars['String'];
};

export type FinanceComplianceExtraFieldConfig = {
  __typename?: 'FinanceComplianceExtraFieldConfig';
  allowedValues?: Maybe<Array<FinanceComplianceExtraFieldAllowedValue>>;
  defaultValueForCreditNote?: Maybe<Scalars['String']>;
  defaultValueForStandardInvoice?: Maybe<Scalars['String']>;
  fieldContext: FinanceValueObjectsComplianceExtraFieldContextEnum;
  label: Scalars['String'];
  mandatoryForCreditNote: Scalars['Boolean'];
  mandatoryForStandardInvoice: Scalars['Boolean'];
  name: Scalars['String'];
  order: Scalars['Int'];
  type: FinanceValueObjectsComplianceExtraFieldTypeEnum;
  visibleForCreditNote: Scalars['Boolean'];
  visibleForStandardInvoice: Scalars['Boolean'];
};

/** Compliance extra field default setting */
export type FinanceComplianceExtraFieldDefaultSetting = {
  __typename?: 'FinanceComplianceExtraFieldDefaultSetting';
  companyId: Scalars['Int'];
  country: Scalars['String'];
  creditNoteDefaultValues: Array<FinanceComplianceExtraFieldDefaultSettingValue>;
  id: Scalars['Int'];
  invoiceDefaultValues: Array<FinanceComplianceExtraFieldDefaultSettingValue>;
  legalEntity: CompaniesLegalEntity;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  legalEntityId: Scalars['Int'];
  organization: FinanceValueObjectsComplianceExtraFieldOrganizationEnum;
};


/** Compliance extra field default setting */
export type FinanceComplianceExtraFieldDefaultSettingLegalEntityArgs = {
  companiesIds?: InputMaybe<Array<Scalars['Int']>>;
  countryIds?: InputMaybe<Array<Scalars['String']>>;
  employeesIds?: InputMaybe<Array<Scalars['Int']>>;
  excludeCountries?: InputMaybe<Array<Scalars['String']>>;
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};

/** The connection type for FinanceComplianceExtraFieldDefaultSetting. */
export type FinanceComplianceExtraFieldDefaultSettingConnection = {
  __typename?: 'FinanceComplianceExtraFieldDefaultSettingConnection';
  /** A list of edges. */
  edges: Array<FinanceComplianceExtraFieldDefaultSettingEdge>;
  /** A list of nodes. */
  nodes: Array<FinanceComplianceExtraFieldDefaultSetting>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FinanceComplianceExtraFieldDefaultSettingEdge = {
  __typename?: 'FinanceComplianceExtraFieldDefaultSettingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FinanceComplianceExtraFieldDefaultSetting;
};

export type FinanceComplianceExtraFieldDefaultSettingValue = {
  __typename?: 'FinanceComplianceExtraFieldDefaultSettingValue';
  fieldName: Scalars['String'];
  value: Scalars['String'];
};

export type FinanceComplianceExtraFieldDefaultSettingValueInput = {
  fieldName: Scalars['String'];
  value: Scalars['String'];
};

/** Compliance snapshot */
export type FinanceComplianceSnapshot = {
  __typename?: 'FinanceComplianceSnapshot';
  createdAt: Scalars['ISO8601DateTime'];
  eventType: FinanceValueObjectsComplianceSnapshotEventEnum;
  financialDocumentSnapshot?: Maybe<FinanceComplianceSnapshotFinancialDocument>;
  id: Scalars['Int'];
  quoteSnapshot?: Maybe<FinanceComplianceSnapshotQuote>;
  resourceId: Scalars['Int'];
  resourceType: FinanceComplianceSnapshotResourceTypeEnum;
  taxAgency: FinanceTaxBridgeTaxAgenciesEnum;
};

export type FinanceComplianceSnapshotComplianceExtraField = {
  __typename?: 'FinanceComplianceSnapshotComplianceExtraField';
  countryCode: Scalars['String'];
  fields: Array<FinanceFinancialDocumentComplianceExtraFieldsField>;
  id: Scalars['Int'];
  organization: FinanceValueObjectsComplianceExtraFieldOrganizationEnum;
};

/** The connection type for FinanceComplianceSnapshot. */
export type FinanceComplianceSnapshotConnection = {
  __typename?: 'FinanceComplianceSnapshotConnection';
  /** A list of edges. */
  edges: Array<FinanceComplianceSnapshotEdge>;
  /** A list of nodes. */
  nodes: Array<FinanceComplianceSnapshot>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FinanceComplianceSnapshotEdge = {
  __typename?: 'FinanceComplianceSnapshotEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FinanceComplianceSnapshot;
};

export type FinanceComplianceSnapshotFinancialDocument = {
  __typename?: 'FinanceComplianceSnapshotFinancialDocument';
  companyId: Scalars['Int'];
  complianceFields: Array<FinanceComplianceSnapshotComplianceExtraField>;
  createdAt: Scalars['ISO8601DateTime'];
  currency?: Maybe<Scalars['String']>;
  discountPercentage?: Maybe<Scalars['Float']>;
  documentDate?: Maybe<Scalars['ISO8601Date']>;
  documentDatetime?: Maybe<Scalars['ISO8601DateTime']>;
  documentNumber?: Maybe<Scalars['String']>;
  documentType: FinanceValueObjectsFinancialDocumentTypeEnum;
  dueDate?: Maybe<Scalars['ISO8601Date']>;
  duplicateFinancialDocumentId?: Maybe<Scalars['Int']>;
  file?: Maybe<FinanceInvoiceFile>;
  financialDocumentId: Scalars['Int'];
  footer?: Maybe<Scalars['String']>;
  fullyReconciledAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['Int'];
  issuerAddressLine1?: Maybe<Scalars['String']>;
  issuerAddressLine2?: Maybe<Scalars['String']>;
  issuerCity?: Maybe<Scalars['String']>;
  issuerCountryCode?: Maybe<Scalars['String']>;
  issuerName?: Maybe<Scalars['String']>;
  issuerPostalCode?: Maybe<Scalars['String']>;
  issuerState?: Maybe<Scalars['String']>;
  issuerTaxId?: Maybe<Scalars['String']>;
  legalEntityId?: Maybe<Scalars['Int']>;
  lineItems: Array<FinanceFinancialDocumentLineItem>;
  memo?: Maybe<Scalars['String']>;
  netAmountCents?: Maybe<Scalars['BigInt']>;
  operationType: FinanceValueObjectsFinancialDocumentOperationTypeEnum;
  parentFinancialDocumentId?: Maybe<Scalars['Int']>;
  recipientAddressLine1?: Maybe<Scalars['String']>;
  recipientAddressLine2?: Maybe<Scalars['String']>;
  recipientCity?: Maybe<Scalars['String']>;
  recipientCountryCode?: Maybe<Scalars['String']>;
  recipientName?: Maybe<Scalars['String']>;
  recipientPostalCode?: Maybe<Scalars['String']>;
  recipientState?: Maybe<Scalars['String']>;
  recipientTaxId?: Maybe<Scalars['String']>;
  reconcilable: Scalars['Boolean'];
  recordedAt?: Maybe<Scalars['ISO8601DateTime']>;
  registerSaleAt?: Maybe<Scalars['ISO8601DateTime']>;
  registerSaleById?: Maybe<Scalars['Int']>;
  retentionTaxRate?: Maybe<FinanceComplianceSnapshotTaxRateField>;
  serialSequenceId?: Maybe<Scalars['Int']>;
  status: FinanceValueObjectsInvoiceStatusEnum;
  taxes: Array<FinanceInvoiceTax>;
  taxesTotalAmountCents?: Maybe<Scalars['Int']>;
  totalAmountCents?: Maybe<Scalars['BigInt']>;
  updatedAt: Scalars['ISO8601DateTime'];
  validatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  validatedById?: Maybe<Scalars['Int']>;
  vendorId?: Maybe<Scalars['Int']>;
};

export type FinanceComplianceSnapshotQuote = {
  __typename?: 'FinanceComplianceSnapshotQuote';
  clientId?: Maybe<Scalars['Int']>;
  companyId: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  currency?: Maybe<Scalars['String']>;
  discountPercentage?: Maybe<Scalars['Float']>;
  documentDate?: Maybe<Scalars['ISO8601Date']>;
  expirationDate?: Maybe<Scalars['ISO8601Date']>;
  footer?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  issuerAddressLine1?: Maybe<Scalars['String']>;
  issuerAddressLine2?: Maybe<Scalars['String']>;
  issuerCity?: Maybe<Scalars['String']>;
  issuerCountryCode?: Maybe<Scalars['String']>;
  issuerName?: Maybe<Scalars['String']>;
  issuerPostalCode?: Maybe<Scalars['String']>;
  issuerState?: Maybe<Scalars['String']>;
  issuerTaxId?: Maybe<Scalars['String']>;
  legalEntityId?: Maybe<Scalars['Int']>;
  lineItems: Array<FinanceFinancialDocumentLineItem>;
  memo?: Maybe<Scalars['String']>;
  netAmountCents?: Maybe<Scalars['BigInt']>;
  ownerIdentifierForBulkPolicy: Scalars['Int'];
  quoteId: Scalars['Int'];
  quoteNumber?: Maybe<Scalars['String']>;
  recipientAddressLine1?: Maybe<Scalars['String']>;
  recipientAddressLine2?: Maybe<Scalars['String']>;
  recipientCity?: Maybe<Scalars['String']>;
  recipientCountryCode?: Maybe<Scalars['String']>;
  recipientName?: Maybe<Scalars['String']>;
  recipientPostalCode?: Maybe<Scalars['String']>;
  recipientState?: Maybe<Scalars['String']>;
  recipientTaxId?: Maybe<Scalars['String']>;
  status: FinanceEnumsQuoteStatusEnum;
  taxes: Array<FinanceInvoiceTax>;
  totalAmountCents?: Maybe<Scalars['BigInt']>;
};

export type FinanceComplianceSnapshotResourceTypeEnum =
  | 'invoice'
  | 'quote';

export type FinanceComplianceSnapshotTaxRateField = {
  __typename?: 'FinanceComplianceSnapshotTaxRateField';
  description: Scalars['String'];
  id: Scalars['Int'];
  rate: Scalars['Float'];
  taxType: FinanceComplianceSnapshotTaxTypeField;
};

export type FinanceComplianceSnapshotTaxTypeField = {
  __typename?: 'FinanceComplianceSnapshotTaxTypeField';
  countryCode: Scalars['String'];
  name: Scalars['String'];
};

/** A contact that can be a client or a provider */
export type FinanceContact = {
  __typename?: 'FinanceContact';
  accountResources: Array<FinanceLedgerAccountResource>;
  accountResourcesConnection: FinanceLedgerAccountResourceConnection;
  /** The address object containing street, city, etc. */
  address: FinanceVendorAddress;
  /** Bank or branch code for the Contact if relevant. */
  bankCode?: Maybe<Scalars['String']>;
  /** The ID of the company to which this Contact is associated. */
  companyId: Scalars['Int'];
  /** Timestamp when the Contact was created. */
  createdAt: Scalars['ISO8601Date'];
  /** The email of the Contact. */
  email?: Maybe<Scalars['String']>;
  /** The external id of the contact. */
  externalId?: Maybe<Scalars['String']>;
  /** International Bank Account Number if provided. */
  iban?: Maybe<Scalars['String']>;
  /** Unique identifier for the Contact. */
  id: Scalars['Int'];
  /** The official or legal name of the Contact. */
  legalName?: Maybe<Scalars['String']>;
  /** The commercial name of the Contact. */
  name: Scalars['String'];
  /** The phone number of the Contact. */
  phoneNumber?: Maybe<Scalars['String']>;
  /** Preferred payment method for the Contact (e.g. wire_transfer, paypal). */
  preferredPaymentMethod?: Maybe<FinanceValueObjectsVendorPreferredPaymentMethodEnum>;
  projects: Array<ProjectManagementProject>;
  projectsConnection: ProjectManagementProjectConnection;
  softwareSetup?: Maybe<SoftwareManagementSoftwareSetup>;
  /** Tax identification number assigned to the Contact. */
  taxId?: Maybe<Scalars['String']>;
  /** Tax identification type for the Contact. */
  taxIdType?: Maybe<FinanceValueObjectsContactTaxIdTypeEnum>;
  /** Timestamp when the Contact was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  /** The website of the Contact. */
  website?: Maybe<Scalars['String']>;
};


/** A contact that can be a client or a provider */
export type FinanceContactAccountResourcesArgs = {
  financeAccountIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


/** A contact that can be a client or a provider */
export type FinanceContactAccountResourcesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  financeAccountIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


/** A contact that can be a client or a provider */
export type FinanceContactProjectsArgs = {
  assignedEmployeesIds?: InputMaybe<Array<Scalars['Int']>>;
  billable?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeCosts?: InputMaybe<Scalars['Boolean']>;
  includeInputedMinutes?: Scalars['Boolean'];
  legalEntityId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  nameOrCode?: InputMaybe<Scalars['String']>;
  noClients?: InputMaybe<Scalars['Boolean']>;
  notClosed?: InputMaybe<Scalars['Boolean']>;
  roleTypes?: InputMaybe<Array<ProjectManagementProjectRoleRoleEnum>>;
  roledByEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  skipViewerByEmployeeId?: InputMaybe<Scalars['Int']>;
  totalCurrency?: InputMaybe<Scalars['String']>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
};


/** A contact that can be a client or a provider */
export type FinanceContactProjectsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  assignedEmployeesIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  billable?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeCosts?: InputMaybe<Scalars['Boolean']>;
  includeInputedMinutes?: Scalars['Boolean'];
  last?: InputMaybe<Scalars['Int']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  nameOrCode?: InputMaybe<Scalars['String']>;
  noClients?: InputMaybe<Scalars['Boolean']>;
  notClosed?: InputMaybe<Scalars['Boolean']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  roleTypes?: InputMaybe<Array<ProjectManagementProjectRoleRoleEnum>>;
  roledByEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  skipViewerByEmployeeId?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  totalCurrency?: InputMaybe<Scalars['String']>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
};


/** A contact that can be a client or a provider */
export type FinanceContactSoftwareSetupArgs = {
  cardIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  withoutCard?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for FinanceContact. */
export type FinanceContactConnection = {
  __typename?: 'FinanceContactConnection';
  /** A list of edges. */
  edges: Array<FinanceContactEdge>;
  /** A list of nodes. */
  nodes: Array<FinanceContact>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** Finance Contact documents */
export type FinanceContactDocument = {
  __typename?: 'FinanceContactDocument';
  contact?: Maybe<FinanceContact>;
  /**
   * id of the contact.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  contactId: Scalars['Int'];
  /** creation date of the contact document. */
  createdOn: Scalars['String'];
  deletedAt?: Maybe<Scalars['String']>;
  /** file attachment details. */
  file?: Maybe<AttachmentsFileAttachment>;
  /** id of the contact document. */
  id: Scalars['Int'];
  /** name of the contact document. */
  name: Scalars['String'];
  uploader?: Maybe<EmployeesEmployee>;
  /**
   * id of the uploader
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  uploaderId: Scalars['Int'];
  /** url of the contact document. */
  url: Scalars['String'];
};


/** Finance Contact documents */
export type FinanceContactDocumentContactArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  contactType?: InputMaybe<FinanceValueObjectsContactTypeEnum>;
  email?: InputMaybe<Scalars['String']>;
  legalName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  taxIdType?: InputMaybe<Scalars['String']>;
  taxIds?: InputMaybe<Array<Scalars['String']>>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
  website?: InputMaybe<Scalars['String']>;
};


/** Finance Contact documents */
export type FinanceContactDocumentUploaderArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for FinanceContactDocument. */
export type FinanceContactDocumentConnection = {
  __typename?: 'FinanceContactDocumentConnection';
  /** A list of edges. */
  edges: Array<FinanceContactDocumentEdge>;
  /** A list of nodes. */
  nodes: Array<FinanceContactDocument>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FinanceContactDocumentEdge = {
  __typename?: 'FinanceContactDocumentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FinanceContactDocument;
};

/** the filter for the contact_documents resource */
export type FinanceContactDocumentFilter = {
  createdOn?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<FinanceContactDocumentFilterConditions>>;
};

export type FinanceContactDocumentFilterConditions = {
  createdOn?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
};

/** An edge in a connection. */
export type FinanceContactEdge = {
  __typename?: 'FinanceContactEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FinanceContact;
};

/** the filter for the contacts resource */
export type FinanceContactFilter = {
  address?: InputMaybe<StringFilter>;
  bankCode?: InputMaybe<StringFilter>;
  companyId?: InputMaybe<IntegerFilter>;
  createdAt?: InputMaybe<DateFilter>;
  email?: InputMaybe<StringFilter>;
  iban?: InputMaybe<StringFilter>;
  legalName?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<FinanceContactFilterConditions>>;
  phoneNumber?: InputMaybe<StringFilter>;
  preferredPaymentMethod?: InputMaybe<StringFilter>;
  taxId?: InputMaybe<StringFilter>;
  taxIdType?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  website?: InputMaybe<StringFilter>;
};

export type FinanceContactFilterConditions = {
  address?: InputMaybe<StringFilter>;
  bankCode?: InputMaybe<StringFilter>;
  companyId?: InputMaybe<IntegerFilter>;
  createdAt?: InputMaybe<DateFilter>;
  email?: InputMaybe<StringFilter>;
  iban?: InputMaybe<StringFilter>;
  legalName?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  phoneNumber?: InputMaybe<StringFilter>;
  preferredPaymentMethod?: InputMaybe<StringFilter>;
  taxId?: InputMaybe<StringFilter>;
  taxIdType?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  website?: InputMaybe<StringFilter>;
};

/** Contacts Import Template */
export type FinanceContactImportTemplate = {
  __typename?: 'FinanceContactImportTemplate';
  fileInBase64: Scalars['String'];
  fileName: Scalars['String'];
  fileType: Scalars['String'];
  id: Scalars['String'];
};

/** Contacts Import Result */
export type FinanceContactsImportResult = {
  __typename?: 'FinanceContactsImportResult';
  added: Scalars['Int'];
  duplicated: Scalars['Int'];
  id: Scalars['String'];
  updated: Scalars['Int'];
};

export type FinanceContextlessPolicies = {
  __typename?: 'FinanceContextlessPolicies';
  accountingManageAccountResources: ContextlessPolicyResolution;
  accountingManageAccounts: ContextlessPolicyResolution;
  accountingManageCustomCategoriesAccounts: ContextlessPolicyResolution;
  accountingSeeAccounts: ContextlessPolicyResolution;
  accountingSeePurchaseAccounts: ContextlessPolicyResolution;
  accountingSeeSalesAccounts: ContextlessPolicyResolution;
  budgetsCreateBudgets: ContextlessPolicyResolution;
  budgetsManageBudgets: ContextlessPolicyResolution;
  budgetsSeeBudgets: ContextlessPolicyResolution;
  complianceExtraFieldDefaultSettingsManage: ContextlessPolicyResolution;
  complianceSnapshotsSeeComplianceSnapshot: ContextlessPolicyResolution;
  contactsCreateOrUpdate: ContextlessPolicyResolution;
  contactsDelete: ContextlessPolicyResolution;
  contactsManageBasicData: ContextlessPolicyResolution;
  contactsManagePaymentData: ContextlessPolicyResolution;
  contactsSee: ContextlessPolicyResolution;
  contactsSeeTaxIdType: ContextlessPolicyResolution;
  costCenterMembershipsBulkImportCostCenterMemberships: ContextlessPolicyResolution;
  costCenterMembershipsEmployeeSeeCostCenterMemberships: ContextlessPolicyResolution;
  costCentersManageCostCenters: ContextlessPolicyResolution;
  costCentersSeeCostCenters: ContextlessPolicyResolution;
  customDimensionsManage: ContextlessPolicyResolution;
  customDimensionsSee: ContextlessPolicyResolution;
  financialDocumentsCreatePurchase: ContextlessPolicyResolution;
  financialDocumentsCreateSale: ContextlessPolicyResolution;
  financialDocumentsManagePurchase: ContextlessPolicyResolution;
  financialDocumentsManageSales: ContextlessPolicyResolution;
  financialDocumentsSeeComplianceExtraFieldConfigs: ContextlessPolicyResolution;
  financialSequencesManage: ContextlessPolicyResolution;
  journalEntriesManage: ContextlessPolicyResolution;
  journalEntriesManagePurchase: ContextlessPolicyResolution;
  journalEntriesManagePurchaseInAccountsPayable: ContextlessPolicyResolution;
  quotesCreate: ContextlessPolicyResolution;
  salesDocumentTemplatesManage: ContextlessPolicyResolution;
  settingsSeeAccountingSettings: ContextlessPolicyResolution;
  settingsSeeAccountingSettingsCustomCategories: ContextlessPolicyResolution;
  settingsSeeAccountingSettingsLedgerAccounts: ContextlessPolicyResolution;
  settingsSeeAccountingSettingsTaxTypes: ContextlessPolicyResolution;
  settingsSeeAnalyticalDimensionsSettings: ContextlessPolicyResolution;
  settingsSeeCostCentersSettings: ContextlessPolicyResolution;
  settingsSeeFinanceCategory: ContextlessPolicyResolution;
  settingsSeeSalesSettings: ContextlessPolicyResolution;
  sidebarSeeFinanceAccountingSubLevelItem: ContextlessPolicyResolution;
  sidebarSeeFinanceAccountsSubLevelItem: ContextlessPolicyResolution;
  sidebarSeeFinanceCardsSubLevelItem: ContextlessPolicyResolution;
  sidebarSeeFinanceClientsSubLevelItem: ContextlessPolicyResolution;
  sidebarSeeFinanceDealsSubLevelItem: ContextlessPolicyResolution;
  sidebarSeeFinanceFinancialWorkspaceSubLevelItem: ContextlessPolicyResolution;
  sidebarSeeFinanceInvoicesSubLevelItem: ContextlessPolicyResolution;
  sidebarSeeFinanceOverviewSubLevelItem: ContextlessPolicyResolution;
  sidebarSeeFinancePaymentsSubLevelItem: ContextlessPolicyResolution;
  sidebarSeeFinanceQuotesSubLevelItem: ContextlessPolicyResolution;
  sidebarSeeFinanceTopLevelItem: ContextlessPolicyResolution;
  sidebarSeeFinanceVendorsSubLevelItem: ContextlessPolicyResolution;
  spendingPoliciesSee: ContextlessPolicyResolution;
  spendingPolicyCreate: ContextlessPolicyResolution;
  spendingPolicyDelete: ContextlessPolicyResolution;
  spendingPolicyUpdate: ContextlessPolicyResolution;
  taxTypeCreate: ContextlessPolicyResolution;
  taxTypeUpdate: ContextlessPolicyResolution;
};

/** Cost centers */
export type FinanceCostCenter = {
  __typename?: 'FinanceCostCenter';
  activeEmployeesCount: Scalars['Int'];
  code?: Maybe<Scalars['String']>;
  company: ApiCoreCompany;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  companyId: Scalars['Int'];
  deactivationDate?: Maybe<Scalars['ISO8601Date']>;
  description?: Maybe<Scalars['String']>;
  historicalEmployeesCount: Scalars['Int'];
  id: Scalars['Int'];
  legalEntity?: Maybe<CompaniesLegalEntity>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  legalEntityId?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  status: Scalars['String'];
};


/** Cost centers */
export type FinanceCostCenterLegalEntityArgs = {
  companiesIds?: InputMaybe<Array<Scalars['Int']>>;
  countryIds?: InputMaybe<Array<Scalars['String']>>;
  employeesIds?: InputMaybe<Array<Scalars['Int']>>;
  excludeCountries?: InputMaybe<Array<Scalars['String']>>;
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};

/** The connection type for FinanceCostCenter. */
export type FinanceCostCenterConnection = {
  __typename?: 'FinanceCostCenterConnection';
  /** A list of edges. */
  edges: Array<FinanceCostCenterEdge>;
  /** A list of nodes. */
  nodes: Array<FinanceCostCenter>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FinanceCostCenterEdge = {
  __typename?: 'FinanceCostCenterEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FinanceCostCenter;
};

/** the filter for the cost_centers resource */
export type FinanceCostCenterFilter = {
  code?: InputMaybe<StringFilter>;
  legalEntityId?: InputMaybe<IntegerFilter>;
  name?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<FinanceCostCenterFilterConditions>>;
};

export type FinanceCostCenterFilterConditions = {
  code?: InputMaybe<StringFilter>;
  legalEntityId?: InputMaybe<IntegerFilter>;
  name?: InputMaybe<StringFilter>;
};

/** Cost center memberships */
export type FinanceCostCenterMembership = {
  __typename?: 'FinanceCostCenterMembership';
  costCenter: FinanceCostCenter;
  /**
   * The identifier of the associated cost center
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  costCenterId: Scalars['Int'];
  employee: EmployeesEmployee;
  /**
   * The identifier of the associated employee
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  employeeId: Scalars['Int'];
  /** The date the em'ployee stopped being assigned to the cost center */
  endDate?: Maybe<Scalars['ISO8601Date']>;
  /** The unique identifier of the cost center membership */
  id: Scalars['Int'];
  /** The percentage allocation of the employee to the cost center */
  percentage: Scalars['Float'];
  /** The date the employee started being assigned to the cost center */
  startDate: Scalars['ISO8601Date'];
};


/** Cost center memberships */
export type FinanceCostCenterMembershipCostCenterArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  includeActivesOnDate?: InputMaybe<Scalars['ISO8601Date']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


/** Cost center memberships */
export type FinanceCostCenterMembershipEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for FinanceCostCenterMembership. */
export type FinanceCostCenterMembershipConnection = {
  __typename?: 'FinanceCostCenterMembershipConnection';
  /** A list of edges. */
  edges: Array<FinanceCostCenterMembershipEdge>;
  /** A list of nodes. */
  nodes: Array<FinanceCostCenterMembership>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FinanceCostCenterMembershipEdge = {
  __typename?: 'FinanceCostCenterMembershipEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FinanceCostCenterMembership;
};

/** the filter for the cost_center_memberships resource */
export type FinanceCostCenterMembershipFilter = {
  or?: InputMaybe<Array<FinanceCostCenterMembershipFilterConditions>>;
  startDate?: InputMaybe<DateFilter>;
};

export type FinanceCostCenterMembershipFilterConditions = {
  startDate?: InputMaybe<DateFilter>;
};

/** Cost center memberships import */
export type FinanceCostCenterMembershipImport = {
  __typename?: 'FinanceCostCenterMembershipImport';
  errors?: Maybe<Array<Scalars['String']>>;
  failedRecords: Scalars['Int'];
  importedRecords: Scalars['Int'];
};

/** Credit notes serial sequence */
export type FinanceCreditNoteSequence = {
  __typename?: 'FinanceCreditNoteSequence';
  archivedAt?: Maybe<Scalars['ISO8601DateTime']>;
  createdAt: Scalars['ISO8601DateTime'];
  humanReadablePreview: Scalars['String'];
  id: Scalars['Int'];
  lastGeneratedSerial?: Maybe<Scalars['String']>;
  legalEntityId: Scalars['Int'];
  lockedSerial?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  pattern: Scalars['String'];
  startFrom: Scalars['Int'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for FinanceCreditNoteSequence. */
export type FinanceCreditNoteSequenceConnection = {
  __typename?: 'FinanceCreditNoteSequenceConnection';
  /** A list of edges. */
  edges: Array<FinanceCreditNoteSequenceEdge>;
  /** A list of nodes. */
  nodes: Array<FinanceCreditNoteSequence>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FinanceCreditNoteSequenceEdge = {
  __typename?: 'FinanceCreditNoteSequenceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FinanceCreditNoteSequence;
};

/** the filter for the credit_note_sequences resource */
export type FinanceCreditNoteSequenceFilter = {
  or?: InputMaybe<Array<FinanceCreditNoteSequenceFilterConditions>>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type FinanceCreditNoteSequenceFilterConditions = {
  updatedAt?: InputMaybe<DateTimeFilter>;
};

/** custom_category */
export type FinanceCustomCategory = {
  __typename?: 'FinanceCustomCategory';
  accountResources: Array<FinanceLedgerAccountResource>;
  accountResourcesConnection: FinanceLedgerAccountResourceConnection;
  companyId: Scalars['Int'];
  defaultLabel: Scalars['String'];
  deleted: Scalars['Boolean'];
  enabled: Scalars['Boolean'];
  id: Scalars['Int'];
  identifier: Scalars['String'];
  label: Scalars['String'];
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  parentCategoryId?: Maybe<Scalars['Int']>;
  position?: Maybe<Scalars['Int']>;
  protected: Scalars['Boolean'];
  subcategories: Array<FinanceCustomCategory>;
  subcategoriesConnection: FinanceCustomCategoryConnection;
  visible: Scalars['Boolean'];
};


/** custom_category */
export type FinanceCustomCategoryAccountResourcesArgs = {
  financeAccountIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


/** custom_category */
export type FinanceCustomCategoryAccountResourcesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  financeAccountIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


/** custom_category */
export type FinanceCustomCategorySubcategoriesArgs = {
  categoryLevel: FinanceValueObjectsCategoryLevelEnum;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  factorialCategoryIdentifier?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  statuses: Array<FinanceValueObjectsCategoryStatusEnum>;
  type: FinanceValueObjectsCategoryTypeEnum;
};


/** custom_category */
export type FinanceCustomCategorySubcategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  categoryLevel: FinanceValueObjectsCategoryLevelEnum;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  factorialCategoryIdentifier?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  statuses: Array<FinanceValueObjectsCategoryStatusEnum>;
  type: FinanceValueObjectsCategoryTypeEnum;
};

/** The connection type for FinanceCustomCategory. */
export type FinanceCustomCategoryConnection = {
  __typename?: 'FinanceCustomCategoryConnection';
  /** A list of edges. */
  edges: Array<FinanceCustomCategoryEdge>;
  /** A list of nodes. */
  nodes: Array<FinanceCustomCategory>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FinanceCustomCategoryEdge = {
  __typename?: 'FinanceCustomCategoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FinanceCustomCategory;
};

/** the filter for the custom_categories resource */
export type FinanceCustomCategoryFilter = {
  label?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<FinanceCustomCategoryFilterConditions>>;
};

export type FinanceCustomCategoryFilterConditions = {
  label?: InputMaybe<StringFilter>;
};

/** Represents a custom dimension */
export type FinanceCustomDimension = {
  __typename?: 'FinanceCustomDimension';
  companyId: Scalars['Int'];
  customDimensionValues: Array<FinanceCustomDimensionValue>;
  customdimensionvaluesConnection: FinanceCustomDimensionValueConnection;
  id: Scalars['Int'];
  legalEntityId?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
};


/** Represents a custom dimension */
export type FinanceCustomDimensionCustomDimensionValuesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  tenant?: InputMaybe<FinanceTenantInput>;
};


/** Represents a custom dimension */
export type FinanceCustomDimensionCustomdimensionvaluesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  tenant?: InputMaybe<FinanceTenantInput>;
};

/** The connection type for FinanceCustomDimension. */
export type FinanceCustomDimensionConnection = {
  __typename?: 'FinanceCustomDimensionConnection';
  /** A list of edges. */
  edges: Array<FinanceCustomDimensionEdge>;
  /** A list of nodes. */
  nodes: Array<FinanceCustomDimension>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FinanceCustomDimensionEdge = {
  __typename?: 'FinanceCustomDimensionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FinanceCustomDimension;
};

/** Represents a value for a custom dimension */
export type FinanceCustomDimensionMembership = {
  __typename?: 'FinanceCustomDimensionMembership';
  customDimensionValue: FinanceCustomDimensionValue;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  customDimensionValueId: Scalars['Int'];
  employee: EmployeesEmployee;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  employeeId: Scalars['Int'];
  id: Scalars['Int'];
};


/** Represents a value for a custom dimension */
export type FinanceCustomDimensionMembershipCustomDimensionValueArgs = {
  customDimensionIds?: InputMaybe<Array<Scalars['Int']>>;
  tenant?: InputMaybe<FinanceTenantInput>;
};


/** Represents a value for a custom dimension */
export type FinanceCustomDimensionMembershipEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for FinanceCustomDimensionMembership. */
export type FinanceCustomDimensionMembershipConnection = {
  __typename?: 'FinanceCustomDimensionMembershipConnection';
  /** A list of edges. */
  edges: Array<FinanceCustomDimensionMembershipEdge>;
  /** A list of nodes. */
  nodes: Array<FinanceCustomDimensionMembership>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FinanceCustomDimensionMembershipEdge = {
  __typename?: 'FinanceCustomDimensionMembershipEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FinanceCustomDimensionMembership;
};

/** Represents a value for a custom dimension */
export type FinanceCustomDimensionValue = {
  __typename?: 'FinanceCustomDimensionValue';
  code?: Maybe<Scalars['String']>;
  customDimension: FinanceCustomDimension;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  customDimensionId: Scalars['Int'];
  customDimensionMemberships: Array<FinanceCustomDimensionMembership>;
  customdimensionmembershipsConnection: FinanceCustomDimensionMembershipConnection;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  legalEntity?: Maybe<CompaniesLegalEntity>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  legalEntityId?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
};


/** Represents a value for a custom dimension */
export type FinanceCustomDimensionValueCustomDimensionArgs = {
  tenant?: InputMaybe<FinanceTenantInput>;
};


/** Represents a value for a custom dimension */
export type FinanceCustomDimensionValueCustomDimensionMembershipsArgs = {
  activeOn?: InputMaybe<Scalars['ISO8601Date']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  tenant?: InputMaybe<FinanceTenantInput>;
};


/** Represents a value for a custom dimension */
export type FinanceCustomDimensionValueCustomdimensionmembershipsConnectionArgs = {
  activeOn?: InputMaybe<Scalars['ISO8601Date']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  tenant?: InputMaybe<FinanceTenantInput>;
};


/** Represents a value for a custom dimension */
export type FinanceCustomDimensionValueLegalEntityArgs = {
  companiesIds?: InputMaybe<Array<Scalars['Int']>>;
  countryIds?: InputMaybe<Array<Scalars['String']>>;
  employeesIds?: InputMaybe<Array<Scalars['Int']>>;
  excludeCountries?: InputMaybe<Array<Scalars['String']>>;
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};

/** The connection type for FinanceCustomDimensionValue. */
export type FinanceCustomDimensionValueConnection = {
  __typename?: 'FinanceCustomDimensionValueConnection';
  /** A list of edges. */
  edges: Array<FinanceCustomDimensionValueEdge>;
  /** A list of nodes. */
  nodes: Array<FinanceCustomDimensionValue>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FinanceCustomDimensionValueEdge = {
  __typename?: 'FinanceCustomDimensionValueEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FinanceCustomDimensionValue;
};

/** the filter for the custom_dimension_values resource */
export type FinanceCustomDimensionValueFilter = {
  legalEntityId?: InputMaybe<IntegerFilter>;
  or?: InputMaybe<Array<FinanceCustomDimensionValueFilterConditions>>;
};

export type FinanceCustomDimensionValueFilterConditions = {
  legalEntityId?: InputMaybe<IntegerFilter>;
};

/** CRM Deal */
export type FinanceDeal = {
  __typename?: 'FinanceDeal';
  _policies?: Maybe<FinanceDealPolicies>;
  _policiesCollection?: Maybe<Array<PermissionsPolicyResolution>>;
  _policiesConnection: PermissionsPolicyResolutionConnection;
  author?: Maybe<EmployeesEmployeeName>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  authorId: Scalars['Int'];
  client?: Maybe<FinanceContact>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  clientId: Scalars['Int'];
  closedLostAt?: Maybe<Scalars['ISO8601DateTime']>;
  closedWonAt?: Maybe<Scalars['ISO8601DateTime']>;
  companyId: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  currency: Scalars['String'];
  estimatedAmountCents: Scalars['Int'];
  expectedCloseDate?: Maybe<Scalars['ISO8601Date']>;
  id: Scalars['Int'];
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  invoiceIds: Array<Scalars['Int']>;
  invoices: Array<FinanceFinancialDocument>;
  invoicesConnection: FinanceFinancialDocumentConnection;
  name: Scalars['String'];
  negotiationAt?: Maybe<Scalars['ISO8601DateTime']>;
  owner?: Maybe<EmployeesEmployeeName>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  ownerId: Scalars['Int'];
  ownerIdentifierForBulkPolicy: Scalars['Int'];
  proposalSentAt?: Maybe<Scalars['ISO8601DateTime']>;
  qualificationAt?: Maybe<Scalars['ISO8601DateTime']>;
  quotes: Array<FinanceQuote>;
  quotesConnection: FinanceQuoteConnection;
  stage: FinanceValueObjectsDealStageEnum;
};


/** CRM Deal */
export type FinanceDeal_PoliciesCollectionArgs = {
  ids: Array<FinanceDealPoliciesEnum>;
};


/** CRM Deal */
export type FinanceDeal_PoliciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** CRM Deal */
export type FinanceDealAuthorArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  afterEmployeeId?: InputMaybe<Scalars['Int']>;
  beforeEmployeeId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  reporteesOrLed?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyId?: InputMaybe<Scalars['Int']>;
  verb?: InputMaybe<Scalars['String']>;
  withActiveContract?: Scalars['Boolean'];
};


/** CRM Deal */
export type FinanceDealClientArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  contactType?: InputMaybe<FinanceValueObjectsContactTypeEnum>;
  email?: InputMaybe<Scalars['String']>;
  legalName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  taxIdType?: InputMaybe<Scalars['String']>;
  taxIds?: InputMaybe<Array<Scalars['String']>>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
  website?: InputMaybe<Scalars['String']>;
};


/** CRM Deal */
export type FinanceDealInvoicesArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  currency?: InputMaybe<Scalars['String']>;
  dealId?: InputMaybe<Scalars['Int']>;
  documentTypes?: InputMaybe<Array<FinanceValueObjectsFinancialDocumentTypeEnum>>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  issuerName?: InputMaybe<Scalars['String']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  operationTypes?: InputMaybe<Array<FinanceValueObjectsFinancialDocumentOperationTypeEnum>>;
  parentFinancialDocumentIds?: InputMaybe<Array<Scalars['Int']>>;
  projectId?: InputMaybe<Scalars['Int']>;
  reconcilable?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<FinanceValueObjectsInvoiceStatusEnum>>;
  toDate?: InputMaybe<Scalars['ISO8601Date']>;
  toDueDate?: InputMaybe<Scalars['ISO8601Date']>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
  vendorId?: InputMaybe<Scalars['Int']>;
};


/** CRM Deal */
export type FinanceDealInvoicesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  currency?: InputMaybe<Scalars['String']>;
  dealId?: InputMaybe<Scalars['Int']>;
  documentTypes?: InputMaybe<Array<FinanceValueObjectsFinancialDocumentTypeEnum>>;
  first?: InputMaybe<Scalars['Int']>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  issuerName?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  operationTypes?: InputMaybe<Array<FinanceValueObjectsFinancialDocumentOperationTypeEnum>>;
  parentFinancialDocumentIds?: InputMaybe<Array<Scalars['Int']>>;
  projectId?: InputMaybe<Scalars['Int']>;
  reconcilable?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  statuses?: InputMaybe<Array<FinanceValueObjectsInvoiceStatusEnum>>;
  toDate?: InputMaybe<Scalars['ISO8601Date']>;
  toDueDate?: InputMaybe<Scalars['ISO8601Date']>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
  vendorId?: InputMaybe<Scalars['Int']>;
};


/** CRM Deal */
export type FinanceDealOwnerArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  afterEmployeeId?: InputMaybe<Scalars['Int']>;
  beforeEmployeeId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  reporteesOrLed?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyId?: InputMaybe<Scalars['Int']>;
  verb?: InputMaybe<Scalars['String']>;
  withActiveContract?: Scalars['Boolean'];
};


/** CRM Deal */
export type FinanceDealQuotesArgs = {
  clientIds?: InputMaybe<Array<Scalars['Int']>>;
  companyId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


/** CRM Deal */
export type FinanceDealQuotesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  clientIds?: InputMaybe<Array<Scalars['Int']>>;
  companyId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for FinanceDeal. */
export type FinanceDealConnection = {
  __typename?: 'FinanceDealConnection';
  /** A list of edges. */
  edges: Array<FinanceDealEdge>;
  /** A list of nodes. */
  nodes: Array<FinanceDeal>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FinanceDealEdge = {
  __typename?: 'FinanceDealEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FinanceDeal;
};

export type FinanceDealPolicies = {
  __typename?: 'FinanceDealPolicies';
  access: PermissionsPolicyResolution;
};

export type FinanceDealPoliciesEnum =
  | 'access';

export type FinanceDtosAccountingAccountImportTemplatePrefillEnum =
  | 'current_data'
  | 'sample_data';

export type FinanceDtosPendingActionsOverviewSummaryScopeEnum =
  | 'accounting'
  | 'treasury';

export type FinanceDtosSpendingPoliciesPeopleGroupStrategyEnum =
  | 'legal_entities'
  | 'manual_selection';

export type FinanceEntitiesFinancialCostStatusEnum =
  | 'active'
  | 'deleted';

export type FinanceEntitiesResourceTypeEnum =
  | 'expense'
  | 'project'
  | 'purchaseorder'
  | 'quote'
  | 'softwaresetup'
  | 'subproject';

export type FinanceEnumsQuoteStatusEnum =
  | 'accepted'
  | 'draft'
  | 'rejected';

export type FinanceEnumsQuoteTypeEnum =
  | 'products'
  | 'timeandmaterials';

/** Represents the supported currencies in the exchange rate API. It's a fixed list of currencies and is not paginateable */
export type FinanceExchangeCurrency = {
  __typename?: 'FinanceExchangeCurrency';
  id: Scalars['String'];
};

/** The connection type for FinanceExchangeCurrency. */
export type FinanceExchangeCurrencyConnection = {
  __typename?: 'FinanceExchangeCurrencyConnection';
  /** A list of edges. */
  edges: Array<FinanceExchangeCurrencyEdge>;
  /** A list of nodes. */
  nodes: Array<FinanceExchangeCurrency>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FinanceExchangeCurrencyEdge = {
  __typename?: 'FinanceExchangeCurrencyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FinanceExchangeCurrency;
};

/** evaluates an expense against a spending policy */
export type FinanceExpenseSpendingPolicyEvaluation = {
  __typename?: 'FinanceExpenseSpendingPolicyEvaluation';
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  applicablePolicyIds: Scalars['String'];
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  applicableRuleGroupIds: Scalars['String'];
  applicableRuleGroups: Array<FinanceSpendingPolicyRuleGroup>;
  applicableRuleGroupsConnection: FinanceSpendingPolicyRuleGroupConnection;
  failedRules: Array<FinanceSpendingPolicyFailedRuleEvaluation>;
  result: FinanceValueObjectsSpendingPolicyEvaluationResultTypeEnum;
  spendingPolicies: Array<FinanceSpendingPolicy>;
  spendingPoliciesConnection: FinanceSpendingPolicyConnection;
};


/** evaluates an expense against a spending policy */
export type FinanceExpenseSpendingPolicyEvaluationApplicableRuleGroupsArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  onlyParents?: InputMaybe<Scalars['Boolean']>;
  parentId?: InputMaybe<Scalars['String']>;
  spendingPolicyIds?: InputMaybe<Array<Scalars['String']>>;
};


/** evaluates an expense against a spending policy */
export type FinanceExpenseSpendingPolicyEvaluationApplicableRuleGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyParents?: InputMaybe<Scalars['Boolean']>;
  parentId?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  spendingPolicyIds?: InputMaybe<Array<Scalars['String']>>;
};


/** evaluates an expense against a spending policy */
export type FinanceExpenseSpendingPolicyEvaluationSpendingPoliciesArgs = {
  companyId?: InputMaybe<Scalars['String']>;
};


/** evaluates an expense against a spending policy */
export type FinanceExpenseSpendingPolicyEvaluationSpendingPoliciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for FinanceExpenseSpendingPolicyEvaluation. */
export type FinanceExpenseSpendingPolicyEvaluationConnection = {
  __typename?: 'FinanceExpenseSpendingPolicyEvaluationConnection';
  /** A list of edges. */
  edges: Array<FinanceExpenseSpendingPolicyEvaluationEdge>;
  /** A list of nodes. */
  nodes: Array<FinanceExpenseSpendingPolicyEvaluation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FinanceExpenseSpendingPolicyEvaluationEdge = {
  __typename?: 'FinanceExpenseSpendingPolicyEvaluationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FinanceExpenseSpendingPolicyEvaluation;
};

export type FinanceFile = {
  __typename?: 'FinanceFile';
  contentType: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  filename: Scalars['String'];
  id: Scalars['Int'];
  size: Scalars['Int'];
  url: Scalars['String'];
};

/** Represents a financial cost */
export type FinanceFinancialCost = {
  __typename?: 'FinanceFinancialCost';
  amount: Money;
  companyId: Scalars['Int'];
  date: Scalars['ISO8601DateTime'];
  employeeId: Scalars['Int'];
  id: Scalars['Int'];
  source: FinanceTrackedCostSource;
  status: FinanceEntitiesFinancialCostStatusEnum;
};

/** The connection type for FinanceFinancialCost. */
export type FinanceFinancialCostConnection = {
  __typename?: 'FinanceFinancialCostConnection';
  /** A list of edges. */
  edges: Array<FinanceFinancialCostEdge>;
  /** A list of nodes. */
  nodes: Array<FinanceFinancialCost>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FinanceFinancialCostEdge = {
  __typename?: 'FinanceFinancialCostEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FinanceFinancialCost;
};

/** Financial Document is a document that represents a financial transaction. Could be an invoice, a credit note or receipt. */
export type FinanceFinancialDocument = {
  __typename?: 'FinanceFinancialDocument';
  accountResource?: Maybe<FinanceLedgerAccountResource>;
  /** Date when the financial document was archived. */
  archivedAt?: Maybe<Scalars['ISO8601DateTime']>;
  childFinancialDocument?: Maybe<FinanceFinancialDocument>;
  companyId: Scalars['Int'];
  complianceFields: Array<FinanceFinancialDocumentComplianceExtraField>;
  complianceFieldsConnection: FinanceFinancialDocumentComplianceExtraFieldConnection;
  complianceOutputFiles?: Maybe<Array<FinanceFile>>;
  /** Creation date. */
  createdAt: Scalars['ISO8601DateTime'];
  /** Document currency. */
  currency?: Maybe<Scalars['String']>;
  deal?: Maybe<FinanceDeal>;
  discountPercentage?: Maybe<Scalars['Float']>;
  /** Document date. */
  documentDate?: Maybe<Scalars['ISO8601Date']>;
  documentDatetime?: Maybe<Scalars['ISO8601DateTime']>;
  /** Document number. */
  documentNumber?: Maybe<Scalars['String']>;
  /** Type of the financial document. Using "invoice" as default. */
  documentType: FinanceValueObjectsFinancialDocumentTypeEnum;
  /** Due date. */
  dueDate?: Maybe<Scalars['ISO8601Date']>;
  duplicateFinancialDocument?: Maybe<FinanceFinancialDocument>;
  /**
   * Factorial unique identifier for the duplicate financial document.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  duplicateFinancialDocumentId?: Maybe<Scalars['Int']>;
  exchangeRate?: Maybe<Scalars['String']>;
  expensesFinancialDocumentAssociation?: Maybe<FinanceFinancialDocumentAssociation>;
  /** File attached. */
  file?: Maybe<FinanceInvoiceFile>;
  financialDocumentEvents: Array<FinanceFinancialDocumentEvent>;
  financialDocumentEventsConnection: FinanceFinancialDocumentEventConnection;
  footer?: Maybe<Scalars['String']>;
  /** Date when was fully reconciled. */
  fullyReconciledAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Factorial unique identifier. */
  id: Scalars['Int'];
  /** First line of the issuer's address. */
  issuerAddressLine1?: Maybe<Scalars['String']>;
  /** Second line of the issuer's address. */
  issuerAddressLine2?: Maybe<Scalars['String']>;
  /** City of the issuer's address. */
  issuerCity?: Maybe<Scalars['String']>;
  /** Country code of the issuer's address. */
  issuerCountryCode?: Maybe<Scalars['String']>;
  /** Name of the entity issuing the financial document. */
  issuerName?: Maybe<Scalars['String']>;
  /** Postal code of the issuer's address. */
  issuerPostalCode?: Maybe<Scalars['String']>;
  /** State or province of the issuer's address. */
  issuerState?: Maybe<Scalars['String']>;
  /** Tax identification number of the issuer. */
  issuerTaxId?: Maybe<Scalars['String']>;
  journalDraftEntry?: Maybe<FinanceJournalDraftEntry>;
  journalEntry?: Maybe<FinanceJournalEntry>;
  legalEntity?: Maybe<CompaniesLegalEntity>;
  /**
   * Factorial unique identifier for the legal entity of the financial document.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  legalEntityId?: Maybe<Scalars['Int']>;
  lineItems: Array<FinanceFinancialDocumentLineItem>;
  logoFile?: Maybe<FinanceFile>;
  memo?: Maybe<Scalars['String']>;
  /** Net amount in cents. */
  netAmountCents?: Maybe<Scalars['BigInt']>;
  /** Specifies the type of financial operation, indicating whether it is a purchase or a sale. */
  operationType: FinanceValueObjectsFinancialDocumentOperationTypeEnum;
  parentFinancialDocument?: Maybe<FinanceFinancialDocument>;
  /**
   * Factorial unique identifier for the parent financial document of the financial document.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  parentFinancialDocumentId?: Maybe<Scalars['Int']>;
  projectsFinancialDocumentAssociation?: Maybe<FinanceFinancialDocumentAssociation>;
  purchaseOrderFinancialDocumentAssociation?: Maybe<FinanceFinancialDocumentAssociation>;
  quote?: Maybe<FinanceQuote>;
  quoteFinancialDocumentAssociation?: Maybe<FinanceFinancialDocumentAssociation>;
  /** First line of the recipient's address. */
  recipientAddressLine1?: Maybe<Scalars['String']>;
  /** Second line of the recipient's address. */
  recipientAddressLine2?: Maybe<Scalars['String']>;
  /** City of the recipient's address. */
  recipientCity?: Maybe<Scalars['String']>;
  /** Country code of the recipient's address. */
  recipientCountryCode?: Maybe<Scalars['String']>;
  /** Name of the entity receiving the financial document. */
  recipientName?: Maybe<Scalars['String']>;
  /** Postal code of the recipient's address. */
  recipientPostalCode?: Maybe<Scalars['String']>;
  /** State or province of the recipient's address. */
  recipientState?: Maybe<Scalars['String']>;
  /** Tax identification number of the recipient. */
  recipientTaxId?: Maybe<Scalars['String']>;
  /** Tax identification type of the recipient. */
  recipientTaxIdType?: Maybe<FinanceValueObjectsContactTaxIdTypeEnum>;
  reconcilable: Scalars['Boolean'];
  reconciliationSuggestions: Array<BankingReconciliationSuggestion>;
  reconciliationSuggestionsConnection: BankingReconciliationSuggestionConnection;
  reconciliations: Array<BankingReconciliation>;
  reconciliationsConnection: BankingReconciliationConnection;
  /** Date when was recorded. */
  recordedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Date when the register sale process was started (initial step of issuing process). */
  registerSaleAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Factorial unique identifier for the user who started the register sale process. */
  registerSaleById?: Maybe<Scalars['Int']>;
  retentionTaxRate?: Maybe<FinanceTaxRate>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  retentionTaxRateId?: Maybe<Scalars['Int']>;
  salesInvoiceSequence?: Maybe<FinanceSalesInvoiceSequence>;
  /**
   * Serial sequence id.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  serialSequenceId?: Maybe<Scalars['Int']>;
  softwareSetupFinancialDocumentAssociation?: Maybe<FinanceFinancialDocumentAssociation>;
  /** Current status. */
  status: FinanceValueObjectsInvoiceStatusEnum;
  subprojectsFinancialDocumentAssociation?: Maybe<FinanceFinancialDocumentAssociation>;
  /** Taxes. */
  taxes: Array<FinanceInvoiceTax>;
  /** Taxes total amount in cents. */
  taxesTotalAmountCents?: Maybe<Scalars['BigInt']>;
  /** Total amount in cents. */
  totalAmountCents?: Maybe<Scalars['BigInt']>;
  /** Updation date. */
  updatedAt: Scalars['ISO8601DateTime'];
  /** Date when was validated. */
  validatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Factorial unique identifier for the user who validated the financial document. */
  validatedById?: Maybe<Scalars['Int']>;
  vendor?: Maybe<FinanceContact>;
  /**
   * Factorial unique identifier for the vendor of the financial document.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  vendorId?: Maybe<Scalars['Int']>;
};


/** Financial Document is a document that represents a financial transaction. Could be an invoice, a credit note or receipt. */
export type FinanceFinancialDocumentAccountResourceArgs = {
  financeAccountIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Financial Document is a document that represents a financial transaction. Could be an invoice, a credit note or receipt. */
export type FinanceFinancialDocumentChildFinancialDocumentArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  currency?: InputMaybe<Scalars['String']>;
  dealId?: InputMaybe<Scalars['Int']>;
  documentTypes?: InputMaybe<Array<FinanceValueObjectsFinancialDocumentTypeEnum>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  issuerName?: InputMaybe<Scalars['String']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  operationTypes?: InputMaybe<Array<FinanceValueObjectsFinancialDocumentOperationTypeEnum>>;
  projectId?: InputMaybe<Scalars['Int']>;
  reconcilable?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<FinanceValueObjectsInvoiceStatusEnum>>;
  toDate?: InputMaybe<Scalars['ISO8601Date']>;
  toDueDate?: InputMaybe<Scalars['ISO8601Date']>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
  vendorId?: InputMaybe<Scalars['Int']>;
};


/** Financial Document is a document that represents a financial transaction. Could be an invoice, a credit note or receipt. */
export type FinanceFinancialDocumentComplianceFieldsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Financial Document is a document that represents a financial transaction. Could be an invoice, a credit note or receipt. */
export type FinanceFinancialDocumentComplianceFieldsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Financial Document is a document that represents a financial transaction. Could be an invoice, a credit note or receipt. */
export type FinanceFinancialDocumentDealArgs = {
  clientIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  stages?: InputMaybe<Array<FinanceValueObjectsDealStageEnum>>;
};


/** Financial Document is a document that represents a financial transaction. Could be an invoice, a credit note or receipt. */
export type FinanceFinancialDocumentDuplicateFinancialDocumentArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  currency?: InputMaybe<Scalars['String']>;
  dealId?: InputMaybe<Scalars['Int']>;
  documentTypes?: InputMaybe<Array<FinanceValueObjectsFinancialDocumentTypeEnum>>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  issuerName?: InputMaybe<Scalars['String']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  operationTypes?: InputMaybe<Array<FinanceValueObjectsFinancialDocumentOperationTypeEnum>>;
  parentFinancialDocumentIds?: InputMaybe<Array<Scalars['Int']>>;
  projectId?: InputMaybe<Scalars['Int']>;
  reconcilable?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<FinanceValueObjectsInvoiceStatusEnum>>;
  toDate?: InputMaybe<Scalars['ISO8601Date']>;
  toDueDate?: InputMaybe<Scalars['ISO8601Date']>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
  vendorId?: InputMaybe<Scalars['Int']>;
};


/** Financial Document is a document that represents a financial transaction. Could be an invoice, a credit note or receipt. */
export type FinanceFinancialDocumentExpensesFinancialDocumentAssociationArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  resourceIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Financial Document is a document that represents a financial transaction. Could be an invoice, a credit note or receipt. */
export type FinanceFinancialDocumentFinancialDocumentEventsArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']>>;
  balanceTypes?: InputMaybe<Array<FinanceValueObjectsLedgerAccountBalanceTypeEnum>>;
  bankAccountIds?: InputMaybe<Array<Scalars['Int']>>;
  bySuspenseAccount?: InputMaybe<Scalars['Boolean']>;
  currency?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  excludingJournalEntryTypes?: InputMaybe<Array<FinanceValueObjectsJournalEntryTypeEnum>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  journalEntryIds?: InputMaybe<Array<Scalars['Int']>>;
  journalEntryTypes?: InputMaybe<Array<FinanceValueObjectsJournalEntryTypeEnum>>;
  reconcilable?: InputMaybe<Scalars['Boolean']>;
  reconciliationStatus?: InputMaybe<FinanceValueObjectsReconciliationStatusEnum>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Financial Document is a document that represents a financial transaction. Could be an invoice, a credit note or receipt. */
export type FinanceFinancialDocumentFinancialDocumentEventsConnectionArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']>>;
  after?: InputMaybe<Scalars['String']>;
  balanceTypes?: InputMaybe<Array<FinanceValueObjectsLedgerAccountBalanceTypeEnum>>;
  bankAccountIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  bySuspenseAccount?: InputMaybe<Scalars['Boolean']>;
  currency?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  excludingJournalEntryTypes?: InputMaybe<Array<FinanceValueObjectsJournalEntryTypeEnum>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  journalEntryIds?: InputMaybe<Array<Scalars['Int']>>;
  journalEntryTypes?: InputMaybe<Array<FinanceValueObjectsJournalEntryTypeEnum>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  reconcilable?: InputMaybe<Scalars['Boolean']>;
  reconciliationStatus?: InputMaybe<FinanceValueObjectsReconciliationStatusEnum>;
  sortOrder?: InputMaybe<Sort>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Financial Document is a document that represents a financial transaction. Could be an invoice, a credit note or receipt. */
export type FinanceFinancialDocumentJournalDraftEntryArgs = {
  bankTransactionIds?: InputMaybe<Array<Scalars['Int']>>;
  companyId?: InputMaybe<Scalars['Int']>;
  financialDocumentIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  invoiceIds?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  statuses?: InputMaybe<Array<FinanceValueObjectsJournalDraftEntryStatusEnum>>;
};


/** Financial Document is a document that represents a financial transaction. Could be an invoice, a credit note or receipt. */
export type FinanceFinancialDocumentJournalEntryArgs = {
  bankTransactionIds?: InputMaybe<Array<Scalars['Int']>>;
  financialDocumentIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  invoiceIds?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  publishedFrom?: InputMaybe<Scalars['ISO8601Date']>;
  status?: InputMaybe<FinanceValueObjectsJournalEntryStatusEnum>;
  types?: InputMaybe<Array<FinanceValueObjectsJournalEntryTypeEnum>>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Financial Document is a document that represents a financial transaction. Could be an invoice, a credit note or receipt. */
export type FinanceFinancialDocumentLegalEntityArgs = {
  companiesIds?: InputMaybe<Array<Scalars['Int']>>;
  countryIds?: InputMaybe<Array<Scalars['String']>>;
  employeesIds?: InputMaybe<Array<Scalars['Int']>>;
  excludeCountries?: InputMaybe<Array<Scalars['String']>>;
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


/** Financial Document is a document that represents a financial transaction. Could be an invoice, a credit note or receipt. */
export type FinanceFinancialDocumentParentFinancialDocumentArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  currency?: InputMaybe<Scalars['String']>;
  dealId?: InputMaybe<Scalars['Int']>;
  documentTypes?: InputMaybe<Array<FinanceValueObjectsFinancialDocumentTypeEnum>>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  issuerName?: InputMaybe<Scalars['String']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  operationTypes?: InputMaybe<Array<FinanceValueObjectsFinancialDocumentOperationTypeEnum>>;
  parentFinancialDocumentIds?: InputMaybe<Array<Scalars['Int']>>;
  projectId?: InputMaybe<Scalars['Int']>;
  reconcilable?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<FinanceValueObjectsInvoiceStatusEnum>>;
  toDate?: InputMaybe<Scalars['ISO8601Date']>;
  toDueDate?: InputMaybe<Scalars['ISO8601Date']>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
  vendorId?: InputMaybe<Scalars['Int']>;
};


/** Financial Document is a document that represents a financial transaction. Could be an invoice, a credit note or receipt. */
export type FinanceFinancialDocumentProjectsFinancialDocumentAssociationArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  resourceIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Financial Document is a document that represents a financial transaction. Could be an invoice, a credit note or receipt. */
export type FinanceFinancialDocumentPurchaseOrderFinancialDocumentAssociationArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  resourceIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Financial Document is a document that represents a financial transaction. Could be an invoice, a credit note or receipt. */
export type FinanceFinancialDocumentQuoteArgs = {
  clientIds?: InputMaybe<Array<Scalars['Int']>>;
  companyId?: InputMaybe<Scalars['Int']>;
  dealIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


/** Financial Document is a document that represents a financial transaction. Could be an invoice, a credit note or receipt. */
export type FinanceFinancialDocumentQuoteFinancialDocumentAssociationArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  resourceIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Financial Document is a document that represents a financial transaction. Could be an invoice, a credit note or receipt. */
export type FinanceFinancialDocumentReconciliationSuggestionsArgs = {
  companyId: Scalars['Int'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  invoiceIds?: InputMaybe<Array<Scalars['Int']>>;
  paymentExecutionIds?: InputMaybe<Array<Scalars['Int']>>;
  transactionIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Financial Document is a document that represents a financial transaction. Could be an invoice, a credit note or receipt. */
export type FinanceFinancialDocumentReconciliationSuggestionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  invoiceIds?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  paymentExecutionIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
  transactionIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Financial Document is a document that represents a financial transaction. Could be an invoice, a credit note or receipt. */
export type FinanceFinancialDocumentReconciliationsArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
  transactionIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Financial Document is a document that represents a financial transaction. Could be an invoice, a credit note or receipt. */
export type FinanceFinancialDocumentReconciliationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  transactionIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Financial Document is a document that represents a financial transaction. Could be an invoice, a credit note or receipt. */
export type FinanceFinancialDocumentRetentionTaxRateArgs = {
  countryCode?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<FinanceValueObjectsTaxSourceEnum>;
  taxTypeIds?: InputMaybe<Array<Scalars['Int']>>;
  type?: InputMaybe<FinanceValueObjectsTaxTypeEnum>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Financial Document is a document that represents a financial transaction. Could be an invoice, a credit note or receipt. */
export type FinanceFinancialDocumentSalesInvoiceSequenceArgs = {
  legalEntityId?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<SerialSequencesValueObjectsStatusEnum>;
};


/** Financial Document is a document that represents a financial transaction. Could be an invoice, a credit note or receipt. */
export type FinanceFinancialDocumentSoftwareSetupFinancialDocumentAssociationArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  resourceIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Financial Document is a document that represents a financial transaction. Could be an invoice, a credit note or receipt. */
export type FinanceFinancialDocumentSubprojectsFinancialDocumentAssociationArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  resourceIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Financial Document is a document that represents a financial transaction. Could be an invoice, a credit note or receipt. */
export type FinanceFinancialDocumentVendorArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  contactType?: InputMaybe<FinanceValueObjectsContactTypeEnum>;
  email?: InputMaybe<Scalars['String']>;
  legalName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  taxIdType?: InputMaybe<Scalars['String']>;
  taxIds?: InputMaybe<Array<Scalars['String']>>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
  website?: InputMaybe<Scalars['String']>;
};

/** Financial document association */
export type FinanceFinancialDocumentAssociation = {
  __typename?: 'FinanceFinancialDocumentAssociation';
  expense?: Maybe<ExpensesExpense>;
  financialDocument?: Maybe<FinanceFinancialDocument>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  financialDocumentId: Scalars['Int'];
  financialProject?: Maybe<ProjectManagementFinancialProject>;
  id: Scalars['Int'];
  purchaseOrder?: Maybe<ProcurementPurchaseOrder>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  resourceId: Scalars['Int'];
  resourceType: FinanceEntitiesResourceTypeEnum;
  softwareSetup?: Maybe<SoftwareManagementSoftwareSetup>;
  subproject?: Maybe<ProjectManagementSubproject>;
};


/** Financial document association */
export type FinanceFinancialDocumentAssociationExpenseArgs = {
  bookEntryIds?: InputMaybe<Array<Scalars['Int']>>;
  cardIds?: InputMaybe<Array<Scalars['Int']>>;
  cardPaymentIds?: InputMaybe<Array<Scalars['Int']>>;
  disputeIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  expensesExpensableIds?: InputMaybe<Array<Scalars['Int']>>;
  externalAuthorizationIds?: InputMaybe<Array<Scalars['String']>>;
  from?: InputMaybe<Scalars['ISO8601DateTime']>;
  includeAttachments?: Scalars['Boolean'];
  includeManualDrafts?: Scalars['Boolean'];
  includeReimbursableData?: InputMaybe<Scalars['Boolean']>;
  to?: InputMaybe<Scalars['ISO8601DateTime']>;
};


/** Financial document association */
export type FinanceFinancialDocumentAssociationFinancialDocumentArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  currency?: InputMaybe<Scalars['String']>;
  dealId?: InputMaybe<Scalars['Int']>;
  documentTypes?: InputMaybe<Array<FinanceValueObjectsFinancialDocumentTypeEnum>>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  issuerName?: InputMaybe<Scalars['String']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  operationTypes?: InputMaybe<Array<FinanceValueObjectsFinancialDocumentOperationTypeEnum>>;
  parentFinancialDocumentIds?: InputMaybe<Array<Scalars['Int']>>;
  projectId?: InputMaybe<Scalars['Int']>;
  reconcilable?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<FinanceValueObjectsInvoiceStatusEnum>>;
  toDate?: InputMaybe<Scalars['ISO8601Date']>;
  toDueDate?: InputMaybe<Scalars['ISO8601Date']>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
  vendorId?: InputMaybe<Scalars['Int']>;
};


/** Financial document association */
export type FinanceFinancialDocumentAssociationFinancialProjectArgs = {
  billable?: InputMaybe<Scalars['Boolean']>;
  nameOrCode?: InputMaybe<Scalars['String']>;
};


/** Financial document association */
export type FinanceFinancialDocumentAssociationPurchaseOrderArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  currencies?: InputMaybe<Array<Scalars['String']>>;
  purchaseRequestIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ProcurementValueObjectsPurchaseOrderStatusEnum>;
  vendorId?: InputMaybe<Scalars['Int']>;
};


/** Financial document association */
export type FinanceFinancialDocumentAssociationSoftwareSetupArgs = {
  cardIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  vendorIds?: InputMaybe<Array<Scalars['Int']>>;
  withoutCard?: InputMaybe<Scalars['Boolean']>;
};


/** Financial document association */
export type FinanceFinancialDocumentAssociationSubprojectArgs = {
  financialProjectIds?: InputMaybe<Array<Scalars['Int']>>;
  imputableProjectIds?: InputMaybe<Array<Scalars['Int']>>;
  includeCost?: InputMaybe<Scalars['Boolean']>;
  includeInputedMinutes?: InputMaybe<Scalars['Boolean']>;
  includeNoSubproject?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  notClosed?: InputMaybe<Scalars['Boolean']>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
};

/** The connection type for FinanceFinancialDocumentAssociation. */
export type FinanceFinancialDocumentAssociationConnection = {
  __typename?: 'FinanceFinancialDocumentAssociationConnection';
  /** A list of edges. */
  edges: Array<FinanceFinancialDocumentAssociationEdge>;
  /** A list of nodes. */
  nodes: Array<FinanceFinancialDocumentAssociation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FinanceFinancialDocumentAssociationEdge = {
  __typename?: 'FinanceFinancialDocumentAssociationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FinanceFinancialDocumentAssociation;
};

/** the filter for the financial_document_associations resource */
export type FinanceFinancialDocumentAssociationFilter = {
  documentNumber?: InputMaybe<StringFilter>;
  financialDocumentId?: InputMaybe<IntegerFilter>;
  or?: InputMaybe<Array<FinanceFinancialDocumentAssociationFilterConditions>>;
};

export type FinanceFinancialDocumentAssociationFilterConditions = {
  documentNumber?: InputMaybe<StringFilter>;
  financialDocumentId?: InputMaybe<IntegerFilter>;
};

export type FinanceFinancialDocumentAssociationInput = {
  id?: InputMaybe<Scalars['Int']>;
  resource: FinanceFinancialDocumentResourceInput;
};

/** Compliance extra fields for financial documents */
export type FinanceFinancialDocumentComplianceExtraField = {
  __typename?: 'FinanceFinancialDocumentComplianceExtraField';
  countryCode: Scalars['String'];
  fields: Array<FinanceFinancialDocumentComplianceExtraFieldsField>;
  financialDocument?: Maybe<FinanceFinancialDocument>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  financialDocumentId: Scalars['Int'];
  id: Scalars['Int'];
  organization: FinanceValueObjectsComplianceExtraFieldOrganizationEnum;
};


/** Compliance extra fields for financial documents */
export type FinanceFinancialDocumentComplianceExtraFieldFinancialDocumentArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  currency?: InputMaybe<Scalars['String']>;
  dealId?: InputMaybe<Scalars['Int']>;
  documentTypes?: InputMaybe<Array<FinanceValueObjectsFinancialDocumentTypeEnum>>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  issuerName?: InputMaybe<Scalars['String']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  operationTypes?: InputMaybe<Array<FinanceValueObjectsFinancialDocumentOperationTypeEnum>>;
  parentFinancialDocumentIds?: InputMaybe<Array<Scalars['Int']>>;
  projectId?: InputMaybe<Scalars['Int']>;
  reconcilable?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<FinanceValueObjectsInvoiceStatusEnum>>;
  toDate?: InputMaybe<Scalars['ISO8601Date']>;
  toDueDate?: InputMaybe<Scalars['ISO8601Date']>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
  vendorId?: InputMaybe<Scalars['Int']>;
};

/** The connection type for FinanceFinancialDocumentComplianceExtraField. */
export type FinanceFinancialDocumentComplianceExtraFieldConnection = {
  __typename?: 'FinanceFinancialDocumentComplianceExtraFieldConnection';
  /** A list of edges. */
  edges: Array<FinanceFinancialDocumentComplianceExtraFieldEdge>;
  /** A list of nodes. */
  nodes: Array<FinanceFinancialDocumentComplianceExtraField>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FinanceFinancialDocumentComplianceExtraFieldEdge = {
  __typename?: 'FinanceFinancialDocumentComplianceExtraFieldEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FinanceFinancialDocumentComplianceExtraField;
};

/** Configs of compliance extra fields for financial documents */
export type FinanceFinancialDocumentComplianceExtraFieldsConfig = {
  __typename?: 'FinanceFinancialDocumentComplianceExtraFieldsConfig';
  countryCode: Scalars['String'];
  fields: Array<FinanceComplianceExtraFieldConfig>;
  id: Scalars['String'];
  organization: FinanceValueObjectsComplianceExtraFieldOrganizationEnum;
};

/** The connection type for FinanceFinancialDocumentComplianceExtraFieldsConfig. */
export type FinanceFinancialDocumentComplianceExtraFieldsConfigConnection = {
  __typename?: 'FinanceFinancialDocumentComplianceExtraFieldsConfigConnection';
  /** A list of edges. */
  edges: Array<FinanceFinancialDocumentComplianceExtraFieldsConfigEdge>;
  /** A list of nodes. */
  nodes: Array<FinanceFinancialDocumentComplianceExtraFieldsConfig>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FinanceFinancialDocumentComplianceExtraFieldsConfigEdge = {
  __typename?: 'FinanceFinancialDocumentComplianceExtraFieldsConfigEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FinanceFinancialDocumentComplianceExtraFieldsConfig;
};

export type FinanceFinancialDocumentComplianceExtraFieldsField = {
  __typename?: 'FinanceFinancialDocumentComplianceExtraFieldsField';
  associatedFieldId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

/** The connection type for FinanceFinancialDocument. */
export type FinanceFinancialDocumentConnection = {
  __typename?: 'FinanceFinancialDocumentConnection';
  aggregate?: Maybe<FinanceFinancialDocumentsAggregate>;
  /** A list of edges. */
  edges: Array<FinanceFinancialDocumentEdge>;
  /** A list of nodes. */
  nodes: Array<FinanceFinancialDocument>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FinanceFinancialDocumentEdge = {
  __typename?: 'FinanceFinancialDocumentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FinanceFinancialDocument;
};

/** events for financial document */
export type FinanceFinancialDocumentEvent = {
  __typename?: 'FinanceFinancialDocumentEvent';
  code?: Maybe<Scalars['String']>;
  date: Scalars['ISO8601DateTime'];
  financialDocumentId: Scalars['Int'];
  message?: Maybe<Scalars['String']>;
  status: FinanceValueObjectsFinancialDocumentEventStatusEnum;
  type: FinanceValueObjectsFinancialDocumentEventTypeEnum;
};

/** The connection type for FinanceFinancialDocumentEvent. */
export type FinanceFinancialDocumentEventConnection = {
  __typename?: 'FinanceFinancialDocumentEventConnection';
  /** A list of edges. */
  edges: Array<FinanceFinancialDocumentEventEdge>;
  /** A list of nodes. */
  nodes: Array<FinanceFinancialDocumentEvent>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FinanceFinancialDocumentEventEdge = {
  __typename?: 'FinanceFinancialDocumentEventEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FinanceFinancialDocumentEvent;
};

/** the filter for the financial_documents resource */
export type FinanceFinancialDocumentFilter = {
  createdAt?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<StringFilter>;
  dealId?: InputMaybe<IntegerFilter>;
  documentDate?: InputMaybe<DateFilter>;
  documentNumber?: InputMaybe<StringFilter>;
  documentType?: InputMaybe<StringFilter>;
  dueDate?: InputMaybe<DateFilter>;
  issuedWithErrors?: InputMaybe<BooleanFilter>;
  legalEntity?: InputMaybe<IntegerFilter>;
  legalEntityId?: InputMaybe<IntegerFilter>;
  netAmountCents?: InputMaybe<StringFilter>;
  operationType?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<FinanceFinancialDocumentFilterConditions>>;
  projectId?: InputMaybe<IntegerFilter>;
  status?: InputMaybe<StringFilter>;
  taxesTotalAmountCents?: InputMaybe<StringFilter>;
  totalAmountCents?: InputMaybe<StringFilter>;
  validated?: InputMaybe<BooleanFilter>;
  vendorId?: InputMaybe<IntegerFilter>;
  vendorLegalName?: InputMaybe<StringFilter>;
};

export type FinanceFinancialDocumentFilterConditions = {
  createdAt?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<StringFilter>;
  dealId?: InputMaybe<IntegerFilter>;
  documentDate?: InputMaybe<DateFilter>;
  documentNumber?: InputMaybe<StringFilter>;
  documentType?: InputMaybe<StringFilter>;
  dueDate?: InputMaybe<DateFilter>;
  issuedWithErrors?: InputMaybe<BooleanFilter>;
  legalEntity?: InputMaybe<IntegerFilter>;
  legalEntityId?: InputMaybe<IntegerFilter>;
  netAmountCents?: InputMaybe<StringFilter>;
  operationType?: InputMaybe<StringFilter>;
  projectId?: InputMaybe<IntegerFilter>;
  status?: InputMaybe<StringFilter>;
  taxesTotalAmountCents?: InputMaybe<StringFilter>;
  totalAmountCents?: InputMaybe<StringFilter>;
  validated?: InputMaybe<BooleanFilter>;
  vendorId?: InputMaybe<IntegerFilter>;
  vendorLegalName?: InputMaybe<StringFilter>;
};

export type FinanceFinancialDocumentLineItem = {
  __typename?: 'FinanceFinancialDocumentLineItem';
  amountCents: Scalars['Int'];
  description: Scalars['String'];
  id: Scalars['String'];
  quantity: Scalars['Float'];
  taxRateId: Scalars['Int'];
  taxRatePercentage: Scalars['Float'];
  taxTypeCountry?: Maybe<Scalars['String']>;
  taxTypeId: Scalars['Int'];
  taxTypeName?: Maybe<Scalars['String']>;
  taxTypeType?: Maybe<FinanceValueObjectsTaxTypeEnum>;
};

/** preview for financial document */
export type FinanceFinancialDocumentPreview = {
  __typename?: 'FinanceFinancialDocumentPreview';
  htmlContent: Scalars['String'];
};

export type FinanceFinancialDocumentResourceInput = {
  id: Scalars['Int'];
  type: FinanceEntitiesResourceTypeEnum;
};

/** Finance financial_documents aggregates */
export type FinanceFinancialDocumentsAggregate = {
  __typename?: 'FinanceFinancialDocumentsAggregate';
  average?: Maybe<FinanceFinancialDocumentsConnectionAggregateAverage>;
  count?: Maybe<Scalars['Int']>;
  maximum?: Maybe<FinanceFinancialDocumentsConnectionAggregateMaximum>;
  minimum?: Maybe<FinanceFinancialDocumentsConnectionAggregateMinimum>;
  sum?: Maybe<FinanceFinancialDocumentsConnectionAggregateSum>;
  terms?: Maybe<FinanceFinancialDocumentsConnectionAggregateTerms>;
};

export type FinanceFinancialDocumentsAggregateTerms = {
  __typename?: 'FinanceFinancialDocumentsAggregateTerms';
  average?: Maybe<FinanceFinancialDocumentsConnectionAggregateTermsAverageFields>;
  count?: Maybe<Array<Scalars['Int']>>;
  maximum?: Maybe<FinanceFinancialDocumentsConnectionAggregateTermsMaximumFields>;
  minimum?: Maybe<FinanceFinancialDocumentsConnectionAggregateTermsMinimumFields>;
  sum?: Maybe<FinanceFinancialDocumentsConnectionAggregateTermsSumFields>;
  values: Array<Scalars['String']>;
};

/** average function */
export type FinanceFinancialDocumentsConnectionAggregateAverage = {
  __typename?: 'FinanceFinancialDocumentsConnectionAggregateAverage';
  netAmountCents?: Maybe<Scalars['Float']>;
  taxesTotalAmountCents?: Maybe<Scalars['Float']>;
  totalAmountCents?: Maybe<Scalars['Float']>;
};

/** maximum function */
export type FinanceFinancialDocumentsConnectionAggregateMaximum = {
  __typename?: 'FinanceFinancialDocumentsConnectionAggregateMaximum';
  netAmountCents?: Maybe<Scalars['Int']>;
  taxesTotalAmountCents?: Maybe<Scalars['Int']>;
  totalAmountCents?: Maybe<Scalars['Int']>;
};

/** minimum function */
export type FinanceFinancialDocumentsConnectionAggregateMinimum = {
  __typename?: 'FinanceFinancialDocumentsConnectionAggregateMinimum';
  netAmountCents?: Maybe<Scalars['Int']>;
  taxesTotalAmountCents?: Maybe<Scalars['Int']>;
  totalAmountCents?: Maybe<Scalars['Int']>;
};

/** sum function */
export type FinanceFinancialDocumentsConnectionAggregateSum = {
  __typename?: 'FinanceFinancialDocumentsConnectionAggregateSum';
  netAmountCents?: Maybe<Scalars['Int']>;
  taxesTotalAmountCents?: Maybe<Scalars['Int']>;
  totalAmountCents?: Maybe<Scalars['Int']>;
};

/** terms function */
export type FinanceFinancialDocumentsConnectionAggregateTerms = {
  __typename?: 'FinanceFinancialDocumentsConnectionAggregateTerms';
  createdAt?: Maybe<FinanceFinancialDocumentsAggregateTerms>;
  currency?: Maybe<FinanceFinancialDocumentsAggregateTerms>;
  documentDate?: Maybe<FinanceFinancialDocumentsAggregateTerms>;
  documentNumber?: Maybe<FinanceFinancialDocumentsAggregateTerms>;
  documentType?: Maybe<FinanceFinancialDocumentsAggregateTerms>;
  dueDate?: Maybe<FinanceFinancialDocumentsAggregateTerms>;
  legalEntityId?: Maybe<FinanceFinancialDocumentsAggregateTerms>;
  netAmountCents?: Maybe<FinanceFinancialDocumentsAggregateTerms>;
  operationType?: Maybe<FinanceFinancialDocumentsAggregateTerms>;
  status?: Maybe<FinanceFinancialDocumentsAggregateTerms>;
  taxesTotalAmountCents?: Maybe<FinanceFinancialDocumentsAggregateTerms>;
  totalAmountCents?: Maybe<FinanceFinancialDocumentsAggregateTerms>;
};


/** terms function */
export type FinanceFinancialDocumentsConnectionAggregateTermsCreatedAtArgs = {
  period?: InputMaybe<GroupByDateFieldsPeriods>;
};

/** average function */
export type FinanceFinancialDocumentsConnectionAggregateTermsAverageFields = {
  __typename?: 'FinanceFinancialDocumentsConnectionAggregateTermsAVERAGEFields';
  netAmountCents?: Maybe<Array<Scalars['Float']>>;
  taxesTotalAmountCents?: Maybe<Array<Scalars['Float']>>;
  totalAmountCents?: Maybe<Array<Scalars['Float']>>;
};

/** maximum function */
export type FinanceFinancialDocumentsConnectionAggregateTermsMaximumFields = {
  __typename?: 'FinanceFinancialDocumentsConnectionAggregateTermsMAXIMUMFields';
  netAmountCents?: Maybe<Array<Scalars['Int']>>;
  taxesTotalAmountCents?: Maybe<Array<Scalars['Int']>>;
  totalAmountCents?: Maybe<Array<Scalars['Int']>>;
};

/** minimum function */
export type FinanceFinancialDocumentsConnectionAggregateTermsMinimumFields = {
  __typename?: 'FinanceFinancialDocumentsConnectionAggregateTermsMINIMUMFields';
  netAmountCents?: Maybe<Array<Scalars['Int']>>;
  taxesTotalAmountCents?: Maybe<Array<Scalars['Int']>>;
  totalAmountCents?: Maybe<Array<Scalars['Int']>>;
};

/** sum function */
export type FinanceFinancialDocumentsConnectionAggregateTermsSumFields = {
  __typename?: 'FinanceFinancialDocumentsConnectionAggregateTermsSUMFields';
  netAmountCents?: Maybe<Array<Scalars['Int']>>;
  taxesTotalAmountCents?: Maybe<Array<Scalars['Int']>>;
  totalAmountCents?: Maybe<Array<Scalars['Int']>>;
};

/** Finance inbox for Factorial companies */
export type FinanceInbox = {
  __typename?: 'FinanceInbox';
  company: ApiCoreCompany;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  companyId: Scalars['Int'];
  email: Scalars['String'];
  id: Scalars['Int'];
  messages: Array<FinanceMessage>;
  messagesConnection: FinanceMessageConnection;
  unreadCount: Scalars['Int'];
};


/** Finance inbox for Factorial companies */
export type FinanceInboxMessagesArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
};


/** Finance inbox for Factorial companies */
export type FinanceInboxMessagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for FinanceInbox. */
export type FinanceInboxConnection = {
  __typename?: 'FinanceInboxConnection';
  /** A list of edges. */
  edges: Array<FinanceInboxEdge>;
  /** A list of nodes. */
  nodes: Array<FinanceInbox>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FinanceInboxEdge = {
  __typename?: 'FinanceInboxEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FinanceInbox;
};

export type FinanceInvoiceFile = {
  __typename?: 'FinanceInvoiceFile';
  contentType: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  filename: Scalars['String'];
  id: Scalars['Int'];
  size: Scalars['Int'];
  url: Scalars['String'];
};

/** Invoice parser service with OCR */
export type FinanceInvoiceParser = {
  __typename?: 'FinanceInvoiceParser';
  classificationReason?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  documentType?: Maybe<FinanceValueObjectsFinancialDocumentTypeEnum>;
  dueDate?: Maybe<Scalars['ISO8601Date']>;
  file?: Maybe<FinanceInvoiceFile>;
  invoiceDate?: Maybe<Scalars['ISO8601Date']>;
  invoiceNumber?: Maybe<Scalars['String']>;
  legalEntity?: Maybe<CompaniesLegalEntity>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  legalEntityId?: Maybe<Scalars['Int']>;
  netAmountCents?: Maybe<Scalars['Int']>;
  scannedDocumentId?: Maybe<Scalars['Int']>;
  status: FinanceValueObjectsInvoiceStatusEnum;
  taxes: Array<FinanceInvoiceTax>;
  totalAmountCents?: Maybe<Scalars['Int']>;
  vendorAddressLine1?: Maybe<Scalars['String']>;
  vendorAddressLine2?: Maybe<Scalars['String']>;
  vendorCity?: Maybe<Scalars['String']>;
  vendorCountryCode?: Maybe<Scalars['String']>;
  vendorId?: Maybe<Scalars['Int']>;
  vendorName?: Maybe<Scalars['String']>;
  vendorPostalCode?: Maybe<Scalars['String']>;
  vendorState?: Maybe<Scalars['String']>;
  vendorTaxId?: Maybe<Scalars['String']>;
};


/** Invoice parser service with OCR */
export type FinanceInvoiceParserLegalEntityArgs = {
  companiesIds?: InputMaybe<Array<Scalars['Int']>>;
  countryIds?: InputMaybe<Array<Scalars['String']>>;
  employeesIds?: InputMaybe<Array<Scalars['Int']>>;
  excludeCountries?: InputMaybe<Array<Scalars['String']>>;
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};

export type FinanceInvoiceResourceInput = {
  id: Scalars['Int'];
  type: FinanceEntitiesResourceTypeEnum;
};

export type FinanceInvoiceTax = {
  __typename?: 'FinanceInvoiceTax';
  amountCents?: Maybe<Scalars['BigInt']>;
  baseAmountCents?: Maybe<Scalars['BigInt']>;
  percentage?: Maybe<Scalars['Float']>;
  taxRates?: Maybe<Array<FinanceTaxRateObject>>;
  taxTypeId?: Maybe<Scalars['Int']>;
  taxTypeName?: Maybe<Scalars['String']>;
  type?: Maybe<FinanceValueObjectsTaxTypeEnum>;
};

export type FinanceInvoiceTaxInput = {
  amountCents?: InputMaybe<Scalars['BigInt']>;
  baseAmountCents?: InputMaybe<Scalars['BigInt']>;
  percentage?: InputMaybe<Scalars['Float']>;
  taxRates?: InputMaybe<Array<FinanceTaxRateObjectInput>>;
  taxTypeId?: InputMaybe<Scalars['Int']>;
  taxTypeName?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<FinanceValueObjectsTaxTypeEnum>;
};

/** journal_draft_entry */
export type FinanceJournalDraftEntry = {
  __typename?: 'FinanceJournalDraftEntry';
  companyId: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  financialDocument?: Maybe<FinanceFinancialDocument>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  financialDocumentId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  invoiceId?: Maybe<Scalars['Int']>;
  journalDraftLines: Array<FinanceJournalDraftLine>;
  journalDraftLinesConnection: FinanceJournalDraftLineConnection;
  legalEntity: CompaniesLegalEntity;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  legalEntityId: Scalars['Int'];
  referenceDate?: Maybe<Scalars['ISO8601Date']>;
  sourceId: Scalars['Int'];
  sourceType: FinanceValueObjectsJournalEntrySourceTypeEnum;
  status: FinanceValueObjectsJournalDraftEntryStatusEnum;
  type: FinanceValueObjectsJournalEntryTypeEnum;
};


/** journal_draft_entry */
export type FinanceJournalDraftEntryFinancialDocumentArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  currency?: InputMaybe<Scalars['String']>;
  dealId?: InputMaybe<Scalars['Int']>;
  documentTypes?: InputMaybe<Array<FinanceValueObjectsFinancialDocumentTypeEnum>>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  issuerName?: InputMaybe<Scalars['String']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  operationTypes?: InputMaybe<Array<FinanceValueObjectsFinancialDocumentOperationTypeEnum>>;
  parentFinancialDocumentIds?: InputMaybe<Array<Scalars['Int']>>;
  projectId?: InputMaybe<Scalars['Int']>;
  reconcilable?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<FinanceValueObjectsInvoiceStatusEnum>>;
  toDate?: InputMaybe<Scalars['ISO8601Date']>;
  toDueDate?: InputMaybe<Scalars['ISO8601Date']>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
  vendorId?: InputMaybe<Scalars['Int']>;
};


/** journal_draft_entry */
export type FinanceJournalDraftEntryJournalDraftLinesArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** journal_draft_entry */
export type FinanceJournalDraftEntryJournalDraftLinesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** journal_draft_entry */
export type FinanceJournalDraftEntryLegalEntityArgs = {
  companiesIds?: InputMaybe<Array<Scalars['Int']>>;
  countryIds?: InputMaybe<Array<Scalars['String']>>;
  employeesIds?: InputMaybe<Array<Scalars['Int']>>;
  excludeCountries?: InputMaybe<Array<Scalars['String']>>;
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};

/** The connection type for FinanceJournalDraftEntry. */
export type FinanceJournalDraftEntryConnection = {
  __typename?: 'FinanceJournalDraftEntryConnection';
  /** A list of edges. */
  edges: Array<FinanceJournalDraftEntryEdge>;
  /** A list of nodes. */
  nodes: Array<FinanceJournalDraftEntry>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FinanceJournalDraftEntryEdge = {
  __typename?: 'FinanceJournalDraftEntryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FinanceJournalDraftEntry;
};

/** the filter for the journal_draft_entries resource */
export type FinanceJournalDraftEntryFilter = {
  legalEntityId?: InputMaybe<IntegerFilter>;
  or?: InputMaybe<Array<FinanceJournalDraftEntryFilterConditions>>;
  referenceDate?: InputMaybe<DateFilter>;
  status?: InputMaybe<StringFilter>;
  type?: InputMaybe<StringFilter>;
};

export type FinanceJournalDraftEntryFilterConditions = {
  legalEntityId?: InputMaybe<IntegerFilter>;
  referenceDate?: InputMaybe<DateFilter>;
  status?: InputMaybe<StringFilter>;
  type?: InputMaybe<StringFilter>;
};

/** journal_draft_line */
export type FinanceJournalDraftLine = {
  __typename?: 'FinanceJournalDraftLine';
  account?: Maybe<FinanceAccount>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  accountId?: Maybe<Scalars['Int']>;
  companyId: Scalars['Int'];
  creditAmountCents?: Maybe<Scalars['Int']>;
  debitAmountCents?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  journalDraftEntry: FinanceJournalDraftEntry;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  journalDraftEntryId: Scalars['Int'];
};


/** journal_draft_line */
export type FinanceJournalDraftLineAccountArgs = {
  includeDisabled?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  number?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Array<Scalars['String']>>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


/** journal_draft_line */
export type FinanceJournalDraftLineJournalDraftEntryArgs = {
  bankTransactionIds?: InputMaybe<Array<Scalars['Int']>>;
  companyId?: InputMaybe<Scalars['Int']>;
  financialDocumentIds?: InputMaybe<Array<Scalars['Int']>>;
  invoiceIds?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  statuses?: InputMaybe<Array<FinanceValueObjectsJournalDraftEntryStatusEnum>>;
};

/** The connection type for FinanceJournalDraftLine. */
export type FinanceJournalDraftLineConnection = {
  __typename?: 'FinanceJournalDraftLineConnection';
  /** A list of edges. */
  edges: Array<FinanceJournalDraftLineEdge>;
  /** A list of nodes. */
  nodes: Array<FinanceJournalDraftLine>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FinanceJournalDraftLineEdge = {
  __typename?: 'FinanceJournalDraftLineEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FinanceJournalDraftLine;
};

/** A journal entry, which groups journal lines together in the accounting system */
export type FinanceJournalEntry = {
  __typename?: 'FinanceJournalEntry';
  bankTransaction?: Maybe<BankingTransaction>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  bankTransactionId?: Maybe<Scalars['Int']>;
  /** Description of the journal entry */
  description?: Maybe<Scalars['String']>;
  /** External identifier for the journal entry */
  externalId?: Maybe<Scalars['String']>;
  financialDocument?: Maybe<FinanceFinancialDocument>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  financialDocumentId?: Maybe<Scalars['Int']>;
  /** Journal entry ID */
  id: Scalars['Int'];
  invoiceId?: Maybe<Scalars['Int']>;
  journalLines: Array<FinanceJournalLine>;
  journalLinesConnection: FinanceJournalLineConnection;
  ledgerAccount?: Maybe<FinanceAccount>;
  legalEntity: CompaniesLegalEntity;
  /**
   * The associated Legal Entity ID
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  legalEntityId: Scalars['Int'];
  /** Incremental number assigned to the journal entry */
  number: Scalars['Int'];
  /** Timestamp when the journal entry was published. */
  publishedAt: Scalars['ISO8601DateTime'];
  /** Date of the associate source */
  referenceDate: Scalars['ISO8601Date'];
  /** Source id related with this journal entry */
  sourceId?: Maybe<Scalars['Int']>;
  /** Source type related with this journal entry */
  sourceType?: Maybe<FinanceValueObjectsJournalEntryApiSourceTypeEnum>;
  /** The status of the journal entry (draft, published, etc.) */
  status: FinanceValueObjectsJournalEntryStatusEnum;
  /** Journal entry type (e.g. bank, invoice, tax) */
  type: FinanceValueObjectsJournalEntryTypeEnum;
  /** Timestamp when the journal entry was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};


/** A journal entry, which groups journal lines together in the accounting system */
export type FinanceJournalEntryBankTransactionArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']>>;
  accounted?: InputMaybe<Scalars['Boolean']>;
  cardPaymentIds?: InputMaybe<Array<Scalars['Int']>>;
  currency?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['ISO8601DateTime']>;
  incomeTransactions?: InputMaybe<Scalars['Boolean']>;
  outcomeTransactions?: InputMaybe<Scalars['Boolean']>;
  reconciled?: InputMaybe<Scalars['Boolean']>;
  reconciliationStatus?: InputMaybe<BankingValueObjectsReconciliationStatusEnum>;
  status?: InputMaybe<BankingEntitiesTransactionStatusEnum>;
  to?: InputMaybe<Scalars['ISO8601DateTime']>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


/** A journal entry, which groups journal lines together in the accounting system */
export type FinanceJournalEntryFinancialDocumentArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  currency?: InputMaybe<Scalars['String']>;
  dealId?: InputMaybe<Scalars['Int']>;
  documentTypes?: InputMaybe<Array<FinanceValueObjectsFinancialDocumentTypeEnum>>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  issuerName?: InputMaybe<Scalars['String']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  operationTypes?: InputMaybe<Array<FinanceValueObjectsFinancialDocumentOperationTypeEnum>>;
  parentFinancialDocumentIds?: InputMaybe<Array<Scalars['Int']>>;
  projectId?: InputMaybe<Scalars['Int']>;
  reconcilable?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<FinanceValueObjectsInvoiceStatusEnum>>;
  toDate?: InputMaybe<Scalars['ISO8601Date']>;
  toDueDate?: InputMaybe<Scalars['ISO8601Date']>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
  vendorId?: InputMaybe<Scalars['Int']>;
};


/** A journal entry, which groups journal lines together in the accounting system */
export type FinanceJournalEntryJournalLinesArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']>>;
  balanceTypes?: InputMaybe<Array<FinanceValueObjectsLedgerAccountBalanceTypeEnum>>;
  bankAccountIds?: InputMaybe<Array<Scalars['Int']>>;
  bySuspenseAccount?: InputMaybe<Scalars['Boolean']>;
  currency?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  excludingJournalEntryTypes?: InputMaybe<Array<FinanceValueObjectsJournalEntryTypeEnum>>;
  financialDocumentIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  journalEntryTypes?: InputMaybe<Array<FinanceValueObjectsJournalEntryTypeEnum>>;
  reconcilable?: InputMaybe<Scalars['Boolean']>;
  reconciliationStatus?: InputMaybe<FinanceValueObjectsReconciliationStatusEnum>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


/** A journal entry, which groups journal lines together in the accounting system */
export type FinanceJournalEntryJournalLinesConnectionArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']>>;
  after?: InputMaybe<Scalars['String']>;
  balanceTypes?: InputMaybe<Array<FinanceValueObjectsLedgerAccountBalanceTypeEnum>>;
  bankAccountIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  bySuspenseAccount?: InputMaybe<Scalars['Boolean']>;
  currency?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  excludingJournalEntryTypes?: InputMaybe<Array<FinanceValueObjectsJournalEntryTypeEnum>>;
  financialDocumentIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  journalEntryTypes?: InputMaybe<Array<FinanceValueObjectsJournalEntryTypeEnum>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  reconcilable?: InputMaybe<Scalars['Boolean']>;
  reconciliationStatus?: InputMaybe<FinanceValueObjectsReconciliationStatusEnum>;
  sortOrder?: InputMaybe<Sort>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


/** A journal entry, which groups journal lines together in the accounting system */
export type FinanceJournalEntryLedgerAccountArgs = {
  includeDisabled?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  number?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Array<Scalars['String']>>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


/** A journal entry, which groups journal lines together in the accounting system */
export type FinanceJournalEntryLegalEntityArgs = {
  companiesIds?: InputMaybe<Array<Scalars['Int']>>;
  countryIds?: InputMaybe<Array<Scalars['String']>>;
  employeesIds?: InputMaybe<Array<Scalars['Int']>>;
  excludeCountries?: InputMaybe<Array<Scalars['String']>>;
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};

/** The connection type for FinanceJournalEntry. */
export type FinanceJournalEntryConnection = {
  __typename?: 'FinanceJournalEntryConnection';
  /** A list of edges. */
  edges: Array<FinanceJournalEntryEdge>;
  /** A list of nodes. */
  nodes: Array<FinanceJournalEntry>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FinanceJournalEntryEdge = {
  __typename?: 'FinanceJournalEntryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FinanceJournalEntry;
};

/** the filter for the journal_entries resource */
export type FinanceJournalEntryFilter = {
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntegerFilter>;
  legalEntityId?: InputMaybe<IntegerFilter>;
  number?: InputMaybe<IntegerFilter>;
  or?: InputMaybe<Array<FinanceJournalEntryFilterConditions>>;
  publishedAt?: InputMaybe<DateTimeFilter>;
  referenceDate?: InputMaybe<DateFilter>;
  status?: InputMaybe<StringFilter>;
  type?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type FinanceJournalEntryFilterConditions = {
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntegerFilter>;
  legalEntityId?: InputMaybe<IntegerFilter>;
  number?: InputMaybe<IntegerFilter>;
  publishedAt?: InputMaybe<DateTimeFilter>;
  referenceDate?: InputMaybe<DateFilter>;
  status?: InputMaybe<StringFilter>;
  type?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

/** A journal line, the base of the double entry accounting system */
export type FinanceJournalLine = {
  __typename?: 'FinanceJournalLine';
  account: FinanceAccount;
  /** The account balance in cents */
  accountBalanceCents: Scalars['Int'];
  /**
   * ID of the associated account
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  accountId: Scalars['Int'];
  /** The credit amount in cents */
  creditAmountCents: Scalars['Int'];
  /** The debit amount in cents */
  debitAmountCents: Scalars['Int'];
  /** External identifier for the journal line */
  externalId?: Maybe<Scalars['String']>;
  /** Timestamp when the journal line was reconciled */
  fullyReconciledAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Factorial id */
  id: Scalars['Int'];
  journalEntry: FinanceJournalEntry;
  /**
   * ID of the parent journal entry
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  journalEntryId: Scalars['Int'];
  /** Sequential number assigned to the line */
  number: Scalars['Int'];
  publishedAt: Scalars['ISO8601DateTime'];
  reconcilableReconciliationSuggestions: Array<FinanceReconciliationSuggestion>;
  reconcilableReconciliationSuggestionsConnection: FinanceReconciliationSuggestionConnection;
  reconcilableReconciliations: Array<FinanceReconciliation>;
  reconcilableReconciliationsConnection: FinanceReconciliationConnection;
  reconciliationSuggestions: Array<FinanceReconciliationSuggestion>;
  reconciliationSuggestionsConnection: FinanceReconciliationSuggestionConnection;
  reconciliations: Array<FinanceReconciliation>;
  reconciliationsConnection: FinanceReconciliationConnection;
  snoozedUntil?: Maybe<Scalars['ISO8601DateTime']>;
  /** Timestamp when the journal line was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};


/** A journal line, the base of the double entry accounting system */
export type FinanceJournalLineAccountArgs = {
  includeDisabled?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  number?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Array<Scalars['String']>>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


/** A journal line, the base of the double entry accounting system */
export type FinanceJournalLineJournalEntryArgs = {
  bankTransactionIds?: InputMaybe<Array<Scalars['Int']>>;
  financialDocumentIds?: InputMaybe<Array<Scalars['Int']>>;
  invoiceIds?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  publishedFrom?: InputMaybe<Scalars['ISO8601Date']>;
  sourceIds?: InputMaybe<Array<Scalars['Int']>>;
  sourceType?: InputMaybe<FinanceValueObjectsJournalEntryApiSourceTypeEnum>;
  status?: InputMaybe<FinanceValueObjectsJournalEntryStatusEnum>;
  types?: InputMaybe<Array<FinanceValueObjectsJournalEntryTypeEnum>>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


/** A journal line, the base of the double entry accounting system */
export type FinanceJournalLineReconcilableReconciliationSuggestionsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  journalLineIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** A journal line, the base of the double entry accounting system */
export type FinanceJournalLineReconcilableReconciliationSuggestionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  journalLineIds?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** A journal line, the base of the double entry accounting system */
export type FinanceJournalLineReconcilableReconciliationsArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
  journalLineIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** A journal line, the base of the double entry accounting system */
export type FinanceJournalLineReconcilableReconciliationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  journalLineIds?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** A journal line, the base of the double entry accounting system */
export type FinanceJournalLineReconciliationSuggestionsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  reconcilableJournalLineIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** A journal line, the base of the double entry accounting system */
export type FinanceJournalLineReconciliationSuggestionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  reconcilableJournalLineIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
};


/** A journal line, the base of the double entry accounting system */
export type FinanceJournalLineReconciliationsArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
  reconcilableIds?: InputMaybe<Array<Scalars['Int']>>;
  reconcilableType?: InputMaybe<Scalars['String']>;
};


/** A journal line, the base of the double entry accounting system */
export type FinanceJournalLineReconciliationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  reconcilableIds?: InputMaybe<Array<Scalars['Int']>>;
  reconcilableType?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for FinanceJournalLine. */
export type FinanceJournalLineConnection = {
  __typename?: 'FinanceJournalLineConnection';
  /** A list of edges. */
  edges: Array<FinanceJournalLineEdge>;
  /** A list of nodes. */
  nodes: Array<FinanceJournalLine>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FinanceJournalLineEdge = {
  __typename?: 'FinanceJournalLineEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FinanceJournalLine;
};

/** the filter for the journal_lines resource */
export type FinanceJournalLineFilter = {
  createdAt?: InputMaybe<StringFilter>;
  creditAmountCents?: InputMaybe<IntegerFilter>;
  debitAmountCents?: InputMaybe<IntegerFilter>;
  id?: InputMaybe<IntegerFilter>;
  journalEntryTypes?: InputMaybe<StringFilter>;
  legalEntity?: InputMaybe<IntegerFilter>;
  or?: InputMaybe<Array<FinanceJournalLineFilterConditions>>;
  publishedAt?: InputMaybe<DateTimeFilter>;
  reconciledStatus?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type FinanceJournalLineFilterConditions = {
  createdAt?: InputMaybe<StringFilter>;
  creditAmountCents?: InputMaybe<IntegerFilter>;
  debitAmountCents?: InputMaybe<IntegerFilter>;
  id?: InputMaybe<IntegerFilter>;
  journalEntryTypes?: InputMaybe<StringFilter>;
  legalEntity?: InputMaybe<IntegerFilter>;
  publishedAt?: InputMaybe<DateTimeFilter>;
  reconciledStatus?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

/**
 * Ledger account resource refers to a structured entity that represents an account
 * within a general ledger system. It serves as a digital record for tracking
 * financial transactions related to a specific category. (e.g. bank account,
 * vendor, tax type, expense, etc.)
 */
export type FinanceLedgerAccountResource = {
  __typename?: 'FinanceLedgerAccountResource';
  account: FinanceAccount;
  /**
   * Factorial Ledger Account identifier.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  accountId: Scalars['Int'];
  /** Ledger account balance type. */
  balanceType?: Maybe<FinanceValueObjectsLedgerAccountBalanceTypeEnum>;
  bankAccount?: Maybe<BankingBankAccount>;
  customCategory?: Maybe<FinanceCustomCategory>;
  /** External identifier. */
  externalId?: Maybe<Scalars['String']>;
  /** Factorial unique identifier. */
  id: Scalars['Int'];
  /** Factorial unique identifier of the Legal entity. */
  legalEntityId?: Maybe<Scalars['Int']>;
  operationType?: Maybe<FinanceValueObjectsLedgerAccountOperationTypeEnum>;
  payrollConcept?: Maybe<PayrollConcept>;
  /**
   * Factorial unique identifier of the resource associated to the ledger account resource.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  resourceId: Scalars['Int'];
  /** Ledger account resource type. */
  resourceType: FinanceValueObjectsLedgerAccountResourceTypeEnum;
  /** Last time the resource was updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  vendor?: Maybe<FinanceContact>;
};


/**
 * Ledger account resource refers to a structured entity that represents an account
 * within a general ledger system. It serves as a digital record for tracking
 * financial transactions related to a specific category. (e.g. bank account,
 * vendor, tax type, expense, etc.)
 */
export type FinanceLedgerAccountResourceAccountArgs = {
  includeDisabled?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  number?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Array<Scalars['String']>>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


/**
 * Ledger account resource refers to a structured entity that represents an account
 * within a general ledger system. It serves as a digital record for tracking
 * financial transactions related to a specific category. (e.g. bank account,
 * vendor, tax type, expense, etc.)
 */
export type FinanceLedgerAccountResourceBankAccountArgs = {
  accountNumberTypes?: InputMaybe<Array<BankingEntitiesBankAccountNumberFormatEnum>>;
  bankingAccountIds?: InputMaybe<Array<Scalars['Int']>>;
  currency?: InputMaybe<Scalars['String']>;
  externalIds?: InputMaybe<Array<Scalars['String']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  providers?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  service?: InputMaybe<BankingProvidersServicesEnumEnum>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


/**
 * Ledger account resource refers to a structured entity that represents an account
 * within a general ledger system. It serves as a digital record for tracking
 * financial transactions related to a specific category. (e.g. bank account,
 * vendor, tax type, expense, etc.)
 */
export type FinanceLedgerAccountResourceCustomCategoryArgs = {
  categoryLevel: FinanceValueObjectsCategoryLevelEnum;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  factorialCategoryIdentifier?: InputMaybe<Scalars['String']>;
  parentCategoryIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  statuses: Array<FinanceValueObjectsCategoryStatusEnum>;
  type: FinanceValueObjectsCategoryTypeEnum;
};


/**
 * Ledger account resource refers to a structured entity that represents an account
 * within a general ledger system. It serves as a digital record for tracking
 * financial transactions related to a specific category. (e.g. bank account,
 * vendor, tax type, expense, etc.)
 */
export type FinanceLedgerAccountResourcePayrollConceptArgs = {
  categories?: InputMaybe<Array<PayrollValueObjectsConceptCategoryEnum>>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  default?: InputMaybe<Scalars['Boolean']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  names?: InputMaybe<Array<Scalars['String']>>;
  policyPeriodId?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  unitTypes?: InputMaybe<Array<PayrollValueObjectsConceptUnitTypeEnum>>;
  withActiveStatus?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Ledger account resource refers to a structured entity that represents an account
 * within a general ledger system. It serves as a digital record for tracking
 * financial transactions related to a specific category. (e.g. bank account,
 * vendor, tax type, expense, etc.)
 */
export type FinanceLedgerAccountResourceVendorArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  contactType?: InputMaybe<FinanceValueObjectsContactTypeEnum>;
  email?: InputMaybe<Scalars['String']>;
  legalName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  taxIdType?: InputMaybe<Scalars['String']>;
  taxIds?: InputMaybe<Array<Scalars['String']>>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
  website?: InputMaybe<Scalars['String']>;
};

/** The connection type for FinanceLedgerAccountResource. */
export type FinanceLedgerAccountResourceConnection = {
  __typename?: 'FinanceLedgerAccountResourceConnection';
  /** A list of edges. */
  edges: Array<FinanceLedgerAccountResourceEdge>;
  /** A list of nodes. */
  nodes: Array<FinanceLedgerAccountResource>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FinanceLedgerAccountResourceEdge = {
  __typename?: 'FinanceLedgerAccountResourceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FinanceLedgerAccountResource;
};

/** Finance line item */
export type FinanceLineItem = {
  __typename?: 'FinanceLineItem';
  description: Scalars['String'];
  id: Scalars['Int'];
  parentId?: Maybe<Scalars['Int']>;
  profitCents?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Float']>;
  quantityType: FinanceValueObjectsLineItemQuantityTypeEnum;
  sourceId: Scalars['Int'];
  sourceType: FinanceValueObjectsLineItemSourceTypeEnum;
  taxRateId?: Maybe<Scalars['Int']>;
  taxRatePercentage?: Maybe<Scalars['Float']>;
  taxTypeCountry?: Maybe<Scalars['String']>;
  taxTypeId?: Maybe<Scalars['Int']>;
  taxTypeName?: Maybe<Scalars['String']>;
  taxTypeType?: Maybe<Scalars['String']>;
  totalCostCents?: Maybe<Scalars['Int']>;
  totalPriceCents: Scalars['Int'];
  type: FinanceValueObjectsLineItemTypeEnum;
  unitCostCents?: Maybe<Scalars['Int']>;
  unitPriceCents?: Maybe<Scalars['Int']>;
};

/** The connection type for FinanceLineItem. */
export type FinanceLineItemConnection = {
  __typename?: 'FinanceLineItemConnection';
  /** A list of edges. */
  edges: Array<FinanceLineItemEdge>;
  /** A list of nodes. */
  nodes: Array<FinanceLineItem>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FinanceLineItemEdge = {
  __typename?: 'FinanceLineItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FinanceLineItem;
};

/** Finance message for inboxes */
export type FinanceMessage = {
  __typename?: 'FinanceMessage';
  content: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  fileNames?: Maybe<Array<Scalars['String']>>;
  from: Scalars['String'];
  id: Scalars['Int'];
  inbox: FinanceInbox;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  inboxId: Scalars['Int'];
  isRead: Scalars['Boolean'];
  subject?: Maybe<Scalars['String']>;
};


/** Finance message for inboxes */
export type FinanceMessageInboxArgs = {
  companyId?: InputMaybe<Scalars['String']>;
};

/** The connection type for FinanceMessage. */
export type FinanceMessageConnection = {
  __typename?: 'FinanceMessageConnection';
  /** A list of edges. */
  edges: Array<FinanceMessageEdge>;
  /** A list of nodes. */
  nodes: Array<FinanceMessage>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FinanceMessageEdge = {
  __typename?: 'FinanceMessageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FinanceMessage;
};

/** the filter for the messages resource */
export type FinanceMessageFilter = {
  createdAt?: InputMaybe<DateTimeFilter>;
  or?: InputMaybe<Array<FinanceMessageFilterConditions>>;
};

export type FinanceMessageFilterConditions = {
  createdAt?: InputMaybe<DateTimeFilter>;
};

/** Money conversion */
export type FinanceMoney = {
  __typename?: 'FinanceMoney';
  cents: Scalars['BigInt'];
  currency: Scalars['String'];
  money: Money;
};

/** pending actions summary */
export type FinancePendingActionsSummary = {
  __typename?: 'FinancePendingActionsSummary';
  count: Scalars['Int'];
  icon: Scalars['String'];
  id: Scalars['String'];
  priority: Scalars['Int'];
  resourceUrl?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  type: FinanceValueObjectsPendingActionTypeEnum;
};

/** The connection type for FinancePendingActionsSummary. */
export type FinancePendingActionsSummaryConnection = {
  __typename?: 'FinancePendingActionsSummaryConnection';
  /** A list of edges. */
  edges: Array<FinancePendingActionsSummaryEdge>;
  /** A list of nodes. */
  nodes: Array<FinancePendingActionsSummary>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FinancePendingActionsSummaryEdge = {
  __typename?: 'FinancePendingActionsSummaryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FinancePendingActionsSummary;
};

/** Finance quote */
export type FinanceQuote = {
  __typename?: 'FinanceQuote';
  _policies?: Maybe<FinanceQuotePolicies>;
  _policiesCollection?: Maybe<Array<PermissionsPolicyResolution>>;
  _policiesConnection: PermissionsPolicyResolutionConnection;
  archivedAt?: Maybe<Scalars['ISO8601DateTime']>;
  author?: Maybe<EmployeesEmployeeName>;
  client?: Maybe<FinanceContact>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  clientId?: Maybe<Scalars['Int']>;
  companyId: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  currency?: Maybe<Scalars['String']>;
  deal?: Maybe<FinanceDeal>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  dealId?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  discountPercentage?: Maybe<Scalars['Float']>;
  documentDate?: Maybe<Scalars['ISO8601Date']>;
  expirationDate?: Maybe<Scalars['ISO8601Date']>;
  financeLineItems: Array<FinanceLineItem>;
  financeLineItemsConnection: FinanceLineItemConnection;
  financialDocumentAssociation?: Maybe<FinanceFinancialDocumentAssociation>;
  footer?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  issuerAddressLine1?: Maybe<Scalars['String']>;
  issuerAddressLine2?: Maybe<Scalars['String']>;
  issuerCity?: Maybe<Scalars['String']>;
  issuerCountryCode?: Maybe<Scalars['String']>;
  issuerName?: Maybe<Scalars['String']>;
  issuerPostalCode?: Maybe<Scalars['String']>;
  issuerState?: Maybe<Scalars['String']>;
  issuerTaxId?: Maybe<Scalars['String']>;
  legalEntity?: Maybe<CompaniesLegalEntity>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  legalEntityId?: Maybe<Scalars['Int']>;
  lineItems: Array<FinanceFinancialDocumentLineItem>;
  logoFile?: Maybe<FinanceFile>;
  memo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  netAmountCents?: Maybe<Scalars['BigInt']>;
  owner?: Maybe<EmployeesEmployeeName>;
  ownerIdentifierForBulkPolicy: Scalars['Int'];
  projectId?: Maybe<Scalars['Int']>;
  quoteNumber?: Maybe<Scalars['String']>;
  quoteType: FinanceEnumsQuoteTypeEnum;
  recipientAddressLine1?: Maybe<Scalars['String']>;
  recipientAddressLine2?: Maybe<Scalars['String']>;
  recipientCity?: Maybe<Scalars['String']>;
  recipientCountryCode?: Maybe<Scalars['String']>;
  recipientName?: Maybe<Scalars['String']>;
  recipientPostalCode?: Maybe<Scalars['String']>;
  recipientState?: Maybe<Scalars['String']>;
  recipientTaxId?: Maybe<Scalars['String']>;
  recipientTaxIdType?: Maybe<FinanceValueObjectsContactTaxIdTypeEnum>;
  status: FinanceEnumsQuoteStatusEnum;
  taxes: Array<FinanceInvoiceTax>;
  totalAmountCents?: Maybe<Scalars['BigInt']>;
};


/** Finance quote */
export type FinanceQuote_PoliciesCollectionArgs = {
  ids: Array<FinanceQuotePoliciesEnum>;
};


/** Finance quote */
export type FinanceQuote_PoliciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Finance quote */
export type FinanceQuoteAuthorArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  afterEmployeeId?: InputMaybe<Scalars['Int']>;
  beforeEmployeeId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  reporteesOrLed?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyId?: InputMaybe<Scalars['Int']>;
  verb?: InputMaybe<Scalars['String']>;
  withActiveContract?: Scalars['Boolean'];
};


/** Finance quote */
export type FinanceQuoteClientArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  contactType?: InputMaybe<FinanceValueObjectsContactTypeEnum>;
  email?: InputMaybe<Scalars['String']>;
  legalName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  taxIdType?: InputMaybe<Scalars['String']>;
  taxIds?: InputMaybe<Array<Scalars['String']>>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
  website?: InputMaybe<Scalars['String']>;
};


/** Finance quote */
export type FinanceQuoteDealArgs = {
  clientIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  stages?: InputMaybe<Array<FinanceValueObjectsDealStageEnum>>;
};


/** Finance quote */
export type FinanceQuoteFinanceLineItemsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  types?: InputMaybe<Array<FinanceValueObjectsLineItemTypeEnum>>;
};


/** Finance quote */
export type FinanceQuoteFinanceLineItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  types?: InputMaybe<Array<FinanceValueObjectsLineItemTypeEnum>>;
};


/** Finance quote */
export type FinanceQuoteFinancialDocumentAssociationArgs = {
  financialDocumentIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Finance quote */
export type FinanceQuoteLegalEntityArgs = {
  companiesIds?: InputMaybe<Array<Scalars['Int']>>;
  countryIds?: InputMaybe<Array<Scalars['String']>>;
  employeesIds?: InputMaybe<Array<Scalars['Int']>>;
  excludeCountries?: InputMaybe<Array<Scalars['String']>>;
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


/** Finance quote */
export type FinanceQuoteOwnerArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  afterEmployeeId?: InputMaybe<Scalars['Int']>;
  beforeEmployeeId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  reporteesOrLed?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyId?: InputMaybe<Scalars['Int']>;
  verb?: InputMaybe<Scalars['String']>;
  withActiveContract?: Scalars['Boolean'];
};

/** The connection type for FinanceQuote. */
export type FinanceQuoteConnection = {
  __typename?: 'FinanceQuoteConnection';
  /** A list of edges. */
  edges: Array<FinanceQuoteEdge>;
  /** A list of nodes. */
  nodes: Array<FinanceQuote>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FinanceQuoteEdge = {
  __typename?: 'FinanceQuoteEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FinanceQuote;
};

/** PDF of a quote */
export type FinanceQuotePdf = {
  __typename?: 'FinanceQuotePdf';
  filename: Scalars['String'];
  rawPdfBase64: Scalars['String'];
};

export type FinanceQuotePolicies = {
  __typename?: 'FinanceQuotePolicies';
  access: PermissionsPolicyResolution;
  convertToInvoice: PermissionsPolicyResolution;
  convertToProject: PermissionsPolicyResolution;
  manage: PermissionsPolicyResolution;
  updateDetails: PermissionsPolicyResolution;
};

export type FinanceQuotePoliciesEnum =
  | 'access'
  | 'convertToInvoice'
  | 'convertToProject'
  | 'manage'
  | 'updateDetails';

/** preview for quotes */
export type FinanceQuotePreview = {
  __typename?: 'FinanceQuotePreview';
  htmlContent: Scalars['String'];
};

/** Finance reconciliations */
export type FinanceReconciliation = {
  __typename?: 'FinanceReconciliation';
  id: Scalars['Int'];
  journalLine: FinanceJournalLine;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  journalLineId: Scalars['Int'];
  journalLineReconciledAmountCents: Scalars['Int'];
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  reconcilableId?: Maybe<Scalars['Int']>;
  reconcilableJournalLine?: Maybe<FinanceJournalLine>;
  reconcilableReconciledAmountCents?: Maybe<Scalars['Int']>;
  reconcilableType?: Maybe<FinanceValueObjectsReconcilableTypeEnum>;
  reconciliationType?: Maybe<FinanceValueObjectsReconcilationTypeEnum>;
};


/** Finance reconciliations */
export type FinanceReconciliationJournalLineArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']>>;
  balanceTypes?: InputMaybe<Array<FinanceValueObjectsLedgerAccountBalanceTypeEnum>>;
  bankAccountIds?: InputMaybe<Array<Scalars['Int']>>;
  bySuspenseAccount?: InputMaybe<Scalars['Boolean']>;
  currency?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  excludingJournalEntryTypes?: InputMaybe<Array<FinanceValueObjectsJournalEntryTypeEnum>>;
  financialDocumentIds?: InputMaybe<Array<Scalars['Int']>>;
  journalEntryIds?: InputMaybe<Array<Scalars['Int']>>;
  journalEntryTypes?: InputMaybe<Array<FinanceValueObjectsJournalEntryTypeEnum>>;
  reconcilable?: InputMaybe<Scalars['Boolean']>;
  reconciliationStatus?: InputMaybe<FinanceValueObjectsReconciliationStatusEnum>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Finance reconciliations */
export type FinanceReconciliationReconcilableJournalLineArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']>>;
  balanceTypes?: InputMaybe<Array<FinanceValueObjectsLedgerAccountBalanceTypeEnum>>;
  bankAccountIds?: InputMaybe<Array<Scalars['Int']>>;
  bySuspenseAccount?: InputMaybe<Scalars['Boolean']>;
  currency?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  excludingJournalEntryTypes?: InputMaybe<Array<FinanceValueObjectsJournalEntryTypeEnum>>;
  financialDocumentIds?: InputMaybe<Array<Scalars['Int']>>;
  journalEntryIds?: InputMaybe<Array<Scalars['Int']>>;
  journalEntryTypes?: InputMaybe<Array<FinanceValueObjectsJournalEntryTypeEnum>>;
  reconcilable?: InputMaybe<Scalars['Boolean']>;
  reconciliationStatus?: InputMaybe<FinanceValueObjectsReconciliationStatusEnum>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};

/** The connection type for FinanceReconciliation. */
export type FinanceReconciliationConnection = {
  __typename?: 'FinanceReconciliationConnection';
  /** A list of edges. */
  edges: Array<FinanceReconciliationEdge>;
  /** A list of nodes. */
  nodes: Array<FinanceReconciliation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FinanceReconciliationEdge = {
  __typename?: 'FinanceReconciliationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FinanceReconciliation;
};

/** A suggestion to match a banking transaction journal lines with a reconcilable journal line */
export type FinanceReconciliationSuggestion = {
  __typename?: 'FinanceReconciliationSuggestion';
  confidencePercentage: Scalars['Int'];
  id: Scalars['Int'];
  journalLine: FinanceJournalLine;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  journalLineId: Scalars['Int'];
  reconcilableJournalLine?: Maybe<FinanceJournalLine>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  reconcilableJournalLineId: Scalars['Int'];
};


/** A suggestion to match a banking transaction journal lines with a reconcilable journal line */
export type FinanceReconciliationSuggestionJournalLineArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']>>;
  balanceTypes?: InputMaybe<Array<FinanceValueObjectsLedgerAccountBalanceTypeEnum>>;
  bankAccountIds?: InputMaybe<Array<Scalars['Int']>>;
  bySuspenseAccount?: InputMaybe<Scalars['Boolean']>;
  currency?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  excludingJournalEntryTypes?: InputMaybe<Array<FinanceValueObjectsJournalEntryTypeEnum>>;
  financialDocumentIds?: InputMaybe<Array<Scalars['Int']>>;
  journalEntryIds?: InputMaybe<Array<Scalars['Int']>>;
  journalEntryTypes?: InputMaybe<Array<FinanceValueObjectsJournalEntryTypeEnum>>;
  reconcilable?: InputMaybe<Scalars['Boolean']>;
  reconciliationStatus?: InputMaybe<FinanceValueObjectsReconciliationStatusEnum>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


/** A suggestion to match a banking transaction journal lines with a reconcilable journal line */
export type FinanceReconciliationSuggestionReconcilableJournalLineArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']>>;
  balanceTypes?: InputMaybe<Array<FinanceValueObjectsLedgerAccountBalanceTypeEnum>>;
  bankAccountIds?: InputMaybe<Array<Scalars['Int']>>;
  bySuspenseAccount?: InputMaybe<Scalars['Boolean']>;
  currency?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  excludingJournalEntryTypes?: InputMaybe<Array<FinanceValueObjectsJournalEntryTypeEnum>>;
  financialDocumentIds?: InputMaybe<Array<Scalars['Int']>>;
  journalEntryIds?: InputMaybe<Array<Scalars['Int']>>;
  journalEntryTypes?: InputMaybe<Array<FinanceValueObjectsJournalEntryTypeEnum>>;
  reconcilable?: InputMaybe<Scalars['Boolean']>;
  reconciliationStatus?: InputMaybe<FinanceValueObjectsReconciliationStatusEnum>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};

/** The connection type for FinanceReconciliationSuggestion. */
export type FinanceReconciliationSuggestionConnection = {
  __typename?: 'FinanceReconciliationSuggestionConnection';
  /** A list of edges. */
  edges: Array<FinanceReconciliationSuggestionEdge>;
  /** A list of nodes. */
  nodes: Array<FinanceReconciliationSuggestion>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FinanceReconciliationSuggestionEdge = {
  __typename?: 'FinanceReconciliationSuggestionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FinanceReconciliationSuggestion;
};

/** Sales document template */
export type FinanceSalesDocumentTemplate = {
  __typename?: 'FinanceSalesDocumentTemplate';
  default: Scalars['Boolean'];
  footer?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  legalEntity: CompaniesLegalEntity;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  legalEntityId: Scalars['Int'];
  logoFile?: Maybe<FinanceFile>;
  name: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};


/** Sales document template */
export type FinanceSalesDocumentTemplateLegalEntityArgs = {
  companiesIds?: InputMaybe<Array<Scalars['Int']>>;
  countryIds?: InputMaybe<Array<Scalars['String']>>;
  employeesIds?: InputMaybe<Array<Scalars['Int']>>;
  excludeCountries?: InputMaybe<Array<Scalars['String']>>;
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};

/** The connection type for FinanceSalesDocumentTemplate. */
export type FinanceSalesDocumentTemplateConnection = {
  __typename?: 'FinanceSalesDocumentTemplateConnection';
  /** A list of edges. */
  edges: Array<FinanceSalesDocumentTemplateEdge>;
  /** A list of nodes. */
  nodes: Array<FinanceSalesDocumentTemplate>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FinanceSalesDocumentTemplateEdge = {
  __typename?: 'FinanceSalesDocumentTemplateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FinanceSalesDocumentTemplate;
};

/** Sales invoices serial sequence */
export type FinanceSalesInvoiceSequence = {
  __typename?: 'FinanceSalesInvoiceSequence';
  archivedAt?: Maybe<Scalars['ISO8601DateTime']>;
  createdAt: Scalars['ISO8601DateTime'];
  humanReadablePreview: Scalars['String'];
  id: Scalars['Int'];
  lastGeneratedSerial?: Maybe<Scalars['String']>;
  legalEntityId: Scalars['Int'];
  lockedSerial?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  pattern: Scalars['String'];
  startFrom: Scalars['Int'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for FinanceSalesInvoiceSequence. */
export type FinanceSalesInvoiceSequenceConnection = {
  __typename?: 'FinanceSalesInvoiceSequenceConnection';
  /** A list of edges. */
  edges: Array<FinanceSalesInvoiceSequenceEdge>;
  /** A list of nodes. */
  nodes: Array<FinanceSalesInvoiceSequence>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FinanceSalesInvoiceSequenceEdge = {
  __typename?: 'FinanceSalesInvoiceSequenceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FinanceSalesInvoiceSequence;
};

/** the filter for the sales_invoice_sequences resource */
export type FinanceSalesInvoiceSequenceFilter = {
  or?: InputMaybe<Array<FinanceSalesInvoiceSequenceFilterConditions>>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type FinanceSalesInvoiceSequenceFilterConditions = {
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type FinanceServicesCustomCategoriesConfigExpenseCategoriesEnum =
  | 'accommodation'
  | 'airlines'
  | 'car_rental_agencies'
  | 'fuel'
  | 'internet'
  | 'laundry'
  | 'office_supplies'
  | 'other'
  | 'parking'
  | 'passport_visa_fees'
  | 'phone'
  | 'private_transport'
  | 'public_transport'
  | 'rail_travel'
  | 'refreshments'
  | 'restaurants'
  | 'subscriptions'
  | 'taxis'
  | 'tolls'
  | 'training'
  | 'transport';

export type FinanceServicesCustomCategoriesConfigResourceTypeEnum =
  | 'expenses_expense'
  | 'expenses_mileage'
  | 'expenses_perdiem';

/** Spending Alerts */
export type FinanceSpendingAlert = {
  __typename?: 'FinanceSpendingAlert';
  companyId: Scalars['Int'];
  discardedAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['Int'];
  reason?: Maybe<Scalars['String']>;
  source?: Maybe<AlertSource>;
  sourceId?: Maybe<Scalars['Int']>;
  sourceType?: Maybe<Scalars['String']>;
  status: FinanceValueObjectsSpendingAlertStatusEnum;
  target?: Maybe<AlertTarget>;
  targetId?: Maybe<Scalars['Int']>;
  targetType?: Maybe<Scalars['String']>;
  type: FinanceValueObjectsSpendingAlertTypeEnum;
};

/** The connection type for FinanceSpendingAlert. */
export type FinanceSpendingAlertConnection = {
  __typename?: 'FinanceSpendingAlertConnection';
  /** A list of edges. */
  edges: Array<FinanceSpendingAlertEdge>;
  /** A list of nodes. */
  nodes: Array<FinanceSpendingAlert>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FinanceSpendingAlertEdge = {
  __typename?: 'FinanceSpendingAlertEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FinanceSpendingAlert;
};

/** spending policy */
export type FinanceSpendingPolicy = {
  __typename?: 'FinanceSpendingPolicy';
  companyId: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  introText?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  peopleGroupId?: Maybe<Scalars['Int']>;
  spendingPolicyAssignees?: Maybe<FinanceSpendingPolicyAssignee>;
  spendingPolicyRuleGroups: Array<FinanceSpendingPolicyRuleGroup>;
  spendingPolicyRuleGroupsConnection: FinanceSpendingPolicyRuleGroupConnection;
};


/** spending policy */
export type FinanceSpendingPolicySpendingPolicyAssigneesArgs = {
  spendingPolicyIds?: InputMaybe<Array<Scalars['String']>>;
};


/** spending policy */
export type FinanceSpendingPolicySpendingPolicyRuleGroupsArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  onlyParents?: InputMaybe<Scalars['Boolean']>;
  parentId?: InputMaybe<Scalars['String']>;
};


/** spending policy */
export type FinanceSpendingPolicySpendingPolicyRuleGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyParents?: InputMaybe<Scalars['Boolean']>;
  parentId?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};

/** spending policy people group */
export type FinanceSpendingPolicyAssignee = {
  __typename?: 'FinanceSpendingPolicyAssignee';
  accessIds?: Maybe<Array<Scalars['Int']>>;
  companyId: Scalars['Int'];
  id: Scalars['Int'];
  legalEntityIds?: Maybe<Array<Scalars['Int']>>;
  spendingPolicyId: Scalars['Int'];
  strategy: FinanceDtosSpendingPoliciesPeopleGroupStrategyEnum;
};

/** The connection type for FinanceSpendingPolicyAssignee. */
export type FinanceSpendingPolicyAssigneeConnection = {
  __typename?: 'FinanceSpendingPolicyAssigneeConnection';
  /** A list of edges. */
  edges: Array<FinanceSpendingPolicyAssigneeEdge>;
  /** A list of nodes. */
  nodes: Array<FinanceSpendingPolicyAssignee>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FinanceSpendingPolicyAssigneeEdge = {
  __typename?: 'FinanceSpendingPolicyAssigneeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FinanceSpendingPolicyAssignee;
};

/** The connection type for FinanceSpendingPolicy. */
export type FinanceSpendingPolicyConnection = {
  __typename?: 'FinanceSpendingPolicyConnection';
  /** A list of edges. */
  edges: Array<FinanceSpendingPolicyEdge>;
  /** A list of nodes. */
  nodes: Array<FinanceSpendingPolicy>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FinanceSpendingPolicyEdge = {
  __typename?: 'FinanceSpendingPolicyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FinanceSpendingPolicy;
};

export type FinanceSpendingPolicyFailedRule = {
  __typename?: 'FinanceSpendingPolicyFailedRule';
  identifier: Scalars['String'];
  label: Scalars['String'];
  resourceValue?: Maybe<Scalars['String']>;
  ruleValue: Scalars['String'];
};

export type FinanceSpendingPolicyFailedRuleEvaluation = {
  __typename?: 'FinanceSpendingPolicyFailedRuleEvaluation';
  applicablePolicyId?: Maybe<Scalars['Int']>;
  applicableRuleGroupId?: Maybe<Scalars['Int']>;
  failedRules: Array<FinanceSpendingPolicyFailedRule>;
};

/** spending policy rule */
export type FinanceSpendingPolicyRule = {
  __typename?: 'FinanceSpendingPolicyRule';
  companyId: Scalars['Int'];
  formatedValue?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  identifier: Scalars['String'];
  inputType?: Maybe<ApprovalsDomainConfigurationInputTypeEnum>;
  label: Scalars['String'];
  operation: ApprovalsDomainConfigurationOperationsEnum;
  spendingPolicyRuleGroupId: Scalars['Int'];
  value: Array<Scalars['String']>;
};

/** spending policy rule configuration */
export type FinanceSpendingPolicyRuleConfiguration = {
  __typename?: 'FinanceSpendingPolicyRuleConfiguration';
  id: Scalars['String'];
  identifier: Scalars['String'];
  inputType?: Maybe<ApprovalsDomainConfigurationInputTypeEnum>;
  label: Scalars['String'];
  options: Array<FinanceSpendingPolicyRuleOption>;
};

/** The connection type for FinanceSpendingPolicyRuleConfiguration. */
export type FinanceSpendingPolicyRuleConfigurationConnection = {
  __typename?: 'FinanceSpendingPolicyRuleConfigurationConnection';
  /** A list of edges. */
  edges: Array<FinanceSpendingPolicyRuleConfigurationEdge>;
  /** A list of nodes. */
  nodes: Array<FinanceSpendingPolicyRuleConfiguration>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FinanceSpendingPolicyRuleConfigurationEdge = {
  __typename?: 'FinanceSpendingPolicyRuleConfigurationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FinanceSpendingPolicyRuleConfiguration;
};

/** The connection type for FinanceSpendingPolicyRule. */
export type FinanceSpendingPolicyRuleConnection = {
  __typename?: 'FinanceSpendingPolicyRuleConnection';
  /** A list of edges. */
  edges: Array<FinanceSpendingPolicyRuleEdge>;
  /** A list of nodes. */
  nodes: Array<FinanceSpendingPolicyRule>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FinanceSpendingPolicyRuleEdge = {
  __typename?: 'FinanceSpendingPolicyRuleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FinanceSpendingPolicyRule;
};

/** spending policy rule group */
export type FinanceSpendingPolicyRuleGroup = {
  __typename?: 'FinanceSpendingPolicyRuleGroup';
  children: Array<FinanceSpendingPolicyRuleGroup>;
  childrenConnection: FinanceSpendingPolicyRuleGroupConnection;
  companyId: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  parentId?: Maybe<Scalars['Int']>;
  parentRuleGroup?: Maybe<FinanceSpendingPolicyRuleGroup>;
  spendingPolicyId: Scalars['Int'];
  spendingPolicyRules: Array<FinanceSpendingPolicyRule>;
  spendingPolicyRulesConnection: FinanceSpendingPolicyRuleConnection;
};


/** spending policy rule group */
export type FinanceSpendingPolicyRuleGroupChildrenArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  onlyParents?: InputMaybe<Scalars['Boolean']>;
  parentId?: InputMaybe<Scalars['String']>;
  spendingPolicyIds?: InputMaybe<Array<Scalars['String']>>;
};


/** spending policy rule group */
export type FinanceSpendingPolicyRuleGroupChildrenConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyParents?: InputMaybe<Scalars['Boolean']>;
  parentId?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  spendingPolicyIds?: InputMaybe<Array<Scalars['String']>>;
};


/** spending policy rule group */
export type FinanceSpendingPolicyRuleGroupParentRuleGroupArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  onlyParents?: InputMaybe<Scalars['Boolean']>;
  parentId?: InputMaybe<Scalars['String']>;
  spendingPolicyIds?: InputMaybe<Array<Scalars['String']>>;
};


/** spending policy rule group */
export type FinanceSpendingPolicyRuleGroupSpendingPolicyRulesArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
};


/** spending policy rule group */
export type FinanceSpendingPolicyRuleGroupSpendingPolicyRulesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for FinanceSpendingPolicyRuleGroup. */
export type FinanceSpendingPolicyRuleGroupConnection = {
  __typename?: 'FinanceSpendingPolicyRuleGroupConnection';
  /** A list of edges. */
  edges: Array<FinanceSpendingPolicyRuleGroupEdge>;
  /** A list of nodes. */
  nodes: Array<FinanceSpendingPolicyRuleGroup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FinanceSpendingPolicyRuleGroupEdge = {
  __typename?: 'FinanceSpendingPolicyRuleGroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FinanceSpendingPolicyRuleGroup;
};

export type FinanceSpendingPolicyRuleOption = {
  __typename?: 'FinanceSpendingPolicyRuleOption';
  label: Scalars['String'];
  parentId?: Maybe<Scalars['String']>;
  selected: Scalars['Boolean'];
  value: Scalars['String'];
};

/** Tax bridge activation */
export type FinanceTaxBridgeActivation = {
  __typename?: 'FinanceTaxBridgeActivation';
  activatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  employeeId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  legalDocument?: Maybe<FinanceFile>;
  legalEntityId: Scalars['Int'];
  taxAgencyProcess: FinanceTaxBridgeTaxAgenciesEnum;
};

/** The connection type for FinanceTaxBridgeActivation. */
export type FinanceTaxBridgeActivationConnection = {
  __typename?: 'FinanceTaxBridgeActivationConnection';
  /** A list of edges. */
  edges: Array<FinanceTaxBridgeActivationEdge>;
  /** A list of nodes. */
  nodes: Array<FinanceTaxBridgeActivation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FinanceTaxBridgeActivationEdge = {
  __typename?: 'FinanceTaxBridgeActivationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FinanceTaxBridgeActivation;
};

export type FinanceTaxBridgeTaxAgenciesEnum =
  | 'aeat_verifactu'
  | 'undefined';

/** Manages the numeric values applied to a specific tax type within financial operations. */
export type FinanceTaxRate = {
  __typename?: 'FinanceTaxRate';
  amount?: Maybe<Scalars['Float']>;
  /** An optional text describing the tax rate's purpose or context. */
  description?: Maybe<Scalars['String']>;
  /** The external id of the tax rate. */
  externalId?: Maybe<Scalars['String']>;
  /** Factorial id */
  id: Scalars['Int'];
  /** Specifies the numerical percentage for the tax rate between -1 and 1. */
  rate: Scalars['Float'];
  /** The source of the tax rate. Can be 'custom' or 'system'. */
  source: FinanceValueObjectsTaxSourceEnum;
  taxType?: Maybe<FinanceTaxType>;
  /**
   * The identifier of the related TaxType record.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  taxTypeId: Scalars['Int'];
  /** Last update date of the tax rate. */
  updatedAt: Scalars['ISO8601DateTime'];
};


/** Manages the numeric values applied to a specific tax type within financial operations. */
export type FinanceTaxRateTaxTypeArgs = {
  countryCode?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<FinanceValueObjectsTaxSourceEnum>;
  type?: InputMaybe<FinanceValueObjectsTaxTypeEnum>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};

/** The connection type for FinanceTaxRate. */
export type FinanceTaxRateConnection = {
  __typename?: 'FinanceTaxRateConnection';
  /** A list of edges. */
  edges: Array<FinanceTaxRateEdge>;
  /** A list of nodes. */
  nodes: Array<FinanceTaxRate>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FinanceTaxRateEdge = {
  __typename?: 'FinanceTaxRateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FinanceTaxRate;
};

/** the filter for the tax_rates resource */
export type FinanceTaxRateFilter = {
  amount?: InputMaybe<NumberFilter>;
  description?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<FinanceTaxRateFilterConditions>>;
  rate?: InputMaybe<NumberFilter>;
  source?: InputMaybe<StringFilter>;
  taxTypeId?: InputMaybe<IntegerFilter>;
};

export type FinanceTaxRateFilterConditions = {
  amount?: InputMaybe<NumberFilter>;
  description?: InputMaybe<StringFilter>;
  rate?: InputMaybe<NumberFilter>;
  source?: InputMaybe<StringFilter>;
  taxTypeId?: InputMaybe<IntegerFilter>;
};

export type FinanceTaxRateObject = {
  __typename?: 'FinanceTaxRateObject';
  percentage: Scalars['Float'];
};

export type FinanceTaxRateObjectInput = {
  percentage: Scalars['Float'];
};

/** Represents the different tax types used in financial operations. */
export type FinanceTaxType = {
  __typename?: 'FinanceTaxType';
  accountResources: Array<FinanceLedgerAccountResource>;
  accountResourcesConnection: FinanceLedgerAccountResourceConnection;
  /** The country code where this tax type applies. */
  countryCode?: Maybe<Scalars['String']>;
  /** The external id of the tax type. */
  externalId?: Maybe<Scalars['String']>;
  /** Factorial id */
  id: Scalars['Int'];
  /** The name assigned to the tax type. */
  name: Scalars['String'];
  /** The source of the tax type. Can be 'custom' or 'system'. */
  source: FinanceValueObjectsTaxSourceEnum;
  taxRates: Array<FinanceTaxRate>;
  taxratesConnection: FinanceTaxRateConnection;
  /** The tax category used to distinguish different tax kinds. */
  type: FinanceValueObjectsTaxTypeEnum;
  /** Last update date of the tax type. */
  updatedAt: Scalars['ISO8601DateTime'];
};


/** Represents the different tax types used in financial operations. */
export type FinanceTaxTypeAccountResourcesArgs = {
  financeAccountIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Represents the different tax types used in financial operations. */
export type FinanceTaxTypeAccountResourcesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  financeAccountIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Represents the different tax types used in financial operations. */
export type FinanceTaxTypeTaxRatesArgs = {
  countryCode?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<FinanceValueObjectsTaxSourceEnum>;
  type?: InputMaybe<FinanceValueObjectsTaxTypeEnum>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Represents the different tax types used in financial operations. */
export type FinanceTaxTypeTaxratesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  source?: InputMaybe<FinanceValueObjectsTaxSourceEnum>;
  type?: InputMaybe<FinanceValueObjectsTaxTypeEnum>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};

/** The connection type for FinanceTaxType. */
export type FinanceTaxTypeConnection = {
  __typename?: 'FinanceTaxTypeConnection';
  /** A list of edges. */
  edges: Array<FinanceTaxTypeEdge>;
  /** A list of nodes. */
  nodes: Array<FinanceTaxType>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FinanceTaxTypeEdge = {
  __typename?: 'FinanceTaxTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FinanceTaxType;
};

/** the filter for the tax_types resource */
export type FinanceTaxTypeFilter = {
  countryCode?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<FinanceTaxTypeFilterConditions>>;
  source?: InputMaybe<StringFilter>;
  type?: InputMaybe<StringFilter>;
};

export type FinanceTaxTypeFilterConditions = {
  countryCode?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  source?: InputMaybe<StringFilter>;
  type?: InputMaybe<StringFilter>;
};

export type FinanceTenantInput = {
  companyId: Scalars['Int'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type FinanceTrackedCostSource = {
  __typename?: 'FinanceTrackedCostSource';
  sourceId: Scalars['Int'];
  sourceType: FinanceValueObjectsTrackedCostSourceTypeEnum;
};

export type FinanceValueObjectsAccountTypeEnum =
  | 'bank'
  | 'current_asset'
  | 'current_liability'
  | 'equity'
  | 'expense'
  | 'income'
  | 'non_current_asset'
  | 'non_current_liability';

export type FinanceValueObjectsAllocationStatusEnum =
  | 'allocation_risk'
  | 'over_allocation'
  | 'within_allocation';

export type FinanceValueObjectsBudgetPeriodicityEnum =
  | 'daily'
  | 'monthly'
  | 'none'
  | 'weekly'
  | 'yearly';

export type FinanceValueObjectsBudgetStatusEnum =
  | 'budget_risk'
  | 'over_budget'
  | 'within_budget';

export type FinanceValueObjectsCategoryLevelEnum =
  | 'all'
  | 'category'
  | 'subcategory';

export type FinanceValueObjectsCategoryStatusEnum =
  | 'deleted'
  | 'disabled'
  | 'enabled';

export type FinanceValueObjectsCategoryTypeEnum =
  | 'all'
  | 'expense'
  | 'mileage'
  | 'perdiem';

export type FinanceValueObjectsComplianceExtraFieldContextEnum =
  | 'document'
  | 'line_item'
  | 'tax';

export type FinanceValueObjectsComplianceExtraFieldOrganizationEnum =
  | 'aeat';

export type FinanceValueObjectsComplianceExtraFieldTypeEnum =
  | 'enum';

export type FinanceValueObjectsComplianceSnapshotEventEnum =
  | 'convert_quote_to_invoice'
  | 'created_document'
  | 'issued_document'
  | 'register_document'
  | 'updated_document';

export type FinanceValueObjectsContactTaxIdTypeEnum =
  | 'not_registered'
  | 'official_id'
  | 'other_proof_document'
  | 'passport'
  | 'residence_certificate'
  | 'vat_number';

export type FinanceValueObjectsContactTypeEnum =
  | 'client'
  | 'vendor';

export type FinanceValueObjectsCurrencyProvidersEnum =
  | 'ecb'
  | 'openexchangerates';

export type FinanceValueObjectsDealStageEnum =
  | 'closed_lost'
  | 'closed_won'
  | 'negotiation'
  | 'new'
  | 'proposal_sent'
  | 'qualification';

export type FinanceValueObjectsFinancialDocumentEventStatusEnum =
  | 'error'
  | 'success';

export type FinanceValueObjectsFinancialDocumentEventTypeEnum =
  | 'created'
  | 'issued'
  | 'registered'
  | 'resetted_registered'
  | 'tax_document_delivered'
  | 'tax_document_formatted';

export type FinanceValueObjectsFinancialDocumentOperationTypeEnum =
  | 'purchase'
  | 'sale';

export type FinanceValueObjectsFinancialDocumentTypeEnum =
  | 'credit_note'
  | 'invoice'
  | 'receipt';

export type FinanceValueObjectsInvoiceStatusEnum =
  | 'paid'
  | 'processing'
  | 'review'
  | 'sent_to_pay';

export type FinanceValueObjectsJournalDraftEntryStatusEnum =
  | 'draft'
  | 'ready_to_publish'
  | 'unbalanced';

export type FinanceValueObjectsJournalEntryApiSourceTypeEnum =
  | 'account'
  | 'bank_transaction'
  | 'expense'
  | 'finance_reconciliation'
  | 'invoice'
  | 'journal_entry'
  | 'payroll_result'
  | 'reconciliation';

export type FinanceValueObjectsJournalEntrySourceTypeEnum =
  | 'banking_reconciliation'
  | 'banking_transaction'
  | 'expenses_expense'
  | 'finance_account'
  | 'finance_invoice'
  | 'finance_journalentry'
  | 'finance_reconciliation'
  | 'payroll_result';

export type FinanceValueObjectsJournalEntryStatusEnum =
  | 'published'
  | 'reversed';

export type FinanceValueObjectsJournalEntryTypeEnum =
  | 'bank'
  | 'bill'
  | 'credit_note'
  | 'external'
  | 'invoice'
  | 'merged_ledger_account'
  | 'payroll_result'
  | 'receipt'
  | 'reconciliation'
  | 'tax';

export type FinanceValueObjectsLedgerAccountBalanceTypeEnum =
  | 'credit'
  | 'debit';

export type FinanceValueObjectsLedgerAccountOperationTypeEnum =
  | 'purchase'
  | 'sale';

export type FinanceValueObjectsLedgerAccountResourceTypeEnum =
  | 'bankaccount'
  | 'customcategory'
  | 'invoice'
  | 'payrollconcept'
  | 'taxtype'
  | 'vendor';

export type FinanceValueObjectsLineItemQuantityTypeEnum =
  | 'hours'
  | 'units';

export type FinanceValueObjectsLineItemSourceTypeEnum =
  | 'financial_document'
  | 'quote';

export type FinanceValueObjectsLineItemTypeEnum =
  | 'phase'
  | 'role'
  | 'simple';

export type FinanceValueObjectsPendingActionTypeEnum =
  | 'critical'
  | 'info'
  | 'neutral'
  | 'positive'
  | 'warning';

export type FinanceValueObjectsReconcilableTypeEnum =
  | 'journal_line';

export type FinanceValueObjectsReconcilationTypeEnum =
  | 'normal'
  | 'skipped';

export type FinanceValueObjectsReconciliationStatusEnum =
  | 'pending'
  | 'reconciled'
  | 'snoozed';

export type FinanceValueObjectsSpendingAlertStatusEnum =
  | 'failed'
  | 'success';

export type FinanceValueObjectsSpendingAlertTypeEnum =
  | 'category_conflict'
  | 'duplicate_expense'
  | 'in_policy'
  | 'mileage_rate_changed'
  | 'policy_compliance'
  | 'spending_policy';

export type FinanceValueObjectsSpendingPolicyEvaluationResultTypeEnum =
  | 'not_applicable'
  | 'out_of_policy'
  | 'within_policy';

export type FinanceValueObjectsTaxSourceEnum =
  | 'custom'
  | 'system';

export type FinanceValueObjectsTaxTypeEnum =
  | 'personal_income'
  | 'vat';

export type FinanceValueObjectsTrackedCostSourceTypeEnum =
  | 'expenses_expensable';

export type FinanceValueObjectsVendorPreferredPaymentMethodEnum =
  | 'banktransfer'
  | 'card';

export type FinanceVendorAddress = {
  __typename?: 'FinanceVendorAddress';
  city: Scalars['String'];
  countryCode: Scalars['String'];
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  postalCode: Scalars['String'];
  state: Scalars['String'];
};

export type FinanceVendorAddressInput = {
  city: Scalars['String'];
  countryCode: Scalars['String'];
  line1: Scalars['String'];
  line2?: InputMaybe<Scalars['String']>;
  postalCode: Scalars['String'];
  state: Scalars['String'];
};

export type FinancialWorkspaceChildrenData = {
  __typename?: 'FinancialWorkspaceChildrenData';
  category?: Maybe<PayrollValueObjectsConceptCategoryEnum>;
  categoryLabel?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  resourceId?: Maybe<Scalars['Int']>;
  rows: Array<FinancialWorkspaceRow>;
};

export type FinancialWorkspaceContextlessPolicies = {
  __typename?: 'FinancialWorkspaceContextlessPolicies';
  compensationsSee: ContextlessPolicyResolution;
  expensesSee: ContextlessPolicyResolution;
  payrollSee: ContextlessPolicyResolution;
  seeAllCompanyData: ContextlessPolicyResolution;
  seeFinancialWorkspace: ContextlessPolicyResolution;
};

export type FinancialWorkspaceContractRate = {
  __typename?: 'FinancialWorkspaceContractRate';
  amountInCents: Scalars['Int'];
  amountInCentsWithPrecision: Scalars['String'];
  date: Scalars['ISO8601Date'];
};

/** Financial Workspace Employee Contract Rates */
export type FinancialWorkspaceEmployeeContractRate = {
  __typename?: 'FinancialWorkspaceEmployeeContractRate';
  fullName: Scalars['String'];
  id: Scalars['String'];
  rates: Array<FinancialWorkspaceContractRate>;
};

/** The connection type for FinancialWorkspaceEmployeeContractRate. */
export type FinancialWorkspaceEmployeeContractRateConnection = {
  __typename?: 'FinancialWorkspaceEmployeeContractRateConnection';
  /** A list of edges. */
  edges: Array<FinancialWorkspaceEmployeeContractRateEdge>;
  /** A list of nodes. */
  nodes: Array<FinancialWorkspaceEmployeeContractRate>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FinancialWorkspaceEmployeeContractRateEdge = {
  __typename?: 'FinancialWorkspaceEmployeeContractRateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FinancialWorkspaceEmployeeContractRate;
};

/** Financial Workspace Employees Incomplete Contracts */
export type FinancialWorkspaceEmployeesIncompleteContract = {
  __typename?: 'FinancialWorkspaceEmployeesIncompleteContract';
  employee?: Maybe<EmployeesEmployee>;
  id: Scalars['Int'];
};


/** Financial Workspace Employees Incomplete Contracts */
export type FinancialWorkspaceEmployeesIncompleteContractEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for FinancialWorkspaceEmployeesIncompleteContract. */
export type FinancialWorkspaceEmployeesIncompleteContractConnection = {
  __typename?: 'FinancialWorkspaceEmployeesIncompleteContractConnection';
  /** A list of edges. */
  edges: Array<FinancialWorkspaceEmployeesIncompleteContractEdge>;
  /** A list of nodes. */
  nodes: Array<FinancialWorkspaceEmployeesIncompleteContract>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FinancialWorkspaceEmployeesIncompleteContractEdge = {
  __typename?: 'FinancialWorkspaceEmployeesIncompleteContractEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FinancialWorkspaceEmployeesIncompleteContract;
};

/** Financial Workspace Export Employees Incomplete Gross Salaries */
export type FinancialWorkspaceEmployeesIncompleteGrossSalary = {
  __typename?: 'FinancialWorkspaceEmployeesIncompleteGrossSalary';
  effectiveOn: Scalars['String'];
  employeeId: Scalars['Int'];
  endsOn: Scalars['String'];
  fullName: Scalars['String'];
  id: Scalars['Int'];
  startsOn: Scalars['String'];
};

/** The connection type for FinancialWorkspaceEmployeesIncompleteGrossSalary. */
export type FinancialWorkspaceEmployeesIncompleteGrossSalaryConnection = {
  __typename?: 'FinancialWorkspaceEmployeesIncompleteGrossSalaryConnection';
  /** A list of edges. */
  edges: Array<FinancialWorkspaceEmployeesIncompleteGrossSalaryEdge>;
  /** A list of nodes. */
  nodes: Array<FinancialWorkspaceEmployeesIncompleteGrossSalary>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FinancialWorkspaceEmployeesIncompleteGrossSalaryEdge = {
  __typename?: 'FinancialWorkspaceEmployeesIncompleteGrossSalaryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FinancialWorkspaceEmployeesIncompleteGrossSalary;
};

/** Financial Workspace Export Finance Fact Summary */
export type FinancialWorkspaceExportFinanceFactSummary = {
  __typename?: 'FinancialWorkspaceExportFinanceFactSummary';
  success: Scalars['Boolean'];
};

/** Financial Workspace Export Gross Salaries */
export type FinancialWorkspaceExportGrossSalary = {
  __typename?: 'FinancialWorkspaceExportGrossSalary';
  success: Scalars['Boolean'];
};

/** Financial Workspace Export Payroll Line Items */
export type FinancialWorkspaceExportPayrollLineItem = {
  __typename?: 'FinancialWorkspaceExportPayrollLineItem';
  success: Scalars['Boolean'];
};

/** Financial Workspace Finance Fact Summary */
export type FinancialWorkspaceFinanceFactSummary = {
  __typename?: 'FinancialWorkspaceFinanceFactSummary';
  active: Scalars['Boolean'];
  category?: Maybe<Scalars['String']>;
  categoryLabel?: Maybe<Scalars['String']>;
  children?: Maybe<Array<FinancialWorkspaceChildrenData>>;
  costCenterName?: Maybe<Scalars['String']>;
  customCategoryName?: Maybe<Scalars['String']>;
  employeeName?: Maybe<Scalars['String']>;
  hasChildren: Scalars['Boolean'];
  id: Scalars['String'];
  imageUrl?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  legalEntityName?: Maybe<Scalars['String']>;
  locationName?: Maybe<Scalars['String']>;
  rows: Array<FinancialWorkspaceRow>;
};

/** The connection type for FinancialWorkspaceFinanceFactSummary. */
export type FinancialWorkspaceFinanceFactSummaryConnection = {
  __typename?: 'FinancialWorkspaceFinanceFactSummaryConnection';
  /** A list of edges. */
  edges: Array<FinancialWorkspaceFinanceFactSummaryEdge>;
  /** A list of nodes. */
  nodes: Array<FinancialWorkspaceFinanceFactSummary>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FinancialWorkspaceFinanceFactSummaryEdge = {
  __typename?: 'FinancialWorkspaceFinanceFactSummaryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FinancialWorkspaceFinanceFactSummary;
};

/** the filter for the finance_fact_summaries resource */
export type FinancialWorkspaceFinanceFactSummaryFilter = {
  costCenterName?: InputMaybe<StringFilter>;
  customCategoryName?: InputMaybe<StringFilter>;
  legalEntityName?: InputMaybe<StringFilter>;
  locationName?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<FinancialWorkspaceFinanceFactSummaryFilterConditions>>;
};

export type FinancialWorkspaceFinanceFactSummaryFilterConditions = {
  costCenterName?: InputMaybe<StringFilter>;
  customCategoryName?: InputMaybe<StringFilter>;
  legalEntityName?: InputMaybe<StringFilter>;
  locationName?: InputMaybe<StringFilter>;
};

/** Financial Workspace Insight Table Item */
export type FinancialWorkspaceInsightTableItem = {
  __typename?: 'FinancialWorkspaceInsightTableItem';
  active: Scalars['Boolean'];
  category?: Maybe<PayrollValueObjectsConceptCategoryEnum>;
  categoryLabel?: Maybe<Scalars['String']>;
  children?: Maybe<Array<FinancialWorkspaceChildrenData>>;
  costCenterName?: Maybe<Scalars['String']>;
  employeeName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  imageUrl?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  legalEntityName?: Maybe<Scalars['String']>;
  locationName?: Maybe<Scalars['String']>;
  rows: Array<FinancialWorkspaceRow>;
};

/** The connection type for FinancialWorkspaceInsightTableItem. */
export type FinancialWorkspaceInsightTableItemConnection = {
  __typename?: 'FinancialWorkspaceInsightTableItemConnection';
  /** A list of edges. */
  edges: Array<FinancialWorkspaceInsightTableItemEdge>;
  /** A list of nodes. */
  nodes: Array<FinancialWorkspaceInsightTableItem>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FinancialWorkspaceInsightTableItemEdge = {
  __typename?: 'FinancialWorkspaceInsightTableItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FinancialWorkspaceInsightTableItem;
};

/** the filter for the insight_table_items resource */
export type FinancialWorkspaceInsightTableItemFilter = {
  costCenterName?: InputMaybe<StringFilter>;
  legalEntityName?: InputMaybe<StringFilter>;
  locationName?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<FinancialWorkspaceInsightTableItemFilterConditions>>;
};

export type FinancialWorkspaceInsightTableItemFilterConditions = {
  costCenterName?: InputMaybe<StringFilter>;
  legalEntityName?: InputMaybe<StringFilter>;
  locationName?: InputMaybe<StringFilter>;
};

/** Financial Workspace Labor Cost Concept */
export type FinancialWorkspaceLaborCostConcept = {
  __typename?: 'FinancialWorkspaceLaborCostConcept';
  conceptId: Scalars['Int'];
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  financialWorkspaceSettingsId: Scalars['Int'];
  id: Scalars['String'];
  laborCostCalculationType: FinancialWorkspaceValueObjectsLaborCostCalculationTypeEnum;
  setting?: Maybe<FinancialWorkspaceSetting>;
};


/** Financial Workspace Labor Cost Concept */
export type FinancialWorkspaceLaborCostConceptSettingArgs = {
  laborCostType?: InputMaybe<FinancialWorkspaceValueObjectsLaborCostTypeEnum>;
};

/** The connection type for FinancialWorkspaceLaborCostConcept. */
export type FinancialWorkspaceLaborCostConceptConnection = {
  __typename?: 'FinancialWorkspaceLaborCostConceptConnection';
  /** A list of edges. */
  edges: Array<FinancialWorkspaceLaborCostConceptEdge>;
  /** A list of nodes. */
  nodes: Array<FinancialWorkspaceLaborCostConcept>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FinancialWorkspaceLaborCostConceptEdge = {
  __typename?: 'FinancialWorkspaceLaborCostConceptEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FinancialWorkspaceLaborCostConcept;
};

/** Financial Workspace Payroll Landing Banner */
export type FinancialWorkspacePayrollLandingBanner = {
  __typename?: 'FinancialWorkspacePayrollLandingBanner';
  payrollSummaryUploadedLastYear: Scalars['Boolean'];
};

/** The connection type for FinancialWorkspacePayrollLandingBanner. */
export type FinancialWorkspacePayrollLandingBannerConnection = {
  __typename?: 'FinancialWorkspacePayrollLandingBannerConnection';
  /** A list of edges. */
  edges: Array<FinancialWorkspacePayrollLandingBannerEdge>;
  /** A list of nodes. */
  nodes: Array<FinancialWorkspacePayrollLandingBanner>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FinancialWorkspacePayrollLandingBannerEdge = {
  __typename?: 'FinancialWorkspacePayrollLandingBannerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FinancialWorkspacePayrollLandingBanner;
};

export type FinancialWorkspaceRow = {
  __typename?: 'FinancialWorkspaceRow';
  amountInCents: Scalars['String'];
  amountWithPrecision?: Maybe<Scalars['String']>;
  columnLabel: Scalars['String'];
};

/** Financial Workspace Settings */
export type FinancialWorkspaceSetting = {
  __typename?: 'FinancialWorkspaceSetting';
  id: Scalars['String'];
  laborCostConcepts: Array<FinancialWorkspaceLaborCostConcept>;
  laborCostConceptsConnection: FinancialWorkspaceLaborCostConceptConnection;
  laborCostType: FinancialWorkspaceValueObjectsLaborCostTypeEnum;
  subtractEmployeeExpenses: Scalars['Boolean'];
};


/** Financial Workspace Settings */
export type FinancialWorkspaceSettingLaborCostConceptsArgs = {
  conceptIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  laborCostCalculationTypes?: InputMaybe<Array<FinancialWorkspaceValueObjectsLaborCostCalculationTypeEnum>>;
};


/** Financial Workspace Settings */
export type FinancialWorkspaceSettingLaborCostConceptsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  conceptIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  laborCostCalculationTypes?: InputMaybe<Array<FinancialWorkspaceValueObjectsLaborCostCalculationTypeEnum>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for FinancialWorkspaceSetting. */
export type FinancialWorkspaceSettingConnection = {
  __typename?: 'FinancialWorkspaceSettingConnection';
  /** A list of edges. */
  edges: Array<FinancialWorkspaceSettingEdge>;
  /** A list of nodes. */
  nodes: Array<FinancialWorkspaceSetting>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FinancialWorkspaceSettingEdge = {
  __typename?: 'FinancialWorkspaceSettingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FinancialWorkspaceSetting;
};

export type FinancialWorkspaceValueObjectsAgreementDataTypeEnum =
  | 'compensations'
  | 'salary';

export type FinancialWorkspaceValueObjectsCostTypeEnum =
  | 'company_cost'
  | 'labor_cost'
  | 'normal';

export type FinancialWorkspaceValueObjectsFinanceTypeEnum =
  | 'agreement'
  | 'compensations'
  | 'expense'
  | 'payroll';

export type FinancialWorkspaceValueObjectsGrossSalaryGroupEnum =
  | 'costcenter'
  | 'employee'
  | 'legalentity'
  | 'location'
  | 'manager'
  | 'nothing';

export type FinancialWorkspaceValueObjectsInsightTableGroupEnum =
  | 'costcenter'
  | 'customcategory'
  | 'employee'
  | 'legalentity'
  | 'lineitem'
  | 'location'
  | 'manager'
  | 'total';

export type FinancialWorkspaceValueObjectsInsightTableTypeEnum =
  | 'gross_salary'
  | 'payroll';

export type FinancialWorkspaceValueObjectsLaborCostCalculationTypeEnum =
  | 'add_to_total'
  | 'subtract_from_total';

export type FinancialWorkspaceValueObjectsLaborCostTypeEnum =
  | 'company_cost'
  | 'simple_calculation';

export type FinancialWorkspaceValueObjectsPayrollGroupByEnum =
  | 'costcenter'
  | 'employee'
  | 'legalentity'
  | 'lineitem'
  | 'location'
  | 'manager';

export type FinancialWorkspaceValueObjectsPeriodEnum =
  | 'daily'
  | 'hourly'
  | 'monthly'
  | 'quarterly'
  | 'weekly'
  | 'yearly';

/** Autogenerated return type of FindByUuidUniversalimporterImportProcess. */
export type FindByUuidUniversalimporterImportProcessPayload = {
  __typename?: 'FindByUuidUniversalimporterImportProcessPayload';
  errors: Array<MutationError>;
  importProcess?: Maybe<UniversalImporterImportProcess>;
};

/** Autogenerated return type of FinishFormsForm. */
export type FinishFormsFormPayload = {
  __typename?: 'FinishFormsFormPayload';
  errors: Array<MutationError>;
  form?: Maybe<FormsForm>;
};

/** Autogenerated return type of FinishSetupBankingBankAccount. */
export type FinishSetupBankingBankAccountPayload = {
  __typename?: 'FinishSetupBankingBankAccountPayload';
  bankAccount?: Maybe<BankingBankAccount>;
  errors: Array<MutationError>;
};

export type FixContractsContractVersionAdditionalCompensationsInput = {
  amount?: InputMaybe<Scalars['Int']>;
  calculation?: InputMaybe<Scalars['String']>;
  compensationType?: InputMaybe<Scalars['String']>;
  contractsTaxonomyId: Scalars['Int'];
  description?: InputMaybe<Scalars['String']>;
  firstPaymentOn?: InputMaybe<Scalars['ISO8601Date']>;
  id?: InputMaybe<Scalars['Int']>;
  minimumAmountOfHours?: InputMaybe<Scalars['Int']>;
  minimumAmountOfHoursInCents?: InputMaybe<Scalars['Int']>;
  payrollPolicyId?: InputMaybe<Scalars['Int']>;
  recurrence?: InputMaybe<Scalars['String']>;
  recurrenceCount?: InputMaybe<Scalars['Int']>;
  startsOn?: InputMaybe<Scalars['ISO8601Date']>;
  syncWithSupplements?: InputMaybe<Scalars['Boolean']>;
  timeCondition?: InputMaybe<ContractsValueObjectsTimeConditionEnum>;
  unit?: InputMaybe<Scalars['String']>;
};

export type FixContractsContractVersionCustomFieldsInput = {
  identifier: Scalars['String'];
  value?: InputMaybe<Scalars['String']>;
};

export type FixContractsContractVersionNewAdditionalCompensationsInput = {
  amount?: InputMaybe<Scalars['Int']>;
  amountStrategyType: Scalars['String'];
  contractVersionId: Scalars['Int'];
  description?: InputMaybe<Scalars['String']>;
  firstPaymentOn?: InputMaybe<Scalars['ISO8601Date']>;
  id?: InputMaybe<Scalars['Int']>;
  payrollConceptId: Scalars['Int'];
  recurrence?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<Scalars['String']>;
  upperLimit?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of FixContractsContractVersion. */
export type FixContractsContractVersionPayload = {
  __typename?: 'FixContractsContractVersionPayload';
  contractVersion?: Maybe<ContractsContractVersion>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of ForceDeleteFormsForm. */
export type ForceDeleteFormsFormPayload = {
  __typename?: 'ForceDeleteFormsFormPayload';
  errors: Array<MutationError>;
  forms?: Maybe<Array<FormsForm>>;
};

/** Autogenerated return type of ForgotClockOutAttendanceClockInOut. */
export type ForgotClockOutAttendanceClockInOutPayload = {
  __typename?: 'ForgotClockOutAttendanceClockInOutPayload';
  clockInOut?: Maybe<AttendanceClockInOut>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of ForgotClockOutAttendanceShift. */
export type ForgotClockOutAttendanceShiftPayload = {
  __typename?: 'ForgotClockOutAttendanceShiftPayload';
  errors: Array<MutationError>;
  shift?: Maybe<AttendanceShift>;
};

/** Form answer */
export type FormsAnswer = {
  __typename?: 'FormsAnswer';
  answer?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  companyId: Scalars['String'];
  element?: Maybe<FormsElement>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  elementId: Scalars['String'];
  elementOptionIds?: Maybe<Array<Scalars['String']>>;
  id: Scalars['String'];
  isCorrect?: Maybe<Scalars['Boolean']>;
  materializedQuestion?: Maybe<FormsMaterializedQuestion>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  materializedQuestionId: Scalars['String'];
  materializedQuestionOption: Array<FormsMaterializedQuestionOption>;
  materializedQuestionOptionConnection: FormsMaterializedQuestionOptionConnection;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  materializedQuestionOptionIds?: Maybe<Array<Scalars['String']>>;
  membership?: Maybe<FormsMembership>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  membershipId: Scalars['String'];
};


/** Form answer */
export type FormsAnswerElementArgs = {
  formId?: InputMaybe<Scalars['String']>;
  formIds?: InputMaybe<Array<Scalars['String']>>;
  locale?: InputMaybe<Scalars['String']>;
};


/** Form answer */
export type FormsAnswerMaterializedQuestionArgs = {
  materializedFormId?: InputMaybe<Scalars['String']>;
  materializedSectionId?: InputMaybe<Scalars['String']>;
  withoutSection?: InputMaybe<Scalars['Boolean']>;
};


/** Form answer */
export type FormsAnswerMaterializedQuestionOptionArgs = {
  materializedQuestionId?: InputMaybe<Scalars['String']>;
};


/** Form answer */
export type FormsAnswerMaterializedQuestionOptionConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  materializedQuestionId?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Form answer */
export type FormsAnswerMembershipArgs = {
  cycleIds?: InputMaybe<Array<Scalars['String']>>;
  formId?: InputMaybe<Scalars['String']>;
  formType?: InputMaybe<Array<Scalars['String']>>;
  hasAnswers?: InputMaybe<Scalars['Boolean']>;
  jobRoles?: InputMaybe<Array<Scalars['Int']>>;
  jobTitles?: InputMaybe<Array<Scalars['String']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  materializedFormIds?: InputMaybe<Array<Scalars['String']>>;
  resourceType?: InputMaybe<Scalars['String']>;
  respondentId?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  searchByFormTitle?: InputMaybe<Scalars['String']>;
  targetId?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  trainingId?: InputMaybe<Scalars['String']>;
};

/** Form answer AI insight */
export type FormsAnswerAiInsight = {
  __typename?: 'FormsAnswerAiInsight';
  element?: Maybe<FormsElement>;
  id: Scalars['String'];
  summary?: Maybe<Scalars['String']>;
};


/** Form answer AI insight */
export type FormsAnswerAiInsightElementArgs = {
  formId?: InputMaybe<Scalars['String']>;
  formIds?: InputMaybe<Array<Scalars['String']>>;
  locale?: InputMaybe<Scalars['String']>;
};

/** The connection type for FormsAnswerAiInsight. */
export type FormsAnswerAiInsightConnection = {
  __typename?: 'FormsAnswerAiInsightConnection';
  /** A list of edges. */
  edges: Array<FormsAnswerAiInsightEdge>;
  /** A list of nodes. */
  nodes: Array<FormsAnswerAiInsight>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FormsAnswerAiInsightEdge = {
  __typename?: 'FormsAnswerAiInsightEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FormsAnswerAiInsight;
};

/** The connection type for FormsAnswer. */
export type FormsAnswerConnection = {
  __typename?: 'FormsAnswerConnection';
  /** A list of edges. */
  edges: Array<FormsAnswerEdge>;
  /** A list of nodes. */
  nodes: Array<FormsAnswer>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FormsAnswerEdge = {
  __typename?: 'FormsAnswerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FormsAnswer;
};

export type FormsAnswerInput = {
  answer?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  elementId?: InputMaybe<Scalars['String']>;
  elementOptionIds?: InputMaybe<Array<Scalars['String']>>;
  materializedQuestionId?: InputMaybe<Scalars['String']>;
  materializedQuestionOptionIds?: InputMaybe<Array<Scalars['String']>>;
};

/** Cycles */
export type FormsCycle = {
  __typename?: 'FormsCycle';
  endsAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['String'];
  materializedForm?: Maybe<FormsMaterializedForm>;
  schedule: FormsSchedule;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  scheduleId: Scalars['String'];
  startsAt: Scalars['ISO8601DateTime'];
};


/** Cycles */
export type FormsCycleMaterializedFormArgs = {
  formId?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  resourceIds?: InputMaybe<Array<Scalars['String']>>;
  resourceType?: InputMaybe<Scalars['String']>;
  respondentId?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


/** Cycles */
export type FormsCycleScheduleArgs = {
  formId?: InputMaybe<Scalars['String']>;
};

/** The connection type for FormsCycle. */
export type FormsCycleConnection = {
  __typename?: 'FormsCycleConnection';
  /** A list of edges. */
  edges: Array<FormsCycleEdge>;
  /** A list of nodes. */
  nodes: Array<FormsCycle>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FormsCycleEdge = {
  __typename?: 'FormsCycleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FormsCycle;
};

/** Form Element */
export type FormsElement = {
  __typename?: 'FormsElement';
  companyId: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  description?: Maybe<Scalars['String']>;
  formId: Scalars['String'];
  hasCorrectAnswer: Scalars['Boolean'];
  id: Scalars['String'];
  label: Scalars['String'];
  mandatory: Scalars['Boolean'];
  options: Array<FormsElementOption>;
  optionsConnection: FormsElementOptionConnection;
  params: FormsElementParams;
  position: Scalars['Int'];
  sectionId: Scalars['String'];
  type: FormsElementTypeEnum;
  updatedAt: Scalars['ISO8601DateTime'];
};


/** Form Element */
export type FormsElementOptionsArgs = {
  elementId?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  locale?: InputMaybe<Scalars['String']>;
};


/** Form Element */
export type FormsElementOptionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  elementId?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** Form element analytics */
export type FormsElementAnalytic = {
  __typename?: 'FormsElementAnalytic';
  categories: Array<Scalars['String']>;
  element?: Maybe<FormsElement>;
  meta: FormsElementAnalyticMeta;
  series: Array<Scalars['Int']>;
};


/** Form element analytics */
export type FormsElementAnalyticElementArgs = {
  formId?: InputMaybe<Scalars['String']>;
  formIds?: InputMaybe<Array<Scalars['String']>>;
  locale?: InputMaybe<Scalars['String']>;
};

/** The connection type for FormsElementAnalytic. */
export type FormsElementAnalyticConnection = {
  __typename?: 'FormsElementAnalyticConnection';
  /** A list of edges. */
  edges: Array<FormsElementAnalyticEdge>;
  /** A list of nodes. */
  nodes: Array<FormsElementAnalytic>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FormsElementAnalyticEdge = {
  __typename?: 'FormsElementAnalyticEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FormsElementAnalytic;
};

export type FormsElementAnalyticMeta = {
  __typename?: 'FormsElementAnalyticMeta';
  average: Scalars['Float'];
  total: Scalars['Int'];
};

/** The connection type for FormsElement. */
export type FormsElementConnection = {
  __typename?: 'FormsElementConnection';
  /** A list of edges. */
  edges: Array<FormsElementEdge>;
  /** A list of nodes. */
  nodes: Array<FormsElement>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FormsElementEdge = {
  __typename?: 'FormsElementEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FormsElement;
};

export type FormsElementInput = {
  description: Scalars['String'];
  elements?: InputMaybe<Array<FormsElementsInSectionsInput>>;
  hasCorrectAnswer?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  label: Scalars['String'];
  mandatory: Scalars['Boolean'];
  options?: InputMaybe<Array<FormsElementOptionInput>>;
  params?: InputMaybe<FormsElementParamsInput>;
  position: Scalars['Int'];
  type: FormsElementTypeEnum;
};

/** Form Element options */
export type FormsElementOption = {
  __typename?: 'FormsElementOption';
  companyId: Scalars['String'];
  elementId: Scalars['String'];
  id: Scalars['String'];
  isCorrect: Scalars['Boolean'];
  label: Scalars['String'];
  value: Scalars['String'];
};

/** The connection type for FormsElementOption. */
export type FormsElementOptionConnection = {
  __typename?: 'FormsElementOptionConnection';
  /** A list of edges. */
  edges: Array<FormsElementOptionEdge>;
  /** A list of nodes. */
  nodes: Array<FormsElementOption>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FormsElementOptionEdge = {
  __typename?: 'FormsElementOptionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FormsElementOption;
};

export type FormsElementOptionInput = {
  id?: InputMaybe<Scalars['String']>;
  isCorrect?: InputMaybe<Scalars['Boolean']>;
  label: Scalars['String'];
  value: Scalars['String'];
};

export type FormsElementParams = {
  __typename?: 'FormsElementParams';
  analyzeWithAi?: Maybe<Scalars['Boolean']>;
  locked?: Maybe<Scalars['Boolean']>;
  maxLength?: Maybe<Scalars['Int']>;
  optionalComment?: Maybe<Scalars['String']>;
  scoreType?: Maybe<Scalars['String']>;
};

export type FormsElementParamsInput = {
  analyzeWithAi?: InputMaybe<Scalars['Boolean']>;
  locked?: InputMaybe<Scalars['Boolean']>;
  maxLength?: InputMaybe<Scalars['Int']>;
  optionalComment?: InputMaybe<Scalars['String']>;
  scoreType?: InputMaybe<Scalars['String']>;
};

export type FormsElementTypeEnum =
  | 'date'
  | 'dropdownsingle'
  | 'longtext'
  | 'multiselect'
  | 'number'
  | 'rating'
  | 'score'
  | 'section'
  | 'select'
  | 'text'
  | 'url';

export type FormsElementsInSectionsInput = {
  description: Scalars['String'];
  hasCorrectAnswer?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  label: Scalars['String'];
  mandatory: Scalars['Boolean'];
  options?: InputMaybe<Array<FormsElementOptionInput>>;
  params?: InputMaybe<FormsElementParamsInput>;
  position: Scalars['Int'];
  type: FormsElementTypeEnum;
};

export type FormsEnumsRecurrenceTypeEnum =
  | 'bi_monthly'
  | 'bi_weekly'
  | 'daily'
  | 'monthly'
  | 'quadrimester'
  | 'quarterly'
  | 'semi_annual'
  | 'weekly'
  | 'yearly';

export type FormsEnumsStatusEnum =
  | 'active'
  | 'archived'
  | 'draft'
  | 'finished'
  | 'scheduled';

/** Form to create user forms */
export type FormsForm = {
  __typename?: 'FormsForm';
  anonymous: Scalars['Boolean'];
  answeredCount?: Maybe<Scalars['Int']>;
  author?: Maybe<ApiCoreAccess>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  authorId?: Maybe<Scalars['String']>;
  companyId: Scalars['String'];
  completionRate?: Maybe<Scalars['Float']>;
  configuration?: Maybe<FormsFormConfiguration>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  description?: Maybe<Scalars['String']>;
  elements: Array<FormsElement>;
  elementsConnection: FormsElementConnection;
  endsAt?: Maybe<Scalars['ISO8601DateTime']>;
  formType: FormsTypeEnum;
  id: Scalars['String'];
  isTemplate?: Maybe<Scalars['Boolean']>;
  materializedForms: Array<FormsMaterializedForm>;
  materializedFormsConnection: FormsMaterializedFormConnection;
  nextRunDate?: Maybe<Scalars['ISO8601DateTime']>;
  questions?: Maybe<FormsQuestion>;
  recurrenceType?: Maybe<FormsEnumsRecurrenceTypeEnum>;
  resourceId?: Maybe<Scalars['String']>;
  resourceIds: Scalars['String'];
  resourceType: Scalars['String'];
  schedule?: Maybe<FormsSchedule>;
  sentCount?: Maybe<Scalars['Int']>;
  status: FormsFormStatusEnum;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};


/** Form to create user forms */
export type FormsFormAuthorArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** Form to create user forms */
export type FormsFormElementsArgs = {
  formId?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  locale?: InputMaybe<Scalars['String']>;
};


/** Form to create user forms */
export type FormsFormElementsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  formId?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Form to create user forms */
export type FormsFormMaterializedFormsArgs = {
  cycleIds?: InputMaybe<Array<Scalars['String']>>;
  formId?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  resourceIds?: InputMaybe<Array<Scalars['String']>>;
  resourceType?: InputMaybe<Scalars['String']>;
  respondentId?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


/** Form to create user forms */
export type FormsFormMaterializedFormsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  cycleIds?: InputMaybe<Array<Scalars['String']>>;
  first?: InputMaybe<Scalars['Int']>;
  formId?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  resourceIds?: InputMaybe<Array<Scalars['String']>>;
  resourceType?: InputMaybe<Scalars['String']>;
  respondentId?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Form to create user forms */
export type FormsFormQuestionsArgs = {
  formId: Scalars['String'];
  ids?: InputMaybe<Array<Scalars['String']>>;
};


/** Form to create user forms */
export type FormsFormScheduleArgs = {
  formId?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
};

export type FormsFormConfiguration = {
  __typename?: 'FormsFormConfiguration';
  allowedElements: Array<FormsValueObjectsElementTypeEnum>;
  daysToAnswer?: Maybe<Scalars['Int']>;
  retryable: Scalars['Boolean'];
  scorable: Scalars['Boolean'];
};

export type FormsFormConfigurationInput = {
  allowedElements: Array<FormsValueObjectsElementTypeEnum>;
  daysToAnswer?: InputMaybe<Scalars['Int']>;
  retryable: Scalars['Boolean'];
  scorable: Scalars['Boolean'];
};

/** The connection type for FormsForm. */
export type FormsFormConnection = {
  __typename?: 'FormsFormConnection';
  /** A list of edges. */
  edges: Array<FormsFormEdge>;
  /** A list of nodes. */
  nodes: Array<FormsForm>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FormsFormEdge = {
  __typename?: 'FormsFormEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FormsForm;
};

/** the filter for the forms resource */
export type FormsFormFilter = {
  formType?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<FormsFormFilterConditions>>;
  resourceIds?: InputMaybe<StringFilter>;
  resourceType?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
  trainingId?: InputMaybe<StringFilter>;
};

export type FormsFormFilterConditions = {
  formType?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  resourceIds?: InputMaybe<StringFilter>;
  resourceType?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
  trainingId?: InputMaybe<StringFilter>;
};

export type FormsFormInput = {
  authorId?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  elements: Array<FormsElementInput>;
  formType?: InputMaybe<FormsTypeEnum>;
  id?: InputMaybe<Scalars['String']>;
  resourceId?: InputMaybe<Scalars['String']>;
  resourceType: Scalars['String'];
  title: Scalars['String'];
};

export type FormsFormStatusEnum =
  | 'active'
  | 'archived'
  | 'draft'
  | 'finished'
  | 'scheduled';

/** Materialized form */
export type FormsMaterializedForm = {
  __typename?: 'FormsMaterializedForm';
  companyId: Scalars['String'];
  configuration?: Maybe<FormsMaterializedFormConfiguration>;
  cycle?: Maybe<FormsCycle>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  cycleId?: Maybe<Scalars['Int']>;
  elements: Array<FormsElement>;
  elementsConnection: FormsElementConnection;
  endsAt?: Maybe<Scalars['ISO8601DateTime']>;
  form?: Maybe<FormsForm>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  formId: Scalars['String'];
  formTitle: Scalars['String'];
  formType?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  materializedFormResource?: Maybe<MaterializedFormResource>;
  materializedQuestions: Array<FormsMaterializedQuestion>;
  materializedQuestionsConnection: FormsMaterializedQuestionConnection;
  materializedSections: Array<FormsMaterializedSection>;
  materializedSectionsConnection: FormsMaterializedSectionConnection;
  memberships: Array<FormsMembership>;
  membershipsConnection: FormsMembershipConnection;
  resourceFormName?: Maybe<Scalars['String']>;
  resourceId: Scalars['String'];
  resourceName?: Maybe<Scalars['String']>;
  resourceType: Scalars['String'];
  startsAt?: Maybe<Scalars['ISO8601DateTime']>;
  status?: Maybe<Scalars['String']>;
};


/** Materialized form */
export type FormsMaterializedFormCycleArgs = {
  scheduleIds?: InputMaybe<Array<Scalars['String']>>;
};


/** Materialized form */
export type FormsMaterializedFormElementsArgs = {
  formId?: InputMaybe<Scalars['String']>;
  formIds?: InputMaybe<Array<Scalars['String']>>;
  locale?: InputMaybe<Scalars['String']>;
};


/** Materialized form */
export type FormsMaterializedFormElementsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  formId?: InputMaybe<Scalars['String']>;
  formIds?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Materialized form */
export type FormsMaterializedFormFormArgs = {
  formType?: InputMaybe<Array<Scalars['String']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyTemplates?: InputMaybe<Scalars['Boolean']>;
  resourceId?: InputMaybe<Scalars['String']>;
  resourceType: Scalars['String'];
  respondentId?: InputMaybe<Scalars['String']>;
  returnAnswerProgress?: Scalars['Boolean'];
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};


/** Materialized form */
export type FormsMaterializedFormMaterializedQuestionsArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
  materializedFormId?: InputMaybe<Scalars['String']>;
  materializedSectionId?: InputMaybe<Scalars['String']>;
  withoutSection?: InputMaybe<Scalars['Boolean']>;
};


/** Materialized form */
export type FormsMaterializedFormMaterializedQuestionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  materializedFormId?: InputMaybe<Scalars['String']>;
  materializedSectionId?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  withoutSection?: InputMaybe<Scalars['Boolean']>;
};


/** Materialized form */
export type FormsMaterializedFormMaterializedSectionsArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
  materializedFormId?: InputMaybe<Scalars['String']>;
};


/** Materialized form */
export type FormsMaterializedFormMaterializedSectionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  materializedFormId?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Materialized form */
export type FormsMaterializedFormMembershipsArgs = {
  cycleIds?: InputMaybe<Array<Scalars['String']>>;
  formId?: InputMaybe<Scalars['String']>;
  formType?: InputMaybe<Array<Scalars['String']>>;
  hasAnswers?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  jobRoles?: InputMaybe<Array<Scalars['Int']>>;
  jobTitles?: InputMaybe<Array<Scalars['String']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceType?: InputMaybe<Scalars['String']>;
  respondentId?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  searchByFormTitle?: InputMaybe<Scalars['String']>;
  targetId?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  trainingId?: InputMaybe<Scalars['String']>;
};


/** Materialized form */
export type FormsMaterializedFormMembershipsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  cycleIds?: InputMaybe<Array<Scalars['String']>>;
  first?: InputMaybe<Scalars['Int']>;
  formId?: InputMaybe<Scalars['String']>;
  formType?: InputMaybe<Array<Scalars['String']>>;
  hasAnswers?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  jobRoles?: InputMaybe<Array<Scalars['Int']>>;
  jobTitles?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  resourceType?: InputMaybe<Scalars['String']>;
  respondentId?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  searchByFormTitle?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  targetId?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  trainingId?: InputMaybe<Scalars['String']>;
};

export type FormsMaterializedFormConfiguration = {
  __typename?: 'FormsMaterializedFormConfiguration';
  respondentIds?: Maybe<Array<Scalars['String']>>;
  targetStrategy: Scalars['String'];
};

export type FormsMaterializedFormConfigurationInput = {
  respondentIds?: InputMaybe<Array<Scalars['String']>>;
  targetStrategy: Scalars['String'];
};

/** The connection type for FormsMaterializedForm. */
export type FormsMaterializedFormConnection = {
  __typename?: 'FormsMaterializedFormConnection';
  /** A list of edges. */
  edges: Array<FormsMaterializedFormEdge>;
  /** A list of nodes. */
  nodes: Array<FormsMaterializedForm>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FormsMaterializedFormEdge = {
  __typename?: 'FormsMaterializedFormEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FormsMaterializedForm;
};

/** Materialized question */
export type FormsMaterializedQuestion = {
  __typename?: 'FormsMaterializedQuestion';
  companyId: Scalars['String'];
  id: Scalars['String'];
  label: Scalars['String'];
  mandatory: Scalars['Boolean'];
  materializedForm?: Maybe<FormsMaterializedForm>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  materializedFormId: Scalars['String'];
  materializedQuestionOptions: Array<FormsMaterializedQuestionOption>;
  materializedQuestionOptionsConnection: FormsMaterializedQuestionOptionConnection;
  materializedSection?: Maybe<FormsMaterializedSection>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  materializedSectionId?: Maybe<Scalars['String']>;
  maxChoices?: Maybe<Scalars['Int']>;
  position: Scalars['Int'];
  questionType: FormsMaterializedQuestionQuestionTypeEnum;
  scale?: Maybe<Array<FormsRatingScaleOption>>;
  uuid: Scalars['String'];
  withComment?: Maybe<Scalars['Boolean']>;
};


/** Materialized question */
export type FormsMaterializedQuestionMaterializedFormArgs = {
  cycleIds?: InputMaybe<Array<Scalars['String']>>;
  formId?: InputMaybe<Scalars['String']>;
  resourceIds?: InputMaybe<Array<Scalars['String']>>;
  resourceType?: InputMaybe<Scalars['String']>;
  respondentId?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


/** Materialized question */
export type FormsMaterializedQuestionMaterializedQuestionOptionsArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
  materializedQuestionId?: InputMaybe<Scalars['String']>;
};


/** Materialized question */
export type FormsMaterializedQuestionMaterializedQuestionOptionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  materializedQuestionId?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Materialized question */
export type FormsMaterializedQuestionMaterializedSectionArgs = {
  materializedFormId?: InputMaybe<Scalars['String']>;
};

/** The connection type for FormsMaterializedQuestion. */
export type FormsMaterializedQuestionConnection = {
  __typename?: 'FormsMaterializedQuestionConnection';
  /** A list of edges. */
  edges: Array<FormsMaterializedQuestionEdge>;
  /** A list of nodes. */
  nodes: Array<FormsMaterializedQuestion>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FormsMaterializedQuestionEdge = {
  __typename?: 'FormsMaterializedQuestionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FormsMaterializedQuestion;
};

/** Materialized question option */
export type FormsMaterializedQuestionOption = {
  __typename?: 'FormsMaterializedQuestionOption';
  companyId: Scalars['String'];
  id: Scalars['String'];
  label: Scalars['String'];
  materializedQuestion?: Maybe<FormsMaterializedForm>;
  materializedQuestionId: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};


/** Materialized question option */
export type FormsMaterializedQuestionOptionMaterializedQuestionArgs = {
  cycleIds?: InputMaybe<Array<Scalars['String']>>;
  formId?: InputMaybe<Scalars['String']>;
  resourceIds?: InputMaybe<Array<Scalars['String']>>;
  resourceType?: InputMaybe<Scalars['String']>;
  respondentId?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};

/** The connection type for FormsMaterializedQuestionOption. */
export type FormsMaterializedQuestionOptionConnection = {
  __typename?: 'FormsMaterializedQuestionOptionConnection';
  /** A list of edges. */
  edges: Array<FormsMaterializedQuestionOptionEdge>;
  /** A list of nodes. */
  nodes: Array<FormsMaterializedQuestionOption>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FormsMaterializedQuestionOptionEdge = {
  __typename?: 'FormsMaterializedQuestionOptionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FormsMaterializedQuestionOption;
};

export type FormsMaterializedQuestionQuestionTypeEnum =
  | 'multiple_choice'
  | 'number'
  | 'rating'
  | 'text';

/** Materialized section */
export type FormsMaterializedSection = {
  __typename?: 'FormsMaterializedSection';
  companyId: Scalars['String'];
  id: Scalars['String'];
  materializedForm?: Maybe<FormsMaterializedForm>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  materializedFormId: Scalars['String'];
  materializedQuestions: Array<FormsMaterializedQuestion>;
  materializedQuestionsConnection: FormsMaterializedQuestionConnection;
  position: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
};


/** Materialized section */
export type FormsMaterializedSectionMaterializedFormArgs = {
  cycleIds?: InputMaybe<Array<Scalars['String']>>;
  formId?: InputMaybe<Scalars['String']>;
  resourceIds?: InputMaybe<Array<Scalars['String']>>;
  resourceType?: InputMaybe<Scalars['String']>;
  respondentId?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


/** Materialized section */
export type FormsMaterializedSectionMaterializedQuestionsArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
  materializedFormId?: InputMaybe<Scalars['String']>;
  materializedSectionId?: InputMaybe<Scalars['String']>;
  withoutSection?: InputMaybe<Scalars['Boolean']>;
};


/** Materialized section */
export type FormsMaterializedSectionMaterializedQuestionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  materializedFormId?: InputMaybe<Scalars['String']>;
  materializedSectionId?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  withoutSection?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for FormsMaterializedSection. */
export type FormsMaterializedSectionConnection = {
  __typename?: 'FormsMaterializedSectionConnection';
  /** A list of edges. */
  edges: Array<FormsMaterializedSectionEdge>;
  /** A list of nodes. */
  nodes: Array<FormsMaterializedSection>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FormsMaterializedSectionEdge = {
  __typename?: 'FormsMaterializedSectionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FormsMaterializedSection;
};

/** Form membership */
export type FormsMembership = {
  __typename?: 'FormsMembership';
  answers: Array<FormsAnswer>;
  answersConnection: FormsAnswerConnection;
  companyId: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['String'];
  materializedForm?: Maybe<FormsMaterializedForm>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  materializedFormId?: Maybe<Scalars['String']>;
  respondent?: Maybe<ApiCoreAccess>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  respondentId?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  target?: Maybe<ApiCoreAccess>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  targetId: Scalars['String'];
  url: Scalars['String'];
};


/** Form membership */
export type FormsMembershipAnswersArgs = {
  formId?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  materializedQuestionId?: InputMaybe<Scalars['String']>;
  materializedQuestionOptionIds?: InputMaybe<Array<Scalars['String']>>;
  membershipId?: InputMaybe<Scalars['String']>;
};


/** Form membership */
export type FormsMembershipAnswersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  formId?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  materializedQuestionId?: InputMaybe<Scalars['String']>;
  materializedQuestionOptionIds?: InputMaybe<Array<Scalars['String']>>;
  membershipId?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Form membership */
export type FormsMembershipMaterializedFormArgs = {
  cycleIds?: InputMaybe<Array<Scalars['String']>>;
  formId?: InputMaybe<Scalars['String']>;
  resourceIds?: InputMaybe<Array<Scalars['String']>>;
  resourceType?: InputMaybe<Scalars['String']>;
  respondentId?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


/** Form membership */
export type FormsMembershipRespondentArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** Form membership */
export type FormsMembershipTargetArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for FormsMembership. */
export type FormsMembershipConnection = {
  __typename?: 'FormsMembershipConnection';
  /** A list of edges. */
  edges: Array<FormsMembershipEdge>;
  /** A list of nodes. */
  nodes: Array<FormsMembership>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FormsMembershipEdge = {
  __typename?: 'FormsMembershipEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FormsMembership;
};

/** the filter for the memberships resource */
export type FormsMembershipFilter = {
  answerCount?: InputMaybe<BooleanFilter>;
  formId?: InputMaybe<StringFilter>;
  jobRoles?: InputMaybe<StringFilter>;
  jobTitles?: InputMaybe<StringFilter>;
  legalEntityIds?: InputMaybe<StringFilter>;
  locationIds?: InputMaybe<StringFilter>;
  managerIds?: InputMaybe<StringFilter>;
  materializedFormFormType?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<FormsMembershipFilterConditions>>;
  status?: InputMaybe<StringFilter>;
  targetId?: InputMaybe<StringFilter>;
  teamIds?: InputMaybe<StringFilter>;
  trainingId?: InputMaybe<StringFilter>;
};

export type FormsMembershipFilterConditions = {
  answerCount?: InputMaybe<BooleanFilter>;
  formId?: InputMaybe<StringFilter>;
  jobRoles?: InputMaybe<StringFilter>;
  jobTitles?: InputMaybe<StringFilter>;
  legalEntityIds?: InputMaybe<StringFilter>;
  locationIds?: InputMaybe<StringFilter>;
  managerIds?: InputMaybe<StringFilter>;
  materializedFormFormType?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
  targetId?: InputMaybe<StringFilter>;
  teamIds?: InputMaybe<StringFilter>;
  trainingId?: InputMaybe<StringFilter>;
};

/** My Form memberships */
export type FormsMyMembership = {
  __typename?: 'FormsMyMembership';
  companyId: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['String'];
  materializedForm?: Maybe<FormsMaterializedForm>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  materializedFormId?: Maybe<Scalars['String']>;
  respondentId?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  targetId?: Maybe<Scalars['Int']>;
  url: Scalars['String'];
};


/** My Form memberships */
export type FormsMyMembershipMaterializedFormArgs = {
  cycleIds?: InputMaybe<Array<Scalars['String']>>;
  formId?: InputMaybe<Scalars['String']>;
  resourceIds?: InputMaybe<Array<Scalars['String']>>;
  resourceType?: InputMaybe<Scalars['String']>;
  respondentId?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};

/** The connection type for FormsMyMembership. */
export type FormsMyMembershipConnection = {
  __typename?: 'FormsMyMembershipConnection';
  /** A list of edges. */
  edges: Array<FormsMyMembershipEdge>;
  /** A list of nodes. */
  nodes: Array<FormsMyMembership>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FormsMyMembershipEdge = {
  __typename?: 'FormsMyMembershipEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FormsMyMembership;
};

/** Questions */
export type FormsQuestion = {
  __typename?: 'FormsQuestion';
  companyId: Scalars['String'];
  form?: Maybe<FormsForm>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  formId: Scalars['String'];
  id: Scalars['String'];
  questionnaire: Array<FormsQuestionnaireElement>;
};


/** Questions */
export type FormsQuestionFormArgs = {
  formType?: InputMaybe<Array<Scalars['String']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyTemplates?: InputMaybe<Scalars['Boolean']>;
  resourceId?: InputMaybe<Scalars['String']>;
  resourceType: Scalars['String'];
  respondentId?: InputMaybe<Scalars['String']>;
  returnAnswerProgress?: Scalars['Boolean'];
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

/** The connection type for FormsQuestion. */
export type FormsQuestionConnection = {
  __typename?: 'FormsQuestionConnection';
  /** A list of edges. */
  edges: Array<FormsQuestionEdge>;
  /** A list of nodes. */
  nodes: Array<FormsQuestion>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FormsQuestionEdge = {
  __typename?: 'FormsQuestionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FormsQuestion;
};

export type FormsQuestionSingleLabel = {
  __typename?: 'FormsQuestionSingleLabel';
  answerType: QuestionnairesQuestionnaireQuestionAnswerTypesEnum;
  choiceOptions?: Maybe<Array<Scalars['String']>>;
  mandatory: Scalars['Boolean'];
  maxChoices?: Maybe<Scalars['Int']>;
  scale?: Maybe<Array<FormsRatingScaleOption>>;
  title: Scalars['String'];
  uuid: Scalars['String'];
  withComment?: Maybe<Scalars['Boolean']>;
};

export type FormsQuestionSingleLabelInput = {
  answerType: QuestionnairesQuestionnaireQuestionAnswerTypesEnum;
  choiceOptions?: InputMaybe<Array<Scalars['String']>>;
  mandatory: Scalars['Boolean'];
  maxChoices?: InputMaybe<Scalars['Int']>;
  scale?: InputMaybe<Array<FormsRatingScaleOptionInput>>;
  title: Scalars['String'];
  uuid: Scalars['String'];
  withComment?: InputMaybe<Scalars['Boolean']>;
};

export type FormsQuestionnaireElement = {
  __typename?: 'FormsQuestionnaireElement';
  locked?: Maybe<Scalars['Boolean']>;
  metadata?: Maybe<FormsQuestionnaireElementMetadata>;
  questions: Array<FormsQuestionSingleLabel>;
  sectionTitle?: Maybe<Scalars['String']>;
  type: FormsValueObjectsQuestionnaireElementTypesEnum;
  uuid: Scalars['String'];
};

export type FormsQuestionnaireElementInput = {
  locked?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<FormsQuestionnaireElementMetadataInput>;
  questions: Array<FormsQuestionSingleLabelInput>;
  sectionTitle?: InputMaybe<Scalars['String']>;
  type: FormsValueObjectsQuestionnaireElementTypesEnum;
  uuid: Scalars['String'];
};

export type FormsQuestionnaireElementMetadata = {
  __typename?: 'FormsQuestionnaireElementMetadata';
  scoreType?: Maybe<Scalars['String']>;
};

export type FormsQuestionnaireElementMetadataInput = {
  scoreType?: InputMaybe<Scalars['String']>;
};

export type FormsRatingScaleOption = {
  __typename?: 'FormsRatingScaleOption';
  text: Scalars['String'];
  value: Scalars['Int'];
};

export type FormsRatingScaleOptionInput = {
  text: Scalars['String'];
  value: Scalars['Int'];
};

export type FormsResourceInput = {
  cycleId?: InputMaybe<Scalars['Int']>;
  resourceId: Scalars['String'];
  targets: Array<FormsTargetInput>;
};

/** Schedules */
export type FormsSchedule = {
  __typename?: 'FormsSchedule';
  active: Scalars['Boolean'];
  companyId: Scalars['String'];
  cycles: Array<FormsCycle>;
  cyclesConnection: FormsCycleConnection;
  daysToAnswer?: Maybe<Scalars['Int']>;
  form?: Maybe<FormsForm>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  formId: Scalars['String'];
  id: Scalars['String'];
  nextRunDate?: Maybe<Scalars['ISO8601DateTime']>;
  recurrenceType: FormsScheduleRecurrenceTypeEnum;
  startDate?: Maybe<Scalars['ISO8601DateTime']>;
  startTime?: Maybe<Scalars['String']>;
};


/** Schedules */
export type FormsScheduleCyclesArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};


/** Schedules */
export type FormsScheduleCyclesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Schedules */
export type FormsScheduleFormArgs = {
  formType?: InputMaybe<Array<Scalars['String']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyTemplates?: InputMaybe<Scalars['Boolean']>;
  resourceId?: InputMaybe<Scalars['String']>;
  resourceType: Scalars['String'];
  respondentId?: InputMaybe<Scalars['String']>;
  returnAnswerProgress?: Scalars['Boolean'];
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

/** The connection type for FormsSchedule. */
export type FormsScheduleConnection = {
  __typename?: 'FormsScheduleConnection';
  /** A list of edges. */
  edges: Array<FormsScheduleEdge>;
  /** A list of nodes. */
  nodes: Array<FormsSchedule>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FormsScheduleEdge = {
  __typename?: 'FormsScheduleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FormsSchedule;
};

export type FormsScheduleInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  daysToAnswer?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  recurrenceType: FormsScheduleRecurrenceTypeEnum;
  startDate?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['String']>;
};

export type FormsScheduleRecurrenceTypeEnum =
  | 'daily'
  | 'monthly'
  | 'onetime'
  | 'quarterly'
  | 'weekly'
  | 'yearly';

/** Scores */
export type FormsScore = {
  __typename?: 'FormsScore';
  denominator: Scalars['Int'];
  numerator: Scalars['Float'];
  type: Scalars['String'];
};

/** The connection type for FormsScore. */
export type FormsScoreConnection = {
  __typename?: 'FormsScoreConnection';
  /** A list of edges. */
  edges: Array<FormsScoreEdge>;
  /** A list of nodes. */
  nodes: Array<FormsScore>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FormsScoreEdge = {
  __typename?: 'FormsScoreEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FormsScore;
};

export type FormsTargetInput = {
  respondentId: Scalars['String'];
  targetId: Scalars['String'];
};

/** Test Scores */
export type FormsTestScore = {
  __typename?: 'FormsTestScore';
  companyId: Scalars['String'];
  id: Scalars['String'];
  materializedFormId: Scalars['String'];
  membershipId: Scalars['String'];
  percentage: Scalars['Float'];
};

/** The connection type for FormsTestScore. */
export type FormsTestScoreConnection = {
  __typename?: 'FormsTestScoreConnection';
  /** A list of edges. */
  edges: Array<FormsTestScoreEdge>;
  /** A list of nodes. */
  nodes: Array<FormsTestScore>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FormsTestScoreEdge = {
  __typename?: 'FormsTestScoreEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: FormsTestScore;
};

export type FormsTypeEnum =
  | 'custom'
  | 'effectiveness'
  | 'knowledge'
  | 'quiz'
  | 'satisfaction';

export type FormsValueObjectsElementTypeEnum =
  | 'date'
  | 'dropdownsingle'
  | 'longtext'
  | 'multiselect'
  | 'number'
  | 'rating'
  | 'score'
  | 'section'
  | 'select'
  | 'text'
  | 'url';

export type FormsValueObjectsQuestionnaireElementTypesEnum =
  | 'question'
  | 'section';

/** Autogenerated return type of FutureAttendanceCompanySettingsVersion. */
export type FutureAttendanceCompanySettingsVersionPayload = {
  __typename?: 'FutureAttendanceCompanySettingsVersionPayload';
  companySettingsVersion?: Maybe<AttendanceCompanySettingsVersion>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of GenerateBookkeepersmanagementPayrollCycleVariableExport. */
export type GenerateBookkeepersmanagementPayrollCycleVariableExportPayload = {
  __typename?: 'GenerateBookkeepersmanagementPayrollCycleVariableExportPayload';
  errors: Array<MutationError>;
  payrollCycleVariableExport?: Maybe<BookkeepersManagementPayrollCycleVariableExport>;
};

/** Autogenerated return type of GenerateDocumentPerformanceAgreement. */
export type GenerateDocumentPerformanceAgreementPayload = {
  __typename?: 'GenerateDocumentPerformanceAgreementPayload';
  agreement?: Maybe<PerformanceAgreement>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of GenerateDraftAtsJobPosting. */
export type GenerateDraftAtsJobPostingPayload = {
  __typename?: 'GenerateDraftAtsJobPostingPayload';
  errors: Array<MutationError>;
  jobPosting?: Maybe<AtsJobPosting>;
};

/** Autogenerated return type of GenerateElementTokenCronofyschedulingCalendarSync. */
export type GenerateElementTokenCronofyschedulingCalendarSyncPayload = {
  __typename?: 'GenerateElementTokenCronofyschedulingCalendarSyncPayload';
  calendarSync?: Maybe<CronofySchedulingCalendarSync>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of GenerateForFiltersPerformanceReviewAggregation. */
export type GenerateForFiltersPerformanceReviewAggregationPayload = {
  __typename?: 'GenerateForFiltersPerformanceReviewAggregationPayload';
  errors: Array<MutationError>;
  reviewAggregation?: Maybe<PerformanceReviewAggregation>;
};

/** Autogenerated return type of GenerateMeetingsAiSummary. */
export type GenerateMeetingsAiSummaryPayload = {
  __typename?: 'GenerateMeetingsAiSummaryPayload';
  aiSummary?: Maybe<MeetingsAiSummary>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of GenerateMeetingsChat. */
export type GenerateMeetingsChatPayload = {
  __typename?: 'GenerateMeetingsChatPayload';
  chat?: Maybe<MeetingsChat>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of GenerateMeetingsGoldLayer. */
export type GenerateMeetingsGoldLayerPayload = {
  __typename?: 'GenerateMeetingsGoldLayerPayload';
  errors: Array<MutationError>;
  goldLayer?: Maybe<MeetingsGoldLayer>;
};

/** Autogenerated return type of GenerateMeetingsLiveCompanion. */
export type GenerateMeetingsLiveCompanionPayload = {
  __typename?: 'GenerateMeetingsLiveCompanionPayload';
  errors: Array<MutationError>;
  liveCompanion?: Maybe<MeetingsLiveCompanion>;
};

/** Autogenerated return type of GeneratePdfFinanceQuotePdf. */
export type GeneratePdfFinanceQuotePdfPayload = {
  __typename?: 'GeneratePdfFinanceQuotePdfPayload';
  errors: Array<MutationError>;
  quotePdf?: Maybe<FinanceQuotePdf>;
};

export type GeneratePerformanceReviewAggregationAccessProcessPairsInput = {
  accessId: Scalars['Int'];
  reviewProcessId: Scalars['Int'];
};

/** Autogenerated return type of GeneratePerformanceReviewAggregation. */
export type GeneratePerformanceReviewAggregationPayload = {
  __typename?: 'GeneratePerformanceReviewAggregationPayload';
  errors: Array<MutationError>;
  reviewAggregation?: Maybe<PerformanceReviewAggregation>;
};

/** Autogenerated return type of GeneratePreviewDocumentsDocument. */
export type GeneratePreviewDocumentsDocumentPayload = {
  __typename?: 'GeneratePreviewDocumentsDocumentPayload';
  document?: Maybe<DocumentsDocument>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of GenerateScheduleShiftmanagementAutomation. */
export type GenerateScheduleShiftmanagementAutomationPayload = {
  __typename?: 'GenerateScheduleShiftmanagementAutomationPayload';
  automation?: Maybe<ShiftManagementAutomation>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of GetBankingTransactionImportTemplate. */
export type GetBankingTransactionImportTemplatePayload = {
  __typename?: 'GetBankingTransactionImportTemplatePayload';
  errors: Array<MutationError>;
  transactionImportTemplate?: Maybe<BankingTransactionImportTemplate>;
};

/** Autogenerated return type of GetFinanceContactImportTemplate. */
export type GetFinanceContactImportTemplatePayload = {
  __typename?: 'GetFinanceContactImportTemplatePayload';
  contactImportTemplate?: Maybe<FinanceContactImportTemplate>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of GetOrCreateFromTemplateMeetingsMeeting. */
export type GetOrCreateFromTemplateMeetingsMeetingPayload = {
  __typename?: 'GetOrCreateFromTemplateMeetingsMeetingPayload';
  errors: Array<MutationError>;
  meeting?: Maybe<MeetingsMeeting>;
};

/** Autogenerated return type of GetOrCreateMeetingsRoom. */
export type GetOrCreateMeetingsRoomPayload = {
  __typename?: 'GetOrCreateMeetingsRoomPayload';
  errors: Array<MutationError>;
  room?: Maybe<MeetingsRoom>;
};

/** Autogenerated return type of GetProjectmanagementimporterProjectsTemplate. */
export type GetProjectmanagementimporterProjectsTemplatePayload = {
  __typename?: 'GetProjectmanagementimporterProjectsTemplatePayload';
  errors: Array<MutationError>;
  projectsTemplate?: Maybe<ProjectManagementImporterProjectsTemplate>;
};

export type GoalsAgreementDetailsInput = {
  performanceAgreementActionItemUuid?: InputMaybe<Scalars['String']>;
  performanceAgreementId: Scalars['String'];
};

export type GoalsContextlessPolicies = {
  __typename?: 'GoalsContextlessPolicies';
  createMetricGroup: ContextlessPolicyResolution;
  sidebarSeePerformanceGoalsV2SubLevelItem: ContextlessPolicyResolution;
};

/** Employees in Goals domain */
export type GoalsEmployee = {
  __typename?: 'GoalsEmployee';
  _policies?: Maybe<GoalsEmployeePolicies>;
  _policiesCollection?: Maybe<Array<PermissionsPolicyResolution>>;
  _policiesConnection: PermissionsPolicyResolutionConnection;
  employee?: Maybe<EmployeesEmployee>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  employeeId: Scalars['Int'];
  fullName: Scalars['String'];
  id: Scalars['Int'];
  metricSummary?: Maybe<GoalsMetricSummary>;
  metrics: Array<GoalsMetric>;
  metricsConnection: GoalsMetricConnection;
  progresses: Array<GoalsEmployeeCycleProgress>;
  progressesConnection: GoalsEmployeeCycleProgressConnection;
};


/** Employees in Goals domain */
export type GoalsEmployee_PoliciesCollectionArgs = {
  ids: Array<GoalsEmployeePoliciesEnum>;
};


/** Employees in Goals domain */
export type GoalsEmployee_PoliciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Employees in Goals domain */
export type GoalsEmployeeEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Employees in Goals domain */
export type GoalsEmployeeMetricsArgs = {
  groupIds?: InputMaybe<Array<Scalars['String']>>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  performanceAgreementIds?: InputMaybe<Array<Scalars['String']>>;
};


/** Employees in Goals domain */
export type GoalsEmployeeMetricsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  groupIds?: InputMaybe<Array<Scalars['String']>>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  performanceAgreementIds?: InputMaybe<Array<Scalars['String']>>;
  sortOrder?: InputMaybe<Sort>;
};


/** Employees in Goals domain */
export type GoalsEmployeeProgressesArgs = {
  cycleIds?: InputMaybe<Array<Scalars['String']>>;
  ids?: InputMaybe<Array<Scalars['String']>>;
};


/** Employees in Goals domain */
export type GoalsEmployeeProgressesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  cycleIds?: InputMaybe<Array<Scalars['String']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for GoalsEmployee. */
export type GoalsEmployeeConnection = {
  __typename?: 'GoalsEmployeeConnection';
  /** A list of edges. */
  edges: Array<GoalsEmployeeEdge>;
  /** A list of nodes. */
  nodes: Array<GoalsEmployee>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** Goal Employee Cycle Progress */
export type GoalsEmployeeCycleProgress = {
  __typename?: 'GoalsEmployeeCycleProgress';
  _policies?: Maybe<GoalsEmployeeCycleProgressPolicies>;
  _policiesCollection?: Maybe<Array<PermissionsPolicyResolution>>;
  _policiesConnection: PermissionsPolicyResolutionConnection;
  cycleId: Scalars['String'];
  employeeId: Scalars['Int'];
  id: Scalars['String'];
  needsAttention: Scalars['Boolean'];
  progress: Scalars['Int'];
  weights: Array<GoalsMetricGroupWeight>;
  weightsConnection: GoalsMetricGroupWeightConnection;
};


/** Goal Employee Cycle Progress */
export type GoalsEmployeeCycleProgress_PoliciesCollectionArgs = {
  ids: Array<GoalsEmployeeCycleProgressPoliciesEnum>;
};


/** Goal Employee Cycle Progress */
export type GoalsEmployeeCycleProgress_PoliciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Goal Employee Cycle Progress */
export type GoalsEmployeeCycleProgressWeightsArgs = {
  cycleIds?: InputMaybe<Array<Scalars['String']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  metricGroupIds?: InputMaybe<Array<Scalars['String']>>;
};


/** Goal Employee Cycle Progress */
export type GoalsEmployeeCycleProgressWeightsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  cycleIds?: InputMaybe<Array<Scalars['String']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  metricGroupIds?: InputMaybe<Array<Scalars['String']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for GoalsEmployeeCycleProgress. */
export type GoalsEmployeeCycleProgressConnection = {
  __typename?: 'GoalsEmployeeCycleProgressConnection';
  /** A list of edges. */
  edges: Array<GoalsEmployeeCycleProgressEdge>;
  /** A list of nodes. */
  nodes: Array<GoalsEmployeeCycleProgress>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type GoalsEmployeeCycleProgressEdge = {
  __typename?: 'GoalsEmployeeCycleProgressEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: GoalsEmployeeCycleProgress;
};

export type GoalsEmployeeCycleProgressPolicies = {
  __typename?: 'GoalsEmployeeCycleProgressPolicies';
  upsertWeights: PermissionsPolicyResolution;
};

export type GoalsEmployeeCycleProgressPoliciesEnum =
  | 'upsert_weights';

/** An edge in a connection. */
export type GoalsEmployeeEdge = {
  __typename?: 'GoalsEmployeeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: GoalsEmployee;
};

/** the filter for the employees resource */
export type GoalsEmployeeFilter = {
  id?: InputMaybe<IntegerFilter>;
  or?: InputMaybe<Array<GoalsEmployeeFilterConditions>>;
};

export type GoalsEmployeeFilterConditions = {
  id?: InputMaybe<IntegerFilter>;
};

export type GoalsEmployeePolicies = {
  __typename?: 'GoalsEmployeePolicies';
  createMetric: PermissionsPolicyResolution;
};

export type GoalsEmployeePoliciesEnum =
  | 'create_metric';

/** Goal Metrics */
export type GoalsMetric = {
  __typename?: 'GoalsMetric';
  _policies?: Maybe<GoalsMetricPolicies>;
  _policiesCollection?: Maybe<Array<PermissionsPolicyResolution>>;
  _policiesConnection: PermissionsPolicyResolutionConnection;
  assignee?: Maybe<EmployeesEmployee>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  assigneeId: Scalars['Int'];
  author?: Maybe<EmployeesEmployee>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  authorId: Scalars['Int'];
  endOn: Scalars['ISO8601Date'];
  expectedProgress: Scalars['Int'];
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  groupId?: Maybe<Scalars['String']>;
  history: Array<GoalsMetricValue>;
  historyConnection: GoalsMetricValueConnection;
  id: Scalars['String'];
  metricGroup?: Maybe<GoalsMetricGroup>;
  performanceAgreement?: Maybe<PerformanceAgreement>;
  performanceAgreementActionItemUuid?: Maybe<Scalars['String']>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  performanceAgreementId?: Maybe<Scalars['String']>;
  progressAssessmentStatus: GoalsValueObjectsMetricProgressAssessmentProgressStatusEnum;
  progressPercentageValue: Scalars['Int'];
  qualitativeValue?: Maybe<GoalsMetricValueStatusEnum>;
  quantitativeValue?: Maybe<GoalsQuantitativeValue>;
  startOn: Scalars['ISO8601Date'];
  title: Scalars['String'];
  type: GoalsMetricTypeEnum;
};


/** Goal Metrics */
export type GoalsMetric_PoliciesCollectionArgs = {
  ids: Array<GoalsMetricPoliciesEnum>;
};


/** Goal Metrics */
export type GoalsMetric_PoliciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Goal Metrics */
export type GoalsMetricAssigneeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Goal Metrics */
export type GoalsMetricAuthorArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Goal Metrics */
export type GoalsMetricHistoryArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};


/** Goal Metrics */
export type GoalsMetricHistoryConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Goal Metrics */
export type GoalsMetricMetricGroupArgs = {
  assigneeIds?: InputMaybe<Array<Scalars['Int']>>;
  cycleIds?: InputMaybe<Array<Scalars['String']>>;
  forMetricsAssignment?: InputMaybe<Scalars['Boolean']>;
  noCycle?: InputMaybe<Scalars['Boolean']>;
  public?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};


/** Goal Metrics */
export type GoalsMetricPerformanceAgreementArgs = {
  materializedProcessTargetIds?: InputMaybe<Array<Scalars['Int']>>;
  processIds?: InputMaybe<Array<Scalars['Int']>>;
  targetIds?: InputMaybe<Array<Scalars['String']>>;
};

/** The connection type for GoalsMetric. */
export type GoalsMetricConnection = {
  __typename?: 'GoalsMetricConnection';
  /** A list of edges. */
  edges: Array<GoalsMetricEdge>;
  /** A list of nodes. */
  nodes: Array<GoalsMetric>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type GoalsMetricEdge = {
  __typename?: 'GoalsMetricEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: GoalsMetric;
};

/** the filter for the metrics resource */
export type GoalsMetricFilter = {
  or?: InputMaybe<Array<GoalsMetricFilterConditions>>;
  title?: InputMaybe<StringFilter>;
};

export type GoalsMetricFilterConditions = {
  title?: InputMaybe<StringFilter>;
};

/** Goal Metric Groups */
export type GoalsMetricGroup = {
  __typename?: 'GoalsMetricGroup';
  _policies?: Maybe<GoalsMetricGroupPolicies>;
  _policiesCollection?: Maybe<Array<PermissionsPolicyResolution>>;
  _policiesConnection: PermissionsPolicyResolutionConnection;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  assigneeIds: Array<Scalars['Int']>;
  assignees: Array<EmployeesEmployee>;
  assigneesConnection: EmployeesEmployeeConnection;
  author?: Maybe<EmployeesEmployee>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  authorId: Scalars['Int'];
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  cycleIds?: Maybe<Array<Scalars['String']>>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  metricGroupWeights: Array<GoalsMetricGroupWeight>;
  metricGroupWeightsConnection: GoalsMetricGroupWeightConnection;
  metrics: Array<GoalsMetric>;
  metricsConnection: GoalsMetricConnection;
  performanceCycles: Array<PerformanceCyclesCycle>;
  performanceCyclesConnection: PerformanceCyclesCycleConnection;
  public: Scalars['Boolean'];
  summary?: Maybe<GoalsMetricSummary>;
  title: Scalars['String'];
};


/** Goal Metric Groups */
export type GoalsMetricGroup_PoliciesCollectionArgs = {
  ids: Array<GoalsMetricGroupPoliciesEnum>;
};


/** Goal Metric Groups */
export type GoalsMetricGroup_PoliciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Goal Metric Groups */
export type GoalsMetricGroupAssigneesArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Goal Metric Groups */
export type GoalsMetricGroupAssigneesConnectionArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  after?: InputMaybe<Scalars['String']>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Sort>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Goal Metric Groups */
export type GoalsMetricGroupAuthorArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Goal Metric Groups */
export type GoalsMetricGroupMetricGroupWeightsArgs = {
  cycleIds?: InputMaybe<Array<Scalars['String']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  progressIds?: InputMaybe<Array<Scalars['String']>>;
};


/** Goal Metric Groups */
export type GoalsMetricGroupMetricGroupWeightsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  cycleIds?: InputMaybe<Array<Scalars['String']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  progressIds?: InputMaybe<Array<Scalars['String']>>;
  sortOrder?: InputMaybe<Sort>;
};


/** Goal Metric Groups */
export type GoalsMetricGroupMetricsArgs = {
  assigneeIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  performanceAgreementIds?: InputMaybe<Array<Scalars['String']>>;
};


/** Goal Metric Groups */
export type GoalsMetricGroupMetricsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  assigneeIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  performanceAgreementIds?: InputMaybe<Array<Scalars['String']>>;
  sortOrder?: InputMaybe<Sort>;
};


/** Goal Metric Groups */
export type GoalsMetricGroupPerformanceCyclesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for GoalsMetricGroup. */
export type GoalsMetricGroupConnection = {
  __typename?: 'GoalsMetricGroupConnection';
  /** A list of edges. */
  edges: Array<GoalsMetricGroupEdge>;
  /** A list of nodes. */
  nodes: Array<GoalsMetricGroup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type GoalsMetricGroupEdge = {
  __typename?: 'GoalsMetricGroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: GoalsMetricGroup;
};

/** the filter for the metric_groups resource */
export type GoalsMetricGroupFilter = {
  or?: InputMaybe<Array<GoalsMetricGroupFilterConditions>>;
  title?: InputMaybe<StringFilter>;
};

export type GoalsMetricGroupFilterConditions = {
  title?: InputMaybe<StringFilter>;
};

export type GoalsMetricGroupPolicies = {
  __typename?: 'GoalsMetricGroupPolicies';
  createMetric: PermissionsPolicyResolution;
  delete: PermissionsPolicyResolution;
  update: PermissionsPolicyResolution;
};

export type GoalsMetricGroupPoliciesEnum =
  | 'create_metric'
  | 'delete'
  | 'update';

/** Goal Metric Group Weight */
export type GoalsMetricGroupWeight = {
  __typename?: 'GoalsMetricGroupWeight';
  cycleId: Scalars['String'];
  employeeId: Scalars['Int'];
  id: Scalars['String'];
  metricGroup?: Maybe<GoalsMetricGroup>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  metricGroupId: Scalars['String'];
  progressId: Scalars['String'];
  weight: Scalars['Float'];
};


/** Goal Metric Group Weight */
export type GoalsMetricGroupWeightMetricGroupArgs = {
  assigneeIds?: InputMaybe<Array<Scalars['Int']>>;
  cycleIds?: InputMaybe<Array<Scalars['String']>>;
  forMetricsAssignment?: InputMaybe<Scalars['Boolean']>;
  noCycle?: InputMaybe<Scalars['Boolean']>;
  public?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};

/** The connection type for GoalsMetricGroupWeight. */
export type GoalsMetricGroupWeightConnection = {
  __typename?: 'GoalsMetricGroupWeightConnection';
  /** A list of edges. */
  edges: Array<GoalsMetricGroupWeightEdge>;
  /** A list of nodes. */
  nodes: Array<GoalsMetricGroupWeight>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type GoalsMetricGroupWeightEdge = {
  __typename?: 'GoalsMetricGroupWeightEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: GoalsMetricGroupWeight;
};

export type GoalsMetricPolicies = {
  __typename?: 'GoalsMetricPolicies';
  delete: PermissionsPolicyResolution;
  update: PermissionsPolicyResolution;
  updateQualitativeCurrentStatus: PermissionsPolicyResolution;
  updateQuantitativeCurrentValue: PermissionsPolicyResolution;
};

export type GoalsMetricPoliciesEnum =
  | 'delete'
  | 'update'
  | 'update_qualitative_current_status'
  | 'update_quantitative_current_value';

export type GoalsMetricSummary = {
  __typename?: 'GoalsMetricSummary';
  averageProgress: Scalars['Int'];
  metricsCount: Scalars['Int'];
  needsAttention: Scalars['Boolean'];
};

export type GoalsMetricTypeEnum =
  | 'qualitative'
  | 'quantitative';

/** Goal Metric Values */
export type GoalsMetricValue = {
  __typename?: 'GoalsMetricValue';
  author?: Maybe<EmployeesEmployee>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  authorId: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['String'];
  metric?: Maybe<GoalsMetric>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  metricId: Scalars['String'];
  qualitativeValue?: Maybe<GoalsMetricValueStatusEnum>;
  quantitativeValue?: Maybe<GoalsQuantitativeValue>;
};


/** Goal Metric Values */
export type GoalsMetricValueAuthorArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Goal Metric Values */
export type GoalsMetricValueMetricArgs = {
  assigneeIds?: InputMaybe<Array<Scalars['Int']>>;
  groupIds?: InputMaybe<Array<Scalars['String']>>;
  performanceAgreementIds?: InputMaybe<Array<Scalars['String']>>;
};

/** The connection type for GoalsMetricValue. */
export type GoalsMetricValueConnection = {
  __typename?: 'GoalsMetricValueConnection';
  /** A list of edges. */
  edges: Array<GoalsMetricValueEdge>;
  /** A list of nodes. */
  nodes: Array<GoalsMetricValue>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type GoalsMetricValueEdge = {
  __typename?: 'GoalsMetricValueEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: GoalsMetricValue;
};

export type GoalsMetricValueStatusEnum =
  | 'achieved'
  | 'not_achieved'
  | 'over_achieved';

export type GoalsQuantitativeValue = {
  __typename?: 'GoalsQuantitativeValue';
  currentValue: Scalars['Float'];
  startValue: Scalars['Float'];
  targetValue: Scalars['Float'];
};

export type GoalsQuantitativeValueInput = {
  currentValue: Scalars['Float'];
  startValue: Scalars['Float'];
  targetValue: Scalars['Float'];
};

export type GoalsValueObjectsMetricProgressAssessmentProgressStatusEnum =
  | 'achieved'
  | 'at_risk'
  | 'highly_at_risk'
  | 'not_achieved'
  | 'not_started'
  | 'on_track'
  | 'over_achieved'
  | 'unknown';

export type GroupByDateFieldsPeriods =
  /** Group by days */
  | 'day'
  /** Group by months */
  | 'month'
  /** Group by quarters */
  | 'quarter'
  /** Group by weeks */
  | 'week'
  /** Group by years */
  | 'year';

export type HandbookPagesContextlessPolicies = {
  __typename?: 'HandbookPagesContextlessPolicies';
  editHandbookPages: ContextlessPolicyResolution;
  seeHandbookPages: ContextlessPolicyResolution;
};

/** Repository for handbook folder categories */
export type HandbookPagesFolder = {
  __typename?: 'HandbookPagesFolder';
  description: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  numberOfItems: Scalars['Int'];
  slug: Scalars['String'];
};

/** The connection type for HandbookPagesFolder. */
export type HandbookPagesFolderConnection = {
  __typename?: 'HandbookPagesFolderConnection';
  /** A list of edges. */
  edges: Array<HandbookPagesFolderEdge>;
  /** A list of nodes. */
  nodes: Array<HandbookPagesFolder>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type HandbookPagesFolderEdge = {
  __typename?: 'HandbookPagesFolderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: HandbookPagesFolder;
};

/** the filter for the folders resource */
export type HandbookPagesFolderFilter = {
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  numberOfItems?: InputMaybe<IntegerFilter>;
  or?: InputMaybe<Array<HandbookPagesFolderFilterConditions>>;
  slug?: InputMaybe<StringFilter>;
};

export type HandbookPagesFolderFilterConditions = {
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  numberOfItems?: InputMaybe<IntegerFilter>;
  slug?: InputMaybe<StringFilter>;
};

/** Repository for importing PDF documents into handbook pages */
export type HandbookPagesImport = {
  __typename?: 'HandbookPagesImport';
  error?: Maybe<Scalars['String']>;
  page?: Maybe<HandbookPagesPage>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  pageId?: Maybe<Scalars['Int']>;
  success: Scalars['Boolean'];
};


/** Repository for importing PDF documents into handbook pages */
export type HandbookPagesImportPageArgs = {
  folderType?: InputMaybe<Scalars['String']>;
  ownerId?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  visibility?: InputMaybe<Scalars['String']>;
};

/** Repository for handbook pages */
export type HandbookPagesPage = {
  __typename?: 'HandbookPagesPage';
  company?: Maybe<CompaniesCompany>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  companyId: Scalars['Int'];
  content?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  createdByEmployee?: Maybe<EmployeesEmployee>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  createdByEmployeeId: Scalars['Int'];
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
  firstPublishedAt?: Maybe<Scalars['ISO8601DateTime']>;
  folderType: HandbookPagesValueObjectsFolderCategoryEnum;
  id: Scalars['Int'];
  lastPublishedAt?: Maybe<Scalars['ISO8601DateTime']>;
  lastPublishedByEmployeeId?: Maybe<Scalars['Int']>;
  latestPublishedVersion: Scalars['Int'];
  owner?: Maybe<EmployeesEmployee>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  ownerId: Scalars['Int'];
  status: HandbookPagesValueObjectsPageStatusEnum;
  title: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
  updatedByEmployee?: Maybe<EmployeesEmployee>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  updatedByEmployeeId: Scalars['Int'];
  visibility: HandbookPagesValueObjectsVisibilityEnum;
};


/** Repository for handbook pages */
export type HandbookPagesPageCompanyArgs = {
  forBookkeepers?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};


/** Repository for handbook pages */
export type HandbookPagesPageCreatedByEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Repository for handbook pages */
export type HandbookPagesPageOwnerArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Repository for handbook pages */
export type HandbookPagesPageUpdatedByEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for HandbookPagesPage. */
export type HandbookPagesPageConnection = {
  __typename?: 'HandbookPagesPageConnection';
  /** A list of edges. */
  edges: Array<HandbookPagesPageEdge>;
  /** A list of nodes. */
  nodes: Array<HandbookPagesPage>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type HandbookPagesPageEdge = {
  __typename?: 'HandbookPagesPageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: HandbookPagesPage;
};

/** the filter for the pages resource */
export type HandbookPagesPageFilter = {
  content?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeFilter>;
  folderType?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntegerFilter>;
  or?: InputMaybe<Array<HandbookPagesPageFilterConditions>>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  visibility?: InputMaybe<StringFilter>;
};

export type HandbookPagesPageFilterConditions = {
  content?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeFilter>;
  folderType?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntegerFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  visibility?: InputMaybe<StringFilter>;
};

/** Repository for handbook page versions */
export type HandbookPagesPageVersion = {
  __typename?: 'HandbookPagesPageVersion';
  content?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  createdByEmployee?: Maybe<EmployeesEmployee>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  createdByEmployeeId: Scalars['Int'];
  id: Scalars['Int'];
  page?: Maybe<HandbookPagesPage>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  pageId: Scalars['Int'];
  publishedAt: Scalars['ISO8601DateTime'];
  publishedByEmployee?: Maybe<EmployeesEmployee>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  publishedByEmployeeId: Scalars['Int'];
  title: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
  versionNumber: Scalars['Int'];
  visibility: Scalars['String'];
};


/** Repository for handbook page versions */
export type HandbookPagesPageVersionCreatedByEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Repository for handbook page versions */
export type HandbookPagesPageVersionPageArgs = {
  folderType?: InputMaybe<Scalars['String']>;
  ownerId?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  visibility?: InputMaybe<Scalars['String']>;
};


/** Repository for handbook page versions */
export type HandbookPagesPageVersionPublishedByEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for HandbookPagesPageVersion. */
export type HandbookPagesPageVersionConnection = {
  __typename?: 'HandbookPagesPageVersionConnection';
  /** A list of edges. */
  edges: Array<HandbookPagesPageVersionEdge>;
  /** A list of nodes. */
  nodes: Array<HandbookPagesPageVersion>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type HandbookPagesPageVersionEdge = {
  __typename?: 'HandbookPagesPageVersionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: HandbookPagesPageVersion;
};

/** the filter for the page_versions resource */
export type HandbookPagesPageVersionFilter = {
  content?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntegerFilter>;
  or?: InputMaybe<Array<HandbookPagesPageVersionFilterConditions>>;
  pageId?: InputMaybe<IntegerFilter>;
  publishedAt?: InputMaybe<DateTimeFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  versionNumber?: InputMaybe<IntegerFilter>;
  visibility?: InputMaybe<StringFilter>;
};

export type HandbookPagesPageVersionFilterConditions = {
  content?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntegerFilter>;
  pageId?: InputMaybe<IntegerFilter>;
  publishedAt?: InputMaybe<DateTimeFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  versionNumber?: InputMaybe<IntegerFilter>;
  visibility?: InputMaybe<StringFilter>;
};

export type HandbookPagesValueObjectsFolderCategoryEnum =
  | 'benefits'
  | 'expenses'
  | 'legal'
  | 'people'
  | 'travel'
  | 'workplace';

export type HandbookPagesValueObjectsPageStatusEnum =
  | 'draft'
  | 'published';

export type HandbookPagesValueObjectsVisibilityEnum =
  | 'company'
  | 'private';

export type HandoffsValueObjectsSourceTypeEnum =
  | 'attendance_compensation'
  | 'benefits_benefitcompensation'
  | 'expenses_expensable'
  | 'expenses_expense'
  | 'expenses_mileage'
  | 'timesettings_customtimerangecategory';

/** Tax residence */
export type HiringVersionsTaxResidence = {
  __typename?: 'HiringVersionsTaxResidence';
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  cityOfBirth?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  countryOfBirth?: Maybe<Scalars['String']>;
  employeeId: Scalars['Int'];
  id: Scalars['Int'];
  identifier?: Maybe<Scalars['String']>;
  isResident: Scalars['Boolean'];
  noResidentEndDate?: Maybe<Scalars['ISO8601Date']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

/** The connection type for HiringVersionsTaxResidence. */
export type HiringVersionsTaxResidenceConnection = {
  __typename?: 'HiringVersionsTaxResidenceConnection';
  /** A list of edges. */
  edges: Array<HiringVersionsTaxResidenceEdge>;
  /** A list of nodes. */
  nodes: Array<HiringVersionsTaxResidence>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type HiringVersionsTaxResidenceEdge = {
  __typename?: 'HiringVersionsTaxResidenceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: HiringVersionsTaxResidence;
};

/** Company holidays */
export type HolidaysCompanyHoliday = {
  __typename?: 'HolidaysCompanyHoliday';
  /** Company holiday date */
  date: Scalars['ISO8601Date'];
  /** Company holiday description */
  description?: Maybe<Scalars['String']>;
  /** If the company holiday is half-day and which part of the day */
  halfDay?: Maybe<HolidaysCompanyHolidayHalfDayTypesEnum>;
  /** Company holiday id */
  id: Scalars['Int'];
  location?: Maybe<LocationsLocation>;
  /**
   * Related location id
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  locationId: Scalars['Int'];
  /** Company holiday summary */
  summary?: Maybe<Scalars['String']>;
};


/** Company holidays */
export type HolidaysCompanyHolidayLocationArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  main?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};

/** The connection type for HolidaysCompanyHoliday. */
export type HolidaysCompanyHolidayConnection = {
  __typename?: 'HolidaysCompanyHolidayConnection';
  /** A list of edges. */
  edges: Array<HolidaysCompanyHolidayEdge>;
  /** A list of nodes. */
  nodes: Array<HolidaysCompanyHoliday>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type HolidaysCompanyHolidayEdge = {
  __typename?: 'HolidaysCompanyHolidayEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: HolidaysCompanyHoliday;
};

/** the filter for the company_holidays resource */
export type HolidaysCompanyHolidayFilter = {
  date?: InputMaybe<DateFilter>;
  or?: InputMaybe<Array<HolidaysCompanyHolidayFilterConditions>>;
};

export type HolidaysCompanyHolidayFilterConditions = {
  date?: InputMaybe<DateFilter>;
};

export type HolidaysCompanyHolidayHalfDayTypesEnum =
  | 'beginning_of_day'
  | 'end_of_day';

/** Autogenerated return type of ImportBankingTransactionImportResult. */
export type ImportBankingTransactionImportResultPayload = {
  __typename?: 'ImportBankingTransactionImportResultPayload';
  errors: Array<MutationError>;
  transactionImportResult?: Maybe<BankingTransactionImportResult>;
};

/** Autogenerated return type of ImportCsvMeetingsImport. */
export type ImportCsvMeetingsImportPayload = {
  __typename?: 'ImportCsvMeetingsImportPayload';
  errors: Array<MutationError>;
  import?: Maybe<MeetingsImport>;
};

/** Autogenerated return type of ImportFinanceAccountingAccountImport. */
export type ImportFinanceAccountingAccountImportPayload = {
  __typename?: 'ImportFinanceAccountingAccountImportPayload';
  accountImport?: Maybe<FinanceAccountImport>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of ImportFinanceContactsImportResult. */
export type ImportFinanceContactsImportResultPayload = {
  __typename?: 'ImportFinanceContactsImportResultPayload';
  contactsImportResult?: Maybe<FinanceContactsImportResult>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of ImportFinanceCostCenterMembershipImport. */
export type ImportFinanceCostCenterMembershipImportPayload = {
  __typename?: 'ImportFinanceCostCenterMembershipImportPayload';
  costCenterMembershipImport?: Maybe<FinanceCostCenterMembershipImport>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of ImportFinanceCustomDimensionMembership. */
export type ImportFinanceCustomDimensionMembershipPayload = {
  __typename?: 'ImportFinanceCustomDimensionMembershipPayload';
  customDimensionMemberships?: Maybe<Array<FinanceCustomDimensionMembership>>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of ImportItmanagementItAsset. */
export type ImportItmanagementItAssetPayload = {
  __typename?: 'ImportItmanagementItAssetPayload';
  errors: Array<MutationError>;
  itAsset?: Maybe<ItManagementItAsset>;
};

/** Autogenerated return type of ImportPdfHandbookpagesImport. */
export type ImportPdfHandbookpagesImportPayload = {
  __typename?: 'ImportPdfHandbookpagesImportPayload';
  errors: Array<MutationError>;
  import?: Maybe<HandbookPagesImport>;
};

/** Importers importer activity */
export type ImportersImporterActivity = {
  __typename?: 'ImportersImporterActivity';
  accessId: Scalars['Int'];
  companyId: Scalars['Int'];
  fileHash?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  importerProcess?: Maybe<ImportersImporterProcess>;
  importerProcessUuid?: Maybe<Scalars['String']>;
  importerUuid: Scalars['String'];
  state: Scalars['String'];
  templateId?: Maybe<Scalars['String']>;
  templateVersion?: Maybe<Scalars['String']>;
};


/** Importers importer activity */
export type ImportersImporterActivityImporterProcessArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  importerUuid?: InputMaybe<Scalars['String']>;
  legalEntityId?: InputMaybe<Scalars['String']>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** The connection type for ImportersImporterActivity. */
export type ImportersImporterActivityConnection = {
  __typename?: 'ImportersImporterActivityConnection';
  /** A list of edges. */
  edges: Array<ImportersImporterActivityEdge>;
  /** A list of nodes. */
  nodes: Array<ImportersImporterActivity>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ImportersImporterActivityEdge = {
  __typename?: 'ImportersImporterActivityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ImportersImporterActivity;
};

/** Importers importer process */
export type ImportersImporterProcess = {
  __typename?: 'ImportersImporterProcess';
  activities: Array<ImportersImporterActivity>;
  activitiesConnection: ImportersImporterActivityConnection;
  fileHash?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  importerUuid?: Maybe<Scalars['String']>;
  itemsCreated?: Maybe<Scalars['Int']>;
  itemsToBeCreated?: Maybe<Scalars['Int']>;
  legalEntityId?: Maybe<Scalars['String']>;
  totalItems?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  uuid: Scalars['String'];
};


/** Importers importer process */
export type ImportersImporterProcessActivitiesArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  fileHash?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  importerUuid?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  templateId?: InputMaybe<Scalars['String']>;
  templateVersion?: InputMaybe<Scalars['String']>;
};


/** Importers importer process */
export type ImportersImporterProcessActivitiesConnectionArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  fileHash?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  importerUuid?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  state?: InputMaybe<Scalars['String']>;
  templateId?: InputMaybe<Scalars['String']>;
  templateVersion?: InputMaybe<Scalars['String']>;
};

/** The connection type for ImportersImporterProcess. */
export type ImportersImporterProcessConnection = {
  __typename?: 'ImportersImporterProcessConnection';
  /** A list of edges. */
  edges: Array<ImportersImporterProcessEdge>;
  /** A list of nodes. */
  nodes: Array<ImportersImporterProcess>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ImportersImporterProcessEdge = {
  __typename?: 'ImportersImporterProcessEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ImportersImporterProcess;
};

/** importer_process_file_content */
export type ImportersImporterProcessFileContent = {
  __typename?: 'ImportersImporterProcessFileContent';
  headers: Array<Scalars['String']>;
  rows: Array<ImportersImporterProcessFileRow>;
};

/** The connection type for ImportersImporterProcessFileContent. */
export type ImportersImporterProcessFileContentConnection = {
  __typename?: 'ImportersImporterProcessFileContentConnection';
  /** A list of edges. */
  edges: Array<ImportersImporterProcessFileContentEdge>;
  /** A list of nodes. */
  nodes: Array<ImportersImporterProcessFileContent>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ImportersImporterProcessFileContentEdge = {
  __typename?: 'ImportersImporterProcessFileContentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ImportersImporterProcessFileContent;
};

export type ImportersImporterProcessFileRow = {
  __typename?: 'ImportersImporterProcessFileRow';
  row: Array<Scalars['String']>;
};

export type InAppCommsBanner = {
  __typename?: 'InAppCommsBanner';
  backgroundColor?: Maybe<Scalars['String']>;
  buttons: Array<InAppCommsButton>;
  countdown?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type InAppCommsButton = {
  __typename?: 'InAppCommsButton';
  closeComponent?: Maybe<Scalars['Boolean']>;
  conditionalOptions?: Maybe<Array<InAppCommsConditionalOption>>;
  defaultSubmit?: Maybe<Scalars['Boolean']>;
  featureRequested?: Maybe<Scalars['String']>;
  isInternalLink?: Maybe<Scalars['Boolean']>;
  link?: Maybe<Scalars['String']>;
  moduleRequested?: Maybe<Scalars['String']>;
  moreInfoUrl?: Maybe<Scalars['String']>;
  openInNewTab?: Maybe<Scalars['Boolean']>;
  requestReason?: Maybe<Scalars['String']>;
  requestSource?: Maybe<Scalars['String']>;
  text: Scalars['String'];
  type: Scalars['String'];
};

export type InAppCommsCardLink = {
  __typename?: 'InAppCommsCardLink';
  isInternalLink: Scalars['Boolean'];
  label?: Maybe<Scalars['String']>;
  link: Scalars['String'];
  openInNewTab: Scalars['Boolean'];
};

/** in app communications module */
export type InAppCommsCommunication = {
  __typename?: 'InAppCommsCommunication';
  content: InAppCommsContent;
  id: Scalars['String'];
  name: Scalars['String'];
  onClose: InAppCommsOnClose;
  onPath: Array<Scalars['String']>;
  schedule: InAppCommsSchedule;
  type: Scalars['String'];
};

/** The connection type for InAppCommsCommunication. */
export type InAppCommsCommunicationConnection = {
  __typename?: 'InAppCommsCommunicationConnection';
  /** A list of edges. */
  edges: Array<InAppCommsCommunicationEdge>;
  /** A list of nodes. */
  nodes: Array<InAppCommsCommunication>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type InAppCommsCommunicationEdge = {
  __typename?: 'InAppCommsCommunicationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: InAppCommsCommunication;
};

export type InAppCommsConditionalOption = {
  __typename?: 'InAppCommsConditionalOption';
  conditionalGoTo: Scalars['String'];
  conditionalIf: Scalars['String'];
};

export type InAppCommsContent = {
  __typename?: 'InAppCommsContent';
  banner?: Maybe<InAppCommsBanner>;
  form?: Maybe<InAppCommsForm>;
  modal?: Maybe<InAppCommsModal>;
  sidebarCard?: Maybe<InAppCommsSidebarCard>;
};

export type InAppCommsContextlessPolicies = {
  __typename?: 'InAppCommsContextlessPolicies';
  canSeeInAppComms: ContextlessPolicyResolution;
};

export type InAppCommsForm = {
  __typename?: 'InAppCommsForm';
  moduleIcon?: Maybe<Scalars['String']>;
  steps: Array<InAppCommsFormStep>;
};

export type InAppCommsFormStep = {
  __typename?: 'InAppCommsFormStep';
  buttons: Array<InAppCommsButton>;
  options: Scalars['String'];
  stepId: Scalars['String'];
  text?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type InAppCommsMedia = {
  __typename?: 'InAppCommsMedia';
  alt?: Maybe<Scalars['String']>;
  height: Scalars['Int'];
  src?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  width: Scalars['Int'];
};

export type InAppCommsModal = {
  __typename?: 'InAppCommsModal';
  buttons: Array<InAppCommsButton>;
  description: Scalars['String'];
  externalUrl?: Maybe<Scalars['String']>;
  media: Array<InAppCommsMedia>;
  steps: Array<InAppCommsModalStep>;
  title: Scalars['String'];
};

export type InAppCommsModalStep = {
  __typename?: 'InAppCommsModalStep';
  description: Scalars['String'];
  media: Array<InAppCommsMedia>;
  title: Scalars['String'];
};

export type InAppCommsOnClose = {
  __typename?: 'InAppCommsOnClose';
  showAgainAfterSelectedDays?: Maybe<Scalars['Int']>;
};

export type InAppCommsSchedule = {
  __typename?: 'InAppCommsSchedule';
  endDate: Scalars['ISO8601Date'];
  startDate: Scalars['ISO8601Date'];
};

export type InAppCommsSidebarCard = {
  __typename?: 'InAppCommsSidebarCard';
  backgroundColor?: Maybe<Scalars['String']>;
  cardLink: InAppCommsCardLink;
  description: Scalars['String'];
  media: Array<InAppCommsMedia>;
  moduleIcon?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

/** Autogenerated return type of InitiateExportBillingCpExportInvoice. */
export type InitiateExportBillingCpExportInvoicePayload = {
  __typename?: 'InitiateExportBillingCpExportInvoicePayload';
  cpExportInvoice?: Maybe<BillingCpExportInvoice>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of InitiatePerformanceAgreement. */
export type InitiatePerformanceAgreementPayload = {
  __typename?: 'InitiatePerformanceAgreementPayload';
  agreement?: Maybe<PerformanceAgreement>;
  errors: Array<MutationError>;
};

export type InsightTableItemsResourceFilterInput = {
  agreementDataTypes?: InputMaybe<Array<FinancialWorkspaceValueObjectsAgreementDataTypeEnum>>;
  conceptIds?: InputMaybe<Array<Scalars['Int']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  costType?: InputMaybe<FinancialWorkspaceValueObjectsCostTypeEnum>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  formattedEndDate: Scalars['String'];
  formattedStartDate: Scalars['String'];
  groupBy: FinancialWorkspaceValueObjectsInsightTableGroupEnum;
  includeFuturePeriods?: InputMaybe<Scalars['Boolean']>;
  insightTableType: FinancialWorkspaceValueObjectsInsightTableTypeEnum;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  period?: InputMaybe<FinancialWorkspaceValueObjectsPeriodEnum>;
  policyIds?: InputMaybe<Array<Scalars['Int']>>;
  policyPeriodIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  withSalaryAmountAndSalaryFrequency?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated return type of InstallationExistsMarketplaceCompanyInstallation. */
export type InstallationExistsMarketplaceCompanyInstallationPayload = {
  __typename?: 'InstallationExistsMarketplaceCompanyInstallationPayload';
  companyInstallation?: Maybe<MarketplaceCompanyInstallation>;
  errors: Array<MutationError>;
};

export type IntegerFilter = {
  between?: InputMaybe<Array<Scalars['Int']>>;
  eq?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gteq?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lteq?: InputMaybe<Scalars['Int']>;
  notEq?: InputMaybe<Scalars['Int']>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type IntegrationsAgreggatedSyncableStateValuesEnum =
  | 'failed'
  | 'outdated'
  | 'partially_synced'
  | 'pending'
  | 'synced';

/** Available integration for integrations sync */
export type IntegrationsAvailableIntegration = {
  __typename?: 'IntegrationsAvailableIntegration';
  capabilityMode: IntegrationsCapabilityModeEnum;
  id: Scalars['String'];
  marketplaceIntegration: MarketplaceDbIntegration;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  marketplaceIntegrationId: Scalars['Int'];
};


/** Available integration for integrations sync */
export type IntegrationsAvailableIntegrationMarketplaceIntegrationArgs = {
  datoIds?: InputMaybe<Array<Scalars['String']>>;
  uuids?: InputMaybe<Array<Scalars['String']>>;
};

/** The connection type for IntegrationsAvailableIntegration. */
export type IntegrationsAvailableIntegrationConnection = {
  __typename?: 'IntegrationsAvailableIntegrationConnection';
  /** A list of edges. */
  edges: Array<IntegrationsAvailableIntegrationEdge>;
  /** A list of nodes. */
  nodes: Array<IntegrationsAvailableIntegration>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type IntegrationsAvailableIntegrationEdge = {
  __typename?: 'IntegrationsAvailableIntegrationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: IntegrationsAvailableIntegration;
};

export type IntegrationsBaseContextlessPolicies = {
  __typename?: 'IntegrationsBaseContextlessPolicies';
  seeAppStore: ContextlessPolicyResolution;
};

export type IntegrationsCapabilityModeEnum =
  | 'api'
  | 'file';

export type IntegrationsCapabilityTypeEnum =
  | 'compensations'
  | 'expenses';

export type IntegrationsDatevLaudsBusinessUnit = {
  __typename?: 'IntegrationsDatevLaudsBusinessUnit';
  id: Scalars['String'];
  name: Scalars['String'];
};

/** Integrations datev lauds client data job result */
export type IntegrationsDatevLaudsClientDataJobResult = {
  __typename?: 'IntegrationsDatevLaudsClientDataJobResult';
  businessUnits: Array<IntegrationsDatevLaudsBusinessUnit>;
  clientId: Scalars['String'];
  departments: Array<IntegrationsDatevLaudsDepartment>;
  healthInsurers: Array<IntegrationsDatevLaudsHealthInsurer>;
  salaryTypes: Array<IntegrationsDatevLaudsSalaryType>;
};

/** The connection type for IntegrationsDatevLaudsClientDataJobResult. */
export type IntegrationsDatevLaudsClientDataJobResultConnection = {
  __typename?: 'IntegrationsDatevLaudsClientDataJobResultConnection';
  /** A list of edges. */
  edges: Array<IntegrationsDatevLaudsClientDataJobResultEdge>;
  /** A list of nodes. */
  nodes: Array<IntegrationsDatevLaudsClientDataJobResult>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type IntegrationsDatevLaudsClientDataJobResultEdge = {
  __typename?: 'IntegrationsDatevLaudsClientDataJobResultEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: IntegrationsDatevLaudsClientDataJobResult;
};

/** Integrations datev lauds client data request */
export type IntegrationsDatevLaudsClientDataRequest = {
  __typename?: 'IntegrationsDatevLaudsClientDataRequest';
  errorCode?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  jobUuid?: Maybe<Scalars['String']>;
  requestId: Scalars['Int'];
};

/** The connection type for IntegrationsDatevLaudsClientDataRequest. */
export type IntegrationsDatevLaudsClientDataRequestConnection = {
  __typename?: 'IntegrationsDatevLaudsClientDataRequestConnection';
  /** A list of edges. */
  edges: Array<IntegrationsDatevLaudsClientDataRequestEdge>;
  /** A list of nodes. */
  nodes: Array<IntegrationsDatevLaudsClientDataRequest>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type IntegrationsDatevLaudsClientDataRequestEdge = {
  __typename?: 'IntegrationsDatevLaudsClientDataRequestEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: IntegrationsDatevLaudsClientDataRequest;
};

export type IntegrationsDatevLaudsContract = {
  __typename?: 'IntegrationsDatevLaudsContract';
  contractEffectiveOn?: Maybe<Scalars['String']>;
  contractStartsOn?: Maybe<Scalars['String']>;
  deActivityType?: Maybe<Scalars['Int']>;
  deEmploymentType?: Maybe<Scalars['Int']>;
  deFlatRateTax?: Maybe<Scalars['Int']>;
  dePersonalKeyGroupId?: Maybe<Scalars['Int']>;
  salaryAmount?: Maybe<Scalars['Float']>;
  salaryAmountInCents?: Maybe<Scalars['Int']>;
  salaryFrequency?: Maybe<Scalars['String']>;
  workingHours?: Maybe<Scalars['Int']>;
  workingWeekDays?: Maybe<Scalars['String']>;
};

export type IntegrationsDatevLaudsDepartment = {
  __typename?: 'IntegrationsDatevLaudsDepartment';
  contactPerson?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
};

/** Integrations datev lauds employee export from Factorial to Datev */
export type IntegrationsDatevLaudsEmployeeExport = {
  __typename?: 'IntegrationsDatevLaudsEmployeeExport';
  company: ApiCoreCompany;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  companyId: Scalars['Int'];
  id: Scalars['Int'];
  status: IntegrationsDatevLaudsValueObjectsEmployeeExportStatusEnum;
};

export type IntegrationsDatevLaudsEmployeeGroup = {
  __typename?: 'IntegrationsDatevLaudsEmployeeGroup';
  employeeGroupId?: Maybe<Scalars['Int']>;
  employeeGroupName?: Maybe<Scalars['String']>;
  legalEntityId?: Maybe<Scalars['Int']>;
};

/** Integrations datev lauds employee import */
export type IntegrationsDatevLaudsEmployeeImport = {
  __typename?: 'IntegrationsDatevLaudsEmployeeImport';
  accessId: Scalars['Int'];
  company: ApiCoreCompany;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  companyId: Scalars['Int'];
  id: Scalars['Int'];
  importType: IntegrationsDatevLaudsValueObjectsEmployeeImportTypeEnum;
  status: IntegrationsDatevLaudsValueObjectsEmployeeImportStatusEnum;
  validEmployeesCount: Scalars['Int'];
};

/** The connection type for IntegrationsDatevLaudsEmployeeImport. */
export type IntegrationsDatevLaudsEmployeeImportConnection = {
  __typename?: 'IntegrationsDatevLaudsEmployeeImportConnection';
  /** A list of edges. */
  edges: Array<IntegrationsDatevLaudsEmployeeImportEdge>;
  /** A list of nodes. */
  nodes: Array<IntegrationsDatevLaudsEmployeeImport>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type IntegrationsDatevLaudsEmployeeImportEdge = {
  __typename?: 'IntegrationsDatevLaudsEmployeeImportEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: IntegrationsDatevLaudsEmployeeImport;
};

export type IntegrationsDatevLaudsEntitiesIntegrationStatusStateEnum =
  | 'feature_not_enabled'
  | 'integration_not_installed'
  | 'mappings_not_done'
  | 'oauth_token_invalid'
  | 'ok';

/** Export employees incoming from datev */
export type IntegrationsDatevLaudsExport = {
  __typename?: 'IntegrationsDatevLaudsExport';
  content: Scalars['String'];
  fileName?: Maybe<Scalars['String']>;
  fileType: Scalars['String'];
};

export type IntegrationsDatevLaudsHealthInsurer = {
  __typename?: 'IntegrationsDatevLaudsHealthInsurer';
  companyNumberOfHealthInsurer?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

/** Integrations datev lauds imported employee */
export type IntegrationsDatevLaudsImportedEmployee = {
  __typename?: 'IntegrationsDatevLaudsImportedEmployee';
  addressLine1?: Maybe<Scalars['String']>;
  bankNumber?: Maybe<Scalars['String']>;
  birthdayOn?: Maybe<Scalars['ISO8601Date']>;
  city?: Maybe<Scalars['String']>;
  contract?: Maybe<IntegrationsDatevLaudsContract>;
  country?: Maybe<Scalars['String']>;
  employeeGroup?: Maybe<IntegrationsDatevLaudsEmployeeGroup>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  mandatoryData?: Maybe<IntegrationsDatevLaudsMandatoryData>;
  nationality?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<Scalars['String']>;
  payrollEmployeesEmployeeData?: Maybe<IntegrationsDatevLaudsPayrollEmployee>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  socialSecurityNumber?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  swiftBic?: Maybe<Scalars['String']>;
  user?: Maybe<IntegrationsDatevLaudsUser>;
  vacationDays?: Maybe<Scalars['Float']>;
};

/** The connection type for IntegrationsDatevLaudsImportedEmployee. */
export type IntegrationsDatevLaudsImportedEmployeeConnection = {
  __typename?: 'IntegrationsDatevLaudsImportedEmployeeConnection';
  /** A list of edges. */
  edges: Array<IntegrationsDatevLaudsImportedEmployeeEdge>;
  /** A list of nodes. */
  nodes: Array<IntegrationsDatevLaudsImportedEmployee>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type IntegrationsDatevLaudsImportedEmployeeEdge = {
  __typename?: 'IntegrationsDatevLaudsImportedEmployeeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: IntegrationsDatevLaudsImportedEmployee;
};

/** Integrations datev lauds integration status */
export type IntegrationsDatevLaudsIntegrationStatus = {
  __typename?: 'IntegrationsDatevLaudsIntegrationStatus';
  company: ApiCoreCompany;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  companyId: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  status: IntegrationsDatevLaudsEntitiesIntegrationStatusStateEnum;
};

/** The connection type for IntegrationsDatevLaudsIntegrationStatus. */
export type IntegrationsDatevLaudsIntegrationStatusConnection = {
  __typename?: 'IntegrationsDatevLaudsIntegrationStatusConnection';
  /** A list of edges. */
  edges: Array<IntegrationsDatevLaudsIntegrationStatusEdge>;
  /** A list of nodes. */
  nodes: Array<IntegrationsDatevLaudsIntegrationStatus>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type IntegrationsDatevLaudsIntegrationStatusEdge = {
  __typename?: 'IntegrationsDatevLaudsIntegrationStatusEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: IntegrationsDatevLaudsIntegrationStatus;
};

export type IntegrationsDatevLaudsMandatoryData = {
  __typename?: 'IntegrationsDatevLaudsMandatoryData';
  datevEmployeeCode?: Maybe<Scalars['Int']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  legalEntityName?: Maybe<Scalars['String']>;
};

/** Integrations datev lauds oauth token */
export type IntegrationsDatevLaudsOauthToken = {
  __typename?: 'IntegrationsDatevLaudsOauthToken';
  access: ApiCoreAccess;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  accessId: Scalars['Int'];
  accessToken: Scalars['String'];
  clientId?: Maybe<Scalars['String']>;
  company: ApiCoreCompany;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  companyId: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  expiresAt?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  idToken?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  tokenUserEmail?: Maybe<Scalars['String']>;
  tokenUserName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};


/** Integrations datev lauds oauth token */
export type IntegrationsDatevLaudsOauthTokenAccessArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for IntegrationsDatevLaudsOauthToken. */
export type IntegrationsDatevLaudsOauthTokenConnection = {
  __typename?: 'IntegrationsDatevLaudsOauthTokenConnection';
  /** A list of edges. */
  edges: Array<IntegrationsDatevLaudsOauthTokenEdge>;
  /** A list of nodes. */
  nodes: Array<IntegrationsDatevLaudsOauthToken>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type IntegrationsDatevLaudsOauthTokenEdge = {
  __typename?: 'IntegrationsDatevLaudsOauthTokenEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: IntegrationsDatevLaudsOauthToken;
};

export type IntegrationsDatevLaudsPayrollEmployee = {
  __typename?: 'IntegrationsDatevLaudsPayrollEmployee';
  academicTitle?: Maybe<Scalars['String']>;
  additionalContributionToNursingInsurance?: Maybe<Scalars['String']>;
  annualTaxAllowance?: Maybe<Scalars['Int']>;
  birthName?: Maybe<Scalars['String']>;
  birthNameAffix?: Maybe<Scalars['String']>;
  birthNamePrefix?: Maybe<Scalars['String']>;
  certificateOfStudyExpirationDate?: Maybe<Scalars['String']>;
  childTaxAllowance?: Maybe<Scalars['Float']>;
  companyNumberOfHealthInsurer?: Maybe<Scalars['Int']>;
  contributionClassHealthInsurance?: Maybe<Scalars['String']>;
  contributionClassNursingInsurance?: Maybe<Scalars['String']>;
  contributionClassPensionInsurance?: Maybe<Scalars['String']>;
  contributionClassUnemploymentInsurance?: Maybe<Scalars['String']>;
  countryOfBirth?: Maybe<Scalars['String']>;
  denomination?: Maybe<Scalars['String']>;
  differingAccountHolder?: Maybe<Scalars['String']>;
  employeeId?: Maybe<Scalars['Int']>;
  factor?: Maybe<Scalars['Float']>;
  factorInCents?: Maybe<Scalars['Int']>;
  healthInsuranceId?: Maybe<Scalars['Int']>;
  highestLevelOfEducation?: Maybe<Scalars['String']>;
  highestLevelOfProfessionalTraining?: Maybe<Scalars['String']>;
  houseNumber?: Maybe<Scalars['String']>;
  monthlyTaxAllowance?: Maybe<Scalars['Int']>;
  nameAffix?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<Scalars['String']>;
  personnelLeasing?: Maybe<Scalars['Int']>;
  placeOfBirth?: Maybe<Scalars['String']>;
  requestedAnnualAllowance?: Maybe<Scalars['Int']>;
  residencyPermitExpirationDate?: Maybe<Scalars['String']>;
  spousesDenomination?: Maybe<Scalars['String']>;
  taxClass?: Maybe<Scalars['Int']>;
};

/** Integrations datev lauds permissions check */
export type IntegrationsDatevLaudsPermission = {
  __typename?: 'IntegrationsDatevLaudsPermission';
  access: ApiCoreAccess;
  company: ApiCoreCompany;
  error?: Maybe<Scalars['String']>;
  statusCode?: Maybe<Scalars['Int']>;
};


/** Integrations datev lauds permissions check */
export type IntegrationsDatevLaudsPermissionAccessArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for IntegrationsDatevLaudsPermission. */
export type IntegrationsDatevLaudsPermissionConnection = {
  __typename?: 'IntegrationsDatevLaudsPermissionConnection';
  /** A list of edges. */
  edges: Array<IntegrationsDatevLaudsPermissionEdge>;
  /** A list of nodes. */
  nodes: Array<IntegrationsDatevLaudsPermission>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type IntegrationsDatevLaudsPermissionEdge = {
  __typename?: 'IntegrationsDatevLaudsPermissionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: IntegrationsDatevLaudsPermission;
};

/** Integrations datev lauds request */
export type IntegrationsDatevLaudsRequest = {
  __typename?: 'IntegrationsDatevLaudsRequest';
  access: ApiCoreAccess;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  accessId: Scalars['Int'];
  clientId?: Maybe<Scalars['String']>;
  company: ApiCoreCompany;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  companyId: Scalars['Int'];
  endpoint: Scalars['String'];
  error?: Maybe<Scalars['Boolean']>;
  errorCode?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  incidence?: Maybe<BookkeepersManagementIncidence>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  incidenceId?: Maybe<Scalars['Int']>;
  jobUuid?: Maybe<Scalars['String']>;
  payload?: Maybe<Scalars['String']>;
  requestData?: Maybe<Scalars['String']>;
  responseBody?: Maybe<Scalars['String']>;
  responseData?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};


/** Integrations datev lauds request */
export type IntegrationsDatevLaudsRequestAccessArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** Integrations datev lauds request */
export type IntegrationsDatevLaudsRequestIncidenceArgs = {
  containsMessage?: InputMaybe<Scalars['Boolean']>;
  customLeaveName?: InputMaybe<Array<Scalars['String']>>;
  direction?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endsOn?: InputMaybe<Scalars['ISO8601Date']>;
  legalEntitiesIds?: InputMaybe<Array<Scalars['Int']>>;
  messageFrom?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
  startsOn?: InputMaybe<Scalars['ISO8601Date']>;
  status?: InputMaybe<Array<Scalars['String']>>;
  type?: InputMaybe<Array<Scalars['String']>>;
  workplaceIds?: InputMaybe<Array<Scalars['Int']>>;
};

/** The connection type for IntegrationsDatevLaudsRequest. */
export type IntegrationsDatevLaudsRequestConnection = {
  __typename?: 'IntegrationsDatevLaudsRequestConnection';
  /** A list of edges. */
  edges: Array<IntegrationsDatevLaudsRequestEdge>;
  /** A list of nodes. */
  nodes: Array<IntegrationsDatevLaudsRequest>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type IntegrationsDatevLaudsRequestEdge = {
  __typename?: 'IntegrationsDatevLaudsRequestEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: IntegrationsDatevLaudsRequest;
};

export type IntegrationsDatevLaudsSalaryType = {
  __typename?: 'IntegrationsDatevLaudsSalaryType';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type IntegrationsDatevLaudsUser = {
  __typename?: 'IntegrationsDatevLaudsUser';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};

export type IntegrationsDatevLaudsValueObjectsEmployeeExportStatusEnum =
  | 'collecting'
  | 'failed'
  | 'mapping'
  | 'partially_processed'
  | 'pending'
  | 'processed'
  | 'processing'
  | 'ready';

export type IntegrationsDatevLaudsValueObjectsEmployeeImportStatusEnum =
  | 'collecting'
  | 'failed'
  | 'mapping'
  | 'partially_processed'
  | 'pending'
  | 'processed'
  | 'processing'
  | 'ready';

export type IntegrationsDatevLaudsValueObjectsEmployeeImportTypeEnum =
  | 'from_datev'
  | 'from_factorial';

export type IntegrationsDatevLaudsValueObjectsRequestStatusEnum =
  | 'complete'
  | 'failed'
  | 'partial'
  | 'pending'
  | 'processed';

export type IntegrationsDatevLaudsValueObjectsTargetSystemEnum =
  | 'datev_lodas'
  | 'datev_lug';

/** Autogenerated return type of IntegrationsDatevLauds_request_update_subscription. */
export type IntegrationsDatevLauds_Request_Update_SubscriptionPayload = {
  __typename?: 'IntegrationsDatevLauds_request_update_subscriptionPayload';
  request?: Maybe<IntegrationsDatevLaudsRequest>;
};

/** Indeed account */
export type IntegrationsIndeedAccount = {
  __typename?: 'IntegrationsIndeedAccount';
  accessId: Scalars['Int'];
  active: Scalars['Boolean'];
  company: ApiCoreCompany;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  companyId: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['Int'];
  indeedApplyEnabled: Scalars['Boolean'];
  sourceName?: Maybe<Scalars['String']>;
  syncOnInstall: Scalars['Boolean'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for IntegrationsIndeedAccount. */
export type IntegrationsIndeedAccountConnection = {
  __typename?: 'IntegrationsIndeedAccountConnection';
  /** A list of edges. */
  edges: Array<IntegrationsIndeedAccountEdge>;
  /** A list of nodes. */
  nodes: Array<IntegrationsIndeedAccount>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type IntegrationsIndeedAccountEdge = {
  __typename?: 'IntegrationsIndeedAccountEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: IntegrationsIndeedAccount;
};

/** Indeed Application */
export type IntegrationsIndeedApplication = {
  __typename?: 'IntegrationsIndeedApplication';
  atsApplicationId: Scalars['Int'];
  company: ApiCoreCompany;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  companyId: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  dispositionStatus: Scalars['String'];
  id: Scalars['Int'];
  indeedApplyId: Scalars['String'];
  indeedJobPosting: IntegrationsIndeedJobPosting;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  integrationsIndeedJobPostingId: Scalars['Int'];
  rawDispositionStatus: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};


/** Indeed Application */
export type IntegrationsIndeedApplicationIndeedJobPostingArgs = {
  atsJobPostingId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
};

/** The connection type for IntegrationsIndeedApplication. */
export type IntegrationsIndeedApplicationConnection = {
  __typename?: 'IntegrationsIndeedApplicationConnection';
  /** A list of edges. */
  edges: Array<IntegrationsIndeedApplicationEdge>;
  /** A list of nodes. */
  nodes: Array<IntegrationsIndeedApplication>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type IntegrationsIndeedApplicationEdge = {
  __typename?: 'IntegrationsIndeedApplicationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: IntegrationsIndeedApplication;
};

export type IntegrationsIndeedDispositionDataStatusesEnum =
  | 'assess_qualifications'
  | 'hired'
  | 'interview'
  | 'new'
  | 'not_selected'
  | 'offer_made'
  | 'screen'
  | 'unable_to_map';

/** Indeed job posting */
export type IntegrationsIndeedJobPosting = {
  __typename?: 'IntegrationsIndeedJobPosting';
  account: IntegrationsIndeedAccount;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  atsJobPostingId: Scalars['Int'];
  company: ApiCoreCompany;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  companyId: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  errors?: Maybe<Array<Scalars['String']>>;
  id: Scalars['Int'];
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  integrationsIndeedAccountId?: Maybe<Scalars['Int']>;
  jobPosting: AtsJobPosting;
  sourcedId?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
  url?: Maybe<Scalars['String']>;
};


/** Indeed job posting */
export type IntegrationsIndeedJobPostingAccountArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
};


/** Indeed job posting */
export type IntegrationsIndeedJobPostingJobPostingArgs = {
  hiringManagerAccessIds?: InputMaybe<Array<Scalars['Int']>>;
  id?: InputMaybe<Scalars['Int']>;
  includeActiveJobs?: InputMaybe<Scalars['Boolean']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  locationId?: InputMaybe<Scalars['Int']>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  status?: InputMaybe<AtsJobPostingStatusesEnum>;
  statuses?: InputMaybe<Array<AtsJobPostingStatusesEnum>>;
  teamId?: InputMaybe<Scalars['Int']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  title?: InputMaybe<Scalars['String']>;
};

/** The connection type for IntegrationsIndeedJobPosting. */
export type IntegrationsIndeedJobPostingConnection = {
  __typename?: 'IntegrationsIndeedJobPostingConnection';
  /** A list of edges. */
  edges: Array<IntegrationsIndeedJobPostingEdge>;
  /** A list of nodes. */
  nodes: Array<IntegrationsIndeedJobPosting>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type IntegrationsIndeedJobPostingEdge = {
  __typename?: 'IntegrationsIndeedJobPostingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: IntegrationsIndeedJobPosting;
};

/** Infojobs offer */
export type IntegrationsInfojobsOffer = {
  __typename?: 'IntegrationsInfojobsOffer';
  company: ApiCoreCompany;
  contractTypeId: Scalars['Int'];
  countryId: Scalars['Int'];
  desiredSkills?: Maybe<Scalars['String']>;
  errorMessages?: Maybe<Array<Scalars['String']>>;
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  jobIndustryId: Scalars['Int'];
  jobPosting: AtsJobPosting;
  jobSubindustryId: Scalars['Int'];
  levelId: Scalars['Int'];
  minimumExperienceId: Scalars['Int'];
  minimumStudiesId: Scalars['Int'];
  promotionCodes?: Maybe<Array<Scalars['String']>>;
  provinceId: Scalars['Int'];
  requiredSkills?: Maybe<Scalars['String']>;
  salaryFromId: Scalars['Int'];
  salaryPerId: Scalars['Int'];
  salaryToId: Scalars['Int'];
  status: IntegrationsInfojobsOfferStatusesEnum;
  workingDayId: Scalars['Int'];
};


/** Infojobs offer */
export type IntegrationsInfojobsOfferJobPostingArgs = {
  hiringManagerAccessIds?: InputMaybe<Array<Scalars['Int']>>;
  id?: InputMaybe<Scalars['Int']>;
  includeActiveJobs?: InputMaybe<Scalars['Boolean']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  locationId?: InputMaybe<Scalars['Int']>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  status?: InputMaybe<AtsJobPostingStatusesEnum>;
  statuses?: InputMaybe<Array<AtsJobPostingStatusesEnum>>;
  teamId?: InputMaybe<Scalars['Int']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  title?: InputMaybe<Scalars['String']>;
};

/** The connection type for IntegrationsInfojobsOffer. */
export type IntegrationsInfojobsOfferConnection = {
  __typename?: 'IntegrationsInfojobsOfferConnection';
  /** A list of edges. */
  edges: Array<IntegrationsInfojobsOfferEdge>;
  /** A list of nodes. */
  nodes: Array<IntegrationsInfojobsOffer>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type IntegrationsInfojobsOfferEdge = {
  __typename?: 'IntegrationsInfojobsOfferEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: IntegrationsInfojobsOffer;
};

export type IntegrationsInfojobsOfferStatusesEnum =
  | 'active'
  | 'archived'
  | 'error'
  | 'expired'
  | 'in_progress';

/** Infojobs job offer list of promotions */
export type IntegrationsInfojobsPromotion = {
  __typename?: 'IntegrationsInfojobsPromotion';
  id: Scalars['String'];
  productName: Scalars['String'];
};

/** The connection type for IntegrationsInfojobsPromotion. */
export type IntegrationsInfojobsPromotionConnection = {
  __typename?: 'IntegrationsInfojobsPromotionConnection';
  /** A list of edges. */
  edges: Array<IntegrationsInfojobsPromotionEdge>;
  /** A list of nodes. */
  nodes: Array<IntegrationsInfojobsPromotion>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type IntegrationsInfojobsPromotionEdge = {
  __typename?: 'IntegrationsInfojobsPromotionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: IntegrationsInfojobsPromotion;
};

/** Infojobs job offer value option */
export type IntegrationsInfojobsValueOption = {
  __typename?: 'IntegrationsInfojobsValueOption';
  label: Scalars['String'];
  order: Scalars['Int'];
  value: Scalars['String'];
};

/** The connection type for IntegrationsInfojobsValueOption. */
export type IntegrationsInfojobsValueOptionConnection = {
  __typename?: 'IntegrationsInfojobsValueOptionConnection';
  /** A list of edges. */
  edges: Array<IntegrationsInfojobsValueOptionEdge>;
  /** A list of nodes. */
  nodes: Array<IntegrationsInfojobsValueOption>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type IntegrationsInfojobsValueOptionEdge = {
  __typename?: 'IntegrationsInfojobsValueOptionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: IntegrationsInfojobsValueOption;
};

export type IntegrationsInfojobsValueTypeEnum =
  | 'contract_type'
  | 'country'
  | 'experience'
  | 'job_industry'
  | 'job_subindustry'
  | 'laboral_level'
  | 'province'
  | 'salary_period'
  | 'salary_ranges'
  | 'shift'
  | 'studies';

export type IntegrationsJoinBoard = {
  __typename?: 'IntegrationsJoinBoard';
  description: Scalars['String'];
  hoursToProcess: Scalars['Int'];
  logoUrl: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type IntegrationsJoinBundleDetail = {
  __typename?: 'IntegrationsJoinBundleDetail';
  description: Scalars['String'];
  durationDays: Scalars['Int'];
  id: Scalars['String'];
  jobBoard: IntegrationsJoinBoard;
  name: Scalars['String'];
};

export type IntegrationsJoinContextlessPolicies = {
  __typename?: 'IntegrationsJoinContextlessPolicies';
  ordersManageRequests: ContextlessPolicyResolution;
  useJoinIntegration: ContextlessPolicyResolution;
};

/** Integration profiles to configure for a given company */
export type IntegrationsJoinIntegration = {
  __typename?: 'IntegrationsJoinIntegration';
  configuration: Array<IntegrationsJoinIntegrationConfiguration>;
  description?: Maybe<Scalars['String']>;
  logoUrl: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
  status: Scalars['String'];
};

export type IntegrationsJoinIntegrationConfiguration = {
  __typename?: 'IntegrationsJoinIntegrationConfiguration';
  placeholder?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  validationPattern?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type IntegrationsJoinIntegrationConfigurationInput = {
  placeholder?: InputMaybe<Scalars['String']>;
  slug: Scalars['String'];
  validationPattern?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type IntegrationsJoinIntegrationsStatusEnum =
  | 'disabled'
  | 'enabled';

export type IntegrationsJoinJobBoard = {
  __typename?: 'IntegrationsJoinJobBoard';
  logoUrl: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type IntegrationsJoinJobBoardInput = {
  logoUrl: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

/** Job posting that has been promoted on JOIN */
export type IntegrationsJoinJobPosting = {
  __typename?: 'IntegrationsJoinJobPosting';
  atsJobPostingId: Scalars['Int'];
  company: ApiCoreCompany;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  companyId: Scalars['Int'];
  createdInJoin: Scalars['Boolean'];
  errorCodes?: Maybe<Scalars['String']>;
  errorLabels?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  joinCompany?: Maybe<IntegrationsJoinJoinCompany>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  joinCompanyId: Scalars['Int'];
  status?: Maybe<Scalars['String']>;
};


/** Job posting that has been promoted on JOIN */
export type IntegrationsJoinJobPostingJoinCompanyArgs = {
  companyId: Scalars['Int'];
};

/** The connection type for IntegrationsJoinJobPosting. */
export type IntegrationsJoinJobPostingConnection = {
  __typename?: 'IntegrationsJoinJobPostingConnection';
  /** A list of edges. */
  edges: Array<IntegrationsJoinJobPostingEdge>;
  /** A list of nodes. */
  nodes: Array<IntegrationsJoinJobPosting>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type IntegrationsJoinJobPostingEdge = {
  __typename?: 'IntegrationsJoinJobPostingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: IntegrationsJoinJobPosting;
};

export type IntegrationsJoinJobPostingStatusesEnum =
  | 'archived'
  | 'online';

/** Company that has been created on JOIN */
export type IntegrationsJoinJoinCompany = {
  __typename?: 'IntegrationsJoinJoinCompany';
  active?: Maybe<Scalars['Boolean']>;
  company: ApiCoreCompany;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  companyId: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  errorCodes?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  joinJobPostings: Array<IntegrationsJoinJobPosting>;
  joinjobpostingsConnection: IntegrationsJoinJobPostingConnection;
  name?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};


/** Company that has been created on JOIN */
export type IntegrationsJoinJoinCompanyJoinJobPostingsArgs = {
  atsJobPostingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyId: Scalars['Int'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  statuses?: InputMaybe<Array<Scalars['String']>>;
};


/** Company that has been created on JOIN */
export type IntegrationsJoinJoinCompanyJoinjobpostingsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  atsJobPostingIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  statuses?: InputMaybe<Array<Scalars['String']>>;
};

/** The connection type for IntegrationsJoinJoinCompany. */
export type IntegrationsJoinJoinCompanyConnection = {
  __typename?: 'IntegrationsJoinJoinCompanyConnection';
  /** A list of edges. */
  edges: Array<IntegrationsJoinJoinCompanyEdge>;
  /** A list of nodes. */
  nodes: Array<IntegrationsJoinJoinCompany>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type IntegrationsJoinJoinCompanyEdge = {
  __typename?: 'IntegrationsJoinJoinCompanyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: IntegrationsJoinJoinCompany;
};

/** This is the office that is associated with a JOIN company akin to factorial locations */
export type IntegrationsJoinOffice = {
  __typename?: 'IntegrationsJoinOffice';
  company: ApiCoreCompany;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  companyId: Scalars['Int'];
  errorCodes?: Maybe<Scalars['String']>;
  errorLabels?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  joinCompany?: Maybe<IntegrationsJoinJoinCompany>;
  locationId: Scalars['Int'];
};


/** This is the office that is associated with a JOIN company akin to factorial locations */
export type IntegrationsJoinOfficeJoinCompanyArgs = {
  companyId: Scalars['Int'];
};

/** The connection type for IntegrationsJoinOffice. */
export type IntegrationsJoinOfficeConnection = {
  __typename?: 'IntegrationsJoinOfficeConnection';
  /** A list of edges. */
  edges: Array<IntegrationsJoinOfficeEdge>;
  /** A list of nodes. */
  nodes: Array<IntegrationsJoinOffice>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type IntegrationsJoinOfficeEdge = {
  __typename?: 'IntegrationsJoinOfficeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: IntegrationsJoinOffice;
};

/** This is the order that represents a Join order before being sent to them */
export type IntegrationsJoinOrder = {
  __typename?: 'IntegrationsJoinOrder';
  approval?: Maybe<ApprovalsMaterializedApprovalsFlow>;
  approverAccessIds?: Maybe<Array<Scalars['Int']>>;
  atsJobPosting: AtsPurchaseRequestJobPosting;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  atsJobPostingId: Scalars['Int'];
  company: ApiCoreCompany;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  companyId: Scalars['Int'];
  /** the date and time when the order was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** identifier of the order. */
  id: Scalars['Int'];
  joinJobPosting: IntegrationsJoinJobPosting;
  note?: Maybe<Scalars['String']>;
  pendingApproverAccessIds?: Maybe<Array<Scalars['Int']>>;
  /** premium offer identifier. */
  premiumOfferId: Scalars['String'];
  /** premium offer name. */
  premiumOfferName: Scalars['String'];
  /** premium offer price. */
  premiumOfferPrice: Scalars['Int'];
  /** premium offer type. */
  premiumOfferType: IntegrationsJoinPremiumOfferTypesEnum;
  premiumOfferTypeLabel: Scalars['String'];
  requestedBy: ApiCoreAccess;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  requestedById: Scalars['Int'];
  snapshot: IntegrationsJoinSnapshot;
  /** status of the order. */
  status: IntegrationsJoinOrderStatusesEnum;
  statusDetail: Scalars['String'];
  statusLabel: Scalars['String'];
  /** the date and time when the order was updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};


/** This is the order that represents a Join order before being sent to them */
export type IntegrationsJoinOrderApprovalArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  ownerId?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<ApprovalsMaterializedApprovalFlowStatusEnum>;
};


/** This is the order that represents a Join order before being sent to them */
export type IntegrationsJoinOrderJoinJobPostingArgs = {
  atsJobPostingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyId: Scalars['Int'];
  statuses?: InputMaybe<Array<Scalars['String']>>;
};


/** This is the order that represents a Join order before being sent to them */
export type IntegrationsJoinOrderRequestedByArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for IntegrationsJoinOrder. */
export type IntegrationsJoinOrderConnection = {
  __typename?: 'IntegrationsJoinOrderConnection';
  /** A list of edges. */
  edges: Array<IntegrationsJoinOrderEdge>;
  /** A list of nodes. */
  nodes: Array<IntegrationsJoinOrder>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type IntegrationsJoinOrderEdge = {
  __typename?: 'IntegrationsJoinOrderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: IntegrationsJoinOrder;
};

/** the filter for the orders resource */
export type IntegrationsJoinOrderFilter = {
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntegerFilter>;
  or?: InputMaybe<Array<IntegrationsJoinOrderFilterConditions>>;
  premiumOfferId?: InputMaybe<StringFilter>;
  premiumOfferName?: InputMaybe<StringFilter>;
  premiumOfferPrice?: InputMaybe<IntegerFilter>;
  premiumOfferType?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type IntegrationsJoinOrderFilterConditions = {
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntegerFilter>;
  premiumOfferId?: InputMaybe<StringFilter>;
  premiumOfferName?: InputMaybe<StringFilter>;
  premiumOfferPrice?: InputMaybe<IntegerFilter>;
  premiumOfferType?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type IntegrationsJoinOrderStatusesEnum =
  | 'approved'
  | 'cancelled'
  | 'failed'
  | 'payment_failed'
  | 'pending'
  | 'processing'
  | 'rejected';

/** Organic channels where a job posting has been promoted on JOIN */
export type IntegrationsJoinOrganicChannel = {
  __typename?: 'IntegrationsJoinOrganicChannel';
  channels: Array<IntegrationsJoinOrganicChannelDetails>;
};

export type IntegrationsJoinOrganicChannelDetails = {
  __typename?: 'IntegrationsJoinOrganicChannelDetails';
  applicationsCount: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  logoUrl: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
  website?: Maybe<Scalars['String']>;
};

/** Paid bundles for a giving job posting to be promoted. */
export type IntegrationsJoinPremiumBundle = {
  __typename?: 'IntegrationsJoinPremiumBundle';
  id: Scalars['String'];
  isBooked: Scalars['Boolean'];
  name: Scalars['String'];
  pricing: IntegrationsJoinPrice;
  products: Array<IntegrationsJoinBundleDetail>;
};

/** The connection type for IntegrationsJoinPremiumBundle. */
export type IntegrationsJoinPremiumBundleConnection = {
  __typename?: 'IntegrationsJoinPremiumBundleConnection';
  /** A list of edges. */
  edges: Array<IntegrationsJoinPremiumBundleEdge>;
  /** A list of nodes. */
  nodes: Array<IntegrationsJoinPremiumBundle>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type IntegrationsJoinPremiumBundleEdge = {
  __typename?: 'IntegrationsJoinPremiumBundleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: IntegrationsJoinPremiumBundle;
};

export type IntegrationsJoinPremiumOfferTypesEnum =
  | 'bundle'
  | 'product';

/** Premium postings where a job posting has been promoted on paid portals from JOIN */
export type IntegrationsJoinPremiumPosting = {
  __typename?: 'IntegrationsJoinPremiumPosting';
  /** ATS job posting identifier. */
  atsJobPostingId: Scalars['Int'];
  company: ApiCoreCompany;
  /**
   * Company identifier.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  companyId: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  /** Start date of the premium posting. */
  fromDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** Premium posting identifier. */
  id: Scalars['Int'];
  integrationJoinOrder: IntegrationsJoinOrder;
  /**
   * Integrations Join order identifier.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  integrationsJoinOrderId: Scalars['Int'];
  /** Job board details where the posting is published. */
  jobBoard: IntegrationsJoinPremiumPostingBoard;
  /** Product details for the premium posting. */
  product: IntegrationsJoinPremiumPostingProduct;
  /** Product order identifier from JOIN. */
  productOrderId: Scalars['String'];
  /** Status of the premium posting. */
  status: IntegrationsJoinPremiumPostingStatusesEnum;
  /** End date of the premium posting. */
  toDate?: Maybe<Scalars['ISO8601DateTime']>;
  updatedAt: Scalars['ISO8601DateTime'];
  url?: Maybe<Scalars['String']>;
};


/** Premium postings where a job posting has been promoted on paid portals from JOIN */
export type IntegrationsJoinPremiumPostingIntegrationJoinOrderArgs = {
  approverAccessIds?: InputMaybe<Array<Scalars['Int']>>;
  atsJobPostingId?: InputMaybe<Scalars['Int']>;
  premiumOfferTypes?: InputMaybe<Array<IntegrationsJoinPremiumOfferTypesEnum>>;
  requestedById?: InputMaybe<Scalars['Int']>;
  requestedOrApproverByIds?: InputMaybe<Array<Scalars['Int']>>;
  statuses?: InputMaybe<Array<IntegrationsJoinOrderStatusesEnum>>;
};

export type IntegrationsJoinPremiumPostingBoard = {
  __typename?: 'IntegrationsJoinPremiumPostingBoard';
  description: Scalars['String'];
  hoursToProcess?: Maybe<Scalars['Int']>;
  logoUrl: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

/** The connection type for IntegrationsJoinPremiumPosting. */
export type IntegrationsJoinPremiumPostingConnection = {
  __typename?: 'IntegrationsJoinPremiumPostingConnection';
  /** A list of edges. */
  edges: Array<IntegrationsJoinPremiumPostingEdge>;
  /** A list of nodes. */
  nodes: Array<IntegrationsJoinPremiumPosting>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type IntegrationsJoinPremiumPostingEdge = {
  __typename?: 'IntegrationsJoinPremiumPostingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: IntegrationsJoinPremiumPosting;
};

/** the filter for the premium_postings resource */
export type IntegrationsJoinPremiumPostingFilter = {
  fromDate?: InputMaybe<DateTimeFilter>;
  or?: InputMaybe<Array<IntegrationsJoinPremiumPostingFilterConditions>>;
  product?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
  toDate?: InputMaybe<DateTimeFilter>;
};

export type IntegrationsJoinPremiumPostingFilterConditions = {
  fromDate?: InputMaybe<DateTimeFilter>;
  product?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
  toDate?: InputMaybe<DateTimeFilter>;
};

export type IntegrationsJoinPremiumPostingProduct = {
  __typename?: 'IntegrationsJoinPremiumPostingProduct';
  description: Scalars['String'];
  durationDays: Scalars['Int'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export type IntegrationsJoinPremiumPostingStatusesEnum =
  | 'archived'
  | 'expired'
  | 'pending'
  | 'posted'
  | 'processing'
  | 'unposted';

/** Paid products for a giving job posting to be promoted. */
export type IntegrationsJoinPremiumProduct = {
  __typename?: 'IntegrationsJoinPremiumProduct';
  description: Scalars['String'];
  hoursToProcess: Scalars['Int'];
  logoUrl: Scalars['String'];
  name: Scalars['String'];
  products: Array<IntegrationsJoinProductDetail>;
  slug: Scalars['String'];
};

/** The connection type for IntegrationsJoinPremiumProduct. */
export type IntegrationsJoinPremiumProductConnection = {
  __typename?: 'IntegrationsJoinPremiumProductConnection';
  /** A list of edges. */
  edges: Array<IntegrationsJoinPremiumProductEdge>;
  /** A list of nodes. */
  nodes: Array<IntegrationsJoinPremiumProduct>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type IntegrationsJoinPremiumProductEdge = {
  __typename?: 'IntegrationsJoinPremiumProductEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: IntegrationsJoinPremiumProduct;
};

export type IntegrationsJoinPrice = {
  __typename?: 'IntegrationsJoinPrice';
  currencyCode: Scalars['String'];
  fallbackPricing: Scalars['Boolean'];
  originalAmount: Scalars['Int'];
  reducedAmount: Scalars['Int'];
  reducedPercentage: Scalars['Int'];
};

export type IntegrationsJoinProduct = {
  __typename?: 'IntegrationsJoinProduct';
  description: Scalars['String'];
  durationDays: Scalars['Int'];
  jobBoard: IntegrationsJoinJobBoard;
};

export type IntegrationsJoinProductDetail = {
  __typename?: 'IntegrationsJoinProductDetail';
  description: Scalars['String'];
  durationDays: Scalars['Int'];
  id: Scalars['String'];
  isBooked: Scalars['Boolean'];
  name: Scalars['String'];
  pricing: IntegrationsJoinPrice;
};

export type IntegrationsJoinProductInput = {
  description: Scalars['String'];
  durationDays: Scalars['Int'];
  jobBoard: IntegrationsJoinJobBoardInput;
};

export type IntegrationsJoinSnapshot = {
  __typename?: 'IntegrationsJoinSnapshot';
  currency: Scalars['String'];
  price: Scalars['Int'];
  products: Array<IntegrationsJoinProduct>;
};

export type IntegrationsJoinSnapshotInput = {
  currency: Scalars['String'];
  price: Scalars['Int'];
  products: Array<IntegrationsJoinProductInput>;
};

/** Integrations primobox document status */
export type IntegrationsPrimoboxDocumentStatus = {
  __typename?: 'IntegrationsPrimoboxDocumentStatus';
  documentId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  messages: Array<Scalars['String']>;
  status: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for IntegrationsPrimoboxDocumentStatus. */
export type IntegrationsPrimoboxDocumentStatusConnection = {
  __typename?: 'IntegrationsPrimoboxDocumentStatusConnection';
  /** A list of edges. */
  edges: Array<IntegrationsPrimoboxDocumentStatusEdge>;
  /** A list of nodes. */
  nodes: Array<IntegrationsPrimoboxDocumentStatus>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type IntegrationsPrimoboxDocumentStatusEdge = {
  __typename?: 'IntegrationsPrimoboxDocumentStatusEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: IntegrationsPrimoboxDocumentStatus;
};

/** Integrations primobox employee status */
export type IntegrationsPrimoboxEmployeeStatus = {
  __typename?: 'IntegrationsPrimoboxEmployeeStatus';
  employeeId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  messages: Array<Scalars['String']>;
  status: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for IntegrationsPrimoboxEmployeeStatus. */
export type IntegrationsPrimoboxEmployeeStatusConnection = {
  __typename?: 'IntegrationsPrimoboxEmployeeStatusConnection';
  /** A list of edges. */
  edges: Array<IntegrationsPrimoboxEmployeeStatusEdge>;
  /** A list of nodes. */
  nodes: Array<IntegrationsPrimoboxEmployeeStatus>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type IntegrationsPrimoboxEmployeeStatusEdge = {
  __typename?: 'IntegrationsPrimoboxEmployeeStatusEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: IntegrationsPrimoboxEmployeeStatus;
};

/** Integrations primobox feature */
export type IntegrationsPrimoboxFeature = {
  __typename?: 'IntegrationsPrimoboxFeature';
  companyId: Scalars['Int'];
  enabled: Scalars['Boolean'];
  id: Scalars['String'];
  label?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  overrideId?: Maybe<Scalars['Int']>;
};

/** Integrations primobox legal entity status */
export type IntegrationsPrimoboxLegalEntityStatus = {
  __typename?: 'IntegrationsPrimoboxLegalEntityStatus';
  id?: Maybe<Scalars['Int']>;
  messages: Array<Scalars['String']>;
  status: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for IntegrationsPrimoboxLegalEntityStatus. */
export type IntegrationsPrimoboxLegalEntityStatusConnection = {
  __typename?: 'IntegrationsPrimoboxLegalEntityStatusConnection';
  /** A list of edges. */
  edges: Array<IntegrationsPrimoboxLegalEntityStatusEdge>;
  /** A list of nodes. */
  nodes: Array<IntegrationsPrimoboxLegalEntityStatus>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type IntegrationsPrimoboxLegalEntityStatusEdge = {
  __typename?: 'IntegrationsPrimoboxLegalEntityStatusEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: IntegrationsPrimoboxLegalEntityStatus;
};

/** Integrations SyncRun */
export type IntegrationsSyncRun = {
  __typename?: 'IntegrationsSyncRun';
  finishedAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['Int'];
  parameters: Array<IntegrationsSyncRunParameters>;
  startedAt: Scalars['ISO8601DateTime'];
  status: IntegrationsSyncRunStatusEnum;
  syncRunOutput?: Maybe<IntegrationsSyncRunOutput>;
  syncableSyncRuns: Array<IntegrationsSyncableSyncRun>;
  syncableSyncRunsConnection: IntegrationsSyncableSyncRunConnection;
};


/** Integrations SyncRun */
export type IntegrationsSyncRunSyncRunOutputArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  parameters?: Array<SyncRunOutputsParametersInput>;
};


/** Integrations SyncRun */
export type IntegrationsSyncRunSyncableSyncRunsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Integrations SyncRun */
export type IntegrationsSyncRunSyncableSyncRunsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for IntegrationsSyncRun. */
export type IntegrationsSyncRunConnection = {
  __typename?: 'IntegrationsSyncRunConnection';
  /** A list of edges. */
  edges: Array<IntegrationsSyncRunEdge>;
  /** A list of nodes. */
  nodes: Array<IntegrationsSyncRun>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type IntegrationsSyncRunEdge = {
  __typename?: 'IntegrationsSyncRunEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: IntegrationsSyncRun;
};

/** the filter for the sync_runs resource */
export type IntegrationsSyncRunFilter = {
  id?: InputMaybe<IntegerFilter>;
  or?: InputMaybe<Array<IntegrationsSyncRunFilterConditions>>;
};

export type IntegrationsSyncRunFilterConditions = {
  id?: InputMaybe<IntegerFilter>;
};

export type IntegrationsSyncRunOriginEnum =
  | 'compensations'
  | 'expenses';

/** Integrations SyncRunOutput */
export type IntegrationsSyncRunOutput = {
  __typename?: 'IntegrationsSyncRunOutput';
  createdAt: Scalars['ISO8601DateTime'];
  fileName: Scalars['String'];
  fileUrl: Scalars['String'];
  id: Scalars['Int'];
  syncRunId: Scalars['Int'];
};

/** The connection type for IntegrationsSyncRunOutput. */
export type IntegrationsSyncRunOutputConnection = {
  __typename?: 'IntegrationsSyncRunOutputConnection';
  /** A list of edges. */
  edges: Array<IntegrationsSyncRunOutputEdge>;
  /** A list of nodes. */
  nodes: Array<IntegrationsSyncRunOutput>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type IntegrationsSyncRunOutputEdge = {
  __typename?: 'IntegrationsSyncRunOutputEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: IntegrationsSyncRunOutput;
};

export type IntegrationsSyncRunParameters = {
  __typename?: 'IntegrationsSyncRunParameters';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type IntegrationsSyncRunParametersInput = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export type IntegrationsSyncRunParametersSubscription = {
  __typename?: 'IntegrationsSyncRunParametersSubscription';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type IntegrationsSyncRunStatusEnum =
  | 'errored'
  | 'running'
  | 'succededwitherrors'
  | 'succeeded';

/** Integrations Sync Validation */
export type IntegrationsSyncValidation = {
  __typename?: 'IntegrationsSyncValidation';
  blockingIssues: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** The connection type for IntegrationsSyncValidation. */
export type IntegrationsSyncValidationConnection = {
  __typename?: 'IntegrationsSyncValidationConnection';
  /** A list of edges. */
  edges: Array<IntegrationsSyncValidationEdge>;
  /** A list of nodes. */
  nodes: Array<IntegrationsSyncValidation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type IntegrationsSyncValidationEdge = {
  __typename?: 'IntegrationsSyncValidationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: IntegrationsSyncValidation;
};

export type IntegrationsSyncable = CompensationsPayrollRunEmployeesCompensation;

export type IntegrationsSyncableErrorMessages = {
  __typename?: 'IntegrationsSyncableErrorMessages';
  key: Scalars['String'];
  value: Scalars['String'];
};

/** Integrations syncable states are the states of the syncable objects like compensations */
export type IntegrationsSyncableState = {
  __typename?: 'IntegrationsSyncableState';
  error?: Maybe<Scalars['Boolean']>;
  errorMessages: Array<IntegrationsSyncableErrorMessages>;
  id: Scalars['Int'];
  marketplaceIntegrationId: Scalars['Int'];
  status: IntegrationsSyncableStateStatusEnum;
  statusUpdatedAt: Scalars['ISO8601DateTime'];
  syncable?: Maybe<IntegrationsSyncable>;
  syncableId: Scalars['Int'];
  syncableType: IntegrationsSyncableTypeEnum;
};

/** The connection type for IntegrationsSyncableState. */
export type IntegrationsSyncableStateConnection = {
  __typename?: 'IntegrationsSyncableStateConnection';
  /** A list of edges. */
  edges: Array<IntegrationsSyncableStateEdge>;
  /** A list of nodes. */
  nodes: Array<IntegrationsSyncableState>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type IntegrationsSyncableStateEdge = {
  __typename?: 'IntegrationsSyncableStateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: IntegrationsSyncableState;
};

export type IntegrationsSyncableStateStatusEnum =
  | 'failed'
  | 'invalid'
  | 'outdated'
  | 'synced'
  | 'syncing';

/**
 * Integrations SyncableSyncRun represents a synchronization execution of a
 * SyncableItem within a sync run. A sync run represents each synchronization
 * execution of a set of items. This endpoint is designed to be used by integrators
 * building a integration between Factorial and an external systems.
 */
export type IntegrationsSyncableSyncRun = {
  __typename?: 'IntegrationsSyncableSyncRun';
  /** Identifier of the company */
  companyId: Scalars['Int'];
  /** Error or validation messages of the syncable sync run */
  errorMessages: Array<IntegrationsSyncableErrorMessages>;
  /** Identifier of the syncable sync run */
  id: Scalars['Int'];
  /** Status of the syncable sync run */
  status: IntegrationsSyncableSyncRunStatusEnum;
  /** Identifier of the sync run */
  syncRunId: Scalars['Int'];
  syncableState: IntegrationsSyncableState;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  syncableStateId: Scalars['Int'];
};


/**
 * Integrations SyncableSyncRun represents a synchronization execution of a
 * SyncableItem within a sync run. A sync run represents each synchronization
 * execution of a set of items. This endpoint is designed to be used by integrators
 * building a integration between Factorial and an external systems.
 */
export type IntegrationsSyncableSyncRunSyncableStateArgs = {
  marketplaceIntegrationId?: InputMaybe<Scalars['Int']>;
  syncableIds?: InputMaybe<Array<Scalars['Int']>>;
  syncableType?: InputMaybe<Scalars['String']>;
};

/** The connection type for IntegrationsSyncableSyncRun. */
export type IntegrationsSyncableSyncRunConnection = {
  __typename?: 'IntegrationsSyncableSyncRunConnection';
  /** A list of edges. */
  edges: Array<IntegrationsSyncableSyncRunEdge>;
  /** A list of nodes. */
  nodes: Array<IntegrationsSyncableSyncRun>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type IntegrationsSyncableSyncRunEdge = {
  __typename?: 'IntegrationsSyncableSyncRunEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: IntegrationsSyncableSyncRun;
};

export type IntegrationsSyncableSyncRunStatusEnum =
  | 'failed'
  | 'invalid'
  | 'success';

export type IntegrationsSyncableTypeEnum =
  | 'compensationscompensation'
  | 'expensesexpensable';

/** Autogenerated return type of Integrations_sync_run_status_change_subscription. */
export type Integrations_Sync_Run_Status_Change_SubscriptionPayload = {
  __typename?: 'Integrations_sync_run_status_change_subscriptionPayload';
  syncRun?: Maybe<Sync_Run_Status_Change_Type>;
};

/** Autogenerated return type of Integrations_syncable_state_update_subscription. */
export type Integrations_Syncable_State_Update_SubscriptionPayload = {
  __typename?: 'Integrations_syncable_state_update_subscriptionPayload';
  syncableState?: Maybe<IntegrationsSyncableState>;
};

export type IntercomContextlessPolicies = {
  __typename?: 'IntercomContextlessPolicies';
  allowIntercom: ContextlessPolicyResolution;
};

/** Autogenerated return type of InvalidateFormDataMarketplaceCompanyInstallation. */
export type InvalidateFormDataMarketplaceCompanyInstallationPayload = {
  __typename?: 'InvalidateFormDataMarketplaceCompanyInstallationPayload';
  companyInstallation?: Maybe<MarketplaceCompanyInstallation>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of InviteApicoreAccess. */
export type InviteApicoreAccessPayload = {
  __typename?: 'InviteApicoreAccessPayload';
  access?: Maybe<ApiCoreAccess>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of InviteCronofyschedulingCalendarSync. */
export type InviteCronofyschedulingCalendarSyncPayload = {
  __typename?: 'InviteCronofyschedulingCalendarSyncPayload';
  calendarSync?: Maybe<CronofySchedulingCalendarSync>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of InviteEmployeesEmployee. */
export type InviteEmployeesEmployeePayload = {
  __typename?: 'InviteEmployeesEmployeePayload';
  employee?: Maybe<EmployeesEmployee>;
  errors: Array<MutationError>;
};

export type IrisColumnSchema = {
  __typename?: 'IrisColumnSchema';
  dataType: IrisValueObjectsDataTypeEnum;
  displayName?: Maybe<Scalars['String']>;
  enumValues: Array<IrisLabeledValue>;
  formatHint?: Maybe<IrisValueObjectsFormatHintEnum>;
  items?: Maybe<IrisValueObjectsDataTypeEnum>;
  labeledEnumValues: Array<IrisLabeledValue>;
  name: Scalars['String'];
};

export type IrisColumnValue = {
  __typename?: 'IrisColumnValue';
  name: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type IrisContextlessPolicies = {
  __typename?: 'IrisContextlessPolicies';
  aiAnalyticsAiAnalyticsEnabled: ContextlessPolicyResolution;
  aiAnalyticsSeeAiAnalytics: ContextlessPolicyResolution;
  aiAnalyticsSidebarSeeAiReportsSubLevelItem: ContextlessPolicyResolution;
};

/** Analytical layer fact tables */
export type IrisFactTable = {
  __typename?: 'IrisFactTable';
  columns: Array<IrisTableColumn>;
  columnsConnection: IrisTableColumnConnection;
  description: Scalars['String'];
  engine: Scalars['String'];
  id: Scalars['String'];
  kind: IrisValueObjectsTableKindEnum;
  name: Scalars['String'];
  tag: IrisValueObjectsTableTagEnum;
};


/** Analytical layer fact tables */
export type IrisFactTableColumnsArgs = {
  companyId: Scalars['Int'];
  ids?: InputMaybe<Array<Scalars['String']>>;
};


/** Analytical layer fact tables */
export type IrisFactTableColumnsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for IrisFactTable. */
export type IrisFactTableConnection = {
  __typename?: 'IrisFactTableConnection';
  /** A list of edges. */
  edges: Array<IrisFactTableEdge>;
  /** A list of nodes. */
  nodes: Array<IrisFactTable>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type IrisFactTableEdge = {
  __typename?: 'IrisFactTableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: IrisFactTable;
};

export type IrisLabeledValue = {
  __typename?: 'IrisLabeledValue';
  label: Scalars['String'];
  value: Scalars['String'];
};

/** The result of running a SQL query against a snapshot view on the analytical layer */
export type IrisSnapshotResult = {
  __typename?: 'IrisSnapshotResult';
  id: Scalars['String'];
  schema: Array<IrisColumnSchema>;
  sqlQuery: Scalars['String'];
  values: Array<IrisColumnValue>;
};

/** The connection type for IrisSnapshotResult. */
export type IrisSnapshotResultConnection = {
  __typename?: 'IrisSnapshotResultConnection';
  /** A list of edges. */
  edges: Array<IrisSnapshotResultEdge>;
  /** A list of nodes. */
  nodes: Array<IrisSnapshotResult>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type IrisSnapshotResultEdge = {
  __typename?: 'IrisSnapshotResultEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: IrisSnapshotResult;
};

/** Analytical layer table columns */
export type IrisTableColumn = {
  __typename?: 'IrisTableColumn';
  description: Scalars['String'];
  formatHint?: Maybe<IrisValueObjectsFormatHintEnum>;
  id: Scalars['String'];
  name: Scalars['String'];
  schema: IrisColumnSchema;
  tableId: Scalars['String'];
  type: Scalars['String'];
};

/** The connection type for IrisTableColumn. */
export type IrisTableColumnConnection = {
  __typename?: 'IrisTableColumnConnection';
  /** A list of edges. */
  edges: Array<IrisTableColumnEdge>;
  /** A list of nodes. */
  nodes: Array<IrisTableColumn>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type IrisTableColumnEdge = {
  __typename?: 'IrisTableColumnEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: IrisTableColumn;
};

/** The result of running a SQL query against a traceability view on the analytical layer */
export type IrisTraceabilityResult = {
  __typename?: 'IrisTraceabilityResult';
  id: Scalars['String'];
  schema: Array<IrisColumnSchema>;
  sqlQuery: Scalars['String'];
  values: Array<IrisColumnValue>;
};

/** The connection type for IrisTraceabilityResult. */
export type IrisTraceabilityResultConnection = {
  __typename?: 'IrisTraceabilityResultConnection';
  /** A list of edges. */
  edges: Array<IrisTraceabilityResultEdge>;
  /** A list of nodes. */
  nodes: Array<IrisTraceabilityResult>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type IrisTraceabilityResultEdge = {
  __typename?: 'IrisTraceabilityResultEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: IrisTraceabilityResult;
};

export type IrisValueObjectsDataTypeEnum =
  | 'array'
  | 'boolean'
  | 'number'
  | 'string';

export type IrisValueObjectsFormatHintEnum =
  | 'array'
  | 'country_code'
  | 'date'
  | 'date_time'
  | 'duration'
  | 'employee_id'
  | 'monetary_amount'
  | 'monetary_currency'
  | 'percentage'
  | 'team_id'
  | 'time';

export type IrisValueObjectsTableKindEnum =
  | 'current'
  | 'embeddings'
  | 'snapshot'
  | 'traceability';

export type IrisValueObjectsTableTagEnum =
  | 'finance'
  | 'organization'
  | 'undefined';

/** Autogenerated return type of IsApproverApprovalsMaterializedApprovalsFlow. */
export type IsApproverApprovalsMaterializedApprovalsFlowPayload = {
  __typename?: 'IsApproverApprovalsMaterializedApprovalsFlowPayload';
  errors: Array<MutationError>;
  materializedApprovalsFlow?: Maybe<ApprovalsMaterializedApprovalsFlow>;
};

/** Asset Activity Log entries */
export type ItManagementAssetActivityLog = {
  __typename?: 'ItManagementAssetActivityLog';
  action?: Maybe<Scalars['String']>;
  author?: Maybe<ApiCoreAccess>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  authorId?: Maybe<Scalars['Int']>;
  authorName?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  label?: Maybe<Scalars['String']>;
  locationId?: Maybe<Scalars['Int']>;
  ownerId?: Maybe<Scalars['Int']>;
  purchasePriceCents?: Maybe<Scalars['Int']>;
  serialNumber?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  teamId?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['ISO8601DateTime'];
  workplaceId?: Maybe<Scalars['Int']>;
};


/** Asset Activity Log entries */
export type ItManagementAssetActivityLogAuthorArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for ItManagementAssetActivityLog. */
export type ItManagementAssetActivityLogConnection = {
  __typename?: 'ItManagementAssetActivityLogConnection';
  /** A list of edges. */
  edges: Array<ItManagementAssetActivityLogEdge>;
  /** A list of nodes. */
  nodes: Array<ItManagementAssetActivityLog>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ItManagementAssetActivityLogEdge = {
  __typename?: 'ItManagementAssetActivityLogEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ItManagementAssetActivityLog;
};

/** List employees in a company */
export type ItManagementCompanyEmployee = {
  __typename?: 'ItManagementCompanyEmployee';
  access: ApiCoreAccess;
  /**
   * Access identifier
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  accessId: Scalars['Int'];
  /** Company identifier */
  companyId: Scalars['Int'];
  /** Employee email address */
  email: Scalars['String'];
  /** Employee full name */
  employeeName: Scalars['String'];
  /** Employee first name */
  firstName: Scalars['String'];
  /** Whether the employee has any draft documents (it-asset documents with document_id is null) */
  hasDraftDocuments: Scalars['Boolean'];
  /** Whether the employee has any it-asset documents */
  hasItAssetDocuments: Scalars['Boolean'];
  /** Whether the employee has any documents to sign (it-asset documents with document_id and not signed status) */
  hasPendingSignatureDocuments: Scalars['Boolean'];
  /** Employee identifier */
  id: Scalars['Int'];
  /** Employee active status */
  isActive: Scalars['Boolean'];
  /** Employee last name */
  lastName: Scalars['String'];
  /** Employee start date */
  startDate: Scalars['ISO8601DateTime'];
  /** Total number of IT assets assigned to the employee */
  totalItAssets: Scalars['Int'];
  /** Employee workplace location */
  workplace: Scalars['String'];
};


/** List employees in a company */
export type ItManagementCompanyEmployeeAccessArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for ItManagementCompanyEmployee. */
export type ItManagementCompanyEmployeeConnection = {
  __typename?: 'ItManagementCompanyEmployeeConnection';
  /** A list of edges. */
  edges: Array<ItManagementCompanyEmployeeEdge>;
  /** A list of nodes. */
  nodes: Array<ItManagementCompanyEmployee>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ItManagementCompanyEmployeeEdge = {
  __typename?: 'ItManagementCompanyEmployeeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ItManagementCompanyEmployee;
};

/** the filter for the company_employees resource */
export type ItManagementCompanyEmployeeFilter = {
  accessId?: InputMaybe<IntegerFilter>;
  companyId?: InputMaybe<IntegerFilter>;
  email?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringFilter>;
  hasDraftDocuments?: InputMaybe<BooleanFilter>;
  hasItAssetDocuments?: InputMaybe<BooleanFilter>;
  hasPendingSignatureDocuments?: InputMaybe<BooleanFilter>;
  id?: InputMaybe<IntegerFilter>;
  isActive?: InputMaybe<BooleanFilter>;
  lastName?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<ItManagementCompanyEmployeeFilterConditions>>;
  startDate?: InputMaybe<DateTimeFilter>;
  workplace?: InputMaybe<StringFilter>;
};

export type ItManagementCompanyEmployeeFilterConditions = {
  accessId?: InputMaybe<IntegerFilter>;
  companyId?: InputMaybe<IntegerFilter>;
  email?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringFilter>;
  hasDraftDocuments?: InputMaybe<BooleanFilter>;
  hasItAssetDocuments?: InputMaybe<BooleanFilter>;
  hasPendingSignatureDocuments?: InputMaybe<BooleanFilter>;
  id?: InputMaybe<IntegerFilter>;
  isActive?: InputMaybe<BooleanFilter>;
  lastName?: InputMaybe<StringFilter>;
  startDate?: InputMaybe<DateTimeFilter>;
  workplace?: InputMaybe<StringFilter>;
};

export type ItManagementContextlessPolicies = {
  __typename?: 'ItManagementContextlessPolicies';
  manageIt: ContextlessPolicyResolution;
  settingsSeeItManagementSettings: ContextlessPolicyResolution;
  sidebarSeeDeviceCatalogItem: ContextlessPolicyResolution;
  sidebarSeeFactorialItItem: ContextlessPolicyResolution;
  sidebarSeeItManagementItem: ContextlessPolicyResolution;
};

/** Distributor Product Variant (one variant per product, grouped by product) */
export type ItManagementDistributorProductVariant = {
  __typename?: 'ItManagementDistributorProductVariant';
  /** Creation date of the distributor product variant */
  createdAt: Scalars['ISO8601DateTime'];
  /** Delivery conditions */
  deliveryConditions?: Maybe<Scalars['String']>;
  /** Product variant description */
  description?: Maybe<Scalars['String']>;
  /** Discarded at timestamp */
  discardedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Distributor identifier */
  distributorId: Scalars['String'];
  /** Cost of the first offer */
  firstOfferCost?: Maybe<Scalars['Float']>;
  /** Period of the first offer in days */
  firstOfferPeriod?: Maybe<Scalars['Int']>;
  /** URL of the first product media image */
  firstProductMediaImageUrl?: Maybe<Scalars['String']>;
  /** Distributor Product Variant identifier */
  id: Scalars['String'];
  product?: Maybe<ItManagementProduct>;
  /**
   * Product identifier
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  productId?: Maybe<Scalars['String']>;
  /** URLs of all product media images, ordered by display order */
  productMediaImageUrls: Array<Scalars['String']>;
  /** SKU code */
  sku?: Maybe<Scalars['String']>;
  /** Stock quantity */
  stock?: Maybe<Scalars['Int']>;
  /** UPC code */
  upc?: Maybe<Scalars['String']>;
  /** Last update date of the distributor product variant */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for ItManagementDistributorProductVariant. */
export type ItManagementDistributorProductVariantConnection = {
  __typename?: 'ItManagementDistributorProductVariantConnection';
  /** A list of edges. */
  edges: Array<ItManagementDistributorProductVariantEdge>;
  /** A list of nodes. */
  nodes: Array<ItManagementDistributorProductVariant>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ItManagementDistributorProductVariantEdge = {
  __typename?: 'ItManagementDistributorProductVariantEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ItManagementDistributorProductVariant;
};

/** the filter for the distributor_product_variants resource */
export type ItManagementDistributorProductVariantFilter = {
  createdAt?: InputMaybe<DateTimeFilter>;
  deliveryConditions?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  discardedAt?: InputMaybe<DateTimeFilter>;
  distributorId?: InputMaybe<StringFilter>;
  firstOfferCost?: InputMaybe<NumberFilter>;
  firstOfferPeriod?: InputMaybe<IntegerFilter>;
  firstProductMediaImageUrl?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<ItManagementDistributorProductVariantFilterConditions>>;
  productId?: InputMaybe<StringFilter>;
  productMediaImageUrls?: InputMaybe<StringFilter>;
  sku?: InputMaybe<StringFilter>;
  stock?: InputMaybe<IntegerFilter>;
  upc?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ItManagementDistributorProductVariantFilterConditions = {
  createdAt?: InputMaybe<DateTimeFilter>;
  deliveryConditions?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  discardedAt?: InputMaybe<DateTimeFilter>;
  distributorId?: InputMaybe<StringFilter>;
  firstOfferCost?: InputMaybe<NumberFilter>;
  firstOfferPeriod?: InputMaybe<IntegerFilter>;
  firstProductMediaImageUrl?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  productId?: InputMaybe<StringFilter>;
  productMediaImageUrls?: InputMaybe<StringFilter>;
  sku?: InputMaybe<StringFilter>;
  stock?: InputMaybe<IntegerFilter>;
  upc?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

/** IT Management Document Template for asset assignment/unassignment documents */
export type ItManagementDocumentTemplate = {
  __typename?: 'ItManagementDocumentTemplate';
  /** Company identifier */
  companyId: Scalars['Int'];
  /** Creation date of the document template */
  createdAt: Scalars['ISO8601DateTime'];
  /** Soft delete timestamp */
  discardedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Document Template identifier */
  id: Scalars['String'];
  /** Primary language code for the template */
  language: Scalars['String'];
  /** Second language code (required if two_languages is true) */
  languageSecond?: Maybe<Scalars['String']>;
  /** Policy text that appears before the asset table in the document */
  policyText?: Maybe<Scalars['String']>;
  /** Policy text in second language */
  policyTextSecondLanguage?: Maybe<Scalars['String']>;
  /**
   * Type of document template. Possible values:
   * - `assign`: Template for asset assignment documents
   * - `unassign`: Template for asset unassignment documents
   */
  templateType: Scalars['String'];
  /** Document title in primary language */
  title: Scalars['String'];
  /** Whether the template supports two languages */
  twoLanguages: Scalars['Boolean'];
  /** Last update date of the document template */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for ItManagementDocumentTemplate. */
export type ItManagementDocumentTemplateConnection = {
  __typename?: 'ItManagementDocumentTemplateConnection';
  /** A list of edges. */
  edges: Array<ItManagementDocumentTemplateEdge>;
  /** A list of nodes. */
  nodes: Array<ItManagementDocumentTemplate>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ItManagementDocumentTemplateEdge = {
  __typename?: 'ItManagementDocumentTemplateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ItManagementDocumentTemplate;
};

/** the filter for the document_templates resource */
export type ItManagementDocumentTemplateFilter = {
  companyId?: InputMaybe<IntegerFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  discardedAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  language?: InputMaybe<StringFilter>;
  languageSecond?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<ItManagementDocumentTemplateFilterConditions>>;
  policyText?: InputMaybe<StringFilter>;
  policyTextSecondLanguage?: InputMaybe<StringFilter>;
  templateType?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  twoLanguages?: InputMaybe<BooleanFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ItManagementDocumentTemplateFilterConditions = {
  companyId?: InputMaybe<IntegerFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  discardedAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  language?: InputMaybe<StringFilter>;
  languageSecond?: InputMaybe<StringFilter>;
  policyText?: InputMaybe<StringFilter>;
  policyTextSecondLanguage?: InputMaybe<StringFilter>;
  templateType?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  twoLanguages?: InputMaybe<BooleanFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

/** IT Asset (device, accessory, keys, etc) */
export type ItManagementItAsset = {
  __typename?: 'ItManagementItAsset';
  /** Company identifier */
  companyId: Scalars['Int'];
  /** Creation date of the IT asset */
  createdAt: Scalars['ISO8601DateTime'];
  /** Currency of the purchase price */
  currency?: Maybe<Scalars['String']>;
  /** Timestamp when the IT asset was soft deleted */
  discardedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** IT Asset identifier */
  id: Scalars['String'];
  itAssetModel?: Maybe<ItManagementItAssetModel>;
  /**
   * IT Asset Model identifier
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  itAssetModelId: Scalars['String'];
  /** Label of the IT asset */
  label?: Maybe<Scalars['String']>;
  location?: Maybe<SpaceControlWorkSpace>;
  /**
   * Location identifier
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  locationId?: Maybe<Scalars['Int']>;
  /** Notes about the IT asset */
  notes?: Maybe<Scalars['String']>;
  owner?: Maybe<EmployeesEmployee>;
  /**
   * Owner (employee) identifier
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  ownerId?: Maybe<Scalars['Int']>;
  /** Purchase date of the IT asset */
  purchaseDate?: Maybe<Scalars['ISO8601Date']>;
  /** Purchase price in cents */
  purchasePriceCents?: Maybe<Scalars['Int']>;
  /** Serial number of the IT asset */
  serialNumber: Scalars['String'];
  /**
   * Status of the IT asset. Possible values:
   * - `assigned`: Asset is assigned to an employee
   * - `in_stock`: Asset is available in inventory
   * - `maintenance`: Asset is under maintenance or repair
   * - `retired`: Asset has been retired or decommissioned
   *
   * Note: Not all status transitions are allowed. For example, an asset cannot be
   * directly changed from `assigned` or `in_stock` to certain other statuses
   * without proper workflow validation.
   */
  status: Scalars['String'];
  team?: Maybe<TeamsTeam>;
  /**
   * Team identifier
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  teamId?: Maybe<Scalars['Int']>;
  /** Last update date of the IT asset */
  updatedAt: Scalars['ISO8601DateTime'];
  /** Warranty end date of the IT asset */
  warrantyEndDate?: Maybe<Scalars['ISO8601Date']>;
  workplace?: Maybe<LocationsLocation>;
  /**
   * Workplace identifier
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  workplaceId?: Maybe<Scalars['Int']>;
};


/** IT Asset (device, accessory, keys, etc) */
export type ItManagementItAssetLocationArgs = {
  endTime?: InputMaybe<Scalars['String']>;
  locationIds?: Array<Scalars['Int']>;
  startTime?: InputMaybe<Scalars['String']>;
  workAreaIds?: Array<Scalars['Int']>;
};


/** IT Asset (device, accessory, keys, etc) */
export type ItManagementItAssetOwnerArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** IT Asset (device, accessory, keys, etc) */
export type ItManagementItAssetTeamArgs = {
  mainTeam?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  withMembers?: InputMaybe<Scalars['Boolean']>;
};


/** IT Asset (device, accessory, keys, etc) */
export type ItManagementItAssetWorkplaceArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  main?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};

/** The connection type for ItManagementItAsset. */
export type ItManagementItAssetConnection = {
  __typename?: 'ItManagementItAssetConnection';
  /** A list of edges. */
  edges: Array<ItManagementItAssetEdge>;
  /** A list of nodes. */
  nodes: Array<ItManagementItAsset>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** IT Asset Document for signature requests */
export type ItManagementItAssetDocument = {
  __typename?: 'ItManagementItAssetDocument';
  /** Company identifier */
  companyId: Scalars['Int'];
  /** Creation date of the IT asset document */
  createdAt: Scalars['ISO8601DateTime'];
  document?: Maybe<DocumentsDocument>;
  /** Document content type */
  documentContentType?: Maybe<Scalars['String']>;
  /** Document file extension */
  documentExtension?: Maybe<Scalars['String']>;
  /** Document file URL */
  documentFileUrl?: Maybe<Scalars['String']>;
  /** Document filename */
  documentFilename?: Maybe<Scalars['String']>;
  /**
   * Document identifier
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  documentId?: Maybe<Scalars['Int']>;
  /** Document space */
  documentSpace?: Maybe<Scalars['String']>;
  /** Type of document (assign, unassign, manually) */
  documentType: Scalars['String'];
  employee?: Maybe<EmployeesEmployee>;
  /**
   * Employee identifier
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  employeeId: Scalars['Int'];
  /** IT Asset Document identifier */
  id: Scalars['String'];
  itAsset?: Maybe<ItManagementItAsset>;
  /**
   * IT Asset identifier
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  itAssetId: Scalars['String'];
  /** Signature status */
  signatureStatus?: Maybe<Scalars['String']>;
  /** Last update date of the IT asset document */
  updatedAt: Scalars['ISO8601DateTime'];
};


/** IT Asset Document for signature requests */
export type ItManagementItAssetDocumentDocumentArgs = {
  afterDate?: InputMaybe<Scalars['ISO8601Date']>;
  beforeDate?: InputMaybe<Scalars['ISO8601Date']>;
  byBookkeeperDocuments?: InputMaybe<Scalars['Boolean']>;
  byPendingAssignment?: Scalars['Boolean'];
  byTrashBin?: Scalars['Boolean'];
  byWithoutFolder?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['Int']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  excludedType?: InputMaybe<Scalars['String']>;
  folderId?: InputMaybe<Scalars['Int']>;
  fromEmployees?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  incidenceId?: InputMaybe<Scalars['Int']>;
  includeTrashBin?: InputMaybe<Scalars['Boolean']>;
  leaveId?: InputMaybe<Scalars['Int']>;
  payrollHiringId?: InputMaybe<Scalars['Int']>;
  relationships?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  sort?: Scalars['String'];
  space?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};


/** IT Asset Document for signature requests */
export type ItManagementItAssetDocumentEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** IT Asset Document for signature requests */
export type ItManagementItAssetDocumentItAssetArgs = {
  currency?: InputMaybe<Scalars['String']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  itAssetModelIds?: InputMaybe<Array<Scalars['String']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  ownerIds?: InputMaybe<Array<Scalars['Int']>>;
  purchaseDate?: InputMaybe<Scalars['ISO8601Date']>;
  purchasePriceCents?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  serialNumbers?: InputMaybe<Array<Scalars['String']>>;
  status?: InputMaybe<ItManagementValueObjectsItAssetStatusEnum>;
  statuses?: InputMaybe<Array<ItManagementValueObjectsItAssetStatusEnum>>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  typeNames?: InputMaybe<Array<Scalars['String']>>;
  warrantyEndDate?: InputMaybe<Scalars['ISO8601Date']>;
  workplaceIds?: InputMaybe<Array<Scalars['Int']>>;
};

/** The connection type for ItManagementItAssetDocument. */
export type ItManagementItAssetDocumentConnection = {
  __typename?: 'ItManagementItAssetDocumentConnection';
  /** A list of edges. */
  edges: Array<ItManagementItAssetDocumentEdge>;
  /** A list of nodes. */
  nodes: Array<ItManagementItAssetDocument>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ItManagementItAssetDocumentEdge = {
  __typename?: 'ItManagementItAssetDocumentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ItManagementItAssetDocument;
};

/** the filter for the it_asset_documents resource */
export type ItManagementItAssetDocumentFilter = {
  companyId?: InputMaybe<IntegerFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  documentContentType?: InputMaybe<StringFilter>;
  documentExtension?: InputMaybe<StringFilter>;
  documentFileUrl?: InputMaybe<StringFilter>;
  documentFilename?: InputMaybe<StringFilter>;
  documentId?: InputMaybe<IntegerFilter>;
  documentSpace?: InputMaybe<StringFilter>;
  documentType?: InputMaybe<StringFilter>;
  employeeId?: InputMaybe<IntegerFilter>;
  id?: InputMaybe<StringFilter>;
  itAssetId?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<ItManagementItAssetDocumentFilterConditions>>;
  signatureStatus?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ItManagementItAssetDocumentFilterConditions = {
  companyId?: InputMaybe<IntegerFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  documentContentType?: InputMaybe<StringFilter>;
  documentExtension?: InputMaybe<StringFilter>;
  documentFileUrl?: InputMaybe<StringFilter>;
  documentFilename?: InputMaybe<StringFilter>;
  documentId?: InputMaybe<IntegerFilter>;
  documentSpace?: InputMaybe<StringFilter>;
  documentType?: InputMaybe<StringFilter>;
  employeeId?: InputMaybe<IntegerFilter>;
  id?: InputMaybe<StringFilter>;
  itAssetId?: InputMaybe<StringFilter>;
  signatureStatus?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

/** An edge in a connection. */
export type ItManagementItAssetEdge = {
  __typename?: 'ItManagementItAssetEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ItManagementItAsset;
};

/** the filter for the it_assets resource */
export type ItManagementItAssetFilter = {
  companyId?: InputMaybe<IntegerFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<StringFilter>;
  discardedAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  itAssetModelId?: InputMaybe<StringFilter>;
  label?: InputMaybe<StringFilter>;
  locationId?: InputMaybe<IntegerFilter>;
  notes?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<ItManagementItAssetFilterConditions>>;
  ownerId?: InputMaybe<IntegerFilter>;
  purchaseDate?: InputMaybe<DateFilter>;
  purchasePriceCents?: InputMaybe<IntegerFilter>;
  serialNumber?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
  teamId?: InputMaybe<IntegerFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  warrantyEndDate?: InputMaybe<DateFilter>;
  workplaceId?: InputMaybe<IntegerFilter>;
};

export type ItManagementItAssetFilterConditions = {
  companyId?: InputMaybe<IntegerFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<StringFilter>;
  discardedAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  itAssetModelId?: InputMaybe<StringFilter>;
  label?: InputMaybe<StringFilter>;
  locationId?: InputMaybe<IntegerFilter>;
  notes?: InputMaybe<StringFilter>;
  ownerId?: InputMaybe<IntegerFilter>;
  purchaseDate?: InputMaybe<DateFilter>;
  purchasePriceCents?: InputMaybe<IntegerFilter>;
  serialNumber?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
  teamId?: InputMaybe<IntegerFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  warrantyEndDate?: InputMaybe<DateFilter>;
  workplaceId?: InputMaybe<IntegerFilter>;
};

/** IT Asset Model (make/model of device) */
export type ItManagementItAssetModel = {
  __typename?: 'ItManagementItAssetModel';
  /** Brand of the IT asset model */
  brand: Scalars['String'];
  /** Company identifier */
  companyId: Scalars['Int'];
  /** Creation date of the IT asset model */
  createdAt: Scalars['ISO8601DateTime'];
  /** IT Asset Model identifier */
  id: Scalars['String'];
  /** Name/model of the IT asset */
  name: Scalars['String'];
  /**
   * Type name of the IT asset model. Possible values are 'laptop', 'phone',
   * 'accessory', 'screen', 'mouse', 'keyboard', 'headset', 'other'
   */
  typeName: Scalars['String'];
  /** Last update date of the IT asset model */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for ItManagementItAssetModel. */
export type ItManagementItAssetModelConnection = {
  __typename?: 'ItManagementItAssetModelConnection';
  /** A list of edges. */
  edges: Array<ItManagementItAssetModelEdge>;
  /** A list of nodes. */
  nodes: Array<ItManagementItAssetModel>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ItManagementItAssetModelEdge = {
  __typename?: 'ItManagementItAssetModelEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ItManagementItAssetModel;
};

/** the filter for the it_asset_models resource */
export type ItManagementItAssetModelFilter = {
  brand?: InputMaybe<StringFilter>;
  companyId?: InputMaybe<IntegerFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<ItManagementItAssetModelFilterConditions>>;
  typeName?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ItManagementItAssetModelFilterConditions = {
  brand?: InputMaybe<StringFilter>;
  companyId?: InputMaybe<IntegerFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  typeName?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

/** Get stock availability for IT asset models during onboarding */
export type ItManagementItAssetModelsStock = {
  __typename?: 'ItManagementItAssetModelsStock';
  hasStock: Scalars['Boolean'];
  id: Scalars['String'];
  itAssetId?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
};

/** The connection type for ItManagementItAssetModelsStock. */
export type ItManagementItAssetModelsStockConnection = {
  __typename?: 'ItManagementItAssetModelsStockConnection';
  /** A list of edges. */
  edges: Array<ItManagementItAssetModelsStockEdge>;
  /** A list of nodes. */
  nodes: Array<ItManagementItAssetModelsStock>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ItManagementItAssetModelsStockEdge = {
  __typename?: 'ItManagementItAssetModelsStockEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ItManagementItAssetModelsStock;
};

/** IT Management Legal Entity Document Template Settings for configuring templates per legal entity */
export type ItManagementLegalEntityDocumentTemplateSetting = {
  __typename?: 'ItManagementLegalEntityDocumentTemplateSetting';
  /** Document template ID for asset assignment documents */
  assignedDocumentTemplateId?: Maybe<Scalars['String']>;
  /** Company identifier */
  companyId: Scalars['Int'];
  /** Creation date of the setting */
  createdAt: Scalars['String'];
  /** Legal Entity Document Template Setting identifier */
  id: Scalars['String'];
  /** Legal Entity identifier */
  legalEntityId: Scalars['Int'];
  /** Document template ID for asset unassignment documents */
  unassignedDocumentTemplateId?: Maybe<Scalars['String']>;
  /** Last update date of the setting */
  updatedAt: Scalars['String'];
};

/** The connection type for ItManagementLegalEntityDocumentTemplateSetting. */
export type ItManagementLegalEntityDocumentTemplateSettingConnection = {
  __typename?: 'ItManagementLegalEntityDocumentTemplateSettingConnection';
  /** A list of edges. */
  edges: Array<ItManagementLegalEntityDocumentTemplateSettingEdge>;
  /** A list of nodes. */
  nodes: Array<ItManagementLegalEntityDocumentTemplateSetting>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ItManagementLegalEntityDocumentTemplateSettingEdge = {
  __typename?: 'ItManagementLegalEntityDocumentTemplateSettingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ItManagementLegalEntityDocumentTemplateSetting;
};

/** the filter for the legal_entity_document_template_settings resource */
export type ItManagementLegalEntityDocumentTemplateSettingFilter = {
  assignedDocumentTemplate?: InputMaybe<StringFilter>;
  assignedDocumentTemplateId?: InputMaybe<StringFilter>;
  companyId?: InputMaybe<IntegerFilter>;
  createdAt?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  legalEntity?: InputMaybe<StringFilter>;
  legalEntityId?: InputMaybe<IntegerFilter>;
  or?: InputMaybe<Array<ItManagementLegalEntityDocumentTemplateSettingFilterConditions>>;
  unassignedDocumentTemplate?: InputMaybe<StringFilter>;
  unassignedDocumentTemplateId?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<StringFilter>;
};

export type ItManagementLegalEntityDocumentTemplateSettingFilterConditions = {
  assignedDocumentTemplate?: InputMaybe<StringFilter>;
  assignedDocumentTemplateId?: InputMaybe<StringFilter>;
  companyId?: InputMaybe<IntegerFilter>;
  createdAt?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  legalEntity?: InputMaybe<StringFilter>;
  legalEntityId?: InputMaybe<IntegerFilter>;
  unassignedDocumentTemplate?: InputMaybe<StringFilter>;
  unassignedDocumentTemplateId?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<StringFilter>;
};

/** IT Management Order */
export type ItManagementOrder = {
  __typename?: 'ItManagementOrder';
  /** Company identifier */
  companyId: Scalars['Int'];
  /** Creation date */
  createdAt: Scalars['ISO8601DateTime'];
  /** Distributor offer identifier */
  distributorOfferId?: Maybe<Scalars['String']>;
  /** Contact email */
  email: Scalars['String'];
  employee?: Maybe<EmployeesEmployee>;
  /**
   * Employee identifier
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  employeeId: Scalars['Int'];
  /** Order identifier */
  id: Scalars['String'];
  /** Order notes */
  notes: Scalars['String'];
  /** Contact phone */
  phone?: Maybe<Scalars['String']>;
  /** Order quantity */
  quantity: Scalars['Int'];
  /**
   * Order status. Possible values:
   * - `open`: Order has been created
   * - `confirmed`: Order has been confirmed
   * - `delivered`: Order has been delivered
   * - `closed`: Order has been closed
   */
  status: Scalars['String'];
  /** Last update date */
  updatedAt: Scalars['ISO8601DateTime'];
  variation?: Maybe<ItManagementDistributorProductVariant>;
  /**
   * Distributor product variation identifier
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  variationId?: Maybe<Scalars['String']>;
};


/** IT Management Order */
export type ItManagementOrderEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** IT Management Order */
export type ItManagementOrderVariationArgs = {
  search?: InputMaybe<Scalars['String']>;
};

/** Product (hardware product catalog) */
export type ItManagementProduct = {
  __typename?: 'ItManagementProduct';
  /** Brand of the product */
  brand?: Maybe<Scalars['String']>;
  /** Creation date of the product */
  createdAt: Scalars['ISO8601DateTime'];
  /** Description of the product */
  description?: Maybe<Scalars['String']>;
  /** Product identifier */
  id: Scalars['String'];
  /** Name/model of the product */
  name?: Maybe<Scalars['String']>;
  /** Type name of the product. Possible values are 'hardware' */
  typeName?: Maybe<Scalars['String']>;
  /** Last update date of the product */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for ItManagementProduct. */
export type ItManagementProductConnection = {
  __typename?: 'ItManagementProductConnection';
  /** A list of edges. */
  edges: Array<ItManagementProductEdge>;
  /** A list of nodes. */
  nodes: Array<ItManagementProduct>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ItManagementProductEdge = {
  __typename?: 'ItManagementProductEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ItManagementProduct;
};

/** the filter for the products resource */
export type ItManagementProductFilter = {
  brand?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<ItManagementProductFilterConditions>>;
  typeName?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ItManagementProductFilterConditions = {
  brand?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  typeName?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ItManagementValueObjectsItAssetDocumentTypeEnum =
  | 'assign'
  | 'unassign';

export type ItManagementValueObjectsItAssetStatusEnum =
  | 'assigned'
  | 'in_stock'
  | 'maintenance'
  | 'retired';

export type JobCatalogCompetencyAttribute = {
  __typename?: 'JobCatalogCompetencyAttribute';
  description?: Maybe<Scalars['String']>;
  level?: Maybe<JobCatalogCompetencyLevel>;
  name?: Maybe<Scalars['String']>;
};

export type JobCatalogCompetencyAttributeInput = {
  description?: InputMaybe<Scalars['String']>;
  level?: InputMaybe<JobCatalogCompetencyLevelInput>;
  name?: InputMaybe<Scalars['String']>;
};

export type JobCatalogCompetencyLevel = {
  __typename?: 'JobCatalogCompetencyLevel';
  description: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type JobCatalogCompetencyLevelInput = {
  description: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type JobCatalogContextlessPolicies = {
  __typename?: 'JobCatalogContextlessPolicies';
  createJob: ContextlessPolicyResolution;
  editJob: ContextlessPolicyResolution;
  jobCatalogTreeManage: ContextlessPolicyResolution;
  jobCatalogTreeReimport: ContextlessPolicyResolution;
  jobCatalogTreeSee: ContextlessPolicyResolution;
  seeJobCatalog: ContextlessPolicyResolution;
  sidebarSeeEmployeesJobCatalogSubLevelItem: ContextlessPolicyResolution;
};

/** Job Catalog Employees Salary Ranges Conformance */
export type JobCatalogEmployeesSalaryRangesConformance = {
  __typename?: 'JobCatalogEmployeesSalaryRangesConformance';
  inRangeCount: Scalars['Int'];
  outOfRangeCount: Scalars['Int'];
};

/** The connection type for JobCatalogEmployeesSalaryRangesConformance. */
export type JobCatalogEmployeesSalaryRangesConformanceConnection = {
  __typename?: 'JobCatalogEmployeesSalaryRangesConformanceConnection';
  /** A list of edges. */
  edges: Array<JobCatalogEmployeesSalaryRangesConformanceEdge>;
  /** A list of nodes. */
  nodes: Array<JobCatalogEmployeesSalaryRangesConformance>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type JobCatalogEmployeesSalaryRangesConformanceEdge = {
  __typename?: 'JobCatalogEmployeesSalaryRangesConformanceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: JobCatalogEmployeesSalaryRangesConformance;
};

export type JobCatalogEnumsJobCatalogTreeAttributeTypesEnum =
  | 'competency'
  | 'it_management'
  | 'salary_range'
  | 'working_conditions';

export type JobCatalogEnumsJobCatalogTreeNodeTypesEnum =
  | 'jobcatalog_treefamily'
  | 'jobcatalog_treefunction'
  | 'jobcatalog_treelevel'
  | 'jobcatalog_treerole'
  | 'jobcatalog_treeroot';

/** Job Catalog Expectations */
export type JobCatalogExpectation = {
  __typename?: 'JobCatalogExpectation';
  competency?: Maybe<CompetenciesCompetency>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  competencyId: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  level?: Maybe<JobCatalogLevel>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  levelId: Scalars['Int'];
  role?: Maybe<JobCatalogRole>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  roleId: Scalars['Int'];
};


/** Job Catalog Expectations */
export type JobCatalogExpectationCompetencyArgs = {
  competencyGroupIds?: InputMaybe<Array<Scalars['String']>>;
  everyone?: InputMaybe<Scalars['Boolean']>;
  roleIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  withDeleted?: InputMaybe<Scalars['Boolean']>;
};


/** Job Catalog Expectations */
export type JobCatalogExpectationLevelArgs = {
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  includeArchived?: Scalars['Boolean'];
  includeArchivedRole?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  roleIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Job Catalog Expectations */
export type JobCatalogExpectationRoleArgs = {
  includeArchived?: Scalars['Boolean'];
  jobCatalogLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  legalEntitiesIds?: InputMaybe<Array<Scalars['Int']>>;
};

/** The connection type for JobCatalogExpectation. */
export type JobCatalogExpectationConnection = {
  __typename?: 'JobCatalogExpectationConnection';
  /** A list of edges. */
  edges: Array<JobCatalogExpectationEdge>;
  /** A list of nodes. */
  nodes: Array<JobCatalogExpectation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type JobCatalogExpectationEdge = {
  __typename?: 'JobCatalogExpectationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: JobCatalogExpectation;
};

export type JobCatalogItManagementAssetAttribute = {
  __typename?: 'JobCatalogItManagementAssetAttribute';
  brand: Scalars['String'];
  name: Scalars['String'];
  typeName: Scalars['String'];
};

export type JobCatalogItManagementAssetAttributeInput = {
  brand: Scalars['String'];
  name: Scalars['String'];
  typeName: Scalars['String'];
};

export type JobCatalogItem = {
  __typename?: 'JobCatalogItem';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type JobCatalogItemInput = {
  key: Scalars['String'];
  value: Scalars['String'];
};

/** Job Catalog Levels */
export type JobCatalogLevel = {
  __typename?: 'JobCatalogLevel';
  /** Shows if the role is archived. */
  archived: Scalars['Boolean'];
  /** identifier for the job catalog level. */
  id: Scalars['Int'];
  /** Shows if the level is the default one. */
  isDefault: Scalars['Boolean'];
  /** Level name. */
  name: Scalars['String'];
  /** Order of the level. */
  order: Scalars['Int'];
  referenceContracts: Array<ContractsReferenceContract>;
  referenceContractsConnection: ContractsReferenceContractConnection;
  role?: Maybe<JobCatalogRole>;
  /**
   * identifier for the job catalog role.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  roleId: Scalars['Int'];
  /** Role name. */
  roleName: Scalars['String'];
  salaryRanges: Array<JobCatalogSalaryRange>;
  salaryRangesConnection: JobCatalogSalaryRangeConnection;
};


/** Job Catalog Levels */
export type JobCatalogLevelReferenceContractsArgs = {
  activeBetween?: InputMaybe<ReferenceContractsActiveBetweenInput>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  effectiveOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endsOnGt?: InputMaybe<Scalars['ISO8601Date']>;
  endsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  frContractTypeIds?: InputMaybe<Array<Scalars['Int']>>;
  frMutualIds?: InputMaybe<Array<Scalars['Int']>>;
  frWorkTypeIds?: InputMaybe<Array<Scalars['Int']>>;
  includeDenormalizedData?: Scalars['Boolean'];
  includeEducationLevel?: Scalars['Boolean'];
  jobCatalogTreeNodeUuids?: InputMaybe<Array<Scalars['String']>>;
  onDate?: InputMaybe<Scalars['ISO8601Date']>;
  payrollPolicyId?: InputMaybe<Scalars['Int']>;
  startsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  startsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedBecauseRelatedModels?: InputMaybe<Scalars['Boolean']>;
  withPayroll?: InputMaybe<Scalars['Boolean']>;
  withTranslations?: InputMaybe<Scalars['Boolean']>;
};


/** Job Catalog Levels */
export type JobCatalogLevelReferenceContractsConnectionArgs = {
  activeBetween?: InputMaybe<ReferenceContractsActiveBetweenInput>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  effectiveOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endsOnGt?: InputMaybe<Scalars['ISO8601Date']>;
  endsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  first?: InputMaybe<Scalars['Int']>;
  frContractTypeIds?: InputMaybe<Array<Scalars['Int']>>;
  frMutualIds?: InputMaybe<Array<Scalars['Int']>>;
  frWorkTypeIds?: InputMaybe<Array<Scalars['Int']>>;
  includeDenormalizedData?: Scalars['Boolean'];
  includeEducationLevel?: Scalars['Boolean'];
  jobCatalogTreeNodeUuids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onDate?: InputMaybe<Scalars['ISO8601Date']>;
  payrollPolicyId?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  startsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedBecauseRelatedModels?: InputMaybe<Scalars['Boolean']>;
  withPayroll?: InputMaybe<Scalars['Boolean']>;
  withTranslations?: InputMaybe<Scalars['Boolean']>;
};


/** Job Catalog Levels */
export type JobCatalogLevelRoleArgs = {
  includeArchived?: Scalars['Boolean'];
  jobCatalogLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  legalEntitiesIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Job Catalog Levels */
export type JobCatalogLevelSalaryRangesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  roleId?: InputMaybe<Scalars['Int']>;
};


/** Job Catalog Levels */
export type JobCatalogLevelSalaryRangesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  roleId?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for JobCatalogLevel. */
export type JobCatalogLevelConnection = {
  __typename?: 'JobCatalogLevelConnection';
  /** A list of edges. */
  edges: Array<JobCatalogLevelEdge>;
  /** A list of nodes. */
  nodes: Array<JobCatalogLevel>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type JobCatalogLevelEdge = {
  __typename?: 'JobCatalogLevelEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: JobCatalogLevel;
};

/** JobCatalog Node Attributes */
export type JobCatalogNodeAttribute = {
  __typename?: 'JobCatalogNodeAttribute';
  /**
   * Identifier of the attribute being assigned to the node it it makes sense like
   * in competecies, but not for working_conditions
   */
  attributeId?: Maybe<Scalars['String']>;
  /** The node type where the attribute is defined (Family, Function, Role or Level) */
  definedAt: JobCatalogEnumsJobCatalogTreeNodeTypesEnum;
  /** The node where the attribute is defined */
  definedAtNode: JobCatalogTreeNodePath;
  /** Effective date when the attribute becomes active */
  effectiveDate?: Maybe<Scalars['ISO8601Date']>;
  /** Unique identifier of the node attribute */
  id: Scalars['Int'];
  /** Type of inheritance for the attribute. Valid values: Final, Overridable */
  inheritanceType: Scalars['String'];
  /** Serialized value of the attribute */
  serializedValue: Scalars['String'];
  /** Whether this attribute takes precedence over other attributes */
  takesPrecedence: Scalars['Boolean'];
  /** Type of the attribute (e.g., competency, salary_range, working_conditions, it_management_asset) */
  type: Scalars['String'];
  /** Competency payload including name, short description and optional level metadata */
  valueCompetency?: Maybe<JobCatalogCompetencyAttribute>;
  /** IT asset payload describing the device assigned to the node */
  valueItManagementAsset?: Maybe<JobCatalogItManagementAssetAttribute>;
  /**
   * Salary payload (cents) with currency, periodicity, range (min and max) or
   * gross values in cents (35.000 EUR is stored as 3500000) and optional workplaces
   */
  valueSalaryRange?: Maybe<JobCatalogSalaryRangeAttribute>;
  /**
   * Working-conditions payload with agreement info and simple key/value
   * constraints. Numeric values are stored in cents (40 hours is stored as 4000).
   */
  valueWorkingConditions?: Maybe<JobCatalogWorkingConditionsAttribute>;
};

/** The connection type for JobCatalogNodeAttribute. */
export type JobCatalogNodeAttributeConnection = {
  __typename?: 'JobCatalogNodeAttributeConnection';
  /** A list of edges. */
  edges: Array<JobCatalogNodeAttributeEdge>;
  /** A list of nodes. */
  nodes: Array<JobCatalogNodeAttribute>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type JobCatalogNodeAttributeEdge = {
  __typename?: 'JobCatalogNodeAttributeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: JobCatalogNodeAttribute;
};

/** JobCatalog People */
export type JobCatalogPerson = {
  __typename?: 'JobCatalogPerson';
  /** Employee contract salary amount (in company currency units). */
  contractSalaryAmount?: Maybe<Scalars['BigInt']>;
  employeeAccessId?: Maybe<Scalars['Int']>;
  employeeFullName: Scalars['String'];
  employeeGender?: Maybe<Scalars['String']>;
  employeeId: Scalars['Int'];
  employeeSeniorityDate?: Maybe<Scalars['ISO8601Date']>;
  jobcatalogtreeFamily?: Maybe<JobCatalogTreeNodePath>;
  jobcatalogtreeFunction?: Maybe<JobCatalogTreeNodePath>;
  jobcatalogtreeLevel?: Maybe<JobCatalogTreeNodePath>;
  jobcatalogtreeRole?: Maybe<JobCatalogTreeNodePath>;
  jobcatalogtreeRoot?: Maybe<JobCatalogTreeNodePath>;
};

/** The connection type for JobCatalogPerson. */
export type JobCatalogPersonConnection = {
  __typename?: 'JobCatalogPersonConnection';
  /** A list of edges. */
  edges: Array<JobCatalogPersonEdge>;
  /** A list of nodes. */
  nodes: Array<JobCatalogPerson>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type JobCatalogPersonEdge = {
  __typename?: 'JobCatalogPersonEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: JobCatalogPerson;
};

/** Job Catalog Roles */
export type JobCatalogRole = {
  __typename?: 'JobCatalogRole';
  _policies?: Maybe<JobCatalogRolePolicies>;
  _policiesCollection?: Maybe<Array<PermissionsPolicyResolution>>;
  _policiesConnection: PermissionsPolicyResolutionConnection;
  /** Shows if the role is archived. */
  archived: Scalars['Boolean'];
  /** Identifier for the company. */
  companyId: Scalars['Int'];
  competencies: Array<CompetenciesCompetency>;
  competenciesConnection: CompetenciesCompetencyConnection;
  /**
   * List of competencies.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  competenciesIds?: Maybe<Array<Scalars['Int']>>;
  /** Role description. */
  description?: Maybe<Scalars['String']>;
  expectations: Array<JobCatalogExpectation>;
  expectationsConnection: JobCatalogExpectationConnection;
  /** identifier for the job catalog role. */
  id: Scalars['Int'];
  legalEntities: Array<CompaniesLegalEntity>;
  legalEntitiesConnection: CompaniesLegalEntityConnection;
  /**
   * List of legal entities.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  legalEntitiesIds: Array<Scalars['Int']>;
  levels: Array<JobCatalogLevel>;
  levelsConnection: JobCatalogLevelConnection;
  /** Role name. */
  name: Scalars['String'];
  supervisors: Array<EmployeesEmployee>;
  supervisorsConnection: EmployeesEmployeeConnection;
  /**
   * List of supervisors.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  supervisorsIds?: Maybe<Array<Scalars['Int']>>;
};


/** Job Catalog Roles */
export type JobCatalogRole_PoliciesCollectionArgs = {
  ids: Array<JobCatalogRolePoliciesEnum>;
};


/** Job Catalog Roles */
export type JobCatalogRole_PoliciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Job Catalog Roles */
export type JobCatalogRoleCompetenciesArgs = {
  competencyGroupIds?: InputMaybe<Array<Scalars['String']>>;
  everyone?: InputMaybe<Scalars['Boolean']>;
  roleIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  withDeleted?: InputMaybe<Scalars['Boolean']>;
};


/** Job Catalog Roles */
export type JobCatalogRoleCompetenciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  competencyGroupIds?: InputMaybe<Array<Scalars['String']>>;
  everyone?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  roleIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  withDeleted?: InputMaybe<Scalars['Boolean']>;
};


/** Job Catalog Roles */
export type JobCatalogRoleExpectationsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  levelIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Job Catalog Roles */
export type JobCatalogRoleExpectationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  levelIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Job Catalog Roles */
export type JobCatalogRoleLegalEntitiesArgs = {
  companiesIds?: InputMaybe<Array<Scalars['Int']>>;
  countryIds?: InputMaybe<Array<Scalars['String']>>;
  employeesIds?: InputMaybe<Array<Scalars['Int']>>;
  excludeCountries?: InputMaybe<Array<Scalars['String']>>;
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


/** Job Catalog Roles */
export type JobCatalogRoleLegalEntitiesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companiesIds?: InputMaybe<Array<Scalars['Int']>>;
  countryIds?: InputMaybe<Array<Scalars['String']>>;
  employeesIds?: InputMaybe<Array<Scalars['Int']>>;
  excludeCountries?: InputMaybe<Array<Scalars['String']>>;
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Job Catalog Roles */
export type JobCatalogRoleLevelsArgs = {
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeArchived?: Scalars['Boolean'];
  includeArchivedRole?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Job Catalog Roles */
export type JobCatalogRoleLevelsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeArchived?: Scalars['Boolean'];
  includeArchivedRole?: Scalars['Boolean'];
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Job Catalog Roles */
export type JobCatalogRoleSupervisorsArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Job Catalog Roles */
export type JobCatalogRoleSupervisorsConnectionArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  after?: InputMaybe<Scalars['String']>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Sort>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};

/** Job Catalog Role Competency Suggestion */
export type JobCatalogRoleCompetencySuggestion = {
  __typename?: 'JobCatalogRoleCompetencySuggestion';
  competencyDescription: Scalars['String'];
  competencyId?: Maybe<Scalars['Int']>;
  competencyName: Scalars['String'];
};

/** The connection type for JobCatalogRoleCompetencySuggestion. */
export type JobCatalogRoleCompetencySuggestionConnection = {
  __typename?: 'JobCatalogRoleCompetencySuggestionConnection';
  /** A list of edges. */
  edges: Array<JobCatalogRoleCompetencySuggestionEdge>;
  /** A list of nodes. */
  nodes: Array<JobCatalogRoleCompetencySuggestion>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type JobCatalogRoleCompetencySuggestionEdge = {
  __typename?: 'JobCatalogRoleCompetencySuggestionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: JobCatalogRoleCompetencySuggestion;
};

/** The connection type for JobCatalogRole. */
export type JobCatalogRoleConnection = {
  __typename?: 'JobCatalogRoleConnection';
  /** A list of edges. */
  edges: Array<JobCatalogRoleEdge>;
  /** A list of nodes. */
  nodes: Array<JobCatalogRole>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type JobCatalogRoleEdge = {
  __typename?: 'JobCatalogRoleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: JobCatalogRole;
};

export type JobCatalogRolePolicies = {
  __typename?: 'JobCatalogRolePolicies';
  editJob: PermissionsPolicyResolution;
};

export type JobCatalogRolePoliciesEnum =
  | 'editJob';

/** Job Catalog Role Salary Ranges Conformance */
export type JobCatalogRoleSalaryRangesConformance = {
  __typename?: 'JobCatalogRoleSalaryRangesConformance';
  inRangeCount: Scalars['Int'];
  outOfRangeCount: Scalars['Int'];
};

/** The connection type for JobCatalogRoleSalaryRangesConformance. */
export type JobCatalogRoleSalaryRangesConformanceConnection = {
  __typename?: 'JobCatalogRoleSalaryRangesConformanceConnection';
  /** A list of edges. */
  edges: Array<JobCatalogRoleSalaryRangesConformanceEdge>;
  /** A list of nodes. */
  nodes: Array<JobCatalogRoleSalaryRangesConformance>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type JobCatalogRoleSalaryRangesConformanceEdge = {
  __typename?: 'JobCatalogRoleSalaryRangesConformanceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: JobCatalogRoleSalaryRangesConformance;
};

/** Job catalog salaries distribution */
export type JobCatalogSalariesDistribution = {
  __typename?: 'JobCatalogSalariesDistribution';
  companyId: Scalars['Int'];
  contractCuratedSalary?: Maybe<Scalars['Float']>;
  contractSalary?: Maybe<Scalars['Float']>;
  contractSalaryFrequency?: Maybe<Scalars['String']>;
  curatedJobCatalogLevelSalaryMaxRange?: Maybe<Scalars['Int']>;
  curatedJobCatalogLevelSalaryMinRange?: Maybe<Scalars['Int']>;
  employee?: Maybe<EmployeesEmployee>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  employeeId: Scalars['Int'];
  gender?: Maybe<Scalars['String']>;
  jobCatalogLevel?: Maybe<Scalars['String']>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  jobCatalogLevelId?: Maybe<Scalars['Int']>;
  jobCatalogLevelOrder?: Maybe<Scalars['Int']>;
  jobCatalogLevelSalaryAmountType?: Maybe<Scalars['String']>;
  jobCatalogLevelSalaryCurrency?: Maybe<Scalars['String']>;
  jobCatalogLevelSalaryFrequency?: Maybe<Scalars['String']>;
  jobCatalogLevelSalaryMaxRange?: Maybe<Scalars['Int']>;
  jobCatalogLevelSalaryMinRange?: Maybe<Scalars['Int']>;
  jobCatalogRole?: Maybe<Scalars['String']>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  jobCatalogRoleId?: Maybe<Scalars['Int']>;
  jobLevel?: Maybe<JobCatalogLevel>;
  jobRole?: Maybe<JobCatalogRole>;
  legalEntity?: Maybe<CompaniesLegalEntity>;
  legalEntityCurrency?: Maybe<Scalars['String']>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  legalEntityId: Scalars['Int'];
  nationality?: Maybe<Scalars['String']>;
};


/** Job catalog salaries distribution */
export type JobCatalogSalariesDistributionEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Job catalog salaries distribution */
export type JobCatalogSalariesDistributionJobLevelArgs = {
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  includeArchived?: Scalars['Boolean'];
  includeArchivedRole?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  roleIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Job catalog salaries distribution */
export type JobCatalogSalariesDistributionJobRoleArgs = {
  includeArchived?: Scalars['Boolean'];
  jobCatalogLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  legalEntitiesIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Job catalog salaries distribution */
export type JobCatalogSalariesDistributionLegalEntityArgs = {
  companiesIds?: InputMaybe<Array<Scalars['Int']>>;
  countryIds?: InputMaybe<Array<Scalars['String']>>;
  employeesIds?: InputMaybe<Array<Scalars['Int']>>;
  excludeCountries?: InputMaybe<Array<Scalars['String']>>;
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};

/** The connection type for JobCatalogSalariesDistribution. */
export type JobCatalogSalariesDistributionConnection = {
  __typename?: 'JobCatalogSalariesDistributionConnection';
  /** A list of edges. */
  edges: Array<JobCatalogSalariesDistributionEdge>;
  /** A list of nodes. */
  nodes: Array<JobCatalogSalariesDistribution>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type JobCatalogSalariesDistributionEdge = {
  __typename?: 'JobCatalogSalariesDistributionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: JobCatalogSalariesDistribution;
};

/** Job Catalog Salary Ranges */
export type JobCatalogSalaryRange = {
  __typename?: 'JobCatalogSalaryRange';
  amountType: Scalars['String'];
  currency: Scalars['String'];
  id: Scalars['Int'];
  legalEntities: Array<CompaniesLegalEntity>;
  legalEntitiesConnection: CompaniesLegalEntityConnection;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  legalEntitiesIds: Array<Scalars['Int']>;
  level?: Maybe<JobCatalogLevel>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  levelId: Scalars['Int'];
  maxRange: Scalars['Int'];
  minRange: Scalars['Int'];
  salaryFrequency: Scalars['String'];
};


/** Job Catalog Salary Ranges */
export type JobCatalogSalaryRangeLegalEntitiesArgs = {
  companiesIds?: InputMaybe<Array<Scalars['Int']>>;
  countryIds?: InputMaybe<Array<Scalars['String']>>;
  employeesIds?: InputMaybe<Array<Scalars['Int']>>;
  excludeCountries?: InputMaybe<Array<Scalars['String']>>;
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


/** Job Catalog Salary Ranges */
export type JobCatalogSalaryRangeLegalEntitiesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companiesIds?: InputMaybe<Array<Scalars['Int']>>;
  countryIds?: InputMaybe<Array<Scalars['String']>>;
  employeesIds?: InputMaybe<Array<Scalars['Int']>>;
  excludeCountries?: InputMaybe<Array<Scalars['String']>>;
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Job Catalog Salary Ranges */
export type JobCatalogSalaryRangeLevelArgs = {
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  includeArchived?: Scalars['Boolean'];
  includeArchivedRole?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  roleIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type JobCatalogSalaryRangeAttribute = {
  __typename?: 'JobCatalogSalaryRangeAttribute';
  currency: Scalars['String'];
  gross?: Maybe<Scalars['BigInt']>;
  max?: Maybe<Scalars['BigInt']>;
  min?: Maybe<Scalars['BigInt']>;
  periodicity?: Maybe<Scalars['String']>;
  workplaces?: Maybe<Array<JobCatalogSalaryWorkplace>>;
};

export type JobCatalogSalaryRangeAttributeInput = {
  currency: Scalars['String'];
  gross?: InputMaybe<Scalars['Int']>;
  max?: InputMaybe<Scalars['Int']>;
  min?: InputMaybe<Scalars['Int']>;
  periodicity?: InputMaybe<Scalars['String']>;
  workplaces?: InputMaybe<Array<JobCatalogSalaryWorkplaceInput>>;
};

/** The connection type for JobCatalogSalaryRange. */
export type JobCatalogSalaryRangeConnection = {
  __typename?: 'JobCatalogSalaryRangeConnection';
  /** A list of edges. */
  edges: Array<JobCatalogSalaryRangeEdge>;
  /** A list of nodes. */
  nodes: Array<JobCatalogSalaryRange>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type JobCatalogSalaryRangeEdge = {
  __typename?: 'JobCatalogSalaryRangeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: JobCatalogSalaryRange;
};

export type JobCatalogSalaryWorkplace = {
  __typename?: 'JobCatalogSalaryWorkplace';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type JobCatalogSalaryWorkplaceInput = {
  id: Scalars['Int'];
  name: Scalars['String'];
};

/** JobCatalog Tree */
export type JobCatalogTree = {
  __typename?: 'JobCatalogTree';
  companyId: Scalars['Int'];
  id: Scalars['Int'];
  legalEntities?: Maybe<Array<Scalars['Int']>>;
  serializedTree: Scalars['String'];
};

/** The connection type for JobCatalogTree. */
export type JobCatalogTreeConnection = {
  __typename?: 'JobCatalogTreeConnection';
  /** A list of edges. */
  edges: Array<JobCatalogTreeEdge>;
  /** A list of nodes. */
  nodes: Array<JobCatalogTree>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type JobCatalogTreeEdge = {
  __typename?: 'JobCatalogTreeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: JobCatalogTree;
};

/** Job Catalog Tree Levels */
export type JobCatalogTreeLevel = {
  __typename?: 'JobCatalogTreeLevel';
  ancestor?: Maybe<JobCatalogTreeNode>;
  ancestorId?: Maybe<Scalars['Int']>;
  ancestorUuid?: Maybe<Scalars['String']>;
  attributes?: Maybe<Array<JobCatalogTreeNodeAttributeRef>>;
  attributesJson?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  description?: Maybe<Scalars['String']>;
  fullPathToRoot?: Maybe<Array<JobCatalogTreeNodePath>>;
  id: Scalars['Int'];
  jobCatalogTitle?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  referenceContracts: Array<ContractsReferenceContract>;
  referenceContractsConnection: ContractsReferenceContractConnection;
  type: JobCatalogEnumsJobCatalogTreeNodeTypesEnum;
  updatedAt: Scalars['ISO8601DateTime'];
  uuid: Scalars['String'];
};


/** Job Catalog Tree Levels */
export type JobCatalogTreeLevelAncestorArgs = {
  ancestorIds?: InputMaybe<Array<Scalars['Int']>>;
  ancestorUuids?: InputMaybe<Array<Scalars['String']>>;
  attributeTypeIds?: InputMaybe<Array<Scalars['String']>>;
  attributeTypes?: InputMaybe<Array<JobCatalogEnumsJobCatalogTreeAttributeTypesEnum>>;
  id?: InputMaybe<Scalars['Int']>;
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  includeFullPath?: InputMaybe<Scalars['Boolean']>;
  nodeType?: InputMaybe<JobCatalogEnumsJobCatalogTreeNodeTypesEnum>;
  nodeUuids?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
};


/** Job Catalog Tree Levels */
export type JobCatalogTreeLevelReferenceContractsArgs = {
  activeBetween?: InputMaybe<ReferenceContractsActiveBetweenInput>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  effectiveOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endsOnGt?: InputMaybe<Scalars['ISO8601Date']>;
  endsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  frContractTypeIds?: InputMaybe<Array<Scalars['Int']>>;
  frMutualIds?: InputMaybe<Array<Scalars['Int']>>;
  frWorkTypeIds?: InputMaybe<Array<Scalars['Int']>>;
  includeDenormalizedData?: Scalars['Boolean'];
  includeEducationLevel?: Scalars['Boolean'];
  jobCatalogLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  onDate?: InputMaybe<Scalars['ISO8601Date']>;
  payrollPolicyId?: InputMaybe<Scalars['Int']>;
  startsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  startsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedBecauseRelatedModels?: InputMaybe<Scalars['Boolean']>;
  withPayroll?: InputMaybe<Scalars['Boolean']>;
  withTranslations?: InputMaybe<Scalars['Boolean']>;
};


/** Job Catalog Tree Levels */
export type JobCatalogTreeLevelReferenceContractsConnectionArgs = {
  activeBetween?: InputMaybe<ReferenceContractsActiveBetweenInput>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  effectiveOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endsOnGt?: InputMaybe<Scalars['ISO8601Date']>;
  endsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  first?: InputMaybe<Scalars['Int']>;
  frContractTypeIds?: InputMaybe<Array<Scalars['Int']>>;
  frMutualIds?: InputMaybe<Array<Scalars['Int']>>;
  frWorkTypeIds?: InputMaybe<Array<Scalars['Int']>>;
  includeDenormalizedData?: Scalars['Boolean'];
  includeEducationLevel?: Scalars['Boolean'];
  jobCatalogLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onDate?: InputMaybe<Scalars['ISO8601Date']>;
  payrollPolicyId?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  startsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedBecauseRelatedModels?: InputMaybe<Scalars['Boolean']>;
  withPayroll?: InputMaybe<Scalars['Boolean']>;
  withTranslations?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for JobCatalogTreeLevel. */
export type JobCatalogTreeLevelConnection = {
  __typename?: 'JobCatalogTreeLevelConnection';
  /** A list of edges. */
  edges: Array<JobCatalogTreeLevelEdge>;
  /** A list of nodes. */
  nodes: Array<JobCatalogTreeLevel>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type JobCatalogTreeLevelEdge = {
  __typename?: 'JobCatalogTreeLevelEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: JobCatalogTreeLevel;
};

/** JobCatalog Tree Node */
export type JobCatalogTreeNode = {
  __typename?: 'JobCatalogTreeNode';
  ancestor?: Maybe<JobCatalogTreeNode>;
  /** id of the ancestor node. */
  ancestorId?: Maybe<Scalars['Int']>;
  /** UUID of the parent node. */
  ancestorUuid?: Maybe<Scalars['String']>;
  /** Array of node attributes. */
  attributes?: Maybe<Array<JobCatalogTreeNodeAttributeRef>>;
  /** JSON string representation of the node attributes. */
  attributesJson?: Maybe<Scalars['String']>;
  /** Creation date of the node. */
  createdAt: Scalars['ISO8601DateTime'];
  /** Description of the node in the Job Catalog. */
  description?: Maybe<Scalars['String']>;
  /** Array with the list of nodes tha compose full path from the current node to the root node. */
  fullPathToRoot?: Maybe<Array<JobCatalogTreeNodePath>>;
  /** id of the node. */
  id: Scalars['Int'];
  /** Full title that represents the job position. */
  jobCatalogTitle?: Maybe<Scalars['String']>;
  /** Name of the node. */
  name?: Maybe<Scalars['String']>;
  /** Type of the node. */
  type: JobCatalogEnumsJobCatalogTreeNodeTypesEnum;
  /** Update date of the node. */
  updatedAt: Scalars['ISO8601DateTime'];
  /** UUIDs of the node. */
  uuid: Scalars['String'];
};


/** JobCatalog Tree Node */
export type JobCatalogTreeNodeAncestorArgs = {
  ancestorIds?: InputMaybe<Array<Scalars['Int']>>;
  ancestorUuids?: InputMaybe<Array<Scalars['String']>>;
  attributeTypeIds?: InputMaybe<Array<Scalars['String']>>;
  attributeTypes?: InputMaybe<Array<JobCatalogEnumsJobCatalogTreeAttributeTypesEnum>>;
  id?: InputMaybe<Scalars['Int']>;
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  includeFullPath?: InputMaybe<Scalars['Boolean']>;
  nodeType?: InputMaybe<JobCatalogEnumsJobCatalogTreeNodeTypesEnum>;
  nodeUuids?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
};

export type JobCatalogTreeNodeAttributeRef = {
  __typename?: 'JobCatalogTreeNodeAttributeRef';
  attributeId?: Maybe<Scalars['String']>;
  definedAt: JobCatalogEnumsJobCatalogTreeNodeTypesEnum;
  definedAtNode: JobCatalogTreeNodePath;
  takesPrecedence: Scalars['Boolean'];
  type: JobCatalogEnumsJobCatalogTreeAttributeTypesEnum;
  valueCompetency?: Maybe<JobCatalogCompetencyAttribute>;
  valueItManagementAsset?: Maybe<JobCatalogItManagementAssetAttribute>;
  valueSalaryRange?: Maybe<JobCatalogSalaryRangeAttribute>;
  valueWorkingConditions?: Maybe<JobCatalogWorkingConditionsAttribute>;
};

/** The connection type for JobCatalogTreeNode. */
export type JobCatalogTreeNodeConnection = {
  __typename?: 'JobCatalogTreeNodeConnection';
  /** A list of edges. */
  edges: Array<JobCatalogTreeNodeEdge>;
  /** A list of nodes. */
  nodes: Array<JobCatalogTreeNode>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type JobCatalogTreeNodeEdge = {
  __typename?: 'JobCatalogTreeNodeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: JobCatalogTreeNode;
};

export type JobCatalogTreeNodePath = {
  __typename?: 'JobCatalogTreeNodePath';
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  uuid: Scalars['String'];
};

export type JobCatalogWorkingConditionsAttribute = {
  __typename?: 'JobCatalogWorkingConditionsAttribute';
  conditions: Array<JobCatalogItem>;
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type JobCatalogWorkingConditionsAttributeInput = {
  conditions: Array<JobCatalogItemInput>;
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type KudosContextlessPolicies = {
  __typename?: 'KudosContextlessPolicies';
  sidebarSeeKudosTopLevelItem: ContextlessPolicyResolution;
};

/** Kudos kudos leaderboard */
export type KudosKudosLeaderboard = {
  __typename?: 'KudosKudosLeaderboard';
  companyId: Scalars['Int'];
  kudosCount: Scalars['Int'];
  receiverAvatar?: Maybe<Scalars['String']>;
  receiverId: Scalars['Int'];
  receiverName: Scalars['String'];
  receiverSurname: Scalars['String'];
};

/** The connection type for KudosKudosLeaderboard. */
export type KudosKudosLeaderboardConnection = {
  __typename?: 'KudosKudosLeaderboardConnection';
  /** A list of edges. */
  edges: Array<KudosKudosLeaderboardEdge>;
  /** A list of nodes. */
  nodes: Array<KudosKudosLeaderboard>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type KudosKudosLeaderboardEdge = {
  __typename?: 'KudosKudosLeaderboardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: KudosKudosLeaderboard;
};

/** Kudos kudos received */
export type KudosKudosReceived = {
  __typename?: 'KudosKudosReceived';
  companyId: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['Int'];
  message: Scalars['String'];
  receiverAvatar?: Maybe<Scalars['String']>;
  receiverId: Scalars['Int'];
  receiverName: Scalars['String'];
  securityHash: Scalars['String'];
  senderAvatar?: Maybe<Scalars['String']>;
  senderId: Scalars['Int'];
  senderName: Scalars['String'];
};

/** The connection type for KudosKudosReceived. */
export type KudosKudosReceivedConnection = {
  __typename?: 'KudosKudosReceivedConnection';
  /** A list of edges. */
  edges: Array<KudosKudosReceivedEdge>;
  /** A list of nodes. */
  nodes: Array<KudosKudosReceived>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type KudosKudosReceivedEdge = {
  __typename?: 'KudosKudosReceivedEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: KudosKudosReceived;
};

/** kudos_sent */
export type KudosKudosSent = {
  __typename?: 'KudosKudosSent';
  companyId: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['Int'];
  message: Scalars['String'];
  receiverAvatar?: Maybe<Scalars['String']>;
  receiverId: Scalars['Int'];
  receiverName: Scalars['String'];
  securityHash: Scalars['String'];
  senderAvatar?: Maybe<Scalars['String']>;
  senderId: Scalars['Int'];
  senderName: Scalars['String'];
};

/** The connection type for KudosKudosSent. */
export type KudosKudosSentConnection = {
  __typename?: 'KudosKudosSentConnection';
  /** A list of edges. */
  edges: Array<KudosKudosSentEdge>;
  /** A list of nodes. */
  nodes: Array<KudosKudosSent>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type KudosKudosSentEdge = {
  __typename?: 'KudosKudosSentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: KudosKudosSent;
};

/** Represents a favourite resource, this will be used for the sidebar */
export type LayoutFavourite = {
  __typename?: 'LayoutFavourite';
  avatar?: Maybe<Scalars['String']>;
  avatarType?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  employeeId: Scalars['Int'];
  icon: Scalars['String'];
  id: Scalars['Int'];
  label: Scalars['String'];
  position: Scalars['Int'];
  url: Scalars['String'];
};

/** The connection type for LayoutFavourite. */
export type LayoutFavouriteConnection = {
  __typename?: 'LayoutFavouriteConnection';
  /** A list of edges. */
  edges: Array<LayoutFavouriteEdge>;
  /** A list of nodes. */
  nodes: Array<LayoutFavourite>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type LayoutFavouriteEdge = {
  __typename?: 'LayoutFavouriteEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: LayoutFavourite;
};

export type LayoutValueObjectsFavouritesDirectionEnum =
  | 'down'
  | 'up';

export type LinkProjectmanagementExpenseRecordItemsInput = {
  projectWorkerId: Scalars['Int'];
  subprojectId?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of LinkProjectmanagementExpenseRecord. */
export type LinkProjectmanagementExpenseRecordPayload = {
  __typename?: 'LinkProjectmanagementExpenseRecordPayload';
  errors: Array<MutationError>;
  expenseRecords?: Maybe<Array<ProjectManagementExpenseRecord>>;
};

/** Autogenerated return type of ListIntegrationsjoinIntegration. */
export type ListIntegrationsjoinIntegrationPayload = {
  __typename?: 'ListIntegrationsjoinIntegrationPayload';
  errors: Array<MutationError>;
  integrations?: Maybe<Array<IntegrationsJoinIntegration>>;
};

/** Autogenerated return type of ListIntegrationsjoinOrganicChannel. */
export type ListIntegrationsjoinOrganicChannelPayload = {
  __typename?: 'ListIntegrationsjoinOrganicChannelPayload';
  errors: Array<MutationError>;
  organicChannel?: Maybe<IntegrationsJoinOrganicChannel>;
};

export type LocationsContextlessPolicies = {
  __typename?: 'LocationsContextlessPolicies';
  locationManage: ContextlessPolicyResolution;
  workAreaManage: ContextlessPolicyResolution;
};

/** Manage employees locations in Factorial */
export type LocationsEmployeesLocation = {
  __typename?: 'LocationsEmployeesLocation';
  employeeId: Scalars['Int'];
  location?: Maybe<LocationsLocation>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  locationId: Scalars['Int'];
};


/** Manage employees locations in Factorial */
export type LocationsEmployeesLocationLocationArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  main?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};

/** The connection type for LocationsEmployeesLocation. */
export type LocationsEmployeesLocationConnection = {
  __typename?: 'LocationsEmployeesLocationConnection';
  /** A list of edges. */
  edges: Array<LocationsEmployeesLocationEdge>;
  /** A list of nodes. */
  nodes: Array<LocationsEmployeesLocation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type LocationsEmployeesLocationEdge = {
  __typename?: 'LocationsEmployeesLocationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: LocationsEmployeesLocation;
};

/** Manage Workplaces in Factorial */
export type LocationsLocation = {
  __typename?: 'LocationsLocation';
  /** Address line 1 of the location */
  addressLine1?: Maybe<Scalars['String']>;
  /** Address line 2 of the location */
  addressLine2?: Maybe<Scalars['String']>;
  /** City of the location */
  city?: Maybe<Scalars['String']>;
  companyHolidays: Array<HolidaysCompanyHoliday>;
  companyHolidaysConnection: HolidaysCompanyHolidayConnection;
  /** company identifier */
  companyId: Scalars['Int'];
  /** country code of the location */
  country?: Maybe<Scalars['String']>;
  employees: Array<EmployeesEmployeeName>;
  employeesConnection: EmployeesEmployeeNameConnection;
  /** identifier of the location */
  id: Scalars['Int'];
  /** latitude of the location */
  latitude?: Maybe<Scalars['Float']>;
  /** longitude of the location */
  longitude?: Maybe<Scalars['Float']>;
  /** whether the location is the main one */
  main: Scalars['Boolean'];
  /** name of the location */
  name: Scalars['String'];
  /** phone number of the location */
  phoneNumber?: Maybe<Scalars['String']>;
  /** Postal code of the location */
  postalCode?: Maybe<Scalars['String']>;
  /** radius of the location */
  radius?: Maybe<Scalars['Float']>;
  shiftsWithoutWorkArea: Array<ShiftManagementShift>;
  shiftsWithoutWorkAreaConnection: ShiftManagementShiftConnection;
  /** siret of the location (only for France) */
  siret?: Maybe<Scalars['String']>;
  /** State of the location */
  state?: Maybe<Scalars['String']>;
  /** timezone of the location */
  timezone?: Maybe<Scalars['String']>;
};


/** Manage Workplaces in Factorial */
export type LocationsLocationCompanyHolidaysArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endAt?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  startAt?: InputMaybe<Scalars['ISO8601Date']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Manage Workplaces in Factorial */
export type LocationsLocationCompanyHolidaysConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endAt?: InputMaybe<Scalars['ISO8601Date']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startAt?: InputMaybe<Scalars['ISO8601Date']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Manage Workplaces in Factorial */
export type LocationsLocationEmployeesArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  afterEmployeeId?: InputMaybe<Scalars['Int']>;
  beforeEmployeeId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  reporteesOrLed?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyId?: InputMaybe<Scalars['Int']>;
  verb?: InputMaybe<Scalars['String']>;
  withActiveContract?: Scalars['Boolean'];
};


/** Manage Workplaces in Factorial */
export type LocationsLocationEmployeesConnectionArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  after?: InputMaybe<Scalars['String']>;
  afterEmployeeId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  beforeEmployeeId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  reporteesOrLed?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyId?: InputMaybe<Scalars['Int']>;
  verb?: InputMaybe<Scalars['String']>;
  withActiveContract?: Scalars['Boolean'];
};


/** Manage Workplaces in Factorial */
export type LocationsLocationShiftsWithoutWorkAreaArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endAt?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  locationsWorkAreaIds?: InputMaybe<Array<Scalars['Int']>>;
  onlyPublished?: InputMaybe<Scalars['Boolean']>;
  onlyStates?: InputMaybe<Array<ShiftManagementEnumsShiftStateEnum>>;
  splitOvernightShifts?: InputMaybe<Scalars['Boolean']>;
  startAt?: InputMaybe<Scalars['String']>;
  withoutIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Manage Workplaces in Factorial */
export type LocationsLocationShiftsWithoutWorkAreaConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endAt?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  locationsWorkAreaIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyPublished?: InputMaybe<Scalars['Boolean']>;
  onlyStates?: InputMaybe<Array<ShiftManagementEnumsShiftStateEnum>>;
  sortOrder?: InputMaybe<Sort>;
  splitOvernightShifts?: InputMaybe<Scalars['Boolean']>;
  startAt?: InputMaybe<Scalars['String']>;
  withoutIds?: InputMaybe<Array<Scalars['Int']>>;
};

/** The connection type for LocationsLocation. */
export type LocationsLocationConnection = {
  __typename?: 'LocationsLocationConnection';
  /** A list of edges. */
  edges: Array<LocationsLocationEdge>;
  /** A list of nodes. */
  nodes: Array<LocationsLocation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type LocationsLocationEdge = {
  __typename?: 'LocationsLocationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: LocationsLocation;
};

/** Location work areas */
export type LocationsWorkArea = {
  __typename?: 'LocationsWorkArea';
  archivedAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['Int'];
  location?: Maybe<LocationsLocation>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  locationId: Scalars['Int'];
  name: Scalars['String'];
  workAreaMap?: Maybe<SpaceControlWorkAreaMap>;
  workSpaces: Array<SpaceControlWorkSpace>;
  workSpacesConnection: SpaceControlWorkSpaceConnection;
};


/** Location work areas */
export type LocationsWorkAreaLocationArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  main?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};


/** Location work areas */
export type LocationsWorkAreaWorkAreaMapArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  ids?: Array<Scalars['Int']>;
};


/** Location work areas */
export type LocationsWorkAreaWorkSpacesArgs = {
  endTime?: InputMaybe<Scalars['String']>;
  ids?: Array<Scalars['Int']>;
  locationIds?: Array<Scalars['Int']>;
  startTime?: InputMaybe<Scalars['String']>;
};


/** Location work areas */
export type LocationsWorkAreaWorkSpacesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: Array<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locationIds?: Array<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startTime?: InputMaybe<Scalars['String']>;
};

/** The connection type for LocationsWorkArea. */
export type LocationsWorkAreaConnection = {
  __typename?: 'LocationsWorkAreaConnection';
  /** A list of edges. */
  edges: Array<LocationsWorkAreaEdge>;
  /** A list of nodes. */
  nodes: Array<LocationsWorkArea>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type LocationsWorkAreaEdge = {
  __typename?: 'LocationsWorkAreaEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: LocationsWorkArea;
};

/** Autogenerated return type of MarkAsClickedNotificationsInboxNotification. */
export type MarkAsClickedNotificationsInboxNotificationPayload = {
  __typename?: 'MarkAsClickedNotificationsInboxNotificationPayload';
  errors: Array<MutationError>;
  inboxNotification?: Maybe<NotificationsInboxNotification>;
};

/** Autogenerated return type of MarkAsCompletedProcessesMaterializedProcess. */
export type MarkAsCompletedProcessesMaterializedProcessPayload = {
  __typename?: 'MarkAsCompletedProcessesMaterializedProcessPayload';
  errors: Array<MutationError>;
  materializedProcess?: Maybe<ProcessesMaterializedProcess>;
};

/** Autogenerated return type of MarkAsDoneProcurementUploadDocumentTask. */
export type MarkAsDoneProcurementUploadDocumentTaskPayload = {
  __typename?: 'MarkAsDoneProcurementUploadDocumentTaskPayload';
  errors: Array<MutationError>;
  uploadDocumentTask?: Maybe<ProcurementUploadDocumentTask>;
};

/** Autogenerated return type of MarkAsPaidBankingPaymentExecution. */
export type MarkAsPaidBankingPaymentExecutionPayload = {
  __typename?: 'MarkAsPaidBankingPaymentExecutionPayload';
  errors: Array<MutationError>;
  paymentExecution?: Maybe<BankingPaymentExecution>;
};

/** Autogenerated return type of MarkAsReadAtsConversation. */
export type MarkAsReadAtsConversationPayload = {
  __typename?: 'MarkAsReadAtsConversationPayload';
  conversation?: Maybe<AtsConversation>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of MarkAsReadFinanceMessage. */
export type MarkAsReadFinanceMessagePayload = {
  __typename?: 'MarkAsReadFinanceMessagePayload';
  errors: Array<MutationError>;
  message?: Maybe<FinanceMessage>;
};

/** Autogenerated return type of MarkAsReadNotificationsInboxNotification. */
export type MarkAsReadNotificationsInboxNotificationPayload = {
  __typename?: 'MarkAsReadNotificationsInboxNotificationPayload';
  errors: Array<MutationError>;
  inboxNotification?: Maybe<NotificationsInboxNotification>;
};

/** Autogenerated return type of MarkAsTasksInboxTask. */
export type MarkAsTasksInboxTaskPayload = {
  __typename?: 'MarkAsTasksInboxTaskPayload';
  errors: Array<MutationError>;
  inboxTask?: Maybe<TasksInboxTask>;
};

/** Autogenerated return type of MarkAsUnreadAtsConversation. */
export type MarkAsUnreadAtsConversationPayload = {
  __typename?: 'MarkAsUnreadAtsConversationPayload';
  conversation?: Maybe<AtsConversation>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of MarkAsUnreadNotificationsInboxNotification. */
export type MarkAsUnreadNotificationsInboxNotificationPayload = {
  __typename?: 'MarkAsUnreadNotificationsInboxNotificationPayload';
  errors: Array<MutationError>;
  inboxNotification?: Maybe<NotificationsInboxNotification>;
};

/** Marketing trial action */
export type MarketingTrialAction = {
  __typename?: 'MarketingTrialAction';
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  droppedBillingStep: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
  reasonOther?: Maybe<Scalars['String']>;
};

/** Marketing user segmentation */
export type MarketingUserSegmentation = {
  __typename?: 'MarketingUserSegmentation';
  containsSegmentation: Scalars['Boolean'];
  email?: Maybe<Scalars['String']>;
  experienceWithFactorial?: Maybe<Scalars['String']>;
  exploreFirst?: Maybe<Scalars['String']>;
  hopesWithFactorial?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  interestingSections?: Maybe<Array<Scalars['String']>>;
};

/** The connection type for MarketingUserSegmentation. */
export type MarketingUserSegmentationConnection = {
  __typename?: 'MarketingUserSegmentationConnection';
  /** A list of edges. */
  edges: Array<MarketingUserSegmentationEdge>;
  /** A list of nodes. */
  nodes: Array<MarketingUserSegmentation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type MarketingUserSegmentationEdge = {
  __typename?: 'MarketingUserSegmentationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: MarketingUserSegmentation;
};

export type MarketplaceCategory = {
  __typename?: 'MarketplaceCategory';
  classification: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  title: Scalars['String'];
};

/** Marketplace company installation */
export type MarketplaceCompanyInstallation = {
  __typename?: 'MarketplaceCompanyInstallation';
  authorId: Scalars['Int'];
  companyId: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  dbIntegration: MarketplaceDbIntegration;
  formData: Scalars['String'];
  id: Scalars['Int'];
  integrationDatoId: Scalars['String'];
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  integrationId: Scalars['Int'];
  secretVersionId: Scalars['String'];
};


/** Marketplace company installation */
export type MarketplaceCompanyInstallationDbIntegrationArgs = {
  datoIds?: InputMaybe<Array<Scalars['String']>>;
  uuids?: InputMaybe<Array<Scalars['String']>>;
};

/** The connection type for MarketplaceCompanyInstallation. */
export type MarketplaceCompanyInstallationConnection = {
  __typename?: 'MarketplaceCompanyInstallationConnection';
  /** A list of edges. */
  edges: Array<MarketplaceCompanyInstallationEdge>;
  /** A list of nodes. */
  nodes: Array<MarketplaceCompanyInstallation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type MarketplaceCompanyInstallationEdge = {
  __typename?: 'MarketplaceCompanyInstallationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: MarketplaceCompanyInstallation;
};

export type MarketplaceContextlessPolicies = {
  __typename?: 'MarketplaceContextlessPolicies';
  installationInstallCompanyWideIntegration: ContextlessPolicyResolution;
  marketplaceSeeMarketplace: ContextlessPolicyResolution;
  sidebarSeeMarketplaceAppStoreSubLevelItem: ContextlessPolicyResolution;
  sidebarSeeMarketplaceSubLevelItem: ContextlessPolicyResolution;
};

export type MarketplaceCountry = {
  __typename?: 'MarketplaceCountry';
  id: Scalars['String'];
  name: Scalars['String'];
  title: Scalars['String'];
};

/** Marketplace db integration */
export type MarketplaceDbIntegration = {
  __typename?: 'MarketplaceDbIntegration';
  authType?: Maybe<Scalars['String']>;
  datoId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  partnerId?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  userAgent?: Maybe<Scalars['String']>;
  uuid: Scalars['String'];
};

/** The connection type for MarketplaceDbIntegration. */
export type MarketplaceDbIntegrationConnection = {
  __typename?: 'MarketplaceDbIntegrationConnection';
  /** A list of edges. */
  edges: Array<MarketplaceDbIntegrationEdge>;
  /** A list of nodes. */
  nodes: Array<MarketplaceDbIntegration>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type MarketplaceDbIntegrationEdge = {
  __typename?: 'MarketplaceDbIntegrationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: MarketplaceDbIntegration;
};

export type MarketplaceEstablishmentCodeItem = {
  __typename?: 'MarketplaceEstablishmentCodeItem';
  locationId: Scalars['String'];
  value: Scalars['String'];
};

export type MarketplaceExternalInstallationLink = {
  __typename?: 'MarketplaceExternalInstallationLink';
  label: Scalars['String'];
  url: Scalars['String'];
};

export type MarketplaceFileNumberItem = {
  __typename?: 'MarketplaceFileNumberItem';
  legalEntityId: Scalars['String'];
  value: Scalars['String'];
};

/** Marketplace form question */
export type MarketplaceFormQuestion = {
  __typename?: 'MarketplaceFormQuestion';
  formQuestions: Scalars['String'];
};

/** The connection type for MarketplaceFormQuestion. */
export type MarketplaceFormQuestionConnection = {
  __typename?: 'MarketplaceFormQuestionConnection';
  /** A list of edges. */
  edges: Array<MarketplaceFormQuestionEdge>;
  /** A list of nodes. */
  nodes: Array<MarketplaceFormQuestion>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type MarketplaceFormQuestionEdge = {
  __typename?: 'MarketplaceFormQuestionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: MarketplaceFormQuestion;
};

export type MarketplaceImage = {
  __typename?: 'MarketplaceImage';
  alt?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  responsiveImage?: Maybe<MarketplaceResponsiveImage>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/** Represents the settings of an integration installation */
export type MarketplaceInstallationSetting = {
  __typename?: 'MarketplaceInstallationSetting';
  /** Workplace establishment codes */
  establishmentCodes: Array<MarketplaceEstablishmentCodeItem>;
  /** Legal Entity file numbers */
  fileNumbers: Array<MarketplaceFileNumberItem>;
  /** Leave types codes */
  leaveTypes: Array<MarketplaceInstallationSettingsItem>;
  /** Timeoff allowance codes */
  timeoffAllowanceCode: Array<MarketplaceInstallationSettingsItem>;
};

/** The connection type for MarketplaceInstallationSetting. */
export type MarketplaceInstallationSettingConnection = {
  __typename?: 'MarketplaceInstallationSettingConnection';
  /** A list of edges. */
  edges: Array<MarketplaceInstallationSettingEdge>;
  /** A list of nodes. */
  nodes: Array<MarketplaceInstallationSetting>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type MarketplaceInstallationSettingEdge = {
  __typename?: 'MarketplaceInstallationSettingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: MarketplaceInstallationSetting;
};

export type MarketplaceInstallationSettingsItem = {
  __typename?: 'MarketplaceInstallationSettingsItem';
  id: Scalars['String'];
  value: Scalars['String'];
};

/** Marketplace integration */
export type MarketplaceIntegration = {
  __typename?: 'MarketplaceIntegration';
  action?: Maybe<Scalars['String']>;
  authType?: Maybe<Scalars['String']>;
  categories?: Maybe<Array<MarketplaceCategory>>;
  category: MarketplaceCategory;
  classification?: Maybe<Scalars['String']>;
  component: Scalars['Boolean'];
  countries?: Maybe<Array<MarketplaceCountry>>;
  datoId: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  developer?: Maybe<Scalars['String']>;
  externalInstallationLink?: Maybe<Array<MarketplaceExternalInstallationLink>>;
  free?: Maybe<Scalars['Boolean']>;
  helpLink?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  images?: Maybe<Array<MarketplaceImage>>;
  installable: Scalars['Boolean'];
  installableFf?: Maybe<Scalars['String']>;
  installablePath?: Maybe<Scalars['String']>;
  installationType: Scalars['String'];
  links?: Maybe<Array<MarketplaceLink>>;
  logo?: Maybe<MarketplaceImage>;
  logoBackground?: Maybe<MarketplaceLogoBackground>;
  name: Scalars['String'];
  partnerId?: Maybe<Scalars['Int']>;
  pricingLink?: Maybe<Array<MarketplaceLink>>;
  setUpIntegrationEndpoint?: Maybe<Scalars['String']>;
  setupInformation?: Maybe<Scalars['String']>;
  shortDescription?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  statusBadge?: Maybe<Scalars['String']>;
  stepByStepDescription?: Maybe<Scalars['String']>;
  supportEmail?: Maybe<Scalars['String']>;
  supportLink?: Maybe<Scalars['String']>;
};

/** The connection type for MarketplaceIntegration. */
export type MarketplaceIntegrationConnection = {
  __typename?: 'MarketplaceIntegrationConnection';
  /** A list of edges. */
  edges: Array<MarketplaceIntegrationEdge>;
  /** A list of nodes. */
  nodes: Array<MarketplaceIntegration>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** Marketplace integration country */
export type MarketplaceIntegrationCountry = {
  __typename?: 'MarketplaceIntegrationCountry';
  id: Scalars['String'];
  name: Scalars['String'];
};

/** The connection type for MarketplaceIntegrationCountry. */
export type MarketplaceIntegrationCountryConnection = {
  __typename?: 'MarketplaceIntegrationCountryConnection';
  /** A list of edges. */
  edges: Array<MarketplaceIntegrationCountryEdge>;
  /** A list of nodes. */
  nodes: Array<MarketplaceIntegrationCountry>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type MarketplaceIntegrationCountryEdge = {
  __typename?: 'MarketplaceIntegrationCountryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: MarketplaceIntegrationCountry;
};

/** An edge in a connection. */
export type MarketplaceIntegrationEdge = {
  __typename?: 'MarketplaceIntegrationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: MarketplaceIntegration;
};

/** Marketplace integration upsell */
export type MarketplaceIntegrationUpsell = {
  __typename?: 'MarketplaceIntegrationUpsell';
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  integrationDatoId: Scalars['String'];
  name: Scalars['String'];
  successDescription?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/** The connection type for MarketplaceIntegrationUpsell. */
export type MarketplaceIntegrationUpsellConnection = {
  __typename?: 'MarketplaceIntegrationUpsellConnection';
  /** A list of edges. */
  edges: Array<MarketplaceIntegrationUpsellEdge>;
  /** A list of nodes. */
  nodes: Array<MarketplaceIntegrationUpsell>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type MarketplaceIntegrationUpsellEdge = {
  __typename?: 'MarketplaceIntegrationUpsellEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: MarketplaceIntegrationUpsell;
};

export type MarketplaceLink = {
  __typename?: 'MarketplaceLink';
  id: Scalars['String'];
  url: Scalars['String'];
};

export type MarketplaceLogoBackground = {
  __typename?: 'MarketplaceLogoBackground';
  hex: Scalars['String'];
};

export type MarketplaceOption = {
  __typename?: 'MarketplaceOption';
  label: Scalars['String'];
  value: Scalars['String'];
};

export type MarketplaceQuestionsSet = {
  __typename?: 'MarketplaceQuestionsSet';
  selectionQuestions: Array<MarketplaceSelection>;
  textFieldQuestions: Array<MarketplaceText>;
  toggleQuestions: Array<MarketplaceToggle>;
};

export type MarketplaceResponsiveImage = {
  __typename?: 'MarketplaceResponsiveImage';
  alt?: Maybe<Scalars['String']>;
  aspectRatio?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['String']>;
  src?: Maybe<Scalars['String']>;
  srcSet?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['String']>;
};

export type MarketplaceSelection = {
  __typename?: 'MarketplaceSelection';
  defaultValues?: Maybe<Array<Scalars['String']>>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  label: Scalars['String'];
  multipleSelection: Scalars['Boolean'];
  options: Array<MarketplaceOption>;
  order: Scalars['Int'];
  placeholder?: Maybe<Scalars['String']>;
  required: Scalars['Boolean'];
  searchBarPlaceholder?: Maybe<Scalars['String']>;
  searchable: Scalars['Boolean'];
};

/** Represents the settings of an integration */
export type MarketplaceSetting = {
  __typename?: 'MarketplaceSetting';
  description?: Maybe<Scalars['String']>;
  hasEncryptedFields: Scalars['Boolean'];
  integrationId: Scalars['Int'];
  questions: MarketplaceQuestionsSet;
  title: Scalars['String'];
};

/** The connection type for MarketplaceSetting. */
export type MarketplaceSettingConnection = {
  __typename?: 'MarketplaceSettingConnection';
  /** A list of edges. */
  edges: Array<MarketplaceSettingEdge>;
  /** A list of nodes. */
  nodes: Array<MarketplaceSetting>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type MarketplaceSettingEdge = {
  __typename?: 'MarketplaceSettingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: MarketplaceSetting;
};

export type MarketplaceText = {
  __typename?: 'MarketplaceText';
  defaultValue?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  inputType?: Maybe<MarketplaceValueObjectsQuestionsQuestionTextTypesEnum>;
  label: Scalars['String'];
  order: Scalars['Int'];
  placeholder?: Maybe<Scalars['String']>;
  required: Scalars['Boolean'];
};

export type MarketplaceToggle = {
  __typename?: 'MarketplaceToggle';
  defaultValue?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  disabled: Scalars['Boolean'];
  id: Scalars['String'];
  label: Scalars['String'];
  order: Scalars['Int'];
  required: Scalars['Boolean'];
  tooltipText?: Maybe<Scalars['String']>;
};

export type MarketplaceValueObjectsQuestionsQuestionTextTypesEnum =
  | 'email'
  | 'number'
  | 'password'
  | 'text'
  | 'time';

export type MaterializedFormResource = TrainingsTrainingClass;

/** AI-generated summary for meetings */
export type MeetingsAiSummary = {
  __typename?: 'MeetingsAiSummary';
  formattedContent: Scalars['String'];
  meeting: MeetingsMeeting;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  meetingId: Scalars['Int'];
  sources: Scalars['String'];
};


/** AI-generated summary for meetings */
export type MeetingsAiSummaryMeetingArgs = {
  attendeeEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  organizerEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};

/** represents a meeting attendee in factorial */
export type MeetingsAttendee = {
  __typename?: 'MeetingsAttendee';
  email?: Maybe<Scalars['String']>;
  employee?: Maybe<EmployeesEmployee>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  employeeId: Scalars['Int'];
  id: Scalars['Int'];
  meeting: MeetingsMeeting;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  meetingId: Scalars['Int'];
  page?: Maybe<PagesPage>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  pageId?: Maybe<Scalars['Int']>;
  status: MeetingsAttendeeStatusesEnum;
};


/** represents a meeting attendee in factorial */
export type MeetingsAttendeeEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** represents a meeting attendee in factorial */
export type MeetingsAttendeeMeetingArgs = {
  attendeeEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  organizerEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


/** represents a meeting attendee in factorial */
export type MeetingsAttendeePageArgs = {
  search?: InputMaybe<Scalars['String']>;
  visibility?: InputMaybe<Array<Scalars['String']>>;
};

/** The connection type for MeetingsAttendee. */
export type MeetingsAttendeeConnection = {
  __typename?: 'MeetingsAttendeeConnection';
  /** A list of edges. */
  edges: Array<MeetingsAttendeeEdge>;
  /** A list of nodes. */
  nodes: Array<MeetingsAttendee>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type MeetingsAttendeeEdge = {
  __typename?: 'MeetingsAttendeeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: MeetingsAttendee;
};

export type MeetingsAttendeeStatusesEnum =
  | 'accepted'
  | 'pending'
  | 'rejected';

/** AI-generated chat for meetings */
export type MeetingsChat = {
  __typename?: 'MeetingsChat';
  coachingDetected: Scalars['Boolean'];
  lastMessage: Scalars['String'];
  meeting: MeetingsMeeting;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  meetingId: Scalars['Int'];
  rawLastMessage?: Maybe<Scalars['String']>;
  sources: Scalars['String'];
};


/** AI-generated chat for meetings */
export type MeetingsChatMeetingArgs = {
  attendeeEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  organizerEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};

export type MeetingsContextlessPolicies = {
  __typename?: 'MeetingsContextlessPolicies';
  seeAdvancedMeetings: ContextlessPolicyResolution;
  seeMeetings: ContextlessPolicyResolution;
};

/** AI-generated gold layer for meetings */
export type MeetingsGoldLayer = {
  __typename?: 'MeetingsGoldLayer';
  attendeeId: Scalars['Int'];
  meeting: MeetingsMeeting;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  meetingId: Scalars['Int'];
  report: Scalars['String'];
  sources: Scalars['String'];
};


/** AI-generated gold layer for meetings */
export type MeetingsGoldLayerMeetingArgs = {
  attendeeEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  organizerEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};

/** Import meetings from CSV */
export type MeetingsImport = {
  __typename?: 'MeetingsImport';
  errors: Array<Scalars['String']>;
  failedRows: Scalars['Int'];
  skippedRows: Scalars['Int'];
  successfulImports: Scalars['Int'];
  totalRows: Scalars['Int'];
};

/** Live AI companion for meetings */
export type MeetingsLiveCompanion = {
  __typename?: 'MeetingsLiveCompanion';
  formattedContent: Scalars['String'];
  meeting: MeetingsMeeting;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  meetingId: Scalars['Int'];
};


/** Live AI companion for meetings */
export type MeetingsLiveCompanionMeetingArgs = {
  attendeeEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  organizerEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};

/** represents a meeting in factorial */
export type MeetingsMeeting = {
  __typename?: 'MeetingsMeeting';
  attendees: Array<MeetingsAttendee>;
  attendeesConnection: MeetingsAttendeeConnection;
  date: Scalars['ISO8601Date'];
  description?: Maybe<Scalars['String']>;
  endTime: Scalars['ISO8601DateTime'];
  id: Scalars['Int'];
  meetingType: Scalars['String'];
  organizer?: Maybe<EmployeesEmployee>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  organizerEmployeeId: Scalars['Int'];
  startTime: Scalars['ISO8601DateTime'];
  template?: Maybe<MeetingsTemplate>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  templateId?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  workSpace?: Maybe<SpaceControlWorkSpace>;
};


/** represents a meeting in factorial */
export type MeetingsMeetingAttendeesArgs = {
  employeeId?: InputMaybe<Scalars['Int']>;
  ids?: Array<Scalars['Int']>;
  meetingId?: InputMaybe<Scalars['Int']>;
  pageId?: InputMaybe<Scalars['Int']>;
  sharedWithEmployeeId?: InputMaybe<Scalars['Int']>;
};


/** represents a meeting in factorial */
export type MeetingsMeetingAttendeesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: Array<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  meetingId?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  pageId?: InputMaybe<Scalars['Int']>;
  sharedWithEmployeeId?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** represents a meeting in factorial */
export type MeetingsMeetingOrganizerArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** represents a meeting in factorial */
export type MeetingsMeetingTemplateArgs = {
  organizerEmployeeIds?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
};


/** represents a meeting in factorial */
export type MeetingsMeetingWorkSpaceArgs = {
  endTime?: InputMaybe<Scalars['String']>;
  locationIds?: Array<Scalars['Int']>;
  startTime?: InputMaybe<Scalars['String']>;
  workAreaIds?: Array<Scalars['Int']>;
};

/** The connection type for MeetingsMeeting. */
export type MeetingsMeetingConnection = {
  __typename?: 'MeetingsMeetingConnection';
  /** A list of edges. */
  edges: Array<MeetingsMeetingEdge>;
  /** A list of nodes. */
  nodes: Array<MeetingsMeeting>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type MeetingsMeetingEdge = {
  __typename?: 'MeetingsMeetingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: MeetingsMeeting;
};

/** the filter for the meetings resource */
export type MeetingsMeetingFilter = {
  date?: InputMaybe<DateFilter>;
  meetingType?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<MeetingsMeetingFilterConditions>>;
  title?: InputMaybe<StringFilter>;
};

export type MeetingsMeetingFilterConditions = {
  date?: InputMaybe<DateFilter>;
  meetingType?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
};

/** A room is a videocall room between people. */
export type MeetingsRoom = {
  __typename?: 'MeetingsRoom';
  id: Scalars['Int'];
  meeting: MeetingsMeeting;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  meetingId: Scalars['Int'];
  roomName: Scalars['String'];
  roomSid: Scalars['String'];
  serverUrl: Scalars['String'];
  token: Scalars['String'];
  transcriptionSession: MeetingsTranscriptionSession;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  transcriptionSessionId: Scalars['Int'];
};


/** A room is a videocall room between people. */
export type MeetingsRoomMeetingArgs = {
  attendeeEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  organizerEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


/** A room is a videocall room between people. */
export type MeetingsRoomTranscriptionSessionArgs = {
  attendeeId?: InputMaybe<Scalars['Int']>;
};

/** Scheduled meetings generated from templates */
export type MeetingsScheduledMeeting = {
  __typename?: 'MeetingsScheduledMeeting';
  date: Scalars['ISO8601Date'];
  description?: Maybe<Scalars['String']>;
  endTime: Scalars['ISO8601DateTime'];
  id?: Maybe<Scalars['Int']>;
  meetingType: Scalars['String'];
  organizer?: Maybe<EmployeesEmployee>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  organizerEmployeeId: Scalars['Int'];
  startTime: Scalars['ISO8601DateTime'];
  template?: Maybe<MeetingsTemplate>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  templateId?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};


/** Scheduled meetings generated from templates */
export type MeetingsScheduledMeetingOrganizerArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Scheduled meetings generated from templates */
export type MeetingsScheduledMeetingTemplateArgs = {
  organizerEmployeeIds?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
};

/** The connection type for MeetingsScheduledMeeting. */
export type MeetingsScheduledMeetingConnection = {
  __typename?: 'MeetingsScheduledMeetingConnection';
  /** A list of edges. */
  edges: Array<MeetingsScheduledMeetingEdge>;
  /** A list of nodes. */
  nodes: Array<MeetingsScheduledMeeting>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type MeetingsScheduledMeetingEdge = {
  __typename?: 'MeetingsScheduledMeetingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: MeetingsScheduledMeeting;
};

/** Settings for the meetings module */
export type MeetingsSetting = {
  __typename?: 'MeetingsSetting';
  companyId: Scalars['Int'];
  id: Scalars['Int'];
  meetingType: Scalars['String'];
  transcriptExpirationTime: Scalars['Int'];
};

/** The connection type for MeetingsSetting. */
export type MeetingsSettingConnection = {
  __typename?: 'MeetingsSettingConnection';
  /** A list of edges. */
  edges: Array<MeetingsSettingEdge>;
  /** A list of nodes. */
  nodes: Array<MeetingsSetting>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type MeetingsSettingEdge = {
  __typename?: 'MeetingsSettingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: MeetingsSetting;
};

/** represents the template of a meetings in factorial */
export type MeetingsTemplate = {
  __typename?: 'MeetingsTemplate';
  byDay?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
  date: Scalars['ISO8601Date'];
  description?: Maybe<Scalars['String']>;
  endTime: Scalars['ISO8601DateTime'];
  frequency?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  interval?: Maybe<Scalars['Int']>;
  meetingType: Scalars['String'];
  organizer?: Maybe<EmployeesEmployee>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  organizerEmployeeId: Scalars['String'];
  startTime: Scalars['ISO8601DateTime'];
  templateAttendees: Array<MeetingsTemplateAttendee>;
  templateAttendeesConnection: MeetingsTemplateAttendeeConnection;
  timezone?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  until?: Maybe<Scalars['ISO8601DateTime']>;
};


/** represents the template of a meetings in factorial */
export type MeetingsTemplateOrganizerArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** represents the template of a meetings in factorial */
export type MeetingsTemplateTemplateAttendeesArgs = {
  email?: InputMaybe<Scalars['String']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  ids?: Array<Scalars['Int']>;
  templateId?: InputMaybe<Scalars['Int']>;
};


/** represents the template of a meetings in factorial */
export type MeetingsTemplateTemplateAttendeesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: Array<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  templateId?: InputMaybe<Scalars['Int']>;
};

/** represents a template attendee in factorial */
export type MeetingsTemplateAttendee = {
  __typename?: 'MeetingsTemplateAttendee';
  email?: Maybe<Scalars['String']>;
  employee?: Maybe<EmployeesEmployee>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  employeeId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  template: MeetingsTemplate;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  templateId: Scalars['Int'];
};


/** represents a template attendee in factorial */
export type MeetingsTemplateAttendeeEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** represents a template attendee in factorial */
export type MeetingsTemplateAttendeeTemplateArgs = {
  organizerEmployeeIds?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
};

/** The connection type for MeetingsTemplateAttendee. */
export type MeetingsTemplateAttendeeConnection = {
  __typename?: 'MeetingsTemplateAttendeeConnection';
  /** A list of edges. */
  edges: Array<MeetingsTemplateAttendeeEdge>;
  /** A list of nodes. */
  nodes: Array<MeetingsTemplateAttendee>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type MeetingsTemplateAttendeeEdge = {
  __typename?: 'MeetingsTemplateAttendeeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: MeetingsTemplateAttendee;
};

/** The connection type for MeetingsTemplate. */
export type MeetingsTemplateConnection = {
  __typename?: 'MeetingsTemplateConnection';
  /** A list of edges. */
  edges: Array<MeetingsTemplateEdge>;
  /** A list of nodes. */
  nodes: Array<MeetingsTemplate>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type MeetingsTemplateEdge = {
  __typename?: 'MeetingsTemplateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: MeetingsTemplate;
};

/** represents a transcript for a meeting */
export type MeetingsTranscript = {
  __typename?: 'MeetingsTranscript';
  id: Scalars['Int'];
  meeting: MeetingsMeeting;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  meetingId: Scalars['Int'];
  utterances: Array<Scalars['String']>;
  utterancesAttendeeIds: Array<Scalars['Int']>;
  utterancesInPerson: Array<Scalars['Int']>;
  utterancesTimestamps: Array<Scalars['String']>;
};


/** represents a transcript for a meeting */
export type MeetingsTranscriptMeetingArgs = {
  attendeeEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  organizerEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};

/** The connection type for MeetingsTranscript. */
export type MeetingsTranscriptConnection = {
  __typename?: 'MeetingsTranscriptConnection';
  /** A list of edges. */
  edges: Array<MeetingsTranscriptEdge>;
  /** A list of nodes. */
  nodes: Array<MeetingsTranscript>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type MeetingsTranscriptEdge = {
  __typename?: 'MeetingsTranscriptEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: MeetingsTranscript;
};

/** represents a transcription session in factorial */
export type MeetingsTranscriptionSession = {
  __typename?: 'MeetingsTranscriptionSession';
  attendee: MeetingsAttendee;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  attendeeId: Scalars['Int'];
  companyId: Scalars['Int'];
  createdAt: Scalars['String'];
  disconnectedAt?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  inPerson: Scalars['Boolean'];
  updatedAt: Scalars['String'];
};


/** represents a transcription session in factorial */
export type MeetingsTranscriptionSessionAttendeeArgs = {
  employeeId?: InputMaybe<Scalars['Int']>;
  meetingId?: InputMaybe<Scalars['Int']>;
  pageId?: InputMaybe<Scalars['Int']>;
  sharedWithEmployeeId?: InputMaybe<Scalars['Int']>;
};

/** The connection type for MeetingsTranscriptionSession. */
export type MeetingsTranscriptionSessionConnection = {
  __typename?: 'MeetingsTranscriptionSessionConnection';
  /** A list of edges. */
  edges: Array<MeetingsTranscriptionSessionEdge>;
  /** A list of nodes. */
  nodes: Array<MeetingsTranscriptionSession>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type MeetingsTranscriptionSessionEdge = {
  __typename?: 'MeetingsTranscriptionSessionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: MeetingsTranscriptionSession;
};

export type MeetingsValueObjectsDeletionTypeEnum =
  | 'all'
  | 'future'
  | 'one';

export type ModulesBannerCallout = {
  __typename?: 'ModulesBannerCallout';
  description?: Maybe<Scalars['String']>;
  image?: Maybe<ModulesMarketplaceUrl>;
  title?: Maybe<Scalars['String']>;
};

export type ModulesBillingAddonReference = {
  __typename?: 'ModulesBillingAddonReference';
  description: Scalars['String'];
  iconId?: Maybe<Scalars['String']>;
  internalTitle: Scalars['String'];
  regions: Array<ModulesRegion>;
  title: Scalars['String'];
};

export type ModulesCategory = {
  __typename?: 'ModulesCategory';
  classification: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  title: Scalars['String'];
};

export type ModulesChargebeeAddon = {
  __typename?: 'ModulesChargebeeAddon';
  addonId: Scalars['String'];
  chargeType: Scalars['String'];
  currencyCode: Scalars['String'];
  maxSeats?: Maybe<Scalars['Int']>;
  minSeats?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  period: Scalars['Int'];
  periodUnit: Scalars['String'];
  price?: Maybe<Scalars['Int']>;
  pricingModel: Scalars['String'];
  seatUnit?: Maybe<Scalars['String']>;
  selectedCountries?: Maybe<Array<Scalars['String']>>;
  tiers?: Maybe<Array<ModulesChargebeeTier>>;
};

export type ModulesChargebeePlan = {
  __typename?: 'ModulesChargebeePlan';
  chargeType: Scalars['String'];
  currencyCode: Scalars['String'];
  maxSeats?: Maybe<Scalars['Int']>;
  minSeats?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  period: Scalars['Int'];
  periodUnit: Scalars['String'];
  planId: Scalars['String'];
  price?: Maybe<Scalars['Int']>;
  pricingModel: Scalars['String'];
  seatUnit?: Maybe<Scalars['String']>;
  selectedCountries?: Maybe<Array<Scalars['String']>>;
  tiers?: Maybe<Array<ModulesChargebeeTier>>;
};

export type ModulesChargebeeTier = {
  __typename?: 'ModulesChargebeeTier';
  endingUnit?: Maybe<Scalars['Int']>;
  price: Scalars['Int'];
  startingUnit: Scalars['Int'];
};

export type ModulesContextlessPolicies = {
  __typename?: 'ModulesContextlessPolicies';
  marketplaceRevampSeeMarketplaceRevamp: ContextlessPolicyResolution;
  moduleManageModule: ContextlessPolicyResolution;
  sidebarSeeModulesSubLevelItem: ContextlessPolicyResolution;
};

export type ModulesCountry = {
  __typename?: 'ModulesCountry';
  countryCode: Scalars['String'];
  name: Scalars['String'];
};

export type ModulesCrossSellingModule = {
  __typename?: 'ModulesCrossSellingModule';
  chargebeeModuleName: Scalars['String'];
  countries: Array<ModulesCountry>;
  hubspotModuleName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  shortDescription: Scalars['String'];
  slug: Scalars['String'];
  upsellMoreInfo: Scalars['String'];
};

/** Modules dato module */
export type ModulesDatoModule = {
  __typename?: 'ModulesDatoModule';
  action?: Maybe<Scalars['String']>;
  bannerCallout?: Maybe<ModulesBannerCallout>;
  benefit?: Maybe<Scalars['String']>;
  billingAddonReference?: Maybe<Array<ModulesBillingAddonReference>>;
  carousel?: Maybe<Array<ModulesMarketplaceUrl>>;
  category: ModulesCategory;
  chargebeeModuleId?: Maybe<Scalars['String']>;
  chargebeeModuleName?: Maybe<Scalars['String']>;
  countries?: Maybe<Array<ModulesCountry>>;
  crossSellingBillingAddonReference?: Maybe<Array<ModulesBillingAddonReference>>;
  crossSellingModules?: Maybe<Array<ModulesCrossSellingModule>>;
  description?: Maybe<Scalars['String']>;
  disableSelfUpsell?: Maybe<Scalars['Boolean']>;
  discoverabilityCta?: Maybe<Scalars['String']>;
  discoverabilityDescription?: Maybe<Scalars['String']>;
  discoverabilityTitle?: Maybe<Scalars['String']>;
  downloadInfo?: Maybe<ModulesMarketplaceUrl>;
  emailModules?: Maybe<Array<ModulesEmailModule>>;
  externalUrl?: Maybe<Scalars['String']>;
  helpLink?: Maybe<Scalars['String']>;
  hubspotModuleName?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  image?: Maybe<ModulesMarketplaceUrl>;
  images?: Maybe<Array<ModulesImage>>;
  includedInPlan?: Maybe<Array<ModulesIncludedInPlan>>;
  mandatoryCrossSellingAddons?: Maybe<Array<ModulesBillingAddonReference>>;
  maxCompanySize?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  navatticImage?: Maybe<ModulesImage>;
  navatticTitle?: Maybe<Scalars['String']>;
  navatticUrl?: Maybe<Scalars['String']>;
  setupGuide?: Maybe<Scalars['String']>;
  sharedSessionLink?: Maybe<Scalars['String']>;
  sharedSessionTitle?: Maybe<Scalars['String']>;
  shortDescription?: Maybe<Scalars['String']>;
  showSharedSession: Scalars['Boolean'];
  slackTagEmail?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  statusBadge?: Maybe<Scalars['String']>;
  supportLink?: Maybe<Array<ModulesLink>>;
  testimonials?: Maybe<Array<ModulesMarketplaceTestimonial>>;
  thumbnailImage?: Maybe<ModulesImage>;
  translatedName?: Maybe<Scalars['String']>;
  upsellColor?: Maybe<Scalars['String']>;
  upsellDescription?: Maybe<Scalars['String']>;
  upsellImage?: Maybe<ModulesImage>;
  upsellMoreInfo?: Maybe<Scalars['String']>;
  upsellPerks?: Maybe<Scalars['String']>;
  upsellTitle?: Maybe<Scalars['String']>;
  values?: Maybe<Array<ModulesMarketplaceValues>>;
};

/** The connection type for ModulesDatoModule. */
export type ModulesDatoModuleConnection = {
  __typename?: 'ModulesDatoModuleConnection';
  /** A list of edges. */
  edges: Array<ModulesDatoModuleEdge>;
  /** A list of nodes. */
  nodes: Array<ModulesDatoModule>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ModulesDatoModuleEdge = {
  __typename?: 'ModulesDatoModuleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ModulesDatoModule;
};

export type ModulesEmailModule = {
  __typename?: 'ModulesEmailModule';
  title?: Maybe<Scalars['String']>;
  values?: Maybe<Array<ModulesMarketplaceValues>>;
};

/** Modules email module */
export type ModulesEmailModuleRequest = {
  __typename?: 'ModulesEmailModuleRequest';
  moduleName: Scalars['String'];
  recipientEmail: Scalars['String'];
};

/** All the modules names */
export type ModulesEnum =
  | 'ai_reports'
  | 'analytics'
  | 'benefits'
  | 'billing'
  | 'calendar'
  | 'company_attendance'
  | 'company_documents'
  | 'company_projects'
  | 'company_trainings'
  | 'compensations'
  | 'complaints'
  | 'dashboard'
  | 'device_catalog'
  | 'discover'
  | 'employee_attendance'
  | 'employee_onboarding'
  | 'employees'
  | 'engagement_insights'
  | 'factorial_it'
  | 'finance'
  | 'finance_accounting'
  | 'finance_sales'
  | 'finance_spending'
  | 'finance_treasury'
  | 'finance_workspace'
  | 'goals'
  | 'handbook_pages'
  | 'it_management'
  | 'kudos'
  | 'meetings'
  | 'mobile_complaints'
  | 'my_benefits'
  | 'my_documents'
  | 'my_payroll'
  | 'my_projects'
  | 'my_spending'
  | 'my_surveys'
  | 'my_trainings'
  | 'notifications'
  | 'onboarding'
  | 'pages'
  | 'payroll_bundle'
  | 'performance'
  | 'processes'
  | 'profile'
  | 'recruitment'
  | 'salary_advance'
  | 'settings'
  | 'shift_management'
  | 'software_management'
  | 'space_control'
  | 'talent_analytics'
  | 'tasks'
  | 'timeoff';

export type ModulesFeature = {
  __typename?: 'ModulesFeature';
  featureStatus?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  tooltip?: Maybe<Scalars['String']>;
};

export type ModulesImage = {
  __typename?: 'ModulesImage';
  alt?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  responsiveImage?: Maybe<ModulesResponsiveImage>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type ModulesIncludedInPlan = {
  __typename?: 'ModulesIncludedInPlan';
  description: Scalars['String'];
  internalTitle: Scalars['String'];
  regions: Array<ModulesPlanRegion>;
  title: Scalars['String'];
};

export type ModulesLink = {
  __typename?: 'ModulesLink';
  id?: Maybe<Scalars['Int']>;
  label?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type ModulesMarketplaceTestimonial = {
  __typename?: 'ModulesMarketplaceTestimonial';
  author?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  jobPosition?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ModulesMarketplaceUrl = {
  __typename?: 'ModulesMarketplaceUrl';
  url?: Maybe<Scalars['String']>;
};

export type ModulesMarketplaceValues = {
  __typename?: 'ModulesMarketplaceValues';
  description?: Maybe<Scalars['String']>;
  emoji?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/** A repository to request modules in the marketplace */
export type ModulesModuleRequest = {
  __typename?: 'ModulesModuleRequest';
  access: ApiCoreAccess;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  accessId: Scalars['Int'];
  company: ApiCoreCompany;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  companyId: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['Int'];
  moduleName: Scalars['String'];
};


/** A repository to request modules in the marketplace */
export type ModulesModuleRequestAccessArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for ModulesModuleRequest. */
export type ModulesModuleRequestConnection = {
  __typename?: 'ModulesModuleRequestConnection';
  /** A list of edges. */
  edges: Array<ModulesModuleRequestEdge>;
  /** A list of nodes. */
  nodes: Array<ModulesModuleRequest>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ModulesModuleRequestEdge = {
  __typename?: 'ModulesModuleRequestEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ModulesModuleRequest;
};

export type ModulesPlanRegion = {
  __typename?: 'ModulesPlanRegion';
  chargebeePlans: Array<ModulesChargebeePlan>;
  features: Array<ModulesFeature>;
};

export type ModulesRegion = {
  __typename?: 'ModulesRegion';
  chargebeeAddons: Array<ModulesChargebeeAddon>;
  features: Array<ModulesFeature>;
};

export type ModulesResponsiveImage = {
  __typename?: 'ModulesResponsiveImage';
  alt?: Maybe<Scalars['String']>;
  aspectRatio?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['String']>;
  src?: Maybe<Scalars['String']>;
  srcSet?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['String']>;
};

export type Money = {
  __typename?: 'Money';
  cents: Scalars['Int'];
  currency: Scalars['String'];
  exchangeRate?: Maybe<Scalars['String']>;
};

export type MoneyInput = {
  cents: Scalars['Int'];
  currency: Scalars['String'];
  exchangeRate?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of MoveJobcatalogTreeNode. */
export type MoveJobcatalogTreeNodePayload = {
  __typename?: 'MoveJobcatalogTreeNodePayload';
  errors: Array<MutationError>;
  treeNode?: Maybe<JobCatalogTreeNode>;
};

/** Autogenerated return type of MoveLayoutFavourite. */
export type MoveLayoutFavouritePayload = {
  __typename?: 'MoveLayoutFavouritePayload';
  errors: Array<MutationError>;
  favourite?: Maybe<LayoutFavourite>;
};

/** Autogenerated return type of MoveToPhaseAtsApplication. */
export type MoveToPhaseAtsApplicationPayload = {
  __typename?: 'MoveToPhaseAtsApplicationPayload';
  application?: Maybe<AtsApplication>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of MoveToTrashBinDocumentsDocument. */
export type MoveToTrashBinDocumentsDocumentPayload = {
  __typename?: 'MoveToTrashBinDocumentsDocumentPayload';
  documents?: Maybe<Array<DocumentsDocument>>;
  errors: Array<MutationError>;
};

/** Represents all types of error messages generated by a mutation */
export type MutationError = SimpleError | StructuredError;

/** Notifications access notification setting */
export type NotificationsAccessNotificationSetting = {
  __typename?: 'NotificationsAccessNotificationSetting';
  accessId: Scalars['Int'];
  disableAll: Scalars['Boolean'];
};

/** The connection type for NotificationsAccessNotificationSetting. */
export type NotificationsAccessNotificationSettingConnection = {
  __typename?: 'NotificationsAccessNotificationSettingConnection';
  /** A list of edges. */
  edges: Array<NotificationsAccessNotificationSettingEdge>;
  /** A list of nodes. */
  nodes: Array<NotificationsAccessNotificationSetting>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type NotificationsAccessNotificationSettingEdge = {
  __typename?: 'NotificationsAccessNotificationSettingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: NotificationsAccessNotificationSetting;
};

/** Notifications access notifier scope */
export type NotificationsAccessNotifierScope = {
  __typename?: 'NotificationsAccessNotifierScope';
  notifier: Scalars['String'];
  value: Scalars['String'];
};

/** The connection type for NotificationsAccessNotifierScope. */
export type NotificationsAccessNotifierScopeConnection = {
  __typename?: 'NotificationsAccessNotifierScopeConnection';
  /** A list of edges. */
  edges: Array<NotificationsAccessNotifierScopeEdge>;
  /** A list of nodes. */
  nodes: Array<NotificationsAccessNotifierScope>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type NotificationsAccessNotifierScopeEdge = {
  __typename?: 'NotificationsAccessNotifierScopeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: NotificationsAccessNotifierScope;
};

export type NotificationsContextlessPolicies = {
  __typename?: 'NotificationsContextlessPolicies';
  dashboardWidgetPendingNotificationsVisible: ContextlessPolicyResolution;
  sidebarSeeNotificationsTopLevelItem: ContextlessPolicyResolution;
};

/** Notifications inbox notification */
export type NotificationsInboxNotification = {
  __typename?: 'NotificationsInboxNotification';
  body: Scalars['String'];
  clickedAt?: Maybe<Scalars['ISO8601DateTime']>;
  createdAt: Scalars['ISO8601DateTime'];
  error?: Maybe<Scalars['Boolean']>;
  icon?: Maybe<Scalars['String']>;
  iconBackground?: Maybe<Scalars['String']>;
  iconColor?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  mobileResourceUrl?: Maybe<Scalars['String']>;
  notifier: Scalars['String'];
  readAt?: Maybe<Scalars['ISO8601DateTime']>;
  title: Scalars['String'];
  webResourceUrl?: Maybe<Scalars['String']>;
};

/** The connection type for NotificationsInboxNotification. */
export type NotificationsInboxNotificationConnection = {
  __typename?: 'NotificationsInboxNotificationConnection';
  /** A list of edges. */
  edges: Array<NotificationsInboxNotificationEdge>;
  /** A list of nodes. */
  nodes: Array<NotificationsInboxNotification>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type NotificationsInboxNotificationEdge = {
  __typename?: 'NotificationsInboxNotificationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: NotificationsInboxNotification;
};

/** the filter for the inbox_notifications resource */
export type NotificationsInboxNotificationFilter = {
  createdAt?: InputMaybe<DateTimeFilter>;
  or?: InputMaybe<Array<NotificationsInboxNotificationFilterConditions>>;
};

export type NotificationsInboxNotificationFilterConditions = {
  createdAt?: InputMaybe<DateTimeFilter>;
};

/** Notifications request */
export type NotificationsRequest = {
  __typename?: 'NotificationsRequest';
  actionUrl?: Maybe<Scalars['String']>;
  avatarAccessIdentifier?: Maybe<Scalars['Int']>;
  bankingCard?: Maybe<BankingCard>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  bankingCardId?: Maybe<Scalars['Int']>;
  categoryIdentifier?: Maybe<Scalars['String']>;
  categoryTitle?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['ISO8601Date']>;
  htmlText?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  remoteUrl?: Maybe<Scalars['String']>;
  resourceCount: Scalars['Int'];
  resourceCreatedAt: Scalars['ISO8601DateTime'];
  resourceIdentifier?: Maybe<Scalars['Int']>;
  text: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};


/** Notifications request */
export type NotificationsRequestBankingCardArgs = {
  bankAccountIds?: InputMaybe<Array<Scalars['Int']>>;
  cardholderIds?: InputMaybe<Array<Scalars['Int']>>;
  creationSource?: InputMaybe<BankingValueObjectsCardCreationSourceEnum>;
  last4?: InputMaybe<Scalars['String']>;
  ownerIds?: InputMaybe<Array<Scalars['Int']>>;
  requestedWithoutApprovalFlow?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<BankingValueObjectsCardStatusEnum>;
};

/** The connection type for NotificationsRequest. */
export type NotificationsRequestConnection = {
  __typename?: 'NotificationsRequestConnection';
  /** A list of edges. */
  edges: Array<NotificationsRequestEdge>;
  /** A list of nodes. */
  nodes: Array<NotificationsRequest>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type NotificationsRequestEdge = {
  __typename?: 'NotificationsRequestEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: NotificationsRequest;
};

/** Autogenerated return type of Notifications_inbox_notification_create_subscription. */
export type Notifications_Inbox_Notification_Create_SubscriptionPayload = {
  __typename?: 'Notifications_inbox_notification_create_subscriptionPayload';
  inboxNotification?: Maybe<NotificationsInboxNotification>;
};

/** Autogenerated return type of NotifierFileUrlDocumentsDocument. */
export type NotifierFileUrlDocumentsDocumentPayload = {
  __typename?: 'NotifierFileUrlDocumentsDocumentPayload';
  document?: Maybe<DocumentsDocument>;
  errors: Array<MutationError>;
};

export type NpsContextlessPolicies = {
  __typename?: 'NpsContextlessPolicies';
  showNpsWidget: ContextlessPolicyResolution;
};

/** survey_response */
export type NpsSurveyResponse = {
  __typename?: 'NpsSurveyResponse';
  authorId?: Maybe<Scalars['Int']>;
  companyId?: Maybe<Scalars['Int']>;
  feedback?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  score?: Maybe<Scalars['Int']>;
  source?: Maybe<Scalars['String']>;
  survey: Scalars['String'];
};

/** The connection type for NpsSurveyResponse. */
export type NpsSurveyResponseConnection = {
  __typename?: 'NpsSurveyResponseConnection';
  /** A list of edges. */
  edges: Array<NpsSurveyResponseEdge>;
  /** A list of nodes. */
  nodes: Array<NpsSurveyResponse>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type NpsSurveyResponseEdge = {
  __typename?: 'NpsSurveyResponseEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: NpsSurveyResponse;
};

/** survey_response_intent */
export type NpsSurveyResponseIntent = {
  __typename?: 'NpsSurveyResponseIntent';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['Int'];
  origin: Scalars['String'];
  surveyResponseId?: Maybe<Scalars['String']>;
};

/** The connection type for NpsSurveyResponseIntent. */
export type NpsSurveyResponseIntentConnection = {
  __typename?: 'NpsSurveyResponseIntentConnection';
  /** A list of edges. */
  edges: Array<NpsSurveyResponseIntentEdge>;
  /** A list of nodes. */
  nodes: Array<NpsSurveyResponseIntent>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type NpsSurveyResponseIntentEdge = {
  __typename?: 'NpsSurveyResponseIntentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: NpsSurveyResponseIntent;
};

/** widget_visibility */
export type NpsWidgetVisibility = {
  __typename?: 'NpsWidgetVisibility';
  id: Scalars['String'];
  shouldSee: Scalars['Boolean'];
};

/** The connection type for NpsWidgetVisibility. */
export type NpsWidgetVisibilityConnection = {
  __typename?: 'NpsWidgetVisibilityConnection';
  /** A list of edges. */
  edges: Array<NpsWidgetVisibilityEdge>;
  /** A list of nodes. */
  nodes: Array<NpsWidgetVisibility>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type NpsWidgetVisibilityEdge = {
  __typename?: 'NpsWidgetVisibilityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: NpsWidgetVisibility;
};

export type NumberFilter = {
  between?: InputMaybe<Array<Scalars['Float']>>;
  eq?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gteq?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<Scalars['Float']>>;
  lt?: InputMaybe<Scalars['Float']>;
  lteq?: InputMaybe<Scalars['Float']>;
  notEq?: InputMaybe<Scalars['Float']>;
};

export type OauthApplicationPolicyContextlessPolicies = {
  __typename?: 'OauthApplicationPolicyContextlessPolicies';
  manageOauthApplication: ContextlessPolicyResolution;
};

export type OnboardingContextlessPolicies = {
  __typename?: 'OnboardingContextlessPolicies';
  sidebarSeeOnboardingTopLevelItem: ContextlessPolicyResolution;
};

export type OnboardingEntitiesWorkScheduleTimeEnum =
  | 'full_time'
  | 'part_time';

export type OnboardingImporterContextlessPolicies = {
  __typename?: 'OnboardingImporterContextlessPolicies';
  importCustomTables: ContextlessPolicyResolution;
  importEmployees: ContextlessPolicyResolution;
};

/** Canonical answers that steer the ONE agent's responses to specific questions */
export type OneAgentSteeringCanonicalAnswer = {
  __typename?: 'OneAgentSteeringCanonicalAnswer';
  answer: Scalars['String'];
  authorId: Scalars['Int'];
  company: ApiCoreCompany;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  companyId: Scalars['Int'];
  id: Scalars['Int'];
  question: Scalars['String'];
};

/** The connection type for OneAgentSteeringCanonicalAnswer. */
export type OneAgentSteeringCanonicalAnswerConnection = {
  __typename?: 'OneAgentSteeringCanonicalAnswerConnection';
  /** A list of edges. */
  edges: Array<OneAgentSteeringCanonicalAnswerEdge>;
  /** A list of nodes. */
  nodes: Array<OneAgentSteeringCanonicalAnswer>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type OneAgentSteeringCanonicalAnswerEdge = {
  __typename?: 'OneAgentSteeringCanonicalAnswerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: OneAgentSteeringCanonicalAnswer;
};

export type OneOnOnesContextlessPolicies = {
  __typename?: 'OneOnOnesContextlessPolicies';
  commandBarCreateOneOnOne: ContextlessPolicyResolution;
  fullVisibility: ContextlessPolicyResolution;
  sidebarSeePerformanceOneOnOnesSubLevelItem: ContextlessPolicyResolution;
};

/** Export functionality for one-on-ones data before deprecation. */
export type OneOnOnesExport = {
  __typename?: 'OneOnOnesExport';
  csvContent: Scalars['String'];
  filename?: Maybe<Scalars['String']>;
  generatedAt: Scalars['ISO8601DateTime'];
};

/** An external note is a document imported from an external source for a one on one meeting. */
export type OneOnOnesExternalNote = {
  __typename?: 'OneOnOnesExternalNote';
  id: Scalars['Int'];
  isPublic: Scalars['Boolean'];
  meeting: OneOnOnesMeeting;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  meetingId: Scalars['Int'];
  originalFileName: Scalars['String'];
  source: Scalars['String'];
  text: Scalars['String'];
  uploader: ApiCoreAccess;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  uploaderId: Scalars['Int'];
};


/** An external note is a document imported from an external source for a one on one meeting. */
export type OneOnOnesExternalNoteMeetingArgs = {
  oneOnOneIds?: InputMaybe<Array<Scalars['Int']>>;
  participantIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


/** An external note is a document imported from an external source for a one on one meeting. */
export type OneOnOnesExternalNoteUploaderArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for OneOnOnesExternalNote. */
export type OneOnOnesExternalNoteConnection = {
  __typename?: 'OneOnOnesExternalNoteConnection';
  /** A list of edges. */
  edges: Array<OneOnOnesExternalNoteEdge>;
  /** A list of nodes. */
  nodes: Array<OneOnOnesExternalNote>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type OneOnOnesExternalNoteEdge = {
  __typename?: 'OneOnOnesExternalNoteEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: OneOnOnesExternalNote;
};

/** Insights generated by open ai fo a one on one meeting */
export type OneOnOnesInsight = {
  __typename?: 'OneOnOnesInsight';
  actionables: Array<Scalars['String']>;
  meetingId: Scalars['Int'];
  prompt: Scalars['String'];
  summary: Scalars['String'];
};

/** A meeting is a scheduled one on one between two people. */
export type OneOnOnesMeeting = {
  __typename?: 'OneOnOnesMeeting';
  _policies?: Maybe<OneOnOnesMeetingPolicies>;
  _policiesCollection?: Maybe<Array<PermissionsPolicyResolution>>;
  _policiesConnection: PermissionsPolicyResolutionConnection;
  externalNotes: Array<OneOnOnesExternalNote>;
  externalNotesConnection: OneOnOnesExternalNoteConnection;
  id: Scalars['Int'];
  oneOnOne: OneOnOnesOneOnOne;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  oneOnOneId: Scalars['Int'];
  startTime: Scalars['ISO8601DateTime'];
  talkingPoints: Array<OneOnOnesTalkingPoint>;
  talkingPointsConnection: OneOnOnesTalkingPointConnection;
  tasks: Array<OneOnOnesTask>;
  tasksConnection: OneOnOnesTaskConnection;
  title: Scalars['String'];
};


/** A meeting is a scheduled one on one between two people. */
export type OneOnOnesMeeting_PoliciesCollectionArgs = {
  ids: Array<OneOnOnesMeetingPoliciesEnum>;
};


/** A meeting is a scheduled one on one between two people. */
export type OneOnOnesMeeting_PoliciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** A meeting is a scheduled one on one between two people. */
export type OneOnOnesMeetingExternalNotesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** A meeting is a scheduled one on one between two people. */
export type OneOnOnesMeetingExternalNotesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** A meeting is a scheduled one on one between two people. */
export type OneOnOnesMeetingOneOnOneArgs = {
  excludedParticipantIds?: InputMaybe<Array<Scalars['Int']>>;
  participantIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


/** A meeting is a scheduled one on one between two people. */
export type OneOnOnesMeetingTalkingPointsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** A meeting is a scheduled one on one between two people. */
export type OneOnOnesMeetingTalkingPointsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** A meeting is a scheduled one on one between two people. */
export type OneOnOnesMeetingTasksArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** A meeting is a scheduled one on one between two people. */
export type OneOnOnesMeetingTasksConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for OneOnOnesMeeting. */
export type OneOnOnesMeetingConnection = {
  __typename?: 'OneOnOnesMeetingConnection';
  /** A list of edges. */
  edges: Array<OneOnOnesMeetingEdge>;
  /** A list of nodes. */
  nodes: Array<OneOnOnesMeeting>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type OneOnOnesMeetingEdge = {
  __typename?: 'OneOnOnesMeetingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: OneOnOnesMeeting;
};

/** the filter for the meetings resource */
export type OneOnOnesMeetingFilter = {
  or?: InputMaybe<Array<OneOnOnesMeetingFilterConditions>>;
  startTime?: InputMaybe<DateTimeFilter>;
};

export type OneOnOnesMeetingFilterConditions = {
  startTime?: InputMaybe<DateTimeFilter>;
};

export type OneOnOnesMeetingPolicies = {
  __typename?: 'OneOnOnesMeetingPolicies';
  delete: PermissionsPolicyResolution;
};

export type OneOnOnesMeetingPoliciesEnum =
  | 'delete';

/** A one on one is a scheduled meeting between two people. */
export type OneOnOnesOneOnOne = {
  __typename?: 'OneOnOnesOneOnOne';
  company: ApiCoreCompany;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  companyId: Scalars['Int'];
  firstParticipant?: Maybe<EmployeesEmployee>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  firstParticipantId: Scalars['Int'];
  id: Scalars['Int'];
  lastMeeting?: Maybe<OneOnOnesOneOnOneMeeting>;
  meetings: Array<OneOnOnesMeeting>;
  meetingsConnection: OneOnOnesMeetingConnection;
  secondParticipant?: Maybe<EmployeesEmployee>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  secondParticipantId: Scalars['Int'];
  upcomingMeeting?: Maybe<OneOnOnesOneOnOneMeeting>;
};


/** A one on one is a scheduled meeting between two people. */
export type OneOnOnesOneOnOneFirstParticipantArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** A one on one is a scheduled meeting between two people. */
export type OneOnOnesOneOnOneMeetingsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  participantIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


/** A one on one is a scheduled meeting between two people. */
export type OneOnOnesOneOnOneMeetingsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  participantIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


/** A one on one is a scheduled meeting between two people. */
export type OneOnOnesOneOnOneSecondParticipantArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for OneOnOnesOneOnOne. */
export type OneOnOnesOneOnOneConnection = {
  __typename?: 'OneOnOnesOneOnOneConnection';
  /** A list of edges. */
  edges: Array<OneOnOnesOneOnOneEdge>;
  /** A list of nodes. */
  nodes: Array<OneOnOnesOneOnOne>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type OneOnOnesOneOnOneEdge = {
  __typename?: 'OneOnOnesOneOnOneEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: OneOnOnesOneOnOne;
};

export type OneOnOnesOneOnOneMeeting = {
  __typename?: 'OneOnOnesOneOnOneMeeting';
  id: Scalars['Int'];
  oneOnOneId: Scalars['Int'];
  startTime: Scalars['ISO8601DateTime'];
  title: Scalars['String'];
};

/** A talking point is a topic of discussion for a one on one. */
export type OneOnOnesTalkingPoint = {
  __typename?: 'OneOnOnesTalkingPoint';
  completed: Scalars['Boolean'];
  id: Scalars['Int'];
  meeting: OneOnOnesMeeting;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  meetingId: Scalars['Int'];
  moodScore?: Maybe<Scalars['Int']>;
  notes?: Maybe<Scalars['String']>;
  owner: EmployeesEmployee;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  participantId: Scalars['Int'];
  privateNotes?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  tasksDrafts?: Maybe<Array<OneOnOnesTaskData>>;
};


/** A talking point is a topic of discussion for a one on one. */
export type OneOnOnesTalkingPointMeetingArgs = {
  oneOnOneIds?: InputMaybe<Array<Scalars['Int']>>;
  participantIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


/** A talking point is a topic of discussion for a one on one. */
export type OneOnOnesTalkingPointOwnerArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for OneOnOnesTalkingPoint. */
export type OneOnOnesTalkingPointConnection = {
  __typename?: 'OneOnOnesTalkingPointConnection';
  /** A list of edges. */
  edges: Array<OneOnOnesTalkingPointEdge>;
  /** A list of nodes. */
  nodes: Array<OneOnOnesTalkingPoint>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type OneOnOnesTalkingPointEdge = {
  __typename?: 'OneOnOnesTalkingPointEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: OneOnOnesTalkingPoint;
};

/** A task is an action item to be done result of the meeting */
export type OneOnOnesTask = {
  __typename?: 'OneOnOnesTask';
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  assigneeIds: Array<Scalars['Int']>;
  assignees: Array<EmployeesEmployee>;
  assigneesConnection: EmployeesEmployeeConnection;
  author: EmployeesEmployee;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  authorId: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  dueOn?: Maybe<Scalars['ISO8601Date']>;
  id: Scalars['Int'];
  meeting: OneOnOnesMeeting;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  meetingId: Scalars['Int'];
  name: Scalars['String'];
  taskId: Scalars['Int'];
};


/** A task is an action item to be done result of the meeting */
export type OneOnOnesTaskAssigneesArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** A task is an action item to be done result of the meeting */
export type OneOnOnesTaskAssigneesConnectionArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  after?: InputMaybe<Scalars['String']>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Sort>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** A task is an action item to be done result of the meeting */
export type OneOnOnesTaskAuthorArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** A task is an action item to be done result of the meeting */
export type OneOnOnesTaskMeetingArgs = {
  oneOnOneIds?: InputMaybe<Array<Scalars['Int']>>;
  participantIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};

/** The connection type for OneOnOnesTask. */
export type OneOnOnesTaskConnection = {
  __typename?: 'OneOnOnesTaskConnection';
  /** A list of edges. */
  edges: Array<OneOnOnesTaskEdge>;
  /** A list of nodes. */
  nodes: Array<OneOnOnesTask>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type OneOnOnesTaskData = {
  __typename?: 'OneOnOnesTaskData';
  assigneeId: Scalars['Int'];
  content?: Maybe<Scalars['String']>;
  dueOn?: Maybe<Scalars['ISO8601Date']>;
  duration?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  startsOn?: Maybe<Scalars['ISO8601Date']>;
};

export type OneOnOnesTaskDataInput = {
  assigneeId: Scalars['Int'];
  content?: InputMaybe<Scalars['String']>;
  dueOn?: InputMaybe<Scalars['ISO8601Date']>;
  duration?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  startsOn?: InputMaybe<Scalars['ISO8601Date']>;
};

/** An edge in a connection. */
export type OneOnOnesTaskEdge = {
  __typename?: 'OneOnOnesTaskEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: OneOnOnesTask;
};

/** the filter for the tasks resource */
export type OneOnOnesTaskFilter = {
  createdAt?: InputMaybe<DateTimeFilter>;
  or?: InputMaybe<Array<OneOnOnesTaskFilterConditions>>;
};

export type OneOnOnesTaskFilterConditions = {
  createdAt?: InputMaybe<DateTimeFilter>;
};

export type OpenAiContextlessPolicies = {
  __typename?: 'OpenAiContextlessPolicies';
  useOne: ContextlessPolicyResolution;
};

/** Resource to describe the editor prompts */
export type OpenAiEditorPrompt = {
  __typename?: 'OpenAiEditorPrompt';
  option: OpenAiPromptOption;
  suboptions?: Maybe<Array<OpenAiPromptOption>>;
};

/** The connection type for OpenAiEditorPrompt. */
export type OpenAiEditorPromptConnection = {
  __typename?: 'OpenAiEditorPromptConnection';
  /** A list of edges. */
  edges: Array<OpenAiEditorPromptEdge>;
  /** A list of nodes. */
  nodes: Array<OpenAiEditorPrompt>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type OpenAiEditorPromptEdge = {
  __typename?: 'OpenAiEditorPromptEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: OpenAiEditorPrompt;
};

/** Resource to describe the enhanced capabilities of the new rich text editor */
export type OpenAiEnhancedText = {
  __typename?: 'OpenAiEnhancedText';
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
  text?: Maybe<Scalars['String']>;
};

/** feedback */
export type OpenAiFeedback = {
  __typename?: 'OpenAiFeedback';
  accessId: Scalars['String'];
  comment?: Maybe<Scalars['String']>;
  companyId: Scalars['String'];
  employeeId?: Maybe<Scalars['String']>;
  feedbackType: Scalars['String'];
  helpful: Scalars['Boolean'];
  id: Scalars['String'];
  integerResourceId: Scalars['Int'];
  resourceId: Scalars['String'];
};

/** The connection type for OpenAiFeedback. */
export type OpenAiFeedbackConnection = {
  __typename?: 'OpenAiFeedbackConnection';
  /** A list of edges. */
  edges: Array<OpenAiFeedbackEdge>;
  /** A list of nodes. */
  nodes: Array<OpenAiFeedback>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type OpenAiFeedbackEdge = {
  __typename?: 'OpenAiFeedbackEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: OpenAiFeedback;
};

export type OpenAiPromptOption = {
  __typename?: 'OpenAiPromptOption';
  label: Scalars['String'];
  name: Scalars['String'];
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

export type PagesContextlessPolicies = {
  __typename?: 'PagesContextlessPolicies';
  seeCompanyPages: ContextlessPolicyResolution;
};

/** page */
export type PagesPage = {
  __typename?: 'PagesPage';
  companyId: Scalars['Int'];
  content?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  createdByEmployeeId: Scalars['Int'];
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['Int'];
  lastRenderedAt?: Maybe<Scalars['ISO8601DateTime']>;
  meetingAttendee?: Maybe<MeetingsAttendee>;
  ownerId: Scalars['Int'];
  pages: Array<PagesPage>;
  pagesConnection: PagesPageConnection;
  parentPageId?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
  updatedByEmployeeId: Scalars['Int'];
  visibility?: Maybe<Scalars['String']>;
};


/** page */
export type PagesPageMeetingAttendeeArgs = {
  employeeId?: InputMaybe<Scalars['Int']>;
  ids?: Array<Scalars['Int']>;
  meetingId?: InputMaybe<Scalars['Int']>;
  pageId?: InputMaybe<Scalars['Int']>;
  sharedWithEmployeeId?: InputMaybe<Scalars['Int']>;
};


/** page */
export type PagesPagePagesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  visibility?: InputMaybe<Array<Scalars['String']>>;
};


/** page */
export type PagesPagePagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  visibility?: InputMaybe<Array<Scalars['String']>>;
};

/** The connection type for PagesPage. */
export type PagesPageConnection = {
  __typename?: 'PagesPageConnection';
  /** A list of edges. */
  edges: Array<PagesPageEdge>;
  /** A list of nodes. */
  nodes: Array<PagesPage>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PagesPageEdge = {
  __typename?: 'PagesPageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PagesPage;
};

/** Autogenerated return type of ParseAndUpdateQuestionnaireForStrategyPerformanceReviewProcessCustomTemplateQuestionnaireByStrategy. */
export type ParseAndUpdateQuestionnaireForStrategyPerformanceReviewProcessCustomTemplateQuestionnaireByStrategyPayload = {
  __typename?: 'ParseAndUpdateQuestionnaireForStrategyPerformanceReviewProcessCustomTemplateQuestionnaireByStrategyPayload';
  errors: Array<MutationError>;
  reviewProcessCustomTemplateQuestionnaireByStrategy?: Maybe<PerformanceReviewProcessCustomTemplateQuestionnaireByStrategy>;
};

/** Autogenerated return type of ParseAndUpdateQuestionnaireForStrategyPerformanceReviewQuestionnaireByStrategy. */
export type ParseAndUpdateQuestionnaireForStrategyPerformanceReviewQuestionnaireByStrategyPayload = {
  __typename?: 'ParseAndUpdateQuestionnaireForStrategyPerformanceReviewQuestionnaireByStrategyPayload';
  errors: Array<MutationError>;
  reviewQuestionnaireByStrategy?: Maybe<PerformanceReviewQuestionnaireByStrategy>;
};

/** Autogenerated return type of ParseFinanceAccountingAccountImport. */
export type ParseFinanceAccountingAccountImportPayload = {
  __typename?: 'ParseFinanceAccountingAccountImportPayload';
  accountImport?: Maybe<FinanceAccountImport>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of ParseFinanceInvoiceParser. */
export type ParseFinanceInvoiceParserPayload = {
  __typename?: 'ParseFinanceInvoiceParserPayload';
  errors: Array<MutationError>;
  invoiceParser?: Maybe<FinanceInvoiceParser>;
};

/** Autogenerated return type of PatchBookkeepersmanagementOptionIncidenceOption. */
export type PatchBookkeepersmanagementOptionIncidenceOptionPayload = {
  __typename?: 'PatchBookkeepersmanagementOptionIncidenceOptionPayload';
  errors: Array<MutationError>;
  incidenceOption?: Maybe<BookkeepersManagementIncidenceOption>;
};

/** Autogenerated return type of PatchPayrollPolicy. */
export type PatchPayrollPolicyPayload = {
  __typename?: 'PatchPayrollPolicyPayload';
  errors: Array<MutationError>;
  policy?: Maybe<PayrollPolicy>;
};

export type PatchProcessesActionItemInput = {
  assigneeIds?: InputMaybe<Array<Scalars['Int']>>;
  assigneeStrategy: Scalars['String'];
  dataCollectionConfiguration?: InputMaybe<ProcessesDataCollectionConfigurationInput>;
  id: Scalars['Int'];
  instruction?: InputMaybe<Scalars['String']>;
  mandatory?: InputMaybe<Scalars['Boolean']>;
  offsetAmount?: InputMaybe<Scalars['Int']>;
  offsetDirection?: InputMaybe<Scalars['String']>;
  position: Scalars['Int'];
  referenceFieldKey?: InputMaybe<Scalars['String']>;
  signatureDocuments?: InputMaybe<PatchProcessesActionSignatureDocumentsInput>;
  stepId?: InputMaybe<Scalars['Int']>;
  taskType?: InputMaybe<Scalars['String']>;
  taskTypeConfiguration?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of PatchProcessesAction. */
export type PatchProcessesActionPayload = {
  __typename?: 'PatchProcessesActionPayload';
  action?: Maybe<ProcessesAction>;
  errors: Array<MutationError>;
};

export type PatchProcessesActionSignatureDocumentsInput = {
  filesToAdd?: InputMaybe<Array<Scalars['File']>>;
  filesToRemove?: InputMaybe<Array<Scalars['Int']>>;
};

/** Autogenerated return type of PatchProcessesItemAssignee. */
export type PatchProcessesItemAssigneePayload = {
  __typename?: 'PatchProcessesItemAssigneePayload';
  errors: Array<MutationError>;
  itemAssignee?: Maybe<ProcessesItemAssignee>;
};

/** Autogenerated return type of PatchProcessesItem. */
export type PatchProcessesItemPayload = {
  __typename?: 'PatchProcessesItemPayload';
  errors: Array<MutationError>;
  item?: Maybe<ProcessesItem>;
};

export type PatchProcessesItemSignatureDocumentsInput = {
  filesToAdd?: InputMaybe<Array<Scalars['File']>>;
  filesToRemove?: InputMaybe<Array<Scalars['Int']>>;
};

/** Autogenerated return type of PatchProcessesMaterializedAssignee. */
export type PatchProcessesMaterializedAssigneePayload = {
  __typename?: 'PatchProcessesMaterializedAssigneePayload';
  errors: Array<MutationError>;
  materializedAssignee?: Maybe<ProcessesMaterializedAssignee>;
};

/** Autogenerated return type of PatchProcessesMaterializedProcess. */
export type PatchProcessesMaterializedProcessPayload = {
  __typename?: 'PatchProcessesMaterializedProcessPayload';
  errors: Array<MutationError>;
  materializedProcess?: Maybe<ProcessesMaterializedProcess>;
};

/** Autogenerated return type of PatchProcessesMaterializedStep. */
export type PatchProcessesMaterializedStepPayload = {
  __typename?: 'PatchProcessesMaterializedStepPayload';
  errors: Array<MutationError>;
  materializedStep?: Maybe<ProcessesMaterializedStep>;
};

/** Autogenerated return type of PatchProcessesProcess. */
export type PatchProcessesProcessPayload = {
  __typename?: 'PatchProcessesProcessPayload';
  errors: Array<MutationError>;
  process?: Maybe<ProcessesProcess>;
};

/** Autogenerated return type of PatchProcessesStep. */
export type PatchProcessesStepPayload = {
  __typename?: 'PatchProcessesStepPayload';
  errors: Array<MutationError>;
  step?: Maybe<ProcessesStep>;
};

/** Autogenerated return type of PauseContractsContract. */
export type PauseContractsContractPayload = {
  __typename?: 'PauseContractsContractPayload';
  contract?: Maybe<ContractsContract>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of PayBankingPayment. */
export type PayBankingPaymentPayload = {
  __typename?: 'PayBankingPaymentPayload';
  errors: Array<MutationError>;
  payment?: Maybe<BankingPayment>;
};

/** Autogenerated return type of PaymentCountUpdatedBillingDuePaymentsUpdate. */
export type PaymentCountUpdatedBillingDuePaymentsUpdatePayload = {
  __typename?: 'PaymentCountUpdatedBillingDuePaymentsUpdatePayload';
  duePaymentsUpdate?: Maybe<BillingDuePaymentsUpdate>;
  errors: Array<MutationError>;
};

/** Payroll concept */
export type PayrollConcept = {
  __typename?: 'PayrollConcept';
  accountResources: Array<FinanceLedgerAccountResource>;
  accountResourcesConnection: FinanceLedgerAccountResourceConnection;
  category?: Maybe<PayrollValueObjectsConceptCategoryEnum>;
  companyId: Scalars['Int'];
  compensationsStatus?: Maybe<CompensationsPayrollConceptStatus>;
  default: Scalars['Boolean'];
  description: Scalars['String'];
  id: Scalars['Int'];
  label: Scalars['String'];
  laborCost?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  translatedName: Scalars['String'];
  unitName?: Maybe<Scalars['String']>;
  unitType?: Maybe<PayrollValueObjectsConceptUnitTypeEnum>;
};


/** Payroll concept */
export type PayrollConceptAccountResourcesArgs = {
  financeAccountIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Payroll concept */
export type PayrollConceptAccountResourcesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  financeAccountIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Payroll concept */
export type PayrollConceptCompensationsStatusArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};

/** The connection type for PayrollConcept. */
export type PayrollConceptConnection = {
  __typename?: 'PayrollConceptConnection';
  /** A list of edges. */
  edges: Array<PayrollConceptEdge>;
  /** A list of nodes. */
  nodes: Array<PayrollConcept>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PayrollConceptEdge = {
  __typename?: 'PayrollConceptEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PayrollConcept;
};

export type PayrollConceptLine = {
  __typename?: 'PayrollConceptLine';
  conceptId: Scalars['Int'];
  label: Scalars['String'];
  value: Scalars['Int'];
};

export type PayrollContextlessPolicies = {
  __typename?: 'PayrollContextlessPolicies';
  companyManagePayroll: ContextlessPolicyResolution;
  conceptsManageLaborCost: ContextlessPolicyResolution;
  createSupplementsFromExpenses: ContextlessPolicyResolution;
  downloadPayrollData: ContextlessPolicyResolution;
  editSupplements: ContextlessPolicyResolution;
  managePayrollIncidences: ContextlessPolicyResolution;
  managePayrollPolicies: ContextlessPolicyResolution;
  periodChangePayrollPeriodStatus: ContextlessPolicyResolution;
  resultsSeeCompanyPayrollResults: ContextlessPolicyResolution;
  resultsSeeOwnPayrollResults: ContextlessPolicyResolution;
  seeCompanySepaGenerator: ContextlessPolicyResolution;
  seePayrollIssues: ContextlessPolicyResolution;
  seeSupplements: ContextlessPolicyResolution;
  settingsSeePayrollSettings: ContextlessPolicyResolution;
  sidebarSeeMyPayrollTopLevelItem: ContextlessPolicyResolution;
  sidebarSeePayrollBundleCycleSubLevelItem: ContextlessPolicyResolution;
  sidebarSeePayrollBundleInHouseActivationSubLevelItem: ContextlessPolicyResolution;
  sidebarSeePayrollBundleIncidencesSubLevelItem: ContextlessPolicyResolution;
  sidebarSeePayrollBundleSalaryCardSubLevelItem: ContextlessPolicyResolution;
  sidebarSeePayrollBundleTopLevelItem: ContextlessPolicyResolution;
  supplementsImportSupplements: ContextlessPolicyResolution;
  supplementsSeeEverybody: ContextlessPolicyResolution;
  supplementsSeeOwned: ContextlessPolicyResolution;
  supplementsSeeReportees: ContextlessPolicyResolution;
  supplementsSeeTeam: ContextlessPolicyResolution;
  upsellSeeActivationPromo: ContextlessPolicyResolution;
  usePayroll: ContextlessPolicyResolution;
};

/** Current default policy period */
export type PayrollCurrentDefaultPolicyPeriod = {
  __typename?: 'PayrollCurrentDefaultPolicyPeriod';
  id: Scalars['Int'];
  openToSupplements: Scalars['Boolean'];
};

/** The connection type for PayrollCurrentDefaultPolicyPeriod. */
export type PayrollCurrentDefaultPolicyPeriodConnection = {
  __typename?: 'PayrollCurrentDefaultPolicyPeriodConnection';
  /** A list of edges. */
  edges: Array<PayrollCurrentDefaultPolicyPeriodEdge>;
  /** A list of nodes. */
  nodes: Array<PayrollCurrentDefaultPolicyPeriod>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PayrollCurrentDefaultPolicyPeriodEdge = {
  __typename?: 'PayrollCurrentDefaultPolicyPeriodEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PayrollCurrentDefaultPolicyPeriod;
};

/** Payroll draft payment item */
export type PayrollDraftPaymentItem = {
  __typename?: 'PayrollDraftPaymentItem';
  amountInCents: Scalars['Int'];
  bankAccount?: Maybe<Scalars['String']>;
  employeeId: Scalars['Int'];
  paymentType: Scalars['String'];
};

/** The connection type for PayrollDraftPaymentItem. */
export type PayrollDraftPaymentItemConnection = {
  __typename?: 'PayrollDraftPaymentItemConnection';
  /** A list of edges. */
  edges: Array<PayrollDraftPaymentItemEdge>;
  /** A list of nodes. */
  nodes: Array<PayrollDraftPaymentItem>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PayrollDraftPaymentItemEdge = {
  __typename?: 'PayrollDraftPaymentItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PayrollDraftPaymentItem;
};

/** Payroll employee estimated period base salary */
export type PayrollEmployeeEstimatedPeriodBaseSalary = {
  __typename?: 'PayrollEmployeeEstimatedPeriodBaseSalary';
  baseSalaryAmount?: Maybe<Scalars['BigInt']>;
  baseSalaryPeriodicity?: Maybe<Scalars['String']>;
  employeeId: Scalars['Int'];
  id: Scalars['String'];
  periodBaseSalaryAmount?: Maybe<Scalars['Float']>;
};

/** The connection type for PayrollEmployeeEstimatedPeriodBaseSalary. */
export type PayrollEmployeeEstimatedPeriodBaseSalaryConnection = {
  __typename?: 'PayrollEmployeeEstimatedPeriodBaseSalaryConnection';
  /** A list of edges. */
  edges: Array<PayrollEmployeeEstimatedPeriodBaseSalaryEdge>;
  /** A list of nodes. */
  nodes: Array<PayrollEmployeeEstimatedPeriodBaseSalary>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PayrollEmployeeEstimatedPeriodBaseSalaryEdge = {
  __typename?: 'PayrollEmployeeEstimatedPeriodBaseSalaryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PayrollEmployeeEstimatedPeriodBaseSalary;
};

/** Latest payroll results for each employee in the specified period */
export type PayrollEmployeeResultsSummary = {
  __typename?: 'PayrollEmployeeResultsSummary';
  employee: EmployeesEmployee;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  employeeId: Scalars['Int'];
  id: Scalars['String'];
  payType: Scalars['String'];
  payrollResultId: Scalars['Int'];
  resultConceptItems: Array<PayrollResultConceptItem>;
  resultConceptItemsConnection: PayrollResultConceptItemConnection;
};


/** Latest payroll results for each employee in the specified period */
export type PayrollEmployeeResultsSummaryEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Latest payroll results for each employee in the specified period */
export type PayrollEmployeeResultsSummaryResultConceptItemsArgs = {
  conceptId?: InputMaybe<Scalars['Int']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  latestByEmployee?: InputMaybe<Scalars['Boolean']>;
  paymentType?: InputMaybe<Scalars['String']>;
  policyPeriodId?: InputMaybe<Scalars['Int']>;
};


/** Latest payroll results for each employee in the specified period */
export type PayrollEmployeeResultsSummaryResultConceptItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  conceptId?: InputMaybe<Scalars['Int']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  latestByEmployee?: InputMaybe<Scalars['Boolean']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  paymentType?: InputMaybe<Scalars['String']>;
  policyPeriodId?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for PayrollEmployeeResultsSummary. */
export type PayrollEmployeeResultsSummaryConnection = {
  __typename?: 'PayrollEmployeeResultsSummaryConnection';
  /** A list of edges. */
  edges: Array<PayrollEmployeeResultsSummaryEdge>;
  /** A list of nodes. */
  nodes: Array<PayrollEmployeeResultsSummary>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PayrollEmployeeResultsSummaryEdge = {
  __typename?: 'PayrollEmployeeResultsSummaryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PayrollEmployeeResultsSummary;
};

export type PayrollEmployeesDtosIdentifierSupportedCountryEnum =
  | 'de'
  | 'it'
  | 'pt';

/** Data provider repository to work with payroll related data for employees */
export type PayrollEmployeesEmployeeDatum = {
  __typename?: 'PayrollEmployeesEmployeeDatum';
  companyId: Scalars['Int'];
  employeeId: Scalars['Int'];
  fields?: Maybe<Array<DataDispatcherFieldSet>>;
  history?: Maybe<Array<DataDispatcherChangeHistory>>;
};

/** The connection type for PayrollEmployeesEmployeeDatum. */
export type PayrollEmployeesEmployeeDatumConnection = {
  __typename?: 'PayrollEmployeesEmployeeDatumConnection';
  /** A list of edges. */
  edges: Array<PayrollEmployeesEmployeeDatumEdge>;
  /** A list of nodes. */
  nodes: Array<PayrollEmployeesEmployeeDatum>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PayrollEmployeesEmployeeDatumEdge = {
  __typename?: 'PayrollEmployeesEmployeeDatumEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PayrollEmployeesEmployeeDatum;
};

/** Payroll employee identifier codes for specific countries (Portugal, Italy and Germany) */
export type PayrollEmployeesIdentifier = {
  __typename?: 'PayrollEmployeesIdentifier';
  /** country code of the employee pt | it | de */
  country: PayrollEmployeesDtosIdentifierSupportedCountryEnum;
  /** identifier of the employee */
  employeeId: Scalars['Int'];
  /** payroll employee identifier */
  id: Scalars['Int'];
  /** social security number of the employee */
  socialSecurityNumber?: Maybe<Scalars['String']>;
  /** tax id of the employee */
  taxId?: Maybe<Scalars['String']>;
};

/** The connection type for PayrollEmployeesIdentifier. */
export type PayrollEmployeesIdentifierConnection = {
  __typename?: 'PayrollEmployeesIdentifierConnection';
  /** A list of edges. */
  edges: Array<PayrollEmployeesIdentifierEdge>;
  /** A list of nodes. */
  nodes: Array<PayrollEmployeesIdentifier>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PayrollEmployeesIdentifierEdge = {
  __typename?: 'PayrollEmployeesIdentifierEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PayrollEmployeesIdentifier;
};

/** Payroll expenses categories contracts taxonomy */
export type PayrollExpensesCategoriesContractsTaxonomy = {
  __typename?: 'PayrollExpensesCategoriesContractsTaxonomy';
  contractsTaxonomyId: Scalars['Int'];
  expensesCategoryId: Scalars['String'];
  id: Scalars['Int'];
};

/** The connection type for PayrollExpensesCategoriesContractsTaxonomy. */
export type PayrollExpensesCategoriesContractsTaxonomyConnection = {
  __typename?: 'PayrollExpensesCategoriesContractsTaxonomyConnection';
  /** A list of edges. */
  edges: Array<PayrollExpensesCategoriesContractsTaxonomyEdge>;
  /** A list of nodes. */
  nodes: Array<PayrollExpensesCategoriesContractsTaxonomy>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PayrollExpensesCategoriesContractsTaxonomyEdge = {
  __typename?: 'PayrollExpensesCategoriesContractsTaxonomyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PayrollExpensesCategoriesContractsTaxonomy;
};

export type PayrollExporterDtosExportReadTypeEnum =
  | 'a3innuva_supplements'
  | 'a3nom_employees'
  | 'a3nom_supplements'
  | 'absences'
  | 'basic'
  | 'contract_changes'
  | 'datev_employees'
  | 'delta'
  | 'extended'
  | 'gispaghe_time'
  | 'paierh_leaves'
  | 'paierh_supplements'
  | 'paierh_updated_employees'
  | 'payslip_contract_changes'
  | 'silae_leave_deltas'
  | 'silae_leaves'
  | 'silae_supplements'
  | 'supplements'
  | 'yeap_paierh_leaves'
  | 'yeap_paierh_supplements'
  | 'yeap_paierh_updated_employees'
  | 'zucchetti_leaves'
  | 'zucchetti_time';

export type PayrollExporterDtosExportReadUpdatePeriodExportTypeEnum =
  | 'all'
  | 'custom';

/** Payroll exporter export */
export type PayrollExporterExport = {
  __typename?: 'PayrollExporterExport';
  content: Scalars['String'];
  document?: Maybe<DocumentsDocument>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  documentId?: Maybe<Scalars['Int']>;
  fileContentType: Scalars['String'];
  fileExtension: Scalars['String'];
  fileName: Scalars['String'];
  id?: Maybe<Scalars['Int']>;
  payrollPolicyPeriodId?: Maybe<Scalars['Int']>;
};


/** Payroll exporter export */
export type PayrollExporterExportDocumentArgs = {
  afterDate?: InputMaybe<Scalars['ISO8601Date']>;
  beforeDate?: InputMaybe<Scalars['ISO8601Date']>;
  byBookkeeperDocuments?: InputMaybe<Scalars['Boolean']>;
  byPendingAssignment?: Scalars['Boolean'];
  byTrashBin?: Scalars['Boolean'];
  byWithoutFolder?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['Int']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  excludedType?: InputMaybe<Scalars['String']>;
  folderId?: InputMaybe<Scalars['Int']>;
  fromEmployees?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  incidenceId?: InputMaybe<Scalars['Int']>;
  includeTrashBin?: InputMaybe<Scalars['Boolean']>;
  leaveId?: InputMaybe<Scalars['Int']>;
  payrollHiringId?: InputMaybe<Scalars['Int']>;
  relationships?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  sort?: Scalars['String'];
  space?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** The connection type for PayrollExporterExport. */
export type PayrollExporterExportConnection = {
  __typename?: 'PayrollExporterExportConnection';
  /** A list of edges. */
  edges: Array<PayrollExporterExportEdge>;
  /** A list of nodes. */
  nodes: Array<PayrollExporterExport>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PayrollExporterExportEdge = {
  __typename?: 'PayrollExporterExportEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PayrollExporterExport;
};

/** Family situation */
export type PayrollFamilySituation = {
  __typename?: 'PayrollFamilySituation';
  /** Civil status of the employee. */
  civilStatus?: Maybe<PayrollFamilySituationCivilStatusEnum>;
  /** Employee id of the family situation. */
  employeeId: Scalars['Int'];
  /** ID of the family situation. */
  id: Scalars['Int'];
  /** Number of dependants of the employee. */
  numberOfDependants?: Maybe<Scalars['Int']>;
};

export type PayrollFamilySituationCivilStatusEnum =
  | 'civil_partnership'
  | 'cohabitating'
  | 'divorced'
  | 'married'
  | 'not_applicable'
  | 'separated'
  | 'single'
  | 'unknown'
  | 'widow';

/** The connection type for PayrollFamilySituation. */
export type PayrollFamilySituationConnection = {
  __typename?: 'PayrollFamilySituationConnection';
  /** A list of edges. */
  edges: Array<PayrollFamilySituationEdge>;
  /** A list of nodes. */
  nodes: Array<PayrollFamilySituation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PayrollFamilySituationEdge = {
  __typename?: 'PayrollFamilySituationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PayrollFamilySituation;
};

/** Payroll inhouse activation */
export type PayrollInhouseActivation = {
  __typename?: 'PayrollInhouseActivation';
  companyId: Scalars['Int'];
};

/** Payroll integrations a3innuva agreement code */
export type PayrollIntegrationsA3innuvaAgreementCode = {
  __typename?: 'PayrollIntegrationsA3innuvaAgreementCode';
  code: Scalars['String'];
  name: Scalars['String'];
};

/** The connection type for PayrollIntegrationsA3innuvaAgreementCode. */
export type PayrollIntegrationsA3innuvaAgreementCodeConnection = {
  __typename?: 'PayrollIntegrationsA3innuvaAgreementCodeConnection';
  /** A list of edges. */
  edges: Array<PayrollIntegrationsA3innuvaAgreementCodeEdge>;
  /** A list of nodes. */
  nodes: Array<PayrollIntegrationsA3innuvaAgreementCode>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PayrollIntegrationsA3innuvaAgreementCodeEdge = {
  __typename?: 'PayrollIntegrationsA3innuvaAgreementCodeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PayrollIntegrationsA3innuvaAgreementCode;
};

/** Payroll integrations a3innuva classification */
export type PayrollIntegrationsA3innuvaClassification = {
  __typename?: 'PayrollIntegrationsA3innuvaClassification';
  code: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
};

/** The connection type for PayrollIntegrationsA3innuvaClassification. */
export type PayrollIntegrationsA3innuvaClassificationConnection = {
  __typename?: 'PayrollIntegrationsA3innuvaClassificationConnection';
  /** A list of edges. */
  edges: Array<PayrollIntegrationsA3innuvaClassificationEdge>;
  /** A list of nodes. */
  nodes: Array<PayrollIntegrationsA3innuvaClassification>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PayrollIntegrationsA3innuvaClassificationEdge = {
  __typename?: 'PayrollIntegrationsA3innuvaClassificationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PayrollIntegrationsA3innuvaClassification;
};

/** Payroll integrations a3innuva cno occupation */
export type PayrollIntegrationsA3innuvaCnoOccupation = {
  __typename?: 'PayrollIntegrationsA3innuvaCnoOccupation';
  code: Scalars['String'];
  name: Scalars['String'];
};

/** The connection type for PayrollIntegrationsA3innuvaCnoOccupation. */
export type PayrollIntegrationsA3innuvaCnoOccupationConnection = {
  __typename?: 'PayrollIntegrationsA3innuvaCnoOccupationConnection';
  /** A list of edges. */
  edges: Array<PayrollIntegrationsA3innuvaCnoOccupationEdge>;
  /** A list of nodes. */
  nodes: Array<PayrollIntegrationsA3innuvaCnoOccupation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PayrollIntegrationsA3innuvaCnoOccupationEdge = {
  __typename?: 'PayrollIntegrationsA3innuvaCnoOccupationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PayrollIntegrationsA3innuvaCnoOccupation;
};

/** Payroll integrations a3innuva company code */
export type PayrollIntegrationsA3innuvaCompanyCode = {
  __typename?: 'PayrollIntegrationsA3innuvaCompanyCode';
  code: Scalars['String'];
  name: Scalars['String'];
};

/** The connection type for PayrollIntegrationsA3innuvaCompanyCode. */
export type PayrollIntegrationsA3innuvaCompanyCodeConnection = {
  __typename?: 'PayrollIntegrationsA3innuvaCompanyCodeConnection';
  /** A list of edges. */
  edges: Array<PayrollIntegrationsA3innuvaCompanyCodeEdge>;
  /** A list of nodes. */
  nodes: Array<PayrollIntegrationsA3innuvaCompanyCode>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PayrollIntegrationsA3innuvaCompanyCodeEdge = {
  __typename?: 'PayrollIntegrationsA3innuvaCompanyCodeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PayrollIntegrationsA3innuvaCompanyCode;
};

/** Payroll integrations a3innuva compensation */
export type PayrollIntegrationsA3innuvaCompensationCode = {
  __typename?: 'PayrollIntegrationsA3innuvaCompensationCode';
  code: Scalars['String'];
  companyCode: Scalars['String'];
  description: Scalars['String'];
};

/** The connection type for PayrollIntegrationsA3innuvaCompensationCode. */
export type PayrollIntegrationsA3innuvaCompensationCodeConnection = {
  __typename?: 'PayrollIntegrationsA3innuvaCompensationCodeConnection';
  /** A list of edges. */
  edges: Array<PayrollIntegrationsA3innuvaCompensationCodeEdge>;
  /** A list of nodes. */
  nodes: Array<PayrollIntegrationsA3innuvaCompensationCode>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PayrollIntegrationsA3innuvaCompensationCodeEdge = {
  __typename?: 'PayrollIntegrationsA3innuvaCompensationCodeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PayrollIntegrationsA3innuvaCompensationCode;
};

/** Payroll integrations a3innuva contract type */
export type PayrollIntegrationsA3innuvaContractType = {
  __typename?: 'PayrollIntegrationsA3innuvaContractType';
  code: Scalars['String'];
  name: Scalars['String'];
};

/** The connection type for PayrollIntegrationsA3innuvaContractType. */
export type PayrollIntegrationsA3innuvaContractTypeConnection = {
  __typename?: 'PayrollIntegrationsA3innuvaContractTypeConnection';
  /** A list of edges. */
  edges: Array<PayrollIntegrationsA3innuvaContractTypeEdge>;
  /** A list of nodes. */
  nodes: Array<PayrollIntegrationsA3innuvaContractType>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PayrollIntegrationsA3innuvaContractTypeEdge = {
  __typename?: 'PayrollIntegrationsA3innuvaContractTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PayrollIntegrationsA3innuvaContractType;
};

/** Payroll integrations a3innuva contribution type */
export type PayrollIntegrationsA3innuvaContributionType = {
  __typename?: 'PayrollIntegrationsA3innuvaContributionType';
  code: Scalars['String'];
  name: Scalars['String'];
};

/** The connection type for PayrollIntegrationsA3innuvaContributionType. */
export type PayrollIntegrationsA3innuvaContributionTypeConnection = {
  __typename?: 'PayrollIntegrationsA3innuvaContributionTypeConnection';
  /** A list of edges. */
  edges: Array<PayrollIntegrationsA3innuvaContributionTypeEdge>;
  /** A list of nodes. */
  nodes: Array<PayrollIntegrationsA3innuvaContributionType>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PayrollIntegrationsA3innuvaContributionTypeEdge = {
  __typename?: 'PayrollIntegrationsA3innuvaContributionTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PayrollIntegrationsA3innuvaContributionType;
};

/** Payroll integrations a3innuva cost center code */
export type PayrollIntegrationsA3innuvaCostCenterCode = {
  __typename?: 'PayrollIntegrationsA3innuvaCostCenterCode';
  code: Scalars['String'];
  name: Scalars['String'];
};

/** The connection type for PayrollIntegrationsA3innuvaCostCenterCode. */
export type PayrollIntegrationsA3innuvaCostCenterCodeConnection = {
  __typename?: 'PayrollIntegrationsA3innuvaCostCenterCodeConnection';
  /** A list of edges. */
  edges: Array<PayrollIntegrationsA3innuvaCostCenterCodeEdge>;
  /** A list of nodes. */
  nodes: Array<PayrollIntegrationsA3innuvaCostCenterCode>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PayrollIntegrationsA3innuvaCostCenterCodeEdge = {
  __typename?: 'PayrollIntegrationsA3innuvaCostCenterCodeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PayrollIntegrationsA3innuvaCostCenterCode;
};

/** Payroll integrations a3innuva education level */
export type PayrollIntegrationsA3innuvaEducationLevel = {
  __typename?: 'PayrollIntegrationsA3innuvaEducationLevel';
  code: Scalars['String'];
  name: Scalars['String'];
};

/** The connection type for PayrollIntegrationsA3innuvaEducationLevel. */
export type PayrollIntegrationsA3innuvaEducationLevelConnection = {
  __typename?: 'PayrollIntegrationsA3innuvaEducationLevelConnection';
  /** A list of edges. */
  edges: Array<PayrollIntegrationsA3innuvaEducationLevelEdge>;
  /** A list of nodes. */
  nodes: Array<PayrollIntegrationsA3innuvaEducationLevel>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PayrollIntegrationsA3innuvaEducationLevelEdge = {
  __typename?: 'PayrollIntegrationsA3innuvaEducationLevelEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PayrollIntegrationsA3innuvaEducationLevel;
};

/** Payroll integrations a3innuva job position */
export type PayrollIntegrationsA3innuvaJobPosition = {
  __typename?: 'PayrollIntegrationsA3innuvaJobPosition';
  code: Scalars['String'];
  legalEntityId: Scalars['Int'];
  name: Scalars['String'];
};

/** The connection type for PayrollIntegrationsA3innuvaJobPosition. */
export type PayrollIntegrationsA3innuvaJobPositionConnection = {
  __typename?: 'PayrollIntegrationsA3innuvaJobPositionConnection';
  /** A list of edges. */
  edges: Array<PayrollIntegrationsA3innuvaJobPositionEdge>;
  /** A list of nodes. */
  nodes: Array<PayrollIntegrationsA3innuvaJobPosition>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PayrollIntegrationsA3innuvaJobPositionEdge = {
  __typename?: 'PayrollIntegrationsA3innuvaJobPositionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PayrollIntegrationsA3innuvaJobPosition;
};

/** Payroll integrations a3innuva leave type */
export type PayrollIntegrationsA3innuvaLeaveType = {
  __typename?: 'PayrollIntegrationsA3innuvaLeaveType';
  identifier: Scalars['String'];
  name: Scalars['String'];
};

/** The connection type for PayrollIntegrationsA3innuvaLeaveType. */
export type PayrollIntegrationsA3innuvaLeaveTypeConnection = {
  __typename?: 'PayrollIntegrationsA3innuvaLeaveTypeConnection';
  /** A list of edges. */
  edges: Array<PayrollIntegrationsA3innuvaLeaveTypeEdge>;
  /** A list of nodes. */
  nodes: Array<PayrollIntegrationsA3innuvaLeaveType>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PayrollIntegrationsA3innuvaLeaveTypeEdge = {
  __typename?: 'PayrollIntegrationsA3innuvaLeaveTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PayrollIntegrationsA3innuvaLeaveType;
};

/** Payroll integrations a3innuva oauth token */
export type PayrollIntegrationsA3innuvaOauthToken = {
  __typename?: 'PayrollIntegrationsA3innuvaOauthToken';
  accessToken: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  expiresAt?: Maybe<Scalars['Int']>;
  organizationalUnitId: Scalars['String'];
  owner?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for PayrollIntegrationsA3innuvaOauthToken. */
export type PayrollIntegrationsA3innuvaOauthTokenConnection = {
  __typename?: 'PayrollIntegrationsA3innuvaOauthTokenConnection';
  /** A list of edges. */
  edges: Array<PayrollIntegrationsA3innuvaOauthTokenEdge>;
  /** A list of nodes. */
  nodes: Array<PayrollIntegrationsA3innuvaOauthToken>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PayrollIntegrationsA3innuvaOauthTokenEdge = {
  __typename?: 'PayrollIntegrationsA3innuvaOauthTokenEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PayrollIntegrationsA3innuvaOauthToken;
};

/** Payroll integrations a3innuva occupation code */
export type PayrollIntegrationsA3innuvaOccupationCode = {
  __typename?: 'PayrollIntegrationsA3innuvaOccupationCode';
  code: Scalars['String'];
  name: Scalars['String'];
  percentageIms: Scalars['Float'];
  percentageIt: Scalars['Float'];
};

/** The connection type for PayrollIntegrationsA3innuvaOccupationCode. */
export type PayrollIntegrationsA3innuvaOccupationCodeConnection = {
  __typename?: 'PayrollIntegrationsA3innuvaOccupationCodeConnection';
  /** A list of edges. */
  edges: Array<PayrollIntegrationsA3innuvaOccupationCodeEdge>;
  /** A list of nodes. */
  nodes: Array<PayrollIntegrationsA3innuvaOccupationCode>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PayrollIntegrationsA3innuvaOccupationCodeEdge = {
  __typename?: 'PayrollIntegrationsA3innuvaOccupationCodeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PayrollIntegrationsA3innuvaOccupationCode;
};

/** Payroll integrations a3innuva organizational unit */
export type PayrollIntegrationsA3innuvaOrganizationalUnit = {
  __typename?: 'PayrollIntegrationsA3innuvaOrganizationalUnit';
  clientId?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  id: Scalars['String'];
};

/** The connection type for PayrollIntegrationsA3innuvaOrganizationalUnit. */
export type PayrollIntegrationsA3innuvaOrganizationalUnitConnection = {
  __typename?: 'PayrollIntegrationsA3innuvaOrganizationalUnitConnection';
  /** A list of edges. */
  edges: Array<PayrollIntegrationsA3innuvaOrganizationalUnitEdge>;
  /** A list of nodes. */
  nodes: Array<PayrollIntegrationsA3innuvaOrganizationalUnit>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PayrollIntegrationsA3innuvaOrganizationalUnitEdge = {
  __typename?: 'PayrollIntegrationsA3innuvaOrganizationalUnitEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PayrollIntegrationsA3innuvaOrganizationalUnit;
};

/** Payroll integrations a3innuva regime */
export type PayrollIntegrationsA3innuvaRegime = {
  __typename?: 'PayrollIntegrationsA3innuvaRegime';
  code: Scalars['String'];
  name: Scalars['String'];
};

/** The connection type for PayrollIntegrationsA3innuvaRegime. */
export type PayrollIntegrationsA3innuvaRegimeConnection = {
  __typename?: 'PayrollIntegrationsA3innuvaRegimeConnection';
  /** A list of edges. */
  edges: Array<PayrollIntegrationsA3innuvaRegimeEdge>;
  /** A list of nodes. */
  nodes: Array<PayrollIntegrationsA3innuvaRegime>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PayrollIntegrationsA3innuvaRegimeEdge = {
  __typename?: 'PayrollIntegrationsA3innuvaRegimeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PayrollIntegrationsA3innuvaRegime;
};

/** Payroll integrations a3innuva tariff group */
export type PayrollIntegrationsA3innuvaTariffGroup = {
  __typename?: 'PayrollIntegrationsA3innuvaTariffGroup';
  code: Scalars['Int'];
  name: Scalars['String'];
};

/** The connection type for PayrollIntegrationsA3innuvaTariffGroup. */
export type PayrollIntegrationsA3innuvaTariffGroupConnection = {
  __typename?: 'PayrollIntegrationsA3innuvaTariffGroupConnection';
  /** A list of edges. */
  edges: Array<PayrollIntegrationsA3innuvaTariffGroupEdge>;
  /** A list of nodes. */
  nodes: Array<PayrollIntegrationsA3innuvaTariffGroup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PayrollIntegrationsA3innuvaTariffGroupEdge = {
  __typename?: 'PayrollIntegrationsA3innuvaTariffGroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PayrollIntegrationsA3innuvaTariffGroup;
};

/** Payroll integrations a3innuva temporary disabilities managers */
export type PayrollIntegrationsA3innuvaTemporaryDisabilitiesManager = {
  __typename?: 'PayrollIntegrationsA3innuvaTemporaryDisabilitiesManager';
  firstName: Scalars['String'];
  fullName: Scalars['String'];
  id: Scalars['Int'];
  lastName: Scalars['String'];
};

/** The connection type for PayrollIntegrationsA3innuvaTemporaryDisabilitiesManager. */
export type PayrollIntegrationsA3innuvaTemporaryDisabilitiesManagerConnection = {
  __typename?: 'PayrollIntegrationsA3innuvaTemporaryDisabilitiesManagerConnection';
  /** A list of edges. */
  edges: Array<PayrollIntegrationsA3innuvaTemporaryDisabilitiesManagerEdge>;
  /** A list of nodes. */
  nodes: Array<PayrollIntegrationsA3innuvaTemporaryDisabilitiesManager>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PayrollIntegrationsA3innuvaTemporaryDisabilitiesManagerEdge = {
  __typename?: 'PayrollIntegrationsA3innuvaTemporaryDisabilitiesManagerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PayrollIntegrationsA3innuvaTemporaryDisabilitiesManager;
};

/** Payroll integrations a3innuva workplace code */
export type PayrollIntegrationsA3innuvaWorkplaceCode = {
  __typename?: 'PayrollIntegrationsA3innuvaWorkplaceCode';
  code: Scalars['String'];
  name: Scalars['String'];
  workplaceId: Scalars['String'];
};

/** The connection type for PayrollIntegrationsA3innuvaWorkplaceCode. */
export type PayrollIntegrationsA3innuvaWorkplaceCodeConnection = {
  __typename?: 'PayrollIntegrationsA3innuvaWorkplaceCodeConnection';
  /** A list of edges. */
  edges: Array<PayrollIntegrationsA3innuvaWorkplaceCodeEdge>;
  /** A list of nodes. */
  nodes: Array<PayrollIntegrationsA3innuvaWorkplaceCode>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PayrollIntegrationsA3innuvaWorkplaceCodeEdge = {
  __typename?: 'PayrollIntegrationsA3innuvaWorkplaceCodeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PayrollIntegrationsA3innuvaWorkplaceCode;
};

/** Codes represent an unique identifier to relate Factorial objects with different payroll softwares */
export type PayrollIntegrationsBaseCode = {
  __typename?: 'PayrollIntegrationsBaseCode';
  /** Code value */
  code: Scalars['String'];
  /** Related object ID. Used together with codeable_type */
  codeableId: Scalars['Int'];
  /** Related object type. Used together with codeable_id */
  codeableType: Scalars['String'];
  /** Company ID where the code belongs to */
  companyId: Scalars['Int'];
  forfaitJours?: Maybe<Scalars['Boolean']>;
  /** Code identifier */
  id: Scalars['Int'];
  /** Integration name */
  integration: PayrollIntegrationsBaseIntegrationEnum;
};

/** The connection type for PayrollIntegrationsBaseCode. */
export type PayrollIntegrationsBaseCodeConnection = {
  __typename?: 'PayrollIntegrationsBaseCodeConnection';
  /** A list of edges. */
  edges: Array<PayrollIntegrationsBaseCodeEdge>;
  /** A list of nodes. */
  nodes: Array<PayrollIntegrationsBaseCode>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PayrollIntegrationsBaseCodeEdge = {
  __typename?: 'PayrollIntegrationsBaseCodeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PayrollIntegrationsBaseCode;
};

export type PayrollIntegrationsBaseEntitiesSyncStatusEnum =
  | 'available'
  | 'blocked'
  | 'done'
  | 'pending'
  | 'unavailable';

export type PayrollIntegrationsBaseIntegrationEnum =
  | 'a3innuva'
  | 'a3nom'
  | 'datev'
  | 'datev_api'
  | 'datev_lauds'
  | 'datev_lug_api'
  | 'gispaghe'
  | 'paierh'
  | 'silae'
  | 'yeap_paierh'
  | 'zucchetti';

export type PayrollIntegrationsContextlessPolicies = {
  __typename?: 'PayrollIntegrationsContextlessPolicies';
  managePayrollIntegrationCodes: ContextlessPolicyResolution;
};

/** Payroll Labor Cost Configuration */
export type PayrollLaborCostConfiguration = {
  __typename?: 'PayrollLaborCostConfiguration';
  id: Scalars['Int'];
  laborCost?: Maybe<Scalars['Boolean']>;
};

/** Payroll onboarding */
export type PayrollOnboarding = {
  __typename?: 'PayrollOnboarding';
  archivedAt?: Maybe<Scalars['String']>;
  companyId: Scalars['Int'];
  country?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  default?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  recurrence: Scalars['String'];
  startsOn: Scalars['ISO8601Date'];
};

/** The totals of payments by status in the specified period */
export type PayrollPaymentTotal = {
  __typename?: 'PayrollPaymentTotal';
  employeeIds: Array<Scalars['Int']>;
  status: Scalars['String'];
  total: Scalars['BigInt'];
};

/** The connection type for PayrollPaymentTotal. */
export type PayrollPaymentTotalConnection = {
  __typename?: 'PayrollPaymentTotalConnection';
  /** A list of edges. */
  edges: Array<PayrollPaymentTotalEdge>;
  /** A list of nodes. */
  nodes: Array<PayrollPaymentTotal>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PayrollPaymentTotalEdge = {
  __typename?: 'PayrollPaymentTotalEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PayrollPaymentTotal;
};

/** Payroll payroll document */
export type PayrollPayrollDocument = {
  __typename?: 'PayrollPayrollDocument';
  document?: Maybe<DocumentsDocument>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  documentId: Scalars['Int'];
  id: Scalars['Int'];
  payrollPolicyPeriodId?: Maybe<Scalars['Int']>;
};


/** Payroll payroll document */
export type PayrollPayrollDocumentDocumentArgs = {
  afterDate?: InputMaybe<Scalars['ISO8601Date']>;
  beforeDate?: InputMaybe<Scalars['ISO8601Date']>;
  byBookkeeperDocuments?: InputMaybe<Scalars['Boolean']>;
  byPendingAssignment?: Scalars['Boolean'];
  byTrashBin?: Scalars['Boolean'];
  byWithoutFolder?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['Int']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  excludedType?: InputMaybe<Scalars['String']>;
  folderId?: InputMaybe<Scalars['Int']>;
  fromEmployees?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  incidenceId?: InputMaybe<Scalars['Int']>;
  includeTrashBin?: InputMaybe<Scalars['Boolean']>;
  leaveId?: InputMaybe<Scalars['Int']>;
  payrollHiringId?: InputMaybe<Scalars['Int']>;
  relationships?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  sort?: Scalars['String'];
  space?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** The connection type for PayrollPayrollDocument. */
export type PayrollPayrollDocumentConnection = {
  __typename?: 'PayrollPayrollDocumentConnection';
  /** A list of edges. */
  edges: Array<PayrollPayrollDocumentEdge>;
  /** A list of nodes. */
  nodes: Array<PayrollPayrollDocument>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PayrollPayrollDocumentEdge = {
  __typename?: 'PayrollPayrollDocumentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PayrollPayrollDocument;
};

/** Payroll payroll issue */
export type PayrollPayrollIssue = {
  __typename?: 'PayrollPayrollIssue';
  compensation?: Maybe<ContractsCompensation>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  contractsCompensationId?: Maybe<Scalars['Int']>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  contractsTaxonomyId?: Maybe<Scalars['Int']>;
  description: Scalars['String'];
  employee?: Maybe<EmployeesEmployee>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  employeeId?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  issueType: Scalars['String'];
  taxonomy?: Maybe<ContractsTaxonomy>;
  title: Scalars['String'];
};


/** Payroll payroll issue */
export type PayrollPayrollIssueCompensationArgs = {
  calculation?: InputMaybe<Scalars['String']>;
  compensationTypes?: InputMaybe<Array<Scalars['String']>>;
  contractApprovalStatus?: InputMaybe<Array<Scalars['String']>>;
  contractVersionIds?: InputMaybe<Array<Scalars['Int']>>;
  notIds?: InputMaybe<Array<Scalars['Int']>>;
  occurringAt?: InputMaybe<Scalars['ISO8601Date']>;
  occurringFrequency?: InputMaybe<Scalars['String']>;
  occursAt?: InputMaybe<Scalars['ISO8601Date']>;
  payrollPolicyId?: InputMaybe<Scalars['Int']>;
  syncWithSupplements?: InputMaybe<Scalars['Boolean']>;
};


/** Payroll payroll issue */
export type PayrollPayrollIssueEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Payroll payroll issue */
export type PayrollPayrollIssueTaxonomyArgs = {
  legalEntityId?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
};

/** The connection type for PayrollPayrollIssue. */
export type PayrollPayrollIssueConnection = {
  __typename?: 'PayrollPayrollIssueConnection';
  /** A list of edges. */
  edges: Array<PayrollPayrollIssueEdge>;
  /** A list of nodes. */
  nodes: Array<PayrollPayrollIssue>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PayrollPayrollIssueEdge = {
  __typename?: 'PayrollPayrollIssueEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PayrollPayrollIssue;
};

/** Payroll Summary Cell Suggestions */
export type PayrollPayrollSummaryCellSuggestion = {
  __typename?: 'PayrollPayrollSummaryCellSuggestion';
  cellIdentifier: Scalars['String'];
  column: Scalars['Int'];
  id: Scalars['String'];
  row: Scalars['Int'];
  value: Scalars['String'];
  valueType: Scalars['String'];
};

/** The connection type for PayrollPayrollSummaryCellSuggestion. */
export type PayrollPayrollSummaryCellSuggestionConnection = {
  __typename?: 'PayrollPayrollSummaryCellSuggestionConnection';
  /** A list of edges. */
  edges: Array<PayrollPayrollSummaryCellSuggestionEdge>;
  /** A list of nodes. */
  nodes: Array<PayrollPayrollSummaryCellSuggestion>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PayrollPayrollSummaryCellSuggestionEdge = {
  __typename?: 'PayrollPayrollSummaryCellSuggestionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PayrollPayrollSummaryCellSuggestion;
};

/** A payroll summary import */
export type PayrollPayrollSummaryImport = {
  __typename?: 'PayrollPayrollSummaryImport';
  companyId: Scalars['Int'];
  companyIdentifierCell?: Maybe<Scalars['String']>;
  compensationType?: Maybe<Scalars['String']>;
  employeesAsRowsOrColumns?: Maybe<Scalars['String']>;
  fileName: Scalars['String'];
  firstNameCell?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  idCell?: Maybe<Scalars['String']>;
  lastNameCell?: Maybe<Scalars['String']>;
  missingInfo: Scalars['Boolean'];
  netSalaryCell?: Maybe<Scalars['String']>;
  policyId: Scalars['Int'];
  policyPeriod: PayrollPolicyPeriod;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  policyPeriodId: Scalars['Int'];
  worksheetData?: Maybe<Scalars['String']>;
};


/** A payroll summary import */
export type PayrollPayrollSummaryImportPolicyPeriodArgs = {
  byCurrentPeriods?: InputMaybe<Scalars['ISO8601Date']>;
  byCurrentPeriodsOrImmediatePastPeriods?: InputMaybe<Scalars['ISO8601Date']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  endsOn?: InputMaybe<Scalars['ISO8601Date']>;
  endsOnGte?: InputMaybe<Scalars['ISO8601Date']>;
  endsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  periodEndsOn?: InputMaybe<Scalars['ISO8601Date']>;
  periodStartsOn?: InputMaybe<Scalars['ISO8601Date']>;
  policyIds?: InputMaybe<Array<Scalars['Int']>>;
  startsOnGt?: InputMaybe<Scalars['ISO8601Date']>;
  startsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  status?: InputMaybe<Array<Scalars['String']>>;
};

/** The connection type for PayrollPayrollSummaryImport. */
export type PayrollPayrollSummaryImportConnection = {
  __typename?: 'PayrollPayrollSummaryImportConnection';
  /** A list of edges. */
  edges: Array<PayrollPayrollSummaryImportEdge>;
  /** A list of nodes. */
  nodes: Array<PayrollPayrollSummaryImport>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PayrollPayrollSummaryImportEdge = {
  __typename?: 'PayrollPayrollSummaryImportEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PayrollPayrollSummaryImport;
};

/** A payroll summary import template */
export type PayrollPayrollSummaryImportTemplate = {
  __typename?: 'PayrollPayrollSummaryImportTemplate';
  id: PayrollSummaryImportTemplatesIdsEnum;
  url: Scalars['String'];
};

/** The connection type for PayrollPayrollSummaryImportTemplate. */
export type PayrollPayrollSummaryImportTemplateConnection = {
  __typename?: 'PayrollPayrollSummaryImportTemplateConnection';
  /** A list of edges. */
  edges: Array<PayrollPayrollSummaryImportTemplateEdge>;
  /** A list of nodes. */
  nodes: Array<PayrollPayrollSummaryImportTemplate>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PayrollPayrollSummaryImportTemplateEdge = {
  __typename?: 'PayrollPayrollSummaryImportTemplateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PayrollPayrollSummaryImportTemplate;
};

/** Returns the employees in an excel together with the name matches for the company */
export type PayrollPayrollSummaryMatch = {
  __typename?: 'PayrollPayrollSummaryMatch';
  companyIdentifier?: Maybe<Scalars['String']>;
  conceptsLines: Array<PayrollConceptLine>;
  employeeId?: Maybe<Scalars['Int']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  matchReason: Scalars['String'];
  row: Scalars['Int'];
};

/** The connection type for PayrollPayrollSummaryMatch. */
export type PayrollPayrollSummaryMatchConnection = {
  __typename?: 'PayrollPayrollSummaryMatchConnection';
  /** A list of edges. */
  edges: Array<PayrollPayrollSummaryMatchEdge>;
  /** A list of nodes. */
  nodes: Array<PayrollPayrollSummaryMatch>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PayrollPayrollSummaryMatchEdge = {
  __typename?: 'PayrollPayrollSummaryMatchEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PayrollPayrollSummaryMatch;
};

/** Payroll payroll summary sample */
export type PayrollPayrollSummarySample = {
  __typename?: 'PayrollPayrollSummarySample';
  column: Scalars['Int'];
  conceptId?: Maybe<Scalars['Int']>;
  fieldName: Scalars['String'];
  sample: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

/** The connection type for PayrollPayrollSummarySample. */
export type PayrollPayrollSummarySampleConnection = {
  __typename?: 'PayrollPayrollSummarySampleConnection';
  /** A list of edges. */
  edges: Array<PayrollPayrollSummarySampleEdge>;
  /** A list of nodes. */
  nodes: Array<PayrollPayrollSummarySample>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PayrollPayrollSummarySampleEdge = {
  __typename?: 'PayrollPayrollSummarySampleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PayrollPayrollSummarySample;
};

/** Payroll policy */
export type PayrollPolicy = {
  __typename?: 'PayrollPolicy';
  archivedAt?: Maybe<Scalars['String']>;
  company: ApiCoreCompany;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  companyId: Scalars['Int'];
  country?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  default?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  recurrence: Scalars['String'];
  startsOn: Scalars['ISO8601Date'];
};

/** The connection type for PayrollPolicy. */
export type PayrollPolicyConnection = {
  __typename?: 'PayrollPolicyConnection';
  /** A list of edges. */
  edges: Array<PayrollPolicyEdge>;
  /** A list of nodes. */
  nodes: Array<PayrollPolicy>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PayrollPolicyEdge = {
  __typename?: 'PayrollPolicyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PayrollPolicy;
};

/** Payroll policy periods */
export type PayrollPolicyPeriod = {
  __typename?: 'PayrollPolicyPeriod';
  /** The date and time the calculation started */
  calculationStartedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The id of the company */
  companyId: Scalars['Int'];
  /** The start date of the policy period */
  endsOn: Scalars['ISO8601Date'];
  /** Policy period id */
  id: Scalars['Int'];
  /** Policy name with start and end date */
  name?: Maybe<Scalars['String']>;
  /** Period for the policy */
  period: Scalars['String'];
  policy?: Maybe<PayrollPolicy>;
  /**
   * The id of the policy associated with the policy period
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  policyId: Scalars['Int'];
  /** Policy name */
  policyName?: Maybe<Scalars['String']>;
  /** The start date of the policy period */
  startsOn: Scalars['ISO8601Date'];
  /** Policy period status */
  status?: Maybe<Scalars['String']>;
};


/** Payroll policy periods */
export type PayrollPolicyPeriodPolicyArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  default?: InputMaybe<Scalars['Boolean']>;
  includeArchived?: Scalars['Boolean'];
};

/** The connection type for PayrollPolicyPeriod. */
export type PayrollPolicyPeriodConnection = {
  __typename?: 'PayrollPolicyPeriodConnection';
  /** A list of edges. */
  edges: Array<PayrollPolicyPeriodEdge>;
  /** A list of nodes. */
  nodes: Array<PayrollPolicyPeriod>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PayrollPolicyPeriodEdge = {
  __typename?: 'PayrollPolicyPeriodEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PayrollPolicyPeriod;
};

/** the filter for the policy_periods resource */
export type PayrollPolicyPeriodFilter = {
  or?: InputMaybe<Array<PayrollPolicyPeriodFilterConditions>>;
  startsOn?: InputMaybe<DateFilter>;
};

export type PayrollPolicyPeriodFilterConditions = {
  startsOn?: InputMaybe<DateFilter>;
};

export type PayrollPolicyPeriodTypesPeriodTypeEnum =
  | 'current'
  | 'next'
  | 'previous';

/** Payroll reimbursable supplement taxonomy */
export type PayrollReimbursableSupplementTaxonomy = {
  __typename?: 'PayrollReimbursableSupplementTaxonomy';
  id: Scalars['String'];
  legalEntityId: Scalars['String'];
  reimbursableId: Scalars['String'];
  reimbursableType: Scalars['String'];
  supplementTaxonomyId: Scalars['String'];
};

/** The connection type for PayrollReimbursableSupplementTaxonomy. */
export type PayrollReimbursableSupplementTaxonomyConnection = {
  __typename?: 'PayrollReimbursableSupplementTaxonomyConnection';
  /** A list of edges. */
  edges: Array<PayrollReimbursableSupplementTaxonomyEdge>;
  /** A list of nodes. */
  nodes: Array<PayrollReimbursableSupplementTaxonomy>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PayrollReimbursableSupplementTaxonomyEdge = {
  __typename?: 'PayrollReimbursableSupplementTaxonomyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PayrollReimbursableSupplementTaxonomy;
};

/** Payroll result */
export type PayrollResult = {
  __typename?: 'PayrollResult';
  authorId?: Maybe<Scalars['Int']>;
  compensationsPayrollRunId?: Maybe<Scalars['Int']>;
  concept?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  documentId?: Maybe<Scalars['Int']>;
  filename: Scalars['String'];
  id: Scalars['Int'];
  importProcess?: Maybe<UniversalImporterImportProcess>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  importProcessId?: Maybe<Scalars['Int']>;
  payrollPolicyPeriodId?: Maybe<Scalars['Int']>;
  selectedFields: Scalars['String'];
};


/** Payroll result */
export type PayrollResultImportProcessArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  importType?: InputMaybe<Scalars['String']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  processTreeId?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['String']>;
  withErrors?: InputMaybe<Scalars['Boolean']>;
};

/** Payroll result concept items */
export type PayrollResultConceptItem = {
  __typename?: 'PayrollResultConceptItem';
  amount?: Maybe<Scalars['BigInt']>;
  concept: PayrollConcept;
  createdAt: Scalars['ISO8601DateTime'];
  employee: EmployeesEmployee;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  employeeId: Scalars['Int'];
  employeeResultsSummaryId: Scalars['String'];
  id: Scalars['Int'];
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  payrollConceptId: Scalars['Int'];
  payrollResultId: Scalars['Int'];
};


/** Payroll result concept items */
export type PayrollResultConceptItemConceptArgs = {
  categories?: InputMaybe<Array<PayrollValueObjectsConceptCategoryEnum>>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  default?: InputMaybe<Scalars['Boolean']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  names?: InputMaybe<Array<Scalars['String']>>;
  policyPeriodId?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  unitTypes?: InputMaybe<Array<PayrollValueObjectsConceptUnitTypeEnum>>;
  withActiveStatus?: InputMaybe<Scalars['Boolean']>;
};


/** Payroll result concept items */
export type PayrollResultConceptItemEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for PayrollResultConceptItem. */
export type PayrollResultConceptItemConnection = {
  __typename?: 'PayrollResultConceptItemConnection';
  /** A list of edges. */
  edges: Array<PayrollResultConceptItemEdge>;
  /** A list of nodes. */
  nodes: Array<PayrollResultConceptItem>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PayrollResultConceptItemEdge = {
  __typename?: 'PayrollResultConceptItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PayrollResultConceptItem;
};

/** Latest payroll result concept items */
export type PayrollResultConceptItemSummary = {
  __typename?: 'PayrollResultConceptItemSummary';
  amount: Scalars['BigInt'];
  concept: PayrollConcept;
  createdAt: Scalars['ISO8601DateTime'];
  employee: EmployeesEmployee;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  employeeId: Scalars['Int'];
  id: Scalars['Int'];
  paymentType: Scalars['String'];
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  payrollConceptId?: Maybe<Scalars['Int']>;
  payrollConceptName: Scalars['String'];
  policyPeriodId?: Maybe<Scalars['Int']>;
};


/** Latest payroll result concept items */
export type PayrollResultConceptItemSummaryConceptArgs = {
  categories?: InputMaybe<Array<PayrollValueObjectsConceptCategoryEnum>>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  default?: InputMaybe<Scalars['Boolean']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  names?: InputMaybe<Array<Scalars['String']>>;
  policyPeriodId?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  unitTypes?: InputMaybe<Array<PayrollValueObjectsConceptUnitTypeEnum>>;
  withActiveStatus?: InputMaybe<Scalars['Boolean']>;
};


/** Latest payroll result concept items */
export type PayrollResultConceptItemSummaryEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for PayrollResultConceptItemSummary. */
export type PayrollResultConceptItemSummaryConnection = {
  __typename?: 'PayrollResultConceptItemSummaryConnection';
  /** A list of edges. */
  edges: Array<PayrollResultConceptItemSummaryEdge>;
  /** A list of nodes. */
  nodes: Array<PayrollResultConceptItemSummary>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PayrollResultConceptItemSummaryEdge = {
  __typename?: 'PayrollResultConceptItemSummaryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PayrollResultConceptItemSummary;
};

/** Payroll result concept total */
export type PayrollResultConceptTotal = {
  __typename?: 'PayrollResultConceptTotal';
  conceptId: Scalars['Int'];
  total: Scalars['BigInt'];
};

/** The connection type for PayrollResultConceptTotal. */
export type PayrollResultConceptTotalConnection = {
  __typename?: 'PayrollResultConceptTotalConnection';
  /** A list of edges. */
  edges: Array<PayrollResultConceptTotalEdge>;
  /** A list of nodes. */
  nodes: Array<PayrollResultConceptTotal>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PayrollResultConceptTotalEdge = {
  __typename?: 'PayrollResultConceptTotalEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PayrollResultConceptTotal;
};

/** The connection type for PayrollResult. */
export type PayrollResultConnection = {
  __typename?: 'PayrollResultConnection';
  /** A list of edges. */
  edges: Array<PayrollResultEdge>;
  /** A list of nodes. */
  nodes: Array<PayrollResult>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PayrollResultEdge = {
  __typename?: 'PayrollResultEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PayrollResult;
};

/** the filter for the results resource */
export type PayrollResultFilter = {
  createdAt?: InputMaybe<DateTimeFilter>;
  or?: InputMaybe<Array<PayrollResultFilterConditions>>;
};

export type PayrollResultFilterConditions = {
  createdAt?: InputMaybe<DateTimeFilter>;
};

/** Payroll result label concept mapping */
export type PayrollResultLabelConceptMapping = {
  __typename?: 'PayrollResultLabelConceptMapping';
  companyId: Scalars['Int'];
  conceptId: Scalars['Int'];
  id: Scalars['Int'];
  label: Scalars['String'];
};

/** The connection type for PayrollResultLabelConceptMapping. */
export type PayrollResultLabelConceptMappingConnection = {
  __typename?: 'PayrollResultLabelConceptMappingConnection';
  /** A list of edges. */
  edges: Array<PayrollResultLabelConceptMappingEdge>;
  /** A list of nodes. */
  nodes: Array<PayrollResultLabelConceptMapping>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PayrollResultLabelConceptMappingEdge = {
  __typename?: 'PayrollResultLabelConceptMappingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PayrollResultLabelConceptMapping;
};

/** Payroll result label concept mappings suggestion */
export type PayrollResultLabelConceptMappingsSuggestion = {
  __typename?: 'PayrollResultLabelConceptMappingsSuggestion';
  conceptId: Scalars['Int'];
  label: Scalars['String'];
};

/** The connection type for PayrollResultLabelConceptMappingsSuggestion. */
export type PayrollResultLabelConceptMappingsSuggestionConnection = {
  __typename?: 'PayrollResultLabelConceptMappingsSuggestionConnection';
  /** A list of edges. */
  edges: Array<PayrollResultLabelConceptMappingsSuggestionEdge>;
  /** A list of nodes. */
  nodes: Array<PayrollResultLabelConceptMappingsSuggestion>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PayrollResultLabelConceptMappingsSuggestionEdge = {
  __typename?: 'PayrollResultLabelConceptMappingsSuggestionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PayrollResultLabelConceptMappingsSuggestion;
};

/** The result of running validation formulas */
export type PayrollResultValidation = {
  __typename?: 'PayrollResultValidation';
  difference: Scalars['Int'];
  employee?: Maybe<EmployeesEmployee>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  employeeId: Scalars['Int'];
  error?: Maybe<Scalars['String']>;
  inputsAmount: Scalars['Int'];
  resultsAmount: Scalars['Int'];
  status: Scalars['String'];
  validation?: Maybe<PayrollResultValidationFormula>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  validationId: Scalars['Int'];
};


/** The result of running validation formulas */
export type PayrollResultValidationEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for PayrollResultValidation. */
export type PayrollResultValidationConnection = {
  __typename?: 'PayrollResultValidationConnection';
  /** A list of edges. */
  edges: Array<PayrollResultValidationEdge>;
  /** A list of nodes. */
  nodes: Array<PayrollResultValidation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PayrollResultValidationEdge = {
  __typename?: 'PayrollResultValidationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PayrollResultValidation;
};

/** Payroll result validation formula */
export type PayrollResultValidationFormula = {
  __typename?: 'PayrollResultValidationFormula';
  companyId: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  errorMargin: Scalars['Int'];
  errorMarginType: Scalars['String'];
  id: Scalars['Int'];
  inputsExpression: Scalars['String'];
  name: Scalars['String'];
  resultsExpression: Scalars['String'];
};

/** The connection type for PayrollResultValidationFormula. */
export type PayrollResultValidationFormulaConnection = {
  __typename?: 'PayrollResultValidationFormulaConnection';
  /** A list of edges. */
  edges: Array<PayrollResultValidationFormulaEdge>;
  /** A list of nodes. */
  nodes: Array<PayrollResultValidationFormula>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PayrollResultValidationFormulaEdge = {
  __typename?: 'PayrollResultValidationFormulaEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PayrollResultValidationFormula;
};

/** Payroll result validations item */
export type PayrollResultValidationsItem = {
  __typename?: 'PayrollResultValidationsItem';
  amount: Scalars['Int'];
  employeeId: Scalars['Int'];
  name: Scalars['String'];
  phase: Scalars['String'];
  selector: Scalars['String'];
  source: Scalars['String'];
};

/** The connection type for PayrollResultValidationsItem. */
export type PayrollResultValidationsItemConnection = {
  __typename?: 'PayrollResultValidationsItemConnection';
  /** A list of edges. */
  edges: Array<PayrollResultValidationsItemEdge>;
  /** A list of nodes. */
  nodes: Array<PayrollResultValidationsItem>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PayrollResultValidationsItemEdge = {
  __typename?: 'PayrollResultValidationsItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PayrollResultValidationsItem;
};

export type PayrollSummaryImportTemplatesIdsEnum =
  | 'de'
  | 'es'
  | 'fr'
  | 'it';

/** Payroll Supplements */
export type PayrollSupplement = {
  __typename?: 'PayrollSupplement';
  /** The amount of the supplement in cents */
  amountInCents?: Maybe<Scalars['Int']>;
  /** The identifier of the company associated with the supplement */
  companyId: Scalars['Int'];
  contractCompensation?: Maybe<ContractsCompensation>;
  /**
   * The contract compensation identifier associated with the supplement
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  contractsCompensationId?: Maybe<Scalars['Int']>;
  /**
   * The taxonomy identifier associated with the supplement
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  contractsTaxonomyId?: Maybe<Scalars['Int']>;
  createdByAccessId?: Maybe<Scalars['Int']>;
  /** The currency used for the supplement, typically in ISO 4217 format */
  currency?: Maybe<Scalars['String']>;
  /** The description of the supplement */
  description?: Maybe<Scalars['String']>;
  /** The date on which the supplement becomes effective */
  effectiveOn?: Maybe<Scalars['ISO8601Date']>;
  employee?: Maybe<EmployeesEmployee>;
  /**
   * The identifier of the employee associated with the supplement
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  employeeId: Scalars['Int'];
  /** Observations on the employee made by the admin or manager */
  employeeObservations?: Maybe<Array<Scalars['String']>>;
  /** The equivalent value of minutes in cents for payroll processing */
  equivalentMinutesInCents?: Maybe<Scalars['Int']>;
  /** The identifier of the supplement */
  id: Scalars['Int'];
  /** The legal entity identifier associated with the supplement */
  legalEntityId?: Maybe<Scalars['Int']>;
  /** The value of minutes in cents after adjustments */
  minutesInCents?: Maybe<Scalars['Int']>;
  /**
   * The payroll policy period identifier associated with the supplement
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  payrollPolicyPeriodId?: Maybe<Scalars['Int']>;
  payrollSupplementBulkImport?: Maybe<PayrollSupplementBulkImport>;
  payrollSupplementDescriptions: Array<PayrollSupplementDescription>;
  payrollSupplementDescriptionsConnection: PayrollSupplementDescriptionConnection;
  payrollSupplementObservations: Array<PayrollSupplementObservation>;
  payrollSupplementObservationsConnection: PayrollSupplementObservationConnection;
  payrollSupplementValidations: Array<PayrollSupplementValidation>;
  payrollSupplementValidationsConnection: PayrollSupplementValidationConnection;
  policyPeriod?: Maybe<PayrollPolicyPeriod>;
  /** The raw value of minutes in cents associated with the supplement */
  rawMinutesInCents?: Maybe<Scalars['Int']>;
  sourceId?: Maybe<Scalars['Int']>;
  sourceType?: Maybe<HandoffsValueObjectsSourceTypeEnum>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  supplementBulkImportId?: Maybe<Scalars['Int']>;
  taxonomy?: Maybe<ContractsTaxonomy>;
  /** The unit of the supplement */
  unit: PayrollSupplementsUnitEnum;
};


/** Payroll Supplements */
export type PayrollSupplementContractCompensationArgs = {
  calculation?: InputMaybe<Scalars['String']>;
  compensationTypes?: InputMaybe<Array<Scalars['String']>>;
  contractApprovalStatus?: InputMaybe<Array<Scalars['String']>>;
  contractVersionIds?: InputMaybe<Array<Scalars['Int']>>;
  notIds?: InputMaybe<Array<Scalars['Int']>>;
  occurringAt?: InputMaybe<Scalars['ISO8601Date']>;
  occurringFrequency?: InputMaybe<Scalars['String']>;
  occursAt?: InputMaybe<Scalars['ISO8601Date']>;
  payrollPolicyId?: InputMaybe<Scalars['Int']>;
  syncWithSupplements?: InputMaybe<Scalars['Boolean']>;
};


/** Payroll Supplements */
export type PayrollSupplementEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Payroll Supplements */
export type PayrollSupplementPayrollSupplementBulkImportArgs = {
  policyPeriodId?: InputMaybe<Scalars['Int']>;
};


/** Payroll Supplements */
export type PayrollSupplementPayrollSupplementDescriptionsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Payroll Supplements */
export type PayrollSupplementPayrollSupplementDescriptionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Payroll Supplements */
export type PayrollSupplementPayrollSupplementObservationsArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Payroll Supplements */
export type PayrollSupplementPayrollSupplementObservationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Payroll Supplements */
export type PayrollSupplementPayrollSupplementValidationsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Payroll Supplements */
export type PayrollSupplementPayrollSupplementValidationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Payroll Supplements */
export type PayrollSupplementPolicyPeriodArgs = {
  byCurrentPeriods?: InputMaybe<Scalars['ISO8601Date']>;
  byCurrentPeriodsOrImmediatePastPeriods?: InputMaybe<Scalars['ISO8601Date']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  endsOn?: InputMaybe<Scalars['ISO8601Date']>;
  endsOnGte?: InputMaybe<Scalars['ISO8601Date']>;
  endsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  periodEndsOn?: InputMaybe<Scalars['ISO8601Date']>;
  periodStartsOn?: InputMaybe<Scalars['ISO8601Date']>;
  policyIds?: InputMaybe<Array<Scalars['Int']>>;
  startsOnGt?: InputMaybe<Scalars['ISO8601Date']>;
  startsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  status?: InputMaybe<Array<Scalars['String']>>;
};


/** Payroll Supplements */
export type PayrollSupplementTaxonomyArgs = {
  legalEntityId?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
};

/** Payroll supplement bulk import */
export type PayrollSupplementBulkImport = {
  __typename?: 'PayrollSupplementBulkImport';
  authorId: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  filename: Scalars['String'];
  id: Scalars['Int'];
  policyPeriodId: Scalars['Int'];
  supplements: Array<PayrollSupplement>;
  supplementsConnection: PayrollSupplementConnection;
};


/** Payroll supplement bulk import */
export type PayrollSupplementBulkImportSupplementsArgs = {
  compensationId?: InputMaybe<Scalars['Int']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  from?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  policyPeriodIds?: Array<Scalars['Int']>;
  sourceIds?: InputMaybe<Array<Scalars['Int']>>;
  sourceType?: InputMaybe<Scalars['String']>;
  taxonomyIds?: InputMaybe<Array<Scalars['Int']>>;
  to?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Payroll supplement bulk import */
export type PayrollSupplementBulkImportSupplementsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  compensationId?: InputMaybe<Scalars['Int']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  policyPeriodIds?: Array<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  sourceIds?: InputMaybe<Array<Scalars['Int']>>;
  sourceType?: InputMaybe<Scalars['String']>;
  taxonomyIds?: InputMaybe<Array<Scalars['Int']>>;
  to?: InputMaybe<Scalars['ISO8601Date']>;
};

/** The connection type for PayrollSupplementBulkImport. */
export type PayrollSupplementBulkImportConnection = {
  __typename?: 'PayrollSupplementBulkImportConnection';
  /** A list of edges. */
  edges: Array<PayrollSupplementBulkImportEdge>;
  /** A list of nodes. */
  nodes: Array<PayrollSupplementBulkImport>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PayrollSupplementBulkImportEdge = {
  __typename?: 'PayrollSupplementBulkImportEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PayrollSupplementBulkImport;
};

/** The connection type for PayrollSupplement. */
export type PayrollSupplementConnection = {
  __typename?: 'PayrollSupplementConnection';
  /** A list of edges. */
  edges: Array<PayrollSupplementEdge>;
  /** A list of nodes. */
  nodes: Array<PayrollSupplement>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** Payroll Supplement Descriptions */
export type PayrollSupplementDescription = {
  __typename?: 'PayrollSupplementDescription';
  compensationAmount?: Maybe<Scalars['Int']>;
  compensationCalculation?: Maybe<Scalars['String']>;
  compensationType?: Maybe<Scalars['String']>;
  equivalentMinutesInCents?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  minutesInCents?: Maybe<Scalars['Int']>;
  rawMinutesInCents?: Maybe<Scalars['Int']>;
  supplementId: Scalars['Int'];
  workedDays?: Maybe<Scalars['Int']>;
};

/** The connection type for PayrollSupplementDescription. */
export type PayrollSupplementDescriptionConnection = {
  __typename?: 'PayrollSupplementDescriptionConnection';
  /** A list of edges. */
  edges: Array<PayrollSupplementDescriptionEdge>;
  /** A list of nodes. */
  nodes: Array<PayrollSupplementDescription>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PayrollSupplementDescriptionEdge = {
  __typename?: 'PayrollSupplementDescriptionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PayrollSupplementDescription;
};

/** An edge in a connection. */
export type PayrollSupplementEdge = {
  __typename?: 'PayrollSupplementEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PayrollSupplement;
};

/** Payroll Supplement Insights */
export type PayrollSupplementInsight = {
  __typename?: 'PayrollSupplementInsight';
  draftSupplementCount: Scalars['Int'];
  legalEntityCount: Scalars['Int'];
  policyPeriod: PayrollPolicyPeriod;
  supplementCount: Scalars['Int'];
  totalByCurrency: Array<PayrollTotalByCurrency>;
  totalByEmployee: Array<PayrollTotalByEmployee>;
  totalByTaxonomy: Array<PayrollTotalByTaxonomy>;
};


/** Payroll Supplement Insights */
export type PayrollSupplementInsightPolicyPeriodArgs = {
  byCurrentPeriods?: InputMaybe<Scalars['ISO8601Date']>;
  byCurrentPeriodsOrImmediatePastPeriods?: InputMaybe<Scalars['ISO8601Date']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  endsOn?: InputMaybe<Scalars['ISO8601Date']>;
  endsOnGte?: InputMaybe<Scalars['ISO8601Date']>;
  endsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  periodEndsOn?: InputMaybe<Scalars['ISO8601Date']>;
  periodStartsOn?: InputMaybe<Scalars['ISO8601Date']>;
  policyIds?: InputMaybe<Array<Scalars['Int']>>;
  startsOnGt?: InputMaybe<Scalars['ISO8601Date']>;
  startsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  status?: InputMaybe<Array<Scalars['String']>>;
};

/** The connection type for PayrollSupplementInsight. */
export type PayrollSupplementInsightConnection = {
  __typename?: 'PayrollSupplementInsightConnection';
  /** A list of edges. */
  edges: Array<PayrollSupplementInsightEdge>;
  /** A list of nodes. */
  nodes: Array<PayrollSupplementInsight>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PayrollSupplementInsightEdge = {
  __typename?: 'PayrollSupplementInsightEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PayrollSupplementInsight;
};

/** Payroll Supplement Observations */
export type PayrollSupplementObservation = {
  __typename?: 'PayrollSupplementObservation';
  author?: Maybe<ApiCoreAccess>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  authorId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  supplementId: Scalars['Int'];
  text: Scalars['String'];
  writtenAt: Scalars['ISO8601DateTime'];
};


/** Payroll Supplement Observations */
export type PayrollSupplementObservationAuthorArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for PayrollSupplementObservation. */
export type PayrollSupplementObservationConnection = {
  __typename?: 'PayrollSupplementObservationConnection';
  /** A list of edges. */
  edges: Array<PayrollSupplementObservationEdge>;
  /** A list of nodes. */
  nodes: Array<PayrollSupplementObservation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PayrollSupplementObservationEdge = {
  __typename?: 'PayrollSupplementObservationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PayrollSupplementObservation;
};

/** Payroll Supplement Validations */
export type PayrollSupplementValidation = {
  __typename?: 'PayrollSupplementValidation';
  authorId: Scalars['Int'];
  createdAt: Scalars['ISO8601Date'];
  id: Scalars['Int'];
  supplementId: Scalars['Int'];
};

/** The connection type for PayrollSupplementValidation. */
export type PayrollSupplementValidationConnection = {
  __typename?: 'PayrollSupplementValidationConnection';
  /** A list of edges. */
  edges: Array<PayrollSupplementValidationEdge>;
  /** A list of nodes. */
  nodes: Array<PayrollSupplementValidation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PayrollSupplementValidationEdge = {
  __typename?: 'PayrollSupplementValidationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PayrollSupplementValidation;
};

export type PayrollSupplementsUnitEnum =
  | 'money'
  | 'time'
  | 'units';

export type PayrollTotalByCurrency = {
  __typename?: 'PayrollTotalByCurrency';
  currency: Scalars['String'];
  total: Scalars['BigInt'];
};

export type PayrollTotalByEmployee = {
  __typename?: 'PayrollTotalByEmployee';
  employeeId: Scalars['Int'];
  total: Scalars['BigInt'];
};

export type PayrollTotalByTaxonomy = {
  __typename?: 'PayrollTotalByTaxonomy';
  contractsTaxonomyId: Scalars['Int'];
  contractsTaxonomyName: Scalars['String'];
  legalEntityCurrency: Scalars['String'];
  legalEntityId: Scalars['Int'];
  legalEntityName: Scalars['String'];
  total: Scalars['BigInt'];
};

export type PayrollValueObjectsBulkDeleteResultErrorCodeEnum =
  | 'closed_policy_period'
  | 'destroy_error'
  | 'no_policy_period'
  | 'unauthorized_to_create_supplement'
  | 'unauthorized_to_delete_supplement';

export type PayrollValueObjectsConceptCategoryEnum =
  | 'company_contribution'
  | 'deductions'
  | 'earnings_benefits_in_kind'
  | 'earnings_fixed_salary'
  | 'earnings_others'
  | 'earnings_variable'
  | 'summarized_values';

export type PayrollValueObjectsConceptUnitTypeEnum =
  | 'distance'
  | 'money'
  | 'time'
  | 'unit';

export type PayrollValueObjectsPolicyPeriodStatusEnum =
  | 'paid'
  | 'payment_processing'
  | 'payroll_calculation'
  | 'preparation'
  | 'supplements_definition'
  | 'under_review';

export type PeopleChartContextlessPolicies = {
  __typename?: 'PeopleChartContextlessPolicies';
  sidebarSeeEmployeesPeopleChartSubLevelItem: ContextlessPolicyResolution;
};

/** People chart structure */
export type PeopleChartStructure = {
  __typename?: 'PeopleChartStructure';
  companyId: Scalars['String'];
  groups: Scalars['String'];
  hierarchy: Scalars['String'];
  id: Scalars['String'];
};

/** The connection type for PeopleChartStructure. */
export type PeopleChartStructureConnection = {
  __typename?: 'PeopleChartStructureConnection';
  /** A list of edges. */
  edges: Array<PeopleChartStructureEdge>;
  /** A list of nodes. */
  nodes: Array<PeopleChartStructure>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PeopleChartStructureEdge = {
  __typename?: 'PeopleChartStructureEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PeopleChartStructure;
};

/** People groups people group membership */
export type PeopleGroupsPeopleGroupMembership = {
  __typename?: 'PeopleGroupsPeopleGroupMembership';
  access: ApiCoreAccess;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  accessId: Scalars['Int'];
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['Int'];
  peopleGroupId: Scalars['Int'];
};


/** People groups people group membership */
export type PeopleGroupsPeopleGroupMembershipAccessArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for PeopleGroupsPeopleGroupMembership. */
export type PeopleGroupsPeopleGroupMembershipConnection = {
  __typename?: 'PeopleGroupsPeopleGroupMembershipConnection';
  /** A list of edges. */
  edges: Array<PeopleGroupsPeopleGroupMembershipEdge>;
  /** A list of nodes. */
  nodes: Array<PeopleGroupsPeopleGroupMembership>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PeopleGroupsPeopleGroupMembershipEdge = {
  __typename?: 'PeopleGroupsPeopleGroupMembershipEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PeopleGroupsPeopleGroupMembership;
};

export type PerformanceAggregationEngagementSignal = {
  __typename?: 'PerformanceAggregationEngagementSignal';
  category: PerformanceEngagementSignalsSignalCategoryEnum;
  count?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  quotes?: Maybe<Array<Scalars['String']>>;
  tag: Scalars['String'];
  type: PerformanceEngagementSignalsSignalTypeEnum;
};

/** Performance Agreements */
export type PerformanceAgreement = {
  __typename?: 'PerformanceAgreement';
  _policies?: Maybe<PerformanceAgreementPolicies>;
  _policiesCollection?: Maybe<Array<PermissionsPolicyResolution>>;
  _policiesConnection: PermissionsPolicyResolutionConnection;
  actionItemsInfo: Array<PerformanceAgreementActionItem>;
  actionItemsInfoConnection: PerformanceAgreementActionItemConnection;
  agreementDocuments: Array<PerformanceAgreementDocument>;
  agreementDocumentsConnection: PerformanceAgreementDocumentConnection;
  /** Date when the action plan was last signed */
  agreementSignedAt?: Maybe<Scalars['String']>;
  agreementTrainingRequests: Array<PerformanceAgreementTrainingRequest>;
  agreementTrainingRequestsConnection: PerformanceAgreementTrainingRequestConnection;
  /** Conclusions of the action plan */
  conclusions?: Maybe<PerformanceAgreementConclusions>;
  /** Whether the agreement PDF is being generated */
  generatingDocument: Scalars['Boolean'];
  goalMetrics: Array<GoalsMetric>;
  goalMetricsConnection: GoalsMetricConnection;
  /** Action plan ID */
  id: Scalars['String'];
  /** Date when the action plan was last modified */
  lastModifiedAt?: Maybe<Scalars['String']>;
  /** When the action plan cannot be edited anymore. Locked when both manager and employee signed it. */
  locked: Scalars['Boolean'];
  /** Manager comments by question */
  managerComments: Array<PerformanceQuestionnaireQuestionAnswerComment>;
  managerEvaluation?: Maybe<PerformanceReviewEvaluation>;
  /**
   * Manager review evaluation ID
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  managerEvaluationId?: Maybe<Scalars['Int']>;
  /** Date when the manager signed the action plan */
  managerSignedAt?: Maybe<Scalars['String']>;
  materializedProcessTargetId: Scalars['Int'];
  process: PerformanceReviewProcess;
  /**
   * Review process ID
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  processId: Scalars['Int'];
  reviewer?: Maybe<EmployeesEmployeeName>;
  /**
   * Manager employee ID
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  reviewerId?: Maybe<Scalars['Int']>;
  /** Self comments by question */
  selfComments: Array<PerformanceQuestionnaireQuestionAnswerComment>;
  selfEvaluation?: Maybe<PerformanceReviewEvaluation>;
  /**
   * Self review evaluation ID
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  selfEvaluationId?: Maybe<Scalars['Int']>;
  signer?: Maybe<ApiCoreAccess>;
  /**
   * Manager access ID who signed the action plan
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  signerId?: Maybe<Scalars['Int']>;
  /** Action plan status */
  status: PerformanceAgreementStatusEnum;
  target: PerformanceReviewProcessTarget;
  /**
   * Review process target ID
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  targetId: Scalars['String'];
  /** Date when the employee signed the action plan */
  targetSignedAt?: Maybe<Scalars['String']>;
};


/** Performance Agreements */
export type PerformanceAgreement_PoliciesCollectionArgs = {
  ids: Array<PerformanceAgreementPoliciesEnum>;
};


/** Performance Agreements */
export type PerformanceAgreement_PoliciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Performance Agreements */
export type PerformanceAgreementActionItemsInfoConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Performance Agreements */
export type PerformanceAgreementAgreementDocumentsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Performance Agreements */
export type PerformanceAgreementAgreementDocumentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Performance Agreements */
export type PerformanceAgreementAgreementTrainingRequestsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Performance Agreements */
export type PerformanceAgreementAgreementTrainingRequestsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Performance Agreements */
export type PerformanceAgreementGoalMetricsArgs = {
  assigneeIds?: InputMaybe<Array<Scalars['Int']>>;
  groupIds?: InputMaybe<Array<Scalars['String']>>;
  ids?: InputMaybe<Array<Scalars['String']>>;
};


/** Performance Agreements */
export type PerformanceAgreementGoalMetricsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  assigneeIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  groupIds?: InputMaybe<Array<Scalars['String']>>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Performance Agreements */
export type PerformanceAgreementManagerEvaluationArgs = {
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  performanceReviewProcessIds?: InputMaybe<Array<Scalars['Int']>>;
  published?: InputMaybe<Scalars['Boolean']>;
  reviewProcessTargetIds?: InputMaybe<Array<Scalars['String']>>;
  reviewerIds?: InputMaybe<Array<Scalars['Int']>>;
  reviewerStrategies?: InputMaybe<Array<PerformanceReviewerStrategiesStrategyEnum>>;
  targetAccessIds?: InputMaybe<Array<Scalars['Int']>>;
  withTargetsManagedByFilter?: InputMaybe<ReviewEvaluationsWithTargetsManagedByFilterInput>;
};


/** Performance Agreements */
export type PerformanceAgreementProcessArgs = {
  search?: InputMaybe<Scalars['String']>;
};


/** Performance Agreements */
export type PerformanceAgreementReviewerArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  afterEmployeeId?: InputMaybe<Scalars['Int']>;
  beforeEmployeeId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  reporteesOrLed?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyId?: InputMaybe<Scalars['Int']>;
  verb?: InputMaybe<Scalars['String']>;
  withActiveContract?: Scalars['Boolean'];
};


/** Performance Agreements */
export type PerformanceAgreementSelfEvaluationArgs = {
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  performanceReviewProcessIds?: InputMaybe<Array<Scalars['Int']>>;
  published?: InputMaybe<Scalars['Boolean']>;
  reviewProcessTargetIds?: InputMaybe<Array<Scalars['String']>>;
  reviewerIds?: InputMaybe<Array<Scalars['Int']>>;
  reviewerStrategies?: InputMaybe<Array<PerformanceReviewerStrategiesStrategyEnum>>;
  targetAccessIds?: InputMaybe<Array<Scalars['Int']>>;
  withTargetsManagedByFilter?: InputMaybe<ReviewEvaluationsWithTargetsManagedByFilterInput>;
};


/** Performance Agreements */
export type PerformanceAgreementSignerArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** Performance Agreements */
export type PerformanceAgreementTargetArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  agreementCompletionStatus?: InputMaybe<PerformanceDtosReviewProcessTargetAgreementCompletionStatusEnum>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  evaluationsCompletionStatus?: InputMaybe<PerformanceReviewEvaluationStatusEnum>;
  finalScores?: InputMaybe<Array<Scalars['Int']>>;
  includeArchivedReviews?: InputMaybe<Scalars['Boolean']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  managedByFilter?: InputMaybe<ReviewProcessTargetsManagedByFilterInput>;
  onlyForPeerAssignment?: InputMaybe<Scalars['Boolean']>;
  pendingPeerEvaluations?: InputMaybe<Scalars['Boolean']>;
  performanceReviewProcessIds?: InputMaybe<Array<Scalars['Int']>>;
  performanceReviewProcessStatus?: InputMaybe<Array<PerformanceReviewProcessStatusEnum>>;
  search?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDates?: InputMaybe<Array<Scalars['String']>>;
  toConductAgreement?: InputMaybe<Scalars['Boolean']>;
  withoutManager?: InputMaybe<Scalars['Boolean']>;
  workplaceIds?: InputMaybe<Array<Scalars['Int']>>;
};

/** Performance Agreement Action Items */
export type PerformanceAgreementActionItem = {
  __typename?: 'PerformanceAgreementActionItem';
  _policies?: Maybe<PerformanceAgreementActionItemPolicies>;
  _policiesCollection?: Maybe<Array<PermissionsPolicyResolution>>;
  _policiesConnection: PermissionsPolicyResolutionConnection;
  agreement: PerformanceAgreement;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  agreementId: Scalars['String'];
  author?: Maybe<ApiCoreAccess>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  authorAccessId: Scalars['Int'];
  createdAt: Scalars['String'];
  id: Scalars['String'];
  text: Scalars['String'];
};


/** Performance Agreement Action Items */
export type PerformanceAgreementActionItem_PoliciesCollectionArgs = {
  ids: Array<PerformanceAgreementActionItemPoliciesEnum>;
};


/** Performance Agreement Action Items */
export type PerformanceAgreementActionItem_PoliciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Performance Agreement Action Items */
export type PerformanceAgreementActionItemAgreementArgs = {
  materializedProcessTargetIds?: InputMaybe<Array<Scalars['Int']>>;
  processIds?: InputMaybe<Array<Scalars['Int']>>;
  targetIds?: InputMaybe<Array<Scalars['String']>>;
};


/** Performance Agreement Action Items */
export type PerformanceAgreementActionItemAuthorArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for PerformanceAgreementActionItem. */
export type PerformanceAgreementActionItemConnection = {
  __typename?: 'PerformanceAgreementActionItemConnection';
  /** A list of edges. */
  edges: Array<PerformanceAgreementActionItemEdge>;
  /** A list of nodes. */
  nodes: Array<PerformanceAgreementActionItem>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PerformanceAgreementActionItemEdge = {
  __typename?: 'PerformanceAgreementActionItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PerformanceAgreementActionItem;
};

export type PerformanceAgreementActionItemPolicies = {
  __typename?: 'PerformanceAgreementActionItemPolicies';
  manage: PermissionsPolicyResolution;
};

export type PerformanceAgreementActionItemPoliciesEnum =
  | 'manage';

export type PerformanceAgreementConclusions = {
  __typename?: 'PerformanceAgreementConclusions';
  lastUpdatedAt: Scalars['ISO8601DateTime'];
  text: Scalars['String'];
};

/** The connection type for PerformanceAgreement. */
export type PerformanceAgreementConnection = {
  __typename?: 'PerformanceAgreementConnection';
  /** A list of edges. */
  edges: Array<PerformanceAgreementEdge>;
  /** A list of nodes. */
  nodes: Array<PerformanceAgreement>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** Performance Agreement Documents */
export type PerformanceAgreementDocument = {
  __typename?: 'PerformanceAgreementDocument';
  agreement: PerformanceAgreement;
  createdAt: Scalars['ISO8601DateTime'];
  document?: Maybe<DocumentsDocument>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  documentsDocumentId: Scalars['Int'];
  fileUrl: Scalars['String'];
  id: Scalars['Int'];
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  performanceAgreementId: Scalars['String'];
  signatureStatus?: Maybe<DocumentsSignatureStatusEnum>;
};


/** Performance Agreement Documents */
export type PerformanceAgreementDocumentAgreementArgs = {
  materializedProcessTargetIds?: InputMaybe<Array<Scalars['Int']>>;
  processIds?: InputMaybe<Array<Scalars['Int']>>;
  targetIds?: InputMaybe<Array<Scalars['String']>>;
};


/** Performance Agreement Documents */
export type PerformanceAgreementDocumentDocumentArgs = {
  afterDate?: InputMaybe<Scalars['ISO8601Date']>;
  beforeDate?: InputMaybe<Scalars['ISO8601Date']>;
  byBookkeeperDocuments?: InputMaybe<Scalars['Boolean']>;
  byPendingAssignment?: Scalars['Boolean'];
  byTrashBin?: Scalars['Boolean'];
  byWithoutFolder?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['Int']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  excludedType?: InputMaybe<Scalars['String']>;
  folderId?: InputMaybe<Scalars['Int']>;
  fromEmployees?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  incidenceId?: InputMaybe<Scalars['Int']>;
  includeTrashBin?: InputMaybe<Scalars['Boolean']>;
  leaveId?: InputMaybe<Scalars['Int']>;
  payrollHiringId?: InputMaybe<Scalars['Int']>;
  relationships?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  sort?: Scalars['String'];
  space?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** The connection type for PerformanceAgreementDocument. */
export type PerformanceAgreementDocumentConnection = {
  __typename?: 'PerformanceAgreementDocumentConnection';
  /** A list of edges. */
  edges: Array<PerformanceAgreementDocumentEdge>;
  /** A list of nodes. */
  nodes: Array<PerformanceAgreementDocument>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PerformanceAgreementDocumentEdge = {
  __typename?: 'PerformanceAgreementDocumentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PerformanceAgreementDocument;
};

/** An edge in a connection. */
export type PerformanceAgreementEdge = {
  __typename?: 'PerformanceAgreementEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PerformanceAgreement;
};

export type PerformanceAgreementPolicies = {
  __typename?: 'PerformanceAgreementPolicies';
  addActionItems: PermissionsPolicyResolution;
  addConclusions: PermissionsPolicyResolution;
  addNotesAsManager: PermissionsPolicyResolution;
  addNotesAsTarget: PermissionsPolicyResolution;
  addTrainingRequest: PermissionsPolicyResolution;
  generateDocument: PermissionsPolicyResolution;
  signAsManager: PermissionsPolicyResolution;
  signAsTarget: PermissionsPolicyResolution;
  unsignAsManager: PermissionsPolicyResolution;
  unsignAsTarget: PermissionsPolicyResolution;
};

export type PerformanceAgreementPoliciesEnum =
  | 'add_action_items'
  | 'add_conclusions'
  | 'add_notes_as_manager'
  | 'add_notes_as_target'
  | 'add_training_request'
  | 'generate_document'
  | 'sign_as_manager'
  | 'sign_as_target'
  | 'unsign_as_manager'
  | 'unsign_as_target';

export type PerformanceAgreementStatusEnum =
  | 'pending'
  | 'signed';

/** Performance Agreement Training Requests */
export type PerformanceAgreementTrainingRequest = {
  __typename?: 'PerformanceAgreementTrainingRequest';
  agreement: PerformanceAgreement;
  id: Scalars['Int'];
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  performanceAgreementId: Scalars['String'];
  trainingRequest: TrainingsTrainingRequest;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  trainingRequestId: Scalars['Int'];
};


/** Performance Agreement Training Requests */
export type PerformanceAgreementTrainingRequestAgreementArgs = {
  materializedProcessTargetIds?: InputMaybe<Array<Scalars['Int']>>;
  processIds?: InputMaybe<Array<Scalars['Int']>>;
  targetIds?: InputMaybe<Array<Scalars['String']>>;
};


/** Performance Agreement Training Requests */
export type PerformanceAgreementTrainingRequestTrainingRequestArgs = {
  allowdrafts?: Scalars['Boolean'];
  authorId?: InputMaybe<Scalars['Int']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  employeesOrAuthor?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<TrainingsTrainingRequestStatusEnum>;
};

/** The connection type for PerformanceAgreementTrainingRequest. */
export type PerformanceAgreementTrainingRequestConnection = {
  __typename?: 'PerformanceAgreementTrainingRequestConnection';
  /** A list of edges. */
  edges: Array<PerformanceAgreementTrainingRequestEdge>;
  /** A list of nodes. */
  nodes: Array<PerformanceAgreementTrainingRequest>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PerformanceAgreementTrainingRequestEdge = {
  __typename?: 'PerformanceAgreementTrainingRequestEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PerformanceAgreementTrainingRequest;
};

export type PerformanceAgreementsConfiguration = {
  __typename?: 'PerformanceAgreementsConfiguration';
  enabled: Scalars['Boolean'];
  esignatureEnabled: Scalars['Boolean'];
};

export type PerformanceAnswer = {
  __typename?: 'PerformanceAnswer';
  answerChoice?: Maybe<Array<Scalars['String']>>;
  answerFloat?: Maybe<Scalars['Float']>;
  answerInt?: Maybe<Scalars['Int']>;
  answerRating?: Maybe<PerformanceRating>;
  answerText?: Maybe<Scalars['String']>;
  uuid: Scalars['String'];
};

export type PerformanceAnswerInput = {
  answerChoice?: InputMaybe<Array<Scalars['String']>>;
  answerFloat?: InputMaybe<Scalars['Float']>;
  answerInt?: InputMaybe<Scalars['Int']>;
  answerRating?: InputMaybe<PerformanceRatingInput>;
  answerText?: InputMaybe<Scalars['String']>;
  uuid: Scalars['String'];
};

/** Performance Company Employee Score Scales */
export type PerformanceCompanyEmployeeScoreScale = {
  __typename?: 'PerformanceCompanyEmployeeScoreScale';
  /** Company ID */
  id: Scalars['Int'];
  /** Default employee score scale */
  isDefault: Scalars['Boolean'];
  /**
   * Employee score scale ID
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  scaleId: Scalars['Int'];
  scoreScale: PerformanceEmployeeScoreScale;
};

/** The connection type for PerformanceCompanyEmployeeScoreScale. */
export type PerformanceCompanyEmployeeScoreScaleConnection = {
  __typename?: 'PerformanceCompanyEmployeeScoreScaleConnection';
  /** A list of edges. */
  edges: Array<PerformanceCompanyEmployeeScoreScaleEdge>;
  /** A list of nodes. */
  nodes: Array<PerformanceCompanyEmployeeScoreScale>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PerformanceCompanyEmployeeScoreScaleEdge = {
  __typename?: 'PerformanceCompanyEmployeeScoreScaleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PerformanceCompanyEmployeeScoreScale;
};

export type PerformanceCompetenciesAssessmentsConfiguration = {
  __typename?: 'PerformanceCompetenciesAssessmentsConfiguration';
  enabled: Scalars['Boolean'];
};

export type PerformanceContextlessPolicies = {
  __typename?: 'PerformanceContextlessPolicies';
  createCustomTemplate: ContextlessPolicyResolution;
  createReviewProcessContextless: ContextlessPolicyResolution;
  manageProcessTemplates: ContextlessPolicyResolution;
  reviewProcessFullVisibilityContextless: ContextlessPolicyResolution;
  seePerformanceAnalytics: ContextlessPolicyResolution;
  seePerformanceAnalyticsPage: ContextlessPolicyResolution;
  seeProcessTemplates: ContextlessPolicyResolution;
  settingsSeePerformanceReviewProcessSettings: ContextlessPolicyResolution;
  sidebarSeeAnalyticsSubLevelItem: ContextlessPolicyResolution;
  sidebarSeePerformanceReviewProcessSubLevelItem: ContextlessPolicyResolution;
  sidebarSeePerformanceTopLevelItem: ContextlessPolicyResolution;
};

export type PerformanceCyclesContextlessPolicies = {
  __typename?: 'PerformanceCyclesContextlessPolicies';
  cycleManage: ContextlessPolicyResolution;
  cycleRead: ContextlessPolicyResolution;
  sidebarSeePerformanceCyclesSubLevelItem: ContextlessPolicyResolution;
};

/** Performance Cycle Cycles */
export type PerformanceCyclesCycle = {
  __typename?: 'PerformanceCyclesCycle';
  companyId: Scalars['Int'];
  endOn: Scalars['ISO8601Date'];
  id: Scalars['String'];
  startOn: Scalars['ISO8601Date'];
  title: Scalars['String'];
};

/** The connection type for PerformanceCyclesCycle. */
export type PerformanceCyclesCycleConnection = {
  __typename?: 'PerformanceCyclesCycleConnection';
  /** A list of edges. */
  edges: Array<PerformanceCyclesCycleEdge>;
  /** A list of nodes. */
  nodes: Array<PerformanceCyclesCycle>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PerformanceCyclesCycleEdge = {
  __typename?: 'PerformanceCyclesCycleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PerformanceCyclesCycle;
};

export type PerformanceDtosReviewProcessCreateFromTemplateTemplateTypeEnum =
  | 'custom'
  | 'predefined';

export type PerformanceDtosReviewProcessTargetAgreementCompletionStatusEnum =
  | 'canbeinitiated'
  | 'hasbouncedemailagreement'
  | 'hascancelledagreement'
  | 'hasdeclinedagreement'
  | 'haserroragreement'
  | 'hasesignedagreement'
  | 'hasexpiredagreement'
  | 'haspartiallyesignedagreement'
  | 'haspendingagreement'
  | 'haspendingesignaturesagreement'
  | 'hassignedagreement'
  | 'notinitiated';

/** Performance employee_performance_insights_summaries aggregates */
export type PerformanceEmployeePerformanceInsightsSummariesAggregate = {
  __typename?: 'PerformanceEmployeePerformanceInsightsSummariesAggregate';
  average?: Maybe<PerformanceEmployeePerformanceInsightsSummariesConnectionAggregateAverage>;
  count?: Maybe<Scalars['Int']>;
  maximum?: Maybe<PerformanceEmployeePerformanceInsightsSummariesConnectionAggregateMaximum>;
  minimum?: Maybe<PerformanceEmployeePerformanceInsightsSummariesConnectionAggregateMinimum>;
  sum?: Maybe<PerformanceEmployeePerformanceInsightsSummariesConnectionAggregateSum>;
  terms?: Maybe<PerformanceEmployeePerformanceInsightsSummariesConnectionAggregateTerms>;
};

export type PerformanceEmployeePerformanceInsightsSummariesAggregateTerms = {
  __typename?: 'PerformanceEmployeePerformanceInsightsSummariesAggregateTerms';
  average?: Maybe<PerformanceEmployeePerformanceInsightsSummariesConnectionAggregateTermsAverageFields>;
  count?: Maybe<Array<Scalars['Int']>>;
  maximum?: Maybe<PerformanceEmployeePerformanceInsightsSummariesConnectionAggregateTermsMaximumFields>;
  minimum?: Maybe<PerformanceEmployeePerformanceInsightsSummariesConnectionAggregateTermsMinimumFields>;
  sum?: Maybe<PerformanceEmployeePerformanceInsightsSummariesConnectionAggregateTermsSumFields>;
  values: Array<Scalars['String']>;
};

/** average function */
export type PerformanceEmployeePerformanceInsightsSummariesConnectionAggregateAverage = {
  __typename?: 'PerformanceEmployeePerformanceInsightsSummariesConnectionAggregateAverage';
  normalizedPotentialScore?: Maybe<Scalars['Float']>;
  normalizedScore?: Maybe<Scalars['Float']>;
  workspace?: Maybe<Scalars['Float']>;
};

/** maximum function */
export type PerformanceEmployeePerformanceInsightsSummariesConnectionAggregateMaximum = {
  __typename?: 'PerformanceEmployeePerformanceInsightsSummariesConnectionAggregateMaximum';
  normalizedPotentialScore?: Maybe<Scalars['Int']>;
  normalizedScore?: Maybe<Scalars['Int']>;
  workspace?: Maybe<Scalars['Int']>;
};

/** minimum function */
export type PerformanceEmployeePerformanceInsightsSummariesConnectionAggregateMinimum = {
  __typename?: 'PerformanceEmployeePerformanceInsightsSummariesConnectionAggregateMinimum';
  normalizedPotentialScore?: Maybe<Scalars['Int']>;
  normalizedScore?: Maybe<Scalars['Int']>;
  workspace?: Maybe<Scalars['Int']>;
};

/** sum function */
export type PerformanceEmployeePerformanceInsightsSummariesConnectionAggregateSum = {
  __typename?: 'PerformanceEmployeePerformanceInsightsSummariesConnectionAggregateSum';
  normalizedPotentialScore?: Maybe<Scalars['Int']>;
  normalizedScore?: Maybe<Scalars['Int']>;
  workspace?: Maybe<Scalars['Int']>;
};

/** terms function */
export type PerformanceEmployeePerformanceInsightsSummariesConnectionAggregateTerms = {
  __typename?: 'PerformanceEmployeePerformanceInsightsSummariesConnectionAggregateTerms';
  employeeFullName?: Maybe<PerformanceEmployeePerformanceInsightsSummariesAggregateTerms>;
  gender?: Maybe<PerformanceEmployeePerformanceInsightsSummariesAggregateTerms>;
  gridStatus?: Maybe<PerformanceEmployeePerformanceInsightsSummariesAggregateTerms>;
  groupBy?: Maybe<PerformanceEmployeePerformanceInsightsSummariesAggregateTerms>;
  legalEntityId?: Maybe<PerformanceEmployeePerformanceInsightsSummariesAggregateTerms>;
  managerFullName?: Maybe<PerformanceEmployeePerformanceInsightsSummariesAggregateTerms>;
  managerId?: Maybe<PerformanceEmployeePerformanceInsightsSummariesAggregateTerms>;
  metric?: Maybe<PerformanceEmployeePerformanceInsightsSummariesAggregateTerms>;
  nationality?: Maybe<PerformanceEmployeePerformanceInsightsSummariesAggregateTerms>;
  normalizedPotentialScore?: Maybe<PerformanceEmployeePerformanceInsightsSummariesAggregateTerms>;
  normalizedScore?: Maybe<PerformanceEmployeePerformanceInsightsSummariesAggregateTerms>;
  pulseAnswer?: Maybe<PerformanceEmployeePerformanceInsightsSummariesAggregateTerms>;
  teamId?: Maybe<PerformanceEmployeePerformanceInsightsSummariesAggregateTerms>;
  workspace?: Maybe<PerformanceEmployeePerformanceInsightsSummariesAggregateTerms>;
};

/** average function */
export type PerformanceEmployeePerformanceInsightsSummariesConnectionAggregateTermsAverageFields = {
  __typename?: 'PerformanceEmployeePerformanceInsightsSummariesConnectionAggregateTermsAVERAGEFields';
  normalizedPotentialScore?: Maybe<Array<Scalars['Float']>>;
  normalizedScore?: Maybe<Array<Scalars['Float']>>;
  workspace?: Maybe<Array<Scalars['Float']>>;
};

/** maximum function */
export type PerformanceEmployeePerformanceInsightsSummariesConnectionAggregateTermsMaximumFields = {
  __typename?: 'PerformanceEmployeePerformanceInsightsSummariesConnectionAggregateTermsMAXIMUMFields';
  normalizedPotentialScore?: Maybe<Array<Scalars['Int']>>;
  normalizedScore?: Maybe<Array<Scalars['Int']>>;
  workspace?: Maybe<Array<Scalars['Int']>>;
};

/** minimum function */
export type PerformanceEmployeePerformanceInsightsSummariesConnectionAggregateTermsMinimumFields = {
  __typename?: 'PerformanceEmployeePerformanceInsightsSummariesConnectionAggregateTermsMINIMUMFields';
  normalizedPotentialScore?: Maybe<Array<Scalars['Int']>>;
  normalizedScore?: Maybe<Array<Scalars['Int']>>;
  workspace?: Maybe<Array<Scalars['Int']>>;
};

/** sum function */
export type PerformanceEmployeePerformanceInsightsSummariesConnectionAggregateTermsSumFields = {
  __typename?: 'PerformanceEmployeePerformanceInsightsSummariesConnectionAggregateTermsSUMFields';
  normalizedPotentialScore?: Maybe<Array<Scalars['Int']>>;
  normalizedScore?: Maybe<Array<Scalars['Int']>>;
  workspace?: Maybe<Array<Scalars['Int']>>;
};

/** Employee performance summary */
export type PerformanceEmployeePerformanceInsightsSummary = {
  __typename?: 'PerformanceEmployeePerformanceInsightsSummary';
  employeeFullName?: Maybe<Scalars['String']>;
  employeePulse?: Maybe<EngagementEmployeePulseMedian>;
  gender?: Maybe<Scalars['String']>;
  gridStatus?: Maybe<Scalars['String']>;
  groupBy?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  insights?: Maybe<PerformanceTargetInsight>;
  legalEntityId?: Maybe<Scalars['Int']>;
  managerFullName?: Maybe<Scalars['String']>;
  managerId?: Maybe<Scalars['Int']>;
  metric?: Maybe<Scalars['String']>;
  nationality?: Maybe<Scalars['String']>;
  normalizedPotentialScore?: Maybe<Scalars['Float']>;
  normalizedScore?: Maybe<Scalars['Float']>;
  potentialScore?: Maybe<Scalars['Int']>;
  pulseAnswer?: Maybe<Scalars['String']>;
  pulses: Array<EngagementEmployeePulse>;
  pulsesConnection: EngagementEmployeePulseConnection;
  reviewEmployeeScore?: Maybe<PerformanceReviewFinalEmployeeScore>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  reviewEmployeeScoreId?: Maybe<Scalars['Int']>;
  reviewProcess?: Maybe<PerformanceReviewProcess>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  reviewProcessId?: Maybe<Scalars['Int']>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  reviewProcessTargetId?: Maybe<Scalars['String']>;
  targetAccess: ApiCoreAccess;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  targetAccessId: Scalars['Int'];
  teamId?: Maybe<Scalars['Int']>;
  workspace?: Maybe<Scalars['Int']>;
};


/** Employee performance summary */
export type PerformanceEmployeePerformanceInsightsSummaryEmployeePulseArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  values?: InputMaybe<Array<Scalars['Int']>>;
};


/** Employee performance summary */
export type PerformanceEmployeePerformanceInsightsSummaryInsightsArgs = {
  performanceReviewProcessIds?: InputMaybe<Array<Scalars['Int']>>;
  targetAccessId?: InputMaybe<Scalars['Int']>;
};


/** Employee performance summary */
export type PerformanceEmployeePerformanceInsightsSummaryPulsesArgs = {
  dateRange?: InputMaybe<DateRangeInput>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  managedOnly?: InputMaybe<Scalars['Boolean']>;
};


/** Employee performance summary */
export type PerformanceEmployeePerformanceInsightsSummaryPulsesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  dateRange?: InputMaybe<DateRangeInput>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  managedOnly?: InputMaybe<Scalars['Boolean']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Employee performance summary */
export type PerformanceEmployeePerformanceInsightsSummaryReviewEmployeeScoreArgs = {
  agreementCompletionStatus?: InputMaybe<PerformanceDtosReviewProcessTargetAgreementCompletionStatusEnum>;
  evaluationsCompletionStatus?: InputMaybe<PerformanceReviewEvaluationStatusEnum>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  managedByFilter?: InputMaybe<ReviewFinalEmployeeScoresManagedByFilterInput>;
  materializedProcessTargetIds?: InputMaybe<Array<Scalars['Int']>>;
  reviewProcessIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  targetAccessIds?: InputMaybe<Array<Scalars['Int']>>;
  targetEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDates?: InputMaybe<Array<Scalars['String']>>;
  workplaceIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Employee performance summary */
export type PerformanceEmployeePerformanceInsightsSummaryReviewProcessArgs = {
  search?: InputMaybe<Scalars['String']>;
};


/** Employee performance summary */
export type PerformanceEmployeePerformanceInsightsSummaryTargetAccessArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for PerformanceEmployeePerformanceInsightsSummary. */
export type PerformanceEmployeePerformanceInsightsSummaryConnection = {
  __typename?: 'PerformanceEmployeePerformanceInsightsSummaryConnection';
  aggregate?: Maybe<PerformanceEmployeePerformanceInsightsSummariesAggregate>;
  /** A list of edges. */
  edges: Array<PerformanceEmployeePerformanceInsightsSummaryEdge>;
  /** A list of nodes. */
  nodes: Array<PerformanceEmployeePerformanceInsightsSummary>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PerformanceEmployeePerformanceInsightsSummaryEdge = {
  __typename?: 'PerformanceEmployeePerformanceInsightsSummaryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PerformanceEmployeePerformanceInsightsSummary;
};

/** the filter for the employee_performance_insights_summaries resource */
export type PerformanceEmployeePerformanceInsightsSummaryFilter = {
  employeeId?: InputMaybe<IntegerFilter>;
  gender?: InputMaybe<StringFilter>;
  gridStatus?: InputMaybe<StringFilter>;
  groupBy?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntegerFilter>;
  legalEntityId?: InputMaybe<IntegerFilter>;
  managerId?: InputMaybe<IntegerFilter>;
  metric?: InputMaybe<StringFilter>;
  nationality?: InputMaybe<StringFilter>;
  normalizedPotentialScore?: InputMaybe<NumberFilter>;
  normalizedScore?: InputMaybe<NumberFilter>;
  or?: InputMaybe<Array<PerformanceEmployeePerformanceInsightsSummaryFilterConditions>>;
  potentialScoreRange?: InputMaybe<StringFilter>;
  project?: InputMaybe<IntegerFilter>;
  pulseAnswer?: InputMaybe<StringFilter>;
  scoreRange?: InputMaybe<StringFilter>;
  teamId?: InputMaybe<IntegerFilter>;
  tenureDate?: InputMaybe<StringFilter>;
  workspace?: InputMaybe<IntegerFilter>;
};

export type PerformanceEmployeePerformanceInsightsSummaryFilterConditions = {
  employeeId?: InputMaybe<IntegerFilter>;
  gender?: InputMaybe<StringFilter>;
  gridStatus?: InputMaybe<StringFilter>;
  groupBy?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntegerFilter>;
  legalEntityId?: InputMaybe<IntegerFilter>;
  managerId?: InputMaybe<IntegerFilter>;
  metric?: InputMaybe<StringFilter>;
  nationality?: InputMaybe<StringFilter>;
  normalizedPotentialScore?: InputMaybe<NumberFilter>;
  normalizedScore?: InputMaybe<NumberFilter>;
  potentialScoreRange?: InputMaybe<StringFilter>;
  project?: InputMaybe<IntegerFilter>;
  pulseAnswer?: InputMaybe<StringFilter>;
  scoreRange?: InputMaybe<StringFilter>;
  teamId?: InputMaybe<IntegerFilter>;
  tenureDate?: InputMaybe<StringFilter>;
  workspace?: InputMaybe<IntegerFilter>;
};

/** Employee performance summary group */
export type PerformanceEmployeePerformanceInsightsSummaryGroup = {
  __typename?: 'PerformanceEmployeePerformanceInsightsSummaryGroup';
  bucket: Scalars['String'];
  counts: Array<Scalars['Int']>;
  groups: Array<Scalars['String']>;
};

/** The connection type for PerformanceEmployeePerformanceInsightsSummaryGroup. */
export type PerformanceEmployeePerformanceInsightsSummaryGroupConnection = {
  __typename?: 'PerformanceEmployeePerformanceInsightsSummaryGroupConnection';
  /** A list of edges. */
  edges: Array<PerformanceEmployeePerformanceInsightsSummaryGroupEdge>;
  /** A list of nodes. */
  nodes: Array<PerformanceEmployeePerformanceInsightsSummaryGroup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PerformanceEmployeePerformanceInsightsSummaryGroupEdge = {
  __typename?: 'PerformanceEmployeePerformanceInsightsSummaryGroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PerformanceEmployeePerformanceInsightsSummaryGroup;
};

/** the filter for the employee_performance_insights_summary_groups resource */
export type PerformanceEmployeePerformanceInsightsSummaryGroupFilter = {
  employeeId?: InputMaybe<IntegerFilter>;
  gender?: InputMaybe<StringFilter>;
  gridStatus?: InputMaybe<StringFilter>;
  legalEntityId?: InputMaybe<IntegerFilter>;
  managerId?: InputMaybe<IntegerFilter>;
  metric?: InputMaybe<StringFilter>;
  nationality?: InputMaybe<StringFilter>;
  normalizedPotentialScore?: InputMaybe<NumberFilter>;
  normalizedScore?: InputMaybe<NumberFilter>;
  or?: InputMaybe<Array<PerformanceEmployeePerformanceInsightsSummaryGroupFilterConditions>>;
  potentialScoreRange?: InputMaybe<StringFilter>;
  project?: InputMaybe<IntegerFilter>;
  pulseAnswer?: InputMaybe<StringFilter>;
  scoreRange?: InputMaybe<StringFilter>;
  teamId?: InputMaybe<IntegerFilter>;
  tenureDate?: InputMaybe<StringFilter>;
  workspace?: InputMaybe<IntegerFilter>;
};

export type PerformanceEmployeePerformanceInsightsSummaryGroupFilterConditions = {
  employeeId?: InputMaybe<IntegerFilter>;
  gender?: InputMaybe<StringFilter>;
  gridStatus?: InputMaybe<StringFilter>;
  legalEntityId?: InputMaybe<IntegerFilter>;
  managerId?: InputMaybe<IntegerFilter>;
  metric?: InputMaybe<StringFilter>;
  nationality?: InputMaybe<StringFilter>;
  normalizedPotentialScore?: InputMaybe<NumberFilter>;
  normalizedScore?: InputMaybe<NumberFilter>;
  potentialScoreRange?: InputMaybe<StringFilter>;
  project?: InputMaybe<IntegerFilter>;
  pulseAnswer?: InputMaybe<StringFilter>;
  scoreRange?: InputMaybe<StringFilter>;
  teamId?: InputMaybe<IntegerFilter>;
  tenureDate?: InputMaybe<StringFilter>;
  workspace?: InputMaybe<IntegerFilter>;
};

export type PerformanceEmployeePotentialScoreConfiguration = {
  __typename?: 'PerformanceEmployeePotentialScoreConfiguration';
  enabled: Scalars['Boolean'];
};

/** Performance Employee Score Scales */
export type PerformanceEmployeeScoreScale = {
  __typename?: 'PerformanceEmployeeScoreScale';
  /** Employee score scale ID */
  id: Scalars['Int'];
  isDefault: Scalars['Boolean'];
  /** Scale to be used when scoring the employee performance */
  scale: Array<PerformanceRatingScaleOption>;
};

/** The connection type for PerformanceEmployeeScoreScale. */
export type PerformanceEmployeeScoreScaleConnection = {
  __typename?: 'PerformanceEmployeeScoreScaleConnection';
  /** A list of edges. */
  edges: Array<PerformanceEmployeeScoreScaleEdge>;
  /** A list of nodes. */
  nodes: Array<PerformanceEmployeeScoreScale>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PerformanceEmployeeScoreScaleEdge = {
  __typename?: 'PerformanceEmployeeScoreScaleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PerformanceEmployeeScoreScale;
};

export type PerformanceEngagementSignalsSignalCategoryEnum =
  | 'accomplishment'
  | 'autonomy'
  | 'environment'
  | 'freedomofopinions'
  | 'goalsetting'
  | 'growth'
  | 'managementsupport'
  | 'meaningfulwork'
  | 'organizationalfit'
  | 'peerrelationships'
  | 'recognition'
  | 'reward'
  | 'strategy'
  | 'workload';

export type PerformanceEngagementSignalsSignalTypeEnum =
  | 'negative'
  | 'neutral'
  | 'neutralornegative'
  | 'neutralorpositive'
  | 'positive';

export type PerformanceEngagmentSignal = {
  __typename?: 'PerformanceEngagmentSignal';
  category: PerformanceEngagementSignalsSignalCategoryEnum;
  name: Scalars['String'];
  quotes: Array<Scalars['String']>;
  tag: Scalars['String'];
  type: PerformanceEngagementSignalsSignalTypeEnum;
};

/** Performance goal */
export type PerformanceGoalsGoal = {
  __typename?: 'PerformanceGoalsGoal';
  companyId: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  goalsParentId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  metricConfiguration?: Maybe<PerformanceGoalsMetricConfiguration>;
  name: Scalars['String'];
  ownerId?: Maybe<Scalars['Int']>;
  ownerType?: Maybe<PerformanceGoalsValueObjectsOwnerEnum>;
  period: PerformanceGoalsPeriod;
  progress: Scalars['Float'];
  status: PerformanceGoalsValueObjectsStatusEnum;
  trackingMode: PerformanceGoalsValueObjectsTrackingModeEnum;
  visibility: PerformanceGoalsValueObjectsVisibilityEnum;
};


/** Performance goal */
export type PerformanceGoalsGoalMetricConfigurationArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};

/** The connection type for PerformanceGoalsGoal. */
export type PerformanceGoalsGoalConnection = {
  __typename?: 'PerformanceGoalsGoalConnection';
  /** A list of edges. */
  edges: Array<PerformanceGoalsGoalEdge>;
  /** A list of nodes. */
  nodes: Array<PerformanceGoalsGoal>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PerformanceGoalsGoalEdge = {
  __typename?: 'PerformanceGoalsGoalEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PerformanceGoalsGoal;
};

/** Metric configuration for performance goals */
export type PerformanceGoalsMetricConfiguration = {
  __typename?: 'PerformanceGoalsMetricConfiguration';
  company: CompaniesCompany;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  companyId: Scalars['Int'];
  currency?: Maybe<Scalars['String']>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  currentMetricValueId?: Maybe<Scalars['Int']>;
  currentValue?: Maybe<PerformanceGoalsMetricValue>;
  goal: PerformanceGoalsGoal;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  goalId: Scalars['Int'];
  id: Scalars['Int'];
  metricType: PerformanceGoalsValueObjectsMetricTypeEnum;
  startValue: Scalars['Int'];
  targetValue: Scalars['Int'];
  valuesHistory: Array<PerformanceGoalsMetricValue>;
  valuesHistoryConnection: PerformanceGoalsMetricValueConnection;
};


/** Metric configuration for performance goals */
export type PerformanceGoalsMetricConfigurationCompanyArgs = {
  forBookkeepers?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};


/** Metric configuration for performance goals */
export type PerformanceGoalsMetricConfigurationCurrentValueArgs = {
  createdByEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  metricConfigurationIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Metric configuration for performance goals */
export type PerformanceGoalsMetricConfigurationValuesHistoryArgs = {
  createdByEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Metric configuration for performance goals */
export type PerformanceGoalsMetricConfigurationValuesHistoryConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  createdByEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for PerformanceGoalsMetricConfiguration. */
export type PerformanceGoalsMetricConfigurationConnection = {
  __typename?: 'PerformanceGoalsMetricConfigurationConnection';
  /** A list of edges. */
  edges: Array<PerformanceGoalsMetricConfigurationEdge>;
  /** A list of nodes. */
  nodes: Array<PerformanceGoalsMetricConfiguration>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PerformanceGoalsMetricConfigurationEdge = {
  __typename?: 'PerformanceGoalsMetricConfigurationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PerformanceGoalsMetricConfiguration;
};

/** Metric value for performance goal metric configurations */
export type PerformanceGoalsMetricValue = {
  __typename?: 'PerformanceGoalsMetricValue';
  company: CompaniesCompany;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  companyId: Scalars['Int'];
  createdBy?: Maybe<EmployeesEmployee>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  createdByEmployeeId: Scalars['Int'];
  currency?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  metricConfiguration: PerformanceGoalsMetricConfiguration;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  metricConfigurationId: Scalars['Int'];
  startValue: Scalars['Int'];
  targetValue: Scalars['Int'];
  value: Scalars['Int'];
};


/** Metric value for performance goal metric configurations */
export type PerformanceGoalsMetricValueCompanyArgs = {
  forBookkeepers?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};


/** Metric value for performance goal metric configurations */
export type PerformanceGoalsMetricValueCreatedByArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Metric value for performance goal metric configurations */
export type PerformanceGoalsMetricValueMetricConfigurationArgs = {
  goalIds?: InputMaybe<Array<Scalars['Int']>>;
};

/** The connection type for PerformanceGoalsMetricValue. */
export type PerformanceGoalsMetricValueConnection = {
  __typename?: 'PerformanceGoalsMetricValueConnection';
  /** A list of edges. */
  edges: Array<PerformanceGoalsMetricValueEdge>;
  /** A list of nodes. */
  nodes: Array<PerformanceGoalsMetricValue>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PerformanceGoalsMetricValueEdge = {
  __typename?: 'PerformanceGoalsMetricValueEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PerformanceGoalsMetricValue;
};

export type PerformanceGoalsPeriod = {
  __typename?: 'PerformanceGoalsPeriod';
  endDate: Scalars['ISO8601DateTime'];
  startDate?: Maybe<Scalars['ISO8601DateTime']>;
};

export type PerformanceGoalsValueObjectsMetricTypeEnum =
  | 'boolean'
  | 'count'
  | 'currency'
  | 'percentage';

export type PerformanceGoalsValueObjectsOwnerEnum =
  | 'employee'
  | 'team';

export type PerformanceGoalsValueObjectsStatusEnum =
  | 'completed'
  | 'delayed'
  | 'on_track';

export type PerformanceGoalsValueObjectsTrackingModeEnum =
  | 'metric'
  | 'sub_goals';

export type PerformanceGoalsValueObjectsVisibilityEnum =
  | 'private'
  | 'public';

export type PerformanceInsightsQuantityEnum =
  | 'high'
  | 'low'
  | 'normal';

/** Performance Manager Insights */
export type PerformanceManagerInsight = {
  __typename?: 'PerformanceManagerInsight';
  access: ApiCoreAccess;
  actionItems?: Maybe<Array<Scalars['String']>>;
  averageAlignmentScore?: Maybe<PerformanceInsightsQuantityEnum>;
  averagePerformanceScore?: Maybe<PerformanceInsightsQuantityEnum>;
  empty: Scalars['Boolean'];
  generalSummary?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  language?: Maybe<Scalars['String']>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  managerAccessId: Scalars['Int'];
  myself: Scalars['Boolean'];
  performanceReviewProcess: PerformanceReviewProcess;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  performanceReviewProcessId: Scalars['Int'];
};


/** Performance Manager Insights */
export type PerformanceManagerInsightAccessArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** Performance Manager Insights */
export type PerformanceManagerInsightPerformanceReviewProcessArgs = {
  search?: InputMaybe<Scalars['String']>;
};

/** The connection type for PerformanceManagerInsight. */
export type PerformanceManagerInsightConnection = {
  __typename?: 'PerformanceManagerInsightConnection';
  /** A list of edges. */
  edges: Array<PerformanceManagerInsightEdge>;
  /** A list of nodes. */
  nodes: Array<PerformanceManagerInsight>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PerformanceManagerInsightEdge = {
  __typename?: 'PerformanceManagerInsightEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PerformanceManagerInsight;
};

export type PerformanceQuestionSingleLabel = {
  __typename?: 'PerformanceQuestionSingleLabel';
  answerType: QuestionnairesQuestionnaireQuestionAnswerTypesEnum;
  choiceOptions?: Maybe<Array<Scalars['String']>>;
  description?: Maybe<Scalars['String']>;
  mandatory: Scalars['Boolean'];
  maxChoices?: Maybe<Scalars['Int']>;
  metadata?: Maybe<PerformanceQuestionSingleLabelMetadata>;
  scale?: Maybe<Array<PerformanceRatingScaleOption>>;
  title: Scalars['String'];
  uuid: Scalars['String'];
  withComment?: Maybe<Scalars['Boolean']>;
};

export type PerformanceQuestionSingleLabelInput = {
  answerType: QuestionnairesQuestionnaireQuestionAnswerTypesEnum;
  choiceOptions?: InputMaybe<Array<Scalars['String']>>;
  description?: InputMaybe<Scalars['String']>;
  mandatory: Scalars['Boolean'];
  maxChoices?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<PerformanceQuestionSingleLabelMetadataInput>;
  scale?: InputMaybe<Array<PerformanceRatingScaleOptionInput>>;
  title: Scalars['String'];
  uuid: Scalars['String'];
  withComment?: InputMaybe<Scalars['Boolean']>;
};

export type PerformanceQuestionSingleLabelMetadata = {
  __typename?: 'PerformanceQuestionSingleLabelMetadata';
  competencyId?: Maybe<Scalars['Int']>;
  competencyLevelDescription?: Maybe<Scalars['String']>;
  competencyLevelId?: Maybe<Scalars['Int']>;
  competencyLevelName?: Maybe<Scalars['String']>;
};

export type PerformanceQuestionSingleLabelMetadataInput = {
  competencyId?: InputMaybe<Scalars['Int']>;
  competencyLevelDescription?: InputMaybe<Scalars['String']>;
  competencyLevelId?: InputMaybe<Scalars['Int']>;
  competencyLevelName?: InputMaybe<Scalars['String']>;
};

export type PerformanceQuestionnaireAnsweredElement = {
  __typename?: 'PerformanceQuestionnaireAnsweredElement';
  questions: Array<PerformanceQuestionnaireQuestionAnswered>;
  sectionTitle?: Maybe<Scalars['String']>;
  type: PerformanceValueObjectsQuestionnaireAnsweredElementTypesEnum;
  uuid: Scalars['String'];
};

export type PerformanceQuestionnaireAnsweredWithSections = {
  __typename?: 'PerformanceQuestionnaireAnsweredWithSections';
  content: Array<PerformanceQuestionnaireAnsweredElement>;
};

export type PerformanceQuestionnaireByStrategy = {
  __typename?: 'PerformanceQuestionnaireByStrategy';
  content: Array<PerformanceQuestionnaireElement>;
  reviewerStrategy: PerformanceReviewerStrategiesStrategyEnum;
};

export type PerformanceQuestionnaireElement = {
  __typename?: 'PerformanceQuestionnaireElement';
  questions: Array<PerformanceQuestionSingleLabel>;
  sectionTitle?: Maybe<Scalars['String']>;
  type: PerformanceValueObjectsQuestionnaireElementTypesEnum;
  uuid: Scalars['String'];
};

export type PerformanceQuestionnaireElementInput = {
  questions: Array<PerformanceQuestionSingleLabelInput>;
  sectionTitle?: InputMaybe<Scalars['String']>;
  type: PerformanceValueObjectsQuestionnaireElementTypesEnum;
  uuid: Scalars['String'];
};

export type PerformanceQuestionnaireQuestionAnswerComment = {
  __typename?: 'PerformanceQuestionnaireQuestionAnswerComment';
  authorAccessId: Scalars['Int'];
  questionUuid: Scalars['String'];
  text: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

export type PerformanceQuestionnaireQuestionAnswered = {
  __typename?: 'PerformanceQuestionnaireQuestionAnswered';
  answer?: Maybe<PerformanceAnswer>;
  question: PerformanceQuestionSingleLabel;
};

export type PerformanceQuestionnaireable = PerformanceReviewProcess | PerformanceReviewProcessCustomTemplate;

export type PerformanceQuestionnairesByStrategy = {
  __typename?: 'PerformanceQuestionnairesByStrategy';
  competenciesPlaceholderManagerQuestionnaire?: Maybe<PerformanceQuestionnaireByStrategy>;
  competenciesPlaceholderSelfQuestionnaire?: Maybe<PerformanceQuestionnaireByStrategy>;
  defaultRatingScale: Array<PerformanceRatingScaleOption>;
  directReportQuestionnaire?: Maybe<PerformanceQuestionnaireByStrategy>;
  employeePotentialScoreManagerQuestionnaire?: Maybe<PerformanceQuestionnaireByStrategy>;
  employeeScoreManagerQuestionnaire?: Maybe<PerformanceQuestionnaireByStrategy>;
  employeeScoreSelfQuestionnaire?: Maybe<PerformanceQuestionnaireByStrategy>;
  managerQuestionnaire?: Maybe<PerformanceQuestionnaireByStrategy>;
  peersQuestionnaire?: Maybe<PerformanceQuestionnaireByStrategy>;
  selfQuestionnaire?: Maybe<PerformanceQuestionnaireByStrategy>;
};

export type PerformanceRating = {
  __typename?: 'PerformanceRating';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Int']>;
};

export type PerformanceRatingInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Int']>;
};

export type PerformanceRatingScaleOption = {
  __typename?: 'PerformanceRatingScaleOption';
  text: Scalars['String'];
  value: Scalars['Int'];
};

export type PerformanceRatingScaleOptionInput = {
  text: Scalars['String'];
  value: Scalars['Int'];
};

export type PerformanceRepublishEvaluationsConfiguration = {
  __typename?: 'PerformanceRepublishEvaluationsConfiguration';
  enabled: Scalars['Boolean'];
};

/** Performance Review Aggregations */
export type PerformanceReviewAggregation = {
  __typename?: 'PerformanceReviewAggregation';
  topics: Array<PerformanceReviewAggregationTopic>;
};

export type PerformanceReviewAggregationTopic = {
  __typename?: 'PerformanceReviewAggregationTopic';
  signals: Array<PerformanceAggregationEngagementSignal>;
  summary: Scalars['String'];
  topicName: Scalars['String'];
};

/** Performance Review Employee Grid */
export type PerformanceReviewEmployeeScoreGrid = {
  __typename?: 'PerformanceReviewEmployeeScoreGrid';
  category: Scalars['String'];
  targetAccess: Array<ApiCoreAccess>;
  targetAccessConnection: ApiCoreAccessConnection;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  targetAccessIds: Array<Scalars['Int']>;
  totalCount: Scalars['Int'];
};


/** Performance Review Employee Grid */
export type PerformanceReviewEmployeeScoreGridTargetAccessArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** Performance Review Employee Grid */
export type PerformanceReviewEmployeeScoreGridTargetAccessConnectionArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  external?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for PerformanceReviewEmployeeScoreGrid. */
export type PerformanceReviewEmployeeScoreGridConnection = {
  __typename?: 'PerformanceReviewEmployeeScoreGridConnection';
  /** A list of edges. */
  edges: Array<PerformanceReviewEmployeeScoreGridEdge>;
  /** A list of nodes. */
  nodes: Array<PerformanceReviewEmployeeScoreGrid>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PerformanceReviewEmployeeScoreGridEdge = {
  __typename?: 'PerformanceReviewEmployeeScoreGridEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PerformanceReviewEmployeeScoreGrid;
};

/** Performance Review Employee Scores Insights */
export type PerformanceReviewEmployeeScoreInsight = {
  __typename?: 'PerformanceReviewEmployeeScoreInsight';
  categories: Array<Scalars['String']>;
  series: Array<Scalars['Int']>;
};

/** The connection type for PerformanceReviewEmployeeScoreInsight. */
export type PerformanceReviewEmployeeScoreInsightConnection = {
  __typename?: 'PerformanceReviewEmployeeScoreInsightConnection';
  /** A list of edges. */
  edges: Array<PerformanceReviewEmployeeScoreInsightEdge>;
  /** A list of nodes. */
  nodes: Array<PerformanceReviewEmployeeScoreInsight>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PerformanceReviewEmployeeScoreInsightEdge = {
  __typename?: 'PerformanceReviewEmployeeScoreInsightEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PerformanceReviewEmployeeScoreInsight;
};

/** Performance Review Evaluations */
export type PerformanceReviewEvaluation = {
  __typename?: 'PerformanceReviewEvaluation';
  _policies?: Maybe<PerformanceReviewEvaluationPolicies>;
  _policiesCollection?: Maybe<Array<PermissionsPolicyResolution>>;
  _policiesConnection: PermissionsPolicyResolutionConnection;
  answeredQuestionnaires?: Maybe<PerformanceReviewEvaluationAnswer>;
  answeredQuestionnairesIdentifier?: Maybe<PerformanceReviewEvaluationAnswersIdentifier>;
  evaluationScore?: Maybe<PerformanceReviewEvaluationScore>;
  /** Evaluation type */
  evaluationType: PerformanceReviewerStrategiesStrategyEnum;
  /** Evaluation ID */
  id: Scalars['Int'];
  performanceReviewProcess?: Maybe<PerformanceReviewProcess>;
  /**
   * Review process ID
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  performanceReviewProcessId?: Maybe<Scalars['Int']>;
  /** Whether the evaluation is published */
  published: Scalars['Boolean'];
  /** Date when the evaluation was published */
  publishedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Date when the evaluation was last republished */
  republishedAt?: Maybe<Scalars['ISO8601DateTime']>;
  reviewProcessTargetId: Scalars['String'];
  reviewerAccess?: Maybe<ApiCoreAccess>;
  /**
   * Reviewer access ID
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  reviewerAccessId?: Maybe<Scalars['Int']>;
  /**
   * Reviewer employee ID
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  reviewerEmployeeId?: Maybe<Scalars['Int']>;
  reviewerEmployeeName?: Maybe<EmployeesEmployeeName>;
  /** Evaluation status */
  status: PerformanceReviewEvaluationStatusEnum;
  targetAccess?: Maybe<ApiCoreAccess>;
  /**
   * Participant access ID
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  targetAccessId?: Maybe<Scalars['Int']>;
};


/** Performance Review Evaluations */
export type PerformanceReviewEvaluation_PoliciesCollectionArgs = {
  ids: Array<PerformanceReviewEvaluationPoliciesEnum>;
};


/** Performance Review Evaluations */
export type PerformanceReviewEvaluation_PoliciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Performance Review Evaluations */
export type PerformanceReviewEvaluationAnsweredQuestionnairesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Performance Review Evaluations */
export type PerformanceReviewEvaluationAnsweredQuestionnairesIdentifierArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Performance Review Evaluations */
export type PerformanceReviewEvaluationEvaluationScoreArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  reviewProcessIds?: InputMaybe<Array<Scalars['Int']>>;
  reviewProcessTargetIds?: InputMaybe<Array<Scalars['String']>>;
  reviewerStrategies?: InputMaybe<Array<PerformanceReviewerStrategiesStrategyEnum>>;
  targetAccessIds?: InputMaybe<Array<Scalars['Int']>>;
  targetEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Performance Review Evaluations */
export type PerformanceReviewEvaluationPerformanceReviewProcessArgs = {
  search?: InputMaybe<Scalars['String']>;
};


/** Performance Review Evaluations */
export type PerformanceReviewEvaluationReviewerAccessArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** Performance Review Evaluations */
export type PerformanceReviewEvaluationReviewerEmployeeNameArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  afterEmployeeId?: InputMaybe<Scalars['Int']>;
  beforeEmployeeId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  reporteesOrLed?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyId?: InputMaybe<Scalars['Int']>;
  verb?: InputMaybe<Scalars['String']>;
  withActiveContract?: Scalars['Boolean'];
};


/** Performance Review Evaluations */
export type PerformanceReviewEvaluationTargetAccessArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};

/** Performance Review Evaluation Answers */
export type PerformanceReviewEvaluationAnswer = {
  __typename?: 'PerformanceReviewEvaluationAnswer';
  _policies?: Maybe<PerformanceReviewEvaluationAnswerPolicies>;
  _policiesCollection?: Maybe<Array<PermissionsPolicyResolution>>;
  _policiesConnection: PermissionsPolicyResolutionConnection;
  answeredCompetenciesQuestionnaire?: Maybe<PerformanceQuestionnaireAnsweredWithSections>;
  /** Questionnaire for getting the employee potential score. */
  answeredEmployeePotentialScoreQuestionnaire?: Maybe<PerformanceQuestionnaireAnsweredWithSections>;
  /** Questionnaire for getting employee score. */
  answeredEmployeeScoreQuestionnaire?: Maybe<PerformanceQuestionnaireAnsweredWithSections>;
  /** List of questions and their respective answers grouped by section. */
  answeredQuestionnaireWithSections: PerformanceQuestionnaireAnsweredWithSections;
  estimatedScore?: Maybe<PerformanceReviewEvaluationEstimatedScore>;
  evaluation?: Maybe<PerformanceReviewEvaluation>;
  /** Review evaluation ID */
  id: Scalars['Int'];
  /**
   * Review evaluation ID
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  performanceReviewEvaluationId: Scalars['Int'];
  /**
   * Review process ID
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  performanceReviewProcessId?: Maybe<Scalars['Int']>;
  reviewProcess?: Maybe<PerformanceReviewProcess>;
};


/** Performance Review Evaluation Answers */
export type PerformanceReviewEvaluationAnswer_PoliciesCollectionArgs = {
  ids: Array<PerformanceReviewEvaluationAnswerPoliciesEnum>;
};


/** Performance Review Evaluation Answers */
export type PerformanceReviewEvaluationAnswer_PoliciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Performance Review Evaluation Answers */
export type PerformanceReviewEvaluationAnswerEstimatedScoreArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Performance Review Evaluation Answers */
export type PerformanceReviewEvaluationAnswerEvaluationArgs = {
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  performanceReviewProcessIds?: InputMaybe<Array<Scalars['Int']>>;
  published?: InputMaybe<Scalars['Boolean']>;
  reviewProcessTargetIds?: InputMaybe<Array<Scalars['String']>>;
  reviewerIds?: InputMaybe<Array<Scalars['Int']>>;
  reviewerStrategies?: InputMaybe<Array<PerformanceReviewerStrategiesStrategyEnum>>;
  targetAccessIds?: InputMaybe<Array<Scalars['Int']>>;
  withTargetsManagedByFilter?: InputMaybe<ReviewEvaluationsWithTargetsManagedByFilterInput>;
};


/** Performance Review Evaluation Answers */
export type PerformanceReviewEvaluationAnswerReviewProcessArgs = {
  search?: InputMaybe<Scalars['String']>;
};

/** The connection type for PerformanceReviewEvaluationAnswer. */
export type PerformanceReviewEvaluationAnswerConnection = {
  __typename?: 'PerformanceReviewEvaluationAnswerConnection';
  /** A list of edges. */
  edges: Array<PerformanceReviewEvaluationAnswerEdge>;
  /** A list of nodes. */
  nodes: Array<PerformanceReviewEvaluationAnswer>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PerformanceReviewEvaluationAnswerEdge = {
  __typename?: 'PerformanceReviewEvaluationAnswerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PerformanceReviewEvaluationAnswer;
};

export type PerformanceReviewEvaluationAnswerPolicies = {
  __typename?: 'PerformanceReviewEvaluationAnswerPolicies';
  answer: PermissionsPolicyResolution;
  estimateScore: PermissionsPolicyResolution;
  republish: PermissionsPolicyResolution;
};

export type PerformanceReviewEvaluationAnswerPoliciesEnum =
  | 'answer'
  | 'estimate_score'
  | 'republish';

/** Performance Review Evaluation Answers Identifier */
export type PerformanceReviewEvaluationAnswersIdentifier = {
  __typename?: 'PerformanceReviewEvaluationAnswersIdentifier';
  evaluation?: Maybe<PerformanceReviewEvaluation>;
  id: Scalars['Int'];
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  performanceReviewEvaluationId: Scalars['Int'];
};


/** Performance Review Evaluation Answers Identifier */
export type PerformanceReviewEvaluationAnswersIdentifierEvaluationArgs = {
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  performanceReviewProcessIds?: InputMaybe<Array<Scalars['Int']>>;
  published?: InputMaybe<Scalars['Boolean']>;
  reviewProcessTargetIds?: InputMaybe<Array<Scalars['String']>>;
  reviewerIds?: InputMaybe<Array<Scalars['Int']>>;
  reviewerStrategies?: InputMaybe<Array<PerformanceReviewerStrategiesStrategyEnum>>;
  targetAccessIds?: InputMaybe<Array<Scalars['Int']>>;
  withTargetsManagedByFilter?: InputMaybe<ReviewEvaluationsWithTargetsManagedByFilterInput>;
};

/** The connection type for PerformanceReviewEvaluationAnswersIdentifier. */
export type PerformanceReviewEvaluationAnswersIdentifierConnection = {
  __typename?: 'PerformanceReviewEvaluationAnswersIdentifierConnection';
  /** A list of edges. */
  edges: Array<PerformanceReviewEvaluationAnswersIdentifierEdge>;
  /** A list of nodes. */
  nodes: Array<PerformanceReviewEvaluationAnswersIdentifier>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PerformanceReviewEvaluationAnswersIdentifierEdge = {
  __typename?: 'PerformanceReviewEvaluationAnswersIdentifierEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PerformanceReviewEvaluationAnswersIdentifier;
};

/** Performance Review Evaluations Categorical */
export type PerformanceReviewEvaluationCategorical = {
  __typename?: 'PerformanceReviewEvaluationCategorical';
  categories: Array<Scalars['String']>;
  series: Array<Scalars['Int']>;
};

/** The connection type for PerformanceReviewEvaluationCategorical. */
export type PerformanceReviewEvaluationCategoricalConnection = {
  __typename?: 'PerformanceReviewEvaluationCategoricalConnection';
  /** A list of edges. */
  edges: Array<PerformanceReviewEvaluationCategoricalEdge>;
  /** A list of nodes. */
  nodes: Array<PerformanceReviewEvaluationCategorical>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PerformanceReviewEvaluationCategoricalEdge = {
  __typename?: 'PerformanceReviewEvaluationCategoricalEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PerformanceReviewEvaluationCategorical;
};

/** The connection type for PerformanceReviewEvaluation. */
export type PerformanceReviewEvaluationConnection = {
  __typename?: 'PerformanceReviewEvaluationConnection';
  /** A list of edges. */
  edges: Array<PerformanceReviewEvaluationEdge>;
  /** A list of nodes. */
  nodes: Array<PerformanceReviewEvaluation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PerformanceReviewEvaluationEdge = {
  __typename?: 'PerformanceReviewEvaluationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PerformanceReviewEvaluation;
};

/** Performance Review Evaluation Estimated Scores */
export type PerformanceReviewEvaluationEstimatedScore = {
  __typename?: 'PerformanceReviewEvaluationEstimatedScore';
  evaluation?: Maybe<PerformanceReviewEvaluation>;
  /** Review evaluation estimated score ID */
  id: Scalars['Int'];
  /** Employee score in percentage (0% to 100%) */
  normalizedScore: Scalars['Float'];
  /**
   * Review evaluation ID
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  performanceReviewEvaluationId: Scalars['Int'];
  /** Maximum score in the scale */
  scaleMax: Scalars['Int'];
  /** Minimum score in the scale */
  scaleMin: Scalars['Int'];
  /** Employee score within the min and max scale */
  score: Scalars['Float'];
};


/** Performance Review Evaluation Estimated Scores */
export type PerformanceReviewEvaluationEstimatedScoreEvaluationArgs = {
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  performanceReviewProcessIds?: InputMaybe<Array<Scalars['Int']>>;
  published?: InputMaybe<Scalars['Boolean']>;
  reviewProcessTargetIds?: InputMaybe<Array<Scalars['String']>>;
  reviewerIds?: InputMaybe<Array<Scalars['Int']>>;
  reviewerStrategies?: InputMaybe<Array<PerformanceReviewerStrategiesStrategyEnum>>;
  targetAccessIds?: InputMaybe<Array<Scalars['Int']>>;
  withTargetsManagedByFilter?: InputMaybe<ReviewEvaluationsWithTargetsManagedByFilterInput>;
};

/** The connection type for PerformanceReviewEvaluationEstimatedScore. */
export type PerformanceReviewEvaluationEstimatedScoreConnection = {
  __typename?: 'PerformanceReviewEvaluationEstimatedScoreConnection';
  /** A list of edges. */
  edges: Array<PerformanceReviewEvaluationEstimatedScoreEdge>;
  /** A list of nodes. */
  nodes: Array<PerformanceReviewEvaluationEstimatedScore>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PerformanceReviewEvaluationEstimatedScoreEdge = {
  __typename?: 'PerformanceReviewEvaluationEstimatedScoreEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PerformanceReviewEvaluationEstimatedScore;
};

/** the filter for the review_evaluations resource */
export type PerformanceReviewEvaluationFilter = {
  evaluationType?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntegerFilter>;
  or?: InputMaybe<Array<PerformanceReviewEvaluationFilterConditions>>;
  performanceReviewProcessId?: InputMaybe<IntegerFilter>;
  publishedAt?: InputMaybe<DateTimeFilter>;
  republishedAt?: InputMaybe<DateTimeFilter>;
};

export type PerformanceReviewEvaluationFilterConditions = {
  evaluationType?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntegerFilter>;
  performanceReviewProcessId?: InputMaybe<IntegerFilter>;
  publishedAt?: InputMaybe<DateTimeFilter>;
  republishedAt?: InputMaybe<DateTimeFilter>;
};

export type PerformanceReviewEvaluationPolicies = {
  __typename?: 'PerformanceReviewEvaluationPolicies';
  replaceReviewer: PermissionsPolicyResolution;
};

export type PerformanceReviewEvaluationPoliciesEnum =
  | 'replace_reviewer';

/** Performance Review Evaluation Scores */
export type PerformanceReviewEvaluationScore = {
  __typename?: 'PerformanceReviewEvaluationScore';
  /** Company identifier of the review evaluation score */
  companyId: Scalars['Int'];
  /** Review evaluation score ID */
  id: Scalars['Int'];
  /** Employee evaluation potential score in percentage (0% to 100%) */
  normalizedPotentialScore?: Maybe<Scalars['Float']>;
  /** Evaluation score in percentage (0% to 100%) */
  normalizedScore: Scalars['Float'];
  /** Employee evaluation potential score within the min and max scale */
  potentialScore?: Maybe<Scalars['Int']>;
  /** Date and time when the evaluation score was published */
  publishedAt: Scalars['ISO8601DateTime'];
  /** Review evaluation ID */
  reviewEvaluationId: Scalars['Int'];
  /** Review process ID */
  reviewProcessId: Scalars['Int'];
  /** Review process target ID (composed with review_process_id and target_access_id) */
  reviewProcessTargetId: Scalars['String'];
  /** Who scored the employee */
  reviewerStrategy: PerformanceReviewerStrategiesStrategyEnum;
  /** Maximum score in the scale */
  scaleMax: Scalars['Int'];
  /** Minimum score in the scale */
  scaleMin: Scalars['Int'];
  /** Evaluation score within the min and max scale */
  score: Scalars['Float'];
  /** Employee access ID */
  targetAccessId: Scalars['Int'];
};

/** The connection type for PerformanceReviewEvaluationScore. */
export type PerformanceReviewEvaluationScoreConnection = {
  __typename?: 'PerformanceReviewEvaluationScoreConnection';
  aggregate?: Maybe<PerformanceReviewEvaluationScoresAggregate>;
  /** A list of edges. */
  edges: Array<PerformanceReviewEvaluationScoreEdge>;
  /** A list of nodes. */
  nodes: Array<PerformanceReviewEvaluationScore>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PerformanceReviewEvaluationScoreEdge = {
  __typename?: 'PerformanceReviewEvaluationScoreEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PerformanceReviewEvaluationScore;
};

/** the filter for the review_evaluation_scores resource */
export type PerformanceReviewEvaluationScoreFilter = {
  or?: InputMaybe<Array<PerformanceReviewEvaluationScoreFilterConditions>>;
  score?: InputMaybe<NumberFilter>;
};

export type PerformanceReviewEvaluationScoreFilterConditions = {
  score?: InputMaybe<NumberFilter>;
};

/** Performance review_evaluation_scores aggregates */
export type PerformanceReviewEvaluationScoresAggregate = {
  __typename?: 'PerformanceReviewEvaluationScoresAggregate';
  average?: Maybe<PerformanceReviewEvaluationScoresConnectionAggregateAverage>;
  count?: Maybe<Scalars['Int']>;
  maximum?: Maybe<PerformanceReviewEvaluationScoresConnectionAggregateMaximum>;
  minimum?: Maybe<PerformanceReviewEvaluationScoresConnectionAggregateMinimum>;
  sum?: Maybe<PerformanceReviewEvaluationScoresConnectionAggregateSum>;
  terms?: Maybe<PerformanceReviewEvaluationScoresConnectionAggregateTerms>;
};

export type PerformanceReviewEvaluationScoresAggregateTerms = {
  __typename?: 'PerformanceReviewEvaluationScoresAggregateTerms';
  average?: Maybe<PerformanceReviewEvaluationScoresConnectionAggregateTermsAverageFields>;
  count?: Maybe<Array<Scalars['Int']>>;
  maximum?: Maybe<PerformanceReviewEvaluationScoresConnectionAggregateTermsMaximumFields>;
  minimum?: Maybe<PerformanceReviewEvaluationScoresConnectionAggregateTermsMinimumFields>;
  sum?: Maybe<PerformanceReviewEvaluationScoresConnectionAggregateTermsSumFields>;
  values: Array<Scalars['String']>;
};

/** average function */
export type PerformanceReviewEvaluationScoresConnectionAggregateAverage = {
  __typename?: 'PerformanceReviewEvaluationScoresConnectionAggregateAverage';
  score?: Maybe<Scalars['Float']>;
};

/** maximum function */
export type PerformanceReviewEvaluationScoresConnectionAggregateMaximum = {
  __typename?: 'PerformanceReviewEvaluationScoresConnectionAggregateMaximum';
  score?: Maybe<Scalars['Int']>;
};

/** minimum function */
export type PerformanceReviewEvaluationScoresConnectionAggregateMinimum = {
  __typename?: 'PerformanceReviewEvaluationScoresConnectionAggregateMinimum';
  score?: Maybe<Scalars['Int']>;
};

/** sum function */
export type PerformanceReviewEvaluationScoresConnectionAggregateSum = {
  __typename?: 'PerformanceReviewEvaluationScoresConnectionAggregateSum';
  score?: Maybe<Scalars['Int']>;
};

/** terms function */
export type PerformanceReviewEvaluationScoresConnectionAggregateTerms = {
  __typename?: 'PerformanceReviewEvaluationScoresConnectionAggregateTerms';
  score?: Maybe<PerformanceReviewEvaluationScoresAggregateTerms>;
};

/** average function */
export type PerformanceReviewEvaluationScoresConnectionAggregateTermsAverageFields = {
  __typename?: 'PerformanceReviewEvaluationScoresConnectionAggregateTermsAVERAGEFields';
  score?: Maybe<Array<Scalars['Float']>>;
};

/** maximum function */
export type PerformanceReviewEvaluationScoresConnectionAggregateTermsMaximumFields = {
  __typename?: 'PerformanceReviewEvaluationScoresConnectionAggregateTermsMAXIMUMFields';
  score?: Maybe<Array<Scalars['Int']>>;
};

/** minimum function */
export type PerformanceReviewEvaluationScoresConnectionAggregateTermsMinimumFields = {
  __typename?: 'PerformanceReviewEvaluationScoresConnectionAggregateTermsMINIMUMFields';
  score?: Maybe<Array<Scalars['Int']>>;
};

/** sum function */
export type PerformanceReviewEvaluationScoresConnectionAggregateTermsSumFields = {
  __typename?: 'PerformanceReviewEvaluationScoresConnectionAggregateTermsSUMFields';
  score?: Maybe<Array<Scalars['Int']>>;
};

export type PerformanceReviewEvaluationStatusEnum =
  | 'pending'
  | 'published';

/** Performance Review Final Employee Scores */
export type PerformanceReviewFinalEmployeeScore = {
  __typename?: 'PerformanceReviewFinalEmployeeScore';
  /** Calculated at */
  calculatedAt: Scalars['ISO8601DateTime'];
  /** Company ID */
  companyId: Scalars['Int'];
  /** Review final employee score ID */
  id: Scalars['Int'];
  /** Materialized process target ID */
  materializedProcessTargetId: Scalars['Int'];
  /** Normalized score */
  normalizedScore: Scalars['Float'];
  /** Performance review process ID */
  performanceReviewProcessId: Scalars['Int'];
  scaleMax: Scalars['Int'];
  scaleMin: Scalars['Int'];
  /** Score */
  score: Scalars['Float'];
  /** Target access ID */
  targetAccessId: Scalars['Int'];
  /** Target employee ID */
  targetEmployeeId?: Maybe<Scalars['Int']>;
};

/** The connection type for PerformanceReviewFinalEmployeeScore. */
export type PerformanceReviewFinalEmployeeScoreConnection = {
  __typename?: 'PerformanceReviewFinalEmployeeScoreConnection';
  aggregate?: Maybe<PerformanceReviewFinalEmployeeScoresAggregate>;
  /** A list of edges. */
  edges: Array<PerformanceReviewFinalEmployeeScoreEdge>;
  /** A list of nodes. */
  nodes: Array<PerformanceReviewFinalEmployeeScore>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PerformanceReviewFinalEmployeeScoreEdge = {
  __typename?: 'PerformanceReviewFinalEmployeeScoreEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PerformanceReviewFinalEmployeeScore;
};

/** the filter for the review_final_employee_scores resource */
export type PerformanceReviewFinalEmployeeScoreFilter = {
  or?: InputMaybe<Array<PerformanceReviewFinalEmployeeScoreFilterConditions>>;
  score?: InputMaybe<NumberFilter>;
};

export type PerformanceReviewFinalEmployeeScoreFilterConditions = {
  score?: InputMaybe<NumberFilter>;
};

/** Performance review_final_employee_scores aggregates */
export type PerformanceReviewFinalEmployeeScoresAggregate = {
  __typename?: 'PerformanceReviewFinalEmployeeScoresAggregate';
  average?: Maybe<PerformanceReviewFinalEmployeeScoresConnectionAggregateAverage>;
  count?: Maybe<Scalars['Int']>;
  maximum?: Maybe<PerformanceReviewFinalEmployeeScoresConnectionAggregateMaximum>;
  minimum?: Maybe<PerformanceReviewFinalEmployeeScoresConnectionAggregateMinimum>;
  sum?: Maybe<PerformanceReviewFinalEmployeeScoresConnectionAggregateSum>;
  terms?: Maybe<PerformanceReviewFinalEmployeeScoresConnectionAggregateTerms>;
};

export type PerformanceReviewFinalEmployeeScoresAggregateTerms = {
  __typename?: 'PerformanceReviewFinalEmployeeScoresAggregateTerms';
  average?: Maybe<PerformanceReviewFinalEmployeeScoresConnectionAggregateTermsAverageFields>;
  count?: Maybe<Array<Scalars['Int']>>;
  maximum?: Maybe<PerformanceReviewFinalEmployeeScoresConnectionAggregateTermsMaximumFields>;
  minimum?: Maybe<PerformanceReviewFinalEmployeeScoresConnectionAggregateTermsMinimumFields>;
  sum?: Maybe<PerformanceReviewFinalEmployeeScoresConnectionAggregateTermsSumFields>;
  values: Array<Scalars['String']>;
};

/** average function */
export type PerformanceReviewFinalEmployeeScoresConnectionAggregateAverage = {
  __typename?: 'PerformanceReviewFinalEmployeeScoresConnectionAggregateAverage';
  score?: Maybe<Scalars['Float']>;
};

/** maximum function */
export type PerformanceReviewFinalEmployeeScoresConnectionAggregateMaximum = {
  __typename?: 'PerformanceReviewFinalEmployeeScoresConnectionAggregateMaximum';
  score?: Maybe<Scalars['Int']>;
};

/** minimum function */
export type PerformanceReviewFinalEmployeeScoresConnectionAggregateMinimum = {
  __typename?: 'PerformanceReviewFinalEmployeeScoresConnectionAggregateMinimum';
  score?: Maybe<Scalars['Int']>;
};

/** sum function */
export type PerformanceReviewFinalEmployeeScoresConnectionAggregateSum = {
  __typename?: 'PerformanceReviewFinalEmployeeScoresConnectionAggregateSum';
  score?: Maybe<Scalars['Int']>;
};

/** terms function */
export type PerformanceReviewFinalEmployeeScoresConnectionAggregateTerms = {
  __typename?: 'PerformanceReviewFinalEmployeeScoresConnectionAggregateTerms';
  score?: Maybe<PerformanceReviewFinalEmployeeScoresAggregateTerms>;
};

/** average function */
export type PerformanceReviewFinalEmployeeScoresConnectionAggregateTermsAverageFields = {
  __typename?: 'PerformanceReviewFinalEmployeeScoresConnectionAggregateTermsAVERAGEFields';
  score?: Maybe<Array<Scalars['Float']>>;
};

/** maximum function */
export type PerformanceReviewFinalEmployeeScoresConnectionAggregateTermsMaximumFields = {
  __typename?: 'PerformanceReviewFinalEmployeeScoresConnectionAggregateTermsMAXIMUMFields';
  score?: Maybe<Array<Scalars['Int']>>;
};

/** minimum function */
export type PerformanceReviewFinalEmployeeScoresConnectionAggregateTermsMinimumFields = {
  __typename?: 'PerformanceReviewFinalEmployeeScoresConnectionAggregateTermsMINIMUMFields';
  score?: Maybe<Array<Scalars['Int']>>;
};

/** sum function */
export type PerformanceReviewFinalEmployeeScoresConnectionAggregateTermsSumFields = {
  __typename?: 'PerformanceReviewFinalEmployeeScoresConnectionAggregateTermsSUMFields';
  score?: Maybe<Array<Scalars['Int']>>;
};

/** Performance Review Owner */
export type PerformanceReviewOwner = {
  __typename?: 'PerformanceReviewOwner';
  access?: Maybe<ApiCoreAccess>;
  /**
   * Review owner access ID
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  accessId: Scalars['Int'];
  /** Review owner ID */
  id: Scalars['Int'];
  performanceReviewProcess?: Maybe<PerformanceReviewProcess>;
  /**
   * Review process ID
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  performanceReviewProcessId: Scalars['Int'];
};


/** Performance Review Owner */
export type PerformanceReviewOwnerAccessArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** Performance Review Owner */
export type PerformanceReviewOwnerPerformanceReviewProcessArgs = {
  search?: InputMaybe<Scalars['String']>;
};

/** The connection type for PerformanceReviewOwner. */
export type PerformanceReviewOwnerConnection = {
  __typename?: 'PerformanceReviewOwnerConnection';
  /** A list of edges. */
  edges: Array<PerformanceReviewOwnerEdge>;
  /** A list of nodes. */
  nodes: Array<PerformanceReviewOwner>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PerformanceReviewOwnerEdge = {
  __typename?: 'PerformanceReviewOwnerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PerformanceReviewOwner;
};

/** Performance Review Process */
export type PerformanceReviewProcess = {
  __typename?: 'PerformanceReviewProcess';
  _policies?: Maybe<PerformanceReviewProcessPolicies>;
  _policiesCollection?: Maybe<Array<PermissionsPolicyResolution>>;
  _policiesConnection: PermissionsPolicyResolutionConnection;
  agreements: Array<PerformanceAgreement>;
  /** Action plans help track goal progress, and facilitate performance review discussions. */
  agreementsConfiguration: PerformanceAgreementsConfiguration;
  agreementsConnection: PerformanceAgreementConnection;
  analyticsSummary?: Maybe<PerformanceReviewProcessAnalytic>;
  /** Whether the review process is archived or not */
  archived: Scalars['Boolean'];
  company: ApiCoreCompany;
  /**
   * Company ID
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  companyId: Scalars['Int'];
  /**
   * Assess employees based on their assigned competencies through both manager and
   * self-reviews. Ensure roles with designated competencies are properly set up.
   */
  competenciesAssessmentsConfiguration: PerformanceCompetenciesAssessmentsConfiguration;
  createdAt: Scalars['ISO8601DateTime'];
  /**
   * Performance cycle ID
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  cycleId?: Maybe<Scalars['String']>;
  /** A brief description of the review process */
  description?: Maybe<Scalars['String']>;
  /**
   * Include one question at the end of the review to rate participants' potential.
   * This rating will be reflected in the 9 box grid.
   */
  employeePotentialScoreConfiguration: PerformanceEmployeePotentialScoreConfiguration;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  employeeScoreScaleId: Scalars['Int'];
  /** Date when the review process should end */
  endsAt?: Maybe<Scalars['ISO8601DateTime']>;
  estimateTargets: Array<PerformanceReviewProcessEstimatedTarget>;
  estimateTargetsConnection: PerformanceReviewProcessEstimatedTargetConnection;
  evaluations: Array<PerformanceReviewEvaluation>;
  evaluationsConnection: PerformanceReviewEvaluationConnection;
  /** URL that directs to the frontend page of the review process */
  frontendUrl: Scalars['String'];
  /** Review process ID */
  id: Scalars['Int'];
  /** Date when the last bulk reminder was sent */
  lastBulkReminder?: Maybe<Scalars['ISO8601DateTime']>;
  materializeTargets: Array<PerformanceReviewProcessTarget>;
  materializeTargetsConnection: PerformanceReviewProcessTargetConnection;
  migratedFromV1: Scalars['Boolean'];
  /** Review process name */
  name?: Maybe<Scalars['String']>;
  owners: Array<PerformanceReviewOwner>;
  ownersConnection: PerformanceReviewOwnerConnection;
  participation?: Maybe<PerformanceReviewProcessParticipationRate>;
  performanceCycle?: Maybe<PerformanceCyclesCycle>;
  publishedEvaluations: Array<PerformanceReviewEvaluation>;
  publishedEvaluationsConnection: PerformanceReviewEvaluationConnection;
  questionnaireByReviewerStrategies?: Maybe<PerformanceReviewQuestionnaireByStrategy>;
  /** Allows to republish the review process evaluations while the review process is active */
  republishEvaluationsConfiguration: PerformanceRepublishEvaluationsConfiguration;
  /** Review types that will be assigned to the review process. It'll be used to create the evaluations when the process starts */
  reviewerStrategies?: Maybe<Array<PerformanceReviewerStrategiesStrategyEnum>>;
  scoreConfiguration?: Maybe<PerformanceScoreConfiguration>;
  scoreScale: PerformanceEmployeeScoreScale;
  /** Missing or invalid information to be able to start the review process */
  startValidationErrors: Array<PerformanceStartReviewProcessValidatorFailedCheckEnum>;
  /** Date when the review process should start */
  startsAt?: Maybe<Scalars['ISO8601DateTime']>;
  statSummary?: Maybe<PerformanceReviewProcessStat>;
  /** Review process status */
  status: PerformanceReviewProcessStatusEnum;
  targetManager: Array<PerformanceTargetManager>;
  targetManagerConnection: PerformanceTargetManagerConnection;
  /** Condition that defines the employees that will be evaluated (participants). Calculated when the review process starts */
  targetStrategy?: Maybe<PerformanceTargetStrategy>;
  visibilitySetting?: Maybe<PerformanceReviewVisibilitySetting>;
};


/** Performance Review Process */
export type PerformanceReviewProcess_PoliciesCollectionArgs = {
  ids: Array<PerformanceReviewProcessPoliciesEnum>;
};


/** Performance Review Process */
export type PerformanceReviewProcess_PoliciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Performance Review Process */
export type PerformanceReviewProcessAgreementsArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
  materializedProcessTargetIds?: InputMaybe<Array<Scalars['Int']>>;
  targetIds?: InputMaybe<Array<Scalars['String']>>;
};


/** Performance Review Process */
export type PerformanceReviewProcessAgreementsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  materializedProcessTargetIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  targetIds?: InputMaybe<Array<Scalars['String']>>;
};


/** Performance Review Process */
export type PerformanceReviewProcessAnalyticsSummaryArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  withTargetsManagedByFilter?: InputMaybe<ReviewProcessAnalyticsWithTargetsManagedByFilterInput>;
};


/** Performance Review Process */
export type PerformanceReviewProcessEstimateTargetsArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


/** Performance Review Process */
export type PerformanceReviewProcessEstimateTargetsConnectionArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Performance Review Process */
export type PerformanceReviewProcessEvaluationsArgs = {
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  published?: InputMaybe<Scalars['Boolean']>;
  reviewProcessTargetIds?: InputMaybe<Array<Scalars['String']>>;
  reviewerIds?: InputMaybe<Array<Scalars['Int']>>;
  reviewerStrategies?: InputMaybe<Array<PerformanceReviewerStrategiesStrategyEnum>>;
  targetAccessIds?: InputMaybe<Array<Scalars['Int']>>;
  withTargetsManagedByFilter?: InputMaybe<ReviewEvaluationsWithTargetsManagedByFilterInput>;
};


/** Performance Review Process */
export type PerformanceReviewProcessEvaluationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reviewProcessTargetIds?: InputMaybe<Array<Scalars['String']>>;
  reviewerIds?: InputMaybe<Array<Scalars['Int']>>;
  reviewerStrategies?: InputMaybe<Array<PerformanceReviewerStrategiesStrategyEnum>>;
  sortOrder?: InputMaybe<Sort>;
  targetAccessIds?: InputMaybe<Array<Scalars['Int']>>;
  withTargetsManagedByFilter?: InputMaybe<ReviewEvaluationsWithTargetsManagedByFilterInput>;
};


/** Performance Review Process */
export type PerformanceReviewProcessMaterializeTargetsArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  agreementCompletionStatus?: InputMaybe<PerformanceDtosReviewProcessTargetAgreementCompletionStatusEnum>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  evaluationsCompletionStatus?: InputMaybe<PerformanceReviewEvaluationStatusEnum>;
  finalScores?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  includeArchivedReviews?: InputMaybe<Scalars['Boolean']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  managedByFilter?: InputMaybe<ReviewProcessTargetsManagedByFilterInput>;
  onlyForPeerAssignment?: InputMaybe<Scalars['Boolean']>;
  pendingPeerEvaluations?: InputMaybe<Scalars['Boolean']>;
  performanceReviewProcessStatus?: InputMaybe<Array<PerformanceReviewProcessStatusEnum>>;
  search?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDates?: InputMaybe<Array<Scalars['String']>>;
  toConductAgreement?: InputMaybe<Scalars['Boolean']>;
  withoutManager?: InputMaybe<Scalars['Boolean']>;
  workplaceIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Performance Review Process */
export type PerformanceReviewProcessMaterializeTargetsConnectionArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  after?: InputMaybe<Scalars['String']>;
  agreementCompletionStatus?: InputMaybe<PerformanceDtosReviewProcessTargetAgreementCompletionStatusEnum>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  evaluationsCompletionStatus?: InputMaybe<PerformanceReviewEvaluationStatusEnum>;
  finalScores?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  includeArchivedReviews?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  managedByFilter?: InputMaybe<ReviewProcessTargetsManagedByFilterInput>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyForPeerAssignment?: InputMaybe<Scalars['Boolean']>;
  pendingPeerEvaluations?: InputMaybe<Scalars['Boolean']>;
  performanceReviewProcessStatus?: InputMaybe<Array<PerformanceReviewProcessStatusEnum>>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDates?: InputMaybe<Array<Scalars['String']>>;
  toConductAgreement?: InputMaybe<Scalars['Boolean']>;
  withoutManager?: InputMaybe<Scalars['Boolean']>;
  workplaceIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Performance Review Process */
export type PerformanceReviewProcessOwnersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Performance Review Process */
export type PerformanceReviewProcessParticipationArgs = {
  agreementCompletionStatus?: InputMaybe<PerformanceDtosReviewProcessTargetAgreementCompletionStatusEnum>;
  finalScores?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  managedByFilter?: InputMaybe<ReviewProcessParticipationRatesManagedByFilterInput>;
  reviewerIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  targetEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDates?: InputMaybe<Array<Scalars['String']>>;
  workplaceIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Performance Review Process */
export type PerformanceReviewProcessPublishedEvaluationsArgs = {
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  reviewProcessTargetIds?: InputMaybe<Array<Scalars['String']>>;
  reviewerIds?: InputMaybe<Array<Scalars['Int']>>;
  reviewerStrategies?: InputMaybe<Array<PerformanceReviewerStrategiesStrategyEnum>>;
  targetAccessIds?: InputMaybe<Array<Scalars['Int']>>;
  withTargetsManagedByFilter?: InputMaybe<ReviewEvaluationsWithTargetsManagedByFilterInput>;
};


/** Performance Review Process */
export type PerformanceReviewProcessPublishedEvaluationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  reviewProcessTargetIds?: InputMaybe<Array<Scalars['String']>>;
  reviewerIds?: InputMaybe<Array<Scalars['Int']>>;
  reviewerStrategies?: InputMaybe<Array<PerformanceReviewerStrategiesStrategyEnum>>;
  sortOrder?: InputMaybe<Sort>;
  targetAccessIds?: InputMaybe<Array<Scalars['Int']>>;
  withTargetsManagedByFilter?: InputMaybe<ReviewEvaluationsWithTargetsManagedByFilterInput>;
};


/** Performance Review Process */
export type PerformanceReviewProcessScoreConfigurationArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Performance Review Process */
export type PerformanceReviewProcessStatSummaryArgs = {
  evaluationTypes?: InputMaybe<Array<PerformanceReviewerStrategiesStrategyEnum>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  onlyManagedEmployeesAsTarget?: InputMaybe<Scalars['Boolean']>;
};


/** Performance Review Process */
export type PerformanceReviewProcessTargetManagerArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Performance Review Process */
export type PerformanceReviewProcessTargetManagerConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** Performance Process Ananlytic */
export type PerformanceReviewProcessAnalytic = {
  __typename?: 'PerformanceReviewProcessAnalytic';
  defaultRatingScaleMax: Scalars['Int'];
  defaultRatingScaleMin: Scalars['Int'];
  id: Scalars['Int'];
  managerGivenPerformanceScores: Array<Scalars['Float']>;
  performanceReviewProcess: PerformanceReviewProcess;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  performanceReviewProcessId: Scalars['Int'];
};


/** Performance Process Ananlytic */
export type PerformanceReviewProcessAnalyticPerformanceReviewProcessArgs = {
  search?: InputMaybe<Scalars['String']>;
};

/** The connection type for PerformanceReviewProcessAnalytic. */
export type PerformanceReviewProcessAnalyticConnection = {
  __typename?: 'PerformanceReviewProcessAnalyticConnection';
  /** A list of edges. */
  edges: Array<PerformanceReviewProcessAnalyticEdge>;
  /** A list of nodes. */
  nodes: Array<PerformanceReviewProcessAnalytic>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PerformanceReviewProcessAnalyticEdge = {
  __typename?: 'PerformanceReviewProcessAnalyticEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PerformanceReviewProcessAnalytic;
};

/** The connection type for PerformanceReviewProcess. */
export type PerformanceReviewProcessConnection = {
  __typename?: 'PerformanceReviewProcessConnection';
  /** A list of edges. */
  edges: Array<PerformanceReviewProcessEdge>;
  /** A list of nodes. */
  nodes: Array<PerformanceReviewProcess>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** Performance Review Process User Created Templates */
export type PerformanceReviewProcessCustomTemplate = {
  __typename?: 'PerformanceReviewProcessCustomTemplate';
  _policies?: Maybe<PerformanceReviewProcessCustomTemplatePolicies>;
  _policiesCollection?: Maybe<Array<PermissionsPolicyResolution>>;
  _policiesConnection: PermissionsPolicyResolutionConnection;
  /** Action plans help track goal progress, and facilitate performance review discussions. */
  agreementsEnabled?: Maybe<Scalars['Boolean']>;
  /** Require electronic signature for action plans. */
  agreementsEsignatureEnabled?: Maybe<Scalars['Boolean']>;
  author?: Maybe<ApiCoreAccess>;
  /**
   * Author of the custom template.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  authorId?: Maybe<Scalars['Int']>;
  company?: Maybe<ApiCoreCompany>;
  /**
   * Company ID
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  companyId: Scalars['Int'];
  /**
   * Assess employees based on their assigned competencies through both manager and
   * self-reviews. Ensure roles with designated competencies are properly set up.
   */
  competenciesAssessmentsEnabled?: Maybe<Scalars['Boolean']>;
  /** Creation date of the template */
  createdAt: Scalars['ISO8601DateTime'];
  /** A brief description of the review process */
  description?: Maybe<Scalars['String']>;
  /**
   * Include one question at the end of the review to rate participants' potential.
   * This rating will be reflected in the 9 box grid.
   */
  employeePotentialScoreEnabled?: Maybe<Scalars['Boolean']>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  employeeScoreScaleId: Scalars['Int'];
  estimateTargets: Array<PerformanceReviewProcessCustomTemplatesEstimatedTarget>;
  estimateTargetsConnection: PerformanceReviewProcessCustomTemplatesEstimatedTargetConnection;
  /** Review process template ID */
  id: Scalars['Int'];
  /** Review process name */
  name: Scalars['String'];
  questionnaireByReviewerStrategies?: Maybe<PerformanceReviewProcessCustomTemplateQuestionnaireByStrategy>;
  /** Allows to republish the review process evaluations while the review process is active */
  republishEvaluationsEnabled?: Maybe<Scalars['Boolean']>;
  /** Review types that will be assigned to the review process. It'll be used to create the evaluations when the process starts */
  reviewerStrategies?: Maybe<Array<PerformanceReviewerStrategiesStrategyEnum>>;
  scoreConfiguration?: Maybe<PerformanceScoreConfiguration>;
  scoreScale: PerformanceEmployeeScoreScale;
  /** Condition that defines the employees that will be evaluated (participants). Calculated when the review process starts */
  targetStrategy?: Maybe<PerformanceTargetStrategy>;
  /** A brief description of the review process template */
  templateDescription?: Maybe<Scalars['String']>;
  /** Visibility settings for the custom template */
  visibilitySettings?: Maybe<PerformanceVisibilitySettings>;
};


/** Performance Review Process User Created Templates */
export type PerformanceReviewProcessCustomTemplate_PoliciesCollectionArgs = {
  ids: Array<PerformanceReviewProcessCustomTemplatePoliciesEnum>;
};


/** Performance Review Process User Created Templates */
export type PerformanceReviewProcessCustomTemplate_PoliciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Performance Review Process User Created Templates */
export type PerformanceReviewProcessCustomTemplateAuthorArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** Performance Review Process User Created Templates */
export type PerformanceReviewProcessCustomTemplateEstimateTargetsArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
};


/** Performance Review Process User Created Templates */
export type PerformanceReviewProcessCustomTemplateEstimateTargetsConnectionArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Performance Review Process User Created Templates */
export type PerformanceReviewProcessCustomTemplateScoreConfigurationArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};

/** The connection type for PerformanceReviewProcessCustomTemplate. */
export type PerformanceReviewProcessCustomTemplateConnection = {
  __typename?: 'PerformanceReviewProcessCustomTemplateConnection';
  /** A list of edges. */
  edges: Array<PerformanceReviewProcessCustomTemplateEdge>;
  /** A list of nodes. */
  nodes: Array<PerformanceReviewProcessCustomTemplate>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PerformanceReviewProcessCustomTemplateEdge = {
  __typename?: 'PerformanceReviewProcessCustomTemplateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PerformanceReviewProcessCustomTemplate;
};

/** the filter for the review_process_custom_templates resource */
export type PerformanceReviewProcessCustomTemplateFilter = {
  authorId?: InputMaybe<IntegerFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntegerFilter>;
  name?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<PerformanceReviewProcessCustomTemplateFilterConditions>>;
  reviewerStrategies?: InputMaybe<StringFilter>;
};

export type PerformanceReviewProcessCustomTemplateFilterConditions = {
  authorId?: InputMaybe<IntegerFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntegerFilter>;
  name?: InputMaybe<StringFilter>;
  reviewerStrategies?: InputMaybe<StringFilter>;
};

export type PerformanceReviewProcessCustomTemplatePolicies = {
  __typename?: 'PerformanceReviewProcessCustomTemplatePolicies';
  generateReviewQuestionsUsingAi: PermissionsPolicyResolution;
  manage: PermissionsPolicyResolution;
};

export type PerformanceReviewProcessCustomTemplatePoliciesEnum =
  | 'generate_review_questions_using_ai'
  | 'manage';

/** Performance custom templates questionnaire by reviewer strategies */
export type PerformanceReviewProcessCustomTemplateQuestionnaireByStrategy = {
  __typename?: 'PerformanceReviewProcessCustomTemplateQuestionnaireByStrategy';
  /** Placeholder used for the presentation of the competency assessments */
  competenciesPlaceholderManagerQuestionnaire?: Maybe<PerformanceQuestionnaireByStrategy>;
  /** Placeholder used for the presentation of the competency assessments */
  competenciesPlaceholderSelfQuestionnaire?: Maybe<PerformanceQuestionnaireByStrategy>;
  /** Scoring range used in rating questions */
  defaultRatingScale: Array<PerformanceRatingScaleOption>;
  /** Questionnaire for direct report evaluation */
  directReportQuestionnaire?: Maybe<PerformanceQuestionnaireByStrategy>;
  /** Questionnaire included in the end of the manager evaluation to evaluate the employee potential */
  employeePotentialScoreManagerQuestionnaire?: Maybe<PerformanceQuestionnaireByStrategy>;
  /** Questionnaire included in the end of manager evaluation to evaluate the employee performance */
  employeeScoreManagerQuestionnaire?: Maybe<PerformanceQuestionnaireByStrategy>;
  /** Questionnaire included in the end of self evaluation to evaluate the employee performance */
  employeeScoreSelfQuestionnaire?: Maybe<PerformanceQuestionnaireByStrategy>;
  /** Review process custom template ID */
  id: Scalars['Int'];
  /** Questionnaire for manager evaluation */
  managerQuestionnaire?: Maybe<PerformanceQuestionnaireByStrategy>;
  /** Questionnaire for peers evaluation */
  peersQuestionnaire?: Maybe<PerformanceQuestionnaireByStrategy>;
  /**
   * Review process custom template ID
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  performanceCustomTemplateId: Scalars['Int'];
  performanceReviewProcessCustomTemplate?: Maybe<PerformanceReviewProcessCustomTemplate>;
  /**
   * Rating scale ID that is used in competency assessments and employee score rating questions
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  ratingScaleId?: Maybe<Scalars['Int']>;
  scoreScale?: Maybe<PerformanceEmployeeScoreScale>;
  /** Questionnaire for self evaluation */
  selfQuestionnaire?: Maybe<PerformanceQuestionnaireByStrategy>;
};


/** Performance custom templates questionnaire by reviewer strategies */
export type PerformanceReviewProcessCustomTemplateQuestionnaireByStrategyPerformanceReviewProcessCustomTemplateArgs = {
  authorIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};

/** The connection type for PerformanceReviewProcessCustomTemplateQuestionnaireByStrategy. */
export type PerformanceReviewProcessCustomTemplateQuestionnaireByStrategyConnection = {
  __typename?: 'PerformanceReviewProcessCustomTemplateQuestionnaireByStrategyConnection';
  /** A list of edges. */
  edges: Array<PerformanceReviewProcessCustomTemplateQuestionnaireByStrategyEdge>;
  /** A list of nodes. */
  nodes: Array<PerformanceReviewProcessCustomTemplateQuestionnaireByStrategy>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PerformanceReviewProcessCustomTemplateQuestionnaireByStrategyEdge = {
  __typename?: 'PerformanceReviewProcessCustomTemplateQuestionnaireByStrategyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PerformanceReviewProcessCustomTemplateQuestionnaireByStrategy;
};

/** Performance custom template target from resolving target strategy */
export type PerformanceReviewProcessCustomTemplatesEstimatedTarget = {
  __typename?: 'PerformanceReviewProcessCustomTemplatesEstimatedTarget';
  access?: Maybe<ApiCoreAccess>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  accessId: Scalars['Int'];
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  employeeId: Scalars['Int'];
  employeeName?: Maybe<EmployeesEmployeeName>;
  id: Scalars['String'];
  performanceCustomTemplateId: Scalars['Int'];
};


/** Performance custom template target from resolving target strategy */
export type PerformanceReviewProcessCustomTemplatesEstimatedTargetAccessArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** Performance custom template target from resolving target strategy */
export type PerformanceReviewProcessCustomTemplatesEstimatedTargetEmployeeNameArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  afterEmployeeId?: InputMaybe<Scalars['Int']>;
  beforeEmployeeId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  reporteesOrLed?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyId?: InputMaybe<Scalars['Int']>;
  verb?: InputMaybe<Scalars['String']>;
  withActiveContract?: Scalars['Boolean'];
};

/** The connection type for PerformanceReviewProcessCustomTemplatesEstimatedTarget. */
export type PerformanceReviewProcessCustomTemplatesEstimatedTargetConnection = {
  __typename?: 'PerformanceReviewProcessCustomTemplatesEstimatedTargetConnection';
  /** A list of edges. */
  edges: Array<PerformanceReviewProcessCustomTemplatesEstimatedTargetEdge>;
  /** A list of nodes. */
  nodes: Array<PerformanceReviewProcessCustomTemplatesEstimatedTarget>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PerformanceReviewProcessCustomTemplatesEstimatedTargetEdge = {
  __typename?: 'PerformanceReviewProcessCustomTemplatesEstimatedTargetEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PerformanceReviewProcessCustomTemplatesEstimatedTarget;
};

/** the filter for the review_process_custom_templates_estimated_targets resource */
export type PerformanceReviewProcessCustomTemplatesEstimatedTargetFilter = {
  id?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<PerformanceReviewProcessCustomTemplatesEstimatedTargetFilterConditions>>;
};

export type PerformanceReviewProcessCustomTemplatesEstimatedTargetFilterConditions = {
  id?: InputMaybe<StringFilter>;
};

/** An edge in a connection. */
export type PerformanceReviewProcessEdge = {
  __typename?: 'PerformanceReviewProcessEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PerformanceReviewProcess;
};

/** Performance Review Target from resolving target strategy */
export type PerformanceReviewProcessEstimatedTarget = {
  __typename?: 'PerformanceReviewProcessEstimatedTarget';
  access?: Maybe<ApiCoreAccess>;
  /**
   * Access ID
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  accessId: Scalars['Int'];
  /**
   * Employee ID
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  employeeId: Scalars['Int'];
  employeeName?: Maybe<EmployeesEmployeeName>;
  /** Process target ID */
  id: Scalars['String'];
  /** Review process ID */
  performanceReviewProcessId: Scalars['Int'];
};


/** Performance Review Target from resolving target strategy */
export type PerformanceReviewProcessEstimatedTargetAccessArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** Performance Review Target from resolving target strategy */
export type PerformanceReviewProcessEstimatedTargetEmployeeNameArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  afterEmployeeId?: InputMaybe<Scalars['Int']>;
  beforeEmployeeId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  reporteesOrLed?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyId?: InputMaybe<Scalars['Int']>;
  verb?: InputMaybe<Scalars['String']>;
  withActiveContract?: Scalars['Boolean'];
};

/** The connection type for PerformanceReviewProcessEstimatedTarget. */
export type PerformanceReviewProcessEstimatedTargetConnection = {
  __typename?: 'PerformanceReviewProcessEstimatedTargetConnection';
  /** A list of edges. */
  edges: Array<PerformanceReviewProcessEstimatedTargetEdge>;
  /** A list of nodes. */
  nodes: Array<PerformanceReviewProcessEstimatedTarget>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PerformanceReviewProcessEstimatedTargetEdge = {
  __typename?: 'PerformanceReviewProcessEstimatedTargetEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PerformanceReviewProcessEstimatedTarget;
};

/** the filter for the review_process_estimated_targets resource */
export type PerformanceReviewProcessEstimatedTargetFilter = {
  id?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<PerformanceReviewProcessEstimatedTargetFilterConditions>>;
};

export type PerformanceReviewProcessEstimatedTargetFilterConditions = {
  id?: InputMaybe<StringFilter>;
};

/** the filter for the review_processes resource */
export type PerformanceReviewProcessFilter = {
  archived?: InputMaybe<BooleanFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  cycleId?: InputMaybe<StringFilter>;
  endsAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntegerFilter>;
  name?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<PerformanceReviewProcessFilterConditions>>;
  ownerEmployeeIds?: InputMaybe<IntegerFilter>;
  ownerIds?: InputMaybe<IntegerFilter>;
  participationRate?: InputMaybe<IntegerFilter>;
  revieweeEmployeeIds?: InputMaybe<IntegerFilter>;
  revieweeIds?: InputMaybe<IntegerFilter>;
  startsAt?: InputMaybe<DateTimeFilter>;
  status?: InputMaybe<StringFilter>;
};

export type PerformanceReviewProcessFilterConditions = {
  archived?: InputMaybe<BooleanFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  cycleId?: InputMaybe<StringFilter>;
  endsAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntegerFilter>;
  name?: InputMaybe<StringFilter>;
  ownerEmployeeIds?: InputMaybe<IntegerFilter>;
  ownerIds?: InputMaybe<IntegerFilter>;
  participationRate?: InputMaybe<IntegerFilter>;
  revieweeEmployeeIds?: InputMaybe<IntegerFilter>;
  revieweeIds?: InputMaybe<IntegerFilter>;
  startsAt?: InputMaybe<DateTimeFilter>;
  status?: InputMaybe<StringFilter>;
};

/** Performance Review Process Materialized Targets */
export type PerformanceReviewProcessMaterializedTarget = {
  __typename?: 'PerformanceReviewProcessMaterializedTarget';
  access?: Maybe<ApiCoreAccess>;
  /**
   * Participant access ID
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  accessId: Scalars['Int'];
  /** Review process target ID */
  id: Scalars['Int'];
  performanceReviewProcess?: Maybe<PerformanceReviewProcess>;
  /**
   * Review process ID
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  performanceReviewProcessId: Scalars['Int'];
};


/** Performance Review Process Materialized Targets */
export type PerformanceReviewProcessMaterializedTargetAccessArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** Performance Review Process Materialized Targets */
export type PerformanceReviewProcessMaterializedTargetPerformanceReviewProcessArgs = {
  search?: InputMaybe<Scalars['String']>;
};

/** The connection type for PerformanceReviewProcessMaterializedTarget. */
export type PerformanceReviewProcessMaterializedTargetConnection = {
  __typename?: 'PerformanceReviewProcessMaterializedTargetConnection';
  /** A list of edges. */
  edges: Array<PerformanceReviewProcessMaterializedTargetEdge>;
  /** A list of nodes. */
  nodes: Array<PerformanceReviewProcessMaterializedTarget>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PerformanceReviewProcessMaterializedTargetEdge = {
  __typename?: 'PerformanceReviewProcessMaterializedTargetEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PerformanceReviewProcessMaterializedTarget;
};

/** Performance Review Process Participation Rates */
export type PerformanceReviewProcessParticipationRate = {
  __typename?: 'PerformanceReviewProcessParticipationRate';
  evaluationsCount: Scalars['Int'];
  id: Scalars['Int'];
  publishedEvaluationsCount: Scalars['Int'];
  publishedPercentage: Scalars['Float'];
};

/** The connection type for PerformanceReviewProcessParticipationRate. */
export type PerformanceReviewProcessParticipationRateConnection = {
  __typename?: 'PerformanceReviewProcessParticipationRateConnection';
  /** A list of edges. */
  edges: Array<PerformanceReviewProcessParticipationRateEdge>;
  /** A list of nodes. */
  nodes: Array<PerformanceReviewProcessParticipationRate>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PerformanceReviewProcessParticipationRateEdge = {
  __typename?: 'PerformanceReviewProcessParticipationRateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PerformanceReviewProcessParticipationRate;
};

export type PerformanceReviewProcessPolicies = {
  __typename?: 'PerformanceReviewProcessPolicies';
  bulkInititateAgreement: PermissionsPolicyResolution;
  export: PermissionsPolicyResolution;
  fullVisibility: PermissionsPolicyResolution;
  generateReviewQuestionsUsingAi: PermissionsPolicyResolution;
  manage: PermissionsPolicyResolution;
};

export type PerformanceReviewProcessPoliciesEnum =
  | 'bulk_inititate_agreement'
  | 'export'
  | 'full_visibility'
  | 'generate_review_questions_using_ai'
  | 'manage';

/** Performance Review Evaluations Score Metadata */
export type PerformanceReviewProcessScoreMetadatum = {
  __typename?: 'PerformanceReviewProcessScoreMetadatum';
  averageScore: Scalars['Float'];
  low: Scalars['Float'];
  maxScore: Scalars['Float'];
  mid: Scalars['Float'];
  participants: Scalars['Int'];
  top: Scalars['Float'];
};

/** The connection type for PerformanceReviewProcessScoreMetadatum. */
export type PerformanceReviewProcessScoreMetadatumConnection = {
  __typename?: 'PerformanceReviewProcessScoreMetadatumConnection';
  /** A list of edges. */
  edges: Array<PerformanceReviewProcessScoreMetadatumEdge>;
  /** A list of nodes. */
  nodes: Array<PerformanceReviewProcessScoreMetadatum>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PerformanceReviewProcessScoreMetadatumEdge = {
  __typename?: 'PerformanceReviewProcessScoreMetadatumEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PerformanceReviewProcessScoreMetadatum;
};

/** Statistics for a Review Process */
export type PerformanceReviewProcessStat = {
  __typename?: 'PerformanceReviewProcessStat';
  id: Scalars['String'];
  pendingReviewers: Array<ApiCoreAccess>;
  pendingReviewersConnection: ApiCoreAccessConnection;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  pendingReviewersIds: Array<Scalars['Int']>;
  performanceReviewProcess?: Maybe<PerformanceReviewProcess>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  performanceReviewProcessId: Scalars['Int'];
};


/** Statistics for a Review Process */
export type PerformanceReviewProcessStatPendingReviewersArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** Statistics for a Review Process */
export type PerformanceReviewProcessStatPendingReviewersConnectionArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  external?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** Statistics for a Review Process */
export type PerformanceReviewProcessStatPerformanceReviewProcessArgs = {
  search?: InputMaybe<Scalars['String']>;
};

/** The connection type for PerformanceReviewProcessStat. */
export type PerformanceReviewProcessStatConnection = {
  __typename?: 'PerformanceReviewProcessStatConnection';
  /** A list of edges. */
  edges: Array<PerformanceReviewProcessStatEdge>;
  /** A list of nodes. */
  nodes: Array<PerformanceReviewProcessStat>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PerformanceReviewProcessStatEdge = {
  __typename?: 'PerformanceReviewProcessStatEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PerformanceReviewProcessStat;
};

export type PerformanceReviewProcessStatusEnum =
  | 'active'
  | 'draft'
  | 'finished'
  | 'scheduled';

/** Performance Review Process Targets */
export type PerformanceReviewProcessTarget = {
  __typename?: 'PerformanceReviewProcessTarget';
  _policies?: Maybe<PerformanceReviewProcessTargetPolicies>;
  _policiesCollection?: Maybe<Array<PermissionsPolicyResolution>>;
  _policiesConnection: PermissionsPolicyResolutionConnection;
  access?: Maybe<ApiCoreAccess>;
  /**
   * Participant access ID
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  accessId: Scalars['Int'];
  agreement?: Maybe<PerformanceAgreement>;
  employeeName?: Maybe<EmployeesEmployeeName>;
  evaluations: Array<PerformanceReviewEvaluation>;
  evaluationsConnection: PerformanceReviewEvaluationConnection;
  /** Review process target ID */
  id: Scalars['String'];
  insight?: Maybe<PerformanceTargetInsight>;
  insightScore?: Maybe<PerformanceTargetInsightScore>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  materializedProcessTargetId: Scalars['Int'];
  performanceReviewProcess?: Maybe<PerformanceReviewProcess>;
  /**
   * Review process ID
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  performanceReviewProcessId: Scalars['Int'];
  performanceReviewProcessStartsAt?: Maybe<Scalars['ISO8601DateTime']>;
  publishedEvaluations: Array<PerformanceReviewEvaluation>;
  publishedEvaluationsConnection: PerformanceReviewEvaluationConnection;
  reviewFinalEmployeeScore?: Maybe<PerformanceReviewFinalEmployeeScore>;
  reviewStrategyEmployeeScores: Array<PerformanceReviewStrategyEmployeeScore>;
  reviewStrategyEmployeeScoresConnection: PerformanceReviewStrategyEmployeeScoreConnection;
  unpublishedEvaluations: Array<PerformanceReviewEvaluation>;
  unpublishedEvaluationsConnection: PerformanceReviewEvaluationConnection;
};


/** Performance Review Process Targets */
export type PerformanceReviewProcessTarget_PoliciesCollectionArgs = {
  ids: Array<PerformanceReviewProcessTargetPoliciesEnum>;
};


/** Performance Review Process Targets */
export type PerformanceReviewProcessTarget_PoliciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Performance Review Process Targets */
export type PerformanceReviewProcessTargetAccessArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** Performance Review Process Targets */
export type PerformanceReviewProcessTargetAgreementArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
  processIds?: InputMaybe<Array<Scalars['Int']>>;
  targetIds?: InputMaybe<Array<Scalars['String']>>;
};


/** Performance Review Process Targets */
export type PerformanceReviewProcessTargetEmployeeNameArgs = {
  afterEmployeeId?: InputMaybe<Scalars['Int']>;
  beforeEmployeeId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  reporteesOrLed?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyId?: InputMaybe<Scalars['Int']>;
  verb?: InputMaybe<Scalars['String']>;
  withActiveContract?: Scalars['Boolean'];
};


/** Performance Review Process Targets */
export type PerformanceReviewProcessTargetEvaluationsArgs = {
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  performanceReviewProcessIds?: InputMaybe<Array<Scalars['Int']>>;
  published?: InputMaybe<Scalars['Boolean']>;
  reviewerIds?: InputMaybe<Array<Scalars['Int']>>;
  reviewerStrategies?: InputMaybe<Array<PerformanceReviewerStrategiesStrategyEnum>>;
  targetAccessIds?: InputMaybe<Array<Scalars['Int']>>;
  withTargetsManagedByFilter?: InputMaybe<ReviewEvaluationsWithTargetsManagedByFilterInput>;
};


/** Performance Review Process Targets */
export type PerformanceReviewProcessTargetEvaluationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  performanceReviewProcessIds?: InputMaybe<Array<Scalars['Int']>>;
  published?: InputMaybe<Scalars['Boolean']>;
  reviewerIds?: InputMaybe<Array<Scalars['Int']>>;
  reviewerStrategies?: InputMaybe<Array<PerformanceReviewerStrategiesStrategyEnum>>;
  sortOrder?: InputMaybe<Sort>;
  targetAccessIds?: InputMaybe<Array<Scalars['Int']>>;
  withTargetsManagedByFilter?: InputMaybe<ReviewEvaluationsWithTargetsManagedByFilterInput>;
};


/** Performance Review Process Targets */
export type PerformanceReviewProcessTargetInsightArgs = {
  performanceReviewProcessIds?: InputMaybe<Array<Scalars['Int']>>;
  targetAccessId?: InputMaybe<Scalars['Int']>;
};


/** Performance Review Process Targets */
export type PerformanceReviewProcessTargetPerformanceReviewProcessArgs = {
  search?: InputMaybe<Scalars['String']>;
};


/** Performance Review Process Targets */
export type PerformanceReviewProcessTargetPublishedEvaluationsArgs = {
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  performanceReviewProcessIds?: InputMaybe<Array<Scalars['Int']>>;
  reviewerIds?: InputMaybe<Array<Scalars['Int']>>;
  reviewerStrategies?: InputMaybe<Array<PerformanceReviewerStrategiesStrategyEnum>>;
  targetAccessIds?: InputMaybe<Array<Scalars['Int']>>;
  withTargetsManagedByFilter?: InputMaybe<ReviewEvaluationsWithTargetsManagedByFilterInput>;
};


/** Performance Review Process Targets */
export type PerformanceReviewProcessTargetPublishedEvaluationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  performanceReviewProcessIds?: InputMaybe<Array<Scalars['Int']>>;
  reviewerIds?: InputMaybe<Array<Scalars['Int']>>;
  reviewerStrategies?: InputMaybe<Array<PerformanceReviewerStrategiesStrategyEnum>>;
  sortOrder?: InputMaybe<Sort>;
  targetAccessIds?: InputMaybe<Array<Scalars['Int']>>;
  withTargetsManagedByFilter?: InputMaybe<ReviewEvaluationsWithTargetsManagedByFilterInput>;
};


/** Performance Review Process Targets */
export type PerformanceReviewProcessTargetReviewFinalEmployeeScoreArgs = {
  agreementCompletionStatus?: InputMaybe<PerformanceDtosReviewProcessTargetAgreementCompletionStatusEnum>;
  evaluationsCompletionStatus?: InputMaybe<PerformanceReviewEvaluationStatusEnum>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  managedByFilter?: InputMaybe<ReviewFinalEmployeeScoresManagedByFilterInput>;
  reviewProcessIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  targetAccessIds?: InputMaybe<Array<Scalars['Int']>>;
  targetEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDates?: InputMaybe<Array<Scalars['String']>>;
  workplaceIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Performance Review Process Targets */
export type PerformanceReviewProcessTargetReviewStrategyEmployeeScoresArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  managedByFilter?: InputMaybe<ReviewStrategyEmployeeScoresManagedByFilterInput>;
  reviewProcessIds?: InputMaybe<Array<Scalars['Int']>>;
  reviewerStrategies?: InputMaybe<Array<PerformanceReviewerStrategiesStrategyEnum>>;
  targetAccessIds?: InputMaybe<Array<Scalars['Int']>>;
  targetEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Performance Review Process Targets */
export type PerformanceReviewProcessTargetReviewStrategyEmployeeScoresConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  managedByFilter?: InputMaybe<ReviewStrategyEmployeeScoresManagedByFilterInput>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  reviewProcessIds?: InputMaybe<Array<Scalars['Int']>>;
  reviewerStrategies?: InputMaybe<Array<PerformanceReviewerStrategiesStrategyEnum>>;
  sortOrder?: InputMaybe<Sort>;
  targetAccessIds?: InputMaybe<Array<Scalars['Int']>>;
  targetEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Performance Review Process Targets */
export type PerformanceReviewProcessTargetUnpublishedEvaluationsArgs = {
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  performanceReviewProcessIds?: InputMaybe<Array<Scalars['Int']>>;
  reviewerIds?: InputMaybe<Array<Scalars['Int']>>;
  reviewerStrategies?: InputMaybe<Array<PerformanceReviewerStrategiesStrategyEnum>>;
  targetAccessIds?: InputMaybe<Array<Scalars['Int']>>;
  withTargetsManagedByFilter?: InputMaybe<ReviewEvaluationsWithTargetsManagedByFilterInput>;
};


/** Performance Review Process Targets */
export type PerformanceReviewProcessTargetUnpublishedEvaluationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  performanceReviewProcessIds?: InputMaybe<Array<Scalars['Int']>>;
  reviewerIds?: InputMaybe<Array<Scalars['Int']>>;
  reviewerStrategies?: InputMaybe<Array<PerformanceReviewerStrategiesStrategyEnum>>;
  sortOrder?: InputMaybe<Sort>;
  targetAccessIds?: InputMaybe<Array<Scalars['Int']>>;
  withTargetsManagedByFilter?: InputMaybe<ReviewEvaluationsWithTargetsManagedByFilterInput>;
};

/** The connection type for PerformanceReviewProcessTarget. */
export type PerformanceReviewProcessTargetConnection = {
  __typename?: 'PerformanceReviewProcessTargetConnection';
  /** A list of edges. */
  edges: Array<PerformanceReviewProcessTargetEdge>;
  /** A list of nodes. */
  nodes: Array<PerformanceReviewProcessTarget>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PerformanceReviewProcessTargetEdge = {
  __typename?: 'PerformanceReviewProcessTargetEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PerformanceReviewProcessTarget;
};

/** the filter for the review_process_targets resource */
export type PerformanceReviewProcessTargetFilter = {
  id?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<PerformanceReviewProcessTargetFilterConditions>>;
  performanceReviewProcessStartsAt?: InputMaybe<DateTimeFilter>;
};

export type PerformanceReviewProcessTargetFilterConditions = {
  id?: InputMaybe<StringFilter>;
  performanceReviewProcessStartsAt?: InputMaybe<DateTimeFilter>;
};

/** the global search for the review_process_targets resource */
export type PerformanceReviewProcessTargetGlobalSearch = {
  employee?: InputMaybe<Scalars['String']>;
};

export type PerformanceReviewProcessTargetPolicies = {
  __typename?: 'PerformanceReviewProcessTargetPolicies';
  initiate: PermissionsPolicyResolution;
  seeTargetFinalScore: PermissionsPolicyResolution;
  seeTargetInsights: PermissionsPolicyResolution;
  seeTargetScoreDetails: PermissionsPolicyResolution;
};

export type PerformanceReviewProcessTargetPoliciesEnum =
  | 'initiate'
  | 'see_target_final_score'
  | 'see_target_insights'
  | 'see_target_score_details';

/** Performance Review Process Template */
export type PerformanceReviewProcessTemplate = {
  __typename?: 'PerformanceReviewProcessTemplate';
  agreementsEnabled?: Maybe<Scalars['Boolean']>;
  agreementsEsignatureEnabled?: Maybe<Scalars['Boolean']>;
  competenciesAssessmentsEnabled?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  employeePotentialScoreEnabled?: Maybe<Scalars['Boolean']>;
  employeeScoreEnabled?: Maybe<Scalars['Boolean']>;
  /** Review process template ID */
  id: Scalars['Int'];
  /** Review process name */
  name: Scalars['String'];
  questionnaires?: Maybe<PerformanceQuestionnairesByStrategy>;
  /** Allows to republish the review process evaluations while the review process is active */
  republishEvaluationsEnabled?: Maybe<Scalars['Boolean']>;
  /** Review types that will be assigned to the review process. It'll be used to create the evaluations when the process starts */
  reviewerStrategies?: Maybe<Array<PerformanceReviewerStrategiesStrategyEnum>>;
  targetStrategy?: Maybe<PerformanceTargetStrategy>;
  /** A brief description of the review process template */
  templateDescription?: Maybe<Scalars['String']>;
};

/** The connection type for PerformanceReviewProcessTemplate. */
export type PerformanceReviewProcessTemplateConnection = {
  __typename?: 'PerformanceReviewProcessTemplateConnection';
  /** A list of edges. */
  edges: Array<PerformanceReviewProcessTemplateEdge>;
  /** A list of nodes. */
  nodes: Array<PerformanceReviewProcessTemplate>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PerformanceReviewProcessTemplateEdge = {
  __typename?: 'PerformanceReviewProcessTemplateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PerformanceReviewProcessTemplate;
};

/** the filter for the review_process_templates resource */
export type PerformanceReviewProcessTemplateFilter = {
  id?: InputMaybe<IntegerFilter>;
  name?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<PerformanceReviewProcessTemplateFilterConditions>>;
  reviewerStrategies?: InputMaybe<StringFilter>;
};

export type PerformanceReviewProcessTemplateFilterConditions = {
  id?: InputMaybe<IntegerFilter>;
  name?: InputMaybe<StringFilter>;
  reviewerStrategies?: InputMaybe<StringFilter>;
};

/** Performance Review Questionnaire by reviewer strategies */
export type PerformanceReviewQuestionnaireByStrategy = {
  __typename?: 'PerformanceReviewQuestionnaireByStrategy';
  /** Placeholder used for the presentation of the competency assessments */
  competenciesPlaceholderManagerQuestionnaire?: Maybe<PerformanceQuestionnaireByStrategy>;
  /** Placeholder used for the presentation of the competency assessments */
  competenciesPlaceholderSelfQuestionnaire?: Maybe<PerformanceQuestionnaireByStrategy>;
  /** Scoring range used in rating questions */
  defaultRatingScale: Array<PerformanceRatingScaleOption>;
  /** Questionnaire for direct report evaluation */
  directReportQuestionnaire?: Maybe<PerformanceQuestionnaireByStrategy>;
  /** Questionnaire included in the end of manager evaluation to evaluate the employee potential */
  employeePotentialScoreManagerQuestionnaire?: Maybe<PerformanceQuestionnaireByStrategy>;
  /** Questionnaire included in the end of manager evaluation to evaluate the employee performance */
  employeeScoreManagerQuestionnaire?: Maybe<PerformanceQuestionnaireByStrategy>;
  /** Questionnaire included in the end of self evaluation to evaluate the employee performance */
  employeeScoreSelfQuestionnaire?: Maybe<PerformanceQuestionnaireByStrategy>;
  /** Review process ID */
  id: Scalars['Int'];
  /** Questionnaire for manager evaluation */
  managerQuestionnaire?: Maybe<PerformanceQuestionnaireByStrategy>;
  /** Questionnaire for peers evaluation */
  peersQuestionnaire?: Maybe<PerformanceQuestionnaireByStrategy>;
  performanceReviewProcess?: Maybe<PerformanceReviewProcess>;
  /**
   * Review process ID
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  performanceReviewProcessId: Scalars['Int'];
  /**
   * Rating scale ID that is used in competency assessments and employee score rating questions
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  ratingScaleId?: Maybe<Scalars['Int']>;
  scoreScale?: Maybe<PerformanceEmployeeScoreScale>;
  /** Questionnaire for self evaluation */
  selfQuestionnaire?: Maybe<PerformanceQuestionnaireByStrategy>;
};


/** Performance Review Questionnaire by reviewer strategies */
export type PerformanceReviewQuestionnaireByStrategyPerformanceReviewProcessArgs = {
  search?: InputMaybe<Scalars['String']>;
};

/** The connection type for PerformanceReviewQuestionnaireByStrategy. */
export type PerformanceReviewQuestionnaireByStrategyConnection = {
  __typename?: 'PerformanceReviewQuestionnaireByStrategyConnection';
  /** A list of edges. */
  edges: Array<PerformanceReviewQuestionnaireByStrategyEdge>;
  /** A list of nodes. */
  nodes: Array<PerformanceReviewQuestionnaireByStrategy>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PerformanceReviewQuestionnaireByStrategyEdge = {
  __typename?: 'PerformanceReviewQuestionnaireByStrategyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PerformanceReviewQuestionnaireByStrategy;
};

/** Performance Review Strategy Employee Scores */
export type PerformanceReviewStrategyEmployeeScore = {
  __typename?: 'PerformanceReviewStrategyEmployeeScore';
  /** Calculated at */
  calculatedAt: Scalars['ISO8601DateTime'];
  /** Company ID */
  companyId: Scalars['Int'];
  /** Review strategy employee score ID */
  id: Scalars['Int'];
  /** Materialized process target ID */
  materializedProcessTargetId: Scalars['Int'];
  /** Normalized score */
  normalizedScore: Scalars['Float'];
  /** Performance review process ID */
  performanceReviewProcessId: Scalars['Int'];
  /** Reviewer strategy */
  reviewerStrategy: PerformanceReviewerStrategiesStrategyEnum;
  scaleMax: Scalars['Int'];
  scaleMin: Scalars['Int'];
  /** Score */
  score: Scalars['Float'];
  /** Target access ID */
  targetAccessId: Scalars['Int'];
  /** Target employee ID */
  targetEmployeeId?: Maybe<Scalars['Int']>;
};

/** The connection type for PerformanceReviewStrategyEmployeeScore. */
export type PerformanceReviewStrategyEmployeeScoreConnection = {
  __typename?: 'PerformanceReviewStrategyEmployeeScoreConnection';
  /** A list of edges. */
  edges: Array<PerformanceReviewStrategyEmployeeScoreEdge>;
  /** A list of nodes. */
  nodes: Array<PerformanceReviewStrategyEmployeeScore>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PerformanceReviewStrategyEmployeeScoreEdge = {
  __typename?: 'PerformanceReviewStrategyEmployeeScoreEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PerformanceReviewStrategyEmployeeScore;
};

/** Performance Review Visibility Settings */
export type PerformanceReviewVisibilitySetting = {
  __typename?: 'PerformanceReviewVisibilitySetting';
  /** Peer evaluations are anonymous when enabled, so employees don't know who reviewed them */
  anonymousPeerEvaluationForTarget: Scalars['Boolean'];
  /** Managers can access the results of their reports before deadline when enabled */
  earlyAccessToAnswersForManagers: Scalars['Boolean'];
  /** Review process ID */
  id: Scalars['Int'];
  migratedAnonymous: Scalars['Boolean'];
  performanceReviewProcess?: Maybe<PerformanceReviewProcess>;
  /**
   * Review process ID
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  performanceReviewProcessId: Scalars['Int'];
  /** Employees don't have access to their results when enabled */
  restrictAnswersVisibilityToReportees: Scalars['Boolean'];
};


/** Performance Review Visibility Settings */
export type PerformanceReviewVisibilitySettingPerformanceReviewProcessArgs = {
  search?: InputMaybe<Scalars['String']>;
};

/** The connection type for PerformanceReviewVisibilitySetting. */
export type PerformanceReviewVisibilitySettingConnection = {
  __typename?: 'PerformanceReviewVisibilitySettingConnection';
  /** A list of edges. */
  edges: Array<PerformanceReviewVisibilitySettingEdge>;
  /** A list of nodes. */
  nodes: Array<PerformanceReviewVisibilitySetting>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PerformanceReviewVisibilitySettingEdge = {
  __typename?: 'PerformanceReviewVisibilitySettingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PerformanceReviewVisibilitySetting;
};

export type PerformanceReviewerStrategiesStrategyEnum =
  | 'direct_reports'
  | 'manager'
  | 'peers'
  | 'self';

/** Performance Score Configurations */
export type PerformanceScoreConfiguration = {
  __typename?: 'PerformanceScoreConfiguration';
  _policies?: Maybe<PerformanceScoreConfigurationPolicies>;
  _policiesCollection?: Maybe<Array<PermissionsPolicyResolution>>;
  _policiesConnection: PermissionsPolicyResolutionConnection;
  id: Scalars['Int'];
  mode: PerformanceScoreConfigurationModeEnum;
  questionnaireable?: Maybe<PerformanceQuestionnaireable>;
  questionnaireableId: Scalars['Int'];
  questionnaireableType: PerformanceValueObjectsQuestionnaireableEnum;
  strategyConfigurations: Array<PerformanceStrategyConfiguration>;
};


/** Performance Score Configurations */
export type PerformanceScoreConfiguration_PoliciesCollectionArgs = {
  ids: Array<PerformanceScoreConfigurationPoliciesEnum>;
};


/** Performance Score Configurations */
export type PerformanceScoreConfiguration_PoliciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for PerformanceScoreConfiguration. */
export type PerformanceScoreConfigurationConnection = {
  __typename?: 'PerformanceScoreConfigurationConnection';
  /** A list of edges. */
  edges: Array<PerformanceScoreConfigurationEdge>;
  /** A list of nodes. */
  nodes: Array<PerformanceScoreConfiguration>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PerformanceScoreConfigurationEdge = {
  __typename?: 'PerformanceScoreConfigurationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PerformanceScoreConfiguration;
};

export type PerformanceScoreConfigurationModeEnum =
  | 'custom_weights'
  | 'final_question';

export type PerformanceScoreConfigurationPolicies = {
  __typename?: 'PerformanceScoreConfigurationPolicies';
  seeWeights: PermissionsPolicyResolution;
};

export type PerformanceScoreConfigurationPoliciesEnum =
  | 'see_weights';

export type PerformanceSectionWeight = {
  __typename?: 'PerformanceSectionWeight';
  sectionId: Scalars['String'];
  weight: Scalars['Float'];
};

export type PerformanceSectionWeightInput = {
  sectionId: Scalars['String'];
  weight: Scalars['Float'];
};

export type PerformanceStartReviewProcessValidatorFailedCheckEnum =
  | 'invalid_deadline'
  | 'invalid_section_weights_sum'
  | 'missing_deadline'
  | 'missing_potential_reviewers'
  | 'missing_questions'
  | 'missing_reviewer_strategy'
  | 'missing_target_strategy'
  | 'missing_target_strategy_members'
  | 'missing_title';

export type PerformanceStrategyConfiguration = {
  __typename?: 'PerformanceStrategyConfiguration';
  producesScore: Scalars['Boolean'];
  reviewerStrategy: PerformanceReviewerStrategiesStrategyEnum;
  sectionWeights: Array<PerformanceSectionWeight>;
  weight?: Maybe<Scalars['Float']>;
};

export type PerformanceStrategyConfigurationInput = {
  producesScore: Scalars['Boolean'];
  reviewerStrategy: PerformanceReviewerStrategiesStrategyEnum;
  sectionWeights: Array<PerformanceSectionWeightInput>;
  weight?: InputMaybe<Scalars['Float']>;
};

/** Performance Target Insights */
export type PerformanceTargetInsight = {
  __typename?: 'PerformanceTargetInsight';
  actionItems?: Maybe<Array<Scalars['String']>>;
  alignmentScore?: Maybe<PerformanceInsightsQuantityEnum>;
  alignmentSummary?: Maybe<Scalars['String']>;
  empty?: Maybe<Scalars['Boolean']>;
  engagementSignals?: Maybe<Array<PerformanceEngagmentSignal>>;
  id: Scalars['String'];
  language?: Maybe<Scalars['String']>;
  myself: Scalars['Boolean'];
  performanceReviewProcess: PerformanceReviewProcess;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  performanceReviewProcessId: Scalars['Int'];
  performanceScore?: Maybe<PerformanceInsightsQuantityEnum>;
  performanceSummary?: Maybe<Scalars['String']>;
  strengths?: Maybe<Scalars['String']>;
  targetAccess: ApiCoreAccess;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  targetAccessId: Scalars['Int'];
  weaknesses?: Maybe<Scalars['String']>;
};


/** Performance Target Insights */
export type PerformanceTargetInsightPerformanceReviewProcessArgs = {
  search?: InputMaybe<Scalars['String']>;
};


/** Performance Target Insights */
export type PerformanceTargetInsightTargetAccessArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for PerformanceTargetInsight. */
export type PerformanceTargetInsightConnection = {
  __typename?: 'PerformanceTargetInsightConnection';
  /** A list of edges. */
  edges: Array<PerformanceTargetInsightEdge>;
  /** A list of nodes. */
  nodes: Array<PerformanceTargetInsight>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PerformanceTargetInsightEdge = {
  __typename?: 'PerformanceTargetInsightEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PerformanceTargetInsight;
};

/** Performance Target Insights Scores */
export type PerformanceTargetInsightScore = {
  __typename?: 'PerformanceTargetInsightScore';
  alignmentScore?: Maybe<PerformanceInsightsQuantityEnum>;
  id: Scalars['String'];
  performanceReviewProcess: PerformanceReviewProcess;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  performanceReviewProcessId: Scalars['Int'];
  performanceScore?: Maybe<PerformanceInsightsQuantityEnum>;
  targetAccess: ApiCoreAccess;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  targetAccessId: Scalars['Int'];
};


/** Performance Target Insights Scores */
export type PerformanceTargetInsightScorePerformanceReviewProcessArgs = {
  search?: InputMaybe<Scalars['String']>;
};


/** Performance Target Insights Scores */
export type PerformanceTargetInsightScoreTargetAccessArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for PerformanceTargetInsightScore. */
export type PerformanceTargetInsightScoreConnection = {
  __typename?: 'PerformanceTargetInsightScoreConnection';
  /** A list of edges. */
  edges: Array<PerformanceTargetInsightScoreEdge>;
  /** A list of nodes. */
  nodes: Array<PerformanceTargetInsightScore>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PerformanceTargetInsightScoreEdge = {
  __typename?: 'PerformanceTargetInsightScoreEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PerformanceTargetInsightScore;
};

/** Performance Target Managers */
export type PerformanceTargetManager = {
  __typename?: 'PerformanceTargetManager';
  /** Manager employee ID */
  id: Scalars['String'];
  /** Manager access ID */
  managerAccessId: Scalars['Int'];
  /** Manager full name */
  managerFullName: Scalars['String'];
  performanceReviewProcess: PerformanceReviewProcess;
  /**
   * Review process ID
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  performanceReviewProcessId: Scalars['Int'];
};


/** Performance Target Managers */
export type PerformanceTargetManagerPerformanceReviewProcessArgs = {
  search?: InputMaybe<Scalars['String']>;
};

/** The connection type for PerformanceTargetManager. */
export type PerformanceTargetManagerConnection = {
  __typename?: 'PerformanceTargetManagerConnection';
  /** A list of edges. */
  edges: Array<PerformanceTargetManagerEdge>;
  /** A list of nodes. */
  nodes: Array<PerformanceTargetManager>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PerformanceTargetManagerEdge = {
  __typename?: 'PerformanceTargetManagerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PerformanceTargetManager;
};

export type PerformanceTargetStrategy = {
  __typename?: 'PerformanceTargetStrategy';
  arguments?: Maybe<Array<Scalars['Int']>>;
  strategy: PerformanceTargetStrategySupportedStrategiesEnum;
};

export type PerformanceTargetStrategySupportedStrategiesEnum =
  | 'all_employees'
  | 'by_employees'
  | 'by_locations'
  | 'by_teams'
  | 'manual_selection';

export type PerformanceValueObjectsQuestionnaireAnsweredElementTypesEnum =
  | 'answered_question'
  | 'answered_section';

export type PerformanceValueObjectsQuestionnaireElementTypesEnum =
  | 'question'
  | 'section';

export type PerformanceValueObjectsQuestionnaireableEnum =
  | 'review_process'
  | 'review_process_custom_template';

export type PerformanceVisibilitySettings = {
  __typename?: 'PerformanceVisibilitySettings';
  anonymousPeerEvaluationForTarget: Scalars['Boolean'];
  earlyAccessToAnswersForManagers: Scalars['Boolean'];
  restrictAnswersVisibilityToReportees: Scalars['Boolean'];
};

/** Autogenerated return type of Performance_agreement_refresh_subscription. */
export type Performance_Agreement_Refresh_SubscriptionPayload = {
  __typename?: 'Performance_agreement_refresh_subscriptionPayload';
  agreement?: Maybe<Agreement_Refresh_Type>;
};

export type PermissionsContextEnum =
  | 'everybody'
  | 'legal_entity'
  | 'owned'
  | 'reportees'
  | 'team_leader';

export type PermissionsContextlessPolicies = {
  __typename?: 'PermissionsContextlessPolicies';
  commandBarSeeInsights: ContextlessPolicyResolution;
  editExternalUsers: ContextlessPolicyResolution;
  groupAssignEmployees: ContextlessPolicyResolution;
  groupCreate: ContextlessPolicyResolution;
  groupCreateExternalUsers: ContextlessPolicyResolution;
  groupDuplicate: ContextlessPolicyResolution;
  groupEdit: ContextlessPolicyResolution;
  insightsSeeInsights: ContextlessPolicyResolution;
  permissionsRead: ContextlessPolicyResolution;
  roleTemplateApply: ContextlessPolicyResolution;
};

/** Used to check if a user can perform an action given a contextless policy key */
export type PermissionsContextlessPolicyResolution = {
  __typename?: 'PermissionsContextlessPolicyResolution';
  can: Scalars['Boolean'];
  id: Scalars['String'];
};

/** The connection type for PermissionsContextlessPolicyResolution. */
export type PermissionsContextlessPolicyResolutionConnection = {
  __typename?: 'PermissionsContextlessPolicyResolutionConnection';
  /** A list of edges. */
  edges: Array<PermissionsContextlessPolicyResolutionEdge>;
  /** A list of nodes. */
  nodes: Array<PermissionsContextlessPolicyResolution>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PermissionsContextlessPolicyResolutionEdge = {
  __typename?: 'PermissionsContextlessPolicyResolutionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PermissionsContextlessPolicyResolution;
};

export type PermissionsEntitiesPermissionGroupKindEnum =
  | 'admin'
  | 'custom'
  | 'default'
  | 'onboarding';

export type PermissionsEntitiesResourceTagTypeEnum =
  | 'legal_entity';

/** Permissions */
export type PermissionsPermission = {
  __typename?: 'PermissionsPermission';
  authorized: Scalars['Boolean'];
  category: Scalars['String'];
  categoryLabel: Scalars['String'];
  contextless: Scalars['Boolean'];
  id: Scalars['String'];
  permissionContext: PermissionsContextEnum;
  permissionsGroupId: Scalars['Int'];
  resource?: Maybe<Scalars['String']>;
  resourceTags: Array<PermissionsResourceTag>;
  resourceTagsConnection: PermissionsResourceTagConnection;
  verb: Scalars['String'];
  verbDescription?: Maybe<Scalars['String']>;
  verbLabel: Scalars['String'];
};


/** Permissions */
export type PermissionsPermissionResourceTagsArgs = {
  companyId: Scalars['String'];
  ids?: InputMaybe<Array<Scalars['String']>>;
};


/** Permissions */
export type PermissionsPermissionResourceTagsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['String'];
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for PermissionsPermission. */
export type PermissionsPermissionConnection = {
  __typename?: 'PermissionsPermissionConnection';
  /** A list of edges. */
  edges: Array<PermissionsPermissionEdge>;
  /** A list of nodes. */
  nodes: Array<PermissionsPermission>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PermissionsPermissionEdge = {
  __typename?: 'PermissionsPermissionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PermissionsPermission;
};

/** Permission Groups */
export type PermissionsPermissionGroup = {
  __typename?: 'PermissionsPermissionGroup';
  companyId: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  defaultGroup: Scalars['Boolean'];
  id: Scalars['Int'];
  kind: PermissionsEntitiesPermissionGroupKindEnum;
  legacyAdmin: Scalars['Boolean'];
  members: Array<ApiCoreAccess>;
  membersConnection: ApiCoreAccessConnection;
  name: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};


/** Permission Groups */
export type PermissionsPermissionGroupMembersArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** Permission Groups */
export type PermissionsPermissionGroupMembersConnectionArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  external?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for PermissionsPermissionGroup. */
export type PermissionsPermissionGroupConnection = {
  __typename?: 'PermissionsPermissionGroupConnection';
  /** A list of edges. */
  edges: Array<PermissionsPermissionGroupEdge>;
  /** A list of nodes. */
  nodes: Array<PermissionsPermissionGroup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PermissionsPermissionGroupEdge = {
  __typename?: 'PermissionsPermissionGroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PermissionsPermissionGroup;
};

/** Permissions policy resolution */
export type PermissionsPolicyResolution = {
  __typename?: 'PermissionsPolicyResolution';
  can: Scalars['Boolean'];
  id: Scalars['String'];
  policy: Scalars['String'];
  resource: Scalars['String'];
  resourceId: Scalars['String'];
};

/** The connection type for PermissionsPolicyResolution. */
export type PermissionsPolicyResolutionConnection = {
  __typename?: 'PermissionsPolicyResolutionConnection';
  /** A list of edges. */
  edges: Array<PermissionsPolicyResolutionEdge>;
  /** A list of nodes. */
  nodes: Array<PermissionsPolicyResolution>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PermissionsPolicyResolutionEdge = {
  __typename?: 'PermissionsPolicyResolutionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PermissionsPolicyResolution;
};

/**
 * Tags with arbitrary information about resources of resource-based permissions,
 * such as the legal entity they belong to. These tags are used to enrich the
 * permissions UI.
 */
export type PermissionsResourceTag = {
  __typename?: 'PermissionsResourceTag';
  id: Scalars['String'];
  label: Scalars['String'];
  resourceId: Scalars['String'];
  type: PermissionsEntitiesResourceTagTypeEnum;
};

/** The connection type for PermissionsResourceTag. */
export type PermissionsResourceTagConnection = {
  __typename?: 'PermissionsResourceTagConnection';
  /** A list of edges. */
  edges: Array<PermissionsResourceTagEdge>;
  /** A list of nodes. */
  nodes: Array<PermissionsResourceTag>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PermissionsResourceTagEdge = {
  __typename?: 'PermissionsResourceTagEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PermissionsResourceTag;
};

/** Role template */
export type PermissionsRoleTemplate = {
  __typename?: 'PermissionsRoleTemplate';
  description: Scalars['String'];
  domain: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  verbs: Array<PermissionsRoleTemplateVerb>;
  verbsConnection: PermissionsRoleTemplateVerbConnection;
};


/** Role template */
export type PermissionsRoleTemplateVerbsArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};


/** Role template */
export type PermissionsRoleTemplateVerbsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for PermissionsRoleTemplate. */
export type PermissionsRoleTemplateConnection = {
  __typename?: 'PermissionsRoleTemplateConnection';
  /** A list of edges. */
  edges: Array<PermissionsRoleTemplateEdge>;
  /** A list of nodes. */
  nodes: Array<PermissionsRoleTemplate>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PermissionsRoleTemplateEdge = {
  __typename?: 'PermissionsRoleTemplateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PermissionsRoleTemplate;
};

/** Role template permission */
export type PermissionsRoleTemplateVerb = {
  __typename?: 'PermissionsRoleTemplateVerb';
  contextless: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  grantedContexts: Array<PermissionsContextEnum>;
  id: Scalars['String'];
  name: Scalars['String'];
  roleTemplateId: Scalars['String'];
};

/** The connection type for PermissionsRoleTemplateVerb. */
export type PermissionsRoleTemplateVerbConnection = {
  __typename?: 'PermissionsRoleTemplateVerbConnection';
  /** A list of edges. */
  edges: Array<PermissionsRoleTemplateVerbEdge>;
  /** A list of nodes. */
  nodes: Array<PermissionsRoleTemplateVerb>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PermissionsRoleTemplateVerbEdge = {
  __typename?: 'PermissionsRoleTemplateVerbEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PermissionsRoleTemplateVerb;
};

/** Manager's Attrition insights */
export type PersonalHistoryAttritionEmployeeOverview = {
  __typename?: 'PersonalHistoryAttritionEmployeeOverview';
  attritionEmployees: Array<EmployeesEmployee>;
  attritionemployeesConnection: EmployeesEmployeeConnection;
  attritions: Array<Scalars['Int']>;
  attritionsDates: Array<Scalars['ISO8601Date']>;
  total: Scalars['Int'];
  totalLastYear: Scalars['Int'];
};


/** Manager's Attrition insights */
export type PersonalHistoryAttritionEmployeeOverviewAttritionEmployeesArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Manager's Attrition insights */
export type PersonalHistoryAttritionEmployeeOverviewAttritionemployeesConnectionArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  after?: InputMaybe<Scalars['String']>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Sort>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for PersonalHistoryAttritionEmployeeOverview. */
export type PersonalHistoryAttritionEmployeeOverviewConnection = {
  __typename?: 'PersonalHistoryAttritionEmployeeOverviewConnection';
  /** A list of edges. */
  edges: Array<PersonalHistoryAttritionEmployeeOverviewEdge>;
  /** A list of nodes. */
  nodes: Array<PersonalHistoryAttritionEmployeeOverview>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PersonalHistoryAttritionEmployeeOverviewEdge = {
  __typename?: 'PersonalHistoryAttritionEmployeeOverviewEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PersonalHistoryAttritionEmployeeOverview;
};

/** Manager's hiring insights */
export type PersonalHistoryHiringEmployeeOverview = {
  __typename?: 'PersonalHistoryHiringEmployeeOverview';
  hiredEmployees: Array<EmployeesEmployee>;
  hiredemployeesConnection: EmployeesEmployeeConnection;
  hires: Array<Scalars['Int']>;
  hiresDates: Array<Scalars['ISO8601Date']>;
  total: Scalars['Int'];
  totalLastYear: Scalars['Int'];
};


/** Manager's hiring insights */
export type PersonalHistoryHiringEmployeeOverviewHiredEmployeesArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Manager's hiring insights */
export type PersonalHistoryHiringEmployeeOverviewHiredemployeesConnectionArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  after?: InputMaybe<Scalars['String']>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Sort>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for PersonalHistoryHiringEmployeeOverview. */
export type PersonalHistoryHiringEmployeeOverviewConnection = {
  __typename?: 'PersonalHistoryHiringEmployeeOverviewConnection';
  /** A list of edges. */
  edges: Array<PersonalHistoryHiringEmployeeOverviewEdge>;
  /** A list of nodes. */
  nodes: Array<PersonalHistoryHiringEmployeeOverview>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PersonalHistoryHiringEmployeeOverviewEdge = {
  __typename?: 'PersonalHistoryHiringEmployeeOverviewEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PersonalHistoryHiringEmployeeOverview;
};

/** Autogenerated return type of PhoneCallAtsCandidate. */
export type PhoneCallAtsCandidatePayload = {
  __typename?: 'PhoneCallAtsCandidatePayload';
  candidate?: Maybe<AtsCandidate>;
  errors: Array<MutationError>;
};

export type PositionsContextlessPolicies = {
  __typename?: 'PositionsContextlessPolicies';
  managePosition: ContextlessPolicyResolution;
};

/** Positions */
export type PositionsPosition = {
  __typename?: 'PositionsPosition';
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  atsJobPostingId: Scalars['Int'];
  companyId: Scalars['Int'];
  employeeId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  jobCatalogLevel?: Maybe<JobCatalogLevel>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  jobCatalogLevelId?: Maybe<Scalars['Int']>;
  jobPosting?: Maybe<AtsJobPosting>;
  managerId: Scalars['Int'];
};


/** Positions */
export type PositionsPositionJobCatalogLevelArgs = {
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  includeArchived?: Scalars['Boolean'];
  includeArchivedRole?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  roleIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Positions */
export type PositionsPositionJobPostingArgs = {
  hiringManagerAccessIds?: InputMaybe<Array<Scalars['Int']>>;
  id?: InputMaybe<Scalars['Int']>;
  includeActiveJobs?: InputMaybe<Scalars['Boolean']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  locationId?: InputMaybe<Scalars['Int']>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  status?: InputMaybe<AtsJobPostingStatusesEnum>;
  statuses?: InputMaybe<Array<AtsJobPostingStatusesEnum>>;
  teamId?: InputMaybe<Scalars['Int']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  title?: InputMaybe<Scalars['String']>;
};

/** The connection type for PositionsPosition. */
export type PositionsPositionConnection = {
  __typename?: 'PositionsPositionConnection';
  /** A list of edges. */
  edges: Array<PositionsPositionEdge>;
  /** A list of nodes. */
  nodes: Array<PositionsPosition>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PositionsPositionEdge = {
  __typename?: 'PositionsPositionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PositionsPosition;
};

export type PostsAggregatedReaction = {
  __typename?: 'PostsAggregatedReaction';
  code: Scalars['String'];
  count: Scalars['Int'];
  postId: Scalars['Int'];
  supporters: Array<PostsSupporter>;
};

/** Posts comment */
export type PostsComment = {
  __typename?: 'PostsComment';
  author?: Maybe<ApiCoreAccess>;
  /**
   * author identifier refers to the employee access, you can get the employee from the employee endpoint
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  authorId: Scalars['Int'];
  /** date of the comment */
  createdAt: Scalars['ISO8601DateTime'];
  /** identifier of the comment */
  id: Scalars['Int'];
  post: PostsPost;
  /** identifier of the post */
  postId: Scalars['Int'];
  /** text of the comment */
  text: Scalars['String'];
};


/** Posts comment */
export type PostsCommentAuthorArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** Posts comment */
export type PostsCommentPostArgs = {
  from?: InputMaybe<Scalars['ISO8601Date']>;
  groups?: InputMaybe<Array<Scalars['Int']>>;
  id?: InputMaybe<Scalars['Int']>;
  isMobile?: InputMaybe<Scalars['Boolean']>;
  noPagination?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  postsPerPage?: InputMaybe<Scalars['Int']>;
  publishedAt?: InputMaybe<Scalars['ISO8601Date']>;
  scheduledPosts?: InputMaybe<Scalars['Boolean']>;
  startsFrom?: InputMaybe<Scalars['ISO8601Date']>;
  startsUntil?: InputMaybe<Scalars['ISO8601Date']>;
  truncateDescription?: InputMaybe<Scalars['Boolean']>;
  types?: InputMaybe<Array<Scalars['String']>>;
  until?: InputMaybe<Scalars['ISO8601Date']>;
  withCoverImage?: InputMaybe<Scalars['Boolean']>;
  withReactions?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for PostsComment. */
export type PostsCommentConnection = {
  __typename?: 'PostsCommentConnection';
  /** A list of edges. */
  edges: Array<PostsCommentEdge>;
  /** A list of nodes. */
  nodes: Array<PostsComment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PostsCommentEdge = {
  __typename?: 'PostsCommentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PostsComment;
};

export type PostsContextlessPolicies = {
  __typename?: 'PostsContextlessPolicies';
  dashboardWidgetNextEventsVisible: ContextlessPolicyResolution;
  groupCanPostSomewhere: ContextlessPolicyResolution;
  groupCreate: ContextlessPolicyResolution;
  postsManage: ContextlessPolicyResolution;
};

/** Preview employees that would be members of a dynamic team based on a specification */
export type PostsDynamicTeamPreview = {
  __typename?: 'PostsDynamicTeamPreview';
  /** first name of the employee */
  firstName: Scalars['String'];
  /** identifier of the employee */
  id: Scalars['Int'];
  /** last name of the employee */
  lastName: Scalars['String'];
};

/** The connection type for PostsDynamicTeamPreview. */
export type PostsDynamicTeamPreviewConnection = {
  __typename?: 'PostsDynamicTeamPreviewConnection';
  /** A list of edges. */
  edges: Array<PostsDynamicTeamPreviewEdge>;
  /** A list of nodes. */
  nodes: Array<PostsDynamicTeamPreview>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PostsDynamicTeamPreviewEdge = {
  __typename?: 'PostsDynamicTeamPreviewEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PostsDynamicTeamPreview;
};

/** Posts group */
export type PostsGroup = {
  __typename?: 'PostsGroup';
  _policies?: Maybe<PostsGroupPolicies>;
  _policiesCollection?: Maybe<Array<PermissionsPolicyResolution>>;
  _policiesConnection: PermissionsPolicyResolutionConnection;
  authorId?: Maybe<Scalars['Int']>;
  /** description of the group. */
  description?: Maybe<Scalars['String']>;
  /**
   * List of employee identifiers that belong to the access group associated with this group.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  employeeIds: Array<Scalars['Int']>;
  employees: Array<EmployeesEmployee>;
  employeesConnection: EmployeesEmployeeConnection;
  /** URL that directs to the frontend page of the community. Returns null if the group does not exist. */
  frontendUrl?: Maybe<Scalars['String']>;
  /** identifier of the group. */
  id: Scalars['Int'];
  /** unique identifier of the group (e.g., 'celebrations', 'announcements'). */
  identifier?: Maybe<Scalars['String']>;
  /** Whether the current access is a member of the group. */
  isMember: Scalars['Boolean'];
  /** title of the group. */
  title: Scalars['String'];
};


/** Posts group */
export type PostsGroup_PoliciesCollectionArgs = {
  ids: Array<PostsGroupPoliciesEnum>;
};


/** Posts group */
export type PostsGroup_PoliciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Posts group */
export type PostsGroupEmployeesArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Posts group */
export type PostsGroupEmployeesConnectionArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  after?: InputMaybe<Scalars['String']>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Sort>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for PostsGroup. */
export type PostsGroupConnection = {
  __typename?: 'PostsGroupConnection';
  /** A list of edges. */
  edges: Array<PostsGroupEdge>;
  /** A list of nodes. */
  nodes: Array<PostsGroup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PostsGroupEdge = {
  __typename?: 'PostsGroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PostsGroup;
};

/** the filter for the groups resource */
export type PostsGroupFilter = {
  identifier?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<PostsGroupFilterConditions>>;
};

export type PostsGroupFilterConditions = {
  identifier?: InputMaybe<StringFilter>;
};

export type PostsGroupPolicies = {
  __typename?: 'PostsGroupPolicies';
  addPosts: PermissionsPolicyResolution;
  leave: PermissionsPolicyResolution;
  update: PermissionsPolicyResolution;
};

export type PostsGroupPoliciesEnum =
  | 'add_posts'
  | 'leave'
  | 'update';

/** Posts post */
export type PostsPost = {
  __typename?: 'PostsPost';
  _policies?: Maybe<PostsPostPolicies>;
  _policiesCollection?: Maybe<Array<PermissionsPolicyResolution>>;
  _policiesConnection: PermissionsPolicyResolutionConnection;
  /** allow comments and reactions on the post */
  allowCommentsAndReactions: Scalars['Boolean'];
  author?: Maybe<ApiCoreAccess>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  authorId?: Maybe<Scalars['Int']>;
  comments: Array<PostsComment>;
  commentsConnection: PostsCommentConnection;
  commentsCount: Scalars['Int'];
  /** url of the cover image */
  coverImageUrl?: Maybe<Scalars['String']>;
  /** date when the post has been created */
  createdAt: Scalars['ISO8601DateTime'];
  /** description of the post */
  description?: Maybe<Scalars['String']>;
  endsAt?: Maybe<Scalars['ISO8601DateTime']>;
  eventOn: Scalars['ISO8601Date'];
  group?: Maybe<PostsGroup>;
  /** identifiers of the post */
  id: Scalars['Int'];
  location?: Maybe<Scalars['String']>;
  mentionedAccessIds: Array<Scalars['Int']>;
  newReactions: Array<PostsAggregatedReaction>;
  /**
   * group identifier of the post, references to posts/groups endpoint
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  postsGroupId?: Maybe<Scalars['Int']>;
  /** date when the post has been published */
  publishedAt: Scalars['ISO8601DateTime'];
  reactions: Array<PostsReaction>;
  reactionsConnection: PostsReactionConnection;
  reactionsCount: Scalars['Int'];
  savedAttachments: Array<ApiCoreAttachment>;
  savedAttachmentsConnection: ApiCoreAttachmentConnection;
  sendNotifications: Scalars['Boolean'];
  startsAt?: Maybe<Scalars['ISO8601DateTime']>;
  target?: Maybe<ApiCoreAccess>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  targetId?: Maybe<Scalars['Int']>;
  targetName?: Maybe<Scalars['String']>;
  /** title of the post */
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  /** date when the post has been updated */
  updatedAt: Scalars['ISO8601DateTime'];
  visits: Array<PostsVisit>;
  visitsConnection: PostsVisitConnection;
  /** number of visits of the post */
  visitsCount: Scalars['Int'];
  workiversaryCount?: Maybe<Scalars['Int']>;
};


/** Posts post */
export type PostsPost_PoliciesCollectionArgs = {
  ids: Array<PostsPostPoliciesEnum>;
};


/** Posts post */
export type PostsPost_PoliciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Posts post */
export type PostsPostAuthorArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** Posts post */
export type PostsPostCommentsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Posts post */
export type PostsPostCommentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Posts post */
export type PostsPostGroupArgs = {
  isMember?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};


/** Posts post */
export type PostsPostReactionsArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
};


/** Posts post */
export type PostsPostReactionsConnectionArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Posts post */
export type PostsPostSavedAttachmentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Posts post */
export type PostsPostTargetArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** Posts post */
export type PostsPostVisitsArgs = {
  from?: InputMaybe<Scalars['ISO8601Date']>;
  to?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Posts post */
export type PostsPostVisitsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['ISO8601Date']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  to?: InputMaybe<Scalars['ISO8601Date']>;
};

/** The connection type for PostsPost. */
export type PostsPostConnection = {
  __typename?: 'PostsPostConnection';
  /** A list of edges. */
  edges: Array<PostsPostEdge>;
  /** A list of nodes. */
  nodes: Array<PostsPost>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PostsPostEdge = {
  __typename?: 'PostsPostEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PostsPost;
};

/** the filter for the posts resource */
export type PostsPostFilter = {
  or?: InputMaybe<Array<PostsPostFilterConditions>>;
  publishedAt?: InputMaybe<DateTimeFilter>;
  startsAt?: InputMaybe<DateTimeFilter>;
  type?: InputMaybe<StringFilter>;
};

export type PostsPostFilterConditions = {
  publishedAt?: InputMaybe<DateTimeFilter>;
  startsAt?: InputMaybe<DateTimeFilter>;
  type?: InputMaybe<StringFilter>;
};

export type PostsPostPolicies = {
  __typename?: 'PostsPostPolicies';
  manage: PermissionsPolicyResolution;
};

export type PostsPostPoliciesEnum =
  | 'manage';

/** Posts reaction */
export type PostsReaction = {
  __typename?: 'PostsReaction';
  author?: Maybe<ApiCoreAccess>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  authorId: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['Int'];
  post?: Maybe<PostsPost>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  postId: Scalars['Int'];
  textCode: Scalars['String'];
};


/** Posts reaction */
export type PostsReactionAuthorArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** Posts reaction */
export type PostsReactionPostArgs = {
  from?: InputMaybe<Scalars['ISO8601Date']>;
  groups?: InputMaybe<Array<Scalars['Int']>>;
  id?: InputMaybe<Scalars['Int']>;
  isMobile?: InputMaybe<Scalars['Boolean']>;
  noPagination?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  postsPerPage?: InputMaybe<Scalars['Int']>;
  publishedAt?: InputMaybe<Scalars['ISO8601Date']>;
  scheduledPosts?: InputMaybe<Scalars['Boolean']>;
  startsFrom?: InputMaybe<Scalars['ISO8601Date']>;
  startsUntil?: InputMaybe<Scalars['ISO8601Date']>;
  truncateDescription?: InputMaybe<Scalars['Boolean']>;
  types?: InputMaybe<Array<Scalars['String']>>;
  until?: InputMaybe<Scalars['ISO8601Date']>;
  withCoverImage?: InputMaybe<Scalars['Boolean']>;
  withReactions?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for PostsReaction. */
export type PostsReactionConnection = {
  __typename?: 'PostsReactionConnection';
  /** A list of edges. */
  edges: Array<PostsReactionEdge>;
  /** A list of nodes. */
  nodes: Array<PostsReaction>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PostsReactionEdge = {
  __typename?: 'PostsReactionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PostsReaction;
};

export type PostsSupporter = {
  __typename?: 'PostsSupporter';
  accessId: Scalars['Int'];
  fullName: Scalars['String'];
  id: Scalars['Int'];
};

/** Posts visit */
export type PostsVisit = {
  __typename?: 'PostsVisit';
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  accessId: Scalars['Int'];
  author?: Maybe<ApiCoreAccess>;
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['Int'];
  post: PostsPost;
  postId: Scalars['Int'];
};


/** Posts visit */
export type PostsVisitAuthorArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** Posts visit */
export type PostsVisitPostArgs = {
  from?: InputMaybe<Scalars['ISO8601Date']>;
  groups?: InputMaybe<Array<Scalars['Int']>>;
  id?: InputMaybe<Scalars['Int']>;
  isMobile?: InputMaybe<Scalars['Boolean']>;
  noPagination?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  postsPerPage?: InputMaybe<Scalars['Int']>;
  publishedAt?: InputMaybe<Scalars['ISO8601Date']>;
  scheduledPosts?: InputMaybe<Scalars['Boolean']>;
  startsFrom?: InputMaybe<Scalars['ISO8601Date']>;
  startsUntil?: InputMaybe<Scalars['ISO8601Date']>;
  truncateDescription?: InputMaybe<Scalars['Boolean']>;
  types?: InputMaybe<Array<Scalars['String']>>;
  until?: InputMaybe<Scalars['ISO8601Date']>;
  withCoverImage?: InputMaybe<Scalars['Boolean']>;
  withReactions?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for PostsVisit. */
export type PostsVisitConnection = {
  __typename?: 'PostsVisitConnection';
  /** A list of edges. */
  edges: Array<PostsVisitEdge>;
  /** A list of nodes. */
  nodes: Array<PostsVisit>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PostsVisitEdge = {
  __typename?: 'PostsVisitEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PostsVisit;
};

/** Autogenerated return type of PreviewAtsJobPosting. */
export type PreviewAtsJobPostingPayload = {
  __typename?: 'PreviewAtsJobPostingPayload';
  errors: Array<MutationError>;
  jobPosting?: Maybe<AtsJobPosting>;
};

/** Autogenerated return type of PreviewDocumentsTemplate. */
export type PreviewDocumentsTemplatePayload = {
  __typename?: 'PreviewDocumentsTemplatePayload';
  errors: Array<MutationError>;
  template?: Maybe<DocumentsTemplate>;
};

export type PreviewFinanceFinancialDocumentPreviewLineItemsInput = {
  amountCents?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Float']>;
  taxRateId?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of PreviewFinanceFinancialDocumentPreview. */
export type PreviewFinanceFinancialDocumentPreviewPayload = {
  __typename?: 'PreviewFinanceFinancialDocumentPreviewPayload';
  errors: Array<MutationError>;
  financialDocumentPreview?: Maybe<FinanceFinancialDocumentPreview>;
};

export type PreviewFinanceQuotePreviewLineItemsInput = {
  amountCents?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Float']>;
  taxRateId?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of PreviewFinanceQuotePreview. */
export type PreviewFinanceQuotePreviewPayload = {
  __typename?: 'PreviewFinanceQuotePreviewPayload';
  errors: Array<MutationError>;
  quotePreview?: Maybe<FinanceQuotePreview>;
};

/** Autogenerated return type of PreviewProjectmanagementimporterProjectsImport. */
export type PreviewProjectmanagementimporterProjectsImportPayload = {
  __typename?: 'PreviewProjectmanagementimporterProjectsImportPayload';
  errors: Array<MutationError>;
  projectsImport?: Maybe<ProjectManagementImporterProjectsImport>;
};

/** Autogenerated return type of PreviewVariablesDocumentsTemplate. */
export type PreviewVariablesDocumentsTemplatePayload = {
  __typename?: 'PreviewVariablesDocumentsTemplatePayload';
  errors: Array<MutationError>;
  template?: Maybe<DocumentsTemplate>;
};

/** Autogenerated return type of ProcessAtsUpsell. */
export type ProcessAtsUpsellPayload = {
  __typename?: 'ProcessAtsUpsellPayload';
  errors: Array<MutationError>;
  upsell?: Maybe<AtsUpsell>;
};

/** Autogenerated return type of ProcessContentTrainingsTraining. */
export type ProcessContentTrainingsTrainingPayload = {
  __typename?: 'ProcessContentTrainingsTrainingPayload';
  errors: Array<MutationError>;
  training?: Maybe<TrainingsTraining>;
};

/** Autogenerated return type of ProcessIntegrationsdatevlaudsEmployeeImport. */
export type ProcessIntegrationsdatevlaudsEmployeeImportPayload = {
  __typename?: 'ProcessIntegrationsdatevlaudsEmployeeImportPayload';
  employeeImport?: Maybe<IntegrationsDatevLaudsEmployeeImport>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of ProcessIntegrationsdatevlaudsRequest. */
export type ProcessIntegrationsdatevlaudsRequestPayload = {
  __typename?: 'ProcessIntegrationsdatevlaudsRequestPayload';
  errors: Array<MutationError>;
  request?: Maybe<IntegrationsDatevLaudsRequest>;
};

/** Autogenerated return type of ProcessOpenaiEnhancedText. */
export type ProcessOpenaiEnhancedTextPayload = {
  __typename?: 'ProcessOpenaiEnhancedTextPayload';
  enhancedText?: Maybe<OpenAiEnhancedText>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of ProcessedDocumentsCountDocumentsUploadProcess. */
export type ProcessedDocumentsCountDocumentsUploadProcessPayload = {
  __typename?: 'ProcessedDocumentsCountDocumentsUploadProcessPayload';
  errors: Array<MutationError>;
  uploadProcess?: Maybe<DocumentsUploadProcess>;
};

/** Autogenerated return type of ProcessedProjectmanagementRate. */
export type ProcessedProjectmanagementRatePayload = {
  __typename?: 'ProcessedProjectmanagementRatePayload';
  errors: Array<MutationError>;
  rate?: Maybe<ProjectManagementRate>;
};

/** Processes action-type item configuration */
export type ProcessesAction = {
  __typename?: 'ProcessesAction';
  actionConfiguration?: Maybe<ProcessesActionConfiguration>;
  configuration: Scalars['String'];
  configurationIdentifier: Scalars['String'];
  files: Array<ApiCoreAttachment>;
  filesConnection: ApiCoreAttachmentConnection;
  id: Scalars['Int'];
  item?: Maybe<ProcessesItem>;
  title?: Maybe<Scalars['String']>;
};


/** Processes action-type item configuration */
export type ProcessesActionActionConfigurationArgs = {
  processCategory?: InputMaybe<Scalars['String']>;
};


/** Processes action-type item configuration */
export type ProcessesActionFilesArgs = {
  attachmentName?: InputMaybe<Scalars['String']>;
};


/** Processes action-type item configuration */
export type ProcessesActionFilesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  attachmentName?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Processes action-type item configuration */
export type ProcessesActionItemArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  stepIds?: InputMaybe<Array<Scalars['Int']>>;
};

/** Processes action configuarations templates */
export type ProcessesActionConfiguration = {
  __typename?: 'ProcessesActionConfiguration';
  description: Scalars['String'];
  enabled: Scalars['Boolean'];
  id: Scalars['String'];
  identifier: Scalars['String'];
  includeAssignees: Scalars['Boolean'];
  includeFiles: Scalars['Boolean'];
  title: Scalars['String'];
};

/** The connection type for ProcessesActionConfiguration. */
export type ProcessesActionConfigurationConnection = {
  __typename?: 'ProcessesActionConfigurationConnection';
  /** A list of edges. */
  edges: Array<ProcessesActionConfigurationEdge>;
  /** A list of nodes. */
  nodes: Array<ProcessesActionConfiguration>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProcessesActionConfigurationEdge = {
  __typename?: 'ProcessesActionConfigurationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProcessesActionConfiguration;
};

/** The connection type for ProcessesAction. */
export type ProcessesActionConnection = {
  __typename?: 'ProcessesActionConnection';
  /** A list of edges. */
  edges: Array<ProcessesActionEdge>;
  /** A list of nodes. */
  nodes: Array<ProcessesAction>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProcessesActionEdge = {
  __typename?: 'ProcessesActionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProcessesAction;
};

export type ProcessesCategoryInput = {
  __typename?: 'ProcessesCategoryInput';
  label: Scalars['String'];
  resource: ProcessesConfigurationFieldsResourceTypeEnum;
  value: Scalars['String'];
};

export type ProcessesConfigurationFieldsResourceTypeEnum =
  | 'contract'
  | 'employee';

export type ProcessesContextlessPolicies = {
  __typename?: 'ProcessesContextlessPolicies';
  processEditProcesses: ContextlessPolicyResolution;
  sidebarSeeProcessesCustomSubLevelItem: ContextlessPolicyResolution;
  sidebarSeeProcessesOffboardingSubLevelItem: ContextlessPolicyResolution;
  sidebarSeeProcessesOnboardingSubLevelItem: ContextlessPolicyResolution;
  sidebarSeeProcessesTopLevelItem: ContextlessPolicyResolution;
};

export type ProcessesDataCollectionConfigurationInput = {
  uploadBankCertificate?: InputMaybe<Scalars['Boolean']>;
  uploadIdCertificate?: InputMaybe<Scalars['Boolean']>;
  uploadSocialSecurityCertificate?: InputMaybe<Scalars['Boolean']>;
};

export type ProcessesInputFieldInput = {
  createdAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  dataType: Scalars['String'];
  key: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  value: Scalars['String'];
};

/** item */
export type ProcessesItem = {
  __typename?: 'ProcessesItem';
  action?: Maybe<ProcessesAction>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  configurationId?: Maybe<Scalars['Int']>;
  configurationType?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  itemAssignee?: Maybe<ProcessesItemAssignee>;
  materializedItems: Array<ProcessesMaterializedItem>;
  materializedItemsConnection: ProcessesMaterializedItemConnection;
  position: Scalars['Int'];
  step: ProcessesStep;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  stepId?: Maybe<Scalars['Int']>;
  taskConfiguration?: Maybe<ProcessesTaskConfiguration>;
};


/** item */
export type ProcessesItemActionArgs = {
  configuration?: InputMaybe<Scalars['String']>;
};


/** item */
export type ProcessesItemMaterializedItemsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  materializedStepIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceIds?: InputMaybe<Array<Scalars['Int']>>;
  taskIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** item */
export type ProcessesItemMaterializedItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  materializedStepIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  resourceIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
  taskIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** item */
export type ProcessesItemStepArgs = {
  processIds?: InputMaybe<Array<Scalars['Int']>>;
};

/** Processes item assignee */
export type ProcessesItemAssignee = {
  __typename?: 'ProcessesItemAssignee';
  assigneeIds: Array<Scalars['Int']>;
  assigneeStrategy: Scalars['String'];
  id: Scalars['Int'];
  itemId: Scalars['Int'];
  peopleGroupId?: Maybe<Scalars['Int']>;
};

/** The connection type for ProcessesItemAssignee. */
export type ProcessesItemAssigneeConnection = {
  __typename?: 'ProcessesItemAssigneeConnection';
  /** A list of edges. */
  edges: Array<ProcessesItemAssigneeEdge>;
  /** A list of nodes. */
  nodes: Array<ProcessesItemAssignee>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProcessesItemAssigneeEdge = {
  __typename?: 'ProcessesItemAssigneeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProcessesItemAssignee;
};

/** The connection type for ProcessesItem. */
export type ProcessesItemConnection = {
  __typename?: 'ProcessesItemConnection';
  /** A list of edges. */
  edges: Array<ProcessesItemEdge>;
  /** A list of nodes. */
  nodes: Array<ProcessesItem>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProcessesItemEdge = {
  __typename?: 'ProcessesItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProcessesItem;
};

export type ProcessesItemObject = {
  __typename?: 'ProcessesItemObject';
  actionConfiguration?: Maybe<Scalars['String']>;
  actionConfigurationIdentifier?: Maybe<Scalars['String']>;
  assigneeIds?: Maybe<Array<Scalars['Int']>>;
  assigneeStrategy?: Maybe<Scalars['String']>;
  configurationType: Scalars['String'];
  feature?: Maybe<Scalars['String']>;
  instruction: Scalars['String'];
  mandatory: Scalars['Boolean'];
  offsetAmount?: Maybe<Scalars['Int']>;
  offsetDirection?: Maybe<Scalars['String']>;
  position: Scalars['Int'];
  referenceFieldKey?: Maybe<Scalars['String']>;
  taskType?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

/** Processes action-type item configuration */
export type ProcessesMaterializedAction = {
  __typename?: 'ProcessesMaterializedAction';
  completedAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['Int'];
  materializedItem?: Maybe<ProcessesMaterializedItem>;
  reason?: Maybe<Scalars['String']>;
  status: ProcessesValueObjectsMaterializedActionStatusEnum;
};


/** Processes action-type item configuration */
export type ProcessesMaterializedActionMaterializedItemArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  itemIds?: InputMaybe<Array<Scalars['Int']>>;
  materializedStepIds?: InputMaybe<Array<Scalars['Int']>>;
  taskIds?: InputMaybe<Array<Scalars['Int']>>;
};

/** The connection type for ProcessesMaterializedAction. */
export type ProcessesMaterializedActionConnection = {
  __typename?: 'ProcessesMaterializedActionConnection';
  /** A list of edges. */
  edges: Array<ProcessesMaterializedActionEdge>;
  /** A list of nodes. */
  nodes: Array<ProcessesMaterializedAction>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProcessesMaterializedActionEdge = {
  __typename?: 'ProcessesMaterializedActionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProcessesMaterializedAction;
};

/** Processes materialized assignee */
export type ProcessesMaterializedAssignee = {
  __typename?: 'ProcessesMaterializedAssignee';
  accessId: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  finalizedAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['Int'];
  materializedItemId: Scalars['Int'];
  status: Scalars['String'];
};

/** The connection type for ProcessesMaterializedAssignee. */
export type ProcessesMaterializedAssigneeConnection = {
  __typename?: 'ProcessesMaterializedAssigneeConnection';
  /** A list of edges. */
  edges: Array<ProcessesMaterializedAssigneeEdge>;
  /** A list of nodes. */
  nodes: Array<ProcessesMaterializedAssignee>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProcessesMaterializedAssigneeEdge = {
  __typename?: 'ProcessesMaterializedAssigneeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProcessesMaterializedAssignee;
};

export type ProcessesMaterializedAssigneeStatusEnum =
  | 'completed'
  | 'pending';

/** materialized item */
export type ProcessesMaterializedItem = {
  __typename?: 'ProcessesMaterializedItem';
  actionIdentifier?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  dueOn?: Maybe<Scalars['ISO8601Date']>;
  finalizedAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['Int'];
  item?: Maybe<ProcessesItem>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  itemId?: Maybe<Scalars['Int']>;
  materializedAction?: Maybe<ProcessesMaterializedAction>;
  materializedAssignees: Array<ProcessesMaterializedAssignee>;
  materializedAssigneesConnection: ProcessesMaterializedAssigneeConnection;
  materializedStep?: Maybe<ProcessesMaterializedStep>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  materializedStepId?: Maybe<Scalars['Int']>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  resourceId?: Maybe<Scalars['Int']>;
  resourceType?: Maybe<Scalars['String']>;
  snapshotConfigurationId?: Maybe<Scalars['Int']>;
  snapshotConfigurationType?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};


/** materialized item */
export type ProcessesMaterializedItemItemArgs = {
  configurationIds?: InputMaybe<Array<Scalars['Int']>>;
  stepIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** materialized item */
export type ProcessesMaterializedItemMaterializedAssigneesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** materialized item */
export type ProcessesMaterializedItemMaterializedStepArgs = {
  materializedProcessIds?: InputMaybe<Array<Scalars['Int']>>;
  stepIds?: InputMaybe<Array<Scalars['Int']>>;
};

/** The connection type for ProcessesMaterializedItem. */
export type ProcessesMaterializedItemConnection = {
  __typename?: 'ProcessesMaterializedItemConnection';
  /** A list of edges. */
  edges: Array<ProcessesMaterializedItemEdge>;
  /** A list of nodes. */
  nodes: Array<ProcessesMaterializedItem>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProcessesMaterializedItemEdge = {
  __typename?: 'ProcessesMaterializedItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProcessesMaterializedItem;
};

/** materialized process */
export type ProcessesMaterializedProcess = {
  __typename?: 'ProcessesMaterializedProcess';
  completedResources?: Maybe<Scalars['Int']>;
  contractEndsOn?: Maybe<Scalars['ISO8601Date']>;
  contractStartsOn?: Maybe<Scalars['ISO8601Date']>;
  finalizedAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['Int'];
  materializedSteps: Array<ProcessesMaterializedStep>;
  materializedStepsConnection: ProcessesMaterializedStepConnection;
  name: Scalars['String'];
  nextItemDueDate?: Maybe<Scalars['ISO8601Date']>;
  ongoingStepId: Scalars['Int'];
  process: ProcessesProcess;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  processId: Scalars['Int'];
  resourceRelationships: Array<ProcessesResourceRelationship>;
  resourceRelationshipsConnection: ProcessesResourceRelationshipConnection;
  status: Scalars['String'];
  totalResources?: Maybe<Scalars['Int']>;
  trainingName?: Maybe<Scalars['String']>;
};


/** materialized process */
export type ProcessesMaterializedProcessMaterializedStepsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  stepIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** materialized process */
export type ProcessesMaterializedProcessMaterializedStepsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  stepIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** materialized process */
export type ProcessesMaterializedProcessProcessArgs = {
  categories?: InputMaybe<Array<ProcessesProcessCategoryEnum>>;
  name?: InputMaybe<Scalars['String']>;
  templateIds?: InputMaybe<Array<Scalars['Int']>>;
  validate?: InputMaybe<Scalars['Boolean']>;
};


/** materialized process */
export type ProcessesMaterializedProcessResourceRelationshipsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  resourceIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceTypes?: InputMaybe<Array<Scalars['String']>>;
};


/** materialized process */
export type ProcessesMaterializedProcessResourceRelationshipsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  resourceIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceTypes?: InputMaybe<Array<Scalars['String']>>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for ProcessesMaterializedProcess. */
export type ProcessesMaterializedProcessConnection = {
  __typename?: 'ProcessesMaterializedProcessConnection';
  /** A list of edges. */
  edges: Array<ProcessesMaterializedProcessEdge>;
  /** A list of nodes. */
  nodes: Array<ProcessesMaterializedProcess>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProcessesMaterializedProcessEdge = {
  __typename?: 'ProcessesMaterializedProcessEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProcessesMaterializedProcess;
};

/** the filter for the materialized_processes resource */
export type ProcessesMaterializedProcessFilter = {
  id?: InputMaybe<IntegerFilter>;
  name?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<ProcessesMaterializedProcessFilterConditions>>;
  status?: InputMaybe<StringFilter>;
};

export type ProcessesMaterializedProcessFilterConditions = {
  id?: InputMaybe<IntegerFilter>;
  name?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
};

export type ProcessesMaterializedProcessStatusEnum =
  | 'archived'
  | 'finalized'
  | 'running';

/** materialized step */
export type ProcessesMaterializedStep = {
  __typename?: 'ProcessesMaterializedStep';
  active?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['ISO8601DateTime'];
  finalizedAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['Int'];
  materializationSnapshot?: Maybe<ProcessesStepMaterializationSnapshot>;
  materializedById?: Maybe<Scalars['Int']>;
  materializedItems: Array<ProcessesMaterializedItem>;
  materializedItemsConnection: ProcessesMaterializedItemConnection;
  materializedProcess: ProcessesMaterializedProcess;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  materializedProcessId: Scalars['Int'];
  name: Scalars['String'];
  status: Scalars['String'];
  step: ProcessesStep;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  stepId?: Maybe<Scalars['Int']>;
};


/** materialized step */
export type ProcessesMaterializedStepMaterializedItemsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  itemIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceIds?: InputMaybe<Array<Scalars['Int']>>;
  taskIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** materialized step */
export type ProcessesMaterializedStepMaterializedItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  itemIds?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  resourceIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
  taskIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** materialized step */
export type ProcessesMaterializedStepMaterializedProcessArgs = {
  includeItemsCount?: InputMaybe<Scalars['Boolean']>;
  itemResources?: InputMaybe<Scalars['String']>;
  materializedTasksAccessId?: InputMaybe<Scalars['Int']>;
  processId?: InputMaybe<Scalars['Int']>;
  processIds?: InputMaybe<Array<Scalars['Int']>>;
  resources?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  withPendingMandatoryTasks?: InputMaybe<Scalars['Boolean']>;
};


/** materialized step */
export type ProcessesMaterializedStepStepArgs = {
  processIds?: InputMaybe<Array<Scalars['Int']>>;
};

/** The connection type for ProcessesMaterializedStep. */
export type ProcessesMaterializedStepConnection = {
  __typename?: 'ProcessesMaterializedStepConnection';
  /** A list of edges. */
  edges: Array<ProcessesMaterializedStepEdge>;
  /** A list of nodes. */
  nodes: Array<ProcessesMaterializedStep>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProcessesMaterializedStepEdge = {
  __typename?: 'ProcessesMaterializedStepEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProcessesMaterializedStep;
};

export type ProcessesMaterializedStepStatusEnum =
  | 'completed'
  | 'running';

/** Processes process */
export type ProcessesProcess = {
  __typename?: 'ProcessesProcess';
  category?: Maybe<ProcessesProcessCategoryEnum>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  materializedProcesses: Array<ProcessesMaterializedProcess>;
  materializedProcessesConnection: ProcessesMaterializedProcessConnection;
  name: Scalars['String'];
  steps: Array<ProcessesStep>;
  stepsConnection: ProcessesStepConnection;
  template?: Maybe<ProcessesTemplate>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  templateId?: Maybe<Scalars['String']>;
  validSettings?: Maybe<Scalars['Boolean']>;
  validationMessage?: Maybe<Scalars['String']>;
};


/** Processes process */
export type ProcessesProcessMaterializedProcessesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeItemsCount?: InputMaybe<Scalars['Boolean']>;
  itemResources?: InputMaybe<Scalars['String']>;
  materializedTasksAccessId?: InputMaybe<Scalars['Int']>;
  processId?: InputMaybe<Scalars['Int']>;
  resources?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  withPendingMandatoryTasks?: InputMaybe<Scalars['Boolean']>;
};


/** Processes process */
export type ProcessesProcessMaterializedProcessesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeItemsCount?: InputMaybe<Scalars['Boolean']>;
  itemResources?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  materializedTasksAccessId?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  processId?: InputMaybe<Scalars['Int']>;
  resources?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  status?: InputMaybe<Scalars['String']>;
  withPendingMandatoryTasks?: InputMaybe<Scalars['Boolean']>;
};


/** Processes process */
export type ProcessesProcessStepsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Processes process */
export type ProcessesProcessStepsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Processes process */
export type ProcessesProcessTemplateArgs = {
  category?: InputMaybe<Scalars['String']>;
  includeHidden?: InputMaybe<Scalars['Boolean']>;
  showInHomepage?: InputMaybe<Scalars['Boolean']>;
};

export type ProcessesProcessCategoryEnum =
  | 'custom'
  | 'offboarding'
  | 'onboarding'
  | 'training';

/** The connection type for ProcessesProcess. */
export type ProcessesProcessConnection = {
  __typename?: 'ProcessesProcessConnection';
  /** A list of edges. */
  edges: Array<ProcessesProcessEdge>;
  /** A list of nodes. */
  nodes: Array<ProcessesProcess>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProcessesProcessEdge = {
  __typename?: 'ProcessesProcessEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProcessesProcess;
};

export type ProcessesProcessInputField = {
  __typename?: 'ProcessesProcessInputField';
  custom: Scalars['Boolean'];
  dataType?: Maybe<ProcessesValueObjectsDataTypeEnum>;
  default: Scalars['Boolean'];
  defaultValue: Scalars['String'];
  identifier: Scalars['Boolean'];
  key: Scalars['String'];
  label: Scalars['String'];
  mandatory: Scalars['Boolean'];
};

export type ProcessesResourceInput = {
  resourceId: Scalars['Int'];
  resourceType?: InputMaybe<Scalars['String']>;
};

/** resource relationship */
export type ProcessesResourceRelationship = {
  __typename?: 'ProcessesResourceRelationship';
  access?: Maybe<ApiCoreAccess>;
  id: Scalars['Int'];
  materializedProcess: ProcessesMaterializedProcess;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  materializedProcessId: Scalars['Int'];
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  resourceId: Scalars['Int'];
  resourceType: Scalars['String'];
};


/** resource relationship */
export type ProcessesResourceRelationshipAccessArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** resource relationship */
export type ProcessesResourceRelationshipMaterializedProcessArgs = {
  includeItemsCount?: InputMaybe<Scalars['Boolean']>;
  itemResources?: InputMaybe<Scalars['String']>;
  materializedTasksAccessId?: InputMaybe<Scalars['Int']>;
  processId?: InputMaybe<Scalars['Int']>;
  processIds?: InputMaybe<Array<Scalars['Int']>>;
  resources?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  withPendingMandatoryTasks?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for ProcessesResourceRelationship. */
export type ProcessesResourceRelationshipConnection = {
  __typename?: 'ProcessesResourceRelationshipConnection';
  /** A list of edges. */
  edges: Array<ProcessesResourceRelationshipEdge>;
  /** A list of nodes. */
  nodes: Array<ProcessesResourceRelationship>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProcessesResourceRelationshipEdge = {
  __typename?: 'ProcessesResourceRelationshipEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProcessesResourceRelationship;
};

/** Processes start step */
export type ProcessesStartStep = {
  __typename?: 'ProcessesStartStep';
  materializedStepIds: Array<Scalars['Int']>;
};

/** steps */
export type ProcessesStep = {
  __typename?: 'ProcessesStep';
  createdAt: Scalars['ISO8601DateTime'];
  id?: Maybe<Scalars['Int']>;
  items: Array<ProcessesItem>;
  itemsConnection: ProcessesItemConnection;
  materializedSteps: Array<ProcessesMaterializedStep>;
  materializedStepsConnection: ProcessesMaterializedStepConnection;
  name: Scalars['String'];
  offsetAmount?: Maybe<Scalars['Int']>;
  offsetDirection?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  process: ProcessesProcess;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  processId: Scalars['Int'];
  progressionCondition?: Maybe<Scalars['String']>;
  progressionConditionResourceKey?: Maybe<Scalars['String']>;
};


/** steps */
export type ProcessesStepItemsArgs = {
  configurationIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** steps */
export type ProcessesStepItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  configurationIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** steps */
export type ProcessesStepMaterializedStepsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  materializedProcessIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** steps */
export type ProcessesStepMaterializedStepsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  materializedProcessIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** steps */
export type ProcessesStepProcessArgs = {
  categories?: InputMaybe<Array<ProcessesProcessCategoryEnum>>;
  name?: InputMaybe<Scalars['String']>;
  templateIds?: InputMaybe<Array<Scalars['Int']>>;
  validate?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for ProcessesStep. */
export type ProcessesStepConnection = {
  __typename?: 'ProcessesStepConnection';
  /** A list of edges. */
  edges: Array<ProcessesStepEdge>;
  /** A list of nodes. */
  nodes: Array<ProcessesStep>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProcessesStepEdge = {
  __typename?: 'ProcessesStepEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProcessesStep;
};

/** Processes step materialization date */
export type ProcessesStepMaterializationDate = {
  __typename?: 'ProcessesStepMaterializationDate';
  materializationDate: Scalars['ISO8601Date'];
  materializationSnapshot?: Maybe<ProcessesStepMaterializationSnapshot>;
  stepId: Scalars['Int'];
  timezone?: Maybe<Scalars['String']>;
};

/** The connection type for ProcessesStepMaterializationDate. */
export type ProcessesStepMaterializationDateConnection = {
  __typename?: 'ProcessesStepMaterializationDateConnection';
  /** A list of edges. */
  edges: Array<ProcessesStepMaterializationDateEdge>;
  /** A list of nodes. */
  nodes: Array<ProcessesStepMaterializationDate>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProcessesStepMaterializationDateEdge = {
  __typename?: 'ProcessesStepMaterializationDateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProcessesStepMaterializationDate;
};

export type ProcessesStepMaterializationSnapshot = {
  __typename?: 'ProcessesStepMaterializationSnapshot';
  stepProgressionCondition?: Maybe<Scalars['String']>;
  stepProgressionConditionResourceKey?: Maybe<Scalars['String']>;
  stepProgressionConditionResourceValue?: Maybe<Scalars['String']>;
};

export type ProcessesStepMaterializationSnapshotInput = {
  stepProgressionCondition?: InputMaybe<Scalars['String']>;
  stepProgressionConditionResourceKey?: InputMaybe<Scalars['String']>;
  stepProgressionConditionResourceValue?: InputMaybe<Scalars['String']>;
};

export type ProcessesStepObject = {
  __typename?: 'ProcessesStepObject';
  items: Array<ProcessesItemObject>;
  name: Scalars['String'];
  offsetAmount?: Maybe<Scalars['Int']>;
  offsetDirection?: Maybe<Scalars['String']>;
  position: Scalars['Int'];
  progressionCondition?: Maybe<Scalars['String']>;
  progressionConditionResourceKey?: Maybe<Scalars['String']>;
};

/** Processes task configuraiton */
export type ProcessesTaskConfiguration = {
  __typename?: 'ProcessesTaskConfiguration';
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  configurationId?: Maybe<Scalars['Int']>;
  configurationType?: Maybe<Scalars['String']>;
  dataConfiguration?: Maybe<ProcessesTaskTypeConfigurationDataCollection>;
  documentConfiguration?: Maybe<ProcessesTaskTypeConfigurationDocument>;
  documentTemplateId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  instruction?: Maybe<Scalars['String']>;
  item?: Maybe<ProcessesItem>;
  mandatory?: Maybe<Scalars['Boolean']>;
  offsetAmount?: Maybe<Scalars['Int']>;
  offsetDirection?: Maybe<Scalars['String']>;
  referenceFieldKey?: Maybe<Scalars['String']>;
  taskType?: Maybe<Scalars['String']>;
  taskTypeConfiguration?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};


/** Processes task configuraiton */
export type ProcessesTaskConfigurationDataConfigurationArgs = {
  id?: InputMaybe<Scalars['Int']>;
};


/** Processes task configuraiton */
export type ProcessesTaskConfigurationDocumentConfigurationArgs = {
  id?: InputMaybe<Scalars['Int']>;
};


/** Processes task configuraiton */
export type ProcessesTaskConfigurationItemArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  stepIds?: InputMaybe<Array<Scalars['Int']>>;
};

/** The connection type for ProcessesTaskConfiguration. */
export type ProcessesTaskConfigurationConnection = {
  __typename?: 'ProcessesTaskConfigurationConnection';
  /** A list of edges. */
  edges: Array<ProcessesTaskConfigurationEdge>;
  /** A list of nodes. */
  nodes: Array<ProcessesTaskConfiguration>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProcessesTaskConfigurationEdge = {
  __typename?: 'ProcessesTaskConfigurationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProcessesTaskConfiguration;
};

/** Processes task configuration file */
export type ProcessesTaskConfigurationFile = {
  __typename?: 'ProcessesTaskConfigurationFile';
  contentType?: Maybe<Scalars['String']>;
  filename: Scalars['String'];
  id: Scalars['Int'];
  path: Scalars['String'];
  taskConfigurationId: Scalars['Int'];
};

/** The connection type for ProcessesTaskConfigurationFile. */
export type ProcessesTaskConfigurationFileConnection = {
  __typename?: 'ProcessesTaskConfigurationFileConnection';
  /** A list of edges. */
  edges: Array<ProcessesTaskConfigurationFileEdge>;
  /** A list of nodes. */
  nodes: Array<ProcessesTaskConfigurationFile>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProcessesTaskConfigurationFileEdge = {
  __typename?: 'ProcessesTaskConfigurationFileEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProcessesTaskConfigurationFile;
};

/** Processes task configuration send document template */
export type ProcessesTaskConfigurationSendDocumentTemplate = {
  __typename?: 'ProcessesTaskConfigurationSendDocumentTemplate';
  documentTemplateId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
};

/** The connection type for ProcessesTaskConfigurationSendDocumentTemplate. */
export type ProcessesTaskConfigurationSendDocumentTemplateConnection = {
  __typename?: 'ProcessesTaskConfigurationSendDocumentTemplateConnection';
  /** A list of edges. */
  edges: Array<ProcessesTaskConfigurationSendDocumentTemplateEdge>;
  /** A list of nodes. */
  nodes: Array<ProcessesTaskConfigurationSendDocumentTemplate>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProcessesTaskConfigurationSendDocumentTemplateEdge = {
  __typename?: 'ProcessesTaskConfigurationSendDocumentTemplateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProcessesTaskConfigurationSendDocumentTemplate;
};

/** Processes task configuration setting */
export type ProcessesTaskConfigurationSetting = {
  __typename?: 'ProcessesTaskConfigurationSetting';
  referenceFieldKeys: Array<Scalars['String']>;
};

/** The connection type for ProcessesTaskConfigurationSetting. */
export type ProcessesTaskConfigurationSettingConnection = {
  __typename?: 'ProcessesTaskConfigurationSettingConnection';
  /** A list of edges. */
  edges: Array<ProcessesTaskConfigurationSettingEdge>;
  /** A list of nodes. */
  nodes: Array<ProcessesTaskConfigurationSetting>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProcessesTaskConfigurationSettingEdge = {
  __typename?: 'ProcessesTaskConfigurationSettingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProcessesTaskConfigurationSetting;
};

/** Processes task configuration signature document */
export type ProcessesTaskConfigurationSignatureDocument = {
  __typename?: 'ProcessesTaskConfigurationSignatureDocument';
  contentType?: Maybe<Scalars['String']>;
  filename: Scalars['String'];
  id: Scalars['Int'];
  path: Scalars['String'];
  taskConfigurationId: Scalars['Int'];
};

/** The connection type for ProcessesTaskConfigurationSignatureDocument. */
export type ProcessesTaskConfigurationSignatureDocumentConnection = {
  __typename?: 'ProcessesTaskConfigurationSignatureDocumentConnection';
  /** A list of edges. */
  edges: Array<ProcessesTaskConfigurationSignatureDocumentEdge>;
  /** A list of nodes. */
  nodes: Array<ProcessesTaskConfigurationSignatureDocument>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProcessesTaskConfigurationSignatureDocumentEdge = {
  __typename?: 'ProcessesTaskConfigurationSignatureDocumentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProcessesTaskConfigurationSignatureDocument;
};

/** Processes task type configuration data collection */
export type ProcessesTaskTypeConfigurationDataCollection = {
  __typename?: 'ProcessesTaskTypeConfigurationDataCollection';
  id: Scalars['Int'];
  resource: Scalars['String'];
  resources: Array<ProcessesTaskTypeConfigurationDataCollectionResource>;
  resourcesConnection: ProcessesTaskTypeConfigurationDataCollectionResourceConnection;
  taskConfiguration?: Maybe<ProcessesTaskConfiguration>;
};


/** Processes task type configuration data collection */
export type ProcessesTaskTypeConfigurationDataCollectionResourcesArgs = {
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Processes task type configuration data collection */
export type ProcessesTaskTypeConfigurationDataCollectionResourcesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** Processes task type configuration data collection resources */
export type ProcessesTaskTypeConfigurationDataCollectionResource = {
  __typename?: 'ProcessesTaskTypeConfigurationDataCollectionResource';
  category: Scalars['String'];
  id: Scalars['Int'];
  resources: Array<ProcessesTaskTypeConfigurationResource>;
  resourcesConnection: ProcessesTaskTypeConfigurationResourceConnection;
  source?: Maybe<ProcessesTaskTypeConfigurationDataCollection>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  sourceId: Scalars['Int'];
};


/** Processes task type configuration data collection resources */
export type ProcessesTaskTypeConfigurationDataCollectionResourceResourcesArgs = {
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Processes task type configuration data collection resources */
export type ProcessesTaskTypeConfigurationDataCollectionResourceResourcesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Processes task type configuration data collection resources */
export type ProcessesTaskTypeConfigurationDataCollectionResourceSourceArgs = {
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};

/** The connection type for ProcessesTaskTypeConfigurationDataCollectionResource. */
export type ProcessesTaskTypeConfigurationDataCollectionResourceConnection = {
  __typename?: 'ProcessesTaskTypeConfigurationDataCollectionResourceConnection';
  /** A list of edges. */
  edges: Array<ProcessesTaskTypeConfigurationDataCollectionResourceEdge>;
  /** A list of nodes. */
  nodes: Array<ProcessesTaskTypeConfigurationDataCollectionResource>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProcessesTaskTypeConfigurationDataCollectionResourceEdge = {
  __typename?: 'ProcessesTaskTypeConfigurationDataCollectionResourceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProcessesTaskTypeConfigurationDataCollectionResource;
};

/** Processes task type configuration document */
export type ProcessesTaskTypeConfigurationDocument = {
  __typename?: 'ProcessesTaskTypeConfigurationDocument';
  id: Scalars['Int'];
  requestEsignature?: Maybe<Scalars['Boolean']>;
  resources: Array<ProcessesTaskTypeConfigurationResource>;
  resourcesConnection: ProcessesTaskTypeConfigurationResourceConnection;
  taskConfiguration?: Maybe<ProcessesTaskConfiguration>;
};


/** Processes task type configuration document */
export type ProcessesTaskTypeConfigurationDocumentResourcesArgs = {
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Processes task type configuration document */
export type ProcessesTaskTypeConfigurationDocumentResourcesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for ProcessesTaskTypeConfigurationDocument. */
export type ProcessesTaskTypeConfigurationDocumentConnection = {
  __typename?: 'ProcessesTaskTypeConfigurationDocumentConnection';
  /** A list of edges. */
  edges: Array<ProcessesTaskTypeConfigurationDocumentEdge>;
  /** A list of nodes. */
  nodes: Array<ProcessesTaskTypeConfigurationDocument>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProcessesTaskTypeConfigurationDocumentEdge = {
  __typename?: 'ProcessesTaskTypeConfigurationDocumentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProcessesTaskTypeConfigurationDocument;
};

/** Processes task type configuration resources */
export type ProcessesTaskTypeConfigurationResource = {
  __typename?: 'ProcessesTaskTypeConfigurationResource';
  configResourceType: Scalars['String'];
  dataCollection?: Maybe<ProcessesTaskTypeConfigurationDataCollectionResource>;
  document: Array<ProcessesTaskTypeConfigurationDocument>;
  documentConnection: ProcessesTaskTypeConfigurationDocumentConnection;
  id: Scalars['Int'];
  resourceId: Scalars['Int'];
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  sourceId: Scalars['Int'];
};


/** Processes task type configuration resources */
export type ProcessesTaskTypeConfigurationResourceDataCollectionArgs = {
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Processes task type configuration resources */
export type ProcessesTaskTypeConfigurationResourceDocumentArgs = {
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Processes task type configuration resources */
export type ProcessesTaskTypeConfigurationResourceDocumentConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for ProcessesTaskTypeConfigurationResource. */
export type ProcessesTaskTypeConfigurationResourceConnection = {
  __typename?: 'ProcessesTaskTypeConfigurationResourceConnection';
  /** A list of edges. */
  edges: Array<ProcessesTaskTypeConfigurationResourceEdge>;
  /** A list of nodes. */
  nodes: Array<ProcessesTaskTypeConfigurationResource>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProcessesTaskTypeConfigurationResourceEdge = {
  __typename?: 'ProcessesTaskTypeConfigurationResourceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProcessesTaskTypeConfigurationResource;
};

/** Processes template */
export type ProcessesTemplate = {
  __typename?: 'ProcessesTemplate';
  category: ProcessesProcessCategoryEnum;
  dataCollectionInputCategoriesObjects: Array<ProcessesCategoryInput>;
  description: Scalars['String'];
  hidden: Scalars['Boolean'];
  id: Scalars['String'];
  name: Scalars['String'];
  new: Scalars['Boolean'];
  orderedVisibleFields: Array<Scalars['String']>;
  processInputFieldObjects: Array<ProcessesProcessInputField>;
  showInHomepage: Scalars['Boolean'];
  stepObjects: Array<ProcessesStepObject>;
};

/** The connection type for ProcessesTemplate. */
export type ProcessesTemplateConnection = {
  __typename?: 'ProcessesTemplateConnection';
  /** A list of edges. */
  edges: Array<ProcessesTemplateEdge>;
  /** A list of nodes. */
  nodes: Array<ProcessesTemplate>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProcessesTemplateEdge = {
  __typename?: 'ProcessesTemplateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProcessesTemplate;
};

export type ProcessesValueObjectsDataTypeEnum =
  | 'date'
  | 'string';

export type ProcessesValueObjectsMaterializedActionStatusEnum =
  | 'completed'
  | 'failed'
  | 'inprogress';

/** Represents a timeline of a procurement flow */
export type ProcurementApprovalsTimeline = {
  __typename?: 'ProcurementApprovalsTimeline';
  entries: Array<ApprovalsV2ApprovalTimelineEntry>;
  purchaseRequestId: Scalars['Int'];
};

/** The connection type for ProcurementApprovalsTimeline. */
export type ProcurementApprovalsTimelineConnection = {
  __typename?: 'ProcurementApprovalsTimelineConnection';
  /** A list of edges. */
  edges: Array<ProcurementApprovalsTimelineEdge>;
  /** A list of nodes. */
  nodes: Array<ProcurementApprovalsTimeline>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProcurementApprovalsTimelineEdge = {
  __typename?: 'ProcurementApprovalsTimelineEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProcurementApprovalsTimeline;
};

export type ProcurementContextlessPolicies = {
  __typename?: 'ProcurementContextlessPolicies';
  featuresPurchaseOrders: ContextlessPolicyResolution;
  featuresPurchaseRequests: ContextlessPolicyResolution;
  purchaseOrderManage: ContextlessPolicyResolution;
  purchaseOrderRead: ContextlessPolicyResolution;
  purchaseRequestCreate: ContextlessPolicyResolution;
  purchaseRequestManage: ContextlessPolicyResolution;
  purchaseRequestManageSettings: ContextlessPolicyResolution;
  purchaseRequestRead: ContextlessPolicyResolution;
  settingsManage: ContextlessPolicyResolution;
  settingsSeeProcurementSettings: ContextlessPolicyResolution;
  sidebarSeeMyExpensesPurchaseRequestSubLevelItem: ContextlessPolicyResolution;
};

/** Eligible assignees for workflow tasks and approvals */
export type ProcurementEligibleWorkflowsAssignee = {
  __typename?: 'ProcurementEligibleWorkflowsAssignee';
  accessId: Scalars['Int'];
  avatar?: Maybe<ApiCoreAttachment>;
  avatarId?: Maybe<Scalars['Int']>;
  companyId: Scalars['Int'];
  defaultLocation?: Maybe<LocationsLocation>;
  employeeGroupId?: Maybe<Scalars['Int']>;
  firstName: Scalars['String'];
  fullName: Scalars['String'];
  id: Scalars['Int'];
  lastName: Scalars['String'];
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  locationId: Scalars['Int'];
  managerId?: Maybe<Scalars['Int']>;
  preferredName?: Maybe<Scalars['String']>;
  teamMemberships: Array<TeamsMembership>;
  teamMembershipsConnection: TeamsMembershipConnection;
};


/** Eligible assignees for workflow tasks and approvals */
export type ProcurementEligibleWorkflowsAssigneeAvatarArgs = {
  attachmentName?: InputMaybe<Scalars['String']>;
};


/** Eligible assignees for workflow tasks and approvals */
export type ProcurementEligibleWorkflowsAssigneeDefaultLocationArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  main?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};


/** Eligible assignees for workflow tasks and approvals */
export type ProcurementEligibleWorkflowsAssigneeTeamMembershipsArgs = {
  activeEmployees?: Scalars['Boolean'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  lead?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  sortByLeads?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Eligible assignees for workflow tasks and approvals */
export type ProcurementEligibleWorkflowsAssigneeTeamMembershipsConnectionArgs = {
  activeEmployees?: Scalars['Boolean'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  lead?: InputMaybe<Scalars['Boolean']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortByLeads?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Sort>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
};

/** The connection type for ProcurementEligibleWorkflowsAssignee. */
export type ProcurementEligibleWorkflowsAssigneeConnection = {
  __typename?: 'ProcurementEligibleWorkflowsAssigneeConnection';
  /** A list of edges. */
  edges: Array<ProcurementEligibleWorkflowsAssigneeEdge>;
  /** A list of nodes. */
  nodes: Array<ProcurementEligibleWorkflowsAssignee>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProcurementEligibleWorkflowsAssigneeEdge = {
  __typename?: 'ProcurementEligibleWorkflowsAssigneeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProcurementEligibleWorkflowsAssignee;
};

export type ProcurementFile = {
  __typename?: 'ProcurementFile';
  byteSize: Scalars['Int'];
  contentType: Scalars['String'];
  filename: Scalars['String'];
  id: Scalars['Int'];
  url: Scalars['String'];
};

/** purchase_order */
export type ProcurementPurchaseOrder = {
  __typename?: 'ProcurementPurchaseOrder';
  /** Amount in cents (use for aggregations) */
  amount: Scalars['Float'];
  card?: Maybe<BankingCard>;
  /**
   * Identifier of the banking card associated with this purchase order, if any
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  cardId?: Maybe<Scalars['Int']>;
  company: ApiCoreCompany;
  /**
   * Identifier of the company that owns this purchase order
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  companyId: Scalars['Int'];
  /** Total cost of the purchase order */
  cost: BigMoney;
  /** Date when the purchase order was created */
  date: Scalars['ISO8601Date'];
  /** Deadline date for the purchase order delivery or completion */
  deadline?: Maybe<Scalars['ISO8601Date']>;
  /** Description or notes about the purchase order */
  description: Scalars['String'];
  financialDocumentAssociation: Array<FinanceFinancialDocumentAssociation>;
  financialDocumentAssociationConnection: FinanceFinancialDocumentAssociationConnection;
  /** Formatted purchase order number with prefix (e.g., PO-00001) */
  formattedPoNumber: Scalars['String'];
  /** Unique identifier of the purchase order */
  id: Scalars['Int'];
  legalEntity: CompaniesLegalEntity;
  /**
   * Identifier of the legal entity that owns this purchase order
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  legalEntityId: Scalars['Int'];
  /** Purchase order number assigned to this order */
  poNumber: Scalars['Int'];
  /** Preferred payment method for this purchase order */
  preferredPaymentMethod?: Maybe<ProcurementValueObjectsPreferredPaymentMethodEnum>;
  purchaseRequest?: Maybe<ProcurementPurchaseRequest>;
  /**
   * Identifier of the purchase request that generated this purchase order
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  purchaseRequestId: Scalars['Int'];
  /** Current status of the purchase order */
  status: ProcurementValueObjectsPurchaseOrderStatusEnum;
  vendor?: Maybe<FinanceContact>;
  /**
   * Identifier of the vendor (contact) associated with this purchase order
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  vendorId?: Maybe<Scalars['Int']>;
};


/** purchase_order */
export type ProcurementPurchaseOrderCardArgs = {
  bankAccountIds?: InputMaybe<Array<Scalars['Int']>>;
  cardholderIds?: InputMaybe<Array<Scalars['Int']>>;
  creationSource?: InputMaybe<BankingValueObjectsCardCreationSourceEnum>;
  last4?: InputMaybe<Scalars['String']>;
  ownerIds?: InputMaybe<Array<Scalars['Int']>>;
  requestedWithoutApprovalFlow?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<BankingValueObjectsCardStatusEnum>;
};


/** purchase_order */
export type ProcurementPurchaseOrderFinancialDocumentAssociationArgs = {
  financialDocumentIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** purchase_order */
export type ProcurementPurchaseOrderFinancialDocumentAssociationConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  financialDocumentIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** purchase_order */
export type ProcurementPurchaseOrderLegalEntityArgs = {
  companiesIds?: InputMaybe<Array<Scalars['Int']>>;
  countryIds?: InputMaybe<Array<Scalars['String']>>;
  employeesIds?: InputMaybe<Array<Scalars['Int']>>;
  excludeCountries?: InputMaybe<Array<Scalars['String']>>;
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


/** purchase_order */
export type ProcurementPurchaseOrderPurchaseRequestArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  currencies?: InputMaybe<Array<Scalars['String']>>;
  onTime?: InputMaybe<Scalars['Boolean']>;
  onlyMyPendingApprovals?: InputMaybe<Scalars['Boolean']>;
  overdue?: InputMaybe<Scalars['Boolean']>;
  requesterEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ProcurementValueObjectsPurchaseRequestStatusEnum>;
  typeIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** purchase_order */
export type ProcurementPurchaseOrderVendorArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  contactType?: InputMaybe<FinanceValueObjectsContactTypeEnum>;
  email?: InputMaybe<Scalars['String']>;
  legalName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  taxIdType?: InputMaybe<Scalars['String']>;
  taxIds?: InputMaybe<Array<Scalars['String']>>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
  website?: InputMaybe<Scalars['String']>;
};

/** The connection type for ProcurementPurchaseOrder. */
export type ProcurementPurchaseOrderConnection = {
  __typename?: 'ProcurementPurchaseOrderConnection';
  aggregate?: Maybe<ProcurementPurchaseOrdersAggregate>;
  /** A list of edges. */
  edges: Array<ProcurementPurchaseOrderEdge>;
  /** A list of nodes. */
  nodes: Array<ProcurementPurchaseOrder>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProcurementPurchaseOrderEdge = {
  __typename?: 'ProcurementPurchaseOrderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProcurementPurchaseOrder;
};

/** the filter for the purchase_orders resource */
export type ProcurementPurchaseOrderFilter = {
  amount?: InputMaybe<NumberFilter>;
  date?: InputMaybe<DateFilter>;
  deadline?: InputMaybe<DateFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntegerFilter>;
  legalEntityId?: InputMaybe<IntegerFilter>;
  or?: InputMaybe<Array<ProcurementPurchaseOrderFilterConditions>>;
  poNumber?: InputMaybe<IntegerFilter>;
  purchaseRequestId?: InputMaybe<IntegerFilter>;
  status?: InputMaybe<StringFilter>;
  vendorId?: InputMaybe<IntegerFilter>;
};

export type ProcurementPurchaseOrderFilterConditions = {
  amount?: InputMaybe<NumberFilter>;
  date?: InputMaybe<DateFilter>;
  deadline?: InputMaybe<DateFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntegerFilter>;
  legalEntityId?: InputMaybe<IntegerFilter>;
  poNumber?: InputMaybe<IntegerFilter>;
  purchaseRequestId?: InputMaybe<IntegerFilter>;
  status?: InputMaybe<StringFilter>;
  vendorId?: InputMaybe<IntegerFilter>;
};

/** Procurement purchase_orders aggregates */
export type ProcurementPurchaseOrdersAggregate = {
  __typename?: 'ProcurementPurchaseOrdersAggregate';
  average?: Maybe<ProcurementPurchaseOrdersConnectionAggregateAverage>;
  count?: Maybe<Scalars['Int']>;
  maximum?: Maybe<ProcurementPurchaseOrdersConnectionAggregateMaximum>;
  minimum?: Maybe<ProcurementPurchaseOrdersConnectionAggregateMinimum>;
  sum?: Maybe<ProcurementPurchaseOrdersConnectionAggregateSum>;
  terms?: Maybe<ProcurementPurchaseOrdersConnectionAggregateTerms>;
};

export type ProcurementPurchaseOrdersAggregateTerms = {
  __typename?: 'ProcurementPurchaseOrdersAggregateTerms';
  average?: Maybe<ProcurementPurchaseOrdersConnectionAggregateTermsAverageFields>;
  count?: Maybe<Array<Scalars['Int']>>;
  maximum?: Maybe<ProcurementPurchaseOrdersConnectionAggregateTermsMaximumFields>;
  minimum?: Maybe<ProcurementPurchaseOrdersConnectionAggregateTermsMinimumFields>;
  sum?: Maybe<ProcurementPurchaseOrdersConnectionAggregateTermsSumFields>;
  values: Array<Scalars['String']>;
};

/** average function */
export type ProcurementPurchaseOrdersConnectionAggregateAverage = {
  __typename?: 'ProcurementPurchaseOrdersConnectionAggregateAverage';
  amount?: Maybe<Scalars['Float']>;
  poNumber?: Maybe<Scalars['Float']>;
};

/** maximum function */
export type ProcurementPurchaseOrdersConnectionAggregateMaximum = {
  __typename?: 'ProcurementPurchaseOrdersConnectionAggregateMaximum';
  amount?: Maybe<Scalars['Int']>;
  poNumber?: Maybe<Scalars['Int']>;
};

/** minimum function */
export type ProcurementPurchaseOrdersConnectionAggregateMinimum = {
  __typename?: 'ProcurementPurchaseOrdersConnectionAggregateMinimum';
  amount?: Maybe<Scalars['Int']>;
  poNumber?: Maybe<Scalars['Int']>;
};

/** sum function */
export type ProcurementPurchaseOrdersConnectionAggregateSum = {
  __typename?: 'ProcurementPurchaseOrdersConnectionAggregateSum';
  amount?: Maybe<Scalars['Int']>;
  poNumber?: Maybe<Scalars['Int']>;
};

/** terms function */
export type ProcurementPurchaseOrdersConnectionAggregateTerms = {
  __typename?: 'ProcurementPurchaseOrdersConnectionAggregateTerms';
  amount?: Maybe<ProcurementPurchaseOrdersAggregateTerms>;
  date?: Maybe<ProcurementPurchaseOrdersAggregateTerms>;
  deadline?: Maybe<ProcurementPurchaseOrdersAggregateTerms>;
  description?: Maybe<ProcurementPurchaseOrdersAggregateTerms>;
  legalEntityId?: Maybe<ProcurementPurchaseOrdersAggregateTerms>;
  poNumber?: Maybe<ProcurementPurchaseOrdersAggregateTerms>;
  purchaseRequestId?: Maybe<ProcurementPurchaseOrdersAggregateTerms>;
  status?: Maybe<ProcurementPurchaseOrdersAggregateTerms>;
  vendorId?: Maybe<ProcurementPurchaseOrdersAggregateTerms>;
};

/** average function */
export type ProcurementPurchaseOrdersConnectionAggregateTermsAverageFields = {
  __typename?: 'ProcurementPurchaseOrdersConnectionAggregateTermsAVERAGEFields';
  amount?: Maybe<Array<Scalars['Float']>>;
  poNumber?: Maybe<Array<Scalars['Float']>>;
};

/** maximum function */
export type ProcurementPurchaseOrdersConnectionAggregateTermsMaximumFields = {
  __typename?: 'ProcurementPurchaseOrdersConnectionAggregateTermsMAXIMUMFields';
  amount?: Maybe<Array<Scalars['Int']>>;
  poNumber?: Maybe<Array<Scalars['Int']>>;
};

/** minimum function */
export type ProcurementPurchaseOrdersConnectionAggregateTermsMinimumFields = {
  __typename?: 'ProcurementPurchaseOrdersConnectionAggregateTermsMINIMUMFields';
  amount?: Maybe<Array<Scalars['Int']>>;
  poNumber?: Maybe<Array<Scalars['Int']>>;
};

/** sum function */
export type ProcurementPurchaseOrdersConnectionAggregateTermsSumFields = {
  __typename?: 'ProcurementPurchaseOrdersConnectionAggregateTermsSUMFields';
  amount?: Maybe<Array<Scalars['Int']>>;
  poNumber?: Maybe<Array<Scalars['Int']>>;
};

/** purchase_request */
export type ProcurementPurchaseRequest = {
  __typename?: 'ProcurementPurchaseRequest';
  /** Additional information or notes about the purchase request */
  additionalInformation?: Maybe<Scalars['String']>;
  /** Amount in cents (deprecated, use cost.cents instead) */
  amount: Scalars['Float'];
  approval?: Maybe<ApprovalsMaterializedApprovalsFlow>;
  approvalProcess?: Maybe<ApprovalsV2ApprovalProcess>;
  comments: Array<CommentsComment>;
  commentsConnection: CommentsCommentConnection;
  company: ApiCoreCompany;
  /**
   * Identifier of the company that owns this purchase request
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  companyId?: Maybe<Scalars['Int']>;
  /** Total cost of the purchase request */
  cost: BigMoney;
  /** Date when the purchase request was created */
  date: Scalars['ISO8601Date'];
  /** Deadline date for the purchase request */
  deadline?: Maybe<Scalars['ISO8601Date']>;
  /** Description or notes about the purchase request */
  description: Scalars['String'];
  /** Array of files attached to the purchase request */
  files: Array<ProcurementFile>;
  formsMembership?: Maybe<FormsMembership>;
  /**
   * Identifier of the forms membership associated with this purchase request
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  formsMembershipId?: Maybe<Scalars['Int']>;
  /** Unique identifier of the purchase request */
  id: Scalars['Int'];
  purchaseOrder?: Maybe<ProcurementPurchaseOrder>;
  /** Reason for rejection if the purchase request was rejected */
  rejectionReason?: Maybe<Scalars['String']>;
  requesterEmployee?: Maybe<EmployeesEmployee>;
  /**
   * Identifier of the employee who requested this purchase
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  requesterEmployeeId: Scalars['Int'];
  /** Current status of the purchase request */
  status: ProcurementValueObjectsPurchaseRequestStatusEnum;
  type?: Maybe<ProcurementType>;
  /**
   * The id of the referred type
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  typeId: Scalars['Int'];
  uploadDocumentTask: Array<ProcurementUploadDocumentTask>;
  uploadDocumentTaskConnection: ProcurementUploadDocumentTaskConnection;
  /** URL related to the purchase request (e.g., product link) */
  url?: Maybe<Scalars['String']>;
  vendor?: Maybe<FinanceContact>;
  /**
   * Identifier of the vendor (contact) associated with this purchase request
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  vendorId?: Maybe<Scalars['Int']>;
};


/** purchase_request */
export type ProcurementPurchaseRequestApprovalArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  ownerId?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<ApprovalsMaterializedApprovalFlowStatusEnum>;
};


/** purchase_request */
export type ProcurementPurchaseRequestApprovalProcessArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  decision?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  requesterId?: InputMaybe<Scalars['Int']>;
  useCase?: InputMaybe<Scalars['String']>;
};


/** purchase_request */
export type ProcurementPurchaseRequestCommentsArgs = {
  companyId: Scalars['Int'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  upToAndIncluding?: InputMaybe<Scalars['Int']>;
};


/** purchase_request */
export type ProcurementPurchaseRequestCommentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  upToAndIncluding?: InputMaybe<Scalars['Int']>;
};


/** purchase_request */
export type ProcurementPurchaseRequestFormsMembershipArgs = {
  cycleIds?: InputMaybe<Array<Scalars['String']>>;
  formId?: InputMaybe<Scalars['String']>;
  formType?: InputMaybe<Array<Scalars['String']>>;
  hasAnswers?: InputMaybe<Scalars['Boolean']>;
  jobRoles?: InputMaybe<Array<Scalars['Int']>>;
  jobTitles?: InputMaybe<Array<Scalars['String']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  materializedFormIds?: InputMaybe<Array<Scalars['String']>>;
  resourceType?: InputMaybe<Scalars['String']>;
  respondentId?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  searchByFormTitle?: InputMaybe<Scalars['String']>;
  targetId?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  trainingId?: InputMaybe<Scalars['String']>;
};


/** purchase_request */
export type ProcurementPurchaseRequestPurchaseOrderArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  currencies?: InputMaybe<Array<Scalars['String']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ProcurementValueObjectsPurchaseOrderStatusEnum>;
  vendorId?: InputMaybe<Scalars['Int']>;
};


/** purchase_request */
export type ProcurementPurchaseRequestRequesterEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** purchase_request */
export type ProcurementPurchaseRequestTypeArgs = {
  authorIds?: InputMaybe<Array<Scalars['Int']>>;
  companyId?: InputMaybe<Scalars['Int']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  includeSystemAuthor?: InputMaybe<Scalars['Boolean']>;
};


/** purchase_request */
export type ProcurementPurchaseRequestUploadDocumentTaskArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  taskType?: InputMaybe<ProcurementValueObjectsUploadDocumentTaskTypeEnum>;
};


/** purchase_request */
export type ProcurementPurchaseRequestUploadDocumentTaskConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  taskType?: InputMaybe<ProcurementValueObjectsUploadDocumentTaskTypeEnum>;
};


/** purchase_request */
export type ProcurementPurchaseRequestVendorArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  contactType?: InputMaybe<FinanceValueObjectsContactTypeEnum>;
  email?: InputMaybe<Scalars['String']>;
  legalName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  taxIdType?: InputMaybe<Scalars['String']>;
  taxIds?: InputMaybe<Array<Scalars['String']>>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
  website?: InputMaybe<Scalars['String']>;
};

/** The connection type for ProcurementPurchaseRequest. */
export type ProcurementPurchaseRequestConnection = {
  __typename?: 'ProcurementPurchaseRequestConnection';
  aggregate?: Maybe<ProcurementPurchaseRequestsAggregate>;
  /** A list of edges. */
  edges: Array<ProcurementPurchaseRequestEdge>;
  /** A list of nodes. */
  nodes: Array<ProcurementPurchaseRequest>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProcurementPurchaseRequestEdge = {
  __typename?: 'ProcurementPurchaseRequestEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProcurementPurchaseRequest;
};

/** the filter for the purchase_requests resource */
export type ProcurementPurchaseRequestFilter = {
  additionalInformation?: InputMaybe<StringFilter>;
  amount?: InputMaybe<NumberFilter>;
  approversEmployeesIds?: InputMaybe<IntegerFilter>;
  companyId?: InputMaybe<IntegerFilter>;
  date?: InputMaybe<DateFilter>;
  deadline?: InputMaybe<DateFilter>;
  description?: InputMaybe<StringFilter>;
  files?: InputMaybe<StringFilter>;
  formsMembershipId?: InputMaybe<IntegerFilter>;
  id?: InputMaybe<IntegerFilter>;
  or?: InputMaybe<Array<ProcurementPurchaseRequestFilterConditions>>;
  rejectionReason?: InputMaybe<StringFilter>;
  requesterEmployeeId?: InputMaybe<IntegerFilter>;
  status?: InputMaybe<StringFilter>;
  typeId?: InputMaybe<IntegerFilter>;
  url?: InputMaybe<StringFilter>;
  vendorId?: InputMaybe<IntegerFilter>;
};

export type ProcurementPurchaseRequestFilterConditions = {
  additionalInformation?: InputMaybe<StringFilter>;
  amount?: InputMaybe<NumberFilter>;
  approversEmployeesIds?: InputMaybe<IntegerFilter>;
  companyId?: InputMaybe<IntegerFilter>;
  date?: InputMaybe<DateFilter>;
  deadline?: InputMaybe<DateFilter>;
  description?: InputMaybe<StringFilter>;
  files?: InputMaybe<StringFilter>;
  formsMembershipId?: InputMaybe<IntegerFilter>;
  id?: InputMaybe<IntegerFilter>;
  rejectionReason?: InputMaybe<StringFilter>;
  requesterEmployeeId?: InputMaybe<IntegerFilter>;
  status?: InputMaybe<StringFilter>;
  typeId?: InputMaybe<IntegerFilter>;
  url?: InputMaybe<StringFilter>;
  vendorId?: InputMaybe<IntegerFilter>;
};

/** Procurement purchase_requests aggregates */
export type ProcurementPurchaseRequestsAggregate = {
  __typename?: 'ProcurementPurchaseRequestsAggregate';
  average?: Maybe<ProcurementPurchaseRequestsConnectionAggregateAverage>;
  count?: Maybe<Scalars['Int']>;
  maximum?: Maybe<ProcurementPurchaseRequestsConnectionAggregateMaximum>;
  minimum?: Maybe<ProcurementPurchaseRequestsConnectionAggregateMinimum>;
  sum?: Maybe<ProcurementPurchaseRequestsConnectionAggregateSum>;
  terms?: Maybe<ProcurementPurchaseRequestsConnectionAggregateTerms>;
};

export type ProcurementPurchaseRequestsAggregateTerms = {
  __typename?: 'ProcurementPurchaseRequestsAggregateTerms';
  average?: Maybe<ProcurementPurchaseRequestsConnectionAggregateTermsAverageFields>;
  count?: Maybe<Array<Scalars['Int']>>;
  maximum?: Maybe<ProcurementPurchaseRequestsConnectionAggregateTermsMaximumFields>;
  minimum?: Maybe<ProcurementPurchaseRequestsConnectionAggregateTermsMinimumFields>;
  sum?: Maybe<ProcurementPurchaseRequestsConnectionAggregateTermsSumFields>;
  values: Array<Scalars['String']>;
};

/** average function */
export type ProcurementPurchaseRequestsConnectionAggregateAverage = {
  __typename?: 'ProcurementPurchaseRequestsConnectionAggregateAverage';
  amount?: Maybe<Scalars['Float']>;
};

/** maximum function */
export type ProcurementPurchaseRequestsConnectionAggregateMaximum = {
  __typename?: 'ProcurementPurchaseRequestsConnectionAggregateMaximum';
  amount?: Maybe<Scalars['Int']>;
};

/** minimum function */
export type ProcurementPurchaseRequestsConnectionAggregateMinimum = {
  __typename?: 'ProcurementPurchaseRequestsConnectionAggregateMinimum';
  amount?: Maybe<Scalars['Int']>;
};

/** sum function */
export type ProcurementPurchaseRequestsConnectionAggregateSum = {
  __typename?: 'ProcurementPurchaseRequestsConnectionAggregateSum';
  amount?: Maybe<Scalars['Int']>;
};

/** terms function */
export type ProcurementPurchaseRequestsConnectionAggregateTerms = {
  __typename?: 'ProcurementPurchaseRequestsConnectionAggregateTerms';
  additionalInformation?: Maybe<ProcurementPurchaseRequestsAggregateTerms>;
  amount?: Maybe<ProcurementPurchaseRequestsAggregateTerms>;
  companyId?: Maybe<ProcurementPurchaseRequestsAggregateTerms>;
  date?: Maybe<ProcurementPurchaseRequestsAggregateTerms>;
  deadline?: Maybe<ProcurementPurchaseRequestsAggregateTerms>;
  description?: Maybe<ProcurementPurchaseRequestsAggregateTerms>;
  files?: Maybe<ProcurementPurchaseRequestsAggregateTerms>;
  formsMembershipId?: Maybe<ProcurementPurchaseRequestsAggregateTerms>;
  rejectionReason?: Maybe<ProcurementPurchaseRequestsAggregateTerms>;
  requesterEmployeeId?: Maybe<ProcurementPurchaseRequestsAggregateTerms>;
  status?: Maybe<ProcurementPurchaseRequestsAggregateTerms>;
  typeId?: Maybe<ProcurementPurchaseRequestsAggregateTerms>;
  url?: Maybe<ProcurementPurchaseRequestsAggregateTerms>;
  vendorId?: Maybe<ProcurementPurchaseRequestsAggregateTerms>;
};

/** average function */
export type ProcurementPurchaseRequestsConnectionAggregateTermsAverageFields = {
  __typename?: 'ProcurementPurchaseRequestsConnectionAggregateTermsAVERAGEFields';
  amount?: Maybe<Array<Scalars['Float']>>;
};

/** maximum function */
export type ProcurementPurchaseRequestsConnectionAggregateTermsMaximumFields = {
  __typename?: 'ProcurementPurchaseRequestsConnectionAggregateTermsMAXIMUMFields';
  amount?: Maybe<Array<Scalars['Int']>>;
};

/** minimum function */
export type ProcurementPurchaseRequestsConnectionAggregateTermsMinimumFields = {
  __typename?: 'ProcurementPurchaseRequestsConnectionAggregateTermsMINIMUMFields';
  amount?: Maybe<Array<Scalars['Int']>>;
};

/** sum function */
export type ProcurementPurchaseRequestsConnectionAggregateTermsSumFields = {
  __typename?: 'ProcurementPurchaseRequestsConnectionAggregateTermsSUMFields';
  amount?: Maybe<Array<Scalars['Int']>>;
};

/** type of purchase (e.g. software, training, etc.) */
export type ProcurementType = {
  __typename?: 'ProcurementType';
  author?: Maybe<EmployeesEmployeeName>;
  /**
   * Employee ID who created this type (null for system types)
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  authorId?: Maybe<Scalars['Int']>;
  company: ApiCoreCompany;
  /**
   * Identifier of the company that owns this type
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  companyId: Scalars['Int'];
  /** Time the procurement type was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** Description of the procurement type */
  description?: Maybe<Scalars['String']>;
  /** Defines if a type is enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  forms: Array<FormsForm>;
  formsConnection: FormsFormConnection;
  /** The id of the type */
  id: Scalars['Int'];
  /** System identifier for default types */
  identifier?: Maybe<Scalars['String']>;
  /** Name of the procurement type */
  name: Scalars['String'];
  purchaseRequests: Array<ProcurementPurchaseRequest>;
  purchaseRequestsConnection: ProcurementPurchaseRequestConnection;
  /** Time the procurement type was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
  /** Currency for workflow approval thresholds */
  workflowCurrency?: Maybe<Scalars['String']>;
  workflows: Array<WorkflowsWorkflow>;
  workflowsConnection: WorkflowsWorkflowConnection;
};


/** type of purchase (e.g. software, training, etc.) */
export type ProcurementTypeAuthorArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  afterEmployeeId?: InputMaybe<Scalars['Int']>;
  beforeEmployeeId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  reporteesOrLed?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyId?: InputMaybe<Scalars['Int']>;
  verb?: InputMaybe<Scalars['String']>;
  withActiveContract?: Scalars['Boolean'];
};


/** type of purchase (e.g. software, training, etc.) */
export type ProcurementTypeFormsArgs = {
  formType?: InputMaybe<Array<Scalars['String']>>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyTemplates?: InputMaybe<Scalars['Boolean']>;
  resourceId?: InputMaybe<Scalars['String']>;
  respondentId?: InputMaybe<Scalars['String']>;
  returnAnswerProgress?: Scalars['Boolean'];
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};


/** type of purchase (e.g. software, training, etc.) */
export type ProcurementTypeFormsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  formType?: InputMaybe<Array<Scalars['String']>>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyTemplates?: InputMaybe<Scalars['Boolean']>;
  resourceId?: InputMaybe<Scalars['String']>;
  respondentId?: InputMaybe<Scalars['String']>;
  returnAnswerProgress?: Scalars['Boolean'];
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  status?: InputMaybe<Scalars['String']>;
};


/** type of purchase (e.g. software, training, etc.) */
export type ProcurementTypePurchaseRequestsArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  currencies?: InputMaybe<Array<Scalars['String']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  onTime?: InputMaybe<Scalars['Boolean']>;
  onlyMyPendingApprovals?: InputMaybe<Scalars['Boolean']>;
  overdue?: InputMaybe<Scalars['Boolean']>;
  requesterEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ProcurementValueObjectsPurchaseRequestStatusEnum>;
};


/** type of purchase (e.g. software, training, etc.) */
export type ProcurementTypePurchaseRequestsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  currencies?: InputMaybe<Array<Scalars['String']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onTime?: InputMaybe<Scalars['Boolean']>;
  onlyMyPendingApprovals?: InputMaybe<Scalars['Boolean']>;
  overdue?: InputMaybe<Scalars['Boolean']>;
  requesterEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  status?: InputMaybe<ProcurementValueObjectsPurchaseRequestStatusEnum>;
};


/** type of purchase (e.g. software, training, etc.) */
export type ProcurementTypeWorkflowsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  companyId: Scalars['Int'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** type of purchase (e.g. software, training, etc.) */
export type ProcurementTypeWorkflowsConnectionArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for ProcurementType. */
export type ProcurementTypeConnection = {
  __typename?: 'ProcurementTypeConnection';
  /** A list of edges. */
  edges: Array<ProcurementTypeEdge>;
  /** A list of nodes. */
  nodes: Array<ProcurementType>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProcurementTypeEdge = {
  __typename?: 'ProcurementTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProcurementType;
};

/** the filter for the types resource */
export type ProcurementTypeFilter = {
  authorId?: InputMaybe<IntegerFilter>;
  companyId?: InputMaybe<IntegerFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringFilter>;
  enabled?: InputMaybe<BooleanFilter>;
  id?: InputMaybe<IntegerFilter>;
  identifier?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<ProcurementTypeFilterConditions>>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  workflowCurrency?: InputMaybe<StringFilter>;
};

export type ProcurementTypeFilterConditions = {
  authorId?: InputMaybe<IntegerFilter>;
  companyId?: InputMaybe<IntegerFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringFilter>;
  enabled?: InputMaybe<BooleanFilter>;
  id?: InputMaybe<IntegerFilter>;
  identifier?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  workflowCurrency?: InputMaybe<StringFilter>;
};

/** The task for uploading specific document to a purchase request */
export type ProcurementUploadDocumentTask = {
  __typename?: 'ProcurementUploadDocumentTask';
  companyId: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  files: Array<ProcurementFile>;
  id: Scalars['Int'];
  purchaseRequest: ProcurementPurchaseRequest;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  purchaseRequestId: Scalars['String'];
  taskAssigneeIds: Array<Scalars['Int']>;
  taskContent?: Maybe<Scalars['String']>;
  taskName?: Maybe<Scalars['String']>;
  taskStatus?: Maybe<Scalars['String']>;
  taskType: ProcurementValueObjectsUploadDocumentTaskTypeEnum;
  updatedAt: Scalars['ISO8601DateTime'];
  workflowsHandlerExecutionId: Scalars['String'];
};


/** The task for uploading specific document to a purchase request */
export type ProcurementUploadDocumentTaskPurchaseRequestArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  currencies?: InputMaybe<Array<Scalars['String']>>;
  onTime?: InputMaybe<Scalars['Boolean']>;
  onlyMyPendingApprovals?: InputMaybe<Scalars['Boolean']>;
  overdue?: InputMaybe<Scalars['Boolean']>;
  requesterEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ProcurementValueObjectsPurchaseRequestStatusEnum>;
  typeIds?: InputMaybe<Array<Scalars['Int']>>;
};

/** The connection type for ProcurementUploadDocumentTask. */
export type ProcurementUploadDocumentTaskConnection = {
  __typename?: 'ProcurementUploadDocumentTaskConnection';
  /** A list of edges. */
  edges: Array<ProcurementUploadDocumentTaskEdge>;
  /** A list of nodes. */
  nodes: Array<ProcurementUploadDocumentTask>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProcurementUploadDocumentTaskEdge = {
  __typename?: 'ProcurementUploadDocumentTaskEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProcurementUploadDocumentTask;
};

export type ProcurementValueObjectsPreferredPaymentMethodEnum =
  | 'banktransfer'
  | 'cash'
  | 'virtualcard';

export type ProcurementValueObjectsPurchaseOrderStatusEnum =
  | 'closed'
  | 'draft'
  | 'ordered'
  | 'partial'
  | 'pending'
  | 'received';

export type ProcurementValueObjectsPurchaseRequestStatusEnum =
  | 'approved'
  | 'changes_requested'
  | 'draft'
  | 'pending'
  | 'rejected';

export type ProcurementValueObjectsUploadDocumentTaskTypeEnum =
  | 'download'
  | 'upload';

export type ProductUpdatesContextlessPolicies = {
  __typename?: 'ProductUpdatesContextlessPolicies';
  seeWaitlistBanners: ContextlessPolicyResolution;
  shareProductUpdate: ContextlessPolicyResolution;
  sidebarSeeProductUpdatesSubLevelItem: ContextlessPolicyResolution;
  upsellButtonSeeUpsellButton: ContextlessPolicyResolution;
};

/** header views */
export type ProductUpdatesHeaderView = {
  __typename?: 'ProductUpdatesHeaderView';
  employeeId: Scalars['Int'];
  id: Scalars['Int'];
  lastViewDate: Scalars['ISO8601DateTime'];
  module: Scalars['String'];
};

/** The connection type for ProductUpdatesHeaderView. */
export type ProductUpdatesHeaderViewConnection = {
  __typename?: 'ProductUpdatesHeaderViewConnection';
  /** A list of edges. */
  edges: Array<ProductUpdatesHeaderViewEdge>;
  /** A list of nodes. */
  nodes: Array<ProductUpdatesHeaderView>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProductUpdatesHeaderViewEdge = {
  __typename?: 'ProductUpdatesHeaderViewEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProductUpdatesHeaderView;
};

export type ProductUpdatesIcon = {
  __typename?: 'ProductUpdatesIcon';
  url: Scalars['String'];
};

export type ProductUpdatesImage = {
  __typename?: 'ProductUpdatesImage';
  height: Scalars['Int'];
  src: Scalars['String'];
  width: Scalars['Int'];
};

export type ProductUpdatesMedia = {
  __typename?: 'ProductUpdatesMedia';
  height: Scalars['Int'];
  src?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  video?: Maybe<ProductUpdatesVideoInfo>;
  width: Scalars['Int'];
};

/** product tour */
export type ProductUpdatesProductTour = {
  __typename?: 'ProductUpdatesProductTour';
  associatedModuleId: Scalars['String'];
  description: Scalars['String'];
  helpCenterUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  intercomId: Scalars['Int'];
  title: Scalars['String'];
  tourGroup: Scalars['String'];
};

/** The connection type for ProductUpdatesProductTour. */
export type ProductUpdatesProductTourConnection = {
  __typename?: 'ProductUpdatesProductTourConnection';
  /** A list of edges. */
  edges: Array<ProductUpdatesProductTourEdge>;
  /** A list of nodes. */
  nodes: Array<ProductUpdatesProductTour>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProductUpdatesProductTourEdge = {
  __typename?: 'ProductUpdatesProductTourEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProductUpdatesProductTour;
};

export type ProductUpdatesProductUpdateEffectiveModule = {
  __typename?: 'ProductUpdatesProductUpdateEffectiveModule';
  chargebeeModuleId?: Maybe<Scalars['String']>;
  chargebeeModuleName?: Maybe<Scalars['String']>;
  discoverabilityTitle?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  shortDescription?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  thumbnailImage?: Maybe<ModulesImage>;
};

export type ProductUpdatesProductUpdateFeature = {
  __typename?: 'ProductUpdatesProductUpdateFeature';
  featureIdentifier: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export type ProductUpdatesProductUpdateModule = {
  __typename?: 'ProductUpdatesProductUpdateModule';
  effectiveModule1?: Maybe<ProductUpdatesProductUpdateEffectiveModule>;
  effectiveModule2?: Maybe<ProductUpdatesProductUpdateEffectiveModule>;
  effectiveModule3?: Maybe<ProductUpdatesProductUpdateEffectiveModule>;
  icon?: Maybe<ProductUpdatesIcon>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
  urlIdentifier: Scalars['String'];
};

/** shareable_employee */
export type ProductUpdatesShareableEmployee = {
  __typename?: 'ProductUpdatesShareableEmployee';
  avatar?: Maybe<Scalars['String']>;
  fullName: Scalars['String'];
  id: Scalars['Int'];
};

/** The connection type for ProductUpdatesShareableEmployee. */
export type ProductUpdatesShareableEmployeeConnection = {
  __typename?: 'ProductUpdatesShareableEmployeeConnection';
  /** A list of edges. */
  edges: Array<ProductUpdatesShareableEmployeeEdge>;
  /** A list of nodes. */
  nodes: Array<ProductUpdatesShareableEmployee>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProductUpdatesShareableEmployeeEdge = {
  __typename?: 'ProductUpdatesShareableEmployeeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProductUpdatesShareableEmployee;
};

/** shared_update */
export type ProductUpdatesSharedUpdate = {
  __typename?: 'ProductUpdatesSharedUpdate';
  message: Scalars['String'];
  receiverIds: Array<Scalars['Int']>;
  senderId: Scalars['Int'];
  slug: Scalars['String'];
};

/** subscription */
export type ProductUpdatesSubscription = {
  __typename?: 'ProductUpdatesSubscription';
  accessId: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['Int'];
  productUpdateId: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for ProductUpdatesSubscription. */
export type ProductUpdatesSubscriptionConnection = {
  __typename?: 'ProductUpdatesSubscriptionConnection';
  /** A list of edges. */
  edges: Array<ProductUpdatesSubscriptionEdge>;
  /** A list of nodes. */
  nodes: Array<ProductUpdatesSubscription>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProductUpdatesSubscriptionEdge = {
  __typename?: 'ProductUpdatesSubscriptionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProductUpdatesSubscription;
};

/** update */
export type ProductUpdatesUpdate = {
  __typename?: 'ProductUpdatesUpdate';
  actionLabel?: Maybe<Scalars['String']>;
  actionUrl?: Maybe<Scalars['String']>;
  authorName?: Maybe<Scalars['String']>;
  authorPosition?: Maybe<Scalars['String']>;
  autoplay?: Maybe<Scalars['Boolean']>;
  chargebeeModuleName?: Maybe<Scalars['String']>;
  externalUrl?: Maybe<Scalars['String']>;
  externalUrlLabel?: Maybe<Scalars['String']>;
  featureRelated?: Maybe<ProductUpdatesProductUpdateFeature>;
  featuredIn?: Maybe<Array<Scalars['String']>>;
  id: Scalars['String'];
  longDescription?: Maybe<Scalars['String']>;
  marketplaceSlug?: Maybe<Scalars['String']>;
  media?: Maybe<Array<ProductUpdatesMedia>>;
  navigationSlug?: Maybe<Scalars['String']>;
  productModule: ProductUpdatesProductUpdateModule;
  publishedAt?: Maybe<Scalars['ISO8601Date']>;
  releaseDate: Scalars['ISO8601Date'];
  shortDescription: Scalars['String'];
  slug: Scalars['String'];
  tag?: Maybe<Scalars['String']>;
  thumbnail: ProductUpdatesImage;
  title: Scalars['String'];
  upsellMoreInfo?: Maybe<Scalars['String']>;
};

/** The connection type for ProductUpdatesUpdate. */
export type ProductUpdatesUpdateConnection = {
  __typename?: 'ProductUpdatesUpdateConnection';
  /** A list of edges. */
  edges: Array<ProductUpdatesUpdateEdge>;
  /** A list of nodes. */
  nodes: Array<ProductUpdatesUpdate>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProductUpdatesUpdateEdge = {
  __typename?: 'ProductUpdatesUpdateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProductUpdatesUpdate;
};

/** update_module */
export type ProductUpdatesUpdateModule = {
  __typename?: 'ProductUpdatesUpdateModule';
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
  urlIdentifier: Scalars['String'];
};

/** The connection type for ProductUpdatesUpdateModule. */
export type ProductUpdatesUpdateModuleConnection = {
  __typename?: 'ProductUpdatesUpdateModuleConnection';
  /** A list of edges. */
  edges: Array<ProductUpdatesUpdateModuleEdge>;
  /** A list of nodes. */
  nodes: Array<ProductUpdatesUpdateModule>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProductUpdatesUpdateModuleEdge = {
  __typename?: 'ProductUpdatesUpdateModuleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProductUpdatesUpdateModule;
};

export type ProductUpdatesVideoInfo = {
  __typename?: 'ProductUpdatesVideoInfo';
  mp4Url?: Maybe<Scalars['String']>;
};

/** waitlist */
export type ProductUpdatesWaitlist = {
  __typename?: 'ProductUpdatesWaitlist';
  accessId: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['Int'];
  isShared: Scalars['Boolean'];
  updatedAt: Scalars['ISO8601DateTime'];
  waitlistType: Scalars['String'];
};

/** The connection type for ProductUpdatesWaitlist. */
export type ProductUpdatesWaitlistConnection = {
  __typename?: 'ProductUpdatesWaitlistConnection';
  /** A list of edges. */
  edges: Array<ProductUpdatesWaitlistEdge>;
  /** A list of nodes. */
  nodes: Array<ProductUpdatesWaitlist>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProductUpdatesWaitlistEdge = {
  __typename?: 'ProductUpdatesWaitlistEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProductUpdatesWaitlist;
};

/** Project management Budget strategies */
export type ProjectManagementBudgetStrategy = {
  __typename?: 'ProjectManagementBudgetStrategy';
  budgetAllocation?: Maybe<Scalars['Int']>;
  budgetType: ProjectManagementValueObjectsBudgetStrategyTypeEnum;
  feeAmountCents?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  plannedCents?: Maybe<Scalars['Int']>;
  plannedMinutes?: Maybe<Scalars['Int']>;
  project?: Maybe<ProjectManagementProject>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  projectId: Scalars['Int'];
};


/** Project management Budget strategies */
export type ProjectManagementBudgetStrategyProjectArgs = {
  assignedEmployeesIds?: InputMaybe<Array<Scalars['Int']>>;
  billable?: InputMaybe<Scalars['Boolean']>;
  clientIds?: InputMaybe<Array<Scalars['Int']>>;
  includeCosts?: InputMaybe<Scalars['Boolean']>;
  includeInputedMinutes?: Scalars['Boolean'];
  legalEntityId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  nameOrCode?: InputMaybe<Scalars['String']>;
  noClients?: InputMaybe<Scalars['Boolean']>;
  notClosed?: InputMaybe<Scalars['Boolean']>;
  roleTypes?: InputMaybe<Array<ProjectManagementProjectRoleRoleEnum>>;
  roledByEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  skipViewerByEmployeeId?: InputMaybe<Scalars['Int']>;
  totalCurrency?: InputMaybe<Scalars['String']>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
};

/** The connection type for ProjectManagementBudgetStrategy. */
export type ProjectManagementBudgetStrategyConnection = {
  __typename?: 'ProjectManagementBudgetStrategyConnection';
  /** A list of edges. */
  edges: Array<ProjectManagementBudgetStrategyEdge>;
  /** A list of nodes. */
  nodes: Array<ProjectManagementBudgetStrategy>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProjectManagementBudgetStrategyEdge = {
  __typename?: 'ProjectManagementBudgetStrategyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProjectManagementBudgetStrategy;
};

export type ProjectManagementContextlessPolicies = {
  __typename?: 'ProjectManagementContextlessPolicies';
  commandBarManageProjects: ContextlessPolicyResolution;
  expenseRecordLink: ContextlessPolicyResolution;
  expenseRecordRead: ContextlessPolicyResolution;
  flexibleTimeRecordRead: ContextlessPolicyResolution;
  globalTimeRecordRead: ContextlessPolicyResolution;
  pagesSeeContributorsList: ContextlessPolicyResolution;
  pagesSeeContributorsListUpsell: ContextlessPolicyResolution;
  pagesSeeJobsAndRates: ContextlessPolicyResolution;
  pagesSeeJobsAndRatesUpsell: ContextlessPolicyResolution;
  pagesSeeProjectsRoot: ContextlessPolicyResolution;
  pagesSeeScheduleContributors: ContextlessPolicyResolution;
  pagesSeeScheduleContributorsUpsell: ContextlessPolicyResolution;
  projectCreate: ContextlessPolicyResolution;
  projectInvoiceManageInvoices: ContextlessPolicyResolution;
  projectManage: ContextlessPolicyResolution;
  projectSeeCost: ContextlessPolicyResolution;
  projectSeeLaborCost: ContextlessPolicyResolution;
  projectSoftDelete: ContextlessPolicyResolution;
  projectTaskManage: ContextlessPolicyResolution;
  projectWorkerRead: ContextlessPolicyResolution;
  rateManage: ContextlessPolicyResolution;
  sidebarSeeMyProjectsTopLevelItem: ContextlessPolicyResolution;
  sidebarSeeProjectsTopLevelItem: ContextlessPolicyResolution;
  subprojectHoursDistributionRead: ContextlessPolicyResolution;
  subprojectRead: ContextlessPolicyResolution;
  timeRecordRead: ContextlessPolicyResolution;
};

/** Project Management Default Rate Costs */
export type ProjectManagementDefaultRateCost = {
  __typename?: 'ProjectManagementDefaultRateCost';
  chargingCostCents: Scalars['Int'];
  resourceId: Scalars['Int'];
  resourceType: Scalars['String'];
};

/** The connection type for ProjectManagementDefaultRateCost. */
export type ProjectManagementDefaultRateCostConnection = {
  __typename?: 'ProjectManagementDefaultRateCostConnection';
  /** A list of edges. */
  edges: Array<ProjectManagementDefaultRateCostEdge>;
  /** A list of nodes. */
  nodes: Array<ProjectManagementDefaultRateCost>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProjectManagementDefaultRateCostEdge = {
  __typename?: 'ProjectManagementDefaultRateCostEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProjectManagementDefaultRateCost;
};

/** Project Management Employee Time Detail Chart */
export type ProjectManagementEmployeeTimeDetailChart = {
  __typename?: 'ProjectManagementEmployeeTimeDetailChart';
  imputedMinutes?: Maybe<Scalars['Int']>;
  projectName?: Maybe<Scalars['String']>;
  timeSlot: Scalars['String'];
  year: Scalars['String'];
};

/** The connection type for ProjectManagementEmployeeTimeDetailChart. */
export type ProjectManagementEmployeeTimeDetailChartConnection = {
  __typename?: 'ProjectManagementEmployeeTimeDetailChartConnection';
  /** A list of edges. */
  edges: Array<ProjectManagementEmployeeTimeDetailChartEdge>;
  /** A list of nodes. */
  nodes: Array<ProjectManagementEmployeeTimeDetailChart>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProjectManagementEmployeeTimeDetailChartEdge = {
  __typename?: 'ProjectManagementEmployeeTimeDetailChartEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProjectManagementEmployeeTimeDetailChart;
};

export type ProjectManagementEnumsExportableProjectDateGroupEnum =
  | 'day'
  | 'month';

/** Project management estimated work times */
export type ProjectManagementEstimatedWorkTime = {
  __typename?: 'ProjectManagementEstimatedWorkTime';
  date: Scalars['ISO8601Date'];
  employee?: Maybe<EmployeesEmployee>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  employeeId: Scalars['Int'];
  expectedMinutes: Scalars['Float'];
  minutes: Scalars['Float'];
  offDays: Array<AttendanceOffDay>;
};


/** Project management estimated work times */
export type ProjectManagementEstimatedWorkTimeEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for ProjectManagementEstimatedWorkTime. */
export type ProjectManagementEstimatedWorkTimeConnection = {
  __typename?: 'ProjectManagementEstimatedWorkTimeConnection';
  /** A list of edges. */
  edges: Array<ProjectManagementEstimatedWorkTimeEdge>;
  /** A list of nodes. */
  nodes: Array<ProjectManagementEstimatedWorkTime>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProjectManagementEstimatedWorkTimeEdge = {
  __typename?: 'ProjectManagementEstimatedWorkTimeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProjectManagementEstimatedWorkTime;
};

/** Project Management Expense Records */
export type ProjectManagementExpenseRecord = {
  __typename?: 'ProjectManagementExpenseRecord';
  effectiveOn?: Maybe<Scalars['ISO8601DateTime']>;
  exchangeRate?: Maybe<Scalars['Float']>;
  expensable?: Maybe<ExpensesExpensable>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  expenseId: Scalars['Int'];
  id: Scalars['Int'];
  legalEntityAmountCents?: Maybe<Scalars['String']>;
  legalEntityAmountCurrency?: Maybe<Scalars['String']>;
  originalAmountCents?: Maybe<Scalars['Int']>;
  originalAmountCurrency?: Maybe<Scalars['String']>;
  projectWorker?: Maybe<ProjectManagementProjectWorker>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  projectWorkerId: Scalars['Int'];
  status?: Maybe<Scalars['String']>;
  subproject?: Maybe<ProjectManagementSubproject>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  subprojectId?: Maybe<Scalars['Int']>;
};


/** Project Management Expense Records */
export type ProjectManagementExpenseRecordExpensableArgs = {
  byResources?: InputMaybe<Array<ExpensablesByResourcesInput>>;
  categories?: InputMaybe<Array<Scalars['String']>>;
  companyId?: InputMaybe<Scalars['Int']>;
  creationType?: InputMaybe<Array<Scalars['String']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  from?: InputMaybe<Scalars['ISO8601DateTime']>;
  groupIds?: InputMaybe<Array<Scalars['Int']>>;
  includeAttachments?: Scalars['Boolean'];
  includeGrouped?: Scalars['Boolean'];
  includeManualDrafts?: Scalars['Boolean'];
  onlyGrouped?: InputMaybe<Scalars['Boolean']>;
  perDiemEndDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  perDiemStartDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  reporterIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Array<ExpensesEntitiesExpensableStatusEnum>>;
  to?: InputMaybe<Scalars['ISO8601DateTime']>;
  withReimbursableCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** Project Management Expense Records */
export type ProjectManagementExpenseRecordProjectWorkerArgs = {
  assigned?: InputMaybe<Scalars['Boolean']>;
  byPlannedRecordEnd?: InputMaybe<Scalars['ISO8601Date']>;
  byPlannedRecordStart?: InputMaybe<Scalars['ISO8601Date']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeName?: InputMaybe<Scalars['String']>;
  includeCost?: InputMaybe<Scalars['Boolean']>;
  includeInputedMinutes?: InputMaybe<Scalars['Boolean']>;
  includeLaborCost?: InputMaybe<Scalars['Boolean']>;
  noSubproject?: InputMaybe<Scalars['Boolean']>;
  onlyByProjectRole?: InputMaybe<Scalars['Boolean']>;
  projectActive?: InputMaybe<Scalars['Boolean']>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  subprojectIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Project Management Expense Records */
export type ProjectManagementExpenseRecordSubprojectArgs = {
  financialProjectIds?: InputMaybe<Array<Scalars['Int']>>;
  imputableProjectIds?: InputMaybe<Array<Scalars['Int']>>;
  includeCost?: InputMaybe<Scalars['Boolean']>;
  includeInputedMinutes?: InputMaybe<Scalars['Boolean']>;
  includeNoSubproject?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  notClosed?: InputMaybe<Scalars['Boolean']>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
};

/** The connection type for ProjectManagementExpenseRecord. */
export type ProjectManagementExpenseRecordConnection = {
  __typename?: 'ProjectManagementExpenseRecordConnection';
  /** A list of edges. */
  edges: Array<ProjectManagementExpenseRecordEdge>;
  /** A list of nodes. */
  nodes: Array<ProjectManagementExpenseRecord>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProjectManagementExpenseRecordEdge = {
  __typename?: 'ProjectManagementExpenseRecordEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProjectManagementExpenseRecord;
};

/** the filter for the expense_records resource */
export type ProjectManagementExpenseRecordFilter = {
  effectiveOn?: InputMaybe<DateTimeFilter>;
  legalEntityAmountCents?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<ProjectManagementExpenseRecordFilterConditions>>;
  status?: InputMaybe<StringFilter>;
};

export type ProjectManagementExpenseRecordFilterConditions = {
  effectiveOn?: InputMaybe<DateTimeFilter>;
  legalEntityAmountCents?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
};

/** Project Management Exportable Expenses */
export type ProjectManagementExportableExpense = {
  __typename?: 'ProjectManagementExportableExpense';
  amount?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  employeeName: Scalars['String'];
  expenseCategory?: Maybe<Scalars['String']>;
  expenseLink?: Maybe<Scalars['String']>;
  expenseStatus?: Maybe<Scalars['String']>;
  expenseSubcategory?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  projectCode?: Maybe<Scalars['String']>;
  projectName?: Maybe<Scalars['String']>;
  projectOwners?: Maybe<Scalars['String']>;
  subprojectName?: Maybe<Scalars['String']>;
};

/** The connection type for ProjectManagementExportableExpense. */
export type ProjectManagementExportableExpenseConnection = {
  __typename?: 'ProjectManagementExportableExpenseConnection';
  /** A list of edges. */
  edges: Array<ProjectManagementExportableExpenseEdge>;
  /** A list of nodes. */
  nodes: Array<ProjectManagementExportableExpense>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProjectManagementExportableExpenseEdge = {
  __typename?: 'ProjectManagementExportableExpenseEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProjectManagementExportableExpense;
};

/** Project Management Exportable Projects */
export type ProjectManagementExportableProject = {
  __typename?: 'ProjectManagementExportableProject';
  client?: Maybe<FinanceContact>;
  /**
   * The client id of the project
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  clientId?: Maybe<Scalars['Int']>;
  cost?: Maybe<Scalars['Float']>;
  /** The date of imputed time */
  date?: Maybe<Scalars['ISO8601Date']>;
  employee?: Maybe<EmployeesEmployee>;
  /**
   * The id of the employee
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  employeeId?: Maybe<Scalars['Int']>;
  /** The name of the employee */
  employeeName?: Maybe<Scalars['String']>;
  /** The id of the project */
  id: Scalars['String'];
  /** The time imputed by the employee */
  inputedTime: Scalars['String'];
  /** The code of the project */
  projectCode?: Maybe<Scalars['String']>;
  /** The description of the project */
  projectDescription?: Maybe<Scalars['String']>;
  /** The due date of the project */
  projectDueDate?: Maybe<Scalars['ISO8601Date']>;
  /** The name of the project */
  projectName: Scalars['String'];
  /** The owners of the project separated by a comma */
  projectOwners?: Maybe<Scalars['String']>;
  /** The start date of the project */
  projectStartDate?: Maybe<Scalars['ISO8601Date']>;
  /** The status of the project */
  projectStatus: Scalars['String'];
  /** The name of the subproject */
  subprojectName?: Maybe<Scalars['String']>;
};


/** Project Management Exportable Projects */
export type ProjectManagementExportableProjectClientArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  contactType?: InputMaybe<FinanceValueObjectsContactTypeEnum>;
  email?: InputMaybe<Scalars['String']>;
  legalName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  taxIdType?: InputMaybe<Scalars['String']>;
  taxIds?: InputMaybe<Array<Scalars['String']>>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
  website?: InputMaybe<Scalars['String']>;
};


/** Project Management Exportable Projects */
export type ProjectManagementExportableProjectEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for ProjectManagementExportableProject. */
export type ProjectManagementExportableProjectConnection = {
  __typename?: 'ProjectManagementExportableProjectConnection';
  /** A list of edges. */
  edges: Array<ProjectManagementExportableProjectEdge>;
  /** A list of nodes. */
  nodes: Array<ProjectManagementExportableProject>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProjectManagementExportableProjectEdge = {
  __typename?: 'ProjectManagementExportableProjectEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProjectManagementExportableProject;
};

/** Project management exportable schedules */
export type ProjectManagementExportableSchedule = {
  __typename?: 'ProjectManagementExportableSchedule';
  date: Scalars['ISO8601Date'];
  employee?: Maybe<EmployeesEmployee>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  employeeId: Scalars['Int'];
  minutesOff: Scalars['String'];
  minutesToPlan: Scalars['String'];
  plannedMinutes: Scalars['String'];
  project?: Maybe<ProjectManagementProject>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  projectId?: Maybe<Scalars['Int']>;
  subproject?: Maybe<ProjectManagementSubproject>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  subprojectId?: Maybe<Scalars['Int']>;
};


/** Project management exportable schedules */
export type ProjectManagementExportableScheduleEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Project management exportable schedules */
export type ProjectManagementExportableScheduleProjectArgs = {
  assignedEmployeesIds?: InputMaybe<Array<Scalars['Int']>>;
  billable?: InputMaybe<Scalars['Boolean']>;
  clientIds?: InputMaybe<Array<Scalars['Int']>>;
  includeCosts?: InputMaybe<Scalars['Boolean']>;
  includeInputedMinutes?: Scalars['Boolean'];
  legalEntityId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  nameOrCode?: InputMaybe<Scalars['String']>;
  noClients?: InputMaybe<Scalars['Boolean']>;
  notClosed?: InputMaybe<Scalars['Boolean']>;
  roleTypes?: InputMaybe<Array<ProjectManagementProjectRoleRoleEnum>>;
  roledByEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  skipViewerByEmployeeId?: InputMaybe<Scalars['Int']>;
  totalCurrency?: InputMaybe<Scalars['String']>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Project management exportable schedules */
export type ProjectManagementExportableScheduleSubprojectArgs = {
  financialProjectIds?: InputMaybe<Array<Scalars['Int']>>;
  imputableProjectIds?: InputMaybe<Array<Scalars['Int']>>;
  includeCost?: InputMaybe<Scalars['Boolean']>;
  includeInputedMinutes?: InputMaybe<Scalars['Boolean']>;
  includeNoSubproject?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  notClosed?: InputMaybe<Scalars['Boolean']>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
};

/** The connection type for ProjectManagementExportableSchedule. */
export type ProjectManagementExportableScheduleConnection = {
  __typename?: 'ProjectManagementExportableScheduleConnection';
  /** A list of edges. */
  edges: Array<ProjectManagementExportableScheduleEdge>;
  /** A list of nodes. */
  nodes: Array<ProjectManagementExportableSchedule>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProjectManagementExportableScheduleEdge = {
  __typename?: 'ProjectManagementExportableScheduleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProjectManagementExportableSchedule;
};

/** Project Management Exportable info for Time Tracking Exports */
export type ProjectManagementExportableShift = {
  __typename?: 'ProjectManagementExportableShift';
  clockIn?: Maybe<Scalars['String']>;
  clockOut?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['ISO8601Date']>;
  duration: Scalars['String'];
  employee?: Maybe<EmployeesEmployee>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  employeeId?: Maybe<Scalars['Int']>;
  employeeName: Scalars['String'];
  id: Scalars['String'];
  projectCode?: Maybe<Scalars['String']>;
  projectName?: Maybe<Scalars['String']>;
  projectOwners?: Maybe<Scalars['String']>;
  projectStatus?: Maybe<Scalars['String']>;
  subprojectName?: Maybe<Scalars['String']>;
};


/** Project Management Exportable info for Time Tracking Exports */
export type ProjectManagementExportableShiftEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for ProjectManagementExportableShift. */
export type ProjectManagementExportableShiftConnection = {
  __typename?: 'ProjectManagementExportableShiftConnection';
  /** A list of edges. */
  edges: Array<ProjectManagementExportableShiftEdge>;
  /** A list of nodes. */
  nodes: Array<ProjectManagementExportableShift>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProjectManagementExportableShiftEdge = {
  __typename?: 'ProjectManagementExportableShiftEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProjectManagementExportableShift;
};

/** Project management exportable tasks */
export type ProjectManagementExportableTask = {
  __typename?: 'ProjectManagementExportableTask';
  assignees?: Maybe<Scalars['String']>;
  daysBetweenInProgressAndDone?: Maybe<Scalars['Int']>;
  daysUntilDeadline?: Maybe<Scalars['Int']>;
  employeesCompanyIdentifiers?: Maybe<Scalars['String']>;
  project?: Maybe<ProjectManagementProject>;
  projectCode?: Maybe<Scalars['String']>;
  projectDescription?: Maybe<Scalars['String']>;
  projectName?: Maybe<Scalars['String']>;
  subproject?: Maybe<ProjectManagementSubproject>;
  subprojectName?: Maybe<Scalars['String']>;
  taskDueOnDate?: Maybe<Scalars['ISO8601Date']>;
  taskName?: Maybe<Scalars['String']>;
  taskStartsOnDate?: Maybe<Scalars['ISO8601Date']>;
  taskStatus: Scalars['String'];
};


/** Project management exportable tasks */
export type ProjectManagementExportableTaskProjectArgs = {
  assignedEmployeesIds?: InputMaybe<Array<Scalars['Int']>>;
  billable?: InputMaybe<Scalars['Boolean']>;
  clientIds?: InputMaybe<Array<Scalars['Int']>>;
  includeCosts?: InputMaybe<Scalars['Boolean']>;
  includeInputedMinutes?: Scalars['Boolean'];
  legalEntityId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  nameOrCode?: InputMaybe<Scalars['String']>;
  noClients?: InputMaybe<Scalars['Boolean']>;
  notClosed?: InputMaybe<Scalars['Boolean']>;
  roleTypes?: InputMaybe<Array<ProjectManagementProjectRoleRoleEnum>>;
  roledByEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  skipViewerByEmployeeId?: InputMaybe<Scalars['Int']>;
  totalCurrency?: InputMaybe<Scalars['String']>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Project management exportable tasks */
export type ProjectManagementExportableTaskSubprojectArgs = {
  financialProjectIds?: InputMaybe<Array<Scalars['Int']>>;
  imputableProjectIds?: InputMaybe<Array<Scalars['Int']>>;
  includeCost?: InputMaybe<Scalars['Boolean']>;
  includeInputedMinutes?: InputMaybe<Scalars['Boolean']>;
  includeNoSubproject?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  notClosed?: InputMaybe<Scalars['Boolean']>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
};

/** The connection type for ProjectManagementExportableTask. */
export type ProjectManagementExportableTaskConnection = {
  __typename?: 'ProjectManagementExportableTaskConnection';
  /** A list of edges. */
  edges: Array<ProjectManagementExportableTaskEdge>;
  /** A list of nodes. */
  nodes: Array<ProjectManagementExportableTask>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProjectManagementExportableTaskEdge = {
  __typename?: 'ProjectManagementExportableTaskEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProjectManagementExportableTask;
};

/** Project Management Favourite projects */
export type ProjectManagementFavouriteProject = {
  __typename?: 'ProjectManagementFavouriteProject';
  id: Scalars['Int'];
  projectWorker?: Maybe<ProjectManagementProjectWorker>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  projectWorkerId: Scalars['Int'];
  subproject?: Maybe<ProjectManagementSubproject>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  subprojectId?: Maybe<Scalars['Int']>;
};


/** Project Management Favourite projects */
export type ProjectManagementFavouriteProjectProjectWorkerArgs = {
  assigned?: InputMaybe<Scalars['Boolean']>;
  byPlannedRecordEnd?: InputMaybe<Scalars['ISO8601Date']>;
  byPlannedRecordStart?: InputMaybe<Scalars['ISO8601Date']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeName?: InputMaybe<Scalars['String']>;
  includeCost?: InputMaybe<Scalars['Boolean']>;
  includeInputedMinutes?: InputMaybe<Scalars['Boolean']>;
  includeLaborCost?: InputMaybe<Scalars['Boolean']>;
  noSubproject?: InputMaybe<Scalars['Boolean']>;
  onlyByProjectRole?: InputMaybe<Scalars['Boolean']>;
  projectActive?: InputMaybe<Scalars['Boolean']>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  subprojectIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Project Management Favourite projects */
export type ProjectManagementFavouriteProjectSubprojectArgs = {
  financialProjectIds?: InputMaybe<Array<Scalars['Int']>>;
  imputableProjectIds?: InputMaybe<Array<Scalars['Int']>>;
  includeCost?: InputMaybe<Scalars['Boolean']>;
  includeInputedMinutes?: InputMaybe<Scalars['Boolean']>;
  includeNoSubproject?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  notClosed?: InputMaybe<Scalars['Boolean']>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
};

/** The connection type for ProjectManagementFavouriteProject. */
export type ProjectManagementFavouriteProjectConnection = {
  __typename?: 'ProjectManagementFavouriteProjectConnection';
  /** A list of edges. */
  edges: Array<ProjectManagementFavouriteProjectEdge>;
  /** A list of nodes. */
  nodes: Array<ProjectManagementFavouriteProject>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProjectManagementFavouriteProjectEdge = {
  __typename?: 'ProjectManagementFavouriteProjectEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProjectManagementFavouriteProject;
};

/** Project Management Financial projects abstraction */
export type ProjectManagementFinancialProject = {
  __typename?: 'ProjectManagementFinancialProject';
  client?: Maybe<FinanceContact>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  clientId?: Maybe<Scalars['Int']>;
  code?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isBillable: Scalars['Boolean'];
  name: Scalars['String'];
  status: ProjectManagementProjectStatusEnum;
  subprojects: Array<ProjectManagementSubproject>;
  subprojectsConnection: ProjectManagementSubprojectConnection;
};


/** Project Management Financial projects abstraction */
export type ProjectManagementFinancialProjectClientArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  contactType?: InputMaybe<FinanceValueObjectsContactTypeEnum>;
  email?: InputMaybe<Scalars['String']>;
  legalName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  taxIdType?: InputMaybe<Scalars['String']>;
  taxIds?: InputMaybe<Array<Scalars['String']>>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
  website?: InputMaybe<Scalars['String']>;
};


/** Project Management Financial projects abstraction */
export type ProjectManagementFinancialProjectSubprojectsArgs = {
  financialProjectIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  imputableProjectIds?: InputMaybe<Array<Scalars['Int']>>;
  includeCost?: InputMaybe<Scalars['Boolean']>;
  includeInputedMinutes?: InputMaybe<Scalars['Boolean']>;
  includeNoSubproject?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  notClosed?: InputMaybe<Scalars['Boolean']>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Project Management Financial projects abstraction */
export type ProjectManagementFinancialProjectSubprojectsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  financialProjectIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  imputableProjectIds?: InputMaybe<Array<Scalars['Int']>>;
  includeCost?: InputMaybe<Scalars['Boolean']>;
  includeInputedMinutes?: InputMaybe<Scalars['Boolean']>;
  includeNoSubproject?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  notClosed?: InputMaybe<Scalars['Boolean']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Sort>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
};

/** The connection type for ProjectManagementFinancialProject. */
export type ProjectManagementFinancialProjectConnection = {
  __typename?: 'ProjectManagementFinancialProjectConnection';
  /** A list of edges. */
  edges: Array<ProjectManagementFinancialProjectEdge>;
  /** A list of nodes. */
  nodes: Array<ProjectManagementFinancialProject>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProjectManagementFinancialProjectEdge = {
  __typename?: 'ProjectManagementFinancialProjectEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProjectManagementFinancialProject;
};

/** Project management Fixed cost plannings */
export type ProjectManagementFixedCostPlanning = {
  __typename?: 'ProjectManagementFixedCostPlanning';
  budgetAllocationCents: Scalars['Int'];
  feeAmountCents?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  project?: Maybe<ProjectManagementProject>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  projectId: Scalars['Int'];
};


/** Project management Fixed cost plannings */
export type ProjectManagementFixedCostPlanningProjectArgs = {
  assignedEmployeesIds?: InputMaybe<Array<Scalars['Int']>>;
  billable?: InputMaybe<Scalars['Boolean']>;
  clientIds?: InputMaybe<Array<Scalars['Int']>>;
  includeCosts?: InputMaybe<Scalars['Boolean']>;
  includeInputedMinutes?: Scalars['Boolean'];
  legalEntityId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  nameOrCode?: InputMaybe<Scalars['String']>;
  noClients?: InputMaybe<Scalars['Boolean']>;
  notClosed?: InputMaybe<Scalars['Boolean']>;
  roleTypes?: InputMaybe<Array<ProjectManagementProjectRoleRoleEnum>>;
  roledByEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  skipViewerByEmployeeId?: InputMaybe<Scalars['Int']>;
  totalCurrency?: InputMaybe<Scalars['String']>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
};

/** The connection type for ProjectManagementFixedCostPlanning. */
export type ProjectManagementFixedCostPlanningConnection = {
  __typename?: 'ProjectManagementFixedCostPlanningConnection';
  /** A list of edges. */
  edges: Array<ProjectManagementFixedCostPlanningEdge>;
  /** A list of nodes. */
  nodes: Array<ProjectManagementFixedCostPlanning>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProjectManagementFixedCostPlanningEdge = {
  __typename?: 'ProjectManagementFixedCostPlanningEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProjectManagementFixedCostPlanning;
};

/** Project management Fixed time budgets */
export type ProjectManagementFixedTimeBudget = {
  __typename?: 'ProjectManagementFixedTimeBudget';
  budgetAllocation: Scalars['Int'];
  id: Scalars['Int'];
  project?: Maybe<ProjectManagementProject>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  projectId: Scalars['Int'];
};


/** Project management Fixed time budgets */
export type ProjectManagementFixedTimeBudgetProjectArgs = {
  assignedEmployeesIds?: InputMaybe<Array<Scalars['Int']>>;
  billable?: InputMaybe<Scalars['Boolean']>;
  clientIds?: InputMaybe<Array<Scalars['Int']>>;
  includeCosts?: InputMaybe<Scalars['Boolean']>;
  includeInputedMinutes?: Scalars['Boolean'];
  legalEntityId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  nameOrCode?: InputMaybe<Scalars['String']>;
  noClients?: InputMaybe<Scalars['Boolean']>;
  notClosed?: InputMaybe<Scalars['Boolean']>;
  roleTypes?: InputMaybe<Array<ProjectManagementProjectRoleRoleEnum>>;
  roledByEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  skipViewerByEmployeeId?: InputMaybe<Scalars['Int']>;
  totalCurrency?: InputMaybe<Scalars['String']>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
};

/** The connection type for ProjectManagementFixedTimeBudget. */
export type ProjectManagementFixedTimeBudgetConnection = {
  __typename?: 'ProjectManagementFixedTimeBudgetConnection';
  /** A list of edges. */
  edges: Array<ProjectManagementFixedTimeBudgetEdge>;
  /** A list of nodes. */
  nodes: Array<ProjectManagementFixedTimeBudget>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProjectManagementFixedTimeBudgetEdge = {
  __typename?: 'ProjectManagementFixedTimeBudgetEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProjectManagementFixedTimeBudget;
};

/** Project Management Flexible Time Records */
export type ProjectManagementFlexibleTimeRecord = {
  __typename?: 'ProjectManagementFlexibleTimeRecord';
  date: Scalars['ISO8601Date'];
  id: Scalars['Int'];
  imputedMinutes: Scalars['Int'];
  projectWorker?: Maybe<ProjectManagementProjectWorker>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  projectWorkerId: Scalars['Int'];
  subproject?: Maybe<ProjectManagementSubproject>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  subprojectId?: Maybe<Scalars['Int']>;
};


/** Project Management Flexible Time Records */
export type ProjectManagementFlexibleTimeRecordProjectWorkerArgs = {
  assigned?: InputMaybe<Scalars['Boolean']>;
  byPlannedRecordEnd?: InputMaybe<Scalars['ISO8601Date']>;
  byPlannedRecordStart?: InputMaybe<Scalars['ISO8601Date']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeName?: InputMaybe<Scalars['String']>;
  includeCost?: InputMaybe<Scalars['Boolean']>;
  includeInputedMinutes?: InputMaybe<Scalars['Boolean']>;
  includeLaborCost?: InputMaybe<Scalars['Boolean']>;
  noSubproject?: InputMaybe<Scalars['Boolean']>;
  onlyByProjectRole?: InputMaybe<Scalars['Boolean']>;
  projectActive?: InputMaybe<Scalars['Boolean']>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  subprojectIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Project Management Flexible Time Records */
export type ProjectManagementFlexibleTimeRecordSubprojectArgs = {
  financialProjectIds?: InputMaybe<Array<Scalars['Int']>>;
  imputableProjectIds?: InputMaybe<Array<Scalars['Int']>>;
  includeCost?: InputMaybe<Scalars['Boolean']>;
  includeInputedMinutes?: InputMaybe<Scalars['Boolean']>;
  includeNoSubproject?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  notClosed?: InputMaybe<Scalars['Boolean']>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
};

/** Project Management Flexible Time Record Comments */
export type ProjectManagementFlexibleTimeRecordComment = {
  __typename?: 'ProjectManagementFlexibleTimeRecordComment';
  content: Scalars['String'];
  flexibleTimeRecord?: Maybe<ProjectManagementFlexibleTimeRecord>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  flexibleTimeRecordId: Scalars['Int'];
  id: Scalars['Int'];
};


/** Project Management Flexible Time Record Comments */
export type ProjectManagementFlexibleTimeRecordCommentFlexibleTimeRecordArgs = {
  endsOn?: InputMaybe<Scalars['ISO8601Date']>;
  projectWorkerIds?: Array<Scalars['Int']>;
  startsOn?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
};

/** The connection type for ProjectManagementFlexibleTimeRecordComment. */
export type ProjectManagementFlexibleTimeRecordCommentConnection = {
  __typename?: 'ProjectManagementFlexibleTimeRecordCommentConnection';
  /** A list of edges. */
  edges: Array<ProjectManagementFlexibleTimeRecordCommentEdge>;
  /** A list of nodes. */
  nodes: Array<ProjectManagementFlexibleTimeRecordComment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProjectManagementFlexibleTimeRecordCommentEdge = {
  __typename?: 'ProjectManagementFlexibleTimeRecordCommentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProjectManagementFlexibleTimeRecordComment;
};

/** The connection type for ProjectManagementFlexibleTimeRecord. */
export type ProjectManagementFlexibleTimeRecordConnection = {
  __typename?: 'ProjectManagementFlexibleTimeRecordConnection';
  /** A list of edges. */
  edges: Array<ProjectManagementFlexibleTimeRecordEdge>;
  /** A list of nodes. */
  nodes: Array<ProjectManagementFlexibleTimeRecord>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProjectManagementFlexibleTimeRecordEdge = {
  __typename?: 'ProjectManagementFlexibleTimeRecordEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProjectManagementFlexibleTimeRecord;
};

/** Project Management Global Time Records */
export type ProjectManagementGlobalTimeRecord = {
  __typename?: 'ProjectManagementGlobalTimeRecord';
  comment?: Maybe<Scalars['String']>;
  customId: Scalars['Int'];
  date: Scalars['ISO8601Date'];
  imputedMinutes: Scalars['Int'];
  isFlexible: Scalars['Boolean'];
  openClockIn?: Maybe<Scalars['String']>;
  projectWorker?: Maybe<ProjectManagementProjectWorker>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  projectWorkerId: Scalars['Int'];
  subproject?: Maybe<ProjectManagementSubproject>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  subprojectId?: Maybe<Scalars['Int']>;
};


/** Project Management Global Time Records */
export type ProjectManagementGlobalTimeRecordProjectWorkerArgs = {
  assigned?: InputMaybe<Scalars['Boolean']>;
  byPlannedRecordEnd?: InputMaybe<Scalars['ISO8601Date']>;
  byPlannedRecordStart?: InputMaybe<Scalars['ISO8601Date']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeName?: InputMaybe<Scalars['String']>;
  includeCost?: InputMaybe<Scalars['Boolean']>;
  includeInputedMinutes?: InputMaybe<Scalars['Boolean']>;
  includeLaborCost?: InputMaybe<Scalars['Boolean']>;
  noSubproject?: InputMaybe<Scalars['Boolean']>;
  onlyByProjectRole?: InputMaybe<Scalars['Boolean']>;
  projectActive?: InputMaybe<Scalars['Boolean']>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  subprojectIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Project Management Global Time Records */
export type ProjectManagementGlobalTimeRecordSubprojectArgs = {
  financialProjectIds?: InputMaybe<Array<Scalars['Int']>>;
  imputableProjectIds?: InputMaybe<Array<Scalars['Int']>>;
  includeCost?: InputMaybe<Scalars['Boolean']>;
  includeInputedMinutes?: InputMaybe<Scalars['Boolean']>;
  includeNoSubproject?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  notClosed?: InputMaybe<Scalars['Boolean']>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
};

/** The connection type for ProjectManagementGlobalTimeRecord. */
export type ProjectManagementGlobalTimeRecordConnection = {
  __typename?: 'ProjectManagementGlobalTimeRecordConnection';
  /** A list of edges. */
  edges: Array<ProjectManagementGlobalTimeRecordEdge>;
  /** A list of nodes. */
  nodes: Array<ProjectManagementGlobalTimeRecord>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProjectManagementGlobalTimeRecordEdge = {
  __typename?: 'ProjectManagementGlobalTimeRecordEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProjectManagementGlobalTimeRecord;
};

/** Project management importer projects import */
export type ProjectManagementImporterProjectsImport = {
  __typename?: 'ProjectManagementImporterProjectsImport';
  projects: Array<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

/** Project Management Importer Projects Templates */
export type ProjectManagementImporterProjectsTemplate = {
  __typename?: 'ProjectManagementImporterProjectsTemplate';
  fileName: Scalars['String'];
  fileType: Scalars['String'];
  stream: Scalars['String'];
};

/** Project Management Imputable projects abstraction */
export type ProjectManagementImputableProject = {
  __typename?: 'ProjectManagementImputableProject';
  client?: Maybe<FinanceContact>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  clientId?: Maybe<Scalars['Int']>;
  /** The code of the imputable project */
  code?: Maybe<Scalars['String']>;
  currency: Scalars['String'];
  /** The due date of the imputable project */
  dueDate?: Maybe<Scalars['ISO8601Date']>;
  id: Scalars['Int'];
  /** The name of the imputable project */
  name: Scalars['String'];
  projectTasks: Array<ProjectManagementProjectTask>;
  projectTasksConnection: ProjectManagementProjectTaskConnection;
  /** The start date of the imputable project */
  startDate?: Maybe<Scalars['ISO8601Date']>;
  status: ProjectManagementProjectStatusEnum;
  subprojects: Array<ProjectManagementSubproject>;
  subprojectsConnection: ProjectManagementSubprojectConnection;
};


/** Project Management Imputable projects abstraction */
export type ProjectManagementImputableProjectClientArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  contactType?: InputMaybe<FinanceValueObjectsContactTypeEnum>;
  email?: InputMaybe<Scalars['String']>;
  legalName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  taxIdType?: InputMaybe<Scalars['String']>;
  taxIds?: InputMaybe<Array<Scalars['String']>>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
  website?: InputMaybe<Scalars['String']>;
};


/** Project Management Imputable projects abstraction */
export type ProjectManagementImputableProjectProjectTasksArgs = {
  clientIds?: InputMaybe<Array<Scalars['Int']>>;
  completed?: InputMaybe<Scalars['Boolean']>;
  dueStatus?: InputMaybe<TasksValueObjectsTaskDueStatusEnum>;
  employeeId?: InputMaybe<Scalars['Int']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  incompleted?: InputMaybe<Scalars['Boolean']>;
  overdue?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  subprojectIds?: InputMaybe<Array<Scalars['Int']>>;
  taskIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Project Management Imputable projects abstraction */
export type ProjectManagementImputableProjectProjectTasksConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  clientIds?: InputMaybe<Array<Scalars['Int']>>;
  completed?: InputMaybe<Scalars['Boolean']>;
  dueStatus?: InputMaybe<TasksValueObjectsTaskDueStatusEnum>;
  employeeId?: InputMaybe<Scalars['Int']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  incompleted?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  overdue?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  subprojectIds?: InputMaybe<Array<Scalars['Int']>>;
  taskIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Project Management Imputable projects abstraction */
export type ProjectManagementImputableProjectSubprojectsArgs = {
  financialProjectIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  imputableProjectIds?: InputMaybe<Array<Scalars['Int']>>;
  includeCost?: InputMaybe<Scalars['Boolean']>;
  includeInputedMinutes?: InputMaybe<Scalars['Boolean']>;
  includeNoSubproject?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  notClosed?: InputMaybe<Scalars['Boolean']>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Project Management Imputable projects abstraction */
export type ProjectManagementImputableProjectSubprojectsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  financialProjectIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  imputableProjectIds?: InputMaybe<Array<Scalars['Int']>>;
  includeCost?: InputMaybe<Scalars['Boolean']>;
  includeInputedMinutes?: InputMaybe<Scalars['Boolean']>;
  includeNoSubproject?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  notClosed?: InputMaybe<Scalars['Boolean']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Sort>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
};

/** The connection type for ProjectManagementImputableProject. */
export type ProjectManagementImputableProjectConnection = {
  __typename?: 'ProjectManagementImputableProjectConnection';
  /** A list of edges. */
  edges: Array<ProjectManagementImputableProjectEdge>;
  /** A list of nodes. */
  nodes: Array<ProjectManagementImputableProject>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProjectManagementImputableProjectEdge = {
  __typename?: 'ProjectManagementImputableProjectEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProjectManagementImputableProject;
};

/** the filter for the imputable_projects resource */
export type ProjectManagementImputableProjectFilter = {
  code?: InputMaybe<StringFilter>;
  dueDate?: InputMaybe<DateFilter>;
  name?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<ProjectManagementImputableProjectFilterConditions>>;
  startDate?: InputMaybe<DateFilter>;
};

export type ProjectManagementImputableProjectFilterConditions = {
  code?: InputMaybe<StringFilter>;
  dueDate?: InputMaybe<DateFilter>;
  name?: InputMaybe<StringFilter>;
  startDate?: InputMaybe<DateFilter>;
};

/** Project management planned records */
export type ProjectManagementPlannedRecord = {
  __typename?: 'ProjectManagementPlannedRecord';
  /** The daily minutes of the planned record */
  dailyMinutes: Scalars['Int'];
  /** The end date of the planned record */
  endDate: Scalars['ISO8601Date'];
  /** The id of the planned record */
  id: Scalars['Int'];
  projectWorker?: Maybe<ProjectManagementProjectWorker>;
  /**
   * The project worker id of the planned record
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  projectWorkerId: Scalars['Int'];
  /** The start date of the planned record */
  startDate: Scalars['ISO8601Date'];
  subproject?: Maybe<ProjectManagementSubproject>;
  /**
   * The subproject id of the planned record
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  subprojectId?: Maybe<Scalars['Int']>;
  /** The week days of the planned record, start in Sunday 0 and end in Saturday 6 */
  weekDays: Array<Scalars['Int']>;
};


/** Project management planned records */
export type ProjectManagementPlannedRecordProjectWorkerArgs = {
  assigned?: InputMaybe<Scalars['Boolean']>;
  byPlannedRecordEnd?: InputMaybe<Scalars['ISO8601Date']>;
  byPlannedRecordStart?: InputMaybe<Scalars['ISO8601Date']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeName?: InputMaybe<Scalars['String']>;
  includeCost?: InputMaybe<Scalars['Boolean']>;
  includeInputedMinutes?: InputMaybe<Scalars['Boolean']>;
  includeLaborCost?: InputMaybe<Scalars['Boolean']>;
  noSubproject?: InputMaybe<Scalars['Boolean']>;
  onlyByProjectRole?: InputMaybe<Scalars['Boolean']>;
  projectActive?: InputMaybe<Scalars['Boolean']>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  subprojectIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Project management planned records */
export type ProjectManagementPlannedRecordSubprojectArgs = {
  financialProjectIds?: InputMaybe<Array<Scalars['Int']>>;
  imputableProjectIds?: InputMaybe<Array<Scalars['Int']>>;
  includeCost?: InputMaybe<Scalars['Boolean']>;
  includeInputedMinutes?: InputMaybe<Scalars['Boolean']>;
  includeNoSubproject?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  notClosed?: InputMaybe<Scalars['Boolean']>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
};

/** The connection type for ProjectManagementPlannedRecord. */
export type ProjectManagementPlannedRecordConnection = {
  __typename?: 'ProjectManagementPlannedRecordConnection';
  /** A list of edges. */
  edges: Array<ProjectManagementPlannedRecordEdge>;
  /** A list of nodes. */
  nodes: Array<ProjectManagementPlannedRecord>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProjectManagementPlannedRecordEdge = {
  __typename?: 'ProjectManagementPlannedRecordEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProjectManagementPlannedRecord;
};

/** Project management planned times */
export type ProjectManagementPlannedTime = {
  __typename?: 'ProjectManagementPlannedTime';
  /** The daily minutes of the planned time */
  dailyMinutes: Scalars['Int'];
  employee?: Maybe<EmployeesEmployee>;
  /**
   * The id of the employee
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  employeeId: Scalars['Int'];
  /** The end date of the planned time */
  endDate: Scalars['ISO8601Date'];
  /** The id of the planned time */
  id: Scalars['Int'];
  /** The start date of the planned time */
  startDate: Scalars['ISO8601Date'];
  weekDays: Array<Scalars['Int']>;
};


/** Project management planned times */
export type ProjectManagementPlannedTimeEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for ProjectManagementPlannedTime. */
export type ProjectManagementPlannedTimeConnection = {
  __typename?: 'ProjectManagementPlannedTimeConnection';
  /** A list of edges. */
  edges: Array<ProjectManagementPlannedTimeEdge>;
  /** A list of nodes. */
  nodes: Array<ProjectManagementPlannedTime>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProjectManagementPlannedTimeEdge = {
  __typename?: 'ProjectManagementPlannedTimeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProjectManagementPlannedTime;
};

/** Project Management Processing Rates */
export type ProjectManagementProcessingRate = {
  __typename?: 'ProjectManagementProcessingRate';
  processing: Scalars['Boolean'];
  resourceId: Scalars['Int'];
  resourceType: Scalars['String'];
};

/** The connection type for ProjectManagementProcessingRate. */
export type ProjectManagementProcessingRateConnection = {
  __typename?: 'ProjectManagementProcessingRateConnection';
  /** A list of edges. */
  edges: Array<ProjectManagementProcessingRateEdge>;
  /** A list of nodes. */
  nodes: Array<ProjectManagementProcessingRate>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProjectManagementProcessingRateEdge = {
  __typename?: 'ProjectManagementProcessingRateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProjectManagementProcessingRate;
};

/** Project Management Projects */
export type ProjectManagementProject = {
  __typename?: 'ProjectManagementProject';
  _policies?: Maybe<ProjectManagementProjectPolicies>;
  _policiesCollection?: Maybe<Array<PermissionsPolicyResolution>>;
  _policiesConnection: PermissionsPolicyResolutionConnection;
  /** The billable rate type of the project */
  billableRateType?: Maybe<ProjectManagementProjectBillableRateTypeEnum>;
  billingRate: Array<ProjectManagementRate>;
  billingRateConnection: ProjectManagementRateConnection;
  budgetStrategy?: Maybe<ProjectManagementBudgetStrategy>;
  client?: Maybe<FinanceContact>;
  /**
   * The client of the project, refers to finance/contacts.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  clientId?: Maybe<Scalars['Int']>;
  /** The code of the project */
  code?: Maybe<Scalars['String']>;
  /** The description of the project */
  description?: Maybe<Scalars['String']>;
  /** The end date of the project */
  dueDate?: Maybe<Scalars['ISO8601Date']>;
  /** The employees assigment of the project */
  employeesAssignment: ProjectManagementProjectEmployeesAssignmentEnum;
  /** Total fixed costs in cents */
  fixedCostCents?: Maybe<Scalars['BigInt']>;
  fixedCostPlanning?: Maybe<ProjectManagementFixedCostPlanning>;
  fixedTimeBudget?: Maybe<ProjectManagementFixedTimeBudget>;
  /** The id of the project */
  id: Scalars['Int'];
  /** The total minutes tracked in the project (if requested) */
  inputedMinutes?: Maybe<Scalars['Int']>;
  /** Check if the projects is billable */
  isBillable: Scalars['Boolean'];
  /** Total labor costs in cents */
  laborCostCents?: Maybe<Scalars['BigInt']>;
  legalEntity: CompaniesLegalEntity;
  /**
   * The legal entity id of the project
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  legalEntityId: Scalars['Int'];
  /** The name of the project */
  name: Scalars['String'];
  projectTasks: Array<ProjectManagementProjectTask>;
  projectWorkers: Array<ProjectManagementProjectWorker>;
  projecttasksConnection: ProjectManagementProjectTaskConnection;
  projectworkersConnection: ProjectManagementProjectWorkerConnection;
  /** Total spending costs in cents */
  spendingCostCents?: Maybe<Scalars['BigInt']>;
  /** The start date of the project */
  startDate?: Maybe<Scalars['ISO8601Date']>;
  /** The status of the project */
  status: ProjectManagementProjectStatusEnum;
  subprojects: Array<ProjectManagementSubproject>;
  subprojectsConnection: ProjectManagementSubprojectConnection;
  /** Total Cost in cents */
  totalCostCents?: Maybe<Scalars['BigInt']>;
};


/** Project Management Projects */
export type ProjectManagementProject_PoliciesCollectionArgs = {
  ids: Array<ProjectManagementProjectPoliciesEnum>;
};


/** Project Management Projects */
export type ProjectManagementProject_PoliciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Project Management Projects */
export type ProjectManagementProjectBillingRateArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  employeeName?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  projectId?: InputMaybe<Scalars['Int']>;
  recordType?: InputMaybe<Scalars['String']>;
  referenceRateId?: InputMaybe<Scalars['Int']>;
  referenceRateIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceId?: InputMaybe<Scalars['Int']>;
  roleOrLevel?: InputMaybe<Scalars['String']>;
  withoutProject?: InputMaybe<Scalars['Boolean']>;
};


/** Project Management Projects */
export type ProjectManagementProjectBillingRateConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  employeeName?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  projectId?: InputMaybe<Scalars['Int']>;
  recordType?: InputMaybe<Scalars['String']>;
  referenceRateId?: InputMaybe<Scalars['Int']>;
  referenceRateIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceId?: InputMaybe<Scalars['Int']>;
  roleOrLevel?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  withoutProject?: InputMaybe<Scalars['Boolean']>;
};


/** Project Management Projects */
export type ProjectManagementProjectClientArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  contactType?: InputMaybe<FinanceValueObjectsContactTypeEnum>;
  email?: InputMaybe<Scalars['String']>;
  legalName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  taxIdType?: InputMaybe<Scalars['String']>;
  taxIds?: InputMaybe<Array<Scalars['String']>>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
  website?: InputMaybe<Scalars['String']>;
};


/** Project Management Projects */
export type ProjectManagementProjectFixedCostPlanningArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Project Management Projects */
export type ProjectManagementProjectFixedTimeBudgetArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Project Management Projects */
export type ProjectManagementProjectLegalEntityArgs = {
  companiesIds?: InputMaybe<Array<Scalars['Int']>>;
  countryIds?: InputMaybe<Array<Scalars['String']>>;
  employeesIds?: InputMaybe<Array<Scalars['Int']>>;
  excludeCountries?: InputMaybe<Array<Scalars['String']>>;
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


/** Project Management Projects */
export type ProjectManagementProjectProjectTasksArgs = {
  clientIds?: InputMaybe<Array<Scalars['Int']>>;
  completed?: InputMaybe<Scalars['Boolean']>;
  dueStatus?: InputMaybe<TasksValueObjectsTaskDueStatusEnum>;
  employeeId?: InputMaybe<Scalars['Int']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  incompleted?: InputMaybe<Scalars['Boolean']>;
  overdue?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  subprojectIds?: InputMaybe<Array<Scalars['Int']>>;
  taskIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Project Management Projects */
export type ProjectManagementProjectProjectWorkersArgs = {
  assigned?: InputMaybe<Scalars['Boolean']>;
  byPlannedRecordEnd?: InputMaybe<Scalars['ISO8601Date']>;
  byPlannedRecordStart?: InputMaybe<Scalars['ISO8601Date']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeName?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeCost?: InputMaybe<Scalars['Boolean']>;
  includeInputedMinutes?: InputMaybe<Scalars['Boolean']>;
  includeLaborCost?: InputMaybe<Scalars['Boolean']>;
  noSubproject?: InputMaybe<Scalars['Boolean']>;
  onlyByProjectRole?: InputMaybe<Scalars['Boolean']>;
  projectActive?: InputMaybe<Scalars['Boolean']>;
  subprojectIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Project Management Projects */
export type ProjectManagementProjectProjecttasksConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  clientIds?: InputMaybe<Array<Scalars['Int']>>;
  completed?: InputMaybe<Scalars['Boolean']>;
  dueStatus?: InputMaybe<TasksValueObjectsTaskDueStatusEnum>;
  employeeId?: InputMaybe<Scalars['Int']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  incompleted?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  overdue?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  subprojectIds?: InputMaybe<Array<Scalars['Int']>>;
  taskIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Project Management Projects */
export type ProjectManagementProjectProjectworkersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  assigned?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  byPlannedRecordEnd?: InputMaybe<Scalars['ISO8601Date']>;
  byPlannedRecordStart?: InputMaybe<Scalars['ISO8601Date']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeName?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeCost?: InputMaybe<Scalars['Boolean']>;
  includeInputedMinutes?: InputMaybe<Scalars['Boolean']>;
  includeLaborCost?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  noSubproject?: InputMaybe<Scalars['Boolean']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyByProjectRole?: InputMaybe<Scalars['Boolean']>;
  projectActive?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Sort>;
  subprojectIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Project Management Projects */
export type ProjectManagementProjectSubprojectsArgs = {
  financialProjectIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  imputableProjectIds?: InputMaybe<Array<Scalars['Int']>>;
  includeCost?: InputMaybe<Scalars['Boolean']>;
  includeInputedMinutes?: InputMaybe<Scalars['Boolean']>;
  includeNoSubproject?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  notClosed?: InputMaybe<Scalars['Boolean']>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Project Management Projects */
export type ProjectManagementProjectSubprojectsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  financialProjectIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  imputableProjectIds?: InputMaybe<Array<Scalars['Int']>>;
  includeCost?: InputMaybe<Scalars['Boolean']>;
  includeInputedMinutes?: InputMaybe<Scalars['Boolean']>;
  includeNoSubproject?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  notClosed?: InputMaybe<Scalars['Boolean']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Sort>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
};

export type ProjectManagementProjectBillableRateTypeEnum =
  | 'flat_bill'
  | 'individual'
  | 'job_based';

/** The connection type for ProjectManagementProject. */
export type ProjectManagementProjectConnection = {
  __typename?: 'ProjectManagementProjectConnection';
  /** A list of edges. */
  edges: Array<ProjectManagementProjectEdge>;
  /** A list of nodes. */
  nodes: Array<ProjectManagementProject>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** Project management project contributor */
export type ProjectManagementProjectContributor = {
  __typename?: 'ProjectManagementProjectContributor';
  defaultRateCost?: Maybe<ProjectManagementDefaultRateCost>;
  employee?: Maybe<EmployeesEmployee>;
  estimatedWorkTimes: Array<ProjectManagementEstimatedWorkTime>;
  estimatedWorkTimesConnection: ProjectManagementEstimatedWorkTimeConnection;
  fullName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  plannedTimes: Array<ProjectManagementPlannedTime>;
  plannedTimesConnection: ProjectManagementPlannedTimeConnection;
  projectWorkers: Array<ProjectManagementProjectWorker>;
  projectWorkersConnection: ProjectManagementProjectWorkerConnection;
  rates: Array<ProjectManagementRate>;
  ratesConnection: ProjectManagementRateConnection;
};


/** Project management project contributor */
export type ProjectManagementProjectContributorEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Project management project contributor */
export type ProjectManagementProjectContributorEstimatedWorkTimesArgs = {
  endDate: Scalars['ISO8601Date'];
  startDate: Scalars['ISO8601Date'];
};


/** Project management project contributor */
export type ProjectManagementProjectContributorEstimatedWorkTimesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endDate: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startDate: Scalars['ISO8601Date'];
};


/** Project management project contributor */
export type ProjectManagementProjectContributorPlannedTimesArgs = {
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  onlyHiddenProjects?: InputMaybe<Scalars['Boolean']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Project management project contributor */
export type ProjectManagementProjectContributorPlannedTimesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyHiddenProjects?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Sort>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Project management project contributor */
export type ProjectManagementProjectContributorProjectWorkersArgs = {
  assigned?: InputMaybe<Scalars['Boolean']>;
  byPlannedRecordEnd?: InputMaybe<Scalars['ISO8601Date']>;
  byPlannedRecordStart?: InputMaybe<Scalars['ISO8601Date']>;
  employeeName?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeCost?: InputMaybe<Scalars['Boolean']>;
  includeInputedMinutes?: InputMaybe<Scalars['Boolean']>;
  includeLaborCost?: InputMaybe<Scalars['Boolean']>;
  noSubproject?: InputMaybe<Scalars['Boolean']>;
  onlyByProjectRole?: InputMaybe<Scalars['Boolean']>;
  projectActive?: InputMaybe<Scalars['Boolean']>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  subprojectIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Project management project contributor */
export type ProjectManagementProjectContributorProjectWorkersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  assigned?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  byPlannedRecordEnd?: InputMaybe<Scalars['ISO8601Date']>;
  byPlannedRecordStart?: InputMaybe<Scalars['ISO8601Date']>;
  employeeName?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeCost?: InputMaybe<Scalars['Boolean']>;
  includeInputedMinutes?: InputMaybe<Scalars['Boolean']>;
  includeLaborCost?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  noSubproject?: InputMaybe<Scalars['Boolean']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyByProjectRole?: InputMaybe<Scalars['Boolean']>;
  projectActive?: InputMaybe<Scalars['Boolean']>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
  subprojectIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Project management project contributor */
export type ProjectManagementProjectContributorRatesArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  employeeName?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  projectId?: InputMaybe<Scalars['Int']>;
  recordType?: InputMaybe<Scalars['String']>;
  referenceRateId?: InputMaybe<Scalars['Int']>;
  referenceRateIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceId?: InputMaybe<Scalars['Int']>;
  roleOrLevel?: InputMaybe<Scalars['String']>;
  withoutProject?: InputMaybe<Scalars['Boolean']>;
};


/** Project management project contributor */
export type ProjectManagementProjectContributorRatesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  employeeName?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  projectId?: InputMaybe<Scalars['Int']>;
  recordType?: InputMaybe<Scalars['String']>;
  referenceRateId?: InputMaybe<Scalars['Int']>;
  referenceRateIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceId?: InputMaybe<Scalars['Int']>;
  roleOrLevel?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  withoutProject?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for ProjectManagementProjectContributor. */
export type ProjectManagementProjectContributorConnection = {
  __typename?: 'ProjectManagementProjectContributorConnection';
  /** A list of edges. */
  edges: Array<ProjectManagementProjectContributorEdge>;
  /** A list of nodes. */
  nodes: Array<ProjectManagementProjectContributor>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProjectManagementProjectContributorEdge = {
  __typename?: 'ProjectManagementProjectContributorEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProjectManagementProjectContributor;
};

/** the filter for the project_contributors resource */
export type ProjectManagementProjectContributorFilter = {
  fullName?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntegerFilter>;
  or?: InputMaybe<Array<ProjectManagementProjectContributorFilterConditions>>;
};

export type ProjectManagementProjectContributorFilterConditions = {
  fullName?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntegerFilter>;
};

/** Project Cost Breakdown Chart Points */
export type ProjectManagementProjectCostBreakdownChartPoint = {
  __typename?: 'ProjectManagementProjectCostBreakdownChartPoint';
  fixedCost: Array<ProjectManagementSerializedProjectCostChartPoint>;
  laborCost: Array<ProjectManagementSerializedProjectCostChartPoint>;
  spendingCost: Array<ProjectManagementSerializedProjectCostChartPoint>;
};

/** The connection type for ProjectManagementProjectCostBreakdownChartPoint. */
export type ProjectManagementProjectCostBreakdownChartPointConnection = {
  __typename?: 'ProjectManagementProjectCostBreakdownChartPointConnection';
  /** A list of edges. */
  edges: Array<ProjectManagementProjectCostBreakdownChartPointEdge>;
  /** A list of nodes. */
  nodes: Array<ProjectManagementProjectCostBreakdownChartPoint>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProjectManagementProjectCostBreakdownChartPointEdge = {
  __typename?: 'ProjectManagementProjectCostBreakdownChartPointEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProjectManagementProjectCostBreakdownChartPoint;
};

/** Project Cost Chart Points */
export type ProjectManagementProjectCostChartPoint = {
  __typename?: 'ProjectManagementProjectCostChartPoint';
  costCents?: Maybe<Scalars['Int']>;
  timeSlot: Scalars['String'];
  year: Scalars['String'];
};

/** The connection type for ProjectManagementProjectCostChartPoint. */
export type ProjectManagementProjectCostChartPointConnection = {
  __typename?: 'ProjectManagementProjectCostChartPointConnection';
  /** A list of edges. */
  edges: Array<ProjectManagementProjectCostChartPointEdge>;
  /** A list of nodes. */
  nodes: Array<ProjectManagementProjectCostChartPoint>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProjectManagementProjectCostChartPointEdge = {
  __typename?: 'ProjectManagementProjectCostChartPointEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProjectManagementProjectCostChartPoint;
};

/** Project Cost Distribution Chart Points */
export type ProjectManagementProjectCostDistributionChartPoint = {
  __typename?: 'ProjectManagementProjectCostDistributionChartPoint';
  costCents?: Maybe<Scalars['Int']>;
  employeeName?: Maybe<Scalars['String']>;
  subprojectName?: Maybe<Scalars['String']>;
  timeSlot: Scalars['String'];
  year: Scalars['String'];
};

/** The connection type for ProjectManagementProjectCostDistributionChartPoint. */
export type ProjectManagementProjectCostDistributionChartPointConnection = {
  __typename?: 'ProjectManagementProjectCostDistributionChartPointConnection';
  /** A list of edges. */
  edges: Array<ProjectManagementProjectCostDistributionChartPointEdge>;
  /** A list of nodes. */
  nodes: Array<ProjectManagementProjectCostDistributionChartPoint>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProjectManagementProjectCostDistributionChartPointEdge = {
  __typename?: 'ProjectManagementProjectCostDistributionChartPointEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProjectManagementProjectCostDistributionChartPoint;
};

/** Project management Project documents */
export type ProjectManagementProjectDocument = {
  __typename?: 'ProjectManagementProjectDocument';
  /** creation date of the project document. */
  createdOn: Scalars['String'];
  deletedAt?: Maybe<Scalars['String']>;
  /** file attachment details. */
  file?: Maybe<AttachmentsFileAttachment>;
  /** id of the project document. */
  id: Scalars['Int'];
  /** name of the project document. */
  name: Scalars['String'];
  project?: Maybe<ProjectManagementProject>;
  /**
   * id of the project.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  projectId: Scalars['Int'];
  uploader?: Maybe<EmployeesEmployee>;
  /**
   * id of the uploader
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  uploaderId: Scalars['Int'];
  /** url of the project document. */
  url: Scalars['String'];
};


/** Project management Project documents */
export type ProjectManagementProjectDocumentProjectArgs = {
  assignedEmployeesIds?: InputMaybe<Array<Scalars['Int']>>;
  billable?: InputMaybe<Scalars['Boolean']>;
  clientIds?: InputMaybe<Array<Scalars['Int']>>;
  includeCosts?: InputMaybe<Scalars['Boolean']>;
  includeInputedMinutes?: Scalars['Boolean'];
  legalEntityId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  nameOrCode?: InputMaybe<Scalars['String']>;
  noClients?: InputMaybe<Scalars['Boolean']>;
  notClosed?: InputMaybe<Scalars['Boolean']>;
  roleTypes?: InputMaybe<Array<ProjectManagementProjectRoleRoleEnum>>;
  roledByEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  skipViewerByEmployeeId?: InputMaybe<Scalars['Int']>;
  totalCurrency?: InputMaybe<Scalars['String']>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Project management Project documents */
export type ProjectManagementProjectDocumentUploaderArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for ProjectManagementProjectDocument. */
export type ProjectManagementProjectDocumentConnection = {
  __typename?: 'ProjectManagementProjectDocumentConnection';
  /** A list of edges. */
  edges: Array<ProjectManagementProjectDocumentEdge>;
  /** A list of nodes. */
  nodes: Array<ProjectManagementProjectDocument>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProjectManagementProjectDocumentEdge = {
  __typename?: 'ProjectManagementProjectDocumentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProjectManagementProjectDocument;
};

/** the filter for the project_documents resource */
export type ProjectManagementProjectDocumentFilter = {
  createdOn?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<ProjectManagementProjectDocumentFilterConditions>>;
};

export type ProjectManagementProjectDocumentFilterConditions = {
  createdOn?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
};

/** An edge in a connection. */
export type ProjectManagementProjectEdge = {
  __typename?: 'ProjectManagementProjectEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProjectManagementProject;
};

export type ProjectManagementProjectEmployeesAssignmentEnum =
  | 'company'
  | 'manual';

/** the filter for the projects resource */
export type ProjectManagementProjectFilter = {
  clientId?: InputMaybe<IntegerFilter>;
  code?: InputMaybe<StringFilter>;
  dueDate?: InputMaybe<DateFilter>;
  isBillable?: InputMaybe<BooleanFilter>;
  legalEntityId?: InputMaybe<IntegerFilter>;
  name?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<ProjectManagementProjectFilterConditions>>;
  startDate?: InputMaybe<DateFilter>;
  status?: InputMaybe<StringFilter>;
};

export type ProjectManagementProjectFilterConditions = {
  clientId?: InputMaybe<IntegerFilter>;
  code?: InputMaybe<StringFilter>;
  dueDate?: InputMaybe<DateFilter>;
  isBillable?: InputMaybe<BooleanFilter>;
  legalEntityId?: InputMaybe<IntegerFilter>;
  name?: InputMaybe<StringFilter>;
  startDate?: InputMaybe<DateFilter>;
  status?: InputMaybe<StringFilter>;
};

export type ProjectManagementProjectPolicies = {
  __typename?: 'ProjectManagementProjectPolicies';
  assignEditor: PermissionsPolicyResolution;
  assignOwner: PermissionsPolicyResolution;
  assignUnassignProjectWorkers: PermissionsPolicyResolution;
  manageProjectInvoices: PermissionsPolicyResolution;
  manageTasks: PermissionsPolicyResolution;
  seeCost: PermissionsPolicyResolution;
  seeLaborCost: PermissionsPolicyResolution;
  subprojectEdit: PermissionsPolicyResolution;
};

export type ProjectManagementProjectPoliciesEnum =
  | 'assign_editor'
  | 'assign_owner'
  | 'assign_unassign_project_workers'
  | 'manage_project_invoices'
  | 'manage_tasks'
  | 'see_cost'
  | 'see_labor_cost'
  | 'subproject_edit';

/** Project management project role */
export type ProjectManagementProjectRole = {
  __typename?: 'ProjectManagementProjectRole';
  employee?: Maybe<EmployeesEmployee>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  employeeId: Scalars['Int'];
  id: Scalars['Int'];
  project?: Maybe<ProjectManagementProject>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  projectId: Scalars['Int'];
  role: ProjectManagementProjectRoleRoleEnum;
};


/** Project management project role */
export type ProjectManagementProjectRoleEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Project management project role */
export type ProjectManagementProjectRoleProjectArgs = {
  assignedEmployeesIds?: InputMaybe<Array<Scalars['Int']>>;
  billable?: InputMaybe<Scalars['Boolean']>;
  clientIds?: InputMaybe<Array<Scalars['Int']>>;
  includeCosts?: InputMaybe<Scalars['Boolean']>;
  includeInputedMinutes?: Scalars['Boolean'];
  legalEntityId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  nameOrCode?: InputMaybe<Scalars['String']>;
  noClients?: InputMaybe<Scalars['Boolean']>;
  notClosed?: InputMaybe<Scalars['Boolean']>;
  roleTypes?: InputMaybe<Array<ProjectManagementProjectRoleRoleEnum>>;
  roledByEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  skipViewerByEmployeeId?: InputMaybe<Scalars['Int']>;
  totalCurrency?: InputMaybe<Scalars['String']>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
};

/** The connection type for ProjectManagementProjectRole. */
export type ProjectManagementProjectRoleConnection = {
  __typename?: 'ProjectManagementProjectRoleConnection';
  /** A list of edges. */
  edges: Array<ProjectManagementProjectRoleEdge>;
  /** A list of nodes. */
  nodes: Array<ProjectManagementProjectRole>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProjectManagementProjectRoleEdge = {
  __typename?: 'ProjectManagementProjectRoleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProjectManagementProjectRole;
};

export type ProjectManagementProjectRoleRoleEnum =
  | 'editor'
  | 'owner'
  | 'viewer';

export type ProjectManagementProjectStatusEnum =
  | 'active'
  | 'closed'
  | 'draft'
  | 'processing';

/** Project management project task */
export type ProjectManagementProjectTask = {
  __typename?: 'ProjectManagementProjectTask';
  createdAt: Scalars['ISO8601DateTime'];
  /** If true, status changes related to the project will notify the author */
  followUp: Scalars['Boolean'];
  id: Scalars['Int'];
  imputableProject?: Maybe<ProjectManagementImputableProject>;
  position?: Maybe<Scalars['String']>;
  project?: Maybe<ProjectManagementProject>;
  /**
   * The ID of the project linked to the project task
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  projectId: Scalars['Int'];
  subproject?: Maybe<ProjectManagementSubproject>;
  /**
   * The ID of the subproject linked to the project task
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  subprojectId?: Maybe<Scalars['Int']>;
  task?: Maybe<TasksTask>;
  /**
   * The ID of the task linked to the project task
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  taskId: Scalars['Int'];
};


/** Project management project task */
export type ProjectManagementProjectTaskImputableProjectArgs = {
  assigned?: InputMaybe<Scalars['Boolean']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  nameOrCode?: InputMaybe<Scalars['String']>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
};


/** Project management project task */
export type ProjectManagementProjectTaskProjectArgs = {
  assignedEmployeesIds?: InputMaybe<Array<Scalars['Int']>>;
  billable?: InputMaybe<Scalars['Boolean']>;
  clientIds?: InputMaybe<Array<Scalars['Int']>>;
  includeCosts?: InputMaybe<Scalars['Boolean']>;
  includeInputedMinutes?: Scalars['Boolean'];
  legalEntityId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  nameOrCode?: InputMaybe<Scalars['String']>;
  noClients?: InputMaybe<Scalars['Boolean']>;
  notClosed?: InputMaybe<Scalars['Boolean']>;
  roleTypes?: InputMaybe<Array<ProjectManagementProjectRoleRoleEnum>>;
  roledByEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  skipViewerByEmployeeId?: InputMaybe<Scalars['Int']>;
  totalCurrency?: InputMaybe<Scalars['String']>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Project management project task */
export type ProjectManagementProjectTaskSubprojectArgs = {
  financialProjectIds?: InputMaybe<Array<Scalars['Int']>>;
  imputableProjectIds?: InputMaybe<Array<Scalars['Int']>>;
  includeCost?: InputMaybe<Scalars['Boolean']>;
  includeInputedMinutes?: InputMaybe<Scalars['Boolean']>;
  includeNoSubproject?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  notClosed?: InputMaybe<Scalars['Boolean']>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Project management project task */
export type ProjectManagementProjectTaskTaskArgs = {
  alreadyDue?: InputMaybe<Scalars['Boolean']>;
  assigneeId?: InputMaybe<Scalars['Int']>;
  assigneeRole?: InputMaybe<TasksValueObjectsTaskInvolvementRolesEnum>;
  authorId?: InputMaybe<Scalars['Int']>;
  category?: InputMaybe<TasksValueObjectsTaskCategoryEnum>;
  companyId?: InputMaybe<Scalars['Int']>;
  documentId?: InputMaybe<Scalars['Int']>;
  dueOn?: InputMaybe<Scalars['ISO8601Date']>;
  involveeId?: InputMaybe<Scalars['Int']>;
  mandatory?: InputMaybe<Scalars['Boolean']>;
  processId?: InputMaybe<Scalars['Int']>;
  processIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  startsOn?: InputMaybe<Scalars['ISO8601Date']>;
  status?: InputMaybe<TasksTaskStatusEnum>;
  taskStatus?: InputMaybe<TasksValueObjectsTaskStatusEnum>;
};

/** The connection type for ProjectManagementProjectTask. */
export type ProjectManagementProjectTaskConnection = {
  __typename?: 'ProjectManagementProjectTaskConnection';
  /** A list of edges. */
  edges: Array<ProjectManagementProjectTaskEdge>;
  /** A list of nodes. */
  nodes: Array<ProjectManagementProjectTask>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProjectManagementProjectTaskEdge = {
  __typename?: 'ProjectManagementProjectTaskEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProjectManagementProjectTask;
};

/** the filter for the project_tasks resource */
export type ProjectManagementProjectTaskFilter = {
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntegerFilter>;
  or?: InputMaybe<Array<ProjectManagementProjectTaskFilterConditions>>;
  position?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
};

export type ProjectManagementProjectTaskFilterConditions = {
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntegerFilter>;
  position?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
};

/** Project management project time detail graph */
export type ProjectManagementProjectTimeDetailGraph = {
  __typename?: 'ProjectManagementProjectTimeDetailGraph';
  employeeName?: Maybe<Scalars['String']>;
  imputedMinutes?: Maybe<Scalars['Int']>;
  subprojectName?: Maybe<Scalars['String']>;
  timeSlot: Scalars['String'];
  year: Scalars['String'];
};

/** The connection type for ProjectManagementProjectTimeDetailGraph. */
export type ProjectManagementProjectTimeDetailGraphConnection = {
  __typename?: 'ProjectManagementProjectTimeDetailGraphConnection';
  /** A list of edges. */
  edges: Array<ProjectManagementProjectTimeDetailGraphEdge>;
  /** A list of nodes. */
  nodes: Array<ProjectManagementProjectTimeDetailGraph>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProjectManagementProjectTimeDetailGraphEdge = {
  __typename?: 'ProjectManagementProjectTimeDetailGraphEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProjectManagementProjectTimeDetailGraph;
};

/** Project management project time graph */
export type ProjectManagementProjectTimeGraph = {
  __typename?: 'ProjectManagementProjectTimeGraph';
  imputedMinutes?: Maybe<Scalars['Int']>;
  timeSlot: Scalars['String'];
  year: Scalars['String'];
};

/** The connection type for ProjectManagementProjectTimeGraph. */
export type ProjectManagementProjectTimeGraphConnection = {
  __typename?: 'ProjectManagementProjectTimeGraphConnection';
  /** A list of edges. */
  edges: Array<ProjectManagementProjectTimeGraphEdge>;
  /** A list of nodes. */
  nodes: Array<ProjectManagementProjectTimeGraph>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProjectManagementProjectTimeGraphEdge = {
  __typename?: 'ProjectManagementProjectTimeGraphEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProjectManagementProjectTimeGraph;
};

/** Project management project time range */
export type ProjectManagementProjectTimeRange = {
  __typename?: 'ProjectManagementProjectTimeRange';
  estimatedDueDate?: Maybe<Scalars['ISO8601Date']>;
  estimatedStartDate?: Maybe<Scalars['ISO8601Date']>;
  realDueDate?: Maybe<Scalars['ISO8601Date']>;
  realStartDate?: Maybe<Scalars['ISO8601Date']>;
};

/** The connection type for ProjectManagementProjectTimeRange. */
export type ProjectManagementProjectTimeRangeConnection = {
  __typename?: 'ProjectManagementProjectTimeRangeConnection';
  /** A list of edges. */
  edges: Array<ProjectManagementProjectTimeRangeEdge>;
  /** A list of nodes. */
  nodes: Array<ProjectManagementProjectTimeRange>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProjectManagementProjectTimeRangeEdge = {
  __typename?: 'ProjectManagementProjectTimeRangeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProjectManagementProjectTimeRange;
};

/** Project Management Project Workers */
export type ProjectManagementProjectWorker = {
  __typename?: 'ProjectManagementProjectWorker';
  /** true if the employee is assigned to the project, false otherwise. */
  assigned: Scalars['Boolean'];
  /** total company currency labor cost of the employee in the project. */
  companyLaborCostCents?: Maybe<Scalars['Int']>;
  defaultRateCost?: Maybe<ProjectManagementDefaultRateCost>;
  employee?: Maybe<EmployeesEmployee>;
  /**
   * id of the employee.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  employeeId: Scalars['Int'];
  expenseRecords: Array<ProjectManagementExpenseRecord>;
  expenserecordsConnection: ProjectManagementExpenseRecordConnection;
  flexibleTimeRecords: Array<ProjectManagementFlexibleTimeRecord>;
  flexibletimerecordsConnection: ProjectManagementFlexibleTimeRecordConnection;
  fullName?: Maybe<Scalars['String']>;
  /** id of the project worker. */
  id: Scalars['Int'];
  imputableProject?: Maybe<ProjectManagementImputableProject>;
  /** total inmputed minutes of the employee in the project. */
  inputedMinutes?: Maybe<Scalars['Int']>;
  /** total project currency labor cost of the employee in the project. */
  laborCostCents?: Maybe<Scalars['Int']>;
  plannedRecords: Array<ProjectManagementPlannedRecord>;
  plannedrecordsConnection: ProjectManagementPlannedRecordConnection;
  processingRate?: Maybe<ProjectManagementProcessingRate>;
  project?: Maybe<ProjectManagementProject>;
  /**
   * id of the project.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  projectId: Scalars['Int'];
  rates: Array<ProjectManagementRate>;
  ratesConnection: ProjectManagementRateConnection;
  /** total spending cost of the employee in the project. */
  spendingCostCents?: Maybe<Scalars['Int']>;
  timeRecords: Array<ProjectManagementTimeRecord>;
  timerecordsConnection: ProjectManagementTimeRecordConnection;
};


/** Project Management Project Workers */
export type ProjectManagementProjectWorkerEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Project Management Project Workers */
export type ProjectManagementProjectWorkerExpenseRecordsArgs = {
  employeeUserNameLike?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  expenseIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  imputableProjectIds?: InputMaybe<Array<Scalars['Int']>>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  subprojectIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Project Management Project Workers */
export type ProjectManagementProjectWorkerExpenserecordsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeUserNameLike?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  expenseIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  imputableProjectIds?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  subprojectIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Project Management Project Workers */
export type ProjectManagementProjectWorkerFlexibleTimeRecordsArgs = {
  endsOn?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: Array<Scalars['Int']>;
  startsOn?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Project Management Project Workers */
export type ProjectManagementProjectWorkerFlexibletimerecordsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endsOn?: InputMaybe<Scalars['ISO8601Date']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: Array<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startsOn?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Project Management Project Workers */
export type ProjectManagementProjectWorkerImputableProjectArgs = {
  assigned?: InputMaybe<Scalars['Boolean']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  nameOrCode?: InputMaybe<Scalars['String']>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
};


/** Project Management Project Workers */
export type ProjectManagementProjectWorkerPlannedRecordsArgs = {
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  subprojectIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Project Management Project Workers */
export type ProjectManagementProjectWorkerPlannedrecordsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  subprojectIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Project Management Project Workers */
export type ProjectManagementProjectWorkerProcessingRateArgs = {
  processing?: InputMaybe<Scalars['Boolean']>;
};


/** Project Management Project Workers */
export type ProjectManagementProjectWorkerProjectArgs = {
  assignedEmployeesIds?: InputMaybe<Array<Scalars['Int']>>;
  billable?: InputMaybe<Scalars['Boolean']>;
  clientIds?: InputMaybe<Array<Scalars['Int']>>;
  includeCosts?: InputMaybe<Scalars['Boolean']>;
  includeInputedMinutes?: Scalars['Boolean'];
  legalEntityId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  nameOrCode?: InputMaybe<Scalars['String']>;
  noClients?: InputMaybe<Scalars['Boolean']>;
  notClosed?: InputMaybe<Scalars['Boolean']>;
  roleTypes?: InputMaybe<Array<ProjectManagementProjectRoleRoleEnum>>;
  roledByEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  skipViewerByEmployeeId?: InputMaybe<Scalars['Int']>;
  totalCurrency?: InputMaybe<Scalars['String']>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Project Management Project Workers */
export type ProjectManagementProjectWorkerRatesArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  employeeName?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  projectId?: InputMaybe<Scalars['Int']>;
  recordType?: InputMaybe<Scalars['String']>;
  referenceRateId?: InputMaybe<Scalars['Int']>;
  referenceRateIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceId?: InputMaybe<Scalars['Int']>;
  roleOrLevel?: InputMaybe<Scalars['String']>;
  withoutProject?: InputMaybe<Scalars['Boolean']>;
};


/** Project Management Project Workers */
export type ProjectManagementProjectWorkerRatesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  employeeName?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  projectId?: InputMaybe<Scalars['Int']>;
  recordType?: InputMaybe<Scalars['String']>;
  referenceRateId?: InputMaybe<Scalars['Int']>;
  referenceRateIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceId?: InputMaybe<Scalars['Int']>;
  roleOrLevel?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  withoutProject?: InputMaybe<Scalars['Boolean']>;
};


/** Project Management Project Workers */
export type ProjectManagementProjectWorkerTimeRecordsArgs = {
  attendanceShiftIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  month?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  subprojectIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
  year?: InputMaybe<Scalars['Int']>;
};


/** Project Management Project Workers */
export type ProjectManagementProjectWorkerTimerecordsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  attendanceShiftIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  month?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  subprojectIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
  year?: InputMaybe<Scalars['Int']>;
};

/** The connection type for ProjectManagementProjectWorker. */
export type ProjectManagementProjectWorkerConnection = {
  __typename?: 'ProjectManagementProjectWorkerConnection';
  /** A list of edges. */
  edges: Array<ProjectManagementProjectWorkerEdge>;
  /** A list of nodes. */
  nodes: Array<ProjectManagementProjectWorker>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** Project Management Project Worker Cost History Records */
export type ProjectManagementProjectWorkerCostHistoryRecord = {
  __typename?: 'ProjectManagementProjectWorkerCostHistoryRecord';
  exchangeDate?: Maybe<Scalars['ISO8601Date']>;
  imputedMinutes: Scalars['Int'];
  legalEntityCompanyCostCents: Scalars['Int'];
  originalCostCents: Scalars['Int'];
  originalCostCurrency: Scalars['String'];
  yearMonth: Scalars['String'];
};

/** The connection type for ProjectManagementProjectWorkerCostHistoryRecord. */
export type ProjectManagementProjectWorkerCostHistoryRecordConnection = {
  __typename?: 'ProjectManagementProjectWorkerCostHistoryRecordConnection';
  /** A list of edges. */
  edges: Array<ProjectManagementProjectWorkerCostHistoryRecordEdge>;
  /** A list of nodes. */
  nodes: Array<ProjectManagementProjectWorkerCostHistoryRecord>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProjectManagementProjectWorkerCostHistoryRecordEdge = {
  __typename?: 'ProjectManagementProjectWorkerCostHistoryRecordEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProjectManagementProjectWorkerCostHistoryRecord;
};

/** An edge in a connection. */
export type ProjectManagementProjectWorkerEdge = {
  __typename?: 'ProjectManagementProjectWorkerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProjectManagementProjectWorker;
};

/** the filter for the project_workers resource */
export type ProjectManagementProjectWorkerFilter = {
  assigned?: InputMaybe<BooleanFilter>;
  or?: InputMaybe<Array<ProjectManagementProjectWorkerFilterConditions>>;
};

export type ProjectManagementProjectWorkerFilterConditions = {
  assigned?: InputMaybe<BooleanFilter>;
};

/** Project Management Project Workers Cost History Records */
export type ProjectManagementProjectWorkersCostHistoryRecord = {
  __typename?: 'ProjectManagementProjectWorkersCostHistoryRecord';
  exchangeDate?: Maybe<Scalars['ISO8601Date']>;
  imputedMinutes: Scalars['Int'];
  legalEntityCompanyCostCents: Scalars['Int'];
  originalCostCents: Scalars['Int'];
  originalCostCurrency: Scalars['String'];
  yearMonth: Scalars['String'];
};

/** The connection type for ProjectManagementProjectWorkersCostHistoryRecord. */
export type ProjectManagementProjectWorkersCostHistoryRecordConnection = {
  __typename?: 'ProjectManagementProjectWorkersCostHistoryRecordConnection';
  /** A list of edges. */
  edges: Array<ProjectManagementProjectWorkersCostHistoryRecordEdge>;
  /** A list of nodes. */
  nodes: Array<ProjectManagementProjectWorkersCostHistoryRecord>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProjectManagementProjectWorkersCostHistoryRecordEdge = {
  __typename?: 'ProjectManagementProjectWorkersCostHistoryRecordEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProjectManagementProjectWorkersCostHistoryRecord;
};

/** Project Management Rates */
export type ProjectManagementRate = {
  __typename?: 'ProjectManagementRate';
  /** The billing rate in cents */
  billingRateCents: Scalars['Int'];
  /** The charging cost in cents */
  chargingCostCents: Scalars['Int'];
  company: CompaniesCompany;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  companyId: Scalars['Int'];
  currency: Scalars['String'];
  endsOn?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['Int'];
  processingRate?: Maybe<ProjectManagementProcessingRate>;
  /** The profitability percentage in cents */
  profitabilityPercentageCents: Scalars['Int'];
  project?: Maybe<ProjectManagementProject>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  projectId?: Maybe<Scalars['Int']>;
  referenceRate?: Maybe<ProjectManagementRate>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  referenceRateId?: Maybe<Scalars['Int']>;
  referencedRates: Array<ProjectManagementRate>;
  referencedRatesConnection: ProjectManagementRateConnection;
  resource?: Maybe<RateResource>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  resourceId: Scalars['Int'];
  resourceType: Scalars['String'];
  startsOn: Scalars['ISO8601DateTime'];
  /** Whether the rate is custom */
  unlinked: Scalars['Boolean'];
};


/** Project Management Rates */
export type ProjectManagementRateCompanyArgs = {
  forBookkeepers?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};


/** Project Management Rates */
export type ProjectManagementRateProcessingRateArgs = {
  processing?: InputMaybe<Scalars['Boolean']>;
};


/** Project Management Rates */
export type ProjectManagementRateProjectArgs = {
  assignedEmployeesIds?: InputMaybe<Array<Scalars['Int']>>;
  billable?: InputMaybe<Scalars['Boolean']>;
  clientIds?: InputMaybe<Array<Scalars['Int']>>;
  includeCosts?: InputMaybe<Scalars['Boolean']>;
  includeInputedMinutes?: Scalars['Boolean'];
  legalEntityId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  nameOrCode?: InputMaybe<Scalars['String']>;
  noClients?: InputMaybe<Scalars['Boolean']>;
  notClosed?: InputMaybe<Scalars['Boolean']>;
  roleTypes?: InputMaybe<Array<ProjectManagementProjectRoleRoleEnum>>;
  roledByEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  skipViewerByEmployeeId?: InputMaybe<Scalars['Int']>;
  totalCurrency?: InputMaybe<Scalars['String']>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Project Management Rates */
export type ProjectManagementRateReferenceRateArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  employeeName?: InputMaybe<Scalars['String']>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  projectId?: InputMaybe<Scalars['Int']>;
  recordType?: InputMaybe<Scalars['String']>;
  referenceRateId?: InputMaybe<Scalars['Int']>;
  referenceRateIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceId?: InputMaybe<Scalars['Int']>;
  resourceIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceType?: InputMaybe<Scalars['String']>;
  roleOrLevel?: InputMaybe<Scalars['String']>;
  withoutProject?: InputMaybe<Scalars['Boolean']>;
};


/** Project Management Rates */
export type ProjectManagementRateReferencedRatesArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  employeeName?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  projectId?: InputMaybe<Scalars['Int']>;
  recordType?: InputMaybe<Scalars['String']>;
  referenceRateId?: InputMaybe<Scalars['Int']>;
  resourceId?: InputMaybe<Scalars['Int']>;
  resourceIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceType?: InputMaybe<Scalars['String']>;
  roleOrLevel?: InputMaybe<Scalars['String']>;
  withoutProject?: InputMaybe<Scalars['Boolean']>;
};


/** Project Management Rates */
export type ProjectManagementRateReferencedRatesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  employeeName?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  projectId?: InputMaybe<Scalars['Int']>;
  recordType?: InputMaybe<Scalars['String']>;
  referenceRateId?: InputMaybe<Scalars['Int']>;
  resourceId?: InputMaybe<Scalars['Int']>;
  resourceIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceType?: InputMaybe<Scalars['String']>;
  roleOrLevel?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  withoutProject?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for ProjectManagementRate. */
export type ProjectManagementRateConnection = {
  __typename?: 'ProjectManagementRateConnection';
  /** A list of edges. */
  edges: Array<ProjectManagementRateEdge>;
  /** A list of nodes. */
  nodes: Array<ProjectManagementRate>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProjectManagementRateEdge = {
  __typename?: 'ProjectManagementRateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProjectManagementRate;
};

/** the filter for the rates resource */
export type ProjectManagementRateFilter = {
  billingRateCents?: InputMaybe<IntegerFilter>;
  chargingCostCents?: InputMaybe<IntegerFilter>;
  or?: InputMaybe<Array<ProjectManagementRateFilterConditions>>;
  profitabilityPercentageCents?: InputMaybe<IntegerFilter>;
  unlinked?: InputMaybe<BooleanFilter>;
};

export type ProjectManagementRateFilterConditions = {
  billingRateCents?: InputMaybe<IntegerFilter>;
  chargingCostCents?: InputMaybe<IntegerFilter>;
  profitabilityPercentageCents?: InputMaybe<IntegerFilter>;
  unlinked?: InputMaybe<BooleanFilter>;
};

/** Project Management Rates Breakdown */
export type ProjectManagementRatesBreakdown = {
  __typename?: 'ProjectManagementRatesBreakdown';
  hoursPerBillRate: Scalars['Int'];
  hoursPerCostRate: Scalars['Int'];
  id: Scalars['Int'];
};

/** The connection type for ProjectManagementRatesBreakdown. */
export type ProjectManagementRatesBreakdownConnection = {
  __typename?: 'ProjectManagementRatesBreakdownConnection';
  /** A list of edges. */
  edges: Array<ProjectManagementRatesBreakdownEdge>;
  /** A list of nodes. */
  nodes: Array<ProjectManagementRatesBreakdown>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProjectManagementRatesBreakdownEdge = {
  __typename?: 'ProjectManagementRatesBreakdownEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProjectManagementRatesBreakdown;
};

/** Project Management Sales Invoices Insights */
export type ProjectManagementSalesInvoicesInsight = {
  __typename?: 'ProjectManagementSalesInvoicesInsight';
  draftInvoicedAmountCents: Scalars['Int'];
  issuedInvoicedAmountCents: Scalars['Int'];
  totalInvoicedAmountCents: Scalars['Int'];
};

/** The connection type for ProjectManagementSalesInvoicesInsight. */
export type ProjectManagementSalesInvoicesInsightConnection = {
  __typename?: 'ProjectManagementSalesInvoicesInsightConnection';
  /** A list of edges. */
  edges: Array<ProjectManagementSalesInvoicesInsightEdge>;
  /** A list of nodes. */
  nodes: Array<ProjectManagementSalesInvoicesInsight>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProjectManagementSalesInvoicesInsightEdge = {
  __typename?: 'ProjectManagementSalesInvoicesInsightEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProjectManagementSalesInvoicesInsight;
};

export type ProjectManagementSerializedProjectCostChartPoint = {
  __typename?: 'ProjectManagementSerializedProjectCostChartPoint';
  costCents?: Maybe<Scalars['Int']>;
  timeSlot: Scalars['String'];
  year: Scalars['String'];
};

/** Project Management Spending Costs */
export type ProjectManagementSpendingCost = {
  __typename?: 'ProjectManagementSpendingCost';
  /** Effective date of the spending cost */
  effectiveOn?: Maybe<Scalars['ISO8601DateTime']>;
  /** Exchange rate of the spending cost */
  exchangeRate?: Maybe<Scalars['Float']>;
  expensable?: Maybe<ExpensesExpensable>;
  financialDocument?: Maybe<FinanceFinancialDocument>;
  /** Id of the spending cost */
  id: Scalars['Int'];
  /** Legal entity amount of the spending cost (from the project's legal entity) */
  legalEntityAmountCents?: Maybe<Scalars['Int']>;
  /** Legal entity currency of the spending cost (from the project's legal entity) */
  legalEntityAmountCurrency?: Maybe<Scalars['String']>;
  /** Original amount of the spending cost */
  originalAmountCents?: Maybe<Scalars['Int']>;
  /** Original currency of the spending cost */
  originalAmountCurrency?: Maybe<Scalars['String']>;
  project?: Maybe<ProjectManagementProject>;
  /**
   * Id of the project
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  projectId: Scalars['Int'];
  /**
   * Id of the resource
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  resourceId?: Maybe<Scalars['Int']>;
  /** Type of the resource */
  resourceType: ProjectManagementSpendingCostTypeEnum;
  /** Status of the spending cost */
  status: Enum;
  subproject?: Maybe<ProjectManagementSubproject>;
  /**
   * Id of the subproject
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  subprojectId?: Maybe<Scalars['Int']>;
};


/** Project Management Spending Costs */
export type ProjectManagementSpendingCostExpensableArgs = {
  byResources?: InputMaybe<Array<ExpensablesByResourcesInput>>;
  categories?: InputMaybe<Array<Scalars['String']>>;
  companyId?: InputMaybe<Scalars['Int']>;
  creationType?: InputMaybe<Array<Scalars['String']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  from?: InputMaybe<Scalars['ISO8601DateTime']>;
  groupIds?: InputMaybe<Array<Scalars['Int']>>;
  includeAttachments?: Scalars['Boolean'];
  includeGrouped?: Scalars['Boolean'];
  onlyGrouped?: InputMaybe<Scalars['Boolean']>;
  perDiemEndDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  perDiemStartDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  reporterIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Array<ExpensesEntitiesExpensableStatusEnum>>;
  to?: InputMaybe<Scalars['ISO8601DateTime']>;
  withReimbursableCurrency?: InputMaybe<Scalars['Boolean']>;
};


/** Project Management Spending Costs */
export type ProjectManagementSpendingCostFinancialDocumentArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  currency?: InputMaybe<Scalars['String']>;
  dealId?: InputMaybe<Scalars['Int']>;
  documentTypes?: InputMaybe<Array<FinanceValueObjectsFinancialDocumentTypeEnum>>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  issuerName?: InputMaybe<Scalars['String']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  operationTypes?: InputMaybe<Array<FinanceValueObjectsFinancialDocumentOperationTypeEnum>>;
  parentFinancialDocumentIds?: InputMaybe<Array<Scalars['Int']>>;
  projectId?: InputMaybe<Scalars['Int']>;
  reconcilable?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<FinanceValueObjectsInvoiceStatusEnum>>;
  toDate?: InputMaybe<Scalars['ISO8601Date']>;
  toDueDate?: InputMaybe<Scalars['ISO8601Date']>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
  vendorId?: InputMaybe<Scalars['Int']>;
};


/** Project Management Spending Costs */
export type ProjectManagementSpendingCostProjectArgs = {
  assignedEmployeesIds?: InputMaybe<Array<Scalars['Int']>>;
  billable?: InputMaybe<Scalars['Boolean']>;
  clientIds?: InputMaybe<Array<Scalars['Int']>>;
  includeCosts?: InputMaybe<Scalars['Boolean']>;
  includeInputedMinutes?: Scalars['Boolean'];
  legalEntityId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  nameOrCode?: InputMaybe<Scalars['String']>;
  noClients?: InputMaybe<Scalars['Boolean']>;
  notClosed?: InputMaybe<Scalars['Boolean']>;
  roleTypes?: InputMaybe<Array<ProjectManagementProjectRoleRoleEnum>>;
  roledByEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  skipViewerByEmployeeId?: InputMaybe<Scalars['Int']>;
  totalCurrency?: InputMaybe<Scalars['String']>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Project Management Spending Costs */
export type ProjectManagementSpendingCostSubprojectArgs = {
  financialProjectIds?: InputMaybe<Array<Scalars['Int']>>;
  imputableProjectIds?: InputMaybe<Array<Scalars['Int']>>;
  includeCost?: InputMaybe<Scalars['Boolean']>;
  includeInputedMinutes?: InputMaybe<Scalars['Boolean']>;
  includeNoSubproject?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  notClosed?: InputMaybe<Scalars['Boolean']>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
};

/** The connection type for ProjectManagementSpendingCost. */
export type ProjectManagementSpendingCostConnection = {
  __typename?: 'ProjectManagementSpendingCostConnection';
  /** A list of edges. */
  edges: Array<ProjectManagementSpendingCostEdge>;
  /** A list of nodes. */
  nodes: Array<ProjectManagementSpendingCost>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProjectManagementSpendingCostEdge = {
  __typename?: 'ProjectManagementSpendingCostEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProjectManagementSpendingCost;
};

/** the filter for the spending_costs resource */
export type ProjectManagementSpendingCostFilter = {
  effectiveOn?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntegerFilter>;
  or?: InputMaybe<Array<ProjectManagementSpendingCostFilterConditions>>;
  status?: InputMaybe<StringFilter>;
  subprojectId?: InputMaybe<IntegerFilter>;
};

export type ProjectManagementSpendingCostFilterConditions = {
  effectiveOn?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntegerFilter>;
  status?: InputMaybe<StringFilter>;
  subprojectId?: InputMaybe<IntegerFilter>;
};

export type ProjectManagementSpendingCostStatusEnum =
  | 'approved'
  | 'pending'
  | 'rejected';

export type ProjectManagementSpendingCostTypeEnum =
  | 'expenses_expensable'
  | 'finance_financialdocument';

/** Project Management Spending Costs Insights */
export type ProjectManagementSpendingCostsInsight = {
  __typename?: 'ProjectManagementSpendingCostsInsight';
  amountCurrency: Scalars['String'];
  approvedAmountCents: Scalars['Int'];
  pendingAmountCents: Scalars['Int'];
  projectId: Scalars['Int'];
  rejectedAmountCents: Scalars['Int'];
};

/** The connection type for ProjectManagementSpendingCostsInsight. */
export type ProjectManagementSpendingCostsInsightConnection = {
  __typename?: 'ProjectManagementSpendingCostsInsightConnection';
  /** A list of edges. */
  edges: Array<ProjectManagementSpendingCostsInsightEdge>;
  /** A list of nodes. */
  nodes: Array<ProjectManagementSpendingCostsInsight>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProjectManagementSpendingCostsInsightEdge = {
  __typename?: 'ProjectManagementSpendingCostsInsightEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProjectManagementSpendingCostsInsight;
};

/** Project Management Spending Insight */
export type ProjectManagementSpendingInsight = {
  __typename?: 'ProjectManagementSpendingInsight';
  approvedTotalCount: Scalars['Int'];
  id: Scalars['Int'];
  totalCount: Scalars['Int'];
};

/** The connection type for ProjectManagementSpendingInsight. */
export type ProjectManagementSpendingInsightConnection = {
  __typename?: 'ProjectManagementSpendingInsightConnection';
  /** A list of edges. */
  edges: Array<ProjectManagementSpendingInsightEdge>;
  /** A list of nodes. */
  nodes: Array<ProjectManagementSpendingInsight>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProjectManagementSpendingInsightEdge = {
  __typename?: 'ProjectManagementSpendingInsightEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProjectManagementSpendingInsight;
};

/** Project Management Subprojects */
export type ProjectManagementSubproject = {
  __typename?: 'ProjectManagementSubproject';
  /** The code of the subproject */
  code?: Maybe<Scalars['String']>;
  /** The description of the subproject */
  description?: Maybe<Scalars['String']>;
  /** The due date of the subproject */
  dueDate?: Maybe<Scalars['String']>;
  flexibleTimeRecords: Array<ProjectManagementFlexibleTimeRecord>;
  flexibletimerecordsConnection: ProjectManagementFlexibleTimeRecordConnection;
  /** The id of the subproject */
  id?: Maybe<Scalars['Int']>;
  /** The total minutes tracked in the subproject (if requested) */
  inputedMinutes?: Maybe<Scalars['Int']>;
  /** Whether the subproject is billable */
  isBillable?: Maybe<Scalars['Boolean']>;
  /** The total labor cost of the subproject in cents (if requested) */
  laborCostCents?: Maybe<Scalars['Int']>;
  /** The name of the subproject */
  name: Scalars['String'];
  plannedRecords: Array<ProjectManagementPlannedRecord>;
  plannedrecordsConnection: ProjectManagementPlannedRecordConnection;
  project: ProjectManagementProject;
  /**
   * The id of the project
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  projectId: Scalars['Int'];
  projectTimeRecords: Array<ProjectManagementTimeRecord>;
  projecttimerecordsConnection: ProjectManagementTimeRecordConnection;
  /** The start date of the subproject */
  startDate?: Maybe<Scalars['String']>;
  /** The status of the subproject */
  status?: Maybe<Scalars['String']>;
};


/** Project Management Subprojects */
export type ProjectManagementSubprojectFlexibleTimeRecordsArgs = {
  endsOn?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: Array<Scalars['Int']>;
  startsOn?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Project Management Subprojects */
export type ProjectManagementSubprojectFlexibletimerecordsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endsOn?: InputMaybe<Scalars['ISO8601Date']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: Array<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startsOn?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Project Management Subprojects */
export type ProjectManagementSubprojectPlannedRecordsArgs = {
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  projectWorkerIds?: InputMaybe<Array<Scalars['Int']>>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Project Management Subprojects */
export type ProjectManagementSubprojectPlannedrecordsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  projectWorkerIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Project Management Subprojects */
export type ProjectManagementSubprojectProjectArgs = {
  assignedEmployeesIds?: InputMaybe<Array<Scalars['Int']>>;
  billable?: InputMaybe<Scalars['Boolean']>;
  clientIds?: InputMaybe<Array<Scalars['Int']>>;
  includeCosts?: InputMaybe<Scalars['Boolean']>;
  includeInputedMinutes?: Scalars['Boolean'];
  legalEntityId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  nameOrCode?: InputMaybe<Scalars['String']>;
  noClients?: InputMaybe<Scalars['Boolean']>;
  notClosed?: InputMaybe<Scalars['Boolean']>;
  roleTypes?: InputMaybe<Array<ProjectManagementProjectRoleRoleEnum>>;
  roledByEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  skipViewerByEmployeeId?: InputMaybe<Scalars['Int']>;
  totalCurrency?: InputMaybe<Scalars['String']>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Project Management Subprojects */
export type ProjectManagementSubprojectProjectTimeRecordsArgs = {
  attendanceShiftIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  month?: InputMaybe<Scalars['Int']>;
  projectWorkerIds?: InputMaybe<Array<Scalars['Int']>>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
  year?: InputMaybe<Scalars['Int']>;
};


/** Project Management Subprojects */
export type ProjectManagementSubprojectProjecttimerecordsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  attendanceShiftIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  month?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  projectWorkerIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
  year?: InputMaybe<Scalars['Int']>;
};

/** The connection type for ProjectManagementSubproject. */
export type ProjectManagementSubprojectConnection = {
  __typename?: 'ProjectManagementSubprojectConnection';
  /** A list of edges. */
  edges: Array<ProjectManagementSubprojectEdge>;
  /** A list of nodes. */
  nodes: Array<ProjectManagementSubproject>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProjectManagementSubprojectEdge = {
  __typename?: 'ProjectManagementSubprojectEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProjectManagementSubproject;
};

/** the filter for the subprojects resource */
export type ProjectManagementSubprojectFilter = {
  name?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<ProjectManagementSubprojectFilterConditions>>;
};

export type ProjectManagementSubprojectFilterConditions = {
  name?: InputMaybe<StringFilter>;
};

/** Project Management Subproject Hours Distribution */
export type ProjectManagementSubprojectHoursDistribution = {
  __typename?: 'ProjectManagementSubprojectHoursDistribution';
  id?: Maybe<Scalars['Int']>;
  inputedMinutes: Scalars['Int'];
  name: Scalars['String'];
};

/** The connection type for ProjectManagementSubprojectHoursDistribution. */
export type ProjectManagementSubprojectHoursDistributionConnection = {
  __typename?: 'ProjectManagementSubprojectHoursDistributionConnection';
  /** A list of edges. */
  edges: Array<ProjectManagementSubprojectHoursDistributionEdge>;
  /** A list of nodes. */
  nodes: Array<ProjectManagementSubprojectHoursDistribution>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProjectManagementSubprojectHoursDistributionEdge = {
  __typename?: 'ProjectManagementSubprojectHoursDistributionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProjectManagementSubprojectHoursDistribution;
};

/** Project Management Time Records */
export type ProjectManagementTimeRecord = {
  __typename?: 'ProjectManagementTimeRecord';
  /** Id of the attendance shift */
  attendanceShiftId: Scalars['Int'];
  /** Clock in time */
  clockIn?: Maybe<Scalars['ISO8601DateTime']>;
  /** Clock out time */
  clockOut?: Maybe<Scalars['ISO8601DateTime']>;
  /** Reference date of the shift */
  date?: Maybe<Scalars['ISO8601Date']>;
  /** Id of the time record */
  id: Scalars['Int'];
  /** Minutes difference between the clock in and clock out */
  imputedMinutes?: Maybe<Scalars['Int']>;
  projectWorker?: Maybe<ProjectManagementProjectWorker>;
  /**
   * Id of the project worker
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  projectWorkerId: Scalars['Int'];
  subproject?: Maybe<ProjectManagementSubproject>;
  /**
   * Id of the subproject
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  subprojectId?: Maybe<Scalars['Int']>;
};


/** Project Management Time Records */
export type ProjectManagementTimeRecordProjectWorkerArgs = {
  assigned?: InputMaybe<Scalars['Boolean']>;
  byPlannedRecordEnd?: InputMaybe<Scalars['ISO8601Date']>;
  byPlannedRecordStart?: InputMaybe<Scalars['ISO8601Date']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeName?: InputMaybe<Scalars['String']>;
  includeCost?: InputMaybe<Scalars['Boolean']>;
  includeInputedMinutes?: InputMaybe<Scalars['Boolean']>;
  includeLaborCost?: InputMaybe<Scalars['Boolean']>;
  noSubproject?: InputMaybe<Scalars['Boolean']>;
  onlyByProjectRole?: InputMaybe<Scalars['Boolean']>;
  projectActive?: InputMaybe<Scalars['Boolean']>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  subprojectIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Project Management Time Records */
export type ProjectManagementTimeRecordSubprojectArgs = {
  financialProjectIds?: InputMaybe<Array<Scalars['Int']>>;
  imputableProjectIds?: InputMaybe<Array<Scalars['Int']>>;
  includeCost?: InputMaybe<Scalars['Boolean']>;
  includeInputedMinutes?: InputMaybe<Scalars['Boolean']>;
  includeNoSubproject?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  notClosed?: InputMaybe<Scalars['Boolean']>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
};

/** The connection type for ProjectManagementTimeRecord. */
export type ProjectManagementTimeRecordConnection = {
  __typename?: 'ProjectManagementTimeRecordConnection';
  /** A list of edges. */
  edges: Array<ProjectManagementTimeRecordEdge>;
  /** A list of nodes. */
  nodes: Array<ProjectManagementTimeRecord>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ProjectManagementTimeRecordEdge = {
  __typename?: 'ProjectManagementTimeRecordEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ProjectManagementTimeRecord;
};

/** the filter for the time_records resource */
export type ProjectManagementTimeRecordFilter = {
  attendanceShiftId?: InputMaybe<IntegerFilter>;
  clockIn?: InputMaybe<DateTimeFilter>;
  clockOut?: InputMaybe<DateTimeFilter>;
  date?: InputMaybe<DateFilter>;
  id?: InputMaybe<IntegerFilter>;
  imputedMinutes?: InputMaybe<IntegerFilter>;
  or?: InputMaybe<Array<ProjectManagementTimeRecordFilterConditions>>;
  projectWorkerId?: InputMaybe<IntegerFilter>;
  subprojectId?: InputMaybe<IntegerFilter>;
};

export type ProjectManagementTimeRecordFilterConditions = {
  attendanceShiftId?: InputMaybe<IntegerFilter>;
  clockIn?: InputMaybe<DateTimeFilter>;
  clockOut?: InputMaybe<DateTimeFilter>;
  date?: InputMaybe<DateFilter>;
  id?: InputMaybe<IntegerFilter>;
  imputedMinutes?: InputMaybe<IntegerFilter>;
  projectWorkerId?: InputMaybe<IntegerFilter>;
  subprojectId?: InputMaybe<IntegerFilter>;
};

/** Project management upsell notification message */
export type ProjectManagementUpsellNotificationMessage = {
  __typename?: 'ProjectManagementUpsellNotificationMessage';
  id: Scalars['String'];
};

export type ProjectManagementValueObjectsBudgetStrategyTypeEnum =
  | 'project_fixed_cost'
  | 'subproject'
  | 'total_budget'
  | 'without_budget';

export type ProjectManagementValueObjectsStatusTypesEnum =
  | 'active'
  | 'closed'
  | 'draft'
  | 'processing';

/** Autogenerated return type of ProjectManagement_processing_rate_read_subscription. */
export type ProjectManagement_Processing_Rate_Read_SubscriptionPayload = {
  __typename?: 'ProjectManagement_processing_rate_read_subscriptionPayload';
  processingRate?: Maybe<Processing_Rate_Read_Type>;
};

/** Autogenerated return type of ProjectManagement_rate_processed_subscription. */
export type ProjectManagement_Rate_Processed_SubscriptionPayload = {
  __typename?: 'ProjectManagement_rate_processed_subscriptionPayload';
  rate?: Maybe<Rate_Processed_Type>;
};

/** Projections needed to build a table - column names and paths */
export type Projection = {
  /** The path to the field that should be in this column */
  path?: InputMaybe<Scalars['String']>;
  /** The export tamplate, in Liquid format */
  template?: InputMaybe<Scalars['String']>;
  /** Title of the column */
  title: Scalars['String'];
};

export type PromoteContractsContractVersionAdditionalCompensationsInput = {
  amount?: InputMaybe<Scalars['Int']>;
  calculation?: InputMaybe<Scalars['String']>;
  compensationType?: InputMaybe<Scalars['String']>;
  contractsTaxonomyId: Scalars['Int'];
  description?: InputMaybe<Scalars['String']>;
  firstPaymentOn?: InputMaybe<Scalars['ISO8601Date']>;
  id?: InputMaybe<Scalars['Int']>;
  minimumAmountOfHours?: InputMaybe<Scalars['Int']>;
  minimumAmountOfHoursInCents?: InputMaybe<Scalars['Int']>;
  payrollPolicyId?: InputMaybe<Scalars['Int']>;
  recurrence?: InputMaybe<Scalars['String']>;
  recurrenceCount?: InputMaybe<Scalars['Int']>;
  startsOn?: InputMaybe<Scalars['ISO8601Date']>;
  syncWithSupplements?: InputMaybe<Scalars['Boolean']>;
  timeCondition?: InputMaybe<ContractsValueObjectsTimeConditionEnum>;
  unit?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of PromoteContractsContractVersion. */
export type PromoteContractsContractVersionPayload = {
  __typename?: 'PromoteContractsContractVersionPayload';
  contractVersion?: Maybe<ContractsContractVersion>;
  errors: Array<MutationError>;
};

/** customer_support_detail */
export type PublicCustomerSupportDetail = {
  __typename?: 'PublicCustomerSupportDetail';
  companyId: Scalars['Int'];
  customCustomerContactUrl?: Maybe<Scalars['String']>;
  customCustomerSupportUrl?: Maybe<Scalars['String']>;
  customPrivacyPolicyUrl?: Maybe<Scalars['String']>;
  customTosEmployeeUrl?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The connection type for PublicCustomerSupportDetail. */
export type PublicCustomerSupportDetailConnection = {
  __typename?: 'PublicCustomerSupportDetailConnection';
  /** A list of edges. */
  edges: Array<PublicCustomerSupportDetailEdge>;
  /** A list of nodes. */
  nodes: Array<PublicCustomerSupportDetail>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PublicCustomerSupportDetailEdge = {
  __typename?: 'PublicCustomerSupportDetailEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PublicCustomerSupportDetail;
};

/** public videos. */
export type PublicVideosVideo = {
  __typename?: 'PublicVideosVideo';
  category?: Maybe<Scalars['String']>;
  contentType: Scalars['String'];
  id: Scalars['Int'];
  locale: Scalars['String'];
  name: Scalars['String'];
  url: Scalars['String'];
};

/** The connection type for PublicVideosVideo. */
export type PublicVideosVideoConnection = {
  __typename?: 'PublicVideosVideoConnection';
  /** A list of edges. */
  edges: Array<PublicVideosVideoEdge>;
  /** A list of nodes. */
  nodes: Array<PublicVideosVideo>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PublicVideosVideoEdge = {
  __typename?: 'PublicVideosVideoEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PublicVideosVideo;
};

/** Autogenerated return type of PublishChangesProcurementType. */
export type PublishChangesProcurementTypePayload = {
  __typename?: 'PublishChangesProcurementTypePayload';
  errors: Array<MutationError>;
  type?: Maybe<ProcurementType>;
};

/** Autogenerated return type of PublishFormsForm. */
export type PublishFormsFormPayload = {
  __typename?: 'PublishFormsFormPayload';
  errors: Array<MutationError>;
  form?: Maybe<FormsForm>;
};

/** Autogenerated return type of PublishHandbookpagesPage. */
export type PublishHandbookpagesPagePayload = {
  __typename?: 'PublishHandbookpagesPagePayload';
  errors: Array<MutationError>;
  page?: Maybe<HandbookPagesPage>;
};

/** Autogenerated return type of PublishPerformanceReviewEvaluationAnswer. */
export type PublishPerformanceReviewEvaluationAnswerPayload = {
  __typename?: 'PublishPerformanceReviewEvaluationAnswerPayload';
  errors: Array<MutationError>;
  reviewEvaluationAnswer?: Maybe<PerformanceReviewEvaluationAnswer>;
};

/** Autogenerated return type of PublishProcurementType. */
export type PublishProcurementTypePayload = {
  __typename?: 'PublishProcurementTypePayload';
  errors: Array<MutationError>;
  type?: Maybe<ProcurementType>;
};

/** Autogenerated return type of PublishShiftmanagementSchedule. */
export type PublishShiftmanagementSchedulePayload = {
  __typename?: 'PublishShiftmanagementSchedulePayload';
  errors: Array<MutationError>;
  schedule?: Maybe<ShiftManagementSchedule>;
};

/** Autogenerated return type of PublishSurveysSurvey. */
export type PublishSurveysSurveyPayload = {
  __typename?: 'PublishSurveysSurveyPayload';
  errors: Array<MutationError>;
  survey?: Maybe<SurveysSurvey>;
};

/** Autogenerated return type of PublishTemplateFormsForm. */
export type PublishTemplateFormsFormPayload = {
  __typename?: 'PublishTemplateFormsFormPayload';
  errors: Array<MutationError>;
  form?: Maybe<FormsForm>;
};

/** Autogenerated return type of PublishWorkflowsWorkflow. */
export type PublishWorkflowsWorkflowPayload = {
  __typename?: 'PublishWorkflowsWorkflowPayload';
  errors: Array<MutationError>;
  workflow?: Maybe<WorkflowsWorkflow>;
};

export type QuestionnairesQuestionnaireQuestionAnswerTypesEnum =
  | 'multiple_choice'
  | 'number'
  | 'rating'
  | 'text';

export type RateResource = EmployeesEmployee | JobCatalogLevel | JobCatalogTreeLevel | ProjectManagementProject | ProjectManagementProjectWorker;

/** Grouped reaction */
export type ReactionsGroupedReaction = {
  __typename?: 'ReactionsGroupedReaction';
  count: Scalars['Int'];
  resourceId: Scalars['Int'];
  resourceType: Scalars['String'];
  selfReactionId?: Maybe<Scalars['Int']>;
  supportersList: Array<Scalars['String']>;
  textCode: Scalars['String'];
};

/** The connection type for ReactionsGroupedReaction. */
export type ReactionsGroupedReactionConnection = {
  __typename?: 'ReactionsGroupedReactionConnection';
  /** A list of edges. */
  edges: Array<ReactionsGroupedReactionEdge>;
  /** A list of nodes. */
  nodes: Array<ReactionsGroupedReaction>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ReactionsGroupedReactionEdge = {
  __typename?: 'ReactionsGroupedReactionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ReactionsGroupedReaction;
};

/** Reaction */
export type ReactionsReaction = {
  __typename?: 'ReactionsReaction';
  author: ApiCoreAccess;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  authorId: Scalars['Int'];
  company: ApiCoreCompany;
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['Int'];
  resourceId: Scalars['Int'];
  resourceType: ReactionsValueObjectsResourceTypesEnum;
  textCode: Scalars['String'];
};


/** Reaction */
export type ReactionsReactionAuthorArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for ReactionsReaction. */
export type ReactionsReactionConnection = {
  __typename?: 'ReactionsReactionConnection';
  /** A list of edges. */
  edges: Array<ReactionsReactionEdge>;
  /** A list of nodes. */
  nodes: Array<ReactionsReaction>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ReactionsReactionEdge = {
  __typename?: 'ReactionsReactionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ReactionsReaction;
};

export type ReactionsValueObjectsResourceTypesEnum =
  | 'comments_comment'
  | 'posts_post';

/** Autogenerated return type of ReactivateBankingCard. */
export type ReactivateBankingCardPayload = {
  __typename?: 'ReactivateBankingCardPayload';
  card?: Maybe<BankingCard>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of ReadByIdExpensesInternalExpenseViewer. */
export type ReadByIdExpensesInternalExpenseViewerPayload = {
  __typename?: 'ReadByIdExpensesInternalExpenseViewerPayload';
  errors: Array<MutationError>;
  internalExpenseViewer?: Maybe<ExpensesInternalExpenseViewer>;
};

/** Autogenerated return type of ReadRandomExpensesInternalExpenseViewer. */
export type ReadRandomExpensesInternalExpenseViewerPayload = {
  __typename?: 'ReadRandomExpensesInternalExpenseViewerPayload';
  errors: Array<MutationError>;
  internalExpenseViewer?: Maybe<ExpensesInternalExpenseViewer>;
};

export type ReadyToReviewExpensesExpensableAllocationInput = {
  id?: InputMaybe<Scalars['Int']>;
  referenceId: Scalars['Int'];
  referenceType: Scalars['String'];
};

export type ReadyToReviewExpensesExpensableAssignmentsInput = {
  assignmentsToCreate: Array<ReadyToReviewExpensesExpensableAssignmentsToCreateInput>;
  assignmentsToUpdate: Array<ReadyToReviewExpensesExpensableAssignmentsToUpdateInput>;
};

export type ReadyToReviewExpensesExpensableAssignmentsToCreateInput = {
  costCenterId: Scalars['Int'];
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  percentage: Scalars['Float'];
  startDate: Scalars['ISO8601Date'];
};

export type ReadyToReviewExpensesExpensableAssignmentsToUpdateInput = {
  costCenterId: Scalars['Int'];
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  id: Scalars['Int'];
  markedForDeletion: Scalars['Boolean'];
  percentage: Scalars['Float'];
  startDate: Scalars['ISO8601Date'];
};

export type ReadyToReviewExpensesExpensableCostCentersInput = {
  allocation?: InputMaybe<ReadyToReviewExpensesExpensableAllocationInput>;
  assignments?: InputMaybe<ReadyToReviewExpensesExpensableAssignmentsInput>;
};

/** Autogenerated return type of ReadyToReviewExpensesExpensableGroup. */
export type ReadyToReviewExpensesExpensableGroupPayload = {
  __typename?: 'ReadyToReviewExpensesExpensableGroupPayload';
  errors: Array<MutationError>;
  expensableGroup?: Maybe<ExpensesExpensableGroup>;
};

/** Autogenerated return type of ReadyToReviewExpensesExpensable. */
export type ReadyToReviewExpensesExpensablePayload = {
  __typename?: 'ReadyToReviewExpensesExpensablePayload';
  errors: Array<MutationError>;
  expensable?: Maybe<ExpensesExpensable>;
};

export type ReadyToReviewExpensesExpensablePerDiemInput = {
  amount?: InputMaybe<Scalars['Int']>;
  amountCents?: InputMaybe<Scalars['Int']>;
  budgetId?: InputMaybe<Scalars['Int']>;
  categoryId?: InputMaybe<Scalars['Int']>;
  companyId: Scalars['Int'];
  currency?: InputMaybe<Scalars['String']>;
  deletedRates?: InputMaybe<Array<Scalars['Int']>>;
  description?: InputMaybe<Scalars['String']>;
  employeeId: Scalars['Int'];
  endDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  files: Array<Scalars['File']>;
  filesIdToRemove?: InputMaybe<Array<Scalars['Int']>>;
  from?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  internalReference?: InputMaybe<Scalars['String']>;
  projects?: InputMaybe<Array<ExpensesProjectInput>>;
  rates: Array<ReadyToReviewExpensesExpensableRatesInput>;
  signedForOrganization?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  subcategory?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
};

export type ReadyToReviewExpensesExpensableRatesInput = {
  id?: InputMaybe<Scalars['Int']>;
  rateConfigurationId: Scalars['Int'];
  totalAmountCents: Scalars['Int'];
  totalDays: Scalars['Int'];
};

export type ReadyToReviewExpensesExpensableTaxesInput = {
  amount?: InputMaybe<Scalars['Int']>;
  baseAmount?: InputMaybe<Scalars['Int']>;
  percentage?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<ExpensesCustomizationExpenseTaxesTypesEnum>;
};

/** Autogenerated return type of ReconnectExternalBankBankingOnboarding. */
export type ReconnectExternalBankBankingOnboardingPayload = {
  __typename?: 'ReconnectExternalBankBankingOnboardingPayload';
  errors: Array<MutationError>;
  onboarding?: Maybe<BankingOnboarding>;
};

/** Autogenerated return type of RecordDraftFinanceJournalEntry. */
export type RecordDraftFinanceJournalEntryPayload = {
  __typename?: 'RecordDraftFinanceJournalEntryPayload';
  errors: Array<MutationError>;
  journalEntry?: Maybe<FinanceJournalEntry>;
};

export type ReferenceContractsActiveBetweenInput = {
  from: Scalars['ISO8601Date'];
  to: Scalars['ISO8601Date'];
};

/** Autogenerated return type of RefreshAttendanceAggregatedBalance. */
export type RefreshAttendanceAggregatedBalancePayload = {
  __typename?: 'RefreshAttendanceAggregatedBalancePayload';
  aggregatedBalances?: Maybe<Array<AttendanceAggregatedBalance>>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of RefreshAttendanceBalance. */
export type RefreshAttendanceBalancePayload = {
  __typename?: 'RefreshAttendanceBalancePayload';
  balances?: Maybe<Array<AttendanceBalance>>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of RefreshAttendanceWorkedTime. */
export type RefreshAttendanceWorkedTimePayload = {
  __typename?: 'RefreshAttendanceWorkedTimePayload';
  errors: Array<MutationError>;
  workedTimes?: Maybe<Array<AttendanceWorkedTime>>;
};

/** Autogenerated return type of RefreshCompensationsEmployeesCompensationsValidation. */
export type RefreshCompensationsEmployeesCompensationsValidationPayload = {
  __typename?: 'RefreshCompensationsEmployeesCompensationsValidationPayload';
  employeesCompensationsValidation?: Maybe<CompensationsEmployeesCompensationsValidation>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of RefreshPerformanceAgreement. */
export type RefreshPerformanceAgreementPayload = {
  __typename?: 'RefreshPerformanceAgreementPayload';
  agreement?: Maybe<PerformanceAgreement>;
  errors: Array<MutationError>;
};

export type RegionFinderCountryEnum =
  | 'ar'
  | 'at'
  | 'be'
  | 'bg'
  | 'br'
  | 'ch'
  | 'cl'
  | 'co'
  | 'cy'
  | 'cz'
  | 'de'
  | 'dk'
  | 'ea'
  | 'ee'
  | 'es'
  | 'fi'
  | 'fr'
  | 'gb'
  | 'gr'
  | 'hr'
  | 'hu'
  | 'ic'
  | 'ie'
  | 'it'
  | 'lt'
  | 'lu'
  | 'lv'
  | 'mt'
  | 'mx'
  | 'nl'
  | 'pl'
  | 'pt'
  | 'ro'
  | 'se'
  | 'si'
  | 'sk'
  | 'us';

/** Autogenerated return type of RegisterSaleFinanceFinancialDocument. */
export type RegisterSaleFinanceFinancialDocumentPayload = {
  __typename?: 'RegisterSaleFinanceFinancialDocumentPayload';
  errors: Array<MutationError>;
  financialDocument?: Maybe<FinanceFinancialDocument>;
};

/** Autogenerated return type of RejectApprovalsMaterializedApprovalStepApprover. */
export type RejectApprovalsMaterializedApprovalStepApproverPayload = {
  __typename?: 'RejectApprovalsMaterializedApprovalStepApproverPayload';
  errors: Array<MutationError>;
  materializedApprovalStepApprover?: Maybe<ApprovalsMaterializedApprovalStepApprover>;
};

/** Autogenerated return type of RejectApprovalsMaterializedApprovalsFlow. */
export type RejectApprovalsMaterializedApprovalsFlowPayload = {
  __typename?: 'RejectApprovalsMaterializedApprovalsFlowPayload';
  errors: Array<MutationError>;
  materializedApprovalsFlow?: Maybe<ApprovalsMaterializedApprovalsFlow>;
};

/** Autogenerated return type of RejectAtsRequisition. */
export type RejectAtsRequisitionPayload = {
  __typename?: 'RejectAtsRequisitionPayload';
  errors: Array<MutationError>;
  requisition?: Maybe<AtsRequisition>;
};

/** Autogenerated return type of RejectAttendanceOvertimeRequest. */
export type RejectAttendanceOvertimeRequestPayload = {
  __typename?: 'RejectAttendanceOvertimeRequestPayload';
  errors: Array<MutationError>;
  overtimeRequest?: Maybe<AttendanceOvertimeRequest>;
};

/** Autogenerated return type of RejectBankingCard. */
export type RejectBankingCardPayload = {
  __typename?: 'RejectBankingCardPayload';
  card?: Maybe<BankingCard>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of RejectBankingReconciliationSuggestion. */
export type RejectBankingReconciliationSuggestionPayload = {
  __typename?: 'RejectBankingReconciliationSuggestionPayload';
  errors: Array<MutationError>;
  reconciliationSuggestion?: Maybe<BankingReconciliationSuggestion>;
};

/** Autogenerated return type of RejectContractsContractVersionRequest. */
export type RejectContractsContractVersionRequestPayload = {
  __typename?: 'RejectContractsContractVersionRequestPayload';
  contractVersionRequest?: Maybe<ContractsContractVersionRequest>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of RejectExpensesExpensableGroup. */
export type RejectExpensesExpensableGroupPayload = {
  __typename?: 'RejectExpensesExpensableGroupPayload';
  errors: Array<MutationError>;
  expensableGroup?: Maybe<ExpensesExpensableGroup>;
};

/** Autogenerated return type of RejectFinanceReconciliationSuggestion. */
export type RejectFinanceReconciliationSuggestionPayload = {
  __typename?: 'RejectFinanceReconciliationSuggestionPayload';
  errors: Array<MutationError>;
  reconciliationSuggestion?: Maybe<FinanceReconciliationSuggestion>;
};

/** Autogenerated return type of RejectIntegrationsjoinOrder. */
export type RejectIntegrationsjoinOrderPayload = {
  __typename?: 'RejectIntegrationsjoinOrderPayload';
  errors: Array<MutationError>;
  order?: Maybe<IntegrationsJoinOrder>;
};

/** Autogenerated return type of RejectProcurementPurchaseRequest. */
export type RejectProcurementPurchaseRequestPayload = {
  __typename?: 'RejectProcurementPurchaseRequestPayload';
  errors: Array<MutationError>;
  purchaseRequest?: Maybe<ProcurementPurchaseRequest>;
};

/** Autogenerated return type of RejectShiftmanagementSwapShift. */
export type RejectShiftmanagementSwapShiftPayload = {
  __typename?: 'RejectShiftmanagementSwapShiftPayload';
  errors: Array<MutationError>;
  swapShift?: Maybe<ShiftManagementSwapShift>;
};

/** Autogenerated return type of RejectTasksDraftOneononesTalkingPoint. */
export type RejectTasksDraftOneononesTalkingPointPayload = {
  __typename?: 'RejectTasksDraftOneononesTalkingPointPayload';
  errors: Array<MutationError>;
  talkingPoint?: Maybe<OneOnOnesTalkingPoint>;
};

/** Autogenerated return type of RejectTimeoffLeave. */
export type RejectTimeoffLeavePayload = {
  __typename?: 'RejectTimeoffLeavePayload';
  errors: Array<MutationError>;
  leave?: Maybe<TimeoffLeave>;
};

/** Autogenerated return type of RejectTrainingsTrainingRequest. */
export type RejectTrainingsTrainingRequestPayload = {
  __typename?: 'RejectTrainingsTrainingRequestPayload';
  errors: Array<MutationError>;
  trainingRequest?: Maybe<TrainingsTrainingRequest>;
};

/** Autogenerated return type of RemindInBulkPerformanceReviewProcess. */
export type RemindInBulkPerformanceReviewProcessPayload = {
  __typename?: 'RemindInBulkPerformanceReviewProcessPayload';
  errors: Array<MutationError>;
  reviewProcess?: Maybe<PerformanceReviewProcess>;
};

/** Autogenerated return type of RemoveAvatarUsersPersonalInfo. */
export type RemoveAvatarUsersPersonalInfoPayload = {
  __typename?: 'RemoveAvatarUsersPersonalInfoPayload';
  errors: Array<MutationError>;
  personalInfo?: Maybe<UsersPersonalInfo>;
};

/** Autogenerated return type of RemoveContractsPayrollPolicy. */
export type RemoveContractsPayrollPolicyPayload = {
  __typename?: 'RemoveContractsPayrollPolicyPayload';
  errors: Array<MutationError>;
  payrollPolicy?: Maybe<ContractsPayrollPolicy>;
};

/** Autogenerated return type of RemoveCvAtsApplication. */
export type RemoveCvAtsApplicationPayload = {
  __typename?: 'RemoveCvAtsApplicationPayload';
  application?: Maybe<AtsApplication>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of RemoveCvAtsCandidate. */
export type RemoveCvAtsCandidatePayload = {
  __typename?: 'RemoveCvAtsCandidatePayload';
  candidate?: Maybe<AtsCandidate>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of RemoveFaviconAtsCompany. */
export type RemoveFaviconAtsCompanyPayload = {
  __typename?: 'RemoveFaviconAtsCompanyPayload';
  company?: Maybe<AtsCompany>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of RemoveFileProcurementUploadDocumentTask. */
export type RemoveFileProcurementUploadDocumentTaskPayload = {
  __typename?: 'RemoveFileProcurementUploadDocumentTaskPayload';
  errors: Array<MutationError>;
  uploadDocumentTask?: Maybe<ProcurementUploadDocumentTask>;
};

/** Autogenerated return type of RemoveFromPayrollExpensesExpensableGroup. */
export type RemoveFromPayrollExpensesExpensableGroupPayload = {
  __typename?: 'RemoveFromPayrollExpensesExpensableGroupPayload';
  errors: Array<MutationError>;
  expensableGroup?: Maybe<ExpensesExpensableGroup>;
};

/** Autogenerated return type of RemoveFromTrashBinDocumentsDocument. */
export type RemoveFromTrashBinDocumentsDocumentPayload = {
  __typename?: 'RemoveFromTrashBinDocumentsDocumentPayload';
  documents?: Maybe<Array<DocumentsDocument>>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of RemoveLegalEntityJobcatalogRole. */
export type RemoveLegalEntityJobcatalogRolePayload = {
  __typename?: 'RemoveLegalEntityJobcatalogRolePayload';
  errors: Array<MutationError>;
  role?: Maybe<JobCatalogRole>;
};

/** Autogenerated return type of RemovePeerEvaluationsPerformanceReviewProcessTarget. */
export type RemovePeerEvaluationsPerformanceReviewProcessTargetPayload = {
  __typename?: 'RemovePeerEvaluationsPerformanceReviewProcessTargetPayload';
  errors: Array<MutationError>;
  reviewProcessTarget?: Maybe<PerformanceReviewProcessTarget>;
};

/** Autogenerated return type of RemoveSchedulePerformanceReviewProcess. */
export type RemoveSchedulePerformanceReviewProcessPayload = {
  __typename?: 'RemoveSchedulePerformanceReviewProcessPayload';
  errors: Array<MutationError>;
  reviewProcess?: Maybe<PerformanceReviewProcess>;
};

/** Autogenerated return type of RemoveSupervisorJobcatalogRole. */
export type RemoveSupervisorJobcatalogRolePayload = {
  __typename?: 'RemoveSupervisorJobcatalogRolePayload';
  errors: Array<MutationError>;
  role?: Maybe<JobCatalogRole>;
};

/** Autogenerated return type of RemoveTagAtsCandidate. */
export type RemoveTagAtsCandidatePayload = {
  __typename?: 'RemoveTagAtsCandidatePayload';
  candidate?: Maybe<AtsCandidate>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of RemoveUnconfirmedCommunicationsEmailUsersPersonalInfo. */
export type RemoveUnconfirmedCommunicationsEmailUsersPersonalInfoPayload = {
  __typename?: 'RemoveUnconfirmedCommunicationsEmailUsersPersonalInfoPayload';
  errors: Array<MutationError>;
  personalInfo?: Maybe<UsersPersonalInfo>;
};

/** Autogenerated return type of RenameFinanceCustomDimension. */
export type RenameFinanceCustomDimensionPayload = {
  __typename?: 'RenameFinanceCustomDimensionPayload';
  customDimension?: Maybe<FinanceCustomDimension>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of RenameProjectmanagementSubproject. */
export type RenameProjectmanagementSubprojectPayload = {
  __typename?: 'RenameProjectmanagementSubprojectPayload';
  errors: Array<MutationError>;
  subproject?: Maybe<ProjectManagementSubproject>;
};

/** Autogenerated return type of RenewConsentAtsCandidate. */
export type RenewConsentAtsCandidatePayload = {
  __typename?: 'RenewConsentAtsCandidatePayload';
  candidate?: Maybe<AtsCandidate>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of RenewConsentDateAtsCandidate. */
export type RenewConsentDateAtsCandidatePayload = {
  __typename?: 'RenewConsentDateAtsCandidatePayload';
  candidate?: Maybe<AtsCandidate>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of ReopenPerformanceReviewProcess. */
export type ReopenPerformanceReviewProcessPayload = {
  __typename?: 'ReopenPerformanceReviewProcessPayload';
  errors: Array<MutationError>;
  reviewProcess?: Maybe<PerformanceReviewProcess>;
};

export type ReorderByCompetencyCompetenciesCompetencyLevelLevelPositionsInput = {
  id: Scalars['Int'];
  position: Scalars['Int'];
};

/** Autogenerated return type of ReorderByCompetencyCompetenciesCompetencyLevel. */
export type ReorderByCompetencyCompetenciesCompetencyLevelPayload = {
  __typename?: 'ReorderByCompetencyCompetenciesCompetencyLevelPayload';
  competencyLevels?: Maybe<Array<CompetenciesCompetencyLevel>>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of ReorderLayoutFavourite. */
export type ReorderLayoutFavouritePayload = {
  __typename?: 'ReorderLayoutFavouritePayload';
  errors: Array<MutationError>;
  favourites?: Maybe<Array<LayoutFavourite>>;
};

/** Autogenerated return type of ReplaceEmployeeReviewerPerformanceReviewEvaluation. */
export type ReplaceEmployeeReviewerPerformanceReviewEvaluationPayload = {
  __typename?: 'ReplaceEmployeeReviewerPerformanceReviewEvaluationPayload';
  errors: Array<MutationError>;
  reviewEvaluation?: Maybe<PerformanceReviewEvaluation>;
};

/** Autogenerated return type of ReplaceReviewerPerformanceReviewEvaluation. */
export type ReplaceReviewerPerformanceReviewEvaluationPayload = {
  __typename?: 'ReplaceReviewerPerformanceReviewEvaluationPayload';
  errors: Array<MutationError>;
  reviewEvaluation?: Maybe<PerformanceReviewEvaluation>;
};

/** Reports attribute */
export type ReportsAttribute = {
  __typename?: 'ReportsAttribute';
  category?: Maybe<Scalars['String']>;
  categoryDescription?: Maybe<Scalars['String']>;
  categoryLabel?: Maybe<Scalars['String']>;
  cohortsSupport?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  enumOptions?: Maybe<Array<Scalars['String']>>;
  expirationDate?: Maybe<Scalars['ISO8601Date']>;
  exposer?: Maybe<Scalars['String']>;
  foreignKey?: Maybe<Scalars['String']>;
  hasDeprecatedPath?: Maybe<Scalars['Boolean']>;
  isIdentifier: Scalars['Boolean'];
  key: Scalars['String'];
  label?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  range?: Maybe<Array<Scalars['Int']>>;
  relatable: Scalars['Boolean'];
  subcategory: Scalars['String'];
  subcategoryDescription?: Maybe<Scalars['String']>;
  subcategoryLabel?: Maybe<Scalars['String']>;
  supportedChartTypes: Array<ReportsValuesReportsChartTypeEnum>;
  supportedEditors: Array<ReportsValuesFieldsEditorEnum>;
  table: Scalars['String'];
  type: ReportsValuesFieldsTypeEnum;
  uiType?: Maybe<ReportsValuesFieldsUiTypeEnum>;
  unitLabel?: Maybe<Scalars['String']>;
};

/** The connection type for ReportsAttribute. */
export type ReportsAttributeConnection = {
  __typename?: 'ReportsAttributeConnection';
  /** A list of edges. */
  edges: Array<ReportsAttributeEdge>;
  /** A list of nodes. */
  nodes: Array<ReportsAttribute>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ReportsAttributeEdge = {
  __typename?: 'ReportsAttributeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ReportsAttribute;
};

/** Categorical Example of an Insight */
export type ReportsCategoricalExample = {
  __typename?: 'ReportsCategoricalExample';
  categories: Array<Scalars['String']>;
  series: Array<Scalars['Int']>;
};

/** The connection type for ReportsCategoricalExample. */
export type ReportsCategoricalExampleConnection = {
  __typename?: 'ReportsCategoricalExampleConnection';
  /** A list of edges. */
  edges: Array<ReportsCategoricalExampleEdge>;
  /** A list of nodes. */
  nodes: Array<ReportsCategoricalExample>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ReportsCategoricalExampleEdge = {
  __typename?: 'ReportsCategoricalExampleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ReportsCategoricalExample;
};

/** Contents are the information resulting from executing a report */
export type ReportsContent = {
  __typename?: 'ReportsContent';
  engine: ReportsValuesContentsEngineEnum;
  lastUpdate: Scalars['ISO8601DateTime'];
  rows: Scalars['String'];
  status: ReportsValuesContentsStatusEnum;
};

export type ReportsContextlessPolicies = {
  __typename?: 'ReportsContextlessPolicies';
  commandBarUseReports: ContextlessPolicyResolution;
  useReports: ContextlessPolicyResolution;
};

/** Reports dashboard */
export type ReportsDashboard = {
  __typename?: 'ReportsDashboard';
  author?: Maybe<ApiCoreAccess>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  authorId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  description?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  identifier?: Maybe<Scalars['String']>;
  isReadonly?: Maybe<Scalars['Boolean']>;
  tags?: Maybe<Array<Scalars['String']>>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  variables?: Maybe<Array<ReportsVariable>>;
};


/** Reports dashboard */
export type ReportsDashboardAuthorArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for ReportsDashboard. */
export type ReportsDashboardConnection = {
  __typename?: 'ReportsDashboardConnection';
  /** A list of edges. */
  edges: Array<ReportsDashboardEdge>;
  /** A list of nodes. */
  nodes: Array<ReportsDashboard>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ReportsDashboardEdge = {
  __typename?: 'ReportsDashboardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ReportsDashboard;
};

export type ReportsDtosExportInsightsTypeEnum =
  | 'csv'
  | 'xlsx';

export type ReportsEntitiesInsightsFilterFilterTypeEnum =
  | 'genders'
  | 'nationalities';

export type ReportsEntitiesSharesModeEnum =
  | 'become'
  | 'personal';

export type ReportsEntitiesSharesVisibilityEnum =
  | 'editor'
  | 'viewer';

export type ReportsError = {
  __typename?: 'ReportsError';
  fields: Array<Scalars['String']>;
};

/** Export insights */
export type ReportsExportInsight = {
  __typename?: 'ReportsExportInsight';
  documentId: Scalars['Int'];
};

/** Reports favourite */
export type ReportsFavourite = {
  __typename?: 'ReportsFavourite';
  authorId: Scalars['Int'];
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  dashboardId: Scalars['Int'];
  id?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** The connection type for ReportsFavourite. */
export type ReportsFavouriteConnection = {
  __typename?: 'ReportsFavouriteConnection';
  /** A list of edges. */
  edges: Array<ReportsFavouriteEdge>;
  /** A list of nodes. */
  nodes: Array<ReportsFavourite>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ReportsFavouriteEdge = {
  __typename?: 'ReportsFavouriteEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ReportsFavourite;
};

/** Insights are analytical widgets that display graphs */
export type ReportsInsightWidget = {
  __typename?: 'ReportsInsightWidget';
  data: Scalars['String'];
};

/** The connection type for ReportsInsightWidget. */
export type ReportsInsightWidgetConnection = {
  __typename?: 'ReportsInsightWidgetConnection';
  /** A list of edges. */
  edges: Array<ReportsInsightWidgetEdge>;
  /** A list of nodes. */
  nodes: Array<ReportsInsightWidget>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ReportsInsightWidgetEdge = {
  __typename?: 'ReportsInsightWidgetEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ReportsInsightWidget;
};

export type ReportsInsightsCycleEnum =
  | 'daily'
  | 'monthly'
  | 'quarterly'
  | 'weekly';

/** Reports insights filter */
export type ReportsInsightsFilter = {
  __typename?: 'ReportsInsightsFilter';
  filterType: ReportsEntitiesInsightsFilterFilterTypeEnum;
  values: Array<Scalars['String']>;
};

/** The connection type for ReportsInsightsFilter. */
export type ReportsInsightsFilterConnection = {
  __typename?: 'ReportsInsightsFilterConnection';
  /** A list of edges. */
  edges: Array<ReportsInsightsFilterEdge>;
  /** A list of nodes. */
  nodes: Array<ReportsInsightsFilter>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ReportsInsightsFilterEdge = {
  __typename?: 'ReportsInsightsFilterEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ReportsInsightsFilter;
};

/** Reports refresh */
export type ReportsRefresh = {
  __typename?: 'ReportsRefresh';
  id: Scalars['Int'];
  isEmpty: Scalars['Boolean'];
  isRunning: Scalars['Boolean'];
  lastRefreshTime?: Maybe<Scalars['ISO8601DateTime']>;
  status: ReportsValuesRefreshStatusEnum;
};

/** The connection type for ReportsRefresh. */
export type ReportsRefreshConnection = {
  __typename?: 'ReportsRefreshConnection';
  /** A list of edges. */
  edges: Array<ReportsRefreshEdge>;
  /** A list of nodes. */
  nodes: Array<ReportsRefresh>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ReportsRefreshEdge = {
  __typename?: 'ReportsRefreshEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ReportsRefresh;
};

/** A report is a Business Intelligence query over the data of a company */
export type ReportsReport = {
  __typename?: 'ReportsReport';
  _policies?: Maybe<ReportsReportPolicies>;
  _policiesCollection?: Maybe<Array<PermissionsPolicyResolution>>;
  _policiesConnection: PermissionsPolicyResolutionConnection;
  authorId?: Maybe<Scalars['Int']>;
  chartType: Scalars['String'];
  companyId: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  dashboardId: Scalars['Int'];
  id: Scalars['Int'];
  identifier?: Maybe<Scalars['String']>;
  jsonQuery?: Maybe<Scalars['String']>;
  origin?: Maybe<Scalars['String']>;
  retrievedAt: Scalars['ISO8601DateTime'];
  sqlQuery?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  variables: Scalars['String'];
};


/** A report is a Business Intelligence query over the data of a company */
export type ReportsReport_PoliciesCollectionArgs = {
  ids: Array<ReportsReportPoliciesEnum>;
};


/** A report is a Business Intelligence query over the data of a company */
export type ReportsReport_PoliciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for ReportsReport. */
export type ReportsReportConnection = {
  __typename?: 'ReportsReportConnection';
  /** A list of edges. */
  edges: Array<ReportsReportEdge>;
  /** A list of nodes. */
  nodes: Array<ReportsReport>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ReportsReportEdge = {
  __typename?: 'ReportsReportEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ReportsReport;
};

export type ReportsReportInput = {
  rows: Array<ReportsRowInput>;
  title: Scalars['String'];
};

export type ReportsReportPolicies = {
  __typename?: 'ReportsReportPolicies';
  share: PermissionsPolicyResolution;
};

export type ReportsReportPoliciesEnum =
  | 'share';

export type ReportsRowInput = {
  columns: Array<Scalars['String']>;
};

/** Single Value Example of an Insight */
export type ReportsSingleValueExample = {
  __typename?: 'ReportsSingleValueExample';
  max?: Maybe<Scalars['Int']>;
  min?: Maybe<Scalars['Int']>;
  value: Scalars['Int'];
};

/** The connection type for ReportsSingleValueExample. */
export type ReportsSingleValueExampleConnection = {
  __typename?: 'ReportsSingleValueExampleConnection';
  /** A list of edges. */
  edges: Array<ReportsSingleValueExampleEdge>;
  /** A list of nodes. */
  nodes: Array<ReportsSingleValueExample>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ReportsSingleValueExampleEdge = {
  __typename?: 'ReportsSingleValueExampleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ReportsSingleValueExample;
};

export type ReportsSqlConfiguration = {
  __typename?: 'ReportsSqlConfiguration';
  initialData?: Maybe<Scalars['String']>;
  secondaryData?: Maybe<Scalars['String']>;
  tertiaryData?: Maybe<Scalars['String']>;
};

/** Reports template */
export type ReportsTemplate = {
  __typename?: 'ReportsTemplate';
  categorySlug: Scalars['String'];
  description: Scalars['String'];
  slug: Scalars['String'];
  sqlConfiguration?: Maybe<ReportsSqlConfiguration>;
  sqlQuery?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  type: Scalars['String'];
};

/** The connection type for ReportsTemplate. */
export type ReportsTemplateConnection = {
  __typename?: 'ReportsTemplateConnection';
  /** A list of edges. */
  edges: Array<ReportsTemplateEdge>;
  /** A list of nodes. */
  nodes: Array<ReportsTemplate>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ReportsTemplateEdge = {
  __typename?: 'ReportsTemplateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ReportsTemplate;
};

/** Reports validate projection */
export type ReportsValidateProjection = {
  __typename?: 'ReportsValidateProjection';
  errors: ReportsError;
  isValid: Scalars['Boolean'];
};

export type ReportsValuesContentsEngineEnum =
  | 'athena';

export type ReportsValuesContentsStatusEnum =
  | 'ok'
  | 'outdated';

export type ReportsValuesDashboardsVariableTypeEnum =
  | 'date'
  | 'team'
  | 'text';

export type ReportsValuesFieldsEditorEnum =
  | 'query_builder'
  | 'sql_editor';

export type ReportsValuesFieldsTypeEnum =
  | 'boolean'
  | 'cohort'
  | 'date'
  | 'decimal'
  | 'number'
  | 'text';

export type ReportsValuesFieldsUiTypeEnum =
  | 'cents'
  | 'enum'
  | 'hours'
  | 'link'
  | 'money'
  | 'rating'
  | 'text';

export type ReportsValuesRefreshStatusEnum =
  | 'empty'
  | 'ready'
  | 'running';

export type ReportsValuesReportsChartTypeEnum =
  | 'area'
  | 'bars'
  | 'lines'
  | 'numeric_metric'
  | 'pie'
  | 'scatterplot'
  | 'table';

export type ReportsVariable = {
  __typename?: 'ReportsVariable';
  defaultValue?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  type?: Maybe<ReportsValuesDashboardsVariableTypeEnum>;
};

export type ReportsVariableInput = {
  defaultValue?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  type?: InputMaybe<ReportsValuesDashboardsVariableTypeEnum>;
};

/** Autogenerated return type of RepublishPerformanceReviewEvaluationAnswer. */
export type RepublishPerformanceReviewEvaluationAnswerPayload = {
  __typename?: 'RepublishPerformanceReviewEvaluationAnswerPayload';
  errors: Array<MutationError>;
  reviewEvaluationAnswer?: Maybe<PerformanceReviewEvaluationAnswer>;
};

/** Autogenerated return type of RequestChangesApprovalsMaterializedApprovalsFlow. */
export type RequestChangesApprovalsMaterializedApprovalsFlowPayload = {
  __typename?: 'RequestChangesApprovalsMaterializedApprovalsFlowPayload';
  errors: Array<MutationError>;
  materializedApprovalsFlow?: Maybe<ApprovalsMaterializedApprovalsFlow>;
};

/** Autogenerated return type of RequestChangesExpensesExpensable. */
export type RequestChangesExpensesExpensablePayload = {
  __typename?: 'RequestChangesExpensesExpensablePayload';
  errors: Array<MutationError>;
  expensable?: Maybe<ExpensesExpensable>;
};

export type RequestSingleUseBankingCardCardholderDataInput = {
  dateOfBirth: Scalars['ISO8601Date'];
  email?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phoneCountryCode: Scalars['String'];
  phoneNumber: Scalars['String'];
};

/** Autogenerated return type of RequestSingleUseBankingCard. */
export type RequestSingleUseBankingCardPayload = {
  __typename?: 'RequestSingleUseBankingCardPayload';
  card?: Maybe<BankingCard>;
  errors: Array<MutationError>;
};

export type RequestVirtualBankingCardCardholderDataInput = {
  dateOfBirth: Scalars['ISO8601Date'];
  email?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phoneCountryCode: Scalars['String'];
  phoneNumber: Scalars['String'];
};

/** Autogenerated return type of RequestVirtualBankingCard. */
export type RequestVirtualBankingCardPayload = {
  __typename?: 'RequestVirtualBankingCardPayload';
  card?: Maybe<BankingCard>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of ResendSignatureEsignatureSignature. */
export type ResendSignatureEsignatureSignaturePayload = {
  __typename?: 'ResendSignatureEsignatureSignaturePayload';
  errors: Array<MutationError>;
  signature?: Maybe<EsignatureSignature>;
};

/** Autogenerated return type of ResetFeaturesFeature. */
export type ResetFeaturesFeaturePayload = {
  __typename?: 'ResetFeaturesFeaturePayload';
  errors: Array<MutationError>;
  feature?: Maybe<FeaturesFeature>;
};

export type RestartApprovalFlowApprovalsMaterializedApprovalsFlowEmailDetailBlocksInput = {
  key: Scalars['String'];
  keyLabel?: InputMaybe<Scalars['String']>;
  type: ApprovalsEntitiesEmailDetailBlockTypeEnum;
};

/** Autogenerated return type of RestartApprovalFlowApprovalsMaterializedApprovalsFlow. */
export type RestartApprovalFlowApprovalsMaterializedApprovalsFlowPayload = {
  __typename?: 'RestartApprovalFlowApprovalsMaterializedApprovalsFlowPayload';
  errors: Array<MutationError>;
  materializedApprovalsFlow?: Maybe<ApprovalsMaterializedApprovalsFlow>;
};

/** Autogenerated return type of RestartReviewExpensesExpensableGroup. */
export type RestartReviewExpensesExpensableGroupPayload = {
  __typename?: 'RestartReviewExpensesExpensableGroupPayload';
  errors: Array<MutationError>;
  expensableGroup?: Maybe<ExpensesExpensableGroup>;
};

/** Autogenerated return type of RestoreFromTrashBinDocumentsDocument. */
export type RestoreFromTrashBinDocumentsDocumentPayload = {
  __typename?: 'RestoreFromTrashBinDocumentsDocumentPayload';
  documents?: Maybe<Array<DocumentsDocument>>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of RestoreHandbookpagesPageVersion. */
export type RestoreHandbookpagesPageVersionPayload = {
  __typename?: 'RestoreHandbookpagesPageVersionPayload';
  errors: Array<MutationError>;
  pageVersion?: Maybe<HandbookPagesPageVersion>;
};

/** Autogenerated return type of ResumeContractsContract. */
export type ResumeContractsContractPayload = {
  __typename?: 'ResumeContractsContractPayload';
  contract?: Maybe<ContractsContract>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of RetryBankingPayment. */
export type RetryBankingPaymentPayload = {
  __typename?: 'RetryBankingPaymentPayload';
  errors: Array<MutationError>;
  payment?: Maybe<BankingPayment>;
};

/** Autogenerated return type of RevertPaidExpensesExpensableGroup. */
export type RevertPaidExpensesExpensableGroupPayload = {
  __typename?: 'RevertPaidExpensesExpensableGroupPayload';
  errors: Array<MutationError>;
  expensableGroup?: Maybe<ExpensesExpensableGroup>;
};

export type ReviewEvaluationCategoricalsManagedByFilterInput = {
  managerEmployeeId: Scalars['Int'];
  onlyDirectReports: Scalars['Boolean'];
};

export type ReviewEvaluationsWithTargetsManagedByFilterInput = {
  managerEmployeeId: Scalars['Int'];
  onlyDirectReports: Scalars['Boolean'];
};

export type ReviewFinalEmployeeScoresManagedByFilterInput = {
  managerEmployeeId: Scalars['Int'];
  onlyDirectReports: Scalars['Boolean'];
};

export type ReviewProcessAnalyticsWithTargetsManagedByFilterInput = {
  managerEmployeeId: Scalars['Int'];
  onlyDirectReports: Scalars['Boolean'];
};

export type ReviewProcessParticipationRatesManagedByFilterInput = {
  managerEmployeeId: Scalars['Int'];
  onlyDirectReports: Scalars['Boolean'];
};

export type ReviewProcessScoreMetadataManagedByFilterInput = {
  managerEmployeeId: Scalars['Int'];
  onlyDirectReports: Scalars['Boolean'];
};

export type ReviewProcessTargetsManagedByFilterInput = {
  managerEmployeeId: Scalars['Int'];
  onlyDirectReports: Scalars['Boolean'];
};

export type ReviewStrategyEmployeeScoresManagedByFilterInput = {
  managerEmployeeId: Scalars['Int'];
  onlyDirectReports: Scalars['Boolean'];
};

/** Autogenerated return type of RevokeAccessCompaniesCompany. */
export type RevokeAccessCompaniesCompanyPayload = {
  __typename?: 'RevokeAccessCompaniesCompanyPayload';
  company?: Maybe<CompaniesCompany>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of RevokeCronofyschedulingCalendarSync. */
export type RevokeCronofyschedulingCalendarSyncPayload = {
  __typename?: 'RevokeCronofyschedulingCalendarSyncPayload';
  calendarSync?: Maybe<CronofySchedulingCalendarSync>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of RevokeIntegrationsdatevlaudsOauthToken. */
export type RevokeIntegrationsdatevlaudsOauthTokenPayload = {
  __typename?: 'RevokeIntegrationsdatevlaudsOauthTokenPayload';
  errors: Array<MutationError>;
  oauthToken?: Maybe<IntegrationsDatevLaudsOauthToken>;
};

/** Autogenerated return type of RevokeTransfersBankingPayment. */
export type RevokeTransfersBankingPaymentPayload = {
  __typename?: 'RevokeTransfersBankingPaymentPayload';
  errors: Array<MutationError>;
  payment?: Maybe<BankingPayment>;
};

/** Salary advance balance for an employee, showing earned amounts, requested amounts, and available balance */
export type SalaryAdvanceBalance = {
  __typename?: 'SalaryAdvanceBalance';
  amountCentsAvailable: Scalars['Int'];
  amountCentsEarned: Scalars['Int'];
  amountCentsRequestCap: Scalars['Int'];
  amountCentsRequested: Scalars['Int'];
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  employeeId: Scalars['Int'];
  employeeName?: Maybe<EmployeesEmployeeName>;
};


/** Salary advance balance for an employee, showing earned amounts, requested amounts, and available balance */
export type SalaryAdvanceBalanceEmployeeNameArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  afterEmployeeId?: InputMaybe<Scalars['Int']>;
  beforeEmployeeId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  reporteesOrLed?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyId?: InputMaybe<Scalars['Int']>;
  verb?: InputMaybe<Scalars['String']>;
  withActiveContract?: Scalars['Boolean'];
};

/** The connection type for SalaryAdvanceBalance. */
export type SalaryAdvanceBalanceConnection = {
  __typename?: 'SalaryAdvanceBalanceConnection';
  /** A list of edges. */
  edges: Array<SalaryAdvanceBalanceEdge>;
  /** A list of nodes. */
  nodes: Array<SalaryAdvanceBalance>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type SalaryAdvanceBalanceEdge = {
  __typename?: 'SalaryAdvanceBalanceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: SalaryAdvanceBalance;
};

/** Salary advance company configuration */
export type SalaryAdvanceCompanySetting = {
  __typename?: 'SalaryAdvanceCompanySetting';
  advanceCapMonthlyWagePercent?: Maybe<Scalars['Int']>;
  companyId: Scalars['Int'];
  id: Scalars['Int'];
  requestDeadlineDay: Scalars['Int'];
  serviceEnabled: Scalars['Boolean'];
};

/** The connection type for SalaryAdvanceCompanySetting. */
export type SalaryAdvanceCompanySettingConnection = {
  __typename?: 'SalaryAdvanceCompanySettingConnection';
  /** A list of edges. */
  edges: Array<SalaryAdvanceCompanySettingEdge>;
  /** A list of nodes. */
  nodes: Array<SalaryAdvanceCompanySetting>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type SalaryAdvanceCompanySettingEdge = {
  __typename?: 'SalaryAdvanceCompanySettingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: SalaryAdvanceCompanySetting;
};

/** the filter for the company_settings resource */
export type SalaryAdvanceCompanySettingFilter = {
  advanceCapMonthlyWagePercent?: InputMaybe<IntegerFilter>;
  companyId?: InputMaybe<IntegerFilter>;
  id?: InputMaybe<IntegerFilter>;
  or?: InputMaybe<Array<SalaryAdvanceCompanySettingFilterConditions>>;
  requestDeadlineDay?: InputMaybe<IntegerFilter>;
  serviceEnabled?: InputMaybe<BooleanFilter>;
};

export type SalaryAdvanceCompanySettingFilterConditions = {
  advanceCapMonthlyWagePercent?: InputMaybe<IntegerFilter>;
  companyId?: InputMaybe<IntegerFilter>;
  id?: InputMaybe<IntegerFilter>;
  requestDeadlineDay?: InputMaybe<IntegerFilter>;
  serviceEnabled?: InputMaybe<BooleanFilter>;
};

/** Employee salary advance compensations */
export type SalaryAdvanceCompensation = {
  __typename?: 'SalaryAdvanceCompensation';
  amountCents: Scalars['Int'];
  companyId: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  currency: Scalars['String'];
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  employeeId: Scalars['Int'];
  employeeName?: Maybe<EmployeesEmployeeName>;
  firstName: Scalars['String'];
  id: Scalars['String'];
  lastName: Scalars['String'];
  numberOfTransactions: Scalars['Int'];
  requests: Array<SalaryAdvanceRequest>;
  requestsConnection: SalaryAdvanceRequestConnection;
  totalAmountRequested: Scalars['Int'];
  updatedAt: Scalars['ISO8601DateTime'];
};


/** Employee salary advance compensations */
export type SalaryAdvanceCompensationEmployeeNameArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  afterEmployeeId?: InputMaybe<Scalars['Int']>;
  beforeEmployeeId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  reporteesOrLed?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyId?: InputMaybe<Scalars['Int']>;
  verb?: InputMaybe<Scalars['String']>;
  withActiveContract?: Scalars['Boolean'];
};


/** Employee salary advance compensations */
export type SalaryAdvanceCompensationRequestsArgs = {
  createdAfter?: InputMaybe<Scalars['ISO8601DateTime']>;
  createdBefore?: InputMaybe<Scalars['ISO8601DateTime']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  status?: InputMaybe<SalaryAdvanceValueObjectsRequestStatusEnum>;
};


/** Employee salary advance compensations */
export type SalaryAdvanceCompensationRequestsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  createdAfter?: InputMaybe<Scalars['ISO8601DateTime']>;
  createdBefore?: InputMaybe<Scalars['ISO8601DateTime']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  status?: InputMaybe<SalaryAdvanceValueObjectsRequestStatusEnum>;
};

/** The connection type for SalaryAdvanceCompensation. */
export type SalaryAdvanceCompensationConnection = {
  __typename?: 'SalaryAdvanceCompensationConnection';
  /** A list of edges. */
  edges: Array<SalaryAdvanceCompensationEdge>;
  /** A list of nodes. */
  nodes: Array<SalaryAdvanceCompensation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type SalaryAdvanceCompensationEdge = {
  __typename?: 'SalaryAdvanceCompensationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: SalaryAdvanceCompensation;
};

/** the filter for the compensations resource */
export type SalaryAdvanceCompensationFilter = {
  amountCents?: InputMaybe<IntegerFilter>;
  companyId?: InputMaybe<IntegerFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<StringFilter>;
  employeeId?: InputMaybe<IntegerFilter>;
  firstName?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  lastName?: InputMaybe<StringFilter>;
  numberOfTransactions?: InputMaybe<IntegerFilter>;
  or?: InputMaybe<Array<SalaryAdvanceCompensationFilterConditions>>;
  totalAmountRequested?: InputMaybe<IntegerFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type SalaryAdvanceCompensationFilterConditions = {
  amountCents?: InputMaybe<IntegerFilter>;
  companyId?: InputMaybe<IntegerFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<StringFilter>;
  employeeId?: InputMaybe<IntegerFilter>;
  firstName?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  lastName?: InputMaybe<StringFilter>;
  numberOfTransactions?: InputMaybe<IntegerFilter>;
  totalAmountRequested?: InputMaybe<IntegerFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type SalaryAdvanceContextlessPolicies = {
  __typename?: 'SalaryAdvanceContextlessPolicies';
  manageSalaryAdvance: ContextlessPolicyResolution;
  salaryAdvanceEnabled: ContextlessPolicyResolution;
};

/** Employee profiles for salary advance with computed salary data */
export type SalaryAdvanceEmployeeProfile = {
  __typename?: 'SalaryAdvanceEmployeeProfile';
  bankNumber?: Maybe<Scalars['String']>;
  companyId: Scalars['Int'];
  currency?: Maybe<Scalars['String']>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  employeeId: Scalars['Int'];
  employeeName?: Maybe<EmployeesEmployeeName>;
  maxMonthlyAccrualCents?: Maybe<Scalars['Int']>;
  /** Indicates if the employee is missing valid bank information (account number or number format) */
  missingBankInfo: Scalars['Boolean'];
  /** Indicates if the employee is missing salary information (amount or frequency) */
  missingSalaryInfo: Scalars['Boolean'];
  netSalaryCents?: Maybe<Scalars['Int']>;
  status: SalaryAdvanceValueObjectsEmployeeStatusEnum;
};


/** Employee profiles for salary advance with computed salary data */
export type SalaryAdvanceEmployeeProfileEmployeeNameArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  afterEmployeeId?: InputMaybe<Scalars['Int']>;
  beforeEmployeeId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  reporteesOrLed?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyId?: InputMaybe<Scalars['Int']>;
  verb?: InputMaybe<Scalars['String']>;
  withActiveContract?: Scalars['Boolean'];
};

/** The connection type for SalaryAdvanceEmployeeProfile. */
export type SalaryAdvanceEmployeeProfileConnection = {
  __typename?: 'SalaryAdvanceEmployeeProfileConnection';
  /** A list of edges. */
  edges: Array<SalaryAdvanceEmployeeProfileEdge>;
  /** A list of nodes. */
  nodes: Array<SalaryAdvanceEmployeeProfile>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type SalaryAdvanceEmployeeProfileEdge = {
  __typename?: 'SalaryAdvanceEmployeeProfileEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: SalaryAdvanceEmployeeProfile;
};

/** the filter for the employee_profiles resource */
export type SalaryAdvanceEmployeeProfileFilter = {
  maxMonthlyAccrualCents?: InputMaybe<IntegerFilter>;
  missingBankInfo?: InputMaybe<BooleanFilter>;
  missingSalaryInfo?: InputMaybe<BooleanFilter>;
  netSalaryCents?: InputMaybe<IntegerFilter>;
  or?: InputMaybe<Array<SalaryAdvanceEmployeeProfileFilterConditions>>;
  status?: InputMaybe<StringFilter>;
};

export type SalaryAdvanceEmployeeProfileFilterConditions = {
  maxMonthlyAccrualCents?: InputMaybe<IntegerFilter>;
  missingBankInfo?: InputMaybe<BooleanFilter>;
  missingSalaryInfo?: InputMaybe<BooleanFilter>;
  netSalaryCents?: InputMaybe<IntegerFilter>;
  status?: InputMaybe<StringFilter>;
};

/** Employee salary advance requests */
export type SalaryAdvanceRequest = {
  __typename?: 'SalaryAdvanceRequest';
  amountCents: Scalars['Int'];
  companyId: Scalars['Int'];
  compensation?: Maybe<SalaryAdvanceCompensation>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  compensationId?: Maybe<Scalars['Int']>;
  createdAt: Scalars['ISO8601DateTime'];
  currency: Scalars['String'];
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  employeeId: Scalars['Int'];
  employeeName?: Maybe<EmployeesEmployeeName>;
  id: Scalars['String'];
  processedAt?: Maybe<Scalars['ISO8601DateTime']>;
  status: SalaryAdvanceValueObjectsRequestStatusEnum;
  updatedAt: Scalars['ISO8601DateTime'];
};


/** Employee salary advance requests */
export type SalaryAdvanceRequestCompensationArgs = {
  createdAfter?: InputMaybe<Scalars['ISO8601DateTime']>;
  createdBefore?: InputMaybe<Scalars['ISO8601DateTime']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


/** Employee salary advance requests */
export type SalaryAdvanceRequestEmployeeNameArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  afterEmployeeId?: InputMaybe<Scalars['Int']>;
  beforeEmployeeId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  reporteesOrLed?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyId?: InputMaybe<Scalars['Int']>;
  verb?: InputMaybe<Scalars['String']>;
  withActiveContract?: Scalars['Boolean'];
};

/** The connection type for SalaryAdvanceRequest. */
export type SalaryAdvanceRequestConnection = {
  __typename?: 'SalaryAdvanceRequestConnection';
  /** A list of edges. */
  edges: Array<SalaryAdvanceRequestEdge>;
  /** A list of nodes. */
  nodes: Array<SalaryAdvanceRequest>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type SalaryAdvanceRequestEdge = {
  __typename?: 'SalaryAdvanceRequestEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: SalaryAdvanceRequest;
};

/** the filter for the requests resource */
export type SalaryAdvanceRequestFilter = {
  amountCents?: InputMaybe<IntegerFilter>;
  companyId?: InputMaybe<IntegerFilter>;
  compensationId?: InputMaybe<IntegerFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<StringFilter>;
  employeeId?: InputMaybe<IntegerFilter>;
  id?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<SalaryAdvanceRequestFilterConditions>>;
  processedAt?: InputMaybe<DateTimeFilter>;
  status?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type SalaryAdvanceRequestFilterConditions = {
  amountCents?: InputMaybe<IntegerFilter>;
  companyId?: InputMaybe<IntegerFilter>;
  compensationId?: InputMaybe<IntegerFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<StringFilter>;
  employeeId?: InputMaybe<IntegerFilter>;
  id?: InputMaybe<StringFilter>;
  processedAt?: InputMaybe<DateTimeFilter>;
  status?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type SalaryAdvanceValueObjectsEmployeeStatusEnum =
  | 'active'
  | 'disabled'
  | 'pending_information';

export type SalaryAdvanceValueObjectsRequestStatusEnum =
  | 'completed'
  | 'processing'
  | 'requested';

/** Autogenerated return type of SaveAsTemplateAtsEvaluationForm. */
export type SaveAsTemplateAtsEvaluationFormPayload = {
  __typename?: 'SaveAsTemplateAtsEvaluationFormPayload';
  errors: Array<MutationError>;
  evaluationForm?: Maybe<AtsEvaluationForm>;
};

/** Autogenerated return type of SaveBenefitsBenefitSetting. */
export type SaveBenefitsBenefitSettingPayload = {
  __typename?: 'SaveBenefitsBenefitSettingPayload';
  benefitSetting?: Maybe<BenefitsBenefitSetting>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of SaveGraphWorkflowsWorkflow. */
export type SaveGraphWorkflowsWorkflowPayload = {
  __typename?: 'SaveGraphWorkflowsWorkflowPayload';
  errors: Array<MutationError>;
  workflow?: Maybe<WorkflowsWorkflow>;
};

export type SaveProcurementTypeFormInput = {
  elements: Array<FormsElementInput>;
  id: Scalars['Int'];
};

/** Autogenerated return type of SaveProcurementType. */
export type SaveProcurementTypePayload = {
  __typename?: 'SaveProcurementTypePayload';
  errors: Array<MutationError>;
  type?: Maybe<ProcurementType>;
};

export type SaveProcurementTypeWorkflowInput = {
  edges: Array<WorkflowsEdgeInput>;
  id: Scalars['Int'];
  nodes: Array<WorkflowsNodeInput>;
};

/** Autogenerated return type of SaveSalaryadvanceCompanySetting. */
export type SaveSalaryadvanceCompanySettingPayload = {
  __typename?: 'SaveSalaryadvanceCompanySettingPayload';
  companySetting?: Maybe<SalaryAdvanceCompanySetting>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of ScheduleFormsForm. */
export type ScheduleFormsFormPayload = {
  __typename?: 'ScheduleFormsFormPayload';
  errors: Array<MutationError>;
  form?: Maybe<FormsForm>;
};

/** Autogenerated return type of SchedulePerformanceReviewProcess. */
export type SchedulePerformanceReviewProcessPayload = {
  __typename?: 'SchedulePerformanceReviewProcessPayload';
  errors: Array<MutationError>;
  reviewProcess?: Maybe<PerformanceReviewProcess>;
};

/** Autogenerated return type of ScheduleUpsellUpsellDiscount. */
export type ScheduleUpsellUpsellDiscountPayload = {
  __typename?: 'ScheduleUpsellUpsellDiscountPayload';
  errors: Array<MutationError>;
  upsellDiscount?: Maybe<UpsellUpsellDiscount>;
};

/** Autogenerated return type of SearchCompetenciesFactorialCompetency. */
export type SearchCompetenciesFactorialCompetencyPayload = {
  __typename?: 'SearchCompetenciesFactorialCompetencyPayload';
  errors: Array<MutationError>;
  factorialCompetencies?: Maybe<Array<CompetenciesFactorialCompetency>>;
};

export type SearchHighlight = {
  __typename?: 'SearchHighlight';
  content: Array<Scalars['String']>;
  field: Scalars['String'];
};

export type SearchResult = {
  __typename?: 'SearchResult';
  highlights: Array<SearchHighlight>;
  score?: Maybe<Scalars['Float']>;
};

/** Company security configuration */
export type SecuritySettingsCompanyConfig = {
  __typename?: 'SecuritySettingsCompanyConfig';
  id: Scalars['Int'];
  mfaStatus: SecuritySettingsMfaStatusEnum;
  passwordRotationEnabled: Scalars['Boolean'];
  passwordRotationExpireInterval?: Maybe<Scalars['Int']>;
  ssoEnforcement: SecuritySettingsSsoEnforcementEnum;
  staffBecomeEnabled: Scalars['Boolean'];
};

/** The connection type for SecuritySettingsCompanyConfig. */
export type SecuritySettingsCompanyConfigConnection = {
  __typename?: 'SecuritySettingsCompanyConfigConnection';
  /** A list of edges. */
  edges: Array<SecuritySettingsCompanyConfigEdge>;
  /** A list of nodes. */
  nodes: Array<SecuritySettingsCompanyConfig>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type SecuritySettingsCompanyConfigEdge = {
  __typename?: 'SecuritySettingsCompanyConfigEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: SecuritySettingsCompanyConfig;
};

export type SecuritySettingsContextlessPolicies = {
  __typename?: 'SecuritySettingsContextlessPolicies';
  updateCompanyConfig: ContextlessPolicyResolution;
};

export type SecuritySettingsMfaStatusEnum =
  | 'disabled'
  | 'enabled'
  | 'required';

export type SecuritySettingsSsoEnforcementEnum =
  | 'all'
  | 'domain'
  | 'none';

/** Autogenerated return type of SendEmployeeDocumentTypeForSignatureItmanagementItAssetDocument. */
export type SendEmployeeDocumentTypeForSignatureItmanagementItAssetDocumentPayload = {
  __typename?: 'SendEmployeeDocumentTypeForSignatureItmanagementItAssetDocumentPayload';
  errors: Array<MutationError>;
  itAssetDocuments?: Maybe<Array<ItManagementItAssetDocument>>;
};

/** Autogenerated return type of SendForSignatureItmanagementItAssetDocument. */
export type SendForSignatureItmanagementItAssetDocumentPayload = {
  __typename?: 'SendForSignatureItmanagementItAssetDocumentPayload';
  errors: Array<MutationError>;
  itAssetDocuments?: Maybe<Array<ItManagementItAssetDocument>>;
};

/** Autogenerated return type of SendFormFormsForm. */
export type SendFormFormsFormPayload = {
  __typename?: 'SendFormFormsFormPayload';
  errors: Array<MutationError>;
  form?: Maybe<FormsForm>;
};

/** Autogenerated return type of SendInBulkUpdateDocumentsDocument. */
export type SendInBulkUpdateDocumentsDocumentPayload = {
  __typename?: 'SendInBulkUpdateDocumentsDocumentPayload';
  documents?: Maybe<Array<DocumentsDocument>>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of SendRemindersTasksMaterializedProcessTask. */
export type SendRemindersTasksMaterializedProcessTaskPayload = {
  __typename?: 'SendRemindersTasksMaterializedProcessTaskPayload';
  errors: Array<MutationError>;
  materializedProcessTasks?: Maybe<Array<TasksMaterializedProcessTask>>;
};

/** Autogenerated return type of SendToPayWithSepaExpensesExpensableGroup. */
export type SendToPayWithSepaExpensesExpensableGroupPayload = {
  __typename?: 'SendToPayWithSepaExpensesExpensableGroupPayload';
  errors: Array<MutationError>;
  expensableGroup?: Maybe<ExpensesExpensableGroup>;
};

export type SerialSequencesValueObjectsStatusEnum =
  | 'active'
  | 'archived';

/** Autogenerated return type of SetAsDefaultApprovalsApprovalGroup. */
export type SetAsDefaultApprovalsApprovalGroupPayload = {
  __typename?: 'SetAsDefaultApprovalsApprovalGroupPayload';
  approvalGroup?: Maybe<ApprovalsApprovalGroup>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of SetAsDefaultAttendanceEmployeesPolicy. */
export type SetAsDefaultAttendanceEmployeesPolicyPayload = {
  __typename?: 'SetAsDefaultAttendanceEmployeesPolicyPayload';
  employeesPolicy?: Maybe<AttendanceEmployeesPolicy>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of SetModePerformanceScoreConfiguration. */
export type SetModePerformanceScoreConfigurationPayload = {
  __typename?: 'SetModePerformanceScoreConfigurationPayload';
  errors: Array<MutationError>;
  scoreConfiguration?: Maybe<PerformanceScoreConfiguration>;
};

/** Autogenerated return type of SetPerformanceCompanyEmployeeScoreScale. */
export type SetPerformanceCompanyEmployeeScoreScalePayload = {
  __typename?: 'SetPerformanceCompanyEmployeeScoreScalePayload';
  companyEmployeeScoreScale?: Maybe<PerformanceCompanyEmployeeScoreScale>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of SetRegularAccessStartDateEmployeesEmployee. */
export type SetRegularAccessStartDateEmployeesEmployeePayload = {
  __typename?: 'SetRegularAccessStartDateEmployeesEmployeePayload';
  employee?: Maybe<EmployeesEmployee>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of SetToPaidExpensesExpensableGroup. */
export type SetToPaidExpensesExpensableGroupPayload = {
  __typename?: 'SetToPaidExpensesExpensableGroupPayload';
  errors: Array<MutationError>;
  expensableGroup?: Maybe<ExpensesExpensableGroup>;
};

/** Autogenerated return type of SetWeightsPerformanceScoreConfiguration. */
export type SetWeightsPerformanceScoreConfigurationPayload = {
  __typename?: 'SetWeightsPerformanceScoreConfigurationPayload';
  errors: Array<MutationError>;
  scoreConfiguration?: Maybe<PerformanceScoreConfiguration>;
};

/** Autogenerated return type of ShareReportsReport. */
export type ShareReportsReportPayload = {
  __typename?: 'ShareReportsReportPayload';
  errors: Array<MutationError>;
  report?: Maybe<ReportsReport>;
};

/** Autogenerated return type of ShareTasksShareTask. */
export type ShareTasksShareTaskPayload = {
  __typename?: 'ShareTasksShareTaskPayload';
  errors: Array<MutationError>;
  shareTask?: Maybe<TasksShareTask>;
};

/**
 * Manages automatic scheduler execution records for shift generation. Tracks the
 * status and progress of automated shift scheduling runs performed by the Timefold
 * optimization engine. Each execution represents a single scheduling job that
 * generates shifts based on constraints and requirements. Supports monitoring
 * execution status, run IDs, and completion states.
 */
export type ShiftManagementAutoSchedulerExecution = {
  __typename?: 'ShiftManagementAutoSchedulerExecution';
  /** Identifier of the company that owns this scheduler execution */
  companyId: Scalars['Int'];
  endAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Unique identifier for the auto scheduler execution record */
  id: Scalars['Int'];
  /** Identifier of the location for which the automatic scheduling is being executed */
  locationId: Scalars['Int'];
  /** Unique identifier for the scheduling run. Used to track and reference a specific scheduling job execution */
  runId: Scalars['String'];
  /** Human-readable name for the scheduling run. Helps identify and distinguish different scheduling executions */
  runName: Scalars['String'];
  startAt?: Maybe<Scalars['ISO8601DateTime']>;
  /**
   * Current status of the scheduler execution. 'solving_scheduled' means the job
   * is queued, 'solving_started' means it has begun, 'solving_active' means it's
   * currently running, 'solving_completed' means it finished successfully,
   * 'solving_incomplete' means it finished but didn't find a complete solution,
   * 'solving_failed' means it encountered an error, 'solving_killed' means it was terminated
   */
  status: ShiftManagementEnumsAutoSchedulerExecutionStatusEnum;
  /** UTC timestamp indicating when the execution record was last updated. Reflects status changes and progress updates */
  updatedAt: Scalars['String'];
  /** Universally unique identifier for the execution. Used for tracking and correlation across systems */
  uuid: Scalars['String'];
};

/** The connection type for ShiftManagementAutoSchedulerExecution. */
export type ShiftManagementAutoSchedulerExecutionConnection = {
  __typename?: 'ShiftManagementAutoSchedulerExecutionConnection';
  /** A list of edges. */
  edges: Array<ShiftManagementAutoSchedulerExecutionEdge>;
  /** A list of nodes. */
  nodes: Array<ShiftManagementAutoSchedulerExecution>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ShiftManagementAutoSchedulerExecutionEdge = {
  __typename?: 'ShiftManagementAutoSchedulerExecutionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ShiftManagementAutoSchedulerExecution;
};

/** the filter for the auto_scheduler_executions resource */
export type ShiftManagementAutoSchedulerExecutionFilter = {
  or?: InputMaybe<Array<ShiftManagementAutoSchedulerExecutionFilterConditions>>;
  updatedAt?: InputMaybe<StringFilter>;
};

export type ShiftManagementAutoSchedulerExecutionFilterConditions = {
  updatedAt?: InputMaybe<StringFilter>;
};

/**
 * Provides automation capabilities for generating schedules and shifts. Supports
 * triggering automatic shift generation through the Timefold optimization engine.
 * Includes subscription support for real-time updates on schedule generation
 * progress and completion.
 */
export type ShiftManagementAutomation = {
  __typename?: 'ShiftManagementAutomation';
  companyId: Scalars['Int'];
  endAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['Int'];
  locationId: Scalars['Int'];
  runId: Scalars['String'];
  runName: Scalars['String'];
  startAt?: Maybe<Scalars['ISO8601DateTime']>;
  status: ShiftManagementEnumsAutoSchedulerExecutionStatusEnum;
  uuid?: Maybe<Scalars['String']>;
};

export type ShiftManagementContextlessPolicies = {
  __typename?: 'ShiftManagementContextlessPolicies';
  accessManageShifts: ContextlessPolicyResolution;
  accessManageTemplates: ContextlessPolicyResolution;
  accessManageUnassignedShifts: ContextlessPolicyResolution;
  accessSeeTimeInsights: ContextlessPolicyResolution;
  defaultShiftManage: ContextlessPolicyResolution;
  insightsSeeEverybody: ContextlessPolicyResolution;
  shiftCreateEverybody: ContextlessPolicyResolution;
  shiftCreateReportees: ContextlessPolicyResolution;
  shiftCreateSelf: ContextlessPolicyResolution;
  shiftCreateTeam: ContextlessPolicyResolution;
  shiftSeeEverybody: ContextlessPolicyResolution;
  shiftSeeReportees: ContextlessPolicyResolution;
  shiftSeeSelf: ContextlessPolicyResolution;
  shiftSeeTeam: ContextlessPolicyResolution;
  sidebarSeeShiftsTopLevelItem: ContextlessPolicyResolution;
  swapShiftCreate: ContextlessPolicyResolution;
  unassignedShiftCreateEverybody: ContextlessPolicyResolution;
  unassignedShiftCreateReportees: ContextlessPolicyResolution;
  unassignedShiftCreateSelf: ContextlessPolicyResolution;
  unassignedShiftCreateTeam: ContextlessPolicyResolution;
};

/**
 * Retrieves coverage statistics for shift management. Coverage represents the
 * number of employees scheduled per day within a specified time period. Helps
 * analyze staffing levels and identify days with insufficient or excess coverage.
 * Supports filtering by shifts, employees, date ranges, publication status, and
 * custom filters.
 */
export type ShiftManagementCoverage = {
  __typename?: 'ShiftManagementCoverage';
  /** Date for which the coverage statistics are calculated */
  date: Scalars['String'];
  /**
   * Total number of shifts scheduled for this date. Represents the coverage level
   * - how many employee shifts are assigned for the day
   */
  numberOfShifts: Scalars['Float'];
};

/** The connection type for ShiftManagementCoverage. */
export type ShiftManagementCoverageConnection = {
  __typename?: 'ShiftManagementCoverageConnection';
  /** A list of edges. */
  edges: Array<ShiftManagementCoverageEdge>;
  /** A list of nodes. */
  nodes: Array<ShiftManagementCoverage>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ShiftManagementCoverageEdge = {
  __typename?: 'ShiftManagementCoverageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ShiftManagementCoverage;
};

/**
 * Retrieves daily coverage statistics for shift management. Coverage represents
 * the number of employees scheduled per day within a specified time period. Helps
 * analyze staffing levels and identify days with insufficient or excess coverage.
 * Supports filtering by shifts, employees, date ranges, and custom filters.
 */
export type ShiftManagementCoveragesByDay = {
  __typename?: 'ShiftManagementCoveragesByDay';
  date: Scalars['ISO8601Date'];
  numberOfEmployees: Scalars['Int'];
};

/** The connection type for ShiftManagementCoveragesByDay. */
export type ShiftManagementCoveragesByDayConnection = {
  __typename?: 'ShiftManagementCoveragesByDayConnection';
  /** A list of edges. */
  edges: Array<ShiftManagementCoveragesByDayEdge>;
  /** A list of nodes. */
  nodes: Array<ShiftManagementCoveragesByDay>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ShiftManagementCoveragesByDayEdge = {
  __typename?: 'ShiftManagementCoveragesByDayEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ShiftManagementCoveragesByDay;
};

export type ShiftManagementCustomFilterInput = {
  condition: Scalars['String'];
  field: Scalars['String'];
  value: Scalars['String'];
};

/**
 * Manages default shift templates that serve as reusable patterns for creating
 * shifts. Default shifts define standard work periods (start/end times) that can
 * be quickly applied when scheduling employees. They support visibility controls
 * for locations and teams, and can be archived when no longer needed.
 */
export type ShiftManagementDefaultShift = {
  __typename?: 'ShiftManagementDefaultShift';
  /**
   * When true, this default shift template is available company-wide to all
   * locations and teams. When false, visibility is restricted to specific
   * locations and teams defined in visible_locations_ids and visible_teams_ids
   */
  allCompany: Scalars['Boolean'];
  /**
   * Indicates whether this default shift template is archived. Archived templates
   * are hidden from selection but can still be used for existing shifts. Set to
   * true to hide the template without deleting it
   */
  archived: Scalars['Boolean'];
  /**
   * Color code (hex format, e.g., '#FF5733') used to visually distinguish shifts
   * created from this template in calendar views. If null, a default color is used
   */
  color?: Maybe<Scalars['String']>;
  /**
   * End time of the shift template in HH:MM:SS format (e.g., '17:00:00'). This
   * time is used as the default end time when creating shifts from this template
   */
  endAt: Scalars['String'];
  /**
   * Indicates whether shifts created from this template should be marked as extra
   * hours (overtime) by default. Used for overtime calculations and reporting
   */
  extraHours: Scalars['Boolean'];
  /** Unique identifier for the default shift template */
  id: Scalars['Int'];
  /**
   * Identifier of the location associated with this default shift template. If
   * set, the template is primarily used for shifts at this location. If null, the
   * template can be used for any location
   */
  locationId?: Maybe<Scalars['Int']>;
  /**
   * Optional notes or comments about this default shift template. These notes can
   * provide context about when or how to use this template
   */
  notes?: Maybe<Scalars['String']>;
  /**
   * Indicates whether this shift template spans across midnight (e.g., 22:00 to
   * 06:00). When true, shifts created from this template will be marked as
   * overnight shifts
   */
  overnightShift: Scalars['Boolean'];
  plannedBreaks: Array<TimePlanningPlannedBreak>;
  plannedbreaksConnection: TimePlanningPlannedBreakConnection;
  /**
   * Start time of the shift template in HH:MM:SS format (e.g., '09:00:00'). This
   * time is used as the default start time when creating shifts from this template
   */
  startAt: Scalars['String'];
  /**
   * Display name of the default shift template (e.g., 'Morning Shift', 'Night
   * Shift'). This title appears when creating shifts from this template
   */
  title: Scalars['String'];
  /**
   * List of location identifiers where this default shift template is visible and
   * can be used. Only relevant when all_company is false. Empty array means the
   * template is not visible at any location
   */
  visibleLocationsIds: Array<Scalars['Int']>;
  /**
   * List of team identifiers where this default shift template is visible and can
   * be used. Only relevant when all_company is false. Empty array means the
   * template is not visible to any team
   */
  visibleTeamsIds: Array<Scalars['Int']>;
  /**
   * Identifier of the work area within a location associated with this template.
   * Work areas allow further subdivision of locations for more specific shift templates
   */
  workAreaId?: Maybe<Scalars['Int']>;
};


/**
 * Manages default shift templates that serve as reusable patterns for creating
 * shifts. Default shifts define standard work periods (start/end times) that can
 * be quickly applied when scheduling employees. They support visibility controls
 * for locations and teams, and can be archived when no longer needed.
 */
export type ShiftManagementDefaultShiftPlannedBreaksArgs = {
  activeBreakConfiguration?: Scalars['Boolean'];
  dayConfigurationIds?: Array<Scalars['Int']>;
  ids?: Array<Scalars['Int']>;
  paid?: InputMaybe<Scalars['Boolean']>;
  shiftConfigurationIds?: Array<Scalars['Int']>;
  shiftIds?: Array<Scalars['Int']>;
};


/**
 * Manages default shift templates that serve as reusable patterns for creating
 * shifts. Default shifts define standard work periods (start/end times) that can
 * be quickly applied when scheduling employees. They support visibility controls
 * for locations and teams, and can be archived when no longer needed.
 */
export type ShiftManagementDefaultShiftPlannedbreaksConnectionArgs = {
  activeBreakConfiguration?: Scalars['Boolean'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  dayConfigurationIds?: Array<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: Array<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  paid?: InputMaybe<Scalars['Boolean']>;
  shiftConfigurationIds?: Array<Scalars['Int']>;
  shiftIds?: Array<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for ShiftManagementDefaultShift. */
export type ShiftManagementDefaultShiftConnection = {
  __typename?: 'ShiftManagementDefaultShiftConnection';
  /** A list of edges. */
  edges: Array<ShiftManagementDefaultShiftEdge>;
  /** A list of nodes. */
  nodes: Array<ShiftManagementDefaultShift>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ShiftManagementDefaultShiftEdge = {
  __typename?: 'ShiftManagementDefaultShiftEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ShiftManagementDefaultShift;
};

/**
 * Retrieves employee permissions and shift management context for employees. This
 * resource provides a comprehensive view of employees within the shift management
 * system, including their shifts, leaves, rest days, planning versions, location,
 * and contract information. Used as the primary data structure for displaying
 * employee schedules and managing shift assignments. Supports filtering by
 * employees, locations, teams, date ranges, and custom filters.
 */
export type ShiftManagementEmployeesPermission = {
  __typename?: 'ShiftManagementEmployeesPermission';
  access?: Maybe<ApiCoreAccess>;
  /**
   * Identifier of the user access account associated with this employee. Used for authentication and user management
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  accessId: Scalars['String'];
  avatar?: Maybe<ApiCoreAttachment>;
  avatarId?: Maybe<Scalars['Int']>;
  employee?: Maybe<EmployeesEmployeeName>;
  firstName: Scalars['String'];
  fullName: Scalars['String'];
  /** Unique identifier for the employee permissions record. This matches the employee's ID */
  id: Scalars['Int'];
  lastName: Scalars['String'];
  leaves: Array<ShiftManagementLeave>;
  leavesConnection: ShiftManagementLeaveConnection;
  location?: Maybe<LocationsLocation>;
  /**
   * Identifier of the location where this employee is primarily assigned. Used as
   * the default location for shift assignments when not explicitly specified
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  locationId?: Maybe<Scalars['Int']>;
  /**
   * Object containing the employee's permissions and access rights within the
   * shift management system. Includes information about what actions the employee can perform
   */
  permissions: ShiftManagementPermissions;
  planningVersions: Array<TimePlanningPlanningVersion>;
  planningVersionsConnection: TimePlanningPlanningVersionConnection;
  preferredName?: Maybe<Scalars['String']>;
  referenceContract?: Maybe<ContractsReferenceContract>;
  restDays: Array<ShiftManagementRestDay>;
  restDaysConnection: ShiftManagementRestDayConnection;
  shifts: Array<ShiftManagementShift>;
  shiftsConnection: ShiftManagementShiftConnection;
  terminatedOn?: Maybe<Scalars['ISO8601Date']>;
};


/**
 * Retrieves employee permissions and shift management context for employees. This
 * resource provides a comprehensive view of employees within the shift management
 * system, including their shifts, leaves, rest days, planning versions, location,
 * and contract information. Used as the primary data structure for displaying
 * employee schedules and managing shift assignments. Supports filtering by
 * employees, locations, teams, date ranges, and custom filters.
 */
export type ShiftManagementEmployeesPermissionAccessArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Retrieves employee permissions and shift management context for employees. This
 * resource provides a comprehensive view of employees within the shift management
 * system, including their shifts, leaves, rest days, planning versions, location,
 * and contract information. Used as the primary data structure for displaying
 * employee schedules and managing shift assignments. Supports filtering by
 * employees, locations, teams, date ranges, and custom filters.
 */
export type ShiftManagementEmployeesPermissionAvatarArgs = {
  attachmentName?: InputMaybe<Scalars['String']>;
};


/**
 * Retrieves employee permissions and shift management context for employees. This
 * resource provides a comprehensive view of employees within the shift management
 * system, including their shifts, leaves, rest days, planning versions, location,
 * and contract information. Used as the primary data structure for displaying
 * employee schedules and managing shift assignments. Supports filtering by
 * employees, locations, teams, date ranges, and custom filters.
 */
export type ShiftManagementEmployeesPermissionEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  afterEmployeeId?: InputMaybe<Scalars['Int']>;
  beforeEmployeeId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  reporteesOrLed?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyId?: InputMaybe<Scalars['Int']>;
  verb?: InputMaybe<Scalars['String']>;
  withActiveContract?: Scalars['Boolean'];
};


/**
 * Retrieves employee permissions and shift management context for employees. This
 * resource provides a comprehensive view of employees within the shift management
 * system, including their shifts, leaves, rest days, planning versions, location,
 * and contract information. Used as the primary data structure for displaying
 * employee schedules and managing shift assignments. Supports filtering by
 * employees, locations, teams, date ranges, and custom filters.
 */
export type ShiftManagementEmployeesPermissionLeavesArgs = {
  approved?: InputMaybe<Scalars['Boolean']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  endAt?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeAllPendingApprovals?: InputMaybe<Scalars['Boolean']>;
  includeAllRelations?: InputMaybe<Scalars['Boolean']>;
  includeDuration?: Scalars['Boolean'];
  includeLeaveType?: Scalars['Boolean'];
  includePending?: InputMaybe<Scalars['Boolean']>;
  leaveType?: InputMaybe<Array<Scalars['String']>>;
  leaveTypeId?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  startAt?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['ISO8601Date']>;
  typeIsWorkable?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Retrieves employee permissions and shift management context for employees. This
 * resource provides a comprehensive view of employees within the shift management
 * system, including their shifts, leaves, rest days, planning versions, location,
 * and contract information. Used as the primary data structure for displaying
 * employee schedules and managing shift assignments. Supports filtering by
 * employees, locations, teams, date ranges, and custom filters.
 */
export type ShiftManagementEmployeesPermissionLeavesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  approved?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  endAt?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeAllPendingApprovals?: InputMaybe<Scalars['Boolean']>;
  includeAllRelations?: InputMaybe<Scalars['Boolean']>;
  includeDuration?: Scalars['Boolean'];
  includeLeaveType?: Scalars['Boolean'];
  includePending?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  leaveType?: InputMaybe<Array<Scalars['String']>>;
  leaveTypeId?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Sort>;
  startAt?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['ISO8601Date']>;
  typeIsWorkable?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Retrieves employee permissions and shift management context for employees. This
 * resource provides a comprehensive view of employees within the shift management
 * system, including their shifts, leaves, rest days, planning versions, location,
 * and contract information. Used as the primary data structure for displaying
 * employee schedules and managing shift assignments. Supports filtering by
 * employees, locations, teams, date ranges, and custom filters.
 */
export type ShiftManagementEmployeesPermissionLocationArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  main?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};


/**
 * Retrieves employee permissions and shift management context for employees. This
 * resource provides a comprehensive view of employees within the shift management
 * system, including their shifts, leaves, rest days, planning versions, location,
 * and contract information. Used as the primary data structure for displaying
 * employee schedules and managing shift assignments. Supports filtering by
 * employees, locations, teams, date ranges, and custom filters.
 */
export type ShiftManagementEmployeesPermissionPlanningVersionsArgs = {
  employeeNameSearch?: InputMaybe<Scalars['String']>;
  forShifts?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: Scalars['Boolean'];
  planningTool?: InputMaybe<TimePlanningPlanningToolEnum>;
  scheduleIds?: InputMaybe<Array<Scalars['Int']>>;
};


/**
 * Retrieves employee permissions and shift management context for employees. This
 * resource provides a comprehensive view of employees within the shift management
 * system, including their shifts, leaves, rest days, planning versions, location,
 * and contract information. Used as the primary data structure for displaying
 * employee schedules and managing shift assignments. Supports filtering by
 * employees, locations, teams, date ranges, and custom filters.
 */
export type ShiftManagementEmployeesPermissionPlanningVersionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeNameSearch?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forShifts?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyActive?: Scalars['Boolean'];
  planningTool?: InputMaybe<TimePlanningPlanningToolEnum>;
  scheduleIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
};


/**
 * Retrieves employee permissions and shift management context for employees. This
 * resource provides a comprehensive view of employees within the shift management
 * system, including their shifts, leaves, rest days, planning versions, location,
 * and contract information. Used as the primary data structure for displaying
 * employee schedules and managing shift assignments. Supports filtering by
 * employees, locations, teams, date ranges, and custom filters.
 */
export type ShiftManagementEmployeesPermissionReferenceContractArgs = {
  activeBetween?: InputMaybe<ReferenceContractsActiveBetweenInput>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  effectiveOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  endsOnGt?: InputMaybe<Scalars['ISO8601Date']>;
  endsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  frContractTypeIds?: InputMaybe<Array<Scalars['Int']>>;
  frMutualIds?: InputMaybe<Array<Scalars['Int']>>;
  frWorkTypeIds?: InputMaybe<Array<Scalars['Int']>>;
  includeDenormalizedData?: Scalars['Boolean'];
  includeEducationLevel?: Scalars['Boolean'];
  jobCatalogLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  jobCatalogTreeNodeUuids?: InputMaybe<Array<Scalars['String']>>;
  onDate?: InputMaybe<Scalars['ISO8601Date']>;
  payrollPolicyId?: InputMaybe<Scalars['Int']>;
  startsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  startsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedBecauseRelatedModels?: InputMaybe<Scalars['Boolean']>;
  withPayroll?: InputMaybe<Scalars['Boolean']>;
  withTranslations?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Retrieves employee permissions and shift management context for employees. This
 * resource provides a comprehensive view of employees within the shift management
 * system, including their shifts, leaves, rest days, planning versions, location,
 * and contract information. Used as the primary data structure for displaying
 * employee schedules and managing shift assignments. Supports filtering by
 * employees, locations, teams, date ranges, and custom filters.
 */
export type ShiftManagementEmployeesPermissionRestDaysArgs = {
  endAt?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  onlyPublished?: InputMaybe<Scalars['Boolean']>;
  startAt?: InputMaybe<Scalars['String']>;
};


/**
 * Retrieves employee permissions and shift management context for employees. This
 * resource provides a comprehensive view of employees within the shift management
 * system, including their shifts, leaves, rest days, planning versions, location,
 * and contract information. Used as the primary data structure for displaying
 * employee schedules and managing shift assignments. Supports filtering by
 * employees, locations, teams, date ranges, and custom filters.
 */
export type ShiftManagementEmployeesPermissionRestDaysConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endAt?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyPublished?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Sort>;
  startAt?: InputMaybe<Scalars['String']>;
};


/**
 * Retrieves employee permissions and shift management context for employees. This
 * resource provides a comprehensive view of employees within the shift management
 * system, including their shifts, leaves, rest days, planning versions, location,
 * and contract information. Used as the primary data structure for displaying
 * employee schedules and managing shift assignments. Supports filtering by
 * employees, locations, teams, date ranges, and custom filters.
 */
export type ShiftManagementEmployeesPermissionShiftsArgs = {
  effectiveLocationIds?: InputMaybe<Array<Scalars['Int']>>;
  endAt?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  locationsWorkAreaIds?: InputMaybe<Array<Scalars['Int']>>;
  onlyPublished?: InputMaybe<Scalars['Boolean']>;
  onlyStates?: InputMaybe<Array<ShiftManagementEnumsShiftStateEnum>>;
  splitOvernightShifts?: InputMaybe<Scalars['Boolean']>;
  startAt?: InputMaybe<Scalars['String']>;
  withoutIds?: InputMaybe<Array<Scalars['Int']>>;
  withoutWorkArea?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Retrieves employee permissions and shift management context for employees. This
 * resource provides a comprehensive view of employees within the shift management
 * system, including their shifts, leaves, rest days, planning versions, location,
 * and contract information. Used as the primary data structure for displaying
 * employee schedules and managing shift assignments. Supports filtering by
 * employees, locations, teams, date ranges, and custom filters.
 */
export type ShiftManagementEmployeesPermissionShiftsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  effectiveLocationIds?: InputMaybe<Array<Scalars['Int']>>;
  endAt?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  locationsWorkAreaIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyPublished?: InputMaybe<Scalars['Boolean']>;
  onlyStates?: InputMaybe<Array<ShiftManagementEnumsShiftStateEnum>>;
  sortOrder?: InputMaybe<Sort>;
  splitOvernightShifts?: InputMaybe<Scalars['Boolean']>;
  startAt?: InputMaybe<Scalars['String']>;
  withoutIds?: InputMaybe<Array<Scalars['Int']>>;
  withoutWorkArea?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for ShiftManagementEmployeesPermission. */
export type ShiftManagementEmployeesPermissionConnection = {
  __typename?: 'ShiftManagementEmployeesPermissionConnection';
  /** A list of edges. */
  edges: Array<ShiftManagementEmployeesPermissionEdge>;
  /** A list of nodes. */
  nodes: Array<ShiftManagementEmployeesPermission>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ShiftManagementEmployeesPermissionEdge = {
  __typename?: 'ShiftManagementEmployeesPermissionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ShiftManagementEmployeesPermission;
};

export type ShiftManagementEnumsAutoSchedulerExecutionStatusEnum =
  | 'solving_active'
  | 'solving_completed'
  | 'solving_failed'
  | 'solving_incomplete'
  | 'solving_killed'
  | 'solving_scheduled'
  | 'solving_started';

export type ShiftManagementEnumsRestDayCreationModeEnum =
  | 'automatic'
  | 'manual';

export type ShiftManagementEnumsRestDayStateEnum =
  | 'draft'
  | 'published';

export type ShiftManagementEnumsShiftCreationModeEnum =
  | 'automatic'
  | 'manual';

export type ShiftManagementEnumsShiftStateEnum =
  | 'backup'
  | 'draft'
  | 'published';

/**
 * Retrieves employee leave (time off) information within the shift management
 * context. Leaves represent periods when employees are absent from work, which
 * affects shift scheduling. Supports filtering by employees, leave types, date
 * ranges, and approval status. Includes detailed information about leave duration,
 * type, and approval workflow.
 */
export type ShiftManagementLeave = {
  __typename?: 'ShiftManagementLeave';
  /**
   * Indicates whether this leave type accrues (accumulates) over time. Used for
   * leave balance calculations and policy enforcement
   */
  accrues?: Maybe<Scalars['Boolean']>;
  approvalSuggestion?: Maybe<TimeoffLeaveApprovalRecommendationsRecommendedActionEnum>;
  /**
   * Indicates whether this leave request has been approved. True means approved,
   * false means rejected, null means pending approval
   */
  approved?: Maybe<Scalars['Boolean']>;
  companyId: Scalars['Int'];
  /** Timestamp indicating when the leave request was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  delegatedApprover?: Maybe<TimeoffDelegateApprover>;
  delegatedApproverId?: Maybe<Scalars['Int']>;
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Optional description or notes about the leave, provided by the employee or manager */
  description?: Maybe<Scalars['String']>;
  /** Full name of the employee taking the leave. Provided for convenience in display and reporting */
  employeeFullName?: Maybe<Scalars['String']>;
  /** Identifier of the employee who requested or is taking this leave */
  employeeId: Scalars['Int'];
  /** End date of the leave period. This is the last day the employee will be absent. Can be null for single-day leaves */
  finishOn?: Maybe<Scalars['ISO8601Date']>;
  /**
   * Natural end date of the leave, which may differ from finish_on in certain
   * calendar systems (e.g., French calendar). Used for accurate duration calculations
   */
  finishOnNatural?: Maybe<Scalars['ISO8601Date']>;
  /**
   * Duration of the leave calculated according to French calendar rules, which may
   * differ from standard calendar calculations. Used for companies operating under
   * French labor regulations
   */
  frenchDuration?: Maybe<Scalars['Float']>;
  /**
   * Unit of measurement for the French duration calculation. Can be 'hours' or
   * 'days' depending on the leave type and company settings
   */
  frenchDurationUnit?: Maybe<TimeoffFrenchDurationsUnitEnum>;
  /** Indicates if this is a half-day leave. Common values include 'morning', 'afternoon', or null for full-day leaves */
  halfDay?: Maybe<Scalars['String']>;
  /** Indicates whether this leave is tracked by hours rather than days. When true, the leave duration is measured in hours */
  hourly?: Maybe<Scalars['Boolean']>;
  /** Amount of leave time in cents (for precise calculations). Used for hourly leave tracking and payroll calculations */
  hoursAmountInCents?: Maybe<Scalars['Int']>;
  /** Unique identifier for the leave record */
  id: Scalars['Int'];
  /** Color code (hex format) used to visually distinguish this leave type in calendar views and schedules */
  leaveTypeColor?: Maybe<Scalars['String']>;
  /** Numeric identifier of the leave type. Links to the company's configured leave type settings */
  leaveTypeId?: Maybe<Scalars['Int']>;
  /** Unique identifier string for the leave type. Used to categorize different types of time off */
  leaveTypeIdentifier?: Maybe<Scalars['String']>;
  /** Human-readable name of the leave type (e.g., 'Vacation', 'Sick Leave', 'Personal Day') */
  leaveTypeName?: Maybe<Scalars['String']>;
  /** Indicates whether employees are paid during this type of leave. Used for payroll calculations and leave policy enforcement */
  leaveTypePayable?: Maybe<Scalars['Boolean']>;
  leaveTypeVisibility?: Maybe<Scalars['Boolean']>;
  /**
   * Indicates whether this leave type counts as a workable day. When false, the
   * leave period is excluded from work calculations. Used for certain types of
   * leave that don't affect work schedules
   */
  leaveTypeWorkable?: Maybe<Scalars['Boolean']>;
  /** Reason for the leave request, explaining why the employee needs time off */
  reason?: Maybe<Scalars['String']>;
  /** Start date of the leave period. This is the first day the employee will be absent */
  startOn: Scalars['ISO8601Date'];
  /** Start time of the leave if it's a partial day leave. Used for half-day or hourly leave tracking */
  startTime?: Maybe<Scalars['String']>;
  /** General type classification of the leave. May differ from leave_type_identifier and is used for internal categorization */
  type?: Maybe<Scalars['String']>;
  /** Timestamp indicating when the leave record was last modified */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for ShiftManagementLeave. */
export type ShiftManagementLeaveConnection = {
  __typename?: 'ShiftManagementLeaveConnection';
  /** A list of edges. */
  edges: Array<ShiftManagementLeaveEdge>;
  /** A list of nodes. */
  nodes: Array<ShiftManagementLeave>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ShiftManagementLeaveEdge = {
  __typename?: 'ShiftManagementLeaveEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ShiftManagementLeave;
};

export type ShiftManagementPermissions = {
  __typename?: 'ShiftManagementPermissions';
  approveLeave: Scalars['Boolean'];
  create: Scalars['Boolean'];
  createLeave: Scalars['Boolean'];
  deleteLeave: Scalars['Boolean'];
};

/**
 * Manages rest days (days off) for employees within shift management. Rest days
 * represent scheduled days when employees are not required to work. Supports
 * filtering by employees, date ranges, and publication status. Rest days can be
 * created manually or automatically generated, and can be in draft or published state.
 */
export type ShiftManagementRestDay = {
  __typename?: 'ShiftManagementRestDay';
  /**
   * Indicates how the rest day was created. 'manual' means it was created by a
   * user, 'automatic' means it was generated by the system (e.g., from templates
   * or scheduling algorithms)
   */
  creationMode: ShiftManagementEnumsRestDayCreationModeEnum;
  /** Timestamp indicating the date of the rest day. This is the actual date when the employee has a day off */
  date: Scalars['ISO8601DateTime'];
  employee?: Maybe<EmployeesEmployee>;
  /**
   * Identifier of the employee who has this rest day
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  employeeId: Scalars['Int'];
  /** Unique identifier for the rest day record */
  id: Scalars['Int'];
  /** Date of the rest day converted to the local timezone. This is what employees see in their schedule */
  localDate: Scalars['ISO8601Date'];
  /**
   * Current state of the rest day. 'draft' means the rest day is not yet visible
   * to employees, 'published' means it's visible and confirmed
   */
  state: ShiftManagementEnumsRestDayStateEnum;
  timezone?: Maybe<Scalars['String']>;
};


/**
 * Manages rest days (days off) for employees within shift management. Rest days
 * represent scheduled days when employees are not required to work. Supports
 * filtering by employees, date ranges, and publication status. Rest days can be
 * created manually or automatically generated, and can be in draft or published state.
 */
export type ShiftManagementRestDayEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for ShiftManagementRestDay. */
export type ShiftManagementRestDayConnection = {
  __typename?: 'ShiftManagementRestDayConnection';
  /** A list of edges. */
  edges: Array<ShiftManagementRestDayEdge>;
  /** A list of nodes. */
  nodes: Array<ShiftManagementRestDay>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ShiftManagementRestDayEdge = {
  __typename?: 'ShiftManagementRestDayEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ShiftManagementRestDay;
};

/**
 * Provides schedule management operations for shift management. Supports
 * publishing shifts to make them visible to employees, copying shifts between date
 * ranges, and applying templates to generate shifts. These operations help manage
 * and maintain employee schedules efficiently.
 */
export type ShiftManagementSchedule = {
  __typename?: 'ShiftManagementSchedule';
  /**
   * Array of rest day identifiers. Returns only the rest days matching the
   * provided IDs. If not provided, returns all rest days
   */
  restDayIds: Array<Scalars['Int']>;
  /** Array of shift identifiers. Returns only the shifts matching the provided IDs. If not provided, returns all shifts */
  shiftIds: Array<Scalars['Int']>;
};

/**
 * Retrieves and manages scheduled work shifts for employees. Shifts represent
 * planned work periods with start and end times, assigned to specific employees at
 * locations. Supports filtering by employees, locations, date ranges, and shift
 * states (draft, published, backup).
 */
export type ShiftManagementShift = {
  __typename?: 'ShiftManagementShift';
  access?: Maybe<ApiCoreAccess>;
  /**
   * Identifier of the user/access who created this shift. Used for audit purposes
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  accessId?: Maybe<Scalars['Int']>;
  /** Color code (hex format) used to visually distinguish this shift in calendar views and schedules */
  color?: Maybe<Scalars['String']>;
  /** Identifier of the company that owns this shift */
  companyId: Scalars['Int'];
  /**
   * Indicates how the shift was created. 'manual' means it was created by a user,
   * 'automatic' means it was generated by the system (e.g., from templates or
   * scheduling algorithms)
   */
  creationMode: ShiftManagementEnumsShiftCreationModeEnum;
  defaultShift?: Maybe<ShiftManagementDefaultShift>;
  /**
   * Identifier of the default shift template used to create this shift. Default shifts provide reusable shift patterns
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  defaultShiftId?: Maybe<Scalars['Int']>;
  /** Title from the default shift template that was used to create this shift, if applicable */
  defaultShiftTitle?: Maybe<Scalars['String']>;
  /**
   * The effective location for this shift, which uses the shift's location if set,
   * otherwise falls back to the employee's assigned location
   */
  effectiveLocationId?: Maybe<Scalars['Int']>;
  employee?: Maybe<EmployeesEmployee>;
  /**
   * Identifier of the employee assigned to this shift
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  employeeId: Scalars['Int'];
  employeePermission?: Maybe<ShiftManagementEmployeesPermission>;
  /** Timestamp indicating when the shift ends */
  endAt: Scalars['ISO8601DateTime'];
  /** Indicates whether this shift counts as extra hours beyond the employee's regular schedule. Used for overtime calculations */
  extraHours: Scalars['Boolean'];
  /** Unique identifier for the shift */
  id: Scalars['Int'];
  /** Indicates whether this shift spans across midnight, meaning it starts on one calendar day and ends on the next */
  isOvernightByCalendarDay?: Maybe<Scalars['Boolean']>;
  /**
   * Identifier of the leave (time off) associated with this shift, if applicable.
   * Used when shifts are created or modified due to leave requests
   */
  leaveId?: Maybe<Scalars['Int']>;
  /** End time of the shift converted to the local timezone. This is what employees see in their schedule */
  localEndAt: Scalars['ISO8601DateTime'];
  /** Start time of the shift converted to the local timezone. This is what employees see in their schedule */
  localStartAt: Scalars['ISO8601DateTime'];
  location?: Maybe<LocationsLocation>;
  /**
   * Identifier of the location where the shift takes place. Can be null if the shift uses the employee's default location
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  locationId?: Maybe<Scalars['Int']>;
  /**
   * Identifier of the specific work area within the location where the shift
   * occurs. Work areas allow further subdivision of locations
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  locationsWorkAreaId?: Maybe<Scalars['Int']>;
  /** Display name of the shift. If not explicitly set, falls back to the default shift title or template week name */
  name?: Maybe<Scalars['String']>;
  /** Optional notes or comments about the shift, visible to managers and schedulers */
  notes?: Maybe<Scalars['String']>;
  plannedBreaks: Array<TimePlanningPlannedBreak>;
  plannedbreaksConnection: TimePlanningPlannedBreakConnection;
  shiftConfiguration?: Maybe<ShiftManagementShiftConfiguration>;
  /**
   * Identifier of the shift configuration used to create this shift. Shift configurations define default settings and rules
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  shiftConfigurationId?: Maybe<Scalars['Int']>;
  /** Timestamp indicating when the shift starts */
  startAt: Scalars['ISO8601DateTime'];
  /**
   * Current state of the shift. 'draft' means the shift is not yet visible to
   * employees, 'published' means it's visible and confirmed, 'backup' indicates a
   * backup shift that can be replaced
   */
  state: ShiftManagementEnumsShiftStateEnum;
  swapShifts: Array<ShiftManagementSwapShift>;
  swapShiftsRequests: Array<ShiftManagementSwapShift>;
  swapshiftsConnection: ShiftManagementSwapShiftConnection;
  swapshiftsrequestsConnection: ShiftManagementSwapShiftConnection;
  /**
   * Identifier of the template week used to generate this shift. Template weeks
   * allow bulk creation of shifts following a pattern
   */
  templateWeekId?: Maybe<Scalars['Int']>;
  /** Combined name of the template and template week used to generate this shift, formatted as 'Template Name - Week Name' */
  templateWeekName?: Maybe<Scalars['String']>;
  /** IANA timezone identifier (e.g., 'Europe/Madrid', 'America/New_York') used to display the shift times in the local timezone */
  timezone: Scalars['String'];
  unassignedShift?: Maybe<ShiftManagementUnassignedShift>;
  /**
   * Identifier of the unassigned shift that was converted to create this shift.
   * Unassigned shifts are placeholders that can be assigned to employees
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  unassignedShiftId?: Maybe<Scalars['Int']>;
  workArea?: Maybe<LocationsWorkArea>;
};


/**
 * Retrieves and manages scheduled work shifts for employees. Shifts represent
 * planned work periods with start and end times, assigned to specific employees at
 * locations. Supports filtering by employees, locations, date ranges, and shift
 * states (draft, published, backup).
 */
export type ShiftManagementShiftAccessArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Retrieves and manages scheduled work shifts for employees. Shifts represent
 * planned work periods with start and end times, assigned to specific employees at
 * locations. Supports filtering by employees, locations, date ranges, and shift
 * states (draft, published, backup).
 */
export type ShiftManagementShiftDefaultShiftArgs = {
  id?: InputMaybe<Scalars['Int']>;
  unassignedShifts?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Retrieves and manages scheduled work shifts for employees. Shifts represent
 * planned work periods with start and end times, assigned to specific employees at
 * locations. Supports filtering by employees, locations, date ranges, and shift
 * states (draft, published, backup).
 */
export type ShiftManagementShiftEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Retrieves and manages scheduled work shifts for employees. Shifts represent
 * planned work periods with start and end times, assigned to specific employees at
 * locations. Supports filtering by employees, locations, date ranges, and shift
 * states (draft, published, backup).
 */
export type ShiftManagementShiftEmployeePermissionArgs = {
  currentEmployeeFirst?: InputMaybe<Scalars['Boolean']>;
  customFilters?: InputMaybe<Array<ShiftManagementCustomFilterInput>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endAt?: InputMaybe<Scalars['String']>;
  forTimeInsights?: Scalars['Boolean'];
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  logicOperator?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<EmployeeSortOptionsEnum>;
  orderDir?: InputMaybe<EmployeeSortDirectionEnum>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  shiftIds?: InputMaybe<Array<Scalars['Int']>>;
  startAt?: InputMaybe<Scalars['String']>;
  teamId?: InputMaybe<Scalars['Int']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withoutShiftIds?: InputMaybe<Array<Scalars['Int']>>;
};


/**
 * Retrieves and manages scheduled work shifts for employees. Shifts represent
 * planned work periods with start and end times, assigned to specific employees at
 * locations. Supports filtering by employees, locations, date ranges, and shift
 * states (draft, published, backup).
 */
export type ShiftManagementShiftLocationArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  main?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};


/**
 * Retrieves and manages scheduled work shifts for employees. Shifts represent
 * planned work periods with start and end times, assigned to specific employees at
 * locations. Supports filtering by employees, locations, date ranges, and shift
 * states (draft, published, backup).
 */
export type ShiftManagementShiftPlannedBreaksArgs = {
  activeBreakConfiguration?: Scalars['Boolean'];
  dayConfigurationIds?: Array<Scalars['Int']>;
  defaultShiftIds?: Array<Scalars['Int']>;
  ids?: Array<Scalars['Int']>;
  paid?: InputMaybe<Scalars['Boolean']>;
  shiftConfigurationIds?: Array<Scalars['Int']>;
};


/**
 * Retrieves and manages scheduled work shifts for employees. Shifts represent
 * planned work periods with start and end times, assigned to specific employees at
 * locations. Supports filtering by employees, locations, date ranges, and shift
 * states (draft, published, backup).
 */
export type ShiftManagementShiftPlannedbreaksConnectionArgs = {
  activeBreakConfiguration?: Scalars['Boolean'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  dayConfigurationIds?: Array<Scalars['Int']>;
  defaultShiftIds?: Array<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: Array<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  paid?: InputMaybe<Scalars['Boolean']>;
  shiftConfigurationIds?: Array<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/**
 * Retrieves and manages scheduled work shifts for employees. Shifts represent
 * planned work periods with start and end times, assigned to specific employees at
 * locations. Supports filtering by employees, locations, date ranges, and shift
 * states (draft, published, backup).
 */
export type ShiftManagementShiftShiftConfigurationArgs = {
  templateWeeksIds?: InputMaybe<Array<Scalars['Int']>>;
  weekday?: InputMaybe<Scalars['Int']>;
};


/**
 * Retrieves and manages scheduled work shifts for employees. Shifts represent
 * planned work periods with start and end times, assigned to specific employees at
 * locations. Supports filtering by employees, locations, date ranges, and shift
 * states (draft, published, backup).
 */
export type ShiftManagementShiftSwapShiftsArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endAt?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  requestedShiftIds?: InputMaybe<Array<Scalars['Int']>>;
  shiftIds?: InputMaybe<Array<Scalars['Int']>>;
  startAt?: InputMaybe<Scalars['ISO8601Date']>;
  status?: InputMaybe<Scalars['String']>;
};


/**
 * Retrieves and manages scheduled work shifts for employees. Shifts represent
 * planned work periods with start and end times, assigned to specific employees at
 * locations. Supports filtering by employees, locations, date ranges, and shift
 * states (draft, published, backup).
 */
export type ShiftManagementShiftSwapShiftsRequestsArgs = {
  currentShiftIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endAt?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  shiftIds?: InputMaybe<Array<Scalars['Int']>>;
  startAt?: InputMaybe<Scalars['ISO8601Date']>;
  status?: InputMaybe<Scalars['String']>;
};


/**
 * Retrieves and manages scheduled work shifts for employees. Shifts represent
 * planned work periods with start and end times, assigned to specific employees at
 * locations. Supports filtering by employees, locations, date ranges, and shift
 * states (draft, published, backup).
 */
export type ShiftManagementShiftSwapshiftsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endAt?: InputMaybe<Scalars['ISO8601Date']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  requestedShiftIds?: InputMaybe<Array<Scalars['Int']>>;
  shiftIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
  startAt?: InputMaybe<Scalars['ISO8601Date']>;
  status?: InputMaybe<Scalars['String']>;
};


/**
 * Retrieves and manages scheduled work shifts for employees. Shifts represent
 * planned work periods with start and end times, assigned to specific employees at
 * locations. Supports filtering by employees, locations, date ranges, and shift
 * states (draft, published, backup).
 */
export type ShiftManagementShiftSwapshiftsrequestsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  currentShiftIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endAt?: InputMaybe<Scalars['ISO8601Date']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  shiftIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
  startAt?: InputMaybe<Scalars['ISO8601Date']>;
  status?: InputMaybe<Scalars['String']>;
};


/**
 * Retrieves and manages scheduled work shifts for employees. Shifts represent
 * planned work periods with start and end times, assigned to specific employees at
 * locations. Supports filtering by employees, locations, date ranges, and shift
 * states (draft, published, backup).
 */
export type ShiftManagementShiftUnassignedShiftArgs = {
  endAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  locationId?: InputMaybe<Scalars['Int']>;
  startAt?: InputMaybe<Scalars['ISO8601DateTime']>;
};


/**
 * Retrieves and manages scheduled work shifts for employees. Shifts represent
 * planned work periods with start and end times, assigned to specific employees at
 * locations. Supports filtering by employees, locations, date ranges, and shift
 * states (draft, published, backup).
 */
export type ShiftManagementShiftWorkAreaArgs = {
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  onlyNonArchived?: Scalars['Boolean'];
};

/**
 * Manages shift configurations within template weeks. Shift configurations define
 * day-specific shift patterns (weekday, start/end times, day type) that are used
 * when generating shifts from template weeks. Each configuration represents how
 * shifts should be created for a specific day of the week within a template.
 * Supports bulk create, update, and delete operations for efficient template management.
 */
export type ShiftManagementShiftConfiguration = {
  __typename?: 'ShiftManagementShiftConfiguration';
  /**
   * Type of day this configuration represents. Common values include 'shift'
   * (regular work day), 'rest_day' (day off), or other custom day types defined by the company
   */
  dayType: Scalars['String'];
  /** End time for shifts created from this configuration. If null, no shift is created for this weekday */
  endAt?: Maybe<Scalars['ISO8601DateTime']>;
  formattedEndAt?: Maybe<Scalars['String']>;
  formattedStartAt?: Maybe<Scalars['String']>;
  /** Unique identifier for the shift configuration */
  id: Scalars['Int'];
  plannedBreaks: Array<TimePlanningPlannedBreak>;
  plannedbreaksConnection: TimePlanningPlannedBreakConnection;
  /** Start time for shifts created from this configuration. If null, no shift is created for this weekday */
  startAt?: Maybe<Scalars['ISO8601DateTime']>;
  templateWeek?: Maybe<ShiftManagementTemplateWeek>;
  /**
   * Identifier of the template week this configuration belongs to. Template weeks
   * contain multiple shift configurations, one for each day of the week
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  templateWeekId: Scalars['Int'];
  /**
   * Day of the week this configuration applies to. Values: 0 = Sunday, 1 = Monday,
   * 2 = Tuesday, 3 = Wednesday, 4 = Thursday, 5 = Friday, 6 = Saturday
   */
  weekday: Scalars['Int'];
};


/**
 * Manages shift configurations within template weeks. Shift configurations define
 * day-specific shift patterns (weekday, start/end times, day type) that are used
 * when generating shifts from template weeks. Each configuration represents how
 * shifts should be created for a specific day of the week within a template.
 * Supports bulk create, update, and delete operations for efficient template management.
 */
export type ShiftManagementShiftConfigurationPlannedBreaksArgs = {
  activeBreakConfiguration?: Scalars['Boolean'];
  dayConfigurationIds?: Array<Scalars['Int']>;
  defaultShiftIds?: Array<Scalars['Int']>;
  ids?: Array<Scalars['Int']>;
  paid?: InputMaybe<Scalars['Boolean']>;
  shiftIds?: Array<Scalars['Int']>;
};


/**
 * Manages shift configurations within template weeks. Shift configurations define
 * day-specific shift patterns (weekday, start/end times, day type) that are used
 * when generating shifts from template weeks. Each configuration represents how
 * shifts should be created for a specific day of the week within a template.
 * Supports bulk create, update, and delete operations for efficient template management.
 */
export type ShiftManagementShiftConfigurationPlannedbreaksConnectionArgs = {
  activeBreakConfiguration?: Scalars['Boolean'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  dayConfigurationIds?: Array<Scalars['Int']>;
  defaultShiftIds?: Array<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: Array<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  paid?: InputMaybe<Scalars['Boolean']>;
  shiftIds?: Array<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/**
 * Manages shift configurations within template weeks. Shift configurations define
 * day-specific shift patterns (weekday, start/end times, day type) that are used
 * when generating shifts from template weeks. Each configuration represents how
 * shifts should be created for a specific day of the week within a template.
 * Supports bulk create, update, and delete operations for efficient template management.
 */
export type ShiftManagementShiftConfigurationTemplateWeekArgs = {
  templateId?: InputMaybe<Scalars['Int']>;
};

/** The connection type for ShiftManagementShiftConfiguration. */
export type ShiftManagementShiftConfigurationConnection = {
  __typename?: 'ShiftManagementShiftConfigurationConnection';
  /** A list of edges. */
  edges: Array<ShiftManagementShiftConfigurationEdge>;
  /** A list of nodes. */
  nodes: Array<ShiftManagementShiftConfiguration>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ShiftManagementShiftConfigurationEdge = {
  __typename?: 'ShiftManagementShiftConfigurationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ShiftManagementShiftConfiguration;
};

export type ShiftManagementShiftConflict = {
  __typename?: 'ShiftManagementShiftConflict';
  conflictingLeavesIds: Array<Scalars['Int']>;
  conflictingRestDaysIds: Array<Scalars['Int']>;
  conflictingShiftsIds: Array<Scalars['Int']>;
  employeeId: Scalars['Int'];
  id: Scalars['Int'];
  startAt: Scalars['String'];
};

/** The connection type for ShiftManagementShift. */
export type ShiftManagementShiftConnection = {
  __typename?: 'ShiftManagementShiftConnection';
  /** A list of edges. */
  edges: Array<ShiftManagementShiftEdge>;
  /** A list of nodes. */
  nodes: Array<ShiftManagementShift>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ShiftManagementShiftEdge = {
  __typename?: 'ShiftManagementShiftEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ShiftManagementShift;
};

/** the filter for the shifts resource */
export type ShiftManagementShiftFilter = {
  localStartAt?: InputMaybe<DateTimeFilter>;
  or?: InputMaybe<Array<ShiftManagementShiftFilterConditions>>;
};

export type ShiftManagementShiftFilterConditions = {
  localStartAt?: InputMaybe<DateTimeFilter>;
};

export type ShiftManagementShiftInteractorDropActionEnum =
  | 'copy'
  | 'move';

/**
 * Retrieves statistics and conflict information for shift management. Provides
 * insights into draft shifts, conflicts between shifts and leaves/rest days, and
 * overall schedule health. Helps identify scheduling issues and validate shift
 * assignments before publishing.
 */
export type ShiftManagementStat = {
  __typename?: 'ShiftManagementStat';
  /** Indicates if there are drafts */
  hasDrafts: Scalars['Boolean'];
  /** Indicates if there are drafts without conflicts */
  hasDraftsWithoutConflict: Scalars['Boolean'];
  /**
   * List of shift conflicts detected in the schedule. Each conflict represents a
   * shift that overlaps with other shifts, leaves, or rest days for the same employee
   */
  shiftConflicts: Array<ShiftManagementShiftConflict>;
};

/** The connection type for ShiftManagementStat. */
export type ShiftManagementStatConnection = {
  __typename?: 'ShiftManagementStatConnection';
  /** A list of edges. */
  edges: Array<ShiftManagementStatEdge>;
  /** A list of nodes. */
  nodes: Array<ShiftManagementStat>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ShiftManagementStatEdge = {
  __typename?: 'ShiftManagementStatEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ShiftManagementStat;
};

/**
 * Manages shift swap requests between employees. Shift swaps allow employees to
 * exchange their scheduled shifts with each other. Supports creating swap
 * requests, approving or rejecting them through approval workflows, and tracking
 * swap status. Each swap request links a current shift (the shift being given up)
 * with a requested shift (the shift being requested).
 */
export type ShiftManagementSwapShift = {
  __typename?: 'ShiftManagementSwapShift';
  approvalFlow: ApprovalsMaterializedApprovalsFlow;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  approvalFlowId?: Maybe<Scalars['Int']>;
  approver?: Maybe<ApiCoreAccess>;
  /**
   * Identifier of the user/access who approved or rejected this swap request. Null if the request is still pending
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  approverId: Scalars['Int'];
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  currentShift?: Maybe<ShiftManagementShift>;
  /**
   * Identifier of the shift that the requesting employee wants to give up. This is the shift being swapped away
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  currentShiftId: Scalars['Int'];
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Unique identifier for the shift swap request */
  id: Scalars['Int'];
  /**
   * Reason provided by the manager or approver when approving or rejecting the
   * swap request. Used to communicate the decision rationale
   */
  managerReason: Scalars['String'];
  /** Reason provided by the employee initiating the swap request, explaining why they want to swap shifts */
  reason: Scalars['String'];
  requestedShift?: Maybe<ShiftManagementShift>;
  /**
   * Identifier of the shift that the requesting employee wants to receive. This is the shift being requested in exchange
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  requestedShiftId: Scalars['Int'];
  /**
   * Current status of the swap request. Common values include 'pending' (awaiting
   * approval), 'approved' (swap is confirmed), 'rejected' (swap was denied), or
   * 'cancelled' (request was cancelled)
   */
  status: Scalars['String'];
  /**
   * Reason provided by the teammate (employee who owns the requested shift)
   * explaining why they agree or disagree with the swap
   */
  teammateReason: Scalars['String'];
};


/**
 * Manages shift swap requests between employees. Shift swaps allow employees to
 * exchange their scheduled shifts with each other. Supports creating swap
 * requests, approving or rejecting them through approval workflows, and tracking
 * swap status. Each swap request links a current shift (the shift being given up)
 * with a requested shift (the shift being requested).
 */
export type ShiftManagementSwapShiftApprovalFlowArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  ownerId?: InputMaybe<Scalars['Int']>;
  resourceIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceType?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ApprovalsMaterializedApprovalFlowStatusEnum>;
};


/**
 * Manages shift swap requests between employees. Shift swaps allow employees to
 * exchange their scheduled shifts with each other. Supports creating swap
 * requests, approving or rejecting them through approval workflows, and tracking
 * swap status. Each swap request links a current shift (the shift being given up)
 * with a requested shift (the shift being requested).
 */
export type ShiftManagementSwapShiftApproverArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Manages shift swap requests between employees. Shift swaps allow employees to
 * exchange their scheduled shifts with each other. Supports creating swap
 * requests, approving or rejecting them through approval workflows, and tracking
 * swap status. Each swap request links a current shift (the shift being given up)
 * with a requested shift (the shift being requested).
 */
export type ShiftManagementSwapShiftCurrentShiftArgs = {
  effectiveLocationIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endAt?: InputMaybe<Scalars['String']>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  locationsWorkAreaIds?: InputMaybe<Array<Scalars['Int']>>;
  onlyPublished?: InputMaybe<Scalars['Boolean']>;
  onlyStates?: InputMaybe<Array<ShiftManagementEnumsShiftStateEnum>>;
  splitOvernightShifts?: InputMaybe<Scalars['Boolean']>;
  startAt?: InputMaybe<Scalars['String']>;
  withoutIds?: InputMaybe<Array<Scalars['Int']>>;
  withoutWorkArea?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Manages shift swap requests between employees. Shift swaps allow employees to
 * exchange their scheduled shifts with each other. Supports creating swap
 * requests, approving or rejecting them through approval workflows, and tracking
 * swap status. Each swap request links a current shift (the shift being given up)
 * with a requested shift (the shift being requested).
 */
export type ShiftManagementSwapShiftRequestedShiftArgs = {
  effectiveLocationIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endAt?: InputMaybe<Scalars['String']>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  locationsWorkAreaIds?: InputMaybe<Array<Scalars['Int']>>;
  onlyPublished?: InputMaybe<Scalars['Boolean']>;
  onlyStates?: InputMaybe<Array<ShiftManagementEnumsShiftStateEnum>>;
  splitOvernightShifts?: InputMaybe<Scalars['Boolean']>;
  startAt?: InputMaybe<Scalars['String']>;
  withoutIds?: InputMaybe<Array<Scalars['Int']>>;
  withoutWorkArea?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for ShiftManagementSwapShift. */
export type ShiftManagementSwapShiftConnection = {
  __typename?: 'ShiftManagementSwapShiftConnection';
  /** A list of edges. */
  edges: Array<ShiftManagementSwapShiftEdge>;
  /** A list of nodes. */
  nodes: Array<ShiftManagementSwapShift>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ShiftManagementSwapShiftEdge = {
  __typename?: 'ShiftManagementSwapShiftEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ShiftManagementSwapShift;
};

/**
 * Manages templates that define reusable shift patterns for generating schedules.
 * Templates contain one or more template weeks, each defining a weekly pattern of
 * shifts. Templates allow creating standardized schedules that can be applied to
 * multiple date ranges and employees. Supports creating, updating, deleting, and
 * reading templates.
 */
export type ShiftManagementTemplate = {
  __typename?: 'ShiftManagementTemplate';
  /**
   * Indicates whether this template is archived. Archived templates are hidden
   * from selection but can still be used for existing schedules. Set to true to
   * hide the template without deleting it
   */
  archived: Scalars['Boolean'];
  /** Identifier of the company that owns this template */
  companyId: Scalars['Int'];
  /** Unique identifier for the template */
  id: Scalars['Int'];
  /**
   * Display name of the template (e.g., 'Standard Schedule', 'Holiday Pattern',
   * 'Summer Schedule'). Used to identify and distinguish different templates
   */
  name: Scalars['String'];
  /**
   * Type of schedule this template represents. Common values include 'fixed'
   * (fixed weekly pattern) or other schedule types defined by the company
   */
  scheduleType: Scalars['String'];
  templateWeeks: Array<ShiftManagementTemplateWeek>;
  templateweeksConnection: ShiftManagementTemplateWeekConnection;
};


/**
 * Manages templates that define reusable shift patterns for generating schedules.
 * Templates contain one or more template weeks, each defining a weekly pattern of
 * shifts. Templates allow creating standardized schedules that can be applied to
 * multiple date ranges and employees. Supports creating, updating, deleting, and
 * reading templates.
 */
export type ShiftManagementTemplateTemplateWeeksArgs = {
  templateId?: InputMaybe<Scalars['Int']>;
};


/**
 * Manages templates that define reusable shift patterns for generating schedules.
 * Templates contain one or more template weeks, each defining a weekly pattern of
 * shifts. Templates allow creating standardized schedules that can be applied to
 * multiple date ranges and employees. Supports creating, updating, deleting, and
 * reading templates.
 */
export type ShiftManagementTemplateTemplateweeksConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  templateId?: InputMaybe<Scalars['Int']>;
};

/** The connection type for ShiftManagementTemplate. */
export type ShiftManagementTemplateConnection = {
  __typename?: 'ShiftManagementTemplateConnection';
  /** A list of edges. */
  edges: Array<ShiftManagementTemplateEdge>;
  /** A list of nodes. */
  nodes: Array<ShiftManagementTemplate>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ShiftManagementTemplateEdge = {
  __typename?: 'ShiftManagementTemplateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ShiftManagementTemplate;
};

/**
 * Manages template weeks that define weekly shift patterns for generating
 * schedules. Template weeks contain shift configurations for each day of the week
 * and belong to templates. They allow creating reusable weekly patterns that can
 * be applied to generate shifts for multiple weeks. Supports creating, updating,
 * deleting, and reading template weeks.
 */
export type ShiftManagementTemplateWeek = {
  __typename?: 'ShiftManagementTemplateWeek';
  /**
   * Indicates whether this template week is archived. Archived template weeks are
   * hidden from selection but can still be used for existing schedules. Set to
   * true to hide the template week without deleting it
   */
  archived: Scalars['Boolean'];
  /**
   * Color code (hex format) used to visually distinguish this template week in
   * calendar views and schedules. If null, a default color is used
   */
  color?: Maybe<Scalars['String']>;
  /** Unique identifier for the template week */
  id: Scalars['Int'];
  /**
   * Display name of the template week (e.g., 'Week 1', 'Morning Pattern', 'Night
   * Pattern'). Used to identify and distinguish different weekly patterns within a template
   */
  name: Scalars['String'];
  /** Position or order of this template week within its template. Used for sorting and organizing multiple template weeks */
  position: Scalars['Int'];
  shiftConfigurations: Array<ShiftManagementShiftConfiguration>;
  shiftconfigurationsConnection: ShiftManagementShiftConfigurationConnection;
  template?: Maybe<ShiftManagementTemplate>;
  /**
   * Identifier of the template this week belongs to. Templates can contain
   * multiple template weeks for different weekly patterns
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  templateId: Scalars['Int'];
  /** Name of the parent template. Provided for convenience in display and filtering */
  templateName: Scalars['String'];
};


/**
 * Manages template weeks that define weekly shift patterns for generating
 * schedules. Template weeks contain shift configurations for each day of the week
 * and belong to templates. They allow creating reusable weekly patterns that can
 * be applied to generate shifts for multiple weeks. Supports creating, updating,
 * deleting, and reading template weeks.
 */
export type ShiftManagementTemplateWeekShiftConfigurationsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  templateWeeksIds?: InputMaybe<Array<Scalars['Int']>>;
  weekday?: InputMaybe<Scalars['Int']>;
};


/**
 * Manages template weeks that define weekly shift patterns for generating
 * schedules. Template weeks contain shift configurations for each day of the week
 * and belong to templates. They allow creating reusable weekly patterns that can
 * be applied to generate shifts for multiple weeks. Supports creating, updating,
 * deleting, and reading template weeks.
 */
export type ShiftManagementTemplateWeekShiftconfigurationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  templateWeeksIds?: InputMaybe<Array<Scalars['Int']>>;
  weekday?: InputMaybe<Scalars['Int']>;
};


/**
 * Manages template weeks that define weekly shift patterns for generating
 * schedules. Template weeks contain shift configurations for each day of the week
 * and belong to templates. They allow creating reusable weekly patterns that can
 * be applied to generate shifts for multiple weeks. Supports creating, updating,
 * deleting, and reading template weeks.
 */
export type ShiftManagementTemplateWeekTemplateArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  searchByName?: InputMaybe<Scalars['String']>;
};

/** The connection type for ShiftManagementTemplateWeek. */
export type ShiftManagementTemplateWeekConnection = {
  __typename?: 'ShiftManagementTemplateWeekConnection';
  /** A list of edges. */
  edges: Array<ShiftManagementTemplateWeekEdge>;
  /** A list of nodes. */
  nodes: Array<ShiftManagementTemplateWeek>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ShiftManagementTemplateWeekEdge = {
  __typename?: 'ShiftManagementTemplateWeekEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ShiftManagementTemplateWeek;
};

/**
 * Manages unassigned shift placeholders that represent work periods without
 * assigned employees. Unassigned shifts are temporary placeholders created when
 * shifts need to be scheduled but no employee has been assigned yet. They can be
 * converted to regular shifts when employees are assigned. Supports visibility
 * controls for locations, teams, and job roles. Useful for planning shifts before
 * assigning them to specific employees.
 */
export type ShiftManagementUnassignedShift = {
  __typename?: 'ShiftManagementUnassignedShift';
  /**
   * When true, this unassigned shift is visible company-wide to all locations and
   * teams. When false, visibility is restricted to specific locations and teams
   * defined in visible_locations_ids and visible_teams_ids
   */
  allCompany: Scalars['Boolean'];
  /**
   * Color code (hex format) used to visually distinguish this unassigned shift in
   * calendar views. Helps identify unassigned shifts visually
   */
  color?: Maybe<Scalars['String']>;
  /**
   * Number of employees needed for this unassigned shift. When converting to
   * regular shifts, this determines how many shifts should be created. Useful for
   * shifts that require multiple employees
   */
  counter: Scalars['Int'];
  /**
   * Identifier of the default shift template used to create this unassigned shift.
   * Provides the shift pattern (start/end times, title) for the placeholder
   */
  defaultShiftId?: Maybe<Scalars['Int']>;
  /** Title from the default shift template. Displayed in calendar views to help identify the type of shift needed */
  defaultShiftTitle?: Maybe<Scalars['String']>;
  /**
   * Timestamp indicating when the unassigned shift period ends. This will become
   * the end time when converted to a regular shift
   */
  endAt: Scalars['ISO8601DateTime'];
  /**
   * Indicates whether this unassigned shift should be marked as extra hours
   * (overtime) when converted to a regular shift. Used for overtime calculations
   */
  extraHours?: Maybe<Scalars['Boolean']>;
  /** Unique identifier for the unassigned shift placeholder */
  id: Scalars['Int'];
  jobCatalogRolesIds: Array<Scalars['Int']>;
  jobCatalogTreeRoleUuids: Array<Scalars['String']>;
  /** Identifier of the location where this unassigned shift will take place. Can be null if the shift uses a default location */
  locationId?: Maybe<Scalars['Int']>;
  /**
   * Identifier of the specific work area within the location where this unassigned
   * shift will occur. Work areas allow further subdivision of locations
   */
  locationsWorkAreaId?: Maybe<Scalars['Int']>;
  /**
   * Optional notes or comments about this unassigned shift. These notes will be
   * preserved when the shift is converted to a regular shift
   */
  notes?: Maybe<Scalars['String']>;
  /**
   * Indicates whether this unassigned shift spans across midnight (e.g., starts on
   * one day and ends on the next). Used for proper calendar display and duration calculations
   */
  overnightShift: Scalars['Boolean'];
  /**
   * Timestamp indicating when the unassigned shift period starts. This will become
   * the start time when converted to a regular shift
   */
  startAt: Scalars['ISO8601DateTime'];
  /**
   * List of location identifiers where this unassigned shift is visible and can be
   * assigned. Only relevant when all_company is false. Empty array means the shift
   * is not visible at any location
   */
  visibleLocationsIds: Array<Scalars['Int']>;
  /**
   * List of team identifiers where this unassigned shift is visible and can be
   * assigned. Only relevant when all_company is false. Empty array means the shift
   * is not visible to any team
   */
  visibleTeamsIds: Array<Scalars['Int']>;
};

/** The connection type for ShiftManagementUnassignedShift. */
export type ShiftManagementUnassignedShiftConnection = {
  __typename?: 'ShiftManagementUnassignedShiftConnection';
  /** A list of edges. */
  edges: Array<ShiftManagementUnassignedShiftEdge>;
  /** A list of nodes. */
  nodes: Array<ShiftManagementUnassignedShift>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ShiftManagementUnassignedShiftEdge = {
  __typename?: 'ShiftManagementUnassignedShiftEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ShiftManagementUnassignedShift;
};

/**
 * Retrieves work areas within locations for shift management. Work areas allow
 * further subdivision of locations for more granular scheduling and organization.
 * Each work area belongs to a location and can have shifts and employees assigned
 * to it. Supports filtering by locations, teams, employees, date ranges, and
 * custom filters.
 */
export type ShiftManagementWorkArea = {
  __typename?: 'ShiftManagementWorkArea';
  /**
   * Timestamp indicating when this work area was archived. If null, the work area
   * is active. Archived work areas are hidden but can still be referenced by
   * existing shifts
   */
  archivedAt?: Maybe<Scalars['ISO8601DateTime']>;
  employeesPermissions: Array<ShiftManagementEmployeesPermission>;
  employeespermissionsConnection: ShiftManagementEmployeesPermissionConnection;
  /** Unique identifier for the work area. Can be null for unassigned work areas */
  id?: Maybe<Scalars['Int']>;
  location?: Maybe<LocationsLocation>;
  /**
   * Identifier of the location this work area belongs to. Work areas are subdivisions of locations
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  locationId: Scalars['Int'];
  /** Name of the parent location. Provided for convenience in display and filtering */
  locationName: Scalars['String'];
  /**
   * Display name of the work area (e.g., 'Kitchen', 'Front Desk', 'Warehouse').
   * Used to identify and distinguish work areas within a location
   */
  name: Scalars['String'];
  shifts: Array<ShiftManagementShift>;
  shiftsConnection: ShiftManagementShiftConnection;
};


/**
 * Retrieves work areas within locations for shift management. Work areas allow
 * further subdivision of locations for more granular scheduling and organization.
 * Each work area belongs to a location and can have shifts and employees assigned
 * to it. Supports filtering by locations, teams, employees, date ranges, and
 * custom filters.
 */
export type ShiftManagementWorkAreaEmployeesPermissionsArgs = {
  currentEmployeeFirst?: InputMaybe<Scalars['Boolean']>;
  customFilters?: InputMaybe<Array<ShiftManagementCustomFilterInput>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endAt?: InputMaybe<Scalars['String']>;
  forTimeInsights?: Scalars['Boolean'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  logicOperator?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<EmployeeSortOptionsEnum>;
  orderDir?: InputMaybe<EmployeeSortDirectionEnum>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  shiftIds?: InputMaybe<Array<Scalars['Int']>>;
  startAt?: InputMaybe<Scalars['String']>;
  teamId?: InputMaybe<Scalars['Int']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withoutShiftIds?: InputMaybe<Array<Scalars['Int']>>;
};


/**
 * Retrieves work areas within locations for shift management. Work areas allow
 * further subdivision of locations for more granular scheduling and organization.
 * Each work area belongs to a location and can have shifts and employees assigned
 * to it. Supports filtering by locations, teams, employees, date ranges, and
 * custom filters.
 */
export type ShiftManagementWorkAreaEmployeespermissionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  currentEmployeeFirst?: InputMaybe<Scalars['Boolean']>;
  customFilters?: InputMaybe<Array<ShiftManagementCustomFilterInput>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endAt?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forTimeInsights?: Scalars['Boolean'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  logicOperator?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<EmployeeSortOptionsEnum>;
  orderDir?: InputMaybe<EmployeeSortDirectionEnum>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  shiftIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
  startAt?: InputMaybe<Scalars['String']>;
  teamId?: InputMaybe<Scalars['Int']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withoutShiftIds?: InputMaybe<Array<Scalars['Int']>>;
};


/**
 * Retrieves work areas within locations for shift management. Work areas allow
 * further subdivision of locations for more granular scheduling and organization.
 * Each work area belongs to a location and can have shifts and employees assigned
 * to it. Supports filtering by locations, teams, employees, date ranges, and
 * custom filters.
 */
export type ShiftManagementWorkAreaLocationArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  main?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};


/**
 * Retrieves work areas within locations for shift management. Work areas allow
 * further subdivision of locations for more granular scheduling and organization.
 * Each work area belongs to a location and can have shifts and employees assigned
 * to it. Supports filtering by locations, teams, employees, date ranges, and
 * custom filters.
 */
export type ShiftManagementWorkAreaShiftsArgs = {
  effectiveLocationIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endAt?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  onlyPublished?: InputMaybe<Scalars['Boolean']>;
  onlyStates?: InputMaybe<Array<ShiftManagementEnumsShiftStateEnum>>;
  splitOvernightShifts?: InputMaybe<Scalars['Boolean']>;
  startAt?: InputMaybe<Scalars['String']>;
  withoutIds?: InputMaybe<Array<Scalars['Int']>>;
  withoutWorkArea?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Retrieves work areas within locations for shift management. Work areas allow
 * further subdivision of locations for more granular scheduling and organization.
 * Each work area belongs to a location and can have shifts and employees assigned
 * to it. Supports filtering by locations, teams, employees, date ranges, and
 * custom filters.
 */
export type ShiftManagementWorkAreaShiftsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  effectiveLocationIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endAt?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyPublished?: InputMaybe<Scalars['Boolean']>;
  onlyStates?: InputMaybe<Array<ShiftManagementEnumsShiftStateEnum>>;
  sortOrder?: InputMaybe<Sort>;
  splitOvernightShifts?: InputMaybe<Scalars['Boolean']>;
  startAt?: InputMaybe<Scalars['String']>;
  withoutIds?: InputMaybe<Array<Scalars['Int']>>;
  withoutWorkArea?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for ShiftManagementWorkArea. */
export type ShiftManagementWorkAreaConnection = {
  __typename?: 'ShiftManagementWorkAreaConnection';
  /** A list of edges. */
  edges: Array<ShiftManagementWorkAreaEdge>;
  /** A list of nodes. */
  nodes: Array<ShiftManagementWorkArea>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type ShiftManagementWorkAreaEdge = {
  __typename?: 'ShiftManagementWorkAreaEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ShiftManagementWorkArea;
};

/** Autogenerated return type of ShiftManagement_automation_generate_schedule_subscription. */
export type ShiftManagement_Automation_Generate_Schedule_SubscriptionPayload = {
  __typename?: 'ShiftManagement_automation_generate_schedule_subscriptionPayload';
  automation?: Maybe<Automation_Generate_Schedule_Type>;
};

/** Autogenerated return type of ShowPostsPost. */
export type ShowPostsPostPayload = {
  __typename?: 'ShowPostsPostPayload';
  errors: Array<MutationError>;
  post?: Maybe<PostsPost>;
};

/** Autogenerated return type of SignAsEmployeePerformanceAgreement. */
export type SignAsEmployeePerformanceAgreementPayload = {
  __typename?: 'SignAsEmployeePerformanceAgreementPayload';
  agreement?: Maybe<PerformanceAgreement>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of SignAsManagerPerformanceAgreement. */
export type SignAsManagerPerformanceAgreementPayload = {
  __typename?: 'SignAsManagerPerformanceAgreementPayload';
  agreement?: Maybe<PerformanceAgreement>;
  errors: Array<MutationError>;
};

/** Signal tags */
export type SignalsTag = {
  __typename?: 'SignalsTag';
  id: Scalars['String'];
  name: Scalars['String'];
};

/** The connection type for SignalsTag. */
export type SignalsTagConnection = {
  __typename?: 'SignalsTagConnection';
  /** A list of edges. */
  edges: Array<SignalsTagEdge>;
  /** A list of nodes. */
  nodes: Array<SignalsTag>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type SignalsTagEdge = {
  __typename?: 'SignalsTagEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: SignalsTag;
};

export type SimpleError = {
  __typename?: 'SimpleError';
  message: Scalars['String'];
  type: Scalars['String'];
};

/** Autogenerated return type of SnoozeBankingTransaction. */
export type SnoozeBankingTransactionPayload = {
  __typename?: 'SnoozeBankingTransactionPayload';
  errors: Array<MutationError>;
  transaction?: Maybe<BankingTransaction>;
};

/** Autogenerated return type of SnoozeFinanceJournalLine. */
export type SnoozeFinanceJournalLinePayload = {
  __typename?: 'SnoozeFinanceJournalLinePayload';
  errors: Array<MutationError>;
  journalLine?: Maybe<FinanceJournalLine>;
};

/** Autogenerated return type of SoftDeleteComplaintsComplaint. */
export type SoftDeleteComplaintsComplaintPayload = {
  __typename?: 'SoftDeleteComplaintsComplaintPayload';
  complaint?: Maybe<ComplaintsComplaint>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of SoftDeleteFinanceContactDocument. */
export type SoftDeleteFinanceContactDocumentPayload = {
  __typename?: 'SoftDeleteFinanceContactDocumentPayload';
  contactDocuments?: Maybe<Array<FinanceContactDocument>>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of SoftDeleteFinanceCustomCategory. */
export type SoftDeleteFinanceCustomCategoryPayload = {
  __typename?: 'SoftDeleteFinanceCustomCategoryPayload';
  customCategory?: Maybe<FinanceCustomCategory>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of SoftDeleteIntegrationsindeedAccount. */
export type SoftDeleteIntegrationsindeedAccountPayload = {
  __typename?: 'SoftDeleteIntegrationsindeedAccountPayload';
  account?: Maybe<IntegrationsIndeedAccount>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of SoftDeleteProjectmanagementProjectDocument. */
export type SoftDeleteProjectmanagementProjectDocumentPayload = {
  __typename?: 'SoftDeleteProjectmanagementProjectDocumentPayload';
  errors: Array<MutationError>;
  projectDocuments?: Maybe<Array<ProjectManagementProjectDocument>>;
};

/** Autogenerated return type of SoftDeleteProjectmanagementProject. */
export type SoftDeleteProjectmanagementProjectPayload = {
  __typename?: 'SoftDeleteProjectmanagementProjectPayload';
  errors: Array<MutationError>;
  project?: Maybe<ProjectManagementProject>;
};

export type SoftwareManagementContextlessPolicies = {
  __typename?: 'SoftwareManagementContextlessPolicies';
  manageSoftware: ContextlessPolicyResolution;
  settingsSeeSoftwareSettings: ContextlessPolicyResolution;
  sidebarSeeSoftwareSubModule: ContextlessPolicyResolution;
  sidebarSeeSoftwareTopLevelItem: ContextlessPolicyResolution;
};

/** Custom software created by company */
export type SoftwareManagementCustomSoftware = {
  __typename?: 'SoftwareManagementCustomSoftware';
  id: Scalars['String'];
  logoUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

/** The connection type for SoftwareManagementCustomSoftware. */
export type SoftwareManagementCustomSoftwareConnection = {
  __typename?: 'SoftwareManagementCustomSoftwareConnection';
  /** A list of edges. */
  edges: Array<SoftwareManagementCustomSoftwareEdge>;
  /** A list of nodes. */
  nodes: Array<SoftwareManagementCustomSoftware>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type SoftwareManagementCustomSoftwareEdge = {
  __typename?: 'SoftwareManagementCustomSoftwareEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: SoftwareManagementCustomSoftware;
};

/** Different software costs to display on dashboard */
export type SoftwareManagementDashboardSoftwareCost = {
  __typename?: 'SoftwareManagementDashboardSoftwareCost';
  monthlyCostInCents: Scalars['Int'];
  monthlyIndexedDate: Scalars['String'];
  seatCostInCents: Scalars['Int'];
};

/** The connection type for SoftwareManagementDashboardSoftwareCost. */
export type SoftwareManagementDashboardSoftwareCostConnection = {
  __typename?: 'SoftwareManagementDashboardSoftwareCostConnection';
  /** A list of edges. */
  edges: Array<SoftwareManagementDashboardSoftwareCostEdge>;
  /** A list of nodes. */
  nodes: Array<SoftwareManagementDashboardSoftwareCost>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type SoftwareManagementDashboardSoftwareCostEdge = {
  __typename?: 'SoftwareManagementDashboardSoftwareCostEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: SoftwareManagementDashboardSoftwareCost;
};

/** Employee object for IT Management Finance */
export type SoftwareManagementEmployee = {
  __typename?: 'SoftwareManagementEmployee';
  access: ApiCoreAccess;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  accessId: Scalars['Int'];
  employeeName: EmployeesEmployeeName;
  employeeSoftwareMemberships: Array<SoftwareManagementEmployeeSoftwareMembership>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  employeesLocationIds: Array<Scalars['Int']>;
  employeesoftwaremembershipsConnection: SoftwareManagementEmployeeSoftwareMembershipConnection;
  firstName: Scalars['String'];
  id: Scalars['Int'];
  isTerminating: Scalars['Boolean'];
  lastName: Scalars['String'];
  locations: Array<LocationsLocation>;
  locationsConnection: LocationsLocationConnection;
  memberships: Array<TeamsMembership>;
  membershipsConnection: TeamsMembershipConnection;
  preferredName?: Maybe<Scalars['String']>;
  referenceContract?: Maybe<ContractsReferenceContract>;
};


/** Employee object for IT Management Finance */
export type SoftwareManagementEmployeeAccessArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** Employee object for IT Management Finance */
export type SoftwareManagementEmployeeEmployeeNameArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  afterEmployeeId?: InputMaybe<Scalars['Int']>;
  beforeEmployeeId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  reporteesOrLed?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyId?: InputMaybe<Scalars['Int']>;
  verb?: InputMaybe<Scalars['String']>;
  withActiveContract?: Scalars['Boolean'];
};


/** Employee object for IT Management Finance */
export type SoftwareManagementEmployeeEmployeeSoftwareMembershipsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  onlyTerminated?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  softwareIds?: InputMaybe<Array<Scalars['String']>>;
  softwareSetupIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Employee object for IT Management Finance */
export type SoftwareManagementEmployeeEmployeesoftwaremembershipsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyTerminated?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  softwareIds?: InputMaybe<Array<Scalars['String']>>;
  softwareSetupIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
};


/** Employee object for IT Management Finance */
export type SoftwareManagementEmployeeLocationsArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  main?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};


/** Employee object for IT Management Finance */
export type SoftwareManagementEmployeeLocationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  main?: InputMaybe<Scalars['Boolean']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Employee object for IT Management Finance */
export type SoftwareManagementEmployeeMembershipsArgs = {
  activeEmployees?: Scalars['Boolean'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  lead?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  sortByLeads?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Employee object for IT Management Finance */
export type SoftwareManagementEmployeeMembershipsConnectionArgs = {
  activeEmployees?: Scalars['Boolean'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  lead?: InputMaybe<Scalars['Boolean']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortByLeads?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Sort>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Employee object for IT Management Finance */
export type SoftwareManagementEmployeeReferenceContractArgs = {
  activeBetween?: InputMaybe<ReferenceContractsActiveBetweenInput>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  effectiveOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  endsOnGt?: InputMaybe<Scalars['ISO8601Date']>;
  endsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  frContractTypeIds?: InputMaybe<Array<Scalars['Int']>>;
  frMutualIds?: InputMaybe<Array<Scalars['Int']>>;
  frWorkTypeIds?: InputMaybe<Array<Scalars['Int']>>;
  includeDenormalizedData?: Scalars['Boolean'];
  includeEducationLevel?: Scalars['Boolean'];
  jobCatalogLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  jobCatalogTreeNodeUuids?: InputMaybe<Array<Scalars['String']>>;
  onDate?: InputMaybe<Scalars['ISO8601Date']>;
  payrollPolicyId?: InputMaybe<Scalars['Int']>;
  startsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  startsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedBecauseRelatedModels?: InputMaybe<Scalars['Boolean']>;
  withPayroll?: InputMaybe<Scalars['Boolean']>;
  withTranslations?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for SoftwareManagementEmployee. */
export type SoftwareManagementEmployeeConnection = {
  __typename?: 'SoftwareManagementEmployeeConnection';
  /** A list of edges. */
  edges: Array<SoftwareManagementEmployeeEdge>;
  /** A list of nodes. */
  nodes: Array<SoftwareManagementEmployee>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type SoftwareManagementEmployeeEdge = {
  __typename?: 'SoftwareManagementEmployeeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: SoftwareManagementEmployee;
};

/** the filter for the employees resource */
export type SoftwareManagementEmployeeFilter = {
  id?: InputMaybe<IntegerFilter>;
  or?: InputMaybe<Array<SoftwareManagementEmployeeFilterConditions>>;
};

export type SoftwareManagementEmployeeFilterConditions = {
  id?: InputMaybe<IntegerFilter>;
};

/** Relationship between employees and software */
export type SoftwareManagementEmployeeSoftwareMembership = {
  __typename?: 'SoftwareManagementEmployeeSoftwareMembership';
  customSoftware?: Maybe<SoftwareManagementCustomSoftware>;
  employee: EmployeesEmployee;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  employeeId: Scalars['Int'];
  id: Scalars['Int'];
  software?: Maybe<SoftwareManagementSoftware>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  softwareId: Scalars['String'];
  softwareSetupId: Scalars['Int'];
};


/** Relationship between employees and software */
export type SoftwareManagementEmployeeSoftwareMembershipEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for SoftwareManagementEmployeeSoftwareMembership. */
export type SoftwareManagementEmployeeSoftwareMembershipConnection = {
  __typename?: 'SoftwareManagementEmployeeSoftwareMembershipConnection';
  /** A list of edges. */
  edges: Array<SoftwareManagementEmployeeSoftwareMembershipEdge>;
  /** A list of nodes. */
  nodes: Array<SoftwareManagementEmployeeSoftwareMembership>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type SoftwareManagementEmployeeSoftwareMembershipEdge = {
  __typename?: 'SoftwareManagementEmployeeSoftwareMembershipEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: SoftwareManagementEmployeeSoftwareMembership;
};

/** the filter for the employee_software_memberships resource */
export type SoftwareManagementEmployeeSoftwareMembershipFilter = {
  employee?: InputMaybe<IntegerFilter>;
  id?: InputMaybe<IntegerFilter>;
  or?: InputMaybe<Array<SoftwareManagementEmployeeSoftwareMembershipFilterConditions>>;
};

export type SoftwareManagementEmployeeSoftwareMembershipFilterConditions = {
  employee?: InputMaybe<IntegerFilter>;
  id?: InputMaybe<IntegerFilter>;
};

export type SoftwareManagementFile = {
  __typename?: 'SoftwareManagementFile';
  contentType: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  filename: Scalars['String'];
  id: Scalars['Int'];
  url: Scalars['String'];
};

/** Software costs for each month */
export type SoftwareManagementMonthlySoftwareCost = {
  __typename?: 'SoftwareManagementMonthlySoftwareCost';
  costInCents: Scalars['Int'];
  monthlyIndexedDate: Scalars['String'];
  softwareSetupId: Scalars['Int'];
};

/** The connection type for SoftwareManagementMonthlySoftwareCost. */
export type SoftwareManagementMonthlySoftwareCostConnection = {
  __typename?: 'SoftwareManagementMonthlySoftwareCostConnection';
  /** A list of edges. */
  edges: Array<SoftwareManagementMonthlySoftwareCostEdge>;
  /** A list of nodes. */
  nodes: Array<SoftwareManagementMonthlySoftwareCost>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type SoftwareManagementMonthlySoftwareCostEdge = {
  __typename?: 'SoftwareManagementMonthlySoftwareCostEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: SoftwareManagementMonthlySoftwareCost;
};

/** Predefined software by Factorial */
export type SoftwareManagementSoftware = {
  __typename?: 'SoftwareManagementSoftware';
  id: Scalars['String'];
  logoUrl: Scalars['String'];
  name: Scalars['String'];
};

/** The connection type for SoftwareManagementSoftware. */
export type SoftwareManagementSoftwareConnection = {
  __typename?: 'SoftwareManagementSoftwareConnection';
  /** A list of edges. */
  edges: Array<SoftwareManagementSoftwareEdge>;
  /** A list of nodes. */
  nodes: Array<SoftwareManagementSoftware>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type SoftwareManagementSoftwareEdge = {
  __typename?: 'SoftwareManagementSoftwareEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: SoftwareManagementSoftware;
};

/** Multi sourcer payments for software */
export type SoftwareManagementSoftwarePayment = {
  __typename?: 'SoftwareManagementSoftwarePayment';
  amountCents: Scalars['Int'];
  cardPayment?: Maybe<BankingCardPayment>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  cardPaymentId?: Maybe<Scalars['Int']>;
  currency: Scalars['String'];
  executedAt: Scalars['ISO8601DateTime'];
  financialDocument?: Maybe<FinanceFinancialDocument>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  financialDocumentId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  invoiceId?: Maybe<Scalars['Int']>;
  owner?: Maybe<EmployeesEmployee>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  ownerId?: Maybe<Scalars['Int']>;
  softwareSetup: SoftwareManagementSoftwareSetup;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  softwareSetupId: Scalars['Int'];
  source?: Maybe<SoftwareManagementSoftwarePaymentSource>;
  sourceId?: Maybe<Scalars['Int']>;
  sourceType?: Maybe<Scalars['String']>;
};


/** Multi sourcer payments for software */
export type SoftwareManagementSoftwarePaymentCardPaymentArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']>>;
  calculatedLabel?: InputMaybe<BankingEntitiesCardPaymentCalculatedLabelEnum>;
  cardIds?: InputMaybe<Array<Scalars['Int']>>;
  externalIds?: InputMaybe<Array<Scalars['String']>>;
  from?: InputMaybe<Scalars['ISO8601DateTime']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<BankingEntitiesCardPaymentStatusEnum>;
  to?: InputMaybe<Scalars['ISO8601DateTime']>;
};


/** Multi sourcer payments for software */
export type SoftwareManagementSoftwarePaymentFinancialDocumentArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  currency?: InputMaybe<Scalars['String']>;
  dealId?: InputMaybe<Scalars['Int']>;
  documentTypes?: InputMaybe<Array<FinanceValueObjectsFinancialDocumentTypeEnum>>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  issuerName?: InputMaybe<Scalars['String']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  operationTypes?: InputMaybe<Array<FinanceValueObjectsFinancialDocumentOperationTypeEnum>>;
  parentFinancialDocumentIds?: InputMaybe<Array<Scalars['Int']>>;
  projectId?: InputMaybe<Scalars['Int']>;
  reconcilable?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<FinanceValueObjectsInvoiceStatusEnum>>;
  toDate?: InputMaybe<Scalars['ISO8601Date']>;
  toDueDate?: InputMaybe<Scalars['ISO8601Date']>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
  vendorId?: InputMaybe<Scalars['Int']>;
};


/** Multi sourcer payments for software */
export type SoftwareManagementSoftwarePaymentOwnerArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Multi sourcer payments for software */
export type SoftwareManagementSoftwarePaymentSoftwareSetupArgs = {
  cardIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  vendorIds?: InputMaybe<Array<Scalars['Int']>>;
  withoutCard?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for SoftwareManagementSoftwarePayment. */
export type SoftwareManagementSoftwarePaymentConnection = {
  __typename?: 'SoftwareManagementSoftwarePaymentConnection';
  /** A list of edges. */
  edges: Array<SoftwareManagementSoftwarePaymentEdge>;
  /** A list of nodes. */
  nodes: Array<SoftwareManagementSoftwarePayment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type SoftwareManagementSoftwarePaymentEdge = {
  __typename?: 'SoftwareManagementSoftwarePaymentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: SoftwareManagementSoftwarePayment;
};

/** the filter for the software_payments resource */
export type SoftwareManagementSoftwarePaymentFilter = {
  executedAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntegerFilter>;
  or?: InputMaybe<Array<SoftwareManagementSoftwarePaymentFilterConditions>>;
};

export type SoftwareManagementSoftwarePaymentFilterConditions = {
  executedAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntegerFilter>;
};

export type SoftwareManagementSoftwarePaymentSource = {
  __typename?: 'SoftwareManagementSoftwarePaymentSource';
  sourceId: Scalars['Int'];
  sourceType: SoftwareManagementValueObjectsSoftwarePaymentSourceTypeEnum;
};

export type SoftwareManagementSoftwarePaymentSourceInput = {
  sourceId: Scalars['Int'];
  sourceType: SoftwareManagementValueObjectsSoftwarePaymentSourceTypeEnum;
};

/** Software configured by companies */
export type SoftwareManagementSoftwareSetup = {
  __typename?: 'SoftwareManagementSoftwareSetup';
  card?: Maybe<BankingCard>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  cardId?: Maybe<Scalars['Int']>;
  companyId: Scalars['Int'];
  contract?: Maybe<SoftwareManagementFile>;
  createdAt: Scalars['ISO8601DateTime'];
  customSoftware?: Maybe<SoftwareManagementCustomSoftware>;
  employeeSoftwareMemberships: Array<SoftwareManagementEmployeeSoftwareMembership>;
  employeeSoftwareMembershipsConnection: SoftwareManagementEmployeeSoftwareMembershipConnection;
  hasPayments: Scalars['Boolean'];
  id: Scalars['Int'];
  licenseType?: Maybe<Scalars['String']>;
  monthlySoftwareCosts: Array<SoftwareManagementMonthlySoftwareCost>;
  monthlySoftwareCostsConnection: SoftwareManagementMonthlySoftwareCostConnection;
  renewalDate?: Maybe<Scalars['ISO8601Date']>;
  software?: Maybe<SoftwareManagementSoftware>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  softwareId: Scalars['String'];
  vendor?: Maybe<FinanceContact>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  vendorId?: Maybe<Scalars['Int']>;
};


/** Software configured by companies */
export type SoftwareManagementSoftwareSetupCardArgs = {
  bankAccountIds?: InputMaybe<Array<Scalars['Int']>>;
  cardholderIds?: InputMaybe<Array<Scalars['Int']>>;
  creationSource?: InputMaybe<BankingValueObjectsCardCreationSourceEnum>;
  last4?: InputMaybe<Scalars['String']>;
  ownerIds?: InputMaybe<Array<Scalars['Int']>>;
  requestedWithoutApprovalFlow?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<BankingValueObjectsCardStatusEnum>;
};


/** Software configured by companies */
export type SoftwareManagementSoftwareSetupEmployeeSoftwareMembershipsArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  onlyTerminated?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  softwareIds?: InputMaybe<Array<Scalars['String']>>;
};


/** Software configured by companies */
export type SoftwareManagementSoftwareSetupEmployeeSoftwareMembershipsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyTerminated?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  softwareIds?: InputMaybe<Array<Scalars['String']>>;
  sortOrder?: InputMaybe<Sort>;
};


/** Software configured by companies */
export type SoftwareManagementSoftwareSetupMonthlySoftwareCostsArgs = {
  currency?: InputMaybe<Scalars['String']>;
  dateFrom?: InputMaybe<Scalars['String']>;
  dateTo?: InputMaybe<Scalars['String']>;
};


/** Software configured by companies */
export type SoftwareManagementSoftwareSetupMonthlySoftwareCostsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  dateFrom?: InputMaybe<Scalars['String']>;
  dateTo?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Software configured by companies */
export type SoftwareManagementSoftwareSetupVendorArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  contactType?: InputMaybe<FinanceValueObjectsContactTypeEnum>;
  email?: InputMaybe<Scalars['String']>;
  legalName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  taxIdType?: InputMaybe<Scalars['String']>;
  taxIds?: InputMaybe<Array<Scalars['String']>>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
  website?: InputMaybe<Scalars['String']>;
};

/** The connection type for SoftwareManagementSoftwareSetup. */
export type SoftwareManagementSoftwareSetupConnection = {
  __typename?: 'SoftwareManagementSoftwareSetupConnection';
  /** A list of edges. */
  edges: Array<SoftwareManagementSoftwareSetupEdge>;
  /** A list of nodes. */
  nodes: Array<SoftwareManagementSoftwareSetup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type SoftwareManagementSoftwareSetupEdge = {
  __typename?: 'SoftwareManagementSoftwareSetupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: SoftwareManagementSoftwareSetup;
};

/** the filter for the software_setups resource */
export type SoftwareManagementSoftwareSetupFilter = {
  id?: InputMaybe<IntegerFilter>;
  or?: InputMaybe<Array<SoftwareManagementSoftwareSetupFilterConditions>>;
};

export type SoftwareManagementSoftwareSetupFilterConditions = {
  id?: InputMaybe<IntegerFilter>;
};

export type SoftwareManagementValueObjectsSoftwarePaymentSourceTypeEnum =
  | 'banking_cardpayment'
  | 'finance_invoice';

/** The sorting field path and order */
export type Sort = {
  /** The column name to sort by in relation to the present table */
  field: Scalars['String'];
  /** Whether to sort nulls last */
  nullsLast?: InputMaybe<Scalars['Boolean']>;
  /** The order of sorting */
  order: Scalars['String'];
};

/** Space Control Bookings */
export type SpaceControlBooking = {
  __typename?: 'SpaceControlBooking';
  access?: Maybe<ApiCoreAccess>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  accessId: Scalars['Int'];
  capacity: Scalars['Int'];
  date: Scalars['ISO8601Date'];
  employee?: Maybe<EmployeesEmployee>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  employeeId?: Maybe<Scalars['Int']>;
  endsAt: Scalars['String'];
  id?: Maybe<Scalars['Int']>;
  startsAt: Scalars['String'];
  status: SpaceControlBookingBookingStatusEnum;
  workSpace?: Maybe<SpaceControlWorkSpace>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  workSpaceId: Scalars['Int'];
};


/** Space Control Bookings */
export type SpaceControlBookingAccessArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** Space Control Bookings */
export type SpaceControlBookingEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Space Control Bookings */
export type SpaceControlBookingWorkSpaceArgs = {
  endTime?: InputMaybe<Scalars['String']>;
  locationIds?: Array<Scalars['Int']>;
  startTime?: InputMaybe<Scalars['String']>;
  workAreaIds?: Array<Scalars['Int']>;
};

export type SpaceControlBookingBookingStatusEnum =
  | 'active'
  | 'cancelled';

/** The connection type for SpaceControlBooking. */
export type SpaceControlBookingConnection = {
  __typename?: 'SpaceControlBookingConnection';
  /** A list of edges. */
  edges: Array<SpaceControlBookingEdge>;
  /** A list of nodes. */
  nodes: Array<SpaceControlBooking>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** Space Control Booking contextless permissions */
export type SpaceControlBookingContextlessPermission = {
  __typename?: 'SpaceControlBookingContextlessPermission';
  cancelForEverybody: Scalars['Boolean'];
  cancelForSelf: Scalars['Boolean'];
  createEditForEverybody: Scalars['Boolean'];
  createEditForSelf: Scalars['Boolean'];
  id: Scalars['Int'];
  readForEveryone: Scalars['Boolean'];
  readForSelf: Scalars['Boolean'];
};

/** The connection type for SpaceControlBookingContextlessPermission. */
export type SpaceControlBookingContextlessPermissionConnection = {
  __typename?: 'SpaceControlBookingContextlessPermissionConnection';
  /** A list of edges. */
  edges: Array<SpaceControlBookingContextlessPermissionEdge>;
  /** A list of nodes. */
  nodes: Array<SpaceControlBookingContextlessPermission>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type SpaceControlBookingContextlessPermissionEdge = {
  __typename?: 'SpaceControlBookingContextlessPermissionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: SpaceControlBookingContextlessPermission;
};

/** An edge in a connection. */
export type SpaceControlBookingEdge = {
  __typename?: 'SpaceControlBookingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: SpaceControlBooking;
};

/** the filter for the bookings resource */
export type SpaceControlBookingFilter = {
  accessId?: InputMaybe<IntegerFilter>;
  date?: InputMaybe<DateFilter>;
  dateStartTime?: InputMaybe<DateTimeFilter>;
  employeeId?: InputMaybe<IntegerFilter>;
  locationId?: InputMaybe<IntegerFilter>;
  or?: InputMaybe<Array<SpaceControlBookingFilterConditions>>;
  spaceType?: InputMaybe<StringFilter>;
};

export type SpaceControlBookingFilterConditions = {
  accessId?: InputMaybe<IntegerFilter>;
  date?: InputMaybe<DateFilter>;
  dateStartTime?: InputMaybe<DateTimeFilter>;
  employeeId?: InputMaybe<IntegerFilter>;
  locationId?: InputMaybe<IntegerFilter>;
  spaceType?: InputMaybe<StringFilter>;
};

export type SpaceControlContextlessPolicies = {
  __typename?: 'SpaceControlContextlessPolicies';
  bookingCancelEverybody: ContextlessPolicyResolution;
  bookingCancelSelf: ContextlessPolicyResolution;
  bookingEditEverybody: ContextlessPolicyResolution;
  bookingEditSelf: ContextlessPolicyResolution;
  bookingSeeEverybody: ContextlessPolicyResolution;
  bookingSeeOwned: ContextlessPolicyResolution;
  sidebarSeeSpaceControlTopLevelItem: ContextlessPolicyResolution;
  workSpaceCreate: ContextlessPolicyResolution;
  workSpaceDelete: ContextlessPolicyResolution;
  workSpaceRead: ContextlessPolicyResolution;
  workSpaceUpdate: ContextlessPolicyResolution;
};

export type SpaceControlImage = {
  __typename?: 'SpaceControlImage';
  height?: Maybe<Scalars['Int']>;
  url?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
};

export type SpaceControlTimeRangeInput = {
  endAt: Scalars['String'];
  startAt: Scalars['String'];
};

/** Manage Area Maps in Factorial */
export type SpaceControlWorkAreaMap = {
  __typename?: 'SpaceControlWorkAreaMap';
  error?: Maybe<Scalars['Boolean']>;
  height: Scalars['Int'];
  /** Unique identifier of the work area map */
  id: Scalars['Int'];
  /** Image file for the work area map */
  image: SpaceControlImage;
  width: Scalars['Int'];
  workArea: LocationsWorkArea;
  /**
   * ID of the work area to associate with the map
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  workAreaId: Scalars['Int'];
  workAreaMapSpaceLocation: Array<SpaceControlWorkAreaMapSpaceLocation>;
  workAreaMapSpaceLocationConnection: SpaceControlWorkAreaMapSpaceLocationConnection;
};


/** Manage Area Maps in Factorial */
export type SpaceControlWorkAreaMapWorkAreaArgs = {
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  onlyNonArchived?: Scalars['Boolean'];
};


/** Manage Area Maps in Factorial */
export type SpaceControlWorkAreaMapWorkAreaMapSpaceLocationArgs = {
  ids?: Array<Scalars['Int']>;
  workSpaceIds?: Array<Scalars['Int']>;
};


/** Manage Area Maps in Factorial */
export type SpaceControlWorkAreaMapWorkAreaMapSpaceLocationConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: Array<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  workSpaceIds?: Array<Scalars['Int']>;
};

/** The connection type for SpaceControlWorkAreaMap. */
export type SpaceControlWorkAreaMapConnection = {
  __typename?: 'SpaceControlWorkAreaMapConnection';
  /** A list of edges. */
  edges: Array<SpaceControlWorkAreaMapEdge>;
  /** A list of nodes. */
  nodes: Array<SpaceControlWorkAreaMap>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type SpaceControlWorkAreaMapEdge = {
  __typename?: 'SpaceControlWorkAreaMapEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: SpaceControlWorkAreaMap;
};

/** Manage Area Map Space Locations in Factorial */
export type SpaceControlWorkAreaMapSpaceLocation = {
  __typename?: 'SpaceControlWorkAreaMapSpaceLocation';
  error?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  workAreaMap: SpaceControlWorkAreaMap;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  workAreaMapId: Scalars['Int'];
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  workSpaceId: Scalars['Int'];
  workSpaceWithBooking?: Maybe<SpaceControlWorkSpaceWithBooking>;
  x: Scalars['Float'];
  y: Scalars['Float'];
};


/** Manage Area Map Space Locations in Factorial */
export type SpaceControlWorkAreaMapSpaceLocationWorkAreaMapArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  workAreaIds?: Array<Scalars['Int']>;
};


/** Manage Area Map Space Locations in Factorial */
export type SpaceControlWorkAreaMapSpaceLocationWorkSpaceWithBookingArgs = {
  date: Scalars['ISO8601Date'];
  endTime?: InputMaybe<Scalars['String']>;
  locationIds?: Array<Scalars['Int']>;
  startTime?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<SpaceControlWorkSpaceWorkSpaceTypeEnum>;
  workAreaIds?: Array<Scalars['Int']>;
};

/** The connection type for SpaceControlWorkAreaMapSpaceLocation. */
export type SpaceControlWorkAreaMapSpaceLocationConnection = {
  __typename?: 'SpaceControlWorkAreaMapSpaceLocationConnection';
  /** A list of edges. */
  edges: Array<SpaceControlWorkAreaMapSpaceLocationEdge>;
  /** A list of nodes. */
  nodes: Array<SpaceControlWorkAreaMapSpaceLocation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type SpaceControlWorkAreaMapSpaceLocationEdge = {
  __typename?: 'SpaceControlWorkAreaMapSpaceLocationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: SpaceControlWorkAreaMapSpaceLocation;
};

/** Manage Space Control in Factorial */
export type SpaceControlWorkSpace = {
  __typename?: 'SpaceControlWorkSpace';
  allowMultipleBookings?: Maybe<Scalars['Boolean']>;
  bookings: Array<SpaceControlBooking>;
  bookingsConnection: SpaceControlBookingConnection;
  capacity?: Maybe<Scalars['Int']>;
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
  description?: Maybe<Scalars['String']>;
  endTime?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  images: Array<ApiCoreAttachment>;
  imagesConnection: ApiCoreAttachmentConnection;
  name?: Maybe<Scalars['String']>;
  slotDuration?: Maybe<Scalars['Int']>;
  slotSetup?: Maybe<Scalars['String']>;
  slotStructure?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
  workArea?: Maybe<LocationsWorkArea>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  workAreaId?: Maybe<Scalars['Int']>;
  workAreaMapSpaceLocation?: Maybe<SpaceControlWorkAreaMapSpaceLocation>;
  workSpaceTypeName?: Maybe<Scalars['String']>;
  workSpaceTypeValue?: Maybe<Scalars['String']>;
};


/** Manage Space Control in Factorial */
export type SpaceControlWorkSpaceBookingsArgs = {
  accessIds?: Array<Scalars['Int']>;
  date?: InputMaybe<Scalars['ISO8601Date']>;
  employeeIds?: Array<Scalars['Int']>;
  ids?: Array<Scalars['Int']>;
  timeRange?: InputMaybe<SpaceControlTimeRangeInput>;
};


/** Manage Space Control in Factorial */
export type SpaceControlWorkSpaceBookingsConnectionArgs = {
  accessIds?: Array<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['ISO8601Date']>;
  employeeIds?: Array<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: Array<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  timeRange?: InputMaybe<SpaceControlTimeRangeInput>;
};


/** Manage Space Control in Factorial */
export type SpaceControlWorkSpaceImagesArgs = {
  attachmentName?: InputMaybe<Scalars['String']>;
};


/** Manage Space Control in Factorial */
export type SpaceControlWorkSpaceImagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  attachmentName?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Manage Space Control in Factorial */
export type SpaceControlWorkSpaceWorkAreaArgs = {
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  onlyNonArchived?: Scalars['Boolean'];
};


/** Manage Space Control in Factorial */
export type SpaceControlWorkSpaceWorkAreaMapSpaceLocationArgs = {
  ids?: Array<Scalars['Int']>;
  workAreaMapIds?: Array<Scalars['Int']>;
};

/** The connection type for SpaceControlWorkSpace. */
export type SpaceControlWorkSpaceConnection = {
  __typename?: 'SpaceControlWorkSpaceConnection';
  /** A list of edges. */
  edges: Array<SpaceControlWorkSpaceEdge>;
  /** A list of nodes. */
  nodes: Array<SpaceControlWorkSpace>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type SpaceControlWorkSpaceEdge = {
  __typename?: 'SpaceControlWorkSpaceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: SpaceControlWorkSpace;
};

/** represents a work_space booking slot */
export type SpaceControlWorkSpaceSlot = {
  __typename?: 'SpaceControlWorkSpaceSlot';
  allowMultipleBookings?: Maybe<Scalars['Boolean']>;
  bookingIds: Array<Scalars['Int']>;
  currentCapacity: Scalars['Int'];
  endsAt: Scalars['String'];
  originalCapacity: Scalars['Int'];
  slotNumber: Scalars['Int'];
  startsAt: Scalars['String'];
  workSpaceId: Scalars['Int'];
};

/** The connection type for SpaceControlWorkSpaceSlot. */
export type SpaceControlWorkSpaceSlotConnection = {
  __typename?: 'SpaceControlWorkSpaceSlotConnection';
  /** A list of edges. */
  edges: Array<SpaceControlWorkSpaceSlotEdge>;
  /** A list of nodes. */
  nodes: Array<SpaceControlWorkSpaceSlot>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type SpaceControlWorkSpaceSlotEdge = {
  __typename?: 'SpaceControlWorkSpaceSlotEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: SpaceControlWorkSpaceSlot;
};

/** represents a work_space with bookings data */
export type SpaceControlWorkSpaceWithBooking = {
  __typename?: 'SpaceControlWorkSpaceWithBooking';
  id: Scalars['Int'];
  images: Array<ApiCoreAttachment>;
  imagesConnection: ApiCoreAttachmentConnection;
  isFull: Scalars['Boolean'];
  locationId: Scalars['Int'];
  locationName: Scalars['String'];
  mapSpaceLocation?: Maybe<SpaceControlWorkAreaMapSpaceLocation>;
  originalCapacity: Scalars['Int'];
  workArea?: Maybe<LocationsWorkArea>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  workAreaId: Scalars['Int'];
  workAreaName: Scalars['String'];
  workSpaceDescription: Scalars['String'];
  workSpaceEndsAt: Scalars['String'];
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  workSpaceId: Scalars['Int'];
  workSpaceName: Scalars['String'];
  workSpaceStartsAt: Scalars['String'];
  workSpaceTypeName: Scalars['String'];
  workSpaceTypeValue: Scalars['String'];
};


/** represents a work_space with bookings data */
export type SpaceControlWorkSpaceWithBookingImagesArgs = {
  attachmentName?: InputMaybe<Scalars['String']>;
};


/** represents a work_space with bookings data */
export type SpaceControlWorkSpaceWithBookingImagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  attachmentName?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** represents a work_space with bookings data */
export type SpaceControlWorkSpaceWithBookingMapSpaceLocationArgs = {
  ids?: Array<Scalars['Int']>;
  workAreaMapIds?: Array<Scalars['Int']>;
};


/** represents a work_space with bookings data */
export type SpaceControlWorkSpaceWithBookingWorkAreaArgs = {
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  onlyNonArchived?: Scalars['Boolean'];
};

/** The connection type for SpaceControlWorkSpaceWithBooking. */
export type SpaceControlWorkSpaceWithBookingConnection = {
  __typename?: 'SpaceControlWorkSpaceWithBookingConnection';
  /** A list of edges. */
  edges: Array<SpaceControlWorkSpaceWithBookingEdge>;
  /** A list of nodes. */
  nodes: Array<SpaceControlWorkSpaceWithBooking>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type SpaceControlWorkSpaceWithBookingEdge = {
  __typename?: 'SpaceControlWorkSpaceWithBookingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: SpaceControlWorkSpaceWithBooking;
};

/** the filter for the work_space_with_bookings resource */
export type SpaceControlWorkSpaceWithBookingFilter = {
  locationId?: InputMaybe<IntegerFilter>;
  locationName?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<SpaceControlWorkSpaceWithBookingFilterConditions>>;
  originalCapacity?: InputMaybe<IntegerFilter>;
  workAreaId?: InputMaybe<IntegerFilter>;
  workAreaName?: InputMaybe<StringFilter>;
  workSpaceEndsAt?: InputMaybe<StringFilter>;
  workSpaceId?: InputMaybe<IntegerFilter>;
  workSpaceName?: InputMaybe<StringFilter>;
  workSpaceStartsAt?: InputMaybe<StringFilter>;
  workSpaceTypeName?: InputMaybe<StringFilter>;
  workSpaceTypeValue?: InputMaybe<StringFilter>;
};

export type SpaceControlWorkSpaceWithBookingFilterConditions = {
  locationId?: InputMaybe<IntegerFilter>;
  locationName?: InputMaybe<StringFilter>;
  originalCapacity?: InputMaybe<IntegerFilter>;
  workAreaId?: InputMaybe<IntegerFilter>;
  workAreaName?: InputMaybe<StringFilter>;
  workSpaceEndsAt?: InputMaybe<StringFilter>;
  workSpaceId?: InputMaybe<IntegerFilter>;
  workSpaceName?: InputMaybe<StringFilter>;
  workSpaceStartsAt?: InputMaybe<StringFilter>;
  workSpaceTypeName?: InputMaybe<StringFilter>;
  workSpaceTypeValue?: InputMaybe<StringFilter>;
};

export type SpaceControlWorkSpaceWorkSpaceTypeEnum =
  | 'booth'
  | 'desk'
  | 'lunch'
  | 'meeting_room'
  | 'other'
  | 'parking';

/** Autogenerated return type of SpaceControl_work_area_map_space_location_update_subscription. */
export type SpaceControl_Work_Area_Map_Space_Location_Update_SubscriptionPayload = {
  __typename?: 'SpaceControl_work_area_map_space_location_update_subscriptionPayload';
  workAreaMapSpaceLocation?: Maybe<SpaceControlWorkAreaMapSpaceLocation>;
};

/** Autogenerated return type of SpaceControl_work_area_map_update_subscription. */
export type SpaceControl_Work_Area_Map_Update_SubscriptionPayload = {
  __typename?: 'SpaceControl_work_area_map_update_subscriptionPayload';
  workAreaMap?: Maybe<SpaceControlWorkAreaMap>;
};

/** Autogenerated return type of SpaceControl_work_space_update_subscription. */
export type SpaceControl_Work_Space_Update_SubscriptionPayload = {
  __typename?: 'SpaceControl_work_space_update_subscriptionPayload';
  workSpace?: Maybe<SpaceControlWorkSpace>;
};

/** Autogenerated return type of StartPerformanceReviewProcess. */
export type StartPerformanceReviewProcessPayload = {
  __typename?: 'StartPerformanceReviewProcessPayload';
  errors: Array<MutationError>;
  reviewProcess?: Maybe<PerformanceReviewProcess>;
};

/** Autogenerated return type of StartProcessesMaterializedProcess. */
export type StartProcessesMaterializedProcessPayload = {
  __typename?: 'StartProcessesMaterializedProcessPayload';
  errors: Array<MutationError>;
  materializedProcess?: Maybe<ProcessesMaterializedProcess>;
};

/** Autogenerated return type of StartProcessesResourceRelationship. */
export type StartProcessesResourceRelationshipPayload = {
  __typename?: 'StartProcessesResourceRelationshipPayload';
  errors: Array<MutationError>;
  resourceRelationship?: Maybe<ProcessesResourceRelationship>;
};

/** Autogenerated return type of StartProcessesStartStep. */
export type StartProcessesStartStepPayload = {
  __typename?: 'StartProcessesStartStepPayload';
  errors: Array<MutationError>;
  startStep?: Maybe<ProcessesStartStep>;
};

/** Autogenerated return type of StatusChangeIntegrationsSyncRun. */
export type StatusChangeIntegrationsSyncRunPayload = {
  __typename?: 'StatusChangeIntegrationsSyncRunPayload';
  errors: Array<MutationError>;
  syncRun?: Maybe<IntegrationsSyncRun>;
};

export type StopApprovalFlowApprovalsMaterializedApprovalsFlowEmailDetailBlocksInput = {
  key: Scalars['String'];
  keyLabel?: InputMaybe<Scalars['String']>;
  type: ApprovalsEntitiesEmailDetailBlockTypeEnum;
};

/** Autogenerated return type of StopApprovalFlowApprovalsMaterializedApprovalsFlow. */
export type StopApprovalFlowApprovalsMaterializedApprovalsFlowPayload = {
  __typename?: 'StopApprovalFlowApprovalsMaterializedApprovalsFlowPayload';
  errors: Array<MutationError>;
  materializedApprovalsFlow?: Maybe<ApprovalsMaterializedApprovalsFlow>;
};

/** Autogenerated return type of StopPerformanceReviewProcess. */
export type StopPerformanceReviewProcessPayload = {
  __typename?: 'StopPerformanceReviewProcessPayload';
  errors: Array<MutationError>;
  reviewProcess?: Maybe<PerformanceReviewProcess>;
};

export type StringEnum =
  | 'company_internal'
  | 'company_public'
  | 'employee_my_documents'
  | 'pending_to_assign'
  | 'pending_to_destroy';

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  eq?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gteq?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lteq?: InputMaybe<Scalars['String']>;
  notEq?: InputMaybe<Scalars['String']>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type StructuredError = {
  __typename?: 'StructuredError';
  field: Scalars['String'];
  messages: Array<Scalars['String']>;
};

/** Autogenerated return type of SubscriptionBillingCustomerPortal. */
export type SubscriptionBillingCustomerPortalPayload = {
  __typename?: 'SubscriptionBillingCustomerPortalPayload';
  customerPortal?: Maybe<BillingCustomerPortal>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of SuggestCompetenciesJobCatalogTreeSuggestion. */
export type SuggestCompetenciesJobCatalogTreeSuggestionPayload = {
  __typename?: 'SuggestCompetenciesJobCatalogTreeSuggestionPayload';
  errors: Array<MutationError>;
  jobCatalogTreeSuggestion?: Maybe<CompetenciesJobCatalogTreeSuggestion>;
};

export type SurveysContextlessPolicies = {
  __typename?: 'SurveysContextlessPolicies';
  createForms: ContextlessPolicyResolution;
  createSurveyTemplates: ContextlessPolicyResolution;
  sidebarSeeEngagementSurveysSubLevelItem: ContextlessPolicyResolution;
  sidebarSeeSmartSurveysSubLevelItem: ContextlessPolicyResolution;
  surveyCreateEverybody: ContextlessPolicyResolution;
  surveyCreateOwned: ContextlessPolicyResolution;
  surveyCreateReportees: ContextlessPolicyResolution;
  surveyCreateTeam: ContextlessPolicyResolution;
  surveysCreateSurvey: ContextlessPolicyResolution;
  v2ManageSurveys: ContextlessPolicyResolution;
};

/** Surveys editor */
export type SurveysEditor = {
  __typename?: 'SurveysEditor';
  companyId: Scalars['Int'];
  employee: EmployeesEmployeeName;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  employeeId: Scalars['Int'];
  id: Scalars['Int'];
  survey: SurveysSurvey;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  surveyId: Scalars['Int'];
};


/** Surveys editor */
export type SurveysEditorEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  afterEmployeeId?: InputMaybe<Scalars['Int']>;
  beforeEmployeeId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  reporteesOrLed?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyId?: InputMaybe<Scalars['Int']>;
  verb?: InputMaybe<Scalars['String']>;
  withActiveContract?: Scalars['Boolean'];
};


/** Surveys editor */
export type SurveysEditorSurveyArgs = {
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Array<FormsEnumsStatusEnum>>;
};

/** The connection type for SurveysEditor. */
export type SurveysEditorConnection = {
  __typename?: 'SurveysEditorConnection';
  /** A list of edges. */
  edges: Array<SurveysEditorEdge>;
  /** A list of nodes. */
  nodes: Array<SurveysEditor>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type SurveysEditorEdge = {
  __typename?: 'SurveysEditorEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: SurveysEditor;
};

export type SurveysEnumsRespondentStrategyEnum =
  | 'all_employees'
  | 'employees'
  | 'everyone'
  | 'legal_entities'
  | 'locations'
  | 'managers'
  | 'teams';

export type SurveysEnumsSurveyTypeEnum =
  | 'custom'
  | 'enps';

export type SurveysFormTypeEnum =
  | 'enps'
  | 'review'
  | 'survey';

/** Question Group to Answer Identifier */
export type SurveysQuestionGroupToAnswerIdentifier = {
  __typename?: 'SurveysQuestionGroupToAnswerIdentifier';
  formId: Scalars['Int'];
  formName: Scalars['String'];
  formType?: Maybe<SurveysFormTypeEnum>;
  id: Scalars['Int'];
  respondentAccessId?: Maybe<Scalars['Int']>;
};

/** The connection type for SurveysQuestionGroupToAnswerIdentifier. */
export type SurveysQuestionGroupToAnswerIdentifierConnection = {
  __typename?: 'SurveysQuestionGroupToAnswerIdentifierConnection';
  /** A list of edges. */
  edges: Array<SurveysQuestionGroupToAnswerIdentifierEdge>;
  /** A list of nodes. */
  nodes: Array<SurveysQuestionGroupToAnswerIdentifier>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type SurveysQuestionGroupToAnswerIdentifierEdge = {
  __typename?: 'SurveysQuestionGroupToAnswerIdentifierEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: SurveysQuestionGroupToAnswerIdentifier;
};

export type SurveysRespondentStrategy = {
  __typename?: 'SurveysRespondentStrategy';
  arguments?: Maybe<Array<Scalars['Int']>>;
  strategy: SurveysEnumsRespondentStrategyEnum;
};

export type SurveysRespondentStrategyInput = {
  arguments?: InputMaybe<Array<Scalars['Int']>>;
  strategy: SurveysEnumsRespondentStrategyEnum;
};

/** Surveys survey */
export type SurveysSurvey = {
  __typename?: 'SurveysSurvey';
  _policies?: Maybe<SurveysSurveyPolicies>;
  _policiesCollection?: Maybe<Array<PermissionsPolicyResolution>>;
  _policiesConnection: PermissionsPolicyResolutionConnection;
  author?: Maybe<ApiCoreAccess>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  authorId: Scalars['Int'];
  companyId: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  editorIds: Array<Scalars['Int']>;
  editors: Array<SurveysEditor>;
  editorsConnection: SurveysEditorConnection;
  form: FormsForm;
  id: Scalars['Int'];
  respondentStrategy: SurveysRespondentStrategy;
  restrictedViewersEnabled: Scalars['Boolean'];
  surveyType: SurveysEnumsSurveyTypeEnum;
  updatedAt: Scalars['ISO8601DateTime'];
};


/** Surveys survey */
export type SurveysSurvey_PoliciesCollectionArgs = {
  ids: Array<SurveysSurveyPoliciesEnum>;
};


/** Surveys survey */
export type SurveysSurvey_PoliciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Surveys survey */
export type SurveysSurveyAuthorArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** Surveys survey */
export type SurveysSurveyEditorsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Surveys survey */
export type SurveysSurveyEditorsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Surveys survey */
export type SurveysSurveyFormArgs = {
  formType?: InputMaybe<Array<Scalars['String']>>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyTemplates?: InputMaybe<Scalars['Boolean']>;
  resourceId?: InputMaybe<Scalars['String']>;
  respondentId?: InputMaybe<Scalars['String']>;
  returnAnswerProgress?: Scalars['Boolean'];
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

/** The connection type for SurveysSurvey. */
export type SurveysSurveyConnection = {
  __typename?: 'SurveysSurveyConnection';
  /** A list of edges. */
  edges: Array<SurveysSurveyEdge>;
  /** A list of nodes. */
  nodes: Array<SurveysSurvey>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type SurveysSurveyEdge = {
  __typename?: 'SurveysSurveyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: SurveysSurvey;
};

export type SurveysSurveyPolicies = {
  __typename?: 'SurveysSurveyPolicies';
  edit: PermissionsPolicyResolution;
};

export type SurveysSurveyPoliciesEnum =
  | 'edit';

/** Autogenerated return type of SwapPositionsAtsHiringStage. */
export type SwapPositionsAtsHiringStagePayload = {
  __typename?: 'SwapPositionsAtsHiringStagePayload';
  errors: Array<MutationError>;
  hiringStages?: Maybe<Array<AtsHiringStage>>;
};

/** Autogenerated return type of SyncBookkeepersmanagementIncidencePayrollIntegrationStatus. */
export type SyncBookkeepersmanagementIncidencePayrollIntegrationStatusPayload = {
  __typename?: 'SyncBookkeepersmanagementIncidencePayrollIntegrationStatusPayload';
  errors: Array<MutationError>;
  incidencePayrollIntegrationStatus?: Maybe<BookkeepersManagementIncidencePayrollIntegrationStatus>;
};

/** Autogenerated return type of SyncDocumentEsignatureSignature. */
export type SyncDocumentEsignatureSignaturePayload = {
  __typename?: 'SyncDocumentEsignatureSignaturePayload';
  errors: Array<MutationError>;
  signatures?: Maybe<Array<EsignatureSignature>>;
};

/** Autogenerated return type of SyncIncidencePayrollStatusesBookkeepersmanagementIncidencePayrollIntegrationStatus. */
export type SyncIncidencePayrollStatusesBookkeepersmanagementIncidencePayrollIntegrationStatusPayload = {
  __typename?: 'SyncIncidencePayrollStatusesBookkeepersmanagementIncidencePayrollIntegrationStatusPayload';
  errors: Array<MutationError>;
  incidencePayrollIntegrationStatus?: Maybe<BookkeepersManagementIncidencePayrollIntegrationStatus>;
};

/** Autogenerated return type of SyncIntegrationsindeedJobPosting. */
export type SyncIntegrationsindeedJobPostingPayload = {
  __typename?: 'SyncIntegrationsindeedJobPostingPayload';
  errors: Array<MutationError>;
  jobPosting?: Maybe<IntegrationsIndeedJobPosting>;
};

/** Autogenerated return type of SyncOnInstallIntegrationsindeedJobPosting. */
export type SyncOnInstallIntegrationsindeedJobPostingPayload = {
  __typename?: 'SyncOnInstallIntegrationsindeedJobPostingPayload';
  errors: Array<MutationError>;
  jobPosting?: Maybe<IntegrationsIndeedJobPosting>;
};

export type SyncRunOutputsParametersInput = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export type SyncRunsParametersInput = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export type SyncValidationsParametersInput = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export type Taskable = ApprovalsMaterializedApprovalStep | ApprovalsV2ReviewRequest | BookkeepersManagementIncidence | DocumentsDocument | EmployeesEmployeeName | EsignatureSignature | FormsMyMembership | PerformanceReviewEvaluationAnswer | PerformanceReviewProcessMaterializedTarget | ProcurementUploadDocumentTask | SurveysQuestionGroupToAnswerIdentifier | WorkflowsWorkflowHandlerExecution;

/** Counts for each task category */
export type TasksCategoryCount = {
  __typename?: 'TasksCategoryCount';
  category: TasksValueObjectsTaskCategoryEnum;
  count: Scalars['Int'];
  id: Scalars['Int'];
};

/** The connection type for TasksCategoryCount. */
export type TasksCategoryCountConnection = {
  __typename?: 'TasksCategoryCountConnection';
  /** A list of edges. */
  edges: Array<TasksCategoryCountEdge>;
  /** A list of nodes. */
  nodes: Array<TasksCategoryCount>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TasksCategoryCountEdge = {
  __typename?: 'TasksCategoryCountEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TasksCategoryCount;
};

export type TasksContextlessPolicies = {
  __typename?: 'TasksContextlessPolicies';
  showProjectsUpsellModal: ContextlessPolicyResolution;
  sidebarSeeTasksTopLevelItem: ContextlessPolicyResolution;
};

export type TasksDataCollectionTypeData = {
  __typename?: 'TasksDataCollectionTypeData';
  configurationFields: Scalars['String'];
  employeeId?: Maybe<Scalars['Int']>;
};

/** Grouped tasks */
export type TasksGroupedTask = {
  __typename?: 'TasksGroupedTask';
  authorId?: Maybe<Scalars['Int']>;
  category?: Maybe<TasksValueObjectsTaskCategoryEnum>;
  companyId: Scalars['Int'];
  completedAt?: Maybe<Scalars['ISO8601DateTime']>;
  completedByEmployeeId?: Maybe<Scalars['Int']>;
  completedById?: Maybe<Scalars['Int']>;
  content?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  dueOn?: Maybe<Scalars['ISO8601Date']>;
  groupableKey?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  kind?: Maybe<TasksValueObjectsTaskKindEnum>;
  name: Scalars['String'];
  resourceId?: Maybe<Scalars['Int']>;
  resourceType?: Maybe<Scalars['String']>;
  startsOn?: Maybe<Scalars['ISO8601Date']>;
  status?: Maybe<TasksValueObjectsTaskStatusEnum>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for TasksGroupedTask. */
export type TasksGroupedTaskConnection = {
  __typename?: 'TasksGroupedTaskConnection';
  /** A list of edges. */
  edges: Array<TasksGroupedTaskEdge>;
  /** A list of nodes. */
  nodes: Array<TasksGroupedTask>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TasksGroupedTaskEdge = {
  __typename?: 'TasksGroupedTaskEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TasksGroupedTask;
};

/** Inbox tasks */
export type TasksInboxTask = {
  __typename?: 'TasksInboxTask';
  affectees: Array<TasksTaskInvolvement>;
  affecteesConnection: TasksTaskInvolvementConnection;
  assignees: Array<TasksTaskInvolvement>;
  assigneesConnection: TasksTaskInvolvementConnection;
  attachments: Array<ApiCoreAttachment>;
  attachmentsConnection: ApiCoreAttachmentConnection;
  author?: Maybe<EmployeesEmployeeName>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  authorId?: Maybe<Scalars['Int']>;
  category?: Maybe<TasksValueObjectsTaskCategoryEnum>;
  companyId: Scalars['Int'];
  completedAt?: Maybe<Scalars['ISO8601DateTime']>;
  completedByEmployeeId?: Maybe<Scalars['Int']>;
  completedById?: Maybe<Scalars['Int']>;
  content?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  dueOn?: Maybe<Scalars['ISO8601Date']>;
  groupableKey?: Maybe<Scalars['String']>;
  groupedTasks: Array<TasksGroupedTask>;
  groupedTasksConnection: TasksGroupedTaskConnection;
  id: Scalars['Int'];
  kind?: Maybe<TasksValueObjectsTaskKindEnum>;
  name: Scalars['String'];
  resourceId?: Maybe<Scalars['Int']>;
  resourceType?: Maybe<Scalars['String']>;
  startsOn?: Maybe<Scalars['ISO8601Date']>;
  status?: Maybe<TasksValueObjectsTaskStatusEnum>;
  taskable?: Maybe<Taskable>;
  updatedAt: Scalars['ISO8601DateTime'];
};


/** Inbox tasks */
export type TasksInboxTaskAffecteesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Inbox tasks */
export type TasksInboxTaskAffecteesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Inbox tasks */
export type TasksInboxTaskAssigneesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Inbox tasks */
export type TasksInboxTaskAssigneesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Inbox tasks */
export type TasksInboxTaskAttachmentsArgs = {
  attachmentName?: InputMaybe<Scalars['String']>;
};


/** Inbox tasks */
export type TasksInboxTaskAttachmentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  attachmentName?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Inbox tasks */
export type TasksInboxTaskAuthorArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  afterEmployeeId?: InputMaybe<Scalars['Int']>;
  beforeEmployeeId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  reporteesOrLed?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyId?: InputMaybe<Scalars['Int']>;
  verb?: InputMaybe<Scalars['String']>;
  withActiveContract?: Scalars['Boolean'];
};


/** Inbox tasks */
export type TasksInboxTaskGroupedTasksArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  status?: InputMaybe<TasksValueObjectsTaskStatusEnum>;
  statuses?: InputMaybe<Array<TasksValueObjectsTaskStatusEnum>>;
};


/** Inbox tasks */
export type TasksInboxTaskGroupedTasksConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  status?: InputMaybe<TasksValueObjectsTaskStatusEnum>;
  statuses?: InputMaybe<Array<TasksValueObjectsTaskStatusEnum>>;
};

/** The connection type for TasksInboxTask. */
export type TasksInboxTaskConnection = {
  __typename?: 'TasksInboxTaskConnection';
  /** A list of edges. */
  edges: Array<TasksInboxTaskEdge>;
  /** A list of nodes. */
  nodes: Array<TasksInboxTask>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TasksInboxTaskEdge = {
  __typename?: 'TasksInboxTaskEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TasksInboxTask;
};

/** the filter for the inbox_tasks resource */
export type TasksInboxTaskFilter = {
  completedAt?: InputMaybe<DateTimeFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dueOn?: InputMaybe<DateFilter>;
  id?: InputMaybe<IntegerFilter>;
  kind?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<TasksInboxTaskFilterConditions>>;
  status?: InputMaybe<StringFilter>;
};

export type TasksInboxTaskFilterConditions = {
  completedAt?: InputMaybe<DateTimeFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dueOn?: InputMaybe<DateFilter>;
  id?: InputMaybe<IntegerFilter>;
  kind?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
};

/** Factorial task element */
export type TasksMaterializedProcessTask = {
  __typename?: 'TasksMaterializedProcessTask';
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  affecteeIds: Array<Scalars['Int']>;
  affectees: Array<TasksUnsafeAccess>;
  affecteesConnection: TasksUnsafeAccessConnection;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  assigneeIds: Array<Scalars['Int']>;
  assignees: Array<TasksUnsafeAccess>;
  assigneesConnection: TasksUnsafeAccessConnection;
  author?: Maybe<TasksUnsafeAccess>;
  completedAt?: Maybe<Scalars['ISO8601DateTime']>;
  completedBy?: Maybe<TasksUnsafeAccess>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  completedById?: Maybe<Scalars['Int']>;
  content?: Maybe<Scalars['String']>;
  contractEndDate?: Maybe<Scalars['ISO8601Date']>;
  contractReferenceDate?: Maybe<Scalars['ISO8601Date']>;
  contractStartDate?: Maybe<Scalars['ISO8601Date']>;
  createdAt: Scalars['ISO8601DateTime'];
  dueOn?: Maybe<Scalars['ISO8601Date']>;
  id: Scalars['Int'];
  materializedItemId?: Maybe<Scalars['Int']>;
  materializedProcessId?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  processId?: Maybe<Scalars['Int']>;
  stepName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};


/** Factorial task element */
export type TasksMaterializedProcessTaskAffecteesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Factorial task element */
export type TasksMaterializedProcessTaskAssigneesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for TasksMaterializedProcessTask. */
export type TasksMaterializedProcessTaskConnection = {
  __typename?: 'TasksMaterializedProcessTaskConnection';
  /** A list of edges. */
  edges: Array<TasksMaterializedProcessTaskEdge>;
  /** A list of nodes. */
  nodes: Array<TasksMaterializedProcessTask>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TasksMaterializedProcessTaskEdge = {
  __typename?: 'TasksMaterializedProcessTaskEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TasksMaterializedProcessTask;
};

/** the filter for the materialized_process_tasks resource */
export type TasksMaterializedProcessTaskFilter = {
  assignee?: InputMaybe<IntegerFilter>;
  content?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dueOn?: InputMaybe<DateFilter>;
  id?: InputMaybe<IntegerFilter>;
  name?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<TasksMaterializedProcessTaskFilterConditions>>;
  owner?: InputMaybe<IntegerFilter>;
  status?: InputMaybe<StringFilter>;
  stepName?: InputMaybe<StringFilter>;
};

export type TasksMaterializedProcessTaskFilterConditions = {
  assignee?: InputMaybe<IntegerFilter>;
  content?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dueOn?: InputMaybe<DateFilter>;
  id?: InputMaybe<IntegerFilter>;
  name?: InputMaybe<StringFilter>;
  owner?: InputMaybe<IntegerFilter>;
  status?: InputMaybe<StringFilter>;
  stepName?: InputMaybe<StringFilter>;
};

export type TasksSendDocumentTemplateTypeData = {
  __typename?: 'TasksSendDocumentTemplateTypeData';
  additionalSignerIds: Array<Scalars['Int']>;
  documentId: Scalars['Int'];
  employeeId: Scalars['Int'];
  folderId: Scalars['Int'];
  requestEsignature: Scalars['Boolean'];
};

/** Share a task */
export type TasksShareTask = {
  __typename?: 'TasksShareTask';
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  accessIds: Array<Scalars['Int']>;
  accesses: Array<TasksUnsafeAccess>;
  accessesConnection: TasksUnsafeAccessConnection;
  taskId: Scalars['Int'];
};


/** Share a task */
export type TasksShareTaskAccessesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for TasksShareTask. */
export type TasksShareTaskConnection = {
  __typename?: 'TasksShareTaskConnection';
  /** A list of edges. */
  edges: Array<TasksShareTaskEdge>;
  /** A list of nodes. */
  nodes: Array<TasksShareTask>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TasksShareTaskEdge = {
  __typename?: 'TasksShareTaskEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TasksShareTask;
};

export type TasksSignatureDocumentsTypeData = {
  __typename?: 'TasksSignatureDocumentsTypeData';
  additionalSignerIds: Array<Scalars['Int']>;
  documentIds: Array<Scalars['Int']>;
  employeeId: Scalars['Int'];
  folderId: Scalars['Int'];
  requestEsignature: Scalars['Boolean'];
};

/** Factorial task element */
export type TasksTask = {
  __typename?: 'TasksTask';
  _policies?: Maybe<TasksTaskPolicies>;
  _policiesCollection?: Maybe<Array<PermissionsPolicyResolution>>;
  _policiesConnection: PermissionsPolicyResolutionConnection;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  affecteeIds: Array<Scalars['Int']>;
  affectees: Array<TasksUnsafeAccess>;
  affecteesConnection: TasksUnsafeAccessConnection;
  /**
   * Employees assigned to the task, assignee_id references to access_id
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  assigneeIds: Array<Scalars['Int']>;
  assignees: Array<TasksUnsafeAccess>;
  assigneesConnection: TasksUnsafeAccessConnection;
  attachments: Array<ApiCoreAttachment>;
  attachmentsConnection: ApiCoreAttachmentConnection;
  author?: Maybe<TasksUnsafeAccess>;
  /** Employee id of the author of the task */
  authorEmployeeId?: Maybe<Scalars['Int']>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  authorId: Scalars['Int'];
  comments: Array<CommentsComment>;
  commentsConnection: CommentsCommentConnection;
  /** Company identifier of the author of the task */
  companyId: Scalars['Int'];
  /** Completed at date of the task */
  completedAt?: Maybe<Scalars['ISO8601DateTime']>;
  completedBy?: Maybe<TasksUnsafeAccess>;
  /**
   * Completed by identifier
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  completedById?: Maybe<Scalars['Int']>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  configurationId?: Maybe<Scalars['Int']>;
  /** Content of the task */
  content?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  dataCollection?: Maybe<TasksTypeDataCollection>;
  dataCollectionTypeData?: Maybe<TasksDataCollectionTypeData>;
  dataDocument?: Maybe<TasksTypeDataDocument>;
  /** Due on date of the task */
  dueOn?: Maybe<Scalars['ISO8601Date']>;
  /** Identifier of the task */
  id: Scalars['Int'];
  identifier: TasksValueObjectsTaskIdentifierEnum;
  /** Name of the task */
  name: Scalars['String'];
  projectTask?: Maybe<ProjectManagementProjectTask>;
  relatedResourceTitle?: Maybe<Scalars['String']>;
  sendDocumentTemplateTypeData?: Maybe<TasksSendDocumentTemplateTypeData>;
  signatureDocumentsTypeData?: Maybe<TasksSignatureDocumentsTypeData>;
  startsOn?: Maybe<Scalars['ISO8601Date']>;
  /** Status of the task */
  status?: Maybe<TasksValueObjectsTaskStatusEnum>;
  type: TasksTaskTypeEnum;
  /** Updated at date of the task */
  updatedAt: Scalars['ISO8601DateTime'];
  uploadDocumentTypeData?: Maybe<TasksUploadDocumentTypeData>;
};


/** Factorial task element */
export type TasksTask_PoliciesCollectionArgs = {
  ids: Array<TasksTaskPoliciesEnum>;
};


/** Factorial task element */
export type TasksTask_PoliciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Factorial task element */
export type TasksTaskAffecteesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Factorial task element */
export type TasksTaskAssigneesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Factorial task element */
export type TasksTaskAttachmentsArgs = {
  attachmentName?: InputMaybe<Scalars['String']>;
};


/** Factorial task element */
export type TasksTaskAttachmentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  attachmentName?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Factorial task element */
export type TasksTaskCommentsArgs = {
  companyId: Scalars['Int'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  upToAndIncluding?: InputMaybe<Scalars['Int']>;
};


/** Factorial task element */
export type TasksTaskCommentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  upToAndIncluding?: InputMaybe<Scalars['Int']>;
};


/** Factorial task element */
export type TasksTaskProjectTaskArgs = {
  clientIds?: InputMaybe<Array<Scalars['Int']>>;
  completed?: InputMaybe<Scalars['Boolean']>;
  dueStatus?: InputMaybe<TasksValueObjectsTaskDueStatusEnum>;
  employeeId?: InputMaybe<Scalars['Int']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  incompleted?: InputMaybe<Scalars['Boolean']>;
  overdue?: InputMaybe<Scalars['Boolean']>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  subprojectIds?: InputMaybe<Array<Scalars['Int']>>;
};

/** The connection type for TasksTask. */
export type TasksTaskConnection = {
  __typename?: 'TasksTaskConnection';
  /** A list of edges. */
  edges: Array<TasksTaskEdge>;
  /** A list of nodes. */
  nodes: Array<TasksTask>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TasksTaskEdge = {
  __typename?: 'TasksTaskEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TasksTask;
};

/** Tasks task file */
export type TasksTaskFile = {
  __typename?: 'TasksTaskFile';
  /** content type of the file. */
  contentType?: Maybe<Scalars['String']>;
  /** creation date of the file. */
  createdAt: Scalars['ISO8601DateTime'];
  /** name of the file. */
  filename: Scalars['String'];
  /** identifier of the file. */
  id: Scalars['Int'];
  /** path of the file, for downloading the file you need to concat api_url/path. */
  path: Scalars['String'];
  /** identifier of the task. */
  taskId: Scalars['Int'];
};

/** The connection type for TasksTaskFile. */
export type TasksTaskFileConnection = {
  __typename?: 'TasksTaskFileConnection';
  /** A list of edges. */
  edges: Array<TasksTaskFileEdge>;
  /** A list of nodes. */
  nodes: Array<TasksTaskFile>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TasksTaskFileEdge = {
  __typename?: 'TasksTaskFileEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TasksTaskFile;
};

/** the filter for the tasks resource */
export type TasksTaskFilter = {
  assigneeIds?: InputMaybe<IntegerFilter>;
  category?: InputMaybe<StringFilter>;
  content?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dueOn?: InputMaybe<DateFilter>;
  id?: InputMaybe<IntegerFilter>;
  identifier?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<TasksTaskFilterConditions>>;
  status?: InputMaybe<StringFilter>;
};

export type TasksTaskFilterConditions = {
  assigneeIds?: InputMaybe<IntegerFilter>;
  category?: InputMaybe<StringFilter>;
  content?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dueOn?: InputMaybe<DateFilter>;
  id?: InputMaybe<IntegerFilter>;
  identifier?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
};

/** Task involvements */
export type TasksTaskInvolvement = {
  __typename?: 'TasksTaskInvolvement';
  employee?: Maybe<EmployeesEmployeeName>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  employeeId: Scalars['Int'];
  id: Scalars['Int'];
  task?: Maybe<TasksTask>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  taskId: Scalars['Int'];
};


/** Task involvements */
export type TasksTaskInvolvementEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  afterEmployeeId?: InputMaybe<Scalars['Int']>;
  beforeEmployeeId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  reporteesOrLed?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyId?: InputMaybe<Scalars['Int']>;
  verb?: InputMaybe<Scalars['String']>;
  withActiveContract?: Scalars['Boolean'];
};


/** Task involvements */
export type TasksTaskInvolvementTaskArgs = {
  alreadyDue?: InputMaybe<Scalars['Boolean']>;
  assigneeId?: InputMaybe<Scalars['Int']>;
  assigneeRole?: InputMaybe<TasksValueObjectsTaskInvolvementRolesEnum>;
  authorId?: InputMaybe<Scalars['Int']>;
  category?: InputMaybe<TasksValueObjectsTaskCategoryEnum>;
  companyId?: InputMaybe<Scalars['Int']>;
  documentId?: InputMaybe<Scalars['Int']>;
  dueOn?: InputMaybe<Scalars['ISO8601Date']>;
  identifier?: InputMaybe<TasksValueObjectsTaskIdentifierEnum>;
  involveeId?: InputMaybe<Scalars['Int']>;
  mandatory?: InputMaybe<Scalars['Boolean']>;
  processId?: InputMaybe<Scalars['Int']>;
  processIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  startsOn?: InputMaybe<Scalars['ISO8601Date']>;
  status?: InputMaybe<TasksTaskStatusEnum>;
  taskStatus?: InputMaybe<TasksValueObjectsTaskStatusEnum>;
};

/** The connection type for TasksTaskInvolvement. */
export type TasksTaskInvolvementConnection = {
  __typename?: 'TasksTaskInvolvementConnection';
  /** A list of edges. */
  edges: Array<TasksTaskInvolvementEdge>;
  /** A list of nodes. */
  nodes: Array<TasksTaskInvolvement>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TasksTaskInvolvementEdge = {
  __typename?: 'TasksTaskInvolvementEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TasksTaskInvolvement;
};

export type TasksTaskPolicies = {
  __typename?: 'TasksTaskPolicies';
  copy: PermissionsPolicyResolution;
  destroy: PermissionsPolicyResolution;
  edit: PermissionsPolicyResolution;
  resolve: PermissionsPolicyResolution;
};

export type TasksTaskPoliciesEnum =
  | 'copy'
  | 'destroy'
  | 'edit'
  | 'resolve';

export type TasksTaskResume = {
  __typename?: 'TasksTaskResume';
  dueOn?: Maybe<Scalars['ISO8601Date']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  status?: Maybe<TasksValueObjectsTaskStatusEnum>;
};

export type TasksTaskStatusEnum =
  | 'all'
  | 'completed'
  | 'due_in_future'
  | 'due_today'
  | 'incompleted'
  | 'no_due'
  | 'over_due'
  | 'owned';

export type TasksTaskTypeEnum =
  | 'data_collection'
  | 'send_document_template'
  | 'sign_documents'
  | 'single_task'
  | 'upload_document';

/** Factorial task summary element for a given employee */
export type TasksTasksSummary = {
  __typename?: 'TasksTasksSummary';
  dueCount: Scalars['Int'];
  id: Scalars['Int'];
  lastTasks: Array<TasksTaskResume>;
  noDueCount: Scalars['Int'];
  overdueCount: Scalars['Int'];
};

/** The connection type for TasksTasksSummary. */
export type TasksTasksSummaryConnection = {
  __typename?: 'TasksTasksSummaryConnection';
  /** A list of edges. */
  edges: Array<TasksTasksSummaryEdge>;
  /** A list of nodes. */
  nodes: Array<TasksTasksSummary>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TasksTasksSummaryEdge = {
  __typename?: 'TasksTasksSummaryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TasksTasksSummary;
};

/** Counts for each task time period */
export type TasksTimeCount = {
  __typename?: 'TasksTimeCount';
  count: Scalars['Int'];
  id: Scalars['Int'];
  timePeriod: TasksValueObjectsTaskTaskTimePeriodEnum;
};

/** The connection type for TasksTimeCount. */
export type TasksTimeCountConnection = {
  __typename?: 'TasksTimeCountConnection';
  /** A list of edges. */
  edges: Array<TasksTimeCountEdge>;
  /** A list of nodes. */
  nodes: Array<TasksTimeCount>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TasksTimeCountEdge = {
  __typename?: 'TasksTimeCountEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TasksTimeCount;
};

/** Task type data collection */
export type TasksTypeDataCollection = {
  __typename?: 'TasksTypeDataCollection';
  employeeId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  resource: Scalars['String'];
  resources: Array<ProcessesTaskTypeConfigurationResource>;
  resourcesConnection: ProcessesTaskTypeConfigurationResourceConnection;
  task?: Maybe<TasksTask>;
};


/** Task type data collection */
export type TasksTypeDataCollectionResourcesArgs = {
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Task type data collection */
export type TasksTypeDataCollectionResourcesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Task type data collection */
export type TasksTypeDataCollectionTaskArgs = {
  alreadyDue?: InputMaybe<Scalars['Boolean']>;
  assigneeId?: InputMaybe<Scalars['Int']>;
  assigneeRole?: InputMaybe<TasksValueObjectsTaskInvolvementRolesEnum>;
  authorId?: InputMaybe<Scalars['Int']>;
  category?: InputMaybe<TasksValueObjectsTaskCategoryEnum>;
  companyId?: InputMaybe<Scalars['Int']>;
  documentId?: InputMaybe<Scalars['Int']>;
  dueOn?: InputMaybe<Scalars['ISO8601Date']>;
  identifier?: InputMaybe<TasksValueObjectsTaskIdentifierEnum>;
  involveeId?: InputMaybe<Scalars['Int']>;
  mandatory?: InputMaybe<Scalars['Boolean']>;
  processId?: InputMaybe<Scalars['Int']>;
  processIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  startsOn?: InputMaybe<Scalars['ISO8601Date']>;
  status?: InputMaybe<TasksTaskStatusEnum>;
  taskStatus?: InputMaybe<TasksValueObjectsTaskStatusEnum>;
};

/** Task type data document */
export type TasksTypeDataDocument = {
  __typename?: 'TasksTypeDataDocument';
  employeeId: Scalars['Int'];
  id: Scalars['Int'];
  requestEsignature?: Maybe<Scalars['Boolean']>;
  resources: Array<ProcessesTaskTypeConfigurationResource>;
  resourcesConnection: ProcessesTaskTypeConfigurationResourceConnection;
  task?: Maybe<TasksTask>;
};


/** Task type data document */
export type TasksTypeDataDocumentResourcesArgs = {
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Task type data document */
export type TasksTypeDataDocumentResourcesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Task type data document */
export type TasksTypeDataDocumentTaskArgs = {
  alreadyDue?: InputMaybe<Scalars['Boolean']>;
  assigneeId?: InputMaybe<Scalars['Int']>;
  assigneeRole?: InputMaybe<TasksValueObjectsTaskInvolvementRolesEnum>;
  authorId?: InputMaybe<Scalars['Int']>;
  category?: InputMaybe<TasksValueObjectsTaskCategoryEnum>;
  companyId?: InputMaybe<Scalars['Int']>;
  documentId?: InputMaybe<Scalars['Int']>;
  dueOn?: InputMaybe<Scalars['ISO8601Date']>;
  identifier?: InputMaybe<TasksValueObjectsTaskIdentifierEnum>;
  involveeId?: InputMaybe<Scalars['Int']>;
  mandatory?: InputMaybe<Scalars['Boolean']>;
  processId?: InputMaybe<Scalars['Int']>;
  processIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  startsOn?: InputMaybe<Scalars['ISO8601Date']>;
  status?: InputMaybe<TasksTaskStatusEnum>;
  taskStatus?: InputMaybe<TasksValueObjectsTaskStatusEnum>;
};

/** Temporary virtual resource to be able to access company-wide accesses by any employee */
export type TasksUnsafeAccess = {
  __typename?: 'TasksUnsafeAccess';
  avatar?: Maybe<Scalars['String']>;
  employee?: Maybe<EmployeesEmployee>;
  employeeName?: Maybe<EmployeesEmployeeName>;
  firstName: Scalars['String'];
  fullName: Scalars['String'];
  id: Scalars['Int'];
  lastName: Scalars['String'];
};


/** Temporary virtual resource to be able to access company-wide accesses by any employee */
export type TasksUnsafeAccessEmployeeArgs = {
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Temporary virtual resource to be able to access company-wide accesses by any employee */
export type TasksUnsafeAccessEmployeeNameArgs = {
  afterEmployeeId?: InputMaybe<Scalars['Int']>;
  beforeEmployeeId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  reporteesOrLed?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyId?: InputMaybe<Scalars['Int']>;
  verb?: InputMaybe<Scalars['String']>;
  withActiveContract?: Scalars['Boolean'];
};

/** The connection type for TasksUnsafeAccess. */
export type TasksUnsafeAccessConnection = {
  __typename?: 'TasksUnsafeAccessConnection';
  /** A list of edges. */
  edges: Array<TasksUnsafeAccessEdge>;
  /** A list of nodes. */
  nodes: Array<TasksUnsafeAccess>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TasksUnsafeAccessEdge = {
  __typename?: 'TasksUnsafeAccessEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TasksUnsafeAccess;
};

/** the filter for the unsafe_accesses resource */
export type TasksUnsafeAccessFilter = {
  avatar?: InputMaybe<StringFilter>;
  fullName?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntegerFilter>;
  or?: InputMaybe<Array<TasksUnsafeAccessFilterConditions>>;
};

export type TasksUnsafeAccessFilterConditions = {
  avatar?: InputMaybe<StringFilter>;
  fullName?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntegerFilter>;
};

/** Tasks upload document task file */
export type TasksUploadDocumentTaskFile = {
  __typename?: 'TasksUploadDocumentTaskFile';
  contentType?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  filename: Scalars['String'];
  id: Scalars['Int'];
  path: Scalars['String'];
  taskId: Scalars['Int'];
};

/** The connection type for TasksUploadDocumentTaskFile. */
export type TasksUploadDocumentTaskFileConnection = {
  __typename?: 'TasksUploadDocumentTaskFileConnection';
  /** A list of edges. */
  edges: Array<TasksUploadDocumentTaskFileEdge>;
  /** A list of nodes. */
  nodes: Array<TasksUploadDocumentTaskFile>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TasksUploadDocumentTaskFileEdge = {
  __typename?: 'TasksUploadDocumentTaskFileEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TasksUploadDocumentTaskFile;
};

export type TasksUploadDocumentTypeData = {
  __typename?: 'TasksUploadDocumentTypeData';
  employeeId: Scalars['Int'];
  folderId: Scalars['Int'];
  folderName?: Maybe<Scalars['String']>;
};

export type TasksValueObjectsTaskCategoryEnum =
  | 'benefits'
  | 'compensation'
  | 'complaints'
  | 'documents'
  | 'engagement'
  | 'finance'
  | 'organization'
  | 'performance'
  | 'recruitment'
  | 'software'
  | 'spending'
  | 'surveys'
  | 'time_planning'
  | 'time_tracking'
  | 'timeoff'
  | 'training';

export type TasksValueObjectsTaskDueStatusEnum =
  | 'due_in_future'
  | 'due_today'
  | 'no_due'
  | 'over_due';

export type TasksValueObjectsTaskIdentifierEnum =
  | 'inbox'
  | 'project'
  | 'shared_and_single'
  | 'single'
  | 'workflow';

export type TasksValueObjectsTaskInvolvementRolesEnum =
  | 'affectee'
  | 'assignee';

export type TasksValueObjectsTaskKindEnum =
  | 'approve'
  | 'complete'
  | 'fill'
  | 'import'
  | 'manual'
  | 'send'
  | 'sign'
  | 'terminate'
  | 'upload';

export type TasksValueObjectsTaskSortColumnEnum =
  | 'created_at'
  | 'due_on';

export type TasksValueObjectsTaskSortDirectionEnum =
  | 'asc'
  | 'desc';

export type TasksValueObjectsTaskStatusEnum =
  | 'discarded'
  | 'done'
  | 'in_progress'
  | 'todo';

export type TasksValueObjectsTaskTaskTimePeriodEnum =
  | 'all'
  | 'completed'
  | 'due_soon'
  | 'due_today'
  | 'due_tomorrow'
  | 'due_upcoming'
  | 'last_month'
  | 'last_week'
  | 'overdue'
  | 'today';

export type TeamsContextlessPolicies = {
  __typename?: 'TeamsContextlessPolicies';
  companySeeTeams: ContextlessPolicyResolution;
  companySeeTeamsSection: ContextlessPolicyResolution;
  dashboardWidgetTeamsBelongToVisible: ContextlessPolicyResolution;
  dashboardWidgetTeamsDirectReportsVisible: ContextlessPolicyResolution;
  sidebarSeeCalendarTeamViewSubLevelItem: ContextlessPolicyResolution;
  sidebarSeeEmployeesTeamsSubLevelItem: ContextlessPolicyResolution;
  teamCreate: ContextlessPolicyResolution;
  teamManage: ContextlessPolicyResolution;
};

/** Teams historical team */
export type TeamsHistoricalTeam = {
  __typename?: 'TeamsHistoricalTeam';
  avatar?: Maybe<Scalars['String']>;
  companyId: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  employeeIds?: Maybe<Array<Scalars['Int']>>;
  id: Scalars['Int'];
  leadIds?: Maybe<Array<Scalars['Int']>>;
  name: Scalars['String'];
};

/** The connection type for TeamsHistoricalTeam. */
export type TeamsHistoricalTeamConnection = {
  __typename?: 'TeamsHistoricalTeamConnection';
  /** A list of edges. */
  edges: Array<TeamsHistoricalTeamEdge>;
  /** A list of nodes. */
  nodes: Array<TeamsHistoricalTeam>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TeamsHistoricalTeamEdge = {
  __typename?: 'TeamsHistoricalTeamEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TeamsHistoricalTeam;
};

/** Teams memberships */
export type TeamsMembership = {
  __typename?: 'TeamsMembership';
  /** Company ID of the membership */
  companyId?: Maybe<Scalars['Int']>;
  employee: EmployeesEmployee;
  /**
   * Employee ID of the membership
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  employeeId: Scalars['Int'];
  employeeName: EmployeesEmployeeName;
  /** Membership ID */
  id: Scalars['Int'];
  /** Whether the employee is a lead of the team or not */
  lead: Scalars['Boolean'];
  team?: Maybe<TeamsTeam>;
  /**
   * Team ID of the membership
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  teamId: Scalars['Int'];
};


/** Teams memberships */
export type TeamsMembershipEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Teams memberships */
export type TeamsMembershipEmployeeNameArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  afterEmployeeId?: InputMaybe<Scalars['Int']>;
  beforeEmployeeId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  reporteesOrLed?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyId?: InputMaybe<Scalars['Int']>;
  verb?: InputMaybe<Scalars['String']>;
  withActiveContract?: Scalars['Boolean'];
};


/** Teams memberships */
export type TeamsMembershipTeamArgs = {
  mainTeam?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  withMembers?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for TeamsMembership. */
export type TeamsMembershipConnection = {
  __typename?: 'TeamsMembershipConnection';
  /** A list of edges. */
  edges: Array<TeamsMembershipEdge>;
  /** A list of nodes. */
  nodes: Array<TeamsMembership>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TeamsMembershipEdge = {
  __typename?: 'TeamsMembershipEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TeamsMembership;
};

/** the filter for the memberships resource */
export type TeamsMembershipFilter = {
  id?: InputMaybe<IntegerFilter>;
  lead?: InputMaybe<BooleanFilter>;
  or?: InputMaybe<Array<TeamsMembershipFilterConditions>>;
};

export type TeamsMembershipFilterConditions = {
  id?: InputMaybe<IntegerFilter>;
  lead?: InputMaybe<BooleanFilter>;
};

/** Teams */
export type TeamsTeam = {
  __typename?: 'TeamsTeam';
  _policies?: Maybe<TeamsTeamPolicies>;
  _policiesCollection?: Maybe<Array<PermissionsPolicyResolution>>;
  _policiesConnection: PermissionsPolicyResolutionConnection;
  avatar?: Maybe<Scalars['String']>;
  companyId: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  employeeIds?: Maybe<Array<Scalars['Int']>>;
  employeeNames: Array<EmployeesEmployeeName>;
  employeeNamesConnection: EmployeesEmployeeNameConnection;
  id: Scalars['Int'];
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  leadIds?: Maybe<Array<Scalars['Int']>>;
  leads: Array<EmployeesEmployeeName>;
  leadsConnection: EmployeesEmployeeNameConnection;
  memberships: Array<TeamsMembership>;
  membershipsConnection: TeamsMembershipConnection;
  name: Scalars['String'];
};


/** Teams */
export type TeamsTeam_PoliciesCollectionArgs = {
  ids: Array<TeamsTeamPoliciesEnum>;
};


/** Teams */
export type TeamsTeam_PoliciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Teams */
export type TeamsTeamEmployeeNamesArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  afterEmployeeId?: InputMaybe<Scalars['Int']>;
  beforeEmployeeId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  reporteesOrLed?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyId?: InputMaybe<Scalars['Int']>;
  verb?: InputMaybe<Scalars['String']>;
  withActiveContract?: Scalars['Boolean'];
};


/** Teams */
export type TeamsTeamEmployeeNamesConnectionArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  after?: InputMaybe<Scalars['String']>;
  afterEmployeeId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  beforeEmployeeId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  reporteesOrLed?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyId?: InputMaybe<Scalars['Int']>;
  verb?: InputMaybe<Scalars['String']>;
  withActiveContract?: Scalars['Boolean'];
};


/** Teams */
export type TeamsTeamLeadsArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  afterEmployeeId?: InputMaybe<Scalars['Int']>;
  beforeEmployeeId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  reporteesOrLed?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyId?: InputMaybe<Scalars['Int']>;
  verb?: InputMaybe<Scalars['String']>;
  withActiveContract?: Scalars['Boolean'];
};


/** Teams */
export type TeamsTeamLeadsConnectionArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  after?: InputMaybe<Scalars['String']>;
  afterEmployeeId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  beforeEmployeeId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  reporteesOrLed?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyId?: InputMaybe<Scalars['Int']>;
  verb?: InputMaybe<Scalars['String']>;
  withActiveContract?: Scalars['Boolean'];
};


/** Teams */
export type TeamsTeamMembershipsArgs = {
  activeEmployees?: Scalars['Boolean'];
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  lead?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  sortByLeads?: InputMaybe<Scalars['Boolean']>;
};


/** Teams */
export type TeamsTeamMembershipsConnectionArgs = {
  activeEmployees?: Scalars['Boolean'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  lead?: InputMaybe<Scalars['Boolean']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortByLeads?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Sort>;
};

/** Team Chart */
export type TeamsTeamChart = {
  __typename?: 'TeamsTeamChart';
  companyId: Scalars['String'];
};

/** The connection type for TeamsTeam. */
export type TeamsTeamConnection = {
  __typename?: 'TeamsTeamConnection';
  /** A list of edges. */
  edges: Array<TeamsTeamEdge>;
  /** A list of nodes. */
  nodes: Array<TeamsTeam>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TeamsTeamEdge = {
  __typename?: 'TeamsTeamEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TeamsTeam;
};

export type TeamsTeamPolicies = {
  __typename?: 'TeamsTeamPolicies';
  manage: PermissionsPolicyResolution;
};

export type TeamsTeamPoliciesEnum =
  | 'manage';

/** Autogenerated return type of TerminateEmployeesEmployee. */
export type TerminateEmployeesEmployeePayload = {
  __typename?: 'TerminateEmployeesEmployeePayload';
  employee?: Maybe<EmployeesEmployee>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of TerminateEmployeesSoftwaremanagementEmployeeSoftwareMembership. */
export type TerminateEmployeesSoftwaremanagementEmployeeSoftwareMembershipPayload = {
  __typename?: 'TerminateEmployeesSoftwaremanagementEmployeeSoftwareMembershipPayload';
  employeeSoftwareMemberships?: Maybe<Array<SoftwareManagementEmployeeSoftwareMembership>>;
  errors: Array<MutationError>;
};

export type TimeBalanceAdditionalHoursDetails = {
  __typename?: 'TimeBalanceAdditionalHoursDetails';
  additionalHours: Scalars['String'];
  equivalentHours: Scalars['String'];
  estimatedHours: Scalars['String'];
  name: Scalars['String'];
  rawHours: Scalars['String'];
  trackedHours: Scalars['String'];
};

/** Agreement hours information */
export type TimeBalanceAgreementHour = {
  __typename?: 'TimeBalanceAgreementHour';
  date: Scalars['ISO8601Date'];
  employeeId: Scalars['Int'];
  leaveMinutes: Scalars['String'];
  minutes: Scalars['String'];
};

/** The connection type for TimeBalanceAgreementHour. */
export type TimeBalanceAgreementHourConnection = {
  __typename?: 'TimeBalanceAgreementHourConnection';
  /** A list of edges. */
  edges: Array<TimeBalanceAgreementHourEdge>;
  /** A list of nodes. */
  nodes: Array<TimeBalanceAgreementHour>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TimeBalanceAgreementHourEdge = {
  __typename?: 'TimeBalanceAgreementHourEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TimeBalanceAgreementHour;
};

export type TimeBalanceContextlessPolicies = {
  __typename?: 'TimeBalanceContextlessPolicies';
  accessSeeTimeBalanceExport: ContextlessPolicyResolution;
  exportSeeEverybody: ContextlessPolicyResolution;
};

/** Time conditions information */
export type TimeBalanceTimeCondition = {
  __typename?: 'TimeBalanceTimeCondition';
  duration: Scalars['Int'];
  id?: Maybe<Scalars['Int']>;
  legalEntityId?: Maybe<Scalars['Int']>;
  startOn: Scalars['Int'];
};

/** The connection type for TimeBalanceTimeCondition. */
export type TimeBalanceTimeConditionConnection = {
  __typename?: 'TimeBalanceTimeConditionConnection';
  /** A list of edges. */
  edges: Array<TimeBalanceTimeConditionEdge>;
  /** A list of nodes. */
  nodes: Array<TimeBalanceTimeCondition>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TimeBalanceTimeConditionEdge = {
  __typename?: 'TimeBalanceTimeConditionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TimeBalanceTimeCondition;
};

/** Time period information */
export type TimeBalanceTimePeriodDetail = {
  __typename?: 'TimeBalanceTimePeriodDetail';
  additionalHoursDetails: Array<TimeBalanceAdditionalHoursDetails>;
  additionalPlannedHours: Scalars['String'];
  bankHolidayHours: Scalars['String'];
  employee: EmployeesEmployee;
  employeeFullName: Scalars['String'];
  id: Scalars['Int'];
  overplannedHours: Scalars['String'];
  overplannedHoursWithoutAdditional: Scalars['String'];
  paidLeavesHours: Scalars['String'];
  plannedHours: Scalars['String'];
  recommendedHours: Scalars['String'];
  remainingHours: Scalars['String'];
  remainingHoursWithoutAdditional: Scalars['String'];
  standardPlannedHours: Scalars['String'];
  totalBalanceHours: Scalars['String'];
  totalBalanceHoursWithoutAdditional: Scalars['String'];
};


/** Time period information */
export type TimeBalanceTimePeriodDetailEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for TimeBalanceTimePeriodDetail. */
export type TimeBalanceTimePeriodDetailConnection = {
  __typename?: 'TimeBalanceTimePeriodDetailConnection';
  /** A list of edges. */
  edges: Array<TimeBalanceTimePeriodDetailEdge>;
  /** A list of nodes. */
  nodes: Array<TimeBalanceTimePeriodDetail>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TimeBalanceTimePeriodDetailEdge = {
  __typename?: 'TimeBalanceTimePeriodDetailEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TimeBalanceTimePeriodDetail;
};

/** Used to answer when an employee is not working but is meant to be */
export type TimeInsightsClockInStatus = {
  __typename?: 'TimeInsightsClockInStatus';
  actualClockIn?: Maybe<Scalars['ISO8601DateTime']>;
  employee?: Maybe<EmployeesEmployee>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  employeeId: Scalars['Int'];
  employeeTimezone: Scalars['String'];
  firstClockIn?: Maybe<Scalars['ISO8601DateTime']>;
  latenessInSeconds: Scalars['Float'];
  plannedClockIn?: Maybe<Scalars['ISO8601DateTime']>;
  plannedClockOut?: Maybe<Scalars['ISO8601DateTime']>;
  shift?: Maybe<AttendanceShift>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  shiftId?: Maybe<Scalars['Int']>;
  status?: Maybe<TimeInsightsEntitiesClockInStatusStatusEnum>;
  userId?: Maybe<Scalars['Int']>;
};


/** Used to answer when an employee is not working but is meant to be */
export type TimeInsightsClockInStatusEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Used to answer when an employee is not working but is meant to be */
export type TimeInsightsClockInStatusShiftArgs = {
  breaksWithTimeConfiguration?: InputMaybe<Scalars['Boolean']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endOn?: InputMaybe<Scalars['ISO8601Date']>;
  halfDay?: Scalars['Boolean'];
  lastWorkingShift?: InputMaybe<Scalars['Boolean']>;
  latestShift?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortCreatedAtAsc?: Scalars['Boolean'];
  startOn?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAt?: InputMaybe<Scalars['ISO8601Date']>;
  workable?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for TimeInsightsClockInStatus. */
export type TimeInsightsClockInStatusConnection = {
  __typename?: 'TimeInsightsClockInStatusConnection';
  /** A list of edges. */
  edges: Array<TimeInsightsClockInStatusEdge>;
  /** A list of nodes. */
  nodes: Array<TimeInsightsClockInStatus>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TimeInsightsClockInStatusEdge = {
  __typename?: 'TimeInsightsClockInStatusEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TimeInsightsClockInStatus;
};

export type TimeInsightsEntitiesClockInStatusStatusEnum =
  | 'clocked_in'
  | 'completed'
  | 'expected_to_work'
  | 'in_a_break'
  | 'invalid_status'
  | 'missing_clock_in'
  | 'should_not_be_working';

export type TimeInsightsEntitiesInconsistencyStateEnum =
  | 'ignored'
  | 'pending'
  | 'resolved';

/** Used to answer questions about time inconsistencies */
export type TimeInsightsInconsistency = {
  __typename?: 'TimeInsightsInconsistency';
  /** Time used when applying the shift action, if relevant (ISO 8601 time). */
  actionTime?: Maybe<Scalars['ISO8601DateTime']>;
  /** Identifier of the related attendance shift, if any. */
  attendanceShiftId?: Maybe<Scalars['Int']>;
  /** Date when the inconsistency happened (ISO 8601). */
  date: Scalars['ISO8601Date'];
  employee?: Maybe<EmployeesEmployee>;
  /**
   * Employee ID this inconsistency belongs to.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  employeeId: Scalars['Int'];
  error?: Maybe<Scalars['Boolean']>;
  /** Unique identifier of the inconsistency. */
  id: Scalars['Int'];
  /** Type of time inconsistency (missing_clock_in, missing_clock_out, insufficient_break_duration or missing_break_time). */
  inconsistencyType: TimeInsightsValueObjectsInconsistencyTypeEnum;
  /** Additional metadata with context about the inconsistency, such as affected breaks or time ranges. */
  metadata?: Maybe<TimeInsightsMetadataType>;
  /** Timestamp when the inconsistency was resolved, if any (ISO 8601). */
  resolvedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** ID of the user who resolved the inconsistency, if any. */
  resolvedBy?: Maybe<Scalars['Int']>;
  /** Action to apply on the related shift to fix the inconsistency (for example create_shift or delete_shift). */
  shiftAction?: Maybe<AttendanceShiftIncidenceShiftActionEnum>;
  /** Current state of the inconsistency (pending, resolved or ignored). */
  state: TimeInsightsEntitiesInconsistencyStateEnum;
  /** Time difference in minutes between expected and actual time that triggered the inconsistency. */
  timeDiff?: Maybe<Scalars['String']>;
};


/** Used to answer questions about time inconsistencies */
export type TimeInsightsInconsistencyEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for TimeInsightsInconsistency. */
export type TimeInsightsInconsistencyConnection = {
  __typename?: 'TimeInsightsInconsistencyConnection';
  /** A list of edges. */
  edges: Array<TimeInsightsInconsistencyEdge>;
  /** A list of nodes. */
  nodes: Array<TimeInsightsInconsistency>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TimeInsightsInconsistencyEdge = {
  __typename?: 'TimeInsightsInconsistencyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TimeInsightsInconsistency;
};

export type TimeInsightsMetadataType = {
  __typename?: 'TimeInsightsMetadataType';
  minimalWorkedMinutes?: Maybe<Scalars['Int']>;
  requiredBreakMinutes?: Maybe<Scalars['Int']>;
};

/** Used to fetch which employees are clocked in or on break */
export type TimeInsightsPresence = {
  __typename?: 'TimeInsightsPresence';
  clockIn?: Maybe<Scalars['ISO8601DateTime']>;
  clockedIn: Scalars['Boolean'];
  date: Scalars['ISO8601Date'];
  employeeId: Scalars['Int'];
  onBreak: Scalars['Boolean'];
  shiftId?: Maybe<Scalars['Int']>;
};

/** The connection type for TimeInsightsPresence. */
export type TimeInsightsPresenceConnection = {
  __typename?: 'TimeInsightsPresenceConnection';
  /** A list of edges. */
  edges: Array<TimeInsightsPresenceEdge>;
  /** A list of nodes. */
  nodes: Array<TimeInsightsPresence>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TimeInsightsPresenceEdge = {
  __typename?: 'TimeInsightsPresenceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TimeInsightsPresence;
};

export type TimeInsightsValueObjectsInconsistencyTypeEnum =
  | 'insufficient_break_duration'
  | 'missing_break_time'
  | 'missing_clock_in'
  | 'missing_clock_out';

/** Autogenerated return type of TimeInsights_inconsistency_create_subscription. */
export type TimeInsights_Inconsistency_Create_SubscriptionPayload = {
  __typename?: 'TimeInsights_inconsistency_create_subscriptionPayload';
  inconsistency?: Maybe<TimeInsightsInconsistency>;
};

/** Time planning balances of the given employees in a date range */
export type TimePlanningBalance = {
  __typename?: 'TimePlanningBalance';
  /** Bank holiday hours balance */
  bankHolidayHours?: Maybe<Scalars['Float']>;
  bankOfHours?: Maybe<Scalars['Float']>;
  /** Contract hours balance */
  contractHours?: Maybe<Scalars['Float']>;
  /** Employee identifier */
  employeeId: Scalars['Int'];
  /** Leave hours balance */
  leaveHours?: Maybe<Scalars['Float']>;
  /** Shift hours balance */
  shiftHours?: Maybe<Scalars['Float']>;
};

/** The connection type for TimePlanningBalance. */
export type TimePlanningBalanceConnection = {
  __typename?: 'TimePlanningBalanceConnection';
  /** A list of edges. */
  edges: Array<TimePlanningBalanceEdge>;
  /** A list of nodes. */
  nodes: Array<TimePlanningBalance>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TimePlanningBalanceEdge = {
  __typename?: 'TimePlanningBalanceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TimePlanningBalance;
};

/** Balances for a list of employees by periods */
export type TimePlanningBalancesByPeriod = {
  __typename?: 'TimePlanningBalancesByPeriod';
  /** Total bank holiday hours balance for this period */
  bankHolidayHours?: Maybe<Scalars['Float']>;
  /** Total contract hours balance for this period */
  contractHours?: Maybe<Scalars['Float']>;
  /** Identifier of the employee these balances belong to */
  employeeId: Scalars['Int'];
  /** End date of the period for balance calculation */
  endAt: Scalars['String'];
  /** Total leave hours balance for this period */
  leaveHours?: Maybe<Scalars['Float']>;
  /** Total shift hours balance for this period */
  shiftHours?: Maybe<Scalars['Float']>;
  /** Start date of the period for balance calculation */
  startAt: Scalars['String'];
};

/** The connection type for TimePlanningBalancesByPeriod. */
export type TimePlanningBalancesByPeriodConnection = {
  __typename?: 'TimePlanningBalancesByPeriodConnection';
  /** A list of edges. */
  edges: Array<TimePlanningBalancesByPeriodEdge>;
  /** A list of nodes. */
  nodes: Array<TimePlanningBalancesByPeriod>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TimePlanningBalancesByPeriodEdge = {
  __typename?: 'TimePlanningBalancesByPeriodEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TimePlanningBalancesByPeriod;
};

export type TimePlanningContextlessPolicies = {
  __typename?: 'TimePlanningContextlessPolicies';
  planningVersionCreateEverybody: ContextlessPolicyResolution;
  planningVersionCreateOwned: ContextlessPolicyResolution;
  planningVersionCreateReportees: ContextlessPolicyResolution;
  planningVersionCreateTeam: ContextlessPolicyResolution;
  planningVersionSeeOwned: ContextlessPolicyResolution;
};

/** Represents the estimated time for an employee on a given date range. */
export type TimePlanningEmployeeDateRangeEstimatedTime = {
  __typename?: 'TimePlanningEmployeeDateRangeEstimatedTime';
  additionalHoursDetails: Array<TimeBalanceAdditionalHoursDetails>;
  effectiveEstimatedMinutes: Scalars['Int'];
  employeeId: Scalars['Int'];
  estimatedExpectedMinutes: Scalars['Int'];
  estimatedMinutes: Scalars['Int'];
  estimatedMinutesUntilToday: Scalars['Int'];
  estimatedOvertimeMinutes: Scalars['Int'];
  estimatedRegularMinutes: Scalars['Int'];
  paidBreaksMinutes: Scalars['Int'];
};

/** The connection type for TimePlanningEmployeeDateRangeEstimatedTime. */
export type TimePlanningEmployeeDateRangeEstimatedTimeConnection = {
  __typename?: 'TimePlanningEmployeeDateRangeEstimatedTimeConnection';
  /** A list of edges. */
  edges: Array<TimePlanningEmployeeDateRangeEstimatedTimeEdge>;
  /** A list of nodes. */
  nodes: Array<TimePlanningEmployeeDateRangeEstimatedTime>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TimePlanningEmployeeDateRangeEstimatedTimeEdge = {
  __typename?: 'TimePlanningEmployeeDateRangeEstimatedTimeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TimePlanningEmployeeDateRangeEstimatedTime;
};

/** Time planning employees permission */
export type TimePlanningEmployeePermission = {
  __typename?: 'TimePlanningEmployeePermission';
  access?: Maybe<ApiCoreAccess>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  accessId?: Maybe<Scalars['Int']>;
  employee?: Maybe<EmployeesEmployeeName>;
  id: Scalars['Int'];
  permissions: TimePlanningPermissions;
};


/** Time planning employees permission */
export type TimePlanningEmployeePermissionAccessArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** Time planning employees permission */
export type TimePlanningEmployeePermissionEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  afterEmployeeId?: InputMaybe<Scalars['Int']>;
  beforeEmployeeId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  reporteesOrLed?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyId?: InputMaybe<Scalars['Int']>;
  verb?: InputMaybe<Scalars['String']>;
  withActiveContract?: Scalars['Boolean'];
};

/** The connection type for TimePlanningEmployeePermission. */
export type TimePlanningEmployeePermissionConnection = {
  __typename?: 'TimePlanningEmployeePermissionConnection';
  /** A list of edges. */
  edges: Array<TimePlanningEmployeePermissionEdge>;
  /** A list of nodes. */
  nodes: Array<TimePlanningEmployeePermission>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TimePlanningEmployeePermissionEdge = {
  __typename?: 'TimePlanningEmployeePermissionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TimePlanningEmployeePermission;
};

/** Time planning employees permission for shifts (checks both TimePlanningSeePlanningVersions and SeeShifts verbs) */
export type TimePlanningEmployeePermissionsForShift = {
  __typename?: 'TimePlanningEmployeePermissionsForShift';
  access?: Maybe<ApiCoreAccess>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  accessId?: Maybe<Scalars['Int']>;
  employee?: Maybe<EmployeesEmployeeName>;
  id: Scalars['Int'];
  permissions: TimePlanningPermissions;
};


/** Time planning employees permission for shifts (checks both TimePlanningSeePlanningVersions and SeeShifts verbs) */
export type TimePlanningEmployeePermissionsForShiftAccessArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** Time planning employees permission for shifts (checks both TimePlanningSeePlanningVersions and SeeShifts verbs) */
export type TimePlanningEmployeePermissionsForShiftEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  afterEmployeeId?: InputMaybe<Scalars['Int']>;
  beforeEmployeeId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  reporteesOrLed?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyId?: InputMaybe<Scalars['Int']>;
  verb?: InputMaybe<Scalars['String']>;
  withActiveContract?: Scalars['Boolean'];
};

/** The connection type for TimePlanningEmployeePermissionsForShift. */
export type TimePlanningEmployeePermissionsForShiftConnection = {
  __typename?: 'TimePlanningEmployeePermissionsForShiftConnection';
  /** A list of edges. */
  edges: Array<TimePlanningEmployeePermissionsForShiftEdge>;
  /** A list of nodes. */
  nodes: Array<TimePlanningEmployeePermissionsForShift>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TimePlanningEmployeePermissionsForShiftEdge = {
  __typename?: 'TimePlanningEmployeePermissionsForShiftEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TimePlanningEmployeePermissionsForShift;
};

export type TimePlanningEnumsBalancesOnlyBalancesEnum =
  | 'all'
  | 'bank_holiday_hours'
  | 'bank_of_hours'
  | 'contract_hours'
  | 'leave_hours'
  | 'shift_hours';

export type TimePlanningEstimatedRestDay = {
  __typename?: 'TimePlanningEstimatedRestDay';
  date: Scalars['ISO8601DateTime'];
  id: Scalars['Int'];
  timezone?: Maybe<Scalars['String']>;
};

export type TimePlanningEstimatedShift = {
  __typename?: 'TimePlanningEstimatedShift';
  endAt: Scalars['ISO8601DateTime'];
  extraHours?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  locationId?: Maybe<Scalars['Int']>;
  startAt: Scalars['ISO8601DateTime'];
  timezone?: Maybe<Scalars['String']>;
};

/** Time planning estimated work day */
export type TimePlanningEstimatedWorkDay = {
  __typename?: 'TimePlanningEstimatedWorkDay';
  /** Work day date */
  date: Scalars['ISO8601Date'];
  /** Employee identifier */
  employeeId: Scalars['Int'];
  hoursInCents: Scalars['String'];
  plannedBreaks: Array<Scalars['String']>;
  /** Planning tool type */
  planningTool: TimePlanningPlanningToolEnum;
  restDays: Array<TimePlanningEstimatedRestDay>;
  shifts: Array<TimePlanningEstimatedShift>;
};

/** The connection type for TimePlanningEstimatedWorkDay. */
export type TimePlanningEstimatedWorkDayConnection = {
  __typename?: 'TimePlanningEstimatedWorkDayConnection';
  /** A list of edges. */
  edges: Array<TimePlanningEstimatedWorkDayEdge>;
  /** A list of nodes. */
  nodes: Array<TimePlanningEstimatedWorkDay>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TimePlanningEstimatedWorkDayEdge = {
  __typename?: 'TimePlanningEstimatedWorkDayEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TimePlanningEstimatedWorkDay;
};

export type TimePlanningPermissions = {
  __typename?: 'TimePlanningPermissions';
  canChangePlanningVersions: Scalars['Boolean'];
  canSeePlanningVersions: Scalars['Boolean'];
};

/** Planned breaks to define custom breaks in Time Planning */
export type TimePlanningPlannedBreak = {
  __typename?: 'TimePlanningPlannedBreak';
  breakConfiguration?: Maybe<TimeSettingsBreakConfiguration>;
  /**
   * Break configuration identifier
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  breakConfigurationId: Scalars['Int'];
  /** Name of the break configuration */
  breakConfigurationName: Scalars['String'];
  /** Whether the break is paid */
  breakConfigurationPaid: Scalars['Boolean'];
  /** Type of the break */
  breakType: TimePlanningPlannedBreakBreakTypeEnum;
  /** Day configuration identifier */
  dayConfigurationId?: Maybe<Scalars['Int']>;
  /** Default shift identifier */
  defaultShiftId?: Maybe<Scalars['Int']>;
  /** Duration of the break in minutes */
  duration?: Maybe<Scalars['Int']>;
  /** Break end time */
  endAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Planned break identifier */
  id: Scalars['Int'];
  /** Shift configuration identifier */
  shiftConfigurationId?: Maybe<Scalars['Int']>;
  /** Shift identifier */
  shiftId?: Maybe<Scalars['Int']>;
  /** Break start time */
  startAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Timezone of the break */
  timezone: Scalars['String'];
};


/** Planned breaks to define custom breaks in Time Planning */
export type TimePlanningPlannedBreakBreakConfigurationArgs = {
  active?: Scalars['Boolean'];
};

export type TimePlanningPlannedBreakBreakTypeEnum =
  | 'fixed'
  | 'flexible'
  | 'semi_flexible';

/** The connection type for TimePlanningPlannedBreak. */
export type TimePlanningPlannedBreakConnection = {
  __typename?: 'TimePlanningPlannedBreakConnection';
  /** A list of edges. */
  edges: Array<TimePlanningPlannedBreakEdge>;
  /** A list of nodes. */
  nodes: Array<TimePlanningPlannedBreak>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TimePlanningPlannedBreakEdge = {
  __typename?: 'TimePlanningPlannedBreakEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TimePlanningPlannedBreak;
};

export type TimePlanningPlanningToolEnum =
  | 'contract_hours'
  | 'shift_management'
  | 'work_schedule';

/**
 * Represents what time planning tool is used for a given employee on a given date.
 * Available options are shift management, work schedules and contract hours.
 */
export type TimePlanningPlanningVersion = {
  __typename?: 'TimePlanningPlanningVersion';
  /** Planning version start date */
  effectiveAt: Scalars['ISO8601Date'];
  employee: EmployeesEmployee;
  /**
   * Employee identifier
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  employeeId: Scalars['Int'];
  /** Planning version identifier */
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  /** Amount of rest days per week if applicable (in cents) */
  numberOfRestDaysInCents?: Maybe<Scalars['Int']>;
  /** Type of planning tool (shift_management, work_schedules, contract_hours) */
  planningTool: Scalars['String'];
  workSchedule?: Maybe<WorkScheduleSchedule>;
  /**
   * Work schedule identifier to include if applicable
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  workScheduleScheduleId?: Maybe<Scalars['Int']>;
};


/**
 * Represents what time planning tool is used for a given employee on a given date.
 * Available options are shift management, work schedules and contract hours.
 */
export type TimePlanningPlanningVersionEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Represents what time planning tool is used for a given employee on a given date.
 * Available options are shift management, work schedules and contract hours.
 */
export type TimePlanningPlanningVersionWorkScheduleArgs = {
  forSettings?: Scalars['Boolean'];
  onlyActive?: Scalars['Boolean'];
  onlyArchived?: Scalars['Boolean'];
  searchByName?: InputMaybe<Scalars['String']>;
  withEmployeeIds?: Scalars['Boolean'];
  withPeriods?: Scalars['Boolean'];
};

/** The connection type for TimePlanningPlanningVersion. */
export type TimePlanningPlanningVersionConnection = {
  __typename?: 'TimePlanningPlanningVersionConnection';
  /** A list of edges. */
  edges: Array<TimePlanningPlanningVersionEdge>;
  /** A list of nodes. */
  nodes: Array<TimePlanningPlanningVersion>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TimePlanningPlanningVersionEdge = {
  __typename?: 'TimePlanningPlanningVersionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TimePlanningPlanningVersion;
};

/** the filter for the planning_versions resource */
export type TimePlanningPlanningVersionFilter = {
  effectiveAt?: InputMaybe<DateFilter>;
  or?: InputMaybe<Array<TimePlanningPlanningVersionFilterConditions>>;
};

export type TimePlanningPlanningVersionFilterConditions = {
  effectiveAt?: InputMaybe<DateFilter>;
};

export type TimeRangeInput = {
  from: Scalars['ISO8601DateTime'];
  to: Scalars['ISO8601DateTime'];
};

/** Break Configurations to define the breaks settings */
export type TimeSettingsBreakConfiguration = {
  __typename?: 'TimeSettingsBreakConfiguration';
  archived: Scalars['Boolean'];
  attendanceBreakConfiguration: Array<AttendanceBreakConfiguration>;
  attendanceBreakConfigurationConnection: AttendanceBreakConfigurationConnection;
  id: Scalars['Int'];
  name: Scalars['String'];
  paid: Scalars['Boolean'];
};


/** Break Configurations to define the breaks settings */
export type TimeSettingsBreakConfigurationAttendanceBreakConfigurationArgs = {
  attendanceEmployeesSettingId?: InputMaybe<Scalars['Int']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Break Configurations to define the breaks settings */
export type TimeSettingsBreakConfigurationAttendanceBreakConfigurationConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  attendanceEmployeesSettingId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for TimeSettingsBreakConfiguration. */
export type TimeSettingsBreakConfigurationConnection = {
  __typename?: 'TimeSettingsBreakConfigurationConnection';
  /** A list of edges. */
  edges: Array<TimeSettingsBreakConfigurationEdge>;
  /** A list of nodes. */
  nodes: Array<TimeSettingsBreakConfiguration>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TimeSettingsBreakConfigurationEdge = {
  __typename?: 'TimeSettingsBreakConfigurationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TimeSettingsBreakConfiguration;
};

/** the filter for the break_configurations resource */
export type TimeSettingsBreakConfigurationFilter = {
  name?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<TimeSettingsBreakConfigurationFilterConditions>>;
  paid?: InputMaybe<BooleanFilter>;
};

export type TimeSettingsBreakConfigurationFilterConditions = {
  name?: InputMaybe<StringFilter>;
  paid?: InputMaybe<BooleanFilter>;
};

export type TimeSettingsContextlessPolicies = {
  __typename?: 'TimeSettingsContextlessPolicies';
  manageBreakConfigurations: ContextlessPolicyResolution;
  manageTimeRangeCategories: ContextlessPolicyResolution;
};

/** Resource to manage work time categories */
export type TimeSettingsCustomTimeRangeCategory = {
  __typename?: 'TimeSettingsCustomTimeRangeCategory';
  archived: Scalars['Boolean'];
  categoryType: TimeSettingsEnumsCategoryTypeEnum;
  companyId: Scalars['Int'];
  default: Scalars['Boolean'];
  id: Scalars['Int'];
  name: Scalars['String'];
  timeType: TimeSettingsEnumsTimeTypeEnum;
};

/** The connection type for TimeSettingsCustomTimeRangeCategory. */
export type TimeSettingsCustomTimeRangeCategoryConnection = {
  __typename?: 'TimeSettingsCustomTimeRangeCategoryConnection';
  /** A list of edges. */
  edges: Array<TimeSettingsCustomTimeRangeCategoryEdge>;
  /** A list of nodes. */
  nodes: Array<TimeSettingsCustomTimeRangeCategory>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TimeSettingsCustomTimeRangeCategoryEdge = {
  __typename?: 'TimeSettingsCustomTimeRangeCategoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TimeSettingsCustomTimeRangeCategory;
};

export type TimeSettingsEnumsCategoryTypeEnum =
  | 'extra_hour'
  | 'special_hour';

export type TimeSettingsEnumsTimeTypeEnum =
  | 'any_time'
  | 'overtime'
  | 'regular';

/** Resource to manage split work time categories */
export type TimeSettingsSplitCustomTimeRangeCategory = {
  __typename?: 'TimeSettingsSplitCustomTimeRangeCategory';
  companyId: Scalars['Int'];
  customTimeRangeCategoryId: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['String'];
  timeType: TimeSettingsEnumsTimeTypeEnum;
};

/** The connection type for TimeSettingsSplitCustomTimeRangeCategory. */
export type TimeSettingsSplitCustomTimeRangeCategoryConnection = {
  __typename?: 'TimeSettingsSplitCustomTimeRangeCategoryConnection';
  /** A list of edges. */
  edges: Array<TimeSettingsSplitCustomTimeRangeCategoryEdge>;
  /** A list of nodes. */
  nodes: Array<TimeSettingsSplitCustomTimeRangeCategory>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TimeSettingsSplitCustomTimeRangeCategoryEdge = {
  __typename?: 'TimeSettingsSplitCustomTimeRangeCategoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TimeSettingsSplitCustomTimeRangeCategory;
};

/** An Allowance represents how a Time off counter accrues and deducts days. */
export type TimeoffAllowance = {
  __typename?: 'TimeoffAllowance';
  /** Only for Allowances based on worked time. It represents how many units you need to work to be granted allowance units */
  accruedDenominatorInCents?: Maybe<Scalars['Int']>;
  /** Only for Allowances based on worked time. It represents how many units you are given per unit of time worked */
  accruedFactorInCents?: Maybe<Scalars['Int']>;
  /** When can the acrrued units be spent. */
  accruedUnitsAvailability?: Maybe<TimeoffAllowancesAccruedUnitsAvailabilityEnum>;
  allowanceIncidences: Array<TimeoffAllowanceIncidence>;
  allowanceIncidencesConnection: TimeoffAllowanceIncidenceConnection;
  /** Sets the allowance units. Can be "days" or "hours" */
  allowanceType: TimeoffAllowanceAllowanceTypeEnum;
  /**
   * Indicates how the allowance units are accrued. For example all_days means all
   * allowance days are given on the first day of the cycle.
   */
  availableDays: TimeoffAllowancesAvailableDaysEnum;
  /** How many units can carry over between cycles */
  carryOverDays?: Maybe<Scalars['Int']>;
  /** How many units can carry over between cycles multiplied by 100 */
  carryOverUnitsInCents?: Maybe<Scalars['Int']>;
  /** This setting flags if units taken during a bank holiday should be deducted or not from allowance. */
  countHolidayAsWorkable: Scalars['Boolean'];
  /** How many months does each allowance cycle last */
  cycleLength?: Maybe<Scalars['Int']>;
  /** When does the cycle start. */
  cycleStart?: Maybe<Scalars['String']>;
  /** Indicates if the allowance is based on working on calendar days. */
  daysType?: Maybe<TimeoffAllowanceDaysTypeEnum>;
  /** When does the carryover start */
  employeeCarryOverStartingYear?: Maybe<Scalars['Int']>;
  /** When does the carryover expire in months. */
  expireInMonths?: Maybe<Scalars['Int']>;
  /** Defines duration of the allowance cycles. Can be "yearly", "monthly_flexible" or "lifetime" */
  frequency?: Maybe<TimeoffAllowancesFrequencyEnum>;
  /** Base amount of holiday allowance units multiplied by 100 */
  holidayAllowanceInCents?: Maybe<Scalars['Int']>;
  /** Unique identifier of the allowance */
  id: Scalars['Int'];
  /**
   * An array of leave type ids associated with that allowance
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  leaveTypeIds: Array<Scalars['Int']>;
  leaveTypes: Array<TimeoffLeaveType>;
  leavetypesConnection: TimeoffLeaveTypeConnection;
  /** Maximum the allowance can reach on accrued */
  maximumAmountInCents?: Maybe<Scalars['Int']>;
  /** Allowance name set by the user */
  name: Scalars['String'];
  /** Whether the allowance allows to request more days than available */
  negativeCounterType?: Maybe<TimeoffAllowanceNegativeCounterTypeEnum>;
  policy?: Maybe<TimeoffPolicy>;
  /** Indicates the position in the allowance when rendering them in UI */
  position?: Maybe<Scalars['Int']>;
  /** Whether the allowance has proration enabled or not. */
  prorationType: TimeoffAllowanceProrationTypeEnum;
  /** Whether the allowance days are prorrated or not */
  ptoProratioEnabled?: Maybe<Scalars['Boolean']>;
  /** Configures how leaves duration is handled. */
  rangeType?: Maybe<TimeoffAllowancesRangeTypeEnum>;
  /** How the accrued units of the allowance are rounded. It depends if the allowance is set in hours or days. */
  rounding: TimeoffAllowanceRoundingsEnum;
  sendNotification?: Maybe<Scalars['Boolean']>;
  /** This field configures the type of allowance (fixed balance, based on worked time) */
  sourceUnits?: Maybe<TimeoffAllowancesSourceUnitsEnum>;
  /** In case the allowance has tenure periods, when is this tenure applied. */
  tenurePeriodTransition?: Maybe<TimeoffAllowancesTenurePeriodTransitionEnum>;
  /** The tenure periods associated with the allowance. */
  tenurePeriods: Array<TimeoffAllowanceTenurePeriod>;
  /** Whether the allowance has tenure periods enabled or not. */
  tenurePeriodsEnabled?: Maybe<Scalars['Boolean']>;
  /** Value to indicate how the allowance cycle is configured. Its an abbreviation of the first and last month. */
  timeoffCycle: Scalars['String'];
  /**
   * The Id of the policy to which the allowance belongs to
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  timeoffPolicyId: Scalars['Int'];
  /** Flag to indicate if there is unlimited accrual. */
  unlimitedAccruedHours?: Maybe<Scalars['Boolean']>;
  /** Flag to indicate if there is unlimited carry over. */
  unlimitedCarryOver?: Maybe<Scalars['Boolean']>;
  /** Boolean to flag if carryover does not expire */
  unlimitedCarryOverExpiration?: Maybe<Scalars['Boolean']>;
  /** Flag to indicate that the allowance has unlimited available days */
  unlimitedHolidays?: Maybe<Scalars['Boolean']>;
};


/** An Allowance represents how a Time off counter accrues and deducts days. */
export type TimeoffAllowanceAllowanceIncidencesArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** An Allowance represents how a Time off counter accrues and deducts days. */
export type TimeoffAllowanceAllowanceIncidencesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** An Allowance represents how a Time off counter accrues and deducts days. */
export type TimeoffAllowanceLeaveTypesArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  allowEndless?: InputMaybe<Scalars['Boolean']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeId?: InputMaybe<Scalars['Int']>;
  leaveTypeId?: InputMaybe<Scalars['Int']>;
  payable?: InputMaybe<Scalars['Boolean']>;
  referenceDate?: InputMaybe<Scalars['ISO8601Date']>;
};


/** An Allowance represents how a Time off counter accrues and deducts days. */
export type TimeoffAllowanceLeavetypesConnectionArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  allowEndless?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  leaveTypeId?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  payable?: InputMaybe<Scalars['Boolean']>;
  referenceDate?: InputMaybe<Scalars['ISO8601Date']>;
  sortOrder?: InputMaybe<Sort>;
};


/** An Allowance represents how a Time off counter accrues and deducts days. */
export type TimeoffAllowancePolicyArgs = {
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type TimeoffAllowanceAllowanceTypeEnum =
  | 'days'
  | 'hours';

/** The connection type for TimeoffAllowance. */
export type TimeoffAllowanceConnection = {
  __typename?: 'TimeoffAllowanceConnection';
  /** A list of edges. */
  edges: Array<TimeoffAllowanceEdge>;
  /** A list of nodes. */
  nodes: Array<TimeoffAllowance>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type TimeoffAllowanceDaysTypeEnum =
  | 'french_calendar_days'
  | 'french_ouvres'
  | 'natural_days'
  | 'natural_days_only_range'
  | 'working_days';

/** An edge in a connection. */
export type TimeoffAllowanceEdge = {
  __typename?: 'TimeoffAllowanceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TimeoffAllowance;
};

/** Timeoff allowance incidence */
export type TimeoffAllowanceIncidence = {
  __typename?: 'TimeoffAllowanceIncidence';
  /** Unix timestamp when the DB record was created */
  createdAt: Scalars['Int'];
  /** How many units * 100 does the incidence add/substract. Can be positive or negative. Example is one unit */
  daysInCents: Scalars['Int'];
  /** Optional comment regarding the incidence */
  description?: Maybe<Scalars['String']>;
  /** When does the incidence take effect; this is for time off cycles calculations. */
  effectiveOn: Scalars['ISO8601Date'];
  employee?: Maybe<EmployeesEmployee>;
  /**
   * Employee id of the affected employee
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  employeeId: Scalars['Int'];
  /** Unique identifier of the allowance incidence */
  id: Scalars['Int'];
  /** Whether the incidence affects the Accrued or the Available counter. */
  targetBalance?: Maybe<Scalars['String']>;
  timeoffAllowance?: Maybe<TimeoffAllowance>;
  /**
   * To what allowance does the incidence affect. It will dictate if its days or hours
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  timeoffAllowanceId: Scalars['Int'];
  /** Unix timestamp when the DB record was last updated */
  updatedAt: Scalars['Int'];
};


/** Timeoff allowance incidence */
export type TimeoffAllowanceIncidenceEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Timeoff allowance incidence */
export type TimeoffAllowanceIncidenceTimeoffAllowanceArgs = {
  byOvertime?: InputMaybe<Scalars['Boolean']>;
  timeoffPolicyId?: InputMaybe<Scalars['Int']>;
};

/** The connection type for TimeoffAllowanceIncidence. */
export type TimeoffAllowanceIncidenceConnection = {
  __typename?: 'TimeoffAllowanceIncidenceConnection';
  /** A list of edges. */
  edges: Array<TimeoffAllowanceIncidenceEdge>;
  /** A list of nodes. */
  nodes: Array<TimeoffAllowanceIncidence>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TimeoffAllowanceIncidenceEdge = {
  __typename?: 'TimeoffAllowanceIncidenceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TimeoffAllowanceIncidence;
};

export type TimeoffAllowanceIncidencesTargetBalanceEnum =
  | 'accrued'
  | 'available';

export type TimeoffAllowanceNegativeCounterTypeEnum =
  | 'negative_counter_disabled'
  | 'negative_counter_enabled';

export type TimeoffAllowanceProrationTypeEnum =
  | 'proration_disabled'
  | 'proration_enabled';

export type TimeoffAllowanceRoundingsEnum =
  | 'decimals'
  | 'half_day'
  | 'quarters'
  | 'round_up';

/** Timeoff allowance stat */
export type TimeoffAllowanceStat = {
  __typename?: 'TimeoffAllowanceStat';
  accumulatedCarryOver: Scalars['String'];
  allowance?: Maybe<TimeoffAllowance>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  allowanceId: Scalars['Int'];
  availableDays: Scalars['String'];
  carryOvers: Array<Scalars['String']>;
  cycles: Scalars['String'];
  employee?: Maybe<EmployeesEmployee>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  employeeId: Scalars['Int'];
  id: Scalars['String'];
  incidences: Scalars['String'];
  maxBalanceCap?: Maybe<Scalars['String']>;
  outstandingUnits: Scalars['String'];
  policyAllowance: Scalars['String'];
  proratedAllowanceDays: Scalars['String'];
  totalAccruedUnits: Scalars['String'];
  totalInDecimal?: Maybe<Scalars['String']>;
  usedCarryOver: Scalars['String'];
  usedDays: Scalars['String'];
  usedUnitsUntilReferenceDate: Scalars['String'];
  year: Scalars['Int'];
};


/** Timeoff allowance stat */
export type TimeoffAllowanceStatAllowanceArgs = {
  byOvertime?: InputMaybe<Scalars['Boolean']>;
  timeoffPolicyId?: InputMaybe<Scalars['Int']>;
};


/** Timeoff allowance stat */
export type TimeoffAllowanceStatEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for TimeoffAllowanceStat. */
export type TimeoffAllowanceStatConnection = {
  __typename?: 'TimeoffAllowanceStatConnection';
  /** A list of edges. */
  edges: Array<TimeoffAllowanceStatEdge>;
  /** A list of nodes. */
  nodes: Array<TimeoffAllowanceStat>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TimeoffAllowanceStatEdge = {
  __typename?: 'TimeoffAllowanceStatEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TimeoffAllowanceStat;
};

export type TimeoffAllowanceTenurePeriod = {
  __typename?: 'TimeoffAllowanceTenurePeriod';
  adjustmentInCents?: Maybe<Scalars['Int']>;
  balanceType: TimeoffAllowanceTenurePeriodBalanceTypeEnum;
  id: Scalars['Int'];
  maxCapInCents?: Maybe<Scalars['Int']>;
  periodLength?: Maybe<Scalars['Int']>;
  periodType: TimeoffAllowanceTenurePeriodPeriodTypeEnum;
  timeWorkedBasedHoursAccruedInCents?: Maybe<Scalars['Int']>;
  timeWorkedBasedPerHoursWorkedInCents?: Maybe<Scalars['Int']>;
};

export type TimeoffAllowanceTenurePeriodBalanceTypeEnum =
  | 'fixed_balance'
  | 'time_worked_based';

export type TimeoffAllowanceTenurePeriodPeriodTypeEnum =
  | 'months'
  | 'years';

export type TimeoffAllowancesAccruedUnitsAvailabilityEnum =
  | 'current_cycle'
  | 'next_cycle';

export type TimeoffAllowancesAvailableDaysEnum =
  | 'all_days'
  | 'bimonthly_fifteenth_and_last'
  | 'bimonthly_first_and_fifteenth'
  | 'generated_days'
  | 'generated_days_monthly'
  | 'generated_days_monthly_first_day'
  | 'mensiversary'
  | 'monthly_fifteenth';

export type TimeoffAllowancesFrequencyEnum =
  | 'lifetime'
  | 'monthly_flexible'
  | 'yearly';

export type TimeoffAllowancesRangeTypeEnum =
  | 'exact_range'
  | 'extra_non_working_days_at_end';

export type TimeoffAllowancesSourceUnitsEnum =
  | 'base_units'
  | 'by_worked_time'
  | 'overtime_units';

export type TimeoffAllowancesTenurePeriodTransitionEnum =
  | 'after_milestone'
  | 'beginning_of_cycle'
  | 'end_of_cycle';

/** Time off blocked period */
export type TimeoffBlockedPeriod = {
  __typename?: 'TimeoffBlockedPeriod';
  company: ApiCoreCompany;
  /**
   * Company id of the blocked period
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  companyId: Scalars['Int'];
  /** Unique identifier of the blocked period */
  id: Scalars['Int'];
  /**
   * Leave types for which absence request has been blocked
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  leaveTypeIds: Array<Scalars['Int']>;
  leaveTypes: Array<TimeoffLeaveType>;
  leavetypesConnection: TimeoffLeaveTypeConnection;
  /** List of legal entity identifiers which the selected employees belong to */
  legalEntityIds?: Maybe<Array<Scalars['Int']>>;
  /** List of locations workplace identifiers where the employees are located */
  locationIds?: Maybe<Array<Scalars['Int']>>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  memberIds: Array<Scalars['Int']>;
  /** Employees whose timeoff will be affected */
  members: Array<Scalars['Int']>;
  membersAsAccesses: Array<ApiCoreAccess>;
  membersasaccessesConnection: ApiCoreAccessConnection;
  /** Name of the blocked period. */
  name: Scalars['String'];
  /** Type of access group */
  strategy: Scalars['String'];
  /** List of team identifiers which the selected employees belong to */
  teamIds?: Maybe<Array<Scalars['Int']>>;
  /** The tenure periods associated with the allowance. */
  timePeriods: Array<TimeoffTimePeriod>;
};


/** Time off blocked period */
export type TimeoffBlockedPeriodLeaveTypesArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  allowEndless?: InputMaybe<Scalars['Boolean']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeId?: InputMaybe<Scalars['Int']>;
  leaveTypeId?: InputMaybe<Scalars['Int']>;
  payable?: InputMaybe<Scalars['Boolean']>;
  referenceDate?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Time off blocked period */
export type TimeoffBlockedPeriodLeavetypesConnectionArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  allowEndless?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  leaveTypeId?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  payable?: InputMaybe<Scalars['Boolean']>;
  referenceDate?: InputMaybe<Scalars['ISO8601Date']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Time off blocked period */
export type TimeoffBlockedPeriodMembersAsAccessesArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** Time off blocked period */
export type TimeoffBlockedPeriodMembersasaccessesConnectionArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  external?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for TimeoffBlockedPeriod. */
export type TimeoffBlockedPeriodConnection = {
  __typename?: 'TimeoffBlockedPeriodConnection';
  /** A list of edges. */
  edges: Array<TimeoffBlockedPeriodEdge>;
  /** A list of nodes. */
  nodes: Array<TimeoffBlockedPeriod>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TimeoffBlockedPeriodEdge = {
  __typename?: 'TimeoffBlockedPeriodEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TimeoffBlockedPeriod;
};

export type TimeoffContextlessPolicies = {
  __typename?: 'TimeoffContextlessPolicies';
  companyManageTimeoff: ContextlessPolicyResolution;
  dashboardWidgetUpcomingAbsencesVisible: ContextlessPolicyResolution;
  dashboardWidgetUpcomingHolidaysVisible: ContextlessPolicyResolution;
  sidebarSeeTimeoffTopLevelItem: ContextlessPolicyResolution;
};

/** Current time off policy assignment */
export type TimeoffCurrentPolicyAssignment = {
  __typename?: 'TimeoffCurrentPolicyAssignment';
  effectiveAt?: Maybe<Scalars['ISO8601Date']>;
  employee?: Maybe<EmployeesEmployee>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  employeeId: Scalars['Int'];
  timeoffPolicyId: Scalars['Int'];
};


/** Current time off policy assignment */
export type TimeoffCurrentPolicyAssignmentEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for TimeoffCurrentPolicyAssignment. */
export type TimeoffCurrentPolicyAssignmentConnection = {
  __typename?: 'TimeoffCurrentPolicyAssignmentConnection';
  /** A list of edges. */
  edges: Array<TimeoffCurrentPolicyAssignmentEdge>;
  /** A list of nodes. */
  nodes: Array<TimeoffCurrentPolicyAssignment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TimeoffCurrentPolicyAssignmentEdge = {
  __typename?: 'TimeoffCurrentPolicyAssignmentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TimeoffCurrentPolicyAssignment;
};

export type TimeoffCycleStartEnum =
  | 'apr'
  | 'aug'
  | 'dec'
  | 'employee_hired_date'
  | 'feb'
  | 'jan'
  | 'jul'
  | 'jun'
  | 'mar'
  | 'may'
  | 'nov'
  | 'oct'
  | 'sep';

export type TimeoffDelegateApprover = {
  __typename?: 'TimeoffDelegateApprover';
  accessId: Scalars['Int'];
};

export type TimeoffFrenchDurationsUnitEnum =
  | 'days'
  | 'hours';

/** Timeoff leave */
export type TimeoffLeave = {
  __typename?: 'TimeoffLeave';
  _policies?: Maybe<TimeoffLeavePolicies>;
  _policiesCollection?: Maybe<Array<PermissionsPolicyResolution>>;
  _policiesConnection: PermissionsPolicyResolutionConnection;
  accrues?: Maybe<Scalars['Boolean']>;
  approvalRecommendation?: Maybe<TimeoffLeaveApprovalRecommendation>;
  approvalSuggestion?: Maybe<TimeoffLeaveApprovalRecommendationsRecommendedActionEnum>;
  /** Indicates whether the leave has been approved */
  approved?: Maybe<Scalars['Boolean']>;
  /** Company identifier of the employee of the leave */
  companyId: Scalars['Int'];
  /** The created at date of the leave */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Number of days taken for paid leave */
  daysTaken: Scalars['Float'];
  delegatedApprover?: Maybe<TimeoffDelegateApprover>;
  delegatedApproverAccess?: Maybe<ApiCoreAccess>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  delegatedApproverId?: Maybe<Scalars['Int']>;
  /** The date when the leave was deleted */
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** A description of the leave */
  description?: Maybe<Scalars['String']>;
  documents: Array<DocumentsDocument>;
  documentsConnection: DocumentsDocumentConnection;
  /** The duration attributes of the leave */
  durationAttributes?: Maybe<Scalars['String']>;
  employee?: Maybe<EmployeesEmployee>;
  /** The full name of the employee taking the leave */
  employeeFullName?: Maybe<Scalars['String']>;
  /**
   * Employee identifier of the leave
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  employeeId: Scalars['Int'];
  /** The end date of the leave */
  finishOn?: Maybe<Scalars['ISO8601Date']>;
  finishOnNatural?: Maybe<Scalars['ISO8601Date']>;
  frenchDuration?: Maybe<Scalars['Float']>;
  frenchDurationUnit?: Maybe<TimeoffFrenchDurationsUnitEnum>;
  /** Indicates if the leave is taken as a half-day */
  halfDay?: Maybe<Scalars['String']>;
  hourly?: Maybe<Scalars['Boolean']>;
  /** The total number of hours taken for the leave, represented in cents */
  hoursAmountInCents?: Maybe<Scalars['Int']>;
  /** Identifier of the Leave */
  id: Scalars['Int'];
  leaveType?: Maybe<TimeoffLeaveType>;
  leaveTypeColor?: Maybe<Scalars['String']>;
  /**
   * The identifier for the type of leave
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  leaveTypeId?: Maybe<Scalars['Int']>;
  leaveTypeIdentifier?: Maybe<Scalars['String']>;
  /** The name of the leave type */
  leaveTypeName?: Maybe<Scalars['String']>;
  leaveTypePayable?: Maybe<Scalars['Boolean']>;
  leaveTypeVisibility?: Maybe<Scalars['Boolean']>;
  leaveTypeWorkable: Scalars['Boolean'];
  /** The reason provided by the employee for taking the leave */
  reason?: Maybe<Scalars['String']>;
  /** The start date of the leave */
  startOn: Scalars['ISO8601Date'];
  /** The start time of the leave */
  startTime?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  /** The updated at date of the leave */
  updatedAt: Scalars['ISO8601DateTime'];
};


/** Timeoff leave */
export type TimeoffLeave_PoliciesCollectionArgs = {
  ids: Array<TimeoffLeavePoliciesEnum>;
};


/** Timeoff leave */
export type TimeoffLeave_PoliciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Timeoff leave */
export type TimeoffLeaveDelegatedApproverAccessArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** Timeoff leave */
export type TimeoffLeaveDocumentsArgs = {
  afterDate?: InputMaybe<Scalars['ISO8601Date']>;
  beforeDate?: InputMaybe<Scalars['ISO8601Date']>;
  byBookkeeperDocuments?: InputMaybe<Scalars['Boolean']>;
  byPendingAssignment?: Scalars['Boolean'];
  byTrashBin?: Scalars['Boolean'];
  byWithoutFolder?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['Int']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  excludedType?: InputMaybe<Scalars['String']>;
  folderId?: InputMaybe<Scalars['Int']>;
  fromEmployees?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  incidenceId?: InputMaybe<Scalars['Int']>;
  includeTrashBin?: InputMaybe<Scalars['Boolean']>;
  leaveId?: InputMaybe<Scalars['Int']>;
  payrollHiringId?: InputMaybe<Scalars['Int']>;
  relationships?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  sort?: Scalars['String'];
  space?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};


/** Timeoff leave */
export type TimeoffLeaveDocumentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  afterDate?: InputMaybe<Scalars['ISO8601Date']>;
  before?: InputMaybe<Scalars['String']>;
  beforeDate?: InputMaybe<Scalars['ISO8601Date']>;
  byBookkeeperDocuments?: InputMaybe<Scalars['Boolean']>;
  byPendingAssignment?: Scalars['Boolean'];
  byTrashBin?: Scalars['Boolean'];
  byWithoutFolder?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['Int']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  excludedType?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  folderId?: InputMaybe<Scalars['Int']>;
  fromEmployees?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  incidenceId?: InputMaybe<Scalars['Int']>;
  includeTrashBin?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  leaveId?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  payrollHiringId?: InputMaybe<Scalars['Int']>;
  relationships?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  sort?: Scalars['String'];
  sortOrder?: InputMaybe<Sort>;
  space?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};


/** Timeoff leave */
export type TimeoffLeaveEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Timeoff leave */
export type TimeoffLeaveLeaveTypeArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  allowEndless?: InputMaybe<Scalars['Boolean']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeId?: InputMaybe<Scalars['Int']>;
  leaveTypeId?: InputMaybe<Scalars['Int']>;
  payable?: InputMaybe<Scalars['Boolean']>;
  referenceDate?: InputMaybe<Scalars['ISO8601Date']>;
};

/** Leave Approval Condition */
export type TimeoffLeaveApprovalCondition = {
  __typename?: 'TimeoffLeaveApprovalCondition';
  companyId: Scalars['Int'];
  conditionType: Scalars['String'];
  enabled: Scalars['Boolean'];
  id: Scalars['Int'];
  leaveApprovalRule: TimeoffLeaveApprovalRule;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  leaveApprovalRuleId: Scalars['Int'];
};


/** Leave Approval Condition */
export type TimeoffLeaveApprovalConditionLeaveApprovalRuleArgs = {
  createdByEmployeeId?: InputMaybe<Scalars['Int']>;
  leaveTypeIds?: InputMaybe<Array<Scalars['Int']>>;
};

/** The connection type for TimeoffLeaveApprovalCondition. */
export type TimeoffLeaveApprovalConditionConnection = {
  __typename?: 'TimeoffLeaveApprovalConditionConnection';
  /** A list of edges. */
  edges: Array<TimeoffLeaveApprovalConditionEdge>;
  /** A list of nodes. */
  nodes: Array<TimeoffLeaveApprovalCondition>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TimeoffLeaveApprovalConditionEdge = {
  __typename?: 'TimeoffLeaveApprovalConditionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TimeoffLeaveApprovalCondition;
};

/** Leave Approval Recommendation */
export type TimeoffLeaveApprovalRecommendation = {
  __typename?: 'TimeoffLeaveApprovalRecommendation';
  action: TimeoffLeaveApprovalRecommendationsRecommendedActionEnum;
  leave?: Maybe<TimeoffLeave>;
  leaveApprovalRule?: Maybe<TimeoffLeaveApprovalRule>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  leaveId: Scalars['Int'];
  reason: TimeoffLeaveApprovalRecommendationReason;
};


/** Leave Approval Recommendation */
export type TimeoffLeaveApprovalRecommendationLeaveArgs = {
  approved?: InputMaybe<Scalars['Boolean']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  from?: InputMaybe<Scalars['ISO8601Date']>;
  includeAllPendingApprovals?: InputMaybe<Scalars['Boolean']>;
  includeAllRelations?: InputMaybe<Scalars['Boolean']>;
  includeDeletedLeaves?: Scalars['Boolean'];
  includeDuration?: InputMaybe<Scalars['Boolean']>;
  includeLeaveType?: InputMaybe<Scalars['Boolean']>;
  includePending?: InputMaybe<Scalars['Boolean']>;
  leaveType?: InputMaybe<Array<Scalars['String']>>;
  leaveTypeId?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  to?: InputMaybe<Scalars['ISO8601Date']>;
  typeIsPayable?: InputMaybe<Scalars['Boolean']>;
  typeIsWorkable?: InputMaybe<Scalars['Boolean']>;
};


/** Leave Approval Recommendation */
export type TimeoffLeaveApprovalRecommendationLeaveApprovalRuleArgs = {
  createdByEmployeeId?: InputMaybe<Scalars['Int']>;
  leaveTypeIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type TimeoffLeaveApprovalRecommendationAvailableDays = {
  __typename?: 'TimeoffLeaveApprovalRecommendationAvailableDays';
  daysLeft: Scalars['String'];
  leaveTypeName: Scalars['String'];
};

/** The connection type for TimeoffLeaveApprovalRecommendation. */
export type TimeoffLeaveApprovalRecommendationConnection = {
  __typename?: 'TimeoffLeaveApprovalRecommendationConnection';
  /** A list of edges. */
  edges: Array<TimeoffLeaveApprovalRecommendationEdge>;
  /** A list of nodes. */
  nodes: Array<TimeoffLeaveApprovalRecommendation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TimeoffLeaveApprovalRecommendationEdge = {
  __typename?: 'TimeoffLeaveApprovalRecommendationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TimeoffLeaveApprovalRecommendation;
};

export type TimeoffLeaveApprovalRecommendationOverlaps = {
  __typename?: 'TimeoffLeaveApprovalRecommendationOverlaps';
  directReportEmployeeNames?: Maybe<Array<Scalars['String']>>;
  teamEmployeeNames?: Maybe<Array<Scalars['String']>>;
  totalReportEmployeeNames?: Maybe<Array<Scalars['String']>>;
};

export type TimeoffLeaveApprovalRecommendationReason = {
  __typename?: 'TimeoffLeaveApprovalRecommendationReason';
  availableDays?: Maybe<TimeoffLeaveApprovalRecommendationAvailableDays>;
  overlaps: TimeoffLeaveApprovalRecommendationOverlaps;
  shiftsInfo?: Maybe<Array<TimeoffLeaveApprovalRecommendationShiftInfo>>;
};

export type TimeoffLeaveApprovalRecommendationShiftInfo = {
  __typename?: 'TimeoffLeaveApprovalRecommendationShiftInfo';
  endAt: Scalars['ISO8601DateTime'];
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  startAt: Scalars['ISO8601DateTime'];
  state: ShiftManagementEnumsShiftStateEnum;
};

export type TimeoffLeaveApprovalRecommendationsRecommendedActionEnum =
  | 'approve'
  | 'no_recommendation'
  | 'reject'
  | 'review';

/** Leave Approval Rule */
export type TimeoffLeaveApprovalRule = {
  __typename?: 'TimeoffLeaveApprovalRule';
  companyId: Scalars['Int'];
  createdByEmployeeId: Scalars['Int'];
  id: Scalars['Int'];
  leaveApprovalConditions: Array<TimeoffLeaveApprovalCondition>;
  leaveApprovalConditionsConnection: TimeoffLeaveApprovalConditionConnection;
  leaveTypeIds: Array<Scalars['Int']>;
  name: Scalars['String'];
};


/** Leave Approval Rule */
export type TimeoffLeaveApprovalRuleLeaveApprovalConditionsArgs = {
  conditionType?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Leave Approval Rule */
export type TimeoffLeaveApprovalRuleLeaveApprovalConditionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  conditionType?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for TimeoffLeaveApprovalRule. */
export type TimeoffLeaveApprovalRuleConnection = {
  __typename?: 'TimeoffLeaveApprovalRuleConnection';
  /** A list of edges. */
  edges: Array<TimeoffLeaveApprovalRuleEdge>;
  /** A list of nodes. */
  nodes: Array<TimeoffLeaveApprovalRule>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TimeoffLeaveApprovalRuleEdge = {
  __typename?: 'TimeoffLeaveApprovalRuleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TimeoffLeaveApprovalRule;
};

/** The connection type for TimeoffLeave. */
export type TimeoffLeaveConnection = {
  __typename?: 'TimeoffLeaveConnection';
  /** A list of edges. */
  edges: Array<TimeoffLeaveEdge>;
  /** A list of nodes. */
  nodes: Array<TimeoffLeave>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TimeoffLeaveEdge = {
  __typename?: 'TimeoffLeaveEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TimeoffLeave;
};

/** the filter for the leaves resource */
export type TimeoffLeaveFilter = {
  or?: InputMaybe<Array<TimeoffLeaveFilterConditions>>;
  startOn?: InputMaybe<DateFilter>;
};

export type TimeoffLeaveFilterConditions = {
  startOn?: InputMaybe<DateFilter>;
};

export type TimeoffLeavePolicies = {
  __typename?: 'TimeoffLeavePolicies';
  approveLeave: PermissionsPolicyResolution;
  deleteLeave: PermissionsPolicyResolution;
  manageLeaveDocuments: PermissionsPolicyResolution;
  updateLeave: PermissionsPolicyResolution;
};

export type TimeoffLeavePoliciesEnum =
  | 'approveLeave'
  | 'deleteLeave'
  | 'manageLeaveDocuments'
  | 'updateLeave';

/** Timeoff leave type */
export type TimeoffLeaveType = {
  __typename?: 'TimeoffLeaveType';
  /** Whether the leave type accrues over time */
  accrues?: Maybe<Scalars['Boolean']>;
  /** Whether the leave type is active */
  active?: Maybe<Scalars['Boolean']>;
  /** Whether endless leave is allowed */
  allowEndless?: Maybe<Scalars['Boolean']>;
  /** List of allowance identifiers associated with this leave type */
  allowanceIds: Array<Scalars['Int']>;
  allowances: Array<TimeoffAllowance>;
  allowancesConnection: TimeoffAllowanceConnection;
  /** Whether approval is required for this leave type */
  approvalRequired?: Maybe<Scalars['Boolean']>;
  /** Whether an attachment is required for this leave type */
  attachment: Scalars['Boolean'];
  /** The color associated with this leave type */
  color: Scalars['String'];
  company: ApiCoreCompany;
  /**
   * Identifier of the company associated with this leave type
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  companyId: Scalars['Int'];
  /** Description of the leave type */
  description?: Maybe<Scalars['String']>;
  /** Whether additional details are required for the leave type */
  detailsRequired: Scalars['Boolean'];
  /** Whether the leave type is editable */
  editable?: Maybe<Scalars['Boolean']>;
  /** Whether half-day units are enabled for this leave type */
  halfDaysUnitsEnabled?: Maybe<Scalars['Boolean']>;
  /** Identifier of the leave type */
  id: Scalars['Int'];
  /** Unique identifier of the leave type */
  identifier: Scalars['String'];
  /** Whether the attachment is mandatory */
  isAttachmentMandatory?: Maybe<Scalars['Boolean']>;
  leaves: Array<TimeoffLeave>;
  leavesConnection: TimeoffLeaveConnection;
  /** Maximum days in cents that can be taken */
  maxDaysInCents?: Maybe<Scalars['Int']>;
  /** Minimum days in cents that must be taken */
  minDaysInCents?: Maybe<Scalars['Int']>;
  /** Name of the leave type */
  name: Scalars['String'];
  /** Whether the leave type is payable */
  payable?: Maybe<Scalars['Boolean']>;
  /** Whether the leave type is restricted */
  restricted?: Maybe<Scalars['Boolean']>;
  /** Translated name of the leave type, if available */
  translatedName?: Maybe<Scalars['String']>;
  /** Whether the leave type is visible to employees */
  visibility: Scalars['Boolean'];
  /** Whether the leave type is workable */
  workable: Scalars['Boolean'];
};


/** Timeoff leave type */
export type TimeoffLeaveTypeAllowancesArgs = {
  byOvertime?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyId?: InputMaybe<Scalars['Int']>;
};


/** Timeoff leave type */
export type TimeoffLeaveTypeAllowancesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  byOvertime?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  timeoffPolicyId?: InputMaybe<Scalars['Int']>;
};


/** Timeoff leave type */
export type TimeoffLeaveTypeLeavesArgs = {
  approved?: InputMaybe<Scalars['Boolean']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  from?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeAllPendingApprovals?: InputMaybe<Scalars['Boolean']>;
  includeAllRelations?: InputMaybe<Scalars['Boolean']>;
  includeDeletedLeaves?: Scalars['Boolean'];
  includeDuration?: InputMaybe<Scalars['Boolean']>;
  includeLeaveType?: InputMaybe<Scalars['Boolean']>;
  includePending?: InputMaybe<Scalars['Boolean']>;
  leaveType?: InputMaybe<Array<Scalars['String']>>;
  leaveTypeId?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  to?: InputMaybe<Scalars['ISO8601Date']>;
  typeIsPayable?: InputMaybe<Scalars['Boolean']>;
  typeIsWorkable?: InputMaybe<Scalars['Boolean']>;
};


/** Timeoff leave type */
export type TimeoffLeaveTypeLeavesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  approved?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeAllPendingApprovals?: InputMaybe<Scalars['Boolean']>;
  includeAllRelations?: InputMaybe<Scalars['Boolean']>;
  includeDeletedLeaves?: Scalars['Boolean'];
  includeDuration?: InputMaybe<Scalars['Boolean']>;
  includeLeaveType?: InputMaybe<Scalars['Boolean']>;
  includePending?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  leaveType?: InputMaybe<Array<Scalars['String']>>;
  leaveTypeId?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Sort>;
  to?: InputMaybe<Scalars['ISO8601Date']>;
  typeIsPayable?: InputMaybe<Scalars['Boolean']>;
  typeIsWorkable?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for TimeoffLeaveType. */
export type TimeoffLeaveTypeConnection = {
  __typename?: 'TimeoffLeaveTypeConnection';
  /** A list of edges. */
  edges: Array<TimeoffLeaveTypeEdge>;
  /** A list of nodes. */
  nodes: Array<TimeoffLeaveType>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TimeoffLeaveTypeEdge = {
  __typename?: 'TimeoffLeaveTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TimeoffLeaveType;
};

/** Time off policies */
export type TimeoffPolicy = {
  __typename?: 'TimeoffPolicy';
  allowanceIncidences: Scalars['Int'];
  allowances: Array<TimeoffAllowance>;
  allowancesConnection: TimeoffAllowanceConnection;
  company: ApiCoreCompany;
  /**
   * The company id.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  companyId: Scalars['Int'];
  defaultAllowanceId?: Maybe<Scalars['Int']>;
  /** The policy description. */
  description?: Maybe<Scalars['String']>;
  employees: Array<EmployeesEmployee>;
  employeesConnection: EmployeesEmployeeConnection;
  /** The policy id. */
  id: Scalars['Int'];
  /** Is the main policy? It will return true if it's the main policy if not it will return false. */
  main?: Maybe<Scalars['Boolean']>;
  /** Policy name. */
  name: Scalars['String'];
  policyAssignments: Array<TimeoffPolicyAssignment>;
  policyassignmentsConnection: TimeoffPolicyAssignmentConnection;
};


/** Time off policies */
export type TimeoffPolicyAllowancesArgs = {
  byOvertime?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyId?: InputMaybe<Scalars['Int']>;
};


/** Time off policies */
export type TimeoffPolicyAllowancesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  byOvertime?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  timeoffPolicyId?: InputMaybe<Scalars['Int']>;
};


/** Time off policies */
export type TimeoffPolicyEmployeesArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Time off policies */
export type TimeoffPolicyEmployeesConnectionArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  after?: InputMaybe<Scalars['String']>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Sort>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Time off policies */
export type TimeoffPolicyPolicyAssignmentsArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Time off policies */
export type TimeoffPolicyPolicyassignmentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** Time off Policy Assignments */
export type TimeoffPolicyAssignment = {
  __typename?: 'TimeoffPolicyAssignment';
  /** The effective date of the policy assignment */
  effectiveAt: Scalars['ISO8601Date'];
  employee?: Maybe<EmployeesEmployee>;
  /**
   * The employee id
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  employeeId: Scalars['Int'];
  endEffectiveAt?: Maybe<Scalars['ISO8601Date']>;
  /** Unique identifier of the policy assignment */
  id?: Maybe<Scalars['Int']>;
  /** Whether the policy assignment is an initial assignment */
  isInitial?: Maybe<Scalars['Boolean']>;
  timeoffPolicy?: Maybe<TimeoffPolicy>;
  /**
   * The time off policy id
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  timeoffPolicyId: Scalars['Int'];
  timeoffPolicyName?: Maybe<Scalars['String']>;
};


/** Time off Policy Assignments */
export type TimeoffPolicyAssignmentEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Time off Policy Assignments */
export type TimeoffPolicyAssignmentTimeoffPolicyArgs = {
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
};

/** The connection type for TimeoffPolicyAssignment. */
export type TimeoffPolicyAssignmentConnection = {
  __typename?: 'TimeoffPolicyAssignmentConnection';
  /** A list of edges. */
  edges: Array<TimeoffPolicyAssignmentEdge>;
  /** A list of nodes. */
  nodes: Array<TimeoffPolicyAssignment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TimeoffPolicyAssignmentEdge = {
  __typename?: 'TimeoffPolicyAssignmentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TimeoffPolicyAssignment;
};

/** the filter for the policy_assignments resource */
export type TimeoffPolicyAssignmentFilter = {
  effectiveAt?: InputMaybe<DateFilter>;
  or?: InputMaybe<Array<TimeoffPolicyAssignmentFilterConditions>>;
};

export type TimeoffPolicyAssignmentFilterConditions = {
  effectiveAt?: InputMaybe<DateFilter>;
};

/** The connection type for TimeoffPolicy. */
export type TimeoffPolicyConnection = {
  __typename?: 'TimeoffPolicyConnection';
  /** A list of edges. */
  edges: Array<TimeoffPolicyEdge>;
  /** A list of nodes. */
  nodes: Array<TimeoffPolicy>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TimeoffPolicyEdge = {
  __typename?: 'TimeoffPolicyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TimeoffPolicy;
};

/** Policy Timeline represents the different Time off policies an employee has during his/her time at a company */
export type TimeoffPolicyTimeline = {
  __typename?: 'TimeoffPolicyTimeline';
  employeeId: Scalars['Int'];
  endLimitDate: Scalars['ISO8601Date'];
  /** This is the employee id since it's a virtual entity */
  id: Scalars['Int'];
  startLimitDate: Scalars['ISO8601Date'];
};

/** The connection type for TimeoffPolicyTimeline. */
export type TimeoffPolicyTimelineConnection = {
  __typename?: 'TimeoffPolicyTimelineConnection';
  /** A list of edges. */
  edges: Array<TimeoffPolicyTimelineEdge>;
  /** A list of nodes. */
  nodes: Array<TimeoffPolicyTimeline>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TimeoffPolicyTimelineEdge = {
  __typename?: 'TimeoffPolicyTimelineEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TimeoffPolicyTimeline;
};

export type TimeoffTimePeriod = {
  __typename?: 'TimeoffTimePeriod';
  duration?: Maybe<Scalars['Int']>;
  durationUnit?: Maybe<Scalars['String']>;
  finishOn?: Maybe<Scalars['ISO8601Date']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  periodType: Scalars['String'];
  policyId: Scalars['Int'];
  startOn?: Maybe<Scalars['ISO8601Date']>;
};

/** Timeoff upcoming leave */
export type TimeoffUpcomingLeave = {
  __typename?: 'TimeoffUpcomingLeave';
  currentEmployeeId: Scalars['Int'];
  employee?: Maybe<EmployeesEmployee>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  employeeId: Scalars['Int'];
  finishOn?: Maybe<Scalars['ISO8601Date']>;
  id: Scalars['Int'];
  leaveType?: Maybe<TimeoffLeaveType>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  leaveTypeId: Scalars['Int'];
  startOn: Scalars['ISO8601Date'];
};


/** Timeoff upcoming leave */
export type TimeoffUpcomingLeaveEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Timeoff upcoming leave */
export type TimeoffUpcomingLeaveLeaveTypeArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  allowEndless?: InputMaybe<Scalars['Boolean']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeId?: InputMaybe<Scalars['Int']>;
  leaveTypeId?: InputMaybe<Scalars['Int']>;
  payable?: InputMaybe<Scalars['Boolean']>;
  referenceDate?: InputMaybe<Scalars['ISO8601Date']>;
};

/** The connection type for TimeoffUpcomingLeave. */
export type TimeoffUpcomingLeaveConnection = {
  __typename?: 'TimeoffUpcomingLeaveConnection';
  /** A list of edges. */
  edges: Array<TimeoffUpcomingLeaveEdge>;
  /** A list of nodes. */
  nodes: Array<TimeoffUpcomingLeave>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TimeoffUpcomingLeaveEdge = {
  __typename?: 'TimeoffUpcomingLeaveEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TimeoffUpcomingLeave;
};

/** Autogenerated return type of ToggleActiveDocumentsFolder. */
export type ToggleActiveDocumentsFolderPayload = {
  __typename?: 'ToggleActiveDocumentsFolderPayload';
  errors: Array<MutationError>;
  folder?: Maybe<DocumentsFolder>;
};

/** Autogenerated return type of ToggleArchivePerformanceReviewProcess. */
export type ToggleArchivePerformanceReviewProcessPayload = {
  __typename?: 'ToggleArchivePerformanceReviewProcessPayload';
  errors: Array<MutationError>;
  reviewProcess?: Maybe<PerformanceReviewProcess>;
};

/** Autogenerated return type of ToggleArchiveWorkscheduleSchedule. */
export type ToggleArchiveWorkscheduleSchedulePayload = {
  __typename?: 'ToggleArchiveWorkscheduleSchedulePayload';
  errors: Array<MutationError>;
  schedule?: Maybe<WorkScheduleSchedule>;
};

/** Autogenerated return type of ToggleAttendancePayrollCompensation. */
export type ToggleAttendancePayrollCompensationPayload = {
  __typename?: 'ToggleAttendancePayrollCompensationPayload';
  errors: Array<MutationError>;
  payrollCompensation?: Maybe<AttendancePayrollCompensation>;
};

/** Autogenerated return type of ToggleCareersPageAtsCompany. */
export type ToggleCareersPageAtsCompanyPayload = {
  __typename?: 'ToggleCareersPageAtsCompanyPayload';
  company?: Maybe<AtsCompany>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of ToggleClockAttendanceClockInOut. */
export type ToggleClockAttendanceClockInOutPayload = {
  __typename?: 'ToggleClockAttendanceClockInOutPayload';
  clockInOut?: Maybe<AttendanceClockInOut>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of ToggleClockAttendanceShift. */
export type ToggleClockAttendanceShiftPayload = {
  __typename?: 'ToggleClockAttendanceShiftPayload';
  errors: Array<MutationError>;
  shift?: Maybe<AttendanceShift>;
};

/** Autogenerated return type of ToggleCompensationsPayrollConceptStatus. */
export type ToggleCompensationsPayrollConceptStatusPayload = {
  __typename?: 'ToggleCompensationsPayrollConceptStatusPayload';
  errors: Array<MutationError>;
  payrollConceptStatus?: Maybe<CompensationsPayrollConceptStatus>;
};

/** Autogenerated return type of ToggleEnabledAtsCandidateEmailAction. */
export type ToggleEnabledAtsCandidateEmailActionPayload = {
  __typename?: 'ToggleEnabledAtsCandidateEmailActionPayload';
  candidateEmailAction?: Maybe<AtsCandidateEmailAction>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of ToggleEnabledAtsOpenApplicationSetting. */
export type ToggleEnabledAtsOpenApplicationSettingPayload = {
  __typename?: 'ToggleEnabledAtsOpenApplicationSettingPayload';
  errors: Array<MutationError>;
  openApplicationSetting?: Maybe<AtsOpenApplicationSetting>;
};

/** Autogenerated return type of ToggleExpensesExpensableGroupsSetting. */
export type ToggleExpensesExpensableGroupsSettingPayload = {
  __typename?: 'ToggleExpensesExpensableGroupsSettingPayload';
  errors: Array<MutationError>;
  expensableGroupsSetting?: Maybe<ExpensesExpensableGroupsSetting>;
};

/** Autogenerated return type of ToggleFeaturesFeature. */
export type ToggleFeaturesFeaturePayload = {
  __typename?: 'ToggleFeaturesFeaturePayload';
  errors: Array<MutationError>;
  feature?: Maybe<FeaturesFeature>;
};

/** Autogenerated return type of ToggleIntegrationsprimoboxFeature. */
export type ToggleIntegrationsprimoboxFeaturePayload = {
  __typename?: 'ToggleIntegrationsprimoboxFeaturePayload';
  errors: Array<MutationError>;
  feature?: Maybe<IntegrationsPrimoboxFeature>;
};

/** Autogenerated return type of ToggleJobRequisitionsAtsCompany. */
export type ToggleJobRequisitionsAtsCompanyPayload = {
  __typename?: 'ToggleJobRequisitionsAtsCompanyPayload';
  company?: Maybe<AtsCompany>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of ToggleLockCompensationsPayrollRun. */
export type ToggleLockCompensationsPayrollRunPayload = {
  __typename?: 'ToggleLockCompensationsPayrollRunPayload';
  errors: Array<MutationError>;
  payrollRun?: Maybe<CompensationsPayrollRun>;
};

/** Autogenerated return type of ToggleVisibilityDocumentsDocument. */
export type ToggleVisibilityDocumentsDocumentPayload = {
  __typename?: 'ToggleVisibilityDocumentsDocumentPayload';
  document?: Maybe<DocumentsDocument>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of ToggleVisibilityTrainingsSessionFile. */
export type ToggleVisibilityTrainingsSessionFilePayload = {
  __typename?: 'ToggleVisibilityTrainingsSessionFilePayload';
  errors: Array<MutationError>;
  sessionFile?: Maybe<TrainingsSessionFile>;
};

/** Autogenerated return type of ToggleVisibilityTrainingsTrainingClassFile. */
export type ToggleVisibilityTrainingsTrainingClassFilePayload = {
  __typename?: 'ToggleVisibilityTrainingsTrainingClassFilePayload';
  errors: Array<MutationError>;
  trainingClassFile?: Maybe<TrainingsTrainingClassFile>;
};

/** Autogenerated return type of ToggleVisibilityTrainingsTrainingFile. */
export type ToggleVisibilityTrainingsTrainingFilePayload = {
  __typename?: 'ToggleVisibilityTrainingsTrainingFilePayload';
  errors: Array<MutationError>;
  trainingFile?: Maybe<TrainingsTrainingFile>;
};

/** Autogenerated return type of TotalWithAccessFeaturesFeatureMembership. */
export type TotalWithAccessFeaturesFeatureMembershipPayload = {
  __typename?: 'TotalWithAccessFeaturesFeatureMembershipPayload';
  errors: Array<MutationError>;
  featureMembership?: Maybe<FeaturesFeatureMembership>;
};

export type TrainingsApprover = {
  __typename?: 'TrainingsApprover';
  accessId: Scalars['Int'];
  status: Scalars['String'];
};

export type TrainingsAttachment = {
  __typename?: 'TrainingsAttachment';
  filename?: Maybe<Scalars['String']>;
  signedId?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type TrainingsAttachmentInput = {
  filename?: InputMaybe<Scalars['String']>;
  signedId?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type TrainingsAttendancePct = {
  __typename?: 'TrainingsAttendancePct';
  completedAttendancePct: Scalars['Int'];
  missingAttendancePct: Scalars['Int'];
  notStartedAttendancePct: Scalars['Int'];
  partiallyCompletedAttendancePct: Scalars['Int'];
  startedAttendancePct: Scalars['Int'];
};

/** Training categories */
export type TrainingsCategory = {
  __typename?: 'TrainingsCategory';
  companyId: Scalars['Int'];
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** The connection type for TrainingsCategory. */
export type TrainingsCategoryConnection = {
  __typename?: 'TrainingsCategoryConnection';
  /** A list of edges. */
  edges: Array<TrainingsCategoryEdge>;
  /** A list of nodes. */
  nodes: Array<TrainingsCategory>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TrainingsCategoryEdge = {
  __typename?: 'TrainingsCategoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TrainingsCategory;
};

/** the filter for the categories resource */
export type TrainingsCategoryFilter = {
  name?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<TrainingsCategoryFilterConditions>>;
};

export type TrainingsCategoryFilterConditions = {
  name?: InputMaybe<StringFilter>;
};

/** Trainings category map config */
export type TrainingsCategoryMapConfig = {
  __typename?: 'TrainingsCategoryMapConfig';
  category: TrainingsCategoryMapConfigCategoryEnum;
  categoryMapConfigItems: Array<TrainingsCategoryMapConfigItem>;
  categoryMapConfigItemsConnection: TrainingsCategoryMapConfigItemConnection;
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


/** Trainings category map config */
export type TrainingsCategoryMapConfigCategoryMapConfigItemsArgs = {
  categoryMapConfigId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Trainings category map config */
export type TrainingsCategoryMapConfigCategoryMapConfigItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  categoryMapConfigId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

export type TrainingsCategoryMapConfigCategoryEnum =
  | 'educationlevel'
  | 'professionalcategory';

/** The connection type for TrainingsCategoryMapConfig. */
export type TrainingsCategoryMapConfigConnection = {
  __typename?: 'TrainingsCategoryMapConfigConnection';
  /** A list of edges. */
  edges: Array<TrainingsCategoryMapConfigEdge>;
  /** A list of nodes. */
  nodes: Array<TrainingsCategoryMapConfig>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TrainingsCategoryMapConfigEdge = {
  __typename?: 'TrainingsCategoryMapConfigEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TrainingsCategoryMapConfig;
};

/** Trainings category map config item */
export type TrainingsCategoryMapConfigItem = {
  __typename?: 'TrainingsCategoryMapConfigItem';
  categoryMapConfig?: Maybe<TrainingsCategoryMapConfig>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  categoryMapConfigId: Scalars['Int'];
  companyId: Scalars['Int'];
  field: TrainingsField;
  id: Scalars['Int'];
  value: Scalars['String'];
};


/** Trainings category map config item */
export type TrainingsCategoryMapConfigItemCategoryMapConfigArgs = {
  category?: InputMaybe<TrainingsCategoryMapConfigCategoryEnum>;
};

/** The connection type for TrainingsCategoryMapConfigItem. */
export type TrainingsCategoryMapConfigItemConnection = {
  __typename?: 'TrainingsCategoryMapConfigItemConnection';
  /** A list of edges. */
  edges: Array<TrainingsCategoryMapConfigItemEdge>;
  /** A list of nodes. */
  nodes: Array<TrainingsCategoryMapConfigItem>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TrainingsCategoryMapConfigItemEdge = {
  __typename?: 'TrainingsCategoryMapConfigItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TrainingsCategoryMapConfigItem;
};

/** Completion configuration */
export type TrainingsCompletionConfiguration = {
  __typename?: 'TrainingsCompletionConfiguration';
  attendancePercentage?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  knowledgeTestRequired: Scalars['Boolean'];
  moduleCompletedPercentage?: Maybe<Scalars['Int']>;
  training?: Maybe<TrainingsTraining>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  trainingId: Scalars['Int'];
};


/** Completion configuration */
export type TrainingsCompletionConfigurationTrainingArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  catalog?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  isMandatory?: InputMaybe<Scalars['Boolean']>;
  onlyAssigned?: InputMaybe<Scalars['Boolean']>;
  returnExpiredMemberships?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  withCurrentTrainingClasses?: InputMaybe<Scalars['Boolean']>;
  withExpiredMemberships?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for TrainingsCompletionConfiguration. */
export type TrainingsCompletionConfigurationConnection = {
  __typename?: 'TrainingsCompletionConfigurationConnection';
  /** A list of edges. */
  edges: Array<TrainingsCompletionConfigurationEdge>;
  /** A list of nodes. */
  nodes: Array<TrainingsCompletionConfiguration>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TrainingsCompletionConfigurationEdge = {
  __typename?: 'TrainingsCompletionConfigurationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TrainingsCompletionConfiguration;
};

/** LMS content blocks. */
export type TrainingsContentBlock = {
  __typename?: 'TrainingsContentBlock';
  accesible: Scalars['Boolean'];
  contentModule?: Maybe<TrainingsContentModule>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  contentModuleId: Scalars['Int'];
  contentable?: Maybe<Contentable>;
  contentableId: Scalars['Int'];
  contentableType: Scalars['String'];
  id: Scalars['Int'];
  position: Scalars['Int'];
  progress: Array<TrainingsContentBlockProgress>;
  progressConnection: TrainingsContentBlockProgressConnection;
  status: TrainingsEntitiesContentBlockStatusEnum;
  title: Scalars['String'];
  uuid: Scalars['String'];
};


/** LMS content blocks. */
export type TrainingsContentBlockContentModuleArgs = {
  employeeId?: InputMaybe<Scalars['Int']>;
  trainingIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** LMS content blocks. */
export type TrainingsContentBlockProgressArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** LMS content blocks. */
export type TrainingsContentBlockProgressConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for TrainingsContentBlock. */
export type TrainingsContentBlockConnection = {
  __typename?: 'TrainingsContentBlockConnection';
  /** A list of edges. */
  edges: Array<TrainingsContentBlockEdge>;
  /** A list of nodes. */
  nodes: Array<TrainingsContentBlock>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TrainingsContentBlockEdge = {
  __typename?: 'TrainingsContentBlockEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TrainingsContentBlock;
};

export type TrainingsContentBlockInput = {
  title: Scalars['String'];
  type: Scalars['String'];
  typePage?: InputMaybe<TrainingsContentBlockPageInput>;
  typeQuiz?: InputMaybe<TrainingsContentBlockQuizInput>;
  typeVideo?: InputMaybe<TrainingsContentBlockVideoInput>;
  uuid: Scalars['String'];
};

/** Specific fields for page content blocks */
export type TrainingsContentBlockPage = {
  __typename?: 'TrainingsContentBlockPage';
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  thumbnail?: Maybe<TrainingsAttachment>;
};

/** The connection type for TrainingsContentBlockPage. */
export type TrainingsContentBlockPageConnection = {
  __typename?: 'TrainingsContentBlockPageConnection';
  /** A list of edges. */
  edges: Array<TrainingsContentBlockPageEdge>;
  /** A list of nodes. */
  nodes: Array<TrainingsContentBlockPage>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TrainingsContentBlockPageEdge = {
  __typename?: 'TrainingsContentBlockPageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TrainingsContentBlockPage;
};

export type TrainingsContentBlockPageInput = {
  description: Scalars['String'];
  thumbnail?: InputMaybe<TrainingsAttachmentInput>;
};

/** Content block progress tracking */
export type TrainingsContentBlockProgress = {
  __typename?: 'TrainingsContentBlockProgress';
  completedAt: Scalars['ISO8601DateTime'];
  contentBlockId: Scalars['Int'];
  employeeId: Scalars['Int'];
  id: Scalars['Int'];
};

/** The connection type for TrainingsContentBlockProgress. */
export type TrainingsContentBlockProgressConnection = {
  __typename?: 'TrainingsContentBlockProgressConnection';
  /** A list of edges. */
  edges: Array<TrainingsContentBlockProgressEdge>;
  /** A list of nodes. */
  nodes: Array<TrainingsContentBlockProgress>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TrainingsContentBlockProgressEdge = {
  __typename?: 'TrainingsContentBlockProgressEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TrainingsContentBlockProgress;
};

/** Specific fields for quiz content blocks */
export type TrainingsContentBlockQuiz = {
  __typename?: 'TrainingsContentBlockQuiz';
  description?: Maybe<Scalars['String']>;
  form?: Maybe<FormsForm>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  formId: Scalars['String'];
  id: Scalars['String'];
};


/** Specific fields for quiz content blocks */
export type TrainingsContentBlockQuizFormArgs = {
  formType?: InputMaybe<Array<Scalars['String']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyTemplates?: InputMaybe<Scalars['Boolean']>;
  resourceId?: InputMaybe<Scalars['String']>;
  resourceType: Scalars['String'];
  respondentId?: InputMaybe<Scalars['String']>;
  returnAnswerProgress?: Scalars['Boolean'];
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

/** The connection type for TrainingsContentBlockQuiz. */
export type TrainingsContentBlockQuizConnection = {
  __typename?: 'TrainingsContentBlockQuizConnection';
  /** A list of edges. */
  edges: Array<TrainingsContentBlockQuizEdge>;
  /** A list of nodes. */
  nodes: Array<TrainingsContentBlockQuiz>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TrainingsContentBlockQuizEdge = {
  __typename?: 'TrainingsContentBlockQuizEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TrainingsContentBlockQuiz;
};

export type TrainingsContentBlockQuizInput = {
  form: FormsFormInput;
};

/** Specific fields for video content blocks */
export type TrainingsContentBlockVideo = {
  __typename?: 'TrainingsContentBlockVideo';
  id: Scalars['Int'];
  video?: Maybe<TrainingsAttachment>;
};

/** The connection type for TrainingsContentBlockVideo. */
export type TrainingsContentBlockVideoConnection = {
  __typename?: 'TrainingsContentBlockVideoConnection';
  /** A list of edges. */
  edges: Array<TrainingsContentBlockVideoEdge>;
  /** A list of nodes. */
  nodes: Array<TrainingsContentBlockVideo>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TrainingsContentBlockVideoEdge = {
  __typename?: 'TrainingsContentBlockVideoEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TrainingsContentBlockVideo;
};

export type TrainingsContentBlockVideoInput = {
  video: TrainingsAttachmentInput;
};

/** LMS modules */
export type TrainingsContentModule = {
  __typename?: 'TrainingsContentModule';
  completed: Scalars['Boolean'];
  contentBlocks: Array<TrainingsContentBlock>;
  contentBlocksConnection: TrainingsContentBlockConnection;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  position: Scalars['Int'];
  thumbnail?: Maybe<TrainingsAttachment>;
  title: Scalars['String'];
  training?: Maybe<TrainingsTraining>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  trainingId: Scalars['Int'];
  uuid: Scalars['String'];
};


/** LMS modules */
export type TrainingsContentModuleContentBlocksArgs = {
  employeeId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** LMS modules */
export type TrainingsContentModuleContentBlocksConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** LMS modules */
export type TrainingsContentModuleTrainingArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  catalog?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  isMandatory?: InputMaybe<Scalars['Boolean']>;
  onlyAssigned?: InputMaybe<Scalars['Boolean']>;
  returnExpiredMemberships?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  withCurrentTrainingClasses?: InputMaybe<Scalars['Boolean']>;
  withExpiredMemberships?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for TrainingsContentModule. */
export type TrainingsContentModuleConnection = {
  __typename?: 'TrainingsContentModuleConnection';
  /** A list of edges. */
  edges: Array<TrainingsContentModuleEdge>;
  /** A list of nodes. */
  nodes: Array<TrainingsContentModule>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TrainingsContentModuleEdge = {
  __typename?: 'TrainingsContentModuleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TrainingsContentModule;
};

export type TrainingsContentModuleInput = {
  contentBlocks: Array<TrainingsContentBlockInput>;
  createdAt?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  thumbnail?: InputMaybe<TrainingsAttachmentInput>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['String']>;
  uuid: Scalars['String'];
};

export type TrainingsContextlessPolicies = {
  __typename?: 'TrainingsContextlessPolicies';
  insightRead: ContextlessPolicyResolution;
  settingsManageSettings: ContextlessPolicyResolution;
  sidebarSeeMyRequestsSubLevelItem: ContextlessPolicyResolution;
  sidebarSeeMyTrainingsTopLevelItem: ContextlessPolicyResolution;
  sidebarSeeTrainingsCatalogSubLevelItem: ContextlessPolicyResolution;
  sidebarSeeTrainingsTopLevelItem: ContextlessPolicyResolution;
  trainingCreate: ContextlessPolicyResolution;
  trainingsAccessManagementSpace: ContextlessPolicyResolution;
  trainingsRequestsCreate: ContextlessPolicyResolution;
  trainingsSeeCatalog: ContextlessPolicyResolution;
};

/** Trainings employee relatorio unico field */
export type TrainingsEmployeeRelatorioUnicoField = {
  __typename?: 'TrainingsEmployeeRelatorioUnicoField';
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  employeeId: Scalars['Int'];
  id: Scalars['Int'];
  retirementRegimeApplied?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** The connection type for TrainingsEmployeeRelatorioUnicoField. */
export type TrainingsEmployeeRelatorioUnicoFieldConnection = {
  __typename?: 'TrainingsEmployeeRelatorioUnicoFieldConnection';
  /** A list of edges. */
  edges: Array<TrainingsEmployeeRelatorioUnicoFieldEdge>;
  /** A list of nodes. */
  nodes: Array<TrainingsEmployeeRelatorioUnicoField>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TrainingsEmployeeRelatorioUnicoFieldEdge = {
  __typename?: 'TrainingsEmployeeRelatorioUnicoFieldEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TrainingsEmployeeRelatorioUnicoField;
};

/** Trainings Employees Gross Salary Hour */
export type TrainingsEmployeesGrossSalaryHour = {
  __typename?: 'TrainingsEmployeesGrossSalaryHour';
  data: Array<TrainingsHourlyGrossSalary>;
  id: Scalars['Int'];
  name: Scalars['String'];
  totalSalaryInCents: Scalars['Int'];
};

/** The connection type for TrainingsEmployeesGrossSalaryHour. */
export type TrainingsEmployeesGrossSalaryHourConnection = {
  __typename?: 'TrainingsEmployeesGrossSalaryHourConnection';
  /** A list of edges. */
  edges: Array<TrainingsEmployeesGrossSalaryHourEdge>;
  /** A list of nodes. */
  nodes: Array<TrainingsEmployeesGrossSalaryHour>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TrainingsEmployeesGrossSalaryHourEdge = {
  __typename?: 'TrainingsEmployeesGrossSalaryHourEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TrainingsEmployeesGrossSalaryHour;
};

export type TrainingsEmployeesWithMore40h = {
  __typename?: 'TrainingsEmployeesWithMore40h';
  less40hEmployees: Scalars['Int'];
  more40hEmployees: Scalars['Int'];
};

export type TrainingsEntitiesContentBlockStatusEnum =
  | 'completed'
  | 'inprogress'
  | 'notstarted';

/** Trainings export */
export type TrainingsExport = {
  __typename?: 'TrainingsExport';
  success: Scalars['Boolean'];
};

/** Autogenerated return type of TrainingsExportTrainingsExport. */
export type TrainingsExportTrainingsExportPayload = {
  __typename?: 'TrainingsExportTrainingsExportPayload';
  errors: Array<MutationError>;
  export?: Maybe<TrainingsExport>;
};

export type TrainingsField = {
  __typename?: 'TrainingsField';
  fieldId: Scalars['Int'];
  fieldType: Scalars['String'];
  fieldValue: Scalars['String'];
};

/** Fundae finish group */
export type TrainingsFundaeFinishGroup = {
  __typename?: 'TrainingsFundaeFinishGroup';
  access?: Maybe<ApiCoreAccess>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  accessId: Scalars['Int'];
  certificate: Scalars['Boolean'];
  id: Scalars['Int'];
  missingData: Scalars['Boolean'];
};


/** Fundae finish group */
export type TrainingsFundaeFinishGroupAccessArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for TrainingsFundaeFinishGroup. */
export type TrainingsFundaeFinishGroupConnection = {
  __typename?: 'TrainingsFundaeFinishGroupConnection';
  /** A list of edges. */
  edges: Array<TrainingsFundaeFinishGroupEdge>;
  /** A list of nodes. */
  nodes: Array<TrainingsFundaeFinishGroup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TrainingsFundaeFinishGroupEdge = {
  __typename?: 'TrainingsFundaeFinishGroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TrainingsFundaeFinishGroup;
};

/** the filter for the fundae_finish_groups resource */
export type TrainingsFundaeFinishGroupFilter = {
  id?: InputMaybe<IntegerFilter>;
  missingData?: InputMaybe<BooleanFilter>;
  or?: InputMaybe<Array<TrainingsFundaeFinishGroupFilterConditions>>;
};

export type TrainingsFundaeFinishGroupFilterConditions = {
  id?: InputMaybe<IntegerFilter>;
  missingData?: InputMaybe<BooleanFilter>;
};

export type TrainingsHourlyGrossSalary = {
  __typename?: 'TrainingsHourlyGrossSalary';
  hourlyGrossSalaryInCents: Scalars['Int'];
  range: Scalars['String'];
};

/** Insights */
export type TrainingsInsight = {
  __typename?: 'TrainingsInsight';
  attendancePct?: Maybe<TrainingsAttendancePct>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  employeeIds: Array<Scalars['Int']>;
  employees: Array<EmployeesEmployee>;
  employeesConnection: EmployeesEmployeeConnection;
  employeesWithMore40h?: Maybe<TrainingsEmployeesWithMore40h>;
  totalDuration?: Maybe<Scalars['Float']>;
  trainedEmployeesByGender?: Maybe<Array<TrainingsTrainedEmployeesByGender>>;
  trainedEmployeesByTeam?: Maybe<Array<TrainingsTrainedEmployeesByTeam>>;
  trainingHours?: Maybe<TrainingsTrainingHours>;
  trainingHoursPerEmployee?: Maybe<Array<TrainingsTrainingHoursPerEmployee>>;
  trainingsEmployees?: Maybe<TrainingsTrainingsEmployees>;
  trainingsHoursAndCost?: Maybe<TrainingsTrainingsHoursAndCost>;
};


/** Insights */
export type TrainingsInsightEmployeesArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Insights */
export type TrainingsInsightEmployeesConnectionArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  after?: InputMaybe<Scalars['String']>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Sort>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for TrainingsInsight. */
export type TrainingsInsightConnection = {
  __typename?: 'TrainingsInsightConnection';
  /** A list of edges. */
  edges: Array<TrainingsInsightEdge>;
  /** A list of nodes. */
  nodes: Array<TrainingsInsight>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TrainingsInsightEdge = {
  __typename?: 'TrainingsInsightEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TrainingsInsight;
};

/** Learning platform */
export type TrainingsLearningPlatform = {
  __typename?: 'TrainingsLearningPlatform';
  companyId: Scalars['Int'];
  duration?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['ISO8601Date']>;
  id: Scalars['Int'];
  link?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['ISO8601Date']>;
  trainingId: Scalars['Int'];
};

/** The connection type for TrainingsLearningPlatform. */
export type TrainingsLearningPlatformConnection = {
  __typename?: 'TrainingsLearningPlatformConnection';
  /** A list of edges. */
  edges: Array<TrainingsLearningPlatformEdge>;
  /** A list of nodes. */
  nodes: Array<TrainingsLearningPlatform>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TrainingsLearningPlatformEdge = {
  __typename?: 'TrainingsLearningPlatformEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TrainingsLearningPlatform;
};

/** Trainings reminder */
export type TrainingsReminder = {
  __typename?: 'TrainingsReminder';
  completed: Scalars['Boolean'];
  content?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  scheduledAt: Scalars['ISO8601DateTime'];
  timeframe?: Maybe<TrainingsReminderTimeframeEnum>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** The connection type for TrainingsReminder. */
export type TrainingsReminderConnection = {
  __typename?: 'TrainingsReminderConnection';
  /** A list of edges. */
  edges: Array<TrainingsReminderEdge>;
  /** A list of nodes. */
  nodes: Array<TrainingsReminder>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TrainingsReminderEdge = {
  __typename?: 'TrainingsReminderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TrainingsReminder;
};

export type TrainingsReminderTimeframeEnum =
  | 'custom'
  | 'oneday'
  | 'onehour'
  | 'oneweek'
  | 'threedays'
  | 'twodays';

/** Training sessions */
export type TrainingsSession = {
  __typename?: 'TrainingsSession';
  /** Session description */
  description?: Maybe<Scalars['String']>;
  /** Date when the session should end */
  dueDate?: Maybe<Scalars['ISO8601Date']>;
  /** The duration in hours and minutes of the session */
  duration?: Maybe<Scalars['String']>;
  /** Date when the session should end */
  endsAt?: Maybe<Scalars['ISO8601DateTime']>;
  frequency?: Maybe<TrainingsSessionFrequencyEnum>;
  /** id of the session */
  id: Scalars['Int'];
  /** The link to see material from the session */
  link?: Maybe<Scalars['String']>;
  /** The place where the session takes place */
  location?: Maybe<Scalars['String']>;
  /** The mode the session will be handled, online, in person or hybrid. */
  modality?: Maybe<TrainingsSessionModalityEnum>;
  name: Scalars['String'];
  /** Id of the recurrent session that is parent of the current one */
  parentId?: Maybe<Scalars['Int']>;
  recurrent?: Maybe<Scalars['Boolean']>;
  /** Session schedule information (scheduled, self-paced) */
  schedule?: Maybe<TrainingsSessionScheduleEnum>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  sessionAttendanceIds?: Maybe<Array<Scalars['Int']>>;
  sessionAttendances: Array<TrainingsSessionAttendance>;
  sessionAttendancesConnection: TrainingsSessionAttendanceConnection;
  sessionAttendancesStatus: Array<Scalars['String']>;
  sessionFeedbackId?: Maybe<Scalars['Int']>;
  /** List of session instructor IDs assigned to this session */
  sessionInstructorIds: Array<Scalars['String']>;
  sessionInstructors: Array<TrainingsSessionInstructor>;
  sessionInstructorsConnection: TrainingsSessionInstructorConnection;
  sessionRelatorioUnicoField?: Maybe<TrainingsSessionRelatorioUnicoField>;
  /** Date when the session should start */
  startsAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Status of the session */
  status?: Maybe<Scalars['String']>;
  /** if the session is subsidized */
  subsidized: Scalars['Boolean'];
  training?: Maybe<TrainingsTraining>;
  /** Identifier of the group */
  trainingClassId?: Maybe<Scalars['String']>;
  /**
   * Identifier of the course
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  trainingId: Scalars['Int'];
};


/** Training sessions */
export type TrainingsSessionSessionAttendancesArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  id?: InputMaybe<Scalars['Int']>;
  sessionAccessMembershipIds?: InputMaybe<Array<Scalars['Int']>>;
  sessionId?: InputMaybe<Scalars['Int']>;
};


/** Training sessions */
export type TrainingsSessionSessionAttendancesConnectionArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sessionAccessMembershipIds?: InputMaybe<Array<Scalars['Int']>>;
  sessionId?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Training sessions */
export type TrainingsSessionSessionInstructorsArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  employeeId?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  sessionId?: InputMaybe<Scalars['String']>;
};


/** Training sessions */
export type TrainingsSessionSessionInstructorsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  employeeId?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sessionId?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Training sessions */
export type TrainingsSessionSessionRelatorioUnicoFieldArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Training sessions */
export type TrainingsSessionTrainingArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  catalog?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  isMandatory?: InputMaybe<Scalars['Boolean']>;
  onlyAssigned?: InputMaybe<Scalars['Boolean']>;
  returnExpiredMemberships?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  withCurrentTrainingClasses?: InputMaybe<Scalars['Boolean']>;
  withExpiredMemberships?: InputMaybe<Scalars['Boolean']>;
};

/** Session memberships */
export type TrainingsSessionAccessMembership = {
  __typename?: 'TrainingsSessionAccessMembership';
  access?: Maybe<ApiCoreAccess>;
  /**
   * ID of the access associated with this membership
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  accessId: Scalars['Int'];
  /** ID of the employee associated with this membership */
  employeeId?: Maybe<Scalars['Int']>;
  /** First name of the user associated with this membership */
  firstName?: Maybe<Scalars['String']>;
  /** ID of this membership */
  id: Scalars['Int'];
  /** Job title of the user associated with this membership */
  jobTitle?: Maybe<Scalars['String']>;
  /** Last name of the user associated with this membership */
  lastName?: Maybe<Scalars['String']>;
  sessionAttendance?: Maybe<TrainingsSessionAttendance>;
  sessionAttendanceStatus: Scalars['String'];
  /** ID of the session associated with this membership */
  sessionId: Scalars['Int'];
  teamId: Scalars['Int'];
};


/** Session memberships */
export type TrainingsSessionAccessMembershipAccessArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** Session memberships */
export type TrainingsSessionAccessMembershipSessionAttendanceArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  sessionId?: InputMaybe<Scalars['Int']>;
};

/** The connection type for TrainingsSessionAccessMembership. */
export type TrainingsSessionAccessMembershipConnection = {
  __typename?: 'TrainingsSessionAccessMembershipConnection';
  /** A list of edges. */
  edges: Array<TrainingsSessionAccessMembershipEdge>;
  /** A list of nodes. */
  nodes: Array<TrainingsSessionAccessMembership>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TrainingsSessionAccessMembershipEdge = {
  __typename?: 'TrainingsSessionAccessMembershipEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TrainingsSessionAccessMembership;
};

/** the filter for the session_access_memberships resource */
export type TrainingsSessionAccessMembershipFilter = {
  accessId?: InputMaybe<IntegerFilter>;
  firstName?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<TrainingsSessionAccessMembershipFilterConditions>>;
  sessionAttendanceStatus?: InputMaybe<StringFilter>;
  teamId?: InputMaybe<IntegerFilter>;
};

export type TrainingsSessionAccessMembershipFilterConditions = {
  accessId?: InputMaybe<IntegerFilter>;
  firstName?: InputMaybe<StringFilter>;
  sessionAttendanceStatus?: InputMaybe<StringFilter>;
  teamId?: InputMaybe<IntegerFilter>;
};

/** Session attendances */
export type TrainingsSessionAttendance = {
  __typename?: 'TrainingsSessionAttendance';
  _policies?: Maybe<TrainingsSessionAttendancePolicies>;
  _policiesCollection?: Maybe<Array<PermissionsPolicyResolution>>;
  _policiesConnection: PermissionsPolicyResolutionConnection;
  accessId: Scalars['Int'];
  employeeId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  sessionAccessMembershipId: Scalars['Int'];
  status: TrainingsSessionAttendanceStatusEnum;
};


/** Session attendances */
export type TrainingsSessionAttendance_PoliciesCollectionArgs = {
  ids: Array<TrainingsSessionAttendancePoliciesEnum>;
};


/** Session attendances */
export type TrainingsSessionAttendance_PoliciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for TrainingsSessionAttendance. */
export type TrainingsSessionAttendanceConnection = {
  __typename?: 'TrainingsSessionAttendanceConnection';
  /** A list of edges. */
  edges: Array<TrainingsSessionAttendanceEdge>;
  /** A list of nodes. */
  nodes: Array<TrainingsSessionAttendance>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TrainingsSessionAttendanceEdge = {
  __typename?: 'TrainingsSessionAttendanceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TrainingsSessionAttendance;
};

export type TrainingsSessionAttendancePolicies = {
  __typename?: 'TrainingsSessionAttendancePolicies';
  edit: PermissionsPolicyResolution;
};

export type TrainingsSessionAttendancePoliciesEnum =
  | 'edit';

export type TrainingsSessionAttendanceStatusEnum =
  | 'completed'
  | 'inprogress'
  | 'missing'
  | 'pending';

/** The connection type for TrainingsSession. */
export type TrainingsSessionConnection = {
  __typename?: 'TrainingsSessionConnection';
  /** A list of edges. */
  edges: Array<TrainingsSessionEdge>;
  /** A list of nodes. */
  nodes: Array<TrainingsSession>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TrainingsSessionEdge = {
  __typename?: 'TrainingsSessionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TrainingsSession;
};

/** Trainings session file */
export type TrainingsSessionFile = {
  __typename?: 'TrainingsSessionFile';
  authorId: Scalars['Int'];
  contentType: Scalars['String'];
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  filename: Scalars['String'];
  id: Scalars['Int'];
  sessionId: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  url: Scalars['String'];
  visibility: Scalars['Boolean'];
};

/** The connection type for TrainingsSessionFile. */
export type TrainingsSessionFileConnection = {
  __typename?: 'TrainingsSessionFileConnection';
  /** A list of edges. */
  edges: Array<TrainingsSessionFileEdge>;
  /** A list of nodes. */
  nodes: Array<TrainingsSessionFile>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TrainingsSessionFileEdge = {
  __typename?: 'TrainingsSessionFileEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TrainingsSessionFile;
};

/** the filter for the sessions resource */
export type TrainingsSessionFilter = {
  dueDate?: InputMaybe<DateFilter>;
  duration?: InputMaybe<StringFilter>;
  endsAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntegerFilter>;
  modality?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<TrainingsSessionFilterConditions>>;
  sessionAttendancesStatus?: InputMaybe<StringFilter>;
  startsAt?: InputMaybe<DateTimeFilter>;
};

export type TrainingsSessionFilterConditions = {
  dueDate?: InputMaybe<DateFilter>;
  duration?: InputMaybe<StringFilter>;
  endsAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntegerFilter>;
  modality?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  sessionAttendancesStatus?: InputMaybe<StringFilter>;
  startsAt?: InputMaybe<DateTimeFilter>;
};

export type TrainingsSessionFrequencyEnum =
  | 'daily'
  | 'monthly'
  | 'weekly';

/** Trainings Session Instructor */
export type TrainingsSessionInstructor = {
  __typename?: 'TrainingsSessionInstructor';
  company: ApiCoreCompany;
  /**
   * Company identifier
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  companyId: Scalars['Int'];
  employee: EmployeesEmployee;
  /**
   * Employee identifier who is the instructor
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  employeeId: Scalars['Int'];
  /** Session instructor identifier */
  id: Scalars['String'];
  /** Training session identifier */
  sessionId: Scalars['Int'];
  sessions?: Maybe<TrainingsSession>;
};


/** Trainings Session Instructor */
export type TrainingsSessionInstructorEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Trainings Session Instructor */
export type TrainingsSessionInstructorSessionsArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  active?: InputMaybe<Scalars['Boolean']>;
  modality?: InputMaybe<Scalars['String']>;
  next?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  startAfter?: InputMaybe<Scalars['String']>;
  startBefore?: InputMaybe<Scalars['String']>;
  startsAt?: InputMaybe<Array<Scalars['String']>>;
  trainingClassIds?: InputMaybe<Array<Scalars['String']>>;
  trainingId?: InputMaybe<Scalars['Int']>;
  trainingIds?: InputMaybe<Array<Scalars['Int']>>;
};

/** The connection type for TrainingsSessionInstructor. */
export type TrainingsSessionInstructorConnection = {
  __typename?: 'TrainingsSessionInstructorConnection';
  /** A list of edges. */
  edges: Array<TrainingsSessionInstructorEdge>;
  /** A list of nodes. */
  nodes: Array<TrainingsSessionInstructor>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TrainingsSessionInstructorEdge = {
  __typename?: 'TrainingsSessionInstructorEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TrainingsSessionInstructor;
};

export type TrainingsSessionModalityEnum =
  | 'inperson'
  | 'mixed'
  | 'online';

/** Trainings session relatorio unico field */
export type TrainingsSessionRelatorioUnicoField = {
  __typename?: 'TrainingsSessionRelatorioUnicoField';
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['Int'];
  sessionId: Scalars['Int'];
  trainingSchedule?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** The connection type for TrainingsSessionRelatorioUnicoField. */
export type TrainingsSessionRelatorioUnicoFieldConnection = {
  __typename?: 'TrainingsSessionRelatorioUnicoFieldConnection';
  /** A list of edges. */
  edges: Array<TrainingsSessionRelatorioUnicoFieldEdge>;
  /** A list of nodes. */
  nodes: Array<TrainingsSessionRelatorioUnicoField>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TrainingsSessionRelatorioUnicoFieldEdge = {
  __typename?: 'TrainingsSessionRelatorioUnicoFieldEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TrainingsSessionRelatorioUnicoField;
};

export type TrainingsSessionScheduleEnum =
  | 'scheduled'
  | 'selfpaced';

export type TrainingsSessionUpdateStrategyEnum =
  | 'all'
  | 'future'
  | 'individually';

/** Trainings setting */
export type TrainingsSetting = {
  __typename?: 'TrainingsSetting';
  companyId: Scalars['Int'];
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['Int'];
  relatorioEnabled?: Maybe<Scalars['Boolean']>;
  trainingRequestsEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** The connection type for TrainingsSetting. */
export type TrainingsSettingConnection = {
  __typename?: 'TrainingsSettingConnection';
  /** A list of edges. */
  edges: Array<TrainingsSettingEdge>;
  /** A list of nodes. */
  nodes: Array<TrainingsSetting>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TrainingsSettingEdge = {
  __typename?: 'TrainingsSettingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TrainingsSetting;
};

export type TrainingsTrainedEmployeesByGender = {
  __typename?: 'TrainingsTrainedEmployeesByGender';
  employeeCount: Scalars['Int'];
  gender?: Maybe<Scalars['String']>;
};

export type TrainingsTrainedEmployeesByTeam = {
  __typename?: 'TrainingsTrainedEmployeesByTeam';
  employeeCount: Scalars['Int'];
  teamId: Scalars['Int'];
  teamName?: Maybe<Scalars['String']>;
};

/** Trainings */
export type TrainingsTraining = {
  __typename?: 'TrainingsTraining';
  _policies?: Maybe<TrainingsTrainingPolicies>;
  _policiesCollection?: Maybe<Array<PermissionsPolicyResolution>>;
  _policiesConnection: PermissionsPolicyResolutionConnection;
  accessId: Scalars['Int'];
  /** The person that creates the training */
  authorId: Scalars['Int'];
  /** Visible in catalog */
  catalog: Scalars['Boolean'];
  categories: Array<TrainingsCategory>;
  categoriesConnection: TrainingsCategoryConnection;
  categoryId: Scalars['Int'];
  /**
   * List of ids of training categories
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  categoryIds?: Maybe<Array<Scalars['Int']>>;
  /** Code of the training */
  code?: Maybe<Scalars['String']>;
  codigoCurso?: Maybe<Scalars['String']>;
  /** Company identifier */
  companyId: Scalars['Int'];
  competencies: Array<CompetenciesCompetency>;
  competenciesConnection: CompetenciesCompetencyConnection;
  competencyId: Scalars['Int'];
  /**
   * List of ids of training competencies
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  competencyIds: Array<Scalars['Int']>;
  completionConfiguration?: Maybe<TrainingsCompletionConfiguration>;
  contentModules: Array<TrainingsContentModule>;
  contentModulesConnection: TrainingsContentModuleConnection;
  cost: Scalars['Int'];
  costDecimal: Scalars['String'];
  /** Creation date of the course */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Description of the training */
  description: Scalars['String'];
  expediente?: Maybe<Scalars['String']>;
  /** External training */
  external: Scalars['Boolean'];
  /** The name of the provider if any */
  externalProvider?: Maybe<Scalars['String']>;
  filename?: Maybe<Scalars['String']>;
  /** Subsidized by Fundae */
  fundaeSubsidized: Scalars['Boolean'];
  /** Identifier of the course */
  id: Scalars['Int'];
  /** This field is used to define if the training is mandatory or not */
  isMandatory: Scalars['Boolean'];
  learningPlatform?: Maybe<TrainingsLearningPlatform>;
  modality: Scalars['String'];
  /** Name of the training */
  name: Scalars['String'];
  /**
   * Number of participants that have the course expired or about to expire in the
   * next 3 months. Only applicable to trainings with validity period.
   */
  numberOfExpiredParticipants?: Maybe<Scalars['Int']>;
  /** Objectives of the course */
  objectives?: Maybe<Scalars['String']>;
  perfil?: Maybe<Scalars['String']>;
  processId?: Maybe<Scalars['Int']>;
  relatorioUnicoField?: Maybe<TrainingsTrainingRelatorioUnicoField>;
  sessions: Array<TrainingsSession>;
  sessionsConnection: TrainingsSessionConnection;
  /** Training status. Can be one of the following values */
  status?: Maybe<TrainingsTrainingStatusEnum>;
  /** Marked as subsidized */
  subsidized: Scalars['Boolean'];
  subsidizedCost: Scalars['Int'];
  subsidizedCostDecimal: Scalars['String'];
  thumbnail?: Maybe<Scalars['String']>;
  totalCost?: Maybe<Scalars['Int']>;
  totalCostDecimal?: Maybe<Scalars['String']>;
  /** The total duration in hours and minutes of the course */
  totalDuration: Scalars['Float'];
  /** Number of participants of all course's groups */
  totalParticipants: Scalars['Int'];
  /** The total direct cost of all course's groups */
  totalTrainingCost: Scalars['String'];
  /** The total indirect cost of all course's groups */
  totalTrainingIndirectCost: Scalars['String'];
  /** The total salary cost of all course's groups */
  totalTrainingSalaryCost: Scalars['String'];
  /** The total subsidized cost of all course's groups */
  totalTrainingSubsidizedCost: Scalars['String'];
  trainingAttendanceStatus: TrainingsTrainingMembershipStatusEnum;
  trainingClasses: Array<TrainingsTrainingClass>;
  trainingClassesConnection: TrainingsTrainingClassConnection;
  trainingFiles: Array<TrainingsTrainingFile>;
  trainingFilesConnection: TrainingsTrainingFileConnection;
  trainingLinks: Array<TrainingsTrainingLink>;
  trainingLinksConnection: TrainingsTrainingLinkConnection;
  /** The modality of the training determined based on sessions and content */
  trainingModality: TrainingsSessionModalityEnum;
  /** Last modification date of the course */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Number of years this course is valid for */
  validFor?: Maybe<Scalars['Int']>;
  /** Year of the training */
  year: Scalars['Int'];
};


/** Trainings */
export type TrainingsTraining_PoliciesCollectionArgs = {
  ids: Array<TrainingsTrainingPoliciesEnum>;
};


/** Trainings */
export type TrainingsTraining_PoliciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Trainings */
export type TrainingsTrainingCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Trainings */
export type TrainingsTrainingCompetenciesArgs = {
  competencyGroupIds?: InputMaybe<Array<Scalars['String']>>;
  everyone?: InputMaybe<Scalars['Boolean']>;
  roleIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  withDeleted?: InputMaybe<Scalars['Boolean']>;
};


/** Trainings */
export type TrainingsTrainingCompetenciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  competencyGroupIds?: InputMaybe<Array<Scalars['String']>>;
  everyone?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  roleIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  withDeleted?: InputMaybe<Scalars['Boolean']>;
};


/** Trainings */
export type TrainingsTrainingCompletionConfigurationArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Trainings */
export type TrainingsTrainingContentModulesArgs = {
  employeeId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Trainings */
export type TrainingsTrainingContentModulesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Trainings */
export type TrainingsTrainingLearningPlatformArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  trainingId: Scalars['Int'];
};


/** Trainings */
export type TrainingsTrainingRelatorioUnicoFieldArgs = {
  trainingId?: InputMaybe<Scalars['Int']>;
};


/** Trainings */
export type TrainingsTrainingSessionsArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  active?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  modality?: InputMaybe<Scalars['String']>;
  next?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  startAfter?: InputMaybe<Scalars['String']>;
  startBefore?: InputMaybe<Scalars['String']>;
  startsAt?: InputMaybe<Array<Scalars['String']>>;
  trainingClassIds?: InputMaybe<Array<Scalars['String']>>;
  trainingId?: InputMaybe<Scalars['Int']>;
};


/** Trainings */
export type TrainingsTrainingSessionsConnectionArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  modality?: InputMaybe<Scalars['String']>;
  next?: InputMaybe<Scalars['Boolean']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  startAfter?: InputMaybe<Scalars['String']>;
  startBefore?: InputMaybe<Scalars['String']>;
  startsAt?: InputMaybe<Array<Scalars['String']>>;
  trainingClassIds?: InputMaybe<Array<Scalars['String']>>;
  trainingId?: InputMaybe<Scalars['Int']>;
};


/** Trainings */
export type TrainingsTrainingTrainingClassesArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  endDate?: InputMaybe<Array<Scalars['ISO8601Date']>>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Array<Scalars['ISO8601Date']>>;
  trainingId?: InputMaybe<Scalars['Int']>;
};


/** Trainings */
export type TrainingsTrainingTrainingClassesConnectionArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Array<Scalars['ISO8601Date']>>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  startDate?: InputMaybe<Array<Scalars['ISO8601Date']>>;
  trainingId?: InputMaybe<Scalars['Int']>;
};


/** Trainings */
export type TrainingsTrainingTrainingFilesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  trainingId: Scalars['Int'];
  visibility?: InputMaybe<Scalars['Boolean']>;
};


/** Trainings */
export type TrainingsTrainingTrainingFilesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  trainingId: Scalars['Int'];
  visibility?: InputMaybe<Scalars['Boolean']>;
};


/** Trainings */
export type TrainingsTrainingTrainingLinksArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  trainingId?: InputMaybe<Scalars['Int']>;
  url?: InputMaybe<Scalars['String']>;
};


/** Trainings */
export type TrainingsTrainingTrainingLinksConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  title?: InputMaybe<Scalars['String']>;
  trainingId?: InputMaybe<Scalars['Int']>;
  url?: InputMaybe<Scalars['String']>;
};

/** Training classes */
export type TrainingsTrainingClass = {
  __typename?: 'TrainingsTrainingClass';
  classFiles: Array<TrainingsTrainingClassFile>;
  classFilesConnection: TrainingsTrainingClassFileConnection;
  classLinks: Array<TrainingsTrainingClassLink>;
  classLinksConnection: TrainingsTrainingClassLinkConnection;
  classMemberships: Array<TrainingsTrainingClassMembership>;
  classMembershipsConnection: TrainingsTrainingClassMembershipConnection;
  /** Number of completed session attendances in this group. */
  completedAttendancesCount: Scalars['Int'];
  /** Training-related expenses, such as instructor fees, materials, venue, and logistics. */
  cost: Scalars['String'];
  /** Class description */
  description?: Maybe<Scalars['String']>;
  /** Traning class end date */
  endDate?: Maybe<Scalars['ISO8601Date']>;
  fundaeConfig?: Maybe<TrainingsTrainingClassFundaeConfiguration>;
  /** Identifier of the training to which the class belongs to */
  id: Scalars['String'];
  /** General business expenses related to training, such as utilities and administrative fees. */
  indirectCost: Scalars['String'];
  learningPlatform?: Maybe<TrainingsLearningPlatform>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  learningPlatformId?: Maybe<Scalars['Int']>;
  materializedForms: Array<FormsMaterializedForm>;
  materializedFormsConnection: FormsMaterializedFormConnection;
  mode: TrainingsTrainingClassModalityEnum;
  /** Class name */
  name: Scalars['String'];
  /** Cost of all employees' time spent on the course. */
  salaryCost: Scalars['String'];
  sessions: Array<TrainingsSession>;
  sessionsConnection: TrainingsSessionConnection;
  /** Traning class start date */
  startDate?: Maybe<Scalars['ISO8601Date']>;
  /** Amount of training expenses covered by financial aid or grants for this group. */
  subsidizedCost: Scalars['String'];
  /** Total number of session attendances expected in this group. */
  totalAttendancesCount: Scalars['Int'];
  training?: Maybe<TrainingsTraining>;
  /**
   * Identifier of the course
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  trainingId: Scalars['Int'];
};


/** Training classes */
export type TrainingsTrainingClassClassFilesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  trainingIds?: InputMaybe<Array<Scalars['Int']>>;
  visibility?: InputMaybe<Scalars['Boolean']>;
};


/** Training classes */
export type TrainingsTrainingClassClassFilesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  trainingIds?: InputMaybe<Array<Scalars['Int']>>;
  visibility?: InputMaybe<Scalars['Boolean']>;
};


/** Training classes */
export type TrainingsTrainingClassClassLinksArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  trainingClassId?: InputMaybe<Scalars['Int']>;
  url?: InputMaybe<Scalars['String']>;
};


/** Training classes */
export type TrainingsTrainingClassClassLinksConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  title?: InputMaybe<Scalars['String']>;
  trainingClassId?: InputMaybe<Scalars['Int']>;
  url?: InputMaybe<Scalars['String']>;
};


/** Training classes */
export type TrainingsTrainingClassClassMembershipsArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  trainingClassId?: InputMaybe<Scalars['Int']>;
};


/** Training classes */
export type TrainingsTrainingClassClassMembershipsConnectionArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  trainingClassId?: InputMaybe<Scalars['Int']>;
};


/** Training classes */
export type TrainingsTrainingClassFundaeConfigArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Training classes */
export type TrainingsTrainingClassLearningPlatformArgs = {
  trainingId: Scalars['Int'];
};


/** Training classes */
export type TrainingsTrainingClassMaterializedFormsArgs = {
  cycleIds?: InputMaybe<Array<Scalars['String']>>;
  formId?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  respondentId?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


/** Training classes */
export type TrainingsTrainingClassMaterializedFormsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  cycleIds?: InputMaybe<Array<Scalars['String']>>;
  first?: InputMaybe<Scalars['Int']>;
  formId?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  respondentId?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Training classes */
export type TrainingsTrainingClassSessionsArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  active?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  modality?: InputMaybe<Scalars['String']>;
  next?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  startAfter?: InputMaybe<Scalars['String']>;
  startBefore?: InputMaybe<Scalars['String']>;
  startsAt?: InputMaybe<Array<Scalars['String']>>;
  trainingId?: InputMaybe<Scalars['Int']>;
  trainingIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Training classes */
export type TrainingsTrainingClassSessionsConnectionArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  modality?: InputMaybe<Scalars['String']>;
  next?: InputMaybe<Scalars['Boolean']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  startAfter?: InputMaybe<Scalars['String']>;
  startBefore?: InputMaybe<Scalars['String']>;
  startsAt?: InputMaybe<Array<Scalars['String']>>;
  trainingId?: InputMaybe<Scalars['Int']>;
  trainingIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Training classes */
export type TrainingsTrainingClassTrainingArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  catalog?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  isMandatory?: InputMaybe<Scalars['Boolean']>;
  onlyAssigned?: InputMaybe<Scalars['Boolean']>;
  returnExpiredMemberships?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  withCurrentTrainingClasses?: InputMaybe<Scalars['Boolean']>;
  withExpiredMemberships?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for TrainingsTrainingClass. */
export type TrainingsTrainingClassConnection = {
  __typename?: 'TrainingsTrainingClassConnection';
  /** A list of edges. */
  edges: Array<TrainingsTrainingClassEdge>;
  /** A list of nodes. */
  nodes: Array<TrainingsTrainingClass>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TrainingsTrainingClassEdge = {
  __typename?: 'TrainingsTrainingClassEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TrainingsTrainingClass;
};

/** Training class files */
export type TrainingsTrainingClassFile = {
  __typename?: 'TrainingsTrainingClassFile';
  authorId: Scalars['Int'];
  contentType: Scalars['String'];
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  filename: Scalars['String'];
  id: Scalars['Int'];
  size: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  trainingClassId: Scalars['String'];
  url: Scalars['String'];
  visibility: Scalars['Boolean'];
};

/** The connection type for TrainingsTrainingClassFile. */
export type TrainingsTrainingClassFileConnection = {
  __typename?: 'TrainingsTrainingClassFileConnection';
  /** A list of edges. */
  edges: Array<TrainingsTrainingClassFileEdge>;
  /** A list of nodes. */
  nodes: Array<TrainingsTrainingClassFile>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TrainingsTrainingClassFileEdge = {
  __typename?: 'TrainingsTrainingClassFileEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TrainingsTrainingClassFile;
};

/** the filter for the training_classes resource */
export type TrainingsTrainingClassFilter = {
  completedAttendancesCount?: InputMaybe<IntegerFilter>;
  endDate?: InputMaybe<DateFilter>;
  or?: InputMaybe<Array<TrainingsTrainingClassFilterConditions>>;
  startDate?: InputMaybe<DateFilter>;
  totalAttendancesCount?: InputMaybe<IntegerFilter>;
};

export type TrainingsTrainingClassFilterConditions = {
  completedAttendancesCount?: InputMaybe<IntegerFilter>;
  endDate?: InputMaybe<DateFilter>;
  startDate?: InputMaybe<DateFilter>;
  totalAttendancesCount?: InputMaybe<IntegerFilter>;
};

/** Trainings training class fundae configuration */
export type TrainingsTrainingClassFundaeConfiguration = {
  __typename?: 'TrainingsTrainingClassFundaeConfiguration';
  codigoGrupo: Scalars['String'];
  id: Scalars['Int'];
  trainingClass?: Maybe<TrainingsTrainingClass>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  trainingClassId: Scalars['String'];
};


/** Trainings training class fundae configuration */
export type TrainingsTrainingClassFundaeConfigurationTrainingClassArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  endDate?: InputMaybe<Array<Scalars['ISO8601Date']>>;
  id?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Array<Scalars['ISO8601Date']>>;
  trainingId?: InputMaybe<Scalars['Int']>;
};

/** The connection type for TrainingsTrainingClassFundaeConfiguration. */
export type TrainingsTrainingClassFundaeConfigurationConnection = {
  __typename?: 'TrainingsTrainingClassFundaeConfigurationConnection';
  /** A list of edges. */
  edges: Array<TrainingsTrainingClassFundaeConfigurationEdge>;
  /** A list of nodes. */
  nodes: Array<TrainingsTrainingClassFundaeConfiguration>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TrainingsTrainingClassFundaeConfigurationEdge = {
  __typename?: 'TrainingsTrainingClassFundaeConfigurationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TrainingsTrainingClassFundaeConfiguration;
};

export type TrainingsTrainingClassFundaeConfigurationInput = {
  codigoGrupo: Scalars['String'];
};

/** Training class links */
export type TrainingsTrainingClassLink = {
  __typename?: 'TrainingsTrainingClassLink';
  authorId: Scalars['Int'];
  companyId: Scalars['Int'];
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['Int'];
  title: Scalars['String'];
  trainingClassId: Scalars['String'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  url: Scalars['String'];
};

/** The connection type for TrainingsTrainingClassLink. */
export type TrainingsTrainingClassLinkConnection = {
  __typename?: 'TrainingsTrainingClassLinkConnection';
  /** A list of edges. */
  edges: Array<TrainingsTrainingClassLinkEdge>;
  /** A list of nodes. */
  nodes: Array<TrainingsTrainingClassLink>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TrainingsTrainingClassLinkEdge = {
  __typename?: 'TrainingsTrainingClassLinkEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TrainingsTrainingClassLink;
};

/** Training class memberships */
export type TrainingsTrainingClassMembership = {
  __typename?: 'TrainingsTrainingClassMembership';
  access?: Maybe<ApiCoreAccess>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  accessId: Scalars['Int'];
  id: Scalars['Int'];
  teamId: Scalars['Int'];
  trainingClassId: Scalars['String'];
};


/** Training class memberships */
export type TrainingsTrainingClassMembershipAccessArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for TrainingsTrainingClassMembership. */
export type TrainingsTrainingClassMembershipConnection = {
  __typename?: 'TrainingsTrainingClassMembershipConnection';
  /** A list of edges. */
  edges: Array<TrainingsTrainingClassMembershipEdge>;
  /** A list of nodes. */
  nodes: Array<TrainingsTrainingClassMembership>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TrainingsTrainingClassMembershipEdge = {
  __typename?: 'TrainingsTrainingClassMembershipEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TrainingsTrainingClassMembership;
};

/** the filter for the training_class_memberships resource */
export type TrainingsTrainingClassMembershipFilter = {
  id?: InputMaybe<IntegerFilter>;
  or?: InputMaybe<Array<TrainingsTrainingClassMembershipFilterConditions>>;
  teamId?: InputMaybe<IntegerFilter>;
};

export type TrainingsTrainingClassMembershipFilterConditions = {
  id?: InputMaybe<IntegerFilter>;
  teamId?: InputMaybe<IntegerFilter>;
};

export type TrainingsTrainingClassModalityEnum =
  | 'scheduled'
  | 'selfpaced';

/** The connection type for TrainingsTraining. */
export type TrainingsTrainingConnection = {
  __typename?: 'TrainingsTrainingConnection';
  /** A list of edges. */
  edges: Array<TrainingsTrainingEdge>;
  /** A list of nodes. */
  nodes: Array<TrainingsTraining>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TrainingsTrainingEdge = {
  __typename?: 'TrainingsTrainingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TrainingsTraining;
};

/** Trainings training file */
export type TrainingsTrainingFile = {
  __typename?: 'TrainingsTrainingFile';
  authorId: Scalars['Int'];
  contentType: Scalars['String'];
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  filename: Scalars['String'];
  id: Scalars['Int'];
  size: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  training?: Maybe<TrainingsTraining>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  trainingId: Scalars['Int'];
  url: Scalars['String'];
  visibility: Scalars['Boolean'];
};


/** Trainings training file */
export type TrainingsTrainingFileTrainingArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  catalog?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  isMandatory?: InputMaybe<Scalars['Boolean']>;
  onlyAssigned?: InputMaybe<Scalars['Boolean']>;
  returnExpiredMemberships?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  withCurrentTrainingClasses?: InputMaybe<Scalars['Boolean']>;
  withExpiredMemberships?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for TrainingsTrainingFile. */
export type TrainingsTrainingFileConnection = {
  __typename?: 'TrainingsTrainingFileConnection';
  /** A list of edges. */
  edges: Array<TrainingsTrainingFileEdge>;
  /** A list of nodes. */
  nodes: Array<TrainingsTrainingFile>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TrainingsTrainingFileEdge = {
  __typename?: 'TrainingsTrainingFileEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TrainingsTrainingFile;
};

/** the filter for the trainings resource */
export type TrainingsTrainingFilter = {
  accessId?: InputMaybe<IntegerFilter>;
  catalog?: InputMaybe<BooleanFilter>;
  categoryId?: InputMaybe<IntegerFilter>;
  competencyId?: InputMaybe<IntegerFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringFilter>;
  externalProvider?: InputMaybe<StringFilter>;
  isMandatory?: InputMaybe<BooleanFilter>;
  modality?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  numberOfExpiredParticipants?: InputMaybe<IntegerFilter>;
  objectives?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<TrainingsTrainingFilterConditions>>;
  startsOn?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
  totalParticipants?: InputMaybe<IntegerFilter>;
  trainingAttendanceStatus?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  withExpiredMemberships?: InputMaybe<BooleanFilter>;
  year?: InputMaybe<IntegerFilter>;
};

export type TrainingsTrainingFilterConditions = {
  accessId?: InputMaybe<IntegerFilter>;
  catalog?: InputMaybe<BooleanFilter>;
  categoryId?: InputMaybe<IntegerFilter>;
  competencyId?: InputMaybe<IntegerFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringFilter>;
  externalProvider?: InputMaybe<StringFilter>;
  isMandatory?: InputMaybe<BooleanFilter>;
  modality?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  numberOfExpiredParticipants?: InputMaybe<IntegerFilter>;
  objectives?: InputMaybe<StringFilter>;
  startsOn?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
  totalParticipants?: InputMaybe<IntegerFilter>;
  trainingAttendanceStatus?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  withExpiredMemberships?: InputMaybe<BooleanFilter>;
  year?: InputMaybe<IntegerFilter>;
};

export type TrainingsTrainingHours = {
  __typename?: 'TrainingsTrainingHours';
  averageSessionHoursPerEmployee: Scalars['Float'];
  totalSessionsHours: Scalars['Float'];
};

export type TrainingsTrainingHoursPerEmployee = {
  __typename?: 'TrainingsTrainingHoursPerEmployee';
  employeeId: Scalars['Int'];
  totalSessionsHours: Scalars['Float'];
};

/** Training links */
export type TrainingsTrainingLink = {
  __typename?: 'TrainingsTrainingLink';
  authorId: Scalars['Int'];
  companyId: Scalars['Int'];
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['Int'];
  title: Scalars['String'];
  trainingId: Scalars['Int'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  url: Scalars['String'];
};

/** The connection type for TrainingsTrainingLink. */
export type TrainingsTrainingLinkConnection = {
  __typename?: 'TrainingsTrainingLinkConnection';
  /** A list of edges. */
  edges: Array<TrainingsTrainingLinkEdge>;
  /** A list of nodes. */
  nodes: Array<TrainingsTrainingLink>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TrainingsTrainingLinkEdge = {
  __typename?: 'TrainingsTrainingLinkEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TrainingsTrainingLink;
};

/** Training memberships */
export type TrainingsTrainingMembership = {
  __typename?: 'TrainingsTrainingMembership';
  access: ApiCoreAccess;
  /**
   * Access_id associated to the employee, refers to employees/employees endpoint.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  accessId: Scalars['Int'];
  employee?: Maybe<EmployeesEmployee>;
  /**
   * Employee_id associated to the employee, refers to employees/employees endpoint.
   * @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation
   */
  employeeId: Scalars['Int'];
  /** Unique identifier for the training membership. */
  id: Scalars['Int'];
  /** This field is used to filter those trainings memberships whose attendance status is the given. */
  status: TrainingsTrainingMembershipStatusEnum;
  /** This field is used to record the date a training was completed for trainings that have an expiry date. */
  trainingCompletedAt?: Maybe<Scalars['ISO8601Date']>;
  /** This field is used for those trainings with an expiry date. */
  trainingDueDate?: Maybe<Scalars['ISO8601Date']>;
  /** This field is used to filter those trainings memberships that belongs to this training. */
  trainingId: Scalars['Int'];
  trainingMembershipFiles: Array<TrainingsTrainingMembershipFile>;
  trainingMembershipFilesConnection: TrainingsTrainingMembershipFileConnection;
};


/** Training memberships */
export type TrainingsTrainingMembershipAccessArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** Training memberships */
export type TrainingsTrainingMembershipEmployeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Training memberships */
export type TrainingsTrainingMembershipTrainingMembershipFilesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for TrainingsTrainingMembership. */
export type TrainingsTrainingMembershipConnection = {
  __typename?: 'TrainingsTrainingMembershipConnection';
  /** A list of edges. */
  edges: Array<TrainingsTrainingMembershipEdge>;
  /** A list of nodes. */
  nodes: Array<TrainingsTrainingMembership>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TrainingsTrainingMembershipEdge = {
  __typename?: 'TrainingsTrainingMembershipEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TrainingsTrainingMembership;
};

/** Training membership files */
export type TrainingsTrainingMembershipFile = {
  __typename?: 'TrainingsTrainingMembershipFile';
  contentType: Scalars['String'];
  documentId?: Maybe<Scalars['Int']>;
  fileId?: Maybe<Scalars['Int']>;
  filename: Scalars['String'];
  id: Scalars['Int'];
  size: Scalars['Int'];
  trainingMembershipId: Scalars['Int'];
  url: Scalars['String'];
};

/** The connection type for TrainingsTrainingMembershipFile. */
export type TrainingsTrainingMembershipFileConnection = {
  __typename?: 'TrainingsTrainingMembershipFileConnection';
  /** A list of edges. */
  edges: Array<TrainingsTrainingMembershipFileEdge>;
  /** A list of nodes. */
  nodes: Array<TrainingsTrainingMembershipFile>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TrainingsTrainingMembershipFileEdge = {
  __typename?: 'TrainingsTrainingMembershipFileEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TrainingsTrainingMembershipFile;
};

/** the filter for the training_memberships resource */
export type TrainingsTrainingMembershipFilter = {
  accessId?: InputMaybe<IntegerFilter>;
  classId?: InputMaybe<IntegerFilter>;
  employeeId?: InputMaybe<IntegerFilter>;
  id?: InputMaybe<IntegerFilter>;
  or?: InputMaybe<Array<TrainingsTrainingMembershipFilterConditions>>;
  status?: InputMaybe<StringFilter>;
  teamId?: InputMaybe<IntegerFilter>;
  trainingCompletedAt?: InputMaybe<DateFilter>;
  trainingDueDate?: InputMaybe<DateFilter>;
  trainingId?: InputMaybe<IntegerFilter>;
};

export type TrainingsTrainingMembershipFilterConditions = {
  accessId?: InputMaybe<IntegerFilter>;
  classId?: InputMaybe<IntegerFilter>;
  employeeId?: InputMaybe<IntegerFilter>;
  id?: InputMaybe<IntegerFilter>;
  status?: InputMaybe<StringFilter>;
  teamId?: InputMaybe<IntegerFilter>;
  trainingCompletedAt?: InputMaybe<DateFilter>;
  trainingDueDate?: InputMaybe<DateFilter>;
  trainingId?: InputMaybe<IntegerFilter>;
};

export type TrainingsTrainingMembershipStatusEnum =
  | 'completed'
  | 'missing'
  | 'notassigned'
  | 'notstarted'
  | 'partiallycompleted'
  | 'started';

export type TrainingsTrainingPolicies = {
  __typename?: 'TrainingsTrainingPolicies';
  edit: PermissionsPolicyResolution;
  read: PermissionsPolicyResolution;
};

export type TrainingsTrainingPoliciesEnum =
  | 'edit'
  | 'read';

/** Trainings training relatorio unico field */
export type TrainingsTrainingRelatorioUnicoField = {
  __typename?: 'TrainingsTrainingRelatorioUnicoField';
  certificateType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  educationArea?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  qualificationLevel?: Maybe<Scalars['String']>;
  trainingEntity?: Maybe<Scalars['String']>;
  trainingId: Scalars['Int'];
  trainingInitiative?: Maybe<Scalars['String']>;
  trainingModality?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** The connection type for TrainingsTrainingRelatorioUnicoField. */
export type TrainingsTrainingRelatorioUnicoFieldConnection = {
  __typename?: 'TrainingsTrainingRelatorioUnicoFieldConnection';
  /** A list of edges. */
  edges: Array<TrainingsTrainingRelatorioUnicoFieldEdge>;
  /** A list of nodes. */
  nodes: Array<TrainingsTrainingRelatorioUnicoField>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TrainingsTrainingRelatorioUnicoFieldEdge = {
  __typename?: 'TrainingsTrainingRelatorioUnicoFieldEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TrainingsTrainingRelatorioUnicoField;
};

/** Training requests */
export type TrainingsTrainingRequest = {
  __typename?: 'TrainingsTrainingRequest';
  _policies?: Maybe<TrainingsTrainingRequestPolicies>;
  _policiesCollection?: Maybe<Array<PermissionsPolicyResolution>>;
  _policiesConnection: PermissionsPolicyResolutionConnection;
  author?: Maybe<ApiCoreAccess>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  authorId: Scalars['Int'];
  comments?: Maybe<Scalars['String']>;
  companyId: Scalars['Int'];
  competencies: Array<CompetenciesCompetency>;
  competenciesConnection: CompetenciesCompetencyConnection;
  competencyId: Scalars['Int'];
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  competencyIds: Array<Scalars['Int']>;
  cost?: Maybe<Scalars['String']>;
  costToEmployee?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  currentApproverIds: Array<Scalars['Int']>;
  currentApprovers: Array<ApiCoreAccess>;
  currentApproversConnection: ApiCoreAccessConnection;
  duration?: Maybe<Scalars['String']>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  employeeIds: Array<Scalars['Int']>;
  endDate?: Maybe<Scalars['ISO8601Date']>;
  externalReference?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  participants: Array<EmployeesEmployee>;
  participantsConnection: EmployeesEmployeeConnection;
  paymentInstallments?: Maybe<Scalars['Int']>;
  providerName?: Maybe<Scalars['String']>;
  schedule?: Maybe<TrainingsTrainingRequestScheduleEnum>;
  startDate?: Maybe<Scalars['ISO8601Date']>;
  status: TrainingsTrainingRequestStatusEnum;
  stepApprovers: Array<TrainingsApprover>;
  subsidized: Scalars['Boolean'];
  training?: Maybe<TrainingsTraining>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  trainingId?: Maybe<Scalars['Int']>;
  trainingName?: Maybe<Scalars['String']>;
  trainingNeed?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};


/** Training requests */
export type TrainingsTrainingRequest_PoliciesCollectionArgs = {
  ids: Array<TrainingsTrainingRequestPoliciesEnum>;
};


/** Training requests */
export type TrainingsTrainingRequest_PoliciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Training requests */
export type TrainingsTrainingRequestAuthorArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** Training requests */
export type TrainingsTrainingRequestCompetenciesArgs = {
  competencyGroupIds?: InputMaybe<Array<Scalars['String']>>;
  everyone?: InputMaybe<Scalars['Boolean']>;
  roleIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  withDeleted?: InputMaybe<Scalars['Boolean']>;
};


/** Training requests */
export type TrainingsTrainingRequestCompetenciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  competencyGroupIds?: InputMaybe<Array<Scalars['String']>>;
  everyone?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  roleIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  withDeleted?: InputMaybe<Scalars['Boolean']>;
};


/** Training requests */
export type TrainingsTrainingRequestCurrentApproversArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** Training requests */
export type TrainingsTrainingRequestCurrentApproversConnectionArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  external?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** Training requests */
export type TrainingsTrainingRequestParticipantsArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Training requests */
export type TrainingsTrainingRequestParticipantsConnectionArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  after?: InputMaybe<Scalars['String']>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Sort>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


/** Training requests */
export type TrainingsTrainingRequestTrainingArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  catalog?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  isMandatory?: InputMaybe<Scalars['Boolean']>;
  onlyAssigned?: InputMaybe<Scalars['Boolean']>;
  returnExpiredMemberships?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  withCurrentTrainingClasses?: InputMaybe<Scalars['Boolean']>;
  withExpiredMemberships?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for TrainingsTrainingRequest. */
export type TrainingsTrainingRequestConnection = {
  __typename?: 'TrainingsTrainingRequestConnection';
  /** A list of edges. */
  edges: Array<TrainingsTrainingRequestEdge>;
  /** A list of nodes. */
  nodes: Array<TrainingsTrainingRequest>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TrainingsTrainingRequestEdge = {
  __typename?: 'TrainingsTrainingRequestEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TrainingsTrainingRequest;
};

/** the filter for the training_requests resource */
export type TrainingsTrainingRequestFilter = {
  authorId?: InputMaybe<IntegerFilter>;
  competencyId?: InputMaybe<IntegerFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  or?: InputMaybe<Array<TrainingsTrainingRequestFilterConditions>>;
  status?: InputMaybe<StringFilter>;
};

export type TrainingsTrainingRequestFilterConditions = {
  authorId?: InputMaybe<IntegerFilter>;
  competencyId?: InputMaybe<IntegerFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  status?: InputMaybe<StringFilter>;
};

export type TrainingsTrainingRequestPolicies = {
  __typename?: 'TrainingsTrainingRequestPolicies';
  manageRequest: PermissionsPolicyResolution;
  read: PermissionsPolicyResolution;
};

export type TrainingsTrainingRequestPoliciesEnum =
  | 'manage_request'
  | 'read';

export type TrainingsTrainingRequestScheduleEnum =
  | 'mixedhours'
  | 'notsure'
  | 'outsideworkinghours'
  | 'workinghours';

export type TrainingsTrainingRequestStatusEnum =
  | 'approved'
  | 'draft'
  | 'rejected'
  | 'review';

export type TrainingsTrainingStatusEnum =
  | 'active'
  | 'deleted'
  | 'draft';

export type TrainingsTrainingSubsidyEnum =
  | 'fundae'
  | 'other';

export type TrainingsTrainingsEmployees = {
  __typename?: 'TrainingsTrainingsEmployees';
  averageEmployeesPerTraining: Scalars['Float'];
  totalUniqueEmployees: Scalars['Int'];
};

export type TrainingsTrainingsHoursAndCost = {
  __typename?: 'TrainingsTrainingsHoursAndCost';
  salaryCost: Scalars['String'];
  totalTrainings: Scalars['Int'];
  trainingCost: Scalars['String'];
  trainingSubsidizedCost: Scalars['String'];
};

export type TrialContextlessPolicies = {
  __typename?: 'TrialContextlessPolicies';
  companyOnboardingShowCompanyOnboarding: ContextlessPolicyResolution;
  trialEmployeeBulkDelete: ContextlessPolicyResolution;
};

/** trial_employee */
export type TrialTrialEmployee = {
  __typename?: 'TrialTrialEmployee';
  accessId: Scalars['Int'];
  companyId: Scalars['Int'];
  id: Scalars['Int'];
  status: Scalars['String'];
};

/** The connection type for TrialTrialEmployee. */
export type TrialTrialEmployeeConnection = {
  __typename?: 'TrialTrialEmployeeConnection';
  /** A list of edges. */
  edges: Array<TrialTrialEmployeeEdge>;
  /** A list of nodes. */
  nodes: Array<TrialTrialEmployee>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TrialTrialEmployeeEdge = {
  __typename?: 'TrialTrialEmployeeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: TrialTrialEmployee;
};

/** Autogenerated return type of UnarchiveFinanceBudget. */
export type UnarchiveFinanceBudgetPayload = {
  __typename?: 'UnarchiveFinanceBudgetPayload';
  budget?: Maybe<FinanceBudget>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UnarchiveFinanceSerialSequenceCreditNoteSequence. */
export type UnarchiveFinanceSerialSequenceCreditNoteSequencePayload = {
  __typename?: 'UnarchiveFinanceSerialSequenceCreditNoteSequencePayload';
  creditNoteSequence?: Maybe<FinanceCreditNoteSequence>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UnarchiveFinanceSerialSequenceSalesInvoiceSequence. */
export type UnarchiveFinanceSerialSequenceSalesInvoiceSequencePayload = {
  __typename?: 'UnarchiveFinanceSerialSequenceSalesInvoiceSequencePayload';
  errors: Array<MutationError>;
  salesInvoiceSequence?: Maybe<FinanceSalesInvoiceSequence>;
};

/** Autogenerated return type of UnarchiveJobcatalogLevel. */
export type UnarchiveJobcatalogLevelPayload = {
  __typename?: 'UnarchiveJobcatalogLevelPayload';
  errors: Array<MutationError>;
  level?: Maybe<JobCatalogLevel>;
};

/** Autogenerated return type of UnarchiveJobcatalogRole. */
export type UnarchiveJobcatalogRolePayload = {
  __typename?: 'UnarchiveJobcatalogRolePayload';
  errors: Array<MutationError>;
  role?: Maybe<JobCatalogRole>;
};

/** Autogenerated return type of UnarchiveLocationsWorkArea. */
export type UnarchiveLocationsWorkAreaPayload = {
  __typename?: 'UnarchiveLocationsWorkAreaPayload';
  errors: Array<MutationError>;
  workArea?: Maybe<LocationsWorkArea>;
};

/** Autogenerated return type of UnassignCompetencyJobcatalogRole. */
export type UnassignCompetencyJobcatalogRolePayload = {
  __typename?: 'UnassignCompetencyJobcatalogRolePayload';
  errors: Array<MutationError>;
  role?: Maybe<JobCatalogRole>;
};

/** Autogenerated return type of UnassignLocationsEmployeesLocation. */
export type UnassignLocationsEmployeesLocationPayload = {
  __typename?: 'UnassignLocationsEmployeesLocationPayload';
  employeesLocation?: Maybe<LocationsEmployeesLocation>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UnassignProjectmanagementProjectRole. */
export type UnassignProjectmanagementProjectRolePayload = {
  __typename?: 'UnassignProjectmanagementProjectRolePayload';
  errors: Array<MutationError>;
  projectRole?: Maybe<ProjectManagementProjectRole>;
};

/** Autogenerated return type of UnassignProjectmanagementProjectWorker. */
export type UnassignProjectmanagementProjectWorkerPayload = {
  __typename?: 'UnassignProjectmanagementProjectWorkerPayload';
  errors: Array<MutationError>;
  projectWorker?: Maybe<ProjectManagementProjectWorker>;
};

/** Autogenerated return type of UninviteApicoreAccess. */
export type UninviteApicoreAccessPayload = {
  __typename?: 'UninviteApicoreAccessPayload';
  access?: Maybe<ApiCoreAccess>;
  errors: Array<MutationError>;
};

/** Universal exports configuration */
export type UniversalExportsConfiguration = {
  __typename?: 'UniversalExportsConfiguration';
  accessId: Scalars['Int'];
  companyId: Scalars['Int'];
  exporter: UniversalExportsExporter;
  extraOptions: Array<UniversalExportsConfigurationExtraOption>;
  fields: Array<UniversalExportsConfigurationField>;
  filters: Array<UniversalExportsConfigurationFilter>;
  format: UniversalExportsEntitiesConfigurationFormatEnum;
  groupColumn?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  resource: Scalars['String'];
};


/** Universal exports configuration */
export type UniversalExportsConfigurationExporterArgs = {
  companyId: Scalars['Int'];
  includeFilterOptions?: Scalars['Boolean'];
  metadata?: Array<UniversalExportsExporterMetadataInput>;
};

/** The connection type for UniversalExportsConfiguration. */
export type UniversalExportsConfigurationConnection = {
  __typename?: 'UniversalExportsConfigurationConnection';
  /** A list of edges. */
  edges: Array<UniversalExportsConfigurationEdge>;
  /** A list of nodes. */
  nodes: Array<UniversalExportsConfiguration>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type UniversalExportsConfigurationEdge = {
  __typename?: 'UniversalExportsConfigurationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: UniversalExportsConfiguration;
};

export type UniversalExportsConfigurationExtraOption = {
  __typename?: 'UniversalExportsConfigurationExtraOption';
  name: Scalars['String'];
  value: Scalars['Boolean'];
};

export type UniversalExportsConfigurationExtraOptionInput = {
  name: Scalars['String'];
  value: Scalars['Boolean'];
};

export type UniversalExportsConfigurationField = {
  __typename?: 'UniversalExportsConfigurationField';
  label?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  position: Scalars['Int'];
};

export type UniversalExportsConfigurationFieldInput = {
  label?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  position: Scalars['Int'];
};

export type UniversalExportsConfigurationFilter = {
  __typename?: 'UniversalExportsConfigurationFilter';
  name: Scalars['String'];
  values: Array<Scalars['String']>;
};

export type UniversalExportsConfigurationFilterInput = {
  name: Scalars['String'];
  values: Array<Scalars['String']>;
};

export type UniversalExportsEntitiesConfigurationFormatEnum =
  | 'csv'
  | 'xlsx';

export type UniversalExportsEntitiesExportStatusEnum =
  | 'failed'
  | 'generated'
  | 'processing';

export type UniversalExportsEntitiesExporterFilterTypeEnum =
  | 'boolean'
  | 'date'
  | 'datetime'
  | 'integer'
  | 'string'
  | 'time';

/** Universal exports export */
export type UniversalExportsExport = {
  __typename?: 'UniversalExportsExport';
  companyId: Scalars['Int'];
  configuration?: Maybe<UniversalExportsConfiguration>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  configurationId?: Maybe<Scalars['Int']>;
  file?: Maybe<ApiCoreAttachment>;
  id: Scalars['Int'];
  status: UniversalExportsEntitiesExportStatusEnum;
};


/** Universal exports export */
export type UniversalExportsExportConfigurationArgs = {
  resources?: InputMaybe<Array<Scalars['String']>>;
};


/** Universal exports export */
export type UniversalExportsExportFileArgs = {
  attachmentName?: InputMaybe<Scalars['String']>;
};

/** Universal exports exporter */
export type UniversalExportsExporter = {
  __typename?: 'UniversalExportsExporter';
  extraOptions: Array<UniversalExportsExporterExtraOption>;
  fields: Array<UniversalExportsExporterField>;
  filters: Array<UniversalExportsExporterFilter>;
  groupableColumns: Array<UniversalExportsExporterGroupColumn>;
  label: Scalars['String'];
  resource: Scalars['String'];
};

/** The connection type for UniversalExportsExporter. */
export type UniversalExportsExporterConnection = {
  __typename?: 'UniversalExportsExporterConnection';
  /** A list of edges. */
  edges: Array<UniversalExportsExporterEdge>;
  /** A list of nodes. */
  nodes: Array<UniversalExportsExporter>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type UniversalExportsExporterEdge = {
  __typename?: 'UniversalExportsExporterEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: UniversalExportsExporter;
};

export type UniversalExportsExporterExtraOption = {
  __typename?: 'UniversalExportsExporterExtraOption';
  label: Scalars['String'];
  name: Scalars['String'];
};

export type UniversalExportsExporterField = {
  __typename?: 'UniversalExportsExporterField';
  default?: Maybe<Scalars['Boolean']>;
  defaultPosition?: Maybe<Scalars['Int']>;
  label: Scalars['String'];
  name: Scalars['String'];
};

export type UniversalExportsExporterFilter = {
  __typename?: 'UniversalExportsExporterFilter';
  default?: Maybe<Scalars['Boolean']>;
  kind: UniversalExportsExporterFilterKindEnum;
  label: Scalars['String'];
  name: Scalars['String'];
  options?: Maybe<Array<UniversalExportsExporterFilterOption>>;
  type: UniversalExportsEntitiesExporterFilterTypeEnum;
};

export type UniversalExportsExporterFilterKindEnum =
  | 'datetimerange'
  | 'employees'
  | 'multiplechoice'
  | 'singlechoice'
  | 'vendors';

export type UniversalExportsExporterFilterOption = {
  __typename?: 'UniversalExportsExporterFilterOption';
  label: Scalars['String'];
  value: Scalars['String'];
};

export type UniversalExportsExporterGroupColumn = {
  __typename?: 'UniversalExportsExporterGroupColumn';
  label: Scalars['String'];
  name: Scalars['String'];
};

export type UniversalExportsExporterMetadataInput = {
  name: Scalars['String'];
  values: Array<Scalars['String']>;
};

export type UniversalImporterActivityDetailedErrors = {
  __typename?: 'UniversalImporterActivityDetailedErrors';
  messages: Array<Scalars['String']>;
  uuid: Scalars['String'];
};

export type UniversalImporterColumnValue = {
  __typename?: 'UniversalImporterColumnValue';
  column: Scalars['String'];
  values: Array<Scalars['String']>;
};

export type UniversalImporterContextlessPolicies = {
  __typename?: 'UniversalImporterContextlessPolicies';
  importResources: ContextlessPolicyResolution;
};

export type UniversalImporterCustomizationParams = {
  __typename?: 'UniversalImporterCustomizationParams';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type UniversalImporterEntitiesSchemaAdapterColumnTypeEnum =
  | 'boolean'
  | 'category'
  | 'date'
  | 'float'
  | 'int'
  | 'string';

export type UniversalImporterFilterCondition = {
  __typename?: 'UniversalImporterFilterCondition';
  field: Scalars['String'];
  values: Array<Scalars['String']>;
};

/** Universal Importer import activity */
export type UniversalImporterImportActivity = {
  __typename?: 'UniversalImporterImportActivity';
  companyId: Scalars['Int'];
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  detailedErrors?: Maybe<Array<UniversalImporterActivityDetailedErrors>>;
  errored: Scalars['Int'];
  importProcessId: Scalars['Int'];
  processed: Scalars['Int'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  uuid: Scalars['String'];
};

/** The connection type for UniversalImporterImportActivity. */
export type UniversalImporterImportActivityConnection = {
  __typename?: 'UniversalImporterImportActivityConnection';
  /** A list of edges. */
  edges: Array<UniversalImporterImportActivityEdge>;
  /** A list of nodes. */
  nodes: Array<UniversalImporterImportActivity>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type UniversalImporterImportActivityEdge = {
  __typename?: 'UniversalImporterImportActivityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: UniversalImporterImportActivity;
};

/** Import processes of the Universal importer */
export type UniversalImporterImportProcess = {
  __typename?: 'UniversalImporterImportProcess';
  access: ApiCoreAccess;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  accessId: Scalars['Int'];
  action?: Maybe<Scalars['String']>;
  companyId: Scalars['Int'];
  errored: Scalars['Int'];
  failedMessage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  importActivities: Array<UniversalImporterImportActivity>;
  importActivitiesConnection: UniversalImporterImportActivityConnection;
  importType: UniversalImporterValueObjectsImportTypeEnum;
  legalEntity?: Maybe<CompaniesLegalEntity>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  legalEntityId?: Maybe<Scalars['Int']>;
  metadata?: Maybe<Array<UniversalImporterImportProcessMetadata>>;
  originalFileFilename?: Maybe<Scalars['String']>;
  originalFileUrl?: Maybe<Scalars['String']>;
  outdated?: Maybe<Scalars['Boolean']>;
  parentProcessId?: Maybe<Scalars['Int']>;
  processed: Scalars['Int'];
  rootProcessId?: Maybe<Scalars['Int']>;
  status: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  total: Scalars['Int'];
  updatedAt: Scalars['ISO8601DateTime'];
  uuid: Scalars['String'];
};


/** Import processes of the Universal importer */
export type UniversalImporterImportProcessAccessArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


/** Import processes of the Universal importer */
export type UniversalImporterImportProcessImportActivitiesArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  importProcessId?: InputMaybe<Scalars['Int']>;
};


/** Import processes of the Universal importer */
export type UniversalImporterImportProcessImportActivitiesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  importProcessId?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Import processes of the Universal importer */
export type UniversalImporterImportProcessLegalEntityArgs = {
  companiesIds?: InputMaybe<Array<Scalars['Int']>>;
  countryIds?: InputMaybe<Array<Scalars['String']>>;
  employeesIds?: InputMaybe<Array<Scalars['Int']>>;
  excludeCountries?: InputMaybe<Array<Scalars['String']>>;
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};

/** The connection type for UniversalImporterImportProcess. */
export type UniversalImporterImportProcessConnection = {
  __typename?: 'UniversalImporterImportProcessConnection';
  /** A list of edges. */
  edges: Array<UniversalImporterImportProcessEdge>;
  /** A list of nodes. */
  nodes: Array<UniversalImporterImportProcess>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type UniversalImporterImportProcessDataColumn = {
  __typename?: 'UniversalImporterImportProcessDataColumn';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type UniversalImporterImportProcessDataRow = {
  __typename?: 'UniversalImporterImportProcessDataRow';
  columns?: Maybe<Array<UniversalImporterImportProcessDataColumn>>;
  errors?: Maybe<Array<Scalars['String']>>;
};

/** An edge in a connection. */
export type UniversalImporterImportProcessEdge = {
  __typename?: 'UniversalImporterImportProcessEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: UniversalImporterImportProcess;
};

/** Import processes errored data of the Universal importer */
export type UniversalImporterImportProcessFailedDatum = {
  __typename?: 'UniversalImporterImportProcessFailedDatum';
  fields?: Maybe<Array<UniversalImporterSchemaData>>;
};

/** The connection type for UniversalImporterImportProcessFailedDatum. */
export type UniversalImporterImportProcessFailedDatumConnection = {
  __typename?: 'UniversalImporterImportProcessFailedDatumConnection';
  /** A list of edges. */
  edges: Array<UniversalImporterImportProcessFailedDatumEdge>;
  /** A list of nodes. */
  nodes: Array<UniversalImporterImportProcessFailedDatum>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type UniversalImporterImportProcessFailedDatumEdge = {
  __typename?: 'UniversalImporterImportProcessFailedDatumEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: UniversalImporterImportProcessFailedDatum;
};

/** the filter for the import_processes resource */
export type UniversalImporterImportProcessFilter = {
  accessId?: InputMaybe<IntegerFilter>;
  errored?: InputMaybe<IntegerFilter>;
  id?: InputMaybe<IntegerFilter>;
  importType?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<UniversalImporterImportProcessFilterConditions>>;
  processed?: InputMaybe<IntegerFilter>;
  status?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  total?: InputMaybe<IntegerFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type UniversalImporterImportProcessFilterConditions = {
  accessId?: InputMaybe<IntegerFilter>;
  errored?: InputMaybe<IntegerFilter>;
  id?: InputMaybe<IntegerFilter>;
  importType?: InputMaybe<StringFilter>;
  processed?: InputMaybe<IntegerFilter>;
  status?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  total?: InputMaybe<IntegerFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type UniversalImporterImportProcessMetadata = {
  __typename?: 'UniversalImporterImportProcessMetadata';
  key: Scalars['String'];
  type: UniversalImporterValueObjectsImportProcessMetadataValueTypeEnum;
  values?: Maybe<Array<Scalars['String']>>;
};

export type UniversalImporterImportProcessMetadataInput = {
  key: Scalars['String'];
  type: UniversalImporterValueObjectsImportProcessMetadataValueTypeEnum;
  values?: InputMaybe<Array<Scalars['String']>>;
};

/** Import processes data of the Universal importer that contains processed rows and errors */
export type UniversalImporterImportProcessRow = {
  __typename?: 'UniversalImporterImportProcessRow';
  errors?: Maybe<Array<UniversalImporterActivityDetailedErrors>>;
  headers?: Maybe<Array<Scalars['String']>>;
  processId: Scalars['Int'];
  rows?: Maybe<Array<UniversalImporterImportProcessDataRow>>;
};

/** The connection type for UniversalImporterImportProcessRow. */
export type UniversalImporterImportProcessRowConnection = {
  __typename?: 'UniversalImporterImportProcessRowConnection';
  /** A list of edges. */
  edges: Array<UniversalImporterImportProcessRowEdge>;
  /** A list of nodes. */
  nodes: Array<UniversalImporterImportProcessRow>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type UniversalImporterImportProcessRowEdge = {
  __typename?: 'UniversalImporterImportProcessRowEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: UniversalImporterImportProcessRow;
};

export type UniversalImporterNuvoCustomization = {
  __typename?: 'UniversalImporterNuvoCustomization';
  computeWith: Scalars['String'];
  parameters?: Maybe<Array<UniversalImporterCustomizationParams>>;
  type: UniversalImporterValueObjectsNuvoCustomizationCustomizationTypeEnum;
};

export type UniversalImporterNuvoDropdownOption = {
  __typename?: 'UniversalImporterNuvoDropdownOption';
  label: Scalars['String'];
  type: UniversalImporterValueObjectsNuvoDropdownOptionTypeEnum;
  validations?: Maybe<Array<UniversalImporterValidation>>;
  value: Scalars['String'];
};

export type UniversalImporterNuvoValidation = {
  __typename?: 'UniversalImporterNuvoValidation';
  columnValues?: Maybe<Array<UniversalImporterColumnValue>>;
  columns?: Maybe<Array<Scalars['String']>>;
  errorMessage?: Maybe<Scalars['String']>;
  regex?: Maybe<Scalars['String']>;
  validate: UniversalImporterValueObjectsNuvoValidationValidationTypeEnum;
};

/** Data schema provider */
export type UniversalImporterSchemaAdapter = {
  __typename?: 'UniversalImporterSchemaAdapter';
  columnType: UniversalImporterEntitiesSchemaAdapterColumnTypeEnum;
  customizations?: Maybe<Array<UniversalImporterNuvoCustomization>>;
  disabled: Scalars['Boolean'];
  dropdownOptions?: Maybe<Array<UniversalImporterNuvoDropdownOption>>;
  hidden: Scalars['Boolean'];
  isMultiSelect?: Maybe<Scalars['Boolean']>;
  key: Scalars['String'];
  label: Scalars['String'];
  outputFormat?: Maybe<Scalars['String']>;
  validations?: Maybe<Array<UniversalImporterNuvoValidation>>;
};

/** The connection type for UniversalImporterSchemaAdapter. */
export type UniversalImporterSchemaAdapterConnection = {
  __typename?: 'UniversalImporterSchemaAdapterConnection';
  /** A list of edges. */
  edges: Array<UniversalImporterSchemaAdapterEdge>;
  /** A list of nodes. */
  nodes: Array<UniversalImporterSchemaAdapter>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type UniversalImporterSchemaAdapterEdge = {
  __typename?: 'UniversalImporterSchemaAdapterEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: UniversalImporterSchemaAdapter;
};

export type UniversalImporterSchemaData = {
  __typename?: 'UniversalImporterSchemaData';
  key: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

/** Data provider for edition in the Universal importer */
export type UniversalImporterSchemaDatum = {
  __typename?: 'UniversalImporterSchemaDatum';
  fields?: Maybe<Array<UniversalImporterSchemaData>>;
};

/** The connection type for UniversalImporterSchemaDatum. */
export type UniversalImporterSchemaDatumConnection = {
  __typename?: 'UniversalImporterSchemaDatumConnection';
  /** A list of edges. */
  edges: Array<UniversalImporterSchemaDatumEdge>;
  /** A list of nodes. */
  nodes: Array<UniversalImporterSchemaDatum>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type UniversalImporterSchemaDatumEdge = {
  __typename?: 'UniversalImporterSchemaDatumEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: UniversalImporterSchemaDatum;
};

export type UniversalImporterValidation = {
  __typename?: 'UniversalImporterValidation';
  conditions: Array<UniversalImporterFilterCondition>;
  errorMessage: Scalars['String'];
  operator: Scalars['String'];
};

export type UniversalImporterValueObjectsImportProcessMetadataValueTypeEnum =
  | 'boolean'
  | 'integer'
  | 'string';

export type UniversalImporterValueObjectsImportTypeEnum =
  | 'ats_job_posting_importer'
  | 'candidates_importer'
  | 'compensations_employee_compensation_importer'
  | 'competencies_competency_assignment_importer'
  | 'competencies_competency_importer'
  | 'contract_version_edition'
  | 'contract_version_importer'
  | 'cost_center_assignment_importer'
  | 'cost_centers_importer'
  | 'employee_bulk_activate_importer'
  | 'employee_bulk_pause_importer'
  | 'employee_bulk_termination_importer'
  | 'employee_edition'
  | 'employee_importer'
  | 'fd_contract_importer'
  | 'healthcare_beneficiaries_importer'
  | 'it_management_it_assets_importer'
  | 'job_catalog_tree_importer'
  | 'payroll_summary_importer'
  | 'teams_importer'
  | 'trainings_importer'
  | 'working_time_percentage_importer';

export type UniversalImporterValueObjectsNuvoCustomizationCustomizationTypeEnum =
  | 'transformation'
  | 'validation';

export type UniversalImporterValueObjectsNuvoDropdownOptionTypeEnum =
  | 'boolean'
  | 'date'
  | 'float'
  | 'int'
  | 'string';

export type UniversalImporterValueObjectsNuvoValidationValidationTypeEnum =
  | 'regex'
  | 'required'
  | 'required_with'
  | 'required_with_all'
  | 'required_with_values'
  | 'unique';

/** Autogenerated return type of UnshareTasksShareTask. */
export type UnshareTasksShareTaskPayload = {
  __typename?: 'UnshareTasksShareTaskPayload';
  errors: Array<MutationError>;
  shareTask?: Maybe<TasksShareTask>;
};

/** Autogenerated return type of UnsignAsEmployeePerformanceAgreement. */
export type UnsignAsEmployeePerformanceAgreementPayload = {
  __typename?: 'UnsignAsEmployeePerformanceAgreementPayload';
  agreement?: Maybe<PerformanceAgreement>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UnsignAsManagerPerformanceAgreement. */
export type UnsignAsManagerPerformanceAgreementPayload = {
  __typename?: 'UnsignAsManagerPerformanceAgreementPayload';
  agreement?: Maybe<PerformanceAgreement>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UnsnoozeBankingTransaction. */
export type UnsnoozeBankingTransactionPayload = {
  __typename?: 'UnsnoozeBankingTransactionPayload';
  errors: Array<MutationError>;
  transaction?: Maybe<BankingTransaction>;
};

/** Autogenerated return type of UnsnoozeFinanceJournalLine. */
export type UnsnoozeFinanceJournalLinePayload = {
  __typename?: 'UnsnoozeFinanceJournalLinePayload';
  errors: Array<MutationError>;
  journalLine?: Maybe<FinanceJournalLine>;
};

/** Autogenerated return type of UnterminateEmployeesEmployee. */
export type UnterminateEmployeesEmployeePayload = {
  __typename?: 'UnterminateEmployeesEmployeePayload';
  employee?: Maybe<EmployeesEmployee>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateAgreementsConfigurationPerformanceReviewProcess. */
export type UpdateAgreementsConfigurationPerformanceReviewProcessPayload = {
  __typename?: 'UpdateAgreementsConfigurationPerformanceReviewProcessPayload';
  errors: Array<MutationError>;
  reviewProcess?: Maybe<PerformanceReviewProcess>;
};

/** Autogenerated return type of UpdateAliasBankingBankAccount. */
export type UpdateAliasBankingBankAccountPayload = {
  __typename?: 'UpdateAliasBankingBankAccountPayload';
  bankAccount?: Maybe<BankingBankAccount>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateAnalyticsReport. */
export type UpdateAnalyticsReportPayload = {
  __typename?: 'UpdateAnalyticsReportPayload';
  errors: Array<MutationError>;
  report?: Maybe<AnalyticsReport>;
};

export type UpdateAndApproveExpensesExpensableAllocationInput = {
  id?: InputMaybe<Scalars['Int']>;
  referenceId: Scalars['Int'];
  referenceType: Scalars['String'];
};

export type UpdateAndApproveExpensesExpensableAssignmentsInput = {
  assignmentsToCreate: Array<UpdateAndApproveExpensesExpensableAssignmentsToCreateInput>;
  assignmentsToUpdate: Array<UpdateAndApproveExpensesExpensableAssignmentsToUpdateInput>;
};

export type UpdateAndApproveExpensesExpensableAssignmentsToCreateInput = {
  costCenterId: Scalars['Int'];
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  percentage: Scalars['Float'];
  startDate: Scalars['ISO8601Date'];
};

export type UpdateAndApproveExpensesExpensableAssignmentsToUpdateInput = {
  costCenterId: Scalars['Int'];
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  id: Scalars['Int'];
  markedForDeletion: Scalars['Boolean'];
  percentage: Scalars['Float'];
  startDate: Scalars['ISO8601Date'];
};

export type UpdateAndApproveExpensesExpensableCostCentersInput = {
  allocation?: InputMaybe<UpdateAndApproveExpensesExpensableAllocationInput>;
  assignments?: InputMaybe<UpdateAndApproveExpensesExpensableAssignmentsInput>;
};

export type UpdateAndApproveExpensesExpensableExpenseInput = {
  accessToken?: InputMaybe<Scalars['String']>;
  amount?: InputMaybe<Scalars['Int']>;
  budgetId?: InputMaybe<Scalars['Int']>;
  category?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['Int']>;
  currency?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  documentNumber?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<Scalars['String']>;
  effectiveOn?: InputMaybe<Scalars['ISO8601DateTime']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  exchangeRate?: InputMaybe<Scalars['Float']>;
  files: Array<Scalars['File']>;
  filesIdToRemove?: InputMaybe<Array<Scalars['Int']>>;
  groupId?: InputMaybe<Scalars['Int']>;
  internalReference?: InputMaybe<Scalars['String']>;
  mcc?: InputMaybe<Scalars['String']>;
  merchantName?: InputMaybe<Scalars['String']>;
  merchantTin?: InputMaybe<Scalars['String']>;
  notifyCreator?: InputMaybe<Scalars['Boolean']>;
  overrideApprovalFlow?: InputMaybe<Scalars['Boolean']>;
  payment?: InputMaybe<ExpensesValueObjectsPaymentOptionsEnum>;
  paymentMethod?: InputMaybe<Scalars['String']>;
  projects?: InputMaybe<Array<ExpensesProjectInput>>;
  reference?: InputMaybe<Scalars['String']>;
  signedDocumentId?: InputMaybe<Scalars['Int']>;
  signedForOrganization?: InputMaybe<Scalars['String']>;
  subcategory?: InputMaybe<Scalars['String']>;
  taxes: Array<UpdateAndApproveExpensesExpensableTaxesInput>;
  userMerchant?: InputMaybe<Scalars['String']>;
};

export type UpdateAndApproveExpensesExpensableMileageNewInput = {
  amount?: InputMaybe<Scalars['Int']>;
  budgetId?: InputMaybe<Scalars['Int']>;
  calculatedMileage?: InputMaybe<Scalars['Int']>;
  categoryId?: InputMaybe<Scalars['Int']>;
  currency?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  destinationLatitude?: InputMaybe<Scalars['Float']>;
  destinationLongitude?: InputMaybe<Scalars['Float']>;
  effectiveOn?: InputMaybe<Scalars['ISO8601DateTime']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  files: Array<Scalars['File']>;
  filesIdToRemove?: InputMaybe<Array<Scalars['Int']>>;
  from?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['Int']>;
  internalReference?: InputMaybe<Scalars['String']>;
  mileage?: InputMaybe<Scalars['Int']>;
  notifyCreator?: InputMaybe<Scalars['Boolean']>;
  originLatitude?: InputMaybe<Scalars['Float']>;
  originLongitude?: InputMaybe<Scalars['Float']>;
  overrideApprovalFlow?: InputMaybe<Scalars['Boolean']>;
  projects?: InputMaybe<Array<ExpensesProjectInput>>;
  rate?: InputMaybe<Scalars['String']>;
  roundTrip?: InputMaybe<Scalars['Boolean']>;
  signedForOrganization?: InputMaybe<Scalars['String']>;
  subcategory?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
  units?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateAndApproveExpensesExpensable. */
export type UpdateAndApproveExpensesExpensablePayload = {
  __typename?: 'UpdateAndApproveExpensesExpensablePayload';
  errors: Array<MutationError>;
  expensable?: Maybe<ExpensesExpensable>;
};

export type UpdateAndApproveExpensesExpensablePerDiemInput = {
  amount?: InputMaybe<Scalars['Int']>;
  budgetId?: InputMaybe<Scalars['Int']>;
  categoryId?: InputMaybe<Scalars['Int']>;
  companyId: Scalars['Int'];
  currency?: InputMaybe<Scalars['String']>;
  deletedRates?: InputMaybe<Array<Scalars['Int']>>;
  description?: InputMaybe<Scalars['String']>;
  effectiveOn?: InputMaybe<Scalars['ISO8601DateTime']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  endDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  files: Array<Scalars['File']>;
  filesIdToRemove?: InputMaybe<Array<Scalars['Int']>>;
  from?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['Int']>;
  internalReference?: InputMaybe<Scalars['String']>;
  notifyCreator?: InputMaybe<Scalars['Boolean']>;
  overrideApprovalFlow?: InputMaybe<Scalars['Boolean']>;
  projects?: InputMaybe<Array<ExpensesProjectInput>>;
  rates: Array<UpdateAndApproveExpensesExpensableRatesInput>;
  signedForOrganization?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  subcategory?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
};

export type UpdateAndApproveExpensesExpensableRatesInput = {
  id?: InputMaybe<Scalars['Int']>;
  rateConfigurationId: Scalars['Int'];
  totalAmountCents: Scalars['Int'];
  totalDays: Scalars['Int'];
};

export type UpdateAndApproveExpensesExpensableTaxesInput = {
  amount?: InputMaybe<Scalars['Int']>;
  baseAmount?: InputMaybe<Scalars['Int']>;
  percentage?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<ExpensesCustomizationExpenseTaxesTypesEnum>;
};

/** Autogenerated return type of UpdateAndSetToPendingProcurementPurchaseRequest. */
export type UpdateAndSetToPendingProcurementPurchaseRequestPayload = {
  __typename?: 'UpdateAndSetToPendingProcurementPurchaseRequestPayload';
  errors: Array<MutationError>;
  purchaseRequest?: Maybe<ProcurementPurchaseRequest>;
};

/** Autogenerated return type of UpdateApicoreAccess. */
export type UpdateApicoreAccessPayload = {
  __typename?: 'UpdateApicoreAccessPayload';
  access?: Maybe<ApiCoreAccess>;
  errors: Array<MutationError>;
};

export type UpdateApprovalsApprovalFlowApproversInput = {
  accessId?: InputMaybe<Scalars['Int']>;
  groupableId?: InputMaybe<Scalars['Int']>;
  groupableType?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  strategy: Scalars['String'];
};

/** Autogenerated return type of UpdateApprovalsApprovalFlow. */
export type UpdateApprovalsApprovalFlowPayload = {
  __typename?: 'UpdateApprovalsApprovalFlowPayload';
  approvalFlow?: Maybe<ApprovalsApprovalFlow>;
  errors: Array<MutationError>;
};

export type UpdateApprovalsApprovalFlowStepsInput = {
  approverIdsToBeDeleted?: InputMaybe<Array<Scalars['Int']>>;
  approvers: Array<UpdateApprovalsApprovalFlowApproversInput>;
  id?: InputMaybe<Scalars['Int']>;
  position: Scalars['Int'];
  strategy?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateApprovalsApprovalGroup. */
export type UpdateApprovalsApprovalGroupPayload = {
  __typename?: 'UpdateApprovalsApprovalGroupPayload';
  approvalGroup?: Maybe<ApprovalsApprovalGroup>;
  errors: Array<MutationError>;
};

export type UpdateApprovalsRulesConfigurationApprovalFlowInput = {
  approvalGroupId?: InputMaybe<Scalars['Int']>;
  default: Scalars['Boolean'];
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  onApprovalFlowChange?: InputMaybe<ApprovalsApprovalFlowOnApprovalFlowChangeEnum>;
  stepIdsToBeDeleted: Array<Scalars['Int']>;
  steps: Array<UpdateApprovalsRulesConfigurationStepsInput>;
};

export type UpdateApprovalsRulesConfigurationApproversInput = {
  accessId?: InputMaybe<Scalars['Int']>;
  groupableId?: InputMaybe<Scalars['Int']>;
  groupableType?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  strategy: Scalars['String'];
};

/** Autogenerated return type of UpdateApprovalsRulesConfiguration. */
export type UpdateApprovalsRulesConfigurationPayload = {
  __typename?: 'UpdateApprovalsRulesConfigurationPayload';
  errors: Array<MutationError>;
  rulesConfiguration?: Maybe<ApprovalsRulesConfiguration>;
};

export type UpdateApprovalsRulesConfigurationRulesInput = {
  identifier: Scalars['String'];
  inputType: ApprovalsDomainConfigurationInputTypeEnum;
  label: Scalars['String'];
  operation: ApprovalsDomainConfigurationOperationsEnum;
  value: Array<Scalars['String']>;
};

export type UpdateApprovalsRulesConfigurationStepsInput = {
  approverIdsToBeDeleted?: InputMaybe<Array<Scalars['Int']>>;
  approvers: Array<UpdateApprovalsRulesConfigurationApproversInput>;
  id?: InputMaybe<Scalars['Int']>;
  position: Scalars['Int'];
  strategy?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateAtsApplication. */
export type UpdateAtsApplicationPayload = {
  __typename?: 'UpdateAtsApplicationPayload';
  application?: Maybe<AtsApplication>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateAtsApplicationPhase. */
export type UpdateAtsApplicationPhasePayload = {
  __typename?: 'UpdateAtsApplicationPhasePayload';
  applicationPhase?: Maybe<AtsApplicationPhase>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateAtsAssessment. */
export type UpdateAtsAssessmentPayload = {
  __typename?: 'UpdateAtsAssessmentPayload';
  assessment?: Maybe<AtsAssessment>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateAtsCandidateDuplicatesIdentification. */
export type UpdateAtsCandidateDuplicatesIdentificationPayload = {
  __typename?: 'UpdateAtsCandidateDuplicatesIdentificationPayload';
  candidateDuplicatesIdentification?: Maybe<AtsCandidateDuplicatesIdentification>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateAtsCandidateEmailAction. */
export type UpdateAtsCandidateEmailActionPayload = {
  __typename?: 'UpdateAtsCandidateEmailActionPayload';
  candidateEmailAction?: Maybe<AtsCandidateEmailAction>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateAtsCandidate. */
export type UpdateAtsCandidatePayload = {
  __typename?: 'UpdateAtsCandidatePayload';
  candidate?: Maybe<AtsCandidate>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateAtsCandidateSource. */
export type UpdateAtsCandidateSourcePayload = {
  __typename?: 'UpdateAtsCandidateSourcePayload';
  candidateSource?: Maybe<AtsCandidateSource>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateAtsCompany. */
export type UpdateAtsCompanyPayload = {
  __typename?: 'UpdateAtsCompanyPayload';
  company?: Maybe<AtsCompany>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateAtsDataRetentionConfiguration. */
export type UpdateAtsDataRetentionConfigurationPayload = {
  __typename?: 'UpdateAtsDataRetentionConfigurationPayload';
  dataRetentionConfiguration?: Maybe<AtsDataRetentionConfiguration>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateAtsEvaluationForm. */
export type UpdateAtsEvaluationFormPayload = {
  __typename?: 'UpdateAtsEvaluationFormPayload';
  errors: Array<MutationError>;
  evaluationForm?: Maybe<AtsEvaluationForm>;
};

export type UpdateAtsFeedbackEvaluationFormAnswersInput = {
  note?: InputMaybe<Scalars['String']>;
  questionId: Scalars['String'];
  score?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of UpdateAtsFeedback. */
export type UpdateAtsFeedbackPayload = {
  __typename?: 'UpdateAtsFeedbackPayload';
  errors: Array<MutationError>;
  feedback?: Maybe<AtsFeedback>;
};

/** Autogenerated return type of UpdateAtsHiringManager. */
export type UpdateAtsHiringManagerPayload = {
  __typename?: 'UpdateAtsHiringManagerPayload';
  errors: Array<MutationError>;
  hiringManager?: Maybe<AtsHiringManager>;
};

/** Autogenerated return type of UpdateAtsHiringPhase. */
export type UpdateAtsHiringPhasePayload = {
  __typename?: 'UpdateAtsHiringPhasePayload';
  errors: Array<MutationError>;
  hiringPhase?: Maybe<AtsHiringPhase>;
};

/** Autogenerated return type of UpdateAtsIntegration. */
export type UpdateAtsIntegrationPayload = {
  __typename?: 'UpdateAtsIntegrationPayload';
  errors: Array<MutationError>;
  integration?: Maybe<AtsIntegration>;
};

/** Autogenerated return type of UpdateAtsInterview. */
export type UpdateAtsInterviewPayload = {
  __typename?: 'UpdateAtsInterviewPayload';
  errors: Array<MutationError>;
  interview?: Maybe<AtsInterview>;
};

/** Autogenerated return type of UpdateAtsJobPosting. */
export type UpdateAtsJobPostingPayload = {
  __typename?: 'UpdateAtsJobPostingPayload';
  errors: Array<MutationError>;
  jobPosting?: Maybe<AtsJobPosting>;
};

/** Autogenerated return type of UpdateAtsMessageTemplate. */
export type UpdateAtsMessageTemplatePayload = {
  __typename?: 'UpdateAtsMessageTemplatePayload';
  errors: Array<MutationError>;
  messageTemplate?: Maybe<AtsMessageTemplate>;
};

/** Autogenerated return type of UpdateAtsOfferLetter. */
export type UpdateAtsOfferLetterPayload = {
  __typename?: 'UpdateAtsOfferLetterPayload';
  errors: Array<MutationError>;
  offerLetter?: Maybe<AtsOfferLetter>;
};

/** Autogenerated return type of UpdateAtsOfferLetterTemplate. */
export type UpdateAtsOfferLetterTemplatePayload = {
  __typename?: 'UpdateAtsOfferLetterTemplatePayload';
  errors: Array<MutationError>;
  offerLetterTemplate?: Maybe<AtsOfferLetterTemplate>;
};

/** Autogenerated return type of UpdateAtsOpenApplicationSetting. */
export type UpdateAtsOpenApplicationSettingPayload = {
  __typename?: 'UpdateAtsOpenApplicationSettingPayload';
  errors: Array<MutationError>;
  openApplicationSetting?: Maybe<AtsOpenApplicationSetting>;
};

/** Autogenerated return type of UpdateAtsQuestion. */
export type UpdateAtsQuestionPayload = {
  __typename?: 'UpdateAtsQuestionPayload';
  errors: Array<MutationError>;
  question?: Maybe<AtsQuestion>;
};

/** Autogenerated return type of UpdateAtsQuestionTemplate. */
export type UpdateAtsQuestionTemplatePayload = {
  __typename?: 'UpdateAtsQuestionTemplatePayload';
  errors: Array<MutationError>;
  questionTemplate?: Maybe<AtsQuestionTemplate>;
};

/** Autogenerated return type of UpdateAtsRejectionReason. */
export type UpdateAtsRejectionReasonPayload = {
  __typename?: 'UpdateAtsRejectionReasonPayload';
  errors: Array<MutationError>;
  rejectionReason?: Maybe<AtsRejectionReason>;
};

/** Autogenerated return type of UpdateAtsRequisition. */
export type UpdateAtsRequisitionPayload = {
  __typename?: 'UpdateAtsRequisitionPayload';
  errors: Array<MutationError>;
  requisition?: Maybe<AtsRequisition>;
};

/** Autogenerated return type of UpdateAtsTag. */
export type UpdateAtsTagPayload = {
  __typename?: 'UpdateAtsTagPayload';
  errors: Array<MutationError>;
  tag?: Maybe<AtsTag>;
};

/** Autogenerated return type of UpdateAttendanceBalanceCarryover. */
export type UpdateAttendanceBalanceCarryoverPayload = {
  __typename?: 'UpdateAttendanceBalanceCarryoverPayload';
  balanceCarryover?: Maybe<AttendanceBalanceCarryover>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateAttendanceBreakConfiguration. */
export type UpdateAttendanceBreakConfigurationPayload = {
  __typename?: 'UpdateAttendanceBreakConfigurationPayload';
  breakConfiguration?: Maybe<AttendanceBreakConfiguration>;
  errors: Array<MutationError>;
};

export type UpdateAttendanceBreakSettingAutomaticBreakRulesAttributesInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  breakDuration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  periodLength?: InputMaybe<Scalars['Int']>;
  timeSettingsBreakConfigurationId?: InputMaybe<Scalars['Int']>;
};

export type UpdateAttendanceBreakSettingDurationRulesAttributesInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  minimalDuration?: InputMaybe<Scalars['Int']>;
  periodLength?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of UpdateAttendanceBreakSetting. */
export type UpdateAttendanceBreakSettingPayload = {
  __typename?: 'UpdateAttendanceBreakSettingPayload';
  breakSetting?: Maybe<AttendanceBreakSetting>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateAttendanceCompanySettingsVersion. */
export type UpdateAttendanceCompanySettingsVersionPayload = {
  __typename?: 'UpdateAttendanceCompanySettingsVersionPayload';
  companySettingsVersion?: Maybe<AttendanceCompanySettingsVersion>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateAttendanceCustomTimeRangeCategory. */
export type UpdateAttendanceCustomTimeRangeCategoryPayload = {
  __typename?: 'UpdateAttendanceCustomTimeRangeCategoryPayload';
  customTimeRangeCategory?: Maybe<AttendanceCustomTimeRangeCategory>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateAttendanceEditTimesheetRequest. */
export type UpdateAttendanceEditTimesheetRequestPayload = {
  __typename?: 'UpdateAttendanceEditTimesheetRequestPayload';
  editTimesheetRequest?: Maybe<AttendanceEditTimesheetRequest>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateAttendanceEmployeesPolicy. */
export type UpdateAttendanceEmployeesPolicyPayload = {
  __typename?: 'UpdateAttendanceEmployeesPolicyPayload';
  employeesPolicy?: Maybe<AttendanceEmployeesPolicy>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateAttendanceEmployeesSetting. */
export type UpdateAttendanceEmployeesSettingPayload = {
  __typename?: 'UpdateAttendanceEmployeesSettingPayload';
  employeesSetting?: Maybe<AttendanceEmployeesSetting>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateAttendanceExtraHoursRange. */
export type UpdateAttendanceExtraHoursRangePayload = {
  __typename?: 'UpdateAttendanceExtraHoursRangePayload';
  errors: Array<MutationError>;
  extraHoursRange?: Maybe<AttendanceExtraHoursRange>;
};

/** Autogenerated return type of UpdateAttendanceOvertimeRequest. */
export type UpdateAttendanceOvertimeRequestPayload = {
  __typename?: 'UpdateAttendanceOvertimeRequestPayload';
  errors: Array<MutationError>;
  overtimeRequest?: Maybe<AttendanceOvertimeRequest>;
};

/** Autogenerated return type of UpdateAttendanceShift. */
export type UpdateAttendanceShiftPayload = {
  __typename?: 'UpdateAttendanceShiftPayload';
  errors: Array<MutationError>;
  shift?: Maybe<AttendanceShift>;
};

/** Autogenerated return type of UpdateAttendanceToleranceSetting. */
export type UpdateAttendanceToleranceSettingPayload = {
  __typename?: 'UpdateAttendanceToleranceSettingPayload';
  errors: Array<MutationError>;
  toleranceSetting?: Maybe<AttendanceToleranceSetting>;
};

/** Autogenerated return type of UpdateAuthorPerformanceReviewProcessCustomTemplate. */
export type UpdateAuthorPerformanceReviewProcessCustomTemplatePayload = {
  __typename?: 'UpdateAuthorPerformanceReviewProcessCustomTemplatePayload';
  errors: Array<MutationError>;
  reviewProcessCustomTemplate?: Maybe<PerformanceReviewProcessCustomTemplate>;
};

/** Autogenerated return type of UpdateAvatarUsersPersonalInfo. */
export type UpdateAvatarUsersPersonalInfoPayload = {
  __typename?: 'UpdateAvatarUsersPersonalInfoPayload';
  errors: Array<MutationError>;
  personalInfo?: Maybe<UsersPersonalInfo>;
};

/** Autogenerated return type of UpdateBankingCardLimit. */
export type UpdateBankingCardLimitPayload = {
  __typename?: 'UpdateBankingCardLimitPayload';
  cardLimit?: Maybe<BankingCardLimit>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateBasicInfoCompetenciesCompetencyLevel. */
export type UpdateBasicInfoCompetenciesCompetencyLevelPayload = {
  __typename?: 'UpdateBasicInfoCompetenciesCompetencyLevelPayload';
  competencyLevel?: Maybe<CompetenciesCompetencyLevel>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateBasicInfoDocumentsDocument. */
export type UpdateBasicInfoDocumentsDocumentPayload = {
  __typename?: 'UpdateBasicInfoDocumentsDocumentPayload';
  document?: Maybe<DocumentsDocument>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateBasicInfoPerformanceReviewProcessCustomTemplate. */
export type UpdateBasicInfoPerformanceReviewProcessCustomTemplatePayload = {
  __typename?: 'UpdateBasicInfoPerformanceReviewProcessCustomTemplatePayload';
  errors: Array<MutationError>;
  reviewProcessCustomTemplate?: Maybe<PerformanceReviewProcessCustomTemplate>;
};

/** Autogenerated return type of UpdateBasicInfoPerformanceReviewProcess. */
export type UpdateBasicInfoPerformanceReviewProcessPayload = {
  __typename?: 'UpdateBasicInfoPerformanceReviewProcessPayload';
  errors: Array<MutationError>;
  reviewProcess?: Maybe<PerformanceReviewProcess>;
};

/** Autogenerated return type of UpdateBasicInfoTrainingsTraining. */
export type UpdateBasicInfoTrainingsTrainingPayload = {
  __typename?: 'UpdateBasicInfoTrainingsTrainingPayload';
  errors: Array<MutationError>;
  training?: Maybe<TrainingsTraining>;
};

/** Autogenerated return type of UpdateBillingCpSubscriptionAdmin. */
export type UpdateBillingCpSubscriptionAdminPayload = {
  __typename?: 'UpdateBillingCpSubscriptionAdminPayload';
  cpSubscriptionAdmin?: Maybe<BillingCpSubscriptionAdmin>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateBillingCpSubscriptionContact. */
export type UpdateBillingCpSubscriptionContactPayload = {
  __typename?: 'UpdateBillingCpSubscriptionContactPayload';
  cpSubscriptionContact?: Maybe<BillingCpSubscriptionContact>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateBookkeepersmanagementBookkeeperCompany. */
export type UpdateBookkeepersmanagementBookkeeperCompanyPayload = {
  __typename?: 'UpdateBookkeepersmanagementBookkeeperCompanyPayload';
  bookkeeperCompany?: Maybe<BookkeepersManagementBookkeeperCompany>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateBookkeepersmanagementIncidence. */
export type UpdateBookkeepersmanagementIncidencePayload = {
  __typename?: 'UpdateBookkeepersmanagementIncidencePayload';
  errors: Array<MutationError>;
  incidence?: Maybe<BookkeepersManagementIncidence>;
};

/** Autogenerated return type of UpdateBookkeepersmanagementTaskTaskStatus. */
export type UpdateBookkeepersmanagementTaskTaskStatusPayload = {
  __typename?: 'UpdateBookkeepersmanagementTaskTaskStatusPayload';
  errors: Array<MutationError>;
  taskStatus?: Maybe<BookkeepersManagementTaskStatus>;
};

/** Autogenerated return type of UpdateByFlexibleTimeRecordProjectmanagementFlexibleTimeRecordComment. */
export type UpdateByFlexibleTimeRecordProjectmanagementFlexibleTimeRecordCommentPayload = {
  __typename?: 'UpdateByFlexibleTimeRecordProjectmanagementFlexibleTimeRecordCommentPayload';
  errors: Array<MutationError>;
  flexibleTimeRecordComment?: Maybe<ProjectManagementFlexibleTimeRecordComment>;
};

/** Autogenerated return type of UpdateCategoryComplaintsComplaint. */
export type UpdateCategoryComplaintsComplaintPayload = {
  __typename?: 'UpdateCategoryComplaintsComplaintPayload';
  complaint?: Maybe<ComplaintsComplaint>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateCommunicationsEmailUsersPersonalInfo. */
export type UpdateCommunicationsEmailUsersPersonalInfoPayload = {
  __typename?: 'UpdateCommunicationsEmailUsersPersonalInfoPayload';
  errors: Array<MutationError>;
  personalInfo?: Maybe<UsersPersonalInfo>;
};

/** Autogenerated return type of UpdateCompaniesSubscriptionOverload. */
export type UpdateCompaniesSubscriptionOverloadPayload = {
  __typename?: 'UpdateCompaniesSubscriptionOverloadPayload';
  errors: Array<MutationError>;
  subscriptionOverload?: Maybe<CompaniesSubscriptionOverload>;
};

/** Autogenerated return type of UpdateCompanypagePerk. */
export type UpdateCompanypagePerkPayload = {
  __typename?: 'UpdateCompanypagePerkPayload';
  errors: Array<MutationError>;
  perk?: Maybe<CompanyPagePerk>;
};

/** Autogenerated return type of UpdateCompensationsCycle. */
export type UpdateCompensationsCyclePayload = {
  __typename?: 'UpdateCompensationsCyclePayload';
  cycle?: Maybe<CompensationsCycle>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateCompetenciesAssessmentsConfigurationPerformanceReviewProcess. */
export type UpdateCompetenciesAssessmentsConfigurationPerformanceReviewProcessPayload = {
  __typename?: 'UpdateCompetenciesAssessmentsConfigurationPerformanceReviewProcessPayload';
  errors: Array<MutationError>;
  reviewProcess?: Maybe<PerformanceReviewProcess>;
};

/** Autogenerated return type of UpdateCompetenciesCompetencyGroup. */
export type UpdateCompetenciesCompetencyGroupPayload = {
  __typename?: 'UpdateCompetenciesCompetencyGroupPayload';
  competencyGroup?: Maybe<CompetenciesCompetencyGroup>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateCompetenciesCompetency. */
export type UpdateCompetenciesCompetencyPayload = {
  __typename?: 'UpdateCompetenciesCompetencyPayload';
  competency?: Maybe<CompetenciesCompetency>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateComplaintsCategory. */
export type UpdateComplaintsCategoryPayload = {
  __typename?: 'UpdateComplaintsCategoryPayload';
  category?: Maybe<ComplaintsCategory>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateComplaintsNote. */
export type UpdateComplaintsNotePayload = {
  __typename?: 'UpdateComplaintsNotePayload';
  errors: Array<MutationError>;
  note?: Maybe<ComplaintsNote>;
};

/** Autogenerated return type of UpdateConclusionsPerformanceAgreement. */
export type UpdateConclusionsPerformanceAgreementPayload = {
  __typename?: 'UpdateConclusionsPerformanceAgreementPayload';
  agreement?: Maybe<PerformanceAgreement>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateContractsCompensation. */
export type UpdateContractsCompensationPayload = {
  __typename?: 'UpdateContractsCompensationPayload';
  compensation?: Maybe<ContractsCompensation>;
  errors: Array<MutationError>;
};

export type UpdateContractsContractVersionFlowAdditionalCompensationsInput = {
  amount?: InputMaybe<Scalars['Int']>;
  calculation?: InputMaybe<Scalars['String']>;
  compensationType?: InputMaybe<Scalars['String']>;
  contractsTaxonomyId: Scalars['Int'];
  description?: InputMaybe<Scalars['String']>;
  firstPaymentOn?: InputMaybe<Scalars['ISO8601Date']>;
  id?: InputMaybe<Scalars['Int']>;
  minimumAmountOfHours?: InputMaybe<Scalars['Int']>;
  minimumAmountOfHoursInCents?: InputMaybe<Scalars['Int']>;
  payrollPolicyId?: InputMaybe<Scalars['Int']>;
  recurrence?: InputMaybe<Scalars['String']>;
  recurrenceCount?: InputMaybe<Scalars['Int']>;
  startsOn?: InputMaybe<Scalars['ISO8601Date']>;
  syncWithSupplements?: InputMaybe<Scalars['Boolean']>;
  timeCondition?: InputMaybe<ContractsValueObjectsTimeConditionEnum>;
  unit?: InputMaybe<Scalars['String']>;
};

export type UpdateContractsContractVersionFlowCustomFieldsInput = {
  identifier: Scalars['String'];
  value?: InputMaybe<Scalars['String']>;
};

export type UpdateContractsContractVersionFlowNewAdditionalCompensationsInput = {
  amount?: InputMaybe<Scalars['Int']>;
  amountStrategyType: Scalars['String'];
  contractVersionId: Scalars['Int'];
  description?: InputMaybe<Scalars['String']>;
  firstPaymentOn?: InputMaybe<Scalars['ISO8601Date']>;
  id?: InputMaybe<Scalars['Int']>;
  payrollConceptId: Scalars['Int'];
  recurrence?: InputMaybe<Scalars['String']>;
  upperLimit?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of UpdateContractsContractVersionFlow. */
export type UpdateContractsContractVersionFlowPayload = {
  __typename?: 'UpdateContractsContractVersionFlowPayload';
  contractVersionFlow?: Maybe<ContractsContractVersionFlow>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateContractsContractVersion. */
export type UpdateContractsContractVersionPayload = {
  __typename?: 'UpdateContractsContractVersionPayload';
  contractVersion?: Maybe<ContractsContractVersion>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateContractsTerminationType. */
export type UpdateContractsTerminationTypePayload = {
  __typename?: 'UpdateContractsTerminationTypePayload';
  errors: Array<MutationError>;
  terminationType?: Maybe<ContractsTerminationType>;
};

/** Autogenerated return type of UpdateContractsWeeksPerMonthConfiguration. */
export type UpdateContractsWeeksPerMonthConfigurationPayload = {
  __typename?: 'UpdateContractsWeeksPerMonthConfigurationPayload';
  errors: Array<MutationError>;
  weeksPerMonthConfiguration?: Maybe<ContractsWeeksPerMonthConfiguration>;
};

/** Autogenerated return type of UpdateCostcentersAllocation. */
export type UpdateCostcentersAllocationPayload = {
  __typename?: 'UpdateCostcentersAllocationPayload';
  allocation?: Maybe<CostCentersAllocation>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateCostcentersConfiguration. */
export type UpdateCostcentersConfigurationPayload = {
  __typename?: 'UpdateCostcentersConfigurationPayload';
  configuration?: Maybe<CostCentersConfiguration>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateCostcentersCostCenter. */
export type UpdateCostcentersCostCenterPayload = {
  __typename?: 'UpdateCostcentersCostCenterPayload';
  costCenter?: Maybe<CostCentersCostCenter>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateCustomRangeProjectmanagementPlannedRecord. */
export type UpdateCustomRangeProjectmanagementPlannedRecordPayload = {
  __typename?: 'UpdateCustomRangeProjectmanagementPlannedRecordPayload';
  errors: Array<MutationError>;
  plannedRecords?: Maybe<Array<ProjectManagementPlannedRecord>>;
};

export type UpdateCustomfieldsFieldChoiceOptionsInput = {
  id?: InputMaybe<Scalars['Int']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateCustomfieldsField. */
export type UpdateCustomfieldsFieldPayload = {
  __typename?: 'UpdateCustomfieldsFieldPayload';
  errors: Array<MutationError>;
  field?: Maybe<CustomFieldsField>;
};

/** Autogenerated return type of UpdateCustomfieldsResourceField. */
export type UpdateCustomfieldsResourceFieldPayload = {
  __typename?: 'UpdateCustomfieldsResourceFieldPayload';
  errors: Array<MutationError>;
  resourceField?: Maybe<CustomFieldsResourceField>;
};

/** Autogenerated return type of UpdateCustomfieldsValue. */
export type UpdateCustomfieldsValuePayload = {
  __typename?: 'UpdateCustomfieldsValuePayload';
  errors: Array<MutationError>;
  value?: Maybe<CustomFieldsValue>;
};

/** Autogenerated return type of UpdateCyclePerformanceReviewProcess. */
export type UpdateCyclePerformanceReviewProcessPayload = {
  __typename?: 'UpdateCyclePerformanceReviewProcessPayload';
  errors: Array<MutationError>;
  reviewProcess?: Maybe<PerformanceReviewProcess>;
};

/** Autogenerated return type of UpdateDashboardCompanyLink. */
export type UpdateDashboardCompanyLinkPayload = {
  __typename?: 'UpdateDashboardCompanyLinkPayload';
  companyLink?: Maybe<DashboardCompanyLink>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateDashboardWidgetsConfiguration. */
export type UpdateDashboardWidgetsConfigurationPayload = {
  __typename?: 'UpdateDashboardWidgetsConfigurationPayload';
  errors: Array<MutationError>;
  widgetsConfiguration?: Maybe<DashboardWidgetsConfiguration>;
};

/** Autogenerated return type of UpdateDeadlinePerformanceReviewProcess. */
export type UpdateDeadlinePerformanceReviewProcessPayload = {
  __typename?: 'UpdateDeadlinePerformanceReviewProcessPayload';
  errors: Array<MutationError>;
  reviewProcess?: Maybe<PerformanceReviewProcess>;
};

/** Autogenerated return type of UpdateDefaultRatingScalePerformanceReviewProcessCustomTemplateQuestionnaireByStrategy. */
export type UpdateDefaultRatingScalePerformanceReviewProcessCustomTemplateQuestionnaireByStrategyPayload = {
  __typename?: 'UpdateDefaultRatingScalePerformanceReviewProcessCustomTemplateQuestionnaireByStrategyPayload';
  errors: Array<MutationError>;
  reviewProcessCustomTemplateQuestionnaireByStrategy?: Maybe<PerformanceReviewProcessCustomTemplateQuestionnaireByStrategy>;
};

/** Autogenerated return type of UpdateDefaultRatingScalePerformanceReviewQuestionnaireByStrategy. */
export type UpdateDefaultRatingScalePerformanceReviewQuestionnaireByStrategyPayload = {
  __typename?: 'UpdateDefaultRatingScalePerformanceReviewQuestionnaireByStrategyPayload';
  errors: Array<MutationError>;
  reviewQuestionnaireByStrategy?: Maybe<PerformanceReviewQuestionnaireByStrategy>;
};

/** Autogenerated return type of UpdateDetailsFinanceQuote. */
export type UpdateDetailsFinanceQuotePayload = {
  __typename?: 'UpdateDetailsFinanceQuotePayload';
  errors: Array<MutationError>;
  quote?: Maybe<FinanceQuote>;
};

/** Autogenerated return type of UpdateDocumentsDocument. */
export type UpdateDocumentsDocumentPayload = {
  __typename?: 'UpdateDocumentsDocumentPayload';
  document?: Maybe<DocumentsDocument>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateDocumentsFolder. */
export type UpdateDocumentsFolderPayload = {
  __typename?: 'UpdateDocumentsFolderPayload';
  errors: Array<MutationError>;
  folder?: Maybe<DocumentsFolder>;
};

/** Autogenerated return type of UpdateDocumentsTemplate. */
export type UpdateDocumentsTemplatePayload = {
  __typename?: 'UpdateDocumentsTemplatePayload';
  errors: Array<MutationError>;
  template?: Maybe<DocumentsTemplate>;
};

/** Autogenerated return type of UpdateDocumentsUploadProcessDocument. */
export type UpdateDocumentsUploadProcessDocumentPayload = {
  __typename?: 'UpdateDocumentsUploadProcessDocumentPayload';
  errors: Array<MutationError>;
  uploadProcessDocument?: Maybe<DocumentsUploadProcessDocument>;
};

export type UpdateEmailDetailBlocksApprovalsMaterializedApprovalsFlowEmailDetailBlocksInput = {
  key: Scalars['String'];
  keyLabel?: InputMaybe<Scalars['String']>;
  type: ApprovalsEntitiesEmailDetailBlockTypeEnum;
};

/** Autogenerated return type of UpdateEmailDetailBlocksApprovalsMaterializedApprovalsFlow. */
export type UpdateEmailDetailBlocksApprovalsMaterializedApprovalsFlowPayload = {
  __typename?: 'UpdateEmailDetailBlocksApprovalsMaterializedApprovalsFlowPayload';
  errors: Array<MutationError>;
  materializedApprovalsFlow?: Maybe<ApprovalsMaterializedApprovalsFlow>;
};

/** Autogenerated return type of UpdateEmployeePotentialScoreConfigurationPerformanceReviewProcess. */
export type UpdateEmployeePotentialScoreConfigurationPerformanceReviewProcessPayload = {
  __typename?: 'UpdateEmployeePotentialScoreConfigurationPerformanceReviewProcessPayload';
  errors: Array<MutationError>;
  reviewProcess?: Maybe<PerformanceReviewProcess>;
};

/** Autogenerated return type of UpdateEmployeeScoreConfigurationPerformanceReviewProcess. */
export type UpdateEmployeeScoreConfigurationPerformanceReviewProcessPayload = {
  __typename?: 'UpdateEmployeeScoreConfigurationPerformanceReviewProcessPayload';
  errors: Array<MutationError>;
  reviewProcess?: Maybe<PerformanceReviewProcess>;
};

/** Autogenerated return type of UpdateEmployeesEmployeeGroup. */
export type UpdateEmployeesEmployeeGroupPayload = {
  __typename?: 'UpdateEmployeesEmployeeGroupPayload';
  employeeGroup?: Maybe<EmployeesEmployeeGroup>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateEmployeesEmployee. */
export type UpdateEmployeesEmployeePayload = {
  __typename?: 'UpdateEmployeesEmployeePayload';
  employee?: Maybe<EmployeesEmployee>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateEngagementSetting. */
export type UpdateEngagementSettingPayload = {
  __typename?: 'UpdateEngagementSettingPayload';
  errors: Array<MutationError>;
  setting?: Maybe<EngagementSetting>;
};

/** Autogenerated return type of UpdateExpensesCustomizationField. */
export type UpdateExpensesCustomizationFieldPayload = {
  __typename?: 'UpdateExpensesCustomizationFieldPayload';
  customizationField?: Maybe<ExpensesCustomizationField>;
  errors: Array<MutationError>;
};

export type UpdateExpensesExpensableAllocationInput = {
  id?: InputMaybe<Scalars['Int']>;
  referenceId: Scalars['Int'];
  referenceType: Scalars['String'];
};

export type UpdateExpensesExpensableAssignmentsInput = {
  assignmentsToCreate: Array<UpdateExpensesExpensableAssignmentsToCreateInput>;
  assignmentsToUpdate: Array<UpdateExpensesExpensableAssignmentsToUpdateInput>;
};

export type UpdateExpensesExpensableAssignmentsToCreateInput = {
  costCenterId: Scalars['Int'];
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  percentage: Scalars['Float'];
  startDate: Scalars['ISO8601Date'];
};

export type UpdateExpensesExpensableAssignmentsToUpdateInput = {
  costCenterId: Scalars['Int'];
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  id: Scalars['Int'];
  markedForDeletion: Scalars['Boolean'];
  percentage: Scalars['Float'];
  startDate: Scalars['ISO8601Date'];
};

export type UpdateExpensesExpensableCostCentersInput = {
  allocation?: InputMaybe<UpdateExpensesExpensableAllocationInput>;
  assignments?: InputMaybe<UpdateExpensesExpensableAssignmentsInput>;
};

export type UpdateExpensesExpensableExpenseInput = {
  accessToken?: InputMaybe<Scalars['String']>;
  amount?: InputMaybe<Scalars['Int']>;
  budgetId?: InputMaybe<Scalars['Int']>;
  category?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['Int']>;
  currency?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  documentNumber?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<Scalars['String']>;
  effectiveOn?: InputMaybe<Scalars['ISO8601DateTime']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  exchangeRate?: InputMaybe<Scalars['Float']>;
  files: Array<Scalars['File']>;
  filesIdToRemove?: InputMaybe<Array<Scalars['Int']>>;
  groupId?: InputMaybe<Scalars['Int']>;
  internalReference?: InputMaybe<Scalars['String']>;
  mcc?: InputMaybe<Scalars['String']>;
  merchantName?: InputMaybe<Scalars['String']>;
  merchantTin?: InputMaybe<Scalars['String']>;
  notifyCreator?: InputMaybe<Scalars['Boolean']>;
  overrideApprovalFlow?: InputMaybe<Scalars['Boolean']>;
  payment?: InputMaybe<ExpensesValueObjectsPaymentOptionsEnum>;
  paymentMethod?: InputMaybe<Scalars['String']>;
  projects?: InputMaybe<Array<ExpensesProjectInput>>;
  reference?: InputMaybe<Scalars['String']>;
  signedDocumentId?: InputMaybe<Scalars['Int']>;
  signedForOrganization?: InputMaybe<Scalars['String']>;
  subcategory?: InputMaybe<Scalars['String']>;
  taxes: Array<UpdateExpensesExpensableTaxesInput>;
  userMerchant?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateExpensesExpensableGroup. */
export type UpdateExpensesExpensableGroupPayload = {
  __typename?: 'UpdateExpensesExpensableGroupPayload';
  errors: Array<MutationError>;
  expensableGroup?: Maybe<ExpensesExpensableGroup>;
};

export type UpdateExpensesExpensableMileageNewInput = {
  amount?: InputMaybe<Scalars['Int']>;
  budgetId?: InputMaybe<Scalars['Int']>;
  calculatedMileage?: InputMaybe<Scalars['Int']>;
  categoryId?: InputMaybe<Scalars['Int']>;
  currency?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  destinationLatitude?: InputMaybe<Scalars['Float']>;
  destinationLongitude?: InputMaybe<Scalars['Float']>;
  effectiveOn?: InputMaybe<Scalars['ISO8601DateTime']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  files: Array<Scalars['File']>;
  filesIdToRemove?: InputMaybe<Array<Scalars['Int']>>;
  from?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['Int']>;
  internalReference?: InputMaybe<Scalars['String']>;
  mileage?: InputMaybe<Scalars['Int']>;
  notifyCreator?: InputMaybe<Scalars['Boolean']>;
  originLatitude?: InputMaybe<Scalars['Float']>;
  originLongitude?: InputMaybe<Scalars['Float']>;
  overrideApprovalFlow?: InputMaybe<Scalars['Boolean']>;
  projects?: InputMaybe<Array<ExpensesProjectInput>>;
  rate?: InputMaybe<Scalars['String']>;
  roundTrip?: InputMaybe<Scalars['Boolean']>;
  signedForOrganization?: InputMaybe<Scalars['String']>;
  subcategory?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
  units?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateExpensesExpensable. */
export type UpdateExpensesExpensablePayload = {
  __typename?: 'UpdateExpensesExpensablePayload';
  errors: Array<MutationError>;
  expensable?: Maybe<ExpensesExpensable>;
};

export type UpdateExpensesExpensablePerDiemInput = {
  amount?: InputMaybe<Scalars['Int']>;
  budgetId?: InputMaybe<Scalars['Int']>;
  categoryId?: InputMaybe<Scalars['Int']>;
  companyId: Scalars['Int'];
  currency?: InputMaybe<Scalars['String']>;
  deletedRates?: InputMaybe<Array<Scalars['Int']>>;
  description?: InputMaybe<Scalars['String']>;
  effectiveOn?: InputMaybe<Scalars['ISO8601DateTime']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  endDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  files: Array<Scalars['File']>;
  filesIdToRemove?: InputMaybe<Array<Scalars['Int']>>;
  from?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['Int']>;
  internalReference?: InputMaybe<Scalars['String']>;
  notifyCreator?: InputMaybe<Scalars['Boolean']>;
  overrideApprovalFlow?: InputMaybe<Scalars['Boolean']>;
  projects?: InputMaybe<Array<ExpensesProjectInput>>;
  rates: Array<UpdateExpensesExpensableRatesInput>;
  signedForOrganization?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  subcategory?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
};

export type UpdateExpensesExpensableRatesInput = {
  id?: InputMaybe<Scalars['Int']>;
  rateConfigurationId: Scalars['Int'];
  totalAmountCents: Scalars['Int'];
  totalDays: Scalars['Int'];
};

export type UpdateExpensesExpensableTaxesInput = {
  amount?: InputMaybe<Scalars['Int']>;
  baseAmount?: InputMaybe<Scalars['Int']>;
  percentage?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<ExpensesCustomizationExpenseTaxesTypesEnum>;
};

/** Autogenerated return type of UpdateExpensesRateConfiguration. */
export type UpdateExpensesRateConfigurationPayload = {
  __typename?: 'UpdateExpensesRateConfigurationPayload';
  errors: Array<MutationError>;
  rateConfiguration?: Maybe<ExpensesRateConfiguration>;
};

/** Autogenerated return type of UpdateExpensesRecommendationResult. */
export type UpdateExpensesRecommendationResultPayload = {
  __typename?: 'UpdateExpensesRecommendationResultPayload';
  errors: Array<MutationError>;
  recommendationResult?: Maybe<ExpensesRecommendationResult>;
};

export type UpdateExpensesSignedInvoiceEqualizationTaxInput = {
  amount?: InputMaybe<Scalars['Int']>;
  baseAmount?: InputMaybe<Scalars['Int']>;
  percentage?: InputMaybe<Scalars['Float']>;
};

export type UpdateExpensesSignedInvoiceIrpfInput = {
  amount?: InputMaybe<Scalars['Int']>;
  baseAmount?: InputMaybe<Scalars['Int']>;
  percentage?: InputMaybe<Scalars['Float']>;
};

/** Autogenerated return type of UpdateExpensesSignedInvoice. */
export type UpdateExpensesSignedInvoicePayload = {
  __typename?: 'UpdateExpensesSignedInvoicePayload';
  errors: Array<MutationError>;
  signedInvoice?: Maybe<ExpensesSignedInvoice>;
};

export type UpdateExpensesSignedInvoiceTaxesInput = {
  equalizationTax?: InputMaybe<UpdateExpensesSignedInvoiceEqualizationTaxInput>;
  irpf?: InputMaybe<UpdateExpensesSignedInvoiceIrpfInput>;
  vats: Array<UpdateExpensesSignedInvoiceVatsInput>;
};

export type UpdateExpensesSignedInvoiceVatsInput = {
  amount?: InputMaybe<Scalars['Int']>;
  baseAmount?: InputMaybe<Scalars['Int']>;
  percentage?: InputMaybe<Scalars['Float']>;
};

/** Autogenerated return type of UpdateFeaturesPerformanceReviewProcessCustomTemplate. */
export type UpdateFeaturesPerformanceReviewProcessCustomTemplatePayload = {
  __typename?: 'UpdateFeaturesPerformanceReviewProcessCustomTemplatePayload';
  errors: Array<MutationError>;
  reviewProcessCustomTemplate?: Maybe<PerformanceReviewProcessCustomTemplate>;
};

/** Autogenerated return type of UpdateFillableDocumentDocumentsDocument. */
export type UpdateFillableDocumentDocumentsDocumentPayload = {
  __typename?: 'UpdateFillableDocumentDocumentsDocumentPayload';
  document?: Maybe<DocumentsDocument>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateFinanceAccount. */
export type UpdateFinanceAccountPayload = {
  __typename?: 'UpdateFinanceAccountPayload';
  account?: Maybe<FinanceAccount>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateFinanceBudgetAllocation. */
export type UpdateFinanceBudgetAllocationPayload = {
  __typename?: 'UpdateFinanceBudgetAllocationPayload';
  budgetAllocation?: Maybe<FinanceBudgetAllocation>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateFinanceBudget. */
export type UpdateFinanceBudgetPayload = {
  __typename?: 'UpdateFinanceBudgetPayload';
  budget?: Maybe<FinanceBudget>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateFinanceContact. */
export type UpdateFinanceContactPayload = {
  __typename?: 'UpdateFinanceContactPayload';
  contact?: Maybe<FinanceContact>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateFinanceCustomCategory. */
export type UpdateFinanceCustomCategoryPayload = {
  __typename?: 'UpdateFinanceCustomCategoryPayload';
  customCategory?: Maybe<FinanceCustomCategory>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateFinanceDeal. */
export type UpdateFinanceDealPayload = {
  __typename?: 'UpdateFinanceDealPayload';
  deal?: Maybe<FinanceDeal>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateFinanceFinancialDocument. */
export type UpdateFinanceFinancialDocumentPayload = {
  __typename?: 'UpdateFinanceFinancialDocumentPayload';
  errors: Array<MutationError>;
  financialDocument?: Maybe<FinanceFinancialDocument>;
};

export type UpdateFinanceJournalDraftEntryLinesInput = {
  accountId?: InputMaybe<Scalars['Int']>;
  creditAmountCents: Scalars['Int'];
  debitAmountCents: Scalars['Int'];
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of UpdateFinanceJournalDraftEntry. */
export type UpdateFinanceJournalDraftEntryPayload = {
  __typename?: 'UpdateFinanceJournalDraftEntryPayload';
  errors: Array<MutationError>;
  journalDraftEntry?: Maybe<FinanceJournalDraftEntry>;
};

/** Autogenerated return type of UpdateFinanceQuote. */
export type UpdateFinanceQuotePayload = {
  __typename?: 'UpdateFinanceQuotePayload';
  errors: Array<MutationError>;
  quote?: Maybe<FinanceQuote>;
};

/** Autogenerated return type of UpdateFinanceSalesDocumentTemplate. */
export type UpdateFinanceSalesDocumentTemplatePayload = {
  __typename?: 'UpdateFinanceSalesDocumentTemplatePayload';
  errors: Array<MutationError>;
  salesDocumentTemplate?: Maybe<FinanceSalesDocumentTemplate>;
};

/** Autogenerated return type of UpdateFinanceSpendingPolicySpendingPolicyAssignee. */
export type UpdateFinanceSpendingPolicySpendingPolicyAssigneePayload = {
  __typename?: 'UpdateFinanceSpendingPolicySpendingPolicyAssigneePayload';
  errors: Array<MutationError>;
  spendingPolicyAssignee?: Maybe<FinanceSpendingPolicyAssignee>;
};

export type UpdateFinanceSpendingPolicySpendingPolicyAssigneePeopleGroupInput = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
};

/** Autogenerated return type of UpdateFinanceSpendingPolicySpendingPolicy. */
export type UpdateFinanceSpendingPolicySpendingPolicyPayload = {
  __typename?: 'UpdateFinanceSpendingPolicySpendingPolicyPayload';
  errors: Array<MutationError>;
  spendingPolicy?: Maybe<FinanceSpendingPolicy>;
};

/** Autogenerated return type of UpdateFinanceSpendingPolicySpendingPolicyRuleGroup. */
export type UpdateFinanceSpendingPolicySpendingPolicyRuleGroupPayload = {
  __typename?: 'UpdateFinanceSpendingPolicySpendingPolicyRuleGroupPayload';
  errors: Array<MutationError>;
  spendingPolicyRuleGroup?: Maybe<FinanceSpendingPolicyRuleGroup>;
};

export type UpdateFinanceSpendingPolicySpendingPolicyRuleGroupRulesInput = {
  id: Scalars['String'];
  value: Array<Scalars['String']>;
};

/** Autogenerated return type of UpdateFinanceTaxRate. */
export type UpdateFinanceTaxRatePayload = {
  __typename?: 'UpdateFinanceTaxRatePayload';
  errors: Array<MutationError>;
  taxRate?: Maybe<FinanceTaxRate>;
};

export type UpdateFinanceTaxTypeLedgerAccountAssignmentsInput = {
  ledgerAccountId: Scalars['Int'];
  ledgerAccountResourceId?: InputMaybe<Scalars['Int']>;
  legalEntityId: Scalars['Int'];
  operationType?: InputMaybe<FinanceValueObjectsLedgerAccountOperationTypeEnum>;
};

/** Autogenerated return type of UpdateFinanceTaxType. */
export type UpdateFinanceTaxTypePayload = {
  __typename?: 'UpdateFinanceTaxTypePayload';
  errors: Array<MutationError>;
  taxType?: Maybe<FinanceTaxType>;
};

/** Autogenerated return type of UpdateFinancialDetailsProjectmanagementProject. */
export type UpdateFinancialDetailsProjectmanagementProjectPayload = {
  __typename?: 'UpdateFinancialDetailsProjectmanagementProjectPayload';
  errors: Array<MutationError>;
  project?: Maybe<ProjectManagementProject>;
};

export type UpdateFinancialworkspaceSettingLaborCostConceptsInput = {
  conceptId: Scalars['Int'];
  laborCostCalculationType: FinancialWorkspaceValueObjectsLaborCostCalculationTypeEnum;
};

/** Autogenerated return type of UpdateFinancialworkspaceSetting. */
export type UpdateFinancialworkspaceSettingPayload = {
  __typename?: 'UpdateFinancialworkspaceSettingPayload';
  errors: Array<MutationError>;
  setting?: Maybe<FinancialWorkspaceSetting>;
};

/** Autogenerated return type of UpdateFormsCycle. */
export type UpdateFormsCyclePayload = {
  __typename?: 'UpdateFormsCyclePayload';
  cycle?: Maybe<FormsCycle>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateFormsElement. */
export type UpdateFormsElementPayload = {
  __typename?: 'UpdateFormsElementPayload';
  element?: Maybe<FormsElement>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateFormsForm. */
export type UpdateFormsFormPayload = {
  __typename?: 'UpdateFormsFormPayload';
  errors: Array<MutationError>;
  form?: Maybe<FormsForm>;
};

/** Autogenerated return type of UpdateFormsQuestion. */
export type UpdateFormsQuestionPayload = {
  __typename?: 'UpdateFormsQuestionPayload';
  errors: Array<MutationError>;
  question?: Maybe<FormsQuestion>;
};

/** Autogenerated return type of UpdateFormsSchedule. */
export type UpdateFormsSchedulePayload = {
  __typename?: 'UpdateFormsSchedulePayload';
  errors: Array<MutationError>;
  schedule?: Maybe<FormsSchedule>;
};

/** Autogenerated return type of UpdateFromDocumentExpensesExpensable. */
export type UpdateFromDocumentExpensesExpensablePayload = {
  __typename?: 'UpdateFromDocumentExpensesExpensablePayload';
  errors: Array<MutationError>;
  expensable?: Maybe<ExpensesExpensable>;
};

/** Autogenerated return type of UpdateFromSyncScanFileFinanceFinancialDocument. */
export type UpdateFromSyncScanFileFinanceFinancialDocumentPayload = {
  __typename?: 'UpdateFromSyncScanFileFinanceFinancialDocumentPayload';
  errors: Array<MutationError>;
  financialDocument?: Maybe<FinanceFinancialDocument>;
};

/** Autogenerated return type of UpdateGoalsMetricGroup. */
export type UpdateGoalsMetricGroupPayload = {
  __typename?: 'UpdateGoalsMetricGroupPayload';
  errors: Array<MutationError>;
  metricGroup?: Maybe<GoalsMetricGroup>;
};

/** Autogenerated return type of UpdateGoalsMetric. */
export type UpdateGoalsMetricPayload = {
  __typename?: 'UpdateGoalsMetricPayload';
  errors: Array<MutationError>;
  metric?: Maybe<GoalsMetric>;
};

/** Autogenerated return type of UpdateHandbookpagesPage. */
export type UpdateHandbookpagesPagePayload = {
  __typename?: 'UpdateHandbookpagesPagePayload';
  errors: Array<MutationError>;
  page?: Maybe<HandbookPagesPage>;
};

/** Autogenerated return type of UpdateHolidaysCompanyHoliday. */
export type UpdateHolidaysCompanyHolidayPayload = {
  __typename?: 'UpdateHolidaysCompanyHolidayPayload';
  companyHoliday?: Maybe<HolidaysCompanyHoliday>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateImportersImporterProcess. */
export type UpdateImportersImporterProcessPayload = {
  __typename?: 'UpdateImportersImporterProcessPayload';
  errors: Array<MutationError>;
  importerProcess?: Maybe<ImportersImporterProcess>;
};

/** Autogenerated return type of UpdateImputedMinutesProjectmanagementGlobalTimeRecord. */
export type UpdateImputedMinutesProjectmanagementGlobalTimeRecordPayload = {
  __typename?: 'UpdateImputedMinutesProjectmanagementGlobalTimeRecordPayload';
  errors: Array<MutationError>;
  globalTimeRecord?: Maybe<ProjectManagementGlobalTimeRecord>;
};

/** Autogenerated return type of UpdateInBulkEmployeesEmployee. */
export type UpdateInBulkEmployeesEmployeePayload = {
  __typename?: 'UpdateInBulkEmployeesEmployeePayload';
  employee?: Maybe<EmployeesEmployee>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateInitialTimeoffPolicyAssignment. */
export type UpdateInitialTimeoffPolicyAssignmentPayload = {
  __typename?: 'UpdateInitialTimeoffPolicyAssignmentPayload';
  errors: Array<MutationError>;
  policyAssignment?: Maybe<TimeoffPolicyAssignment>;
};

/** Autogenerated return type of UpdateIntegrationsdatevlaudsRequest. */
export type UpdateIntegrationsdatevlaudsRequestPayload = {
  __typename?: 'UpdateIntegrationsdatevlaudsRequestPayload';
  errors: Array<MutationError>;
  request?: Maybe<IntegrationsDatevLaudsRequest>;
};

/** Autogenerated return type of UpdateIntegrationsindeedAccount. */
export type UpdateIntegrationsindeedAccountPayload = {
  __typename?: 'UpdateIntegrationsindeedAccountPayload';
  account?: Maybe<IntegrationsIndeedAccount>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateIntegrationsindeedApplication. */
export type UpdateIntegrationsindeedApplicationPayload = {
  __typename?: 'UpdateIntegrationsindeedApplicationPayload';
  application?: Maybe<IntegrationsIndeedApplication>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateIntegrationsinfojobsOffer. */
export type UpdateIntegrationsinfojobsOfferPayload = {
  __typename?: 'UpdateIntegrationsinfojobsOfferPayload';
  errors: Array<MutationError>;
  offer?: Maybe<IntegrationsInfojobsOffer>;
};

/** Autogenerated return type of UpdateIntegrationsjoinIntegration. */
export type UpdateIntegrationsjoinIntegrationPayload = {
  __typename?: 'UpdateIntegrationsjoinIntegrationPayload';
  errors: Array<MutationError>;
  integration?: Maybe<IntegrationsJoinIntegration>;
};

/** Autogenerated return type of UpdateIntegrationsjoinJobPosting. */
export type UpdateIntegrationsjoinJobPostingPayload = {
  __typename?: 'UpdateIntegrationsjoinJobPostingPayload';
  errors: Array<MutationError>;
  jobPosting?: Maybe<IntegrationsJoinJobPosting>;
};

/** Autogenerated return type of UpdateIntegrationsjoinJoinCompany. */
export type UpdateIntegrationsjoinJoinCompanyPayload = {
  __typename?: 'UpdateIntegrationsjoinJoinCompanyPayload';
  errors: Array<MutationError>;
  joinCompany?: Maybe<IntegrationsJoinJoinCompany>;
};

/** Autogenerated return type of UpdateIntegrationsjoinOffice. */
export type UpdateIntegrationsjoinOfficePayload = {
  __typename?: 'UpdateIntegrationsjoinOfficePayload';
  errors: Array<MutationError>;
  office?: Maybe<IntegrationsJoinOffice>;
};

/** Autogenerated return type of UpdateInternalInfoTrainingsTraining. */
export type UpdateInternalInfoTrainingsTrainingPayload = {
  __typename?: 'UpdateInternalInfoTrainingsTrainingPayload';
  errors: Array<MutationError>;
  training?: Maybe<TrainingsTraining>;
};

/** Autogenerated return type of UpdateItmanagementDocumentTemplate. */
export type UpdateItmanagementDocumentTemplatePayload = {
  __typename?: 'UpdateItmanagementDocumentTemplatePayload';
  documentTemplate?: Maybe<ItManagementDocumentTemplate>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateItmanagementItAssetModel. */
export type UpdateItmanagementItAssetModelPayload = {
  __typename?: 'UpdateItmanagementItAssetModelPayload';
  errors: Array<MutationError>;
  itAssetModel?: Maybe<ItManagementItAssetModel>;
};

/** Autogenerated return type of UpdateItmanagementItAsset. */
export type UpdateItmanagementItAssetPayload = {
  __typename?: 'UpdateItmanagementItAssetPayload';
  errors: Array<MutationError>;
  itAsset?: Maybe<ItManagementItAsset>;
};

/** Autogenerated return type of UpdateJobcatalogLevel. */
export type UpdateJobcatalogLevelPayload = {
  __typename?: 'UpdateJobcatalogLevelPayload';
  errors: Array<MutationError>;
  level?: Maybe<JobCatalogLevel>;
};

/** Autogenerated return type of UpdateJobcatalogNodeAttribute. */
export type UpdateJobcatalogNodeAttributePayload = {
  __typename?: 'UpdateJobcatalogNodeAttributePayload';
  errors: Array<MutationError>;
  nodeAttribute?: Maybe<JobCatalogNodeAttribute>;
};

/** Autogenerated return type of UpdateJobcatalogRole. */
export type UpdateJobcatalogRolePayload = {
  __typename?: 'UpdateJobcatalogRolePayload';
  errors: Array<MutationError>;
  role?: Maybe<JobCatalogRole>;
};

/** Autogenerated return type of UpdateJobcatalogSalaryRange. */
export type UpdateJobcatalogSalaryRangePayload = {
  __typename?: 'UpdateJobcatalogSalaryRangePayload';
  errors: Array<MutationError>;
  salaryRange?: Maybe<JobCatalogSalaryRange>;
};

/** Autogenerated return type of UpdateJobcatalogTreeNode. */
export type UpdateJobcatalogTreeNodePayload = {
  __typename?: 'UpdateJobcatalogTreeNodePayload';
  errors: Array<MutationError>;
  treeNode?: Maybe<JobCatalogTreeNode>;
};

/** Autogenerated return type of UpdateLaborCostPayrollLaborCostConfiguration. */
export type UpdateLaborCostPayrollLaborCostConfigurationPayload = {
  __typename?: 'UpdateLaborCostPayrollLaborCostConfigurationPayload';
  errors: Array<MutationError>;
  laborCostConfigurations?: Maybe<Array<PayrollLaborCostConfiguration>>;
};

/** Autogenerated return type of UpdateLayoutFavourite. */
export type UpdateLayoutFavouritePayload = {
  __typename?: 'UpdateLayoutFavouritePayload';
  errors: Array<MutationError>;
  favourite?: Maybe<LayoutFavourite>;
};

/** Autogenerated return type of UpdateLocationsLocation. */
export type UpdateLocationsLocationPayload = {
  __typename?: 'UpdateLocationsLocationPayload';
  errors: Array<MutationError>;
  location?: Maybe<LocationsLocation>;
};

/** Autogenerated return type of UpdateLocationsWorkArea. */
export type UpdateLocationsWorkAreaPayload = {
  __typename?: 'UpdateLocationsWorkAreaPayload';
  errors: Array<MutationError>;
  workArea?: Maybe<LocationsWorkArea>;
};

/** Autogenerated return type of UpdateMarketplaceCompanyInstallation. */
export type UpdateMarketplaceCompanyInstallationPayload = {
  __typename?: 'UpdateMarketplaceCompanyInstallationPayload';
  companyInstallation?: Maybe<MarketplaceCompanyInstallation>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateMeetingsAttendee. */
export type UpdateMeetingsAttendeePayload = {
  __typename?: 'UpdateMeetingsAttendeePayload';
  attendee?: Maybe<MeetingsAttendee>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateMeetingsMeeting. */
export type UpdateMeetingsMeetingPayload = {
  __typename?: 'UpdateMeetingsMeetingPayload';
  errors: Array<MutationError>;
  meeting?: Maybe<MeetingsMeeting>;
};

/** Autogenerated return type of UpdateMeetingsSetting. */
export type UpdateMeetingsSettingPayload = {
  __typename?: 'UpdateMeetingsSettingPayload';
  errors: Array<MutationError>;
  setting?: Maybe<MeetingsSetting>;
};

/** Autogenerated return type of UpdateMeetingsTemplate. */
export type UpdateMeetingsTemplatePayload = {
  __typename?: 'UpdateMeetingsTemplatePayload';
  errors: Array<MutationError>;
  template?: Maybe<MeetingsTemplate>;
};

/** Autogenerated return type of UpdateMembersFeaturesFeatureMembership. */
export type UpdateMembersFeaturesFeatureMembershipPayload = {
  __typename?: 'UpdateMembersFeaturesFeatureMembershipPayload';
  errors: Array<MutationError>;
  featureMembership?: Maybe<FeaturesFeatureMembership>;
};

/** Autogenerated return type of UpdateNameFinanceSerialSequenceCreditNoteSequence. */
export type UpdateNameFinanceSerialSequenceCreditNoteSequencePayload = {
  __typename?: 'UpdateNameFinanceSerialSequenceCreditNoteSequencePayload';
  creditNoteSequence?: Maybe<FinanceCreditNoteSequence>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateNameFinanceSerialSequenceSalesInvoiceSequence. */
export type UpdateNameFinanceSerialSequenceSalesInvoiceSequencePayload = {
  __typename?: 'UpdateNameFinanceSerialSequenceSalesInvoiceSequencePayload';
  errors: Array<MutationError>;
  salesInvoiceSequence?: Maybe<FinanceSalesInvoiceSequence>;
};

/** Autogenerated return type of UpdateNotificationsAccessNotificationSetting. */
export type UpdateNotificationsAccessNotificationSettingPayload = {
  __typename?: 'UpdateNotificationsAccessNotificationSettingPayload';
  accessNotificationSetting?: Maybe<NotificationsAccessNotificationSetting>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateNotificationsAccessNotifierScope. */
export type UpdateNotificationsAccessNotifierScopePayload = {
  __typename?: 'UpdateNotificationsAccessNotifierScopePayload';
  accessNotifierScope?: Maybe<NotificationsAccessNotifierScope>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateNpsSurveyResponseIntent. */
export type UpdateNpsSurveyResponseIntentPayload = {
  __typename?: 'UpdateNpsSurveyResponseIntentPayload';
  errors: Array<MutationError>;
  surveyResponseIntent?: Maybe<NpsSurveyResponseIntent>;
};

/** Autogenerated return type of UpdateOpenaiFeedback. */
export type UpdateOpenaiFeedbackPayload = {
  __typename?: 'UpdateOpenaiFeedbackPayload';
  errors: Array<MutationError>;
  feedback?: Maybe<OpenAiFeedback>;
};

/** Autogenerated return type of UpdatePagesPage. */
export type UpdatePagesPagePayload = {
  __typename?: 'UpdatePagesPagePayload';
  errors: Array<MutationError>;
  page?: Maybe<PagesPage>;
};

/** Autogenerated return type of UpdatePaymentDetailsFinanceContact. */
export type UpdatePaymentDetailsFinanceContactPayload = {
  __typename?: 'UpdatePaymentDetailsFinanceContactPayload';
  contact?: Maybe<FinanceContact>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdatePayrollConcept. */
export type UpdatePayrollConceptPayload = {
  __typename?: 'UpdatePayrollConceptPayload';
  concept?: Maybe<PayrollConcept>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdatePayrollExpensesCategoriesContractsTaxonomy. */
export type UpdatePayrollExpensesCategoriesContractsTaxonomyPayload = {
  __typename?: 'UpdatePayrollExpensesCategoriesContractsTaxonomyPayload';
  errors: Array<MutationError>;
  expensesCategoriesContractsTaxonomy?: Maybe<PayrollExpensesCategoriesContractsTaxonomy>;
};

/** Autogenerated return type of UpdatePayrollFamilySituation. */
export type UpdatePayrollFamilySituationPayload = {
  __typename?: 'UpdatePayrollFamilySituationPayload';
  errors: Array<MutationError>;
  familySituation?: Maybe<PayrollFamilySituation>;
};

/** Autogenerated return type of UpdatePayrollPayrollSummaryImport. */
export type UpdatePayrollPayrollSummaryImportPayload = {
  __typename?: 'UpdatePayrollPayrollSummaryImportPayload';
  errors: Array<MutationError>;
  payrollSummaryImport?: Maybe<PayrollPayrollSummaryImport>;
};

/** Autogenerated return type of UpdatePayrollReimbursableSupplementTaxonomy. */
export type UpdatePayrollReimbursableSupplementTaxonomyPayload = {
  __typename?: 'UpdatePayrollReimbursableSupplementTaxonomyPayload';
  errors: Array<MutationError>;
  reimbursableSupplementTaxonomy?: Maybe<PayrollReimbursableSupplementTaxonomy>;
};

/** Autogenerated return type of UpdatePayrollResultLabelConceptMapping. */
export type UpdatePayrollResultLabelConceptMappingPayload = {
  __typename?: 'UpdatePayrollResultLabelConceptMappingPayload';
  errors: Array<MutationError>;
  resultLabelConceptMapping?: Maybe<PayrollResultLabelConceptMapping>;
};

/** Autogenerated return type of UpdatePayrollSupplementDescription. */
export type UpdatePayrollSupplementDescriptionPayload = {
  __typename?: 'UpdatePayrollSupplementDescriptionPayload';
  errors: Array<MutationError>;
  supplementDescription?: Maybe<PayrollSupplementDescription>;
};

/** Autogenerated return type of UpdatePayrollSupplementObservation. */
export type UpdatePayrollSupplementObservationPayload = {
  __typename?: 'UpdatePayrollSupplementObservationPayload';
  errors: Array<MutationError>;
  supplementObservation?: Maybe<PayrollSupplementObservation>;
};

/** Autogenerated return type of UpdatePayrollSupplement. */
export type UpdatePayrollSupplementPayload = {
  __typename?: 'UpdatePayrollSupplementPayload';
  errors: Array<MutationError>;
  supplement?: Maybe<PayrollSupplement>;
};

/** Autogenerated return type of UpdatePayrollemployeesEmployeeDatum. */
export type UpdatePayrollemployeesEmployeeDatumPayload = {
  __typename?: 'UpdatePayrollemployeesEmployeeDatumPayload';
  employeeDatum?: Maybe<PayrollEmployeesEmployeeDatum>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdatePayrollemployeesIdentifier. */
export type UpdatePayrollemployeesIdentifierPayload = {
  __typename?: 'UpdatePayrollemployeesIdentifierPayload';
  errors: Array<MutationError>;
  identifier?: Maybe<PayrollEmployeesIdentifier>;
};

/** Autogenerated return type of UpdatePayrollintegrationsBaseCode. */
export type UpdatePayrollintegrationsBaseCodePayload = {
  __typename?: 'UpdatePayrollintegrationsBaseCodePayload';
  code?: Maybe<PayrollIntegrationsBaseCode>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdatePerformanceAgreementActionItem. */
export type UpdatePerformanceAgreementActionItemPayload = {
  __typename?: 'UpdatePerformanceAgreementActionItemPayload';
  agreementActionItem?: Maybe<PerformanceAgreementActionItem>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdatePerformanceReviewVisibilitySetting. */
export type UpdatePerformanceReviewVisibilitySettingPayload = {
  __typename?: 'UpdatePerformanceReviewVisibilitySettingPayload';
  errors: Array<MutationError>;
  reviewVisibilitySetting?: Maybe<PerformanceReviewVisibilitySetting>;
};

/** Autogenerated return type of UpdatePerformancecyclesCycle. */
export type UpdatePerformancecyclesCyclePayload = {
  __typename?: 'UpdatePerformancecyclesCyclePayload';
  cycle?: Maybe<PerformanceCyclesCycle>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdatePermissionsPermissionGroup. */
export type UpdatePermissionsPermissionGroupPayload = {
  __typename?: 'UpdatePermissionsPermissionGroupPayload';
  errors: Array<MutationError>;
  permissionGroup?: Maybe<PermissionsPermissionGroup>;
};

/** Autogenerated return type of UpdatePositionsApprovalsRulesConfiguration. */
export type UpdatePositionsApprovalsRulesConfigurationPayload = {
  __typename?: 'UpdatePositionsApprovalsRulesConfigurationPayload';
  errors: Array<MutationError>;
  rulesConfigurations?: Maybe<Array<ApprovalsRulesConfiguration>>;
};

export type UpdatePositionsApprovalsRulesConfigurationPositionsInput = {
  id: Scalars['Int'];
  position: Scalars['Int'];
};

export type UpdatePositionsAtsApplicationPhaseNewPositionsInput = {
  atsApplicationPhaseId: Scalars['Int'];
  newPosition: Scalars['Int'];
};

/** Autogenerated return type of UpdatePositionsAtsApplicationPhase. */
export type UpdatePositionsAtsApplicationPhasePayload = {
  __typename?: 'UpdatePositionsAtsApplicationPhasePayload';
  applicationPhases?: Maybe<Array<AtsApplicationPhase>>;
  errors: Array<MutationError>;
};

export type UpdatePositionsAtsHiringPhaseNewPositionsInput = {
  atsHiringPhaseId: Scalars['Int'];
  newPosition: Scalars['Int'];
};

/** Autogenerated return type of UpdatePositionsAtsHiringPhase. */
export type UpdatePositionsAtsHiringPhasePayload = {
  __typename?: 'UpdatePositionsAtsHiringPhasePayload';
  errors: Array<MutationError>;
  hiringPhases?: Maybe<Array<AtsHiringPhase>>;
};

/** Autogenerated return type of UpdatePositionsPosition. */
export type UpdatePositionsPositionPayload = {
  __typename?: 'UpdatePositionsPositionPayload';
  errors: Array<MutationError>;
  position?: Maybe<PositionsPosition>;
};

/** Autogenerated return type of UpdatePostsComment. */
export type UpdatePostsCommentPayload = {
  __typename?: 'UpdatePostsCommentPayload';
  comment?: Maybe<PostsComment>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdatePostsGroup. */
export type UpdatePostsGroupPayload = {
  __typename?: 'UpdatePostsGroupPayload';
  errors: Array<MutationError>;
  group?: Maybe<PostsGroup>;
};

/** Autogenerated return type of UpdatePostsPost. */
export type UpdatePostsPostPayload = {
  __typename?: 'UpdatePostsPostPayload';
  errors: Array<MutationError>;
  post?: Maybe<PostsPost>;
};

export type UpdateProcurementPurchaseOrderCardPaymentDetailsInput = {
  amountLimitCents: Scalars['Int'];
  cardAlias: Scalars['String'];
  cardholderData?: InputMaybe<UpdateProcurementPurchaseOrderCardholderDataInput>;
  employeeId: Scalars['Int'];
};

export type UpdateProcurementPurchaseOrderCardholderDataInput = {
  dateOfBirth: Scalars['ISO8601Date'];
  email?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phoneCountryCode: Scalars['String'];
  phoneNumber: Scalars['String'];
};

/** Autogenerated return type of UpdateProcurementPurchaseOrder. */
export type UpdateProcurementPurchaseOrderPayload = {
  __typename?: 'UpdateProcurementPurchaseOrderPayload';
  errors: Array<MutationError>;
  purchaseOrder?: Maybe<ProcurementPurchaseOrder>;
};

/** Autogenerated return type of UpdateProcurementPurchaseRequest. */
export type UpdateProcurementPurchaseRequestPayload = {
  __typename?: 'UpdateProcurementPurchaseRequestPayload';
  errors: Array<MutationError>;
  purchaseRequest?: Maybe<ProcurementPurchaseRequest>;
};

/** Autogenerated return type of UpdateProcurementType. */
export type UpdateProcurementTypePayload = {
  __typename?: 'UpdateProcurementTypePayload';
  errors: Array<MutationError>;
  type?: Maybe<ProcurementType>;
};

/** Autogenerated return type of UpdateProjectWorkerProjectmanagementTimeRecord. */
export type UpdateProjectWorkerProjectmanagementTimeRecordPayload = {
  __typename?: 'UpdateProjectWorkerProjectmanagementTimeRecordPayload';
  errors: Array<MutationError>;
  timeRecord?: Maybe<ProjectManagementTimeRecord>;
};

/** Autogenerated return type of UpdateProjectmanagementBudgetStrategy. */
export type UpdateProjectmanagementBudgetStrategyPayload = {
  __typename?: 'UpdateProjectmanagementBudgetStrategyPayload';
  budgetStrategy?: Maybe<ProjectManagementBudgetStrategy>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateProjectmanagementFixedCostPlanning. */
export type UpdateProjectmanagementFixedCostPlanningPayload = {
  __typename?: 'UpdateProjectmanagementFixedCostPlanningPayload';
  errors: Array<MutationError>;
  fixedCostPlanning?: Maybe<ProjectManagementFixedCostPlanning>;
};

/** Autogenerated return type of UpdateProjectmanagementFixedTimeBudget. */
export type UpdateProjectmanagementFixedTimeBudgetPayload = {
  __typename?: 'UpdateProjectmanagementFixedTimeBudgetPayload';
  errors: Array<MutationError>;
  fixedTimeBudget?: Maybe<ProjectManagementFixedTimeBudget>;
};

/** Autogenerated return type of UpdateProjectmanagementFlexibleTimeRecord. */
export type UpdateProjectmanagementFlexibleTimeRecordPayload = {
  __typename?: 'UpdateProjectmanagementFlexibleTimeRecordPayload';
  errors: Array<MutationError>;
  flexibleTimeRecord?: Maybe<ProjectManagementFlexibleTimeRecord>;
};

/** Autogenerated return type of UpdateProjectmanagementPlannedRecord. */
export type UpdateProjectmanagementPlannedRecordPayload = {
  __typename?: 'UpdateProjectmanagementPlannedRecordPayload';
  errors: Array<MutationError>;
  plannedRecord?: Maybe<ProjectManagementPlannedRecord>;
};

/** Autogenerated return type of UpdateProjectmanagementProject. */
export type UpdateProjectmanagementProjectPayload = {
  __typename?: 'UpdateProjectmanagementProjectPayload';
  errors: Array<MutationError>;
  project?: Maybe<ProjectManagementProject>;
};

/** Autogenerated return type of UpdateProjectmanagementProjectRole. */
export type UpdateProjectmanagementProjectRolePayload = {
  __typename?: 'UpdateProjectmanagementProjectRolePayload';
  errors: Array<MutationError>;
  projectRole?: Maybe<ProjectManagementProjectRole>;
};

/** Autogenerated return type of UpdateProjectmanagementProjectTask. */
export type UpdateProjectmanagementProjectTaskPayload = {
  __typename?: 'UpdateProjectmanagementProjectTaskPayload';
  errors: Array<MutationError>;
  projectTask?: Maybe<ProjectManagementProjectTask>;
};

/** Autogenerated return type of UpdateProjectmanagementRate. */
export type UpdateProjectmanagementRatePayload = {
  __typename?: 'UpdateProjectmanagementRatePayload';
  errors: Array<MutationError>;
  rate?: Maybe<ProjectManagementRate>;
};

/** Autogenerated return type of UpdateProjectmanagementSubproject. */
export type UpdateProjectmanagementSubprojectPayload = {
  __typename?: 'UpdateProjectmanagementSubprojectPayload';
  errors: Array<MutationError>;
  subproject?: Maybe<ProjectManagementSubproject>;
};

/** Autogenerated return type of UpdateQualitativeCurrentStatusGoalsMetric. */
export type UpdateQualitativeCurrentStatusGoalsMetricPayload = {
  __typename?: 'UpdateQualitativeCurrentStatusGoalsMetricPayload';
  errors: Array<MutationError>;
  metric?: Maybe<GoalsMetric>;
};

/** Autogenerated return type of UpdateQuantitativeCurrentValueGoalsMetric. */
export type UpdateQuantitativeCurrentValueGoalsMetricPayload = {
  __typename?: 'UpdateQuantitativeCurrentValueGoalsMetricPayload';
  errors: Array<MutationError>;
  metric?: Maybe<GoalsMetric>;
};

/** Autogenerated return type of UpdateQuestionnaireForStrategyPerformanceReviewProcessCustomTemplateQuestionnaireByStrategy. */
export type UpdateQuestionnaireForStrategyPerformanceReviewProcessCustomTemplateQuestionnaireByStrategyPayload = {
  __typename?: 'UpdateQuestionnaireForStrategyPerformanceReviewProcessCustomTemplateQuestionnaireByStrategyPayload';
  errors: Array<MutationError>;
  reviewProcessCustomTemplateQuestionnaireByStrategy?: Maybe<PerformanceReviewProcessCustomTemplateQuestionnaireByStrategy>;
};

/** Autogenerated return type of UpdateQuestionnaireForStrategyPerformanceReviewQuestionnaireByStrategy. */
export type UpdateQuestionnaireForStrategyPerformanceReviewQuestionnaireByStrategyPayload = {
  __typename?: 'UpdateQuestionnaireForStrategyPerformanceReviewQuestionnaireByStrategyPayload';
  errors: Array<MutationError>;
  reviewQuestionnaireByStrategy?: Maybe<PerformanceReviewQuestionnaireByStrategy>;
};

/** Autogenerated return type of UpdateReadAtComplaintsComplaint. */
export type UpdateReadAtComplaintsComplaintPayload = {
  __typename?: 'UpdateReadAtComplaintsComplaintPayload';
  complaint?: Maybe<ComplaintsComplaint>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateReportsDashboard. */
export type UpdateReportsDashboardPayload = {
  __typename?: 'UpdateReportsDashboardPayload';
  dashboard?: Maybe<ReportsDashboard>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateReportsReport. */
export type UpdateReportsReportPayload = {
  __typename?: 'UpdateReportsReportPayload';
  errors: Array<MutationError>;
  report?: Maybe<ReportsReport>;
};

/** Autogenerated return type of UpdateRepublishEvaluationsConfigurationPerformanceReviewProcess. */
export type UpdateRepublishEvaluationsConfigurationPerformanceReviewProcessPayload = {
  __typename?: 'UpdateRepublishEvaluationsConfigurationPerformanceReviewProcessPayload';
  errors: Array<MutationError>;
  reviewProcess?: Maybe<PerformanceReviewProcess>;
};

/** Autogenerated return type of UpdateResourceUrlApprovalsMaterializedApprovalsFlow. */
export type UpdateResourceUrlApprovalsMaterializedApprovalsFlowPayload = {
  __typename?: 'UpdateResourceUrlApprovalsMaterializedApprovalsFlowPayload';
  errors: Array<MutationError>;
  materializedApprovalsFlow?: Maybe<ApprovalsMaterializedApprovalsFlow>;
};

/** Autogenerated return type of UpdateRespondentStrategySurveysSurvey. */
export type UpdateRespondentStrategySurveysSurveyPayload = {
  __typename?: 'UpdateRespondentStrategySurveysSurveyPayload';
  errors: Array<MutationError>;
  survey?: Maybe<SurveysSurvey>;
};

/** Autogenerated return type of UpdateRestrictedViewersEnabledSurveysSurvey. */
export type UpdateRestrictedViewersEnabledSurveysSurveyPayload = {
  __typename?: 'UpdateRestrictedViewersEnabledSurveysSurveyPayload';
  errors: Array<MutationError>;
  survey?: Maybe<SurveysSurvey>;
};

/** Autogenerated return type of UpdateReviewerStrategiesPerformanceReviewProcessCustomTemplate. */
export type UpdateReviewerStrategiesPerformanceReviewProcessCustomTemplatePayload = {
  __typename?: 'UpdateReviewerStrategiesPerformanceReviewProcessCustomTemplatePayload';
  errors: Array<MutationError>;
  reviewProcessCustomTemplate?: Maybe<PerformanceReviewProcessCustomTemplate>;
};

/** Autogenerated return type of UpdateReviewerStrategiesPerformanceReviewProcess. */
export type UpdateReviewerStrategiesPerformanceReviewProcessPayload = {
  __typename?: 'UpdateReviewerStrategiesPerformanceReviewProcessPayload';
  errors: Array<MutationError>;
  reviewProcess?: Maybe<PerformanceReviewProcess>;
};

/** Autogenerated return type of UpdateSchedulePerformanceReviewProcess. */
export type UpdateSchedulePerformanceReviewProcessPayload = {
  __typename?: 'UpdateSchedulePerformanceReviewProcessPayload';
  errors: Array<MutationError>;
  reviewProcess?: Maybe<PerformanceReviewProcess>;
};

/** Autogenerated return type of UpdateSecuritysettingsCompanyConfig. */
export type UpdateSecuritysettingsCompanyConfigPayload = {
  __typename?: 'UpdateSecuritysettingsCompanyConfigPayload';
  companyConfig?: Maybe<SecuritySettingsCompanyConfig>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateSepaFileBankingPaymentExecution. */
export type UpdateSepaFileBankingPaymentExecutionPayload = {
  __typename?: 'UpdateSepaFileBankingPaymentExecutionPayload';
  errors: Array<MutationError>;
  paymentExecution?: Maybe<BankingPaymentExecution>;
};

/** Autogenerated return type of UpdateShiftmanagementAutoSchedulerExecution. */
export type UpdateShiftmanagementAutoSchedulerExecutionPayload = {
  __typename?: 'UpdateShiftmanagementAutoSchedulerExecutionPayload';
  autoSchedulerExecution?: Maybe<ShiftManagementAutoSchedulerExecution>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateShiftmanagementDefaultShift. */
export type UpdateShiftmanagementDefaultShiftPayload = {
  __typename?: 'UpdateShiftmanagementDefaultShiftPayload';
  defaultShift?: Maybe<ShiftManagementDefaultShift>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateShiftmanagementSwapShift. */
export type UpdateShiftmanagementSwapShiftPayload = {
  __typename?: 'UpdateShiftmanagementSwapShiftPayload';
  errors: Array<MutationError>;
  swapShift?: Maybe<ShiftManagementSwapShift>;
};

/** Autogenerated return type of UpdateShiftmanagementTemplate. */
export type UpdateShiftmanagementTemplatePayload = {
  __typename?: 'UpdateShiftmanagementTemplatePayload';
  errors: Array<MutationError>;
  template?: Maybe<ShiftManagementTemplate>;
};

/** Autogenerated return type of UpdateShiftmanagementTemplateWeek. */
export type UpdateShiftmanagementTemplateWeekPayload = {
  __typename?: 'UpdateShiftmanagementTemplateWeekPayload';
  errors: Array<MutationError>;
  templateWeek?: Maybe<ShiftManagementTemplateWeek>;
};

/** Autogenerated return type of UpdateShiftmanagementUnassignedShift. */
export type UpdateShiftmanagementUnassignedShiftPayload = {
  __typename?: 'UpdateShiftmanagementUnassignedShiftPayload';
  errors: Array<MutationError>;
  unassignedShift?: Maybe<ShiftManagementUnassignedShift>;
};

/** Autogenerated return type of UpdateSignatureStatusDocumentsDocument. */
export type UpdateSignatureStatusDocumentsDocumentPayload = {
  __typename?: 'UpdateSignatureStatusDocumentsDocumentPayload';
  document?: Maybe<DocumentsDocument>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateSimpleFinanceLineItem. */
export type UpdateSimpleFinanceLineItemPayload = {
  __typename?: 'UpdateSimpleFinanceLineItemPayload';
  errors: Array<MutationError>;
  lineItem?: Maybe<FinanceLineItem>;
};

/** Autogenerated return type of UpdateSoftwaremanagementCustomSoftware. */
export type UpdateSoftwaremanagementCustomSoftwarePayload = {
  __typename?: 'UpdateSoftwaremanagementCustomSoftwarePayload';
  customSoftware?: Maybe<SoftwareManagementCustomSoftware>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateSoftwaremanagementSoftwarePayment. */
export type UpdateSoftwaremanagementSoftwarePaymentPayload = {
  __typename?: 'UpdateSoftwaremanagementSoftwarePaymentPayload';
  errors: Array<MutationError>;
  softwarePayment?: Maybe<SoftwareManagementSoftwarePayment>;
};

/** Autogenerated return type of UpdateSoftwaremanagementSoftwareSetup. */
export type UpdateSoftwaremanagementSoftwareSetupPayload = {
  __typename?: 'UpdateSoftwaremanagementSoftwareSetupPayload';
  errors: Array<MutationError>;
  softwareSetup?: Maybe<SoftwareManagementSoftwareSetup>;
};

/** Autogenerated return type of UpdateSpacecontrolWorkAreaMap. */
export type UpdateSpacecontrolWorkAreaMapPayload = {
  __typename?: 'UpdateSpacecontrolWorkAreaMapPayload';
  errors: Array<MutationError>;
  workAreaMap?: Maybe<SpaceControlWorkAreaMap>;
};

/** Autogenerated return type of UpdateSpacecontrolWorkSpace. */
export type UpdateSpacecontrolWorkSpacePayload = {
  __typename?: 'UpdateSpacecontrolWorkSpacePayload';
  errors: Array<MutationError>;
  workSpace?: Maybe<SpaceControlWorkSpace>;
};

/** Autogenerated return type of UpdateStatusAtsCvBulkUpload. */
export type UpdateStatusAtsCvBulkUploadPayload = {
  __typename?: 'UpdateStatusAtsCvBulkUploadPayload';
  cvBulkUpload?: Maybe<AtsCvBulkUpload>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateStatusComplaintsComplaint. */
export type UpdateStatusComplaintsComplaintPayload = {
  __typename?: 'UpdateStatusComplaintsComplaintPayload';
  complaint?: Maybe<ComplaintsComplaint>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateStatusFilledDocumentsDocument. */
export type UpdateStatusFilledDocumentsDocumentPayload = {
  __typename?: 'UpdateStatusFilledDocumentsDocumentPayload';
  document?: Maybe<DocumentsDocument>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateStatusProcurementPurchaseOrder. */
export type UpdateStatusProcurementPurchaseOrderPayload = {
  __typename?: 'UpdateStatusProcurementPurchaseOrderPayload';
  errors: Array<MutationError>;
  purchaseOrder?: Maybe<ProcurementPurchaseOrder>;
};

/** Autogenerated return type of UpdateStatusTrainingsTraining. */
export type UpdateStatusTrainingsTrainingPayload = {
  __typename?: 'UpdateStatusTrainingsTrainingPayload';
  errors: Array<MutationError>;
  training?: Maybe<TrainingsTraining>;
};

/** Autogenerated return type of UpdateSurveysSurvey. */
export type UpdateSurveysSurveyPayload = {
  __typename?: 'UpdateSurveysSurveyPayload';
  errors: Array<MutationError>;
  survey?: Maybe<SurveysSurvey>;
};

/** Autogenerated return type of UpdateTargetStrategyPerformanceReviewProcessCustomTemplate. */
export type UpdateTargetStrategyPerformanceReviewProcessCustomTemplatePayload = {
  __typename?: 'UpdateTargetStrategyPerformanceReviewProcessCustomTemplatePayload';
  errors: Array<MutationError>;
  reviewProcessCustomTemplate?: Maybe<PerformanceReviewProcessCustomTemplate>;
};

/** Autogenerated return type of UpdateTargetStrategyPerformanceReviewProcess. */
export type UpdateTargetStrategyPerformanceReviewProcessPayload = {
  __typename?: 'UpdateTargetStrategyPerformanceReviewProcessPayload';
  errors: Array<MutationError>;
  reviewProcess?: Maybe<PerformanceReviewProcess>;
};

/** Autogenerated return type of UpdateTasksTask. */
export type UpdateTasksTaskPayload = {
  __typename?: 'UpdateTasksTaskPayload';
  errors: Array<MutationError>;
  task?: Maybe<TasksTask>;
};

/** Autogenerated return type of UpdateTeamsMembership. */
export type UpdateTeamsMembershipPayload = {
  __typename?: 'UpdateTeamsMembershipPayload';
  errors: Array<MutationError>;
  membership?: Maybe<TeamsMembership>;
};

/** Autogenerated return type of UpdateTeamsTeam. */
export type UpdateTeamsTeamPayload = {
  __typename?: 'UpdateTeamsTeamPayload';
  errors: Array<MutationError>;
  team?: Maybe<TeamsTeam>;
};

/** Autogenerated return type of UpdateTimeinsightsInconsistency. */
export type UpdateTimeinsightsInconsistencyPayload = {
  __typename?: 'UpdateTimeinsightsInconsistencyPayload';
  errors: Array<MutationError>;
  inconsistency?: Maybe<TimeInsightsInconsistency>;
};

/** Autogenerated return type of UpdateTimeoffAllowanceIncidence. */
export type UpdateTimeoffAllowanceIncidencePayload = {
  __typename?: 'UpdateTimeoffAllowanceIncidencePayload';
  allowanceIncidence?: Maybe<TimeoffAllowanceIncidence>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateTimeoffAllowance. */
export type UpdateTimeoffAllowancePayload = {
  __typename?: 'UpdateTimeoffAllowancePayload';
  allowance?: Maybe<TimeoffAllowance>;
  errors: Array<MutationError>;
};

export type UpdateTimeoffAllowanceTenurePeriodsInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  adjustmentInCents?: InputMaybe<Scalars['Int']>;
  balanceType?: InputMaybe<TimeoffAllowanceTenurePeriodBalanceTypeEnum>;
  id?: InputMaybe<Scalars['Int']>;
  maxCapInCents?: InputMaybe<Scalars['Int']>;
  periodLength?: InputMaybe<Scalars['Int']>;
  periodType?: InputMaybe<TimeoffAllowanceTenurePeriodPeriodTypeEnum>;
  tempId?: InputMaybe<Scalars['Int']>;
  timeWorkedBasedHoursAccruedInCents?: InputMaybe<Scalars['Int']>;
  timeWorkedBasedPerHoursWorkedInCents?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of UpdateTimeoffBlockedPeriod. */
export type UpdateTimeoffBlockedPeriodPayload = {
  __typename?: 'UpdateTimeoffBlockedPeriodPayload';
  blockedPeriod?: Maybe<TimeoffBlockedPeriod>;
  errors: Array<MutationError>;
};

export type UpdateTimeoffBlockedPeriodTimePeriodsAttributesInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  duration?: InputMaybe<Scalars['Int']>;
  durationUnit?: InputMaybe<Scalars['String']>;
  finishOn?: InputMaybe<Scalars['ISO8601Date']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  periodType?: InputMaybe<Scalars['String']>;
  startOn?: InputMaybe<Scalars['ISO8601Date']>;
};

/** Autogenerated return type of UpdateTimeoffLeaveApprovalRule. */
export type UpdateTimeoffLeaveApprovalRulePayload = {
  __typename?: 'UpdateTimeoffLeaveApprovalRulePayload';
  errors: Array<MutationError>;
  leaveApprovalRule?: Maybe<TimeoffLeaveApprovalRule>;
};

/** Autogenerated return type of UpdateTimeoffLeave. */
export type UpdateTimeoffLeavePayload = {
  __typename?: 'UpdateTimeoffLeavePayload';
  errors: Array<MutationError>;
  leave?: Maybe<TimeoffLeave>;
};

/** Autogenerated return type of UpdateTimeoffLeaveType. */
export type UpdateTimeoffLeaveTypePayload = {
  __typename?: 'UpdateTimeoffLeaveTypePayload';
  errors: Array<MutationError>;
  leaveType?: Maybe<TimeoffLeaveType>;
};

/** Autogenerated return type of UpdateTimeoffPolicyAssignment. */
export type UpdateTimeoffPolicyAssignmentPayload = {
  __typename?: 'UpdateTimeoffPolicyAssignmentPayload';
  errors: Array<MutationError>;
  policyAssignment?: Maybe<TimeoffPolicyAssignment>;
};

/** Autogenerated return type of UpdateTimeoffPolicy. */
export type UpdateTimeoffPolicyPayload = {
  __typename?: 'UpdateTimeoffPolicyPayload';
  errors: Array<MutationError>;
  policy?: Maybe<TimeoffPolicy>;
};

/** Autogenerated return type of UpdateTimeplanningPlanningVersion. */
export type UpdateTimeplanningPlanningVersionPayload = {
  __typename?: 'UpdateTimeplanningPlanningVersionPayload';
  errors: Array<MutationError>;
  planningVersion?: Maybe<TimePlanningPlanningVersion>;
};

/** Autogenerated return type of UpdateTimesettingsBreakConfiguration. */
export type UpdateTimesettingsBreakConfigurationPayload = {
  __typename?: 'UpdateTimesettingsBreakConfigurationPayload';
  breakConfiguration?: Maybe<TimeSettingsBreakConfiguration>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateTimesettingsCustomTimeRangeCategory. */
export type UpdateTimesettingsCustomTimeRangeCategoryPayload = {
  __typename?: 'UpdateTimesettingsCustomTimeRangeCategoryPayload';
  customTimeRangeCategory?: Maybe<TimeSettingsCustomTimeRangeCategory>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateTrainingsCategoryMapConfigItem. */
export type UpdateTrainingsCategoryMapConfigItemPayload = {
  __typename?: 'UpdateTrainingsCategoryMapConfigItemPayload';
  categoryMapConfigItem?: Maybe<TrainingsCategoryMapConfigItem>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateTrainingsCompletionConfiguration. */
export type UpdateTrainingsCompletionConfigurationPayload = {
  __typename?: 'UpdateTrainingsCompletionConfigurationPayload';
  completionConfiguration?: Maybe<TrainingsCompletionConfiguration>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateTrainingsEmployeeRelatorioUnicoField. */
export type UpdateTrainingsEmployeeRelatorioUnicoFieldPayload = {
  __typename?: 'UpdateTrainingsEmployeeRelatorioUnicoFieldPayload';
  employeeRelatorioUnicoField?: Maybe<TrainingsEmployeeRelatorioUnicoField>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateTrainingsLearningPlatform. */
export type UpdateTrainingsLearningPlatformPayload = {
  __typename?: 'UpdateTrainingsLearningPlatformPayload';
  errors: Array<MutationError>;
  learningPlatform?: Maybe<TrainingsLearningPlatform>;
};

/** Autogenerated return type of UpdateTrainingsSession. */
export type UpdateTrainingsSessionPayload = {
  __typename?: 'UpdateTrainingsSessionPayload';
  errors: Array<MutationError>;
  session?: Maybe<TrainingsSession>;
};

/** Autogenerated return type of UpdateTrainingsSessionRelatorioUnicoField. */
export type UpdateTrainingsSessionRelatorioUnicoFieldPayload = {
  __typename?: 'UpdateTrainingsSessionRelatorioUnicoFieldPayload';
  errors: Array<MutationError>;
  sessionRelatorioUnicoField?: Maybe<TrainingsSessionRelatorioUnicoField>;
};

/** Autogenerated return type of UpdateTrainingsSetting. */
export type UpdateTrainingsSettingPayload = {
  __typename?: 'UpdateTrainingsSettingPayload';
  errors: Array<MutationError>;
  setting?: Maybe<TrainingsSetting>;
};

/** Autogenerated return type of UpdateTrainingsTrainingClass. */
export type UpdateTrainingsTrainingClassPayload = {
  __typename?: 'UpdateTrainingsTrainingClassPayload';
  errors: Array<MutationError>;
  trainingClass?: Maybe<TrainingsTrainingClass>;
};

/** Autogenerated return type of UpdateTrainingsTrainingMembership. */
export type UpdateTrainingsTrainingMembershipPayload = {
  __typename?: 'UpdateTrainingsTrainingMembershipPayload';
  errors: Array<MutationError>;
  trainingMembership?: Maybe<TrainingsTrainingMembership>;
};

/** Autogenerated return type of UpdateTrainingsTraining. */
export type UpdateTrainingsTrainingPayload = {
  __typename?: 'UpdateTrainingsTrainingPayload';
  errors: Array<MutationError>;
  training?: Maybe<TrainingsTraining>;
};

/** Autogenerated return type of UpdateTrainingsTrainingRelatorioUnicoField. */
export type UpdateTrainingsTrainingRelatorioUnicoFieldPayload = {
  __typename?: 'UpdateTrainingsTrainingRelatorioUnicoFieldPayload';
  errors: Array<MutationError>;
  trainingRelatorioUnicoField?: Maybe<TrainingsTrainingRelatorioUnicoField>;
};

/** Autogenerated return type of UpdateTrainingsTrainingRequest. */
export type UpdateTrainingsTrainingRequestPayload = {
  __typename?: 'UpdateTrainingsTrainingRequestPayload';
  errors: Array<MutationError>;
  trainingRequest?: Maybe<TrainingsTrainingRequest>;
};

/** Autogenerated return type of UpdateUniversalexportsConfiguration. */
export type UpdateUniversalexportsConfigurationPayload = {
  __typename?: 'UpdateUniversalexportsConfigurationPayload';
  configuration?: Maybe<UniversalExportsConfiguration>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpdateUsersPersonalInfo. */
export type UpdateUsersPersonalInfoPayload = {
  __typename?: 'UpdateUsersPersonalInfoPayload';
  errors: Array<MutationError>;
  personalInfo?: Maybe<UsersPersonalInfo>;
};

/** Autogenerated return type of UpdateVisibilitySettingsPerformanceReviewProcessCustomTemplate. */
export type UpdateVisibilitySettingsPerformanceReviewProcessCustomTemplatePayload = {
  __typename?: 'UpdateVisibilitySettingsPerformanceReviewProcessCustomTemplatePayload';
  errors: Array<MutationError>;
  reviewProcessCustomTemplate?: Maybe<PerformanceReviewProcessCustomTemplate>;
};

/** Autogenerated return type of UpdateWorkingconditionsItem. */
export type UpdateWorkingconditionsItemPayload = {
  __typename?: 'UpdateWorkingconditionsItemPayload';
  errors: Array<MutationError>;
  item?: Maybe<WorkingConditionsItem>;
};

/** Autogenerated return type of UpdateWorkingconditionsVersion. */
export type UpdateWorkingconditionsVersionPayload = {
  __typename?: 'UpdateWorkingconditionsVersionPayload';
  errors: Array<MutationError>;
  version?: Maybe<WorkingConditionsVersion>;
};

/** Autogenerated return type of UpdateWorkscheduleOverlapPeriod. */
export type UpdateWorkscheduleOverlapPeriodPayload = {
  __typename?: 'UpdateWorkscheduleOverlapPeriodPayload';
  errors: Array<MutationError>;
  overlapPeriod?: Maybe<WorkScheduleOverlapPeriod>;
};

/** Autogenerated return type of UpdateWorkscheduleSchedule. */
export type UpdateWorkscheduleSchedulePayload = {
  __typename?: 'UpdateWorkscheduleSchedulePayload';
  errors: Array<MutationError>;
  schedule?: Maybe<WorkScheduleSchedule>;
};

/** Autogenerated return type of UploadCvAtsCandidate. */
export type UploadCvAtsCandidatePayload = {
  __typename?: 'UploadCvAtsCandidatePayload';
  candidate?: Maybe<AtsCandidate>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UploadFromDocumentDocumentsDocument. */
export type UploadFromDocumentDocumentsDocumentPayload = {
  __typename?: 'UploadFromDocumentDocumentsDocumentPayload';
  document?: Maybe<DocumentsDocument>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UploadProcurementUploadDocumentTask. */
export type UploadProcurementUploadDocumentTaskPayload = {
  __typename?: 'UploadProcurementUploadDocumentTaskPayload';
  errors: Array<MutationError>;
  uploadDocumentTask?: Maybe<ProcurementUploadDocumentTask>;
};

/** Autogenerated return type of UploadWorkspaceLogoCompaniesLogo. */
export type UploadWorkspaceLogoCompaniesLogoPayload = {
  __typename?: 'UploadWorkspaceLogoCompaniesLogoPayload';
  errors: Array<MutationError>;
  logo?: Maybe<CompaniesLogo>;
};

/** account_manager_info */
export type UpsellAccountManagerInfo = {
  __typename?: 'UpsellAccountManagerInfo';
  avatar: Scalars['String'];
  firstName: Scalars['String'];
};

/** The connection type for UpsellAccountManagerInfo. */
export type UpsellAccountManagerInfoConnection = {
  __typename?: 'UpsellAccountManagerInfoConnection';
  /** A list of edges. */
  edges: Array<UpsellAccountManagerInfoEdge>;
  /** A list of nodes. */
  nodes: Array<UpsellAccountManagerInfo>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type UpsellAccountManagerInfoEdge = {
  __typename?: 'UpsellAccountManagerInfoEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: UpsellAccountManagerInfo;
};

/** add_line_item */
export type UpsellAddLineItem = {
  __typename?: 'UpsellAddLineItem';
  newAddonsIds: Array<Scalars['String']>;
  oldAddonsIds: Array<Scalars['String']>;
};

export type UpsellBlock = {
  __typename?: 'UpsellBlock';
  glpButton?: Maybe<UpsellGlpButton>;
  glpCard?: Maybe<UpsellGlpCard>;
  glpFeaturesSection?: Maybe<UpsellGlpFeaturesSection>;
  glpHeader?: Maybe<UpsellGlpHeader>;
  glpHeroSection?: Maybe<UpsellGlpHeroSection>;
  glpRow?: Maybe<UpsellGlpRow>;
};

/** book_meeting */
export type UpsellBookMeeting = {
  __typename?: 'UpsellBookMeeting';
  meetingLink: Scalars['String'];
  owner: Scalars['String'];
};

/** The connection type for UpsellBookMeeting. */
export type UpsellBookMeetingConnection = {
  __typename?: 'UpsellBookMeetingConnection';
  /** A list of edges. */
  edges: Array<UpsellBookMeetingEdge>;
  /** A list of nodes. */
  nodes: Array<UpsellBookMeeting>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type UpsellBookMeetingEdge = {
  __typename?: 'UpsellBookMeetingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: UpsellBookMeeting;
};

export type UpsellContextlessPolicies = {
  __typename?: 'UpsellContextlessPolicies';
  canJoinOneWaitlist: ContextlessPolicyResolution;
  canRequestUpsell: ContextlessPolicyResolution;
  canSeeBlackFridayPromo: ContextlessPolicyResolution;
};

/** discoverability_widget */
export type UpsellDiscoverabilityWidget = {
  __typename?: 'UpsellDiscoverabilityWidget';
  chargebeeModuleName?: Maybe<Scalars['String']>;
  ctaLink?: Maybe<Scalars['String']>;
  ctaText?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  expirationDate?: Maybe<Scalars['ISO8601Date']>;
  id: Scalars['String'];
  marketplaceSlug?: Maybe<Scalars['String']>;
  thumbnail: ProductUpdatesImage;
  title: Scalars['String'];
};

/** The connection type for UpsellDiscoverabilityWidget. */
export type UpsellDiscoverabilityWidgetConnection = {
  __typename?: 'UpsellDiscoverabilityWidgetConnection';
  /** A list of edges. */
  edges: Array<UpsellDiscoverabilityWidgetEdge>;
  /** A list of nodes. */
  nodes: Array<UpsellDiscoverabilityWidget>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type UpsellDiscoverabilityWidgetEdge = {
  __typename?: 'UpsellDiscoverabilityWidgetEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: UpsellDiscoverabilityWidget;
};

export type UpsellDtosUpsellDiscountCreateDiscountTypeEnum =
  | 'abandoned_cart';

export type UpsellDtosUpsellDiscountScheduleDiscountTypeEnum =
  | 'abandoned_cart';

export type UpsellFeature = {
  __typename?: 'UpsellFeature';
  description?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type UpsellGlpButton = {
  __typename?: 'UpsellGlpButton';
  actionType?: Maybe<Scalars['String']>;
  chargebeeAddonId: Scalars['String'];
  id: Scalars['String'];
  label: Scalars['String'];
  opensInNewTab: Scalars['Boolean'];
  secondaryLabel: Scalars['String'];
  style: Scalars['String'];
  subscriptionExpiresIn: Scalars['String'];
  upsellRequest: Scalars['Boolean'];
  url: Scalars['String'];
};

export type UpsellGlpCard = {
  __typename?: 'UpsellGlpCard';
  actions?: Maybe<Array<UpsellGlpButton>>;
  cardContent?: Maybe<Scalars['String']>;
  cardMedia?: Maybe<UpsellMedia>;
  cardTitle?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  url: Scalars['String'];
};

export type UpsellGlpFeatures = {
  __typename?: 'UpsellGlpFeatures';
  glpCards?: Maybe<Array<UpsellGlpCard>>;
  glpRows?: Maybe<Array<UpsellGlpRow>>;
};

export type UpsellGlpFeaturesSection = {
  __typename?: 'UpsellGlpFeaturesSection';
  features?: Maybe<UpsellGlpFeatures>;
  header?: Maybe<UpsellGlpHeader>;
  id: Scalars['String'];
};

export type UpsellGlpHeader = {
  __typename?: 'UpsellGlpHeader';
  actions?: Maybe<Array<UpsellGlpButton>>;
  id: Scalars['String'];
  sectionSubtitle?: Maybe<Scalars['String']>;
  sectionTitle?: Maybe<Scalars['String']>;
};

export type UpsellGlpHeroSection = {
  __typename?: 'UpsellGlpHeroSection';
  actions?: Maybe<Array<UpsellGlpButton>>;
  id: Scalars['String'];
  media?: Maybe<UpsellMedia>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  videoUrl?: Maybe<Scalars['String']>;
};

export type UpsellGlpModuleRelated = {
  __typename?: 'UpsellGlpModuleRelated';
  billingAddonReference: Array<ModulesBillingAddonReference>;
  chargebeeModuleId: Scalars['String'];
  chargebeeModuleName: Scalars['String'];
};

export type UpsellGlpRow = {
  __typename?: 'UpsellGlpRow';
  actions?: Maybe<Array<UpsellGlpButton>>;
  id: Scalars['String'];
  mediaPosition?: Maybe<Scalars['String']>;
  rowContent?: Maybe<Scalars['String']>;
  rowMedia?: Maybe<UpsellMedia>;
  rowTitle?: Maybe<Scalars['String']>;
};

/** join_one_waitlist */
export type UpsellJoinOneWaitlist = {
  __typename?: 'UpsellJoinOneWaitlist';
  newAddonsIds: Array<Scalars['String']>;
  oldAddonsIds: Array<Scalars['String']>;
};

/** landing_page */
export type UpsellLandingPage = {
  __typename?: 'UpsellLandingPage';
  blocks?: Maybe<Array<UpsellBlock>>;
  buttonLabel?: Maybe<Scalars['String']>;
  chargebeeModuleName?: Maybe<Scalars['String']>;
  crossSellingDescription?: Maybe<Scalars['String']>;
  crossSellingTitle?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  featureAvailabilityId?: Maybe<Scalars['String']>;
  installedTagLabel?: Maybe<Scalars['String']>;
  media?: Maybe<UpsellMedia>;
  mediaUrl?: Maybe<Scalars['String']>;
  moduleRelated?: Maybe<UpsellGlpModuleRelated>;
  productUpdates?: Maybe<Array<UpsellProductUpdate>>;
  sections: Array<UpsellSection>;
  sectionsDescription?: Maybe<Scalars['String']>;
  sectionsTitle?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  tagLabel?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/** The connection type for UpsellLandingPage. */
export type UpsellLandingPageConnection = {
  __typename?: 'UpsellLandingPageConnection';
  /** A list of edges. */
  edges: Array<UpsellLandingPageEdge>;
  /** A list of nodes. */
  nodes: Array<UpsellLandingPage>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type UpsellLandingPageEdge = {
  __typename?: 'UpsellLandingPageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: UpsellLandingPage;
};

export type UpsellMedia = {
  __typename?: 'UpsellMedia';
  alt?: Maybe<Scalars['String']>;
  height: Scalars['Int'];
  url?: Maybe<Scalars['String']>;
  video?: Maybe<UpsellVideoInfo>;
  width: Scalars['Int'];
};

/** one_waitlist_position */
export type UpsellOneWaitlistPosition = {
  __typename?: 'UpsellOneWaitlistPosition';
  companyId: Scalars['String'];
  position: Scalars['Int'];
};

/** The connection type for UpsellOneWaitlistPosition. */
export type UpsellOneWaitlistPositionConnection = {
  __typename?: 'UpsellOneWaitlistPositionConnection';
  /** A list of edges. */
  edges: Array<UpsellOneWaitlistPositionEdge>;
  /** A list of nodes. */
  nodes: Array<UpsellOneWaitlistPosition>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type UpsellOneWaitlistPositionEdge = {
  __typename?: 'UpsellOneWaitlistPositionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: UpsellOneWaitlistPosition;
};

export type UpsellProductUpdate = {
  __typename?: 'UpsellProductUpdate';
  id: Scalars['String'];
  releaseDate: Scalars['String'];
  shortDescription: Scalars['String'];
  slug: Scalars['String'];
  thumbnail: UpsellMedia;
  title: Scalars['String'];
};

export type UpsellSection = {
  __typename?: 'UpsellSection';
  actionUrl?: Maybe<Scalars['String']>;
  buttonLabel?: Maybe<Scalars['String']>;
  buttonLink?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  features?: Maybe<Array<UpsellFeature>>;
  highlightedMediaText?: Maybe<Scalars['String']>;
  media?: Maybe<UpsellMedia>;
  mediaText?: Maybe<Scalars['String']>;
  mediaUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** upsell_discount */
export type UpsellUpsellDiscount = {
  __typename?: 'UpsellUpsellDiscount';
  companyId: Scalars['Int'];
  disabledAt: Scalars['ISO8601Date'];
  enableAt: Scalars['ISO8601Date'];
  id: Scalars['Int'];
  module: Scalars['String'];
  percentage: Scalars['Float'];
  period: Scalars['Int'];
  periodUnit: Scalars['String'];
  source?: Maybe<Scalars['String']>;
};

/** The connection type for UpsellUpsellDiscount. */
export type UpsellUpsellDiscountConnection = {
  __typename?: 'UpsellUpsellDiscountConnection';
  /** A list of edges. */
  edges: Array<UpsellUpsellDiscountEdge>;
  /** A list of nodes. */
  nodes: Array<UpsellUpsellDiscount>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type UpsellUpsellDiscountEdge = {
  __typename?: 'UpsellUpsellDiscountEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: UpsellUpsellDiscount;
};

/** upsell_request */
export type UpsellUpsellRequest = {
  __typename?: 'UpsellUpsellRequest';
  companyId: Scalars['Int'];
  featureRequested?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  moduleRequested?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  requestReason?: Maybe<Scalars['String']>;
  requestSource?: Maybe<Scalars['String']>;
  requestSourceCategory?: Maybe<Scalars['String']>;
  requestSourceComponent?: Maybe<Scalars['String']>;
  upsellRequestAmount?: Maybe<Scalars['Float']>;
  upsellRequestComponentType?: Maybe<Scalars['String']>;
  upsellRequestStatus?: Maybe<Scalars['String']>;
  upsellRequestType?: Maybe<Scalars['String']>;
};

/** The connection type for UpsellUpsellRequest. */
export type UpsellUpsellRequestConnection = {
  __typename?: 'UpsellUpsellRequestConnection';
  /** A list of edges. */
  edges: Array<UpsellUpsellRequestEdge>;
  /** A list of nodes. */
  nodes: Array<UpsellUpsellRequest>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type UpsellUpsellRequestEdge = {
  __typename?: 'UpsellUpsellRequestEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: UpsellUpsellRequest;
};

export type UpsellVideoInfo = {
  __typename?: 'UpsellVideoInfo';
  mp4Url?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UpsertBankingBankAccountMembership. */
export type UpsertBankingBankAccountMembershipPayload = {
  __typename?: 'UpsertBankingBankAccountMembershipPayload';
  bankAccountMembership?: Maybe<BankingBankAccountMembership>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpsertBankingBankAccountNumber. */
export type UpsertBankingBankAccountNumberPayload = {
  __typename?: 'UpsertBankingBankAccountNumberPayload';
  bankAccountNumber?: Maybe<BankingBankAccountNumber>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpsertCompensationsCompensationSetting. */
export type UpsertCompensationsCompensationSettingPayload = {
  __typename?: 'UpsertCompensationsCompensationSettingPayload';
  compensationSetting?: Maybe<CompensationsCompensationSetting>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpsertCompensationsEmployeesCompensation. */
export type UpsertCompensationsEmployeesCompensationPayload = {
  __typename?: 'UpsertCompensationsEmployeesCompensationPayload';
  employeesCompensation?: Maybe<CompensationsEmployeesCompensation>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpsertCompensationsReimbursablePayrollConcept. */
export type UpsertCompensationsReimbursablePayrollConceptPayload = {
  __typename?: 'UpsertCompensationsReimbursablePayrollConceptPayload';
  errors: Array<MutationError>;
  reimbursablePayrollConcept?: Maybe<CompensationsReimbursablePayrollConcept>;
};

/** Autogenerated return type of UpsertContractsWeeksPerMonthConfiguration. */
export type UpsertContractsWeeksPerMonthConfigurationPayload = {
  __typename?: 'UpsertContractsWeeksPerMonthConfigurationPayload';
  errors: Array<MutationError>;
  weeksPerMonthConfiguration?: Maybe<ContractsWeeksPerMonthConfiguration>;
};

/** Autogenerated return type of UpsertCustomfieldsValue. */
export type UpsertCustomfieldsValuePayload = {
  __typename?: 'UpsertCustomfieldsValuePayload';
  errors: Array<MutationError>;
  value?: Maybe<CustomFieldsValue>;
};

export type UpsertDistributionsCostcentersDistributionAllocationInput = {
  id?: InputMaybe<Scalars['Int']>;
  referenceId: Scalars['Int'];
  referenceType: Scalars['String'];
};

export type UpsertDistributionsCostcentersDistributionAssignmentsInput = {
  assignmentsToCreate: Array<UpsertDistributionsCostcentersDistributionAssignmentsToCreateInput>;
  assignmentsToUpdate: Array<UpsertDistributionsCostcentersDistributionAssignmentsToUpdateInput>;
};

export type UpsertDistributionsCostcentersDistributionAssignmentsToCreateInput = {
  costCenterId: Scalars['Int'];
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  percentage: Scalars['Float'];
  startDate: Scalars['ISO8601Date'];
};

export type UpsertDistributionsCostcentersDistributionAssignmentsToUpdateInput = {
  costCenterId: Scalars['Int'];
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  id: Scalars['Int'];
  markedForDeletion: Scalars['Boolean'];
  percentage: Scalars['Float'];
  startDate: Scalars['ISO8601Date'];
};

/** Autogenerated return type of UpsertDistributionsCostcentersDistribution. */
export type UpsertDistributionsCostcentersDistributionPayload = {
  __typename?: 'UpsertDistributionsCostcentersDistributionPayload';
  distributions?: Maybe<Array<CostCentersDistribution>>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpsertFinanceAccount. */
export type UpsertFinanceAccountPayload = {
  __typename?: 'UpsertFinanceAccountPayload';
  account?: Maybe<FinanceAccount>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpsertFinanceAccountingSetting. */
export type UpsertFinanceAccountingSettingPayload = {
  __typename?: 'UpsertFinanceAccountingSettingPayload';
  accountingSetting?: Maybe<FinanceAccountingSetting>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpsertFinanceComplianceExtraFieldDefaultSetting. */
export type UpsertFinanceComplianceExtraFieldDefaultSettingPayload = {
  __typename?: 'UpsertFinanceComplianceExtraFieldDefaultSettingPayload';
  complianceExtraFieldDefaultSetting?: Maybe<FinanceComplianceExtraFieldDefaultSetting>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpsertFinanceCustomDimensionMembership. */
export type UpsertFinanceCustomDimensionMembershipPayload = {
  __typename?: 'UpsertFinanceCustomDimensionMembershipPayload';
  customDimensionMembership?: Maybe<FinanceCustomDimensionMembership>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpsertFinanceLedgerAccountResource. */
export type UpsertFinanceLedgerAccountResourcePayload = {
  __typename?: 'UpsertFinanceLedgerAccountResourcePayload';
  errors: Array<MutationError>;
  ledgerAccountResource?: Maybe<FinanceLedgerAccountResource>;
};

export type UpsertFinanceQuoteFinanceLineItemsInput = {
  description: Scalars['String'];
  discountPercentage?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['Int']>;
  quantity: Scalars['Float'];
  quantityType: FinanceValueObjectsLineItemQuantityTypeEnum;
  taxRateId: Scalars['Int'];
  type: FinanceValueObjectsLineItemTypeEnum;
  unitPriceCents: Scalars['Int'];
};

/** Autogenerated return type of UpsertFinanceQuote. */
export type UpsertFinanceQuotePayload = {
  __typename?: 'UpsertFinanceQuotePayload';
  errors: Array<MutationError>;
  quote?: Maybe<FinanceQuote>;
};

/** Autogenerated return type of UpsertHiringversionsTaxResidence. */
export type UpsertHiringversionsTaxResidencePayload = {
  __typename?: 'UpsertHiringversionsTaxResidencePayload';
  errors: Array<MutationError>;
  taxResidence?: Maybe<HiringVersionsTaxResidence>;
};

/** Autogenerated return type of UpsertItmanagementLegalEntityDocumentTemplateSetting. */
export type UpsertItmanagementLegalEntityDocumentTemplateSettingPayload = {
  __typename?: 'UpsertItmanagementLegalEntityDocumentTemplateSettingPayload';
  errors: Array<MutationError>;
  legalEntityDocumentTemplateSetting?: Maybe<ItManagementLegalEntityDocumentTemplateSetting>;
};

/** Autogenerated return type of UpsertJobcatalogExpectation. */
export type UpsertJobcatalogExpectationPayload = {
  __typename?: 'UpsertJobcatalogExpectationPayload';
  errors: Array<MutationError>;
  expectation?: Maybe<JobCatalogExpectation>;
};

/** Autogenerated return type of UpsertManagerQuestionCommentPerformanceAgreement. */
export type UpsertManagerQuestionCommentPerformanceAgreementPayload = {
  __typename?: 'UpsertManagerQuestionCommentPerformanceAgreementPayload';
  agreement?: Maybe<PerformanceAgreement>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpsertOpenaiFeedback. */
export type UpsertOpenaiFeedbackPayload = {
  __typename?: 'UpsertOpenaiFeedbackPayload';
  errors: Array<MutationError>;
  feedback?: Maybe<OpenAiFeedback>;
};

/** Autogenerated return type of UpsertPayrollemployeesEmployeeDatum. */
export type UpsertPayrollemployeesEmployeeDatumPayload = {
  __typename?: 'UpsertPayrollemployeesEmployeeDatumPayload';
  employeeDatum?: Maybe<PayrollEmployeesEmployeeDatum>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpsertPayrollemployeesIdentifier. */
export type UpsertPayrollemployeesIdentifierPayload = {
  __typename?: 'UpsertPayrollemployeesIdentifierPayload';
  errors: Array<MutationError>;
  identifier?: Maybe<PayrollEmployeesIdentifier>;
};

/** Autogenerated return type of UpsertPeoplechartStructure. */
export type UpsertPeoplechartStructurePayload = {
  __typename?: 'UpsertPeoplechartStructurePayload';
  errors: Array<MutationError>;
  structure?: Maybe<PeopleChartStructure>;
};

export type UpsertSaleFinanceFinancialDocumentComplianceExtraFieldsInput = {
  country: Scalars['String'];
  fields: Array<UpsertSaleFinanceFinancialDocumentFieldsInput>;
  id?: InputMaybe<Scalars['Int']>;
  organization: FinanceValueObjectsComplianceExtraFieldOrganizationEnum;
};

export type UpsertSaleFinanceFinancialDocumentFieldsInput = {
  associatedFieldId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  value?: InputMaybe<Scalars['String']>;
};

export type UpsertSaleFinanceFinancialDocumentLineItemsInput = {
  amountCents: Scalars['Int'];
  description: Scalars['String'];
  id: Scalars['String'];
  quantity: Scalars['Float'];
  taxRateId: Scalars['Int'];
};

/** Autogenerated return type of UpsertSaleFinanceFinancialDocument. */
export type UpsertSaleFinanceFinancialDocumentPayload = {
  __typename?: 'UpsertSaleFinanceFinancialDocumentPayload';
  errors: Array<MutationError>;
  financialDocument?: Maybe<FinanceFinancialDocument>;
};

/** Autogenerated return type of UpsertSelfQuestionCommentPerformanceAgreement. */
export type UpsertSelfQuestionCommentPerformanceAgreementPayload = {
  __typename?: 'UpsertSelfQuestionCommentPerformanceAgreementPayload';
  agreement?: Maybe<PerformanceAgreement>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of UpsertSpacecontrolWorkAreaMapSpaceLocation. */
export type UpsertSpacecontrolWorkAreaMapSpaceLocationPayload = {
  __typename?: 'UpsertSpacecontrolWorkAreaMapSpaceLocationPayload';
  errors: Array<MutationError>;
  workAreaMapSpaceLocation?: Maybe<SpaceControlWorkAreaMapSpaceLocation>;
};

/** Autogenerated return type of UpsertSubsidyTrainingsTraining. */
export type UpsertSubsidyTrainingsTrainingPayload = {
  __typename?: 'UpsertSubsidyTrainingsTrainingPayload';
  errors: Array<MutationError>;
  training?: Maybe<TrainingsTraining>;
};

/** Autogenerated return type of UpsertTimebalanceTimeCondition. */
export type UpsertTimebalanceTimeConditionPayload = {
  __typename?: 'UpsertTimebalanceTimeConditionPayload';
  errors: Array<MutationError>;
  timeCondition?: Maybe<TimeBalanceTimeCondition>;
};

/** Autogenerated return type of UpsertTrainingsTrainingClassFundaeConfiguration. */
export type UpsertTrainingsTrainingClassFundaeConfigurationPayload = {
  __typename?: 'UpsertTrainingsTrainingClassFundaeConfigurationPayload';
  errors: Array<MutationError>;
  trainingClassFundaeConfiguration?: Maybe<TrainingsTrainingClassFundaeConfiguration>;
};

/** Autogenerated return type of UpsertWeightsGoalsEmployeeCycleProgress. */
export type UpsertWeightsGoalsEmployeeCycleProgressPayload = {
  __typename?: 'UpsertWeightsGoalsEmployeeCycleProgressPayload';
  employeeCycleProgress?: Maybe<GoalsEmployeeCycleProgress>;
  errors: Array<MutationError>;
};

export type UpsertWeightsGoalsEmployeeCycleProgressWeightsInput = {
  metricGroupId: Scalars['String'];
  weight: Scalars['Float'];
};

/** Personal Info for Users */
export type UsersPersonalInfo = {
  __typename?: 'UsersPersonalInfo';
  _policies?: Maybe<UsersPersonalInfoPolicies>;
  _policiesCollection?: Maybe<Array<PermissionsPolicyResolution>>;
  _policiesConnection: PermissionsPolicyResolutionConnection;
  accessId?: Maybe<Scalars['Int']>;
  avatar?: Maybe<Scalars['String']>;
  communicationsEmail?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  employeeId?: Maybe<Scalars['Int']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  lastName?: Maybe<Scalars['String']>;
  multitenant?: Maybe<Scalars['Boolean']>;
  unconfirmedCommunicationsEmail?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['Int']>;
};


/** Personal Info for Users */
export type UsersPersonalInfo_PoliciesCollectionArgs = {
  ids: Array<UsersPersonalInfoPoliciesEnum>;
};


/** Personal Info for Users */
export type UsersPersonalInfo_PoliciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for UsersPersonalInfo. */
export type UsersPersonalInfoConnection = {
  __typename?: 'UsersPersonalInfoConnection';
  /** A list of edges. */
  edges: Array<UsersPersonalInfoEdge>;
  /** A list of nodes. */
  nodes: Array<UsersPersonalInfo>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type UsersPersonalInfoEdge = {
  __typename?: 'UsersPersonalInfoEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: UsersPersonalInfo;
};

export type UsersPersonalInfoPolicies = {
  __typename?: 'UsersPersonalInfoPolicies';
  edit: PermissionsPolicyResolution;
  editProfileEmail: PermissionsPolicyResolution;
};

export type UsersPersonalInfoPoliciesEnum =
  | 'edit'
  | 'editProfileEmail';

/** Autogenerated return type of ValidateBankingBankAccountNumber. */
export type ValidateBankingBankAccountNumberPayload = {
  __typename?: 'ValidateBankingBankAccountNumberPayload';
  bankAccountNumber?: Maybe<BankingBankAccountNumber>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of ValidateBankingTransactionImportResult. */
export type ValidateBankingTransactionImportResultPayload = {
  __typename?: 'ValidateBankingTransactionImportResultPayload';
  errors: Array<MutationError>;
  transactionImportResult?: Maybe<BankingTransactionImportResult>;
};

/** Autogenerated return type of ValidateFinanceContactsImportResult. */
export type ValidateFinanceContactsImportResultPayload = {
  __typename?: 'ValidateFinanceContactsImportResultPayload';
  contactsImportResult?: Maybe<FinanceContactsImportResult>;
  errors: Array<MutationError>;
};

export type ValidateSaleForIssueFinanceFinancialDocumentComplianceExtraFieldsInput = {
  country: Scalars['String'];
  fields: Array<ValidateSaleForIssueFinanceFinancialDocumentFieldsInput>;
  id?: InputMaybe<Scalars['Int']>;
  organization: FinanceValueObjectsComplianceExtraFieldOrganizationEnum;
};

export type ValidateSaleForIssueFinanceFinancialDocumentFieldsInput = {
  associatedFieldId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  value?: InputMaybe<Scalars['String']>;
};

export type ValidateSaleForIssueFinanceFinancialDocumentLineItemsInput = {
  amountCents: Scalars['Int'];
  description: Scalars['String'];
  id: Scalars['String'];
  quantity: Scalars['Float'];
  taxRateId: Scalars['Int'];
};

/** Autogenerated return type of ValidateSaleForIssueFinanceFinancialDocument. */
export type ValidateSaleForIssueFinanceFinancialDocumentPayload = {
  __typename?: 'ValidateSaleForIssueFinanceFinancialDocumentPayload';
  errors: Array<MutationError>;
  financialDocument?: Maybe<FinanceFinancialDocument>;
};

/** Autogenerated return type of ValidateSettingsProcessesProcess. */
export type ValidateSettingsProcessesProcessPayload = {
  __typename?: 'ValidateSettingsProcessesProcessPayload';
  errors: Array<MutationError>;
  process?: Maybe<ProcessesProcess>;
};

/** Autogenerated return type of VerifyAuthenticationDomain. */
export type VerifyAuthenticationDomainPayload = {
  __typename?: 'VerifyAuthenticationDomainPayload';
  domain?: Maybe<AuthenticationDomain>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of WalletCardAvailableExpensesCard. */
export type WalletCardAvailableExpensesCardPayload = {
  __typename?: 'WalletCardAvailableExpensesCardPayload';
  card?: Maybe<ExpensesCard>;
  errors: Array<MutationError>;
};

/** Autogenerated return type of WalletCardsAvailableExpensesCard. */
export type WalletCardsAvailableExpensesCardPayload = {
  __typename?: 'WalletCardsAvailableExpensesCardPayload';
  card?: Maybe<ExpensesCard>;
  errors: Array<MutationError>;
};

/** Check if employee can assign employees to schedules */
export type WorkScheduleCanAssignEmployeesPolicy = {
  __typename?: 'WorkScheduleCanAssignEmployeesPolicy';
  can: Scalars['Boolean'];
  id?: Maybe<Scalars['Int']>;
};

/** The connection type for WorkScheduleCanAssignEmployeesPolicy. */
export type WorkScheduleCanAssignEmployeesPolicyConnection = {
  __typename?: 'WorkScheduleCanAssignEmployeesPolicyConnection';
  /** A list of edges. */
  edges: Array<WorkScheduleCanAssignEmployeesPolicyEdge>;
  /** A list of nodes. */
  nodes: Array<WorkScheduleCanAssignEmployeesPolicy>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type WorkScheduleCanAssignEmployeesPolicyEdge = {
  __typename?: 'WorkScheduleCanAssignEmployeesPolicyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: WorkScheduleCanAssignEmployeesPolicy;
};

/** Check if employee can reassign schedule employees */
export type WorkScheduleCanReassignEmployeesPolicy = {
  __typename?: 'WorkScheduleCanReassignEmployeesPolicy';
  can: Scalars['Boolean'];
  id: Scalars['Int'];
};

/** The connection type for WorkScheduleCanReassignEmployeesPolicy. */
export type WorkScheduleCanReassignEmployeesPolicyConnection = {
  __typename?: 'WorkScheduleCanReassignEmployeesPolicyConnection';
  /** A list of edges. */
  edges: Array<WorkScheduleCanReassignEmployeesPolicyEdge>;
  /** A list of nodes. */
  nodes: Array<WorkScheduleCanReassignEmployeesPolicy>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type WorkScheduleCanReassignEmployeesPolicyEdge = {
  __typename?: 'WorkScheduleCanReassignEmployeesPolicyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: WorkScheduleCanReassignEmployeesPolicy;
};

export type WorkScheduleContextlessPolicies = {
  __typename?: 'WorkScheduleContextlessPolicies';
  manageCompanySchedules: ContextlessPolicyResolution;
};

/** Represents the hours to work on a given day inside a given overlap period for a schedule. */
export type WorkScheduleDayConfiguration = {
  __typename?: 'WorkScheduleDayConfiguration';
  durationInSeconds: Scalars['Int'];
  formattedEndAt?: Maybe<Scalars['String']>;
  formattedStartAt?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  overlapPeriod?: Maybe<WorkScheduleOverlapPeriod>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  overlapPeriodId: Scalars['Int'];
  plannedBreaks: Array<TimePlanningPlannedBreak>;
  plannedbreaksConnection: TimePlanningPlannedBreakConnection;
  startAt?: Maybe<Scalars['ISO8601DateTime']>;
  weekday: Scalars['String'];
};


/** Represents the hours to work on a given day inside a given overlap period for a schedule. */
export type WorkScheduleDayConfigurationPlannedBreaksArgs = {
  activeBreakConfiguration?: Scalars['Boolean'];
  defaultShiftIds?: Array<Scalars['Int']>;
  ids?: Array<Scalars['Int']>;
  paid?: InputMaybe<Scalars['Boolean']>;
  shiftConfigurationIds?: Array<Scalars['Int']>;
  shiftIds?: Array<Scalars['Int']>;
};


/** Represents the hours to work on a given day inside a given overlap period for a schedule. */
export type WorkScheduleDayConfigurationPlannedbreaksConnectionArgs = {
  activeBreakConfiguration?: Scalars['Boolean'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  defaultShiftIds?: Array<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: Array<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  paid?: InputMaybe<Scalars['Boolean']>;
  shiftConfigurationIds?: Array<Scalars['Int']>;
  shiftIds?: Array<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for WorkScheduleDayConfiguration. */
export type WorkScheduleDayConfigurationConnection = {
  __typename?: 'WorkScheduleDayConfigurationConnection';
  /** A list of edges. */
  edges: Array<WorkScheduleDayConfigurationEdge>;
  /** A list of nodes. */
  nodes: Array<WorkScheduleDayConfiguration>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type WorkScheduleDayConfigurationEdge = {
  __typename?: 'WorkScheduleDayConfigurationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: WorkScheduleDayConfiguration;
};

/**
 * Represents a specific time frame where a schedule applies. It has a day and
 * month for for beginning and end, but not a year: it is assumed it repeats every
 * year at the same dates.
 */
export type WorkScheduleOverlapPeriod = {
  __typename?: 'WorkScheduleOverlapPeriod';
  dayConfigurations: Array<WorkScheduleDayConfiguration>;
  dayconfigurationsConnection: WorkScheduleDayConfigurationConnection;
  default: Scalars['Boolean'];
  endDate: Scalars['ISO8601Date'];
  endDay: Scalars['Int'];
  endMonth: Scalars['Int'];
  id: Scalars['Int'];
  schedule?: Maybe<WorkScheduleSchedule>;
  scheduleId: Scalars['Int'];
  scheduleType: Scalars['String'];
  startDate: Scalars['ISO8601Date'];
  startDay: Scalars['Int'];
  startMonth: Scalars['Int'];
};


/**
 * Represents a specific time frame where a schedule applies. It has a day and
 * month for for beginning and end, but not a year: it is assumed it repeats every
 * year at the same dates.
 */
export type WorkScheduleOverlapPeriodDayConfigurationsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  overlapPeriodId?: InputMaybe<Scalars['Int']>;
  scheduleId?: InputMaybe<Scalars['Int']>;
};


/**
 * Represents a specific time frame where a schedule applies. It has a day and
 * month for for beginning and end, but not a year: it is assumed it repeats every
 * year at the same dates.
 */
export type WorkScheduleOverlapPeriodDayconfigurationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  overlapPeriodId?: InputMaybe<Scalars['Int']>;
  scheduleId?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/**
 * Represents a specific time frame where a schedule applies. It has a day and
 * month for for beginning and end, but not a year: it is assumed it repeats every
 * year at the same dates.
 */
export type WorkScheduleOverlapPeriodScheduleArgs = {
  forSettings?: Scalars['Boolean'];
  onlyActive?: Scalars['Boolean'];
  onlyArchived?: Scalars['Boolean'];
  searchByName?: InputMaybe<Scalars['String']>;
  withEmployeeIds?: Scalars['Boolean'];
  withPeriods?: Scalars['Boolean'];
};

/** The connection type for WorkScheduleOverlapPeriod. */
export type WorkScheduleOverlapPeriodConnection = {
  __typename?: 'WorkScheduleOverlapPeriodConnection';
  /** A list of edges. */
  edges: Array<WorkScheduleOverlapPeriodEdge>;
  /** A list of nodes. */
  nodes: Array<WorkScheduleOverlapPeriod>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type WorkScheduleOverlapPeriodEdge = {
  __typename?: 'WorkScheduleOverlapPeriodEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: WorkScheduleOverlapPeriod;
};

/** Represents a specific work schedule. Contains multiple overlap periods. */
export type WorkScheduleSchedule = {
  __typename?: 'WorkScheduleSchedule';
  archivedAt?: Maybe<Scalars['ISO8601Date']>;
  canAssignEmployeesPolicy: WorkScheduleCanAssignEmployeesPolicy;
  canReassignEmployeesPolicy: WorkScheduleCanReassignEmployeesPolicy;
  companyId: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  employeeIds: Array<Scalars['Int']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  overlapPeriods: Array<WorkScheduleOverlapPeriod>;
  overlapperiodsConnection: WorkScheduleOverlapPeriodConnection;
  updatedAt: Scalars['ISO8601DateTime'];
};


/** Represents a specific work schedule. Contains multiple overlap periods. */
export type WorkScheduleScheduleOverlapPeriodsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Represents a specific work schedule. Contains multiple overlap periods. */
export type WorkScheduleScheduleOverlapperiodsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for WorkScheduleSchedule. */
export type WorkScheduleScheduleConnection = {
  __typename?: 'WorkScheduleScheduleConnection';
  /** A list of edges. */
  edges: Array<WorkScheduleScheduleEdge>;
  /** A list of nodes. */
  nodes: Array<WorkScheduleSchedule>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type WorkScheduleScheduleEdge = {
  __typename?: 'WorkScheduleScheduleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: WorkScheduleSchedule;
};

export type WorkflowsComparison = {
  __typename?: 'WorkflowsComparison';
  _type?: Maybe<Scalars['String']>;
  left: WorkflowsVariable;
  operator: WorkflowsValueObjectsConditionAstTermsRelationalOperatorEnum;
  right: WorkflowsLiteral;
};

/** Represents an edge/connection between workflow nodes */
export type WorkflowsEdge = {
  __typename?: 'WorkflowsEdge';
  companyId: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  fromNodeIdentifier: Scalars['String'];
  id: Scalars['Int'];
  label?: Maybe<Scalars['String']>;
  toNodeIdentifier: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
  workflowId: Scalars['Int'];
};

/** The connection type for WorkflowsEdge. */
export type WorkflowsEdgeConnection = {
  __typename?: 'WorkflowsEdgeConnection';
  /** A list of edges. */
  edges: Array<WorkflowsEdgeEdge>;
  /** A list of nodes. */
  nodes: Array<WorkflowsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type WorkflowsEdgeEdge = {
  __typename?: 'WorkflowsEdgeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: WorkflowsEdge;
};

export type WorkflowsEdgeInput = {
  fromIdentifier: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
  label?: InputMaybe<Scalars['String']>;
  toIdentifier: Scalars['String'];
};

export type WorkflowsEnumsExecutionHandlerStatusEnum =
  | 'completed'
  | 'failed'
  | 'running';

export type WorkflowsExpression = {
  __typename?: 'WorkflowsExpression';
  root: WorkflowsLogical;
};

export type WorkflowsHandler = {
  __typename?: 'WorkflowsHandler';
  actionGroup: Scalars['String'];
  inputs: Array<WorkflowsInput>;
  name: Scalars['String'];
};

export type WorkflowsInput = {
  __typename?: 'WorkflowsInput';
  name: Scalars['String'];
};

export type WorkflowsLiteral = {
  __typename?: 'WorkflowsLiteral';
  _type?: Maybe<Scalars['String']>;
  type: WorkflowsValueObjectsConditionAstTermsLiteralTypeEnum;
  value: Scalars['String'];
};

export type WorkflowsLogical = {
  __typename?: 'WorkflowsLogical';
  _type?: Maybe<Scalars['String']>;
  expressions: Array<WorkflowsComparison>;
  operator: WorkflowsValueObjectsConditionAstTermsLogicalOperatorEnum;
};

/** Represents a node in a workflow graph */
export type WorkflowsNode = {
  __typename?: 'WorkflowsNode';
  companyId: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  data?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  hackExposeExpressions?: Maybe<WorkflowsExpression>;
  id: Scalars['Int'];
  identifier: Scalars['String'];
  nodeType: WorkflowsValueObjectsNodeTypeEnum;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
  workflowId: Scalars['Int'];
};

/** The connection type for WorkflowsNode. */
export type WorkflowsNodeConnection = {
  __typename?: 'WorkflowsNodeConnection';
  /** A list of edges. */
  edges: Array<WorkflowsNodeEdge>;
  /** A list of nodes. */
  nodes: Array<WorkflowsNode>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type WorkflowsNodeEdge = {
  __typename?: 'WorkflowsNodeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: WorkflowsNode;
};

export type WorkflowsNodeInput = {
  data?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  identifier: Scalars['String'];
  nodeType: WorkflowsValueObjectsNodeTypeEnum;
  title?: InputMaybe<Scalars['String']>;
};

export type WorkflowsValueObjectsConditionAstTermsInputDataTypeEnum =
  | 'boolean'
  | 'float'
  | 'integer'
  | 'string';

export type WorkflowsValueObjectsConditionAstTermsLiteralTypeEnum =
  | 'boolean'
  | 'float'
  | 'integer'
  | 'integer_array'
  | 'nil'
  | 'string';

export type WorkflowsValueObjectsConditionAstTermsLogicalOperatorEnum =
  | 'and';

export type WorkflowsValueObjectsConditionAstTermsRelationalOperatorEnum =
  | 'eq'
  | 'gt'
  | 'gte'
  | 'lt'
  | 'lte'
  | 'neq'
  | 'not_one_of'
  | 'one_of';

export type WorkflowsValueObjectsNodeTypeEnum =
  | 'action'
  | 'start'
  | 'switch'
  | 'terminate';

export type WorkflowsVariable = {
  __typename?: 'WorkflowsVariable';
  _type?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  source: Scalars['String'];
};

/** Represents a workflow */
export type WorkflowsWorkflow = {
  __typename?: 'WorkflowsWorkflow';
  companyId: Scalars['Int'];
  /** Indicates whether the workflow is disabled and should not be executed */
  disabled: Scalars['Boolean'];
  id: Scalars['Int'];
  identifier: Scalars['String'];
  status: Scalars['String'];
  /** The ID of the target entity instance this workflow is associated with */
  targetId?: Maybe<Scalars['Int']>;
  /** The class name of the entity type this workflow is associated with */
  targetType?: Maybe<Scalars['String']>;
  useCase: Scalars['String'];
  /** version of the workflow. Once a workflow is published is immutable, to be able to edit a new version needs to be created. */
  version: Scalars['Int'];
  workflowEdges: Array<WorkflowsEdge>;
  workflowEdgesConnection: WorkflowsEdgeConnection;
  workflowManifest?: Maybe<WorkflowsWorkflowManifest>;
  workflowNodeFiles: Array<WorkflowsWorkflowNodeFile>;
  workflowNodeFilesConnection: WorkflowsWorkflowNodeFileConnection;
  workflowNodes: Array<WorkflowsNode>;
  workflowNodesConnection: WorkflowsNodeConnection;
};


/** Represents a workflow */
export type WorkflowsWorkflowWorkflowEdgesArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Represents a workflow */
export type WorkflowsWorkflowWorkflowEdgesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


/** Represents a workflow */
export type WorkflowsWorkflowWorkflowNodeFilesArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  workflowNodeIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Represents a workflow */
export type WorkflowsWorkflowWorkflowNodeFilesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  workflowNodeIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Represents a workflow */
export type WorkflowsWorkflowWorkflowNodesArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** Represents a workflow */
export type WorkflowsWorkflowWorkflowNodesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** The connection type for WorkflowsWorkflow. */
export type WorkflowsWorkflowConnection = {
  __typename?: 'WorkflowsWorkflowConnection';
  /** A list of edges. */
  edges: Array<WorkflowsWorkflowEdge>;
  /** A list of nodes. */
  nodes: Array<WorkflowsWorkflow>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type WorkflowsWorkflowDataInput = {
  __typename?: 'WorkflowsWorkflowDataInput';
  name: Scalars['String'];
  type: WorkflowsValueObjectsConditionAstTermsInputDataTypeEnum;
};

/** An edge in a connection. */
export type WorkflowsWorkflowEdge = {
  __typename?: 'WorkflowsWorkflowEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: WorkflowsWorkflow;
};

/** the filter for the workflows resource */
export type WorkflowsWorkflowFilter = {
  disabled?: InputMaybe<BooleanFilter>;
  id?: InputMaybe<IntegerFilter>;
  or?: InputMaybe<Array<WorkflowsWorkflowFilterConditions>>;
  targetId?: InputMaybe<IntegerFilter>;
  targetType?: InputMaybe<StringFilter>;
  version?: InputMaybe<IntegerFilter>;
};

export type WorkflowsWorkflowFilterConditions = {
  disabled?: InputMaybe<BooleanFilter>;
  id?: InputMaybe<IntegerFilter>;
  targetId?: InputMaybe<IntegerFilter>;
  targetType?: InputMaybe<StringFilter>;
  version?: InputMaybe<IntegerFilter>;
};

/** Represents a workflow handler execution */
export type WorkflowsWorkflowHandlerExecution = {
  __typename?: 'WorkflowsWorkflowHandlerExecution';
  asyncTask: Scalars['Boolean'];
  companyId: Scalars['Int'];
  error?: Maybe<Scalars['String']>;
  finishedAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['Int'];
  operationType: Scalars['String'];
  startedAt?: Maybe<Scalars['ISO8601DateTime']>;
  status: WorkflowsEnumsExecutionHandlerStatusEnum;
  taskReferenceName: Scalars['String'];
  workflowExecutionId: Scalars['Int'];
};

/** Represents a workflow manifest from the registry */
export type WorkflowsWorkflowManifest = {
  __typename?: 'WorkflowsWorkflowManifest';
  handlers: Array<WorkflowsHandler>;
  useCase: Scalars['String'];
  workflowDataInputs: Array<WorkflowsWorkflowDataInput>;
};

/** The connection type for WorkflowsWorkflowManifest. */
export type WorkflowsWorkflowManifestConnection = {
  __typename?: 'WorkflowsWorkflowManifestConnection';
  /** A list of edges. */
  edges: Array<WorkflowsWorkflowManifestEdge>;
  /** A list of nodes. */
  nodes: Array<WorkflowsWorkflowManifest>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type WorkflowsWorkflowManifestEdge = {
  __typename?: 'WorkflowsWorkflowManifestEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: WorkflowsWorkflowManifest;
};

/** Represents files attached to a workflow node. */
export type WorkflowsWorkflowNodeFile = {
  __typename?: 'WorkflowsWorkflowNodeFile';
  companyId: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  file?: Maybe<WorkflowsWorkflowNodeFileAttachment>;
  id: Scalars['Int'];
  nodeIdentifier?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
  workflowId: Scalars['Int'];
  workflowNodeId?: Maybe<Scalars['Int']>;
};

export type WorkflowsWorkflowNodeFileAttachment = {
  __typename?: 'WorkflowsWorkflowNodeFileAttachment';
  byteSize: Scalars['Int'];
  contentType: Scalars['String'];
  filename: Scalars['String'];
  id: Scalars['Int'];
  url: Scalars['String'];
};

/** The connection type for WorkflowsWorkflowNodeFile. */
export type WorkflowsWorkflowNodeFileConnection = {
  __typename?: 'WorkflowsWorkflowNodeFileConnection';
  /** A list of edges. */
  edges: Array<WorkflowsWorkflowNodeFileEdge>;
  /** A list of nodes. */
  nodes: Array<WorkflowsWorkflowNodeFile>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type WorkflowsWorkflowNodeFileEdge = {
  __typename?: 'WorkflowsWorkflowNodeFileEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: WorkflowsWorkflowNodeFile;
};

/** Working conditions applicable assignment */
export type WorkingConditionsApplicableAssignment = {
  __typename?: 'WorkingConditionsApplicableAssignment';
  companyId: Scalars['Int'];
  groupType: Scalars['String'];
  id: Scalars['Int'];
  jobLevelId?: Maybe<Scalars['Int']>;
  version: WorkingConditionsVersion;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  versionId: Scalars['Int'];
  workplaceId?: Maybe<Scalars['Int']>;
};


/** Working conditions applicable assignment */
export type WorkingConditionsApplicableAssignmentVersionArgs = {
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  workingConditionGroupIds?: InputMaybe<Array<Scalars['Int']>>;
};

/** The connection type for WorkingConditionsApplicableAssignment. */
export type WorkingConditionsApplicableAssignmentConnection = {
  __typename?: 'WorkingConditionsApplicableAssignmentConnection';
  /** A list of edges. */
  edges: Array<WorkingConditionsApplicableAssignmentEdge>;
  /** A list of nodes. */
  nodes: Array<WorkingConditionsApplicableAssignment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type WorkingConditionsApplicableAssignmentEdge = {
  __typename?: 'WorkingConditionsApplicableAssignmentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: WorkingConditionsApplicableAssignment;
};

export type WorkingConditionsApplyToStrategyInput = {
  jobCatalogLevelId?: InputMaybe<Scalars['Int']>;
  locationId?: InputMaybe<Scalars['Int']>;
};

/** Working conditions group */
export type WorkingConditionsGroup = {
  __typename?: 'WorkingConditionsGroup';
  companyId: Scalars['Int'];
  id: Scalars['Int'];
  isArchived: Scalars['Boolean'];
};

/** The connection type for WorkingConditionsGroup. */
export type WorkingConditionsGroupConnection = {
  __typename?: 'WorkingConditionsGroupConnection';
  /** A list of edges. */
  edges: Array<WorkingConditionsGroupEdge>;
  /** A list of nodes. */
  nodes: Array<WorkingConditionsGroup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type WorkingConditionsGroupEdge = {
  __typename?: 'WorkingConditionsGroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: WorkingConditionsGroup;
};

/** Working conditions item */
export type WorkingConditionsItem = {
  __typename?: 'WorkingConditionsItem';
  companyId: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['String'];
  type: Scalars['String'];
  value: Scalars['String'];
  version: WorkingConditionsVersion;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  versionId: Scalars['Int'];
};


/** Working conditions item */
export type WorkingConditionsItemVersionArgs = {
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  workingConditionGroupIds?: InputMaybe<Array<Scalars['Int']>>;
};

/** The connection type for WorkingConditionsItem. */
export type WorkingConditionsItemConnection = {
  __typename?: 'WorkingConditionsItemConnection';
  /** A list of edges. */
  edges: Array<WorkingConditionsItemEdge>;
  /** A list of nodes. */
  nodes: Array<WorkingConditionsItem>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type WorkingConditionsItemEdge = {
  __typename?: 'WorkingConditionsItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: WorkingConditionsItem;
};

/** Working conditions people assignment */
export type WorkingConditionsPeopleAssignment = {
  __typename?: 'WorkingConditionsPeopleAssignment';
  companyId: Scalars['Int'];
  groupType: Scalars['String'];
  id: Scalars['Int'];
  jobLevel?: Maybe<JobCatalogLevel>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  jobLevelId?: Maybe<Scalars['Int']>;
  version: WorkingConditionsVersion;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  versionId: Scalars['Int'];
  workplace?: Maybe<LocationsLocation>;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  workplaceId?: Maybe<Scalars['Int']>;
};


/** Working conditions people assignment */
export type WorkingConditionsPeopleAssignmentJobLevelArgs = {
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  includeArchived?: Scalars['Boolean'];
  includeArchivedRole?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  roleIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Working conditions people assignment */
export type WorkingConditionsPeopleAssignmentVersionArgs = {
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  workingConditionGroupIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Working conditions people assignment */
export type WorkingConditionsPeopleAssignmentWorkplaceArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  main?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};

/** The connection type for WorkingConditionsPeopleAssignment. */
export type WorkingConditionsPeopleAssignmentConnection = {
  __typename?: 'WorkingConditionsPeopleAssignmentConnection';
  /** A list of edges. */
  edges: Array<WorkingConditionsPeopleAssignmentEdge>;
  /** A list of nodes. */
  nodes: Array<WorkingConditionsPeopleAssignment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type WorkingConditionsPeopleAssignmentEdge = {
  __typename?: 'WorkingConditionsPeopleAssignmentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: WorkingConditionsPeopleAssignment;
};

/** Working conditions version */
export type WorkingConditionsVersion = {
  __typename?: 'WorkingConditionsVersion';
  companyId: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  effectiveOn: Scalars['ISO8601Date'];
  group: WorkingConditionsGroup;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  groupId: Scalars['Int'];
  id: Scalars['Int'];
  items: Array<WorkingConditionsItem>;
  itemsConnection: WorkingConditionsItemConnection;
  name: Scalars['String'];
  peopleAssignments: Array<WorkingConditionsPeopleAssignment>;
  peopleAssignmentsConnection: WorkingConditionsPeopleAssignmentConnection;
};


/** Working conditions version */
export type WorkingConditionsVersionGroupArgs = {
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  includeArchived?: InputMaybe<Scalars['Boolean']>;
};


/** Working conditions version */
export type WorkingConditionsVersionItemsArgs = {
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  workingConditionsVersionIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Working conditions version */
export type WorkingConditionsVersionItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  workingConditionsVersionIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Working conditions version */
export type WorkingConditionsVersionPeopleAssignmentsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  workingConditionsVersionIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** Working conditions version */
export type WorkingConditionsVersionPeopleAssignmentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  workingConditionsVersionIds?: InputMaybe<Array<Scalars['Int']>>;
};

/** Working conditions version application */
export type WorkingConditionsVersionApplication = {
  __typename?: 'WorkingConditionsVersionApplication';
  companyId: Scalars['Int'];
  contractVersion: ContractsContractVersion;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  contractVersionId: Scalars['Int'];
  differentFieldsCount: Scalars['Int'];
  fields: Array<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  jobTitle?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  version: WorkingConditionsVersion;
  /** @deprecated This kind of 'foreign key' is not used in GraphQL. Use the relation */
  versionId: Scalars['Int'];
};


/** Working conditions version application */
export type WorkingConditionsVersionApplicationContractVersionArgs = {
  activeOn?: InputMaybe<Scalars['ISO8601Date']>;
  activeOrUpcomingOn?: InputMaybe<Scalars['ISO8601Date']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  contractIds?: InputMaybe<Array<Scalars['Int']>>;
  date?: InputMaybe<Scalars['ISO8601Date']>;
  effectiveOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  effectiveOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endsOnGt?: InputMaybe<Scalars['ISO8601Date']>;
  endsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  endsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  esEducationLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  forfaitJours?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  jobCatalogTreeNodeUuids?: InputMaybe<Array<Scalars['String']>>;
  levelIds?: InputMaybe<Array<Scalars['Int']>>;
  startsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  startsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  upcomingOn?: InputMaybe<Scalars['ISO8601Date']>;
  withFallback?: Scalars['Boolean'];
  withHasPayrollPolicies?: InputMaybe<Scalars['Boolean']>;
  withMetadata?: Scalars['Boolean'];
  withOldestEffectiveOn?: InputMaybe<Scalars['Boolean']>;
  withPayroll?: InputMaybe<Scalars['Boolean']>;
  withSalaryAmount?: InputMaybe<Scalars['Boolean']>;
  withoutSalaryAmountOrSalaryFrequency?: InputMaybe<Scalars['Boolean']>;
};


/** Working conditions version application */
export type WorkingConditionsVersionApplicationVersionArgs = {
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  workingConditionGroupIds?: InputMaybe<Array<Scalars['Int']>>;
};

/** The connection type for WorkingConditionsVersionApplication. */
export type WorkingConditionsVersionApplicationConnection = {
  __typename?: 'WorkingConditionsVersionApplicationConnection';
  /** A list of edges. */
  edges: Array<WorkingConditionsVersionApplicationEdge>;
  /** A list of nodes. */
  nodes: Array<WorkingConditionsVersionApplication>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type WorkingConditionsVersionApplicationEdge = {
  __typename?: 'WorkingConditionsVersionApplicationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: WorkingConditionsVersionApplication;
};

/** the filter for the version_applications resource */
export type WorkingConditionsVersionApplicationFilter = {
  firstName?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntegerFilter>;
  jobTitle?: InputMaybe<StringFilter>;
  lastName?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<WorkingConditionsVersionApplicationFilterConditions>>;
};

export type WorkingConditionsVersionApplicationFilterConditions = {
  firstName?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntegerFilter>;
  jobTitle?: InputMaybe<StringFilter>;
  lastName?: InputMaybe<StringFilter>;
};

/** The connection type for WorkingConditionsVersion. */
export type WorkingConditionsVersionConnection = {
  __typename?: 'WorkingConditionsVersionConnection';
  /** A list of edges. */
  edges: Array<WorkingConditionsVersionEdge>;
  /** A list of nodes. */
  nodes: Array<WorkingConditionsVersion>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type WorkingConditionsVersionEdge = {
  __typename?: 'WorkingConditionsVersionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: WorkingConditionsVersion;
};

export type AccountSettings = {
  __typename?: 'accountSettings';
  /** @deprecated Please favor `categoriesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  categories: Array<AccountSettingsCategory>;
  categoriesConnection: AccountSettingsCategoryConnection;
  category?: Maybe<AccountSettingsCategory>;
  setting?: Maybe<AccountSettingsSetting>;
  /** @deprecated Please favor `settingsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  settings: Array<AccountSettingsSetting>;
  settingsConnection: AccountSettingsSettingConnection;
};


export type AccountSettingsCategoriesArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};


export type AccountSettingsCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type AccountSettingsCategoryArgs = {
  id: Scalars['String'];
};


export type AccountSettingsSettingArgs = {
  companyId: Scalars['Int'];
  id: Scalars['String'];
};


export type AccountSettingsSettingsArgs = {
  categoryIds?: InputMaybe<Array<Scalars['String']>>;
  companyId: Scalars['Int'];
  ids?: InputMaybe<Array<Scalars['String']>>;
};


export type AccountSettingsSettingsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  categoryIds?: InputMaybe<Array<Scalars['String']>>;
  companyId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

export type ActivityLog = {
  __typename?: 'activityLog';
  log?: Maybe<ActivityLogLog>;
  /** @deprecated Please favor `logsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  logs: Array<ActivityLogLog>;
  logsConnection: ActivityLogLogConnection;
};


export type ActivityLogLogArgs = {
  id: Scalars['Int'];
  identifier: Scalars['String'];
  sources: Array<Scalars['String']>;
};


export type ActivityLogLogsArgs = {
  authorId?: InputMaybe<Scalars['Int']>;
  identifier: Scalars['String'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  parentResourceId?: InputMaybe<Scalars['Int']>;
  sources: Array<Scalars['String']>;
};


export type ActivityLogLogsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  authorId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  identifier: Scalars['String'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  parentResourceId?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  sources: Array<Scalars['String']>;
};

/** Payload for aggregated_balance and subscription: refresh */
export type Aggregated_Balance_Refresh_Type = {
  __typename?: 'aggregated_balance_refresh_type';
  balances: Array<AttendanceAggregatedBalanceSubscription>;
  employeeId: Scalars['Int'];
  error?: Maybe<Scalars['Boolean']>;
};

/** Payload for agreement and subscription: refresh */
export type Agreement_Refresh_Type = {
  __typename?: 'agreement_refresh_type';
  error?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
};

export type Analytics = {
  __typename?: 'analytics';
  _policies: AnalyticsContextlessPolicies;
  report?: Maybe<AnalyticsReport>;
  /** @deprecated Please favor `reportsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  reports: Array<AnalyticsReport>;
  reportsConnection: AnalyticsReportConnection;
};


export type AnalyticsReportArgs = {
  companyIds: Array<Scalars['Int']>;
  id: Scalars['String'];
};


export type AnalyticsReportsArgs = {
  authorId?: InputMaybe<Scalars['String']>;
  companyIds: Array<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
};


export type AnalyticsReportsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  authorId?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyIds: Array<Scalars['Int']>;
  filter?: InputMaybe<AnalyticsReportFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};

export type AnalyticsMutations = {
  __typename?: 'analyticsMutations';
  createAnalyticsReport: CreateAnalyticsReportPayload;
  deleteAnalyticsReport: DeleteAnalyticsReportPayload;
  updateAnalyticsReport: UpdateAnalyticsReportPayload;
};


export type AnalyticsMutationsCreateAnalyticsReportArgs = {
  columnFormatHints?: InputMaybe<Array<AnalyticsFormatHintInput>>;
  companyId: Scalars['Int'];
  datasourceId: Scalars['String'];
  description: Scalars['String'];
  filters?: InputMaybe<AnalyticsReportFiltersInput>;
  id: Scalars['String'];
  name: Scalars['String'];
  widgets: Array<AnalyticsWidgetInput>;
};


export type AnalyticsMutationsDeleteAnalyticsReportArgs = {
  companyId: Scalars['Int'];
  id: Scalars['String'];
};


export type AnalyticsMutationsUpdateAnalyticsReportArgs = {
  columnFormatHints?: InputMaybe<Array<AnalyticsFormatHintInput>>;
  companyId: Scalars['Int'];
  description?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<AnalyticsReportFiltersInput>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  widgets?: InputMaybe<Array<AnalyticsWidgetInput>>;
};

export type ApiCore = {
  __typename?: 'apiCore';
  _policies: ApiCoreContextlessPolicies;
  access?: Maybe<ApiCoreAccess>;
  /** @deprecated Please favor `accessesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  accesses: Array<ApiCoreAccess>;
  accessesConnection: ApiCoreAccessConnection;
  /** @deprecated Please favor `companiesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  companies: Array<ApiCoreCompany>;
  companiesConnection: ApiCoreCompanyConnection;
  company?: Maybe<ApiCoreCompany>;
  /** @deprecated Please favor `currenciesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  currencies: Array<ApiCoreCurrency>;
  currenciesConnection: ApiCoreCurrencyConnection;
  /** @deprecated Please favor `currentsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  currents: Array<ApiCoreCurrent>;
  currentsConnection: ApiCoreCurrentConnection;
  /** @deprecated Please favor `moduleRegistriesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  moduleRegistries: Array<ApiCoreModuleRegistry>;
  moduleRegistriesConnection: ApiCoreModuleRegistryConnection;
  moduleRegistry?: Maybe<ApiCoreModuleRegistry>;
};


export type ApiCoreAccessArgs = {
  id: Scalars['Int'];
};


export type ApiCoreAccessesArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  external?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


export type ApiCoreAccessesConnectionArgs = {
  affiliations?: InputMaybe<Array<ApiCoreEntitiesAccessAffiliationEnum>>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  external?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ApiCoreAccessFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withRegularAccess?: InputMaybe<Scalars['Boolean']>;
};


export type ApiCoreCompaniesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type ApiCoreCompaniesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ApiCoreCompanyArgs = {
  id: Scalars['Int'];
};


export type ApiCoreCurrenciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ApiCoreCurrentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ApiCoreModuleRegistriesArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};


export type ApiCoreModuleRegistriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ApiCoreModuleRegistryArgs = {
  id: Scalars['String'];
};

export type ApiCoreMutations = {
  __typename?: 'apiCoreMutations';
  createApicoreAccess: CreateApicoreAccessPayload;
  createExternalApicoreAccess: CreateExternalApicoreAccessPayload;
  deactivateApicoreAccess: DeactivateApicoreAccessPayload;
  inviteApicoreAccess: InviteApicoreAccessPayload;
  uninviteApicoreAccess: UninviteApicoreAccessPayload;
  updateApicoreAccess: UpdateApicoreAccessPayload;
};


export type ApiCoreMutationsCreateApicoreAccessArgs = {
  affiliation: AccessAffiliationEnum;
  companyId: Scalars['Int'];
  role: AccessRoleEnum;
};


export type ApiCoreMutationsCreateExternalApicoreAccessArgs = {
  avatar?: InputMaybe<Scalars['File']>;
  companyId: Scalars['Int'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};


export type ApiCoreMutationsDeactivateApicoreAccessArgs = {
  id: Scalars['Int'];
};


export type ApiCoreMutationsInviteApicoreAccessArgs = {
  id: Scalars['Int'];
};


export type ApiCoreMutationsUninviteApicoreAccessArgs = {
  id: Scalars['Int'];
};


export type ApiCoreMutationsUpdateApicoreAccessArgs = {
  analyticsConsent?: InputMaybe<Scalars['Boolean']>;
  avatar?: InputMaybe<Scalars['File']>;
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  lastName?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  removeAvatar?: InputMaybe<Scalars['Boolean']>;
};

export type ApiPublic = {
  __typename?: 'apiPublic';
  _policies: ApiPublicContextlessPolicies;
};

export type Approvals = {
  __typename?: 'approvals';
  _policies: ApprovalsContextlessPolicies;
  /** @deprecated Please favor `accessApprovalFlowsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  accessApprovalFlows: Array<ApprovalsAccessApprovalFlow>;
  accessApprovalFlowsConnection: ApprovalsAccessApprovalFlowConnection;
  approvalFlow?: Maybe<ApprovalsApprovalFlow>;
  /** @deprecated Please favor `approvalFlowsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  approvalFlows: Array<ApprovalsApprovalFlow>;
  approvalFlowsConnection: ApprovalsApprovalFlowConnection;
  approvalGroup?: Maybe<ApprovalsApprovalGroup>;
  approvalGroupMembership?: Maybe<ApprovalsApprovalGroupMembership>;
  /** @deprecated Please favor `approvalGroupMembershipsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  approvalGroupMemberships: Array<ApprovalsApprovalGroupMembership>;
  approvalGroupMembershipsConnection: ApprovalsApprovalGroupMembershipConnection;
  /** @deprecated Please favor `approvalGroupsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  approvalGroups: Array<ApprovalsApprovalGroup>;
  approvalGroupsConnection: ApprovalsApprovalGroupConnection;
  /** @deprecated Please favor `limitsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  limits: Array<ApprovalsLimit>;
  limitsConnection: ApprovalsLimitConnection;
  materializedApprovalStep?: Maybe<ApprovalsMaterializedApprovalStep>;
  materializedApprovalStepApprover?: Maybe<ApprovalsMaterializedApprovalStepApprover>;
  /** @deprecated Please favor `materializedApprovalStepApproversConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  materializedApprovalStepApprovers: Array<ApprovalsMaterializedApprovalStepApprover>;
  materializedApprovalStepApproversConnection: ApprovalsMaterializedApprovalStepApproverConnection;
  /** @deprecated Please favor `materializedApprovalStepsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  materializedApprovalSteps: Array<ApprovalsMaterializedApprovalStep>;
  materializedApprovalStepsConnection: ApprovalsMaterializedApprovalStepConnection;
  materializedApprovalsFlow?: Maybe<ApprovalsMaterializedApprovalsFlow>;
  /** @deprecated Please favor `materializedApprovalsFlowsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  materializedApprovalsFlows: Array<ApprovalsMaterializedApprovalsFlow>;
  materializedApprovalsFlowsConnection: ApprovalsMaterializedApprovalsFlowConnection;
  rule?: Maybe<ApprovalsRule>;
  /** @deprecated Please favor `rulesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  rules: Array<ApprovalsRule>;
  rulesConfiguration?: Maybe<ApprovalsRulesConfiguration>;
  /** @deprecated Please favor `rulesConfigurationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  rulesConfigurations: Array<ApprovalsRulesConfiguration>;
  rulesConfigurationsConnection: ApprovalsRulesConfigurationConnection;
  rulesConnection: ApprovalsRuleConnection;
};


export type ApprovalsAccessApprovalFlowsArgs = {
  accessId: Scalars['Int'];
  category?: InputMaybe<ApprovalsValueObjectsApprovalCategoryEnum>;
};


export type ApprovalsAccessApprovalFlowsConnectionArgs = {
  accessId: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<ApprovalsValueObjectsApprovalCategoryEnum>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ApprovalsApprovalFlowArgs = {
  id: Scalars['Int'];
};


export type ApprovalsApprovalFlowsArgs = {
  approvalGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type ApprovalsApprovalFlowsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  approvalGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ApprovalsApprovalGroupArgs = {
  id: Scalars['Int'];
};


export type ApprovalsApprovalGroupMembershipArgs = {
  id: Scalars['Int'];
};


export type ApprovalsApprovalGroupMembershipsArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  approvalGroupId?: InputMaybe<Scalars['Int']>;
  autoApprovalGroup?: InputMaybe<Scalars['Boolean']>;
  category?: InputMaybe<ApprovalsValueObjectsApprovalCategoryEnum>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


export type ApprovalsApprovalGroupMembershipsConnectionArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  after?: InputMaybe<Scalars['String']>;
  approvalGroupId?: InputMaybe<Scalars['Int']>;
  autoApprovalGroup?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<ApprovalsValueObjectsApprovalCategoryEnum>;
  filter?: InputMaybe<ApprovalsApprovalGroupMembershipFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ApprovalsApprovalGroupsArgs = {
  accessId?: Array<Scalars['Int']>;
  autoApproved?: Scalars['Boolean'];
  category?: InputMaybe<ApprovalsValueObjectsApprovalCategoryEnum>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


export type ApprovalsApprovalGroupsConnectionArgs = {
  accessId?: Array<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  autoApproved?: Scalars['Boolean'];
  before?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<ApprovalsValueObjectsApprovalCategoryEnum>;
  filter?: InputMaybe<ApprovalsApprovalGroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ApprovalsLimitsArgs = {
  companyId: Scalars['Int'];
};


export type ApprovalsLimitsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ApprovalsMaterializedApprovalStepArgs = {
  id: Scalars['Int'];
};


export type ApprovalsMaterializedApprovalStepApproverArgs = {
  id: Scalars['Int'];
};


export type ApprovalsMaterializedApprovalStepApproversArgs = {
  approvalFlowIds?: InputMaybe<Array<Scalars['Int']>>;
  approverStatus?: InputMaybe<ApprovalsMaterializedApprovalStepApproverApproverStatusEnum>;
  employeeId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  materializedApprovalStepIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type ApprovalsMaterializedApprovalStepApproversConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  approvalFlowIds?: InputMaybe<Array<Scalars['Int']>>;
  approverStatus?: InputMaybe<ApprovalsMaterializedApprovalStepApproverApproverStatusEnum>;
  before?: InputMaybe<Scalars['String']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  materializedApprovalStepIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ApprovalsMaterializedApprovalStepsArgs = {
  approvalStepIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  materializedApprovalFlowIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type ApprovalsMaterializedApprovalStepsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  approvalStepIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  materializedApprovalFlowIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ApprovalsMaterializedApprovalsFlowArgs = {
  id: Scalars['Int'];
};


export type ApprovalsMaterializedApprovalsFlowsArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  ownerId?: InputMaybe<Scalars['Int']>;
  resourceIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceType?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ApprovalsMaterializedApprovalFlowStatusEnum>;
};


export type ApprovalsMaterializedApprovalsFlowsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  ownerId?: InputMaybe<Scalars['Int']>;
  resourceIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceType?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  status?: InputMaybe<ApprovalsMaterializedApprovalFlowStatusEnum>;
};


export type ApprovalsRuleArgs = {
  category: ApprovalsValueObjectsApprovalCategoryEnum;
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type ApprovalsRulesArgs = {
  category: ApprovalsValueObjectsApprovalCategoryEnum;
  companyId: Scalars['Int'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  rulesConfigurationIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type ApprovalsRulesConfigurationArgs = {
  id: Scalars['Int'];
};


export type ApprovalsRulesConfigurationsArgs = {
  approvalGroupId?: InputMaybe<Scalars['Int']>;
  approvalGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type ApprovalsRulesConfigurationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  approvalGroupId?: InputMaybe<Scalars['Int']>;
  approvalGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ApprovalsRulesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  category: ApprovalsValueObjectsApprovalCategoryEnum;
  companyId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  rulesConfigurationIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
};

export type ApprovalsMutations = {
  __typename?: 'approvalsMutations';
  approveApprovalsMaterializedApprovalStepApprover: ApproveApprovalsMaterializedApprovalStepApproverPayload;
  approveApprovalsMaterializedApprovalsFlow: ApproveApprovalsMaterializedApprovalsFlowPayload;
  bulkApproveApprovalsMaterializedApprovalsFlow: BulkApproveApprovalsMaterializedApprovalsFlowPayload;
  bulkAssignApprovalsApprovalGroupMembership: BulkAssignApprovalsApprovalGroupMembershipPayload;
  bulkMoveApprovalsApprovalGroupMembership: BulkMoveApprovalsApprovalGroupMembershipPayload;
  bulkRejectApprovalsMaterializedApprovalsFlow: BulkRejectApprovalsMaterializedApprovalsFlowPayload;
  continueApprovalsMaterializedApprovalsFlow: ContinueApprovalsMaterializedApprovalsFlowPayload;
  createApprovalsApprovalFlow: CreateApprovalsApprovalFlowPayload;
  createApprovalsApprovalGroup: CreateApprovalsApprovalGroupPayload;
  createApprovalsRulesConfiguration: CreateApprovalsRulesConfigurationPayload;
  deleteApprovalsApprovalGroup: DeleteApprovalsApprovalGroupPayload;
  deleteApprovalsRulesConfiguration: DeleteApprovalsRulesConfigurationPayload;
  filterApprovalsMaterializedApprovalsFlow: FilterApprovalsMaterializedApprovalsFlowPayload;
  isApproverApprovalsMaterializedApprovalsFlow: IsApproverApprovalsMaterializedApprovalsFlowPayload;
  rejectApprovalsMaterializedApprovalStepApprover: RejectApprovalsMaterializedApprovalStepApproverPayload;
  rejectApprovalsMaterializedApprovalsFlow: RejectApprovalsMaterializedApprovalsFlowPayload;
  requestChangesApprovalsMaterializedApprovalsFlow: RequestChangesApprovalsMaterializedApprovalsFlowPayload;
  restartApprovalFlowApprovalsMaterializedApprovalsFlow: RestartApprovalFlowApprovalsMaterializedApprovalsFlowPayload;
  setAsDefaultApprovalsApprovalGroup: SetAsDefaultApprovalsApprovalGroupPayload;
  stopApprovalFlowApprovalsMaterializedApprovalsFlow: StopApprovalFlowApprovalsMaterializedApprovalsFlowPayload;
  updateApprovalsApprovalFlow: UpdateApprovalsApprovalFlowPayload;
  updateApprovalsApprovalGroup: UpdateApprovalsApprovalGroupPayload;
  updateApprovalsRulesConfiguration: UpdateApprovalsRulesConfigurationPayload;
  updateEmailDetailBlocksApprovalsMaterializedApprovalsFlow: UpdateEmailDetailBlocksApprovalsMaterializedApprovalsFlowPayload;
  updatePositionsApprovalsRulesConfiguration: UpdatePositionsApprovalsRulesConfigurationPayload;
  updateResourceUrlApprovalsMaterializedApprovalsFlow: UpdateResourceUrlApprovalsMaterializedApprovalsFlowPayload;
};


export type ApprovalsMutationsApproveApprovalsMaterializedApprovalStepApproverArgs = {
  accessId: Scalars['Int'];
  ids: Array<Scalars['Int']>;
  reason?: InputMaybe<Scalars['String']>;
};


export type ApprovalsMutationsApproveApprovalsMaterializedApprovalsFlowArgs = {
  accessId: Scalars['Int'];
  approveWholeFlow: Scalars['Boolean'];
  materializedApprovalFlowId: Scalars['Int'];
  reason?: InputMaybe<Scalars['String']>;
};


export type ApprovalsMutationsBulkApproveApprovalsMaterializedApprovalsFlowArgs = {
  materializedApprovalFlowIds?: InputMaybe<Array<Scalars['Int']>>;
  materializedStepApproverIds?: InputMaybe<Array<Scalars['Int']>>;
  reason?: InputMaybe<Scalars['String']>;
  updateWholeFlow: Scalars['Boolean'];
};


export type ApprovalsMutationsBulkAssignApprovalsApprovalGroupMembershipArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  approvalGroupId: Scalars['Int'];
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type ApprovalsMutationsBulkMoveApprovalsApprovalGroupMembershipArgs = {
  destinationApprovalGroupId: Scalars['Int'];
  membershipIds: Array<Scalars['Int']>;
  originApprovalGroupId: Scalars['Int'];
};


export type ApprovalsMutationsBulkRejectApprovalsMaterializedApprovalsFlowArgs = {
  materializedApprovalFlowIds?: InputMaybe<Array<Scalars['Int']>>;
  materializedStepApproverIds?: InputMaybe<Array<Scalars['Int']>>;
  reason?: InputMaybe<Scalars['String']>;
  updateWholeFlow: Scalars['Boolean'];
};


export type ApprovalsMutationsContinueApprovalsMaterializedApprovalsFlowArgs = {
  reason?: InputMaybe<Scalars['String']>;
};


export type ApprovalsMutationsCreateApprovalsApprovalFlowArgs = {
  approvalGroupId?: InputMaybe<Scalars['Int']>;
  default: Scalars['Boolean'];
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  onApprovalFlowChange?: InputMaybe<ApprovalsApprovalFlowOnApprovalFlowChangeEnum>;
  stepIdsToBeDeleted: Array<Scalars['Int']>;
  steps: Array<CreateApprovalsApprovalFlowStepsInput>;
};


export type ApprovalsMutationsCreateApprovalsApprovalGroupArgs = {
  autoApproved?: InputMaybe<Scalars['Boolean']>;
  category: ApprovalsValueObjectsApprovalCategoryEnum;
  companyId: Scalars['Int'];
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};


export type ApprovalsMutationsCreateApprovalsRulesConfigurationArgs = {
  approvalFlow?: InputMaybe<CreateApprovalsRulesConfigurationApprovalFlowInput>;
  approvalFlowId?: InputMaybe<Scalars['Int']>;
  approvalGroupId: Scalars['Int'];
  category: ApprovalsValueObjectsApprovalCategoryEnum;
  isTemplate?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  onRulesFail?: InputMaybe<ApprovalsValueObjectsRulesConfigurationRuleDecisionEnum>;
  onRulesMet?: InputMaybe<ApprovalsValueObjectsRulesConfigurationRuleDecisionEnum>;
  rules: Array<CreateApprovalsRulesConfigurationRulesInput>;
};


export type ApprovalsMutationsDeleteApprovalsApprovalGroupArgs = {
  destinationGroupId?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
};


export type ApprovalsMutationsDeleteApprovalsRulesConfigurationArgs = {
  id: Scalars['Int'];
};


export type ApprovalsMutationsFilterApprovalsMaterializedApprovalsFlowArgs = {
  actionType?: InputMaybe<Scalars['String']>;
  approverAccessId?: InputMaybe<Scalars['Int']>;
  approverFlowStatus?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  fromDate?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  representation?: InputMaybe<ApprovalsDtosMaterializedApprovalFlowsRepresentationEnum>;
  resourceIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceType?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  toDate?: InputMaybe<Scalars['ISO8601Date']>;
  withApprovers?: InputMaybe<Scalars['Boolean']>;
};


export type ApprovalsMutationsIsApproverApprovalsMaterializedApprovalsFlowArgs = {
  actionType?: InputMaybe<Scalars['String']>;
  approverAccessId?: InputMaybe<Scalars['Int']>;
  approverFlowStatus?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  fromDate?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  representation?: InputMaybe<ApprovalsDtosMaterializedApprovalFlowsRepresentationEnum>;
  resourceIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceType?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  toDate?: InputMaybe<Scalars['ISO8601Date']>;
  withApprovers?: InputMaybe<Scalars['Boolean']>;
};


export type ApprovalsMutationsRejectApprovalsMaterializedApprovalStepApproverArgs = {
  accessId: Scalars['Int'];
  ids: Array<Scalars['Int']>;
  reason?: InputMaybe<Scalars['String']>;
};


export type ApprovalsMutationsRejectApprovalsMaterializedApprovalsFlowArgs = {
  accessId: Scalars['Int'];
  materializedApprovalFlowId: Scalars['Int'];
  reason?: InputMaybe<Scalars['String']>;
  rejectWholeFlow: Scalars['Boolean'];
};


export type ApprovalsMutationsRequestChangesApprovalsMaterializedApprovalsFlowArgs = {
  materializedApprovalFlowId: Scalars['Int'];
  reason: Scalars['String'];
};


export type ApprovalsMutationsRestartApprovalFlowApprovalsMaterializedApprovalsFlowArgs = {
  emailDetailBlocks?: InputMaybe<Array<RestartApprovalFlowApprovalsMaterializedApprovalsFlowEmailDetailBlocksInput>>;
  expiresAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  forceRestart: Scalars['Boolean'];
  resourceId: Scalars['Int'];
  resourceType: Scalars['String'];
  skipAutoApproveOnRestart: Scalars['Boolean'];
};


export type ApprovalsMutationsSetAsDefaultApprovalsApprovalGroupArgs = {
  id: Scalars['Int'];
};


export type ApprovalsMutationsStopApprovalFlowApprovalsMaterializedApprovalsFlowArgs = {
  emailDetailBlocks?: InputMaybe<Array<StopApprovalFlowApprovalsMaterializedApprovalsFlowEmailDetailBlocksInput>>;
  expiresAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  forceRestart: Scalars['Boolean'];
  resourceId: Scalars['Int'];
  resourceType: Scalars['String'];
  skipAutoApproveOnRestart: Scalars['Boolean'];
};


export type ApprovalsMutationsUpdateApprovalsApprovalFlowArgs = {
  approvalGroupId?: InputMaybe<Scalars['Int']>;
  default: Scalars['Boolean'];
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  onApprovalFlowChange?: InputMaybe<ApprovalsApprovalFlowOnApprovalFlowChangeEnum>;
  stepIdsToBeDeleted: Array<Scalars['Int']>;
  steps: Array<UpdateApprovalsApprovalFlowStepsInput>;
};


export type ApprovalsMutationsUpdateApprovalsApprovalGroupArgs = {
  autoApproved?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
};


export type ApprovalsMutationsUpdateApprovalsRulesConfigurationArgs = {
  approvalFlow?: InputMaybe<UpdateApprovalsRulesConfigurationApprovalFlowInput>;
  approvalFlowId?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  isTemplate: Scalars['Boolean'];
  name: Scalars['String'];
  onRulesFail?: InputMaybe<ApprovalsValueObjectsRulesConfigurationRuleDecisionEnum>;
  onRulesMet?: InputMaybe<ApprovalsValueObjectsRulesConfigurationRuleDecisionEnum>;
  rules: Array<UpdateApprovalsRulesConfigurationRulesInput>;
};


export type ApprovalsMutationsUpdateEmailDetailBlocksApprovalsMaterializedApprovalsFlowArgs = {
  companyId: Scalars['Int'];
  emailDetailBlocks: Array<UpdateEmailDetailBlocksApprovalsMaterializedApprovalsFlowEmailDetailBlocksInput>;
  id: Scalars['Int'];
};


export type ApprovalsMutationsUpdatePositionsApprovalsRulesConfigurationArgs = {
  positions: Array<UpdatePositionsApprovalsRulesConfigurationPositionsInput>;
};


export type ApprovalsMutationsUpdateResourceUrlApprovalsMaterializedApprovalsFlowArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
  resourceUrl: Scalars['String'];
};

export type ApprovalsV2 = {
  __typename?: 'approvalsV2';
  /** @deprecated Please favor `employeeSegmentsStrategiesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  employeeSegmentsStrategies: Array<ApprovalsV2EmployeeSegmentsStrategy>;
  employeeSegmentsStrategiesConnection: ApprovalsV2EmployeeSegmentsStrategyConnection;
};


export type ApprovalsV2EmployeeSegmentsStrategiesArgs = {
  names?: InputMaybe<Array<Scalars['String']>>;
};


export type ApprovalsV2EmployeeSegmentsStrategiesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  names?: InputMaybe<Array<Scalars['String']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

export type ApprovalsV2Mutations = {
  __typename?: 'approvalsV2Mutations';
  bulkApproveApprovalsv2ReviewRequest: BulkApproveApprovalsv2ReviewRequestPayload;
  bulkRejectApprovalsv2ReviewRequest: BulkRejectApprovalsv2ReviewRequestPayload;
  bulkRequestChangesApprovalsv2ReviewRequest: BulkRequestChangesApprovalsv2ReviewRequestPayload;
};


export type ApprovalsV2MutationsBulkApproveApprovalsv2ReviewRequestArgs = {
  companyId: Scalars['Int'];
  reviewRequestIds: Array<Scalars['Int']>;
  reviewerId: Scalars['Int'];
};


export type ApprovalsV2MutationsBulkRejectApprovalsv2ReviewRequestArgs = {
  companyId: Scalars['Int'];
  reason?: InputMaybe<Scalars['String']>;
  reviewRequestIds: Array<Scalars['Int']>;
  reviewerId: Scalars['Int'];
};


export type ApprovalsV2MutationsBulkRequestChangesApprovalsv2ReviewRequestArgs = {
  companyId: Scalars['Int'];
  reason?: InputMaybe<Scalars['String']>;
  reviewRequestIds: Array<Scalars['Int']>;
  reviewerId: Scalars['Int'];
};

export type Ats = {
  __typename?: 'ats';
  _policies: AtsContextlessPolicies;
  answer?: Maybe<AtsAnswer>;
  /** @deprecated Please favor `answersConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  answers: Array<AtsAnswer>;
  answersConnection: AtsAnswerConnection;
  application?: Maybe<AtsApplication>;
  /** @deprecated Please favor `applicationParticipantsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  applicationParticipants: Array<AtsApplicationParticipant>;
  applicationParticipantsConnection: AtsApplicationParticipantConnection;
  applicationPhase?: Maybe<AtsApplicationPhase>;
  /** @deprecated Please favor `applicationPhasesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  applicationPhases: Array<AtsApplicationPhase>;
  applicationPhasesConnection: AtsApplicationPhaseConnection;
  /** @deprecated Please favor `applicationSummariesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  applicationSummaries: Array<AtsApplicationSummary>;
  applicationSummariesConnection: AtsApplicationSummaryConnection;
  /** @deprecated Please favor `applicationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  applications: Array<AtsApplication>;
  applicationsConnection: AtsApplicationConnection;
  /** @deprecated Please favor `applicationsGenderInsightsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  applicationsGenderInsights: Array<AtsApplicationsGenderInsight>;
  applicationsGenderInsightsConnection: AtsApplicationsGenderInsightConnection;
  /** @deprecated Please favor `applicationsSourceInsightsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  applicationsSourceInsights: Array<AtsApplicationsSourceInsight>;
  applicationsSourceInsightsConnection: AtsApplicationsSourceInsightConnection;
  assessment?: Maybe<AtsAssessment>;
  /** @deprecated Please favor `assessmentsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  assessments: Array<AtsAssessment>;
  assessmentsConnection: AtsAssessmentConnection;
  candidate?: Maybe<AtsCandidate>;
  candidateDuplicatesIdentification?: Maybe<AtsCandidateDuplicatesIdentification>;
  /** @deprecated Please favor `candidateDuplicatesIdentificationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  candidateDuplicatesIdentifications: Array<AtsCandidateDuplicatesIdentification>;
  candidateDuplicatesIdentificationsConnection: AtsCandidateDuplicatesIdentificationConnection;
  candidateEmailAction?: Maybe<AtsCandidateEmailAction>;
  /** @deprecated Please favor `candidateEmailActionsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  candidateEmailActions: Array<AtsCandidateEmailAction>;
  candidateEmailActionsConnection: AtsCandidateEmailActionConnection;
  /** @deprecated Please favor `candidateRecommendationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  candidateRecommendations: Array<AtsCandidateRecommendation>;
  candidateRecommendationsConnection: AtsCandidateRecommendationConnection;
  candidateSource?: Maybe<AtsCandidateSource>;
  /** @deprecated Please favor `candidateSourcesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  candidateSources: Array<AtsCandidateSource>;
  candidateSourcesConnection: AtsCandidateSourceConnection;
  /** @deprecated Please favor `candidatesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  candidates: Array<AtsCandidate>;
  candidatesConnection: AtsCandidateConnection;
  /** @deprecated Please favor `companiesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  companies: Array<AtsCompany>;
  companiesConnection: AtsCompanyConnection;
  company?: Maybe<AtsCompany>;
  contractType?: Maybe<AtsContractType>;
  /** @deprecated Please favor `contractTypesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  contractTypes: Array<AtsContractType>;
  contractTypesConnection: AtsContractTypeConnection;
  conversation?: Maybe<AtsConversation>;
  /** @deprecated Please favor `conversationStatusesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  conversationStatuses: Array<AtsConversationStatus>;
  conversationStatusesConnection: AtsConversationStatusConnection;
  /** @deprecated Please favor `conversationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  conversations: Array<AtsConversation>;
  conversationsConnection: AtsConversationConnection;
  cvBulkUpload?: Maybe<AtsCvBulkUpload>;
  /** @deprecated Please favor `cvBulkUploadsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  cvBulkUploads: Array<AtsCvBulkUpload>;
  cvBulkUploadsConnection: AtsCvBulkUploadConnection;
  /** @deprecated Please favor `dataRetentionConfigurationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  dataRetentionConfigurations: Array<AtsDataRetentionConfiguration>;
  dataRetentionConfigurationsConnection: AtsDataRetentionConfigurationConnection;
  evaluationForm?: Maybe<AtsEvaluationForm>;
  /** @deprecated Please favor `evaluationFormsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  evaluationForms: Array<AtsEvaluationForm>;
  evaluationFormsConnection: AtsEvaluationFormConnection;
  /** @deprecated Please favor `favouriteJobPostingsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  favouriteJobPostings: Array<AtsFavouriteJobPosting>;
  favouriteJobPostingsConnection: AtsFavouriteJobPostingConnection;
  feedback?: Maybe<AtsFeedback>;
  /** @deprecated Please favor `feedbacksConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  feedbacks: Array<AtsFeedback>;
  feedbacksConnection: AtsFeedbackConnection;
  /** @deprecated Please favor `filesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  files: Array<AtsFile>;
  filesConnection: AtsFileConnection;
  /** @deprecated Please favor `hiringManagersConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  hiringManagers: Array<AtsHiringManager>;
  hiringManagersConnection: AtsHiringManagerConnection;
  hiringPhase?: Maybe<AtsHiringPhase>;
  /** @deprecated Please favor `hiringPhasesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  hiringPhases: Array<AtsHiringPhase>;
  hiringPhasesConnection: AtsHiringPhaseConnection;
  hiringStage?: Maybe<AtsHiringStage>;
  /** @deprecated Please favor `hiringStageOptionsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  hiringStageOptions: Array<AtsHiringStageOption>;
  hiringStageOptionsConnection: AtsHiringStageOptionConnection;
  /** @deprecated Please favor `hiringStagesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  hiringStages: Array<AtsHiringStage>;
  hiringStagesConnection: AtsHiringStageConnection;
  /** @deprecated Please favor `hiringStagesInsightsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  hiringStagesInsights: Array<AtsHiringStagesInsight>;
  hiringStagesInsightsConnection: AtsHiringStagesInsightConnection;
  integration?: Maybe<AtsIntegration>;
  /** @deprecated Please favor `integrationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  integrations: Array<AtsIntegration>;
  integrationsConnection: AtsIntegrationConnection;
  interview?: Maybe<AtsInterview>;
  interviewAttendee?: Maybe<AtsInterviewAttendee>;
  /** @deprecated Please favor `interviewAttendeesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  interviewAttendees: Array<AtsInterviewAttendee>;
  interviewAttendeesConnection: AtsInterviewAttendeeConnection;
  /** @deprecated Please favor `interviewsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  interviews: Array<AtsInterview>;
  interviewsConnection: AtsInterviewConnection;
  jobPosting?: Maybe<AtsJobPosting>;
  /** @deprecated Please favor `jobPostingsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  jobPostings: Array<AtsJobPosting>;
  jobPostingsConnection: AtsJobPostingConnection;
  /** @deprecated Please favor `jobPostingsInsightsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  jobPostingsInsights: Array<AtsJobPostingsInsight>;
  jobPostingsInsightsConnection: AtsJobPostingsInsightConnection;
  /** @deprecated Please favor `lastUpdatedAtInsightsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  lastUpdatedAtInsights: Array<AtsLastUpdatedAtInsight>;
  lastUpdatedAtInsightsConnection: AtsLastUpdatedAtInsightConnection;
  message?: Maybe<AtsMessage>;
  messageTemplate?: Maybe<AtsMessageTemplate>;
  /** @deprecated Please favor `messageTemplatesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  messageTemplates: Array<AtsMessageTemplate>;
  messageTemplatesConnection: AtsMessageTemplateConnection;
  /** @deprecated Please favor `messagesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  messages: Array<AtsMessage>;
  messagesConnection: AtsMessageConnection;
  offerLetterTemplate?: Maybe<AtsOfferLetterTemplate>;
  /** @deprecated Please favor `offerLetterTemplatesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  offerLetterTemplates: Array<AtsOfferLetterTemplate>;
  offerLetterTemplatesConnection: AtsOfferLetterTemplateConnection;
  /** @deprecated Please favor `offerLettersConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  offerLetters: Array<AtsOfferLetter>;
  offerLettersConnection: AtsOfferLetterConnection;
  openApplicationSetting?: Maybe<AtsOpenApplicationSetting>;
  /** @deprecated Please favor `openApplicationSettingsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  openApplicationSettings: Array<AtsOpenApplicationSetting>;
  openApplicationSettingsConnection: AtsOpenApplicationSettingConnection;
  /** @deprecated Please favor `openPositionsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  openPositions: Array<AtsOpenPosition>;
  openPositionsConnection: AtsOpenPositionConnection;
  /** @deprecated Please favor `openPositionsLocationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  openPositionsLocations: Array<AtsOpenPositionsLocation>;
  openPositionsLocationsConnection: AtsOpenPositionsLocationConnection;
  purchaseRequestJobPosting?: Maybe<AtsPurchaseRequestJobPosting>;
  /** @deprecated Please favor `purchaseRequestJobPostingsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  purchaseRequestJobPostings: Array<AtsPurchaseRequestJobPosting>;
  purchaseRequestJobPostingsConnection: AtsPurchaseRequestJobPostingConnection;
  question?: Maybe<AtsQuestion>;
  questionTemplate?: Maybe<AtsQuestionTemplate>;
  /** @deprecated Please favor `questionTemplatesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  questionTemplates: Array<AtsQuestionTemplate>;
  questionTemplatesConnection: AtsQuestionTemplateConnection;
  /** @deprecated Please favor `questionsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  questions: Array<AtsQuestion>;
  questionsConnection: AtsQuestionConnection;
  referral?: Maybe<AtsReferral>;
  /** @deprecated Please favor `referralsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  referrals: Array<AtsReferral>;
  referralsConnection: AtsReferralConnection;
  rejectionReason?: Maybe<AtsRejectionReason>;
  /** @deprecated Please favor `rejectionReasonsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  rejectionReasons: Array<AtsRejectionReason>;
  rejectionReasonsConnection: AtsRejectionReasonConnection;
  relatedCandidateApplication?: Maybe<AtsRelatedCandidateApplication>;
  /** @deprecated Please favor `relatedCandidateApplicationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  relatedCandidateApplications: Array<AtsRelatedCandidateApplication>;
  relatedCandidateApplicationsConnection: AtsRelatedCandidateApplicationConnection;
  relatedJobPosting?: Maybe<AtsRelatedJobPosting>;
  /** @deprecated Please favor `relatedJobPostingsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  relatedJobPostings: Array<AtsRelatedJobPosting>;
  relatedJobPostingsConnection: AtsRelatedJobPostingConnection;
  requisition?: Maybe<AtsRequisition>;
  /** @deprecated Please favor `requisitionsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  requisitions: Array<AtsRequisition>;
  requisitionsConnection: AtsRequisitionConnection;
  /** @deprecated Please favor `salaryConditionsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  salaryConditions: Array<AtsSalaryCondition>;
  salaryConditionsConnection: AtsSalaryConditionConnection;
  tag?: Maybe<AtsTag>;
  /** @deprecated Please favor `tagsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  tags: Array<AtsTag>;
  tagsConnection: AtsTagConnection;
};


export type AtsAnswerArgs = {
  id: Scalars['Int'];
};


export type AtsAnswersArgs = {
  atsApplicationIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type AtsAnswersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  atsApplicationIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type AtsApplicationArgs = {
  id: Scalars['Int'];
};


export type AtsApplicationParticipantsArgs = {
  atsApplicationIds: Array<Scalars['Int']>;
};


export type AtsApplicationParticipantsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  atsApplicationIds: Array<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type AtsApplicationPhaseArgs = {
  id: Scalars['Int'];
};


export type AtsApplicationPhasesArgs = {
  atsJobPostingId?: InputMaybe<Scalars['Int']>;
  atsJobPostingIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type AtsApplicationPhasesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  atsJobPostingId?: InputMaybe<Scalars['Int']>;
  atsJobPostingIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type AtsApplicationSummariesArgs = {
  atsApplicationIds?: InputMaybe<Array<Scalars['Int']>>;
  translate?: InputMaybe<Scalars['Boolean']>;
};


export type AtsApplicationSummariesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  atsApplicationIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  translate?: InputMaybe<Scalars['Boolean']>;
};


export type AtsApplicationsArgs = {
  afterApplicationId?: InputMaybe<Scalars['Int']>;
  atsAnswers?: InputMaybe<Array<ApplicationsAtsAnswersInput>>;
  atsApplicationPhaseId?: InputMaybe<Scalars['Int']>;
  atsCandidateId?: InputMaybe<Scalars['Int']>;
  atsCandidateIds?: InputMaybe<Array<Scalars['Int']>>;
  atsJobPostingId?: InputMaybe<Scalars['Int']>;
  atsRejectionReasonIds?: InputMaybe<Array<Scalars['Int']>>;
  atsTagsIds?: InputMaybe<Array<Scalars['Int']>>;
  beforeApplicationId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeRatingAverages?: InputMaybe<Scalars['Boolean']>;
  qualified?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};


export type AtsApplicationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  afterApplicationId?: InputMaybe<Scalars['Int']>;
  atsAnswers?: InputMaybe<Array<ApplicationsAtsAnswersInput>>;
  atsApplicationPhaseId?: InputMaybe<Scalars['Int']>;
  atsCandidateId?: InputMaybe<Scalars['Int']>;
  atsCandidateIds?: InputMaybe<Array<Scalars['Int']>>;
  atsJobPostingId?: InputMaybe<Scalars['Int']>;
  atsRejectionReasonIds?: InputMaybe<Array<Scalars['Int']>>;
  atsTagsIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  beforeApplicationId?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<AtsApplicationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeRatingAverages?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  qualified?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type AtsApplicationsGenderInsightsArgs = {
  atsCompanyId: Scalars['Int'];
  atsJobPostingIds?: InputMaybe<Array<Scalars['Int']>>;
  endDateRange: Scalars['String'];
  startDateRange: Scalars['String'];
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type AtsApplicationsGenderInsightsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  atsCompanyId: Scalars['Int'];
  atsJobPostingIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  endDateRange: Scalars['String'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startDateRange: Scalars['String'];
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type AtsApplicationsSourceInsightsArgs = {
  atsCompanyId: Scalars['Int'];
  atsJobPostingIds?: InputMaybe<Array<Scalars['Int']>>;
  endDateRange: Scalars['String'];
  startDateRange: Scalars['String'];
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type AtsApplicationsSourceInsightsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  atsCompanyId: Scalars['Int'];
  atsJobPostingIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  endDateRange: Scalars['String'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startDateRange: Scalars['String'];
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type AtsAssessmentArgs = {
  id: Scalars['Int'];
};


export type AtsAssessmentsArgs = {
  atsApplicationIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type AtsAssessmentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  atsApplicationIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type AtsCandidateArgs = {
  id: Scalars['Int'];
};


export type AtsCandidateDuplicatesIdentificationArgs = {
  id: Scalars['Int'];
};


export type AtsCandidateDuplicatesIdentificationsArgs = {
  candidateMatchedId?: InputMaybe<Scalars['Int']>;
  candidateMatchedIds?: InputMaybe<Array<Scalars['Int']>>;
  candidateSourceId?: InputMaybe<Scalars['Int']>;
  candidateSourceIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  minScore?: InputMaybe<Scalars['Float']>;
};


export type AtsCandidateDuplicatesIdentificationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  candidateMatchedId?: InputMaybe<Scalars['Int']>;
  candidateMatchedIds?: InputMaybe<Array<Scalars['Int']>>;
  candidateSourceId?: InputMaybe<Scalars['Int']>;
  candidateSourceIds?: InputMaybe<Array<Scalars['Int']>>;
  filter?: InputMaybe<AtsCandidateDuplicatesIdentificationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  minScore?: InputMaybe<Scalars['Float']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type AtsCandidateEmailActionArgs = {
  id: Scalars['Int'];
};


export type AtsCandidateEmailActionsArgs = {
  actionType?: InputMaybe<AtsCandidateEmailActionTypesEnum>;
  atsApplicationPhaseIds?: InputMaybe<Array<Scalars['Int']>>;
  atsJobPostingId?: InputMaybe<Scalars['Int']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type AtsCandidateEmailActionsConnectionArgs = {
  actionType?: InputMaybe<AtsCandidateEmailActionTypesEnum>;
  after?: InputMaybe<Scalars['String']>;
  atsApplicationPhaseIds?: InputMaybe<Array<Scalars['Int']>>;
  atsJobPostingId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type AtsCandidateRecommendationsArgs = {
  jobPostingId?: InputMaybe<Scalars['Int']>;
  searchText?: InputMaybe<Scalars['String']>;
};


export type AtsCandidateRecommendationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  jobPostingId?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  searchText?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type AtsCandidateSourceArgs = {
  id: Scalars['Int'];
};


export type AtsCandidateSourcesArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


export type AtsCandidateSourcesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<AtsCandidateSourceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type AtsCandidatesArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  atsTagIds?: InputMaybe<Array<Scalars['Int']>>;
  consent?: InputMaybe<Array<Scalars['String']>>;
  contractType?: InputMaybe<Scalars['String']>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  jobPostingIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  minimumAverageRating?: InputMaybe<Scalars['Float']>;
  rejectionReasonIds?: InputMaybe<Array<Scalars['Int']>>;
  remote?: InputMaybe<Scalars['Boolean']>;
  scheduleType?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Array<Scalars['String']>>;
  sourceIds?: InputMaybe<Array<Scalars['Int']>>;
  talentPool?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type AtsCandidatesConnectionArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  atsTagIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  consent?: InputMaybe<Array<Scalars['String']>>;
  contractType?: InputMaybe<Scalars['String']>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  filter?: InputMaybe<AtsCandidateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  jobPostingIds?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  minimumAverageRating?: InputMaybe<Scalars['Float']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  rejectionReasonIds?: InputMaybe<Array<Scalars['Int']>>;
  remote?: InputMaybe<Scalars['Boolean']>;
  scheduleType?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  source?: InputMaybe<Array<Scalars['String']>>;
  sourceIds?: InputMaybe<Array<Scalars['Int']>>;
  talentPool?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type AtsCompaniesArgs = {
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type AtsCompaniesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type AtsCompanyArgs = {
  id: Scalars['Int'];
};


export type AtsContractTypeArgs = {
  id: Scalars['String'];
};


export type AtsContractTypesArgs = {
  ids?: InputMaybe<Array<AtsContractTypesEnum>>;
};


export type AtsContractTypesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<AtsContractTypesEnum>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type AtsConversationArgs = {
  id: Scalars['Int'];
};


export type AtsConversationStatusesArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  atsConversationId?: InputMaybe<Scalars['Int']>;
  atsConversationIds?: InputMaybe<Array<Scalars['Int']>>;
  id?: InputMaybe<Scalars['Int']>;
};


export type AtsConversationStatusesConnectionArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  atsConversationId?: InputMaybe<Scalars['Int']>;
  atsConversationIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type AtsConversationsArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  atsApplicationIds?: InputMaybe<Array<Scalars['Int']>>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeLastMessage?: Scalars['Boolean'];
  watcher?: InputMaybe<Scalars['Boolean']>;
};


export type AtsConversationsConnectionArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  atsApplicationIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeLastMessage?: Scalars['Boolean'];
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  watcher?: InputMaybe<Scalars['Boolean']>;
};


export type AtsCvBulkUploadArgs = {
  id: Scalars['Int'];
};


export type AtsCvBulkUploadsArgs = {
  atsJobPostingId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  statuses?: InputMaybe<Array<AtsCvBulkUploadStatusesEnum>>;
};


export type AtsCvBulkUploadsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  atsJobPostingId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  statuses?: InputMaybe<Array<AtsCvBulkUploadStatusesEnum>>;
};


export type AtsDataRetentionConfigurationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type AtsEvaluationFormArgs = {
  id: Scalars['Int'];
};


export type AtsEvaluationFormsArgs = {
  atsJobPostingId?: InputMaybe<Scalars['Int']>;
  atsJobPostingIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  template?: InputMaybe<Scalars['Boolean']>;
};


export type AtsEvaluationFormsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  atsJobPostingId?: InputMaybe<Scalars['Int']>;
  atsJobPostingIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  template?: InputMaybe<Scalars['Boolean']>;
};


export type AtsFavouriteJobPostingsArgs = {
  authorId: Scalars['Int'];
};


export type AtsFavouriteJobPostingsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  authorId: Scalars['Int'];
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<AtsFavouriteJobPostingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type AtsFeedbackArgs = {
  id: Scalars['Int'];
};


export type AtsFeedbacksArgs = {
  atsApplicationId?: InputMaybe<Scalars['Int']>;
  atsApplicationIds?: InputMaybe<Array<Scalars['Int']>>;
  atsCandidateId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  publicFeedbacks?: InputMaybe<Scalars['Boolean']>;
};


export type AtsFeedbacksConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  atsApplicationId?: InputMaybe<Scalars['Int']>;
  atsApplicationIds?: InputMaybe<Array<Scalars['Int']>>;
  atsCandidateId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<AtsFeedbackFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  publicFeedbacks?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Sort>;
};


export type AtsFilesArgs = {
  atsApplicationId?: InputMaybe<Scalars['Int']>;
  atsApplicationIds?: InputMaybe<Array<Scalars['Int']>>;
  atsCandidateId?: InputMaybe<Scalars['Int']>;
  atsCandidateIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceId?: InputMaybe<Scalars['Int']>;
  resourceIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceType?: InputMaybe<Scalars['String']>;
};


export type AtsFilesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  atsApplicationId?: InputMaybe<Scalars['Int']>;
  atsApplicationIds?: InputMaybe<Array<Scalars['Int']>>;
  atsCandidateId?: InputMaybe<Scalars['Int']>;
  atsCandidateIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  resourceId?: InputMaybe<Scalars['Int']>;
  resourceIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceType?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type AtsHiringManagersArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  atsJobPostingId?: InputMaybe<Scalars['Int']>;
  atsJobPostingIds?: InputMaybe<Array<Scalars['Int']>>;
  uniqueByAccess?: InputMaybe<Scalars['Boolean']>;
};


export type AtsHiringManagersConnectionArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  atsJobPostingId?: InputMaybe<Scalars['Int']>;
  atsJobPostingIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  uniqueByAccess?: InputMaybe<Scalars['Boolean']>;
};


export type AtsHiringPhaseArgs = {
  id: Scalars['Int'];
};


export type AtsHiringPhasesArgs = {
  atsHiringStageIds?: InputMaybe<Array<Scalars['Int']>>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type AtsHiringPhasesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  atsHiringStageIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type AtsHiringStageArgs = {
  id: Scalars['Int'];
};


export type AtsHiringStageOptionsArgs = {
  name?: InputMaybe<Scalars['String']>;
};


export type AtsHiringStageOptionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type AtsHiringStagesArgs = {
  atsApplicationPhaseId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type AtsHiringStagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  atsApplicationPhaseId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<AtsHiringStageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type AtsHiringStagesInsightsArgs = {
  atsCompanyId: Scalars['Int'];
  atsJobPostingIds?: InputMaybe<Array<Scalars['Int']>>;
  endDateRange: Scalars['String'];
  startDateRange: Scalars['String'];
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type AtsHiringStagesInsightsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  atsCompanyId: Scalars['Int'];
  atsJobPostingIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  endDateRange: Scalars['String'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startDateRange: Scalars['String'];
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type AtsIntegrationArgs = {
  id: Scalars['Int'];
};


export type AtsIntegrationsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  integrationName?: InputMaybe<Scalars['String']>;
};


export type AtsIntegrationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  integrationName?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type AtsInterviewArgs = {
  id: Scalars['Int'];
};


export type AtsInterviewAttendeeArgs = {
  id: Scalars['Int'];
};


export type AtsInterviewAttendeesArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  atsInterviewIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type AtsInterviewAttendeesConnectionArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  atsInterviewIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type AtsInterviewsArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  atsApplicationId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type AtsInterviewsConnectionArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  atsApplicationId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type AtsJobPostingArgs = {
  id: Scalars['Int'];
};


export type AtsJobPostingsArgs = {
  hiringManagerAccessIds?: InputMaybe<Array<Scalars['Int']>>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeActiveJobs?: InputMaybe<Scalars['Boolean']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  locationId?: InputMaybe<Scalars['Int']>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  status?: InputMaybe<AtsJobPostingStatusesEnum>;
  statuses?: InputMaybe<Array<AtsJobPostingStatusesEnum>>;
  teamId?: InputMaybe<Scalars['Int']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  title?: InputMaybe<Scalars['String']>;
};


export type AtsJobPostingsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<AtsJobPostingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  hiringManagerAccessIds?: InputMaybe<Array<Scalars['Int']>>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeActiveJobs?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  locationId?: InputMaybe<Scalars['Int']>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  status?: InputMaybe<AtsJobPostingStatusesEnum>;
  statuses?: InputMaybe<Array<AtsJobPostingStatusesEnum>>;
  teamId?: InputMaybe<Scalars['Int']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  title?: InputMaybe<Scalars['String']>;
};


export type AtsJobPostingsInsightsArgs = {
  atsCompanyId: Scalars['Int'];
  atsJobPostingIds?: InputMaybe<Array<Scalars['Int']>>;
  endDateRange: Scalars['String'];
  startDateRange: Scalars['String'];
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type AtsJobPostingsInsightsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  atsCompanyId: Scalars['Int'];
  atsJobPostingIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  endDateRange: Scalars['String'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startDateRange: Scalars['String'];
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type AtsLastUpdatedAtInsightsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type AtsMessageArgs = {
  id: Scalars['Int'];
};


export type AtsMessageTemplateArgs = {
  id: Scalars['Int'];
};


export type AtsMessageTemplatesArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


export type AtsMessageTemplatesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<AtsMessageTemplateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type AtsMessagesArgs = {
  atsConversationId?: InputMaybe<Scalars['Int']>;
  atsConversationIds?: InputMaybe<Array<Scalars['Int']>>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  lastPerConversation?: Scalars['Boolean'];
};


export type AtsMessagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  atsConversationId?: InputMaybe<Scalars['Int']>;
  atsConversationIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  lastPerConversation?: Scalars['Boolean'];
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type AtsOfferLetterTemplateArgs = {
  id: Scalars['Int'];
};


export type AtsOfferLetterTemplatesArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['Int']>;
  contractTypes?: InputMaybe<Array<AtsContractTypesEnum>>;
  countryCodes?: InputMaybe<Array<RegionFinderCountryEnum>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  languageCodes?: InputMaybe<Array<Scalars['String']>>;
  scheduleTypes?: InputMaybe<Array<AtsJobPostingScheduleTypesEnum>>;
  search?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  workplaceTypes?: InputMaybe<Array<AtsWorkplaceTypesEnum>>;
};


export type AtsOfferLetterTemplatesConnectionArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  contractTypes?: InputMaybe<Array<AtsContractTypesEnum>>;
  countryCodes?: InputMaybe<Array<RegionFinderCountryEnum>>;
  filter?: InputMaybe<AtsOfferLetterTemplateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  languageCodes?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  scheduleTypes?: InputMaybe<Array<AtsJobPostingScheduleTypesEnum>>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  workplaceTypes?: InputMaybe<Array<AtsWorkplaceTypesEnum>>;
};


export type AtsOfferLettersArgs = {
  atsApplicationIds?: InputMaybe<Array<Scalars['Int']>>;
  atsJobPostingId?: InputMaybe<Scalars['Int']>;
};


export type AtsOfferLettersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  atsApplicationIds?: InputMaybe<Array<Scalars['Int']>>;
  atsJobPostingId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type AtsOpenApplicationSettingArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type AtsOpenApplicationSettingsArgs = {
  companyId: Scalars['Int'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type AtsOpenApplicationSettingsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type AtsOpenPositionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type AtsOpenPositionsLocationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type AtsPurchaseRequestJobPostingArgs = {
  id: Scalars['Int'];
};


export type AtsPurchaseRequestJobPostingsArgs = {
  ids: Array<Scalars['Int']>;
};


export type AtsPurchaseRequestJobPostingsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids: Array<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type AtsQuestionArgs = {
  id: Scalars['Int'];
};


export type AtsQuestionTemplateArgs = {
  id: Scalars['Int'];
};


export type AtsQuestionTemplatesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


export type AtsQuestionTemplatesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<AtsQuestionTemplateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type AtsQuestionsArgs = {
  atsJobPostingIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type AtsQuestionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  atsJobPostingIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<AtsQuestionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type AtsReferralArgs = {
  id: Scalars['Int'];
};


export type AtsReferralsArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type AtsReferralsConnectionArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type AtsRejectionReasonArgs = {
  id: Scalars['Int'];
};


export type AtsRejectionReasonsArgs = {
  atsApplicationIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type AtsRejectionReasonsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  atsApplicationIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<AtsRejectionReasonFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type AtsRelatedCandidateApplicationArgs = {
  id: Scalars['Int'];
};


export type AtsRelatedCandidateApplicationsArgs = {
  atsCandidateId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type AtsRelatedCandidateApplicationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  atsCandidateId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type AtsRelatedJobPostingArgs = {
  id: Scalars['Int'];
};


export type AtsRelatedJobPostingsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  status?: InputMaybe<Enum>;
};


export type AtsRelatedJobPostingsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  status?: InputMaybe<Enum>;
};


export type AtsRequisitionArgs = {
  id: Scalars['Int'];
};


export type AtsRequisitionsArgs = {
  atsJobPostingIds?: InputMaybe<Array<Scalars['Int']>>;
  hiringManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  recruiterIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Array<Scalars['String']>>;
  workplaceIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type AtsRequisitionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  atsJobPostingIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<AtsRequisitionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  hiringManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  recruiterIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  status?: InputMaybe<Array<Scalars['String']>>;
  workplaceIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type AtsSalaryConditionsArgs = {
  jobCatalogLevelNodeUuid: Scalars['String'];
  locationId: Scalars['Int'];
};


export type AtsSalaryConditionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  jobCatalogLevelNodeUuid: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  locationId: Scalars['Int'];
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type AtsTagArgs = {
  id: Scalars['Int'];
};


export type AtsTagsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type AtsTagsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

export type AtsMutations = {
  __typename?: 'atsMutations';
  acceptAtsOfferLetter: AcceptAtsOfferLetterPayload;
  addFaviconAtsCompany: AddFaviconAtsCompanyPayload;
  addTagAtsCandidate: AddTagAtsCandidatePayload;
  applyAtsApplication: ApplyAtsApplicationPayload;
  applyAtsCandidate: ApplyAtsCandidatePayload;
  approveAtsRequisition: ApproveAtsRequisitionPayload;
  archiveAtsConversation: ArchiveAtsConversationPayload;
  archiveAtsCvBulkUpload: ArchiveAtsCvBulkUploadPayload;
  bulkCreateAtsFile: BulkCreateAtsFilePayload;
  bulkCreateAtsHiringManager: BulkCreateAtsHiringManagerPayload;
  bulkCreateAtsInterviewAttendee: BulkCreateAtsInterviewAttendeePayload;
  bulkCreateAtsMessage: BulkCreateAtsMessagePayload;
  bulkDeleteAtsCandidate: BulkDeleteAtsCandidatePayload;
  bulkDeleteAtsQuestionTemplate: BulkDeleteAtsQuestionTemplatePayload;
  bulkDisqualifyAtsApplication: BulkDisqualifyAtsApplicationPayload;
  bulkMoveToPhaseAtsApplication: BulkMoveToPhaseAtsApplicationPayload;
  bulkUpdateAtsApplication: BulkUpdateAtsApplicationPayload;
  bulkUpdateAtsQuestion: BulkUpdateAtsQuestionPayload;
  cancelAtsInterview: CancelAtsInterviewPayload;
  cancelAtsMessage: CancelAtsMessagePayload;
  cancelAtsOfferLetter: CancelAtsOfferLetterPayload;
  cancelAtsRequisition: CancelAtsRequisitionPayload;
  changeHiringStageAtsApplicationPhase: ChangeHiringStageAtsApplicationPhasePayload;
  createAtsAnswer: CreateAtsAnswerPayload;
  createAtsApplication: CreateAtsApplicationPayload;
  createAtsApplicationParticipant: CreateAtsApplicationParticipantPayload;
  createAtsApplicationPhase: CreateAtsApplicationPhasePayload;
  createAtsAssessment: CreateAtsAssessmentPayload;
  createAtsCandidate: CreateAtsCandidatePayload;
  createAtsCandidateDuplicatesIdentification: CreateAtsCandidateDuplicatesIdentificationPayload;
  createAtsCandidateEmailAction: CreateAtsCandidateEmailActionPayload;
  createAtsCandidateImport: CreateAtsCandidateImportPayload;
  createAtsCandidateSource: CreateAtsCandidateSourcePayload;
  createAtsCvBulkUpload: CreateAtsCvBulkUploadPayload;
  createAtsEvaluationForm: CreateAtsEvaluationFormPayload;
  createAtsFavouriteJobPosting: CreateAtsFavouriteJobPostingPayload;
  createAtsFeedback: CreateAtsFeedbackPayload;
  createAtsHiringManager: CreateAtsHiringManagerPayload;
  createAtsHiringPhase: CreateAtsHiringPhasePayload;
  createAtsHiringStage: CreateAtsHiringStagePayload;
  createAtsIntegration: CreateAtsIntegrationPayload;
  createAtsInterview: CreateAtsInterviewPayload;
  createAtsJobPosting: CreateAtsJobPostingPayload;
  createAtsMessage: CreateAtsMessagePayload;
  createAtsMessageTemplate: CreateAtsMessageTemplatePayload;
  createAtsOfferLetter: CreateAtsOfferLetterPayload;
  createAtsOfferLetterTemplate: CreateAtsOfferLetterTemplatePayload;
  createAtsOpenApplicationSetting: CreateAtsOpenApplicationSettingPayload;
  createAtsQuestion: CreateAtsQuestionPayload;
  createAtsQuestionTemplate: CreateAtsQuestionTemplatePayload;
  createAtsReferral: CreateAtsReferralPayload;
  createAtsRejectionReason: CreateAtsRejectionReasonPayload;
  createAtsRequisition: CreateAtsRequisitionPayload;
  createAtsTag: CreateAtsTagPayload;
  createAtsVonqClientToken: CreateAtsVonqClientTokenPayload;
  createFromApplicationsAtsApplication: CreateFromApplicationsAtsApplicationPayload;
  createFromCandidatesAtsApplication: CreateFromCandidatesAtsApplicationPayload;
  createFromCandidatesRecommendationsAtsApplication: CreateFromCandidatesRecommendationsAtsApplicationPayload;
  createFromEmployeeAtsApplication: CreateFromEmployeeAtsApplicationPayload;
  createFromEmployeesAtsApplication: CreateFromEmployeesAtsApplicationPayload;
  createFromEmployeesAtsCandidate: CreateFromEmployeesAtsCandidatePayload;
  createFromTemplateAtsQuestion: CreateFromTemplateAtsQuestionPayload;
  declineAtsOfferLetter: DeclineAtsOfferLetterPayload;
  deleteAtsApplication: DeleteAtsApplicationPayload;
  deleteAtsApplicationParticipant: DeleteAtsApplicationParticipantPayload;
  deleteAtsApplicationPhase: DeleteAtsApplicationPhasePayload;
  deleteAtsAssessment: DeleteAtsAssessmentPayload;
  deleteAtsCandidate: DeleteAtsCandidatePayload;
  deleteAtsCandidateDuplicatesIdentification: DeleteAtsCandidateDuplicatesIdentificationPayload;
  deleteAtsCandidateEmailAction: DeleteAtsCandidateEmailActionPayload;
  deleteAtsCandidateSource: DeleteAtsCandidateSourcePayload;
  deleteAtsEvaluationForm: DeleteAtsEvaluationFormPayload;
  deleteAtsFavouriteJobPosting: DeleteAtsFavouriteJobPostingPayload;
  deleteAtsFeedback: DeleteAtsFeedbackPayload;
  deleteAtsFile: DeleteAtsFilePayload;
  deleteAtsHiringPhase: DeleteAtsHiringPhasePayload;
  deleteAtsHiringStage: DeleteAtsHiringStagePayload;
  deleteAtsIntegration: DeleteAtsIntegrationPayload;
  deleteAtsJobPosting: DeleteAtsJobPostingPayload;
  deleteAtsMessageTemplate: DeleteAtsMessageTemplatePayload;
  deleteAtsOfferLetter: DeleteAtsOfferLetterPayload;
  deleteAtsOfferLetterTemplate: DeleteAtsOfferLetterTemplatePayload;
  deleteAtsOpenApplicationSetting: DeleteAtsOpenApplicationSettingPayload;
  deleteAtsQuestion: DeleteAtsQuestionPayload;
  deleteAtsQuestionTemplate: DeleteAtsQuestionTemplatePayload;
  deleteAtsReferral: DeleteAtsReferralPayload;
  deleteAtsRejectionReason: DeleteAtsRejectionReasonPayload;
  deleteAtsRequisition: DeleteAtsRequisitionPayload;
  deleteAtsTag: DeleteAtsTagPayload;
  destroyAtsHiringManager: DestroyAtsHiringManagerPayload;
  duplicateAtsJobPosting: DuplicateAtsJobPostingPayload;
  fetchAtsApplication: FetchAtsApplicationPayload;
  fetchAtsJobPosting: FetchAtsJobPostingPayload;
  generateDraftAtsJobPosting: GenerateDraftAtsJobPostingPayload;
  markAsReadAtsConversation: MarkAsReadAtsConversationPayload;
  markAsUnreadAtsConversation: MarkAsUnreadAtsConversationPayload;
  moveToPhaseAtsApplication: MoveToPhaseAtsApplicationPayload;
  phoneCallAtsCandidate: PhoneCallAtsCandidatePayload;
  previewAtsJobPosting: PreviewAtsJobPostingPayload;
  processAtsUpsell: ProcessAtsUpsellPayload;
  rejectAtsRequisition: RejectAtsRequisitionPayload;
  removeCvAtsApplication: RemoveCvAtsApplicationPayload;
  removeCvAtsCandidate: RemoveCvAtsCandidatePayload;
  removeFaviconAtsCompany: RemoveFaviconAtsCompanyPayload;
  removeTagAtsCandidate: RemoveTagAtsCandidatePayload;
  renewConsentAtsCandidate: RenewConsentAtsCandidatePayload;
  renewConsentDateAtsCandidate: RenewConsentDateAtsCandidatePayload;
  saveAsTemplateAtsEvaluationForm: SaveAsTemplateAtsEvaluationFormPayload;
  swapPositionsAtsHiringStage: SwapPositionsAtsHiringStagePayload;
  toggleCareersPageAtsCompany: ToggleCareersPageAtsCompanyPayload;
  toggleEnabledAtsCandidateEmailAction: ToggleEnabledAtsCandidateEmailActionPayload;
  toggleEnabledAtsOpenApplicationSetting: ToggleEnabledAtsOpenApplicationSettingPayload;
  toggleJobRequisitionsAtsCompany: ToggleJobRequisitionsAtsCompanyPayload;
  updateAtsApplication: UpdateAtsApplicationPayload;
  updateAtsApplicationPhase: UpdateAtsApplicationPhasePayload;
  updateAtsAssessment: UpdateAtsAssessmentPayload;
  updateAtsCandidate: UpdateAtsCandidatePayload;
  updateAtsCandidateDuplicatesIdentification: UpdateAtsCandidateDuplicatesIdentificationPayload;
  updateAtsCandidateEmailAction: UpdateAtsCandidateEmailActionPayload;
  updateAtsCandidateSource: UpdateAtsCandidateSourcePayload;
  updateAtsCompany: UpdateAtsCompanyPayload;
  updateAtsDataRetentionConfiguration: UpdateAtsDataRetentionConfigurationPayload;
  updateAtsEvaluationForm: UpdateAtsEvaluationFormPayload;
  updateAtsFeedback: UpdateAtsFeedbackPayload;
  updateAtsHiringManager: UpdateAtsHiringManagerPayload;
  updateAtsHiringPhase: UpdateAtsHiringPhasePayload;
  updateAtsIntegration: UpdateAtsIntegrationPayload;
  updateAtsInterview: UpdateAtsInterviewPayload;
  updateAtsJobPosting: UpdateAtsJobPostingPayload;
  updateAtsMessageTemplate: UpdateAtsMessageTemplatePayload;
  updateAtsOfferLetter: UpdateAtsOfferLetterPayload;
  updateAtsOfferLetterTemplate: UpdateAtsOfferLetterTemplatePayload;
  updateAtsOpenApplicationSetting: UpdateAtsOpenApplicationSettingPayload;
  updateAtsQuestion: UpdateAtsQuestionPayload;
  updateAtsQuestionTemplate: UpdateAtsQuestionTemplatePayload;
  updateAtsRejectionReason: UpdateAtsRejectionReasonPayload;
  updateAtsRequisition: UpdateAtsRequisitionPayload;
  updateAtsTag: UpdateAtsTagPayload;
  updatePositionsAtsApplicationPhase: UpdatePositionsAtsApplicationPhasePayload;
  updatePositionsAtsHiringPhase: UpdatePositionsAtsHiringPhasePayload;
  updateStatusAtsCvBulkUpload: UpdateStatusAtsCvBulkUploadPayload;
  uploadCvAtsCandidate: UploadCvAtsCandidatePayload;
};


export type AtsMutationsAcceptAtsOfferLetterArgs = {
  createdAt: Scalars['String'];
  declineReason?: InputMaybe<Scalars['String']>;
  recordId?: InputMaybe<Scalars['String']>;
  recordType?: InputMaybe<Scalars['String']>;
  remoteId: Scalars['String'];
  remoteParentId: Scalars['String'];
};


export type AtsMutationsAddFaviconAtsCompanyArgs = {
  favicon: Scalars['File'];
  id: Scalars['Int'];
};


export type AtsMutationsAddTagAtsCandidateArgs = {
  atsCandidateId: Scalars['Int'];
  atsTagId?: InputMaybe<Scalars['Int']>;
  atsTagName?: InputMaybe<Scalars['String']>;
};


export type AtsMutationsApplyAtsApplicationArgs = {
  answers?: InputMaybe<Array<ApplyAtsApplicationAnswersInput>>;
  atsJobPostingId: Scalars['Int'];
  companyId?: InputMaybe<Scalars['Int']>;
  consentToTalentPool?: InputMaybe<Scalars['Boolean']>;
  coverLetter?: InputMaybe<Scalars['String']>;
  cv?: InputMaybe<Scalars['File']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  gender?: InputMaybe<Scalars['String']>;
  integrationsJoinOrderId?: InputMaybe<Scalars['Int']>;
  lastName: Scalars['String'];
  medium?: InputMaybe<Scalars['String']>;
  personalUrl?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  photo?: InputMaybe<Scalars['File']>;
  skipValidations?: InputMaybe<Scalars['Boolean']>;
  source?: InputMaybe<Scalars['String']>;
};


export type AtsMutationsApplyAtsCandidateArgs = {
  companyId: Scalars['Int'];
  consentGivenAt?: InputMaybe<Scalars['String']>;
  consentToTalentPool?: InputMaybe<Scalars['Boolean']>;
  cv?: InputMaybe<Scalars['File']>;
  email?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  gender?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  personalUrl?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  photo?: InputMaybe<Scalars['File']>;
  talentPool?: InputMaybe<Scalars['Boolean']>;
  termsOfService?: InputMaybe<Scalars['Boolean']>;
};


export type AtsMutationsApproveAtsRequisitionArgs = {
  approverId: Scalars['Int'];
  id: Scalars['Int'];
};


export type AtsMutationsArchiveAtsConversationArgs = {
  accessId: Scalars['Int'];
  id: Scalars['Int'];
};


export type AtsMutationsArchiveAtsCvBulkUploadArgs = {
  id: Scalars['Int'];
};


export type AtsMutationsBulkCreateAtsFileArgs = {
  atsApplicationId?: InputMaybe<Scalars['Int']>;
  atsCandidateId?: InputMaybe<Scalars['Int']>;
  authorId?: InputMaybe<Scalars['Int']>;
  authorType?: InputMaybe<AtsFileOptionsTypesAuthorEnum>;
  files: Array<BulkCreateAtsFileFilesInput>;
  resourceId: Scalars['Int'];
  resourceType: AtsFileOptionsTypesResourceEnum;
};


export type AtsMutationsBulkCreateAtsHiringManagerArgs = {
  accessIds: Array<Scalars['Int']>;
  atsJobPostingId: Scalars['Int'];
  hiringRole?: InputMaybe<AtsHiringRolesEnum>;
};


export type AtsMutationsBulkCreateAtsInterviewAttendeeArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  atsInterviewId: Scalars['Int'];
  emails?: InputMaybe<Array<Scalars['String']>>;
};


export type AtsMutationsBulkCreateAtsMessageArgs = {
  atsApplicationIds: Array<Scalars['Int']>;
  attachments: Array<Scalars['File']>;
  content: Scalars['String'];
  delayedUntil?: InputMaybe<Scalars['ISO8601DateTime']>;
  sendAsCorporateEmail: Scalars['Boolean'];
  sentById: Scalars['Int'];
  sentByType: AtsMessageSendersEnum;
  topic?: InputMaybe<Scalars['String']>;
};


export type AtsMutationsBulkDeleteAtsCandidateArgs = {
  ids: Array<Scalars['Int']>;
};


export type AtsMutationsBulkDeleteAtsQuestionTemplateArgs = {
  ids: Array<Scalars['Int']>;
};


export type AtsMutationsBulkDisqualifyAtsApplicationArgs = {
  atsRejectionReasonId: Scalars['Int'];
  authorId?: InputMaybe<Scalars['Int']>;
  authorType?: InputMaybe<AtsApplicationAuthorTypeEnum>;
  disqualifiedMessage?: InputMaybe<Scalars['String']>;
  ids: Array<Scalars['Int']>;
  messageDelayedUntil?: InputMaybe<Scalars['ISO8601DateTime']>;
  notify?: InputMaybe<Scalars['Boolean']>;
  sendAsCorporateEmail?: InputMaybe<Scalars['Boolean']>;
  talentPool?: InputMaybe<Scalars['Boolean']>;
};


export type AtsMutationsBulkMoveToPhaseAtsApplicationArgs = {
  atsApplicationPhaseId: Scalars['Int'];
  authorId?: InputMaybe<Scalars['Int']>;
  ids: Array<Scalars['Int']>;
  skipSmartAction?: InputMaybe<Scalars['Boolean']>;
};


export type AtsMutationsBulkUpdateAtsApplicationArgs = {
  atsApplicationPhaseId?: InputMaybe<Scalars['Int']>;
  authorId?: InputMaybe<Scalars['Int']>;
  authorType?: InputMaybe<AtsApplicationAuthorTypeEnum>;
  ids: Array<Scalars['Int']>;
  talentPool?: InputMaybe<Scalars['Boolean']>;
};


export type AtsMutationsBulkUpdateAtsQuestionArgs = {
  questions: Array<BulkUpdateAtsQuestionQuestionsInput>;
};


export type AtsMutationsCancelAtsInterviewArgs = {
  id: Scalars['Int'];
};


export type AtsMutationsCancelAtsMessageArgs = {
  id: Scalars['Int'];
};


export type AtsMutationsCancelAtsOfferLetterArgs = {
  id: Scalars['Int'];
};


export type AtsMutationsCancelAtsRequisitionArgs = {
  id: Scalars['Int'];
};


export type AtsMutationsChangeHiringStageAtsApplicationPhaseArgs = {
  atsHiringStageId: Scalars['Int'];
  id: Scalars['Int'];
};


export type AtsMutationsCreateAtsAnswerArgs = {
  atsApplicationId: Scalars['Int'];
  atsQuestionId: Scalars['Int'];
  originalQuestionLabel: Scalars['String'];
  originalQuestionType: AtsQuestionTypeEnum;
  value: Scalars['String'];
};


export type AtsMutationsCreateAtsApplicationArgs = {
  answers?: InputMaybe<Array<CreateAtsApplicationAnswersInput>>;
  atsApplicationPhaseId?: InputMaybe<Scalars['Int']>;
  atsCandidateId?: InputMaybe<Scalars['Int']>;
  atsJobPostingId: Scalars['Int'];
  authorId?: InputMaybe<Scalars['Int']>;
  authorType?: InputMaybe<AtsApplicationAuthorTypeEnum>;
  consentToTalentPool?: InputMaybe<Scalars['Boolean']>;
  coverLetter?: InputMaybe<Scalars['String']>;
  cv?: InputMaybe<Scalars['File']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  medium?: InputMaybe<Scalars['String']>;
  personalUrl?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  photo?: InputMaybe<Scalars['File']>;
  source?: InputMaybe<Scalars['String']>;
  talentPool?: InputMaybe<Scalars['Boolean']>;
};


export type AtsMutationsCreateAtsApplicationParticipantArgs = {
  accessId: Scalars['Int'];
  atsApplicationId: Scalars['Int'];
};


export type AtsMutationsCreateAtsApplicationPhaseArgs = {
  atsHiringStageId?: InputMaybe<Scalars['Int']>;
  atsJobPostingId: Scalars['Int'];
  name: Scalars['String'];
  phaseType?: InputMaybe<AtsApplicationPhaseTypeEnum>;
  position: Scalars['Int'];
};


export type AtsMutationsCreateAtsAssessmentArgs = {
  accessId: Scalars['Int'];
  atsApplicationId: Scalars['Int'];
  gender: Scalars['String'];
};


export type AtsMutationsCreateAtsCandidateArgs = {
  atsCompanyId?: InputMaybe<Scalars['Int']>;
  companyId: Scalars['Int'];
  consentGivenAt?: InputMaybe<Scalars['String']>;
  consentToTalentPool?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  gender?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  medium?: InputMaybe<Scalars['String']>;
  personalUrl?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['Int']>;
  talentPool?: InputMaybe<Scalars['Boolean']>;
};


export type AtsMutationsCreateAtsCandidateDuplicatesIdentificationArgs = {
  candidateMatchedId: Scalars['Int'];
  candidateSourceId: Scalars['Int'];
  companyId: Scalars['Int'];
  score: Scalars['Float'];
};


export type AtsMutationsCreateAtsCandidateEmailActionArgs = {
  actionType: AtsCandidateEmailActionTypesEnum;
  atsApplicationPhaseIds: Array<Scalars['Int']>;
  atsJobPostingId: Scalars['Int'];
  delay?: InputMaybe<AtsCandidateEmailActionDelaysEnum>;
  emailFrom: AtsCandidateEmailActionSenderOptionsEnum;
  enabled: Scalars['Boolean'];
  files?: InputMaybe<Array<Scalars['File']>>;
  messageContent: Scalars['String'];
};


export type AtsMutationsCreateAtsCandidateImportArgs = {
  accessId: Scalars['Int'];
  file: Scalars['File'];
};


export type AtsMutationsCreateAtsCandidateSourceArgs = {
  category: AtsCandidateSourceCategoriesEnum;
  companyId: Scalars['Int'];
  editable?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
};


export type AtsMutationsCreateAtsCvBulkUploadArgs = {
  accessId: Scalars['Int'];
  atsApplicationPhaseId?: InputMaybe<Scalars['Int']>;
  atsCandidateSourceId: Scalars['Int'];
  atsJobPostingId?: InputMaybe<Scalars['Int']>;
  companyId: Scalars['Int'];
  files: Array<Scalars['File']>;
};


export type AtsMutationsCreateAtsEvaluationFormArgs = {
  atsJobPostingId?: InputMaybe<Scalars['Int']>;
  basedOnId?: InputMaybe<Scalars['Int']>;
  companyId: Scalars['Int'];
  name: Scalars['String'];
  questions: Array<AtsEvaluationFormQuestionInput>;
};


export type AtsMutationsCreateAtsFavouriteJobPostingArgs = {
  atsJobPostingId: Scalars['Int'];
  authorId: Scalars['Int'];
};


export type AtsMutationsCreateAtsFeedbackArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  atsApplicationId?: InputMaybe<Scalars['Int']>;
  atsApplicationPhaseId?: InputMaybe<Scalars['Int']>;
  atsCandidateId: Scalars['Int'];
  atsEvaluationFormsId?: InputMaybe<Scalars['Int']>;
  attachments?: InputMaybe<Array<Scalars['File']>>;
  description?: InputMaybe<Scalars['String']>;
  evaluationFormAnswers?: InputMaybe<Array<CreateAtsFeedbackEvaluationFormAnswersInput>>;
  mentionIds?: InputMaybe<Array<Scalars['Int']>>;
  rating?: InputMaybe<Scalars['Int']>;
  visibility?: InputMaybe<AtsFeedbackVisibilityEnum>;
};


export type AtsMutationsCreateAtsHiringManagerArgs = {
  accessId: Scalars['Int'];
  atsJobPostingId: Scalars['Int'];
  hiringRole?: InputMaybe<AtsHiringRolesEnum>;
};


export type AtsMutationsCreateAtsHiringPhaseArgs = {
  atsHiringStageId: Scalars['Int'];
  name: Scalars['String'];
  position: Scalars['Int'];
};


export type AtsMutationsCreateAtsHiringStageArgs = {
  companyId: Scalars['Int'];
  name: AtsHiringStageNamesEnum;
  position: Scalars['Int'];
};


export type AtsMutationsCreateAtsIntegrationArgs = {
  companyId: Scalars['Int'];
  integrationName: Scalars['String'];
  integrationValue: Scalars['String'];
};


export type AtsMutationsCreateAtsInterviewArgs = {
  atsApplicationId: Scalars['Int'];
  attendeeIds: Array<Scalars['Int']>;
  companyId: Scalars['Int'];
  customLocation?: InputMaybe<Scalars['String']>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  endsAt: Scalars['String'];
  interviewType: Scalars['String'];
  messageAttachments?: InputMaybe<Array<Scalars['File']>>;
  messageContent?: InputMaybe<Scalars['String']>;
  organizerAccessId: Scalars['Int'];
  startsAt: Scalars['String'];
  timezone?: InputMaybe<Scalars['String']>;
  workSpaceId?: InputMaybe<Scalars['Int']>;
};


export type AtsMutationsCreateAtsJobPostingArgs = {
  allowInternalApply?: InputMaybe<Scalars['Boolean']>;
  allowReferral?: InputMaybe<Scalars['Boolean']>;
  authorId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  contractType?: InputMaybe<AtsContractTypesEnum>;
  coverLetterRequirement: AtsJobRequirementsOptionsEnum;
  cvRequirement: AtsJobRequirementsOptionsEnum;
  description?: InputMaybe<Scalars['String']>;
  genderRequirement?: InputMaybe<AtsJobRequirementsOptionsEnum>;
  hideSalary?: InputMaybe<Scalars['Boolean']>;
  jobCatalogNodeLevelsUuid?: InputMaybe<Scalars['String']>;
  jobCatalogNodeRolesUuid?: InputMaybe<Scalars['String']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  locationId?: InputMaybe<Scalars['Int']>;
  numberOfVacancies?: InputMaybe<Scalars['Int']>;
  personalUrlRequirement: AtsJobRequirementsOptionsEnum;
  phoneRequirement: AtsJobRequirementsOptionsEnum;
  photoRequirement: AtsJobRequirementsOptionsEnum;
  salaryFormat?: InputMaybe<AtsJobPostingSalaryFormatEnum>;
  salaryFromAmountInCents?: InputMaybe<Scalars['Int']>;
  salaryPeriod?: InputMaybe<AtsJobPostingSalaryPeriodEnum>;
  salaryToAmountInCents?: InputMaybe<Scalars['Int']>;
  scheduleType?: InputMaybe<OnboardingEntitiesWorkScheduleTimeEnum>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  status: AtsJobPostingStatusesEnum;
  teamId?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
  workplaceType?: InputMaybe<AtsWorkplaceTypesEnum>;
};


export type AtsMutationsCreateAtsMessageArgs = {
  atsApplicationId: Scalars['Int'];
  attachments: Array<Scalars['File']>;
  content: Scalars['String'];
  delayedUntil?: InputMaybe<Scalars['ISO8601DateTime']>;
  sendAsCorporateEmail: Scalars['Boolean'];
  sentById: Scalars['Int'];
  sentByType: AtsMessageSendersEnum;
  topic?: InputMaybe<Scalars['String']>;
};


export type AtsMutationsCreateAtsMessageTemplateArgs = {
  authorId: Scalars['Int'];
  body?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  name: Scalars['String'];
  visibility: AtsMessageTemplateVisibilityEnum;
};


export type AtsMutationsCreateAtsOfferLetterArgs = {
  accessId: Scalars['Int'];
  atsApplicationId: Scalars['Int'];
  customMessage: Scalars['String'];
  document: Scalars['File'];
  status?: InputMaybe<Scalars['String']>;
};


export type AtsMutationsCreateAtsOfferLetterTemplateArgs = {
  companyId: Scalars['Int'];
  contractTypes?: InputMaybe<Array<AtsContractTypesEnum>>;
  employeeId: Scalars['Int'];
  file: Scalars['File'];
  legalEntityId?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  tags?: InputMaybe<Array<Scalars['String']>>;
};


export type AtsMutationsCreateAtsOpenApplicationSettingArgs = {
  companyId: Scalars['Int'];
  cvRequirement: AtsJobRequirementsOptionsEnum;
  enabled: Scalars['Boolean'];
  genderRequirement: AtsJobRequirementsOptionsEnum;
  personalUrlRequirement: AtsJobRequirementsOptionsEnum;
  phoneRequirement: AtsJobRequirementsOptionsEnum;
  photoRequirement: AtsJobRequirementsOptionsEnum;
};


export type AtsMutationsCreateAtsQuestionArgs = {
  atsJobPostingId: Scalars['Int'];
  autoDisqualify?: InputMaybe<Scalars['Boolean']>;
  companyId: Scalars['Int'];
  label: Scalars['String'];
  mandatory?: InputMaybe<Scalars['Boolean']>;
  options?: InputMaybe<Array<AtsQuestionOptionInput>>;
  position: Scalars['Int'];
  questionType: AtsQuestionTypeEnum;
};


export type AtsMutationsCreateAtsQuestionTemplateArgs = {
  autoDisqualify?: InputMaybe<Scalars['Boolean']>;
  companyId: Scalars['Int'];
  label: Scalars['String'];
  mandatory?: InputMaybe<Scalars['Boolean']>;
  options?: InputMaybe<Array<AtsQuestionOptionInput>>;
  questionType: AtsQuestionTypeEnum;
};


export type AtsMutationsCreateAtsReferralArgs = {
  atsJobPostingId: Scalars['Int'];
  cv?: InputMaybe<Scalars['File']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  personalUrl?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};


export type AtsMutationsCreateAtsRejectionReasonArgs = {
  companyId: Scalars['Int'];
  decisionMaker: AtsRejectionReasonDecisionMakersEnum;
  reason: Scalars['String'];
};


export type AtsMutationsCreateAtsRequisitionArgs = {
  authorId: Scalars['Int'];
  companyId: Scalars['Int'];
  contractType?: InputMaybe<AtsContractTypesEnum>;
  hiringManagerId: Scalars['Int'];
  jobCatalogLevelUuid?: InputMaybe<Scalars['String']>;
  jobCatalogRoleUuid?: InputMaybe<Scalars['String']>;
  jobPostingTitle: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  numberOfPositions?: InputMaybe<Scalars['Int']>;
  reason: AtsRequisitionReasonsEnum;
  recruiterId: Scalars['Int'];
  salaryFromAmountInCents?: InputMaybe<Scalars['Int']>;
  salaryPeriod?: InputMaybe<AtsJobPostingSalaryPeriodEnum>;
  salaryToAmountInCents?: InputMaybe<Scalars['Int']>;
  scheduleType?: InputMaybe<OnboardingEntitiesWorkScheduleTimeEnum>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  teamId?: InputMaybe<Scalars['Int']>;
  workplaceId: Scalars['Int'];
};


export type AtsMutationsCreateAtsTagArgs = {
  companyId: Scalars['Int'];
  name: Scalars['String'];
};


export type AtsMutationsCreateAtsVonqClientTokenArgs = {
  companyId: Scalars['Int'];
};


export type AtsMutationsCreateFromApplicationsAtsApplicationArgs = {
  atsApplicationPhaseId?: InputMaybe<Scalars['Int']>;
  atsJobPostingId: Scalars['Int'];
  authorId?: InputMaybe<Scalars['Int']>;
  authorType?: InputMaybe<AtsApplicationAuthorTypeEnum>;
  ids: Array<Scalars['Int']>;
};


export type AtsMutationsCreateFromCandidatesAtsApplicationArgs = {
  atsApplicationPhaseId?: InputMaybe<Scalars['Int']>;
  atsCandidateIds: Array<Scalars['Int']>;
  atsJobPostingId: Scalars['Int'];
  authorId?: InputMaybe<Scalars['Int']>;
  authorType?: InputMaybe<AtsApplicationAuthorTypeEnum>;
};


export type AtsMutationsCreateFromCandidatesRecommendationsAtsApplicationArgs = {
  jobPostingId: Scalars['Int'];
};


export type AtsMutationsCreateFromEmployeeAtsApplicationArgs = {
  atsJobPostingId: Scalars['Int'];
  cv: Scalars['File'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  personalUrl?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};


export type AtsMutationsCreateFromEmployeesAtsApplicationArgs = {
  atsApplicationPhaseId: Scalars['Int'];
  atsJobPostingId: Scalars['Int'];
  authorId?: InputMaybe<Scalars['Int']>;
  authorType?: InputMaybe<AtsApplicationAuthorTypeEnum>;
  employeeIds: Array<Scalars['Int']>;
  source?: InputMaybe<Scalars['String']>;
};


export type AtsMutationsCreateFromEmployeesAtsCandidateArgs = {
  companyId: Scalars['Int'];
  employeeIds: Array<Scalars['Int']>;
  talentPool?: InputMaybe<Scalars['Boolean']>;
};


export type AtsMutationsCreateFromTemplateAtsQuestionArgs = {
  atsJobPostingId: Scalars['Int'];
  companyId: Scalars['Int'];
  questionTemplateIds: Array<Scalars['Int']>;
};


export type AtsMutationsDeclineAtsOfferLetterArgs = {
  createdAt: Scalars['String'];
  declineReason?: InputMaybe<Scalars['String']>;
  recordId?: InputMaybe<Scalars['String']>;
  recordType?: InputMaybe<Scalars['String']>;
  remoteId: Scalars['String'];
  remoteParentId: Scalars['String'];
};


export type AtsMutationsDeleteAtsApplicationArgs = {
  id: Scalars['Int'];
};


export type AtsMutationsDeleteAtsApplicationParticipantArgs = {
  accessId: Scalars['Int'];
  atsApplicationId: Scalars['Int'];
};


export type AtsMutationsDeleteAtsApplicationPhaseArgs = {
  alternativeApplicationPhaseId?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
};


export type AtsMutationsDeleteAtsAssessmentArgs = {
  id: Scalars['Int'];
};


export type AtsMutationsDeleteAtsCandidateArgs = {
  id: Scalars['Int'];
};


export type AtsMutationsDeleteAtsCandidateDuplicatesIdentificationArgs = {
  id: Scalars['Int'];
};


export type AtsMutationsDeleteAtsCandidateEmailActionArgs = {
  id: Scalars['Int'];
};


export type AtsMutationsDeleteAtsCandidateSourceArgs = {
  id: Scalars['Int'];
};


export type AtsMutationsDeleteAtsEvaluationFormArgs = {
  id: Scalars['Int'];
};


export type AtsMutationsDeleteAtsFavouriteJobPostingArgs = {
  authorId: Scalars['Int'];
  id: Scalars['Int'];
};


export type AtsMutationsDeleteAtsFeedbackArgs = {
  id: Scalars['Int'];
};


export type AtsMutationsDeleteAtsFileArgs = {
  id: Scalars['Int'];
};


export type AtsMutationsDeleteAtsHiringPhaseArgs = {
  id: Scalars['Int'];
};


export type AtsMutationsDeleteAtsHiringStageArgs = {
  id: Scalars['Int'];
};


export type AtsMutationsDeleteAtsIntegrationArgs = {
  id: Scalars['Int'];
};


export type AtsMutationsDeleteAtsJobPostingArgs = {
  id: Scalars['Int'];
};


export type AtsMutationsDeleteAtsMessageTemplateArgs = {
  id: Scalars['Int'];
};


export type AtsMutationsDeleteAtsOfferLetterArgs = {
  id: Scalars['Int'];
};


export type AtsMutationsDeleteAtsOfferLetterTemplateArgs = {
  id: Scalars['Int'];
};


export type AtsMutationsDeleteAtsOpenApplicationSettingArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type AtsMutationsDeleteAtsQuestionArgs = {
  id: Scalars['Int'];
};


export type AtsMutationsDeleteAtsQuestionTemplateArgs = {
  id: Scalars['Int'];
};


export type AtsMutationsDeleteAtsReferralArgs = {
  id: Scalars['Int'];
};


export type AtsMutationsDeleteAtsRejectionReasonArgs = {
  id: Scalars['Int'];
};


export type AtsMutationsDeleteAtsRequisitionArgs = {
  id: Scalars['Int'];
};


export type AtsMutationsDeleteAtsTagArgs = {
  id: Scalars['Int'];
};


export type AtsMutationsDestroyAtsHiringManagerArgs = {
  id: Scalars['Int'];
};


export type AtsMutationsDuplicateAtsJobPostingArgs = {
  authorId: Scalars['Int'];
  id: Scalars['Int'];
};


export type AtsMutationsFetchAtsApplicationArgs = {
  id: Scalars['Int'];
};


export type AtsMutationsFetchAtsJobPostingArgs = {
  id: Scalars['Int'];
};


export type AtsMutationsGenerateDraftAtsJobPostingArgs = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};


export type AtsMutationsMarkAsReadAtsConversationArgs = {
  accessId: Scalars['Int'];
  id: Scalars['Int'];
};


export type AtsMutationsMarkAsUnreadAtsConversationArgs = {
  accessId: Scalars['Int'];
  id: Scalars['Int'];
};


export type AtsMutationsMoveToPhaseAtsApplicationArgs = {
  atsApplicationPhaseId: Scalars['Int'];
  authorId?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
};


export type AtsMutationsPhoneCallAtsCandidateArgs = {
  accessId: Scalars['Int'];
  atsApplicationId?: InputMaybe<Scalars['Int']>;
  atsCandidateId: Scalars['Int'];
};


export type AtsMutationsPreviewAtsJobPostingArgs = {
  id: Scalars['Int'];
};


export type AtsMutationsProcessAtsUpsellArgs = {
  companyId: Scalars['Int'];
};


export type AtsMutationsRejectAtsRequisitionArgs = {
  approverId: Scalars['Int'];
  id: Scalars['Int'];
  reason?: InputMaybe<Scalars['String']>;
};


export type AtsMutationsRemoveCvAtsApplicationArgs = {
  id: Scalars['Int'];
};


export type AtsMutationsRemoveCvAtsCandidateArgs = {
  atsCandidateId: Scalars['Int'];
};


export type AtsMutationsRemoveFaviconAtsCompanyArgs = {
  id: Scalars['Int'];
};


export type AtsMutationsRemoveTagAtsCandidateArgs = {
  atsCandidateId: Scalars['Int'];
  atsTagId: Scalars['Int'];
};


export type AtsMutationsRenewConsentAtsCandidateArgs = {
  id: Scalars['Int'];
  token: Scalars['String'];
};


export type AtsMutationsRenewConsentDateAtsCandidateArgs = {
  id: Scalars['Int'];
};


export type AtsMutationsSaveAsTemplateAtsEvaluationFormArgs = {
  id: Scalars['Int'];
};


export type AtsMutationsSwapPositionsAtsHiringStageArgs = {
  atsHiringStageIdOne: Scalars['Int'];
  atsHiringStageIdTwo: Scalars['Int'];
};


export type AtsMutationsToggleCareersPageAtsCompanyArgs = {
  id: Scalars['Int'];
  publicCareersPageActive: Scalars['Boolean'];
};


export type AtsMutationsToggleEnabledAtsCandidateEmailActionArgs = {
  enabled: Scalars['Boolean'];
  id: Scalars['Int'];
};


export type AtsMutationsToggleEnabledAtsOpenApplicationSettingArgs = {
  enabled: Scalars['Boolean'];
  id: Scalars['Int'];
};


export type AtsMutationsToggleJobRequisitionsAtsCompanyArgs = {
  enabled: Scalars['Boolean'];
  id: Scalars['Int'];
};


export type AtsMutationsUpdateAtsApplicationArgs = {
  atsApplicationPhaseId?: InputMaybe<Scalars['Int']>;
  atsRejectionReasonId?: InputMaybe<Scalars['Int']>;
  authorId?: InputMaybe<Scalars['Int']>;
  authorType?: InputMaybe<AtsApplicationAuthorTypeEnum>;
  cv?: InputMaybe<Scalars['File']>;
  disqualifiedReason?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  lastName?: InputMaybe<Scalars['String']>;
  personalUrl?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  photo?: InputMaybe<Scalars['File']>;
  qualified?: InputMaybe<Scalars['Boolean']>;
  source?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['Int']>;
};


export type AtsMutationsUpdateAtsApplicationPhaseArgs = {
  atsHiringStageId?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  phaseType?: InputMaybe<AtsApplicationPhaseTypeEnum>;
  position?: InputMaybe<Scalars['Int']>;
};


export type AtsMutationsUpdateAtsAssessmentArgs = {
  id: Scalars['Int'];
  reportUrl?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<AtsAssessmentStatusesEnum>;
};


export type AtsMutationsUpdateAtsCandidateArgs = {
  consentGivenAt?: InputMaybe<Scalars['String']>;
  consentToTalentPool?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  lastName?: InputMaybe<Scalars['String']>;
  personalUrl?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  talentPool?: InputMaybe<Scalars['Boolean']>;
};


export type AtsMutationsUpdateAtsCandidateDuplicatesIdentificationArgs = {
  id: Scalars['Int'];
  score?: InputMaybe<Scalars['Float']>;
};


export type AtsMutationsUpdateAtsCandidateEmailActionArgs = {
  applicationPhaseIds?: InputMaybe<Array<Scalars['Int']>>;
  delay?: InputMaybe<AtsCandidateEmailActionDelaysEnum>;
  deleteFiles?: InputMaybe<Array<Scalars['Int']>>;
  emailFrom?: InputMaybe<AtsCandidateEmailActionSenderOptionsEnum>;
  files?: InputMaybe<Array<Scalars['File']>>;
  id: Scalars['Int'];
  messageContent?: InputMaybe<Scalars['String']>;
};


export type AtsMutationsUpdateAtsCandidateSourceArgs = {
  category?: InputMaybe<AtsCandidateSourceCategoriesEnum>;
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
};


export type AtsMutationsUpdateAtsCompanyArgs = {
  aiMatchingEnabled?: InputMaybe<Scalars['Boolean']>;
  candidateSummaryEnabled?: InputMaybe<Scalars['Boolean']>;
  fieldsAllowedToUnset?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  jobsUrl?: InputMaybe<Scalars['String']>;
  joinDirectApplyEnabled?: InputMaybe<Scalars['Boolean']>;
  joinEnabled?: InputMaybe<Scalars['Boolean']>;
  legalNoticeCustomUrl?: InputMaybe<Scalars['String']>;
  legalNoticeCustomUrlActive?: InputMaybe<Scalars['Boolean']>;
  linkedinId?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  privacyPolicyCustomUrl?: InputMaybe<Scalars['String']>;
  privacyPolicyCustomUrlActive?: InputMaybe<Scalars['Boolean']>;
  privacyPolicyRecipients?: InputMaybe<Scalars['String']>;
  referralsEnabled?: InputMaybe<Scalars['Boolean']>;
  removeLinkedinId?: InputMaybe<Scalars['Boolean']>;
  showFactorialAts?: InputMaybe<Scalars['Boolean']>;
  showFactorialBadge?: InputMaybe<Scalars['Boolean']>;
  showPrivacyPolicy?: InputMaybe<Scalars['Boolean']>;
  showTeamInJobOpenings?: InputMaybe<Scalars['Boolean']>;
  showWorkplaceTypeInJobOpenings?: InputMaybe<Scalars['Boolean']>;
  talentPoolByDefault?: InputMaybe<Scalars['Boolean']>;
};


export type AtsMutationsUpdateAtsDataRetentionConfigurationArgs = {
  atsCompanyId?: InputMaybe<Scalars['Int']>;
  autoDeletionEnabled?: InputMaybe<Scalars['Boolean']>;
  consentLimitEnabled?: InputMaybe<Scalars['Boolean']>;
  consentRenewalEmailBody?: InputMaybe<Scalars['String']>;
  consentRenewalEmailEnabled?: InputMaybe<Scalars['Boolean']>;
  consentRenewalEmailSubject?: InputMaybe<Scalars['String']>;
  defaultRetentionLimit?: InputMaybe<Scalars['Int']>;
  eraseRejectedCandidates?: InputMaybe<Scalars['Boolean']>;
  gracePeriodBeforeDeletion?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  notifyExpiredPermissions?: InputMaybe<Scalars['Boolean']>;
  talentPoolRetentionLimit?: InputMaybe<Scalars['Int']>;
};


export type AtsMutationsUpdateAtsEvaluationFormArgs = {
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  questions?: InputMaybe<Array<AtsEvaluationFormQuestionInput>>;
};


export type AtsMutationsUpdateAtsFeedbackArgs = {
  atsApplicationPhaseId?: InputMaybe<Scalars['Int']>;
  attachments?: InputMaybe<Array<Scalars['File']>>;
  description?: InputMaybe<Scalars['String']>;
  evaluationFormAnswers?: InputMaybe<Array<UpdateAtsFeedbackEvaluationFormAnswersInput>>;
  id?: InputMaybe<Scalars['Int']>;
  rating?: InputMaybe<Scalars['Int']>;
  visibility?: InputMaybe<AtsFeedbackVisibilityEnum>;
};


export type AtsMutationsUpdateAtsHiringManagerArgs = {
  hiringRole: AtsHiringRolesEnum;
  id: Scalars['Int'];
};


export type AtsMutationsUpdateAtsHiringPhaseArgs = {
  atsHiringStageId?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
};


export type AtsMutationsUpdateAtsIntegrationArgs = {
  id: Scalars['Int'];
  integrationValue: Scalars['String'];
};


export type AtsMutationsUpdateAtsInterviewArgs = {
  attendeeIds?: InputMaybe<Array<Scalars['Int']>>;
  customLocation?: InputMaybe<Scalars['String']>;
  endsAt?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  interviewType?: InputMaybe<Scalars['String']>;
  organizerAccessId?: InputMaybe<Scalars['Int']>;
  startsAt?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  workSpaceId?: InputMaybe<Scalars['Int']>;
};


export type AtsMutationsUpdateAtsJobPostingArgs = {
  allowInternalApply?: InputMaybe<Scalars['Boolean']>;
  allowReferral?: InputMaybe<Scalars['Boolean']>;
  contractType?: InputMaybe<AtsContractTypesEnum>;
  coverLetterRequirement?: InputMaybe<AtsJobRequirementsOptionsEnum>;
  cvRequirement?: InputMaybe<AtsJobRequirementsOptionsEnum>;
  description?: InputMaybe<Scalars['String']>;
  fieldsAllowedToUnset: Array<Scalars['String']>;
  genderRequirement?: InputMaybe<AtsJobRequirementsOptionsEnum>;
  hideSalary?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  jobCatalogNodeLevelsUuid?: InputMaybe<Scalars['String']>;
  jobCatalogNodeRolesUuid?: InputMaybe<Scalars['String']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  locationId?: InputMaybe<Scalars['Int']>;
  numberOfVacancies?: InputMaybe<Scalars['Int']>;
  personalUrlRequirement?: InputMaybe<AtsJobRequirementsOptionsEnum>;
  phoneRequirement?: InputMaybe<AtsJobRequirementsOptionsEnum>;
  photoRequirement?: InputMaybe<AtsJobRequirementsOptionsEnum>;
  salaryFormat?: InputMaybe<AtsJobPostingSalaryFormatEnum>;
  salaryFromAmountInCents?: InputMaybe<Scalars['Int']>;
  salaryPeriod?: InputMaybe<AtsJobPostingSalaryPeriodEnum>;
  salaryToAmountInCents?: InputMaybe<Scalars['Int']>;
  scheduleType?: InputMaybe<OnboardingEntitiesWorkScheduleTimeEnum>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  status?: InputMaybe<AtsJobPostingStatusesEnum>;
  teamId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  workplaceType?: InputMaybe<AtsWorkplaceTypesEnum>;
};


export type AtsMutationsUpdateAtsMessageTemplateArgs = {
  body?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  visibility?: InputMaybe<AtsMessageTemplateVisibilityEnum>;
};


export type AtsMutationsUpdateAtsOfferLetterArgs = {
  atsApplicationId?: InputMaybe<Scalars['Int']>;
  customMessage?: InputMaybe<Scalars['String']>;
  declinedReason?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  notificationRead?: InputMaybe<Scalars['Boolean']>;
  remoteDocumentId?: InputMaybe<Scalars['String']>;
  remoteSignatureId?: InputMaybe<Scalars['String']>;
  signatureUrl?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};


export type AtsMutationsUpdateAtsOfferLetterTemplateArgs = {
  contractTypes?: InputMaybe<Array<AtsContractTypesEnum>>;
  id: Scalars['Int'];
  legalEntityId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
};


export type AtsMutationsUpdateAtsOpenApplicationSettingArgs = {
  cvRequirement?: InputMaybe<AtsJobRequirementsOptionsEnum>;
  genderRequirement?: InputMaybe<AtsJobRequirementsOptionsEnum>;
  id: Scalars['Int'];
  personalUrlRequirement?: InputMaybe<AtsJobRequirementsOptionsEnum>;
  phoneRequirement?: InputMaybe<AtsJobRequirementsOptionsEnum>;
  photoRequirement?: InputMaybe<AtsJobRequirementsOptionsEnum>;
};


export type AtsMutationsUpdateAtsQuestionArgs = {
  autoDisqualify?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  label?: InputMaybe<Scalars['String']>;
  mandatory?: InputMaybe<Scalars['Boolean']>;
  options?: InputMaybe<Array<AtsQuestionOptionInput>>;
  position?: InputMaybe<Scalars['Int']>;
};


export type AtsMutationsUpdateAtsQuestionTemplateArgs = {
  autoDisqualify?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  label?: InputMaybe<Scalars['String']>;
  mandatory?: InputMaybe<Scalars['Boolean']>;
  options?: InputMaybe<Array<AtsQuestionOptionInput>>;
};


export type AtsMutationsUpdateAtsRejectionReasonArgs = {
  decisionMaker?: InputMaybe<AtsRejectionReasonDecisionMakersEnum>;
  id: Scalars['Int'];
  reason?: InputMaybe<Scalars['String']>;
};


export type AtsMutationsUpdateAtsRequisitionArgs = {
  id: Scalars['Int'];
  status: AtsRequisitionStatusesEnum;
};


export type AtsMutationsUpdateAtsTagArgs = {
  id: Scalars['Int'];
  name: Scalars['String'];
};


export type AtsMutationsUpdatePositionsAtsApplicationPhaseArgs = {
  newPositions: Array<UpdatePositionsAtsApplicationPhaseNewPositionsInput>;
};


export type AtsMutationsUpdatePositionsAtsHiringPhaseArgs = {
  newPositions: Array<UpdatePositionsAtsHiringPhaseNewPositionsInput>;
};


export type AtsMutationsUpdateStatusAtsCvBulkUploadArgs = {
  id: Scalars['Int'];
  status: AtsCvBulkUploadStatusesEnum;
};


export type AtsMutationsUploadCvAtsCandidateArgs = {
  accessId: Scalars['Int'];
  atsCandidateId: Scalars['Int'];
  file: Scalars['File'];
};

export type Attendance = {
  __typename?: 'attendance';
  _policies: AttendanceContextlessPolicies;
  /** @deprecated Please favor `aggregateShiftLocationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  aggregateShiftLocations: Array<AttendanceAggregateShiftLocation>;
  aggregateShiftLocationsConnection: AttendanceAggregateShiftLocationConnection;
  aggregatedBalance?: Maybe<AttendanceAggregatedBalance>;
  /** @deprecated Please favor `aggregatedBalancesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  aggregatedBalances: Array<AttendanceAggregatedBalance>;
  aggregatedBalancesConnection: AttendanceAggregatedBalanceConnection;
  aggregatedWorkedTime?: Maybe<AttendanceAggregatedWorkedTime>;
  /** @deprecated Please favor `aggregatedWorkedTimesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  aggregatedWorkedTimes: Array<AttendanceAggregatedWorkedTime>;
  aggregatedWorkedTimesConnection: AttendanceAggregatedWorkedTimeConnection;
  /** @deprecated Please favor `automaticBreakRulesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  automaticBreakRules: Array<AttendanceAutomaticBreakRule>;
  automaticBreakRulesConnection: AttendanceAutomaticBreakRuleConnection;
  balance?: Maybe<AttendanceBalance>;
  balanceBreakdown?: Maybe<AttendanceBalanceBreakdown>;
  /** @deprecated Please favor `balanceBreakdownsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  balanceBreakdowns: Array<AttendanceBalanceBreakdown>;
  balanceBreakdownsConnection: AttendanceBalanceBreakdownConnection;
  /** @deprecated Please favor `balanceCarryoversConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  balanceCarryovers: Array<AttendanceBalanceCarryover>;
  balanceCarryoversConnection: AttendanceBalanceCarryoverConnection;
  /** @deprecated Please favor `balancesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  balances: Array<AttendanceBalance>;
  balancesConnection: AttendanceBalanceConnection;
  breakConfiguration?: Maybe<AttendanceBreakConfiguration>;
  /** @deprecated Please favor `breakConfigurationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  breakConfigurations: Array<AttendanceBreakConfiguration>;
  breakConfigurationsConnection: AttendanceBreakConfigurationConnection;
  /** @deprecated Please favor `breakConfigurationsForDatesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  breakConfigurationsForDates: Array<AttendanceBreakConfigurationsForDate>;
  breakConfigurationsForDatesConnection: AttendanceBreakConfigurationsForDateConnection;
  breakDurationRule?: Maybe<AttendanceBreakDurationRule>;
  /** @deprecated Please favor `breakDurationRulesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  breakDurationRules: Array<AttendanceBreakDurationRule>;
  breakDurationRulesConnection: AttendanceBreakDurationRuleConnection;
  breakSetting?: Maybe<AttendanceBreakSetting>;
  /** @deprecated Please favor `breakSettingsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  breakSettings: Array<AttendanceBreakSetting>;
  breakSettingsConnection: AttendanceBreakSettingConnection;
  companySettingsVersion?: Maybe<AttendanceCompanySettingsVersion>;
  /** @deprecated Please favor `companySettingsVersionHistoriesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  companySettingsVersionHistories: Array<AttendanceCompanySettingsVersionHistory>;
  companySettingsVersionHistoriesConnection: AttendanceCompanySettingsVersionHistoryConnection;
  /** @deprecated Please favor `companySettingsVersionsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  companySettingsVersions: Array<AttendanceCompanySettingsVersion>;
  companySettingsVersionsConnection: AttendanceCompanySettingsVersionConnection;
  compensation?: Maybe<AttendanceCompensation>;
  compensationBlock?: Maybe<AttendanceCompensationBlock>;
  /** @deprecated Please favor `compensationBlocksConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  compensationBlocks: Array<AttendanceCompensationBlock>;
  compensationBlocksConnection: AttendanceCompensationBlockConnection;
  /** @deprecated Please favor `compensationPeriodStatusesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  compensationPeriodStatuses: Array<AttendanceCompensationPeriodStatus>;
  compensationPeriodStatusesConnection: AttendanceCompensationPeriodStatusConnection;
  /** @deprecated Please favor `compensationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  compensations: Array<AttendanceCompensation>;
  compensationsConnection: AttendanceCompensationConnection;
  customPeriodEmployee?: Maybe<AttendanceCustomPeriodEmployee>;
  /** @deprecated Please favor `customPeriodEmployeesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  customPeriodEmployees: Array<AttendanceCustomPeriodEmployee>;
  customPeriodEmployeesConnection: AttendanceCustomPeriodEmployeeConnection;
  /** @deprecated Please favor `customTimeRangeCategoriesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  customTimeRangeCategories: Array<AttendanceCustomTimeRangeCategory>;
  customTimeRangeCategoriesConnection: AttendanceCustomTimeRangeCategoryConnection;
  customTimeRangeCategory?: Maybe<AttendanceCustomTimeRangeCategory>;
  /** @deprecated Please favor `customTimeRangesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  customTimeRanges: Array<AttendanceCustomTimeRange>;
  customTimeRangesConnection: AttendanceCustomTimeRangeConnection;
  /** @deprecated Please favor `cyclesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  cycles: Array<AttendanceCycle>;
  cyclesConnection: AttendanceCycleConnection;
  editTimesheetRequest?: Maybe<AttendanceEditTimesheetRequest>;
  /** @deprecated Please favor `editTimesheetRequestsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  editTimesheetRequests: Array<AttendanceEditTimesheetRequest>;
  editTimesheetRequestsConnection: AttendanceEditTimesheetRequestConnection;
  employee?: Maybe<AttendanceEmployee>;
  /** @deprecated Please favor `employeesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  employees: Array<AttendanceEmployee>;
  employeesConnection: AttendanceEmployeeConnection;
  /** @deprecated Please favor `employeesPoliciesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  employeesPolicies: Array<AttendanceEmployeesPolicy>;
  employeesPoliciesConnection: AttendanceEmployeesPolicyConnection;
  employeesPolicy?: Maybe<AttendanceEmployeesPolicy>;
  employeesSetting?: Maybe<AttendanceEmployeesSetting>;
  /** @deprecated Please favor `employeesSettingsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  employeesSettings: Array<AttendanceEmployeesSetting>;
  employeesSettingsConnection: AttendanceEmployeesSettingConnection;
  /** @deprecated Please favor `employeesSettingsEventsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  employeesSettingsEvents: Array<AttendanceEmployeesSettingsEvent>;
  employeesSettingsEventsConnection: AttendanceEmployeesSettingsEventConnection;
  estimatedTime?: Maybe<AttendanceEstimatedTime>;
  /** @deprecated Please favor `estimatedTimesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  estimatedTimes: Array<AttendanceEstimatedTime>;
  estimatedTimesConnection: AttendanceEstimatedTimeConnection;
  extraHoursRange?: Maybe<AttendanceExtraHoursRange>;
  /** @deprecated Please favor `extraHoursRangesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  extraHoursRanges: Array<AttendanceExtraHoursRange>;
  extraHoursRangesConnection: AttendanceExtraHoursRangeConnection;
  /** @deprecated Please favor `googleMapsSignedUrlsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  googleMapsSignedUrls: Array<AttendanceGoogleMapsSignedUrl>;
  googleMapsSignedUrlsConnection: AttendanceGoogleMapsSignedUrlConnection;
  /** @deprecated Please favor `halfDayShiftsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  halfDayShifts: Array<AttendanceHalfDayShift>;
  halfDayShiftsConnection: AttendanceHalfDayShiftConnection;
  /** @deprecated Please favor `incidentAggregateShiftLocationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  incidentAggregateShiftLocations: Array<AttendanceIncidentAggregateShiftLocation>;
  incidentAggregateShiftLocationsConnection: AttendanceIncidentAggregateShiftLocationConnection;
  /** @deprecated Please favor `openShiftsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  openShifts: Array<AttendanceOpenShift>;
  openShiftsConnection: AttendanceOpenShiftConnection;
  overtimePool?: Maybe<AttendanceOvertimePool>;
  /** @deprecated Please favor `overtimePoolsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  overtimePools: Array<AttendanceOvertimePool>;
  overtimePoolsConnection: AttendanceOvertimePoolConnection;
  overtimeRequest?: Maybe<AttendanceOvertimeRequest>;
  /** @deprecated Please favor `overtimeRequestsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  overtimeRequests: Array<AttendanceOvertimeRequest>;
  overtimeRequestsConnection: AttendanceOvertimeRequestConnection;
  /** @deprecated Please favor `payrollCompensationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  payrollCompensations: Array<AttendancePayrollCompensation>;
  payrollCompensationsConnection: AttendancePayrollCompensationConnection;
  /** @deprecated Please favor `periodsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  periods: Array<AttendancePeriod>;
  periodsConnection: AttendancePeriodConnection;
  /** @deprecated Please favor `reviewsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  reviews: Array<AttendanceReview>;
  reviewsConnection: AttendanceReviewConnection;
  reviewsStat?: Maybe<AttendanceReviewsStat>;
  /** @deprecated Please favor `reviewsStatsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  reviewsStats: Array<AttendanceReviewsStat>;
  reviewsStatsConnection: AttendanceReviewsStatConnection;
  shift?: Maybe<AttendanceShift>;
  shiftLocation?: Maybe<AttendanceShiftLocation>;
  /** @deprecated Please favor `shiftLocationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  shiftLocations: Array<AttendanceShiftLocation>;
  shiftLocationsConnection: AttendanceShiftLocationConnection;
  /** @deprecated Please favor `shiftVersionHistoriesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  shiftVersionHistories: Array<AttendanceShiftVersionHistory>;
  shiftVersionHistoriesConnection: AttendanceShiftVersionHistoryConnection;
  /** @deprecated Please favor `shiftsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  shifts: Array<AttendanceShift>;
  shiftsConnection: AttendanceShiftConnection;
  /** @deprecated Please favor `toleranceSettingsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  toleranceSettings: Array<AttendanceToleranceSetting>;
  toleranceSettingsConnection: AttendanceToleranceSettingConnection;
  /** @deprecated Please favor `workedBreaksConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  workedBreaks: Array<AttendanceWorkedBreak>;
  workedBreaksConnection: AttendanceWorkedBreakConnection;
  workedTime?: Maybe<AttendanceWorkedTime>;
  /** @deprecated Please favor `workedTimesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  workedTimes: Array<AttendanceWorkedTime>;
  workedTimesConnection: AttendanceWorkedTimeConnection;
  yearlyTimeInfo?: Maybe<AttendanceYearlyTimeInfo>;
  /** @deprecated Please favor `yearlyTimeInfosConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  yearlyTimeInfos: Array<AttendanceYearlyTimeInfo>;
  yearlyTimeInfosConnection: AttendanceYearlyTimeInfoConnection;
};


export type AttendanceAggregateShiftLocationsArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endAt: Scalars['ISO8601Date'];
  onlyIncidents: Scalars['Boolean'];
  startAt: Scalars['ISO8601Date'];
};


export type AttendanceAggregateShiftLocationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endAt: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyIncidents: Scalars['Boolean'];
  sortOrder?: InputMaybe<Sort>;
  startAt: Scalars['ISO8601Date'];
};


export type AttendanceAggregatedBalanceArgs = {
  endOn: Scalars['ISO8601Date'];
  id: Scalars['String'];
  startOn: Scalars['ISO8601Date'];
};


export type AttendanceAggregatedBalancesArgs = {
  employeeIds?: Array<Scalars['Int']>;
  endOn: Scalars['ISO8601Date'];
  ids?: InputMaybe<Array<Scalars['String']>>;
  startOn: Scalars['ISO8601Date'];
};


export type AttendanceAggregatedBalancesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: Array<Scalars['Int']>;
  endOn: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startOn: Scalars['ISO8601Date'];
};


export type AttendanceAggregatedWorkedTimeArgs = {
  employeeIds: Array<Scalars['Int']>;
  endOn: Scalars['ISO8601Date'];
  id: Scalars['Int'];
  startOn: Scalars['ISO8601Date'];
};


export type AttendanceAggregatedWorkedTimesArgs = {
  employeeIds: Array<Scalars['Int']>;
  endOn: Scalars['ISO8601Date'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  startOn: Scalars['ISO8601Date'];
};


export type AttendanceAggregatedWorkedTimesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds: Array<Scalars['Int']>;
  endOn: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startOn: Scalars['ISO8601Date'];
};


export type AttendanceAutomaticBreakRulesArgs = {
  breakSettingId?: InputMaybe<Scalars['Int']>;
};


export type AttendanceAutomaticBreakRulesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  breakSettingId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type AttendanceBalanceArgs = {
  employeeIds: Array<Scalars['Int']>;
  endOn: Scalars['ISO8601Date'];
  id: Scalars['String'];
  startOn: Scalars['ISO8601Date'];
};


export type AttendanceBalanceBreakdownArgs = {
  date: Scalars['ISO8601Date'];
  employeeIds: Array<Scalars['Int']>;
  id: Scalars['Int'];
};


export type AttendanceBalanceBreakdownsArgs = {
  date: Scalars['ISO8601Date'];
  employeeIds: Array<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type AttendanceBalanceBreakdownsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  date: Scalars['ISO8601Date'];
  employeeIds: Array<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type AttendanceBalanceCarryoversArgs = {
  attendanceEmployeesSettingId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};


export type AttendanceBalanceCarryoversConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  attendanceEmployeesSettingId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type AttendanceBalancesArgs = {
  disableAccumulation?: Scalars['Boolean'];
  employeeIds: Array<Scalars['Int']>;
  endOn: Scalars['ISO8601Date'];
  ids?: InputMaybe<Array<Scalars['String']>>;
  startOn: Scalars['ISO8601Date'];
};


export type AttendanceBalancesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  disableAccumulation?: Scalars['Boolean'];
  employeeIds: Array<Scalars['Int']>;
  endOn: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startOn: Scalars['ISO8601Date'];
};


export type AttendanceBreakConfigurationArgs = {
  id: Scalars['Int'];
};


export type AttendanceBreakConfigurationsArgs = {
  attendanceEmployeesSettingId?: InputMaybe<Scalars['Int']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  timeSettingsBreakConfigurationIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type AttendanceBreakConfigurationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  attendanceEmployeesSettingId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  timeSettingsBreakConfigurationIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type AttendanceBreakConfigurationsForDatesArgs = {
  attendanceEmployeesPolicyId: Scalars['Int'];
  endAt: Scalars['ISO8601Date'];
  startAt: Scalars['ISO8601Date'];
};


export type AttendanceBreakConfigurationsForDatesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  attendanceEmployeesPolicyId: Scalars['Int'];
  before?: InputMaybe<Scalars['String']>;
  endAt: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startAt: Scalars['ISO8601Date'];
};


export type AttendanceBreakDurationRuleArgs = {
  id: Scalars['Int'];
};


export type AttendanceBreakDurationRulesArgs = {
  attendanceBreakSettingIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type AttendanceBreakDurationRulesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  attendanceBreakSettingIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type AttendanceBreakSettingArgs = {
  id: Scalars['Int'];
};


export type AttendanceBreakSettingsArgs = {
  attendanceEmployeesSettingIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type AttendanceBreakSettingsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  attendanceEmployeesSettingIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type AttendanceCompanySettingsVersionArgs = {
  id: Scalars['Int'];
};


export type AttendanceCompanySettingsVersionHistoriesArgs = {
  companyId: Scalars['Int'];
  endOn: Scalars['ISO8601Date'];
  startOn: Scalars['ISO8601Date'];
};


export type AttendanceCompanySettingsVersionHistoriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  endOn: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startOn: Scalars['ISO8601Date'];
};


export type AttendanceCompanySettingsVersionsArgs = {
  date?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type AttendanceCompanySettingsVersionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['ISO8601Date']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type AttendanceCompensationArgs = {
  id: Scalars['Int'];
};


export type AttendanceCompensationBlockArgs = {
  endOn: Scalars['ISO8601Date'];
  id: Scalars['String'];
  startOn: Scalars['ISO8601Date'];
};


export type AttendanceCompensationBlocksArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endOn: Scalars['ISO8601Date'];
  ids?: InputMaybe<Array<Scalars['String']>>;
  startOn: Scalars['ISO8601Date'];
};


export type AttendanceCompensationBlocksConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endOn: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startOn: Scalars['ISO8601Date'];
};


export type AttendanceCompensationPeriodStatusesArgs = {
  employeeIds: Array<Scalars['Int']>;
  endDate: Scalars['ISO8601Date'];
  startDate: Scalars['ISO8601Date'];
};


export type AttendanceCompensationPeriodStatusesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds: Array<Scalars['Int']>;
  endDate: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startDate: Scalars['ISO8601Date'];
};


export type AttendanceCompensationsArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endOn?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  startOn?: InputMaybe<Scalars['ISO8601Date']>;
};


export type AttendanceCompensationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endOn?: InputMaybe<Scalars['ISO8601Date']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startOn?: InputMaybe<Scalars['ISO8601Date']>;
};


export type AttendanceCustomPeriodEmployeeArgs = {
  companyId: Scalars['Int'];
  endOn: Scalars['ISO8601Date'];
  id: Scalars['Int'];
  startOn: Scalars['ISO8601Date'];
};


export type AttendanceCustomPeriodEmployeesArgs = {
  companyId: Scalars['Int'];
  endOn: Scalars['ISO8601Date'];
  hasWorkedLessThanPlanned?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeLocations?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyNonAttendable?: Scalars['Boolean'];
  search?: InputMaybe<Scalars['String']>;
  startOn: Scalars['ISO8601Date'];
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  timeInsightsInconsistencyTypes?: InputMaybe<Array<TimeInsightsValueObjectsInconsistencyTypeEnum>>;
};


export type AttendanceCustomPeriodEmployeesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  endOn: Scalars['ISO8601Date'];
  filter?: InputMaybe<AttendanceCustomPeriodEmployeeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  hasWorkedLessThanPlanned?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeLocations?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyNonAttendable?: Scalars['Boolean'];
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  startOn: Scalars['ISO8601Date'];
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  timeInsightsInconsistencyTypes?: InputMaybe<Array<TimeInsightsValueObjectsInconsistencyTypeEnum>>;
};


export type AttendanceCustomTimeRangeCategoriesArgs = {
  attendanceEmployeesSettingId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type AttendanceCustomTimeRangeCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  attendanceEmployeesSettingId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type AttendanceCustomTimeRangeCategoryArgs = {
  id: Scalars['Int'];
};


export type AttendanceCustomTimeRangesArgs = {
  attendanceEmployeesSettingId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  timeSettingsCompanyId?: InputMaybe<Scalars['Int']>;
};


export type AttendanceCustomTimeRangesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  attendanceEmployeesSettingId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  timeSettingsCompanyId?: InputMaybe<Scalars['Int']>;
};


export type AttendanceCyclesArgs = {
  employeeIds: Array<Scalars['Int']>;
  endOn: Scalars['ISO8601Date'];
  startOn: Scalars['ISO8601Date'];
};


export type AttendanceCyclesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds: Array<Scalars['Int']>;
  endOn: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startOn: Scalars['ISO8601Date'];
};


export type AttendanceEditTimesheetRequestArgs = {
  id: Scalars['Int'];
};


export type AttendanceEditTimesheetRequestsArgs = {
  attendanceShiftIds?: InputMaybe<Array<Scalars['Int']>>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  date?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endOn?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  pending?: InputMaybe<Scalars['Boolean']>;
  shiftId?: InputMaybe<Scalars['Int']>;
  startOn?: InputMaybe<Scalars['ISO8601Date']>;
};


export type AttendanceEditTimesheetRequestsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  attendanceShiftIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  date?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endOn?: InputMaybe<Scalars['ISO8601Date']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  shiftId?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startOn?: InputMaybe<Scalars['ISO8601Date']>;
};


export type AttendanceEmployeeArgs = {
  id: Scalars['Int'];
};


export type AttendanceEmployeesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type AttendanceEmployeesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type AttendanceEmployeesPoliciesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type AttendanceEmployeesPoliciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<AttendanceEmployeesPolicyFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type AttendanceEmployeesPolicyArgs = {
  id: Scalars['Int'];
};


export type AttendanceEmployeesSettingArgs = {
  id: Scalars['Int'];
};


export type AttendanceEmployeesSettingsArgs = {
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  customTimeRangeCategoryIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  employeesPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  endOn?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  ignoreDependencies?: InputMaybe<Scalars['Boolean']>;
  ignoreOvertimePools?: Scalars['Boolean'];
  includesEmployeeIds?: Scalars['Boolean'];
  startOn?: InputMaybe<Scalars['ISO8601Date']>;
};


export type AttendanceEmployeesSettingsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  customTimeRangeCategoryIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  employeesPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  endOn?: InputMaybe<Scalars['ISO8601Date']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  ignoreDependencies?: InputMaybe<Scalars['Boolean']>;
  ignoreOvertimePools?: Scalars['Boolean'];
  includesEmployeeIds?: Scalars['Boolean'];
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startOn?: InputMaybe<Scalars['ISO8601Date']>;
};


export type AttendanceEmployeesSettingsEventsArgs = {
  employeesSettingIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type AttendanceEmployeesSettingsEventsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeesSettingIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type AttendanceEstimatedTimeArgs = {
  employeeIds: Array<Scalars['Int']>;
  endOn: Scalars['ISO8601Date'];
  id: Scalars['Int'];
  startOn: Scalars['ISO8601Date'];
};


export type AttendanceEstimatedTimesArgs = {
  employeeIds: Array<Scalars['Int']>;
  endOn: Scalars['ISO8601Date'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeNonAttendableEmployees?: Scalars['Boolean'];
  startOn: Scalars['ISO8601Date'];
};


export type AttendanceEstimatedTimesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds: Array<Scalars['Int']>;
  endOn: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeNonAttendableEmployees?: Scalars['Boolean'];
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startOn: Scalars['ISO8601Date'];
};


export type AttendanceExtraHoursRangeArgs = {
  id: Scalars['Int'];
};


export type AttendanceExtraHoursRangesArgs = {
  attendanceEmployeesSettingId?: InputMaybe<Scalars['Int']>;
  employeeType?: InputMaybe<AttendanceEnumsEmployeeTypeEnum>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type AttendanceExtraHoursRangesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  attendanceEmployeesSettingId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  employeeType?: InputMaybe<AttendanceEnumsEmployeeTypeEnum>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type AttendanceGoogleMapsSignedUrlsArgs = {
  rawUrl: Scalars['String'];
};


export type AttendanceGoogleMapsSignedUrlsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  rawUrl: Scalars['String'];
  sortOrder?: InputMaybe<Sort>;
};


export type AttendanceHalfDayShiftsArgs = {
  employeeId: Scalars['Int'];
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  year: Scalars['Int'];
};


export type AttendanceHalfDayShiftsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeId: Scalars['Int'];
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  year: Scalars['Int'];
};


export type AttendanceIncidentAggregateShiftLocationsArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endOn: Scalars['ISO8601Date'];
  startOn: Scalars['ISO8601Date'];
};


export type AttendanceIncidentAggregateShiftLocationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endOn: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startOn: Scalars['ISO8601Date'];
};


export type AttendanceOpenShiftsArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type AttendanceOpenShiftsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type AttendanceOvertimePoolArgs = {
  id: Scalars['Int'];
};


export type AttendanceOvertimePoolsArgs = {
  attendanceEmployeesSettingId?: InputMaybe<Scalars['Int']>;
  currentOn?: InputMaybe<Scalars['ISO8601Date']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  employeesPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type AttendanceOvertimePoolsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  attendanceEmployeesSettingId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  currentOn?: InputMaybe<Scalars['ISO8601Date']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  employeesPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type AttendanceOvertimeRequestArgs = {
  id: Scalars['Int'];
};


export type AttendanceOvertimeRequestsArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endOn?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeApprovalFlow?: Scalars['Boolean'];
  startOn?: InputMaybe<Scalars['ISO8601Date']>;
  status?: InputMaybe<AttendanceEnumsOvertimeRequestStatusEnum>;
};


export type AttendanceOvertimeRequestsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endOn?: InputMaybe<Scalars['ISO8601Date']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeApprovalFlow?: Scalars['Boolean'];
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startOn?: InputMaybe<Scalars['ISO8601Date']>;
  status?: InputMaybe<AttendanceEnumsOvertimeRequestStatusEnum>;
};


export type AttendancePayrollCompensationsArgs = {
  attendanceEmployeesSettingId: Scalars['Int'];
};


export type AttendancePayrollCompensationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  attendanceEmployeesSettingId: Scalars['Int'];
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type AttendancePeriodsArgs = {
  employeeIds: Array<Scalars['Int']>;
  endOn?: InputMaybe<Scalars['ISO8601Date']>;
  id?: InputMaybe<Scalars['Int']>;
  month?: InputMaybe<Scalars['Int']>;
  startOn?: InputMaybe<Scalars['ISO8601Date']>;
  year?: InputMaybe<Scalars['Int']>;
};


export type AttendancePeriodsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds: Array<Scalars['Int']>;
  endOn?: InputMaybe<Scalars['ISO8601Date']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  month?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startOn?: InputMaybe<Scalars['ISO8601Date']>;
  year?: InputMaybe<Scalars['Int']>;
};


export type AttendanceReviewsArgs = {
  employeeIds: Array<Scalars['Int']>;
  endOn?: InputMaybe<Scalars['ISO8601Date']>;
  reviewedAt?: InputMaybe<Scalars['String']>;
  startOn?: InputMaybe<Scalars['ISO8601Date']>;
};


export type AttendanceReviewsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds: Array<Scalars['Int']>;
  endOn?: InputMaybe<Scalars['ISO8601Date']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  reviewedAt?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  startOn?: InputMaybe<Scalars['ISO8601Date']>;
};


export type AttendanceReviewsStatArgs = {
  employeeIds: Array<Scalars['Int']>;
  id: Scalars['Int'];
};


export type AttendanceReviewsStatsArgs = {
  employeeIds: Array<Scalars['Int']>;
  endOn?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  reviewedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  startOn?: InputMaybe<Scalars['ISO8601Date']>;
};


export type AttendanceReviewsStatsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds: Array<Scalars['Int']>;
  endOn?: InputMaybe<Scalars['ISO8601Date']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  reviewedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  sortOrder?: InputMaybe<Sort>;
  startOn?: InputMaybe<Scalars['ISO8601Date']>;
};


export type AttendanceShiftArgs = {
  id: Scalars['Int'];
};


export type AttendanceShiftLocationArgs = {
  id: Scalars['Int'];
};


export type AttendanceShiftLocationsArgs = {
  dateFrom?: InputMaybe<Scalars['ISO8601Date']>;
  dateTo?: InputMaybe<Scalars['ISO8601Date']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  shiftIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type AttendanceShiftLocationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  dateFrom?: InputMaybe<Scalars['ISO8601Date']>;
  dateTo?: InputMaybe<Scalars['ISO8601Date']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  shiftIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
};


export type AttendanceShiftVersionHistoriesArgs = {
  employeeId: Scalars['Int'];
  endOn?: InputMaybe<Scalars['ISO8601Date']>;
  shiftIds?: Array<Scalars['Int']>;
  startOn?: InputMaybe<Scalars['ISO8601Date']>;
};


export type AttendanceShiftVersionHistoriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeId: Scalars['Int'];
  endOn?: InputMaybe<Scalars['ISO8601Date']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  shiftIds?: Array<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startOn?: InputMaybe<Scalars['ISO8601Date']>;
};


export type AttendanceShiftsArgs = {
  breaksWithTimeConfiguration?: InputMaybe<Scalars['Boolean']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endOn?: InputMaybe<Scalars['ISO8601Date']>;
  halfDay?: Scalars['Boolean'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  lastWorkingShift?: InputMaybe<Scalars['Boolean']>;
  latestShift?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortCreatedAtAsc?: Scalars['Boolean'];
  startOn?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAt?: InputMaybe<Scalars['ISO8601Date']>;
  workable?: InputMaybe<Scalars['Boolean']>;
};


export type AttendanceShiftsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  breaksWithTimeConfiguration?: InputMaybe<Scalars['Boolean']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endOn?: InputMaybe<Scalars['ISO8601Date']>;
  first?: InputMaybe<Scalars['Int']>;
  halfDay?: Scalars['Boolean'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  lastWorkingShift?: InputMaybe<Scalars['Boolean']>;
  latestShift?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortCreatedAtAsc?: Scalars['Boolean'];
  sortOrder?: InputMaybe<Sort>;
  startOn?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAt?: InputMaybe<Scalars['ISO8601Date']>;
  workable?: InputMaybe<Scalars['Boolean']>;
};


export type AttendanceToleranceSettingsArgs = {
  attendanceEmployeesSettingId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};


export type AttendanceToleranceSettingsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  attendanceEmployeesSettingId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type AttendanceWorkedBreaksArgs = {
  employeeIds: Array<Scalars['Int']>;
  endOn: Scalars['ISO8601Date'];
  paid?: InputMaybe<Scalars['Boolean']>;
  startOn: Scalars['ISO8601Date'];
};


export type AttendanceWorkedBreaksConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds: Array<Scalars['Int']>;
  endOn: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  paid?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Sort>;
  startOn: Scalars['ISO8601Date'];
};


export type AttendanceWorkedTimeArgs = {
  id: Scalars['String'];
};


export type AttendanceWorkedTimesArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endOn?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  includeNonAttendableEmployees?: Scalars['Boolean'];
  includeTimeRangeCategory?: Scalars['Boolean'];
  startOn?: InputMaybe<Scalars['ISO8601Date']>;
};


export type AttendanceWorkedTimesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endOn?: InputMaybe<Scalars['ISO8601Date']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  includeNonAttendableEmployees?: Scalars['Boolean'];
  includeTimeRangeCategory?: Scalars['Boolean'];
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startOn?: InputMaybe<Scalars['ISO8601Date']>;
};


export type AttendanceYearlyTimeInfoArgs = {
  employeeIds: Array<Scalars['Int']>;
  id: Scalars['String'];
  referenceDate: Scalars['ISO8601Date'];
};


export type AttendanceYearlyTimeInfosArgs = {
  employeeIds: Array<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  referenceDate: Scalars['ISO8601Date'];
};


export type AttendanceYearlyTimeInfosConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds: Array<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  referenceDate: Scalars['ISO8601Date'];
  sortOrder?: InputMaybe<Sort>;
};

export type AttendanceMutations = {
  __typename?: 'attendanceMutations';
  addEmployeesAttendanceEmployeesPolicy: AddEmployeesAttendanceEmployeesPolicyPayload;
  approveAttendanceOvertimeRequest: ApproveAttendanceOvertimeRequestPayload;
  autofillAttendanceShift: AutofillAttendanceShiftPayload;
  breakEndAttendanceBreakShift: BreakEndAttendanceBreakShiftPayload;
  breakEndAttendanceShift: BreakEndAttendanceShiftPayload;
  breakStartAttendanceBreakShift: BreakStartAttendanceBreakShiftPayload;
  breakStartAttendanceShift: BreakStartAttendanceShiftPayload;
  bulkCreateAttendanceCompensationBlock: BulkCreateAttendanceCompensationBlockPayload;
  bulkCreateAttendanceCustomTimeRange: BulkCreateAttendanceCustomTimeRangePayload;
  bulkCreateAttendanceReview: BulkCreateAttendanceReviewPayload;
  bulkCreateAttendanceShift: BulkCreateAttendanceShiftPayload;
  bulkCreatePayrollSupplementAttendanceManualCompensation: BulkCreatePayrollSupplementAttendanceManualCompensationPayload;
  bulkCreateTimeBlockSupplementAttendanceManualCompensation: BulkCreateTimeBlockSupplementAttendanceManualCompensationPayload;
  bulkDeleteAttendanceCustomTimeRange: BulkDeleteAttendanceCustomTimeRangePayload;
  bulkDeletePayrollSupplementAttendanceManualCompensation: BulkDeletePayrollSupplementAttendanceManualCompensationPayload;
  bulkDestroyAttendanceReview: BulkDestroyAttendanceReviewPayload;
  bulkDestroyAttendanceShift: BulkDestroyAttendanceShiftPayload;
  bulkUpdateAttendanceCustomTimeRange: BulkUpdateAttendanceCustomTimeRangePayload;
  bulkUpdateAttendanceOvertimePool: BulkUpdateAttendanceOvertimePoolPayload;
  clockInAttendanceClockInOut: ClockInAttendanceClockInOutPayload;
  clockInAttendanceShift: ClockInAttendanceShiftPayload;
  clockOutAttendanceClockInOut: ClockOutAttendanceClockInOutPayload;
  clockOutAttendanceShift: ClockOutAttendanceShiftPayload;
  createAttendanceBalanceCarryover: CreateAttendanceBalanceCarryoverPayload;
  createAttendanceBreakConfiguration: CreateAttendanceBreakConfigurationPayload;
  createAttendanceBreakSetting: CreateAttendanceBreakSettingPayload;
  createAttendanceCompanySettingsVersion: CreateAttendanceCompanySettingsVersionPayload;
  createAttendanceCustomTimeRangeCategory: CreateAttendanceCustomTimeRangeCategoryPayload;
  createAttendanceEditTimesheetRequest: CreateAttendanceEditTimesheetRequestPayload;
  createAttendanceEmployeesPolicy: CreateAttendanceEmployeesPolicyPayload;
  createAttendanceExport: CreateAttendanceExportPayload;
  createAttendanceExtraHoursRange: CreateAttendanceExtraHoursRangePayload;
  createAttendanceMessage: CreateAttendanceMessagePayload;
  createAttendanceOvertimeRequest: CreateAttendanceOvertimeRequestPayload;
  createAttendanceShift: CreateAttendanceShiftPayload;
  createAttendanceToleranceSetting: CreateAttendanceToleranceSettingPayload;
  createVersionAttendanceEmployeesSetting: CreateVersionAttendanceEmployeesSettingPayload;
  currentAttendanceCompanySettingsVersion: CurrentAttendanceCompanySettingsVersionPayload;
  deleteAttendanceCompanySettingsVersion: DeleteAttendanceCompanySettingsVersionPayload;
  deleteAttendanceCustomTimeRangeCategory: DeleteAttendanceCustomTimeRangeCategoryPayload;
  deleteAttendanceEditTimesheetRequest: DeleteAttendanceEditTimesheetRequestPayload;
  deleteAttendanceEmployeesPolicy: DeleteAttendanceEmployeesPolicyPayload;
  deleteAttendanceExtraHoursRange: DeleteAttendanceExtraHoursRangePayload;
  deleteAttendanceOvertimeRequest: DeleteAttendanceOvertimeRequestPayload;
  deleteAttendanceShift: DeleteAttendanceShiftPayload;
  forgotClockOutAttendanceClockInOut: ForgotClockOutAttendanceClockInOutPayload;
  forgotClockOutAttendanceShift: ForgotClockOutAttendanceShiftPayload;
  futureAttendanceCompanySettingsVersion: FutureAttendanceCompanySettingsVersionPayload;
  refreshAttendanceAggregatedBalance: RefreshAttendanceAggregatedBalancePayload;
  refreshAttendanceBalance: RefreshAttendanceBalancePayload;
  refreshAttendanceWorkedTime: RefreshAttendanceWorkedTimePayload;
  rejectAttendanceOvertimeRequest: RejectAttendanceOvertimeRequestPayload;
  setAsDefaultAttendanceEmployeesPolicy: SetAsDefaultAttendanceEmployeesPolicyPayload;
  toggleAttendancePayrollCompensation: ToggleAttendancePayrollCompensationPayload;
  toggleClockAttendanceClockInOut: ToggleClockAttendanceClockInOutPayload;
  toggleClockAttendanceShift: ToggleClockAttendanceShiftPayload;
  updateAttendanceBalanceCarryover: UpdateAttendanceBalanceCarryoverPayload;
  updateAttendanceBreakConfiguration: UpdateAttendanceBreakConfigurationPayload;
  updateAttendanceBreakSetting: UpdateAttendanceBreakSettingPayload;
  updateAttendanceCompanySettingsVersion: UpdateAttendanceCompanySettingsVersionPayload;
  updateAttendanceCustomTimeRangeCategory: UpdateAttendanceCustomTimeRangeCategoryPayload;
  updateAttendanceEditTimesheetRequest: UpdateAttendanceEditTimesheetRequestPayload;
  updateAttendanceEmployeesPolicy: UpdateAttendanceEmployeesPolicyPayload;
  updateAttendanceEmployeesSetting: UpdateAttendanceEmployeesSettingPayload;
  updateAttendanceExtraHoursRange: UpdateAttendanceExtraHoursRangePayload;
  updateAttendanceOvertimeRequest: UpdateAttendanceOvertimeRequestPayload;
  updateAttendanceShift: UpdateAttendanceShiftPayload;
  updateAttendanceToleranceSetting: UpdateAttendanceToleranceSettingPayload;
};


export type AttendanceMutationsAddEmployeesAttendanceEmployeesPolicyArgs = {
  employeeIds: Array<Scalars['Int']>;
  policyId: Scalars['Int'];
};


export type AttendanceMutationsApproveAttendanceOvertimeRequestArgs = {
  approverId?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  reason?: InputMaybe<Scalars['String']>;
};


export type AttendanceMutationsAutofillAttendanceShiftArgs = {
  employeeIds: Array<Scalars['Int']>;
  endOn: Scalars['ISO8601Date'];
  source?: InputMaybe<Scalars['String']>;
  startOn: Scalars['ISO8601Date'];
};


export type AttendanceMutationsBreakEndAttendanceBreakShiftArgs = {
  accuracy?: InputMaybe<Scalars['Float']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  latitude?: InputMaybe<Scalars['Float']>;
  locationType?: InputMaybe<AttendanceShiftLocationTypeEnum>;
  longitude?: InputMaybe<Scalars['Float']>;
  now: Scalars['ISO8601DateTime'];
  observations?: InputMaybe<Scalars['String']>;
  precisionGranted?: InputMaybe<Scalars['Boolean']>;
  projectWorkerId?: InputMaybe<Scalars['Int']>;
  source?: InputMaybe<AttendanceEnumsShiftSourceEnum>;
  subprojectId?: InputMaybe<Scalars['Int']>;
  systemCreated: Scalars['Boolean'];
};


export type AttendanceMutationsBreakEndAttendanceShiftArgs = {
  accuracy?: InputMaybe<Scalars['Float']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  latitude?: InputMaybe<Scalars['Float']>;
  locationType?: InputMaybe<AttendanceShiftLocationTypeEnum>;
  longitude?: InputMaybe<Scalars['Float']>;
  now: Scalars['ISO8601DateTime'];
  observations?: InputMaybe<Scalars['String']>;
  precisionGranted?: InputMaybe<Scalars['Boolean']>;
  projectWorkerId?: InputMaybe<Scalars['Int']>;
  source?: InputMaybe<AttendanceEnumsShiftSourceEnum>;
  subprojectId?: InputMaybe<Scalars['Int']>;
  systemCreated: Scalars['Boolean'];
};


export type AttendanceMutationsBreakStartAttendanceBreakShiftArgs = {
  accuracy?: InputMaybe<Scalars['Float']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  now: Scalars['ISO8601DateTime'];
  observations?: InputMaybe<Scalars['String']>;
  precisionGranted?: InputMaybe<Scalars['Boolean']>;
  source?: InputMaybe<AttendanceEnumsShiftSourceEnum>;
  systemCreated: Scalars['Boolean'];
  timeSettingsBreakConfigurationId?: InputMaybe<Scalars['Int']>;
};


export type AttendanceMutationsBreakStartAttendanceShiftArgs = {
  accuracy?: InputMaybe<Scalars['Float']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  now: Scalars['ISO8601DateTime'];
  observations?: InputMaybe<Scalars['String']>;
  precisionGranted?: InputMaybe<Scalars['Boolean']>;
  source?: InputMaybe<AttendanceEnumsShiftSourceEnum>;
  systemCreated: Scalars['Boolean'];
  timeSettingsBreakConfigurationId?: InputMaybe<Scalars['Int']>;
};


export type AttendanceMutationsBulkCreateAttendanceCompensationBlockArgs = {
  blockSelections: Array<BulkCreateAttendanceCompensationBlockBlockSelectionsInput>;
  companyId: Scalars['Int'];
  employeeId: Scalars['Int'];
  endOn: Scalars['ISO8601Date'];
  sourceId: Scalars['Int'];
  sourceType: Scalars['String'];
  startOn: Scalars['ISO8601Date'];
};


export type AttendanceMutationsBulkCreateAttendanceCustomTimeRangeArgs = {
  attendanceEmployeesSettingId: Scalars['Int'];
  customTimeRanges: Array<BulkCreateAttendanceCustomTimeRangeCustomTimeRangesInput>;
};


export type AttendanceMutationsBulkCreateAttendanceReviewArgs = {
  employeeIds: Array<Scalars['Int']>;
  endOn?: InputMaybe<Scalars['ISO8601Date']>;
  reviewedBy?: InputMaybe<Scalars['Int']>;
  startOn?: InputMaybe<Scalars['ISO8601Date']>;
};


export type AttendanceMutationsBulkCreateAttendanceShiftArgs = {
  deviceSourceType?: InputMaybe<AttendanceEnumsShiftSourceEnum>;
  shifts: Array<BulkCreateAttendanceShiftShiftsInput>;
};


export type AttendanceMutationsBulkCreatePayrollSupplementAttendanceManualCompensationArgs = {
  employeeIds: Array<Scalars['Int']>;
  endOn: Scalars['ISO8601Date'];
  period?: InputMaybe<PayrollPolicyPeriodTypesPeriodTypeEnum>;
  startOn: Scalars['ISO8601Date'];
};


export type AttendanceMutationsBulkCreateTimeBlockSupplementAttendanceManualCompensationArgs = {
  compensationBlockIds?: InputMaybe<Array<Scalars['String']>>;
  employeeId: Scalars['Int'];
  endOn: Scalars['ISO8601Date'];
  period?: InputMaybe<PayrollPolicyPeriodTypesPeriodTypeEnum>;
  startOn: Scalars['ISO8601Date'];
  timeBlocks?: InputMaybe<Array<BulkCreateTimeBlockSupplementAttendanceManualCompensationTimeBlocksInput>>;
};


export type AttendanceMutationsBulkDeleteAttendanceCustomTimeRangeArgs = {
  attendanceEmployeesSettingId: Scalars['Int'];
  ids: Array<Scalars['Int']>;
};


export type AttendanceMutationsBulkDeletePayrollSupplementAttendanceManualCompensationArgs = {
  employeeIds: Array<Scalars['Int']>;
  endOn: Scalars['ISO8601Date'];
  period?: InputMaybe<PayrollPolicyPeriodTypesPeriodTypeEnum>;
  startOn: Scalars['ISO8601Date'];
};


export type AttendanceMutationsBulkDestroyAttendanceReviewArgs = {
  employeeIds: Array<Scalars['Int']>;
  endOn: Scalars['ISO8601Date'];
  startOn: Scalars['ISO8601Date'];
};


export type AttendanceMutationsBulkDestroyAttendanceShiftArgs = {
  employeeId: Scalars['Int'];
  endOn: Scalars['ISO8601Date'];
  ids: Array<Scalars['Int']>;
  startOn: Scalars['ISO8601Date'];
};


export type AttendanceMutationsBulkUpdateAttendanceCustomTimeRangeArgs = {
  attendanceEmployeesSettingId: Scalars['Int'];
  customTimeRanges: Array<BulkUpdateAttendanceCustomTimeRangeCustomTimeRangesInput>;
};


export type AttendanceMutationsBulkUpdateAttendanceOvertimePoolArgs = {
  attendanceEmployeesSettingId: Scalars['Int'];
  updateFrequency: AttendanceEnumsOvertimePoolUpdateFrequencyEnum;
};


export type AttendanceMutationsClockInAttendanceClockInOutArgs = {
  accuracy?: InputMaybe<Scalars['Float']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  latitude?: InputMaybe<Scalars['Float']>;
  locationType?: InputMaybe<AttendanceShiftLocationTypeEnum>;
  longitude?: InputMaybe<Scalars['Float']>;
  now: Scalars['ISO8601DateTime'];
  observations?: InputMaybe<Scalars['String']>;
  precisionGranted?: InputMaybe<Scalars['Boolean']>;
  projectWorkerId?: InputMaybe<Scalars['Int']>;
  qrCode?: InputMaybe<Scalars['Int']>;
  referenceDate?: InputMaybe<Scalars['ISO8601Date']>;
  skipQr?: InputMaybe<Scalars['Boolean']>;
  source?: InputMaybe<AttendanceEnumsShiftSourceEnum>;
  subprojectId?: InputMaybe<Scalars['Int']>;
  systemCreated?: InputMaybe<Scalars['Boolean']>;
  timeSettingsBreakConfigurationId?: InputMaybe<Scalars['Int']>;
  workable?: InputMaybe<Scalars['Boolean']>;
  workplaceId?: InputMaybe<Scalars['Int']>;
};


export type AttendanceMutationsClockInAttendanceShiftArgs = {
  accuracy?: InputMaybe<Scalars['Float']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  latitude?: InputMaybe<Scalars['Float']>;
  locationType?: InputMaybe<AttendanceShiftLocationTypeEnum>;
  longitude?: InputMaybe<Scalars['Float']>;
  now: Scalars['ISO8601DateTime'];
  observations?: InputMaybe<Scalars['String']>;
  precisionGranted?: InputMaybe<Scalars['Boolean']>;
  projectWorkerId?: InputMaybe<Scalars['Int']>;
  qrCode?: InputMaybe<Scalars['Int']>;
  referenceDate?: InputMaybe<Scalars['ISO8601Date']>;
  skipQr?: InputMaybe<Scalars['Boolean']>;
  source?: InputMaybe<AttendanceEnumsShiftSourceEnum>;
  subprojectId?: InputMaybe<Scalars['Int']>;
  systemCreated?: InputMaybe<Scalars['Boolean']>;
  timeSettingsBreakConfigurationId?: InputMaybe<Scalars['Int']>;
  workable?: InputMaybe<Scalars['Boolean']>;
  workplaceId?: InputMaybe<Scalars['Int']>;
};


export type AttendanceMutationsClockOutAttendanceClockInOutArgs = {
  accuracy?: InputMaybe<Scalars['Float']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  now: Scalars['ISO8601DateTime'];
  observations?: InputMaybe<Scalars['String']>;
  precisionGranted?: InputMaybe<Scalars['Boolean']>;
  qrCode?: InputMaybe<Scalars['Int']>;
  skipQr?: InputMaybe<Scalars['Boolean']>;
  source?: InputMaybe<AttendanceEnumsShiftSourceEnum>;
  systemCreated?: InputMaybe<Scalars['Boolean']>;
  workable?: InputMaybe<Scalars['Boolean']>;
};


export type AttendanceMutationsClockOutAttendanceShiftArgs = {
  accuracy?: InputMaybe<Scalars['Float']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  now: Scalars['ISO8601DateTime'];
  observations?: InputMaybe<Scalars['String']>;
  precisionGranted?: InputMaybe<Scalars['Boolean']>;
  qrCode?: InputMaybe<Scalars['Int']>;
  skipQr?: InputMaybe<Scalars['Boolean']>;
  source?: InputMaybe<AttendanceEnumsShiftSourceEnum>;
  systemCreated?: InputMaybe<Scalars['Boolean']>;
  workable?: InputMaybe<Scalars['Boolean']>;
};


export type AttendanceMutationsCreateAttendanceBalanceCarryoverArgs = {
  attendanceEmployeesSettingId: Scalars['Int'];
  frequencyNumber?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  resetFrequency?: InputMaybe<Scalars['String']>;
  startReference?: InputMaybe<Scalars['String']>;
};


export type AttendanceMutationsCreateAttendanceBreakConfigurationArgs = {
  attendanceEmployeesSettingId: Scalars['Int'];
  enabled: Scalars['Boolean'];
  timeSettingsBreakConfigurationId: Scalars['Int'];
};


export type AttendanceMutationsCreateAttendanceBreakSettingArgs = {
  attendanceEmployeesSettingId?: InputMaybe<Scalars['Int']>;
  automaticBreakRulesAttributes: Array<CreateAttendanceBreakSettingAutomaticBreakRulesAttributesInput>;
  automaticBreakSource?: InputMaybe<Scalars['String']>;
  automaticBreaks?: InputMaybe<Scalars['Boolean']>;
  baseMinimalDuration?: InputMaybe<Scalars['Int']>;
  breakViolationsHandling?: InputMaybe<AttendanceEnumsBreakViolationsHandlingEnum>;
  durationRulesAttributes: Array<CreateAttendanceBreakSettingDurationRulesAttributesInput>;
  manualBreaks: Scalars['Boolean'];
  restTime?: InputMaybe<Scalars['Boolean']>;
  sendNotification?: InputMaybe<Scalars['Boolean']>;
};


export type AttendanceMutationsCreateAttendanceCompanySettingsVersionArgs = {
  effectiveOn: Scalars['ISO8601Date'];
  overnightShiftsCalculationMethod: AttendanceCompanySettingsVersionCalculationMethodEnum;
};


export type AttendanceMutationsCreateAttendanceCustomTimeRangeCategoryArgs = {
  attendanceEmployeesSettingId: Scalars['Int'];
  equivalentMinutesInCents: Scalars['Int'];
  rawMinutesInCents: Scalars['Int'];
  timeSettingsCustomTimeRangeCategoryId: Scalars['Int'];
};


export type AttendanceMutationsCreateAttendanceEditTimesheetRequestArgs = {
  attendanceShiftId?: InputMaybe<Scalars['Int']>;
  clockIn?: InputMaybe<Scalars['String']>;
  clockOut?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['ISO8601Date']>;
  employeeId: Scalars['Int'];
  locationType?: InputMaybe<AttendanceShiftLocationTypeEnum>;
  observations?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
  referenceDate?: InputMaybe<Scalars['ISO8601Date']>;
  requestType: AttendanceEditTimesheetRequestRequestTypeEnum;
  timeSettingsBreakConfigurationId?: InputMaybe<Scalars['Int']>;
  workable?: InputMaybe<Scalars['Boolean']>;
};


export type AttendanceMutationsCreateAttendanceEmployeesPolicyArgs = {
  default?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  employees?: InputMaybe<Array<Scalars['Int']>>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
};


export type AttendanceMutationsCreateAttendanceExportArgs = {
  employeeIds: Array<Scalars['Int']>;
  endOn: Scalars['ISO8601Date'];
  fileFormat: Scalars['String'];
  leaveTypeIds: Array<Scalars['Int']>;
  locationId?: InputMaybe<Scalars['Int']>;
  startOn: Scalars['ISO8601Date'];
  teamId?: InputMaybe<Scalars['Int']>;
  timeFormat: Scalars['String'];
  timePeriod: Scalars['String'];
  type: Scalars['String'];
};


export type AttendanceMutationsCreateAttendanceExtraHoursRangeArgs = {
  attendanceEmployeesSettingId: Scalars['Int'];
  baseline?: InputMaybe<AttendanceEnumsExtraHoursRangeBaselineEnum>;
  default?: InputMaybe<Scalars['Boolean']>;
  employeeType?: InputMaybe<AttendanceEnumsEmployeeTypeEnum>;
  equivalentMinutesInCents: Scalars['Int'];
  fromMinute: Scalars['Int'];
  poolType: AttendanceEnumsPoolTypeEnum;
  rawMinutesInCents: Scalars['Int'];
  timeSettingsCustomTimeRangeCategoryId: Scalars['Int'];
  toMinute?: InputMaybe<Scalars['Int']>;
  unlimited: Scalars['Boolean'];
};


export type AttendanceMutationsCreateAttendanceMessageArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  message: Scalars['String'];
  sendCopy: Scalars['Boolean'];
};


export type AttendanceMutationsCreateAttendanceOvertimeRequestArgs = {
  authorId: Scalars['Int'];
  date: Scalars['ISO8601Date'];
  description?: InputMaybe<Scalars['String']>;
  employeeId: Scalars['Int'];
  hoursAmount?: InputMaybe<Scalars['Float']>;
};


export type AttendanceMutationsCreateAttendanceShiftArgs = {
  accuracy?: InputMaybe<Scalars['Float']>;
  clockIn?: InputMaybe<Scalars['ISO8601DateTime']>;
  clockOffset?: InputMaybe<Scalars['String']>;
  clockOut?: InputMaybe<Scalars['ISO8601DateTime']>;
  date: Scalars['ISO8601Date'];
  day?: InputMaybe<Scalars['Int']>;
  editTimesheetRequestId?: InputMaybe<Scalars['Int']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  halfDay?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['Float']>;
  locationType?: InputMaybe<AttendanceShiftLocationTypeEnum>;
  longitude?: InputMaybe<Scalars['Float']>;
  observations?: InputMaybe<Scalars['String']>;
  precisionGranted?: InputMaybe<Scalars['Boolean']>;
  referenceDate?: InputMaybe<Scalars['ISO8601Date']>;
  source?: InputMaybe<AttendanceEnumsShiftSourceEnum>;
  timeSettingsBreakConfigurationId?: InputMaybe<Scalars['Int']>;
  workable?: InputMaybe<Scalars['Boolean']>;
};


export type AttendanceMutationsCreateAttendanceToleranceSettingArgs = {
  aboveEstimated?: InputMaybe<Scalars['Int']>;
  attendanceEmployeesSettingId: Scalars['Int'];
  belowEstimated?: InputMaybe<Scalars['Int']>;
  clockInAfter?: InputMaybe<Scalars['Int']>;
  clockInBefore?: InputMaybe<Scalars['Int']>;
  clockInRoundUpEnabled?: InputMaybe<Scalars['Boolean']>;
  clockInRoundingEnabled: Scalars['Boolean'];
  clockOutAfter?: InputMaybe<Scalars['Int']>;
  clockOutBefore?: InputMaybe<Scalars['Int']>;
  clockOutRoundingEnabled: Scalars['Boolean'];
  gridRounding: Scalars['Boolean'];
  gridRoundingBias?: InputMaybe<AttendanceGridRoundingBiasEnum>;
  shiftsToleranceEnabled: Scalars['Boolean'];
  toleranceType: Scalars['String'];
  workedHoursRoundingEnabled: Scalars['Boolean'];
  workedHoursToleranceEnabled: Scalars['Boolean'];
};


export type AttendanceMutationsCreateVersionAttendanceEmployeesSettingArgs = {
  effectiveAt: Scalars['ISO8601Date'];
  id: Scalars['Int'];
};


export type AttendanceMutationsDeleteAttendanceCompanySettingsVersionArgs = {
  id: Scalars['Int'];
};


export type AttendanceMutationsDeleteAttendanceCustomTimeRangeCategoryArgs = {
  id: Scalars['Int'];
};


export type AttendanceMutationsDeleteAttendanceEditTimesheetRequestArgs = {
  id: Scalars['Int'];
};


export type AttendanceMutationsDeleteAttendanceEmployeesPolicyArgs = {
  id: Scalars['Int'];
};


export type AttendanceMutationsDeleteAttendanceExtraHoursRangeArgs = {
  id: Scalars['Int'];
};


export type AttendanceMutationsDeleteAttendanceOvertimeRequestArgs = {
  id: Scalars['Int'];
};


export type AttendanceMutationsDeleteAttendanceShiftArgs = {
  editTimesheetRequestId?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
};


export type AttendanceMutationsForgotClockOutAttendanceClockInOutArgs = {
  accuracy?: InputMaybe<Scalars['Float']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  now: Scalars['ISO8601DateTime'];
  precisionGranted?: InputMaybe<Scalars['Boolean']>;
  qrCode?: InputMaybe<Scalars['Int']>;
  skipQr?: InputMaybe<Scalars['Boolean']>;
  source?: InputMaybe<AttendanceEnumsShiftSourceEnum>;
  systemCreated?: InputMaybe<Scalars['Boolean']>;
};


export type AttendanceMutationsForgotClockOutAttendanceShiftArgs = {
  accuracy?: InputMaybe<Scalars['Float']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  now: Scalars['ISO8601DateTime'];
  precisionGranted?: InputMaybe<Scalars['Boolean']>;
  qrCode?: InputMaybe<Scalars['Int']>;
  skipQr?: InputMaybe<Scalars['Boolean']>;
  source?: InputMaybe<AttendanceEnumsShiftSourceEnum>;
  systemCreated?: InputMaybe<Scalars['Boolean']>;
};


export type AttendanceMutationsRefreshAttendanceAggregatedBalanceArgs = {
  balances: Array<AttendanceAggregatedBalanceInput>;
  employeeId: Scalars['Int'];
};


export type AttendanceMutationsRefreshAttendanceBalanceArgs = {
  balances: Array<AttendanceBalanceInput>;
  employeeId: Scalars['Int'];
};


export type AttendanceMutationsRefreshAttendanceWorkedTimeArgs = {
  dates?: InputMaybe<Array<Scalars['ISO8601Date']>>;
  employeeId?: InputMaybe<Scalars['Int']>;
  id: Scalars['String'];
  workedTimes: Array<AttendanceWorkedTimeInput>;
};


export type AttendanceMutationsRejectAttendanceOvertimeRequestArgs = {
  approverId?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  reason: Scalars['String'];
};


export type AttendanceMutationsSetAsDefaultAttendanceEmployeesPolicyArgs = {
  id: Scalars['Int'];
};


export type AttendanceMutationsToggleAttendancePayrollCompensationArgs = {
  attendanceEmployeesSettingId: Scalars['Int'];
  compensationEnabled: Scalars['Boolean'];
};


export type AttendanceMutationsToggleClockAttendanceClockInOutArgs = {
  clockTime: Scalars['ISO8601DateTime'];
  employeeId: Scalars['Int'];
  locationType?: InputMaybe<AttendanceShiftLocationTypeEnum>;
  observations?: InputMaybe<Scalars['String']>;
  skipQr?: InputMaybe<Scalars['Boolean']>;
  source?: InputMaybe<AttendanceEnumsShiftSourceEnum>;
  timeSettingsBreakConfigurationId?: InputMaybe<Scalars['Int']>;
};


export type AttendanceMutationsToggleClockAttendanceShiftArgs = {
  clockTime: Scalars['ISO8601DateTime'];
  employeeId: Scalars['Int'];
  locationType?: InputMaybe<AttendanceShiftLocationTypeEnum>;
  observations?: InputMaybe<Scalars['String']>;
  skipQr?: InputMaybe<Scalars['Boolean']>;
  source?: InputMaybe<AttendanceEnumsShiftSourceEnum>;
  timeSettingsBreakConfigurationId?: InputMaybe<Scalars['Int']>;
};


export type AttendanceMutationsUpdateAttendanceBalanceCarryoverArgs = {
  attendanceEmployeesSettingId: Scalars['Int'];
  frequencyNumber?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  resetFrequency?: InputMaybe<Scalars['String']>;
  startReference?: InputMaybe<Scalars['String']>;
};


export type AttendanceMutationsUpdateAttendanceBreakConfigurationArgs = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
};


export type AttendanceMutationsUpdateAttendanceBreakSettingArgs = {
  attendanceEmployeesSettingId?: InputMaybe<Scalars['Int']>;
  automaticBreakRulesAttributes: Array<UpdateAttendanceBreakSettingAutomaticBreakRulesAttributesInput>;
  automaticBreakSource: Scalars['String'];
  automaticBreaks?: InputMaybe<Scalars['Boolean']>;
  baseMinimalDuration?: InputMaybe<Scalars['Int']>;
  breakViolationsHandling?: InputMaybe<AttendanceEnumsBreakViolationsHandlingEnum>;
  durationRulesAttributes: Array<UpdateAttendanceBreakSettingDurationRulesAttributesInput>;
  id: Scalars['Int'];
  manualBreaks: Scalars['Boolean'];
  restTime?: InputMaybe<Scalars['Boolean']>;
  sendNotification?: InputMaybe<Scalars['Boolean']>;
};


export type AttendanceMutationsUpdateAttendanceCompanySettingsVersionArgs = {
  effectiveOn: Scalars['ISO8601Date'];
  id: Scalars['Int'];
  overnightShiftsCalculationMethod: AttendanceCompanySettingsVersionCalculationMethodEnum;
};


export type AttendanceMutationsUpdateAttendanceCustomTimeRangeCategoryArgs = {
  attendanceEmployeesSettingId?: InputMaybe<Scalars['Int']>;
  equivalentMinutesInCents?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  rawMinutesInCents?: InputMaybe<Scalars['Int']>;
  timeSettingsCustomTimeRangeCategoryId?: InputMaybe<Scalars['Int']>;
};


export type AttendanceMutationsUpdateAttendanceEditTimesheetRequestArgs = {
  attendanceShiftId?: InputMaybe<Scalars['Int']>;
  clockIn?: InputMaybe<Scalars['String']>;
  clockOut?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['ISO8601Date']>;
  employeeId: Scalars['Int'];
  id: Scalars['Int'];
  locationType?: InputMaybe<AttendanceShiftLocationTypeEnum>;
  observations?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
  referenceDate?: InputMaybe<Scalars['ISO8601Date']>;
  timeSettingsBreakConfigurationId?: InputMaybe<Scalars['Int']>;
};


export type AttendanceMutationsUpdateAttendanceEmployeesPolicyArgs = {
  description?: InputMaybe<Scalars['String']>;
  employees?: InputMaybe<Array<Scalars['Int']>>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
};


export type AttendanceMutationsUpdateAttendanceEmployeesSettingArgs = {
  accuracy?: InputMaybe<Scalars['String']>;
  allowManualAllocation?: InputMaybe<Scalars['Boolean']>;
  autofillTimesheet?: InputMaybe<Scalars['Boolean']>;
  complementaryHoursBaseline?: InputMaybe<Scalars['String']>;
  desktopClockin?: InputMaybe<Scalars['Boolean']>;
  editTimesheetAuthorization?: InputMaybe<Scalars['Boolean']>;
  effectiveAt?: InputMaybe<Scalars['ISO8601Date']>;
  employeeAccessSearchField?: InputMaybe<Scalars['String']>;
  enableBreaks?: InputMaybe<Scalars['Boolean']>;
  enableClockInLocation?: InputMaybe<Scalars['Boolean']>;
  enableComplementaryHours?: InputMaybe<Scalars['Boolean']>;
  extraHoursBaseline?: InputMaybe<Scalars['String']>;
  extraHoursTransferFrequency?: InputMaybe<Scalars['String']>;
  faceRecognition?: InputMaybe<Scalars['Boolean']>;
  forced?: InputMaybe<Scalars['Boolean']>;
  forgotClockOut?: InputMaybe<Scalars['String']>;
  forgotClockOutToleranceMinutes?: InputMaybe<Scalars['Int']>;
  geofencing?: InputMaybe<Scalars['Boolean']>;
  geolocation?: InputMaybe<Scalars['Boolean']>;
  geolocationBlock?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  idClockSharedDevice?: InputMaybe<Scalars['Boolean']>;
  missingClockInAlert?: InputMaybe<Scalars['Boolean']>;
  mobileClockin?: InputMaybe<Scalars['Boolean']>;
  overtimeAuthorization?: InputMaybe<Scalars['Boolean']>;
  qrCodeClockin?: InputMaybe<Scalars['Boolean']>;
  reason?: InputMaybe<Scalars['String']>;
  specialHoursRegularHoursCompensation?: InputMaybe<Scalars['Boolean']>;
};


export type AttendanceMutationsUpdateAttendanceExtraHoursRangeArgs = {
  attendanceEmployeesSettingId?: InputMaybe<Scalars['Int']>;
  baseline?: InputMaybe<AttendanceEnumsExtraHoursRangeBaselineEnum>;
  employeeType?: InputMaybe<AttendanceEnumsEmployeeTypeEnum>;
  equivalentMinutesInCents?: InputMaybe<Scalars['Int']>;
  fromMinute?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  poolType?: InputMaybe<AttendanceEnumsPoolTypeEnum>;
  rawMinutesInCents?: InputMaybe<Scalars['Int']>;
  timeSettingsCustomTimeRangeCategoryId?: InputMaybe<Scalars['Int']>;
  toMinute?: InputMaybe<Scalars['Int']>;
  unlimited?: InputMaybe<Scalars['Boolean']>;
};


export type AttendanceMutationsUpdateAttendanceOvertimeRequestArgs = {
  date?: InputMaybe<Scalars['ISO8601Date']>;
  description?: InputMaybe<Scalars['String']>;
  hoursAmount?: InputMaybe<Scalars['Float']>;
  id: Scalars['Int'];
  reason?: InputMaybe<Scalars['String']>;
};


export type AttendanceMutationsUpdateAttendanceShiftArgs = {
  clockIn?: InputMaybe<Scalars['ISO8601DateTime']>;
  clockOut?: InputMaybe<Scalars['ISO8601DateTime']>;
  date?: InputMaybe<Scalars['ISO8601Date']>;
  editTimesheetRequestId?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  locationType?: InputMaybe<AttendanceShiftLocationTypeEnum>;
  observations?: InputMaybe<Scalars['String']>;
  referenceDate?: InputMaybe<Scalars['ISO8601Date']>;
  timeSettingsBreakConfigurationId?: InputMaybe<Scalars['Int']>;
  workplaceId?: InputMaybe<Scalars['Int']>;
};


export type AttendanceMutationsUpdateAttendanceToleranceSettingArgs = {
  aboveEstimated?: InputMaybe<Scalars['Int']>;
  attendanceEmployeesSettingId: Scalars['Int'];
  belowEstimated?: InputMaybe<Scalars['Int']>;
  clockInAfter?: InputMaybe<Scalars['Int']>;
  clockInBefore?: InputMaybe<Scalars['Int']>;
  clockInRoundUpEnabled?: InputMaybe<Scalars['Boolean']>;
  clockInRoundingEnabled: Scalars['Boolean'];
  clockOutAfter?: InputMaybe<Scalars['Int']>;
  clockOutBefore?: InputMaybe<Scalars['Int']>;
  clockOutRoundingEnabled: Scalars['Boolean'];
  gridRounding: Scalars['Boolean'];
  gridRoundingBias?: InputMaybe<AttendanceGridRoundingBiasEnum>;
  id: Scalars['Int'];
  shiftsToleranceEnabled: Scalars['Boolean'];
  toleranceType: Scalars['String'];
  workedHoursRoundingEnabled: Scalars['Boolean'];
  workedHoursToleranceEnabled: Scalars['Boolean'];
};

export type AuditLog = {
  __typename?: 'auditLog';
  _policies: AuditLogContextlessPolicies;
};

export type Authentication = {
  __typename?: 'authentication';
  _policies: AuthenticationContextlessPolicies;
  access?: Maybe<AuthenticationAccess>;
  /** @deprecated Please favor `accessesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  accesses: Array<AuthenticationAccess>;
  accessesConnection: AuthenticationAccessConnection;
  domain?: Maybe<AuthenticationDomain>;
  /** @deprecated Please favor `domainsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  domains: Array<AuthenticationDomain>;
  domainsConnection: AuthenticationDomainConnection;
};


export type AuthenticationAccessArgs = {
  id: Scalars['Int'];
};


export type AuthenticationAccessesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeMfaStatus?: Scalars['Boolean'];
};


export type AuthenticationAccessesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeMfaStatus?: Scalars['Boolean'];
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type AuthenticationDomainArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type AuthenticationDomainsArgs = {
  companyId: Scalars['Int'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type AuthenticationDomainsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

export type AuthenticationMutations = {
  __typename?: 'authenticationMutations';
  createAuthenticationDomain: CreateAuthenticationDomainPayload;
  deleteAuthenticationDomain: DeleteAuthenticationDomainPayload;
  disableMfaAuthenticationAccess: DisableMfaAuthenticationAccessPayload;
  verifyAuthenticationDomain: VerifyAuthenticationDomainPayload;
};


export type AuthenticationMutationsCreateAuthenticationDomainArgs = {
  companyId: Scalars['Int'];
  domainName: Scalars['String'];
};


export type AuthenticationMutationsDeleteAuthenticationDomainArgs = {
  id: Scalars['Int'];
};


export type AuthenticationMutationsDisableMfaAuthenticationAccessArgs = {
  id: Scalars['Int'];
};


export type AuthenticationMutationsVerifyAuthenticationDomainArgs = {
  id: Scalars['Int'];
};

/** Payload for automation and subscription: generate_schedule */
export type Automation_Generate_Schedule_Type = {
  __typename?: 'automation_generate_schedule_type';
  agreementHours: Scalars['Boolean'];
  employeesIds: Array<Scalars['Int']>;
  endAt: Scalars['ISO8601DateTime'];
  error?: Maybe<Scalars['Boolean']>;
  locationId: Scalars['Int'];
  maxWorkHoursPerDay: Scalars['Boolean'];
  restDaysPerWeek: Scalars['Boolean'];
  restHoursBetweenShifts: Scalars['Boolean'];
  startAt: Scalars['ISO8601DateTime'];
  status: Scalars['String'];
};

export type Automations = {
  __typename?: 'automations';
  _policies: AutomationsContextlessPolicies;
};

/** Payload for balance and subscription: refresh */
export type Balance_Refresh_Type = {
  __typename?: 'balance_refresh_type';
  balances: Array<AttendanceBalanceSubscription>;
  employeeId: Scalars['Int'];
  error?: Maybe<Scalars['Boolean']>;
};

export type Banking = {
  __typename?: 'banking';
  _policies: BankingContextlessPolicies;
  account?: Maybe<BankingAccount>;
  /** @deprecated Please favor `accountsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  accounts: Array<BankingAccount>;
  accountsConnection: BankingAccountConnection;
  /** @deprecated Please favor `authorizationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  authorizations: Array<BankingAuthorization>;
  authorizationsConnection: BankingAuthorizationConnection;
  bankAccount?: Maybe<BankingBankAccount>;
  bankAccountMembership?: Maybe<BankingBankAccountMembership>;
  /** @deprecated Please favor `bankAccountMembershipsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  bankAccountMemberships: Array<BankingBankAccountMembership>;
  bankAccountMembershipsConnection: BankingBankAccountMembershipConnection;
  /** @deprecated Please favor `bankAccountNumbersConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  bankAccountNumbers: Array<BankingBankAccountNumber>;
  bankAccountNumbersConnection: BankingBankAccountNumberConnection;
  /** @deprecated Please favor `bankAccountsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  bankAccounts: Array<BankingBankAccount>;
  bankAccountsConnection: BankingBankAccountConnection;
  card?: Maybe<BankingCard>;
  cardLimit?: Maybe<BankingCardLimit>;
  /** @deprecated Please favor `cardLimitsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  cardLimits: Array<BankingCardLimit>;
  cardLimitsConnection: BankingCardLimitConnection;
  cardPayment?: Maybe<BankingCardPayment>;
  /** @deprecated Please favor `cardPaymentCategoriesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  cardPaymentCategories: Array<BankingCardPaymentCategory>;
  cardPaymentCategoriesConnection: BankingCardPaymentCategoryConnection;
  cardPaymentCategory?: Maybe<BankingCardPaymentCategory>;
  /** @deprecated Please favor `cardPaymentsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  cardPayments: Array<BankingCardPayment>;
  cardPaymentsConnection: BankingCardPaymentConnection;
  cardholder?: Maybe<BankingCardholder>;
  /** @deprecated Please favor `cardholdersConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  cardholders: Array<BankingCardholder>;
  cardholdersConnection: BankingCardholderConnection;
  /** @deprecated Please favor `cardsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  cards: Array<BankingCard>;
  cardsConnection: BankingCardConnection;
  consent?: Maybe<BankingConsent>;
  /** @deprecated Please favor `consentsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  consents: Array<BankingConsent>;
  consentsConnection: BankingConsentConnection;
  dispute?: Maybe<BankingDispute>;
  /** @deprecated Please favor `disputesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  disputes: Array<BankingDispute>;
  disputesConnection: BankingDisputeConnection;
  institution?: Maybe<BankingInstitution>;
  /** @deprecated Please favor `institutionsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  institutions: Array<BankingInstitution>;
  institutionsConnection: BankingInstitutionConnection;
  onboarding?: Maybe<BankingOnboarding>;
  /** @deprecated Please favor `onboardingsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  onboardings: Array<BankingOnboarding>;
  onboardingsConnection: BankingOnboardingConnection;
  payment?: Maybe<BankingPayment>;
  paymentExecution?: Maybe<BankingPaymentExecution>;
  /** @deprecated Please favor `paymentExecutionsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  paymentExecutions: Array<BankingPaymentExecution>;
  paymentExecutionsConnection: BankingPaymentExecutionConnection;
  paymentRequest?: Maybe<BankingPaymentRequest>;
  paymentRequestItem?: Maybe<BankingPaymentRequestItem>;
  /** @deprecated Please favor `paymentRequestItemsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  paymentRequestItems: Array<BankingPaymentRequestItem>;
  paymentRequestItemsConnection: BankingPaymentRequestItemConnection;
  /** @deprecated Please favor `paymentRequestsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  paymentRequests: Array<BankingPaymentRequest>;
  paymentRequestsConnection: BankingPaymentRequestConnection;
  /** @deprecated Please favor `paymentsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  payments: Array<BankingPayment>;
  paymentsConnection: BankingPaymentConnection;
  payoutBankAccount?: Maybe<BankingPayoutBankAccount>;
  /** @deprecated Please favor `payoutBankAccountsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  payoutBankAccounts: Array<BankingPayoutBankAccount>;
  payoutBankAccountsConnection: BankingPayoutBankAccountConnection;
  providerConfiguration?: Maybe<BankingProviderConfiguration>;
  /** @deprecated Please favor `providerConfigurationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  providerConfigurations: Array<BankingProviderConfiguration>;
  providerConfigurationsConnection: BankingProviderConfigurationConnection;
  reconciliation?: Maybe<BankingReconciliation>;
  reconciliationSuggestion?: Maybe<BankingReconciliationSuggestion>;
  /** @deprecated Please favor `reconciliationSuggestionsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  reconciliationSuggestions: Array<BankingReconciliationSuggestion>;
  reconciliationSuggestionsConnection: BankingReconciliationSuggestionConnection;
  /** @deprecated Please favor `reconciliationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  reconciliations: Array<BankingReconciliation>;
  reconciliationsConnection: BankingReconciliationConnection;
  transaction?: Maybe<BankingTransaction>;
  /** @deprecated Please favor `transactionsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  transactions: Array<BankingTransaction>;
  transactionsConnection: BankingTransactionConnection;
  transfer?: Maybe<BankingTransfer>;
  /** @deprecated Please favor `transfersConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  transfers: Array<BankingTransfer>;
  transfersConnection: BankingTransferConnection;
};


export type BankingAccountArgs = {
  id: Scalars['Int'];
};


export type BankingAccountsArgs = {
  externalId?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  provider?: InputMaybe<Scalars['String']>;
  providers?: InputMaybe<Array<Scalars['String']>>;
  source?: InputMaybe<BankingValueObjectsOnboardingCreationSourceValueEnum>;
};


export type BankingAccountsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  provider?: InputMaybe<Scalars['String']>;
  providers?: InputMaybe<Array<Scalars['String']>>;
  sortOrder?: InputMaybe<Sort>;
  source?: InputMaybe<BankingValueObjectsOnboardingCreationSourceValueEnum>;
};


export type BankingAuthorizationsArgs = {
  data?: InputMaybe<AuthorizationsDataInput>;
  employeeId: Scalars['Int'];
  provider: BankingValueObjectsProviderEnum;
  redirectUrl: Scalars['String'];
};


export type BankingAuthorizationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<AuthorizationsDataInput>;
  employeeId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  provider: BankingValueObjectsProviderEnum;
  redirectUrl: Scalars['String'];
  sortOrder?: InputMaybe<Sort>;
};


export type BankingBankAccountArgs = {
  id: Scalars['Int'];
};


export type BankingBankAccountMembershipArgs = {
  id: Scalars['Int'];
};


export type BankingBankAccountMembershipsArgs = {
  bankAccountIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type BankingBankAccountMembershipsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  bankAccountIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type BankingBankAccountNumbersArgs = {
  employeeIds: Array<Scalars['Int']>;
};


export type BankingBankAccountNumbersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds: Array<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type BankingBankAccountsArgs = {
  accountNumberTypes?: InputMaybe<Array<BankingEntitiesBankAccountNumberFormatEnum>>;
  bankingAccountIds?: InputMaybe<Array<Scalars['Int']>>;
  currency?: InputMaybe<Scalars['String']>;
  externalIds?: InputMaybe<Array<Scalars['String']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  providers?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  service?: InputMaybe<BankingProvidersServicesEnumEnum>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


export type BankingBankAccountsConnectionArgs = {
  accountNumberTypes?: InputMaybe<Array<BankingEntitiesBankAccountNumberFormatEnum>>;
  after?: InputMaybe<Scalars['String']>;
  bankingAccountIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  externalIds?: InputMaybe<Array<Scalars['String']>>;
  filter?: InputMaybe<BankingBankAccountFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  providers?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  service?: InputMaybe<BankingProvidersServicesEnumEnum>;
  sortOrder?: InputMaybe<Sort>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


export type BankingCardArgs = {
  id: Scalars['Int'];
};


export type BankingCardLimitArgs = {
  id: Scalars['Int'];
};


export type BankingCardLimitsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type BankingCardLimitsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type BankingCardPaymentArgs = {
  id: Scalars['Int'];
};


export type BankingCardPaymentCategoriesArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};


export type BankingCardPaymentCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type BankingCardPaymentCategoryArgs = {
  id: Scalars['String'];
};


export type BankingCardPaymentsArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']>>;
  calculatedLabel?: InputMaybe<BankingEntitiesCardPaymentCalculatedLabelEnum>;
  cardIds?: InputMaybe<Array<Scalars['Int']>>;
  externalIds?: InputMaybe<Array<Scalars['String']>>;
  from?: InputMaybe<Scalars['ISO8601DateTime']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<BankingEntitiesCardPaymentStatusEnum>;
  to?: InputMaybe<Scalars['ISO8601DateTime']>;
};


export type BankingCardPaymentsConnectionArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']>>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  calculatedLabel?: InputMaybe<BankingEntitiesCardPaymentCalculatedLabelEnum>;
  cardIds?: InputMaybe<Array<Scalars['Int']>>;
  externalIds?: InputMaybe<Array<Scalars['String']>>;
  filter?: InputMaybe<BankingCardPaymentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['ISO8601DateTime']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  status?: InputMaybe<BankingEntitiesCardPaymentStatusEnum>;
  to?: InputMaybe<Scalars['ISO8601DateTime']>;
};


export type BankingCardholderArgs = {
  id: Scalars['Int'];
};


export type BankingCardholdersArgs = {
  bankAccountIds?: InputMaybe<Array<Scalars['Int']>>;
  creationSource?: InputMaybe<BankingValueObjectsCardCreationSourceEnum>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type BankingCardholdersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  bankAccountIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  creationSource?: InputMaybe<BankingValueObjectsCardCreationSourceEnum>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type BankingCardsArgs = {
  bankAccountIds?: InputMaybe<Array<Scalars['Int']>>;
  cardholderIds?: InputMaybe<Array<Scalars['Int']>>;
  creationSource?: InputMaybe<BankingValueObjectsCardCreationSourceEnum>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last4?: InputMaybe<Scalars['String']>;
  ownerIds?: InputMaybe<Array<Scalars['Int']>>;
  requestedWithoutApprovalFlow?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<BankingValueObjectsCardStatusEnum>;
};


export type BankingCardsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  bankAccountIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  cardholderIds?: InputMaybe<Array<Scalars['Int']>>;
  creationSource?: InputMaybe<BankingValueObjectsCardCreationSourceEnum>;
  filter?: InputMaybe<BankingCardFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  last4?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  ownerIds?: InputMaybe<Array<Scalars['Int']>>;
  requestedWithoutApprovalFlow?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Sort>;
  status?: InputMaybe<BankingValueObjectsCardStatusEnum>;
};


export type BankingConsentArgs = {
  id: Scalars['Int'];
};


export type BankingConsentsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type BankingConsentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type BankingDisputeArgs = {
  id: Scalars['Int'];
};


export type BankingDisputesArgs = {
  bankAccountIds?: InputMaybe<Array<Scalars['Int']>>;
  externalIds?: InputMaybe<Array<Scalars['String']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  refundTransactionIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type BankingDisputesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  bankAccountIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  externalIds?: InputMaybe<Array<Scalars['String']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  refundTransactionIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
};


export type BankingInstitutionArgs = {
  id: Scalars['String'];
};


export type BankingInstitutionsArgs = {
  countries?: InputMaybe<Array<Scalars['String']>>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  name?: InputMaybe<Scalars['String']>;
};


export type BankingInstitutionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  countries?: InputMaybe<Array<Scalars['String']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type BankingOnboardingArgs = {
  id: Scalars['Int'];
};


export type BankingOnboardingsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  source?: InputMaybe<BankingValueObjectsOnboardingCreationSourceValueEnum>;
  statuses?: InputMaybe<Array<BankingValueObjectsOnboardingStatusEnum>>;
  swanDocumentsCollectionId?: InputMaybe<Scalars['String']>;
};


export type BankingOnboardingsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  source?: InputMaybe<BankingValueObjectsOnboardingCreationSourceValueEnum>;
  statuses?: InputMaybe<Array<BankingValueObjectsOnboardingStatusEnum>>;
  swanDocumentsCollectionId?: InputMaybe<Scalars['String']>;
};


export type BankingPaymentArgs = {
  id: Scalars['Int'];
};


export type BankingPaymentExecutionArgs = {
  id: Scalars['Int'];
};


export type BankingPaymentExecutionsArgs = {
  consentIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  paymentIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type BankingPaymentExecutionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  consentIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  paymentIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
};


export type BankingPaymentRequestArgs = {
  id: Scalars['Int'];
};


export type BankingPaymentRequestItemArgs = {
  id: Scalars['Int'];
};


export type BankingPaymentRequestItemsArgs = {
  bankingPaymentRequestIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type BankingPaymentRequestItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  bankingPaymentRequestIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<BankingPaymentRequestItemFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type BankingPaymentRequestsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  requesterIds?: InputMaybe<Array<Scalars['Int']>>;
  statuses?: InputMaybe<Array<BankingValueObjectsPaymentRequestStatusEnum>>;
};


export type BankingPaymentRequestsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<BankingPaymentRequestFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  requesterIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
  statuses?: InputMaybe<Array<BankingValueObjectsPaymentRequestStatusEnum>>;
};


export type BankingPaymentsArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']>>;
  currencies?: InputMaybe<Array<Scalars['String']>>;
  dueThisWeek?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  onTime?: InputMaybe<Scalars['Boolean']>;
  onlyInit?: InputMaybe<Scalars['Boolean']>;
  overdue?: InputMaybe<Scalars['Boolean']>;
  requestedByIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<BankingEntitiesPaymentStatusEnum>>;
};


export type BankingPaymentsConnectionArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']>>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  currencies?: InputMaybe<Array<Scalars['String']>>;
  dueThisWeek?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<BankingPaymentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onTime?: InputMaybe<Scalars['Boolean']>;
  onlyInit?: InputMaybe<Scalars['Boolean']>;
  overdue?: InputMaybe<Scalars['Boolean']>;
  requestedByIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  statuses?: InputMaybe<Array<BankingEntitiesPaymentStatusEnum>>;
};


export type BankingPayoutBankAccountArgs = {
  id: Scalars['Int'];
};


export type BankingPayoutBankAccountsArgs = {
  bankingAccountIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type BankingPayoutBankAccountsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  bankingAccountIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type BankingProviderConfigurationArgs = {
  id: Scalars['String'];
};


export type BankingProviderConfigurationsArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  service?: InputMaybe<BankingProvidersServicesEnumEnum>;
};


export type BankingProviderConfigurationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  service?: InputMaybe<BankingProvidersServicesEnumEnum>;
  sortOrder?: InputMaybe<Sort>;
};


export type BankingReconciliationArgs = {
  id: Scalars['String'];
};


export type BankingReconciliationSuggestionArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type BankingReconciliationSuggestionsArgs = {
  companyId: Scalars['Int'];
  financialDocumentIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  invoiceIds?: InputMaybe<Array<Scalars['Int']>>;
  paymentExecutionIds?: InputMaybe<Array<Scalars['Int']>>;
  transactionIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type BankingReconciliationSuggestionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  financialDocumentIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  invoiceIds?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  paymentExecutionIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
  transactionIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type BankingReconciliationsArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
  reconcilableIds?: InputMaybe<Array<Scalars['Int']>>;
  reconcilableType?: InputMaybe<Scalars['String']>;
  transactionIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type BankingReconciliationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  reconcilableIds?: InputMaybe<Array<Scalars['Int']>>;
  reconcilableType?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  transactionIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type BankingTransactionArgs = {
  id: Scalars['Int'];
};


export type BankingTransactionsArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']>>;
  accounted?: InputMaybe<Scalars['Boolean']>;
  cardPaymentIds?: InputMaybe<Array<Scalars['Int']>>;
  currency?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['ISO8601DateTime']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  incomeTransactions?: InputMaybe<Scalars['Boolean']>;
  outcomeTransactions?: InputMaybe<Scalars['Boolean']>;
  reconciled?: InputMaybe<Scalars['Boolean']>;
  reconciliationStatus?: InputMaybe<BankingValueObjectsReconciliationStatusEnum>;
  status?: InputMaybe<BankingEntitiesTransactionStatusEnum>;
  to?: InputMaybe<Scalars['ISO8601DateTime']>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


export type BankingTransactionsConnectionArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']>>;
  accounted?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  cardPaymentIds?: InputMaybe<Array<Scalars['Int']>>;
  currency?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<BankingTransactionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['ISO8601DateTime']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  incomeTransactions?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  outcomeTransactions?: InputMaybe<Scalars['Boolean']>;
  reconciled?: InputMaybe<Scalars['Boolean']>;
  reconciliationStatus?: InputMaybe<BankingValueObjectsReconciliationStatusEnum>;
  sortOrder?: InputMaybe<Sort>;
  status?: InputMaybe<BankingEntitiesTransactionStatusEnum>;
  to?: InputMaybe<Scalars['ISO8601DateTime']>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


export type BankingTransferArgs = {
  id: Scalars['Int'];
};


export type BankingTransfersArgs = {
  currencies?: InputMaybe<Array<Scalars['String']>>;
  dueDateRange?: InputMaybe<DateRangeInput>;
  dueThisWeek?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  onTime?: InputMaybe<Scalars['Boolean']>;
  onlyPending?: InputMaybe<Scalars['Boolean']>;
  overdue?: InputMaybe<Scalars['Boolean']>;
  paymentExecutionIds?: InputMaybe<Array<Scalars['Int']>>;
  paymentRequestItemIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


export type BankingTransfersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  currencies?: InputMaybe<Array<Scalars['String']>>;
  dueDateRange?: InputMaybe<DateRangeInput>;
  dueThisWeek?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<BankingTransferFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onTime?: InputMaybe<Scalars['Boolean']>;
  onlyPending?: InputMaybe<Scalars['Boolean']>;
  overdue?: InputMaybe<Scalars['Boolean']>;
  paymentExecutionIds?: InputMaybe<Array<Scalars['Int']>>;
  paymentRequestItemIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};

export type BankingMutations = {
  __typename?: 'bankingMutations';
  activateBankingCard: ActivateBankingCardPayload;
  addPaymentRequestsBankingPayment: AddPaymentRequestsBankingPaymentPayload;
  addTransfersBankingPayment: AddTransfersBankingPaymentPayload;
  approveBankingCard: ApproveBankingCardPayload;
  bulkDeleteBankingTransfer: BulkDeleteBankingTransferPayload;
  bulkManageBankingReconciliation: BulkManageBankingReconciliationPayload;
  cancelBankingCard: CancelBankingCardPayload;
  categorizeBankingTransaction: CategorizeBankingTransactionPayload;
  changeAliasBankingCard: ChangeAliasBankingCardPayload;
  changePhoneBankingCardholder: ChangePhoneBankingCardholderPayload;
  changeStatusBankingConsent: ChangeStatusBankingConsentPayload;
  confirmBankingReconciliationSuggestion: ConfirmBankingReconciliationSuggestionPayload;
  createBankingCardEphemeralKey: CreateBankingCardEphemeralKeyPayload;
  createBankingPayment: CreateBankingPaymentPayload;
  createBankingPaymentRequest: CreateBankingPaymentRequestPayload;
  createForCardsBankingOnboarding: CreateForCardsBankingOnboardingPayload;
  createForExternalBankBankingOnboarding: CreateForExternalBankBankingOnboardingPayload;
  createForPaymentsBankingOnboarding: CreateForPaymentsBankingOnboardingPayload;
  createManualBankingBankAccount: CreateManualBankingBankAccountPayload;
  createPhysicalBankingCard: CreatePhysicalBankingCardPayload;
  createSingleUseBankingCard: CreateSingleUseBankingCardPayload;
  createVirtualBankingCard: CreateVirtualBankingCardPayload;
  createWithoutDocumentBankingReconciliation: CreateWithoutDocumentBankingReconciliationPayload;
  deactivateBankingCard: DeactivateBankingCardPayload;
  deleteBankingBankAccount: DeleteBankingBankAccountPayload;
  deleteBankingOnboarding: DeleteBankingOnboardingPayload;
  deleteBankingPayment: DeleteBankingPaymentPayload;
  deleteBankingPaymentRequest: DeleteBankingPaymentRequestPayload;
  exportBankingReconciliation: ExportBankingReconciliationPayload;
  finishSetupBankingBankAccount: FinishSetupBankingBankAccountPayload;
  getBankingTransactionImportTemplate: GetBankingTransactionImportTemplatePayload;
  importBankingTransactionImportResult: ImportBankingTransactionImportResultPayload;
  markAsPaidBankingPaymentExecution: MarkAsPaidBankingPaymentExecutionPayload;
  payBankingPayment: PayBankingPaymentPayload;
  reactivateBankingCard: ReactivateBankingCardPayload;
  reconnectExternalBankBankingOnboarding: ReconnectExternalBankBankingOnboardingPayload;
  rejectBankingCard: RejectBankingCardPayload;
  rejectBankingReconciliationSuggestion: RejectBankingReconciliationSuggestionPayload;
  requestSingleUseBankingCard: RequestSingleUseBankingCardPayload;
  requestVirtualBankingCard: RequestVirtualBankingCardPayload;
  retryBankingPayment: RetryBankingPaymentPayload;
  revokeTransfersBankingPayment: RevokeTransfersBankingPaymentPayload;
  snoozeBankingTransaction: SnoozeBankingTransactionPayload;
  unsnoozeBankingTransaction: UnsnoozeBankingTransactionPayload;
  updateAliasBankingBankAccount: UpdateAliasBankingBankAccountPayload;
  updateBankingCardLimit: UpdateBankingCardLimitPayload;
  updateSepaFileBankingPaymentExecution: UpdateSepaFileBankingPaymentExecutionPayload;
  upsertBankingBankAccountMembership: UpsertBankingBankAccountMembershipPayload;
  upsertBankingBankAccountNumber: UpsertBankingBankAccountNumberPayload;
  validateBankingBankAccountNumber: ValidateBankingBankAccountNumberPayload;
  validateBankingTransactionImportResult: ValidateBankingTransactionImportResultPayload;
};


export type BankingMutationsActivateBankingCardArgs = {
  code: Scalars['String'];
  id: Scalars['String'];
};


export type BankingMutationsAddPaymentRequestsBankingPaymentArgs = {
  id: Scalars['Int'];
  paymentRequestIds: Array<Scalars['Int']>;
};


export type BankingMutationsAddTransfersBankingPaymentArgs = {
  id: Scalars['Int'];
  transferIds: Array<Scalars['Int']>;
};


export type BankingMutationsApproveBankingCardArgs = {
  id: Scalars['String'];
};


export type BankingMutationsBulkDeleteBankingTransferArgs = {
  ids: Array<Scalars['Int']>;
};


export type BankingMutationsBulkManageBankingReconciliationArgs = {
  companyId: Scalars['Int'];
  reconciliationIdsToRemove: Array<Scalars['Int']>;
  reconciliations: Array<BulkManageBankingReconciliationReconciliationsInput>;
};


export type BankingMutationsCancelBankingCardArgs = {
  cancellationReason?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};


export type BankingMutationsCategorizeBankingTransactionArgs = {
  categoryId?: InputMaybe<Scalars['Int']>;
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type BankingMutationsChangeAliasBankingCardArgs = {
  alias: Scalars['String'];
  id: Scalars['String'];
};


export type BankingMutationsChangePhoneBankingCardholderArgs = {
  id: Scalars['String'];
  phoneCountryCode: Scalars['String'];
  phoneNumber: Scalars['String'];
};


export type BankingMutationsChangeStatusBankingConsentArgs = {
  externalId: Scalars['String'];
  status: Scalars['String'];
};


export type BankingMutationsConfirmBankingReconciliationSuggestionArgs = {
  id: Scalars['Int'];
};


export type BankingMutationsCreateBankingCardEphemeralKeyArgs = {
  cardId: Scalars['String'];
  nonce?: InputMaybe<Scalars['String']>;
};


export type BankingMutationsCreateBankingPaymentArgs = {
  bankAccountId: Scalars['Int'];
  description?: InputMaybe<Scalars['String']>;
  label: Scalars['String'];
  paymentRequestIds?: InputMaybe<Array<Scalars['Int']>>;
  transferIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type BankingMutationsCreateBankingPaymentRequestArgs = {
  companyId: Scalars['Int'];
  currency: Scalars['String'];
  dueDate: Scalars['ISO8601DateTime'];
  items: Array<CreateBankingPaymentRequestItemsInput>;
  label: Scalars['String'];
  requesterId: Scalars['Int'];
};


export type BankingMutationsCreateForCardsBankingOnboardingArgs = {
  legalEntityId: Scalars['Int'];
  source: BankingValueObjectsOnboardingCreationSourceValueEnum;
};


export type BankingMutationsCreateForExternalBankBankingOnboardingArgs = {
  institutionId: Scalars['String'];
  legalEntityId: Scalars['Int'];
};


export type BankingMutationsCreateForPaymentsBankingOnboardingArgs = {
  legalEntityId: Scalars['Int'];
};


export type BankingMutationsCreateManualBankingBankAccountArgs = {
  accountAlias?: InputMaybe<Scalars['String']>;
  accountNumber: Scalars['String'];
  accountNumberType: BankingEntitiesBankAccountNumberFormatEnum;
  bankAccountMembershipEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  complementaryData?: InputMaybe<Scalars['String']>;
  currency: Scalars['String'];
  externalId?: InputMaybe<Scalars['String']>;
  ledgerAccountId?: InputMaybe<Scalars['Int']>;
  legalEntityId: Scalars['String'];
};


export type BankingMutationsCreatePhysicalBankingCardArgs = {
  alias?: InputMaybe<Scalars['String']>;
  cardholderData?: InputMaybe<CreatePhysicalBankingCardCardholderDataInput>;
  creationSource: BankingValueObjectsCardCreationSourceEnum;
  employeeId: Scalars['String'];
  shipping: CreatePhysicalBankingCardShippingInput;
};


export type BankingMutationsCreateSingleUseBankingCardArgs = {
  alias: Scalars['String'];
  amountLimitCents: Scalars['Int'];
  cardholderData?: InputMaybe<CreateSingleUseBankingCardCardholderDataInput>;
  creationSource: BankingValueObjectsCardCreationSourceEnum;
  employeeId: Scalars['String'];
};


export type BankingMutationsCreateVirtualBankingCardArgs = {
  alias: Scalars['String'];
  amountLimitCents?: InputMaybe<Scalars['Int']>;
  cardholderData?: InputMaybe<CreateVirtualBankingCardCardholderDataInput>;
  creationSource: BankingValueObjectsCardCreationSourceEnum;
  employeeId: Scalars['String'];
  limitPeriod?: InputMaybe<BankingCardLimitPeriodEnum>;
};


export type BankingMutationsCreateWithoutDocumentBankingReconciliationArgs = {
  companyId: Scalars['Int'];
  transactionId: Scalars['Int'];
};


export type BankingMutationsDeactivateBankingCardArgs = {
  id: Scalars['String'];
};


export type BankingMutationsDeleteBankingBankAccountArgs = {
  id: Scalars['Int'];
};


export type BankingMutationsDeleteBankingOnboardingArgs = {
  id: Scalars['Int'];
};


export type BankingMutationsDeleteBankingPaymentArgs = {
  id: Scalars['Int'];
};


export type BankingMutationsDeleteBankingPaymentRequestArgs = {
  id: Scalars['Int'];
  reason?: InputMaybe<Scalars['String']>;
};


export type BankingMutationsExportBankingReconciliationArgs = {
  bankAccountId: Scalars['Int'];
  companyId: Scalars['Int'];
  exportFormat: BankingDtosReconciliationFullExportExportFormatsEnum;
  fromDate: Scalars['ISO8601Date'];
  toDate: Scalars['ISO8601Date'];
};


export type BankingMutationsFinishSetupBankingBankAccountArgs = {
  accountAlias?: InputMaybe<Scalars['String']>;
  bankAccountId: Scalars['Int'];
  bankAccountMembershipEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  companyId: Scalars['Int'];
  ledgerAccountId?: InputMaybe<Scalars['Int']>;
};


export type BankingMutationsGetBankingTransactionImportTemplateArgs = {
  currency: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
};


export type BankingMutationsImportBankingTransactionImportResultArgs = {
  bankAccountId: Scalars['Int'];
  file: Scalars['File'];
  locale?: InputMaybe<Scalars['String']>;
};


export type BankingMutationsMarkAsPaidBankingPaymentExecutionArgs = {
  id: Scalars['Int'];
};


export type BankingMutationsPayBankingPaymentArgs = {
  id: Scalars['Int'];
};


export type BankingMutationsReactivateBankingCardArgs = {
  id: Scalars['String'];
};


export type BankingMutationsReconnectExternalBankBankingOnboardingArgs = {
  institutionId: Scalars['String'];
  legalEntityId: Scalars['Int'];
};


export type BankingMutationsRejectBankingCardArgs = {
  id: Scalars['String'];
  reason?: InputMaybe<Scalars['String']>;
};


export type BankingMutationsRejectBankingReconciliationSuggestionArgs = {
  id: Scalars['Int'];
};


export type BankingMutationsRequestSingleUseBankingCardArgs = {
  alias: Scalars['String'];
  amountLimitCents: Scalars['Int'];
  cardholderData?: InputMaybe<RequestSingleUseBankingCardCardholderDataInput>;
  creationSource: BankingValueObjectsCardCreationSourceEnum;
  description: Scalars['String'];
  employeeId: Scalars['String'];
};


export type BankingMutationsRequestVirtualBankingCardArgs = {
  alias: Scalars['String'];
  amountLimitCents?: InputMaybe<Scalars['Int']>;
  cardholderData?: InputMaybe<RequestVirtualBankingCardCardholderDataInput>;
  creationSource: BankingValueObjectsCardCreationSourceEnum;
  employeeId: Scalars['String'];
  limitPeriod?: InputMaybe<BankingCardLimitPeriodEnum>;
};


export type BankingMutationsRetryBankingPaymentArgs = {
  id: Scalars['Int'];
};


export type BankingMutationsRevokeTransfersBankingPaymentArgs = {
  id: Scalars['Int'];
  transferIds: Array<Scalars['Int']>;
};


export type BankingMutationsSnoozeBankingTransactionArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
  snoozedUntil: Scalars['ISO8601DateTime'];
};


export type BankingMutationsUnsnoozeBankingTransactionArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type BankingMutationsUpdateAliasBankingBankAccountArgs = {
  alias: Scalars['String'];
  id: Scalars['Int'];
};


export type BankingMutationsUpdateBankingCardLimitArgs = {
  amountCents?: InputMaybe<Scalars['Int']>;
  categories: Array<BankingCardCategoryEnum>;
  categoriesNew?: InputMaybe<Array<Scalars['String']>>;
  id: Scalars['String'];
  limitType?: InputMaybe<BankingCardLimitTypeEnum>;
  period?: InputMaybe<BankingCardLimitPeriodEnum>;
};


export type BankingMutationsUpdateSepaFileBankingPaymentExecutionArgs = {
  id: Scalars['Int'];
};


export type BankingMutationsUpsertBankingBankAccountMembershipArgs = {
  addEmployeeIds: Array<Scalars['Int']>;
  bankAccountId: Scalars['Int'];
  companyId: Scalars['Int'];
  removeEmployeeIds: Array<Scalars['Int']>;
};


export type BankingMutationsUpsertBankingBankAccountNumberArgs = {
  accountNumber: Scalars['String'];
  complementaryData?: InputMaybe<Scalars['String']>;
  employeeId: Scalars['Int'];
  format: BankingEntitiesBankAccountNumberFormatEnum;
};


export type BankingMutationsValidateBankingBankAccountNumberArgs = {
  accountNumber: Scalars['String'];
  complementaryData?: InputMaybe<Scalars['String']>;
  format: BankingEntitiesBankAccountNumberFormatEnum;
};


export type BankingMutationsValidateBankingTransactionImportResultArgs = {
  bankAccountId: Scalars['Int'];
  file: Scalars['File'];
  locale?: InputMaybe<Scalars['String']>;
};

export type Benefits = {
  __typename?: 'benefits';
  _policies: BenefitsContextlessPolicies;
  /** @deprecated Please favor `benefitBalancesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  benefitBalances: Array<BenefitsBenefitBalance>;
  benefitBalancesConnection: BenefitsBenefitBalanceConnection;
  benefitCompensation?: Maybe<BenefitsBenefitCompensation>;
  /** @deprecated Please favor `benefitCompensationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  benefitCompensations: Array<BenefitsBenefitCompensation>;
  benefitCompensationsConnection: BenefitsBenefitCompensationConnection;
  benefitEmployee?: Maybe<BenefitsBenefitEmployee>;
  /** @deprecated Please favor `benefitEmployeesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  benefitEmployees: Array<BenefitsBenefitEmployee>;
  benefitEmployeesConnection: BenefitsBenefitEmployeeConnection;
  /** @deprecated Please favor `benefitSettingsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  benefitSettings: Array<BenefitsBenefitSetting>;
  benefitSettingsConnection: BenefitsBenefitSettingConnection;
  benefitTransaction?: Maybe<BenefitsBenefitTransaction>;
  /** @deprecated Please favor `benefitTransactionsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  benefitTransactions: Array<BenefitsBenefitTransaction>;
  benefitTransactionsConnection: BenefitsBenefitTransactionConnection;
  /** @deprecated Please favor `healthcareEnrollmentsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  healthcareEnrollments: Array<BenefitsHealthcareEnrollment>;
  healthcareEnrollmentsConnection: BenefitsHealthcareEnrollmentConnection;
  /** @deprecated Please favor `healthcarePlansConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  healthcarePlans: Array<BenefitsHealthcarePlan>;
  healthcarePlansConnection: BenefitsHealthcarePlanConnection;
};


export type BenefitsBenefitBalancesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type BenefitsBenefitCompensationArgs = {
  id: Scalars['Int'];
};


export type BenefitsBenefitCompensationsArgs = {
  categories?: InputMaybe<Array<BenefitsValueObjectsBenefitTransactionCategoryEnum>>;
  createdAfter?: InputMaybe<Scalars['ISO8601DateTime']>;
  createdBefore?: InputMaybe<Scalars['ISO8601DateTime']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type BenefitsBenefitCompensationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  categories?: InputMaybe<Array<BenefitsValueObjectsBenefitTransactionCategoryEnum>>;
  createdAfter?: InputMaybe<Scalars['ISO8601DateTime']>;
  createdBefore?: InputMaybe<Scalars['ISO8601DateTime']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type BenefitsBenefitEmployeeArgs = {
  id: Scalars['Int'];
};


export type BenefitsBenefitEmployeesArgs = {
  benefitCategories?: InputMaybe<Array<BenefitsValueObjectsBenefitTransactionCategoryEnum>>;
  compensatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
  compensatedBefore?: InputMaybe<Scalars['ISO8601Date']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type BenefitsBenefitEmployeesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  benefitCategories?: InputMaybe<Array<BenefitsValueObjectsBenefitTransactionCategoryEnum>>;
  compensatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
  compensatedBefore?: InputMaybe<Scalars['ISO8601Date']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type BenefitsBenefitSettingsArgs = {
  companyId: Scalars['Int'];
};


export type BenefitsBenefitSettingsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type BenefitsBenefitTransactionArgs = {
  id: Scalars['Int'];
};


export type BenefitsBenefitTransactionsArgs = {
  categories?: InputMaybe<Array<BenefitsValueObjectsBenefitTransactionCategoryEnum>>;
  compensationStatuses?: InputMaybe<Array<BenefitsValueObjectsBenefitTransactionCompensationStatusEnum>>;
  createdAfter?: InputMaybe<Scalars['ISO8601DateTime']>;
  createdBefore?: InputMaybe<Scalars['ISO8601DateTime']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


export type BenefitsBenefitTransactionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  categories?: InputMaybe<Array<BenefitsValueObjectsBenefitTransactionCategoryEnum>>;
  compensationStatuses?: InputMaybe<Array<BenefitsValueObjectsBenefitTransactionCompensationStatusEnum>>;
  createdAfter?: InputMaybe<Scalars['ISO8601DateTime']>;
  createdBefore?: InputMaybe<Scalars['ISO8601DateTime']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  filter?: InputMaybe<BenefitsBenefitTransactionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type BenefitsHealthcareEnrollmentsArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  enrollmentId?: InputMaybe<Array<Scalars['Int']>>;
  healthcarePlanId?: InputMaybe<Scalars['Int']>;
  memberTypes?: InputMaybe<Array<BenefitsValueObjectsBenefitMembersMemberTypeEnum>>;
  search?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<BenefitsValueObjectsBenefitStatusEnum>>;
};


export type BenefitsHealthcareEnrollmentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  enrollmentId?: InputMaybe<Array<Scalars['Int']>>;
  filter?: InputMaybe<BenefitsHealthcareEnrollmentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  healthcarePlanId?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  memberTypes?: InputMaybe<Array<BenefitsValueObjectsBenefitMembersMemberTypeEnum>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  statuses?: InputMaybe<Array<BenefitsValueObjectsBenefitStatusEnum>>;
};


export type BenefitsHealthcarePlansArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
};


export type BenefitsHealthcarePlansConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

export type BenefitsMutations = {
  __typename?: 'benefitsMutations';
  bulkActivateBenefitsEmployeeActivation: BulkActivateBenefitsEmployeeActivationPayload;
  bulkCreateBenefitsHealthcareEnrollment: BulkCreateBenefitsHealthcareEnrollmentPayload;
  bulkUpsertBenefitsSpendingLimitOverride: BulkUpsertBenefitsSpendingLimitOverridePayload;
  changeStatusBenefitsHealthcareEnrollment: ChangeStatusBenefitsHealthcareEnrollmentPayload;
  createBenefitsChildcareRequest: CreateBenefitsChildcareRequestPayload;
  createBenefitsHealthcarePlan: CreateBenefitsHealthcarePlanPayload;
  createBenefitsTrainingCost: CreateBenefitsTrainingCostPayload;
  saveBenefitsBenefitSetting: SaveBenefitsBenefitSettingPayload;
};


export type BenefitsMutationsBulkActivateBenefitsEmployeeActivationArgs = {
  employeeIds: Array<Scalars['Int']>;
};


export type BenefitsMutationsBulkCreateBenefitsHealthcareEnrollmentArgs = {
  companyId: Scalars['Int'];
  employeeId: Scalars['Int'];
  existingProfiles: Array<BulkCreateBenefitsHealthcareEnrollmentExistingProfilesInput>;
  healthcarePlanId: Scalars['Int'];
  newProfiles: Array<BulkCreateBenefitsHealthcareEnrollmentNewProfilesInput>;
};


export type BenefitsMutationsBulkUpsertBenefitsSpendingLimitOverrideArgs = {
  spendingLimitOverrides: Array<BulkUpsertBenefitsSpendingLimitOverrideSpendingLimitOverridesInput>;
};


export type BenefitsMutationsChangeStatusBenefitsHealthcareEnrollmentArgs = {
  benefitStatus: BenefitsValueObjectsBenefitStatusEnum;
  companyId: Scalars['Int'];
  membershipId: Scalars['Int'];
};


export type BenefitsMutationsCreateBenefitsChildcareRequestArgs = {
  companyId: Scalars['Int'];
  employeeId: Scalars['Int'];
};


export type BenefitsMutationsCreateBenefitsHealthcarePlanArgs = {
  allowPreExistingConditions: Scalars['Boolean'];
  companyId: Scalars['Int'];
  coveredDependentCostCents?: InputMaybe<Scalars['Int']>;
  coveredEmployeeCostCents: Scalars['Int'];
  dependentCostCents?: InputMaybe<Scalars['Int']>;
  employeeCostCents: Scalars['Int'];
  planDocument: Scalars['File'];
  planName: Scalars['String'];
  providerName: Scalars['String'];
  renewalDate: Scalars['ISO8601Date'];
  waitingPeriodMonths: Scalars['Int'];
};


export type BenefitsMutationsCreateBenefitsTrainingCostArgs = {
  companyId: Scalars['Int'];
  effectiveDate?: InputMaybe<Scalars['ISO8601Date']>;
  employeeId: Scalars['Int'];
  numberPayslips?: InputMaybe<Scalars['Int']>;
  paymentOption: BenefitsValueObjectsTrainingsPaymentOptionEnum;
  priceCents: Scalars['Int'];
  trainingRequestId: Scalars['Int'];
};


export type BenefitsMutationsSaveBenefitsBenefitSettingArgs = {
  companyId: Scalars['Int'];
  resetDay: Scalars['Int'];
};

export type Billing = {
  __typename?: 'billing';
  _policies: BillingContextlessPolicies;
  churnRequest?: Maybe<BillingChurnRequest>;
  /** @deprecated Please favor `churnRequestsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  churnRequests: Array<BillingChurnRequest>;
  churnRequestsConnection: BillingChurnRequestConnection;
  cpCreditNote?: Maybe<BillingCpCreditNote>;
  /** @deprecated Please favor `cpCreditNotePdfsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  cpCreditNotePdfs: Array<BillingCpCreditNotePdf>;
  cpCreditNotePdfsConnection: BillingCpCreditNotePdfConnection;
  /** @deprecated Please favor `cpCreditNotesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  cpCreditNotes: Array<BillingCpCreditNote>;
  cpCreditNotesConnection: BillingCpCreditNoteConnection;
  cpInvoice?: Maybe<BillingCpInvoice>;
  /** @deprecated Please favor `cpInvoicePdfsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  cpInvoicePdfs: Array<BillingCpInvoicePdf>;
  cpInvoicePdfsConnection: BillingCpInvoicePdfConnection;
  /** @deprecated Please favor `cpInvoicesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  cpInvoices: Array<BillingCpInvoice>;
  cpInvoicesConnection: BillingCpInvoiceConnection;
  cpNextBillingEstimate?: Maybe<BillingCpNextBillingEstimate>;
  /** @deprecated Please favor `cpNextBillingEstimatesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  cpNextBillingEstimates: Array<BillingCpNextBillingEstimate>;
  cpNextBillingEstimatesConnection: BillingCpNextBillingEstimateConnection;
  cpPaymentMethod?: Maybe<BillingCpPaymentMethod>;
  /** @deprecated Please favor `cpPaymentMethodsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  cpPaymentMethods: Array<BillingCpPaymentMethod>;
  cpPaymentMethodsConnection: BillingCpPaymentMethodConnection;
  /** @deprecated Please favor `cpSeatHistoriesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  cpSeatHistories: Array<BillingCpSeatHistory>;
  cpSeatHistoriesConnection: BillingCpSeatHistoryConnection;
  /** @deprecated Please favor `cpSubscriptionContactsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  cpSubscriptionContacts: Array<BillingCpSubscriptionContact>;
  cpSubscriptionContactsConnection: BillingCpSubscriptionContactConnection;
  /** @deprecated Please favor `cpSubscriptionsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  cpSubscriptions: Array<BillingCpSubscription>;
  cpSubscriptionsConnection: BillingCpSubscriptionConnection;
  headquarter?: Maybe<BillingHeadquarter>;
  /** @deprecated Please favor `headquartersConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  headquarters: Array<BillingHeadquarter>;
  headquartersConnection: BillingHeadquarterConnection;
  /** @deprecated Please favor `payingCompaniesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  payingCompanies: Array<BillingPayingCompany>;
  payingCompaniesConnection: BillingPayingCompanyConnection;
  subscription?: Maybe<BillingSubscription>;
  /** @deprecated Please favor `subscriptionItemsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  subscriptionItems: Array<BillingSubscriptionItem>;
  subscriptionItemsConnection: BillingSubscriptionItemConnection;
  /** @deprecated Please favor `subscriptionsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  subscriptions: Array<BillingSubscription>;
  subscriptionsConnection: BillingSubscriptionConnection;
};


export type BillingChurnRequestArgs = {
  id: Scalars['Int'];
};


export type BillingChurnRequestsArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type BillingChurnRequestsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type BillingCpCreditNoteArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type BillingCpCreditNotePdfsArgs = {
  companyId: Scalars['Int'];
  creditNote: Scalars['String'];
  customerAccess?: InputMaybe<BillingCustomerAccessInput>;
};


export type BillingCpCreditNotePdfsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  creditNote: Scalars['String'];
  customerAccess?: InputMaybe<BillingCustomerAccessInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type BillingCpCreditNotesArgs = {
  companyId: Scalars['Int'];
  customerAccess?: InputMaybe<BillingCustomerAccessInput>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type BillingCpCreditNotesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  customerAccess?: InputMaybe<BillingCustomerAccessInput>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type BillingCpInvoiceArgs = {
  accessId: Scalars['Int'];
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type BillingCpInvoicePdfsArgs = {
  companyId: Scalars['Int'];
  customerAccess?: InputMaybe<BillingCustomerAccessInput>;
  invoice: Scalars['String'];
};


export type BillingCpInvoicePdfsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  customerAccess?: InputMaybe<BillingCustomerAccessInput>;
  first?: InputMaybe<Scalars['Int']>;
  invoice: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type BillingCpInvoicesArgs = {
  accessId: Scalars['Int'];
  companyId: Scalars['Int'];
  customerAccess?: InputMaybe<BillingCustomerAccessInput>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type BillingCpInvoicesConnectionArgs = {
  accessId: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  customerAccess?: InputMaybe<BillingCustomerAccessInput>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type BillingCpNextBillingEstimateArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type BillingCpNextBillingEstimatesArgs = {
  companyId: Scalars['Int'];
  customerAccess?: InputMaybe<BillingCustomerAccessInput>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type BillingCpNextBillingEstimatesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  customerAccess?: InputMaybe<BillingCustomerAccessInput>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type BillingCpPaymentMethodArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type BillingCpPaymentMethodsArgs = {
  companyId: Scalars['Int'];
  customerAccess?: InputMaybe<BillingCustomerAccessInput>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type BillingCpPaymentMethodsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  customerAccess?: InputMaybe<BillingCustomerAccessInput>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type BillingCpSeatHistoriesArgs = {
  companyId: Scalars['Int'];
  customerAccess?: InputMaybe<BillingCustomerAccessInput>;
  endDate?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
};


export type BillingCpSeatHistoriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  customerAccess?: InputMaybe<BillingCustomerAccessInput>;
  endDate?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startDate?: InputMaybe<Scalars['String']>;
};


export type BillingCpSubscriptionContactsArgs = {
  companyId: Scalars['Int'];
  customerAccess?: InputMaybe<BillingCustomerAccessInput>;
};


export type BillingCpSubscriptionContactsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  customerAccess?: InputMaybe<BillingCustomerAccessInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type BillingCpSubscriptionsArgs = {
  accessId: Scalars['Int'];
  companyId: Scalars['Int'];
  customerAccess?: InputMaybe<BillingCustomerAccessInput>;
};


export type BillingCpSubscriptionsConnectionArgs = {
  accessId: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  customerAccess?: InputMaybe<BillingCustomerAccessInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type BillingHeadquarterArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type BillingHeadquartersArgs = {
  companyId: Scalars['Int'];
  customerAccess?: InputMaybe<BillingCustomerAccessInput>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type BillingHeadquartersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  customerAccess?: InputMaybe<BillingCustomerAccessInput>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type BillingPayingCompaniesArgs = {
  companyId: Scalars['Int'];
  companyName?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
  customerAccess?: InputMaybe<BillingCustomerAccessInput>;
  customerCompanyId?: InputMaybe<Scalars['String']>;
  limitRate?: InputMaybe<Scalars['Int']>;
  subscriptionId?: InputMaybe<Scalars['String']>;
};


export type BillingPayingCompaniesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  companyName?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
  customerAccess?: InputMaybe<BillingCustomerAccessInput>;
  customerCompanyId?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  limitRate?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  subscriptionId?: InputMaybe<Scalars['String']>;
};


export type BillingSubscriptionArgs = {
  id: Scalars['Int'];
};


export type BillingSubscriptionItemsArgs = {
  subscriptionItems?: InputMaybe<Array<Scalars['String']>>;
};


export type BillingSubscriptionItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  subscriptionItems?: InputMaybe<Array<Scalars['String']>>;
};


export type BillingSubscriptionsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type BillingSubscriptionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

export type BillingMutations = {
  __typename?: 'billingMutations';
  chatBillingCpChat: ChatBillingCpChatPayload;
  createBillingChurnRequest: CreateBillingChurnRequestPayload;
  createBillingCpCollectNow: CreateBillingCpCollectNowPayload;
  createBillingCpPaymentIntent: CreateBillingCpPaymentIntentPayload;
  createBillingCpPaymentLink: CreateBillingCpPaymentLinkPayload;
  createBillingCpPaymentMethod: CreateBillingCpPaymentMethodPayload;
  createBillingCpSubscriptionContact: CreateBillingCpSubscriptionContactPayload;
  createBillingEstimateProrate: CreateBillingEstimateProratePayload;
  createBillingUpgradeLineItem: CreateBillingUpgradeLineItemPayload;
  createBillingUpgradeSubscription: CreateBillingUpgradeSubscriptionPayload;
  deleteBillingCpPaymentMethod: DeleteBillingCpPaymentMethodPayload;
  deleteBillingCpSubscriptionContact: DeleteBillingCpSubscriptionContactPayload;
  deleteBillingSubscription: DeleteBillingSubscriptionPayload;
  downloadZipBillingCpDownloadZip: DownloadZipBillingCpDownloadZipPayload;
  feedbackBillingCpChat: FeedbackBillingCpChatPayload;
  initiateExportBillingCpExportInvoice: InitiateExportBillingCpExportInvoicePayload;
  paymentCountUpdatedBillingDuePaymentsUpdate: PaymentCountUpdatedBillingDuePaymentsUpdatePayload;
  subscriptionBillingCustomerPortal: SubscriptionBillingCustomerPortalPayload;
  updateBillingCpSubscriptionAdmin: UpdateBillingCpSubscriptionAdminPayload;
  updateBillingCpSubscriptionContact: UpdateBillingCpSubscriptionContactPayload;
};


export type BillingMutationsChatBillingCpChatArgs = {
  companyId: Scalars['Int'];
  conversationId: Scalars['String'];
  customerAccess?: InputMaybe<BillingCustomerAccessInput>;
  question: Scalars['String'];
  response?: InputMaybe<Scalars['String']>;
  subscriptionId: Scalars['String'];
};


export type BillingMutationsCreateBillingChurnRequestArgs = {
  mainChurnReason: Scalars['String'];
  secondaryChurnReason: Scalars['String'];
};


export type BillingMutationsCreateBillingCpCollectNowArgs = {
  companyId: Scalars['Int'];
  customerAccess?: InputMaybe<BillingCustomerAccessInput>;
  customerId: Scalars['String'];
  gatewayAccountId: Scalars['String'];
};


export type BillingMutationsCreateBillingCpPaymentIntentArgs = {
  amount: Scalars['Int'];
  companyId: Scalars['Int'];
  currencyCode: Scalars['String'];
  customerAccess?: InputMaybe<BillingCustomerAccessInput>;
  gatewayAccountId: Scalars['String'];
  paymentMethodType?: InputMaybe<Scalars['String']>;
};


export type BillingMutationsCreateBillingCpPaymentLinkArgs = {
  companyId: Scalars['Int'];
  customerAccess?: InputMaybe<BillingCustomerAccessInput>;
  invoiceId: Scalars['String'];
};


export type BillingMutationsCreateBillingCpPaymentMethodArgs = {
  adyenPaymentMethod: BillingAdyenPaymentMethodInput;
  companyId: Scalars['Int'];
  customerAccess?: InputMaybe<BillingCustomerAccessInput>;
  paymentIntentId: Scalars['String'];
  role?: InputMaybe<Scalars['String']>;
};


export type BillingMutationsCreateBillingCpSubscriptionContactArgs = {
  companyId: Scalars['Int'];
  customerAccess?: InputMaybe<BillingCustomerAccessInput>;
  email: Scalars['String'];
  enabled?: InputMaybe<Scalars['Boolean']>;
  firstName: Scalars['String'];
  label?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  sendAccountEmail: Scalars['Boolean'];
  sendBillingEmail: Scalars['Boolean'];
};


export type BillingMutationsCreateBillingEstimateProrateArgs = {
  newAddons: Array<BillingAddonItemInput>;
};


export type BillingMutationsCreateBillingUpgradeLineItemArgs = {
  newAddons: Array<BillingAddonItemInput>;
  oldAddons: Array<BillingAddonItemInput>;
  origin?: InputMaybe<Scalars['String']>;
  upsellInfo?: InputMaybe<BillingUpsellInfoInput>;
};


export type BillingMutationsCreateBillingUpgradeSubscriptionArgs = {
  crossSellingInfo?: InputMaybe<Array<BillingUpsellInfoInput>>;
  newAddons: Array<BillingAddonItemInput>;
  origin?: InputMaybe<Scalars['String']>;
  upsellInfo?: InputMaybe<BillingUpsellInfoInput>;
};


export type BillingMutationsDeleteBillingCpPaymentMethodArgs = {
  companyId: Scalars['Int'];
  customerAccess?: InputMaybe<BillingCustomerAccessInput>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  paymentSourceId: Scalars['String'];
};


export type BillingMutationsDeleteBillingCpSubscriptionContactArgs = {
  companyId: Scalars['Int'];
  customerAccess?: InputMaybe<BillingCustomerAccessInput>;
  id: Scalars['String'];
};


export type BillingMutationsDeleteBillingSubscriptionArgs = {
  id: Scalars['Int'];
};


export type BillingMutationsDownloadZipBillingCpDownloadZipArgs = {
  companyId: Scalars['Int'];
  customerAccess?: InputMaybe<BillingCustomerAccessInput>;
  invoice: Scalars['String'];
};


export type BillingMutationsFeedbackBillingCpChatArgs = {
  comment: Scalars['String'];
  companyId: Scalars['Int'];
  conversationId: Scalars['String'];
  customerAccess?: InputMaybe<BillingCustomerAccessInput>;
  feedback: Scalars['Boolean'];
  subscriptionId: Scalars['String'];
  userId?: InputMaybe<Scalars['String']>;
};


export type BillingMutationsInitiateExportBillingCpExportInvoiceArgs = {
  companyId: Scalars['Int'];
  customerId?: InputMaybe<Scalars['String']>;
  downloadUrl?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};


export type BillingMutationsPaymentCountUpdatedBillingDuePaymentsUpdateArgs = {
  companyId: Scalars['Int'];
  country: Scalars['String'];
  dueInvoicesCount: Scalars['Int'];
  subscriptionId: Scalars['String'];
};


export type BillingMutationsSubscriptionBillingCustomerPortalArgs = {
  accessId: Scalars['Int'];
  companyId: Scalars['Int'];
  customerAccess?: InputMaybe<BillingCustomerAccessInput>;
};


export type BillingMutationsUpdateBillingCpSubscriptionAdminArgs = {
  companyId: Scalars['Int'];
  customerAccess?: InputMaybe<BillingCustomerAccessInput>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
};


export type BillingMutationsUpdateBillingCpSubscriptionContactArgs = {
  companyId: Scalars['Int'];
  customerAccess?: InputMaybe<BillingCustomerAccessInput>;
  email?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  label?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  sendAccountEmail?: InputMaybe<Scalars['Boolean']>;
  sendBillingEmail?: InputMaybe<Scalars['Boolean']>;
};

export type BookkeepersManagement = {
  __typename?: 'bookkeepersManagement';
  _policies: BookkeepersManagementContextlessPolicies;
  bookkeeper?: Maybe<BookkeepersManagementBookkeeper>;
  /** @deprecated Please favor `bookkeeperCompaniesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  bookkeeperCompanies: Array<BookkeepersManagementBookkeeperCompany>;
  bookkeeperCompaniesConnection: BookkeepersManagementBookkeeperCompanyConnection;
  bookkeeperCompany?: Maybe<BookkeepersManagementBookkeeperCompany>;
  bookkeeperCustomer?: Maybe<BookkeepersManagementBookkeeperCustomer>;
  /** @deprecated Please favor `bookkeeperCustomersConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  bookkeeperCustomers: Array<BookkeepersManagementBookkeeperCustomer>;
  bookkeeperCustomersConnection: BookkeepersManagementBookkeeperCustomerConnection;
  /** @deprecated Please favor `bookkeepersConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  bookkeepers: Array<BookkeepersManagementBookkeeper>;
  bookkeepersConnection: BookkeepersManagementBookkeeperConnection;
  incidence?: Maybe<BookkeepersManagementIncidence>;
  incidenceChange?: Maybe<BookkeepersManagementIncidenceChange>;
  /** @deprecated Please favor `incidenceChangesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  incidenceChanges: Array<BookkeepersManagementIncidenceChange>;
  incidenceChangesConnection: BookkeepersManagementIncidenceChangeConnection;
  incidenceMessageStat?: Maybe<BookkeepersManagementIncidenceMessageStat>;
  /** @deprecated Please favor `incidenceMessageStatsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  incidenceMessageStats: Array<BookkeepersManagementIncidenceMessageStat>;
  incidenceMessageStatsConnection: BookkeepersManagementIncidenceMessageStatConnection;
  /** @deprecated Please favor `incidenceOptionsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  incidenceOptions: Array<BookkeepersManagementIncidenceOption>;
  incidenceOptionsConnection: BookkeepersManagementIncidenceOptionConnection;
  /** @deprecated Please favor `incidencePayrollIntegrationStatusesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  incidencePayrollIntegrationStatuses: Array<BookkeepersManagementIncidencePayrollIntegrationStatus>;
  incidencePayrollIntegrationStatusesConnection: BookkeepersManagementIncidencePayrollIntegrationStatusConnection;
  incidenceRule?: Maybe<BookkeepersManagementIncidenceRule>;
  incidenceRuleEvaluation?: Maybe<BookkeepersManagementIncidenceRuleEvaluation>;
  /** @deprecated Please favor `incidenceRuleEvaluationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  incidenceRuleEvaluations: Array<BookkeepersManagementIncidenceRuleEvaluation>;
  incidenceRuleEvaluationsConnection: BookkeepersManagementIncidenceRuleEvaluationConnection;
  /** @deprecated Please favor `incidenceRulesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  incidenceRules: Array<BookkeepersManagementIncidenceRule>;
  incidenceRulesConnection: BookkeepersManagementIncidenceRuleConnection;
  incidenceStat?: Maybe<BookkeepersManagementIncidenceStat>;
  /** @deprecated Please favor `incidenceStatsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  incidenceStats: Array<BookkeepersManagementIncidenceStat>;
  incidenceStatsConnection: BookkeepersManagementIncidenceStatConnection;
  /** @deprecated Please favor `incidencesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  incidences: Array<BookkeepersManagementIncidence>;
  incidencesConnection: BookkeepersManagementIncidenceConnection;
  taskDocument?: Maybe<BookkeepersManagementTaskDocument>;
  /** @deprecated Please favor `taskDocumentsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  taskDocuments: Array<BookkeepersManagementTaskDocument>;
  taskDocumentsConnection: BookkeepersManagementTaskDocumentConnection;
  /** @deprecated Please favor `taskStatusesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  taskStatuses: Array<BookkeepersManagementTaskStatus>;
  taskStatusesConnection: BookkeepersManagementTaskStatusConnection;
  taskType?: Maybe<BookkeepersManagementTaskType>;
  /** @deprecated Please favor `taskTypesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  taskTypes: Array<BookkeepersManagementTaskType>;
  taskTypesConnection: BookkeepersManagementTaskTypeConnection;
};


export type BookkeepersManagementBookkeeperArgs = {
  id: Scalars['Int'];
};


export type BookkeepersManagementBookkeeperCompaniesArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  withCompanyData?: Scalars['Boolean'];
};


export type BookkeepersManagementBookkeeperCompaniesConnectionArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  withCompanyData?: Scalars['Boolean'];
};


export type BookkeepersManagementBookkeeperCompanyArgs = {
  id: Scalars['Int'];
};


export type BookkeepersManagementBookkeeperCustomerArgs = {
  id: Scalars['Int'];
};


export type BookkeepersManagementBookkeeperCustomersArgs = {
  bookkeeperIds?: InputMaybe<Array<Scalars['Int']>>;
  customerCompanyIds?: InputMaybe<Array<Scalars['Int']>>;
  customerName?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type BookkeepersManagementBookkeeperCustomersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  bookkeeperIds?: InputMaybe<Array<Scalars['Int']>>;
  customerCompanyIds?: InputMaybe<Array<Scalars['Int']>>;
  customerName?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type BookkeepersManagementBookkeepersArgs = {
  accesses?: InputMaybe<Array<Scalars['Int']>>;
  companies?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type BookkeepersManagementBookkeepersConnectionArgs = {
  accesses?: InputMaybe<Array<Scalars['Int']>>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companies?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type BookkeepersManagementIncidenceArgs = {
  id: Scalars['Int'];
};


export type BookkeepersManagementIncidenceChangeArgs = {
  id: Scalars['Int'];
  incidenceId: Scalars['Int'];
};


export type BookkeepersManagementIncidenceChangesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  incidenceId: Scalars['Int'];
};


export type BookkeepersManagementIncidenceChangesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  incidenceId: Scalars['Int'];
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type BookkeepersManagementIncidenceMessageStatArgs = {
  id: Scalars['Int'];
  messageFrom: Scalars['String'];
};


export type BookkeepersManagementIncidenceMessageStatsArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  containsMessage?: InputMaybe<Scalars['Boolean']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endsOn?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntitiesIds?: InputMaybe<Array<Scalars['Int']>>;
  messageFrom: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
  startsOn?: InputMaybe<Scalars['ISO8601Date']>;
  status?: InputMaybe<Array<Scalars['String']>>;
  type?: InputMaybe<Array<Scalars['String']>>;
};


export type BookkeepersManagementIncidenceMessageStatsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  containsMessage?: InputMaybe<Scalars['Boolean']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endsOn?: InputMaybe<Scalars['ISO8601Date']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntitiesIds?: InputMaybe<Array<Scalars['Int']>>;
  messageFrom: Scalars['String'];
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  startsOn?: InputMaybe<Scalars['ISO8601Date']>;
  status?: InputMaybe<Array<Scalars['String']>>;
  type?: InputMaybe<Array<Scalars['String']>>;
};


export type BookkeepersManagementIncidenceOptionsArgs = {
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  withDynamicUpdates?: InputMaybe<Scalars['Boolean']>;
};


export type BookkeepersManagementIncidenceOptionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  withDynamicUpdates?: InputMaybe<Scalars['Boolean']>;
};


export type BookkeepersManagementIncidencePayrollIntegrationStatusesArgs = {
  companyId: Scalars['Int'];
  currentUserId: Scalars['Int'];
  incidenceIds: Array<Scalars['Int']>;
};


export type BookkeepersManagementIncidencePayrollIntegrationStatusesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  currentUserId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  incidenceIds: Array<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type BookkeepersManagementIncidenceRuleArgs = {
  id: Scalars['Int'];
};


export type BookkeepersManagementIncidenceRuleEvaluationArgs = {
  id: Scalars['Int'];
};


export type BookkeepersManagementIncidenceRuleEvaluationsArgs = {
  ids: Array<Scalars['Int']>;
};


export type BookkeepersManagementIncidenceRuleEvaluationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids: Array<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type BookkeepersManagementIncidenceRulesArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  enforced?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  incidenceTypes?: InputMaybe<Array<Scalars['String']>>;
};


export type BookkeepersManagementIncidenceRulesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  enforced?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  incidenceTypes?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type BookkeepersManagementIncidenceStatArgs = {
  id: Scalars['Int'];
};


export type BookkeepersManagementIncidenceStatsArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endsOn?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntitiesIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  startsOn?: InputMaybe<Scalars['ISO8601Date']>;
  status?: InputMaybe<Array<Scalars['String']>>;
  type?: InputMaybe<Array<Scalars['String']>>;
};


export type BookkeepersManagementIncidenceStatsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endsOn?: InputMaybe<Scalars['ISO8601Date']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntitiesIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  startsOn?: InputMaybe<Scalars['ISO8601Date']>;
  status?: InputMaybe<Array<Scalars['String']>>;
  type?: InputMaybe<Array<Scalars['String']>>;
};


export type BookkeepersManagementIncidencesArgs = {
  containsMessage?: InputMaybe<Scalars['Boolean']>;
  customLeaveName?: InputMaybe<Array<Scalars['String']>>;
  direction?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endsOn?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntitiesIds?: InputMaybe<Array<Scalars['Int']>>;
  messageFrom?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
  startsOn?: InputMaybe<Scalars['ISO8601Date']>;
  status?: InputMaybe<Array<Scalars['String']>>;
  type?: InputMaybe<Array<Scalars['String']>>;
  workplaceIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type BookkeepersManagementIncidencesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  containsMessage?: InputMaybe<Scalars['Boolean']>;
  customLeaveName?: InputMaybe<Array<Scalars['String']>>;
  direction?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endsOn?: InputMaybe<Scalars['ISO8601Date']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntitiesIds?: InputMaybe<Array<Scalars['Int']>>;
  messageFrom?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  startsOn?: InputMaybe<Scalars['ISO8601Date']>;
  status?: InputMaybe<Array<Scalars['String']>>;
  type?: InputMaybe<Array<Scalars['String']>>;
  workplaceIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type BookkeepersManagementTaskDocumentArgs = {
  id: Scalars['Int'];
};


export type BookkeepersManagementTaskDocumentsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  incidenceId?: InputMaybe<Scalars['Int']>;
  taskTypeId?: InputMaybe<Scalars['Int']>;
};


export type BookkeepersManagementTaskDocumentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  incidenceId?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  taskTypeId?: InputMaybe<Scalars['Int']>;
};


export type BookkeepersManagementTaskStatusesArgs = {
  incidenceId?: InputMaybe<Scalars['Int']>;
  incidenceIds?: InputMaybe<Array<Scalars['Int']>>;
  taskTypeId?: InputMaybe<Scalars['Int']>;
};


export type BookkeepersManagementTaskStatusesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  incidenceId?: InputMaybe<Scalars['Int']>;
  incidenceIds?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  taskTypeId?: InputMaybe<Scalars['Int']>;
};


export type BookkeepersManagementTaskTypeArgs = {
  id: Scalars['Int'];
};


export type BookkeepersManagementTaskTypesArgs = {
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  incidenceName?: InputMaybe<Scalars['String']>;
};


export type BookkeepersManagementTaskTypesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  incidenceName?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

export type BookkeepersManagementMutations = {
  __typename?: 'bookkeepersManagementMutations';
  bulkUpdateBookkeepersmanagementIncidence: BulkUpdateBookkeepersmanagementIncidencePayload;
  createBookkeepersmanagementBookkeeper: CreateBookkeepersmanagementBookkeeperPayload;
  createBookkeepersmanagementBookkeeperAccess: CreateBookkeepersmanagementBookkeeperAccessPayload;
  createBookkeepersmanagementBookkeeperCompany: CreateBookkeepersmanagementBookkeeperCompanyPayload;
  createBookkeepersmanagementBookkeeperCustomer: CreateBookkeepersmanagementBookkeeperCustomerPayload;
  createBookkeepersmanagementOptionIncidenceOption: CreateBookkeepersmanagementOptionIncidenceOptionPayload;
  createBookkeepersmanagementOptionIncidenceRule: CreateBookkeepersmanagementOptionIncidenceRulePayload;
  createBookkeepersmanagementTaskTaskDocument: CreateBookkeepersmanagementTaskTaskDocumentPayload;
  createBookkeepersmanagementTaskTaskStatus: CreateBookkeepersmanagementTaskTaskStatusPayload;
  deleteBookkeepersmanagementBookkeeper: DeleteBookkeepersmanagementBookkeeperPayload;
  deleteBookkeepersmanagementBookkeeperAccess: DeleteBookkeepersmanagementBookkeeperAccessPayload;
  deleteBookkeepersmanagementBookkeeperCustomer: DeleteBookkeepersmanagementBookkeeperCustomerPayload;
  deleteBookkeepersmanagementTaskTaskDocument: DeleteBookkeepersmanagementTaskTaskDocumentPayload;
  generateBookkeepersmanagementPayrollCycleVariableExport: GenerateBookkeepersmanagementPayrollCycleVariableExportPayload;
  patchBookkeepersmanagementOptionIncidenceOption: PatchBookkeepersmanagementOptionIncidenceOptionPayload;
  syncBookkeepersmanagementIncidencePayrollIntegrationStatus: SyncBookkeepersmanagementIncidencePayrollIntegrationStatusPayload;
  syncIncidencePayrollStatusesBookkeepersmanagementIncidencePayrollIntegrationStatus: SyncIncidencePayrollStatusesBookkeepersmanagementIncidencePayrollIntegrationStatusPayload;
  updateBookkeepersmanagementBookkeeperCompany: UpdateBookkeepersmanagementBookkeeperCompanyPayload;
  updateBookkeepersmanagementIncidence: UpdateBookkeepersmanagementIncidencePayload;
  updateBookkeepersmanagementTaskTaskStatus: UpdateBookkeepersmanagementTaskTaskStatusPayload;
};


export type BookkeepersManagementMutationsBulkUpdateBookkeepersmanagementIncidenceArgs = {
  ignoreWarnings?: InputMaybe<Scalars['Boolean']>;
  incidenceIds: Array<Scalars['Int']>;
  newStatus: Scalars['String'];
};


export type BookkeepersManagementMutationsCreateBookkeepersmanagementBookkeeperArgs = {
  accessId: Scalars['Int'];
  companyId: Scalars['Int'];
};


export type BookkeepersManagementMutationsCreateBookkeepersmanagementBookkeeperAccessArgs = {
  bookkeeperEmployeeAccessId: Scalars['Int'];
  companyId: Scalars['Int'];
};


export type BookkeepersManagementMutationsCreateBookkeepersmanagementBookkeeperCompanyArgs = {
  companyId: Scalars['Int'];
};


export type BookkeepersManagementMutationsCreateBookkeepersmanagementBookkeeperCustomerArgs = {
  bookkeeperCompanyId: Scalars['Int'];
  customerCompanyId: Scalars['Int'];
};


export type BookkeepersManagementMutationsCreateBookkeepersmanagementOptionIncidenceOptionArgs = {
  companyId: Scalars['Int'];
  incidenceName: Scalars['String'];
  leaveTypeId?: InputMaybe<Scalars['Int']>;
  needsValidation?: InputMaybe<Scalars['Boolean']>;
  trackIncidence?: InputMaybe<Scalars['Boolean']>;
};


export type BookkeepersManagementMutationsCreateBookkeepersmanagementOptionIncidenceRuleArgs = {
  companyId: Scalars['Int'];
  enforced: Scalars['Boolean'];
  enforcement: Scalars['String'];
  field: Scalars['String'];
  incidenceType: Scalars['String'];
};


export type BookkeepersManagementMutationsCreateBookkeepersmanagementTaskTaskDocumentArgs = {
  file: Scalars['File'];
  incidenceId: Scalars['Int'];
  taskTypeId: Scalars['Int'];
};


export type BookkeepersManagementMutationsCreateBookkeepersmanagementTaskTaskStatusArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  completed: Scalars['Boolean'];
  incidenceId: Scalars['Int'];
  taskTypeId: Scalars['Int'];
};


export type BookkeepersManagementMutationsDeleteBookkeepersmanagementBookkeeperArgs = {
  id: Scalars['Int'];
};


export type BookkeepersManagementMutationsDeleteBookkeepersmanagementBookkeeperAccessArgs = {
  bookkeeperId: Scalars['Int'];
};


export type BookkeepersManagementMutationsDeleteBookkeepersmanagementBookkeeperCustomerArgs = {
  id: Scalars['Int'];
};


export type BookkeepersManagementMutationsDeleteBookkeepersmanagementTaskTaskDocumentArgs = {
  id: Scalars['Int'];
};


export type BookkeepersManagementMutationsGenerateBookkeepersmanagementPayrollCycleVariableExportArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  format?: InputMaybe<Scalars['String']>;
  fromDate?: InputMaybe<Scalars['ISO8601Date']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  payrollRunId: Scalars['Int'];
  toDate?: InputMaybe<Scalars['ISO8601Date']>;
};


export type BookkeepersManagementMutationsPatchBookkeepersmanagementOptionIncidenceOptionArgs = {
  id: Scalars['Int'];
  needsValidation?: InputMaybe<Scalars['Boolean']>;
  trackIncidence?: InputMaybe<Scalars['Boolean']>;
};


export type BookkeepersManagementMutationsSyncBookkeepersmanagementIncidencePayrollIntegrationStatusArgs = {
  companyId: Scalars['Int'];
  currentUserId: Scalars['Int'];
  incidenceIds: Array<Scalars['Int']>;
};


export type BookkeepersManagementMutationsSyncIncidencePayrollStatusesBookkeepersmanagementIncidencePayrollIntegrationStatusArgs = {
  companyId: Scalars['Int'];
  currentUserId: Scalars['Int'];
  incidenceIds: Array<Scalars['Int']>;
};


export type BookkeepersManagementMutationsUpdateBookkeepersmanagementBookkeeperCompanyArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
};


export type BookkeepersManagementMutationsUpdateBookkeepersmanagementIncidenceArgs = {
  hasMessage?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  ignoreWarnings?: InputMaybe<Scalars['Boolean']>;
  markAsRead?: InputMaybe<Scalars['Boolean']>;
  messageFrom?: InputMaybe<Scalars['String']>;
  readAt?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};


export type BookkeepersManagementMutationsUpdateBookkeepersmanagementTaskTaskStatusArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  completed: Scalars['Boolean'];
  id: Scalars['Int'];
};

export type Calendar = {
  __typename?: 'calendar';
  _policies: CalendarContextlessPolicies;
  calendarEvent?: Maybe<CalendarCalendarEvent>;
  /** @deprecated Please favor `calendarEventsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  calendarEvents: Array<CalendarCalendarEvent>;
  calendarEventsConnection: CalendarCalendarEventConnection;
};


export type CalendarCalendarEventArgs = {
  endsOn: Scalars['ISO8601Date'];
  id: Scalars['String'];
  startsOn: Scalars['ISO8601Date'];
};


export type CalendarCalendarEventsArgs = {
  approved?: InputMaybe<Scalars['Boolean']>;
  endsOn: Scalars['ISO8601Date'];
  ids?: InputMaybe<Array<Scalars['String']>>;
  onlyPublishedShifts?: InputMaybe<Scalars['Boolean']>;
  own?: InputMaybe<Scalars['Boolean']>;
  spanLeavesByDates?: InputMaybe<Scalars['Boolean']>;
  startsOn: Scalars['ISO8601Date'];
  types?: InputMaybe<Array<CalendarValueObjectsEventTypeEnum>>;
};


export type CalendarCalendarEventsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  approved?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  endsOn: Scalars['ISO8601Date'];
  filter?: InputMaybe<CalendarCalendarEventFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyPublishedShifts?: InputMaybe<Scalars['Boolean']>;
  own?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Sort>;
  spanLeavesByDates?: InputMaybe<Scalars['Boolean']>;
  startsOn: Scalars['ISO8601Date'];
  types?: InputMaybe<Array<CalendarValueObjectsEventTypeEnum>>;
};

export type CoffreFortNumerique = {
  __typename?: 'coffreFortNumerique';
  /** @deprecated Please favor `statusesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  statuses: Array<CoffreFortNumeriqueStatus>;
  statusesConnection: CoffreFortNumeriqueStatusConnection;
};


export type CoffreFortNumeriqueStatusesArgs = {
  stateableId: Scalars['Int'];
  stateableType: Scalars['String'];
};


export type CoffreFortNumeriqueStatusesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  stateableId: Scalars['Int'];
  stateableType: Scalars['String'];
};

export type Cognito = {
  __typename?: 'cognito';
  samlProvider?: Maybe<CognitoSamlProvider>;
  /** @deprecated Please favor `samlProvidersConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  samlProviders: Array<CognitoSamlProvider>;
  samlProvidersConnection: CognitoSamlProviderConnection;
};


export type CognitoSamlProviderArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type CognitoSamlProvidersArgs = {
  companyId: Scalars['Int'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type CognitoSamlProvidersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

export type CognitoMutations = {
  __typename?: 'cognitoMutations';
  createCognitoSamlProvider: CreateCognitoSamlProviderPayload;
};


export type CognitoMutationsCreateCognitoSamlProviderArgs = {
  companyId: Scalars['Int'];
  domainIds: Array<Scalars['Int']>;
  samlMetadata: Scalars['String'];
  vendor: Scalars['String'];
};

export type Companies = {
  __typename?: 'companies';
  /** @deprecated Please favor `companiesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  companies: Array<CompaniesCompany>;
  companiesConnection: CompaniesCompanyConnection;
  company?: Maybe<CompaniesCompany>;
  /** @deprecated Please favor `employeesPerLegalEntitiesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  employeesPerLegalEntities: Array<CompaniesEmployeesPerLegalEntity>;
  employeesPerLegalEntitiesConnection: CompaniesEmployeesPerLegalEntityConnection;
  /** @deprecated Please favor `featureAvailabilitiesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  featureAvailabilities: Array<CompaniesFeatureAvailability>;
  featureAvailabilitiesConnection: CompaniesFeatureAvailabilityConnection;
  featureAvailability?: Maybe<CompaniesFeatureAvailability>;
  gender?: Maybe<CompaniesGender>;
  /** @deprecated Please favor `gendersConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  genders: Array<CompaniesGender>;
  gendersConnection: CompaniesGenderConnection;
  /** @deprecated Please favor `legalEntitiesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  legalEntities: Array<CompaniesLegalEntity>;
  legalEntitiesConnection: CompaniesLegalEntityConnection;
  legalEntity?: Maybe<CompaniesLegalEntity>;
  /** @deprecated Please favor `legalGendersConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  legalGenders: Array<CompaniesLegalGender>;
  legalGendersConnection: CompaniesLegalGenderConnection;
  /** @deprecated Please favor `moduleAvailabilitiesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  moduleAvailabilities: Array<CompaniesModuleAvailability>;
  moduleAvailabilitiesConnection: CompaniesModuleAvailabilityConnection;
  moduleAvailability?: Maybe<CompaniesModuleAvailability>;
  /** @deprecated Please favor `subscriptionOverloadsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  subscriptionOverloads: Array<CompaniesSubscriptionOverload>;
  subscriptionOverloadsConnection: CompaniesSubscriptionOverloadConnection;
};


export type CompaniesCompaniesArgs = {
  forBookkeepers?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  name?: InputMaybe<Scalars['String']>;
};


export type CompaniesCompaniesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forBookkeepers?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type CompaniesCompanyArgs = {
  id: Scalars['Int'];
};


export type CompaniesEmployeesPerLegalEntitiesArgs = {
  companyId: Scalars['Int'];
  costCenters?: InputMaybe<Array<Scalars['Int']>>;
  cycle: ReportsInsightsCycleEnum;
  employees?: InputMaybe<Array<Scalars['Int']>>;
  endDate: Scalars['ISO8601Date'];
  forFinancialWorkspace?: InputMaybe<Scalars['Boolean']>;
  genders?: InputMaybe<Array<Scalars['String']>>;
  legalEntities?: InputMaybe<Array<Scalars['Int']>>;
  managers?: InputMaybe<Array<Scalars['Int']>>;
  nationalities?: InputMaybe<Array<Scalars['String']>>;
  startDate: Scalars['ISO8601Date'];
  teams?: InputMaybe<Array<Scalars['Int']>>;
  withNoGender?: Scalars['Boolean'];
  withNoManager?: Scalars['Boolean'];
  withNoNationality?: Scalars['Boolean'];
  workplaces?: InputMaybe<Array<Scalars['Int']>>;
};


export type CompaniesEmployeesPerLegalEntitiesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  costCenters?: InputMaybe<Array<Scalars['Int']>>;
  cycle: ReportsInsightsCycleEnum;
  employees?: InputMaybe<Array<Scalars['Int']>>;
  endDate: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  forFinancialWorkspace?: InputMaybe<Scalars['Boolean']>;
  genders?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntities?: InputMaybe<Array<Scalars['Int']>>;
  managers?: InputMaybe<Array<Scalars['Int']>>;
  nationalities?: InputMaybe<Array<Scalars['String']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startDate: Scalars['ISO8601Date'];
  teams?: InputMaybe<Array<Scalars['Int']>>;
  withNoGender?: Scalars['Boolean'];
  withNoManager?: Scalars['Boolean'];
  withNoNationality?: Scalars['Boolean'];
  workplaces?: InputMaybe<Array<Scalars['Int']>>;
};


export type CompaniesFeatureAvailabilitiesArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  modules?: InputMaybe<Array<Scalars['String']>>;
};


export type CompaniesFeatureAvailabilitiesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<CompaniesFeatureAvailabilityFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  modules?: InputMaybe<Array<Scalars['String']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type CompaniesFeatureAvailabilityArgs = {
  id: Scalars['String'];
};


export type CompaniesGenderArgs = {
  id: Scalars['String'];
};


export type CompaniesGendersArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};


export type CompaniesGendersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type CompaniesLegalEntitiesArgs = {
  companiesIds?: InputMaybe<Array<Scalars['Int']>>;
  countryIds?: InputMaybe<Array<Scalars['String']>>;
  employeesIds?: InputMaybe<Array<Scalars['Int']>>;
  excludeCountries?: InputMaybe<Array<Scalars['String']>>;
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


export type CompaniesLegalEntitiesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companiesIds?: InputMaybe<Array<Scalars['Int']>>;
  countryIds?: InputMaybe<Array<Scalars['String']>>;
  employeesIds?: InputMaybe<Array<Scalars['Int']>>;
  excludeCountries?: InputMaybe<Array<Scalars['String']>>;
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  filter?: InputMaybe<CompaniesLegalEntityFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type CompaniesLegalEntityArgs = {
  id: Scalars['Int'];
};


export type CompaniesLegalGendersArgs = {
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type CompaniesLegalGendersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type CompaniesModuleAvailabilitiesArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
};


export type CompaniesModuleAvailabilitiesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type CompaniesModuleAvailabilityArgs = {
  id: Scalars['String'];
};


export type CompaniesSubscriptionOverloadsArgs = {
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  featureId?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type CompaniesSubscriptionOverloadsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  featureId?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};

export type CompaniesMutations = {
  __typename?: 'companiesMutations';
  activateCompanyPageCompaniesCompany: ActivateCompanyPageCompaniesCompanyPayload;
  changeGeneralInformationCompaniesCompany: ChangeGeneralInformationCompaniesCompanyPayload;
  changeLocaleCompaniesCompany: ChangeLocaleCompaniesCompanyPayload;
  changeSlugCompaniesCompany: ChangeSlugCompaniesCompanyPayload;
  createCompaniesLegalEntity: CreateCompaniesLegalEntityPayload;
  createCompaniesSubscriptionOverload: CreateCompaniesSubscriptionOverloadPayload;
  createModuleTrialCompaniesSubscriptionOverload: CreateModuleTrialCompaniesSubscriptionOverloadPayload;
  deleteWorkspaceLogoCompaniesLogo: DeleteWorkspaceLogoCompaniesLogoPayload;
  enableTrialCompaniesSubscriptionOverload: EnableTrialCompaniesSubscriptionOverloadPayload;
  revokeAccessCompaniesCompany: RevokeAccessCompaniesCompanyPayload;
  updateCompaniesSubscriptionOverload: UpdateCompaniesSubscriptionOverloadPayload;
  uploadWorkspaceLogoCompaniesLogo: UploadWorkspaceLogoCompaniesLogoPayload;
};


export type CompaniesMutationsActivateCompanyPageCompaniesCompanyArgs = {
  countryFactorialDomain: Scalars['String'];
  publicEmail: Scalars['String'];
  slug: Scalars['String'];
};


export type CompaniesMutationsChangeGeneralInformationCompaniesCompanyArgs = {
  id: Scalars['Int'];
  industry: Scalars['String'];
  name: Scalars['String'];
};


export type CompaniesMutationsChangeLocaleCompaniesCompanyArgs = {
  id: Scalars['Int'];
  locale: Scalars['String'];
};


export type CompaniesMutationsChangeSlugCompaniesCompanyArgs = {
  countryFactorialDomain: Scalars['String'];
  id: Scalars['Int'];
  slug: Scalars['String'];
};


export type CompaniesMutationsCreateCompaniesLegalEntityArgs = {
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  country: Scalars['String'];
  currency: Scalars['String'];
  legalName: Scalars['String'];
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  tin?: InputMaybe<Scalars['String']>;
};


export type CompaniesMutationsCreateCompaniesSubscriptionOverloadArgs = {
  addonIds: Array<Scalars['String']>;
  authorId?: InputMaybe<Scalars['Int']>;
  expirationDate: Scalars['ISO8601Date'];
  overloadReason: Scalars['String'];
  planId?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
};


export type CompaniesMutationsCreateModuleTrialCompaniesSubscriptionOverloadArgs = {
  addonIds: Array<Scalars['String']>;
  expirationDate: Scalars['ISO8601Date'];
  overloadReason: Scalars['String'];
  planId?: InputMaybe<Scalars['String']>;
};


export type CompaniesMutationsDeleteWorkspaceLogoCompaniesLogoArgs = {
  companyId: Scalars['Int'];
};


export type CompaniesMutationsRevokeAccessCompaniesCompanyArgs = {
  id: Scalars['Int'];
};


export type CompaniesMutationsUpdateCompaniesSubscriptionOverloadArgs = {
  expirationDate: Scalars['ISO8601Date'];
  id: Scalars['Int'];
};


export type CompaniesMutationsUploadWorkspaceLogoCompaniesLogoArgs = {
  companyId: Scalars['Int'];
  file: Scalars['File'];
};

export type CompanyPage = {
  __typename?: 'companyPage';
  _policies: CompanyPageContextlessPolicies;
  companyValue?: Maybe<CompanyPageCompanyValue>;
  /** @deprecated Please favor `companyValuesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  companyValues: Array<CompanyPageCompanyValue>;
  companyValuesConnection: CompanyPageCompanyValueConnection;
  perk?: Maybe<CompanyPagePerk>;
  /** @deprecated Please favor `perksConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  perks: Array<CompanyPagePerk>;
  perksConnection: CompanyPagePerkConnection;
};


export type CompanyPageCompanyValueArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type CompanyPageCompanyValuesArgs = {
  companyId: Scalars['Int'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type CompanyPageCompanyValuesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type CompanyPagePerkArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type CompanyPagePerksArgs = {
  companyId: Scalars['Int'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type CompanyPagePerksConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

export type CompanyPageMutations = {
  __typename?: 'companyPageMutations';
  createCompanypagePerk: CreateCompanypagePerkPayload;
  deleteCompanypagePerk: DeleteCompanypagePerkPayload;
  updateCompanypagePerk: UpdateCompanypagePerkPayload;
};


export type CompanyPageMutationsCreateCompanypagePerkArgs = {
  categoryType: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};


export type CompanyPageMutationsDeleteCompanypagePerkArgs = {
  id: Scalars['String'];
};


export type CompanyPageMutationsUpdateCompanypagePerkArgs = {
  categoryType?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
};

export type Compensations = {
  __typename?: 'compensations';
  _policies: CompensationsContextlessPolicies;
  compensationSetting?: Maybe<CompensationsCompensationSetting>;
  /** @deprecated Please favor `compensationSettingsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  compensationSettings: Array<CompensationsCompensationSetting>;
  compensationSettingsConnection: CompensationsCompensationSettingConnection;
  concept?: Maybe<CompensationsConcept>;
  /** @deprecated Please favor `conceptsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  concepts: Array<CompensationsConcept>;
  conceptsConnection: CompensationsConceptConnection;
  /** @deprecated Please favor `currentCompensationsPayrollRunsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  currentCompensationsPayrollRuns: Array<CompensationsCurrentCompensationsPayrollRun>;
  currentCompensationsPayrollRunsConnection: CompensationsCurrentCompensationsPayrollRunConnection;
  cycle?: Maybe<CompensationsCycle>;
  /** @deprecated Please favor `cyclesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  cycles: Array<CompensationsCycle>;
  /** @deprecated Please favor `cyclesByEmployeesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  cyclesByEmployees: Array<CompensationsCyclesByEmployee>;
  cyclesByEmployeesConnection: CompensationsCyclesByEmployeeConnection;
  cyclesConnection: CompensationsCycleConnection;
  elementPayrollConcept?: Maybe<CompensationsElementPayrollConcept>;
  /** @deprecated Please favor `elementPayrollConceptsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  elementPayrollConcepts: Array<CompensationsElementPayrollConcept>;
  elementPayrollConceptsConnection: CompensationsElementPayrollConceptConnection;
  employeesCompensation?: Maybe<CompensationsEmployeesCompensation>;
  /** @deprecated Please favor `employeesCompensationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  employeesCompensations: Array<CompensationsEmployeesCompensation>;
  employeesCompensationsConnection: CompensationsEmployeesCompensationConnection;
  employeesCompensationsValidation?: Maybe<CompensationsEmployeesCompensationsValidation>;
  /** @deprecated Please favor `employeesCompensationsValidationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  employeesCompensationsValidations: Array<CompensationsEmployeesCompensationsValidation>;
  employeesCompensationsValidationsConnection: CompensationsEmployeesCompensationsValidationConnection;
  file?: Maybe<CompensationsFile>;
  /** @deprecated Please favor `fileCategoriesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  fileCategories: Array<CompensationsFileCategory>;
  fileCategoriesConnection: CompensationsFileCategoryConnection;
  /** @deprecated Please favor `filesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  files: Array<CompensationsFile>;
  filesConnection: CompensationsFileConnection;
  /** @deprecated Please favor `fixedAmountStrategiesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  fixedAmountStrategies: Array<CompensationsFixedAmountStrategy>;
  fixedAmountStrategiesConnection: CompensationsFixedAmountStrategyConnection;
  fixedAmountStrategy?: Maybe<CompensationsFixedAmountStrategy>;
  /** @deprecated Please favor `paymentRequestItemsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  paymentRequestItems: Array<CompensationsPaymentRequestItem>;
  paymentRequestItemsConnection: CompensationsPaymentRequestItemConnection;
  /** @deprecated Please favor `paymentRequestPendingItemsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  paymentRequestPendingItems: Array<CompensationsPaymentRequestPendingItem>;
  paymentRequestPendingItemsConnection: CompensationsPaymentRequestPendingItemConnection;
  payrollConceptStatus?: Maybe<CompensationsPayrollConceptStatus>;
  /** @deprecated Please favor `payrollConceptStatusesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  payrollConceptStatuses: Array<CompensationsPayrollConceptStatus>;
  payrollConceptStatusesConnection: CompensationsPayrollConceptStatusConnection;
  payrollRun?: Maybe<CompensationsPayrollRun>;
  payrollRunEmployee?: Maybe<CompensationsPayrollRunEmployee>;
  /** @deprecated Please favor `payrollRunEmployeesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  payrollRunEmployees: Array<CompensationsPayrollRunEmployee>;
  payrollRunEmployeesCompensation?: Maybe<CompensationsPayrollRunEmployeesCompensation>;
  /** @deprecated Please favor `payrollRunEmployeesCompensationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  payrollRunEmployeesCompensations: Array<CompensationsPayrollRunEmployeesCompensation>;
  payrollRunEmployeesCompensationsConnection: CompensationsPayrollRunEmployeesCompensationConnection;
  payrollRunEmployeesConnection: CompensationsPayrollRunEmployeeConnection;
  payrollRunTotal?: Maybe<CompensationsPayrollRunTotal>;
  /** @deprecated Please favor `payrollRunTotalsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  payrollRunTotals: Array<CompensationsPayrollRunTotal>;
  payrollRunTotalsConnection: CompensationsPayrollRunTotalConnection;
  /** @deprecated Please favor `payrollRunsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  payrollRuns: Array<CompensationsPayrollRun>;
  payrollRunsConnection: CompensationsPayrollRunConnection;
  reimbursablePayrollConcept?: Maybe<CompensationsReimbursablePayrollConcept>;
  /** @deprecated Please favor `reimbursablePayrollConceptsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  reimbursablePayrollConcepts: Array<CompensationsReimbursablePayrollConcept>;
  reimbursablePayrollConceptsConnection: CompensationsReimbursablePayrollConceptConnection;
  /** @deprecated Please favor `variableAmountStrategiesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  variableAmountStrategies: Array<CompensationsVariableAmountStrategy>;
  variableAmountStrategiesConnection: CompensationsVariableAmountStrategyConnection;
  variableAmountStrategy?: Maybe<CompensationsVariableAmountStrategy>;
};


export type CompensationsCompensationSettingArgs = {
  id: Scalars['Int'];
};


export type CompensationsCompensationSettingsArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type CompensationsCompensationSettingsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type CompensationsConceptArgs = {
  id: Scalars['Int'];
};


export type CompensationsConceptsArgs = {
  categories?: InputMaybe<Array<PayrollValueObjectsConceptCategoryEnum>>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  unitTypes?: InputMaybe<Array<PayrollValueObjectsConceptUnitTypeEnum>>;
  withActiveStatus?: InputMaybe<Scalars['Boolean']>;
};


export type CompensationsConceptsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  categories?: InputMaybe<Array<PayrollValueObjectsConceptCategoryEnum>>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  unitTypes?: InputMaybe<Array<PayrollValueObjectsConceptUnitTypeEnum>>;
  withActiveStatus?: InputMaybe<Scalars['Boolean']>;
};


export type CompensationsCurrentCompensationsPayrollRunsArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type CompensationsCurrentCompensationsPayrollRunsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type CompensationsCycleArgs = {
  id: Scalars['Int'];
};


export type CompensationsCyclesArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  country?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  recurrence?: InputMaybe<Scalars['String']>;
};


export type CompensationsCyclesByEmployeesArgs = {
  employeeId: Scalars['Int'];
};


export type CompensationsCyclesByEmployeesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type CompensationsCyclesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  country?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  recurrence?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type CompensationsElementPayrollConceptArgs = {
  id: Scalars['Int'];
};


export type CompensationsElementPayrollConceptsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  payrollRunIds?: InputMaybe<Array<Scalars['Int']>>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  validationTypes?: InputMaybe<Array<CompensationsValueObjectsEmployeeCompensationValidationTypeEnum>>;
  workplaceIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type CompensationsElementPayrollConceptsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  payrollRunIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  validationTypes?: InputMaybe<Array<CompensationsValueObjectsEmployeeCompensationValidationTypeEnum>>;
  workplaceIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type CompensationsEmployeesCompensationArgs = {
  id: Scalars['Int'];
};


export type CompensationsEmployeesCompensationsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  payrollConceptIds?: InputMaybe<Array<Scalars['Int']>>;
  payrollRunEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  payrollRunIds?: InputMaybe<Array<Scalars['Int']>>;
  resultType?: InputMaybe<CompensationsValueObjectsResultTypeEnum>;
  sourceIds?: InputMaybe<Array<Scalars['Int']>>;
  sourceType?: InputMaybe<Scalars['String']>;
};


export type CompensationsEmployeesCompensationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  payrollConceptIds?: InputMaybe<Array<Scalars['Int']>>;
  payrollRunEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  payrollRunIds?: InputMaybe<Array<Scalars['Int']>>;
  resultType?: InputMaybe<CompensationsValueObjectsResultTypeEnum>;
  sortOrder?: InputMaybe<Sort>;
  sourceIds?: InputMaybe<Array<Scalars['Int']>>;
  sourceType?: InputMaybe<Scalars['String']>;
};


export type CompensationsEmployeesCompensationsValidationArgs = {
  id: Scalars['Int'];
};


export type CompensationsEmployeesCompensationsValidationsArgs = {
  employeeCompensationIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  payrollRunEmployeeCompensationIds?: InputMaybe<Array<Scalars['Int']>>;
  payrollRunIds?: InputMaybe<Array<Scalars['Int']>>;
  validationType?: InputMaybe<Array<CompensationsValueObjectsEmployeeCompensationValidationTypeEnum>>;
};


export type CompensationsEmployeesCompensationsValidationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeCompensationIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  payrollRunEmployeeCompensationIds?: InputMaybe<Array<Scalars['Int']>>;
  payrollRunIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
  validationType?: InputMaybe<Array<CompensationsValueObjectsEmployeeCompensationValidationTypeEnum>>;
};


export type CompensationsFileArgs = {
  id: Scalars['Int'];
};


export type CompensationsFileCategoriesArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  categoryType?: InputMaybe<CompensationsValueObjectsFileCategoryTypeEnum>;
  companyId?: InputMaybe<Scalars['Int']>;
};


export type CompensationsFileCategoriesConnectionArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  categoryType?: InputMaybe<CompensationsValueObjectsFileCategoryTypeEnum>;
  companyId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type CompensationsFilesArgs = {
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  fileCategoryIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  payrollRunIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type CompensationsFilesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  fileCategoryIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  payrollRunIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
};


export type CompensationsFixedAmountStrategiesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  parentIds?: InputMaybe<Array<Scalars['Int']>>;
  parentType?: InputMaybe<Scalars['String']>;
};


export type CompensationsFixedAmountStrategiesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  parentIds?: InputMaybe<Array<Scalars['Int']>>;
  parentType?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type CompensationsFixedAmountStrategyArgs = {
  id: Scalars['Int'];
};


export type CompensationsPaymentRequestItemsArgs = {
  payrollRunIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type CompensationsPaymentRequestItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  payrollRunIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
};


export type CompensationsPaymentRequestPendingItemsArgs = {
  payrollRunId: Scalars['Int'];
};


export type CompensationsPaymentRequestPendingItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  payrollRunId: Scalars['Int'];
  sortOrder?: InputMaybe<Sort>;
};


export type CompensationsPayrollConceptStatusArgs = {
  id: Scalars['Int'];
};


export type CompensationsPayrollConceptStatusesArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type CompensationsPayrollConceptStatusesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type CompensationsPayrollRunArgs = {
  id: Scalars['Int'];
};


export type CompensationsPayrollRunEmployeeArgs = {
  id: Scalars['Int'];
};


export type CompensationsPayrollRunEmployeesArgs = {
  employeeStatus?: InputMaybe<Array<CompensationsValueObjectsEmployeeStatusEnum>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  integrationsAgreggatedSyncableStates?: InputMaybe<Array<IntegrationsAgreggatedSyncableStateValuesEnum>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  payrollRunId?: InputMaybe<Scalars['Int']>;
  payrollRunIds?: InputMaybe<Array<Scalars['Int']>>;
  resultType?: InputMaybe<CompensationsValueObjectsResultTypeEnum>;
  search?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  validationTypes?: InputMaybe<Array<CompensationsValueObjectsEmployeeCompensationValidationTypeEnum>>;
  workplaceIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type CompensationsPayrollRunEmployeesCompensationArgs = {
  id: Scalars['Int'];
};


export type CompensationsPayrollRunEmployeesCompensationsArgs = {
  fromDate?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  payrollConceptId?: InputMaybe<Scalars['Int']>;
  payrollConceptIds?: InputMaybe<Array<Scalars['Int']>>;
  payrollRunEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  payrollRunIds?: InputMaybe<Array<Scalars['Int']>>;
  resultType?: InputMaybe<CompensationsValueObjectsResultTypeEnum>;
  toDate?: InputMaybe<Scalars['ISO8601Date']>;
};


export type CompensationsPayrollRunEmployeesCompensationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  fromDate?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  payrollConceptId?: InputMaybe<Scalars['Int']>;
  payrollConceptIds?: InputMaybe<Array<Scalars['Int']>>;
  payrollRunEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  payrollRunIds?: InputMaybe<Array<Scalars['Int']>>;
  resultType?: InputMaybe<CompensationsValueObjectsResultTypeEnum>;
  sortOrder?: InputMaybe<Sort>;
  toDate?: InputMaybe<Scalars['ISO8601Date']>;
};


export type CompensationsPayrollRunEmployeesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeStatus?: InputMaybe<Array<CompensationsValueObjectsEmployeeStatusEnum>>;
  filter?: InputMaybe<CompensationsPayrollRunEmployeeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  integrationsAgreggatedSyncableStates?: InputMaybe<Array<IntegrationsAgreggatedSyncableStateValuesEnum>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  payrollRunId?: InputMaybe<Scalars['Int']>;
  payrollRunIds?: InputMaybe<Array<Scalars['Int']>>;
  resultType?: InputMaybe<CompensationsValueObjectsResultTypeEnum>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  validationTypes?: InputMaybe<Array<CompensationsValueObjectsEmployeeCompensationValidationTypeEnum>>;
  workplaceIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type CompensationsPayrollRunTotalArgs = {
  id: Scalars['Int'];
};


export type CompensationsPayrollRunTotalsArgs = {
  employeeStatus?: InputMaybe<Array<CompensationsValueObjectsEmployeeStatusEnum>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  integrationsAgreggatedSyncableStates?: InputMaybe<Array<IntegrationsAgreggatedSyncableStateValuesEnum>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  payrollRunId?: InputMaybe<Scalars['Int']>;
  payrollRunIds?: InputMaybe<Array<Scalars['Int']>>;
  resultType?: InputMaybe<CompensationsValueObjectsResultTypeEnum>;
  search?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  totalAmountInCents?: InputMaybe<Scalars['BigInt']>;
  validationTypes?: InputMaybe<Array<CompensationsValueObjectsEmployeeCompensationValidationTypeEnum>>;
  workplaceIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type CompensationsPayrollRunTotalsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeStatus?: InputMaybe<Array<CompensationsValueObjectsEmployeeStatusEnum>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  integrationsAgreggatedSyncableStates?: InputMaybe<Array<IntegrationsAgreggatedSyncableStateValuesEnum>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  payrollRunId?: InputMaybe<Scalars['Int']>;
  payrollRunIds?: InputMaybe<Array<Scalars['Int']>>;
  resultType?: InputMaybe<CompensationsValueObjectsResultTypeEnum>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  totalAmountInCents?: InputMaybe<Scalars['BigInt']>;
  validationTypes?: InputMaybe<Array<CompensationsValueObjectsEmployeeCompensationValidationTypeEnum>>;
  workplaceIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type CompensationsPayrollRunsArgs = {
  afterPayrollRunId?: InputMaybe<Scalars['Int']>;
  beforePayrollRunId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  countries?: InputMaybe<Array<Scalars['String']>>;
  currencies?: InputMaybe<Array<Scalars['String']>>;
  cycleIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  resultType?: InputMaybe<CompensationsValueObjectsResultTypeEnum>;
  startsOnGte?: InputMaybe<Scalars['ISO8601Date']>;
  startsOnLte?: InputMaybe<Scalars['ISO8601Date']>;
  status?: InputMaybe<CompensationsValueObjectsPayrollRunStatusEnum>;
  statuses?: InputMaybe<Array<Scalars['String']>>;
};


export type CompensationsPayrollRunsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  afterPayrollRunId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  beforePayrollRunId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  countries?: InputMaybe<Array<Scalars['String']>>;
  currencies?: InputMaybe<Array<Scalars['String']>>;
  cycleIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  resultType?: InputMaybe<CompensationsValueObjectsResultTypeEnum>;
  sortOrder?: InputMaybe<Sort>;
  startsOnGte?: InputMaybe<Scalars['ISO8601Date']>;
  startsOnLte?: InputMaybe<Scalars['ISO8601Date']>;
  status?: InputMaybe<CompensationsValueObjectsPayrollRunStatusEnum>;
  statuses?: InputMaybe<Array<Scalars['String']>>;
};


export type CompensationsReimbursablePayrollConceptArgs = {
  id: Scalars['Int'];
};


export type CompensationsReimbursablePayrollConceptsArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  payrollConceptIds?: InputMaybe<Scalars['Int']>;
  reimbursableTypes?: InputMaybe<Array<Scalars['String']>>;
};


export type CompensationsReimbursablePayrollConceptsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  payrollConceptIds?: InputMaybe<Scalars['Int']>;
  reimbursableTypes?: InputMaybe<Array<Scalars['String']>>;
  sortOrder?: InputMaybe<Sort>;
};


export type CompensationsVariableAmountStrategiesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  parentIds?: InputMaybe<Array<Scalars['Int']>>;
  parentType?: InputMaybe<Scalars['String']>;
};


export type CompensationsVariableAmountStrategiesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  parentIds?: InputMaybe<Array<Scalars['Int']>>;
  parentType?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type CompensationsVariableAmountStrategyArgs = {
  id: Scalars['Int'];
};

export type CompensationsMutations = {
  __typename?: 'compensationsMutations';
  aggregateCompensationsPayrollRunEmployeesCompensation: AggregateCompensationsPayrollRunEmployeesCompensationPayload;
  archiveCompensationsCycle: ArchiveCompensationsCyclePayload;
  bulkCreateCompensationsEmployeesCompensation: BulkCreateCompensationsEmployeesCompensationPayload;
  bulkCreateCompensationsFile: BulkCreateCompensationsFilePayload;
  bulkDeleteCompensationsEmployeesCompensation: BulkDeleteCompensationsEmployeesCompensationPayload;
  bulkUpdateCompensationsEmployeesCompensation: BulkUpdateCompensationsEmployeesCompensationPayload;
  completeCompensationsPayrollRun: CompleteCompensationsPayrollRunPayload;
  createCommentCompensationsPayrollRun: CreateCommentCompensationsPayrollRunPayload;
  createCompensationsCycle: CreateCompensationsCyclePayload;
  createCompensationsEmployeesCompensationsValidation: CreateCompensationsEmployeesCompensationsValidationPayload;
  createCompensationsPayrollConceptStatus: CreateCompensationsPayrollConceptStatusPayload;
  createWithItemsCompensationsPaymentRequest: CreateWithItemsCompensationsPaymentRequestPayload;
  dataUpdatedCompensationsPayrollRun: DataUpdatedCompensationsPayrollRunPayload;
  deleteCompensationsCycle: DeleteCompensationsCyclePayload;
  deleteCompensationsEmployeesCompensation: DeleteCompensationsEmployeesCompensationPayload;
  deleteCompensationsEmployeesCompensationsValidation: DeleteCompensationsEmployeesCompensationsValidationPayload;
  deleteCompensationsFile: DeleteCompensationsFilePayload;
  deleteCompensationsReimbursablePayrollConcept: DeleteCompensationsReimbursablePayrollConceptPayload;
  downloadCompensationsFile: DownloadCompensationsFilePayload;
  refreshCompensationsEmployeesCompensationsValidation: RefreshCompensationsEmployeesCompensationsValidationPayload;
  toggleCompensationsPayrollConceptStatus: ToggleCompensationsPayrollConceptStatusPayload;
  toggleLockCompensationsPayrollRun: ToggleLockCompensationsPayrollRunPayload;
  updateCompensationsCycle: UpdateCompensationsCyclePayload;
  upsertCompensationsCompensationSetting: UpsertCompensationsCompensationSettingPayload;
  upsertCompensationsEmployeesCompensation: UpsertCompensationsEmployeesCompensationPayload;
  upsertCompensationsReimbursablePayrollConcept: UpsertCompensationsReimbursablePayrollConceptPayload;
};


export type CompensationsMutationsAggregateCompensationsPayrollRunEmployeesCompensationArgs = {
  employeeId: Scalars['Int'];
  payrollConceptId: Scalars['Int'];
  payrollRunId: Scalars['Int'];
  resultType: CompensationsValueObjectsResultTypeEnum;
};


export type CompensationsMutationsArchiveCompensationsCycleArgs = {
  id: Scalars['Int'];
};


export type CompensationsMutationsBulkCreateCompensationsEmployeesCompensationArgs = {
  employeeId: Scalars['Int'];
  payrollRunId: Scalars['Int'];
  resultType: CompensationsValueObjectsResultTypeEnum;
  skipPayrollRunChecks: Scalars['Boolean'];
};


export type CompensationsMutationsBulkCreateCompensationsFileArgs = {
  companyId: Scalars['Int'];
  files: Array<BulkCreateCompensationsFileFilesInput>;
  payrollRunId: Scalars['Int'];
};


export type CompensationsMutationsBulkDeleteCompensationsEmployeesCompensationArgs = {
  ids: Array<Scalars['Int']>;
};


export type CompensationsMutationsBulkUpdateCompensationsEmployeesCompensationArgs = {
  employeeCompensations: Array<BulkUpdateCompensationsEmployeesCompensationEmployeeCompensationsInput>;
};


export type CompensationsMutationsCompleteCompensationsPayrollRunArgs = {
  id: Scalars['Int'];
};


export type CompensationsMutationsCreateCommentCompensationsPayrollRunArgs = {
  authorId: Scalars['Int'];
  companyId: Scalars['Int'];
  content: Scalars['String'];
  mentionedAccessIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceId: Scalars['Int'];
};


export type CompensationsMutationsCreateCompensationsCycleArgs = {
  companyId: Scalars['Int'];
  country?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  firstPayment?: InputMaybe<Scalars['ISO8601Date']>;
  peopleGroup?: InputMaybe<CreateCompensationsCyclePeopleGroupInput>;
  recurrence: Scalars['String'];
};


export type CompensationsMutationsCreateCompensationsEmployeesCompensationsValidationArgs = {
  payrollRunEmployeeCompensationId?: InputMaybe<Scalars['Int']>;
  sourceId: Scalars['Int'];
  sourceType: Scalars['String'];
  validationType: CompensationsValueObjectsEmployeeCompensationValidationTypeEnum;
};


export type CompensationsMutationsCreateCompensationsPayrollConceptStatusArgs = {
  companyId: Scalars['Int'];
  enabled: Scalars['Boolean'];
  payrollConceptId: Scalars['Int'];
};


export type CompensationsMutationsCreateWithItemsCompensationsPaymentRequestArgs = {
  dueDate: Scalars['ISO8601Date'];
  payrollRunId: Scalars['Int'];
};


export type CompensationsMutationsDataUpdatedCompensationsPayrollRunArgs = {
  id: Scalars['Int'];
  type?: InputMaybe<Scalars['String']>;
};


export type CompensationsMutationsDeleteCompensationsCycleArgs = {
  id: Scalars['Int'];
};


export type CompensationsMutationsDeleteCompensationsEmployeesCompensationArgs = {
  id: Scalars['Int'];
};


export type CompensationsMutationsDeleteCompensationsEmployeesCompensationsValidationArgs = {
  id: Scalars['Int'];
};


export type CompensationsMutationsDeleteCompensationsFileArgs = {
  fileId: Scalars['Int'];
};


export type CompensationsMutationsDeleteCompensationsReimbursablePayrollConceptArgs = {
  id: Scalars['Int'];
};


export type CompensationsMutationsDownloadCompensationsFileArgs = {
  id: Scalars['Int'];
};


export type CompensationsMutationsRefreshCompensationsEmployeesCompensationsValidationArgs = {
  payrollConceptIds?: InputMaybe<Array<Scalars['Int']>>;
  payrollRunId: Scalars['Int'];
};


export type CompensationsMutationsToggleCompensationsPayrollConceptStatusArgs = {
  id: Scalars['Int'];
};


export type CompensationsMutationsToggleLockCompensationsPayrollRunArgs = {
  id: Scalars['Int'];
  lock: Scalars['Boolean'];
};


export type CompensationsMutationsUpdateCompensationsCycleArgs = {
  country?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  firstPayment?: InputMaybe<Scalars['ISO8601Date']>;
  id: Scalars['Int'];
  recurrence?: InputMaybe<Scalars['String']>;
};


export type CompensationsMutationsUpsertCompensationsCompensationSettingArgs = {
  companyId: Scalars['Int'];
  pendingCompensationsAlertDay: Scalars['Int'];
};


export type CompensationsMutationsUpsertCompensationsEmployeesCompensationArgs = {
  amount?: InputMaybe<Scalars['Int']>;
  employeeId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  isOverwritten?: InputMaybe<Scalars['Boolean']>;
  payrollConceptId: Scalars['Int'];
  payrollRunId?: InputMaybe<Scalars['Int']>;
  sourceId?: InputMaybe<Scalars['Int']>;
  sourceType?: InputMaybe<Scalars['String']>;
  strategyType?: InputMaybe<Scalars['String']>;
  unitSymbol?: InputMaybe<Scalars['String']>;
  upperLimit?: InputMaybe<Scalars['Int']>;
};


export type CompensationsMutationsUpsertCompensationsReimbursablePayrollConceptArgs = {
  id?: InputMaybe<Scalars['Int']>;
  payrollConceptId: Scalars['Int'];
  reimbursableId: Scalars['Int'];
  reimbursableType: Scalars['String'];
};

export type Competencies = {
  __typename?: 'competencies';
  _policies: CompetenciesContextlessPolicies;
  assessment?: Maybe<CompetenciesAssessment>;
  assessmentGroup?: Maybe<CompetenciesAssessmentGroup>;
  /** @deprecated Please favor `assessmentGroupsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  assessmentGroups: Array<CompetenciesAssessmentGroup>;
  assessmentGroupsConnection: CompetenciesAssessmentGroupConnection;
  /** @deprecated Please favor `assessmentsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  assessments: Array<CompetenciesAssessment>;
  assessmentsConnection: CompetenciesAssessmentConnection;
  /** @deprecated Please favor `competenciesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  competencies: Array<CompetenciesCompetency>;
  competenciesConnection: CompetenciesCompetencyConnection;
  competency?: Maybe<CompetenciesCompetency>;
  competencyGroup?: Maybe<CompetenciesCompetencyGroup>;
  /** @deprecated Please favor `competencyGroupsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  competencyGroups: Array<CompetenciesCompetencyGroup>;
  competencyGroupsConnection: CompetenciesCompetencyGroupConnection;
  competencyJobCatalogNode?: Maybe<CompetenciesCompetencyJobCatalogNode>;
  /** @deprecated Please favor `competencyJobCatalogNodesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  competencyJobCatalogNodes: Array<CompetenciesCompetencyJobCatalogNode>;
  competencyJobCatalogNodesConnection: CompetenciesCompetencyJobCatalogNodeConnection;
  competencyLevel?: Maybe<CompetenciesCompetencyLevel>;
  /** @deprecated Please favor `competencyLevelsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  competencyLevels: Array<CompetenciesCompetencyLevel>;
  competencyLevelsConnection: CompetenciesCompetencyLevelConnection;
  /** @deprecated Please favor `factorialCompetenciesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  factorialCompetencies: Array<CompetenciesFactorialCompetency>;
  factorialCompetenciesConnection: CompetenciesFactorialCompetencyConnection;
  /** @deprecated Please favor `jobCatalogNodeSuggestionsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  jobCatalogNodeSuggestions: Array<CompetenciesJobCatalogNodeSuggestion>;
  jobCatalogNodeSuggestionsConnection: CompetenciesJobCatalogNodeSuggestionConnection;
  jobCatalogTreeSuggestion?: Maybe<CompetenciesJobCatalogTreeSuggestion>;
  /** @deprecated Please favor `jobCatalogTreeSuggestionsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  jobCatalogTreeSuggestions: Array<CompetenciesJobCatalogTreeSuggestion>;
  jobCatalogTreeSuggestionsConnection: CompetenciesJobCatalogTreeSuggestionConnection;
};


export type CompetenciesAssessmentArgs = {
  id: Scalars['String'];
};


export type CompetenciesAssessmentGroupArgs = {
  id: Scalars['String'];
};


export type CompetenciesAssessmentGroupsArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
  targetEmployeeIds?: InputMaybe<Array<Scalars['String']>>;
};


export type CompetenciesAssessmentGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<CompetenciesAssessmentGroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  targetEmployeeIds?: InputMaybe<Array<Scalars['String']>>;
};


export type CompetenciesAssessmentsArgs = {
  assessmentGroupIds?: InputMaybe<Array<Scalars['String']>>;
  ids?: InputMaybe<Array<Scalars['String']>>;
};


export type CompetenciesAssessmentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  assessmentGroupIds?: InputMaybe<Array<Scalars['String']>>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type CompetenciesCompetenciesArgs = {
  competencyGroupIds?: InputMaybe<Array<Scalars['String']>>;
  everyone?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  roleIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  withDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type CompetenciesCompetenciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  competencyGroupIds?: InputMaybe<Array<Scalars['String']>>;
  everyone?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CompetenciesCompetencyFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  roleIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  withDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type CompetenciesCompetencyArgs = {
  id: Scalars['Int'];
};


export type CompetenciesCompetencyGroupArgs = {
  id: Scalars['String'];
};


export type CompetenciesCompetencyGroupsArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
};


export type CompetenciesCompetencyGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<CompetenciesCompetencyGroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type CompetenciesCompetencyJobCatalogNodeArgs = {
  id: Scalars['Int'];
  nodeType: JobCatalogEnumsJobCatalogTreeNodeTypesEnum;
};


export type CompetenciesCompetencyJobCatalogNodesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  nodeType: JobCatalogEnumsJobCatalogTreeNodeTypesEnum;
};


export type CompetenciesCompetencyJobCatalogNodesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  nodeType: JobCatalogEnumsJobCatalogTreeNodeTypesEnum;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type CompetenciesCompetencyLevelArgs = {
  id: Scalars['Int'];
};


export type CompetenciesCompetencyLevelsArgs = {
  competencyIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type CompetenciesCompetencyLevelsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  competencyIds?: InputMaybe<Array<Scalars['Int']>>;
  filter?: InputMaybe<CompetenciesCompetencyLevelFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type CompetenciesFactorialCompetenciesArgs = {
  companyId: Scalars['Int'];
  excludeUuids?: Array<Scalars['String']>;
  search: Scalars['String'];
};


export type CompetenciesFactorialCompetenciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  excludeUuids?: Array<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search: Scalars['String'];
  sortOrder?: InputMaybe<Sort>;
};


export type CompetenciesJobCatalogNodeSuggestionsArgs = {
  companyId: Scalars['Int'];
  excludeUuids?: Array<Scalars['String']>;
  treeId: Scalars['Int'];
  treeNodeUuid: Scalars['String'];
};


export type CompetenciesJobCatalogNodeSuggestionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  excludeUuids?: Array<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  treeId: Scalars['Int'];
  treeNodeUuid: Scalars['String'];
};


export type CompetenciesJobCatalogTreeSuggestionArgs = {
  id: Scalars['Int'];
};


export type CompetenciesJobCatalogTreeSuggestionsArgs = {
  ids: Array<Scalars['Int']>;
};


export type CompetenciesJobCatalogTreeSuggestionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids: Array<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

export type CompetenciesMutations = {
  __typename?: 'competenciesMutations';
  appendCompetenciesCompetencyLevel: AppendCompetenciesCompetencyLevelPayload;
  bulkAssignToJobCatalogTreeCompetenciesCompetency: BulkAssignToJobCatalogTreeCompetenciesCompetencyPayload;
  bulkCreateCompetenciesCompetency: BulkCreateCompetenciesCompetencyPayload;
  bulkCreateCompetenciesCompetencyLevel: BulkCreateCompetenciesCompetencyLevelPayload;
  createCompetenciesCompetency: CreateCompetenciesCompetencyPayload;
  createCompetenciesCompetencyGroup: CreateCompetenciesCompetencyGroupPayload;
  deleteCompetenciesCompetency: DeleteCompetenciesCompetencyPayload;
  deleteCompetenciesCompetencyGroup: DeleteCompetenciesCompetencyGroupPayload;
  deleteCompetenciesCompetencyLevel: DeleteCompetenciesCompetencyLevelPayload;
  duplicateCompetenciesCompetency: DuplicateCompetenciesCompetencyPayload;
  reorderByCompetencyCompetenciesCompetencyLevel: ReorderByCompetencyCompetenciesCompetencyLevelPayload;
  searchCompetenciesFactorialCompetency: SearchCompetenciesFactorialCompetencyPayload;
  suggestCompetenciesJobCatalogTreeSuggestion: SuggestCompetenciesJobCatalogTreeSuggestionPayload;
  updateBasicInfoCompetenciesCompetencyLevel: UpdateBasicInfoCompetenciesCompetencyLevelPayload;
  updateCompetenciesCompetency: UpdateCompetenciesCompetencyPayload;
  updateCompetenciesCompetencyGroup: UpdateCompetenciesCompetencyGroupPayload;
};


export type CompetenciesMutationsAppendCompetenciesCompetencyLevelArgs = {
  competencyId: Scalars['Int'];
  description: Scalars['String'];
  name: Scalars['String'];
};


export type CompetenciesMutationsBulkAssignToJobCatalogTreeCompetenciesCompetencyArgs = {
  assignments: Array<BulkAssignToJobCatalogTreeCompetenciesCompetencyAssignmentsInput>;
  companyId: Scalars['Int'];
};


export type CompetenciesMutationsBulkCreateCompetenciesCompetencyArgs = {
  competencies: Array<BulkCreateCompetenciesCompetencyCompetenciesInput>;
};


export type CompetenciesMutationsBulkCreateCompetenciesCompetencyLevelArgs = {
  competencyId: Scalars['Int'];
  levels: Array<BulkCreateCompetenciesCompetencyLevelLevelsInput>;
};


export type CompetenciesMutationsCreateCompetenciesCompetencyArgs = {
  competencyGroupId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  everyone?: InputMaybe<Scalars['Boolean']>;
  factorialCompetencyUuid?: InputMaybe<Scalars['String']>;
  jobCatalogTreeNodeUuids?: InputMaybe<Array<Scalars['String']>>;
  levels?: InputMaybe<Array<CreateCompetenciesCompetencyLevelsInput>>;
  name: Scalars['String'];
  roleIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type CompetenciesMutationsCreateCompetenciesCompetencyGroupArgs = {
  companyId: Scalars['Int'];
  name: Scalars['String'];
};


export type CompetenciesMutationsDeleteCompetenciesCompetencyArgs = {
  id: Scalars['Int'];
};


export type CompetenciesMutationsDeleteCompetenciesCompetencyGroupArgs = {
  id: Scalars['String'];
};


export type CompetenciesMutationsDeleteCompetenciesCompetencyLevelArgs = {
  id: Scalars['Int'];
};


export type CompetenciesMutationsDuplicateCompetenciesCompetencyArgs = {
  id: Scalars['Int'];
};


export type CompetenciesMutationsReorderByCompetencyCompetenciesCompetencyLevelArgs = {
  competencyId: Scalars['Int'];
  levelPositions: Array<ReorderByCompetencyCompetenciesCompetencyLevelLevelPositionsInput>;
};


export type CompetenciesMutationsSearchCompetenciesFactorialCompetencyArgs = {
  companyId: Scalars['Int'];
  excludeUuids: Array<Scalars['String']>;
  search: Scalars['String'];
};


export type CompetenciesMutationsSuggestCompetenciesJobCatalogTreeSuggestionArgs = {
  id: Scalars['Int'];
};


export type CompetenciesMutationsUpdateBasicInfoCompetenciesCompetencyLevelArgs = {
  description: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
};


export type CompetenciesMutationsUpdateCompetenciesCompetencyArgs = {
  competencyGroupId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  everyone?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  roleIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type CompetenciesMutationsUpdateCompetenciesCompetencyGroupArgs = {
  id: Scalars['String'];
  name: Scalars['String'];
};

export type Complaints = {
  __typename?: 'complaints';
  _policies: ComplaintsContextlessPolicies;
  /** @deprecated Please favor `categoriesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  categories: Array<ComplaintsCategory>;
  categoriesConnection: ComplaintsCategoryConnection;
  category?: Maybe<ComplaintsCategory>;
  complaint?: Maybe<ComplaintsComplaint>;
  /** @deprecated Please favor `complaintsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  complaints: Array<ComplaintsComplaint>;
  complaintsConnection: ComplaintsComplaintConnection;
  message?: Maybe<ComplaintsMessage>;
  /** @deprecated Please favor `messageFilesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  messageFiles: Array<ComplaintsMessageFile>;
  messageFilesConnection: ComplaintsMessageFileConnection;
  /** @deprecated Please favor `messagesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  messages: Array<ComplaintsMessage>;
  messagesConnection: ComplaintsMessageConnection;
  /** @deprecated Please favor `notesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  notes: Array<ComplaintsNote>;
  notesConnection: ComplaintsNoteConnection;
};


export type ComplaintsCategoriesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  onlyEnabled?: Scalars['Boolean'];
};


export type ComplaintsCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyEnabled?: Scalars['Boolean'];
  sortOrder?: InputMaybe<Sort>;
};


export type ComplaintsCategoryArgs = {
  id: Scalars['Int'];
};


export type ComplaintsComplaintArgs = {
  id: Scalars['Int'];
};


export type ComplaintsComplaintsArgs = {
  id?: InputMaybe<Scalars['Int']>;
  identifier?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  showDeleted?: InputMaybe<Scalars['Boolean']>;
  statuses?: InputMaybe<Array<ComplaintsStatusEnum>>;
};


export type ComplaintsComplaintsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<ComplaintsComplaintFilter>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  identifier?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  showDeleted?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Sort>;
  statuses?: InputMaybe<Array<ComplaintsStatusEnum>>;
};


export type ComplaintsMessageArgs = {
  id: Scalars['Int'];
};


export type ComplaintsMessageFilesArgs = {
  complaintIds?: InputMaybe<Array<Scalars['Int']>>;
  messageIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type ComplaintsMessageFilesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  complaintIds?: InputMaybe<Array<Scalars['Int']>>;
  filter?: InputMaybe<ComplaintsMessageFileFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  messageIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ComplaintsMessagesArgs = {
  complaintsComplaintsIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type ComplaintsMessagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  complaintsComplaintsIds?: InputMaybe<Array<Scalars['Int']>>;
  filter?: InputMaybe<ComplaintsMessageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ComplaintsNotesArgs = {
  complaintIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type ComplaintsNotesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  complaintIds?: InputMaybe<Array<Scalars['Int']>>;
  filter?: InputMaybe<ComplaintsNoteFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

export type ComplaintsMutations = {
  __typename?: 'complaintsMutations';
  createComplaintsCategory: CreateComplaintsCategoryPayload;
  createComplaintsMessage: CreateComplaintsMessagePayload;
  createComplaintsNote: CreateComplaintsNotePayload;
  deleteComplaintsCategory: DeleteComplaintsCategoryPayload;
  deleteComplaintsNote: DeleteComplaintsNotePayload;
  softDeleteComplaintsComplaint: SoftDeleteComplaintsComplaintPayload;
  updateCategoryComplaintsComplaint: UpdateCategoryComplaintsComplaintPayload;
  updateComplaintsCategory: UpdateComplaintsCategoryPayload;
  updateComplaintsNote: UpdateComplaintsNotePayload;
  updateReadAtComplaintsComplaint: UpdateReadAtComplaintsComplaintPayload;
  updateStatusComplaintsComplaint: UpdateStatusComplaintsComplaintPayload;
};


export type ComplaintsMutationsCreateComplaintsCategoryArgs = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
};


export type ComplaintsMutationsCreateComplaintsMessageArgs = {
  blobIds?: InputMaybe<Array<Scalars['Int']>>;
  complaintId: Scalars['Int'];
  files?: InputMaybe<Array<Scalars['File']>>;
  isCompanyMessage: Scalars['Boolean'];
  text: Scalars['String'];
};


export type ComplaintsMutationsCreateComplaintsNoteArgs = {
  complaintId: Scalars['Int'];
  text: Scalars['String'];
};


export type ComplaintsMutationsDeleteComplaintsCategoryArgs = {
  id: Scalars['Int'];
};


export type ComplaintsMutationsDeleteComplaintsNoteArgs = {
  id: Scalars['Int'];
};


export type ComplaintsMutationsSoftDeleteComplaintsComplaintArgs = {
  id: Scalars['Int'];
};


export type ComplaintsMutationsUpdateCategoryComplaintsComplaintArgs = {
  categoryId?: InputMaybe<Scalars['Int']>;
  complaintId: Scalars['Int'];
};


export type ComplaintsMutationsUpdateComplaintsCategoryArgs = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
};


export type ComplaintsMutationsUpdateComplaintsNoteArgs = {
  id: Scalars['Int'];
  text: Scalars['String'];
};


export type ComplaintsMutationsUpdateReadAtComplaintsComplaintArgs = {
  complaintId: Scalars['Int'];
  readAt?: InputMaybe<Scalars['Boolean']>;
};


export type ComplaintsMutationsUpdateStatusComplaintsComplaintArgs = {
  complaintId: Scalars['Int'];
  status?: InputMaybe<Scalars['String']>;
};

export type Contracts = {
  __typename?: 'contracts';
  _policies: ContractsContextlessPolicies;
  additionalCompensation?: Maybe<ContractsAdditionalCompensation>;
  /** @deprecated Please favor `additionalCompensationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  additionalCompensations: Array<ContractsAdditionalCompensation>;
  additionalCompensationsConnection: ContractsAdditionalCompensationConnection;
  compensation?: Maybe<ContractsCompensation>;
  /** @deprecated Please favor `compensationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  compensations: Array<ContractsCompensation>;
  compensationsConnection: ContractsCompensationConnection;
  contract?: Maybe<ContractsContract>;
  /** @deprecated Please favor `contractActivityGroupsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  contractActivityGroups: Array<ContractsContractActivityGroup>;
  contractActivityGroupsConnection: ContractsContractActivityGroupConnection;
  contractStatus?: Maybe<ContractsContractStatus>;
  /** @deprecated Please favor `contractStatusesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  contractStatuses: Array<ContractsContractStatus>;
  contractStatusesConnection: ContractsContractStatusConnection;
  contractTemplate?: Maybe<ContractsContractTemplate>;
  /** @deprecated Please favor `contractTemplatesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  contractTemplates: Array<ContractsContractTemplate>;
  contractTemplatesConnection: ContractsContractTemplateConnection;
  contractVersion?: Maybe<ContractsContractVersion>;
  contractVersionChange?: Maybe<ContractsContractVersionChange>;
  /** @deprecated Please favor `contractVersionChangesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  contractVersionChanges: Array<ContractsContractVersionChange>;
  contractVersionChangesConnection: ContractsContractVersionChangeConnection;
  /** @deprecated Please favor `contractVersionMetaDataConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  contractVersionMetaData: Array<ContractsContractVersionMetaDatum>;
  contractVersionMetaDataConnection: ContractsContractVersionMetaDatumConnection;
  contractVersionRequest?: Maybe<ContractsContractVersionRequest>;
  /** @deprecated Please favor `contractVersionRequestsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  contractVersionRequests: Array<ContractsContractVersionRequest>;
  contractVersionRequestsConnection: ContractsContractVersionRequestConnection;
  /** @deprecated Please favor `contractVersionsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  contractVersions: Array<ContractsContractVersion>;
  contractVersionsConnection: ContractsContractVersionConnection;
  /** @deprecated Please favor `contractsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  contracts: Array<ContractsContract>;
  contractsConnection: ContractsContractConnection;
  /** @deprecated Please favor `employeeActivitiesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  employeeActivities: Array<ContractsEmployeeActivity>;
  employeeActivitiesConnection: ContractsEmployeeActivityConnection;
  /** @deprecated Please favor `fixedAmountStrategiesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  fixedAmountStrategies: Array<ContractsFixedAmountStrategy>;
  fixedAmountStrategiesConnection: ContractsFixedAmountStrategyConnection;
  fixedAmountStrategy?: Maybe<ContractsFixedAmountStrategy>;
  frenchContractType?: Maybe<ContractsFrenchContractType>;
  /** @deprecated Please favor `frenchContractTypesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  frenchContractTypes: Array<ContractsFrenchContractType>;
  frenchContractTypesConnection: ContractsFrenchContractTypeConnection;
  frenchLevel?: Maybe<ContractsFrenchLevel>;
  /** @deprecated Please favor `frenchLevelsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  frenchLevels: Array<ContractsFrenchLevel>;
  frenchLevelsConnection: ContractsFrenchLevelConnection;
  frenchMutual?: Maybe<ContractsFrenchMutual>;
  /** @deprecated Please favor `frenchMutualsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  frenchMutuals: Array<ContractsFrenchMutual>;
  frenchMutualsConnection: ContractsFrenchMutualConnection;
  /** @deprecated Please favor `frenchProfessionalCategoriesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  frenchProfessionalCategories: Array<ContractsFrenchProfessionalCategory>;
  frenchProfessionalCategoriesConnection: ContractsFrenchProfessionalCategoryConnection;
  frenchProfessionalCategory?: Maybe<ContractsFrenchProfessionalCategory>;
  frenchStep?: Maybe<ContractsFrenchStep>;
  /** @deprecated Please favor `frenchStepsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  frenchSteps: Array<ContractsFrenchStep>;
  frenchStepsConnection: ContractsFrenchStepConnection;
  frenchWorkType?: Maybe<ContractsFrenchWorkType>;
  /** @deprecated Please favor `frenchWorkTypesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  frenchWorkTypes: Array<ContractsFrenchWorkType>;
  frenchWorkTypesConnection: ContractsFrenchWorkTypeConnection;
  germanContractType?: Maybe<ContractsGermanContractType>;
  /** @deprecated Please favor `germanContractTypesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  germanContractTypes: Array<ContractsGermanContractType>;
  germanContractTypesConnection: ContractsGermanContractTypeConnection;
  /** @deprecated Please favor `headcountCategoricalsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  headcountCategoricals: Array<ContractsHeadcountCategorical>;
  headcountCategoricalsConnection: ContractsHeadcountCategoricalConnection;
  /** @deprecated Please favor `joinersConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  joiners: Array<ContractsJoiner>;
  joinersConnection: ContractsJoinerConnection;
  /** @deprecated Please favor `leaversConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  leavers: Array<ContractsLeaver>;
  leaversConnection: ContractsLeaverConnection;
  /** @deprecated Please favor `monthlyHeadcountsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  monthlyHeadcounts: Array<ContractsMonthlyHeadcount>;
  monthlyHeadcountsConnection: ContractsMonthlyHeadcountConnection;
  /** @deprecated Please favor `payrollPoliciesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  payrollPolicies: Array<ContractsPayrollPolicy>;
  payrollPoliciesConnection: ContractsPayrollPolicyConnection;
  payrollPolicy?: Maybe<ContractsPayrollPolicy>;
  /** @deprecated Please favor `payrollPolicyAssignmentEligibleEmployeesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  payrollPolicyAssignmentEligibleEmployees: Array<ContractsPayrollPolicyAssignmentEligibleEmployee>;
  payrollPolicyAssignmentEligibleEmployeesConnection: ContractsPayrollPolicyAssignmentEligibleEmployeeConnection;
  /** @deprecated Please favor `payrollPolicyEmployeesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  payrollPolicyEmployees: Array<ContractsPayrollPolicyEmployee>;
  payrollPolicyEmployeesConnection: ContractsPayrollPolicyEmployeeConnection;
  portugueseContractType?: Maybe<ContractsPortugueseContractType>;
  /** @deprecated Please favor `portugueseContractTypesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  portugueseContractTypes: Array<ContractsPortugueseContractType>;
  portugueseContractTypesConnection: ContractsPortugueseContractTypeConnection;
  /** @deprecated Please favor `promotionEmployeeOverviewsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  promotionEmployeeOverviews: Array<ContractsPromotionEmployeeOverview>;
  promotionEmployeeOverviewsConnection: ContractsPromotionEmployeeOverviewConnection;
  /** @deprecated Please favor `promotionStatsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  promotionStats: Array<ContractsPromotionStat>;
  promotionStatsConnection: ContractsPromotionStatConnection;
  /** @deprecated Please favor `promotionsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  promotions: Array<ContractsPromotion>;
  /** @deprecated Please favor `promotionsByMonthCategoricalsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  promotionsByMonthCategoricals: Array<ContractsPromotionsByMonthCategorical>;
  promotionsByMonthCategoricalsConnection: ContractsPromotionsByMonthCategoricalConnection;
  promotionsConnection: ContractsPromotionConnection;
  /** @deprecated Please favor `promotionsDatesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  promotionsDates: Array<ContractsPromotionsDate>;
  promotionsDatesConnection: ContractsPromotionsDateConnection;
  /** @deprecated Please favor `promotionsSingleValuesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  promotionsSingleValues: Array<ContractsPromotionsSingleValue>;
  promotionsSingleValuesConnection: ContractsPromotionsSingleValueConnection;
  /** @deprecated Please favor `referenceContractsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  referenceContracts: Array<ContractsReferenceContract>;
  referenceContractsConnection: ContractsReferenceContractConnection;
  spanishA3innuvaJobPosition?: Maybe<ContractsSpanishA3innuvaJobPosition>;
  /** @deprecated Please favor `spanishA3innuvaJobPositionsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  spanishA3innuvaJobPositions: Array<ContractsSpanishA3innuvaJobPosition>;
  spanishA3innuvaJobPositionsConnection: ContractsSpanishA3innuvaJobPositionConnection;
  spanishAgreementCode?: Maybe<ContractsSpanishAgreementCode>;
  /** @deprecated Please favor `spanishAgreementCodesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  spanishAgreementCodes: Array<ContractsSpanishAgreementCode>;
  spanishAgreementCodesConnection: ContractsSpanishAgreementCodeConnection;
  spanishClassification?: Maybe<ContractsSpanishClassification>;
  /** @deprecated Please favor `spanishClassificationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  spanishClassifications: Array<ContractsSpanishClassification>;
  spanishClassificationsConnection: ContractsSpanishClassificationConnection;
  spanishCnoOccupation?: Maybe<ContractsSpanishCnoOccupation>;
  /** @deprecated Please favor `spanishCnoOccupationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  spanishCnoOccupations: Array<ContractsSpanishCnoOccupation>;
  spanishCnoOccupationsConnection: ContractsSpanishCnoOccupationConnection;
  spanishContractType?: Maybe<ContractsSpanishContractType>;
  /** @deprecated Please favor `spanishContractTypesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  spanishContractTypes: Array<ContractsSpanishContractType>;
  spanishContractTypesConnection: ContractsSpanishContractTypeConnection;
  spanishContributionType?: Maybe<ContractsSpanishContributionType>;
  /** @deprecated Please favor `spanishContributionTypesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  spanishContributionTypes: Array<ContractsSpanishContributionType>;
  spanishContributionTypesConnection: ContractsSpanishContributionTypeConnection;
  spanishEducationLevel?: Maybe<ContractsSpanishEducationLevel>;
  /** @deprecated Please favor `spanishEducationLevelsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  spanishEducationLevels: Array<ContractsSpanishEducationLevel>;
  spanishEducationLevelsConnection: ContractsSpanishEducationLevelConnection;
  spanishOccupationCode?: Maybe<ContractsSpanishOccupationCode>;
  /** @deprecated Please favor `spanishOccupationCodesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  spanishOccupationCodes: Array<ContractsSpanishOccupationCode>;
  spanishOccupationCodesConnection: ContractsSpanishOccupationCodeConnection;
  /** @deprecated Please favor `spanishProfessionalCategoriesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  spanishProfessionalCategories: Array<ContractsSpanishProfessionalCategory>;
  spanishProfessionalCategoriesConnection: ContractsSpanishProfessionalCategoryConnection;
  spanishProfessionalCategory?: Maybe<ContractsSpanishProfessionalCategory>;
  spanishRegime?: Maybe<ContractsSpanishRegime>;
  /** @deprecated Please favor `spanishRegimesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  spanishRegimes: Array<ContractsSpanishRegime>;
  spanishRegimesConnection: ContractsSpanishRegimeConnection;
  spanishWorkingDayType?: Maybe<ContractsSpanishWorkingDayType>;
  /** @deprecated Please favor `spanishWorkingDayTypesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  spanishWorkingDayTypes: Array<ContractsSpanishWorkingDayType>;
  spanishWorkingDayTypesConnection: ContractsSpanishWorkingDayTypeConnection;
  /** @deprecated Please favor `taxonomiesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  taxonomies: Array<ContractsTaxonomy>;
  taxonomiesConnection: ContractsTaxonomyConnection;
  taxonomy?: Maybe<ContractsTaxonomy>;
  terminationType?: Maybe<ContractsTerminationType>;
  /** @deprecated Please favor `terminationTypesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  terminationTypes: Array<ContractsTerminationType>;
  terminationTypesConnection: ContractsTerminationTypeConnection;
  timeBalance?: Maybe<ContractsTimeBalance>;
  /** @deprecated Please favor `timeBalancesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  timeBalances: Array<ContractsTimeBalance>;
  timeBalancesConnection: ContractsTimeBalanceConnection;
  /** @deprecated Please favor `turnoverCategoricalsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  turnoverCategoricals: Array<ContractsTurnoverCategorical>;
  turnoverCategoricalsConnection: ContractsTurnoverCategoricalConnection;
  /** @deprecated Please favor `turnoverSingleValuesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  turnoverSingleValues: Array<ContractsTurnoverSingleValue>;
  turnoverSingleValuesConnection: ContractsTurnoverSingleValueConnection;
  /** @deprecated Please favor `variableAmountStrategiesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  variableAmountStrategies: Array<ContractsVariableAmountStrategy>;
  variableAmountStrategiesConnection: ContractsVariableAmountStrategyConnection;
  variableAmountStrategy?: Maybe<ContractsVariableAmountStrategy>;
  /** @deprecated Please favor `weeksPerMonthConfigurationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  weeksPerMonthConfigurations: Array<ContractsWeeksPerMonthConfiguration>;
  weeksPerMonthConfigurationsConnection: ContractsWeeksPerMonthConfigurationConnection;
};


export type ContractsAdditionalCompensationArgs = {
  id: Scalars['Int'];
};


export type ContractsAdditionalCompensationsArgs = {
  contractVersionIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type ContractsAdditionalCompensationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  contractVersionIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ContractsCompensationArgs = {
  id: Scalars['Int'];
};


export type ContractsCompensationsArgs = {
  calculation?: InputMaybe<Scalars['String']>;
  compensationTypes?: InputMaybe<Array<Scalars['String']>>;
  contractApprovalStatus?: InputMaybe<Array<Scalars['String']>>;
  contractVersionIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  notIds?: InputMaybe<Array<Scalars['Int']>>;
  occurringAt?: InputMaybe<Scalars['ISO8601Date']>;
  occurringFrequency?: InputMaybe<Scalars['String']>;
  occursAt?: InputMaybe<Scalars['ISO8601Date']>;
  payrollPolicyId?: InputMaybe<Scalars['Int']>;
  syncWithSupplements?: InputMaybe<Scalars['Boolean']>;
};


export type ContractsCompensationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  calculation?: InputMaybe<Scalars['String']>;
  compensationTypes?: InputMaybe<Array<Scalars['String']>>;
  contractApprovalStatus?: InputMaybe<Array<Scalars['String']>>;
  contractVersionIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  notIds?: InputMaybe<Array<Scalars['Int']>>;
  occurringAt?: InputMaybe<Scalars['ISO8601Date']>;
  occurringFrequency?: InputMaybe<Scalars['String']>;
  occursAt?: InputMaybe<Scalars['ISO8601Date']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  payrollPolicyId?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  syncWithSupplements?: InputMaybe<Scalars['Boolean']>;
};


export type ContractsContractArgs = {
  id: Scalars['Int'];
};


export type ContractsContractActivityGroupsArgs = {
  contractIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type ContractsContractActivityGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  contractIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ContractsContractStatusArgs = {
  id: Scalars['Int'];
};


export type ContractsContractStatusesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type ContractsContractStatusesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ContractsContractTemplateArgs = {
  id: Scalars['Int'];
};


export type ContractsContractTemplatesArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  contractVersionType?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type ContractsContractTemplatesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  contractVersionType?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ContractsContractVersionArgs = {
  id: Scalars['Int'];
};


export type ContractsContractVersionChangeArgs = {
  employeeId: Scalars['Int'];
  id: Scalars['Int'];
};


export type ContractsContractVersionChangesArgs = {
  employeeId: Scalars['Int'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type ContractsContractVersionChangesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ContractsContractVersionMetaDataArgs = {
  contractVersionIds: Array<Scalars['Int']>;
};


export type ContractsContractVersionMetaDataConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  contractVersionIds: Array<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ContractsContractVersionRequestArgs = {
  id: Scalars['Int'];
};


export type ContractsContractVersionRequestsArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  statuses?: InputMaybe<Array<Scalars['String']>>;
};


export type ContractsContractVersionRequestsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  statuses?: InputMaybe<Array<Scalars['String']>>;
};


export type ContractsContractVersionsArgs = {
  activeOn?: InputMaybe<Scalars['ISO8601Date']>;
  activeOrUpcomingOn?: InputMaybe<Scalars['ISO8601Date']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  contractIds?: InputMaybe<Array<Scalars['Int']>>;
  date?: InputMaybe<Scalars['ISO8601Date']>;
  effectiveOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  effectiveOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endsOnGt?: InputMaybe<Scalars['ISO8601Date']>;
  endsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  endsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  esEducationLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  forfaitJours?: Scalars['Boolean'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeDenormalizedData?: Scalars['Boolean'];
  jobCatalogTreeNodeUuids?: InputMaybe<Array<Scalars['String']>>;
  levelIds?: InputMaybe<Array<Scalars['Int']>>;
  startsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  startsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  upcomingOn?: InputMaybe<Scalars['ISO8601Date']>;
  withFallback?: Scalars['Boolean'];
  withHasPayrollPolicies?: InputMaybe<Scalars['Boolean']>;
  withMetadata?: Scalars['Boolean'];
  withOldestEffectiveOn?: InputMaybe<Scalars['Boolean']>;
  withPayroll?: InputMaybe<Scalars['Boolean']>;
  withSalaryAmount?: InputMaybe<Scalars['Boolean']>;
  withoutSalaryAmountOrSalaryFrequency?: InputMaybe<Scalars['Boolean']>;
};


export type ContractsContractVersionsConnectionArgs = {
  activeOn?: InputMaybe<Scalars['ISO8601Date']>;
  activeOrUpcomingOn?: InputMaybe<Scalars['ISO8601Date']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  contractIds?: InputMaybe<Array<Scalars['Int']>>;
  date?: InputMaybe<Scalars['ISO8601Date']>;
  effectiveOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  effectiveOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endsOnGt?: InputMaybe<Scalars['ISO8601Date']>;
  endsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  endsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  esEducationLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  filter?: InputMaybe<ContractsContractVersionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  forfaitJours?: Scalars['Boolean'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeDenormalizedData?: Scalars['Boolean'];
  jobCatalogTreeNodeUuids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  levelIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  startsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  upcomingOn?: InputMaybe<Scalars['ISO8601Date']>;
  withFallback?: Scalars['Boolean'];
  withHasPayrollPolicies?: InputMaybe<Scalars['Boolean']>;
  withMetadata?: Scalars['Boolean'];
  withOldestEffectiveOn?: InputMaybe<Scalars['Boolean']>;
  withPayroll?: InputMaybe<Scalars['Boolean']>;
  withSalaryAmount?: InputMaybe<Scalars['Boolean']>;
  withoutSalaryAmountOrSalaryFrequency?: InputMaybe<Scalars['Boolean']>;
};


export type ContractsContractsArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  startsOn?: InputMaybe<Scalars['ISO8601Date']>;
};


export type ContractsContractsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  filter?: InputMaybe<ContractsContractFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startsOn?: InputMaybe<Scalars['ISO8601Date']>;
};


export type ContractsEmployeeActivitiesArgs = {
  activityFrom?: InputMaybe<Scalars['ISO8601Date']>;
  activityTo?: InputMaybe<Scalars['ISO8601Date']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type ContractsEmployeeActivitiesConnectionArgs = {
  activityFrom?: InputMaybe<Scalars['ISO8601Date']>;
  activityTo?: InputMaybe<Scalars['ISO8601Date']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ContractsFixedAmountStrategiesArgs = {
  additionalCompensationIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type ContractsFixedAmountStrategiesConnectionArgs = {
  additionalCompensationIds?: InputMaybe<Array<Scalars['Int']>>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ContractsFixedAmountStrategyArgs = {
  id: Scalars['Int'];
};


export type ContractsFrenchContractTypeArgs = {
  id: Scalars['Int'];
};


export type ContractsFrenchContractTypesArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
};


export type ContractsFrenchContractTypesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ContractsFrenchLevelArgs = {
  id: Scalars['Int'];
};


export type ContractsFrenchLevelsArgs = {
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Scalars['String']>;
  legalEntityIds?: InputMaybe<Scalars['String']>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
};


export type ContractsFrenchLevelsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Scalars['String']>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ContractsFrenchMutualArgs = {
  id: Scalars['Int'];
};


export type ContractsFrenchMutualsArgs = {
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Scalars['String']>;
  legalEntityIds?: InputMaybe<Scalars['String']>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
};


export type ContractsFrenchMutualsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Scalars['String']>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ContractsFrenchProfessionalCategoriesArgs = {
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Scalars['String']>;
  legalEntityIds?: InputMaybe<Scalars['String']>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
};


export type ContractsFrenchProfessionalCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Scalars['String']>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ContractsFrenchProfessionalCategoryArgs = {
  id: Scalars['Int'];
};


export type ContractsFrenchStepArgs = {
  id: Scalars['Int'];
};


export type ContractsFrenchStepsArgs = {
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Scalars['String']>;
  legalEntityIds?: InputMaybe<Scalars['String']>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
};


export type ContractsFrenchStepsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Scalars['String']>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ContractsFrenchWorkTypeArgs = {
  id: Scalars['Int'];
};


export type ContractsFrenchWorkTypesArgs = {
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Scalars['String']>;
  legalEntityIds?: InputMaybe<Scalars['String']>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
};


export type ContractsFrenchWorkTypesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Scalars['String']>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ContractsGermanContractTypeArgs = {
  id: Scalars['Int'];
};


export type ContractsGermanContractTypesArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
};


export type ContractsGermanContractTypesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ContractsHeadcountCategoricalsArgs = {
  companyId: Scalars['Int'];
  costCenters?: InputMaybe<Array<Scalars['Int']>>;
  cycle: ReportsInsightsCycleEnum;
  employees?: InputMaybe<Array<Scalars['Int']>>;
  endDate: Scalars['ISO8601Date'];
  forFinancialWorkspace?: InputMaybe<Scalars['Boolean']>;
  genders?: InputMaybe<Array<Scalars['String']>>;
  legalEntities?: InputMaybe<Array<Scalars['Int']>>;
  managers?: InputMaybe<Array<Scalars['Int']>>;
  nationalities?: InputMaybe<Array<Scalars['String']>>;
  startDate: Scalars['ISO8601Date'];
  teams?: InputMaybe<Array<Scalars['Int']>>;
  withNoGender?: Scalars['Boolean'];
  withNoManager?: Scalars['Boolean'];
  withNoNationality?: Scalars['Boolean'];
  workplaces?: InputMaybe<Array<Scalars['Int']>>;
};


export type ContractsHeadcountCategoricalsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  costCenters?: InputMaybe<Array<Scalars['Int']>>;
  cycle: ReportsInsightsCycleEnum;
  employees?: InputMaybe<Array<Scalars['Int']>>;
  endDate: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  forFinancialWorkspace?: InputMaybe<Scalars['Boolean']>;
  genders?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntities?: InputMaybe<Array<Scalars['Int']>>;
  managers?: InputMaybe<Array<Scalars['Int']>>;
  nationalities?: InputMaybe<Array<Scalars['String']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startDate: Scalars['ISO8601Date'];
  teams?: InputMaybe<Array<Scalars['Int']>>;
  withNoGender?: Scalars['Boolean'];
  withNoManager?: Scalars['Boolean'];
  withNoNationality?: Scalars['Boolean'];
  workplaces?: InputMaybe<Array<Scalars['Int']>>;
};


export type ContractsJoinersArgs = {
  companyId: Scalars['Int'];
  costCenters?: InputMaybe<Array<Scalars['Int']>>;
  cycle: ReportsInsightsCycleEnum;
  employees?: InputMaybe<Array<Scalars['Int']>>;
  endDate: Scalars['ISO8601Date'];
  forFinancialWorkspace?: InputMaybe<Scalars['Boolean']>;
  genders?: InputMaybe<Array<Scalars['String']>>;
  legalEntities?: InputMaybe<Array<Scalars['Int']>>;
  managers?: InputMaybe<Array<Scalars['Int']>>;
  nationalities?: InputMaybe<Array<Scalars['String']>>;
  startDate: Scalars['ISO8601Date'];
  teams?: InputMaybe<Array<Scalars['Int']>>;
  withNoGender?: Scalars['Boolean'];
  withNoManager?: Scalars['Boolean'];
  withNoNationality?: Scalars['Boolean'];
  workplaces?: InputMaybe<Array<Scalars['Int']>>;
};


export type ContractsJoinersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  costCenters?: InputMaybe<Array<Scalars['Int']>>;
  cycle: ReportsInsightsCycleEnum;
  employees?: InputMaybe<Array<Scalars['Int']>>;
  endDate: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  forFinancialWorkspace?: InputMaybe<Scalars['Boolean']>;
  genders?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntities?: InputMaybe<Array<Scalars['Int']>>;
  managers?: InputMaybe<Array<Scalars['Int']>>;
  nationalities?: InputMaybe<Array<Scalars['String']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startDate: Scalars['ISO8601Date'];
  teams?: InputMaybe<Array<Scalars['Int']>>;
  withNoGender?: Scalars['Boolean'];
  withNoManager?: Scalars['Boolean'];
  withNoNationality?: Scalars['Boolean'];
  workplaces?: InputMaybe<Array<Scalars['Int']>>;
};


export type ContractsLeaversArgs = {
  companyId: Scalars['Int'];
  costCenters?: InputMaybe<Array<Scalars['Int']>>;
  cycle: ReportsInsightsCycleEnum;
  employees?: InputMaybe<Array<Scalars['Int']>>;
  endDate: Scalars['ISO8601Date'];
  forFinancialWorkspace?: InputMaybe<Scalars['Boolean']>;
  genders?: InputMaybe<Array<Scalars['String']>>;
  legalEntities?: InputMaybe<Array<Scalars['Int']>>;
  managers?: InputMaybe<Array<Scalars['Int']>>;
  nationalities?: InputMaybe<Array<Scalars['String']>>;
  startDate: Scalars['ISO8601Date'];
  teams?: InputMaybe<Array<Scalars['Int']>>;
  withNoGender?: Scalars['Boolean'];
  withNoManager?: Scalars['Boolean'];
  withNoNationality?: Scalars['Boolean'];
  workplaces?: InputMaybe<Array<Scalars['Int']>>;
};


export type ContractsLeaversConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  costCenters?: InputMaybe<Array<Scalars['Int']>>;
  cycle: ReportsInsightsCycleEnum;
  employees?: InputMaybe<Array<Scalars['Int']>>;
  endDate: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  forFinancialWorkspace?: InputMaybe<Scalars['Boolean']>;
  genders?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntities?: InputMaybe<Array<Scalars['Int']>>;
  managers?: InputMaybe<Array<Scalars['Int']>>;
  nationalities?: InputMaybe<Array<Scalars['String']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startDate: Scalars['ISO8601Date'];
  teams?: InputMaybe<Array<Scalars['Int']>>;
  withNoGender?: Scalars['Boolean'];
  withNoManager?: Scalars['Boolean'];
  withNoNationality?: Scalars['Boolean'];
  workplaces?: InputMaybe<Array<Scalars['Int']>>;
};


export type ContractsMonthlyHeadcountsArgs = {
  companyId: Scalars['Int'];
  costCenters?: InputMaybe<Array<Scalars['Int']>>;
  cycle: ReportsInsightsCycleEnum;
  employees?: InputMaybe<Array<Scalars['Int']>>;
  endDate: Scalars['ISO8601Date'];
  forFinancialWorkspace?: InputMaybe<Scalars['Boolean']>;
  genders?: InputMaybe<Array<Scalars['String']>>;
  legalEntities?: InputMaybe<Array<Scalars['Int']>>;
  managers?: InputMaybe<Array<Scalars['Int']>>;
  nationalities?: InputMaybe<Array<Scalars['String']>>;
  startDate: Scalars['ISO8601Date'];
  teams?: InputMaybe<Array<Scalars['Int']>>;
  withNoGender?: Scalars['Boolean'];
  withNoManager?: Scalars['Boolean'];
  withNoNationality?: Scalars['Boolean'];
  workplaces?: InputMaybe<Array<Scalars['Int']>>;
};


export type ContractsMonthlyHeadcountsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  costCenters?: InputMaybe<Array<Scalars['Int']>>;
  cycle: ReportsInsightsCycleEnum;
  employees?: InputMaybe<Array<Scalars['Int']>>;
  endDate: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  forFinancialWorkspace?: InputMaybe<Scalars['Boolean']>;
  genders?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntities?: InputMaybe<Array<Scalars['Int']>>;
  managers?: InputMaybe<Array<Scalars['Int']>>;
  nationalities?: InputMaybe<Array<Scalars['String']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startDate: Scalars['ISO8601Date'];
  teams?: InputMaybe<Array<Scalars['Int']>>;
  withNoGender?: Scalars['Boolean'];
  withNoManager?: Scalars['Boolean'];
  withNoNationality?: Scalars['Boolean'];
  workplaces?: InputMaybe<Array<Scalars['Int']>>;
};


export type ContractsPayrollPoliciesArgs = {
  contractVersionIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  payrollPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type ContractsPayrollPoliciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  contractVersionIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  payrollPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
};


export type ContractsPayrollPolicyArgs = {
  id: Scalars['Int'];
};


export type ContractsPayrollPolicyAssignmentEligibleEmployeesArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type ContractsPayrollPolicyAssignmentEligibleEmployeesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ContractsPayrollPolicyEmployeesArgs = {
  allowUpcomingContracts?: InputMaybe<Scalars['Boolean']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  fromDate?: InputMaybe<Scalars['ISO8601Date']>;
  onDate?: InputMaybe<Scalars['ISO8601Date']>;
  payrollPolicyId?: InputMaybe<Scalars['Int']>;
  payrollPolicyPeriodId?: InputMaybe<Scalars['Int']>;
  toDate?: InputMaybe<Scalars['ISO8601Date']>;
};


export type ContractsPayrollPolicyEmployeesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  allowUpcomingContracts?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  filter?: InputMaybe<ContractsPayrollPolicyEmployeeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  fromDate?: InputMaybe<Scalars['ISO8601Date']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onDate?: InputMaybe<Scalars['ISO8601Date']>;
  payrollPolicyId?: InputMaybe<Scalars['Int']>;
  payrollPolicyPeriodId?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  toDate?: InputMaybe<Scalars['ISO8601Date']>;
};


export type ContractsPortugueseContractTypeArgs = {
  id: Scalars['Int'];
};


export type ContractsPortugueseContractTypesArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
};


export type ContractsPortugueseContractTypesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ContractsPromotionEmployeeOverviewsArgs = {
  managerId: Scalars['Int'];
};


export type ContractsPromotionEmployeeOverviewsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  managerId: Scalars['Int'];
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ContractsPromotionStatsArgs = {
  companyId: Scalars['Int'];
  costCenters?: InputMaybe<Array<Scalars['Int']>>;
  cycle: ReportsInsightsCycleEnum;
  employees?: InputMaybe<Array<Scalars['Int']>>;
  endDate: Scalars['ISO8601Date'];
  forFinancialWorkspace?: InputMaybe<Scalars['Boolean']>;
  genders?: InputMaybe<Array<Scalars['String']>>;
  legalEntities?: InputMaybe<Array<Scalars['Int']>>;
  managers?: InputMaybe<Array<Scalars['Int']>>;
  nationalities?: InputMaybe<Array<Scalars['String']>>;
  startDate: Scalars['ISO8601Date'];
  teams?: InputMaybe<Array<Scalars['Int']>>;
  withNoGender?: Scalars['Boolean'];
  withNoManager?: Scalars['Boolean'];
  withNoNationality?: Scalars['Boolean'];
  workplaces?: InputMaybe<Array<Scalars['Int']>>;
};


export type ContractsPromotionStatsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  costCenters?: InputMaybe<Array<Scalars['Int']>>;
  cycle: ReportsInsightsCycleEnum;
  employees?: InputMaybe<Array<Scalars['Int']>>;
  endDate: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  forFinancialWorkspace?: InputMaybe<Scalars['Boolean']>;
  genders?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntities?: InputMaybe<Array<Scalars['Int']>>;
  managers?: InputMaybe<Array<Scalars['Int']>>;
  nationalities?: InputMaybe<Array<Scalars['String']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startDate: Scalars['ISO8601Date'];
  teams?: InputMaybe<Array<Scalars['Int']>>;
  withNoGender?: Scalars['Boolean'];
  withNoManager?: Scalars['Boolean'];
  withNoNationality?: Scalars['Boolean'];
  workplaces?: InputMaybe<Array<Scalars['Int']>>;
};


export type ContractsPromotionsArgs = {
  companyId: Scalars['Int'];
  costCenters?: InputMaybe<Array<Scalars['Int']>>;
  cycle: ReportsInsightsCycleEnum;
  employees?: InputMaybe<Array<Scalars['Int']>>;
  endDate: Scalars['ISO8601Date'];
  forFinancialWorkspace?: InputMaybe<Scalars['Boolean']>;
  genders?: InputMaybe<Array<Scalars['String']>>;
  legalEntities?: InputMaybe<Array<Scalars['Int']>>;
  managers?: InputMaybe<Array<Scalars['Int']>>;
  nationalities?: InputMaybe<Array<Scalars['String']>>;
  startDate: Scalars['ISO8601Date'];
  teams?: InputMaybe<Array<Scalars['Int']>>;
  withNoGender?: Scalars['Boolean'];
  withNoManager?: Scalars['Boolean'];
  withNoNationality?: Scalars['Boolean'];
  workplaces?: InputMaybe<Array<Scalars['Int']>>;
};


export type ContractsPromotionsByMonthCategoricalsArgs = {
  companyId: Scalars['Int'];
  costCenters?: InputMaybe<Array<Scalars['Int']>>;
  cycle: ReportsInsightsCycleEnum;
  employees?: InputMaybe<Array<Scalars['Int']>>;
  endDate: Scalars['ISO8601Date'];
  forFinancialWorkspace?: InputMaybe<Scalars['Boolean']>;
  genders?: InputMaybe<Array<Scalars['String']>>;
  legalEntities?: InputMaybe<Array<Scalars['Int']>>;
  managers?: InputMaybe<Array<Scalars['Int']>>;
  nationalities?: InputMaybe<Array<Scalars['String']>>;
  startDate: Scalars['ISO8601Date'];
  teams?: InputMaybe<Array<Scalars['Int']>>;
  withNoGender?: Scalars['Boolean'];
  withNoManager?: Scalars['Boolean'];
  withNoNationality?: Scalars['Boolean'];
  workplaces?: InputMaybe<Array<Scalars['Int']>>;
};


export type ContractsPromotionsByMonthCategoricalsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  costCenters?: InputMaybe<Array<Scalars['Int']>>;
  cycle: ReportsInsightsCycleEnum;
  employees?: InputMaybe<Array<Scalars['Int']>>;
  endDate: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  forFinancialWorkspace?: InputMaybe<Scalars['Boolean']>;
  genders?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntities?: InputMaybe<Array<Scalars['Int']>>;
  managers?: InputMaybe<Array<Scalars['Int']>>;
  nationalities?: InputMaybe<Array<Scalars['String']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startDate: Scalars['ISO8601Date'];
  teams?: InputMaybe<Array<Scalars['Int']>>;
  withNoGender?: Scalars['Boolean'];
  withNoManager?: Scalars['Boolean'];
  withNoNationality?: Scalars['Boolean'];
  workplaces?: InputMaybe<Array<Scalars['Int']>>;
};


export type ContractsPromotionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  costCenters?: InputMaybe<Array<Scalars['Int']>>;
  cycle: ReportsInsightsCycleEnum;
  employees?: InputMaybe<Array<Scalars['Int']>>;
  endDate: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  forFinancialWorkspace?: InputMaybe<Scalars['Boolean']>;
  genders?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntities?: InputMaybe<Array<Scalars['Int']>>;
  managers?: InputMaybe<Array<Scalars['Int']>>;
  nationalities?: InputMaybe<Array<Scalars['String']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startDate: Scalars['ISO8601Date'];
  teams?: InputMaybe<Array<Scalars['Int']>>;
  withNoGender?: Scalars['Boolean'];
  withNoManager?: Scalars['Boolean'];
  withNoNationality?: Scalars['Boolean'];
  workplaces?: InputMaybe<Array<Scalars['Int']>>;
};


export type ContractsPromotionsDatesArgs = {
  companyId: Scalars['Int'];
  costCenters?: InputMaybe<Array<Scalars['Int']>>;
  cycle: ReportsInsightsCycleEnum;
  employees?: InputMaybe<Array<Scalars['Int']>>;
  endDate: Scalars['ISO8601Date'];
  forFinancialWorkspace?: InputMaybe<Scalars['Boolean']>;
  genders?: InputMaybe<Array<Scalars['String']>>;
  legalEntities?: InputMaybe<Array<Scalars['Int']>>;
  managers?: InputMaybe<Array<Scalars['Int']>>;
  nationalities?: InputMaybe<Array<Scalars['String']>>;
  startDate: Scalars['ISO8601Date'];
  teams?: InputMaybe<Array<Scalars['Int']>>;
  withNoGender?: Scalars['Boolean'];
  withNoManager?: Scalars['Boolean'];
  withNoNationality?: Scalars['Boolean'];
  workplaces?: InputMaybe<Array<Scalars['Int']>>;
};


export type ContractsPromotionsDatesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  costCenters?: InputMaybe<Array<Scalars['Int']>>;
  cycle: ReportsInsightsCycleEnum;
  employees?: InputMaybe<Array<Scalars['Int']>>;
  endDate: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  forFinancialWorkspace?: InputMaybe<Scalars['Boolean']>;
  genders?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntities?: InputMaybe<Array<Scalars['Int']>>;
  managers?: InputMaybe<Array<Scalars['Int']>>;
  nationalities?: InputMaybe<Array<Scalars['String']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startDate: Scalars['ISO8601Date'];
  teams?: InputMaybe<Array<Scalars['Int']>>;
  withNoGender?: Scalars['Boolean'];
  withNoManager?: Scalars['Boolean'];
  withNoNationality?: Scalars['Boolean'];
  workplaces?: InputMaybe<Array<Scalars['Int']>>;
};


export type ContractsPromotionsSingleValuesArgs = {
  companyId: Scalars['Int'];
  costCenters?: InputMaybe<Array<Scalars['Int']>>;
  cycle: ReportsInsightsCycleEnum;
  employees?: InputMaybe<Array<Scalars['Int']>>;
  endDate: Scalars['ISO8601Date'];
  forFinancialWorkspace?: InputMaybe<Scalars['Boolean']>;
  genders?: InputMaybe<Array<Scalars['String']>>;
  legalEntities?: InputMaybe<Array<Scalars['Int']>>;
  managers?: InputMaybe<Array<Scalars['Int']>>;
  nationalities?: InputMaybe<Array<Scalars['String']>>;
  startDate: Scalars['ISO8601Date'];
  teams?: InputMaybe<Array<Scalars['Int']>>;
  withNoGender?: Scalars['Boolean'];
  withNoManager?: Scalars['Boolean'];
  withNoNationality?: Scalars['Boolean'];
  workplaces?: InputMaybe<Array<Scalars['Int']>>;
};


export type ContractsPromotionsSingleValuesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  costCenters?: InputMaybe<Array<Scalars['Int']>>;
  cycle: ReportsInsightsCycleEnum;
  employees?: InputMaybe<Array<Scalars['Int']>>;
  endDate: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  forFinancialWorkspace?: InputMaybe<Scalars['Boolean']>;
  genders?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntities?: InputMaybe<Array<Scalars['Int']>>;
  managers?: InputMaybe<Array<Scalars['Int']>>;
  nationalities?: InputMaybe<Array<Scalars['String']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startDate: Scalars['ISO8601Date'];
  teams?: InputMaybe<Array<Scalars['Int']>>;
  withNoGender?: Scalars['Boolean'];
  withNoManager?: Scalars['Boolean'];
  withNoNationality?: Scalars['Boolean'];
  workplaces?: InputMaybe<Array<Scalars['Int']>>;
};


export type ContractsReferenceContractsArgs = {
  activeBetween?: InputMaybe<ReferenceContractsActiveBetweenInput>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  effectiveOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endsOnGt?: InputMaybe<Scalars['ISO8601Date']>;
  endsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  frContractTypeIds?: InputMaybe<Array<Scalars['Int']>>;
  frMutualIds?: InputMaybe<Array<Scalars['Int']>>;
  frWorkTypeIds?: InputMaybe<Array<Scalars['Int']>>;
  includeDenormalizedData?: Scalars['Boolean'];
  includeEducationLevel?: Scalars['Boolean'];
  jobCatalogLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  jobCatalogTreeNodeUuids?: InputMaybe<Array<Scalars['String']>>;
  onDate?: InputMaybe<Scalars['ISO8601Date']>;
  payrollPolicyId?: InputMaybe<Scalars['Int']>;
  startsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  startsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedBecauseRelatedModels?: InputMaybe<Scalars['Boolean']>;
  withPayroll?: InputMaybe<Scalars['Boolean']>;
  withTranslations?: InputMaybe<Scalars['Boolean']>;
};


export type ContractsReferenceContractsConnectionArgs = {
  activeBetween?: InputMaybe<ReferenceContractsActiveBetweenInput>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  effectiveOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endsOnGt?: InputMaybe<Scalars['ISO8601Date']>;
  endsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  first?: InputMaybe<Scalars['Int']>;
  frContractTypeIds?: InputMaybe<Array<Scalars['Int']>>;
  frMutualIds?: InputMaybe<Array<Scalars['Int']>>;
  frWorkTypeIds?: InputMaybe<Array<Scalars['Int']>>;
  includeDenormalizedData?: Scalars['Boolean'];
  includeEducationLevel?: Scalars['Boolean'];
  jobCatalogLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  jobCatalogTreeNodeUuids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onDate?: InputMaybe<Scalars['ISO8601Date']>;
  payrollPolicyId?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  startsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedBecauseRelatedModels?: InputMaybe<Scalars['Boolean']>;
  withPayroll?: InputMaybe<Scalars['Boolean']>;
  withTranslations?: InputMaybe<Scalars['Boolean']>;
};


export type ContractsSpanishA3innuvaJobPositionArgs = {
  id: Scalars['Int'];
};


export type ContractsSpanishA3innuvaJobPositionsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type ContractsSpanishA3innuvaJobPositionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ContractsSpanishAgreementCodeArgs = {
  id: Scalars['Int'];
};


export type ContractsSpanishAgreementCodesArgs = {
  ids?: InputMaybe<Scalars['String']>;
  legalEntityIds?: InputMaybe<Scalars['String']>;
};


export type ContractsSpanishAgreementCodesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ContractsSpanishClassificationArgs = {
  id: Scalars['Int'];
};


export type ContractsSpanishClassificationsArgs = {
  ids?: InputMaybe<Scalars['String']>;
  legalEntityIds?: InputMaybe<Scalars['String']>;
};


export type ContractsSpanishClassificationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ContractsSpanishCnoOccupationArgs = {
  id: Scalars['Int'];
};


export type ContractsSpanishCnoOccupationsArgs = {
  ids?: InputMaybe<Scalars['String']>;
  legalEntityIds?: InputMaybe<Scalars['String']>;
};


export type ContractsSpanishCnoOccupationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ContractsSpanishContractTypeArgs = {
  id: Scalars['Int'];
};


export type ContractsSpanishContractTypesArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
};


export type ContractsSpanishContractTypesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ContractsSpanishContributionTypeArgs = {
  id: Scalars['Int'];
};


export type ContractsSpanishContributionTypesArgs = {
  ids?: InputMaybe<Scalars['String']>;
  legalEntityIds?: InputMaybe<Scalars['String']>;
};


export type ContractsSpanishContributionTypesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ContractsSpanishEducationLevelArgs = {
  id: Scalars['Int'];
};


export type ContractsSpanishEducationLevelsArgs = {
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
};


export type ContractsSpanishEducationLevelsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ContractsSpanishOccupationCodeArgs = {
  id: Scalars['Int'];
};


export type ContractsSpanishOccupationCodesArgs = {
  ids?: InputMaybe<Scalars['String']>;
  legalEntityIds?: InputMaybe<Scalars['String']>;
};


export type ContractsSpanishOccupationCodesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ContractsSpanishProfessionalCategoriesArgs = {
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
  withArchived?: Scalars['Boolean'];
};


export type ContractsSpanishProfessionalCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  withArchived?: Scalars['Boolean'];
};


export type ContractsSpanishProfessionalCategoryArgs = {
  id: Scalars['Int'];
};


export type ContractsSpanishRegimeArgs = {
  id: Scalars['Int'];
};


export type ContractsSpanishRegimesArgs = {
  ids?: InputMaybe<Scalars['String']>;
  legalEntityIds?: InputMaybe<Scalars['String']>;
};


export type ContractsSpanishRegimesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ContractsSpanishWorkingDayTypeArgs = {
  id: Scalars['Int'];
};


export type ContractsSpanishWorkingDayTypesArgs = {
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Scalars['String']>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
};


export type ContractsSpanishWorkingDayTypesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Scalars['String']>;
  notHidden?: InputMaybe<Scalars['Boolean']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ContractsTaxonomiesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type ContractsTaxonomiesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ContractsTaxonomyArgs = {
  id: Scalars['Int'];
};


export type ContractsTerminationTypeArgs = {
  id: Scalars['Int'];
};


export type ContractsTerminationTypesArgs = {
  country?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type ContractsTerminationTypesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ContractsTimeBalanceArgs = {
  dateFrom: Scalars['ISO8601Date'];
  dateTo: Scalars['ISO8601Date'];
  employeeIds: Array<Scalars['Int']>;
  id: Scalars['Int'];
};


export type ContractsTimeBalancesArgs = {
  dateFrom: Scalars['ISO8601Date'];
  dateTo: Scalars['ISO8601Date'];
  employeeIds: Array<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type ContractsTimeBalancesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  dateFrom: Scalars['ISO8601Date'];
  dateTo: Scalars['ISO8601Date'];
  employeeIds: Array<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ContractsTurnoverCategoricalsArgs = {
  companyId: Scalars['Int'];
  costCenters?: InputMaybe<Array<Scalars['Int']>>;
  cycle: ReportsInsightsCycleEnum;
  employees?: InputMaybe<Array<Scalars['Int']>>;
  endDate: Scalars['ISO8601Date'];
  forFinancialWorkspace?: InputMaybe<Scalars['Boolean']>;
  genders?: InputMaybe<Array<Scalars['String']>>;
  legalEntities?: InputMaybe<Array<Scalars['Int']>>;
  managers?: InputMaybe<Array<Scalars['Int']>>;
  nationalities?: InputMaybe<Array<Scalars['String']>>;
  startDate: Scalars['ISO8601Date'];
  teams?: InputMaybe<Array<Scalars['Int']>>;
  withNoGender?: Scalars['Boolean'];
  withNoManager?: Scalars['Boolean'];
  withNoNationality?: Scalars['Boolean'];
  workplaces?: InputMaybe<Array<Scalars['Int']>>;
};


export type ContractsTurnoverCategoricalsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  costCenters?: InputMaybe<Array<Scalars['Int']>>;
  cycle: ReportsInsightsCycleEnum;
  employees?: InputMaybe<Array<Scalars['Int']>>;
  endDate: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  forFinancialWorkspace?: InputMaybe<Scalars['Boolean']>;
  genders?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntities?: InputMaybe<Array<Scalars['Int']>>;
  managers?: InputMaybe<Array<Scalars['Int']>>;
  nationalities?: InputMaybe<Array<Scalars['String']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startDate: Scalars['ISO8601Date'];
  teams?: InputMaybe<Array<Scalars['Int']>>;
  withNoGender?: Scalars['Boolean'];
  withNoManager?: Scalars['Boolean'];
  withNoNationality?: Scalars['Boolean'];
  workplaces?: InputMaybe<Array<Scalars['Int']>>;
};


export type ContractsTurnoverSingleValuesArgs = {
  companyId: Scalars['Int'];
  costCenters?: InputMaybe<Array<Scalars['Int']>>;
  cycle: ReportsInsightsCycleEnum;
  employees?: InputMaybe<Array<Scalars['Int']>>;
  endDate: Scalars['ISO8601Date'];
  forFinancialWorkspace?: InputMaybe<Scalars['Boolean']>;
  genders?: InputMaybe<Array<Scalars['String']>>;
  legalEntities?: InputMaybe<Array<Scalars['Int']>>;
  managers?: InputMaybe<Array<Scalars['Int']>>;
  nationalities?: InputMaybe<Array<Scalars['String']>>;
  startDate: Scalars['ISO8601Date'];
  teams?: InputMaybe<Array<Scalars['Int']>>;
  withNoGender?: Scalars['Boolean'];
  withNoManager?: Scalars['Boolean'];
  withNoNationality?: Scalars['Boolean'];
  workplaces?: InputMaybe<Array<Scalars['Int']>>;
};


export type ContractsTurnoverSingleValuesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  costCenters?: InputMaybe<Array<Scalars['Int']>>;
  cycle: ReportsInsightsCycleEnum;
  employees?: InputMaybe<Array<Scalars['Int']>>;
  endDate: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  forFinancialWorkspace?: InputMaybe<Scalars['Boolean']>;
  genders?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntities?: InputMaybe<Array<Scalars['Int']>>;
  managers?: InputMaybe<Array<Scalars['Int']>>;
  nationalities?: InputMaybe<Array<Scalars['String']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startDate: Scalars['ISO8601Date'];
  teams?: InputMaybe<Array<Scalars['Int']>>;
  withNoGender?: Scalars['Boolean'];
  withNoManager?: Scalars['Boolean'];
  withNoNationality?: Scalars['Boolean'];
  workplaces?: InputMaybe<Array<Scalars['Int']>>;
};


export type ContractsVariableAmountStrategiesArgs = {
  additionalCompensationIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type ContractsVariableAmountStrategiesConnectionArgs = {
  additionalCompensationIds?: InputMaybe<Array<Scalars['Int']>>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ContractsVariableAmountStrategyArgs = {
  id: Scalars['Int'];
};


export type ContractsWeeksPerMonthConfigurationsArgs = {
  legalEntitiesIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type ContractsWeeksPerMonthConfigurationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntitiesIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

export type ContractsImporter = {
  __typename?: 'contractsImporter';
  _policies: ContractsImporterContextlessPolicies;
};

export type ContractsMutations = {
  __typename?: 'contractsMutations';
  approveContractsContractVersionRequest: ApproveContractsContractVersionRequestPayload;
  archiveContractsFranceFrenchContractType: ArchiveContractsFranceFrenchContractTypePayload;
  archiveContractsFranceFrenchLevel: ArchiveContractsFranceFrenchLevelPayload;
  archiveContractsFranceFrenchMutual: ArchiveContractsFranceFrenchMutualPayload;
  archiveContractsFranceFrenchProfessionalCategory: ArchiveContractsFranceFrenchProfessionalCategoryPayload;
  archiveContractsFranceFrenchStep: ArchiveContractsFranceFrenchStepPayload;
  archiveContractsFranceFrenchWorkType: ArchiveContractsFranceFrenchWorkTypePayload;
  archiveContractsGermanyGermanContractType: ArchiveContractsGermanyGermanContractTypePayload;
  archiveContractsPortugalPortugueseContractType: ArchiveContractsPortugalPortugueseContractTypePayload;
  archiveContractsSpainSpanishContractType: ArchiveContractsSpainSpanishContractTypePayload;
  archiveContractsSpainSpanishEducationLevel: ArchiveContractsSpainSpanishEducationLevelPayload;
  archiveContractsSpainSpanishProfessionalCategory: ArchiveContractsSpainSpanishProfessionalCategoryPayload;
  archiveContractsSpainSpanishWorkingDayType: ArchiveContractsSpainSpanishWorkingDayTypePayload;
  archiveContractsTaxonomy: ArchiveContractsTaxonomyPayload;
  bulkAssignContractsPayrollPolicy: BulkAssignContractsPayrollPolicyPayload;
  bulkCreateContractsAdditionalCompensation: BulkCreateContractsAdditionalCompensationPayload;
  bulkCreateContractsTaxonomy: BulkCreateContractsTaxonomyPayload;
  createByFixContractsCompensationsRollout: CreateByFixContractsCompensationsRolloutPayload;
  createContractsCompensation: CreateContractsCompensationPayload;
  createContractsContractTemplate: CreateContractsContractTemplatePayload;
  createContractsContractVersion: CreateContractsContractVersionPayload;
  createContractsFranceFrenchContractType: CreateContractsFranceFrenchContractTypePayload;
  createContractsFranceFrenchLevel: CreateContractsFranceFrenchLevelPayload;
  createContractsFranceFrenchMutual: CreateContractsFranceFrenchMutualPayload;
  createContractsFranceFrenchProfessionalCategory: CreateContractsFranceFrenchProfessionalCategoryPayload;
  createContractsFranceFrenchStep: CreateContractsFranceFrenchStepPayload;
  createContractsFranceFrenchWorkType: CreateContractsFranceFrenchWorkTypePayload;
  createContractsGermanyGermanContractType: CreateContractsGermanyGermanContractTypePayload;
  createContractsPayrollPolicy: CreateContractsPayrollPolicyPayload;
  createContractsPortugalPortugueseContractType: CreateContractsPortugalPortugueseContractTypePayload;
  createContractsSpainSpanishContractType: CreateContractsSpainSpanishContractTypePayload;
  createContractsSpainSpanishEducationLevel: CreateContractsSpainSpanishEducationLevelPayload;
  createContractsSpainSpanishProfessionalCategory: CreateContractsSpainSpanishProfessionalCategoryPayload;
  createContractsSpainSpanishWorkingDayType: CreateContractsSpainSpanishWorkingDayTypePayload;
  createContractsTaxonomy: CreateContractsTaxonomyPayload;
  createContractsTerminationType: CreateContractsTerminationTypePayload;
  createContractsWeeksPerMonthConfiguration: CreateContractsWeeksPerMonthConfigurationPayload;
  createPromoteRequestContractsContractVersionRequest: CreatePromoteRequestContractsContractVersionRequestPayload;
  createWithPayrollPolicyContractsContractVersion: CreateWithPayrollPolicyContractsContractVersionPayload;
  deleteContractsCompensation: DeleteContractsCompensationPayload;
  deleteContractsContractVersion: DeleteContractsContractVersionPayload;
  deleteContractsContractVersionRequest: DeleteContractsContractVersionRequestPayload;
  fixContractsContractVersion: FixContractsContractVersionPayload;
  pauseContractsContract: PauseContractsContractPayload;
  promoteContractsContractVersion: PromoteContractsContractVersionPayload;
  rejectContractsContractVersionRequest: RejectContractsContractVersionRequestPayload;
  removeContractsPayrollPolicy: RemoveContractsPayrollPolicyPayload;
  resumeContractsContract: ResumeContractsContractPayload;
  updateContractsCompensation: UpdateContractsCompensationPayload;
  updateContractsContractVersion: UpdateContractsContractVersionPayload;
  updateContractsContractVersionFlow: UpdateContractsContractVersionFlowPayload;
  updateContractsTerminationType: UpdateContractsTerminationTypePayload;
  updateContractsWeeksPerMonthConfiguration: UpdateContractsWeeksPerMonthConfigurationPayload;
  upsertContractsWeeksPerMonthConfiguration: UpsertContractsWeeksPerMonthConfigurationPayload;
};


export type ContractsMutationsApproveContractsContractVersionRequestArgs = {
  id: Scalars['Int'];
};


export type ContractsMutationsArchiveContractsFranceFrenchContractTypeArgs = {
  archived: Scalars['Boolean'];
  id: Scalars['Int'];
};


export type ContractsMutationsArchiveContractsFranceFrenchLevelArgs = {
  archived: Scalars['Boolean'];
  id: Scalars['Int'];
};


export type ContractsMutationsArchiveContractsFranceFrenchMutualArgs = {
  archived: Scalars['Boolean'];
  id: Scalars['Int'];
};


export type ContractsMutationsArchiveContractsFranceFrenchProfessionalCategoryArgs = {
  archived: Scalars['Boolean'];
  id: Scalars['Int'];
};


export type ContractsMutationsArchiveContractsFranceFrenchStepArgs = {
  archived: Scalars['Boolean'];
  id: Scalars['Int'];
};


export type ContractsMutationsArchiveContractsFranceFrenchWorkTypeArgs = {
  archived: Scalars['Boolean'];
  id: Scalars['Int'];
};


export type ContractsMutationsArchiveContractsGermanyGermanContractTypeArgs = {
  archived: Scalars['Boolean'];
  id: Scalars['Int'];
};


export type ContractsMutationsArchiveContractsPortugalPortugueseContractTypeArgs = {
  archived: Scalars['Boolean'];
  id: Scalars['Int'];
};


export type ContractsMutationsArchiveContractsSpainSpanishContractTypeArgs = {
  archived: Scalars['Boolean'];
  id: Scalars['Int'];
};


export type ContractsMutationsArchiveContractsSpainSpanishEducationLevelArgs = {
  archived: Scalars['Boolean'];
  id: Scalars['Int'];
};


export type ContractsMutationsArchiveContractsSpainSpanishProfessionalCategoryArgs = {
  archived: Scalars['Boolean'];
  id: Scalars['Int'];
};


export type ContractsMutationsArchiveContractsSpainSpanishWorkingDayTypeArgs = {
  archived: Scalars['Boolean'];
  id: Scalars['Int'];
};


export type ContractsMutationsArchiveContractsTaxonomyArgs = {
  archived: Scalars['Boolean'];
  id: Scalars['Int'];
};


export type ContractsMutationsBulkAssignContractsPayrollPolicyArgs = {
  employeeIds: Array<Scalars['Int']>;
  payrollPolicyId: Scalars['Int'];
};


export type ContractsMutationsBulkCreateContractsAdditionalCompensationArgs = {
  amount?: InputMaybe<Scalars['Int']>;
  amountStrategyType: ContractsValueObjectsAmountStrategyTypeEnum;
  companyId: Scalars['Int'];
  description?: InputMaybe<Scalars['String']>;
  employeeIds: Array<Scalars['Int']>;
  firstPaymentOn: Scalars['ISO8601Date'];
  payrollConceptId: Scalars['Int'];
  recurrence: ContractsAdditionalCompensationRecurrenceEnum;
  upperLimit?: InputMaybe<Scalars['Int']>;
};


export type ContractsMutationsBulkCreateContractsTaxonomyArgs = {
  legalEntityIds: Array<Scalars['Int']>;
  name: Scalars['String'];
};


export type ContractsMutationsCreateByFixContractsCompensationsRolloutArgs = {
  companyId: Scalars['Int'];
  compensationEmployeeMaps: Array<CreateByFixContractsCompensationsRolloutCompensationEmployeeMapsInput>;
  removeExistingCompensations: Scalars['Boolean'];
};


export type ContractsMutationsCreateContractsCompensationArgs = {
  amount?: InputMaybe<Scalars['Int']>;
  calculation?: InputMaybe<Scalars['String']>;
  compensationType?: InputMaybe<Scalars['String']>;
  contractApprovalStatus?: InputMaybe<Scalars['String']>;
  contractVersionId: Scalars['Int'];
  contractsTaxonomyId: Scalars['Int'];
  description?: InputMaybe<Scalars['String']>;
  firstPaymentOn?: InputMaybe<Scalars['ISO8601Date']>;
  minimumAmountOfHours?: InputMaybe<Scalars['Int']>;
  minimumAmountOfHoursInCents?: InputMaybe<Scalars['Int']>;
  payrollPolicyId?: InputMaybe<Scalars['Int']>;
  recurrence?: InputMaybe<Scalars['String']>;
  recurrenceCount?: InputMaybe<Scalars['Int']>;
  startsOn?: InputMaybe<Scalars['ISO8601Date']>;
  syncWithSupplements?: InputMaybe<Scalars['Boolean']>;
  timeCondition?: InputMaybe<ContractsValueObjectsTimeConditionEnum>;
  unit?: InputMaybe<Scalars['String']>;
};


export type ContractsMutationsCreateContractsContractTemplateArgs = {
  companyId: Scalars['Int'];
  contractVersionType: Scalars['String'];
};


export type ContractsMutationsCreateContractsContractVersionArgs = {
  actionType?: InputMaybe<ContractsContractVersionHistoryActionTypeEnum>;
  allowNilPayrollPolicy: Scalars['Boolean'];
  annualWorkingTimeDistribution?: InputMaybe<ContractsAnnualWorkingTimeDistributionEnum>;
  bankHolidayTreatment?: InputMaybe<ContractsBankHolidayTreatmentEnum>;
  compensations?: InputMaybe<Array<CreateContractsContractVersionCompensationsInput>>;
  contractsDeContractTypeId?: InputMaybe<Scalars['Int']>;
  contractsEsA3innuvaJobPositionId?: InputMaybe<Scalars['Int']>;
  contractsEsAgreementCodeId?: InputMaybe<Scalars['Int']>;
  contractsEsClassificationId?: InputMaybe<Scalars['Int']>;
  contractsEsCnoOccupationId?: InputMaybe<Scalars['Int']>;
  contractsEsContractTypeId?: InputMaybe<Scalars['Int']>;
  contractsEsContributionTypeId?: InputMaybe<Scalars['Int']>;
  contractsEsEducationLevelId?: InputMaybe<Scalars['Int']>;
  contractsEsOccupationCodeId?: InputMaybe<Scalars['Int']>;
  contractsEsProfessionalCategoryId?: InputMaybe<Scalars['Int']>;
  contractsEsRegimeId?: InputMaybe<Scalars['Int']>;
  contractsEsTariffGroupId?: InputMaybe<Scalars['Int']>;
  contractsEsWorkingDayTypeId?: InputMaybe<Scalars['Int']>;
  contractsFrContractTypeId?: InputMaybe<Scalars['Int']>;
  contractsFrLevelId?: InputMaybe<Scalars['Int']>;
  contractsFrMutualId?: InputMaybe<Scalars['Int']>;
  contractsFrProfessionalCategoryId?: InputMaybe<Scalars['Int']>;
  contractsFrStepId?: InputMaybe<Scalars['Int']>;
  contractsFrWorkTypeId?: InputMaybe<Scalars['Int']>;
  contractsPtContractTypeId?: InputMaybe<Scalars['Int']>;
  copyCurrentContractVersion?: InputMaybe<Scalars['Boolean']>;
  deActivityType?: InputMaybe<Scalars['Int']>;
  deEmploymentType?: InputMaybe<Scalars['Int']>;
  deFlatRateTax?: InputMaybe<Scalars['Int']>;
  dePersonalKeyGroupId?: InputMaybe<Scalars['Int']>;
  effectiveOn: Scalars['ISO8601Date'];
  employeeId: Scalars['Int'];
  endsOn?: InputMaybe<Scalars['ISO8601Date']>;
  esContractObservations?: InputMaybe<Scalars['String']>;
  esCotizationGroup?: InputMaybe<Scalars['Int']>;
  esHasTeleworkingContract?: InputMaybe<Scalars['Boolean']>;
  esJobDescription?: InputMaybe<Scalars['String']>;
  frCoefficient?: InputMaybe<Scalars['String']>;
  frEmployeeType?: InputMaybe<Scalars['String']>;
  frForfaitJours?: InputMaybe<Scalars['Boolean']>;
  frJoursParAn?: InputMaybe<Scalars['Int']>;
  frJoursParAnCents?: InputMaybe<Scalars['Int']>;
  hasPayroll?: InputMaybe<Scalars['Boolean']>;
  hasTrialPeriod?: InputMaybe<Scalars['Boolean']>;
  isDiscontinuous?: InputMaybe<Scalars['Boolean']>;
  jobCatalogLevelId?: InputMaybe<Scalars['Int']>;
  jobCatalogTreeNodeUuid?: InputMaybe<Scalars['String']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  maxLegalYearlyHours?: InputMaybe<Scalars['Int']>;
  maxWorkDaysInRow?: InputMaybe<Scalars['Int']>;
  maxWorkMinutesPerDay?: InputMaybe<Scalars['Int']>;
  maximumWeeklyHours?: InputMaybe<Scalars['Int']>;
  minRestHoursInRow?: InputMaybe<Scalars['Int']>;
  minRestMinutesBetweenDays?: InputMaybe<Scalars['Int']>;
  newAdditionalCompensations: Array<CreateContractsContractVersionNewAdditionalCompensationsInput>;
  payrollPolicyId?: InputMaybe<Scalars['Int']>;
  requestDetails?: InputMaybe<Scalars['String']>;
  salaryAmount?: InputMaybe<Scalars['Int']>;
  salaryFrequency?: InputMaybe<Scalars['String']>;
  startsOn: Scalars['ISO8601Date'];
  trialPeriodEndsOn?: InputMaybe<Scalars['ISO8601Date']>;
  workingHours?: InputMaybe<Scalars['Int']>;
  workingHoursFrequency?: InputMaybe<Scalars['String']>;
  workingTimePercentageInCents?: InputMaybe<Scalars['Int']>;
  workingWeekDays?: InputMaybe<Scalars['String']>;
};


export type ContractsMutationsCreateContractsFranceFrenchContractTypeArgs = {
  contractsContractTemplateId?: InputMaybe<Scalars['Int']>;
  default?: InputMaybe<Scalars['Boolean']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};


export type ContractsMutationsCreateContractsFranceFrenchLevelArgs = {
  contractsContractTemplateId?: InputMaybe<Scalars['Int']>;
  default?: InputMaybe<Scalars['Boolean']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};


export type ContractsMutationsCreateContractsFranceFrenchMutualArgs = {
  contractsContractTemplateId?: InputMaybe<Scalars['Int']>;
  default?: InputMaybe<Scalars['Boolean']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};


export type ContractsMutationsCreateContractsFranceFrenchProfessionalCategoryArgs = {
  contractsContractTemplateId?: InputMaybe<Scalars['Int']>;
  default?: InputMaybe<Scalars['Boolean']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};


export type ContractsMutationsCreateContractsFranceFrenchStepArgs = {
  contractsContractTemplateId?: InputMaybe<Scalars['Int']>;
  default?: InputMaybe<Scalars['Boolean']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};


export type ContractsMutationsCreateContractsFranceFrenchWorkTypeArgs = {
  contractsContractTemplateId?: InputMaybe<Scalars['Int']>;
  default?: InputMaybe<Scalars['Boolean']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};


export type ContractsMutationsCreateContractsGermanyGermanContractTypeArgs = {
  contractsContractTemplateId?: InputMaybe<Scalars['Int']>;
  default?: InputMaybe<Scalars['Boolean']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};


export type ContractsMutationsCreateContractsPayrollPolicyArgs = {
  contractVersionId: Scalars['Int'];
  payrollPolicyId: Scalars['Int'];
};


export type ContractsMutationsCreateContractsPortugalPortugueseContractTypeArgs = {
  contractsContractTemplateId?: InputMaybe<Scalars['Int']>;
  default?: InputMaybe<Scalars['Boolean']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};


export type ContractsMutationsCreateContractsSpainSpanishContractTypeArgs = {
  contractsContractTemplateId: Scalars['Int'];
  default?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
};


export type ContractsMutationsCreateContractsSpainSpanishEducationLevelArgs = {
  contractsContractTemplateId: Scalars['Int'];
  name: Scalars['String'];
};


export type ContractsMutationsCreateContractsSpainSpanishProfessionalCategoryArgs = {
  contractsContractTemplateId: Scalars['Int'];
  default?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
};


export type ContractsMutationsCreateContractsSpainSpanishWorkingDayTypeArgs = {
  contractsContractTemplateId?: InputMaybe<Scalars['Int']>;
  default?: InputMaybe<Scalars['Boolean']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};


export type ContractsMutationsCreateContractsTaxonomyArgs = {
  default?: InputMaybe<Scalars['Boolean']>;
  legalEntityId: Scalars['Int'];
  name: Scalars['String'];
};


export type ContractsMutationsCreateContractsTerminationTypeArgs = {
  country: Scalars['String'];
  description: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
  isDeprecated: Scalars['Boolean'];
  slug: Scalars['String'];
  terminationReasonType: Scalars['String'];
};


export type ContractsMutationsCreateContractsWeeksPerMonthConfigurationArgs = {
  legalEntityId: Scalars['Int'];
  weeksPerMonth?: InputMaybe<ContractsWeeksPerMonthConfigurationOptionEnum>;
};


export type ContractsMutationsCreatePromoteRequestContractsContractVersionRequestArgs = {
  additionalCompensations: Array<CreatePromoteRequestContractsContractVersionRequestAdditionalCompensationsInput>;
  effectiveOn: Scalars['ISO8601Date'];
  employeeId: Scalars['Int'];
  esJobDescription?: InputMaybe<Scalars['String']>;
  jobCatalogLevelId?: InputMaybe<Scalars['Int']>;
  jobCatalogTreeNodeUuid?: InputMaybe<Scalars['String']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  newAdditionalCompensations: Array<CreatePromoteRequestContractsContractVersionRequestNewAdditionalCompensationsInput>;
  payrollPolicyId?: InputMaybe<Scalars['Int']>;
  requestDetails?: InputMaybe<Scalars['String']>;
  salaryAmount?: InputMaybe<Scalars['Int']>;
  salaryFrequency?: InputMaybe<Scalars['String']>;
};


export type ContractsMutationsCreateWithPayrollPolicyContractsContractVersionArgs = {
  createContractVersionDto: CreateWithPayrollPolicyContractsContractVersionCreateContractVersionDtoInput;
  payrollPolicyId?: InputMaybe<Scalars['Int']>;
};


export type ContractsMutationsDeleteContractsCompensationArgs = {
  id: Scalars['Int'];
};


export type ContractsMutationsDeleteContractsContractVersionArgs = {
  id: Scalars['Int'];
};


export type ContractsMutationsDeleteContractsContractVersionRequestArgs = {
  id: Scalars['Int'];
};


export type ContractsMutationsFixContractsContractVersionArgs = {
  additionalCompensations?: InputMaybe<Array<FixContractsContractVersionAdditionalCompensationsInput>>;
  annualWorkingTimeDistribution?: InputMaybe<Scalars['String']>;
  bankHolidayTreatment?: InputMaybe<Scalars['String']>;
  contractsEsTariffGroupId?: InputMaybe<Scalars['Int']>;
  customFields: Array<FixContractsContractVersionCustomFieldsInput>;
  deActivityType?: InputMaybe<Scalars['Int']>;
  deContractTypeId?: InputMaybe<Scalars['Int']>;
  deEmploymentType?: InputMaybe<Scalars['Int']>;
  deFlatRateTax?: InputMaybe<Scalars['Int']>;
  dePersonalKeyGroupId?: InputMaybe<Scalars['Int']>;
  effectiveOn?: InputMaybe<Scalars['ISO8601Date']>;
  employeeId: Scalars['Int'];
  endsOn?: InputMaybe<Scalars['ISO8601Date']>;
  esA3innuvaJobPositionId?: InputMaybe<Scalars['Int']>;
  esA3innuvaJobPositionPayrollIntegrationCode?: InputMaybe<Scalars['String']>;
  esA3innuvaJobPositionPayrollIntegrationName?: InputMaybe<Scalars['String']>;
  esAgreementCodePayrollIntegrationCode?: InputMaybe<Scalars['String']>;
  esAgreementCodePayrollIntegrationName?: InputMaybe<Scalars['String']>;
  esClassificationId?: InputMaybe<Scalars['Int']>;
  esClassificationPayrollIntegrationCode?: InputMaybe<Scalars['String']>;
  esClassificationPayrollIntegrationName?: InputMaybe<Scalars['String']>;
  esCnoOccupationId?: InputMaybe<Scalars['Int']>;
  esCnoOccupationPayrollIntegrationCode?: InputMaybe<Scalars['String']>;
  esCnoOccupationPayrollIntegrationName?: InputMaybe<Scalars['String']>;
  esContractObservations?: InputMaybe<Scalars['String']>;
  esContractTypeId?: InputMaybe<Scalars['Int']>;
  esContractTypePayrollIntegrationCode?: InputMaybe<Scalars['String']>;
  esContractTypePayrollIntegrationName?: InputMaybe<Scalars['String']>;
  esContributionTypeId?: InputMaybe<Scalars['Int']>;
  esContributionTypePayrollIntegrationCode?: InputMaybe<Scalars['String']>;
  esContributionTypePayrollIntegrationName?: InputMaybe<Scalars['String']>;
  esCotizationGroup?: InputMaybe<Scalars['Int']>;
  esEducationLevelId?: InputMaybe<Scalars['Int']>;
  esEducationLevelPayrollIntegrationCode?: InputMaybe<Scalars['String']>;
  esEducationLevelPayrollIntegrationName?: InputMaybe<Scalars['String']>;
  esHasTeleworkingContract?: InputMaybe<Scalars['Boolean']>;
  esJobDescription?: InputMaybe<Scalars['String']>;
  esOccupationCodeId?: InputMaybe<Scalars['Int']>;
  esOccupationCodePayrollIntegrationCode?: InputMaybe<Scalars['String']>;
  esOccupationCodePayrollIntegrationName?: InputMaybe<Scalars['String']>;
  esProfessionalCategoryId?: InputMaybe<Scalars['Int']>;
  esRegimeId?: InputMaybe<Scalars['Int']>;
  esRegimePayrollIntegrationCode?: InputMaybe<Scalars['String']>;
  esRegimePayrollIntegrationName?: InputMaybe<Scalars['String']>;
  esTariffGroupId?: InputMaybe<Scalars['String']>;
  esTariffGroupName?: InputMaybe<Scalars['String']>;
  esWorkingDayTypeId?: InputMaybe<Scalars['Int']>;
  frCoefficient?: InputMaybe<Scalars['String']>;
  frContractTypeId?: InputMaybe<Scalars['Int']>;
  frEmployeeType?: InputMaybe<Scalars['String']>;
  frForfaitJours?: InputMaybe<Scalars['Boolean']>;
  frJoursParAn?: InputMaybe<Scalars['Int']>;
  frJoursParAnCents?: InputMaybe<Scalars['Int']>;
  frLevelId?: InputMaybe<Scalars['Int']>;
  frMutualId?: InputMaybe<Scalars['Int']>;
  frProfessionalCategoryId?: InputMaybe<Scalars['Int']>;
  frStepId?: InputMaybe<Scalars['Int']>;
  frWorkTypeId?: InputMaybe<Scalars['Int']>;
  hasTrialPeriod?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  jobCatalogLevelId?: InputMaybe<Scalars['Int']>;
  jobCatalogTreeNodeUuid?: InputMaybe<Scalars['String']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  maxLegalYearlyHours?: InputMaybe<Scalars['Int']>;
  maxWorkMinutesPerDay?: InputMaybe<Scalars['Int']>;
  maximumWeeklyHours?: InputMaybe<Scalars['Int']>;
  minRestMinutesBetweenDays?: InputMaybe<Scalars['Int']>;
  newAdditionalCompensations?: InputMaybe<Array<FixContractsContractVersionNewAdditionalCompensationsInput>>;
  ptContractTypeId?: InputMaybe<Scalars['Int']>;
  salaryAmount?: InputMaybe<Scalars['Int']>;
  salaryFrequency?: InputMaybe<Scalars['String']>;
  startsOn?: InputMaybe<Scalars['ISO8601Date']>;
  trialPeriodEndsOn?: InputMaybe<Scalars['ISO8601Date']>;
  workingHours?: InputMaybe<Scalars['Int']>;
  workingHoursFrequency?: InputMaybe<Scalars['String']>;
  workingTimePercentageInCents?: InputMaybe<Scalars['Int']>;
  workingWeekDays?: InputMaybe<Scalars['String']>;
};


export type ContractsMutationsPauseContractsContractArgs = {
  contractActivityPauseOn: Scalars['ISO8601Date'];
  contractId: Scalars['Int'];
  employeeTerminatedOn: Scalars['ISO8601Date'];
  reassignToEmployeeId?: InputMaybe<Scalars['Int']>;
};


export type ContractsMutationsPromoteContractsContractVersionArgs = {
  additionalCompensations: Array<PromoteContractsContractVersionAdditionalCompensationsInput>;
  effectiveOn: Scalars['ISO8601Date'];
  employeeId: Scalars['Int'];
  esJobDescription?: InputMaybe<Scalars['String']>;
  jobCatalogLevelId?: InputMaybe<Scalars['Int']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  payrollPolicyId?: InputMaybe<Scalars['Int']>;
  requestDetails?: InputMaybe<Scalars['String']>;
  salaryAmount?: InputMaybe<Scalars['Int']>;
  salaryFrequency?: InputMaybe<Scalars['String']>;
};


export type ContractsMutationsRejectContractsContractVersionRequestArgs = {
  id: Scalars['Int'];
  reason?: InputMaybe<Scalars['String']>;
};


export type ContractsMutationsRemoveContractsPayrollPolicyArgs = {
  id: Scalars['Int'];
};


export type ContractsMutationsResumeContractsContractArgs = {
  contractActivityResumeOn: Scalars['ISO8601Date'];
  contractId: Scalars['Int'];
  contractOnboardingEnabled: Scalars['Boolean'];
  onboardingProcessId?: InputMaybe<Scalars['Int']>;
  unterminateNow: Scalars['Boolean'];
};


export type ContractsMutationsUpdateContractsCompensationArgs = {
  amount?: InputMaybe<Scalars['Int']>;
  calculation?: InputMaybe<Scalars['String']>;
  compensationType?: InputMaybe<Scalars['String']>;
  contractsTaxonomyId: Scalars['Int'];
  description?: InputMaybe<Scalars['String']>;
  firstPaymentOn?: InputMaybe<Scalars['ISO8601Date']>;
  id?: InputMaybe<Scalars['Int']>;
  minimumAmountOfHours?: InputMaybe<Scalars['Int']>;
  minimumAmountOfHoursInCents?: InputMaybe<Scalars['Int']>;
  payrollPolicyId?: InputMaybe<Scalars['Int']>;
  recurrence?: InputMaybe<Scalars['String']>;
  recurrenceCount?: InputMaybe<Scalars['Int']>;
  startsOn?: InputMaybe<Scalars['ISO8601Date']>;
  syncWithSupplements?: InputMaybe<Scalars['Boolean']>;
  timeCondition?: InputMaybe<ContractsValueObjectsTimeConditionEnum>;
  unit?: InputMaybe<Scalars['String']>;
};


export type ContractsMutationsUpdateContractsContractVersionArgs = {
  annualWorkingTimeDistribution?: InputMaybe<ContractsAnnualWorkingTimeDistributionEnum>;
  bankHolidayTreatment?: InputMaybe<ContractsBankHolidayTreatmentEnum>;
  effectiveOn?: InputMaybe<Scalars['ISO8601Date']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  endsOn?: InputMaybe<Scalars['ISO8601Date']>;
  esContractTypeId?: InputMaybe<Scalars['Int']>;
  esCotizationGroup?: InputMaybe<Scalars['Int']>;
  esEducationLevelId?: InputMaybe<Scalars['Int']>;
  esProfessionalCategoryId?: InputMaybe<Scalars['Int']>;
  esWorkingDayTypeId?: InputMaybe<Scalars['Int']>;
  hasTrialPeriod?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  jobCatalogTreeNodeUuid?: InputMaybe<Scalars['String']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  salaryAmount?: InputMaybe<Scalars['Int']>;
  salaryFrequency?: InputMaybe<Scalars['String']>;
  startsOn?: InputMaybe<Scalars['ISO8601Date']>;
  trialPeriodEndsOn?: InputMaybe<Scalars['ISO8601Date']>;
  workingHours?: InputMaybe<Scalars['Int']>;
  workingHoursFrequency?: InputMaybe<Scalars['String']>;
  workingTimePercentageInCents?: InputMaybe<Scalars['Int']>;
  workingWeekDays?: InputMaybe<Scalars['String']>;
};


export type ContractsMutationsUpdateContractsContractVersionFlowArgs = {
  additionalCompensations: Array<UpdateContractsContractVersionFlowAdditionalCompensationsInput>;
  annualWorkingTimeDistribution?: InputMaybe<ContractsAnnualWorkingTimeDistributionEnum>;
  bankHolidayTreatment?: InputMaybe<ContractsBankHolidayTreatmentEnum>;
  customFields: Array<UpdateContractsContractVersionFlowCustomFieldsInput>;
  deActivityType?: InputMaybe<Scalars['Int']>;
  deContractTypeId?: InputMaybe<Scalars['Int']>;
  deEmploymentType?: InputMaybe<Scalars['Int']>;
  deFlatRateTax?: InputMaybe<Scalars['Int']>;
  dePersonalKeyGroupId?: InputMaybe<Scalars['Int']>;
  effectiveOn: Scalars['ISO8601Date'];
  employeeId: Scalars['Int'];
  endsOn?: InputMaybe<Scalars['ISO8601Date']>;
  esA3innuvaJobPositionPayrollIntegrationCode?: InputMaybe<Scalars['String']>;
  esA3innuvaJobPositionPayrollIntegrationName?: InputMaybe<Scalars['String']>;
  esAgreementCodePayrollIntegrationCode?: InputMaybe<Scalars['String']>;
  esAgreementCodePayrollIntegrationName?: InputMaybe<Scalars['String']>;
  esClassificationPayrollIntegrationCode?: InputMaybe<Scalars['String']>;
  esClassificationPayrollIntegrationName?: InputMaybe<Scalars['String']>;
  esCnoOccupationPayrollIntegrationCode?: InputMaybe<Scalars['String']>;
  esCnoOccupationPayrollIntegrationName?: InputMaybe<Scalars['String']>;
  esContractObservations?: InputMaybe<Scalars['String']>;
  esContractTypeId?: InputMaybe<Scalars['Int']>;
  esContractTypePayrollIntegrationCode?: InputMaybe<Scalars['String']>;
  esContractTypePayrollIntegrationName?: InputMaybe<Scalars['String']>;
  esContributionTypePayrollIntegrationCode?: InputMaybe<Scalars['String']>;
  esContributionTypePayrollIntegrationName?: InputMaybe<Scalars['String']>;
  esCotizationGroup?: InputMaybe<Scalars['Int']>;
  esEducationLevelId?: InputMaybe<Scalars['Int']>;
  esEducationLevelPayrollIntegrationCode?: InputMaybe<Scalars['String']>;
  esEducationLevelPayrollIntegrationName?: InputMaybe<Scalars['String']>;
  esHasTeleworkingContract: Scalars['Boolean'];
  esJobDescription?: InputMaybe<Scalars['String']>;
  esOccupationCodePayrollIntegrationCode?: InputMaybe<Scalars['String']>;
  esOccupationCodePayrollIntegrationName?: InputMaybe<Scalars['String']>;
  esProfessionalCategoryId?: InputMaybe<Scalars['Int']>;
  esRegimePayrollIntegrationCode?: InputMaybe<Scalars['String']>;
  esRegimePayrollIntegrationName?: InputMaybe<Scalars['String']>;
  esTariffGroupId?: InputMaybe<Scalars['String']>;
  esTariffGroupName?: InputMaybe<Scalars['String']>;
  esWorkingDayTypeId?: InputMaybe<Scalars['Int']>;
  frCoefficient?: InputMaybe<Scalars['String']>;
  frContractTypeId?: InputMaybe<Scalars['Int']>;
  frEmployeeType?: InputMaybe<Scalars['String']>;
  frForfaitJours: Scalars['Boolean'];
  frJoursParAn?: InputMaybe<Scalars['Int']>;
  frJoursParAnCents?: InputMaybe<Scalars['Int']>;
  frLevelId?: InputMaybe<Scalars['Int']>;
  frMutualId?: InputMaybe<Scalars['Int']>;
  frProfessionalCategoryId?: InputMaybe<Scalars['Int']>;
  frStepId?: InputMaybe<Scalars['Int']>;
  frWorkTypeId?: InputMaybe<Scalars['Int']>;
  hasTrialPeriod?: InputMaybe<Scalars['Boolean']>;
  isDiscontinuous?: InputMaybe<Scalars['Boolean']>;
  jobCatalogLevelId?: InputMaybe<Scalars['Int']>;
  jobCatalogRoleId?: InputMaybe<Scalars['Int']>;
  jobCatalogTreeNodeUuid?: InputMaybe<Scalars['String']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  maxLegalYearlyHours?: InputMaybe<Scalars['Int']>;
  maximumWeeklyHours?: InputMaybe<Scalars['Int']>;
  newAdditionalCompensations: Array<UpdateContractsContractVersionFlowNewAdditionalCompensationsInput>;
  payrollPolicyId?: InputMaybe<Scalars['Int']>;
  ptContractTypeId?: InputMaybe<Scalars['Int']>;
  salaryAmount?: InputMaybe<Scalars['Int']>;
  salaryFrequency?: InputMaybe<Scalars['String']>;
  startsOn?: InputMaybe<Scalars['ISO8601Date']>;
  trialPeriodEndsOn?: InputMaybe<Scalars['ISO8601Date']>;
  workingHours?: InputMaybe<Scalars['Int']>;
  workingHoursFrequency?: InputMaybe<Scalars['String']>;
  workingTimePercentageInCents?: InputMaybe<Scalars['Int']>;
  workingWeekDays?: InputMaybe<Scalars['String']>;
};


export type ContractsMutationsUpdateContractsTerminationTypeArgs = {
  country?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  isDeprecated?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  terminationReasonType?: InputMaybe<Scalars['String']>;
};


export type ContractsMutationsUpdateContractsWeeksPerMonthConfigurationArgs = {
  id: Scalars['Int'];
  weeksPerMonth?: InputMaybe<ContractsWeeksPerMonthConfigurationOptionEnum>;
};


export type ContractsMutationsUpsertContractsWeeksPerMonthConfigurationArgs = {
  legalEntityId: Scalars['Int'];
  weeksPerMonth?: InputMaybe<ContractsWeeksPerMonthConfigurationOptionEnum>;
};

export type CostCenters = {
  __typename?: 'costCenters';
  _policies: CostCentersContextlessPolicies;
  allocation?: Maybe<CostCentersAllocation>;
  /** @deprecated Please favor `allocationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  allocations: Array<CostCentersAllocation>;
  allocationsConnection: CostCentersAllocationConnection;
  assignment?: Maybe<CostCentersAssignment>;
  /** @deprecated Please favor `assignmentsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  assignments: Array<CostCentersAssignment>;
  assignmentsConnection: CostCentersAssignmentConnection;
  configuration?: Maybe<CostCentersConfiguration>;
  /** @deprecated Please favor `configurationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  configurations: Array<CostCentersConfiguration>;
  configurationsConnection: CostCentersConfigurationConnection;
  costCenter?: Maybe<CostCentersCostCenter>;
  /** @deprecated Please favor `costCentersConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  costCenters: Array<CostCentersCostCenter>;
  costCentersConnection: CostCentersCostCenterConnection;
  /** @deprecated Please favor `distributionsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  distributions: Array<CostCentersDistribution>;
  distributionsConnection: CostCentersDistributionConnection;
  /** @deprecated Please favor `undistributedLegalEntitiesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  undistributedLegalEntities: Array<CostCentersUndistributedLegalEntity>;
  undistributedLegalEntitiesConnection: CostCentersUndistributedLegalEntityConnection;
};


export type CostCentersAllocationArgs = {
  id: Scalars['Int'];
};


export type CostCentersAllocationsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  referenceIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceType?: InputMaybe<Scalars['String']>;
  resourceIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceType?: InputMaybe<Scalars['String']>;
};


export type CostCentersAllocationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  referenceIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceType?: InputMaybe<Scalars['String']>;
  resourceIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceType?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type CostCentersAssignmentArgs = {
  id: Scalars['Int'];
};


export type CostCentersAssignmentsArgs = {
  activeOn?: InputMaybe<Scalars['ISO8601Date']>;
  applyingOn?: InputMaybe<Scalars['ISO8601Date']>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyNextUpcoming?: InputMaybe<Scalars['Boolean']>;
  resourceIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceType?: InputMaybe<Scalars['String']>;
};


export type CostCentersAssignmentsConnectionArgs = {
  activeOn?: InputMaybe<Scalars['ISO8601Date']>;
  after?: InputMaybe<Scalars['String']>;
  applyingOn?: InputMaybe<Scalars['ISO8601Date']>;
  before?: InputMaybe<Scalars['String']>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyNextUpcoming?: InputMaybe<Scalars['Boolean']>;
  resourceIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceType?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type CostCentersConfigurationArgs = {
  id: Scalars['Int'];
};


export type CostCentersConfigurationsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  processingStatus?: InputMaybe<CostCentersValueObjectsProcessingStatusEnum>;
  structure?: InputMaybe<CostCentersValueObjectsStructureEnum>;
};


export type CostCentersConfigurationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<CostCentersConfigurationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  processingStatus?: InputMaybe<CostCentersValueObjectsProcessingStatusEnum>;
  sortOrder?: InputMaybe<Sort>;
  structure?: InputMaybe<CostCentersValueObjectsStructureEnum>;
};


export type CostCentersCostCenterArgs = {
  id: Scalars['Int'];
};


export type CostCentersCostCentersArgs = {
  activesOnDate?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityMissingAssignmentsFor?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<CostCentersValueObjectsCostCenterStatusEnum>>;
};


export type CostCentersCostCentersConnectionArgs = {
  activesOnDate?: InputMaybe<Scalars['ISO8601Date']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<CostCentersCostCenterFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityMissingAssignmentsFor?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  statuses?: InputMaybe<Array<CostCentersValueObjectsCostCenterStatusEnum>>;
};


export type CostCentersDistributionsArgs = {
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceType: Scalars['String'];
};


export type CostCentersDistributionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  resourceIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceType: Scalars['String'];
  sortOrder?: InputMaybe<Sort>;
};


export type CostCentersUndistributedLegalEntitiesArgs = {
  resourceType: Scalars['String'];
};


export type CostCentersUndistributedLegalEntitiesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  resourceType: Scalars['String'];
  sortOrder?: InputMaybe<Sort>;
};

export type CostCentersMutations = {
  __typename?: 'costCentersMutations';
  bulkDeleteCostcentersAllocation: BulkDeleteCostcentersAllocationPayload;
  bulkDeleteCostcentersAssignment: BulkDeleteCostcentersAssignmentPayload;
  bulkUpsertCostcentersAssignment: BulkUpsertCostcentersAssignmentPayload;
  createCostcentersAllocation: CreateCostcentersAllocationPayload;
  createCostcentersConfiguration: CreateCostcentersConfigurationPayload;
  createCostcentersCostCenter: CreateCostcentersCostCenterPayload;
  deleteCostcentersCostCenter: DeleteCostcentersCostCenterPayload;
  updateCostcentersAllocation: UpdateCostcentersAllocationPayload;
  updateCostcentersConfiguration: UpdateCostcentersConfigurationPayload;
  updateCostcentersCostCenter: UpdateCostcentersCostCenterPayload;
  upsertDistributionsCostcentersDistribution: UpsertDistributionsCostcentersDistributionPayload;
};


export type CostCentersMutationsBulkDeleteCostcentersAllocationArgs = {
  ids: Array<Scalars['Int']>;
};


export type CostCentersMutationsBulkDeleteCostcentersAssignmentArgs = {
  ids: Array<Scalars['Int']>;
};


export type CostCentersMutationsBulkUpsertCostcentersAssignmentArgs = {
  assignmentsToCreate: Array<BulkUpsertCostcentersAssignmentAssignmentsToCreateInput>;
  assignmentsToUpdate: Array<BulkUpsertCostcentersAssignmentAssignmentsToUpdateInput>;
};


export type CostCentersMutationsCreateCostcentersAllocationArgs = {
  referenceId: Scalars['Int'];
  referenceType: Scalars['String'];
  resourceId: Scalars['Int'];
  resourceType: Scalars['String'];
};


export type CostCentersMutationsCreateCostcentersConfigurationArgs = {
  companyId: Scalars['Int'];
  structure: CostCentersValueObjectsStructureEnum;
};


export type CostCentersMutationsCreateCostcentersCostCenterArgs = {
  code?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};


export type CostCentersMutationsDeleteCostcentersCostCenterArgs = {
  id: Scalars['Int'];
};


export type CostCentersMutationsUpdateCostcentersAllocationArgs = {
  id: Scalars['Int'];
  referenceId: Scalars['Int'];
  referenceType: Scalars['String'];
};


export type CostCentersMutationsUpdateCostcentersConfigurationArgs = {
  id: Scalars['Int'];
  processedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  processingStatus?: InputMaybe<CostCentersValueObjectsProcessingStatusEnum>;
};


export type CostCentersMutationsUpdateCostcentersCostCenterArgs = {
  code?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
};


export type CostCentersMutationsUpsertDistributionsCostcentersDistributionArgs = {
  allocation?: InputMaybe<UpsertDistributionsCostcentersDistributionAllocationInput>;
  assignments?: InputMaybe<UpsertDistributionsCostcentersDistributionAssignmentsInput>;
  resourceId: Scalars['Int'];
  resourceType: Scalars['String'];
};

/** Payload for cp_chat and subscription: chat */
export type Cp_Chat_Chat_Type = {
  __typename?: 'cp_chat_chat_type';
  companyId: Scalars['Int'];
  conversationId: Scalars['String'];
  customerAccess?: Maybe<BillingCustomerAccessSubscription>;
  error?: Maybe<Scalars['Boolean']>;
  question: Scalars['String'];
  response?: Maybe<Scalars['String']>;
  subscriptionId: Scalars['String'];
};

/** Payload for cp_export_invoice and subscription: initiate_export */
export type Cp_Export_Invoice_Initiate_Export_Type = {
  __typename?: 'cp_export_invoice_initiate_export_type';
  companyId: Scalars['Int'];
  customerId?: Maybe<Scalars['String']>;
  downloadUrl?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['String']>;
};

export type CronofyScheduling = {
  __typename?: 'cronofyScheduling';
  calendarSync?: Maybe<CronofySchedulingCalendarSync>;
  /** @deprecated Please favor `calendarSyncsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  calendarSyncs: Array<CronofySchedulingCalendarSync>;
  calendarSyncsConnection: CronofySchedulingCalendarSyncConnection;
};


export type CronofySchedulingCalendarSyncArgs = {
  id: Scalars['Int'];
};


export type CronofySchedulingCalendarSyncsArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type CronofySchedulingCalendarSyncsConnectionArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

export type CronofySchedulingMutations = {
  __typename?: 'cronofySchedulingMutations';
  acceptCronofyschedulingCalendarSync: AcceptCronofyschedulingCalendarSyncPayload;
  createCronofyschedulingCalendarSync: CreateCronofyschedulingCalendarSyncPayload;
  generateElementTokenCronofyschedulingCalendarSync: GenerateElementTokenCronofyschedulingCalendarSyncPayload;
  inviteCronofyschedulingCalendarSync: InviteCronofyschedulingCalendarSyncPayload;
  revokeCronofyschedulingCalendarSync: RevokeCronofyschedulingCalendarSyncPayload;
};


export type CronofySchedulingMutationsAcceptCronofyschedulingCalendarSyncArgs = {
  callbackUrl: Scalars['String'];
  code: Scalars['String'];
  eventsCallbackUrl: Scalars['String'];
  id: Scalars['Int'];
};


export type CronofySchedulingMutationsCreateCronofyschedulingCalendarSyncArgs = {
  accessId: Scalars['Int'];
};


export type CronofySchedulingMutationsGenerateElementTokenCronofyschedulingCalendarSyncArgs = {
  attendeesAccessesIds: Array<Scalars['Int']>;
  id: Scalars['Int'];
};


export type CronofySchedulingMutationsInviteCronofyschedulingCalendarSyncArgs = {
  accessId: Scalars['Int'];
};


export type CronofySchedulingMutationsRevokeCronofyschedulingCalendarSyncArgs = {
  id: Scalars['Int'];
};

export type CustomFields = {
  __typename?: 'customFields';
  _policies: CustomFieldsContextlessPolicies;
  field?: Maybe<CustomFieldsField>;
  /** @deprecated Please favor `fieldsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  fields: Array<CustomFieldsField>;
  fieldsConnection: CustomFieldsFieldConnection;
  option?: Maybe<CustomFieldsOption>;
  /** @deprecated Please favor `optionsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  options: Array<CustomFieldsOption>;
  optionsConnection: CustomFieldsOptionConnection;
  resourceField?: Maybe<CustomFieldsResourceField>;
  /** @deprecated Please favor `resourceFieldsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  resourceFields: Array<CustomFieldsResourceField>;
  resourceFieldsConnection: CustomFieldsResourceFieldConnection;
  usageGroup?: Maybe<CustomFieldsUsageGroup>;
  /** @deprecated Please favor `usageGroupsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  usageGroups: Array<CustomFieldsUsageGroup>;
  usageGroupsConnection: CustomFieldsUsageGroupConnection;
  value?: Maybe<CustomFieldsValue>;
  /** @deprecated Please favor `valuesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  values: Array<CustomFieldsValue>;
  valuesConnection: CustomFieldsValueConnection;
};


export type CustomFieldsFieldArgs = {
  id: Scalars['Int'];
};


export type CustomFieldsFieldsArgs = {
  authorId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  fieldType?: InputMaybe<CustomFieldsFieldTypeEnum>;
  identifiers?: InputMaybe<Array<Scalars['String']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  instanceId?: InputMaybe<Scalars['Int']>;
  label?: InputMaybe<Scalars['String']>;
  modelSlug?: InputMaybe<Scalars['String']>;
  relatedEmployeeId?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  usageGroupId?: InputMaybe<Scalars['Int']>;
  usageGroupSlugs?: InputMaybe<Array<Scalars['String']>>;
};


export type CustomFieldsFieldsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  authorId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  fieldType?: InputMaybe<CustomFieldsFieldTypeEnum>;
  first?: InputMaybe<Scalars['Int']>;
  identifiers?: InputMaybe<Array<Scalars['String']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  instanceId?: InputMaybe<Scalars['Int']>;
  label?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  modelSlug?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  relatedEmployeeId?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  usageGroupId?: InputMaybe<Scalars['Int']>;
  usageGroupSlugs?: InputMaybe<Array<Scalars['String']>>;
};


export type CustomFieldsOptionArgs = {
  id: Scalars['Int'];
};


export type CustomFieldsOptionsArgs = {
  fieldIds?: InputMaybe<Array<Scalars['Int']>>;
  fieldableIds?: InputMaybe<Array<Scalars['Int']>>;
  fieldableType?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  withArchived?: InputMaybe<Scalars['Boolean']>;
};


export type CustomFieldsOptionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  fieldIds?: InputMaybe<Array<Scalars['Int']>>;
  fieldableIds?: InputMaybe<Array<Scalars['Int']>>;
  fieldableType?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  withArchived?: InputMaybe<Scalars['Boolean']>;
};


export type CustomFieldsResourceFieldArgs = {
  id: Scalars['Int'];
};


export type CustomFieldsResourceFieldsArgs = {
  fieldIds?: InputMaybe<Array<Scalars['Int']>>;
  fieldableIds?: InputMaybe<Array<Scalars['Int']>>;
  fieldableType?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  schemaIds?: InputMaybe<Array<Scalars['Int']>>;
  usageGroupSlugs?: InputMaybe<Array<Scalars['String']>>;
};


export type CustomFieldsResourceFieldsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  fieldIds?: InputMaybe<Array<Scalars['Int']>>;
  fieldableIds?: InputMaybe<Array<Scalars['Int']>>;
  fieldableType?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  schemaIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
  usageGroupSlugs?: InputMaybe<Array<Scalars['String']>>;
};


export type CustomFieldsUsageGroupArgs = {
  id: Scalars['Int'];
};


export type CustomFieldsUsageGroupsArgs = {
  fieldsIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  slugs?: InputMaybe<Array<Scalars['String']>>;
};


export type CustomFieldsUsageGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  fieldsIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  slugs?: InputMaybe<Array<Scalars['String']>>;
  sortOrder?: InputMaybe<Sort>;
};


export type CustomFieldsValueArgs = {
  id: Scalars['Int'];
};


export type CustomFieldsValuesArgs = {
  contractsVersionsIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  fieldId?: InputMaybe<Scalars['Int']>;
  identifiers?: InputMaybe<Array<Scalars['String']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  instanceId?: InputMaybe<Scalars['Int']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  updatedAtGteq?: InputMaybe<Scalars['String']>;
  usageGroupId?: InputMaybe<Scalars['Int']>;
  usageGroupSlugs?: InputMaybe<Array<Scalars['String']>>;
  valuableIds?: InputMaybe<Array<Scalars['Int']>>;
  valuableType?: InputMaybe<CustomFieldsValueObjectsValuableTypeEnum>;
  value?: InputMaybe<Scalars['String']>;
};


export type CustomFieldsValuesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  contractsVersionsIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  fieldId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  identifiers?: InputMaybe<Array<Scalars['String']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  instanceId?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  updatedAtGteq?: InputMaybe<Scalars['String']>;
  usageGroupId?: InputMaybe<Scalars['Int']>;
  usageGroupSlugs?: InputMaybe<Array<Scalars['String']>>;
  valuableIds?: InputMaybe<Array<Scalars['Int']>>;
  valuableType?: InputMaybe<CustomFieldsValueObjectsValuableTypeEnum>;
  value?: InputMaybe<Scalars['String']>;
};

export type CustomFieldsMutations = {
  __typename?: 'customFieldsMutations';
  createCustomfieldsField: CreateCustomfieldsFieldPayload;
  createCustomfieldsOption: CreateCustomfieldsOptionPayload;
  createCustomfieldsResourceField: CreateCustomfieldsResourceFieldPayload;
  createCustomfieldsValue: CreateCustomfieldsValuePayload;
  deleteCustomfieldsField: DeleteCustomfieldsFieldPayload;
  updateCustomfieldsField: UpdateCustomfieldsFieldPayload;
  updateCustomfieldsResourceField: UpdateCustomfieldsResourceFieldPayload;
  updateCustomfieldsValue: UpdateCustomfieldsValuePayload;
  upsertCustomfieldsValue: UpsertCustomfieldsValuePayload;
};


export type CustomFieldsMutationsCreateCustomfieldsFieldArgs = {
  companyId: Scalars['Int'];
  editable?: InputMaybe<PermissionsContextEnum>;
  fieldType: CustomFieldsFieldTypeEnum;
  fieldableId?: InputMaybe<Scalars['Int']>;
  fieldableType?: InputMaybe<Scalars['String']>;
  identifier?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
  maxValue?: InputMaybe<Scalars['Int']>;
  minValue?: InputMaybe<Scalars['Int']>;
  options?: InputMaybe<Array<Scalars['String']>>;
  position?: InputMaybe<Scalars['Int']>;
  required?: InputMaybe<Scalars['Boolean']>;
  usageGroupSlug?: InputMaybe<Scalars['String']>;
  visible?: InputMaybe<PermissionsContextEnum>;
};


export type CustomFieldsMutationsCreateCustomfieldsOptionArgs = {
  fieldId: Scalars['Int'];
  isActive?: InputMaybe<Scalars['Boolean']>;
  label: Scalars['String'];
};


export type CustomFieldsMutationsCreateCustomfieldsResourceFieldArgs = {
  companyId: Scalars['Int'];
  editable: PermissionsContextEnum;
  fieldType: CustomFieldsFieldTypeEnum;
  identifier?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
  maxValue?: InputMaybe<Scalars['Int']>;
  minValue?: InputMaybe<Scalars['Int']>;
  options?: InputMaybe<Array<Scalars['String']>>;
  position?: InputMaybe<Scalars['Int']>;
  required: Scalars['Boolean'];
  schemaId: Scalars['Int'];
  visible: PermissionsContextEnum;
};


export type CustomFieldsMutationsCreateCustomfieldsValueArgs = {
  customValueId?: InputMaybe<Scalars['Int']>;
  fieldId: Scalars['Int'];
  valuableId: Scalars['Int'];
  valuableType: Scalars['String'];
  value: Scalars['String'];
};


export type CustomFieldsMutationsDeleteCustomfieldsFieldArgs = {
  id: Scalars['Int'];
};


export type CustomFieldsMutationsUpdateCustomfieldsFieldArgs = {
  choiceOptions?: InputMaybe<Array<UpdateCustomfieldsFieldChoiceOptionsInput>>;
  companyId: Scalars['Int'];
  fieldId: Scalars['Int'];
  label?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  required?: InputMaybe<Scalars['Boolean']>;
};


export type CustomFieldsMutationsUpdateCustomfieldsResourceFieldArgs = {
  position?: InputMaybe<Scalars['Int']>;
  resourceId: Scalars['Int'];
};


export type CustomFieldsMutationsUpdateCustomfieldsValueArgs = {
  id?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['String']>;
};


export type CustomFieldsMutationsUpsertCustomfieldsValueArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  contractsVersionsIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  fieldId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  identifiers?: InputMaybe<Array<Scalars['String']>>;
  modelSlug?: InputMaybe<Scalars['String']>;
  valuableId?: InputMaybe<Scalars['Int']>;
  valuableType?: InputMaybe<Scalars['String']>;
  value: Scalars['String'];
};

export type CustomResources = {
  __typename?: 'customResources';
  resource?: Maybe<CustomResourcesResource>;
  /** @deprecated Please favor `resourcesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  resources: Array<CustomResourcesResource>;
  resourcesConnection: CustomResourcesResourceConnection;
  schema?: Maybe<CustomResourcesSchema>;
  /** @deprecated Please favor `schemasConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  schemas: Array<CustomResourcesSchema>;
  schemasConnection: CustomResourcesSchemaConnection;
  value?: Maybe<CustomResourcesValue>;
  /** @deprecated Please favor `valuesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  values: Array<CustomResourcesValue>;
  valuesConnection: CustomResourcesValueConnection;
};


export type CustomResourcesResourceArgs = {
  id: Scalars['Int'];
};


export type CustomResourcesResourcesArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  schemaIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type CustomResourcesResourcesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  schemaIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
};


export type CustomResourcesSchemaArgs = {
  id: Scalars['Int'];
};


export type CustomResourcesSchemasArgs = {
  employeeId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type CustomResourcesSchemasConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type CustomResourcesValueArgs = {
  id: Scalars['Int'];
};


export type CustomResourcesValuesArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  resourceIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type CustomResourcesValuesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  resourceIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
};

export type CustomResourcesMutations = {
  __typename?: 'customResourcesMutations';
  attachValuesCustomresourcesResource: AttachValuesCustomresourcesResourcePayload;
  createCustomresourcesResource: CreateCustomresourcesResourcePayload;
  createCustomresourcesSchema: CreateCustomresourcesSchemaPayload;
  createCustomresourcesValue: CreateCustomresourcesValuePayload;
  deleteCustomresourcesValue: DeleteCustomresourcesValuePayload;
};


export type CustomResourcesMutationsAttachValuesCustomresourcesResourceArgs = {
  employeeId: Scalars['Int'];
  resourceId?: InputMaybe<Scalars['Int']>;
  schemaId: Scalars['Int'];
  valueId?: InputMaybe<Scalars['Int']>;
  values: Array<CustomResourcesResourceValuesInput>;
};


export type CustomResourcesMutationsCreateCustomresourcesResourceArgs = {
  employeeId: Scalars['Int'];
  schemaId: Scalars['Int'];
};


export type CustomResourcesMutationsCreateCustomresourcesSchemaArgs = {
  billingSubscriptionAddonId?: InputMaybe<Scalars['Int']>;
  companyId: Scalars['Int'];
  effectiveAtId?: InputMaybe<Scalars['Int']>;
  hidden: Scalars['Boolean'];
  name: Scalars['String'];
  position?: InputMaybe<Scalars['Int']>;
  reportable: Scalars['Boolean'];
  topic?: InputMaybe<Scalars['String']>;
  usageGroupSlug?: InputMaybe<Scalars['String']>;
};


export type CustomResourcesMutationsCreateCustomresourcesValueArgs = {
  customResourceId?: InputMaybe<Scalars['Int']>;
  employeeId: Scalars['Int'];
  fieldId: Scalars['Int'];
  schemaId: Scalars['Int'];
  value: Scalars['String'];
};


export type CustomResourcesMutationsDeleteCustomresourcesValueArgs = {
  resourceValueId: Scalars['Int'];
};

export type CustomerPortal = {
  __typename?: 'customerPortal';
  _policies: CustomerPortalContextlessPolicies;
  /** @deprecated Please favor `addonsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  addons: Array<CustomerPortalAddon>;
  addonsConnection: CustomerPortalAddonConnection;
  /** @deprecated Please favor `plansConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  plans: Array<CustomerPortalPlan>;
  plansConnection: CustomerPortalPlanConnection;
};


export type CustomerPortalAddonsArgs = {
  companyId: Scalars['Int'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: Scalars['Boolean'];
};


export type CustomerPortalAddonsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  preview?: Scalars['Boolean'];
  sortOrder?: InputMaybe<Sort>;
};


export type CustomerPortalPlansArgs = {
  companyId: Scalars['Int'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: Scalars['Boolean'];
};


export type CustomerPortalPlansConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  preview?: Scalars['Boolean'];
  sortOrder?: InputMaybe<Sort>;
};

export type Dashboard = {
  __typename?: 'dashboard';
  _policies: DashboardContextlessPolicies;
  /** @deprecated Please favor `companyLinksConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  companyLinks: Array<DashboardCompanyLink>;
  companyLinksConnection: DashboardCompanyLinkConnection;
  widget?: Maybe<DashboardWidget>;
  /** @deprecated Please favor `widgetsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  widgets: Array<DashboardWidget>;
  widgetsConfiguration?: Maybe<DashboardWidgetsConfiguration>;
  /** @deprecated Please favor `widgetsConfigurationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  widgetsConfigurations: Array<DashboardWidgetsConfiguration>;
  widgetsConfigurationsConnection: DashboardWidgetsConfigurationConnection;
  widgetsConnection: DashboardWidgetConnection;
};


export type DashboardCompanyLinksConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type DashboardWidgetArgs = {
  id: Scalars['String'];
};


export type DashboardWidgetsArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};


export type DashboardWidgetsConfigurationArgs = {
  id: Scalars['String'];
};


export type DashboardWidgetsConfigurationsArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};


export type DashboardWidgetsConfigurationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type DashboardWidgetsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

export type DashboardMutations = {
  __typename?: 'dashboardMutations';
  bulkUpdateDashboardCompanyLink: BulkUpdateDashboardCompanyLinkPayload;
  createDashboardCompanyLink: CreateDashboardCompanyLinkPayload;
  createDashboardWidgetsConfiguration: CreateDashboardWidgetsConfigurationPayload;
  destroyDashboardCompanyLink: DestroyDashboardCompanyLinkPayload;
  updateDashboardCompanyLink: UpdateDashboardCompanyLinkPayload;
  updateDashboardWidgetsConfiguration: UpdateDashboardWidgetsConfigurationPayload;
};


export type DashboardMutationsBulkUpdateDashboardCompanyLinkArgs = {
  linkIdsToBeDeleted: Array<Scalars['Int']>;
  links: Array<BulkUpdateDashboardCompanyLinkLinksInput>;
};


export type DashboardMutationsCreateDashboardCompanyLinkArgs = {
  name: Scalars['String'];
  order: Scalars['Int'];
  url: Scalars['String'];
};


export type DashboardMutationsCreateDashboardWidgetsConfigurationArgs = {
  authorId: Scalars['Int'];
  companyId: Scalars['Int'];
  configuration: Scalars['String'];
  editable?: InputMaybe<Scalars['Boolean']>;
};


export type DashboardMutationsDestroyDashboardCompanyLinkArgs = {
  id: Scalars['Int'];
};


export type DashboardMutationsUpdateDashboardCompanyLinkArgs = {
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  url?: InputMaybe<Scalars['String']>;
};


export type DashboardMutationsUpdateDashboardWidgetsConfigurationArgs = {
  configuration?: InputMaybe<Scalars['String']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  updatedBy: Scalars['Int'];
};

export type DataDispatcher = {
  __typename?: 'dataDispatcher';
  dataSchema?: Maybe<DataDispatcherDataSchema>;
  /** @deprecated Please favor `dataSchemasConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  dataSchemas: Array<DataDispatcherDataSchema>;
  dataSchemasConnection: DataDispatcherDataSchemaConnection;
};


export type DataDispatcherDataSchemaArgs = {
  capabilityFilter: DataDispatcherCapabilityFilterInput;
  id: Scalars['String'];
};


export type DataDispatcherDataSchemasArgs = {
  capabilityFilter: DataDispatcherCapabilityFilterInput;
  ids?: InputMaybe<Array<Scalars['String']>>;
};


export type DataDispatcherDataSchemasConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  capabilityFilter: DataDispatcherCapabilityFilterInput;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

export type DirectUploadsMutations = {
  __typename?: 'directUploadsMutations';
  createDirectuploadsDirectUpload: CreateDirectuploadsDirectUploadPayload;
};


export type DirectUploadsMutationsCreateDirectuploadsDirectUploadArgs = {
  byteSize: Scalars['Int'];
  checksum: Scalars['String'];
  companyId: Scalars['Int'];
  contentType: Scalars['String'];
  filename: Scalars['String'];
  resourceId?: InputMaybe<Scalars['String']>;
  resourceType: Scalars['String'];
};

export type Documents = {
  __typename?: 'documents';
  _policies: DocumentsContextlessPolicies;
  document?: Maybe<DocumentsDocument>;
  /** @deprecated Please favor `documentsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  documents: Array<DocumentsDocument>;
  documentsConnection: DocumentsDocumentConnection;
  /** @deprecated Please favor `editableEmployeeFoldersConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  editableEmployeeFolders: Array<DocumentsEditableEmployeeFolder>;
  editableEmployeeFoldersConnection: DocumentsEditableEmployeeFolderConnection;
  folder?: Maybe<DocumentsFolder>;
  /** @deprecated Please favor `foldersConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  folders: Array<DocumentsFolder>;
  foldersConnection: DocumentsFolderConnection;
  /** @deprecated Please favor `logsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  logs: Array<DocumentsLog>;
  logsConnection: DocumentsLogConnection;
  template?: Maybe<DocumentsTemplate>;
  /** @deprecated Please favor `templatesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  templates: Array<DocumentsTemplate>;
  templatesConnection: DocumentsTemplateConnection;
  uploadProcessDocument?: Maybe<DocumentsUploadProcessDocument>;
  /** @deprecated Please favor `uploadProcessDocumentsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  uploadProcessDocuments: Array<DocumentsUploadProcessDocument>;
  uploadProcessDocumentsConnection: DocumentsUploadProcessDocumentConnection;
  /** @deprecated Please favor `uploadProcessFileUrlsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  uploadProcessFileUrls: Array<DocumentsUploadProcessFileUrl>;
  uploadProcessFileUrlsConnection: DocumentsUploadProcessFileUrlConnection;
  uploadProcessOperation?: Maybe<DocumentsUploadProcessOperation>;
  /** @deprecated Please favor `uploadProcessOperationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  uploadProcessOperations: Array<DocumentsUploadProcessOperation>;
  uploadProcessOperationsConnection: DocumentsUploadProcessOperationConnection;
  /** @deprecated Please favor `uploadProcessesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  uploadProcesses: Array<DocumentsUploadProcess>;
  uploadProcessesConnection: DocumentsUploadProcessConnection;
};


export type DocumentsDocumentArgs = {
  id: Scalars['Int'];
};


export type DocumentsDocumentsArgs = {
  afterDate?: InputMaybe<Scalars['ISO8601Date']>;
  beforeDate?: InputMaybe<Scalars['ISO8601Date']>;
  byBookkeeperDocuments?: InputMaybe<Scalars['Boolean']>;
  byPendingAssignment?: Scalars['Boolean'];
  byTrashBin?: Scalars['Boolean'];
  byWithoutFolder?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['Int']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  excludedType?: InputMaybe<Scalars['String']>;
  folderId?: InputMaybe<Scalars['Int']>;
  fromEmployees?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  incidenceId?: InputMaybe<Scalars['Int']>;
  includeTrashBin?: InputMaybe<Scalars['Boolean']>;
  leaveId?: InputMaybe<Scalars['Int']>;
  payrollHiringId?: InputMaybe<Scalars['Int']>;
  relationships?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  sort?: Scalars['String'];
  space?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};


export type DocumentsDocumentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  afterDate?: InputMaybe<Scalars['ISO8601Date']>;
  before?: InputMaybe<Scalars['String']>;
  beforeDate?: InputMaybe<Scalars['ISO8601Date']>;
  byBookkeeperDocuments?: InputMaybe<Scalars['Boolean']>;
  byPendingAssignment?: Scalars['Boolean'];
  byTrashBin?: Scalars['Boolean'];
  byWithoutFolder?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['Int']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  excludedType?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<DocumentsDocumentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  folderId?: InputMaybe<Scalars['Int']>;
  fromEmployees?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  incidenceId?: InputMaybe<Scalars['Int']>;
  includeTrashBin?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  leaveId?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  payrollHiringId?: InputMaybe<Scalars['Int']>;
  relationships?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  sort?: Scalars['String'];
  sortOrder?: InputMaybe<Sort>;
  space?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};


export type DocumentsEditableEmployeeFoldersArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type DocumentsEditableEmployeeFoldersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type DocumentsFolderArgs = {
  id: Scalars['Int'];
};


export type DocumentsFoldersArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  ascendantFolderId?: InputMaybe<Scalars['Int']>;
  billingSubscriptionAddonId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['Int']>;
  descendantFolderId?: InputMaybe<Scalars['Int']>;
  employee?: InputMaybe<Scalars['Boolean']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  mobileRequest?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  parentFolderId?: InputMaybe<Scalars['Int']>;
  parentFolderIds?: InputMaybe<Array<Scalars['Int']>>;
  rootFolders?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Scalars['String']>;
  space?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  withCounters?: InputMaybe<Scalars['Boolean']>;
  withUnfilteredCounters?: InputMaybe<Scalars['Boolean']>;
};


export type DocumentsFoldersConnectionArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  ascendantFolderId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  billingSubscriptionAddonId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['Int']>;
  descendantFolderId?: InputMaybe<Scalars['Int']>;
  employee?: InputMaybe<Scalars['Boolean']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<DocumentsFolderFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  mobileRequest?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  parentFolderId?: InputMaybe<Scalars['Int']>;
  parentFolderIds?: InputMaybe<Array<Scalars['Int']>>;
  rootFolders?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  space?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  withCounters?: InputMaybe<Scalars['Boolean']>;
  withUnfilteredCounters?: InputMaybe<Scalars['Boolean']>;
};


export type DocumentsLogsArgs = {
  documentId?: InputMaybe<Scalars['Int']>;
  logType?: InputMaybe<Scalars['String']>;
};


export type DocumentsLogsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  documentId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  logType?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type DocumentsTemplateArgs = {
  id: Scalars['Int'];
};


export type DocumentsTemplatesArgs = {
  documentType?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type DocumentsTemplatesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type DocumentsUploadProcessDocumentArgs = {
  id: Scalars['Int'];
};


export type DocumentsUploadProcessDocumentsArgs = {
  additionalSignersAccessIds?: InputMaybe<Array<Scalars['Int']>>;
  documentIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  uploadProcessId?: InputMaybe<Scalars['Int']>;
};


export type DocumentsUploadProcessDocumentsConnectionArgs = {
  additionalSignersAccessIds?: InputMaybe<Array<Scalars['Int']>>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  documentIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  uploadProcessId?: InputMaybe<Scalars['Int']>;
};


export type DocumentsUploadProcessFileUrlsArgs = {
  fileIds?: InputMaybe<Array<Scalars['Int']>>;
  uploadProcessId?: InputMaybe<Scalars['Int']>;
};


export type DocumentsUploadProcessFileUrlsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  fileIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  uploadProcessId?: InputMaybe<Scalars['Int']>;
};


export type DocumentsUploadProcessOperationArgs = {
  id: Scalars['Int'];
};


export type DocumentsUploadProcessOperationsArgs = {
  fileIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  uploadProcessId?: InputMaybe<Scalars['Int']>;
};


export type DocumentsUploadProcessOperationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  fileIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  uploadProcessId?: InputMaybe<Scalars['Int']>;
};


export type DocumentsUploadProcessesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

export type DocumentsMutations = {
  __typename?: 'documentsMutations';
  bulkCreateDocumentsDocument: BulkCreateDocumentsDocumentPayload;
  bulkCreateDocumentsDownloadUrl: BulkCreateDocumentsDownloadUrlPayload;
  bulkCreateDocumentsUploadProcessOperation: BulkCreateDocumentsUploadProcessOperationPayload;
  bulkDeleteDocumentsUploadProcessOperation: BulkDeleteDocumentsUploadProcessOperationPayload;
  bulkDestroyDocumentsUploadProcessDocument: BulkDestroyDocumentsUploadProcessDocumentPayload;
  bulkUpdateDocumentsDocument: BulkUpdateDocumentsDocumentPayload;
  bulkUpdateFolderDocumentsDocument: BulkUpdateFolderDocumentsDocumentPayload;
  bulkUpdateNotificationStatusDocumentsDocument: BulkUpdateNotificationStatusDocumentsDocumentPayload;
  bulkUpdateVisibilityDocumentsDocument: BulkUpdateVisibilityDocumentsDocumentPayload;
  cancelDocumentsUploadProcess: CancelDocumentsUploadProcessPayload;
  createDocumentsDocument: CreateDocumentsDocumentPayload;
  createDocumentsFolder: CreateDocumentsFolderPayload;
  createDocumentsTemplate: CreateDocumentsTemplatePayload;
  createDocumentsUploadProcess: CreateDocumentsUploadProcessPayload;
  createFileUpdatedLogDocumentsLog: CreateFileUpdatedLogDocumentsLogPayload;
  createFromTemplateDocumentsDocument: CreateFromTemplateDocumentsDocumentPayload;
  deleteDocumentsDocument: DeleteDocumentsDocumentPayload;
  deleteDocumentsTemplate: DeleteDocumentsTemplatePayload;
  destroyDocumentsFolder: DestroyDocumentsFolderPayload;
  distributeDocumentsUploadProcess: DistributeDocumentsUploadProcessPayload;
  fillDocumentDocumentsDocument: FillDocumentDocumentsDocumentPayload;
  generatePreviewDocumentsDocument: GeneratePreviewDocumentsDocumentPayload;
  moveToTrashBinDocumentsDocument: MoveToTrashBinDocumentsDocumentPayload;
  notifierFileUrlDocumentsDocument: NotifierFileUrlDocumentsDocumentPayload;
  previewDocumentsTemplate: PreviewDocumentsTemplatePayload;
  previewVariablesDocumentsTemplate: PreviewVariablesDocumentsTemplatePayload;
  processedDocumentsCountDocumentsUploadProcess: ProcessedDocumentsCountDocumentsUploadProcessPayload;
  removeFromTrashBinDocumentsDocument: RemoveFromTrashBinDocumentsDocumentPayload;
  restoreFromTrashBinDocumentsDocument: RestoreFromTrashBinDocumentsDocumentPayload;
  sendInBulkUpdateDocumentsDocument: SendInBulkUpdateDocumentsDocumentPayload;
  toggleActiveDocumentsFolder: ToggleActiveDocumentsFolderPayload;
  toggleVisibilityDocumentsDocument: ToggleVisibilityDocumentsDocumentPayload;
  updateBasicInfoDocumentsDocument: UpdateBasicInfoDocumentsDocumentPayload;
  updateDocumentsDocument: UpdateDocumentsDocumentPayload;
  updateDocumentsFolder: UpdateDocumentsFolderPayload;
  updateDocumentsTemplate: UpdateDocumentsTemplatePayload;
  updateDocumentsUploadProcessDocument: UpdateDocumentsUploadProcessDocumentPayload;
  updateFillableDocumentDocumentsDocument: UpdateFillableDocumentDocumentsDocumentPayload;
  updateSignatureStatusDocumentsDocument: UpdateSignatureStatusDocumentsDocumentPayload;
  updateStatusFilledDocumentsDocument: UpdateStatusFilledDocumentsDocumentPayload;
  uploadFromDocumentDocumentsDocument: UploadFromDocumentDocumentsDocumentPayload;
};


export type DocumentsMutationsBulkCreateDocumentsDocumentArgs = {
  authorId: Scalars['Int'];
  customFields?: InputMaybe<Array<BulkCreateDocumentsDocumentCustomFieldsInput>>;
  employeeId?: InputMaybe<Scalars['Int']>;
  files: Array<Scalars['File']>;
  folderId?: InputMaybe<Scalars['Int']>;
  incidenceMessageId?: InputMaybe<Scalars['Int']>;
  leaveId?: InputMaybe<Scalars['Int']>;
  notify: Scalars['Boolean'];
  public: Scalars['Boolean'];
  signaturePlacement?: InputMaybe<Scalars['Boolean']>;
  signeeIds?: InputMaybe<Array<Scalars['Int']>>;
  signeeStamps?: InputMaybe<Array<BulkCreateDocumentsDocumentSigneeStampsInput>>;
  space: Scalars['String'];
};


export type DocumentsMutationsBulkCreateDocumentsDownloadUrlArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type DocumentsMutationsBulkCreateDocumentsUploadProcessOperationArgs = {
  operations: Array<BulkCreateDocumentsUploadProcessOperationOperationsInput>;
  uploadProcessId: Scalars['Int'];
};


export type DocumentsMutationsBulkDeleteDocumentsUploadProcessOperationArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type DocumentsMutationsBulkDestroyDocumentsUploadProcessDocumentArgs = {
  documentIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type DocumentsMutationsBulkUpdateDocumentsDocumentArgs = {
  documents: Array<BulkUpdateDocumentsDocumentDocumentsInput>;
};


export type DocumentsMutationsBulkUpdateFolderDocumentsDocumentArgs = {
  documentIds: Array<Scalars['Int']>;
  folderId?: InputMaybe<Scalars['Int']>;
};


export type DocumentsMutationsBulkUpdateNotificationStatusDocumentsDocumentArgs = {
  documentIds: Array<Scalars['Int']>;
  notificationStatus: DocumentNotificationStatusEnum;
};


export type DocumentsMutationsBulkUpdateVisibilityDocumentsDocumentArgs = {
  documentIds: Array<Scalars['Int']>;
  sendNotifications: Scalars['Boolean'];
  visibility: Scalars['Boolean'];
};


export type DocumentsMutationsCancelDocumentsUploadProcessArgs = {
  id: Scalars['Int'];
};


export type DocumentsMutationsCreateDocumentsDocumentArgs = {
  authorId: Scalars['Int'];
  companyId: Scalars['Int'];
  createAccessNotifications: Scalars['Boolean'];
  customFields: Scalars['String'];
  employeeId?: InputMaybe<Scalars['Int']>;
  file: Scalars['File'];
  fileFilename?: InputMaybe<Scalars['String']>;
  filename?: InputMaybe<Scalars['String']>;
  folderId?: InputMaybe<Scalars['Int']>;
  incidenceMessageId?: InputMaybe<Scalars['Int']>;
  isPendingAssignment: Scalars['Boolean'];
  leaveId?: InputMaybe<Scalars['Int']>;
  public: Scalars['Boolean'];
  requestEsignature: Scalars['Boolean'];
  signaturePlacement?: InputMaybe<Scalars['Boolean']>;
  signeeIds: Array<Scalars['Int']>;
  signeeStamps?: InputMaybe<Array<CreateDocumentsDocumentSigneeStampsInput>>;
  skipNotifications: Scalars['Boolean'];
  space: StringEnum;
  type?: InputMaybe<Scalars['String']>;
};


export type DocumentsMutationsCreateDocumentsFolderArgs = {
  companyId: Scalars['Int'];
  identifier?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  parentFolderId?: InputMaybe<Scalars['Int']>;
  rootParentFolderId?: InputMaybe<Scalars['Int']>;
  space: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
};


export type DocumentsMutationsCreateDocumentsTemplateArgs = {
  companyId: Scalars['Int'];
  file: Scalars['File'];
  name: Scalars['String'];
};


export type DocumentsMutationsCreateDocumentsUploadProcessArgs = {
  additionalSignersAccessIds?: InputMaybe<Array<Scalars['Int']>>;
  combineFileName?: InputMaybe<Scalars['String']>;
  distributionWorkflow?: InputMaybe<Scalars['String']>;
  esignatureRequest?: InputMaybe<Scalars['Boolean']>;
  files: Array<Scalars['File']>;
  folderId?: InputMaybe<Scalars['Int']>;
  numberSplitPages?: InputMaybe<Scalars['Int']>;
  ownerId?: InputMaybe<Scalars['Int']>;
  uploadType: Scalars['String'];
};


export type DocumentsMutationsCreateFileUpdatedLogDocumentsLogArgs = {
  documentId: Scalars['Int'];
  esignatureId: Scalars['Int'];
};


export type DocumentsMutationsCreateFromTemplateDocumentsDocumentArgs = {
  authorId?: InputMaybe<Scalars['Int']>;
  employeeId: Scalars['Int'];
  filename?: InputMaybe<Scalars['String']>;
  folderId?: InputMaybe<Scalars['Int']>;
  signeeIds: Array<Scalars['Int']>;
  templateId: Scalars['Int'];
};


export type DocumentsMutationsDeleteDocumentsDocumentArgs = {
  byPendingAssignment?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
};


export type DocumentsMutationsDeleteDocumentsTemplateArgs = {
  id: Scalars['Int'];
};


export type DocumentsMutationsDestroyDocumentsFolderArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type DocumentsMutationsDistributeDocumentsUploadProcessArgs = {
  id: Scalars['Int'];
};


export type DocumentsMutationsFillDocumentDocumentsDocumentArgs = {
  file: Scalars['File'];
};


export type DocumentsMutationsGeneratePreviewDocumentsDocumentArgs = {
  additionalSignersAccessIds?: InputMaybe<Array<Scalars['Int']>>;
  authorId?: InputMaybe<Scalars['Int']>;
  esignatureRequest?: InputMaybe<Scalars['Boolean']>;
  filename?: InputMaybe<Scalars['String']>;
  folderId?: InputMaybe<Scalars['Int']>;
  templateId: Scalars['Int'];
};


export type DocumentsMutationsMoveToTrashBinDocumentsDocumentArgs = {
  documentIds: Array<Scalars['Int']>;
};


export type DocumentsMutationsNotifierFileUrlDocumentsDocumentArgs = {
  id: Scalars['Int'];
  recipientId: Scalars['Int'];
};


export type DocumentsMutationsPreviewDocumentsTemplateArgs = {
  employeeId?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
};


export type DocumentsMutationsPreviewVariablesDocumentsTemplateArgs = {
  employeeId: Scalars['Int'];
  id: Scalars['Int'];
};


export type DocumentsMutationsProcessedDocumentsCountDocumentsUploadProcessArgs = {
  id: Scalars['Int'];
  processedDocumentsCount?: InputMaybe<Scalars['Int']>;
  processedPagesCount?: InputMaybe<Scalars['Int']>;
  totalDocumentsCount?: InputMaybe<Scalars['Int']>;
  totalPagesCount?: InputMaybe<Scalars['Int']>;
};


export type DocumentsMutationsRemoveFromTrashBinDocumentsDocumentArgs = {
  documentIds: Array<Scalars['Int']>;
};


export type DocumentsMutationsRestoreFromTrashBinDocumentsDocumentArgs = {
  documentIds: Array<Scalars['Int']>;
};


export type DocumentsMutationsSendInBulkUpdateDocumentsDocumentArgs = {
  byPendingAssignment?: InputMaybe<Scalars['Boolean']>;
  distributionMethod?: InputMaybe<Scalars['String']>;
  employeeIds: Array<Scalars['Int']>;
  id: Scalars['Int'];
  isPendingAssignment: Scalars['Boolean'];
  public: Scalars['Boolean'];
  requestEsignature: Scalars['Boolean'];
  signeeIds: Array<Scalars['Int']>;
};


export type DocumentsMutationsToggleActiveDocumentsFolderArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type DocumentsMutationsToggleVisibilityDocumentsDocumentArgs = {
  id: Scalars['Int'];
  sendNotifications: Scalars['Boolean'];
};


export type DocumentsMutationsUpdateBasicInfoDocumentsDocumentArgs = {
  filename?: InputMaybe<Scalars['String']>;
  folderId?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
};


export type DocumentsMutationsUpdateDocumentsDocumentArgs = {
  employeeId?: InputMaybe<Scalars['Int']>;
  folderId?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  public: Scalars['Boolean'];
  requestEsignature: Scalars['Boolean'];
  signeeIds: Array<Scalars['Int']>;
};


export type DocumentsMutationsUpdateDocumentsFolderArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['String'];
};


export type DocumentsMutationsUpdateDocumentsTemplateArgs = {
  customFields?: InputMaybe<Array<Scalars['String']>>;
  file?: InputMaybe<Scalars['File']>;
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
};


export type DocumentsMutationsUpdateDocumentsUploadProcessDocumentArgs = {
  additionalSignersAccessIds: Array<Scalars['Int']>;
  documentId: Scalars['Int'];
  ownerId?: InputMaybe<Scalars['Int']>;
};


export type DocumentsMutationsUpdateFillableDocumentDocumentsDocumentArgs = {
  file: Scalars['File'];
  id: Scalars['Int'];
};


export type DocumentsMutationsUpdateSignatureStatusDocumentsDocumentArgs = {
  documentId: Scalars['Int'];
  signatureStatus: DocumentsSignatureStatusEnum;
};


export type DocumentsMutationsUpdateStatusFilledDocumentsDocumentArgs = {
  id: Scalars['Int'];
};


export type DocumentsMutationsUploadFromDocumentDocumentsDocumentArgs = {
  afterDate?: InputMaybe<Scalars['ISO8601Date']>;
  beforeDate?: InputMaybe<Scalars['ISO8601Date']>;
  byBookkeeperDocuments?: InputMaybe<Scalars['Boolean']>;
  byPendingAssignment: Scalars['Boolean'];
  byTrashBin: Scalars['Boolean'];
  byWithoutFolder?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['Int']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  excludedType?: InputMaybe<Scalars['String']>;
  folderId?: InputMaybe<Scalars['Int']>;
  fromEmployees?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  incidenceId?: InputMaybe<Scalars['Int']>;
  includeTrashBin?: InputMaybe<Scalars['Boolean']>;
  leaveId?: InputMaybe<Scalars['Int']>;
  payrollHiringId?: InputMaybe<Scalars['Int']>;
  relationships?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  sort: Scalars['String'];
  space?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** Payload for due_payments_update and subscription: payment_count_updated */
export type Due_Payments_Update_Payment_Count_Updated_Type = {
  __typename?: 'due_payments_update_payment_count_updated_type';
  companyId: Scalars['Int'];
  country: Scalars['String'];
  dueInvoicesCount: Scalars['Int'];
  error?: Maybe<Scalars['Boolean']>;
  subscriptionId: Scalars['String'];
};

export type EmployeeOnboarding = {
  __typename?: 'employeeOnboarding';
  _policies: EmployeeOnboardingContextlessPolicies;
  /** @deprecated Please favor `employeeOnboardingsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  employeeOnboardings: Array<EmployeeOnboardingEmployeeOnboarding>;
  employeeOnboardingsConnection: EmployeeOnboardingEmployeeOnboardingConnection;
};


export type EmployeeOnboardingEmployeeOnboardingsArgs = {
  employeeIds: Array<Scalars['Int']>;
};


export type EmployeeOnboardingEmployeeOnboardingsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds: Array<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

export type EmployeeUpdates = {
  __typename?: 'employeeUpdates';
  absence?: Maybe<EmployeeUpdatesAbsence>;
  /** @deprecated Please favor `absencesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  absences: Array<EmployeeUpdatesAbsence>;
  absencesConnection: EmployeeUpdatesAbsenceConnection;
  contractChange?: Maybe<EmployeeUpdatesContractChange>;
  /** @deprecated Please favor `contractChangesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  contractChanges: Array<EmployeeUpdatesContractChange>;
  contractChangesConnection: EmployeeUpdatesContractChangeConnection;
  newHire?: Maybe<EmployeeUpdatesNewHire>;
  /** @deprecated Please favor `newHiresConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  newHires: Array<EmployeeUpdatesNewHire>;
  newHiresConnection: EmployeeUpdatesNewHireConnection;
  personalChange?: Maybe<EmployeeUpdatesPersonalChange>;
  /** @deprecated Please favor `personalChangesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  personalChanges: Array<EmployeeUpdatesPersonalChange>;
  personalChangesConnection: EmployeeUpdatesPersonalChangeConnection;
  /** @deprecated Please favor `summariesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  summaries: Array<EmployeeUpdatesSummary>;
  summariesConnection: EmployeeUpdatesSummaryConnection;
  summary?: Maybe<EmployeeUpdatesSummary>;
  termination?: Maybe<EmployeeUpdatesTermination>;
  /** @deprecated Please favor `terminationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  terminations: Array<EmployeeUpdatesTermination>;
  terminationsConnection: EmployeeUpdatesTerminationConnection;
};


export type EmployeeUpdatesAbsenceArgs = {
  id: Scalars['Int'];
};


export type EmployeeUpdatesAbsencesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type EmployeeUpdatesAbsencesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type EmployeeUpdatesContractChangeArgs = {
  id: Scalars['Int'];
};


export type EmployeeUpdatesContractChangesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type EmployeeUpdatesContractChangesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type EmployeeUpdatesNewHireArgs = {
  id: Scalars['Int'];
};


export type EmployeeUpdatesNewHiresArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type EmployeeUpdatesNewHiresConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type EmployeeUpdatesPersonalChangeArgs = {
  id: Scalars['Int'];
};


export type EmployeeUpdatesPersonalChangesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type EmployeeUpdatesPersonalChangesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type EmployeeUpdatesSummariesArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endsOn?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntitiesIds?: InputMaybe<Array<Scalars['Int']>>;
  startsOn?: InputMaybe<Scalars['ISO8601Date']>;
  type?: InputMaybe<Array<Scalars['String']>>;
};


export type EmployeeUpdatesSummariesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endsOn?: InputMaybe<Scalars['ISO8601Date']>;
  filter?: InputMaybe<EmployeeUpdatesSummaryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntitiesIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startsOn?: InputMaybe<Scalars['ISO8601Date']>;
  type?: InputMaybe<Array<Scalars['String']>>;
};


export type EmployeeUpdatesSummaryArgs = {
  id: Scalars['Int'];
};


export type EmployeeUpdatesTerminationArgs = {
  id: Scalars['Int'];
};


export type EmployeeUpdatesTerminationsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type EmployeeUpdatesTerminationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

export type Employees = {
  __typename?: 'employees';
  _policies: EmployeesContextlessPolicies;
  /** @deprecated Please favor `ageHeadcountsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  ageHeadcounts: Array<EmployeesAgeHeadcount>;
  ageHeadcountsConnection: EmployeesAgeHeadcountConnection;
  employee?: Maybe<EmployeesEmployee>;
  employeeGroup?: Maybe<EmployeesEmployeeGroup>;
  /** @deprecated Please favor `employeeGroupsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  employeeGroups: Array<EmployeesEmployeeGroup>;
  employeeGroupsConnection: EmployeesEmployeeGroupConnection;
  employeeName?: Maybe<EmployeesEmployeeName>;
  /** @deprecated Please favor `employeeNamesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  employeeNames: Array<EmployeesEmployeeName>;
  employeeNamesConnection: EmployeesEmployeeNameConnection;
  /** @deprecated Please favor `employeesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  employees: Array<EmployeesEmployee>;
  employeesConnection: EmployeesEmployeeConnection;
  /** @deprecated Please favor `genderHeadcountCategoricalsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  genderHeadcountCategoricals: Array<EmployeesGenderHeadcountCategorical>;
  genderHeadcountCategoricalsConnection: EmployeesGenderHeadcountCategoricalConnection;
  /** @deprecated Please favor `genderHeadcountsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  genderHeadcounts: Array<EmployeesGenderHeadcount>;
  genderHeadcountsConnection: EmployeesGenderHeadcountConnection;
  /** @deprecated Please favor `reporteesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  reportees: Array<EmployeesReportee>;
  reporteesConnection: EmployeesReporteeConnection;
  /** @deprecated Please favor `teamHeadcountsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  teamHeadcounts: Array<EmployeesTeamHeadcount>;
  teamHeadcountsConnection: EmployeesTeamHeadcountConnection;
};


export type EmployeesAgeHeadcountsArgs = {
  companyId: Scalars['Int'];
  costCenters?: InputMaybe<Array<Scalars['Int']>>;
  cycle: ReportsInsightsCycleEnum;
  employees?: InputMaybe<Array<Scalars['Int']>>;
  endDate: Scalars['ISO8601Date'];
  forFinancialWorkspace?: InputMaybe<Scalars['Boolean']>;
  genders?: InputMaybe<Array<Scalars['String']>>;
  legalEntities?: InputMaybe<Array<Scalars['Int']>>;
  managers?: InputMaybe<Array<Scalars['Int']>>;
  nationalities?: InputMaybe<Array<Scalars['String']>>;
  startDate: Scalars['ISO8601Date'];
  teams?: InputMaybe<Array<Scalars['Int']>>;
  withNoGender?: Scalars['Boolean'];
  withNoManager?: Scalars['Boolean'];
  withNoNationality?: Scalars['Boolean'];
  workplaces?: InputMaybe<Array<Scalars['Int']>>;
};


export type EmployeesAgeHeadcountsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  costCenters?: InputMaybe<Array<Scalars['Int']>>;
  cycle: ReportsInsightsCycleEnum;
  employees?: InputMaybe<Array<Scalars['Int']>>;
  endDate: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  forFinancialWorkspace?: InputMaybe<Scalars['Boolean']>;
  genders?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntities?: InputMaybe<Array<Scalars['Int']>>;
  managers?: InputMaybe<Array<Scalars['Int']>>;
  nationalities?: InputMaybe<Array<Scalars['String']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startDate: Scalars['ISO8601Date'];
  teams?: InputMaybe<Array<Scalars['Int']>>;
  withNoGender?: Scalars['Boolean'];
  withNoManager?: Scalars['Boolean'];
  withNoNationality?: Scalars['Boolean'];
  workplaces?: InputMaybe<Array<Scalars['Int']>>;
};


export type EmployeesEmployeeArgs = {
  id: Scalars['Int'];
};


export type EmployeesEmployeeGroupArgs = {
  id: Scalars['Int'];
};


export type EmployeesEmployeeGroupsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type EmployeesEmployeeGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type EmployeesEmployeeNameArgs = {
  id: Scalars['Int'];
};


export type EmployeesEmployeeNamesArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  afterEmployeeId?: InputMaybe<Scalars['Int']>;
  beforeEmployeeId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  reporteesOrLed?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyId?: InputMaybe<Scalars['Int']>;
  verb?: InputMaybe<Scalars['String']>;
  withActiveContract?: Scalars['Boolean'];
};


export type EmployeesEmployeeNamesConnectionArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  after?: InputMaybe<Scalars['String']>;
  afterEmployeeId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  beforeEmployeeId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<EmployeesEmployeeNameFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  reporteesOrLed?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyId?: InputMaybe<Scalars['Int']>;
  verb?: InputMaybe<Scalars['String']>;
  withActiveContract?: Scalars['Boolean'];
};


export type EmployeesEmployeesArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


export type EmployeesEmployeesConnectionArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  accessStatus?: InputMaybe<Array<Scalars['String']>>;
  affiliation?: InputMaybe<Array<AccessAffiliationEnum>>;
  after?: InputMaybe<Scalars['String']>;
  attendancePolicyId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Array<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  filter?: InputMaybe<EmployeesEmployeeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  fullTextName?: InputMaybe<Scalars['String']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeActiveAndTerminated?: Scalars['Boolean'];
  includeDenormalizedData?: Scalars['Boolean'];
  includeLocations?: Scalars['Boolean'];
  includePayrollIdentifiers?: Scalars['Boolean'];
  includeTeams?: Scalars['Boolean'];
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyActive?: Scalars['Boolean'];
  onlyDirectReports?: Scalars['Boolean'];
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  promotionStatus?: InputMaybe<Array<Scalars['String']>>;
  referenceContractJobTitles?: InputMaybe<Array<Scalars['String']>>;
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractStartsOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractStartsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Sort>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDateGteq?: InputMaybe<Scalars['ISO8601Date']>;
  tenureDateLteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnGteq?: InputMaybe<Scalars['ISO8601Date']>;
  terminatedOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAtLteq?: InputMaybe<Scalars['ISO8601Date']>;
  withCostCenterAssignments?: InputMaybe<Scalars['Boolean']>;
};


export type EmployeesGenderHeadcountCategoricalsArgs = {
  companyId: Scalars['Int'];
  costCenters?: InputMaybe<Array<Scalars['Int']>>;
  cycle: ReportsInsightsCycleEnum;
  employees?: InputMaybe<Array<Scalars['Int']>>;
  endDate: Scalars['ISO8601Date'];
  forFinancialWorkspace?: InputMaybe<Scalars['Boolean']>;
  genders?: InputMaybe<Array<Scalars['String']>>;
  legalEntities?: InputMaybe<Array<Scalars['Int']>>;
  managers?: InputMaybe<Array<Scalars['Int']>>;
  nationalities?: InputMaybe<Array<Scalars['String']>>;
  startDate: Scalars['ISO8601Date'];
  teams?: InputMaybe<Array<Scalars['Int']>>;
  withNoGender?: Scalars['Boolean'];
  withNoManager?: Scalars['Boolean'];
  withNoNationality?: Scalars['Boolean'];
  workplaces?: InputMaybe<Array<Scalars['Int']>>;
};


export type EmployeesGenderHeadcountCategoricalsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  costCenters?: InputMaybe<Array<Scalars['Int']>>;
  cycle: ReportsInsightsCycleEnum;
  employees?: InputMaybe<Array<Scalars['Int']>>;
  endDate: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  forFinancialWorkspace?: InputMaybe<Scalars['Boolean']>;
  genders?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntities?: InputMaybe<Array<Scalars['Int']>>;
  managers?: InputMaybe<Array<Scalars['Int']>>;
  nationalities?: InputMaybe<Array<Scalars['String']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startDate: Scalars['ISO8601Date'];
  teams?: InputMaybe<Array<Scalars['Int']>>;
  withNoGender?: Scalars['Boolean'];
  withNoManager?: Scalars['Boolean'];
  withNoNationality?: Scalars['Boolean'];
  workplaces?: InputMaybe<Array<Scalars['Int']>>;
};


export type EmployeesGenderHeadcountsArgs = {
  companyId: Scalars['Int'];
  costCenters?: InputMaybe<Array<Scalars['Int']>>;
  cycle: ReportsInsightsCycleEnum;
  employees?: InputMaybe<Array<Scalars['Int']>>;
  endDate: Scalars['ISO8601Date'];
  forFinancialWorkspace?: InputMaybe<Scalars['Boolean']>;
  genders?: InputMaybe<Array<Scalars['String']>>;
  legalEntities?: InputMaybe<Array<Scalars['Int']>>;
  managers?: InputMaybe<Array<Scalars['Int']>>;
  nationalities?: InputMaybe<Array<Scalars['String']>>;
  startDate: Scalars['ISO8601Date'];
  teams?: InputMaybe<Array<Scalars['Int']>>;
  withNoGender?: Scalars['Boolean'];
  withNoManager?: Scalars['Boolean'];
  withNoNationality?: Scalars['Boolean'];
  workplaces?: InputMaybe<Array<Scalars['Int']>>;
};


export type EmployeesGenderHeadcountsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  costCenters?: InputMaybe<Array<Scalars['Int']>>;
  cycle: ReportsInsightsCycleEnum;
  employees?: InputMaybe<Array<Scalars['Int']>>;
  endDate: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  forFinancialWorkspace?: InputMaybe<Scalars['Boolean']>;
  genders?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntities?: InputMaybe<Array<Scalars['Int']>>;
  managers?: InputMaybe<Array<Scalars['Int']>>;
  nationalities?: InputMaybe<Array<Scalars['String']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startDate: Scalars['ISO8601Date'];
  teams?: InputMaybe<Array<Scalars['Int']>>;
  withNoGender?: Scalars['Boolean'];
  withNoManager?: Scalars['Boolean'];
  withNoNationality?: Scalars['Boolean'];
  workplaces?: InputMaybe<Array<Scalars['Int']>>;
};


export type EmployeesReporteesArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  direct?: Scalars['Boolean'];
  employeeId?: InputMaybe<Scalars['Int']>;
};


export type EmployeesReporteesConnectionArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  direct?: Scalars['Boolean'];
  employeeId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type EmployeesTeamHeadcountsArgs = {
  companyId: Scalars['Int'];
  costCenters?: InputMaybe<Array<Scalars['Int']>>;
  cycle: ReportsInsightsCycleEnum;
  employees?: InputMaybe<Array<Scalars['Int']>>;
  endDate: Scalars['ISO8601Date'];
  forFinancialWorkspace?: InputMaybe<Scalars['Boolean']>;
  genders?: InputMaybe<Array<Scalars['String']>>;
  legalEntities?: InputMaybe<Array<Scalars['Int']>>;
  managers?: InputMaybe<Array<Scalars['Int']>>;
  nationalities?: InputMaybe<Array<Scalars['String']>>;
  startDate: Scalars['ISO8601Date'];
  teams?: InputMaybe<Array<Scalars['Int']>>;
  withNoGender?: Scalars['Boolean'];
  withNoManager?: Scalars['Boolean'];
  withNoNationality?: Scalars['Boolean'];
  workplaces?: InputMaybe<Array<Scalars['Int']>>;
};


export type EmployeesTeamHeadcountsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  costCenters?: InputMaybe<Array<Scalars['Int']>>;
  cycle: ReportsInsightsCycleEnum;
  employees?: InputMaybe<Array<Scalars['Int']>>;
  endDate: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  forFinancialWorkspace?: InputMaybe<Scalars['Boolean']>;
  genders?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntities?: InputMaybe<Array<Scalars['Int']>>;
  managers?: InputMaybe<Array<Scalars['Int']>>;
  nationalities?: InputMaybe<Array<Scalars['String']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startDate: Scalars['ISO8601Date'];
  teams?: InputMaybe<Array<Scalars['Int']>>;
  withNoGender?: Scalars['Boolean'];
  withNoManager?: Scalars['Boolean'];
  withNoNationality?: Scalars['Boolean'];
  workplaces?: InputMaybe<Array<Scalars['Int']>>;
};

export type EmployeesMutations = {
  __typename?: 'employeesMutations';
  bulkAssignToEmployeeGroupEmployeesEmployee: BulkAssignToEmployeeGroupEmployeesEmployeePayload;
  createEmployeesEmployee: CreateEmployeesEmployeePayload;
  createEmployeesEmployeeGroup: CreateEmployeesEmployeeGroupPayload;
  createInBulkEmployeesEmployee: CreateInBulkEmployeesEmployeePayload;
  createWithContractEmployeesEmployee: CreateWithContractEmployeesEmployeePayload;
  deleteEmployeesEmployeeGroup: DeleteEmployeesEmployeeGroupPayload;
  inviteEmployeesEmployee: InviteEmployeesEmployeePayload;
  setRegularAccessStartDateEmployeesEmployee: SetRegularAccessStartDateEmployeesEmployeePayload;
  terminateEmployeesEmployee: TerminateEmployeesEmployeePayload;
  unterminateEmployeesEmployee: UnterminateEmployeesEmployeePayload;
  updateEmployeesEmployee: UpdateEmployeesEmployeePayload;
  updateEmployeesEmployeeGroup: UpdateEmployeesEmployeeGroupPayload;
  updateInBulkEmployeesEmployee: UpdateInBulkEmployeesEmployeePayload;
};


export type EmployeesMutationsBulkAssignToEmployeeGroupEmployeesEmployeeArgs = {
  employeeGroupId: Scalars['Int'];
  employeeIds: Array<Scalars['Int']>;
  legalEntityId: Scalars['Int'];
};


export type EmployeesMutationsCreateEmployeesEmployeeArgs = {
  accessId: Scalars['Int'];
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  affiliation?: InputMaybe<Scalars['String']>;
  bankNumber?: InputMaybe<Scalars['String']>;
  birthdayOn?: InputMaybe<Scalars['ISO8601Date']>;
  city?: InputMaybe<Scalars['String']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  disabilityPercentageCents?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['String']>;
  employeeGroupId?: InputMaybe<Scalars['Int']>;
  firstName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  identifier?: InputMaybe<Scalars['String']>;
  identifierExpirationDate?: InputMaybe<Scalars['ISO8601Date']>;
  identifierType?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  locationId?: InputMaybe<Scalars['Int']>;
  managerId?: InputMaybe<Scalars['Int']>;
  nationality?: InputMaybe<Scalars['String']>;
  onboardingProcessId?: InputMaybe<Scalars['Int']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  regularAccessStartsOn?: InputMaybe<Scalars['ISO8601Date']>;
  seniorityCalculationDate?: InputMaybe<Scalars['ISO8601Date']>;
  source?: InputMaybe<EmployeesEmployeeSourceInput>;
  spanishEmployeeFields?: InputMaybe<EmployeesSpanishEmployeeFieldsInput>;
  state?: InputMaybe<Scalars['String']>;
  swiftBic?: InputMaybe<Scalars['String']>;
  timeoffManagerId?: InputMaybe<Scalars['Int']>;
};


export type EmployeesMutationsCreateEmployeesEmployeeGroupArgs = {
  legalEntityId: Scalars['Int'];
  main?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
};


export type EmployeesMutationsCreateInBulkEmployeesEmployeeArgs = {
  accessId: Scalars['Int'];
  employees: Scalars['String'];
  importerProcessUuid: Scalars['String'];
};


export type EmployeesMutationsCreateWithContractEmployeesEmployeeArgs = {
  a3InnuvaCode?: InputMaybe<Scalars['String']>;
  a3NomCode?: InputMaybe<Scalars['String']>;
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  bankNumber?: InputMaybe<Scalars['String']>;
  bankNumberFormat?: InputMaybe<Scalars['String']>;
  birthdayOn?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contactName?: InputMaybe<Scalars['String']>;
  contactNumber?: InputMaybe<Scalars['String']>;
  contractEffectiveOn?: InputMaybe<Scalars['String']>;
  contractIsDiscontinuous?: InputMaybe<Scalars['Boolean']>;
  contractStartsOn?: InputMaybe<Scalars['String']>;
  contractsAnnualWorkingTimeDistribution?: InputMaybe<ContractsAnnualWorkingTimeDistributionEnum>;
  contractsBankHolidayTreatment?: InputMaybe<ContractsBankHolidayTreatmentEnum>;
  contractsMaxLegalYearlyHours?: InputMaybe<Scalars['Int']>;
  contractsMaximumWeeklyHours?: InputMaybe<Scalars['Int']>;
  contractsWorkingTimePercentageInCents?: InputMaybe<Scalars['Int']>;
  country?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  employeeGroupId?: InputMaybe<Scalars['Int']>;
  endsOn?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  franceContractFields?: InputMaybe<EmployeesFranceContractFieldsInput>;
  gender?: InputMaybe<Scalars['String']>;
  germanyContractFields?: InputMaybe<EmployeesGermanyContractFieldsInput>;
  hasTrialPeriod?: InputMaybe<Scalars['Boolean']>;
  identifier?: InputMaybe<Scalars['String']>;
  identifierExpirationDate?: InputMaybe<Scalars['ISO8601Date']>;
  identifierType?: InputMaybe<Scalars['String']>;
  itAssetIds?: InputMaybe<Array<Scalars['String']>>;
  jobCatalogLevelId?: InputMaybe<Scalars['Int']>;
  jobCatalogTreeNodeUuid?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  legalEntityId?: InputMaybe<Scalars['Int']>;
  locationId?: InputMaybe<Scalars['Int']>;
  managerId?: InputMaybe<Scalars['Int']>;
  nationality?: InputMaybe<Scalars['String']>;
  onboardingProcessId?: InputMaybe<Scalars['Int']>;
  payrollPolicyId?: InputMaybe<Scalars['Int']>;
  permissionsGroupId?: InputMaybe<Scalars['Int']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  portugalContractFields?: InputMaybe<EmployeesPortugalContractFieldsInput>;
  postalCode?: InputMaybe<Scalars['String']>;
  salaryAmountInCents?: InputMaybe<Scalars['Int']>;
  salaryFrequency?: InputMaybe<Scalars['String']>;
  sendInvitation?: InputMaybe<Scalars['Boolean']>;
  seniorityCalculationDate?: InputMaybe<Scalars['String']>;
  socialSecurityNumber?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<EmployeesEmployeeSourceInput>;
  spainContractFields?: InputMaybe<EmployeesSpainContractFieldsInput>;
  state?: InputMaybe<Scalars['String']>;
  swiftBic?: InputMaybe<Scalars['String']>;
  teamId?: InputMaybe<Scalars['Int']>;
  timeoffManagerId?: InputMaybe<Scalars['Int']>;
  trialPeriodEndsOn?: InputMaybe<Scalars['String']>;
  withWelcomeSpace?: InputMaybe<Scalars['Boolean']>;
  workingHours?: InputMaybe<Scalars['Int']>;
  workingHoursFrequency?: InputMaybe<Scalars['String']>;
  workingWeekDays?: InputMaybe<Scalars['String']>;
};


export type EmployeesMutationsDeleteEmployeesEmployeeGroupArgs = {
  id: Scalars['Int'];
};


export type EmployeesMutationsInviteEmployeesEmployeeArgs = {
  authorId?: InputMaybe<Scalars['Int']>;
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type EmployeesMutationsSetRegularAccessStartDateEmployeesEmployeeArgs = {
  id: Scalars['Int'];
  startsOn?: InputMaybe<Scalars['ISO8601Date']>;
};


export type EmployeesMutationsTerminateEmployeesEmployeeArgs = {
  contractEndDate?: InputMaybe<Scalars['ISO8601Date']>;
  id: Scalars['Int'];
  stopPendingApprovals?: InputMaybe<Scalars['Boolean']>;
  terminatedOn: Scalars['ISO8601Date'];
  terminationAssignedManagerId?: InputMaybe<Scalars['Int']>;
  terminationReason?: InputMaybe<Scalars['String']>;
  terminationReasonType?: InputMaybe<Scalars['String']>;
  terminationTypeId?: InputMaybe<Scalars['Int']>;
};


export type EmployeesMutationsUnterminateEmployeesEmployeeArgs = {
  id: Scalars['Int'];
};


export type EmployeesMutationsUpdateEmployeesEmployeeArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  attendable?: InputMaybe<Scalars['Boolean']>;
  bankNumber?: InputMaybe<Scalars['String']>;
  birthName?: InputMaybe<Scalars['String']>;
  birthdayOn?: InputMaybe<Scalars['ISO8601Date']>;
  birthplace?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  companyIdentifier?: InputMaybe<Scalars['String']>;
  contactName?: InputMaybe<Scalars['String']>;
  contactNumber?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  countryOfBirth?: InputMaybe<Scalars['String']>;
  disabilityPercentageCents?: InputMaybe<Scalars['Int']>;
  employeeGroupId?: InputMaybe<Scalars['Int']>;
  firstName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  gqlAddressLine1?: InputMaybe<Scalars['String']>;
  gqlAddressLine2?: InputMaybe<Scalars['String']>;
  hasWorkPermit?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  identifier?: InputMaybe<Scalars['String']>;
  identifierExpirationDate?: InputMaybe<Scalars['ISO8601Date']>;
  identifierType?: InputMaybe<Scalars['String']>;
  irpf?: InputMaybe<Scalars['Int']>;
  irpfInCents?: InputMaybe<Scalars['Int']>;
  lastName?: InputMaybe<Scalars['String']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  locationId?: InputMaybe<Scalars['Int']>;
  managerId?: InputMaybe<Scalars['Int']>;
  nationality?: InputMaybe<Scalars['String']>;
  paymentFrequency?: InputMaybe<Scalars['String']>;
  personalEmail?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  preferredName?: InputMaybe<Scalars['String']>;
  pronouns?: InputMaybe<Scalars['String']>;
  regularAccessStartsOn?: InputMaybe<Scalars['ISO8601Date']>;
  seniorityCalculationDate?: InputMaybe<Scalars['ISO8601Date']>;
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  socialSecurityNumber?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  swiftBic?: InputMaybe<Scalars['String']>;
  taxResidence?: InputMaybe<EmployeesTaxResidenceFieldsInput>;
  timeoffManagerId?: InputMaybe<Scalars['Int']>;
  timeoffPolicyId?: InputMaybe<Scalars['Int']>;
  validateTimeoffPolicyReassignment?: InputMaybe<Scalars['Boolean']>;
};


export type EmployeesMutationsUpdateEmployeesEmployeeGroupArgs = {
  id: Scalars['Int'];
  main?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};


export type EmployeesMutationsUpdateInBulkEmployeesEmployeeArgs = {
  accessId: Scalars['Int'];
};

export type Engagement = {
  __typename?: 'engagement';
  _policies: EngagementContextlessPolicies;
  employeeCurrentPulse?: Maybe<EngagementEmployeeCurrentPulse>;
  /** @deprecated Please favor `employeeCurrentPulsesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  employeeCurrentPulses: Array<EngagementEmployeeCurrentPulse>;
  employeeCurrentPulsesConnection: EngagementEmployeeCurrentPulseConnection;
  employeePulse?: Maybe<EngagementEmployeePulse>;
  employeePulseInsight?: Maybe<EngagementEmployeePulseInsight>;
  employeePulseInsightGroup?: Maybe<EngagementEmployeePulseInsightGroup>;
  /** @deprecated Please favor `employeePulseInsightGroupsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  employeePulseInsightGroups: Array<EngagementEmployeePulseInsightGroup>;
  employeePulseInsightGroupsConnection: EngagementEmployeePulseInsightGroupConnection;
  /** @deprecated Please favor `employeePulseInsightsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  employeePulseInsights: Array<EngagementEmployeePulseInsight>;
  employeePulseInsightsConnection: EngagementEmployeePulseInsightConnection;
  employeePulseMedian?: Maybe<EngagementEmployeePulseMedian>;
  /** @deprecated Please favor `employeePulseMediansConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  employeePulseMedians: Array<EngagementEmployeePulseMedian>;
  employeePulseMediansConnection: EngagementEmployeePulseMedianConnection;
  /** @deprecated Please favor `employeePulseSummariesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  employeePulseSummaries: Array<EngagementEmployeePulseSummary>;
  employeePulseSummariesConnection: EngagementEmployeePulseSummaryConnection;
  employeePulseSummary?: Maybe<EngagementEmployeePulseSummary>;
  employeePulseTopicInsight?: Maybe<EngagementEmployeePulseTopicInsight>;
  /** @deprecated Please favor `employeePulseTopicInsightsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  employeePulseTopicInsights: Array<EngagementEmployeePulseTopicInsight>;
  employeePulseTopicInsightsConnection: EngagementEmployeePulseTopicInsightConnection;
  /** @deprecated Please favor `employeePulsesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  employeePulses: Array<EngagementEmployeePulse>;
  employeePulsesConnection: EngagementEmployeePulseConnection;
  pulseTag?: Maybe<EngagementPulseTag>;
  /** @deprecated Please favor `pulseTagsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  pulseTags: Array<EngagementPulseTag>;
  pulseTagsConnection: EngagementPulseTagConnection;
  setting?: Maybe<EngagementSetting>;
  /** @deprecated Please favor `settingsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  settings: Array<EngagementSetting>;
  settingsConnection: EngagementSettingConnection;
};


export type EngagementEmployeeCurrentPulseArgs = {
  id: Scalars['Int'];
};


export type EngagementEmployeeCurrentPulsesArgs = {
  ids?: Array<Scalars['Int']>;
};


export type EngagementEmployeeCurrentPulsesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: Array<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type EngagementEmployeePulseArgs = {
  id: Scalars['Int'];
};


export type EngagementEmployeePulseInsightArgs = {
  id: Scalars['Int'];
};


export type EngagementEmployeePulseInsightGroupArgs = {
  groupBy: EngagementDtosEmployeePulseInsightGroupsGroupByEnum;
  id: Scalars['Int'];
};


export type EngagementEmployeePulseInsightGroupsArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  genders?: InputMaybe<Array<Scalars['String']>>;
  gridStatus?: InputMaybe<Array<Scalars['String']>>;
  groupBy: EngagementDtosEmployeePulseInsightGroupsGroupByEnum;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nationalities?: InputMaybe<Array<Scalars['String']>>;
  potentialScoreRange?: InputMaybe<Array<Scalars['String']>>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  pulseValues?: InputMaybe<Array<Scalars['Int']>>;
  scoreRange?: InputMaybe<Array<Scalars['String']>>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDate?: InputMaybe<Array<Scalars['String']>>;
  workspaceIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type EngagementEmployeePulseInsightGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  genders?: InputMaybe<Array<Scalars['String']>>;
  gridStatus?: InputMaybe<Array<Scalars['String']>>;
  groupBy: EngagementDtosEmployeePulseInsightGroupsGroupByEnum;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nationalities?: InputMaybe<Array<Scalars['String']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  potentialScoreRange?: InputMaybe<Array<Scalars['String']>>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  pulseValues?: InputMaybe<Array<Scalars['Int']>>;
  scoreRange?: InputMaybe<Array<Scalars['String']>>;
  sortOrder?: InputMaybe<Sort>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDate?: InputMaybe<Array<Scalars['String']>>;
  workspaceIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type EngagementEmployeePulseInsightsArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  genders?: InputMaybe<Array<Scalars['String']>>;
  gridStatus?: InputMaybe<Array<Scalars['String']>>;
  groupBy?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nationalities?: InputMaybe<Array<Scalars['String']>>;
  potentialScoreRange?: InputMaybe<Array<Scalars['String']>>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  pulseValues?: InputMaybe<Array<Scalars['Int']>>;
  scoreRange?: InputMaybe<Array<Scalars['String']>>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDate?: InputMaybe<Array<Scalars['String']>>;
  workspaceIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type EngagementEmployeePulseInsightsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  filter?: InputMaybe<EngagementEmployeePulseInsightFilter>;
  first?: InputMaybe<Scalars['Int']>;
  genders?: InputMaybe<Array<Scalars['String']>>;
  gridStatus?: InputMaybe<Array<Scalars['String']>>;
  groupBy?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nationalities?: InputMaybe<Array<Scalars['String']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  potentialScoreRange?: InputMaybe<Array<Scalars['String']>>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  pulseValues?: InputMaybe<Array<Scalars['Int']>>;
  scoreRange?: InputMaybe<Array<Scalars['String']>>;
  sortOrder?: InputMaybe<Sort>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDate?: InputMaybe<Array<Scalars['String']>>;
  workspaceIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type EngagementEmployeePulseMedianArgs = {
  id: Scalars['Int'];
};


export type EngagementEmployeePulseMediansArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  values?: InputMaybe<Array<Scalars['Int']>>;
};


export type EngagementEmployeePulseMediansConnectionArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  values?: InputMaybe<Array<Scalars['Int']>>;
};


export type EngagementEmployeePulseSummariesArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  dateRange?: InputMaybe<DateRangeInput>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  managerId?: InputMaybe<Array<Scalars['Int']>>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  teamId?: InputMaybe<Array<Scalars['Int']>>;
  values?: InputMaybe<Array<Scalars['Int']>>;
  withTags?: Scalars['Boolean'];
};


export type EngagementEmployeePulseSummariesConnectionArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  dateRange?: InputMaybe<DateRangeInput>;
  filter?: InputMaybe<EngagementEmployeePulseSummaryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  managerId?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  teamId?: InputMaybe<Array<Scalars['Int']>>;
  values?: InputMaybe<Array<Scalars['Int']>>;
  withTags?: Scalars['Boolean'];
};


export type EngagementEmployeePulseSummaryArgs = {
  id: Scalars['Int'];
};


export type EngagementEmployeePulseTopicInsightArgs = {
  id: Scalars['Int'];
};


export type EngagementEmployeePulseTopicInsightsArgs = {
  dateRange?: InputMaybe<DateRangeInput>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  managerId?: InputMaybe<Array<Scalars['Int']>>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  teamId?: InputMaybe<Array<Scalars['Int']>>;
  values?: InputMaybe<Array<Scalars['Int']>>;
};


export type EngagementEmployeePulseTopicInsightsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  dateRange?: InputMaybe<DateRangeInput>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  managerId?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  teamId?: InputMaybe<Array<Scalars['Int']>>;
  values?: InputMaybe<Array<Scalars['Int']>>;
};


export type EngagementEmployeePulsesArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  dateRange?: InputMaybe<DateRangeInput>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  managedOnly?: InputMaybe<Scalars['Boolean']>;
};


export type EngagementEmployeePulsesConnectionArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  dateRange?: InputMaybe<DateRangeInput>;
  filter?: InputMaybe<EngagementEmployeePulseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  managedOnly?: InputMaybe<Scalars['Boolean']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type EngagementPulseTagArgs = {
  employeePulseIds: Array<Scalars['Int']>;
  id: Scalars['Int'];
};


export type EngagementPulseTagsArgs = {
  employeePulseIds: Array<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type EngagementPulseTagsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeePulseIds: Array<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type EngagementSettingArgs = {
  id: Scalars['Int'];
};


export type EngagementSettingsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type EngagementSettingsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

export type EngagementInsights = {
  __typename?: 'engagementInsights';
  _policies: EngagementInsightsContextlessPolicies;
  /** @deprecated Please favor `climateSurveyInsightsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  climateSurveyInsights: Array<EngagementInsightsClimateSurveyInsight>;
  climateSurveyInsightsConnection: EngagementInsightsClimateSurveyInsightConnection;
  /** @deprecated Please favor `enpsInsightsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  enpsInsights: Array<EngagementInsightsEnpsInsight>;
  enpsInsightsConnection: EngagementInsightsEnpsInsightConnection;
};


export type EngagementInsightsClimateSurveyInsightsArgs = {
  managerId?: InputMaybe<Scalars['Int']>;
};


export type EngagementInsightsClimateSurveyInsightsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  managerId?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type EngagementInsightsEnpsInsightsArgs = {
  managerId?: InputMaybe<Scalars['Int']>;
};


export type EngagementInsightsEnpsInsightsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  managerId?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

export type EngagementMutations = {
  __typename?: 'engagementMutations';
  createEngagementEmployeePulse: CreateEngagementEmployeePulsePayload;
  updateEngagementSetting: UpdateEngagementSettingPayload;
};


export type EngagementMutationsCreateEngagementEmployeePulseArgs = {
  comment?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['ISO8601Date']>;
  timezone?: InputMaybe<Scalars['String']>;
  value: Scalars['Int'];
};


export type EngagementMutationsUpdateEngagementSettingArgs = {
  days: Array<EngagementSettingDaysEnum>;
  employeePulseEnabled?: InputMaybe<Scalars['Boolean']>;
  frequency: EngagementSettingFrequencyEnum;
  id: Scalars['Int'];
  question: Scalars['String'];
  questionType: EngagementSettingQuestionTypeEnum;
};

export type Enps = {
  __typename?: 'enps';
  _policies: EnpsContextlessPolicies;
};

export type Esignature = {
  __typename?: 'esignature';
  /** @deprecated Please favor `requestsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  requests: Array<EsignatureRequest>;
  requestsConnection: EsignatureRequestConnection;
  signature?: Maybe<EsignatureSignature>;
  /** @deprecated Please favor `signaturesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  signatures: Array<EsignatureSignature>;
  signaturesConnection: EsignatureSignatureConnection;
};


export type EsignatureRequestsArgs = {
  documentId?: InputMaybe<Scalars['Int']>;
};


export type EsignatureRequestsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  documentId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type EsignatureSignatureArgs = {
  id: Scalars['Int'];
};


export type EsignatureSignaturesArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  documentId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  signed?: InputMaybe<Scalars['Boolean']>;
};


export type EsignatureSignaturesConnectionArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  documentId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  signed?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Sort>;
};

export type EsignatureMutations = {
  __typename?: 'esignatureMutations';
  bulkCreateEsignatureRequest: BulkCreateEsignatureRequestPayload;
  bulkResendSignatureEsignatureSignature: BulkResendSignatureEsignatureSignaturePayload;
  destroyEsignatureSignature: DestroyEsignatureSignaturePayload;
  downloadAuditTrailEsignatureSignature: DownloadAuditTrailEsignatureSignaturePayload;
  resendSignatureEsignatureSignature: ResendSignatureEsignatureSignaturePayload;
  syncDocumentEsignatureSignature: SyncDocumentEsignatureSignaturePayload;
};


export type EsignatureMutationsBulkCreateEsignatureRequestArgs = {
  documentId: Scalars['Int'];
  requesterId?: InputMaybe<Scalars['Int']>;
  signeesId: Array<Scalars['Int']>;
};


export type EsignatureMutationsBulkResendSignatureEsignatureSignatureArgs = {
  documentIds: Array<Scalars['Int']>;
};


export type EsignatureMutationsDestroyEsignatureSignatureArgs = {
  id: Scalars['Int'];
};


export type EsignatureMutationsDownloadAuditTrailEsignatureSignatureArgs = {
  id: Scalars['Int'];
};


export type EsignatureMutationsResendSignatureEsignatureSignatureArgs = {
  id: Scalars['Int'];
};


export type EsignatureMutationsSyncDocumentEsignatureSignatureArgs = {
  documentId: Scalars['Int'];
};

export type Expenses = {
  __typename?: 'expenses';
  _policies: ExpensesContextlessPolicies;
  /** @deprecated Please favor `approvalsTimelinesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  approvalsTimelines: Array<ExpensesApprovalsTimeline>;
  approvalsTimelinesConnection: ExpensesApprovalsTimelineConnection;
  card?: Maybe<ExpensesCard>;
  /** @deprecated Please favor `cardsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  cards: Array<ExpensesCard>;
  cardsConnection: ExpensesCardConnection;
  /** @deprecated Please favor `categoriesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  categories: Array<ExpensesCategory>;
  categoriesConnection: ExpensesCategoryConnection;
  category?: Maybe<ExpensesCategory>;
  closingPeriod?: Maybe<ExpensesClosingPeriod>;
  /** @deprecated Please favor `closingPeriodFrequenciesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  closingPeriodFrequencies: Array<ExpensesClosingPeriodFrequency>;
  closingPeriodFrequenciesConnection: ExpensesClosingPeriodFrequencyConnection;
  closingPeriodFrequency?: Maybe<ExpensesClosingPeriodFrequency>;
  /** @deprecated Please favor `closingPeriodsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  closingPeriods: Array<ExpensesClosingPeriod>;
  closingPeriodsConnection: ExpensesClosingPeriodConnection;
  companyPerDiemRate?: Maybe<ExpensesCompanyPerDiemRate>;
  /** @deprecated Please favor `companyPerDiemRatesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  companyPerDiemRates: Array<ExpensesCompanyPerDiemRate>;
  companyPerDiemRatesConnection: ExpensesCompanyPerDiemRateConnection;
  /** @deprecated Please favor `customizationFieldsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  customizationFields: Array<ExpensesCustomizationField>;
  customizationFieldsConnection: ExpensesCustomizationFieldConnection;
  expensable?: Maybe<ExpensesExpensable>;
  expensableGroup?: Maybe<ExpensesExpensableGroup>;
  /** @deprecated Please favor `expensableGroupsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  expensableGroups: Array<ExpensesExpensableGroup>;
  expensableGroupsConnection: ExpensesExpensableGroupConnection;
  expensableGroupsSetting?: Maybe<ExpensesExpensableGroupsSetting>;
  /** @deprecated Please favor `expensableGroupsSettingsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  expensableGroupsSettings: Array<ExpensesExpensableGroupsSetting>;
  expensableGroupsSettingsConnection: ExpensesExpensableGroupsSettingConnection;
  /** @deprecated Please favor `expensableReadyToReviewIssuesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  expensableReadyToReviewIssues: Array<ExpensesExpensableReadyToReviewIssue>;
  expensableReadyToReviewIssuesConnection: ExpensesExpensableReadyToReviewIssueConnection;
  /** @deprecated Please favor `expensablesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  expensables: Array<ExpensesExpensable>;
  expensablesByApprovalStatus?: Maybe<ExpensesExpensablesByApprovalStatus>;
  /** @deprecated Please favor `expensablesByApprovalStatusesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  expensablesByApprovalStatuses: Array<ExpensesExpensablesByApprovalStatus>;
  expensablesByApprovalStatusesConnection: ExpensesExpensablesByApprovalStatusConnection;
  expensablesByCategoryTotal?: Maybe<ExpensesExpensablesByCategoryTotal>;
  /** @deprecated Please favor `expensablesByCategoryTotalsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  expensablesByCategoryTotals: Array<ExpensesExpensablesByCategoryTotal>;
  expensablesByCategoryTotalsConnection: ExpensesExpensablesByCategoryTotalConnection;
  expensablesByCostCenter?: Maybe<ExpensesExpensablesByCostCenter>;
  /** @deprecated Please favor `expensablesByCostCentersConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  expensablesByCostCenters: Array<ExpensesExpensablesByCostCenter>;
  expensablesByCostCentersConnection: ExpensesExpensablesByCostCenterConnection;
  expensablesByEmployee?: Maybe<ExpensesExpensablesByEmployee>;
  /** @deprecated Please favor `expensablesByEmployeesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  expensablesByEmployees: Array<ExpensesExpensablesByEmployee>;
  expensablesByEmployeesConnection: ExpensesExpensablesByEmployeeConnection;
  expensablesByMonth?: Maybe<ExpensesExpensablesByMonth>;
  /** @deprecated Please favor `expensablesByMonthsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  expensablesByMonths: Array<ExpensesExpensablesByMonth>;
  expensablesByMonthsConnection: ExpensesExpensablesByMonthConnection;
  expensablesByTeam?: Maybe<ExpensesExpensablesByTeam>;
  /** @deprecated Please favor `expensablesByTeamsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  expensablesByTeams: Array<ExpensesExpensablesByTeam>;
  expensablesByTeamsConnection: ExpensesExpensablesByTeamConnection;
  expensablesConnection: ExpensesExpensableConnection;
  expense?: Maybe<ExpensesExpense>;
  /** @deprecated Please favor `expensesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  expenses: Array<ExpensesExpense>;
  expensesConnection: ExpensesExpenseConnection;
  /** @deprecated Please favor `expensesSubscriptionsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  expensesSubscriptions: Array<ExpensesExpensesSubscription>;
  expensesSubscriptionsConnection: ExpensesExpensesSubscriptionConnection;
  mileage?: Maybe<ExpensesMileage>;
  /** @deprecated Please favor `mileagesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  mileages: Array<ExpensesMileage>;
  mileagesConnection: ExpensesMileageConnection;
  officialPerDiemRate?: Maybe<ExpensesOfficialPerDiemRate>;
  /** @deprecated Please favor `officialPerDiemRatesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  officialPerDiemRates: Array<ExpensesOfficialPerDiemRate>;
  officialPerDiemRatesConnection: ExpensesOfficialPerDiemRateConnection;
  /** @deprecated Please favor `pendingClosingPeriodsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  pendingClosingPeriods: Array<ExpensesPendingClosingPeriod>;
  pendingClosingPeriodsConnection: ExpensesPendingClosingPeriodConnection;
  perDiem?: Maybe<ExpensesPerDiem>;
  perDiemRate?: Maybe<ExpensesPerDiemRate>;
  /** @deprecated Please favor `perDiemRatesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  perDiemRates: Array<ExpensesPerDiemRate>;
  perDiemRatesConnection: ExpensesPerDiemRateConnection;
  /** @deprecated Please favor `perDiemsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  perDiems: Array<ExpensesPerDiem>;
  perDiemsConnection: ExpensesPerDiemConnection;
  policyWorkflow?: Maybe<ExpensesPolicyWorkflow>;
  /** @deprecated Please favor `policyWorkflowsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  policyWorkflows: Array<ExpensesPolicyWorkflow>;
  policyWorkflowsConnection: ExpensesPolicyWorkflowConnection;
  rateConfiguration?: Maybe<ExpensesRateConfiguration>;
  rateConfigurationAssignee?: Maybe<ExpensesRateConfigurationAssignee>;
  /** @deprecated Please favor `rateConfigurationAssigneesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  rateConfigurationAssignees: Array<ExpensesRateConfigurationAssignee>;
  rateConfigurationAssigneesConnection: ExpensesRateConfigurationAssigneeConnection;
  /** @deprecated Please favor `rateConfigurationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  rateConfigurations: Array<ExpensesRateConfiguration>;
  rateConfigurationsConnection: ExpensesRateConfigurationConnection;
  signedDocumentsTerm?: Maybe<ExpensesSignedDocumentsTerm>;
  /** @deprecated Please favor `signedDocumentsTermsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  signedDocumentsTerms: Array<ExpensesSignedDocumentsTerm>;
  signedDocumentsTermsConnection: ExpensesSignedDocumentsTermConnection;
  signedInvoice?: Maybe<ExpensesSignedInvoice>;
  /** @deprecated Please favor `signedInvoicesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  signedInvoices: Array<ExpensesSignedInvoice>;
  signedInvoicesConnection: ExpensesSignedInvoiceConnection;
};


export type ExpensesApprovalsTimelinesArgs = {
  companyId: Scalars['Int'];
  expensableId: Scalars['Int'];
};


export type ExpensesApprovalsTimelinesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  expensableId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ExpensesCardArgs = {
  id: Scalars['Int'];
};


export type ExpensesCardsArgs = {
  accountExternalId?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  externalIds?: InputMaybe<Array<Scalars['String']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeSoftwareCards?: InputMaybe<Scalars['Boolean']>;
  last4?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};


export type ExpensesCardsConnectionArgs = {
  accountExternalId?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  externalIds?: InputMaybe<Array<Scalars['String']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeSoftwareCards?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  last4?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};


export type ExpensesCategoriesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  resourceType?: InputMaybe<FinanceServicesCustomCategoriesConfigResourceTypeEnum>;
};


export type ExpensesCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  resourceType?: InputMaybe<FinanceServicesCustomCategoriesConfigResourceTypeEnum>;
  sortOrder?: InputMaybe<Sort>;
};


export type ExpensesCategoryArgs = {
  id: Scalars['Int'];
};


export type ExpensesClosingPeriodArgs = {
  id: Scalars['Int'];
};


export type ExpensesClosingPeriodFrequenciesArgs = {
  forOrganization?: InputMaybe<ExpensesValueObjectsTaxAgencyOrganizationsEnum>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type ExpensesClosingPeriodFrequenciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forOrganization?: InputMaybe<ExpensesValueObjectsTaxAgencyOrganizationsEnum>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ExpensesClosingPeriodFrequencyArgs = {
  id: Scalars['Int'];
};


export type ExpensesClosingPeriodsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type ExpensesClosingPeriodsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ExpensesCompanyPerDiemRateArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type ExpensesCompanyPerDiemRatesArgs = {
  companyId: Scalars['Int'];
  currentlyActive?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  officialPerDiemRateIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


export type ExpensesCompanyPerDiemRatesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  currentlyActive?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  officialPerDiemRateIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ExpensesCustomizationFieldsArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  identifier?: InputMaybe<Scalars['String']>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  resourceType?: InputMaybe<Scalars['String']>;
};


export type ExpensesCustomizationFieldsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  identifier?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  resourceType?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ExpensesExpensableArgs = {
  id: Scalars['Int'];
};


export type ExpensesExpensableGroupArgs = {
  id: Scalars['Int'];
};


export type ExpensesExpensableGroupsArgs = {
  byStatus?: InputMaybe<ExpensesEntitiesExpensableStatusEnum>;
  companyId?: InputMaybe<Scalars['Int']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  from?: InputMaybe<Scalars['ISO8601DateTime']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeAttachments?: Scalars['Boolean'];
  includeDrafts?: Scalars['Boolean'];
  search?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['ISO8601DateTime']>;
};


export type ExpensesExpensableGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  byStatus?: InputMaybe<ExpensesEntitiesExpensableStatusEnum>;
  companyId?: InputMaybe<Scalars['Int']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  filter?: InputMaybe<ExpensesExpensableGroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['ISO8601DateTime']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeAttachments?: Scalars['Boolean'];
  includeDrafts?: Scalars['Boolean'];
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  to?: InputMaybe<Scalars['ISO8601DateTime']>;
};


export type ExpensesExpensableGroupsSettingArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type ExpensesExpensableGroupsSettingsArgs = {
  companyId: Scalars['Int'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type ExpensesExpensableGroupsSettingsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ExpensesExpensableReadyToReviewIssuesArgs = {
  expensableIds: Array<Scalars['Int']>;
};


export type ExpensesExpensableReadyToReviewIssuesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  expensableIds: Array<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ExpensesExpensablesArgs = {
  byResources?: InputMaybe<Array<ExpensablesByResourcesInput>>;
  categories?: InputMaybe<Array<Scalars['String']>>;
  companyId?: InputMaybe<Scalars['Int']>;
  creationType?: InputMaybe<Array<Scalars['String']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  from?: InputMaybe<Scalars['ISO8601DateTime']>;
  groupIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeAttachments?: Scalars['Boolean'];
  includeGrouped?: Scalars['Boolean'];
  includeManualDrafts?: Scalars['Boolean'];
  onlyGrouped?: InputMaybe<Scalars['Boolean']>;
  perDiemEndDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  perDiemStartDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  reporterIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Array<ExpensesEntitiesExpensableStatusEnum>>;
  to?: InputMaybe<Scalars['ISO8601DateTime']>;
  withReimbursableCurrency?: InputMaybe<Scalars['Boolean']>;
};


export type ExpensesExpensablesByApprovalStatusArgs = {
  companyId: Scalars['Int'];
  filters: ExpensesExpensableFiltersInput;
  from: Scalars['String'];
  id: Scalars['Int'];
  to: Scalars['String'];
};


export type ExpensesExpensablesByApprovalStatusesArgs = {
  companyId: Scalars['Int'];
  filters: ExpensesExpensableFiltersInput;
  from: Scalars['String'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  to: Scalars['String'];
};


export type ExpensesExpensablesByApprovalStatusesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  filters: ExpensesExpensableFiltersInput;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  to: Scalars['String'];
};


export type ExpensesExpensablesByCategoryTotalArgs = {
  companyId: Scalars['Int'];
  filters: ExpensesExpensableFiltersInput;
  from: Scalars['String'];
  id: Scalars['Int'];
  to: Scalars['String'];
};


export type ExpensesExpensablesByCategoryTotalsArgs = {
  companyId: Scalars['Int'];
  filters: ExpensesExpensableFiltersInput;
  from: Scalars['String'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  to: Scalars['String'];
};


export type ExpensesExpensablesByCategoryTotalsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  filter?: InputMaybe<ExpensesExpensablesByCategoryTotalFilter>;
  filters: ExpensesExpensableFiltersInput;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  to: Scalars['String'];
};


export type ExpensesExpensablesByCostCenterArgs = {
  companyId: Scalars['Int'];
  filters: ExpensesExpensableFiltersInput;
  from: Scalars['String'];
  id: Scalars['Int'];
  to: Scalars['String'];
};


export type ExpensesExpensablesByCostCentersArgs = {
  companyId: Scalars['Int'];
  filters: ExpensesExpensableFiltersInput;
  from: Scalars['String'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  to: Scalars['String'];
};


export type ExpensesExpensablesByCostCentersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  filter?: InputMaybe<ExpensesExpensablesByCostCenterFilter>;
  filters: ExpensesExpensableFiltersInput;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  to: Scalars['String'];
};


export type ExpensesExpensablesByEmployeeArgs = {
  companyId: Scalars['Int'];
  filters: ExpensesExpensableFiltersInput;
  from: Scalars['String'];
  id: Scalars['Int'];
  to: Scalars['String'];
};


export type ExpensesExpensablesByEmployeesArgs = {
  companyId: Scalars['Int'];
  filters: ExpensesExpensableFiltersInput;
  from: Scalars['String'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  to: Scalars['String'];
};


export type ExpensesExpensablesByEmployeesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  filter?: InputMaybe<ExpensesExpensablesByEmployeeFilter>;
  filters: ExpensesExpensableFiltersInput;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  to: Scalars['String'];
};


export type ExpensesExpensablesByMonthArgs = {
  companyId: Scalars['Int'];
  filters: ExpensesExpensableFiltersInput;
  from: Scalars['String'];
  id: Scalars['Int'];
  localTz: Scalars['String'];
  to: Scalars['String'];
};


export type ExpensesExpensablesByMonthsArgs = {
  companyId: Scalars['Int'];
  filters: ExpensesExpensableFiltersInput;
  from: Scalars['String'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  localTz: Scalars['String'];
  to: Scalars['String'];
};


export type ExpensesExpensablesByMonthsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  filters: ExpensesExpensableFiltersInput;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  localTz: Scalars['String'];
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  to: Scalars['String'];
};


export type ExpensesExpensablesByTeamArgs = {
  companyId: Scalars['Int'];
  filters: ExpensesExpensableFiltersInput;
  from: Scalars['String'];
  id: Scalars['Int'];
  to: Scalars['String'];
};


export type ExpensesExpensablesByTeamsArgs = {
  companyId: Scalars['Int'];
  filters: ExpensesExpensableFiltersInput;
  from: Scalars['String'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  to: Scalars['String'];
};


export type ExpensesExpensablesByTeamsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  filter?: InputMaybe<ExpensesExpensablesByTeamFilter>;
  filters: ExpensesExpensableFiltersInput;
  first?: InputMaybe<Scalars['Int']>;
  from: Scalars['String'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  to: Scalars['String'];
};


export type ExpensesExpensablesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  byResources?: InputMaybe<Array<ExpensablesByResourcesInput>>;
  categories?: InputMaybe<Array<Scalars['String']>>;
  companyId?: InputMaybe<Scalars['Int']>;
  creationType?: InputMaybe<Array<Scalars['String']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  filter?: InputMaybe<ExpensesExpensableFilter>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['ISO8601DateTime']>;
  groupIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeAttachments?: Scalars['Boolean'];
  includeGrouped?: Scalars['Boolean'];
  includeManualDrafts?: Scalars['Boolean'];
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyGrouped?: InputMaybe<Scalars['Boolean']>;
  perDiemEndDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  perDiemStartDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  reporterIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  status?: InputMaybe<Array<ExpensesEntitiesExpensableStatusEnum>>;
  to?: InputMaybe<Scalars['ISO8601DateTime']>;
  withReimbursableCurrency?: InputMaybe<Scalars['Boolean']>;
};


export type ExpensesExpenseArgs = {
  id: Scalars['Int'];
};


export type ExpensesExpensesArgs = {
  bookEntryIds?: InputMaybe<Array<Scalars['Int']>>;
  cardIds?: InputMaybe<Array<Scalars['Int']>>;
  cardPaymentIds?: InputMaybe<Array<Scalars['Int']>>;
  disputeIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  expensesExpensableIds?: InputMaybe<Array<Scalars['Int']>>;
  externalAuthorizationIds?: InputMaybe<Array<Scalars['String']>>;
  from?: InputMaybe<Scalars['ISO8601DateTime']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeAttachments?: Scalars['Boolean'];
  includeManualDrafts?: Scalars['Boolean'];
  includeReimbursableData?: InputMaybe<Scalars['Boolean']>;
  to?: InputMaybe<Scalars['ISO8601DateTime']>;
};


export type ExpensesExpensesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  bookEntryIds?: InputMaybe<Array<Scalars['Int']>>;
  cardIds?: InputMaybe<Array<Scalars['Int']>>;
  cardPaymentIds?: InputMaybe<Array<Scalars['Int']>>;
  disputeIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  expensesExpensableIds?: InputMaybe<Array<Scalars['Int']>>;
  externalAuthorizationIds?: InputMaybe<Array<Scalars['String']>>;
  filter?: InputMaybe<ExpensesExpenseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['ISO8601DateTime']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeAttachments?: Scalars['Boolean'];
  includeManualDrafts?: Scalars['Boolean'];
  includeReimbursableData?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  to?: InputMaybe<Scalars['ISO8601DateTime']>;
};


export type ExpensesExpensesSubscriptionsArgs = {
  companyId: Scalars['Int'];
};


export type ExpensesExpensesSubscriptionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ExpensesMileageArgs = {
  id: Scalars['Int'];
};


export type ExpensesMileagesArgs = {
  cardIds?: InputMaybe<Array<Scalars['Int']>>;
  cardPaymentIds?: InputMaybe<Array<Scalars['Int']>>;
  disputeIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  expensesExpensableIds?: InputMaybe<Array<Scalars['Int']>>;
  externalAuthorizationIds?: InputMaybe<Array<Scalars['String']>>;
  from?: InputMaybe<Scalars['ISO8601DateTime']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeAttachments?: Scalars['Boolean'];
  includeManualDrafts?: Scalars['Boolean'];
  to?: InputMaybe<Scalars['ISO8601DateTime']>;
};


export type ExpensesMileagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  cardIds?: InputMaybe<Array<Scalars['Int']>>;
  cardPaymentIds?: InputMaybe<Array<Scalars['Int']>>;
  disputeIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  expensesExpensableIds?: InputMaybe<Array<Scalars['Int']>>;
  externalAuthorizationIds?: InputMaybe<Array<Scalars['String']>>;
  filter?: InputMaybe<ExpensesMileageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['ISO8601DateTime']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeAttachments?: Scalars['Boolean'];
  includeManualDrafts?: Scalars['Boolean'];
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  to?: InputMaybe<Scalars['ISO8601DateTime']>;
};


export type ExpensesOfficialPerDiemRateArgs = {
  id: Scalars['Int'];
};


export type ExpensesOfficialPerDiemRatesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


export type ExpensesOfficialPerDiemRatesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ExpensesPendingClosingPeriodsArgs = {
  legalEntityId: Scalars['Int'];
};


export type ExpensesPendingClosingPeriodsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityId: Scalars['Int'];
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ExpensesPerDiemArgs = {
  id: Scalars['Int'];
};


export type ExpensesPerDiemRateArgs = {
  id: Scalars['Int'];
};


export type ExpensesPerDiemRatesArgs = {
  expensesPerDiemIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type ExpensesPerDiemRatesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  expensesPerDiemIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ExpensesPerDiemsArgs = {
  employeeId?: InputMaybe<Scalars['Int']>;
  endDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  excludeDrafts?: InputMaybe<Scalars['Boolean']>;
  expensesExpensableIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  startDate?: InputMaybe<Scalars['ISO8601DateTime']>;
};


export type ExpensesPerDiemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  endDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  excludeDrafts?: InputMaybe<Scalars['Boolean']>;
  expensesExpensableIds?: InputMaybe<Array<Scalars['Int']>>;
  filter?: InputMaybe<ExpensesPerDiemFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startDate?: InputMaybe<Scalars['ISO8601DateTime']>;
};


export type ExpensesPolicyWorkflowArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type ExpensesPolicyWorkflowsArgs = {
  companyId: Scalars['Int'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type ExpensesPolicyWorkflowsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ExpensesRateConfigurationArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type ExpensesRateConfigurationAssigneeArgs = {
  id: Scalars['Int'];
};


export type ExpensesRateConfigurationAssigneesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  rateIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


export type ExpensesRateConfigurationAssigneesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  rateIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ExpensesRateConfigurationsArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  archivedOnly?: InputMaybe<Scalars['Boolean']>;
  companyId: Scalars['Int'];
  currency?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  includeInactive?: InputMaybe<Scalars['Boolean']>;
  resourceType?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type ExpensesRateConfigurationsConnectionArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  after?: InputMaybe<Scalars['String']>;
  archivedOnly?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  currency?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  filter?: InputMaybe<ExpensesRateConfigurationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  includeInactive?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  resourceType?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ExpensesSignedDocumentsTermArgs = {
  id: Scalars['Int'];
};


export type ExpensesSignedDocumentsTermsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  organization?: InputMaybe<Scalars['String']>;
};


export type ExpensesSignedDocumentsTermsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  organization?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ExpensesSignedInvoiceArgs = {
  id: Scalars['Int'];
  receiverLegalEntityId: Scalars['Int'];
  signedForOrganization: Scalars['String'];
};


export type ExpensesSignedInvoicesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  invoiceState?: InputMaybe<Scalars['String']>;
  omitSignedDocuments?: InputMaybe<Scalars['Boolean']>;
  receiverLegalEntityId: Scalars['Int'];
  signedForOrganization: Scalars['String'];
};


export type ExpensesSignedInvoicesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<ExpensesSignedInvoiceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  invoiceState?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  omitSignedDocuments?: InputMaybe<Scalars['Boolean']>;
  receiverLegalEntityId: Scalars['Int'];
  signedForOrganization: Scalars['String'];
  sortOrder?: InputMaybe<Sort>;
};

export type ExpensesMutations = {
  __typename?: 'expensesMutations';
  addToPayrollExpensesExpensableGroup: AddToPayrollExpensesExpensableGroupPayload;
  approveExpensesExpensableGroup: ApproveExpensesExpensableGroupPayload;
  archiveExpensesRateConfiguration: ArchiveExpensesRateConfigurationPayload;
  bulkAddToGroupExpensesExpensable: BulkAddToGroupExpensesExpensablePayload;
  bulkAddToPayrollExpensesExpensable: BulkAddToPayrollExpensesExpensablePayload;
  bulkApproveExpensesExpensable: BulkApproveExpensesExpensablePayload;
  bulkReadyToReviewExpensesExpensable: BulkReadyToReviewExpensesExpensablePayload;
  bulkRejectExpensesExpensable: BulkRejectExpensesExpensablePayload;
  bulkRemoveFromGroupExpensesExpensable: BulkRemoveFromGroupExpensesExpensablePayload;
  bulkRemoveFromPayrollExpensesExpensable: BulkRemoveFromPayrollExpensesExpensablePayload;
  bulkRestartReviewExpensesExpensable: BulkRestartReviewExpensesExpensablePayload;
  bulkRevertPaidExpensesExpensable: BulkRevertPaidExpensesExpensablePayload;
  bulkSendToPayWithSepaExpensesExpensable: BulkSendToPayWithSepaExpensesExpensablePayload;
  bulkSetToPaidExpensesExpensable: BulkSetToPaidExpensesExpensablePayload;
  calculateExpensesPerDiem: CalculateExpensesPerDiemPayload;
  createCommentExpensesExpensable: CreateCommentExpensesExpensablePayload;
  createEphemeralKeysExpensesCard: CreateEphemeralKeysExpensesCardPayload;
  createExpensesClosingPeriod: CreateExpensesClosingPeriodPayload;
  createExpensesClosingPeriodFrequency: CreateExpensesClosingPeriodFrequencyPayload;
  createExpensesExpensable: CreateExpensesExpensablePayload;
  createExpensesExpensableGroup: CreateExpensesExpensableGroupPayload;
  createExpensesPolicyWorkflow: CreateExpensesPolicyWorkflowPayload;
  createExpensesRateConfiguration: CreateExpensesRateConfigurationPayload;
  createExpensesRecommendationResult: CreateExpensesRecommendationResultPayload;
  createExpensesSignedDocumentsTerm: CreateExpensesSignedDocumentsTermPayload;
  createFromDocumentExpensesExpensable: CreateFromDocumentExpensesExpensablePayload;
  deleteExpensesExpensable: DeleteExpensesExpensablePayload;
  deleteExpensesExpensableGroup: DeleteExpensesExpensableGroupPayload;
  detailsExpensesCard: DetailsExpensesCardPayload;
  exportExpensesSignedInvoice: ExportExpensesSignedInvoicePayload;
  exportExpensesSignedInvoiceExport: ExportExpensesSignedInvoiceExportPayload;
  exportPdfExpensesExpensableGroup: ExportPdfExpensesExpensableGroupPayload;
  readByIdExpensesInternalExpenseViewer: ReadByIdExpensesInternalExpenseViewerPayload;
  readRandomExpensesInternalExpenseViewer: ReadRandomExpensesInternalExpenseViewerPayload;
  readyToReviewExpensesExpensable: ReadyToReviewExpensesExpensablePayload;
  readyToReviewExpensesExpensableGroup: ReadyToReviewExpensesExpensableGroupPayload;
  rejectExpensesExpensableGroup: RejectExpensesExpensableGroupPayload;
  removeFromPayrollExpensesExpensableGroup: RemoveFromPayrollExpensesExpensableGroupPayload;
  requestChangesExpensesExpensable: RequestChangesExpensesExpensablePayload;
  restartReviewExpensesExpensableGroup: RestartReviewExpensesExpensableGroupPayload;
  revertPaidExpensesExpensableGroup: RevertPaidExpensesExpensableGroupPayload;
  sendToPayWithSepaExpensesExpensableGroup: SendToPayWithSepaExpensesExpensableGroupPayload;
  setToPaidExpensesExpensableGroup: SetToPaidExpensesExpensableGroupPayload;
  toggleExpensesExpensableGroupsSetting: ToggleExpensesExpensableGroupsSettingPayload;
  updateAndApproveExpensesExpensable: UpdateAndApproveExpensesExpensablePayload;
  updateExpensesCustomizationField: UpdateExpensesCustomizationFieldPayload;
  updateExpensesExpensable: UpdateExpensesExpensablePayload;
  updateExpensesExpensableGroup: UpdateExpensesExpensableGroupPayload;
  updateExpensesRateConfiguration: UpdateExpensesRateConfigurationPayload;
  updateExpensesRecommendationResult: UpdateExpensesRecommendationResultPayload;
  updateExpensesSignedInvoice: UpdateExpensesSignedInvoicePayload;
  updateFromDocumentExpensesExpensable: UpdateFromDocumentExpensesExpensablePayload;
  walletCardAvailableExpensesCard: WalletCardAvailableExpensesCardPayload;
  walletCardsAvailableExpensesCard: WalletCardsAvailableExpensesCardPayload;
};


export type ExpensesMutationsAddToPayrollExpensesExpensableGroupArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
  period: PayrollPolicyPeriodTypesPeriodTypeEnum;
};


export type ExpensesMutationsApproveExpensesExpensableGroupArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
  overrideApprovalFlow?: InputMaybe<Scalars['Boolean']>;
};


export type ExpensesMutationsArchiveExpensesRateConfigurationArgs = {
  id: Scalars['Int'];
};


export type ExpensesMutationsBulkAddToGroupExpensesExpensableArgs = {
  groupId: Scalars['Int'];
  ids: Array<Scalars['Int']>;
};


export type ExpensesMutationsBulkAddToPayrollExpensesExpensableArgs = {
  ids: Array<Scalars['Int']>;
  period?: InputMaybe<PayrollPolicyPeriodTypesPeriodTypeEnum>;
};


export type ExpensesMutationsBulkApproveExpensesExpensableArgs = {
  ids: Array<Scalars['Int']>;
  overrideApprovalFlow?: InputMaybe<Scalars['Boolean']>;
  reason?: InputMaybe<Scalars['String']>;
  validateAll: Scalars['Boolean'];
};


export type ExpensesMutationsBulkReadyToReviewExpensesExpensableArgs = {
  ids: Array<Scalars['Int']>;
  validateAll: Scalars['Boolean'];
};


export type ExpensesMutationsBulkRejectExpensesExpensableArgs = {
  ids: Array<Scalars['Int']>;
  overrideApprovalFlow?: InputMaybe<Scalars['Boolean']>;
  reason?: InputMaybe<Scalars['String']>;
  validateAll: Scalars['Boolean'];
};


export type ExpensesMutationsBulkRemoveFromGroupExpensesExpensableArgs = {
  ids: Array<Scalars['Int']>;
};


export type ExpensesMutationsBulkRemoveFromPayrollExpensesExpensableArgs = {
  ids: Array<Scalars['Int']>;
  period?: InputMaybe<PayrollPolicyPeriodTypesPeriodTypeEnum>;
};


export type ExpensesMutationsBulkRestartReviewExpensesExpensableArgs = {
  ids: Array<Scalars['Int']>;
  overrideApprovalFlow?: InputMaybe<Scalars['Boolean']>;
  reason?: InputMaybe<Scalars['String']>;
  validateAll: Scalars['Boolean'];
};


export type ExpensesMutationsBulkRevertPaidExpensesExpensableArgs = {
  ids: Array<Scalars['Int']>;
};


export type ExpensesMutationsBulkSendToPayWithSepaExpensesExpensableArgs = {
  dueDate?: InputMaybe<Scalars['ISO8601Date']>;
  ids: Array<Scalars['Int']>;
};


export type ExpensesMutationsBulkSetToPaidExpensesExpensableArgs = {
  ids: Array<Scalars['Int']>;
};


export type ExpensesMutationsCalculateExpensesPerDiemArgs = {
  dayExclusions?: InputMaybe<Array<CalculateExpensesPerDiemDayExclusionsInput>>;
  destinations?: InputMaybe<Array<CalculateExpensesPerDiemDestinationsInput>>;
  employeeId: Scalars['Int'];
  from?: InputMaybe<Scalars['String']>;
  rateParams?: InputMaybe<Array<CalculateExpensesPerDiemRateParamsInput>>;
  startDate?: InputMaybe<Scalars['ISO8601DateTime']>;
};


export type ExpensesMutationsCreateCommentExpensesExpensableArgs = {
  authorId: Scalars['Int'];
  companyId: Scalars['Int'];
  content: Scalars['String'];
  mentionedAccessIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceId: Scalars['Int'];
};


export type ExpensesMutationsCreateEphemeralKeysExpensesCardArgs = {
  employeeId?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  nonce?: InputMaybe<Scalars['String']>;
};


export type ExpensesMutationsCreateExpensesClosingPeriodArgs = {
  legalEntityId: Scalars['Int'];
  period: Scalars['Int'];
  year: Scalars['Int'];
};


export type ExpensesMutationsCreateExpensesClosingPeriodFrequencyArgs = {
  frequency: Scalars['String'];
  legalEntityId: Scalars['Int'];
  organization: ExpensesValueObjectsTaxAgencyOrganizationsEnum;
};


export type ExpensesMutationsCreateExpensesExpensableArgs = {
  accessToken?: InputMaybe<Scalars['String']>;
  amount?: InputMaybe<Scalars['BigInt']>;
  budgetId?: InputMaybe<Scalars['Int']>;
  calculatedMileage?: InputMaybe<Scalars['Int']>;
  cardPaymentId?: InputMaybe<Scalars['Int']>;
  category?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['Int']>;
  companyId: Scalars['Int'];
  costCenters?: InputMaybe<CreateExpensesExpensableCostCentersInput>;
  creationSource?: InputMaybe<Scalars['String']>;
  creationType?: InputMaybe<ExpensesExpenseCreationTypeEnum>;
  currency?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  destinationLatitude?: InputMaybe<Scalars['Float']>;
  destinationLongitude?: InputMaybe<Scalars['Float']>;
  disputeId?: InputMaybe<Scalars['Int']>;
  documentNumber?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<Scalars['String']>;
  effectiveOn?: InputMaybe<Scalars['ISO8601DateTime']>;
  employeeId: Scalars['Int'];
  endDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  exchangeRate?: InputMaybe<Scalars['Float']>;
  expense?: InputMaybe<CreateExpensesExpensableExpenseInput>;
  expensesCardId?: InputMaybe<Scalars['Int']>;
  externalAuthorizationId?: InputMaybe<Scalars['String']>;
  files: Array<Scalars['File']>;
  from?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['Int']>;
  internalReference?: InputMaybe<Scalars['String']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  mcc?: InputMaybe<Scalars['String']>;
  merchantName?: InputMaybe<Scalars['String']>;
  merchantTin?: InputMaybe<Scalars['String']>;
  mileage?: InputMaybe<Scalars['Int']>;
  mileageNew?: InputMaybe<CreateExpensesExpensableMileageNewInput>;
  originLatitude?: InputMaybe<Scalars['Float']>;
  originLongitude?: InputMaybe<Scalars['Float']>;
  payment?: InputMaybe<ExpensesValueObjectsPaymentOptionsEnum>;
  paymentMethod?: InputMaybe<Scalars['String']>;
  perDiem?: InputMaybe<CreateExpensesExpensablePerDiemInput>;
  perDiemNew?: InputMaybe<CreateExpensesExpensablePerDiemNewInput>;
  projects?: InputMaybe<Array<ExpensesProjectInput>>;
  rate?: InputMaybe<Scalars['String']>;
  rates?: InputMaybe<Array<CreateExpensesExpensableRatesInput>>;
  reference?: InputMaybe<Scalars['String']>;
  reimbursableAmount?: InputMaybe<Scalars['BigInt']>;
  reimbursableCurrency?: InputMaybe<Scalars['String']>;
  resourceType?: InputMaybe<Scalars['String']>;
  roundTrip?: InputMaybe<Scalars['Boolean']>;
  signedDocumentId?: InputMaybe<Scalars['Int']>;
  signedForOrganization?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  statusUpdatedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  subcategory?: InputMaybe<Scalars['String']>;
  taxes: Array<CreateExpensesExpensableTaxesInput>;
  to?: InputMaybe<Scalars['String']>;
  units?: InputMaybe<Scalars['String']>;
};


export type ExpensesMutationsCreateExpensesExpensableGroupArgs = {
  companyId: Scalars['Int'];
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};


export type ExpensesMutationsCreateExpensesPolicyWorkflowArgs = {
  authorId: Scalars['Int'];
  companyId: Scalars['Int'];
  spendingPolicyId: Scalars['Int'];
};


export type ExpensesMutationsCreateExpensesRateConfigurationArgs = {
  accessIds: Array<Scalars['Int']>;
  amountCents?: InputMaybe<Scalars['Int']>;
  companyId: Scalars['Int'];
  currency: Scalars['String'];
  legalEntityIds: Array<Scalars['Int']>;
  name: Scalars['String'];
  rate?: InputMaybe<Scalars['Float']>;
  resourceType?: InputMaybe<Scalars['String']>;
};


export type ExpensesMutationsCreateExpensesRecommendationResultArgs = {
  companyId: Scalars['Int'];
  expenseId: Scalars['Int'];
};


export type ExpensesMutationsCreateExpensesSignedDocumentsTermArgs = {
  legalEntityId: Scalars['Int'];
  organization: Scalars['String'];
  representativeIdentifier?: InputMaybe<Scalars['String']>;
  representativeName?: InputMaybe<Scalars['String']>;
  representativeSurname?: InputMaybe<Scalars['String']>;
};


export type ExpensesMutationsCreateFromDocumentExpensesExpensableArgs = {
  budgetId?: InputMaybe<Scalars['Int']>;
  companyId: Scalars['Int'];
  creationSource?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  documentOrigin?: InputMaybe<ExpensesValueObjectsDocumentOriginEnum>;
  employeeId: Scalars['Int'];
  files: Array<Scalars['File']>;
  groupId?: InputMaybe<Scalars['Int']>;
  internalReference?: InputMaybe<Scalars['String']>;
  reference?: InputMaybe<Scalars['String']>;
  reimbursableAmount?: InputMaybe<Scalars['Int']>;
  reimbursableCurrency?: InputMaybe<Scalars['String']>;
  signedForOrganization?: InputMaybe<Scalars['String']>;
};


export type ExpensesMutationsDeleteExpensesExpensableArgs = {
  id: Scalars['Int'];
};


export type ExpensesMutationsDeleteExpensesExpensableGroupArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type ExpensesMutationsDetailsExpensesCardArgs = {
  id: Scalars['Int'];
};


export type ExpensesMutationsExportExpensesSignedInvoiceArgs = {
  accessId: Scalars['Int'];
  companyId: Scalars['Int'];
  exportFormat: ExpensesDtosSignedInvoicesExportFormatsEnum;
  fromDate: Scalars['ISO8601Date'];
  toDate: Scalars['ISO8601Date'];
  withFiles: Scalars['Boolean'];
};


export type ExpensesMutationsExportExpensesSignedInvoiceExportArgs = {
  accessId: Scalars['Int'];
  companyId: Scalars['Int'];
  exportFormat: ExpensesDtosSignedInvoicesExportFormatsEnum;
  fromDate: Scalars['ISO8601Date'];
  toDate: Scalars['ISO8601Date'];
  withFiles: Scalars['Boolean'];
};


export type ExpensesMutationsExportPdfExpensesExpensableGroupArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type ExpensesMutationsReadByIdExpensesInternalExpenseViewerArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type ExpensesMutationsReadRandomExpensesInternalExpenseViewerArgs = {
  companyId: Scalars['Int'];
  excludeId?: InputMaybe<Scalars['Int']>;
  scoping: Scalars['String'];
};


export type ExpensesMutationsReadyToReviewExpensesExpensableArgs = {
  amount?: InputMaybe<Scalars['BigInt']>;
  budgetId?: InputMaybe<Scalars['Int']>;
  calculatedMileage?: InputMaybe<Scalars['Int']>;
  category?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['Int']>;
  companyId: Scalars['Int'];
  costCenters?: InputMaybe<ReadyToReviewExpensesExpensableCostCentersInput>;
  creationSource?: InputMaybe<Scalars['String']>;
  creationType?: InputMaybe<ExpensesExpenseCreationTypeEnum>;
  currency?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  destinationLatitude?: InputMaybe<Scalars['Float']>;
  destinationLongitude?: InputMaybe<Scalars['Float']>;
  documentNumber?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<Scalars['String']>;
  effectiveOn: Scalars['ISO8601DateTime'];
  employeeId: Scalars['Int'];
  exchangeRate?: InputMaybe<Scalars['Float']>;
  expensesCardId?: InputMaybe<Scalars['Int']>;
  externalAuthorizationId?: InputMaybe<Scalars['String']>;
  files: Array<Scalars['File']>;
  filesIdToRemove?: InputMaybe<Array<Scalars['Int']>>;
  from?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  internalReference?: InputMaybe<Scalars['String']>;
  merchantName?: InputMaybe<Scalars['String']>;
  merchantTin?: InputMaybe<Scalars['String']>;
  mileage?: InputMaybe<Scalars['Int']>;
  originLatitude?: InputMaybe<Scalars['Float']>;
  originLongitude?: InputMaybe<Scalars['Float']>;
  payment?: InputMaybe<ExpensesValueObjectsPaymentOptionsEnum>;
  paymentMethod?: InputMaybe<Scalars['String']>;
  perDiem?: InputMaybe<ReadyToReviewExpensesExpensablePerDiemInput>;
  projects?: InputMaybe<Array<ExpensesProjectInput>>;
  rate?: InputMaybe<Scalars['String']>;
  reference?: InputMaybe<Scalars['String']>;
  reimbursableAmount?: InputMaybe<Scalars['BigInt']>;
  reimbursableCurrency?: InputMaybe<Scalars['String']>;
  resourceType?: InputMaybe<Scalars['String']>;
  roundTrip?: InputMaybe<Scalars['Boolean']>;
  signedDocumentId?: InputMaybe<Scalars['Int']>;
  signedForOrganization?: InputMaybe<Scalars['String']>;
  subcategory?: InputMaybe<Scalars['String']>;
  taxes: Array<ReadyToReviewExpensesExpensableTaxesInput>;
  to?: InputMaybe<Scalars['String']>;
  units?: InputMaybe<Scalars['String']>;
  userMerchant?: InputMaybe<Scalars['String']>;
};


export type ExpensesMutationsReadyToReviewExpensesExpensableGroupArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type ExpensesMutationsRejectExpensesExpensableGroupArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
  reason?: InputMaybe<Scalars['String']>;
};


export type ExpensesMutationsRemoveFromPayrollExpensesExpensableGroupArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type ExpensesMutationsRequestChangesExpensesExpensableArgs = {
  id: Scalars['Int'];
  reason: Scalars['String'];
};


export type ExpensesMutationsRestartReviewExpensesExpensableGroupArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type ExpensesMutationsRevertPaidExpensesExpensableGroupArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type ExpensesMutationsSendToPayWithSepaExpensesExpensableGroupArgs = {
  companyId: Scalars['Int'];
  dueDate?: InputMaybe<Scalars['ISO8601Date']>;
  id: Scalars['Int'];
};


export type ExpensesMutationsSetToPaidExpensesExpensableGroupArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type ExpensesMutationsToggleExpensesExpensableGroupsSettingArgs = {
  companyId: Scalars['Int'];
};


export type ExpensesMutationsUpdateAndApproveExpensesExpensableArgs = {
  amount?: InputMaybe<Scalars['Int']>;
  budgetId?: InputMaybe<Scalars['Int']>;
  calculatedMileage?: InputMaybe<Scalars['Int']>;
  category?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['Int']>;
  costCenters?: InputMaybe<UpdateAndApproveExpensesExpensableCostCentersInput>;
  creationType?: InputMaybe<ExpensesExpenseCreationTypeEnum>;
  currency?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  destinationLatitude?: InputMaybe<Scalars['Float']>;
  destinationLongitude?: InputMaybe<Scalars['Float']>;
  documentNumber?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<Scalars['String']>;
  effectiveOn?: InputMaybe<Scalars['ISO8601DateTime']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  exchangeRate?: InputMaybe<Scalars['Float']>;
  expense?: InputMaybe<UpdateAndApproveExpensesExpensableExpenseInput>;
  expensesCardId?: InputMaybe<Scalars['Int']>;
  externalAuthorizationId?: InputMaybe<Scalars['String']>;
  files?: InputMaybe<Array<Scalars['File']>>;
  filesIdToRemove?: InputMaybe<Array<Scalars['Int']>>;
  from?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  internalReference?: InputMaybe<Scalars['String']>;
  mcc?: InputMaybe<Scalars['String']>;
  merchantName?: InputMaybe<Scalars['String']>;
  merchantTin?: InputMaybe<Scalars['String']>;
  mileage?: InputMaybe<Scalars['Int']>;
  mileageNew?: InputMaybe<UpdateAndApproveExpensesExpensableMileageNewInput>;
  notifyCreator?: InputMaybe<Scalars['Boolean']>;
  originLatitude?: InputMaybe<Scalars['Float']>;
  originLongitude?: InputMaybe<Scalars['Float']>;
  overrideApprovalFlow?: InputMaybe<Scalars['Boolean']>;
  payment?: InputMaybe<ExpensesValueObjectsPaymentOptionsEnum>;
  paymentMethod?: InputMaybe<Scalars['String']>;
  perDiem?: InputMaybe<UpdateAndApproveExpensesExpensablePerDiemInput>;
  projects?: InputMaybe<Array<ExpensesProjectInput>>;
  rate?: InputMaybe<Scalars['String']>;
  reference?: InputMaybe<Scalars['String']>;
  reimbursableAmount?: InputMaybe<Scalars['Int']>;
  reimbursableCurrency?: InputMaybe<Scalars['String']>;
  resourceType?: InputMaybe<Scalars['String']>;
  roundTrip?: InputMaybe<Scalars['Boolean']>;
  signedDocumentId?: InputMaybe<Scalars['Int']>;
  signedForOrganization?: InputMaybe<Scalars['String']>;
  subcategory?: InputMaybe<Scalars['String']>;
  taxes?: InputMaybe<Array<UpdateAndApproveExpensesExpensableTaxesInput>>;
  to?: InputMaybe<Scalars['String']>;
  units?: InputMaybe<Scalars['String']>;
  userMerchant?: InputMaybe<Scalars['String']>;
};


export type ExpensesMutationsUpdateExpensesCustomizationFieldArgs = {
  companyId: Scalars['Int'];
  enabled?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
  mandatory?: InputMaybe<Scalars['Boolean']>;
  options?: InputMaybe<Scalars['String']>;
};


export type ExpensesMutationsUpdateExpensesExpensableArgs = {
  amount?: InputMaybe<Scalars['BigInt']>;
  budgetId?: InputMaybe<Scalars['Int']>;
  calculatedMileage?: InputMaybe<Scalars['Int']>;
  category?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['Int']>;
  costCenters?: InputMaybe<UpdateExpensesExpensableCostCentersInput>;
  creationType?: InputMaybe<ExpensesExpenseCreationTypeEnum>;
  currency?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  destinationLatitude?: InputMaybe<Scalars['Float']>;
  destinationLongitude?: InputMaybe<Scalars['Float']>;
  documentNumber?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<Scalars['String']>;
  effectiveOn?: InputMaybe<Scalars['ISO8601DateTime']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  exchangeRate?: InputMaybe<Scalars['Float']>;
  expense?: InputMaybe<UpdateExpensesExpensableExpenseInput>;
  expensesCardId?: InputMaybe<Scalars['Int']>;
  externalAuthorizationId?: InputMaybe<Scalars['String']>;
  files?: InputMaybe<Array<Scalars['File']>>;
  filesIdToRemove?: InputMaybe<Array<Scalars['Int']>>;
  from?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  internalReference?: InputMaybe<Scalars['String']>;
  mcc?: InputMaybe<Scalars['String']>;
  merchantName?: InputMaybe<Scalars['String']>;
  merchantTin?: InputMaybe<Scalars['String']>;
  mileage?: InputMaybe<Scalars['Int']>;
  mileageNew?: InputMaybe<UpdateExpensesExpensableMileageNewInput>;
  notifyCreator?: InputMaybe<Scalars['Boolean']>;
  originLatitude?: InputMaybe<Scalars['Float']>;
  originLongitude?: InputMaybe<Scalars['Float']>;
  overrideApprovalFlow?: InputMaybe<Scalars['Boolean']>;
  payment?: InputMaybe<ExpensesValueObjectsPaymentOptionsEnum>;
  paymentMethod?: InputMaybe<Scalars['String']>;
  perDiem?: InputMaybe<UpdateExpensesExpensablePerDiemInput>;
  projects?: InputMaybe<Array<ExpensesProjectInput>>;
  rate?: InputMaybe<Scalars['String']>;
  reference?: InputMaybe<Scalars['String']>;
  reimbursableAmount?: InputMaybe<Scalars['BigInt']>;
  reimbursableCurrency?: InputMaybe<Scalars['String']>;
  resourceType?: InputMaybe<Scalars['String']>;
  roundTrip?: InputMaybe<Scalars['Boolean']>;
  signedDocumentId?: InputMaybe<Scalars['Int']>;
  signedForOrganization?: InputMaybe<Scalars['String']>;
  subcategory?: InputMaybe<Scalars['String']>;
  taxes?: InputMaybe<Array<UpdateExpensesExpensableTaxesInput>>;
  to?: InputMaybe<Scalars['String']>;
  units?: InputMaybe<Scalars['String']>;
  userMerchant?: InputMaybe<Scalars['String']>;
};


export type ExpensesMutationsUpdateExpensesExpensableGroupArgs = {
  companyId: Scalars['Int'];
  description?: InputMaybe<Scalars['String']>;
  files: Array<Scalars['File']>;
  filesIdToRemove: Array<Scalars['Int']>;
  id: Scalars['Int'];
  name: Scalars['String'];
};


export type ExpensesMutationsUpdateExpensesRateConfigurationArgs = {
  accessIds: Array<Scalars['Int']>;
  amountCents?: InputMaybe<Scalars['Int']>;
  companyId: Scalars['Int'];
  currency: Scalars['String'];
  id: Scalars['Int'];
  legalEntityIds: Array<Scalars['Int']>;
  name: Scalars['String'];
  rate?: InputMaybe<Scalars['Float']>;
};


export type ExpensesMutationsUpdateExpensesRecommendationResultArgs = {
  humanComment?: InputMaybe<Scalars['String']>;
  humanValidation?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};


export type ExpensesMutationsUpdateExpensesSignedInvoiceArgs = {
  accountingDate?: InputMaybe<Scalars['String']>;
  discountAmount?: InputMaybe<Scalars['Int']>;
  documentDate?: InputMaybe<Scalars['String']>;
  emitterName?: InputMaybe<Scalars['String']>;
  emitterTin?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  invoiceType?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  receiverLegalEntityId: Scalars['Int'];
  receiverName?: InputMaybe<Scalars['String']>;
  receiverTin?: InputMaybe<Scalars['String']>;
  signedDocumentId?: InputMaybe<Scalars['Int']>;
  signedForOrganization: Scalars['String'];
  taxes: UpdateExpensesSignedInvoiceTaxesInput;
};


export type ExpensesMutationsUpdateFromDocumentExpensesExpensableArgs = {
  documentOrigin?: InputMaybe<ExpensesValueObjectsDocumentOriginEnum>;
  files: Array<Scalars['File']>;
  filesIdToRemove?: InputMaybe<Array<Scalars['Int']>>;
  id: Scalars['Int'];
  notifyCreator?: InputMaybe<Scalars['Boolean']>;
  signedForOrganization?: InputMaybe<Scalars['String']>;
};


export type ExpensesMutationsWalletCardAvailableExpensesCardArgs = {
  employeeId: Scalars['Int'];
  id: Scalars['Int'];
};


export type ExpensesMutationsWalletCardsAvailableExpensesCardArgs = {
  accountExternalId?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  externalIds?: InputMaybe<Array<Scalars['String']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeSoftwareCards?: InputMaybe<Scalars['Boolean']>;
  last4?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type FaceRecognition = {
  __typename?: 'faceRecognition';
  employeePicture?: Maybe<FaceRecognitionEmployeePicture>;
  /** @deprecated Please favor `employeePicturesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  employeePictures: Array<FaceRecognitionEmployeePicture>;
  employeePicturesConnection: FaceRecognitionEmployeePictureConnection;
};


export type FaceRecognitionEmployeePictureArgs = {
  id: Scalars['Int'];
};


export type FaceRecognitionEmployeePicturesArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  status?: InputMaybe<Scalars['String']>;
};


export type FaceRecognitionEmployeePicturesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  status?: InputMaybe<Scalars['String']>;
};

export type FaceRecognitionMutations = {
  __typename?: 'faceRecognitionMutations';
  createFacerecognitionEmployeePicture: CreateFacerecognitionEmployeePicturePayload;
  destroyFacerecognitionEmployeePicture: DestroyFacerecognitionEmployeePicturePayload;
  downloadFacerecognitionEmployeePicture: DownloadFacerecognitionEmployeePicturePayload;
};


export type FaceRecognitionMutationsCreateFacerecognitionEmployeePictureArgs = {
  employeeId: Scalars['Int'];
  picture: Scalars['File'];
};


export type FaceRecognitionMutationsDestroyFacerecognitionEmployeePictureArgs = {
  id: Scalars['Int'];
};


export type FaceRecognitionMutationsDownloadFacerecognitionEmployeePictureArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  status?: InputMaybe<Scalars['String']>;
};

export type Features = {
  __typename?: 'features';
  _policies: FeaturesContextlessPolicies;
  featureMembership?: Maybe<FeaturesFeatureMembership>;
  /** @deprecated Please favor `featureMembershipsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  featureMemberships: Array<FeaturesFeatureMembership>;
  featureMembershipsConnection: FeaturesFeatureMembershipConnection;
  /** @deprecated Please favor `featuresConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  features: Array<FeaturesFeature>;
  featuresConnection: FeaturesFeatureConnection;
};


export type FeaturesFeatureMembershipArgs = {
  id: Scalars['String'];
};


export type FeaturesFeatureMembershipsArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};


export type FeaturesFeatureMembershipsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type FeaturesFeaturesArgs = {
  companyIds: Array<Scalars['Int']>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  names?: InputMaybe<Array<Scalars['String']>>;
};


export type FeaturesFeaturesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyIds: Array<Scalars['Int']>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  names?: InputMaybe<Array<Scalars['String']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

export type FeaturesMutations = {
  __typename?: 'featuresMutations';
  enabledForAccessFeaturesFeatureMembership: EnabledForAccessFeaturesFeatureMembershipPayload;
  enabledForEmployeeFeaturesFeatureMembership: EnabledForEmployeeFeaturesFeatureMembershipPayload;
  resetFeaturesFeature: ResetFeaturesFeaturePayload;
  toggleFeaturesFeature: ToggleFeaturesFeaturePayload;
  totalWithAccessFeaturesFeatureMembership: TotalWithAccessFeaturesFeatureMembershipPayload;
  updateMembersFeaturesFeatureMembership: UpdateMembersFeaturesFeatureMembershipPayload;
};


export type FeaturesMutationsEnabledForAccessFeaturesFeatureMembershipArgs = {
  accessId: Scalars['Int'];
  companyId: Scalars['Int'];
  featureId: Scalars['String'];
};


export type FeaturesMutationsEnabledForEmployeeFeaturesFeatureMembershipArgs = {
  companyId: Scalars['Int'];
  employeeId: Scalars['Int'];
  featureId: Scalars['String'];
};


export type FeaturesMutationsResetFeaturesFeatureArgs = {
  featureId: Scalars['String'];
};


export type FeaturesMutationsToggleFeaturesFeatureArgs = {
  enabled: Scalars['Boolean'];
  featureId: Scalars['String'];
};


export type FeaturesMutationsTotalWithAccessFeaturesFeatureMembershipArgs = {
  companyId: Scalars['Int'];
  featureId: Scalars['String'];
};


export type FeaturesMutationsUpdateMembersFeaturesFeatureMembershipArgs = {
  addAccessIds?: InputMaybe<Array<Scalars['Int']>>;
  addEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  companyId: Scalars['Int'];
  featureId: Scalars['String'];
  removeAccessIds?: InputMaybe<Array<Scalars['Int']>>;
  removeEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type Feedbacks = {
  __typename?: 'feedbacks';
  _policies: FeedbacksContextlessPolicies;
  /** @deprecated Please favor `feedbackEntriesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  feedbackEntries: Array<FeedbacksFeedbackEntry>;
  feedbackEntriesConnection: FeedbacksFeedbackEntryConnection;
  feedbackEntry?: Maybe<FeedbacksFeedbackEntry>;
  feedbackRequest?: Maybe<FeedbacksFeedbackRequest>;
  /** @deprecated Please favor `feedbackRequestsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  feedbackRequests: Array<FeedbacksFeedbackRequest>;
  feedbackRequestsConnection: FeedbacksFeedbackRequestConnection;
};


export type FeedbacksFeedbackEntriesArgs = {
  authorId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  receiverId?: InputMaybe<Scalars['Int']>;
};


export type FeedbacksFeedbackEntriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  authorId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<FeedbacksFeedbackEntryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  receiverId?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type FeedbacksFeedbackEntryArgs = {
  id: Scalars['Int'];
};


export type FeedbacksFeedbackRequestArgs = {
  id: Scalars['Int'];
};


export type FeedbacksFeedbackRequestsArgs = {
  authorId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type FeedbacksFeedbackRequestsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  authorId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

export type FeedbacksMutations = {
  __typename?: 'feedbacksMutations';
  createFeedbacksFeedbackEntry: CreateFeedbacksFeedbackEntryPayload;
  createFeedbacksFeedbackRequest: CreateFeedbacksFeedbackRequestPayload;
};


export type FeedbacksMutationsCreateFeedbacksFeedbackEntryArgs = {
  feedback: Scalars['String'];
  feedbackRequestId?: InputMaybe<Scalars['Int']>;
  receiverIds: Array<Scalars['Int']>;
  visibility: FeedbacksFeedbackEntryVisibilityEnum;
};


export type FeedbacksMutationsCreateFeedbacksFeedbackRequestArgs = {
  description: Scalars['String'];
  entryVisibility: FeedbacksFeedbackEntryVisibilityEnum;
  receiverIds: Array<Scalars['Int']>;
};

export type Finance = {
  __typename?: 'finance';
  _policies: FinanceContextlessPolicies;
  account?: Maybe<FinanceAccount>;
  /** @deprecated Please favor `accountImportTemplatesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  accountImportTemplates: Array<FinanceAccountImportTemplate>;
  accountImportTemplatesConnection: FinanceAccountImportTemplateConnection;
  accountingSetting?: Maybe<FinanceAccountingSetting>;
  /** @deprecated Please favor `accountingSettingsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  accountingSettings: Array<FinanceAccountingSetting>;
  accountingSettingsConnection: FinanceAccountingSettingConnection;
  /** @deprecated Please favor `accountsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  accounts: Array<FinanceAccount>;
  accountsConnection: FinanceAccountConnection;
  budget?: Maybe<FinanceBudget>;
  budgetAllocation?: Maybe<FinanceBudgetAllocation>;
  /** @deprecated Please favor `budgetAllocationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  budgetAllocations: Array<FinanceBudgetAllocation>;
  budgetAllocationsConnection: FinanceBudgetAllocationConnection;
  budgetMovement?: Maybe<FinanceBudgetMovement>;
  /** @deprecated Please favor `budgetMovementsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  budgetMovements: Array<FinanceBudgetMovement>;
  budgetMovementsConnection: FinanceBudgetMovementConnection;
  budgetOption?: Maybe<FinanceBudgetOption>;
  /** @deprecated Please favor `budgetOptionsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  budgetOptions: Array<FinanceBudgetOption>;
  budgetOptionsConnection: FinanceBudgetOptionConnection;
  /** @deprecated Please favor `budgetsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  budgets: Array<FinanceBudget>;
  budgetsConnection: FinanceBudgetConnection;
  /** @deprecated Please favor `categoriesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  categories: Array<FinanceCategory>;
  categoriesConnection: FinanceCategoryConnection;
  category?: Maybe<FinanceCategory>;
  complianceExtraFieldDefaultSetting?: Maybe<FinanceComplianceExtraFieldDefaultSetting>;
  /** @deprecated Please favor `complianceExtraFieldDefaultSettingsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  complianceExtraFieldDefaultSettings: Array<FinanceComplianceExtraFieldDefaultSetting>;
  complianceExtraFieldDefaultSettingsConnection: FinanceComplianceExtraFieldDefaultSettingConnection;
  complianceSnapshot?: Maybe<FinanceComplianceSnapshot>;
  /** @deprecated Please favor `complianceSnapshotsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  complianceSnapshots: Array<FinanceComplianceSnapshot>;
  complianceSnapshotsConnection: FinanceComplianceSnapshotConnection;
  contact?: Maybe<FinanceContact>;
  contactDocument?: Maybe<FinanceContactDocument>;
  /** @deprecated Please favor `contactDocumentsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  contactDocuments: Array<FinanceContactDocument>;
  contactDocumentsConnection: FinanceContactDocumentConnection;
  /** @deprecated Please favor `contactsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  contacts: Array<FinanceContact>;
  contactsConnection: FinanceContactConnection;
  costCenter?: Maybe<FinanceCostCenter>;
  /** @deprecated Please favor `costCenterMembershipsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  costCenterMemberships: Array<FinanceCostCenterMembership>;
  costCenterMembershipsConnection: FinanceCostCenterMembershipConnection;
  /** @deprecated Please favor `costCentersConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  costCenters: Array<FinanceCostCenter>;
  costCentersConnection: FinanceCostCenterConnection;
  creditNoteSequence?: Maybe<FinanceCreditNoteSequence>;
  /** @deprecated Please favor `creditNoteSequencesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  creditNoteSequences: Array<FinanceCreditNoteSequence>;
  creditNoteSequencesConnection: FinanceCreditNoteSequenceConnection;
  /** @deprecated Please favor `customCategoriesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  customCategories: Array<FinanceCustomCategory>;
  customCategoriesConnection: FinanceCustomCategoryConnection;
  customCategory?: Maybe<FinanceCustomCategory>;
  customDimension?: Maybe<FinanceCustomDimension>;
  /** @deprecated Please favor `customDimensionMembershipsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  customDimensionMemberships: Array<FinanceCustomDimensionMembership>;
  customDimensionMembershipsConnection: FinanceCustomDimensionMembershipConnection;
  customDimensionValue?: Maybe<FinanceCustomDimensionValue>;
  /** @deprecated Please favor `customDimensionValuesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  customDimensionValues: Array<FinanceCustomDimensionValue>;
  customDimensionValuesConnection: FinanceCustomDimensionValueConnection;
  /** @deprecated Please favor `customDimensionsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  customDimensions: Array<FinanceCustomDimension>;
  customDimensionsConnection: FinanceCustomDimensionConnection;
  deal?: Maybe<FinanceDeal>;
  /** @deprecated Please favor `dealsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  deals: Array<FinanceDeal>;
  dealsConnection: FinanceDealConnection;
  /** @deprecated Please favor `exchangeCurrenciesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  exchangeCurrencies: Array<FinanceExchangeCurrency>;
  exchangeCurrenciesConnection: FinanceExchangeCurrencyConnection;
  /** @deprecated Please favor `expenseSpendingPolicyEvaluationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  expenseSpendingPolicyEvaluations: Array<FinanceExpenseSpendingPolicyEvaluation>;
  expenseSpendingPolicyEvaluationsConnection: FinanceExpenseSpendingPolicyEvaluationConnection;
  financialCost?: Maybe<FinanceFinancialCost>;
  /** @deprecated Please favor `financialCostsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  financialCosts: Array<FinanceFinancialCost>;
  financialCostsConnection: FinanceFinancialCostConnection;
  financialDocument?: Maybe<FinanceFinancialDocument>;
  financialDocumentAssociation?: Maybe<FinanceFinancialDocumentAssociation>;
  /** @deprecated Please favor `financialDocumentAssociationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  financialDocumentAssociations: Array<FinanceFinancialDocumentAssociation>;
  financialDocumentAssociationsConnection: FinanceFinancialDocumentAssociationConnection;
  financialDocumentComplianceExtraField?: Maybe<FinanceFinancialDocumentComplianceExtraField>;
  /** @deprecated Please favor `financialDocumentComplianceExtraFieldsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  financialDocumentComplianceExtraFields: Array<FinanceFinancialDocumentComplianceExtraField>;
  financialDocumentComplianceExtraFieldsConfig?: Maybe<FinanceFinancialDocumentComplianceExtraFieldsConfig>;
  /** @deprecated Please favor `financialDocumentComplianceExtraFieldsConfigsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  financialDocumentComplianceExtraFieldsConfigs: Array<FinanceFinancialDocumentComplianceExtraFieldsConfig>;
  financialDocumentComplianceExtraFieldsConfigsConnection: FinanceFinancialDocumentComplianceExtraFieldsConfigConnection;
  financialDocumentComplianceExtraFieldsConnection: FinanceFinancialDocumentComplianceExtraFieldConnection;
  financialDocumentEvent?: Maybe<FinanceFinancialDocumentEvent>;
  /** @deprecated Please favor `financialDocumentEventsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  financialDocumentEvents: Array<FinanceFinancialDocumentEvent>;
  financialDocumentEventsConnection: FinanceFinancialDocumentEventConnection;
  /** @deprecated Please favor `financialDocumentsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  financialDocuments: Array<FinanceFinancialDocument>;
  financialDocumentsConnection: FinanceFinancialDocumentConnection;
  inbox?: Maybe<FinanceInbox>;
  /** @deprecated Please favor `inboxesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  inboxes: Array<FinanceInbox>;
  inboxesConnection: FinanceInboxConnection;
  /** @deprecated Please favor `journalDraftEntriesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  journalDraftEntries: Array<FinanceJournalDraftEntry>;
  journalDraftEntriesConnection: FinanceJournalDraftEntryConnection;
  journalDraftEntry?: Maybe<FinanceJournalDraftEntry>;
  journalDraftLine?: Maybe<FinanceJournalDraftLine>;
  /** @deprecated Please favor `journalDraftLinesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  journalDraftLines: Array<FinanceJournalDraftLine>;
  journalDraftLinesConnection: FinanceJournalDraftLineConnection;
  /** @deprecated Please favor `journalEntriesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  journalEntries: Array<FinanceJournalEntry>;
  journalEntriesConnection: FinanceJournalEntryConnection;
  journalEntry?: Maybe<FinanceJournalEntry>;
  journalLine?: Maybe<FinanceJournalLine>;
  /** @deprecated Please favor `journalLinesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  journalLines: Array<FinanceJournalLine>;
  journalLinesConnection: FinanceJournalLineConnection;
  ledgerAccountResource?: Maybe<FinanceLedgerAccountResource>;
  /** @deprecated Please favor `ledgerAccountResourcesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  ledgerAccountResources: Array<FinanceLedgerAccountResource>;
  ledgerAccountResourcesConnection: FinanceLedgerAccountResourceConnection;
  lineItem?: Maybe<FinanceLineItem>;
  /** @deprecated Please favor `lineItemsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  lineItems: Array<FinanceLineItem>;
  lineItemsConnection: FinanceLineItemConnection;
  message?: Maybe<FinanceMessage>;
  /** @deprecated Please favor `messagesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  messages: Array<FinanceMessage>;
  messagesConnection: FinanceMessageConnection;
  /** @deprecated Please favor `pendingActionsSummariesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  pendingActionsSummaries: Array<FinancePendingActionsSummary>;
  pendingActionsSummariesConnection: FinancePendingActionsSummaryConnection;
  pendingActionsSummary?: Maybe<FinancePendingActionsSummary>;
  quote?: Maybe<FinanceQuote>;
  /** @deprecated Please favor `quotesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  quotes: Array<FinanceQuote>;
  quotesConnection: FinanceQuoteConnection;
  reconciliation?: Maybe<FinanceReconciliation>;
  reconciliationSuggestion?: Maybe<FinanceReconciliationSuggestion>;
  /** @deprecated Please favor `reconciliationSuggestionsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  reconciliationSuggestions: Array<FinanceReconciliationSuggestion>;
  reconciliationSuggestionsConnection: FinanceReconciliationSuggestionConnection;
  /** @deprecated Please favor `reconciliationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  reconciliations: Array<FinanceReconciliation>;
  reconciliationsConnection: FinanceReconciliationConnection;
  salesDocumentTemplate?: Maybe<FinanceSalesDocumentTemplate>;
  /** @deprecated Please favor `salesDocumentTemplatesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  salesDocumentTemplates: Array<FinanceSalesDocumentTemplate>;
  salesDocumentTemplatesConnection: FinanceSalesDocumentTemplateConnection;
  salesInvoiceSequence?: Maybe<FinanceSalesInvoiceSequence>;
  /** @deprecated Please favor `salesInvoiceSequencesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  salesInvoiceSequences: Array<FinanceSalesInvoiceSequence>;
  salesInvoiceSequencesConnection: FinanceSalesInvoiceSequenceConnection;
  spendingAlert?: Maybe<FinanceSpendingAlert>;
  /** @deprecated Please favor `spendingAlertsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  spendingAlerts: Array<FinanceSpendingAlert>;
  spendingAlertsConnection: FinanceSpendingAlertConnection;
  /** @deprecated Please favor `spendingPoliciesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  spendingPolicies: Array<FinanceSpendingPolicy>;
  spendingPoliciesConnection: FinanceSpendingPolicyConnection;
  spendingPolicy?: Maybe<FinanceSpendingPolicy>;
  spendingPolicyAssignee?: Maybe<FinanceSpendingPolicyAssignee>;
  /** @deprecated Please favor `spendingPolicyAssigneesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  spendingPolicyAssignees: Array<FinanceSpendingPolicyAssignee>;
  spendingPolicyAssigneesConnection: FinanceSpendingPolicyAssigneeConnection;
  spendingPolicyRule?: Maybe<FinanceSpendingPolicyRule>;
  spendingPolicyRuleConfiguration?: Maybe<FinanceSpendingPolicyRuleConfiguration>;
  /** @deprecated Please favor `spendingPolicyRuleConfigurationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  spendingPolicyRuleConfigurations: Array<FinanceSpendingPolicyRuleConfiguration>;
  spendingPolicyRuleConfigurationsConnection: FinanceSpendingPolicyRuleConfigurationConnection;
  spendingPolicyRuleGroup?: Maybe<FinanceSpendingPolicyRuleGroup>;
  /** @deprecated Please favor `spendingPolicyRuleGroupsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  spendingPolicyRuleGroups: Array<FinanceSpendingPolicyRuleGroup>;
  spendingPolicyRuleGroupsConnection: FinanceSpendingPolicyRuleGroupConnection;
  /** @deprecated Please favor `spendingPolicyRulesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  spendingPolicyRules: Array<FinanceSpendingPolicyRule>;
  spendingPolicyRulesConnection: FinanceSpendingPolicyRuleConnection;
  taxBridgeActivation?: Maybe<FinanceTaxBridgeActivation>;
  /** @deprecated Please favor `taxBridgeActivationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  taxBridgeActivations: Array<FinanceTaxBridgeActivation>;
  taxBridgeActivationsConnection: FinanceTaxBridgeActivationConnection;
  taxRate?: Maybe<FinanceTaxRate>;
  /** @deprecated Please favor `taxRatesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  taxRates: Array<FinanceTaxRate>;
  taxRatesConnection: FinanceTaxRateConnection;
  taxType?: Maybe<FinanceTaxType>;
  /** @deprecated Please favor `taxTypesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  taxTypes: Array<FinanceTaxType>;
  taxTypesConnection: FinanceTaxTypeConnection;
};


export type FinanceAccountArgs = {
  id: Scalars['Int'];
};


export type FinanceAccountImportTemplatesArgs = {
  legalEntityId?: InputMaybe<Array<Scalars['Int']>>;
  prefill?: InputMaybe<FinanceDtosAccountingAccountImportTemplatePrefillEnum>;
};


export type FinanceAccountImportTemplatesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityId?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  prefill?: InputMaybe<FinanceDtosAccountingAccountImportTemplatePrefillEnum>;
  sortOrder?: InputMaybe<Sort>;
};


export type FinanceAccountingSettingArgs = {
  id: Scalars['Int'];
};


export type FinanceAccountingSettingsArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


export type FinanceAccountingSettingsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<FinanceAccountingSettingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


export type FinanceAccountsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeDisabled?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  number?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Array<Scalars['String']>>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


export type FinanceAccountsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<FinanceAccountFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeDisabled?: Scalars['Boolean'];
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  number?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  types?: InputMaybe<Array<Scalars['String']>>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


export type FinanceBudgetArgs = {
  id: Scalars['Int'];
};


export type FinanceBudgetAllocationArgs = {
  id: Scalars['Int'];
};


export type FinanceBudgetAllocationsArgs = {
  budgetIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  excludeDrafts?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  periodEnd?: InputMaybe<Scalars['ISO8601DateTime']>;
  periodStart?: InputMaybe<Scalars['ISO8601DateTime']>;
  search?: InputMaybe<Scalars['String']>;
};


export type FinanceBudgetAllocationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  budgetIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  excludeDrafts?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<FinanceBudgetAllocationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  periodEnd?: InputMaybe<Scalars['ISO8601DateTime']>;
  periodStart?: InputMaybe<Scalars['ISO8601DateTime']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type FinanceBudgetMovementArgs = {
  id: Scalars['Int'];
};


export type FinanceBudgetMovementsArgs = {
  budgetId?: InputMaybe<Array<Scalars['Int']>>;
  budgetIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeId?: InputMaybe<Scalars['Int']>;
  excludeDrafts?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  periodEnd?: InputMaybe<Scalars['ISO8601DateTime']>;
  periodStart?: InputMaybe<Scalars['ISO8601DateTime']>;
  resourceIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceType?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type FinanceBudgetMovementsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  budgetId?: InputMaybe<Array<Scalars['Int']>>;
  budgetIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeId?: InputMaybe<Scalars['Int']>;
  excludeDrafts?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<FinanceBudgetMovementFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  periodEnd?: InputMaybe<Scalars['ISO8601DateTime']>;
  periodStart?: InputMaybe<Scalars['ISO8601DateTime']>;
  resourceIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceType?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type FinanceBudgetOptionArgs = {
  id: Scalars['Int'];
};


export type FinanceBudgetOptionsArgs = {
  effectiveAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeArchived?: Scalars['Boolean'];
  includeInactive?: Scalars['Boolean'];
};


export type FinanceBudgetOptionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  effectiveAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  filter?: InputMaybe<FinanceBudgetOptionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeArchived?: Scalars['Boolean'];
  includeInactive?: Scalars['Boolean'];
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type FinanceBudgetsArgs = {
  effectiveAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  extendedVisibility?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  includeInactive?: InputMaybe<Scalars['Boolean']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  onlyArchived?: InputMaybe<Scalars['Boolean']>;
  ownerOrViewerEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  periodStart?: InputMaybe<Scalars['ISO8601DateTime']>;
};


export type FinanceBudgetsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  effectiveAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  extendedVisibility?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  includeInactive?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyArchived?: InputMaybe<Scalars['Boolean']>;
  ownerOrViewerEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  periodStart?: InputMaybe<Scalars['ISO8601DateTime']>;
  sortOrder?: InputMaybe<Sort>;
};


export type FinanceCategoriesArgs = {
  categoryLevel?: InputMaybe<FinanceValueObjectsCategoryLevelEnum>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  factorialCategoryIdentifier?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  parentCategoryIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<FinanceValueObjectsCategoryStatusEnum>>;
  type?: InputMaybe<FinanceValueObjectsCategoryTypeEnum>;
};


export type FinanceCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  categoryLevel?: InputMaybe<FinanceValueObjectsCategoryLevelEnum>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  factorialCategoryIdentifier?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<FinanceCategoryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  parentCategoryIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  statuses?: InputMaybe<Array<FinanceValueObjectsCategoryStatusEnum>>;
  type?: InputMaybe<FinanceValueObjectsCategoryTypeEnum>;
};


export type FinanceCategoryArgs = {
  id: Scalars['Int'];
};


export type FinanceComplianceExtraFieldDefaultSettingArgs = {
  id: Scalars['Int'];
};


export type FinanceComplianceExtraFieldDefaultSettingsArgs = {
  country?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  organization?: InputMaybe<FinanceValueObjectsComplianceExtraFieldOrganizationEnum>;
};


export type FinanceComplianceExtraFieldDefaultSettingsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  organization?: InputMaybe<FinanceValueObjectsComplianceExtraFieldOrganizationEnum>;
  sortOrder?: InputMaybe<Sort>;
};


export type FinanceComplianceSnapshotArgs = {
  id: Scalars['Int'];
};


export type FinanceComplianceSnapshotsArgs = {
  financialDocumentId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  quoteId?: InputMaybe<Scalars['Int']>;
};


export type FinanceComplianceSnapshotsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  financialDocumentId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  quoteId?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type FinanceContactArgs = {
  id: Scalars['Int'];
};


export type FinanceContactDocumentArgs = {
  id: Scalars['Int'];
};


export type FinanceContactDocumentsArgs = {
  contactId?: InputMaybe<Scalars['Int']>;
  filterOutDeleted?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type FinanceContactDocumentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  contactId?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<FinanceContactDocumentFilter>;
  filterOutDeleted?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type FinanceContactsArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  contactType?: InputMaybe<FinanceValueObjectsContactTypeEnum>;
  email?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  taxIdType?: InputMaybe<Scalars['String']>;
  taxIds?: InputMaybe<Array<Scalars['String']>>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
  website?: InputMaybe<Scalars['String']>;
};


export type FinanceContactsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  contactType?: InputMaybe<FinanceValueObjectsContactTypeEnum>;
  email?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<FinanceContactFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  taxIdType?: InputMaybe<Scalars['String']>;
  taxIds?: InputMaybe<Array<Scalars['String']>>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
  website?: InputMaybe<Scalars['String']>;
};


export type FinanceCostCenterArgs = {
  id: Scalars['Int'];
};


export type FinanceCostCenterMembershipsArgs = {
  activeOn?: InputMaybe<Scalars['ISO8601Date']>;
  applyingOn?: InputMaybe<Scalars['ISO8601Date']>;
  companyId?: InputMaybe<Scalars['Int']>;
  costCenterId?: InputMaybe<Scalars['Int']>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeId?: InputMaybe<Scalars['Int']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
};


export type FinanceCostCenterMembershipsConnectionArgs = {
  activeOn?: InputMaybe<Scalars['ISO8601Date']>;
  after?: InputMaybe<Scalars['String']>;
  applyingOn?: InputMaybe<Scalars['ISO8601Date']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  costCenterId?: InputMaybe<Scalars['Int']>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeId?: InputMaybe<Scalars['Int']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  filter?: InputMaybe<FinanceCostCenterMembershipFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Sort>;
};


export type FinanceCostCentersArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeActivesOnDate?: InputMaybe<Scalars['ISO8601Date']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


export type FinanceCostCentersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<FinanceCostCenterFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeActivesOnDate?: InputMaybe<Scalars['ISO8601Date']>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type FinanceCreditNoteSequenceArgs = {
  id: Scalars['Int'];
};


export type FinanceCreditNoteSequencesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<SerialSequencesValueObjectsStatusEnum>;
};


export type FinanceCreditNoteSequencesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<FinanceCreditNoteSequenceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  status?: InputMaybe<SerialSequencesValueObjectsStatusEnum>;
};


export type FinanceCustomCategoriesArgs = {
  categoryLevel: FinanceValueObjectsCategoryLevelEnum;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  factorialCategoryIdentifier?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  parentCategoryIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  statuses: Array<FinanceValueObjectsCategoryStatusEnum>;
  type: FinanceValueObjectsCategoryTypeEnum;
};


export type FinanceCustomCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  categoryLevel: FinanceValueObjectsCategoryLevelEnum;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  factorialCategoryIdentifier?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<FinanceCustomCategoryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  parentCategoryIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  statuses: Array<FinanceValueObjectsCategoryStatusEnum>;
  type: FinanceValueObjectsCategoryTypeEnum;
};


export type FinanceCustomCategoryArgs = {
  categoryLevel: FinanceValueObjectsCategoryLevelEnum;
  id: Scalars['Int'];
  statuses: Array<FinanceValueObjectsCategoryStatusEnum>;
  type: FinanceValueObjectsCategoryTypeEnum;
};


export type FinanceCustomDimensionArgs = {
  id: Scalars['Int'];
};


export type FinanceCustomDimensionMembershipsArgs = {
  activeOn?: InputMaybe<Scalars['ISO8601Date']>;
  customDimensionValueIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeId?: InputMaybe<Scalars['Int']>;
  tenant?: InputMaybe<FinanceTenantInput>;
};


export type FinanceCustomDimensionMembershipsConnectionArgs = {
  activeOn?: InputMaybe<Scalars['ISO8601Date']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  customDimensionValueIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  tenant?: InputMaybe<FinanceTenantInput>;
};


export type FinanceCustomDimensionValueArgs = {
  id: Scalars['Int'];
};


export type FinanceCustomDimensionValuesArgs = {
  customDimensionIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  tenant?: InputMaybe<FinanceTenantInput>;
};


export type FinanceCustomDimensionValuesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  customDimensionIds?: InputMaybe<Array<Scalars['Int']>>;
  filter?: InputMaybe<FinanceCustomDimensionValueFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  tenant?: InputMaybe<FinanceTenantInput>;
};


export type FinanceCustomDimensionsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  tenant?: InputMaybe<FinanceTenantInput>;
};


export type FinanceCustomDimensionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  tenant?: InputMaybe<FinanceTenantInput>;
};


export type FinanceDealArgs = {
  id: Scalars['Int'];
};


export type FinanceDealsArgs = {
  clientIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  stages?: InputMaybe<Array<FinanceValueObjectsDealStageEnum>>;
};


export type FinanceDealsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  clientIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  stages?: InputMaybe<Array<FinanceValueObjectsDealStageEnum>>;
};


export type FinanceExchangeCurrenciesArgs = {
  provider?: InputMaybe<FinanceValueObjectsCurrencyProvidersEnum>;
};


export type FinanceExchangeCurrenciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  provider?: InputMaybe<FinanceValueObjectsCurrencyProvidersEnum>;
  sortOrder?: InputMaybe<Sort>;
};


export type FinanceExpenseSpendingPolicyEvaluationsArgs = {
  amount?: InputMaybe<Scalars['BigInt']>;
  category: Scalars['String'];
  companyId: Scalars['String'];
  currency: Scalars['String'];
  effectiveOn: Scalars['ISO8601DateTime'];
  employeeId: Scalars['Int'];
  expensableId?: InputMaybe<Scalars['Int']>;
  subcategory?: InputMaybe<Scalars['String']>;
};


export type FinanceExpenseSpendingPolicyEvaluationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  amount?: InputMaybe<Scalars['BigInt']>;
  before?: InputMaybe<Scalars['String']>;
  category: Scalars['String'];
  companyId: Scalars['String'];
  currency: Scalars['String'];
  effectiveOn: Scalars['ISO8601DateTime'];
  employeeId: Scalars['Int'];
  expensableId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  subcategory?: InputMaybe<Scalars['String']>;
};


export type FinanceFinancialCostArgs = {
  id: Scalars['Int'];
  tenant: FinanceTenantInput;
};


export type FinanceFinancialCostsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  tenant: FinanceTenantInput;
};


export type FinanceFinancialCostsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  tenant: FinanceTenantInput;
};


export type FinanceFinancialDocumentArgs = {
  id: Scalars['Int'];
};


export type FinanceFinancialDocumentAssociationArgs = {
  id: Scalars['Int'];
};


export type FinanceFinancialDocumentAssociationsArgs = {
  financialDocumentIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  resourceIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceType?: InputMaybe<Scalars['String']>;
};


export type FinanceFinancialDocumentAssociationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<FinanceFinancialDocumentAssociationFilter>;
  financialDocumentIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  resourceIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceType?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type FinanceFinancialDocumentComplianceExtraFieldArgs = {
  id: Scalars['Int'];
};


export type FinanceFinancialDocumentComplianceExtraFieldsArgs = {
  financialDocumentIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type FinanceFinancialDocumentComplianceExtraFieldsConfigArgs = {
  id: Scalars['String'];
};


export type FinanceFinancialDocumentComplianceExtraFieldsConfigsArgs = {
  countries?: InputMaybe<Array<Scalars['String']>>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  organizations?: InputMaybe<Array<FinanceValueObjectsComplianceExtraFieldOrganizationEnum>>;
};


export type FinanceFinancialDocumentComplianceExtraFieldsConfigsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  countries?: InputMaybe<Array<Scalars['String']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  organizations?: InputMaybe<Array<FinanceValueObjectsComplianceExtraFieldOrganizationEnum>>;
  sortOrder?: InputMaybe<Sort>;
};


export type FinanceFinancialDocumentComplianceExtraFieldsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  financialDocumentIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type FinanceFinancialDocumentEventArgs = {
  id: Scalars['Int'];
};


export type FinanceFinancialDocumentEventsArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']>>;
  balanceTypes?: InputMaybe<Array<FinanceValueObjectsLedgerAccountBalanceTypeEnum>>;
  bankAccountIds?: InputMaybe<Array<Scalars['Int']>>;
  bySuspenseAccount?: InputMaybe<Scalars['Boolean']>;
  currency?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  excludingJournalEntryTypes?: InputMaybe<Array<FinanceValueObjectsJournalEntryTypeEnum>>;
  financialDocumentIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  journalEntryIds?: InputMaybe<Array<Scalars['Int']>>;
  journalEntryTypes?: InputMaybe<Array<FinanceValueObjectsJournalEntryTypeEnum>>;
  reconcilable?: InputMaybe<Scalars['Boolean']>;
  reconciliationStatus?: InputMaybe<FinanceValueObjectsReconciliationStatusEnum>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


export type FinanceFinancialDocumentEventsConnectionArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']>>;
  after?: InputMaybe<Scalars['String']>;
  balanceTypes?: InputMaybe<Array<FinanceValueObjectsLedgerAccountBalanceTypeEnum>>;
  bankAccountIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  bySuspenseAccount?: InputMaybe<Scalars['Boolean']>;
  currency?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  excludingJournalEntryTypes?: InputMaybe<Array<FinanceValueObjectsJournalEntryTypeEnum>>;
  financialDocumentIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  journalEntryIds?: InputMaybe<Array<Scalars['Int']>>;
  journalEntryTypes?: InputMaybe<Array<FinanceValueObjectsJournalEntryTypeEnum>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  reconcilable?: InputMaybe<Scalars['Boolean']>;
  reconciliationStatus?: InputMaybe<FinanceValueObjectsReconciliationStatusEnum>;
  sortOrder?: InputMaybe<Sort>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


export type FinanceFinancialDocumentsArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  currency?: InputMaybe<Scalars['String']>;
  dealId?: InputMaybe<Scalars['Int']>;
  documentTypes?: InputMaybe<Array<FinanceValueObjectsFinancialDocumentTypeEnum>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  issuerName?: InputMaybe<Scalars['String']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  operationTypes?: InputMaybe<Array<FinanceValueObjectsFinancialDocumentOperationTypeEnum>>;
  parentFinancialDocumentIds?: InputMaybe<Array<Scalars['Int']>>;
  projectId?: InputMaybe<Scalars['Int']>;
  reconcilable?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<FinanceValueObjectsInvoiceStatusEnum>>;
  toDate?: InputMaybe<Scalars['ISO8601Date']>;
  toDueDate?: InputMaybe<Scalars['ISO8601Date']>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
  vendorId?: InputMaybe<Scalars['Int']>;
};


export type FinanceFinancialDocumentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  currency?: InputMaybe<Scalars['String']>;
  dealId?: InputMaybe<Scalars['Int']>;
  documentTypes?: InputMaybe<Array<FinanceValueObjectsFinancialDocumentTypeEnum>>;
  filter?: InputMaybe<FinanceFinancialDocumentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  issuerName?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  operationTypes?: InputMaybe<Array<FinanceValueObjectsFinancialDocumentOperationTypeEnum>>;
  parentFinancialDocumentIds?: InputMaybe<Array<Scalars['Int']>>;
  projectId?: InputMaybe<Scalars['Int']>;
  reconcilable?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  statuses?: InputMaybe<Array<FinanceValueObjectsInvoiceStatusEnum>>;
  toDate?: InputMaybe<Scalars['ISO8601Date']>;
  toDueDate?: InputMaybe<Scalars['ISO8601Date']>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
  vendorId?: InputMaybe<Scalars['Int']>;
};


export type FinanceInboxArgs = {
  id: Scalars['Int'];
};


export type FinanceInboxesArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type FinanceInboxesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type FinanceJournalDraftEntriesArgs = {
  bankTransactionIds?: InputMaybe<Array<Scalars['Int']>>;
  companyId?: InputMaybe<Scalars['Int']>;
  financialDocumentIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  invoiceIds?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  statuses?: InputMaybe<Array<FinanceValueObjectsJournalDraftEntryStatusEnum>>;
};


export type FinanceJournalDraftEntriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  bankTransactionIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<FinanceJournalDraftEntryFilter>;
  financialDocumentIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  invoiceIds?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  statuses?: InputMaybe<Array<FinanceValueObjectsJournalDraftEntryStatusEnum>>;
};


export type FinanceJournalDraftEntryArgs = {
  id: Scalars['Int'];
};


export type FinanceJournalDraftLineArgs = {
  id: Scalars['Int'];
};


export type FinanceJournalDraftLinesArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type FinanceJournalDraftLinesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type FinanceJournalEntriesArgs = {
  bankTransactionIds?: InputMaybe<Array<Scalars['Int']>>;
  financialDocumentIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  invoiceIds?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  publishedFrom?: InputMaybe<Scalars['ISO8601Date']>;
  sourceIds?: InputMaybe<Array<Scalars['Int']>>;
  sourceType?: InputMaybe<FinanceValueObjectsJournalEntryApiSourceTypeEnum>;
  status?: InputMaybe<FinanceValueObjectsJournalEntryStatusEnum>;
  types?: InputMaybe<Array<FinanceValueObjectsJournalEntryTypeEnum>>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


export type FinanceJournalEntriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  bankTransactionIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<FinanceJournalEntryFilter>;
  financialDocumentIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  invoiceIds?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  publishedFrom?: InputMaybe<Scalars['ISO8601Date']>;
  sortOrder?: InputMaybe<Sort>;
  sourceIds?: InputMaybe<Array<Scalars['Int']>>;
  sourceType?: InputMaybe<FinanceValueObjectsJournalEntryApiSourceTypeEnum>;
  status?: InputMaybe<FinanceValueObjectsJournalEntryStatusEnum>;
  types?: InputMaybe<Array<FinanceValueObjectsJournalEntryTypeEnum>>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


export type FinanceJournalEntryArgs = {
  id: Scalars['Int'];
};


export type FinanceJournalLineArgs = {
  id: Scalars['Int'];
};


export type FinanceJournalLinesArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']>>;
  balanceTypes?: InputMaybe<Array<FinanceValueObjectsLedgerAccountBalanceTypeEnum>>;
  bankAccountIds?: InputMaybe<Array<Scalars['Int']>>;
  bySuspenseAccount?: InputMaybe<Scalars['Boolean']>;
  currency?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  excludingJournalEntryTypes?: InputMaybe<Array<FinanceValueObjectsJournalEntryTypeEnum>>;
  financialDocumentIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  journalEntryIds?: InputMaybe<Array<Scalars['Int']>>;
  journalEntryTypes?: InputMaybe<Array<FinanceValueObjectsJournalEntryTypeEnum>>;
  reconcilable?: InputMaybe<Scalars['Boolean']>;
  reconciliationStatus?: InputMaybe<FinanceValueObjectsReconciliationStatusEnum>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


export type FinanceJournalLinesConnectionArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']>>;
  after?: InputMaybe<Scalars['String']>;
  balanceTypes?: InputMaybe<Array<FinanceValueObjectsLedgerAccountBalanceTypeEnum>>;
  bankAccountIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  bySuspenseAccount?: InputMaybe<Scalars['Boolean']>;
  currency?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  excludingJournalEntryTypes?: InputMaybe<Array<FinanceValueObjectsJournalEntryTypeEnum>>;
  filter?: InputMaybe<FinanceJournalLineFilter>;
  financialDocumentIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  journalEntryIds?: InputMaybe<Array<Scalars['Int']>>;
  journalEntryTypes?: InputMaybe<Array<FinanceValueObjectsJournalEntryTypeEnum>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  reconcilable?: InputMaybe<Scalars['Boolean']>;
  reconciliationStatus?: InputMaybe<FinanceValueObjectsReconciliationStatusEnum>;
  sortOrder?: InputMaybe<Sort>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


export type FinanceLedgerAccountResourceArgs = {
  id: Scalars['Int'];
};


export type FinanceLedgerAccountResourcesArgs = {
  financeAccountIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceType?: InputMaybe<FinanceValueObjectsLedgerAccountResourceTypeEnum>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


export type FinanceLedgerAccountResourcesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  financeAccountIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  resourceIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceType?: InputMaybe<FinanceValueObjectsLedgerAccountResourceTypeEnum>;
  sortOrder?: InputMaybe<Sort>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


export type FinanceLineItemArgs = {
  id: Scalars['Int'];
};


export type FinanceLineItemsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  sourceIds?: InputMaybe<Array<Scalars['Int']>>;
  sourceType?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Array<FinanceValueObjectsLineItemTypeEnum>>;
};


export type FinanceLineItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  sourceIds?: InputMaybe<Array<Scalars['Int']>>;
  sourceType?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Array<FinanceValueObjectsLineItemTypeEnum>>;
};


export type FinanceMessageArgs = {
  id: Scalars['String'];
};


export type FinanceMessagesArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
  inboxIds?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
};


export type FinanceMessagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<FinanceMessageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  inboxIds?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type FinancePendingActionsSummariesArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
  summaryScope?: Array<FinanceDtosPendingActionsOverviewSummaryScopeEnum>;
};


export type FinancePendingActionsSummariesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  summaryScope?: Array<FinanceDtosPendingActionsOverviewSummaryScopeEnum>;
};


export type FinancePendingActionsSummaryArgs = {
  id: Scalars['String'];
};


export type FinanceQuoteArgs = {
  id: Scalars['Int'];
};


export type FinanceQuotesArgs = {
  clientIds?: InputMaybe<Array<Scalars['Int']>>;
  companyId?: InputMaybe<Scalars['Int']>;
  dealIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


export type FinanceQuotesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  clientIds?: InputMaybe<Array<Scalars['Int']>>;
  companyId?: InputMaybe<Scalars['Int']>;
  dealIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type FinanceReconciliationArgs = {
  id: Scalars['String'];
};


export type FinanceReconciliationSuggestionArgs = {
  id: Scalars['Int'];
};


export type FinanceReconciliationSuggestionsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  journalLineIds?: InputMaybe<Array<Scalars['Int']>>;
  reconcilableJournalLineIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type FinanceReconciliationSuggestionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  journalLineIds?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  reconcilableJournalLineIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
};


export type FinanceReconciliationsArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
  journalLineIds?: InputMaybe<Array<Scalars['Int']>>;
  reconcilableIds?: InputMaybe<Array<Scalars['Int']>>;
  reconcilableType?: InputMaybe<Scalars['String']>;
};


export type FinanceReconciliationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  journalLineIds?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  reconcilableIds?: InputMaybe<Array<Scalars['Int']>>;
  reconcilableType?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type FinanceSalesDocumentTemplateArgs = {
  id: Scalars['Int'];
};


export type FinanceSalesDocumentTemplatesArgs = {
  default?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


export type FinanceSalesDocumentTemplatesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  default?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type FinanceSalesInvoiceSequenceArgs = {
  id: Scalars['Int'];
};


export type FinanceSalesInvoiceSequencesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<SerialSequencesValueObjectsStatusEnum>;
};


export type FinanceSalesInvoiceSequencesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<FinanceSalesInvoiceSequenceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  status?: InputMaybe<SerialSequencesValueObjectsStatusEnum>;
};


export type FinanceSpendingAlertArgs = {
  id: Scalars['Int'];
};


export type FinanceSpendingAlertsArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  expensableIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeDiscarded?: InputMaybe<Scalars['Boolean']>;
};


export type FinanceSpendingAlertsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
  expensableIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeDiscarded?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type FinanceSpendingPoliciesArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
};


export type FinanceSpendingPoliciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type FinanceSpendingPolicyArgs = {
  id: Scalars['String'];
};


export type FinanceSpendingPolicyAssigneeArgs = {
  id: Scalars['String'];
};


export type FinanceSpendingPolicyAssigneesArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
  spendingPolicyIds?: InputMaybe<Array<Scalars['String']>>;
};


export type FinanceSpendingPolicyAssigneesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  spendingPolicyIds?: InputMaybe<Array<Scalars['String']>>;
};


export type FinanceSpendingPolicyRuleArgs = {
  id: Scalars['String'];
};


export type FinanceSpendingPolicyRuleConfigurationArgs = {
  companyId: Scalars['String'];
  id: Scalars['String'];
};


export type FinanceSpendingPolicyRuleConfigurationsArgs = {
  companyId: Scalars['String'];
  ids?: InputMaybe<Array<Scalars['String']>>;
  spendingPolicyId?: InputMaybe<Scalars['Int']>;
};


export type FinanceSpendingPolicyRuleConfigurationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['String'];
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  spendingPolicyId?: InputMaybe<Scalars['Int']>;
};


export type FinanceSpendingPolicyRuleGroupArgs = {
  id: Scalars['String'];
};


export type FinanceSpendingPolicyRuleGroupsArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  onlyParents?: InputMaybe<Scalars['Boolean']>;
  parentId?: InputMaybe<Scalars['String']>;
  spendingPolicyIds?: InputMaybe<Array<Scalars['String']>>;
};


export type FinanceSpendingPolicyRuleGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyParents?: InputMaybe<Scalars['Boolean']>;
  parentId?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  spendingPolicyIds?: InputMaybe<Array<Scalars['String']>>;
};


export type FinanceSpendingPolicyRulesArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  spendingPolicyRuleGroupIds?: InputMaybe<Array<Scalars['String']>>;
};


export type FinanceSpendingPolicyRulesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  spendingPolicyRuleGroupIds?: InputMaybe<Array<Scalars['String']>>;
};


export type FinanceTaxBridgeActivationArgs = {
  id: Scalars['Int'];
};


export type FinanceTaxBridgeActivationsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type FinanceTaxBridgeActivationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type FinanceTaxRateArgs = {
  id: Scalars['Int'];
};


export type FinanceTaxRatesArgs = {
  countryCode?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<FinanceValueObjectsTaxSourceEnum>;
  taxTypeIds?: InputMaybe<Array<Scalars['Int']>>;
  type?: InputMaybe<FinanceValueObjectsTaxTypeEnum>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


export type FinanceTaxRatesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<FinanceTaxRateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  source?: InputMaybe<FinanceValueObjectsTaxSourceEnum>;
  taxTypeIds?: InputMaybe<Array<Scalars['Int']>>;
  type?: InputMaybe<FinanceValueObjectsTaxTypeEnum>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


export type FinanceTaxTypeArgs = {
  id: Scalars['Int'];
};


export type FinanceTaxTypesArgs = {
  countryCode?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<FinanceValueObjectsTaxSourceEnum>;
  type?: InputMaybe<FinanceValueObjectsTaxTypeEnum>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


export type FinanceTaxTypesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<FinanceTaxTypeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  source?: InputMaybe<FinanceValueObjectsTaxSourceEnum>;
  type?: InputMaybe<FinanceValueObjectsTaxTypeEnum>;
  updatedFrom?: InputMaybe<Scalars['ISO8601Date']>;
};

export type FinanceMutations = {
  __typename?: 'financeMutations';
  archiveFinanceBudget: ArchiveFinanceBudgetPayload;
  archiveFinanceQuote: ArchiveFinanceQuotePayload;
  archiveFinanceSerialSequenceCreditNoteSequence: ArchiveFinanceSerialSequenceCreditNoteSequencePayload;
  archiveFinanceSerialSequenceSalesInvoiceSequence: ArchiveFinanceSerialSequenceSalesInvoiceSequencePayload;
  archiveSaleFinanceFinancialDocument: ArchiveSaleFinanceFinancialDocumentPayload;
  bulkAssignmentsFinanceCostCenterMembership: BulkAssignmentsFinanceCostCenterMembershipPayload;
  bulkCreateFinanceBudgetAllocation: BulkCreateFinanceBudgetAllocationPayload;
  bulkCreateFinanceContactDocument: BulkCreateFinanceContactDocumentPayload;
  bulkCreateFinanceCostCenterMembership: BulkCreateFinanceCostCenterMembershipPayload;
  bulkCreateUpdateFinanceCostCenterMembership: BulkCreateUpdateFinanceCostCenterMembershipPayload;
  bulkDeleteFinanceBudgetAllocation: BulkDeleteFinanceBudgetAllocationPayload;
  bulkDeleteFinanceCostCenterMembership: BulkDeleteFinanceCostCenterMembershipPayload;
  bulkDiscardFinanceSpendingAlertSpendingAlert: BulkDiscardFinanceSpendingAlertSpendingAlertPayload;
  bulkManageFinanceReconciliation: BulkManageFinanceReconciliationPayload;
  bulkSendToPayFinanceFinancialDocument: BulkSendToPayFinanceFinancialDocumentPayload;
  bulkTerminateFinanceCostCenterMembership: BulkTerminateFinanceCostCenterMembershipPayload;
  bulkUpdateFinanceBudgetAllocation: BulkUpdateFinanceBudgetAllocationPayload;
  bulkUpdateFinanceCostCenterMembership: BulkUpdateFinanceCostCenterMembershipPayload;
  confirmFinanceReconciliationSuggestion: ConfirmFinanceReconciliationSuggestionPayload;
  convertFinanceMoney: ConvertFinanceMoneyPayload;
  convertToInvoiceFinanceQuote: ConvertToInvoiceFinanceQuotePayload;
  convertToProjectFinanceQuote: ConvertToProjectFinanceQuotePayload;
  createFinanceAccount: CreateFinanceAccountPayload;
  createFinanceBudget: CreateFinanceBudgetPayload;
  createFinanceBudgetAllocation: CreateFinanceBudgetAllocationPayload;
  createFinanceContact: CreateFinanceContactPayload;
  createFinanceCostCenter: CreateFinanceCostCenterPayload;
  createFinanceCustomCategory: CreateFinanceCustomCategoryPayload;
  createFinanceCustomDimension: CreateFinanceCustomDimensionPayload;
  createFinanceCustomDimensionValue: CreateFinanceCustomDimensionValuePayload;
  createFinanceDeal: CreateFinanceDealPayload;
  createFinanceFinancialDocumentAssociation: CreateFinanceFinancialDocumentAssociationPayload;
  createFinanceJournalEntry: CreateFinanceJournalEntryPayload;
  createFinanceQuote: CreateFinanceQuotePayload;
  createFinanceSalesDocumentTemplate: CreateFinanceSalesDocumentTemplatePayload;
  createFinanceSerialSequenceCreditNoteSequence: CreateFinanceSerialSequenceCreditNoteSequencePayload;
  createFinanceSerialSequenceSalesInvoiceSequence: CreateFinanceSerialSequenceSalesInvoiceSequencePayload;
  createFinanceSpendingAlertSpendingAlert: CreateFinanceSpendingAlertSpendingAlertPayload;
  createFinanceSpendingPolicySpendingPolicy: CreateFinanceSpendingPolicySpendingPolicyPayload;
  createFinanceSpendingPolicySpendingPolicyRuleGroup: CreateFinanceSpendingPolicySpendingPolicyRuleGroupPayload;
  createFinanceTaxRate: CreateFinanceTaxRatePayload;
  createFinanceTaxType: CreateFinanceTaxTypePayload;
  createForExpenseFinanceFinancialDocument: CreateForExpenseFinanceFinancialDocumentPayload;
  createFromSyncScanFileFinanceFinancialDocument: CreateFromSyncScanFileFinanceFinancialDocumentPayload;
  createSimpleFinanceLineItem: CreateSimpleFinanceLineItemPayload;
  createValidatingSalesClientFinanceContact: CreateValidatingSalesClientFinanceContactPayload;
  createWithAsyncScanFileFinanceFinancialDocument: CreateWithAsyncScanFileFinanceFinancialDocumentPayload;
  deleteFinanceAccount: DeleteFinanceAccountPayload;
  deleteFinanceComplianceExtraFieldDefaultSetting: DeleteFinanceComplianceExtraFieldDefaultSettingPayload;
  deleteFinanceContact: DeleteFinanceContactPayload;
  deleteFinanceCostCenter: DeleteFinanceCostCenterPayload;
  deleteFinanceCustomDimension: DeleteFinanceCustomDimensionPayload;
  deleteFinanceCustomDimensionValue: DeleteFinanceCustomDimensionValuePayload;
  deleteFinanceFinancialDocument: DeleteFinanceFinancialDocumentPayload;
  deleteFinanceSalesDocumentTemplate: DeleteFinanceSalesDocumentTemplatePayload;
  deleteFinanceSerialSequenceCreditNoteSequence: DeleteFinanceSerialSequenceCreditNoteSequencePayload;
  deleteFinanceSerialSequenceSalesInvoiceSequence: DeleteFinanceSerialSequenceSalesInvoiceSequencePayload;
  deleteFinanceSpendingPolicySpendingPolicy: DeleteFinanceSpendingPolicySpendingPolicyPayload;
  deleteFinanceSpendingPolicySpendingPolicyRuleGroup: DeleteFinanceSpendingPolicySpendingPolicyRuleGroupPayload;
  deleteFinanceTaxRate: DeleteFinanceTaxRatePayload;
  deleteFinanceTaxType: DeleteFinanceTaxTypePayload;
  disableFinanceAccount: DisableFinanceAccountPayload;
  disableFinanceCustomCategory: DisableFinanceCustomCategoryPayload;
  duplicateFinanceQuote: DuplicateFinanceQuotePayload;
  duplicateSaleFinanceFinancialDocument: DuplicateSaleFinanceFinancialDocumentPayload;
  editFinanceCostCenter: EditFinanceCostCenterPayload;
  editFinanceCustomDimensionValue: EditFinanceCustomDimensionValuePayload;
  enableFinanceAccount: EnableFinanceAccountPayload;
  enableFinanceCustomCategory: EnableFinanceCustomCategoryPayload;
  endFinanceCustomDimensionMembership: EndFinanceCustomDimensionMembershipPayload;
  exportFinanceCustomDimensionMembership: ExportFinanceCustomDimensionMembershipPayload;
  generatePdfFinanceQuotePdf: GeneratePdfFinanceQuotePdfPayload;
  getFinanceContactImportTemplate: GetFinanceContactImportTemplatePayload;
  importFinanceAccountingAccountImport: ImportFinanceAccountingAccountImportPayload;
  importFinanceContactsImportResult: ImportFinanceContactsImportResultPayload;
  importFinanceCostCenterMembershipImport: ImportFinanceCostCenterMembershipImportPayload;
  importFinanceCustomDimensionMembership: ImportFinanceCustomDimensionMembershipPayload;
  markAsReadFinanceMessage: MarkAsReadFinanceMessagePayload;
  parseFinanceAccountingAccountImport: ParseFinanceAccountingAccountImportPayload;
  parseFinanceInvoiceParser: ParseFinanceInvoiceParserPayload;
  previewFinanceFinancialDocumentPreview: PreviewFinanceFinancialDocumentPreviewPayload;
  previewFinanceQuotePreview: PreviewFinanceQuotePreviewPayload;
  recordDraftFinanceJournalEntry: RecordDraftFinanceJournalEntryPayload;
  registerSaleFinanceFinancialDocument: RegisterSaleFinanceFinancialDocumentPayload;
  rejectFinanceReconciliationSuggestion: RejectFinanceReconciliationSuggestionPayload;
  renameFinanceCustomDimension: RenameFinanceCustomDimensionPayload;
  snoozeFinanceJournalLine: SnoozeFinanceJournalLinePayload;
  softDeleteFinanceContactDocument: SoftDeleteFinanceContactDocumentPayload;
  softDeleteFinanceCustomCategory: SoftDeleteFinanceCustomCategoryPayload;
  unarchiveFinanceBudget: UnarchiveFinanceBudgetPayload;
  unarchiveFinanceSerialSequenceCreditNoteSequence: UnarchiveFinanceSerialSequenceCreditNoteSequencePayload;
  unarchiveFinanceSerialSequenceSalesInvoiceSequence: UnarchiveFinanceSerialSequenceSalesInvoiceSequencePayload;
  unsnoozeFinanceJournalLine: UnsnoozeFinanceJournalLinePayload;
  updateDetailsFinanceQuote: UpdateDetailsFinanceQuotePayload;
  updateFinanceAccount: UpdateFinanceAccountPayload;
  updateFinanceBudget: UpdateFinanceBudgetPayload;
  updateFinanceBudgetAllocation: UpdateFinanceBudgetAllocationPayload;
  updateFinanceContact: UpdateFinanceContactPayload;
  updateFinanceCustomCategory: UpdateFinanceCustomCategoryPayload;
  updateFinanceDeal: UpdateFinanceDealPayload;
  updateFinanceFinancialDocument: UpdateFinanceFinancialDocumentPayload;
  updateFinanceJournalDraftEntry: UpdateFinanceJournalDraftEntryPayload;
  updateFinanceQuote: UpdateFinanceQuotePayload;
  updateFinanceSalesDocumentTemplate: UpdateFinanceSalesDocumentTemplatePayload;
  updateFinanceSpendingPolicySpendingPolicy: UpdateFinanceSpendingPolicySpendingPolicyPayload;
  updateFinanceSpendingPolicySpendingPolicyAssignee: UpdateFinanceSpendingPolicySpendingPolicyAssigneePayload;
  updateFinanceSpendingPolicySpendingPolicyRuleGroup: UpdateFinanceSpendingPolicySpendingPolicyRuleGroupPayload;
  updateFinanceTaxRate: UpdateFinanceTaxRatePayload;
  updateFinanceTaxType: UpdateFinanceTaxTypePayload;
  updateFromSyncScanFileFinanceFinancialDocument: UpdateFromSyncScanFileFinanceFinancialDocumentPayload;
  updateNameFinanceSerialSequenceCreditNoteSequence: UpdateNameFinanceSerialSequenceCreditNoteSequencePayload;
  updateNameFinanceSerialSequenceSalesInvoiceSequence: UpdateNameFinanceSerialSequenceSalesInvoiceSequencePayload;
  updatePaymentDetailsFinanceContact: UpdatePaymentDetailsFinanceContactPayload;
  updateSimpleFinanceLineItem: UpdateSimpleFinanceLineItemPayload;
  upsertFinanceAccount: UpsertFinanceAccountPayload;
  upsertFinanceAccountingSetting: UpsertFinanceAccountingSettingPayload;
  upsertFinanceComplianceExtraFieldDefaultSetting: UpsertFinanceComplianceExtraFieldDefaultSettingPayload;
  upsertFinanceCustomDimensionMembership: UpsertFinanceCustomDimensionMembershipPayload;
  upsertFinanceLedgerAccountResource: UpsertFinanceLedgerAccountResourcePayload;
  upsertFinanceQuote: UpsertFinanceQuotePayload;
  upsertSaleFinanceFinancialDocument: UpsertSaleFinanceFinancialDocumentPayload;
  validateFinanceContactsImportResult: ValidateFinanceContactsImportResultPayload;
  validateSaleForIssueFinanceFinancialDocument: ValidateSaleForIssueFinanceFinancialDocumentPayload;
};


export type FinanceMutationsArchiveFinanceBudgetArgs = {
  id: Scalars['Int'];
};


export type FinanceMutationsArchiveFinanceQuoteArgs = {
  id: Scalars['Int'];
};


export type FinanceMutationsArchiveFinanceSerialSequenceCreditNoteSequenceArgs = {
  id: Scalars['Int'];
};


export type FinanceMutationsArchiveFinanceSerialSequenceSalesInvoiceSequenceArgs = {
  id: Scalars['Int'];
};


export type FinanceMutationsArchiveSaleFinanceFinancialDocumentArgs = {
  id: Scalars['Int'];
};


export type FinanceMutationsBulkAssignmentsFinanceCostCenterMembershipArgs = {
  membershipsToCreate: Array<BulkAssignmentsFinanceCostCenterMembershipMembershipsToCreateInput>;
  membershipsToUpdate: Array<BulkAssignmentsFinanceCostCenterMembershipMembershipsToUpdateInput>;
};


export type FinanceMutationsBulkCreateFinanceBudgetAllocationArgs = {
  amountCents?: InputMaybe<Scalars['Int']>;
  budgetId: Scalars['Int'];
  budgetLimitAmountCents?: InputMaybe<Scalars['Int']>;
  employeeIds: Array<Scalars['Int']>;
};


export type FinanceMutationsBulkCreateFinanceContactDocumentArgs = {
  contactId: Scalars['Int'];
  files: Array<Scalars['File']>;
  uploaderId: Scalars['Int'];
};


export type FinanceMutationsBulkCreateFinanceCostCenterMembershipArgs = {
  memberships: Array<BulkCreateFinanceCostCenterMembershipMembershipsInput>;
};


export type FinanceMutationsBulkCreateUpdateFinanceCostCenterMembershipArgs = {
  companyId: Scalars['Int'];
  employeeId: Scalars['Int'];
  memberships: Array<BulkCreateUpdateFinanceCostCenterMembershipMembershipsInput>;
};


export type FinanceMutationsBulkDeleteFinanceBudgetAllocationArgs = {
  budgetId: Scalars['Int'];
  ids: Array<Scalars['Int']>;
};


export type FinanceMutationsBulkDeleteFinanceCostCenterMembershipArgs = {
  ids: Array<Scalars['Int']>;
};


export type FinanceMutationsBulkDiscardFinanceSpendingAlertSpendingAlertArgs = {
  companyId: Scalars['Int'];
  ids: Array<Scalars['Int']>;
};


export type FinanceMutationsBulkManageFinanceReconciliationArgs = {
  companyId: Scalars['Int'];
  reconciliationIdsToRemove: Array<Scalars['Int']>;
  reconciliations: Array<BulkManageFinanceReconciliationReconciliationsInput>;
};


export type FinanceMutationsBulkSendToPayFinanceFinancialDocumentArgs = {
  companyId: Scalars['Int'];
  ids: Array<Scalars['Int']>;
};


export type FinanceMutationsBulkTerminateFinanceCostCenterMembershipArgs = {
  ids: Array<Scalars['Int']>;
};


export type FinanceMutationsBulkUpdateFinanceBudgetAllocationArgs = {
  amountCents?: InputMaybe<Scalars['Int']>;
  budgetId: Scalars['Int'];
  budgetLimitAmountCents?: InputMaybe<Scalars['Int']>;
  ids: Array<Scalars['Int']>;
};


export type FinanceMutationsBulkUpdateFinanceCostCenterMembershipArgs = {
  memberships: Array<BulkUpdateFinanceCostCenterMembershipMembershipsInput>;
};


export type FinanceMutationsConfirmFinanceReconciliationSuggestionArgs = {
  id: Scalars['Int'];
};


export type FinanceMutationsConvertFinanceMoneyArgs = {
  date?: InputMaybe<Scalars['ISO8601Date']>;
  money: MoneyInput;
  provider?: InputMaybe<FinanceValueObjectsCurrencyProvidersEnum>;
  targetCurrency: Scalars['String'];
};


export type FinanceMutationsConvertToInvoiceFinanceQuoteArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type FinanceMutationsConvertToProjectFinanceQuoteArgs = {
  id: Scalars['Int'];
  ownerEmployeeId: Scalars['Int'];
  projectName: Scalars['String'];
};


export type FinanceMutationsCreateFinanceAccountArgs = {
  currency: Scalars['String'];
  disabled: Scalars['Boolean'];
  externalId?: InputMaybe<Scalars['String']>;
  legalEntityId: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  number: Scalars['String'];
  type: FinanceValueObjectsAccountTypeEnum;
};


export type FinanceMutationsCreateFinanceBudgetArgs = {
  allocatedAmountCents?: InputMaybe<Scalars['BigInt']>;
  amountCents: Scalars['BigInt'];
  description?: InputMaybe<Scalars['String']>;
  effectiveFrom: Scalars['ISO8601DateTime'];
  effectiveUntil?: InputMaybe<Scalars['ISO8601DateTime']>;
  legalEntityId: Scalars['Int'];
  name: Scalars['String'];
  ownerEmployeeIds: Array<Scalars['Int']>;
  periodicity: FinanceValueObjectsBudgetPeriodicityEnum;
  spenderEmployeeIds: Array<Scalars['Int']>;
  viewerEmployeeIds: Array<Scalars['Int']>;
};


export type FinanceMutationsCreateFinanceBudgetAllocationArgs = {
  amountCents?: InputMaybe<Scalars['Int']>;
  budgetId: Scalars['Int'];
  employeeId: Scalars['Int'];
};


export type FinanceMutationsCreateFinanceContactArgs = {
  address?: InputMaybe<FinanceVendorAddressInput>;
  bankCode?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  contactTypes?: InputMaybe<Array<FinanceValueObjectsContactTypeEnum>>;
  email?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  iban?: InputMaybe<Scalars['String']>;
  legalName?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['String']>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  taxId?: InputMaybe<Scalars['String']>;
  taxIdType?: InputMaybe<FinanceValueObjectsContactTaxIdTypeEnum>;
  website?: InputMaybe<Scalars['String']>;
};


export type FinanceMutationsCreateFinanceCostCenterArgs = {
  code?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  description?: InputMaybe<Scalars['String']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};


export type FinanceMutationsCreateFinanceCustomCategoryArgs = {
  companyId: Scalars['Int'];
  deleted?: InputMaybe<Scalars['Boolean']>;
  enabled: Scalars['Boolean'];
  factorialCategoryIdentifier?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
  ledgerAccountAssignments?: InputMaybe<Array<FinanceCategoryLedgerAccountInput>>;
  parentCategoryId?: InputMaybe<Scalars['Int']>;
  position?: InputMaybe<Scalars['Int']>;
  protected: Scalars['Boolean'];
  visible: Scalars['Boolean'];
};


export type FinanceMutationsCreateFinanceCustomDimensionArgs = {
  companyId: Scalars['Int'];
  legalEntityId?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};


export type FinanceMutationsCreateFinanceCustomDimensionValueArgs = {
  code?: InputMaybe<Scalars['String']>;
  customDimensionId: Scalars['Int'];
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  tenant: FinanceTenantInput;
};


export type FinanceMutationsCreateFinanceDealArgs = {
  clientId: Scalars['Int'];
  currency: Scalars['String'];
  estimatedAmountCents: Scalars['Int'];
  expectedCloseDate?: InputMaybe<Scalars['ISO8601Date']>;
  name: Scalars['String'];
  ownerId?: InputMaybe<Scalars['Int']>;
  stage: FinanceValueObjectsDealStageEnum;
};


export type FinanceMutationsCreateFinanceFinancialDocumentAssociationArgs = {
  companyId: Scalars['Int'];
  financialDocumentId: Scalars['Int'];
  resource: FinanceInvoiceResourceInput;
};


export type FinanceMutationsCreateFinanceJournalEntryArgs = {
  description?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  legalEntityId: Scalars['Int'];
  lines: Array<CreateFinanceJournalEntryLinesInput>;
  referenceDate: Scalars['ISO8601Date'];
  status?: InputMaybe<FinanceValueObjectsJournalEntryStatusEnum>;
  type?: InputMaybe<FinanceValueObjectsJournalEntryTypeEnum>;
};


export type FinanceMutationsCreateFinanceQuoteArgs = {
  clientId?: InputMaybe<Scalars['Int']>;
  dealId?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  quoteType: FinanceEnumsQuoteTypeEnum;
};


export type FinanceMutationsCreateFinanceSalesDocumentTemplateArgs = {
  default: Scalars['Boolean'];
  footer?: InputMaybe<Scalars['String']>;
  legalEntityId: Scalars['Int'];
  logoFile?: InputMaybe<Scalars['File']>;
  name: Scalars['String'];
};


export type FinanceMutationsCreateFinanceSerialSequenceCreditNoteSequenceArgs = {
  legalEntityId: Scalars['Int'];
  name: Scalars['String'];
  prefix?: InputMaybe<Scalars['String']>;
  sequenceLength: Scalars['Int'];
  startFrom: Scalars['Int'];
  suffix?: InputMaybe<Scalars['String']>;
};


export type FinanceMutationsCreateFinanceSerialSequenceSalesInvoiceSequenceArgs = {
  legalEntityId: Scalars['Int'];
  name: Scalars['String'];
  prefix?: InputMaybe<Scalars['String']>;
  sequenceLength: Scalars['Int'];
  startFrom: Scalars['Int'];
  suffix?: InputMaybe<Scalars['String']>;
};


export type FinanceMutationsCreateFinanceSpendingAlertSpendingAlertArgs = {
  companyId: Scalars['Int'];
  reason?: InputMaybe<Scalars['String']>;
  status: FinanceValueObjectsSpendingAlertStatusEnum;
  targetId: Scalars['Int'];
  targetType: Scalars['String'];
  type: FinanceValueObjectsSpendingAlertTypeEnum;
};


export type FinanceMutationsCreateFinanceSpendingPolicySpendingPolicyArgs = {
  companyId: Scalars['Int'];
  description?: InputMaybe<Scalars['String']>;
  icon?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  peopleGroup?: InputMaybe<CreateFinanceSpendingPolicySpendingPolicyPeopleGroupInput>;
  ruleGroups: Array<CreateFinanceSpendingPolicySpendingPolicyRuleGroupsInput>;
};


export type FinanceMutationsCreateFinanceSpendingPolicySpendingPolicyRuleGroupArgs = {
  description?: InputMaybe<Scalars['String']>;
  parentRuleGroupId?: InputMaybe<Scalars['String']>;
  rules: Array<CreateFinanceSpendingPolicySpendingPolicyRuleGroupRulesInput>;
  spendingPolicyId: Scalars['String'];
};


export type FinanceMutationsCreateFinanceTaxRateArgs = {
  amount?: InputMaybe<Scalars['Float']>;
  description?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  rate?: InputMaybe<Scalars['Float']>;
  taxTypeId?: InputMaybe<Scalars['Int']>;
};


export type FinanceMutationsCreateFinanceTaxTypeArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  countryCode?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  ledgerAccountAssignments?: InputMaybe<Array<CreateFinanceTaxTypeLedgerAccountAssignmentsInput>>;
  name: Scalars['String'];
  taxRates?: InputMaybe<Array<CreateFinanceTaxTypeTaxRatesInput>>;
  type: FinanceValueObjectsTaxTypeEnum;
};


export type FinanceMutationsCreateForExpenseFinanceFinancialDocumentArgs = {
  companyId: Scalars['Int'];
  expenseId: Scalars['Int'];
  ownerIds: Array<Scalars['Int']>;
};


export type FinanceMutationsCreateFromSyncScanFileFinanceFinancialDocumentArgs = {
  companyId: Scalars['Int'];
  employeeIds: Array<Scalars['Int']>;
  file: Scalars['File'];
  readyForValidationAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  resource?: InputMaybe<FinanceInvoiceResourceInput>;
};


export type FinanceMutationsCreateSimpleFinanceLineItemArgs = {
  description: Scalars['String'];
  discountPercentage: Scalars['Float'];
  parentId?: InputMaybe<Scalars['Int']>;
  quantity: Scalars['Float'];
  sourceId: Scalars['Int'];
  sourceType: FinanceValueObjectsLineItemSourceTypeEnum;
  taxRateId?: InputMaybe<Scalars['Int']>;
  unitPriceCents: Scalars['Int'];
};


export type FinanceMutationsCreateValidatingSalesClientFinanceContactArgs = {
  address?: InputMaybe<FinanceVendorAddressInput>;
  bankCode?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  iban?: InputMaybe<Scalars['String']>;
  legalName?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['String']>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  taxId?: InputMaybe<Scalars['String']>;
  taxIdType?: InputMaybe<FinanceValueObjectsContactTaxIdTypeEnum>;
  website?: InputMaybe<Scalars['String']>;
};


export type FinanceMutationsCreateWithAsyncScanFileFinanceFinancialDocumentArgs = {
  companyId: Scalars['Int'];
  file: Scalars['File'];
  resources?: InputMaybe<Array<FinanceInvoiceResourceInput>>;
  vendorId?: InputMaybe<Scalars['Int']>;
};


export type FinanceMutationsDeleteFinanceAccountArgs = {
  id: Scalars['Int'];
};


export type FinanceMutationsDeleteFinanceComplianceExtraFieldDefaultSettingArgs = {
  id: Scalars['Int'];
};


export type FinanceMutationsDeleteFinanceContactArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type FinanceMutationsDeleteFinanceCostCenterArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type FinanceMutationsDeleteFinanceCustomDimensionArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type FinanceMutationsDeleteFinanceCustomDimensionValueArgs = {
  id: Scalars['Int'];
  tenant: FinanceTenantInput;
};


export type FinanceMutationsDeleteFinanceFinancialDocumentArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type FinanceMutationsDeleteFinanceSalesDocumentTemplateArgs = {
  id: Scalars['Int'];
};


export type FinanceMutationsDeleteFinanceSerialSequenceCreditNoteSequenceArgs = {
  id: Scalars['Int'];
};


export type FinanceMutationsDeleteFinanceSerialSequenceSalesInvoiceSequenceArgs = {
  id: Scalars['Int'];
};


export type FinanceMutationsDeleteFinanceSpendingPolicySpendingPolicyArgs = {
  id: Scalars['String'];
};


export type FinanceMutationsDeleteFinanceSpendingPolicySpendingPolicyRuleGroupArgs = {
  companyId: Scalars['String'];
  id: Scalars['String'];
};


export type FinanceMutationsDeleteFinanceTaxRateArgs = {
  id: Scalars['Int'];
};


export type FinanceMutationsDeleteFinanceTaxTypeArgs = {
  id: Scalars['Int'];
};


export type FinanceMutationsDisableFinanceAccountArgs = {
  id: Scalars['Int'];
  ledgerAccountIdToMerge?: InputMaybe<Scalars['Int']>;
};


export type FinanceMutationsDisableFinanceCustomCategoryArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type FinanceMutationsDuplicateFinanceQuoteArgs = {
  id: Scalars['Int'];
};


export type FinanceMutationsDuplicateSaleFinanceFinancialDocumentArgs = {
  authorId: Scalars['Int'];
  id: Scalars['Int'];
};


export type FinanceMutationsEditFinanceCostCenterArgs = {
  code?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
};


export type FinanceMutationsEditFinanceCustomDimensionValueArgs = {
  code?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  tenant?: InputMaybe<FinanceTenantInput>;
};


export type FinanceMutationsEnableFinanceAccountArgs = {
  id: Scalars['Int'];
};


export type FinanceMutationsEnableFinanceCustomCategoryArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type FinanceMutationsEndFinanceCustomDimensionMembershipArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type FinanceMutationsExportFinanceCustomDimensionMembershipArgs = {
  companyId: Scalars['Int'];
  dimensionId: Scalars['Int'];
  legalEntityId: Scalars['Int'];
};


export type FinanceMutationsGeneratePdfFinanceQuotePdfArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type FinanceMutationsGetFinanceContactImportTemplateArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


export type FinanceMutationsImportFinanceAccountingAccountImportArgs = {
  file: Scalars['File'];
  legalEntityId: Scalars['Int'];
};


export type FinanceMutationsImportFinanceContactsImportResultArgs = {
  companyId: Scalars['Int'];
  contactType: FinanceValueObjectsContactTypeEnum;
  file: Scalars['File'];
  locale?: InputMaybe<Scalars['String']>;
};


export type FinanceMutationsImportFinanceCostCenterMembershipImportArgs = {
  companyId: Scalars['Int'];
  file: Scalars['File'];
};


export type FinanceMutationsImportFinanceCustomDimensionMembershipArgs = {
  dimensionId: Scalars['Int'];
  file: Scalars['File'];
  tenant: FinanceTenantInput;
};


export type FinanceMutationsMarkAsReadFinanceMessageArgs = {
  id: Scalars['String'];
};


export type FinanceMutationsParseFinanceAccountingAccountImportArgs = {
  file: Scalars['File'];
  legalEntityId: Scalars['Int'];
};


export type FinanceMutationsParseFinanceInvoiceParserArgs = {
  file: Scalars['File'];
};


export type FinanceMutationsPreviewFinanceFinancialDocumentPreviewArgs = {
  contactId?: InputMaybe<Scalars['Int']>;
  currency?: InputMaybe<Scalars['String']>;
  discountPercentage?: InputMaybe<Scalars['Float']>;
  documentType: FinanceValueObjectsFinancialDocumentTypeEnum;
  dueDate?: InputMaybe<Scalars['ISO8601Date']>;
  footer?: InputMaybe<Scalars['String']>;
  issueDate?: InputMaybe<Scalars['ISO8601Date']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  lineItems: Array<PreviewFinanceFinancialDocumentPreviewLineItemsInput>;
  logoFile?: InputMaybe<Scalars['File']>;
  memo?: InputMaybe<Scalars['String']>;
  operationDate?: InputMaybe<Scalars['ISO8601Date']>;
  operationType: FinanceValueObjectsFinancialDocumentOperationTypeEnum;
  projectId?: InputMaybe<Scalars['Int']>;
  retentionTaxRateId?: InputMaybe<Scalars['Int']>;
  serialSequenceId?: InputMaybe<Scalars['Int']>;
  subprojectId?: InputMaybe<Scalars['Int']>;
};


export type FinanceMutationsPreviewFinanceQuotePreviewArgs = {
  clientId?: InputMaybe<Scalars['Int']>;
  currency?: InputMaybe<Scalars['String']>;
  discountPercentage?: InputMaybe<Scalars['Float']>;
  documentDate?: InputMaybe<Scalars['ISO8601Date']>;
  expirationDate?: InputMaybe<Scalars['ISO8601Date']>;
  footer?: InputMaybe<Scalars['String']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  lineItems: Array<PreviewFinanceQuotePreviewLineItemsInput>;
  logoFile?: InputMaybe<Scalars['File']>;
  memo?: InputMaybe<Scalars['String']>;
  quoteNumber?: InputMaybe<Scalars['String']>;
};


export type FinanceMutationsRecordDraftFinanceJournalEntryArgs = {
  journalDraftEntryId: Scalars['Int'];
};


export type FinanceMutationsRegisterSaleFinanceFinancialDocumentArgs = {
  id: Scalars['Int'];
};


export type FinanceMutationsRejectFinanceReconciliationSuggestionArgs = {
  id: Scalars['Int'];
};


export type FinanceMutationsRenameFinanceCustomDimensionArgs = {
  id: Scalars['Int'];
  name: Scalars['String'];
  tenant: FinanceTenantInput;
};


export type FinanceMutationsSnoozeFinanceJournalLineArgs = {
  id: Scalars['Int'];
  snoozedUntil: Scalars['ISO8601DateTime'];
};


export type FinanceMutationsSoftDeleteFinanceContactDocumentArgs = {
  contactId: Scalars['Int'];
  ids: Array<Scalars['Int']>;
};


export type FinanceMutationsSoftDeleteFinanceCustomCategoryArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type FinanceMutationsUnarchiveFinanceBudgetArgs = {
  id: Scalars['Int'];
};


export type FinanceMutationsUnarchiveFinanceSerialSequenceCreditNoteSequenceArgs = {
  id: Scalars['Int'];
};


export type FinanceMutationsUnarchiveFinanceSerialSequenceSalesInvoiceSequenceArgs = {
  id: Scalars['Int'];
};


export type FinanceMutationsUnsnoozeFinanceJournalLineArgs = {
  id: Scalars['Int'];
};


export type FinanceMutationsUpdateDetailsFinanceQuoteArgs = {
  contactId: Scalars['Int'];
  currency: Scalars['String'];
  dealId?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  documentDate: Scalars['ISO8601Date'];
  expirationDate?: InputMaybe<Scalars['ISO8601Date']>;
  footer?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  legalEntityId: Scalars['Int'];
  logoFile?: InputMaybe<Scalars['File']>;
  memo?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  quoteNumber: Scalars['String'];
  quoteType: FinanceEnumsQuoteTypeEnum;
  status: FinanceEnumsQuoteStatusEnum;
};


export type FinanceMutationsUpdateFinanceAccountArgs = {
  currency?: InputMaybe<Scalars['String']>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  externalId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  legalEntityId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<FinanceValueObjectsAccountTypeEnum>;
};


export type FinanceMutationsUpdateFinanceBudgetArgs = {
  amountCents?: InputMaybe<Scalars['BigInt']>;
  description?: InputMaybe<Scalars['String']>;
  effectiveFrom?: InputMaybe<Scalars['ISO8601DateTime']>;
  effectiveUntil?: InputMaybe<Scalars['ISO8601DateTime']>;
  id: Scalars['Int'];
  legalEntityId: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  ownerEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  periodicity?: InputMaybe<FinanceValueObjectsBudgetPeriodicityEnum>;
  spenderEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  viewerEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type FinanceMutationsUpdateFinanceBudgetAllocationArgs = {
  amountCents?: InputMaybe<Scalars['Int']>;
  budgetId: Scalars['Int'];
  id: Scalars['Int'];
};


export type FinanceMutationsUpdateFinanceContactArgs = {
  address?: InputMaybe<FinanceVendorAddressInput>;
  companyId?: InputMaybe<Scalars['Int']>;
  contactTypes?: InputMaybe<Array<FinanceValueObjectsContactTypeEnum>>;
  email?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  legalName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  taxId?: InputMaybe<Scalars['String']>;
  taxIdType?: InputMaybe<FinanceValueObjectsContactTaxIdTypeEnum>;
  website?: InputMaybe<Scalars['String']>;
};


export type FinanceMutationsUpdateFinanceCustomCategoryArgs = {
  deleted: Scalars['Boolean'];
  enabled: Scalars['Boolean'];
  id: Scalars['Int'];
  label?: InputMaybe<Scalars['String']>;
  ledgerAccountAssignments?: InputMaybe<Array<FinanceCategoryLedgerAccountInput>>;
  parentCategoryId?: InputMaybe<Scalars['Int']>;
  position: Scalars['Int'];
  visible: Scalars['Boolean'];
};


export type FinanceMutationsUpdateFinanceDealArgs = {
  clientId: Scalars['Int'];
  currency: Scalars['String'];
  estimatedAmountCents: Scalars['Int'];
  expectedCloseDate?: InputMaybe<Scalars['ISO8601Date']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  ownerId?: InputMaybe<Scalars['Int']>;
  stage: FinanceValueObjectsDealStageEnum;
};


export type FinanceMutationsUpdateFinanceFinancialDocumentArgs = {
  associations?: InputMaybe<Array<FinanceFinancialDocumentAssociationInput>>;
  companyId: Scalars['Int'];
  currency?: InputMaybe<Scalars['String']>;
  documentDate?: InputMaybe<Scalars['ISO8601Date']>;
  documentNumber?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<FinanceValueObjectsFinancialDocumentTypeEnum>;
  dueDate?: InputMaybe<Scalars['ISO8601Date']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  id: Scalars['Int'];
  ledgerAccountId?: InputMaybe<Scalars['Int']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  parentFinancialDocumentId?: InputMaybe<Scalars['Int']>;
  status: FinanceValueObjectsInvoiceStatusEnum;
  taxes: Array<FinanceInvoiceTaxInput>;
  totalAmountCents?: InputMaybe<Scalars['Int']>;
  validateDocumentNumberUniqueness?: InputMaybe<Scalars['Boolean']>;
  validatedAt?: InputMaybe<Scalars['String']>;
  vendorId?: InputMaybe<Scalars['Int']>;
};


export type FinanceMutationsUpdateFinanceJournalDraftEntryArgs = {
  description?: InputMaybe<Scalars['String']>;
  journalDraftEntryId: Scalars['Int'];
  lines: Array<UpdateFinanceJournalDraftEntryLinesInput>;
  linesIdsToDelete: Array<Scalars['Int']>;
  referenceDate?: InputMaybe<Scalars['ISO8601Date']>;
};


export type FinanceMutationsUpdateFinanceQuoteArgs = {
  id: Scalars['Int'];
  status: FinanceEnumsQuoteStatusEnum;
};


export type FinanceMutationsUpdateFinanceSalesDocumentTemplateArgs = {
  default: Scalars['Boolean'];
  footer?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  logoFile?: InputMaybe<Scalars['File']>;
  name: Scalars['String'];
};


export type FinanceMutationsUpdateFinanceSpendingPolicySpendingPolicyArgs = {
  closingText?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  icon?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  introText?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};


export type FinanceMutationsUpdateFinanceSpendingPolicySpendingPolicyAssigneeArgs = {
  peopleGroup?: InputMaybe<UpdateFinanceSpendingPolicySpendingPolicyAssigneePeopleGroupInput>;
  spendingPolicyId: Scalars['Int'];
};


export type FinanceMutationsUpdateFinanceSpendingPolicySpendingPolicyRuleGroupArgs = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  rules: Array<UpdateFinanceSpendingPolicySpendingPolicyRuleGroupRulesInput>;
};


export type FinanceMutationsUpdateFinanceTaxRateArgs = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};


export type FinanceMutationsUpdateFinanceTaxTypeArgs = {
  countryCode?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  ledgerAccountAssignments?: InputMaybe<Array<UpdateFinanceTaxTypeLedgerAccountAssignmentsInput>>;
  name?: InputMaybe<Scalars['String']>;
  type: FinanceValueObjectsTaxTypeEnum;
};


export type FinanceMutationsUpdateFromSyncScanFileFinanceFinancialDocumentArgs = {
  file: Scalars['File'];
  id: Scalars['Int'];
};


export type FinanceMutationsUpdateNameFinanceSerialSequenceCreditNoteSequenceArgs = {
  id: Scalars['Int'];
  name: Scalars['String'];
};


export type FinanceMutationsUpdateNameFinanceSerialSequenceSalesInvoiceSequenceArgs = {
  id: Scalars['Int'];
  name: Scalars['String'];
};


export type FinanceMutationsUpdatePaymentDetailsFinanceContactArgs = {
  bankCode?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  iban?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  preferredPaymentMethod?: InputMaybe<FinanceValueObjectsVendorPreferredPaymentMethodEnum>;
};


export type FinanceMutationsUpdateSimpleFinanceLineItemArgs = {
  description: Scalars['String'];
  discountPercentage: Scalars['Float'];
  id: Scalars['Int'];
  quantity: Scalars['Float'];
  taxRateId?: InputMaybe<Scalars['Int']>;
  unitPriceCents: Scalars['Int'];
};


export type FinanceMutationsUpsertFinanceAccountArgs = {
  currency: Scalars['String'];
  disabled: Scalars['Boolean'];
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  legalEntityId: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  number: Scalars['String'];
  type: FinanceValueObjectsAccountTypeEnum;
};


export type FinanceMutationsUpsertFinanceAccountingSettingArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  defaultAccountForBanksId?: InputMaybe<Scalars['Int']>;
  defaultAccountForBenefitsId?: InputMaybe<Scalars['Int']>;
  defaultAccountForClientsId?: InputMaybe<Scalars['Int']>;
  defaultAccountForEmployeesId?: InputMaybe<Scalars['Int']>;
  defaultAccountForExpensesId?: InputMaybe<Scalars['Int']>;
  defaultAccountForPurchaseInvoicesId?: InputMaybe<Scalars['Int']>;
  defaultAccountForSaleInvoicesId?: InputMaybe<Scalars['Int']>;
  defaultAccountForSuspenseId?: InputMaybe<Scalars['Int']>;
  defaultAccountForVendorsId?: InputMaybe<Scalars['Int']>;
  externalId?: InputMaybe<Scalars['String']>;
  legalEntityId: Scalars['Int'];
};


export type FinanceMutationsUpsertFinanceComplianceExtraFieldDefaultSettingArgs = {
  country: Scalars['String'];
  creditNoteDefaultValues: Array<FinanceComplianceExtraFieldDefaultSettingValueInput>;
  invoiceDefaultValues: Array<FinanceComplianceExtraFieldDefaultSettingValueInput>;
  legalEntityId: Scalars['Int'];
  organization: FinanceValueObjectsComplianceExtraFieldOrganizationEnum;
};


export type FinanceMutationsUpsertFinanceCustomDimensionMembershipArgs = {
  companyId: Scalars['Int'];
  customDimensionValueId: Scalars['Int'];
  employeeId: Scalars['Int'];
};


export type FinanceMutationsUpsertFinanceLedgerAccountResourceArgs = {
  accountId?: InputMaybe<Scalars['Int']>;
  balanceType?: InputMaybe<FinanceValueObjectsLedgerAccountBalanceTypeEnum>;
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  legalEntityId: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  operationType?: InputMaybe<FinanceValueObjectsLedgerAccountOperationTypeEnum>;
  resourceId?: InputMaybe<Scalars['Int']>;
  resourceType: FinanceValueObjectsLedgerAccountResourceTypeEnum;
};


export type FinanceMutationsUpsertFinanceQuoteArgs = {
  contactId: Scalars['Int'];
  currency: Scalars['String'];
  dealId?: InputMaybe<Scalars['Int']>;
  discountPercentage?: InputMaybe<Scalars['Float']>;
  documentDate: Scalars['ISO8601Date'];
  expirationDate?: InputMaybe<Scalars['ISO8601Date']>;
  financeLineItems: Array<UpsertFinanceQuoteFinanceLineItemsInput>;
  footer?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  legalEntityId: Scalars['Int'];
  logoFile?: InputMaybe<Scalars['File']>;
  memo?: InputMaybe<Scalars['String']>;
  quoteNumber: Scalars['String'];
  status?: InputMaybe<FinanceEnumsQuoteStatusEnum>;
};


export type FinanceMutationsUpsertSaleFinanceFinancialDocumentArgs = {
  complianceExtraFields?: InputMaybe<Array<UpsertSaleFinanceFinancialDocumentComplianceExtraFieldsInput>>;
  contactId?: InputMaybe<Scalars['Int']>;
  currency?: InputMaybe<Scalars['String']>;
  discountPercentage?: InputMaybe<Scalars['Float']>;
  documentType: FinanceValueObjectsFinancialDocumentTypeEnum;
  dueDate?: InputMaybe<Scalars['ISO8601Date']>;
  exchangeRate?: InputMaybe<Scalars['String']>;
  footer?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  lineItems: Array<UpsertSaleFinanceFinancialDocumentLineItemsInput>;
  logoFile?: InputMaybe<Scalars['File']>;
  memo?: InputMaybe<Scalars['String']>;
  operationDate?: InputMaybe<Scalars['ISO8601Date']>;
  originalFinancialDocumentId?: InputMaybe<Scalars['Int']>;
  projectId?: InputMaybe<Scalars['Int']>;
  retentionTaxRateId?: InputMaybe<Scalars['Int']>;
  serialSequenceId?: InputMaybe<Scalars['Int']>;
  subprojectId?: InputMaybe<Scalars['Int']>;
};


export type FinanceMutationsValidateFinanceContactsImportResultArgs = {
  companyId: Scalars['Int'];
  contactType: FinanceValueObjectsContactTypeEnum;
  file: Scalars['File'];
  locale?: InputMaybe<Scalars['String']>;
};


export type FinanceMutationsValidateSaleForIssueFinanceFinancialDocumentArgs = {
  complianceExtraFields?: InputMaybe<Array<ValidateSaleForIssueFinanceFinancialDocumentComplianceExtraFieldsInput>>;
  contactId: Scalars['Int'];
  currency: Scalars['String'];
  discountPercentage?: InputMaybe<Scalars['Float']>;
  documentType: FinanceValueObjectsFinancialDocumentTypeEnum;
  dueDate: Scalars['ISO8601Date'];
  exchangeRate?: InputMaybe<Scalars['String']>;
  footer?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  legalEntityId: Scalars['Int'];
  lineItems: Array<ValidateSaleForIssueFinanceFinancialDocumentLineItemsInput>;
  logoFile?: InputMaybe<Scalars['File']>;
  memo?: InputMaybe<Scalars['String']>;
  operationDate: Scalars['ISO8601Date'];
  originalFinancialDocumentId?: InputMaybe<Scalars['Int']>;
  projectId?: InputMaybe<Scalars['Int']>;
  retentionTaxRateId?: InputMaybe<Scalars['Int']>;
  serialSequenceId: Scalars['Int'];
  subprojectId?: InputMaybe<Scalars['Int']>;
};

export type FinancialWorkspace = {
  __typename?: 'financialWorkspace';
  _policies: FinancialWorkspaceContextlessPolicies;
  /** @deprecated Please favor `employeeContractRatesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  employeeContractRates: Array<FinancialWorkspaceEmployeeContractRate>;
  employeeContractRatesConnection: FinancialWorkspaceEmployeeContractRateConnection;
  employeesIncompleteContract?: Maybe<FinancialWorkspaceEmployeesIncompleteContract>;
  /** @deprecated Please favor `employeesIncompleteContractsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  employeesIncompleteContracts: Array<FinancialWorkspaceEmployeesIncompleteContract>;
  employeesIncompleteContractsConnection: FinancialWorkspaceEmployeesIncompleteContractConnection;
  /** @deprecated Please favor `employeesIncompleteGrossSalariesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  employeesIncompleteGrossSalaries: Array<FinancialWorkspaceEmployeesIncompleteGrossSalary>;
  employeesIncompleteGrossSalariesConnection: FinancialWorkspaceEmployeesIncompleteGrossSalaryConnection;
  employeesIncompleteGrossSalary?: Maybe<FinancialWorkspaceEmployeesIncompleteGrossSalary>;
  /** @deprecated Please favor `financeFactSummariesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  financeFactSummaries: Array<FinancialWorkspaceFinanceFactSummary>;
  financeFactSummariesConnection: FinancialWorkspaceFinanceFactSummaryConnection;
  financeFactSummary?: Maybe<FinancialWorkspaceFinanceFactSummary>;
  insightTableItem?: Maybe<FinancialWorkspaceInsightTableItem>;
  /** @deprecated Please favor `insightTableItemsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  insightTableItems: Array<FinancialWorkspaceInsightTableItem>;
  insightTableItemsConnection: FinancialWorkspaceInsightTableItemConnection;
  laborCostConcept?: Maybe<FinancialWorkspaceLaborCostConcept>;
  /** @deprecated Please favor `laborCostConceptsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  laborCostConcepts: Array<FinancialWorkspaceLaborCostConcept>;
  laborCostConceptsConnection: FinancialWorkspaceLaborCostConceptConnection;
  /** @deprecated Please favor `payrollLandingBannersConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  payrollLandingBanners: Array<FinancialWorkspacePayrollLandingBanner>;
  payrollLandingBannersConnection: FinancialWorkspacePayrollLandingBannerConnection;
  setting?: Maybe<FinancialWorkspaceSetting>;
  /** @deprecated Please favor `settingsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  settings: Array<FinancialWorkspaceSetting>;
  settingsConnection: FinancialWorkspaceSettingConnection;
};


export type FinancialWorkspaceEmployeeContractRatesArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  formattedEndDate: Scalars['String'];
  formattedStartDate: Scalars['String'];
  period?: InputMaybe<FinancialWorkspaceValueObjectsPeriodEnum>;
};


export type FinancialWorkspaceEmployeeContractRatesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  formattedEndDate: Scalars['String'];
  formattedStartDate: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  period?: InputMaybe<FinancialWorkspaceValueObjectsPeriodEnum>;
  sortOrder?: InputMaybe<Sort>;
};


export type FinancialWorkspaceEmployeesIncompleteContractArgs = {
  formattedEndDate: Scalars['String'];
  formattedStartDate: Scalars['String'];
  id: Scalars['Int'];
  period: FinancialWorkspaceValueObjectsPeriodEnum;
};


export type FinancialWorkspaceEmployeesIncompleteContractsArgs = {
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  formattedEndDate: Scalars['String'];
  formattedStartDate: Scalars['String'];
  groupBy?: InputMaybe<FinancialWorkspaceValueObjectsGrossSalaryGroupEnum>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeFuturePeriods?: InputMaybe<Scalars['Boolean']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  period: FinancialWorkspaceValueObjectsPeriodEnum;
  search?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type FinancialWorkspaceEmployeesIncompleteContractsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  formattedEndDate: Scalars['String'];
  formattedStartDate: Scalars['String'];
  groupBy?: InputMaybe<FinancialWorkspaceValueObjectsGrossSalaryGroupEnum>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeFuturePeriods?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  period: FinancialWorkspaceValueObjectsPeriodEnum;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type FinancialWorkspaceEmployeesIncompleteGrossSalariesArgs = {
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  formattedEndDate: Scalars['String'];
  formattedStartDate: Scalars['String'];
  groupBy?: InputMaybe<FinancialWorkspaceValueObjectsGrossSalaryGroupEnum>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeFuturePeriods?: InputMaybe<Scalars['Boolean']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  period: FinancialWorkspaceValueObjectsPeriodEnum;
  search?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type FinancialWorkspaceEmployeesIncompleteGrossSalariesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  formattedEndDate: Scalars['String'];
  formattedStartDate: Scalars['String'];
  groupBy?: InputMaybe<FinancialWorkspaceValueObjectsGrossSalaryGroupEnum>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeFuturePeriods?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  period: FinancialWorkspaceValueObjectsPeriodEnum;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type FinancialWorkspaceEmployeesIncompleteGrossSalaryArgs = {
  formattedEndDate: Scalars['String'];
  formattedStartDate: Scalars['String'];
  id: Scalars['Int'];
  period: FinancialWorkspaceValueObjectsPeriodEnum;
};


export type FinancialWorkspaceFinanceFactSummariesArgs = {
  agreementDataTypes?: InputMaybe<Array<FinancialWorkspaceValueObjectsAgreementDataTypeEnum>>;
  conceptIds?: InputMaybe<Array<Scalars['Int']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  costType?: InputMaybe<FinancialWorkspaceValueObjectsCostTypeEnum>;
  customCategoryIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  excludeChildrenData?: InputMaybe<Scalars['Boolean']>;
  financeTypes?: InputMaybe<Array<FinancialWorkspaceValueObjectsFinanceTypeEnum>>;
  formattedEndDate: Scalars['String'];
  formattedStartDate: Scalars['String'];
  groupBy: FinancialWorkspaceValueObjectsInsightTableGroupEnum;
  ids?: InputMaybe<Array<Scalars['String']>>;
  includeFuturePeriods?: InputMaybe<Scalars['Boolean']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  period?: InputMaybe<FinancialWorkspaceValueObjectsPeriodEnum>;
  policyIds?: InputMaybe<Array<Scalars['Int']>>;
  policyPeriodIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  withSalaryAmountAndSalaryFrequency?: InputMaybe<Scalars['Boolean']>;
};


export type FinancialWorkspaceFinanceFactSummariesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  agreementDataTypes?: InputMaybe<Array<FinancialWorkspaceValueObjectsAgreementDataTypeEnum>>;
  before?: InputMaybe<Scalars['String']>;
  conceptIds?: InputMaybe<Array<Scalars['Int']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  costType?: InputMaybe<FinancialWorkspaceValueObjectsCostTypeEnum>;
  customCategoryIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  excludeChildrenData?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<FinancialWorkspaceFinanceFactSummaryFilter>;
  financeTypes?: InputMaybe<Array<FinancialWorkspaceValueObjectsFinanceTypeEnum>>;
  first?: InputMaybe<Scalars['Int']>;
  formattedEndDate: Scalars['String'];
  formattedStartDate: Scalars['String'];
  groupBy: FinancialWorkspaceValueObjectsInsightTableGroupEnum;
  ids?: InputMaybe<Array<Scalars['String']>>;
  includeFuturePeriods?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  period?: InputMaybe<FinancialWorkspaceValueObjectsPeriodEnum>;
  policyIds?: InputMaybe<Array<Scalars['Int']>>;
  policyPeriodIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  withSalaryAmountAndSalaryFrequency?: InputMaybe<Scalars['Boolean']>;
};


export type FinancialWorkspaceFinanceFactSummaryArgs = {
  formattedEndDate: Scalars['String'];
  formattedStartDate: Scalars['String'];
  groupBy: FinancialWorkspaceValueObjectsInsightTableGroupEnum;
  id: Scalars['String'];
};


export type FinancialWorkspaceInsightTableItemArgs = {
  id: Scalars['Int'];
};


export type FinancialWorkspaceInsightTableItemsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  resourceFilter?: InputMaybe<InsightTableItemsResourceFilterInput>;
};


export type FinancialWorkspaceInsightTableItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<FinancialWorkspaceInsightTableItemFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  resourceFilter?: InputMaybe<InsightTableItemsResourceFilterInput>;
  sortOrder?: InputMaybe<Sort>;
};


export type FinancialWorkspaceLaborCostConceptArgs = {
  id: Scalars['Int'];
};


export type FinancialWorkspaceLaborCostConceptsArgs = {
  conceptIds?: InputMaybe<Array<Scalars['Int']>>;
  financialWorkspaceSettingsIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  laborCostCalculationTypes?: InputMaybe<Array<FinancialWorkspaceValueObjectsLaborCostCalculationTypeEnum>>;
};


export type FinancialWorkspaceLaborCostConceptsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  conceptIds?: InputMaybe<Array<Scalars['Int']>>;
  financialWorkspaceSettingsIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  laborCostCalculationTypes?: InputMaybe<Array<FinancialWorkspaceValueObjectsLaborCostCalculationTypeEnum>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type FinancialWorkspacePayrollLandingBannersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type FinancialWorkspaceSettingArgs = {
  id: Scalars['Int'];
};


export type FinancialWorkspaceSettingsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  laborCostType?: InputMaybe<FinancialWorkspaceValueObjectsLaborCostTypeEnum>;
};


export type FinancialWorkspaceSettingsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  laborCostType?: InputMaybe<FinancialWorkspaceValueObjectsLaborCostTypeEnum>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

export type FinancialWorkspaceMutations = {
  __typename?: 'financialWorkspaceMutations';
  createFinancialworkspaceSetting: CreateFinancialworkspaceSettingPayload;
  exportFinancialworkspaceExportExportFinanceFactSummary: ExportFinancialworkspaceExportExportFinanceFactSummaryPayload;
  exportFinancialworkspaceExportExportGrossSalary: ExportFinancialworkspaceExportExportGrossSalaryPayload;
  exportFinancialworkspaceExportExportPayrollLineItem: ExportFinancialworkspaceExportExportPayrollLineItemPayload;
  updateFinancialworkspaceSetting: UpdateFinancialworkspaceSettingPayload;
};


export type FinancialWorkspaceMutationsCreateFinancialworkspaceSettingArgs = {
  laborCostConcepts: Array<CreateFinancialworkspaceSettingLaborCostConceptsInput>;
};


export type FinancialWorkspaceMutationsExportFinancialworkspaceExportExportFinanceFactSummaryArgs = {
  agreementDataTypes?: InputMaybe<Array<FinancialWorkspaceValueObjectsAgreementDataTypeEnum>>;
  conceptIds?: InputMaybe<Array<Scalars['Int']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  costType?: InputMaybe<FinancialWorkspaceValueObjectsCostTypeEnum>;
  customCategoryIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  excludeChildrenData?: InputMaybe<Scalars['Boolean']>;
  financeTypes?: InputMaybe<Array<FinancialWorkspaceValueObjectsFinanceTypeEnum>>;
  formattedEndDate: Scalars['String'];
  formattedStartDate: Scalars['String'];
  groupBy: FinancialWorkspaceValueObjectsInsightTableGroupEnum;
  ids?: InputMaybe<Array<Scalars['String']>>;
  includeFuturePeriods?: InputMaybe<Scalars['Boolean']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  period?: InputMaybe<FinancialWorkspaceValueObjectsPeriodEnum>;
  policyIds?: InputMaybe<Array<Scalars['Int']>>;
  policyPeriodIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  withSalaryAmountAndSalaryFrequency?: InputMaybe<Scalars['Boolean']>;
};


export type FinancialWorkspaceMutationsExportFinancialworkspaceExportExportGrossSalaryArgs = {
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  formattedEndDate: Scalars['String'];
  formattedStartDate: Scalars['String'];
  groupBy?: InputMaybe<FinancialWorkspaceValueObjectsGrossSalaryGroupEnum>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeFuturePeriods?: InputMaybe<Scalars['Boolean']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  period: FinancialWorkspaceValueObjectsPeriodEnum;
  search?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type FinancialWorkspaceMutationsExportFinancialworkspaceExportExportPayrollLineItemArgs = {
  conceptIds?: InputMaybe<Array<Scalars['Int']>>;
  costCenterIds?: InputMaybe<Array<Scalars['Int']>>;
  firstLevelGroupBy?: InputMaybe<FinancialWorkspaceValueObjectsPayrollGroupByEnum>;
  formattedEndDate: Scalars['String'];
  formattedStartDate: Scalars['String'];
  groupBy: FinancialWorkspaceValueObjectsPayrollGroupByEnum;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type FinancialWorkspaceMutationsUpdateFinancialworkspaceSettingArgs = {
  id: Scalars['Int'];
  laborCostConcepts: Array<UpdateFinancialworkspaceSettingLaborCostConceptsInput>;
};

export type Forms = {
  __typename?: 'forms';
  answer?: Maybe<FormsAnswer>;
  /** @deprecated Please favor `answerAiInsightsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  answerAiInsights: Array<FormsAnswerAiInsight>;
  answerAiInsightsConnection: FormsAnswerAiInsightConnection;
  /** @deprecated Please favor `answersConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  answers: Array<FormsAnswer>;
  answersConnection: FormsAnswerConnection;
  cycle?: Maybe<FormsCycle>;
  /** @deprecated Please favor `cyclesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  cycles: Array<FormsCycle>;
  cyclesConnection: FormsCycleConnection;
  element?: Maybe<FormsElement>;
  /** @deprecated Please favor `elementAnalyticsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  elementAnalytics: Array<FormsElementAnalytic>;
  elementAnalyticsConnection: FormsElementAnalyticConnection;
  /** @deprecated Please favor `elementsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  elements: Array<FormsElement>;
  elementsConnection: FormsElementConnection;
  form?: Maybe<FormsForm>;
  /** @deprecated Please favor `formsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  forms: Array<FormsForm>;
  formsConnection: FormsFormConnection;
  materializedForm?: Maybe<FormsMaterializedForm>;
  /** @deprecated Please favor `materializedFormsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  materializedForms: Array<FormsMaterializedForm>;
  materializedFormsConnection: FormsMaterializedFormConnection;
  membership?: Maybe<FormsMembership>;
  /** @deprecated Please favor `membershipsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  memberships: Array<FormsMembership>;
  membershipsConnection: FormsMembershipConnection;
  myMembership?: Maybe<FormsMyMembership>;
  /** @deprecated Please favor `myMembershipsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  myMemberships: Array<FormsMyMembership>;
  myMembershipsConnection: FormsMyMembershipConnection;
  question?: Maybe<FormsQuestion>;
  /** @deprecated Please favor `questionsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  questions: Array<FormsQuestion>;
  questionsConnection: FormsQuestionConnection;
  schedule?: Maybe<FormsSchedule>;
  /** @deprecated Please favor `schedulesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  schedules: Array<FormsSchedule>;
  schedulesConnection: FormsScheduleConnection;
  /** @deprecated Please favor `scoresConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  scores: Array<FormsScore>;
  scoresConnection: FormsScoreConnection;
  testScore?: Maybe<FormsTestScore>;
  /** @deprecated Please favor `testScoresConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  testScores: Array<FormsTestScore>;
  testScoresConnection: FormsTestScoreConnection;
};


export type FormsAnswerArgs = {
  id: Scalars['String'];
};


export type FormsAnswerAiInsightsArgs = {
  cycleIds?: InputMaybe<Array<Scalars['Int']>>;
  elementId: Scalars['String'];
  jobRoles?: InputMaybe<Array<Scalars['Int']>>;
  jobTitles?: InputMaybe<Array<Scalars['String']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type FormsAnswerAiInsightsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  cycleIds?: InputMaybe<Array<Scalars['Int']>>;
  elementId: Scalars['String'];
  first?: InputMaybe<Scalars['Int']>;
  jobRoles?: InputMaybe<Array<Scalars['Int']>>;
  jobTitles?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type FormsAnswersArgs = {
  formId?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  materializedQuestionId?: InputMaybe<Scalars['String']>;
  materializedQuestionOptionIds?: InputMaybe<Array<Scalars['String']>>;
  membershipId?: InputMaybe<Scalars['String']>;
};


export type FormsAnswersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  formId?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  materializedQuestionId?: InputMaybe<Scalars['String']>;
  materializedQuestionOptionIds?: InputMaybe<Array<Scalars['String']>>;
  membershipId?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type FormsCycleArgs = {
  id: Scalars['String'];
};


export type FormsCyclesArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
  scheduleIds?: InputMaybe<Array<Scalars['String']>>;
};


export type FormsCyclesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  scheduleIds?: InputMaybe<Array<Scalars['String']>>;
  sortOrder?: InputMaybe<Sort>;
};


export type FormsElementArgs = {
  id: Scalars['String'];
};


export type FormsElementAnalyticsArgs = {
  cycleIds?: InputMaybe<Array<Scalars['Int']>>;
  elementId: Scalars['String'];
  jobRoles?: InputMaybe<Array<Scalars['Int']>>;
  jobTitles?: InputMaybe<Array<Scalars['String']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  materializedFormId?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type FormsElementAnalyticsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  cycleIds?: InputMaybe<Array<Scalars['Int']>>;
  elementId: Scalars['String'];
  first?: InputMaybe<Scalars['Int']>;
  jobRoles?: InputMaybe<Array<Scalars['Int']>>;
  jobTitles?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  materializedFormId?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type FormsElementsArgs = {
  formId?: InputMaybe<Scalars['String']>;
  formIds?: InputMaybe<Array<Scalars['String']>>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  locale?: InputMaybe<Scalars['String']>;
};


export type FormsElementsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  formId?: InputMaybe<Scalars['String']>;
  formIds?: InputMaybe<Array<Scalars['String']>>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type FormsFormArgs = {
  id: Scalars['String'];
  resourceType: Scalars['String'];
};


export type FormsFormsArgs = {
  formType?: InputMaybe<Array<Scalars['String']>>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyTemplates?: InputMaybe<Scalars['Boolean']>;
  resourceId?: InputMaybe<Scalars['String']>;
  resourceType: Scalars['String'];
  respondentId?: InputMaybe<Scalars['String']>;
  returnAnswerProgress?: Scalars['Boolean'];
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};


export type FormsFormsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<FormsFormFilter>;
  first?: InputMaybe<Scalars['Int']>;
  formType?: InputMaybe<Array<Scalars['String']>>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyTemplates?: InputMaybe<Scalars['Boolean']>;
  resourceId?: InputMaybe<Scalars['String']>;
  resourceType: Scalars['String'];
  respondentId?: InputMaybe<Scalars['String']>;
  returnAnswerProgress?: Scalars['Boolean'];
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  status?: InputMaybe<Scalars['String']>;
};


export type FormsMaterializedFormArgs = {
  id: Scalars['String'];
};


export type FormsMaterializedFormsArgs = {
  cycleIds?: InputMaybe<Array<Scalars['String']>>;
  formId?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  resourceIds?: InputMaybe<Array<Scalars['String']>>;
  resourceType?: InputMaybe<Scalars['String']>;
  respondentId?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type FormsMaterializedFormsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  cycleIds?: InputMaybe<Array<Scalars['String']>>;
  first?: InputMaybe<Scalars['Int']>;
  formId?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  resourceIds?: InputMaybe<Array<Scalars['String']>>;
  resourceType?: InputMaybe<Scalars['String']>;
  respondentId?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type FormsMembershipArgs = {
  id: Scalars['String'];
};


export type FormsMembershipsArgs = {
  cycleIds?: InputMaybe<Array<Scalars['String']>>;
  formId?: InputMaybe<Scalars['String']>;
  formType?: InputMaybe<Array<Scalars['String']>>;
  hasAnswers?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  jobRoles?: InputMaybe<Array<Scalars['Int']>>;
  jobTitles?: InputMaybe<Array<Scalars['String']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  materializedFormIds?: InputMaybe<Array<Scalars['String']>>;
  resourceType?: InputMaybe<Scalars['String']>;
  respondentId?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  searchByFormTitle?: InputMaybe<Scalars['String']>;
  targetId?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  trainingId?: InputMaybe<Scalars['String']>;
};


export type FormsMembershipsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  cycleIds?: InputMaybe<Array<Scalars['String']>>;
  filter?: InputMaybe<FormsMembershipFilter>;
  first?: InputMaybe<Scalars['Int']>;
  formId?: InputMaybe<Scalars['String']>;
  formType?: InputMaybe<Array<Scalars['String']>>;
  hasAnswers?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  jobRoles?: InputMaybe<Array<Scalars['Int']>>;
  jobTitles?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  materializedFormIds?: InputMaybe<Array<Scalars['String']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  resourceType?: InputMaybe<Scalars['String']>;
  respondentId?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  searchByFormTitle?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  targetId?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  trainingId?: InputMaybe<Scalars['String']>;
};


export type FormsMyMembershipArgs = {
  id: Scalars['String'];
};


export type FormsMyMembershipsArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};


export type FormsMyMembershipsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type FormsQuestionArgs = {
  formId: Scalars['String'];
  id: Scalars['String'];
};


export type FormsQuestionsArgs = {
  formId: Scalars['String'];
  ids?: InputMaybe<Array<Scalars['String']>>;
};


export type FormsQuestionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  formId: Scalars['String'];
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type FormsScheduleArgs = {
  id: Scalars['String'];
};


export type FormsSchedulesArgs = {
  formId?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
};


export type FormsSchedulesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  formId?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type FormsScoresArgs = {
  resourceId: Scalars['String'];
  resourceType: Scalars['String'];
  scoreTypes: Array<Scalars['String']>;
};


export type FormsScoresConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  resourceId: Scalars['String'];
  resourceType: Scalars['String'];
  scoreTypes: Array<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type FormsTestScoreArgs = {
  id: Scalars['String'];
};


export type FormsTestScoresArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
  materializedFormId?: InputMaybe<Scalars['String']>;
  membershipId?: InputMaybe<Scalars['String']>;
  resourceId?: InputMaybe<Scalars['String']>;
  resourceType?: InputMaybe<Scalars['String']>;
};


export type FormsTestScoresConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  materializedFormId?: InputMaybe<Scalars['String']>;
  membershipId?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  resourceId?: InputMaybe<Scalars['String']>;
  resourceType?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};

export type FormsMutations = {
  __typename?: 'formsMutations';
  archiveFormsForm: ArchiveFormsFormPayload;
  bulkCreateFormsAnswer: BulkCreateFormsAnswerPayload;
  bulkCreateFormsMaterializedForm: BulkCreateFormsMaterializedFormPayload;
  bulkCreateFormsMembership: BulkCreateFormsMembershipPayload;
  bulkDeleteMembershipAnswersFormsAnswer: BulkDeleteMembershipAnswersFormsAnswerPayload;
  createFormsAnswer: CreateFormsAnswerPayload;
  createFormsCycle: CreateFormsCyclePayload;
  createFormsElement: CreateFormsElementPayload;
  createFormsForm: CreateFormsFormPayload;
  createFormsQuestion: CreateFormsQuestionPayload;
  createFormsSchedule: CreateFormsSchedulePayload;
  deleteFormsElement: DeleteFormsElementPayload;
  deleteFormsForm: DeleteFormsFormPayload;
  draftTemplateFormsForm: DraftTemplateFormsFormPayload;
  duplicateFormsForm: DuplicateFormsFormPayload;
  finishFormsForm: FinishFormsFormPayload;
  forceDeleteFormsForm: ForceDeleteFormsFormPayload;
  publishFormsForm: PublishFormsFormPayload;
  publishTemplateFormsForm: PublishTemplateFormsFormPayload;
  scheduleFormsForm: ScheduleFormsFormPayload;
  sendFormFormsForm: SendFormFormsFormPayload;
  updateFormsCycle: UpdateFormsCyclePayload;
  updateFormsElement: UpdateFormsElementPayload;
  updateFormsForm: UpdateFormsFormPayload;
  updateFormsQuestion: UpdateFormsQuestionPayload;
  updateFormsSchedule: UpdateFormsSchedulePayload;
};


export type FormsMutationsArchiveFormsFormArgs = {
  id: Scalars['String'];
};


export type FormsMutationsBulkCreateFormsAnswerArgs = {
  answers: Array<FormsAnswerInput>;
  companyId: Scalars['String'];
  ids?: InputMaybe<Array<Scalars['String']>>;
  membershipId: Scalars['String'];
};


export type FormsMutationsBulkCreateFormsMaterializedFormArgs = {
  companyId: Scalars['String'];
  configuration?: InputMaybe<FormsMaterializedFormConfigurationInput>;
  endsAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  formId: Scalars['String'];
  notify?: InputMaybe<Scalars['Boolean']>;
  resourceType: Scalars['String'];
  resources: Array<FormsResourceInput>;
  startsAt?: InputMaybe<Scalars['ISO8601DateTime']>;
};


export type FormsMutationsBulkCreateFormsMembershipArgs = {
  companyId: Scalars['String'];
  materializedFormIds: Array<Scalars['String']>;
  notify?: InputMaybe<Scalars['Boolean']>;
  targets: Array<FormsTargetInput>;
};


export type FormsMutationsBulkDeleteMembershipAnswersFormsAnswerArgs = {
  membershipId: Scalars['String'];
};


export type FormsMutationsCreateFormsAnswerArgs = {
  answer?: InputMaybe<Scalars['String']>;
  companyId: Scalars['String'];
  elementId?: InputMaybe<Scalars['String']>;
  elementOptionIds?: InputMaybe<Array<Scalars['String']>>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  materializedQuestionId?: InputMaybe<Scalars['String']>;
  materializedQuestionOptionIds?: InputMaybe<Array<Scalars['String']>>;
  membershipId: Scalars['String'];
};


export type FormsMutationsCreateFormsCycleArgs = {
  companyId: Scalars['String'];
  endsAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  scheduleId: Scalars['String'];
  startsAt: Scalars['ISO8601DateTime'];
};


export type FormsMutationsCreateFormsElementArgs = {
  description?: InputMaybe<Scalars['String']>;
  formId: Scalars['String'];
  hasCorrectAnswer?: InputMaybe<Scalars['Boolean']>;
  label: Scalars['String'];
  mandatory?: InputMaybe<Scalars['Boolean']>;
  options?: InputMaybe<Array<FormsElementOptionInput>>;
  params?: InputMaybe<FormsElementParamsInput>;
  position: Scalars['Int'];
  resourceId?: InputMaybe<Scalars['String']>;
  resourceType: Scalars['String'];
  sectionId?: InputMaybe<Scalars['String']>;
  type: FormsElementTypeEnum;
};


export type FormsMutationsCreateFormsFormArgs = {
  anonymous: Scalars['Boolean'];
  authorId?: InputMaybe<Scalars['Int']>;
  companyId: Scalars['Int'];
  configuration?: InputMaybe<FormsFormConfigurationInput>;
  description?: InputMaybe<Scalars['String']>;
  elements?: InputMaybe<Array<FormsElementInput>>;
  endsAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  formType?: InputMaybe<FormsTypeEnum>;
  questionnaire?: InputMaybe<Array<FormsQuestionnaireElementInput>>;
  resourceId?: InputMaybe<Scalars['String']>;
  resourceType: Scalars['String'];
  schedule?: InputMaybe<FormsScheduleInput>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};


export type FormsMutationsCreateFormsQuestionArgs = {
  companyId: Scalars['String'];
  formId: Scalars['String'];
  questionnaire: Array<FormsQuestionnaireElementInput>;
  resourceId: Scalars['String'];
  resourceType: Scalars['String'];
};


export type FormsMutationsCreateFormsScheduleArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  companyId: Scalars['String'];
  daysToAnswer?: InputMaybe<Scalars['Int']>;
  formId: Scalars['String'];
  recurrenceType: FormsScheduleRecurrenceTypeEnum;
  startDate?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['String']>;
};


export type FormsMutationsDeleteFormsElementArgs = {
  id: Scalars['String'];
  resourceId?: InputMaybe<Scalars['String']>;
  resourceType: Scalars['String'];
};


export type FormsMutationsDeleteFormsFormArgs = {
  id: Scalars['String'];
};


export type FormsMutationsDraftTemplateFormsFormArgs = {
  id: Scalars['String'];
  resourceType: Scalars['String'];
};


export type FormsMutationsDuplicateFormsFormArgs = {
  duplicateDescription?: InputMaybe<Scalars['String']>;
  duplicateName?: InputMaybe<Scalars['String']>;
  formId?: InputMaybe<Scalars['String']>;
  isTemplate?: InputMaybe<Scalars['Boolean']>;
  newResourceId?: InputMaybe<Scalars['String']>;
  resourceId?: InputMaybe<Scalars['String']>;
  resourceType: Scalars['String'];
};


export type FormsMutationsFinishFormsFormArgs = {
  id: Scalars['String'];
};


export type FormsMutationsForceDeleteFormsFormArgs = {
  ids: Array<Scalars['String']>;
};


export type FormsMutationsPublishFormsFormArgs = {
  id: Scalars['String'];
  resourceIds: Array<Scalars['String']>;
  resourceType: Scalars['String'];
};


export type FormsMutationsPublishTemplateFormsFormArgs = {
  id: Scalars['String'];
  resourceType: Scalars['String'];
};


export type FormsMutationsScheduleFormsFormArgs = {
  id: Scalars['String'];
  recurrenceType?: InputMaybe<FormsEnumsRecurrenceTypeEnum>;
  resourceIds: Array<Scalars['String']>;
  resourceType: Scalars['String'];
  startsAt: Scalars['ISO8601DateTime'];
};


export type FormsMutationsSendFormFormsFormArgs = {
  configuration?: InputMaybe<FormsMaterializedFormConfigurationInput>;
  id: Scalars['String'];
  notify?: InputMaybe<Scalars['Boolean']>;
  recurrenceType?: InputMaybe<FormsEnumsRecurrenceTypeEnum>;
  resourceIds: Array<Scalars['String']>;
  respondentId?: InputMaybe<Scalars['String']>;
};


export type FormsMutationsUpdateFormsCycleArgs = {
  endsAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  id: Scalars['String'];
  startsAt?: InputMaybe<Scalars['ISO8601DateTime']>;
};


export type FormsMutationsUpdateFormsElementArgs = {
  description?: InputMaybe<Scalars['String']>;
  hasCorrectAnswer?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
  label?: InputMaybe<Scalars['String']>;
  mandatory?: InputMaybe<Scalars['Boolean']>;
  options?: InputMaybe<Array<FormsElementOptionInput>>;
  params?: InputMaybe<FormsElementParamsInput>;
  position?: InputMaybe<Scalars['Int']>;
  resourceId?: InputMaybe<Scalars['String']>;
  resourceType: Scalars['String'];
  sectionId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<FormsElementTypeEnum>;
};


export type FormsMutationsUpdateFormsFormArgs = {
  anonymous?: InputMaybe<Scalars['Boolean']>;
  configuration?: InputMaybe<FormsFormConfigurationInput>;
  description?: InputMaybe<Scalars['String']>;
  elements?: InputMaybe<Array<FormsElementInput>>;
  endsAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  id: Scalars['String'];
  nextRunDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  recurrenceType?: InputMaybe<FormsEnumsRecurrenceTypeEnum>;
  schedule?: InputMaybe<FormsScheduleInput>;
  title?: InputMaybe<Scalars['String']>;
};


export type FormsMutationsUpdateFormsQuestionArgs = {
  id: Scalars['String'];
  questionnaire: Array<FormsQuestionnaireElementInput>;
  resourceId: Scalars['String'];
  resourceType: Scalars['String'];
};


export type FormsMutationsUpdateFormsScheduleArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  daysToAnswer?: InputMaybe<Scalars['Int']>;
  id: Scalars['String'];
  recurrenceType?: InputMaybe<FormsScheduleRecurrenceTypeEnum>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  startTime?: InputMaybe<Scalars['String']>;
};

export type Goals = {
  __typename?: 'goals';
  _policies: GoalsContextlessPolicies;
  employee?: Maybe<GoalsEmployee>;
  employeeCycleProgress?: Maybe<GoalsEmployeeCycleProgress>;
  /** @deprecated Please favor `employeeCycleProgressesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  employeeCycleProgresses: Array<GoalsEmployeeCycleProgress>;
  employeeCycleProgressesConnection: GoalsEmployeeCycleProgressConnection;
  /** @deprecated Please favor `employeesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  employees: Array<GoalsEmployee>;
  employeesConnection: GoalsEmployeeConnection;
  metric?: Maybe<GoalsMetric>;
  metricGroup?: Maybe<GoalsMetricGroup>;
  metricGroupWeight?: Maybe<GoalsMetricGroupWeight>;
  /** @deprecated Please favor `metricGroupWeightsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  metricGroupWeights: Array<GoalsMetricGroupWeight>;
  metricGroupWeightsConnection: GoalsMetricGroupWeightConnection;
  /** @deprecated Please favor `metricGroupsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  metricGroups: Array<GoalsMetricGroup>;
  metricGroupsConnection: GoalsMetricGroupConnection;
  metricValue?: Maybe<GoalsMetricValue>;
  /** @deprecated Please favor `metricValuesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  metricValues: Array<GoalsMetricValue>;
  metricValuesConnection: GoalsMetricValueConnection;
  /** @deprecated Please favor `metricsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  metrics: Array<GoalsMetric>;
  metricsConnection: GoalsMetricConnection;
};


export type GoalsEmployeeArgs = {
  id: Scalars['Int'];
};


export type GoalsEmployeeCycleProgressArgs = {
  id: Scalars['String'];
};


export type GoalsEmployeeCycleProgressesArgs = {
  cycleIds?: InputMaybe<Array<Scalars['String']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['String']>>;
};


export type GoalsEmployeeCycleProgressesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  cycleIds?: InputMaybe<Array<Scalars['String']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type GoalsEmployeesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  noCycle?: InputMaybe<Scalars['Boolean']>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyAssignable?: InputMaybe<Scalars['Boolean']>;
  onlyDirectReports?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};


export type GoalsEmployeesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<GoalsEmployeeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  noCycle?: InputMaybe<Scalars['Boolean']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyAssignable?: InputMaybe<Scalars['Boolean']>;
  onlyDirectReports?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type GoalsMetricArgs = {
  id: Scalars['String'];
};


export type GoalsMetricGroupArgs = {
  id: Scalars['String'];
};


export type GoalsMetricGroupWeightArgs = {
  id: Scalars['String'];
};


export type GoalsMetricGroupWeightsArgs = {
  cycleIds?: InputMaybe<Array<Scalars['String']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  metricGroupIds?: InputMaybe<Array<Scalars['String']>>;
  progressIds?: InputMaybe<Array<Scalars['String']>>;
};


export type GoalsMetricGroupWeightsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  cycleIds?: InputMaybe<Array<Scalars['String']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  metricGroupIds?: InputMaybe<Array<Scalars['String']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  progressIds?: InputMaybe<Array<Scalars['String']>>;
  sortOrder?: InputMaybe<Sort>;
};


export type GoalsMetricGroupsArgs = {
  assigneeIds?: InputMaybe<Array<Scalars['Int']>>;
  cycleIds?: InputMaybe<Array<Scalars['String']>>;
  forMetricsAssignment?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  noCycle?: InputMaybe<Scalars['Boolean']>;
  public?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};


export type GoalsMetricGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  assigneeIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  cycleIds?: InputMaybe<Array<Scalars['String']>>;
  filter?: InputMaybe<GoalsMetricGroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  forMetricsAssignment?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  noCycle?: InputMaybe<Scalars['Boolean']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  public?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type GoalsMetricValueArgs = {
  id: Scalars['String'];
};


export type GoalsMetricValuesArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
  metricIds?: InputMaybe<Array<Scalars['String']>>;
};


export type GoalsMetricValuesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  metricIds?: InputMaybe<Array<Scalars['String']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type GoalsMetricsArgs = {
  assigneeIds?: InputMaybe<Array<Scalars['Int']>>;
  groupIds?: InputMaybe<Array<Scalars['String']>>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  performanceAgreementIds?: InputMaybe<Array<Scalars['String']>>;
};


export type GoalsMetricsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  assigneeIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<GoalsMetricFilter>;
  first?: InputMaybe<Scalars['Int']>;
  groupIds?: InputMaybe<Array<Scalars['String']>>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  performanceAgreementIds?: InputMaybe<Array<Scalars['String']>>;
  sortOrder?: InputMaybe<Sort>;
};

export type GoalsMutations = {
  __typename?: 'goalsMutations';
  bulkCreateGoalsMetric: BulkCreateGoalsMetricPayload;
  createGoalsMetric: CreateGoalsMetricPayload;
  createGoalsMetricGroup: CreateGoalsMetricGroupPayload;
  deleteGoalsMetric: DeleteGoalsMetricPayload;
  deleteGoalsMetricGroup: DeleteGoalsMetricGroupPayload;
  updateGoalsMetric: UpdateGoalsMetricPayload;
  updateGoalsMetricGroup: UpdateGoalsMetricGroupPayload;
  updateQualitativeCurrentStatusGoalsMetric: UpdateQualitativeCurrentStatusGoalsMetricPayload;
  updateQuantitativeCurrentValueGoalsMetric: UpdateQuantitativeCurrentValueGoalsMetricPayload;
  upsertWeightsGoalsEmployeeCycleProgress: UpsertWeightsGoalsEmployeeCycleProgressPayload;
};


export type GoalsMutationsBulkCreateGoalsMetricArgs = {
  assigneeIds: Array<Scalars['Int']>;
  endOn: Scalars['ISO8601Date'];
  metricGroupId: Scalars['String'];
  quantitativeValue?: InputMaybe<GoalsQuantitativeValueInput>;
  startOn: Scalars['ISO8601Date'];
  title: Scalars['String'];
};


export type GoalsMutationsCreateGoalsMetricArgs = {
  assigneeId: Scalars['Int'];
  endOn: Scalars['ISO8601Date'];
  metricGroupId: Scalars['String'];
  performanceAgreementDetails?: InputMaybe<GoalsAgreementDetailsInput>;
  quantitativeValue?: InputMaybe<GoalsQuantitativeValueInput>;
  startOn: Scalars['ISO8601Date'];
  title: Scalars['String'];
};


export type GoalsMutationsCreateGoalsMetricGroupArgs = {
  cycleIds?: InputMaybe<Array<Scalars['String']>>;
  description?: InputMaybe<Scalars['String']>;
  public?: InputMaybe<Scalars['Boolean']>;
  title: Scalars['String'];
};


export type GoalsMutationsDeleteGoalsMetricArgs = {
  id: Scalars['String'];
};


export type GoalsMutationsDeleteGoalsMetricGroupArgs = {
  id: Scalars['String'];
};


export type GoalsMutationsUpdateGoalsMetricArgs = {
  endOn?: InputMaybe<Scalars['ISO8601Date']>;
  id: Scalars['String'];
  metricGroupId?: InputMaybe<Scalars['String']>;
  startOn?: InputMaybe<Scalars['ISO8601Date']>;
  startValue?: InputMaybe<Scalars['Float']>;
  targetValue?: InputMaybe<Scalars['Float']>;
  title?: InputMaybe<Scalars['String']>;
};


export type GoalsMutationsUpdateGoalsMetricGroupArgs = {
  cycleIds?: InputMaybe<Array<Scalars['String']>>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  public?: InputMaybe<Scalars['Boolean']>;
  title: Scalars['String'];
};


export type GoalsMutationsUpdateQualitativeCurrentStatusGoalsMetricArgs = {
  id: Scalars['String'];
  status: GoalsMetricValueStatusEnum;
};


export type GoalsMutationsUpdateQuantitativeCurrentValueGoalsMetricArgs = {
  currentValue: Scalars['Float'];
  id: Scalars['String'];
};


export type GoalsMutationsUpsertWeightsGoalsEmployeeCycleProgressArgs = {
  id: Scalars['String'];
  weights: Array<UpsertWeightsGoalsEmployeeCycleProgressWeightsInput>;
};

export type HandbookPages = {
  __typename?: 'handbookPages';
  _policies: HandbookPagesContextlessPolicies;
  /** @deprecated Please favor `foldersConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  folders: Array<HandbookPagesFolder>;
  foldersConnection: HandbookPagesFolderConnection;
  page?: Maybe<HandbookPagesPage>;
  /** @deprecated Please favor `pageVersionsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  pageVersions: Array<HandbookPagesPageVersion>;
  pageVersionsConnection: HandbookPagesPageVersionConnection;
  /** @deprecated Please favor `pagesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  pages: Array<HandbookPagesPage>;
  pagesConnection: HandbookPagesPageConnection;
};


export type HandbookPagesFoldersArgs = {
  onlyFoldersWithItems?: Scalars['Boolean'];
  search?: InputMaybe<Scalars['String']>;
};


export type HandbookPagesFoldersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<HandbookPagesFolderFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyFoldersWithItems?: Scalars['Boolean'];
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type HandbookPagesPageArgs = {
  id: Scalars['Int'];
};


export type HandbookPagesPageVersionsArgs = {
  pageId: Scalars['Int'];
};


export type HandbookPagesPageVersionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<HandbookPagesPageVersionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  pageId: Scalars['Int'];
  sortOrder?: InputMaybe<Sort>;
};


export type HandbookPagesPagesArgs = {
  folderType?: InputMaybe<Scalars['String']>;
  ids?: Array<Scalars['Int']>;
  ownerId?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  visibility?: InputMaybe<Scalars['String']>;
};


export type HandbookPagesPagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<HandbookPagesPageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  folderType?: InputMaybe<Scalars['String']>;
  ids?: Array<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  ownerId?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  visibility?: InputMaybe<Scalars['String']>;
};

export type HandbookPagesMutations = {
  __typename?: 'handbookPagesMutations';
  bulkDeleteHandbookpagesPage: BulkDeleteHandbookpagesPagePayload;
  bulkPublishHandbookpagesPage: BulkPublishHandbookpagesPagePayload;
  createHandbookpagesPage: CreateHandbookpagesPagePayload;
  deleteHandbookpagesPage: DeleteHandbookpagesPagePayload;
  importPdfHandbookpagesImport: ImportPdfHandbookpagesImportPayload;
  publishHandbookpagesPage: PublishHandbookpagesPagePayload;
  restoreHandbookpagesPageVersion: RestoreHandbookpagesPageVersionPayload;
  updateHandbookpagesPage: UpdateHandbookpagesPagePayload;
};


export type HandbookPagesMutationsBulkDeleteHandbookpagesPageArgs = {
  ids: Array<Scalars['Int']>;
};


export type HandbookPagesMutationsBulkPublishHandbookpagesPageArgs = {
  ids: Array<Scalars['Int']>;
};


export type HandbookPagesMutationsCreateHandbookpagesPageArgs = {
  content?: InputMaybe<Scalars['String']>;
  folderType?: InputMaybe<Scalars['String']>;
  ownerId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  visibility?: InputMaybe<Scalars['String']>;
};


export type HandbookPagesMutationsDeleteHandbookpagesPageArgs = {
  id: Scalars['Int'];
};


export type HandbookPagesMutationsImportPdfHandbookpagesImportArgs = {
  filePath: Scalars['String'];
  folderType: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
  visibility: Scalars['String'];
};


export type HandbookPagesMutationsPublishHandbookpagesPageArgs = {
  id: Scalars['Int'];
};


export type HandbookPagesMutationsRestoreHandbookpagesPageVersionArgs = {
  pageId: Scalars['Int'];
  versionNumber: Scalars['Int'];
};


export type HandbookPagesMutationsUpdateHandbookpagesPageArgs = {
  content?: InputMaybe<Scalars['String']>;
  folderType?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  visibility?: InputMaybe<Scalars['String']>;
};

export type HiringVersions = {
  __typename?: 'hiringVersions';
  /** @deprecated Please favor `taxResidencesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  taxResidences: Array<HiringVersionsTaxResidence>;
  taxResidencesConnection: HiringVersionsTaxResidenceConnection;
};


export type HiringVersionsTaxResidencesArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type HiringVersionsTaxResidencesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

export type HiringVersionsMutations = {
  __typename?: 'hiringVersionsMutations';
  upsertHiringversionsTaxResidence: UpsertHiringversionsTaxResidencePayload;
};


export type HiringVersionsMutationsUpsertHiringversionsTaxResidenceArgs = {
  addressLineOne?: InputMaybe<Scalars['String']>;
  addressLineTwo?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  cityOfBirth?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  countryOfBirth?: InputMaybe<Scalars['String']>;
  employeeId: Scalars['Int'];
  identifier?: InputMaybe<Scalars['String']>;
  isResident?: InputMaybe<Scalars['Boolean']>;
  noResidentEndDate?: InputMaybe<Scalars['ISO8601Date']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

export type Holidays = {
  __typename?: 'holidays';
  companyHoliday?: Maybe<HolidaysCompanyHoliday>;
  /** @deprecated Please favor `companyHolidaysConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  companyHolidays: Array<HolidaysCompanyHoliday>;
  companyHolidaysConnection: HolidaysCompanyHolidayConnection;
};


export type HolidaysCompanyHolidayArgs = {
  id: Scalars['Int'];
};


export type HolidaysCompanyHolidaysArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endAt?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  startAt?: InputMaybe<Scalars['ISO8601Date']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type HolidaysCompanyHolidaysConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endAt?: InputMaybe<Scalars['ISO8601Date']>;
  filter?: InputMaybe<HolidaysCompanyHolidayFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startAt?: InputMaybe<Scalars['ISO8601Date']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type HolidaysMutations = {
  __typename?: 'holidaysMutations';
  createHolidaysCompanyHoliday: CreateHolidaysCompanyHolidayPayload;
  destroyHolidaysCompanyHoliday: DestroyHolidaysCompanyHolidayPayload;
  updateHolidaysCompanyHoliday: UpdateHolidaysCompanyHolidayPayload;
};


export type HolidaysMutationsCreateHolidaysCompanyHolidayArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  date: Scalars['ISO8601Date'];
  description?: InputMaybe<Scalars['String']>;
  halfDay?: InputMaybe<HolidaysCompanyHolidayHalfDayTypesEnum>;
  locationId?: InputMaybe<Scalars['Int']>;
  summary?: InputMaybe<Scalars['String']>;
};


export type HolidaysMutationsDestroyHolidaysCompanyHolidayArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
};


export type HolidaysMutationsUpdateHolidaysCompanyHolidayArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  date: Scalars['ISO8601Date'];
  description?: InputMaybe<Scalars['String']>;
  halfDay?: InputMaybe<HolidaysCompanyHolidayHalfDayTypesEnum>;
  id: Scalars['Int'];
  summary?: InputMaybe<Scalars['String']>;
};

export type Importers = {
  __typename?: 'importers';
  /** @deprecated Please favor `importerActivitiesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  importerActivities: Array<ImportersImporterActivity>;
  importerActivitiesConnection: ImportersImporterActivityConnection;
  importerActivity?: Maybe<ImportersImporterActivity>;
  importerProcess?: Maybe<ImportersImporterProcess>;
  /** @deprecated Please favor `importerProcessFileContentsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  importerProcessFileContents: Array<ImportersImporterProcessFileContent>;
  importerProcessFileContentsConnection: ImportersImporterProcessFileContentConnection;
  /** @deprecated Please favor `importerProcessesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  importerProcesses: Array<ImportersImporterProcess>;
  importerProcessesConnection: ImportersImporterProcessConnection;
};


export type ImportersImporterActivitiesArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  fileHash?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  importerProcessUuids?: InputMaybe<Array<Scalars['String']>>;
  importerUuid?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  templateId?: InputMaybe<Scalars['String']>;
  templateVersion?: InputMaybe<Scalars['String']>;
};


export type ImportersImporterActivitiesConnectionArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  fileHash?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  importerProcessUuids?: InputMaybe<Array<Scalars['String']>>;
  importerUuid?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  state?: InputMaybe<Scalars['String']>;
  templateId?: InputMaybe<Scalars['String']>;
  templateVersion?: InputMaybe<Scalars['String']>;
};


export type ImportersImporterActivityArgs = {
  id: Scalars['Int'];
};


export type ImportersImporterProcessArgs = {
  id: Scalars['Int'];
};


export type ImportersImporterProcessFileContentsArgs = {
  importerProcessUuid: Scalars['String'];
  maxRows?: InputMaybe<Scalars['Int']>;
};


export type ImportersImporterProcessFileContentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  importerProcessUuid: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  maxRows?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ImportersImporterProcessesArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  importerUuid?: InputMaybe<Scalars['String']>;
  legalEntityId?: InputMaybe<Scalars['String']>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  uuid?: InputMaybe<Scalars['String']>;
};


export type ImportersImporterProcessesConnectionArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  importerUuid?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityId?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  updatedAtGteq?: InputMaybe<Scalars['ISO8601Date']>;
  uuid?: InputMaybe<Scalars['String']>;
};

export type ImportersMutations = {
  __typename?: 'importersMutations';
  createImportersImporterActivity: CreateImportersImporterActivityPayload;
  createImportersImporterProcess: CreateImportersImporterProcessPayload;
  updateImportersImporterProcess: UpdateImportersImporterProcessPayload;
};


export type ImportersMutationsCreateImportersImporterActivityArgs = {
  companyId: Scalars['Int'];
  importerProcessUuid?: InputMaybe<Scalars['String']>;
  importerUuid: Scalars['String'];
  state: Scalars['String'];
  templateId?: InputMaybe<Scalars['String']>;
};


export type ImportersMutationsCreateImportersImporterProcessArgs = {
  file: Scalars['File'];
  importerProcessUuid?: InputMaybe<Scalars['String']>;
  importerUuid?: InputMaybe<Scalars['String']>;
  legalEntityId?: InputMaybe<Scalars['String']>;
};


export type ImportersMutationsUpdateImportersImporterProcessArgs = {
  importerProcessUuid: Scalars['String'];
  itemsCreated?: InputMaybe<Scalars['Int']>;
  itemsToBeCreated?: InputMaybe<Scalars['Int']>;
  totalItems?: InputMaybe<Scalars['Int']>;
};

export type InAppComms = {
  __typename?: 'inAppComms';
  _policies: InAppCommsContextlessPolicies;
  communication?: Maybe<InAppCommsCommunication>;
  /** @deprecated Please favor `communicationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  communications: Array<InAppCommsCommunication>;
  communicationsConnection: InAppCommsCommunicationConnection;
};


export type InAppCommsCommunicationArgs = {
  id: Scalars['String'];
  locale: Scalars['String'];
  preview: Scalars['Boolean'];
};


export type InAppCommsCommunicationsArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
  locale: Scalars['String'];
  preview: Scalars['Boolean'];
};


export type InAppCommsCommunicationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  locale: Scalars['String'];
  offsetPage?: InputMaybe<Scalars['Int']>;
  preview: Scalars['Boolean'];
  sortOrder?: InputMaybe<Sort>;
};

export type Integrations = {
  __typename?: 'integrations';
  /** @deprecated Please favor `availableIntegrationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  availableIntegrations: Array<IntegrationsAvailableIntegration>;
  availableIntegrationsConnection: IntegrationsAvailableIntegrationConnection;
  syncRun?: Maybe<IntegrationsSyncRun>;
  syncRunOutput?: Maybe<IntegrationsSyncRunOutput>;
  /** @deprecated Please favor `syncRunOutputsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  syncRunOutputs: Array<IntegrationsSyncRunOutput>;
  syncRunOutputsConnection: IntegrationsSyncRunOutputConnection;
  /** @deprecated Please favor `syncRunsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  syncRuns: Array<IntegrationsSyncRun>;
  syncRunsConnection: IntegrationsSyncRunConnection;
  /** @deprecated Please favor `syncValidationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  syncValidations: Array<IntegrationsSyncValidation>;
  syncValidationsConnection: IntegrationsSyncValidationConnection;
  syncableState?: Maybe<IntegrationsSyncableState>;
  /** @deprecated Please favor `syncableStatesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  syncableStates: Array<IntegrationsSyncableState>;
  syncableStatesConnection: IntegrationsSyncableStateConnection;
  syncableSyncRun?: Maybe<IntegrationsSyncableSyncRun>;
  /** @deprecated Please favor `syncableSyncRunsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  syncableSyncRuns: Array<IntegrationsSyncableSyncRun>;
  syncableSyncRunsConnection: IntegrationsSyncableSyncRunConnection;
};


export type IntegrationsAvailableIntegrationsArgs = {
  capabilityType?: InputMaybe<IntegrationsCapabilityTypeEnum>;
  marketplaceIntegrationIds?: InputMaybe<Array<Scalars['Int']>>;
  origin?: InputMaybe<IntegrationsSyncRunOriginEnum>;
};


export type IntegrationsAvailableIntegrationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  capabilityType?: InputMaybe<IntegrationsCapabilityTypeEnum>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  marketplaceIntegrationIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  origin?: InputMaybe<IntegrationsSyncRunOriginEnum>;
  sortOrder?: InputMaybe<Sort>;
};


export type IntegrationsSyncRunArgs = {
  id: Scalars['Int'];
  marketplaceIntegrationId: Scalars['Int'];
};


export type IntegrationsSyncRunOutputArgs = {
  id: Scalars['Int'];
};


export type IntegrationsSyncRunOutputsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  parameters?: Array<SyncRunOutputsParametersInput>;
  syncRunIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type IntegrationsSyncRunOutputsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  parameters?: Array<SyncRunOutputsParametersInput>;
  sortOrder?: InputMaybe<Sort>;
  syncRunIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type IntegrationsSyncRunsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  marketplaceIntegrationId: Scalars['Int'];
  parameters?: Array<SyncRunsParametersInput>;
};


export type IntegrationsSyncRunsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<IntegrationsSyncRunFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  marketplaceIntegrationId: Scalars['Int'];
  offsetPage?: InputMaybe<Scalars['Int']>;
  parameters?: Array<SyncRunsParametersInput>;
  sortOrder?: InputMaybe<Sort>;
};


export type IntegrationsSyncValidationsArgs = {
  capabilityType?: InputMaybe<IntegrationsCapabilityTypeEnum>;
  companyId: Scalars['Int'];
  marketplaceIntegrationId: Scalars['Int'];
  origin?: InputMaybe<IntegrationsSyncRunOriginEnum>;
  parameters?: Array<SyncValidationsParametersInput>;
};


export type IntegrationsSyncValidationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  capabilityType?: InputMaybe<IntegrationsCapabilityTypeEnum>;
  companyId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  marketplaceIntegrationId: Scalars['Int'];
  offsetPage?: InputMaybe<Scalars['Int']>;
  origin?: InputMaybe<IntegrationsSyncRunOriginEnum>;
  parameters?: Array<SyncValidationsParametersInput>;
  sortOrder?: InputMaybe<Sort>;
};


export type IntegrationsSyncableStateArgs = {
  id: Scalars['Int'];
};


export type IntegrationsSyncableStatesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  marketplaceIntegrationId?: InputMaybe<Scalars['Int']>;
  syncableIds?: InputMaybe<Array<Scalars['Int']>>;
  syncableType?: InputMaybe<Scalars['String']>;
};


export type IntegrationsSyncableStatesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  marketplaceIntegrationId?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  syncableIds?: InputMaybe<Array<Scalars['Int']>>;
  syncableType?: InputMaybe<Scalars['String']>;
};


export type IntegrationsSyncableSyncRunArgs = {
  id: Scalars['Int'];
};


export type IntegrationsSyncableSyncRunsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  syncRunIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type IntegrationsSyncableSyncRunsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  syncRunIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type IntegrationsBase = {
  __typename?: 'integrationsBase';
  _policies: IntegrationsBaseContextlessPolicies;
};

export type IntegrationsDatevLauds = {
  __typename?: 'integrationsDatevLauds';
  clientDataJobResult?: Maybe<IntegrationsDatevLaudsClientDataJobResult>;
  /** @deprecated Please favor `clientDataJobResultsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  clientDataJobResults: Array<IntegrationsDatevLaudsClientDataJobResult>;
  clientDataJobResultsConnection: IntegrationsDatevLaudsClientDataJobResultConnection;
  clientDataRequest?: Maybe<IntegrationsDatevLaudsClientDataRequest>;
  /** @deprecated Please favor `clientDataRequestsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  clientDataRequests: Array<IntegrationsDatevLaudsClientDataRequest>;
  clientDataRequestsConnection: IntegrationsDatevLaudsClientDataRequestConnection;
  employeeImport?: Maybe<IntegrationsDatevLaudsEmployeeImport>;
  /** @deprecated Please favor `employeeImportsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  employeeImports: Array<IntegrationsDatevLaudsEmployeeImport>;
  employeeImportsConnection: IntegrationsDatevLaudsEmployeeImportConnection;
  importedEmployee?: Maybe<IntegrationsDatevLaudsImportedEmployee>;
  /** @deprecated Please favor `importedEmployeesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  importedEmployees: Array<IntegrationsDatevLaudsImportedEmployee>;
  importedEmployeesConnection: IntegrationsDatevLaudsImportedEmployeeConnection;
  /** @deprecated Please favor `integrationStatusesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  integrationStatuses: Array<IntegrationsDatevLaudsIntegrationStatus>;
  integrationStatusesConnection: IntegrationsDatevLaudsIntegrationStatusConnection;
  oauthToken?: Maybe<IntegrationsDatevLaudsOauthToken>;
  /** @deprecated Please favor `oauthTokensConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  oauthTokens: Array<IntegrationsDatevLaudsOauthToken>;
  oauthTokensConnection: IntegrationsDatevLaudsOauthTokenConnection;
  /** @deprecated Please favor `permissionsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  permissions: Array<IntegrationsDatevLaudsPermission>;
  permissionsConnection: IntegrationsDatevLaudsPermissionConnection;
  request?: Maybe<IntegrationsDatevLaudsRequest>;
  /** @deprecated Please favor `requestsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  requests: Array<IntegrationsDatevLaudsRequest>;
  requestsConnection: IntegrationsDatevLaudsRequestConnection;
};


export type IntegrationsDatevLaudsClientDataJobResultArgs = {
  accessId: Scalars['Int'];
  clientId: Scalars['String'];
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type IntegrationsDatevLaudsClientDataJobResultsArgs = {
  accessId: Scalars['Int'];
  clientId: Scalars['String'];
  companyId: Scalars['Int'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  jobUuid?: InputMaybe<Scalars['String']>;
  referenceDate?: InputMaybe<Scalars['ISO8601Date']>;
  resourceId?: InputMaybe<Scalars['String']>;
  resourceType?: InputMaybe<Scalars['String']>;
  targetSystem?: InputMaybe<Scalars['String']>;
};


export type IntegrationsDatevLaudsClientDataJobResultsConnectionArgs = {
  accessId: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  clientId: Scalars['String'];
  companyId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  jobUuid?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  referenceDate?: InputMaybe<Scalars['ISO8601Date']>;
  resourceId?: InputMaybe<Scalars['String']>;
  resourceType?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  targetSystem?: InputMaybe<Scalars['String']>;
};


export type IntegrationsDatevLaudsClientDataRequestArgs = {
  accessId: Scalars['Int'];
  clientId: Scalars['String'];
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type IntegrationsDatevLaudsClientDataRequestsArgs = {
  accessId: Scalars['Int'];
  clientId: Scalars['String'];
  companyId: Scalars['Int'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  jobUuid?: InputMaybe<Scalars['String']>;
  referenceDate?: InputMaybe<Scalars['ISO8601Date']>;
  resourceId?: InputMaybe<Scalars['String']>;
  resourceType?: InputMaybe<Scalars['String']>;
  targetSystem?: InputMaybe<Scalars['String']>;
};


export type IntegrationsDatevLaudsClientDataRequestsConnectionArgs = {
  accessId: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  clientId: Scalars['String'];
  companyId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  jobUuid?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  referenceDate?: InputMaybe<Scalars['ISO8601Date']>;
  resourceId?: InputMaybe<Scalars['String']>;
  resourceType?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  targetSystem?: InputMaybe<Scalars['String']>;
};


export type IntegrationsDatevLaudsEmployeeImportArgs = {
  id: Scalars['Int'];
};


export type IntegrationsDatevLaudsEmployeeImportsArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  status?: InputMaybe<Scalars['String']>;
};


export type IntegrationsDatevLaudsEmployeeImportsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  status?: InputMaybe<Scalars['String']>;
};


export type IntegrationsDatevLaudsImportedEmployeeArgs = {
  employeeImportId: Scalars['Int'];
  id: Scalars['Int'];
};


export type IntegrationsDatevLaudsImportedEmployeesArgs = {
  employeeImportId: Scalars['Int'];
  employeeType?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type IntegrationsDatevLaudsImportedEmployeesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeImportId: Scalars['Int'];
  employeeType?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type IntegrationsDatevLaudsIntegrationStatusesArgs = {
  companyId: Scalars['Int'];
};


export type IntegrationsDatevLaudsIntegrationStatusesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type IntegrationsDatevLaudsOauthTokenArgs = {
  id: Scalars['Int'];
};


export type IntegrationsDatevLaudsOauthTokensArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  clientId?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  validAccessToken?: Scalars['Boolean'];
};


export type IntegrationsDatevLaudsOauthTokensConnectionArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  clientId?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  validAccessToken?: Scalars['Boolean'];
};


export type IntegrationsDatevLaudsPermissionsArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  clientId?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
};


export type IntegrationsDatevLaudsPermissionsConnectionArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  clientId?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type IntegrationsDatevLaudsRequestArgs = {
  id: Scalars['Int'];
};


export type IntegrationsDatevLaudsRequestsArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  incidenceId?: InputMaybe<Scalars['Int']>;
  jobUuid?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};


export type IntegrationsDatevLaudsRequestsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  incidenceId?: InputMaybe<Scalars['Int']>;
  jobUuid?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  status?: InputMaybe<Scalars['String']>;
};

export type IntegrationsDatevLaudsMutations = {
  __typename?: 'integrationsDatevLaudsMutations';
  authorizeIntegrationsdatevlaudsOauthToken: AuthorizeIntegrationsdatevlaudsOauthTokenPayload;
  bulkDeleteIntegrationsdatevlaudsRequest: BulkDeleteIntegrationsdatevlaudsRequestPayload;
  createIntegrationsdatevlaudsEmployeeExport: CreateIntegrationsdatevlaudsEmployeeExportPayload;
  createIntegrationsdatevlaudsEmployeeImport: CreateIntegrationsdatevlaudsEmployeeImportPayload;
  createIntegrationsdatevlaudsExport: CreateIntegrationsdatevlaudsExportPayload;
  createIntegrationsdatevlaudsRequest: CreateIntegrationsdatevlaudsRequestPayload;
  deleteIntegrationsdatevlaudsOauthToken: DeleteIntegrationsdatevlaudsOauthTokenPayload;
  processIntegrationsdatevlaudsEmployeeImport: ProcessIntegrationsdatevlaudsEmployeeImportPayload;
  processIntegrationsdatevlaudsRequest: ProcessIntegrationsdatevlaudsRequestPayload;
  revokeIntegrationsdatevlaudsOauthToken: RevokeIntegrationsdatevlaudsOauthTokenPayload;
  updateIntegrationsdatevlaudsRequest: UpdateIntegrationsdatevlaudsRequestPayload;
};


export type IntegrationsDatevLaudsMutationsAuthorizeIntegrationsdatevlaudsOauthTokenArgs = {
  clientId?: InputMaybe<Scalars['String']>;
  code: Scalars['String'];
  companyId: Scalars['Int'];
  redirectUri: Scalars['String'];
};


export type IntegrationsDatevLaudsMutationsBulkDeleteIntegrationsdatevlaudsRequestArgs = {
  companyId: Scalars['Int'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type IntegrationsDatevLaudsMutationsCreateIntegrationsdatevlaudsEmployeeExportArgs = {
  accessId: Scalars['Int'];
  companyId: Scalars['Int'];
};


export type IntegrationsDatevLaudsMutationsCreateIntegrationsdatevlaudsEmployeeImportArgs = {
  accessId: Scalars['Int'];
  companyId: Scalars['Int'];
  importType?: InputMaybe<IntegrationsDatevLaudsValueObjectsEmployeeImportTypeEnum>;
};


export type IntegrationsDatevLaudsMutationsCreateIntegrationsdatevlaudsExportArgs = {
  employeeImportId: Scalars['Int'];
  employeeType?: InputMaybe<Scalars['String']>;
};


export type IntegrationsDatevLaudsMutationsCreateIntegrationsdatevlaudsRequestArgs = {
  accessId: Scalars['Int'];
  clientId: Scalars['String'];
  companyId: Scalars['Int'];
  endpoint: Scalars['String'];
  errorCode?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  incidenceId?: InputMaybe<Scalars['Int']>;
  jobUuid?: InputMaybe<Scalars['String']>;
  payload?: InputMaybe<Scalars['String']>;
  requestData?: InputMaybe<Scalars['String']>;
  responseBody?: InputMaybe<Scalars['String']>;
  responseData?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<IntegrationsDatevLaudsValueObjectsRequestStatusEnum>;
  targetSystem?: InputMaybe<IntegrationsDatevLaudsValueObjectsTargetSystemEnum>;
};


export type IntegrationsDatevLaudsMutationsDeleteIntegrationsdatevlaudsOauthTokenArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};


export type IntegrationsDatevLaudsMutationsProcessIntegrationsdatevlaudsEmployeeImportArgs = {
  id: Scalars['Int'];
};


export type IntegrationsDatevLaudsMutationsProcessIntegrationsdatevlaudsRequestArgs = {
  companyId: Scalars['Int'];
  jobUuid: Scalars['String'];
  status?: InputMaybe<IntegrationsDatevLaudsValueObjectsRequestStatusEnum>;
};


export type IntegrationsDatevLaudsMutationsRevokeIntegrationsdatevlaudsOauthTokenArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  clientId?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
};


export type IntegrationsDatevLaudsMutationsUpdateIntegrationsdatevlaudsRequestArgs = {
  id: Scalars['Int'];
  jobUuid?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<IntegrationsDatevLaudsValueObjectsRequestStatusEnum>;
};

export type IntegrationsIndeed = {
  __typename?: 'integrationsIndeed';
  account?: Maybe<IntegrationsIndeedAccount>;
  /** @deprecated Please favor `accountsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  accounts: Array<IntegrationsIndeedAccount>;
  accountsConnection: IntegrationsIndeedAccountConnection;
  application?: Maybe<IntegrationsIndeedApplication>;
  /** @deprecated Please favor `applicationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  applications: Array<IntegrationsIndeedApplication>;
  applicationsConnection: IntegrationsIndeedApplicationConnection;
  jobPosting?: Maybe<IntegrationsIndeedJobPosting>;
  /** @deprecated Please favor `jobPostingsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  jobPostings: Array<IntegrationsIndeedJobPosting>;
  jobPostingsConnection: IntegrationsIndeedJobPostingConnection;
};


export type IntegrationsIndeedAccountArgs = {
  id: Scalars['Int'];
};


export type IntegrationsIndeedAccountsArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type IntegrationsIndeedAccountsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type IntegrationsIndeedApplicationArgs = {
  id: Scalars['Int'];
};


export type IntegrationsIndeedApplicationsArgs = {
  atsApplicationId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type IntegrationsIndeedApplicationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  atsApplicationId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type IntegrationsIndeedJobPostingArgs = {
  id: Scalars['Int'];
};


export type IntegrationsIndeedJobPostingsArgs = {
  atsJobPostingId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type IntegrationsIndeedJobPostingsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  atsJobPostingId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

export type IntegrationsIndeedMutations = {
  __typename?: 'integrationsIndeedMutations';
  createIntegrationsindeedAccount: CreateIntegrationsindeedAccountPayload;
  createIntegrationsindeedApplication: CreateIntegrationsindeedApplicationPayload;
  expireIntegrationsindeedJobPosting: ExpireIntegrationsindeedJobPostingPayload;
  expireOnUninstallIntegrationsindeedJobPosting: ExpireOnUninstallIntegrationsindeedJobPostingPayload;
  softDeleteIntegrationsindeedAccount: SoftDeleteIntegrationsindeedAccountPayload;
  syncIntegrationsindeedJobPosting: SyncIntegrationsindeedJobPostingPayload;
  syncOnInstallIntegrationsindeedJobPosting: SyncOnInstallIntegrationsindeedJobPostingPayload;
  updateIntegrationsindeedAccount: UpdateIntegrationsindeedAccountPayload;
  updateIntegrationsindeedApplication: UpdateIntegrationsindeedApplicationPayload;
};


export type IntegrationsIndeedMutationsCreateIntegrationsindeedAccountArgs = {
  accessId: Scalars['Int'];
  active?: InputMaybe<Scalars['Boolean']>;
  companyId: Scalars['Int'];
  indeedApplyEnabled: Scalars['Boolean'];
  sourceName?: InputMaybe<Scalars['String']>;
};


export type IntegrationsIndeedMutationsCreateIntegrationsindeedApplicationArgs = {
  atsApplicationId: Scalars['Int'];
  companyId: Scalars['Int'];
  dispositionStatus: IntegrationsIndeedDispositionDataStatusesEnum;
  indeedApplyId: Scalars['String'];
  integrationsIndeedJobPostingId: Scalars['Int'];
  rawDispositionStatus: Scalars['String'];
};


export type IntegrationsIndeedMutationsExpireIntegrationsindeedJobPostingArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type IntegrationsIndeedMutationsExpireOnUninstallIntegrationsindeedJobPostingArgs = {
  companyId: Scalars['Int'];
};


export type IntegrationsIndeedMutationsSoftDeleteIntegrationsindeedAccountArgs = {
  accessId: Scalars['Int'];
  companyId: Scalars['Int'];
};


export type IntegrationsIndeedMutationsSyncIntegrationsindeedJobPostingArgs = {
  atsJobPostingId: Scalars['Int'];
  companyId: Scalars['Int'];
};


export type IntegrationsIndeedMutationsSyncOnInstallIntegrationsindeedJobPostingArgs = {
  companyId: Scalars['Int'];
};


export type IntegrationsIndeedMutationsUpdateIntegrationsindeedAccountArgs = {
  accessId: Scalars['Int'];
  companyId: Scalars['Int'];
  indeedApplyEnabled: Scalars['Boolean'];
  sourceName: Scalars['String'];
};


export type IntegrationsIndeedMutationsUpdateIntegrationsindeedApplicationArgs = {
  companyId: Scalars['Int'];
  dispositionStatus: IntegrationsIndeedDispositionDataStatusesEnum;
  id: Scalars['Int'];
  rawDispositionStatus: Scalars['String'];
};

export type IntegrationsInfojobs = {
  __typename?: 'integrationsInfojobs';
  offer?: Maybe<IntegrationsInfojobsOffer>;
  /** @deprecated Please favor `offersConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  offers: Array<IntegrationsInfojobsOffer>;
  offersConnection: IntegrationsInfojobsOfferConnection;
  /** @deprecated Please favor `promotionsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  promotions: Array<IntegrationsInfojobsPromotion>;
  promotionsConnection: IntegrationsInfojobsPromotionConnection;
  /** @deprecated Please favor `valueOptionsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  valueOptions: Array<IntegrationsInfojobsValueOption>;
  valueOptionsConnection: IntegrationsInfojobsValueOptionConnection;
};


export type IntegrationsInfojobsOfferArgs = {
  id: Scalars['Int'];
};


export type IntegrationsInfojobsOffersArgs = {
  atsJobPostingId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type IntegrationsInfojobsOffersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  atsJobPostingId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type IntegrationsInfojobsPromotionsArgs = {
  companyId: Scalars['Int'];
};


export type IntegrationsInfojobsPromotionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type IntegrationsInfojobsValueOptionsArgs = {
  companyId: Scalars['Int'];
  parentId?: InputMaybe<Scalars['String']>;
  valueType: IntegrationsInfojobsValueTypeEnum;
};


export type IntegrationsInfojobsValueOptionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  parentId?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  valueType: IntegrationsInfojobsValueTypeEnum;
};

export type IntegrationsInfojobsMutations = {
  __typename?: 'integrationsInfojobsMutations';
  createIntegrationsinfojobsOffer: CreateIntegrationsinfojobsOfferPayload;
  deleteIntegrationsinfojobsOffer: DeleteIntegrationsinfojobsOfferPayload;
  disableIntegrationsinfojobsOffer: DisableIntegrationsinfojobsOfferPayload;
  enableIntegrationsinfojobsOffer: EnableIntegrationsinfojobsOfferPayload;
  updateIntegrationsinfojobsOffer: UpdateIntegrationsinfojobsOfferPayload;
};


export type IntegrationsInfojobsMutationsCreateIntegrationsinfojobsOfferArgs = {
  atsJobPostingId: Scalars['Int'];
  companyId: Scalars['Int'];
  contractTypeId: Scalars['Int'];
  countryId: Scalars['Int'];
  desiredSkills?: InputMaybe<Scalars['String']>;
  jobIndustryId: Scalars['Int'];
  jobSubindustryId: Scalars['Int'];
  levelId: Scalars['Int'];
  minimumExperienceId: Scalars['Int'];
  minimumStudiesId: Scalars['Int'];
  numberOfVacancies: Scalars['Int'];
  promotionCodes?: InputMaybe<Array<Scalars['String']>>;
  provinceId: Scalars['Int'];
  requiredSkills?: InputMaybe<Scalars['String']>;
  salaryFromId: Scalars['Int'];
  salaryPerId: Scalars['Int'];
  salaryToId: Scalars['Int'];
  workingDayId: Scalars['Int'];
};


export type IntegrationsInfojobsMutationsDeleteIntegrationsinfojobsOfferArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type IntegrationsInfojobsMutationsDisableIntegrationsinfojobsOfferArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type IntegrationsInfojobsMutationsEnableIntegrationsinfojobsOfferArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type IntegrationsInfojobsMutationsUpdateIntegrationsinfojobsOfferArgs = {
  contractTypeId?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  jobSubindustryId: Scalars['Int'];
  levelId: Scalars['Int'];
  minimumExperienceId?: InputMaybe<Scalars['Int']>;
  minimumStudiesId?: InputMaybe<Scalars['Int']>;
  salaryFromId?: InputMaybe<Scalars['Int']>;
  salaryPerId?: InputMaybe<Scalars['Int']>;
  salaryToId?: InputMaybe<Scalars['Int']>;
  workingDayId: Scalars['Int'];
};

export type IntegrationsJoin = {
  __typename?: 'integrationsJoin';
  _policies: IntegrationsJoinContextlessPolicies;
  jobPosting?: Maybe<IntegrationsJoinJobPosting>;
  /** @deprecated Please favor `jobPostingsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  jobPostings: Array<IntegrationsJoinJobPosting>;
  jobPostingsConnection: IntegrationsJoinJobPostingConnection;
  /** @deprecated Please favor `joinCompaniesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  joinCompanies: Array<IntegrationsJoinJoinCompany>;
  joinCompaniesConnection: IntegrationsJoinJoinCompanyConnection;
  joinCompany?: Maybe<IntegrationsJoinJoinCompany>;
  office?: Maybe<IntegrationsJoinOffice>;
  /** @deprecated Please favor `officesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  offices: Array<IntegrationsJoinOffice>;
  officesConnection: IntegrationsJoinOfficeConnection;
  order?: Maybe<IntegrationsJoinOrder>;
  /** @deprecated Please favor `ordersConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  orders: Array<IntegrationsJoinOrder>;
  ordersConnection: IntegrationsJoinOrderConnection;
  /** @deprecated Please favor `premiumBundlesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  premiumBundles: Array<IntegrationsJoinPremiumBundle>;
  premiumBundlesConnection: IntegrationsJoinPremiumBundleConnection;
  premiumPosting?: Maybe<IntegrationsJoinPremiumPosting>;
  /** @deprecated Please favor `premiumPostingsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  premiumPostings: Array<IntegrationsJoinPremiumPosting>;
  premiumPostingsConnection: IntegrationsJoinPremiumPostingConnection;
  /** @deprecated Please favor `premiumProductsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  premiumProducts: Array<IntegrationsJoinPremiumProduct>;
  premiumProductsConnection: IntegrationsJoinPremiumProductConnection;
};


export type IntegrationsJoinJobPostingArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type IntegrationsJoinJobPostingsArgs = {
  atsJobPostingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyId: Scalars['Int'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  statuses?: InputMaybe<Array<Scalars['String']>>;
};


export type IntegrationsJoinJobPostingsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  atsJobPostingIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  statuses?: InputMaybe<Array<Scalars['String']>>;
};


export type IntegrationsJoinJoinCompaniesArgs = {
  companyId: Scalars['Int'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type IntegrationsJoinJoinCompaniesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type IntegrationsJoinJoinCompanyArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type IntegrationsJoinOfficeArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type IntegrationsJoinOfficesArgs = {
  companyId: Scalars['Int'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type IntegrationsJoinOfficesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type IntegrationsJoinOrderArgs = {
  id: Scalars['Int'];
};


export type IntegrationsJoinOrdersArgs = {
  approverAccessIds?: InputMaybe<Array<Scalars['Int']>>;
  atsJobPostingId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  premiumOfferTypes?: InputMaybe<Array<IntegrationsJoinPremiumOfferTypesEnum>>;
  requestedById?: InputMaybe<Scalars['Int']>;
  requestedOrApproverByIds?: InputMaybe<Array<Scalars['Int']>>;
  statuses?: InputMaybe<Array<IntegrationsJoinOrderStatusesEnum>>;
};


export type IntegrationsJoinOrdersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  approverAccessIds?: InputMaybe<Array<Scalars['Int']>>;
  atsJobPostingId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<IntegrationsJoinOrderFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  premiumOfferTypes?: InputMaybe<Array<IntegrationsJoinPremiumOfferTypesEnum>>;
  requestedById?: InputMaybe<Scalars['Int']>;
  requestedOrApproverByIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
  statuses?: InputMaybe<Array<IntegrationsJoinOrderStatusesEnum>>;
};


export type IntegrationsJoinPremiumBundlesArgs = {
  accessId: Scalars['Int'];
  atsJobPostingId: Scalars['Int'];
  jobBoardName?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type IntegrationsJoinPremiumBundlesConnectionArgs = {
  accessId: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  atsJobPostingId: Scalars['Int'];
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  jobBoardName?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type IntegrationsJoinPremiumPostingArgs = {
  id: Scalars['Int'];
};


export type IntegrationsJoinPremiumPostingsArgs = {
  atsJobPostingId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  statuses?: InputMaybe<Array<IntegrationsJoinPremiumPostingStatusesEnum>>;
};


export type IntegrationsJoinPremiumPostingsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  atsJobPostingId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<IntegrationsJoinPremiumPostingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  statuses?: InputMaybe<Array<IntegrationsJoinPremiumPostingStatusesEnum>>;
};


export type IntegrationsJoinPremiumProductsArgs = {
  accessId: Scalars['Int'];
  atsJobPostingId: Scalars['Int'];
  jobBoardName?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type IntegrationsJoinPremiumProductsConnectionArgs = {
  accessId: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  atsJobPostingId: Scalars['Int'];
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  jobBoardName?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

export type IntegrationsJoinMutations = {
  __typename?: 'integrationsJoinMutations';
  approveIntegrationsjoinOrder: ApproveIntegrationsjoinOrderPayload;
  cancelIntegrationsjoinOrder: CancelIntegrationsjoinOrderPayload;
  changeStatusIntegrationsjoinJobPosting: ChangeStatusIntegrationsjoinJobPostingPayload;
  changeStatusIntegrationsjoinOrder: ChangeStatusIntegrationsjoinOrderPayload;
  createIntegrationsjoinJobPosting: CreateIntegrationsjoinJobPostingPayload;
  createIntegrationsjoinJoinCompany: CreateIntegrationsjoinJoinCompanyPayload;
  createIntegrationsjoinOffice: CreateIntegrationsjoinOfficePayload;
  createIntegrationsjoinOrder: CreateIntegrationsjoinOrderPayload;
  deleteIntegrationsjoinJobPosting: DeleteIntegrationsjoinJobPostingPayload;
  deleteIntegrationsjoinJoinCompany: DeleteIntegrationsjoinJoinCompanyPayload;
  deleteIntegrationsjoinOffice: DeleteIntegrationsjoinOfficePayload;
  enqueueCompanyJobsForPublishingIntegrationsjoinJobPosting: EnqueueCompanyJobsForPublishingIntegrationsjoinJobPostingPayload;
  listIntegrationsjoinIntegration: ListIntegrationsjoinIntegrationPayload;
  listIntegrationsjoinOrganicChannel: ListIntegrationsjoinOrganicChannelPayload;
  rejectIntegrationsjoinOrder: RejectIntegrationsjoinOrderPayload;
  updateIntegrationsjoinIntegration: UpdateIntegrationsjoinIntegrationPayload;
  updateIntegrationsjoinJobPosting: UpdateIntegrationsjoinJobPostingPayload;
  updateIntegrationsjoinJoinCompany: UpdateIntegrationsjoinJoinCompanyPayload;
  updateIntegrationsjoinOffice: UpdateIntegrationsjoinOfficePayload;
};


export type IntegrationsJoinMutationsApproveIntegrationsjoinOrderArgs = {
  accessId: Scalars['Int'];
  id: Scalars['Int'];
};


export type IntegrationsJoinMutationsCancelIntegrationsjoinOrderArgs = {
  accessId: Scalars['Int'];
  id: Scalars['Int'];
};


export type IntegrationsJoinMutationsChangeStatusIntegrationsjoinJobPostingArgs = {
  id: Scalars['Int'];
  status: IntegrationsJoinJobPostingStatusesEnum;
};


export type IntegrationsJoinMutationsChangeStatusIntegrationsjoinOrderArgs = {
  id: Scalars['Int'];
  status: IntegrationsJoinOrderStatusesEnum;
};


export type IntegrationsJoinMutationsCreateIntegrationsjoinJobPostingArgs = {
  atsJobPostingId: Scalars['Int'];
  companyId: Scalars['Int'];
};


export type IntegrationsJoinMutationsCreateIntegrationsjoinJoinCompanyArgs = {
  companyId: Scalars['Int'];
};


export type IntegrationsJoinMutationsCreateIntegrationsjoinOfficeArgs = {
  companyId: Scalars['Int'];
  locationId: Scalars['Int'];
};


export type IntegrationsJoinMutationsCreateIntegrationsjoinOrderArgs = {
  accessId: Scalars['Int'];
  atsJobPostingId: Scalars['Int'];
  note?: InputMaybe<Scalars['String']>;
  premiumOfferId: Scalars['String'];
  premiumOfferName: Scalars['String'];
  premiumOfferPrice: Scalars['Int'];
  premiumOfferType: IntegrationsJoinPremiumOfferTypesEnum;
  snapshot: IntegrationsJoinSnapshotInput;
};


export type IntegrationsJoinMutationsDeleteIntegrationsjoinJobPostingArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type IntegrationsJoinMutationsDeleteIntegrationsjoinJoinCompanyArgs = {
  id: Scalars['Int'];
};


export type IntegrationsJoinMutationsDeleteIntegrationsjoinOfficeArgs = {
  id: Scalars['Int'];
};


export type IntegrationsJoinMutationsEnqueueCompanyJobsForPublishingIntegrationsjoinJobPostingArgs = {
  companyId: Scalars['Int'];
};


export type IntegrationsJoinMutationsListIntegrationsjoinIntegrationArgs = {
  accessId: Scalars['Int'];
  companyId: Scalars['Int'];
};


export type IntegrationsJoinMutationsListIntegrationsjoinOrganicChannelArgs = {
  accessId: Scalars['Int'];
  atsJobPostingId: Scalars['Int'];
};


export type IntegrationsJoinMutationsRejectIntegrationsjoinOrderArgs = {
  accessId: Scalars['Int'];
  id: Scalars['Int'];
  reason?: InputMaybe<Scalars['String']>;
};


export type IntegrationsJoinMutationsUpdateIntegrationsjoinIntegrationArgs = {
  accessId: Scalars['Int'];
  companyId: Scalars['Int'];
  configuration?: InputMaybe<Array<IntegrationsJoinIntegrationConfigurationInput>>;
  file?: InputMaybe<Scalars['File']>;
  integrationSlug: Scalars['String'];
  status: IntegrationsJoinIntegrationsStatusEnum;
};


export type IntegrationsJoinMutationsUpdateIntegrationsjoinJobPostingArgs = {
  id: Scalars['Int'];
};


export type IntegrationsJoinMutationsUpdateIntegrationsjoinJoinCompanyArgs = {
  companyId: Scalars['Int'];
  countryCode?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  employeesCount?: InputMaybe<Scalars['String']>;
  industry?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
};


export type IntegrationsJoinMutationsUpdateIntegrationsjoinOfficeArgs = {
  id: Scalars['Int'];
  locationId: Scalars['Int'];
};

export type IntegrationsMutations = {
  __typename?: 'integrationsMutations';
  createIntegrationsSyncRun: CreateIntegrationsSyncRunPayload;
  createIntegrationsSyncRunOutput: CreateIntegrationsSyncRunOutputPayload;
  statusChangeIntegrationsSyncRun: StatusChangeIntegrationsSyncRunPayload;
};


export type IntegrationsMutationsCreateIntegrationsSyncRunArgs = {
  capabilityType?: InputMaybe<IntegrationsCapabilityTypeEnum>;
  companyId: Scalars['Int'];
  marketplaceIntegrationId: Scalars['Int'];
  origin?: InputMaybe<IntegrationsSyncRunOriginEnum>;
  parameters: Array<CreateIntegrationsSyncRunParametersInput>;
};


export type IntegrationsMutationsCreateIntegrationsSyncRunOutputArgs = {
  file: Scalars['File'];
  syncRunId: Scalars['Int'];
};


export type IntegrationsMutationsStatusChangeIntegrationsSyncRunArgs = {
  finishedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  id: Scalars['Int'];
  parameters: Array<IntegrationsSyncRunParametersInput>;
  status: IntegrationsSyncRunStatusEnum;
};

export type IntegrationsPrimobox = {
  __typename?: 'integrationsPrimobox';
  documentStatus?: Maybe<IntegrationsPrimoboxDocumentStatus>;
  /** @deprecated Please favor `documentStatusesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  documentStatuses: Array<IntegrationsPrimoboxDocumentStatus>;
  documentStatusesConnection: IntegrationsPrimoboxDocumentStatusConnection;
  employeeStatus?: Maybe<IntegrationsPrimoboxEmployeeStatus>;
  /** @deprecated Please favor `employeeStatusesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  employeeStatuses: Array<IntegrationsPrimoboxEmployeeStatus>;
  employeeStatusesConnection: IntegrationsPrimoboxEmployeeStatusConnection;
  legalEntityStatus?: Maybe<IntegrationsPrimoboxLegalEntityStatus>;
  /** @deprecated Please favor `legalEntityStatusesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  legalEntityStatuses: Array<IntegrationsPrimoboxLegalEntityStatus>;
  legalEntityStatusesConnection: IntegrationsPrimoboxLegalEntityStatusConnection;
};


export type IntegrationsPrimoboxDocumentStatusArgs = {
  id: Scalars['Int'];
};


export type IntegrationsPrimoboxDocumentStatusesArgs = {
  documentIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type IntegrationsPrimoboxDocumentStatusesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  documentIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type IntegrationsPrimoboxEmployeeStatusArgs = {
  id: Scalars['Int'];
};


export type IntegrationsPrimoboxEmployeeStatusesArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type IntegrationsPrimoboxEmployeeStatusesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type IntegrationsPrimoboxLegalEntityStatusArgs = {
  id: Scalars['Int'];
};


export type IntegrationsPrimoboxLegalEntityStatusesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
};


export type IntegrationsPrimoboxLegalEntityStatusesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

export type IntegrationsPrimoboxMutations = {
  __typename?: 'integrationsPrimoboxMutations';
  toggleIntegrationsprimoboxFeature: ToggleIntegrationsprimoboxFeaturePayload;
};


export type IntegrationsPrimoboxMutationsToggleIntegrationsprimoboxFeatureArgs = {
  companyId: Scalars['Int'];
  enabled: Scalars['Boolean'];
};

export type Intercom = {
  __typename?: 'intercom';
  _policies: IntercomContextlessPolicies;
};

export type Iris = {
  __typename?: 'iris';
  _policies: IrisContextlessPolicies;
  factTable?: Maybe<IrisFactTable>;
  /** @deprecated Please favor `factTablesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  factTables: Array<IrisFactTable>;
  factTablesConnection: IrisFactTableConnection;
  snapshotResult?: Maybe<IrisSnapshotResult>;
  /** @deprecated Please favor `snapshotResultsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  snapshotResults: Array<IrisSnapshotResult>;
  snapshotResultsConnection: IrisSnapshotResultConnection;
  tableColumn?: Maybe<IrisTableColumn>;
  /** @deprecated Please favor `tableColumnsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  tableColumns: Array<IrisTableColumn>;
  tableColumnsConnection: IrisTableColumnConnection;
  traceabilityResult?: Maybe<IrisTraceabilityResult>;
  /** @deprecated Please favor `traceabilityResultsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  traceabilityResults: Array<IrisTraceabilityResult>;
  traceabilityResultsConnection: IrisTraceabilityResultConnection;
};


export type IrisFactTableArgs = {
  companyId: Scalars['Int'];
  id: Scalars['String'];
};


export type IrisFactTablesArgs = {
  companyId: Scalars['Int'];
  ids?: InputMaybe<Array<Scalars['String']>>;
};


export type IrisFactTablesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type IrisSnapshotResultArgs = {
  companyId: Scalars['Int'];
  id: Scalars['String'];
  snapshotDate: Scalars['ISO8601DateTime'];
  sqlQuery: Scalars['String'];
  tableId: Scalars['String'];
};


export type IrisSnapshotResultsArgs = {
  companyId: Scalars['Int'];
  filters?: Scalars['String'];
  ids?: InputMaybe<Array<Scalars['String']>>;
  snapshotDate: Scalars['ISO8601DateTime'];
  sqlQuery: Scalars['String'];
  tableId: Scalars['String'];
};


export type IrisSnapshotResultsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  filters?: Scalars['String'];
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  snapshotDate: Scalars['ISO8601DateTime'];
  sortOrder?: InputMaybe<Sort>;
  sqlQuery: Scalars['String'];
  tableId: Scalars['String'];
};


export type IrisTableColumnArgs = {
  companyId: Scalars['Int'];
  id: Scalars['String'];
};


export type IrisTableColumnsArgs = {
  companyId: Scalars['Int'];
  ids?: InputMaybe<Array<Scalars['String']>>;
  tableIds?: InputMaybe<Array<Scalars['String']>>;
};


export type IrisTableColumnsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  tableIds?: InputMaybe<Array<Scalars['String']>>;
};


export type IrisTraceabilityResultArgs = {
  companyId: Scalars['Int'];
  dateRange: TimeRangeInput;
  id: Scalars['String'];
  sqlQuery: Scalars['String'];
  tableId: Scalars['String'];
};


export type IrisTraceabilityResultsArgs = {
  companyId: Scalars['Int'];
  dateRange: TimeRangeInput;
  filters?: Scalars['String'];
  ids?: InputMaybe<Array<Scalars['String']>>;
  sqlQuery: Scalars['String'];
  tableId: Scalars['String'];
};


export type IrisTraceabilityResultsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  dateRange: TimeRangeInput;
  filters?: Scalars['String'];
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  sqlQuery: Scalars['String'];
  tableId: Scalars['String'];
};

export type ItManagement = {
  __typename?: 'itManagement';
  _policies: ItManagementContextlessPolicies;
  /** @deprecated Please favor `assetActivityLogsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  assetActivityLogs: Array<ItManagementAssetActivityLog>;
  assetActivityLogsConnection: ItManagementAssetActivityLogConnection;
  /** @deprecated Please favor `companyEmployeesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  companyEmployees: Array<ItManagementCompanyEmployee>;
  companyEmployeesConnection: ItManagementCompanyEmployeeConnection;
  distributorProductVariant?: Maybe<ItManagementDistributorProductVariant>;
  /** @deprecated Please favor `distributorProductVariantsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  distributorProductVariants: Array<ItManagementDistributorProductVariant>;
  distributorProductVariantsConnection: ItManagementDistributorProductVariantConnection;
  documentTemplate?: Maybe<ItManagementDocumentTemplate>;
  /** @deprecated Please favor `documentTemplatesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  documentTemplates: Array<ItManagementDocumentTemplate>;
  documentTemplatesConnection: ItManagementDocumentTemplateConnection;
  itAsset?: Maybe<ItManagementItAsset>;
  /** @deprecated Please favor `itAssetDocumentsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  itAssetDocuments: Array<ItManagementItAssetDocument>;
  itAssetDocumentsConnection: ItManagementItAssetDocumentConnection;
  itAssetModel?: Maybe<ItManagementItAssetModel>;
  /** @deprecated Please favor `itAssetModelsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  itAssetModels: Array<ItManagementItAssetModel>;
  itAssetModelsConnection: ItManagementItAssetModelConnection;
  /** @deprecated Please favor `itAssetModelsStocksConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  itAssetModelsStocks: Array<ItManagementItAssetModelsStock>;
  itAssetModelsStocksConnection: ItManagementItAssetModelsStockConnection;
  /** @deprecated Please favor `itAssetsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  itAssets: Array<ItManagementItAsset>;
  itAssetsConnection: ItManagementItAssetConnection;
  legalEntityDocumentTemplateSetting?: Maybe<ItManagementLegalEntityDocumentTemplateSetting>;
  /** @deprecated Please favor `legalEntityDocumentTemplateSettingsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  legalEntityDocumentTemplateSettings: Array<ItManagementLegalEntityDocumentTemplateSetting>;
  legalEntityDocumentTemplateSettingsConnection: ItManagementLegalEntityDocumentTemplateSettingConnection;
  product?: Maybe<ItManagementProduct>;
  /** @deprecated Please favor `productsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  products: Array<ItManagementProduct>;
  productsConnection: ItManagementProductConnection;
};


export type ItManagementAssetActivityLogsArgs = {
  assetId: Scalars['String'];
};


export type ItManagementAssetActivityLogsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  assetId: Scalars['String'];
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ItManagementCompanyEmployeesArgs = {
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: Scalars['Boolean'];
  onlyNewHires?: Scalars['Boolean'];
  onlyPendingDocuments?: InputMaybe<Scalars['Boolean']>;
  onlyTerminated?: Scalars['Boolean'];
  search?: InputMaybe<Scalars['String']>;
  startDateFilter?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type ItManagementCompanyEmployeesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<ItManagementCompanyEmployeeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyActive?: Scalars['Boolean'];
  onlyNewHires?: Scalars['Boolean'];
  onlyPendingDocuments?: InputMaybe<Scalars['Boolean']>;
  onlyTerminated?: Scalars['Boolean'];
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  startDateFilter?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type ItManagementDistributorProductVariantArgs = {
  id: Scalars['String'];
};


export type ItManagementDistributorProductVariantsArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
};


export type ItManagementDistributorProductVariantsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<ItManagementDistributorProductVariantFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ItManagementDocumentTemplateArgs = {
  id: Scalars['String'];
};


export type ItManagementDocumentTemplatesArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
  includeDiscarded?: InputMaybe<Scalars['Boolean']>;
  templateTypes?: InputMaybe<Array<Scalars['String']>>;
};


export type ItManagementDocumentTemplatesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<ItManagementDocumentTemplateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  includeDiscarded?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  templateTypes?: InputMaybe<Array<Scalars['String']>>;
};


export type ItManagementItAssetArgs = {
  id: Scalars['String'];
};


export type ItManagementItAssetDocumentsArgs = {
  employeeId?: InputMaybe<Scalars['Int']>;
  itAssetId?: InputMaybe<Scalars['String']>;
};


export type ItManagementItAssetDocumentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ItManagementItAssetDocumentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  itAssetId?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ItManagementItAssetModelArgs = {
  id: Scalars['String'];
};


export type ItManagementItAssetModelsArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};


export type ItManagementItAssetModelsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<ItManagementItAssetModelFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ItManagementItAssetModelsStocksArgs = {
  itAssetModelIds?: Array<Scalars['String']>;
};


export type ItManagementItAssetModelsStocksConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  itAssetModelIds?: Array<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ItManagementItAssetsArgs = {
  currency?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  itAssetModelIds?: InputMaybe<Array<Scalars['String']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  ownerIds?: InputMaybe<Array<Scalars['Int']>>;
  purchaseDate?: InputMaybe<Scalars['ISO8601Date']>;
  purchasePriceCents?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  serialNumbers?: InputMaybe<Array<Scalars['String']>>;
  status?: InputMaybe<ItManagementValueObjectsItAssetStatusEnum>;
  statuses?: InputMaybe<Array<ItManagementValueObjectsItAssetStatusEnum>>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  typeNames?: InputMaybe<Array<Scalars['String']>>;
  warrantyEndDate?: InputMaybe<Scalars['ISO8601Date']>;
  workplaceIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type ItManagementItAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<ItManagementItAssetFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  itAssetModelIds?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  ownerIds?: InputMaybe<Array<Scalars['Int']>>;
  purchaseDate?: InputMaybe<Scalars['ISO8601Date']>;
  purchasePriceCents?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  serialNumbers?: InputMaybe<Array<Scalars['String']>>;
  sortOrder?: InputMaybe<Sort>;
  status?: InputMaybe<ItManagementValueObjectsItAssetStatusEnum>;
  statuses?: InputMaybe<Array<ItManagementValueObjectsItAssetStatusEnum>>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  typeNames?: InputMaybe<Array<Scalars['String']>>;
  warrantyEndDate?: InputMaybe<Scalars['ISO8601Date']>;
  workplaceIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type ItManagementLegalEntityDocumentTemplateSettingArgs = {
  id: Scalars['String'];
};


export type ItManagementLegalEntityDocumentTemplateSettingsArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type ItManagementLegalEntityDocumentTemplateSettingsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<ItManagementLegalEntityDocumentTemplateSettingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ItManagementProductArgs = {
  id: Scalars['String'];
};


export type ItManagementProductsArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};


export type ItManagementProductsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<ItManagementProductFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

export type ItManagementMutations = {
  __typename?: 'itManagementMutations';
  bulkChangeOwnershipItmanagementItAsset: BulkChangeOwnershipItmanagementItAssetPayload;
  bulkDeleteItmanagementItAsset: BulkDeleteItmanagementItAssetPayload;
  changeOwnershipItmanagementItAsset: ChangeOwnershipItmanagementItAssetPayload;
  createItmanagementDocumentTemplate: CreateItmanagementDocumentTemplatePayload;
  createItmanagementItAsset: CreateItmanagementItAssetPayload;
  createItmanagementItAssetModel: CreateItmanagementItAssetModelPayload;
  createItmanagementOrder: CreateItmanagementOrderPayload;
  createManuallyItmanagementItAssetDocument: CreateManuallyItmanagementItAssetDocumentPayload;
  deleteItmanagementDocumentTemplate: DeleteItmanagementDocumentTemplatePayload;
  deleteItmanagementItAsset: DeleteItmanagementItAssetPayload;
  deleteItmanagementItAssetDocument: DeleteItmanagementItAssetDocumentPayload;
  importItmanagementItAsset: ImportItmanagementItAssetPayload;
  sendEmployeeDocumentTypeForSignatureItmanagementItAssetDocument: SendEmployeeDocumentTypeForSignatureItmanagementItAssetDocumentPayload;
  sendForSignatureItmanagementItAssetDocument: SendForSignatureItmanagementItAssetDocumentPayload;
  updateItmanagementDocumentTemplate: UpdateItmanagementDocumentTemplatePayload;
  updateItmanagementItAsset: UpdateItmanagementItAssetPayload;
  updateItmanagementItAssetModel: UpdateItmanagementItAssetModelPayload;
  upsertItmanagementLegalEntityDocumentTemplateSetting: UpsertItmanagementLegalEntityDocumentTemplateSettingPayload;
};


export type ItManagementMutationsBulkChangeOwnershipItmanagementItAssetArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  ids: Array<Scalars['String']>;
  locationId?: InputMaybe<Scalars['Int']>;
  ownerId?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<ItManagementValueObjectsItAssetStatusEnum>;
  teamId?: InputMaybe<Scalars['Int']>;
  workplaceId?: InputMaybe<Scalars['Int']>;
};


export type ItManagementMutationsBulkDeleteItmanagementItAssetArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  ids: Array<Scalars['String']>;
};


export type ItManagementMutationsChangeOwnershipItmanagementItAssetArgs = {
  id: Scalars['String'];
  locationId?: InputMaybe<Scalars['Int']>;
  ownerId?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<ItManagementValueObjectsItAssetStatusEnum>;
  teamId?: InputMaybe<Scalars['Int']>;
  workplaceId?: InputMaybe<Scalars['Int']>;
};


export type ItManagementMutationsCreateItmanagementDocumentTemplateArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  language?: InputMaybe<Scalars['String']>;
  languageSecond?: InputMaybe<Scalars['String']>;
  policyText?: InputMaybe<Scalars['String']>;
  policyTextSecondLanguage?: InputMaybe<Scalars['String']>;
  templateType: Scalars['String'];
  title: Scalars['String'];
  twoLanguages?: InputMaybe<Scalars['Boolean']>;
};


export type ItManagementMutationsCreateItmanagementItAssetArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  currency?: InputMaybe<Scalars['String']>;
  itAssetModelId: Scalars['String'];
  label?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['Int']>;
  notes?: InputMaybe<Scalars['String']>;
  ownerId?: InputMaybe<Scalars['Int']>;
  purchaseDate?: InputMaybe<Scalars['ISO8601Date']>;
  purchasePriceCents?: InputMaybe<Scalars['Int']>;
  serialNumber: Scalars['String'];
  teamId?: InputMaybe<Scalars['Int']>;
  warrantyEndDate?: InputMaybe<Scalars['ISO8601Date']>;
  workplaceId?: InputMaybe<Scalars['Int']>;
};


export type ItManagementMutationsCreateItmanagementItAssetModelArgs = {
  brand: Scalars['String'];
  companyId?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  typeName: Scalars['String'];
};


export type ItManagementMutationsCreateItmanagementOrderArgs = {
  companyId: Scalars['Int'];
  distributorOfferId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  employeeId: Scalars['Int'];
  notes: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  quantity: Scalars['Int'];
  variationId?: InputMaybe<Scalars['String']>;
};


export type ItManagementMutationsCreateManuallyItmanagementItAssetDocumentArgs = {
  document: Scalars['File'];
  itAssetId: Scalars['String'];
};


export type ItManagementMutationsDeleteItmanagementDocumentTemplateArgs = {
  id: Scalars['String'];
};


export type ItManagementMutationsDeleteItmanagementItAssetArgs = {
  id: Scalars['String'];
};


export type ItManagementMutationsDeleteItmanagementItAssetDocumentArgs = {
  id: Scalars['String'];
};


export type ItManagementMutationsImportItmanagementItAssetArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  currency?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['Int']>;
  modelBrand?: InputMaybe<Scalars['String']>;
  modelName?: InputMaybe<Scalars['String']>;
  modelTypeName?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  ownerId?: InputMaybe<Scalars['Int']>;
  purchaseDate?: InputMaybe<Scalars['ISO8601Date']>;
  purchasePriceCents?: InputMaybe<Scalars['Int']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  teamId?: InputMaybe<Scalars['Int']>;
  warrantyEndDate?: InputMaybe<Scalars['ISO8601Date']>;
  workplaceId?: InputMaybe<Scalars['Int']>;
};


export type ItManagementMutationsSendEmployeeDocumentTypeForSignatureItmanagementItAssetDocumentArgs = {
  companyId: Scalars['Int'];
  documentType: ItManagementValueObjectsItAssetDocumentTypeEnum;
  employeeId: Scalars['Int'];
};


export type ItManagementMutationsSendForSignatureItmanagementItAssetDocumentArgs = {
  companyId: Scalars['Int'];
  employeIds: Array<Scalars['Int']>;
};


export type ItManagementMutationsUpdateItmanagementDocumentTemplateArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  id: Scalars['String'];
  language?: InputMaybe<Scalars['String']>;
  languageSecond?: InputMaybe<Scalars['String']>;
  policyText?: InputMaybe<Scalars['String']>;
  policyTextSecondLanguage?: InputMaybe<Scalars['String']>;
  templateType?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  twoLanguages?: InputMaybe<Scalars['Boolean']>;
};


export type ItManagementMutationsUpdateItmanagementItAssetArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  currency?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  itAssetModelId?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['Int']>;
  notes?: InputMaybe<Scalars['String']>;
  ownerId?: InputMaybe<Scalars['Int']>;
  purchaseDate?: InputMaybe<Scalars['ISO8601Date']>;
  purchasePriceCents?: InputMaybe<Scalars['Int']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  teamId?: InputMaybe<Scalars['Int']>;
  warrantyEndDate?: InputMaybe<Scalars['ISO8601Date']>;
  workplaceId?: InputMaybe<Scalars['Int']>;
};


export type ItManagementMutationsUpdateItmanagementItAssetModelArgs = {
  brand: Scalars['String'];
  companyId?: InputMaybe<Scalars['Int']>;
  id: Scalars['String'];
  name: Scalars['String'];
  typeName: Scalars['String'];
};


export type ItManagementMutationsUpsertItmanagementLegalEntityDocumentTemplateSettingArgs = {
  assignedDocumentTemplateId?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  id?: InputMaybe<Scalars['String']>;
  legalEntityId: Scalars['Int'];
  unassignedDocumentTemplateId?: InputMaybe<Scalars['String']>;
};

export type JobCatalog = {
  __typename?: 'jobCatalog';
  _policies: JobCatalogContextlessPolicies;
  employeesSalaryRangesConformance?: Maybe<JobCatalogEmployeesSalaryRangesConformance>;
  /** @deprecated Please favor `employeesSalaryRangesConformancesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  employeesSalaryRangesConformances: Array<JobCatalogEmployeesSalaryRangesConformance>;
  employeesSalaryRangesConformancesConnection: JobCatalogEmployeesSalaryRangesConformanceConnection;
  expectation?: Maybe<JobCatalogExpectation>;
  /** @deprecated Please favor `expectationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  expectations: Array<JobCatalogExpectation>;
  expectationsConnection: JobCatalogExpectationConnection;
  level?: Maybe<JobCatalogLevel>;
  /** @deprecated Please favor `levelsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  levels: Array<JobCatalogLevel>;
  levelsConnection: JobCatalogLevelConnection;
  /** @deprecated Please favor `nodeAttributesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  nodeAttributes: Array<JobCatalogNodeAttribute>;
  nodeAttributesConnection: JobCatalogNodeAttributeConnection;
  /** @deprecated Please favor `peopleConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  people: Array<JobCatalogPerson>;
  peopleConnection: JobCatalogPersonConnection;
  role?: Maybe<JobCatalogRole>;
  /** @deprecated Please favor `roleCompetencySuggestionsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  roleCompetencySuggestions: Array<JobCatalogRoleCompetencySuggestion>;
  roleCompetencySuggestionsConnection: JobCatalogRoleCompetencySuggestionConnection;
  roleSalaryRangesConformance?: Maybe<JobCatalogRoleSalaryRangesConformance>;
  /** @deprecated Please favor `roleSalaryRangesConformancesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  roleSalaryRangesConformances: Array<JobCatalogRoleSalaryRangesConformance>;
  roleSalaryRangesConformancesConnection: JobCatalogRoleSalaryRangesConformanceConnection;
  /** @deprecated Please favor `rolesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  roles: Array<JobCatalogRole>;
  rolesConnection: JobCatalogRoleConnection;
  /** @deprecated Please favor `salariesDistributionsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  salariesDistributions: Array<JobCatalogSalariesDistribution>;
  salariesDistributionsConnection: JobCatalogSalariesDistributionConnection;
  salaryRange?: Maybe<JobCatalogSalaryRange>;
  /** @deprecated Please favor `salaryRangesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  salaryRanges: Array<JobCatalogSalaryRange>;
  salaryRangesConnection: JobCatalogSalaryRangeConnection;
  tree?: Maybe<JobCatalogTree>;
  treeLevel?: Maybe<JobCatalogTreeLevel>;
  /** @deprecated Please favor `treeLevelsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  treeLevels: Array<JobCatalogTreeLevel>;
  treeLevelsConnection: JobCatalogTreeLevelConnection;
  /** @deprecated Please favor `treeNodesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  treeNodes: Array<JobCatalogTreeNode>;
  treeNodesConnection: JobCatalogTreeNodeConnection;
  /** @deprecated Please favor `treesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  trees: Array<JobCatalogTree>;
  treesConnection: JobCatalogTreeConnection;
};


export type JobCatalogEmployeesSalaryRangesConformanceArgs = {
  id: Scalars['Int'];
};


export type JobCatalogEmployeesSalaryRangesConformancesArgs = {
  ids: Array<Scalars['Int']>;
};


export type JobCatalogEmployeesSalaryRangesConformancesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids: Array<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type JobCatalogExpectationArgs = {
  id: Scalars['Int'];
};


export type JobCatalogExpectationsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  levelIds?: InputMaybe<Array<Scalars['Int']>>;
  roleIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type JobCatalogExpectationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  levelIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  roleIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
};


export type JobCatalogLevelArgs = {
  id: Scalars['Int'];
};


export type JobCatalogLevelsArgs = {
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeArchived?: Scalars['Boolean'];
  includeArchivedRole?: Scalars['Boolean'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  roleIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type JobCatalogLevelsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeArchived?: Scalars['Boolean'];
  includeArchivedRole?: Scalars['Boolean'];
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  roleIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
};


export type JobCatalogNodeAttributesArgs = {
  attributeTypes?: InputMaybe<Array<JobCatalogEnumsJobCatalogTreeAttributeTypesEnum>>;
  includeArchivedNodes?: InputMaybe<Scalars['Boolean']>;
  includeInherited?: InputMaybe<Scalars['Boolean']>;
  includeOnlyOverriden?: InputMaybe<Scalars['Boolean']>;
  nodeUuid: Scalars['String'];
};


export type JobCatalogNodeAttributesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  attributeTypes?: InputMaybe<Array<JobCatalogEnumsJobCatalogTreeAttributeTypesEnum>>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  includeArchivedNodes?: InputMaybe<Scalars['Boolean']>;
  includeInherited?: InputMaybe<Scalars['Boolean']>;
  includeOnlyOverriden?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  nodeUuid: Scalars['String'];
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type JobCatalogPeopleArgs = {
  nodeUuid: Scalars['String'];
};


export type JobCatalogPeopleConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  nodeUuid: Scalars['String'];
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type JobCatalogRoleArgs = {
  id: Scalars['Int'];
};


export type JobCatalogRoleCompetencySuggestionsArgs = {
  companyId: Scalars['Int'];
  roleName: Scalars['String'];
};


export type JobCatalogRoleCompetencySuggestionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  roleName: Scalars['String'];
  sortOrder?: InputMaybe<Sort>;
};


export type JobCatalogRoleSalaryRangesConformanceArgs = {
  id: Scalars['Int'];
};


export type JobCatalogRoleSalaryRangesConformancesArgs = {
  ids: Array<Scalars['Int']>;
};


export type JobCatalogRoleSalaryRangesConformancesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids: Array<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type JobCatalogRolesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeArchived?: Scalars['Boolean'];
  jobCatalogLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  legalEntitiesIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type JobCatalogRolesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeArchived?: Scalars['Boolean'];
  jobCatalogLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntitiesIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type JobCatalogSalariesDistributionsArgs = {
  roleId: Scalars['Int'];
};


export type JobCatalogSalariesDistributionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  roleId: Scalars['Int'];
  sortOrder?: InputMaybe<Sort>;
};


export type JobCatalogSalaryRangeArgs = {
  id: Scalars['Int'];
};


export type JobCatalogSalaryRangesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  levelIds?: InputMaybe<Array<Scalars['Int']>>;
  roleId?: InputMaybe<Scalars['Int']>;
};


export type JobCatalogSalaryRangesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  levelIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  roleId?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type JobCatalogTreeArgs = {
  id: Scalars['Int'];
};


export type JobCatalogTreeLevelArgs = {
  id: Scalars['Int'];
};


export type JobCatalogTreeLevelsArgs = {
  familyIds?: InputMaybe<Array<Scalars['Int']>>;
  functionIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  roleIds?: InputMaybe<Array<Scalars['Int']>>;
  treeRootIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type JobCatalogTreeLevelsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  familyIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  functionIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  roleIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
  treeRootIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type JobCatalogTreeNodesArgs = {
  ancestorIds?: InputMaybe<Array<Scalars['Int']>>;
  ancestorUuids?: InputMaybe<Array<Scalars['String']>>;
  attributeTypeIds?: InputMaybe<Array<Scalars['String']>>;
  attributeTypes?: InputMaybe<Array<JobCatalogEnumsJobCatalogTreeAttributeTypesEnum>>;
  id?: InputMaybe<Scalars['Int']>;
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  includeFullPath?: InputMaybe<Scalars['Boolean']>;
  nodeType?: InputMaybe<JobCatalogEnumsJobCatalogTreeNodeTypesEnum>;
  nodeUuids?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  uuids?: InputMaybe<Array<Scalars['String']>>;
};


export type JobCatalogTreeNodesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  ancestorIds?: InputMaybe<Array<Scalars['Int']>>;
  ancestorUuids?: InputMaybe<Array<Scalars['String']>>;
  attributeTypeIds?: InputMaybe<Array<Scalars['String']>>;
  attributeTypes?: InputMaybe<Array<JobCatalogEnumsJobCatalogTreeAttributeTypesEnum>>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  includeFullPath?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  nodeType?: InputMaybe<JobCatalogEnumsJobCatalogTreeNodeTypesEnum>;
  nodeUuids?: InputMaybe<Array<Scalars['String']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  uuids?: InputMaybe<Array<Scalars['String']>>;
};


export type JobCatalogTreesArgs = {
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
};


export type JobCatalogTreesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

export type JobCatalogMutations = {
  __typename?: 'jobCatalogMutations';
  addCompetenciesJobcatalogRole: AddCompetenciesJobcatalogRolePayload;
  addCompetencyJobcatalogRole: AddCompetencyJobcatalogRolePayload;
  addLegalEntitiesJobcatalogRole: AddLegalEntitiesJobcatalogRolePayload;
  addSupervisorsJobcatalogRole: AddSupervisorsJobcatalogRolePayload;
  archiveJobcatalogLevel: ArchiveJobcatalogLevelPayload;
  archiveJobcatalogRole: ArchiveJobcatalogRolePayload;
  bulkAssignJobcatalogNodeAttribute: BulkAssignJobcatalogNodeAttributePayload;
  bulkCreateJobcatalogRole: BulkCreateJobcatalogRolePayload;
  bulkUpdateJobcatalogLevel: BulkUpdateJobcatalogLevelPayload;
  canDeleteJobcatalogTree: CanDeleteJobcatalogTreePayload;
  createJobcatalogLevel: CreateJobcatalogLevelPayload;
  createJobcatalogNodeAttribute: CreateJobcatalogNodeAttributePayload;
  createJobcatalogRole: CreateJobcatalogRolePayload;
  createJobcatalogSalaryRange: CreateJobcatalogSalaryRangePayload;
  createJobcatalogTree: CreateJobcatalogTreePayload;
  createJobcatalogTreeNode: CreateJobcatalogTreeNodePayload;
  deleteJobcatalogExpectation: DeleteJobcatalogExpectationPayload;
  deleteJobcatalogNodeAttribute: DeleteJobcatalogNodeAttributePayload;
  deleteJobcatalogTree: DeleteJobcatalogTreePayload;
  deleteJobcatalogTreeNode: DeleteJobcatalogTreeNodePayload;
  destroyJobcatalogLevel: DestroyJobcatalogLevelPayload;
  destroyJobcatalogRole: DestroyJobcatalogRolePayload;
  destroyJobcatalogSalaryRange: DestroyJobcatalogSalaryRangePayload;
  moveJobcatalogTreeNode: MoveJobcatalogTreeNodePayload;
  removeLegalEntityJobcatalogRole: RemoveLegalEntityJobcatalogRolePayload;
  removeSupervisorJobcatalogRole: RemoveSupervisorJobcatalogRolePayload;
  unarchiveJobcatalogLevel: UnarchiveJobcatalogLevelPayload;
  unarchiveJobcatalogRole: UnarchiveJobcatalogRolePayload;
  unassignCompetencyJobcatalogRole: UnassignCompetencyJobcatalogRolePayload;
  updateJobcatalogLevel: UpdateJobcatalogLevelPayload;
  updateJobcatalogNodeAttribute: UpdateJobcatalogNodeAttributePayload;
  updateJobcatalogRole: UpdateJobcatalogRolePayload;
  updateJobcatalogSalaryRange: UpdateJobcatalogSalaryRangePayload;
  updateJobcatalogTreeNode: UpdateJobcatalogTreeNodePayload;
  upsertJobcatalogExpectation: UpsertJobcatalogExpectationPayload;
};


export type JobCatalogMutationsAddCompetenciesJobcatalogRoleArgs = {
  competenciesIds: Array<Scalars['Int']>;
  id: Scalars['Int'];
};


export type JobCatalogMutationsAddCompetencyJobcatalogRoleArgs = {
  competencyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type JobCatalogMutationsAddLegalEntitiesJobcatalogRoleArgs = {
  id: Scalars['Int'];
  legalEntitiesIds: Array<Scalars['Int']>;
};


export type JobCatalogMutationsAddSupervisorsJobcatalogRoleArgs = {
  id: Scalars['Int'];
  supervisorsIds: Array<Scalars['Int']>;
};


export type JobCatalogMutationsArchiveJobcatalogLevelArgs = {
  id: Scalars['Int'];
};


export type JobCatalogMutationsArchiveJobcatalogRoleArgs = {
  id: Scalars['Int'];
};


export type JobCatalogMutationsBulkAssignJobcatalogNodeAttributeArgs = {
  attributeType: JobCatalogEnumsJobCatalogTreeAttributeTypesEnum;
  attributes?: InputMaybe<Array<BulkAssignJobcatalogNodeAttributeAttributesInput>>;
  attributesJson?: InputMaybe<Array<Scalars['String']>>;
  companyId: Scalars['Int'];
  nodeUuid: Scalars['String'];
};


export type JobCatalogMutationsBulkCreateJobcatalogRoleArgs = {
  roles: Array<BulkCreateJobcatalogRoleRolesInput>;
};


export type JobCatalogMutationsBulkUpdateJobcatalogLevelArgs = {
  changes: Array<BulkUpdateJobcatalogLevelChangesInput>;
};


export type JobCatalogMutationsCanDeleteJobcatalogTreeArgs = {
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type JobCatalogMutationsCreateJobcatalogLevelArgs = {
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  roleId: Scalars['Int'];
};


export type JobCatalogMutationsCreateJobcatalogNodeAttributeArgs = {
  attributeId?: InputMaybe<Scalars['String']>;
  attributeType: Scalars['String'];
  companyId: Scalars['Int'];
  effectiveDate?: InputMaybe<Scalars['ISO8601Date']>;
  inheritanceType?: InputMaybe<Scalars['String']>;
  nodeUuid?: InputMaybe<Scalars['String']>;
  treeNodeId?: InputMaybe<Scalars['Int']>;
  treeNodeType?: InputMaybe<JobCatalogEnumsJobCatalogTreeNodeTypesEnum>;
  valueCompetency?: InputMaybe<JobCatalogCompetencyAttributeInput>;
  valueItManagementAsset?: InputMaybe<JobCatalogItManagementAssetAttributeInput>;
  valueJson?: InputMaybe<Scalars['String']>;
  valueSalaryRange?: InputMaybe<JobCatalogSalaryRangeAttributeInput>;
  valueWorkingConditions?: InputMaybe<JobCatalogWorkingConditionsAttributeInput>;
};


export type JobCatalogMutationsCreateJobcatalogRoleArgs = {
  companyId: Scalars['Int'];
  description?: InputMaybe<Scalars['String']>;
  legalEntitiesIds: Array<Scalars['Int']>;
  levelNames?: InputMaybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  supervisorsIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type JobCatalogMutationsCreateJobcatalogSalaryRangeArgs = {
  amountType: Scalars['String'];
  currency: Scalars['String'];
  legalEntitiesIds: Array<Scalars['Int']>;
  levelId: Scalars['Int'];
  maxRange: Scalars['Int'];
  minRange: Scalars['Int'];
  salaryFrequency: Scalars['String'];
};


export type JobCatalogMutationsCreateJobcatalogTreeArgs = {
  companyId: Scalars['Int'];
  legalEntitiesIds?: InputMaybe<Array<Scalars['Int']>>;
  serializedTree: Scalars['String'];
};


export type JobCatalogMutationsCreateJobcatalogTreeNodeArgs = {
  companyId: Scalars['Int'];
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  parentId?: InputMaybe<Scalars['Int']>;
  treeNodeType: Scalars['String'];
};


export type JobCatalogMutationsDeleteJobcatalogExpectationArgs = {
  id: Scalars['String'];
};


export type JobCatalogMutationsDeleteJobcatalogNodeAttributeArgs = {
  id: Scalars['Int'];
  treeNodeId: Scalars['Int'];
  treeNodeType: JobCatalogEnumsJobCatalogTreeNodeTypesEnum;
};


export type JobCatalogMutationsDeleteJobcatalogTreeArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type JobCatalogMutationsDeleteJobcatalogTreeNodeArgs = {
  uuid: Scalars['String'];
};


export type JobCatalogMutationsDestroyJobcatalogLevelArgs = {
  id: Scalars['Int'];
};


export type JobCatalogMutationsDestroyJobcatalogRoleArgs = {
  id: Scalars['Int'];
};


export type JobCatalogMutationsDestroyJobcatalogSalaryRangeArgs = {
  id: Scalars['Int'];
};


export type JobCatalogMutationsMoveJobcatalogTreeNodeArgs = {
  companyId: Scalars['Int'];
  newParentUuid: Scalars['String'];
  nodeUuid: Scalars['String'];
};


export type JobCatalogMutationsRemoveLegalEntityJobcatalogRoleArgs = {
  id: Scalars['Int'];
  legalEntityId: Scalars['Int'];
};


export type JobCatalogMutationsRemoveSupervisorJobcatalogRoleArgs = {
  id: Scalars['Int'];
  supervisorId: Scalars['Int'];
};


export type JobCatalogMutationsUnarchiveJobcatalogLevelArgs = {
  id: Scalars['Int'];
};


export type JobCatalogMutationsUnarchiveJobcatalogRoleArgs = {
  id: Scalars['Int'];
};


export type JobCatalogMutationsUnassignCompetencyJobcatalogRoleArgs = {
  competencyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type JobCatalogMutationsUpdateJobcatalogLevelArgs = {
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
};


export type JobCatalogMutationsUpdateJobcatalogNodeAttributeArgs = {
  attributeId?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  effectiveDate?: InputMaybe<Scalars['ISO8601Date']>;
  id: Scalars['Int'];
  inheritanceType?: InputMaybe<Scalars['String']>;
  treeNodeId: Scalars['Int'];
  treeNodeType: JobCatalogEnumsJobCatalogTreeNodeTypesEnum;
  valueCompetency?: InputMaybe<JobCatalogCompetencyAttributeInput>;
  valueItManagementAsset?: InputMaybe<JobCatalogItManagementAssetAttributeInput>;
  valueJson?: InputMaybe<Scalars['String']>;
  valueSalaryRange?: InputMaybe<JobCatalogSalaryRangeAttributeInput>;
  valueWorkingConditions?: InputMaybe<JobCatalogWorkingConditionsAttributeInput>;
};


export type JobCatalogMutationsUpdateJobcatalogRoleArgs = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
};


export type JobCatalogMutationsUpdateJobcatalogSalaryRangeArgs = {
  amountType?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  legalEntitiesIds?: InputMaybe<Array<Scalars['Int']>>;
  maxRange?: InputMaybe<Scalars['Int']>;
  minRange?: InputMaybe<Scalars['Int']>;
  salaryFrequency?: InputMaybe<Scalars['String']>;
};


export type JobCatalogMutationsUpdateJobcatalogTreeNodeArgs = {
  attributesJson?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  nodeId: Scalars['Int'];
  nodeType: JobCatalogEnumsJobCatalogTreeNodeTypesEnum;
  parentId?: InputMaybe<Scalars['Int']>;
};


export type JobCatalogMutationsUpsertJobcatalogExpectationArgs = {
  competencyId: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  levelId: Scalars['String'];
};

/** Payload for job_posting and subscription: generate_draft */
export type Job_Posting_Generate_Draft_Type = {
  __typename?: 'job_posting_generate_draft_type';
  description?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
};

export type Kudos = {
  __typename?: 'kudos';
  _policies: KudosContextlessPolicies;
  /** @deprecated Please favor `kudosLeaderboardsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  kudosLeaderboards: Array<KudosKudosLeaderboard>;
  kudosLeaderboardsConnection: KudosKudosLeaderboardConnection;
  /** @deprecated Please favor `kudosReceivedsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  kudosReceiveds: Array<KudosKudosReceived>;
  kudosReceivedsConnection: KudosKudosReceivedConnection;
  /** @deprecated Please favor `kudosSentsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  kudosSents: Array<KudosKudosSent>;
  kudosSentsConnection: KudosKudosSentConnection;
};


export type KudosKudosLeaderboardsArgs = {
  from?: InputMaybe<Scalars['ISO8601Date']>;
  to?: InputMaybe<Scalars['ISO8601Date']>;
};


export type KudosKudosLeaderboardsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['ISO8601Date']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  to?: InputMaybe<Scalars['ISO8601Date']>;
};


export type KudosKudosReceivedsArgs = {
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
};


export type KudosKudosReceivedsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
};


export type KudosKudosSentsArgs = {
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
};


export type KudosKudosSentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
};

export type KudosMutations = {
  __typename?: 'kudosMutations';
  createKudosKudosSent: CreateKudosKudosSentPayload;
};


export type KudosMutationsCreateKudosKudosSentArgs = {
  message: Scalars['String'];
  receiverId: Scalars['Int'];
};

export type Layout = {
  __typename?: 'layout';
  favourite?: Maybe<LayoutFavourite>;
  /** @deprecated Please favor `favouritesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  favourites: Array<LayoutFavourite>;
  favouritesConnection: LayoutFavouriteConnection;
};


export type LayoutFavouriteArgs = {
  id: Scalars['Int'];
};


export type LayoutFavouritesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type LayoutFavouritesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

export type LayoutMutations = {
  __typename?: 'layoutMutations';
  createLayoutFavourite: CreateLayoutFavouritePayload;
  deleteLayoutFavourite: DeleteLayoutFavouritePayload;
  moveLayoutFavourite: MoveLayoutFavouritePayload;
  reorderLayoutFavourite: ReorderLayoutFavouritePayload;
  updateLayoutFavourite: UpdateLayoutFavouritePayload;
};


export type LayoutMutationsCreateLayoutFavouriteArgs = {
  avatar?: InputMaybe<Scalars['String']>;
  avatarType?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  icon: Scalars['String'];
  label: Scalars['String'];
  url: Scalars['String'];
};


export type LayoutMutationsDeleteLayoutFavouriteArgs = {
  id: Scalars['Int'];
};


export type LayoutMutationsMoveLayoutFavouriteArgs = {
  direction: LayoutValueObjectsFavouritesDirectionEnum;
  id: Scalars['Int'];
};


export type LayoutMutationsReorderLayoutFavouriteArgs = {
  ids: Array<Scalars['Int']>;
};


export type LayoutMutationsUpdateLayoutFavouriteArgs = {
  avatar?: InputMaybe<Scalars['String']>;
  avatarType?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  icon: Scalars['String'];
  id: Scalars['Int'];
  label: Scalars['String'];
  url: Scalars['String'];
};

export type Locations = {
  __typename?: 'locations';
  _policies: LocationsContextlessPolicies;
  /** @deprecated Please favor `employeesLocationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  employeesLocations: Array<LocationsEmployeesLocation>;
  employeesLocationsConnection: LocationsEmployeesLocationConnection;
  location?: Maybe<LocationsLocation>;
  /** @deprecated Please favor `locationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  locations: Array<LocationsLocation>;
  locationsConnection: LocationsLocationConnection;
  workArea?: Maybe<LocationsWorkArea>;
  /** @deprecated Please favor `workAreasConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  workAreas: Array<LocationsWorkArea>;
  workAreasConnection: LocationsWorkAreaConnection;
};


export type LocationsEmployeesLocationsArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type LocationsEmployeesLocationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type LocationsLocationArgs = {
  id: Scalars['Int'];
};


export type LocationsLocationsArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  main?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};


export type LocationsLocationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  main?: InputMaybe<Scalars['Boolean']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type LocationsWorkAreaArgs = {
  id: Scalars['Int'];
};


export type LocationsWorkAreasArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  onlyNonArchived?: Scalars['Boolean'];
};


export type LocationsWorkAreasConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyNonArchived?: Scalars['Boolean'];
  sortOrder?: InputMaybe<Sort>;
};

export type LocationsMutations = {
  __typename?: 'locationsMutations';
  archiveLocationsWorkArea: ArchiveLocationsWorkAreaPayload;
  bulkAssignLocationsEmployeesLocation: BulkAssignLocationsEmployeesLocationPayload;
  createLocationsLocation: CreateLocationsLocationPayload;
  createLocationsWorkArea: CreateLocationsWorkAreaPayload;
  deleteLocationsLocation: DeleteLocationsLocationPayload;
  unarchiveLocationsWorkArea: UnarchiveLocationsWorkAreaPayload;
  unassignLocationsEmployeesLocation: UnassignLocationsEmployeesLocationPayload;
  updateLocationsLocation: UpdateLocationsLocationPayload;
  updateLocationsWorkArea: UpdateLocationsWorkAreaPayload;
};


export type LocationsMutationsArchiveLocationsWorkAreaArgs = {
  id: Scalars['Int'];
};


export type LocationsMutationsBulkAssignLocationsEmployeesLocationArgs = {
  employeeId: Scalars['Int'];
  locationIds: Array<Scalars['Int']>;
};


export type LocationsMutationsCreateLocationsLocationArgs = {
  addressLineOne?: InputMaybe<Scalars['String']>;
  addressLineTwo?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  country: Scalars['String'];
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  main?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  radius?: InputMaybe<Scalars['Float']>;
  siret?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  timezone: Scalars['String'];
};


export type LocationsMutationsCreateLocationsWorkAreaArgs = {
  locationId: Scalars['Int'];
  name: Scalars['String'];
};


export type LocationsMutationsDeleteLocationsLocationArgs = {
  id: Scalars['Int'];
};


export type LocationsMutationsUnarchiveLocationsWorkAreaArgs = {
  id: Scalars['Int'];
};


export type LocationsMutationsUnassignLocationsEmployeesLocationArgs = {
  employeeId: Scalars['Int'];
  locationId: Scalars['Int'];
};


export type LocationsMutationsUpdateLocationsLocationArgs = {
  addressLineOne?: InputMaybe<Scalars['String']>;
  addressLineTwo?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  main?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  radius?: InputMaybe<Scalars['Float']>;
  siret?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


export type LocationsMutationsUpdateLocationsWorkAreaArgs = {
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type Marketing = {
  __typename?: 'marketing';
  /** @deprecated Please favor `userSegmentationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  userSegmentations: Array<MarketingUserSegmentation>;
  userSegmentationsConnection: MarketingUserSegmentationConnection;
};


export type MarketingUserSegmentationsArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  signupEmail?: InputMaybe<Scalars['String']>;
};


export type MarketingUserSegmentationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  signupEmail?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};

export type MarketingMutations = {
  __typename?: 'marketingMutations';
  createMarketingTrialAction: CreateMarketingTrialActionPayload;
  createMarketingUserSegmentation: CreateMarketingUserSegmentationPayload;
};


export type MarketingMutationsCreateMarketingTrialActionArgs = {
  droppedBillingStep: Scalars['Boolean'];
  reason?: InputMaybe<Scalars['String']>;
  reasonOther?: InputMaybe<Scalars['String']>;
};


export type MarketingMutationsCreateMarketingUserSegmentationArgs = {
  context: Scalars['String'];
  exploreFirst: Scalars['String'];
  locale: Scalars['String'];
  signupEmail: Scalars['String'];
};

export type Marketplace = {
  __typename?: 'marketplace';
  _policies: MarketplaceContextlessPolicies;
  /** @deprecated Please favor `companyInstallationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  companyInstallations: Array<MarketplaceCompanyInstallation>;
  companyInstallationsConnection: MarketplaceCompanyInstallationConnection;
  dbIntegration?: Maybe<MarketplaceDbIntegration>;
  /** @deprecated Please favor `dbIntegrationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  dbIntegrations: Array<MarketplaceDbIntegration>;
  dbIntegrationsConnection: MarketplaceDbIntegrationConnection;
  /** @deprecated Please favor `formQuestionsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  formQuestions: Array<MarketplaceFormQuestion>;
  formQuestionsConnection: MarketplaceFormQuestionConnection;
  /** @deprecated Please favor `installationSettingsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  installationSettings: Array<MarketplaceInstallationSetting>;
  installationSettingsConnection: MarketplaceInstallationSettingConnection;
  /** @deprecated Please favor `integrationCountriesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  integrationCountries: Array<MarketplaceIntegrationCountry>;
  integrationCountriesConnection: MarketplaceIntegrationCountryConnection;
  integrationCountry?: Maybe<MarketplaceIntegrationCountry>;
  /** @deprecated Please favor `integrationUpsellsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  integrationUpsells: Array<MarketplaceIntegrationUpsell>;
  integrationUpsellsConnection: MarketplaceIntegrationUpsellConnection;
  /** @deprecated Please favor `integrationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  integrations: Array<MarketplaceIntegration>;
  integrationsConnection: MarketplaceIntegrationConnection;
  /** @deprecated Please favor `settingsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  settings: Array<MarketplaceSetting>;
  settingsConnection: MarketplaceSettingConnection;
};


export type MarketplaceCompanyInstallationsArgs = {
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  integrationDatoIds?: InputMaybe<Array<Scalars['String']>>;
  integrationIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type MarketplaceCompanyInstallationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  integrationDatoIds?: InputMaybe<Array<Scalars['String']>>;
  integrationIds?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type MarketplaceDbIntegrationArgs = {
  id: Scalars['Int'];
};


export type MarketplaceDbIntegrationsArgs = {
  datoIds?: InputMaybe<Array<Scalars['String']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  uuids?: InputMaybe<Array<Scalars['String']>>;
};


export type MarketplaceDbIntegrationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  datoIds?: InputMaybe<Array<Scalars['String']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  uuids?: InputMaybe<Array<Scalars['String']>>;
};


export type MarketplaceFormQuestionsArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  companyId: Scalars['Int'];
  integrationId: Scalars['Int'];
};


export type MarketplaceFormQuestionsConnectionArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  integrationId: Scalars['Int'];
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type MarketplaceInstallationSettingsArgs = {
  companyId: Scalars['Int'];
  integrationId: Scalars['String'];
};


export type MarketplaceInstallationSettingsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  integrationId: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type MarketplaceIntegrationCountriesArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
  locale?: InputMaybe<Scalars['String']>;
};


export type MarketplaceIntegrationCountriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type MarketplaceIntegrationCountryArgs = {
  id: Scalars['String'];
};


export type MarketplaceIntegrationUpsellsArgs = {
  integrationDatoIds?: InputMaybe<Array<Scalars['String']>>;
  locale?: InputMaybe<Scalars['String']>;
};


export type MarketplaceIntegrationUpsellsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  integrationDatoIds?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type MarketplaceIntegrationsArgs = {
  datoIds?: InputMaybe<Array<Scalars['String']>>;
  locale?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  uuids?: InputMaybe<Array<Scalars['String']>>;
};


export type MarketplaceIntegrationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  datoIds?: InputMaybe<Array<Scalars['String']>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  uuids?: InputMaybe<Array<Scalars['String']>>;
};


export type MarketplaceSettingsArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  companyId: Scalars['Int'];
  integrationId: Scalars['Int'];
};


export type MarketplaceSettingsConnectionArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  integrationId: Scalars['Int'];
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

export type MarketplaceMutations = {
  __typename?: 'marketplaceMutations';
  createMarketplaceCompanyInstallation: CreateMarketplaceCompanyInstallationPayload;
  deleteMarketplaceCompanyInstallation: DeleteMarketplaceCompanyInstallationPayload;
  installationExistsMarketplaceCompanyInstallation: InstallationExistsMarketplaceCompanyInstallationPayload;
  invalidateFormDataMarketplaceCompanyInstallation: InvalidateFormDataMarketplaceCompanyInstallationPayload;
  updateMarketplaceCompanyInstallation: UpdateMarketplaceCompanyInstallationPayload;
};


export type MarketplaceMutationsCreateMarketplaceCompanyInstallationArgs = {
  accessId: Scalars['Int'];
  companyId: Scalars['Int'];
  integrationId: Scalars['Int'];
};


export type MarketplaceMutationsDeleteMarketplaceCompanyInstallationArgs = {
  accessId: Scalars['Int'];
  companyId: Scalars['Int'];
  integrationId: Scalars['Int'];
};


export type MarketplaceMutationsInstallationExistsMarketplaceCompanyInstallationArgs = {
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  integrationDatoIds?: InputMaybe<Array<Scalars['String']>>;
  integrationIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type MarketplaceMutationsInvalidateFormDataMarketplaceCompanyInstallationArgs = {
  companyId: Scalars['Int'];
  integrationDatoId: Scalars['String'];
  notify?: InputMaybe<Scalars['Boolean']>;
};


export type MarketplaceMutationsUpdateMarketplaceCompanyInstallationArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  companyId: Scalars['Int'];
  integrationId: Scalars['Int'];
};

export type Meetings = {
  __typename?: 'meetings';
  _policies: MeetingsContextlessPolicies;
  attendee?: Maybe<MeetingsAttendee>;
  /** @deprecated Please favor `attendeesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  attendees: Array<MeetingsAttendee>;
  attendeesConnection: MeetingsAttendeeConnection;
  meeting?: Maybe<MeetingsMeeting>;
  /** @deprecated Please favor `meetingsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  meetings: Array<MeetingsMeeting>;
  meetingsConnection: MeetingsMeetingConnection;
  /** @deprecated Please favor `scheduledMeetingsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  scheduledMeetings: Array<MeetingsScheduledMeeting>;
  scheduledMeetingsConnection: MeetingsScheduledMeetingConnection;
  setting?: Maybe<MeetingsSetting>;
  /** @deprecated Please favor `settingsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  settings: Array<MeetingsSetting>;
  settingsConnection: MeetingsSettingConnection;
  template?: Maybe<MeetingsTemplate>;
  templateAttendee?: Maybe<MeetingsTemplateAttendee>;
  /** @deprecated Please favor `templateAttendeesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  templateAttendees: Array<MeetingsTemplateAttendee>;
  templateAttendeesConnection: MeetingsTemplateAttendeeConnection;
  /** @deprecated Please favor `templatesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  templates: Array<MeetingsTemplate>;
  templatesConnection: MeetingsTemplateConnection;
  transcript?: Maybe<MeetingsTranscript>;
  transcriptionSession?: Maybe<MeetingsTranscriptionSession>;
  /** @deprecated Please favor `transcriptionSessionsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  transcriptionSessions: Array<MeetingsTranscriptionSession>;
  transcriptionSessionsConnection: MeetingsTranscriptionSessionConnection;
  /** @deprecated Please favor `transcriptsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  transcripts: Array<MeetingsTranscript>;
  transcriptsConnection: MeetingsTranscriptConnection;
};


export type MeetingsAttendeeArgs = {
  id: Scalars['Int'];
};


export type MeetingsAttendeesArgs = {
  employeeId?: InputMaybe<Scalars['Int']>;
  ids?: Array<Scalars['Int']>;
  meetingId?: InputMaybe<Scalars['Int']>;
  pageId?: InputMaybe<Scalars['Int']>;
  sharedWithEmployeeId?: InputMaybe<Scalars['Int']>;
};


export type MeetingsAttendeesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: Array<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  meetingId?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  pageId?: InputMaybe<Scalars['Int']>;
  sharedWithEmployeeId?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type MeetingsMeetingArgs = {
  id: Scalars['Int'];
};


export type MeetingsMeetingsArgs = {
  attendeeEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: Array<Scalars['Int']>;
  organizerEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


export type MeetingsMeetingsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  attendeeEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<MeetingsMeetingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: Array<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  organizerEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type MeetingsScheduledMeetingsArgs = {
  attendeeEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  exactAttendeeMatch?: Scalars['Boolean'];
  meetingTypes?: InputMaybe<Array<Scalars['String']>>;
  organizerEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  templateIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type MeetingsScheduledMeetingsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  attendeeEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  exactAttendeeMatch?: Scalars['Boolean'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  meetingTypes?: InputMaybe<Array<Scalars['String']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  organizerEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  templateIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type MeetingsSettingArgs = {
  id: Scalars['Int'];
};


export type MeetingsSettingsArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  meetingType?: InputMaybe<Scalars['String']>;
};


export type MeetingsSettingsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  meetingType?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type MeetingsTemplateArgs = {
  id: Scalars['String'];
};


export type MeetingsTemplateAttendeeArgs = {
  id: Scalars['Int'];
};


export type MeetingsTemplateAttendeesArgs = {
  email?: InputMaybe<Scalars['String']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  ids?: Array<Scalars['Int']>;
  templateId?: InputMaybe<Scalars['Int']>;
};


export type MeetingsTemplateAttendeesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: Array<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  templateId?: InputMaybe<Scalars['Int']>;
};


export type MeetingsTemplatesArgs = {
  ids?: Array<Scalars['String']>;
  organizerEmployeeIds?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
};


export type MeetingsTemplatesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: Array<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  organizerEmployeeIds?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type MeetingsTranscriptArgs = {
  id: Scalars['Int'];
  meetingId: Scalars['Int'];
};


export type MeetingsTranscriptionSessionArgs = {
  id: Scalars['Int'];
};


export type MeetingsTranscriptionSessionsArgs = {
  attendeeId?: InputMaybe<Scalars['Int']>;
  ids: Array<Scalars['Int']>;
};


export type MeetingsTranscriptionSessionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  attendeeId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids: Array<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type MeetingsTranscriptsArgs = {
  ids?: Array<Scalars['Int']>;
  meetingId: Scalars['Int'];
};


export type MeetingsTranscriptsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: Array<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  meetingId: Scalars['Int'];
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

export type MeetingsMutations = {
  __typename?: 'meetingsMutations';
  addAudioChunkMeetingsTranscriptionSession: AddAudioChunkMeetingsTranscriptionSessionPayload;
  bulkCreateMeetingsAttendee: BulkCreateMeetingsAttendeePayload;
  bulkDeleteMeetingsAttendee: BulkDeleteMeetingsAttendeePayload;
  createMeetingsMeeting: CreateMeetingsMeetingPayload;
  createMeetingsSetting: CreateMeetingsSettingPayload;
  createMeetingsTemplate: CreateMeetingsTemplatePayload;
  createMeetingsTranscriptionSession: CreateMeetingsTranscriptionSessionPayload;
  deleteMeetingsMeeting: DeleteMeetingsMeetingPayload;
  deleteMeetingsTemplate: DeleteMeetingsTemplatePayload;
  generateMeetingsAiSummary: GenerateMeetingsAiSummaryPayload;
  generateMeetingsChat: GenerateMeetingsChatPayload;
  generateMeetingsGoldLayer: GenerateMeetingsGoldLayerPayload;
  generateMeetingsLiveCompanion: GenerateMeetingsLiveCompanionPayload;
  getOrCreateFromTemplateMeetingsMeeting: GetOrCreateFromTemplateMeetingsMeetingPayload;
  getOrCreateMeetingsRoom: GetOrCreateMeetingsRoomPayload;
  importCsvMeetingsImport: ImportCsvMeetingsImportPayload;
  updateMeetingsAttendee: UpdateMeetingsAttendeePayload;
  updateMeetingsMeeting: UpdateMeetingsMeetingPayload;
  updateMeetingsSetting: UpdateMeetingsSettingPayload;
  updateMeetingsTemplate: UpdateMeetingsTemplatePayload;
};


export type MeetingsMutationsAddAudioChunkMeetingsTranscriptionSessionArgs = {
  attendeeId: Scalars['Int'];
  audioChunk: Scalars['String'];
  sessionId: Scalars['Int'];
  timestamp: Scalars['Int'];
};


export type MeetingsMutationsBulkCreateMeetingsAttendeeArgs = {
  attendeesEmployeeIds: Array<Scalars['Int']>;
  externalUsersEmails: Array<Scalars['String']>;
  meetingId: Scalars['Int'];
};


export type MeetingsMutationsBulkDeleteMeetingsAttendeeArgs = {
  ids: Array<Scalars['Int']>;
};


export type MeetingsMutationsCreateMeetingsMeetingArgs = {
  attendeeIds?: InputMaybe<Array<Scalars['Int']>>;
  date: Scalars['ISO8601Date'];
  description?: InputMaybe<Scalars['String']>;
  endTime: Scalars['ISO8601DateTime'];
  meetingType?: InputMaybe<Scalars['String']>;
  skipCalendarEvent?: InputMaybe<Scalars['Boolean']>;
  startTime: Scalars['ISO8601DateTime'];
  templateId?: InputMaybe<Scalars['Int']>;
  timezone?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};


export type MeetingsMutationsCreateMeetingsSettingArgs = {
  companyId: Scalars['Int'];
  meetingType: Scalars['String'];
  transcriptExpirationTime: Scalars['Int'];
};


export type MeetingsMutationsCreateMeetingsTemplateArgs = {
  attendeeIds?: InputMaybe<Array<Scalars['Int']>>;
  byDay?: InputMaybe<Scalars['String']>;
  count?: InputMaybe<Scalars['Int']>;
  date: Scalars['ISO8601Date'];
  description?: InputMaybe<Scalars['String']>;
  endTime: Scalars['ISO8601DateTime'];
  frequency?: InputMaybe<Scalars['String']>;
  interval?: InputMaybe<Scalars['Int']>;
  meetingType?: InputMaybe<Scalars['String']>;
  skipCalendarEvent?: InputMaybe<Scalars['Boolean']>;
  startTime: Scalars['ISO8601DateTime'];
  timezone?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  until?: InputMaybe<Scalars['ISO8601DateTime']>;
};


export type MeetingsMutationsCreateMeetingsTranscriptionSessionArgs = {
  attendeeId: Scalars['Int'];
  inPerson: Scalars['Boolean'];
};


export type MeetingsMutationsDeleteMeetingsMeetingArgs = {
  id: Scalars['Int'];
};


export type MeetingsMutationsDeleteMeetingsTemplateArgs = {
  date?: InputMaybe<Scalars['ISO8601Date']>;
  deletionType?: InputMaybe<MeetingsValueObjectsDeletionTypeEnum>;
  id: Scalars['Int'];
};


export type MeetingsMutationsGenerateMeetingsAiSummaryArgs = {
  meetingId: Scalars['Int'];
  templateType: Scalars['String'];
};


export type MeetingsMutationsGenerateMeetingsChatArgs = {
  meetingId: Scalars['Int'];
  messageHistory: Array<Scalars['String']>;
  roleHistory: Array<Scalars['String']>;
  threadId: Scalars['String'];
};


export type MeetingsMutationsGenerateMeetingsGoldLayerArgs = {
  meetingId: Scalars['Int'];
};


export type MeetingsMutationsGenerateMeetingsLiveCompanionArgs = {
  meetingId: Scalars['Int'];
};


export type MeetingsMutationsGetOrCreateFromTemplateMeetingsMeetingArgs = {
  templateId: Scalars['Int'];
  timestamp: Scalars['ISO8601DateTime'];
};


export type MeetingsMutationsGetOrCreateMeetingsRoomArgs = {
  inPerson: Scalars['Boolean'];
  meetingId: Scalars['Int'];
};


export type MeetingsMutationsImportCsvMeetingsImportArgs = {
  csvContent: Scalars['String'];
};


export type MeetingsMutationsUpdateMeetingsAttendeeArgs = {
  email?: InputMaybe<Scalars['String']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  status?: InputMaybe<Scalars['String']>;
};


export type MeetingsMutationsUpdateMeetingsMeetingArgs = {
  attendeeIds?: InputMaybe<Array<Scalars['Int']>>;
  date?: InputMaybe<Scalars['ISO8601Date']>;
  description?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  meetingType?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};


export type MeetingsMutationsUpdateMeetingsSettingArgs = {
  id: Scalars['Int'];
  transcriptExpirationTime?: InputMaybe<Scalars['Int']>;
};


export type MeetingsMutationsUpdateMeetingsTemplateArgs = {
  attendeeIds?: InputMaybe<Array<Scalars['Int']>>;
  byDay?: InputMaybe<Scalars['String']>;
  count?: InputMaybe<Scalars['Int']>;
  date?: InputMaybe<Scalars['ISO8601Date']>;
  description?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<Scalars['String']>;
  frequency?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  interval?: InputMaybe<Scalars['Int']>;
  meetingType?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  until?: InputMaybe<Scalars['ISO8601DateTime']>;
};

export type Modules = {
  __typename?: 'modules';
  _policies: ModulesContextlessPolicies;
  datoModule?: Maybe<ModulesDatoModule>;
  /** @deprecated Please favor `datoModulesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  datoModules: Array<ModulesDatoModule>;
  datoModulesConnection: ModulesDatoModuleConnection;
  /** @deprecated Please favor `moduleRequestsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  moduleRequests: Array<ModulesModuleRequest>;
  moduleRequestsConnection: ModulesModuleRequestConnection;
};


export type ModulesDatoModuleArgs = {
  id: Scalars['String'];
};


export type ModulesDatoModulesArgs = {
  chargebeeModuleName?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  hubspotModuleName?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  showHiddenModules?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  slugs?: InputMaybe<Array<Scalars['String']>>;
};


export type ModulesDatoModulesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  chargebeeModuleName?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  hubspotModuleName?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  showHiddenModules?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  slugs?: InputMaybe<Array<Scalars['String']>>;
  sortOrder?: InputMaybe<Sort>;
};


export type ModulesModuleRequestsArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  moduleName?: InputMaybe<Scalars['String']>;
};


export type ModulesModuleRequestsConnectionArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  moduleName?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

export type ModulesMutations = {
  __typename?: 'modulesMutations';
  createModulesEmailModuleRequest: CreateModulesEmailModuleRequestPayload;
  createModulesModuleRequest: CreateModulesModuleRequestPayload;
};


export type ModulesMutationsCreateModulesEmailModuleRequestArgs = {
  moduleName: Scalars['String'];
  queryParam?: InputMaybe<Scalars['String']>;
};


export type ModulesMutationsCreateModulesModuleRequestArgs = {
  moduleName: Scalars['String'];
};

export type Notifications = {
  __typename?: 'notifications';
  _policies: NotificationsContextlessPolicies;
  /** @deprecated Please favor `accessNotificationSettingsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  accessNotificationSettings: Array<NotificationsAccessNotificationSetting>;
  accessNotificationSettingsConnection: NotificationsAccessNotificationSettingConnection;
  /** @deprecated Please favor `accessNotifierScopesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  accessNotifierScopes: Array<NotificationsAccessNotifierScope>;
  accessNotifierScopesConnection: NotificationsAccessNotifierScopeConnection;
  inboxNotification?: Maybe<NotificationsInboxNotification>;
  /** @deprecated Please favor `inboxNotificationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  inboxNotifications: Array<NotificationsInboxNotification>;
  inboxNotificationsConnection: NotificationsInboxNotificationConnection;
  /** @deprecated Please favor `requestsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  requests: Array<NotificationsRequest>;
  requestsConnection: NotificationsRequestConnection;
};


export type NotificationsAccessNotificationSettingsArgs = {
  accessId: Scalars['Int'];
};


export type NotificationsAccessNotificationSettingsConnectionArgs = {
  accessId: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type NotificationsAccessNotifierScopesArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
};


export type NotificationsAccessNotifierScopesConnectionArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type NotificationsInboxNotificationArgs = {
  id: Scalars['Int'];
};


export type NotificationsInboxNotificationsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  notifier?: InputMaybe<Scalars['String']>;
  onlyUnread?: InputMaybe<Scalars['Boolean']>;
  recipientId?: InputMaybe<Scalars['Int']>;
};


export type NotificationsInboxNotificationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<NotificationsInboxNotificationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  notifier?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyUnread?: InputMaybe<Scalars['Boolean']>;
  recipientId?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type NotificationsRequestsArgs = {
  recipientId?: InputMaybe<Scalars['Int']>;
};


export type NotificationsRequestsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  recipientId?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

export type NotificationsMutations = {
  __typename?: 'notificationsMutations';
  markAsClickedNotificationsInboxNotification: MarkAsClickedNotificationsInboxNotificationPayload;
  markAsReadNotificationsInboxNotification: MarkAsReadNotificationsInboxNotificationPayload;
  markAsUnreadNotificationsInboxNotification: MarkAsUnreadNotificationsInboxNotificationPayload;
  updateNotificationsAccessNotificationSetting: UpdateNotificationsAccessNotificationSettingPayload;
  updateNotificationsAccessNotifierScope: UpdateNotificationsAccessNotifierScopePayload;
};


export type NotificationsMutationsMarkAsClickedNotificationsInboxNotificationArgs = {
  id: Scalars['Int'];
  recipientId?: InputMaybe<Scalars['Int']>;
};


export type NotificationsMutationsMarkAsReadNotificationsInboxNotificationArgs = {
  recipientId?: InputMaybe<Scalars['Int']>;
  sinceId: Scalars['Int'];
  untilId?: InputMaybe<Scalars['Int']>;
};


export type NotificationsMutationsMarkAsUnreadNotificationsInboxNotificationArgs = {
  id: Scalars['Int'];
  recipientId?: InputMaybe<Scalars['Int']>;
};


export type NotificationsMutationsUpdateNotificationsAccessNotificationSettingArgs = {
  accessId: Scalars['Int'];
  disableAll?: InputMaybe<Scalars['Boolean']>;
};


export type NotificationsMutationsUpdateNotificationsAccessNotifierScopeArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  notifier: Scalars['String'];
  value: Scalars['String'];
};

export type Nps = {
  __typename?: 'nps';
  _policies: NpsContextlessPolicies;
  surveyResponse?: Maybe<NpsSurveyResponse>;
  surveyResponseIntent?: Maybe<NpsSurveyResponseIntent>;
  /** @deprecated Please favor `surveyResponseIntentsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  surveyResponseIntents: Array<NpsSurveyResponseIntent>;
  surveyResponseIntentsConnection: NpsSurveyResponseIntentConnection;
  /** @deprecated Please favor `surveyResponsesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  surveyResponses: Array<NpsSurveyResponse>;
  surveyResponsesConnection: NpsSurveyResponseConnection;
  /** @deprecated Please favor `widgetVisibilitiesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  widgetVisibilities: Array<NpsWidgetVisibility>;
  widgetVisibilitiesConnection: NpsWidgetVisibilityConnection;
  widgetVisibility?: Maybe<NpsWidgetVisibility>;
};


export type NpsSurveyResponseArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type NpsSurveyResponseIntentArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type NpsSurveyResponseIntentsArgs = {
  companyId: Scalars['Int'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  surveyResponseIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type NpsSurveyResponseIntentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  surveyResponseIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type NpsSurveyResponsesArgs = {
  companyId: Scalars['Int'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type NpsSurveyResponsesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type NpsWidgetVisibilitiesArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
  origin?: InputMaybe<Scalars['String']>;
};


export type NpsWidgetVisibilitiesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  origin?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type NpsWidgetVisibilityArgs = {
  id: Scalars['String'];
};

export type NpsMutations = {
  __typename?: 'npsMutations';
  createNpsSurveyResponse: CreateNpsSurveyResponsePayload;
  createNpsSurveyResponseIntent: CreateNpsSurveyResponseIntentPayload;
  updateNpsSurveyResponseIntent: UpdateNpsSurveyResponseIntentPayload;
};


export type NpsMutationsCreateNpsSurveyResponseArgs = {
  authorId: Scalars['Int'];
  companyId: Scalars['Int'];
  feedback?: InputMaybe<Scalars['String']>;
  score?: InputMaybe<Scalars['Int']>;
  source?: InputMaybe<Scalars['String']>;
  survey: Scalars['String'];
};


export type NpsMutationsCreateNpsSurveyResponseIntentArgs = {
  companyId: Scalars['Int'];
  origin: Scalars['String'];
  surveyResponseId?: InputMaybe<Scalars['String']>;
};


export type NpsMutationsUpdateNpsSurveyResponseIntentArgs = {
  id?: InputMaybe<Scalars['Int']>;
  surveyResponseId: Scalars['Int'];
};

export type OauthApplicationPolicy = {
  __typename?: 'oauthApplicationPolicy';
  _policies: OauthApplicationPolicyContextlessPolicies;
};

export type Onboarding = {
  __typename?: 'onboarding';
  _policies: OnboardingContextlessPolicies;
};

export type OnboardingImporter = {
  __typename?: 'onboardingImporter';
  _policies: OnboardingImporterContextlessPolicies;
};

export type OneAgentSteering = {
  __typename?: 'oneAgentSteering';
  canonicalAnswer?: Maybe<OneAgentSteeringCanonicalAnswer>;
  /** @deprecated Please favor `canonicalAnswersConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  canonicalAnswers: Array<OneAgentSteeringCanonicalAnswer>;
  canonicalAnswersConnection: OneAgentSteeringCanonicalAnswerConnection;
};


export type OneAgentSteeringCanonicalAnswerArgs = {
  id: Scalars['Int'];
};


export type OneAgentSteeringCanonicalAnswersArgs = {
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type OneAgentSteeringCanonicalAnswersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

export type OneOnOnes = {
  __typename?: 'oneOnOnes';
  _policies: OneOnOnesContextlessPolicies;
  externalNote?: Maybe<OneOnOnesExternalNote>;
  /** @deprecated Please favor `externalNotesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  externalNotes: Array<OneOnOnesExternalNote>;
  externalNotesConnection: OneOnOnesExternalNoteConnection;
  meeting?: Maybe<OneOnOnesMeeting>;
  /** @deprecated Please favor `meetingsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  meetings: Array<OneOnOnesMeeting>;
  meetingsConnection: OneOnOnesMeetingConnection;
  oneOnOne?: Maybe<OneOnOnesOneOnOne>;
  /** @deprecated Please favor `oneOnOnesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  oneOnOnes: Array<OneOnOnesOneOnOne>;
  oneOnOnesConnection: OneOnOnesOneOnOneConnection;
  talkingPoint?: Maybe<OneOnOnesTalkingPoint>;
  /** @deprecated Please favor `talkingPointsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  talkingPoints: Array<OneOnOnesTalkingPoint>;
  talkingPointsConnection: OneOnOnesTalkingPointConnection;
  task?: Maybe<OneOnOnesTask>;
  /** @deprecated Please favor `tasksConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  tasks: Array<OneOnOnesTask>;
  tasksConnection: OneOnOnesTaskConnection;
};


export type OneOnOnesExternalNoteArgs = {
  id: Scalars['Int'];
};


export type OneOnOnesExternalNotesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  meetingIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type OneOnOnesExternalNotesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  meetingIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type OneOnOnesMeetingArgs = {
  id: Scalars['Int'];
};


export type OneOnOnesMeetingsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  oneOnOneIds?: InputMaybe<Array<Scalars['Int']>>;
  participantIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


export type OneOnOnesMeetingsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<OneOnOnesMeetingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  oneOnOneIds?: InputMaybe<Array<Scalars['Int']>>;
  participantIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type OneOnOnesOneOnOneArgs = {
  id: Scalars['Int'];
};


export type OneOnOnesOneOnOnesArgs = {
  excludedParticipantIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  participantIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


export type OneOnOnesOneOnOnesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  excludedParticipantIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  participantIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type OneOnOnesTalkingPointArgs = {
  id: Scalars['Int'];
};


export type OneOnOnesTalkingPointsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  meetingIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type OneOnOnesTalkingPointsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  meetingIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type OneOnOnesTaskArgs = {
  id: Scalars['Int'];
};


export type OneOnOnesTasksArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  meetingIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type OneOnOnesTasksConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<OneOnOnesTaskFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  meetingIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

export type OneOnOnesMutations = {
  __typename?: 'oneOnOnesMutations';
  addOneononesTalkingPoint: AddOneononesTalkingPointPayload;
  augmentWithAiOneononesMeeting: AugmentWithAiOneononesMeetingPayload;
  bulkCreateOneononesTask: BulkCreateOneononesTaskPayload;
  createFromTextOneononesExternalNote: CreateFromTextOneononesExternalNotePayload;
  createOneononesInsight: CreateOneononesInsightPayload;
  createOneononesMeeting: CreateOneononesMeetingPayload;
  createOneononesTask: CreateOneononesTaskPayload;
  deleteOneononesMeeting: DeleteOneononesMeetingPayload;
  exportCsvOneononesExport: ExportCsvOneononesExportPayload;
  rejectTasksDraftOneononesTalkingPoint: RejectTasksDraftOneononesTalkingPointPayload;
};


export type OneOnOnesMutationsAddOneononesTalkingPointArgs = {
  meetingId: Scalars['Int'];
  moodScore?: InputMaybe<Scalars['Int']>;
  notes?: InputMaybe<Scalars['String']>;
  participantId: Scalars['Int'];
  privateNotes?: InputMaybe<Scalars['String']>;
  summary?: InputMaybe<Scalars['String']>;
};


export type OneOnOnesMutationsAugmentWithAiOneononesMeetingArgs = {
  id: Scalars['Int'];
  requesterId: Scalars['Int'];
};


export type OneOnOnesMutationsBulkCreateOneononesTaskArgs = {
  fromSuggested: Scalars['Boolean'];
  meetingId: Scalars['Int'];
  participantId: Scalars['Int'];
  tasks: Array<OneOnOnesTaskDataInput>;
};


export type OneOnOnesMutationsCreateFromTextOneononesExternalNoteArgs = {
  fileName: Scalars['String'];
  isPublic: Scalars['Boolean'];
  meetingId: Array<Scalars['Int']>;
  source: Scalars['String'];
  text: Scalars['String'];
  uploaderAccessId: Scalars['Int'];
};


export type OneOnOnesMutationsCreateOneononesInsightArgs = {
  meetingId: Scalars['Int'];
};


export type OneOnOnesMutationsCreateOneononesMeetingArgs = {
  authorId: Scalars['Int'];
  employeeId: Scalars['Int'];
  startTime: Scalars['ISO8601DateTime'];
};


export type OneOnOnesMutationsCreateOneononesTaskArgs = {
  assigneeIds: Array<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  dueDate: Scalars['ISO8601Date'];
  meetingId: Scalars['Int'];
  name: Scalars['String'];
  participantId: Scalars['Int'];
};


export type OneOnOnesMutationsDeleteOneononesMeetingArgs = {
  id: Scalars['Int'];
};


export type OneOnOnesMutationsRejectTasksDraftOneononesTalkingPointArgs = {
  id: Scalars['Int'];
};

export type OpenAi = {
  __typename?: 'openAi';
  _policies: OpenAiContextlessPolicies;
  editorPrompt?: Maybe<OpenAiEditorPrompt>;
  /** @deprecated Please favor `editorPromptsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  editorPrompts: Array<OpenAiEditorPrompt>;
  editorPromptsConnection: OpenAiEditorPromptConnection;
  feedback?: Maybe<OpenAiFeedback>;
  /** @deprecated Please favor `feedbacksConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  feedbacks: Array<OpenAiFeedback>;
  feedbacksConnection: OpenAiFeedbackConnection;
};


export type OpenAiEditorPromptArgs = {
  companyId: Scalars['Int'];
  id: Scalars['String'];
};


export type OpenAiEditorPromptsArgs = {
  companyId: Scalars['Int'];
  ids?: InputMaybe<Array<Scalars['String']>>;
};


export type OpenAiEditorPromptsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type OpenAiFeedbackArgs = {
  id: Scalars['String'];
};


export type OpenAiFeedbacksArgs = {
  feedbackTypes?: InputMaybe<Array<Scalars['String']>>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  integerResourceIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceIds?: InputMaybe<Array<Scalars['String']>>;
};


export type OpenAiFeedbacksConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  feedbackTypes?: InputMaybe<Array<Scalars['String']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  integerResourceIds?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  resourceIds?: InputMaybe<Array<Scalars['String']>>;
  sortOrder?: InputMaybe<Sort>;
};

export type OpenAiMutations = {
  __typename?: 'openAiMutations';
  createOpenaiFeedback: CreateOpenaiFeedbackPayload;
  deleteOpenaiFeedback: DeleteOpenaiFeedbackPayload;
  processOpenaiEnhancedText: ProcessOpenaiEnhancedTextPayload;
  updateOpenaiFeedback: UpdateOpenaiFeedbackPayload;
  upsertOpenaiFeedback: UpsertOpenaiFeedbackPayload;
};


export type OpenAiMutationsCreateOpenaiFeedbackArgs = {
  comment?: InputMaybe<Scalars['String']>;
  feedbackType: Scalars['String'];
  helpful: Scalars['Boolean'];
  resourceId: Scalars['String'];
};


export type OpenAiMutationsDeleteOpenaiFeedbackArgs = {
  id: Scalars['String'];
};


export type OpenAiMutationsProcessOpenaiEnhancedTextArgs = {
  companyId: Scalars['Int'];
  context?: InputMaybe<Scalars['String']>;
  customIntent?: InputMaybe<Scalars['String']>;
  selectedIntent?: InputMaybe<Scalars['String']>;
  text: Scalars['String'];
};


export type OpenAiMutationsUpdateOpenaiFeedbackArgs = {
  comment?: InputMaybe<Scalars['String']>;
  helpful?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


export type OpenAiMutationsUpsertOpenaiFeedbackArgs = {
  comment?: InputMaybe<Scalars['String']>;
  feedbackType: Scalars['String'];
  helpful?: InputMaybe<Scalars['Boolean']>;
  resourceId: Scalars['String'];
};

export type Pages = {
  __typename?: 'pages';
  _policies: PagesContextlessPolicies;
  page?: Maybe<PagesPage>;
  /** @deprecated Please favor `pagesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  pages: Array<PagesPage>;
  pagesConnection: PagesPageConnection;
};


export type PagesPageArgs = {
  id: Scalars['Int'];
};


export type PagesPagesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  visibility?: InputMaybe<Array<Scalars['String']>>;
};


export type PagesPagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  visibility?: InputMaybe<Array<Scalars['String']>>;
};

export type PagesMutations = {
  __typename?: 'pagesMutations';
  createPagesPage: CreatePagesPagePayload;
  deletePagesPage: DeletePagesPagePayload;
  updatePagesPage: UpdatePagesPagePayload;
};


export type PagesMutationsCreatePagesPageArgs = {
  content?: InputMaybe<Scalars['String']>;
  ownerId?: InputMaybe<Scalars['Int']>;
  parentPageId?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  visibility?: InputMaybe<Scalars['String']>;
};


export type PagesMutationsDeletePagesPageArgs = {
  id: Scalars['Int'];
};


export type PagesMutationsUpdatePagesPageArgs = {
  content?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  title?: InputMaybe<Scalars['String']>;
  visibility?: InputMaybe<Scalars['String']>;
};

export type Payroll = {
  __typename?: 'payroll';
  _policies: PayrollContextlessPolicies;
  concept?: Maybe<PayrollConcept>;
  /** @deprecated Please favor `conceptsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  concepts: Array<PayrollConcept>;
  conceptsConnection: PayrollConceptConnection;
  /** @deprecated Please favor `currentDefaultPolicyPeriodsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  currentDefaultPolicyPeriods: Array<PayrollCurrentDefaultPolicyPeriod>;
  currentDefaultPolicyPeriodsConnection: PayrollCurrentDefaultPolicyPeriodConnection;
  /** @deprecated Please favor `draftPaymentItemsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  draftPaymentItems: Array<PayrollDraftPaymentItem>;
  draftPaymentItemsConnection: PayrollDraftPaymentItemConnection;
  /** @deprecated Please favor `employeeEstimatedPeriodBaseSalariesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  employeeEstimatedPeriodBaseSalaries: Array<PayrollEmployeeEstimatedPeriodBaseSalary>;
  employeeEstimatedPeriodBaseSalariesConnection: PayrollEmployeeEstimatedPeriodBaseSalaryConnection;
  /** @deprecated Please favor `employeeResultsSummariesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  employeeResultsSummaries: Array<PayrollEmployeeResultsSummary>;
  employeeResultsSummariesConnection: PayrollEmployeeResultsSummaryConnection;
  /** @deprecated Please favor `expensesCategoriesContractsTaxonomiesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  expensesCategoriesContractsTaxonomies: Array<PayrollExpensesCategoriesContractsTaxonomy>;
  expensesCategoriesContractsTaxonomiesConnection: PayrollExpensesCategoriesContractsTaxonomyConnection;
  /** @deprecated Please favor `familySituationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  familySituations: Array<PayrollFamilySituation>;
  familySituationsConnection: PayrollFamilySituationConnection;
  /** @deprecated Please favor `paymentTotalsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  paymentTotals: Array<PayrollPaymentTotal>;
  paymentTotalsConnection: PayrollPaymentTotalConnection;
  payrollDocument?: Maybe<PayrollPayrollDocument>;
  /** @deprecated Please favor `payrollDocumentsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  payrollDocuments: Array<PayrollPayrollDocument>;
  payrollDocumentsConnection: PayrollPayrollDocumentConnection;
  /** @deprecated Please favor `payrollIssuesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  payrollIssues: Array<PayrollPayrollIssue>;
  payrollIssuesConnection: PayrollPayrollIssueConnection;
  payrollSummaryCellSuggestion?: Maybe<PayrollPayrollSummaryCellSuggestion>;
  /** @deprecated Please favor `payrollSummaryCellSuggestionsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  payrollSummaryCellSuggestions: Array<PayrollPayrollSummaryCellSuggestion>;
  payrollSummaryCellSuggestionsConnection: PayrollPayrollSummaryCellSuggestionConnection;
  payrollSummaryImport?: Maybe<PayrollPayrollSummaryImport>;
  payrollSummaryImportTemplate?: Maybe<PayrollPayrollSummaryImportTemplate>;
  /** @deprecated Please favor `payrollSummaryImportTemplatesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  payrollSummaryImportTemplates: Array<PayrollPayrollSummaryImportTemplate>;
  payrollSummaryImportTemplatesConnection: PayrollPayrollSummaryImportTemplateConnection;
  /** @deprecated Please favor `payrollSummaryImportsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  payrollSummaryImports: Array<PayrollPayrollSummaryImport>;
  payrollSummaryImportsConnection: PayrollPayrollSummaryImportConnection;
  /** @deprecated Please favor `payrollSummaryMatchesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  payrollSummaryMatches: Array<PayrollPayrollSummaryMatch>;
  payrollSummaryMatchesConnection: PayrollPayrollSummaryMatchConnection;
  /** @deprecated Please favor `payrollSummarySamplesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  payrollSummarySamples: Array<PayrollPayrollSummarySample>;
  payrollSummarySamplesConnection: PayrollPayrollSummarySampleConnection;
  /** @deprecated Please favor `policiesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  policies: Array<PayrollPolicy>;
  policiesConnection: PayrollPolicyConnection;
  policy?: Maybe<PayrollPolicy>;
  policyPeriod?: Maybe<PayrollPolicyPeriod>;
  /** @deprecated Please favor `policyPeriodsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  policyPeriods: Array<PayrollPolicyPeriod>;
  policyPeriodsConnection: PayrollPolicyPeriodConnection;
  /** @deprecated Please favor `reimbursableSupplementTaxonomiesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  reimbursableSupplementTaxonomies: Array<PayrollReimbursableSupplementTaxonomy>;
  reimbursableSupplementTaxonomiesConnection: PayrollReimbursableSupplementTaxonomyConnection;
  reimbursableSupplementTaxonomy?: Maybe<PayrollReimbursableSupplementTaxonomy>;
  result?: Maybe<PayrollResult>;
  resultConceptItem?: Maybe<PayrollResultConceptItem>;
  /** @deprecated Please favor `resultConceptItemSummariesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  resultConceptItemSummaries: Array<PayrollResultConceptItemSummary>;
  resultConceptItemSummariesConnection: PayrollResultConceptItemSummaryConnection;
  resultConceptItemSummary?: Maybe<PayrollResultConceptItemSummary>;
  /** @deprecated Please favor `resultConceptItemsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  resultConceptItems: Array<PayrollResultConceptItem>;
  resultConceptItemsConnection: PayrollResultConceptItemConnection;
  resultConceptTotal?: Maybe<PayrollResultConceptTotal>;
  /** @deprecated Please favor `resultConceptTotalsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  resultConceptTotals: Array<PayrollResultConceptTotal>;
  resultConceptTotalsConnection: PayrollResultConceptTotalConnection;
  resultLabelConceptMapping?: Maybe<PayrollResultLabelConceptMapping>;
  /** @deprecated Please favor `resultLabelConceptMappingsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  resultLabelConceptMappings: Array<PayrollResultLabelConceptMapping>;
  resultLabelConceptMappingsConnection: PayrollResultLabelConceptMappingConnection;
  /** @deprecated Please favor `resultLabelConceptMappingsSuggestionsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  resultLabelConceptMappingsSuggestions: Array<PayrollResultLabelConceptMappingsSuggestion>;
  resultLabelConceptMappingsSuggestionsConnection: PayrollResultLabelConceptMappingsSuggestionConnection;
  resultValidationFormula?: Maybe<PayrollResultValidationFormula>;
  /** @deprecated Please favor `resultValidationFormulasConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  resultValidationFormulas: Array<PayrollResultValidationFormula>;
  resultValidationFormulasConnection: PayrollResultValidationFormulaConnection;
  /** @deprecated Please favor `resultValidationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  resultValidations: Array<PayrollResultValidation>;
  resultValidationsConnection: PayrollResultValidationConnection;
  /** @deprecated Please favor `resultValidationsItemsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  resultValidationsItems: Array<PayrollResultValidationsItem>;
  resultValidationsItemsConnection: PayrollResultValidationsItemConnection;
  /** @deprecated Please favor `resultsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  results: Array<PayrollResult>;
  resultsConnection: PayrollResultConnection;
  supplement?: Maybe<PayrollSupplement>;
  supplementBulkImport?: Maybe<PayrollSupplementBulkImport>;
  /** @deprecated Please favor `supplementBulkImportsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  supplementBulkImports: Array<PayrollSupplementBulkImport>;
  supplementBulkImportsConnection: PayrollSupplementBulkImportConnection;
  supplementDescription?: Maybe<PayrollSupplementDescription>;
  /** @deprecated Please favor `supplementDescriptionsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  supplementDescriptions: Array<PayrollSupplementDescription>;
  supplementDescriptionsConnection: PayrollSupplementDescriptionConnection;
  supplementInsight?: Maybe<PayrollSupplementInsight>;
  /** @deprecated Please favor `supplementInsightsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  supplementInsights: Array<PayrollSupplementInsight>;
  supplementInsightsConnection: PayrollSupplementInsightConnection;
  supplementObservation?: Maybe<PayrollSupplementObservation>;
  /** @deprecated Please favor `supplementObservationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  supplementObservations: Array<PayrollSupplementObservation>;
  supplementObservationsConnection: PayrollSupplementObservationConnection;
  supplementValidation?: Maybe<PayrollSupplementValidation>;
  /** @deprecated Please favor `supplementValidationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  supplementValidations: Array<PayrollSupplementValidation>;
  supplementValidationsConnection: PayrollSupplementValidationConnection;
  /** @deprecated Please favor `supplementsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  supplements: Array<PayrollSupplement>;
  supplementsConnection: PayrollSupplementConnection;
};


export type PayrollConceptArgs = {
  id: Scalars['Int'];
};


export type PayrollConceptsArgs = {
  categories?: InputMaybe<Array<PayrollValueObjectsConceptCategoryEnum>>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  default?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  names?: InputMaybe<Array<Scalars['String']>>;
  policyPeriodId?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  unitTypes?: InputMaybe<Array<PayrollValueObjectsConceptUnitTypeEnum>>;
  withActiveStatus?: InputMaybe<Scalars['Boolean']>;
};


export type PayrollConceptsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  categories?: InputMaybe<Array<PayrollValueObjectsConceptCategoryEnum>>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  default?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  names?: InputMaybe<Array<Scalars['String']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  policyPeriodId?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  unitTypes?: InputMaybe<Array<PayrollValueObjectsConceptUnitTypeEnum>>;
  withActiveStatus?: InputMaybe<Scalars['Boolean']>;
};


export type PayrollCurrentDefaultPolicyPeriodsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type PayrollDraftPaymentItemsArgs = {
  paymentType?: InputMaybe<Scalars['String']>;
  policyPeriodId: Scalars['Int'];
};


export type PayrollDraftPaymentItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  paymentType?: InputMaybe<Scalars['String']>;
  policyPeriodId: Scalars['Int'];
  sortOrder?: InputMaybe<Sort>;
};


export type PayrollEmployeeEstimatedPeriodBaseSalariesArgs = {
  policyPeriodId: Scalars['Int'];
};


export type PayrollEmployeeEstimatedPeriodBaseSalariesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  policyPeriodId: Scalars['Int'];
  sortOrder?: InputMaybe<Sort>;
};


export type PayrollEmployeeResultsSummariesArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  policyPeriodId: Scalars['Int'];
  search?: InputMaybe<Scalars['String']>;
  sortConceptId?: InputMaybe<Scalars['Int']>;
  sortDirection?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
};


export type PayrollEmployeeResultsSummariesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  policyPeriodId: Scalars['Int'];
  search?: InputMaybe<Scalars['String']>;
  sortConceptId?: InputMaybe<Scalars['Int']>;
  sortDirection?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type PayrollExpensesCategoriesContractsTaxonomiesArgs = {
  onlyFullyMapped?: Scalars['Boolean'];
};


export type PayrollExpensesCategoriesContractsTaxonomiesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyFullyMapped?: Scalars['Boolean'];
  sortOrder?: InputMaybe<Sort>;
};


export type PayrollFamilySituationsArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type PayrollFamilySituationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type PayrollPaymentTotalsArgs = {
  policyPeriodId: Scalars['Int'];
};


export type PayrollPaymentTotalsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  policyPeriodId: Scalars['Int'];
  sortOrder?: InputMaybe<Sort>;
};


export type PayrollPayrollDocumentArgs = {
  id: Scalars['Int'];
};


export type PayrollPayrollDocumentsArgs = {
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  policyPeriodIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type PayrollPayrollDocumentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  policyPeriodIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
};


export type PayrollPayrollIssuesArgs = {
  payrollPolicyPeriodId: Scalars['Int'];
};


export type PayrollPayrollIssuesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  payrollPolicyPeriodId: Scalars['Int'];
  sortOrder?: InputMaybe<Sort>;
};


export type PayrollPayrollSummaryCellSuggestionArgs = {
  id: Scalars['Int'];
};


export type PayrollPayrollSummaryCellSuggestionsArgs = {
  ids: Array<Scalars['Int']>;
};


export type PayrollPayrollSummaryCellSuggestionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids: Array<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type PayrollPayrollSummaryImportArgs = {
  id: Scalars['Int'];
};


export type PayrollPayrollSummaryImportTemplateArgs = {
  id: Scalars['String'];
};


export type PayrollPayrollSummaryImportTemplatesArgs = {
  ids?: InputMaybe<Array<PayrollSummaryImportTemplatesIdsEnum>>;
};


export type PayrollPayrollSummaryImportTemplatesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<PayrollSummaryImportTemplatesIdsEnum>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type PayrollPayrollSummaryImportsArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  compensationType?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  nonNillableCells?: InputMaybe<Scalars['Boolean']>;
  policyId?: InputMaybe<Scalars['Int']>;
};


export type PayrollPayrollSummaryImportsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  compensationType?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  nonNillableCells?: InputMaybe<Scalars['Boolean']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  policyId?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type PayrollPayrollSummaryMatchesArgs = {
  financePayrollSummaryImportId: Scalars['Int'];
};


export type PayrollPayrollSummaryMatchesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  financePayrollSummaryImportId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type PayrollPayrollSummarySamplesArgs = {
  financePayrollSummaryImportId: Scalars['Int'];
};


export type PayrollPayrollSummarySamplesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  financePayrollSummaryImportId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type PayrollPoliciesArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  default?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeArchived?: Scalars['Boolean'];
};


export type PayrollPoliciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  default?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeArchived?: Scalars['Boolean'];
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type PayrollPolicyArgs = {
  id: Scalars['Int'];
};


export type PayrollPolicyPeriodArgs = {
  id: Scalars['Int'];
};


export type PayrollPolicyPeriodsArgs = {
  byCurrentPeriods?: InputMaybe<Scalars['ISO8601Date']>;
  byCurrentPeriodsOrImmediatePastPeriods?: InputMaybe<Scalars['ISO8601Date']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  endsOn?: InputMaybe<Scalars['ISO8601Date']>;
  endsOnGte?: InputMaybe<Scalars['ISO8601Date']>;
  endsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  periodEndsOn?: InputMaybe<Scalars['ISO8601Date']>;
  periodStartsOn?: InputMaybe<Scalars['ISO8601Date']>;
  policyIds?: InputMaybe<Array<Scalars['Int']>>;
  startsOnGt?: InputMaybe<Scalars['ISO8601Date']>;
  startsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  status?: InputMaybe<Array<Scalars['String']>>;
};


export type PayrollPolicyPeriodsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  byCurrentPeriods?: InputMaybe<Scalars['ISO8601Date']>;
  byCurrentPeriodsOrImmediatePastPeriods?: InputMaybe<Scalars['ISO8601Date']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  endsOn?: InputMaybe<Scalars['ISO8601Date']>;
  endsOnGte?: InputMaybe<Scalars['ISO8601Date']>;
  endsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  filter?: InputMaybe<PayrollPolicyPeriodFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  periodEndsOn?: InputMaybe<Scalars['ISO8601Date']>;
  periodStartsOn?: InputMaybe<Scalars['ISO8601Date']>;
  policyIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
  startsOnGt?: InputMaybe<Scalars['ISO8601Date']>;
  startsOnLteq?: InputMaybe<Scalars['ISO8601Date']>;
  status?: InputMaybe<Array<Scalars['String']>>;
};


export type PayrollReimbursableSupplementTaxonomiesArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  reimbursableTypes?: InputMaybe<Array<Scalars['String']>>;
};


export type PayrollReimbursableSupplementTaxonomiesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  reimbursableTypes?: InputMaybe<Array<Scalars['String']>>;
  sortOrder?: InputMaybe<Sort>;
};


export type PayrollReimbursableSupplementTaxonomyArgs = {
  id: Scalars['String'];
};


export type PayrollResultArgs = {
  id: Scalars['Int'];
};


export type PayrollResultConceptItemArgs = {
  id: Scalars['Int'];
};


export type PayrollResultConceptItemSummariesArgs = {
  conceptId?: InputMaybe<Scalars['Int']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  employeeResultsSummaryIds?: InputMaybe<Array<Scalars['String']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  latestByEmployee?: InputMaybe<Scalars['Boolean']>;
  paymentType?: InputMaybe<Scalars['String']>;
  policyPeriodId?: InputMaybe<Scalars['Int']>;
};


export type PayrollResultConceptItemSummariesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  conceptId?: InputMaybe<Scalars['Int']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  employeeResultsSummaryIds?: InputMaybe<Array<Scalars['String']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  latestByEmployee?: InputMaybe<Scalars['Boolean']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  paymentType?: InputMaybe<Scalars['String']>;
  policyPeriodId?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type PayrollResultConceptItemSummaryArgs = {
  id: Scalars['Int'];
};


export type PayrollResultConceptItemsArgs = {
  conceptId?: InputMaybe<Scalars['Int']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  employeeResultsSummaryIds?: InputMaybe<Array<Scalars['String']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  latestByEmployee?: InputMaybe<Scalars['Boolean']>;
  paymentType?: InputMaybe<Scalars['String']>;
  policyPeriodId?: InputMaybe<Scalars['Int']>;
};


export type PayrollResultConceptItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  conceptId?: InputMaybe<Scalars['Int']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  employeeResultsSummaryIds?: InputMaybe<Array<Scalars['String']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  latestByEmployee?: InputMaybe<Scalars['Boolean']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  paymentType?: InputMaybe<Scalars['String']>;
  policyPeriodId?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type PayrollResultConceptTotalArgs = {
  id: Scalars['Int'];
};


export type PayrollResultConceptTotalsArgs = {
  conceptId?: InputMaybe<Scalars['Int']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  employeeResultsSummaryIds?: InputMaybe<Array<Scalars['String']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  latestByEmployee?: InputMaybe<Scalars['Boolean']>;
  paymentType?: InputMaybe<Scalars['String']>;
  policyPeriodId?: InputMaybe<Scalars['Int']>;
};


export type PayrollResultConceptTotalsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  conceptId?: InputMaybe<Scalars['Int']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  employeeResultsSummaryIds?: InputMaybe<Array<Scalars['String']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  latestByEmployee?: InputMaybe<Scalars['Boolean']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  paymentType?: InputMaybe<Scalars['String']>;
  policyPeriodId?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type PayrollResultLabelConceptMappingArgs = {
  id: Scalars['Int'];
};


export type PayrollResultLabelConceptMappingsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type PayrollResultLabelConceptMappingsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type PayrollResultLabelConceptMappingsSuggestionsArgs = {
  companyId: Scalars['Int'];
  conceptIds: Array<Scalars['Int']>;
  labels: Array<Scalars['String']>;
};


export type PayrollResultLabelConceptMappingsSuggestionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  conceptIds: Array<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  labels: Array<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type PayrollResultValidationFormulaArgs = {
  id: Scalars['Int'];
};


export type PayrollResultValidationFormulasArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type PayrollResultValidationFormulasConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type PayrollResultValidationsArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  policyPeriodId: Scalars['Int'];
  validationFormulaIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type PayrollResultValidationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  policyPeriodId: Scalars['Int'];
  sortOrder?: InputMaybe<Sort>;
  validationFormulaIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type PayrollResultValidationsItemsArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  policyPeriodId: Scalars['Int'];
};


export type PayrollResultValidationsItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  policyPeriodId: Scalars['Int'];
  sortOrder?: InputMaybe<Sort>;
};


export type PayrollResultsArgs = {
  compensationsPayrollRunId?: InputMaybe<Scalars['Int']>;
  compensationsPayrollRunIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  policyPeriodId?: InputMaybe<Scalars['Int']>;
  policyPeriodIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type PayrollResultsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  compensationsPayrollRunId?: InputMaybe<Scalars['Int']>;
  compensationsPayrollRunIds?: InputMaybe<Array<Scalars['Int']>>;
  filter?: InputMaybe<PayrollResultFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  policyPeriodId?: InputMaybe<Scalars['Int']>;
  policyPeriodIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
};


export type PayrollSupplementArgs = {
  id: Scalars['Int'];
};


export type PayrollSupplementBulkImportArgs = {
  id: Scalars['Int'];
};


export type PayrollSupplementBulkImportsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  policyPeriodId?: InputMaybe<Scalars['Int']>;
};


export type PayrollSupplementBulkImportsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  policyPeriodId?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type PayrollSupplementDescriptionArgs = {
  id: Scalars['Int'];
};


export type PayrollSupplementDescriptionsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  supplementIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type PayrollSupplementDescriptionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  supplementIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type PayrollSupplementInsightArgs = {
  id: Scalars['Int'];
};


export type PayrollSupplementInsightsArgs = {
  from?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  policyPeriodId?: InputMaybe<Scalars['Int']>;
  to?: InputMaybe<Scalars['ISO8601Date']>;
};


export type PayrollSupplementInsightsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  policyPeriodId?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  to?: InputMaybe<Scalars['ISO8601Date']>;
};


export type PayrollSupplementObservationArgs = {
  id: Scalars['Int'];
};


export type PayrollSupplementObservationsArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  supplementIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type PayrollSupplementObservationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  supplementIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type PayrollSupplementValidationArgs = {
  id: Scalars['Int'];
};


export type PayrollSupplementValidationsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  supplementIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type PayrollSupplementValidationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  supplementIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type PayrollSupplementsArgs = {
  compensationId?: InputMaybe<Scalars['Int']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  from?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  policyPeriodIds?: Array<Scalars['Int']>;
  sourceIds?: InputMaybe<Array<Scalars['Int']>>;
  sourceType?: InputMaybe<Scalars['String']>;
  taxonomyIds?: InputMaybe<Array<Scalars['Int']>>;
  to?: InputMaybe<Scalars['ISO8601Date']>;
};


export type PayrollSupplementsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  compensationId?: InputMaybe<Scalars['Int']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  policyPeriodIds?: Array<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  sourceIds?: InputMaybe<Array<Scalars['Int']>>;
  sourceType?: InputMaybe<Scalars['String']>;
  taxonomyIds?: InputMaybe<Array<Scalars['Int']>>;
  to?: InputMaybe<Scalars['ISO8601Date']>;
};

export type PayrollEmployees = {
  __typename?: 'payrollEmployees';
  /** @deprecated Please favor `employeeDataConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  employeeData: Array<PayrollEmployeesEmployeeDatum>;
  employeeDataConnection: PayrollEmployeesEmployeeDatumConnection;
  employeeDatum?: Maybe<PayrollEmployeesEmployeeDatum>;
  identifier?: Maybe<PayrollEmployeesIdentifier>;
  /** @deprecated Please favor `identifiersConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  identifiers: Array<PayrollEmployeesIdentifier>;
  identifiersConnection: PayrollEmployeesIdentifierConnection;
};


export type PayrollEmployeesEmployeeDataArgs = {
  capabilityFilter?: InputMaybe<DataDispatcherCapabilityFilterInput>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  historyFrom?: InputMaybe<Scalars['ISO8601DateTime']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  schema?: InputMaybe<Array<EmployeeDataSchemaInput>>;
};


export type PayrollEmployeesEmployeeDataConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  capabilityFilter?: InputMaybe<DataDispatcherCapabilityFilterInput>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  historyFrom?: InputMaybe<Scalars['ISO8601DateTime']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  schema?: InputMaybe<Array<EmployeeDataSchemaInput>>;
  sortOrder?: InputMaybe<Sort>;
};


export type PayrollEmployeesEmployeeDatumArgs = {
  id: Scalars['Int'];
};


export type PayrollEmployeesIdentifierArgs = {
  country: PayrollEmployeesDtosIdentifierSupportedCountryEnum;
  id: Scalars['Int'];
};


export type PayrollEmployeesIdentifiersArgs = {
  country: PayrollEmployeesDtosIdentifierSupportedCountryEnum;
  employeesIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntitiesIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type PayrollEmployeesIdentifiersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  country: PayrollEmployeesDtosIdentifierSupportedCountryEnum;
  employeesIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntitiesIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

export type PayrollEmployeesMutations = {
  __typename?: 'payrollEmployeesMutations';
  createPayrollemployeesEmployeeDatum: CreatePayrollemployeesEmployeeDatumPayload;
  createPayrollemployeesIdentifier: CreatePayrollemployeesIdentifierPayload;
  deletePayrollemployeesIdentifier: DeletePayrollemployeesIdentifierPayload;
  updatePayrollemployeesEmployeeDatum: UpdatePayrollemployeesEmployeeDatumPayload;
  updatePayrollemployeesIdentifier: UpdatePayrollemployeesIdentifierPayload;
  upsertPayrollemployeesEmployeeDatum: UpsertPayrollemployeesEmployeeDatumPayload;
  upsertPayrollemployeesIdentifier: UpsertPayrollemployeesIdentifierPayload;
};


export type PayrollEmployeesMutationsCreatePayrollemployeesEmployeeDatumArgs = {
  companyId: Scalars['Int'];
  employeeId: Scalars['Int'];
  fields: Array<DataDispatcherFieldSetInput>;
};


export type PayrollEmployeesMutationsCreatePayrollemployeesIdentifierArgs = {
  country: PayrollEmployeesDtosIdentifierSupportedCountryEnum;
  employeeId: Scalars['Int'];
  socialSecurityNumber?: InputMaybe<Scalars['String']>;
  taxId?: InputMaybe<Scalars['String']>;
};


export type PayrollEmployeesMutationsDeletePayrollemployeesIdentifierArgs = {
  country: PayrollEmployeesDtosIdentifierSupportedCountryEnum;
  id: Scalars['Int'];
};


export type PayrollEmployeesMutationsUpdatePayrollemployeesEmployeeDatumArgs = {
  companyId: Scalars['Int'];
  employeeId: Scalars['Int'];
  fields: Array<DataDispatcherFieldSetInput>;
};


export type PayrollEmployeesMutationsUpdatePayrollemployeesIdentifierArgs = {
  country: PayrollEmployeesDtosIdentifierSupportedCountryEnum;
  id: Scalars['Int'];
  socialSecurityNumber?: InputMaybe<Scalars['String']>;
  taxId?: InputMaybe<Scalars['String']>;
};


export type PayrollEmployeesMutationsUpsertPayrollemployeesEmployeeDatumArgs = {
  companyId: Scalars['Int'];
  employeeId: Scalars['Int'];
  fields: Array<DataDispatcherFieldSetInput>;
};


export type PayrollEmployeesMutationsUpsertPayrollemployeesIdentifierArgs = {
  country: PayrollEmployeesDtosIdentifierSupportedCountryEnum;
  employeeId: Scalars['Int'];
  socialSecurityNumber?: InputMaybe<Scalars['String']>;
  taxId?: InputMaybe<Scalars['String']>;
};

export type PayrollExporter = {
  __typename?: 'payrollExporter';
  export?: Maybe<PayrollExporterExport>;
  /** @deprecated Please favor `exportsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  exports: Array<PayrollExporterExport>;
  exportsConnection: PayrollExporterExportConnection;
};


export type PayrollExporterExportArgs = {
  id: Scalars['Int'];
};


export type PayrollExporterExportsArgs = {
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  policyPeriodIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type PayrollExporterExportsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  policyPeriodIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
};

export type PayrollExporterMutations = {
  __typename?: 'payrollExporterMutations';
  createPayrollexporterExport: CreatePayrollexporterExportPayload;
};


export type PayrollExporterMutationsCreatePayrollexporterExportArgs = {
  bookkeeperView: Scalars['Boolean'];
  companyId: Scalars['Int'];
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  from?: InputMaybe<Scalars['String']>;
  leaveTypeIds?: InputMaybe<Array<Scalars['Int']>>;
  legalEntity?: InputMaybe<Scalars['Int']>;
  payrollPolicyPeriodId?: InputMaybe<Scalars['Int']>;
  showAbsencesTotal?: InputMaybe<Scalars['Boolean']>;
  timestamp?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
  trimLeaveDuration?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<PayrollExporterDtosExportReadTypeEnum>;
  updateExportPeriodType?: InputMaybe<PayrollExporterDtosExportReadUpdatePeriodExportTypeEnum>;
  updateFrom?: InputMaybe<Scalars['String']>;
  updateTo?: InputMaybe<Scalars['String']>;
};

export type PayrollIntegrations = {
  __typename?: 'payrollIntegrations';
  _policies: PayrollIntegrationsContextlessPolicies;
};

export type PayrollIntegrationsA3innuva = {
  __typename?: 'payrollIntegrationsA3innuva';
  /** @deprecated Please favor `agreementCodesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  agreementCodes: Array<PayrollIntegrationsA3innuvaAgreementCode>;
  agreementCodesConnection: PayrollIntegrationsA3innuvaAgreementCodeConnection;
  /** @deprecated Please favor `classificationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  classifications: Array<PayrollIntegrationsA3innuvaClassification>;
  classificationsConnection: PayrollIntegrationsA3innuvaClassificationConnection;
  /** @deprecated Please favor `cnoOccupationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  cnoOccupations: Array<PayrollIntegrationsA3innuvaCnoOccupation>;
  cnoOccupationsConnection: PayrollIntegrationsA3innuvaCnoOccupationConnection;
  /** @deprecated Please favor `companyCodesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  companyCodes: Array<PayrollIntegrationsA3innuvaCompanyCode>;
  companyCodesConnection: PayrollIntegrationsA3innuvaCompanyCodeConnection;
  /** @deprecated Please favor `compensationCodesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  compensationCodes: Array<PayrollIntegrationsA3innuvaCompensationCode>;
  compensationCodesConnection: PayrollIntegrationsA3innuvaCompensationCodeConnection;
  /** @deprecated Please favor `contractTypesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  contractTypes: Array<PayrollIntegrationsA3innuvaContractType>;
  contractTypesConnection: PayrollIntegrationsA3innuvaContractTypeConnection;
  /** @deprecated Please favor `contributionTypesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  contributionTypes: Array<PayrollIntegrationsA3innuvaContributionType>;
  contributionTypesConnection: PayrollIntegrationsA3innuvaContributionTypeConnection;
  /** @deprecated Please favor `costCenterCodesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  costCenterCodes: Array<PayrollIntegrationsA3innuvaCostCenterCode>;
  costCenterCodesConnection: PayrollIntegrationsA3innuvaCostCenterCodeConnection;
  /** @deprecated Please favor `educationLevelsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  educationLevels: Array<PayrollIntegrationsA3innuvaEducationLevel>;
  educationLevelsConnection: PayrollIntegrationsA3innuvaEducationLevelConnection;
  /** @deprecated Please favor `jobPositionsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  jobPositions: Array<PayrollIntegrationsA3innuvaJobPosition>;
  jobPositionsConnection: PayrollIntegrationsA3innuvaJobPositionConnection;
  leaveType?: Maybe<PayrollIntegrationsA3innuvaLeaveType>;
  /** @deprecated Please favor `leaveTypesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  leaveTypes: Array<PayrollIntegrationsA3innuvaLeaveType>;
  leaveTypesConnection: PayrollIntegrationsA3innuvaLeaveTypeConnection;
  /** @deprecated Please favor `oauthTokensConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  oauthTokens: Array<PayrollIntegrationsA3innuvaOauthToken>;
  oauthTokensConnection: PayrollIntegrationsA3innuvaOauthTokenConnection;
  /** @deprecated Please favor `occupationCodesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  occupationCodes: Array<PayrollIntegrationsA3innuvaOccupationCode>;
  occupationCodesConnection: PayrollIntegrationsA3innuvaOccupationCodeConnection;
  /** @deprecated Please favor `organizationalUnitsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  organizationalUnits: Array<PayrollIntegrationsA3innuvaOrganizationalUnit>;
  organizationalUnitsConnection: PayrollIntegrationsA3innuvaOrganizationalUnitConnection;
  /** @deprecated Please favor `regimesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  regimes: Array<PayrollIntegrationsA3innuvaRegime>;
  regimesConnection: PayrollIntegrationsA3innuvaRegimeConnection;
  /** @deprecated Please favor `tariffGroupsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  tariffGroups: Array<PayrollIntegrationsA3innuvaTariffGroup>;
  tariffGroupsConnection: PayrollIntegrationsA3innuvaTariffGroupConnection;
  /** @deprecated Please favor `temporaryDisabilitiesManagersConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  temporaryDisabilitiesManagers: Array<PayrollIntegrationsA3innuvaTemporaryDisabilitiesManager>;
  temporaryDisabilitiesManagersConnection: PayrollIntegrationsA3innuvaTemporaryDisabilitiesManagerConnection;
  /** @deprecated Please favor `workplaceCodesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  workplaceCodes: Array<PayrollIntegrationsA3innuvaWorkplaceCode>;
  workplaceCodesConnection: PayrollIntegrationsA3innuvaWorkplaceCodeConnection;
};


export type PayrollIntegrationsA3innuvaAgreementCodesArgs = {
  companyId: Scalars['Int'];
  currentUserId: Scalars['Int'];
  legalEntityId: Scalars['Int'];
};


export type PayrollIntegrationsA3innuvaAgreementCodesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  currentUserId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityId: Scalars['Int'];
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type PayrollIntegrationsA3innuvaClassificationsArgs = {
  agreementCode: Scalars['String'];
  companyId: Scalars['Int'];
  currentUserId: Scalars['Int'];
  legalEntityId: Scalars['Int'];
};


export type PayrollIntegrationsA3innuvaClassificationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  agreementCode: Scalars['String'];
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  currentUserId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityId: Scalars['Int'];
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type PayrollIntegrationsA3innuvaCnoOccupationsArgs = {
  companyId: Scalars['Int'];
  currentUserId: Scalars['Int'];
  legalEntityId: Scalars['Int'];
};


export type PayrollIntegrationsA3innuvaCnoOccupationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  currentUserId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityId: Scalars['Int'];
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type PayrollIntegrationsA3innuvaCompanyCodesArgs = {
  companyId: Scalars['Int'];
  currentUserId: Scalars['Int'];
  organizationalUnitId?: InputMaybe<Scalars['String']>;
};


export type PayrollIntegrationsA3innuvaCompanyCodesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  currentUserId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  organizationalUnitId?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type PayrollIntegrationsA3innuvaCompensationCodesArgs = {
  companyCodes: Array<Scalars['String']>;
  companyId: Scalars['Int'];
  currentUserId: Scalars['Int'];
  organizationalUnitId?: InputMaybe<Scalars['String']>;
};


export type PayrollIntegrationsA3innuvaCompensationCodesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyCodes: Array<Scalars['String']>;
  companyId: Scalars['Int'];
  currentUserId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  organizationalUnitId?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type PayrollIntegrationsA3innuvaContractTypesArgs = {
  companyId: Scalars['Int'];
  currentUserId: Scalars['Int'];
  organizationalUnitId?: InputMaybe<Scalars['String']>;
};


export type PayrollIntegrationsA3innuvaContractTypesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  currentUserId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  organizationalUnitId?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type PayrollIntegrationsA3innuvaContributionTypesArgs = {
  companyId: Scalars['Int'];
  currentUserId: Scalars['Int'];
};


export type PayrollIntegrationsA3innuvaContributionTypesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  currentUserId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type PayrollIntegrationsA3innuvaCostCenterCodesArgs = {
  companyCodes: Array<Scalars['String']>;
  companyId: Scalars['Int'];
  currentUserId: Scalars['Int'];
  legalEntityId?: InputMaybe<Scalars['Int']>;
  organizationalUnitId?: InputMaybe<Scalars['String']>;
};


export type PayrollIntegrationsA3innuvaCostCenterCodesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyCodes: Array<Scalars['String']>;
  companyId: Scalars['Int'];
  currentUserId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  organizationalUnitId?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type PayrollIntegrationsA3innuvaEducationLevelsArgs = {
  companyId: Scalars['Int'];
  currentUserId: Scalars['Int'];
  organizationalUnitId?: InputMaybe<Scalars['String']>;
};


export type PayrollIntegrationsA3innuvaEducationLevelsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  currentUserId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  organizationalUnitId?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type PayrollIntegrationsA3innuvaJobPositionsArgs = {
  companyCode?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  currentUserId: Scalars['Int'];
  legalEntityCodes?: InputMaybe<Scalars['String']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  organizationalUnitId?: InputMaybe<Scalars['String']>;
};


export type PayrollIntegrationsA3innuvaJobPositionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyCode?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  currentUserId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityCodes?: InputMaybe<Scalars['String']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  organizationalUnitId?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type PayrollIntegrationsA3innuvaLeaveTypeArgs = {
  id: Scalars['String'];
};


export type PayrollIntegrationsA3innuvaLeaveTypesArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};


export type PayrollIntegrationsA3innuvaLeaveTypesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type PayrollIntegrationsA3innuvaOauthTokensArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  organizationalUnitId?: InputMaybe<Scalars['String']>;
  useOtherUsersTokensAsFallback?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['Int']>;
  validAccessToken?: Scalars['Boolean'];
};


export type PayrollIntegrationsA3innuvaOauthTokensConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  organizationalUnitId?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  useOtherUsersTokensAsFallback?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['Int']>;
  validAccessToken?: Scalars['Boolean'];
};


export type PayrollIntegrationsA3innuvaOccupationCodesArgs = {
  companyId: Scalars['Int'];
  currentUserId: Scalars['Int'];
  legalEntityId: Scalars['Int'];
};


export type PayrollIntegrationsA3innuvaOccupationCodesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  currentUserId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityId: Scalars['Int'];
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type PayrollIntegrationsA3innuvaOrganizationalUnitsArgs = {
  companyId: Scalars['Int'];
  currentUserId: Scalars['Int'];
};


export type PayrollIntegrationsA3innuvaOrganizationalUnitsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  currentUserId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type PayrollIntegrationsA3innuvaRegimesArgs = {
  companyId: Scalars['Int'];
  currentUserId: Scalars['Int'];
  legalEntityId: Scalars['Int'];
};


export type PayrollIntegrationsA3innuvaRegimesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  currentUserId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityId: Scalars['Int'];
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type PayrollIntegrationsA3innuvaTariffGroupsArgs = {
  codes?: InputMaybe<Array<Scalars['Int']>>;
};


export type PayrollIntegrationsA3innuvaTariffGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  codes?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type PayrollIntegrationsA3innuvaTemporaryDisabilitiesManagersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type PayrollIntegrationsA3innuvaWorkplaceCodesArgs = {
  companyCodes: Array<Scalars['String']>;
  companyId: Scalars['Int'];
  currentUserId: Scalars['Int'];
  legalEntityId?: InputMaybe<Scalars['Int']>;
  organizationalUnitId?: InputMaybe<Scalars['String']>;
};


export type PayrollIntegrationsA3innuvaWorkplaceCodesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyCodes: Array<Scalars['String']>;
  companyId: Scalars['Int'];
  currentUserId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  organizationalUnitId?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};

export type PayrollIntegrationsA3innuvaMutations = {
  __typename?: 'payrollIntegrationsA3innuvaMutations';
  deletePayrollintegrationsA3innuvaOauthToken: DeletePayrollintegrationsA3innuvaOauthTokenPayload;
};


export type PayrollIntegrationsA3innuvaMutationsDeletePayrollintegrationsA3innuvaOauthTokenArgs = {
  organizationalUnitId: Scalars['String'];
};

export type PayrollIntegrationsBase = {
  __typename?: 'payrollIntegrationsBase';
  /** @deprecated Please favor `codesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  codes: Array<PayrollIntegrationsBaseCode>;
  codesConnection: PayrollIntegrationsBaseCodeConnection;
};


export type PayrollIntegrationsBaseCodesArgs = {
  code?: InputMaybe<Scalars['String']>;
  codeableId?: InputMaybe<Scalars['Int']>;
  codeableType?: InputMaybe<Scalars['String']>;
  forfaitJours?: InputMaybe<Scalars['Boolean']>;
  integrations: Array<PayrollIntegrationsBaseIntegrationEnum>;
};


export type PayrollIntegrationsBaseCodesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  codeableId?: InputMaybe<Scalars['Int']>;
  codeableType?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forfaitJours?: InputMaybe<Scalars['Boolean']>;
  integrations: Array<PayrollIntegrationsBaseIntegrationEnum>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

export type PayrollIntegrationsBaseMutations = {
  __typename?: 'payrollIntegrationsBaseMutations';
  createPayrollintegrationsBaseCode: CreatePayrollintegrationsBaseCodePayload;
  deletePayrollintegrationsBaseCode: DeletePayrollintegrationsBaseCodePayload;
  updatePayrollintegrationsBaseCode: UpdatePayrollintegrationsBaseCodePayload;
};


export type PayrollIntegrationsBaseMutationsCreatePayrollintegrationsBaseCodeArgs = {
  code: Scalars['String'];
  codeableId: Scalars['Int'];
  codeableType: Scalars['String'];
  forfaitJours?: InputMaybe<Scalars['Boolean']>;
  integration: PayrollIntegrationsBaseIntegrationEnum;
};


export type PayrollIntegrationsBaseMutationsDeletePayrollintegrationsBaseCodeArgs = {
  id: Scalars['Int'];
};


export type PayrollIntegrationsBaseMutationsUpdatePayrollintegrationsBaseCodeArgs = {
  code: Scalars['String'];
  id: Scalars['Int'];
};

export type PayrollMutations = {
  __typename?: 'payrollMutations';
  addResultConceptItemsPayrollResult: AddResultConceptItemsPayrollResultPayload;
  archivePayrollPolicy: ArchivePayrollPolicyPayload;
  buildPayrollResult: BuildPayrollResultPayload;
  bulkDestroyLegalEntitySupplementsPayrollSupplement: BulkDestroyLegalEntitySupplementsPayrollSupplementPayload;
  bulkDestroyPayrollResultLabelConceptMapping: BulkDestroyPayrollResultLabelConceptMappingPayload;
  bulkDestroyPayrollSupplementValidation: BulkDestroyPayrollSupplementValidationPayload;
  bulkDocumentCreatePayrollPayrollDocument: BulkDocumentCreatePayrollPayrollDocumentPayload;
  changeStatusPayrollPolicyPeriod: ChangeStatusPayrollPolicyPeriodPayload;
  closePayrollResult: ClosePayrollResultPayload;
  createPayrollConcept: CreatePayrollConceptPayload;
  createPayrollExpensesCategoriesContractsTaxonomy: CreatePayrollExpensesCategoriesContractsTaxonomyPayload;
  createPayrollFamilySituation: CreatePayrollFamilySituationPayload;
  createPayrollInhouseActivation: CreatePayrollInhouseActivationPayload;
  createPayrollOnboarding: CreatePayrollOnboardingPayload;
  createPayrollPayrollDocument: CreatePayrollPayrollDocumentPayload;
  createPayrollPayrollSummaryImport: CreatePayrollPayrollSummaryImportPayload;
  createPayrollPolicy: CreatePayrollPolicyPayload;
  createPayrollReimbursableSupplementTaxonomy: CreatePayrollReimbursableSupplementTaxonomyPayload;
  createPayrollResult: CreatePayrollResultPayload;
  createPayrollResultLabelConceptMapping: CreatePayrollResultLabelConceptMappingPayload;
  createPayrollSupplement: CreatePayrollSupplementPayload;
  createPayrollSupplementBulkImport: CreatePayrollSupplementBulkImportPayload;
  createPayrollSupplementObservation: CreatePayrollSupplementObservationPayload;
  createPayrollSupplementValidation: CreatePayrollSupplementValidationPayload;
  createWithEmployeesPayrollPolicy: CreateWithEmployeesPayrollPolicyPayload;
  deletePayrollResult: DeletePayrollResultPayload;
  deletePayrollSupplement: DeletePayrollSupplementPayload;
  deletePayrollSupplementObservation: DeletePayrollSupplementObservationPayload;
  deletePayrollSupplementValidation: DeletePayrollSupplementValidationPayload;
  destroyPayrollPayrollDocument: DestroyPayrollPayrollDocumentPayload;
  patchPayrollPolicy: PatchPayrollPolicyPayload;
  updateLaborCostPayrollLaborCostConfiguration: UpdateLaborCostPayrollLaborCostConfigurationPayload;
  updatePayrollConcept: UpdatePayrollConceptPayload;
  updatePayrollExpensesCategoriesContractsTaxonomy: UpdatePayrollExpensesCategoriesContractsTaxonomyPayload;
  updatePayrollFamilySituation: UpdatePayrollFamilySituationPayload;
  updatePayrollPayrollSummaryImport: UpdatePayrollPayrollSummaryImportPayload;
  updatePayrollReimbursableSupplementTaxonomy: UpdatePayrollReimbursableSupplementTaxonomyPayload;
  updatePayrollResultLabelConceptMapping: UpdatePayrollResultLabelConceptMappingPayload;
  updatePayrollSupplement: UpdatePayrollSupplementPayload;
  updatePayrollSupplementDescription: UpdatePayrollSupplementDescriptionPayload;
  updatePayrollSupplementObservation: UpdatePayrollSupplementObservationPayload;
};


export type PayrollMutationsAddResultConceptItemsPayrollResultArgs = {
  id: Scalars['Int'];
  resultConceptItems: Array<AddResultConceptItemsPayrollResultResultConceptItemsInput>;
};


export type PayrollMutationsArchivePayrollPolicyArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type PayrollMutationsBuildPayrollResultArgs = {
  authorId: Scalars['Int'];
  companyId: Scalars['Int'];
  compensationsPayrollRunId?: InputMaybe<Scalars['Int']>;
  concept?: InputMaybe<Scalars['String']>;
  documentId?: InputMaybe<Scalars['Int']>;
  filename: Scalars['String'];
  importProcessId?: InputMaybe<Scalars['Int']>;
  payrollPolicyPeriodId?: InputMaybe<Scalars['Int']>;
  resultConceptItems?: InputMaybe<Array<BuildPayrollResultResultConceptItemsInput>>;
  selectedFields: Scalars['String'];
};


export type PayrollMutationsBulkDestroyLegalEntitySupplementsPayrollSupplementArgs = {
  legalEntityId: Scalars['Int'];
};


export type PayrollMutationsBulkDestroyPayrollResultLabelConceptMappingArgs = {
  ids: Array<Scalars['Int']>;
};


export type PayrollMutationsBulkDestroyPayrollSupplementValidationArgs = {
  supplementIds: Array<Scalars['Int']>;
};


export type PayrollMutationsBulkDocumentCreatePayrollPayrollDocumentArgs = {
  authorId: Scalars['Int'];
  companyId: Scalars['Int'];
  files: Array<Scalars['File']>;
  folderId?: InputMaybe<Scalars['Int']>;
  policyPeriodId?: InputMaybe<Scalars['Int']>;
};


export type PayrollMutationsChangeStatusPayrollPolicyPeriodArgs = {
  employeeIds: Array<Scalars['Int']>;
  id: Scalars['Int'];
  notifyEmployee: Scalars['Boolean'];
  status: PayrollValueObjectsPolicyPeriodStatusEnum;
};


export type PayrollMutationsClosePayrollResultArgs = {
  id: Scalars['Int'];
};


export type PayrollMutationsCreatePayrollConceptArgs = {
  category: PayrollValueObjectsConceptCategoryEnum;
  companyId: Scalars['Int'];
  description?: InputMaybe<Scalars['String']>;
  label: Scalars['String'];
  unitType?: InputMaybe<PayrollValueObjectsConceptUnitTypeEnum>;
};


export type PayrollMutationsCreatePayrollExpensesCategoriesContractsTaxonomyArgs = {
  categoryId?: InputMaybe<Scalars['Int']>;
  contractsTaxonomyId: Scalars['Int'];
  expensesCategoryId: Scalars['String'];
};


export type PayrollMutationsCreatePayrollFamilySituationArgs = {
  civilStatus?: InputMaybe<PayrollFamilySituationCivilStatusEnum>;
  employeeId: Scalars['Int'];
  numberOfDependants?: InputMaybe<Scalars['Int']>;
};


export type PayrollMutationsCreatePayrollInhouseActivationArgs = {
  companyId: Scalars['Int'];
  incidenceOptionNames: Array<Scalars['String']>;
};


export type PayrollMutationsCreatePayrollOnboardingArgs = {
  incidenceOptions: Array<Scalars['String']>;
  policyWithEmployees: CreatePayrollOnboardingPolicyWithEmployeesInput;
};


export type PayrollMutationsCreatePayrollPayrollDocumentArgs = {
  documentId: Scalars['Int'];
  policyPeriodId?: InputMaybe<Scalars['Int']>;
};


export type PayrollMutationsCreatePayrollPayrollSummaryImportArgs = {
  companyId: Scalars['Int'];
  compensationType?: InputMaybe<Scalars['String']>;
  documentId?: InputMaybe<Scalars['Int']>;
  file?: InputMaybe<Scalars['File']>;
  policyPeriodId: Scalars['Int'];
};


export type PayrollMutationsCreatePayrollPolicyArgs = {
  companyId: Scalars['Int'];
  country?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  default?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  recurrence: Scalars['String'];
  startsOn: Scalars['ISO8601Date'];
};


export type PayrollMutationsCreatePayrollReimbursableSupplementTaxonomyArgs = {
  legalEntityId: Scalars['String'];
  reimbursableId: Scalars['String'];
  reimbursableType: Scalars['String'];
  supplementTaxonomyId: Scalars['String'];
};


export type PayrollMutationsCreatePayrollResultArgs = {
  authorId: Scalars['Int'];
  companyId: Scalars['Int'];
  compensationsPayrollRunId?: InputMaybe<Scalars['Int']>;
  concept?: InputMaybe<Scalars['String']>;
  documentId?: InputMaybe<Scalars['Int']>;
  filename: Scalars['String'];
  importProcessId?: InputMaybe<Scalars['Int']>;
  payrollPolicyPeriodId?: InputMaybe<Scalars['Int']>;
  resultConceptItems?: InputMaybe<Array<CreatePayrollResultResultConceptItemsInput>>;
  selectedFields: Scalars['String'];
};


export type PayrollMutationsCreatePayrollResultLabelConceptMappingArgs = {
  companyId: Scalars['Int'];
  conceptId: Scalars['Int'];
  label: Scalars['String'];
};


export type PayrollMutationsCreatePayrollSupplementArgs = {
  amountInCents: Scalars['Int'];
  contractsCompensationId?: InputMaybe<Scalars['Int']>;
  contractsTaxonomyId: Scalars['Int'];
  effectiveOn: Scalars['ISO8601Date'];
  employeeId: Scalars['Int'];
  equivalentMinutesInCents?: InputMaybe<Scalars['Int']>;
  ignorePeriodStatus: Scalars['Boolean'];
  minutesInCents?: InputMaybe<Scalars['Int']>;
  payrollPolicyPeriodId: Scalars['Int'];
  rawMinutesInCents?: InputMaybe<Scalars['Int']>;
  sourceId?: InputMaybe<Scalars['Int']>;
  sourceType?: InputMaybe<Scalars['String']>;
  supplementBulkImportId?: InputMaybe<Scalars['Int']>;
  unit?: InputMaybe<Scalars['String']>;
  workedDays?: InputMaybe<Scalars['Int']>;
};


export type PayrollMutationsCreatePayrollSupplementBulkImportArgs = {
  filename: Scalars['String'];
  policyPeriodId: Scalars['Int'];
  supplements: Array<CreatePayrollSupplementBulkImportSupplementsInput>;
};


export type PayrollMutationsCreatePayrollSupplementObservationArgs = {
  authorId?: InputMaybe<Scalars['Int']>;
  supplementId: Scalars['Int'];
  text: Scalars['String'];
  writtenAt: Scalars['String'];
};


export type PayrollMutationsCreatePayrollSupplementValidationArgs = {
  authorId: Scalars['Int'];
  employeeId: Scalars['Int'];
  supplementId: Scalars['Int'];
};


export type PayrollMutationsCreateWithEmployeesPayrollPolicyArgs = {
  employeeIds: Array<Scalars['String']>;
  policy: CreateWithEmployeesPayrollPolicyPolicyInput;
};


export type PayrollMutationsDeletePayrollResultArgs = {
  id: Scalars['Int'];
};


export type PayrollMutationsDeletePayrollSupplementArgs = {
  employeeId?: InputMaybe<Scalars['Int']>;
  error?: InputMaybe<PayrollValueObjectsBulkDeleteResultErrorCodeEnum>;
  id?: InputMaybe<Scalars['Int']>;
  sourceId?: InputMaybe<Scalars['Int']>;
  sourceType?: InputMaybe<Scalars['String']>;
  supplementType?: InputMaybe<Scalars['String']>;
};


export type PayrollMutationsDeletePayrollSupplementObservationArgs = {
  id: Scalars['Int'];
};


export type PayrollMutationsDeletePayrollSupplementValidationArgs = {
  id: Scalars['Int'];
};


export type PayrollMutationsDestroyPayrollPayrollDocumentArgs = {
  id: Scalars['Int'];
};


export type PayrollMutationsPatchPayrollPolicyArgs = {
  companyId: Scalars['Int'];
  country?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  default?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  recurrence: Scalars['String'];
  startsOn: Scalars['ISO8601Date'];
};


export type PayrollMutationsUpdateLaborCostPayrollLaborCostConfigurationArgs = {
  ids: Array<Scalars['Int']>;
};


export type PayrollMutationsUpdatePayrollConceptArgs = {
  category: PayrollValueObjectsConceptCategoryEnum;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  label: Scalars['String'];
  laborCost?: InputMaybe<Scalars['Boolean']>;
  unitType?: InputMaybe<PayrollValueObjectsConceptUnitTypeEnum>;
};


export type PayrollMutationsUpdatePayrollExpensesCategoriesContractsTaxonomyArgs = {
  contractsTaxonomyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type PayrollMutationsUpdatePayrollFamilySituationArgs = {
  civilStatus?: InputMaybe<PayrollFamilySituationCivilStatusEnum>;
  employeeId: Scalars['Int'];
  id: Scalars['Int'];
  numberOfDependants?: InputMaybe<Scalars['Int']>;
};


export type PayrollMutationsUpdatePayrollPayrollSummaryImportArgs = {
  companyIdentifierCell?: InputMaybe<Scalars['String']>;
  firstNameCell: Scalars['String'];
  id: Scalars['Int'];
  idCell?: InputMaybe<Scalars['String']>;
  lastNameCell: Scalars['String'];
  netSalaryCell: Scalars['String'];
};


export type PayrollMutationsUpdatePayrollReimbursableSupplementTaxonomyArgs = {
  id: Scalars['String'];
  supplementTaxonomyId: Scalars['String'];
};


export type PayrollMutationsUpdatePayrollResultLabelConceptMappingArgs = {
  conceptId: Scalars['Int'];
  id: Scalars['Int'];
};


export type PayrollMutationsUpdatePayrollSupplementArgs = {
  amountInCents?: InputMaybe<Scalars['Int']>;
  contractsCompensationId?: InputMaybe<Scalars['Int']>;
  contractsTaxonomiesId?: InputMaybe<Scalars['Int']>;
  contractsTaxonomyId?: InputMaybe<Scalars['Int']>;
  effectiveOn?: InputMaybe<Scalars['ISO8601Date']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  payrollPolicyPeriodId?: InputMaybe<Scalars['Int']>;
  unit?: InputMaybe<Scalars['String']>;
};


export type PayrollMutationsUpdatePayrollSupplementDescriptionArgs = {
  compensationAmount?: InputMaybe<Scalars['Int']>;
  supplementId: Scalars['Int'];
  workedDays?: InputMaybe<Scalars['Int']>;
};


export type PayrollMutationsUpdatePayrollSupplementObservationArgs = {
  id: Scalars['Int'];
  text: Scalars['String'];
};

/** Payload for payroll_run and subscription: data_updated */
export type Payroll_Run_Data_Updated_Type = {
  __typename?: 'payroll_run_data_updated_type';
  error?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  type: Scalars['String'];
};

export type PeopleChart = {
  __typename?: 'peopleChart';
  _policies: PeopleChartContextlessPolicies;
  structure?: Maybe<PeopleChartStructure>;
  /** @deprecated Please favor `structuresConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  structures: Array<PeopleChartStructure>;
  structuresConnection: PeopleChartStructureConnection;
};


export type PeopleChartStructureArgs = {
  id: Scalars['Int'];
};


export type PeopleChartStructuresArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type PeopleChartStructuresConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

export type PeopleChartMutations = {
  __typename?: 'peopleChartMutations';
  upsertPeoplechartStructure: UpsertPeoplechartStructurePayload;
};


export type PeopleChartMutationsUpsertPeoplechartStructureArgs = {
  companyId: Scalars['Int'];
  groups?: InputMaybe<Scalars['String']>;
  hierarchy: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
};

export type Performance = {
  __typename?: 'performance';
  _policies: PerformanceContextlessPolicies;
  agreement?: Maybe<PerformanceAgreement>;
  /** @deprecated Please favor `agreementActionItemsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  agreementActionItems: Array<PerformanceAgreementActionItem>;
  agreementActionItemsConnection: PerformanceAgreementActionItemConnection;
  agreementDocument?: Maybe<PerformanceAgreementDocument>;
  /** @deprecated Please favor `agreementDocumentsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  agreementDocuments: Array<PerformanceAgreementDocument>;
  agreementDocumentsConnection: PerformanceAgreementDocumentConnection;
  agreementTrainingRequest?: Maybe<PerformanceAgreementTrainingRequest>;
  /** @deprecated Please favor `agreementTrainingRequestsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  agreementTrainingRequests: Array<PerformanceAgreementTrainingRequest>;
  agreementTrainingRequestsConnection: PerformanceAgreementTrainingRequestConnection;
  /** @deprecated Please favor `agreementsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  agreements: Array<PerformanceAgreement>;
  agreementsConnection: PerformanceAgreementConnection;
  companyEmployeeScoreScale?: Maybe<PerformanceCompanyEmployeeScoreScale>;
  /** @deprecated Please favor `companyEmployeeScoreScalesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  companyEmployeeScoreScales: Array<PerformanceCompanyEmployeeScoreScale>;
  companyEmployeeScoreScalesConnection: PerformanceCompanyEmployeeScoreScaleConnection;
  /** @deprecated Please favor `employeePerformanceInsightsSummariesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  employeePerformanceInsightsSummaries: Array<PerformanceEmployeePerformanceInsightsSummary>;
  employeePerformanceInsightsSummariesConnection: PerformanceEmployeePerformanceInsightsSummaryConnection;
  employeePerformanceInsightsSummary?: Maybe<PerformanceEmployeePerformanceInsightsSummary>;
  employeePerformanceInsightsSummaryGroup?: Maybe<PerformanceEmployeePerformanceInsightsSummaryGroup>;
  /** @deprecated Please favor `employeePerformanceInsightsSummaryGroupsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  employeePerformanceInsightsSummaryGroups: Array<PerformanceEmployeePerformanceInsightsSummaryGroup>;
  employeePerformanceInsightsSummaryGroupsConnection: PerformanceEmployeePerformanceInsightsSummaryGroupConnection;
  employeeScoreScale?: Maybe<PerformanceEmployeeScoreScale>;
  /** @deprecated Please favor `employeeScoreScalesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  employeeScoreScales: Array<PerformanceEmployeeScoreScale>;
  employeeScoreScalesConnection: PerformanceEmployeeScoreScaleConnection;
  managerInsight?: Maybe<PerformanceManagerInsight>;
  /** @deprecated Please favor `managerInsightsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  managerInsights: Array<PerformanceManagerInsight>;
  managerInsightsConnection: PerformanceManagerInsightConnection;
  reviewEmployeeScoreGrid?: Maybe<PerformanceReviewEmployeeScoreGrid>;
  /** @deprecated Please favor `reviewEmployeeScoreGridsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  reviewEmployeeScoreGrids: Array<PerformanceReviewEmployeeScoreGrid>;
  reviewEmployeeScoreGridsConnection: PerformanceReviewEmployeeScoreGridConnection;
  reviewEmployeeScoreInsight?: Maybe<PerformanceReviewEmployeeScoreInsight>;
  /** @deprecated Please favor `reviewEmployeeScoreInsightsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  reviewEmployeeScoreInsights: Array<PerformanceReviewEmployeeScoreInsight>;
  reviewEmployeeScoreInsightsConnection: PerformanceReviewEmployeeScoreInsightConnection;
  reviewEvaluation?: Maybe<PerformanceReviewEvaluation>;
  reviewEvaluationAnswer?: Maybe<PerformanceReviewEvaluationAnswer>;
  /** @deprecated Please favor `reviewEvaluationAnswersConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  reviewEvaluationAnswers: Array<PerformanceReviewEvaluationAnswer>;
  reviewEvaluationAnswersConnection: PerformanceReviewEvaluationAnswerConnection;
  reviewEvaluationAnswersIdentifier?: Maybe<PerformanceReviewEvaluationAnswersIdentifier>;
  /** @deprecated Please favor `reviewEvaluationAnswersIdentifiersConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  reviewEvaluationAnswersIdentifiers: Array<PerformanceReviewEvaluationAnswersIdentifier>;
  reviewEvaluationAnswersIdentifiersConnection: PerformanceReviewEvaluationAnswersIdentifierConnection;
  reviewEvaluationCategorical?: Maybe<PerformanceReviewEvaluationCategorical>;
  /** @deprecated Please favor `reviewEvaluationCategoricalsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  reviewEvaluationCategoricals: Array<PerformanceReviewEvaluationCategorical>;
  reviewEvaluationCategoricalsConnection: PerformanceReviewEvaluationCategoricalConnection;
  reviewEvaluationEstimatedScore?: Maybe<PerformanceReviewEvaluationEstimatedScore>;
  /** @deprecated Please favor `reviewEvaluationEstimatedScoresConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  reviewEvaluationEstimatedScores: Array<PerformanceReviewEvaluationEstimatedScore>;
  reviewEvaluationEstimatedScoresConnection: PerformanceReviewEvaluationEstimatedScoreConnection;
  reviewEvaluationScore?: Maybe<PerformanceReviewEvaluationScore>;
  /** @deprecated Please favor `reviewEvaluationScoresConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  reviewEvaluationScores: Array<PerformanceReviewEvaluationScore>;
  reviewEvaluationScoresConnection: PerformanceReviewEvaluationScoreConnection;
  /** @deprecated Please favor `reviewEvaluationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  reviewEvaluations: Array<PerformanceReviewEvaluation>;
  reviewEvaluationsConnection: PerformanceReviewEvaluationConnection;
  reviewFinalEmployeeScore?: Maybe<PerformanceReviewFinalEmployeeScore>;
  /** @deprecated Please favor `reviewFinalEmployeeScoresConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  reviewFinalEmployeeScores: Array<PerformanceReviewFinalEmployeeScore>;
  reviewFinalEmployeeScoresConnection: PerformanceReviewFinalEmployeeScoreConnection;
  /** @deprecated Please favor `reviewOwnersConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  reviewOwners: Array<PerformanceReviewOwner>;
  reviewOwnersConnection: PerformanceReviewOwnerConnection;
  reviewProcess?: Maybe<PerformanceReviewProcess>;
  reviewProcessAnalytic?: Maybe<PerformanceReviewProcessAnalytic>;
  /** @deprecated Please favor `reviewProcessAnalyticsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  reviewProcessAnalytics: Array<PerformanceReviewProcessAnalytic>;
  reviewProcessAnalyticsConnection: PerformanceReviewProcessAnalyticConnection;
  reviewProcessCustomTemplate?: Maybe<PerformanceReviewProcessCustomTemplate>;
  /** @deprecated Please favor `reviewProcessCustomTemplateQuestionnaireByStrategiesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  reviewProcessCustomTemplateQuestionnaireByStrategies: Array<PerformanceReviewProcessCustomTemplateQuestionnaireByStrategy>;
  reviewProcessCustomTemplateQuestionnaireByStrategiesConnection: PerformanceReviewProcessCustomTemplateQuestionnaireByStrategyConnection;
  reviewProcessCustomTemplateQuestionnaireByStrategy?: Maybe<PerformanceReviewProcessCustomTemplateQuestionnaireByStrategy>;
  /** @deprecated Please favor `reviewProcessCustomTemplatesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  reviewProcessCustomTemplates: Array<PerformanceReviewProcessCustomTemplate>;
  reviewProcessCustomTemplatesConnection: PerformanceReviewProcessCustomTemplateConnection;
  reviewProcessCustomTemplatesEstimatedTarget?: Maybe<PerformanceReviewProcessCustomTemplatesEstimatedTarget>;
  /** @deprecated Please favor `reviewProcessCustomTemplatesEstimatedTargetsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  reviewProcessCustomTemplatesEstimatedTargets: Array<PerformanceReviewProcessCustomTemplatesEstimatedTarget>;
  reviewProcessCustomTemplatesEstimatedTargetsConnection: PerformanceReviewProcessCustomTemplatesEstimatedTargetConnection;
  /** @deprecated Please favor `reviewProcessEstimatedTargetsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  reviewProcessEstimatedTargets: Array<PerformanceReviewProcessEstimatedTarget>;
  reviewProcessEstimatedTargetsConnection: PerformanceReviewProcessEstimatedTargetConnection;
  reviewProcessMaterializedTarget?: Maybe<PerformanceReviewProcessMaterializedTarget>;
  /** @deprecated Please favor `reviewProcessMaterializedTargetsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  reviewProcessMaterializedTargets: Array<PerformanceReviewProcessMaterializedTarget>;
  reviewProcessMaterializedTargetsConnection: PerformanceReviewProcessMaterializedTargetConnection;
  reviewProcessParticipationRate?: Maybe<PerformanceReviewProcessParticipationRate>;
  /** @deprecated Please favor `reviewProcessParticipationRatesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  reviewProcessParticipationRates: Array<PerformanceReviewProcessParticipationRate>;
  reviewProcessParticipationRatesConnection: PerformanceReviewProcessParticipationRateConnection;
  /** @deprecated Please favor `reviewProcessScoreMetadataConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  reviewProcessScoreMetadata: Array<PerformanceReviewProcessScoreMetadatum>;
  reviewProcessScoreMetadataConnection: PerformanceReviewProcessScoreMetadatumConnection;
  reviewProcessScoreMetadatum?: Maybe<PerformanceReviewProcessScoreMetadatum>;
  reviewProcessStat?: Maybe<PerformanceReviewProcessStat>;
  /** @deprecated Please favor `reviewProcessStatsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  reviewProcessStats: Array<PerformanceReviewProcessStat>;
  reviewProcessStatsConnection: PerformanceReviewProcessStatConnection;
  reviewProcessTarget?: Maybe<PerformanceReviewProcessTarget>;
  /** @deprecated Please favor `reviewProcessTargetsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  reviewProcessTargets: Array<PerformanceReviewProcessTarget>;
  reviewProcessTargetsConnection: PerformanceReviewProcessTargetConnection;
  reviewProcessTemplate?: Maybe<PerformanceReviewProcessTemplate>;
  /** @deprecated Please favor `reviewProcessTemplatesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  reviewProcessTemplates: Array<PerformanceReviewProcessTemplate>;
  reviewProcessTemplatesConnection: PerformanceReviewProcessTemplateConnection;
  /** @deprecated Please favor `reviewProcessesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  reviewProcesses: Array<PerformanceReviewProcess>;
  reviewProcessesConnection: PerformanceReviewProcessConnection;
  /** @deprecated Please favor `reviewQuestionnaireByStrategiesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  reviewQuestionnaireByStrategies: Array<PerformanceReviewQuestionnaireByStrategy>;
  reviewQuestionnaireByStrategiesConnection: PerformanceReviewQuestionnaireByStrategyConnection;
  reviewQuestionnaireByStrategy?: Maybe<PerformanceReviewQuestionnaireByStrategy>;
  reviewStrategyEmployeeScore?: Maybe<PerformanceReviewStrategyEmployeeScore>;
  /** @deprecated Please favor `reviewStrategyEmployeeScoresConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  reviewStrategyEmployeeScores: Array<PerformanceReviewStrategyEmployeeScore>;
  reviewStrategyEmployeeScoresConnection: PerformanceReviewStrategyEmployeeScoreConnection;
  /** @deprecated Please favor `reviewVisibilitySettingsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  reviewVisibilitySettings: Array<PerformanceReviewVisibilitySetting>;
  reviewVisibilitySettingsConnection: PerformanceReviewVisibilitySettingConnection;
  scoreConfiguration?: Maybe<PerformanceScoreConfiguration>;
  /** @deprecated Please favor `scoreConfigurationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  scoreConfigurations: Array<PerformanceScoreConfiguration>;
  scoreConfigurationsConnection: PerformanceScoreConfigurationConnection;
  targetInsight?: Maybe<PerformanceTargetInsight>;
  targetInsightScore?: Maybe<PerformanceTargetInsightScore>;
  /** @deprecated Please favor `targetInsightScoresConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  targetInsightScores: Array<PerformanceTargetInsightScore>;
  targetInsightScoresConnection: PerformanceTargetInsightScoreConnection;
  /** @deprecated Please favor `targetInsightsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  targetInsights: Array<PerformanceTargetInsight>;
  targetInsightsConnection: PerformanceTargetInsightConnection;
  targetManager?: Maybe<PerformanceTargetManager>;
  /** @deprecated Please favor `targetManagersConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  targetManagers: Array<PerformanceTargetManager>;
  targetManagersConnection: PerformanceTargetManagerConnection;
};


export type PerformanceAgreementArgs = {
  id: Scalars['String'];
};


export type PerformanceAgreementActionItemsArgs = {
  agreementIds?: InputMaybe<Array<Scalars['String']>>;
};


export type PerformanceAgreementActionItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  agreementIds?: InputMaybe<Array<Scalars['String']>>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type PerformanceAgreementDocumentArgs = {
  id: Scalars['Int'];
};


export type PerformanceAgreementDocumentsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  performanceAgreementIds?: InputMaybe<Array<Scalars['String']>>;
};


export type PerformanceAgreementDocumentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  performanceAgreementIds?: InputMaybe<Array<Scalars['String']>>;
  sortOrder?: InputMaybe<Sort>;
};


export type PerformanceAgreementTrainingRequestArgs = {
  id: Scalars['Int'];
};


export type PerformanceAgreementTrainingRequestsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  performanceAgreementIds?: InputMaybe<Array<Scalars['String']>>;
};


export type PerformanceAgreementTrainingRequestsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  performanceAgreementIds?: InputMaybe<Array<Scalars['String']>>;
  sortOrder?: InputMaybe<Sort>;
};


export type PerformanceAgreementsArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
  materializedProcessTargetIds?: InputMaybe<Array<Scalars['Int']>>;
  processIds?: InputMaybe<Array<Scalars['Int']>>;
  targetIds?: InputMaybe<Array<Scalars['String']>>;
};


export type PerformanceAgreementsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  materializedProcessTargetIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  processIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
  targetIds?: InputMaybe<Array<Scalars['String']>>;
};


export type PerformanceCompanyEmployeeScoreScaleArgs = {
  id: Scalars['Int'];
};


export type PerformanceCompanyEmployeeScoreScalesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type PerformanceCompanyEmployeeScoreScalesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type PerformanceEmployeePerformanceInsightsSummariesArgs = {
  employeeIds?: Array<Scalars['Int']>;
  groupBy?: InputMaybe<Scalars['String']>;
  ids?: Array<Scalars['Int']>;
};


export type PerformanceEmployeePerformanceInsightsSummariesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: Array<Scalars['Int']>;
  filter?: InputMaybe<PerformanceEmployeePerformanceInsightsSummaryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  groupBy?: InputMaybe<Scalars['String']>;
  ids?: Array<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type PerformanceEmployeePerformanceInsightsSummaryArgs = {
  id: Scalars['Int'];
};


export type PerformanceEmployeePerformanceInsightsSummaryGroupArgs = {
  id: Scalars['Int'];
};


export type PerformanceEmployeePerformanceInsightsSummaryGroupsArgs = {
  employeeIds?: Array<Scalars['Int']>;
  groupBy?: InputMaybe<Scalars['String']>;
  ids?: Array<Scalars['Int']>;
};


export type PerformanceEmployeePerformanceInsightsSummaryGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: Array<Scalars['Int']>;
  filter?: InputMaybe<PerformanceEmployeePerformanceInsightsSummaryGroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  groupBy?: InputMaybe<Scalars['String']>;
  ids?: Array<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type PerformanceEmployeeScoreScaleArgs = {
  id: Scalars['Int'];
};


export type PerformanceEmployeeScoreScalesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type PerformanceEmployeeScoreScalesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type PerformanceManagerInsightArgs = {
  id: Scalars['String'];
};


export type PerformanceManagerInsightsArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
  managerAccessId?: InputMaybe<Scalars['Int']>;
  performanceReviewProcessIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type PerformanceManagerInsightsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  managerAccessId?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  performanceReviewProcessIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
};


export type PerformanceReviewEmployeeScoreGridArgs = {
  id: Scalars['String'];
};


export type PerformanceReviewEmployeeScoreGridsArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  genders?: InputMaybe<Array<Scalars['String']>>;
  gridStatus?: InputMaybe<Array<Scalars['String']>>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nationalities?: InputMaybe<Array<Scalars['String']>>;
  potentialScoreRange?: InputMaybe<Array<Scalars['String']>>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  pulseValues?: InputMaybe<Array<Scalars['Int']>>;
  scoreRange?: InputMaybe<Array<Scalars['String']>>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDate?: InputMaybe<Array<Scalars['String']>>;
  workspaceIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type PerformanceReviewEmployeeScoreGridsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  genders?: InputMaybe<Array<Scalars['String']>>;
  gridStatus?: InputMaybe<Array<Scalars['String']>>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nationalities?: InputMaybe<Array<Scalars['String']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  potentialScoreRange?: InputMaybe<Array<Scalars['String']>>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  pulseValues?: InputMaybe<Array<Scalars['Int']>>;
  scoreRange?: InputMaybe<Array<Scalars['String']>>;
  sortOrder?: InputMaybe<Sort>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDate?: InputMaybe<Array<Scalars['String']>>;
  workspaceIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type PerformanceReviewEmployeeScoreInsightArgs = {
  id: Scalars['Int'];
};


export type PerformanceReviewEmployeeScoreInsightsArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  genders?: InputMaybe<Array<Scalars['String']>>;
  gridStatus?: InputMaybe<Array<Scalars['String']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nationalities?: InputMaybe<Array<Scalars['String']>>;
  potentialScoreRange?: InputMaybe<Array<Scalars['String']>>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  pulseValues?: InputMaybe<Array<Scalars['Int']>>;
  scoreRange?: InputMaybe<Array<Scalars['String']>>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDate?: InputMaybe<Array<Scalars['String']>>;
  workspaceIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type PerformanceReviewEmployeeScoreInsightsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  genders?: InputMaybe<Array<Scalars['String']>>;
  gridStatus?: InputMaybe<Array<Scalars['String']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  nationalities?: InputMaybe<Array<Scalars['String']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  potentialScoreRange?: InputMaybe<Array<Scalars['String']>>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  pulseValues?: InputMaybe<Array<Scalars['Int']>>;
  scoreRange?: InputMaybe<Array<Scalars['String']>>;
  sortOrder?: InputMaybe<Sort>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDate?: InputMaybe<Array<Scalars['String']>>;
  workspaceIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type PerformanceReviewEvaluationArgs = {
  id: Scalars['Int'];
};


export type PerformanceReviewEvaluationAnswerArgs = {
  id: Scalars['Int'];
};


export type PerformanceReviewEvaluationAnswersArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  performanceReviewEvaluationIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type PerformanceReviewEvaluationAnswersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  performanceReviewEvaluationIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
};


export type PerformanceReviewEvaluationAnswersIdentifierArgs = {
  id: Scalars['Int'];
};


export type PerformanceReviewEvaluationAnswersIdentifiersArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  performanceReviewEvaluationIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type PerformanceReviewEvaluationAnswersIdentifiersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  performanceReviewEvaluationIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
};


export type PerformanceReviewEvaluationCategoricalArgs = {
  id: Scalars['Int'];
};


export type PerformanceReviewEvaluationCategoricalsArgs = {
  ids: Array<Scalars['Int']>;
  managedByFilter?: InputMaybe<ReviewEvaluationCategoricalsManagedByFilterInput>;
};


export type PerformanceReviewEvaluationCategoricalsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids: Array<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  managedByFilter?: InputMaybe<ReviewEvaluationCategoricalsManagedByFilterInput>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type PerformanceReviewEvaluationEstimatedScoreArgs = {
  id: Scalars['Int'];
};


export type PerformanceReviewEvaluationEstimatedScoresArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  performanceReviewEvaluationIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type PerformanceReviewEvaluationEstimatedScoresConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  performanceReviewEvaluationIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
};


export type PerformanceReviewEvaluationScoreArgs = {
  id: Scalars['Int'];
};


export type PerformanceReviewEvaluationScoresArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  reviewEvaluationIds?: InputMaybe<Array<Scalars['Int']>>;
  reviewProcessIds?: InputMaybe<Array<Scalars['Int']>>;
  reviewProcessTargetIds?: InputMaybe<Array<Scalars['String']>>;
  reviewerStrategies?: InputMaybe<Array<PerformanceReviewerStrategiesStrategyEnum>>;
  targetAccessIds?: InputMaybe<Array<Scalars['Int']>>;
  targetEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type PerformanceReviewEvaluationScoresConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<PerformanceReviewEvaluationScoreFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  reviewEvaluationIds?: InputMaybe<Array<Scalars['Int']>>;
  reviewProcessIds?: InputMaybe<Array<Scalars['Int']>>;
  reviewProcessTargetIds?: InputMaybe<Array<Scalars['String']>>;
  reviewerStrategies?: InputMaybe<Array<PerformanceReviewerStrategiesStrategyEnum>>;
  sortOrder?: InputMaybe<Sort>;
  targetAccessIds?: InputMaybe<Array<Scalars['Int']>>;
  targetEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type PerformanceReviewEvaluationsArgs = {
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  performanceReviewProcessIds?: InputMaybe<Array<Scalars['Int']>>;
  published?: InputMaybe<Scalars['Boolean']>;
  reviewProcessTargetIds?: InputMaybe<Array<Scalars['String']>>;
  reviewerIds?: InputMaybe<Array<Scalars['Int']>>;
  reviewerStrategies?: InputMaybe<Array<PerformanceReviewerStrategiesStrategyEnum>>;
  targetAccessIds?: InputMaybe<Array<Scalars['Int']>>;
  withTargetsManagedByFilter?: InputMaybe<ReviewEvaluationsWithTargetsManagedByFilterInput>;
};


export type PerformanceReviewEvaluationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  filter?: InputMaybe<PerformanceReviewEvaluationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  performanceReviewProcessIds?: InputMaybe<Array<Scalars['Int']>>;
  published?: InputMaybe<Scalars['Boolean']>;
  reviewProcessTargetIds?: InputMaybe<Array<Scalars['String']>>;
  reviewerIds?: InputMaybe<Array<Scalars['Int']>>;
  reviewerStrategies?: InputMaybe<Array<PerformanceReviewerStrategiesStrategyEnum>>;
  sortOrder?: InputMaybe<Sort>;
  targetAccessIds?: InputMaybe<Array<Scalars['Int']>>;
  withTargetsManagedByFilter?: InputMaybe<ReviewEvaluationsWithTargetsManagedByFilterInput>;
};


export type PerformanceReviewFinalEmployeeScoreArgs = {
  id: Scalars['Int'];
};


export type PerformanceReviewFinalEmployeeScoresArgs = {
  agreementCompletionStatus?: InputMaybe<PerformanceDtosReviewProcessTargetAgreementCompletionStatusEnum>;
  evaluationsCompletionStatus?: InputMaybe<PerformanceReviewEvaluationStatusEnum>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  managedByFilter?: InputMaybe<ReviewFinalEmployeeScoresManagedByFilterInput>;
  materializedProcessTargetIds?: InputMaybe<Array<Scalars['Int']>>;
  reviewProcessIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  targetAccessIds?: InputMaybe<Array<Scalars['Int']>>;
  targetEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDates?: InputMaybe<Array<Scalars['String']>>;
  workplaceIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type PerformanceReviewFinalEmployeeScoresConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  agreementCompletionStatus?: InputMaybe<PerformanceDtosReviewProcessTargetAgreementCompletionStatusEnum>;
  before?: InputMaybe<Scalars['String']>;
  evaluationsCompletionStatus?: InputMaybe<PerformanceReviewEvaluationStatusEnum>;
  filter?: InputMaybe<PerformanceReviewFinalEmployeeScoreFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  managedByFilter?: InputMaybe<ReviewFinalEmployeeScoresManagedByFilterInput>;
  materializedProcessTargetIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  reviewProcessIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  targetAccessIds?: InputMaybe<Array<Scalars['Int']>>;
  targetEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDates?: InputMaybe<Array<Scalars['String']>>;
  workplaceIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type PerformanceReviewOwnersArgs = {
  performanceReviewProcessIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type PerformanceReviewOwnersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  performanceReviewProcessIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
};


export type PerformanceReviewProcessArgs = {
  id: Scalars['Int'];
};


export type PerformanceReviewProcessAnalyticArgs = {
  id: Scalars['String'];
};


export type PerformanceReviewProcessAnalyticsArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
  performanceReviewProcessIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  withTargetsManagedByFilter?: InputMaybe<ReviewProcessAnalyticsWithTargetsManagedByFilterInput>;
};


export type PerformanceReviewProcessAnalyticsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  performanceReviewProcessIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  withTargetsManagedByFilter?: InputMaybe<ReviewProcessAnalyticsWithTargetsManagedByFilterInput>;
};


export type PerformanceReviewProcessCustomTemplateArgs = {
  id: Scalars['Int'];
};


export type PerformanceReviewProcessCustomTemplateQuestionnaireByStrategiesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type PerformanceReviewProcessCustomTemplateQuestionnaireByStrategiesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type PerformanceReviewProcessCustomTemplateQuestionnaireByStrategyArgs = {
  id: Scalars['Int'];
};


export type PerformanceReviewProcessCustomTemplatesArgs = {
  authorIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


export type PerformanceReviewProcessCustomTemplatesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  authorIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<PerformanceReviewProcessCustomTemplateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type PerformanceReviewProcessCustomTemplatesEstimatedTargetArgs = {
  id: Scalars['String'];
};


export type PerformanceReviewProcessCustomTemplatesEstimatedTargetsArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  performanceCustomTemplateIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


export type PerformanceReviewProcessCustomTemplatesEstimatedTargetsConnectionArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<PerformanceReviewProcessCustomTemplatesEstimatedTargetFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  performanceCustomTemplateIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type PerformanceReviewProcessEstimatedTargetsArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  performanceReviewProcessIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


export type PerformanceReviewProcessEstimatedTargetsConnectionArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<PerformanceReviewProcessEstimatedTargetFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  performanceReviewProcessIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type PerformanceReviewProcessMaterializedTargetArgs = {
  id: Scalars['Int'];
};


export type PerformanceReviewProcessMaterializedTargetsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type PerformanceReviewProcessMaterializedTargetsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type PerformanceReviewProcessParticipationRateArgs = {
  id: Scalars['Int'];
};


export type PerformanceReviewProcessParticipationRatesArgs = {
  agreementCompletionStatus?: InputMaybe<PerformanceDtosReviewProcessTargetAgreementCompletionStatusEnum>;
  finalScores?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  managedByFilter?: InputMaybe<ReviewProcessParticipationRatesManagedByFilterInput>;
  reviewerIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  targetEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDates?: InputMaybe<Array<Scalars['String']>>;
  workplaceIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type PerformanceReviewProcessParticipationRatesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  agreementCompletionStatus?: InputMaybe<PerformanceDtosReviewProcessTargetAgreementCompletionStatusEnum>;
  before?: InputMaybe<Scalars['String']>;
  finalScores?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  managedByFilter?: InputMaybe<ReviewProcessParticipationRatesManagedByFilterInput>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  reviewerIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  targetEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDates?: InputMaybe<Array<Scalars['String']>>;
  workplaceIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type PerformanceReviewProcessScoreMetadataArgs = {
  ids: Array<Scalars['Int']>;
  managedByFilter?: InputMaybe<ReviewProcessScoreMetadataManagedByFilterInput>;
};


export type PerformanceReviewProcessScoreMetadataConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids: Array<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  managedByFilter?: InputMaybe<ReviewProcessScoreMetadataManagedByFilterInput>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type PerformanceReviewProcessScoreMetadatumArgs = {
  id: Scalars['Int'];
};


export type PerformanceReviewProcessStatArgs = {
  id: Scalars['Int'];
};


export type PerformanceReviewProcessStatsArgs = {
  evaluationTypes?: InputMaybe<Array<PerformanceReviewerStrategiesStrategyEnum>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  onlyManagedEmployeesAsTarget?: InputMaybe<Scalars['Boolean']>;
  performanceReviewProcessIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type PerformanceReviewProcessStatsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  evaluationTypes?: InputMaybe<Array<PerformanceReviewerStrategiesStrategyEnum>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyManagedEmployeesAsTarget?: InputMaybe<Scalars['Boolean']>;
  performanceReviewProcessIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
};


export type PerformanceReviewProcessTargetArgs = {
  id: Scalars['String'];
};


export type PerformanceReviewProcessTargetsArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  agreementCompletionStatus?: InputMaybe<PerformanceDtosReviewProcessTargetAgreementCompletionStatusEnum>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  evaluationsCompletionStatus?: InputMaybe<PerformanceReviewEvaluationStatusEnum>;
  finalScores?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  includeArchivedReviews?: InputMaybe<Scalars['Boolean']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  managedByFilter?: InputMaybe<ReviewProcessTargetsManagedByFilterInput>;
  onlyForPeerAssignment?: InputMaybe<Scalars['Boolean']>;
  pendingPeerEvaluations?: InputMaybe<Scalars['Boolean']>;
  performanceReviewProcessIds?: InputMaybe<Array<Scalars['Int']>>;
  performanceReviewProcessStatus?: InputMaybe<Array<PerformanceReviewProcessStatusEnum>>;
  search?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDates?: InputMaybe<Array<Scalars['String']>>;
  toConductAgreement?: InputMaybe<Scalars['Boolean']>;
  withoutManager?: InputMaybe<Scalars['Boolean']>;
  workplaceIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type PerformanceReviewProcessTargetsConnectionArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  after?: InputMaybe<Scalars['String']>;
  agreementCompletionStatus?: InputMaybe<PerformanceDtosReviewProcessTargetAgreementCompletionStatusEnum>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  evaluationsCompletionStatus?: InputMaybe<PerformanceReviewEvaluationStatusEnum>;
  filter?: InputMaybe<PerformanceReviewProcessTargetFilter>;
  finalScores?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  globalSearch?: InputMaybe<PerformanceReviewProcessTargetGlobalSearch>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  includeArchivedReviews?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  managedByFilter?: InputMaybe<ReviewProcessTargetsManagedByFilterInput>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyForPeerAssignment?: InputMaybe<Scalars['Boolean']>;
  pendingPeerEvaluations?: InputMaybe<Scalars['Boolean']>;
  performanceReviewProcessIds?: InputMaybe<Array<Scalars['Int']>>;
  performanceReviewProcessStatus?: InputMaybe<Array<PerformanceReviewProcessStatusEnum>>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDates?: InputMaybe<Array<Scalars['String']>>;
  toConductAgreement?: InputMaybe<Scalars['Boolean']>;
  withoutManager?: InputMaybe<Scalars['Boolean']>;
  workplaceIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type PerformanceReviewProcessTemplateArgs = {
  id: Scalars['Int'];
};


export type PerformanceReviewProcessTemplatesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


export type PerformanceReviewProcessTemplatesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<PerformanceReviewProcessTemplateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type PerformanceReviewProcessesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


export type PerformanceReviewProcessesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<PerformanceReviewProcessFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type PerformanceReviewQuestionnaireByStrategiesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type PerformanceReviewQuestionnaireByStrategiesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type PerformanceReviewQuestionnaireByStrategyArgs = {
  id: Scalars['Int'];
};


export type PerformanceReviewStrategyEmployeeScoreArgs = {
  id: Scalars['Int'];
};


export type PerformanceReviewStrategyEmployeeScoresArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  managedByFilter?: InputMaybe<ReviewStrategyEmployeeScoresManagedByFilterInput>;
  materializedProcessTargetIds?: InputMaybe<Array<Scalars['Int']>>;
  reviewProcessIds?: InputMaybe<Array<Scalars['Int']>>;
  reviewerStrategies?: InputMaybe<Array<PerformanceReviewerStrategiesStrategyEnum>>;
  targetAccessIds?: InputMaybe<Array<Scalars['Int']>>;
  targetEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type PerformanceReviewStrategyEmployeeScoresConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  managedByFilter?: InputMaybe<ReviewStrategyEmployeeScoresManagedByFilterInput>;
  materializedProcessTargetIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  reviewProcessIds?: InputMaybe<Array<Scalars['Int']>>;
  reviewerStrategies?: InputMaybe<Array<PerformanceReviewerStrategiesStrategyEnum>>;
  sortOrder?: InputMaybe<Sort>;
  targetAccessIds?: InputMaybe<Array<Scalars['Int']>>;
  targetEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type PerformanceReviewVisibilitySettingsArgs = {
  performanceReviewProcessIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type PerformanceReviewVisibilitySettingsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  performanceReviewProcessIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
};


export type PerformanceScoreConfigurationArgs = {
  id: Scalars['Int'];
};


export type PerformanceScoreConfigurationsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  questionnaireableIds?: InputMaybe<Array<Scalars['Int']>>;
  questionnaireableType?: InputMaybe<PerformanceValueObjectsQuestionnaireableEnum>;
};


export type PerformanceScoreConfigurationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  questionnaireableIds?: InputMaybe<Array<Scalars['Int']>>;
  questionnaireableType?: InputMaybe<PerformanceValueObjectsQuestionnaireableEnum>;
  sortOrder?: InputMaybe<Sort>;
};


export type PerformanceTargetInsightArgs = {
  id: Scalars['String'];
};


export type PerformanceTargetInsightScoreArgs = {
  id: Scalars['String'];
};


export type PerformanceTargetInsightScoresArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};


export type PerformanceTargetInsightScoresConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type PerformanceTargetInsightsArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
  performanceReviewProcessIds?: InputMaybe<Array<Scalars['Int']>>;
  targetAccessId?: InputMaybe<Scalars['Int']>;
};


export type PerformanceTargetInsightsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  performanceReviewProcessIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
  targetAccessId?: InputMaybe<Scalars['Int']>;
};


export type PerformanceTargetManagerArgs = {
  id: Scalars['Int'];
  performanceReviewProcessIds: Array<Scalars['Int']>;
};


export type PerformanceTargetManagersArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  performanceReviewProcessIds: Array<Scalars['Int']>;
};


export type PerformanceTargetManagersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  performanceReviewProcessIds: Array<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

export type PerformanceCycles = {
  __typename?: 'performanceCycles';
  _policies: PerformanceCyclesContextlessPolicies;
  cycle?: Maybe<PerformanceCyclesCycle>;
  /** @deprecated Please favor `cyclesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  cycles: Array<PerformanceCyclesCycle>;
  cyclesConnection: PerformanceCyclesCycleConnection;
};


export type PerformanceCyclesCycleArgs = {
  id: Scalars['String'];
};


export type PerformanceCyclesCyclesArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};


export type PerformanceCyclesCyclesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

export type PerformanceCyclesMutations = {
  __typename?: 'performanceCyclesMutations';
  createPerformancecyclesCycle: CreatePerformancecyclesCyclePayload;
  deletePerformancecyclesCycle: DeletePerformancecyclesCyclePayload;
  updatePerformancecyclesCycle: UpdatePerformancecyclesCyclePayload;
};


export type PerformanceCyclesMutationsCreatePerformancecyclesCycleArgs = {
  companyId: Scalars['Int'];
  endOn: Scalars['ISO8601Date'];
  startOn: Scalars['ISO8601Date'];
  title: Scalars['String'];
};


export type PerformanceCyclesMutationsDeletePerformancecyclesCycleArgs = {
  id: Scalars['String'];
};


export type PerformanceCyclesMutationsUpdatePerformancecyclesCycleArgs = {
  endOn?: InputMaybe<Scalars['ISO8601Date']>;
  id: Scalars['String'];
  startOn?: InputMaybe<Scalars['ISO8601Date']>;
  title?: InputMaybe<Scalars['String']>;
};

export type PerformanceGoals = {
  __typename?: 'performanceGoals';
  goal?: Maybe<PerformanceGoalsGoal>;
  /** @deprecated Please favor `goalsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  goals: Array<PerformanceGoalsGoal>;
  goalsConnection: PerformanceGoalsGoalConnection;
  metricConfiguration?: Maybe<PerformanceGoalsMetricConfiguration>;
  /** @deprecated Please favor `metricConfigurationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  metricConfigurations: Array<PerformanceGoalsMetricConfiguration>;
  metricConfigurationsConnection: PerformanceGoalsMetricConfigurationConnection;
  metricValue?: Maybe<PerformanceGoalsMetricValue>;
  /** @deprecated Please favor `metricValuesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  metricValues: Array<PerformanceGoalsMetricValue>;
  metricValuesConnection: PerformanceGoalsMetricValueConnection;
};


export type PerformanceGoalsGoalArgs = {
  id: Scalars['String'];
};


export type PerformanceGoalsGoalsArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};


export type PerformanceGoalsGoalsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type PerformanceGoalsMetricConfigurationArgs = {
  id: Scalars['Int'];
};


export type PerformanceGoalsMetricConfigurationsArgs = {
  goalIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type PerformanceGoalsMetricConfigurationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  goalIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type PerformanceGoalsMetricValueArgs = {
  id: Scalars['Int'];
};


export type PerformanceGoalsMetricValuesArgs = {
  createdByEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  metricConfigurationIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type PerformanceGoalsMetricValuesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  createdByEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  metricConfigurationIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

export type PerformanceMutations = {
  __typename?: 'performanceMutations';
  addPeersPerformanceReviewProcessTarget: AddPeersPerformanceReviewProcessTargetPayload;
  addPerformanceAgreementActionItem: AddPerformanceAgreementActionItemPayload;
  addTrainingRequestPerformanceAgreement: AddTrainingRequestPerformanceAgreementPayload;
  bulkCreatePerformanceReviewOwner: BulkCreatePerformanceReviewOwnerPayload;
  bulkCreatePerformanceReviewProcessTarget: BulkCreatePerformanceReviewProcessTargetPayload;
  bulkInitiatePerformanceAgreement: BulkInitiatePerformanceAgreementPayload;
  createFromPredefinedTemplatePerformanceReviewProcessCustomTemplate: CreateFromPredefinedTemplatePerformanceReviewProcessCustomTemplatePayload;
  createFromReviewProcessPerformanceReviewProcessCustomTemplate: CreateFromReviewProcessPerformanceReviewProcessCustomTemplatePayload;
  createFromTemplatePerformanceReviewProcess: CreateFromTemplatePerformanceReviewProcessPayload;
  createPerformanceReviewProcess: CreatePerformanceReviewProcessPayload;
  deletePerformanceAgreementActionItem: DeletePerformanceAgreementActionItemPayload;
  deletePerformanceReviewOwner: DeletePerformanceReviewOwnerPayload;
  deletePerformanceReviewProcess: DeletePerformanceReviewProcessPayload;
  deletePerformanceReviewProcessCustomTemplate: DeletePerformanceReviewProcessCustomTemplatePayload;
  deletePerformanceReviewProcessTarget: DeletePerformanceReviewProcessTargetPayload;
  deletePerformanceScoreConfiguration: DeletePerformanceScoreConfigurationPayload;
  draftPerformanceReviewEvaluationAnswer: DraftPerformanceReviewEvaluationAnswerPayload;
  duplicatePerformanceReviewProcess: DuplicatePerformanceReviewProcessPayload;
  duplicatePerformanceReviewProcessCustomTemplate: DuplicatePerformanceReviewProcessCustomTemplatePayload;
  estimatePerformanceReviewEvaluationEstimatedScore: EstimatePerformanceReviewEvaluationEstimatedScorePayload;
  exportPerformanceReviewProcess: ExportPerformanceReviewProcessPayload;
  generateDocumentPerformanceAgreement: GenerateDocumentPerformanceAgreementPayload;
  generateForFiltersPerformanceReviewAggregation: GenerateForFiltersPerformanceReviewAggregationPayload;
  generatePerformanceReviewAggregation: GeneratePerformanceReviewAggregationPayload;
  initiatePerformanceAgreement: InitiatePerformanceAgreementPayload;
  parseAndUpdateQuestionnaireForStrategyPerformanceReviewProcessCustomTemplateQuestionnaireByStrategy: ParseAndUpdateQuestionnaireForStrategyPerformanceReviewProcessCustomTemplateQuestionnaireByStrategyPayload;
  parseAndUpdateQuestionnaireForStrategyPerformanceReviewQuestionnaireByStrategy: ParseAndUpdateQuestionnaireForStrategyPerformanceReviewQuestionnaireByStrategyPayload;
  publishPerformanceReviewEvaluationAnswer: PublishPerformanceReviewEvaluationAnswerPayload;
  refreshPerformanceAgreement: RefreshPerformanceAgreementPayload;
  remindInBulkPerformanceReviewProcess: RemindInBulkPerformanceReviewProcessPayload;
  removePeerEvaluationsPerformanceReviewProcessTarget: RemovePeerEvaluationsPerformanceReviewProcessTargetPayload;
  removeSchedulePerformanceReviewProcess: RemoveSchedulePerformanceReviewProcessPayload;
  reopenPerformanceReviewProcess: ReopenPerformanceReviewProcessPayload;
  replaceEmployeeReviewerPerformanceReviewEvaluation: ReplaceEmployeeReviewerPerformanceReviewEvaluationPayload;
  replaceReviewerPerformanceReviewEvaluation: ReplaceReviewerPerformanceReviewEvaluationPayload;
  republishPerformanceReviewEvaluationAnswer: RepublishPerformanceReviewEvaluationAnswerPayload;
  schedulePerformanceReviewProcess: SchedulePerformanceReviewProcessPayload;
  setModePerformanceScoreConfiguration: SetModePerformanceScoreConfigurationPayload;
  setPerformanceCompanyEmployeeScoreScale: SetPerformanceCompanyEmployeeScoreScalePayload;
  setWeightsPerformanceScoreConfiguration: SetWeightsPerformanceScoreConfigurationPayload;
  signAsEmployeePerformanceAgreement: SignAsEmployeePerformanceAgreementPayload;
  signAsManagerPerformanceAgreement: SignAsManagerPerformanceAgreementPayload;
  startPerformanceReviewProcess: StartPerformanceReviewProcessPayload;
  stopPerformanceReviewProcess: StopPerformanceReviewProcessPayload;
  toggleArchivePerformanceReviewProcess: ToggleArchivePerformanceReviewProcessPayload;
  unsignAsEmployeePerformanceAgreement: UnsignAsEmployeePerformanceAgreementPayload;
  unsignAsManagerPerformanceAgreement: UnsignAsManagerPerformanceAgreementPayload;
  updateAgreementsConfigurationPerformanceReviewProcess: UpdateAgreementsConfigurationPerformanceReviewProcessPayload;
  updateAuthorPerformanceReviewProcessCustomTemplate: UpdateAuthorPerformanceReviewProcessCustomTemplatePayload;
  updateBasicInfoPerformanceReviewProcess: UpdateBasicInfoPerformanceReviewProcessPayload;
  updateBasicInfoPerformanceReviewProcessCustomTemplate: UpdateBasicInfoPerformanceReviewProcessCustomTemplatePayload;
  updateCompetenciesAssessmentsConfigurationPerformanceReviewProcess: UpdateCompetenciesAssessmentsConfigurationPerformanceReviewProcessPayload;
  updateConclusionsPerformanceAgreement: UpdateConclusionsPerformanceAgreementPayload;
  updateCyclePerformanceReviewProcess: UpdateCyclePerformanceReviewProcessPayload;
  updateDeadlinePerformanceReviewProcess: UpdateDeadlinePerformanceReviewProcessPayload;
  updateDefaultRatingScalePerformanceReviewProcessCustomTemplateQuestionnaireByStrategy: UpdateDefaultRatingScalePerformanceReviewProcessCustomTemplateQuestionnaireByStrategyPayload;
  updateDefaultRatingScalePerformanceReviewQuestionnaireByStrategy: UpdateDefaultRatingScalePerformanceReviewQuestionnaireByStrategyPayload;
  updateEmployeePotentialScoreConfigurationPerformanceReviewProcess: UpdateEmployeePotentialScoreConfigurationPerformanceReviewProcessPayload;
  updateEmployeeScoreConfigurationPerformanceReviewProcess: UpdateEmployeeScoreConfigurationPerformanceReviewProcessPayload;
  updateFeaturesPerformanceReviewProcessCustomTemplate: UpdateFeaturesPerformanceReviewProcessCustomTemplatePayload;
  updatePerformanceAgreementActionItem: UpdatePerformanceAgreementActionItemPayload;
  updatePerformanceReviewVisibilitySetting: UpdatePerformanceReviewVisibilitySettingPayload;
  updateQuestionnaireForStrategyPerformanceReviewProcessCustomTemplateQuestionnaireByStrategy: UpdateQuestionnaireForStrategyPerformanceReviewProcessCustomTemplateQuestionnaireByStrategyPayload;
  updateQuestionnaireForStrategyPerformanceReviewQuestionnaireByStrategy: UpdateQuestionnaireForStrategyPerformanceReviewQuestionnaireByStrategyPayload;
  updateRepublishEvaluationsConfigurationPerformanceReviewProcess: UpdateRepublishEvaluationsConfigurationPerformanceReviewProcessPayload;
  updateReviewerStrategiesPerformanceReviewProcess: UpdateReviewerStrategiesPerformanceReviewProcessPayload;
  updateReviewerStrategiesPerformanceReviewProcessCustomTemplate: UpdateReviewerStrategiesPerformanceReviewProcessCustomTemplatePayload;
  updateSchedulePerformanceReviewProcess: UpdateSchedulePerformanceReviewProcessPayload;
  updateTargetStrategyPerformanceReviewProcess: UpdateTargetStrategyPerformanceReviewProcessPayload;
  updateTargetStrategyPerformanceReviewProcessCustomTemplate: UpdateTargetStrategyPerformanceReviewProcessCustomTemplatePayload;
  updateVisibilitySettingsPerformanceReviewProcessCustomTemplate: UpdateVisibilitySettingsPerformanceReviewProcessCustomTemplatePayload;
  upsertManagerQuestionCommentPerformanceAgreement: UpsertManagerQuestionCommentPerformanceAgreementPayload;
  upsertSelfQuestionCommentPerformanceAgreement: UpsertSelfQuestionCommentPerformanceAgreementPayload;
};


export type PerformanceMutationsAddPeersPerformanceReviewProcessTargetArgs = {
  id: Scalars['String'];
  peerAccessIds: Array<Scalars['Int']>;
  peerEmployeeIds: Array<Scalars['Int']>;
};


export type PerformanceMutationsAddPerformanceAgreementActionItemArgs = {
  agreementId: Scalars['String'];
  text: Scalars['String'];
};


export type PerformanceMutationsAddTrainingRequestPerformanceAgreementArgs = {
  agreementId: Scalars['String'];
  trainingComment?: InputMaybe<Scalars['String']>;
  trainingId: Scalars['Int'];
  trainingNeed: Scalars['String'];
};


export type PerformanceMutationsBulkCreatePerformanceReviewOwnerArgs = {
  ownerAccessIds: Array<Scalars['Int']>;
  reviewProcessId: Scalars['Int'];
};


export type PerformanceMutationsBulkCreatePerformanceReviewProcessTargetArgs = {
  employeeSelection?: InputMaybe<EmployeesEmployeeSelectorInput>;
  performanceReviewProcessId: Scalars['Int'];
  targetsAccessIds: Array<Scalars['Int']>;
  targetsEmployeeIds: Array<Scalars['Int']>;
};


export type PerformanceMutationsBulkInitiatePerformanceAgreementArgs = {
  processId: Scalars['Int'];
};


export type PerformanceMutationsCreateFromPredefinedTemplatePerformanceReviewProcessCustomTemplateArgs = {
  authorId: Scalars['Int'];
  companyId: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  predefinedTemplateId: Scalars['Int'];
  templateDescription?: InputMaybe<Scalars['String']>;
};


export type PerformanceMutationsCreateFromReviewProcessPerformanceReviewProcessCustomTemplateArgs = {
  authorId: Scalars['Int'];
  name: Scalars['String'];
  reviewProcessId: Scalars['Int'];
  templateDescription?: InputMaybe<Scalars['String']>;
};


export type PerformanceMutationsCreateFromTemplatePerformanceReviewProcessArgs = {
  authorAccessId: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  templateId: Scalars['Int'];
  templateType?: InputMaybe<PerformanceDtosReviewProcessCreateFromTemplateTemplateTypeEnum>;
};


export type PerformanceMutationsCreatePerformanceReviewProcessArgs = {
  agreementsEnabled?: InputMaybe<Scalars['Boolean']>;
  agreementsEsignatureEnabled?: InputMaybe<Scalars['Boolean']>;
  arguments?: InputMaybe<Array<Scalars['Int']>>;
  authorAccessId: Scalars['Int'];
  competenciesAssessmentsEnabled?: InputMaybe<Scalars['Boolean']>;
  customSectionWeightsEnabled?: InputMaybe<Scalars['Boolean']>;
  cycleId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  employeePotentialScoreEnabled?: InputMaybe<Scalars['Boolean']>;
  employeeScoreEnabled?: InputMaybe<Scalars['Boolean']>;
  endsAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  name?: InputMaybe<Scalars['String']>;
  republishEvaluationsEnabled?: InputMaybe<Scalars['Boolean']>;
  reviewerStrategies?: InputMaybe<Array<PerformanceReviewerStrategiesStrategyEnum>>;
  targetStrategy?: InputMaybe<PerformanceTargetStrategySupportedStrategiesEnum>;
};


export type PerformanceMutationsDeletePerformanceAgreementActionItemArgs = {
  agreementId: Scalars['String'];
  id: Scalars['String'];
};


export type PerformanceMutationsDeletePerformanceReviewOwnerArgs = {
  id: Scalars['Int'];
};


export type PerformanceMutationsDeletePerformanceReviewProcessArgs = {
  id: Scalars['Int'];
};


export type PerformanceMutationsDeletePerformanceReviewProcessCustomTemplateArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type PerformanceMutationsDeletePerformanceReviewProcessTargetArgs = {
  id?: InputMaybe<Scalars['String']>;
  performanceReviewProcessId?: InputMaybe<Scalars['Int']>;
  targetAccessId?: InputMaybe<Scalars['Int']>;
};


export type PerformanceMutationsDeletePerformanceScoreConfigurationArgs = {
  questionnaireableId?: InputMaybe<Scalars['Int']>;
  questionnaireableType: PerformanceValueObjectsQuestionnaireableEnum;
};


export type PerformanceMutationsDraftPerformanceReviewEvaluationAnswerArgs = {
  answers: Array<PerformanceAnswerInput>;
  competenciesAnswers?: InputMaybe<Array<PerformanceAnswerInput>>;
  employeePotentialScoreAnswer?: InputMaybe<PerformanceAnswerInput>;
  employeeScoreAnswer?: InputMaybe<PerformanceAnswerInput>;
  performanceReviewEvaluationId: Scalars['Int'];
};


export type PerformanceMutationsDuplicatePerformanceReviewProcessArgs = {
  authorAccessId: Scalars['Int'];
  id: Scalars['Int'];
};


export type PerformanceMutationsDuplicatePerformanceReviewProcessCustomTemplateArgs = {
  authorId: Scalars['Int'];
  id: Scalars['Int'];
};


export type PerformanceMutationsEstimatePerformanceReviewEvaluationEstimatedScoreArgs = {
  answers: Array<PerformanceAnswerInput>;
  competenciesAnswers?: InputMaybe<Array<PerformanceAnswerInput>>;
  employeePotentialScoreAnswer?: InputMaybe<PerformanceAnswerInput>;
  employeeScoreAnswer?: InputMaybe<PerformanceAnswerInput>;
  id: Scalars['Int'];
};


export type PerformanceMutationsExportPerformanceReviewProcessArgs = {
  id: Scalars['Int'];
};


export type PerformanceMutationsGenerateDocumentPerformanceAgreementArgs = {
  id: Scalars['String'];
};


export type PerformanceMutationsGenerateForFiltersPerformanceReviewAggregationArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  gridStatus?: InputMaybe<Array<Scalars['String']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  potentialScoreRange?: InputMaybe<Array<Scalars['String']>>;
  pulseAnswers?: InputMaybe<Array<Scalars['String']>>;
  scoreRange?: InputMaybe<Array<Scalars['String']>>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  tenureDate?: InputMaybe<Array<Scalars['String']>>;
};


export type PerformanceMutationsGeneratePerformanceReviewAggregationArgs = {
  accessProcessPairs: Array<GeneratePerformanceReviewAggregationAccessProcessPairsInput>;
};


export type PerformanceMutationsInitiatePerformanceAgreementArgs = {
  processId: Scalars['Int'];
  targetId: Scalars['String'];
};


export type PerformanceMutationsParseAndUpdateQuestionnaireForStrategyPerformanceReviewProcessCustomTemplateQuestionnaireByStrategyArgs = {
  content: Scalars['String'];
  performanceCustomTemplateId: Scalars['Int'];
  strategy: PerformanceReviewerStrategiesStrategyEnum;
};


export type PerformanceMutationsParseAndUpdateQuestionnaireForStrategyPerformanceReviewQuestionnaireByStrategyArgs = {
  content: Scalars['String'];
  performanceReviewProcessId: Scalars['Int'];
  strategy: PerformanceReviewerStrategiesStrategyEnum;
};


export type PerformanceMutationsPublishPerformanceReviewEvaluationAnswerArgs = {
  answers: Array<PerformanceAnswerInput>;
  competenciesAnswers?: InputMaybe<Array<PerformanceAnswerInput>>;
  employeePotentialScoreAnswer?: InputMaybe<PerformanceAnswerInput>;
  employeeScoreAnswer?: InputMaybe<PerformanceAnswerInput>;
  performanceReviewEvaluationId: Scalars['Int'];
};


export type PerformanceMutationsRefreshPerformanceAgreementArgs = {
  id: Scalars['String'];
};


export type PerformanceMutationsRemindInBulkPerformanceReviewProcessArgs = {
  evaluationTypes?: InputMaybe<Array<PerformanceReviewerStrategiesStrategyEnum>>;
  id: Scalars['Int'];
};


export type PerformanceMutationsRemovePeerEvaluationsPerformanceReviewProcessTargetArgs = {
  evaluationIds: Array<Scalars['Int']>;
  id: Scalars['String'];
};


export type PerformanceMutationsRemoveSchedulePerformanceReviewProcessArgs = {
  id: Scalars['Int'];
};


export type PerformanceMutationsReopenPerformanceReviewProcessArgs = {
  endsAt: Scalars['ISO8601DateTime'];
  id: Scalars['Int'];
};


export type PerformanceMutationsReplaceEmployeeReviewerPerformanceReviewEvaluationArgs = {
  id: Scalars['Int'];
  newReviewerEmployeeId: Scalars['Int'];
};


export type PerformanceMutationsReplaceReviewerPerformanceReviewEvaluationArgs = {
  id: Scalars['String'];
  newReviewerAccessId: Scalars['String'];
};


export type PerformanceMutationsRepublishPerformanceReviewEvaluationAnswerArgs = {
  answers: Array<PerformanceAnswerInput>;
  competenciesAnswers?: InputMaybe<Array<PerformanceAnswerInput>>;
  employeePotentialScoreAnswer?: InputMaybe<PerformanceAnswerInput>;
  employeeScoreAnswer?: InputMaybe<PerformanceAnswerInput>;
  performanceReviewEvaluationId: Scalars['Int'];
};


export type PerformanceMutationsSchedulePerformanceReviewProcessArgs = {
  id: Scalars['Int'];
  startsAt: Scalars['ISO8601DateTime'];
};


export type PerformanceMutationsSetModePerformanceScoreConfigurationArgs = {
  mode: PerformanceScoreConfigurationModeEnum;
  questionnaireableId?: InputMaybe<Scalars['Int']>;
  questionnaireableType: PerformanceValueObjectsQuestionnaireableEnum;
};


export type PerformanceMutationsSetPerformanceCompanyEmployeeScoreScaleArgs = {
  id: Scalars['Int'];
  scaleId: Scalars['Int'];
};


export type PerformanceMutationsSetWeightsPerformanceScoreConfigurationArgs = {
  questionnaireableId?: InputMaybe<Scalars['Int']>;
  questionnaireableType: PerformanceValueObjectsQuestionnaireableEnum;
  strategyConfigurations: Array<PerformanceStrategyConfigurationInput>;
};


export type PerformanceMutationsSignAsEmployeePerformanceAgreementArgs = {
  agreementId: Scalars['String'];
};


export type PerformanceMutationsSignAsManagerPerformanceAgreementArgs = {
  agreementId: Scalars['String'];
};


export type PerformanceMutationsStartPerformanceReviewProcessArgs = {
  id: Scalars['Int'];
};


export type PerformanceMutationsStopPerformanceReviewProcessArgs = {
  id: Scalars['Int'];
};


export type PerformanceMutationsToggleArchivePerformanceReviewProcessArgs = {
  id: Scalars['Int'];
};


export type PerformanceMutationsUnsignAsEmployeePerformanceAgreementArgs = {
  agreementId: Scalars['String'];
};


export type PerformanceMutationsUnsignAsManagerPerformanceAgreementArgs = {
  agreementId: Scalars['String'];
};


export type PerformanceMutationsUpdateAgreementsConfigurationPerformanceReviewProcessArgs = {
  enabled: Scalars['Boolean'];
  esignatureEnabled?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
};


export type PerformanceMutationsUpdateAuthorPerformanceReviewProcessCustomTemplateArgs = {
  authorId: Scalars['Int'];
  id: Scalars['Int'];
};


export type PerformanceMutationsUpdateBasicInfoPerformanceReviewProcessArgs = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
};


export type PerformanceMutationsUpdateBasicInfoPerformanceReviewProcessCustomTemplateArgs = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  templateDescription?: InputMaybe<Scalars['String']>;
};


export type PerformanceMutationsUpdateCompetenciesAssessmentsConfigurationPerformanceReviewProcessArgs = {
  enabled: Scalars['Boolean'];
  id: Scalars['Int'];
};


export type PerformanceMutationsUpdateConclusionsPerformanceAgreementArgs = {
  agreementId: Scalars['String'];
  text: Scalars['String'];
};


export type PerformanceMutationsUpdateCyclePerformanceReviewProcessArgs = {
  cycleId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};


export type PerformanceMutationsUpdateDeadlinePerformanceReviewProcessArgs = {
  endsAt: Scalars['ISO8601DateTime'];
  id: Scalars['Int'];
};


export type PerformanceMutationsUpdateDefaultRatingScalePerformanceReviewProcessCustomTemplateQuestionnaireByStrategyArgs = {
  defaultRatingScale: Array<PerformanceRatingScaleOptionInput>;
  performanceCustomTemplateId: Scalars['Int'];
};


export type PerformanceMutationsUpdateDefaultRatingScalePerformanceReviewQuestionnaireByStrategyArgs = {
  defaultRatingScale: Array<PerformanceRatingScaleOptionInput>;
  performanceReviewProcessId: Scalars['Int'];
};


export type PerformanceMutationsUpdateEmployeePotentialScoreConfigurationPerformanceReviewProcessArgs = {
  enabled: Scalars['Boolean'];
  id: Scalars['Int'];
};


export type PerformanceMutationsUpdateEmployeeScoreConfigurationPerformanceReviewProcessArgs = {
  enabled: Scalars['Boolean'];
  id: Scalars['Int'];
};


export type PerformanceMutationsUpdateFeaturesPerformanceReviewProcessCustomTemplateArgs = {
  agreementsEnabled?: InputMaybe<Scalars['Boolean']>;
  agreementsEsignatureEnabled?: InputMaybe<Scalars['Boolean']>;
  competenciesAssessmentsEnabled?: InputMaybe<Scalars['Boolean']>;
  employeePotentialScoreEnabled?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  republishEvaluationsEnabled?: InputMaybe<Scalars['Boolean']>;
};


export type PerformanceMutationsUpdatePerformanceAgreementActionItemArgs = {
  agreementId: Scalars['String'];
  id: Scalars['String'];
  text: Scalars['String'];
};


export type PerformanceMutationsUpdatePerformanceReviewVisibilitySettingArgs = {
  anonymousPeerEvaluationForTarget: Scalars['Boolean'];
  earlyAccessToAnswersForManagers: Scalars['Boolean'];
  id?: InputMaybe<Scalars['Int']>;
  performanceReviewProcessId?: InputMaybe<Scalars['Int']>;
  restrictAnswersVisibilityToReportees: Scalars['Boolean'];
};


export type PerformanceMutationsUpdateQuestionnaireForStrategyPerformanceReviewProcessCustomTemplateQuestionnaireByStrategyArgs = {
  performanceCustomTemplateId: Scalars['Int'];
  questionnaireContent: Array<PerformanceQuestionnaireElementInput>;
  strategy: PerformanceReviewerStrategiesStrategyEnum;
};


export type PerformanceMutationsUpdateQuestionnaireForStrategyPerformanceReviewQuestionnaireByStrategyArgs = {
  performanceReviewProcessId: Scalars['Int'];
  questionnaireContent: Array<PerformanceQuestionnaireElementInput>;
  strategy: PerformanceReviewerStrategiesStrategyEnum;
};


export type PerformanceMutationsUpdateRepublishEvaluationsConfigurationPerformanceReviewProcessArgs = {
  enabled: Scalars['Boolean'];
  id: Scalars['Int'];
};


export type PerformanceMutationsUpdateReviewerStrategiesPerformanceReviewProcessArgs = {
  id: Scalars['Int'];
  reviewerStrategies: Array<PerformanceReviewerStrategiesStrategyEnum>;
};


export type PerformanceMutationsUpdateReviewerStrategiesPerformanceReviewProcessCustomTemplateArgs = {
  id: Scalars['Int'];
  reviewerStrategies: Array<PerformanceReviewerStrategiesStrategyEnum>;
};


export type PerformanceMutationsUpdateSchedulePerformanceReviewProcessArgs = {
  id: Scalars['Int'];
  startsAt: Scalars['ISO8601DateTime'];
};


export type PerformanceMutationsUpdateTargetStrategyPerformanceReviewProcessArgs = {
  arguments?: InputMaybe<Array<Scalars['Int']>>;
  id: Scalars['Int'];
  targetStrategy?: InputMaybe<PerformanceTargetStrategySupportedStrategiesEnum>;
};


export type PerformanceMutationsUpdateTargetStrategyPerformanceReviewProcessCustomTemplateArgs = {
  arguments?: InputMaybe<Array<Scalars['Int']>>;
  id: Scalars['Int'];
  targetStrategy?: InputMaybe<PerformanceTargetStrategySupportedStrategiesEnum>;
};


export type PerformanceMutationsUpdateVisibilitySettingsPerformanceReviewProcessCustomTemplateArgs = {
  anonymousPeerEvaluationForTarget?: InputMaybe<Scalars['Boolean']>;
  earlyAccessToAnswersForManagers?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  restrictAnswersVisibilityToReportees?: InputMaybe<Scalars['Boolean']>;
};


export type PerformanceMutationsUpsertManagerQuestionCommentPerformanceAgreementArgs = {
  agreementId: Scalars['String'];
  questionUuid: Scalars['String'];
  text: Scalars['String'];
};


export type PerformanceMutationsUpsertSelfQuestionCommentPerformanceAgreementArgs = {
  agreementId: Scalars['String'];
  questionUuid: Scalars['String'];
  text: Scalars['String'];
};

export type Permissions = {
  __typename?: 'permissions';
  _policies: PermissionsContextlessPolicies;
  contextlessPolicyResolution?: Maybe<PermissionsContextlessPolicyResolution>;
  /** @deprecated Please favor `contextlessPolicyResolutionsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  contextlessPolicyResolutions: Array<PermissionsContextlessPolicyResolution>;
  contextlessPolicyResolutionsConnection: PermissionsContextlessPolicyResolutionConnection;
  permission?: Maybe<PermissionsPermission>;
  permissionGroup?: Maybe<PermissionsPermissionGroup>;
  /** @deprecated Please favor `permissionGroupsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  permissionGroups: Array<PermissionsPermissionGroup>;
  permissionGroupsConnection: PermissionsPermissionGroupConnection;
  /** @deprecated Please favor `permissionsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  permissions: Array<PermissionsPermission>;
  permissionsConnection: PermissionsPermissionConnection;
  resourceTag?: Maybe<PermissionsResourceTag>;
  /** @deprecated Please favor `resourceTagsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  resourceTags: Array<PermissionsResourceTag>;
  resourceTagsConnection: PermissionsResourceTagConnection;
  roleTemplate?: Maybe<PermissionsRoleTemplate>;
  /** @deprecated Please favor `roleTemplatesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  roleTemplates: Array<PermissionsRoleTemplate>;
  roleTemplatesConnection: PermissionsRoleTemplateConnection;
};


export type PermissionsContextlessPolicyResolutionArgs = {
  id: Scalars['String'];
};


export type PermissionsContextlessPolicyResolutionsArgs = {
  ids: Array<Scalars['String']>;
};


export type PermissionsContextlessPolicyResolutionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids: Array<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type PermissionsPermissionArgs = {
  id: Scalars['String'];
  permissionsGroupId: Scalars['Int'];
};


export type PermissionsPermissionGroupArgs = {
  id: Scalars['Int'];
};


export type PermissionsPermissionGroupsArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  ids?: Array<Scalars['Int']>;
  membersEditable?: InputMaybe<Scalars['Boolean']>;
};


export type PermissionsPermissionGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: Array<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  membersEditable?: InputMaybe<Scalars['Boolean']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type PermissionsPermissionsArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
  permissionsGroupId: Scalars['Int'];
};


export type PermissionsPermissionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  permissionsGroupId: Scalars['Int'];
  sortOrder?: InputMaybe<Sort>;
};


export type PermissionsResourceTagArgs = {
  companyId: Scalars['String'];
  id: Scalars['String'];
};


export type PermissionsResourceTagsArgs = {
  companyId: Scalars['String'];
  ids?: InputMaybe<Array<Scalars['String']>>;
  resourceIds?: InputMaybe<Array<Scalars['String']>>;
};


export type PermissionsResourceTagsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['String'];
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  resourceIds?: InputMaybe<Array<Scalars['String']>>;
  sortOrder?: InputMaybe<Sort>;
};


export type PermissionsRoleTemplateArgs = {
  companyId: Scalars['Int'];
  id: Scalars['String'];
};


export type PermissionsRoleTemplatesArgs = {
  companyId: Scalars['Int'];
  ids?: InputMaybe<Array<Scalars['String']>>;
};


export type PermissionsRoleTemplatesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

export type PermissionsMutations = {
  __typename?: 'permissionsMutations';
  addMembersPermissionsPermissionGroup: AddMembersPermissionsPermissionGroupPayload;
  applyRoleTemplatePermissionsPermissionGroup: ApplyRoleTemplatePermissionsPermissionGroupPayload;
  createPermissionsPermissionGroup: CreatePermissionsPermissionGroupPayload;
  deletePermissionsPermissionGroup: DeletePermissionsPermissionGroupPayload;
  duplicatePermissionsPermissionGroup: DuplicatePermissionsPermissionGroupPayload;
  updatePermissionsPermissionGroup: UpdatePermissionsPermissionGroupPayload;
};


export type PermissionsMutationsAddMembersPermissionsPermissionGroupArgs = {
  accessIds: Array<Scalars['Int']>;
  permissionGroupId: Scalars['Int'];
};


export type PermissionsMutationsApplyRoleTemplatePermissionsPermissionGroupArgs = {
  permissionGroupId: Scalars['Int'];
  roleTemplateId: Scalars['String'];
};


export type PermissionsMutationsCreatePermissionsPermissionGroupArgs = {
  companyId: Scalars['Int'];
  name: Scalars['String'];
};


export type PermissionsMutationsDuplicatePermissionsPermissionGroupArgs = {
  name: Scalars['String'];
};


export type PermissionsMutationsUpdatePermissionsPermissionGroupArgs = {
  name: Scalars['String'];
};

export type PersonalHistory = {
  __typename?: 'personalHistory';
  /** @deprecated Please favor `attritionEmployeeOverviewsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  attritionEmployeeOverviews: Array<PersonalHistoryAttritionEmployeeOverview>;
  attritionEmployeeOverviewsConnection: PersonalHistoryAttritionEmployeeOverviewConnection;
  /** @deprecated Please favor `hiringEmployeeOverviewsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  hiringEmployeeOverviews: Array<PersonalHistoryHiringEmployeeOverview>;
  hiringEmployeeOverviewsConnection: PersonalHistoryHiringEmployeeOverviewConnection;
};


export type PersonalHistoryAttritionEmployeeOverviewsArgs = {
  managerId: Scalars['Int'];
};


export type PersonalHistoryAttritionEmployeeOverviewsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  managerId: Scalars['Int'];
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type PersonalHistoryHiringEmployeeOverviewsArgs = {
  managerId: Scalars['Int'];
};


export type PersonalHistoryHiringEmployeeOverviewsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  managerId: Scalars['Int'];
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

export type Positions = {
  __typename?: 'positions';
  _policies: PositionsContextlessPolicies;
  position?: Maybe<PositionsPosition>;
  /** @deprecated Please favor `positionsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  positions: Array<PositionsPosition>;
  positionsConnection: PositionsPositionConnection;
};


export type PositionsPositionArgs = {
  id: Scalars['Int'];
};


export type PositionsPositionsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type PositionsPositionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

export type PositionsMutations = {
  __typename?: 'positionsMutations';
  createPositionsPosition: CreatePositionsPositionPayload;
  deletePositionsPosition: DeletePositionsPositionPayload;
  fetchPositionsPosition: FetchPositionsPositionPayload;
  updatePositionsPosition: UpdatePositionsPositionPayload;
};


export type PositionsMutationsCreatePositionsPositionArgs = {
  atsJobPostingId?: InputMaybe<Scalars['Int']>;
  companyId: Scalars['Int'];
  jobCatalogLevelId?: InputMaybe<Scalars['Int']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  managerId: Scalars['Int'];
};


export type PositionsMutationsDeletePositionsPositionArgs = {
  id: Scalars['Int'];
};


export type PositionsMutationsFetchPositionsPositionArgs = {
  id: Scalars['Int'];
};


export type PositionsMutationsUpdatePositionsPositionArgs = {
  atsJobPostingId?: InputMaybe<Scalars['Int']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  jobCatalogLevelId?: InputMaybe<Scalars['Int']>;
  managerId?: InputMaybe<Scalars['Int']>;
};

export type Posts = {
  __typename?: 'posts';
  _policies: PostsContextlessPolicies;
  comment?: Maybe<PostsComment>;
  /** @deprecated Please favor `commentsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  comments: Array<PostsComment>;
  commentsConnection: PostsCommentConnection;
  /** @deprecated Please favor `dynamicTeamPreviewsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  dynamicTeamPreviews: Array<PostsDynamicTeamPreview>;
  dynamicTeamPreviewsConnection: PostsDynamicTeamPreviewConnection;
  group?: Maybe<PostsGroup>;
  /** @deprecated Please favor `groupsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  groups: Array<PostsGroup>;
  groupsConnection: PostsGroupConnection;
  post?: Maybe<PostsPost>;
  /** @deprecated Please favor `postsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  posts: Array<PostsPost>;
  postsConnection: PostsPostConnection;
  /** @deprecated Please favor `reactionsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  reactions: Array<PostsReaction>;
  reactionsConnection: PostsReactionConnection;
  /** @deprecated Please favor `visitsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  visits: Array<PostsVisit>;
  visitsConnection: PostsVisitConnection;
};


export type PostsCommentArgs = {
  id: Scalars['Int'];
  postIds: Array<Scalars['Int']>;
};


export type PostsCommentsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  postIds: Array<Scalars['Int']>;
};


export type PostsCommentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  postIds: Array<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type PostsDynamicTeamPreviewsArgs = {
  search?: InputMaybe<Scalars['String']>;
  specification: Scalars['String'];
};


export type PostsDynamicTeamPreviewsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  specification: Scalars['String'];
};


export type PostsGroupArgs = {
  id: Scalars['Int'];
};


export type PostsGroupsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  isMember?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};


export type PostsGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<PostsGroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  isMember?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type PostsPostArgs = {
  id: Scalars['Int'];
};


export type PostsPostsArgs = {
  from?: InputMaybe<Scalars['ISO8601Date']>;
  groups?: InputMaybe<Array<Scalars['Int']>>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  isMobile?: InputMaybe<Scalars['Boolean']>;
  noPagination?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  postsPerPage?: InputMaybe<Scalars['Int']>;
  publishedAt?: InputMaybe<Scalars['ISO8601Date']>;
  scheduledPosts?: InputMaybe<Scalars['Boolean']>;
  startsFrom?: InputMaybe<Scalars['ISO8601Date']>;
  startsUntil?: InputMaybe<Scalars['ISO8601Date']>;
  truncateDescription?: InputMaybe<Scalars['Boolean']>;
  types?: InputMaybe<Array<Scalars['String']>>;
  until?: InputMaybe<Scalars['ISO8601Date']>;
  withCoverImage?: InputMaybe<Scalars['Boolean']>;
  withReactions?: InputMaybe<Scalars['Boolean']>;
};


export type PostsPostsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<PostsPostFilter>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['ISO8601Date']>;
  groups?: InputMaybe<Array<Scalars['Int']>>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  isMobile?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  noPagination?: InputMaybe<Scalars['Boolean']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  postsPerPage?: InputMaybe<Scalars['Int']>;
  publishedAt?: InputMaybe<Scalars['ISO8601Date']>;
  scheduledPosts?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Sort>;
  startsFrom?: InputMaybe<Scalars['ISO8601Date']>;
  startsUntil?: InputMaybe<Scalars['ISO8601Date']>;
  truncateDescription?: InputMaybe<Scalars['Boolean']>;
  types?: InputMaybe<Array<Scalars['String']>>;
  until?: InputMaybe<Scalars['ISO8601Date']>;
  withCoverImage?: InputMaybe<Scalars['Boolean']>;
  withReactions?: InputMaybe<Scalars['Boolean']>;
};


export type PostsReactionsArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  postIds: Array<Scalars['Int']>;
};


export type PostsReactionsConnectionArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  postIds: Array<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type PostsVisitsArgs = {
  from?: InputMaybe<Scalars['ISO8601Date']>;
  postIds?: InputMaybe<Array<Scalars['Int']>>;
  to?: InputMaybe<Scalars['ISO8601Date']>;
};


export type PostsVisitsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['ISO8601Date']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  postIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
  to?: InputMaybe<Scalars['ISO8601Date']>;
};

export type PostsMutations = {
  __typename?: 'postsMutations';
  archivePostsGroup: ArchivePostsGroupPayload;
  countPostsPost: CountPostsPostPayload;
  createPostsComment: CreatePostsCommentPayload;
  createPostsGroup: CreatePostsGroupPayload;
  createPostsPost: CreatePostsPostPayload;
  createPostsReaction: CreatePostsReactionPayload;
  deletePostsComment: DeletePostsCommentPayload;
  deletePostsGroup: DeletePostsGroupPayload;
  deletePostsPost: DeletePostsPostPayload;
  deletePostsReaction: DeletePostsReactionPayload;
  showPostsPost: ShowPostsPostPayload;
  updatePostsComment: UpdatePostsCommentPayload;
  updatePostsGroup: UpdatePostsGroupPayload;
  updatePostsPost: UpdatePostsPostPayload;
};


export type PostsMutationsArchivePostsGroupArgs = {
  id: Scalars['Int'];
};


export type PostsMutationsCountPostsPostArgs = {
  from: Scalars['ISO8601Date'];
};


export type PostsMutationsCreatePostsCommentArgs = {
  mentionedAccessIds: Array<Scalars['Int']>;
  postId: Scalars['Int'];
  text: Scalars['String'];
};


export type PostsMutationsCreatePostsGroupArgs = {
  companyId: Scalars['Int'];
  description: Scalars['String'];
  title: Scalars['String'];
};


export type PostsMutationsCreatePostsPostArgs = {
  allowCommentsAndReactions?: InputMaybe<Scalars['Boolean']>;
  attachments?: InputMaybe<Array<Scalars['File']>>;
  coverImage?: InputMaybe<Scalars['File']>;
  description: Scalars['String'];
  endsAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  location?: InputMaybe<Scalars['String']>;
  mentionedAccessIds: Array<Scalars['Int']>;
  postGroupId: Scalars['Int'];
  publishedAt: Scalars['ISO8601DateTime'];
  sendNotifications?: InputMaybe<Scalars['Boolean']>;
  startsAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  targetId?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
  type: Scalars['String'];
};


export type PostsMutationsCreatePostsReactionArgs = {
  code: Scalars['String'];
  postId: Scalars['Int'];
};


export type PostsMutationsDeletePostsCommentArgs = {
  id: Scalars['Int'];
  postId: Scalars['Int'];
};


export type PostsMutationsDeletePostsGroupArgs = {
  id: Scalars['Int'];
};


export type PostsMutationsDeletePostsPostArgs = {
  id: Scalars['Int'];
};


export type PostsMutationsDeletePostsReactionArgs = {
  id: Scalars['Int'];
};


export type PostsMutationsShowPostsPostArgs = {
  id: Scalars['Int'];
  withAttachments?: InputMaybe<Scalars['Boolean']>;
  withComments?: InputMaybe<Scalars['Boolean']>;
  withReactions?: InputMaybe<Scalars['Boolean']>;
  withVisits?: InputMaybe<Scalars['Boolean']>;
};


export type PostsMutationsUpdatePostsCommentArgs = {
  id: Scalars['Int'];
  mentionedAccessIds?: InputMaybe<Array<Scalars['Int']>>;
  postId: Scalars['Int'];
  text: Scalars['String'];
};


export type PostsMutationsUpdatePostsGroupArgs = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  title?: InputMaybe<Scalars['String']>;
};


export type PostsMutationsUpdatePostsPostArgs = {
  allowCommentsAndReactions?: InputMaybe<Scalars['Boolean']>;
  authorId?: InputMaybe<Scalars['Int']>;
  deleteCoverImage?: InputMaybe<Scalars['Boolean']>;
  deletedAttachments?: InputMaybe<Array<Scalars['Int']>>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  location?: InputMaybe<Scalars['String']>;
  mentionedAccessIds?: InputMaybe<Array<Scalars['Int']>>;
  newAttachments?: InputMaybe<Array<Scalars['File']>>;
  newCoverImage?: InputMaybe<Scalars['File']>;
  postGroupId?: InputMaybe<Scalars['Int']>;
  sendNotifications?: InputMaybe<Scalars['Boolean']>;
  startsAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  title?: InputMaybe<Scalars['String']>;
};

export type Processes = {
  __typename?: 'processes';
  _policies: ProcessesContextlessPolicies;
  action?: Maybe<ProcessesAction>;
  actionConfiguration?: Maybe<ProcessesActionConfiguration>;
  /** @deprecated Please favor `actionConfigurationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  actionConfigurations: Array<ProcessesActionConfiguration>;
  actionConfigurationsConnection: ProcessesActionConfigurationConnection;
  /** @deprecated Please favor `actionsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  actions: Array<ProcessesAction>;
  actionsConnection: ProcessesActionConnection;
  item?: Maybe<ProcessesItem>;
  /** @deprecated Please favor `itemAssigneesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  itemAssignees: Array<ProcessesItemAssignee>;
  itemAssigneesConnection: ProcessesItemAssigneeConnection;
  /** @deprecated Please favor `itemsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  items: Array<ProcessesItem>;
  itemsConnection: ProcessesItemConnection;
  materializedAction?: Maybe<ProcessesMaterializedAction>;
  /** @deprecated Please favor `materializedActionsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  materializedActions: Array<ProcessesMaterializedAction>;
  materializedActionsConnection: ProcessesMaterializedActionConnection;
  /** @deprecated Please favor `materializedAssigneesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  materializedAssignees: Array<ProcessesMaterializedAssignee>;
  materializedAssigneesConnection: ProcessesMaterializedAssigneeConnection;
  materializedItem?: Maybe<ProcessesMaterializedItem>;
  /** @deprecated Please favor `materializedItemsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  materializedItems: Array<ProcessesMaterializedItem>;
  materializedItemsConnection: ProcessesMaterializedItemConnection;
  materializedProcess?: Maybe<ProcessesMaterializedProcess>;
  /** @deprecated Please favor `materializedProcessesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  materializedProcesses: Array<ProcessesMaterializedProcess>;
  materializedProcessesConnection: ProcessesMaterializedProcessConnection;
  materializedStep?: Maybe<ProcessesMaterializedStep>;
  /** @deprecated Please favor `materializedStepsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  materializedSteps: Array<ProcessesMaterializedStep>;
  materializedStepsConnection: ProcessesMaterializedStepConnection;
  process?: Maybe<ProcessesProcess>;
  /** @deprecated Please favor `processesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  processes: Array<ProcessesProcess>;
  processesConnection: ProcessesProcessConnection;
  resourceRelationship?: Maybe<ProcessesResourceRelationship>;
  /** @deprecated Please favor `resourceRelationshipsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  resourceRelationships: Array<ProcessesResourceRelationship>;
  resourceRelationshipsConnection: ProcessesResourceRelationshipConnection;
  step?: Maybe<ProcessesStep>;
  /** @deprecated Please favor `stepMaterializationDatesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  stepMaterializationDates: Array<ProcessesStepMaterializationDate>;
  stepMaterializationDatesConnection: ProcessesStepMaterializationDateConnection;
  /** @deprecated Please favor `stepsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  steps: Array<ProcessesStep>;
  stepsConnection: ProcessesStepConnection;
  taskConfiguration?: Maybe<ProcessesTaskConfiguration>;
  taskConfigurationFile?: Maybe<ProcessesTaskConfigurationFile>;
  /** @deprecated Please favor `taskConfigurationFilesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  taskConfigurationFiles: Array<ProcessesTaskConfigurationFile>;
  taskConfigurationFilesConnection: ProcessesTaskConfigurationFileConnection;
  /** @deprecated Please favor `taskConfigurationSendDocumentTemplatesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  taskConfigurationSendDocumentTemplates: Array<ProcessesTaskConfigurationSendDocumentTemplate>;
  taskConfigurationSendDocumentTemplatesConnection: ProcessesTaskConfigurationSendDocumentTemplateConnection;
  /** @deprecated Please favor `taskConfigurationSettingsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  taskConfigurationSettings: Array<ProcessesTaskConfigurationSetting>;
  taskConfigurationSettingsConnection: ProcessesTaskConfigurationSettingConnection;
  taskConfigurationSignatureDocument?: Maybe<ProcessesTaskConfigurationSignatureDocument>;
  /** @deprecated Please favor `taskConfigurationSignatureDocumentsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  taskConfigurationSignatureDocuments: Array<ProcessesTaskConfigurationSignatureDocument>;
  taskConfigurationSignatureDocumentsConnection: ProcessesTaskConfigurationSignatureDocumentConnection;
  /** @deprecated Please favor `taskConfigurationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  taskConfigurations: Array<ProcessesTaskConfiguration>;
  taskConfigurationsConnection: ProcessesTaskConfigurationConnection;
  template?: Maybe<ProcessesTemplate>;
  /** @deprecated Please favor `templatesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  templates: Array<ProcessesTemplate>;
  templatesConnection: ProcessesTemplateConnection;
};


export type ProcessesActionArgs = {
  id: Scalars['Int'];
};


export type ProcessesActionConfigurationArgs = {
  id: Scalars['String'];
};


export type ProcessesActionConfigurationsArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
  processCategory?: InputMaybe<Scalars['String']>;
};


export type ProcessesActionConfigurationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  processCategory?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ProcessesActionsArgs = {
  configuration?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type ProcessesActionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  configuration?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ProcessesItemArgs = {
  id: Scalars['Int'];
};


export type ProcessesItemAssigneesArgs = {
  itemIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type ProcessesItemAssigneesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  itemIds?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ProcessesItemsArgs = {
  configurationIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  stepIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type ProcessesItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  configurationIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  stepIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type ProcessesMaterializedActionArgs = {
  id: Scalars['Int'];
};


export type ProcessesMaterializedActionsArgs = {
  ids: Array<Scalars['Int']>;
};


export type ProcessesMaterializedActionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids: Array<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ProcessesMaterializedAssigneesArgs = {
  materializedItemIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type ProcessesMaterializedAssigneesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  materializedItemIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ProcessesMaterializedItemArgs = {
  id: Scalars['Int'];
};


export type ProcessesMaterializedItemsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  itemIds?: InputMaybe<Array<Scalars['Int']>>;
  materializedStepIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceIds?: InputMaybe<Array<Scalars['Int']>>;
  taskIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type ProcessesMaterializedItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  itemIds?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  materializedStepIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  resourceIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
  taskIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type ProcessesMaterializedProcessArgs = {
  id: Scalars['Int'];
};


export type ProcessesMaterializedProcessesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeItemsCount?: InputMaybe<Scalars['Boolean']>;
  itemResources?: InputMaybe<Scalars['String']>;
  materializedTasksAccessId?: InputMaybe<Scalars['Int']>;
  processId?: InputMaybe<Scalars['Int']>;
  processIds?: InputMaybe<Array<Scalars['Int']>>;
  resources?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  withPendingMandatoryTasks?: InputMaybe<Scalars['Boolean']>;
};


export type ProcessesMaterializedProcessesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<ProcessesMaterializedProcessFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeItemsCount?: InputMaybe<Scalars['Boolean']>;
  itemResources?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  materializedTasksAccessId?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  processId?: InputMaybe<Scalars['Int']>;
  processIds?: InputMaybe<Array<Scalars['Int']>>;
  resources?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  status?: InputMaybe<Scalars['String']>;
  withPendingMandatoryTasks?: InputMaybe<Scalars['Boolean']>;
};


export type ProcessesMaterializedStepArgs = {
  id: Scalars['Int'];
};


export type ProcessesMaterializedStepsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  materializedProcessIds?: InputMaybe<Array<Scalars['Int']>>;
  stepIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type ProcessesMaterializedStepsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  materializedProcessIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  stepIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type ProcessesProcessArgs = {
  id: Scalars['Int'];
};


export type ProcessesProcessesArgs = {
  categories?: InputMaybe<Array<ProcessesProcessCategoryEnum>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  name?: InputMaybe<Scalars['String']>;
  templateIds?: InputMaybe<Array<Scalars['Int']>>;
  validate?: InputMaybe<Scalars['Boolean']>;
};


export type ProcessesProcessesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  categories?: InputMaybe<Array<ProcessesProcessCategoryEnum>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  templateIds?: InputMaybe<Array<Scalars['Int']>>;
  validate?: InputMaybe<Scalars['Boolean']>;
};


export type ProcessesResourceRelationshipArgs = {
  id: Scalars['Int'];
};


export type ProcessesResourceRelationshipsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  materializedProcessIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceTypes?: InputMaybe<Array<Scalars['String']>>;
};


export type ProcessesResourceRelationshipsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  materializedProcessIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  resourceIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceTypes?: InputMaybe<Array<Scalars['String']>>;
  sortOrder?: InputMaybe<Sort>;
};


export type ProcessesStepArgs = {
  id: Scalars['Int'];
};


export type ProcessesStepMaterializationDatesArgs = {
  materializedProcessId: Scalars['Int'];
};


export type ProcessesStepMaterializationDatesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  materializedProcessId: Scalars['Int'];
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ProcessesStepsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  processIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type ProcessesStepsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  processIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
};


export type ProcessesTaskConfigurationArgs = {
  id: Scalars['Int'];
};


export type ProcessesTaskConfigurationFileArgs = {
  id: Scalars['Int'];
  taskConfigurationId: Scalars['Int'];
};


export type ProcessesTaskConfigurationFilesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  taskConfigurationId: Scalars['Int'];
};


export type ProcessesTaskConfigurationFilesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  taskConfigurationId: Scalars['Int'];
};


export type ProcessesTaskConfigurationSendDocumentTemplatesArgs = {
  documentTemplateIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type ProcessesTaskConfigurationSendDocumentTemplatesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  documentTemplateIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ProcessesTaskConfigurationSettingsArgs = {
  category: Scalars['String'];
};


export type ProcessesTaskConfigurationSettingsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  category: Scalars['String'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ProcessesTaskConfigurationSignatureDocumentArgs = {
  id: Scalars['Int'];
  taskConfigurationId: Scalars['Int'];
};


export type ProcessesTaskConfigurationSignatureDocumentsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  taskConfigurationId: Scalars['Int'];
};


export type ProcessesTaskConfigurationSignatureDocumentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  taskConfigurationId: Scalars['Int'];
};


export type ProcessesTaskConfigurationsArgs = {
  ids: Array<Scalars['Int']>;
};


export type ProcessesTaskConfigurationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids: Array<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ProcessesTemplateArgs = {
  id: Scalars['String'];
};


export type ProcessesTemplatesArgs = {
  category?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  includeHidden?: InputMaybe<Scalars['Boolean']>;
  showInHomepage?: InputMaybe<Scalars['Boolean']>;
};


export type ProcessesTemplatesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  includeHidden?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  showInHomepage?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Sort>;
};

export type ProcessesMutations = {
  __typename?: 'processesMutations';
  archiveProcessesProcess: ArchiveProcessesProcessPayload;
  bulkCreateProcessesItem: BulkCreateProcessesItemPayload;
  bulkCreateProcessesItemAssignee: BulkCreateProcessesItemAssigneePayload;
  bulkCreateProcessesMaterializedProcess: BulkCreateProcessesMaterializedProcessPayload;
  bulkCreateProcessesResourceRelationship: BulkCreateProcessesResourceRelationshipPayload;
  bulkCreateProcessesStep: BulkCreateProcessesStepPayload;
  bulkUpdateProcessesConfigurationTaskConfigurationFile: BulkUpdateProcessesConfigurationTaskConfigurationFilePayload;
  bulkUpdateProcessesItem: BulkUpdateProcessesItemPayload;
  bulkUpdateProcessesStep: BulkUpdateProcessesStepPayload;
  createProcessesAction: CreateProcessesActionPayload;
  createProcessesItem: CreateProcessesItemPayload;
  createProcessesItemAssignee: CreateProcessesItemAssigneePayload;
  createProcessesMaterializedAssignee: CreateProcessesMaterializedAssigneePayload;
  createProcessesMaterializedItem: CreateProcessesMaterializedItemPayload;
  createProcessesMaterializedProcess: CreateProcessesMaterializedProcessPayload;
  createProcessesMaterializedStep: CreateProcessesMaterializedStepPayload;
  createProcessesProcess: CreateProcessesProcessPayload;
  createProcessesResourceRelationship: CreateProcessesResourceRelationshipPayload;
  createProcessesStep: CreateProcessesStepPayload;
  destroyProcessesItem: DestroyProcessesItemPayload;
  destroyProcessesItemAssignee: DestroyProcessesItemAssigneePayload;
  destroyProcessesMaterializedAssignee: DestroyProcessesMaterializedAssigneePayload;
  destroyProcessesMaterializedItem: DestroyProcessesMaterializedItemPayload;
  destroyProcessesMaterializedProcess: DestroyProcessesMaterializedProcessPayload;
  destroyProcessesMaterializedStep: DestroyProcessesMaterializedStepPayload;
  destroyProcessesStep: DestroyProcessesStepPayload;
  duplicateProcessesProcess: DuplicateProcessesProcessPayload;
  duplicateProcessesStep: DuplicateProcessesStepPayload;
  markAsCompletedProcessesMaterializedProcess: MarkAsCompletedProcessesMaterializedProcessPayload;
  patchProcessesAction: PatchProcessesActionPayload;
  patchProcessesItem: PatchProcessesItemPayload;
  patchProcessesItemAssignee: PatchProcessesItemAssigneePayload;
  patchProcessesMaterializedAssignee: PatchProcessesMaterializedAssigneePayload;
  patchProcessesMaterializedProcess: PatchProcessesMaterializedProcessPayload;
  patchProcessesMaterializedStep: PatchProcessesMaterializedStepPayload;
  patchProcessesProcess: PatchProcessesProcessPayload;
  patchProcessesStep: PatchProcessesStepPayload;
  startProcessesMaterializedProcess: StartProcessesMaterializedProcessPayload;
  startProcessesResourceRelationship: StartProcessesResourceRelationshipPayload;
  startProcessesStartStep: StartProcessesStartStepPayload;
  validateSettingsProcessesProcess: ValidateSettingsProcessesProcessPayload;
};


export type ProcessesMutationsArchiveProcessesProcessArgs = {
  id: Scalars['Int'];
};


export type ProcessesMutationsBulkCreateProcessesItemArgs = {
  items: Array<BulkCreateProcessesItemItemsInput>;
};


export type ProcessesMutationsBulkCreateProcessesItemAssigneeArgs = {
  itemAssignees: Array<BulkCreateProcessesItemAssigneeItemAssigneesInput>;
};


export type ProcessesMutationsBulkCreateProcessesMaterializedProcessArgs = {
  processId: Scalars['Int'];
  processInputFields?: InputMaybe<Array<ProcessesInputFieldInput>>;
  resourceIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type ProcessesMutationsBulkCreateProcessesResourceRelationshipArgs = {
  materializedProcessId: Scalars['Int'];
  resources: Array<ProcessesResourceInput>;
};


export type ProcessesMutationsBulkCreateProcessesStepArgs = {
  steps: Array<BulkCreateProcessesStepStepsInput>;
};


export type ProcessesMutationsBulkUpdateProcessesConfigurationTaskConfigurationFileArgs = {
  filesToAdd?: InputMaybe<Array<Scalars['File']>>;
  filesToRemove?: InputMaybe<Array<Scalars['Int']>>;
  taskConfigurationId: Scalars['Int'];
};


export type ProcessesMutationsBulkUpdateProcessesItemArgs = {
  items: Array<BulkUpdateProcessesItemItemsInput>;
};


export type ProcessesMutationsBulkUpdateProcessesStepArgs = {
  steps: Array<BulkUpdateProcessesStepStepsInput>;
};


export type ProcessesMutationsCreateProcessesActionArgs = {
  assigneeIds?: InputMaybe<Array<Scalars['Int']>>;
  assigneeStrategy?: InputMaybe<Scalars['String']>;
  configuration: Scalars['String'];
  configurationIdentifier: Scalars['String'];
  filesToAdd?: InputMaybe<Array<Scalars['File']>>;
  item: CreateProcessesActionItemInput;
  title?: InputMaybe<Scalars['String']>;
};


export type ProcessesMutationsCreateProcessesItemArgs = {
  actionConfiguration?: InputMaybe<Scalars['String']>;
  actionConfigurationIdentifier?: InputMaybe<Scalars['String']>;
  assigneeIds?: InputMaybe<Array<Scalars['Int']>>;
  assigneeStrategy?: InputMaybe<Scalars['String']>;
  configurationId?: InputMaybe<Scalars['Int']>;
  configurationType?: InputMaybe<Scalars['String']>;
  dataCollectionConfiguration?: InputMaybe<ProcessesDataCollectionConfigurationInput>;
  instruction?: InputMaybe<Scalars['String']>;
  mandatory?: InputMaybe<Scalars['Boolean']>;
  offsetAmount?: InputMaybe<Scalars['Int']>;
  offsetDirection?: InputMaybe<Scalars['String']>;
  position: Scalars['Int'];
  referenceFieldKey?: InputMaybe<Scalars['String']>;
  signatureDocuments?: InputMaybe<CreateProcessesItemSignatureDocumentsInput>;
  stepId?: InputMaybe<Scalars['Int']>;
  taskType?: InputMaybe<Scalars['String']>;
  taskTypeConfiguration?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};


export type ProcessesMutationsCreateProcessesItemAssigneeArgs = {
  assigneeIds: Array<Scalars['Int']>;
  assigneeStrategy: Scalars['String'];
  itemId: Scalars['Int'];
};


export type ProcessesMutationsCreateProcessesMaterializedAssigneeArgs = {
  accessId: Scalars['Int'];
  itemAssigneeId?: InputMaybe<Scalars['Int']>;
  materializedItemId?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<ProcessesMaterializedAssigneeStatusEnum>;
};


export type ProcessesMutationsCreateProcessesMaterializedItemArgs = {
  itemId: Scalars['Int'];
  materializedStepId?: InputMaybe<Scalars['Int']>;
  resourceId?: InputMaybe<Scalars['Int']>;
  resourceType?: InputMaybe<Scalars['String']>;
  strategy?: InputMaybe<Scalars['String']>;
};


export type ProcessesMutationsCreateProcessesMaterializedProcessArgs = {
  ongoingStepId?: InputMaybe<Scalars['Int']>;
  processId: Scalars['Int'];
  processInputFields?: InputMaybe<Array<ProcessesInputFieldInput>>;
  resourceId?: InputMaybe<Scalars['Int']>;
  resources?: InputMaybe<Array<ProcessesResourceInput>>;
};


export type ProcessesMutationsCreateProcessesMaterializedStepArgs = {
  materializationSnapshot?: InputMaybe<ProcessesStepMaterializationSnapshotInput>;
  materializedProcessId: Scalars['Int'];
  name: Scalars['String'];
  status?: InputMaybe<ProcessesMaterializedStepStatusEnum>;
  stepId: Scalars['Int'];
  stepProgressionCondition?: InputMaybe<Scalars['String']>;
};


export type ProcessesMutationsCreateProcessesProcessArgs = {
  category?: InputMaybe<ProcessesProcessCategoryEnum>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  steps?: InputMaybe<Array<CreateProcessesProcessStepsInput>>;
  templateId?: InputMaybe<Scalars['String']>;
};


export type ProcessesMutationsCreateProcessesResourceRelationshipArgs = {
  materializedProcessId: Scalars['Int'];
  resourceId: Scalars['Int'];
  resourceType?: InputMaybe<Scalars['String']>;
};


export type ProcessesMutationsCreateProcessesStepArgs = {
  items?: InputMaybe<Array<CreateProcessesStepItemsInput>>;
  name: Scalars['String'];
  offsetAmount?: InputMaybe<Scalars['Int']>;
  offsetDirection?: InputMaybe<Scalars['String']>;
  position: Scalars['Int'];
  processId?: InputMaybe<Scalars['Int']>;
  progressionCondition?: InputMaybe<Scalars['String']>;
  progressionConditionResourceKey?: InputMaybe<Scalars['String']>;
};


export type ProcessesMutationsDestroyProcessesItemArgs = {
  id?: InputMaybe<Scalars['Int']>;
};


export type ProcessesMutationsDestroyProcessesItemAssigneeArgs = {
  id: Scalars['Int'];
};


export type ProcessesMutationsDestroyProcessesMaterializedAssigneeArgs = {
  id: Scalars['Int'];
};


export type ProcessesMutationsDestroyProcessesMaterializedItemArgs = {
  id: Scalars['Int'];
};


export type ProcessesMutationsDestroyProcessesMaterializedProcessArgs = {
  id: Scalars['Int'];
};


export type ProcessesMutationsDestroyProcessesMaterializedStepArgs = {
  id: Scalars['Int'];
};


export type ProcessesMutationsDestroyProcessesStepArgs = {
  id: Scalars['Int'];
};


export type ProcessesMutationsDuplicateProcessesProcessArgs = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
};


export type ProcessesMutationsDuplicateProcessesStepArgs = {
  duplicateStepId: Scalars['Int'];
  name: Scalars['String'];
  offsetDirection: Scalars['String'];
  stepToSwapId?: InputMaybe<Scalars['Int']>;
};


export type ProcessesMutationsMarkAsCompletedProcessesMaterializedProcessArgs = {
  id: Scalars['Int'];
};


export type ProcessesMutationsPatchProcessesActionArgs = {
  configuration: Scalars['String'];
  filesToAdd?: InputMaybe<Array<Scalars['File']>>;
  filesToRemove?: InputMaybe<Array<Scalars['Int']>>;
  id: Scalars['Int'];
  item: PatchProcessesActionItemInput;
  title?: InputMaybe<Scalars['String']>;
};


export type ProcessesMutationsPatchProcessesItemArgs = {
  assigneeIds?: InputMaybe<Array<Scalars['Int']>>;
  assigneeStrategy: Scalars['String'];
  dataCollectionConfiguration?: InputMaybe<ProcessesDataCollectionConfigurationInput>;
  id: Scalars['Int'];
  instruction?: InputMaybe<Scalars['String']>;
  mandatory?: InputMaybe<Scalars['Boolean']>;
  offsetAmount?: InputMaybe<Scalars['Int']>;
  offsetDirection?: InputMaybe<Scalars['String']>;
  position: Scalars['Int'];
  referenceFieldKey?: InputMaybe<Scalars['String']>;
  signatureDocuments?: InputMaybe<PatchProcessesItemSignatureDocumentsInput>;
  stepId?: InputMaybe<Scalars['Int']>;
  taskType?: InputMaybe<Scalars['String']>;
  taskTypeConfiguration?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};


export type ProcessesMutationsPatchProcessesItemAssigneeArgs = {
  assigneeIds: Array<Scalars['Int']>;
  assigneeStrategy: Scalars['String'];
  id: Scalars['Int'];
};


export type ProcessesMutationsPatchProcessesMaterializedAssigneeArgs = {
  finalizedAt?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  status?: InputMaybe<ProcessesMaterializedAssigneeStatusEnum>;
};


export type ProcessesMutationsPatchProcessesMaterializedProcessArgs = {
  finalizedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  id: Scalars['Int'];
  ongoingStepId?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<ProcessesMaterializedProcessStatusEnum>;
};


export type ProcessesMutationsPatchProcessesMaterializedStepArgs = {
  finalizedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  id: Scalars['Int'];
  status?: InputMaybe<ProcessesMaterializedStepStatusEnum>;
};


export type ProcessesMutationsPatchProcessesProcessArgs = {
  category?: InputMaybe<ProcessesProcessCategoryEnum>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
};


export type ProcessesMutationsPatchProcessesStepArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  offsetAmount?: InputMaybe<Scalars['Int']>;
  offsetDirection?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  progressionCondition?: InputMaybe<Scalars['String']>;
  progressionConditionResourceKey?: InputMaybe<Scalars['String']>;
};


export type ProcessesMutationsStartProcessesMaterializedProcessArgs = {
  ongoingStepId?: InputMaybe<Scalars['Int']>;
  processId: Scalars['Int'];
  processInputFields?: InputMaybe<Array<ProcessesInputFieldInput>>;
  resourceId?: InputMaybe<Scalars['Int']>;
  resources?: InputMaybe<Array<ProcessesResourceInput>>;
};


export type ProcessesMutationsStartProcessesResourceRelationshipArgs = {
  materializedProcessId: Scalars['Int'];
  resourceId: Scalars['Int'];
  resourceType?: InputMaybe<Scalars['String']>;
};


export type ProcessesMutationsStartProcessesStartStepArgs = {
  materializedProcessId: Scalars['Int'];
  stepIds: Array<Scalars['Int']>;
};


export type ProcessesMutationsValidateSettingsProcessesProcessArgs = {
  id: Scalars['Int'];
};

/** Payload for processing_rate and subscription: read */
export type Processing_Rate_Read_Type = {
  __typename?: 'processing_rate_read_type';
  error?: Maybe<Scalars['Boolean']>;
  processing: Scalars['Boolean'];
  resourceIds: Array<Scalars['Int']>;
  resourceType: Scalars['String'];
};

export type Procurement = {
  __typename?: 'procurement';
  _policies: ProcurementContextlessPolicies;
  /** @deprecated Please favor `approvalsTimelinesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  approvalsTimelines: Array<ProcurementApprovalsTimeline>;
  approvalsTimelinesConnection: ProcurementApprovalsTimelineConnection;
  eligibleWorkflowsAssignee?: Maybe<ProcurementEligibleWorkflowsAssignee>;
  /** @deprecated Please favor `eligibleWorkflowsAssigneesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  eligibleWorkflowsAssignees: Array<ProcurementEligibleWorkflowsAssignee>;
  eligibleWorkflowsAssigneesConnection: ProcurementEligibleWorkflowsAssigneeConnection;
  purchaseOrder?: Maybe<ProcurementPurchaseOrder>;
  /** @deprecated Please favor `purchaseOrdersConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  purchaseOrders: Array<ProcurementPurchaseOrder>;
  purchaseOrdersConnection: ProcurementPurchaseOrderConnection;
  purchaseRequest?: Maybe<ProcurementPurchaseRequest>;
  /** @deprecated Please favor `purchaseRequestsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  purchaseRequests: Array<ProcurementPurchaseRequest>;
  purchaseRequestsConnection: ProcurementPurchaseRequestConnection;
  type?: Maybe<ProcurementType>;
  /** @deprecated Please favor `typesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  types: Array<ProcurementType>;
  typesConnection: ProcurementTypeConnection;
  uploadDocumentTask?: Maybe<ProcurementUploadDocumentTask>;
  /** @deprecated Please favor `uploadDocumentTasksConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  uploadDocumentTasks: Array<ProcurementUploadDocumentTask>;
  uploadDocumentTasksConnection: ProcurementUploadDocumentTaskConnection;
};


export type ProcurementApprovalsTimelinesArgs = {
  companyId: Scalars['Int'];
  purchaseRequestId: Scalars['Int'];
};


export type ProcurementApprovalsTimelinesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  purchaseRequestId: Scalars['Int'];
  sortOrder?: InputMaybe<Sort>;
};


export type ProcurementEligibleWorkflowsAssigneeArgs = {
  id: Scalars['Int'];
};


export type ProcurementEligibleWorkflowsAssigneesArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  afterEmployeeId?: InputMaybe<Scalars['Int']>;
  beforeEmployeeId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  reporteesOrLed?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyId?: InputMaybe<Scalars['Int']>;
  verb?: InputMaybe<Scalars['String']>;
  withActiveContract?: Scalars['Boolean'];
};


export type ProcurementEligibleWorkflowsAssigneesConnectionArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  after?: InputMaybe<Scalars['String']>;
  afterEmployeeId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  beforeEmployeeId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  onlyManagers?: Scalars['Boolean'];
  onlyMyReportees?: Scalars['Boolean'];
  referenceContractLevelIds?: InputMaybe<Array<Scalars['Int']>>;
  referenceContractTreeLevelUuids?: InputMaybe<Array<Scalars['String']>>;
  reporteesOrLed?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyId?: InputMaybe<Scalars['Int']>;
  verb?: InputMaybe<Scalars['String']>;
  withActiveContract?: Scalars['Boolean'];
};


export type ProcurementPurchaseOrderArgs = {
  id: Scalars['Int'];
};


export type ProcurementPurchaseOrdersArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  currencies?: InputMaybe<Array<Scalars['String']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  purchaseRequestIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ProcurementValueObjectsPurchaseOrderStatusEnum>;
  vendorId?: InputMaybe<Scalars['Int']>;
};


export type ProcurementPurchaseOrdersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  currencies?: InputMaybe<Array<Scalars['String']>>;
  filter?: InputMaybe<ProcurementPurchaseOrderFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  purchaseRequestIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  status?: InputMaybe<ProcurementValueObjectsPurchaseOrderStatusEnum>;
  vendorId?: InputMaybe<Scalars['Int']>;
};


export type ProcurementPurchaseRequestArgs = {
  id: Scalars['Int'];
};


export type ProcurementPurchaseRequestsArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  currencies?: InputMaybe<Array<Scalars['String']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  onTime?: InputMaybe<Scalars['Boolean']>;
  onlyMyPendingApprovals?: InputMaybe<Scalars['Boolean']>;
  overdue?: InputMaybe<Scalars['Boolean']>;
  requesterEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ProcurementValueObjectsPurchaseRequestStatusEnum>;
  typeIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type ProcurementPurchaseRequestsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  currencies?: InputMaybe<Array<Scalars['String']>>;
  filter?: InputMaybe<ProcurementPurchaseRequestFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onTime?: InputMaybe<Scalars['Boolean']>;
  onlyMyPendingApprovals?: InputMaybe<Scalars['Boolean']>;
  overdue?: InputMaybe<Scalars['Boolean']>;
  requesterEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  status?: InputMaybe<ProcurementValueObjectsPurchaseRequestStatusEnum>;
  typeIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type ProcurementTypeArgs = {
  id: Scalars['Int'];
};


export type ProcurementTypesArgs = {
  authorIds?: InputMaybe<Array<Scalars['Int']>>;
  companyId?: InputMaybe<Scalars['Int']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeSystemAuthor?: InputMaybe<Scalars['Boolean']>;
};


export type ProcurementTypesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  authorIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ProcurementTypeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeSystemAuthor?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ProcurementUploadDocumentTaskArgs = {
  id: Scalars['String'];
};


export type ProcurementUploadDocumentTasksArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  purchaseRequestIds?: InputMaybe<Array<Scalars['String']>>;
  taskType?: InputMaybe<ProcurementValueObjectsUploadDocumentTaskTypeEnum>;
};


export type ProcurementUploadDocumentTasksConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  purchaseRequestIds?: InputMaybe<Array<Scalars['String']>>;
  sortOrder?: InputMaybe<Sort>;
  taskType?: InputMaybe<ProcurementValueObjectsUploadDocumentTaskTypeEnum>;
};

export type ProcurementMutations = {
  __typename?: 'procurementMutations';
  approveProcurementPurchaseRequest: ApproveProcurementPurchaseRequestPayload;
  createCommentProcurementPurchaseRequest: CreateCommentProcurementPurchaseRequestPayload;
  createProcurementPurchaseRequest: CreateProcurementPurchaseRequestPayload;
  createProcurementType: CreateProcurementTypePayload;
  createWorkflowProcurementType: CreateWorkflowProcurementTypePayload;
  deleteProcurementPurchaseRequest: DeleteProcurementPurchaseRequestPayload;
  deleteProcurementType: DeleteProcurementTypePayload;
  duplicateProcurementType: DuplicateProcurementTypePayload;
  markAsDoneProcurementUploadDocumentTask: MarkAsDoneProcurementUploadDocumentTaskPayload;
  publishChangesProcurementType: PublishChangesProcurementTypePayload;
  publishProcurementType: PublishProcurementTypePayload;
  rejectProcurementPurchaseRequest: RejectProcurementPurchaseRequestPayload;
  removeFileProcurementUploadDocumentTask: RemoveFileProcurementUploadDocumentTaskPayload;
  saveProcurementType: SaveProcurementTypePayload;
  updateAndSetToPendingProcurementPurchaseRequest: UpdateAndSetToPendingProcurementPurchaseRequestPayload;
  updateProcurementPurchaseOrder: UpdateProcurementPurchaseOrderPayload;
  updateProcurementPurchaseRequest: UpdateProcurementPurchaseRequestPayload;
  updateProcurementType: UpdateProcurementTypePayload;
  updateStatusProcurementPurchaseOrder: UpdateStatusProcurementPurchaseOrderPayload;
  uploadProcurementUploadDocumentTask: UploadProcurementUploadDocumentTaskPayload;
};


export type ProcurementMutationsApproveProcurementPurchaseRequestArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type ProcurementMutationsCreateCommentProcurementPurchaseRequestArgs = {
  authorId: Scalars['Int'];
  companyId: Scalars['Int'];
  content: Scalars['String'];
  mentionedAccessIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceId: Scalars['Int'];
};


export type ProcurementMutationsCreateProcurementPurchaseRequestArgs = {
  additionalInformation?: InputMaybe<Scalars['String']>;
  answers?: InputMaybe<Array<FormsAnswerInput>>;
  companyId: Scalars['Int'];
  cost: BigMoneyInput;
  date: Scalars['ISO8601Date'];
  deadline?: InputMaybe<Scalars['ISO8601Date']>;
  description: Scalars['String'];
  files: Array<Scalars['File']>;
  formId?: InputMaybe<Scalars['String']>;
  requesterEmployeeId: Scalars['Int'];
  status?: InputMaybe<ProcurementValueObjectsPurchaseRequestStatusEnum>;
  typeId?: InputMaybe<Scalars['Int']>;
  url?: InputMaybe<Scalars['String']>;
  vendorId?: InputMaybe<Scalars['Int']>;
};


export type ProcurementMutationsCreateProcurementTypeArgs = {
  authorId?: InputMaybe<Scalars['Int']>;
  companyId: Scalars['Int'];
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};


export type ProcurementMutationsCreateWorkflowProcurementTypeArgs = {
  authorId: Scalars['Int'];
  companyId: Scalars['Int'];
  typeId: Scalars['Int'];
};


export type ProcurementMutationsDeleteProcurementPurchaseRequestArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type ProcurementMutationsDeleteProcurementTypeArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type ProcurementMutationsDuplicateProcurementTypeArgs = {
  authorId: Scalars['Int'];
  duplicateDescription: Scalars['String'];
  duplicateName: Scalars['String'];
  id: Scalars['Int'];
};


export type ProcurementMutationsMarkAsDoneProcurementUploadDocumentTaskArgs = {
  completedById: Scalars['Int'];
  uploadDocumentTaskId: Scalars['Int'];
};


export type ProcurementMutationsPublishChangesProcurementTypeArgs = {
  companyId: Scalars['Int'];
  formId: Scalars['Int'];
  id: Scalars['Int'];
  workflowId: Scalars['Int'];
};


export type ProcurementMutationsPublishProcurementTypeArgs = {
  companyId: Scalars['Int'];
  formId: Scalars['Int'];
  id: Scalars['Int'];
  workflowId?: InputMaybe<Scalars['Int']>;
};


export type ProcurementMutationsRejectProcurementPurchaseRequestArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
  rejectionReason?: InputMaybe<Scalars['String']>;
};


export type ProcurementMutationsRemoveFileProcurementUploadDocumentTaskArgs = {
  fileId: Scalars['Int'];
  uploadDocumentTaskId: Scalars['Int'];
};


export type ProcurementMutationsSaveProcurementTypeArgs = {
  authorId: Scalars['Int'];
  companyId: Scalars['Int'];
  form?: InputMaybe<SaveProcurementTypeFormInput>;
  id: Scalars['Int'];
  workflow?: InputMaybe<SaveProcurementTypeWorkflowInput>;
};


export type ProcurementMutationsUpdateAndSetToPendingProcurementPurchaseRequestArgs = {
  additionalInformation?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  cost: BigMoneyInput;
  date?: InputMaybe<Scalars['ISO8601Date']>;
  deadline?: InputMaybe<Scalars['ISO8601Date']>;
  description?: InputMaybe<Scalars['String']>;
  files: Array<Scalars['File']>;
  id: Scalars['Int'];
  typeId?: InputMaybe<Scalars['Int']>;
  url?: InputMaybe<Scalars['String']>;
  vendorId?: InputMaybe<Scalars['Int']>;
};


export type ProcurementMutationsUpdateProcurementPurchaseOrderArgs = {
  cardPaymentDetails?: InputMaybe<UpdateProcurementPurchaseOrderCardPaymentDetailsInput>;
  companyId: Scalars['Int'];
  cost: BigMoneyInput;
  description: Scalars['String'];
  formattedPoNumber: Scalars['String'];
  id: Scalars['Int'];
  legalEntityId: Scalars['Int'];
  preferredPaymentMethod?: InputMaybe<ProcurementValueObjectsPreferredPaymentMethodEnum>;
  status?: InputMaybe<ProcurementValueObjectsPurchaseOrderStatusEnum>;
  vendorId?: InputMaybe<Scalars['Int']>;
};


export type ProcurementMutationsUpdateProcurementPurchaseRequestArgs = {
  additionalInformation?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  cost: BigMoneyInput;
  date?: InputMaybe<Scalars['ISO8601Date']>;
  deadline?: InputMaybe<Scalars['ISO8601Date']>;
  description?: InputMaybe<Scalars['String']>;
  files: Array<Scalars['File']>;
  id: Scalars['Int'];
  typeId?: InputMaybe<Scalars['Int']>;
  url?: InputMaybe<Scalars['String']>;
  vendorId?: InputMaybe<Scalars['Int']>;
};


export type ProcurementMutationsUpdateProcurementTypeArgs = {
  companyId: Scalars['Int'];
  description?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
};


export type ProcurementMutationsUpdateStatusProcurementPurchaseOrderArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
  status: ProcurementValueObjectsPurchaseOrderStatusEnum;
};


export type ProcurementMutationsUploadProcurementUploadDocumentTaskArgs = {
  files: Array<Scalars['File']>;
  uploadDocumentTaskId: Scalars['Int'];
};

export type ProductUpdates = {
  __typename?: 'productUpdates';
  _policies: ProductUpdatesContextlessPolicies;
  headerView?: Maybe<ProductUpdatesHeaderView>;
  /** @deprecated Please favor `headerViewsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  headerViews: Array<ProductUpdatesHeaderView>;
  headerViewsConnection: ProductUpdatesHeaderViewConnection;
  productTour?: Maybe<ProductUpdatesProductTour>;
  /** @deprecated Please favor `productToursConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  productTours: Array<ProductUpdatesProductTour>;
  productToursConnection: ProductUpdatesProductTourConnection;
  shareableEmployee?: Maybe<ProductUpdatesShareableEmployee>;
  /** @deprecated Please favor `shareableEmployeesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  shareableEmployees: Array<ProductUpdatesShareableEmployee>;
  shareableEmployeesConnection: ProductUpdatesShareableEmployeeConnection;
  subscription?: Maybe<ProductUpdatesSubscription>;
  /** @deprecated Please favor `subscriptionsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  subscriptions: Array<ProductUpdatesSubscription>;
  subscriptionsConnection: ProductUpdatesSubscriptionConnection;
  update?: Maybe<ProductUpdatesUpdate>;
  updateModule?: Maybe<ProductUpdatesUpdateModule>;
  /** @deprecated Please favor `updateModulesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  updateModules: Array<ProductUpdatesUpdateModule>;
  updateModulesConnection: ProductUpdatesUpdateModuleConnection;
  /** @deprecated Please favor `updatesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  updates: Array<ProductUpdatesUpdate>;
  updatesConnection: ProductUpdatesUpdateConnection;
  waitlist?: Maybe<ProductUpdatesWaitlist>;
  /** @deprecated Please favor `waitlistsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  waitlists: Array<ProductUpdatesWaitlist>;
  waitlistsConnection: ProductUpdatesWaitlistConnection;
};


export type ProductUpdatesHeaderViewArgs = {
  id: Scalars['String'];
};


export type ProductUpdatesHeaderViewsArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};


export type ProductUpdatesHeaderViewsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ProductUpdatesProductTourArgs = {
  id: Scalars['String'];
  locale: Scalars['String'];
  preview: Scalars['Boolean'];
};


export type ProductUpdatesProductToursArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
  locale: Scalars['String'];
  preview: Scalars['Boolean'];
  title?: InputMaybe<Scalars['String']>;
};


export type ProductUpdatesProductToursConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  locale: Scalars['String'];
  offsetPage?: InputMaybe<Scalars['Int']>;
  preview: Scalars['Boolean'];
  sortOrder?: InputMaybe<Sort>;
  title?: InputMaybe<Scalars['String']>;
};


export type ProductUpdatesShareableEmployeeArgs = {
  id: Scalars['Int'];
};


export type ProductUpdatesShareableEmployeesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  slug?: InputMaybe<Scalars['String']>;
};


export type ProductUpdatesShareableEmployeesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ProductUpdatesSubscriptionArgs = {
  id: Scalars['String'];
};


export type ProductUpdatesSubscriptionsArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  productUpdateId?: InputMaybe<Scalars['String']>;
};


export type ProductUpdatesSubscriptionsConnectionArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  productUpdateId?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ProductUpdatesUpdateArgs = {
  id: Scalars['String'];
  locale: Scalars['String'];
  preview: Scalars['Boolean'];
};


export type ProductUpdatesUpdateModuleArgs = {
  id: Scalars['String'];
  locale: Scalars['String'];
  preview: Scalars['Boolean'];
};


export type ProductUpdatesUpdateModulesArgs = {
  alreadyReleased?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  locale: Scalars['String'];
  moduleSlug?: InputMaybe<Scalars['String']>;
  preview: Scalars['Boolean'];
};


export type ProductUpdatesUpdateModulesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  alreadyReleased?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  locale: Scalars['String'];
  moduleSlug?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  preview: Scalars['Boolean'];
  sortOrder?: InputMaybe<Sort>;
};


export type ProductUpdatesUpdatesArgs = {
  alreadyReleased?: InputMaybe<Scalars['Boolean']>;
  featuredIn?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  locale: Scalars['String'];
  moduleIdentifier?: InputMaybe<Scalars['String']>;
  moduleSlug?: InputMaybe<Scalars['String']>;
  preview: Scalars['Boolean'];
  publishedAfter?: InputMaybe<Scalars['ISO8601Date']>;
  releasedAfter?: InputMaybe<Scalars['Int']>;
  releasedToday?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
};


export type ProductUpdatesUpdatesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  alreadyReleased?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  featuredIn?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  locale: Scalars['String'];
  moduleIdentifier?: InputMaybe<Scalars['String']>;
  moduleSlug?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  preview: Scalars['Boolean'];
  publishedAfter?: InputMaybe<Scalars['ISO8601Date']>;
  releasedAfter?: InputMaybe<Scalars['Int']>;
  releasedToday?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ProductUpdatesWaitlistArgs = {
  id: Scalars['Int'];
};


export type ProductUpdatesWaitlistsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type ProductUpdatesWaitlistsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

export type ProductUpdatesMutations = {
  __typename?: 'productUpdatesMutations';
  createProductupdatesHeaderView: CreateProductupdatesHeaderViewPayload;
  createProductupdatesSharedUpdate: CreateProductupdatesSharedUpdatePayload;
  createProductupdatesSubscription: CreateProductupdatesSubscriptionPayload;
  createProductupdatesWaitlist: CreateProductupdatesWaitlistPayload;
  deleteProductupdatesSubscription: DeleteProductupdatesSubscriptionPayload;
};


export type ProductUpdatesMutationsCreateProductupdatesHeaderViewArgs = {
  module: Scalars['String'];
};


export type ProductUpdatesMutationsCreateProductupdatesSharedUpdateArgs = {
  locale: Scalars['String'];
  message: Scalars['String'];
  receiverIds: Array<Scalars['Int']>;
  slug: Scalars['String'];
};


export type ProductUpdatesMutationsCreateProductupdatesSubscriptionArgs = {
  productUpdateId: Scalars['String'];
  productUpdateSlug: Scalars['String'];
};


export type ProductUpdatesMutationsCreateProductupdatesWaitlistArgs = {
  isShared: Scalars['Boolean'];
  waitlistType: Scalars['String'];
};


export type ProductUpdatesMutationsDeleteProductupdatesSubscriptionArgs = {
  productUpdateId: Scalars['String'];
};

export type ProjectManagement = {
  __typename?: 'projectManagement';
  _policies: ProjectManagementContextlessPolicies;
  /** @deprecated Please favor `budgetStrategiesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  budgetStrategies: Array<ProjectManagementBudgetStrategy>;
  budgetStrategiesConnection: ProjectManagementBudgetStrategyConnection;
  /** @deprecated Please favor `defaultRateCostsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  defaultRateCosts: Array<ProjectManagementDefaultRateCost>;
  defaultRateCostsConnection: ProjectManagementDefaultRateCostConnection;
  employeeTimeDetailChart?: Maybe<ProjectManagementEmployeeTimeDetailChart>;
  /** @deprecated Please favor `employeeTimeDetailChartsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  employeeTimeDetailCharts: Array<ProjectManagementEmployeeTimeDetailChart>;
  employeeTimeDetailChartsConnection: ProjectManagementEmployeeTimeDetailChartConnection;
  /** @deprecated Please favor `estimatedWorkTimesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  estimatedWorkTimes: Array<ProjectManagementEstimatedWorkTime>;
  estimatedWorkTimesConnection: ProjectManagementEstimatedWorkTimeConnection;
  expenseRecord?: Maybe<ProjectManagementExpenseRecord>;
  /** @deprecated Please favor `expenseRecordsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  expenseRecords: Array<ProjectManagementExpenseRecord>;
  expenseRecordsConnection: ProjectManagementExpenseRecordConnection;
  /** @deprecated Please favor `exportableExpensesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  exportableExpenses: Array<ProjectManagementExportableExpense>;
  exportableExpensesConnection: ProjectManagementExportableExpenseConnection;
  /** @deprecated Please favor `exportableProjectsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  exportableProjects: Array<ProjectManagementExportableProject>;
  exportableProjectsConnection: ProjectManagementExportableProjectConnection;
  /** @deprecated Please favor `exportableSchedulesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  exportableSchedules: Array<ProjectManagementExportableSchedule>;
  exportableSchedulesConnection: ProjectManagementExportableScheduleConnection;
  /** @deprecated Please favor `exportableShiftsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  exportableShifts: Array<ProjectManagementExportableShift>;
  exportableShiftsConnection: ProjectManagementExportableShiftConnection;
  /** @deprecated Please favor `exportableTasksConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  exportableTasks: Array<ProjectManagementExportableTask>;
  exportableTasksConnection: ProjectManagementExportableTaskConnection;
  favouriteProject?: Maybe<ProjectManagementFavouriteProject>;
  /** @deprecated Please favor `favouriteProjectsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  favouriteProjects: Array<ProjectManagementFavouriteProject>;
  favouriteProjectsConnection: ProjectManagementFavouriteProjectConnection;
  financialProject?: Maybe<ProjectManagementFinancialProject>;
  /** @deprecated Please favor `financialProjectsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  financialProjects: Array<ProjectManagementFinancialProject>;
  financialProjectsConnection: ProjectManagementFinancialProjectConnection;
  fixedCostPlanning?: Maybe<ProjectManagementFixedCostPlanning>;
  /** @deprecated Please favor `fixedCostPlanningsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  fixedCostPlannings: Array<ProjectManagementFixedCostPlanning>;
  fixedCostPlanningsConnection: ProjectManagementFixedCostPlanningConnection;
  fixedTimeBudget?: Maybe<ProjectManagementFixedTimeBudget>;
  /** @deprecated Please favor `fixedTimeBudgetsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  fixedTimeBudgets: Array<ProjectManagementFixedTimeBudget>;
  fixedTimeBudgetsConnection: ProjectManagementFixedTimeBudgetConnection;
  flexibleTimeRecord?: Maybe<ProjectManagementFlexibleTimeRecord>;
  flexibleTimeRecordComment?: Maybe<ProjectManagementFlexibleTimeRecordComment>;
  /** @deprecated Please favor `flexibleTimeRecordCommentsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  flexibleTimeRecordComments: Array<ProjectManagementFlexibleTimeRecordComment>;
  flexibleTimeRecordCommentsConnection: ProjectManagementFlexibleTimeRecordCommentConnection;
  /** @deprecated Please favor `flexibleTimeRecordsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  flexibleTimeRecords: Array<ProjectManagementFlexibleTimeRecord>;
  flexibleTimeRecordsConnection: ProjectManagementFlexibleTimeRecordConnection;
  /** @deprecated Please favor `globalTimeRecordsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  globalTimeRecords: Array<ProjectManagementGlobalTimeRecord>;
  globalTimeRecordsConnection: ProjectManagementGlobalTimeRecordConnection;
  imputableProject?: Maybe<ProjectManagementImputableProject>;
  /** @deprecated Please favor `imputableProjectsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  imputableProjects: Array<ProjectManagementImputableProject>;
  imputableProjectsConnection: ProjectManagementImputableProjectConnection;
  plannedRecord?: Maybe<ProjectManagementPlannedRecord>;
  /** @deprecated Please favor `plannedRecordsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  plannedRecords: Array<ProjectManagementPlannedRecord>;
  plannedRecordsConnection: ProjectManagementPlannedRecordConnection;
  /** @deprecated Please favor `plannedTimesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  plannedTimes: Array<ProjectManagementPlannedTime>;
  plannedTimesConnection: ProjectManagementPlannedTimeConnection;
  /** @deprecated Please favor `processingRatesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  processingRates: Array<ProjectManagementProcessingRate>;
  processingRatesConnection: ProjectManagementProcessingRateConnection;
  project?: Maybe<ProjectManagementProject>;
  projectContributor?: Maybe<ProjectManagementProjectContributor>;
  /** @deprecated Please favor `projectContributorsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  projectContributors: Array<ProjectManagementProjectContributor>;
  projectContributorsConnection: ProjectManagementProjectContributorConnection;
  /** @deprecated Please favor `projectCostBreakdownChartPointsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  projectCostBreakdownChartPoints: Array<ProjectManagementProjectCostBreakdownChartPoint>;
  projectCostBreakdownChartPointsConnection: ProjectManagementProjectCostBreakdownChartPointConnection;
  /** @deprecated Please favor `projectCostChartPointsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  projectCostChartPoints: Array<ProjectManagementProjectCostChartPoint>;
  projectCostChartPointsConnection: ProjectManagementProjectCostChartPointConnection;
  /** @deprecated Please favor `projectCostDistributionChartPointsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  projectCostDistributionChartPoints: Array<ProjectManagementProjectCostDistributionChartPoint>;
  projectCostDistributionChartPointsConnection: ProjectManagementProjectCostDistributionChartPointConnection;
  projectDocument?: Maybe<ProjectManagementProjectDocument>;
  /** @deprecated Please favor `projectDocumentsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  projectDocuments: Array<ProjectManagementProjectDocument>;
  projectDocumentsConnection: ProjectManagementProjectDocumentConnection;
  projectRole?: Maybe<ProjectManagementProjectRole>;
  /** @deprecated Please favor `projectRolesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  projectRoles: Array<ProjectManagementProjectRole>;
  projectRolesConnection: ProjectManagementProjectRoleConnection;
  projectTask?: Maybe<ProjectManagementProjectTask>;
  /** @deprecated Please favor `projectTasksConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  projectTasks: Array<ProjectManagementProjectTask>;
  projectTasksConnection: ProjectManagementProjectTaskConnection;
  /** @deprecated Please favor `projectTimeDetailGraphsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  projectTimeDetailGraphs: Array<ProjectManagementProjectTimeDetailGraph>;
  projectTimeDetailGraphsConnection: ProjectManagementProjectTimeDetailGraphConnection;
  /** @deprecated Please favor `projectTimeGraphsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  projectTimeGraphs: Array<ProjectManagementProjectTimeGraph>;
  projectTimeGraphsConnection: ProjectManagementProjectTimeGraphConnection;
  /** @deprecated Please favor `projectTimeRangesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  projectTimeRanges: Array<ProjectManagementProjectTimeRange>;
  projectTimeRangesConnection: ProjectManagementProjectTimeRangeConnection;
  projectWorker?: Maybe<ProjectManagementProjectWorker>;
  /** @deprecated Please favor `projectWorkerCostHistoryRecordsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  projectWorkerCostHistoryRecords: Array<ProjectManagementProjectWorkerCostHistoryRecord>;
  projectWorkerCostHistoryRecordsConnection: ProjectManagementProjectWorkerCostHistoryRecordConnection;
  /** @deprecated Please favor `projectWorkersConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  projectWorkers: Array<ProjectManagementProjectWorker>;
  projectWorkersConnection: ProjectManagementProjectWorkerConnection;
  /** @deprecated Please favor `projectWorkersCostHistoryRecordsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  projectWorkersCostHistoryRecords: Array<ProjectManagementProjectWorkersCostHistoryRecord>;
  projectWorkersCostHistoryRecordsConnection: ProjectManagementProjectWorkersCostHistoryRecordConnection;
  /** @deprecated Please favor `projectsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  projects: Array<ProjectManagementProject>;
  projectsConnection: ProjectManagementProjectConnection;
  rate?: Maybe<ProjectManagementRate>;
  /** @deprecated Please favor `ratesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  rates: Array<ProjectManagementRate>;
  /** @deprecated Please favor `ratesBreakdownsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  ratesBreakdowns: Array<ProjectManagementRatesBreakdown>;
  ratesBreakdownsConnection: ProjectManagementRatesBreakdownConnection;
  ratesConnection: ProjectManagementRateConnection;
  /** @deprecated Please favor `salesInvoicesInsightsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  salesInvoicesInsights: Array<ProjectManagementSalesInvoicesInsight>;
  salesInvoicesInsightsConnection: ProjectManagementSalesInvoicesInsightConnection;
  /** @deprecated Please favor `spendingCostsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  spendingCosts: Array<ProjectManagementSpendingCost>;
  spendingCostsConnection: ProjectManagementSpendingCostConnection;
  /** @deprecated Please favor `spendingCostsInsightsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  spendingCostsInsights: Array<ProjectManagementSpendingCostsInsight>;
  spendingCostsInsightsConnection: ProjectManagementSpendingCostsInsightConnection;
  /** @deprecated Please favor `spendingInsightsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  spendingInsights: Array<ProjectManagementSpendingInsight>;
  spendingInsightsConnection: ProjectManagementSpendingInsightConnection;
  subproject?: Maybe<ProjectManagementSubproject>;
  /** @deprecated Please favor `subprojectHoursDistributionsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  subprojectHoursDistributions: Array<ProjectManagementSubprojectHoursDistribution>;
  subprojectHoursDistributionsConnection: ProjectManagementSubprojectHoursDistributionConnection;
  /** @deprecated Please favor `subprojectsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  subprojects: Array<ProjectManagementSubproject>;
  subprojectsConnection: ProjectManagementSubprojectConnection;
  timeRecord?: Maybe<ProjectManagementTimeRecord>;
  /** @deprecated Please favor `timeRecordsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  timeRecords: Array<ProjectManagementTimeRecord>;
  timeRecordsConnection: ProjectManagementTimeRecordConnection;
};


export type ProjectManagementBudgetStrategiesArgs = {
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type ProjectManagementBudgetStrategiesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
};


export type ProjectManagementDefaultRateCostsArgs = {
  resourceIds: Array<Scalars['Int']>;
  resourceType: Scalars['String'];
};


export type ProjectManagementDefaultRateCostsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  resourceIds: Array<Scalars['Int']>;
  resourceType: Scalars['String'];
  sortOrder?: InputMaybe<Sort>;
};


export type ProjectManagementEmployeeTimeDetailChartArgs = {
  employeeId: Scalars['Int'];
  endDate: Scalars['ISO8601Date'];
  id: Scalars['Int'];
  slotType: Scalars['String'];
  startDate: Scalars['ISO8601Date'];
};


export type ProjectManagementEmployeeTimeDetailChartsArgs = {
  employeeId: Scalars['Int'];
  endDate: Scalars['ISO8601Date'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  slotType: Scalars['String'];
  startDate: Scalars['ISO8601Date'];
};


export type ProjectManagementEmployeeTimeDetailChartsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeId: Scalars['Int'];
  endDate: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  slotType: Scalars['String'];
  sortOrder?: InputMaybe<Sort>;
  startDate: Scalars['ISO8601Date'];
};


export type ProjectManagementEstimatedWorkTimesArgs = {
  employeeIds?: Array<Scalars['Int']>;
  endDate: Scalars['ISO8601Date'];
  startDate: Scalars['ISO8601Date'];
};


export type ProjectManagementEstimatedWorkTimesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: Array<Scalars['Int']>;
  endDate: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startDate: Scalars['ISO8601Date'];
};


export type ProjectManagementExpenseRecordArgs = {
  id: Scalars['Int'];
};


export type ProjectManagementExpenseRecordsArgs = {
  employeeUserNameLike?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  expenseIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  imputableProjectIds?: InputMaybe<Array<Scalars['Int']>>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  projectWorkerIds?: InputMaybe<Array<Scalars['Int']>>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  subprojectIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
};


export type ProjectManagementExpenseRecordsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeUserNameLike?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  expenseIds?: InputMaybe<Array<Scalars['Int']>>;
  filter?: InputMaybe<ProjectManagementExpenseRecordFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  imputableProjectIds?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  projectWorkerIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  subprojectIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
};


export type ProjectManagementExportableExpensesArgs = {
  endDate: Scalars['ISO8601Date'];
  projectIds?: Array<Scalars['Int']>;
  startDate: Scalars['ISO8601Date'];
};


export type ProjectManagementExportableExpensesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endDate: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  projectIds?: Array<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startDate: Scalars['ISO8601Date'];
};


export type ProjectManagementExportableProjectsArgs = {
  dateGroup?: InputMaybe<ProjectManagementEnumsExportableProjectDateGroupEnum>;
  endDate: Scalars['ISO8601Date'];
  includeDate?: InputMaybe<Scalars['Boolean']>;
  includeEmployeesWithoutTimeTracked?: InputMaybe<Scalars['Boolean']>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  startDate: Scalars['ISO8601Date'];
  timeFormat?: InputMaybe<Scalars['String']>;
};


export type ProjectManagementExportableProjectsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  dateGroup?: InputMaybe<ProjectManagementEnumsExportableProjectDateGroupEnum>;
  endDate: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  includeDate?: InputMaybe<Scalars['Boolean']>;
  includeEmployeesWithoutTimeTracked?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
  startDate: Scalars['ISO8601Date'];
  timeFormat?: InputMaybe<Scalars['String']>;
};


export type ProjectManagementExportableSchedulesArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endDate: Scalars['ISO8601Date'];
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  startDate: Scalars['ISO8601Date'];
};


export type ProjectManagementExportableSchedulesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endDate: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
  startDate: Scalars['ISO8601Date'];
};


export type ProjectManagementExportableShiftsArgs = {
  employeeIds?: Array<Scalars['Int']>;
  endDate: Scalars['ISO8601Date'];
  includeSubprojects?: InputMaybe<Scalars['Boolean']>;
  sortByEmployee?: InputMaybe<Scalars['Boolean']>;
  startDate: Scalars['ISO8601Date'];
  timeFormat?: InputMaybe<Scalars['String']>;
};


export type ProjectManagementExportableShiftsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: Array<Scalars['Int']>;
  endDate: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  includeSubprojects?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortByEmployee?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Sort>;
  startDate: Scalars['ISO8601Date'];
  timeFormat?: InputMaybe<Scalars['String']>;
};


export type ProjectManagementExportableTasksArgs = {
  endDate: Scalars['ISO8601Date'];
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  startDate: Scalars['ISO8601Date'];
};


export type ProjectManagementExportableTasksConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endDate: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
  startDate: Scalars['ISO8601Date'];
};


export type ProjectManagementFavouriteProjectArgs = {
  employeeId: Scalars['Int'];
  id: Scalars['Int'];
};


export type ProjectManagementFavouriteProjectsArgs = {
  employeeId: Scalars['Int'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type ProjectManagementFavouriteProjectsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ProjectManagementFinancialProjectArgs = {
  id: Scalars['Int'];
};


export type ProjectManagementFinancialProjectsArgs = {
  billable?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  nameOrCode?: InputMaybe<Scalars['String']>;
};


export type ProjectManagementFinancialProjectsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  billable?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  nameOrCode?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ProjectManagementFixedCostPlanningArgs = {
  id: Scalars['Int'];
};


export type ProjectManagementFixedCostPlanningsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type ProjectManagementFixedCostPlanningsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
};


export type ProjectManagementFixedTimeBudgetArgs = {
  id: Scalars['Int'];
};


export type ProjectManagementFixedTimeBudgetsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type ProjectManagementFixedTimeBudgetsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
};


export type ProjectManagementFlexibleTimeRecordArgs = {
  id: Scalars['Int'];
};


export type ProjectManagementFlexibleTimeRecordCommentArgs = {
  id: Scalars['Int'];
};


export type ProjectManagementFlexibleTimeRecordCommentsArgs = {
  flexibleTimeRecordId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type ProjectManagementFlexibleTimeRecordCommentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  flexibleTimeRecordId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ProjectManagementFlexibleTimeRecordsArgs = {
  endsOn?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: Array<Scalars['Int']>;
  projectWorkerIds?: Array<Scalars['Int']>;
  startsOn?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
};


export type ProjectManagementFlexibleTimeRecordsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endsOn?: InputMaybe<Scalars['ISO8601Date']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: Array<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  projectWorkerIds?: Array<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startsOn?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
};


export type ProjectManagementGlobalTimeRecordsArgs = {
  employeeIds?: Array<Scalars['Int']>;
  endsOn: Scalars['ISO8601Date'];
  projectWorkerIds?: Array<Scalars['Int']>;
  startsOn: Scalars['ISO8601Date'];
  subprojectIds?: Array<Scalars['Int']>;
};


export type ProjectManagementGlobalTimeRecordsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: Array<Scalars['Int']>;
  endsOn: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  projectWorkerIds?: Array<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startsOn: Scalars['ISO8601Date'];
  subprojectIds?: Array<Scalars['Int']>;
};


export type ProjectManagementImputableProjectArgs = {
  id: Scalars['Int'];
};


export type ProjectManagementImputableProjectsArgs = {
  assigned?: InputMaybe<Scalars['Boolean']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  nameOrCode?: InputMaybe<Scalars['String']>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
};


export type ProjectManagementImputableProjectsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  assigned?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  filter?: InputMaybe<ProjectManagementImputableProjectFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  nameOrCode?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ProjectManagementPlannedRecordArgs = {
  id: Scalars['Int'];
};


export type ProjectManagementPlannedRecordsArgs = {
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  projectWorkerIds?: InputMaybe<Array<Scalars['Int']>>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  subprojectIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type ProjectManagementPlannedRecordsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  projectWorkerIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  subprojectIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type ProjectManagementPlannedTimesArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  onlyHiddenProjects?: InputMaybe<Scalars['Boolean']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
};


export type ProjectManagementPlannedTimesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyHiddenProjects?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Sort>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
};


export type ProjectManagementProcessingRatesArgs = {
  processing?: InputMaybe<Scalars['Boolean']>;
  resourceIds: Array<Scalars['Int']>;
  resourceType: Scalars['String'];
};


export type ProjectManagementProcessingRatesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  processing?: InputMaybe<Scalars['Boolean']>;
  resourceIds: Array<Scalars['Int']>;
  resourceType: Scalars['String'];
  sortOrder?: InputMaybe<Sort>;
};


export type ProjectManagementProjectArgs = {
  id: Scalars['Int'];
};


export type ProjectManagementProjectContributorArgs = {
  id: Scalars['Int'];
};


export type ProjectManagementProjectContributorsArgs = {
  activeEmployees?: InputMaybe<Scalars['Boolean']>;
  afterContributorId?: InputMaybe<Scalars['Int']>;
  assigned?: InputMaybe<Scalars['Boolean']>;
  beforeContributorId?: InputMaybe<Scalars['Int']>;
  employeeName?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  onlyByProjectRole?: InputMaybe<Scalars['Boolean']>;
  projectActive?: InputMaybe<Scalars['Boolean']>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type ProjectManagementProjectContributorsConnectionArgs = {
  activeEmployees?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  afterContributorId?: InputMaybe<Scalars['Int']>;
  assigned?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  beforeContributorId?: InputMaybe<Scalars['Int']>;
  employeeName?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<ProjectManagementProjectContributorFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyByProjectRole?: InputMaybe<Scalars['Boolean']>;
  projectActive?: InputMaybe<Scalars['Boolean']>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
};


export type ProjectManagementProjectCostBreakdownChartPointsArgs = {
  endDate: Scalars['ISO8601Date'];
  projectId: Scalars['Int'];
  slotType: Scalars['String'];
  startDate: Scalars['ISO8601Date'];
};


export type ProjectManagementProjectCostBreakdownChartPointsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endDate: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  projectId: Scalars['Int'];
  slotType: Scalars['String'];
  sortOrder?: InputMaybe<Sort>;
  startDate: Scalars['ISO8601Date'];
};


export type ProjectManagementProjectCostChartPointsArgs = {
  endDate: Scalars['ISO8601Date'];
  projectId: Scalars['Int'];
  slotType: Scalars['String'];
  startDate: Scalars['ISO8601Date'];
};


export type ProjectManagementProjectCostChartPointsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endDate: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  projectId: Scalars['Int'];
  slotType: Scalars['String'];
  sortOrder?: InputMaybe<Sort>;
  startDate: Scalars['ISO8601Date'];
};


export type ProjectManagementProjectCostDistributionChartPointsArgs = {
  endDate: Scalars['ISO8601Date'];
  includeEmployees?: InputMaybe<Scalars['Boolean']>;
  includeSubprojects?: InputMaybe<Scalars['Boolean']>;
  projectId: Scalars['Int'];
  slotType: Scalars['String'];
  startDate: Scalars['ISO8601Date'];
};


export type ProjectManagementProjectCostDistributionChartPointsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endDate: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  includeEmployees?: InputMaybe<Scalars['Boolean']>;
  includeSubprojects?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  projectId: Scalars['Int'];
  slotType: Scalars['String'];
  sortOrder?: InputMaybe<Sort>;
  startDate: Scalars['ISO8601Date'];
};


export type ProjectManagementProjectDocumentArgs = {
  id: Scalars['Int'];
};


export type ProjectManagementProjectDocumentsArgs = {
  filterOutDeleted?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  projectId?: InputMaybe<Scalars['Int']>;
};


export type ProjectManagementProjectDocumentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<ProjectManagementProjectDocumentFilter>;
  filterOutDeleted?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  projectId?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ProjectManagementProjectRoleArgs = {
  id: Scalars['Int'];
};


export type ProjectManagementProjectRolesArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  roles?: InputMaybe<Array<ProjectManagementProjectRoleRoleEnum>>;
};


export type ProjectManagementProjectRolesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  roles?: InputMaybe<Array<ProjectManagementProjectRoleRoleEnum>>;
  sortOrder?: InputMaybe<Sort>;
};


export type ProjectManagementProjectTaskArgs = {
  id: Scalars['Int'];
};


export type ProjectManagementProjectTasksArgs = {
  clientIds?: InputMaybe<Array<Scalars['Int']>>;
  completed?: InputMaybe<Scalars['Boolean']>;
  dueStatus?: InputMaybe<TasksValueObjectsTaskDueStatusEnum>;
  employeeId?: InputMaybe<Scalars['Int']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  incompleted?: InputMaybe<Scalars['Boolean']>;
  overdue?: InputMaybe<Scalars['Boolean']>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  subprojectIds?: InputMaybe<Array<Scalars['Int']>>;
  taskIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type ProjectManagementProjectTasksConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  clientIds?: InputMaybe<Array<Scalars['Int']>>;
  completed?: InputMaybe<Scalars['Boolean']>;
  dueStatus?: InputMaybe<TasksValueObjectsTaskDueStatusEnum>;
  employeeId?: InputMaybe<Scalars['Int']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  filter?: InputMaybe<ProjectManagementProjectTaskFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  incompleted?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  overdue?: InputMaybe<Scalars['Boolean']>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  subprojectIds?: InputMaybe<Array<Scalars['Int']>>;
  taskIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type ProjectManagementProjectTimeDetailGraphsArgs = {
  endDate: Scalars['ISO8601Date'];
  includeEmployee?: InputMaybe<Scalars['Boolean']>;
  includeSubproject?: InputMaybe<Scalars['Boolean']>;
  projectId: Scalars['Int'];
  slotType: Scalars['String'];
  startDate: Scalars['ISO8601Date'];
};


export type ProjectManagementProjectTimeDetailGraphsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endDate: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  includeEmployee?: InputMaybe<Scalars['Boolean']>;
  includeSubproject?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  projectId: Scalars['Int'];
  slotType: Scalars['String'];
  sortOrder?: InputMaybe<Sort>;
  startDate: Scalars['ISO8601Date'];
};


export type ProjectManagementProjectTimeGraphsArgs = {
  endDate: Scalars['ISO8601Date'];
  projectId: Scalars['Int'];
  slotType: Scalars['String'];
  startDate: Scalars['ISO8601Date'];
};


export type ProjectManagementProjectTimeGraphsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endDate: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  projectId: Scalars['Int'];
  slotType: Scalars['String'];
  sortOrder?: InputMaybe<Sort>;
  startDate: Scalars['ISO8601Date'];
};


export type ProjectManagementProjectTimeRangesArgs = {
  projectId: Scalars['Int'];
};


export type ProjectManagementProjectTimeRangesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  projectId: Scalars['Int'];
  sortOrder?: InputMaybe<Sort>;
};


export type ProjectManagementProjectWorkerArgs = {
  id: Scalars['Int'];
};


export type ProjectManagementProjectWorkerCostHistoryRecordsArgs = {
  projectWorkerId: Scalars['Int'];
};


export type ProjectManagementProjectWorkerCostHistoryRecordsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  projectWorkerId: Scalars['Int'];
  sortOrder?: InputMaybe<Sort>;
};


export type ProjectManagementProjectWorkersArgs = {
  assigned?: InputMaybe<Scalars['Boolean']>;
  byPlannedRecordEnd?: InputMaybe<Scalars['ISO8601Date']>;
  byPlannedRecordStart?: InputMaybe<Scalars['ISO8601Date']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeName?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeCost?: InputMaybe<Scalars['Boolean']>;
  includeInputedMinutes?: InputMaybe<Scalars['Boolean']>;
  includeLaborCost?: InputMaybe<Scalars['Boolean']>;
  noSubproject?: InputMaybe<Scalars['Boolean']>;
  onlyByProjectRole?: InputMaybe<Scalars['Boolean']>;
  projectActive?: InputMaybe<Scalars['Boolean']>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  subprojectIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
};


export type ProjectManagementProjectWorkersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  assigned?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  byPlannedRecordEnd?: InputMaybe<Scalars['ISO8601Date']>;
  byPlannedRecordStart?: InputMaybe<Scalars['ISO8601Date']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeName?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<ProjectManagementProjectWorkerFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeCost?: InputMaybe<Scalars['Boolean']>;
  includeInputedMinutes?: InputMaybe<Scalars['Boolean']>;
  includeLaborCost?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  noSubproject?: InputMaybe<Scalars['Boolean']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyByProjectRole?: InputMaybe<Scalars['Boolean']>;
  projectActive?: InputMaybe<Scalars['Boolean']>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
  subprojectIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
};


export type ProjectManagementProjectWorkersCostHistoryRecordsArgs = {
  projectWorkerIds: Array<Scalars['Int']>;
};


export type ProjectManagementProjectWorkersCostHistoryRecordsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  projectWorkerIds: Array<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ProjectManagementProjectsArgs = {
  assignedEmployeesIds?: InputMaybe<Array<Scalars['Int']>>;
  billable?: InputMaybe<Scalars['Boolean']>;
  clientIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeCosts?: InputMaybe<Scalars['Boolean']>;
  includeInputedMinutes?: Scalars['Boolean'];
  legalEntityId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  nameOrCode?: InputMaybe<Scalars['String']>;
  noClients?: InputMaybe<Scalars['Boolean']>;
  notClosed?: InputMaybe<Scalars['Boolean']>;
  roleTypes?: InputMaybe<Array<ProjectManagementProjectRoleRoleEnum>>;
  roledByEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  skipViewerByEmployeeId?: InputMaybe<Scalars['Int']>;
  totalCurrency?: InputMaybe<Scalars['String']>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
};


export type ProjectManagementProjectsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  assignedEmployeesIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  billable?: InputMaybe<Scalars['Boolean']>;
  clientIds?: InputMaybe<Array<Scalars['Int']>>;
  filter?: InputMaybe<ProjectManagementProjectFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeCosts?: InputMaybe<Scalars['Boolean']>;
  includeInputedMinutes?: Scalars['Boolean'];
  last?: InputMaybe<Scalars['Int']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  nameOrCode?: InputMaybe<Scalars['String']>;
  noClients?: InputMaybe<Scalars['Boolean']>;
  notClosed?: InputMaybe<Scalars['Boolean']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  roleTypes?: InputMaybe<Array<ProjectManagementProjectRoleRoleEnum>>;
  roledByEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  skipViewerByEmployeeId?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  totalCurrency?: InputMaybe<Scalars['String']>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
};


export type ProjectManagementRateArgs = {
  id: Scalars['Int'];
};


export type ProjectManagementRatesArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  employeeName?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  projectId?: InputMaybe<Scalars['Int']>;
  recordType?: InputMaybe<Scalars['String']>;
  referenceRateId?: InputMaybe<Scalars['Int']>;
  referenceRateIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceId?: InputMaybe<Scalars['Int']>;
  resourceIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceType?: InputMaybe<Scalars['String']>;
  roleOrLevel?: InputMaybe<Scalars['String']>;
  withoutProject?: InputMaybe<Scalars['Boolean']>;
};


export type ProjectManagementRatesBreakdownsArgs = {
  projectId: Scalars['Int'];
};


export type ProjectManagementRatesBreakdownsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  projectId: Scalars['Int'];
  sortOrder?: InputMaybe<Sort>;
};


export type ProjectManagementRatesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  employeeName?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<ProjectManagementRateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  projectId?: InputMaybe<Scalars['Int']>;
  recordType?: InputMaybe<Scalars['String']>;
  referenceRateId?: InputMaybe<Scalars['Int']>;
  referenceRateIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceId?: InputMaybe<Scalars['Int']>;
  resourceIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceType?: InputMaybe<Scalars['String']>;
  roleOrLevel?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  withoutProject?: InputMaybe<Scalars['Boolean']>;
};


export type ProjectManagementSalesInvoicesInsightsArgs = {
  projectId: Scalars['Int'];
};


export type ProjectManagementSalesInvoicesInsightsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  projectId: Scalars['Int'];
  sortOrder?: InputMaybe<Sort>;
};


export type ProjectManagementSpendingCostsArgs = {
  dateRange?: InputMaybe<Array<Scalars['ISO8601Date']>>;
  expenseCategories?: InputMaybe<Array<FinanceServicesCustomCategoriesConfigExpenseCategoriesEnum>>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  status?: InputMaybe<Array<ProjectManagementSpendingCostStatusEnum>>;
};


export type ProjectManagementSpendingCostsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  dateRange?: InputMaybe<Array<Scalars['ISO8601Date']>>;
  expenseCategories?: InputMaybe<Array<FinanceServicesCustomCategoriesConfigExpenseCategoriesEnum>>;
  filter?: InputMaybe<ProjectManagementSpendingCostFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
  status?: InputMaybe<Array<ProjectManagementSpendingCostStatusEnum>>;
};


export type ProjectManagementSpendingCostsInsightsArgs = {
  onlyApproved?: InputMaybe<Scalars['Boolean']>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  projectWorkerIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type ProjectManagementSpendingCostsInsightsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyApproved?: InputMaybe<Scalars['Boolean']>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  projectWorkerIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
};


export type ProjectManagementSpendingInsightsArgs = {
  projectId: Scalars['Int'];
};


export type ProjectManagementSpendingInsightsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  projectId: Scalars['Int'];
  sortOrder?: InputMaybe<Sort>;
};


export type ProjectManagementSubprojectArgs = {
  id: Scalars['Int'];
};


export type ProjectManagementSubprojectHoursDistributionsArgs = {
  projectId: Scalars['Int'];
};


export type ProjectManagementSubprojectHoursDistributionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  projectId: Scalars['Int'];
  sortOrder?: InputMaybe<Sort>;
};


export type ProjectManagementSubprojectsArgs = {
  financialProjectIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  imputableProjectIds?: InputMaybe<Array<Scalars['Int']>>;
  includeCost?: InputMaybe<Scalars['Boolean']>;
  includeInputedMinutes?: InputMaybe<Scalars['Boolean']>;
  includeNoSubproject?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  notClosed?: InputMaybe<Scalars['Boolean']>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
};


export type ProjectManagementSubprojectsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<ProjectManagementSubprojectFilter>;
  financialProjectIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  imputableProjectIds?: InputMaybe<Array<Scalars['Int']>>;
  includeCost?: InputMaybe<Scalars['Boolean']>;
  includeInputedMinutes?: InputMaybe<Scalars['Boolean']>;
  includeNoSubproject?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  notClosed?: InputMaybe<Scalars['Boolean']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
};


export type ProjectManagementTimeRecordArgs = {
  id: Scalars['Int'];
};


export type ProjectManagementTimeRecordsArgs = {
  attendanceShiftIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  month?: InputMaybe<Scalars['Int']>;
  projectWorkerIds?: InputMaybe<Array<Scalars['Int']>>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  subprojectIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
  year?: InputMaybe<Scalars['Int']>;
};


export type ProjectManagementTimeRecordsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  attendanceShiftIds?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  filter?: InputMaybe<ProjectManagementTimeRecordFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  month?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  projectWorkerIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  subprojectIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAfter?: InputMaybe<Scalars['ISO8601Date']>;
  year?: InputMaybe<Scalars['Int']>;
};

export type ProjectManagementImporterMutations = {
  __typename?: 'projectManagementImporterMutations';
  confirmProjectmanagementimporterProjectsImport: ConfirmProjectmanagementimporterProjectsImportPayload;
  getProjectmanagementimporterProjectsTemplate: GetProjectmanagementimporterProjectsTemplatePayload;
  previewProjectmanagementimporterProjectsImport: PreviewProjectmanagementimporterProjectsImportPayload;
};


export type ProjectManagementImporterMutationsConfirmProjectmanagementimporterProjectsImportArgs = {
  selectedProjects: Array<Scalars['String']>;
  token: Scalars['String'];
};


export type ProjectManagementImporterMutationsPreviewProjectmanagementimporterProjectsImportArgs = {
  file: Scalars['File'];
};

export type ProjectManagementMutations = {
  __typename?: 'projectManagementMutations';
  activateProjectmanagementProject: ActivateProjectmanagementProjectPayload;
  bulkAssignProjectmanagementProjectRole: BulkAssignProjectmanagementProjectRolePayload;
  bulkAssignProjectmanagementProjectWorker: BulkAssignProjectmanagementProjectWorkerPayload;
  bulkChangeAssignmentProjectmanagementProject: BulkChangeAssignmentProjectmanagementProjectPayload;
  bulkClientAssignmentProjectmanagementProject: BulkClientAssignmentProjectmanagementProjectPayload;
  bulkCreateProjectmanagementPlannedRecord: BulkCreateProjectmanagementPlannedRecordPayload;
  bulkCreateProjectmanagementProjectDocument: BulkCreateProjectmanagementProjectDocumentPayload;
  bulkCreateProjectmanagementProjectWorker: BulkCreateProjectmanagementProjectWorkerPayload;
  bulkCreateProjectmanagementRate: BulkCreateProjectmanagementRatePayload;
  bulkDeleteProjectmanagementGlobalTimeRecord: BulkDeleteProjectmanagementGlobalTimeRecordPayload;
  bulkDeleteProjectmanagementTimeRecord: BulkDeleteProjectmanagementTimeRecordPayload;
  bulkDestroyProjectmanagementProjectTask: BulkDestroyProjectmanagementProjectTaskPayload;
  bulkDuplicateProjectmanagementProjectTask: BulkDuplicateProjectmanagementProjectTaskPayload;
  bulkProcessProjectmanagementTimeRecord: BulkProcessProjectmanagementTimeRecordPayload;
  changeAssignmentProjectmanagementProject: ChangeAssignmentProjectmanagementProjectPayload;
  changeBillableRateProjectmanagementProject: ChangeBillableRateProjectmanagementProjectPayload;
  changeStatusProjectmanagementProject: ChangeStatusProjectmanagementProjectPayload;
  closeProjectmanagementProject: CloseProjectmanagementProjectPayload;
  createProjectmanagementBudgetStrategy: CreateProjectmanagementBudgetStrategyPayload;
  createProjectmanagementFavouriteProject: CreateProjectmanagementFavouriteProjectPayload;
  createProjectmanagementFixedCostPlanning: CreateProjectmanagementFixedCostPlanningPayload;
  createProjectmanagementFixedTimeBudget: CreateProjectmanagementFixedTimeBudgetPayload;
  createProjectmanagementFlexibleTimeRecord: CreateProjectmanagementFlexibleTimeRecordPayload;
  createProjectmanagementFlexibleTimeRecordComment: CreateProjectmanagementFlexibleTimeRecordCommentPayload;
  createProjectmanagementProject: CreateProjectmanagementProjectPayload;
  createProjectmanagementProjectTask: CreateProjectmanagementProjectTaskPayload;
  createProjectmanagementProjectWorker: CreateProjectmanagementProjectWorkerPayload;
  createProjectmanagementRate: CreateProjectmanagementRatePayload;
  createProjectmanagementSubproject: CreateProjectmanagementSubprojectPayload;
  createProjectmanagementTimeRecord: CreateProjectmanagementTimeRecordPayload;
  createProjectmanagementUpsellNotificationMessage: CreateProjectmanagementUpsellNotificationMessagePayload;
  deleteByFlexibleTimeRecordProjectmanagementFlexibleTimeRecordComment: DeleteByFlexibleTimeRecordProjectmanagementFlexibleTimeRecordCommentPayload;
  deleteCustomRangeProjectmanagementPlannedRecord: DeleteCustomRangeProjectmanagementPlannedRecordPayload;
  deleteProjectmanagementBudgetStrategy: DeleteProjectmanagementBudgetStrategyPayload;
  deleteProjectmanagementFavouriteProject: DeleteProjectmanagementFavouriteProjectPayload;
  deleteProjectmanagementFixedCostPlanning: DeleteProjectmanagementFixedCostPlanningPayload;
  deleteProjectmanagementFixedTimeBudget: DeleteProjectmanagementFixedTimeBudgetPayload;
  deleteProjectmanagementFlexibleTimeRecord: DeleteProjectmanagementFlexibleTimeRecordPayload;
  deleteProjectmanagementPlannedRecord: DeleteProjectmanagementPlannedRecordPayload;
  deleteProjectmanagementRate: DeleteProjectmanagementRatePayload;
  deleteProjectmanagementSubproject: DeleteProjectmanagementSubprojectPayload;
  deleteProjectmanagementTimeRecord: DeleteProjectmanagementTimeRecordPayload;
  duplicateProjectmanagementProject: DuplicateProjectmanagementProjectPayload;
  linkProjectmanagementExpenseRecord: LinkProjectmanagementExpenseRecordPayload;
  processedProjectmanagementRate: ProcessedProjectmanagementRatePayload;
  renameProjectmanagementSubproject: RenameProjectmanagementSubprojectPayload;
  softDeleteProjectmanagementProject: SoftDeleteProjectmanagementProjectPayload;
  softDeleteProjectmanagementProjectDocument: SoftDeleteProjectmanagementProjectDocumentPayload;
  unassignProjectmanagementProjectRole: UnassignProjectmanagementProjectRolePayload;
  unassignProjectmanagementProjectWorker: UnassignProjectmanagementProjectWorkerPayload;
  updateByFlexibleTimeRecordProjectmanagementFlexibleTimeRecordComment: UpdateByFlexibleTimeRecordProjectmanagementFlexibleTimeRecordCommentPayload;
  updateCustomRangeProjectmanagementPlannedRecord: UpdateCustomRangeProjectmanagementPlannedRecordPayload;
  updateFinancialDetailsProjectmanagementProject: UpdateFinancialDetailsProjectmanagementProjectPayload;
  updateImputedMinutesProjectmanagementGlobalTimeRecord: UpdateImputedMinutesProjectmanagementGlobalTimeRecordPayload;
  updateProjectWorkerProjectmanagementTimeRecord: UpdateProjectWorkerProjectmanagementTimeRecordPayload;
  updateProjectmanagementBudgetStrategy: UpdateProjectmanagementBudgetStrategyPayload;
  updateProjectmanagementFixedCostPlanning: UpdateProjectmanagementFixedCostPlanningPayload;
  updateProjectmanagementFixedTimeBudget: UpdateProjectmanagementFixedTimeBudgetPayload;
  updateProjectmanagementFlexibleTimeRecord: UpdateProjectmanagementFlexibleTimeRecordPayload;
  updateProjectmanagementPlannedRecord: UpdateProjectmanagementPlannedRecordPayload;
  updateProjectmanagementProject: UpdateProjectmanagementProjectPayload;
  updateProjectmanagementProjectRole: UpdateProjectmanagementProjectRolePayload;
  updateProjectmanagementProjectTask: UpdateProjectmanagementProjectTaskPayload;
  updateProjectmanagementRate: UpdateProjectmanagementRatePayload;
  updateProjectmanagementSubproject: UpdateProjectmanagementSubprojectPayload;
};


export type ProjectManagementMutationsActivateProjectmanagementProjectArgs = {
  id: Scalars['Int'];
};


export type ProjectManagementMutationsBulkAssignProjectmanagementProjectRoleArgs = {
  editors?: InputMaybe<Array<Scalars['Int']>>;
  owners?: InputMaybe<Array<Scalars['Int']>>;
  projectIds: Array<Scalars['Int']>;
  viewers?: InputMaybe<Array<Scalars['Int']>>;
};


export type ProjectManagementMutationsBulkAssignProjectmanagementProjectWorkerArgs = {
  employeeIds: Array<Scalars['Int']>;
  notifyEmployees?: InputMaybe<Scalars['Boolean']>;
  projectId?: InputMaybe<Scalars['Int']>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type ProjectManagementMutationsBulkChangeAssignmentProjectmanagementProjectArgs = {
  employeesAssignment: Scalars['String'];
  ids: Array<Scalars['Int']>;
};


export type ProjectManagementMutationsBulkClientAssignmentProjectmanagementProjectArgs = {
  clientId?: InputMaybe<Scalars['Int']>;
  companyId: Scalars['Int'];
  ids: Array<Scalars['Int']>;
};


export type ProjectManagementMutationsBulkCreateProjectmanagementPlannedRecordArgs = {
  dailyMinutes: Scalars['Int'];
  endDate: Scalars['ISO8601Date'];
  projectWorkerIds: Array<Scalars['Int']>;
  startDate: Scalars['ISO8601Date'];
  subprojectId?: InputMaybe<Scalars['Int']>;
  weekDays?: InputMaybe<Array<Scalars['Int']>>;
};


export type ProjectManagementMutationsBulkCreateProjectmanagementProjectDocumentArgs = {
  files: Array<Scalars['File']>;
  projectId: Scalars['Int'];
  uploaderId: Scalars['Int'];
};


export type ProjectManagementMutationsBulkCreateProjectmanagementProjectWorkerArgs = {
  employeeIds: Array<Scalars['Int']>;
  projectId: Scalars['Int'];
};


export type ProjectManagementMutationsBulkCreateProjectmanagementRateArgs = {
  rates: Array<BulkCreateProjectmanagementRateRatesInput>;
};


export type ProjectManagementMutationsBulkDeleteProjectmanagementGlobalTimeRecordArgs = {
  date: Scalars['ISO8601Date'];
  projectWorkerId: Scalars['Int'];
  subprojectId?: InputMaybe<Scalars['Int']>;
};


export type ProjectManagementMutationsBulkDeleteProjectmanagementTimeRecordArgs = {
  date: Scalars['ISO8601Date'];
  projectWorkerId: Scalars['Int'];
  subprojectId?: InputMaybe<Scalars['Int']>;
};


export type ProjectManagementMutationsBulkDestroyProjectmanagementProjectTaskArgs = {
  ids: Array<Scalars['Int']>;
};


export type ProjectManagementMutationsBulkDuplicateProjectmanagementProjectTaskArgs = {
  excludeAssignees?: InputMaybe<Scalars['Boolean']>;
  ids: Array<Scalars['Int']>;
  projectId?: InputMaybe<Scalars['Int']>;
  subprojectId?: InputMaybe<Scalars['Int']>;
};


export type ProjectManagementMutationsBulkProcessProjectmanagementTimeRecordArgs = {
  items: Array<BulkProcessProjectmanagementTimeRecordItemsInput>;
};


export type ProjectManagementMutationsChangeAssignmentProjectmanagementProjectArgs = {
  employeesAssignment: Scalars['String'];
  id: Scalars['Int'];
};


export type ProjectManagementMutationsChangeBillableRateProjectmanagementProjectArgs = {
  billableRateType: ProjectManagementProjectBillableRateTypeEnum;
  id: Scalars['Int'];
  rates?: InputMaybe<Array<ChangeBillableRateProjectmanagementProjectRatesInput>>;
};


export type ProjectManagementMutationsChangeStatusProjectmanagementProjectArgs = {
  id: Scalars['Int'];
  status: ProjectManagementProjectStatusEnum;
};


export type ProjectManagementMutationsCloseProjectmanagementProjectArgs = {
  id: Scalars['Int'];
};


export type ProjectManagementMutationsCreateProjectmanagementBudgetStrategyArgs = {
  budgetAllocation?: InputMaybe<Scalars['Int']>;
  budgetStrategyType?: InputMaybe<ProjectManagementValueObjectsBudgetStrategyTypeEnum>;
  feeAmountCents?: InputMaybe<Scalars['Int']>;
  plannedCents?: InputMaybe<Scalars['Int']>;
  plannedMinutes?: InputMaybe<Scalars['Int']>;
  projectId: Scalars['Int'];
};


export type ProjectManagementMutationsCreateProjectmanagementFavouriteProjectArgs = {
  projectWorkerId: Scalars['Int'];
  subprojectId?: InputMaybe<Scalars['Int']>;
};


export type ProjectManagementMutationsCreateProjectmanagementFixedCostPlanningArgs = {
  budgetAllocationCents: Scalars['Int'];
  feeAmountCents?: InputMaybe<Scalars['Int']>;
  projectId: Scalars['Int'];
};


export type ProjectManagementMutationsCreateProjectmanagementFixedTimeBudgetArgs = {
  budgetAllocation: Scalars['Int'];
  projectId: Scalars['Int'];
};


export type ProjectManagementMutationsCreateProjectmanagementFlexibleTimeRecordArgs = {
  date: Scalars['ISO8601Date'];
  imputedMinutes: Scalars['Int'];
  projectWorkerId: Scalars['Int'];
  subprojectId?: InputMaybe<Scalars['Int']>;
};


export type ProjectManagementMutationsCreateProjectmanagementFlexibleTimeRecordCommentArgs = {
  content: Scalars['String'];
  flexibleTimeRecordId: Scalars['Int'];
};


export type ProjectManagementMutationsCreateProjectmanagementProjectArgs = {
  budgetAllocation?: InputMaybe<Scalars['Int']>;
  budgetAllocationCents?: InputMaybe<Scalars['Int']>;
  budgetType?: InputMaybe<Scalars['String']>;
  clientId?: InputMaybe<Scalars['Int']>;
  code?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  dueDate?: InputMaybe<Scalars['ISO8601Date']>;
  employeesAssignment?: InputMaybe<Scalars['String']>;
  feeAmountCents?: InputMaybe<Scalars['Int']>;
  fixedCostCents?: InputMaybe<Scalars['Int']>;
  isBillable?: InputMaybe<Scalars['Boolean']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  plannedCents?: InputMaybe<Scalars['Int']>;
  plannedMinutes?: InputMaybe<Scalars['Int']>;
  projectAdmins?: InputMaybe<Array<Scalars['Int']>>;
  projectManagers?: InputMaybe<Array<Scalars['Int']>>;
  projectViewers?: InputMaybe<Array<Scalars['Int']>>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  status?: InputMaybe<Scalars['String']>;
  usePolicyContextAsOwner?: InputMaybe<Scalars['Boolean']>;
};


export type ProjectManagementMutationsCreateProjectmanagementProjectTaskArgs = {
  assigneeEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  content?: InputMaybe<Scalars['String']>;
  dueOn?: InputMaybe<Scalars['ISO8601Date']>;
  files?: InputMaybe<Array<Scalars['File']>>;
  followUp?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  projectId: Scalars['Int'];
  startsOn?: InputMaybe<Scalars['ISO8601Date']>;
  status?: InputMaybe<TasksValueObjectsTaskStatusEnum>;
  subprojectId?: InputMaybe<Scalars['Int']>;
};


export type ProjectManagementMutationsCreateProjectmanagementProjectWorkerArgs = {
  employeeId: Scalars['Int'];
  projectId: Scalars['Int'];
};


export type ProjectManagementMutationsCreateProjectmanagementRateArgs = {
  billingRateCents: Scalars['Int'];
  currency: Scalars['String'];
  profitabilityPercentageCents: Scalars['Int'];
  projectId?: InputMaybe<Scalars['Int']>;
  referenceRateId?: InputMaybe<Scalars['Int']>;
  resourceId: Scalars['Int'];
  resourceType: Scalars['String'];
};


export type ProjectManagementMutationsCreateProjectmanagementSubprojectArgs = {
  name: Scalars['String'];
  projectId: Scalars['Int'];
  status?: InputMaybe<ProjectManagementValueObjectsStatusTypesEnum>;
};


export type ProjectManagementMutationsCreateProjectmanagementTimeRecordArgs = {
  attendanceShiftId: Scalars['Int'];
  projectWorkerId: Scalars['Int'];
  subprojectId?: InputMaybe<Scalars['Int']>;
};


export type ProjectManagementMutationsCreateProjectmanagementUpsellNotificationMessageArgs = {
  source: Scalars['String'];
};


export type ProjectManagementMutationsDeleteByFlexibleTimeRecordProjectmanagementFlexibleTimeRecordCommentArgs = {
  flexibleTimeRecordId: Scalars['Int'];
};


export type ProjectManagementMutationsDeleteCustomRangeProjectmanagementPlannedRecordArgs = {
  endDate: Scalars['ISO8601Date'];
  id: Scalars['Int'];
  startDate: Scalars['ISO8601Date'];
};


export type ProjectManagementMutationsDeleteProjectmanagementBudgetStrategyArgs = {
  id: Scalars['Int'];
};


export type ProjectManagementMutationsDeleteProjectmanagementFavouriteProjectArgs = {
  id: Scalars['Int'];
};


export type ProjectManagementMutationsDeleteProjectmanagementFixedCostPlanningArgs = {
  id: Scalars['Int'];
};


export type ProjectManagementMutationsDeleteProjectmanagementFixedTimeBudgetArgs = {
  id: Scalars['Int'];
};


export type ProjectManagementMutationsDeleteProjectmanagementFlexibleTimeRecordArgs = {
  id: Scalars['Int'];
};


export type ProjectManagementMutationsDeleteProjectmanagementPlannedRecordArgs = {
  id: Scalars['Int'];
};


export type ProjectManagementMutationsDeleteProjectmanagementRateArgs = {
  id: Scalars['Int'];
};


export type ProjectManagementMutationsDeleteProjectmanagementSubprojectArgs = {
  id: Scalars['Int'];
};


export type ProjectManagementMutationsDeleteProjectmanagementTimeRecordArgs = {
  id: Scalars['Int'];
};


export type ProjectManagementMutationsDuplicateProjectmanagementProjectArgs = {
  code?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  dueDate?: InputMaybe<Scalars['ISO8601Date']>;
  includeClient: Scalars['Boolean'];
  includeProjectTasks: Scalars['Boolean'];
  includeProjectTasksAssignees: Scalars['Boolean'];
  includeProjectWorkers: Scalars['Boolean'];
  includeSubprojects: Scalars['Boolean'];
  name: Scalars['String'];
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  toBeDuplicatedId: Scalars['Int'];
};


export type ProjectManagementMutationsLinkProjectmanagementExpenseRecordArgs = {
  expenseId: Scalars['Int'];
  items: Array<LinkProjectmanagementExpenseRecordItemsInput>;
};


export type ProjectManagementMutationsProcessedProjectmanagementRateArgs = {
  id: Scalars['Int'];
  processing?: InputMaybe<Scalars['Boolean']>;
};


export type ProjectManagementMutationsRenameProjectmanagementSubprojectArgs = {
  id: Scalars['Int'];
  name: Scalars['String'];
};


export type ProjectManagementMutationsSoftDeleteProjectmanagementProjectArgs = {
  id: Scalars['Int'];
};


export type ProjectManagementMutationsSoftDeleteProjectmanagementProjectDocumentArgs = {
  ids: Array<Scalars['Int']>;
  projectId: Scalars['Int'];
};


export type ProjectManagementMutationsUnassignProjectmanagementProjectRoleArgs = {
  id: Scalars['Int'];
};


export type ProjectManagementMutationsUnassignProjectmanagementProjectWorkerArgs = {
  id: Scalars['Int'];
};


export type ProjectManagementMutationsUpdateByFlexibleTimeRecordProjectmanagementFlexibleTimeRecordCommentArgs = {
  content: Scalars['String'];
  flexibleTimeRecordId: Scalars['Int'];
};


export type ProjectManagementMutationsUpdateCustomRangeProjectmanagementPlannedRecordArgs = {
  dailyMinutes: Scalars['Int'];
  endDate: Scalars['ISO8601Date'];
  id: Scalars['Int'];
  projectWorkerId?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['ISO8601Date'];
  weekDays?: InputMaybe<Array<Scalars['Int']>>;
};


export type ProjectManagementMutationsUpdateFinancialDetailsProjectmanagementProjectArgs = {
  fixedCostCents?: InputMaybe<Scalars['Int']>;
  isBillable: Scalars['Boolean'];
  legalEntityId: Scalars['Int'];
  projectId: Scalars['Int'];
};


export type ProjectManagementMutationsUpdateImputedMinutesProjectmanagementGlobalTimeRecordArgs = {
  date: Scalars['ISO8601Date'];
  imputedMinutes: Scalars['Int'];
  projectWorkerId: Scalars['Int'];
  subprojectId?: InputMaybe<Scalars['Int']>;
};


export type ProjectManagementMutationsUpdateProjectWorkerProjectmanagementTimeRecordArgs = {
  id: Scalars['Int'];
  projectWorkerId: Scalars['Int'];
  subprojectId?: InputMaybe<Scalars['Int']>;
};


export type ProjectManagementMutationsUpdateProjectmanagementBudgetStrategyArgs = {
  budgetAllocation?: InputMaybe<Scalars['Int']>;
  budgetStrategyType?: InputMaybe<ProjectManagementValueObjectsBudgetStrategyTypeEnum>;
  feeAmountCents?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  plannedCents?: InputMaybe<Scalars['Int']>;
  plannedMinutes?: InputMaybe<Scalars['Int']>;
};


export type ProjectManagementMutationsUpdateProjectmanagementFixedCostPlanningArgs = {
  budgetAllocationCents: Scalars['Int'];
  feeAmountCents?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
};


export type ProjectManagementMutationsUpdateProjectmanagementFixedTimeBudgetArgs = {
  budgetAllocation: Scalars['Int'];
  id: Scalars['Int'];
};


export type ProjectManagementMutationsUpdateProjectmanagementFlexibleTimeRecordArgs = {
  id: Scalars['Int'];
  imputedMinutes: Scalars['Int'];
};


export type ProjectManagementMutationsUpdateProjectmanagementPlannedRecordArgs = {
  dailyMinutes: Scalars['Int'];
  endDate: Scalars['ISO8601Date'];
  id: Scalars['Int'];
  projectWorkerId?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['ISO8601Date'];
  weekDays?: InputMaybe<Array<Scalars['Int']>>;
};


export type ProjectManagementMutationsUpdateProjectmanagementProjectArgs = {
  clientId?: InputMaybe<Scalars['Int']>;
  code?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  dueDate?: InputMaybe<Scalars['ISO8601Date']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
};


export type ProjectManagementMutationsUpdateProjectmanagementProjectRoleArgs = {
  id: Scalars['Int'];
  role: Scalars['String'];
};


export type ProjectManagementMutationsUpdateProjectmanagementProjectTaskArgs = {
  afterPosition?: InputMaybe<Scalars['String']>;
  assigneeEmployeeIds?: InputMaybe<Array<Scalars['Int']>>;
  beforePosition?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['String']>;
  dueOn?: InputMaybe<Scalars['ISO8601Date']>;
  filesToAdd?: InputMaybe<Array<Scalars['File']>>;
  filesToRemove?: InputMaybe<Array<Scalars['Int']>>;
  followUp?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  position?: InputMaybe<Scalars['String']>;
  projectId: Scalars['Int'];
  startsOn?: InputMaybe<Scalars['ISO8601Date']>;
  status?: InputMaybe<TasksValueObjectsTaskStatusEnum>;
  subprojectId?: InputMaybe<Scalars['Int']>;
};


export type ProjectManagementMutationsUpdateProjectmanagementRateArgs = {
  billingRateCents?: InputMaybe<Scalars['Int']>;
  currency?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  profitabilityPercentageCents?: InputMaybe<Scalars['Int']>;
};


export type ProjectManagementMutationsUpdateProjectmanagementSubprojectArgs = {
  code?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  dueDate?: InputMaybe<Scalars['ISO8601Date']>;
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  status?: InputMaybe<ProjectManagementValueObjectsStatusTypesEnum>;
};

export type Public = {
  __typename?: 'public';
  customerSupportDetail?: Maybe<PublicCustomerSupportDetail>;
  /** @deprecated Please favor `customerSupportDetailsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  customerSupportDetails: Array<PublicCustomerSupportDetail>;
  customerSupportDetailsConnection: PublicCustomerSupportDetailConnection;
};


export type PublicCustomerSupportDetailArgs = {
  id: Scalars['Int'];
};


export type PublicCustomerSupportDetailsArgs = {
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type PublicCustomerSupportDetailsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

export type PublicVideos = {
  __typename?: 'publicVideos';
  /** @deprecated Please favor `videosConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  videos: Array<PublicVideosVideo>;
  videosConnection: PublicVideosVideoConnection;
};


export type PublicVideosVideosArgs = {
  category?: InputMaybe<Scalars['String']>;
  locale: Scalars['String'];
};


export type PublicVideosVideosConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locale: Scalars['String'];
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

/** Payload for rate and subscription: processed */
export type Rate_Processed_Type = {
  __typename?: 'rate_processed_type';
  error?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  processing: Scalars['Boolean'];
};

export type Reports = {
  __typename?: 'reports';
  _policies: ReportsContextlessPolicies;
  attribute?: Maybe<ReportsAttribute>;
  /** @deprecated Please favor `attributesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  attributes: Array<ReportsAttribute>;
  attributesConnection: ReportsAttributeConnection;
  /** @deprecated Please favor `categoricalExamplesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  categoricalExamples: Array<ReportsCategoricalExample>;
  categoricalExamplesConnection: ReportsCategoricalExampleConnection;
  /** @deprecated Please favor `dashboardsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  dashboards: Array<ReportsDashboard>;
  dashboardsConnection: ReportsDashboardConnection;
  /** @deprecated Please favor `favouritesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  favourites: Array<ReportsFavourite>;
  favouritesConnection: ReportsFavouriteConnection;
  /** @deprecated Please favor `insightWidgetsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  insightWidgets: Array<ReportsInsightWidget>;
  insightWidgetsConnection: ReportsInsightWidgetConnection;
  /** @deprecated Please favor `insightsFiltersConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  insightsFilters: Array<ReportsInsightsFilter>;
  insightsFiltersConnection: ReportsInsightsFilterConnection;
  /** @deprecated Please favor `refreshesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  refreshes: Array<ReportsRefresh>;
  refreshesConnection: ReportsRefreshConnection;
  report?: Maybe<ReportsReport>;
  /** @deprecated Please favor `reportsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  reports: Array<ReportsReport>;
  reportsConnection: ReportsReportConnection;
  /** @deprecated Please favor `singleValueExamplesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  singleValueExamples: Array<ReportsSingleValueExample>;
  singleValueExamplesConnection: ReportsSingleValueExampleConnection;
  /** @deprecated Please favor `templatesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  templates: Array<ReportsTemplate>;
  templatesConnection: ReportsTemplateConnection;
};


export type ReportsAttributeArgs = {
  id: Scalars['String'];
};


export type ReportsAttributesArgs = {
  editor?: InputMaybe<ReportsValuesFieldsEditorEnum>;
  ids?: Array<Scalars['String']>;
  projections?: Array<Scalars['String']>;
};


export type ReportsAttributesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  editor?: InputMaybe<ReportsValuesFieldsEditorEnum>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: Array<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  projections?: Array<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ReportsCategoricalExamplesArgs = {
  companyId: Scalars['Int'];
  costCenters?: InputMaybe<Array<Scalars['Int']>>;
  cycle: ReportsInsightsCycleEnum;
  employees?: InputMaybe<Array<Scalars['Int']>>;
  endDate: Scalars['ISO8601Date'];
  forFinancialWorkspace?: InputMaybe<Scalars['Boolean']>;
  genders?: InputMaybe<Array<Scalars['String']>>;
  legalEntities?: InputMaybe<Array<Scalars['Int']>>;
  managers?: InputMaybe<Array<Scalars['Int']>>;
  nationalities?: InputMaybe<Array<Scalars['String']>>;
  startDate: Scalars['ISO8601Date'];
  teams?: InputMaybe<Array<Scalars['Int']>>;
  withNoGender?: Scalars['Boolean'];
  withNoManager?: Scalars['Boolean'];
  withNoNationality?: Scalars['Boolean'];
  workplaces?: InputMaybe<Array<Scalars['Int']>>;
};


export type ReportsCategoricalExamplesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  costCenters?: InputMaybe<Array<Scalars['Int']>>;
  cycle: ReportsInsightsCycleEnum;
  employees?: InputMaybe<Array<Scalars['Int']>>;
  endDate: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  forFinancialWorkspace?: InputMaybe<Scalars['Boolean']>;
  genders?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntities?: InputMaybe<Array<Scalars['Int']>>;
  managers?: InputMaybe<Array<Scalars['Int']>>;
  nationalities?: InputMaybe<Array<Scalars['String']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startDate: Scalars['ISO8601Date'];
  teams?: InputMaybe<Array<Scalars['Int']>>;
  withNoGender?: Scalars['Boolean'];
  withNoManager?: Scalars['Boolean'];
  withNoNationality?: Scalars['Boolean'];
  workplaces?: InputMaybe<Array<Scalars['Int']>>;
};


export type ReportsDashboardsArgs = {
  id?: InputMaybe<Scalars['Int']>;
};


export type ReportsDashboardsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ReportsFavouritesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ReportsInsightWidgetsArgs = {
  companyId: Scalars['Int'];
  costCenters?: InputMaybe<Array<Scalars['Int']>>;
  cycle: ReportsInsightsCycleEnum;
  employees?: InputMaybe<Array<Scalars['Int']>>;
  endDate: Scalars['ISO8601Date'];
  forFinancialWorkspace?: InputMaybe<Scalars['Boolean']>;
  genders?: InputMaybe<Array<Scalars['String']>>;
  legalEntities?: InputMaybe<Array<Scalars['Int']>>;
  managers?: InputMaybe<Array<Scalars['Int']>>;
  nationalities?: InputMaybe<Array<Scalars['String']>>;
  startDate: Scalars['ISO8601Date'];
  teams?: InputMaybe<Array<Scalars['Int']>>;
  withNoGender?: Scalars['Boolean'];
  withNoManager?: Scalars['Boolean'];
  withNoNationality?: Scalars['Boolean'];
  workplaces?: InputMaybe<Array<Scalars['Int']>>;
};


export type ReportsInsightWidgetsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  costCenters?: InputMaybe<Array<Scalars['Int']>>;
  cycle: ReportsInsightsCycleEnum;
  employees?: InputMaybe<Array<Scalars['Int']>>;
  endDate: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  forFinancialWorkspace?: InputMaybe<Scalars['Boolean']>;
  genders?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntities?: InputMaybe<Array<Scalars['Int']>>;
  managers?: InputMaybe<Array<Scalars['Int']>>;
  nationalities?: InputMaybe<Array<Scalars['String']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startDate: Scalars['ISO8601Date'];
  teams?: InputMaybe<Array<Scalars['Int']>>;
  withNoGender?: Scalars['Boolean'];
  withNoManager?: Scalars['Boolean'];
  withNoNationality?: Scalars['Boolean'];
  workplaces?: InputMaybe<Array<Scalars['Int']>>;
};


export type ReportsInsightsFiltersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ReportsRefreshesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ReportsReportArgs = {
  id: Scalars['Int'];
};


export type ReportsReportsArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  dashboardId?: InputMaybe<Scalars['Int']>;
  identifier?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type ReportsReportsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  dashboardId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  identifier?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ReportsSingleValueExamplesArgs = {
  companyId: Scalars['Int'];
  costCenters?: InputMaybe<Array<Scalars['Int']>>;
  cycle: ReportsInsightsCycleEnum;
  employees?: InputMaybe<Array<Scalars['Int']>>;
  endDate: Scalars['ISO8601Date'];
  forFinancialWorkspace?: InputMaybe<Scalars['Boolean']>;
  genders?: InputMaybe<Array<Scalars['String']>>;
  legalEntities?: InputMaybe<Array<Scalars['Int']>>;
  managers?: InputMaybe<Array<Scalars['Int']>>;
  nationalities?: InputMaybe<Array<Scalars['String']>>;
  startDate: Scalars['ISO8601Date'];
  teams?: InputMaybe<Array<Scalars['Int']>>;
  withNoGender?: Scalars['Boolean'];
  withNoManager?: Scalars['Boolean'];
  withNoNationality?: Scalars['Boolean'];
  workplaces?: InputMaybe<Array<Scalars['Int']>>;
};


export type ReportsSingleValueExamplesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  costCenters?: InputMaybe<Array<Scalars['Int']>>;
  cycle: ReportsInsightsCycleEnum;
  employees?: InputMaybe<Array<Scalars['Int']>>;
  endDate: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  forFinancialWorkspace?: InputMaybe<Scalars['Boolean']>;
  genders?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntities?: InputMaybe<Array<Scalars['Int']>>;
  managers?: InputMaybe<Array<Scalars['Int']>>;
  nationalities?: InputMaybe<Array<Scalars['String']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startDate: Scalars['ISO8601Date'];
  teams?: InputMaybe<Array<Scalars['Int']>>;
  withNoGender?: Scalars['Boolean'];
  withNoManager?: Scalars['Boolean'];
  withNoNationality?: Scalars['Boolean'];
  workplaces?: InputMaybe<Array<Scalars['Int']>>;
};


export type ReportsTemplatesArgs = {
  id?: InputMaybe<Scalars['Int']>;
};


export type ReportsTemplatesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

export type ReportsMutations = {
  __typename?: 'reportsMutations';
  createFromQuestionReportsReport: CreateFromQuestionReportsReportPayload;
  createReportsContent: CreateReportsContentPayload;
  createReportsDashboard: CreateReportsDashboardPayload;
  createReportsExportInsight: CreateReportsExportInsightPayload;
  createReportsFavourite: CreateReportsFavouritePayload;
  createReportsRefresh: CreateReportsRefreshPayload;
  createReportsReport: CreateReportsReportPayload;
  createReportsValidateProjection: CreateReportsValidateProjectionPayload;
  deleteReportsDashboard: DeleteReportsDashboardPayload;
  deleteReportsFavourite: DeleteReportsFavouritePayload;
  deleteReportsReport: DeleteReportsReportPayload;
  shareReportsReport: ShareReportsReportPayload;
  updateReportsDashboard: UpdateReportsDashboardPayload;
  updateReportsReport: UpdateReportsReportPayload;
};


export type ReportsMutationsCreateFromQuestionReportsReportArgs = {
  companyId: Scalars['Int'];
  dashboardId: Scalars['Int'];
  question: Scalars['String'];
};


export type ReportsMutationsCreateReportsContentArgs = {
  fallback?: InputMaybe<Scalars['Boolean']>;
  jsonQuery?: InputMaybe<Scalars['String']>;
  reportId?: InputMaybe<Scalars['Int']>;
  sqlConfiguration?: InputMaybe<Scalars['String']>;
  sqlQuery?: InputMaybe<Scalars['String']>;
  templateId?: InputMaybe<Scalars['Int']>;
};


export type ReportsMutationsCreateReportsDashboardArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  icon?: InputMaybe<Scalars['String']>;
  identifier?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  variables?: InputMaybe<Array<ReportsVariableInput>>;
};


export type ReportsMutationsCreateReportsExportInsightArgs = {
  name: Scalars['String'];
  reports: Array<ReportsReportInput>;
  type: ReportsDtosExportInsightsTypeEnum;
};


export type ReportsMutationsCreateReportsFavouriteArgs = {
  dashboardId: Scalars['Int'];
};


export type ReportsMutationsCreateReportsRefreshArgs = {
  force: Scalars['Boolean'];
};


export type ReportsMutationsCreateReportsReportArgs = {
  authorId?: InputMaybe<Scalars['Int']>;
  chartType: ReportsValuesReportsChartTypeEnum;
  createdAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  dashboardId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  identifier?: InputMaybe<Scalars['String']>;
  jsonQuery?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  retrievedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  sqlConfiguration?: InputMaybe<Scalars['String']>;
  sqlQuery?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};


export type ReportsMutationsCreateReportsValidateProjectionArgs = {
  filters: Array<Scalars['String']>;
  projections: Array<Scalars['String']>;
};


export type ReportsMutationsDeleteReportsDashboardArgs = {
  id: Scalars['Int'];
};


export type ReportsMutationsDeleteReportsFavouriteArgs = {
  id: Scalars['Int'];
};


export type ReportsMutationsDeleteReportsReportArgs = {
  id: Scalars['Int'];
};


export type ReportsMutationsShareReportsReportArgs = {
  mode: ReportsEntitiesSharesModeEnum;
  reportId: Scalars['Int'];
  shareeId: Scalars['Int'];
  visibility: ReportsEntitiesSharesVisibilityEnum;
};


export type ReportsMutationsUpdateReportsDashboardArgs = {
  description?: InputMaybe<Scalars['String']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  icon?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  identifier?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  variables?: InputMaybe<Array<ReportsVariableInput>>;
};


export type ReportsMutationsUpdateReportsReportArgs = {
  authorId: Scalars['Int'];
  chartType: ReportsValuesReportsChartTypeEnum;
  createdAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  dashboardId: Scalars['Int'];
  id: Scalars['Int'];
  identifier?: InputMaybe<Scalars['String']>;
  jsonQuery?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  retrievedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  sqlConfiguration?: InputMaybe<Scalars['String']>;
  sqlQuery?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

/** Root mutation */
export type Root_Mutation = {
  __typename?: 'root_mutation';
  analyticsMutations: AnalyticsMutations;
  apiCoreMutations: ApiCoreMutations;
  approvalsMutations: ApprovalsMutations;
  approvalsV2Mutations: ApprovalsV2Mutations;
  atsMutations: AtsMutations;
  attendanceMutations: AttendanceMutations;
  authenticationMutations: AuthenticationMutations;
  bankingMutations: BankingMutations;
  benefitsMutations: BenefitsMutations;
  billingMutations: BillingMutations;
  bookkeepersManagementMutations: BookkeepersManagementMutations;
  cognitoMutations: CognitoMutations;
  companiesMutations: CompaniesMutations;
  companyPageMutations: CompanyPageMutations;
  compensationsMutations: CompensationsMutations;
  competenciesMutations: CompetenciesMutations;
  complaintsMutations: ComplaintsMutations;
  contractsMutations: ContractsMutations;
  costCentersMutations: CostCentersMutations;
  cronofySchedulingMutations: CronofySchedulingMutations;
  customFieldsMutations: CustomFieldsMutations;
  customResourcesMutations: CustomResourcesMutations;
  dashboardMutations: DashboardMutations;
  directUploadsMutations: DirectUploadsMutations;
  documentsMutations: DocumentsMutations;
  employeesMutations: EmployeesMutations;
  engagementMutations: EngagementMutations;
  esignatureMutations: EsignatureMutations;
  expensesMutations: ExpensesMutations;
  faceRecognitionMutations: FaceRecognitionMutations;
  featuresMutations: FeaturesMutations;
  feedbacksMutations: FeedbacksMutations;
  financeMutations: FinanceMutations;
  financialWorkspaceMutations: FinancialWorkspaceMutations;
  formsMutations: FormsMutations;
  goalsMutations: GoalsMutations;
  handbookPagesMutations: HandbookPagesMutations;
  hiringVersionsMutations: HiringVersionsMutations;
  holidaysMutations: HolidaysMutations;
  importersMutations: ImportersMutations;
  integrationsDatevLaudsMutations: IntegrationsDatevLaudsMutations;
  integrationsIndeedMutations: IntegrationsIndeedMutations;
  integrationsInfojobsMutations: IntegrationsInfojobsMutations;
  integrationsJoinMutations: IntegrationsJoinMutations;
  integrationsMutations: IntegrationsMutations;
  integrationsPrimoboxMutations: IntegrationsPrimoboxMutations;
  itManagementMutations: ItManagementMutations;
  jobCatalogMutations: JobCatalogMutations;
  kudosMutations: KudosMutations;
  layoutMutations: LayoutMutations;
  locationsMutations: LocationsMutations;
  marketingMutations: MarketingMutations;
  marketplaceMutations: MarketplaceMutations;
  meetingsMutations: MeetingsMutations;
  modulesMutations: ModulesMutations;
  notificationsMutations: NotificationsMutations;
  npsMutations: NpsMutations;
  oneOnOnesMutations: OneOnOnesMutations;
  openAiMutations: OpenAiMutations;
  pagesMutations: PagesMutations;
  payrollEmployeesMutations: PayrollEmployeesMutations;
  payrollExporterMutations: PayrollExporterMutations;
  payrollIntegrationsA3innuvaMutations: PayrollIntegrationsA3innuvaMutations;
  payrollIntegrationsBaseMutations: PayrollIntegrationsBaseMutations;
  payrollMutations: PayrollMutations;
  peopleChartMutations: PeopleChartMutations;
  performanceCyclesMutations: PerformanceCyclesMutations;
  performanceMutations: PerformanceMutations;
  permissionsMutations: PermissionsMutations;
  positionsMutations: PositionsMutations;
  postsMutations: PostsMutations;
  processesMutations: ProcessesMutations;
  procurementMutations: ProcurementMutations;
  productUpdatesMutations: ProductUpdatesMutations;
  projectManagementImporterMutations: ProjectManagementImporterMutations;
  projectManagementMutations: ProjectManagementMutations;
  reportsMutations: ReportsMutations;
  salaryAdvanceMutations: SalaryAdvanceMutations;
  securitySettingsMutations: SecuritySettingsMutations;
  shiftManagementMutations: ShiftManagementMutations;
  softwareManagementMutations: SoftwareManagementMutations;
  spaceControlMutations: SpaceControlMutations;
  surveysMutations: SurveysMutations;
  tasksMutations: TasksMutations;
  teamsMutations: TeamsMutations;
  timeBalanceMutations: TimeBalanceMutations;
  timeInsightsMutations: TimeInsightsMutations;
  timePlanningMutations: TimePlanningMutations;
  timeSettingsMutations: TimeSettingsMutations;
  timeoffMutations: TimeoffMutations;
  trainingsMutations: TrainingsMutations;
  trialMutations: TrialMutations;
  universalExportsMutations: UniversalExportsMutations;
  universalImporterMutations: UniversalImporterMutations;
  upsellMutations: UpsellMutations;
  usersMutations: UsersMutations;
  workScheduleMutations: WorkScheduleMutations;
  workflowsMutations: WorkflowsMutations;
  workingConditionsMutations: WorkingConditionsMutations;
};

/** Root query */
export type Root_Query = {
  __typename?: 'root_query';
  accountSettings: AccountSettings;
  activityLog: ActivityLog;
  analytics: Analytics;
  apiCore: ApiCore;
  apiPublic: ApiPublic;
  approvals: Approvals;
  approvalsV2: ApprovalsV2;
  ats: Ats;
  attendance: Attendance;
  auditLog: AuditLog;
  authentication: Authentication;
  automations: Automations;
  banking: Banking;
  benefits: Benefits;
  billing: Billing;
  bookkeepersManagement: BookkeepersManagement;
  calendar: Calendar;
  coffreFortNumerique: CoffreFortNumerique;
  cognito: Cognito;
  companies: Companies;
  companyPage: CompanyPage;
  compensations: Compensations;
  competencies: Competencies;
  complaints: Complaints;
  contracts: Contracts;
  contractsImporter: ContractsImporter;
  costCenters: CostCenters;
  cronofyScheduling: CronofyScheduling;
  customFields: CustomFields;
  customResources: CustomResources;
  customerPortal: CustomerPortal;
  dashboard: Dashboard;
  dataDispatcher: DataDispatcher;
  documents: Documents;
  employeeOnboarding: EmployeeOnboarding;
  employeeUpdates: EmployeeUpdates;
  employees: Employees;
  engagement: Engagement;
  engagementInsights: EngagementInsights;
  enps: Enps;
  esignature: Esignature;
  expenses: Expenses;
  faceRecognition: FaceRecognition;
  features: Features;
  feedbacks: Feedbacks;
  finance: Finance;
  financialWorkspace: FinancialWorkspace;
  forms: Forms;
  goals: Goals;
  handbookPages: HandbookPages;
  hiringVersions: HiringVersions;
  holidays: Holidays;
  importers: Importers;
  inAppComms: InAppComms;
  integrations: Integrations;
  integrationsBase: IntegrationsBase;
  integrationsDatevLauds: IntegrationsDatevLauds;
  integrationsIndeed: IntegrationsIndeed;
  integrationsInfojobs: IntegrationsInfojobs;
  integrationsJoin: IntegrationsJoin;
  integrationsPrimobox: IntegrationsPrimobox;
  intercom: Intercom;
  iris: Iris;
  itManagement: ItManagement;
  jobCatalog: JobCatalog;
  kudos: Kudos;
  layout: Layout;
  locations: Locations;
  marketing: Marketing;
  marketplace: Marketplace;
  meetings: Meetings;
  modules: Modules;
  notifications: Notifications;
  nps: Nps;
  oauthApplicationPolicy: OauthApplicationPolicy;
  onboarding: Onboarding;
  onboardingImporter: OnboardingImporter;
  oneAgentSteering: OneAgentSteering;
  oneOnOnes: OneOnOnes;
  openAi: OpenAi;
  pages: Pages;
  payroll: Payroll;
  payrollEmployees: PayrollEmployees;
  payrollExporter: PayrollExporter;
  payrollIntegrations: PayrollIntegrations;
  payrollIntegrationsA3innuva: PayrollIntegrationsA3innuva;
  payrollIntegrationsBase: PayrollIntegrationsBase;
  peopleChart: PeopleChart;
  performance: Performance;
  performanceCycles: PerformanceCycles;
  performanceGoals: PerformanceGoals;
  permissions: Permissions;
  personalHistory: PersonalHistory;
  positions: Positions;
  posts: Posts;
  processes: Processes;
  procurement: Procurement;
  productUpdates: ProductUpdates;
  projectManagement: ProjectManagement;
  public: Public;
  publicVideos: PublicVideos;
  reports: Reports;
  salaryAdvance: SalaryAdvance;
  securitySettings: SecuritySettings;
  shiftManagement: ShiftManagement;
  signals: Signals;
  softwareManagement: SoftwareManagement;
  spaceControl: SpaceControl;
  surveys: Surveys;
  tasks: Tasks;
  teams: Teams;
  timeBalance: TimeBalance;
  timeInsights: TimeInsights;
  timePlanning: TimePlanning;
  timeSettings: TimeSettings;
  timeoff: Timeoff;
  trainings: Trainings;
  trial: Trial;
  universalExports: UniversalExports;
  universalImporter: UniversalImporter;
  upsell: Upsell;
  users: Users;
  workSchedule: WorkSchedule;
  workflows: Workflows;
  workingConditions: WorkingConditions;
};

/** Subscription for automation generate_schedule */
export type Root_Subscription = {
  __typename?: 'root_subscription';
  atsJobPostingGenerateDraft: Ats_Job_Posting_Generate_Draft_SubscriptionPayload;
  attendanceAggregatedBalanceRefresh: Attendance_Aggregated_Balance_Refresh_SubscriptionPayload;
  attendanceBalanceRefresh: Attendance_Balance_Refresh_SubscriptionPayload;
  attendanceWorkedTimeRefresh: Attendance_Worked_Time_Refresh_SubscriptionPayload;
  billingCpChatChat: Billing_Cp_Chat_Chat_SubscriptionPayload;
  billingCpExportInvoiceInitiateExport: Billing_Cp_Export_Invoice_Initiate_Export_SubscriptionPayload;
  billingDuePaymentsUpdatePaymentCountUpdated: Billing_Due_Payments_Update_Payment_Count_Updated_SubscriptionPayload;
  compensationsPayrollRunDataUpdated: Compensations_Payroll_Run_Data_Updated_SubscriptionPayload;
  complaintsCategoryUpdate: Complaints_Category_Update_SubscriptionPayload;
  documentsUploadProcessProcessedDocumentsCount: Documents_Upload_Process_Processed_Documents_Count_SubscriptionPayload;
  integrationsSyncRunStatusChange: Integrations_Sync_Run_Status_Change_SubscriptionPayload;
  integrationsSyncableStateUpdate: Integrations_Syncable_State_Update_SubscriptionPayload;
  integrationsdatevlaudsRequestUpdate: IntegrationsDatevLauds_Request_Update_SubscriptionPayload;
  notificationsInboxNotificationCreate: Notifications_Inbox_Notification_Create_SubscriptionPayload;
  performanceAgreementRefresh: Performance_Agreement_Refresh_SubscriptionPayload;
  projectmanagementProcessingRateRead: ProjectManagement_Processing_Rate_Read_SubscriptionPayload;
  projectmanagementRateProcessed: ProjectManagement_Rate_Processed_SubscriptionPayload;
  shiftmanagementAutomationGenerateSchedule: ShiftManagement_Automation_Generate_Schedule_SubscriptionPayload;
  spacecontrolWorkAreaMapSpaceLocationUpdate: SpaceControl_Work_Area_Map_Space_Location_Update_SubscriptionPayload;
  spacecontrolWorkAreaMapUpdate: SpaceControl_Work_Area_Map_Update_SubscriptionPayload;
  spacecontrolWorkSpaceUpdate: SpaceControl_Work_Space_Update_SubscriptionPayload;
  timeinsightsInconsistencyCreate: TimeInsights_Inconsistency_Create_SubscriptionPayload;
};


/** Subscription for automation generate_schedule */
export type Root_SubscriptionComplaintsCategoryUpdateArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


/** Subscription for automation generate_schedule */
export type Root_SubscriptionIntegrationsSyncableStateUpdateArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


/** Subscription for automation generate_schedule */
export type Root_SubscriptionIntegrationsdatevlaudsRequestUpdateArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


/** Subscription for automation generate_schedule */
export type Root_SubscriptionSpacecontrolWorkAreaMapSpaceLocationUpdateArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


/** Subscription for automation generate_schedule */
export type Root_SubscriptionSpacecontrolWorkAreaMapUpdateArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


/** Subscription for automation generate_schedule */
export type Root_SubscriptionSpacecontrolWorkSpaceUpdateArgs = {
  id?: InputMaybe<Scalars['ID']>;
};

export type SalaryAdvance = {
  __typename?: 'salaryAdvance';
  _policies: SalaryAdvanceContextlessPolicies;
  /** @deprecated Please favor `balancesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  balances: Array<SalaryAdvanceBalance>;
  balancesConnection: SalaryAdvanceBalanceConnection;
  /** @deprecated Please favor `companySettingsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  companySettings: Array<SalaryAdvanceCompanySetting>;
  companySettingsConnection: SalaryAdvanceCompanySettingConnection;
  compensation?: Maybe<SalaryAdvanceCompensation>;
  /** @deprecated Please favor `compensationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  compensations: Array<SalaryAdvanceCompensation>;
  compensationsConnection: SalaryAdvanceCompensationConnection;
  employeeProfile?: Maybe<SalaryAdvanceEmployeeProfile>;
  /** @deprecated Please favor `employeeProfilesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  employeeProfiles: Array<SalaryAdvanceEmployeeProfile>;
  employeeProfilesConnection: SalaryAdvanceEmployeeProfileConnection;
  request?: Maybe<SalaryAdvanceRequest>;
  /** @deprecated Please favor `requestsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  requests: Array<SalaryAdvanceRequest>;
  requestsConnection: SalaryAdvanceRequestConnection;
};


export type SalaryAdvanceBalancesArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type SalaryAdvanceBalancesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type SalaryAdvanceCompanySettingsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SalaryAdvanceCompanySettingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type SalaryAdvanceCompensationArgs = {
  id: Scalars['Int'];
};


export type SalaryAdvanceCompensationsArgs = {
  createdAfter?: InputMaybe<Scalars['ISO8601DateTime']>;
  createdBefore?: InputMaybe<Scalars['ISO8601DateTime']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


export type SalaryAdvanceCompensationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  createdAfter?: InputMaybe<Scalars['ISO8601DateTime']>;
  createdBefore?: InputMaybe<Scalars['ISO8601DateTime']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  filter?: InputMaybe<SalaryAdvanceCompensationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type SalaryAdvanceEmployeeProfileArgs = {
  id: Scalars['Int'];
};


export type SalaryAdvanceEmployeeProfilesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


export type SalaryAdvanceEmployeeProfilesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SalaryAdvanceEmployeeProfileFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type SalaryAdvanceRequestArgs = {
  id: Scalars['Int'];
};


export type SalaryAdvanceRequestsArgs = {
  compensationIds?: InputMaybe<Array<Scalars['Int']>>;
  createdAfter?: InputMaybe<Scalars['ISO8601DateTime']>;
  createdBefore?: InputMaybe<Scalars['ISO8601DateTime']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  status?: InputMaybe<SalaryAdvanceValueObjectsRequestStatusEnum>;
};


export type SalaryAdvanceRequestsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  compensationIds?: InputMaybe<Array<Scalars['Int']>>;
  createdAfter?: InputMaybe<Scalars['ISO8601DateTime']>;
  createdBefore?: InputMaybe<Scalars['ISO8601DateTime']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  filter?: InputMaybe<SalaryAdvanceRequestFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  status?: InputMaybe<SalaryAdvanceValueObjectsRequestStatusEnum>;
};

export type SalaryAdvanceMutations = {
  __typename?: 'salaryAdvanceMutations';
  createSalaryadvanceRequest: CreateSalaryadvanceRequestPayload;
  saveSalaryadvanceCompanySetting: SaveSalaryadvanceCompanySettingPayload;
};


export type SalaryAdvanceMutationsCreateSalaryadvanceRequestArgs = {
  amountCents: Scalars['Int'];
};


export type SalaryAdvanceMutationsSaveSalaryadvanceCompanySettingArgs = {
  advanceCapMonthlyWagePercent?: InputMaybe<Scalars['Int']>;
  requestDeadlineDay: Scalars['Int'];
  serviceEnabled: Scalars['Boolean'];
};

export type SecuritySettings = {
  __typename?: 'securitySettings';
  _policies: SecuritySettingsContextlessPolicies;
  companyConfig?: Maybe<SecuritySettingsCompanyConfig>;
  /** @deprecated Please favor `companyConfigsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  companyConfigs: Array<SecuritySettingsCompanyConfig>;
  companyConfigsConnection: SecuritySettingsCompanyConfigConnection;
};


export type SecuritySettingsCompanyConfigArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type SecuritySettingsCompanyConfigsArgs = {
  companyId: Scalars['Int'];
  ids?: InputMaybe<Scalars['Int']>;
};


export type SecuritySettingsCompanyConfigsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

export type SecuritySettingsMutations = {
  __typename?: 'securitySettingsMutations';
  updateSecuritysettingsCompanyConfig: UpdateSecuritysettingsCompanyConfigPayload;
};


export type SecuritySettingsMutationsUpdateSecuritysettingsCompanyConfigArgs = {
  companyId: Scalars['Int'];
  mfaStatus?: InputMaybe<SecuritySettingsMfaStatusEnum>;
  passwordRotationEnabled?: InputMaybe<Scalars['Boolean']>;
  passwordRotationExpireInterval?: InputMaybe<Scalars['Int']>;
  ssoEnforcement?: InputMaybe<SecuritySettingsSsoEnforcementEnum>;
  staffBecomeEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type ShiftManagement = {
  __typename?: 'shiftManagement';
  _policies: ShiftManagementContextlessPolicies;
  autoSchedulerExecution?: Maybe<ShiftManagementAutoSchedulerExecution>;
  /** @deprecated Please favor `autoSchedulerExecutionsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  autoSchedulerExecutions: Array<ShiftManagementAutoSchedulerExecution>;
  autoSchedulerExecutionsConnection: ShiftManagementAutoSchedulerExecutionConnection;
  coverage?: Maybe<ShiftManagementCoverage>;
  /** @deprecated Please favor `coveragesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  coverages: Array<ShiftManagementCoverage>;
  coveragesByDay?: Maybe<ShiftManagementCoveragesByDay>;
  /** @deprecated Please favor `coveragesByDaysConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  coveragesByDays: Array<ShiftManagementCoveragesByDay>;
  coveragesByDaysConnection: ShiftManagementCoveragesByDayConnection;
  coveragesConnection: ShiftManagementCoverageConnection;
  defaultShift?: Maybe<ShiftManagementDefaultShift>;
  /** @deprecated Please favor `defaultShiftsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  defaultShifts: Array<ShiftManagementDefaultShift>;
  defaultShiftsConnection: ShiftManagementDefaultShiftConnection;
  employeesPermission?: Maybe<ShiftManagementEmployeesPermission>;
  /** @deprecated Please favor `employeesPermissionsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  employeesPermissions: Array<ShiftManagementEmployeesPermission>;
  employeesPermissionsConnection: ShiftManagementEmployeesPermissionConnection;
  leave?: Maybe<ShiftManagementLeave>;
  /** @deprecated Please favor `leavesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  leaves: Array<ShiftManagementLeave>;
  leavesConnection: ShiftManagementLeaveConnection;
  restDay?: Maybe<ShiftManagementRestDay>;
  /** @deprecated Please favor `restDaysConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  restDays: Array<ShiftManagementRestDay>;
  restDaysConnection: ShiftManagementRestDayConnection;
  shift?: Maybe<ShiftManagementShift>;
  shiftConfiguration?: Maybe<ShiftManagementShiftConfiguration>;
  /** @deprecated Please favor `shiftConfigurationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  shiftConfigurations: Array<ShiftManagementShiftConfiguration>;
  shiftConfigurationsConnection: ShiftManagementShiftConfigurationConnection;
  /** @deprecated Please favor `shiftsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  shifts: Array<ShiftManagementShift>;
  shiftsConnection: ShiftManagementShiftConnection;
  /** @deprecated Please favor `statsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  stats: Array<ShiftManagementStat>;
  statsConnection: ShiftManagementStatConnection;
  swapShift?: Maybe<ShiftManagementSwapShift>;
  /** @deprecated Please favor `swapShiftsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  swapShifts: Array<ShiftManagementSwapShift>;
  swapShiftsConnection: ShiftManagementSwapShiftConnection;
  template?: Maybe<ShiftManagementTemplate>;
  /** @deprecated Please favor `templateWeeksConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  templateWeeks: Array<ShiftManagementTemplateWeek>;
  templateWeeksConnection: ShiftManagementTemplateWeekConnection;
  /** @deprecated Please favor `templatesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  templates: Array<ShiftManagementTemplate>;
  templatesConnection: ShiftManagementTemplateConnection;
  /** @deprecated Please favor `unassignedShiftsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  unassignedShifts: Array<ShiftManagementUnassignedShift>;
  unassignedShiftsConnection: ShiftManagementUnassignedShiftConnection;
  /** @deprecated Please favor `workAreasConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  workAreas: Array<ShiftManagementWorkArea>;
  workAreasConnection: ShiftManagementWorkAreaConnection;
};


export type ShiftManagementAutoSchedulerExecutionArgs = {
  id: Scalars['Int'];
  locationId: Scalars['Int'];
};


export type ShiftManagementAutoSchedulerExecutionsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  locationId: Scalars['Int'];
};


export type ShiftManagementAutoSchedulerExecutionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<ShiftManagementAutoSchedulerExecutionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  locationId: Scalars['Int'];
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ShiftManagementCoverageArgs = {
  endAt: Scalars['String'];
  id: Scalars['Int'];
  startAt: Scalars['String'];
};


export type ShiftManagementCoveragesArgs = {
  customFilters?: InputMaybe<Array<ShiftManagementCustomFilterInput>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endAt: Scalars['String'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  logicOperator?: InputMaybe<Scalars['String']>;
  onlyPublished?: InputMaybe<Scalars['Boolean']>;
  shiftIds?: InputMaybe<Array<Scalars['Int']>>;
  startAt: Scalars['String'];
  terminated?: InputMaybe<Scalars['Boolean']>;
  usePercentages?: InputMaybe<Scalars['Boolean']>;
};


export type ShiftManagementCoveragesByDayArgs = {
  companyId: Scalars['Int'];
  endAt: Scalars['String'];
  id: Scalars['Int'];
  startAt: Scalars['String'];
};


export type ShiftManagementCoveragesByDaysArgs = {
  companyId: Scalars['Int'];
  customFilters?: InputMaybe<Array<ShiftManagementCustomFilterInput>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endAt: Scalars['String'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  logicOperator?: InputMaybe<Scalars['String']>;
  shiftIds?: InputMaybe<Array<Scalars['Int']>>;
  startAt: Scalars['String'];
  terminated?: InputMaybe<Scalars['Boolean']>;
};


export type ShiftManagementCoveragesByDaysConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  customFilters?: InputMaybe<Array<ShiftManagementCustomFilterInput>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endAt: Scalars['String'];
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  logicOperator?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  shiftIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
  startAt: Scalars['String'];
  terminated?: InputMaybe<Scalars['Boolean']>;
};


export type ShiftManagementCoveragesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  customFilters?: InputMaybe<Array<ShiftManagementCustomFilterInput>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endAt: Scalars['String'];
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  logicOperator?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyPublished?: InputMaybe<Scalars['Boolean']>;
  shiftIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
  startAt: Scalars['String'];
  terminated?: InputMaybe<Scalars['Boolean']>;
  usePercentages?: InputMaybe<Scalars['Boolean']>;
};


export type ShiftManagementDefaultShiftArgs = {
  id: Scalars['Int'];
};


export type ShiftManagementDefaultShiftsArgs = {
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  unassignedShifts?: InputMaybe<Scalars['Boolean']>;
};


export type ShiftManagementDefaultShiftsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  unassignedShifts?: InputMaybe<Scalars['Boolean']>;
};


export type ShiftManagementEmployeesPermissionArgs = {
  endAt?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  startAt?: InputMaybe<Scalars['String']>;
};


export type ShiftManagementEmployeesPermissionsArgs = {
  currentEmployeeFirst?: InputMaybe<Scalars['Boolean']>;
  customFilters?: InputMaybe<Array<ShiftManagementCustomFilterInput>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endAt?: InputMaybe<Scalars['String']>;
  forTimeInsights?: Scalars['Boolean'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  logicOperator?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<EmployeeSortOptionsEnum>;
  orderDir?: InputMaybe<EmployeeSortDirectionEnum>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  shiftIds?: InputMaybe<Array<Scalars['Int']>>;
  startAt?: InputMaybe<Scalars['String']>;
  teamId?: InputMaybe<Scalars['Int']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withoutShiftIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type ShiftManagementEmployeesPermissionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  currentEmployeeFirst?: InputMaybe<Scalars['Boolean']>;
  customFilters?: InputMaybe<Array<ShiftManagementCustomFilterInput>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endAt?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forTimeInsights?: Scalars['Boolean'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  logicOperator?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<EmployeeSortOptionsEnum>;
  orderDir?: InputMaybe<EmployeeSortDirectionEnum>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  shiftIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
  startAt?: InputMaybe<Scalars['String']>;
  teamId?: InputMaybe<Scalars['Int']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  withoutShiftIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type ShiftManagementLeaveArgs = {
  id: Scalars['Int'];
};


export type ShiftManagementLeavesArgs = {
  approved?: InputMaybe<Scalars['Boolean']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endAt?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeAllPendingApprovals?: InputMaybe<Scalars['Boolean']>;
  includeAllRelations?: InputMaybe<Scalars['Boolean']>;
  includeDuration?: Scalars['Boolean'];
  includeLeaveType?: Scalars['Boolean'];
  includePending?: InputMaybe<Scalars['Boolean']>;
  leaveType?: InputMaybe<Array<Scalars['String']>>;
  leaveTypeId?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  startAt?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['ISO8601Date']>;
  typeIsWorkable?: InputMaybe<Scalars['Boolean']>;
};


export type ShiftManagementLeavesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  approved?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endAt?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeAllPendingApprovals?: InputMaybe<Scalars['Boolean']>;
  includeAllRelations?: InputMaybe<Scalars['Boolean']>;
  includeDuration?: Scalars['Boolean'];
  includeLeaveType?: Scalars['Boolean'];
  includePending?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  leaveType?: InputMaybe<Array<Scalars['String']>>;
  leaveTypeId?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Sort>;
  startAt?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['ISO8601Date']>;
  typeIsWorkable?: InputMaybe<Scalars['Boolean']>;
};


export type ShiftManagementRestDayArgs = {
  id: Scalars['Int'];
};


export type ShiftManagementRestDaysArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endAt?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  onlyPublished?: InputMaybe<Scalars['Boolean']>;
  startAt?: InputMaybe<Scalars['String']>;
};


export type ShiftManagementRestDaysConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endAt?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyPublished?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Sort>;
  startAt?: InputMaybe<Scalars['String']>;
};


export type ShiftManagementShiftArgs = {
  id: Scalars['Int'];
};


export type ShiftManagementShiftConfigurationArgs = {
  id: Scalars['Int'];
};


export type ShiftManagementShiftConfigurationsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  templateWeeksIds?: InputMaybe<Array<Scalars['Int']>>;
  weekday?: InputMaybe<Scalars['Int']>;
};


export type ShiftManagementShiftConfigurationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  templateWeeksIds?: InputMaybe<Array<Scalars['Int']>>;
  weekday?: InputMaybe<Scalars['Int']>;
};


export type ShiftManagementShiftsArgs = {
  effectiveLocationIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endAt?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  locationsWorkAreaIds?: InputMaybe<Array<Scalars['Int']>>;
  onlyPublished?: InputMaybe<Scalars['Boolean']>;
  onlyStates?: InputMaybe<Array<ShiftManagementEnumsShiftStateEnum>>;
  splitOvernightShifts?: InputMaybe<Scalars['Boolean']>;
  startAt?: InputMaybe<Scalars['String']>;
  withoutIds?: InputMaybe<Array<Scalars['Int']>>;
  withoutWorkArea?: InputMaybe<Scalars['Boolean']>;
};


export type ShiftManagementShiftsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  effectiveLocationIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endAt?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<ShiftManagementShiftFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  locationsWorkAreaIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyPublished?: InputMaybe<Scalars['Boolean']>;
  onlyStates?: InputMaybe<Array<ShiftManagementEnumsShiftStateEnum>>;
  sortOrder?: InputMaybe<Sort>;
  splitOvernightShifts?: InputMaybe<Scalars['Boolean']>;
  startAt?: InputMaybe<Scalars['String']>;
  withoutIds?: InputMaybe<Array<Scalars['Int']>>;
  withoutWorkArea?: InputMaybe<Scalars['Boolean']>;
};


export type ShiftManagementStatsArgs = {
  companyId: Scalars['Int'];
  customFilters?: InputMaybe<Array<ShiftManagementCustomFilterInput>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endDate: Scalars['String'];
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  logicOperator?: InputMaybe<Scalars['String']>;
  newVersion?: Scalars['Boolean'];
  startDate: Scalars['String'];
  terminated?: InputMaybe<Scalars['Boolean']>;
  withoutShiftIds?: InputMaybe<Array<Scalars['Int']>>;
  withoutShiftsIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type ShiftManagementStatsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  customFilters?: InputMaybe<Array<ShiftManagementCustomFilterInput>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endDate: Scalars['String'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  logicOperator?: InputMaybe<Scalars['String']>;
  newVersion?: Scalars['Boolean'];
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startDate: Scalars['String'];
  terminated?: InputMaybe<Scalars['Boolean']>;
  withoutShiftIds?: InputMaybe<Array<Scalars['Int']>>;
  withoutShiftsIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type ShiftManagementSwapShiftArgs = {
  id: Scalars['Int'];
  shiftIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type ShiftManagementSwapShiftsArgs = {
  currentShiftIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endAt?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  requestedShiftIds?: InputMaybe<Array<Scalars['Int']>>;
  shiftIds?: InputMaybe<Array<Scalars['Int']>>;
  startAt?: InputMaybe<Scalars['ISO8601Date']>;
  status?: InputMaybe<Scalars['String']>;
};


export type ShiftManagementSwapShiftsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  currentShiftIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endAt?: InputMaybe<Scalars['ISO8601Date']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  requestedShiftIds?: InputMaybe<Array<Scalars['Int']>>;
  shiftIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
  startAt?: InputMaybe<Scalars['ISO8601Date']>;
  status?: InputMaybe<Scalars['String']>;
};


export type ShiftManagementTemplateArgs = {
  id: Scalars['Int'];
};


export type ShiftManagementTemplateWeeksArgs = {
  templateId?: InputMaybe<Scalars['Int']>;
};


export type ShiftManagementTemplateWeeksConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  templateId?: InputMaybe<Scalars['Int']>;
};


export type ShiftManagementTemplatesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  searchByName?: InputMaybe<Scalars['String']>;
};


export type ShiftManagementTemplatesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  searchByName?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type ShiftManagementUnassignedShiftsArgs = {
  endAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  locationId?: InputMaybe<Scalars['Int']>;
  startAt?: InputMaybe<Scalars['ISO8601DateTime']>;
};


export type ShiftManagementUnassignedShiftsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locationId?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startAt?: InputMaybe<Scalars['ISO8601DateTime']>;
};


export type ShiftManagementWorkAreasArgs = {
  customFilters?: InputMaybe<Array<ShiftManagementCustomFilterInput>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endAt: Scalars['String'];
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  logicOperator?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  shiftIds?: InputMaybe<Array<Scalars['Int']>>;
  startAt: Scalars['String'];
  teamId?: InputMaybe<Scalars['Int']>;
};


export type ShiftManagementWorkAreasConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  customFilters?: InputMaybe<Array<ShiftManagementCustomFilterInput>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endAt: Scalars['String'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  logicOperator?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  shiftIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
  startAt: Scalars['String'];
  teamId?: InputMaybe<Scalars['Int']>;
};

export type ShiftManagementMutations = {
  __typename?: 'shiftManagementMutations';
  applyTemplateShiftmanagementSchedule: ApplyTemplateShiftmanagementSchedulePayload;
  approveShiftmanagementSwapShift: ApproveShiftmanagementSwapShiftPayload;
  bulkCopyShiftmanagementSchedule: BulkCopyShiftmanagementSchedulePayload;
  bulkCopyShiftmanagementUnassignedShift: BulkCopyShiftmanagementUnassignedShiftPayload;
  bulkCreateShiftmanagementRestDay: BulkCreateShiftmanagementRestDayPayload;
  bulkCreateShiftmanagementShift: BulkCreateShiftmanagementShiftPayload;
  bulkCreateShiftmanagementUnassignedShift: BulkCreateShiftmanagementUnassignedShiftPayload;
  bulkCudShiftmanagementShiftConfiguration: BulkCudShiftmanagementShiftConfigurationPayload;
  bulkDeleteShiftmanagementRestDay: BulkDeleteShiftmanagementRestDayPayload;
  bulkDeleteShiftmanagementShift: BulkDeleteShiftmanagementShiftPayload;
  bulkDeleteShiftmanagementUnassignedShift: BulkDeleteShiftmanagementUnassignedShiftPayload;
  bulkGenerateShiftmanagementUnassignedShift: BulkGenerateShiftmanagementUnassignedShiftPayload;
  bulkPatchShiftmanagementShift: BulkPatchShiftmanagementShiftPayload;
  createShiftmanagementAutoSchedulerExecution: CreateShiftmanagementAutoSchedulerExecutionPayload;
  createShiftmanagementDefaultShift: CreateShiftmanagementDefaultShiftPayload;
  createShiftmanagementShift: CreateShiftmanagementShiftPayload;
  createShiftmanagementSwapShift: CreateShiftmanagementSwapShiftPayload;
  createShiftmanagementTemplate: CreateShiftmanagementTemplatePayload;
  createShiftmanagementTemplateWeek: CreateShiftmanagementTemplateWeekPayload;
  createShiftmanagementUnassignedShift: CreateShiftmanagementUnassignedShiftPayload;
  deleteShiftmanagementDefaultShift: DeleteShiftmanagementDefaultShiftPayload;
  deleteShiftmanagementShift: DeleteShiftmanagementShiftPayload;
  deleteShiftmanagementSwapShift: DeleteShiftmanagementSwapShiftPayload;
  deleteShiftmanagementTemplate: DeleteShiftmanagementTemplatePayload;
  deleteShiftmanagementTemplateWeek: DeleteShiftmanagementTemplateWeekPayload;
  deleteShiftmanagementUnassignedShift: DeleteShiftmanagementUnassignedShiftPayload;
  dropShiftmanagementShift: DropShiftmanagementShiftPayload;
  generateScheduleShiftmanagementAutomation: GenerateScheduleShiftmanagementAutomationPayload;
  publishShiftmanagementSchedule: PublishShiftmanagementSchedulePayload;
  rejectShiftmanagementSwapShift: RejectShiftmanagementSwapShiftPayload;
  updateShiftmanagementAutoSchedulerExecution: UpdateShiftmanagementAutoSchedulerExecutionPayload;
  updateShiftmanagementDefaultShift: UpdateShiftmanagementDefaultShiftPayload;
  updateShiftmanagementSwapShift: UpdateShiftmanagementSwapShiftPayload;
  updateShiftmanagementTemplate: UpdateShiftmanagementTemplatePayload;
  updateShiftmanagementTemplateWeek: UpdateShiftmanagementTemplateWeekPayload;
  updateShiftmanagementUnassignedShift: UpdateShiftmanagementUnassignedShiftPayload;
};


export type ShiftManagementMutationsApplyTemplateShiftmanagementScheduleArgs = {
  employeesIds: Array<Scalars['Int']>;
  endDate: Scalars['ISO8601Date'];
  localTimezone?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['Int']>;
  notes?: InputMaybe<Scalars['String']>;
  startDate: Scalars['ISO8601Date'];
  templateId: Scalars['Int'];
  templateWeekPosition?: InputMaybe<Scalars['Int']>;
  viewEndDate: Scalars['ISO8601Date'];
  viewStartDate: Scalars['ISO8601Date'];
  workAreaId?: InputMaybe<Scalars['Int']>;
};


export type ShiftManagementMutationsApproveShiftmanagementSwapShiftArgs = {
  approverId?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  reason?: InputMaybe<Scalars['String']>;
};


export type ShiftManagementMutationsBulkCopyShiftmanagementScheduleArgs = {
  companyId: Scalars['Int'];
  customFilters?: InputMaybe<Array<ShiftManagementCustomFilterInput>>;
  daysToCopy?: InputMaybe<Scalars['Int']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  includeDraftShifts?: InputMaybe<Scalars['Boolean']>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  logicOperator?: InputMaybe<Scalars['String']>;
  originalStartAt: Scalars['String'];
  targetStartAt: Scalars['String'];
};


export type ShiftManagementMutationsBulkCopyShiftmanagementUnassignedShiftArgs = {
  companyId: Scalars['Int'];
  customFilters?: InputMaybe<Array<ShiftManagementCustomFilterInput>>;
  daysToCopy?: InputMaybe<Scalars['Int']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  includeDraftShifts?: InputMaybe<Scalars['Boolean']>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  logicOperator?: InputMaybe<Scalars['String']>;
  originalStartAt: Scalars['String'];
  targetStartAt: Scalars['String'];
};


export type ShiftManagementMutationsBulkCreateShiftmanagementRestDayArgs = {
  restDays: Array<BulkCreateShiftmanagementRestDayRestDaysInput>;
};


export type ShiftManagementMutationsBulkCreateShiftmanagementShiftArgs = {
  plannedBreaks?: InputMaybe<Array<BulkCreateShiftmanagementShiftPlannedBreaksInput>>;
  shifts: Array<BulkCreateShiftmanagementShiftShiftsInput>;
};


export type ShiftManagementMutationsBulkCreateShiftmanagementUnassignedShiftArgs = {
  unassignedShifts: Array<BulkCreateShiftmanagementUnassignedShiftUnassignedShiftsInput>;
};


export type ShiftManagementMutationsBulkCudShiftmanagementShiftConfigurationArgs = {
  shiftConfigurations: Array<BulkCudShiftmanagementShiftConfigurationShiftConfigurationsInput>;
  templateWeekId: Scalars['Int'];
};


export type ShiftManagementMutationsBulkDeleteShiftmanagementRestDayArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endAt?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  startAt?: InputMaybe<Scalars['ISO8601Date']>;
};


export type ShiftManagementMutationsBulkDeleteShiftmanagementShiftArgs = {
  authorId?: InputMaybe<Scalars['Int']>;
  destroyAutomaticShifts?: InputMaybe<Scalars['Boolean']>;
  destroyBackupShifts?: InputMaybe<Scalars['Boolean']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endAt?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  startAt?: InputMaybe<Scalars['String']>;
};


export type ShiftManagementMutationsBulkDeleteShiftmanagementUnassignedShiftArgs = {
  endAt?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  startAt?: InputMaybe<Scalars['String']>;
};


export type ShiftManagementMutationsBulkGenerateShiftmanagementUnassignedShiftArgs = {
  customFilters?: InputMaybe<Array<ShiftManagementCustomFilterInput>>;
  daysToGenerate: Scalars['Int'];
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  includeDraftShifts?: InputMaybe<Scalars['Boolean']>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  logicOperator?: InputMaybe<Scalars['String']>;
  originalStartAt: Scalars['ISO8601DateTime'];
  targetStartAt: Scalars['ISO8601DateTime'];
};


export type ShiftManagementMutationsBulkPatchShiftmanagementShiftArgs = {
  companyId: Scalars['Int'];
  endAt?: InputMaybe<Scalars['String']>;
  extraHours?: InputMaybe<Scalars['Boolean']>;
  locationId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  plannedBreaks?: InputMaybe<Array<BulkPatchShiftmanagementShiftPlannedBreaksInput>>;
  shiftIds: Array<Scalars['Int']>;
  startAt?: InputMaybe<Scalars['String']>;
  workAreaId?: InputMaybe<Scalars['Int']>;
};


export type ShiftManagementMutationsCreateShiftmanagementAutoSchedulerExecutionArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  endAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  locationId: Scalars['Int'];
  runId: Scalars['String'];
  runName: Scalars['String'];
  startAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  status?: InputMaybe<ShiftManagementEnumsAutoSchedulerExecutionStatusEnum>;
  uuid?: InputMaybe<Scalars['String']>;
};


export type ShiftManagementMutationsCreateShiftmanagementDefaultShiftArgs = {
  allCompany?: InputMaybe<Scalars['Boolean']>;
  color?: InputMaybe<Scalars['String']>;
  endAt: Scalars['String'];
  extraHours?: InputMaybe<Scalars['Boolean']>;
  locationId?: InputMaybe<Scalars['Int']>;
  locationsIdsVisibilities: Array<Scalars['Int']>;
  notes?: InputMaybe<Scalars['String']>;
  startAt: Scalars['String'];
  teamsIdsVisibilities: Array<Scalars['Int']>;
  title: Scalars['String'];
  workAreaId?: InputMaybe<Scalars['Int']>;
};


export type ShiftManagementMutationsCreateShiftmanagementShiftArgs = {
  authorId?: InputMaybe<Scalars['Int']>;
  companyId: Scalars['Int'];
  creationMode?: InputMaybe<ShiftManagementEnumsShiftCreationModeEnum>;
  defaultShiftId?: InputMaybe<Scalars['Int']>;
  employeeId: Scalars['Int'];
  endAt: Scalars['ISO8601DateTime'];
  extraHours?: InputMaybe<Scalars['Boolean']>;
  leaveId?: InputMaybe<Scalars['Int']>;
  locationId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  startAt: Scalars['ISO8601DateTime'];
  state?: InputMaybe<ShiftManagementEnumsShiftStateEnum>;
  templateWeekId?: InputMaybe<Scalars['Int']>;
  unassignedShiftId?: InputMaybe<Scalars['Int']>;
  workAreaId?: InputMaybe<Scalars['Int']>;
};


export type ShiftManagementMutationsCreateShiftmanagementSwapShiftArgs = {
  currentShiftId: Scalars['Int'];
  reason: Scalars['String'];
  requestedShiftId: Scalars['Int'];
};


export type ShiftManagementMutationsCreateShiftmanagementTemplateArgs = {
  name: Scalars['String'];
  scheduleType?: InputMaybe<Scalars['String']>;
};


export type ShiftManagementMutationsCreateShiftmanagementTemplateWeekArgs = {
  name: Scalars['String'];
  templateId: Scalars['Int'];
};


export type ShiftManagementMutationsCreateShiftmanagementUnassignedShiftArgs = {
  allCompany: Scalars['Boolean'];
  companyId: Scalars['Int'];
  counter: Scalars['Int'];
  defaultShiftId?: InputMaybe<Scalars['Int']>;
  endAt: Scalars['ISO8601DateTime'];
  extraHours?: InputMaybe<Scalars['Boolean']>;
  jobCatalogRolesIds: Array<Scalars['Int']>;
  jobCatalogTreeRoleUuids: Array<Scalars['String']>;
  locationId?: InputMaybe<Scalars['Int']>;
  locationsIdsVisibilities: Array<Scalars['Int']>;
  notes?: InputMaybe<Scalars['String']>;
  startAt: Scalars['ISO8601DateTime'];
  teamsIdsVisibilities: Array<Scalars['Int']>;
  workAreaId?: InputMaybe<Scalars['Int']>;
};


export type ShiftManagementMutationsDeleteShiftmanagementDefaultShiftArgs = {
  id: Scalars['Int'];
};


export type ShiftManagementMutationsDeleteShiftmanagementShiftArgs = {
  id: Scalars['Int'];
};


export type ShiftManagementMutationsDeleteShiftmanagementSwapShiftArgs = {
  id: Scalars['Int'];
};


export type ShiftManagementMutationsDeleteShiftmanagementTemplateArgs = {
  id: Scalars['Int'];
};


export type ShiftManagementMutationsDeleteShiftmanagementTemplateWeekArgs = {
  id: Scalars['Int'];
};


export type ShiftManagementMutationsDeleteShiftmanagementUnassignedShiftArgs = {
  id: Scalars['Int'];
};


export type ShiftManagementMutationsDropShiftmanagementShiftArgs = {
  companyId: Scalars['Int'];
  date?: InputMaybe<Scalars['ISO8601Date']>;
  dropAction: ShiftManagementShiftInteractorDropActionEnum;
  employeeId: Scalars['Int'];
  id: Scalars['Int'];
  locationId?: InputMaybe<Scalars['Int']>;
  startTime?: InputMaybe<Scalars['String']>;
  workAreaId?: InputMaybe<Scalars['Int']>;
};


export type ShiftManagementMutationsGenerateScheduleShiftmanagementAutomationArgs = {
  agreementHours: Scalars['Boolean'];
  employeesIds: Array<Scalars['Int']>;
  endAt: Scalars['ISO8601DateTime'];
  locationId: Scalars['Int'];
  maxWorkHoursPerDay: Scalars['Boolean'];
  restDaysPerWeek: Scalars['Boolean'];
  restHoursBetweenShifts: Scalars['Boolean'];
  startAt: Scalars['ISO8601DateTime'];
  status?: InputMaybe<Scalars['String']>;
};


export type ShiftManagementMutationsPublishShiftmanagementScheduleArgs = {
  customFilters?: InputMaybe<Array<ShiftManagementCustomFilterInput>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endAt: Scalars['ISO8601DateTime'];
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  logicOperator?: InputMaybe<Scalars['String']>;
  sendNotifications?: InputMaybe<Scalars['Boolean']>;
  startAt: Scalars['ISO8601DateTime'];
  viewType?: InputMaybe<Scalars['String']>;
  withoutShiftsIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type ShiftManagementMutationsRejectShiftmanagementSwapShiftArgs = {
  approverId?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  reason: Scalars['String'];
};


export type ShiftManagementMutationsUpdateShiftmanagementAutoSchedulerExecutionArgs = {
  id: Scalars['Int'];
  status: ShiftManagementEnumsAutoSchedulerExecutionStatusEnum;
};


export type ShiftManagementMutationsUpdateShiftmanagementDefaultShiftArgs = {
  allCompany?: InputMaybe<Scalars['Boolean']>;
  color?: InputMaybe<Scalars['String']>;
  endAt: Scalars['String'];
  extraHours?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  locationId?: InputMaybe<Scalars['Int']>;
  locationsIdsVisibilities: Array<Scalars['Int']>;
  notes?: InputMaybe<Scalars['String']>;
  startAt: Scalars['String'];
  teamsIdsVisibilities: Array<Scalars['Int']>;
  title: Scalars['String'];
  workAreaId?: InputMaybe<Scalars['Int']>;
};


export type ShiftManagementMutationsUpdateShiftmanagementSwapShiftArgs = {
  id: Scalars['Int'];
  managerReason?: InputMaybe<Scalars['String']>;
  teammateReason?: InputMaybe<Scalars['String']>;
};


export type ShiftManagementMutationsUpdateShiftmanagementTemplateArgs = {
  id: Scalars['Int'];
  name: Scalars['String'];
};


export type ShiftManagementMutationsUpdateShiftmanagementTemplateWeekArgs = {
  color?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
};


export type ShiftManagementMutationsUpdateShiftmanagementUnassignedShiftArgs = {
  allCompany: Scalars['Boolean'];
  counter: Scalars['Int'];
  endAt: Scalars['ISO8601DateTime'];
  extraHours?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  jobCatalogRolesIds: Array<Scalars['Int']>;
  jobCatalogTreeRoleUuids: Array<Scalars['String']>;
  locationId?: InputMaybe<Scalars['Int']>;
  locationsIdsVisibilities: Array<Scalars['Int']>;
  notes?: InputMaybe<Scalars['String']>;
  startAt: Scalars['ISO8601DateTime'];
  teamsIdsVisibilities: Array<Scalars['Int']>;
  workAreaId?: InputMaybe<Scalars['Int']>;
};

export type Signals = {
  __typename?: 'signals';
  tag?: Maybe<SignalsTag>;
  /** @deprecated Please favor `tagsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  tags: Array<SignalsTag>;
  tagsConnection: SignalsTagConnection;
};


export type SignalsTagArgs = {
  id: Scalars['String'];
};


export type SignalsTagsArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};


export type SignalsTagsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

export type SoftwareManagement = {
  __typename?: 'softwareManagement';
  _policies: SoftwareManagementContextlessPolicies;
  customSoftware?: Maybe<SoftwareManagementCustomSoftware>;
  /** @deprecated Please favor `customSoftwaresConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  customSoftwares: Array<SoftwareManagementCustomSoftware>;
  customSoftwaresConnection: SoftwareManagementCustomSoftwareConnection;
  /** @deprecated Please favor `dashboardSoftwareCostsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  dashboardSoftwareCosts: Array<SoftwareManagementDashboardSoftwareCost>;
  dashboardSoftwareCostsConnection: SoftwareManagementDashboardSoftwareCostConnection;
  employee?: Maybe<SoftwareManagementEmployee>;
  employeeSoftwareMembership?: Maybe<SoftwareManagementEmployeeSoftwareMembership>;
  /** @deprecated Please favor `employeeSoftwareMembershipsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  employeeSoftwareMemberships: Array<SoftwareManagementEmployeeSoftwareMembership>;
  employeeSoftwareMembershipsConnection: SoftwareManagementEmployeeSoftwareMembershipConnection;
  /** @deprecated Please favor `employeesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  employees: Array<SoftwareManagementEmployee>;
  employeesConnection: SoftwareManagementEmployeeConnection;
  /** @deprecated Please favor `monthlySoftwareCostsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  monthlySoftwareCosts: Array<SoftwareManagementMonthlySoftwareCost>;
  monthlySoftwareCostsConnection: SoftwareManagementMonthlySoftwareCostConnection;
  software?: Maybe<SoftwareManagementSoftware>;
  softwarePayment?: Maybe<SoftwareManagementSoftwarePayment>;
  /** @deprecated Please favor `softwarePaymentsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  softwarePayments: Array<SoftwareManagementSoftwarePayment>;
  softwarePaymentsConnection: SoftwareManagementSoftwarePaymentConnection;
  softwareSetup?: Maybe<SoftwareManagementSoftwareSetup>;
  /** @deprecated Please favor `softwareSetupsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  softwareSetups: Array<SoftwareManagementSoftwareSetup>;
  softwareSetupsConnection: SoftwareManagementSoftwareSetupConnection;
  /** @deprecated Please favor `softwaresConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  softwares: Array<SoftwareManagementSoftware>;
  softwaresConnection: SoftwareManagementSoftwareConnection;
};


export type SoftwareManagementCustomSoftwareArgs = {
  id: Scalars['String'];
};


export type SoftwareManagementCustomSoftwaresArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};


export type SoftwareManagementCustomSoftwaresConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type SoftwareManagementDashboardSoftwareCostsArgs = {
  currency?: InputMaybe<Scalars['String']>;
  dateFrom?: InputMaybe<Scalars['String']>;
  dateTo?: InputMaybe<Scalars['String']>;
};


export type SoftwareManagementDashboardSoftwareCostsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  dateFrom?: InputMaybe<Scalars['String']>;
  dateTo?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type SoftwareManagementEmployeeArgs = {
  id: Scalars['String'];
};


export type SoftwareManagementEmployeeSoftwareMembershipArgs = {
  id: Scalars['Int'];
};


export type SoftwareManagementEmployeeSoftwareMembershipsArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  onlyTerminated?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  softwareIds?: InputMaybe<Array<Scalars['String']>>;
  softwareSetupIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type SoftwareManagementEmployeeSoftwareMembershipsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  filter?: InputMaybe<SoftwareManagementEmployeeSoftwareMembershipFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyTerminated?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  softwareIds?: InputMaybe<Array<Scalars['String']>>;
  softwareSetupIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
};


export type SoftwareManagementEmployeesArgs = {
  fuzzySearch?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  onlyTerminated?: Scalars['Boolean'];
  withSoftware?: Scalars['Boolean'];
};


export type SoftwareManagementEmployeesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SoftwareManagementEmployeeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  fuzzySearch?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyTerminated?: Scalars['Boolean'];
  sortOrder?: InputMaybe<Sort>;
  withSoftware?: Scalars['Boolean'];
};


export type SoftwareManagementMonthlySoftwareCostsArgs = {
  currency?: InputMaybe<Scalars['String']>;
  dateFrom?: InputMaybe<Scalars['String']>;
  dateTo?: InputMaybe<Scalars['String']>;
  softwareSetupIds: Array<Scalars['Int']>;
};


export type SoftwareManagementMonthlySoftwareCostsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  dateFrom?: InputMaybe<Scalars['String']>;
  dateTo?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  softwareSetupIds: Array<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type SoftwareManagementSoftwareArgs = {
  id: Scalars['String'];
};


export type SoftwareManagementSoftwarePaymentArgs = {
  id: Scalars['Int'];
};


export type SoftwareManagementSoftwarePaymentsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  softwareSetupId?: InputMaybe<Scalars['Int']>;
  sourceIds?: InputMaybe<Array<Scalars['Int']>>;
  sourceType?: InputMaybe<Scalars['String']>;
};


export type SoftwareManagementSoftwarePaymentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SoftwareManagementSoftwarePaymentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  softwareSetupId?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  sourceIds?: InputMaybe<Array<Scalars['Int']>>;
  sourceType?: InputMaybe<Scalars['String']>;
};


export type SoftwareManagementSoftwareSetupArgs = {
  id: Scalars['Int'];
};


export type SoftwareManagementSoftwareSetupsArgs = {
  cardIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  vendorIds?: InputMaybe<Array<Scalars['Int']>>;
  withoutCard?: InputMaybe<Scalars['Boolean']>;
};


export type SoftwareManagementSoftwareSetupsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  cardIds?: InputMaybe<Array<Scalars['Int']>>;
  filter?: InputMaybe<SoftwareManagementSoftwareSetupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  vendorIds?: InputMaybe<Array<Scalars['Int']>>;
  withoutCard?: InputMaybe<Scalars['Boolean']>;
};


export type SoftwareManagementSoftwaresArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};


export type SoftwareManagementSoftwaresConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

export type SoftwareManagementMutations = {
  __typename?: 'softwareManagementMutations';
  addCardSoftwaremanagementSoftwareSetup: AddCardSoftwaremanagementSoftwareSetupPayload;
  bulkCreateSoftwaremanagementEmployeeSoftwareMembership: BulkCreateSoftwaremanagementEmployeeSoftwareMembershipPayload;
  createSoftwaremanagementCustomSoftware: CreateSoftwaremanagementCustomSoftwarePayload;
  createSoftwaremanagementEmployeeSoftwareMembership: CreateSoftwaremanagementEmployeeSoftwareMembershipPayload;
  createSoftwaremanagementSoftwarePayment: CreateSoftwaremanagementSoftwarePaymentPayload;
  createSoftwaremanagementSoftwareSetup: CreateSoftwaremanagementSoftwareSetupPayload;
  deleteContractSoftwaremanagementSoftwareSetup: DeleteContractSoftwaremanagementSoftwareSetupPayload;
  deleteSoftwaremanagementEmployeeSoftwareMembership: DeleteSoftwaremanagementEmployeeSoftwareMembershipPayload;
  deleteSoftwaremanagementSoftwareSetup: DeleteSoftwaremanagementSoftwareSetupPayload;
  terminateEmployeesSoftwaremanagementEmployeeSoftwareMembership: TerminateEmployeesSoftwaremanagementEmployeeSoftwareMembershipPayload;
  updateSoftwaremanagementCustomSoftware: UpdateSoftwaremanagementCustomSoftwarePayload;
  updateSoftwaremanagementSoftwarePayment: UpdateSoftwaremanagementSoftwarePaymentPayload;
  updateSoftwaremanagementSoftwareSetup: UpdateSoftwaremanagementSoftwareSetupPayload;
};


export type SoftwareManagementMutationsAddCardSoftwaremanagementSoftwareSetupArgs = {
  amountLimitCents: Scalars['Int'];
  cardholderData?: InputMaybe<AddCardSoftwaremanagementSoftwareSetupCardholderDataInput>;
  employeeId: Scalars['String'];
  limitPeriod: BankingCardLimitPeriodEnum;
  softwareSetupId: Scalars['Int'];
};


export type SoftwareManagementMutationsBulkCreateSoftwaremanagementEmployeeSoftwareMembershipArgs = {
  employeeIds: Array<Scalars['Int']>;
  softwareId: Scalars['String'];
};


export type SoftwareManagementMutationsCreateSoftwaremanagementCustomSoftwareArgs = {
  name: Scalars['String'];
};


export type SoftwareManagementMutationsCreateSoftwaremanagementEmployeeSoftwareMembershipArgs = {
  employeeId: Scalars['Int'];
  softwareId: Scalars['String'];
};


export type SoftwareManagementMutationsCreateSoftwaremanagementSoftwarePaymentArgs = {
  amountCents: Scalars['Int'];
  currency: Scalars['String'];
  executedAt: Scalars['ISO8601DateTime'];
  softwareSetupId: Scalars['Int'];
  source?: InputMaybe<SoftwareManagementSoftwarePaymentSourceInput>;
};


export type SoftwareManagementMutationsCreateSoftwaremanagementSoftwareSetupArgs = {
  cardholderData?: InputMaybe<CreateSoftwaremanagementSoftwareSetupCardholderDataInput>;
  createCard?: InputMaybe<Scalars['Boolean']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  licenseType?: InputMaybe<Scalars['String']>;
  renewalDate?: InputMaybe<Scalars['ISO8601Date']>;
  softwareId: Scalars['String'];
  spendingAmount?: InputMaybe<Scalars['Int']>;
  spendingPeriod?: InputMaybe<BankingCardLimitPeriodEnum>;
};


export type SoftwareManagementMutationsDeleteContractSoftwaremanagementSoftwareSetupArgs = {
  softwareSetupId: Scalars['Int'];
};


export type SoftwareManagementMutationsDeleteSoftwaremanagementEmployeeSoftwareMembershipArgs = {
  id: Scalars['Int'];
};


export type SoftwareManagementMutationsDeleteSoftwaremanagementSoftwareSetupArgs = {
  id: Scalars['Int'];
};


export type SoftwareManagementMutationsTerminateEmployeesSoftwaremanagementEmployeeSoftwareMembershipArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type SoftwareManagementMutationsUpdateSoftwaremanagementCustomSoftwareArgs = {
  id: Scalars['Int'];
  logo?: InputMaybe<Scalars['File']>;
  name?: InputMaybe<Scalars['String']>;
};


export type SoftwareManagementMutationsUpdateSoftwaremanagementSoftwarePaymentArgs = {
  amountCents: Scalars['Int'];
  currency: Scalars['String'];
  executedAt: Scalars['ISO8601DateTime'];
  id: Scalars['Int'];
};


export type SoftwareManagementMutationsUpdateSoftwaremanagementSoftwareSetupArgs = {
  contract?: InputMaybe<Scalars['File']>;
  id: Scalars['Int'];
  licenseType?: InputMaybe<Scalars['String']>;
  renewalDate?: InputMaybe<Scalars['ISO8601Date']>;
  vendorId?: InputMaybe<Scalars['Int']>;
};

export type SpaceControl = {
  __typename?: 'spaceControl';
  _policies: SpaceControlContextlessPolicies;
  booking?: Maybe<SpaceControlBooking>;
  /** @deprecated Please favor `bookingContextlessPermissionsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  bookingContextlessPermissions: Array<SpaceControlBookingContextlessPermission>;
  bookingContextlessPermissionsConnection: SpaceControlBookingContextlessPermissionConnection;
  /** @deprecated Please favor `bookingsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  bookings: Array<SpaceControlBooking>;
  bookingsConnection: SpaceControlBookingConnection;
  workAreaMap?: Maybe<SpaceControlWorkAreaMap>;
  workAreaMapSpaceLocation?: Maybe<SpaceControlWorkAreaMapSpaceLocation>;
  /** @deprecated Please favor `workAreaMapSpaceLocationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  workAreaMapSpaceLocations: Array<SpaceControlWorkAreaMapSpaceLocation>;
  workAreaMapSpaceLocationsConnection: SpaceControlWorkAreaMapSpaceLocationConnection;
  /** @deprecated Please favor `workAreaMapsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  workAreaMaps: Array<SpaceControlWorkAreaMap>;
  workAreaMapsConnection: SpaceControlWorkAreaMapConnection;
  workSpace?: Maybe<SpaceControlWorkSpace>;
  /** @deprecated Please favor `workSpaceSlotsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  workSpaceSlots: Array<SpaceControlWorkSpaceSlot>;
  workSpaceSlotsConnection: SpaceControlWorkSpaceSlotConnection;
  /** @deprecated Please favor `workSpaceWithBookingsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  workSpaceWithBookings: Array<SpaceControlWorkSpaceWithBooking>;
  workSpaceWithBookingsConnection: SpaceControlWorkSpaceWithBookingConnection;
  /** @deprecated Please favor `workSpacesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  workSpaces: Array<SpaceControlWorkSpace>;
  workSpacesConnection: SpaceControlWorkSpaceConnection;
};


export type SpaceControlBookingArgs = {
  id: Scalars['Int'];
};


export type SpaceControlBookingContextlessPermissionsArgs = {
  id?: InputMaybe<Scalars['Int']>;
};


export type SpaceControlBookingContextlessPermissionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type SpaceControlBookingsArgs = {
  accessIds?: Array<Scalars['Int']>;
  date?: InputMaybe<Scalars['ISO8601Date']>;
  employeeIds?: Array<Scalars['Int']>;
  ids?: Array<Scalars['Int']>;
  timeRange?: InputMaybe<SpaceControlTimeRangeInput>;
  workSpaceIds?: Array<Scalars['Int']>;
};


export type SpaceControlBookingsConnectionArgs = {
  accessIds?: Array<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['ISO8601Date']>;
  employeeIds?: Array<Scalars['Int']>;
  filter?: InputMaybe<SpaceControlBookingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: Array<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  timeRange?: InputMaybe<SpaceControlTimeRangeInput>;
  workSpaceIds?: Array<Scalars['Int']>;
};


export type SpaceControlWorkAreaMapArgs = {
  id: Scalars['Int'];
};


export type SpaceControlWorkAreaMapSpaceLocationArgs = {
  id: Scalars['Int'];
};


export type SpaceControlWorkAreaMapSpaceLocationsArgs = {
  ids?: Array<Scalars['Int']>;
  workAreaMapIds?: Array<Scalars['Int']>;
  workSpaceIds?: Array<Scalars['Int']>;
};


export type SpaceControlWorkAreaMapSpaceLocationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: Array<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  workAreaMapIds?: Array<Scalars['Int']>;
  workSpaceIds?: Array<Scalars['Int']>;
};


export type SpaceControlWorkAreaMapsArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  ids?: Array<Scalars['Int']>;
  workAreaIds?: Array<Scalars['Int']>;
};


export type SpaceControlWorkAreaMapsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: Array<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  workAreaIds?: Array<Scalars['Int']>;
};


export type SpaceControlWorkSpaceArgs = {
  id: Scalars['Int'];
};


export type SpaceControlWorkSpaceSlotsArgs = {
  date: Scalars['ISO8601Date'];
  workSpaceId: Scalars['Int'];
};


export type SpaceControlWorkSpaceSlotsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  date: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  workSpaceId: Scalars['Int'];
};


export type SpaceControlWorkSpaceWithBookingsArgs = {
  date: Scalars['ISO8601Date'];
  endTime?: InputMaybe<Scalars['String']>;
  locationIds?: Array<Scalars['Int']>;
  startTime?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<SpaceControlWorkSpaceWorkSpaceTypeEnum>;
  workAreaIds?: Array<Scalars['Int']>;
  workSpaceIds?: Array<Scalars['Int']>;
};


export type SpaceControlWorkSpaceWithBookingsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  date: Scalars['ISO8601Date'];
  endTime?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SpaceControlWorkSpaceWithBookingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locationIds?: Array<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startTime?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<SpaceControlWorkSpaceWorkSpaceTypeEnum>;
  workAreaIds?: Array<Scalars['Int']>;
  workSpaceIds?: Array<Scalars['Int']>;
};


export type SpaceControlWorkSpacesArgs = {
  endTime?: InputMaybe<Scalars['String']>;
  ids?: Array<Scalars['Int']>;
  locationIds?: Array<Scalars['Int']>;
  startTime?: InputMaybe<Scalars['String']>;
  workAreaIds?: Array<Scalars['Int']>;
};


export type SpaceControlWorkSpacesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: Array<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locationIds?: Array<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startTime?: InputMaybe<Scalars['String']>;
  workAreaIds?: Array<Scalars['Int']>;
};

export type SpaceControlMutations = {
  __typename?: 'spaceControlMutations';
  bulkCancelSpacecontrolBooking: BulkCancelSpacecontrolBookingPayload;
  bulkCreateSpacecontrolBooking: BulkCreateSpacecontrolBookingPayload;
  bulkUpdateSpacecontrolBooking: BulkUpdateSpacecontrolBookingPayload;
  createSpacecontrolWorkAreaMap: CreateSpacecontrolWorkAreaMapPayload;
  createSpacecontrolWorkSpace: CreateSpacecontrolWorkSpacePayload;
  deleteSpacecontrolWorkAreaMap: DeleteSpacecontrolWorkAreaMapPayload;
  deleteSpacecontrolWorkAreaMapSpaceLocation: DeleteSpacecontrolWorkAreaMapSpaceLocationPayload;
  deleteSpacecontrolWorkSpace: DeleteSpacecontrolWorkSpacePayload;
  updateSpacecontrolWorkAreaMap: UpdateSpacecontrolWorkAreaMapPayload;
  updateSpacecontrolWorkSpace: UpdateSpacecontrolWorkSpacePayload;
  upsertSpacecontrolWorkAreaMapSpaceLocation: UpsertSpacecontrolWorkAreaMapSpaceLocationPayload;
};


export type SpaceControlMutationsBulkCancelSpacecontrolBookingArgs = {
  ids: Array<Scalars['Int']>;
};


export type SpaceControlMutationsBulkCreateSpacecontrolBookingArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  capacity?: InputMaybe<Scalars['Int']>;
  date: Scalars['ISO8601Date'];
  employeeId?: InputMaybe<Scalars['Int']>;
  slots?: InputMaybe<Array<Scalars['Int']>>;
  workSpaceId: Scalars['Int'];
};


export type SpaceControlMutationsBulkUpdateSpacecontrolBookingArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  capacity?: InputMaybe<Scalars['Int']>;
  date: Scalars['ISO8601Date'];
  employeeId?: InputMaybe<Scalars['Int']>;
  ids: Array<Scalars['Int']>;
  slots: Array<Scalars['Int']>;
  workSpaceId: Scalars['Int'];
};


export type SpaceControlMutationsCreateSpacecontrolWorkAreaMapArgs = {
  image: Scalars['File'];
  workAreaId: Scalars['Int'];
};


export type SpaceControlMutationsCreateSpacecontrolWorkSpaceArgs = {
  allowMultipleBookings: Scalars['Boolean'];
  capacity: Scalars['Int'];
  description: Scalars['String'];
  endTime: Scalars['String'];
  images: Array<Scalars['File']>;
  name: Scalars['String'];
  slotDuration: Scalars['String'];
  slotSetup: Scalars['String'];
  startTime: Scalars['String'];
  workAreaId: Scalars['Int'];
  workSpaceType: Scalars['String'];
};


export type SpaceControlMutationsDeleteSpacecontrolWorkAreaMapArgs = {
  id: Scalars['Int'];
};


export type SpaceControlMutationsDeleteSpacecontrolWorkAreaMapSpaceLocationArgs = {
  id: Scalars['Int'];
};


export type SpaceControlMutationsDeleteSpacecontrolWorkSpaceArgs = {
  id: Scalars['Int'];
};


export type SpaceControlMutationsUpdateSpacecontrolWorkAreaMapArgs = {
  id: Scalars['Int'];
  image: Scalars['File'];
};


export type SpaceControlMutationsUpdateSpacecontrolWorkSpaceArgs = {
  allowMultipleBookings: Scalars['Boolean'];
  capacity: Scalars['Int'];
  description?: InputMaybe<Scalars['String']>;
  endTime: Scalars['String'];
  id: Scalars['Int'];
  images: Array<Scalars['File']>;
  name?: InputMaybe<Scalars['String']>;
  slotDuration: Scalars['String'];
  slotSetup: Scalars['String'];
  startTime: Scalars['String'];
  workAreaId?: InputMaybe<Scalars['Int']>;
  workSpaceType: Scalars['String'];
};


export type SpaceControlMutationsUpsertSpacecontrolWorkAreaMapSpaceLocationArgs = {
  workAreaMapId: Scalars['Int'];
  workSpaceId: Scalars['Int'];
  x: Scalars['Float'];
  y: Scalars['Float'];
};

export type Surveys = {
  __typename?: 'surveys';
  _policies: SurveysContextlessPolicies;
  editor?: Maybe<SurveysEditor>;
  /** @deprecated Please favor `editorsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  editors: Array<SurveysEditor>;
  editorsConnection: SurveysEditorConnection;
  questionGroupToAnswerIdentifier?: Maybe<SurveysQuestionGroupToAnswerIdentifier>;
  /** @deprecated Please favor `questionGroupToAnswerIdentifiersConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  questionGroupToAnswerIdentifiers: Array<SurveysQuestionGroupToAnswerIdentifier>;
  questionGroupToAnswerIdentifiersConnection: SurveysQuestionGroupToAnswerIdentifierConnection;
  survey?: Maybe<SurveysSurvey>;
  /** @deprecated Please favor `surveysConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  surveys: Array<SurveysSurvey>;
  surveysConnection: SurveysSurveyConnection;
};


export type SurveysEditorArgs = {
  id: Scalars['Int'];
};


export type SurveysEditorsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type SurveysEditorsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type SurveysQuestionGroupToAnswerIdentifierArgs = {
  id: Scalars['Int'];
};


export type SurveysQuestionGroupToAnswerIdentifiersArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type SurveysQuestionGroupToAnswerIdentifiersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type SurveysSurveyArgs = {
  id: Scalars['Int'];
};


export type SurveysSurveysArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Array<FormsEnumsStatusEnum>>;
};


export type SurveysSurveysConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  status?: InputMaybe<Array<FormsEnumsStatusEnum>>;
};

export type SurveysMutations = {
  __typename?: 'surveysMutations';
  archiveSurveysSurvey: ArchiveSurveysSurveyPayload;
  createSurveysEditor: CreateSurveysEditorPayload;
  createSurveysSurvey: CreateSurveysSurveyPayload;
  deleteSurveysEditor: DeleteSurveysEditorPayload;
  deleteSurveysSurvey: DeleteSurveysSurveyPayload;
  duplicateSurveysSurvey: DuplicateSurveysSurveyPayload;
  publishSurveysSurvey: PublishSurveysSurveyPayload;
  updateRespondentStrategySurveysSurvey: UpdateRespondentStrategySurveysSurveyPayload;
  updateRestrictedViewersEnabledSurveysSurvey: UpdateRestrictedViewersEnabledSurveysSurveyPayload;
  updateSurveysSurvey: UpdateSurveysSurveyPayload;
};


export type SurveysMutationsArchiveSurveysSurveyArgs = {
  id: Scalars['String'];
};


export type SurveysMutationsCreateSurveysEditorArgs = {
  employeeId: Scalars['Int'];
  surveyId: Scalars['Int'];
};


export type SurveysMutationsCreateSurveysSurveyArgs = {
  anonymous?: InputMaybe<Scalars['Boolean']>;
  companyId: Scalars['Int'];
  description?: InputMaybe<Scalars['String']>;
  editorIds?: InputMaybe<Array<Scalars['Int']>>;
  respondentStrategy?: InputMaybe<SurveysRespondentStrategyInput>;
  restrictedViewersEnabled?: InputMaybe<Scalars['Boolean']>;
  surveyType: SurveysEnumsSurveyTypeEnum;
  title: Scalars['String'];
};


export type SurveysMutationsDeleteSurveysEditorArgs = {
  employeeId: Scalars['Int'];
  surveyId: Scalars['Int'];
};


export type SurveysMutationsDeleteSurveysSurveyArgs = {
  surveyId: Scalars['Int'];
};


export type SurveysMutationsDuplicateSurveysSurveyArgs = {
  surveyId: Scalars['Int'];
};


export type SurveysMutationsPublishSurveysSurveyArgs = {
  daysToAnswer?: InputMaybe<Scalars['Int']>;
  endsAt?: InputMaybe<Scalars['String']>;
  recurrenceType: FormsScheduleRecurrenceTypeEnum;
  startDate?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['String']>;
  surveyId: Scalars['Int'];
};


export type SurveysMutationsUpdateRespondentStrategySurveysSurveyArgs = {
  respondentStrategy: SurveysRespondentStrategyInput;
  surveyId: Scalars['Int'];
};


export type SurveysMutationsUpdateRestrictedViewersEnabledSurveysSurveyArgs = {
  restrictedViewersEnabled: Scalars['Boolean'];
  surveyId: Scalars['Int'];
};


export type SurveysMutationsUpdateSurveysSurveyArgs = {
  anonymous?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  editorIds?: InputMaybe<Array<Scalars['Int']>>;
  respondentStrategy?: InputMaybe<SurveysRespondentStrategyInput>;
  restrictedViewersEnabled?: InputMaybe<Scalars['Boolean']>;
  surveyId: Scalars['Int'];
  title?: InputMaybe<Scalars['String']>;
};

/** Payload for sync_run and subscription: status_change */
export type Sync_Run_Status_Change_Type = {
  __typename?: 'sync_run_status_change_type';
  error?: Maybe<Scalars['Boolean']>;
  finishedAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['Int'];
  parameters: Array<IntegrationsSyncRunParametersSubscription>;
  status: IntegrationsSyncRunStatusEnum;
};

export type Tasks = {
  __typename?: 'tasks';
  _policies: TasksContextlessPolicies;
  categoryCount?: Maybe<TasksCategoryCount>;
  /** @deprecated Please favor `categoryCountsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  categoryCounts: Array<TasksCategoryCount>;
  categoryCountsConnection: TasksCategoryCountConnection;
  inboxTask?: Maybe<TasksInboxTask>;
  /** @deprecated Please favor `inboxTasksConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  inboxTasks: Array<TasksInboxTask>;
  inboxTasksConnection: TasksInboxTaskConnection;
  /** @deprecated Please favor `materializedProcessTasksConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  materializedProcessTasks: Array<TasksMaterializedProcessTask>;
  materializedProcessTasksConnection: TasksMaterializedProcessTaskConnection;
  /** @deprecated Please favor `shareTasksConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  shareTasks: Array<TasksShareTask>;
  shareTasksConnection: TasksShareTaskConnection;
  task?: Maybe<TasksTask>;
  taskFile?: Maybe<TasksTaskFile>;
  /** @deprecated Please favor `taskFilesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  taskFiles: Array<TasksTaskFile>;
  taskFilesConnection: TasksTaskFileConnection;
  /** @deprecated Please favor `tasksConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  tasks: Array<TasksTask>;
  tasksConnection: TasksTaskConnection;
  /** @deprecated Please favor `tasksSummariesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  tasksSummaries: Array<TasksTasksSummary>;
  tasksSummariesConnection: TasksTasksSummaryConnection;
  timeCount?: Maybe<TasksTimeCount>;
  /** @deprecated Please favor `timeCountsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  timeCounts: Array<TasksTimeCount>;
  timeCountsConnection: TasksTimeCountConnection;
  unsafeAccess?: Maybe<TasksUnsafeAccess>;
  /** @deprecated Please favor `unsafeAccessesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  unsafeAccesses: Array<TasksUnsafeAccess>;
  unsafeAccessesConnection: TasksUnsafeAccessConnection;
  uploadDocumentTaskFile?: Maybe<TasksUploadDocumentTaskFile>;
  /** @deprecated Please favor `uploadDocumentTaskFilesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  uploadDocumentTaskFiles: Array<TasksUploadDocumentTaskFile>;
  uploadDocumentTaskFilesConnection: TasksUploadDocumentTaskFileConnection;
};


export type TasksCategoryCountArgs = {
  id: Scalars['Int'];
};


export type TasksCategoryCountsArgs = {
  categories?: InputMaybe<Array<TasksValueObjectsTaskCategoryEnum>>;
  category?: InputMaybe<TasksValueObjectsTaskCategoryEnum>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  kind?: InputMaybe<TasksValueObjectsTaskKindEnum>;
  kinds?: InputMaybe<Array<TasksValueObjectsTaskKindEnum>>;
  sortBy?: InputMaybe<TasksValueObjectsTaskSortColumnEnum>;
  sortDirection?: InputMaybe<TasksValueObjectsTaskSortDirectionEnum>;
  status?: InputMaybe<TasksValueObjectsTaskStatusEnum>;
  statuses?: InputMaybe<Array<TasksValueObjectsTaskStatusEnum>>;
};


export type TasksCategoryCountsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  categories?: InputMaybe<Array<TasksValueObjectsTaskCategoryEnum>>;
  category?: InputMaybe<TasksValueObjectsTaskCategoryEnum>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  kind?: InputMaybe<TasksValueObjectsTaskKindEnum>;
  kinds?: InputMaybe<Array<TasksValueObjectsTaskKindEnum>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<TasksValueObjectsTaskSortColumnEnum>;
  sortDirection?: InputMaybe<TasksValueObjectsTaskSortDirectionEnum>;
  sortOrder?: InputMaybe<Sort>;
  status?: InputMaybe<TasksValueObjectsTaskStatusEnum>;
  statuses?: InputMaybe<Array<TasksValueObjectsTaskStatusEnum>>;
};


export type TasksInboxTaskArgs = {
  id: Scalars['Int'];
};


export type TasksInboxTasksArgs = {
  categories?: InputMaybe<Array<TasksValueObjectsTaskCategoryEnum>>;
  category?: InputMaybe<TasksValueObjectsTaskCategoryEnum>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  kind?: InputMaybe<TasksValueObjectsTaskKindEnum>;
  kinds?: InputMaybe<Array<TasksValueObjectsTaskKindEnum>>;
  sortBy?: InputMaybe<TasksValueObjectsTaskSortColumnEnum>;
  sortDirection?: InputMaybe<TasksValueObjectsTaskSortDirectionEnum>;
  status?: InputMaybe<TasksValueObjectsTaskStatusEnum>;
  statuses?: InputMaybe<Array<TasksValueObjectsTaskStatusEnum>>;
};


export type TasksInboxTasksConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  categories?: InputMaybe<Array<TasksValueObjectsTaskCategoryEnum>>;
  category?: InputMaybe<TasksValueObjectsTaskCategoryEnum>;
  filter?: InputMaybe<TasksInboxTaskFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  kind?: InputMaybe<TasksValueObjectsTaskKindEnum>;
  kinds?: InputMaybe<Array<TasksValueObjectsTaskKindEnum>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<TasksValueObjectsTaskSortColumnEnum>;
  sortDirection?: InputMaybe<TasksValueObjectsTaskSortDirectionEnum>;
  sortOrder?: InputMaybe<Sort>;
  status?: InputMaybe<TasksValueObjectsTaskStatusEnum>;
  statuses?: InputMaybe<Array<TasksValueObjectsTaskStatusEnum>>;
};


export type TasksMaterializedProcessTasksArgs = {
  alreadyDue?: InputMaybe<Scalars['Boolean']>;
  mandatory?: InputMaybe<Scalars['Boolean']>;
  processCategory: ProcessesProcessCategoryEnum;
  processId: Scalars['Int'];
  search?: InputMaybe<Scalars['String']>;
};


export type TasksMaterializedProcessTasksConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  alreadyDue?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<TasksMaterializedProcessTaskFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  mandatory?: InputMaybe<Scalars['Boolean']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  processCategory: ProcessesProcessCategoryEnum;
  processId: Scalars['Int'];
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type TasksShareTasksArgs = {
  accesses?: InputMaybe<Array<Scalars['Int']>>;
  taskId: Scalars['Int'];
};


export type TasksShareTasksConnectionArgs = {
  accesses?: InputMaybe<Array<Scalars['Int']>>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  taskId: Scalars['Int'];
};


export type TasksTaskArgs = {
  id: Scalars['Int'];
};


export type TasksTaskFileArgs = {
  id: Scalars['Int'];
  taskId: Scalars['Int'];
};


export type TasksTaskFilesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  taskId: Scalars['Int'];
};


export type TasksTaskFilesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  taskId: Scalars['Int'];
};


export type TasksTasksArgs = {
  alreadyDue?: InputMaybe<Scalars['Boolean']>;
  assigneeId?: InputMaybe<Scalars['Int']>;
  assigneeRole?: InputMaybe<TasksValueObjectsTaskInvolvementRolesEnum>;
  authorId?: InputMaybe<Scalars['Int']>;
  category?: InputMaybe<TasksValueObjectsTaskCategoryEnum>;
  companyId?: InputMaybe<Scalars['Int']>;
  documentId?: InputMaybe<Scalars['Int']>;
  dueOn?: InputMaybe<Scalars['ISO8601Date']>;
  identifier?: InputMaybe<TasksValueObjectsTaskIdentifierEnum>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  involveeId?: InputMaybe<Scalars['Int']>;
  mandatory?: InputMaybe<Scalars['Boolean']>;
  processId?: InputMaybe<Scalars['Int']>;
  processIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  startsOn?: InputMaybe<Scalars['ISO8601Date']>;
  status?: InputMaybe<TasksTaskStatusEnum>;
  taskStatus?: InputMaybe<TasksValueObjectsTaskStatusEnum>;
};


export type TasksTasksConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  alreadyDue?: InputMaybe<Scalars['Boolean']>;
  assigneeId?: InputMaybe<Scalars['Int']>;
  assigneeRole?: InputMaybe<TasksValueObjectsTaskInvolvementRolesEnum>;
  authorId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<TasksValueObjectsTaskCategoryEnum>;
  companyId?: InputMaybe<Scalars['Int']>;
  documentId?: InputMaybe<Scalars['Int']>;
  dueOn?: InputMaybe<Scalars['ISO8601Date']>;
  filter?: InputMaybe<TasksTaskFilter>;
  first?: InputMaybe<Scalars['Int']>;
  identifier?: InputMaybe<TasksValueObjectsTaskIdentifierEnum>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  involveeId?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  mandatory?: InputMaybe<Scalars['Boolean']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  processId?: InputMaybe<Scalars['Int']>;
  processIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  startsOn?: InputMaybe<Scalars['ISO8601Date']>;
  status?: InputMaybe<TasksTaskStatusEnum>;
  taskStatus?: InputMaybe<TasksValueObjectsTaskStatusEnum>;
};


export type TasksTasksSummariesArgs = {
  assigneeId: Scalars['Int'];
  tasksLimit?: InputMaybe<Scalars['Int']>;
};


export type TasksTasksSummariesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  assigneeId: Scalars['Int'];
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  tasksLimit?: InputMaybe<Scalars['Int']>;
};


export type TasksTimeCountArgs = {
  id: Scalars['Int'];
};


export type TasksTimeCountsArgs = {
  categories?: InputMaybe<Array<TasksValueObjectsTaskCategoryEnum>>;
  category?: InputMaybe<TasksValueObjectsTaskCategoryEnum>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  kind?: InputMaybe<TasksValueObjectsTaskKindEnum>;
  kinds?: InputMaybe<Array<TasksValueObjectsTaskKindEnum>>;
  sortBy?: InputMaybe<TasksValueObjectsTaskSortColumnEnum>;
  sortDirection?: InputMaybe<TasksValueObjectsTaskSortDirectionEnum>;
  status?: InputMaybe<TasksValueObjectsTaskStatusEnum>;
  statuses?: InputMaybe<Array<TasksValueObjectsTaskStatusEnum>>;
};


export type TasksTimeCountsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  categories?: InputMaybe<Array<TasksValueObjectsTaskCategoryEnum>>;
  category?: InputMaybe<TasksValueObjectsTaskCategoryEnum>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  kind?: InputMaybe<TasksValueObjectsTaskKindEnum>;
  kinds?: InputMaybe<Array<TasksValueObjectsTaskKindEnum>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<TasksValueObjectsTaskSortColumnEnum>;
  sortDirection?: InputMaybe<TasksValueObjectsTaskSortDirectionEnum>;
  sortOrder?: InputMaybe<Sort>;
  status?: InputMaybe<TasksValueObjectsTaskStatusEnum>;
  statuses?: InputMaybe<Array<TasksValueObjectsTaskStatusEnum>>;
};


export type TasksUnsafeAccessArgs = {
  id: Scalars['Int'];
};


export type TasksUnsafeAccessesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type TasksUnsafeAccessesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<TasksUnsafeAccessFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type TasksUploadDocumentTaskFileArgs = {
  id: Scalars['Int'];
  taskId: Scalars['Int'];
};


export type TasksUploadDocumentTaskFilesArgs = {
  folderId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  taskId: Scalars['Int'];
};


export type TasksUploadDocumentTaskFilesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  folderId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  taskId: Scalars['Int'];
};

export type TasksMutations = {
  __typename?: 'tasksMutations';
  bulkCreateTasksTask: BulkCreateTasksTaskPayload;
  bulkDeleteTasksTask: BulkDeleteTasksTaskPayload;
  bulkMarkAsTasksInboxTask: BulkMarkAsTasksInboxTaskPayload;
  bulkUpdateTasksTask: BulkUpdateTasksTaskPayload;
  bulkUpdateTasksTaskFile: BulkUpdateTasksTaskFilePayload;
  bulkUpdateTasksUploadDocumentTaskFile: BulkUpdateTasksUploadDocumentTaskFilePayload;
  copyTasksTask: CopyTasksTaskPayload;
  createCommentTasksTask: CreateCommentTasksTaskPayload;
  createTaskCommentReactionTasksTask: CreateTaskCommentReactionTasksTaskPayload;
  createTasksTask: CreateTasksTaskPayload;
  createTasksTaskFile: CreateTasksTaskFilePayload;
  deleteTaskCommentReactionTasksTask: DeleteTaskCommentReactionTasksTaskPayload;
  deleteTasksTask: DeleteTasksTaskPayload;
  deleteTasksTaskFile: DeleteTasksTaskFilePayload;
  discardOutdatedTasksInboxTask: DiscardOutdatedTasksInboxTaskPayload;
  filterTasksTaskFile: FilterTasksTaskFilePayload;
  markAsTasksInboxTask: MarkAsTasksInboxTaskPayload;
  sendRemindersTasksMaterializedProcessTask: SendRemindersTasksMaterializedProcessTaskPayload;
  shareTasksShareTask: ShareTasksShareTaskPayload;
  unshareTasksShareTask: UnshareTasksShareTaskPayload;
  updateTasksTask: UpdateTasksTaskPayload;
};


export type TasksMutationsBulkCreateTasksTaskArgs = {
  affecteeIds?: InputMaybe<Array<Scalars['Int']>>;
  assigneeIds?: InputMaybe<Array<Scalars['Int']>>;
  authorId?: InputMaybe<Scalars['Int']>;
  content?: InputMaybe<Scalars['String']>;
  dueOn?: InputMaybe<Scalars['ISO8601Date']>;
  groupableKey?: InputMaybe<Scalars['String']>;
  identifier?: InputMaybe<TasksValueObjectsTaskIdentifierEnum>;
  name: Scalars['String'];
  startsOn?: InputMaybe<Scalars['ISO8601Date']>;
  status?: InputMaybe<TasksValueObjectsTaskStatusEnum>;
  taskType?: InputMaybe<Scalars['String']>;
};


export type TasksMutationsBulkDeleteTasksTaskArgs = {
  ids: Array<Scalars['Int']>;
};


export type TasksMutationsBulkMarkAsTasksInboxTaskArgs = {
  ids: Array<Scalars['Int']>;
  status: TasksValueObjectsTaskStatusEnum;
};


export type TasksMutationsBulkUpdateTasksTaskArgs = {
  tasks: Array<BulkUpdateTasksTaskTasksInput>;
};


export type TasksMutationsBulkUpdateTasksTaskFileArgs = {
  filesToAdd?: InputMaybe<Array<Scalars['File']>>;
  filesToRemove?: InputMaybe<Array<Scalars['Int']>>;
  taskId: Scalars['Int'];
};


export type TasksMutationsBulkUpdateTasksUploadDocumentTaskFileArgs = {
  filesToAdd?: InputMaybe<Array<Scalars['File']>>;
  filesToRemove?: InputMaybe<Array<Scalars['Int']>>;
  folderId?: InputMaybe<Scalars['Int']>;
  taskId: Scalars['Int'];
};


export type TasksMutationsCopyTasksTaskArgs = {
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
};


export type TasksMutationsCreateCommentTasksTaskArgs = {
  authorId: Scalars['Int'];
  companyId: Scalars['Int'];
  content: Scalars['String'];
  mentionedAccessIds?: InputMaybe<Array<Scalars['Int']>>;
  resourceId: Scalars['Int'];
};


export type TasksMutationsCreateTaskCommentReactionTasksTaskArgs = {
  commentId: Scalars['Int'];
  taskId: Scalars['Int'];
  textCode: Scalars['String'];
};


export type TasksMutationsCreateTasksTaskArgs = {
  affecteeIds?: InputMaybe<Array<Scalars['Int']>>;
  assigneeIds?: InputMaybe<Array<Scalars['Int']>>;
  authorId?: InputMaybe<Scalars['Int']>;
  content?: InputMaybe<Scalars['String']>;
  dueOn?: InputMaybe<Scalars['ISO8601Date']>;
  groupableKey?: InputMaybe<Scalars['String']>;
  identifier?: InputMaybe<TasksValueObjectsTaskIdentifierEnum>;
  name: Scalars['String'];
  startsOn?: InputMaybe<Scalars['ISO8601Date']>;
  status?: InputMaybe<TasksValueObjectsTaskStatusEnum>;
  taskType?: InputMaybe<Scalars['String']>;
};


export type TasksMutationsCreateTasksTaskFileArgs = {
  file: Scalars['File'];
  taskId: Scalars['Int'];
};


export type TasksMutationsDeleteTaskCommentReactionTasksTaskArgs = {
  id: Scalars['Int'];
};


export type TasksMutationsDeleteTasksTaskArgs = {
  id: Scalars['Int'];
  identifier?: InputMaybe<TasksValueObjectsTaskIdentifierEnum>;
};


export type TasksMutationsDeleteTasksTaskFileArgs = {
  id: Scalars['Int'];
};


export type TasksMutationsDiscardOutdatedTasksInboxTaskArgs = {
  id: Scalars['Int'];
};


export type TasksMutationsFilterTasksTaskFileArgs = {
  taskIds: Array<Scalars['Int']>;
};


export type TasksMutationsMarkAsTasksInboxTaskArgs = {
  id: Scalars['Int'];
  status: TasksValueObjectsTaskStatusEnum;
};


export type TasksMutationsSendRemindersTasksMaterializedProcessTaskArgs = {
  ids: Array<Scalars['Int']>;
  message: Scalars['String'];
};


export type TasksMutationsShareTasksShareTaskArgs = {
  sharedIds: Array<Scalars['Int']>;
  taskId: Scalars['Int'];
};


export type TasksMutationsUnshareTasksShareTaskArgs = {
  accessIds: Array<Scalars['Int']>;
  taskId: Scalars['Int'];
};


export type TasksMutationsUpdateTasksTaskArgs = {
  assigneeIds?: InputMaybe<Array<Scalars['Int']>>;
  content?: InputMaybe<Scalars['String']>;
  dueOn?: InputMaybe<Scalars['ISO8601Date']>;
  id: Scalars['Int'];
  identifier?: InputMaybe<TasksValueObjectsTaskIdentifierEnum>;
  name?: InputMaybe<Scalars['String']>;
  startsOn?: InputMaybe<Scalars['ISO8601Date']>;
  status?: InputMaybe<TasksValueObjectsTaskStatusEnum>;
};

export type Teams = {
  __typename?: 'teams';
  _policies: TeamsContextlessPolicies;
  /** @deprecated Please favor `historicalTeamsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  historicalTeams: Array<TeamsHistoricalTeam>;
  historicalTeamsConnection: TeamsHistoricalTeamConnection;
  membership?: Maybe<TeamsMembership>;
  /** @deprecated Please favor `membershipsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  memberships: Array<TeamsMembership>;
  membershipsConnection: TeamsMembershipConnection;
  team?: Maybe<TeamsTeam>;
  /** @deprecated Please favor `teamsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  teams: Array<TeamsTeam>;
  teamsConnection: TeamsTeamConnection;
};


export type TeamsHistoricalTeamsArgs = {
  fromDate: Scalars['ISO8601Date'];
  toDate: Scalars['ISO8601Date'];
};


export type TeamsHistoricalTeamsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  fromDate: Scalars['ISO8601Date'];
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  toDate: Scalars['ISO8601Date'];
};


export type TeamsMembershipArgs = {
  id: Scalars['Int'];
};


export type TeamsMembershipsArgs = {
  activeEmployees?: Scalars['Boolean'];
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  lead?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  sortByLeads?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type TeamsMembershipsConnectionArgs = {
  activeEmployees?: Scalars['Boolean'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  filter?: InputMaybe<TeamsMembershipFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  lead?: InputMaybe<Scalars['Boolean']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortByLeads?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Sort>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type TeamsTeamArgs = {
  id: Scalars['Int'];
};


export type TeamsTeamsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  mainTeam?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  withMembers?: InputMaybe<Scalars['Boolean']>;
};


export type TeamsTeamsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  mainTeam?: InputMaybe<Scalars['Boolean']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  withMembers?: InputMaybe<Scalars['Boolean']>;
};

export type TeamsMutations = {
  __typename?: 'teamsMutations';
  activateFeatureTeamsTeamChart: ActivateFeatureTeamsTeamChartPayload;
  bulkUpsertTeamsMembership: BulkUpsertTeamsMembershipPayload;
  createTeamsMembership: CreateTeamsMembershipPayload;
  createTeamsTeam: CreateTeamsTeamPayload;
  deleteTeamsMembership: DeleteTeamsMembershipPayload;
  deleteTeamsTeam: DeleteTeamsTeamPayload;
  employeesByMonthTeamsHistoricalTeam: EmployeesByMonthTeamsHistoricalTeamPayload;
  updateTeamsMembership: UpdateTeamsMembershipPayload;
  updateTeamsTeam: UpdateTeamsTeamPayload;
};


export type TeamsMutationsActivateFeatureTeamsTeamChartArgs = {
  companyId: Scalars['Int'];
};


export type TeamsMutationsBulkUpsertTeamsMembershipArgs = {
  teamId: Scalars['Int'];
};


export type TeamsMutationsCreateTeamsMembershipArgs = {
  employeeId: Scalars['Int'];
  lead?: InputMaybe<Scalars['Boolean']>;
  teamId: Scalars['Int'];
};


export type TeamsMutationsCreateTeamsTeamArgs = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};


export type TeamsMutationsDeleteTeamsMembershipArgs = {
  id: Scalars['Int'];
};


export type TeamsMutationsDeleteTeamsTeamArgs = {
  id: Scalars['Int'];
};


export type TeamsMutationsEmployeesByMonthTeamsHistoricalTeamArgs = {
  ranges: Scalars['String'];
  teamIds: Array<Scalars['Int']>;
};


export type TeamsMutationsUpdateTeamsMembershipArgs = {
  id: Scalars['Int'];
  lead?: InputMaybe<Scalars['Boolean']>;
};


export type TeamsMutationsUpdateTeamsTeamArgs = {
  avatar?: InputMaybe<Scalars['File']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
};

export type TimeBalance = {
  __typename?: 'timeBalance';
  _policies: TimeBalanceContextlessPolicies;
  agreementHour?: Maybe<TimeBalanceAgreementHour>;
  /** @deprecated Please favor `agreementHoursConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  agreementHours: Array<TimeBalanceAgreementHour>;
  agreementHoursConnection: TimeBalanceAgreementHourConnection;
  timeCondition?: Maybe<TimeBalanceTimeCondition>;
  /** @deprecated Please favor `timeConditionsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  timeConditions: Array<TimeBalanceTimeCondition>;
  timeConditionsConnection: TimeBalanceTimeConditionConnection;
  timePeriodDetail?: Maybe<TimeBalanceTimePeriodDetail>;
  /** @deprecated Please favor `timePeriodDetailsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  timePeriodDetails: Array<TimeBalanceTimePeriodDetail>;
  timePeriodDetailsConnection: TimeBalanceTimePeriodDetailConnection;
};


export type TimeBalanceAgreementHourArgs = {
  employeeIds: Array<Scalars['Int']>;
  id: Scalars['String'];
};


export type TimeBalanceAgreementHoursArgs = {
  employeeIds: Array<Scalars['Int']>;
  endOn?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  startOn?: InputMaybe<Scalars['ISO8601Date']>;
};


export type TimeBalanceAgreementHoursConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds: Array<Scalars['Int']>;
  endOn?: InputMaybe<Scalars['ISO8601Date']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startOn?: InputMaybe<Scalars['ISO8601Date']>;
};


export type TimeBalanceTimeConditionArgs = {
  id: Scalars['Int'];
};


export type TimeBalanceTimeConditionsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type TimeBalanceTimeConditionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type TimeBalanceTimePeriodDetailArgs = {
  dateFrom: Scalars['ISO8601Date'];
  dateTo: Scalars['ISO8601Date'];
  id: Scalars['Int'];
  locationsIds: Array<Scalars['Int']>;
  teamsIds: Array<Scalars['Int']>;
};


export type TimeBalanceTimePeriodDetailsArgs = {
  dateFrom: Scalars['ISO8601Date'];
  dateTo: Scalars['ISO8601Date'];
  ids: Array<Scalars['Int']>;
  locationsIds: Array<Scalars['Int']>;
  teamsIds: Array<Scalars['Int']>;
};


export type TimeBalanceTimePeriodDetailsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  dateFrom: Scalars['ISO8601Date'];
  dateTo: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  ids: Array<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locationsIds: Array<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  teamsIds: Array<Scalars['Int']>;
};

export type TimeBalanceMutations = {
  __typename?: 'timeBalanceMutations';
  currentTimebalanceTimeCondition: CurrentTimebalanceTimeConditionPayload;
  upsertTimebalanceTimeCondition: UpsertTimebalanceTimeConditionPayload;
};


export type TimeBalanceMutationsCurrentTimebalanceTimeConditionArgs = {
  legalEntityId?: InputMaybe<Scalars['Int']>;
};


export type TimeBalanceMutationsUpsertTimebalanceTimeConditionArgs = {
  duration: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  legalEntityId: Scalars['Int'];
  startOn: Scalars['Int'];
};

export type TimeInsights = {
  __typename?: 'timeInsights';
  /** @deprecated Please favor `clockInStatusesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  clockInStatuses: Array<TimeInsightsClockInStatus>;
  clockInStatusesConnection: TimeInsightsClockInStatusConnection;
  /** @deprecated Please favor `inconsistenciesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  inconsistencies: Array<TimeInsightsInconsistency>;
  inconsistenciesConnection: TimeInsightsInconsistencyConnection;
  inconsistency?: Maybe<TimeInsightsInconsistency>;
  /** @deprecated Please favor `presencesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  presences: Array<TimeInsightsPresence>;
  presencesConnection: TimeInsightsPresenceConnection;
};


export type TimeInsightsClockInStatusesArgs = {
  employeeId?: InputMaybe<Scalars['Int']>;
  endOn: Scalars['ISO8601Date'];
  startOn: Scalars['ISO8601Date'];
  status?: InputMaybe<TimeInsightsEntitiesClockInStatusStatusEnum>;
};


export type TimeInsightsClockInStatusesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  endOn: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startOn: Scalars['ISO8601Date'];
  status?: InputMaybe<TimeInsightsEntitiesClockInStatusStatusEnum>;
};


export type TimeInsightsInconsistenciesArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endOn?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  inconsistencyTypes?: InputMaybe<Array<TimeInsightsValueObjectsInconsistencyTypeEnum>>;
  shiftIds?: InputMaybe<Array<Scalars['Int']>>;
  startOn?: InputMaybe<Scalars['ISO8601Date']>;
  state?: InputMaybe<TimeInsightsEntitiesInconsistencyStateEnum>;
};


export type TimeInsightsInconsistenciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endOn?: InputMaybe<Scalars['ISO8601Date']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  inconsistencyTypes?: InputMaybe<Array<TimeInsightsValueObjectsInconsistencyTypeEnum>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  shiftIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
  startOn?: InputMaybe<Scalars['ISO8601Date']>;
  state?: InputMaybe<TimeInsightsEntitiesInconsistencyStateEnum>;
};


export type TimeInsightsInconsistencyArgs = {
  id: Scalars['Int'];
};


export type TimeInsightsPresencesArgs = {
  companyId: Scalars['Int'];
  date: Scalars['ISO8601Date'];
};


export type TimeInsightsPresencesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  date: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

export type TimeInsightsMutations = {
  __typename?: 'timeInsightsMutations';
  bulkDeleteTimeinsightsInconsistency: BulkDeleteTimeinsightsInconsistencyPayload;
  deleteTimeinsightsInconsistency: DeleteTimeinsightsInconsistencyPayload;
  updateTimeinsightsInconsistency: UpdateTimeinsightsInconsistencyPayload;
};


export type TimeInsightsMutationsBulkDeleteTimeinsightsInconsistencyArgs = {
  ids: Array<Scalars['Int']>;
};


export type TimeInsightsMutationsDeleteTimeinsightsInconsistencyArgs = {
  id: Scalars['Int'];
};


export type TimeInsightsMutationsUpdateTimeinsightsInconsistencyArgs = {
  id: Scalars['Int'];
  resolvedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  state?: InputMaybe<TimeInsightsEntitiesInconsistencyStateEnum>;
};

export type TimePlanning = {
  __typename?: 'timePlanning';
  _policies: TimePlanningContextlessPolicies;
  balance?: Maybe<TimePlanningBalance>;
  /** @deprecated Please favor `balancesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  balances: Array<TimePlanningBalance>;
  balancesByPeriod?: Maybe<TimePlanningBalancesByPeriod>;
  /** @deprecated Please favor `balancesByPeriodsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  balancesByPeriods: Array<TimePlanningBalancesByPeriod>;
  balancesByPeriodsConnection: TimePlanningBalancesByPeriodConnection;
  balancesConnection: TimePlanningBalanceConnection;
  employeeDateRangeEstimatedTime?: Maybe<TimePlanningEmployeeDateRangeEstimatedTime>;
  /** @deprecated Please favor `employeeDateRangeEstimatedTimesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  employeeDateRangeEstimatedTimes: Array<TimePlanningEmployeeDateRangeEstimatedTime>;
  employeeDateRangeEstimatedTimesConnection: TimePlanningEmployeeDateRangeEstimatedTimeConnection;
  /** @deprecated Please favor `employeePermissionsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  employeePermissions: Array<TimePlanningEmployeePermission>;
  employeePermissionsConnection: TimePlanningEmployeePermissionConnection;
  /** @deprecated Please favor `employeePermissionsForShiftsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  employeePermissionsForShifts: Array<TimePlanningEmployeePermissionsForShift>;
  employeePermissionsForShiftsConnection: TimePlanningEmployeePermissionsForShiftConnection;
  /** @deprecated Please favor `estimatedWorkDaysConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  estimatedWorkDays: Array<TimePlanningEstimatedWorkDay>;
  estimatedWorkDaysConnection: TimePlanningEstimatedWorkDayConnection;
  plannedBreak?: Maybe<TimePlanningPlannedBreak>;
  /** @deprecated Please favor `plannedBreaksConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  plannedBreaks: Array<TimePlanningPlannedBreak>;
  plannedBreaksConnection: TimePlanningPlannedBreakConnection;
  planningVersion?: Maybe<TimePlanningPlanningVersion>;
  /** @deprecated Please favor `planningVersionsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  planningVersions: Array<TimePlanningPlanningVersion>;
  planningVersionsConnection: TimePlanningPlanningVersionConnection;
};


export type TimePlanningBalanceArgs = {
  employeeIds: Array<Scalars['Int']>;
  endAt: Scalars['String'];
  id: Scalars['Int'];
  startAt: Scalars['String'];
};


export type TimePlanningBalancesArgs = {
  employeeIds: Array<Scalars['Int']>;
  endAt: Scalars['String'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  only?: InputMaybe<Array<TimePlanningEnumsBalancesOnlyBalancesEnum>>;
  startAt: Scalars['String'];
};


export type TimePlanningBalancesByPeriodArgs = {
  employeeIds: Array<Scalars['Int']>;
  id: Scalars['Int'];
  periods: Array<BalancesByPeriodsPeriodsInput>;
};


export type TimePlanningBalancesByPeriodsArgs = {
  employeeIds: Array<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  only?: InputMaybe<Array<TimePlanningEnumsBalancesOnlyBalancesEnum>>;
  periods: Array<BalancesByPeriodsPeriodsInput>;
};


export type TimePlanningBalancesByPeriodsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds: Array<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  only?: InputMaybe<Array<TimePlanningEnumsBalancesOnlyBalancesEnum>>;
  periods: Array<BalancesByPeriodsPeriodsInput>;
  sortOrder?: InputMaybe<Sort>;
};


export type TimePlanningBalancesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds: Array<Scalars['Int']>;
  endAt: Scalars['String'];
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  only?: InputMaybe<Array<TimePlanningEnumsBalancesOnlyBalancesEnum>>;
  sortOrder?: InputMaybe<Sort>;
  startAt: Scalars['String'];
};


export type TimePlanningEmployeeDateRangeEstimatedTimeArgs = {
  employeeIds: Array<Scalars['Int']>;
  endOn: Scalars['ISO8601Date'];
  id: Scalars['Int'];
  startOn: Scalars['ISO8601Date'];
};


export type TimePlanningEmployeeDateRangeEstimatedTimesArgs = {
  employeeIds: Array<Scalars['Int']>;
  endOn: Scalars['ISO8601Date'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  startOn: Scalars['ISO8601Date'];
};


export type TimePlanningEmployeeDateRangeEstimatedTimesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds: Array<Scalars['Int']>;
  endOn: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startOn: Scalars['ISO8601Date'];
};


export type TimePlanningEmployeePermissionsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  perPage: Scalars['Int'];
};


export type TimePlanningEmployeePermissionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  perPage: Scalars['Int'];
  sortOrder?: InputMaybe<Sort>;
};


export type TimePlanningEmployeePermissionsForShiftsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  perPage: Scalars['Int'];
};


export type TimePlanningEmployeePermissionsForShiftsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  perPage: Scalars['Int'];
  sortOrder?: InputMaybe<Sort>;
};


export type TimePlanningEstimatedWorkDaysArgs = {
  employeeIds: Array<Scalars['Int']>;
  endOn: Scalars['ISO8601Date'];
  startOn: Scalars['ISO8601Date'];
};


export type TimePlanningEstimatedWorkDaysConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds: Array<Scalars['Int']>;
  endOn: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  startOn: Scalars['ISO8601Date'];
};


export type TimePlanningPlannedBreakArgs = {
  id: Scalars['Int'];
};


export type TimePlanningPlannedBreaksArgs = {
  activeBreakConfiguration?: Scalars['Boolean'];
  dayConfigurationIds?: Array<Scalars['Int']>;
  defaultShiftIds?: Array<Scalars['Int']>;
  ids?: Array<Scalars['Int']>;
  paid?: InputMaybe<Scalars['Boolean']>;
  shiftConfigurationIds?: Array<Scalars['Int']>;
  shiftIds?: Array<Scalars['Int']>;
};


export type TimePlanningPlannedBreaksConnectionArgs = {
  activeBreakConfiguration?: Scalars['Boolean'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  dayConfigurationIds?: Array<Scalars['Int']>;
  defaultShiftIds?: Array<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: Array<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  paid?: InputMaybe<Scalars['Boolean']>;
  shiftConfigurationIds?: Array<Scalars['Int']>;
  shiftIds?: Array<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type TimePlanningPlanningVersionArgs = {
  id: Scalars['Int'];
};


export type TimePlanningPlanningVersionsArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeNameSearch?: InputMaybe<Scalars['String']>;
  forShifts?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: Scalars['Boolean'];
  planningTool?: InputMaybe<TimePlanningPlanningToolEnum>;
  scheduleIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type TimePlanningPlanningVersionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeNameSearch?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<TimePlanningPlanningVersionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  forShifts?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyActive?: Scalars['Boolean'];
  planningTool?: InputMaybe<TimePlanningPlanningToolEnum>;
  scheduleIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
};

export type TimePlanningMutations = {
  __typename?: 'timePlanningMutations';
  bulkCreateTimeplanningPlannedBreak: BulkCreateTimeplanningPlannedBreakPayload;
  bulkCreateTimeplanningPlanningVersion: BulkCreateTimeplanningPlanningVersionPayload;
  bulkCudTimeplanningPlannedBreak: BulkCudTimeplanningPlannedBreakPayload;
  createTimeplanningPlanningVersion: CreateTimeplanningPlanningVersionPayload;
  deactivateTimeplanningPlanningVersion: DeactivateTimeplanningPlanningVersionPayload;
  deleteTimeplanningPlanningVersion: DeleteTimeplanningPlanningVersionPayload;
  updateTimeplanningPlanningVersion: UpdateTimeplanningPlanningVersionPayload;
};


export type TimePlanningMutationsBulkCreateTimeplanningPlannedBreakArgs = {
  plannedBreaks: Array<BulkCreateTimeplanningPlannedBreakPlannedBreaksInput>;
};


export type TimePlanningMutationsBulkCreateTimeplanningPlanningVersionArgs = {
  effectiveAt: Scalars['ISO8601Date'];
  employeeIds: Array<Scalars['Int']>;
  employeeSelection?: InputMaybe<EmployeesEmployeeSelectorInput>;
  numberOfRestDaysInCents?: InputMaybe<Scalars['Int']>;
  planningTool: Scalars['String'];
  scheduleId?: InputMaybe<Scalars['Int']>;
};


export type TimePlanningMutationsBulkCudTimeplanningPlannedBreakArgs = {
  plannedBreaksParams: Array<BulkCudTimeplanningPlannedBreakPlannedBreaksParamsInput>;
};


export type TimePlanningMutationsCreateTimeplanningPlanningVersionArgs = {
  effectiveAt: Scalars['ISO8601Date'];
  employeeId: Scalars['Int'];
  numberOfRestDaysInCents?: InputMaybe<Scalars['Int']>;
  planningTool: Scalars['String'];
  scheduleId?: InputMaybe<Scalars['Int']>;
};


export type TimePlanningMutationsDeactivateTimeplanningPlanningVersionArgs = {
  effectiveAt: Scalars['ISO8601Date'];
  planningTool: Scalars['String'];
  scheduleId?: InputMaybe<Scalars['Int']>;
};


export type TimePlanningMutationsDeleteTimeplanningPlanningVersionArgs = {
  id: Scalars['Int'];
};


export type TimePlanningMutationsUpdateTimeplanningPlanningVersionArgs = {
  effectiveAt: Scalars['ISO8601Date'];
  id: Scalars['Int'];
  numberOfRestDaysInCents?: InputMaybe<Scalars['Int']>;
  planningTool: Scalars['String'];
  scheduleId?: InputMaybe<Scalars['Int']>;
};

export type TimeSettings = {
  __typename?: 'timeSettings';
  _policies: TimeSettingsContextlessPolicies;
  breakConfiguration?: Maybe<TimeSettingsBreakConfiguration>;
  /** @deprecated Please favor `breakConfigurationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  breakConfigurations: Array<TimeSettingsBreakConfiguration>;
  breakConfigurationsConnection: TimeSettingsBreakConfigurationConnection;
  /** @deprecated Please favor `customTimeRangeCategoriesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  customTimeRangeCategories: Array<TimeSettingsCustomTimeRangeCategory>;
  customTimeRangeCategoriesConnection: TimeSettingsCustomTimeRangeCategoryConnection;
  customTimeRangeCategory?: Maybe<TimeSettingsCustomTimeRangeCategory>;
  /** @deprecated Please favor `splitCustomTimeRangeCategoriesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  splitCustomTimeRangeCategories: Array<TimeSettingsSplitCustomTimeRangeCategory>;
  splitCustomTimeRangeCategoriesConnection: TimeSettingsSplitCustomTimeRangeCategoryConnection;
  splitCustomTimeRangeCategory?: Maybe<TimeSettingsSplitCustomTimeRangeCategory>;
};


export type TimeSettingsBreakConfigurationArgs = {
  id: Scalars['Int'];
};


export type TimeSettingsBreakConfigurationsArgs = {
  active?: Scalars['Boolean'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type TimeSettingsBreakConfigurationsConnectionArgs = {
  active?: Scalars['Boolean'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<TimeSettingsBreakConfigurationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type TimeSettingsCustomTimeRangeCategoriesArgs = {
  active?: Scalars['Boolean'];
  categoryType?: InputMaybe<TimeSettingsEnumsCategoryTypeEnum>;
  companyId?: InputMaybe<Scalars['Int']>;
  default?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type TimeSettingsCustomTimeRangeCategoriesConnectionArgs = {
  active?: Scalars['Boolean'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  categoryType?: InputMaybe<TimeSettingsEnumsCategoryTypeEnum>;
  companyId?: InputMaybe<Scalars['Int']>;
  default?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type TimeSettingsCustomTimeRangeCategoryArgs = {
  id: Scalars['Int'];
};


export type TimeSettingsSplitCustomTimeRangeCategoriesArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type TimeSettingsSplitCustomTimeRangeCategoriesConnectionArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type TimeSettingsSplitCustomTimeRangeCategoryArgs = {
  id: Scalars['Int'];
};

export type TimeSettingsMutations = {
  __typename?: 'timeSettingsMutations';
  createTimesettingsBreakConfiguration: CreateTimesettingsBreakConfigurationPayload;
  createTimesettingsCustomTimeRangeCategory: CreateTimesettingsCustomTimeRangeCategoryPayload;
  createTimesettingsSplitCustomTimeRangeCategory: CreateTimesettingsSplitCustomTimeRangeCategoryPayload;
  updateTimesettingsBreakConfiguration: UpdateTimesettingsBreakConfigurationPayload;
  updateTimesettingsCustomTimeRangeCategory: UpdateTimesettingsCustomTimeRangeCategoryPayload;
};


export type TimeSettingsMutationsCreateTimesettingsBreakConfigurationArgs = {
  name: Scalars['String'];
  paid: Scalars['Boolean'];
};


export type TimeSettingsMutationsCreateTimesettingsCustomTimeRangeCategoryArgs = {
  categoryType: TimeSettingsEnumsCategoryTypeEnum;
  companyId: Scalars['Int'];
  default?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  timeType: TimeSettingsEnumsTimeTypeEnum;
};


export type TimeSettingsMutationsCreateTimesettingsSplitCustomTimeRangeCategoryArgs = {
  companyId: Scalars['Int'];
  customTimeRangeCategoryId: Scalars['Int'];
  timeType: TimeSettingsEnumsTimeTypeEnum;
};


export type TimeSettingsMutationsUpdateTimesettingsBreakConfigurationArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  paid?: InputMaybe<Scalars['Boolean']>;
};


export type TimeSettingsMutationsUpdateTimesettingsCustomTimeRangeCategoryArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
};

export type Timeoff = {
  __typename?: 'timeoff';
  _policies: TimeoffContextlessPolicies;
  allowance?: Maybe<TimeoffAllowance>;
  allowanceIncidence?: Maybe<TimeoffAllowanceIncidence>;
  /** @deprecated Please favor `allowanceIncidencesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  allowanceIncidences: Array<TimeoffAllowanceIncidence>;
  allowanceIncidencesConnection: TimeoffAllowanceIncidenceConnection;
  /** @deprecated Please favor `allowancesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  allowances: Array<TimeoffAllowance>;
  allowancesConnection: TimeoffAllowanceConnection;
  blockedPeriod?: Maybe<TimeoffBlockedPeriod>;
  /** @deprecated Please favor `blockedPeriodsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  blockedPeriods: Array<TimeoffBlockedPeriod>;
  blockedPeriodsConnection: TimeoffBlockedPeriodConnection;
  currentPolicyAssignment?: Maybe<TimeoffCurrentPolicyAssignment>;
  /** @deprecated Please favor `currentPolicyAssignmentsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  currentPolicyAssignments: Array<TimeoffCurrentPolicyAssignment>;
  currentPolicyAssignmentsConnection: TimeoffCurrentPolicyAssignmentConnection;
  leave?: Maybe<TimeoffLeave>;
  leaveApprovalCondition?: Maybe<TimeoffLeaveApprovalCondition>;
  /** @deprecated Please favor `leaveApprovalConditionsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  leaveApprovalConditions: Array<TimeoffLeaveApprovalCondition>;
  leaveApprovalConditionsConnection: TimeoffLeaveApprovalConditionConnection;
  /** @deprecated Please favor `leaveApprovalRecommendationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  leaveApprovalRecommendations: Array<TimeoffLeaveApprovalRecommendation>;
  leaveApprovalRecommendationsConnection: TimeoffLeaveApprovalRecommendationConnection;
  leaveApprovalRule?: Maybe<TimeoffLeaveApprovalRule>;
  /** @deprecated Please favor `leaveApprovalRulesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  leaveApprovalRules: Array<TimeoffLeaveApprovalRule>;
  leaveApprovalRulesConnection: TimeoffLeaveApprovalRuleConnection;
  leaveType?: Maybe<TimeoffLeaveType>;
  /** @deprecated Please favor `leaveTypesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  leaveTypes: Array<TimeoffLeaveType>;
  leaveTypesConnection: TimeoffLeaveTypeConnection;
  /** @deprecated Please favor `leavesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  leaves: Array<TimeoffLeave>;
  leavesConnection: TimeoffLeaveConnection;
  /** @deprecated Please favor `policiesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  policies: Array<TimeoffPolicy>;
  policiesConnection: TimeoffPolicyConnection;
  policy?: Maybe<TimeoffPolicy>;
  policyAssignment?: Maybe<TimeoffPolicyAssignment>;
  /** @deprecated Please favor `policyAssignmentsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  policyAssignments: Array<TimeoffPolicyAssignment>;
  policyAssignmentsConnection: TimeoffPolicyAssignmentConnection;
  /** @deprecated Please favor `policyTimelinesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  policyTimelines: Array<TimeoffPolicyTimeline>;
  policyTimelinesConnection: TimeoffPolicyTimelineConnection;
  upcomingLeave?: Maybe<TimeoffUpcomingLeave>;
  /** @deprecated Please favor `upcomingLeavesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  upcomingLeaves: Array<TimeoffUpcomingLeave>;
  upcomingLeavesConnection: TimeoffUpcomingLeaveConnection;
};


export type TimeoffAllowanceArgs = {
  id: Scalars['Int'];
};


export type TimeoffAllowanceIncidenceArgs = {
  id: Scalars['Int'];
};


export type TimeoffAllowanceIncidencesArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  timeoffAllowanceIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type TimeoffAllowanceIncidencesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  timeoffAllowanceIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type TimeoffAllowancesArgs = {
  byOvertime?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyId?: InputMaybe<Scalars['Int']>;
};


export type TimeoffAllowancesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  byOvertime?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  timeoffPolicyId?: InputMaybe<Scalars['Int']>;
};


export type TimeoffBlockedPeriodArgs = {
  id: Scalars['Int'];
};


export type TimeoffBlockedPeriodsArgs = {
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type TimeoffBlockedPeriodsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type TimeoffCurrentPolicyAssignmentArgs = {
  id: Scalars['Int'];
};


export type TimeoffCurrentPolicyAssignmentsArgs = {
  ids: Array<Scalars['Int']>;
};


export type TimeoffCurrentPolicyAssignmentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids: Array<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type TimeoffLeaveArgs = {
  id: Scalars['Int'];
};


export type TimeoffLeaveApprovalConditionArgs = {
  id: Scalars['Int'];
};


export type TimeoffLeaveApprovalConditionsArgs = {
  conditionType?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  leaveApprovalRuleIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type TimeoffLeaveApprovalConditionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  conditionType?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  leaveApprovalRuleIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type TimeoffLeaveApprovalRecommendationsArgs = {
  leaveIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type TimeoffLeaveApprovalRecommendationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  leaveIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type TimeoffLeaveApprovalRuleArgs = {
  id: Scalars['Int'];
};


export type TimeoffLeaveApprovalRulesArgs = {
  createdByEmployeeId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  leaveTypeIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type TimeoffLeaveApprovalRulesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  createdByEmployeeId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  leaveTypeIds?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type TimeoffLeaveTypeArgs = {
  id: Scalars['Int'];
};


export type TimeoffLeaveTypesArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  allowEndless?: InputMaybe<Scalars['Boolean']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  leaveTypeId?: InputMaybe<Scalars['Int']>;
  payable?: InputMaybe<Scalars['Boolean']>;
  referenceDate?: InputMaybe<Scalars['ISO8601Date']>;
};


export type TimeoffLeaveTypesConnectionArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  allowEndless?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  leaveTypeId?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  payable?: InputMaybe<Scalars['Boolean']>;
  referenceDate?: InputMaybe<Scalars['ISO8601Date']>;
  sortOrder?: InputMaybe<Sort>;
};


export type TimeoffLeavesArgs = {
  approved?: InputMaybe<Scalars['Boolean']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  from?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeAllPendingApprovals?: InputMaybe<Scalars['Boolean']>;
  includeAllRelations?: InputMaybe<Scalars['Boolean']>;
  includeDeletedLeaves?: Scalars['Boolean'];
  includeDuration?: InputMaybe<Scalars['Boolean']>;
  includeLeaveType?: InputMaybe<Scalars['Boolean']>;
  includePending?: InputMaybe<Scalars['Boolean']>;
  leaveType?: InputMaybe<Array<Scalars['String']>>;
  leaveTypeId?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  to?: InputMaybe<Scalars['ISO8601Date']>;
  typeIsPayable?: InputMaybe<Scalars['Boolean']>;
  typeIsWorkable?: InputMaybe<Scalars['Boolean']>;
};


export type TimeoffLeavesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  approved?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  filter?: InputMaybe<TimeoffLeaveFilter>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['ISO8601Date']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeAllPendingApprovals?: InputMaybe<Scalars['Boolean']>;
  includeAllRelations?: InputMaybe<Scalars['Boolean']>;
  includeDeletedLeaves?: Scalars['Boolean'];
  includeDuration?: InputMaybe<Scalars['Boolean']>;
  includeLeaveType?: InputMaybe<Scalars['Boolean']>;
  includePending?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  leaveType?: InputMaybe<Array<Scalars['String']>>;
  leaveTypeId?: InputMaybe<Array<Scalars['Int']>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Sort>;
  to?: InputMaybe<Scalars['ISO8601Date']>;
  typeIsPayable?: InputMaybe<Scalars['Boolean']>;
  typeIsWorkable?: InputMaybe<Scalars['Boolean']>;
};


export type TimeoffPoliciesArgs = {
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type TimeoffPoliciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type TimeoffPolicyArgs = {
  id: Scalars['Int'];
};


export type TimeoffPolicyAssignmentArgs = {
  id: Scalars['Int'];
};


export type TimeoffPolicyAssignmentsArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type TimeoffPolicyAssignmentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  filter?: InputMaybe<TimeoffPolicyAssignmentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  timeoffPolicyIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type TimeoffPolicyTimelinesArgs = {
  employeeId: Scalars['Int'];
  referenceDate: Scalars['ISO8601Date'];
};


export type TimeoffPolicyTimelinesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  referenceDate: Scalars['ISO8601Date'];
  sortOrder?: InputMaybe<Sort>;
};


export type TimeoffUpcomingLeaveArgs = {
  futureDays: Scalars['Int'];
  id: Scalars['Int'];
};


export type TimeoffUpcomingLeavesArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  futureDays: Scalars['Int'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  onlyTeamLeaves?: InputMaybe<Scalars['Boolean']>;
};


export type TimeoffUpcomingLeavesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  futureDays: Scalars['Int'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyTeamLeaves?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Sort>;
};

export type TimeoffMutations = {
  __typename?: 'timeoffMutations';
  approveAllTimeoffLeave: ApproveAllTimeoffLeavePayload;
  approveTimeoffLeave: ApproveTimeoffLeavePayload;
  bulkAssignEmployeesTimeoffPolicy: BulkAssignEmployeesTimeoffPolicyPayload;
  bulkCreateTimeoffCurrentPolicyAssignment: BulkCreateTimeoffCurrentPolicyAssignmentPayload;
  bulkCreateTimeoffLeaveApprovalCondition: BulkCreateTimeoffLeaveApprovalConditionPayload;
  bulkUpdateTimeoffLeaveApprovalCondition: BulkUpdateTimeoffLeaveApprovalConditionPayload;
  createDefaultsTimeoffLeaveType: CreateDefaultsTimeoffLeaveTypePayload;
  createTimeoffAllowance: CreateTimeoffAllowancePayload;
  createTimeoffAllowanceIncidence: CreateTimeoffAllowanceIncidencePayload;
  createTimeoffBlockedPeriod: CreateTimeoffBlockedPeriodPayload;
  createTimeoffLeave: CreateTimeoffLeavePayload;
  createTimeoffLeaveApprovalRule: CreateTimeoffLeaveApprovalRulePayload;
  createTimeoffLeaveType: CreateTimeoffLeaveTypePayload;
  createTimeoffPolicy: CreateTimeoffPolicyPayload;
  createTimeoffPolicyAssignment: CreateTimeoffPolicyAssignmentPayload;
  deleteTimeoffAllowance: DeleteTimeoffAllowancePayload;
  deleteTimeoffAllowanceIncidence: DeleteTimeoffAllowanceIncidencePayload;
  deleteTimeoffBlockedPeriod: DeleteTimeoffBlockedPeriodPayload;
  deleteTimeoffLeave: DeleteTimeoffLeavePayload;
  deleteTimeoffLeaveApprovalRule: DeleteTimeoffLeaveApprovalRulePayload;
  deleteTimeoffPolicy: DeleteTimeoffPolicyPayload;
  deleteTimeoffPolicyAssignment: DeleteTimeoffPolicyAssignmentPayload;
  deleteWithAltAllowanceTimeoffAllowance: DeleteWithAltAllowanceTimeoffAllowancePayload;
  rejectTimeoffLeave: RejectTimeoffLeavePayload;
  updateInitialTimeoffPolicyAssignment: UpdateInitialTimeoffPolicyAssignmentPayload;
  updateTimeoffAllowance: UpdateTimeoffAllowancePayload;
  updateTimeoffAllowanceIncidence: UpdateTimeoffAllowanceIncidencePayload;
  updateTimeoffBlockedPeriod: UpdateTimeoffBlockedPeriodPayload;
  updateTimeoffLeave: UpdateTimeoffLeavePayload;
  updateTimeoffLeaveApprovalRule: UpdateTimeoffLeaveApprovalRulePayload;
  updateTimeoffLeaveType: UpdateTimeoffLeaveTypePayload;
  updateTimeoffPolicy: UpdateTimeoffPolicyPayload;
  updateTimeoffPolicyAssignment: UpdateTimeoffPolicyAssignmentPayload;
};


export type TimeoffMutationsApproveAllTimeoffLeaveArgs = {
  id: Scalars['Int'];
  source?: InputMaybe<Scalars['String']>;
};


export type TimeoffMutationsApproveTimeoffLeaveArgs = {
  id: Scalars['Int'];
  source?: InputMaybe<Scalars['String']>;
};


export type TimeoffMutationsBulkAssignEmployeesTimeoffPolicyArgs = {
  employeeIds: Array<Scalars['Int']>;
  mappings: Array<BulkAssignEmployeesTimeoffPolicyMappingsInput>;
  policyId: Scalars['Int'];
};


export type TimeoffMutationsBulkCreateTimeoffCurrentPolicyAssignmentArgs = {
  employeeIds: Array<Scalars['Int']>;
  employeeSelection?: InputMaybe<EmployeesEmployeeSelectorInput>;
  timeoffPolicyId: Scalars['Int'];
};


export type TimeoffMutationsBulkCreateTimeoffLeaveApprovalConditionArgs = {
  conditions: Array<BulkCreateTimeoffLeaveApprovalConditionConditionsInput>;
  leaveApprovalRuleId: Scalars['Int'];
};


export type TimeoffMutationsBulkUpdateTimeoffLeaveApprovalConditionArgs = {
  conditions: Array<BulkUpdateTimeoffLeaveApprovalConditionConditionsInput>;
};


export type TimeoffMutationsCreateTimeoffAllowanceArgs = {
  accruedDenominatorInCents?: InputMaybe<Scalars['Int']>;
  accruedFactorInCents?: InputMaybe<Scalars['Int']>;
  accruedUnitsAvailability: TimeoffAllowancesAccruedUnitsAvailabilityEnum;
  allowanceType: TimeoffAllowanceAllowanceTypeEnum;
  availableDays: TimeoffAllowancesAvailableDaysEnum;
  carryOverUnitsInCents?: InputMaybe<Scalars['Int']>;
  countHolidayAsWorkable: Scalars['Boolean'];
  cycleLength?: InputMaybe<Scalars['Int']>;
  cycleStart: TimeoffCycleStartEnum;
  daysType: TimeoffAllowanceDaysTypeEnum;
  expireInMonths?: InputMaybe<Scalars['Int']>;
  frequency?: InputMaybe<TimeoffAllowancesFrequencyEnum>;
  holidayAllowanceInCents: Scalars['Int'];
  leaveTypeIds: Array<Scalars['Int']>;
  maximumAmountInCents?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  negativeCounterType: TimeoffAllowanceNegativeCounterTypeEnum;
  position?: InputMaybe<Scalars['Int']>;
  prorationType: TimeoffAllowanceProrationTypeEnum;
  ptoProratioEnabled: Scalars['Boolean'];
  rangeType?: InputMaybe<TimeoffAllowancesRangeTypeEnum>;
  rounding: TimeoffAllowanceRoundingsEnum;
  sourceUnits: TimeoffAllowancesSourceUnitsEnum;
  tenurePeriodTransition?: InputMaybe<TimeoffAllowancesTenurePeriodTransitionEnum>;
  tenurePeriods: Array<CreateTimeoffAllowanceTenurePeriodsInput>;
  tenurePeriodsEnabled?: InputMaybe<Scalars['Boolean']>;
  timeoffPolicyId: Scalars['Int'];
  unlimitedAccruedHours: Scalars['Boolean'];
  unlimitedCarryOver: Scalars['Boolean'];
  unlimitedCarryOverExpiration: Scalars['Boolean'];
  unlimitedHolidays: Scalars['Boolean'];
};


export type TimeoffMutationsCreateTimeoffAllowanceIncidenceArgs = {
  _skipNotifications?: InputMaybe<Scalars['Boolean']>;
  daysInCents: Scalars['Int'];
  description?: InputMaybe<Scalars['String']>;
  effectiveOn: Scalars['ISO8601Date'];
  employeeId: Scalars['Int'];
  targetBalance?: InputMaybe<TimeoffAllowanceIncidencesTargetBalanceEnum>;
  timeoffAllowanceId: Scalars['Int'];
};


export type TimeoffMutationsCreateTimeoffBlockedPeriodArgs = {
  companyId: Scalars['Int'];
  leaveTypeIds: Array<Scalars['Int']>;
  name: Scalars['String'];
};


export type TimeoffMutationsCreateTimeoffLeaveArgs = {
  accidentOn?: InputMaybe<Scalars['ISO8601Date']>;
  colegiateNumber?: InputMaybe<Scalars['Int']>;
  delegatedApproverId?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  effectiveOn?: InputMaybe<Scalars['ISO8601Date']>;
  employeeId: Scalars['Int'];
  finishOn?: InputMaybe<Scalars['ISO8601Date']>;
  halfDay?: InputMaybe<Scalars['String']>;
  hasPreviousRelapse?: InputMaybe<Scalars['Boolean']>;
  hoursAmountInCents?: InputMaybe<Scalars['Int']>;
  leaveTypeId?: InputMaybe<Scalars['Int']>;
  medicalDischargeReason?: InputMaybe<Scalars['String']>;
  medicalLeaveType?: InputMaybe<Scalars['Int']>;
  paternityBirthOn?: InputMaybe<Scalars['ISO8601Date']>;
  relapseLeaveId?: InputMaybe<Scalars['Int']>;
  relapseOn?: InputMaybe<Scalars['ISO8601Date']>;
  skipEauCheck?: InputMaybe<Scalars['Boolean']>;
  startOn: Scalars['ISO8601Date'];
  startTime?: InputMaybe<Scalars['String']>;
};


export type TimeoffMutationsCreateTimeoffLeaveApprovalRuleArgs = {
  leaveTypeIds: Array<Scalars['Int']>;
  name: Scalars['String'];
};


export type TimeoffMutationsCreateTimeoffLeaveTypeArgs = {
  accrues: Scalars['Boolean'];
  allowEndless?: InputMaybe<Scalars['Boolean']>;
  approvalRequired: Scalars['Boolean'];
  attachment?: InputMaybe<Scalars['Boolean']>;
  color: Scalars['String'];
  companyId: Scalars['Int'];
  description?: InputMaybe<Scalars['String']>;
  detailsRequired: Scalars['Boolean'];
  editable?: InputMaybe<Scalars['Boolean']>;
  halfDaysUnitsEnabled?: InputMaybe<Scalars['Boolean']>;
  identifier?: InputMaybe<Scalars['String']>;
  isAttachmentMandatory?: InputMaybe<Scalars['Boolean']>;
  maxDaysInCents?: InputMaybe<Scalars['Int']>;
  minDaysInCents?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  payable?: InputMaybe<Scalars['Boolean']>;
  restricted?: InputMaybe<Scalars['Boolean']>;
  visibility?: InputMaybe<Scalars['Boolean']>;
  workable: Scalars['Boolean'];
};


export type TimeoffMutationsCreateTimeoffPolicyArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  main?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
};


export type TimeoffMutationsCreateTimeoffPolicyAssignmentArgs = {
  effectiveAt: Scalars['ISO8601Date'];
  employeeId: Scalars['Int'];
  timeoffPolicyId: Scalars['Int'];
};


export type TimeoffMutationsDeleteTimeoffAllowanceArgs = {
  id: Scalars['Int'];
};


export type TimeoffMutationsDeleteTimeoffAllowanceIncidenceArgs = {
  id: Scalars['Int'];
};


export type TimeoffMutationsDeleteTimeoffBlockedPeriodArgs = {
  id: Scalars['Int'];
};


export type TimeoffMutationsDeleteTimeoffLeaveArgs = {
  id: Scalars['Int'];
};


export type TimeoffMutationsDeleteTimeoffLeaveApprovalRuleArgs = {
  id: Scalars['Int'];
};


export type TimeoffMutationsDeleteTimeoffPolicyArgs = {
  id: Scalars['Int'];
};


export type TimeoffMutationsDeleteTimeoffPolicyAssignmentArgs = {
  id: Scalars['Int'];
};


export type TimeoffMutationsDeleteWithAltAllowanceTimeoffAllowanceArgs = {
  altAllowanceId: Scalars['Int'];
  id: Scalars['Int'];
};


export type TimeoffMutationsRejectTimeoffLeaveArgs = {
  id: Scalars['Int'];
  reason?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
};


export type TimeoffMutationsUpdateInitialTimeoffPolicyAssignmentArgs = {
  effectiveAt: Scalars['ISO8601Date'];
  employeeId: Scalars['Int'];
  timeoffPolicyId: Scalars['Int'];
};


export type TimeoffMutationsUpdateTimeoffAllowanceArgs = {
  accruedDenominatorInCents?: InputMaybe<Scalars['Int']>;
  accruedFactorInCents?: InputMaybe<Scalars['Int']>;
  availableDays?: InputMaybe<TimeoffAllowancesAvailableDaysEnum>;
  carryOverUnitsInCents?: InputMaybe<Scalars['Int']>;
  countHolidayAsWorkable?: InputMaybe<Scalars['Boolean']>;
  daysType?: InputMaybe<TimeoffAllowanceDaysTypeEnum>;
  expireInMonths?: InputMaybe<Scalars['Int']>;
  frequency?: InputMaybe<TimeoffAllowancesFrequencyEnum>;
  holidayAllowanceInCents?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  leaveTypeIds?: InputMaybe<Array<Scalars['Int']>>;
  maximumAmountInCents?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  negativeCounterType?: InputMaybe<TimeoffAllowanceNegativeCounterTypeEnum>;
  position?: InputMaybe<Scalars['Int']>;
  prorationType?: InputMaybe<TimeoffAllowanceProrationTypeEnum>;
  ptoProratioEnabled?: InputMaybe<Scalars['Boolean']>;
  rangeType?: InputMaybe<TimeoffAllowancesRangeTypeEnum>;
  rounding?: InputMaybe<TimeoffAllowanceRoundingsEnum>;
  tenurePeriodTransition?: InputMaybe<TimeoffAllowancesTenurePeriodTransitionEnum>;
  tenurePeriods?: InputMaybe<Array<UpdateTimeoffAllowanceTenurePeriodsInput>>;
  tenurePeriodsEnabled?: InputMaybe<Scalars['Boolean']>;
  unlimitedAccruedHours?: InputMaybe<Scalars['Boolean']>;
  unlimitedCarryOver?: InputMaybe<Scalars['Boolean']>;
  unlimitedCarryOverExpiration?: InputMaybe<Scalars['Boolean']>;
  unlimitedHolidays?: InputMaybe<Scalars['Boolean']>;
};


export type TimeoffMutationsUpdateTimeoffAllowanceIncidenceArgs = {
  daysInCents?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  effectiveOn?: InputMaybe<Scalars['ISO8601Date']>;
  id: Scalars['Int'];
  targetBalance?: InputMaybe<TimeoffAllowanceIncidencesTargetBalanceEnum>;
  timeoffAllowanceId?: InputMaybe<Scalars['Int']>;
};


export type TimeoffMutationsUpdateTimeoffBlockedPeriodArgs = {
  id: Scalars['Int'];
  leaveTypeIds: Array<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  members?: InputMaybe<Array<Scalars['Int']>>;
  name: Scalars['String'];
  query?: InputMaybe<Scalars['String']>;
  strategy: Scalars['String'];
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  timePeriodsAttributes: Array<UpdateTimeoffBlockedPeriodTimePeriodsAttributesInput>;
};


export type TimeoffMutationsUpdateTimeoffLeaveArgs = {
  approved?: InputMaybe<Scalars['Boolean']>;
  delegatedApproverId?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  finishOn?: InputMaybe<Scalars['ISO8601Date']>;
  halfDay?: InputMaybe<Scalars['String']>;
  hoursAmountInCents?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  leaveTypeId?: InputMaybe<Scalars['Int']>;
  medicalLeave?: InputMaybe<Scalars['String']>;
  skipEauCheck?: InputMaybe<Scalars['Boolean']>;
  skipMedicalLeave?: InputMaybe<Scalars['Boolean']>;
  skipNotifications?: InputMaybe<Scalars['Boolean']>;
  skipValidations?: InputMaybe<Scalars['Boolean']>;
  startOn?: InputMaybe<Scalars['ISO8601Date']>;
  startTime?: InputMaybe<Scalars['String']>;
};


export type TimeoffMutationsUpdateTimeoffLeaveApprovalRuleArgs = {
  id: Scalars['Int'];
  leaveTypeIds?: InputMaybe<Array<Scalars['Int']>>;
  name?: InputMaybe<Scalars['String']>;
};


export type TimeoffMutationsUpdateTimeoffLeaveTypeArgs = {
  accrues?: InputMaybe<Scalars['Boolean']>;
  active?: InputMaybe<Scalars['Boolean']>;
  allowEndless?: InputMaybe<Scalars['Boolean']>;
  approvalRequired?: InputMaybe<Scalars['Boolean']>;
  attachment?: InputMaybe<Scalars['Boolean']>;
  color?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  detailsRequired?: InputMaybe<Scalars['Boolean']>;
  halfDaysUnitsEnabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  identifier?: InputMaybe<Scalars['String']>;
  maxDaysInCents?: InputMaybe<Scalars['Int']>;
  minDaysInCents?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  payable?: InputMaybe<Scalars['Boolean']>;
  restricted?: InputMaybe<Scalars['Boolean']>;
  visibility?: InputMaybe<Scalars['Boolean']>;
  workable?: InputMaybe<Scalars['Boolean']>;
};


export type TimeoffMutationsUpdateTimeoffPolicyArgs = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  main?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};


export type TimeoffMutationsUpdateTimeoffPolicyAssignmentArgs = {
  effectiveAt: Scalars['ISO8601Date'];
  id: Scalars['Int'];
  timeoffPolicyId: Scalars['Int'];
};

export type Trainings = {
  __typename?: 'trainings';
  _policies: TrainingsContextlessPolicies;
  /** @deprecated Please favor `categoriesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  categories: Array<TrainingsCategory>;
  categoriesConnection: TrainingsCategoryConnection;
  category?: Maybe<TrainingsCategory>;
  categoryMapConfig?: Maybe<TrainingsCategoryMapConfig>;
  categoryMapConfigItem?: Maybe<TrainingsCategoryMapConfigItem>;
  /** @deprecated Please favor `categoryMapConfigItemsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  categoryMapConfigItems: Array<TrainingsCategoryMapConfigItem>;
  categoryMapConfigItemsConnection: TrainingsCategoryMapConfigItemConnection;
  /** @deprecated Please favor `categoryMapConfigsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  categoryMapConfigs: Array<TrainingsCategoryMapConfig>;
  categoryMapConfigsConnection: TrainingsCategoryMapConfigConnection;
  completionConfiguration?: Maybe<TrainingsCompletionConfiguration>;
  /** @deprecated Please favor `completionConfigurationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  completionConfigurations: Array<TrainingsCompletionConfiguration>;
  completionConfigurationsConnection: TrainingsCompletionConfigurationConnection;
  contentBlock?: Maybe<TrainingsContentBlock>;
  contentBlockPage?: Maybe<TrainingsContentBlockPage>;
  /** @deprecated Please favor `contentBlockPagesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  contentBlockPages: Array<TrainingsContentBlockPage>;
  contentBlockPagesConnection: TrainingsContentBlockPageConnection;
  contentBlockQuiz?: Maybe<TrainingsContentBlockQuiz>;
  /** @deprecated Please favor `contentBlockQuizzesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  contentBlockQuizzes: Array<TrainingsContentBlockQuiz>;
  contentBlockQuizzesConnection: TrainingsContentBlockQuizConnection;
  contentBlockVideo?: Maybe<TrainingsContentBlockVideo>;
  /** @deprecated Please favor `contentBlockVideosConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  contentBlockVideos: Array<TrainingsContentBlockVideo>;
  contentBlockVideosConnection: TrainingsContentBlockVideoConnection;
  /** @deprecated Please favor `contentBlocksConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  contentBlocks: Array<TrainingsContentBlock>;
  contentBlocksConnection: TrainingsContentBlockConnection;
  contentModule?: Maybe<TrainingsContentModule>;
  /** @deprecated Please favor `contentModulesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  contentModules: Array<TrainingsContentModule>;
  contentModulesConnection: TrainingsContentModuleConnection;
  /** @deprecated Please favor `employeeRelatorioUnicoFieldsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  employeeRelatorioUnicoFields: Array<TrainingsEmployeeRelatorioUnicoField>;
  employeeRelatorioUnicoFieldsConnection: TrainingsEmployeeRelatorioUnicoFieldConnection;
  /** @deprecated Please favor `employeesGrossSalaryHoursConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  employeesGrossSalaryHours: Array<TrainingsEmployeesGrossSalaryHour>;
  employeesGrossSalaryHoursConnection: TrainingsEmployeesGrossSalaryHourConnection;
  fundaeFinishGroup?: Maybe<TrainingsFundaeFinishGroup>;
  /** @deprecated Please favor `fundaeFinishGroupsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  fundaeFinishGroups: Array<TrainingsFundaeFinishGroup>;
  fundaeFinishGroupsConnection: TrainingsFundaeFinishGroupConnection;
  /** @deprecated Please favor `insightsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  insights: Array<TrainingsInsight>;
  insightsConnection: TrainingsInsightConnection;
  learningPlatform?: Maybe<TrainingsLearningPlatform>;
  /** @deprecated Please favor `learningPlatformsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  learningPlatforms: Array<TrainingsLearningPlatform>;
  learningPlatformsConnection: TrainingsLearningPlatformConnection;
  reminder?: Maybe<TrainingsReminder>;
  /** @deprecated Please favor `remindersConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  reminders: Array<TrainingsReminder>;
  remindersConnection: TrainingsReminderConnection;
  session?: Maybe<TrainingsSession>;
  sessionAccessMembership?: Maybe<TrainingsSessionAccessMembership>;
  /** @deprecated Please favor `sessionAccessMembershipsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  sessionAccessMemberships: Array<TrainingsSessionAccessMembership>;
  sessionAccessMembershipsConnection: TrainingsSessionAccessMembershipConnection;
  sessionAttendance?: Maybe<TrainingsSessionAttendance>;
  /** @deprecated Please favor `sessionAttendancesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  sessionAttendances: Array<TrainingsSessionAttendance>;
  sessionAttendancesConnection: TrainingsSessionAttendanceConnection;
  sessionFile?: Maybe<TrainingsSessionFile>;
  /** @deprecated Please favor `sessionFilesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  sessionFiles: Array<TrainingsSessionFile>;
  sessionFilesConnection: TrainingsSessionFileConnection;
  sessionInstructor?: Maybe<TrainingsSessionInstructor>;
  /** @deprecated Please favor `sessionInstructorsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  sessionInstructors: Array<TrainingsSessionInstructor>;
  sessionInstructorsConnection: TrainingsSessionInstructorConnection;
  sessionRelatorioUnicoField?: Maybe<TrainingsSessionRelatorioUnicoField>;
  /** @deprecated Please favor `sessionRelatorioUnicoFieldsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  sessionRelatorioUnicoFields: Array<TrainingsSessionRelatorioUnicoField>;
  sessionRelatorioUnicoFieldsConnection: TrainingsSessionRelatorioUnicoFieldConnection;
  /** @deprecated Please favor `sessionsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  sessions: Array<TrainingsSession>;
  sessionsConnection: TrainingsSessionConnection;
  /** @deprecated Please favor `settingsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  settings: Array<TrainingsSetting>;
  settingsConnection: TrainingsSettingConnection;
  training?: Maybe<TrainingsTraining>;
  trainingClass?: Maybe<TrainingsTrainingClass>;
  trainingClassFile?: Maybe<TrainingsTrainingClassFile>;
  /** @deprecated Please favor `trainingClassFilesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  trainingClassFiles: Array<TrainingsTrainingClassFile>;
  trainingClassFilesConnection: TrainingsTrainingClassFileConnection;
  trainingClassFundaeConfiguration?: Maybe<TrainingsTrainingClassFundaeConfiguration>;
  /** @deprecated Please favor `trainingClassFundaeConfigurationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  trainingClassFundaeConfigurations: Array<TrainingsTrainingClassFundaeConfiguration>;
  trainingClassFundaeConfigurationsConnection: TrainingsTrainingClassFundaeConfigurationConnection;
  trainingClassLink?: Maybe<TrainingsTrainingClassLink>;
  /** @deprecated Please favor `trainingClassLinksConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  trainingClassLinks: Array<TrainingsTrainingClassLink>;
  trainingClassLinksConnection: TrainingsTrainingClassLinkConnection;
  trainingClassMembership?: Maybe<TrainingsTrainingClassMembership>;
  /** @deprecated Please favor `trainingClassMembershipsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  trainingClassMemberships: Array<TrainingsTrainingClassMembership>;
  trainingClassMembershipsConnection: TrainingsTrainingClassMembershipConnection;
  /** @deprecated Please favor `trainingClassesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  trainingClasses: Array<TrainingsTrainingClass>;
  trainingClassesConnection: TrainingsTrainingClassConnection;
  trainingFile?: Maybe<TrainingsTrainingFile>;
  /** @deprecated Please favor `trainingFilesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  trainingFiles: Array<TrainingsTrainingFile>;
  trainingFilesConnection: TrainingsTrainingFileConnection;
  trainingLink?: Maybe<TrainingsTrainingLink>;
  /** @deprecated Please favor `trainingLinksConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  trainingLinks: Array<TrainingsTrainingLink>;
  trainingLinksConnection: TrainingsTrainingLinkConnection;
  trainingMembership?: Maybe<TrainingsTrainingMembership>;
  /** @deprecated Please favor `trainingMembershipFilesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  trainingMembershipFiles: Array<TrainingsTrainingMembershipFile>;
  trainingMembershipFilesConnection: TrainingsTrainingMembershipFileConnection;
  /** @deprecated Please favor `trainingMembershipsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  trainingMemberships: Array<TrainingsTrainingMembership>;
  trainingMembershipsConnection: TrainingsTrainingMembershipConnection;
  /** @deprecated Please favor `trainingRelatorioUnicoFieldsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  trainingRelatorioUnicoFields: Array<TrainingsTrainingRelatorioUnicoField>;
  trainingRelatorioUnicoFieldsConnection: TrainingsTrainingRelatorioUnicoFieldConnection;
  trainingRequest?: Maybe<TrainingsTrainingRequest>;
  /** @deprecated Please favor `trainingRequestsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  trainingRequests: Array<TrainingsTrainingRequest>;
  trainingRequestsConnection: TrainingsTrainingRequestConnection;
  /** @deprecated Please favor `trainingsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  trainings: Array<TrainingsTraining>;
  trainingsConnection: TrainingsTrainingConnection;
};


export type TrainingsCategoriesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type TrainingsCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<TrainingsCategoryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type TrainingsCategoryArgs = {
  id: Scalars['Int'];
};


export type TrainingsCategoryMapConfigArgs = {
  id: Scalars['Int'];
};


export type TrainingsCategoryMapConfigItemArgs = {
  id: Scalars['Int'];
};


export type TrainingsCategoryMapConfigItemsArgs = {
  categoryMapConfigId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type TrainingsCategoryMapConfigItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  categoryMapConfigId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type TrainingsCategoryMapConfigsArgs = {
  category?: InputMaybe<TrainingsCategoryMapConfigCategoryEnum>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type TrainingsCategoryMapConfigsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<TrainingsCategoryMapConfigCategoryEnum>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type TrainingsCompletionConfigurationArgs = {
  id: Scalars['Int'];
};


export type TrainingsCompletionConfigurationsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  trainingIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type TrainingsCompletionConfigurationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  trainingIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type TrainingsContentBlockArgs = {
  id: Scalars['Int'];
};


export type TrainingsContentBlockPageArgs = {
  id: Scalars['Int'];
};


export type TrainingsContentBlockPagesArgs = {
  contentModuleIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type TrainingsContentBlockPagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  contentModuleIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type TrainingsContentBlockQuizArgs = {
  id: Scalars['Int'];
};


export type TrainingsContentBlockQuizzesArgs = {
  contentModuleIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type TrainingsContentBlockQuizzesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  contentModuleIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type TrainingsContentBlockVideoArgs = {
  id: Scalars['Int'];
};


export type TrainingsContentBlockVideosArgs = {
  contentModuleIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type TrainingsContentBlockVideosConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  contentModuleIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type TrainingsContentBlocksArgs = {
  contentModuleIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type TrainingsContentBlocksConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  contentModuleIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type TrainingsContentModuleArgs = {
  id: Scalars['Int'];
};


export type TrainingsContentModulesArgs = {
  employeeId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  trainingIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type TrainingsContentModulesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  trainingIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type TrainingsEmployeeRelatorioUnicoFieldsArgs = {
  employeeId: Scalars['Int'];
};


export type TrainingsEmployeeRelatorioUnicoFieldsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type TrainingsEmployeesGrossSalaryHoursArgs = {
  employeeSelection: EmployeesEmployeeSelectorInput;
  hours: Array<EmployeesGrossSalaryHoursHoursInput>;
};


export type TrainingsEmployeesGrossSalaryHoursConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeSelection: EmployeesEmployeeSelectorInput;
  first?: InputMaybe<Scalars['Int']>;
  hours: Array<EmployeesGrossSalaryHoursHoursInput>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type TrainingsFundaeFinishGroupArgs = {
  id: Scalars['Int'];
  trainingClassId: Scalars['Int'];
};


export type TrainingsFundaeFinishGroupsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  missingData?: Scalars['Boolean'];
  search?: InputMaybe<Scalars['String']>;
  trainingClassId: Scalars['Int'];
};


export type TrainingsFundaeFinishGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<TrainingsFundaeFinishGroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  missingData?: Scalars['Boolean'];
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  trainingClassId: Scalars['Int'];
};


export type TrainingsInsightsArgs = {
  from?: InputMaybe<Scalars['ISO8601Date']>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  to?: InputMaybe<Scalars['ISO8601Date']>;
  trainingClassesIds?: InputMaybe<Array<Scalars['Int']>>;
  trainingIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type TrainingsInsightsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['ISO8601Date']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  to?: InputMaybe<Scalars['ISO8601Date']>;
  trainingClassesIds?: InputMaybe<Array<Scalars['Int']>>;
  trainingIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type TrainingsLearningPlatformArgs = {
  id: Scalars['Int'];
  trainingId: Scalars['Int'];
};


export type TrainingsLearningPlatformsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  trainingId: Scalars['Int'];
};


export type TrainingsLearningPlatformsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  trainingId: Scalars['Int'];
};


export type TrainingsReminderArgs = {
  id: Scalars['Int'];
  sessionId: Scalars['Int'];
};


export type TrainingsRemindersArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  sessionId: Scalars['Int'];
};


export type TrainingsRemindersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sessionId: Scalars['Int'];
  sortOrder?: InputMaybe<Sort>;
};


export type TrainingsSessionArgs = {
  id: Scalars['Int'];
};


export type TrainingsSessionAccessMembershipArgs = {
  id: Scalars['Int'];
  sessionId: Scalars['Int'];
};


export type TrainingsSessionAccessMembershipsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  sessionId: Scalars['Int'];
  status?: InputMaybe<Array<Scalars['String']>>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type TrainingsSessionAccessMembershipsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<TrainingsSessionAccessMembershipFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sessionId: Scalars['Int'];
  sortOrder?: InputMaybe<Sort>;
  status?: InputMaybe<Array<Scalars['String']>>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type TrainingsSessionAttendanceArgs = {
  id: Scalars['Int'];
};


export type TrainingsSessionAttendancesArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  sessionAccessMembershipIds?: InputMaybe<Array<Scalars['Int']>>;
  sessionId?: InputMaybe<Scalars['Int']>;
};


export type TrainingsSessionAttendancesConnectionArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sessionAccessMembershipIds?: InputMaybe<Array<Scalars['Int']>>;
  sessionId?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type TrainingsSessionFileArgs = {
  id: Scalars['Int'];
};


export type TrainingsSessionFilesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  sessionId?: InputMaybe<Scalars['Int']>;
  trainingId?: InputMaybe<Scalars['Int']>;
  visibility?: InputMaybe<Scalars['Boolean']>;
};


export type TrainingsSessionFilesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sessionId?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  trainingId?: InputMaybe<Scalars['Int']>;
  visibility?: InputMaybe<Scalars['Boolean']>;
};


export type TrainingsSessionInstructorArgs = {
  id: Scalars['String'];
};


export type TrainingsSessionInstructorsArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  employeeId?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  sessionId?: InputMaybe<Scalars['String']>;
};


export type TrainingsSessionInstructorsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  employeeId?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sessionId?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
};


export type TrainingsSessionRelatorioUnicoFieldArgs = {
  id: Scalars['Int'];
};


export type TrainingsSessionRelatorioUnicoFieldsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  sessionIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type TrainingsSessionRelatorioUnicoFieldsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sessionIds?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<Sort>;
};


export type TrainingsSessionsArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  active?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  modality?: InputMaybe<Scalars['String']>;
  next?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  startAfter?: InputMaybe<Scalars['String']>;
  startBefore?: InputMaybe<Scalars['String']>;
  startsAt?: InputMaybe<Array<Scalars['String']>>;
  trainingClassIds?: InputMaybe<Array<Scalars['String']>>;
  trainingId?: InputMaybe<Scalars['Int']>;
  trainingIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type TrainingsSessionsConnectionArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<TrainingsSessionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  modality?: InputMaybe<Scalars['String']>;
  next?: InputMaybe<Scalars['Boolean']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  startAfter?: InputMaybe<Scalars['String']>;
  startBefore?: InputMaybe<Scalars['String']>;
  startsAt?: InputMaybe<Array<Scalars['String']>>;
  trainingClassIds?: InputMaybe<Array<Scalars['String']>>;
  trainingId?: InputMaybe<Scalars['Int']>;
  trainingIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type TrainingsSettingsArgs = {
  companyId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
};


export type TrainingsSettingsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type TrainingsTrainingArgs = {
  id: Scalars['Int'];
};


export type TrainingsTrainingClassArgs = {
  id: Scalars['Int'];
};


export type TrainingsTrainingClassFileArgs = {
  id: Scalars['Int'];
};


export type TrainingsTrainingClassFilesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  trainingClassIds?: InputMaybe<Array<Scalars['String']>>;
  trainingIds?: InputMaybe<Array<Scalars['Int']>>;
  visibility?: InputMaybe<Scalars['Boolean']>;
};


export type TrainingsTrainingClassFilesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  trainingClassIds?: InputMaybe<Array<Scalars['String']>>;
  trainingIds?: InputMaybe<Array<Scalars['Int']>>;
  visibility?: InputMaybe<Scalars['Boolean']>;
};


export type TrainingsTrainingClassFundaeConfigurationArgs = {
  id: Scalars['Int'];
};


export type TrainingsTrainingClassFundaeConfigurationsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type TrainingsTrainingClassFundaeConfigurationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type TrainingsTrainingClassLinkArgs = {
  id: Scalars['Int'];
};


export type TrainingsTrainingClassLinksArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  trainingClassId?: InputMaybe<Scalars['Int']>;
  url?: InputMaybe<Scalars['String']>;
};


export type TrainingsTrainingClassLinksConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  title?: InputMaybe<Scalars['String']>;
  trainingClassId?: InputMaybe<Scalars['Int']>;
  url?: InputMaybe<Scalars['String']>;
};


export type TrainingsTrainingClassMembershipArgs = {
  id: Scalars['Int'];
};


export type TrainingsTrainingClassMembershipsArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  trainingClassId?: InputMaybe<Scalars['Int']>;
  trainingClassIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type TrainingsTrainingClassMembershipsConnectionArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<TrainingsTrainingClassMembershipFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  trainingClassId?: InputMaybe<Scalars['Int']>;
  trainingClassIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type TrainingsTrainingClassesArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  endDate?: InputMaybe<Array<Scalars['ISO8601Date']>>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Array<Scalars['ISO8601Date']>>;
  trainingId?: InputMaybe<Scalars['Int']>;
};


export type TrainingsTrainingClassesConnectionArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Array<Scalars['ISO8601Date']>>;
  filter?: InputMaybe<TrainingsTrainingClassFilter>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  startDate?: InputMaybe<Array<Scalars['ISO8601Date']>>;
  trainingId?: InputMaybe<Scalars['Int']>;
};


export type TrainingsTrainingFileArgs = {
  id: Scalars['Int'];
  trainingId: Scalars['Int'];
};


export type TrainingsTrainingFilesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  trainingId: Scalars['Int'];
  visibility?: InputMaybe<Scalars['Boolean']>;
};


export type TrainingsTrainingFilesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  trainingId: Scalars['Int'];
  visibility?: InputMaybe<Scalars['Boolean']>;
};


export type TrainingsTrainingLinkArgs = {
  id: Scalars['Int'];
};


export type TrainingsTrainingLinksArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  trainingId?: InputMaybe<Scalars['Int']>;
  url?: InputMaybe<Scalars['String']>;
};


export type TrainingsTrainingLinksConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  title?: InputMaybe<Scalars['String']>;
  trainingId?: InputMaybe<Scalars['Int']>;
  url?: InputMaybe<Scalars['String']>;
};


export type TrainingsTrainingMembershipArgs = {
  id: Scalars['Int'];
  trainingId: Scalars['Int'];
};


export type TrainingsTrainingMembershipFilesArgs = {
  trainingMembershipIds: Array<Scalars['Int']>;
};


export type TrainingsTrainingMembershipFilesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  trainingMembershipIds: Array<Scalars['Int']>;
};


export type TrainingsTrainingMembershipsArgs = {
  classId?: InputMaybe<Scalars['Int']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  teamId?: InputMaybe<Scalars['Int']>;
  trainingId: Scalars['Int'];
};


export type TrainingsTrainingMembershipsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  classId?: InputMaybe<Scalars['Int']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<TrainingsTrainingMembershipFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  status?: InputMaybe<Scalars['String']>;
  teamId?: InputMaybe<Scalars['Int']>;
  trainingId: Scalars['Int'];
};


export type TrainingsTrainingRelatorioUnicoFieldsArgs = {
  trainingId?: InputMaybe<Scalars['Int']>;
};


export type TrainingsTrainingRelatorioUnicoFieldsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  trainingId?: InputMaybe<Scalars['Int']>;
};


export type TrainingsTrainingRequestArgs = {
  id: Scalars['Int'];
};


export type TrainingsTrainingRequestsArgs = {
  allowdrafts?: Scalars['Boolean'];
  authorId?: InputMaybe<Scalars['Int']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  employeesOrAuthor?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<TrainingsTrainingRequestStatusEnum>;
};


export type TrainingsTrainingRequestsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  allowdrafts?: Scalars['Boolean'];
  authorId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  employeesOrAuthor?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TrainingsTrainingRequestFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  status?: InputMaybe<TrainingsTrainingRequestStatusEnum>;
};


export type TrainingsTrainingsArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  catalog?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  isMandatory?: InputMaybe<Scalars['Boolean']>;
  onlyAssigned?: InputMaybe<Scalars['Boolean']>;
  returnExpiredMemberships?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  withCurrentTrainingClasses?: InputMaybe<Scalars['Boolean']>;
  withExpiredMemberships?: InputMaybe<Scalars['Boolean']>;
};


export type TrainingsTrainingsConnectionArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  catalog?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TrainingsTrainingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  isMandatory?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyAssigned?: InputMaybe<Scalars['Boolean']>;
  returnExpiredMemberships?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  status?: InputMaybe<Scalars['String']>;
  withCurrentTrainingClasses?: InputMaybe<Scalars['Boolean']>;
  withExpiredMemberships?: InputMaybe<Scalars['Boolean']>;
};

export type TrainingsMutations = {
  __typename?: 'trainingsMutations';
  approveTrainingsTrainingRequest: ApproveTrainingsTrainingRequestPayload;
  bulkAssignTrainingsTrainingClassMembership: BulkAssignTrainingsTrainingClassMembershipPayload;
  bulkCreateTrainingsSessionAccessMembership: BulkCreateTrainingsSessionAccessMembershipPayload;
  bulkCreateTrainingsSessionInstructor: BulkCreateTrainingsSessionInstructorPayload;
  bulkCreateTrainingsTrainingClassMembership: BulkCreateTrainingsTrainingClassMembershipPayload;
  bulkCreateTrainingsTrainingMembership: BulkCreateTrainingsTrainingMembershipPayload;
  bulkCreateTrainingsTrainingMembershipFile: BulkCreateTrainingsTrainingMembershipFilePayload;
  bulkDeleteTrainingsSessionInstructor: BulkDeleteTrainingsSessionInstructorPayload;
  bulkDeleteTrainingsTraining: BulkDeleteTrainingsTrainingPayload;
  bulkDeleteTrainingsTrainingClassMembership: BulkDeleteTrainingsTrainingClassMembershipPayload;
  bulkDestroyTrainingsSessionAccessMembership: BulkDestroyTrainingsSessionAccessMembershipPayload;
  bulkDestroyTrainingsTrainingMembership: BulkDestroyTrainingsTrainingMembershipPayload;
  bulkUpdateCatalogTrainingsTraining: BulkUpdateCatalogTrainingsTrainingPayload;
  bulkUpdateTrainingsSessionAttendance: BulkUpdateTrainingsSessionAttendancePayload;
  bulkUpdateTrainingsSessionInstructor: BulkUpdateTrainingsSessionInstructorPayload;
  createFromTemplateTrainingsTrainingMembershipFile: CreateFromTemplateTrainingsTrainingMembershipFilePayload;
  createTrainingsCategory: CreateTrainingsCategoryPayload;
  createTrainingsCategoryMapConfig: CreateTrainingsCategoryMapConfigPayload;
  createTrainingsCategoryMapConfigItem: CreateTrainingsCategoryMapConfigItemPayload;
  createTrainingsCompletionConfiguration: CreateTrainingsCompletionConfigurationPayload;
  createTrainingsContentBlockProgress: CreateTrainingsContentBlockProgressPayload;
  createTrainingsEmployeeRelatorioUnicoField: CreateTrainingsEmployeeRelatorioUnicoFieldPayload;
  createTrainingsLearningPlatform: CreateTrainingsLearningPlatformPayload;
  createTrainingsReminder: CreateTrainingsReminderPayload;
  createTrainingsSession: CreateTrainingsSessionPayload;
  createTrainingsSessionFile: CreateTrainingsSessionFilePayload;
  createTrainingsSessionRelatorioUnicoField: CreateTrainingsSessionRelatorioUnicoFieldPayload;
  createTrainingsSetting: CreateTrainingsSettingPayload;
  createTrainingsTraining: CreateTrainingsTrainingPayload;
  createTrainingsTrainingClass: CreateTrainingsTrainingClassPayload;
  createTrainingsTrainingClassFile: CreateTrainingsTrainingClassFilePayload;
  createTrainingsTrainingClassLink: CreateTrainingsTrainingClassLinkPayload;
  createTrainingsTrainingFile: CreateTrainingsTrainingFilePayload;
  createTrainingsTrainingLink: CreateTrainingsTrainingLinkPayload;
  createTrainingsTrainingRelatorioUnicoField: CreateTrainingsTrainingRelatorioUnicoFieldPayload;
  createTrainingsTrainingRequest: CreateTrainingsTrainingRequestPayload;
  deleteTrainingsCategory: DeleteTrainingsCategoryPayload;
  deleteTrainingsCategoryMapConfigItem: DeleteTrainingsCategoryMapConfigItemPayload;
  deleteTrainingsLearningPlatform: DeleteTrainingsLearningPlatformPayload;
  deleteTrainingsReminder: DeleteTrainingsReminderPayload;
  deleteTrainingsSession: DeleteTrainingsSessionPayload;
  deleteTrainingsSessionFile: DeleteTrainingsSessionFilePayload;
  deleteTrainingsTraining: DeleteTrainingsTrainingPayload;
  deleteTrainingsTrainingClass: DeleteTrainingsTrainingClassPayload;
  deleteTrainingsTrainingClassFile: DeleteTrainingsTrainingClassFilePayload;
  deleteTrainingsTrainingClassLink: DeleteTrainingsTrainingClassLinkPayload;
  deleteTrainingsTrainingFile: DeleteTrainingsTrainingFilePayload;
  deleteTrainingsTrainingLink: DeleteTrainingsTrainingLinkPayload;
  deleteTrainingsTrainingMembershipFile: DeleteTrainingsTrainingMembershipFilePayload;
  deleteTrainingsTrainingRequest: DeleteTrainingsTrainingRequestPayload;
  duplicateTrainingsTraining: DuplicateTrainingsTrainingPayload;
  duplicateTrainingsTrainingClass: DuplicateTrainingsTrainingClassPayload;
  exportTrainingsFundaeFinishGroup: ExportTrainingsFundaeFinishGroupPayload;
  processContentTrainingsTraining: ProcessContentTrainingsTrainingPayload;
  rejectTrainingsTrainingRequest: RejectTrainingsTrainingRequestPayload;
  toggleVisibilityTrainingsSessionFile: ToggleVisibilityTrainingsSessionFilePayload;
  toggleVisibilityTrainingsTrainingClassFile: ToggleVisibilityTrainingsTrainingClassFilePayload;
  toggleVisibilityTrainingsTrainingFile: ToggleVisibilityTrainingsTrainingFilePayload;
  trainingsExportTrainingsExport: TrainingsExportTrainingsExportPayload;
  updateBasicInfoTrainingsTraining: UpdateBasicInfoTrainingsTrainingPayload;
  updateInternalInfoTrainingsTraining: UpdateInternalInfoTrainingsTrainingPayload;
  updateStatusTrainingsTraining: UpdateStatusTrainingsTrainingPayload;
  updateTrainingsCategoryMapConfigItem: UpdateTrainingsCategoryMapConfigItemPayload;
  updateTrainingsCompletionConfiguration: UpdateTrainingsCompletionConfigurationPayload;
  updateTrainingsEmployeeRelatorioUnicoField: UpdateTrainingsEmployeeRelatorioUnicoFieldPayload;
  updateTrainingsLearningPlatform: UpdateTrainingsLearningPlatformPayload;
  updateTrainingsSession: UpdateTrainingsSessionPayload;
  updateTrainingsSessionRelatorioUnicoField: UpdateTrainingsSessionRelatorioUnicoFieldPayload;
  updateTrainingsSetting: UpdateTrainingsSettingPayload;
  updateTrainingsTraining: UpdateTrainingsTrainingPayload;
  updateTrainingsTrainingClass: UpdateTrainingsTrainingClassPayload;
  updateTrainingsTrainingMembership: UpdateTrainingsTrainingMembershipPayload;
  updateTrainingsTrainingRelatorioUnicoField: UpdateTrainingsTrainingRelatorioUnicoFieldPayload;
  updateTrainingsTrainingRequest: UpdateTrainingsTrainingRequestPayload;
  upsertSubsidyTrainingsTraining: UpsertSubsidyTrainingsTrainingPayload;
  upsertTrainingsTrainingClassFundaeConfiguration: UpsertTrainingsTrainingClassFundaeConfigurationPayload;
};


export type TrainingsMutationsApproveTrainingsTrainingRequestArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type TrainingsMutationsBulkAssignTrainingsTrainingClassMembershipArgs = {
  accessIds: Array<Scalars['Int']>;
  trainingClassIds: Array<Scalars['Int']>;
};


export type TrainingsMutationsBulkCreateTrainingsSessionAccessMembershipArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  notify: Scalars['Boolean'];
  sessionId: Scalars['Int'];
};


export type TrainingsMutationsBulkCreateTrainingsSessionInstructorArgs = {
  companyId: Scalars['Int'];
  employeeIds: Array<Scalars['String']>;
  sessionId?: InputMaybe<Scalars['String']>;
};


export type TrainingsMutationsBulkCreateTrainingsTrainingClassMembershipArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  companyId: Scalars['Int'];
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  selection?: InputMaybe<EmployeesEmployeeSelectorInput>;
  trainingClassId?: InputMaybe<Scalars['Int']>;
  trainingClassIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type TrainingsMutationsBulkCreateTrainingsTrainingMembershipArgs = {
  employeeIds: Array<Scalars['Int']>;
  selection?: InputMaybe<EmployeesEmployeeSelectorInput>;
  trainingId: Scalars['Int'];
};


export type TrainingsMutationsBulkCreateTrainingsTrainingMembershipFileArgs = {
  authorId: Scalars['Int'];
  companyId: Scalars['Int'];
  files: Array<Scalars['File']>;
  trainingId?: InputMaybe<Scalars['Int']>;
  trainingMembershipId: Scalars['Int'];
};


export type TrainingsMutationsBulkDeleteTrainingsSessionInstructorArgs = {
  ids: Array<Scalars['String']>;
};


export type TrainingsMutationsBulkDeleteTrainingsTrainingArgs = {
  ids: Array<Scalars['Int']>;
};


export type TrainingsMutationsBulkDeleteTrainingsTrainingClassMembershipArgs = {
  ids: Array<Scalars['Int']>;
  trainingClassId: Scalars['Int'];
};


export type TrainingsMutationsBulkDestroyTrainingsSessionAccessMembershipArgs = {
  ids: Array<Scalars['Int']>;
  notify: Scalars['Boolean'];
};


export type TrainingsMutationsBulkDestroyTrainingsTrainingMembershipArgs = {
  ids: Array<Scalars['Int']>;
};


export type TrainingsMutationsBulkUpdateCatalogTrainingsTrainingArgs = {
  catalog: Scalars['Boolean'];
  ids: Array<Scalars['Int']>;
};


export type TrainingsMutationsBulkUpdateTrainingsSessionAttendanceArgs = {
  ids: Array<Scalars['Int']>;
  status: Scalars['String'];
};


export type TrainingsMutationsBulkUpdateTrainingsSessionInstructorArgs = {
  companyId: Scalars['Int'];
  employeeIds: Array<Scalars['String']>;
  sessionId: Scalars['String'];
};


export type TrainingsMutationsCreateFromTemplateTrainingsTrainingMembershipFileArgs = {
  authorId: Scalars['Int'];
  companyId: Scalars['Int'];
  documentTemplateId: Scalars['Int'];
  employeeId: Scalars['Int'];
  folderId: Scalars['Int'];
  signeeIds: Array<Scalars['Int']>;
  trainingMembershipId: Scalars['Int'];
};


export type TrainingsMutationsCreateTrainingsCategoryArgs = {
  companyId: Scalars['Int'];
  name: Scalars['String'];
};


export type TrainingsMutationsCreateTrainingsCategoryMapConfigArgs = {
  category: TrainingsCategoryMapConfigCategoryEnum;
  companyId: Scalars['Int'];
};


export type TrainingsMutationsCreateTrainingsCategoryMapConfigItemArgs = {
  categoryMapConfigId: Scalars['Int'];
  companyId: Scalars['Int'];
  fieldId: Scalars['Int'];
  fieldType: Scalars['String'];
  value: Scalars['String'];
};


export type TrainingsMutationsCreateTrainingsCompletionConfigurationArgs = {
  attendancePercentage?: InputMaybe<Scalars['Int']>;
  companyId: Scalars['Int'];
  knowledgeTestRequired: Scalars['Boolean'];
  moduleCompletedPercentage?: InputMaybe<Scalars['Int']>;
  trainingId: Scalars['Int'];
};


export type TrainingsMutationsCreateTrainingsContentBlockProgressArgs = {
  contentBlockId: Scalars['Int'];
  employeeId: Scalars['Int'];
};


export type TrainingsMutationsCreateTrainingsEmployeeRelatorioUnicoFieldArgs = {
  employeeId: Scalars['Int'];
  retirementRegimeApplied?: InputMaybe<Scalars['String']>;
};


export type TrainingsMutationsCreateTrainingsLearningPlatformArgs = {
  companyId: Scalars['Int'];
  duration?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  link: Scalars['String'];
  name: Scalars['String'];
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  trainingId: Scalars['Int'];
};


export type TrainingsMutationsCreateTrainingsReminderArgs = {
  content?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  scheduledAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  sessionId?: InputMaybe<Scalars['Int']>;
  timeframe?: InputMaybe<TrainingsReminderTimeframeEnum>;
};


export type TrainingsMutationsCreateTrainingsSessionArgs = {
  description?: InputMaybe<Scalars['String']>;
  dueDate?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['String']>;
  endsAt?: InputMaybe<Scalars['String']>;
  frequency?: InputMaybe<TrainingsSessionFrequencyEnum>;
  link?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  modality?: InputMaybe<TrainingsSessionModalityEnum>;
  name: Scalars['String'];
  recurrent?: InputMaybe<Scalars['Boolean']>;
  reminders?: InputMaybe<Array<CreateTrainingsSessionRemindersInput>>;
  schedule?: InputMaybe<TrainingsSessionScheduleEnum>;
  sessionInstructors?: InputMaybe<CreateTrainingsSessionSessionInstructorsInput>;
  startsAt?: InputMaybe<Scalars['String']>;
  subsidized?: InputMaybe<Scalars['Boolean']>;
  trainingClassId?: InputMaybe<Scalars['Int']>;
  trainingId: Scalars['Int'];
};


export type TrainingsMutationsCreateTrainingsSessionFileArgs = {
  authorId: Scalars['Int'];
  file: Scalars['File'];
  sessionId: Scalars['Int'];
  title?: InputMaybe<Scalars['String']>;
  visibility?: InputMaybe<Scalars['Boolean']>;
};


export type TrainingsMutationsCreateTrainingsSessionRelatorioUnicoFieldArgs = {
  sessionId: Scalars['Int'];
  trainingSchedule?: InputMaybe<Scalars['String']>;
};


export type TrainingsMutationsCreateTrainingsSettingArgs = {
  companyId: Scalars['Int'];
  relatorioEnabled?: InputMaybe<Scalars['Boolean']>;
  trainingRequestsEnabled?: InputMaybe<Scalars['Boolean']>;
};


export type TrainingsMutationsCreateTrainingsTrainingArgs = {
  attachments: Array<CreateTrainingsTrainingAttachmentsInput>;
  authorId?: InputMaybe<Scalars['Int']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']>>;
  code?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  competencyIds?: InputMaybe<Array<Scalars['Int']>>;
  completionConfiguration?: InputMaybe<CreateTrainingsTrainingCompletionConfigurationInput>;
  cost?: InputMaybe<Scalars['Int']>;
  costDecimal?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  employeeId?: InputMaybe<Scalars['Int']>;
  external: Scalars['Boolean'];
  externalProvider?: InputMaybe<Scalars['String']>;
  isMandatory?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  objectives?: InputMaybe<Scalars['String']>;
  subsidizedCost?: InputMaybe<Scalars['Int']>;
  subsidizedCostDecimal?: InputMaybe<Scalars['String']>;
  thumbnail?: InputMaybe<Scalars['File']>;
  totalDuration?: InputMaybe<Scalars['Float']>;
  validFor?: InputMaybe<Scalars['Int']>;
  year: Scalars['Int'];
};


export type TrainingsMutationsCreateTrainingsTrainingClassArgs = {
  attachments: Array<CreateTrainingsTrainingClassAttachmentsInput>;
  authorId: Scalars['Int'];
  companyId: Scalars['Int'];
  cost?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  endDate: Scalars['ISO8601Date'];
  fundaeConfiguration?: InputMaybe<TrainingsTrainingClassFundaeConfigurationInput>;
  indirectCost?: InputMaybe<Scalars['String']>;
  learningPlatformId?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<TrainingsTrainingClassModalityEnum>;
  name?: InputMaybe<Scalars['String']>;
  salaryCost?: InputMaybe<Scalars['String']>;
  selection?: InputMaybe<EmployeesEmployeeSelectorInput>;
  startDate: Scalars['ISO8601Date'];
  subsidizedCost?: InputMaybe<Scalars['String']>;
  trainingId: Scalars['Int'];
  trainingSessions: Array<CreateTrainingsTrainingClassTrainingSessionsInput>;
};


export type TrainingsMutationsCreateTrainingsTrainingClassFileArgs = {
  authorId: Scalars['Int'];
  file?: InputMaybe<Scalars['File']>;
  signedId?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  trainingClassId: Scalars['Int'];
  visibility?: InputMaybe<Scalars['Boolean']>;
};


export type TrainingsMutationsCreateTrainingsTrainingClassLinkArgs = {
  authorId: Scalars['Int'];
  companyId: Scalars['Int'];
  title: Scalars['String'];
  trainingClassId: Scalars['Int'];
  url: Scalars['String'];
};


export type TrainingsMutationsCreateTrainingsTrainingFileArgs = {
  authorId: Scalars['Int'];
  file?: InputMaybe<Scalars['File']>;
  signedId?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  trainingId: Scalars['Int'];
  visibility?: InputMaybe<Scalars['Boolean']>;
};


export type TrainingsMutationsCreateTrainingsTrainingLinkArgs = {
  authorId: Scalars['Int'];
  companyId?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
  trainingId: Scalars['Int'];
  url: Scalars['String'];
};


export type TrainingsMutationsCreateTrainingsTrainingRelatorioUnicoFieldArgs = {
  certificateType?: InputMaybe<Scalars['String']>;
  educationArea?: InputMaybe<Scalars['String']>;
  qualificationLevel?: InputMaybe<Scalars['String']>;
  trainingEntity?: InputMaybe<Scalars['String']>;
  trainingId: Scalars['Int'];
  trainingInitiative?: InputMaybe<Scalars['String']>;
  trainingModality?: InputMaybe<Scalars['String']>;
};


export type TrainingsMutationsCreateTrainingsTrainingRequestArgs = {
  authorId?: InputMaybe<Scalars['Int']>;
  comments?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  competencyIds: Array<Scalars['Int']>;
  cost?: InputMaybe<Scalars['Float']>;
  costToEmployee?: InputMaybe<Scalars['Float']>;
  duration?: InputMaybe<Scalars['Float']>;
  employeeIds: Array<Scalars['Int']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  externalReference?: InputMaybe<Scalars['String']>;
  paymentInstallments?: InputMaybe<Scalars['Int']>;
  providerName?: InputMaybe<Scalars['String']>;
  schedule?: InputMaybe<TrainingsTrainingRequestScheduleEnum>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  status: TrainingsTrainingRequestStatusEnum;
  subsidized: Scalars['Boolean'];
  targetStrategy?: InputMaybe<PerformanceTargetStrategySupportedStrategiesEnum>;
  trainingId?: InputMaybe<Scalars['Int']>;
  trainingName?: InputMaybe<Scalars['String']>;
  trainingNeed?: InputMaybe<Scalars['String']>;
};


export type TrainingsMutationsDeleteTrainingsCategoryArgs = {
  id: Scalars['Int'];
};


export type TrainingsMutationsDeleteTrainingsCategoryMapConfigItemArgs = {
  id: Scalars['Int'];
};


export type TrainingsMutationsDeleteTrainingsLearningPlatformArgs = {
  id: Scalars['Int'];
};


export type TrainingsMutationsDeleteTrainingsReminderArgs = {
  id: Scalars['Int'];
};


export type TrainingsMutationsDeleteTrainingsSessionArgs = {
  id: Scalars['Int'];
  updateStrategy?: InputMaybe<TrainingsSessionUpdateStrategyEnum>;
};


export type TrainingsMutationsDeleteTrainingsSessionFileArgs = {
  id: Scalars['Int'];
};


export type TrainingsMutationsDeleteTrainingsTrainingArgs = {
  id: Scalars['Int'];
};


export type TrainingsMutationsDeleteTrainingsTrainingClassArgs = {
  id: Scalars['Int'];
};


export type TrainingsMutationsDeleteTrainingsTrainingClassFileArgs = {
  id: Scalars['Int'];
};


export type TrainingsMutationsDeleteTrainingsTrainingClassLinkArgs = {
  id: Scalars['Int'];
};


export type TrainingsMutationsDeleteTrainingsTrainingFileArgs = {
  id: Scalars['Int'];
};


export type TrainingsMutationsDeleteTrainingsTrainingLinkArgs = {
  id: Scalars['Int'];
};


export type TrainingsMutationsDeleteTrainingsTrainingMembershipFileArgs = {
  id: Scalars['Int'];
};


export type TrainingsMutationsDeleteTrainingsTrainingRequestArgs = {
  id: Scalars['Int'];
};


export type TrainingsMutationsDuplicateTrainingsTrainingArgs = {
  basicInfo?: InputMaybe<Scalars['Boolean']>;
  classFiles?: InputMaybe<Scalars['Boolean']>;
  employees?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  sessions?: InputMaybe<Scalars['Boolean']>;
  surveys?: InputMaybe<Scalars['Boolean']>;
  trainingFiles?: InputMaybe<Scalars['Boolean']>;
};


export type TrainingsMutationsDuplicateTrainingsTrainingClassArgs = {
  classFiles?: InputMaybe<Scalars['Boolean']>;
  costs?: InputMaybe<Scalars['Boolean']>;
  employees?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['ISO8601Date'];
  id: Scalars['Int'];
  name: Scalars['String'];
  sessions?: InputMaybe<Scalars['Boolean']>;
  startDate: Scalars['ISO8601Date'];
};


export type TrainingsMutationsExportTrainingsFundaeFinishGroupArgs = {
  authorId: Scalars['Int'];
  trainingClassId: Scalars['Int'];
};


export type TrainingsMutationsProcessContentTrainingsTrainingArgs = {
  authorId: Scalars['Int'];
  companyId: Scalars['Int'];
  contentModules: Array<TrainingsContentModuleInput>;
  id: Scalars['Int'];
};


export type TrainingsMutationsRejectTrainingsTrainingRequestArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
  reason?: InputMaybe<Scalars['String']>;
};


export type TrainingsMutationsToggleVisibilityTrainingsSessionFileArgs = {
  id: Scalars['Int'];
};


export type TrainingsMutationsToggleVisibilityTrainingsTrainingClassFileArgs = {
  id: Scalars['Int'];
};


export type TrainingsMutationsToggleVisibilityTrainingsTrainingFileArgs = {
  id: Scalars['Int'];
};


export type TrainingsMutationsTrainingsExportTrainingsExportArgs = {
  cae?: InputMaybe<Scalars['String']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']>>;
  companyId: Scalars['Int'];
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  exportType?: InputMaybe<Scalars['String']>;
  filename: Scalars['String'];
  format: Scalars['String'];
  from: Scalars['ISO8601Date'];
  idEntidade?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  referenceYear?: InputMaybe<Scalars['String']>;
  scheduleAccessId: Scalars['Int'];
  status?: InputMaybe<Array<Scalars['String']>>;
  teamIds?: InputMaybe<Array<Scalars['Int']>>;
  to: Scalars['ISO8601Date'];
};


export type TrainingsMutationsUpdateBasicInfoTrainingsTrainingArgs = {
  competencyIds?: InputMaybe<Array<Scalars['Int']>>;
  description: Scalars['String'];
  id: Scalars['Int'];
  isMandatory?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  objectives?: InputMaybe<Scalars['String']>;
  thumbnail?: InputMaybe<Scalars['File']>;
  thumbnailDelete: Scalars['Boolean'];
  totalDuration?: InputMaybe<Scalars['Float']>;
  validFor?: InputMaybe<Scalars['Int']>;
};


export type TrainingsMutationsUpdateInternalInfoTrainingsTrainingArgs = {
  categoryIds?: InputMaybe<Array<Scalars['Int']>>;
  code?: InputMaybe<Scalars['String']>;
  costDecimal?: InputMaybe<Scalars['String']>;
  external: Scalars['Boolean'];
  externalProvider?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  subsidizedCostDecimal?: InputMaybe<Scalars['String']>;
  year: Scalars['Int'];
};


export type TrainingsMutationsUpdateStatusTrainingsTrainingArgs = {
  id: Scalars['Int'];
  notify: Scalars['Boolean'];
  status: Scalars['String'];
};


export type TrainingsMutationsUpdateTrainingsCategoryMapConfigItemArgs = {
  id: Scalars['Int'];
  value: Scalars['String'];
};


export type TrainingsMutationsUpdateTrainingsCompletionConfigurationArgs = {
  attendancePercentage?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  knowledgeTestRequired: Scalars['Boolean'];
  moduleCompletedPercentage?: InputMaybe<Scalars['Int']>;
};


export type TrainingsMutationsUpdateTrainingsEmployeeRelatorioUnicoFieldArgs = {
  id: Scalars['Int'];
  retirementRegimeApplied?: InputMaybe<Scalars['String']>;
};


export type TrainingsMutationsUpdateTrainingsLearningPlatformArgs = {
  duration?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  id: Scalars['Int'];
  link: Scalars['String'];
  name: Scalars['String'];
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
};


export type TrainingsMutationsUpdateTrainingsSessionArgs = {
  dueDate?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['String']>;
  endsAt?: InputMaybe<Scalars['String']>;
  frequency?: InputMaybe<TrainingsSessionFrequencyEnum>;
  id: Scalars['Int'];
  link?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  modality?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  recurrent?: InputMaybe<Scalars['Boolean']>;
  schedule?: InputMaybe<TrainingsSessionScheduleEnum>;
  startsAt?: InputMaybe<Scalars['String']>;
  subsidized?: InputMaybe<Scalars['Boolean']>;
  updateStrategy?: InputMaybe<TrainingsSessionUpdateStrategyEnum>;
};


export type TrainingsMutationsUpdateTrainingsSessionRelatorioUnicoFieldArgs = {
  id: Scalars['Int'];
  trainingSchedule?: InputMaybe<Scalars['String']>;
};


export type TrainingsMutationsUpdateTrainingsSettingArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
  relatorioEnabled?: InputMaybe<Scalars['Boolean']>;
  trainingRequestsEnabled?: InputMaybe<Scalars['Boolean']>;
};


export type TrainingsMutationsUpdateTrainingsTrainingArgs = {
  categoryIds?: InputMaybe<Array<Scalars['Int']>>;
  code?: InputMaybe<Scalars['String']>;
  competencyIds?: InputMaybe<Array<Scalars['Int']>>;
  cost?: InputMaybe<Scalars['Int']>;
  costDecimal?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  external: Scalars['Boolean'];
  externalProvider?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  subsidizedCost?: InputMaybe<Scalars['Int']>;
  subsidizedCostDecimal?: InputMaybe<Scalars['String']>;
  validFor?: InputMaybe<Scalars['Int']>;
  year: Scalars['Int'];
};


export type TrainingsMutationsUpdateTrainingsTrainingClassArgs = {
  cost?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  fundaeConfiguration?: InputMaybe<TrainingsTrainingClassFundaeConfigurationInput>;
  id: Scalars['Int'];
  indirectCost?: InputMaybe<Scalars['String']>;
  learningPlatformId?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<TrainingsTrainingClassModalityEnum>;
  name?: InputMaybe<Scalars['String']>;
  salaryCost?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  subsidizedCost?: InputMaybe<Scalars['String']>;
};


export type TrainingsMutationsUpdateTrainingsTrainingMembershipArgs = {
  id: Scalars['Int'];
  trainingCompletedAt?: InputMaybe<Scalars['ISO8601Date']>;
};


export type TrainingsMutationsUpdateTrainingsTrainingRelatorioUnicoFieldArgs = {
  certificateType?: InputMaybe<Scalars['String']>;
  educationArea?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  qualificationLevel?: InputMaybe<Scalars['String']>;
  trainingEntity?: InputMaybe<Scalars['String']>;
  trainingInitiative?: InputMaybe<Scalars['String']>;
  trainingModality?: InputMaybe<Scalars['String']>;
};


export type TrainingsMutationsUpdateTrainingsTrainingRequestArgs = {
  comments?: InputMaybe<Scalars['String']>;
  competencyIds: Array<Scalars['Int']>;
  cost?: InputMaybe<Scalars['Float']>;
  duration?: InputMaybe<Scalars['Float']>;
  employeeIds: Array<Scalars['Int']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  externalReference?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  providerName?: InputMaybe<Scalars['String']>;
  schedule?: InputMaybe<TrainingsTrainingRequestScheduleEnum>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  status: TrainingsTrainingRequestStatusEnum;
  subsidized: Scalars['Boolean'];
  trainingId?: InputMaybe<Scalars['Int']>;
  trainingName?: InputMaybe<Scalars['String']>;
  trainingNeed?: InputMaybe<Scalars['String']>;
};


export type TrainingsMutationsUpsertSubsidyTrainingsTrainingArgs = {
  codigoCurso?: InputMaybe<Scalars['String']>;
  expediente?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  perfil?: InputMaybe<Scalars['String']>;
  processId?: InputMaybe<Scalars['Int']>;
  subsidy?: InputMaybe<TrainingsTrainingSubsidyEnum>;
};


export type TrainingsMutationsUpsertTrainingsTrainingClassFundaeConfigurationArgs = {
  codigoGrupo: Scalars['String'];
  companyId: Scalars['Int'];
  trainingClassId: Scalars['Int'];
};

export type Trial = {
  __typename?: 'trial';
  _policies: TrialContextlessPolicies;
  trialEmployee?: Maybe<TrialTrialEmployee>;
  /** @deprecated Please favor `trialEmployeesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  trialEmployees: Array<TrialTrialEmployee>;
  trialEmployeesConnection: TrialTrialEmployeeConnection;
};


export type TrialTrialEmployeeArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type TrialTrialEmployeesArgs = {
  companyId: Scalars['Int'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type TrialTrialEmployeesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

export type TrialMutations = {
  __typename?: 'trialMutations';
  bulkDeleteTrialTrialEmployee: BulkDeleteTrialTrialEmployeePayload;
};


export type TrialMutationsBulkDeleteTrialTrialEmployeeArgs = {
  companyId: Scalars['Int'];
};

export type UniversalExports = {
  __typename?: 'universalExports';
  configuration?: Maybe<UniversalExportsConfiguration>;
  /** @deprecated Please favor `configurationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  configurations: Array<UniversalExportsConfiguration>;
  configurationsConnection: UniversalExportsConfigurationConnection;
  /** @deprecated Please favor `exportersConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  exporters: Array<UniversalExportsExporter>;
  exportersConnection: UniversalExportsExporterConnection;
};


export type UniversalExportsConfigurationArgs = {
  id: Scalars['Int'];
};


export type UniversalExportsConfigurationsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  resources?: InputMaybe<Array<Scalars['String']>>;
};


export type UniversalExportsConfigurationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  resources?: InputMaybe<Array<Scalars['String']>>;
  sortOrder?: InputMaybe<Sort>;
};


export type UniversalExportsExportersArgs = {
  companyId: Scalars['Int'];
  includeFilterOptions?: Scalars['Boolean'];
  metadata?: Array<UniversalExportsExporterMetadataInput>;
  resources?: InputMaybe<Array<Scalars['String']>>;
};


export type UniversalExportsExportersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  includeFilterOptions?: Scalars['Boolean'];
  last?: InputMaybe<Scalars['Int']>;
  metadata?: Array<UniversalExportsExporterMetadataInput>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  resources?: InputMaybe<Array<Scalars['String']>>;
  sortOrder?: InputMaybe<Sort>;
};

export type UniversalExportsMutations = {
  __typename?: 'universalExportsMutations';
  createUniversalexportsConfiguration: CreateUniversalexportsConfigurationPayload;
  createUniversalexportsExport: CreateUniversalexportsExportPayload;
  updateUniversalexportsConfiguration: UpdateUniversalexportsConfigurationPayload;
};


export type UniversalExportsMutationsCreateUniversalexportsConfigurationArgs = {
  accessId: Scalars['Int'];
  companyId: Scalars['Int'];
  extraOptions: Array<UniversalExportsConfigurationExtraOptionInput>;
  fields: Array<UniversalExportsConfigurationFieldInput>;
  filters: Array<UniversalExportsConfigurationFilterInput>;
  format: UniversalExportsEntitiesConfigurationFormatEnum;
  groupColumn?: InputMaybe<Scalars['String']>;
  resource: Scalars['String'];
};


export type UniversalExportsMutationsCreateUniversalexportsExportArgs = {
  configurationId: Scalars['Int'];
};


export type UniversalExportsMutationsUpdateUniversalexportsConfigurationArgs = {
  extraOptions: Array<UniversalExportsConfigurationExtraOptionInput>;
  fields: Array<UniversalExportsConfigurationFieldInput>;
  filters: Array<UniversalExportsConfigurationFilterInput>;
  format: UniversalExportsEntitiesConfigurationFormatEnum;
  groupColumn?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  resource: Scalars['String'];
};

export type UniversalImporter = {
  __typename?: 'universalImporter';
  _policies: UniversalImporterContextlessPolicies;
  /** @deprecated Please favor `importActivitiesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  importActivities: Array<UniversalImporterImportActivity>;
  importActivitiesConnection: UniversalImporterImportActivityConnection;
  importProcess?: Maybe<UniversalImporterImportProcess>;
  /** @deprecated Please favor `importProcessFailedDataConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  importProcessFailedData: Array<UniversalImporterImportProcessFailedDatum>;
  importProcessFailedDataConnection: UniversalImporterImportProcessFailedDatumConnection;
  /** @deprecated Please favor `importProcessRowsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  importProcessRows: Array<UniversalImporterImportProcessRow>;
  importProcessRowsConnection: UniversalImporterImportProcessRowConnection;
  /** @deprecated Please favor `importProcessesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  importProcesses: Array<UniversalImporterImportProcess>;
  importProcessesConnection: UniversalImporterImportProcessConnection;
  schemaAdapter?: Maybe<UniversalImporterSchemaAdapter>;
  /** @deprecated Please favor `schemaAdaptersConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  schemaAdapters: Array<UniversalImporterSchemaAdapter>;
  schemaAdaptersConnection: UniversalImporterSchemaAdapterConnection;
  /** @deprecated Please favor `schemaDataConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  schemaData: Array<UniversalImporterSchemaDatum>;
  schemaDataConnection: UniversalImporterSchemaDatumConnection;
};


export type UniversalImporterImportActivitiesArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  importProcessId?: InputMaybe<Scalars['Int']>;
};


export type UniversalImporterImportActivitiesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  importProcessId?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type UniversalImporterImportProcessArgs = {
  id: Scalars['Int'];
};


export type UniversalImporterImportProcessFailedDataArgs = {
  companyId: Scalars['Int'];
  importProcessId: Scalars['Int'];
};


export type UniversalImporterImportProcessFailedDataConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  importProcessId: Scalars['Int'];
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type UniversalImporterImportProcessRowsArgs = {
  companyId: Scalars['Int'];
  importProcessId: Scalars['Int'];
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Array<Scalars['String']>>;
};


export type UniversalImporterImportProcessRowsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  importProcessId: Scalars['Int'];
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  status?: InputMaybe<Array<Scalars['String']>>;
};


export type UniversalImporterImportProcessesArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  importType?: InputMaybe<Scalars['String']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  processTreeId?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['String']>;
  withErrors?: InputMaybe<Scalars['Boolean']>;
};


export type UniversalImporterImportProcessesConnectionArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<UniversalImporterImportProcessFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  importType?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  processTreeId?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  status?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['String']>;
  withErrors?: InputMaybe<Scalars['Boolean']>;
};


export type UniversalImporterSchemaAdapterArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
  importType: Scalars['String'];
};


export type UniversalImporterSchemaAdaptersArgs = {
  companyId: Scalars['Int'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  importType: Scalars['String'];
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  metadata?: InputMaybe<Array<UniversalImporterImportProcessMetadataInput>>;
};


export type UniversalImporterSchemaAdaptersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  importType: Scalars['String'];
  last?: InputMaybe<Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']>>;
  metadata?: InputMaybe<Array<UniversalImporterImportProcessMetadataInput>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type UniversalImporterSchemaDataArgs = {
  fieldNames: Array<Scalars['String']>;
  importType?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Array<UniversalImporterImportProcessMetadataInput>>;
};


export type UniversalImporterSchemaDataConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  fieldNames: Array<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  importType?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Array<UniversalImporterImportProcessMetadataInput>>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

export type UniversalImporterMutations = {
  __typename?: 'universalImporterMutations';
  findByUuidUniversalimporterImportProcess: FindByUuidUniversalimporterImportProcessPayload;
};


export type UniversalImporterMutationsFindByUuidUniversalimporterImportProcessArgs = {
  accessId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  importType?: InputMaybe<Scalars['String']>;
  legalEntityId?: InputMaybe<Scalars['Int']>;
  processTreeId?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['String']>;
  withErrors?: InputMaybe<Scalars['Boolean']>;
};

/** Payload for upload_process and subscription: processed_documents_count */
export type Upload_Process_Processed_Documents_Count_Type = {
  __typename?: 'upload_process_processed_documents_count_type';
  error?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  processedDocumentsCount: Scalars['Int'];
  processedPagesCount: Scalars['Int'];
  totalDocumentsCount: Scalars['Int'];
  totalPagesCount: Scalars['Int'];
};

export type Upsell = {
  __typename?: 'upsell';
  _policies: UpsellContextlessPolicies;
  accountManagerInfo?: Maybe<UpsellAccountManagerInfo>;
  /** @deprecated Please favor `accountManagerInfosConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  accountManagerInfos: Array<UpsellAccountManagerInfo>;
  accountManagerInfosConnection: UpsellAccountManagerInfoConnection;
  /** @deprecated Please favor `bookMeetingsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  bookMeetings: Array<UpsellBookMeeting>;
  bookMeetingsConnection: UpsellBookMeetingConnection;
  discoverabilityWidget?: Maybe<UpsellDiscoverabilityWidget>;
  /** @deprecated Please favor `discoverabilityWidgetsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  discoverabilityWidgets: Array<UpsellDiscoverabilityWidget>;
  discoverabilityWidgetsConnection: UpsellDiscoverabilityWidgetConnection;
  landingPage?: Maybe<UpsellLandingPage>;
  /** @deprecated Please favor `landingPagesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  landingPages: Array<UpsellLandingPage>;
  landingPagesConnection: UpsellLandingPageConnection;
  /** @deprecated Please favor `oneWaitlistPositionsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  oneWaitlistPositions: Array<UpsellOneWaitlistPosition>;
  oneWaitlistPositionsConnection: UpsellOneWaitlistPositionConnection;
  /** @deprecated Please favor `upsellDiscountsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  upsellDiscounts: Array<UpsellUpsellDiscount>;
  upsellDiscountsConnection: UpsellUpsellDiscountConnection;
  /** @deprecated Please favor `upsellRequestsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  upsellRequests: Array<UpsellUpsellRequest>;
  upsellRequestsConnection: UpsellUpsellRequestConnection;
};


export type UpsellAccountManagerInfoArgs = {
  companyId: Scalars['Int'];
  id: Scalars['String'];
};


export type UpsellAccountManagerInfosArgs = {
  companyId: Scalars['Int'];
  ids?: InputMaybe<Array<Scalars['String']>>;
};


export type UpsellAccountManagerInfosConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type UpsellBookMeetingsArgs = {
  moduleRequested: Scalars['String'];
};


export type UpsellBookMeetingsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  moduleRequested: Scalars['String'];
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type UpsellDiscoverabilityWidgetArgs = {
  id: Scalars['String'];
  locale: Scalars['String'];
  preview: Scalars['Boolean'];
};


export type UpsellDiscoverabilityWidgetsArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
  locale: Scalars['String'];
  preview: Scalars['Boolean'];
};


export type UpsellDiscoverabilityWidgetsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  locale: Scalars['String'];
  offsetPage?: InputMaybe<Scalars['Int']>;
  preview: Scalars['Boolean'];
  sortOrder?: InputMaybe<Sort>;
};


export type UpsellLandingPageArgs = {
  id: Scalars['String'];
  locale: Scalars['String'];
  preview: Scalars['Boolean'];
  slug: Scalars['String'];
};


export type UpsellLandingPagesArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
  locale: Scalars['String'];
  preview: Scalars['Boolean'];
  slug: Scalars['String'];
};


export type UpsellLandingPagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  locale: Scalars['String'];
  offsetPage?: InputMaybe<Scalars['Int']>;
  preview: Scalars['Boolean'];
  slug: Scalars['String'];
  sortOrder?: InputMaybe<Sort>;
};


export type UpsellOneWaitlistPositionsArgs = {
  companyId: Scalars['String'];
};


export type UpsellOneWaitlistPositionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['String'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type UpsellUpsellDiscountsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  module?: InputMaybe<Scalars['String']>;
};


export type UpsellUpsellDiscountsConnectionArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  module?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type UpsellUpsellRequestsArgs = {
  id?: InputMaybe<Scalars['Int']>;
  moduleRequested?: InputMaybe<Scalars['String']>;
};


export type UpsellUpsellRequestsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  moduleRequested?: InputMaybe<Scalars['String']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

export type UpsellMutations = {
  __typename?: 'upsellMutations';
  createUpsellAddLineItem: CreateUpsellAddLineItemPayload;
  createUpsellJoinOneWaitlist: CreateUpsellJoinOneWaitlistPayload;
  createUpsellUpsellDiscount: CreateUpsellUpsellDiscountPayload;
  createUpsellUpsellRequest: CreateUpsellUpsellRequestPayload;
  scheduleUpsellUpsellDiscount: ScheduleUpsellUpsellDiscountPayload;
};


export type UpsellMutationsCreateUpsellAddLineItemArgs = {
  feature: Scalars['String'];
  newAddons: Array<BillingAddonItemInput>;
  origin?: InputMaybe<Scalars['String']>;
  upsellInfo?: InputMaybe<BillingUpsellInfoInput>;
};


export type UpsellMutationsCreateUpsellJoinOneWaitlistArgs = {
  newAddons: Array<BillingAddonItemInput>;
  origin?: InputMaybe<Scalars['String']>;
  upsellInfo?: InputMaybe<BillingUpsellInfoInput>;
};


export type UpsellMutationsCreateUpsellUpsellDiscountArgs = {
  discountType: UpsellDtosUpsellDiscountCreateDiscountTypeEnum;
  isAutomatedDiscount: Scalars['Boolean'];
  module: Scalars['String'];
  moduleName: Scalars['String'];
  moduleSlug: Scalars['String'];
};


export type UpsellMutationsCreateUpsellUpsellRequestArgs = {
  employeeId?: InputMaybe<Scalars['Int']>;
  featureRequested?: InputMaybe<Scalars['String']>;
  hubspotModuleName?: InputMaybe<Scalars['String']>;
  meetingBooked?: InputMaybe<Scalars['Boolean']>;
  moduleRequested?: InputMaybe<Scalars['String']>;
  moreInfoUrl?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  requestReason?: InputMaybe<Scalars['String']>;
  requestSource?: InputMaybe<Scalars['String']>;
  requestSourceCategory?: InputMaybe<Scalars['String']>;
  requestSourceComponent?: InputMaybe<Scalars['String']>;
  requestedAt?: InputMaybe<Scalars['String']>;
  upsellRequestAmount?: InputMaybe<Scalars['Float']>;
  upsellRequestComponentType?: InputMaybe<Scalars['String']>;
  upsellRequestStatus?: InputMaybe<Scalars['String']>;
  upsellRequestType?: InputMaybe<Scalars['String']>;
};


export type UpsellMutationsScheduleUpsellUpsellDiscountArgs = {
  discountType: UpsellDtosUpsellDiscountScheduleDiscountTypeEnum;
  module: Scalars['String'];
};

export type Users = {
  __typename?: 'users';
  /** @deprecated Please favor `personalInfosConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  personalInfos: Array<UsersPersonalInfo>;
  personalInfosConnection: UsersPersonalInfoConnection;
};


export type UsersPersonalInfosArgs = {
  accessIds: Array<Scalars['Int']>;
};


export type UsersPersonalInfosConnectionArgs = {
  accessIds: Array<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};

export type UsersMutations = {
  __typename?: 'usersMutations';
  removeAvatarUsersPersonalInfo: RemoveAvatarUsersPersonalInfoPayload;
  removeUnconfirmedCommunicationsEmailUsersPersonalInfo: RemoveUnconfirmedCommunicationsEmailUsersPersonalInfoPayload;
  updateAvatarUsersPersonalInfo: UpdateAvatarUsersPersonalInfoPayload;
  updateCommunicationsEmailUsersPersonalInfo: UpdateCommunicationsEmailUsersPersonalInfoPayload;
  updateUsersPersonalInfo: UpdateUsersPersonalInfoPayload;
};


export type UsersMutationsRemoveAvatarUsersPersonalInfoArgs = {
  accessId: Scalars['Int'];
  allCompanies: Scalars['Boolean'];
};


export type UsersMutationsRemoveUnconfirmedCommunicationsEmailUsersPersonalInfoArgs = {
  accessId: Scalars['Int'];
  allCompanies: Scalars['Boolean'];
  communicationsEmail?: InputMaybe<Scalars['String']>;
};


export type UsersMutationsUpdateAvatarUsersPersonalInfoArgs = {
  accessId: Scalars['Int'];
  avatar: Scalars['File'];
  syncAvatar: Scalars['Boolean'];
};


export type UsersMutationsUpdateCommunicationsEmailUsersPersonalInfoArgs = {
  accessId: Scalars['Int'];
  allCompanies: Scalars['Boolean'];
  communicationsEmail?: InputMaybe<Scalars['String']>;
};


export type UsersMutationsUpdateUsersPersonalInfoArgs = {
  accessId: Scalars['Int'];
  allTenants: Scalars['Boolean'];
  communicationsEmail?: InputMaybe<Scalars['String']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
};

export type WorkSchedule = {
  __typename?: 'workSchedule';
  _policies: WorkScheduleContextlessPolicies;
  /** @deprecated Please favor `canAssignEmployeesPoliciesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  canAssignEmployeesPolicies: Array<WorkScheduleCanAssignEmployeesPolicy>;
  canAssignEmployeesPoliciesConnection: WorkScheduleCanAssignEmployeesPolicyConnection;
  canAssignEmployeesPolicy?: Maybe<WorkScheduleCanAssignEmployeesPolicy>;
  /** @deprecated Please favor `canReassignEmployeesPoliciesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  canReassignEmployeesPolicies: Array<WorkScheduleCanReassignEmployeesPolicy>;
  canReassignEmployeesPoliciesConnection: WorkScheduleCanReassignEmployeesPolicyConnection;
  canReassignEmployeesPolicy?: Maybe<WorkScheduleCanReassignEmployeesPolicy>;
  dayConfiguration?: Maybe<WorkScheduleDayConfiguration>;
  /** @deprecated Please favor `dayConfigurationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  dayConfigurations: Array<WorkScheduleDayConfiguration>;
  dayConfigurationsConnection: WorkScheduleDayConfigurationConnection;
  overlapPeriod?: Maybe<WorkScheduleOverlapPeriod>;
  /** @deprecated Please favor `overlapPeriodsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  overlapPeriods: Array<WorkScheduleOverlapPeriod>;
  overlapPeriodsConnection: WorkScheduleOverlapPeriodConnection;
  schedule?: Maybe<WorkScheduleSchedule>;
  /** @deprecated Please favor `schedulesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  schedules: Array<WorkScheduleSchedule>;
  schedulesConnection: WorkScheduleScheduleConnection;
};


export type WorkScheduleCanAssignEmployeesPoliciesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type WorkScheduleCanAssignEmployeesPoliciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type WorkScheduleCanAssignEmployeesPolicyArgs = {
  id: Scalars['Int'];
};


export type WorkScheduleCanReassignEmployeesPoliciesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type WorkScheduleCanReassignEmployeesPoliciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type WorkScheduleCanReassignEmployeesPolicyArgs = {
  id: Scalars['Int'];
};


export type WorkScheduleDayConfigurationArgs = {
  id: Scalars['Int'];
};


export type WorkScheduleDayConfigurationsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  overlapPeriodId?: InputMaybe<Scalars['Int']>;
  scheduleId?: InputMaybe<Scalars['Int']>;
};


export type WorkScheduleDayConfigurationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  overlapPeriodId?: InputMaybe<Scalars['Int']>;
  scheduleId?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type WorkScheduleOverlapPeriodArgs = {
  id: Scalars['Int'];
};


export type WorkScheduleOverlapPeriodsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type WorkScheduleOverlapPeriodsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type WorkScheduleScheduleArgs = {
  id: Scalars['Int'];
};


export type WorkScheduleSchedulesArgs = {
  forSettings?: Scalars['Boolean'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  onlyActive?: Scalars['Boolean'];
  onlyArchived?: Scalars['Boolean'];
  searchByName?: InputMaybe<Scalars['String']>;
  withEmployeeIds?: Scalars['Boolean'];
  withPeriods?: Scalars['Boolean'];
};


export type WorkScheduleSchedulesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forSettings?: Scalars['Boolean'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  onlyActive?: Scalars['Boolean'];
  onlyArchived?: Scalars['Boolean'];
  searchByName?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort>;
  withEmployeeIds?: Scalars['Boolean'];
  withPeriods?: Scalars['Boolean'];
};

export type WorkScheduleMutations = {
  __typename?: 'workScheduleMutations';
  bulkCudWorkscheduleDayConfiguration: BulkCudWorkscheduleDayConfigurationPayload;
  bulkDeleteArchivedWorkscheduleSchedule: BulkDeleteArchivedWorkscheduleSchedulePayload;
  createWorkscheduleOverlapPeriod: CreateWorkscheduleOverlapPeriodPayload;
  createWorkscheduleSchedule: CreateWorkscheduleSchedulePayload;
  deleteWorkscheduleOverlapPeriod: DeleteWorkscheduleOverlapPeriodPayload;
  toggleArchiveWorkscheduleSchedule: ToggleArchiveWorkscheduleSchedulePayload;
  updateWorkscheduleOverlapPeriod: UpdateWorkscheduleOverlapPeriodPayload;
  updateWorkscheduleSchedule: UpdateWorkscheduleSchedulePayload;
};


export type WorkScheduleMutationsBulkCudWorkscheduleDayConfigurationArgs = {
  dayConfigurations: Array<BulkCudWorkscheduleDayConfigurationDayConfigurationsInput>;
  overlapPeriodId: Scalars['Int'];
};


export type WorkScheduleMutationsCreateWorkscheduleOverlapPeriodArgs = {
  scheduleId: Scalars['Int'];
};


export type WorkScheduleMutationsCreateWorkscheduleScheduleArgs = {
  name: Scalars['String'];
  scheduleType: Scalars['String'];
};


export type WorkScheduleMutationsDeleteWorkscheduleOverlapPeriodArgs = {
  id: Scalars['Int'];
};


export type WorkScheduleMutationsToggleArchiveWorkscheduleScheduleArgs = {
  id: Scalars['Int'];
};


export type WorkScheduleMutationsUpdateWorkscheduleOverlapPeriodArgs = {
  id: Scalars['Int'];
};


export type WorkScheduleMutationsUpdateWorkscheduleScheduleArgs = {
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
};

/** Payload for worked_time and subscription: refresh */
export type Worked_Time_Refresh_Type = {
  __typename?: 'worked_time_refresh_type';
  dates?: Maybe<Array<Scalars['ISO8601Date']>>;
  employeeId?: Maybe<Scalars['Int']>;
  error?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  workedTimes: Array<AttendanceWorkedTimeSubscription>;
};

export type Workflows = {
  __typename?: 'workflows';
  workflow?: Maybe<WorkflowsWorkflow>;
  /** @deprecated Please favor `workflowManifestsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  workflowManifests: Array<WorkflowsWorkflowManifest>;
  workflowManifestsConnection: WorkflowsWorkflowManifestConnection;
  workflowNodeFile?: Maybe<WorkflowsWorkflowNodeFile>;
  /** @deprecated Please favor `workflowNodeFilesConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  workflowNodeFiles: Array<WorkflowsWorkflowNodeFile>;
  workflowNodeFilesConnection: WorkflowsWorkflowNodeFileConnection;
  /** @deprecated Please favor `workflowsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  workflows: Array<WorkflowsWorkflow>;
  workflowsConnection: WorkflowsWorkflowConnection;
};


export type WorkflowsWorkflowArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
  useCase: Scalars['String'];
};


export type WorkflowsWorkflowManifestsArgs = {
  useCases: Array<Scalars['String']>;
};


export type WorkflowsWorkflowManifestsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  useCases: Array<Scalars['String']>;
};


export type WorkflowsWorkflowNodeFileArgs = {
  id: Scalars['Int'];
};


export type WorkflowsWorkflowNodeFilesArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  workflowIds?: InputMaybe<Array<Scalars['Int']>>;
  workflowNodeIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type WorkflowsWorkflowNodeFilesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  workflowIds?: InputMaybe<Array<Scalars['Int']>>;
  workflowNodeIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type WorkflowsWorkflowsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  companyId: Scalars['Int'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  targetIds?: InputMaybe<Array<Scalars['Int']>>;
  targetType?: InputMaybe<Scalars['String']>;
  useCase: Scalars['String'];
};


export type WorkflowsWorkflowsConnectionArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
  filter?: InputMaybe<WorkflowsWorkflowFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  targetIds?: InputMaybe<Array<Scalars['Int']>>;
  targetType?: InputMaybe<Scalars['String']>;
  useCase: Scalars['String'];
};

export type WorkflowsMutations = {
  __typename?: 'workflowsMutations';
  createVersionWorkflowsWorkflow: CreateVersionWorkflowsWorkflowPayload;
  createWorkflowsWorkflow: CreateWorkflowsWorkflowPayload;
  createWorkflowsWorkflowNodeFile: CreateWorkflowsWorkflowNodeFilePayload;
  deleteWorkflowsWorkflowNodeFile: DeleteWorkflowsWorkflowNodeFilePayload;
  disableWorkflowsWorkflow: DisableWorkflowsWorkflowPayload;
  publishWorkflowsWorkflow: PublishWorkflowsWorkflowPayload;
  saveGraphWorkflowsWorkflow: SaveGraphWorkflowsWorkflowPayload;
};


export type WorkflowsMutationsCreateVersionWorkflowsWorkflowArgs = {
  authorId?: InputMaybe<Scalars['Int']>;
  companyId: Scalars['Int'];
  workflowId: Scalars['Int'];
};


export type WorkflowsMutationsCreateWorkflowsWorkflowArgs = {
  authorId?: InputMaybe<Scalars['Int']>;
  companyId: Scalars['Int'];
  targetId?: InputMaybe<Scalars['Int']>;
  targetType?: InputMaybe<Scalars['String']>;
  useCase: Scalars['String'];
  withStartNode: Scalars['Boolean'];
};


export type WorkflowsMutationsCreateWorkflowsWorkflowNodeFileArgs = {
  files: Array<Scalars['File']>;
  nodeIdentifier?: InputMaybe<Scalars['String']>;
  workflowId: Scalars['Int'];
  workflowNodeId?: InputMaybe<Scalars['Int']>;
};


export type WorkflowsMutationsDeleteWorkflowsWorkflowNodeFileArgs = {
  id: Scalars['Int'];
};


export type WorkflowsMutationsDisableWorkflowsWorkflowArgs = {
  workflowId: Scalars['Int'];
};


export type WorkflowsMutationsPublishWorkflowsWorkflowArgs = {
  workflowId: Scalars['Int'];
};


export type WorkflowsMutationsSaveGraphWorkflowsWorkflowArgs = {
  companyId: Scalars['Int'];
  edges: Array<WorkflowsEdgeInput>;
  nodes: Array<WorkflowsNodeInput>;
  workflowId: Scalars['Int'];
};

export type WorkingConditions = {
  __typename?: 'workingConditions';
  /** @deprecated Please favor `applicableAssignmentsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  applicableAssignments: Array<WorkingConditionsApplicableAssignment>;
  applicableAssignmentsConnection: WorkingConditionsApplicableAssignmentConnection;
  group?: Maybe<WorkingConditionsGroup>;
  /** @deprecated Please favor `groupsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  groups: Array<WorkingConditionsGroup>;
  groupsConnection: WorkingConditionsGroupConnection;
  item?: Maybe<WorkingConditionsItem>;
  /** @deprecated Please favor `itemsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  items: Array<WorkingConditionsItem>;
  itemsConnection: WorkingConditionsItemConnection;
  peopleAssignment?: Maybe<WorkingConditionsPeopleAssignment>;
  /** @deprecated Please favor `peopleAssignmentsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  peopleAssignments: Array<WorkingConditionsPeopleAssignment>;
  peopleAssignmentsConnection: WorkingConditionsPeopleAssignmentConnection;
  version?: Maybe<WorkingConditionsVersion>;
  versionApplication?: Maybe<WorkingConditionsVersionApplication>;
  /** @deprecated Please favor `versionApplicationsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  versionApplications: Array<WorkingConditionsVersionApplication>;
  versionApplicationsConnection: WorkingConditionsVersionApplicationConnection;
  /** @deprecated Please favor `versionsConnection` over using this field as connections come with built-in pagination. This will help you build more performant user interfaces. */
  versions: Array<WorkingConditionsVersion>;
  versionsConnection: WorkingConditionsVersionConnection;
};


export type WorkingConditionsApplicableAssignmentsArgs = {
  employeeId?: InputMaybe<Scalars['Int']>;
  jobLevelId?: InputMaybe<Scalars['Int']>;
  workplaceId?: InputMaybe<Scalars['Int']>;
};


export type WorkingConditionsApplicableAssignmentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  jobLevelId?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  workplaceId?: InputMaybe<Scalars['Int']>;
};


export type WorkingConditionsGroupArgs = {
  id: Scalars['Int'];
};


export type WorkingConditionsGroupsArgs = {
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeArchived?: InputMaybe<Scalars['Boolean']>;
};


export type WorkingConditionsGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
};


export type WorkingConditionsItemArgs = {
  id: Scalars['Int'];
};


export type WorkingConditionsItemsArgs = {
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  workingConditionsVersionIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type WorkingConditionsItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  workingConditionsVersionIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type WorkingConditionsPeopleAssignmentArgs = {
  id: Scalars['Int'];
};


export type WorkingConditionsPeopleAssignmentsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  workingConditionsVersionIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type WorkingConditionsPeopleAssignmentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  workingConditionsVersionIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type WorkingConditionsVersionArgs = {
  id: Scalars['Int'];
};


export type WorkingConditionsVersionApplicationArgs = {
  id: Scalars['Int'];
};


export type WorkingConditionsVersionApplicationsArgs = {
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  contractVersionIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  workingConditionVersionIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type WorkingConditionsVersionApplicationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  contractVersionIds?: InputMaybe<Array<Scalars['Int']>>;
  filter?: InputMaybe<WorkingConditionsVersionApplicationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  workingConditionVersionIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type WorkingConditionsVersionsArgs = {
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  workingConditionGroupIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type WorkingConditionsVersionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  last?: InputMaybe<Scalars['Int']>;
  offsetPage?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Sort>;
  workingConditionGroupIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type WorkingConditionsMutations = {
  __typename?: 'workingConditionsMutations';
  archiveWorkingconditionsGroup: ArchiveWorkingconditionsGroupPayload;
  bulkUpsertWorkingconditionsItem: BulkUpsertWorkingconditionsItemPayload;
  createWorkingconditionsItem: CreateWorkingconditionsItemPayload;
  createWorkingconditionsPeopleAssignment: CreateWorkingconditionsPeopleAssignmentPayload;
  createWorkingconditionsVersion: CreateWorkingconditionsVersionPayload;
  duplicateWorkingconditionsGroup: DuplicateWorkingconditionsGroupPayload;
  updateWorkingconditionsItem: UpdateWorkingconditionsItemPayload;
  updateWorkingconditionsVersion: UpdateWorkingconditionsVersionPayload;
};


export type WorkingConditionsMutationsArchiveWorkingconditionsGroupArgs = {
  id: Scalars['Int'];
  newGroupId?: InputMaybe<Scalars['Int']>;
};


export type WorkingConditionsMutationsBulkUpsertWorkingconditionsItemArgs = {
  companyId: Scalars['Int'];
  items: Array<BulkUpsertWorkingconditionsItemItemsInput>;
  versionId: Scalars['Int'];
};


export type WorkingConditionsMutationsCreateWorkingconditionsItemArgs = {
  companyId: Scalars['Int'];
  dataType: Scalars['String'];
  name: Scalars['String'];
  value: Scalars['String'];
  versionId: Scalars['Int'];
};


export type WorkingConditionsMutationsCreateWorkingconditionsPeopleAssignmentArgs = {
  accessIds?: InputMaybe<Array<Scalars['Int']>>;
  companyId: Scalars['Int'];
  jobLevelId?: InputMaybe<Scalars['Int']>;
  workingConditionsVersionId: Scalars['Int'];
  workplaceId?: InputMaybe<Scalars['Int']>;
};


export type WorkingConditionsMutationsCreateWorkingconditionsVersionArgs = {
  applyTo?: InputMaybe<Array<WorkingConditionsApplyToStrategyInput>>;
  companyId: Scalars['Int'];
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  workingConditionsGroupId?: InputMaybe<Scalars['Int']>;
};


export type WorkingConditionsMutationsDuplicateWorkingconditionsGroupArgs = {
  id: Scalars['Int'];
};


export type WorkingConditionsMutationsUpdateWorkingconditionsItemArgs = {
  id: Scalars['Int'];
  value?: InputMaybe<Scalars['String']>;
};


export type WorkingConditionsMutationsUpdateWorkingconditionsVersionArgs = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
};

export const AccessAffiliationEnumValues: AccessAffiliationEnum[] = [ 'employee'  , 'external'  , 'partner']

export const AccessRoleEnumValues: AccessRoleEnum[] = [ 'admin'  , 'basic']

export const ApiCoreAccessPoliciesEnumValues: ApiCoreAccessPoliciesEnum[] = [ 'become'  , 'invite'  , 'update'  , 'update_avatar']

export const ApiCoreEntitiesAccessAffiliationEnumValues: ApiCoreEntitiesAccessAffiliationEnum[] = [ 'employee'  , 'external'  , 'partner']

export const ApiCoreEntitiesAccessWeekdayEnumValues: ApiCoreEntitiesAccessWeekdayEnum[] = [ 'friday'  , 'monday'  , 'saturday'  , 'sunday'  , 'thursday'  , 'tuesday'  , 'wednesday']

export const ApprovalsApprovalFlowOnApprovalFlowChangeEnumValues: ApprovalsApprovalFlowOnApprovalFlowChangeEnum[] = [ 'donothing'  , 'resetall']

export const ApprovalsDomainConfigurationInputTypeEnumValues: ApprovalsDomainConfigurationInputTypeEnum[] = [ 'cents'  , 'selector'  , 'single_choice']

export const ApprovalsDomainConfigurationInputWithEnumValues: ApprovalsDomainConfigurationInputWithEnum[] = [ 'full'  , 'half']

export const ApprovalsDomainConfigurationOperationsEnumValues: ApprovalsDomainConfigurationOperationsEnum[] = [ 'greaterthan'  , 'includes'  , 'lessthan'  , 'nooperation']

export const ApprovalsDomainConfigurationRulesConfigurationStatusEnumValues: ApprovalsDomainConfigurationRulesConfigurationStatusEnum[] = [ 'disabled'  , 'enabled'  , 'upgrade_plan']

export const ApprovalsDtosMaterializedApprovalFlowsRepresentationEnumValues: ApprovalsDtosMaterializedApprovalFlowsRepresentationEnum[] = [ 'location'  , 'permissions_group']

export const ApprovalsEntitiesEmailDetailBlockTypeEnumValues: ApprovalsEntitiesEmailDetailBlockTypeEnum[] = [ 'date'  , 'daterange'  , 'datetime'  , 'integer'  , 'string']

export const ApprovalsMaterializedApprovalFlowStatusEnumValues: ApprovalsMaterializedApprovalFlowStatusEnum[] = [ 'approved'  , 'changes_requested'  , 'rejected'  , 'requestedinformation'  , 'running'  , 'stopped']

export const ApprovalsMaterializedApprovalStepApproverApproverStatusEnumValues: ApprovalsMaterializedApprovalStepApproverApproverStatusEnum[] = [ 'approved'  , 'changes_requested'  , 'ignored'  , 'pending'  , 'rejected'  , 'requestedinformation'  , 'stopped'  , 'waiting_changes']

export const ApprovalsMaterializedApprovalsFlowPoliciesEnumValues: ApprovalsMaterializedApprovalsFlowPoliciesEnum[] = [ 'approve_or_reject']

export const ApprovalsV2ValueObjectsApprovalProcessDecisionEnumValues: ApprovalsV2ValueObjectsApprovalProcessDecisionEnum[] = [ 'approved'  , 'rejected']

export const ApprovalsV2ValueObjectsApprovalTimelineEntryStatusEnumValues: ApprovalsV2ValueObjectsApprovalTimelineEntryStatusEnum[] = [ 'changesrequested'  , 'completed'  , 'future'  , 'rejected'  , 'running']

export const ApprovalsV2ValueObjectsApprovalTimelineEntryTypeEnumValues: ApprovalsV2ValueObjectsApprovalTimelineEntryTypeEnum[] = [ 'action'  , 'cannot_resolve'  , 'start']

export const ApprovalsV2ValueObjectsReviewRequestDecisionEnumValues: ApprovalsV2ValueObjectsReviewRequestDecisionEnum[] = [ 'approved'  , 'changes_requested'  , 'rejected']

export const ApprovalsValueObjectsApprovalCategoryEnumValues: ApprovalsValueObjectsApprovalCategoryEnum[] = [ 'ats'  , 'contracts'  , 'expenses'  , 'premium_portals'  , 'purchases'  , 'shift_management'  , 'software'  , 'time_tracking'  , 'timeoff'  , 'trainings']

export const ApprovalsValueObjectsRulesConfigurationRuleDecisionEnumValues: ApprovalsValueObjectsRulesConfigurationRuleDecisionEnum[] = [ 'auto_approve'  , 'custom_approval_flow'  , 'default_approval_flow'  , 'do_nothing'  , 'restarted'  , 'start_approval_flow']

export const AtsApplicationAuthorTypeEnumValues: AtsApplicationAuthorTypeEnum[] = [ 'access'  , 'company'  , 'user']

export const AtsApplicationPhaseTypeEnumValues: AtsApplicationPhaseTypeEnum[] = [ 'assessment'  , 'hired'  , 'initial'  , 'interview'  , 'normal'  , 'offer'  , 'screening']

export const AtsAssessmentStatusesEnumValues: AtsAssessmentStatusesEnum[] = [ 'completed'  , 'failed_to_process'  , 'pending_to_complete'  , 'pending_to_create']

export const AtsCandidateEmailActionDelaysEnumValues: AtsCandidateEmailActionDelaysEnum[] = [ 'four_hours'  , 'next_monday_at_nine_am'  , 'now'  , 'six_hours'  , 'today_at_six_pm'  , 'tomorrow_at_nine_am'  , 'two_hours']

export const AtsCandidateEmailActionSenderOptionsEnumValues: AtsCandidateEmailActionSenderOptionsEnum[] = [ 'conversation'  , 'no_reply']

export const AtsCandidateEmailActionTypesEnumValues: AtsCandidateEmailActionTypesEnum[] = [ 'phase_changed'  , 'reject']

export const AtsCandidateGenderOptionsEnumValues: AtsCandidateGenderOptionsEnum[] = [ 'female'  , 'male'  , 'other'  , 'unanswered']

export const AtsCandidateSourceCategoriesEnumValues: AtsCandidateSourceCategoriesEnum[] = [ 'agency_or_external_recruiter'  , 'event'  , 'internal'  , 'job_board'  , 'manually_added'  , 'organic'  , 'referral'  , 'social_media'  , 'system']

export const AtsContractTypesEnumValues: AtsContractTypesEnum[] = [ 'a_tempo_parcial'  , 'a_termo_certo'  , 'a_termo_incerto'  , 'alternant'  , 'apprendistato'  , 'apprenticeship'  , 'apprentissage'  , 'clt'  , 'com_pluralidade_de_empregadores'  , 'de_curta_duracao'  , 'de_muita_curta_duracao'  , 'estagio'  , 'fixed_discontinued'  , 'freelance'  , 'indefinite'  , 'interim'  , 'intern'  , 'jovem_aprendiz'  , 'minijob'  , 'other'  , 'per_hour'  , 'pj'  , 'pre_reforma'  , 'promessa_de_trabalho'  , 'recibos_verdes'  , 'sem_termo'  , 'teletrabalho'  , 'temporary'  , 'training'  , 'vendor_contractor'  , 'volunteer'  , 'werkstudent']

export const AtsCvBulkUploadStatusesEnumValues: AtsCvBulkUploadStatusesEnum[] = [ 'archived'  , 'cancelled'  , 'cancelling'  , 'completed'  , 'processing']

export const AtsEntitiesInsightsDataSourceIdEnumValues: AtsEntitiesInsightsDataSourceIdEnum[] = [ 'applications'  , 'job_postings']

export const AtsEntitiesInsightsJobPostingsInsightIdEnumValues: AtsEntitiesInsightsJobPostingsInsightIdEnum[] = [ 'hire_time'  , 'job_postings'  , 'job_postings_with_hiring'  , 'last_updated_at'  , 'new_job_postings'  , 'offer_time']

export const AtsFeedbackVisibilityEnumValues: AtsFeedbackVisibilityEnum[] = [ 'public'  , 'restricted']

export const AtsFileOptionsCategoriesEnumValues: AtsFileOptionsCategoriesEnum[] = [ 'cover_letter'  , 'cv'  , 'none'  , 'photo']

export const AtsFileOptionsErrorsEnumValues: AtsFileOptionsErrorsEnum[] = [ 'candidate_creation_failed'  , 'candidate_data_not_found'  , 'cv_bulk_upload_cancelled'  , 'file_conversion_failed'  , 'file_could_not_be_processed'  , 'text_extraction_failed'  , 'unsupported_format']

export const AtsFileOptionsTypesAuthorEnumValues: AtsFileOptionsTypesAuthorEnum[] = [ 'access'  , 'candidate'  , 'company'  , 'user']

export const AtsFileOptionsTypesResourceEnumValues: AtsFileOptionsTypesResourceEnum[] = [ 'application'  , 'candidate'  , 'candidate_email_action'  , 'cv_bulk_upload'  , 'feedback'  , 'offer_letter_template']

export const AtsHiringRolesEnumValues: AtsHiringRolesEnum[] = [ 'editor'  , 'owner'  , 'reviewer']

export const AtsHiringStageNamesEnumValues: AtsHiringStageNamesEnum[] = [ 'assessment'  , 'hired'  , 'interview'  , 'new'  , 'offer'  , 'screening']

export const AtsInterviewAttendeeStatusesEnumValues: AtsInterviewAttendeeStatusesEnum[] = [ 'accepted'  , 'declined'  , 'needs_action'  , 'tentative'  , 'unknown']

export const AtsInterviewOptionsStatusesEnumValues: AtsInterviewOptionsStatusesEnum[] = [ 'cancelled'  , 'completed'  , 'processing'  , 'rejected'  , 'scheduled']

export const AtsInterviewOptionsTypesEnumValues: AtsInterviewOptionsTypesEnum[] = [ 'in_person'  , 'online'  , 'telephone']

export const AtsJobPostingPoliciesEnumValues: AtsJobPostingPoliciesEnum[] = [ 'manage']

export const AtsJobPostingSalaryFormatEnumValues: AtsJobPostingSalaryFormatEnum[] = [ 'fixed_amount'  , 'range']

export const AtsJobPostingSalaryPeriodEnumValues: AtsJobPostingSalaryPeriodEnum[] = [ 'annual'  , 'daily'  , 'monthly']

export const AtsJobPostingScheduleTypesEnumValues: AtsJobPostingScheduleTypesEnum[] = [ 'full_time'  , 'part_time']

export const AtsJobPostingStatusesEnumValues: AtsJobPostingStatusesEnum[] = [ 'archived'  , 'cancelled'  , 'deleted'  , 'draft'  , 'published'  , 'unlisted']

export const AtsJobRequirementsOptionsEnumValues: AtsJobRequirementsOptionsEnum[] = [ 'do_not_ask'  , 'mandatory'  , 'optional']

export const AtsMessageSendersEnumValues: AtsMessageSendersEnum[] = [ 'candidate'  , 'user']

export const AtsMessageTemplateVisibilityEnumValues: AtsMessageTemplateVisibilityEnum[] = [ 'company'  , 'personal']

export const AtsQuestionTypeEnumValues: AtsQuestionTypeEnum[] = [ 'file'  , 'long_text'  , 'multiple_choice'  , 'single_choice'  , 'text']

export const AtsRejectionReasonDecisionMakersEnumValues: AtsRejectionReasonDecisionMakersEnum[] = [ 'candidate'  , 'company']

export const AtsRelatedJobPostingPoliciesEnumValues: AtsRelatedJobPostingPoliciesEnum[] = [ 'manage']

export const AtsRequisitionReasonsEnumValues: AtsRequisitionReasonsEnum[] = [ 'backfill'  , 'new_position']

export const AtsRequisitionStatusesEnumValues: AtsRequisitionStatusesEnum[] = [ 'approved'  , 'cancelled'  , 'pending'  , 'rejected']

export const AtsWorkplaceTypesEnumValues: AtsWorkplaceTypesEnum[] = [ 'hybrid'  , 'onsite'  , 'remote']

export const AttendanceCompanySettingsVersionCalculationMethodEnumValues: AttendanceCompanySettingsVersionCalculationMethodEnum[] = [ 'beginning_shift'  , 'calendar_day'  , 'legacy']

export const AttendanceCustomPeriodEmployeePoliciesEnumValues: AttendanceCustomPeriodEmployeePoliciesEnum[] = [ 'approveTimesheet']

export const AttendanceCustomTimeRangeDayEnumValues: AttendanceCustomTimeRangeDayEnum[] = [ 'bank_holiday'  , 'friday'  , 'monday'  , 'saturday'  , 'sunday'  , 'thursday'  , 'tuesday'  , 'wednesday']

export const AttendanceEditTimesheetRequestRequestTypeEnumValues: AttendanceEditTimesheetRequestRequestTypeEnum[] = [ 'create_shift'  , 'delete_shift'  , 'update_shift']

export const AttendanceEmployeePoliciesEnumValues: AttendanceEmployeePoliciesEnum[] = [ 'deleteAttendance'  , 'editAttendance'  , 'seeAttendance']

export const AttendanceEmployeesSettingComplementaryHoursBaselineEnumValues: AttendanceEmployeesSettingComplementaryHoursBaselineEnum[] = [ 'contract_hours'  , 'planned_hours']

export const AttendanceEmployeesSettingEmployeeAccessSearchFieldEnumValues: AttendanceEmployeesSettingEmployeeAccessSearchFieldEnum[] = [ 'employee_company_identifier'  , 'personal_identifier']

export const AttendanceEmployeesSettingExtraHoursBaselineEnumValues: AttendanceEmployeesSettingExtraHoursBaselineEnum[] = [ 'contract_hours'  , 'planned_hours']

export const AttendanceEmployeesSettingExtraHoursTransferFrequencyEnumValues: AttendanceEmployeesSettingExtraHoursTransferFrequencyEnum[] = [ 'daily'  , 'monthly'  , 'weekly']

export const AttendanceEmployeesSettingForgotClockOutOptionEnumValues: AttendanceEmployeesSettingForgotClockOutOptionEnum[] = [ 'clock_out_reminder'  , 'disabled'  , 'missing_clock_out']

export const AttendanceEntitiesCompensationBlockCompensationPoolEnumValues: AttendanceEntitiesCompensationBlockCompensationPoolEnum[] = [ 'balance'  , 'payroll'  , 'timeoff']

export const AttendanceEntitiesCompensationBlockCompensationTypeEnumValues: AttendanceEntitiesCompensationBlockCompensationTypeEnum[] = [ 'extra_hours'  , 'extra_hours_from_bank_of_hours'  , 'special_hours']

export const AttendanceEntitiesCompensationBlockStatusEnumValues: AttendanceEntitiesCompensationBlockStatusEnum[] = [ 'available'  , 'compensated'  , 'pending']

export const AttendanceEnumsBalanceCarryoverResetFrequencyEnumValues: AttendanceEnumsBalanceCarryoverResetFrequencyEnum[] = [ 'custom_period'  , 'monthly'  , 'never'  , 'weekly'  , 'yearly']

export const AttendanceEnumsBreakSourceEnumValues: AttendanceEnumsBreakSourceEnum[] = [ 'planned_hours'  , 'rules']

export const AttendanceEnumsBreakViolationsHandlingEnumValues: AttendanceEnumsBreakViolationsHandlingEnum[] = [ 'autofix'  , 'no_action']

export const AttendanceEnumsDayTypeEnumValues: AttendanceEnumsDayTypeEnum[] = [ 'bank_holiday'  , 'saturday'  , 'sunday'  , 'workday']

export const AttendanceEnumsEmployeeTypeEnumValues: AttendanceEnumsEmployeeTypeEnum[] = [ 'full_time'  , 'part_time']

export const AttendanceEnumsExtraHoursRangeBaselineEnumValues: AttendanceEnumsExtraHoursRangeBaselineEnum[] = [ 'contract_hours'  , 'effective_hours']

export const AttendanceEnumsOvertimePoolNegativeTransfersEnumValues: AttendanceEnumsOvertimePoolNegativeTransfersEnum[] = [ 'limited'  , 'none'  , 'unlimited']

export const AttendanceEnumsOvertimePoolUpdateFrequencyEnumValues: AttendanceEnumsOvertimePoolUpdateFrequencyEnum[] = [ 'at_cycle_end'  , 'daily'  , 'monthly'  , 'on_approval'  , 'weekly'  , 'yearly']

export const AttendanceEnumsOvertimeRequestStatusEnumValues: AttendanceEnumsOvertimeRequestStatusEnum[] = [ 'approved'  , 'none'  , 'pending'  , 'rejected']

export const AttendanceEnumsPoolTypeEnumValues: AttendanceEnumsPoolTypeEnum[] = [ 'balance'  , 'buffer'  , 'complementary_buffer'  , 'discarded'  , 'payroll'  , 'timeoff'  , 'virtual_payroll'  , 'virtual_timeoff']

export const AttendanceEnumsShiftSourceEnumValues: AttendanceEnumsShiftSourceEnum[] = [ 'api'  , 'desktop'  , 'face_recognition'  , 'mobile'  , 'mobile_geolocation'  , 'qr_code'  , 'shared_device'  , 'system']

export const AttendanceEnumsTimeUnitEnumValues: AttendanceEnumsTimeUnitEnum[] = [ 'half_day'  , 'minute'  , 'none']

export const AttendanceGridRoundingBiasEnumValues: AttendanceGridRoundingBiasEnum[] = [ 'balanced'  , 'company'  , 'neutral']

export const AttendanceShiftHalfDayTypesEnumValues: AttendanceShiftHalfDayTypesEnum[] = [ 'beginning_of_day'  , 'end_of_day']

export const AttendanceShiftIncidenceShiftActionEnumValues: AttendanceShiftIncidenceShiftActionEnum[] = [ 'break_end'  , 'break_start'  , 'clock_in'  , 'clock_out']

export const AttendanceShiftLocationTypeEnumValues: AttendanceShiftLocationTypeEnum[] = [ 'business_trip'  , 'office'  , 'work_from_home']

export const AttendanceShiftStatusEnumValues: AttendanceShiftStatusEnum[] = [ 'closed'  , 'created'  , 'opened']

export const AttendanceStateResolverStateEnumValues: AttendanceStateResolverStateEnum[] = [ 'approved'  , 'in_progress'  , 'pending']

export const AttendanceValueObjectsCompensationPeriodStatusStatusEnumValues: AttendanceValueObjectsCompensationPeriodStatusStatusEnum[] = [ 'finished'  , 'in_progress'  , 'incompatible_period'  , 'not_started']

export const AttendanceValueObjectsEstimatedTimeSourcesEnumValues: AttendanceValueObjectsEstimatedTimeSourcesEnum[] = [ 'contract_hours'  , 'none'  , 'shift_management'  , 'work_schedule']

export const AttendanceValueObjectsOffDayDayTypeEnumValues: AttendanceValueObjectsOffDayDayTypeEnum[] = [ 'beggining_of_day'  , 'beginning_of_day'  , 'end_of_day'  , 'full'  , 'hourly']

export const AttendanceValueObjectsOffDayOffDayTypeEnumValues: AttendanceValueObjectsOffDayOffDayTypeEnum[] = [ 'bank_holiday'  , 'leave']

export const AuthenticationAccessPoliciesEnumValues: AuthenticationAccessPoliciesEnum[] = [ 'disable_mfa']

export const AuthenticationDomainStatusEnumValues: AuthenticationDomainStatusEnum[] = [ 'missing_token'  , 'unverified'  , 'verified']

export const BankingCardCategoryEnumValues: BankingCardCategoryEnum[] = [ 'accommodation'  , 'airlines'  , 'car_rental_agencies'  , 'fuel'  , 'internet'  , 'laundry'  , 'office_supplies'  , 'other'  , 'parking'  , 'passport_visa_fees'  , 'phone'  , 'private_transport'  , 'public_transport'  , 'rail_travel'  , 'refreshments'  , 'restaurants'  , 'subscriptions'  , 'taxis'  , 'tolls'  , 'training'  , 'transport']

export const BankingCardLimitPeriodEnumValues: BankingCardLimitPeriodEnum[] = [ 'daily'  , 'monthly'  , 'weekly'  , 'yearly']

export const BankingCardLimitPoliciesEnumValues: BankingCardLimitPoliciesEnum[] = [ 'update']

export const BankingCardLimitTypeEnumValues: BankingCardLimitTypeEnum[] = [ 'allow'  , 'block']

export const BankingCardPoliciesEnumValues: BankingCardPoliciesEnum[] = [ 'activate'  , 'approve'  , 'cancel'  , 'change_alias'  , 'create_ephemeral_key'  , 'deactivate'  , 'reactivate'  , 'reject']

export const BankingCardholderPoliciesEnumValues: BankingCardholderPoliciesEnum[] = [ 'change_phone']

export const BankingDtosReconciliationFullExportExportFormatsEnumValues: BankingDtosReconciliationFullExportExportFormatsEnum[] = [ 'csv'  , 'xlsx']

export const BankingEntitiesBankAccountNumberFormatEnumValues: BankingEntitiesBankAccountNumberFormatEnum[] = [ 'bank_name_and_account_number'  , 'clabe'  , 'iban'  , 'other'  , 'routing_number_and_account_number'  , 'sort_code_and_account_number']

export const BankingEntitiesBeneficiariableTypeEnumValues: BankingEntitiesBeneficiariableTypeEnum[] = [ 'employee'  , 'finance_contact']

export const BankingEntitiesCardPaymentCalculatedLabelEnumValues: BankingEntitiesCardPaymentCalculatedLabelEnum[] = [ 'complete'  , 'decline'  , 'refund'  , 'reverse'  , 'withhold']

export const BankingEntitiesCardPaymentRejectedReasonEnumValues: BankingEntitiesCardPaymentRejectedReasonEnum[] = [ 'account_compliance_disabled'  , 'account_disabled'  , 'account_inactive'  , 'authentication_failed'  , 'authorization_controls'  , 'card_active'  , 'card_canceled'  , 'card_expired'  , 'card_inactive'  , 'cardholder_blocked'  , 'cardholder_inactive'  , 'cardholder_verification_required'  , 'incorrect_cvc'  , 'incorrect_expiry'  , 'insecure_authorization_method'  , 'insufficient_funds'  , 'not_allowed'  , 'pin_blocked'  , 'spending_controls'  , 'suspected_fraud'  , 'verification_failed'  , 'webhook_approved'  , 'webhook_declined'  , 'webhook_error'  , 'webhook_timeout']

export const BankingEntitiesCardPaymentStatusEnumValues: BankingEntitiesCardPaymentStatusEnum[] = [ 'closed'  , 'pending'  , 'rejected'  , 'reversed']

export const BankingEntitiesCardPaymentTypeEnumValues: BankingEntitiesCardPaymentTypeEnum[] = [ 'payment'  , 'refund']

export const BankingEntitiesConsentPurposeEnumValues: BankingEntitiesConsentPurposeEnum[] = [ 'account_membership'  , 'payment']

export const BankingEntitiesConsentStatusEnumValues: BankingEntitiesConsentStatusEnum[] = [ 'accepted'  , 'canceled'  , 'expired'  , 'init'  , 'pending']

export const BankingEntitiesPaymentStatusEnumValues: BankingEntitiesPaymentStatusEnum[] = [ 'done'  , 'in_progress'  , 'init'  , 'paid'  , 'partially_paid'  , 'pending_consent'  , 'rejected'  , 'rejected_consent']

export const BankingEntitiesTransactionRejectionReasonEnumValues: BankingEntitiesTransactionRejectionReasonEnum[] = [ 'card_error'  , 'creditor_error'  , 'debtor_error'  , 'factorial_error'  , 'provider_error'  , 'rejected_consent'  , 'technical_error'  , 'transfer_error'  , 'unknown_error']

export const BankingEntitiesTransactionStatusEnumValues: BankingEntitiesTransactionStatusEnum[] = [ 'done'  , 'in_progress'  , 'init'  , 'rejected']

export const BankingEntitiesTransactionTypeEnumValues: BankingEntitiesTransactionTypeEnum[] = [ 'card_payment'  , 'card_refund'  , 'dispute'  , 'fees'  , 'incoming'  , 'incoming_transfer'  , 'outgoing'  , 'outgoing_transfer'  , 'payment'  , 'payroll'  , 'topup'  , 'unknown']

export const BankingProvidersServicesEnumEnumValues: BankingProvidersServicesEnumEnum[] = [ 'bank_account_removal'  , 'bank_aggregation'  , 'card_management'  , 'external_bank_account'  , 'external_provider'  , 'import_data'  , 'onboarding'  , 'payment_management'  , 'payout_bank_account'  , 'sepa_payment_management']

export const BankingValueObjectsAuthorizationActionEnumValues: BankingValueObjectsAuthorizationActionEnum[] = [ 'bind_account_membership']

export const BankingValueObjectsCardCreationSourceEnumValues: BankingValueObjectsCardCreationSourceEnum[] = [ 'expenses'  , 'procurement'  , 'salary'  , 'software']

export const BankingValueObjectsCardSendingTypeEnumValues: BankingValueObjectsCardSendingTypeEnum[] = [ 'cardholder'  , 'company']

export const BankingValueObjectsCardShippingStatusEnumValues: BankingValueObjectsCardShippingStatusEnum[] = [ 'canceled'  , 'delivered'  , 'failure'  , 'pending'  , 'returned'  , 'shipped']

export const BankingValueObjectsCardStatusEnumValues: BankingValueObjectsCardStatusEnum[] = [ 'active'  , 'approved'  , 'canceled'  , 'inactive'  , 'pending'  , 'rejected'  , 'requested']

export const BankingValueObjectsCardTypeEnumValues: BankingValueObjectsCardTypeEnum[] = [ 'physical'  , 'single_use'  , 'virtual']

export const BankingValueObjectsDisputeStatusEnumValues: BankingValueObjectsDisputeStatusEnum[] = [ 'lost'  , 'pending'  , 'won']

export const BankingValueObjectsOnboardingCreationSourceValueEnumValues: BankingValueObjectsOnboardingCreationSourceValueEnum[] = [ 'accounts_payable'  , 'benefits'  , 'expenses'  , 'expensescombined'  , 'finance'  , 'payments'  , 'salary_advance'  , 'software']

export const BankingValueObjectsOnboardingStatusEnumValues: BankingValueObjectsOnboardingStatusEnum[] = [ 'completed'  , 'in_review'  , 'missing_information'  , 'pending'  , 'rejected'  , 'verification_pending']

export const BankingValueObjectsPaymentRequestItemStatusEnumValues: BankingValueObjectsPaymentRequestItemStatusEnum[] = [ 'in_payment'  , 'in_progress'  , 'init'  , 'paid'  , 'rejected']

export const BankingValueObjectsPaymentRequestSourceTypeEnumValues: BankingValueObjectsPaymentRequestSourceTypeEnum[] = [ 'compensation'  , 'expensable'  , 'invoice'  , 'payroll'  , 'salary_advance_request']

export const BankingValueObjectsPaymentRequestStatusEnumValues: BankingValueObjectsPaymentRequestStatusEnum[] = [ 'in_payment'  , 'in_progress'  , 'init'  , 'paid']

export const BankingValueObjectsProviderEnumValues: BankingValueObjectsProviderEnum[] = [ 'fake'  , 'go_cardless'  , 'manual'  , 'stripe'  , 'swan']

export const BankingValueObjectsReconcilableTypeEnumValues: BankingValueObjectsReconcilableTypeEnum[] = [ 'invoice'  , 'payment_execution']

export const BankingValueObjectsReconcilationTypeEnumValues: BankingValueObjectsReconcilationTypeEnum[] = [ 'normal'  , 'skipped']

export const BankingValueObjectsReconciliationStatusEnumValues: BankingValueObjectsReconciliationStatusEnum[] = [ 'pending'  , 'reconciled'  , 'snoozed']

export const BankingValueObjectsTransferSourceTypeEnumValues: BankingValueObjectsTransferSourceTypeEnum[] = [ 'compensation'  , 'expensable'  , 'invoice'  , 'payroll'  , 'salary_advance_request']

export const BankingValueObjectsTransferStatusEnumValues: BankingValueObjectsTransferStatusEnum[] = [ 'in_progress'  , 'init'  , 'paid'  , 'rejected']

export const BenefitsValueObjectsBenefitMembersMemberTypeEnumValues: BenefitsValueObjectsBenefitMembersMemberTypeEnum[] = [ 'child'  , 'employee'  , 'other_family'  , 'other_non_family'  , 'partner'  , 'spouse']

export const BenefitsValueObjectsBenefitMembersSexEnumValues: BenefitsValueObjectsBenefitMembersSexEnum[] = [ 'female'  , 'male']

export const BenefitsValueObjectsBenefitStatusEnumValues: BenefitsValueObjectsBenefitStatusEnum[] = [ 'active'  , 'inactive'  , 'pending'  , 'requested']

export const BenefitsValueObjectsBenefitTransactionCategoryEnumValues: BenefitsValueObjectsBenefitTransactionCategoryEnum[] = [ 'childcare'  , 'healthcare'  , 'meals'  , 'training'  , 'transportation'  , 'unsupported'  , 'wellness']

export const BenefitsValueObjectsBenefitTransactionCompensationStatusEnumValues: BenefitsValueObjectsBenefitTransactionCompensationStatusEnum[] = [ 'completed'  , 'discarded'  , 'pending'  , 'ready'  , 'reversed']

export const BenefitsValueObjectsTrainingsPaymentOptionEnumValues: BenefitsValueObjectsTrainingsPaymentOptionEnum[] = [ 'from_salary'  , 'paid_by_company']

export const BillingEntitiesCpInvoiceStatusEnumValues: BillingEntitiesCpInvoiceStatusEnum[] = [ 'not_paid'  , 'paid'  , 'payment_due'  , 'pending'  , 'posted'  , 'voided']

export const BillingEntitiesCpPaymentMethodPaymentSourceStatusEnumValues: BillingEntitiesCpPaymentMethodPaymentSourceStatusEnum[] = [ 'expired'  , 'invalid'  , 'valid']

export const BillingEntitiesCpPaymentMethodPaymentSourceTypeEnumValues: BillingEntitiesCpPaymentMethodPaymentSourceTypeEnum[] = [ 'bank_account'  , 'card'  , 'direct_debit']

export const BillingValueObjectsAtsAddonEnumValues: BillingValueObjectsAtsAddonEnum[] = [ 'ats_5_jobs'  , 'ats_10_jobs'  , 'ats_unlimited_jobs']

export const BookkeepersManagementValueObjectsIncidenceRuleEnforcementEnumValues: BookkeepersManagementValueObjectsIncidenceRuleEnforcementEnum[] = [ 'blockage'  , 'recommendation']

export const BookkeepersManagementValueObjectsIncidenceRuleValidityEnumValues: BookkeepersManagementValueObjectsIncidenceRuleValidityEnum[] = [ 'blocked'  , 'valid'  , 'warning']

export const CalendarValueObjectsEventTypeEnumValues: CalendarValueObjectsEventTypeEnum[] = [ 'birthday'  , 'firstday'  , 'leave'  , 'post'  , 'shiftmanagement'  , 'task'  , 'trainingsession'  , 'workiversary']

export const CompanyPagePerkCategoryTypeEnumValues: CompanyPagePerkCategoryTypeEnum[] = [ 'fitness'  , 'food'  , 'health'  , 'learning'  , 'other'  , 'time'  , 'transport']

export const CompensationsEmployeesCompensationPoliciesEnumValues: CompensationsEmployeesCompensationPoliciesEnum[] = [ 'editCompensations']

export const CompensationsValueObjectsAmountStrategyTypeEnumValues: CompensationsValueObjectsAmountStrategyTypeEnum[] = [ 'compensations_fixed_amount_strategy'  , 'compensations_variable_amount_strategy']

export const CompensationsValueObjectsEmployeeCompensationSourceTypeEnumValues: CompensationsValueObjectsEmployeeCompensationSourceTypeEnum[] = [ 'benefits_compensation'  , 'compensations_compensationpolicy'  , 'expenses_expensable'  , 'expenses_expense'  , 'expenses_mileage'  , 'timesettings_customtimerangecategory']

export const CompensationsValueObjectsEmployeeCompensationValidationTypeEnumValues: CompensationsValueObjectsEmployeeCompensationValidationTypeEnum[] = [ 'above_limit'  , 'discrepancy'  , 'pending_to_define']

export const CompensationsValueObjectsEmployeeStatusEnumValues: CompensationsValueObjectsEmployeeStatusEnum[] = [ 'active'  , 'inactive_last_3_months'  , 'inactive_this_month']

export const CompensationsValueObjectsFileCategoryTypeEnumValues: CompensationsValueObjectsFileCategoryTypeEnum[] = [ 'exported'  , 'others'  , 'payment_method'  , 'payroll_result'  , 'payslips']

export const CompensationsValueObjectsFileStatusEnumValues: CompensationsValueObjectsFileStatusEnum[] = [ 'imported'  , 'pending']

export const CompensationsValueObjectsPaymentRequestStatusEnumValues: CompensationsValueObjectsPaymentRequestStatusEnum[] = [ 'in_progress'  , 'paid']

export const CompensationsValueObjectsPayrollRunStatusEnumValues: CompensationsValueObjectsPayrollRunStatusEnum[] = [ 'calculation'  , 'closed'  , 'completed'  , 'in_preparation'  , 'in_review'  , 'open'  , 'opened']

export const CompensationsValueObjectsResultTypeEnumValues: CompensationsValueObjectsResultTypeEnum[] = [ 'compensation'  , 'payroll_result']

export const CompetenciesEntitiesJobCatalogTreeSuggestionStatusEnumValues: CompetenciesEntitiesJobCatalogTreeSuggestionStatusEnum[] = [ 'completed'  , 'failed'  , 'processing']

export const ComplaintsStatusEnumValues: ComplaintsStatusEnum[] = [ 'acknowledged'  , 'archived'  , 'completed'  , 'created'  , 'discarded']

export const ContextlessPoliciesEnumValues: ContextlessPoliciesEnum[] = [ 'Analytics_sidebarSeeAnalyticsInsightsSubLevelItem'  , 'Analytics_sidebarSeeAnalyticsReportsSubLevelItem'  , 'Analytics_sidebarSeeAnalyticsTopLevelItem'  , 'ApiCore_accessCreateExternal'  , 'ApiCore_accessDownloadLeaves'  , 'ApiCore_accessEnpsCreateForms'  , 'ApiCore_accessEnpsSeeForms'  , 'ApiCore_accessReadOrgChart'  , 'ApiCore_accessReadPeopleChart'  , 'ApiCore_accessSurveysSeeForms'  , 'ApiCore_companyCreateLegalEntities'  , 'ApiCore_companyManageAdmins'  , 'ApiCore_companyManageCustomNotifications'  , 'ApiCore_companyManageCustomization'  , 'ApiCore_companyManagePermissions'  , 'ApiCore_companySeeEmployeeProfile'  , 'ApiCore_companySeeLegalEntityEmployees'  , 'ApiCore_customTablesBulkImport'  , 'ApiCore_employeeCreate'  , 'ApiCore_manageDiscoverabilityWidget'  , 'ApiCore_seeAllSettingsPages'  , 'ApiCore_seeReferralProgramPage'  , 'ApiCore_sidebarSeeSettingsTopLevelItem'  , 'ApiPublic_coreApiKeyManage'  , 'Approvals_approvalFlowsView'  , 'Approvals_approvalGroupMembershipsAssign'  , 'Approvals_approvalGroupMembershipsView'  , 'Approvals_approvalGroupsCreate'  , 'Approvals_approvalGroupsDelete'  , 'Approvals_approvalGroupsEdit'  , 'Approvals_approvalStepApproversEdit'  , 'Approvals_approvalStepApproversView'  , 'Approvals_globalApproverUse'  , 'Ats_callCandidate'  , 'Ats_createJobPostings'  , 'Ats_dashboardWidgetOpenPositionsVisible'  , 'Ats_manageAtsSettings'  , 'Ats_manageJobPostings'  , 'Ats_managementEnabled'  , 'Ats_messageTemplatesManageCompanyMessageTemplates'  , 'Ats_requisitionsManage'  , 'Ats_requisitionsUse'  , 'Ats_salaryManage'  , 'Ats_seeActiveJobsLimit'  , 'Ats_sidebarSeeRecruitmentCandidatesSubLevelItem'  , 'Ats_sidebarSeeRecruitmentInboxSubLevelItem'  , 'Ats_sidebarSeeRecruitmentInsightsSubLevelItem'  , 'Ats_sidebarSeeRecruitmentJobsSubLevelItem'  , 'Ats_sidebarSeeRecruitmentOpenPositionsSubLevelItem'  , 'Ats_sidebarSeeRecruitmentPurchaseRequestsSubLevelItem'  , 'Ats_sidebarSeeRecruitmentTopLevelItem'  , 'Ats_useAts'  , 'Attendance_accessEditSettings'  , 'Attendance_brazilianExportAccess'  , 'Attendance_companyApproveAttendance'  , 'Attendance_companyCalendarAccess'  , 'Attendance_companyReadAttendance'  , 'Attendance_companySeeClockedIn'  , 'Attendance_companySeeOthers'  , 'Attendance_companySeeOwned'  , 'Attendance_dashboardWidgetSeeAttendanceWidget'  , 'Attendance_dashboardWidgetTimeTrackingVisible'  , 'Attendance_dashboardWidgetWhoIsInVisible'  , 'Attendance_shiftAutofill'  , 'Attendance_sidebarSeeAttendanceCompanyTopLevelItem'  , 'Attendance_sidebarSeeAttendanceEmployeeTopLevelItem'  , 'Attendance_sidebarSeeAttendanceTimeTrackingAdminSubLevelItem'  , 'Attendance_sidebarSeeAttendanceTopLevelItem'  , 'AuditLog_seeAuditLog'  , 'Authentication_accessCreateExternal'  , 'Authentication_accessEditExternal'  , 'Automations_manageCustomNotifications'  , 'Banking_bankAccountRead'  , 'Banking_bankAccountsManage'  , 'Banking_bankAccountsSeeDetailPage'  , 'Banking_cardPaymentRead'  , 'Banking_consentChangeStatus'  , 'Banking_consentRead'  , 'Banking_paymentManage'  , 'Banking_payoutBankAccountRead'  , 'Banking_reconciliationBulkManage'  , 'Banking_reconciliationRead'  , 'Banking_reconciliationSuggestionConfirmOrReject'  , 'Banking_reconciliationsSeeFinancialDocumentsPage'  , 'Banking_reconciliationsSeeJournalEntriesPage'  , 'Banking_transactionCategorize'  , 'Banking_transactionRead'  , 'Benefits_benefitsActive'  , 'Benefits_canChangeCycleDay'  , 'Benefits_sidebarSeeBenefitsTopLevelItem'  , 'Benefits_sidebarSeeMyBenefitsTopLevelItem'  , 'Billing_subscriptionManageSubscription'  , 'Billing_subscriptionPurchaseSubscription'  , 'Billing_subscriptionUpgradeSubscription'  , 'BookkeepersManagement_seePayrollIncidencesSettings'  , 'Calendar_sidebarSeeCalendarCalendarSubLevelItem'  , 'CompanyPage_manageCompanyPage'  , 'Compensations_compensationActivityManage'  , 'Compensations_employeeCompensationBulkImport'  , 'Compensations_employeeCompensationExport'  , 'Compensations_payrollConceptsEdit'  , 'Compensations_payrollResultImport'  , 'Compensations_payrollRunToggleLockStatus'  , 'Compensations_settingsSeeCompensationsSettings'  , 'Compensations_sidebarSeeCompensationsInHouseActivationSubLevelItem'  , 'Compensations_sidebarSeeCompensationsIncidencesSubLevelItem'  , 'Compensations_sidebarSeeCompensationsTopLevelItem'  , 'Competencies_competenciesManage'  , 'Competencies_competencyGroupsManage'  , 'Competencies_sidebarSeePerformanceCompetenciesSubLevelItem'  , 'Complaints_hasComplaints'  , 'Complaints_manageComplaints'  , 'Complaints_sidebarSeeComplaintsTopLevelItem'  , 'Complaints_use'  , 'ContractsImporter_contractsImporterImportContracts'  , 'Contracts_contractBulkCreateAdditionalCompensationType'  , 'Contracts_contractEditContractVersion'  , 'Contracts_contractEditContractsSettings'  , 'Contracts_contractPromote'  , 'Contracts_contractSeeAdditionalCompensation'  , 'Contracts_contractSeeContractType'  , 'Contracts_contractSeeEndDate'  , 'Contracts_contractSeeGrossSalary'  , 'Contracts_contractSeeJobTitle'  , 'Contracts_contractSeePayroll'  , 'Contracts_contractSeePendingPromotions'  , 'Contracts_contractSeeStartDate'  , 'Contracts_contractSeeTrialPeriod'  , 'Contracts_contractSeeTrialPeriodEndDate'  , 'Contracts_contractSeeWorkingDayType'  , 'Contracts_contractSeeWorkingHours'  , 'Contracts_sidebarSeeProfileContractsSubLevelItem'  , 'Contracts_weeksPerMonthConfigurationCreate'  , 'Contracts_weeksPerMonthConfigurationRead'  , 'Contracts_weeksPerMonthConfigurationUpdate'  , 'Contracts_weeksPerMonthConfigurationUpsert'  , 'CostCenters_costCentersManageCostCenters'  , 'CostCenters_costCentersSeeCostCenters'  , 'CostCenters_featuresCostCenterManagement'  , 'CustomFields_companyCreateCustomFields'  , 'CustomFields_fieldCreate'  , 'CustomFields_fieldDocumentsCreate'  , 'CustomerPortal_subscriptionManageSubscription'  , 'Dashboard_dashboardWidgetCompanyLinksVisible'  , 'Dashboard_sidebarSeeDashboardTopLevelItem'  , 'Documents_companyEditInternalDocuments'  , 'Documents_companyEditPublicDocuments'  , 'Documents_companyManageEmployeesFolders'  , 'Documents_companyManageFolders'  , 'Documents_companyManagePublicCompanyFolders'  , 'Documents_companySeeInternalDocuments'  , 'Documents_companySeePublicDocuments'  , 'Documents_companyUseCompanyDocuments'  , 'Documents_employeeEditAnyEmployeeFolder'  , 'Documents_employeeEditDocuments'  , 'Documents_employeeEditDocumentsTrashBin'  , 'Documents_employeeManageAnyEmployeeFolder'  , 'Documents_employeeManageDefaultEmployeeFolder'  , 'Documents_employeeSeeEmployeeFiles'  , 'Documents_sidebarSeeDocumentsDocumentsSubLevelItem'  , 'Documents_sidebarSeeDocumentsTopLevelItem'  , 'Documents_sidebarSeeFilesBulkFilesSubLevelItem'  , 'Documents_sidebarSeeFilesDocumentTemplatesSubLevelItem'  , 'Documents_sidebarSeeFilesEmployeeFilesSubLevelItem'  , 'Documents_sidebarSeeFilesManagementDocumentsSubLevelItem'  , 'Documents_sidebarSeeFilesPublicDocumentsSubLevelItem'  , 'Documents_sidebarSeeFilesTopLevelItem'  , 'Documents_sidebarSeeTrash'  , 'Documents_templateManageDocumentTemplates'  , 'Documents_withoutFolderEverybodyEditEmployeeDocumentsWithoutFolder'  , 'EmployeeOnboarding_sidebarSeeEmployeeOnboardingTopLevelItem'  , 'Employees_addCustomTableRecords'  , 'Employees_assignEmployeeManager'  , 'Employees_assignEmployeePermissionGroup'  , 'Employees_assignEmployeeToWorkflow'  , 'Employees_editEmployeesInBulkButton'  , 'Employees_employeeSeeAggregatedPersonalInfo'  , 'Employees_exportEmployees'  , 'Employees_exportOrgChart'  , 'Employees_inviteEmployee'  , 'Employees_manageCustomTableSettings'  , 'Employees_removeCustomTableRecords'  , 'Employees_seeAdminWelcomeSpace'  , 'Employees_seeEmployeeLegalGender'  , 'Employees_seeFormerEmployees'  , 'Employees_seeFutureEmployees'  , 'Employees_sidebarSeeEmployeesOrgChartSubLevelItem'  , 'Employees_sidebarSeeEmployeesTopLevelItem'  , 'Employees_sidebarSeeProfileContractVersionsSubLevelItem'  , 'Employees_sidebarSeeProfileCustomTablesSubLevelItem'  , 'Employees_sidebarSeeProfilePersonalSubLevelItem'  , 'Employees_sidebarSeeProfilePlanningVersionsSubLevelItem'  , 'Employees_sidebarSeeProfileTopLevelItem'  , 'EngagementInsights_sidebarSeeEngagementInsightsSubLevelItem'  , 'EngagementInsights_sidebarSeeEngagementTopLevelItem'  , 'Engagement_seePulseDashboard'  , 'Engagement_settingsManage'  , 'Enps_createForms'  , 'Enps_manageEnps'  , 'Enps_sidebarSeeEngagementEnpsSubLevelItem'  , 'Expenses_cardManageCards'  , 'Expenses_cardRequestSingleUseCards'  , 'Expenses_expenseCreateExpenses'  , 'Expenses_expenseCreateExpensesForOthers'  , 'Expenses_expenseCustomizeSettings'  , 'Expenses_expenseManageExpensables'  , 'Expenses_expenseManageExpenses'  , 'Expenses_expenseOverrideApprovalFlow'  , 'Expenses_expenseRestartApprovalFlow'  , 'Expenses_expenseSeeEmployeeLegalEntity'  , 'Expenses_expenseSendToReimburseThroughPayments'  , 'Expenses_expenseSendToReimburseThroughPayroll'  , 'Expenses_expenseSetToPaid'  , 'Expenses_internalExpenseViewerEnabledContextless'  , 'Expenses_recommendationsEnabledContextless'  , 'Expenses_settingsSeeExpensesSettings'  , 'Expenses_sidebarSeeExpensesBudgetsSubLevelItem'  , 'Expenses_sidebarSeeExpensesExpensesSubLevelItem'  , 'Expenses_sidebarSeeExpensesProcurementPurchaseOrderSubLevelItem'  , 'Expenses_sidebarSeeExpensesProcurementPurchaseRequestSubLevelItem'  , 'Expenses_sidebarSeeExpensesReportsSubLevelItem'  , 'Expenses_sidebarSeeExpensesSpendingPoliciesSubLevelItem'  , 'Expenses_sidebarSeeExpensesSubModule'  , 'Expenses_sidebarSeeExpensesTopLevelItem'  , 'Expenses_sidebarSeeMyExpensesMyCardsSubLevelItem'  , 'Expenses_sidebarSeeMyExpensesMyExpensesSubLevelItem'  , 'Expenses_sidebarSeeMyExpensesTopLevelItem'  , 'Features_featureRead'  , 'Features_featureReset'  , 'Features_featureToggle'  , 'Feedbacks_sidebarSeePerformanceFeedbacksSubLevelItem'  , 'Finance_accountingManageAccountResources'  , 'Finance_accountingManageAccounts'  , 'Finance_accountingManageCustomCategoriesAccounts'  , 'Finance_accountingSeeAccounts'  , 'Finance_accountingSeePurchaseAccounts'  , 'Finance_accountingSeeSalesAccounts'  , 'Finance_budgetsCreateBudgets'  , 'Finance_budgetsManageBudgets'  , 'Finance_budgetsSeeBudgets'  , 'Finance_complianceExtraFieldDefaultSettingsManage'  , 'Finance_complianceSnapshotsSeeComplianceSnapshot'  , 'Finance_contactsCreateOrUpdate'  , 'Finance_contactsDelete'  , 'Finance_contactsManageBasicData'  , 'Finance_contactsManagePaymentData'  , 'Finance_contactsSee'  , 'Finance_contactsSeeTaxIdType'  , 'Finance_costCenterMembershipsBulkImportCostCenterMemberships'  , 'Finance_costCenterMembershipsEmployeeSeeCostCenterMemberships'  , 'Finance_costCentersManageCostCenters'  , 'Finance_costCentersSeeCostCenters'  , 'Finance_customDimensionsManage'  , 'Finance_customDimensionsSee'  , 'Finance_financialDocumentsCreatePurchase'  , 'Finance_financialDocumentsCreateSale'  , 'Finance_financialDocumentsManagePurchase'  , 'Finance_financialDocumentsManageSales'  , 'Finance_financialDocumentsSeeComplianceExtraFieldConfigs'  , 'Finance_financialSequencesManage'  , 'Finance_journalEntriesManage'  , 'Finance_journalEntriesManagePurchase'  , 'Finance_journalEntriesManagePurchaseInAccountsPayable'  , 'Finance_quotesCreate'  , 'Finance_salesDocumentTemplatesManage'  , 'Finance_settingsSeeAccountingSettings'  , 'Finance_settingsSeeAccountingSettingsCustomCategories'  , 'Finance_settingsSeeAccountingSettingsLedgerAccounts'  , 'Finance_settingsSeeAccountingSettingsTaxTypes'  , 'Finance_settingsSeeAnalyticalDimensionsSettings'  , 'Finance_settingsSeeCostCentersSettings'  , 'Finance_settingsSeeFinanceCategory'  , 'Finance_settingsSeeSalesSettings'  , 'Finance_sidebarSeeFinanceAccountingSubLevelItem'  , 'Finance_sidebarSeeFinanceAccountsSubLevelItem'  , 'Finance_sidebarSeeFinanceCardsSubLevelItem'  , 'Finance_sidebarSeeFinanceClientsSubLevelItem'  , 'Finance_sidebarSeeFinanceDealsSubLevelItem'  , 'Finance_sidebarSeeFinanceFinancialWorkspaceSubLevelItem'  , 'Finance_sidebarSeeFinanceInvoicesSubLevelItem'  , 'Finance_sidebarSeeFinanceOverviewSubLevelItem'  , 'Finance_sidebarSeeFinancePaymentsSubLevelItem'  , 'Finance_sidebarSeeFinanceQuotesSubLevelItem'  , 'Finance_sidebarSeeFinanceTopLevelItem'  , 'Finance_sidebarSeeFinanceVendorsSubLevelItem'  , 'Finance_spendingPoliciesSee'  , 'Finance_spendingPolicyCreate'  , 'Finance_spendingPolicyDelete'  , 'Finance_spendingPolicyUpdate'  , 'Finance_taxTypeCreate'  , 'Finance_taxTypeUpdate'  , 'FinancialWorkspace_compensationsSee'  , 'FinancialWorkspace_expensesSee'  , 'FinancialWorkspace_payrollSee'  , 'FinancialWorkspace_seeAllCompanyData'  , 'FinancialWorkspace_seeFinancialWorkspace'  , 'Goals_createMetricGroup'  , 'Goals_sidebarSeePerformanceGoalsV2SubLevelItem'  , 'HandbookPages_editHandbookPages'  , 'HandbookPages_seeHandbookPages'  , 'InAppComms_canSeeInAppComms'  , 'IntegrationsBase_seeAppStore'  , 'IntegrationsJoin_ordersManageRequests'  , 'IntegrationsJoin_useJoinIntegration'  , 'Intercom_allowIntercom'  , 'Iris_aiAnalyticsAiAnalyticsEnabled'  , 'Iris_aiAnalyticsSeeAiAnalytics'  , 'Iris_aiAnalyticsSidebarSeeAiReportsSubLevelItem'  , 'ItManagement_manageIt'  , 'ItManagement_settingsSeeItManagementSettings'  , 'ItManagement_sidebarSeeDeviceCatalogItem'  , 'ItManagement_sidebarSeeFactorialItItem'  , 'ItManagement_sidebarSeeItManagementItem'  , 'JobCatalog_createJob'  , 'JobCatalog_editJob'  , 'JobCatalog_jobCatalogTreeManage'  , 'JobCatalog_jobCatalogTreeReimport'  , 'JobCatalog_jobCatalogTreeSee'  , 'JobCatalog_seeJobCatalog'  , 'JobCatalog_sidebarSeeEmployeesJobCatalogSubLevelItem'  , 'Kudos_sidebarSeeKudosTopLevelItem'  , 'Locations_locationManage'  , 'Locations_workAreaManage'  , 'Marketplace_installationInstallCompanyWideIntegration'  , 'Marketplace_marketplaceSeeMarketplace'  , 'Marketplace_sidebarSeeMarketplaceAppStoreSubLevelItem'  , 'Marketplace_sidebarSeeMarketplaceSubLevelItem'  , 'Meetings_seeAdvancedMeetings'  , 'Meetings_seeMeetings'  , 'Modules_marketplaceRevampSeeMarketplaceRevamp'  , 'Modules_moduleManageModule'  , 'Modules_sidebarSeeModulesSubLevelItem'  , 'Notifications_dashboardWidgetPendingNotificationsVisible'  , 'Notifications_sidebarSeeNotificationsTopLevelItem'  , 'Nps_showNpsWidget'  , 'OauthApplicationPolicy_manageOauthApplication'  , 'OnboardingImporter_importCustomTables'  , 'OnboardingImporter_importEmployees'  , 'Onboarding_sidebarSeeOnboardingTopLevelItem'  , 'OneOnOnes_commandBarCreateOneOnOne'  , 'OneOnOnes_fullVisibility'  , 'OneOnOnes_sidebarSeePerformanceOneOnOnesSubLevelItem'  , 'OpenAi_useOne'  , 'Pages_seeCompanyPages'  , 'PayrollIntegrations_managePayrollIntegrationCodes'  , 'Payroll_companyManagePayroll'  , 'Payroll_conceptsManageLaborCost'  , 'Payroll_createSupplementsFromExpenses'  , 'Payroll_downloadPayrollData'  , 'Payroll_editSupplements'  , 'Payroll_managePayrollIncidences'  , 'Payroll_managePayrollPolicies'  , 'Payroll_periodChangePayrollPeriodStatus'  , 'Payroll_resultsSeeCompanyPayrollResults'  , 'Payroll_resultsSeeOwnPayrollResults'  , 'Payroll_seeCompanySepaGenerator'  , 'Payroll_seePayrollIssues'  , 'Payroll_seeSupplements'  , 'Payroll_settingsSeePayrollSettings'  , 'Payroll_sidebarSeeMyPayrollTopLevelItem'  , 'Payroll_sidebarSeePayrollBundleCycleSubLevelItem'  , 'Payroll_sidebarSeePayrollBundleInHouseActivationSubLevelItem'  , 'Payroll_sidebarSeePayrollBundleIncidencesSubLevelItem'  , 'Payroll_sidebarSeePayrollBundleSalaryCardSubLevelItem'  , 'Payroll_sidebarSeePayrollBundleTopLevelItem'  , 'Payroll_supplementsImportSupplements'  , 'Payroll_supplementsSeeEverybody'  , 'Payroll_supplementsSeeOwned'  , 'Payroll_supplementsSeeReportees'  , 'Payroll_supplementsSeeTeam'  , 'Payroll_upsellSeeActivationPromo'  , 'Payroll_usePayroll'  , 'PeopleChart_sidebarSeeEmployeesPeopleChartSubLevelItem'  , 'PerformanceCycles_cycleManage'  , 'PerformanceCycles_cycleRead'  , 'PerformanceCycles_sidebarSeePerformanceCyclesSubLevelItem'  , 'Performance_createCustomTemplate'  , 'Performance_createReviewProcessContextless'  , 'Performance_manageProcessTemplates'  , 'Performance_reviewProcessFullVisibilityContextless'  , 'Performance_seePerformanceAnalytics'  , 'Performance_seePerformanceAnalyticsPage'  , 'Performance_seeProcessTemplates'  , 'Performance_settingsSeePerformanceReviewProcessSettings'  , 'Performance_sidebarSeeAnalyticsSubLevelItem'  , 'Performance_sidebarSeePerformanceReviewProcessSubLevelItem'  , 'Performance_sidebarSeePerformanceTopLevelItem'  , 'Permissions_commandBarSeeInsights'  , 'Permissions_editExternalUsers'  , 'Permissions_groupAssignEmployees'  , 'Permissions_groupCreate'  , 'Permissions_groupCreateExternalUsers'  , 'Permissions_groupDuplicate'  , 'Permissions_groupEdit'  , 'Permissions_insightsSeeInsights'  , 'Permissions_permissionsRead'  , 'Permissions_roleTemplateApply'  , 'Positions_managePosition'  , 'Posts_dashboardWidgetNextEventsVisible'  , 'Posts_groupCanPostSomewhere'  , 'Posts_groupCreate'  , 'Posts_postsManage'  , 'Processes_processEditProcesses'  , 'Processes_sidebarSeeProcessesCustomSubLevelItem'  , 'Processes_sidebarSeeProcessesOffboardingSubLevelItem'  , 'Processes_sidebarSeeProcessesOnboardingSubLevelItem'  , 'Processes_sidebarSeeProcessesTopLevelItem'  , 'Procurement_featuresPurchaseOrders'  , 'Procurement_featuresPurchaseRequests'  , 'Procurement_purchaseOrderManage'  , 'Procurement_purchaseOrderRead'  , 'Procurement_purchaseRequestCreate'  , 'Procurement_purchaseRequestManage'  , 'Procurement_purchaseRequestManageSettings'  , 'Procurement_purchaseRequestRead'  , 'Procurement_settingsManage'  , 'Procurement_settingsSeeProcurementSettings'  , 'Procurement_sidebarSeeMyExpensesPurchaseRequestSubLevelItem'  , 'ProductUpdates_seeWaitlistBanners'  , 'ProductUpdates_shareProductUpdate'  , 'ProductUpdates_sidebarSeeProductUpdatesSubLevelItem'  , 'ProductUpdates_upsellButtonSeeUpsellButton'  , 'ProjectManagement_commandBarManageProjects'  , 'ProjectManagement_expenseRecordLink'  , 'ProjectManagement_expenseRecordRead'  , 'ProjectManagement_flexibleTimeRecordRead'  , 'ProjectManagement_globalTimeRecordRead'  , 'ProjectManagement_pagesSeeContributorsList'  , 'ProjectManagement_pagesSeeContributorsListUpsell'  , 'ProjectManagement_pagesSeeJobsAndRates'  , 'ProjectManagement_pagesSeeJobsAndRatesUpsell'  , 'ProjectManagement_pagesSeeProjectsRoot'  , 'ProjectManagement_pagesSeeScheduleContributors'  , 'ProjectManagement_pagesSeeScheduleContributorsUpsell'  , 'ProjectManagement_projectCreate'  , 'ProjectManagement_projectInvoiceManageInvoices'  , 'ProjectManagement_projectManage'  , 'ProjectManagement_projectSeeCost'  , 'ProjectManagement_projectSeeLaborCost'  , 'ProjectManagement_projectSoftDelete'  , 'ProjectManagement_projectTaskManage'  , 'ProjectManagement_projectWorkerRead'  , 'ProjectManagement_rateManage'  , 'ProjectManagement_sidebarSeeMyProjectsTopLevelItem'  , 'ProjectManagement_sidebarSeeProjectsTopLevelItem'  , 'ProjectManagement_subprojectHoursDistributionRead'  , 'ProjectManagement_subprojectRead'  , 'ProjectManagement_timeRecordRead'  , 'Reports_commandBarUseReports'  , 'Reports_useReports'  , 'SalaryAdvance_manageSalaryAdvance'  , 'SalaryAdvance_salaryAdvanceEnabled'  , 'SecuritySettings_updateCompanyConfig'  , 'ShiftManagement_accessManageShifts'  , 'ShiftManagement_accessManageTemplates'  , 'ShiftManagement_accessManageUnassignedShifts'  , 'ShiftManagement_accessSeeTimeInsights'  , 'ShiftManagement_defaultShiftManage'  , 'ShiftManagement_insightsSeeEverybody'  , 'ShiftManagement_shiftCreateEverybody'  , 'ShiftManagement_shiftCreateReportees'  , 'ShiftManagement_shiftCreateSelf'  , 'ShiftManagement_shiftCreateTeam'  , 'ShiftManagement_shiftSeeEverybody'  , 'ShiftManagement_shiftSeeReportees'  , 'ShiftManagement_shiftSeeSelf'  , 'ShiftManagement_shiftSeeTeam'  , 'ShiftManagement_sidebarSeeShiftsTopLevelItem'  , 'ShiftManagement_swapShiftCreate'  , 'ShiftManagement_unassignedShiftCreateEverybody'  , 'ShiftManagement_unassignedShiftCreateReportees'  , 'ShiftManagement_unassignedShiftCreateSelf'  , 'ShiftManagement_unassignedShiftCreateTeam'  , 'SoftwareManagement_manageSoftware'  , 'SoftwareManagement_settingsSeeSoftwareSettings'  , 'SoftwareManagement_sidebarSeeSoftwareSubModule'  , 'SoftwareManagement_sidebarSeeSoftwareTopLevelItem'  , 'SpaceControl_bookingCancelEverybody'  , 'SpaceControl_bookingCancelSelf'  , 'SpaceControl_bookingEditEverybody'  , 'SpaceControl_bookingEditSelf'  , 'SpaceControl_bookingSeeEverybody'  , 'SpaceControl_bookingSeeOwned'  , 'SpaceControl_sidebarSeeSpaceControlTopLevelItem'  , 'SpaceControl_workSpaceCreate'  , 'SpaceControl_workSpaceDelete'  , 'SpaceControl_workSpaceRead'  , 'SpaceControl_workSpaceUpdate'  , 'Surveys_createForms'  , 'Surveys_createSurveyTemplates'  , 'Surveys_sidebarSeeEngagementSurveysSubLevelItem'  , 'Surveys_sidebarSeeSmartSurveysSubLevelItem'  , 'Surveys_surveyCreateEverybody'  , 'Surveys_surveyCreateOwned'  , 'Surveys_surveyCreateReportees'  , 'Surveys_surveyCreateTeam'  , 'Surveys_surveysCreateSurvey'  , 'Surveys_v2ManageSurveys'  , 'Tasks_showProjectsUpsellModal'  , 'Tasks_sidebarSeeTasksTopLevelItem'  , 'Teams_companySeeTeams'  , 'Teams_companySeeTeamsSection'  , 'Teams_dashboardWidgetTeamsBelongToVisible'  , 'Teams_dashboardWidgetTeamsDirectReportsVisible'  , 'Teams_sidebarSeeCalendarTeamViewSubLevelItem'  , 'Teams_sidebarSeeEmployeesTeamsSubLevelItem'  , 'Teams_teamCreate'  , 'Teams_teamManage'  , 'TimeBalance_accessSeeTimeBalanceExport'  , 'TimeBalance_exportSeeEverybody'  , 'TimePlanning_planningVersionCreateEverybody'  , 'TimePlanning_planningVersionCreateOwned'  , 'TimePlanning_planningVersionCreateReportees'  , 'TimePlanning_planningVersionCreateTeam'  , 'TimePlanning_planningVersionSeeOwned'  , 'TimeSettings_manageBreakConfigurations'  , 'TimeSettings_manageTimeRangeCategories'  , 'Timeoff_companyManageTimeoff'  , 'Timeoff_dashboardWidgetUpcomingAbsencesVisible'  , 'Timeoff_dashboardWidgetUpcomingHolidaysVisible'  , 'Timeoff_sidebarSeeTimeoffTopLevelItem'  , 'Trainings_insightRead'  , 'Trainings_settingsManageSettings'  , 'Trainings_sidebarSeeMyRequestsSubLevelItem'  , 'Trainings_sidebarSeeMyTrainingsTopLevelItem'  , 'Trainings_sidebarSeeTrainingsCatalogSubLevelItem'  , 'Trainings_sidebarSeeTrainingsTopLevelItem'  , 'Trainings_trainingCreate'  , 'Trainings_trainingsAccessManagementSpace'  , 'Trainings_trainingsRequestsCreate'  , 'Trainings_trainingsSeeCatalog'  , 'Trial_companyOnboardingShowCompanyOnboarding'  , 'Trial_trialEmployeeBulkDelete'  , 'UniversalImporter_importResources'  , 'Upsell_canJoinOneWaitlist'  , 'Upsell_canRequestUpsell'  , 'Upsell_canSeeBlackFridayPromo'  , 'WorkSchedule_manageCompanySchedules']

export const ContractsAdditionalCompensationRecurrenceEnumValues: ContractsAdditionalCompensationRecurrenceEnum[] = [ 'every_2_months'  , 'every_3_months'  , 'every_4_months'  , 'every_5_months'  , 'every_6_months'  , 'every_7_months'  , 'every_8_months'  , 'every_9_months'  , 'every_10_months'  , 'every_11_months'  , 'every_12_months'  , 'monthly']

export const ContractsAnnualWorkingTimeDistributionEnumValues: ContractsAnnualWorkingTimeDistributionEnum[] = [ 'limit_daily_hours'  , 'limit_workdays']

export const ContractsBankHolidayTreatmentEnumValues: ContractsBankHolidayTreatmentEnum[] = [ 'non_workable'  , 'workable']

export const ContractsCompensationsTypesEnumValues: ContractsCompensationsTypesEnum[] = [ 'fixed'  , 'per_worked_day'  , 'per_worked_hour'  , 'undefined'  , 'up_to']

export const ContractsContractVersionHistoryActionTypeEnumValues: ContractsContractVersionHistoryActionTypeEnum[] = [ 'evolution'  , 'fix'  , 'promotion']

export const ContractsContractVersionPoliciesEnumValues: ContractsContractVersionPoliciesEnum[] = [ 'delete'  , 'edit'  , 'promote'  , 'see_additional_compensation'  , 'see_contract_extra_info'  , 'see_contract_type'  , 'see_end_date'  , 'see_gross_salary'  , 'see_job_title'  , 'see_payroll_policy'  , 'see_start_date'  , 'see_trial_period'  , 'see_trial_period_end_date'  , 'see_working_day_type'  , 'see_working_hours']

export const ContractsContractVersionRequestPoliciesEnumValues: ContractsContractVersionRequestPoliciesEnum[] = [ 'promote']

export const ContractsReferenceContractPoliciesEnumValues: ContractsReferenceContractPoliciesEnum[] = [ 'delete'  , 'edit'  , 'promote'  , 'see_additional_compensation'  , 'see_contract_type'  , 'see_end_date'  , 'see_extra_info'  , 'see_gross_salary'  , 'see_job_title'  , 'see_payroll_policy'  , 'see_start_date'  , 'see_trial_period'  , 'see_trial_period_end_date'  , 'see_working_day_type'  , 'see_working_hours']

export const ContractsValueObjectsAmountStrategyTypeEnumValues: ContractsValueObjectsAmountStrategyTypeEnum[] = [ 'contracts_fixed_amount_strategy'  , 'contracts_variable_amount_strategy']

export const ContractsValueObjectsContractActivityGroupsTypeEnumValues: ContractsValueObjectsContractActivityGroupsTypeEnum[] = [ 'activity'  , 'inactivity']

export const ContractsValueObjectsContractScheduleEnumValues: ContractsValueObjectsContractScheduleEnum[] = [ 'expired'  , 'ongoing'  , 'upcoming']

export const ContractsValueObjectsTimeConditionEnumValues: ContractsValueObjectsTimeConditionEnum[] = [ 'custom'  , 'full_day'  , 'half_day']

export const ContractsWeeksPerMonthConfigurationOptionEnumValues: ContractsWeeksPerMonthConfigurationOptionEnum[] = [ 'days_in_a_year_based'  , 'weeks_in_a_year_based']

export const CostCentersValueObjectsCostCenterStatusEnumValues: CostCentersValueObjectsCostCenterStatusEnum[] = [ 'active'  , 'inactive']

export const CostCentersValueObjectsProcessingStatusEnumValues: CostCentersValueObjectsProcessingStatusEnum[] = [ 'completed'  , 'failed'  , 'pending'  , 'processing']

export const CostCentersValueObjectsStructureEnumValues: CostCentersValueObjectsStructureEnum[] = [ 'job_catalog_family'  , 'job_catalog_function'  , 'job_catalog_role'  , 'workplace']

export const CustomFieldsFieldTypeEnumValues: CustomFieldsFieldTypeEnum[] = [ 'cents'  , 'checkbox'  , 'date'  , 'long_text'  , 'money'  , 'multiple_choice'  , 'rating'  , 'single_choice'  , 'text']

export const CustomFieldsValueObjectsValuableTypeEnumValues: CustomFieldsValueObjectsValuableTypeEnum[] = [ 'contracts_contractversion'  , 'customresources_value'  , 'document'  , 'employee']

export const DataDispatcherValueObjectsCapabilitiesCapabilityEnumValues: DataDispatcherValueObjectsCapabilitiesCapabilityEnum[] = [ 'cost_center_assignment_importer'  , 'employee_compensations'  , 'employee_creation'  , 'employee_importer'  , 'german_employee'  , 'payroll_updates'  , 'universal_importer']

export const DataDispatcherValueObjectsCapabilitiesFilterOperationEnumValues: DataDispatcherValueObjectsCapabilitiesFilterOperationEnum[] = [ 'equals'  , 'include'  , 'none_or_any'  , 'none_or_include']

export const DocumentNotificationStatusEnumValues: DocumentNotificationStatusEnum[] = [ 'declined_pending'  , 'viewed']

export const DocumentSplitUploadTypesEnumValues: DocumentSplitUploadTypesEnum[] = [ 'combine'  , 'do_not_touch'  , 'manual_per_file'  , 'manual_per_page'  , 'split']

export const DocumentStatusesEnumValues: DocumentStatusesEnum[] = [ 'filled'  , 'to_fill']

export const DocumentsDocumentPoliciesEnumValues: DocumentsDocumentPoliciesEnum[] = [ 'edit']

export const DocumentsEditableEmployeeFolderPoliciesEnumValues: DocumentsEditableEmployeeFolderPoliciesEnum[] = [ 'edit_employee_folder_for_everybody'  , 'edit_employee_folder_for_others']

export const DocumentsEmployeeFolderPoliciesEnumValues: DocumentsEmployeeFolderPoliciesEnum[] = [ 'edit']

export const DocumentsFolderPoliciesEnumValues: DocumentsFolderPoliciesEnum[] = [ 'edit_employee_folder_for_everybody'  , 'edit_employee_folder_for_others']

export const DocumentsSignatureStatusEnumValues: DocumentsSignatureStatusEnum[] = [ 'bounced_email'  , 'cancelled'  , 'completed'  , 'declined'  , 'error'  , 'expired'  , 'partially_signed'  , 'pending']

export const DocumentsUploadProcessOperationTypesEnumValues: DocumentsUploadProcessOperationTypesEnum[] = [ 'discard'  , 'employee_assignment'  , 'merge']

export const DocumentsUploadProcessStatusesEnumValues: DocumentsUploadProcessStatusesEnum[] = [ 'canceled'  , 'completed'  , 'error'  , 'in_distribution'  , 'in_progress'  , 'ready']

export const EmployeeSortDirectionEnumValues: EmployeeSortDirectionEnum[] = [ 'asc'  , 'desc']

export const EmployeeSortOptionsEnumValues: EmployeeSortOptionsEnum[] = [ 'first_name'  , 'job'  , 'last_name'  , 'seniority']

export const EmployeesEmployeePoliciesEnumValues: EmployeesEmployeePoliciesEnum[] = [ 'addCustomTablesRecords'  , 'approveLeaves'  , 'bulkAssignLocations'  , 'createEauRequestOauthToken'  , 'createExpenseCardFor'  , 'createLeaves'  , 'editAttendance'  , 'editCompanyIdentifier'  , 'editContract'  , 'editEmployeeDocumentsWithoutFolder'  , 'editInBulk'  , 'editManager'  , 'editPersonalInfo'  , 'editPlanningVersions'  , 'editPolicyAssignments'  , 'editSeniorityCalculationDate'  , 'electronicSickLeave'  , 'inviteEmployeeToApp'  , 'manageCostCenterMembershipsFor'  , 'manageFinanceCustomDimensionsFor'  , 'manageIncidences'  , 'manageLeavesDocuments'  , 'manageTasks'  , 'readCompanyIdentifier'  , 'readLeaves'  , 'readPersonalInfo'  , 'readSeniorityCalculationDate'  , 'registerFlexibleTracking'  , 'removeCustomTablesRecords'  , 'seeAnyEmployeeDocumentsByFolder'  , 'seeAttendance'  , 'seeContract'  , 'seeContractType'  , 'seeCostCenterMembershipsFor'  , 'seeDocuments'  , 'seeEmployeeCompetenciesAssessments'  , 'seeEmployeeDocumentsWithoutFolder'  , 'seeEmployeePerformanceTab'  , 'seeEmployeeTalentPage'  , 'seeEmployeeTrainings'  , 'seeFinanceCustomDimensionsFor'  , 'seeFutureEmployees'  , 'seePlanningVersions'  , 'seeSalary'  , 'seeTerminateEmployeesInfo'  , 'seeTrainings'  , 'seeWorkingHours'  , 'sharePreferredName'  , 'shareProfileEmail'  , 'terminateEmployees'  , 'updateLeaves']

export const EmployeesValueObjectsEmployeeSelectorTypeEnumEnumValues: EmployeesValueObjectsEmployeeSelectorTypeEnumEnum[] = [ 'all'  , 'manual']

export const EngagementDtosEmployeePulseInsightGroupsGroupByEnumValues: EngagementDtosEmployeePulseInsightGroupsGroupByEnum[] = [ 'gender'  , 'legal_entity'  , 'manager'  , 'nationality'  , 'team'  , 'workspace']

export const EngagementSettingDaysEnumValues: EngagementSettingDaysEnum[] = [ 'friday'  , 'monday'  , 'saturday'  , 'sunday'  , 'thursday'  , 'tuesday'  , 'wednesday']

export const EngagementSettingFrequencyEnumValues: EngagementSettingFrequencyEnum[] = [ 'daily'  , 'specificdays']

export const EngagementSettingQuestionTypeEnumValues: EngagementSettingQuestionTypeEnum[] = [ 'custom'  , 'daily_question'  , 'weekly_question']

export const EnumValues: Enum[] = [ 'archived'  , 'cancelled'  , 'draft'  , 'published'  , 'unlisted']

export const ExpensesCustomizationConfigFieldTypeEnumValues: ExpensesCustomizationConfigFieldTypeEnum[] = [ 'cents'  , 'date'  , 'file'  , 'long_text'  , 'single_choice'  , 'tax_type'  , 'text']

export const ExpensesCustomizationConfigResourceTypeEnumValues: ExpensesCustomizationConfigResourceTypeEnum[] = [ 'expense'  , 'mileage'  , 'perdiem']

export const ExpensesCustomizationExpenseTaxesTypesEnumValues: ExpensesCustomizationExpenseTaxesTypesEnum[] = [ 'vat']

export const ExpensesDtosRateConfigurationPeopleGroupStrategyEnumValues: ExpensesDtosRateConfigurationPeopleGroupStrategyEnum[] = [ 'legal_entities'  , 'manual_selection']

export const ExpensesDtosSignedInvoicesExportFormatsEnumValues: ExpensesDtosSignedInvoicesExportFormatsEnum[] = [ 'csv'  , 'xlsx']

export const ExpensesEntitiesExpensableReimbursementMethodEnumValues: ExpensesEntitiesExpensableReimbursementMethodEnum[] = [ 'payroll'  , 'sepa_transfer'  , 'unknown']

export const ExpensesEntitiesExpensableResourceTypeEnumValues: ExpensesEntitiesExpensableResourceTypeEnum[] = [ 'expense'  , 'mileage'  , 'perdiem']

export const ExpensesEntitiesExpensableStatusEnumValues: ExpensesEntitiesExpensableStatusEnum[] = [ 'approved'  , 'changes_requested'  , 'draft'  , 'in_payroll'  , 'paid'  , 'pending'  , 'rejected'  , 'reversed'  , 'sent_to_pay']

export const ExpensesEntitiesExpenseCreationTypeEnumValues: ExpensesEntitiesExpenseCreationTypeEnum[] = [ 'automatic'  , 'manual'  , 'travelperk']

export const ExpensesExpensableGroupPoliciesEnumValues: ExpensesExpensableGroupPoliciesEnum[] = [ 'destroy'  , 'edit']

export const ExpensesExpensablePoliciesEnumValues: ExpensesExpensablePoliciesEnum[] = [ 'destroy'  , 'edit']

export const ExpensesExpenseCreationTypeEnumValues: ExpensesExpenseCreationTypeEnum[] = [ 'automatic'  , 'manual'  , 'travelperk']

export const ExpensesValueObjectsCardTypeEnumValues: ExpensesValueObjectsCardTypeEnum[] = [ 'physical'  , 'single_use'  , 'virtual']

export const ExpensesValueObjectsClosingPeriodFrequenciesEnumValues: ExpensesValueObjectsClosingPeriodFrequenciesEnum[] = [ 'monthly'  , 'quarterly']

export const ExpensesValueObjectsCreationTypeEnumValues: ExpensesValueObjectsCreationTypeEnum[] = [ 'automatic'  , 'manual'  , 'travelperk']

export const ExpensesValueObjectsCustomizationDocumentTypeEnumValues: ExpensesValueObjectsCustomizationDocumentTypeEnum[] = [ 'default'  , 'invoice']

export const ExpensesValueObjectsDocumentOriginEnumValues: ExpensesValueObjectsDocumentOriginEnum[] = [ 'camera'  , 'file']

export const ExpensesValueObjectsPaymentOptionsEnumValues: ExpensesValueObjectsPaymentOptionsEnum[] = [ 'not_reimbursable'  , 'reimbursable']

export const ExpensesValueObjectsPerDiemCalculationExcludedConceptEnumValues: ExpensesValueObjectsPerDiemCalculationExcludedConceptEnum[] = [ 'accommodation'  , 'breakfast'  , 'dinner'  , 'lunch']

export const ExpensesValueObjectsSpendingLimitIntervalEnumValues: ExpensesValueObjectsSpendingLimitIntervalEnum[] = [ 'daily'  , 'monthly'  , 'weekly'  , 'yearly']

export const ExpensesValueObjectsTaxAgencyOrganizationsEnumValues: ExpensesValueObjectsTaxAgencyOrganizationsEnum[] = [ 'aeat'  , 'urssaf']

export const ExpensesValueObjectsValidationsSerializableIssueTypeEnumValues: ExpensesValueObjectsValidationsSerializableIssueTypeEnum[] = [ 'invalidvalue'  , 'missingfield']

export const FeedbacksFeedbackEntryVisibilityEnumValues: FeedbacksFeedbackEntryVisibilityEnum[] = [ 'manager_only'  , 'private'  , 'private_and_manager']

export const FinanceBudgetPoliciesEnumValues: FinanceBudgetPoliciesEnum[] = [ 'update']

export const FinanceComplianceSnapshotResourceTypeEnumValues: FinanceComplianceSnapshotResourceTypeEnum[] = [ 'invoice'  , 'quote']

export const FinanceDealPoliciesEnumValues: FinanceDealPoliciesEnum[] = [ 'access']

export const FinanceDtosAccountingAccountImportTemplatePrefillEnumValues: FinanceDtosAccountingAccountImportTemplatePrefillEnum[] = [ 'current_data'  , 'sample_data']

export const FinanceDtosPendingActionsOverviewSummaryScopeEnumValues: FinanceDtosPendingActionsOverviewSummaryScopeEnum[] = [ 'accounting'  , 'treasury']

export const FinanceDtosSpendingPoliciesPeopleGroupStrategyEnumValues: FinanceDtosSpendingPoliciesPeopleGroupStrategyEnum[] = [ 'legal_entities'  , 'manual_selection']

export const FinanceEntitiesFinancialCostStatusEnumValues: FinanceEntitiesFinancialCostStatusEnum[] = [ 'active'  , 'deleted']

export const FinanceEntitiesResourceTypeEnumValues: FinanceEntitiesResourceTypeEnum[] = [ 'expense'  , 'project'  , 'purchaseorder'  , 'quote'  , 'softwaresetup'  , 'subproject']

export const FinanceEnumsQuoteStatusEnumValues: FinanceEnumsQuoteStatusEnum[] = [ 'accepted'  , 'draft'  , 'rejected']

export const FinanceEnumsQuoteTypeEnumValues: FinanceEnumsQuoteTypeEnum[] = [ 'products'  , 'timeandmaterials']

export const FinanceQuotePoliciesEnumValues: FinanceQuotePoliciesEnum[] = [ 'access'  , 'convertToInvoice'  , 'convertToProject'  , 'manage'  , 'updateDetails']

export const FinanceServicesCustomCategoriesConfigExpenseCategoriesEnumValues: FinanceServicesCustomCategoriesConfigExpenseCategoriesEnum[] = [ 'accommodation'  , 'airlines'  , 'car_rental_agencies'  , 'fuel'  , 'internet'  , 'laundry'  , 'office_supplies'  , 'other'  , 'parking'  , 'passport_visa_fees'  , 'phone'  , 'private_transport'  , 'public_transport'  , 'rail_travel'  , 'refreshments'  , 'restaurants'  , 'subscriptions'  , 'taxis'  , 'tolls'  , 'training'  , 'transport']

export const FinanceServicesCustomCategoriesConfigResourceTypeEnumValues: FinanceServicesCustomCategoriesConfigResourceTypeEnum[] = [ 'expenses_expense'  , 'expenses_mileage'  , 'expenses_perdiem']

export const FinanceTaxBridgeTaxAgenciesEnumValues: FinanceTaxBridgeTaxAgenciesEnum[] = [ 'aeat_verifactu'  , 'undefined']

export const FinanceValueObjectsAccountTypeEnumValues: FinanceValueObjectsAccountTypeEnum[] = [ 'bank'  , 'current_asset'  , 'current_liability'  , 'equity'  , 'expense'  , 'income'  , 'non_current_asset'  , 'non_current_liability']

export const FinanceValueObjectsAllocationStatusEnumValues: FinanceValueObjectsAllocationStatusEnum[] = [ 'allocation_risk'  , 'over_allocation'  , 'within_allocation']

export const FinanceValueObjectsBudgetPeriodicityEnumValues: FinanceValueObjectsBudgetPeriodicityEnum[] = [ 'daily'  , 'monthly'  , 'none'  , 'weekly'  , 'yearly']

export const FinanceValueObjectsBudgetStatusEnumValues: FinanceValueObjectsBudgetStatusEnum[] = [ 'budget_risk'  , 'over_budget'  , 'within_budget']

export const FinanceValueObjectsCategoryLevelEnumValues: FinanceValueObjectsCategoryLevelEnum[] = [ 'all'  , 'category'  , 'subcategory']

export const FinanceValueObjectsCategoryStatusEnumValues: FinanceValueObjectsCategoryStatusEnum[] = [ 'deleted'  , 'disabled'  , 'enabled']

export const FinanceValueObjectsCategoryTypeEnumValues: FinanceValueObjectsCategoryTypeEnum[] = [ 'all'  , 'expense'  , 'mileage'  , 'perdiem']

export const FinanceValueObjectsComplianceExtraFieldContextEnumValues: FinanceValueObjectsComplianceExtraFieldContextEnum[] = [ 'document'  , 'line_item'  , 'tax']

export const FinanceValueObjectsComplianceExtraFieldOrganizationEnumValues: FinanceValueObjectsComplianceExtraFieldOrganizationEnum[] = [ 'aeat']

export const FinanceValueObjectsComplianceExtraFieldTypeEnumValues: FinanceValueObjectsComplianceExtraFieldTypeEnum[] = [ 'enum']

export const FinanceValueObjectsComplianceSnapshotEventEnumValues: FinanceValueObjectsComplianceSnapshotEventEnum[] = [ 'convert_quote_to_invoice'  , 'created_document'  , 'issued_document'  , 'register_document'  , 'updated_document']

export const FinanceValueObjectsContactTaxIdTypeEnumValues: FinanceValueObjectsContactTaxIdTypeEnum[] = [ 'not_registered'  , 'official_id'  , 'other_proof_document'  , 'passport'  , 'residence_certificate'  , 'vat_number']

export const FinanceValueObjectsContactTypeEnumValues: FinanceValueObjectsContactTypeEnum[] = [ 'client'  , 'vendor']

export const FinanceValueObjectsCurrencyProvidersEnumValues: FinanceValueObjectsCurrencyProvidersEnum[] = [ 'ecb'  , 'openexchangerates']

export const FinanceValueObjectsDealStageEnumValues: FinanceValueObjectsDealStageEnum[] = [ 'closed_lost'  , 'closed_won'  , 'negotiation'  , 'new'  , 'proposal_sent'  , 'qualification']

export const FinanceValueObjectsFinancialDocumentEventStatusEnumValues: FinanceValueObjectsFinancialDocumentEventStatusEnum[] = [ 'error'  , 'success']

export const FinanceValueObjectsFinancialDocumentEventTypeEnumValues: FinanceValueObjectsFinancialDocumentEventTypeEnum[] = [ 'created'  , 'issued'  , 'registered'  , 'resetted_registered'  , 'tax_document_delivered'  , 'tax_document_formatted']

export const FinanceValueObjectsFinancialDocumentOperationTypeEnumValues: FinanceValueObjectsFinancialDocumentOperationTypeEnum[] = [ 'purchase'  , 'sale']

export const FinanceValueObjectsFinancialDocumentTypeEnumValues: FinanceValueObjectsFinancialDocumentTypeEnum[] = [ 'credit_note'  , 'invoice'  , 'receipt']

export const FinanceValueObjectsInvoiceStatusEnumValues: FinanceValueObjectsInvoiceStatusEnum[] = [ 'paid'  , 'processing'  , 'review'  , 'sent_to_pay']

export const FinanceValueObjectsJournalDraftEntryStatusEnumValues: FinanceValueObjectsJournalDraftEntryStatusEnum[] = [ 'draft'  , 'ready_to_publish'  , 'unbalanced']

export const FinanceValueObjectsJournalEntryApiSourceTypeEnumValues: FinanceValueObjectsJournalEntryApiSourceTypeEnum[] = [ 'account'  , 'bank_transaction'  , 'expense'  , 'finance_reconciliation'  , 'invoice'  , 'journal_entry'  , 'payroll_result'  , 'reconciliation']

export const FinanceValueObjectsJournalEntrySourceTypeEnumValues: FinanceValueObjectsJournalEntrySourceTypeEnum[] = [ 'banking_reconciliation'  , 'banking_transaction'  , 'expenses_expense'  , 'finance_account'  , 'finance_invoice'  , 'finance_journalentry'  , 'finance_reconciliation'  , 'payroll_result']

export const FinanceValueObjectsJournalEntryStatusEnumValues: FinanceValueObjectsJournalEntryStatusEnum[] = [ 'published'  , 'reversed']

export const FinanceValueObjectsJournalEntryTypeEnumValues: FinanceValueObjectsJournalEntryTypeEnum[] = [ 'bank'  , 'bill'  , 'credit_note'  , 'external'  , 'invoice'  , 'merged_ledger_account'  , 'payroll_result'  , 'receipt'  , 'reconciliation'  , 'tax']

export const FinanceValueObjectsLedgerAccountBalanceTypeEnumValues: FinanceValueObjectsLedgerAccountBalanceTypeEnum[] = [ 'credit'  , 'debit']

export const FinanceValueObjectsLedgerAccountOperationTypeEnumValues: FinanceValueObjectsLedgerAccountOperationTypeEnum[] = [ 'purchase'  , 'sale']

export const FinanceValueObjectsLedgerAccountResourceTypeEnumValues: FinanceValueObjectsLedgerAccountResourceTypeEnum[] = [ 'bankaccount'  , 'customcategory'  , 'invoice'  , 'payrollconcept'  , 'taxtype'  , 'vendor']

export const FinanceValueObjectsLineItemQuantityTypeEnumValues: FinanceValueObjectsLineItemQuantityTypeEnum[] = [ 'hours'  , 'units']

export const FinanceValueObjectsLineItemSourceTypeEnumValues: FinanceValueObjectsLineItemSourceTypeEnum[] = [ 'financial_document'  , 'quote']

export const FinanceValueObjectsLineItemTypeEnumValues: FinanceValueObjectsLineItemTypeEnum[] = [ 'phase'  , 'role'  , 'simple']

export const FinanceValueObjectsPendingActionTypeEnumValues: FinanceValueObjectsPendingActionTypeEnum[] = [ 'critical'  , 'info'  , 'neutral'  , 'positive'  , 'warning']

export const FinanceValueObjectsReconcilableTypeEnumValues: FinanceValueObjectsReconcilableTypeEnum[] = [ 'journal_line']

export const FinanceValueObjectsReconcilationTypeEnumValues: FinanceValueObjectsReconcilationTypeEnum[] = [ 'normal'  , 'skipped']

export const FinanceValueObjectsReconciliationStatusEnumValues: FinanceValueObjectsReconciliationStatusEnum[] = [ 'pending'  , 'reconciled'  , 'snoozed']

export const FinanceValueObjectsSpendingAlertStatusEnumValues: FinanceValueObjectsSpendingAlertStatusEnum[] = [ 'failed'  , 'success']

export const FinanceValueObjectsSpendingAlertTypeEnumValues: FinanceValueObjectsSpendingAlertTypeEnum[] = [ 'category_conflict'  , 'duplicate_expense'  , 'in_policy'  , 'mileage_rate_changed'  , 'policy_compliance'  , 'spending_policy']

export const FinanceValueObjectsSpendingPolicyEvaluationResultTypeEnumValues: FinanceValueObjectsSpendingPolicyEvaluationResultTypeEnum[] = [ 'not_applicable'  , 'out_of_policy'  , 'within_policy']

export const FinanceValueObjectsTaxSourceEnumValues: FinanceValueObjectsTaxSourceEnum[] = [ 'custom'  , 'system']

export const FinanceValueObjectsTaxTypeEnumValues: FinanceValueObjectsTaxTypeEnum[] = [ 'personal_income'  , 'vat']

export const FinanceValueObjectsTrackedCostSourceTypeEnumValues: FinanceValueObjectsTrackedCostSourceTypeEnum[] = [ 'expenses_expensable']

export const FinanceValueObjectsVendorPreferredPaymentMethodEnumValues: FinanceValueObjectsVendorPreferredPaymentMethodEnum[] = [ 'banktransfer'  , 'card']

export const FinancialWorkspaceValueObjectsAgreementDataTypeEnumValues: FinancialWorkspaceValueObjectsAgreementDataTypeEnum[] = [ 'compensations'  , 'salary']

export const FinancialWorkspaceValueObjectsCostTypeEnumValues: FinancialWorkspaceValueObjectsCostTypeEnum[] = [ 'company_cost'  , 'labor_cost'  , 'normal']

export const FinancialWorkspaceValueObjectsFinanceTypeEnumValues: FinancialWorkspaceValueObjectsFinanceTypeEnum[] = [ 'agreement'  , 'compensations'  , 'expense'  , 'payroll']

export const FinancialWorkspaceValueObjectsGrossSalaryGroupEnumValues: FinancialWorkspaceValueObjectsGrossSalaryGroupEnum[] = [ 'costcenter'  , 'employee'  , 'legalentity'  , 'location'  , 'manager'  , 'nothing']

export const FinancialWorkspaceValueObjectsInsightTableGroupEnumValues: FinancialWorkspaceValueObjectsInsightTableGroupEnum[] = [ 'costcenter'  , 'customcategory'  , 'employee'  , 'legalentity'  , 'lineitem'  , 'location'  , 'manager'  , 'total']

export const FinancialWorkspaceValueObjectsInsightTableTypeEnumValues: FinancialWorkspaceValueObjectsInsightTableTypeEnum[] = [ 'gross_salary'  , 'payroll']

export const FinancialWorkspaceValueObjectsLaborCostCalculationTypeEnumValues: FinancialWorkspaceValueObjectsLaborCostCalculationTypeEnum[] = [ 'add_to_total'  , 'subtract_from_total']

export const FinancialWorkspaceValueObjectsLaborCostTypeEnumValues: FinancialWorkspaceValueObjectsLaborCostTypeEnum[] = [ 'company_cost'  , 'simple_calculation']

export const FinancialWorkspaceValueObjectsPayrollGroupByEnumValues: FinancialWorkspaceValueObjectsPayrollGroupByEnum[] = [ 'costcenter'  , 'employee'  , 'legalentity'  , 'lineitem'  , 'location'  , 'manager']

export const FinancialWorkspaceValueObjectsPeriodEnumValues: FinancialWorkspaceValueObjectsPeriodEnum[] = [ 'daily'  , 'hourly'  , 'monthly'  , 'quarterly'  , 'weekly'  , 'yearly']

export const FormsElementTypeEnumValues: FormsElementTypeEnum[] = [ 'date'  , 'dropdownsingle'  , 'longtext'  , 'multiselect'  , 'number'  , 'rating'  , 'score'  , 'section'  , 'select'  , 'text'  , 'url']

export const FormsEnumsRecurrenceTypeEnumValues: FormsEnumsRecurrenceTypeEnum[] = [ 'bi_monthly'  , 'bi_weekly'  , 'daily'  , 'monthly'  , 'quadrimester'  , 'quarterly'  , 'semi_annual'  , 'weekly'  , 'yearly']

export const FormsEnumsStatusEnumValues: FormsEnumsStatusEnum[] = [ 'active'  , 'archived'  , 'draft'  , 'finished'  , 'scheduled']

export const FormsFormStatusEnumValues: FormsFormStatusEnum[] = [ 'active'  , 'archived'  , 'draft'  , 'finished'  , 'scheduled']

export const FormsMaterializedQuestionQuestionTypeEnumValues: FormsMaterializedQuestionQuestionTypeEnum[] = [ 'multiple_choice'  , 'number'  , 'rating'  , 'text']

export const FormsScheduleRecurrenceTypeEnumValues: FormsScheduleRecurrenceTypeEnum[] = [ 'daily'  , 'monthly'  , 'onetime'  , 'quarterly'  , 'weekly'  , 'yearly']

export const FormsTypeEnumValues: FormsTypeEnum[] = [ 'custom'  , 'effectiveness'  , 'knowledge'  , 'quiz'  , 'satisfaction']

export const FormsValueObjectsElementTypeEnumValues: FormsValueObjectsElementTypeEnum[] = [ 'date'  , 'dropdownsingle'  , 'longtext'  , 'multiselect'  , 'number'  , 'rating'  , 'score'  , 'section'  , 'select'  , 'text'  , 'url']

export const FormsValueObjectsQuestionnaireElementTypesEnumValues: FormsValueObjectsQuestionnaireElementTypesEnum[] = [ 'question'  , 'section']

export const GoalsEmployeeCycleProgressPoliciesEnumValues: GoalsEmployeeCycleProgressPoliciesEnum[] = [ 'upsert_weights']

export const GoalsEmployeePoliciesEnumValues: GoalsEmployeePoliciesEnum[] = [ 'create_metric']

export const GoalsMetricGroupPoliciesEnumValues: GoalsMetricGroupPoliciesEnum[] = [ 'create_metric'  , 'delete'  , 'update']

export const GoalsMetricPoliciesEnumValues: GoalsMetricPoliciesEnum[] = [ 'delete'  , 'update'  , 'update_qualitative_current_status'  , 'update_quantitative_current_value']

export const GoalsMetricTypeEnumValues: GoalsMetricTypeEnum[] = [ 'qualitative'  , 'quantitative']

export const GoalsMetricValueStatusEnumValues: GoalsMetricValueStatusEnum[] = [ 'achieved'  , 'not_achieved'  , 'over_achieved']

export const GoalsValueObjectsMetricProgressAssessmentProgressStatusEnumValues: GoalsValueObjectsMetricProgressAssessmentProgressStatusEnum[] = [ 'achieved'  , 'at_risk'  , 'highly_at_risk'  , 'not_achieved'  , 'not_started'  , 'on_track'  , 'over_achieved'  , 'unknown']

export const HandbookPagesValueObjectsFolderCategoryEnumValues: HandbookPagesValueObjectsFolderCategoryEnum[] = [ 'benefits'  , 'expenses'  , 'legal'  , 'people'  , 'travel'  , 'workplace']

export const HandbookPagesValueObjectsPageStatusEnumValues: HandbookPagesValueObjectsPageStatusEnum[] = [ 'draft'  , 'published']

export const HandbookPagesValueObjectsVisibilityEnumValues: HandbookPagesValueObjectsVisibilityEnum[] = [ 'company'  , 'private']

export const HandoffsValueObjectsSourceTypeEnumValues: HandoffsValueObjectsSourceTypeEnum[] = [ 'attendance_compensation'  , 'benefits_benefitcompensation'  , 'expenses_expensable'  , 'expenses_expense'  , 'expenses_mileage'  , 'timesettings_customtimerangecategory']

export const HolidaysCompanyHolidayHalfDayTypesEnumValues: HolidaysCompanyHolidayHalfDayTypesEnum[] = [ 'beginning_of_day'  , 'end_of_day']

export const IntegrationsAgreggatedSyncableStateValuesEnumValues: IntegrationsAgreggatedSyncableStateValuesEnum[] = [ 'failed'  , 'outdated'  , 'partially_synced'  , 'pending'  , 'synced']

export const IntegrationsCapabilityModeEnumValues: IntegrationsCapabilityModeEnum[] = [ 'api'  , 'file']

export const IntegrationsCapabilityTypeEnumValues: IntegrationsCapabilityTypeEnum[] = [ 'compensations'  , 'expenses']

export const IntegrationsDatevLaudsEntitiesIntegrationStatusStateEnumValues: IntegrationsDatevLaudsEntitiesIntegrationStatusStateEnum[] = [ 'feature_not_enabled'  , 'integration_not_installed'  , 'mappings_not_done'  , 'oauth_token_invalid'  , 'ok']

export const IntegrationsDatevLaudsValueObjectsEmployeeExportStatusEnumValues: IntegrationsDatevLaudsValueObjectsEmployeeExportStatusEnum[] = [ 'collecting'  , 'failed'  , 'mapping'  , 'partially_processed'  , 'pending'  , 'processed'  , 'processing'  , 'ready']

export const IntegrationsDatevLaudsValueObjectsEmployeeImportStatusEnumValues: IntegrationsDatevLaudsValueObjectsEmployeeImportStatusEnum[] = [ 'collecting'  , 'failed'  , 'mapping'  , 'partially_processed'  , 'pending'  , 'processed'  , 'processing'  , 'ready']

export const IntegrationsDatevLaudsValueObjectsEmployeeImportTypeEnumValues: IntegrationsDatevLaudsValueObjectsEmployeeImportTypeEnum[] = [ 'from_datev'  , 'from_factorial']

export const IntegrationsDatevLaudsValueObjectsRequestStatusEnumValues: IntegrationsDatevLaudsValueObjectsRequestStatusEnum[] = [ 'complete'  , 'failed'  , 'partial'  , 'pending'  , 'processed']

export const IntegrationsDatevLaudsValueObjectsTargetSystemEnumValues: IntegrationsDatevLaudsValueObjectsTargetSystemEnum[] = [ 'datev_lodas'  , 'datev_lug']

export const IntegrationsIndeedDispositionDataStatusesEnumValues: IntegrationsIndeedDispositionDataStatusesEnum[] = [ 'assess_qualifications'  , 'hired'  , 'interview'  , 'new'  , 'not_selected'  , 'offer_made'  , 'screen'  , 'unable_to_map']

export const IntegrationsInfojobsOfferStatusesEnumValues: IntegrationsInfojobsOfferStatusesEnum[] = [ 'active'  , 'archived'  , 'error'  , 'expired'  , 'in_progress']

export const IntegrationsInfojobsValueTypeEnumValues: IntegrationsInfojobsValueTypeEnum[] = [ 'contract_type'  , 'country'  , 'experience'  , 'job_industry'  , 'job_subindustry'  , 'laboral_level'  , 'province'  , 'salary_period'  , 'salary_ranges'  , 'shift'  , 'studies']

export const IntegrationsJoinIntegrationsStatusEnumValues: IntegrationsJoinIntegrationsStatusEnum[] = [ 'disabled'  , 'enabled']

export const IntegrationsJoinJobPostingStatusesEnumValues: IntegrationsJoinJobPostingStatusesEnum[] = [ 'archived'  , 'online']

export const IntegrationsJoinOrderStatusesEnumValues: IntegrationsJoinOrderStatusesEnum[] = [ 'approved'  , 'cancelled'  , 'failed'  , 'payment_failed'  , 'pending'  , 'processing'  , 'rejected']

export const IntegrationsJoinPremiumOfferTypesEnumValues: IntegrationsJoinPremiumOfferTypesEnum[] = [ 'bundle'  , 'product']

export const IntegrationsJoinPremiumPostingStatusesEnumValues: IntegrationsJoinPremiumPostingStatusesEnum[] = [ 'archived'  , 'expired'  , 'pending'  , 'posted'  , 'processing'  , 'unposted']

export const IntegrationsSyncRunOriginEnumValues: IntegrationsSyncRunOriginEnum[] = [ 'compensations'  , 'expenses']

export const IntegrationsSyncRunStatusEnumValues: IntegrationsSyncRunStatusEnum[] = [ 'errored'  , 'running'  , 'succededwitherrors'  , 'succeeded']

export const IntegrationsSyncableStateStatusEnumValues: IntegrationsSyncableStateStatusEnum[] = [ 'failed'  , 'invalid'  , 'outdated'  , 'synced'  , 'syncing']

export const IntegrationsSyncableSyncRunStatusEnumValues: IntegrationsSyncableSyncRunStatusEnum[] = [ 'failed'  , 'invalid'  , 'success']

export const IntegrationsSyncableTypeEnumValues: IntegrationsSyncableTypeEnum[] = [ 'compensationscompensation'  , 'expensesexpensable']

export const IrisValueObjectsDataTypeEnumValues: IrisValueObjectsDataTypeEnum[] = [ 'array'  , 'boolean'  , 'number'  , 'string']

export const IrisValueObjectsFormatHintEnumValues: IrisValueObjectsFormatHintEnum[] = [ 'array'  , 'country_code'  , 'date'  , 'date_time'  , 'duration'  , 'employee_id'  , 'monetary_amount'  , 'monetary_currency'  , 'percentage'  , 'team_id'  , 'time']

export const IrisValueObjectsTableKindEnumValues: IrisValueObjectsTableKindEnum[] = [ 'current'  , 'embeddings'  , 'snapshot'  , 'traceability']

export const IrisValueObjectsTableTagEnumValues: IrisValueObjectsTableTagEnum[] = [ 'finance'  , 'organization'  , 'undefined']

export const ItManagementValueObjectsItAssetDocumentTypeEnumValues: ItManagementValueObjectsItAssetDocumentTypeEnum[] = [ 'assign'  , 'unassign']

export const ItManagementValueObjectsItAssetStatusEnumValues: ItManagementValueObjectsItAssetStatusEnum[] = [ 'assigned'  , 'in_stock'  , 'maintenance'  , 'retired']

export const JobCatalogEnumsJobCatalogTreeAttributeTypesEnumValues: JobCatalogEnumsJobCatalogTreeAttributeTypesEnum[] = [ 'competency'  , 'it_management'  , 'salary_range'  , 'working_conditions']

export const JobCatalogEnumsJobCatalogTreeNodeTypesEnumValues: JobCatalogEnumsJobCatalogTreeNodeTypesEnum[] = [ 'jobcatalog_treefamily'  , 'jobcatalog_treefunction'  , 'jobcatalog_treelevel'  , 'jobcatalog_treerole'  , 'jobcatalog_treeroot']

export const JobCatalogRolePoliciesEnumValues: JobCatalogRolePoliciesEnum[] = [ 'editJob']

export const LayoutValueObjectsFavouritesDirectionEnumValues: LayoutValueObjectsFavouritesDirectionEnum[] = [ 'down'  , 'up']

export const MarketplaceValueObjectsQuestionsQuestionTextTypesEnumValues: MarketplaceValueObjectsQuestionsQuestionTextTypesEnum[] = [ 'email'  , 'number'  , 'password'  , 'text'  , 'time']

export const MeetingsAttendeeStatusesEnumValues: MeetingsAttendeeStatusesEnum[] = [ 'accepted'  , 'pending'  , 'rejected']

export const MeetingsValueObjectsDeletionTypeEnumValues: MeetingsValueObjectsDeletionTypeEnum[] = [ 'all'  , 'future'  , 'one']

export const ModulesEnumValues: ModulesEnum[] = [ 'ai_reports'  , 'analytics'  , 'benefits'  , 'billing'  , 'calendar'  , 'company_attendance'  , 'company_documents'  , 'company_projects'  , 'company_trainings'  , 'compensations'  , 'complaints'  , 'dashboard'  , 'device_catalog'  , 'discover'  , 'employee_attendance'  , 'employee_onboarding'  , 'employees'  , 'engagement_insights'  , 'factorial_it'  , 'finance'  , 'finance_accounting'  , 'finance_sales'  , 'finance_spending'  , 'finance_treasury'  , 'finance_workspace'  , 'goals'  , 'handbook_pages'  , 'it_management'  , 'kudos'  , 'meetings'  , 'mobile_complaints'  , 'my_benefits'  , 'my_documents'  , 'my_payroll'  , 'my_projects'  , 'my_spending'  , 'my_surveys'  , 'my_trainings'  , 'notifications'  , 'onboarding'  , 'pages'  , 'payroll_bundle'  , 'performance'  , 'processes'  , 'profile'  , 'recruitment'  , 'salary_advance'  , 'settings'  , 'shift_management'  , 'software_management'  , 'space_control'  , 'talent_analytics'  , 'tasks'  , 'timeoff']

export const OnboardingEntitiesWorkScheduleTimeEnumValues: OnboardingEntitiesWorkScheduleTimeEnum[] = [ 'full_time'  , 'part_time']

export const OneOnOnesMeetingPoliciesEnumValues: OneOnOnesMeetingPoliciesEnum[] = [ 'delete']

export const PayrollEmployeesDtosIdentifierSupportedCountryEnumValues: PayrollEmployeesDtosIdentifierSupportedCountryEnum[] = [ 'de'  , 'it'  , 'pt']

export const PayrollExporterDtosExportReadTypeEnumValues: PayrollExporterDtosExportReadTypeEnum[] = [ 'a3innuva_supplements'  , 'a3nom_employees'  , 'a3nom_supplements'  , 'absences'  , 'basic'  , 'contract_changes'  , 'datev_employees'  , 'delta'  , 'extended'  , 'gispaghe_time'  , 'paierh_leaves'  , 'paierh_supplements'  , 'paierh_updated_employees'  , 'payslip_contract_changes'  , 'silae_leave_deltas'  , 'silae_leaves'  , 'silae_supplements'  , 'supplements'  , 'yeap_paierh_leaves'  , 'yeap_paierh_supplements'  , 'yeap_paierh_updated_employees'  , 'zucchetti_leaves'  , 'zucchetti_time']

export const PayrollExporterDtosExportReadUpdatePeriodExportTypeEnumValues: PayrollExporterDtosExportReadUpdatePeriodExportTypeEnum[] = [ 'all'  , 'custom']

export const PayrollFamilySituationCivilStatusEnumValues: PayrollFamilySituationCivilStatusEnum[] = [ 'civil_partnership'  , 'cohabitating'  , 'divorced'  , 'married'  , 'not_applicable'  , 'separated'  , 'single'  , 'unknown'  , 'widow']

export const PayrollIntegrationsBaseEntitiesSyncStatusEnumValues: PayrollIntegrationsBaseEntitiesSyncStatusEnum[] = [ 'available'  , 'blocked'  , 'done'  , 'pending'  , 'unavailable']

export const PayrollIntegrationsBaseIntegrationEnumValues: PayrollIntegrationsBaseIntegrationEnum[] = [ 'a3innuva'  , 'a3nom'  , 'datev'  , 'datev_api'  , 'datev_lauds'  , 'datev_lug_api'  , 'gispaghe'  , 'paierh'  , 'silae'  , 'yeap_paierh'  , 'zucchetti']

export const PayrollPolicyPeriodTypesPeriodTypeEnumValues: PayrollPolicyPeriodTypesPeriodTypeEnum[] = [ 'current'  , 'next'  , 'previous']

export const PayrollSummaryImportTemplatesIdsEnumValues: PayrollSummaryImportTemplatesIdsEnum[] = [ 'de'  , 'es'  , 'fr'  , 'it']

export const PayrollSupplementsUnitEnumValues: PayrollSupplementsUnitEnum[] = [ 'money'  , 'time'  , 'units']

export const PayrollValueObjectsBulkDeleteResultErrorCodeEnumValues: PayrollValueObjectsBulkDeleteResultErrorCodeEnum[] = [ 'closed_policy_period'  , 'destroy_error'  , 'no_policy_period'  , 'unauthorized_to_create_supplement'  , 'unauthorized_to_delete_supplement']

export const PayrollValueObjectsConceptCategoryEnumValues: PayrollValueObjectsConceptCategoryEnum[] = [ 'company_contribution'  , 'deductions'  , 'earnings_benefits_in_kind'  , 'earnings_fixed_salary'  , 'earnings_others'  , 'earnings_variable'  , 'summarized_values']

export const PayrollValueObjectsConceptUnitTypeEnumValues: PayrollValueObjectsConceptUnitTypeEnum[] = [ 'distance'  , 'money'  , 'time'  , 'unit']

export const PayrollValueObjectsPolicyPeriodStatusEnumValues: PayrollValueObjectsPolicyPeriodStatusEnum[] = [ 'paid'  , 'payment_processing'  , 'payroll_calculation'  , 'preparation'  , 'supplements_definition'  , 'under_review']

export const PerformanceAgreementActionItemPoliciesEnumValues: PerformanceAgreementActionItemPoliciesEnum[] = [ 'manage']

export const PerformanceAgreementPoliciesEnumValues: PerformanceAgreementPoliciesEnum[] = [ 'add_action_items'  , 'add_conclusions'  , 'add_notes_as_manager'  , 'add_notes_as_target'  , 'add_training_request'  , 'generate_document'  , 'sign_as_manager'  , 'sign_as_target'  , 'unsign_as_manager'  , 'unsign_as_target']

export const PerformanceAgreementStatusEnumValues: PerformanceAgreementStatusEnum[] = [ 'pending'  , 'signed']

export const PerformanceDtosReviewProcessCreateFromTemplateTemplateTypeEnumValues: PerformanceDtosReviewProcessCreateFromTemplateTemplateTypeEnum[] = [ 'custom'  , 'predefined']

export const PerformanceDtosReviewProcessTargetAgreementCompletionStatusEnumValues: PerformanceDtosReviewProcessTargetAgreementCompletionStatusEnum[] = [ 'canbeinitiated'  , 'hasbouncedemailagreement'  , 'hascancelledagreement'  , 'hasdeclinedagreement'  , 'haserroragreement'  , 'hasesignedagreement'  , 'hasexpiredagreement'  , 'haspartiallyesignedagreement'  , 'haspendingagreement'  , 'haspendingesignaturesagreement'  , 'hassignedagreement'  , 'notinitiated']

export const PerformanceEngagementSignalsSignalCategoryEnumValues: PerformanceEngagementSignalsSignalCategoryEnum[] = [ 'accomplishment'  , 'autonomy'  , 'environment'  , 'freedomofopinions'  , 'goalsetting'  , 'growth'  , 'managementsupport'  , 'meaningfulwork'  , 'organizationalfit'  , 'peerrelationships'  , 'recognition'  , 'reward'  , 'strategy'  , 'workload']

export const PerformanceEngagementSignalsSignalTypeEnumValues: PerformanceEngagementSignalsSignalTypeEnum[] = [ 'negative'  , 'neutral'  , 'neutralornegative'  , 'neutralorpositive'  , 'positive']

export const PerformanceGoalsValueObjectsMetricTypeEnumValues: PerformanceGoalsValueObjectsMetricTypeEnum[] = [ 'boolean'  , 'count'  , 'currency'  , 'percentage']

export const PerformanceGoalsValueObjectsOwnerEnumValues: PerformanceGoalsValueObjectsOwnerEnum[] = [ 'employee'  , 'team']

export const PerformanceGoalsValueObjectsStatusEnumValues: PerformanceGoalsValueObjectsStatusEnum[] = [ 'completed'  , 'delayed'  , 'on_track']

export const PerformanceGoalsValueObjectsTrackingModeEnumValues: PerformanceGoalsValueObjectsTrackingModeEnum[] = [ 'metric'  , 'sub_goals']

export const PerformanceGoalsValueObjectsVisibilityEnumValues: PerformanceGoalsValueObjectsVisibilityEnum[] = [ 'private'  , 'public']

export const PerformanceInsightsQuantityEnumValues: PerformanceInsightsQuantityEnum[] = [ 'high'  , 'low'  , 'normal']

export const PerformanceReviewEvaluationAnswerPoliciesEnumValues: PerformanceReviewEvaluationAnswerPoliciesEnum[] = [ 'answer'  , 'estimate_score'  , 'republish']

export const PerformanceReviewEvaluationPoliciesEnumValues: PerformanceReviewEvaluationPoliciesEnum[] = [ 'replace_reviewer']

export const PerformanceReviewEvaluationStatusEnumValues: PerformanceReviewEvaluationStatusEnum[] = [ 'pending'  , 'published']

export const PerformanceReviewProcessCustomTemplatePoliciesEnumValues: PerformanceReviewProcessCustomTemplatePoliciesEnum[] = [ 'generate_review_questions_using_ai'  , 'manage']

export const PerformanceReviewProcessPoliciesEnumValues: PerformanceReviewProcessPoliciesEnum[] = [ 'bulk_inititate_agreement'  , 'export'  , 'full_visibility'  , 'generate_review_questions_using_ai'  , 'manage']

export const PerformanceReviewProcessStatusEnumValues: PerformanceReviewProcessStatusEnum[] = [ 'active'  , 'draft'  , 'finished'  , 'scheduled']

export const PerformanceReviewProcessTargetPoliciesEnumValues: PerformanceReviewProcessTargetPoliciesEnum[] = [ 'initiate'  , 'see_target_final_score'  , 'see_target_insights'  , 'see_target_score_details']

export const PerformanceReviewerStrategiesStrategyEnumValues: PerformanceReviewerStrategiesStrategyEnum[] = [ 'direct_reports'  , 'manager'  , 'peers'  , 'self']

export const PerformanceScoreConfigurationModeEnumValues: PerformanceScoreConfigurationModeEnum[] = [ 'custom_weights'  , 'final_question']

export const PerformanceScoreConfigurationPoliciesEnumValues: PerformanceScoreConfigurationPoliciesEnum[] = [ 'see_weights']

export const PerformanceStartReviewProcessValidatorFailedCheckEnumValues: PerformanceStartReviewProcessValidatorFailedCheckEnum[] = [ 'invalid_deadline'  , 'invalid_section_weights_sum'  , 'missing_deadline'  , 'missing_potential_reviewers'  , 'missing_questions'  , 'missing_reviewer_strategy'  , 'missing_target_strategy'  , 'missing_target_strategy_members'  , 'missing_title']

export const PerformanceTargetStrategySupportedStrategiesEnumValues: PerformanceTargetStrategySupportedStrategiesEnum[] = [ 'all_employees'  , 'by_employees'  , 'by_locations'  , 'by_teams'  , 'manual_selection']

export const PerformanceValueObjectsQuestionnaireAnsweredElementTypesEnumValues: PerformanceValueObjectsQuestionnaireAnsweredElementTypesEnum[] = [ 'answered_question'  , 'answered_section']

export const PerformanceValueObjectsQuestionnaireElementTypesEnumValues: PerformanceValueObjectsQuestionnaireElementTypesEnum[] = [ 'question'  , 'section']

export const PerformanceValueObjectsQuestionnaireableEnumValues: PerformanceValueObjectsQuestionnaireableEnum[] = [ 'review_process'  , 'review_process_custom_template']

export const PermissionsContextEnumValues: PermissionsContextEnum[] = [ 'everybody'  , 'legal_entity'  , 'owned'  , 'reportees'  , 'team_leader']

export const PermissionsEntitiesPermissionGroupKindEnumValues: PermissionsEntitiesPermissionGroupKindEnum[] = [ 'admin'  , 'custom'  , 'default'  , 'onboarding']

export const PermissionsEntitiesResourceTagTypeEnumValues: PermissionsEntitiesResourceTagTypeEnum[] = [ 'legal_entity']

export const PostsGroupPoliciesEnumValues: PostsGroupPoliciesEnum[] = [ 'add_posts'  , 'leave'  , 'update']

export const PostsPostPoliciesEnumValues: PostsPostPoliciesEnum[] = [ 'manage']

export const ProcessesConfigurationFieldsResourceTypeEnumValues: ProcessesConfigurationFieldsResourceTypeEnum[] = [ 'contract'  , 'employee']

export const ProcessesMaterializedAssigneeStatusEnumValues: ProcessesMaterializedAssigneeStatusEnum[] = [ 'completed'  , 'pending']

export const ProcessesMaterializedProcessStatusEnumValues: ProcessesMaterializedProcessStatusEnum[] = [ 'archived'  , 'finalized'  , 'running']

export const ProcessesMaterializedStepStatusEnumValues: ProcessesMaterializedStepStatusEnum[] = [ 'completed'  , 'running']

export const ProcessesProcessCategoryEnumValues: ProcessesProcessCategoryEnum[] = [ 'custom'  , 'offboarding'  , 'onboarding'  , 'training']

export const ProcessesValueObjectsDataTypeEnumValues: ProcessesValueObjectsDataTypeEnum[] = [ 'date'  , 'string']

export const ProcessesValueObjectsMaterializedActionStatusEnumValues: ProcessesValueObjectsMaterializedActionStatusEnum[] = [ 'completed'  , 'failed'  , 'inprogress']

export const ProcurementValueObjectsPreferredPaymentMethodEnumValues: ProcurementValueObjectsPreferredPaymentMethodEnum[] = [ 'banktransfer'  , 'cash'  , 'virtualcard']

export const ProcurementValueObjectsPurchaseOrderStatusEnumValues: ProcurementValueObjectsPurchaseOrderStatusEnum[] = [ 'closed'  , 'draft'  , 'ordered'  , 'partial'  , 'pending'  , 'received']

export const ProcurementValueObjectsPurchaseRequestStatusEnumValues: ProcurementValueObjectsPurchaseRequestStatusEnum[] = [ 'approved'  , 'changes_requested'  , 'draft'  , 'pending'  , 'rejected']

export const ProcurementValueObjectsUploadDocumentTaskTypeEnumValues: ProcurementValueObjectsUploadDocumentTaskTypeEnum[] = [ 'download'  , 'upload']

export const ProjectManagementEnumsExportableProjectDateGroupEnumValues: ProjectManagementEnumsExportableProjectDateGroupEnum[] = [ 'day'  , 'month']

export const ProjectManagementProjectBillableRateTypeEnumValues: ProjectManagementProjectBillableRateTypeEnum[] = [ 'flat_bill'  , 'individual'  , 'job_based']

export const ProjectManagementProjectEmployeesAssignmentEnumValues: ProjectManagementProjectEmployeesAssignmentEnum[] = [ 'company'  , 'manual']

export const ProjectManagementProjectPoliciesEnumValues: ProjectManagementProjectPoliciesEnum[] = [ 'assign_editor'  , 'assign_owner'  , 'assign_unassign_project_workers'  , 'manage_project_invoices'  , 'manage_tasks'  , 'see_cost'  , 'see_labor_cost'  , 'subproject_edit']

export const ProjectManagementProjectRoleRoleEnumValues: ProjectManagementProjectRoleRoleEnum[] = [ 'editor'  , 'owner'  , 'viewer']

export const ProjectManagementProjectStatusEnumValues: ProjectManagementProjectStatusEnum[] = [ 'active'  , 'closed'  , 'draft'  , 'processing']

export const ProjectManagementSpendingCostStatusEnumValues: ProjectManagementSpendingCostStatusEnum[] = [ 'approved'  , 'pending'  , 'rejected']

export const ProjectManagementSpendingCostTypeEnumValues: ProjectManagementSpendingCostTypeEnum[] = [ 'expenses_expensable'  , 'finance_financialdocument']

export const ProjectManagementValueObjectsBudgetStrategyTypeEnumValues: ProjectManagementValueObjectsBudgetStrategyTypeEnum[] = [ 'project_fixed_cost'  , 'subproject'  , 'total_budget'  , 'without_budget']

export const ProjectManagementValueObjectsStatusTypesEnumValues: ProjectManagementValueObjectsStatusTypesEnum[] = [ 'active'  , 'closed'  , 'draft'  , 'processing']

export const QuestionnairesQuestionnaireQuestionAnswerTypesEnumValues: QuestionnairesQuestionnaireQuestionAnswerTypesEnum[] = [ 'multiple_choice'  , 'number'  , 'rating'  , 'text']

export const ReactionsValueObjectsResourceTypesEnumValues: ReactionsValueObjectsResourceTypesEnum[] = [ 'comments_comment'  , 'posts_post']

export const RegionFinderCountryEnumValues: RegionFinderCountryEnum[] = [ 'ar'  , 'at'  , 'be'  , 'bg'  , 'br'  , 'ch'  , 'cl'  , 'co'  , 'cy'  , 'cz'  , 'de'  , 'dk'  , 'ea'  , 'ee'  , 'es'  , 'fi'  , 'fr'  , 'gb'  , 'gr'  , 'hr'  , 'hu'  , 'ic'  , 'ie'  , 'it'  , 'lt'  , 'lu'  , 'lv'  , 'mt'  , 'mx'  , 'nl'  , 'pl'  , 'pt'  , 'ro'  , 'se'  , 'si'  , 'sk'  , 'us']

export const ReportsDtosExportInsightsTypeEnumValues: ReportsDtosExportInsightsTypeEnum[] = [ 'csv'  , 'xlsx']

export const ReportsEntitiesInsightsFilterFilterTypeEnumValues: ReportsEntitiesInsightsFilterFilterTypeEnum[] = [ 'genders'  , 'nationalities']

export const ReportsEntitiesSharesModeEnumValues: ReportsEntitiesSharesModeEnum[] = [ 'become'  , 'personal']

export const ReportsEntitiesSharesVisibilityEnumValues: ReportsEntitiesSharesVisibilityEnum[] = [ 'editor'  , 'viewer']

export const ReportsInsightsCycleEnumValues: ReportsInsightsCycleEnum[] = [ 'daily'  , 'monthly'  , 'quarterly'  , 'weekly']

export const ReportsReportPoliciesEnumValues: ReportsReportPoliciesEnum[] = [ 'share']

export const ReportsValuesContentsEngineEnumValues: ReportsValuesContentsEngineEnum[] = [ 'athena']

export const ReportsValuesContentsStatusEnumValues: ReportsValuesContentsStatusEnum[] = [ 'ok'  , 'outdated']

export const ReportsValuesDashboardsVariableTypeEnumValues: ReportsValuesDashboardsVariableTypeEnum[] = [ 'date'  , 'team'  , 'text']

export const ReportsValuesFieldsEditorEnumValues: ReportsValuesFieldsEditorEnum[] = [ 'query_builder'  , 'sql_editor']

export const ReportsValuesFieldsTypeEnumValues: ReportsValuesFieldsTypeEnum[] = [ 'boolean'  , 'cohort'  , 'date'  , 'decimal'  , 'number'  , 'text']

export const ReportsValuesFieldsUiTypeEnumValues: ReportsValuesFieldsUiTypeEnum[] = [ 'cents'  , 'enum'  , 'hours'  , 'link'  , 'money'  , 'rating'  , 'text']

export const ReportsValuesRefreshStatusEnumValues: ReportsValuesRefreshStatusEnum[] = [ 'empty'  , 'ready'  , 'running']

export const ReportsValuesReportsChartTypeEnumValues: ReportsValuesReportsChartTypeEnum[] = [ 'area'  , 'bars'  , 'lines'  , 'numeric_metric'  , 'pie'  , 'scatterplot'  , 'table']

export const SalaryAdvanceValueObjectsEmployeeStatusEnumValues: SalaryAdvanceValueObjectsEmployeeStatusEnum[] = [ 'active'  , 'disabled'  , 'pending_information']

export const SalaryAdvanceValueObjectsRequestStatusEnumValues: SalaryAdvanceValueObjectsRequestStatusEnum[] = [ 'completed'  , 'processing'  , 'requested']

export const SecuritySettingsMfaStatusEnumValues: SecuritySettingsMfaStatusEnum[] = [ 'disabled'  , 'enabled'  , 'required']

export const SecuritySettingsSsoEnforcementEnumValues: SecuritySettingsSsoEnforcementEnum[] = [ 'all'  , 'domain'  , 'none']

export const SerialSequencesValueObjectsStatusEnumValues: SerialSequencesValueObjectsStatusEnum[] = [ 'active'  , 'archived']

export const ShiftManagementEnumsAutoSchedulerExecutionStatusEnumValues: ShiftManagementEnumsAutoSchedulerExecutionStatusEnum[] = [ 'solving_active'  , 'solving_completed'  , 'solving_failed'  , 'solving_incomplete'  , 'solving_killed'  , 'solving_scheduled'  , 'solving_started']

export const ShiftManagementEnumsRestDayCreationModeEnumValues: ShiftManagementEnumsRestDayCreationModeEnum[] = [ 'automatic'  , 'manual']

export const ShiftManagementEnumsRestDayStateEnumValues: ShiftManagementEnumsRestDayStateEnum[] = [ 'draft'  , 'published']

export const ShiftManagementEnumsShiftCreationModeEnumValues: ShiftManagementEnumsShiftCreationModeEnum[] = [ 'automatic'  , 'manual']

export const ShiftManagementEnumsShiftStateEnumValues: ShiftManagementEnumsShiftStateEnum[] = [ 'backup'  , 'draft'  , 'published']

export const ShiftManagementShiftInteractorDropActionEnumValues: ShiftManagementShiftInteractorDropActionEnum[] = [ 'copy'  , 'move']

export const SoftwareManagementValueObjectsSoftwarePaymentSourceTypeEnumValues: SoftwareManagementValueObjectsSoftwarePaymentSourceTypeEnum[] = [ 'banking_cardpayment'  , 'finance_invoice']

export const SpaceControlBookingBookingStatusEnumValues: SpaceControlBookingBookingStatusEnum[] = [ 'active'  , 'cancelled']

export const SpaceControlWorkSpaceWorkSpaceTypeEnumValues: SpaceControlWorkSpaceWorkSpaceTypeEnum[] = [ 'booth'  , 'desk'  , 'lunch'  , 'meeting_room'  , 'other'  , 'parking']

export const StringEnumValues: StringEnum[] = [ 'company_internal'  , 'company_public'  , 'employee_my_documents'  , 'pending_to_assign'  , 'pending_to_destroy']

export const SurveysEnumsRespondentStrategyEnumValues: SurveysEnumsRespondentStrategyEnum[] = [ 'all_employees'  , 'employees'  , 'everyone'  , 'legal_entities'  , 'locations'  , 'managers'  , 'teams']

export const SurveysEnumsSurveyTypeEnumValues: SurveysEnumsSurveyTypeEnum[] = [ 'custom'  , 'enps']

export const SurveysFormTypeEnumValues: SurveysFormTypeEnum[] = [ 'enps'  , 'review'  , 'survey']

export const SurveysSurveyPoliciesEnumValues: SurveysSurveyPoliciesEnum[] = [ 'edit']

export const TasksTaskPoliciesEnumValues: TasksTaskPoliciesEnum[] = [ 'copy'  , 'destroy'  , 'edit'  , 'resolve']

export const TasksTaskStatusEnumValues: TasksTaskStatusEnum[] = [ 'all'  , 'completed'  , 'due_in_future'  , 'due_today'  , 'incompleted'  , 'no_due'  , 'over_due'  , 'owned']

export const TasksTaskTypeEnumValues: TasksTaskTypeEnum[] = [ 'data_collection'  , 'send_document_template'  , 'sign_documents'  , 'single_task'  , 'upload_document']

export const TasksValueObjectsTaskCategoryEnumValues: TasksValueObjectsTaskCategoryEnum[] = [ 'benefits'  , 'compensation'  , 'complaints'  , 'documents'  , 'engagement'  , 'finance'  , 'organization'  , 'performance'  , 'recruitment'  , 'software'  , 'spending'  , 'surveys'  , 'time_planning'  , 'time_tracking'  , 'timeoff'  , 'training']

export const TasksValueObjectsTaskDueStatusEnumValues: TasksValueObjectsTaskDueStatusEnum[] = [ 'due_in_future'  , 'due_today'  , 'no_due'  , 'over_due']

export const TasksValueObjectsTaskIdentifierEnumValues: TasksValueObjectsTaskIdentifierEnum[] = [ 'inbox'  , 'project'  , 'shared_and_single'  , 'single'  , 'workflow']

export const TasksValueObjectsTaskInvolvementRolesEnumValues: TasksValueObjectsTaskInvolvementRolesEnum[] = [ 'affectee'  , 'assignee']

export const TasksValueObjectsTaskKindEnumValues: TasksValueObjectsTaskKindEnum[] = [ 'approve'  , 'complete'  , 'fill'  , 'import'  , 'manual'  , 'send'  , 'sign'  , 'terminate'  , 'upload']

export const TasksValueObjectsTaskSortColumnEnumValues: TasksValueObjectsTaskSortColumnEnum[] = [ 'created_at'  , 'due_on']

export const TasksValueObjectsTaskSortDirectionEnumValues: TasksValueObjectsTaskSortDirectionEnum[] = [ 'asc'  , 'desc']

export const TasksValueObjectsTaskStatusEnumValues: TasksValueObjectsTaskStatusEnum[] = [ 'discarded'  , 'done'  , 'in_progress'  , 'todo']

export const TasksValueObjectsTaskTaskTimePeriodEnumValues: TasksValueObjectsTaskTaskTimePeriodEnum[] = [ 'all'  , 'completed'  , 'due_soon'  , 'due_today'  , 'due_tomorrow'  , 'due_upcoming'  , 'last_month'  , 'last_week'  , 'overdue'  , 'today']

export const TeamsTeamPoliciesEnumValues: TeamsTeamPoliciesEnum[] = [ 'manage']

export const TimeInsightsEntitiesClockInStatusStatusEnumValues: TimeInsightsEntitiesClockInStatusStatusEnum[] = [ 'clocked_in'  , 'completed'  , 'expected_to_work'  , 'in_a_break'  , 'invalid_status'  , 'missing_clock_in'  , 'should_not_be_working']

export const TimeInsightsEntitiesInconsistencyStateEnumValues: TimeInsightsEntitiesInconsistencyStateEnum[] = [ 'ignored'  , 'pending'  , 'resolved']

export const TimeInsightsValueObjectsInconsistencyTypeEnumValues: TimeInsightsValueObjectsInconsistencyTypeEnum[] = [ 'insufficient_break_duration'  , 'missing_break_time'  , 'missing_clock_in'  , 'missing_clock_out']

export const TimePlanningEnumsBalancesOnlyBalancesEnumValues: TimePlanningEnumsBalancesOnlyBalancesEnum[] = [ 'all'  , 'bank_holiday_hours'  , 'bank_of_hours'  , 'contract_hours'  , 'leave_hours'  , 'shift_hours']

export const TimePlanningPlannedBreakBreakTypeEnumValues: TimePlanningPlannedBreakBreakTypeEnum[] = [ 'fixed'  , 'flexible'  , 'semi_flexible']

export const TimePlanningPlanningToolEnumValues: TimePlanningPlanningToolEnum[] = [ 'contract_hours'  , 'shift_management'  , 'work_schedule']

export const TimeSettingsEnumsCategoryTypeEnumValues: TimeSettingsEnumsCategoryTypeEnum[] = [ 'extra_hour'  , 'special_hour']

export const TimeSettingsEnumsTimeTypeEnumValues: TimeSettingsEnumsTimeTypeEnum[] = [ 'any_time'  , 'overtime'  , 'regular']

export const TimeoffAllowanceAllowanceTypeEnumValues: TimeoffAllowanceAllowanceTypeEnum[] = [ 'days'  , 'hours']

export const TimeoffAllowanceDaysTypeEnumValues: TimeoffAllowanceDaysTypeEnum[] = [ 'french_calendar_days'  , 'french_ouvres'  , 'natural_days'  , 'natural_days_only_range'  , 'working_days']

export const TimeoffAllowanceIncidencesTargetBalanceEnumValues: TimeoffAllowanceIncidencesTargetBalanceEnum[] = [ 'accrued'  , 'available']

export const TimeoffAllowanceNegativeCounterTypeEnumValues: TimeoffAllowanceNegativeCounterTypeEnum[] = [ 'negative_counter_disabled'  , 'negative_counter_enabled']

export const TimeoffAllowanceProrationTypeEnumValues: TimeoffAllowanceProrationTypeEnum[] = [ 'proration_disabled'  , 'proration_enabled']

export const TimeoffAllowanceRoundingsEnumValues: TimeoffAllowanceRoundingsEnum[] = [ 'decimals'  , 'half_day'  , 'quarters'  , 'round_up']

export const TimeoffAllowanceTenurePeriodBalanceTypeEnumValues: TimeoffAllowanceTenurePeriodBalanceTypeEnum[] = [ 'fixed_balance'  , 'time_worked_based']

export const TimeoffAllowanceTenurePeriodPeriodTypeEnumValues: TimeoffAllowanceTenurePeriodPeriodTypeEnum[] = [ 'months'  , 'years']

export const TimeoffAllowancesAccruedUnitsAvailabilityEnumValues: TimeoffAllowancesAccruedUnitsAvailabilityEnum[] = [ 'current_cycle'  , 'next_cycle']

export const TimeoffAllowancesAvailableDaysEnumValues: TimeoffAllowancesAvailableDaysEnum[] = [ 'all_days'  , 'bimonthly_fifteenth_and_last'  , 'bimonthly_first_and_fifteenth'  , 'generated_days'  , 'generated_days_monthly'  , 'generated_days_monthly_first_day'  , 'mensiversary'  , 'monthly_fifteenth']

export const TimeoffAllowancesFrequencyEnumValues: TimeoffAllowancesFrequencyEnum[] = [ 'lifetime'  , 'monthly_flexible'  , 'yearly']

export const TimeoffAllowancesRangeTypeEnumValues: TimeoffAllowancesRangeTypeEnum[] = [ 'exact_range'  , 'extra_non_working_days_at_end']

export const TimeoffAllowancesSourceUnitsEnumValues: TimeoffAllowancesSourceUnitsEnum[] = [ 'base_units'  , 'by_worked_time'  , 'overtime_units']

export const TimeoffAllowancesTenurePeriodTransitionEnumValues: TimeoffAllowancesTenurePeriodTransitionEnum[] = [ 'after_milestone'  , 'beginning_of_cycle'  , 'end_of_cycle']

export const TimeoffCycleStartEnumValues: TimeoffCycleStartEnum[] = [ 'apr'  , 'aug'  , 'dec'  , 'employee_hired_date'  , 'feb'  , 'jan'  , 'jul'  , 'jun'  , 'mar'  , 'may'  , 'nov'  , 'oct'  , 'sep']

export const TimeoffFrenchDurationsUnitEnumValues: TimeoffFrenchDurationsUnitEnum[] = [ 'days'  , 'hours']

export const TimeoffLeaveApprovalRecommendationsRecommendedActionEnumValues: TimeoffLeaveApprovalRecommendationsRecommendedActionEnum[] = [ 'approve'  , 'no_recommendation'  , 'reject'  , 'review']

export const TimeoffLeavePoliciesEnumValues: TimeoffLeavePoliciesEnum[] = [ 'approveLeave'  , 'deleteLeave'  , 'manageLeaveDocuments'  , 'updateLeave']

export const TrainingsCategoryMapConfigCategoryEnumValues: TrainingsCategoryMapConfigCategoryEnum[] = [ 'educationlevel'  , 'professionalcategory']

export const TrainingsEntitiesContentBlockStatusEnumValues: TrainingsEntitiesContentBlockStatusEnum[] = [ 'completed'  , 'inprogress'  , 'notstarted']

export const TrainingsReminderTimeframeEnumValues: TrainingsReminderTimeframeEnum[] = [ 'custom'  , 'oneday'  , 'onehour'  , 'oneweek'  , 'threedays'  , 'twodays']

export const TrainingsSessionAttendancePoliciesEnumValues: TrainingsSessionAttendancePoliciesEnum[] = [ 'edit']

export const TrainingsSessionAttendanceStatusEnumValues: TrainingsSessionAttendanceStatusEnum[] = [ 'completed'  , 'inprogress'  , 'missing'  , 'pending']

export const TrainingsSessionFrequencyEnumValues: TrainingsSessionFrequencyEnum[] = [ 'daily'  , 'monthly'  , 'weekly']

export const TrainingsSessionModalityEnumValues: TrainingsSessionModalityEnum[] = [ 'inperson'  , 'mixed'  , 'online']

export const TrainingsSessionScheduleEnumValues: TrainingsSessionScheduleEnum[] = [ 'scheduled'  , 'selfpaced']

export const TrainingsSessionUpdateStrategyEnumValues: TrainingsSessionUpdateStrategyEnum[] = [ 'all'  , 'future'  , 'individually']

export const TrainingsTrainingClassModalityEnumValues: TrainingsTrainingClassModalityEnum[] = [ 'scheduled'  , 'selfpaced']

export const TrainingsTrainingMembershipStatusEnumValues: TrainingsTrainingMembershipStatusEnum[] = [ 'completed'  , 'missing'  , 'notassigned'  , 'notstarted'  , 'partiallycompleted'  , 'started']

export const TrainingsTrainingPoliciesEnumValues: TrainingsTrainingPoliciesEnum[] = [ 'edit'  , 'read']

export const TrainingsTrainingRequestPoliciesEnumValues: TrainingsTrainingRequestPoliciesEnum[] = [ 'manage_request'  , 'read']

export const TrainingsTrainingRequestScheduleEnumValues: TrainingsTrainingRequestScheduleEnum[] = [ 'mixedhours'  , 'notsure'  , 'outsideworkinghours'  , 'workinghours']

export const TrainingsTrainingRequestStatusEnumValues: TrainingsTrainingRequestStatusEnum[] = [ 'approved'  , 'draft'  , 'rejected'  , 'review']

export const TrainingsTrainingStatusEnumValues: TrainingsTrainingStatusEnum[] = [ 'active'  , 'deleted'  , 'draft']

export const TrainingsTrainingSubsidyEnumValues: TrainingsTrainingSubsidyEnum[] = [ 'fundae'  , 'other']

export const UniversalExportsEntitiesConfigurationFormatEnumValues: UniversalExportsEntitiesConfigurationFormatEnum[] = [ 'csv'  , 'xlsx']

export const UniversalExportsEntitiesExportStatusEnumValues: UniversalExportsEntitiesExportStatusEnum[] = [ 'failed'  , 'generated'  , 'processing']

export const UniversalExportsEntitiesExporterFilterTypeEnumValues: UniversalExportsEntitiesExporterFilterTypeEnum[] = [ 'boolean'  , 'date'  , 'datetime'  , 'integer'  , 'string'  , 'time']

export const UniversalExportsExporterFilterKindEnumValues: UniversalExportsExporterFilterKindEnum[] = [ 'datetimerange'  , 'employees'  , 'multiplechoice'  , 'singlechoice'  , 'vendors']

export const UniversalImporterEntitiesSchemaAdapterColumnTypeEnumValues: UniversalImporterEntitiesSchemaAdapterColumnTypeEnum[] = [ 'boolean'  , 'category'  , 'date'  , 'float'  , 'int'  , 'string']

export const UniversalImporterValueObjectsImportProcessMetadataValueTypeEnumValues: UniversalImporterValueObjectsImportProcessMetadataValueTypeEnum[] = [ 'boolean'  , 'integer'  , 'string']

export const UniversalImporterValueObjectsImportTypeEnumValues: UniversalImporterValueObjectsImportTypeEnum[] = [ 'ats_job_posting_importer'  , 'candidates_importer'  , 'compensations_employee_compensation_importer'  , 'competencies_competency_assignment_importer'  , 'competencies_competency_importer'  , 'contract_version_edition'  , 'contract_version_importer'  , 'cost_center_assignment_importer'  , 'cost_centers_importer'  , 'employee_bulk_activate_importer'  , 'employee_bulk_pause_importer'  , 'employee_bulk_termination_importer'  , 'employee_edition'  , 'employee_importer'  , 'fd_contract_importer'  , 'healthcare_beneficiaries_importer'  , 'it_management_it_assets_importer'  , 'job_catalog_tree_importer'  , 'payroll_summary_importer'  , 'teams_importer'  , 'trainings_importer'  , 'working_time_percentage_importer']

export const UniversalImporterValueObjectsNuvoCustomizationCustomizationTypeEnumValues: UniversalImporterValueObjectsNuvoCustomizationCustomizationTypeEnum[] = [ 'transformation'  , 'validation']

export const UniversalImporterValueObjectsNuvoDropdownOptionTypeEnumValues: UniversalImporterValueObjectsNuvoDropdownOptionTypeEnum[] = [ 'boolean'  , 'date'  , 'float'  , 'int'  , 'string']

export const UniversalImporterValueObjectsNuvoValidationValidationTypeEnumValues: UniversalImporterValueObjectsNuvoValidationValidationTypeEnum[] = [ 'regex'  , 'required'  , 'required_with'  , 'required_with_all'  , 'required_with_values'  , 'unique']

export const UpsellDtosUpsellDiscountCreateDiscountTypeEnumValues: UpsellDtosUpsellDiscountCreateDiscountTypeEnum[] = [ 'abandoned_cart']

export const UpsellDtosUpsellDiscountScheduleDiscountTypeEnumValues: UpsellDtosUpsellDiscountScheduleDiscountTypeEnum[] = [ 'abandoned_cart']

export const UsersPersonalInfoPoliciesEnumValues: UsersPersonalInfoPoliciesEnum[] = [ 'edit'  , 'editProfileEmail']

export const WorkflowsEnumsExecutionHandlerStatusEnumValues: WorkflowsEnumsExecutionHandlerStatusEnum[] = [ 'completed'  , 'failed'  , 'running']

export const WorkflowsValueObjectsConditionAstTermsInputDataTypeEnumValues: WorkflowsValueObjectsConditionAstTermsInputDataTypeEnum[] = [ 'boolean'  , 'float'  , 'integer'  , 'string']

export const WorkflowsValueObjectsConditionAstTermsLiteralTypeEnumValues: WorkflowsValueObjectsConditionAstTermsLiteralTypeEnum[] = [ 'boolean'  , 'float'  , 'integer'  , 'integer_array'  , 'nil'  , 'string']

export const WorkflowsValueObjectsConditionAstTermsLogicalOperatorEnumValues: WorkflowsValueObjectsConditionAstTermsLogicalOperatorEnum[] = [ 'and']

export const WorkflowsValueObjectsConditionAstTermsRelationalOperatorEnumValues: WorkflowsValueObjectsConditionAstTermsRelationalOperatorEnum[] = [ 'eq'  , 'gt'  , 'gte'  , 'lt'  , 'lte'  , 'neq'  , 'not_one_of'  , 'one_of']

export const WorkflowsValueObjectsNodeTypeEnumValues: WorkflowsValueObjectsNodeTypeEnum[] = [ 'action'  , 'start'  , 'switch'  , 'terminate']
export type ApprovalGroupEmployeesDataTableQueryVariables = Exact<{
  approvalGroupId: Scalars['Int'];
  search?: InputMaybe<Scalars['String']>;
}>;


export type ApprovalGroupEmployeesDataTableQuery = { __typename?: 'root_query', approvals: { __typename?: 'approvals', approvalGroupMembershipsConnection: { __typename?: 'ApprovalsApprovalGroupMembershipConnection', edges: Array<{ __typename?: 'ApprovalsApprovalGroupMembershipEdge', node: { __typename?: 'ApprovalsApprovalGroupMembership', id: number, access?: { __typename?: 'ApiCoreAccess', id: number, employee?: { __typename?: 'EmployeesEmployee', id: number, fullName: string, access: { __typename?: 'ApiCoreAccess', id: number, avatar?: string | null, fullName: string }, referenceContract?: { __typename?: 'ContractsReferenceContract', id?: number | null, jobTitle?: string | null } | null } | null } | null } }> } } };

export type CandidatesDataTableQueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  atsTagIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  consent?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  emails?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  jobPostingIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  locationIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  minimumAverageRating?: InputMaybe<Scalars['Float']>;
  rejectionReasonIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sourceIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  talentPool?: InputMaybe<Scalars['Boolean']>;
  teamIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type CandidatesDataTableQuery = { __typename?: 'root_query', ats: { __typename?: 'ats', candidatesConnection: { __typename?: 'AtsCandidateConnection', edges: Array<{ __typename?: 'AtsCandidateEdge', node: { __typename?: 'AtsCandidate', id: number, activeApplicationCount?: number | null, consentExpirationDate?: any | null, consentToTalentPool?: boolean | null, email?: string | null, firstName: string, fullName: string, inactiveSince?: any | null, medium?: string | null, phoneNumber?: string | null, searchable?: string | null, talentPool: boolean, createdAt: any, candidateSource?: { __typename?: 'AtsCandidateSource', id: number, name: string } | null } }> } } };

export type ApplicationsDataTableQueryVariables = Exact<{
  atsAnswers?: InputMaybe<Array<ApplicationsAtsAnswersInput> | ApplicationsAtsAnswersInput>;
  atsApplicationPhaseId?: InputMaybe<Scalars['Int']>;
  atsJobPostingId?: InputMaybe<Scalars['Int']>;
  atsTagIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  qualified: Scalars['Boolean'];
  search?: InputMaybe<Scalars['String']>;
}>;


export type ApplicationsDataTableQuery = { __typename?: 'root_query', ats: { __typename?: 'ats', applicationsConnection: { __typename?: 'AtsApplicationConnection', edges: Array<{ __typename?: 'AtsApplicationEdge', node: { __typename?: 'AtsApplication', id: number, atsApplicationPhasePosition?: number | null, atsCandidateSourceName?: string | null, atsJobPostingId: number, medium?: string | null, qualified?: boolean | null, ratingAverage?: number | null, createdAt: any, applicationPhase: { __typename?: 'AtsApplicationPhase', id: number, name: string, position: number, hiringStage?: { __typename?: 'AtsHiringStage', id: number, name: AtsHiringStageNamesEnum } | null }, applicationSource?: { __typename?: 'AtsCandidateSource', id: number, name: string } | null, assessment?: { __typename?: 'AtsAssessment', id: number, status: AtsAssessmentStatusesEnum } | null, candidate: { __typename?: 'AtsCandidate', id: number, atsTagIds?: Array<number> | null, consentToTalentPool?: boolean | null, email?: string | null, fullName: string, duplicateIdentificationsAsMatched: Array<{ __typename?: 'AtsCandidateDuplicatesIdentification', id: number }>, duplicateIdentificationsAsSource: Array<{ __typename?: 'AtsCandidateDuplicatesIdentification', id: number }> }, offerLetter?: { __typename?: 'AtsOfferLetter', id: number, status: string } | null, openAiFeedbackTopMatchRating?: { __typename?: 'OpenAiFeedback', id: string, helpful: boolean } | null, rejectionReason?: { __typename?: 'AtsRejectionReason', id: number, reason: string } | null, summary?: { __typename?: 'AtsApplicationSummary', score: number, topMatch: boolean } | null } }> } } };

export type CardPaymentsDataTableQueryVariables = Exact<{
  accountIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  cardIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  search: Scalars['String'];
}>;


export type CardPaymentsDataTableQuery = { __typename?: 'root_query', banking: { __typename?: 'banking', cardPaymentsConnection: { __typename?: 'BankingCardPaymentConnection', edges: Array<{ __typename?: 'BankingCardPaymentEdge', node: { __typename?: 'BankingCardPayment', id: number, amountCents: number, approved: boolean, calculatedLabel: BankingEntitiesCardPaymentCalculatedLabelEnum, currency: string, externalCreatedAt: any, merchantAmountCents: number, merchantCurrency: string, merchantName: string, rejectedReason?: BankingEntitiesCardPaymentRejectedReasonEnum | null, status: BankingEntitiesCardPaymentStatusEnum, type: BankingEntitiesCardPaymentTypeEnum } }> } } };

export type PaymentExecutionTransfersDataTableQueryVariables = Exact<{
  paymentExecutionId: Scalars['Int'];
  search: Scalars['String'];
}>;


export type PaymentExecutionTransfersDataTableQuery = { __typename?: 'root_query', banking: { __typename?: 'banking', transfersConnection: { __typename?: 'BankingTransferConnection', edges: Array<{ __typename?: 'BankingTransferEdge', node: { __typename?: 'BankingTransfer', id: number, accountNumber: string, amountCents: number, beneficiaryName: string, currency: string, dueDate: any, label: string, paymentExecutionId?: number | null, sourceId: number, sourceType: BankingValueObjectsTransferSourceTypeEnum, status: BankingValueObjectsTransferStatusEnum, createdAt: any, requester?: { __typename?: 'EmployeesEmployee', id: number, access: { __typename?: 'ApiCoreAccess', id: number, avatar?: string | null, fullName: string } } | null } }> } } };

export type PaymentsDataTableQueryVariables = Exact<{
  search: Scalars['String'];
}>;


export type PaymentsDataTableQuery = { __typename?: 'root_query', banking: { __typename?: 'banking', paymentsConnection: { __typename?: 'BankingPaymentConnection', edges: Array<{ __typename?: 'BankingPaymentEdge', node: { __typename?: 'BankingPayment', id: number, amountCents: number, currency: string, date: any, dueDate?: any | null, label: string, status: BankingEntitiesPaymentStatusEnum, account?: { __typename?: 'BankingBankAccount', id: number, account: { __typename?: 'BankingAccount', id: number, providerConfiguration?: { __typename?: 'BankingProviderConfiguration', id: string, services: Array<BankingProvidersServicesEnumEnum> } | null } } | null, paymentExecutions: Array<{ __typename?: 'BankingPaymentExecution', id: number, date: any, executedAt?: any | null, paidAt?: any | null, status: BankingEntitiesPaymentStatusEnum, consent?: { __typename?: 'BankingConsent', id: number, consentUrl: string } | null, payer?: { __typename?: 'EmployeesEmployee', id: number, fullName: string } | null, sepaFile?: { __typename?: 'ApiCoreAttachment', id: number, filename: string, url: string } | null, transfersConnection: { __typename?: 'BankingTransferConnection', totalCount?: number | null } }>, requester?: { __typename?: 'EmployeesEmployee', id: number, fullName: string, access: { __typename?: 'ApiCoreAccess', id: number, avatar?: string | null, fullName: string } } | null } }> } } };

export type TransfersDataTableQueryVariables = Exact<{
  onlyPending?: InputMaybe<Scalars['Boolean']>;
  search: Scalars['String'];
}>;


export type TransfersDataTableQuery = { __typename?: 'root_query', banking: { __typename?: 'banking', transfersConnection: { __typename?: 'BankingTransferConnection', edges: Array<{ __typename?: 'BankingTransferEdge', node: { __typename?: 'BankingTransfer', id: number, accountNumber: string, amountCents: number, beneficiaryName: string, currency: string, dueDate: any, label: string, paymentExecutionId?: number | null, sourceId: number, sourceType: BankingValueObjectsTransferSourceTypeEnum, createdAt: any, requester?: { __typename?: 'EmployeesEmployee', id: number, access: { __typename?: 'ApiCoreAccess', id: number, avatar?: string | null, fullName: string } } | null } }> } } };

export type CardsDataTableQueryVariables = Exact<{
  bankAccountIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  companyId: Scalars['Int'];
}>;


export type CardsDataTableQuery = { __typename?: 'root_query', banking: { __typename?: 'banking', cardsConnection: { __typename?: 'BankingCardConnection', edges: Array<{ __typename?: 'BankingCardEdge', node: { __typename?: 'BankingCard', id: number, alias?: string | null, creationSource: BankingValueObjectsCardCreationSourceEnum, expMonth: number, expYear: number, last4?: string | null, status: BankingValueObjectsCardStatusEnum, type: BankingValueObjectsCardTypeEnum, createdAt: any, _policies?: { __typename?: 'BankingCardPolicies', activate: { __typename?: 'PermissionsPolicyResolution', id: string, can: boolean }, approve: { __typename?: 'PermissionsPolicyResolution', id: string, can: boolean }, cancel: { __typename?: 'PermissionsPolicyResolution', id: string, can: boolean }, deactivate: { __typename?: 'PermissionsPolicyResolution', id: string, can: boolean }, reactivate: { __typename?: 'PermissionsPolicyResolution', id: string, can: boolean } } | null, approval?: { __typename?: 'ApprovalsMaterializedApprovalsFlow', id: number, status: ApprovalsMaterializedApprovalFlowStatusEnum, _policies?: { __typename?: 'ApprovalsMaterializedApprovalsFlowPolicies', approveOrReject: { __typename?: 'PermissionsPolicyResolution', id: string, can: boolean } } | null } | null, cardholder: { __typename?: 'BankingCardholder', id: number, employee?: { __typename?: 'EmployeesEmployeeName', id: number, access: { __typename?: 'ApiCoreAccess', id: number, avatar?: string | null, fullName: string } } | null }, softwareSetup?: { __typename?: 'SoftwareManagementSoftwareSetup', id: number, software?: { __typename?: 'SoftwareManagementSoftware', id: string, logoUrl: string, name: string } | null } | null } }> } } };

export type ReconciliationInvoicesDataTableQueryVariables = Exact<{
  companyId: Scalars['Int'];
  currency?: InputMaybe<Scalars['String']>;
  reconcilable?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type ReconciliationInvoicesDataTableQuery = { __typename?: 'root_query', finance: { __typename?: 'finance', financialDocumentsConnection: { __typename?: 'FinanceFinancialDocumentConnection', edges: Array<{ __typename?: 'FinanceFinancialDocumentEdge', node: { __typename?: 'FinanceFinancialDocument', id: number, currency?: string | null, documentDate?: string | null, documentNumber?: string | null, documentType: FinanceValueObjectsFinancialDocumentTypeEnum, totalAmountCents?: any | null, expensesFinancialDocumentAssociation?: { __typename?: 'FinanceFinancialDocumentAssociation', expense?: { __typename?: 'ExpensesExpense', expensable: { __typename?: 'ExpensesExpensable', id: number } } | null } | null, reconciliations: Array<{ __typename?: 'BankingReconciliation', id: number, reconcilableReconciledAmountCents?: number | null }>, vendor?: { __typename?: 'FinanceContact', id: number, legalName?: string | null, name: string } | null } }> } } };

export type ReconciliationTransactionDataTableQueryVariables = Exact<{
  accountIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  currency?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  status: BankingEntitiesTransactionStatusEnum;
}>;


export type ReconciliationTransactionDataTableQuery = { __typename?: 'root_query', banking: { __typename?: 'banking', transactionsConnection: { __typename?: 'BankingTransactionConnection', edges: Array<{ __typename?: 'BankingTransactionEdge', node: { __typename?: 'BankingTransaction', id: number, amountCents: number, bookingDate: any, currency: string, description?: string | null, fullyReconciledAt?: any | null, snoozedUntil?: any | null, reconciliations: Array<{ __typename?: 'BankingReconciliation', id: number, transactionReconciledAmountCents: number }> } }> } } };

export type TransactionDataTableQueryVariables = Exact<{
  accountIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  description: Scalars['String'];
  status: BankingEntitiesTransactionStatusEnum;
}>;


export type TransactionDataTableQuery = { __typename?: 'root_query', banking: { __typename?: 'banking', transactionsConnection: { __typename?: 'BankingTransactionConnection', edges: Array<{ __typename?: 'BankingTransactionEdge', node: { __typename?: 'BankingTransaction', id: number, amountCents: number, balanceAfterCents?: number | null, bookingDate: any, currency: string, description?: string | null, type: BankingEntitiesTransactionTypeEnum, cardPayment?: { __typename?: 'BankingCardPayment', id: number, card: { __typename?: 'BankingCard', id: number, creationSource: BankingValueObjectsCardCreationSourceEnum, last4?: string | null } } | null, category?: { __typename?: 'FinanceCustomCategory', id: number, label: string } | null } }> } } };

export type BookkeepersManagementIncidenceDataTableQueryVariables = Exact<{ [key: string]: never; }>;


export type BookkeepersManagementIncidenceDataTableQuery = { __typename?: 'root_query', bookkeepersManagement: { __typename?: 'bookkeepersManagement', incidencesConnection: { __typename?: 'BookkeepersManagementIncidenceConnection', edges: Array<{ __typename?: 'BookkeepersManagementIncidenceEdge', node: { __typename?: 'BookkeepersManagementIncidence', id: number, customName?: string | null, hasMessage?: boolean | null, isReopened: boolean, messageFrom?: string | null, name: string, readAt?: string | null, startsOn?: string | null, status: string, targetId: number, employee?: { __typename?: 'EmployeesEmployee', id: number, firstName: string, fullName: string, lastName: string } | null, legalEntity?: { __typename?: 'CompaniesLegalEntity', id: number, legalName: string, company: { __typename?: 'ApiCoreCompany', id: number } } | null } }> } } };

export type BookkeepersManagementPayrollResultsDataTableQueryVariables = Exact<{
  companyIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  periodEndsOn?: InputMaybe<Scalars['ISO8601Date']>;
  periodStartsOn?: InputMaybe<Scalars['ISO8601Date']>;
  status?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type BookkeepersManagementPayrollResultsDataTableQuery = { __typename?: 'root_query', payroll: { __typename?: 'payroll', policyPeriodsConnection: { __typename?: 'PayrollPolicyPeriodConnection', edges: Array<{ __typename?: 'PayrollPolicyPeriodEdge', node: { __typename?: 'PayrollPolicyPeriod', id: number, endsOn: string, startsOn: string, status?: string | null, policy?: { __typename?: 'PayrollPolicy', id: number, name?: string | null, recurrence: string, company: { __typename?: 'ApiCoreCompany', id: number, name: string } } | null } }> } } };

export type WorkingConditionsVersionEmployeesQueryVariables = Exact<{
  versionId: Scalars['Int'];
}>;


export type WorkingConditionsVersionEmployeesQuery = { __typename?: 'root_query', workingConditions: { __typename?: 'workingConditions', versionApplicationsConnection: { __typename?: 'WorkingConditionsVersionApplicationConnection', edges: Array<{ __typename?: 'WorkingConditionsVersionApplicationEdge', node: { __typename?: 'WorkingConditionsVersionApplication', id: number, differentFieldsCount: number, contractVersion: { __typename?: 'ContractsContractVersion', id?: number | null, jobTitle?: string | null, employee?: { __typename?: 'EmployeesEmployee', id: number, firstName: string, lastName: string, locationId: number, locationName?: string | null, avatar?: { __typename?: 'ApiCoreAttachment', id: number, url: string } | null } | null, jobCatalogLevel?: { __typename?: 'JobCatalogLevel', id: number, name: string, roleName: string } | null }, version: { __typename?: 'WorkingConditionsVersion', id: number, description?: string | null, name: string } } }> } } };

export type DocumentsDataTableQueryVariables = Exact<{
  byTrashBin?: InputMaybe<Scalars['Boolean']>;
  byWithoutFolder?: InputMaybe<Scalars['Boolean']>;
  employeeId?: InputMaybe<Scalars['Int']>;
  folderId?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  space?: InputMaybe<Scalars['String']>;
}>;


export type DocumentsDataTableQuery = { __typename?: 'root_query', documents: { __typename?: 'documents', documentsConnection: { __typename?: 'DocumentsDocumentConnection', edges: Array<{ __typename?: 'DocumentsDocumentEdge', node: { __typename?: 'DocumentsDocument', id: number, arCreatedAt?: number | null, contentType?: string | null, deletedAt?: any | null, extension?: string | null, file?: string | null, filename: string, fileSize?: any | null, fileUrl: string, fromTemplate?: boolean | null, incidenceMessageId?: number | null, isCompanyDocument?: boolean | null, isPendingAssignment?: boolean | null, leaveId?: number | null, notificationStatus?: string | null, permissionUpdate: boolean, public: boolean, signatureStatus?: DocumentsSignatureStatusEnum | null, signees?: Array<number> | null, space: string, status?: DocumentStatusesEnum | null, templateId?: number | null, type: string, createdAt: any, updatedAt: any, _policies?: { __typename?: 'DocumentsDocumentPolicies', edit: { __typename?: 'PermissionsPolicyResolution', can: boolean } } | null, author?: { __typename?: 'ApiCoreAccess', id: number, fullName: string } | null, company: { __typename?: 'ApiCoreCompany', id: number }, employee?: { __typename?: 'EmployeesEmployee', id: number, fullName: string, access: { __typename?: 'ApiCoreAccess', id: number, avatar?: string | null, firstName: string, fullName: string, lastName: string }, avatar?: { __typename?: 'ApiCoreAttachment', url: string } | null } | null, folder?: { __typename?: 'DocumentsFolder', id: number, name: string, showOnly: boolean, rootParentFolder?: { __typename?: 'DocumentsFolder', id: number, name: string } | null } | null } }> } } };

export type DatevLaudsEmployeesDataTableQueryVariables = Exact<{
  employeeImportId: Scalars['Int'];
  employeeType?: InputMaybe<Scalars['String']>;
}>;


export type DatevLaudsEmployeesDataTableQuery = { __typename?: 'root_query', integrationsDatevLauds: { __typename?: 'integrationsDatevLauds', importedEmployeesConnection: { __typename?: 'IntegrationsDatevLaudsImportedEmployeeConnection', edges: Array<{ __typename?: 'IntegrationsDatevLaudsImportedEmployeeEdge', node: { __typename?: 'IntegrationsDatevLaudsImportedEmployee', id?: number | null, mandatoryData?: { __typename?: 'IntegrationsDatevLaudsMandatoryData', datevEmployeeCode?: number | null, email?: string | null, firstName?: string | null, lastName?: string | null } | null } }> } } };

export type ErroredEmployeesDataTableQueryVariables = Exact<{
  employeeImportId: Scalars['Int'];
  employeeType?: InputMaybe<Scalars['String']>;
}>;


export type ErroredEmployeesDataTableQuery = { __typename?: 'root_query', integrationsDatevLauds: { __typename?: 'integrationsDatevLauds', importedEmployeesConnection: { __typename?: 'IntegrationsDatevLaudsImportedEmployeeConnection', edges: Array<{ __typename?: 'IntegrationsDatevLaudsImportedEmployeeEdge', node: { __typename?: 'IntegrationsDatevLaudsImportedEmployee', id?: number | null, mandatoryData?: { __typename?: 'IntegrationsDatevLaudsMandatoryData', datevEmployeeCode?: number | null, email?: string | null, firstName?: string | null, lastName?: string | null, legalEntityName?: string | null } | null } }> } } };

export type ValidEmployeesDataTableQueryVariables = Exact<{
  employeeImportId: Scalars['Int'];
  employeeType?: InputMaybe<Scalars['String']>;
}>;


export type ValidEmployeesDataTableQuery = { __typename?: 'root_query', integrationsDatevLauds: { __typename?: 'integrationsDatevLauds', importedEmployeesConnection: { __typename?: 'IntegrationsDatevLaudsImportedEmployeeConnection', edges: Array<{ __typename?: 'IntegrationsDatevLaudsImportedEmployeeEdge', node: { __typename?: 'IntegrationsDatevLaudsImportedEmployee', id?: number | null, mandatoryData?: { __typename?: 'IntegrationsDatevLaudsMandatoryData', datevEmployeeCode?: number | null, email?: string | null, firstName?: string | null, lastName?: string | null, legalEntityName?: string | null } | null } }> } } };

export type EmployeePulseEmployeeDatatableQueryVariables = Exact<{
  from: Scalars['ISO8601Date'];
  to: Scalars['ISO8601Date'];
  withTags?: InputMaybe<Scalars['Boolean']>;
}>;


export type EmployeePulseEmployeeDatatableQuery = { __typename?: 'root_query', engagement: { __typename?: 'engagement', employeePulseSummariesConnection: { __typename?: 'EngagementEmployeePulseSummaryConnection', edges: Array<{ __typename?: 'EngagementEmployeePulseSummaryEdge', node: { __typename?: 'EngagementEmployeePulseSummary', id: number, comment?: string | null, submittedDate?: any | null, value: number, access?: { __typename?: 'ApiCoreAccess', id: number, avatar?: string | null, employee?: { __typename?: 'EmployeesEmployee', id: number, fullName: string } | null } | null, tags: Array<{ __typename?: 'EngagementPulseTag', id: number, key: string, signalName: string }> } }> } }, teams: { __typename?: 'teams', teamsConnection: { __typename?: 'TeamsTeamConnection', edges: Array<{ __typename?: 'TeamsTeamEdge', node: { __typename?: 'TeamsTeam', id: number, name: string } }> } } };

export type SignedInvoicesDataTableQueryVariables = Exact<{
  invoiceState?: InputMaybe<Scalars['String']>;
  omitSignedDocuments?: InputMaybe<Scalars['Boolean']>;
  receiverLegalEntityId: Scalars['Int'];
  signedForOrganization: Scalars['String'];
}>;


export type SignedInvoicesDataTableQuery = { __typename?: 'root_query', companies: { __typename?: 'companies', legalEntitiesConnection: { __typename?: 'CompaniesLegalEntityConnection', edges: Array<{ __typename?: 'CompaniesLegalEntityEdge', node: { __typename?: 'CompaniesLegalEntity', id: number, aeatClosingPeriodFrequency?: string | null } }> } }, expenses: { __typename?: 'expenses', signedInvoicesConnection: { __typename?: 'ExpensesSignedInvoiceConnection', edges: Array<{ __typename?: 'ExpensesSignedInvoiceEdge', node: { __typename?: 'ExpensesSignedInvoice', id: number, accountingDate?: any | null, amount: number, beenTampered: boolean, currency: string, emitterName?: string | null, missingRequiredData: boolean, expensesClosingPeriod?: { __typename?: 'ExpensesClosingPeriod', id: number } | null, parentExpense?: { __typename?: 'ExpensesExpense', id?: number | null, status: ExpensesEntitiesExpensableStatusEnum } | null } }> } } };

export type ExpensesSubscriptionMembersDatatableQueryVariables = Exact<{
  accessIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  companyId: Scalars['Int'];
}>;


export type ExpensesSubscriptionMembersDatatableQuery = { __typename?: 'root_query', features: { __typename?: 'features', featureMembership?: { __typename?: 'FeaturesFeatureMembership', id: number, membersConnection: { __typename?: 'PeopleGroupsPeopleGroupMembershipConnection', totalCount?: number | null, edges: Array<{ __typename?: 'PeopleGroupsPeopleGroupMembershipEdge', node: { __typename?: 'PeopleGroupsPeopleGroupMembership', id: number, createdAt?: any | null, access: { __typename?: 'ApiCoreAccess', id: number, avatar?: string | null, fullName: string, employee?: { __typename?: 'EmployeesEmployee', id: number } | null } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean } } } | null } };

export type ExpensablesDataTableQueryVariables = Exact<{
  companyId: Scalars['String'];
  employeeIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  from?: InputMaybe<Scalars['ISO8601DateTime']>;
  groupIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  includeManualDrafts?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['ISO8601DateTime']>;
}>;


export type ExpensablesDataTableQuery = { __typename?: 'root_query', expenses: { __typename?: 'expenses', expensablesConnection: { __typename?: 'ExpensesExpensableConnection', edges: Array<{ __typename?: 'ExpensesExpensableEdge', node: { __typename?: 'ExpensesExpensable', id: number, amount?: any | null, approvalFlowReason?: string | null, currency: string, currentUserApprovalStatus?: string | null, description?: string | null, effectiveOn?: any | null, groupId?: number | null, internalReference?: string | null, materializedApprovalFlowId?: number | null, materializedStepApproverId?: number | null, paidAt?: any | null, reimbursableAmount?: any | null, reimbursableCurrency?: string | null, reimbursementMethod?: ExpensesEntitiesExpensableReimbursementMethodEnum | null, reviewRequestAt?: any | null, status: ExpensesEntitiesExpensableStatusEnum, statusUpdatedAt: any, type: ExpensesEntitiesExpensableResourceTypeEnum, createdAt: any, company: { __typename?: 'ApiCoreCompany', id: number, currency?: string | null }, compensation?: { __typename?: 'CompensationsEmployeesCompensation', id: number } | null, currentApprovers: Array<{ __typename?: 'ApiCoreAccess', id: number, fullName: string }>, expense?: { __typename?: 'ExpensesExpense', id?: number | null, creationType: ExpensesEntitiesExpenseCreationTypeEnum, documentType?: string | null, merchantName?: string | null, payment?: ExpensesValueObjectsPaymentOptionsEnum | null, paymentMethod?: string | null, userMerchant?: string | null, card?: { __typename?: 'ExpensesCardWithoutSensitiveInfo', cardType: string, last4?: string | null } | null, cardPayment?: { __typename?: 'BankingCardPayment', id: number, status: BankingEntitiesCardPaymentStatusEnum } | null, category?: { __typename?: 'ExpensesExpenseCategory', id: string, name: string } | null } | null, mileage?: { __typename?: 'ExpensesMileage', id: number, category?: { __typename?: 'ExpensesExpenseCategory', id: string, name: string } | null } | null, owner?: { __typename?: 'EmployeesEmployee', id: number, bankNumber?: string | null, bankNumberFormat?: BankingEntitiesBankAccountNumberFormatEnum | null, access: { __typename?: 'ApiCoreAccess', id: number, avatar?: string | null, fullName: string }, legalEntity?: { __typename?: 'CompaniesLegalEntity', id: number, currency: string } | null } | null, perDiem?: { __typename?: 'ExpensesPerDiem', id: number, category?: { __typename?: 'ExpensesExpenseCategory', id: string, name: string } | null } | null, reporter?: { __typename?: 'EmployeesEmployee', id: number } | null, spendingAlertsSource: Array<{ __typename?: 'FinanceSpendingAlert', id: number, status: FinanceValueObjectsSpendingAlertStatusEnum, type: FinanceValueObjectsSpendingAlertTypeEnum }>, spendingAlertsTarget: Array<{ __typename?: 'FinanceSpendingAlert', id: number, reason?: string | null, status: FinanceValueObjectsSpendingAlertStatusEnum, type: FinanceValueObjectsSpendingAlertTypeEnum, source?: { __typename?: 'ExpensesExpensable' } | { __typename?: 'FinanceSpendingPolicy', id: number, description?: string | null } | { __typename?: 'FinanceSpendingPolicyRuleGroup', id: number, description?: string | null, spendingPolicyRulesConnection: { __typename?: 'FinanceSpendingPolicyRuleConnection', edges: Array<{ __typename?: 'FinanceSpendingPolicyRuleEdge', node: { __typename?: 'FinanceSpendingPolicyRule', id: number, formatedValue?: string | null, identifier: string, operation: ApprovalsDomainConfigurationOperationsEnum, value: Array<string> } }> } } | null }>, supplement?: { __typename?: 'PayrollSupplement', id: number } | null } }> } } };

export type MyGroupedExpensablesDataTableQueryVariables = Exact<{
  employeeIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  from?: InputMaybe<Scalars['ISO8601DateTime']>;
  groupIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  includeManualDrafts?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['ISO8601DateTime']>;
}>;


export type MyGroupedExpensablesDataTableQuery = { __typename?: 'root_query', expenses: { __typename?: 'expenses', expensablesConnection: { __typename?: 'ExpensesExpensableConnection', edges: Array<{ __typename?: 'ExpensesExpensableEdge', node: { __typename?: 'ExpensesExpensable', id: number, amount?: any | null, approvalFlowReason?: string | null, currency: string, currentUserApprovalStatus?: string | null, description?: string | null, effectiveOn?: any | null, groupId?: number | null, internalReference?: string | null, materializedApprovalFlowId?: number | null, materializedStepApproverId?: number | null, paidAt?: any | null, reimbursableAmount?: any | null, reimbursableCurrency?: string | null, reviewRequestAt?: any | null, status: ExpensesEntitiesExpensableStatusEnum, statusUpdatedAt: any, type: ExpensesEntitiesExpensableResourceTypeEnum, createdAt: any, company: { __typename?: 'ApiCoreCompany', id: number, currency?: string | null }, currentApprovers: Array<{ __typename?: 'ApiCoreAccess', id: number, fullName: string }>, expense?: { __typename?: 'ExpensesExpense', id?: number | null, creationType: ExpensesEntitiesExpenseCreationTypeEnum, documentType?: string | null, merchantName?: string | null, payment?: ExpensesValueObjectsPaymentOptionsEnum | null, paymentMethod?: string | null, userMerchant?: string | null, card?: { __typename?: 'ExpensesCardWithoutSensitiveInfo', cardType: string, last4?: string | null } | null, cardPayment?: { __typename?: 'BankingCardPayment', id: number, status: BankingEntitiesCardPaymentStatusEnum } | null, category?: { __typename?: 'ExpensesExpenseCategory', id: string, name: string } | null } | null, mileage?: { __typename?: 'ExpensesMileage', id: number, category?: { __typename?: 'ExpensesExpenseCategory', id: string, name: string } | null } | null, owner?: { __typename?: 'EmployeesEmployee', id: number, access: { __typename?: 'ApiCoreAccess', id: number, avatar?: string | null, fullName: string }, legalEntity?: { __typename?: 'CompaniesLegalEntity', id: number, currency: string } | null } | null, perDiem?: { __typename?: 'ExpensesPerDiem', id: number, category?: { __typename?: 'ExpensesExpenseCategory', id: string, name: string } | null } | null, readyToReviewIssues?: { __typename?: 'ExpensesExpensableReadyToReviewIssue', issues: Array<{ __typename?: 'ExpensesSerializableIssue', type: ExpensesValueObjectsValidationsSerializableIssueTypeEnum }> } | null, reporter?: { __typename?: 'EmployeesEmployee', id: number } | null, spendingAlertsSource: Array<{ __typename?: 'FinanceSpendingAlert', id: number, status: FinanceValueObjectsSpendingAlertStatusEnum, type: FinanceValueObjectsSpendingAlertTypeEnum }>, spendingAlertsTarget: Array<{ __typename?: 'FinanceSpendingAlert', id: number, status: FinanceValueObjectsSpendingAlertStatusEnum, type: FinanceValueObjectsSpendingAlertTypeEnum }>, supplement?: { __typename?: 'PayrollSupplement', id: number } | null } }> } } };

export type ExpensableGroupsDataTableQueryVariables = Exact<{
  companyId: Scalars['Int'];
  employeeIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  from?: InputMaybe<Scalars['ISO8601DateTime']>;
  includeDrafts?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['ISO8601DateTime']>;
}>;


export type ExpensableGroupsDataTableQuery = { __typename?: 'root_query', expenses: { __typename?: 'expenses', expensableGroupsConnection: { __typename?: 'ExpensesExpensableGroupConnection', edges: Array<{ __typename?: 'ExpensesExpensableGroupEdge', node: { __typename?: 'ExpensesExpensableGroup', id: number, amount?: any | null, companyId: number, currency?: string | null, description?: string | null, expensablesCount: number, name: string, reimbursableAmount?: any | null, reimbursableCurrency?: string | null, reviewRequestAt?: any | null, status: ExpensesEntitiesExpensableStatusEnum, owner?: { __typename?: 'EmployeesEmployee', id: number, access: { __typename?: 'ApiCoreAccess', id: number, avatar?: string | null, fullName: string }, legalEntity?: { __typename?: 'CompaniesLegalEntity', id: number, currency: string } | null } | null } }> } } };

export type ExpensablesByCategoryTotalsQueryVariables = Exact<{
  companyId: Scalars['Int'];
  filters: ExpensesExpensableFiltersInput;
  from: Scalars['String'];
  to: Scalars['String'];
}>;


export type ExpensablesByCategoryTotalsQuery = { __typename?: 'root_query', expenses: { __typename?: 'expenses', expensablesByCategoryTotalsConnection: { __typename?: 'ExpensesExpensablesByCategoryTotalConnection', totalCount?: number | null, edges: Array<{ __typename?: 'ExpensesExpensablesByCategoryTotalEdge', node: { __typename?: 'ExpensesExpensablesByCategoryTotal', totalAmount: any, customCategory: { __typename?: 'FinanceCustomCategory', id: number, label: string } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean } } } };

export type ExpensablesByTeamQueryVariables = Exact<{
  companyId: Scalars['Int'];
  filters: ExpensesExpensableFiltersInput;
  from: Scalars['String'];
  to: Scalars['String'];
}>;


export type ExpensablesByTeamQuery = { __typename?: 'root_query', expenses: { __typename?: 'expenses', expensablesByTeamsConnection: { __typename?: 'ExpensesExpensablesByTeamConnection', edges: Array<{ __typename?: 'ExpensesExpensablesByTeamEdge', node: { __typename?: 'ExpensesExpensablesByTeam', id: number, totalAmount: any, team: { __typename?: 'TeamsTeam', id: number, avatar?: string | null, name: string } } }> } } };

export type ExpensesByCostCenterDatatableQueryVariables = Exact<{
  companyId: Scalars['Int'];
  filters: ExpensesExpensableFiltersInput;
  from: Scalars['String'];
  to: Scalars['String'];
}>;


export type ExpensesByCostCenterDatatableQuery = { __typename?: 'root_query', expenses: { __typename?: 'expenses', expensablesByCostCentersConnection: { __typename?: 'ExpensesExpensablesByCostCenterConnection', totalCount?: number | null, edges: Array<{ __typename?: 'ExpensesExpensablesByCostCenterEdge', node: { __typename?: 'ExpensesExpensablesByCostCenter', totalAmount: any, costCenter: { __typename?: 'FinanceCostCenter', id: number, name: string } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean } } } };

export type ExpensesByEmployeeDatatableQueryVariables = Exact<{
  companyId: Scalars['Int'];
  filters: ExpensesExpensableFiltersInput;
  from: Scalars['String'];
  to: Scalars['String'];
}>;


export type ExpensesByEmployeeDatatableQuery = { __typename?: 'root_query', expenses: { __typename?: 'expenses', expensablesByEmployeesConnection: { __typename?: 'ExpensesExpensablesByEmployeeConnection', totalCount?: number | null, edges: Array<{ __typename?: 'ExpensesExpensablesByEmployeeEdge', node: { __typename?: 'ExpensesExpensablesByEmployee', totalAmount: any, employee: { __typename?: 'EmployeesEmployee', id: number, access: { __typename?: 'ApiCoreAccess', id: number, avatar?: string | null, fullName: string } } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean } } } };

export type RateConfigurationsDatatableQueryVariables = Exact<{
  archivedOnly?: InputMaybe<Scalars['Boolean']>;
  companyId: Scalars['Int'];
  resourceType?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type RateConfigurationsDatatableQuery = { __typename?: 'root_query', expenses: { __typename?: 'expenses', rateConfigurationsConnection: { __typename?: 'ExpensesRateConfigurationConnection', edges: Array<{ __typename?: 'ExpensesRateConfigurationEdge', node: { __typename?: 'ExpensesRateConfiguration', id: number, amountCents?: number | null, archivedAt?: any | null, currency: string, name: string, rate?: number | null, legalEntitiesConnection: { __typename?: 'CompaniesLegalEntityConnection', nodes: Array<{ __typename?: 'CompaniesLegalEntity', id: number, legalName: string }> }, rateAssigneesConnection: { __typename?: 'ExpensesRateConfigurationAssigneeConnection', totalCount?: number | null } } }> } } };

export type RateConfigurationAssigneesQueryVariables = Exact<{
  rateIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type RateConfigurationAssigneesQuery = { __typename?: 'root_query', expenses: { __typename?: 'expenses', rateConfigurationAssigneesConnection: { __typename?: 'ExpensesRateConfigurationAssigneeConnection', edges: Array<{ __typename?: 'ExpensesRateConfigurationAssigneeEdge', node: { __typename?: 'ExpensesRateConfigurationAssignee', id: number, avatar?: string | null, fullName: string } }> } } };

export type LedgerAccountsDataTableQueryVariables = Exact<{ [key: string]: never; }>;


export type LedgerAccountsDataTableQuery = { __typename?: 'root_query', finance: { __typename?: 'finance', accountsConnection: { __typename?: 'FinanceAccountConnection', edges: Array<{ __typename?: 'FinanceAccountEdge', node: { __typename?: 'FinanceAccount', id: number, balance: number, currency: string, disabled: boolean, externalId?: string | null, legalEntityId: number, name?: string | null, number: string, type: FinanceValueObjectsAccountTypeEnum } }> } } };

export type MissingAgreementDataTableQueryVariables = Exact<{
  costCenterIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  formattedEndDate: Scalars['String'];
  formattedStartDate: Scalars['String'];
  includeFuturePeriods?: InputMaybe<Scalars['Boolean']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  locationIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  managerIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  period: FinancialWorkspaceValueObjectsPeriodEnum;
}>;


export type MissingAgreementDataTableQuery = { __typename?: 'root_query', financialWorkspace: { __typename?: 'financialWorkspace', employeesIncompleteGrossSalariesConnection: { __typename?: 'FinancialWorkspaceEmployeesIncompleteGrossSalaryConnection', edges: Array<{ __typename?: 'FinancialWorkspaceEmployeesIncompleteGrossSalaryEdge', node: { __typename?: 'FinancialWorkspaceEmployeesIncompleteGrossSalary', id: number, effectiveOn: string, endsOn: string, fullName: string, startsOn: string } }> } } };

export type InvoicesDataTableQueryVariables = Exact<{
  companyId: Scalars['Int'];
  documentTypes?: InputMaybe<Array<FinanceValueObjectsFinancialDocumentTypeEnum> | FinanceValueObjectsFinancialDocumentTypeEnum>;
  operationTypes?: InputMaybe<Array<FinanceValueObjectsFinancialDocumentOperationTypeEnum> | FinanceValueObjectsFinancialDocumentOperationTypeEnum>;
  search?: InputMaybe<Scalars['String']>;
  vendorId?: InputMaybe<Scalars['Int']>;
}>;


export type InvoicesDataTableQuery = { __typename?: 'root_query', finance: { __typename?: 'finance', financialDocumentsConnection: { __typename?: 'FinanceFinancialDocumentConnection', edges: Array<{ __typename?: 'FinanceFinancialDocumentEdge', node: { __typename?: 'FinanceFinancialDocument', id: number, companyId: number, currency?: string | null, documentDate?: string | null, documentNumber?: string | null, documentType: FinanceValueObjectsFinancialDocumentTypeEnum, dueDate?: string | null, duplicateFinancialDocumentId?: number | null, status: FinanceValueObjectsInvoiceStatusEnum, totalAmountCents?: any | null, validatedAt?: any | null, legalEntity?: { __typename?: 'CompaniesLegalEntity', id: number, legalName: string } | null, taxes: Array<{ __typename?: 'FinanceInvoiceTax', amountCents?: any | null, baseAmountCents?: any | null, percentage?: number | null }>, vendor?: { __typename?: 'FinanceContact', id: number, companyId: number, iban?: string | null, legalName?: string | null, name: string } | null } }> } } };

export type JournalDraftEntryDatableQueryVariables = Exact<{
  companyId: Scalars['Int'];
  legalEntityIds: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type JournalDraftEntryDatableQuery = { __typename?: 'root_query', finance: { __typename?: 'finance', journalDraftEntriesConnection: { __typename?: 'FinanceJournalDraftEntryConnection', edges: Array<{ __typename?: 'FinanceJournalDraftEntryEdge', node: { __typename?: 'FinanceJournalDraftEntry', id: number, description?: string | null, referenceDate?: string | null, status: FinanceValueObjectsJournalDraftEntryStatusEnum, type: FinanceValueObjectsJournalEntryTypeEnum, financialDocument?: { __typename?: 'FinanceFinancialDocument', id: number, documentNumber?: string | null } | null, journalDraftLines: Array<{ __typename?: 'FinanceJournalDraftLine', id: number, creditAmountCents?: number | null, debitAmountCents?: number | null }>, legalEntity: { __typename?: 'CompaniesLegalEntity', id: number, currency: string } } }> } } };

export type JournalEntryDatableQueryVariables = Exact<{
  companyId: Scalars['Int'];
  legalEntityIds: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type JournalEntryDatableQuery = { __typename?: 'root_query', finance: { __typename?: 'finance', journalEntriesConnection: { __typename?: 'FinanceJournalEntryConnection', edges: Array<{ __typename?: 'FinanceJournalEntryEdge', node: { __typename?: 'FinanceJournalEntry', id: number, description?: string | null, number: number, publishedAt: any, status: FinanceValueObjectsJournalEntryStatusEnum, type: FinanceValueObjectsJournalEntryTypeEnum, financialDocument?: { __typename?: 'FinanceFinancialDocument', id: number, documentNumber?: string | null } | null, journalLines: Array<{ __typename?: 'FinanceJournalLine', id: number, creditAmountCents: number, debitAmountCents: number }>, legalEntity: { __typename?: 'CompaniesLegalEntity', id: number, currency: string } } }> } } };

export type LedgerAccountDetailDataTableQueryVariables = Exact<{
  ledgerAccountId: Scalars['Int'];
}>;


export type LedgerAccountDetailDataTableQuery = { __typename?: 'root_query', finance: { __typename?: 'finance', journalLinesConnection: { __typename?: 'FinanceJournalLineConnection', edges: Array<{ __typename?: 'FinanceJournalLineEdge', node: { __typename?: 'FinanceJournalLine', id: number, creditAmountCents: number, debitAmountCents: number, journalEntry: { __typename?: 'FinanceJournalEntry', id: number, description?: string | null, number: number, publishedAt: any, referenceDate: string } } }> } } };

export type ReconciliationJournalLinesDataTableQueryVariables = Exact<{
  allowedJournalEntryTypes?: InputMaybe<Array<FinanceValueObjectsJournalEntryTypeEnum> | FinanceValueObjectsJournalEntryTypeEnum>;
  balanceTypes?: InputMaybe<Array<FinanceValueObjectsLedgerAccountBalanceTypeEnum> | FinanceValueObjectsLedgerAccountBalanceTypeEnum>;
  bySuspenseAccount?: InputMaybe<Scalars['Boolean']>;
  currency?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  excludingJournalEntryTypes?: InputMaybe<Array<FinanceValueObjectsJournalEntryTypeEnum> | FinanceValueObjectsJournalEntryTypeEnum>;
  reconcilable?: InputMaybe<Scalars['Boolean']>;
}>;


export type ReconciliationJournalLinesDataTableQuery = { __typename?: 'root_query', finance: { __typename?: 'finance', journalLinesConnection: { __typename?: 'FinanceJournalLineConnection', edges: Array<{ __typename?: 'FinanceJournalLineEdge', node: { __typename?: 'FinanceJournalLine', id: number, creditAmountCents: number, debitAmountCents: number, fullyReconciledAt?: any | null, snoozedUntil?: any | null, journalEntry: { __typename?: 'FinanceJournalEntry', id: number, description?: string | null, number: number, publishedAt: any, referenceDate: string }, reconcilableReconciliations: Array<{ __typename?: 'FinanceReconciliation', id: number, journalLineReconciledAmountCents: number, reconcilableReconciledAmountCents?: number | null }>, reconciliations: Array<{ __typename?: 'FinanceReconciliation', id: number, journalLineReconciledAmountCents: number, reconcilableReconciledAmountCents?: number | null }> } }> } } };

export type ReconciliationBankJournalLinesDataTableQueryVariables = Exact<{
  bankAccountIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
}>;


export type ReconciliationBankJournalLinesDataTableQuery = { __typename?: 'root_query', finance: { __typename?: 'finance', journalLinesConnection: { __typename?: 'FinanceJournalLineConnection', edges: Array<{ __typename?: 'FinanceJournalLineEdge', node: { __typename?: 'FinanceJournalLine', id: number, creditAmountCents: number, debitAmountCents: number, fullyReconciledAt?: any | null, snoozedUntil?: any | null, journalEntry: { __typename?: 'FinanceJournalEntry', id: number, description?: string | null, number: number, publishedAt: any, referenceDate: string }, reconciliations: Array<{ __typename?: 'FinanceReconciliation', id: number, journalLineReconciledAmountCents: number }> } }> } } };

export type TaxTypeDatableQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type TaxTypeDatableQuery = { __typename?: 'root_query', finance: { __typename?: 'finance', taxTypesConnection: { __typename?: 'FinanceTaxTypeConnection', edges: Array<{ __typename?: 'FinanceTaxTypeEdge', node: { __typename?: 'FinanceTaxType', id: number, countryCode?: string | null, name: string, source: FinanceValueObjectsTaxSourceEnum, type: FinanceValueObjectsTaxTypeEnum } }> } } };

export type BudgetMovementsDatatableQueryVariables = Exact<{
  id: Scalars['Int'];
  periodEnd?: InputMaybe<Scalars['ISO8601DateTime']>;
  periodStart?: InputMaybe<Scalars['ISO8601DateTime']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type BudgetMovementsDatatableQuery = { __typename?: 'root_query', finance: { __typename?: 'finance', budgetMovementsConnection: { __typename?: 'FinanceBudgetMovementConnection', edges: Array<{ __typename?: 'FinanceBudgetMovementEdge', node: { __typename?: 'FinanceBudgetMovement', id: number, amountCents?: number | null, convertedAt?: any | null, effectiveAt: any, exchangeRate?: number | null, resourceId: number, sourceCurrency: string, targetCurrency: string, budget?: { __typename?: 'FinanceBudget', currency: string } | null, employee?: { __typename?: 'EmployeesEmployee', id: number, fullName: string, avatar?: { __typename?: 'ApiCoreAttachment', url: string } | null, legalEntity?: { __typename?: 'CompaniesLegalEntity', legalName: string } | null } | null, expensable?: { __typename?: 'ExpensesExpensable', id: number, amount?: any | null, currency: string, status: ExpensesEntitiesExpensableStatusEnum, expense?: { __typename?: 'ExpensesExpense', reimbursableAmount?: any | null, reimbursableCurrency?: string | null, category?: { __typename?: 'ExpensesExpenseCategory', name: string } | null } | null, mileage?: { __typename?: 'ExpensesMileage', category?: { __typename?: 'ExpensesExpenseCategory', name: string } | null } | null, perDiem?: { __typename?: 'ExpensesPerDiem', category?: { __typename?: 'ExpensesExpenseCategory', name: string } | null } | null } | null } }> } } };

export type BudgetEmployeesDatatableQueryVariables = Exact<{
  id: Scalars['Int'];
  periodEnd?: InputMaybe<Scalars['ISO8601DateTime']>;
  periodStart?: InputMaybe<Scalars['ISO8601DateTime']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type BudgetEmployeesDatatableQuery = { __typename?: 'root_query', finance: { __typename?: 'finance', budgetAllocationsConnection: { __typename?: 'FinanceBudgetAllocationConnection', edges: Array<{ __typename?: 'FinanceBudgetAllocationEdge', node: { __typename?: 'FinanceBudgetAllocation', id: number, amountCents?: number | null, availableAmountCents?: number | null, reportedAmountCents: number, status?: FinanceValueObjectsAllocationStatusEnum | null, employee?: { __typename?: 'EmployeesEmployee', id: number, fullName: string, avatar?: { __typename?: 'ApiCoreAttachment', id: number, url: string } | null } | null } }> } } };

export type FinanceDimensionValuesDataTableQueryVariables = Exact<{
  dimensionId: Scalars['Int'];
  tenant?: InputMaybe<FinanceTenantInput>;
}>;


export type FinanceDimensionValuesDataTableQuery = { __typename?: 'root_query', finance: { __typename?: 'finance', customDimensionValuesConnection: { __typename?: 'FinanceCustomDimensionValueConnection', edges: Array<{ __typename?: 'FinanceCustomDimensionValueEdge', node: { __typename?: 'FinanceCustomDimensionValue', id: number, code?: string | null, description?: string | null, name: string, legalEntity?: { __typename?: 'CompaniesLegalEntity', id: number, legalName: string } | null } }> } } };

export type PerformanceGoalsMetricGroupDataTableQueryVariables = Exact<{
  cycleIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  noCycle?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type PerformanceGoalsMetricGroupDataTableQuery = { __typename?: 'root_query', goals: { __typename?: 'goals', metricGroupsConnection: { __typename?: 'GoalsMetricGroupConnection', edges: Array<{ __typename?: 'GoalsMetricGroupEdge', node: { __typename?: 'GoalsMetricGroup', id: string, description?: string | null, public: boolean, title: string, _policies?: { __typename?: 'GoalsMetricGroupPolicies', update: { __typename?: 'PermissionsPolicyResolution', id: string, can: boolean } } | null, assigneesConnection: { __typename?: 'EmployeesEmployeeConnection', totalCount?: number | null, edges: Array<{ __typename?: 'EmployeesEmployeeEdge', node: { __typename?: 'EmployeesEmployee', id: number, fullName: string, access: { __typename?: 'ApiCoreAccess', id: number, avatar?: string | null } } }> }, performanceCycles: Array<{ __typename?: 'PerformanceCyclesCycle', id: string, companyId: number, endOn: string, startOn: string, title: string }>, summary?: { __typename?: 'GoalsMetricSummary', averageProgress: number, metricsCount: number, needsAttention: boolean } | null } }> } } };

export type PerformanceGoalsPeopleDataTableQueryVariables = Exact<{
  cycleIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  noCycle?: InputMaybe<Scalars['Boolean']>;
  onlyDirectReports?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type PerformanceGoalsPeopleDataTableQuery = { __typename?: 'root_query', goals: { __typename?: 'goals', employeesConnection: { __typename?: 'GoalsEmployeeConnection', totalCount?: number | null, edges: Array<{ __typename?: 'GoalsEmployeeEdge', node: { __typename?: 'GoalsEmployee', id: number, fullName: string, employee?: { __typename?: 'EmployeesEmployee', id: number, access: { __typename?: 'ApiCoreAccess', id: number, avatar?: string | null }, manager?: { __typename?: 'EmployeesEmployee', id: number, fullName: string } | null } | null, metricSummary?: { __typename?: 'GoalsMetricSummary', averageProgress: number, metricsCount: number, needsAttention: boolean } | null, progresses: Array<{ __typename?: 'GoalsEmployeeCycleProgress', id: string, needsAttention: boolean, progress: number }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean } } } };

export type InsightsHeadcountDataTableQueryVariables = Exact<{
  contractDate: Scalars['ISO8601Date'];
  employeeIds: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type InsightsHeadcountDataTableQuery = { __typename?: 'root_query', employees: { __typename?: 'employees', employeesConnection: { __typename?: 'EmployeesEmployeeConnection', edges: Array<{ __typename?: 'EmployeesEmployeeEdge', node: { __typename?: 'EmployeesEmployee', id: number, fullName: string, terminatedOn?: string | null, terminationReason?: string | null, terminationTypeDescription?: string | null, contractversionsConnection: { __typename?: 'ContractsContractVersionConnection', nodes: Array<{ __typename?: 'ContractsContractVersion', id?: number | null, endsOn?: string | null, startsOn?: string | null }> }, manager?: { __typename?: 'EmployeesEmployee', id: number, fullName: string } | null } }> } } };

export type TaskDataTableQueryVariables = Exact<{
  meetingIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type TaskDataTableQuery = { __typename?: 'root_query', oneOnOnes: { __typename?: 'oneOnOnes', tasksConnection: { __typename?: 'OneOnOnesTaskConnection', edges: Array<{ __typename?: 'OneOnOnesTaskEdge', node: { __typename?: 'OneOnOnesTask', id: number, dueOn?: string | null, name: string, taskId: number, assignees: Array<{ __typename?: 'EmployeesEmployee', id: number, firstName: string, fullName: string, access: { __typename?: 'ApiCoreAccess', id: number, avatar?: string | null } }>, meeting: { __typename?: 'OneOnOnesMeeting', id: number } } }> } } };

export type PerformanceInsightsSummaryDatatableQueryVariables = Exact<{
  pulseFrom: Scalars['ISO8601Date'];
  pulseTo: Scalars['ISO8601Date'];
}>;


export type PerformanceInsightsSummaryDatatableQuery = { __typename?: 'root_query', performance: { __typename?: 'performance', employeePerformanceInsightsSummariesConnection: { __typename?: 'PerformanceEmployeePerformanceInsightsSummaryConnection', totalCount?: number | null, edges: Array<{ __typename?: 'PerformanceEmployeePerformanceInsightsSummaryEdge', node: { __typename?: 'PerformanceEmployeePerformanceInsightsSummary', id: number, employeeFullName?: string | null, gridStatus?: string | null, managerFullName?: string | null, normalizedPotentialScore?: number | null, normalizedScore?: number | null, potentialScore?: number | null, pulseAnswer?: string | null, employeePulse?: { __typename?: 'EngagementEmployeePulseMedian', id: number, value: number } | null, insights?: { __typename?: 'PerformanceTargetInsight', id: string, engagementSignals?: Array<{ __typename?: 'PerformanceEngagmentSignal', category: PerformanceEngagementSignalsSignalCategoryEnum, name: string, tag: string, type: PerformanceEngagementSignalsSignalTypeEnum }> | null } | null, pulsesConnection: { __typename?: 'EngagementEmployeePulseConnection', edges: Array<{ __typename?: 'EngagementEmployeePulseEdge', node: { __typename?: 'EngagementEmployeePulse', id: number, comment?: string | null, submittedDate?: any | null, value: number } }> }, reviewEmployeeScore?: { __typename?: 'PerformanceReviewFinalEmployeeScore', id: number, normalizedScore: number, scaleMax: number, score: number } | null, reviewProcess?: { __typename?: 'PerformanceReviewProcess', id: number, endsAt?: any | null, name?: string | null, startsAt?: any | null } | null, targetAccess: { __typename?: 'ApiCoreAccess', id: number, avatar?: string | null, fullName: string, employee?: { __typename?: 'EmployeesEmployee', id: number, manager?: { __typename?: 'EmployeesEmployee', id: number, access: { __typename?: 'ApiCoreAccess', id: number, avatar?: string | null, fullName: string } } | null, memberships: Array<{ __typename?: 'TeamsMembership', id: number, team?: { __typename?: 'TeamsTeam', id: number, name: string } | null }> } | null } } }> } } };

export type PerformanceCyclesDataTableQueryVariables = Exact<{ [key: string]: never; }>;


export type PerformanceCyclesDataTableQuery = { __typename?: 'root_query', performanceCycles: { __typename?: 'performanceCycles', cyclesConnection: { __typename?: 'PerformanceCyclesCycleConnection', edges: Array<{ __typename?: 'PerformanceCyclesCycleEdge', node: { __typename?: 'PerformanceCyclesCycle', id: string, companyId: number, endOn: string, startOn: string, title: string } }> } } };

export type PerformanceProcessPendingReviewersDataTableQueryVariables = Exact<{
  ids: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type PerformanceProcessPendingReviewersDataTableQuery = { __typename?: 'root_query', apiCore: { __typename?: 'apiCore', accessesConnection: { __typename?: 'ApiCoreAccessConnection', edges: Array<{ __typename?: 'ApiCoreAccessEdge', node: { __typename?: 'ApiCoreAccess', id: number, firstName: string, employeeName?: { __typename?: 'EmployeesEmployeeName', id: number, access: { __typename?: 'ApiCoreAccess', id: number, avatar?: string | null, fullName: string }, managerName?: { __typename?: 'EmployeesEmployeeName', id: number, access: { __typename?: 'ApiCoreAccess', id: number, avatar?: string | null, fullName: string } } | null } | null } }> } } };

export type ProcessTargetDataTableQueryVariables = Exact<{
  agreementCompletionStatus?: InputMaybe<PerformanceDtosReviewProcessTargetAgreementCompletionStatusEnum>;
  employeeIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  evaluationsCompletionStatus?: InputMaybe<PerformanceReviewEvaluationStatusEnum>;
  finalScores?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  legalEntityIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  managedByFilter?: InputMaybe<ReviewProcessTargetsManagedByFilterInput>;
  performanceReviewProcessIds: Array<Scalars['Int']> | Scalars['Int'];
  searchValue?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  tenureDates?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  workplaceIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type ProcessTargetDataTableQuery = { __typename?: 'root_query', performance: { __typename?: 'performance', reviewProcessTargetsConnection: { __typename?: 'PerformanceReviewProcessTargetConnection', edges: Array<{ __typename?: 'PerformanceReviewProcessTargetEdge', node: { __typename?: 'PerformanceReviewProcessTarget', id: string, access?: { __typename?: 'ApiCoreAccess', id: number, employeeName?: { __typename?: 'EmployeesEmployeeName', id: number, fullName: string, avatar?: { __typename?: 'ApiCoreAttachment', id: number, url: string } | null, managerName?: { __typename?: 'EmployeesEmployeeName', id: number, fullName: string } | null } | null } | null, agreement?: { __typename?: 'PerformanceAgreement', id: string, status: PerformanceAgreementStatusEnum, agreementDocuments: Array<{ __typename?: 'PerformanceAgreementDocument', id: number, signatureStatus?: DocumentsSignatureStatusEnum | null }> } | null, evaluations: Array<{ __typename?: 'PerformanceReviewEvaluation', id: number, evaluationType: PerformanceReviewerStrategiesStrategyEnum, status: PerformanceReviewEvaluationStatusEnum, answeredQuestionnairesIdentifier?: { __typename?: 'PerformanceReviewEvaluationAnswersIdentifier', id: number } | null }>, insightScore?: { __typename?: 'PerformanceTargetInsightScore', id: string, alignmentScore?: PerformanceInsightsQuantityEnum | null } | null, reviewFinalEmployeeScore?: { __typename?: 'PerformanceReviewFinalEmployeeScore', id: number, scaleMax: number, scaleMin: number, score: number } | null } }> } } };

export type ProcessTargetForPeerAssignmentDataTableQueryVariables = Exact<{
  performanceReviewProcessIds: Array<Scalars['Int']> | Scalars['Int'];
  searchValue?: InputMaybe<Scalars['String']>;
}>;


export type ProcessTargetForPeerAssignmentDataTableQuery = { __typename?: 'root_query', performance: { __typename?: 'performance', reviewProcessTargetsConnection: { __typename?: 'PerformanceReviewProcessTargetConnection', edges: Array<{ __typename?: 'PerformanceReviewProcessTargetEdge', node: { __typename?: 'PerformanceReviewProcessTarget', id: string, access?: { __typename?: 'ApiCoreAccess', id: number, employeeName?: { __typename?: 'EmployeesEmployeeName', id: number, fullName: string, avatar?: { __typename?: 'ApiCoreAttachment', id: number, url: string } | null, managerName?: { __typename?: 'EmployeesEmployeeName', id: number, fullName: string } | null } | null } | null, evaluations: Array<{ __typename?: 'PerformanceReviewEvaluation', id: number, reviewerEmployeeName?: { __typename?: 'EmployeesEmployeeName', id: number, fullName: string, avatar?: { __typename?: 'ApiCoreAttachment', id: number, url: string } | null } | null }> } }> } } };

export type PastCoursesDatatableQueryVariables = Exact<{
  accessId: Scalars['Int'];
}>;


export type PastCoursesDatatableQuery = { __typename?: 'root_query', trainings: { __typename?: 'trainings', trainingsConnection: { __typename?: 'TrainingsTrainingConnection', edges: Array<{ __typename?: 'TrainingsTrainingEdge', node: { __typename?: 'TrainingsTraining', id: number, name: string, trainingAttendanceStatus: TrainingsTrainingMembershipStatusEnum, _policies?: { __typename?: 'TrainingsTrainingPolicies', read: { __typename?: 'PermissionsPolicyResolution', can: boolean } } | null, competencies: Array<{ __typename?: 'CompetenciesCompetency', name: string }>, sessions: Array<{ __typename?: 'TrainingsSession', id: number, sessionAttendances: Array<{ __typename?: 'TrainingsSessionAttendance', id: number, accessId: number, status: TrainingsSessionAttendanceStatusEnum }> }> } }> } } };

export type TargetGroupDataTableQueryVariables = Exact<{
  id: Scalars['Int'];
  searchValue?: InputMaybe<Scalars['String']>;
}>;


export type TargetGroupDataTableQuery = { __typename?: 'root_query', performance: { __typename?: 'performance', reviewProcessEstimatedTargetsConnection: { __typename?: 'PerformanceReviewProcessEstimatedTargetConnection', edges: Array<{ __typename?: 'PerformanceReviewProcessEstimatedTargetEdge', node: { __typename?: 'PerformanceReviewProcessEstimatedTarget', id: string, access?: { __typename?: 'ApiCoreAccess', id: number, employeeName?: { __typename?: 'EmployeesEmployeeName', id: number, fullName: string, avatar?: { __typename?: 'ApiCoreAttachment', id: number, url: string } | null } | null } | null } }> } } };

export type PerformanceReviewsDataTableQueryVariables = Exact<{
  ids: Array<Scalars['Int']> | Scalars['Int'];
  includeParticipation: Scalars['Boolean'];
  search?: InputMaybe<Scalars['String']>;
}>;


export type PerformanceReviewsDataTableQuery = { __typename?: 'root_query', performance: { __typename?: 'performance', reviewProcessesConnection: { __typename?: 'PerformanceReviewProcessConnection', totalCount?: number | null, edges: Array<{ __typename?: 'PerformanceReviewProcessEdge', node: { __typename: 'PerformanceReviewProcess', id: number, archived: boolean, endsAt?: any | null, name?: string | null, startsAt?: any | null, status: PerformanceReviewProcessStatusEnum, createdAt: any, _policies?: { __typename?: 'PerformanceReviewProcessPolicies', manage: { __typename?: 'PermissionsPolicyResolution', id: string, can: boolean } } | null, participation?: { __typename?: 'PerformanceReviewProcessParticipationRate', id: number, evaluationsCount: number, publishedEvaluationsCount: number } | null, performanceCycle?: { __typename?: 'PerformanceCyclesCycle', id: string, endOn: string, startOn: string, title: string } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean } } } };

export type TemplateTargetGroupDataTableQueryVariables = Exact<{
  customTemplateId: Scalars['Int'];
  searchValue?: InputMaybe<Scalars['String']>;
}>;


export type TemplateTargetGroupDataTableQuery = { __typename?: 'root_query', performance: { __typename?: 'performance', reviewProcessCustomTemplatesEstimatedTargetsConnection: { __typename?: 'PerformanceReviewProcessCustomTemplatesEstimatedTargetConnection', edges: Array<{ __typename?: 'PerformanceReviewProcessCustomTemplatesEstimatedTargetEdge', node: { __typename?: 'PerformanceReviewProcessCustomTemplatesEstimatedTarget', id: string, access?: { __typename?: 'ApiCoreAccess', id: number, avatar?: string | null, fullName: string, employee?: { __typename?: 'EmployeesEmployee', id: number, access: { __typename?: 'ApiCoreAccess', id: number, avatar?: string | null, fullName: string } } | null } | null } }> } } };

export type CustomTemplatesDataTableQueryVariables = Exact<{
  ids: Array<Scalars['Int']> | Scalars['Int'];
  search?: InputMaybe<Scalars['String']>;
}>;


export type CustomTemplatesDataTableQuery = { __typename?: 'root_query', performance: { __typename?: 'performance', reviewProcessCustomTemplatesConnection: { __typename?: 'PerformanceReviewProcessCustomTemplateConnection', edges: Array<{ __typename?: 'PerformanceReviewProcessCustomTemplateEdge', node: { __typename?: 'PerformanceReviewProcessCustomTemplate', id: number, name: string, reviewerStrategies?: Array<PerformanceReviewerStrategiesStrategyEnum> | null, createdAt: any, _policies?: { __typename?: 'PerformanceReviewProcessCustomTemplatePolicies', manage: { __typename?: 'PermissionsPolicyResolution', id: string, can: boolean } } | null, author?: { __typename?: 'ApiCoreAccess', id: number, avatar?: string | null, firstName: string, lastName: string } | null } }> } } };

export type PredefinedTemplatesDataTableQueryVariables = Exact<{
  ids: Array<Scalars['Int']> | Scalars['Int'];
  search?: InputMaybe<Scalars['String']>;
}>;


export type PredefinedTemplatesDataTableQuery = { __typename?: 'root_query', performance: { __typename?: 'performance', reviewProcessTemplatesConnection: { __typename?: 'PerformanceReviewProcessTemplateConnection', edges: Array<{ __typename?: 'PerformanceReviewProcessTemplateEdge', node: { __typename?: 'PerformanceReviewProcessTemplate', id: number, name: string, reviewerStrategies?: Array<PerformanceReviewerStrategiesStrategyEnum> | null } }> } } };

export type TargetProcessesDataTableQueryVariables = Exact<{
  accessIds: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type TargetProcessesDataTableQuery = { __typename?: 'root_query', performance: { __typename?: 'performance', reviewProcessTargetsConnection: { __typename?: 'PerformanceReviewProcessTargetConnection', edges: Array<{ __typename?: 'PerformanceReviewProcessTargetEdge', node: { __typename?: 'PerformanceReviewProcessTarget', id: string, evaluations: Array<{ __typename?: 'PerformanceReviewEvaluation', id: number, reviewerAccess?: { __typename?: 'ApiCoreAccess', id: number, employeeName?: { __typename?: 'EmployeesEmployeeName', id: number, fullName: string, avatar?: { __typename?: 'ApiCoreAttachment', id: number, url: string } | null } | null } | null }>, insightScore?: { __typename?: 'PerformanceTargetInsightScore', id: string, alignmentScore?: PerformanceInsightsQuantityEnum | null } | null, performanceReviewProcess?: { __typename?: 'PerformanceReviewProcess', id: number, endsAt?: any | null, name?: string | null, status: PerformanceReviewProcessStatusEnum } | null, reviewFinalEmployeeScore?: { __typename?: 'PerformanceReviewFinalEmployeeScore', id: number, scaleMax: number, score: number } | null } }> } } };

export type MandatoryProcessTasksQueryVariables = Exact<{
  category: ProcessesProcessCategoryEnum;
  mandatory?: InputMaybe<Scalars['Boolean']>;
  processId: Scalars['Int'];
  search?: InputMaybe<Scalars['String']>;
}>;


export type MandatoryProcessTasksQuery = { __typename?: 'root_query', tasks: { __typename?: 'tasks', materializedProcessTasksConnection: { __typename?: 'TasksMaterializedProcessTaskConnection', edges: Array<{ __typename?: 'TasksMaterializedProcessTaskEdge', node: { __typename?: 'TasksMaterializedProcessTask', id: number, completedAt?: any | null, contractEndDate?: string | null, contractReferenceDate?: string | null, contractStartDate?: string | null, dueOn?: string | null, materializedItemId?: number | null, materializedProcessId?: number | null, name: string, stepName?: string | null, affecteesConnection: { __typename?: 'TasksUnsafeAccessConnection', totalCount?: number | null, nodes: Array<{ __typename?: 'TasksUnsafeAccess', id: number, avatar?: string | null, fullName: string }> }, assigneesConnection: { __typename?: 'TasksUnsafeAccessConnection', totalCount?: number | null, nodes: Array<{ __typename?: 'TasksUnsafeAccess', id: number, avatar?: string | null, fullName: string }> } } }> } } };

export type MaterializedProcessesDataTableQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  includeItemsCount?: InputMaybe<Scalars['Boolean']>;
  materializedTasksAccessId?: InputMaybe<Scalars['Int']>;
  processId?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type MaterializedProcessesDataTableQuery = { __typename?: 'root_query', processes: { __typename?: 'processes', materializedProcessesConnection: { __typename?: 'ProcessesMaterializedProcessConnection', edges: Array<{ __typename?: 'ProcessesMaterializedProcessEdge', node: { __typename?: 'ProcessesMaterializedProcess', id: number, completedResources?: number | null, contractEndsOn?: string | null, contractStartsOn?: string | null, finalizedAt?: any | null, name: string, nextItemDueDate?: string | null, status: string, totalResources?: number | null, trainingName?: string | null, process: { __typename?: 'ProcessesProcess', id: number }, resourceRelationships: Array<{ __typename?: 'ProcessesResourceRelationship', id: number, resourceId: number, access?: { __typename?: 'ApiCoreAccess', id: number, avatar?: string | null, fullName: string, employee?: { __typename?: 'EmployeesEmployee', id: number, referenceContract?: { __typename?: 'ContractsReferenceContract', id?: number | null, trialPeriodEndsOn?: string | null } | null } | null } | null }> } }> } } };

export type ProcurementPurchaseOrdersInvoicesDatatableQueryVariables = Exact<{
  companyId: Scalars['Int'];
  ids?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type ProcurementPurchaseOrdersInvoicesDatatableQuery = { __typename?: 'root_query', finance: { __typename?: 'finance', financialDocumentAssociationsConnection: { __typename?: 'FinanceFinancialDocumentAssociationConnection', edges: Array<{ __typename?: 'FinanceFinancialDocumentAssociationEdge', node: { __typename?: 'FinanceFinancialDocumentAssociation', id: number, financialDocument?: { __typename?: 'FinanceFinancialDocument', id: number, currency?: string | null, documentDate?: string | null, documentNumber?: string | null, totalAmountCents?: any | null } | null } }> } } };

export type ProcurementPurchaseOrdersDatatableQueryVariables = Exact<{
  companyId: Scalars['Int'];
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ProcurementValueObjectsPurchaseOrderStatusEnum>;
  vendorId?: InputMaybe<Scalars['Int']>;
}>;


export type ProcurementPurchaseOrdersDatatableQuery = { __typename?: 'root_query', procurement: { __typename?: 'procurement', purchaseOrdersConnection: { __typename?: 'ProcurementPurchaseOrderConnection', edges: Array<{ __typename?: 'ProcurementPurchaseOrderEdge', node: { __typename?: 'ProcurementPurchaseOrder', id: number, date: string, description: string, formattedPoNumber: string, poNumber: number, status: ProcurementValueObjectsPurchaseOrderStatusEnum, cost: { __typename?: 'BigMoney', cents: any, currency: string }, legalEntity: { __typename?: 'CompaniesLegalEntity', id: number, legalName: string }, purchaseRequest?: { __typename?: 'ProcurementPurchaseRequest', id: number, requesterEmployee?: { __typename?: 'EmployeesEmployee', id: number, fullName: string, avatar?: { __typename?: 'ApiCoreAttachment', id: number, url: string } | null } | null, type?: { __typename?: 'ProcurementType', id: number, name: string } | null } | null, vendor?: { __typename?: 'FinanceContact', id: number, legalName?: string | null, name: string } | null } }> } } };

export type ProcurementMyPurchaseRequestsDatatableQueryVariables = Exact<{
  companyId: Scalars['Int'];
  requesterEmployeeIds: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type ProcurementMyPurchaseRequestsDatatableQuery = { __typename?: 'root_query', procurement: { __typename?: 'procurement', purchaseRequestsConnection: { __typename?: 'ProcurementPurchaseRequestConnection', edges: Array<{ __typename?: 'ProcurementPurchaseRequestEdge', node: { __typename?: 'ProcurementPurchaseRequest', id: number, date: string, deadline?: string | null, description: string, status: ProcurementValueObjectsPurchaseRequestStatusEnum, cost: { __typename?: 'BigMoney', cents: any, currency: string }, vendor?: { __typename?: 'FinanceContact', id: number, legalName?: string | null, name: string } | null } }> } } };

export type ProcurementPurchaseRequestsDatatableQueryVariables = Exact<{
  companyId: Scalars['Int'];
  onlyMyPendingApprovals?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type ProcurementPurchaseRequestsDatatableQuery = { __typename?: 'root_query', procurement: { __typename?: 'procurement', purchaseRequestsConnection: { __typename?: 'ProcurementPurchaseRequestConnection', edges: Array<{ __typename?: 'ProcurementPurchaseRequestEdge', node: { __typename?: 'ProcurementPurchaseRequest', id: number, date: string, deadline?: string | null, description: string, status: ProcurementValueObjectsPurchaseRequestStatusEnum, cost: { __typename?: 'BigMoney', cents: any, currency: string }, requesterEmployee?: { __typename?: 'EmployeesEmployee', id: number, fullName: string, avatar?: { __typename?: 'ApiCoreAttachment', id: number, url: string } | null } | null, vendor?: { __typename?: 'FinanceContact', id: number, legalName?: string | null, name: string } | null } }> } } };

export type ProjectTasksDataTableQueryVariables = Exact<{
  projectIds: Array<Scalars['Int']> | Scalars['Int'];
  search?: InputMaybe<Scalars['String']>;
}>;


export type ProjectTasksDataTableQuery = { __typename?: 'root_query', projectManagement: { __typename?: 'projectManagement', projectTasksConnection: { __typename?: 'ProjectManagementProjectTaskConnection', edges: Array<{ __typename?: 'ProjectManagementProjectTaskEdge', node: { __typename?: 'ProjectManagementProjectTask', id: number, followUp: boolean, subproject?: { __typename?: 'ProjectManagementSubproject', id?: number | null, name: string } | null, task?: { __typename?: 'TasksTask', id: number, completedAt?: any | null, dueOn?: string | null, identifier: TasksValueObjectsTaskIdentifierEnum, name: string, relatedResourceTitle?: string | null, startsOn?: string | null, status?: TasksValueObjectsTaskStatusEnum | null, createdAt: any, assigneesConnection: { __typename?: 'TasksUnsafeAccessConnection', totalCount?: number | null, edges: Array<{ __typename?: 'TasksUnsafeAccessEdge', node: { __typename?: 'TasksUnsafeAccess', id: number, avatar?: string | null, fullName: string } }> } } | null } }> } } };

export type GetExpensesDatatableExportQueryVariables = Exact<{
  endDate: Scalars['ISO8601Date'];
  projectIds: Array<Scalars['Int']> | Scalars['Int'];
  startDate: Scalars['ISO8601Date'];
}>;


export type GetExpensesDatatableExportQuery = { __typename?: 'root_query', projectManagement: { __typename?: 'projectManagement', exportableExpensesConnection: { __typename?: 'ProjectManagementExportableExpenseConnection', edges: Array<{ __typename?: 'ProjectManagementExportableExpenseEdge', node: { __typename?: 'ProjectManagementExportableExpense', amount?: string | null, currency?: string | null, date?: string | null, employeeName: string, expenseCategory?: string | null, expenseLink?: string | null, expenseStatus?: string | null, expenseSubcategory?: string | null, preferredName?: string | null, projectCode?: string | null, projectName?: string | null, projectOwners?: string | null, subprojectName?: string | null } }> } } };

export type GetProjectsDatatableExportQueryVariables = Exact<{
  companyId: Scalars['Int'];
  dateGroup: ProjectManagementEnumsExportableProjectDateGroupEnum;
  endDate: Scalars['ISO8601Date'];
  includeClient?: InputMaybe<Scalars['Boolean']>;
  includeDate?: InputMaybe<Scalars['Boolean']>;
  includeEmployeesWithoutTimeTracked?: InputMaybe<Scalars['Boolean']>;
  includeSubprojects?: InputMaybe<Scalars['Boolean']>;
  projectIds: Array<Scalars['Int']> | Scalars['Int'];
  startDate: Scalars['ISO8601Date'];
  timeFormat?: InputMaybe<Scalars['String']>;
}>;


export type GetProjectsDatatableExportQuery = { __typename?: 'root_query', projectManagement: { __typename?: 'projectManagement', exportableProjectsConnection: { __typename?: 'ProjectManagementExportableProjectConnection', edges: Array<{ __typename?: 'ProjectManagementExportableProjectEdge', node: { __typename?: 'ProjectManagementExportableProject', id: string, cost?: number | null, date?: string | null, employeeName?: string | null, inputedTime: string, projectCode?: string | null, projectDescription?: string | null, projectDueDate?: string | null, projectName: string, projectOwners?: string | null, projectStartDate?: string | null, projectStatus: string, subprojectName?: string | null, client?: { __typename?: 'FinanceContact', id: number, legalName?: string | null, name: string } | null, employee?: { __typename?: 'EmployeesEmployee', id: number, companyIdentifier?: string | null } | null } }> } } };

export type GetShiftsDatatableExportQueryVariables = Exact<{
  employeeIds: Array<Scalars['Int']> | Scalars['Int'];
  endDate: Scalars['ISO8601Date'];
  includeSubprojects?: InputMaybe<Scalars['Boolean']>;
  sortByEmployee?: InputMaybe<Scalars['Boolean']>;
  startDate: Scalars['ISO8601Date'];
  timeFormat?: InputMaybe<Scalars['String']>;
}>;


export type GetShiftsDatatableExportQuery = { __typename?: 'root_query', projectManagement: { __typename?: 'projectManagement', exportableShiftsConnection: { __typename?: 'ProjectManagementExportableShiftConnection', edges: Array<{ __typename?: 'ProjectManagementExportableShiftEdge', node: { __typename?: 'ProjectManagementExportableShift', id: string, clockIn?: string | null, clockOut?: string | null, comments?: string | null, date?: string | null, duration: string, employeeName: string, projectCode?: string | null, projectName?: string | null, projectOwners?: string | null, projectStatus?: string | null, subprojectName?: string | null, employee?: { __typename?: 'EmployeesEmployee', id: number, companyIdentifier?: string | null } | null } }> } } };

export type GetTasksDatatableExportQueryVariables = Exact<{
  endDate: Scalars['ISO8601Date'];
  projectIds: Array<Scalars['Int']> | Scalars['Int'];
  startDate: Scalars['ISO8601Date'];
}>;


export type GetTasksDatatableExportQuery = { __typename?: 'root_query', projectManagement: { __typename?: 'projectManagement', exportableTasksConnection: { __typename?: 'ProjectManagementExportableTaskConnection', edges: Array<{ __typename?: 'ProjectManagementExportableTaskEdge', node: { __typename?: 'ProjectManagementExportableTask', assignees?: string | null, daysBetweenInProgressAndDone?: number | null, daysUntilDeadline?: number | null, employeesCompanyIdentifiers?: string | null, projectCode?: string | null, projectDescription?: string | null, projectName?: string | null, subprojectName?: string | null, taskDueOnDate?: string | null, taskName?: string | null, taskStartsOnDate?: string | null, taskStatus: string } }> } } };

export type EmployeesMembershipDataTableQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  softwareSetupIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type EmployeesMembershipDataTableQuery = { __typename?: 'root_query', softwareManagement: { __typename?: 'softwareManagement', employeeSoftwareMembershipsConnection: { __typename?: 'SoftwareManagementEmployeeSoftwareMembershipConnection', edges: Array<{ __typename?: 'SoftwareManagementEmployeeSoftwareMembershipEdge', node: { __typename?: 'SoftwareManagementEmployeeSoftwareMembership', id: number, employee: { __typename?: 'EmployeesEmployee', id: number, email?: string | null, fullName: string, isTerminating: boolean, access: { __typename?: 'ApiCoreAccess', id: number, avatar?: string | null, fullName: string }, locations: Array<{ __typename?: 'LocationsEmployeesLocation', location?: { __typename?: 'LocationsLocation', id: number, name: string } | null }>, memberships: Array<{ __typename?: 'TeamsMembership', id: number, team?: { __typename?: 'TeamsTeam', id: number, name: string } | null }>, referenceContract?: { __typename?: 'ContractsReferenceContract', id?: number | null, jobTitle?: string | null, startsOn?: string | null } | null } } }> } } };

export type SoftwarePaymentsDataTableQueryVariables = Exact<{
  companyId: Scalars['Int'];
  softwareSetupId: Scalars['Int'];
}>;


export type SoftwarePaymentsDataTableQuery = { __typename?: 'root_query', softwareManagement: { __typename?: 'softwareManagement', softwarePaymentsConnection: { __typename?: 'SoftwareManagementSoftwarePaymentConnection', edges: Array<{ __typename?: 'SoftwareManagementSoftwarePaymentEdge', node: { __typename?: 'SoftwareManagementSoftwarePayment', id: number, amountCents: number, currency: string, executedAt: any, cardPayment?: { __typename?: 'BankingCardPayment', id: number, merchantName: string, status: BankingEntitiesCardPaymentStatusEnum } | null, financialDocument?: { __typename?: 'FinanceFinancialDocument', id: number, status: FinanceValueObjectsInvoiceStatusEnum } | null, softwareSetup: { __typename?: 'SoftwareManagementSoftwareSetup', id: number, customSoftware?: { __typename?: 'SoftwareManagementCustomSoftware', id: string, logoUrl?: string | null, name: string } | null, software?: { __typename?: 'SoftwareManagementSoftware', id: string, logoUrl: string, name: string } | null } } }> } } };

export type EmployeeListForSoftwareDataTableQueryVariables = Exact<{
  onlyTerminated?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  softwareSetupIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  withSoftware?: InputMaybe<Scalars['Boolean']>;
}>;


export type EmployeeListForSoftwareDataTableQuery = { __typename?: 'root_query', softwareManagement: { __typename?: 'softwareManagement', employeesConnection: { __typename?: 'SoftwareManagementEmployeeConnection', edges: Array<{ __typename?: 'SoftwareManagementEmployeeEdge', node: { __typename?: 'SoftwareManagementEmployee', id: number, firstName: string, isTerminating: boolean, lastName: string, preferredName?: string | null, access: { __typename?: 'ApiCoreAccess', avatar?: string | null, fullName: string }, employeeSoftwareMemberships: Array<{ __typename?: 'SoftwareManagementEmployeeSoftwareMembership', customSoftware?: { __typename?: 'SoftwareManagementCustomSoftware', logoUrl?: string | null, name: string } | null, software?: { __typename?: 'SoftwareManagementSoftware', logoUrl: string, name: string } | null }>, locations: Array<{ __typename?: 'LocationsLocation', id: number, name: string }>, memberships: Array<{ __typename?: 'TeamsMembership', id: number, team?: { __typename?: 'TeamsTeam', name: string } | null }>, referenceContract?: { __typename?: 'ContractsReferenceContract', id?: number | null, jobTitle?: string | null, startsOn?: string | null } | null } }> } } };

export type GetBookingsDataTableQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBookingsDataTableQuery = { __typename?: 'root_query', spaceControl: { __typename?: 'spaceControl', bookingsConnection: { __typename?: 'SpaceControlBookingConnection', edges: Array<{ __typename?: 'SpaceControlBookingEdge', node: { __typename?: 'SpaceControlBooking', id?: number | null, capacity: number, date: string, endsAt: string, startsAt: string, status: SpaceControlBookingBookingStatusEnum, access?: { __typename?: 'ApiCoreAccess', id: number, avatar?: string | null, fullName: string, employee?: { __typename?: 'EmployeesEmployee', id: number } | null } | null, workSpace?: { __typename?: 'SpaceControlWorkSpace', id?: number | null, name?: string | null, workSpaceTypeName?: string | null, workSpaceTypeValue?: string | null, workArea?: { __typename?: 'LocationsWorkArea', id: number, name: string, location?: { __typename?: 'LocationsLocation', id: number, name: string } | null } | null } | null } }> } } };

export type GetTasksDataTableQueryVariables = Exact<{
  assigneeId?: InputMaybe<Scalars['Int']>;
  authorId?: InputMaybe<Scalars['Int']>;
  identifier?: InputMaybe<TasksValueObjectsTaskIdentifierEnum>;
  ids?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  involveeId?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<TasksTaskStatusEnum>;
  taskStatus?: InputMaybe<TasksValueObjectsTaskStatusEnum>;
}>;


export type GetTasksDataTableQuery = { __typename?: 'root_query', tasks: { __typename?: 'tasks', tasksConnection: { __typename?: 'TasksTaskConnection', edges: Array<{ __typename?: 'TasksTaskEdge', node: { __typename?: 'TasksTask', id: number, completedAt?: any | null, dueOn?: string | null, identifier: TasksValueObjectsTaskIdentifierEnum, name: string, relatedResourceTitle?: string | null, startsOn?: string | null, status?: TasksValueObjectsTaskStatusEnum | null, createdAt: any, _policies?: { __typename?: 'TasksTaskPolicies', copy: { __typename?: 'PermissionsPolicyResolution', id: string, can: boolean }, destroy: { __typename?: 'PermissionsPolicyResolution', id: string, can: boolean }, edit: { __typename?: 'PermissionsPolicyResolution', id: string, can: boolean }, resolve: { __typename?: 'PermissionsPolicyResolution', id: string, can: boolean } } | null, affectees: Array<{ __typename?: 'TasksUnsafeAccess', id: number, avatar?: string | null, fullName: string }>, assigneesConnection: { __typename?: 'TasksUnsafeAccessConnection', totalCount?: number | null, edges: Array<{ __typename?: 'TasksUnsafeAccessEdge', node: { __typename?: 'TasksUnsafeAccess', id: number, avatar?: string | null, fullName: string } }> }, author?: { __typename?: 'TasksUnsafeAccess', id: number, avatar?: string | null, fullName: string } | null } }> } } };

export type TrainingsCategoriesDataTableQueryVariables = Exact<{ [key: string]: never; }>;


export type TrainingsCategoriesDataTableQuery = { __typename?: 'root_query', trainings: { __typename?: 'trainings', categoriesConnection: { __typename?: 'TrainingsCategoryConnection', edges: Array<{ __typename?: 'TrainingsCategoryEdge', node: { __typename?: 'TrainingsCategory', id: number, name: string } }> } } };

export type MyTrainingsDatatableQueryVariables = Exact<{
  accessId: Scalars['Int'];
  next?: InputMaybe<Scalars['Boolean']>;
  onlyAssigned?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
}>;


export type MyTrainingsDatatableQuery = { __typename?: 'root_query', trainings: { __typename?: 'trainings', trainingsConnection: { __typename?: 'TrainingsTrainingConnection', edges: Array<{ __typename?: 'TrainingsTrainingEdge', node: { __typename?: 'TrainingsTraining', id: number, name: string, trainingAttendanceStatus: TrainingsTrainingMembershipStatusEnum, sessions: Array<{ __typename?: 'TrainingsSession', id: number, dueDate?: string | null, duration?: string | null, endsAt?: any | null, link?: string | null, location?: string | null, modality?: TrainingsSessionModalityEnum | null, name: string, schedule?: TrainingsSessionScheduleEnum | null, startsAt?: any | null, sessionAttendances: Array<{ __typename?: 'TrainingsSessionAttendance', id: number, accessId: number, status: TrainingsSessionAttendanceStatusEnum }> }> } }> } } };

export type MyTrainingRequestsDatatableQueryVariables = Exact<{
  authorId?: InputMaybe<Scalars['Int']>;
  companyId: Scalars['Int'];
  employeeIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  employeesOrAuthor?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<TrainingsTrainingRequestStatusEnum>;
}>;


export type MyTrainingRequestsDatatableQuery = { __typename?: 'root_query', trainings: { __typename?: 'trainings', _policies: { __typename?: 'TrainingsContextlessPolicies', trainingsRequestsCreate: { __typename?: 'ContextlessPolicyResolution', can: boolean } }, settingsConnection: { __typename?: 'TrainingsSettingConnection', nodes: Array<{ __typename?: 'TrainingsSetting', id: number, trainingRequestsEnabled?: boolean | null }> }, trainingRequestsConnection: { __typename?: 'TrainingsTrainingRequestConnection', edges: Array<{ __typename?: 'TrainingsTrainingRequestEdge', node: { __typename?: 'TrainingsTrainingRequest', id: number, currentApproverIds: Array<number>, employeeIds: Array<number>, status: TrainingsTrainingRequestStatusEnum, trainingName?: string | null, createdAt?: any | null, author?: { __typename?: 'ApiCoreAccess', id: number, avatar?: string | null, fullName: string } | null, competencies: Array<{ __typename?: 'CompetenciesCompetency', id: number, name: string }> } }> }, trainingsConnection: { __typename?: 'TrainingsTrainingConnection', edges: Array<{ __typename?: 'TrainingsTrainingEdge', node: { __typename?: 'TrainingsTraining', id: number } }> } } };

export type TrainingRequestsDatatableQueryVariables = Exact<{
  authorId?: InputMaybe<Scalars['Int']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  employeesOrAuthor?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type TrainingRequestsDatatableQuery = { __typename?: 'root_query', trainings: { __typename?: 'trainings', trainingRequestsConnection: { __typename?: 'TrainingsTrainingRequestConnection', totalCount?: number | null, edges: Array<{ __typename?: 'TrainingsTrainingRequestEdge', node: { __typename?: 'TrainingsTrainingRequest', id: number, cost?: string | null, currentApproverIds: Array<number>, employeeIds: Array<number>, status: TrainingsTrainingRequestStatusEnum, trainingName?: string | null, createdAt?: any | null, author?: { __typename?: 'ApiCoreAccess', id: number, avatar?: string | null, fullName: string } | null, competencies: Array<{ __typename?: 'CompetenciesCompetency', id: number, name: string }>, participants: Array<{ __typename?: 'EmployeesEmployee', id: number, accessId: number, fullName: string, avatar?: { __typename?: 'ApiCoreAttachment', url: string } | null }> } }> } } };

export type TrainingFormsDatatableQueryVariables = Exact<{
  resourceId?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type TrainingFormsDatatableQuery = { __typename?: 'root_query', forms: { __typename?: 'forms', formsConnection: { __typename?: 'FormsFormConnection', totalCount?: number | null, edges: Array<{ __typename?: 'FormsFormEdge', node: { __typename?: 'FormsForm', id: string, anonymous: boolean, authorId?: string | null, description?: string | null, formType: FormsTypeEnum, resourceId?: string | null, status: FormsFormStatusEnum, title: string } }> } } };

export type FundaeFinishGroupDatatableQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  trainingClassId: Scalars['Int'];
}>;


export type FundaeFinishGroupDatatableQuery = { __typename?: 'root_query', contracts: { __typename?: 'contracts', spanishEducationLevelsConnection: { __typename?: 'ContractsSpanishEducationLevelConnection', nodes: Array<{ __typename?: 'ContractsSpanishEducationLevel', id: number, name: string }> }, spanishProfessionalCategoriesConnection: { __typename?: 'ContractsSpanishProfessionalCategoryConnection', nodes: Array<{ __typename?: 'ContractsSpanishProfessionalCategory', id: number, name: string }> } }, trainings: { __typename?: 'trainings', categoryMapConfigsConnection: { __typename?: 'TrainingsCategoryMapConfigConnection', nodes: Array<{ __typename?: 'TrainingsCategoryMapConfig', category: TrainingsCategoryMapConfigCategoryEnum, categoryMapConfigItemsConnection: { __typename?: 'TrainingsCategoryMapConfigItemConnection', nodes: Array<{ __typename?: 'TrainingsCategoryMapConfigItem', value: string, field: { __typename?: 'TrainingsField', fieldId: number } }> } }> }, fundaeFinishGroupsConnection: { __typename?: 'TrainingsFundaeFinishGroupConnection', edges: Array<{ __typename?: 'TrainingsFundaeFinishGroupEdge', node: { __typename?: 'TrainingsFundaeFinishGroup', id: number, certificate: boolean, access?: { __typename?: 'ApiCoreAccess', id: number, avatar?: string | null, fullName: string, employee?: { __typename?: 'EmployeesEmployee', id: number, email?: string | null, identifier?: string | null, identifierType?: string | null, phoneNumber?: string | null, _policies?: { __typename?: 'EmployeesEmployeePolicies', editPersonalInfo: { __typename?: 'PermissionsPolicyResolution', can: boolean }, readPersonalInfo: { __typename?: 'PermissionsPolicyResolution', can: boolean } } | null, referenceContract?: { __typename?: 'ContractsReferenceContract', id?: number | null, esEducationLevelId?: number | null, esEducationLevelName?: string | null, esProfessionalCategoryId?: number | null, esProfessionalCategoryName?: string | null, _policies?: { __typename?: 'ContractsReferenceContractPolicies', edit: { __typename?: 'PermissionsPolicyResolution', can: boolean }, seeExtraInfo: { __typename?: 'PermissionsPolicyResolution', can: boolean } } | null } | null } | null } | null } }> } } };

export type MySessionsDataTableQueryVariables = Exact<{
  accessId?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  trainingId?: InputMaybe<Scalars['Int']>;
}>;


export type MySessionsDataTableQuery = { __typename?: 'root_query', trainings: { __typename?: 'trainings', sessionsConnection: { __typename?: 'TrainingsSessionConnection', edges: Array<{ __typename?: 'TrainingsSessionEdge', node: { __typename?: 'TrainingsSession', id: number, dueDate?: string | null, duration?: string | null, endsAt?: any | null, link?: string | null, location?: string | null, modality?: TrainingsSessionModalityEnum | null, name: string, schedule?: TrainingsSessionScheduleEnum | null, startsAt?: any | null, sessionAttendances: Array<{ __typename?: 'TrainingsSessionAttendance', id: number, accessId: number, status: TrainingsSessionAttendanceStatusEnum, _policies?: { __typename?: 'TrainingsSessionAttendancePolicies', edit: { __typename?: 'PermissionsPolicyResolution', id: string, can: boolean } } | null }> } }> } } };

export type RemindersDataTableQueryVariables = Exact<{
  sessionId: Scalars['Int'];
}>;


export type RemindersDataTableQuery = { __typename?: 'root_query', trainings: { __typename?: 'trainings', remindersConnection: { __typename?: 'TrainingsReminderConnection', edges: Array<{ __typename?: 'TrainingsReminderEdge', node: { __typename?: 'TrainingsReminder', id: number, completed: boolean, content?: string | null, name?: string | null, scheduledAt: any } }> } } };

export type SessionAccessMembershipsDataTableQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  sessionId: Scalars['Int'];
}>;


export type SessionAccessMembershipsDataTableQuery = { __typename?: 'root_query', trainings: { __typename?: 'trainings', sessionAccessMembershipsConnection: { __typename?: 'TrainingsSessionAccessMembershipConnection', edges: Array<{ __typename?: 'TrainingsSessionAccessMembershipEdge', node: { __typename?: 'TrainingsSessionAccessMembership', id: number, firstName?: string | null, jobTitle?: string | null, lastName?: string | null, access?: { __typename?: 'ApiCoreAccess', id: number, avatar?: string | null, fullName: string } | null, sessionAttendance?: { __typename?: 'TrainingsSessionAttendance', id: number, status: TrainingsSessionAttendanceStatusEnum } | null } }> } } };

export type SessionsDataTableQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  trainingIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type SessionsDataTableQuery = { __typename?: 'root_query', trainings: { __typename?: 'trainings', sessionsConnection: { __typename?: 'TrainingsSessionConnection', edges: Array<{ __typename?: 'TrainingsSessionEdge', node: { __typename?: 'TrainingsSession', id: number, duration?: string | null, endsAt?: any | null, link?: string | null, modality?: TrainingsSessionModalityEnum | null, name: string, startsAt?: any | null, status?: string | null } }> } } };

export type TrainingClassMembershipsDatatableQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  trainingClassId: Scalars['Int'];
}>;


export type TrainingClassMembershipsDatatableQuery = { __typename?: 'root_query', trainings: { __typename?: 'trainings', trainingClassMembershipsConnection: { __typename?: 'TrainingsTrainingClassMembershipConnection', edges: Array<{ __typename?: 'TrainingsTrainingClassMembershipEdge', node: { __typename?: 'TrainingsTrainingClassMembership', id: number, trainingClassId: string, access?: { __typename?: 'ApiCoreAccess', id: number, avatar?: string | null, fullName: string, employee?: { __typename?: 'EmployeesEmployee', id: number, preferredName?: string | null, referenceContract?: { __typename?: 'ContractsReferenceContract', id?: number | null, jobTitle?: string | null } | null } | null } | null } }> } } };

export type TrainingSessionsByEmployeeDataTableQueryVariables = Exact<{
  accessId: Scalars['Int'];
  search?: InputMaybe<Scalars['String']>;
  trainingClassIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type TrainingSessionsByEmployeeDataTableQuery = { __typename?: 'root_query', trainings: { __typename?: 'trainings', sessionsConnection: { __typename?: 'TrainingsSessionConnection', edges: Array<{ __typename?: 'TrainingsSessionEdge', node: { __typename?: 'TrainingsSession', id: number, endsAt?: any | null, link?: string | null, location?: string | null, startsAt?: any | null, sessionAttendances: Array<{ __typename?: 'TrainingsSessionAttendance', id: number, accessId: number, employeeId?: number | null, status: TrainingsSessionAttendanceStatusEnum }> } }> } } };

export type TrainingMembershipsDataTableQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  trainingId: Scalars['Int'];
}>;


export type TrainingMembershipsDataTableQuery = { __typename?: 'root_query', trainings: { __typename?: 'trainings', trainingMembershipsConnection: { __typename?: 'TrainingsTrainingMembershipConnection', edges: Array<{ __typename?: 'TrainingsTrainingMembershipEdge', node: { __typename?: 'TrainingsTrainingMembership', id: number, accessId: number, status: TrainingsTrainingMembershipStatusEnum, trainingCompletedAt?: string | null, trainingDueDate?: string | null, trainingId: number, employee?: { __typename?: 'EmployeesEmployee', id: number, fullName: string, preferredName?: string | null, avatar?: { __typename?: 'ApiCoreAttachment', id: number, url: string } | null } | null, trainingMembershipFiles: Array<{ __typename?: 'TrainingsTrainingMembershipFile', id: number, contentType: string, fileId?: number | null, filename: string, trainingMembershipId: number, url: string }> } }> } } };

export type TrainingsDataTableQueryVariables = Exact<{
  catalog?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  withExpiredMemberships?: InputMaybe<Scalars['Boolean']>;
}>;


export type TrainingsDataTableQuery = { __typename?: 'root_query', trainings: { __typename?: 'trainings', trainingsConnection: { __typename?: 'TrainingsTrainingConnection', edges: Array<{ __typename?: 'TrainingsTrainingEdge', node: { __typename?: 'TrainingsTraining', id: number, authorId: number, catalog: boolean, code?: string | null, costDecimal: string, description: string, external: boolean, externalProvider?: string | null, fundaeSubsidized: boolean, name: string, numberOfExpiredParticipants?: number | null, status?: TrainingsTrainingStatusEnum | null, subsidized: boolean, subsidizedCostDecimal: string, totalCostDecimal?: string | null, totalParticipants: number, year: number, _policies?: { __typename?: 'TrainingsTrainingPolicies', edit: { __typename?: 'PermissionsPolicyResolution', id: string, can: boolean }, read: { __typename?: 'PermissionsPolicyResolution', id: string, can: boolean } } | null, categories: Array<{ __typename?: 'TrainingsCategory', id: number, name: string }>, competencies: Array<{ __typename?: 'CompetenciesCompetency', id: number, name: string }>, sessions: Array<{ __typename?: 'TrainingsSession', id: number, endsAt?: any | null, modality?: TrainingsSessionModalityEnum | null, name: string, startsAt?: any | null }> } }> } } };

export type MyTrainingsCatalogSessionsDataTableQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  startsAfter?: InputMaybe<Scalars['String']>;
  trainingId?: InputMaybe<Scalars['Int']>;
}>;


export type MyTrainingsCatalogSessionsDataTableQuery = { __typename?: 'root_query', trainings: { __typename?: 'trainings', sessionsConnection: { __typename?: 'TrainingsSessionConnection', edges: Array<{ __typename?: 'TrainingsSessionEdge', node: { __typename?: 'TrainingsSession', id: number, dueDate?: string | null, duration?: string | null, endsAt?: any | null, link?: string | null, location?: string | null, modality?: TrainingsSessionModalityEnum | null, name: string, schedule?: TrainingsSessionScheduleEnum | null, startsAt?: any | null, sessionAttendances: Array<{ __typename?: 'TrainingsSessionAttendance', id: number, accessId: number, status: TrainingsSessionAttendanceStatusEnum, _policies?: { __typename?: 'TrainingsSessionAttendancePolicies', edit: { __typename?: 'PermissionsPolicyResolution', id: string, can: boolean } } | null }> } }> } } };

export type TrainingSessionsDataTableQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  trainingClassIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type TrainingSessionsDataTableQuery = { __typename?: 'root_query', trainings: { __typename?: 'trainings', sessionsConnection: { __typename?: 'TrainingsSessionConnection', edges: Array<{ __typename?: 'TrainingsSessionEdge', node: { __typename?: 'TrainingsSession', id: number, dueDate?: string | null, duration?: string | null, endsAt?: any | null, link?: string | null, location?: string | null, modality?: TrainingsSessionModalityEnum | null, name: string, startsAt?: any | null, sessionAttendances: Array<{ __typename?: 'TrainingsSessionAttendance', id: number, accessId: number, status: TrainingsSessionAttendanceStatusEnum }> } }> } } };

export const ApprovalGroupEmployeesDataTableDocument = gql`
query ApprovalGroupEmployeesDataTable($approvalGroupId: Int!, $search: String, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: ApprovalsApprovalGroupMembershipFilter) {
  approvals {
    approvalGroupMembershipsConnection(
      approvalGroupId: $approvalGroupId
      search: $search
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          access {
            id
            employee {
              id
              access {
                id
                avatar
                fullName
              }
              fullName
              referenceContract {
                id
                jobTitle
              }
            }
          }
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type ApprovalGroupEmployeesDataTableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<ApprovalGroupEmployeesDataTableQuery['approvals']>['approvalGroupMembershipsConnection']>['edges']
>

const ApprovalGroupEmployeesDataTableSortableFields = ['id', 'id', 'fullName', 'id', 'id'] as const

interface ApprovalGroupEmployeesDataTableFields {
  'access_employee_access_id': RevealType<['node', 'access', 'employee', 'access', 'id'], ApprovalGroupEmployeesDataTableDataSourceType>,
  'access_employee_access_avatar': RevealType<['node', 'access', 'employee', 'access', 'avatar'], ApprovalGroupEmployeesDataTableDataSourceType>,
  'access_employee_access_fullName': RevealType<['node', 'access', 'employee', 'access', 'fullName'], ApprovalGroupEmployeesDataTableDataSourceType>,
  'access_employee_referenceContract_id': RevealType<['node', 'access', 'employee', 'referenceContract', 'id'], ApprovalGroupEmployeesDataTableDataSourceType>,
  'access_employee_referenceContract_jobTitle': RevealType<['node', 'access', 'employee', 'referenceContract', 'jobTitle'], ApprovalGroupEmployeesDataTableDataSourceType>,
  'access_employee_id': RevealType<['node', 'access', 'employee', 'id'], ApprovalGroupEmployeesDataTableDataSourceType>,
  'access_employee_access': RevealType<['node', 'access', 'employee', 'access'], ApprovalGroupEmployeesDataTableDataSourceType>,
  'access_employee_fullName': RevealType<['node', 'access', 'employee', 'fullName'], ApprovalGroupEmployeesDataTableDataSourceType>,
  'access_employee_referenceContract': RevealType<['node', 'access', 'employee', 'referenceContract'], ApprovalGroupEmployeesDataTableDataSourceType>,
  'access_id': RevealType<['node', 'access', 'id'], ApprovalGroupEmployeesDataTableDataSourceType>,
  'access_employee': RevealType<['node', 'access', 'employee'], ApprovalGroupEmployeesDataTableDataSourceType>,
  'id': RevealType<['node', 'id'], ApprovalGroupEmployeesDataTableDataSourceType>,
  'access': RevealType<['node', 'access'], ApprovalGroupEmployeesDataTableDataSourceType>
}

const ApprovalGroupEmployeesDataTableResolver = {
  dataSource: (data: ApprovalGroupEmployeesDataTableQuery) => data.approvals.approvalGroupMembershipsConnection,
  edges: (data: ApprovalGroupEmployeesDataTableQuery) => data.approvals.approvalGroupMembershipsConnection.edges,
  fields: {
    'access_employee_access_id': (edge: ApprovalGroupEmployeesDataTableDataSourceType) => edge.node.access?.employee?.access?.id,
    'access_employee_access_avatar': (edge: ApprovalGroupEmployeesDataTableDataSourceType) => edge.node.access?.employee?.access?.avatar,
    'access_employee_access_fullName': (edge: ApprovalGroupEmployeesDataTableDataSourceType) => edge.node.access?.employee?.access?.fullName,
    'access_employee_referenceContract_id': (edge: ApprovalGroupEmployeesDataTableDataSourceType) => edge.node.access?.employee?.referenceContract?.id,
    'access_employee_referenceContract_jobTitle': (edge: ApprovalGroupEmployeesDataTableDataSourceType) => edge.node.access?.employee?.referenceContract?.jobTitle,
    'access_employee_id': (edge: ApprovalGroupEmployeesDataTableDataSourceType) => edge.node.access?.employee?.id,
    'access_employee_access': (edge: ApprovalGroupEmployeesDataTableDataSourceType) => edge.node.access?.employee?.access,
    'access_employee_fullName': (edge: ApprovalGroupEmployeesDataTableDataSourceType) => edge.node.access?.employee?.fullName,
    'access_employee_referenceContract': (edge: ApprovalGroupEmployeesDataTableDataSourceType) => edge.node.access?.employee?.referenceContract,
    'access_id': (edge: ApprovalGroupEmployeesDataTableDataSourceType) => edge.node.access?.id,
    'access_employee': (edge: ApprovalGroupEmployeesDataTableDataSourceType) => edge.node.access?.employee,
    'id': (edge: ApprovalGroupEmployeesDataTableDataSourceType) => edge.node.id,
    'access': (edge: ApprovalGroupEmployeesDataTableDataSourceType) => edge.node.access,
  }
}

export function buildApprovalGroupEmployeesDataTableFilter(
  source: DataTableSource<ApprovalGroupEmployeesDataTableFields, typeof ApprovalGroupEmployeesDataTableSortableFields[number]>,
  filter: DataTableFilter<ApprovalsApprovalGroupMembershipFilter>
) {
  return filter
}

export function useApprovalGroupEmployeesDataTable(
  projections: DataTableProjection<ApprovalGroupEmployeesDataTableFields, typeof ApprovalGroupEmployeesDataTableSortableFields[number]>[],
  options?: {
    variables?: ApprovalGroupEmployeesDataTableQueryVariables
    defaultSort?: typeof ApprovalGroupEmployeesDataTableSortableFields[number]
    identifier?: string
  }
): DataTableSource<ApprovalGroupEmployeesDataTableFields, typeof ApprovalGroupEmployeesDataTableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'ApprovalGroupEmployeesDataTable'

  return {
    identifier,
    query: ApprovalGroupEmployeesDataTableDocument,
    resolver: ApprovalGroupEmployeesDataTableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? ApprovalGroupEmployeesDataTableSortableFields.at(0),
      fields: ApprovalGroupEmployeesDataTableSortableFields,
    },
    variables
  }
}
export const CandidatesDataTableDocument = gql`
query CandidatesDataTable($active: Boolean, $archived: Boolean, $atsTagIds: [Int!], $consent: [String!], $emails: [String!], $jobPostingIds: [Int!], $locationIds: [Int!], $minimumAverageRating: Float, $rejectionReasonIds: [Int!], $search: String, $sourceIds: [Int!], $talentPool: Boolean, $teamIds: [Int!], $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: AtsCandidateFilter) {
  ats {
    candidatesConnection(
      active: $active
      archived: $archived
      atsTagIds: $atsTagIds
      consent: $consent
      emails: $emails
      jobPostingIds: $jobPostingIds
      locationIds: $locationIds
      minimumAverageRating: $minimumAverageRating
      rejectionReasonIds: $rejectionReasonIds
      search: $search
      sourceIds: $sourceIds
      talentPool: $talentPool
      teamIds: $teamIds
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          activeApplicationCount
          candidateSource {
            id
            name
          }
          consentExpirationDate
          consentToTalentPool
          email
          firstName
          fullName
          inactiveSince
          medium
          phoneNumber
          searchable
          talentPool
          createdAt
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type CandidatesDataTableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<CandidatesDataTableQuery['ats']>['candidatesConnection']>['edges']
>

const CandidatesDataTableSortableFields = ['name', 'id', 'firstName', 'fullName', 'createdAt'] as const

interface CandidatesDataTableFields {
  'candidateSource_id': RevealType<['node', 'candidateSource', 'id'], CandidatesDataTableDataSourceType>,
  'candidateSource_name': RevealType<['node', 'candidateSource', 'name'], CandidatesDataTableDataSourceType>,
  'id': RevealType<['node', 'id'], CandidatesDataTableDataSourceType>,
  'activeApplicationCount': RevealType<['node', 'activeApplicationCount'], CandidatesDataTableDataSourceType>,
  'candidateSource': RevealType<['node', 'candidateSource'], CandidatesDataTableDataSourceType>,
  'consentExpirationDate': RevealType<['node', 'consentExpirationDate'], CandidatesDataTableDataSourceType>,
  'consentToTalentPool': RevealType<['node', 'consentToTalentPool'], CandidatesDataTableDataSourceType>,
  'email': RevealType<['node', 'email'], CandidatesDataTableDataSourceType>,
  'firstName': RevealType<['node', 'firstName'], CandidatesDataTableDataSourceType>,
  'fullName': RevealType<['node', 'fullName'], CandidatesDataTableDataSourceType>,
  'inactiveSince': RevealType<['node', 'inactiveSince'], CandidatesDataTableDataSourceType>,
  'medium': RevealType<['node', 'medium'], CandidatesDataTableDataSourceType>,
  'phoneNumber': RevealType<['node', 'phoneNumber'], CandidatesDataTableDataSourceType>,
  'searchable': RevealType<['node', 'searchable'], CandidatesDataTableDataSourceType>,
  'talentPool': RevealType<['node', 'talentPool'], CandidatesDataTableDataSourceType>,
  'createdAt': RevealType<['node', 'createdAt'], CandidatesDataTableDataSourceType>
}

const CandidatesDataTableResolver = {
  dataSource: (data: CandidatesDataTableQuery) => data.ats.candidatesConnection,
  edges: (data: CandidatesDataTableQuery) => data.ats.candidatesConnection.edges,
  fields: {
    'candidateSource_id': (edge: CandidatesDataTableDataSourceType) => edge.node.candidateSource?.id,
    'candidateSource_name': (edge: CandidatesDataTableDataSourceType) => edge.node.candidateSource?.name,
    'id': (edge: CandidatesDataTableDataSourceType) => edge.node.id,
    'activeApplicationCount': (edge: CandidatesDataTableDataSourceType) => edge.node.activeApplicationCount,
    'candidateSource': (edge: CandidatesDataTableDataSourceType) => edge.node.candidateSource,
    'consentExpirationDate': (edge: CandidatesDataTableDataSourceType) => edge.node.consentExpirationDate,
    'consentToTalentPool': (edge: CandidatesDataTableDataSourceType) => edge.node.consentToTalentPool,
    'email': (edge: CandidatesDataTableDataSourceType) => edge.node.email,
    'firstName': (edge: CandidatesDataTableDataSourceType) => edge.node.firstName,
    'fullName': (edge: CandidatesDataTableDataSourceType) => edge.node.fullName,
    'inactiveSince': (edge: CandidatesDataTableDataSourceType) => edge.node.inactiveSince,
    'medium': (edge: CandidatesDataTableDataSourceType) => edge.node.medium,
    'phoneNumber': (edge: CandidatesDataTableDataSourceType) => edge.node.phoneNumber,
    'searchable': (edge: CandidatesDataTableDataSourceType) => edge.node.searchable,
    'talentPool': (edge: CandidatesDataTableDataSourceType) => edge.node.talentPool,
    'createdAt': (edge: CandidatesDataTableDataSourceType) => edge.node.createdAt,
  }
}

export function buildCandidatesDataTableFilter(
  source: DataTableSource<CandidatesDataTableFields, typeof CandidatesDataTableSortableFields[number]>,
  filter: DataTableFilter<AtsCandidateFilter>
) {
  return filter
}

export function useCandidatesDataTable(
  projections: DataTableProjection<CandidatesDataTableFields, typeof CandidatesDataTableSortableFields[number]>[],
  options?: {
    variables?: CandidatesDataTableQueryVariables
    defaultSort?: typeof CandidatesDataTableSortableFields[number]
    identifier?: string
  }
): DataTableSource<CandidatesDataTableFields, typeof CandidatesDataTableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'CandidatesDataTable'

  return {
    identifier,
    query: CandidatesDataTableDocument,
    resolver: CandidatesDataTableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? CandidatesDataTableSortableFields.at(0),
      fields: CandidatesDataTableSortableFields,
    },
    variables
  }
}
export const ApplicationsDataTableDocument = gql`
query ApplicationsDataTable($atsAnswers: [ApplicationsAtsAnswersInput!], $atsApplicationPhaseId: Int, $atsJobPostingId: Int, $atsTagIds: [Int!], $qualified: Boolean!, $search: String, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: AtsApplicationFilter) {
  ats {
    applicationsConnection(
      atsAnswers: $atsAnswers
      atsApplicationPhaseId: $atsApplicationPhaseId
      atsJobPostingId: $atsJobPostingId
      atsTagsIds: $atsTagIds
      qualified: $qualified
      search: $search
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          applicationPhase {
            id
            hiringStage {
              id
              name
            }
            name
            position
          }
          applicationSource {
            id
            name
          }
          assessment {
            id
            status
          }
          atsApplicationPhasePosition
          atsCandidateSourceName
          atsJobPostingId
          candidate {
            id
            atsTagIds
            consentToTalentPool
            duplicateIdentificationsAsMatched {
              id
            }
            duplicateIdentificationsAsSource {
              id
            }
            email
            fullName
          }
          medium
          offerLetter {
            id
            status
          }
          openAiFeedbackTopMatchRating {
            id
            helpful
          }
          qualified
          ratingAverage
          rejectionReason {
            id
            reason
          }
          summary {
            score
            topMatch
          }
          createdAt
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type ApplicationsDataTableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<ApplicationsDataTableQuery['ats']>['applicationsConnection']>['edges']
>

const ApplicationsDataTableSortableFields = ['id', 'name', 'name', 'id', 'fullName', 'reason', 'id', 'atsApplicationPhasePosition', 'atsCandidateSourceName', 'ratingAverage', 'createdAt'] as const

interface ApplicationsDataTableFields {
  'applicationPhase_hiringStage_id': RevealType<['node', 'applicationPhase', 'hiringStage', 'id'], ApplicationsDataTableDataSourceType>,
  'applicationPhase_hiringStage_name': RevealType<['node', 'applicationPhase', 'hiringStage', 'name'], ApplicationsDataTableDataSourceType>,
  'applicationPhase_id': RevealType<['node', 'applicationPhase', 'id'], ApplicationsDataTableDataSourceType>,
  'applicationPhase_hiringStage': RevealType<['node', 'applicationPhase', 'hiringStage'], ApplicationsDataTableDataSourceType>,
  'applicationPhase_name': RevealType<['node', 'applicationPhase', 'name'], ApplicationsDataTableDataSourceType>,
  'applicationPhase_position': RevealType<['node', 'applicationPhase', 'position'], ApplicationsDataTableDataSourceType>,
  'applicationSource_id': RevealType<['node', 'applicationSource', 'id'], ApplicationsDataTableDataSourceType>,
  'applicationSource_name': RevealType<['node', 'applicationSource', 'name'], ApplicationsDataTableDataSourceType>,
  'assessment_id': RevealType<['node', 'assessment', 'id'], ApplicationsDataTableDataSourceType>,
  'assessment_status': RevealType<['node', 'assessment', 'status'], ApplicationsDataTableDataSourceType>,
  'candidate_id': RevealType<['node', 'candidate', 'id'], ApplicationsDataTableDataSourceType>,
  'candidate_atsTagIds': RevealType<['node', 'candidate', 'atsTagIds'], ApplicationsDataTableDataSourceType>,
  'candidate_consentToTalentPool': RevealType<['node', 'candidate', 'consentToTalentPool'], ApplicationsDataTableDataSourceType>,
  'candidate_duplicateIdentificationsAsMatched': RevealType<['node', 'candidate', 'duplicateIdentificationsAsMatched'], ApplicationsDataTableDataSourceType>,
  'candidate_duplicateIdentificationsAsSource': RevealType<['node', 'candidate', 'duplicateIdentificationsAsSource'], ApplicationsDataTableDataSourceType>,
  'candidate_email': RevealType<['node', 'candidate', 'email'], ApplicationsDataTableDataSourceType>,
  'candidate_fullName': RevealType<['node', 'candidate', 'fullName'], ApplicationsDataTableDataSourceType>,
  'offerLetter_id': RevealType<['node', 'offerLetter', 'id'], ApplicationsDataTableDataSourceType>,
  'offerLetter_status': RevealType<['node', 'offerLetter', 'status'], ApplicationsDataTableDataSourceType>,
  'openAiFeedbackTopMatchRating_id': RevealType<['node', 'openAiFeedbackTopMatchRating', 'id'], ApplicationsDataTableDataSourceType>,
  'openAiFeedbackTopMatchRating_helpful': RevealType<['node', 'openAiFeedbackTopMatchRating', 'helpful'], ApplicationsDataTableDataSourceType>,
  'rejectionReason_id': RevealType<['node', 'rejectionReason', 'id'], ApplicationsDataTableDataSourceType>,
  'rejectionReason_reason': RevealType<['node', 'rejectionReason', 'reason'], ApplicationsDataTableDataSourceType>,
  'summary_score': RevealType<['node', 'summary', 'score'], ApplicationsDataTableDataSourceType>,
  'summary_topMatch': RevealType<['node', 'summary', 'topMatch'], ApplicationsDataTableDataSourceType>,
  'id': RevealType<['node', 'id'], ApplicationsDataTableDataSourceType>,
  'applicationPhase': RevealType<['node', 'applicationPhase'], ApplicationsDataTableDataSourceType>,
  'applicationSource': RevealType<['node', 'applicationSource'], ApplicationsDataTableDataSourceType>,
  'assessment': RevealType<['node', 'assessment'], ApplicationsDataTableDataSourceType>,
  'atsApplicationPhasePosition': RevealType<['node', 'atsApplicationPhasePosition'], ApplicationsDataTableDataSourceType>,
  'atsCandidateSourceName': RevealType<['node', 'atsCandidateSourceName'], ApplicationsDataTableDataSourceType>,
  'atsJobPostingId': RevealType<['node', 'atsJobPostingId'], ApplicationsDataTableDataSourceType>,
  'candidate': RevealType<['node', 'candidate'], ApplicationsDataTableDataSourceType>,
  'medium': RevealType<['node', 'medium'], ApplicationsDataTableDataSourceType>,
  'offerLetter': RevealType<['node', 'offerLetter'], ApplicationsDataTableDataSourceType>,
  'openAiFeedbackTopMatchRating': RevealType<['node', 'openAiFeedbackTopMatchRating'], ApplicationsDataTableDataSourceType>,
  'qualified': RevealType<['node', 'qualified'], ApplicationsDataTableDataSourceType>,
  'ratingAverage': RevealType<['node', 'ratingAverage'], ApplicationsDataTableDataSourceType>,
  'rejectionReason': RevealType<['node', 'rejectionReason'], ApplicationsDataTableDataSourceType>,
  'summary': RevealType<['node', 'summary'], ApplicationsDataTableDataSourceType>,
  'createdAt': RevealType<['node', 'createdAt'], ApplicationsDataTableDataSourceType>
}

const ApplicationsDataTableResolver = {
  dataSource: (data: ApplicationsDataTableQuery) => data.ats.applicationsConnection,
  edges: (data: ApplicationsDataTableQuery) => data.ats.applicationsConnection.edges,
  fields: {
    'applicationPhase_hiringStage_id': (edge: ApplicationsDataTableDataSourceType) => edge.node.applicationPhase?.hiringStage?.id,
    'applicationPhase_hiringStage_name': (edge: ApplicationsDataTableDataSourceType) => edge.node.applicationPhase?.hiringStage?.name,
    'applicationPhase_id': (edge: ApplicationsDataTableDataSourceType) => edge.node.applicationPhase?.id,
    'applicationPhase_hiringStage': (edge: ApplicationsDataTableDataSourceType) => edge.node.applicationPhase?.hiringStage,
    'applicationPhase_name': (edge: ApplicationsDataTableDataSourceType) => edge.node.applicationPhase?.name,
    'applicationPhase_position': (edge: ApplicationsDataTableDataSourceType) => edge.node.applicationPhase?.position,
    'applicationSource_id': (edge: ApplicationsDataTableDataSourceType) => edge.node.applicationSource?.id,
    'applicationSource_name': (edge: ApplicationsDataTableDataSourceType) => edge.node.applicationSource?.name,
    'assessment_id': (edge: ApplicationsDataTableDataSourceType) => edge.node.assessment?.id,
    'assessment_status': (edge: ApplicationsDataTableDataSourceType) => edge.node.assessment?.status,
    'candidate_id': (edge: ApplicationsDataTableDataSourceType) => edge.node.candidate?.id,
    'candidate_atsTagIds': (edge: ApplicationsDataTableDataSourceType) => edge.node.candidate?.atsTagIds,
    'candidate_consentToTalentPool': (edge: ApplicationsDataTableDataSourceType) => edge.node.candidate?.consentToTalentPool,
    'candidate_duplicateIdentificationsAsMatched': (edge: ApplicationsDataTableDataSourceType) => edge.node.candidate?.duplicateIdentificationsAsMatched,
    'candidate_duplicateIdentificationsAsSource': (edge: ApplicationsDataTableDataSourceType) => edge.node.candidate?.duplicateIdentificationsAsSource,
    'candidate_email': (edge: ApplicationsDataTableDataSourceType) => edge.node.candidate?.email,
    'candidate_fullName': (edge: ApplicationsDataTableDataSourceType) => edge.node.candidate?.fullName,
    'offerLetter_id': (edge: ApplicationsDataTableDataSourceType) => edge.node.offerLetter?.id,
    'offerLetter_status': (edge: ApplicationsDataTableDataSourceType) => edge.node.offerLetter?.status,
    'openAiFeedbackTopMatchRating_id': (edge: ApplicationsDataTableDataSourceType) => edge.node.openAiFeedbackTopMatchRating?.id,
    'openAiFeedbackTopMatchRating_helpful': (edge: ApplicationsDataTableDataSourceType) => edge.node.openAiFeedbackTopMatchRating?.helpful,
    'rejectionReason_id': (edge: ApplicationsDataTableDataSourceType) => edge.node.rejectionReason?.id,
    'rejectionReason_reason': (edge: ApplicationsDataTableDataSourceType) => edge.node.rejectionReason?.reason,
    'summary_score': (edge: ApplicationsDataTableDataSourceType) => edge.node.summary?.score,
    'summary_topMatch': (edge: ApplicationsDataTableDataSourceType) => edge.node.summary?.topMatch,
    'id': (edge: ApplicationsDataTableDataSourceType) => edge.node.id,
    'applicationPhase': (edge: ApplicationsDataTableDataSourceType) => edge.node.applicationPhase,
    'applicationSource': (edge: ApplicationsDataTableDataSourceType) => edge.node.applicationSource,
    'assessment': (edge: ApplicationsDataTableDataSourceType) => edge.node.assessment,
    'atsApplicationPhasePosition': (edge: ApplicationsDataTableDataSourceType) => edge.node.atsApplicationPhasePosition,
    'atsCandidateSourceName': (edge: ApplicationsDataTableDataSourceType) => edge.node.atsCandidateSourceName,
    'atsJobPostingId': (edge: ApplicationsDataTableDataSourceType) => edge.node.atsJobPostingId,
    'candidate': (edge: ApplicationsDataTableDataSourceType) => edge.node.candidate,
    'medium': (edge: ApplicationsDataTableDataSourceType) => edge.node.medium,
    'offerLetter': (edge: ApplicationsDataTableDataSourceType) => edge.node.offerLetter,
    'openAiFeedbackTopMatchRating': (edge: ApplicationsDataTableDataSourceType) => edge.node.openAiFeedbackTopMatchRating,
    'qualified': (edge: ApplicationsDataTableDataSourceType) => edge.node.qualified,
    'ratingAverage': (edge: ApplicationsDataTableDataSourceType) => edge.node.ratingAverage,
    'rejectionReason': (edge: ApplicationsDataTableDataSourceType) => edge.node.rejectionReason,
    'summary': (edge: ApplicationsDataTableDataSourceType) => edge.node.summary,
    'createdAt': (edge: ApplicationsDataTableDataSourceType) => edge.node.createdAt,
  }
}

export function buildApplicationsDataTableFilter(
  source: DataTableSource<ApplicationsDataTableFields, typeof ApplicationsDataTableSortableFields[number]>,
  filter: DataTableFilter<AtsApplicationFilter>
) {
  return filter
}

export function useApplicationsDataTable(
  projections: DataTableProjection<ApplicationsDataTableFields, typeof ApplicationsDataTableSortableFields[number]>[],
  options?: {
    variables?: ApplicationsDataTableQueryVariables
    defaultSort?: typeof ApplicationsDataTableSortableFields[number]
    identifier?: string
  }
): DataTableSource<ApplicationsDataTableFields, typeof ApplicationsDataTableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'ApplicationsDataTable'

  return {
    identifier,
    query: ApplicationsDataTableDocument,
    resolver: ApplicationsDataTableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? ApplicationsDataTableSortableFields.at(0),
      fields: ApplicationsDataTableSortableFields,
    },
    variables
  }
}
export const CardPaymentsDataTableDocument = gql`
query CardPaymentsDataTable($accountIds: [Int!], $cardIds: [Int!], $search: String!, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: BankingCardPaymentFilter) {
  banking {
    cardPaymentsConnection(
      accountIds: $accountIds
      cardIds: $cardIds
      search: $search
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          amountCents
          approved
          calculatedLabel
          currency
          externalCreatedAt
          merchantAmountCents
          merchantCurrency
          merchantName
          rejectedReason
          status
          type
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type CardPaymentsDataTableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<CardPaymentsDataTableQuery['banking']>['cardPaymentsConnection']>['edges']
>

const CardPaymentsDataTableSortableFields = ['id', 'amountCents', 'calculatedLabel', 'currency', 'externalCreatedAt', 'merchantAmountCents', 'merchantCurrency', 'merchantName'] as const

interface CardPaymentsDataTableFields {
  'id': RevealType<['node', 'id'], CardPaymentsDataTableDataSourceType>,
  'amountCents': RevealType<['node', 'amountCents'], CardPaymentsDataTableDataSourceType>,
  'approved': RevealType<['node', 'approved'], CardPaymentsDataTableDataSourceType>,
  'calculatedLabel': RevealType<['node', 'calculatedLabel'], CardPaymentsDataTableDataSourceType>,
  'currency': RevealType<['node', 'currency'], CardPaymentsDataTableDataSourceType>,
  'externalCreatedAt': RevealType<['node', 'externalCreatedAt'], CardPaymentsDataTableDataSourceType>,
  'merchantAmountCents': RevealType<['node', 'merchantAmountCents'], CardPaymentsDataTableDataSourceType>,
  'merchantCurrency': RevealType<['node', 'merchantCurrency'], CardPaymentsDataTableDataSourceType>,
  'merchantName': RevealType<['node', 'merchantName'], CardPaymentsDataTableDataSourceType>,
  'rejectedReason': RevealType<['node', 'rejectedReason'], CardPaymentsDataTableDataSourceType>,
  'status': RevealType<['node', 'status'], CardPaymentsDataTableDataSourceType>,
  'type': RevealType<['node', 'type'], CardPaymentsDataTableDataSourceType>
}

const CardPaymentsDataTableResolver = {
  dataSource: (data: CardPaymentsDataTableQuery) => data.banking.cardPaymentsConnection,
  edges: (data: CardPaymentsDataTableQuery) => data.banking.cardPaymentsConnection.edges,
  fields: {
    'id': (edge: CardPaymentsDataTableDataSourceType) => edge.node.id,
    'amountCents': (edge: CardPaymentsDataTableDataSourceType) => edge.node.amountCents,
    'approved': (edge: CardPaymentsDataTableDataSourceType) => edge.node.approved,
    'calculatedLabel': (edge: CardPaymentsDataTableDataSourceType) => edge.node.calculatedLabel,
    'currency': (edge: CardPaymentsDataTableDataSourceType) => edge.node.currency,
    'externalCreatedAt': (edge: CardPaymentsDataTableDataSourceType) => edge.node.externalCreatedAt,
    'merchantAmountCents': (edge: CardPaymentsDataTableDataSourceType) => edge.node.merchantAmountCents,
    'merchantCurrency': (edge: CardPaymentsDataTableDataSourceType) => edge.node.merchantCurrency,
    'merchantName': (edge: CardPaymentsDataTableDataSourceType) => edge.node.merchantName,
    'rejectedReason': (edge: CardPaymentsDataTableDataSourceType) => edge.node.rejectedReason,
    'status': (edge: CardPaymentsDataTableDataSourceType) => edge.node.status,
    'type': (edge: CardPaymentsDataTableDataSourceType) => edge.node.type,
  }
}

export function buildCardPaymentsDataTableFilter(
  source: DataTableSource<CardPaymentsDataTableFields, typeof CardPaymentsDataTableSortableFields[number]>,
  filter: DataTableFilter<BankingCardPaymentFilter>
) {
  return filter
}

export function useCardPaymentsDataTable(
  projections: DataTableProjection<CardPaymentsDataTableFields, typeof CardPaymentsDataTableSortableFields[number]>[],
  options?: {
    variables?: CardPaymentsDataTableQueryVariables
    defaultSort?: typeof CardPaymentsDataTableSortableFields[number]
    identifier?: string
  }
): DataTableSource<CardPaymentsDataTableFields, typeof CardPaymentsDataTableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'CardPaymentsDataTable'

  return {
    identifier,
    query: CardPaymentsDataTableDocument,
    resolver: CardPaymentsDataTableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? CardPaymentsDataTableSortableFields.at(0),
      fields: CardPaymentsDataTableSortableFields,
    },
    variables
  }
}
export const PaymentExecutionTransfersDataTableDocument = gql`
query PaymentExecutionTransfersDataTable($paymentExecutionId: Int!, $search: String!, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: BankingTransferFilter) {
  banking {
    transfersConnection(
      paymentExecutionIds: [$paymentExecutionId]
      search: $search
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          accountNumber
          amountCents
          beneficiaryName
          currency
          dueDate
          label
          paymentExecutionId
          requester {
            id
            access {
              id
              avatar
              fullName
            }
          }
          sourceId
          sourceType
          status
          createdAt
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type PaymentExecutionTransfersDataTableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<PaymentExecutionTransfersDataTableQuery['banking']>['transfersConnection']>['edges']
>

const PaymentExecutionTransfersDataTableSortableFields = ['id', 'id', 'accountNumber', 'amountCents', 'beneficiaryName', 'currency', 'dueDate', 'sourceId', 'sourceType', 'status', 'createdAt'] as const

interface PaymentExecutionTransfersDataTableFields {
  'requester_access_id': RevealType<['node', 'requester', 'access', 'id'], PaymentExecutionTransfersDataTableDataSourceType>,
  'requester_access_avatar': RevealType<['node', 'requester', 'access', 'avatar'], PaymentExecutionTransfersDataTableDataSourceType>,
  'requester_access_fullName': RevealType<['node', 'requester', 'access', 'fullName'], PaymentExecutionTransfersDataTableDataSourceType>,
  'requester_id': RevealType<['node', 'requester', 'id'], PaymentExecutionTransfersDataTableDataSourceType>,
  'requester_access': RevealType<['node', 'requester', 'access'], PaymentExecutionTransfersDataTableDataSourceType>,
  'id': RevealType<['node', 'id'], PaymentExecutionTransfersDataTableDataSourceType>,
  'accountNumber': RevealType<['node', 'accountNumber'], PaymentExecutionTransfersDataTableDataSourceType>,
  'amountCents': RevealType<['node', 'amountCents'], PaymentExecutionTransfersDataTableDataSourceType>,
  'beneficiaryName': RevealType<['node', 'beneficiaryName'], PaymentExecutionTransfersDataTableDataSourceType>,
  'currency': RevealType<['node', 'currency'], PaymentExecutionTransfersDataTableDataSourceType>,
  'dueDate': RevealType<['node', 'dueDate'], PaymentExecutionTransfersDataTableDataSourceType>,
  'label': RevealType<['node', 'label'], PaymentExecutionTransfersDataTableDataSourceType>,
  'paymentExecutionId': RevealType<['node', 'paymentExecutionId'], PaymentExecutionTransfersDataTableDataSourceType>,
  'requester': RevealType<['node', 'requester'], PaymentExecutionTransfersDataTableDataSourceType>,
  'sourceId': RevealType<['node', 'sourceId'], PaymentExecutionTransfersDataTableDataSourceType>,
  'sourceType': RevealType<['node', 'sourceType'], PaymentExecutionTransfersDataTableDataSourceType>,
  'status': RevealType<['node', 'status'], PaymentExecutionTransfersDataTableDataSourceType>,
  'createdAt': RevealType<['node', 'createdAt'], PaymentExecutionTransfersDataTableDataSourceType>
}

const PaymentExecutionTransfersDataTableResolver = {
  dataSource: (data: PaymentExecutionTransfersDataTableQuery) => data.banking.transfersConnection,
  edges: (data: PaymentExecutionTransfersDataTableQuery) => data.banking.transfersConnection.edges,
  fields: {
    'requester_access_id': (edge: PaymentExecutionTransfersDataTableDataSourceType) => edge.node.requester?.access?.id,
    'requester_access_avatar': (edge: PaymentExecutionTransfersDataTableDataSourceType) => edge.node.requester?.access?.avatar,
    'requester_access_fullName': (edge: PaymentExecutionTransfersDataTableDataSourceType) => edge.node.requester?.access?.fullName,
    'requester_id': (edge: PaymentExecutionTransfersDataTableDataSourceType) => edge.node.requester?.id,
    'requester_access': (edge: PaymentExecutionTransfersDataTableDataSourceType) => edge.node.requester?.access,
    'id': (edge: PaymentExecutionTransfersDataTableDataSourceType) => edge.node.id,
    'accountNumber': (edge: PaymentExecutionTransfersDataTableDataSourceType) => edge.node.accountNumber,
    'amountCents': (edge: PaymentExecutionTransfersDataTableDataSourceType) => edge.node.amountCents,
    'beneficiaryName': (edge: PaymentExecutionTransfersDataTableDataSourceType) => edge.node.beneficiaryName,
    'currency': (edge: PaymentExecutionTransfersDataTableDataSourceType) => edge.node.currency,
    'dueDate': (edge: PaymentExecutionTransfersDataTableDataSourceType) => edge.node.dueDate,
    'label': (edge: PaymentExecutionTransfersDataTableDataSourceType) => edge.node.label,
    'paymentExecutionId': (edge: PaymentExecutionTransfersDataTableDataSourceType) => edge.node.paymentExecutionId,
    'requester': (edge: PaymentExecutionTransfersDataTableDataSourceType) => edge.node.requester,
    'sourceId': (edge: PaymentExecutionTransfersDataTableDataSourceType) => edge.node.sourceId,
    'sourceType': (edge: PaymentExecutionTransfersDataTableDataSourceType) => edge.node.sourceType,
    'status': (edge: PaymentExecutionTransfersDataTableDataSourceType) => edge.node.status,
    'createdAt': (edge: PaymentExecutionTransfersDataTableDataSourceType) => edge.node.createdAt,
  }
}

export function buildPaymentExecutionTransfersDataTableFilter(
  source: DataTableSource<PaymentExecutionTransfersDataTableFields, typeof PaymentExecutionTransfersDataTableSortableFields[number]>,
  filter: DataTableFilter<BankingTransferFilter>
) {
  return filter
}

export function usePaymentExecutionTransfersDataTable(
  projections: DataTableProjection<PaymentExecutionTransfersDataTableFields, typeof PaymentExecutionTransfersDataTableSortableFields[number]>[],
  options?: {
    variables?: PaymentExecutionTransfersDataTableQueryVariables
    defaultSort?: typeof PaymentExecutionTransfersDataTableSortableFields[number]
    identifier?: string
  }
): DataTableSource<PaymentExecutionTransfersDataTableFields, typeof PaymentExecutionTransfersDataTableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'PaymentExecutionTransfersDataTable'

  return {
    identifier,
    query: PaymentExecutionTransfersDataTableDocument,
    resolver: PaymentExecutionTransfersDataTableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? PaymentExecutionTransfersDataTableSortableFields.at(0),
      fields: PaymentExecutionTransfersDataTableSortableFields,
    },
    variables
  }
}
export const PaymentsDataTableDocument = gql`
query PaymentsDataTable($search: String!, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: BankingPaymentFilter) {
  banking {
    paymentsConnection(
      search: $search
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          account {
            id
            account {
              id
              providerConfiguration {
                id
                services
              }
            }
          }
          amountCents
          currency
          date
          dueDate
          label
          paymentExecutions {
            id
            consent {
              id
              consentUrl
            }
            date
            executedAt
            paidAt
            payer {
              id
              fullName
            }
            sepaFile {
              id
              filename
              url
            }
            status
            transfersConnection {
              totalCount
            }
          }
          requester {
            id
            access {
              id
              avatar
              fullName
            }
            fullName
          }
          status
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type PaymentsDataTableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<PaymentsDataTableQuery['banking']>['paymentsConnection']>['edges']
>

const PaymentsDataTableSortableFields = ['id', 'id', 'fullName', 'amountCents', 'currency', 'date', 'dueDate', 'label', 'status'] as const

interface PaymentsDataTableFields {
  'account_account_providerConfiguration_id': RevealType<['node', 'account', 'account', 'providerConfiguration', 'id'], PaymentsDataTableDataSourceType>,
  'account_account_providerConfiguration_services': RevealType<['node', 'account', 'account', 'providerConfiguration', 'services'], PaymentsDataTableDataSourceType>,
  'account_account_id': RevealType<['node', 'account', 'account', 'id'], PaymentsDataTableDataSourceType>,
  'account_account_providerConfiguration': RevealType<['node', 'account', 'account', 'providerConfiguration'], PaymentsDataTableDataSourceType>,
  'account_id': RevealType<['node', 'account', 'id'], PaymentsDataTableDataSourceType>,
  'account_account': RevealType<['node', 'account', 'account'], PaymentsDataTableDataSourceType>,
  'requester_access_id': RevealType<['node', 'requester', 'access', 'id'], PaymentsDataTableDataSourceType>,
  'requester_access_avatar': RevealType<['node', 'requester', 'access', 'avatar'], PaymentsDataTableDataSourceType>,
  'requester_access_fullName': RevealType<['node', 'requester', 'access', 'fullName'], PaymentsDataTableDataSourceType>,
  'requester_id': RevealType<['node', 'requester', 'id'], PaymentsDataTableDataSourceType>,
  'requester_access': RevealType<['node', 'requester', 'access'], PaymentsDataTableDataSourceType>,
  'requester_fullName': RevealType<['node', 'requester', 'fullName'], PaymentsDataTableDataSourceType>,
  'id': RevealType<['node', 'id'], PaymentsDataTableDataSourceType>,
  'account': RevealType<['node', 'account'], PaymentsDataTableDataSourceType>,
  'amountCents': RevealType<['node', 'amountCents'], PaymentsDataTableDataSourceType>,
  'currency': RevealType<['node', 'currency'], PaymentsDataTableDataSourceType>,
  'date': RevealType<['node', 'date'], PaymentsDataTableDataSourceType>,
  'dueDate': RevealType<['node', 'dueDate'], PaymentsDataTableDataSourceType>,
  'label': RevealType<['node', 'label'], PaymentsDataTableDataSourceType>,
  'paymentExecutions': RevealType<['node', 'paymentExecutions'], PaymentsDataTableDataSourceType>,
  'requester': RevealType<['node', 'requester'], PaymentsDataTableDataSourceType>,
  'status': RevealType<['node', 'status'], PaymentsDataTableDataSourceType>
}

const PaymentsDataTableResolver = {
  dataSource: (data: PaymentsDataTableQuery) => data.banking.paymentsConnection,
  edges: (data: PaymentsDataTableQuery) => data.banking.paymentsConnection.edges,
  fields: {
    'account_account_providerConfiguration_id': (edge: PaymentsDataTableDataSourceType) => edge.node.account?.account?.providerConfiguration?.id,
    'account_account_providerConfiguration_services': (edge: PaymentsDataTableDataSourceType) => edge.node.account?.account?.providerConfiguration?.services,
    'account_account_id': (edge: PaymentsDataTableDataSourceType) => edge.node.account?.account?.id,
    'account_account_providerConfiguration': (edge: PaymentsDataTableDataSourceType) => edge.node.account?.account?.providerConfiguration,
    'account_id': (edge: PaymentsDataTableDataSourceType) => edge.node.account?.id,
    'account_account': (edge: PaymentsDataTableDataSourceType) => edge.node.account?.account,
    'requester_access_id': (edge: PaymentsDataTableDataSourceType) => edge.node.requester?.access?.id,
    'requester_access_avatar': (edge: PaymentsDataTableDataSourceType) => edge.node.requester?.access?.avatar,
    'requester_access_fullName': (edge: PaymentsDataTableDataSourceType) => edge.node.requester?.access?.fullName,
    'requester_id': (edge: PaymentsDataTableDataSourceType) => edge.node.requester?.id,
    'requester_access': (edge: PaymentsDataTableDataSourceType) => edge.node.requester?.access,
    'requester_fullName': (edge: PaymentsDataTableDataSourceType) => edge.node.requester?.fullName,
    'id': (edge: PaymentsDataTableDataSourceType) => edge.node.id,
    'account': (edge: PaymentsDataTableDataSourceType) => edge.node.account,
    'amountCents': (edge: PaymentsDataTableDataSourceType) => edge.node.amountCents,
    'currency': (edge: PaymentsDataTableDataSourceType) => edge.node.currency,
    'date': (edge: PaymentsDataTableDataSourceType) => edge.node.date,
    'dueDate': (edge: PaymentsDataTableDataSourceType) => edge.node.dueDate,
    'label': (edge: PaymentsDataTableDataSourceType) => edge.node.label,
    'paymentExecutions': (edge: PaymentsDataTableDataSourceType) => edge.node.paymentExecutions,
    'requester': (edge: PaymentsDataTableDataSourceType) => edge.node.requester,
    'status': (edge: PaymentsDataTableDataSourceType) => edge.node.status,
  }
}

export function buildPaymentsDataTableFilter(
  source: DataTableSource<PaymentsDataTableFields, typeof PaymentsDataTableSortableFields[number]>,
  filter: DataTableFilter<BankingPaymentFilter>
) {
  return filter
}

export function usePaymentsDataTable(
  projections: DataTableProjection<PaymentsDataTableFields, typeof PaymentsDataTableSortableFields[number]>[],
  options?: {
    variables?: PaymentsDataTableQueryVariables
    defaultSort?: typeof PaymentsDataTableSortableFields[number]
    identifier?: string
  }
): DataTableSource<PaymentsDataTableFields, typeof PaymentsDataTableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'PaymentsDataTable'

  return {
    identifier,
    query: PaymentsDataTableDocument,
    resolver: PaymentsDataTableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? PaymentsDataTableSortableFields.at(0),
      fields: PaymentsDataTableSortableFields,
    },
    variables
  }
}
export const TransfersDataTableDocument = gql`
query TransfersDataTable($onlyPending: Boolean, $search: String!, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: BankingTransferFilter) {
  banking {
    transfersConnection(
      onlyPending: $onlyPending
      search: $search
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          accountNumber
          amountCents
          beneficiaryName
          currency
          dueDate
          label
          paymentExecutionId
          requester {
            id
            access {
              id
              avatar
              fullName
            }
          }
          sourceId
          sourceType
          createdAt
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type TransfersDataTableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<TransfersDataTableQuery['banking']>['transfersConnection']>['edges']
>

const TransfersDataTableSortableFields = ['id', 'id', 'accountNumber', 'amountCents', 'beneficiaryName', 'currency', 'dueDate', 'sourceId', 'sourceType', 'createdAt'] as const

interface TransfersDataTableFields {
  'requester_access_id': RevealType<['node', 'requester', 'access', 'id'], TransfersDataTableDataSourceType>,
  'requester_access_avatar': RevealType<['node', 'requester', 'access', 'avatar'], TransfersDataTableDataSourceType>,
  'requester_access_fullName': RevealType<['node', 'requester', 'access', 'fullName'], TransfersDataTableDataSourceType>,
  'requester_id': RevealType<['node', 'requester', 'id'], TransfersDataTableDataSourceType>,
  'requester_access': RevealType<['node', 'requester', 'access'], TransfersDataTableDataSourceType>,
  'id': RevealType<['node', 'id'], TransfersDataTableDataSourceType>,
  'accountNumber': RevealType<['node', 'accountNumber'], TransfersDataTableDataSourceType>,
  'amountCents': RevealType<['node', 'amountCents'], TransfersDataTableDataSourceType>,
  'beneficiaryName': RevealType<['node', 'beneficiaryName'], TransfersDataTableDataSourceType>,
  'currency': RevealType<['node', 'currency'], TransfersDataTableDataSourceType>,
  'dueDate': RevealType<['node', 'dueDate'], TransfersDataTableDataSourceType>,
  'label': RevealType<['node', 'label'], TransfersDataTableDataSourceType>,
  'paymentExecutionId': RevealType<['node', 'paymentExecutionId'], TransfersDataTableDataSourceType>,
  'requester': RevealType<['node', 'requester'], TransfersDataTableDataSourceType>,
  'sourceId': RevealType<['node', 'sourceId'], TransfersDataTableDataSourceType>,
  'sourceType': RevealType<['node', 'sourceType'], TransfersDataTableDataSourceType>,
  'createdAt': RevealType<['node', 'createdAt'], TransfersDataTableDataSourceType>
}

const TransfersDataTableResolver = {
  dataSource: (data: TransfersDataTableQuery) => data.banking.transfersConnection,
  edges: (data: TransfersDataTableQuery) => data.banking.transfersConnection.edges,
  fields: {
    'requester_access_id': (edge: TransfersDataTableDataSourceType) => edge.node.requester?.access?.id,
    'requester_access_avatar': (edge: TransfersDataTableDataSourceType) => edge.node.requester?.access?.avatar,
    'requester_access_fullName': (edge: TransfersDataTableDataSourceType) => edge.node.requester?.access?.fullName,
    'requester_id': (edge: TransfersDataTableDataSourceType) => edge.node.requester?.id,
    'requester_access': (edge: TransfersDataTableDataSourceType) => edge.node.requester?.access,
    'id': (edge: TransfersDataTableDataSourceType) => edge.node.id,
    'accountNumber': (edge: TransfersDataTableDataSourceType) => edge.node.accountNumber,
    'amountCents': (edge: TransfersDataTableDataSourceType) => edge.node.amountCents,
    'beneficiaryName': (edge: TransfersDataTableDataSourceType) => edge.node.beneficiaryName,
    'currency': (edge: TransfersDataTableDataSourceType) => edge.node.currency,
    'dueDate': (edge: TransfersDataTableDataSourceType) => edge.node.dueDate,
    'label': (edge: TransfersDataTableDataSourceType) => edge.node.label,
    'paymentExecutionId': (edge: TransfersDataTableDataSourceType) => edge.node.paymentExecutionId,
    'requester': (edge: TransfersDataTableDataSourceType) => edge.node.requester,
    'sourceId': (edge: TransfersDataTableDataSourceType) => edge.node.sourceId,
    'sourceType': (edge: TransfersDataTableDataSourceType) => edge.node.sourceType,
    'createdAt': (edge: TransfersDataTableDataSourceType) => edge.node.createdAt,
  }
}

export function buildTransfersDataTableFilter(
  source: DataTableSource<TransfersDataTableFields, typeof TransfersDataTableSortableFields[number]>,
  filter: DataTableFilter<BankingTransferFilter>
) {
  return filter
}

export function useTransfersDataTable(
  projections: DataTableProjection<TransfersDataTableFields, typeof TransfersDataTableSortableFields[number]>[],
  options?: {
    variables?: TransfersDataTableQueryVariables
    defaultSort?: typeof TransfersDataTableSortableFields[number]
    identifier?: string
  }
): DataTableSource<TransfersDataTableFields, typeof TransfersDataTableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'TransfersDataTable'

  return {
    identifier,
    query: TransfersDataTableDocument,
    resolver: TransfersDataTableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? TransfersDataTableSortableFields.at(0),
      fields: TransfersDataTableSortableFields,
    },
    variables
  }
}
export const CardsDataTableDocument = gql`
query CardsDataTable($bankAccountIds: [Int!], $companyId: Int!, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: BankingCardFilter) {
  banking {
    cardsConnection(
      bankAccountIds: $bankAccountIds
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          _policies {
            activate {
              id
              can
            }
            approve {
              id
              can
            }
            cancel {
              id
              can
            }
            deactivate {
              id
              can
            }
            reactivate {
              id
              can
            }
          }
          alias
          approval(companyId: $companyId) {
            id
            _policies {
              approveOrReject {
                id
                can
              }
            }
            status
          }
          cardholder {
            id
            employee {
              id
              access {
                id
                avatar
                fullName
              }
            }
          }
          creationSource
          expMonth
          expYear
          last4
          softwareSetup {
            id
            software {
              id
              logoUrl
              name
            }
          }
          status
          type
          createdAt
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type CardsDataTableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<CardsDataTableQuery['banking']>['cardsConnection']>['edges']
>

const CardsDataTableSortableFields = ['id', 'id', 'id', 'id', 'creationSource', 'status', 'type'] as const

interface CardsDataTableFields {
  '_policies_activate_id': RevealType<['node', '_policies', 'activate', 'id'], CardsDataTableDataSourceType>,
  '_policies_activate_can': RevealType<['node', '_policies', 'activate', 'can'], CardsDataTableDataSourceType>,
  '_policies_approve_id': RevealType<['node', '_policies', 'approve', 'id'], CardsDataTableDataSourceType>,
  '_policies_approve_can': RevealType<['node', '_policies', 'approve', 'can'], CardsDataTableDataSourceType>,
  '_policies_cancel_id': RevealType<['node', '_policies', 'cancel', 'id'], CardsDataTableDataSourceType>,
  '_policies_cancel_can': RevealType<['node', '_policies', 'cancel', 'can'], CardsDataTableDataSourceType>,
  '_policies_deactivate_id': RevealType<['node', '_policies', 'deactivate', 'id'], CardsDataTableDataSourceType>,
  '_policies_deactivate_can': RevealType<['node', '_policies', 'deactivate', 'can'], CardsDataTableDataSourceType>,
  '_policies_reactivate_id': RevealType<['node', '_policies', 'reactivate', 'id'], CardsDataTableDataSourceType>,
  '_policies_reactivate_can': RevealType<['node', '_policies', 'reactivate', 'can'], CardsDataTableDataSourceType>,
  '_policies_activate': RevealType<['node', '_policies', 'activate'], CardsDataTableDataSourceType>,
  '_policies_approve': RevealType<['node', '_policies', 'approve'], CardsDataTableDataSourceType>,
  '_policies_cancel': RevealType<['node', '_policies', 'cancel'], CardsDataTableDataSourceType>,
  '_policies_deactivate': RevealType<['node', '_policies', 'deactivate'], CardsDataTableDataSourceType>,
  '_policies_reactivate': RevealType<['node', '_policies', 'reactivate'], CardsDataTableDataSourceType>,
  'approval__policies_approveOrReject_id': RevealType<['node', 'approval', '_policies', 'approveOrReject', 'id'], CardsDataTableDataSourceType>,
  'approval__policies_approveOrReject_can': RevealType<['node', 'approval', '_policies', 'approveOrReject', 'can'], CardsDataTableDataSourceType>,
  'approval__policies_approveOrReject': RevealType<['node', 'approval', '_policies', 'approveOrReject'], CardsDataTableDataSourceType>,
  'approval_id': RevealType<['node', 'approval', 'id'], CardsDataTableDataSourceType>,
  'approval__policies': RevealType<['node', 'approval', '_policies'], CardsDataTableDataSourceType>,
  'approval_status': RevealType<['node', 'approval', 'status'], CardsDataTableDataSourceType>,
  'cardholder_employee_access_id': RevealType<['node', 'cardholder', 'employee', 'access', 'id'], CardsDataTableDataSourceType>,
  'cardholder_employee_access_avatar': RevealType<['node', 'cardholder', 'employee', 'access', 'avatar'], CardsDataTableDataSourceType>,
  'cardholder_employee_access_fullName': RevealType<['node', 'cardholder', 'employee', 'access', 'fullName'], CardsDataTableDataSourceType>,
  'cardholder_employee_id': RevealType<['node', 'cardholder', 'employee', 'id'], CardsDataTableDataSourceType>,
  'cardholder_employee_access': RevealType<['node', 'cardholder', 'employee', 'access'], CardsDataTableDataSourceType>,
  'cardholder_id': RevealType<['node', 'cardholder', 'id'], CardsDataTableDataSourceType>,
  'cardholder_employee': RevealType<['node', 'cardholder', 'employee'], CardsDataTableDataSourceType>,
  'softwareSetup_software_id': RevealType<['node', 'softwareSetup', 'software', 'id'], CardsDataTableDataSourceType>,
  'softwareSetup_software_logoUrl': RevealType<['node', 'softwareSetup', 'software', 'logoUrl'], CardsDataTableDataSourceType>,
  'softwareSetup_software_name': RevealType<['node', 'softwareSetup', 'software', 'name'], CardsDataTableDataSourceType>,
  'softwareSetup_id': RevealType<['node', 'softwareSetup', 'id'], CardsDataTableDataSourceType>,
  'softwareSetup_software': RevealType<['node', 'softwareSetup', 'software'], CardsDataTableDataSourceType>,
  'id': RevealType<['node', 'id'], CardsDataTableDataSourceType>,
  '_policies': RevealType<['node', '_policies'], CardsDataTableDataSourceType>,
  'alias': RevealType<['node', 'alias'], CardsDataTableDataSourceType>,
  'approval': RevealType<['node', 'approval'], CardsDataTableDataSourceType>,
  'cardholder': RevealType<['node', 'cardholder'], CardsDataTableDataSourceType>,
  'creationSource': RevealType<['node', 'creationSource'], CardsDataTableDataSourceType>,
  'expMonth': RevealType<['node', 'expMonth'], CardsDataTableDataSourceType>,
  'expYear': RevealType<['node', 'expYear'], CardsDataTableDataSourceType>,
  'last4': RevealType<['node', 'last4'], CardsDataTableDataSourceType>,
  'softwareSetup': RevealType<['node', 'softwareSetup'], CardsDataTableDataSourceType>,
  'status': RevealType<['node', 'status'], CardsDataTableDataSourceType>,
  'type': RevealType<['node', 'type'], CardsDataTableDataSourceType>,
  'createdAt': RevealType<['node', 'createdAt'], CardsDataTableDataSourceType>
}

const CardsDataTableResolver = {
  dataSource: (data: CardsDataTableQuery) => data.banking.cardsConnection,
  edges: (data: CardsDataTableQuery) => data.banking.cardsConnection.edges,
  fields: {
    '_policies_activate_id': (edge: CardsDataTableDataSourceType) => edge.node._policies?.activate?.id,
    '_policies_activate_can': (edge: CardsDataTableDataSourceType) => edge.node._policies?.activate?.can,
    '_policies_approve_id': (edge: CardsDataTableDataSourceType) => edge.node._policies?.approve?.id,
    '_policies_approve_can': (edge: CardsDataTableDataSourceType) => edge.node._policies?.approve?.can,
    '_policies_cancel_id': (edge: CardsDataTableDataSourceType) => edge.node._policies?.cancel?.id,
    '_policies_cancel_can': (edge: CardsDataTableDataSourceType) => edge.node._policies?.cancel?.can,
    '_policies_deactivate_id': (edge: CardsDataTableDataSourceType) => edge.node._policies?.deactivate?.id,
    '_policies_deactivate_can': (edge: CardsDataTableDataSourceType) => edge.node._policies?.deactivate?.can,
    '_policies_reactivate_id': (edge: CardsDataTableDataSourceType) => edge.node._policies?.reactivate?.id,
    '_policies_reactivate_can': (edge: CardsDataTableDataSourceType) => edge.node._policies?.reactivate?.can,
    '_policies_activate': (edge: CardsDataTableDataSourceType) => edge.node._policies?.activate,
    '_policies_approve': (edge: CardsDataTableDataSourceType) => edge.node._policies?.approve,
    '_policies_cancel': (edge: CardsDataTableDataSourceType) => edge.node._policies?.cancel,
    '_policies_deactivate': (edge: CardsDataTableDataSourceType) => edge.node._policies?.deactivate,
    '_policies_reactivate': (edge: CardsDataTableDataSourceType) => edge.node._policies?.reactivate,
    'approval__policies_approveOrReject_id': (edge: CardsDataTableDataSourceType) => edge.node.approval?._policies?.approveOrReject?.id,
    'approval__policies_approveOrReject_can': (edge: CardsDataTableDataSourceType) => edge.node.approval?._policies?.approveOrReject?.can,
    'approval__policies_approveOrReject': (edge: CardsDataTableDataSourceType) => edge.node.approval?._policies?.approveOrReject,
    'approval_id': (edge: CardsDataTableDataSourceType) => edge.node.approval?.id,
    'approval__policies': (edge: CardsDataTableDataSourceType) => edge.node.approval?._policies,
    'approval_status': (edge: CardsDataTableDataSourceType) => edge.node.approval?.status,
    'cardholder_employee_access_id': (edge: CardsDataTableDataSourceType) => edge.node.cardholder?.employee?.access?.id,
    'cardholder_employee_access_avatar': (edge: CardsDataTableDataSourceType) => edge.node.cardholder?.employee?.access?.avatar,
    'cardholder_employee_access_fullName': (edge: CardsDataTableDataSourceType) => edge.node.cardholder?.employee?.access?.fullName,
    'cardholder_employee_id': (edge: CardsDataTableDataSourceType) => edge.node.cardholder?.employee?.id,
    'cardholder_employee_access': (edge: CardsDataTableDataSourceType) => edge.node.cardholder?.employee?.access,
    'cardholder_id': (edge: CardsDataTableDataSourceType) => edge.node.cardholder?.id,
    'cardholder_employee': (edge: CardsDataTableDataSourceType) => edge.node.cardholder?.employee,
    'softwareSetup_software_id': (edge: CardsDataTableDataSourceType) => edge.node.softwareSetup?.software?.id,
    'softwareSetup_software_logoUrl': (edge: CardsDataTableDataSourceType) => edge.node.softwareSetup?.software?.logoUrl,
    'softwareSetup_software_name': (edge: CardsDataTableDataSourceType) => edge.node.softwareSetup?.software?.name,
    'softwareSetup_id': (edge: CardsDataTableDataSourceType) => edge.node.softwareSetup?.id,
    'softwareSetup_software': (edge: CardsDataTableDataSourceType) => edge.node.softwareSetup?.software,
    'id': (edge: CardsDataTableDataSourceType) => edge.node.id,
    '_policies': (edge: CardsDataTableDataSourceType) => edge.node._policies,
    'alias': (edge: CardsDataTableDataSourceType) => edge.node.alias,
    'approval': (edge: CardsDataTableDataSourceType) => edge.node.approval,
    'cardholder': (edge: CardsDataTableDataSourceType) => edge.node.cardholder,
    'creationSource': (edge: CardsDataTableDataSourceType) => edge.node.creationSource,
    'expMonth': (edge: CardsDataTableDataSourceType) => edge.node.expMonth,
    'expYear': (edge: CardsDataTableDataSourceType) => edge.node.expYear,
    'last4': (edge: CardsDataTableDataSourceType) => edge.node.last4,
    'softwareSetup': (edge: CardsDataTableDataSourceType) => edge.node.softwareSetup,
    'status': (edge: CardsDataTableDataSourceType) => edge.node.status,
    'type': (edge: CardsDataTableDataSourceType) => edge.node.type,
    'createdAt': (edge: CardsDataTableDataSourceType) => edge.node.createdAt,
  }
}

export function buildCardsDataTableFilter(
  source: DataTableSource<CardsDataTableFields, typeof CardsDataTableSortableFields[number]>,
  filter: DataTableFilter<BankingCardFilter>
) {
  return filter
}

export function useCardsDataTable(
  projections: DataTableProjection<CardsDataTableFields, typeof CardsDataTableSortableFields[number]>[],
  options?: {
    variables?: CardsDataTableQueryVariables
    defaultSort?: typeof CardsDataTableSortableFields[number]
    identifier?: string
  }
): DataTableSource<CardsDataTableFields, typeof CardsDataTableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'CardsDataTable'

  return {
    identifier,
    query: CardsDataTableDocument,
    resolver: CardsDataTableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? CardsDataTableSortableFields.at(0),
      fields: CardsDataTableSortableFields,
    },
    variables
  }
}
export const ReconciliationInvoicesDataTableDocument = gql`
query ReconciliationInvoicesDataTable($companyId: Int!, $currency: String, $reconcilable: Boolean, $search: String, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: FinanceFinancialDocumentFilter) {
  finance {
    financialDocumentsConnection(
      companyId: $companyId
      currency: $currency
      operationTypes: [purchase]
      reconcilable: $reconcilable
      search: $search
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          currency
          documentDate
          documentNumber
          documentType
          expensesFinancialDocumentAssociation {
            expense {
              expensable {
                id
              }
            }
          }
          reconciliations {
            id
            reconcilableReconciledAmountCents
          }
          totalAmountCents
          vendor(companyId: $companyId) {
            id
            legalName
            name
          }
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type ReconciliationInvoicesDataTableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<ReconciliationInvoicesDataTableQuery['finance']>['financialDocumentsConnection']>['edges']
>

const ReconciliationInvoicesDataTableSortableFields = ['legalName', 'name', 'currency', 'documentDate', 'documentNumber', 'documentType', 'totalAmountCents'] as const

interface ReconciliationInvoicesDataTableFields {
  'expensesFinancialDocumentAssociation_expense_expensable_id': RevealType<['node', 'expensesFinancialDocumentAssociation', 'expense', 'expensable', 'id'], ReconciliationInvoicesDataTableDataSourceType>,
  'expensesFinancialDocumentAssociation_expense_expensable': RevealType<['node', 'expensesFinancialDocumentAssociation', 'expense', 'expensable'], ReconciliationInvoicesDataTableDataSourceType>,
  'expensesFinancialDocumentAssociation_expense': RevealType<['node', 'expensesFinancialDocumentAssociation', 'expense'], ReconciliationInvoicesDataTableDataSourceType>,
  'vendor_id': RevealType<['node', 'vendor', 'id'], ReconciliationInvoicesDataTableDataSourceType>,
  'vendor_legalName': RevealType<['node', 'vendor', 'legalName'], ReconciliationInvoicesDataTableDataSourceType>,
  'vendor_name': RevealType<['node', 'vendor', 'name'], ReconciliationInvoicesDataTableDataSourceType>,
  'id': RevealType<['node', 'id'], ReconciliationInvoicesDataTableDataSourceType>,
  'currency': RevealType<['node', 'currency'], ReconciliationInvoicesDataTableDataSourceType>,
  'documentDate': RevealType<['node', 'documentDate'], ReconciliationInvoicesDataTableDataSourceType>,
  'documentNumber': RevealType<['node', 'documentNumber'], ReconciliationInvoicesDataTableDataSourceType>,
  'documentType': RevealType<['node', 'documentType'], ReconciliationInvoicesDataTableDataSourceType>,
  'expensesFinancialDocumentAssociation': RevealType<['node', 'expensesFinancialDocumentAssociation'], ReconciliationInvoicesDataTableDataSourceType>,
  'reconciliations': RevealType<['node', 'reconciliations'], ReconciliationInvoicesDataTableDataSourceType>,
  'totalAmountCents': RevealType<['node', 'totalAmountCents'], ReconciliationInvoicesDataTableDataSourceType>,
  'vendor': RevealType<['node', 'vendor'], ReconciliationInvoicesDataTableDataSourceType>
}

const ReconciliationInvoicesDataTableResolver = {
  dataSource: (data: ReconciliationInvoicesDataTableQuery) => data.finance.financialDocumentsConnection,
  edges: (data: ReconciliationInvoicesDataTableQuery) => data.finance.financialDocumentsConnection.edges,
  fields: {
    'expensesFinancialDocumentAssociation_expense_expensable_id': (edge: ReconciliationInvoicesDataTableDataSourceType) => edge.node.expensesFinancialDocumentAssociation?.expense?.expensable?.id,
    'expensesFinancialDocumentAssociation_expense_expensable': (edge: ReconciliationInvoicesDataTableDataSourceType) => edge.node.expensesFinancialDocumentAssociation?.expense?.expensable,
    'expensesFinancialDocumentAssociation_expense': (edge: ReconciliationInvoicesDataTableDataSourceType) => edge.node.expensesFinancialDocumentAssociation?.expense,
    'vendor_id': (edge: ReconciliationInvoicesDataTableDataSourceType) => edge.node.vendor?.id,
    'vendor_legalName': (edge: ReconciliationInvoicesDataTableDataSourceType) => edge.node.vendor?.legalName,
    'vendor_name': (edge: ReconciliationInvoicesDataTableDataSourceType) => edge.node.vendor?.name,
    'id': (edge: ReconciliationInvoicesDataTableDataSourceType) => edge.node.id,
    'currency': (edge: ReconciliationInvoicesDataTableDataSourceType) => edge.node.currency,
    'documentDate': (edge: ReconciliationInvoicesDataTableDataSourceType) => edge.node.documentDate,
    'documentNumber': (edge: ReconciliationInvoicesDataTableDataSourceType) => edge.node.documentNumber,
    'documentType': (edge: ReconciliationInvoicesDataTableDataSourceType) => edge.node.documentType,
    'expensesFinancialDocumentAssociation': (edge: ReconciliationInvoicesDataTableDataSourceType) => edge.node.expensesFinancialDocumentAssociation,
    'reconciliations': (edge: ReconciliationInvoicesDataTableDataSourceType) => edge.node.reconciliations,
    'totalAmountCents': (edge: ReconciliationInvoicesDataTableDataSourceType) => edge.node.totalAmountCents,
    'vendor': (edge: ReconciliationInvoicesDataTableDataSourceType) => edge.node.vendor,
  }
}

export function buildReconciliationInvoicesDataTableFilter(
  source: DataTableSource<ReconciliationInvoicesDataTableFields, typeof ReconciliationInvoicesDataTableSortableFields[number]>,
  filter: DataTableFilter<FinanceFinancialDocumentFilter>
) {
  return filter
}

export function useReconciliationInvoicesDataTable(
  projections: DataTableProjection<ReconciliationInvoicesDataTableFields, typeof ReconciliationInvoicesDataTableSortableFields[number]>[],
  options?: {
    variables?: ReconciliationInvoicesDataTableQueryVariables
    defaultSort?: typeof ReconciliationInvoicesDataTableSortableFields[number]
    identifier?: string
  }
): DataTableSource<ReconciliationInvoicesDataTableFields, typeof ReconciliationInvoicesDataTableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'ReconciliationInvoicesDataTable'

  return {
    identifier,
    query: ReconciliationInvoicesDataTableDocument,
    resolver: ReconciliationInvoicesDataTableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? ReconciliationInvoicesDataTableSortableFields.at(0),
      fields: ReconciliationInvoicesDataTableSortableFields,
    },
    variables
  }
}
export const ReconciliationTransactionDataTableDocument = gql`
query ReconciliationTransactionDataTable($accountIds: [Int!], $currency: String, $description: String!, $status: BankingEntitiesTransactionStatusEnum!, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: BankingTransactionFilter) {
  banking {
    transactionsConnection(
      accountIds: $accountIds
      currency: $currency
      description: $description
      status: $status
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          amountCents
          bookingDate
          currency
          description
          fullyReconciledAt
          reconciliations {
            id
            transactionReconciledAmountCents
          }
          snoozedUntil
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type ReconciliationTransactionDataTableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<ReconciliationTransactionDataTableQuery['banking']>['transactionsConnection']>['edges']
>

const ReconciliationTransactionDataTableSortableFields = ['amountCents', 'bookingDate', 'currency', 'description'] as const

interface ReconciliationTransactionDataTableFields {
  'id': RevealType<['node', 'id'], ReconciliationTransactionDataTableDataSourceType>,
  'amountCents': RevealType<['node', 'amountCents'], ReconciliationTransactionDataTableDataSourceType>,
  'bookingDate': RevealType<['node', 'bookingDate'], ReconciliationTransactionDataTableDataSourceType>,
  'currency': RevealType<['node', 'currency'], ReconciliationTransactionDataTableDataSourceType>,
  'description': RevealType<['node', 'description'], ReconciliationTransactionDataTableDataSourceType>,
  'fullyReconciledAt': RevealType<['node', 'fullyReconciledAt'], ReconciliationTransactionDataTableDataSourceType>,
  'reconciliations': RevealType<['node', 'reconciliations'], ReconciliationTransactionDataTableDataSourceType>,
  'snoozedUntil': RevealType<['node', 'snoozedUntil'], ReconciliationTransactionDataTableDataSourceType>
}

const ReconciliationTransactionDataTableResolver = {
  dataSource: (data: ReconciliationTransactionDataTableQuery) => data.banking.transactionsConnection,
  edges: (data: ReconciliationTransactionDataTableQuery) => data.banking.transactionsConnection.edges,
  fields: {
    'id': (edge: ReconciliationTransactionDataTableDataSourceType) => edge.node.id,
    'amountCents': (edge: ReconciliationTransactionDataTableDataSourceType) => edge.node.amountCents,
    'bookingDate': (edge: ReconciliationTransactionDataTableDataSourceType) => edge.node.bookingDate,
    'currency': (edge: ReconciliationTransactionDataTableDataSourceType) => edge.node.currency,
    'description': (edge: ReconciliationTransactionDataTableDataSourceType) => edge.node.description,
    'fullyReconciledAt': (edge: ReconciliationTransactionDataTableDataSourceType) => edge.node.fullyReconciledAt,
    'reconciliations': (edge: ReconciliationTransactionDataTableDataSourceType) => edge.node.reconciliations,
    'snoozedUntil': (edge: ReconciliationTransactionDataTableDataSourceType) => edge.node.snoozedUntil,
  }
}

export function buildReconciliationTransactionDataTableFilter(
  source: DataTableSource<ReconciliationTransactionDataTableFields, typeof ReconciliationTransactionDataTableSortableFields[number]>,
  filter: DataTableFilter<BankingTransactionFilter>
) {
  return filter
}

export function useReconciliationTransactionDataTable(
  projections: DataTableProjection<ReconciliationTransactionDataTableFields, typeof ReconciliationTransactionDataTableSortableFields[number]>[],
  options?: {
    variables?: ReconciliationTransactionDataTableQueryVariables
    defaultSort?: typeof ReconciliationTransactionDataTableSortableFields[number]
    identifier?: string
  }
): DataTableSource<ReconciliationTransactionDataTableFields, typeof ReconciliationTransactionDataTableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'ReconciliationTransactionDataTable'

  return {
    identifier,
    query: ReconciliationTransactionDataTableDocument,
    resolver: ReconciliationTransactionDataTableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? ReconciliationTransactionDataTableSortableFields.at(0),
      fields: ReconciliationTransactionDataTableSortableFields,
    },
    variables
  }
}
export const TransactionDataTableDocument = gql`
query TransactionDataTable($accountIds: [Int!], $description: String!, $status: BankingEntitiesTransactionStatusEnum!, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: BankingTransactionFilter) {
  banking {
    transactionsConnection(
      accountIds: $accountIds
      description: $description
      status: $status
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          amountCents
          balanceAfterCents
          bookingDate
          cardPayment {
            id
            card {
              id
              creationSource
              last4
            }
          }
          category {
            id
            label
          }
          currency
          description
          type
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type TransactionDataTableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<TransactionDataTableQuery['banking']>['transactionsConnection']>['edges']
>

const TransactionDataTableSortableFields = ['id', 'creationSource', 'id', 'label', 'amountCents', 'bookingDate', 'currency', 'description', 'type'] as const

interface TransactionDataTableFields {
  'cardPayment_card_id': RevealType<['node', 'cardPayment', 'card', 'id'], TransactionDataTableDataSourceType>,
  'cardPayment_card_creationSource': RevealType<['node', 'cardPayment', 'card', 'creationSource'], TransactionDataTableDataSourceType>,
  'cardPayment_card_last4': RevealType<['node', 'cardPayment', 'card', 'last4'], TransactionDataTableDataSourceType>,
  'cardPayment_id': RevealType<['node', 'cardPayment', 'id'], TransactionDataTableDataSourceType>,
  'cardPayment_card': RevealType<['node', 'cardPayment', 'card'], TransactionDataTableDataSourceType>,
  'category_id': RevealType<['node', 'category', 'id'], TransactionDataTableDataSourceType>,
  'category_label': RevealType<['node', 'category', 'label'], TransactionDataTableDataSourceType>,
  'id': RevealType<['node', 'id'], TransactionDataTableDataSourceType>,
  'amountCents': RevealType<['node', 'amountCents'], TransactionDataTableDataSourceType>,
  'balanceAfterCents': RevealType<['node', 'balanceAfterCents'], TransactionDataTableDataSourceType>,
  'bookingDate': RevealType<['node', 'bookingDate'], TransactionDataTableDataSourceType>,
  'cardPayment': RevealType<['node', 'cardPayment'], TransactionDataTableDataSourceType>,
  'category': RevealType<['node', 'category'], TransactionDataTableDataSourceType>,
  'currency': RevealType<['node', 'currency'], TransactionDataTableDataSourceType>,
  'description': RevealType<['node', 'description'], TransactionDataTableDataSourceType>,
  'type': RevealType<['node', 'type'], TransactionDataTableDataSourceType>
}

const TransactionDataTableResolver = {
  dataSource: (data: TransactionDataTableQuery) => data.banking.transactionsConnection,
  edges: (data: TransactionDataTableQuery) => data.banking.transactionsConnection.edges,
  fields: {
    'cardPayment_card_id': (edge: TransactionDataTableDataSourceType) => edge.node.cardPayment?.card?.id,
    'cardPayment_card_creationSource': (edge: TransactionDataTableDataSourceType) => edge.node.cardPayment?.card?.creationSource,
    'cardPayment_card_last4': (edge: TransactionDataTableDataSourceType) => edge.node.cardPayment?.card?.last4,
    'cardPayment_id': (edge: TransactionDataTableDataSourceType) => edge.node.cardPayment?.id,
    'cardPayment_card': (edge: TransactionDataTableDataSourceType) => edge.node.cardPayment?.card,
    'category_id': (edge: TransactionDataTableDataSourceType) => edge.node.category?.id,
    'category_label': (edge: TransactionDataTableDataSourceType) => edge.node.category?.label,
    'id': (edge: TransactionDataTableDataSourceType) => edge.node.id,
    'amountCents': (edge: TransactionDataTableDataSourceType) => edge.node.amountCents,
    'balanceAfterCents': (edge: TransactionDataTableDataSourceType) => edge.node.balanceAfterCents,
    'bookingDate': (edge: TransactionDataTableDataSourceType) => edge.node.bookingDate,
    'cardPayment': (edge: TransactionDataTableDataSourceType) => edge.node.cardPayment,
    'category': (edge: TransactionDataTableDataSourceType) => edge.node.category,
    'currency': (edge: TransactionDataTableDataSourceType) => edge.node.currency,
    'description': (edge: TransactionDataTableDataSourceType) => edge.node.description,
    'type': (edge: TransactionDataTableDataSourceType) => edge.node.type,
  }
}

export function buildTransactionDataTableFilter(
  source: DataTableSource<TransactionDataTableFields, typeof TransactionDataTableSortableFields[number]>,
  filter: DataTableFilter<BankingTransactionFilter>
) {
  return filter
}

export function useTransactionDataTable(
  projections: DataTableProjection<TransactionDataTableFields, typeof TransactionDataTableSortableFields[number]>[],
  options?: {
    variables?: TransactionDataTableQueryVariables
    defaultSort?: typeof TransactionDataTableSortableFields[number]
    identifier?: string
  }
): DataTableSource<TransactionDataTableFields, typeof TransactionDataTableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'TransactionDataTable'

  return {
    identifier,
    query: TransactionDataTableDocument,
    resolver: TransactionDataTableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? TransactionDataTableSortableFields.at(0),
      fields: TransactionDataTableSortableFields,
    },
    variables
  }
}
export const BookkeepersManagementIncidenceDataTableDocument = gql`
query BookkeepersManagementIncidenceDataTable($projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort) {
  bookkeepersManagement {
    incidencesConnection(
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          customName
          employee {
            id
            firstName
            fullName
            lastName
          }
          hasMessage
          isReopened
          legalEntity {
            id
            company {
              id
            }
            legalName
          }
          messageFrom
          name
          readAt
          startsOn
          status
          targetId
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type BookkeepersManagementIncidenceDataTableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<BookkeepersManagementIncidenceDataTableQuery['bookkeepersManagement']>['incidencesConnection']>['edges']
>

const BookkeepersManagementIncidenceDataTableSortableFields = ['id', 'firstName', 'fullName', 'lastName', 'legalName'] as const

interface BookkeepersManagementIncidenceDataTableFields {
  'employee_id': RevealType<['node', 'employee', 'id'], BookkeepersManagementIncidenceDataTableDataSourceType>,
  'employee_firstName': RevealType<['node', 'employee', 'firstName'], BookkeepersManagementIncidenceDataTableDataSourceType>,
  'employee_fullName': RevealType<['node', 'employee', 'fullName'], BookkeepersManagementIncidenceDataTableDataSourceType>,
  'employee_lastName': RevealType<['node', 'employee', 'lastName'], BookkeepersManagementIncidenceDataTableDataSourceType>,
  'legalEntity_company_id': RevealType<['node', 'legalEntity', 'company', 'id'], BookkeepersManagementIncidenceDataTableDataSourceType>,
  'legalEntity_id': RevealType<['node', 'legalEntity', 'id'], BookkeepersManagementIncidenceDataTableDataSourceType>,
  'legalEntity_company': RevealType<['node', 'legalEntity', 'company'], BookkeepersManagementIncidenceDataTableDataSourceType>,
  'legalEntity_legalName': RevealType<['node', 'legalEntity', 'legalName'], BookkeepersManagementIncidenceDataTableDataSourceType>,
  'id': RevealType<['node', 'id'], BookkeepersManagementIncidenceDataTableDataSourceType>,
  'customName': RevealType<['node', 'customName'], BookkeepersManagementIncidenceDataTableDataSourceType>,
  'employee': RevealType<['node', 'employee'], BookkeepersManagementIncidenceDataTableDataSourceType>,
  'hasMessage': RevealType<['node', 'hasMessage'], BookkeepersManagementIncidenceDataTableDataSourceType>,
  'isReopened': RevealType<['node', 'isReopened'], BookkeepersManagementIncidenceDataTableDataSourceType>,
  'legalEntity': RevealType<['node', 'legalEntity'], BookkeepersManagementIncidenceDataTableDataSourceType>,
  'messageFrom': RevealType<['node', 'messageFrom'], BookkeepersManagementIncidenceDataTableDataSourceType>,
  'name': RevealType<['node', 'name'], BookkeepersManagementIncidenceDataTableDataSourceType>,
  'readAt': RevealType<['node', 'readAt'], BookkeepersManagementIncidenceDataTableDataSourceType>,
  'startsOn': RevealType<['node', 'startsOn'], BookkeepersManagementIncidenceDataTableDataSourceType>,
  'status': RevealType<['node', 'status'], BookkeepersManagementIncidenceDataTableDataSourceType>,
  'targetId': RevealType<['node', 'targetId'], BookkeepersManagementIncidenceDataTableDataSourceType>
}

const BookkeepersManagementIncidenceDataTableResolver = {
  dataSource: (data: BookkeepersManagementIncidenceDataTableQuery) => data.bookkeepersManagement.incidencesConnection,
  edges: (data: BookkeepersManagementIncidenceDataTableQuery) => data.bookkeepersManagement.incidencesConnection.edges,
  fields: {
    'employee_id': (edge: BookkeepersManagementIncidenceDataTableDataSourceType) => edge.node.employee?.id,
    'employee_firstName': (edge: BookkeepersManagementIncidenceDataTableDataSourceType) => edge.node.employee?.firstName,
    'employee_fullName': (edge: BookkeepersManagementIncidenceDataTableDataSourceType) => edge.node.employee?.fullName,
    'employee_lastName': (edge: BookkeepersManagementIncidenceDataTableDataSourceType) => edge.node.employee?.lastName,
    'legalEntity_company_id': (edge: BookkeepersManagementIncidenceDataTableDataSourceType) => edge.node.legalEntity?.company?.id,
    'legalEntity_id': (edge: BookkeepersManagementIncidenceDataTableDataSourceType) => edge.node.legalEntity?.id,
    'legalEntity_company': (edge: BookkeepersManagementIncidenceDataTableDataSourceType) => edge.node.legalEntity?.company,
    'legalEntity_legalName': (edge: BookkeepersManagementIncidenceDataTableDataSourceType) => edge.node.legalEntity?.legalName,
    'id': (edge: BookkeepersManagementIncidenceDataTableDataSourceType) => edge.node.id,
    'customName': (edge: BookkeepersManagementIncidenceDataTableDataSourceType) => edge.node.customName,
    'employee': (edge: BookkeepersManagementIncidenceDataTableDataSourceType) => edge.node.employee,
    'hasMessage': (edge: BookkeepersManagementIncidenceDataTableDataSourceType) => edge.node.hasMessage,
    'isReopened': (edge: BookkeepersManagementIncidenceDataTableDataSourceType) => edge.node.isReopened,
    'legalEntity': (edge: BookkeepersManagementIncidenceDataTableDataSourceType) => edge.node.legalEntity,
    'messageFrom': (edge: BookkeepersManagementIncidenceDataTableDataSourceType) => edge.node.messageFrom,
    'name': (edge: BookkeepersManagementIncidenceDataTableDataSourceType) => edge.node.name,
    'readAt': (edge: BookkeepersManagementIncidenceDataTableDataSourceType) => edge.node.readAt,
    'startsOn': (edge: BookkeepersManagementIncidenceDataTableDataSourceType) => edge.node.startsOn,
    'status': (edge: BookkeepersManagementIncidenceDataTableDataSourceType) => edge.node.status,
    'targetId': (edge: BookkeepersManagementIncidenceDataTableDataSourceType) => edge.node.targetId,
  }
}

export function useBookkeepersManagementIncidenceDataTable(
  projections: DataTableProjection<BookkeepersManagementIncidenceDataTableFields, typeof BookkeepersManagementIncidenceDataTableSortableFields[number]>[],
  options?: {
    variables?: BookkeepersManagementIncidenceDataTableQueryVariables
    defaultSort?: typeof BookkeepersManagementIncidenceDataTableSortableFields[number]
    identifier?: string
  }
): DataTableSource<BookkeepersManagementIncidenceDataTableFields, typeof BookkeepersManagementIncidenceDataTableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'BookkeepersManagementIncidenceDataTable'

  return {
    identifier,
    query: BookkeepersManagementIncidenceDataTableDocument,
    resolver: BookkeepersManagementIncidenceDataTableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? BookkeepersManagementIncidenceDataTableSortableFields.at(0),
      fields: BookkeepersManagementIncidenceDataTableSortableFields,
    },
    variables
  }
}
export const BookkeepersManagementPayrollResultsDataTableDocument = gql`
query BookkeepersManagementPayrollResultsDataTable($companyIds: [Int!], $periodEndsOn: ISO8601Date, $periodStartsOn: ISO8601Date, $status: [String!], $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: PayrollPolicyPeriodFilter) {
  payroll {
    policyPeriodsConnection(
      companyIds: $companyIds
      periodEndsOn: $periodEndsOn
      periodStartsOn: $periodStartsOn
      status: $status
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          endsOn
          policy {
            id
            company {
              id
              name
            }
            name
            recurrence
          }
          startsOn
          status
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type BookkeepersManagementPayrollResultsDataTableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<BookkeepersManagementPayrollResultsDataTableQuery['payroll']>['policyPeriodsConnection']>['edges']
>

const BookkeepersManagementPayrollResultsDataTableSortableFields = ['startsOn'] as const

interface BookkeepersManagementPayrollResultsDataTableFields {
  'policy_company_id': RevealType<['node', 'policy', 'company', 'id'], BookkeepersManagementPayrollResultsDataTableDataSourceType>,
  'policy_company_name': RevealType<['node', 'policy', 'company', 'name'], BookkeepersManagementPayrollResultsDataTableDataSourceType>,
  'policy_id': RevealType<['node', 'policy', 'id'], BookkeepersManagementPayrollResultsDataTableDataSourceType>,
  'policy_company': RevealType<['node', 'policy', 'company'], BookkeepersManagementPayrollResultsDataTableDataSourceType>,
  'policy_name': RevealType<['node', 'policy', 'name'], BookkeepersManagementPayrollResultsDataTableDataSourceType>,
  'policy_recurrence': RevealType<['node', 'policy', 'recurrence'], BookkeepersManagementPayrollResultsDataTableDataSourceType>,
  'id': RevealType<['node', 'id'], BookkeepersManagementPayrollResultsDataTableDataSourceType>,
  'endsOn': RevealType<['node', 'endsOn'], BookkeepersManagementPayrollResultsDataTableDataSourceType>,
  'policy': RevealType<['node', 'policy'], BookkeepersManagementPayrollResultsDataTableDataSourceType>,
  'startsOn': RevealType<['node', 'startsOn'], BookkeepersManagementPayrollResultsDataTableDataSourceType>,
  'status': RevealType<['node', 'status'], BookkeepersManagementPayrollResultsDataTableDataSourceType>
}

const BookkeepersManagementPayrollResultsDataTableResolver = {
  dataSource: (data: BookkeepersManagementPayrollResultsDataTableQuery) => data.payroll.policyPeriodsConnection,
  edges: (data: BookkeepersManagementPayrollResultsDataTableQuery) => data.payroll.policyPeriodsConnection.edges,
  fields: {
    'policy_company_id': (edge: BookkeepersManagementPayrollResultsDataTableDataSourceType) => edge.node.policy?.company?.id,
    'policy_company_name': (edge: BookkeepersManagementPayrollResultsDataTableDataSourceType) => edge.node.policy?.company?.name,
    'policy_id': (edge: BookkeepersManagementPayrollResultsDataTableDataSourceType) => edge.node.policy?.id,
    'policy_company': (edge: BookkeepersManagementPayrollResultsDataTableDataSourceType) => edge.node.policy?.company,
    'policy_name': (edge: BookkeepersManagementPayrollResultsDataTableDataSourceType) => edge.node.policy?.name,
    'policy_recurrence': (edge: BookkeepersManagementPayrollResultsDataTableDataSourceType) => edge.node.policy?.recurrence,
    'id': (edge: BookkeepersManagementPayrollResultsDataTableDataSourceType) => edge.node.id,
    'endsOn': (edge: BookkeepersManagementPayrollResultsDataTableDataSourceType) => edge.node.endsOn,
    'policy': (edge: BookkeepersManagementPayrollResultsDataTableDataSourceType) => edge.node.policy,
    'startsOn': (edge: BookkeepersManagementPayrollResultsDataTableDataSourceType) => edge.node.startsOn,
    'status': (edge: BookkeepersManagementPayrollResultsDataTableDataSourceType) => edge.node.status,
  }
}

export function buildBookkeepersManagementPayrollResultsDataTableFilter(
  source: DataTableSource<BookkeepersManagementPayrollResultsDataTableFields, typeof BookkeepersManagementPayrollResultsDataTableSortableFields[number]>,
  filter: DataTableFilter<PayrollPolicyPeriodFilter>
) {
  return filter
}

export function useBookkeepersManagementPayrollResultsDataTable(
  projections: DataTableProjection<BookkeepersManagementPayrollResultsDataTableFields, typeof BookkeepersManagementPayrollResultsDataTableSortableFields[number]>[],
  options?: {
    variables?: BookkeepersManagementPayrollResultsDataTableQueryVariables
    defaultSort?: typeof BookkeepersManagementPayrollResultsDataTableSortableFields[number]
    identifier?: string
  }
): DataTableSource<BookkeepersManagementPayrollResultsDataTableFields, typeof BookkeepersManagementPayrollResultsDataTableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'BookkeepersManagementPayrollResultsDataTable'

  return {
    identifier,
    query: BookkeepersManagementPayrollResultsDataTableDocument,
    resolver: BookkeepersManagementPayrollResultsDataTableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? BookkeepersManagementPayrollResultsDataTableSortableFields.at(0),
      fields: BookkeepersManagementPayrollResultsDataTableSortableFields,
    },
    variables
  }
}
export const WorkingConditionsVersionEmployeesDocument = gql`
query WorkingConditionsVersionEmployees($versionId: Int!, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: WorkingConditionsVersionApplicationFilter) {
  workingConditions {
    versionApplicationsConnection(
      workingConditionVersionIds: [$versionId]
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          contractVersion {
            id
            employee(includeDenormalizedData: true) {
              id
              avatar {
                id
                url
              }
              firstName
              lastName
              locationId
              locationName
            }
            jobCatalogLevel {
              id
              name
              roleName
            }
            jobTitle
          }
          differentFieldsCount
          version {
            id
            description
            name
          }
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type WorkingConditionsVersionEmployeesDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<WorkingConditionsVersionEmployeesQuery['workingConditions']>['versionApplicationsConnection']>['edges']
>

const WorkingConditionsVersionEmployeesSortableFields = ['id', 'firstName', 'lastName', 'locationId', 'id'] as const

interface WorkingConditionsVersionEmployeesFields {
  'contractVersion_employee_avatar_id': RevealType<['node', 'contractVersion', 'employee', 'avatar', 'id'], WorkingConditionsVersionEmployeesDataSourceType>,
  'contractVersion_employee_avatar_url': RevealType<['node', 'contractVersion', 'employee', 'avatar', 'url'], WorkingConditionsVersionEmployeesDataSourceType>,
  'contractVersion_employee_id': RevealType<['node', 'contractVersion', 'employee', 'id'], WorkingConditionsVersionEmployeesDataSourceType>,
  'contractVersion_employee_avatar': RevealType<['node', 'contractVersion', 'employee', 'avatar'], WorkingConditionsVersionEmployeesDataSourceType>,
  'contractVersion_employee_firstName': RevealType<['node', 'contractVersion', 'employee', 'firstName'], WorkingConditionsVersionEmployeesDataSourceType>,
  'contractVersion_employee_lastName': RevealType<['node', 'contractVersion', 'employee', 'lastName'], WorkingConditionsVersionEmployeesDataSourceType>,
  'contractVersion_employee_locationId': RevealType<['node', 'contractVersion', 'employee', 'locationId'], WorkingConditionsVersionEmployeesDataSourceType>,
  'contractVersion_employee_locationName': RevealType<['node', 'contractVersion', 'employee', 'locationName'], WorkingConditionsVersionEmployeesDataSourceType>,
  'contractVersion_jobCatalogLevel_id': RevealType<['node', 'contractVersion', 'jobCatalogLevel', 'id'], WorkingConditionsVersionEmployeesDataSourceType>,
  'contractVersion_jobCatalogLevel_name': RevealType<['node', 'contractVersion', 'jobCatalogLevel', 'name'], WorkingConditionsVersionEmployeesDataSourceType>,
  'contractVersion_jobCatalogLevel_roleName': RevealType<['node', 'contractVersion', 'jobCatalogLevel', 'roleName'], WorkingConditionsVersionEmployeesDataSourceType>,
  'contractVersion_id': RevealType<['node', 'contractVersion', 'id'], WorkingConditionsVersionEmployeesDataSourceType>,
  'contractVersion_employee': RevealType<['node', 'contractVersion', 'employee'], WorkingConditionsVersionEmployeesDataSourceType>,
  'contractVersion_jobCatalogLevel': RevealType<['node', 'contractVersion', 'jobCatalogLevel'], WorkingConditionsVersionEmployeesDataSourceType>,
  'contractVersion_jobTitle': RevealType<['node', 'contractVersion', 'jobTitle'], WorkingConditionsVersionEmployeesDataSourceType>,
  'version_id': RevealType<['node', 'version', 'id'], WorkingConditionsVersionEmployeesDataSourceType>,
  'version_description': RevealType<['node', 'version', 'description'], WorkingConditionsVersionEmployeesDataSourceType>,
  'version_name': RevealType<['node', 'version', 'name'], WorkingConditionsVersionEmployeesDataSourceType>,
  'id': RevealType<['node', 'id'], WorkingConditionsVersionEmployeesDataSourceType>,
  'contractVersion': RevealType<['node', 'contractVersion'], WorkingConditionsVersionEmployeesDataSourceType>,
  'differentFieldsCount': RevealType<['node', 'differentFieldsCount'], WorkingConditionsVersionEmployeesDataSourceType>,
  'version': RevealType<['node', 'version'], WorkingConditionsVersionEmployeesDataSourceType>
}

const WorkingConditionsVersionEmployeesResolver = {
  dataSource: (data: WorkingConditionsVersionEmployeesQuery) => data.workingConditions.versionApplicationsConnection,
  edges: (data: WorkingConditionsVersionEmployeesQuery) => data.workingConditions.versionApplicationsConnection.edges,
  fields: {
    'contractVersion_employee_avatar_id': (edge: WorkingConditionsVersionEmployeesDataSourceType) => edge.node.contractVersion?.employee?.avatar?.id,
    'contractVersion_employee_avatar_url': (edge: WorkingConditionsVersionEmployeesDataSourceType) => edge.node.contractVersion?.employee?.avatar?.url,
    'contractVersion_employee_id': (edge: WorkingConditionsVersionEmployeesDataSourceType) => edge.node.contractVersion?.employee?.id,
    'contractVersion_employee_avatar': (edge: WorkingConditionsVersionEmployeesDataSourceType) => edge.node.contractVersion?.employee?.avatar,
    'contractVersion_employee_firstName': (edge: WorkingConditionsVersionEmployeesDataSourceType) => edge.node.contractVersion?.employee?.firstName,
    'contractVersion_employee_lastName': (edge: WorkingConditionsVersionEmployeesDataSourceType) => edge.node.contractVersion?.employee?.lastName,
    'contractVersion_employee_locationId': (edge: WorkingConditionsVersionEmployeesDataSourceType) => edge.node.contractVersion?.employee?.locationId,
    'contractVersion_employee_locationName': (edge: WorkingConditionsVersionEmployeesDataSourceType) => edge.node.contractVersion?.employee?.locationName,
    'contractVersion_jobCatalogLevel_id': (edge: WorkingConditionsVersionEmployeesDataSourceType) => edge.node.contractVersion?.jobCatalogLevel?.id,
    'contractVersion_jobCatalogLevel_name': (edge: WorkingConditionsVersionEmployeesDataSourceType) => edge.node.contractVersion?.jobCatalogLevel?.name,
    'contractVersion_jobCatalogLevel_roleName': (edge: WorkingConditionsVersionEmployeesDataSourceType) => edge.node.contractVersion?.jobCatalogLevel?.roleName,
    'contractVersion_id': (edge: WorkingConditionsVersionEmployeesDataSourceType) => edge.node.contractVersion?.id,
    'contractVersion_employee': (edge: WorkingConditionsVersionEmployeesDataSourceType) => edge.node.contractVersion?.employee,
    'contractVersion_jobCatalogLevel': (edge: WorkingConditionsVersionEmployeesDataSourceType) => edge.node.contractVersion?.jobCatalogLevel,
    'contractVersion_jobTitle': (edge: WorkingConditionsVersionEmployeesDataSourceType) => edge.node.contractVersion?.jobTitle,
    'version_id': (edge: WorkingConditionsVersionEmployeesDataSourceType) => edge.node.version?.id,
    'version_description': (edge: WorkingConditionsVersionEmployeesDataSourceType) => edge.node.version?.description,
    'version_name': (edge: WorkingConditionsVersionEmployeesDataSourceType) => edge.node.version?.name,
    'id': (edge: WorkingConditionsVersionEmployeesDataSourceType) => edge.node.id,
    'contractVersion': (edge: WorkingConditionsVersionEmployeesDataSourceType) => edge.node.contractVersion,
    'differentFieldsCount': (edge: WorkingConditionsVersionEmployeesDataSourceType) => edge.node.differentFieldsCount,
    'version': (edge: WorkingConditionsVersionEmployeesDataSourceType) => edge.node.version,
  }
}

export function buildWorkingConditionsVersionEmployeesFilter(
  source: DataTableSource<WorkingConditionsVersionEmployeesFields, typeof WorkingConditionsVersionEmployeesSortableFields[number]>,
  filter: DataTableFilter<WorkingConditionsVersionApplicationFilter>
) {
  return filter
}

export function useWorkingConditionsVersionEmployees(
  projections: DataTableProjection<WorkingConditionsVersionEmployeesFields, typeof WorkingConditionsVersionEmployeesSortableFields[number]>[],
  options?: {
    variables?: WorkingConditionsVersionEmployeesQueryVariables
    defaultSort?: typeof WorkingConditionsVersionEmployeesSortableFields[number]
    identifier?: string
  }
): DataTableSource<WorkingConditionsVersionEmployeesFields, typeof WorkingConditionsVersionEmployeesSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'WorkingConditionsVersionEmployees'

  return {
    identifier,
    query: WorkingConditionsVersionEmployeesDocument,
    resolver: WorkingConditionsVersionEmployeesResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? WorkingConditionsVersionEmployeesSortableFields.at(0),
      fields: WorkingConditionsVersionEmployeesSortableFields,
    },
    variables
  }
}
export const DocumentsDataTableDocument = gql`
query DocumentsDataTable($byTrashBin: Boolean, $byWithoutFolder: Boolean, $employeeId: Int, $folderId: Int, $search: String, $space: String, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: DocumentsDocumentFilter) {
  documents {
    documentsConnection(
      byTrashBin: $byTrashBin
      byWithoutFolder: $byWithoutFolder
      employeeId: $employeeId
      folderId: $folderId
      search: $search
      space: $space
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          _policies {
            edit {
              can
            }
          }
          arCreatedAt
          author {
            id
            fullName
          }
          company {
            id
          }
          contentType
          deletedAt
          employee {
            id
            access {
              id
              avatar
              firstName
              fullName
              lastName
            }
            avatar {
              url
            }
            fullName
          }
          extension
          file
          filename
          fileSize
          fileUrl
          folder {
            id
            name
            rootParentFolder {
              id
              name
            }
            showOnly
          }
          fromTemplate
          incidenceMessageId
          isCompanyDocument
          isPendingAssignment
          leaveId
          notificationStatus
          permissionUpdate
          public
          signatureStatus
          signees
          space
          status
          templateId
          type
          createdAt
          updatedAt
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type DocumentsDataTableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<DocumentsDataTableQuery['documents']>['documentsConnection']>['edges']
>

const DocumentsDataTableSortableFields = ['id', 'id', 'firstName', 'id', 'fullName', 'name', 'name', 'deletedAt', 'filename', 'createdAt'] as const

interface DocumentsDataTableFields {
  '_policies_edit_can': RevealType<['node', '_policies', 'edit', 'can'], DocumentsDataTableDataSourceType>,
  '_policies_edit': RevealType<['node', '_policies', 'edit'], DocumentsDataTableDataSourceType>,
  'author_id': RevealType<['node', 'author', 'id'], DocumentsDataTableDataSourceType>,
  'author_fullName': RevealType<['node', 'author', 'fullName'], DocumentsDataTableDataSourceType>,
  'company_id': RevealType<['node', 'company', 'id'], DocumentsDataTableDataSourceType>,
  'employee_access_id': RevealType<['node', 'employee', 'access', 'id'], DocumentsDataTableDataSourceType>,
  'employee_access_avatar': RevealType<['node', 'employee', 'access', 'avatar'], DocumentsDataTableDataSourceType>,
  'employee_access_firstName': RevealType<['node', 'employee', 'access', 'firstName'], DocumentsDataTableDataSourceType>,
  'employee_access_fullName': RevealType<['node', 'employee', 'access', 'fullName'], DocumentsDataTableDataSourceType>,
  'employee_access_lastName': RevealType<['node', 'employee', 'access', 'lastName'], DocumentsDataTableDataSourceType>,
  'employee_avatar_url': RevealType<['node', 'employee', 'avatar', 'url'], DocumentsDataTableDataSourceType>,
  'employee_id': RevealType<['node', 'employee', 'id'], DocumentsDataTableDataSourceType>,
  'employee_access': RevealType<['node', 'employee', 'access'], DocumentsDataTableDataSourceType>,
  'employee_avatar': RevealType<['node', 'employee', 'avatar'], DocumentsDataTableDataSourceType>,
  'employee_fullName': RevealType<['node', 'employee', 'fullName'], DocumentsDataTableDataSourceType>,
  'folder_rootParentFolder_id': RevealType<['node', 'folder', 'rootParentFolder', 'id'], DocumentsDataTableDataSourceType>,
  'folder_rootParentFolder_name': RevealType<['node', 'folder', 'rootParentFolder', 'name'], DocumentsDataTableDataSourceType>,
  'folder_id': RevealType<['node', 'folder', 'id'], DocumentsDataTableDataSourceType>,
  'folder_name': RevealType<['node', 'folder', 'name'], DocumentsDataTableDataSourceType>,
  'folder_rootParentFolder': RevealType<['node', 'folder', 'rootParentFolder'], DocumentsDataTableDataSourceType>,
  'folder_showOnly': RevealType<['node', 'folder', 'showOnly'], DocumentsDataTableDataSourceType>,
  'id': RevealType<['node', 'id'], DocumentsDataTableDataSourceType>,
  '_policies': RevealType<['node', '_policies'], DocumentsDataTableDataSourceType>,
  'arCreatedAt': RevealType<['node', 'arCreatedAt'], DocumentsDataTableDataSourceType>,
  'author': RevealType<['node', 'author'], DocumentsDataTableDataSourceType>,
  'company': RevealType<['node', 'company'], DocumentsDataTableDataSourceType>,
  'contentType': RevealType<['node', 'contentType'], DocumentsDataTableDataSourceType>,
  'deletedAt': RevealType<['node', 'deletedAt'], DocumentsDataTableDataSourceType>,
  'employee': RevealType<['node', 'employee'], DocumentsDataTableDataSourceType>,
  'extension': RevealType<['node', 'extension'], DocumentsDataTableDataSourceType>,
  'file': RevealType<['node', 'file'], DocumentsDataTableDataSourceType>,
  'filename': RevealType<['node', 'filename'], DocumentsDataTableDataSourceType>,
  'fileSize': RevealType<['node', 'fileSize'], DocumentsDataTableDataSourceType>,
  'fileUrl': RevealType<['node', 'fileUrl'], DocumentsDataTableDataSourceType>,
  'folder': RevealType<['node', 'folder'], DocumentsDataTableDataSourceType>,
  'fromTemplate': RevealType<['node', 'fromTemplate'], DocumentsDataTableDataSourceType>,
  'incidenceMessageId': RevealType<['node', 'incidenceMessageId'], DocumentsDataTableDataSourceType>,
  'isCompanyDocument': RevealType<['node', 'isCompanyDocument'], DocumentsDataTableDataSourceType>,
  'isPendingAssignment': RevealType<['node', 'isPendingAssignment'], DocumentsDataTableDataSourceType>,
  'leaveId': RevealType<['node', 'leaveId'], DocumentsDataTableDataSourceType>,
  'notificationStatus': RevealType<['node', 'notificationStatus'], DocumentsDataTableDataSourceType>,
  'permissionUpdate': RevealType<['node', 'permissionUpdate'], DocumentsDataTableDataSourceType>,
  'public': RevealType<['node', 'public'], DocumentsDataTableDataSourceType>,
  'signatureStatus': RevealType<['node', 'signatureStatus'], DocumentsDataTableDataSourceType>,
  'signees': RevealType<['node', 'signees'], DocumentsDataTableDataSourceType>,
  'space': RevealType<['node', 'space'], DocumentsDataTableDataSourceType>,
  'status': RevealType<['node', 'status'], DocumentsDataTableDataSourceType>,
  'templateId': RevealType<['node', 'templateId'], DocumentsDataTableDataSourceType>,
  'type': RevealType<['node', 'type'], DocumentsDataTableDataSourceType>,
  'createdAt': RevealType<['node', 'createdAt'], DocumentsDataTableDataSourceType>,
  'updatedAt': RevealType<['node', 'updatedAt'], DocumentsDataTableDataSourceType>
}

const DocumentsDataTableResolver = {
  dataSource: (data: DocumentsDataTableQuery) => data.documents.documentsConnection,
  edges: (data: DocumentsDataTableQuery) => data.documents.documentsConnection.edges,
  fields: {
    '_policies_edit_can': (edge: DocumentsDataTableDataSourceType) => edge.node._policies?.edit?.can,
    '_policies_edit': (edge: DocumentsDataTableDataSourceType) => edge.node._policies?.edit,
    'author_id': (edge: DocumentsDataTableDataSourceType) => edge.node.author?.id,
    'author_fullName': (edge: DocumentsDataTableDataSourceType) => edge.node.author?.fullName,
    'company_id': (edge: DocumentsDataTableDataSourceType) => edge.node.company?.id,
    'employee_access_id': (edge: DocumentsDataTableDataSourceType) => edge.node.employee?.access?.id,
    'employee_access_avatar': (edge: DocumentsDataTableDataSourceType) => edge.node.employee?.access?.avatar,
    'employee_access_firstName': (edge: DocumentsDataTableDataSourceType) => edge.node.employee?.access?.firstName,
    'employee_access_fullName': (edge: DocumentsDataTableDataSourceType) => edge.node.employee?.access?.fullName,
    'employee_access_lastName': (edge: DocumentsDataTableDataSourceType) => edge.node.employee?.access?.lastName,
    'employee_avatar_url': (edge: DocumentsDataTableDataSourceType) => edge.node.employee?.avatar?.url,
    'employee_id': (edge: DocumentsDataTableDataSourceType) => edge.node.employee?.id,
    'employee_access': (edge: DocumentsDataTableDataSourceType) => edge.node.employee?.access,
    'employee_avatar': (edge: DocumentsDataTableDataSourceType) => edge.node.employee?.avatar,
    'employee_fullName': (edge: DocumentsDataTableDataSourceType) => edge.node.employee?.fullName,
    'folder_rootParentFolder_id': (edge: DocumentsDataTableDataSourceType) => edge.node.folder?.rootParentFolder?.id,
    'folder_rootParentFolder_name': (edge: DocumentsDataTableDataSourceType) => edge.node.folder?.rootParentFolder?.name,
    'folder_id': (edge: DocumentsDataTableDataSourceType) => edge.node.folder?.id,
    'folder_name': (edge: DocumentsDataTableDataSourceType) => edge.node.folder?.name,
    'folder_rootParentFolder': (edge: DocumentsDataTableDataSourceType) => edge.node.folder?.rootParentFolder,
    'folder_showOnly': (edge: DocumentsDataTableDataSourceType) => edge.node.folder?.showOnly,
    'id': (edge: DocumentsDataTableDataSourceType) => edge.node.id,
    '_policies': (edge: DocumentsDataTableDataSourceType) => edge.node._policies,
    'arCreatedAt': (edge: DocumentsDataTableDataSourceType) => edge.node.arCreatedAt,
    'author': (edge: DocumentsDataTableDataSourceType) => edge.node.author,
    'company': (edge: DocumentsDataTableDataSourceType) => edge.node.company,
    'contentType': (edge: DocumentsDataTableDataSourceType) => edge.node.contentType,
    'deletedAt': (edge: DocumentsDataTableDataSourceType) => edge.node.deletedAt,
    'employee': (edge: DocumentsDataTableDataSourceType) => edge.node.employee,
    'extension': (edge: DocumentsDataTableDataSourceType) => edge.node.extension,
    'file': (edge: DocumentsDataTableDataSourceType) => edge.node.file,
    'filename': (edge: DocumentsDataTableDataSourceType) => edge.node.filename,
    'fileSize': (edge: DocumentsDataTableDataSourceType) => edge.node.fileSize,
    'fileUrl': (edge: DocumentsDataTableDataSourceType) => edge.node.fileUrl,
    'folder': (edge: DocumentsDataTableDataSourceType) => edge.node.folder,
    'fromTemplate': (edge: DocumentsDataTableDataSourceType) => edge.node.fromTemplate,
    'incidenceMessageId': (edge: DocumentsDataTableDataSourceType) => edge.node.incidenceMessageId,
    'isCompanyDocument': (edge: DocumentsDataTableDataSourceType) => edge.node.isCompanyDocument,
    'isPendingAssignment': (edge: DocumentsDataTableDataSourceType) => edge.node.isPendingAssignment,
    'leaveId': (edge: DocumentsDataTableDataSourceType) => edge.node.leaveId,
    'notificationStatus': (edge: DocumentsDataTableDataSourceType) => edge.node.notificationStatus,
    'permissionUpdate': (edge: DocumentsDataTableDataSourceType) => edge.node.permissionUpdate,
    'public': (edge: DocumentsDataTableDataSourceType) => edge.node.public,
    'signatureStatus': (edge: DocumentsDataTableDataSourceType) => edge.node.signatureStatus,
    'signees': (edge: DocumentsDataTableDataSourceType) => edge.node.signees,
    'space': (edge: DocumentsDataTableDataSourceType) => edge.node.space,
    'status': (edge: DocumentsDataTableDataSourceType) => edge.node.status,
    'templateId': (edge: DocumentsDataTableDataSourceType) => edge.node.templateId,
    'type': (edge: DocumentsDataTableDataSourceType) => edge.node.type,
    'createdAt': (edge: DocumentsDataTableDataSourceType) => edge.node.createdAt,
    'updatedAt': (edge: DocumentsDataTableDataSourceType) => edge.node.updatedAt,
  }
}

export function buildDocumentsDataTableFilter(
  source: DataTableSource<DocumentsDataTableFields, typeof DocumentsDataTableSortableFields[number]>,
  filter: DataTableFilter<DocumentsDocumentFilter>
) {
  return filter
}

export function useDocumentsDataTable(
  projections: DataTableProjection<DocumentsDataTableFields, typeof DocumentsDataTableSortableFields[number]>[],
  options?: {
    variables?: DocumentsDataTableQueryVariables
    defaultSort?: typeof DocumentsDataTableSortableFields[number]
    identifier?: string
  }
): DataTableSource<DocumentsDataTableFields, typeof DocumentsDataTableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'DocumentsDataTable'

  return {
    identifier,
    query: DocumentsDataTableDocument,
    resolver: DocumentsDataTableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? DocumentsDataTableSortableFields.at(0),
      fields: DocumentsDataTableSortableFields,
    },
    variables
  }
}
export const DatevLaudsEmployeesDataTableDocument = gql`
query DatevLaudsEmployeesDataTable($employeeImportId: Int!, $employeeType: String, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort) {
  integrationsDatevLauds {
    importedEmployeesConnection(
      employeeImportId: $employeeImportId
      employeeType: $employeeType
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          mandatoryData {
            datevEmployeeCode
            email
            firstName
            lastName
          }
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type DatevLaudsEmployeesDataTableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<DatevLaudsEmployeesDataTableQuery['integrationsDatevLauds']>['importedEmployeesConnection']>['edges']
>

const DatevLaudsEmployeesDataTableSortableFields = [] as const

interface DatevLaudsEmployeesDataTableFields {
  'mandatoryData_datevEmployeeCode': RevealType<['node', 'mandatoryData', 'datevEmployeeCode'], DatevLaudsEmployeesDataTableDataSourceType>,
  'mandatoryData_email': RevealType<['node', 'mandatoryData', 'email'], DatevLaudsEmployeesDataTableDataSourceType>,
  'mandatoryData_firstName': RevealType<['node', 'mandatoryData', 'firstName'], DatevLaudsEmployeesDataTableDataSourceType>,
  'mandatoryData_lastName': RevealType<['node', 'mandatoryData', 'lastName'], DatevLaudsEmployeesDataTableDataSourceType>,
  'id': RevealType<['node', 'id'], DatevLaudsEmployeesDataTableDataSourceType>,
  'mandatoryData': RevealType<['node', 'mandatoryData'], DatevLaudsEmployeesDataTableDataSourceType>
}

const DatevLaudsEmployeesDataTableResolver = {
  dataSource: (data: DatevLaudsEmployeesDataTableQuery) => data.integrationsDatevLauds.importedEmployeesConnection,
  edges: (data: DatevLaudsEmployeesDataTableQuery) => data.integrationsDatevLauds.importedEmployeesConnection.edges,
  fields: {
    'mandatoryData_datevEmployeeCode': (edge: DatevLaudsEmployeesDataTableDataSourceType) => edge.node.mandatoryData?.datevEmployeeCode,
    'mandatoryData_email': (edge: DatevLaudsEmployeesDataTableDataSourceType) => edge.node.mandatoryData?.email,
    'mandatoryData_firstName': (edge: DatevLaudsEmployeesDataTableDataSourceType) => edge.node.mandatoryData?.firstName,
    'mandatoryData_lastName': (edge: DatevLaudsEmployeesDataTableDataSourceType) => edge.node.mandatoryData?.lastName,
    'id': (edge: DatevLaudsEmployeesDataTableDataSourceType) => edge.node.id,
    'mandatoryData': (edge: DatevLaudsEmployeesDataTableDataSourceType) => edge.node.mandatoryData,
  }
}

export function useDatevLaudsEmployeesDataTable(
  projections: DataTableProjection<DatevLaudsEmployeesDataTableFields, typeof DatevLaudsEmployeesDataTableSortableFields[number]>[],
  options?: {
    variables?: DatevLaudsEmployeesDataTableQueryVariables
    defaultSort?: typeof DatevLaudsEmployeesDataTableSortableFields[number]
    identifier?: string
  }
): DataTableSource<DatevLaudsEmployeesDataTableFields, typeof DatevLaudsEmployeesDataTableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'DatevLaudsEmployeesDataTable'

  return {
    identifier,
    query: DatevLaudsEmployeesDataTableDocument,
    resolver: DatevLaudsEmployeesDataTableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? DatevLaudsEmployeesDataTableSortableFields.at(0),
      fields: DatevLaudsEmployeesDataTableSortableFields,
    },
    variables
  }
}
export const ErroredEmployeesDataTableDocument = gql`
query ErroredEmployeesDataTable($employeeImportId: Int!, $employeeType: String, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort) {
  integrationsDatevLauds {
    importedEmployeesConnection(
      employeeImportId: $employeeImportId
      employeeType: $employeeType
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          mandatoryData {
            datevEmployeeCode
            email
            firstName
            lastName
            legalEntityName
          }
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type ErroredEmployeesDataTableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<ErroredEmployeesDataTableQuery['integrationsDatevLauds']>['importedEmployeesConnection']>['edges']
>

const ErroredEmployeesDataTableSortableFields = [] as const

interface ErroredEmployeesDataTableFields {
  'mandatoryData_datevEmployeeCode': RevealType<['node', 'mandatoryData', 'datevEmployeeCode'], ErroredEmployeesDataTableDataSourceType>,
  'mandatoryData_email': RevealType<['node', 'mandatoryData', 'email'], ErroredEmployeesDataTableDataSourceType>,
  'mandatoryData_firstName': RevealType<['node', 'mandatoryData', 'firstName'], ErroredEmployeesDataTableDataSourceType>,
  'mandatoryData_lastName': RevealType<['node', 'mandatoryData', 'lastName'], ErroredEmployeesDataTableDataSourceType>,
  'mandatoryData_legalEntityName': RevealType<['node', 'mandatoryData', 'legalEntityName'], ErroredEmployeesDataTableDataSourceType>,
  'id': RevealType<['node', 'id'], ErroredEmployeesDataTableDataSourceType>,
  'mandatoryData': RevealType<['node', 'mandatoryData'], ErroredEmployeesDataTableDataSourceType>
}

const ErroredEmployeesDataTableResolver = {
  dataSource: (data: ErroredEmployeesDataTableQuery) => data.integrationsDatevLauds.importedEmployeesConnection,
  edges: (data: ErroredEmployeesDataTableQuery) => data.integrationsDatevLauds.importedEmployeesConnection.edges,
  fields: {
    'mandatoryData_datevEmployeeCode': (edge: ErroredEmployeesDataTableDataSourceType) => edge.node.mandatoryData?.datevEmployeeCode,
    'mandatoryData_email': (edge: ErroredEmployeesDataTableDataSourceType) => edge.node.mandatoryData?.email,
    'mandatoryData_firstName': (edge: ErroredEmployeesDataTableDataSourceType) => edge.node.mandatoryData?.firstName,
    'mandatoryData_lastName': (edge: ErroredEmployeesDataTableDataSourceType) => edge.node.mandatoryData?.lastName,
    'mandatoryData_legalEntityName': (edge: ErroredEmployeesDataTableDataSourceType) => edge.node.mandatoryData?.legalEntityName,
    'id': (edge: ErroredEmployeesDataTableDataSourceType) => edge.node.id,
    'mandatoryData': (edge: ErroredEmployeesDataTableDataSourceType) => edge.node.mandatoryData,
  }
}

export function useErroredEmployeesDataTable(
  projections: DataTableProjection<ErroredEmployeesDataTableFields, typeof ErroredEmployeesDataTableSortableFields[number]>[],
  options?: {
    variables?: ErroredEmployeesDataTableQueryVariables
    defaultSort?: typeof ErroredEmployeesDataTableSortableFields[number]
    identifier?: string
  }
): DataTableSource<ErroredEmployeesDataTableFields, typeof ErroredEmployeesDataTableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'ErroredEmployeesDataTable'

  return {
    identifier,
    query: ErroredEmployeesDataTableDocument,
    resolver: ErroredEmployeesDataTableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? ErroredEmployeesDataTableSortableFields.at(0),
      fields: ErroredEmployeesDataTableSortableFields,
    },
    variables
  }
}
export const ValidEmployeesDataTableDocument = gql`
query ValidEmployeesDataTable($employeeImportId: Int!, $employeeType: String, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort) {
  integrationsDatevLauds {
    importedEmployeesConnection(
      employeeImportId: $employeeImportId
      employeeType: $employeeType
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          mandatoryData {
            datevEmployeeCode
            email
            firstName
            lastName
            legalEntityName
          }
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type ValidEmployeesDataTableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<ValidEmployeesDataTableQuery['integrationsDatevLauds']>['importedEmployeesConnection']>['edges']
>

const ValidEmployeesDataTableSortableFields = [] as const

interface ValidEmployeesDataTableFields {
  'mandatoryData_datevEmployeeCode': RevealType<['node', 'mandatoryData', 'datevEmployeeCode'], ValidEmployeesDataTableDataSourceType>,
  'mandatoryData_email': RevealType<['node', 'mandatoryData', 'email'], ValidEmployeesDataTableDataSourceType>,
  'mandatoryData_firstName': RevealType<['node', 'mandatoryData', 'firstName'], ValidEmployeesDataTableDataSourceType>,
  'mandatoryData_lastName': RevealType<['node', 'mandatoryData', 'lastName'], ValidEmployeesDataTableDataSourceType>,
  'mandatoryData_legalEntityName': RevealType<['node', 'mandatoryData', 'legalEntityName'], ValidEmployeesDataTableDataSourceType>,
  'id': RevealType<['node', 'id'], ValidEmployeesDataTableDataSourceType>,
  'mandatoryData': RevealType<['node', 'mandatoryData'], ValidEmployeesDataTableDataSourceType>
}

const ValidEmployeesDataTableResolver = {
  dataSource: (data: ValidEmployeesDataTableQuery) => data.integrationsDatevLauds.importedEmployeesConnection,
  edges: (data: ValidEmployeesDataTableQuery) => data.integrationsDatevLauds.importedEmployeesConnection.edges,
  fields: {
    'mandatoryData_datevEmployeeCode': (edge: ValidEmployeesDataTableDataSourceType) => edge.node.mandatoryData?.datevEmployeeCode,
    'mandatoryData_email': (edge: ValidEmployeesDataTableDataSourceType) => edge.node.mandatoryData?.email,
    'mandatoryData_firstName': (edge: ValidEmployeesDataTableDataSourceType) => edge.node.mandatoryData?.firstName,
    'mandatoryData_lastName': (edge: ValidEmployeesDataTableDataSourceType) => edge.node.mandatoryData?.lastName,
    'mandatoryData_legalEntityName': (edge: ValidEmployeesDataTableDataSourceType) => edge.node.mandatoryData?.legalEntityName,
    'id': (edge: ValidEmployeesDataTableDataSourceType) => edge.node.id,
    'mandatoryData': (edge: ValidEmployeesDataTableDataSourceType) => edge.node.mandatoryData,
  }
}

export function useValidEmployeesDataTable(
  projections: DataTableProjection<ValidEmployeesDataTableFields, typeof ValidEmployeesDataTableSortableFields[number]>[],
  options?: {
    variables?: ValidEmployeesDataTableQueryVariables
    defaultSort?: typeof ValidEmployeesDataTableSortableFields[number]
    identifier?: string
  }
): DataTableSource<ValidEmployeesDataTableFields, typeof ValidEmployeesDataTableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'ValidEmployeesDataTable'

  return {
    identifier,
    query: ValidEmployeesDataTableDocument,
    resolver: ValidEmployeesDataTableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? ValidEmployeesDataTableSortableFields.at(0),
      fields: ValidEmployeesDataTableSortableFields,
    },
    variables
  }
}
export const EmployeePulseEmployeeDatatableDocument = gql`
query EmployeePulseEmployeeDatatable($from: ISO8601Date!, $to: ISO8601Date!, $withTags: Boolean, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: EngagementEmployeePulseSummaryFilter) {
  engagement {
    employeePulseSummariesConnection(
      dateRange: {from: $from, to: $to}
      withTags: $withTags
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          access {
            id
            avatar
            employee {
              id
              fullName
            }
          }
          comment
          submittedDate
          tags {
            id
            key
            signalName
          }
          value
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
  teams {
    teamsConnection {
      edges {
        node {
          id
          name
        }
      }
    }
  }
}
`

type EmployeePulseEmployeeDatatableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<EmployeePulseEmployeeDatatableQuery['engagement']>['employeePulseSummariesConnection']>['edges']
>

const EmployeePulseEmployeeDatatableSortableFields = ['id', 'fullName', 'id', 'submittedDate', 'value'] as const

interface EmployeePulseEmployeeDatatableFields {
  'access_employee_id': RevealType<['node', 'access', 'employee', 'id'], EmployeePulseEmployeeDatatableDataSourceType>,
  'access_employee_fullName': RevealType<['node', 'access', 'employee', 'fullName'], EmployeePulseEmployeeDatatableDataSourceType>,
  'access_id': RevealType<['node', 'access', 'id'], EmployeePulseEmployeeDatatableDataSourceType>,
  'access_avatar': RevealType<['node', 'access', 'avatar'], EmployeePulseEmployeeDatatableDataSourceType>,
  'access_employee': RevealType<['node', 'access', 'employee'], EmployeePulseEmployeeDatatableDataSourceType>,
  'id': RevealType<['node', 'id'], EmployeePulseEmployeeDatatableDataSourceType>,
  'access': RevealType<['node', 'access'], EmployeePulseEmployeeDatatableDataSourceType>,
  'comment': RevealType<['node', 'comment'], EmployeePulseEmployeeDatatableDataSourceType>,
  'submittedDate': RevealType<['node', 'submittedDate'], EmployeePulseEmployeeDatatableDataSourceType>,
  'tags': RevealType<['node', 'tags'], EmployeePulseEmployeeDatatableDataSourceType>,
  'value': RevealType<['node', 'value'], EmployeePulseEmployeeDatatableDataSourceType>,
  'name': RevealType<['node', 'name'], EmployeePulseEmployeeDatatableDataSourceType>
}

const EmployeePulseEmployeeDatatableResolver = {
  dataSource: (data: EmployeePulseEmployeeDatatableQuery) => data.engagement.employeePulseSummariesConnection,
  edges: (data: EmployeePulseEmployeeDatatableQuery) => data.engagement.employeePulseSummariesConnection.edges,
  fields: {
    'access_employee_id': (edge: EmployeePulseEmployeeDatatableDataSourceType) => edge.node.access?.employee?.id,
    'access_employee_fullName': (edge: EmployeePulseEmployeeDatatableDataSourceType) => edge.node.access?.employee?.fullName,
    'access_id': (edge: EmployeePulseEmployeeDatatableDataSourceType) => edge.node.access?.id,
    'access_avatar': (edge: EmployeePulseEmployeeDatatableDataSourceType) => edge.node.access?.avatar,
    'access_employee': (edge: EmployeePulseEmployeeDatatableDataSourceType) => edge.node.access?.employee,
    'id': (edge: EmployeePulseEmployeeDatatableDataSourceType) => edge.node.id,
    'access': (edge: EmployeePulseEmployeeDatatableDataSourceType) => edge.node.access,
    'comment': (edge: EmployeePulseEmployeeDatatableDataSourceType) => edge.node.comment,
    'submittedDate': (edge: EmployeePulseEmployeeDatatableDataSourceType) => edge.node.submittedDate,
    'tags': (edge: EmployeePulseEmployeeDatatableDataSourceType) => edge.node.tags,
    'value': (edge: EmployeePulseEmployeeDatatableDataSourceType) => edge.node.value,
    'name': (edge: EmployeePulseEmployeeDatatableDataSourceType) => edge.node.name,
  }
}

export function buildEmployeePulseEmployeeDatatableFilter(
  source: DataTableSource<EmployeePulseEmployeeDatatableFields, typeof EmployeePulseEmployeeDatatableSortableFields[number]>,
  filter: DataTableFilter<EngagementEmployeePulseSummaryFilter>
) {
  return filter
}

export function useEmployeePulseEmployeeDatatable(
  projections: DataTableProjection<EmployeePulseEmployeeDatatableFields, typeof EmployeePulseEmployeeDatatableSortableFields[number]>[],
  options?: {
    variables?: EmployeePulseEmployeeDatatableQueryVariables
    defaultSort?: typeof EmployeePulseEmployeeDatatableSortableFields[number]
    identifier?: string
  }
): DataTableSource<EmployeePulseEmployeeDatatableFields, typeof EmployeePulseEmployeeDatatableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'EmployeePulseEmployeeDatatable'

  return {
    identifier,
    query: EmployeePulseEmployeeDatatableDocument,
    resolver: EmployeePulseEmployeeDatatableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? EmployeePulseEmployeeDatatableSortableFields.at(0),
      fields: EmployeePulseEmployeeDatatableSortableFields,
    },
    variables
  }
}
export const signedInvoicesDataTableDocument = gql`
query signedInvoicesDataTable($invoiceState: String, $omitSignedDocuments: Boolean, $receiverLegalEntityId: Int!, $signedForOrganization: String!, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: ExpensesSignedInvoiceFilter) {
  companies {
    legalEntitiesConnection(ids: [$receiverLegalEntityId]) {
      edges {
        node {
          id
          aeatClosingPeriodFrequency
        }
      }
    }
  }
  expenses {
    signedInvoicesConnection(
      invoiceState: $invoiceState
      omitSignedDocuments: $omitSignedDocuments
      receiverLegalEntityId: $receiverLegalEntityId
      signedForOrganization: $signedForOrganization
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          accountingDate
          amount
          beenTampered
          currency
          emitterName
          expensesClosingPeriod {
            id
          }
          missingRequiredData
          parentExpense {
            id
            status
          }
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type signedInvoicesDataTableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<signedInvoicesDataTableQuery['expenses']>['signedInvoicesConnection']>['edges']
>

const signedInvoicesDataTableSortableFields = ['accountingDate', 'amount', 'emitterName'] as const

interface signedInvoicesDataTableFields {
  'id': RevealType<['node', 'id'], signedInvoicesDataTableDataSourceType>,
  'aeatClosingPeriodFrequency': RevealType<['node', 'aeatClosingPeriodFrequency'], signedInvoicesDataTableDataSourceType>,
  'expensesClosingPeriod_id': RevealType<['node', 'expensesClosingPeriod', 'id'], signedInvoicesDataTableDataSourceType>,
  'parentExpense_id': RevealType<['node', 'parentExpense', 'id'], signedInvoicesDataTableDataSourceType>,
  'parentExpense_status': RevealType<['node', 'parentExpense', 'status'], signedInvoicesDataTableDataSourceType>,
  'accountingDate': RevealType<['node', 'accountingDate'], signedInvoicesDataTableDataSourceType>,
  'amount': RevealType<['node', 'amount'], signedInvoicesDataTableDataSourceType>,
  'beenTampered': RevealType<['node', 'beenTampered'], signedInvoicesDataTableDataSourceType>,
  'currency': RevealType<['node', 'currency'], signedInvoicesDataTableDataSourceType>,
  'emitterName': RevealType<['node', 'emitterName'], signedInvoicesDataTableDataSourceType>,
  'expensesClosingPeriod': RevealType<['node', 'expensesClosingPeriod'], signedInvoicesDataTableDataSourceType>,
  'missingRequiredData': RevealType<['node', 'missingRequiredData'], signedInvoicesDataTableDataSourceType>,
  'parentExpense': RevealType<['node', 'parentExpense'], signedInvoicesDataTableDataSourceType>
}

const signedInvoicesDataTableResolver = {
  dataSource: (data: signedInvoicesDataTableQuery) => data.expenses.signedInvoicesConnection,
  edges: (data: signedInvoicesDataTableQuery) => data.expenses.signedInvoicesConnection.edges,
  fields: {
    'id': (edge: signedInvoicesDataTableDataSourceType) => edge.node.id,
    'aeatClosingPeriodFrequency': (edge: signedInvoicesDataTableDataSourceType) => edge.node.aeatClosingPeriodFrequency,
    'expensesClosingPeriod_id': (edge: signedInvoicesDataTableDataSourceType) => edge.node.expensesClosingPeriod?.id,
    'parentExpense_id': (edge: signedInvoicesDataTableDataSourceType) => edge.node.parentExpense?.id,
    'parentExpense_status': (edge: signedInvoicesDataTableDataSourceType) => edge.node.parentExpense?.status,
    'accountingDate': (edge: signedInvoicesDataTableDataSourceType) => edge.node.accountingDate,
    'amount': (edge: signedInvoicesDataTableDataSourceType) => edge.node.amount,
    'beenTampered': (edge: signedInvoicesDataTableDataSourceType) => edge.node.beenTampered,
    'currency': (edge: signedInvoicesDataTableDataSourceType) => edge.node.currency,
    'emitterName': (edge: signedInvoicesDataTableDataSourceType) => edge.node.emitterName,
    'expensesClosingPeriod': (edge: signedInvoicesDataTableDataSourceType) => edge.node.expensesClosingPeriod,
    'missingRequiredData': (edge: signedInvoicesDataTableDataSourceType) => edge.node.missingRequiredData,
    'parentExpense': (edge: signedInvoicesDataTableDataSourceType) => edge.node.parentExpense,
  }
}

export function buildsignedInvoicesDataTableFilter(
  source: DataTableSource<signedInvoicesDataTableFields, typeof signedInvoicesDataTableSortableFields[number]>,
  filter: DataTableFilter<ExpensesSignedInvoiceFilter>
) {
  return filter
}

export function usesignedInvoicesDataTable(
  projections: DataTableProjection<signedInvoicesDataTableFields, typeof signedInvoicesDataTableSortableFields[number]>[],
  options?: {
    variables?: signedInvoicesDataTableQueryVariables
    defaultSort?: typeof signedInvoicesDataTableSortableFields[number]
    identifier?: string
  }
): DataTableSource<signedInvoicesDataTableFields, typeof signedInvoicesDataTableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'signedInvoicesDataTable'

  return {
    identifier,
    query: signedInvoicesDataTableDocument,
    resolver: signedInvoicesDataTableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? signedInvoicesDataTableSortableFields.at(0),
      fields: signedInvoicesDataTableSortableFields,
    },
    variables
  }
}
export const ExpensesSubscriptionMembersDatatableDocument = gql`
query ExpensesSubscriptionMembersDatatable($accessIds: [Int!], $companyId: Int!, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort) {
  features {
    featureMembership(id: "expenses_per_user_pricing_create_expenses") {
      id
      membersConnection(
        accessIds: $accessIds
        companyId: $companyId
        first: $first
        last: $last
        offsetPage: $offsetPage
        before: $before
        after: $after
        sortOrder: $sortOrder
      ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
        edges {
          node {
            id
            access {
              id
              avatar
              employee {
                id
              }
              fullName
            }
            createdAt
          }
          cursor
        }
        totalCount
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
      }
    }
  }
}
`

type ExpensesSubscriptionMembersDatatableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<RemoveArrayAndNull<ExpensesSubscriptionMembersDatatableQuery['features']>['featureMembership']>['membersConnection']>['edges']
>

const ExpensesSubscriptionMembersDatatableSortableFields = ['id', 'id'] as const

interface ExpensesSubscriptionMembersDatatableFields {
  'access_employee_id': RevealType<['node', 'access', 'employee', 'id'], ExpensesSubscriptionMembersDatatableDataSourceType>,
  'access_id': RevealType<['node', 'access', 'id'], ExpensesSubscriptionMembersDatatableDataSourceType>,
  'access_avatar': RevealType<['node', 'access', 'avatar'], ExpensesSubscriptionMembersDatatableDataSourceType>,
  'access_employee': RevealType<['node', 'access', 'employee'], ExpensesSubscriptionMembersDatatableDataSourceType>,
  'access_fullName': RevealType<['node', 'access', 'fullName'], ExpensesSubscriptionMembersDatatableDataSourceType>,
  'id': RevealType<['node', 'id'], ExpensesSubscriptionMembersDatatableDataSourceType>,
  'access': RevealType<['node', 'access'], ExpensesSubscriptionMembersDatatableDataSourceType>,
  'createdAt': RevealType<['node', 'createdAt'], ExpensesSubscriptionMembersDatatableDataSourceType>
}

const ExpensesSubscriptionMembersDatatableResolver = {
  dataSource: (data: ExpensesSubscriptionMembersDatatableQuery) => data.features.featureMembership.membersConnection,
  edges: (data: ExpensesSubscriptionMembersDatatableQuery) => data.features.featureMembership.membersConnection.edges,
  fields: {
    'access_employee_id': (edge: ExpensesSubscriptionMembersDatatableDataSourceType) => edge.node.access?.employee?.id,
    'access_id': (edge: ExpensesSubscriptionMembersDatatableDataSourceType) => edge.node.access?.id,
    'access_avatar': (edge: ExpensesSubscriptionMembersDatatableDataSourceType) => edge.node.access?.avatar,
    'access_employee': (edge: ExpensesSubscriptionMembersDatatableDataSourceType) => edge.node.access?.employee,
    'access_fullName': (edge: ExpensesSubscriptionMembersDatatableDataSourceType) => edge.node.access?.fullName,
    'id': (edge: ExpensesSubscriptionMembersDatatableDataSourceType) => edge.node.id,
    'access': (edge: ExpensesSubscriptionMembersDatatableDataSourceType) => edge.node.access,
    'createdAt': (edge: ExpensesSubscriptionMembersDatatableDataSourceType) => edge.node.createdAt,
  }
}

export function useExpensesSubscriptionMembersDatatable(
  projections: DataTableProjection<ExpensesSubscriptionMembersDatatableFields, typeof ExpensesSubscriptionMembersDatatableSortableFields[number]>[],
  options?: {
    variables?: ExpensesSubscriptionMembersDatatableQueryVariables
    defaultSort?: typeof ExpensesSubscriptionMembersDatatableSortableFields[number]
    identifier?: string
  }
): DataTableSource<ExpensesSubscriptionMembersDatatableFields, typeof ExpensesSubscriptionMembersDatatableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'ExpensesSubscriptionMembersDatatable'

  return {
    identifier,
    query: ExpensesSubscriptionMembersDatatableDocument,
    resolver: ExpensesSubscriptionMembersDatatableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? ExpensesSubscriptionMembersDatatableSortableFields.at(0),
      fields: ExpensesSubscriptionMembersDatatableSortableFields,
    },
    variables
  }
}
export const ExpensablesDataTableDocument = gql`
query ExpensablesDataTable($companyId: String!, $employeeIds: [Int!], $from: ISO8601DateTime, $groupIds: [Int!], $includeManualDrafts: Boolean, $search: String, $to: ISO8601DateTime, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: ExpensesExpensableFilter) {
  expenses {
    expensablesConnection(
      employeeIds: $employeeIds
      from: $from
      groupIds: $groupIds
      includeAttachments: false
      includeManualDrafts: $includeManualDrafts
      reporterIds: $employeeIds
      search: $search
      to: $to
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          amount
          approvalFlowReason
          company {
            id
            currency
          }
          compensation {
            id
          }
          currency
          currentApprovers {
            id
            fullName
          }
          currentUserApprovalStatus
          description
          effectiveOn
          expense(includeAttachments: false, includeManualDrafts: $includeManualDrafts) {
            id
            card {
              cardType
              last4
            }
            cardPayment {
              id
              status
            }
            category {
              id
              name
            }
            creationType
            documentType
            merchantName
            payment
            paymentMethod
            userMerchant
          }
          groupId
          internalReference
          materializedApprovalFlowId
          materializedStepApproverId
          mileage(includeAttachments: false, includeManualDrafts: $includeManualDrafts) {
            id
            category {
              id
              name
            }
          }
          owner {
            id
            access {
              id
              avatar
              fullName
            }
            bankNumber
            bankNumberFormat
            legalEntity {
              id
              currency
            }
          }
          paidAt
          perDiem {
            id
            category {
              id
              name
            }
          }
          reimbursableAmount
          reimbursableCurrency
          reimbursementMethod
          reporter {
            id
          }
          reviewRequestAt
          spendingAlertsSource {
            id
            status
            type
          }
          spendingAlertsTarget {
            id
            reason
            source {
              ... on FinanceSpendingPolicyRuleGroup {
                id
                description
                spendingPolicyRulesConnection(companyId: $companyId) {
                  edges {
                    node {
                      id
                      formatedValue
                      identifier
                      operation
                      value
                    }
                  }
                }
              }
              ... on FinanceSpendingPolicy {
                id
                description
              }
            }
            status
            type
          }
          status
          statusUpdatedAt
          supplement {
            id
          }
          type
          createdAt
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type ExpensablesDataTableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<ExpensablesDataTableQuery['expenses']>['expensablesConnection']>['edges']
>

const ExpensablesDataTableSortableFields = ['id', 'id', 'id', 'id', 'amount', 'currency', 'effectiveOn', 'reimbursableAmount', 'reimbursableCurrency', 'reimbursementMethod', 'reviewRequestAt', 'status', 'type', 'createdAt'] as const

interface ExpensablesDataTableFields {
  'company_id': RevealType<['node', 'company', 'id'], ExpensablesDataTableDataSourceType>,
  'company_currency': RevealType<['node', 'company', 'currency'], ExpensablesDataTableDataSourceType>,
  'compensation_id': RevealType<['node', 'compensation', 'id'], ExpensablesDataTableDataSourceType>,
  'expense_card_cardType': RevealType<['node', 'expense', 'card', 'cardType'], ExpensablesDataTableDataSourceType>,
  'expense_card_last4': RevealType<['node', 'expense', 'card', 'last4'], ExpensablesDataTableDataSourceType>,
  'expense_cardPayment_id': RevealType<['node', 'expense', 'cardPayment', 'id'], ExpensablesDataTableDataSourceType>,
  'expense_cardPayment_status': RevealType<['node', 'expense', 'cardPayment', 'status'], ExpensablesDataTableDataSourceType>,
  'expense_category_id': RevealType<['node', 'expense', 'category', 'id'], ExpensablesDataTableDataSourceType>,
  'expense_category_name': RevealType<['node', 'expense', 'category', 'name'], ExpensablesDataTableDataSourceType>,
  'expense_id': RevealType<['node', 'expense', 'id'], ExpensablesDataTableDataSourceType>,
  'expense_card': RevealType<['node', 'expense', 'card'], ExpensablesDataTableDataSourceType>,
  'expense_cardPayment': RevealType<['node', 'expense', 'cardPayment'], ExpensablesDataTableDataSourceType>,
  'expense_category': RevealType<['node', 'expense', 'category'], ExpensablesDataTableDataSourceType>,
  'expense_creationType': RevealType<['node', 'expense', 'creationType'], ExpensablesDataTableDataSourceType>,
  'expense_documentType': RevealType<['node', 'expense', 'documentType'], ExpensablesDataTableDataSourceType>,
  'expense_merchantName': RevealType<['node', 'expense', 'merchantName'], ExpensablesDataTableDataSourceType>,
  'expense_payment': RevealType<['node', 'expense', 'payment'], ExpensablesDataTableDataSourceType>,
  'expense_paymentMethod': RevealType<['node', 'expense', 'paymentMethod'], ExpensablesDataTableDataSourceType>,
  'expense_userMerchant': RevealType<['node', 'expense', 'userMerchant'], ExpensablesDataTableDataSourceType>,
  'mileage_category_id': RevealType<['node', 'mileage', 'category', 'id'], ExpensablesDataTableDataSourceType>,
  'mileage_category_name': RevealType<['node', 'mileage', 'category', 'name'], ExpensablesDataTableDataSourceType>,
  'mileage_id': RevealType<['node', 'mileage', 'id'], ExpensablesDataTableDataSourceType>,
  'mileage_category': RevealType<['node', 'mileage', 'category'], ExpensablesDataTableDataSourceType>,
  'owner_access_id': RevealType<['node', 'owner', 'access', 'id'], ExpensablesDataTableDataSourceType>,
  'owner_access_avatar': RevealType<['node', 'owner', 'access', 'avatar'], ExpensablesDataTableDataSourceType>,
  'owner_access_fullName': RevealType<['node', 'owner', 'access', 'fullName'], ExpensablesDataTableDataSourceType>,
  'owner_legalEntity_id': RevealType<['node', 'owner', 'legalEntity', 'id'], ExpensablesDataTableDataSourceType>,
  'owner_legalEntity_currency': RevealType<['node', 'owner', 'legalEntity', 'currency'], ExpensablesDataTableDataSourceType>,
  'owner_id': RevealType<['node', 'owner', 'id'], ExpensablesDataTableDataSourceType>,
  'owner_access': RevealType<['node', 'owner', 'access'], ExpensablesDataTableDataSourceType>,
  'owner_bankNumber': RevealType<['node', 'owner', 'bankNumber'], ExpensablesDataTableDataSourceType>,
  'owner_bankNumberFormat': RevealType<['node', 'owner', 'bankNumberFormat'], ExpensablesDataTableDataSourceType>,
  'owner_legalEntity': RevealType<['node', 'owner', 'legalEntity'], ExpensablesDataTableDataSourceType>,
  'perDiem_category_id': RevealType<['node', 'perDiem', 'category', 'id'], ExpensablesDataTableDataSourceType>,
  'perDiem_category_name': RevealType<['node', 'perDiem', 'category', 'name'], ExpensablesDataTableDataSourceType>,
  'perDiem_id': RevealType<['node', 'perDiem', 'id'], ExpensablesDataTableDataSourceType>,
  'perDiem_category': RevealType<['node', 'perDiem', 'category'], ExpensablesDataTableDataSourceType>,
  'reporter_id': RevealType<['node', 'reporter', 'id'], ExpensablesDataTableDataSourceType>,
  'supplement_id': RevealType<['node', 'supplement', 'id'], ExpensablesDataTableDataSourceType>,
  'id': RevealType<['node', 'id'], ExpensablesDataTableDataSourceType>,
  'amount': RevealType<['node', 'amount'], ExpensablesDataTableDataSourceType>,
  'approvalFlowReason': RevealType<['node', 'approvalFlowReason'], ExpensablesDataTableDataSourceType>,
  'company': RevealType<['node', 'company'], ExpensablesDataTableDataSourceType>,
  'compensation': RevealType<['node', 'compensation'], ExpensablesDataTableDataSourceType>,
  'currency': RevealType<['node', 'currency'], ExpensablesDataTableDataSourceType>,
  'currentApprovers': RevealType<['node', 'currentApprovers'], ExpensablesDataTableDataSourceType>,
  'currentUserApprovalStatus': RevealType<['node', 'currentUserApprovalStatus'], ExpensablesDataTableDataSourceType>,
  'description': RevealType<['node', 'description'], ExpensablesDataTableDataSourceType>,
  'effectiveOn': RevealType<['node', 'effectiveOn'], ExpensablesDataTableDataSourceType>,
  'expense': RevealType<['node', 'expense'], ExpensablesDataTableDataSourceType>,
  'groupId': RevealType<['node', 'groupId'], ExpensablesDataTableDataSourceType>,
  'internalReference': RevealType<['node', 'internalReference'], ExpensablesDataTableDataSourceType>,
  'materializedApprovalFlowId': RevealType<['node', 'materializedApprovalFlowId'], ExpensablesDataTableDataSourceType>,
  'materializedStepApproverId': RevealType<['node', 'materializedStepApproverId'], ExpensablesDataTableDataSourceType>,
  'mileage': RevealType<['node', 'mileage'], ExpensablesDataTableDataSourceType>,
  'owner': RevealType<['node', 'owner'], ExpensablesDataTableDataSourceType>,
  'paidAt': RevealType<['node', 'paidAt'], ExpensablesDataTableDataSourceType>,
  'perDiem': RevealType<['node', 'perDiem'], ExpensablesDataTableDataSourceType>,
  'reimbursableAmount': RevealType<['node', 'reimbursableAmount'], ExpensablesDataTableDataSourceType>,
  'reimbursableCurrency': RevealType<['node', 'reimbursableCurrency'], ExpensablesDataTableDataSourceType>,
  'reimbursementMethod': RevealType<['node', 'reimbursementMethod'], ExpensablesDataTableDataSourceType>,
  'reporter': RevealType<['node', 'reporter'], ExpensablesDataTableDataSourceType>,
  'reviewRequestAt': RevealType<['node', 'reviewRequestAt'], ExpensablesDataTableDataSourceType>,
  'spendingAlertsSource': RevealType<['node', 'spendingAlertsSource'], ExpensablesDataTableDataSourceType>,
  'spendingAlertsTarget': RevealType<['node', 'spendingAlertsTarget'], ExpensablesDataTableDataSourceType>,
  'status': RevealType<['node', 'status'], ExpensablesDataTableDataSourceType>,
  'statusUpdatedAt': RevealType<['node', 'statusUpdatedAt'], ExpensablesDataTableDataSourceType>,
  'supplement': RevealType<['node', 'supplement'], ExpensablesDataTableDataSourceType>,
  'type': RevealType<['node', 'type'], ExpensablesDataTableDataSourceType>,
  'createdAt': RevealType<['node', 'createdAt'], ExpensablesDataTableDataSourceType>
}

const ExpensablesDataTableResolver = {
  dataSource: (data: ExpensablesDataTableQuery) => data.expenses.expensablesConnection,
  edges: (data: ExpensablesDataTableQuery) => data.expenses.expensablesConnection.edges,
  fields: {
    'company_id': (edge: ExpensablesDataTableDataSourceType) => edge.node.company?.id,
    'company_currency': (edge: ExpensablesDataTableDataSourceType) => edge.node.company?.currency,
    'compensation_id': (edge: ExpensablesDataTableDataSourceType) => edge.node.compensation?.id,
    'expense_card_cardType': (edge: ExpensablesDataTableDataSourceType) => edge.node.expense?.card?.cardType,
    'expense_card_last4': (edge: ExpensablesDataTableDataSourceType) => edge.node.expense?.card?.last4,
    'expense_cardPayment_id': (edge: ExpensablesDataTableDataSourceType) => edge.node.expense?.cardPayment?.id,
    'expense_cardPayment_status': (edge: ExpensablesDataTableDataSourceType) => edge.node.expense?.cardPayment?.status,
    'expense_category_id': (edge: ExpensablesDataTableDataSourceType) => edge.node.expense?.category?.id,
    'expense_category_name': (edge: ExpensablesDataTableDataSourceType) => edge.node.expense?.category?.name,
    'expense_id': (edge: ExpensablesDataTableDataSourceType) => edge.node.expense?.id,
    'expense_card': (edge: ExpensablesDataTableDataSourceType) => edge.node.expense?.card,
    'expense_cardPayment': (edge: ExpensablesDataTableDataSourceType) => edge.node.expense?.cardPayment,
    'expense_category': (edge: ExpensablesDataTableDataSourceType) => edge.node.expense?.category,
    'expense_creationType': (edge: ExpensablesDataTableDataSourceType) => edge.node.expense?.creationType,
    'expense_documentType': (edge: ExpensablesDataTableDataSourceType) => edge.node.expense?.documentType,
    'expense_merchantName': (edge: ExpensablesDataTableDataSourceType) => edge.node.expense?.merchantName,
    'expense_payment': (edge: ExpensablesDataTableDataSourceType) => edge.node.expense?.payment,
    'expense_paymentMethod': (edge: ExpensablesDataTableDataSourceType) => edge.node.expense?.paymentMethod,
    'expense_userMerchant': (edge: ExpensablesDataTableDataSourceType) => edge.node.expense?.userMerchant,
    'mileage_category_id': (edge: ExpensablesDataTableDataSourceType) => edge.node.mileage?.category?.id,
    'mileage_category_name': (edge: ExpensablesDataTableDataSourceType) => edge.node.mileage?.category?.name,
    'mileage_id': (edge: ExpensablesDataTableDataSourceType) => edge.node.mileage?.id,
    'mileage_category': (edge: ExpensablesDataTableDataSourceType) => edge.node.mileage?.category,
    'owner_access_id': (edge: ExpensablesDataTableDataSourceType) => edge.node.owner?.access?.id,
    'owner_access_avatar': (edge: ExpensablesDataTableDataSourceType) => edge.node.owner?.access?.avatar,
    'owner_access_fullName': (edge: ExpensablesDataTableDataSourceType) => edge.node.owner?.access?.fullName,
    'owner_legalEntity_id': (edge: ExpensablesDataTableDataSourceType) => edge.node.owner?.legalEntity?.id,
    'owner_legalEntity_currency': (edge: ExpensablesDataTableDataSourceType) => edge.node.owner?.legalEntity?.currency,
    'owner_id': (edge: ExpensablesDataTableDataSourceType) => edge.node.owner?.id,
    'owner_access': (edge: ExpensablesDataTableDataSourceType) => edge.node.owner?.access,
    'owner_bankNumber': (edge: ExpensablesDataTableDataSourceType) => edge.node.owner?.bankNumber,
    'owner_bankNumberFormat': (edge: ExpensablesDataTableDataSourceType) => edge.node.owner?.bankNumberFormat,
    'owner_legalEntity': (edge: ExpensablesDataTableDataSourceType) => edge.node.owner?.legalEntity,
    'perDiem_category_id': (edge: ExpensablesDataTableDataSourceType) => edge.node.perDiem?.category?.id,
    'perDiem_category_name': (edge: ExpensablesDataTableDataSourceType) => edge.node.perDiem?.category?.name,
    'perDiem_id': (edge: ExpensablesDataTableDataSourceType) => edge.node.perDiem?.id,
    'perDiem_category': (edge: ExpensablesDataTableDataSourceType) => edge.node.perDiem?.category,
    'reporter_id': (edge: ExpensablesDataTableDataSourceType) => edge.node.reporter?.id,
    'supplement_id': (edge: ExpensablesDataTableDataSourceType) => edge.node.supplement?.id,
    'id': (edge: ExpensablesDataTableDataSourceType) => edge.node.id,
    'amount': (edge: ExpensablesDataTableDataSourceType) => edge.node.amount,
    'approvalFlowReason': (edge: ExpensablesDataTableDataSourceType) => edge.node.approvalFlowReason,
    'company': (edge: ExpensablesDataTableDataSourceType) => edge.node.company,
    'compensation': (edge: ExpensablesDataTableDataSourceType) => edge.node.compensation,
    'currency': (edge: ExpensablesDataTableDataSourceType) => edge.node.currency,
    'currentApprovers': (edge: ExpensablesDataTableDataSourceType) => edge.node.currentApprovers,
    'currentUserApprovalStatus': (edge: ExpensablesDataTableDataSourceType) => edge.node.currentUserApprovalStatus,
    'description': (edge: ExpensablesDataTableDataSourceType) => edge.node.description,
    'effectiveOn': (edge: ExpensablesDataTableDataSourceType) => edge.node.effectiveOn,
    'expense': (edge: ExpensablesDataTableDataSourceType) => edge.node.expense,
    'groupId': (edge: ExpensablesDataTableDataSourceType) => edge.node.groupId,
    'internalReference': (edge: ExpensablesDataTableDataSourceType) => edge.node.internalReference,
    'materializedApprovalFlowId': (edge: ExpensablesDataTableDataSourceType) => edge.node.materializedApprovalFlowId,
    'materializedStepApproverId': (edge: ExpensablesDataTableDataSourceType) => edge.node.materializedStepApproverId,
    'mileage': (edge: ExpensablesDataTableDataSourceType) => edge.node.mileage,
    'owner': (edge: ExpensablesDataTableDataSourceType) => edge.node.owner,
    'paidAt': (edge: ExpensablesDataTableDataSourceType) => edge.node.paidAt,
    'perDiem': (edge: ExpensablesDataTableDataSourceType) => edge.node.perDiem,
    'reimbursableAmount': (edge: ExpensablesDataTableDataSourceType) => edge.node.reimbursableAmount,
    'reimbursableCurrency': (edge: ExpensablesDataTableDataSourceType) => edge.node.reimbursableCurrency,
    'reimbursementMethod': (edge: ExpensablesDataTableDataSourceType) => edge.node.reimbursementMethod,
    'reporter': (edge: ExpensablesDataTableDataSourceType) => edge.node.reporter,
    'reviewRequestAt': (edge: ExpensablesDataTableDataSourceType) => edge.node.reviewRequestAt,
    'spendingAlertsSource': (edge: ExpensablesDataTableDataSourceType) => edge.node.spendingAlertsSource,
    'spendingAlertsTarget': (edge: ExpensablesDataTableDataSourceType) => edge.node.spendingAlertsTarget,
    'status': (edge: ExpensablesDataTableDataSourceType) => edge.node.status,
    'statusUpdatedAt': (edge: ExpensablesDataTableDataSourceType) => edge.node.statusUpdatedAt,
    'supplement': (edge: ExpensablesDataTableDataSourceType) => edge.node.supplement,
    'type': (edge: ExpensablesDataTableDataSourceType) => edge.node.type,
    'createdAt': (edge: ExpensablesDataTableDataSourceType) => edge.node.createdAt,
  }
}

export function buildExpensablesDataTableFilter(
  source: DataTableSource<ExpensablesDataTableFields, typeof ExpensablesDataTableSortableFields[number]>,
  filter: DataTableFilter<ExpensesExpensableFilter>
) {
  return filter
}

export function useExpensablesDataTable(
  projections: DataTableProjection<ExpensablesDataTableFields, typeof ExpensablesDataTableSortableFields[number]>[],
  options?: {
    variables?: ExpensablesDataTableQueryVariables
    defaultSort?: typeof ExpensablesDataTableSortableFields[number]
    identifier?: string
  }
): DataTableSource<ExpensablesDataTableFields, typeof ExpensablesDataTableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'ExpensablesDataTable'

  return {
    identifier,
    query: ExpensablesDataTableDocument,
    resolver: ExpensablesDataTableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? ExpensablesDataTableSortableFields.at(0),
      fields: ExpensablesDataTableSortableFields,
    },
    variables
  }
}
export const MyGroupedExpensablesDataTableDocument = gql`
query MyGroupedExpensablesDataTable($employeeIds: [Int!], $from: ISO8601DateTime, $groupIds: [Int!], $includeManualDrafts: Boolean, $search: String, $to: ISO8601DateTime, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: ExpensesExpensableFilter) {
  expenses {
    expensablesConnection(
      employeeIds: $employeeIds
      from: $from
      groupIds: $groupIds
      includeAttachments: false
      includeManualDrafts: $includeManualDrafts
      reporterIds: $employeeIds
      search: $search
      to: $to
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          amount
          approvalFlowReason
          company {
            id
            currency
          }
          currency
          currentApprovers {
            id
            fullName
          }
          currentUserApprovalStatus
          description
          effectiveOn
          expense(includeAttachments: false, includeManualDrafts: $includeManualDrafts) {
            id
            card {
              cardType
              last4
            }
            cardPayment {
              id
              status
            }
            category {
              id
              name
            }
            creationType
            documentType
            merchantName
            payment
            paymentMethod
            userMerchant
          }
          groupId
          internalReference
          materializedApprovalFlowId
          materializedStepApproverId
          mileage(includeAttachments: false, includeManualDrafts: $includeManualDrafts) {
            id
            category {
              id
              name
            }
          }
          owner {
            id
            access {
              id
              avatar
              fullName
            }
            legalEntity {
              id
              currency
            }
          }
          paidAt
          perDiem {
            id
            category {
              id
              name
            }
          }
          readyToReviewIssues {
            issues {
              type
            }
          }
          reimbursableAmount
          reimbursableCurrency
          reporter {
            id
          }
          reviewRequestAt
          spendingAlertsSource {
            id
            status
            type
          }
          spendingAlertsTarget {
            id
            status
            type
          }
          status
          statusUpdatedAt
          supplement {
            id
          }
          type
          createdAt
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type MyGroupedExpensablesDataTableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<MyGroupedExpensablesDataTableQuery['expenses']>['expensablesConnection']>['edges']
>

const MyGroupedExpensablesDataTableSortableFields = ['id', 'id', 'id', 'id', 'amount', 'currency', 'effectiveOn', 'reimbursableAmount', 'reimbursableCurrency', 'reviewRequestAt', 'status', 'type', 'createdAt'] as const

interface MyGroupedExpensablesDataTableFields {
  'company_id': RevealType<['node', 'company', 'id'], MyGroupedExpensablesDataTableDataSourceType>,
  'company_currency': RevealType<['node', 'company', 'currency'], MyGroupedExpensablesDataTableDataSourceType>,
  'expense_card_cardType': RevealType<['node', 'expense', 'card', 'cardType'], MyGroupedExpensablesDataTableDataSourceType>,
  'expense_card_last4': RevealType<['node', 'expense', 'card', 'last4'], MyGroupedExpensablesDataTableDataSourceType>,
  'expense_cardPayment_id': RevealType<['node', 'expense', 'cardPayment', 'id'], MyGroupedExpensablesDataTableDataSourceType>,
  'expense_cardPayment_status': RevealType<['node', 'expense', 'cardPayment', 'status'], MyGroupedExpensablesDataTableDataSourceType>,
  'expense_category_id': RevealType<['node', 'expense', 'category', 'id'], MyGroupedExpensablesDataTableDataSourceType>,
  'expense_category_name': RevealType<['node', 'expense', 'category', 'name'], MyGroupedExpensablesDataTableDataSourceType>,
  'expense_id': RevealType<['node', 'expense', 'id'], MyGroupedExpensablesDataTableDataSourceType>,
  'expense_card': RevealType<['node', 'expense', 'card'], MyGroupedExpensablesDataTableDataSourceType>,
  'expense_cardPayment': RevealType<['node', 'expense', 'cardPayment'], MyGroupedExpensablesDataTableDataSourceType>,
  'expense_category': RevealType<['node', 'expense', 'category'], MyGroupedExpensablesDataTableDataSourceType>,
  'expense_creationType': RevealType<['node', 'expense', 'creationType'], MyGroupedExpensablesDataTableDataSourceType>,
  'expense_documentType': RevealType<['node', 'expense', 'documentType'], MyGroupedExpensablesDataTableDataSourceType>,
  'expense_merchantName': RevealType<['node', 'expense', 'merchantName'], MyGroupedExpensablesDataTableDataSourceType>,
  'expense_payment': RevealType<['node', 'expense', 'payment'], MyGroupedExpensablesDataTableDataSourceType>,
  'expense_paymentMethod': RevealType<['node', 'expense', 'paymentMethod'], MyGroupedExpensablesDataTableDataSourceType>,
  'expense_userMerchant': RevealType<['node', 'expense', 'userMerchant'], MyGroupedExpensablesDataTableDataSourceType>,
  'mileage_category_id': RevealType<['node', 'mileage', 'category', 'id'], MyGroupedExpensablesDataTableDataSourceType>,
  'mileage_category_name': RevealType<['node', 'mileage', 'category', 'name'], MyGroupedExpensablesDataTableDataSourceType>,
  'mileage_id': RevealType<['node', 'mileage', 'id'], MyGroupedExpensablesDataTableDataSourceType>,
  'mileage_category': RevealType<['node', 'mileage', 'category'], MyGroupedExpensablesDataTableDataSourceType>,
  'owner_access_id': RevealType<['node', 'owner', 'access', 'id'], MyGroupedExpensablesDataTableDataSourceType>,
  'owner_access_avatar': RevealType<['node', 'owner', 'access', 'avatar'], MyGroupedExpensablesDataTableDataSourceType>,
  'owner_access_fullName': RevealType<['node', 'owner', 'access', 'fullName'], MyGroupedExpensablesDataTableDataSourceType>,
  'owner_legalEntity_id': RevealType<['node', 'owner', 'legalEntity', 'id'], MyGroupedExpensablesDataTableDataSourceType>,
  'owner_legalEntity_currency': RevealType<['node', 'owner', 'legalEntity', 'currency'], MyGroupedExpensablesDataTableDataSourceType>,
  'owner_id': RevealType<['node', 'owner', 'id'], MyGroupedExpensablesDataTableDataSourceType>,
  'owner_access': RevealType<['node', 'owner', 'access'], MyGroupedExpensablesDataTableDataSourceType>,
  'owner_legalEntity': RevealType<['node', 'owner', 'legalEntity'], MyGroupedExpensablesDataTableDataSourceType>,
  'perDiem_category_id': RevealType<['node', 'perDiem', 'category', 'id'], MyGroupedExpensablesDataTableDataSourceType>,
  'perDiem_category_name': RevealType<['node', 'perDiem', 'category', 'name'], MyGroupedExpensablesDataTableDataSourceType>,
  'perDiem_id': RevealType<['node', 'perDiem', 'id'], MyGroupedExpensablesDataTableDataSourceType>,
  'perDiem_category': RevealType<['node', 'perDiem', 'category'], MyGroupedExpensablesDataTableDataSourceType>,
  'readyToReviewIssues_issues': RevealType<['node', 'readyToReviewIssues', 'issues'], MyGroupedExpensablesDataTableDataSourceType>,
  'reporter_id': RevealType<['node', 'reporter', 'id'], MyGroupedExpensablesDataTableDataSourceType>,
  'supplement_id': RevealType<['node', 'supplement', 'id'], MyGroupedExpensablesDataTableDataSourceType>,
  'id': RevealType<['node', 'id'], MyGroupedExpensablesDataTableDataSourceType>,
  'amount': RevealType<['node', 'amount'], MyGroupedExpensablesDataTableDataSourceType>,
  'approvalFlowReason': RevealType<['node', 'approvalFlowReason'], MyGroupedExpensablesDataTableDataSourceType>,
  'company': RevealType<['node', 'company'], MyGroupedExpensablesDataTableDataSourceType>,
  'currency': RevealType<['node', 'currency'], MyGroupedExpensablesDataTableDataSourceType>,
  'currentApprovers': RevealType<['node', 'currentApprovers'], MyGroupedExpensablesDataTableDataSourceType>,
  'currentUserApprovalStatus': RevealType<['node', 'currentUserApprovalStatus'], MyGroupedExpensablesDataTableDataSourceType>,
  'description': RevealType<['node', 'description'], MyGroupedExpensablesDataTableDataSourceType>,
  'effectiveOn': RevealType<['node', 'effectiveOn'], MyGroupedExpensablesDataTableDataSourceType>,
  'expense': RevealType<['node', 'expense'], MyGroupedExpensablesDataTableDataSourceType>,
  'groupId': RevealType<['node', 'groupId'], MyGroupedExpensablesDataTableDataSourceType>,
  'internalReference': RevealType<['node', 'internalReference'], MyGroupedExpensablesDataTableDataSourceType>,
  'materializedApprovalFlowId': RevealType<['node', 'materializedApprovalFlowId'], MyGroupedExpensablesDataTableDataSourceType>,
  'materializedStepApproverId': RevealType<['node', 'materializedStepApproverId'], MyGroupedExpensablesDataTableDataSourceType>,
  'mileage': RevealType<['node', 'mileage'], MyGroupedExpensablesDataTableDataSourceType>,
  'owner': RevealType<['node', 'owner'], MyGroupedExpensablesDataTableDataSourceType>,
  'paidAt': RevealType<['node', 'paidAt'], MyGroupedExpensablesDataTableDataSourceType>,
  'perDiem': RevealType<['node', 'perDiem'], MyGroupedExpensablesDataTableDataSourceType>,
  'readyToReviewIssues': RevealType<['node', 'readyToReviewIssues'], MyGroupedExpensablesDataTableDataSourceType>,
  'reimbursableAmount': RevealType<['node', 'reimbursableAmount'], MyGroupedExpensablesDataTableDataSourceType>,
  'reimbursableCurrency': RevealType<['node', 'reimbursableCurrency'], MyGroupedExpensablesDataTableDataSourceType>,
  'reporter': RevealType<['node', 'reporter'], MyGroupedExpensablesDataTableDataSourceType>,
  'reviewRequestAt': RevealType<['node', 'reviewRequestAt'], MyGroupedExpensablesDataTableDataSourceType>,
  'spendingAlertsSource': RevealType<['node', 'spendingAlertsSource'], MyGroupedExpensablesDataTableDataSourceType>,
  'spendingAlertsTarget': RevealType<['node', 'spendingAlertsTarget'], MyGroupedExpensablesDataTableDataSourceType>,
  'status': RevealType<['node', 'status'], MyGroupedExpensablesDataTableDataSourceType>,
  'statusUpdatedAt': RevealType<['node', 'statusUpdatedAt'], MyGroupedExpensablesDataTableDataSourceType>,
  'supplement': RevealType<['node', 'supplement'], MyGroupedExpensablesDataTableDataSourceType>,
  'type': RevealType<['node', 'type'], MyGroupedExpensablesDataTableDataSourceType>,
  'createdAt': RevealType<['node', 'createdAt'], MyGroupedExpensablesDataTableDataSourceType>
}

const MyGroupedExpensablesDataTableResolver = {
  dataSource: (data: MyGroupedExpensablesDataTableQuery) => data.expenses.expensablesConnection,
  edges: (data: MyGroupedExpensablesDataTableQuery) => data.expenses.expensablesConnection.edges,
  fields: {
    'company_id': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.company?.id,
    'company_currency': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.company?.currency,
    'expense_card_cardType': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.expense?.card?.cardType,
    'expense_card_last4': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.expense?.card?.last4,
    'expense_cardPayment_id': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.expense?.cardPayment?.id,
    'expense_cardPayment_status': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.expense?.cardPayment?.status,
    'expense_category_id': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.expense?.category?.id,
    'expense_category_name': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.expense?.category?.name,
    'expense_id': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.expense?.id,
    'expense_card': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.expense?.card,
    'expense_cardPayment': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.expense?.cardPayment,
    'expense_category': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.expense?.category,
    'expense_creationType': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.expense?.creationType,
    'expense_documentType': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.expense?.documentType,
    'expense_merchantName': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.expense?.merchantName,
    'expense_payment': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.expense?.payment,
    'expense_paymentMethod': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.expense?.paymentMethod,
    'expense_userMerchant': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.expense?.userMerchant,
    'mileage_category_id': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.mileage?.category?.id,
    'mileage_category_name': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.mileage?.category?.name,
    'mileage_id': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.mileage?.id,
    'mileage_category': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.mileage?.category,
    'owner_access_id': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.owner?.access?.id,
    'owner_access_avatar': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.owner?.access?.avatar,
    'owner_access_fullName': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.owner?.access?.fullName,
    'owner_legalEntity_id': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.owner?.legalEntity?.id,
    'owner_legalEntity_currency': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.owner?.legalEntity?.currency,
    'owner_id': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.owner?.id,
    'owner_access': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.owner?.access,
    'owner_legalEntity': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.owner?.legalEntity,
    'perDiem_category_id': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.perDiem?.category?.id,
    'perDiem_category_name': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.perDiem?.category?.name,
    'perDiem_id': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.perDiem?.id,
    'perDiem_category': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.perDiem?.category,
    'readyToReviewIssues_issues': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.readyToReviewIssues?.issues,
    'reporter_id': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.reporter?.id,
    'supplement_id': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.supplement?.id,
    'id': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.id,
    'amount': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.amount,
    'approvalFlowReason': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.approvalFlowReason,
    'company': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.company,
    'currency': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.currency,
    'currentApprovers': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.currentApprovers,
    'currentUserApprovalStatus': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.currentUserApprovalStatus,
    'description': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.description,
    'effectiveOn': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.effectiveOn,
    'expense': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.expense,
    'groupId': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.groupId,
    'internalReference': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.internalReference,
    'materializedApprovalFlowId': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.materializedApprovalFlowId,
    'materializedStepApproverId': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.materializedStepApproverId,
    'mileage': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.mileage,
    'owner': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.owner,
    'paidAt': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.paidAt,
    'perDiem': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.perDiem,
    'readyToReviewIssues': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.readyToReviewIssues,
    'reimbursableAmount': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.reimbursableAmount,
    'reimbursableCurrency': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.reimbursableCurrency,
    'reporter': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.reporter,
    'reviewRequestAt': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.reviewRequestAt,
    'spendingAlertsSource': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.spendingAlertsSource,
    'spendingAlertsTarget': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.spendingAlertsTarget,
    'status': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.status,
    'statusUpdatedAt': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.statusUpdatedAt,
    'supplement': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.supplement,
    'type': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.type,
    'createdAt': (edge: MyGroupedExpensablesDataTableDataSourceType) => edge.node.createdAt,
  }
}

export function buildMyGroupedExpensablesDataTableFilter(
  source: DataTableSource<MyGroupedExpensablesDataTableFields, typeof MyGroupedExpensablesDataTableSortableFields[number]>,
  filter: DataTableFilter<ExpensesExpensableFilter>
) {
  return filter
}

export function useMyGroupedExpensablesDataTable(
  projections: DataTableProjection<MyGroupedExpensablesDataTableFields, typeof MyGroupedExpensablesDataTableSortableFields[number]>[],
  options?: {
    variables?: MyGroupedExpensablesDataTableQueryVariables
    defaultSort?: typeof MyGroupedExpensablesDataTableSortableFields[number]
    identifier?: string
  }
): DataTableSource<MyGroupedExpensablesDataTableFields, typeof MyGroupedExpensablesDataTableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'MyGroupedExpensablesDataTable'

  return {
    identifier,
    query: MyGroupedExpensablesDataTableDocument,
    resolver: MyGroupedExpensablesDataTableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? MyGroupedExpensablesDataTableSortableFields.at(0),
      fields: MyGroupedExpensablesDataTableSortableFields,
    },
    variables
  }
}
export const ExpensableGroupsDataTableDocument = gql`
query ExpensableGroupsDataTable($companyId: Int!, $employeeIds: [Int!], $from: ISO8601DateTime, $includeDrafts: Boolean, $search: String, $to: ISO8601DateTime, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: ExpensesExpensableGroupFilter) {
  expenses {
    expensableGroupsConnection(
      companyId: $companyId
      employeeIds: $employeeIds
      from: $from
      includeDrafts: $includeDrafts
      search: $search
      to: $to
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          amount
          companyId
          currency
          description
          expensablesCount
          name
          owner {
            id
            access {
              id
              avatar
              fullName
            }
            legalEntity {
              id
              currency
            }
          }
          reimbursableAmount
          reimbursableCurrency
          reviewRequestAt
          status
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type ExpensableGroupsDataTableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<ExpensableGroupsDataTableQuery['expenses']>['expensableGroupsConnection']>['edges']
>

const ExpensableGroupsDataTableSortableFields = ['id', 'id', 'currency', 'reviewRequestAt', 'status'] as const

interface ExpensableGroupsDataTableFields {
  'owner_access_id': RevealType<['node', 'owner', 'access', 'id'], ExpensableGroupsDataTableDataSourceType>,
  'owner_access_avatar': RevealType<['node', 'owner', 'access', 'avatar'], ExpensableGroupsDataTableDataSourceType>,
  'owner_access_fullName': RevealType<['node', 'owner', 'access', 'fullName'], ExpensableGroupsDataTableDataSourceType>,
  'owner_legalEntity_id': RevealType<['node', 'owner', 'legalEntity', 'id'], ExpensableGroupsDataTableDataSourceType>,
  'owner_legalEntity_currency': RevealType<['node', 'owner', 'legalEntity', 'currency'], ExpensableGroupsDataTableDataSourceType>,
  'owner_id': RevealType<['node', 'owner', 'id'], ExpensableGroupsDataTableDataSourceType>,
  'owner_access': RevealType<['node', 'owner', 'access'], ExpensableGroupsDataTableDataSourceType>,
  'owner_legalEntity': RevealType<['node', 'owner', 'legalEntity'], ExpensableGroupsDataTableDataSourceType>,
  'id': RevealType<['node', 'id'], ExpensableGroupsDataTableDataSourceType>,
  'amount': RevealType<['node', 'amount'], ExpensableGroupsDataTableDataSourceType>,
  'companyId': RevealType<['node', 'companyId'], ExpensableGroupsDataTableDataSourceType>,
  'currency': RevealType<['node', 'currency'], ExpensableGroupsDataTableDataSourceType>,
  'description': RevealType<['node', 'description'], ExpensableGroupsDataTableDataSourceType>,
  'expensablesCount': RevealType<['node', 'expensablesCount'], ExpensableGroupsDataTableDataSourceType>,
  'name': RevealType<['node', 'name'], ExpensableGroupsDataTableDataSourceType>,
  'owner': RevealType<['node', 'owner'], ExpensableGroupsDataTableDataSourceType>,
  'reimbursableAmount': RevealType<['node', 'reimbursableAmount'], ExpensableGroupsDataTableDataSourceType>,
  'reimbursableCurrency': RevealType<['node', 'reimbursableCurrency'], ExpensableGroupsDataTableDataSourceType>,
  'reviewRequestAt': RevealType<['node', 'reviewRequestAt'], ExpensableGroupsDataTableDataSourceType>,
  'status': RevealType<['node', 'status'], ExpensableGroupsDataTableDataSourceType>
}

const ExpensableGroupsDataTableResolver = {
  dataSource: (data: ExpensableGroupsDataTableQuery) => data.expenses.expensableGroupsConnection,
  edges: (data: ExpensableGroupsDataTableQuery) => data.expenses.expensableGroupsConnection.edges,
  fields: {
    'owner_access_id': (edge: ExpensableGroupsDataTableDataSourceType) => edge.node.owner?.access?.id,
    'owner_access_avatar': (edge: ExpensableGroupsDataTableDataSourceType) => edge.node.owner?.access?.avatar,
    'owner_access_fullName': (edge: ExpensableGroupsDataTableDataSourceType) => edge.node.owner?.access?.fullName,
    'owner_legalEntity_id': (edge: ExpensableGroupsDataTableDataSourceType) => edge.node.owner?.legalEntity?.id,
    'owner_legalEntity_currency': (edge: ExpensableGroupsDataTableDataSourceType) => edge.node.owner?.legalEntity?.currency,
    'owner_id': (edge: ExpensableGroupsDataTableDataSourceType) => edge.node.owner?.id,
    'owner_access': (edge: ExpensableGroupsDataTableDataSourceType) => edge.node.owner?.access,
    'owner_legalEntity': (edge: ExpensableGroupsDataTableDataSourceType) => edge.node.owner?.legalEntity,
    'id': (edge: ExpensableGroupsDataTableDataSourceType) => edge.node.id,
    'amount': (edge: ExpensableGroupsDataTableDataSourceType) => edge.node.amount,
    'companyId': (edge: ExpensableGroupsDataTableDataSourceType) => edge.node.companyId,
    'currency': (edge: ExpensableGroupsDataTableDataSourceType) => edge.node.currency,
    'description': (edge: ExpensableGroupsDataTableDataSourceType) => edge.node.description,
    'expensablesCount': (edge: ExpensableGroupsDataTableDataSourceType) => edge.node.expensablesCount,
    'name': (edge: ExpensableGroupsDataTableDataSourceType) => edge.node.name,
    'owner': (edge: ExpensableGroupsDataTableDataSourceType) => edge.node.owner,
    'reimbursableAmount': (edge: ExpensableGroupsDataTableDataSourceType) => edge.node.reimbursableAmount,
    'reimbursableCurrency': (edge: ExpensableGroupsDataTableDataSourceType) => edge.node.reimbursableCurrency,
    'reviewRequestAt': (edge: ExpensableGroupsDataTableDataSourceType) => edge.node.reviewRequestAt,
    'status': (edge: ExpensableGroupsDataTableDataSourceType) => edge.node.status,
  }
}

export function buildExpensableGroupsDataTableFilter(
  source: DataTableSource<ExpensableGroupsDataTableFields, typeof ExpensableGroupsDataTableSortableFields[number]>,
  filter: DataTableFilter<ExpensesExpensableGroupFilter>
) {
  return filter
}

export function useExpensableGroupsDataTable(
  projections: DataTableProjection<ExpensableGroupsDataTableFields, typeof ExpensableGroupsDataTableSortableFields[number]>[],
  options?: {
    variables?: ExpensableGroupsDataTableQueryVariables
    defaultSort?: typeof ExpensableGroupsDataTableSortableFields[number]
    identifier?: string
  }
): DataTableSource<ExpensableGroupsDataTableFields, typeof ExpensableGroupsDataTableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'ExpensableGroupsDataTable'

  return {
    identifier,
    query: ExpensableGroupsDataTableDocument,
    resolver: ExpensableGroupsDataTableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? ExpensableGroupsDataTableSortableFields.at(0),
      fields: ExpensableGroupsDataTableSortableFields,
    },
    variables
  }
}
export const ExpensablesByCategoryTotalsDocument = gql`
query ExpensablesByCategoryTotals($companyId: Int!, $filters: ExpensesExpensableFiltersInput!, $from: String!, $to: String!, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: ExpensesExpensablesByCategoryTotalFilter) {
  expenses {
    expensablesByCategoryTotalsConnection(
      companyId: $companyId
      filters: $filters
      from: $from
      to: $to
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          customCategory(categoryLevel: all, statuses: [enabled, disabled], type: all) {
            id
            label
          }
          totalAmount
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type ExpensablesByCategoryTotalsDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<ExpensablesByCategoryTotalsQuery['expenses']>['expensablesByCategoryTotalsConnection']>['edges']
>

const ExpensablesByCategoryTotalsSortableFields = ['label', 'totalAmount'] as const

interface ExpensablesByCategoryTotalsFields {
  'customCategory_id': RevealType<['node', 'customCategory', 'id'], ExpensablesByCategoryTotalsDataSourceType>,
  'customCategory_label': RevealType<['node', 'customCategory', 'label'], ExpensablesByCategoryTotalsDataSourceType>,
  'customCategory': RevealType<['node', 'customCategory'], ExpensablesByCategoryTotalsDataSourceType>,
  'totalAmount': RevealType<['node', 'totalAmount'], ExpensablesByCategoryTotalsDataSourceType>
}

const ExpensablesByCategoryTotalsResolver = {
  dataSource: (data: ExpensablesByCategoryTotalsQuery) => data.expenses.expensablesByCategoryTotalsConnection,
  edges: (data: ExpensablesByCategoryTotalsQuery) => data.expenses.expensablesByCategoryTotalsConnection.edges,
  fields: {
    'customCategory_id': (edge: ExpensablesByCategoryTotalsDataSourceType) => edge.node.customCategory?.id,
    'customCategory_label': (edge: ExpensablesByCategoryTotalsDataSourceType) => edge.node.customCategory?.label,
    'customCategory': (edge: ExpensablesByCategoryTotalsDataSourceType) => edge.node.customCategory,
    'totalAmount': (edge: ExpensablesByCategoryTotalsDataSourceType) => edge.node.totalAmount,
  }
}

export function buildExpensablesByCategoryTotalsFilter(
  source: DataTableSource<ExpensablesByCategoryTotalsFields, typeof ExpensablesByCategoryTotalsSortableFields[number]>,
  filter: DataTableFilter<ExpensesExpensablesByCategoryTotalFilter>
) {
  return filter
}

export function useExpensablesByCategoryTotals(
  projections: DataTableProjection<ExpensablesByCategoryTotalsFields, typeof ExpensablesByCategoryTotalsSortableFields[number]>[],
  options?: {
    variables?: ExpensablesByCategoryTotalsQueryVariables
    defaultSort?: typeof ExpensablesByCategoryTotalsSortableFields[number]
    identifier?: string
  }
): DataTableSource<ExpensablesByCategoryTotalsFields, typeof ExpensablesByCategoryTotalsSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'ExpensablesByCategoryTotals'

  return {
    identifier,
    query: ExpensablesByCategoryTotalsDocument,
    resolver: ExpensablesByCategoryTotalsResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? ExpensablesByCategoryTotalsSortableFields.at(0),
      fields: ExpensablesByCategoryTotalsSortableFields,
    },
    variables
  }
}
export const ExpensablesByTeamDocument = gql`
query ExpensablesByTeam($companyId: Int!, $filters: ExpensesExpensableFiltersInput!, $from: String!, $to: String!, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: ExpensesExpensablesByTeamFilter) {
  expenses {
    expensablesByTeamsConnection(
      companyId: $companyId
      filters: $filters
      from: $from
      to: $to
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          team {
            id
            avatar
            name
          }
          totalAmount
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type ExpensablesByTeamDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<ExpensablesByTeamQuery['expenses']>['expensablesByTeamsConnection']>['edges']
>

const ExpensablesByTeamSortableFields = ['totalAmount'] as const

interface ExpensablesByTeamFields {
  'team_id': RevealType<['node', 'team', 'id'], ExpensablesByTeamDataSourceType>,
  'team_avatar': RevealType<['node', 'team', 'avatar'], ExpensablesByTeamDataSourceType>,
  'team_name': RevealType<['node', 'team', 'name'], ExpensablesByTeamDataSourceType>,
  'id': RevealType<['node', 'id'], ExpensablesByTeamDataSourceType>,
  'team': RevealType<['node', 'team'], ExpensablesByTeamDataSourceType>,
  'totalAmount': RevealType<['node', 'totalAmount'], ExpensablesByTeamDataSourceType>
}

const ExpensablesByTeamResolver = {
  dataSource: (data: ExpensablesByTeamQuery) => data.expenses.expensablesByTeamsConnection,
  edges: (data: ExpensablesByTeamQuery) => data.expenses.expensablesByTeamsConnection.edges,
  fields: {
    'team_id': (edge: ExpensablesByTeamDataSourceType) => edge.node.team?.id,
    'team_avatar': (edge: ExpensablesByTeamDataSourceType) => edge.node.team?.avatar,
    'team_name': (edge: ExpensablesByTeamDataSourceType) => edge.node.team?.name,
    'id': (edge: ExpensablesByTeamDataSourceType) => edge.node.id,
    'team': (edge: ExpensablesByTeamDataSourceType) => edge.node.team,
    'totalAmount': (edge: ExpensablesByTeamDataSourceType) => edge.node.totalAmount,
  }
}

export function buildExpensablesByTeamFilter(
  source: DataTableSource<ExpensablesByTeamFields, typeof ExpensablesByTeamSortableFields[number]>,
  filter: DataTableFilter<ExpensesExpensablesByTeamFilter>
) {
  return filter
}

export function useExpensablesByTeam(
  projections: DataTableProjection<ExpensablesByTeamFields, typeof ExpensablesByTeamSortableFields[number]>[],
  options?: {
    variables?: ExpensablesByTeamQueryVariables
    defaultSort?: typeof ExpensablesByTeamSortableFields[number]
    identifier?: string
  }
): DataTableSource<ExpensablesByTeamFields, typeof ExpensablesByTeamSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'ExpensablesByTeam'

  return {
    identifier,
    query: ExpensablesByTeamDocument,
    resolver: ExpensablesByTeamResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? ExpensablesByTeamSortableFields.at(0),
      fields: ExpensablesByTeamSortableFields,
    },
    variables
  }
}
export const ExpensesByCostCenterDatatableDocument = gql`
query ExpensesByCostCenterDatatable($companyId: Int!, $filters: ExpensesExpensableFiltersInput!, $from: String!, $to: String!, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: ExpensesExpensablesByCostCenterFilter) {
  expenses {
    expensablesByCostCentersConnection(
      companyId: $companyId
      filters: $filters
      from: $from
      to: $to
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          costCenter {
            id
            name
          }
          totalAmount
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type ExpensesByCostCenterDatatableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<ExpensesByCostCenterDatatableQuery['expenses']>['expensablesByCostCentersConnection']>['edges']
>

const ExpensesByCostCenterDatatableSortableFields = ['name', 'totalAmount'] as const

interface ExpensesByCostCenterDatatableFields {
  'costCenter_id': RevealType<['node', 'costCenter', 'id'], ExpensesByCostCenterDatatableDataSourceType>,
  'costCenter_name': RevealType<['node', 'costCenter', 'name'], ExpensesByCostCenterDatatableDataSourceType>,
  'costCenter': RevealType<['node', 'costCenter'], ExpensesByCostCenterDatatableDataSourceType>,
  'totalAmount': RevealType<['node', 'totalAmount'], ExpensesByCostCenterDatatableDataSourceType>
}

const ExpensesByCostCenterDatatableResolver = {
  dataSource: (data: ExpensesByCostCenterDatatableQuery) => data.expenses.expensablesByCostCentersConnection,
  edges: (data: ExpensesByCostCenterDatatableQuery) => data.expenses.expensablesByCostCentersConnection.edges,
  fields: {
    'costCenter_id': (edge: ExpensesByCostCenterDatatableDataSourceType) => edge.node.costCenter?.id,
    'costCenter_name': (edge: ExpensesByCostCenterDatatableDataSourceType) => edge.node.costCenter?.name,
    'costCenter': (edge: ExpensesByCostCenterDatatableDataSourceType) => edge.node.costCenter,
    'totalAmount': (edge: ExpensesByCostCenterDatatableDataSourceType) => edge.node.totalAmount,
  }
}

export function buildExpensesByCostCenterDatatableFilter(
  source: DataTableSource<ExpensesByCostCenterDatatableFields, typeof ExpensesByCostCenterDatatableSortableFields[number]>,
  filter: DataTableFilter<ExpensesExpensablesByCostCenterFilter>
) {
  return filter
}

export function useExpensesByCostCenterDatatable(
  projections: DataTableProjection<ExpensesByCostCenterDatatableFields, typeof ExpensesByCostCenterDatatableSortableFields[number]>[],
  options?: {
    variables?: ExpensesByCostCenterDatatableQueryVariables
    defaultSort?: typeof ExpensesByCostCenterDatatableSortableFields[number]
    identifier?: string
  }
): DataTableSource<ExpensesByCostCenterDatatableFields, typeof ExpensesByCostCenterDatatableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'ExpensesByCostCenterDatatable'

  return {
    identifier,
    query: ExpensesByCostCenterDatatableDocument,
    resolver: ExpensesByCostCenterDatatableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? ExpensesByCostCenterDatatableSortableFields.at(0),
      fields: ExpensesByCostCenterDatatableSortableFields,
    },
    variables
  }
}
export const ExpensesByEmployeeDatatableDocument = gql`
query ExpensesByEmployeeDatatable($companyId: Int!, $filters: ExpensesExpensableFiltersInput!, $from: String!, $to: String!, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: ExpensesExpensablesByEmployeeFilter) {
  expenses {
    expensablesByEmployeesConnection(
      companyId: $companyId
      filters: $filters
      from: $from
      to: $to
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          employee {
            id
            access {
              id
              avatar
              fullName
            }
          }
          totalAmount
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type ExpensesByEmployeeDatatableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<ExpensesByEmployeeDatatableQuery['expenses']>['expensablesByEmployeesConnection']>['edges']
>

const ExpensesByEmployeeDatatableSortableFields = ['id', 'id', 'totalAmount'] as const

interface ExpensesByEmployeeDatatableFields {
  'employee_access_id': RevealType<['node', 'employee', 'access', 'id'], ExpensesByEmployeeDatatableDataSourceType>,
  'employee_access_avatar': RevealType<['node', 'employee', 'access', 'avatar'], ExpensesByEmployeeDatatableDataSourceType>,
  'employee_access_fullName': RevealType<['node', 'employee', 'access', 'fullName'], ExpensesByEmployeeDatatableDataSourceType>,
  'employee_id': RevealType<['node', 'employee', 'id'], ExpensesByEmployeeDatatableDataSourceType>,
  'employee_access': RevealType<['node', 'employee', 'access'], ExpensesByEmployeeDatatableDataSourceType>,
  'employee': RevealType<['node', 'employee'], ExpensesByEmployeeDatatableDataSourceType>,
  'totalAmount': RevealType<['node', 'totalAmount'], ExpensesByEmployeeDatatableDataSourceType>
}

const ExpensesByEmployeeDatatableResolver = {
  dataSource: (data: ExpensesByEmployeeDatatableQuery) => data.expenses.expensablesByEmployeesConnection,
  edges: (data: ExpensesByEmployeeDatatableQuery) => data.expenses.expensablesByEmployeesConnection.edges,
  fields: {
    'employee_access_id': (edge: ExpensesByEmployeeDatatableDataSourceType) => edge.node.employee?.access?.id,
    'employee_access_avatar': (edge: ExpensesByEmployeeDatatableDataSourceType) => edge.node.employee?.access?.avatar,
    'employee_access_fullName': (edge: ExpensesByEmployeeDatatableDataSourceType) => edge.node.employee?.access?.fullName,
    'employee_id': (edge: ExpensesByEmployeeDatatableDataSourceType) => edge.node.employee?.id,
    'employee_access': (edge: ExpensesByEmployeeDatatableDataSourceType) => edge.node.employee?.access,
    'employee': (edge: ExpensesByEmployeeDatatableDataSourceType) => edge.node.employee,
    'totalAmount': (edge: ExpensesByEmployeeDatatableDataSourceType) => edge.node.totalAmount,
  }
}

export function buildExpensesByEmployeeDatatableFilter(
  source: DataTableSource<ExpensesByEmployeeDatatableFields, typeof ExpensesByEmployeeDatatableSortableFields[number]>,
  filter: DataTableFilter<ExpensesExpensablesByEmployeeFilter>
) {
  return filter
}

export function useExpensesByEmployeeDatatable(
  projections: DataTableProjection<ExpensesByEmployeeDatatableFields, typeof ExpensesByEmployeeDatatableSortableFields[number]>[],
  options?: {
    variables?: ExpensesByEmployeeDatatableQueryVariables
    defaultSort?: typeof ExpensesByEmployeeDatatableSortableFields[number]
    identifier?: string
  }
): DataTableSource<ExpensesByEmployeeDatatableFields, typeof ExpensesByEmployeeDatatableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'ExpensesByEmployeeDatatable'

  return {
    identifier,
    query: ExpensesByEmployeeDatatableDocument,
    resolver: ExpensesByEmployeeDatatableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? ExpensesByEmployeeDatatableSortableFields.at(0),
      fields: ExpensesByEmployeeDatatableSortableFields,
    },
    variables
  }
}
export const RateConfigurationsDatatableDocument = gql`
query RateConfigurationsDatatable($archivedOnly: Boolean, $companyId: Int!, $resourceType: String, $search: String, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: ExpensesRateConfigurationFilter) {
  expenses {
    rateConfigurationsConnection(
      archivedOnly: $archivedOnly
      companyId: $companyId
      resourceType: $resourceType
      search: $search
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          amountCents
          archivedAt
          currency
          legalEntitiesConnection {
            nodes {
              id
              legalName
            }
          }
          name
          rate
          rateAssigneesConnection {
            totalCount
          }
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type RateConfigurationsDatatableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<RateConfigurationsDatatableQuery['expenses']>['rateConfigurationsConnection']>['edges']
>

const RateConfigurationsDatatableSortableFields = ['id', 'amountCents', 'archivedAt', 'name', 'rate'] as const

interface RateConfigurationsDatatableFields {
  'legalEntitiesConnection_nodes': RevealType<['node', 'legalEntitiesConnection', 'nodes'], RateConfigurationsDatatableDataSourceType>,
  'rateAssigneesConnection_totalCount': RevealType<['node', 'rateAssigneesConnection', 'totalCount'], RateConfigurationsDatatableDataSourceType>,
  'id': RevealType<['node', 'id'], RateConfigurationsDatatableDataSourceType>,
  'amountCents': RevealType<['node', 'amountCents'], RateConfigurationsDatatableDataSourceType>,
  'archivedAt': RevealType<['node', 'archivedAt'], RateConfigurationsDatatableDataSourceType>,
  'currency': RevealType<['node', 'currency'], RateConfigurationsDatatableDataSourceType>,
  'legalEntitiesConnection': RevealType<['node', 'legalEntitiesConnection'], RateConfigurationsDatatableDataSourceType>,
  'name': RevealType<['node', 'name'], RateConfigurationsDatatableDataSourceType>,
  'rate': RevealType<['node', 'rate'], RateConfigurationsDatatableDataSourceType>,
  'rateAssigneesConnection': RevealType<['node', 'rateAssigneesConnection'], RateConfigurationsDatatableDataSourceType>
}

const RateConfigurationsDatatableResolver = {
  dataSource: (data: RateConfigurationsDatatableQuery) => data.expenses.rateConfigurationsConnection,
  edges: (data: RateConfigurationsDatatableQuery) => data.expenses.rateConfigurationsConnection.edges,
  fields: {
    'legalEntitiesConnection_nodes': (edge: RateConfigurationsDatatableDataSourceType) => edge.node.legalEntitiesConnection?.nodes,
    'rateAssigneesConnection_totalCount': (edge: RateConfigurationsDatatableDataSourceType) => edge.node.rateAssigneesConnection?.totalCount,
    'id': (edge: RateConfigurationsDatatableDataSourceType) => edge.node.id,
    'amountCents': (edge: RateConfigurationsDatatableDataSourceType) => edge.node.amountCents,
    'archivedAt': (edge: RateConfigurationsDatatableDataSourceType) => edge.node.archivedAt,
    'currency': (edge: RateConfigurationsDatatableDataSourceType) => edge.node.currency,
    'legalEntitiesConnection': (edge: RateConfigurationsDatatableDataSourceType) => edge.node.legalEntitiesConnection,
    'name': (edge: RateConfigurationsDatatableDataSourceType) => edge.node.name,
    'rate': (edge: RateConfigurationsDatatableDataSourceType) => edge.node.rate,
    'rateAssigneesConnection': (edge: RateConfigurationsDatatableDataSourceType) => edge.node.rateAssigneesConnection,
  }
}

export function buildRateConfigurationsDatatableFilter(
  source: DataTableSource<RateConfigurationsDatatableFields, typeof RateConfigurationsDatatableSortableFields[number]>,
  filter: DataTableFilter<ExpensesRateConfigurationFilter>
) {
  return filter
}

export function useRateConfigurationsDatatable(
  projections: DataTableProjection<RateConfigurationsDatatableFields, typeof RateConfigurationsDatatableSortableFields[number]>[],
  options?: {
    variables?: RateConfigurationsDatatableQueryVariables
    defaultSort?: typeof RateConfigurationsDatatableSortableFields[number]
    identifier?: string
  }
): DataTableSource<RateConfigurationsDatatableFields, typeof RateConfigurationsDatatableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'RateConfigurationsDatatable'

  return {
    identifier,
    query: RateConfigurationsDatatableDocument,
    resolver: RateConfigurationsDatatableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? RateConfigurationsDatatableSortableFields.at(0),
      fields: RateConfigurationsDatatableSortableFields,
    },
    variables
  }
}
export const RateConfigurationAssigneesDocument = gql`
query RateConfigurationAssignees($rateIds: [Int!], $search: String, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort) {
  expenses {
    rateConfigurationAssigneesConnection(
      rateIds: $rateIds
      search: $search
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          avatar
          fullName
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type RateConfigurationAssigneesDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<RateConfigurationAssigneesQuery['expenses']>['rateConfigurationAssigneesConnection']>['edges']
>

const RateConfigurationAssigneesSortableFields = [] as const

interface RateConfigurationAssigneesFields {
  'id': RevealType<['node', 'id'], RateConfigurationAssigneesDataSourceType>,
  'avatar': RevealType<['node', 'avatar'], RateConfigurationAssigneesDataSourceType>,
  'fullName': RevealType<['node', 'fullName'], RateConfigurationAssigneesDataSourceType>
}

const RateConfigurationAssigneesResolver = {
  dataSource: (data: RateConfigurationAssigneesQuery) => data.expenses.rateConfigurationAssigneesConnection,
  edges: (data: RateConfigurationAssigneesQuery) => data.expenses.rateConfigurationAssigneesConnection.edges,
  fields: {
    'id': (edge: RateConfigurationAssigneesDataSourceType) => edge.node.id,
    'avatar': (edge: RateConfigurationAssigneesDataSourceType) => edge.node.avatar,
    'fullName': (edge: RateConfigurationAssigneesDataSourceType) => edge.node.fullName,
  }
}

export function useRateConfigurationAssignees(
  projections: DataTableProjection<RateConfigurationAssigneesFields, typeof RateConfigurationAssigneesSortableFields[number]>[],
  options?: {
    variables?: RateConfigurationAssigneesQueryVariables
    defaultSort?: typeof RateConfigurationAssigneesSortableFields[number]
    identifier?: string
  }
): DataTableSource<RateConfigurationAssigneesFields, typeof RateConfigurationAssigneesSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'RateConfigurationAssignees'

  return {
    identifier,
    query: RateConfigurationAssigneesDocument,
    resolver: RateConfigurationAssigneesResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? RateConfigurationAssigneesSortableFields.at(0),
      fields: RateConfigurationAssigneesSortableFields,
    },
    variables
  }
}
export const LedgerAccountsDataTableDocument = gql`
query LedgerAccountsDataTable($projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: FinanceAccountFilter) {
  finance {
    accountsConnection(
      includeDisabled: true
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          balance
          currency
          disabled
          externalId
          legalEntityId
          name
          number
          type
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type LedgerAccountsDataTableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<LedgerAccountsDataTableQuery['finance']>['accountsConnection']>['edges']
>

const LedgerAccountsDataTableSortableFields = ['externalId', 'legalEntityId', 'name', 'number', 'type'] as const

interface LedgerAccountsDataTableFields {
  'id': RevealType<['node', 'id'], LedgerAccountsDataTableDataSourceType>,
  'balance': RevealType<['node', 'balance'], LedgerAccountsDataTableDataSourceType>,
  'currency': RevealType<['node', 'currency'], LedgerAccountsDataTableDataSourceType>,
  'disabled': RevealType<['node', 'disabled'], LedgerAccountsDataTableDataSourceType>,
  'externalId': RevealType<['node', 'externalId'], LedgerAccountsDataTableDataSourceType>,
  'legalEntityId': RevealType<['node', 'legalEntityId'], LedgerAccountsDataTableDataSourceType>,
  'name': RevealType<['node', 'name'], LedgerAccountsDataTableDataSourceType>,
  'number': RevealType<['node', 'number'], LedgerAccountsDataTableDataSourceType>,
  'type': RevealType<['node', 'type'], LedgerAccountsDataTableDataSourceType>
}

const LedgerAccountsDataTableResolver = {
  dataSource: (data: LedgerAccountsDataTableQuery) => data.finance.accountsConnection,
  edges: (data: LedgerAccountsDataTableQuery) => data.finance.accountsConnection.edges,
  fields: {
    'id': (edge: LedgerAccountsDataTableDataSourceType) => edge.node.id,
    'balance': (edge: LedgerAccountsDataTableDataSourceType) => edge.node.balance,
    'currency': (edge: LedgerAccountsDataTableDataSourceType) => edge.node.currency,
    'disabled': (edge: LedgerAccountsDataTableDataSourceType) => edge.node.disabled,
    'externalId': (edge: LedgerAccountsDataTableDataSourceType) => edge.node.externalId,
    'legalEntityId': (edge: LedgerAccountsDataTableDataSourceType) => edge.node.legalEntityId,
    'name': (edge: LedgerAccountsDataTableDataSourceType) => edge.node.name,
    'number': (edge: LedgerAccountsDataTableDataSourceType) => edge.node.number,
    'type': (edge: LedgerAccountsDataTableDataSourceType) => edge.node.type,
  }
}

export function buildLedgerAccountsDataTableFilter(
  source: DataTableSource<LedgerAccountsDataTableFields, typeof LedgerAccountsDataTableSortableFields[number]>,
  filter: DataTableFilter<FinanceAccountFilter>
) {
  return filter
}

export function useLedgerAccountsDataTable(
  projections: DataTableProjection<LedgerAccountsDataTableFields, typeof LedgerAccountsDataTableSortableFields[number]>[],
  options?: {
    variables?: LedgerAccountsDataTableQueryVariables
    defaultSort?: typeof LedgerAccountsDataTableSortableFields[number]
    identifier?: string
  }
): DataTableSource<LedgerAccountsDataTableFields, typeof LedgerAccountsDataTableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'LedgerAccountsDataTable'

  return {
    identifier,
    query: LedgerAccountsDataTableDocument,
    resolver: LedgerAccountsDataTableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? LedgerAccountsDataTableSortableFields.at(0),
      fields: LedgerAccountsDataTableSortableFields,
    },
    variables
  }
}
export const MissingAgreementDataTableDocument = gql`
query MissingAgreementDataTable($costCenterIds: [Int!] = [], $formattedEndDate: String!, $formattedStartDate: String!, $includeFuturePeriods: Boolean = true, $legalEntityIds: [Int!] = [], $locationIds: [Int!] = [], $managerIds: [Int!] = [], $period: FinancialWorkspaceValueObjectsPeriodEnum!, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort) {
  financialWorkspace {
    employeesIncompleteGrossSalariesConnection(
      costCenterIds: $costCenterIds
      formattedEndDate: $formattedEndDate
      formattedStartDate: $formattedStartDate
      includeFuturePeriods: $includeFuturePeriods
      legalEntityIds: $legalEntityIds
      locationIds: $locationIds
      managerIds: $managerIds
      period: $period
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          effectiveOn
          endsOn
          fullName
          startsOn
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type MissingAgreementDataTableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<MissingAgreementDataTableQuery['financialWorkspace']>['employeesIncompleteGrossSalariesConnection']>['edges']
>

const MissingAgreementDataTableSortableFields = [] as const

interface MissingAgreementDataTableFields {
  'id': RevealType<['node', 'id'], MissingAgreementDataTableDataSourceType>,
  'effectiveOn': RevealType<['node', 'effectiveOn'], MissingAgreementDataTableDataSourceType>,
  'endsOn': RevealType<['node', 'endsOn'], MissingAgreementDataTableDataSourceType>,
  'fullName': RevealType<['node', 'fullName'], MissingAgreementDataTableDataSourceType>,
  'startsOn': RevealType<['node', 'startsOn'], MissingAgreementDataTableDataSourceType>
}

const MissingAgreementDataTableResolver = {
  dataSource: (data: MissingAgreementDataTableQuery) => data.financialWorkspace.employeesIncompleteGrossSalariesConnection,
  edges: (data: MissingAgreementDataTableQuery) => data.financialWorkspace.employeesIncompleteGrossSalariesConnection.edges,
  fields: {
    'id': (edge: MissingAgreementDataTableDataSourceType) => edge.node.id,
    'effectiveOn': (edge: MissingAgreementDataTableDataSourceType) => edge.node.effectiveOn,
    'endsOn': (edge: MissingAgreementDataTableDataSourceType) => edge.node.endsOn,
    'fullName': (edge: MissingAgreementDataTableDataSourceType) => edge.node.fullName,
    'startsOn': (edge: MissingAgreementDataTableDataSourceType) => edge.node.startsOn,
  }
}

export function useMissingAgreementDataTable(
  projections: DataTableProjection<MissingAgreementDataTableFields, typeof MissingAgreementDataTableSortableFields[number]>[],
  options?: {
    variables?: MissingAgreementDataTableQueryVariables
    defaultSort?: typeof MissingAgreementDataTableSortableFields[number]
    identifier?: string
  }
): DataTableSource<MissingAgreementDataTableFields, typeof MissingAgreementDataTableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'MissingAgreementDataTable'

  return {
    identifier,
    query: MissingAgreementDataTableDocument,
    resolver: MissingAgreementDataTableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? MissingAgreementDataTableSortableFields.at(0),
      fields: MissingAgreementDataTableSortableFields,
    },
    variables
  }
}
export const InvoicesDataTableDocument = gql`
query InvoicesDataTable($companyId: Int!, $documentTypes: [FinanceValueObjectsFinancialDocumentTypeEnum!], $operationTypes: [FinanceValueObjectsFinancialDocumentOperationTypeEnum!], $search: String, $vendorId: Int, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: FinanceFinancialDocumentFilter) {
  finance {
    financialDocumentsConnection(
      companyId: $companyId
      documentTypes: $documentTypes
      operationTypes: $operationTypes
      search: $search
      vendorId: $vendorId
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          companyId
          currency
          documentDate
          documentNumber
          documentType
          dueDate
          duplicateFinancialDocumentId
          legalEntity(companiesIds: [$companyId]) {
            id
            legalName
          }
          status
          taxes {
            amountCents
            baseAmountCents
            percentage
          }
          totalAmountCents
          validatedAt
          vendor(companyId: $companyId) {
            id
            companyId
            iban
            legalName
            name
          }
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type InvoicesDataTableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<InvoicesDataTableQuery['finance']>['financialDocumentsConnection']>['edges']
>

const InvoicesDataTableSortableFields = ['legalName', 'companyId', 'iban', 'legalName', 'name', 'currency', 'documentDate', 'documentNumber', 'documentType', 'dueDate', 'status', 'totalAmountCents'] as const

interface InvoicesDataTableFields {
  'legalEntity_id': RevealType<['node', 'legalEntity', 'id'], InvoicesDataTableDataSourceType>,
  'legalEntity_legalName': RevealType<['node', 'legalEntity', 'legalName'], InvoicesDataTableDataSourceType>,
  'vendor_id': RevealType<['node', 'vendor', 'id'], InvoicesDataTableDataSourceType>,
  'vendor_companyId': RevealType<['node', 'vendor', 'companyId'], InvoicesDataTableDataSourceType>,
  'vendor_iban': RevealType<['node', 'vendor', 'iban'], InvoicesDataTableDataSourceType>,
  'vendor_legalName': RevealType<['node', 'vendor', 'legalName'], InvoicesDataTableDataSourceType>,
  'vendor_name': RevealType<['node', 'vendor', 'name'], InvoicesDataTableDataSourceType>,
  'id': RevealType<['node', 'id'], InvoicesDataTableDataSourceType>,
  'companyId': RevealType<['node', 'companyId'], InvoicesDataTableDataSourceType>,
  'currency': RevealType<['node', 'currency'], InvoicesDataTableDataSourceType>,
  'documentDate': RevealType<['node', 'documentDate'], InvoicesDataTableDataSourceType>,
  'documentNumber': RevealType<['node', 'documentNumber'], InvoicesDataTableDataSourceType>,
  'documentType': RevealType<['node', 'documentType'], InvoicesDataTableDataSourceType>,
  'dueDate': RevealType<['node', 'dueDate'], InvoicesDataTableDataSourceType>,
  'duplicateFinancialDocumentId': RevealType<['node', 'duplicateFinancialDocumentId'], InvoicesDataTableDataSourceType>,
  'legalEntity': RevealType<['node', 'legalEntity'], InvoicesDataTableDataSourceType>,
  'status': RevealType<['node', 'status'], InvoicesDataTableDataSourceType>,
  'taxes': RevealType<['node', 'taxes'], InvoicesDataTableDataSourceType>,
  'totalAmountCents': RevealType<['node', 'totalAmountCents'], InvoicesDataTableDataSourceType>,
  'validatedAt': RevealType<['node', 'validatedAt'], InvoicesDataTableDataSourceType>,
  'vendor': RevealType<['node', 'vendor'], InvoicesDataTableDataSourceType>
}

const InvoicesDataTableResolver = {
  dataSource: (data: InvoicesDataTableQuery) => data.finance.financialDocumentsConnection,
  edges: (data: InvoicesDataTableQuery) => data.finance.financialDocumentsConnection.edges,
  fields: {
    'legalEntity_id': (edge: InvoicesDataTableDataSourceType) => edge.node.legalEntity?.id,
    'legalEntity_legalName': (edge: InvoicesDataTableDataSourceType) => edge.node.legalEntity?.legalName,
    'vendor_id': (edge: InvoicesDataTableDataSourceType) => edge.node.vendor?.id,
    'vendor_companyId': (edge: InvoicesDataTableDataSourceType) => edge.node.vendor?.companyId,
    'vendor_iban': (edge: InvoicesDataTableDataSourceType) => edge.node.vendor?.iban,
    'vendor_legalName': (edge: InvoicesDataTableDataSourceType) => edge.node.vendor?.legalName,
    'vendor_name': (edge: InvoicesDataTableDataSourceType) => edge.node.vendor?.name,
    'id': (edge: InvoicesDataTableDataSourceType) => edge.node.id,
    'companyId': (edge: InvoicesDataTableDataSourceType) => edge.node.companyId,
    'currency': (edge: InvoicesDataTableDataSourceType) => edge.node.currency,
    'documentDate': (edge: InvoicesDataTableDataSourceType) => edge.node.documentDate,
    'documentNumber': (edge: InvoicesDataTableDataSourceType) => edge.node.documentNumber,
    'documentType': (edge: InvoicesDataTableDataSourceType) => edge.node.documentType,
    'dueDate': (edge: InvoicesDataTableDataSourceType) => edge.node.dueDate,
    'duplicateFinancialDocumentId': (edge: InvoicesDataTableDataSourceType) => edge.node.duplicateFinancialDocumentId,
    'legalEntity': (edge: InvoicesDataTableDataSourceType) => edge.node.legalEntity,
    'status': (edge: InvoicesDataTableDataSourceType) => edge.node.status,
    'taxes': (edge: InvoicesDataTableDataSourceType) => edge.node.taxes,
    'totalAmountCents': (edge: InvoicesDataTableDataSourceType) => edge.node.totalAmountCents,
    'validatedAt': (edge: InvoicesDataTableDataSourceType) => edge.node.validatedAt,
    'vendor': (edge: InvoicesDataTableDataSourceType) => edge.node.vendor,
  }
}

export function buildInvoicesDataTableFilter(
  source: DataTableSource<InvoicesDataTableFields, typeof InvoicesDataTableSortableFields[number]>,
  filter: DataTableFilter<FinanceFinancialDocumentFilter>
) {
  return filter
}

export function useInvoicesDataTable(
  projections: DataTableProjection<InvoicesDataTableFields, typeof InvoicesDataTableSortableFields[number]>[],
  options?: {
    variables?: InvoicesDataTableQueryVariables
    defaultSort?: typeof InvoicesDataTableSortableFields[number]
    identifier?: string
  }
): DataTableSource<InvoicesDataTableFields, typeof InvoicesDataTableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'InvoicesDataTable'

  return {
    identifier,
    query: InvoicesDataTableDocument,
    resolver: InvoicesDataTableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? InvoicesDataTableSortableFields.at(0),
      fields: InvoicesDataTableSortableFields,
    },
    variables
  }
}
export const JournalDraftEntryDatableDocument = gql`
query JournalDraftEntryDatable($companyId: Int!, $legalEntityIds: [Int!]!, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: FinanceJournalDraftEntryFilter) {
  finance {
    journalDraftEntriesConnection(
      companyId: $companyId
      legalEntityIds: $legalEntityIds
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          description
          financialDocument(companyId: $companyId) {
            id
            documentNumber
          }
          journalDraftLines(companyId: $companyId) {
            id
            creditAmountCents
            debitAmountCents
          }
          legalEntity {
            id
            currency
          }
          referenceDate
          status
          type
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type JournalDraftEntryDatableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<JournalDraftEntryDatableQuery['finance']>['journalDraftEntriesConnection']>['edges']
>

const JournalDraftEntryDatableSortableFields = ['documentNumber', 'referenceDate', 'status', 'type'] as const

interface JournalDraftEntryDatableFields {
  'financialDocument_id': RevealType<['node', 'financialDocument', 'id'], JournalDraftEntryDatableDataSourceType>,
  'financialDocument_documentNumber': RevealType<['node', 'financialDocument', 'documentNumber'], JournalDraftEntryDatableDataSourceType>,
  'legalEntity_id': RevealType<['node', 'legalEntity', 'id'], JournalDraftEntryDatableDataSourceType>,
  'legalEntity_currency': RevealType<['node', 'legalEntity', 'currency'], JournalDraftEntryDatableDataSourceType>,
  'id': RevealType<['node', 'id'], JournalDraftEntryDatableDataSourceType>,
  'description': RevealType<['node', 'description'], JournalDraftEntryDatableDataSourceType>,
  'financialDocument': RevealType<['node', 'financialDocument'], JournalDraftEntryDatableDataSourceType>,
  'journalDraftLines': RevealType<['node', 'journalDraftLines'], JournalDraftEntryDatableDataSourceType>,
  'legalEntity': RevealType<['node', 'legalEntity'], JournalDraftEntryDatableDataSourceType>,
  'referenceDate': RevealType<['node', 'referenceDate'], JournalDraftEntryDatableDataSourceType>,
  'status': RevealType<['node', 'status'], JournalDraftEntryDatableDataSourceType>,
  'type': RevealType<['node', 'type'], JournalDraftEntryDatableDataSourceType>
}

const JournalDraftEntryDatableResolver = {
  dataSource: (data: JournalDraftEntryDatableQuery) => data.finance.journalDraftEntriesConnection,
  edges: (data: JournalDraftEntryDatableQuery) => data.finance.journalDraftEntriesConnection.edges,
  fields: {
    'financialDocument_id': (edge: JournalDraftEntryDatableDataSourceType) => edge.node.financialDocument?.id,
    'financialDocument_documentNumber': (edge: JournalDraftEntryDatableDataSourceType) => edge.node.financialDocument?.documentNumber,
    'legalEntity_id': (edge: JournalDraftEntryDatableDataSourceType) => edge.node.legalEntity?.id,
    'legalEntity_currency': (edge: JournalDraftEntryDatableDataSourceType) => edge.node.legalEntity?.currency,
    'id': (edge: JournalDraftEntryDatableDataSourceType) => edge.node.id,
    'description': (edge: JournalDraftEntryDatableDataSourceType) => edge.node.description,
    'financialDocument': (edge: JournalDraftEntryDatableDataSourceType) => edge.node.financialDocument,
    'journalDraftLines': (edge: JournalDraftEntryDatableDataSourceType) => edge.node.journalDraftLines,
    'legalEntity': (edge: JournalDraftEntryDatableDataSourceType) => edge.node.legalEntity,
    'referenceDate': (edge: JournalDraftEntryDatableDataSourceType) => edge.node.referenceDate,
    'status': (edge: JournalDraftEntryDatableDataSourceType) => edge.node.status,
    'type': (edge: JournalDraftEntryDatableDataSourceType) => edge.node.type,
  }
}

export function buildJournalDraftEntryDatableFilter(
  source: DataTableSource<JournalDraftEntryDatableFields, typeof JournalDraftEntryDatableSortableFields[number]>,
  filter: DataTableFilter<FinanceJournalDraftEntryFilter>
) {
  return filter
}

export function useJournalDraftEntryDatable(
  projections: DataTableProjection<JournalDraftEntryDatableFields, typeof JournalDraftEntryDatableSortableFields[number]>[],
  options?: {
    variables?: JournalDraftEntryDatableQueryVariables
    defaultSort?: typeof JournalDraftEntryDatableSortableFields[number]
    identifier?: string
  }
): DataTableSource<JournalDraftEntryDatableFields, typeof JournalDraftEntryDatableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'JournalDraftEntryDatable'

  return {
    identifier,
    query: JournalDraftEntryDatableDocument,
    resolver: JournalDraftEntryDatableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? JournalDraftEntryDatableSortableFields.at(0),
      fields: JournalDraftEntryDatableSortableFields,
    },
    variables
  }
}
export const JournalEntryDatableDocument = gql`
query JournalEntryDatable($companyId: Int!, $legalEntityIds: [Int!]!, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: FinanceJournalEntryFilter) {
  finance {
    journalEntriesConnection(
      legalEntityIds: $legalEntityIds
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          description
          financialDocument(companyId: $companyId) {
            id
            documentNumber
          }
          journalLines {
            id
            creditAmountCents
            debitAmountCents
          }
          legalEntity {
            id
            currency
          }
          number
          publishedAt
          status
          type
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type JournalEntryDatableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<JournalEntryDatableQuery['finance']>['journalEntriesConnection']>['edges']
>

const JournalEntryDatableSortableFields = ['documentNumber', 'id', 'description', 'number', 'publishedAt', 'status', 'type'] as const

interface JournalEntryDatableFields {
  'financialDocument_id': RevealType<['node', 'financialDocument', 'id'], JournalEntryDatableDataSourceType>,
  'financialDocument_documentNumber': RevealType<['node', 'financialDocument', 'documentNumber'], JournalEntryDatableDataSourceType>,
  'legalEntity_id': RevealType<['node', 'legalEntity', 'id'], JournalEntryDatableDataSourceType>,
  'legalEntity_currency': RevealType<['node', 'legalEntity', 'currency'], JournalEntryDatableDataSourceType>,
  'id': RevealType<['node', 'id'], JournalEntryDatableDataSourceType>,
  'description': RevealType<['node', 'description'], JournalEntryDatableDataSourceType>,
  'financialDocument': RevealType<['node', 'financialDocument'], JournalEntryDatableDataSourceType>,
  'journalLines': RevealType<['node', 'journalLines'], JournalEntryDatableDataSourceType>,
  'legalEntity': RevealType<['node', 'legalEntity'], JournalEntryDatableDataSourceType>,
  'number': RevealType<['node', 'number'], JournalEntryDatableDataSourceType>,
  'publishedAt': RevealType<['node', 'publishedAt'], JournalEntryDatableDataSourceType>,
  'status': RevealType<['node', 'status'], JournalEntryDatableDataSourceType>,
  'type': RevealType<['node', 'type'], JournalEntryDatableDataSourceType>
}

const JournalEntryDatableResolver = {
  dataSource: (data: JournalEntryDatableQuery) => data.finance.journalEntriesConnection,
  edges: (data: JournalEntryDatableQuery) => data.finance.journalEntriesConnection.edges,
  fields: {
    'financialDocument_id': (edge: JournalEntryDatableDataSourceType) => edge.node.financialDocument?.id,
    'financialDocument_documentNumber': (edge: JournalEntryDatableDataSourceType) => edge.node.financialDocument?.documentNumber,
    'legalEntity_id': (edge: JournalEntryDatableDataSourceType) => edge.node.legalEntity?.id,
    'legalEntity_currency': (edge: JournalEntryDatableDataSourceType) => edge.node.legalEntity?.currency,
    'id': (edge: JournalEntryDatableDataSourceType) => edge.node.id,
    'description': (edge: JournalEntryDatableDataSourceType) => edge.node.description,
    'financialDocument': (edge: JournalEntryDatableDataSourceType) => edge.node.financialDocument,
    'journalLines': (edge: JournalEntryDatableDataSourceType) => edge.node.journalLines,
    'legalEntity': (edge: JournalEntryDatableDataSourceType) => edge.node.legalEntity,
    'number': (edge: JournalEntryDatableDataSourceType) => edge.node.number,
    'publishedAt': (edge: JournalEntryDatableDataSourceType) => edge.node.publishedAt,
    'status': (edge: JournalEntryDatableDataSourceType) => edge.node.status,
    'type': (edge: JournalEntryDatableDataSourceType) => edge.node.type,
  }
}

export function buildJournalEntryDatableFilter(
  source: DataTableSource<JournalEntryDatableFields, typeof JournalEntryDatableSortableFields[number]>,
  filter: DataTableFilter<FinanceJournalEntryFilter>
) {
  return filter
}

export function useJournalEntryDatable(
  projections: DataTableProjection<JournalEntryDatableFields, typeof JournalEntryDatableSortableFields[number]>[],
  options?: {
    variables?: JournalEntryDatableQueryVariables
    defaultSort?: typeof JournalEntryDatableSortableFields[number]
    identifier?: string
  }
): DataTableSource<JournalEntryDatableFields, typeof JournalEntryDatableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'JournalEntryDatable'

  return {
    identifier,
    query: JournalEntryDatableDocument,
    resolver: JournalEntryDatableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? JournalEntryDatableSortableFields.at(0),
      fields: JournalEntryDatableSortableFields,
    },
    variables
  }
}
export const LedgerAccountDetailDataTableDocument = gql`
query LedgerAccountDetailDataTable($ledgerAccountId: Int!, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: FinanceJournalLineFilter) {
  finance {
    journalLinesConnection(
      accountIds: [$ledgerAccountId]
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          creditAmountCents
          debitAmountCents
          journalEntry {
            id
            description
            number
            publishedAt
            referenceDate
          }
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type LedgerAccountDetailDataTableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<LedgerAccountDetailDataTableQuery['finance']>['journalLinesConnection']>['edges']
>

const LedgerAccountDetailDataTableSortableFields = ['id', 'description', 'number', 'publishedAt', 'referenceDate', 'id', 'creditAmountCents', 'debitAmountCents'] as const

interface LedgerAccountDetailDataTableFields {
  'journalEntry_id': RevealType<['node', 'journalEntry', 'id'], LedgerAccountDetailDataTableDataSourceType>,
  'journalEntry_description': RevealType<['node', 'journalEntry', 'description'], LedgerAccountDetailDataTableDataSourceType>,
  'journalEntry_number': RevealType<['node', 'journalEntry', 'number'], LedgerAccountDetailDataTableDataSourceType>,
  'journalEntry_publishedAt': RevealType<['node', 'journalEntry', 'publishedAt'], LedgerAccountDetailDataTableDataSourceType>,
  'journalEntry_referenceDate': RevealType<['node', 'journalEntry', 'referenceDate'], LedgerAccountDetailDataTableDataSourceType>,
  'id': RevealType<['node', 'id'], LedgerAccountDetailDataTableDataSourceType>,
  'creditAmountCents': RevealType<['node', 'creditAmountCents'], LedgerAccountDetailDataTableDataSourceType>,
  'debitAmountCents': RevealType<['node', 'debitAmountCents'], LedgerAccountDetailDataTableDataSourceType>,
  'journalEntry': RevealType<['node', 'journalEntry'], LedgerAccountDetailDataTableDataSourceType>
}

const LedgerAccountDetailDataTableResolver = {
  dataSource: (data: LedgerAccountDetailDataTableQuery) => data.finance.journalLinesConnection,
  edges: (data: LedgerAccountDetailDataTableQuery) => data.finance.journalLinesConnection.edges,
  fields: {
    'journalEntry_id': (edge: LedgerAccountDetailDataTableDataSourceType) => edge.node.journalEntry?.id,
    'journalEntry_description': (edge: LedgerAccountDetailDataTableDataSourceType) => edge.node.journalEntry?.description,
    'journalEntry_number': (edge: LedgerAccountDetailDataTableDataSourceType) => edge.node.journalEntry?.number,
    'journalEntry_publishedAt': (edge: LedgerAccountDetailDataTableDataSourceType) => edge.node.journalEntry?.publishedAt,
    'journalEntry_referenceDate': (edge: LedgerAccountDetailDataTableDataSourceType) => edge.node.journalEntry?.referenceDate,
    'id': (edge: LedgerAccountDetailDataTableDataSourceType) => edge.node.id,
    'creditAmountCents': (edge: LedgerAccountDetailDataTableDataSourceType) => edge.node.creditAmountCents,
    'debitAmountCents': (edge: LedgerAccountDetailDataTableDataSourceType) => edge.node.debitAmountCents,
    'journalEntry': (edge: LedgerAccountDetailDataTableDataSourceType) => edge.node.journalEntry,
  }
}

export function buildLedgerAccountDetailDataTableFilter(
  source: DataTableSource<LedgerAccountDetailDataTableFields, typeof LedgerAccountDetailDataTableSortableFields[number]>,
  filter: DataTableFilter<FinanceJournalLineFilter>
) {
  return filter
}

export function useLedgerAccountDetailDataTable(
  projections: DataTableProjection<LedgerAccountDetailDataTableFields, typeof LedgerAccountDetailDataTableSortableFields[number]>[],
  options?: {
    variables?: LedgerAccountDetailDataTableQueryVariables
    defaultSort?: typeof LedgerAccountDetailDataTableSortableFields[number]
    identifier?: string
  }
): DataTableSource<LedgerAccountDetailDataTableFields, typeof LedgerAccountDetailDataTableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'LedgerAccountDetailDataTable'

  return {
    identifier,
    query: LedgerAccountDetailDataTableDocument,
    resolver: LedgerAccountDetailDataTableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? LedgerAccountDetailDataTableSortableFields.at(0),
      fields: LedgerAccountDetailDataTableSortableFields,
    },
    variables
  }
}
export const ReconciliationJournalLinesDataTableDocument = gql`
query ReconciliationJournalLinesDataTable($allowedJournalEntryTypes: [FinanceValueObjectsJournalEntryTypeEnum!], $balanceTypes: [FinanceValueObjectsLedgerAccountBalanceTypeEnum!], $bySuspenseAccount: Boolean, $currency: String, $description: String, $excludingJournalEntryTypes: [FinanceValueObjectsJournalEntryTypeEnum!], $reconcilable: Boolean, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: FinanceJournalLineFilter) {
  finance {
    journalLinesConnection(
      balanceTypes: $balanceTypes
      bySuspenseAccount: $bySuspenseAccount
      currency: $currency
      description: $description
      excludingJournalEntryTypes: $excludingJournalEntryTypes
      journalEntryTypes: $allowedJournalEntryTypes
      reconcilable: $reconcilable
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          creditAmountCents
          debitAmountCents
          fullyReconciledAt
          journalEntry {
            id
            description
            number
            publishedAt
            referenceDate
          }
          reconcilableReconciliations {
            id
            journalLineReconciledAmountCents
            reconcilableReconciledAmountCents
          }
          reconciliations {
            id
            journalLineReconciledAmountCents
            reconcilableReconciledAmountCents
          }
          snoozedUntil
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type ReconciliationJournalLinesDataTableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<ReconciliationJournalLinesDataTableQuery['finance']>['journalLinesConnection']>['edges']
>

const ReconciliationJournalLinesDataTableSortableFields = ['id', 'description', 'number', 'publishedAt', 'referenceDate', 'id', 'creditAmountCents', 'debitAmountCents'] as const

interface ReconciliationJournalLinesDataTableFields {
  'journalEntry_id': RevealType<['node', 'journalEntry', 'id'], ReconciliationJournalLinesDataTableDataSourceType>,
  'journalEntry_description': RevealType<['node', 'journalEntry', 'description'], ReconciliationJournalLinesDataTableDataSourceType>,
  'journalEntry_number': RevealType<['node', 'journalEntry', 'number'], ReconciliationJournalLinesDataTableDataSourceType>,
  'journalEntry_publishedAt': RevealType<['node', 'journalEntry', 'publishedAt'], ReconciliationJournalLinesDataTableDataSourceType>,
  'journalEntry_referenceDate': RevealType<['node', 'journalEntry', 'referenceDate'], ReconciliationJournalLinesDataTableDataSourceType>,
  'id': RevealType<['node', 'id'], ReconciliationJournalLinesDataTableDataSourceType>,
  'creditAmountCents': RevealType<['node', 'creditAmountCents'], ReconciliationJournalLinesDataTableDataSourceType>,
  'debitAmountCents': RevealType<['node', 'debitAmountCents'], ReconciliationJournalLinesDataTableDataSourceType>,
  'fullyReconciledAt': RevealType<['node', 'fullyReconciledAt'], ReconciliationJournalLinesDataTableDataSourceType>,
  'journalEntry': RevealType<['node', 'journalEntry'], ReconciliationJournalLinesDataTableDataSourceType>,
  'reconcilableReconciliations': RevealType<['node', 'reconcilableReconciliations'], ReconciliationJournalLinesDataTableDataSourceType>,
  'reconciliations': RevealType<['node', 'reconciliations'], ReconciliationJournalLinesDataTableDataSourceType>,
  'snoozedUntil': RevealType<['node', 'snoozedUntil'], ReconciliationJournalLinesDataTableDataSourceType>
}

const ReconciliationJournalLinesDataTableResolver = {
  dataSource: (data: ReconciliationJournalLinesDataTableQuery) => data.finance.journalLinesConnection,
  edges: (data: ReconciliationJournalLinesDataTableQuery) => data.finance.journalLinesConnection.edges,
  fields: {
    'journalEntry_id': (edge: ReconciliationJournalLinesDataTableDataSourceType) => edge.node.journalEntry?.id,
    'journalEntry_description': (edge: ReconciliationJournalLinesDataTableDataSourceType) => edge.node.journalEntry?.description,
    'journalEntry_number': (edge: ReconciliationJournalLinesDataTableDataSourceType) => edge.node.journalEntry?.number,
    'journalEntry_publishedAt': (edge: ReconciliationJournalLinesDataTableDataSourceType) => edge.node.journalEntry?.publishedAt,
    'journalEntry_referenceDate': (edge: ReconciliationJournalLinesDataTableDataSourceType) => edge.node.journalEntry?.referenceDate,
    'id': (edge: ReconciliationJournalLinesDataTableDataSourceType) => edge.node.id,
    'creditAmountCents': (edge: ReconciliationJournalLinesDataTableDataSourceType) => edge.node.creditAmountCents,
    'debitAmountCents': (edge: ReconciliationJournalLinesDataTableDataSourceType) => edge.node.debitAmountCents,
    'fullyReconciledAt': (edge: ReconciliationJournalLinesDataTableDataSourceType) => edge.node.fullyReconciledAt,
    'journalEntry': (edge: ReconciliationJournalLinesDataTableDataSourceType) => edge.node.journalEntry,
    'reconcilableReconciliations': (edge: ReconciliationJournalLinesDataTableDataSourceType) => edge.node.reconcilableReconciliations,
    'reconciliations': (edge: ReconciliationJournalLinesDataTableDataSourceType) => edge.node.reconciliations,
    'snoozedUntil': (edge: ReconciliationJournalLinesDataTableDataSourceType) => edge.node.snoozedUntil,
  }
}

export function buildReconciliationJournalLinesDataTableFilter(
  source: DataTableSource<ReconciliationJournalLinesDataTableFields, typeof ReconciliationJournalLinesDataTableSortableFields[number]>,
  filter: DataTableFilter<FinanceJournalLineFilter>
) {
  return filter
}

export function useReconciliationJournalLinesDataTable(
  projections: DataTableProjection<ReconciliationJournalLinesDataTableFields, typeof ReconciliationJournalLinesDataTableSortableFields[number]>[],
  options?: {
    variables?: ReconciliationJournalLinesDataTableQueryVariables
    defaultSort?: typeof ReconciliationJournalLinesDataTableSortableFields[number]
    identifier?: string
  }
): DataTableSource<ReconciliationJournalLinesDataTableFields, typeof ReconciliationJournalLinesDataTableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'ReconciliationJournalLinesDataTable'

  return {
    identifier,
    query: ReconciliationJournalLinesDataTableDocument,
    resolver: ReconciliationJournalLinesDataTableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? ReconciliationJournalLinesDataTableSortableFields.at(0),
      fields: ReconciliationJournalLinesDataTableSortableFields,
    },
    variables
  }
}
export const ReconciliationBankJournalLinesDataTableDocument = gql`
query ReconciliationBankJournalLinesDataTable($bankAccountIds: [Int!], $description: String, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: FinanceJournalLineFilter) {
  finance {
    journalLinesConnection(
      bankAccountIds: $bankAccountIds
      bySuspenseAccount: true
      description: $description
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          creditAmountCents
          debitAmountCents
          fullyReconciledAt
          journalEntry {
            id
            description
            number
            publishedAt
            referenceDate
          }
          reconciliations {
            id
            journalLineReconciledAmountCents
          }
          snoozedUntil
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type ReconciliationBankJournalLinesDataTableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<ReconciliationBankJournalLinesDataTableQuery['finance']>['journalLinesConnection']>['edges']
>

const ReconciliationBankJournalLinesDataTableSortableFields = ['id', 'description', 'number', 'publishedAt', 'referenceDate', 'id', 'creditAmountCents', 'debitAmountCents'] as const

interface ReconciliationBankJournalLinesDataTableFields {
  'journalEntry_id': RevealType<['node', 'journalEntry', 'id'], ReconciliationBankJournalLinesDataTableDataSourceType>,
  'journalEntry_description': RevealType<['node', 'journalEntry', 'description'], ReconciliationBankJournalLinesDataTableDataSourceType>,
  'journalEntry_number': RevealType<['node', 'journalEntry', 'number'], ReconciliationBankJournalLinesDataTableDataSourceType>,
  'journalEntry_publishedAt': RevealType<['node', 'journalEntry', 'publishedAt'], ReconciliationBankJournalLinesDataTableDataSourceType>,
  'journalEntry_referenceDate': RevealType<['node', 'journalEntry', 'referenceDate'], ReconciliationBankJournalLinesDataTableDataSourceType>,
  'id': RevealType<['node', 'id'], ReconciliationBankJournalLinesDataTableDataSourceType>,
  'creditAmountCents': RevealType<['node', 'creditAmountCents'], ReconciliationBankJournalLinesDataTableDataSourceType>,
  'debitAmountCents': RevealType<['node', 'debitAmountCents'], ReconciliationBankJournalLinesDataTableDataSourceType>,
  'fullyReconciledAt': RevealType<['node', 'fullyReconciledAt'], ReconciliationBankJournalLinesDataTableDataSourceType>,
  'journalEntry': RevealType<['node', 'journalEntry'], ReconciliationBankJournalLinesDataTableDataSourceType>,
  'reconciliations': RevealType<['node', 'reconciliations'], ReconciliationBankJournalLinesDataTableDataSourceType>,
  'snoozedUntil': RevealType<['node', 'snoozedUntil'], ReconciliationBankJournalLinesDataTableDataSourceType>
}

const ReconciliationBankJournalLinesDataTableResolver = {
  dataSource: (data: ReconciliationBankJournalLinesDataTableQuery) => data.finance.journalLinesConnection,
  edges: (data: ReconciliationBankJournalLinesDataTableQuery) => data.finance.journalLinesConnection.edges,
  fields: {
    'journalEntry_id': (edge: ReconciliationBankJournalLinesDataTableDataSourceType) => edge.node.journalEntry?.id,
    'journalEntry_description': (edge: ReconciliationBankJournalLinesDataTableDataSourceType) => edge.node.journalEntry?.description,
    'journalEntry_number': (edge: ReconciliationBankJournalLinesDataTableDataSourceType) => edge.node.journalEntry?.number,
    'journalEntry_publishedAt': (edge: ReconciliationBankJournalLinesDataTableDataSourceType) => edge.node.journalEntry?.publishedAt,
    'journalEntry_referenceDate': (edge: ReconciliationBankJournalLinesDataTableDataSourceType) => edge.node.journalEntry?.referenceDate,
    'id': (edge: ReconciliationBankJournalLinesDataTableDataSourceType) => edge.node.id,
    'creditAmountCents': (edge: ReconciliationBankJournalLinesDataTableDataSourceType) => edge.node.creditAmountCents,
    'debitAmountCents': (edge: ReconciliationBankJournalLinesDataTableDataSourceType) => edge.node.debitAmountCents,
    'fullyReconciledAt': (edge: ReconciliationBankJournalLinesDataTableDataSourceType) => edge.node.fullyReconciledAt,
    'journalEntry': (edge: ReconciliationBankJournalLinesDataTableDataSourceType) => edge.node.journalEntry,
    'reconciliations': (edge: ReconciliationBankJournalLinesDataTableDataSourceType) => edge.node.reconciliations,
    'snoozedUntil': (edge: ReconciliationBankJournalLinesDataTableDataSourceType) => edge.node.snoozedUntil,
  }
}

export function buildReconciliationBankJournalLinesDataTableFilter(
  source: DataTableSource<ReconciliationBankJournalLinesDataTableFields, typeof ReconciliationBankJournalLinesDataTableSortableFields[number]>,
  filter: DataTableFilter<FinanceJournalLineFilter>
) {
  return filter
}

export function useReconciliationBankJournalLinesDataTable(
  projections: DataTableProjection<ReconciliationBankJournalLinesDataTableFields, typeof ReconciliationBankJournalLinesDataTableSortableFields[number]>[],
  options?: {
    variables?: ReconciliationBankJournalLinesDataTableQueryVariables
    defaultSort?: typeof ReconciliationBankJournalLinesDataTableSortableFields[number]
    identifier?: string
  }
): DataTableSource<ReconciliationBankJournalLinesDataTableFields, typeof ReconciliationBankJournalLinesDataTableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'ReconciliationBankJournalLinesDataTable'

  return {
    identifier,
    query: ReconciliationBankJournalLinesDataTableDocument,
    resolver: ReconciliationBankJournalLinesDataTableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? ReconciliationBankJournalLinesDataTableSortableFields.at(0),
      fields: ReconciliationBankJournalLinesDataTableSortableFields,
    },
    variables
  }
}
export const TaxTypeDatableDocument = gql`
query TaxTypeDatable($search: String, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: FinanceTaxTypeFilter) {
  finance {
    taxTypesConnection(
      search: $search
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          countryCode
          name
          source
          type
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type TaxTypeDatableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<TaxTypeDatableQuery['finance']>['taxTypesConnection']>['edges']
>

const TaxTypeDatableSortableFields = ['countryCode', 'name', 'source', 'type'] as const

interface TaxTypeDatableFields {
  'id': RevealType<['node', 'id'], TaxTypeDatableDataSourceType>,
  'countryCode': RevealType<['node', 'countryCode'], TaxTypeDatableDataSourceType>,
  'name': RevealType<['node', 'name'], TaxTypeDatableDataSourceType>,
  'source': RevealType<['node', 'source'], TaxTypeDatableDataSourceType>,
  'type': RevealType<['node', 'type'], TaxTypeDatableDataSourceType>
}

const TaxTypeDatableResolver = {
  dataSource: (data: TaxTypeDatableQuery) => data.finance.taxTypesConnection,
  edges: (data: TaxTypeDatableQuery) => data.finance.taxTypesConnection.edges,
  fields: {
    'id': (edge: TaxTypeDatableDataSourceType) => edge.node.id,
    'countryCode': (edge: TaxTypeDatableDataSourceType) => edge.node.countryCode,
    'name': (edge: TaxTypeDatableDataSourceType) => edge.node.name,
    'source': (edge: TaxTypeDatableDataSourceType) => edge.node.source,
    'type': (edge: TaxTypeDatableDataSourceType) => edge.node.type,
  }
}

export function buildTaxTypeDatableFilter(
  source: DataTableSource<TaxTypeDatableFields, typeof TaxTypeDatableSortableFields[number]>,
  filter: DataTableFilter<FinanceTaxTypeFilter>
) {
  return filter
}

export function useTaxTypeDatable(
  projections: DataTableProjection<TaxTypeDatableFields, typeof TaxTypeDatableSortableFields[number]>[],
  options?: {
    variables?: TaxTypeDatableQueryVariables
    defaultSort?: typeof TaxTypeDatableSortableFields[number]
    identifier?: string
  }
): DataTableSource<TaxTypeDatableFields, typeof TaxTypeDatableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'TaxTypeDatable'

  return {
    identifier,
    query: TaxTypeDatableDocument,
    resolver: TaxTypeDatableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? TaxTypeDatableSortableFields.at(0),
      fields: TaxTypeDatableSortableFields,
    },
    variables
  }
}
export const BudgetMovementsDatatableDocument = gql`
query BudgetMovementsDatatable($id: Int!, $periodEnd: ISO8601DateTime, $periodStart: ISO8601DateTime, $search: String, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: FinanceBudgetMovementFilter) {
  finance {
    budgetMovementsConnection(
      budgetId: [$id]
      excludeDrafts: true
      periodEnd: $periodEnd
      periodStart: $periodStart
      search: $search
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          amountCents
          budget {
            currency
          }
          convertedAt
          effectiveAt
          employee {
            id
            avatar {
              url
            }
            fullName
            legalEntity {
              legalName
            }
          }
          exchangeRate
          expensable {
            id
            amount
            currency
            expense {
              category {
                name
              }
              reimbursableAmount
              reimbursableCurrency
            }
            mileage {
              category {
                name
              }
            }
            perDiem {
              category {
                name
              }
            }
            status
          }
          resourceId
          sourceCurrency
          targetCurrency
          targetCurrency
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type BudgetMovementsDatatableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<BudgetMovementsDatatableQuery['finance']>['budgetMovementsConnection']>['edges']
>

const BudgetMovementsDatatableSortableFields = ['legalName', 'id', 'fullName', 'amount', 'currency', 'status', 'id', 'amountCents', 'effectiveAt'] as const

interface BudgetMovementsDatatableFields {
  'budget_currency': RevealType<['node', 'budget', 'currency'], BudgetMovementsDatatableDataSourceType>,
  'employee_avatar_url': RevealType<['node', 'employee', 'avatar', 'url'], BudgetMovementsDatatableDataSourceType>,
  'employee_legalEntity_legalName': RevealType<['node', 'employee', 'legalEntity', 'legalName'], BudgetMovementsDatatableDataSourceType>,
  'employee_id': RevealType<['node', 'employee', 'id'], BudgetMovementsDatatableDataSourceType>,
  'employee_avatar': RevealType<['node', 'employee', 'avatar'], BudgetMovementsDatatableDataSourceType>,
  'employee_fullName': RevealType<['node', 'employee', 'fullName'], BudgetMovementsDatatableDataSourceType>,
  'employee_legalEntity': RevealType<['node', 'employee', 'legalEntity'], BudgetMovementsDatatableDataSourceType>,
  'expensable_expense_category_name': RevealType<['node', 'expensable', 'expense', 'category', 'name'], BudgetMovementsDatatableDataSourceType>,
  'expensable_expense_category': RevealType<['node', 'expensable', 'expense', 'category'], BudgetMovementsDatatableDataSourceType>,
  'expensable_expense_reimbursableAmount': RevealType<['node', 'expensable', 'expense', 'reimbursableAmount'], BudgetMovementsDatatableDataSourceType>,
  'expensable_expense_reimbursableCurrency': RevealType<['node', 'expensable', 'expense', 'reimbursableCurrency'], BudgetMovementsDatatableDataSourceType>,
  'expensable_mileage_category_name': RevealType<['node', 'expensable', 'mileage', 'category', 'name'], BudgetMovementsDatatableDataSourceType>,
  'expensable_mileage_category': RevealType<['node', 'expensable', 'mileage', 'category'], BudgetMovementsDatatableDataSourceType>,
  'expensable_perDiem_category_name': RevealType<['node', 'expensable', 'perDiem', 'category', 'name'], BudgetMovementsDatatableDataSourceType>,
  'expensable_perDiem_category': RevealType<['node', 'expensable', 'perDiem', 'category'], BudgetMovementsDatatableDataSourceType>,
  'expensable_id': RevealType<['node', 'expensable', 'id'], BudgetMovementsDatatableDataSourceType>,
  'expensable_amount': RevealType<['node', 'expensable', 'amount'], BudgetMovementsDatatableDataSourceType>,
  'expensable_currency': RevealType<['node', 'expensable', 'currency'], BudgetMovementsDatatableDataSourceType>,
  'expensable_expense': RevealType<['node', 'expensable', 'expense'], BudgetMovementsDatatableDataSourceType>,
  'expensable_mileage': RevealType<['node', 'expensable', 'mileage'], BudgetMovementsDatatableDataSourceType>,
  'expensable_perDiem': RevealType<['node', 'expensable', 'perDiem'], BudgetMovementsDatatableDataSourceType>,
  'expensable_status': RevealType<['node', 'expensable', 'status'], BudgetMovementsDatatableDataSourceType>,
  'id': RevealType<['node', 'id'], BudgetMovementsDatatableDataSourceType>,
  'amountCents': RevealType<['node', 'amountCents'], BudgetMovementsDatatableDataSourceType>,
  'budget': RevealType<['node', 'budget'], BudgetMovementsDatatableDataSourceType>,
  'convertedAt': RevealType<['node', 'convertedAt'], BudgetMovementsDatatableDataSourceType>,
  'effectiveAt': RevealType<['node', 'effectiveAt'], BudgetMovementsDatatableDataSourceType>,
  'employee': RevealType<['node', 'employee'], BudgetMovementsDatatableDataSourceType>,
  'exchangeRate': RevealType<['node', 'exchangeRate'], BudgetMovementsDatatableDataSourceType>,
  'expensable': RevealType<['node', 'expensable'], BudgetMovementsDatatableDataSourceType>,
  'resourceId': RevealType<['node', 'resourceId'], BudgetMovementsDatatableDataSourceType>,
  'sourceCurrency': RevealType<['node', 'sourceCurrency'], BudgetMovementsDatatableDataSourceType>,
  'targetCurrency': RevealType<['node', 'targetCurrency'], BudgetMovementsDatatableDataSourceType>
}

const BudgetMovementsDatatableResolver = {
  dataSource: (data: BudgetMovementsDatatableQuery) => data.finance.budgetMovementsConnection,
  edges: (data: BudgetMovementsDatatableQuery) => data.finance.budgetMovementsConnection.edges,
  fields: {
    'budget_currency': (edge: BudgetMovementsDatatableDataSourceType) => edge.node.budget?.currency,
    'employee_avatar_url': (edge: BudgetMovementsDatatableDataSourceType) => edge.node.employee?.avatar?.url,
    'employee_legalEntity_legalName': (edge: BudgetMovementsDatatableDataSourceType) => edge.node.employee?.legalEntity?.legalName,
    'employee_id': (edge: BudgetMovementsDatatableDataSourceType) => edge.node.employee?.id,
    'employee_avatar': (edge: BudgetMovementsDatatableDataSourceType) => edge.node.employee?.avatar,
    'employee_fullName': (edge: BudgetMovementsDatatableDataSourceType) => edge.node.employee?.fullName,
    'employee_legalEntity': (edge: BudgetMovementsDatatableDataSourceType) => edge.node.employee?.legalEntity,
    'expensable_expense_category_name': (edge: BudgetMovementsDatatableDataSourceType) => edge.node.expensable?.expense?.category?.name,
    'expensable_expense_category': (edge: BudgetMovementsDatatableDataSourceType) => edge.node.expensable?.expense?.category,
    'expensable_expense_reimbursableAmount': (edge: BudgetMovementsDatatableDataSourceType) => edge.node.expensable?.expense?.reimbursableAmount,
    'expensable_expense_reimbursableCurrency': (edge: BudgetMovementsDatatableDataSourceType) => edge.node.expensable?.expense?.reimbursableCurrency,
    'expensable_mileage_category_name': (edge: BudgetMovementsDatatableDataSourceType) => edge.node.expensable?.mileage?.category?.name,
    'expensable_mileage_category': (edge: BudgetMovementsDatatableDataSourceType) => edge.node.expensable?.mileage?.category,
    'expensable_perDiem_category_name': (edge: BudgetMovementsDatatableDataSourceType) => edge.node.expensable?.perDiem?.category?.name,
    'expensable_perDiem_category': (edge: BudgetMovementsDatatableDataSourceType) => edge.node.expensable?.perDiem?.category,
    'expensable_id': (edge: BudgetMovementsDatatableDataSourceType) => edge.node.expensable?.id,
    'expensable_amount': (edge: BudgetMovementsDatatableDataSourceType) => edge.node.expensable?.amount,
    'expensable_currency': (edge: BudgetMovementsDatatableDataSourceType) => edge.node.expensable?.currency,
    'expensable_expense': (edge: BudgetMovementsDatatableDataSourceType) => edge.node.expensable?.expense,
    'expensable_mileage': (edge: BudgetMovementsDatatableDataSourceType) => edge.node.expensable?.mileage,
    'expensable_perDiem': (edge: BudgetMovementsDatatableDataSourceType) => edge.node.expensable?.perDiem,
    'expensable_status': (edge: BudgetMovementsDatatableDataSourceType) => edge.node.expensable?.status,
    'id': (edge: BudgetMovementsDatatableDataSourceType) => edge.node.id,
    'amountCents': (edge: BudgetMovementsDatatableDataSourceType) => edge.node.amountCents,
    'budget': (edge: BudgetMovementsDatatableDataSourceType) => edge.node.budget,
    'convertedAt': (edge: BudgetMovementsDatatableDataSourceType) => edge.node.convertedAt,
    'effectiveAt': (edge: BudgetMovementsDatatableDataSourceType) => edge.node.effectiveAt,
    'employee': (edge: BudgetMovementsDatatableDataSourceType) => edge.node.employee,
    'exchangeRate': (edge: BudgetMovementsDatatableDataSourceType) => edge.node.exchangeRate,
    'expensable': (edge: BudgetMovementsDatatableDataSourceType) => edge.node.expensable,
    'resourceId': (edge: BudgetMovementsDatatableDataSourceType) => edge.node.resourceId,
    'sourceCurrency': (edge: BudgetMovementsDatatableDataSourceType) => edge.node.sourceCurrency,
    'targetCurrency': (edge: BudgetMovementsDatatableDataSourceType) => edge.node.targetCurrency,
  }
}

export function buildBudgetMovementsDatatableFilter(
  source: DataTableSource<BudgetMovementsDatatableFields, typeof BudgetMovementsDatatableSortableFields[number]>,
  filter: DataTableFilter<FinanceBudgetMovementFilter>
) {
  return filter
}

export function useBudgetMovementsDatatable(
  projections: DataTableProjection<BudgetMovementsDatatableFields, typeof BudgetMovementsDatatableSortableFields[number]>[],
  options?: {
    variables?: BudgetMovementsDatatableQueryVariables
    defaultSort?: typeof BudgetMovementsDatatableSortableFields[number]
    identifier?: string
  }
): DataTableSource<BudgetMovementsDatatableFields, typeof BudgetMovementsDatatableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'BudgetMovementsDatatable'

  return {
    identifier,
    query: BudgetMovementsDatatableDocument,
    resolver: BudgetMovementsDatatableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? BudgetMovementsDatatableSortableFields.at(0),
      fields: BudgetMovementsDatatableSortableFields,
    },
    variables
  }
}
export const BudgetEmployeesDatatableDocument = gql`
query BudgetEmployeesDatatable($id: Int!, $periodEnd: ISO8601DateTime, $periodStart: ISO8601DateTime, $search: String, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: FinanceBudgetAllocationFilter) {
  finance {
    budgetAllocationsConnection(
      budgetIds: [$id]
      excludeDrafts: true
      periodEnd: $periodEnd
      periodStart: $periodStart
      search: $search
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          amountCents
          availableAmountCents
          employee {
            id
            avatar {
              id
              url
            }
            fullName
          }
          reportedAmountCents
          status
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type BudgetEmployeesDatatableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<BudgetEmployeesDatatableQuery['finance']>['budgetAllocationsConnection']>['edges']
>

const BudgetEmployeesDatatableSortableFields = ['id', 'fullName', 'id', 'amountCents'] as const

interface BudgetEmployeesDatatableFields {
  'employee_avatar_id': RevealType<['node', 'employee', 'avatar', 'id'], BudgetEmployeesDatatableDataSourceType>,
  'employee_avatar_url': RevealType<['node', 'employee', 'avatar', 'url'], BudgetEmployeesDatatableDataSourceType>,
  'employee_id': RevealType<['node', 'employee', 'id'], BudgetEmployeesDatatableDataSourceType>,
  'employee_avatar': RevealType<['node', 'employee', 'avatar'], BudgetEmployeesDatatableDataSourceType>,
  'employee_fullName': RevealType<['node', 'employee', 'fullName'], BudgetEmployeesDatatableDataSourceType>,
  'id': RevealType<['node', 'id'], BudgetEmployeesDatatableDataSourceType>,
  'amountCents': RevealType<['node', 'amountCents'], BudgetEmployeesDatatableDataSourceType>,
  'availableAmountCents': RevealType<['node', 'availableAmountCents'], BudgetEmployeesDatatableDataSourceType>,
  'employee': RevealType<['node', 'employee'], BudgetEmployeesDatatableDataSourceType>,
  'reportedAmountCents': RevealType<['node', 'reportedAmountCents'], BudgetEmployeesDatatableDataSourceType>,
  'status': RevealType<['node', 'status'], BudgetEmployeesDatatableDataSourceType>
}

const BudgetEmployeesDatatableResolver = {
  dataSource: (data: BudgetEmployeesDatatableQuery) => data.finance.budgetAllocationsConnection,
  edges: (data: BudgetEmployeesDatatableQuery) => data.finance.budgetAllocationsConnection.edges,
  fields: {
    'employee_avatar_id': (edge: BudgetEmployeesDatatableDataSourceType) => edge.node.employee?.avatar?.id,
    'employee_avatar_url': (edge: BudgetEmployeesDatatableDataSourceType) => edge.node.employee?.avatar?.url,
    'employee_id': (edge: BudgetEmployeesDatatableDataSourceType) => edge.node.employee?.id,
    'employee_avatar': (edge: BudgetEmployeesDatatableDataSourceType) => edge.node.employee?.avatar,
    'employee_fullName': (edge: BudgetEmployeesDatatableDataSourceType) => edge.node.employee?.fullName,
    'id': (edge: BudgetEmployeesDatatableDataSourceType) => edge.node.id,
    'amountCents': (edge: BudgetEmployeesDatatableDataSourceType) => edge.node.amountCents,
    'availableAmountCents': (edge: BudgetEmployeesDatatableDataSourceType) => edge.node.availableAmountCents,
    'employee': (edge: BudgetEmployeesDatatableDataSourceType) => edge.node.employee,
    'reportedAmountCents': (edge: BudgetEmployeesDatatableDataSourceType) => edge.node.reportedAmountCents,
    'status': (edge: BudgetEmployeesDatatableDataSourceType) => edge.node.status,
  }
}

export function buildBudgetEmployeesDatatableFilter(
  source: DataTableSource<BudgetEmployeesDatatableFields, typeof BudgetEmployeesDatatableSortableFields[number]>,
  filter: DataTableFilter<FinanceBudgetAllocationFilter>
) {
  return filter
}

export function useBudgetEmployeesDatatable(
  projections: DataTableProjection<BudgetEmployeesDatatableFields, typeof BudgetEmployeesDatatableSortableFields[number]>[],
  options?: {
    variables?: BudgetEmployeesDatatableQueryVariables
    defaultSort?: typeof BudgetEmployeesDatatableSortableFields[number]
    identifier?: string
  }
): DataTableSource<BudgetEmployeesDatatableFields, typeof BudgetEmployeesDatatableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'BudgetEmployeesDatatable'

  return {
    identifier,
    query: BudgetEmployeesDatatableDocument,
    resolver: BudgetEmployeesDatatableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? BudgetEmployeesDatatableSortableFields.at(0),
      fields: BudgetEmployeesDatatableSortableFields,
    },
    variables
  }
}
export const FinanceDimensionValuesDataTableDocument = gql`
query FinanceDimensionValuesDataTable($dimensionId: Int!, $tenant: FinanceTenantInput, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: FinanceCustomDimensionValueFilter) {
  finance {
    customDimensionValuesConnection(
      customDimensionIds: [$dimensionId]
      tenant: $tenant
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          code
          description
          legalEntity {
            id
            legalName
          }
          name
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type FinanceDimensionValuesDataTableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<FinanceDimensionValuesDataTableQuery['finance']>['customDimensionValuesConnection']>['edges']
>

const FinanceDimensionValuesDataTableSortableFields = ['legalName'] as const

interface FinanceDimensionValuesDataTableFields {
  'legalEntity_id': RevealType<['node', 'legalEntity', 'id'], FinanceDimensionValuesDataTableDataSourceType>,
  'legalEntity_legalName': RevealType<['node', 'legalEntity', 'legalName'], FinanceDimensionValuesDataTableDataSourceType>,
  'id': RevealType<['node', 'id'], FinanceDimensionValuesDataTableDataSourceType>,
  'code': RevealType<['node', 'code'], FinanceDimensionValuesDataTableDataSourceType>,
  'description': RevealType<['node', 'description'], FinanceDimensionValuesDataTableDataSourceType>,
  'legalEntity': RevealType<['node', 'legalEntity'], FinanceDimensionValuesDataTableDataSourceType>,
  'name': RevealType<['node', 'name'], FinanceDimensionValuesDataTableDataSourceType>
}

const FinanceDimensionValuesDataTableResolver = {
  dataSource: (data: FinanceDimensionValuesDataTableQuery) => data.finance.customDimensionValuesConnection,
  edges: (data: FinanceDimensionValuesDataTableQuery) => data.finance.customDimensionValuesConnection.edges,
  fields: {
    'legalEntity_id': (edge: FinanceDimensionValuesDataTableDataSourceType) => edge.node.legalEntity?.id,
    'legalEntity_legalName': (edge: FinanceDimensionValuesDataTableDataSourceType) => edge.node.legalEntity?.legalName,
    'id': (edge: FinanceDimensionValuesDataTableDataSourceType) => edge.node.id,
    'code': (edge: FinanceDimensionValuesDataTableDataSourceType) => edge.node.code,
    'description': (edge: FinanceDimensionValuesDataTableDataSourceType) => edge.node.description,
    'legalEntity': (edge: FinanceDimensionValuesDataTableDataSourceType) => edge.node.legalEntity,
    'name': (edge: FinanceDimensionValuesDataTableDataSourceType) => edge.node.name,
  }
}

export function buildFinanceDimensionValuesDataTableFilter(
  source: DataTableSource<FinanceDimensionValuesDataTableFields, typeof FinanceDimensionValuesDataTableSortableFields[number]>,
  filter: DataTableFilter<FinanceCustomDimensionValueFilter>
) {
  return filter
}

export function useFinanceDimensionValuesDataTable(
  projections: DataTableProjection<FinanceDimensionValuesDataTableFields, typeof FinanceDimensionValuesDataTableSortableFields[number]>[],
  options?: {
    variables?: FinanceDimensionValuesDataTableQueryVariables
    defaultSort?: typeof FinanceDimensionValuesDataTableSortableFields[number]
    identifier?: string
  }
): DataTableSource<FinanceDimensionValuesDataTableFields, typeof FinanceDimensionValuesDataTableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'FinanceDimensionValuesDataTable'

  return {
    identifier,
    query: FinanceDimensionValuesDataTableDocument,
    resolver: FinanceDimensionValuesDataTableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? FinanceDimensionValuesDataTableSortableFields.at(0),
      fields: FinanceDimensionValuesDataTableSortableFields,
    },
    variables
  }
}
export const PerformanceGoalsMetricGroupDataTableDocument = gql`
query PerformanceGoalsMetricGroupDataTable($cycleIds: [String!], $noCycle: Boolean, $search: String, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: GoalsMetricGroupFilter) {
  goals {
    metricGroupsConnection(
      cycleIds: $cycleIds
      noCycle: $noCycle
      search: $search
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          _policies {
            update {
              id
              can
            }
          }
          assigneesConnection(first: 5) {
            edges {
              node {
                id
                access {
                  id
                  avatar
                }
                fullName
              }
            }
            totalCount
          }
          description
          performanceCycles {
            id
            companyId
            endOn
            startOn
            title
          }
          public
          summary {
            averageProgress
            metricsCount
            needsAttention
          }
          title
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type PerformanceGoalsMetricGroupDataTableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<PerformanceGoalsMetricGroupDataTableQuery['goals']>['metricGroupsConnection']>['edges']
>

const PerformanceGoalsMetricGroupDataTableSortableFields = ['title'] as const

interface PerformanceGoalsMetricGroupDataTableFields {
  '_policies_update_id': RevealType<['node', '_policies', 'update', 'id'], PerformanceGoalsMetricGroupDataTableDataSourceType>,
  '_policies_update_can': RevealType<['node', '_policies', 'update', 'can'], PerformanceGoalsMetricGroupDataTableDataSourceType>,
  '_policies_update': RevealType<['node', '_policies', 'update'], PerformanceGoalsMetricGroupDataTableDataSourceType>,
  'assigneesConnection_edges': RevealType<['node', 'assigneesConnection', 'edges'], PerformanceGoalsMetricGroupDataTableDataSourceType>,
  'assigneesConnection_totalCount': RevealType<['node', 'assigneesConnection', 'totalCount'], PerformanceGoalsMetricGroupDataTableDataSourceType>,
  'summary_averageProgress': RevealType<['node', 'summary', 'averageProgress'], PerformanceGoalsMetricGroupDataTableDataSourceType>,
  'summary_metricsCount': RevealType<['node', 'summary', 'metricsCount'], PerformanceGoalsMetricGroupDataTableDataSourceType>,
  'summary_needsAttention': RevealType<['node', 'summary', 'needsAttention'], PerformanceGoalsMetricGroupDataTableDataSourceType>,
  'id': RevealType<['node', 'id'], PerformanceGoalsMetricGroupDataTableDataSourceType>,
  '_policies': RevealType<['node', '_policies'], PerformanceGoalsMetricGroupDataTableDataSourceType>,
  'assigneesConnection': RevealType<['node', 'assigneesConnection'], PerformanceGoalsMetricGroupDataTableDataSourceType>,
  'description': RevealType<['node', 'description'], PerformanceGoalsMetricGroupDataTableDataSourceType>,
  'performanceCycles': RevealType<['node', 'performanceCycles'], PerformanceGoalsMetricGroupDataTableDataSourceType>,
  'public': RevealType<['node', 'public'], PerformanceGoalsMetricGroupDataTableDataSourceType>,
  'summary': RevealType<['node', 'summary'], PerformanceGoalsMetricGroupDataTableDataSourceType>,
  'title': RevealType<['node', 'title'], PerformanceGoalsMetricGroupDataTableDataSourceType>
}

const PerformanceGoalsMetricGroupDataTableResolver = {
  dataSource: (data: PerformanceGoalsMetricGroupDataTableQuery) => data.goals.metricGroupsConnection,
  edges: (data: PerformanceGoalsMetricGroupDataTableQuery) => data.goals.metricGroupsConnection.edges,
  fields: {
    '_policies_update_id': (edge: PerformanceGoalsMetricGroupDataTableDataSourceType) => edge.node._policies?.update?.id,
    '_policies_update_can': (edge: PerformanceGoalsMetricGroupDataTableDataSourceType) => edge.node._policies?.update?.can,
    '_policies_update': (edge: PerformanceGoalsMetricGroupDataTableDataSourceType) => edge.node._policies?.update,
    'assigneesConnection_edges': (edge: PerformanceGoalsMetricGroupDataTableDataSourceType) => edge.node.assigneesConnection?.edges,
    'assigneesConnection_totalCount': (edge: PerformanceGoalsMetricGroupDataTableDataSourceType) => edge.node.assigneesConnection?.totalCount,
    'summary_averageProgress': (edge: PerformanceGoalsMetricGroupDataTableDataSourceType) => edge.node.summary?.averageProgress,
    'summary_metricsCount': (edge: PerformanceGoalsMetricGroupDataTableDataSourceType) => edge.node.summary?.metricsCount,
    'summary_needsAttention': (edge: PerformanceGoalsMetricGroupDataTableDataSourceType) => edge.node.summary?.needsAttention,
    'id': (edge: PerformanceGoalsMetricGroupDataTableDataSourceType) => edge.node.id,
    '_policies': (edge: PerformanceGoalsMetricGroupDataTableDataSourceType) => edge.node._policies,
    'assigneesConnection': (edge: PerformanceGoalsMetricGroupDataTableDataSourceType) => edge.node.assigneesConnection,
    'description': (edge: PerformanceGoalsMetricGroupDataTableDataSourceType) => edge.node.description,
    'performanceCycles': (edge: PerformanceGoalsMetricGroupDataTableDataSourceType) => edge.node.performanceCycles,
    'public': (edge: PerformanceGoalsMetricGroupDataTableDataSourceType) => edge.node.public,
    'summary': (edge: PerformanceGoalsMetricGroupDataTableDataSourceType) => edge.node.summary,
    'title': (edge: PerformanceGoalsMetricGroupDataTableDataSourceType) => edge.node.title,
  }
}

export function buildPerformanceGoalsMetricGroupDataTableFilter(
  source: DataTableSource<PerformanceGoalsMetricGroupDataTableFields, typeof PerformanceGoalsMetricGroupDataTableSortableFields[number]>,
  filter: DataTableFilter<GoalsMetricGroupFilter>
) {
  return filter
}

export function usePerformanceGoalsMetricGroupDataTable(
  projections: DataTableProjection<PerformanceGoalsMetricGroupDataTableFields, typeof PerformanceGoalsMetricGroupDataTableSortableFields[number]>[],
  options?: {
    variables?: PerformanceGoalsMetricGroupDataTableQueryVariables
    defaultSort?: typeof PerformanceGoalsMetricGroupDataTableSortableFields[number]
    identifier?: string
  }
): DataTableSource<PerformanceGoalsMetricGroupDataTableFields, typeof PerformanceGoalsMetricGroupDataTableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'PerformanceGoalsMetricGroupDataTable'

  return {
    identifier,
    query: PerformanceGoalsMetricGroupDataTableDocument,
    resolver: PerformanceGoalsMetricGroupDataTableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? PerformanceGoalsMetricGroupDataTableSortableFields.at(0),
      fields: PerformanceGoalsMetricGroupDataTableSortableFields,
    },
    variables
  }
}
export const PerformanceGoalsPeopleDataTableDocument = gql`
query PerformanceGoalsPeopleDataTable($cycleIds: [String!], $noCycle: Boolean, $onlyDirectReports: Boolean, $search: String, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: GoalsEmployeeFilter) {
  goals {
    employeesConnection(
      noCycle: $noCycle
      onlyActive: false
      onlyDirectReports: $onlyDirectReports
      search: $search
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          employee {
            id
            access {
              id
              avatar
            }
            manager {
              id
              fullName
            }
          }
          fullName
          metricSummary {
            averageProgress
            metricsCount
            needsAttention
          }
          progresses(cycleIds: $cycleIds) {
            id
            needsAttention
            progress
          }
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type PerformanceGoalsPeopleDataTableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<PerformanceGoalsPeopleDataTableQuery['goals']>['employeesConnection']>['edges']
>

const PerformanceGoalsPeopleDataTableSortableFields = ['id', 'id', 'fullName', 'id', 'id', 'fullName'] as const

interface PerformanceGoalsPeopleDataTableFields {
  'employee_access_id': RevealType<['node', 'employee', 'access', 'id'], PerformanceGoalsPeopleDataTableDataSourceType>,
  'employee_access_avatar': RevealType<['node', 'employee', 'access', 'avatar'], PerformanceGoalsPeopleDataTableDataSourceType>,
  'employee_manager_id': RevealType<['node', 'employee', 'manager', 'id'], PerformanceGoalsPeopleDataTableDataSourceType>,
  'employee_manager_fullName': RevealType<['node', 'employee', 'manager', 'fullName'], PerformanceGoalsPeopleDataTableDataSourceType>,
  'employee_id': RevealType<['node', 'employee', 'id'], PerformanceGoalsPeopleDataTableDataSourceType>,
  'employee_access': RevealType<['node', 'employee', 'access'], PerformanceGoalsPeopleDataTableDataSourceType>,
  'employee_manager': RevealType<['node', 'employee', 'manager'], PerformanceGoalsPeopleDataTableDataSourceType>,
  'metricSummary_averageProgress': RevealType<['node', 'metricSummary', 'averageProgress'], PerformanceGoalsPeopleDataTableDataSourceType>,
  'metricSummary_metricsCount': RevealType<['node', 'metricSummary', 'metricsCount'], PerformanceGoalsPeopleDataTableDataSourceType>,
  'metricSummary_needsAttention': RevealType<['node', 'metricSummary', 'needsAttention'], PerformanceGoalsPeopleDataTableDataSourceType>,
  'id': RevealType<['node', 'id'], PerformanceGoalsPeopleDataTableDataSourceType>,
  'employee': RevealType<['node', 'employee'], PerformanceGoalsPeopleDataTableDataSourceType>,
  'fullName': RevealType<['node', 'fullName'], PerformanceGoalsPeopleDataTableDataSourceType>,
  'metricSummary': RevealType<['node', 'metricSummary'], PerformanceGoalsPeopleDataTableDataSourceType>,
  'progresses': RevealType<['node', 'progresses'], PerformanceGoalsPeopleDataTableDataSourceType>
}

const PerformanceGoalsPeopleDataTableResolver = {
  dataSource: (data: PerformanceGoalsPeopleDataTableQuery) => data.goals.employeesConnection,
  edges: (data: PerformanceGoalsPeopleDataTableQuery) => data.goals.employeesConnection.edges,
  fields: {
    'employee_access_id': (edge: PerformanceGoalsPeopleDataTableDataSourceType) => edge.node.employee?.access?.id,
    'employee_access_avatar': (edge: PerformanceGoalsPeopleDataTableDataSourceType) => edge.node.employee?.access?.avatar,
    'employee_manager_id': (edge: PerformanceGoalsPeopleDataTableDataSourceType) => edge.node.employee?.manager?.id,
    'employee_manager_fullName': (edge: PerformanceGoalsPeopleDataTableDataSourceType) => edge.node.employee?.manager?.fullName,
    'employee_id': (edge: PerformanceGoalsPeopleDataTableDataSourceType) => edge.node.employee?.id,
    'employee_access': (edge: PerformanceGoalsPeopleDataTableDataSourceType) => edge.node.employee?.access,
    'employee_manager': (edge: PerformanceGoalsPeopleDataTableDataSourceType) => edge.node.employee?.manager,
    'metricSummary_averageProgress': (edge: PerformanceGoalsPeopleDataTableDataSourceType) => edge.node.metricSummary?.averageProgress,
    'metricSummary_metricsCount': (edge: PerformanceGoalsPeopleDataTableDataSourceType) => edge.node.metricSummary?.metricsCount,
    'metricSummary_needsAttention': (edge: PerformanceGoalsPeopleDataTableDataSourceType) => edge.node.metricSummary?.needsAttention,
    'id': (edge: PerformanceGoalsPeopleDataTableDataSourceType) => edge.node.id,
    'employee': (edge: PerformanceGoalsPeopleDataTableDataSourceType) => edge.node.employee,
    'fullName': (edge: PerformanceGoalsPeopleDataTableDataSourceType) => edge.node.fullName,
    'metricSummary': (edge: PerformanceGoalsPeopleDataTableDataSourceType) => edge.node.metricSummary,
    'progresses': (edge: PerformanceGoalsPeopleDataTableDataSourceType) => edge.node.progresses,
  }
}

export function buildPerformanceGoalsPeopleDataTableFilter(
  source: DataTableSource<PerformanceGoalsPeopleDataTableFields, typeof PerformanceGoalsPeopleDataTableSortableFields[number]>,
  filter: DataTableFilter<GoalsEmployeeFilter>
) {
  return filter
}

export function usePerformanceGoalsPeopleDataTable(
  projections: DataTableProjection<PerformanceGoalsPeopleDataTableFields, typeof PerformanceGoalsPeopleDataTableSortableFields[number]>[],
  options?: {
    variables?: PerformanceGoalsPeopleDataTableQueryVariables
    defaultSort?: typeof PerformanceGoalsPeopleDataTableSortableFields[number]
    identifier?: string
  }
): DataTableSource<PerformanceGoalsPeopleDataTableFields, typeof PerformanceGoalsPeopleDataTableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'PerformanceGoalsPeopleDataTable'

  return {
    identifier,
    query: PerformanceGoalsPeopleDataTableDocument,
    resolver: PerformanceGoalsPeopleDataTableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? PerformanceGoalsPeopleDataTableSortableFields.at(0),
      fields: PerformanceGoalsPeopleDataTableSortableFields,
    },
    variables
  }
}
export const InsightsHeadcountDataTableDocument = gql`
query InsightsHeadcountDataTable($contractDate: ISO8601Date!, $employeeIds: [Int!]!, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: EmployeesEmployeeFilter) {
  employees {
    employeesConnection(
      ids: $employeeIds
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          contractversionsConnection(date: $contractDate) {
            nodes {
              id
              endsOn
              startsOn
            }
          }
          fullName
          manager {
            id
            fullName
          }
          terminatedOn
          terminationReason
          terminationTypeDescription
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type InsightsHeadcountDataTableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<InsightsHeadcountDataTableQuery['employees']>['employeesConnection']>['edges']
>

const InsightsHeadcountDataTableSortableFields = ['id', 'fullName', 'id', 'fullName', 'terminatedOn'] as const

interface InsightsHeadcountDataTableFields {
  'contractversionsConnection_nodes': RevealType<['node', 'contractversionsConnection', 'nodes'], InsightsHeadcountDataTableDataSourceType>,
  'manager_id': RevealType<['node', 'manager', 'id'], InsightsHeadcountDataTableDataSourceType>,
  'manager_fullName': RevealType<['node', 'manager', 'fullName'], InsightsHeadcountDataTableDataSourceType>,
  'id': RevealType<['node', 'id'], InsightsHeadcountDataTableDataSourceType>,
  'contractversionsConnection': RevealType<['node', 'contractversionsConnection'], InsightsHeadcountDataTableDataSourceType>,
  'fullName': RevealType<['node', 'fullName'], InsightsHeadcountDataTableDataSourceType>,
  'manager': RevealType<['node', 'manager'], InsightsHeadcountDataTableDataSourceType>,
  'terminatedOn': RevealType<['node', 'terminatedOn'], InsightsHeadcountDataTableDataSourceType>,
  'terminationReason': RevealType<['node', 'terminationReason'], InsightsHeadcountDataTableDataSourceType>,
  'terminationTypeDescription': RevealType<['node', 'terminationTypeDescription'], InsightsHeadcountDataTableDataSourceType>
}

const InsightsHeadcountDataTableResolver = {
  dataSource: (data: InsightsHeadcountDataTableQuery) => data.employees.employeesConnection,
  edges: (data: InsightsHeadcountDataTableQuery) => data.employees.employeesConnection.edges,
  fields: {
    'contractversionsConnection_nodes': (edge: InsightsHeadcountDataTableDataSourceType) => edge.node.contractversionsConnection?.nodes,
    'manager_id': (edge: InsightsHeadcountDataTableDataSourceType) => edge.node.manager?.id,
    'manager_fullName': (edge: InsightsHeadcountDataTableDataSourceType) => edge.node.manager?.fullName,
    'id': (edge: InsightsHeadcountDataTableDataSourceType) => edge.node.id,
    'contractversionsConnection': (edge: InsightsHeadcountDataTableDataSourceType) => edge.node.contractversionsConnection,
    'fullName': (edge: InsightsHeadcountDataTableDataSourceType) => edge.node.fullName,
    'manager': (edge: InsightsHeadcountDataTableDataSourceType) => edge.node.manager,
    'terminatedOn': (edge: InsightsHeadcountDataTableDataSourceType) => edge.node.terminatedOn,
    'terminationReason': (edge: InsightsHeadcountDataTableDataSourceType) => edge.node.terminationReason,
    'terminationTypeDescription': (edge: InsightsHeadcountDataTableDataSourceType) => edge.node.terminationTypeDescription,
  }
}

export function buildInsightsHeadcountDataTableFilter(
  source: DataTableSource<InsightsHeadcountDataTableFields, typeof InsightsHeadcountDataTableSortableFields[number]>,
  filter: DataTableFilter<EmployeesEmployeeFilter>
) {
  return filter
}

export function useInsightsHeadcountDataTable(
  projections: DataTableProjection<InsightsHeadcountDataTableFields, typeof InsightsHeadcountDataTableSortableFields[number]>[],
  options?: {
    variables?: InsightsHeadcountDataTableQueryVariables
    defaultSort?: typeof InsightsHeadcountDataTableSortableFields[number]
    identifier?: string
  }
): DataTableSource<InsightsHeadcountDataTableFields, typeof InsightsHeadcountDataTableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'InsightsHeadcountDataTable'

  return {
    identifier,
    query: InsightsHeadcountDataTableDocument,
    resolver: InsightsHeadcountDataTableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? InsightsHeadcountDataTableSortableFields.at(0),
      fields: InsightsHeadcountDataTableSortableFields,
    },
    variables
  }
}
export const TaskDataTableDocument = gql`
query TaskDataTable($meetingIds: [Int!], $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: OneOnOnesTaskFilter) {
  oneOnOnes {
    tasksConnection(
      meetingIds: $meetingIds
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          assignees {
            id
            access {
              id
              avatar
            }
            firstName
            fullName
          }
          dueOn
          meeting {
            id
          }
          name
          taskId
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type TaskDataTableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<TaskDataTableQuery['oneOnOnes']>['tasksConnection']>['edges']
>

const TaskDataTableSortableFields = [] as const

interface TaskDataTableFields {
  'meeting_id': RevealType<['node', 'meeting', 'id'], TaskDataTableDataSourceType>,
  'id': RevealType<['node', 'id'], TaskDataTableDataSourceType>,
  'assignees': RevealType<['node', 'assignees'], TaskDataTableDataSourceType>,
  'dueOn': RevealType<['node', 'dueOn'], TaskDataTableDataSourceType>,
  'meeting': RevealType<['node', 'meeting'], TaskDataTableDataSourceType>,
  'name': RevealType<['node', 'name'], TaskDataTableDataSourceType>,
  'taskId': RevealType<['node', 'taskId'], TaskDataTableDataSourceType>
}

const TaskDataTableResolver = {
  dataSource: (data: TaskDataTableQuery) => data.oneOnOnes.tasksConnection,
  edges: (data: TaskDataTableQuery) => data.oneOnOnes.tasksConnection.edges,
  fields: {
    'meeting_id': (edge: TaskDataTableDataSourceType) => edge.node.meeting?.id,
    'id': (edge: TaskDataTableDataSourceType) => edge.node.id,
    'assignees': (edge: TaskDataTableDataSourceType) => edge.node.assignees,
    'dueOn': (edge: TaskDataTableDataSourceType) => edge.node.dueOn,
    'meeting': (edge: TaskDataTableDataSourceType) => edge.node.meeting,
    'name': (edge: TaskDataTableDataSourceType) => edge.node.name,
    'taskId': (edge: TaskDataTableDataSourceType) => edge.node.taskId,
  }
}

export function buildTaskDataTableFilter(
  source: DataTableSource<TaskDataTableFields, typeof TaskDataTableSortableFields[number]>,
  filter: DataTableFilter<OneOnOnesTaskFilter>
) {
  return filter
}

export function useTaskDataTable(
  projections: DataTableProjection<TaskDataTableFields, typeof TaskDataTableSortableFields[number]>[],
  options?: {
    variables?: TaskDataTableQueryVariables
    defaultSort?: typeof TaskDataTableSortableFields[number]
    identifier?: string
  }
): DataTableSource<TaskDataTableFields, typeof TaskDataTableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'TaskDataTable'

  return {
    identifier,
    query: TaskDataTableDocument,
    resolver: TaskDataTableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? TaskDataTableSortableFields.at(0),
      fields: TaskDataTableSortableFields,
    },
    variables
  }
}
export const PerformanceInsightsSummaryDatatableDocument = gql`
query PerformanceInsightsSummaryDatatable($pulseFrom: ISO8601Date!, $pulseTo: ISO8601Date!, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: PerformanceEmployeePerformanceInsightsSummaryFilter) {
  performance {
    employeePerformanceInsightsSummariesConnection(
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          employeeFullName
          employeePulse {
            id
            value
          }
          gridStatus
          insights {
            id
            engagementSignals {
              category
              name
              tag
              type
            }
          }
          managerFullName
          normalizedPotentialScore
          normalizedPotentialScore
          normalizedScore
          potentialScore
          pulseAnswer
          pulsesConnection(
            dateRange: {from: $pulseFrom, to: $pulseTo}
            sortOrder: {field: "submittedAt", order: "desc"}
          ) {
            edges {
              node {
                id
                comment
                submittedDate
                value
              }
            }
          }
          reviewEmployeeScore {
            id
            normalizedScore
            scaleMax
            score
          }
          reviewProcess {
            id
            endsAt
            name
            startsAt
          }
          targetAccess {
            id
            avatar
            employee {
              id
              manager {
                id
                access {
                  id
                  avatar
                  fullName
                }
              }
              memberships {
                id
                team {
                  id
                  name
                }
              }
            }
            fullName
          }
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type PerformanceInsightsSummaryDatatableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<PerformanceInsightsSummaryDatatableQuery['performance']>['employeePerformanceInsightsSummariesConnection']>['edges']
>

const PerformanceInsightsSummaryDatatableSortableFields = ['score', 'id', 'endsAt', 'name', 'startsAt', 'id', 'id', 'id', 'id', 'id', 'employeeFullName', 'gridStatus', 'managerFullName', 'normalizedPotentialScore', 'normalizedScore', 'pulseAnswer'] as const

interface PerformanceInsightsSummaryDatatableFields {
  'employeePulse_id': RevealType<['node', 'employeePulse', 'id'], PerformanceInsightsSummaryDatatableDataSourceType>,
  'employeePulse_value': RevealType<['node', 'employeePulse', 'value'], PerformanceInsightsSummaryDatatableDataSourceType>,
  'insights_id': RevealType<['node', 'insights', 'id'], PerformanceInsightsSummaryDatatableDataSourceType>,
  'insights_engagementSignals': RevealType<['node', 'insights', 'engagementSignals'], PerformanceInsightsSummaryDatatableDataSourceType>,
  'pulsesConnection_edges': RevealType<['node', 'pulsesConnection', 'edges'], PerformanceInsightsSummaryDatatableDataSourceType>,
  'reviewEmployeeScore_id': RevealType<['node', 'reviewEmployeeScore', 'id'], PerformanceInsightsSummaryDatatableDataSourceType>,
  'reviewEmployeeScore_normalizedScore': RevealType<['node', 'reviewEmployeeScore', 'normalizedScore'], PerformanceInsightsSummaryDatatableDataSourceType>,
  'reviewEmployeeScore_scaleMax': RevealType<['node', 'reviewEmployeeScore', 'scaleMax'], PerformanceInsightsSummaryDatatableDataSourceType>,
  'reviewEmployeeScore_score': RevealType<['node', 'reviewEmployeeScore', 'score'], PerformanceInsightsSummaryDatatableDataSourceType>,
  'reviewProcess_id': RevealType<['node', 'reviewProcess', 'id'], PerformanceInsightsSummaryDatatableDataSourceType>,
  'reviewProcess_endsAt': RevealType<['node', 'reviewProcess', 'endsAt'], PerformanceInsightsSummaryDatatableDataSourceType>,
  'reviewProcess_name': RevealType<['node', 'reviewProcess', 'name'], PerformanceInsightsSummaryDatatableDataSourceType>,
  'reviewProcess_startsAt': RevealType<['node', 'reviewProcess', 'startsAt'], PerformanceInsightsSummaryDatatableDataSourceType>,
  'targetAccess_employee_manager_access_id': RevealType<['node', 'targetAccess', 'employee', 'manager', 'access', 'id'], PerformanceInsightsSummaryDatatableDataSourceType>,
  'targetAccess_employee_manager_access_avatar': RevealType<['node', 'targetAccess', 'employee', 'manager', 'access', 'avatar'], PerformanceInsightsSummaryDatatableDataSourceType>,
  'targetAccess_employee_manager_access_fullName': RevealType<['node', 'targetAccess', 'employee', 'manager', 'access', 'fullName'], PerformanceInsightsSummaryDatatableDataSourceType>,
  'targetAccess_employee_manager_id': RevealType<['node', 'targetAccess', 'employee', 'manager', 'id'], PerformanceInsightsSummaryDatatableDataSourceType>,
  'targetAccess_employee_manager_access': RevealType<['node', 'targetAccess', 'employee', 'manager', 'access'], PerformanceInsightsSummaryDatatableDataSourceType>,
  'targetAccess_employee_id': RevealType<['node', 'targetAccess', 'employee', 'id'], PerformanceInsightsSummaryDatatableDataSourceType>,
  'targetAccess_employee_manager': RevealType<['node', 'targetAccess', 'employee', 'manager'], PerformanceInsightsSummaryDatatableDataSourceType>,
  'targetAccess_employee_memberships': RevealType<['node', 'targetAccess', 'employee', 'memberships'], PerformanceInsightsSummaryDatatableDataSourceType>,
  'targetAccess_id': RevealType<['node', 'targetAccess', 'id'], PerformanceInsightsSummaryDatatableDataSourceType>,
  'targetAccess_avatar': RevealType<['node', 'targetAccess', 'avatar'], PerformanceInsightsSummaryDatatableDataSourceType>,
  'targetAccess_employee': RevealType<['node', 'targetAccess', 'employee'], PerformanceInsightsSummaryDatatableDataSourceType>,
  'targetAccess_fullName': RevealType<['node', 'targetAccess', 'fullName'], PerformanceInsightsSummaryDatatableDataSourceType>,
  'id': RevealType<['node', 'id'], PerformanceInsightsSummaryDatatableDataSourceType>,
  'employeeFullName': RevealType<['node', 'employeeFullName'], PerformanceInsightsSummaryDatatableDataSourceType>,
  'employeePulse': RevealType<['node', 'employeePulse'], PerformanceInsightsSummaryDatatableDataSourceType>,
  'gridStatus': RevealType<['node', 'gridStatus'], PerformanceInsightsSummaryDatatableDataSourceType>,
  'insights': RevealType<['node', 'insights'], PerformanceInsightsSummaryDatatableDataSourceType>,
  'managerFullName': RevealType<['node', 'managerFullName'], PerformanceInsightsSummaryDatatableDataSourceType>,
  'normalizedPotentialScore': RevealType<['node', 'normalizedPotentialScore'], PerformanceInsightsSummaryDatatableDataSourceType>,
  'normalizedScore': RevealType<['node', 'normalizedScore'], PerformanceInsightsSummaryDatatableDataSourceType>,
  'potentialScore': RevealType<['node', 'potentialScore'], PerformanceInsightsSummaryDatatableDataSourceType>,
  'pulseAnswer': RevealType<['node', 'pulseAnswer'], PerformanceInsightsSummaryDatatableDataSourceType>,
  'pulsesConnection': RevealType<['node', 'pulsesConnection'], PerformanceInsightsSummaryDatatableDataSourceType>,
  'reviewEmployeeScore': RevealType<['node', 'reviewEmployeeScore'], PerformanceInsightsSummaryDatatableDataSourceType>,
  'reviewProcess': RevealType<['node', 'reviewProcess'], PerformanceInsightsSummaryDatatableDataSourceType>,
  'targetAccess': RevealType<['node', 'targetAccess'], PerformanceInsightsSummaryDatatableDataSourceType>
}

const PerformanceInsightsSummaryDatatableResolver = {
  dataSource: (data: PerformanceInsightsSummaryDatatableQuery) => data.performance.employeePerformanceInsightsSummariesConnection,
  edges: (data: PerformanceInsightsSummaryDatatableQuery) => data.performance.employeePerformanceInsightsSummariesConnection.edges,
  fields: {
    'employeePulse_id': (edge: PerformanceInsightsSummaryDatatableDataSourceType) => edge.node.employeePulse?.id,
    'employeePulse_value': (edge: PerformanceInsightsSummaryDatatableDataSourceType) => edge.node.employeePulse?.value,
    'insights_id': (edge: PerformanceInsightsSummaryDatatableDataSourceType) => edge.node.insights?.id,
    'insights_engagementSignals': (edge: PerformanceInsightsSummaryDatatableDataSourceType) => edge.node.insights?.engagementSignals,
    'pulsesConnection_edges': (edge: PerformanceInsightsSummaryDatatableDataSourceType) => edge.node.pulsesConnection?.edges,
    'reviewEmployeeScore_id': (edge: PerformanceInsightsSummaryDatatableDataSourceType) => edge.node.reviewEmployeeScore?.id,
    'reviewEmployeeScore_normalizedScore': (edge: PerformanceInsightsSummaryDatatableDataSourceType) => edge.node.reviewEmployeeScore?.normalizedScore,
    'reviewEmployeeScore_scaleMax': (edge: PerformanceInsightsSummaryDatatableDataSourceType) => edge.node.reviewEmployeeScore?.scaleMax,
    'reviewEmployeeScore_score': (edge: PerformanceInsightsSummaryDatatableDataSourceType) => edge.node.reviewEmployeeScore?.score,
    'reviewProcess_id': (edge: PerformanceInsightsSummaryDatatableDataSourceType) => edge.node.reviewProcess?.id,
    'reviewProcess_endsAt': (edge: PerformanceInsightsSummaryDatatableDataSourceType) => edge.node.reviewProcess?.endsAt,
    'reviewProcess_name': (edge: PerformanceInsightsSummaryDatatableDataSourceType) => edge.node.reviewProcess?.name,
    'reviewProcess_startsAt': (edge: PerformanceInsightsSummaryDatatableDataSourceType) => edge.node.reviewProcess?.startsAt,
    'targetAccess_employee_manager_access_id': (edge: PerformanceInsightsSummaryDatatableDataSourceType) => edge.node.targetAccess?.employee?.manager?.access?.id,
    'targetAccess_employee_manager_access_avatar': (edge: PerformanceInsightsSummaryDatatableDataSourceType) => edge.node.targetAccess?.employee?.manager?.access?.avatar,
    'targetAccess_employee_manager_access_fullName': (edge: PerformanceInsightsSummaryDatatableDataSourceType) => edge.node.targetAccess?.employee?.manager?.access?.fullName,
    'targetAccess_employee_manager_id': (edge: PerformanceInsightsSummaryDatatableDataSourceType) => edge.node.targetAccess?.employee?.manager?.id,
    'targetAccess_employee_manager_access': (edge: PerformanceInsightsSummaryDatatableDataSourceType) => edge.node.targetAccess?.employee?.manager?.access,
    'targetAccess_employee_id': (edge: PerformanceInsightsSummaryDatatableDataSourceType) => edge.node.targetAccess?.employee?.id,
    'targetAccess_employee_manager': (edge: PerformanceInsightsSummaryDatatableDataSourceType) => edge.node.targetAccess?.employee?.manager,
    'targetAccess_employee_memberships': (edge: PerformanceInsightsSummaryDatatableDataSourceType) => edge.node.targetAccess?.employee?.memberships,
    'targetAccess_id': (edge: PerformanceInsightsSummaryDatatableDataSourceType) => edge.node.targetAccess?.id,
    'targetAccess_avatar': (edge: PerformanceInsightsSummaryDatatableDataSourceType) => edge.node.targetAccess?.avatar,
    'targetAccess_employee': (edge: PerformanceInsightsSummaryDatatableDataSourceType) => edge.node.targetAccess?.employee,
    'targetAccess_fullName': (edge: PerformanceInsightsSummaryDatatableDataSourceType) => edge.node.targetAccess?.fullName,
    'id': (edge: PerformanceInsightsSummaryDatatableDataSourceType) => edge.node.id,
    'employeeFullName': (edge: PerformanceInsightsSummaryDatatableDataSourceType) => edge.node.employeeFullName,
    'employeePulse': (edge: PerformanceInsightsSummaryDatatableDataSourceType) => edge.node.employeePulse,
    'gridStatus': (edge: PerformanceInsightsSummaryDatatableDataSourceType) => edge.node.gridStatus,
    'insights': (edge: PerformanceInsightsSummaryDatatableDataSourceType) => edge.node.insights,
    'managerFullName': (edge: PerformanceInsightsSummaryDatatableDataSourceType) => edge.node.managerFullName,
    'normalizedPotentialScore': (edge: PerformanceInsightsSummaryDatatableDataSourceType) => edge.node.normalizedPotentialScore,
    'normalizedScore': (edge: PerformanceInsightsSummaryDatatableDataSourceType) => edge.node.normalizedScore,
    'potentialScore': (edge: PerformanceInsightsSummaryDatatableDataSourceType) => edge.node.potentialScore,
    'pulseAnswer': (edge: PerformanceInsightsSummaryDatatableDataSourceType) => edge.node.pulseAnswer,
    'pulsesConnection': (edge: PerformanceInsightsSummaryDatatableDataSourceType) => edge.node.pulsesConnection,
    'reviewEmployeeScore': (edge: PerformanceInsightsSummaryDatatableDataSourceType) => edge.node.reviewEmployeeScore,
    'reviewProcess': (edge: PerformanceInsightsSummaryDatatableDataSourceType) => edge.node.reviewProcess,
    'targetAccess': (edge: PerformanceInsightsSummaryDatatableDataSourceType) => edge.node.targetAccess,
  }
}

export function buildPerformanceInsightsSummaryDatatableFilter(
  source: DataTableSource<PerformanceInsightsSummaryDatatableFields, typeof PerformanceInsightsSummaryDatatableSortableFields[number]>,
  filter: DataTableFilter<PerformanceEmployeePerformanceInsightsSummaryFilter>
) {
  return filter
}

export function usePerformanceInsightsSummaryDatatable(
  projections: DataTableProjection<PerformanceInsightsSummaryDatatableFields, typeof PerformanceInsightsSummaryDatatableSortableFields[number]>[],
  options?: {
    variables?: PerformanceInsightsSummaryDatatableQueryVariables
    defaultSort?: typeof PerformanceInsightsSummaryDatatableSortableFields[number]
    identifier?: string
  }
): DataTableSource<PerformanceInsightsSummaryDatatableFields, typeof PerformanceInsightsSummaryDatatableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'PerformanceInsightsSummaryDatatable'

  return {
    identifier,
    query: PerformanceInsightsSummaryDatatableDocument,
    resolver: PerformanceInsightsSummaryDatatableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? PerformanceInsightsSummaryDatatableSortableFields.at(0),
      fields: PerformanceInsightsSummaryDatatableSortableFields,
    },
    variables
  }
}
export const PerformanceCyclesDataTableDocument = gql`
query PerformanceCyclesDataTable($projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort) {
  performanceCycles {
    cyclesConnection(
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          companyId
          endOn
          startOn
          title
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type PerformanceCyclesDataTableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<PerformanceCyclesDataTableQuery['performanceCycles']>['cyclesConnection']>['edges']
>

const PerformanceCyclesDataTableSortableFields = [] as const

interface PerformanceCyclesDataTableFields {
  'id': RevealType<['node', 'id'], PerformanceCyclesDataTableDataSourceType>,
  'companyId': RevealType<['node', 'companyId'], PerformanceCyclesDataTableDataSourceType>,
  'endOn': RevealType<['node', 'endOn'], PerformanceCyclesDataTableDataSourceType>,
  'startOn': RevealType<['node', 'startOn'], PerformanceCyclesDataTableDataSourceType>,
  'title': RevealType<['node', 'title'], PerformanceCyclesDataTableDataSourceType>
}

const PerformanceCyclesDataTableResolver = {
  dataSource: (data: PerformanceCyclesDataTableQuery) => data.performanceCycles.cyclesConnection,
  edges: (data: PerformanceCyclesDataTableQuery) => data.performanceCycles.cyclesConnection.edges,
  fields: {
    'id': (edge: PerformanceCyclesDataTableDataSourceType) => edge.node.id,
    'companyId': (edge: PerformanceCyclesDataTableDataSourceType) => edge.node.companyId,
    'endOn': (edge: PerformanceCyclesDataTableDataSourceType) => edge.node.endOn,
    'startOn': (edge: PerformanceCyclesDataTableDataSourceType) => edge.node.startOn,
    'title': (edge: PerformanceCyclesDataTableDataSourceType) => edge.node.title,
  }
}

export function usePerformanceCyclesDataTable(
  projections: DataTableProjection<PerformanceCyclesDataTableFields, typeof PerformanceCyclesDataTableSortableFields[number]>[],
  options?: {
    variables?: PerformanceCyclesDataTableQueryVariables
    defaultSort?: typeof PerformanceCyclesDataTableSortableFields[number]
    identifier?: string
  }
): DataTableSource<PerformanceCyclesDataTableFields, typeof PerformanceCyclesDataTableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'PerformanceCyclesDataTable'

  return {
    identifier,
    query: PerformanceCyclesDataTableDocument,
    resolver: PerformanceCyclesDataTableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? PerformanceCyclesDataTableSortableFields.at(0),
      fields: PerformanceCyclesDataTableSortableFields,
    },
    variables
  }
}
export const PerformanceProcessPendingReviewersDataTableDocument = gql`
query PerformanceProcessPendingReviewersDataTable($ids: [Int!]!, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: ApiCoreAccessFilter) {
  apiCore {
    accessesConnection(
      ids: $ids
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          employeeName {
            id
            access {
              id
              avatar
              fullName
            }
            managerName {
              id
              access {
                id
                avatar
                fullName
              }
            }
          }
          firstName
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type PerformanceProcessPendingReviewersDataTableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<PerformanceProcessPendingReviewersDataTableQuery['apiCore']>['accessesConnection']>['edges']
>

const PerformanceProcessPendingReviewersDataTableSortableFields = ['id', 'id', 'id', 'id', 'id', 'firstName'] as const

interface PerformanceProcessPendingReviewersDataTableFields {
  'employeeName_access_id': RevealType<['node', 'employeeName', 'access', 'id'], PerformanceProcessPendingReviewersDataTableDataSourceType>,
  'employeeName_access_avatar': RevealType<['node', 'employeeName', 'access', 'avatar'], PerformanceProcessPendingReviewersDataTableDataSourceType>,
  'employeeName_access_fullName': RevealType<['node', 'employeeName', 'access', 'fullName'], PerformanceProcessPendingReviewersDataTableDataSourceType>,
  'employeeName_managerName_access_id': RevealType<['node', 'employeeName', 'managerName', 'access', 'id'], PerformanceProcessPendingReviewersDataTableDataSourceType>,
  'employeeName_managerName_access_avatar': RevealType<['node', 'employeeName', 'managerName', 'access', 'avatar'], PerformanceProcessPendingReviewersDataTableDataSourceType>,
  'employeeName_managerName_access_fullName': RevealType<['node', 'employeeName', 'managerName', 'access', 'fullName'], PerformanceProcessPendingReviewersDataTableDataSourceType>,
  'employeeName_managerName_id': RevealType<['node', 'employeeName', 'managerName', 'id'], PerformanceProcessPendingReviewersDataTableDataSourceType>,
  'employeeName_managerName_access': RevealType<['node', 'employeeName', 'managerName', 'access'], PerformanceProcessPendingReviewersDataTableDataSourceType>,
  'employeeName_id': RevealType<['node', 'employeeName', 'id'], PerformanceProcessPendingReviewersDataTableDataSourceType>,
  'employeeName_access': RevealType<['node', 'employeeName', 'access'], PerformanceProcessPendingReviewersDataTableDataSourceType>,
  'employeeName_managerName': RevealType<['node', 'employeeName', 'managerName'], PerformanceProcessPendingReviewersDataTableDataSourceType>,
  'id': RevealType<['node', 'id'], PerformanceProcessPendingReviewersDataTableDataSourceType>,
  'employeeName': RevealType<['node', 'employeeName'], PerformanceProcessPendingReviewersDataTableDataSourceType>,
  'firstName': RevealType<['node', 'firstName'], PerformanceProcessPendingReviewersDataTableDataSourceType>
}

const PerformanceProcessPendingReviewersDataTableResolver = {
  dataSource: (data: PerformanceProcessPendingReviewersDataTableQuery) => data.apiCore.accessesConnection,
  edges: (data: PerformanceProcessPendingReviewersDataTableQuery) => data.apiCore.accessesConnection.edges,
  fields: {
    'employeeName_access_id': (edge: PerformanceProcessPendingReviewersDataTableDataSourceType) => edge.node.employeeName?.access?.id,
    'employeeName_access_avatar': (edge: PerformanceProcessPendingReviewersDataTableDataSourceType) => edge.node.employeeName?.access?.avatar,
    'employeeName_access_fullName': (edge: PerformanceProcessPendingReviewersDataTableDataSourceType) => edge.node.employeeName?.access?.fullName,
    'employeeName_managerName_access_id': (edge: PerformanceProcessPendingReviewersDataTableDataSourceType) => edge.node.employeeName?.managerName?.access?.id,
    'employeeName_managerName_access_avatar': (edge: PerformanceProcessPendingReviewersDataTableDataSourceType) => edge.node.employeeName?.managerName?.access?.avatar,
    'employeeName_managerName_access_fullName': (edge: PerformanceProcessPendingReviewersDataTableDataSourceType) => edge.node.employeeName?.managerName?.access?.fullName,
    'employeeName_managerName_id': (edge: PerformanceProcessPendingReviewersDataTableDataSourceType) => edge.node.employeeName?.managerName?.id,
    'employeeName_managerName_access': (edge: PerformanceProcessPendingReviewersDataTableDataSourceType) => edge.node.employeeName?.managerName?.access,
    'employeeName_id': (edge: PerformanceProcessPendingReviewersDataTableDataSourceType) => edge.node.employeeName?.id,
    'employeeName_access': (edge: PerformanceProcessPendingReviewersDataTableDataSourceType) => edge.node.employeeName?.access,
    'employeeName_managerName': (edge: PerformanceProcessPendingReviewersDataTableDataSourceType) => edge.node.employeeName?.managerName,
    'id': (edge: PerformanceProcessPendingReviewersDataTableDataSourceType) => edge.node.id,
    'employeeName': (edge: PerformanceProcessPendingReviewersDataTableDataSourceType) => edge.node.employeeName,
    'firstName': (edge: PerformanceProcessPendingReviewersDataTableDataSourceType) => edge.node.firstName,
  }
}

export function buildPerformanceProcessPendingReviewersDataTableFilter(
  source: DataTableSource<PerformanceProcessPendingReviewersDataTableFields, typeof PerformanceProcessPendingReviewersDataTableSortableFields[number]>,
  filter: DataTableFilter<ApiCoreAccessFilter>
) {
  return filter
}

export function usePerformanceProcessPendingReviewersDataTable(
  projections: DataTableProjection<PerformanceProcessPendingReviewersDataTableFields, typeof PerformanceProcessPendingReviewersDataTableSortableFields[number]>[],
  options?: {
    variables?: PerformanceProcessPendingReviewersDataTableQueryVariables
    defaultSort?: typeof PerformanceProcessPendingReviewersDataTableSortableFields[number]
    identifier?: string
  }
): DataTableSource<PerformanceProcessPendingReviewersDataTableFields, typeof PerformanceProcessPendingReviewersDataTableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'PerformanceProcessPendingReviewersDataTable'

  return {
    identifier,
    query: PerformanceProcessPendingReviewersDataTableDocument,
    resolver: PerformanceProcessPendingReviewersDataTableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? PerformanceProcessPendingReviewersDataTableSortableFields.at(0),
      fields: PerformanceProcessPendingReviewersDataTableSortableFields,
    },
    variables
  }
}
export const ProcessTargetDataTableDocument = gql`
query ProcessTargetDataTable($agreementCompletionStatus: PerformanceDtosReviewProcessTargetAgreementCompletionStatusEnum, $employeeIds: [Int!], $evaluationsCompletionStatus: PerformanceReviewEvaluationStatusEnum, $finalScores: [Int!], $legalEntityIds: [Int!], $managedByFilter: ReviewProcessTargetsManagedByFilterInput, $performanceReviewProcessIds: [Int!]!, $searchValue: String, $teamIds: [Int!], $tenureDates: [String!], $workplaceIds: [Int!], $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: PerformanceReviewProcessTargetFilter) {
  performance {
    reviewProcessTargetsConnection(
      agreementCompletionStatus: $agreementCompletionStatus
      employeeIds: $employeeIds
      evaluationsCompletionStatus: $evaluationsCompletionStatus
      finalScores: $finalScores
      legalEntityIds: $legalEntityIds
      managedByFilter: $managedByFilter
      performanceReviewProcessIds: $performanceReviewProcessIds
      search: $searchValue
      teamIds: $teamIds
      tenureDates: $tenureDates
      workplaceIds: $workplaceIds
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          access {
            id
            employeeName(onlyActive: false) {
              id
              avatar {
                id
                url
              }
              fullName
              managerName {
                id
                fullName
              }
            }
          }
          agreement {
            id
            agreementDocuments {
              id
              signatureStatus
            }
            status
          }
          evaluations {
            id
            answeredQuestionnairesIdentifier {
              id
            }
            evaluationType
            status
          }
          insightScore {
            id
            alignmentScore
          }
          reviewFinalEmployeeScore {
            id
            scaleMax
            scaleMin
            score
          }
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type ProcessTargetDataTableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<ProcessTargetDataTableQuery['performance']>['reviewProcessTargetsConnection']>['edges']
>

const ProcessTargetDataTableSortableFields = ['id', 'fullName', 'id', 'fullName', 'id', 'score', 'id'] as const

interface ProcessTargetDataTableFields {
  'access_employeeName_avatar_id': RevealType<['node', 'access', 'employeeName', 'avatar', 'id'], ProcessTargetDataTableDataSourceType>,
  'access_employeeName_avatar_url': RevealType<['node', 'access', 'employeeName', 'avatar', 'url'], ProcessTargetDataTableDataSourceType>,
  'access_employeeName_managerName_id': RevealType<['node', 'access', 'employeeName', 'managerName', 'id'], ProcessTargetDataTableDataSourceType>,
  'access_employeeName_managerName_fullName': RevealType<['node', 'access', 'employeeName', 'managerName', 'fullName'], ProcessTargetDataTableDataSourceType>,
  'access_employeeName_id': RevealType<['node', 'access', 'employeeName', 'id'], ProcessTargetDataTableDataSourceType>,
  'access_employeeName_avatar': RevealType<['node', 'access', 'employeeName', 'avatar'], ProcessTargetDataTableDataSourceType>,
  'access_employeeName_fullName': RevealType<['node', 'access', 'employeeName', 'fullName'], ProcessTargetDataTableDataSourceType>,
  'access_employeeName_managerName': RevealType<['node', 'access', 'employeeName', 'managerName'], ProcessTargetDataTableDataSourceType>,
  'access_id': RevealType<['node', 'access', 'id'], ProcessTargetDataTableDataSourceType>,
  'access_employeeName': RevealType<['node', 'access', 'employeeName'], ProcessTargetDataTableDataSourceType>,
  'agreement_id': RevealType<['node', 'agreement', 'id'], ProcessTargetDataTableDataSourceType>,
  'agreement_agreementDocuments': RevealType<['node', 'agreement', 'agreementDocuments'], ProcessTargetDataTableDataSourceType>,
  'agreement_status': RevealType<['node', 'agreement', 'status'], ProcessTargetDataTableDataSourceType>,
  'insightScore_id': RevealType<['node', 'insightScore', 'id'], ProcessTargetDataTableDataSourceType>,
  'insightScore_alignmentScore': RevealType<['node', 'insightScore', 'alignmentScore'], ProcessTargetDataTableDataSourceType>,
  'reviewFinalEmployeeScore_id': RevealType<['node', 'reviewFinalEmployeeScore', 'id'], ProcessTargetDataTableDataSourceType>,
  'reviewFinalEmployeeScore_scaleMax': RevealType<['node', 'reviewFinalEmployeeScore', 'scaleMax'], ProcessTargetDataTableDataSourceType>,
  'reviewFinalEmployeeScore_scaleMin': RevealType<['node', 'reviewFinalEmployeeScore', 'scaleMin'], ProcessTargetDataTableDataSourceType>,
  'reviewFinalEmployeeScore_score': RevealType<['node', 'reviewFinalEmployeeScore', 'score'], ProcessTargetDataTableDataSourceType>,
  'id': RevealType<['node', 'id'], ProcessTargetDataTableDataSourceType>,
  'access': RevealType<['node', 'access'], ProcessTargetDataTableDataSourceType>,
  'agreement': RevealType<['node', 'agreement'], ProcessTargetDataTableDataSourceType>,
  'evaluations': RevealType<['node', 'evaluations'], ProcessTargetDataTableDataSourceType>,
  'insightScore': RevealType<['node', 'insightScore'], ProcessTargetDataTableDataSourceType>,
  'reviewFinalEmployeeScore': RevealType<['node', 'reviewFinalEmployeeScore'], ProcessTargetDataTableDataSourceType>
}

const ProcessTargetDataTableResolver = {
  dataSource: (data: ProcessTargetDataTableQuery) => data.performance.reviewProcessTargetsConnection,
  edges: (data: ProcessTargetDataTableQuery) => data.performance.reviewProcessTargetsConnection.edges,
  fields: {
    'access_employeeName_avatar_id': (edge: ProcessTargetDataTableDataSourceType) => edge.node.access?.employeeName?.avatar?.id,
    'access_employeeName_avatar_url': (edge: ProcessTargetDataTableDataSourceType) => edge.node.access?.employeeName?.avatar?.url,
    'access_employeeName_managerName_id': (edge: ProcessTargetDataTableDataSourceType) => edge.node.access?.employeeName?.managerName?.id,
    'access_employeeName_managerName_fullName': (edge: ProcessTargetDataTableDataSourceType) => edge.node.access?.employeeName?.managerName?.fullName,
    'access_employeeName_id': (edge: ProcessTargetDataTableDataSourceType) => edge.node.access?.employeeName?.id,
    'access_employeeName_avatar': (edge: ProcessTargetDataTableDataSourceType) => edge.node.access?.employeeName?.avatar,
    'access_employeeName_fullName': (edge: ProcessTargetDataTableDataSourceType) => edge.node.access?.employeeName?.fullName,
    'access_employeeName_managerName': (edge: ProcessTargetDataTableDataSourceType) => edge.node.access?.employeeName?.managerName,
    'access_id': (edge: ProcessTargetDataTableDataSourceType) => edge.node.access?.id,
    'access_employeeName': (edge: ProcessTargetDataTableDataSourceType) => edge.node.access?.employeeName,
    'agreement_id': (edge: ProcessTargetDataTableDataSourceType) => edge.node.agreement?.id,
    'agreement_agreementDocuments': (edge: ProcessTargetDataTableDataSourceType) => edge.node.agreement?.agreementDocuments,
    'agreement_status': (edge: ProcessTargetDataTableDataSourceType) => edge.node.agreement?.status,
    'insightScore_id': (edge: ProcessTargetDataTableDataSourceType) => edge.node.insightScore?.id,
    'insightScore_alignmentScore': (edge: ProcessTargetDataTableDataSourceType) => edge.node.insightScore?.alignmentScore,
    'reviewFinalEmployeeScore_id': (edge: ProcessTargetDataTableDataSourceType) => edge.node.reviewFinalEmployeeScore?.id,
    'reviewFinalEmployeeScore_scaleMax': (edge: ProcessTargetDataTableDataSourceType) => edge.node.reviewFinalEmployeeScore?.scaleMax,
    'reviewFinalEmployeeScore_scaleMin': (edge: ProcessTargetDataTableDataSourceType) => edge.node.reviewFinalEmployeeScore?.scaleMin,
    'reviewFinalEmployeeScore_score': (edge: ProcessTargetDataTableDataSourceType) => edge.node.reviewFinalEmployeeScore?.score,
    'id': (edge: ProcessTargetDataTableDataSourceType) => edge.node.id,
    'access': (edge: ProcessTargetDataTableDataSourceType) => edge.node.access,
    'agreement': (edge: ProcessTargetDataTableDataSourceType) => edge.node.agreement,
    'evaluations': (edge: ProcessTargetDataTableDataSourceType) => edge.node.evaluations,
    'insightScore': (edge: ProcessTargetDataTableDataSourceType) => edge.node.insightScore,
    'reviewFinalEmployeeScore': (edge: ProcessTargetDataTableDataSourceType) => edge.node.reviewFinalEmployeeScore,
  }
}

export function buildProcessTargetDataTableFilter(
  source: DataTableSource<ProcessTargetDataTableFields, typeof ProcessTargetDataTableSortableFields[number]>,
  filter: DataTableFilter<PerformanceReviewProcessTargetFilter>
) {
  return filter
}

export function useProcessTargetDataTable(
  projections: DataTableProjection<ProcessTargetDataTableFields, typeof ProcessTargetDataTableSortableFields[number]>[],
  options?: {
    variables?: ProcessTargetDataTableQueryVariables
    defaultSort?: typeof ProcessTargetDataTableSortableFields[number]
    identifier?: string
  }
): DataTableSource<ProcessTargetDataTableFields, typeof ProcessTargetDataTableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'ProcessTargetDataTable'

  return {
    identifier,
    query: ProcessTargetDataTableDocument,
    resolver: ProcessTargetDataTableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? ProcessTargetDataTableSortableFields.at(0),
      fields: ProcessTargetDataTableSortableFields,
    },
    variables
  }
}
export const ProcessTargetForPeerAssignmentDataTableDocument = gql`
query ProcessTargetForPeerAssignmentDataTable($performanceReviewProcessIds: [Int!]!, $searchValue: String, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: PerformanceReviewProcessTargetFilter) {
  performance {
    reviewProcessTargetsConnection(
      onlyForPeerAssignment: true
      performanceReviewProcessIds: $performanceReviewProcessIds
      search: $searchValue
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          access {
            id
            employeeName(onlyActive: false) {
              id
              avatar {
                id
                url
              }
              fullName
              managerName {
                id
                fullName
              }
            }
          }
          evaluations(reviewerStrategies: [peers]) {
            id
            reviewerEmployeeName(onlyActive: false) {
              id
              avatar {
                id
                url
              }
              fullName
            }
          }
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type ProcessTargetForPeerAssignmentDataTableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<ProcessTargetForPeerAssignmentDataTableQuery['performance']>['reviewProcessTargetsConnection']>['edges']
>

const ProcessTargetForPeerAssignmentDataTableSortableFields = ['id', 'fullName', 'id', 'fullName', 'id', 'id'] as const

interface ProcessTargetForPeerAssignmentDataTableFields {
  'access_employeeName_avatar_id': RevealType<['node', 'access', 'employeeName', 'avatar', 'id'], ProcessTargetForPeerAssignmentDataTableDataSourceType>,
  'access_employeeName_avatar_url': RevealType<['node', 'access', 'employeeName', 'avatar', 'url'], ProcessTargetForPeerAssignmentDataTableDataSourceType>,
  'access_employeeName_managerName_id': RevealType<['node', 'access', 'employeeName', 'managerName', 'id'], ProcessTargetForPeerAssignmentDataTableDataSourceType>,
  'access_employeeName_managerName_fullName': RevealType<['node', 'access', 'employeeName', 'managerName', 'fullName'], ProcessTargetForPeerAssignmentDataTableDataSourceType>,
  'access_employeeName_id': RevealType<['node', 'access', 'employeeName', 'id'], ProcessTargetForPeerAssignmentDataTableDataSourceType>,
  'access_employeeName_avatar': RevealType<['node', 'access', 'employeeName', 'avatar'], ProcessTargetForPeerAssignmentDataTableDataSourceType>,
  'access_employeeName_fullName': RevealType<['node', 'access', 'employeeName', 'fullName'], ProcessTargetForPeerAssignmentDataTableDataSourceType>,
  'access_employeeName_managerName': RevealType<['node', 'access', 'employeeName', 'managerName'], ProcessTargetForPeerAssignmentDataTableDataSourceType>,
  'access_id': RevealType<['node', 'access', 'id'], ProcessTargetForPeerAssignmentDataTableDataSourceType>,
  'access_employeeName': RevealType<['node', 'access', 'employeeName'], ProcessTargetForPeerAssignmentDataTableDataSourceType>,
  'id': RevealType<['node', 'id'], ProcessTargetForPeerAssignmentDataTableDataSourceType>,
  'access': RevealType<['node', 'access'], ProcessTargetForPeerAssignmentDataTableDataSourceType>,
  'evaluations': RevealType<['node', 'evaluations'], ProcessTargetForPeerAssignmentDataTableDataSourceType>
}

const ProcessTargetForPeerAssignmentDataTableResolver = {
  dataSource: (data: ProcessTargetForPeerAssignmentDataTableQuery) => data.performance.reviewProcessTargetsConnection,
  edges: (data: ProcessTargetForPeerAssignmentDataTableQuery) => data.performance.reviewProcessTargetsConnection.edges,
  fields: {
    'access_employeeName_avatar_id': (edge: ProcessTargetForPeerAssignmentDataTableDataSourceType) => edge.node.access?.employeeName?.avatar?.id,
    'access_employeeName_avatar_url': (edge: ProcessTargetForPeerAssignmentDataTableDataSourceType) => edge.node.access?.employeeName?.avatar?.url,
    'access_employeeName_managerName_id': (edge: ProcessTargetForPeerAssignmentDataTableDataSourceType) => edge.node.access?.employeeName?.managerName?.id,
    'access_employeeName_managerName_fullName': (edge: ProcessTargetForPeerAssignmentDataTableDataSourceType) => edge.node.access?.employeeName?.managerName?.fullName,
    'access_employeeName_id': (edge: ProcessTargetForPeerAssignmentDataTableDataSourceType) => edge.node.access?.employeeName?.id,
    'access_employeeName_avatar': (edge: ProcessTargetForPeerAssignmentDataTableDataSourceType) => edge.node.access?.employeeName?.avatar,
    'access_employeeName_fullName': (edge: ProcessTargetForPeerAssignmentDataTableDataSourceType) => edge.node.access?.employeeName?.fullName,
    'access_employeeName_managerName': (edge: ProcessTargetForPeerAssignmentDataTableDataSourceType) => edge.node.access?.employeeName?.managerName,
    'access_id': (edge: ProcessTargetForPeerAssignmentDataTableDataSourceType) => edge.node.access?.id,
    'access_employeeName': (edge: ProcessTargetForPeerAssignmentDataTableDataSourceType) => edge.node.access?.employeeName,
    'id': (edge: ProcessTargetForPeerAssignmentDataTableDataSourceType) => edge.node.id,
    'access': (edge: ProcessTargetForPeerAssignmentDataTableDataSourceType) => edge.node.access,
    'evaluations': (edge: ProcessTargetForPeerAssignmentDataTableDataSourceType) => edge.node.evaluations,
  }
}

export function buildProcessTargetForPeerAssignmentDataTableFilter(
  source: DataTableSource<ProcessTargetForPeerAssignmentDataTableFields, typeof ProcessTargetForPeerAssignmentDataTableSortableFields[number]>,
  filter: DataTableFilter<PerformanceReviewProcessTargetFilter>
) {
  return filter
}

export function useProcessTargetForPeerAssignmentDataTable(
  projections: DataTableProjection<ProcessTargetForPeerAssignmentDataTableFields, typeof ProcessTargetForPeerAssignmentDataTableSortableFields[number]>[],
  options?: {
    variables?: ProcessTargetForPeerAssignmentDataTableQueryVariables
    defaultSort?: typeof ProcessTargetForPeerAssignmentDataTableSortableFields[number]
    identifier?: string
  }
): DataTableSource<ProcessTargetForPeerAssignmentDataTableFields, typeof ProcessTargetForPeerAssignmentDataTableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'ProcessTargetForPeerAssignmentDataTable'

  return {
    identifier,
    query: ProcessTargetForPeerAssignmentDataTableDocument,
    resolver: ProcessTargetForPeerAssignmentDataTableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? ProcessTargetForPeerAssignmentDataTableSortableFields.at(0),
      fields: ProcessTargetForPeerAssignmentDataTableSortableFields,
    },
    variables
  }
}
export const PastCoursesDatatableDocument = gql`
query PastCoursesDatatable($accessId: Int!, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: TrainingsTrainingFilter) {
  trainings {
    trainingsConnection(
      accessId: $accessId
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          _policies {
            read {
              can
            }
          }
          competencies {
            name
          }
          name
          sessions(accessId: $accessId) {
            id
            sessionAttendances(accessIds: [$accessId]) {
              id
              accessId
              status
            }
          }
          trainingAttendanceStatus
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type PastCoursesDatatableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<PastCoursesDatatableQuery['trainings']>['trainingsConnection']>['edges']
>

const PastCoursesDatatableSortableFields = ['name', 'trainingAttendanceStatus'] as const

interface PastCoursesDatatableFields {
  '_policies_read_can': RevealType<['node', '_policies', 'read', 'can'], PastCoursesDatatableDataSourceType>,
  '_policies_read': RevealType<['node', '_policies', 'read'], PastCoursesDatatableDataSourceType>,
  'id': RevealType<['node', 'id'], PastCoursesDatatableDataSourceType>,
  '_policies': RevealType<['node', '_policies'], PastCoursesDatatableDataSourceType>,
  'competencies': RevealType<['node', 'competencies'], PastCoursesDatatableDataSourceType>,
  'name': RevealType<['node', 'name'], PastCoursesDatatableDataSourceType>,
  'sessions': RevealType<['node', 'sessions'], PastCoursesDatatableDataSourceType>,
  'trainingAttendanceStatus': RevealType<['node', 'trainingAttendanceStatus'], PastCoursesDatatableDataSourceType>
}

const PastCoursesDatatableResolver = {
  dataSource: (data: PastCoursesDatatableQuery) => data.trainings.trainingsConnection,
  edges: (data: PastCoursesDatatableQuery) => data.trainings.trainingsConnection.edges,
  fields: {
    '_policies_read_can': (edge: PastCoursesDatatableDataSourceType) => edge.node._policies?.read?.can,
    '_policies_read': (edge: PastCoursesDatatableDataSourceType) => edge.node._policies?.read,
    'id': (edge: PastCoursesDatatableDataSourceType) => edge.node.id,
    '_policies': (edge: PastCoursesDatatableDataSourceType) => edge.node._policies,
    'competencies': (edge: PastCoursesDatatableDataSourceType) => edge.node.competencies,
    'name': (edge: PastCoursesDatatableDataSourceType) => edge.node.name,
    'sessions': (edge: PastCoursesDatatableDataSourceType) => edge.node.sessions,
    'trainingAttendanceStatus': (edge: PastCoursesDatatableDataSourceType) => edge.node.trainingAttendanceStatus,
  }
}

export function buildPastCoursesDatatableFilter(
  source: DataTableSource<PastCoursesDatatableFields, typeof PastCoursesDatatableSortableFields[number]>,
  filter: DataTableFilter<TrainingsTrainingFilter>
) {
  return filter
}

export function usePastCoursesDatatable(
  projections: DataTableProjection<PastCoursesDatatableFields, typeof PastCoursesDatatableSortableFields[number]>[],
  options?: {
    variables?: PastCoursesDatatableQueryVariables
    defaultSort?: typeof PastCoursesDatatableSortableFields[number]
    identifier?: string
  }
): DataTableSource<PastCoursesDatatableFields, typeof PastCoursesDatatableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'PastCoursesDatatable'

  return {
    identifier,
    query: PastCoursesDatatableDocument,
    resolver: PastCoursesDatatableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? PastCoursesDatatableSortableFields.at(0),
      fields: PastCoursesDatatableSortableFields,
    },
    variables
  }
}
export const TargetGroupDataTableDocument = gql`
query TargetGroupDataTable($id: Int!, $searchValue: String, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: PerformanceReviewProcessEstimatedTargetFilter) {
  performance {
    reviewProcessEstimatedTargetsConnection(
      performanceReviewProcessIds: [$id]
      search: $searchValue
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          access {
            id
            employeeName(onlyActive: true) {
              id
              avatar {
                id
                url
              }
              fullName
            }
          }
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type TargetGroupDataTableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<TargetGroupDataTableQuery['performance']>['reviewProcessEstimatedTargetsConnection']>['edges']
>

const TargetGroupDataTableSortableFields = ['id', 'fullName', 'id', 'id'] as const

interface TargetGroupDataTableFields {
  'access_employeeName_avatar_id': RevealType<['node', 'access', 'employeeName', 'avatar', 'id'], TargetGroupDataTableDataSourceType>,
  'access_employeeName_avatar_url': RevealType<['node', 'access', 'employeeName', 'avatar', 'url'], TargetGroupDataTableDataSourceType>,
  'access_employeeName_id': RevealType<['node', 'access', 'employeeName', 'id'], TargetGroupDataTableDataSourceType>,
  'access_employeeName_avatar': RevealType<['node', 'access', 'employeeName', 'avatar'], TargetGroupDataTableDataSourceType>,
  'access_employeeName_fullName': RevealType<['node', 'access', 'employeeName', 'fullName'], TargetGroupDataTableDataSourceType>,
  'access_id': RevealType<['node', 'access', 'id'], TargetGroupDataTableDataSourceType>,
  'access_employeeName': RevealType<['node', 'access', 'employeeName'], TargetGroupDataTableDataSourceType>,
  'id': RevealType<['node', 'id'], TargetGroupDataTableDataSourceType>,
  'access': RevealType<['node', 'access'], TargetGroupDataTableDataSourceType>
}

const TargetGroupDataTableResolver = {
  dataSource: (data: TargetGroupDataTableQuery) => data.performance.reviewProcessEstimatedTargetsConnection,
  edges: (data: TargetGroupDataTableQuery) => data.performance.reviewProcessEstimatedTargetsConnection.edges,
  fields: {
    'access_employeeName_avatar_id': (edge: TargetGroupDataTableDataSourceType) => edge.node.access?.employeeName?.avatar?.id,
    'access_employeeName_avatar_url': (edge: TargetGroupDataTableDataSourceType) => edge.node.access?.employeeName?.avatar?.url,
    'access_employeeName_id': (edge: TargetGroupDataTableDataSourceType) => edge.node.access?.employeeName?.id,
    'access_employeeName_avatar': (edge: TargetGroupDataTableDataSourceType) => edge.node.access?.employeeName?.avatar,
    'access_employeeName_fullName': (edge: TargetGroupDataTableDataSourceType) => edge.node.access?.employeeName?.fullName,
    'access_id': (edge: TargetGroupDataTableDataSourceType) => edge.node.access?.id,
    'access_employeeName': (edge: TargetGroupDataTableDataSourceType) => edge.node.access?.employeeName,
    'id': (edge: TargetGroupDataTableDataSourceType) => edge.node.id,
    'access': (edge: TargetGroupDataTableDataSourceType) => edge.node.access,
  }
}

export function buildTargetGroupDataTableFilter(
  source: DataTableSource<TargetGroupDataTableFields, typeof TargetGroupDataTableSortableFields[number]>,
  filter: DataTableFilter<PerformanceReviewProcessEstimatedTargetFilter>
) {
  return filter
}

export function useTargetGroupDataTable(
  projections: DataTableProjection<TargetGroupDataTableFields, typeof TargetGroupDataTableSortableFields[number]>[],
  options?: {
    variables?: TargetGroupDataTableQueryVariables
    defaultSort?: typeof TargetGroupDataTableSortableFields[number]
    identifier?: string
  }
): DataTableSource<TargetGroupDataTableFields, typeof TargetGroupDataTableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'TargetGroupDataTable'

  return {
    identifier,
    query: TargetGroupDataTableDocument,
    resolver: TargetGroupDataTableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? TargetGroupDataTableSortableFields.at(0),
      fields: TargetGroupDataTableSortableFields,
    },
    variables
  }
}
export const PerformanceReviewsDataTableDocument = gql`
query PerformanceReviewsDataTable($ids: [Int!]!, $includeParticipation: Boolean!, $search: String, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: PerformanceReviewProcessFilter) {
  performance {
    reviewProcessesConnection(
      ids: $ids
      search: $search
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          __typename
          _policies {
            manage {
              id
              can
            }
          }
          archived
          endsAt
          name
          participation @include(if: $includeParticipation) {
            id
            evaluationsCount
            publishedEvaluationsCount
          }
          performanceCycle {
            id
            endOn
            startOn
            title
          }
          startsAt
          status
          createdAt
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type PerformanceReviewsDataTableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<PerformanceReviewsDataTableQuery['performance']>['reviewProcessesConnection']>['edges']
>

const PerformanceReviewsDataTableSortableFields = ['id', 'archived', 'endsAt', 'name', 'startsAt', 'status', 'createdAt'] as const

interface PerformanceReviewsDataTableFields {
  '_policies_manage_id': RevealType<['node', '_policies', 'manage', 'id'], PerformanceReviewsDataTableDataSourceType>,
  '_policies_manage_can': RevealType<['node', '_policies', 'manage', 'can'], PerformanceReviewsDataTableDataSourceType>,
  '_policies_manage': RevealType<['node', '_policies', 'manage'], PerformanceReviewsDataTableDataSourceType>,
  'participation_id': RevealType<['node', 'participation', 'id'], PerformanceReviewsDataTableDataSourceType>,
  'participation_evaluationsCount': RevealType<['node', 'participation', 'evaluationsCount'], PerformanceReviewsDataTableDataSourceType>,
  'participation_publishedEvaluationsCount': RevealType<['node', 'participation', 'publishedEvaluationsCount'], PerformanceReviewsDataTableDataSourceType>,
  'performanceCycle_id': RevealType<['node', 'performanceCycle', 'id'], PerformanceReviewsDataTableDataSourceType>,
  'performanceCycle_endOn': RevealType<['node', 'performanceCycle', 'endOn'], PerformanceReviewsDataTableDataSourceType>,
  'performanceCycle_startOn': RevealType<['node', 'performanceCycle', 'startOn'], PerformanceReviewsDataTableDataSourceType>,
  'performanceCycle_title': RevealType<['node', 'performanceCycle', 'title'], PerformanceReviewsDataTableDataSourceType>,
  'id': RevealType<['node', 'id'], PerformanceReviewsDataTableDataSourceType>,
  '__typename': RevealType<['node', '__typename'], PerformanceReviewsDataTableDataSourceType>,
  '_policies': RevealType<['node', '_policies'], PerformanceReviewsDataTableDataSourceType>,
  'archived': RevealType<['node', 'archived'], PerformanceReviewsDataTableDataSourceType>,
  'endsAt': RevealType<['node', 'endsAt'], PerformanceReviewsDataTableDataSourceType>,
  'name': RevealType<['node', 'name'], PerformanceReviewsDataTableDataSourceType>,
  'participation': RevealType<['node', 'participation'], PerformanceReviewsDataTableDataSourceType>,
  'performanceCycle': RevealType<['node', 'performanceCycle'], PerformanceReviewsDataTableDataSourceType>,
  'startsAt': RevealType<['node', 'startsAt'], PerformanceReviewsDataTableDataSourceType>,
  'status': RevealType<['node', 'status'], PerformanceReviewsDataTableDataSourceType>,
  'createdAt': RevealType<['node', 'createdAt'], PerformanceReviewsDataTableDataSourceType>
}

const PerformanceReviewsDataTableResolver = {
  dataSource: (data: PerformanceReviewsDataTableQuery) => data.performance.reviewProcessesConnection,
  edges: (data: PerformanceReviewsDataTableQuery) => data.performance.reviewProcessesConnection.edges,
  fields: {
    '_policies_manage_id': (edge: PerformanceReviewsDataTableDataSourceType) => edge.node._policies?.manage?.id,
    '_policies_manage_can': (edge: PerformanceReviewsDataTableDataSourceType) => edge.node._policies?.manage?.can,
    '_policies_manage': (edge: PerformanceReviewsDataTableDataSourceType) => edge.node._policies?.manage,
    'participation_id': (edge: PerformanceReviewsDataTableDataSourceType) => edge.node.participation?.id,
    'participation_evaluationsCount': (edge: PerformanceReviewsDataTableDataSourceType) => edge.node.participation?.evaluationsCount,
    'participation_publishedEvaluationsCount': (edge: PerformanceReviewsDataTableDataSourceType) => edge.node.participation?.publishedEvaluationsCount,
    'performanceCycle_id': (edge: PerformanceReviewsDataTableDataSourceType) => edge.node.performanceCycle?.id,
    'performanceCycle_endOn': (edge: PerformanceReviewsDataTableDataSourceType) => edge.node.performanceCycle?.endOn,
    'performanceCycle_startOn': (edge: PerformanceReviewsDataTableDataSourceType) => edge.node.performanceCycle?.startOn,
    'performanceCycle_title': (edge: PerformanceReviewsDataTableDataSourceType) => edge.node.performanceCycle?.title,
    'id': (edge: PerformanceReviewsDataTableDataSourceType) => edge.node.id,
    '__typename': (edge: PerformanceReviewsDataTableDataSourceType) => edge.node.__typename,
    '_policies': (edge: PerformanceReviewsDataTableDataSourceType) => edge.node._policies,
    'archived': (edge: PerformanceReviewsDataTableDataSourceType) => edge.node.archived,
    'endsAt': (edge: PerformanceReviewsDataTableDataSourceType) => edge.node.endsAt,
    'name': (edge: PerformanceReviewsDataTableDataSourceType) => edge.node.name,
    'participation': (edge: PerformanceReviewsDataTableDataSourceType) => edge.node.participation,
    'performanceCycle': (edge: PerformanceReviewsDataTableDataSourceType) => edge.node.performanceCycle,
    'startsAt': (edge: PerformanceReviewsDataTableDataSourceType) => edge.node.startsAt,
    'status': (edge: PerformanceReviewsDataTableDataSourceType) => edge.node.status,
    'createdAt': (edge: PerformanceReviewsDataTableDataSourceType) => edge.node.createdAt,
  }
}

export function buildPerformanceReviewsDataTableFilter(
  source: DataTableSource<PerformanceReviewsDataTableFields, typeof PerformanceReviewsDataTableSortableFields[number]>,
  filter: DataTableFilter<PerformanceReviewProcessFilter>
) {
  return filter
}

export function usePerformanceReviewsDataTable(
  projections: DataTableProjection<PerformanceReviewsDataTableFields, typeof PerformanceReviewsDataTableSortableFields[number]>[],
  options?: {
    variables?: PerformanceReviewsDataTableQueryVariables
    defaultSort?: typeof PerformanceReviewsDataTableSortableFields[number]
    identifier?: string
  }
): DataTableSource<PerformanceReviewsDataTableFields, typeof PerformanceReviewsDataTableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'PerformanceReviewsDataTable'

  return {
    identifier,
    query: PerformanceReviewsDataTableDocument,
    resolver: PerformanceReviewsDataTableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? PerformanceReviewsDataTableSortableFields.at(0),
      fields: PerformanceReviewsDataTableSortableFields,
    },
    variables
  }
}
export const TemplateTargetGroupDataTableDocument = gql`
query TemplateTargetGroupDataTable($customTemplateId: Int!, $searchValue: String, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: PerformanceReviewProcessCustomTemplatesEstimatedTargetFilter) {
  performance {
    reviewProcessCustomTemplatesEstimatedTargetsConnection(
      performanceCustomTemplateIds: [$customTemplateId]
      search: $searchValue
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          access {
            id
            avatar
            employee(onlyActive: true) {
              id
              access {
                id
                avatar
                fullName
              }
            }
            fullName
          }
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type TemplateTargetGroupDataTableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<TemplateTargetGroupDataTableQuery['performance']>['reviewProcessCustomTemplatesEstimatedTargetsConnection']>['edges']
>

const TemplateTargetGroupDataTableSortableFields = ['id', 'id', 'id', 'id'] as const

interface TemplateTargetGroupDataTableFields {
  'access_employee_access_id': RevealType<['node', 'access', 'employee', 'access', 'id'], TemplateTargetGroupDataTableDataSourceType>,
  'access_employee_access_avatar': RevealType<['node', 'access', 'employee', 'access', 'avatar'], TemplateTargetGroupDataTableDataSourceType>,
  'access_employee_access_fullName': RevealType<['node', 'access', 'employee', 'access', 'fullName'], TemplateTargetGroupDataTableDataSourceType>,
  'access_employee_id': RevealType<['node', 'access', 'employee', 'id'], TemplateTargetGroupDataTableDataSourceType>,
  'access_employee_access': RevealType<['node', 'access', 'employee', 'access'], TemplateTargetGroupDataTableDataSourceType>,
  'access_id': RevealType<['node', 'access', 'id'], TemplateTargetGroupDataTableDataSourceType>,
  'access_avatar': RevealType<['node', 'access', 'avatar'], TemplateTargetGroupDataTableDataSourceType>,
  'access_employee': RevealType<['node', 'access', 'employee'], TemplateTargetGroupDataTableDataSourceType>,
  'access_fullName': RevealType<['node', 'access', 'fullName'], TemplateTargetGroupDataTableDataSourceType>,
  'id': RevealType<['node', 'id'], TemplateTargetGroupDataTableDataSourceType>,
  'access': RevealType<['node', 'access'], TemplateTargetGroupDataTableDataSourceType>
}

const TemplateTargetGroupDataTableResolver = {
  dataSource: (data: TemplateTargetGroupDataTableQuery) => data.performance.reviewProcessCustomTemplatesEstimatedTargetsConnection,
  edges: (data: TemplateTargetGroupDataTableQuery) => data.performance.reviewProcessCustomTemplatesEstimatedTargetsConnection.edges,
  fields: {
    'access_employee_access_id': (edge: TemplateTargetGroupDataTableDataSourceType) => edge.node.access?.employee?.access?.id,
    'access_employee_access_avatar': (edge: TemplateTargetGroupDataTableDataSourceType) => edge.node.access?.employee?.access?.avatar,
    'access_employee_access_fullName': (edge: TemplateTargetGroupDataTableDataSourceType) => edge.node.access?.employee?.access?.fullName,
    'access_employee_id': (edge: TemplateTargetGroupDataTableDataSourceType) => edge.node.access?.employee?.id,
    'access_employee_access': (edge: TemplateTargetGroupDataTableDataSourceType) => edge.node.access?.employee?.access,
    'access_id': (edge: TemplateTargetGroupDataTableDataSourceType) => edge.node.access?.id,
    'access_avatar': (edge: TemplateTargetGroupDataTableDataSourceType) => edge.node.access?.avatar,
    'access_employee': (edge: TemplateTargetGroupDataTableDataSourceType) => edge.node.access?.employee,
    'access_fullName': (edge: TemplateTargetGroupDataTableDataSourceType) => edge.node.access?.fullName,
    'id': (edge: TemplateTargetGroupDataTableDataSourceType) => edge.node.id,
    'access': (edge: TemplateTargetGroupDataTableDataSourceType) => edge.node.access,
  }
}

export function buildTemplateTargetGroupDataTableFilter(
  source: DataTableSource<TemplateTargetGroupDataTableFields, typeof TemplateTargetGroupDataTableSortableFields[number]>,
  filter: DataTableFilter<PerformanceReviewProcessCustomTemplatesEstimatedTargetFilter>
) {
  return filter
}

export function useTemplateTargetGroupDataTable(
  projections: DataTableProjection<TemplateTargetGroupDataTableFields, typeof TemplateTargetGroupDataTableSortableFields[number]>[],
  options?: {
    variables?: TemplateTargetGroupDataTableQueryVariables
    defaultSort?: typeof TemplateTargetGroupDataTableSortableFields[number]
    identifier?: string
  }
): DataTableSource<TemplateTargetGroupDataTableFields, typeof TemplateTargetGroupDataTableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'TemplateTargetGroupDataTable'

  return {
    identifier,
    query: TemplateTargetGroupDataTableDocument,
    resolver: TemplateTargetGroupDataTableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? TemplateTargetGroupDataTableSortableFields.at(0),
      fields: TemplateTargetGroupDataTableSortableFields,
    },
    variables
  }
}
export const CustomTemplatesDataTableDocument = gql`
query CustomTemplatesDataTable($ids: [Int!]!, $search: String, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: PerformanceReviewProcessCustomTemplateFilter) {
  performance {
    reviewProcessCustomTemplatesConnection(
      ids: $ids
      search: $search
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          _policies {
            manage {
              id
              can
            }
          }
          author {
            id
            avatar
            firstName
            lastName
          }
          name
          reviewerStrategies
          createdAt
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type CustomTemplatesDataTableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<CustomTemplatesDataTableQuery['performance']>['reviewProcessCustomTemplatesConnection']>['edges']
>

const CustomTemplatesDataTableSortableFields = ['id', 'firstName', 'id', 'name', 'reviewerStrategies', 'createdAt'] as const

interface CustomTemplatesDataTableFields {
  '_policies_manage_id': RevealType<['node', '_policies', 'manage', 'id'], CustomTemplatesDataTableDataSourceType>,
  '_policies_manage_can': RevealType<['node', '_policies', 'manage', 'can'], CustomTemplatesDataTableDataSourceType>,
  '_policies_manage': RevealType<['node', '_policies', 'manage'], CustomTemplatesDataTableDataSourceType>,
  'author_id': RevealType<['node', 'author', 'id'], CustomTemplatesDataTableDataSourceType>,
  'author_avatar': RevealType<['node', 'author', 'avatar'], CustomTemplatesDataTableDataSourceType>,
  'author_firstName': RevealType<['node', 'author', 'firstName'], CustomTemplatesDataTableDataSourceType>,
  'author_lastName': RevealType<['node', 'author', 'lastName'], CustomTemplatesDataTableDataSourceType>,
  'id': RevealType<['node', 'id'], CustomTemplatesDataTableDataSourceType>,
  '_policies': RevealType<['node', '_policies'], CustomTemplatesDataTableDataSourceType>,
  'author': RevealType<['node', 'author'], CustomTemplatesDataTableDataSourceType>,
  'name': RevealType<['node', 'name'], CustomTemplatesDataTableDataSourceType>,
  'reviewerStrategies': RevealType<['node', 'reviewerStrategies'], CustomTemplatesDataTableDataSourceType>,
  'createdAt': RevealType<['node', 'createdAt'], CustomTemplatesDataTableDataSourceType>
}

const CustomTemplatesDataTableResolver = {
  dataSource: (data: CustomTemplatesDataTableQuery) => data.performance.reviewProcessCustomTemplatesConnection,
  edges: (data: CustomTemplatesDataTableQuery) => data.performance.reviewProcessCustomTemplatesConnection.edges,
  fields: {
    '_policies_manage_id': (edge: CustomTemplatesDataTableDataSourceType) => edge.node._policies?.manage?.id,
    '_policies_manage_can': (edge: CustomTemplatesDataTableDataSourceType) => edge.node._policies?.manage?.can,
    '_policies_manage': (edge: CustomTemplatesDataTableDataSourceType) => edge.node._policies?.manage,
    'author_id': (edge: CustomTemplatesDataTableDataSourceType) => edge.node.author?.id,
    'author_avatar': (edge: CustomTemplatesDataTableDataSourceType) => edge.node.author?.avatar,
    'author_firstName': (edge: CustomTemplatesDataTableDataSourceType) => edge.node.author?.firstName,
    'author_lastName': (edge: CustomTemplatesDataTableDataSourceType) => edge.node.author?.lastName,
    'id': (edge: CustomTemplatesDataTableDataSourceType) => edge.node.id,
    '_policies': (edge: CustomTemplatesDataTableDataSourceType) => edge.node._policies,
    'author': (edge: CustomTemplatesDataTableDataSourceType) => edge.node.author,
    'name': (edge: CustomTemplatesDataTableDataSourceType) => edge.node.name,
    'reviewerStrategies': (edge: CustomTemplatesDataTableDataSourceType) => edge.node.reviewerStrategies,
    'createdAt': (edge: CustomTemplatesDataTableDataSourceType) => edge.node.createdAt,
  }
}

export function buildCustomTemplatesDataTableFilter(
  source: DataTableSource<CustomTemplatesDataTableFields, typeof CustomTemplatesDataTableSortableFields[number]>,
  filter: DataTableFilter<PerformanceReviewProcessCustomTemplateFilter>
) {
  return filter
}

export function useCustomTemplatesDataTable(
  projections: DataTableProjection<CustomTemplatesDataTableFields, typeof CustomTemplatesDataTableSortableFields[number]>[],
  options?: {
    variables?: CustomTemplatesDataTableQueryVariables
    defaultSort?: typeof CustomTemplatesDataTableSortableFields[number]
    identifier?: string
  }
): DataTableSource<CustomTemplatesDataTableFields, typeof CustomTemplatesDataTableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'CustomTemplatesDataTable'

  return {
    identifier,
    query: CustomTemplatesDataTableDocument,
    resolver: CustomTemplatesDataTableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? CustomTemplatesDataTableSortableFields.at(0),
      fields: CustomTemplatesDataTableSortableFields,
    },
    variables
  }
}
export const PredefinedTemplatesDataTableDocument = gql`
query PredefinedTemplatesDataTable($ids: [Int!]!, $search: String, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: PerformanceReviewProcessTemplateFilter) {
  performance {
    reviewProcessTemplatesConnection(
      ids: $ids
      search: $search
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          name
          reviewerStrategies
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type PredefinedTemplatesDataTableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<PredefinedTemplatesDataTableQuery['performance']>['reviewProcessTemplatesConnection']>['edges']
>

const PredefinedTemplatesDataTableSortableFields = ['id', 'name', 'reviewerStrategies'] as const

interface PredefinedTemplatesDataTableFields {
  'id': RevealType<['node', 'id'], PredefinedTemplatesDataTableDataSourceType>,
  'name': RevealType<['node', 'name'], PredefinedTemplatesDataTableDataSourceType>,
  'reviewerStrategies': RevealType<['node', 'reviewerStrategies'], PredefinedTemplatesDataTableDataSourceType>
}

const PredefinedTemplatesDataTableResolver = {
  dataSource: (data: PredefinedTemplatesDataTableQuery) => data.performance.reviewProcessTemplatesConnection,
  edges: (data: PredefinedTemplatesDataTableQuery) => data.performance.reviewProcessTemplatesConnection.edges,
  fields: {
    'id': (edge: PredefinedTemplatesDataTableDataSourceType) => edge.node.id,
    'name': (edge: PredefinedTemplatesDataTableDataSourceType) => edge.node.name,
    'reviewerStrategies': (edge: PredefinedTemplatesDataTableDataSourceType) => edge.node.reviewerStrategies,
  }
}

export function buildPredefinedTemplatesDataTableFilter(
  source: DataTableSource<PredefinedTemplatesDataTableFields, typeof PredefinedTemplatesDataTableSortableFields[number]>,
  filter: DataTableFilter<PerformanceReviewProcessTemplateFilter>
) {
  return filter
}

export function usePredefinedTemplatesDataTable(
  projections: DataTableProjection<PredefinedTemplatesDataTableFields, typeof PredefinedTemplatesDataTableSortableFields[number]>[],
  options?: {
    variables?: PredefinedTemplatesDataTableQueryVariables
    defaultSort?: typeof PredefinedTemplatesDataTableSortableFields[number]
    identifier?: string
  }
): DataTableSource<PredefinedTemplatesDataTableFields, typeof PredefinedTemplatesDataTableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'PredefinedTemplatesDataTable'

  return {
    identifier,
    query: PredefinedTemplatesDataTableDocument,
    resolver: PredefinedTemplatesDataTableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? PredefinedTemplatesDataTableSortableFields.at(0),
      fields: PredefinedTemplatesDataTableSortableFields,
    },
    variables
  }
}
export const TargetProcessesDataTableDocument = gql`
query TargetProcessesDataTable($accessIds: [Int!]!, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: PerformanceReviewProcessTargetFilter) {
  performance {
    reviewProcessTargetsConnection(
      accessIds: $accessIds
      includeArchivedReviews: false
      performanceReviewProcessStatus: [active, finished]
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          evaluations(reviewerStrategies: [manager]) {
            id
            reviewerAccess {
              id
              employeeName(onlyActive: false) {
                id
                avatar {
                  id
                  url
                }
                fullName
              }
            }
          }
          insightScore {
            id
            alignmentScore
          }
          performanceReviewProcess {
            id
            endsAt
            name
            status
          }
          reviewFinalEmployeeScore {
            id
            scaleMax
            score
          }
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type TargetProcessesDataTableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<TargetProcessesDataTableQuery['performance']>['reviewProcessTargetsConnection']>['edges']
>

const TargetProcessesDataTableSortableFields = ['id', 'endsAt', 'name', 'status', 'score', 'id'] as const

interface TargetProcessesDataTableFields {
  'insightScore_id': RevealType<['node', 'insightScore', 'id'], TargetProcessesDataTableDataSourceType>,
  'insightScore_alignmentScore': RevealType<['node', 'insightScore', 'alignmentScore'], TargetProcessesDataTableDataSourceType>,
  'performanceReviewProcess_id': RevealType<['node', 'performanceReviewProcess', 'id'], TargetProcessesDataTableDataSourceType>,
  'performanceReviewProcess_endsAt': RevealType<['node', 'performanceReviewProcess', 'endsAt'], TargetProcessesDataTableDataSourceType>,
  'performanceReviewProcess_name': RevealType<['node', 'performanceReviewProcess', 'name'], TargetProcessesDataTableDataSourceType>,
  'performanceReviewProcess_status': RevealType<['node', 'performanceReviewProcess', 'status'], TargetProcessesDataTableDataSourceType>,
  'reviewFinalEmployeeScore_id': RevealType<['node', 'reviewFinalEmployeeScore', 'id'], TargetProcessesDataTableDataSourceType>,
  'reviewFinalEmployeeScore_scaleMax': RevealType<['node', 'reviewFinalEmployeeScore', 'scaleMax'], TargetProcessesDataTableDataSourceType>,
  'reviewFinalEmployeeScore_score': RevealType<['node', 'reviewFinalEmployeeScore', 'score'], TargetProcessesDataTableDataSourceType>,
  'id': RevealType<['node', 'id'], TargetProcessesDataTableDataSourceType>,
  'evaluations': RevealType<['node', 'evaluations'], TargetProcessesDataTableDataSourceType>,
  'insightScore': RevealType<['node', 'insightScore'], TargetProcessesDataTableDataSourceType>,
  'performanceReviewProcess': RevealType<['node', 'performanceReviewProcess'], TargetProcessesDataTableDataSourceType>,
  'reviewFinalEmployeeScore': RevealType<['node', 'reviewFinalEmployeeScore'], TargetProcessesDataTableDataSourceType>
}

const TargetProcessesDataTableResolver = {
  dataSource: (data: TargetProcessesDataTableQuery) => data.performance.reviewProcessTargetsConnection,
  edges: (data: TargetProcessesDataTableQuery) => data.performance.reviewProcessTargetsConnection.edges,
  fields: {
    'insightScore_id': (edge: TargetProcessesDataTableDataSourceType) => edge.node.insightScore?.id,
    'insightScore_alignmentScore': (edge: TargetProcessesDataTableDataSourceType) => edge.node.insightScore?.alignmentScore,
    'performanceReviewProcess_id': (edge: TargetProcessesDataTableDataSourceType) => edge.node.performanceReviewProcess?.id,
    'performanceReviewProcess_endsAt': (edge: TargetProcessesDataTableDataSourceType) => edge.node.performanceReviewProcess?.endsAt,
    'performanceReviewProcess_name': (edge: TargetProcessesDataTableDataSourceType) => edge.node.performanceReviewProcess?.name,
    'performanceReviewProcess_status': (edge: TargetProcessesDataTableDataSourceType) => edge.node.performanceReviewProcess?.status,
    'reviewFinalEmployeeScore_id': (edge: TargetProcessesDataTableDataSourceType) => edge.node.reviewFinalEmployeeScore?.id,
    'reviewFinalEmployeeScore_scaleMax': (edge: TargetProcessesDataTableDataSourceType) => edge.node.reviewFinalEmployeeScore?.scaleMax,
    'reviewFinalEmployeeScore_score': (edge: TargetProcessesDataTableDataSourceType) => edge.node.reviewFinalEmployeeScore?.score,
    'id': (edge: TargetProcessesDataTableDataSourceType) => edge.node.id,
    'evaluations': (edge: TargetProcessesDataTableDataSourceType) => edge.node.evaluations,
    'insightScore': (edge: TargetProcessesDataTableDataSourceType) => edge.node.insightScore,
    'performanceReviewProcess': (edge: TargetProcessesDataTableDataSourceType) => edge.node.performanceReviewProcess,
    'reviewFinalEmployeeScore': (edge: TargetProcessesDataTableDataSourceType) => edge.node.reviewFinalEmployeeScore,
  }
}

export function buildTargetProcessesDataTableFilter(
  source: DataTableSource<TargetProcessesDataTableFields, typeof TargetProcessesDataTableSortableFields[number]>,
  filter: DataTableFilter<PerformanceReviewProcessTargetFilter>
) {
  return filter
}

export function useTargetProcessesDataTable(
  projections: DataTableProjection<TargetProcessesDataTableFields, typeof TargetProcessesDataTableSortableFields[number]>[],
  options?: {
    variables?: TargetProcessesDataTableQueryVariables
    defaultSort?: typeof TargetProcessesDataTableSortableFields[number]
    identifier?: string
  }
): DataTableSource<TargetProcessesDataTableFields, typeof TargetProcessesDataTableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'TargetProcessesDataTable'

  return {
    identifier,
    query: TargetProcessesDataTableDocument,
    resolver: TargetProcessesDataTableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? TargetProcessesDataTableSortableFields.at(0),
      fields: TargetProcessesDataTableSortableFields,
    },
    variables
  }
}
export const MandatoryProcessTasksDocument = gql`
query MandatoryProcessTasks($category: ProcessesProcessCategoryEnum!, $mandatory: Boolean, $processId: Int!, $search: String, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: TasksMaterializedProcessTaskFilter) {
  tasks {
    materializedProcessTasksConnection(
      mandatory: $mandatory
      processCategory: $category
      processId: $processId
      search: $search
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          affecteesConnection(first: 1) {
            nodes {
              id
              avatar
              fullName
            }
            totalCount
          }
          assigneesConnection(first: 3) {
            nodes {
              id
              avatar
              fullName
            }
            totalCount
          }
          completedAt
          contractEndDate
          contractReferenceDate
          contractStartDate
          dueOn
          materializedItemId
          materializedProcessId
          name
          stepName
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type MandatoryProcessTasksDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<MandatoryProcessTasksQuery['tasks']>['materializedProcessTasksConnection']>['edges']
>

const MandatoryProcessTasksSortableFields = ['id', 'dueOn', 'name', 'stepName'] as const

interface MandatoryProcessTasksFields {
  'affecteesConnection_nodes': RevealType<['node', 'affecteesConnection', 'nodes'], MandatoryProcessTasksDataSourceType>,
  'affecteesConnection_totalCount': RevealType<['node', 'affecteesConnection', 'totalCount'], MandatoryProcessTasksDataSourceType>,
  'assigneesConnection_nodes': RevealType<['node', 'assigneesConnection', 'nodes'], MandatoryProcessTasksDataSourceType>,
  'assigneesConnection_totalCount': RevealType<['node', 'assigneesConnection', 'totalCount'], MandatoryProcessTasksDataSourceType>,
  'id': RevealType<['node', 'id'], MandatoryProcessTasksDataSourceType>,
  'affecteesConnection': RevealType<['node', 'affecteesConnection'], MandatoryProcessTasksDataSourceType>,
  'assigneesConnection': RevealType<['node', 'assigneesConnection'], MandatoryProcessTasksDataSourceType>,
  'completedAt': RevealType<['node', 'completedAt'], MandatoryProcessTasksDataSourceType>,
  'contractEndDate': RevealType<['node', 'contractEndDate'], MandatoryProcessTasksDataSourceType>,
  'contractReferenceDate': RevealType<['node', 'contractReferenceDate'], MandatoryProcessTasksDataSourceType>,
  'contractStartDate': RevealType<['node', 'contractStartDate'], MandatoryProcessTasksDataSourceType>,
  'dueOn': RevealType<['node', 'dueOn'], MandatoryProcessTasksDataSourceType>,
  'materializedItemId': RevealType<['node', 'materializedItemId'], MandatoryProcessTasksDataSourceType>,
  'materializedProcessId': RevealType<['node', 'materializedProcessId'], MandatoryProcessTasksDataSourceType>,
  'name': RevealType<['node', 'name'], MandatoryProcessTasksDataSourceType>,
  'stepName': RevealType<['node', 'stepName'], MandatoryProcessTasksDataSourceType>
}

const MandatoryProcessTasksResolver = {
  dataSource: (data: MandatoryProcessTasksQuery) => data.tasks.materializedProcessTasksConnection,
  edges: (data: MandatoryProcessTasksQuery) => data.tasks.materializedProcessTasksConnection.edges,
  fields: {
    'affecteesConnection_nodes': (edge: MandatoryProcessTasksDataSourceType) => edge.node.affecteesConnection?.nodes,
    'affecteesConnection_totalCount': (edge: MandatoryProcessTasksDataSourceType) => edge.node.affecteesConnection?.totalCount,
    'assigneesConnection_nodes': (edge: MandatoryProcessTasksDataSourceType) => edge.node.assigneesConnection?.nodes,
    'assigneesConnection_totalCount': (edge: MandatoryProcessTasksDataSourceType) => edge.node.assigneesConnection?.totalCount,
    'id': (edge: MandatoryProcessTasksDataSourceType) => edge.node.id,
    'affecteesConnection': (edge: MandatoryProcessTasksDataSourceType) => edge.node.affecteesConnection,
    'assigneesConnection': (edge: MandatoryProcessTasksDataSourceType) => edge.node.assigneesConnection,
    'completedAt': (edge: MandatoryProcessTasksDataSourceType) => edge.node.completedAt,
    'contractEndDate': (edge: MandatoryProcessTasksDataSourceType) => edge.node.contractEndDate,
    'contractReferenceDate': (edge: MandatoryProcessTasksDataSourceType) => edge.node.contractReferenceDate,
    'contractStartDate': (edge: MandatoryProcessTasksDataSourceType) => edge.node.contractStartDate,
    'dueOn': (edge: MandatoryProcessTasksDataSourceType) => edge.node.dueOn,
    'materializedItemId': (edge: MandatoryProcessTasksDataSourceType) => edge.node.materializedItemId,
    'materializedProcessId': (edge: MandatoryProcessTasksDataSourceType) => edge.node.materializedProcessId,
    'name': (edge: MandatoryProcessTasksDataSourceType) => edge.node.name,
    'stepName': (edge: MandatoryProcessTasksDataSourceType) => edge.node.stepName,
  }
}

export function buildMandatoryProcessTasksFilter(
  source: DataTableSource<MandatoryProcessTasksFields, typeof MandatoryProcessTasksSortableFields[number]>,
  filter: DataTableFilter<TasksMaterializedProcessTaskFilter>
) {
  return filter
}

export function useMandatoryProcessTasks(
  projections: DataTableProjection<MandatoryProcessTasksFields, typeof MandatoryProcessTasksSortableFields[number]>[],
  options?: {
    variables?: MandatoryProcessTasksQueryVariables
    defaultSort?: typeof MandatoryProcessTasksSortableFields[number]
    identifier?: string
  }
): DataTableSource<MandatoryProcessTasksFields, typeof MandatoryProcessTasksSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'MandatoryProcessTasks'

  return {
    identifier,
    query: MandatoryProcessTasksDocument,
    resolver: MandatoryProcessTasksResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? MandatoryProcessTasksSortableFields.at(0),
      fields: MandatoryProcessTasksSortableFields,
    },
    variables
  }
}
export const MaterializedProcessesDataTableDocument = gql`
query MaterializedProcessesDataTable($ids: [Int!], $includeItemsCount: Boolean, $materializedTasksAccessId: Int, $processId: Int, $search: String, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: ProcessesMaterializedProcessFilter) {
  processes {
    materializedProcessesConnection(
      ids: $ids
      includeItemsCount: $includeItemsCount
      materializedTasksAccessId: $materializedTasksAccessId
      processId: $processId
      search: $search
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          completedResources
          contractEndsOn
          contractStartsOn
          finalizedAt
          name
          nextItemDueDate
          process {
            id
          }
          resourceRelationships {
            id
            access {
              id
              avatar
              employee {
                id
                referenceContract {
                  id
                  trialPeriodEndsOn
                }
              }
              fullName
            }
            resourceId
          }
          status
          totalResources
          trainingName
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type MaterializedProcessesDataTableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<MaterializedProcessesDataTableQuery['processes']>['materializedProcessesConnection']>['edges']
>

const MaterializedProcessesDataTableSortableFields = ['id', 'name', 'status'] as const

interface MaterializedProcessesDataTableFields {
  'process_id': RevealType<['node', 'process', 'id'], MaterializedProcessesDataTableDataSourceType>,
  'id': RevealType<['node', 'id'], MaterializedProcessesDataTableDataSourceType>,
  'completedResources': RevealType<['node', 'completedResources'], MaterializedProcessesDataTableDataSourceType>,
  'contractEndsOn': RevealType<['node', 'contractEndsOn'], MaterializedProcessesDataTableDataSourceType>,
  'contractStartsOn': RevealType<['node', 'contractStartsOn'], MaterializedProcessesDataTableDataSourceType>,
  'finalizedAt': RevealType<['node', 'finalizedAt'], MaterializedProcessesDataTableDataSourceType>,
  'name': RevealType<['node', 'name'], MaterializedProcessesDataTableDataSourceType>,
  'nextItemDueDate': RevealType<['node', 'nextItemDueDate'], MaterializedProcessesDataTableDataSourceType>,
  'process': RevealType<['node', 'process'], MaterializedProcessesDataTableDataSourceType>,
  'resourceRelationships': RevealType<['node', 'resourceRelationships'], MaterializedProcessesDataTableDataSourceType>,
  'status': RevealType<['node', 'status'], MaterializedProcessesDataTableDataSourceType>,
  'totalResources': RevealType<['node', 'totalResources'], MaterializedProcessesDataTableDataSourceType>,
  'trainingName': RevealType<['node', 'trainingName'], MaterializedProcessesDataTableDataSourceType>
}

const MaterializedProcessesDataTableResolver = {
  dataSource: (data: MaterializedProcessesDataTableQuery) => data.processes.materializedProcessesConnection,
  edges: (data: MaterializedProcessesDataTableQuery) => data.processes.materializedProcessesConnection.edges,
  fields: {
    'process_id': (edge: MaterializedProcessesDataTableDataSourceType) => edge.node.process?.id,
    'id': (edge: MaterializedProcessesDataTableDataSourceType) => edge.node.id,
    'completedResources': (edge: MaterializedProcessesDataTableDataSourceType) => edge.node.completedResources,
    'contractEndsOn': (edge: MaterializedProcessesDataTableDataSourceType) => edge.node.contractEndsOn,
    'contractStartsOn': (edge: MaterializedProcessesDataTableDataSourceType) => edge.node.contractStartsOn,
    'finalizedAt': (edge: MaterializedProcessesDataTableDataSourceType) => edge.node.finalizedAt,
    'name': (edge: MaterializedProcessesDataTableDataSourceType) => edge.node.name,
    'nextItemDueDate': (edge: MaterializedProcessesDataTableDataSourceType) => edge.node.nextItemDueDate,
    'process': (edge: MaterializedProcessesDataTableDataSourceType) => edge.node.process,
    'resourceRelationships': (edge: MaterializedProcessesDataTableDataSourceType) => edge.node.resourceRelationships,
    'status': (edge: MaterializedProcessesDataTableDataSourceType) => edge.node.status,
    'totalResources': (edge: MaterializedProcessesDataTableDataSourceType) => edge.node.totalResources,
    'trainingName': (edge: MaterializedProcessesDataTableDataSourceType) => edge.node.trainingName,
  }
}

export function buildMaterializedProcessesDataTableFilter(
  source: DataTableSource<MaterializedProcessesDataTableFields, typeof MaterializedProcessesDataTableSortableFields[number]>,
  filter: DataTableFilter<ProcessesMaterializedProcessFilter>
) {
  return filter
}

export function useMaterializedProcessesDataTable(
  projections: DataTableProjection<MaterializedProcessesDataTableFields, typeof MaterializedProcessesDataTableSortableFields[number]>[],
  options?: {
    variables?: MaterializedProcessesDataTableQueryVariables
    defaultSort?: typeof MaterializedProcessesDataTableSortableFields[number]
    identifier?: string
  }
): DataTableSource<MaterializedProcessesDataTableFields, typeof MaterializedProcessesDataTableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'MaterializedProcessesDataTable'

  return {
    identifier,
    query: MaterializedProcessesDataTableDocument,
    resolver: MaterializedProcessesDataTableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? MaterializedProcessesDataTableSortableFields.at(0),
      fields: MaterializedProcessesDataTableSortableFields,
    },
    variables
  }
}
export const ProcurementPurchaseOrdersInvoicesDatatableDocument = gql`
query ProcurementPurchaseOrdersInvoicesDatatable($companyId: Int!, $ids: [Int!], $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: FinanceFinancialDocumentAssociationFilter) {
  finance {
    financialDocumentAssociationsConnection(
      resourceIds: $ids
      resourceType: "purchaseorder"
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          financialDocument(companyId: $companyId) {
            id
            currency
            documentDate
            documentNumber
            totalAmountCents
          }
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type ProcurementPurchaseOrdersInvoicesDatatableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<ProcurementPurchaseOrdersInvoicesDatatableQuery['finance']>['financialDocumentAssociationsConnection']>['edges']
>

const ProcurementPurchaseOrdersInvoicesDatatableSortableFields = ['currency', 'documentDate', 'documentNumber', 'totalAmountCents'] as const

interface ProcurementPurchaseOrdersInvoicesDatatableFields {
  'financialDocument_id': RevealType<['node', 'financialDocument', 'id'], ProcurementPurchaseOrdersInvoicesDatatableDataSourceType>,
  'financialDocument_currency': RevealType<['node', 'financialDocument', 'currency'], ProcurementPurchaseOrdersInvoicesDatatableDataSourceType>,
  'financialDocument_documentDate': RevealType<['node', 'financialDocument', 'documentDate'], ProcurementPurchaseOrdersInvoicesDatatableDataSourceType>,
  'financialDocument_documentNumber': RevealType<['node', 'financialDocument', 'documentNumber'], ProcurementPurchaseOrdersInvoicesDatatableDataSourceType>,
  'financialDocument_totalAmountCents': RevealType<['node', 'financialDocument', 'totalAmountCents'], ProcurementPurchaseOrdersInvoicesDatatableDataSourceType>,
  'id': RevealType<['node', 'id'], ProcurementPurchaseOrdersInvoicesDatatableDataSourceType>,
  'financialDocument': RevealType<['node', 'financialDocument'], ProcurementPurchaseOrdersInvoicesDatatableDataSourceType>
}

const ProcurementPurchaseOrdersInvoicesDatatableResolver = {
  dataSource: (data: ProcurementPurchaseOrdersInvoicesDatatableQuery) => data.finance.financialDocumentAssociationsConnection,
  edges: (data: ProcurementPurchaseOrdersInvoicesDatatableQuery) => data.finance.financialDocumentAssociationsConnection.edges,
  fields: {
    'financialDocument_id': (edge: ProcurementPurchaseOrdersInvoicesDatatableDataSourceType) => edge.node.financialDocument?.id,
    'financialDocument_currency': (edge: ProcurementPurchaseOrdersInvoicesDatatableDataSourceType) => edge.node.financialDocument?.currency,
    'financialDocument_documentDate': (edge: ProcurementPurchaseOrdersInvoicesDatatableDataSourceType) => edge.node.financialDocument?.documentDate,
    'financialDocument_documentNumber': (edge: ProcurementPurchaseOrdersInvoicesDatatableDataSourceType) => edge.node.financialDocument?.documentNumber,
    'financialDocument_totalAmountCents': (edge: ProcurementPurchaseOrdersInvoicesDatatableDataSourceType) => edge.node.financialDocument?.totalAmountCents,
    'id': (edge: ProcurementPurchaseOrdersInvoicesDatatableDataSourceType) => edge.node.id,
    'financialDocument': (edge: ProcurementPurchaseOrdersInvoicesDatatableDataSourceType) => edge.node.financialDocument,
  }
}

export function buildProcurementPurchaseOrdersInvoicesDatatableFilter(
  source: DataTableSource<ProcurementPurchaseOrdersInvoicesDatatableFields, typeof ProcurementPurchaseOrdersInvoicesDatatableSortableFields[number]>,
  filter: DataTableFilter<FinanceFinancialDocumentAssociationFilter>
) {
  return filter
}

export function useProcurementPurchaseOrdersInvoicesDatatable(
  projections: DataTableProjection<ProcurementPurchaseOrdersInvoicesDatatableFields, typeof ProcurementPurchaseOrdersInvoicesDatatableSortableFields[number]>[],
  options?: {
    variables?: ProcurementPurchaseOrdersInvoicesDatatableQueryVariables
    defaultSort?: typeof ProcurementPurchaseOrdersInvoicesDatatableSortableFields[number]
    identifier?: string
  }
): DataTableSource<ProcurementPurchaseOrdersInvoicesDatatableFields, typeof ProcurementPurchaseOrdersInvoicesDatatableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'ProcurementPurchaseOrdersInvoicesDatatable'

  return {
    identifier,
    query: ProcurementPurchaseOrdersInvoicesDatatableDocument,
    resolver: ProcurementPurchaseOrdersInvoicesDatatableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? ProcurementPurchaseOrdersInvoicesDatatableSortableFields.at(0),
      fields: ProcurementPurchaseOrdersInvoicesDatatableSortableFields,
    },
    variables
  }
}
export const ProcurementPurchaseOrdersDatatableDocument = gql`
query ProcurementPurchaseOrdersDatatable($companyId: Int!, $search: String, $status: ProcurementValueObjectsPurchaseOrderStatusEnum, $vendorId: Int, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: ProcurementPurchaseOrderFilter) {
  procurement {
    purchaseOrdersConnection(
      companyId: $companyId
      search: $search
      status: $status
      vendorId: $vendorId
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          cost {
            cents
            currency
          }
          date
          description
          formattedPoNumber
          legalEntity {
            id
            legalName
          }
          poNumber
          purchaseRequest(companyId: $companyId) {
            id
            requesterEmployee {
              id
              avatar {
                id
                url
              }
              fullName
            }
            type(companyId: $companyId) {
              id
              name
            }
          }
          status
          vendor(companyId: $companyId) {
            id
            legalName
            name
          }
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type ProcurementPurchaseOrdersDatatableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<ProcurementPurchaseOrdersDatatableQuery['procurement']>['purchaseOrdersConnection']>['edges']
>

const ProcurementPurchaseOrdersDatatableSortableFields = ['legalName', 'id', 'fullName', 'id', 'name', 'id', 'legalName', 'name', 'id', 'date', 'description', 'poNumber', 'status'] as const

interface ProcurementPurchaseOrdersDatatableFields {
  'cost_cents': RevealType<['node', 'cost', 'cents'], ProcurementPurchaseOrdersDatatableDataSourceType>,
  'cost_currency': RevealType<['node', 'cost', 'currency'], ProcurementPurchaseOrdersDatatableDataSourceType>,
  'legalEntity_id': RevealType<['node', 'legalEntity', 'id'], ProcurementPurchaseOrdersDatatableDataSourceType>,
  'legalEntity_legalName': RevealType<['node', 'legalEntity', 'legalName'], ProcurementPurchaseOrdersDatatableDataSourceType>,
  'purchaseRequest_requesterEmployee_avatar_id': RevealType<['node', 'purchaseRequest', 'requesterEmployee', 'avatar', 'id'], ProcurementPurchaseOrdersDatatableDataSourceType>,
  'purchaseRequest_requesterEmployee_avatar_url': RevealType<['node', 'purchaseRequest', 'requesterEmployee', 'avatar', 'url'], ProcurementPurchaseOrdersDatatableDataSourceType>,
  'purchaseRequest_requesterEmployee_id': RevealType<['node', 'purchaseRequest', 'requesterEmployee', 'id'], ProcurementPurchaseOrdersDatatableDataSourceType>,
  'purchaseRequest_requesterEmployee_avatar': RevealType<['node', 'purchaseRequest', 'requesterEmployee', 'avatar'], ProcurementPurchaseOrdersDatatableDataSourceType>,
  'purchaseRequest_requesterEmployee_fullName': RevealType<['node', 'purchaseRequest', 'requesterEmployee', 'fullName'], ProcurementPurchaseOrdersDatatableDataSourceType>,
  'purchaseRequest_type_id': RevealType<['node', 'purchaseRequest', 'type', 'id'], ProcurementPurchaseOrdersDatatableDataSourceType>,
  'purchaseRequest_type_name': RevealType<['node', 'purchaseRequest', 'type', 'name'], ProcurementPurchaseOrdersDatatableDataSourceType>,
  'purchaseRequest_id': RevealType<['node', 'purchaseRequest', 'id'], ProcurementPurchaseOrdersDatatableDataSourceType>,
  'purchaseRequest_requesterEmployee': RevealType<['node', 'purchaseRequest', 'requesterEmployee'], ProcurementPurchaseOrdersDatatableDataSourceType>,
  'purchaseRequest_type': RevealType<['node', 'purchaseRequest', 'type'], ProcurementPurchaseOrdersDatatableDataSourceType>,
  'vendor_id': RevealType<['node', 'vendor', 'id'], ProcurementPurchaseOrdersDatatableDataSourceType>,
  'vendor_legalName': RevealType<['node', 'vendor', 'legalName'], ProcurementPurchaseOrdersDatatableDataSourceType>,
  'vendor_name': RevealType<['node', 'vendor', 'name'], ProcurementPurchaseOrdersDatatableDataSourceType>,
  'id': RevealType<['node', 'id'], ProcurementPurchaseOrdersDatatableDataSourceType>,
  'cost': RevealType<['node', 'cost'], ProcurementPurchaseOrdersDatatableDataSourceType>,
  'date': RevealType<['node', 'date'], ProcurementPurchaseOrdersDatatableDataSourceType>,
  'description': RevealType<['node', 'description'], ProcurementPurchaseOrdersDatatableDataSourceType>,
  'formattedPoNumber': RevealType<['node', 'formattedPoNumber'], ProcurementPurchaseOrdersDatatableDataSourceType>,
  'legalEntity': RevealType<['node', 'legalEntity'], ProcurementPurchaseOrdersDatatableDataSourceType>,
  'poNumber': RevealType<['node', 'poNumber'], ProcurementPurchaseOrdersDatatableDataSourceType>,
  'purchaseRequest': RevealType<['node', 'purchaseRequest'], ProcurementPurchaseOrdersDatatableDataSourceType>,
  'status': RevealType<['node', 'status'], ProcurementPurchaseOrdersDatatableDataSourceType>,
  'vendor': RevealType<['node', 'vendor'], ProcurementPurchaseOrdersDatatableDataSourceType>
}

const ProcurementPurchaseOrdersDatatableResolver = {
  dataSource: (data: ProcurementPurchaseOrdersDatatableQuery) => data.procurement.purchaseOrdersConnection,
  edges: (data: ProcurementPurchaseOrdersDatatableQuery) => data.procurement.purchaseOrdersConnection.edges,
  fields: {
    'cost_cents': (edge: ProcurementPurchaseOrdersDatatableDataSourceType) => edge.node.cost?.cents,
    'cost_currency': (edge: ProcurementPurchaseOrdersDatatableDataSourceType) => edge.node.cost?.currency,
    'legalEntity_id': (edge: ProcurementPurchaseOrdersDatatableDataSourceType) => edge.node.legalEntity?.id,
    'legalEntity_legalName': (edge: ProcurementPurchaseOrdersDatatableDataSourceType) => edge.node.legalEntity?.legalName,
    'purchaseRequest_requesterEmployee_avatar_id': (edge: ProcurementPurchaseOrdersDatatableDataSourceType) => edge.node.purchaseRequest?.requesterEmployee?.avatar?.id,
    'purchaseRequest_requesterEmployee_avatar_url': (edge: ProcurementPurchaseOrdersDatatableDataSourceType) => edge.node.purchaseRequest?.requesterEmployee?.avatar?.url,
    'purchaseRequest_requesterEmployee_id': (edge: ProcurementPurchaseOrdersDatatableDataSourceType) => edge.node.purchaseRequest?.requesterEmployee?.id,
    'purchaseRequest_requesterEmployee_avatar': (edge: ProcurementPurchaseOrdersDatatableDataSourceType) => edge.node.purchaseRequest?.requesterEmployee?.avatar,
    'purchaseRequest_requesterEmployee_fullName': (edge: ProcurementPurchaseOrdersDatatableDataSourceType) => edge.node.purchaseRequest?.requesterEmployee?.fullName,
    'purchaseRequest_type_id': (edge: ProcurementPurchaseOrdersDatatableDataSourceType) => edge.node.purchaseRequest?.type?.id,
    'purchaseRequest_type_name': (edge: ProcurementPurchaseOrdersDatatableDataSourceType) => edge.node.purchaseRequest?.type?.name,
    'purchaseRequest_id': (edge: ProcurementPurchaseOrdersDatatableDataSourceType) => edge.node.purchaseRequest?.id,
    'purchaseRequest_requesterEmployee': (edge: ProcurementPurchaseOrdersDatatableDataSourceType) => edge.node.purchaseRequest?.requesterEmployee,
    'purchaseRequest_type': (edge: ProcurementPurchaseOrdersDatatableDataSourceType) => edge.node.purchaseRequest?.type,
    'vendor_id': (edge: ProcurementPurchaseOrdersDatatableDataSourceType) => edge.node.vendor?.id,
    'vendor_legalName': (edge: ProcurementPurchaseOrdersDatatableDataSourceType) => edge.node.vendor?.legalName,
    'vendor_name': (edge: ProcurementPurchaseOrdersDatatableDataSourceType) => edge.node.vendor?.name,
    'id': (edge: ProcurementPurchaseOrdersDatatableDataSourceType) => edge.node.id,
    'cost': (edge: ProcurementPurchaseOrdersDatatableDataSourceType) => edge.node.cost,
    'date': (edge: ProcurementPurchaseOrdersDatatableDataSourceType) => edge.node.date,
    'description': (edge: ProcurementPurchaseOrdersDatatableDataSourceType) => edge.node.description,
    'formattedPoNumber': (edge: ProcurementPurchaseOrdersDatatableDataSourceType) => edge.node.formattedPoNumber,
    'legalEntity': (edge: ProcurementPurchaseOrdersDatatableDataSourceType) => edge.node.legalEntity,
    'poNumber': (edge: ProcurementPurchaseOrdersDatatableDataSourceType) => edge.node.poNumber,
    'purchaseRequest': (edge: ProcurementPurchaseOrdersDatatableDataSourceType) => edge.node.purchaseRequest,
    'status': (edge: ProcurementPurchaseOrdersDatatableDataSourceType) => edge.node.status,
    'vendor': (edge: ProcurementPurchaseOrdersDatatableDataSourceType) => edge.node.vendor,
  }
}

export function buildProcurementPurchaseOrdersDatatableFilter(
  source: DataTableSource<ProcurementPurchaseOrdersDatatableFields, typeof ProcurementPurchaseOrdersDatatableSortableFields[number]>,
  filter: DataTableFilter<ProcurementPurchaseOrderFilter>
) {
  return filter
}

export function useProcurementPurchaseOrdersDatatable(
  projections: DataTableProjection<ProcurementPurchaseOrdersDatatableFields, typeof ProcurementPurchaseOrdersDatatableSortableFields[number]>[],
  options?: {
    variables?: ProcurementPurchaseOrdersDatatableQueryVariables
    defaultSort?: typeof ProcurementPurchaseOrdersDatatableSortableFields[number]
    identifier?: string
  }
): DataTableSource<ProcurementPurchaseOrdersDatatableFields, typeof ProcurementPurchaseOrdersDatatableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'ProcurementPurchaseOrdersDatatable'

  return {
    identifier,
    query: ProcurementPurchaseOrdersDatatableDocument,
    resolver: ProcurementPurchaseOrdersDatatableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? ProcurementPurchaseOrdersDatatableSortableFields.at(0),
      fields: ProcurementPurchaseOrdersDatatableSortableFields,
    },
    variables
  }
}
export const ProcurementMyPurchaseRequestsDatatableDocument = gql`
query ProcurementMyPurchaseRequestsDatatable($companyId: Int!, $requesterEmployeeIds: [Int!]!, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: ProcurementPurchaseRequestFilter) {
  procurement {
    purchaseRequestsConnection(
      companyId: $companyId
      requesterEmployeeIds: $requesterEmployeeIds
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          cost {
            cents
            currency
          }
          date
          deadline
          description
          status
          vendor(companyId: $companyId) {
            id
            legalName
            name
          }
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type ProcurementMyPurchaseRequestsDatatableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<ProcurementMyPurchaseRequestsDatatableQuery['procurement']>['purchaseRequestsConnection']>['edges']
>

const ProcurementMyPurchaseRequestsDatatableSortableFields = ['legalName', 'name', 'id', 'date', 'deadline', 'description', 'status'] as const

interface ProcurementMyPurchaseRequestsDatatableFields {
  'cost_cents': RevealType<['node', 'cost', 'cents'], ProcurementMyPurchaseRequestsDatatableDataSourceType>,
  'cost_currency': RevealType<['node', 'cost', 'currency'], ProcurementMyPurchaseRequestsDatatableDataSourceType>,
  'vendor_id': RevealType<['node', 'vendor', 'id'], ProcurementMyPurchaseRequestsDatatableDataSourceType>,
  'vendor_legalName': RevealType<['node', 'vendor', 'legalName'], ProcurementMyPurchaseRequestsDatatableDataSourceType>,
  'vendor_name': RevealType<['node', 'vendor', 'name'], ProcurementMyPurchaseRequestsDatatableDataSourceType>,
  'id': RevealType<['node', 'id'], ProcurementMyPurchaseRequestsDatatableDataSourceType>,
  'cost': RevealType<['node', 'cost'], ProcurementMyPurchaseRequestsDatatableDataSourceType>,
  'date': RevealType<['node', 'date'], ProcurementMyPurchaseRequestsDatatableDataSourceType>,
  'deadline': RevealType<['node', 'deadline'], ProcurementMyPurchaseRequestsDatatableDataSourceType>,
  'description': RevealType<['node', 'description'], ProcurementMyPurchaseRequestsDatatableDataSourceType>,
  'status': RevealType<['node', 'status'], ProcurementMyPurchaseRequestsDatatableDataSourceType>,
  'vendor': RevealType<['node', 'vendor'], ProcurementMyPurchaseRequestsDatatableDataSourceType>
}

const ProcurementMyPurchaseRequestsDatatableResolver = {
  dataSource: (data: ProcurementMyPurchaseRequestsDatatableQuery) => data.procurement.purchaseRequestsConnection,
  edges: (data: ProcurementMyPurchaseRequestsDatatableQuery) => data.procurement.purchaseRequestsConnection.edges,
  fields: {
    'cost_cents': (edge: ProcurementMyPurchaseRequestsDatatableDataSourceType) => edge.node.cost?.cents,
    'cost_currency': (edge: ProcurementMyPurchaseRequestsDatatableDataSourceType) => edge.node.cost?.currency,
    'vendor_id': (edge: ProcurementMyPurchaseRequestsDatatableDataSourceType) => edge.node.vendor?.id,
    'vendor_legalName': (edge: ProcurementMyPurchaseRequestsDatatableDataSourceType) => edge.node.vendor?.legalName,
    'vendor_name': (edge: ProcurementMyPurchaseRequestsDatatableDataSourceType) => edge.node.vendor?.name,
    'id': (edge: ProcurementMyPurchaseRequestsDatatableDataSourceType) => edge.node.id,
    'cost': (edge: ProcurementMyPurchaseRequestsDatatableDataSourceType) => edge.node.cost,
    'date': (edge: ProcurementMyPurchaseRequestsDatatableDataSourceType) => edge.node.date,
    'deadline': (edge: ProcurementMyPurchaseRequestsDatatableDataSourceType) => edge.node.deadline,
    'description': (edge: ProcurementMyPurchaseRequestsDatatableDataSourceType) => edge.node.description,
    'status': (edge: ProcurementMyPurchaseRequestsDatatableDataSourceType) => edge.node.status,
    'vendor': (edge: ProcurementMyPurchaseRequestsDatatableDataSourceType) => edge.node.vendor,
  }
}

export function buildProcurementMyPurchaseRequestsDatatableFilter(
  source: DataTableSource<ProcurementMyPurchaseRequestsDatatableFields, typeof ProcurementMyPurchaseRequestsDatatableSortableFields[number]>,
  filter: DataTableFilter<ProcurementPurchaseRequestFilter>
) {
  return filter
}

export function useProcurementMyPurchaseRequestsDatatable(
  projections: DataTableProjection<ProcurementMyPurchaseRequestsDatatableFields, typeof ProcurementMyPurchaseRequestsDatatableSortableFields[number]>[],
  options?: {
    variables?: ProcurementMyPurchaseRequestsDatatableQueryVariables
    defaultSort?: typeof ProcurementMyPurchaseRequestsDatatableSortableFields[number]
    identifier?: string
  }
): DataTableSource<ProcurementMyPurchaseRequestsDatatableFields, typeof ProcurementMyPurchaseRequestsDatatableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'ProcurementMyPurchaseRequestsDatatable'

  return {
    identifier,
    query: ProcurementMyPurchaseRequestsDatatableDocument,
    resolver: ProcurementMyPurchaseRequestsDatatableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? ProcurementMyPurchaseRequestsDatatableSortableFields.at(0),
      fields: ProcurementMyPurchaseRequestsDatatableSortableFields,
    },
    variables
  }
}
export const ProcurementPurchaseRequestsDatatableDocument = gql`
query ProcurementPurchaseRequestsDatatable($companyId: Int!, $onlyMyPendingApprovals: Boolean, $search: String, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: ProcurementPurchaseRequestFilter) {
  procurement {
    purchaseRequestsConnection(
      companyId: $companyId
      onlyMyPendingApprovals: $onlyMyPendingApprovals
      search: $search
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          cost {
            cents
            currency
          }
          date
          deadline
          description
          requesterEmployee {
            id
            avatar {
              id
              url
            }
            fullName
          }
          status
          vendor(companyId: $companyId) {
            id
            legalName
            name
          }
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type ProcurementPurchaseRequestsDatatableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<ProcurementPurchaseRequestsDatatableQuery['procurement']>['purchaseRequestsConnection']>['edges']
>

const ProcurementPurchaseRequestsDatatableSortableFields = ['id', 'fullName', 'legalName', 'name', 'id', 'date', 'deadline', 'description', 'status'] as const

interface ProcurementPurchaseRequestsDatatableFields {
  'cost_cents': RevealType<['node', 'cost', 'cents'], ProcurementPurchaseRequestsDatatableDataSourceType>,
  'cost_currency': RevealType<['node', 'cost', 'currency'], ProcurementPurchaseRequestsDatatableDataSourceType>,
  'requesterEmployee_avatar_id': RevealType<['node', 'requesterEmployee', 'avatar', 'id'], ProcurementPurchaseRequestsDatatableDataSourceType>,
  'requesterEmployee_avatar_url': RevealType<['node', 'requesterEmployee', 'avatar', 'url'], ProcurementPurchaseRequestsDatatableDataSourceType>,
  'requesterEmployee_id': RevealType<['node', 'requesterEmployee', 'id'], ProcurementPurchaseRequestsDatatableDataSourceType>,
  'requesterEmployee_avatar': RevealType<['node', 'requesterEmployee', 'avatar'], ProcurementPurchaseRequestsDatatableDataSourceType>,
  'requesterEmployee_fullName': RevealType<['node', 'requesterEmployee', 'fullName'], ProcurementPurchaseRequestsDatatableDataSourceType>,
  'vendor_id': RevealType<['node', 'vendor', 'id'], ProcurementPurchaseRequestsDatatableDataSourceType>,
  'vendor_legalName': RevealType<['node', 'vendor', 'legalName'], ProcurementPurchaseRequestsDatatableDataSourceType>,
  'vendor_name': RevealType<['node', 'vendor', 'name'], ProcurementPurchaseRequestsDatatableDataSourceType>,
  'id': RevealType<['node', 'id'], ProcurementPurchaseRequestsDatatableDataSourceType>,
  'cost': RevealType<['node', 'cost'], ProcurementPurchaseRequestsDatatableDataSourceType>,
  'date': RevealType<['node', 'date'], ProcurementPurchaseRequestsDatatableDataSourceType>,
  'deadline': RevealType<['node', 'deadline'], ProcurementPurchaseRequestsDatatableDataSourceType>,
  'description': RevealType<['node', 'description'], ProcurementPurchaseRequestsDatatableDataSourceType>,
  'requesterEmployee': RevealType<['node', 'requesterEmployee'], ProcurementPurchaseRequestsDatatableDataSourceType>,
  'status': RevealType<['node', 'status'], ProcurementPurchaseRequestsDatatableDataSourceType>,
  'vendor': RevealType<['node', 'vendor'], ProcurementPurchaseRequestsDatatableDataSourceType>
}

const ProcurementPurchaseRequestsDatatableResolver = {
  dataSource: (data: ProcurementPurchaseRequestsDatatableQuery) => data.procurement.purchaseRequestsConnection,
  edges: (data: ProcurementPurchaseRequestsDatatableQuery) => data.procurement.purchaseRequestsConnection.edges,
  fields: {
    'cost_cents': (edge: ProcurementPurchaseRequestsDatatableDataSourceType) => edge.node.cost?.cents,
    'cost_currency': (edge: ProcurementPurchaseRequestsDatatableDataSourceType) => edge.node.cost?.currency,
    'requesterEmployee_avatar_id': (edge: ProcurementPurchaseRequestsDatatableDataSourceType) => edge.node.requesterEmployee?.avatar?.id,
    'requesterEmployee_avatar_url': (edge: ProcurementPurchaseRequestsDatatableDataSourceType) => edge.node.requesterEmployee?.avatar?.url,
    'requesterEmployee_id': (edge: ProcurementPurchaseRequestsDatatableDataSourceType) => edge.node.requesterEmployee?.id,
    'requesterEmployee_avatar': (edge: ProcurementPurchaseRequestsDatatableDataSourceType) => edge.node.requesterEmployee?.avatar,
    'requesterEmployee_fullName': (edge: ProcurementPurchaseRequestsDatatableDataSourceType) => edge.node.requesterEmployee?.fullName,
    'vendor_id': (edge: ProcurementPurchaseRequestsDatatableDataSourceType) => edge.node.vendor?.id,
    'vendor_legalName': (edge: ProcurementPurchaseRequestsDatatableDataSourceType) => edge.node.vendor?.legalName,
    'vendor_name': (edge: ProcurementPurchaseRequestsDatatableDataSourceType) => edge.node.vendor?.name,
    'id': (edge: ProcurementPurchaseRequestsDatatableDataSourceType) => edge.node.id,
    'cost': (edge: ProcurementPurchaseRequestsDatatableDataSourceType) => edge.node.cost,
    'date': (edge: ProcurementPurchaseRequestsDatatableDataSourceType) => edge.node.date,
    'deadline': (edge: ProcurementPurchaseRequestsDatatableDataSourceType) => edge.node.deadline,
    'description': (edge: ProcurementPurchaseRequestsDatatableDataSourceType) => edge.node.description,
    'requesterEmployee': (edge: ProcurementPurchaseRequestsDatatableDataSourceType) => edge.node.requesterEmployee,
    'status': (edge: ProcurementPurchaseRequestsDatatableDataSourceType) => edge.node.status,
    'vendor': (edge: ProcurementPurchaseRequestsDatatableDataSourceType) => edge.node.vendor,
  }
}

export function buildProcurementPurchaseRequestsDatatableFilter(
  source: DataTableSource<ProcurementPurchaseRequestsDatatableFields, typeof ProcurementPurchaseRequestsDatatableSortableFields[number]>,
  filter: DataTableFilter<ProcurementPurchaseRequestFilter>
) {
  return filter
}

export function useProcurementPurchaseRequestsDatatable(
  projections: DataTableProjection<ProcurementPurchaseRequestsDatatableFields, typeof ProcurementPurchaseRequestsDatatableSortableFields[number]>[],
  options?: {
    variables?: ProcurementPurchaseRequestsDatatableQueryVariables
    defaultSort?: typeof ProcurementPurchaseRequestsDatatableSortableFields[number]
    identifier?: string
  }
): DataTableSource<ProcurementPurchaseRequestsDatatableFields, typeof ProcurementPurchaseRequestsDatatableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'ProcurementPurchaseRequestsDatatable'

  return {
    identifier,
    query: ProcurementPurchaseRequestsDatatableDocument,
    resolver: ProcurementPurchaseRequestsDatatableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? ProcurementPurchaseRequestsDatatableSortableFields.at(0),
      fields: ProcurementPurchaseRequestsDatatableSortableFields,
    },
    variables
  }
}
export const ProjectTasksDataTableDocument = gql`
query ProjectTasksDataTable($projectIds: [Int!]!, $search: String, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: ProjectManagementProjectTaskFilter) {
  projectManagement {
    projectTasksConnection(
      projectIds: $projectIds
      search: $search
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          followUp
          subproject {
            id
            name
          }
          task {
            id
            assigneesConnection(first: 2) {
              edges {
                node {
                  id
                  avatar
                  fullName
                }
              }
              totalCount
            }
            completedAt
            dueOn
            identifier
            name
            relatedResourceTitle
            startsOn
            status
            createdAt
          }
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type ProjectTasksDataTableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<ProjectTasksDataTableQuery['projectManagement']>['projectTasksConnection']>['edges']
>

const ProjectTasksDataTableSortableFields = ['name', 'id', 'dueOn', 'identifier', 'name', 'createdAt', 'id'] as const

interface ProjectTasksDataTableFields {
  'subproject_id': RevealType<['node', 'subproject', 'id'], ProjectTasksDataTableDataSourceType>,
  'subproject_name': RevealType<['node', 'subproject', 'name'], ProjectTasksDataTableDataSourceType>,
  'task_assigneesConnection_edges': RevealType<['node', 'task', 'assigneesConnection', 'edges'], ProjectTasksDataTableDataSourceType>,
  'task_assigneesConnection_totalCount': RevealType<['node', 'task', 'assigneesConnection', 'totalCount'], ProjectTasksDataTableDataSourceType>,
  'task_id': RevealType<['node', 'task', 'id'], ProjectTasksDataTableDataSourceType>,
  'task_assigneesConnection': RevealType<['node', 'task', 'assigneesConnection'], ProjectTasksDataTableDataSourceType>,
  'task_completedAt': RevealType<['node', 'task', 'completedAt'], ProjectTasksDataTableDataSourceType>,
  'task_dueOn': RevealType<['node', 'task', 'dueOn'], ProjectTasksDataTableDataSourceType>,
  'task_identifier': RevealType<['node', 'task', 'identifier'], ProjectTasksDataTableDataSourceType>,
  'task_name': RevealType<['node', 'task', 'name'], ProjectTasksDataTableDataSourceType>,
  'task_relatedResourceTitle': RevealType<['node', 'task', 'relatedResourceTitle'], ProjectTasksDataTableDataSourceType>,
  'task_startsOn': RevealType<['node', 'task', 'startsOn'], ProjectTasksDataTableDataSourceType>,
  'task_status': RevealType<['node', 'task', 'status'], ProjectTasksDataTableDataSourceType>,
  'task_createdAt': RevealType<['node', 'task', 'createdAt'], ProjectTasksDataTableDataSourceType>,
  'id': RevealType<['node', 'id'], ProjectTasksDataTableDataSourceType>,
  'followUp': RevealType<['node', 'followUp'], ProjectTasksDataTableDataSourceType>,
  'subproject': RevealType<['node', 'subproject'], ProjectTasksDataTableDataSourceType>,
  'task': RevealType<['node', 'task'], ProjectTasksDataTableDataSourceType>
}

const ProjectTasksDataTableResolver = {
  dataSource: (data: ProjectTasksDataTableQuery) => data.projectManagement.projectTasksConnection,
  edges: (data: ProjectTasksDataTableQuery) => data.projectManagement.projectTasksConnection.edges,
  fields: {
    'subproject_id': (edge: ProjectTasksDataTableDataSourceType) => edge.node.subproject?.id,
    'subproject_name': (edge: ProjectTasksDataTableDataSourceType) => edge.node.subproject?.name,
    'task_assigneesConnection_edges': (edge: ProjectTasksDataTableDataSourceType) => edge.node.task?.assigneesConnection?.edges,
    'task_assigneesConnection_totalCount': (edge: ProjectTasksDataTableDataSourceType) => edge.node.task?.assigneesConnection?.totalCount,
    'task_id': (edge: ProjectTasksDataTableDataSourceType) => edge.node.task?.id,
    'task_assigneesConnection': (edge: ProjectTasksDataTableDataSourceType) => edge.node.task?.assigneesConnection,
    'task_completedAt': (edge: ProjectTasksDataTableDataSourceType) => edge.node.task?.completedAt,
    'task_dueOn': (edge: ProjectTasksDataTableDataSourceType) => edge.node.task?.dueOn,
    'task_identifier': (edge: ProjectTasksDataTableDataSourceType) => edge.node.task?.identifier,
    'task_name': (edge: ProjectTasksDataTableDataSourceType) => edge.node.task?.name,
    'task_relatedResourceTitle': (edge: ProjectTasksDataTableDataSourceType) => edge.node.task?.relatedResourceTitle,
    'task_startsOn': (edge: ProjectTasksDataTableDataSourceType) => edge.node.task?.startsOn,
    'task_status': (edge: ProjectTasksDataTableDataSourceType) => edge.node.task?.status,
    'task_createdAt': (edge: ProjectTasksDataTableDataSourceType) => edge.node.task?.createdAt,
    'id': (edge: ProjectTasksDataTableDataSourceType) => edge.node.id,
    'followUp': (edge: ProjectTasksDataTableDataSourceType) => edge.node.followUp,
    'subproject': (edge: ProjectTasksDataTableDataSourceType) => edge.node.subproject,
    'task': (edge: ProjectTasksDataTableDataSourceType) => edge.node.task,
  }
}

export function buildProjectTasksDataTableFilter(
  source: DataTableSource<ProjectTasksDataTableFields, typeof ProjectTasksDataTableSortableFields[number]>,
  filter: DataTableFilter<ProjectManagementProjectTaskFilter>
) {
  return filter
}

export function useProjectTasksDataTable(
  projections: DataTableProjection<ProjectTasksDataTableFields, typeof ProjectTasksDataTableSortableFields[number]>[],
  options?: {
    variables?: ProjectTasksDataTableQueryVariables
    defaultSort?: typeof ProjectTasksDataTableSortableFields[number]
    identifier?: string
  }
): DataTableSource<ProjectTasksDataTableFields, typeof ProjectTasksDataTableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'ProjectTasksDataTable'

  return {
    identifier,
    query: ProjectTasksDataTableDocument,
    resolver: ProjectTasksDataTableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? ProjectTasksDataTableSortableFields.at(0),
      fields: ProjectTasksDataTableSortableFields,
    },
    variables
  }
}
export const GetExpensesDatatableExportDocument = gql`
query GetExpensesDatatableExport($endDate: ISO8601Date!, $projectIds: [Int!]!, $startDate: ISO8601Date!, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort) {
  projectManagement {
    exportableExpensesConnection(
      endDate: $endDate
      projectIds: $projectIds
      startDate: $startDate
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          amount
          currency
          date
          employeeName
          expenseCategory
          expenseLink
          expenseStatus
          expenseSubcategory
          preferredName
          projectCode
          projectName
          projectOwners
          subprojectName
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type GetExpensesDatatableExportDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<GetExpensesDatatableExportQuery['projectManagement']>['exportableExpensesConnection']>['edges']
>

const GetExpensesDatatableExportSortableFields = [] as const

interface GetExpensesDatatableExportFields {
  'amount': RevealType<['node', 'amount'], GetExpensesDatatableExportDataSourceType>,
  'currency': RevealType<['node', 'currency'], GetExpensesDatatableExportDataSourceType>,
  'date': RevealType<['node', 'date'], GetExpensesDatatableExportDataSourceType>,
  'employeeName': RevealType<['node', 'employeeName'], GetExpensesDatatableExportDataSourceType>,
  'expenseCategory': RevealType<['node', 'expenseCategory'], GetExpensesDatatableExportDataSourceType>,
  'expenseLink': RevealType<['node', 'expenseLink'], GetExpensesDatatableExportDataSourceType>,
  'expenseStatus': RevealType<['node', 'expenseStatus'], GetExpensesDatatableExportDataSourceType>,
  'expenseSubcategory': RevealType<['node', 'expenseSubcategory'], GetExpensesDatatableExportDataSourceType>,
  'preferredName': RevealType<['node', 'preferredName'], GetExpensesDatatableExportDataSourceType>,
  'projectCode': RevealType<['node', 'projectCode'], GetExpensesDatatableExportDataSourceType>,
  'projectName': RevealType<['node', 'projectName'], GetExpensesDatatableExportDataSourceType>,
  'projectOwners': RevealType<['node', 'projectOwners'], GetExpensesDatatableExportDataSourceType>,
  'subprojectName': RevealType<['node', 'subprojectName'], GetExpensesDatatableExportDataSourceType>
}

const GetExpensesDatatableExportResolver = {
  dataSource: (data: GetExpensesDatatableExportQuery) => data.projectManagement.exportableExpensesConnection,
  edges: (data: GetExpensesDatatableExportQuery) => data.projectManagement.exportableExpensesConnection.edges,
  fields: {
    'amount': (edge: GetExpensesDatatableExportDataSourceType) => edge.node.amount,
    'currency': (edge: GetExpensesDatatableExportDataSourceType) => edge.node.currency,
    'date': (edge: GetExpensesDatatableExportDataSourceType) => edge.node.date,
    'employeeName': (edge: GetExpensesDatatableExportDataSourceType) => edge.node.employeeName,
    'expenseCategory': (edge: GetExpensesDatatableExportDataSourceType) => edge.node.expenseCategory,
    'expenseLink': (edge: GetExpensesDatatableExportDataSourceType) => edge.node.expenseLink,
    'expenseStatus': (edge: GetExpensesDatatableExportDataSourceType) => edge.node.expenseStatus,
    'expenseSubcategory': (edge: GetExpensesDatatableExportDataSourceType) => edge.node.expenseSubcategory,
    'preferredName': (edge: GetExpensesDatatableExportDataSourceType) => edge.node.preferredName,
    'projectCode': (edge: GetExpensesDatatableExportDataSourceType) => edge.node.projectCode,
    'projectName': (edge: GetExpensesDatatableExportDataSourceType) => edge.node.projectName,
    'projectOwners': (edge: GetExpensesDatatableExportDataSourceType) => edge.node.projectOwners,
    'subprojectName': (edge: GetExpensesDatatableExportDataSourceType) => edge.node.subprojectName,
  }
}

export function useGetExpensesDatatableExport(
  projections: DataTableProjection<GetExpensesDatatableExportFields, typeof GetExpensesDatatableExportSortableFields[number]>[],
  options?: {
    variables?: GetExpensesDatatableExportQueryVariables
    defaultSort?: typeof GetExpensesDatatableExportSortableFields[number]
    identifier?: string
  }
): DataTableSource<GetExpensesDatatableExportFields, typeof GetExpensesDatatableExportSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'GetExpensesDatatableExport'

  return {
    identifier,
    query: GetExpensesDatatableExportDocument,
    resolver: GetExpensesDatatableExportResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? GetExpensesDatatableExportSortableFields.at(0),
      fields: GetExpensesDatatableExportSortableFields,
    },
    variables
  }
}
export const GetProjectsDatatableExportDocument = gql`
query GetProjectsDatatableExport($companyId: Int!, $dateGroup: ProjectManagementEnumsExportableProjectDateGroupEnum!, $endDate: ISO8601Date!, $includeClient: Boolean = false, $includeDate: Boolean = false, $includeEmployeesWithoutTimeTracked: Boolean = false, $includeSubprojects: Boolean = false, $projectIds: [Int!]!, $startDate: ISO8601Date!, $timeFormat: String, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort) {
  projectManagement {
    exportableProjectsConnection(
      dateGroup: $dateGroup
      endDate: $endDate
      includeDate: $includeDate
      includeEmployeesWithoutTimeTracked: $includeEmployeesWithoutTimeTracked
      projectIds: $projectIds
      startDate: $startDate
      timeFormat: $timeFormat
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          client(companyId: $companyId, contactType: client) @include(if: $includeClient) {
            id
            legalName
            name
          }
          cost
          date @include(if: $includeDate)
          employee {
            id
            companyIdentifier
          }
          employeeName
          inputedTime
          projectCode
          projectDescription
          projectDueDate
          projectName
          projectOwners
          projectStartDate
          projectStatus
          subprojectName @include(if: $includeSubprojects)
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type GetProjectsDatatableExportDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<GetProjectsDatatableExportQuery['projectManagement']>['exportableProjectsConnection']>['edges']
>

const GetProjectsDatatableExportSortableFields = ['legalName', 'name', 'id'] as const

interface GetProjectsDatatableExportFields {
  'client_id': RevealType<['node', 'client', 'id'], GetProjectsDatatableExportDataSourceType>,
  'client_legalName': RevealType<['node', 'client', 'legalName'], GetProjectsDatatableExportDataSourceType>,
  'client_name': RevealType<['node', 'client', 'name'], GetProjectsDatatableExportDataSourceType>,
  'employee_id': RevealType<['node', 'employee', 'id'], GetProjectsDatatableExportDataSourceType>,
  'employee_companyIdentifier': RevealType<['node', 'employee', 'companyIdentifier'], GetProjectsDatatableExportDataSourceType>,
  'id': RevealType<['node', 'id'], GetProjectsDatatableExportDataSourceType>,
  'client': RevealType<['node', 'client'], GetProjectsDatatableExportDataSourceType>,
  'cost': RevealType<['node', 'cost'], GetProjectsDatatableExportDataSourceType>,
  'date': RevealType<['node', 'date'], GetProjectsDatatableExportDataSourceType>,
  'employee': RevealType<['node', 'employee'], GetProjectsDatatableExportDataSourceType>,
  'employeeName': RevealType<['node', 'employeeName'], GetProjectsDatatableExportDataSourceType>,
  'inputedTime': RevealType<['node', 'inputedTime'], GetProjectsDatatableExportDataSourceType>,
  'projectCode': RevealType<['node', 'projectCode'], GetProjectsDatatableExportDataSourceType>,
  'projectDescription': RevealType<['node', 'projectDescription'], GetProjectsDatatableExportDataSourceType>,
  'projectDueDate': RevealType<['node', 'projectDueDate'], GetProjectsDatatableExportDataSourceType>,
  'projectName': RevealType<['node', 'projectName'], GetProjectsDatatableExportDataSourceType>,
  'projectOwners': RevealType<['node', 'projectOwners'], GetProjectsDatatableExportDataSourceType>,
  'projectStartDate': RevealType<['node', 'projectStartDate'], GetProjectsDatatableExportDataSourceType>,
  'projectStatus': RevealType<['node', 'projectStatus'], GetProjectsDatatableExportDataSourceType>,
  'subprojectName': RevealType<['node', 'subprojectName'], GetProjectsDatatableExportDataSourceType>
}

const GetProjectsDatatableExportResolver = {
  dataSource: (data: GetProjectsDatatableExportQuery) => data.projectManagement.exportableProjectsConnection,
  edges: (data: GetProjectsDatatableExportQuery) => data.projectManagement.exportableProjectsConnection.edges,
  fields: {
    'client_id': (edge: GetProjectsDatatableExportDataSourceType) => edge.node.client?.id,
    'client_legalName': (edge: GetProjectsDatatableExportDataSourceType) => edge.node.client?.legalName,
    'client_name': (edge: GetProjectsDatatableExportDataSourceType) => edge.node.client?.name,
    'employee_id': (edge: GetProjectsDatatableExportDataSourceType) => edge.node.employee?.id,
    'employee_companyIdentifier': (edge: GetProjectsDatatableExportDataSourceType) => edge.node.employee?.companyIdentifier,
    'id': (edge: GetProjectsDatatableExportDataSourceType) => edge.node.id,
    'client': (edge: GetProjectsDatatableExportDataSourceType) => edge.node.client,
    'cost': (edge: GetProjectsDatatableExportDataSourceType) => edge.node.cost,
    'date': (edge: GetProjectsDatatableExportDataSourceType) => edge.node.date,
    'employee': (edge: GetProjectsDatatableExportDataSourceType) => edge.node.employee,
    'employeeName': (edge: GetProjectsDatatableExportDataSourceType) => edge.node.employeeName,
    'inputedTime': (edge: GetProjectsDatatableExportDataSourceType) => edge.node.inputedTime,
    'projectCode': (edge: GetProjectsDatatableExportDataSourceType) => edge.node.projectCode,
    'projectDescription': (edge: GetProjectsDatatableExportDataSourceType) => edge.node.projectDescription,
    'projectDueDate': (edge: GetProjectsDatatableExportDataSourceType) => edge.node.projectDueDate,
    'projectName': (edge: GetProjectsDatatableExportDataSourceType) => edge.node.projectName,
    'projectOwners': (edge: GetProjectsDatatableExportDataSourceType) => edge.node.projectOwners,
    'projectStartDate': (edge: GetProjectsDatatableExportDataSourceType) => edge.node.projectStartDate,
    'projectStatus': (edge: GetProjectsDatatableExportDataSourceType) => edge.node.projectStatus,
    'subprojectName': (edge: GetProjectsDatatableExportDataSourceType) => edge.node.subprojectName,
  }
}

export function useGetProjectsDatatableExport(
  projections: DataTableProjection<GetProjectsDatatableExportFields, typeof GetProjectsDatatableExportSortableFields[number]>[],
  options?: {
    variables?: GetProjectsDatatableExportQueryVariables
    defaultSort?: typeof GetProjectsDatatableExportSortableFields[number]
    identifier?: string
  }
): DataTableSource<GetProjectsDatatableExportFields, typeof GetProjectsDatatableExportSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'GetProjectsDatatableExport'

  return {
    identifier,
    query: GetProjectsDatatableExportDocument,
    resolver: GetProjectsDatatableExportResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? GetProjectsDatatableExportSortableFields.at(0),
      fields: GetProjectsDatatableExportSortableFields,
    },
    variables
  }
}
export const GetShiftsDatatableExportDocument = gql`
query GetShiftsDatatableExport($employeeIds: [Int!]!, $endDate: ISO8601Date!, $includeSubprojects: Boolean = false, $sortByEmployee: Boolean = false, $startDate: ISO8601Date!, $timeFormat: String, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort) {
  projectManagement {
    exportableShiftsConnection(
      employeeIds: $employeeIds
      endDate: $endDate
      includeSubprojects: $includeSubprojects
      sortByEmployee: $sortByEmployee
      startDate: $startDate
      timeFormat: $timeFormat
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          clockIn @skip(if: $sortByEmployee)
          clockOut @skip(if: $sortByEmployee)
          comments @skip(if: $sortByEmployee)
          date @skip(if: $sortByEmployee)
          duration
          employee {
            id
            companyIdentifier
          }
          employeeName
          projectCode
          projectName
          projectOwners
          projectStatus @include(if: $sortByEmployee)
          subprojectName @include(if: $includeSubprojects)
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type GetShiftsDatatableExportDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<GetShiftsDatatableExportQuery['projectManagement']>['exportableShiftsConnection']>['edges']
>

const GetShiftsDatatableExportSortableFields = ['id'] as const

interface GetShiftsDatatableExportFields {
  'employee_id': RevealType<['node', 'employee', 'id'], GetShiftsDatatableExportDataSourceType>,
  'employee_companyIdentifier': RevealType<['node', 'employee', 'companyIdentifier'], GetShiftsDatatableExportDataSourceType>,
  'id': RevealType<['node', 'id'], GetShiftsDatatableExportDataSourceType>,
  'clockIn': RevealType<['node', 'clockIn'], GetShiftsDatatableExportDataSourceType>,
  'clockOut': RevealType<['node', 'clockOut'], GetShiftsDatatableExportDataSourceType>,
  'comments': RevealType<['node', 'comments'], GetShiftsDatatableExportDataSourceType>,
  'date': RevealType<['node', 'date'], GetShiftsDatatableExportDataSourceType>,
  'duration': RevealType<['node', 'duration'], GetShiftsDatatableExportDataSourceType>,
  'employee': RevealType<['node', 'employee'], GetShiftsDatatableExportDataSourceType>,
  'employeeName': RevealType<['node', 'employeeName'], GetShiftsDatatableExportDataSourceType>,
  'projectCode': RevealType<['node', 'projectCode'], GetShiftsDatatableExportDataSourceType>,
  'projectName': RevealType<['node', 'projectName'], GetShiftsDatatableExportDataSourceType>,
  'projectOwners': RevealType<['node', 'projectOwners'], GetShiftsDatatableExportDataSourceType>,
  'projectStatus': RevealType<['node', 'projectStatus'], GetShiftsDatatableExportDataSourceType>,
  'subprojectName': RevealType<['node', 'subprojectName'], GetShiftsDatatableExportDataSourceType>
}

const GetShiftsDatatableExportResolver = {
  dataSource: (data: GetShiftsDatatableExportQuery) => data.projectManagement.exportableShiftsConnection,
  edges: (data: GetShiftsDatatableExportQuery) => data.projectManagement.exportableShiftsConnection.edges,
  fields: {
    'employee_id': (edge: GetShiftsDatatableExportDataSourceType) => edge.node.employee?.id,
    'employee_companyIdentifier': (edge: GetShiftsDatatableExportDataSourceType) => edge.node.employee?.companyIdentifier,
    'id': (edge: GetShiftsDatatableExportDataSourceType) => edge.node.id,
    'clockIn': (edge: GetShiftsDatatableExportDataSourceType) => edge.node.clockIn,
    'clockOut': (edge: GetShiftsDatatableExportDataSourceType) => edge.node.clockOut,
    'comments': (edge: GetShiftsDatatableExportDataSourceType) => edge.node.comments,
    'date': (edge: GetShiftsDatatableExportDataSourceType) => edge.node.date,
    'duration': (edge: GetShiftsDatatableExportDataSourceType) => edge.node.duration,
    'employee': (edge: GetShiftsDatatableExportDataSourceType) => edge.node.employee,
    'employeeName': (edge: GetShiftsDatatableExportDataSourceType) => edge.node.employeeName,
    'projectCode': (edge: GetShiftsDatatableExportDataSourceType) => edge.node.projectCode,
    'projectName': (edge: GetShiftsDatatableExportDataSourceType) => edge.node.projectName,
    'projectOwners': (edge: GetShiftsDatatableExportDataSourceType) => edge.node.projectOwners,
    'projectStatus': (edge: GetShiftsDatatableExportDataSourceType) => edge.node.projectStatus,
    'subprojectName': (edge: GetShiftsDatatableExportDataSourceType) => edge.node.subprojectName,
  }
}

export function useGetShiftsDatatableExport(
  projections: DataTableProjection<GetShiftsDatatableExportFields, typeof GetShiftsDatatableExportSortableFields[number]>[],
  options?: {
    variables?: GetShiftsDatatableExportQueryVariables
    defaultSort?: typeof GetShiftsDatatableExportSortableFields[number]
    identifier?: string
  }
): DataTableSource<GetShiftsDatatableExportFields, typeof GetShiftsDatatableExportSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'GetShiftsDatatableExport'

  return {
    identifier,
    query: GetShiftsDatatableExportDocument,
    resolver: GetShiftsDatatableExportResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? GetShiftsDatatableExportSortableFields.at(0),
      fields: GetShiftsDatatableExportSortableFields,
    },
    variables
  }
}
export const GetTasksDatatableExportDocument = gql`
query GetTasksDatatableExport($endDate: ISO8601Date!, $projectIds: [Int!]!, $startDate: ISO8601Date!, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort) {
  projectManagement {
    exportableTasksConnection(
      endDate: $endDate
      projectIds: $projectIds
      startDate: $startDate
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          assignees
          daysBetweenInProgressAndDone
          daysUntilDeadline
          employeesCompanyIdentifiers
          projectCode
          projectDescription
          projectName
          subprojectName
          taskDueOnDate
          taskName
          taskStartsOnDate
          taskStatus
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type GetTasksDatatableExportDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<GetTasksDatatableExportQuery['projectManagement']>['exportableTasksConnection']>['edges']
>

const GetTasksDatatableExportSortableFields = [] as const

interface GetTasksDatatableExportFields {
  'assignees': RevealType<['node', 'assignees'], GetTasksDatatableExportDataSourceType>,
  'daysBetweenInProgressAndDone': RevealType<['node', 'daysBetweenInProgressAndDone'], GetTasksDatatableExportDataSourceType>,
  'daysUntilDeadline': RevealType<['node', 'daysUntilDeadline'], GetTasksDatatableExportDataSourceType>,
  'employeesCompanyIdentifiers': RevealType<['node', 'employeesCompanyIdentifiers'], GetTasksDatatableExportDataSourceType>,
  'projectCode': RevealType<['node', 'projectCode'], GetTasksDatatableExportDataSourceType>,
  'projectDescription': RevealType<['node', 'projectDescription'], GetTasksDatatableExportDataSourceType>,
  'projectName': RevealType<['node', 'projectName'], GetTasksDatatableExportDataSourceType>,
  'subprojectName': RevealType<['node', 'subprojectName'], GetTasksDatatableExportDataSourceType>,
  'taskDueOnDate': RevealType<['node', 'taskDueOnDate'], GetTasksDatatableExportDataSourceType>,
  'taskName': RevealType<['node', 'taskName'], GetTasksDatatableExportDataSourceType>,
  'taskStartsOnDate': RevealType<['node', 'taskStartsOnDate'], GetTasksDatatableExportDataSourceType>,
  'taskStatus': RevealType<['node', 'taskStatus'], GetTasksDatatableExportDataSourceType>
}

const GetTasksDatatableExportResolver = {
  dataSource: (data: GetTasksDatatableExportQuery) => data.projectManagement.exportableTasksConnection,
  edges: (data: GetTasksDatatableExportQuery) => data.projectManagement.exportableTasksConnection.edges,
  fields: {
    'assignees': (edge: GetTasksDatatableExportDataSourceType) => edge.node.assignees,
    'daysBetweenInProgressAndDone': (edge: GetTasksDatatableExportDataSourceType) => edge.node.daysBetweenInProgressAndDone,
    'daysUntilDeadline': (edge: GetTasksDatatableExportDataSourceType) => edge.node.daysUntilDeadline,
    'employeesCompanyIdentifiers': (edge: GetTasksDatatableExportDataSourceType) => edge.node.employeesCompanyIdentifiers,
    'projectCode': (edge: GetTasksDatatableExportDataSourceType) => edge.node.projectCode,
    'projectDescription': (edge: GetTasksDatatableExportDataSourceType) => edge.node.projectDescription,
    'projectName': (edge: GetTasksDatatableExportDataSourceType) => edge.node.projectName,
    'subprojectName': (edge: GetTasksDatatableExportDataSourceType) => edge.node.subprojectName,
    'taskDueOnDate': (edge: GetTasksDatatableExportDataSourceType) => edge.node.taskDueOnDate,
    'taskName': (edge: GetTasksDatatableExportDataSourceType) => edge.node.taskName,
    'taskStartsOnDate': (edge: GetTasksDatatableExportDataSourceType) => edge.node.taskStartsOnDate,
    'taskStatus': (edge: GetTasksDatatableExportDataSourceType) => edge.node.taskStatus,
  }
}

export function useGetTasksDatatableExport(
  projections: DataTableProjection<GetTasksDatatableExportFields, typeof GetTasksDatatableExportSortableFields[number]>[],
  options?: {
    variables?: GetTasksDatatableExportQueryVariables
    defaultSort?: typeof GetTasksDatatableExportSortableFields[number]
    identifier?: string
  }
): DataTableSource<GetTasksDatatableExportFields, typeof GetTasksDatatableExportSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'GetTasksDatatableExport'

  return {
    identifier,
    query: GetTasksDatatableExportDocument,
    resolver: GetTasksDatatableExportResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? GetTasksDatatableExportSortableFields.at(0),
      fields: GetTasksDatatableExportSortableFields,
    },
    variables
  }
}
export const EmployeesMembershipDataTableDocument = gql`
query EmployeesMembershipDataTable($search: String, $softwareSetupIds: [Int!], $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: SoftwareManagementEmployeeSoftwareMembershipFilter) {
  softwareManagement {
    employeeSoftwareMembershipsConnection(
      search: $search
      softwareSetupIds: $softwareSetupIds
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          employee(includeLocations: true) {
            id
            access {
              id
              avatar
              fullName
            }
            email
            fullName
            isTerminating
            locations {
              location {
                id
                name
              }
            }
            memberships {
              id
              team {
                id
                name
              }
            }
            referenceContract {
              id
              jobTitle
              startsOn
            }
          }
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type EmployeesMembershipDataTableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<EmployeesMembershipDataTableQuery['softwareManagement']>['employeeSoftwareMembershipsConnection']>['edges']
>

const EmployeesMembershipDataTableSortableFields = ['id', 'id', 'fullName', 'id'] as const

interface EmployeesMembershipDataTableFields {
  'employee_access_id': RevealType<['node', 'employee', 'access', 'id'], EmployeesMembershipDataTableDataSourceType>,
  'employee_access_avatar': RevealType<['node', 'employee', 'access', 'avatar'], EmployeesMembershipDataTableDataSourceType>,
  'employee_access_fullName': RevealType<['node', 'employee', 'access', 'fullName'], EmployeesMembershipDataTableDataSourceType>,
  'employee_referenceContract_id': RevealType<['node', 'employee', 'referenceContract', 'id'], EmployeesMembershipDataTableDataSourceType>,
  'employee_referenceContract_jobTitle': RevealType<['node', 'employee', 'referenceContract', 'jobTitle'], EmployeesMembershipDataTableDataSourceType>,
  'employee_referenceContract_startsOn': RevealType<['node', 'employee', 'referenceContract', 'startsOn'], EmployeesMembershipDataTableDataSourceType>,
  'employee_id': RevealType<['node', 'employee', 'id'], EmployeesMembershipDataTableDataSourceType>,
  'employee_access': RevealType<['node', 'employee', 'access'], EmployeesMembershipDataTableDataSourceType>,
  'employee_email': RevealType<['node', 'employee', 'email'], EmployeesMembershipDataTableDataSourceType>,
  'employee_fullName': RevealType<['node', 'employee', 'fullName'], EmployeesMembershipDataTableDataSourceType>,
  'employee_isTerminating': RevealType<['node', 'employee', 'isTerminating'], EmployeesMembershipDataTableDataSourceType>,
  'employee_locations': RevealType<['node', 'employee', 'locations'], EmployeesMembershipDataTableDataSourceType>,
  'employee_memberships': RevealType<['node', 'employee', 'memberships'], EmployeesMembershipDataTableDataSourceType>,
  'employee_referenceContract': RevealType<['node', 'employee', 'referenceContract'], EmployeesMembershipDataTableDataSourceType>,
  'id': RevealType<['node', 'id'], EmployeesMembershipDataTableDataSourceType>,
  'employee': RevealType<['node', 'employee'], EmployeesMembershipDataTableDataSourceType>
}

const EmployeesMembershipDataTableResolver = {
  dataSource: (data: EmployeesMembershipDataTableQuery) => data.softwareManagement.employeeSoftwareMembershipsConnection,
  edges: (data: EmployeesMembershipDataTableQuery) => data.softwareManagement.employeeSoftwareMembershipsConnection.edges,
  fields: {
    'employee_access_id': (edge: EmployeesMembershipDataTableDataSourceType) => edge.node.employee?.access?.id,
    'employee_access_avatar': (edge: EmployeesMembershipDataTableDataSourceType) => edge.node.employee?.access?.avatar,
    'employee_access_fullName': (edge: EmployeesMembershipDataTableDataSourceType) => edge.node.employee?.access?.fullName,
    'employee_referenceContract_id': (edge: EmployeesMembershipDataTableDataSourceType) => edge.node.employee?.referenceContract?.id,
    'employee_referenceContract_jobTitle': (edge: EmployeesMembershipDataTableDataSourceType) => edge.node.employee?.referenceContract?.jobTitle,
    'employee_referenceContract_startsOn': (edge: EmployeesMembershipDataTableDataSourceType) => edge.node.employee?.referenceContract?.startsOn,
    'employee_id': (edge: EmployeesMembershipDataTableDataSourceType) => edge.node.employee?.id,
    'employee_access': (edge: EmployeesMembershipDataTableDataSourceType) => edge.node.employee?.access,
    'employee_email': (edge: EmployeesMembershipDataTableDataSourceType) => edge.node.employee?.email,
    'employee_fullName': (edge: EmployeesMembershipDataTableDataSourceType) => edge.node.employee?.fullName,
    'employee_isTerminating': (edge: EmployeesMembershipDataTableDataSourceType) => edge.node.employee?.isTerminating,
    'employee_locations': (edge: EmployeesMembershipDataTableDataSourceType) => edge.node.employee?.locations,
    'employee_memberships': (edge: EmployeesMembershipDataTableDataSourceType) => edge.node.employee?.memberships,
    'employee_referenceContract': (edge: EmployeesMembershipDataTableDataSourceType) => edge.node.employee?.referenceContract,
    'id': (edge: EmployeesMembershipDataTableDataSourceType) => edge.node.id,
    'employee': (edge: EmployeesMembershipDataTableDataSourceType) => edge.node.employee,
  }
}

export function buildEmployeesMembershipDataTableFilter(
  source: DataTableSource<EmployeesMembershipDataTableFields, typeof EmployeesMembershipDataTableSortableFields[number]>,
  filter: DataTableFilter<SoftwareManagementEmployeeSoftwareMembershipFilter>
) {
  return filter
}

export function useEmployeesMembershipDataTable(
  projections: DataTableProjection<EmployeesMembershipDataTableFields, typeof EmployeesMembershipDataTableSortableFields[number]>[],
  options?: {
    variables?: EmployeesMembershipDataTableQueryVariables
    defaultSort?: typeof EmployeesMembershipDataTableSortableFields[number]
    identifier?: string
  }
): DataTableSource<EmployeesMembershipDataTableFields, typeof EmployeesMembershipDataTableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'EmployeesMembershipDataTable'

  return {
    identifier,
    query: EmployeesMembershipDataTableDocument,
    resolver: EmployeesMembershipDataTableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? EmployeesMembershipDataTableSortableFields.at(0),
      fields: EmployeesMembershipDataTableSortableFields,
    },
    variables
  }
}
export const SoftwarePaymentsDataTableDocument = gql`
query SoftwarePaymentsDataTable($companyId: Int!, $softwareSetupId: Int!, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: SoftwareManagementSoftwarePaymentFilter) {
  softwareManagement {
    softwarePaymentsConnection(
      softwareSetupId: $softwareSetupId
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          amountCents
          cardPayment {
            id
            merchantName
            status
          }
          currency
          executedAt
          financialDocument(companyId: $companyId) {
            id
            status
          }
          softwareSetup {
            id
            customSoftware {
              id
              logoUrl
              name
            }
            software {
              id
              logoUrl
              name
            }
          }
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type SoftwarePaymentsDataTableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<SoftwarePaymentsDataTableQuery['softwareManagement']>['softwarePaymentsConnection']>['edges']
>

const SoftwarePaymentsDataTableSortableFields = ['id', 'merchantName', 'status', 'id', 'id', 'executedAt'] as const

interface SoftwarePaymentsDataTableFields {
  'cardPayment_id': RevealType<['node', 'cardPayment', 'id'], SoftwarePaymentsDataTableDataSourceType>,
  'cardPayment_merchantName': RevealType<['node', 'cardPayment', 'merchantName'], SoftwarePaymentsDataTableDataSourceType>,
  'cardPayment_status': RevealType<['node', 'cardPayment', 'status'], SoftwarePaymentsDataTableDataSourceType>,
  'financialDocument_id': RevealType<['node', 'financialDocument', 'id'], SoftwarePaymentsDataTableDataSourceType>,
  'financialDocument_status': RevealType<['node', 'financialDocument', 'status'], SoftwarePaymentsDataTableDataSourceType>,
  'softwareSetup_customSoftware_id': RevealType<['node', 'softwareSetup', 'customSoftware', 'id'], SoftwarePaymentsDataTableDataSourceType>,
  'softwareSetup_customSoftware_logoUrl': RevealType<['node', 'softwareSetup', 'customSoftware', 'logoUrl'], SoftwarePaymentsDataTableDataSourceType>,
  'softwareSetup_customSoftware_name': RevealType<['node', 'softwareSetup', 'customSoftware', 'name'], SoftwarePaymentsDataTableDataSourceType>,
  'softwareSetup_software_id': RevealType<['node', 'softwareSetup', 'software', 'id'], SoftwarePaymentsDataTableDataSourceType>,
  'softwareSetup_software_logoUrl': RevealType<['node', 'softwareSetup', 'software', 'logoUrl'], SoftwarePaymentsDataTableDataSourceType>,
  'softwareSetup_software_name': RevealType<['node', 'softwareSetup', 'software', 'name'], SoftwarePaymentsDataTableDataSourceType>,
  'softwareSetup_id': RevealType<['node', 'softwareSetup', 'id'], SoftwarePaymentsDataTableDataSourceType>,
  'softwareSetup_customSoftware': RevealType<['node', 'softwareSetup', 'customSoftware'], SoftwarePaymentsDataTableDataSourceType>,
  'softwareSetup_software': RevealType<['node', 'softwareSetup', 'software'], SoftwarePaymentsDataTableDataSourceType>,
  'id': RevealType<['node', 'id'], SoftwarePaymentsDataTableDataSourceType>,
  'amountCents': RevealType<['node', 'amountCents'], SoftwarePaymentsDataTableDataSourceType>,
  'cardPayment': RevealType<['node', 'cardPayment'], SoftwarePaymentsDataTableDataSourceType>,
  'currency': RevealType<['node', 'currency'], SoftwarePaymentsDataTableDataSourceType>,
  'executedAt': RevealType<['node', 'executedAt'], SoftwarePaymentsDataTableDataSourceType>,
  'financialDocument': RevealType<['node', 'financialDocument'], SoftwarePaymentsDataTableDataSourceType>,
  'softwareSetup': RevealType<['node', 'softwareSetup'], SoftwarePaymentsDataTableDataSourceType>
}

const SoftwarePaymentsDataTableResolver = {
  dataSource: (data: SoftwarePaymentsDataTableQuery) => data.softwareManagement.softwarePaymentsConnection,
  edges: (data: SoftwarePaymentsDataTableQuery) => data.softwareManagement.softwarePaymentsConnection.edges,
  fields: {
    'cardPayment_id': (edge: SoftwarePaymentsDataTableDataSourceType) => edge.node.cardPayment?.id,
    'cardPayment_merchantName': (edge: SoftwarePaymentsDataTableDataSourceType) => edge.node.cardPayment?.merchantName,
    'cardPayment_status': (edge: SoftwarePaymentsDataTableDataSourceType) => edge.node.cardPayment?.status,
    'financialDocument_id': (edge: SoftwarePaymentsDataTableDataSourceType) => edge.node.financialDocument?.id,
    'financialDocument_status': (edge: SoftwarePaymentsDataTableDataSourceType) => edge.node.financialDocument?.status,
    'softwareSetup_customSoftware_id': (edge: SoftwarePaymentsDataTableDataSourceType) => edge.node.softwareSetup?.customSoftware?.id,
    'softwareSetup_customSoftware_logoUrl': (edge: SoftwarePaymentsDataTableDataSourceType) => edge.node.softwareSetup?.customSoftware?.logoUrl,
    'softwareSetup_customSoftware_name': (edge: SoftwarePaymentsDataTableDataSourceType) => edge.node.softwareSetup?.customSoftware?.name,
    'softwareSetup_software_id': (edge: SoftwarePaymentsDataTableDataSourceType) => edge.node.softwareSetup?.software?.id,
    'softwareSetup_software_logoUrl': (edge: SoftwarePaymentsDataTableDataSourceType) => edge.node.softwareSetup?.software?.logoUrl,
    'softwareSetup_software_name': (edge: SoftwarePaymentsDataTableDataSourceType) => edge.node.softwareSetup?.software?.name,
    'softwareSetup_id': (edge: SoftwarePaymentsDataTableDataSourceType) => edge.node.softwareSetup?.id,
    'softwareSetup_customSoftware': (edge: SoftwarePaymentsDataTableDataSourceType) => edge.node.softwareSetup?.customSoftware,
    'softwareSetup_software': (edge: SoftwarePaymentsDataTableDataSourceType) => edge.node.softwareSetup?.software,
    'id': (edge: SoftwarePaymentsDataTableDataSourceType) => edge.node.id,
    'amountCents': (edge: SoftwarePaymentsDataTableDataSourceType) => edge.node.amountCents,
    'cardPayment': (edge: SoftwarePaymentsDataTableDataSourceType) => edge.node.cardPayment,
    'currency': (edge: SoftwarePaymentsDataTableDataSourceType) => edge.node.currency,
    'executedAt': (edge: SoftwarePaymentsDataTableDataSourceType) => edge.node.executedAt,
    'financialDocument': (edge: SoftwarePaymentsDataTableDataSourceType) => edge.node.financialDocument,
    'softwareSetup': (edge: SoftwarePaymentsDataTableDataSourceType) => edge.node.softwareSetup,
  }
}

export function buildSoftwarePaymentsDataTableFilter(
  source: DataTableSource<SoftwarePaymentsDataTableFields, typeof SoftwarePaymentsDataTableSortableFields[number]>,
  filter: DataTableFilter<SoftwareManagementSoftwarePaymentFilter>
) {
  return filter
}

export function useSoftwarePaymentsDataTable(
  projections: DataTableProjection<SoftwarePaymentsDataTableFields, typeof SoftwarePaymentsDataTableSortableFields[number]>[],
  options?: {
    variables?: SoftwarePaymentsDataTableQueryVariables
    defaultSort?: typeof SoftwarePaymentsDataTableSortableFields[number]
    identifier?: string
  }
): DataTableSource<SoftwarePaymentsDataTableFields, typeof SoftwarePaymentsDataTableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'SoftwarePaymentsDataTable'

  return {
    identifier,
    query: SoftwarePaymentsDataTableDocument,
    resolver: SoftwarePaymentsDataTableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? SoftwarePaymentsDataTableSortableFields.at(0),
      fields: SoftwarePaymentsDataTableSortableFields,
    },
    variables
  }
}
export const EmployeeListForSoftwareDataTableDocument = gql`
query EmployeeListForSoftwareDataTable($onlyTerminated: Boolean, $search: String, $softwareSetupIds: [Int!], $withSoftware: Boolean, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: SoftwareManagementEmployeeFilter) {
  softwareManagement {
    employeesConnection(
      fuzzySearch: $search
      onlyTerminated: $onlyTerminated
      withSoftware: $withSoftware
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          access {
            avatar
            fullName
          }
          employeeSoftwareMemberships(softwareSetupIds: $softwareSetupIds) {
            customSoftware {
              logoUrl
              name
            }
            software {
              logoUrl
              name
            }
          }
          firstName
          isTerminating
          lastName
          locations {
            id
            name
          }
          memberships {
            id
            team {
              name
            }
          }
          preferredName
          referenceContract {
            id
            jobTitle
            startsOn
          }
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type EmployeeListForSoftwareDataTableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<EmployeeListForSoftwareDataTableQuery['softwareManagement']>['employeesConnection']>['edges']
>

const EmployeeListForSoftwareDataTableSortableFields = ['id'] as const

interface EmployeeListForSoftwareDataTableFields {
  'access_avatar': RevealType<['node', 'access', 'avatar'], EmployeeListForSoftwareDataTableDataSourceType>,
  'access_fullName': RevealType<['node', 'access', 'fullName'], EmployeeListForSoftwareDataTableDataSourceType>,
  'referenceContract_id': RevealType<['node', 'referenceContract', 'id'], EmployeeListForSoftwareDataTableDataSourceType>,
  'referenceContract_jobTitle': RevealType<['node', 'referenceContract', 'jobTitle'], EmployeeListForSoftwareDataTableDataSourceType>,
  'referenceContract_startsOn': RevealType<['node', 'referenceContract', 'startsOn'], EmployeeListForSoftwareDataTableDataSourceType>,
  'id': RevealType<['node', 'id'], EmployeeListForSoftwareDataTableDataSourceType>,
  'access': RevealType<['node', 'access'], EmployeeListForSoftwareDataTableDataSourceType>,
  'employeeSoftwareMemberships': RevealType<['node', 'employeeSoftwareMemberships'], EmployeeListForSoftwareDataTableDataSourceType>,
  'firstName': RevealType<['node', 'firstName'], EmployeeListForSoftwareDataTableDataSourceType>,
  'isTerminating': RevealType<['node', 'isTerminating'], EmployeeListForSoftwareDataTableDataSourceType>,
  'lastName': RevealType<['node', 'lastName'], EmployeeListForSoftwareDataTableDataSourceType>,
  'locations': RevealType<['node', 'locations'], EmployeeListForSoftwareDataTableDataSourceType>,
  'memberships': RevealType<['node', 'memberships'], EmployeeListForSoftwareDataTableDataSourceType>,
  'preferredName': RevealType<['node', 'preferredName'], EmployeeListForSoftwareDataTableDataSourceType>,
  'referenceContract': RevealType<['node', 'referenceContract'], EmployeeListForSoftwareDataTableDataSourceType>
}

const EmployeeListForSoftwareDataTableResolver = {
  dataSource: (data: EmployeeListForSoftwareDataTableQuery) => data.softwareManagement.employeesConnection,
  edges: (data: EmployeeListForSoftwareDataTableQuery) => data.softwareManagement.employeesConnection.edges,
  fields: {
    'access_avatar': (edge: EmployeeListForSoftwareDataTableDataSourceType) => edge.node.access?.avatar,
    'access_fullName': (edge: EmployeeListForSoftwareDataTableDataSourceType) => edge.node.access?.fullName,
    'referenceContract_id': (edge: EmployeeListForSoftwareDataTableDataSourceType) => edge.node.referenceContract?.id,
    'referenceContract_jobTitle': (edge: EmployeeListForSoftwareDataTableDataSourceType) => edge.node.referenceContract?.jobTitle,
    'referenceContract_startsOn': (edge: EmployeeListForSoftwareDataTableDataSourceType) => edge.node.referenceContract?.startsOn,
    'id': (edge: EmployeeListForSoftwareDataTableDataSourceType) => edge.node.id,
    'access': (edge: EmployeeListForSoftwareDataTableDataSourceType) => edge.node.access,
    'employeeSoftwareMemberships': (edge: EmployeeListForSoftwareDataTableDataSourceType) => edge.node.employeeSoftwareMemberships,
    'firstName': (edge: EmployeeListForSoftwareDataTableDataSourceType) => edge.node.firstName,
    'isTerminating': (edge: EmployeeListForSoftwareDataTableDataSourceType) => edge.node.isTerminating,
    'lastName': (edge: EmployeeListForSoftwareDataTableDataSourceType) => edge.node.lastName,
    'locations': (edge: EmployeeListForSoftwareDataTableDataSourceType) => edge.node.locations,
    'memberships': (edge: EmployeeListForSoftwareDataTableDataSourceType) => edge.node.memberships,
    'preferredName': (edge: EmployeeListForSoftwareDataTableDataSourceType) => edge.node.preferredName,
    'referenceContract': (edge: EmployeeListForSoftwareDataTableDataSourceType) => edge.node.referenceContract,
  }
}

export function buildEmployeeListForSoftwareDataTableFilter(
  source: DataTableSource<EmployeeListForSoftwareDataTableFields, typeof EmployeeListForSoftwareDataTableSortableFields[number]>,
  filter: DataTableFilter<SoftwareManagementEmployeeFilter>
) {
  return filter
}

export function useEmployeeListForSoftwareDataTable(
  projections: DataTableProjection<EmployeeListForSoftwareDataTableFields, typeof EmployeeListForSoftwareDataTableSortableFields[number]>[],
  options?: {
    variables?: EmployeeListForSoftwareDataTableQueryVariables
    defaultSort?: typeof EmployeeListForSoftwareDataTableSortableFields[number]
    identifier?: string
  }
): DataTableSource<EmployeeListForSoftwareDataTableFields, typeof EmployeeListForSoftwareDataTableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'EmployeeListForSoftwareDataTable'

  return {
    identifier,
    query: EmployeeListForSoftwareDataTableDocument,
    resolver: EmployeeListForSoftwareDataTableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? EmployeeListForSoftwareDataTableSortableFields.at(0),
      fields: EmployeeListForSoftwareDataTableSortableFields,
    },
    variables
  }
}
export const GetBookingsDataTableDocument = gql`
query GetBookingsDataTable($projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: SpaceControlBookingFilter) {
  spaceControl {
    bookingsConnection(
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          access {
            id
            avatar
            employee {
              id
            }
            fullName
          }
          capacity
          date
          endsAt
          startsAt
          status
          workSpace {
            id
            name
            workArea {
              id
              location {
                id
                name
              }
              name
            }
            workSpaceTypeName
            workSpaceTypeValue
          }
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type GetBookingsDataTableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<GetBookingsDataTableQuery['spaceControl']>['bookingsConnection']>['edges']
>

const GetBookingsDataTableSortableFields = ['id', 'id', 'date'] as const

interface GetBookingsDataTableFields {
  'access_employee_id': RevealType<['node', 'access', 'employee', 'id'], GetBookingsDataTableDataSourceType>,
  'access_id': RevealType<['node', 'access', 'id'], GetBookingsDataTableDataSourceType>,
  'access_avatar': RevealType<['node', 'access', 'avatar'], GetBookingsDataTableDataSourceType>,
  'access_employee': RevealType<['node', 'access', 'employee'], GetBookingsDataTableDataSourceType>,
  'access_fullName': RevealType<['node', 'access', 'fullName'], GetBookingsDataTableDataSourceType>,
  'workSpace_workArea_location_id': RevealType<['node', 'workSpace', 'workArea', 'location', 'id'], GetBookingsDataTableDataSourceType>,
  'workSpace_workArea_location_name': RevealType<['node', 'workSpace', 'workArea', 'location', 'name'], GetBookingsDataTableDataSourceType>,
  'workSpace_workArea_id': RevealType<['node', 'workSpace', 'workArea', 'id'], GetBookingsDataTableDataSourceType>,
  'workSpace_workArea_location': RevealType<['node', 'workSpace', 'workArea', 'location'], GetBookingsDataTableDataSourceType>,
  'workSpace_workArea_name': RevealType<['node', 'workSpace', 'workArea', 'name'], GetBookingsDataTableDataSourceType>,
  'workSpace_id': RevealType<['node', 'workSpace', 'id'], GetBookingsDataTableDataSourceType>,
  'workSpace_name': RevealType<['node', 'workSpace', 'name'], GetBookingsDataTableDataSourceType>,
  'workSpace_workArea': RevealType<['node', 'workSpace', 'workArea'], GetBookingsDataTableDataSourceType>,
  'workSpace_workSpaceTypeName': RevealType<['node', 'workSpace', 'workSpaceTypeName'], GetBookingsDataTableDataSourceType>,
  'workSpace_workSpaceTypeValue': RevealType<['node', 'workSpace', 'workSpaceTypeValue'], GetBookingsDataTableDataSourceType>,
  'id': RevealType<['node', 'id'], GetBookingsDataTableDataSourceType>,
  'access': RevealType<['node', 'access'], GetBookingsDataTableDataSourceType>,
  'capacity': RevealType<['node', 'capacity'], GetBookingsDataTableDataSourceType>,
  'date': RevealType<['node', 'date'], GetBookingsDataTableDataSourceType>,
  'endsAt': RevealType<['node', 'endsAt'], GetBookingsDataTableDataSourceType>,
  'startsAt': RevealType<['node', 'startsAt'], GetBookingsDataTableDataSourceType>,
  'status': RevealType<['node', 'status'], GetBookingsDataTableDataSourceType>,
  'workSpace': RevealType<['node', 'workSpace'], GetBookingsDataTableDataSourceType>
}

const GetBookingsDataTableResolver = {
  dataSource: (data: GetBookingsDataTableQuery) => data.spaceControl.bookingsConnection,
  edges: (data: GetBookingsDataTableQuery) => data.spaceControl.bookingsConnection.edges,
  fields: {
    'access_employee_id': (edge: GetBookingsDataTableDataSourceType) => edge.node.access?.employee?.id,
    'access_id': (edge: GetBookingsDataTableDataSourceType) => edge.node.access?.id,
    'access_avatar': (edge: GetBookingsDataTableDataSourceType) => edge.node.access?.avatar,
    'access_employee': (edge: GetBookingsDataTableDataSourceType) => edge.node.access?.employee,
    'access_fullName': (edge: GetBookingsDataTableDataSourceType) => edge.node.access?.fullName,
    'workSpace_workArea_location_id': (edge: GetBookingsDataTableDataSourceType) => edge.node.workSpace?.workArea?.location?.id,
    'workSpace_workArea_location_name': (edge: GetBookingsDataTableDataSourceType) => edge.node.workSpace?.workArea?.location?.name,
    'workSpace_workArea_id': (edge: GetBookingsDataTableDataSourceType) => edge.node.workSpace?.workArea?.id,
    'workSpace_workArea_location': (edge: GetBookingsDataTableDataSourceType) => edge.node.workSpace?.workArea?.location,
    'workSpace_workArea_name': (edge: GetBookingsDataTableDataSourceType) => edge.node.workSpace?.workArea?.name,
    'workSpace_id': (edge: GetBookingsDataTableDataSourceType) => edge.node.workSpace?.id,
    'workSpace_name': (edge: GetBookingsDataTableDataSourceType) => edge.node.workSpace?.name,
    'workSpace_workArea': (edge: GetBookingsDataTableDataSourceType) => edge.node.workSpace?.workArea,
    'workSpace_workSpaceTypeName': (edge: GetBookingsDataTableDataSourceType) => edge.node.workSpace?.workSpaceTypeName,
    'workSpace_workSpaceTypeValue': (edge: GetBookingsDataTableDataSourceType) => edge.node.workSpace?.workSpaceTypeValue,
    'id': (edge: GetBookingsDataTableDataSourceType) => edge.node.id,
    'access': (edge: GetBookingsDataTableDataSourceType) => edge.node.access,
    'capacity': (edge: GetBookingsDataTableDataSourceType) => edge.node.capacity,
    'date': (edge: GetBookingsDataTableDataSourceType) => edge.node.date,
    'endsAt': (edge: GetBookingsDataTableDataSourceType) => edge.node.endsAt,
    'startsAt': (edge: GetBookingsDataTableDataSourceType) => edge.node.startsAt,
    'status': (edge: GetBookingsDataTableDataSourceType) => edge.node.status,
    'workSpace': (edge: GetBookingsDataTableDataSourceType) => edge.node.workSpace,
  }
}

export function buildGetBookingsDataTableFilter(
  source: DataTableSource<GetBookingsDataTableFields, typeof GetBookingsDataTableSortableFields[number]>,
  filter: DataTableFilter<SpaceControlBookingFilter>
) {
  return filter
}

export function useGetBookingsDataTable(
  projections: DataTableProjection<GetBookingsDataTableFields, typeof GetBookingsDataTableSortableFields[number]>[],
  options?: {
    variables?: GetBookingsDataTableQueryVariables
    defaultSort?: typeof GetBookingsDataTableSortableFields[number]
    identifier?: string
  }
): DataTableSource<GetBookingsDataTableFields, typeof GetBookingsDataTableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'GetBookingsDataTable'

  return {
    identifier,
    query: GetBookingsDataTableDocument,
    resolver: GetBookingsDataTableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? GetBookingsDataTableSortableFields.at(0),
      fields: GetBookingsDataTableSortableFields,
    },
    variables
  }
}
export const GetTasksDataTableDocument = gql`
query GetTasksDataTable($assigneeId: Int, $authorId: Int, $identifier: TasksValueObjectsTaskIdentifierEnum, $ids: [Int!], $involveeId: Int, $search: String, $status: TasksTaskStatusEnum, $taskStatus: TasksValueObjectsTaskStatusEnum, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: TasksTaskFilter) {
  tasks {
    tasksConnection(
      assigneeId: $assigneeId
      authorId: $authorId
      identifier: $identifier
      ids: $ids
      involveeId: $involveeId
      search: $search
      status: $status
      taskStatus: $taskStatus
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          _policies {
            copy {
              id
              can
            }
            destroy {
              id
              can
            }
            edit {
              id
              can
            }
            resolve {
              id
              can
            }
          }
          affectees {
            id
            avatar
            fullName
          }
          assigneesConnection(first: 3) {
            edges {
              node {
                id
                avatar
                fullName
              }
            }
            totalCount
          }
          author {
            id
            avatar
            fullName
          }
          completedAt
          dueOn
          identifier
          name
          relatedResourceTitle
          startsOn
          status
          createdAt
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type GetTasksDataTableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<GetTasksDataTableQuery['tasks']>['tasksConnection']>['edges']
>

const GetTasksDataTableSortableFields = ['id', 'avatar', 'fullName', 'id', 'dueOn', 'identifier', 'name', 'createdAt'] as const

interface GetTasksDataTableFields {
  '_policies_copy_id': RevealType<['node', '_policies', 'copy', 'id'], GetTasksDataTableDataSourceType>,
  '_policies_copy_can': RevealType<['node', '_policies', 'copy', 'can'], GetTasksDataTableDataSourceType>,
  '_policies_destroy_id': RevealType<['node', '_policies', 'destroy', 'id'], GetTasksDataTableDataSourceType>,
  '_policies_destroy_can': RevealType<['node', '_policies', 'destroy', 'can'], GetTasksDataTableDataSourceType>,
  '_policies_edit_id': RevealType<['node', '_policies', 'edit', 'id'], GetTasksDataTableDataSourceType>,
  '_policies_edit_can': RevealType<['node', '_policies', 'edit', 'can'], GetTasksDataTableDataSourceType>,
  '_policies_resolve_id': RevealType<['node', '_policies', 'resolve', 'id'], GetTasksDataTableDataSourceType>,
  '_policies_resolve_can': RevealType<['node', '_policies', 'resolve', 'can'], GetTasksDataTableDataSourceType>,
  '_policies_copy': RevealType<['node', '_policies', 'copy'], GetTasksDataTableDataSourceType>,
  '_policies_destroy': RevealType<['node', '_policies', 'destroy'], GetTasksDataTableDataSourceType>,
  '_policies_edit': RevealType<['node', '_policies', 'edit'], GetTasksDataTableDataSourceType>,
  '_policies_resolve': RevealType<['node', '_policies', 'resolve'], GetTasksDataTableDataSourceType>,
  'assigneesConnection_edges': RevealType<['node', 'assigneesConnection', 'edges'], GetTasksDataTableDataSourceType>,
  'assigneesConnection_totalCount': RevealType<['node', 'assigneesConnection', 'totalCount'], GetTasksDataTableDataSourceType>,
  'author_id': RevealType<['node', 'author', 'id'], GetTasksDataTableDataSourceType>,
  'author_avatar': RevealType<['node', 'author', 'avatar'], GetTasksDataTableDataSourceType>,
  'author_fullName': RevealType<['node', 'author', 'fullName'], GetTasksDataTableDataSourceType>,
  'id': RevealType<['node', 'id'], GetTasksDataTableDataSourceType>,
  '_policies': RevealType<['node', '_policies'], GetTasksDataTableDataSourceType>,
  'affectees': RevealType<['node', 'affectees'], GetTasksDataTableDataSourceType>,
  'assigneesConnection': RevealType<['node', 'assigneesConnection'], GetTasksDataTableDataSourceType>,
  'author': RevealType<['node', 'author'], GetTasksDataTableDataSourceType>,
  'completedAt': RevealType<['node', 'completedAt'], GetTasksDataTableDataSourceType>,
  'dueOn': RevealType<['node', 'dueOn'], GetTasksDataTableDataSourceType>,
  'identifier': RevealType<['node', 'identifier'], GetTasksDataTableDataSourceType>,
  'name': RevealType<['node', 'name'], GetTasksDataTableDataSourceType>,
  'relatedResourceTitle': RevealType<['node', 'relatedResourceTitle'], GetTasksDataTableDataSourceType>,
  'startsOn': RevealType<['node', 'startsOn'], GetTasksDataTableDataSourceType>,
  'status': RevealType<['node', 'status'], GetTasksDataTableDataSourceType>,
  'createdAt': RevealType<['node', 'createdAt'], GetTasksDataTableDataSourceType>
}

const GetTasksDataTableResolver = {
  dataSource: (data: GetTasksDataTableQuery) => data.tasks.tasksConnection,
  edges: (data: GetTasksDataTableQuery) => data.tasks.tasksConnection.edges,
  fields: {
    '_policies_copy_id': (edge: GetTasksDataTableDataSourceType) => edge.node._policies?.copy?.id,
    '_policies_copy_can': (edge: GetTasksDataTableDataSourceType) => edge.node._policies?.copy?.can,
    '_policies_destroy_id': (edge: GetTasksDataTableDataSourceType) => edge.node._policies?.destroy?.id,
    '_policies_destroy_can': (edge: GetTasksDataTableDataSourceType) => edge.node._policies?.destroy?.can,
    '_policies_edit_id': (edge: GetTasksDataTableDataSourceType) => edge.node._policies?.edit?.id,
    '_policies_edit_can': (edge: GetTasksDataTableDataSourceType) => edge.node._policies?.edit?.can,
    '_policies_resolve_id': (edge: GetTasksDataTableDataSourceType) => edge.node._policies?.resolve?.id,
    '_policies_resolve_can': (edge: GetTasksDataTableDataSourceType) => edge.node._policies?.resolve?.can,
    '_policies_copy': (edge: GetTasksDataTableDataSourceType) => edge.node._policies?.copy,
    '_policies_destroy': (edge: GetTasksDataTableDataSourceType) => edge.node._policies?.destroy,
    '_policies_edit': (edge: GetTasksDataTableDataSourceType) => edge.node._policies?.edit,
    '_policies_resolve': (edge: GetTasksDataTableDataSourceType) => edge.node._policies?.resolve,
    'assigneesConnection_edges': (edge: GetTasksDataTableDataSourceType) => edge.node.assigneesConnection?.edges,
    'assigneesConnection_totalCount': (edge: GetTasksDataTableDataSourceType) => edge.node.assigneesConnection?.totalCount,
    'author_id': (edge: GetTasksDataTableDataSourceType) => edge.node.author?.id,
    'author_avatar': (edge: GetTasksDataTableDataSourceType) => edge.node.author?.avatar,
    'author_fullName': (edge: GetTasksDataTableDataSourceType) => edge.node.author?.fullName,
    'id': (edge: GetTasksDataTableDataSourceType) => edge.node.id,
    '_policies': (edge: GetTasksDataTableDataSourceType) => edge.node._policies,
    'affectees': (edge: GetTasksDataTableDataSourceType) => edge.node.affectees,
    'assigneesConnection': (edge: GetTasksDataTableDataSourceType) => edge.node.assigneesConnection,
    'author': (edge: GetTasksDataTableDataSourceType) => edge.node.author,
    'completedAt': (edge: GetTasksDataTableDataSourceType) => edge.node.completedAt,
    'dueOn': (edge: GetTasksDataTableDataSourceType) => edge.node.dueOn,
    'identifier': (edge: GetTasksDataTableDataSourceType) => edge.node.identifier,
    'name': (edge: GetTasksDataTableDataSourceType) => edge.node.name,
    'relatedResourceTitle': (edge: GetTasksDataTableDataSourceType) => edge.node.relatedResourceTitle,
    'startsOn': (edge: GetTasksDataTableDataSourceType) => edge.node.startsOn,
    'status': (edge: GetTasksDataTableDataSourceType) => edge.node.status,
    'createdAt': (edge: GetTasksDataTableDataSourceType) => edge.node.createdAt,
  }
}

export function buildGetTasksDataTableFilter(
  source: DataTableSource<GetTasksDataTableFields, typeof GetTasksDataTableSortableFields[number]>,
  filter: DataTableFilter<TasksTaskFilter>
) {
  return filter
}

export function useGetTasksDataTable(
  projections: DataTableProjection<GetTasksDataTableFields, typeof GetTasksDataTableSortableFields[number]>[],
  options?: {
    variables?: GetTasksDataTableQueryVariables
    defaultSort?: typeof GetTasksDataTableSortableFields[number]
    identifier?: string
  }
): DataTableSource<GetTasksDataTableFields, typeof GetTasksDataTableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'GetTasksDataTable'

  return {
    identifier,
    query: GetTasksDataTableDocument,
    resolver: GetTasksDataTableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? GetTasksDataTableSortableFields.at(0),
      fields: GetTasksDataTableSortableFields,
    },
    variables
  }
}
export const TrainingsCategoriesDataTableDocument = gql`
query TrainingsCategoriesDataTable($projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: TrainingsCategoryFilter) {
  trainings {
    categoriesConnection(
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          name
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type TrainingsCategoriesDataTableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<TrainingsCategoriesDataTableQuery['trainings']>['categoriesConnection']>['edges']
>

const TrainingsCategoriesDataTableSortableFields = ['name'] as const

interface TrainingsCategoriesDataTableFields {
  'id': RevealType<['node', 'id'], TrainingsCategoriesDataTableDataSourceType>,
  'name': RevealType<['node', 'name'], TrainingsCategoriesDataTableDataSourceType>
}

const TrainingsCategoriesDataTableResolver = {
  dataSource: (data: TrainingsCategoriesDataTableQuery) => data.trainings.categoriesConnection,
  edges: (data: TrainingsCategoriesDataTableQuery) => data.trainings.categoriesConnection.edges,
  fields: {
    'id': (edge: TrainingsCategoriesDataTableDataSourceType) => edge.node.id,
    'name': (edge: TrainingsCategoriesDataTableDataSourceType) => edge.node.name,
  }
}

export function buildTrainingsCategoriesDataTableFilter(
  source: DataTableSource<TrainingsCategoriesDataTableFields, typeof TrainingsCategoriesDataTableSortableFields[number]>,
  filter: DataTableFilter<TrainingsCategoryFilter>
) {
  return filter
}

export function useTrainingsCategoriesDataTable(
  projections: DataTableProjection<TrainingsCategoriesDataTableFields, typeof TrainingsCategoriesDataTableSortableFields[number]>[],
  options?: {
    variables?: TrainingsCategoriesDataTableQueryVariables
    defaultSort?: typeof TrainingsCategoriesDataTableSortableFields[number]
    identifier?: string
  }
): DataTableSource<TrainingsCategoriesDataTableFields, typeof TrainingsCategoriesDataTableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'TrainingsCategoriesDataTable'

  return {
    identifier,
    query: TrainingsCategoriesDataTableDocument,
    resolver: TrainingsCategoriesDataTableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? TrainingsCategoriesDataTableSortableFields.at(0),
      fields: TrainingsCategoriesDataTableSortableFields,
    },
    variables
  }
}
export const MyTrainingsDatatableDocument = gql`
query MyTrainingsDatatable($accessId: Int!, $next: Boolean, $onlyAssigned: Boolean, $search: String, $status: String, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: TrainingsTrainingFilter) {
  trainings {
    trainingsConnection(
      accessId: $accessId
      onlyAssigned: $onlyAssigned
      search: $search
      status: $status
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          name
          sessions(accessId: $accessId, next: $next) {
            id
            dueDate
            duration
            endsAt
            link
            location
            modality
            name
            schedule
            sessionAttendances(accessIds: [$accessId]) {
              id
              accessId
              status
            }
            startsAt
          }
          trainingAttendanceStatus
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type MyTrainingsDatatableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<MyTrainingsDatatableQuery['trainings']>['trainingsConnection']>['edges']
>

const MyTrainingsDatatableSortableFields = ['name', 'trainingAttendanceStatus'] as const

interface MyTrainingsDatatableFields {
  'id': RevealType<['node', 'id'], MyTrainingsDatatableDataSourceType>,
  'name': RevealType<['node', 'name'], MyTrainingsDatatableDataSourceType>,
  'sessions': RevealType<['node', 'sessions'], MyTrainingsDatatableDataSourceType>,
  'trainingAttendanceStatus': RevealType<['node', 'trainingAttendanceStatus'], MyTrainingsDatatableDataSourceType>
}

const MyTrainingsDatatableResolver = {
  dataSource: (data: MyTrainingsDatatableQuery) => data.trainings.trainingsConnection,
  edges: (data: MyTrainingsDatatableQuery) => data.trainings.trainingsConnection.edges,
  fields: {
    'id': (edge: MyTrainingsDatatableDataSourceType) => edge.node.id,
    'name': (edge: MyTrainingsDatatableDataSourceType) => edge.node.name,
    'sessions': (edge: MyTrainingsDatatableDataSourceType) => edge.node.sessions,
    'trainingAttendanceStatus': (edge: MyTrainingsDatatableDataSourceType) => edge.node.trainingAttendanceStatus,
  }
}

export function buildMyTrainingsDatatableFilter(
  source: DataTableSource<MyTrainingsDatatableFields, typeof MyTrainingsDatatableSortableFields[number]>,
  filter: DataTableFilter<TrainingsTrainingFilter>
) {
  return filter
}

export function useMyTrainingsDatatable(
  projections: DataTableProjection<MyTrainingsDatatableFields, typeof MyTrainingsDatatableSortableFields[number]>[],
  options?: {
    variables?: MyTrainingsDatatableQueryVariables
    defaultSort?: typeof MyTrainingsDatatableSortableFields[number]
    identifier?: string
  }
): DataTableSource<MyTrainingsDatatableFields, typeof MyTrainingsDatatableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'MyTrainingsDatatable'

  return {
    identifier,
    query: MyTrainingsDatatableDocument,
    resolver: MyTrainingsDatatableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? MyTrainingsDatatableSortableFields.at(0),
      fields: MyTrainingsDatatableSortableFields,
    },
    variables
  }
}
export const MyTrainingRequestsDatatableDocument = gql`
query MyTrainingRequestsDatatable($authorId: Int, $companyId: Int!, $employeeIds: [Int!], $employeesOrAuthor: Boolean, $search: String, $status: TrainingsTrainingRequestStatusEnum, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: TrainingsTrainingRequestFilter) {
  trainings {
    _policies {
      trainingsRequestsCreate {
        can
      }
    }
    settingsConnection(companyId: $companyId) {
      nodes {
        id
        trainingRequestsEnabled
      }
    }
    trainingRequestsConnection(
      allowdrafts: true
      authorId: $authorId
      employeeIds: $employeeIds
      employeesOrAuthor: $employeesOrAuthor
      search: $search
      status: $status
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          author {
            id
            avatar
            fullName
          }
          competencies {
            id
            name
          }
          currentApproverIds
          employeeIds
          status
          trainingName
          createdAt
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
    trainingsConnection(catalog: true) {
      edges {
        node {
          id
        }
      }
    }
  }
}
`

type MyTrainingRequestsDatatableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<MyTrainingRequestsDatatableQuery['trainings']>['trainingRequestsConnection']>['edges']
>

const MyTrainingRequestsDatatableSortableFields = ['id', 'status', 'createdAt'] as const

interface MyTrainingRequestsDatatableFields {
  'author_id': RevealType<['node', 'author', 'id'], MyTrainingRequestsDatatableDataSourceType>,
  'author_avatar': RevealType<['node', 'author', 'avatar'], MyTrainingRequestsDatatableDataSourceType>,
  'author_fullName': RevealType<['node', 'author', 'fullName'], MyTrainingRequestsDatatableDataSourceType>,
  'id': RevealType<['node', 'id'], MyTrainingRequestsDatatableDataSourceType>,
  'author': RevealType<['node', 'author'], MyTrainingRequestsDatatableDataSourceType>,
  'competencies': RevealType<['node', 'competencies'], MyTrainingRequestsDatatableDataSourceType>,
  'currentApproverIds': RevealType<['node', 'currentApproverIds'], MyTrainingRequestsDatatableDataSourceType>,
  'employeeIds': RevealType<['node', 'employeeIds'], MyTrainingRequestsDatatableDataSourceType>,
  'status': RevealType<['node', 'status'], MyTrainingRequestsDatatableDataSourceType>,
  'trainingName': RevealType<['node', 'trainingName'], MyTrainingRequestsDatatableDataSourceType>,
  'createdAt': RevealType<['node', 'createdAt'], MyTrainingRequestsDatatableDataSourceType>
}

const MyTrainingRequestsDatatableResolver = {
  dataSource: (data: MyTrainingRequestsDatatableQuery) => data.trainings.trainingRequestsConnection,
  edges: (data: MyTrainingRequestsDatatableQuery) => data.trainings.trainingRequestsConnection.edges,
  fields: {
    'author_id': (edge: MyTrainingRequestsDatatableDataSourceType) => edge.node.author?.id,
    'author_avatar': (edge: MyTrainingRequestsDatatableDataSourceType) => edge.node.author?.avatar,
    'author_fullName': (edge: MyTrainingRequestsDatatableDataSourceType) => edge.node.author?.fullName,
    'id': (edge: MyTrainingRequestsDatatableDataSourceType) => edge.node.id,
    'author': (edge: MyTrainingRequestsDatatableDataSourceType) => edge.node.author,
    'competencies': (edge: MyTrainingRequestsDatatableDataSourceType) => edge.node.competencies,
    'currentApproverIds': (edge: MyTrainingRequestsDatatableDataSourceType) => edge.node.currentApproverIds,
    'employeeIds': (edge: MyTrainingRequestsDatatableDataSourceType) => edge.node.employeeIds,
    'status': (edge: MyTrainingRequestsDatatableDataSourceType) => edge.node.status,
    'trainingName': (edge: MyTrainingRequestsDatatableDataSourceType) => edge.node.trainingName,
    'createdAt': (edge: MyTrainingRequestsDatatableDataSourceType) => edge.node.createdAt,
  }
}

export function buildMyTrainingRequestsDatatableFilter(
  source: DataTableSource<MyTrainingRequestsDatatableFields, typeof MyTrainingRequestsDatatableSortableFields[number]>,
  filter: DataTableFilter<TrainingsTrainingRequestFilter>
) {
  return filter
}

export function useMyTrainingRequestsDatatable(
  projections: DataTableProjection<MyTrainingRequestsDatatableFields, typeof MyTrainingRequestsDatatableSortableFields[number]>[],
  options?: {
    variables?: MyTrainingRequestsDatatableQueryVariables
    defaultSort?: typeof MyTrainingRequestsDatatableSortableFields[number]
    identifier?: string
  }
): DataTableSource<MyTrainingRequestsDatatableFields, typeof MyTrainingRequestsDatatableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'MyTrainingRequestsDatatable'

  return {
    identifier,
    query: MyTrainingRequestsDatatableDocument,
    resolver: MyTrainingRequestsDatatableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? MyTrainingRequestsDatatableSortableFields.at(0),
      fields: MyTrainingRequestsDatatableSortableFields,
    },
    variables
  }
}
export const TrainingRequestsDatatableDocument = gql`
query TrainingRequestsDatatable($authorId: Int, $employeeIds: [Int!], $employeesOrAuthor: Boolean, $search: String, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: TrainingsTrainingRequestFilter) {
  trainings {
    trainingRequestsConnection(
      authorId: $authorId
      employeeIds: $employeeIds
      employeesOrAuthor: $employeesOrAuthor
      search: $search
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          author {
            id
            avatar
            fullName
          }
          competencies {
            id
            name
          }
          cost
          currentApproverIds
          employeeIds
          participants {
            id
            accessId
            avatar {
              url
            }
            fullName
          }
          status
          trainingName
          createdAt
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type TrainingRequestsDatatableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<TrainingRequestsDatatableQuery['trainings']>['trainingRequestsConnection']>['edges']
>

const TrainingRequestsDatatableSortableFields = ['id', 'status', 'createdAt'] as const

interface TrainingRequestsDatatableFields {
  'author_id': RevealType<['node', 'author', 'id'], TrainingRequestsDatatableDataSourceType>,
  'author_avatar': RevealType<['node', 'author', 'avatar'], TrainingRequestsDatatableDataSourceType>,
  'author_fullName': RevealType<['node', 'author', 'fullName'], TrainingRequestsDatatableDataSourceType>,
  'id': RevealType<['node', 'id'], TrainingRequestsDatatableDataSourceType>,
  'author': RevealType<['node', 'author'], TrainingRequestsDatatableDataSourceType>,
  'competencies': RevealType<['node', 'competencies'], TrainingRequestsDatatableDataSourceType>,
  'cost': RevealType<['node', 'cost'], TrainingRequestsDatatableDataSourceType>,
  'currentApproverIds': RevealType<['node', 'currentApproverIds'], TrainingRequestsDatatableDataSourceType>,
  'employeeIds': RevealType<['node', 'employeeIds'], TrainingRequestsDatatableDataSourceType>,
  'participants': RevealType<['node', 'participants'], TrainingRequestsDatatableDataSourceType>,
  'status': RevealType<['node', 'status'], TrainingRequestsDatatableDataSourceType>,
  'trainingName': RevealType<['node', 'trainingName'], TrainingRequestsDatatableDataSourceType>,
  'createdAt': RevealType<['node', 'createdAt'], TrainingRequestsDatatableDataSourceType>
}

const TrainingRequestsDatatableResolver = {
  dataSource: (data: TrainingRequestsDatatableQuery) => data.trainings.trainingRequestsConnection,
  edges: (data: TrainingRequestsDatatableQuery) => data.trainings.trainingRequestsConnection.edges,
  fields: {
    'author_id': (edge: TrainingRequestsDatatableDataSourceType) => edge.node.author?.id,
    'author_avatar': (edge: TrainingRequestsDatatableDataSourceType) => edge.node.author?.avatar,
    'author_fullName': (edge: TrainingRequestsDatatableDataSourceType) => edge.node.author?.fullName,
    'id': (edge: TrainingRequestsDatatableDataSourceType) => edge.node.id,
    'author': (edge: TrainingRequestsDatatableDataSourceType) => edge.node.author,
    'competencies': (edge: TrainingRequestsDatatableDataSourceType) => edge.node.competencies,
    'cost': (edge: TrainingRequestsDatatableDataSourceType) => edge.node.cost,
    'currentApproverIds': (edge: TrainingRequestsDatatableDataSourceType) => edge.node.currentApproverIds,
    'employeeIds': (edge: TrainingRequestsDatatableDataSourceType) => edge.node.employeeIds,
    'participants': (edge: TrainingRequestsDatatableDataSourceType) => edge.node.participants,
    'status': (edge: TrainingRequestsDatatableDataSourceType) => edge.node.status,
    'trainingName': (edge: TrainingRequestsDatatableDataSourceType) => edge.node.trainingName,
    'createdAt': (edge: TrainingRequestsDatatableDataSourceType) => edge.node.createdAt,
  }
}

export function buildTrainingRequestsDatatableFilter(
  source: DataTableSource<TrainingRequestsDatatableFields, typeof TrainingRequestsDatatableSortableFields[number]>,
  filter: DataTableFilter<TrainingsTrainingRequestFilter>
) {
  return filter
}

export function useTrainingRequestsDatatable(
  projections: DataTableProjection<TrainingRequestsDatatableFields, typeof TrainingRequestsDatatableSortableFields[number]>[],
  options?: {
    variables?: TrainingRequestsDatatableQueryVariables
    defaultSort?: typeof TrainingRequestsDatatableSortableFields[number]
    identifier?: string
  }
): DataTableSource<TrainingRequestsDatatableFields, typeof TrainingRequestsDatatableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'TrainingRequestsDatatable'

  return {
    identifier,
    query: TrainingRequestsDatatableDocument,
    resolver: TrainingRequestsDatatableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? TrainingRequestsDatatableSortableFields.at(0),
      fields: TrainingRequestsDatatableSortableFields,
    },
    variables
  }
}
export const TrainingFormsDatatableDocument = gql`
query TrainingFormsDatatable($resourceId: String, $search: String, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: FormsFormFilter) {
  forms {
    formsConnection(
      formType: ["satisfaction", "effectiveness", "knowledge"]
      resourceId: $resourceId
      resourceType: "Trainings::Training"
      search: $search
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          anonymous
          authorId
          description
          formType
          resourceId
          status
          title
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type TrainingFormsDatatableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<TrainingFormsDatatableQuery['forms']>['formsConnection']>['edges']
>

const TrainingFormsDatatableSortableFields = ['id', 'formType', 'status'] as const

interface TrainingFormsDatatableFields {
  'id': RevealType<['node', 'id'], TrainingFormsDatatableDataSourceType>,
  'anonymous': RevealType<['node', 'anonymous'], TrainingFormsDatatableDataSourceType>,
  'authorId': RevealType<['node', 'authorId'], TrainingFormsDatatableDataSourceType>,
  'description': RevealType<['node', 'description'], TrainingFormsDatatableDataSourceType>,
  'formType': RevealType<['node', 'formType'], TrainingFormsDatatableDataSourceType>,
  'resourceId': RevealType<['node', 'resourceId'], TrainingFormsDatatableDataSourceType>,
  'status': RevealType<['node', 'status'], TrainingFormsDatatableDataSourceType>,
  'title': RevealType<['node', 'title'], TrainingFormsDatatableDataSourceType>
}

const TrainingFormsDatatableResolver = {
  dataSource: (data: TrainingFormsDatatableQuery) => data.forms.formsConnection,
  edges: (data: TrainingFormsDatatableQuery) => data.forms.formsConnection.edges,
  fields: {
    'id': (edge: TrainingFormsDatatableDataSourceType) => edge.node.id,
    'anonymous': (edge: TrainingFormsDatatableDataSourceType) => edge.node.anonymous,
    'authorId': (edge: TrainingFormsDatatableDataSourceType) => edge.node.authorId,
    'description': (edge: TrainingFormsDatatableDataSourceType) => edge.node.description,
    'formType': (edge: TrainingFormsDatatableDataSourceType) => edge.node.formType,
    'resourceId': (edge: TrainingFormsDatatableDataSourceType) => edge.node.resourceId,
    'status': (edge: TrainingFormsDatatableDataSourceType) => edge.node.status,
    'title': (edge: TrainingFormsDatatableDataSourceType) => edge.node.title,
  }
}

export function buildTrainingFormsDatatableFilter(
  source: DataTableSource<TrainingFormsDatatableFields, typeof TrainingFormsDatatableSortableFields[number]>,
  filter: DataTableFilter<FormsFormFilter>
) {
  return filter
}

export function useTrainingFormsDatatable(
  projections: DataTableProjection<TrainingFormsDatatableFields, typeof TrainingFormsDatatableSortableFields[number]>[],
  options?: {
    variables?: TrainingFormsDatatableQueryVariables
    defaultSort?: typeof TrainingFormsDatatableSortableFields[number]
    identifier?: string
  }
): DataTableSource<TrainingFormsDatatableFields, typeof TrainingFormsDatatableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'TrainingFormsDatatable'

  return {
    identifier,
    query: TrainingFormsDatatableDocument,
    resolver: TrainingFormsDatatableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? TrainingFormsDatatableSortableFields.at(0),
      fields: TrainingFormsDatatableSortableFields,
    },
    variables
  }
}
export const FundaeFinishGroupDatatableDocument = gql`
query FundaeFinishGroupDatatable($search: String, $trainingClassId: Int!, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: TrainingsFundaeFinishGroupFilter) {
  contracts {
    spanishEducationLevelsConnection {
      nodes {
        id
        name
      }
    }
    spanishProfessionalCategoriesConnection {
      nodes {
        id
        name
      }
    }
  }
  trainings {
    categoryMapConfigsConnection {
      nodes {
        category
        categoryMapConfigItemsConnection {
          nodes {
            field {
              fieldId
            }
            value
          }
        }
      }
    }
    fundaeFinishGroupsConnection(
      search: $search
      trainingClassId: $trainingClassId
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          access {
            id
            avatar
            employee {
              id
              _policies {
                editPersonalInfo {
                  can
                }
                readPersonalInfo {
                  can
                }
              }
              email
              identifier
              identifierType
              phoneNumber
              referenceContract(withTranslations: true) {
                id
                _policies {
                  edit {
                    can
                  }
                  seeExtraInfo {
                    can
                  }
                }
                esEducationLevelId
                esEducationLevelName
                esProfessionalCategoryId
                esProfessionalCategoryName
              }
            }
            fullName
          }
          certificate
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type FundaeFinishGroupDatatableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<FundaeFinishGroupDatatableQuery['trainings']>['fundaeFinishGroupsConnection']>['edges']
>

const FundaeFinishGroupDatatableSortableFields = ['id', 'id', 'id'] as const

interface FundaeFinishGroupDatatableFields {
  'nodes': RevealType<['node', 'nodes'], FundaeFinishGroupDatatableDataSourceType>,
  'access_employee__policies_editPersonalInfo_can': RevealType<['node', 'access', 'employee', '_policies', 'editPersonalInfo', 'can'], FundaeFinishGroupDatatableDataSourceType>,
  'access_employee__policies_readPersonalInfo_can': RevealType<['node', 'access', 'employee', '_policies', 'readPersonalInfo', 'can'], FundaeFinishGroupDatatableDataSourceType>,
  'access_employee__policies_editPersonalInfo': RevealType<['node', 'access', 'employee', '_policies', 'editPersonalInfo'], FundaeFinishGroupDatatableDataSourceType>,
  'access_employee__policies_readPersonalInfo': RevealType<['node', 'access', 'employee', '_policies', 'readPersonalInfo'], FundaeFinishGroupDatatableDataSourceType>,
  'access_employee_referenceContract__policies_edit_can': RevealType<['node', 'access', 'employee', 'referenceContract', '_policies', 'edit', 'can'], FundaeFinishGroupDatatableDataSourceType>,
  'access_employee_referenceContract__policies_seeExtraInfo_can': RevealType<['node', 'access', 'employee', 'referenceContract', '_policies', 'seeExtraInfo', 'can'], FundaeFinishGroupDatatableDataSourceType>,
  'access_employee_referenceContract__policies_edit': RevealType<['node', 'access', 'employee', 'referenceContract', '_policies', 'edit'], FundaeFinishGroupDatatableDataSourceType>,
  'access_employee_referenceContract__policies_seeExtraInfo': RevealType<['node', 'access', 'employee', 'referenceContract', '_policies', 'seeExtraInfo'], FundaeFinishGroupDatatableDataSourceType>,
  'access_employee_referenceContract_id': RevealType<['node', 'access', 'employee', 'referenceContract', 'id'], FundaeFinishGroupDatatableDataSourceType>,
  'access_employee_referenceContract__policies': RevealType<['node', 'access', 'employee', 'referenceContract', '_policies'], FundaeFinishGroupDatatableDataSourceType>,
  'access_employee_referenceContract_esEducationLevelId': RevealType<['node', 'access', 'employee', 'referenceContract', 'esEducationLevelId'], FundaeFinishGroupDatatableDataSourceType>,
  'access_employee_referenceContract_esEducationLevelName': RevealType<['node', 'access', 'employee', 'referenceContract', 'esEducationLevelName'], FundaeFinishGroupDatatableDataSourceType>,
  'access_employee_referenceContract_esProfessionalCategoryId': RevealType<['node', 'access', 'employee', 'referenceContract', 'esProfessionalCategoryId'], FundaeFinishGroupDatatableDataSourceType>,
  'access_employee_referenceContract_esProfessionalCategoryName': RevealType<['node', 'access', 'employee', 'referenceContract', 'esProfessionalCategoryName'], FundaeFinishGroupDatatableDataSourceType>,
  'access_employee_id': RevealType<['node', 'access', 'employee', 'id'], FundaeFinishGroupDatatableDataSourceType>,
  'access_employee__policies': RevealType<['node', 'access', 'employee', '_policies'], FundaeFinishGroupDatatableDataSourceType>,
  'access_employee_email': RevealType<['node', 'access', 'employee', 'email'], FundaeFinishGroupDatatableDataSourceType>,
  'access_employee_identifier': RevealType<['node', 'access', 'employee', 'identifier'], FundaeFinishGroupDatatableDataSourceType>,
  'access_employee_identifierType': RevealType<['node', 'access', 'employee', 'identifierType'], FundaeFinishGroupDatatableDataSourceType>,
  'access_employee_phoneNumber': RevealType<['node', 'access', 'employee', 'phoneNumber'], FundaeFinishGroupDatatableDataSourceType>,
  'access_employee_referenceContract': RevealType<['node', 'access', 'employee', 'referenceContract'], FundaeFinishGroupDatatableDataSourceType>,
  'access_id': RevealType<['node', 'access', 'id'], FundaeFinishGroupDatatableDataSourceType>,
  'access_avatar': RevealType<['node', 'access', 'avatar'], FundaeFinishGroupDatatableDataSourceType>,
  'access_employee': RevealType<['node', 'access', 'employee'], FundaeFinishGroupDatatableDataSourceType>,
  'access_fullName': RevealType<['node', 'access', 'fullName'], FundaeFinishGroupDatatableDataSourceType>,
  'id': RevealType<['node', 'id'], FundaeFinishGroupDatatableDataSourceType>,
  'access': RevealType<['node', 'access'], FundaeFinishGroupDatatableDataSourceType>,
  'certificate': RevealType<['node', 'certificate'], FundaeFinishGroupDatatableDataSourceType>
}

const FundaeFinishGroupDatatableResolver = {
  dataSource: (data: FundaeFinishGroupDatatableQuery) => data.trainings.fundaeFinishGroupsConnection,
  edges: (data: FundaeFinishGroupDatatableQuery) => data.trainings.fundaeFinishGroupsConnection.edges,
  fields: {
    'nodes': (edge: FundaeFinishGroupDatatableDataSourceType) => edge.node.nodes,
    'access_employee__policies_editPersonalInfo_can': (edge: FundaeFinishGroupDatatableDataSourceType) => edge.node.access?.employee?._policies?.editPersonalInfo?.can,
    'access_employee__policies_readPersonalInfo_can': (edge: FundaeFinishGroupDatatableDataSourceType) => edge.node.access?.employee?._policies?.readPersonalInfo?.can,
    'access_employee__policies_editPersonalInfo': (edge: FundaeFinishGroupDatatableDataSourceType) => edge.node.access?.employee?._policies?.editPersonalInfo,
    'access_employee__policies_readPersonalInfo': (edge: FundaeFinishGroupDatatableDataSourceType) => edge.node.access?.employee?._policies?.readPersonalInfo,
    'access_employee_referenceContract__policies_edit_can': (edge: FundaeFinishGroupDatatableDataSourceType) => edge.node.access?.employee?.referenceContract?._policies?.edit?.can,
    'access_employee_referenceContract__policies_seeExtraInfo_can': (edge: FundaeFinishGroupDatatableDataSourceType) => edge.node.access?.employee?.referenceContract?._policies?.seeExtraInfo?.can,
    'access_employee_referenceContract__policies_edit': (edge: FundaeFinishGroupDatatableDataSourceType) => edge.node.access?.employee?.referenceContract?._policies?.edit,
    'access_employee_referenceContract__policies_seeExtraInfo': (edge: FundaeFinishGroupDatatableDataSourceType) => edge.node.access?.employee?.referenceContract?._policies?.seeExtraInfo,
    'access_employee_referenceContract_id': (edge: FundaeFinishGroupDatatableDataSourceType) => edge.node.access?.employee?.referenceContract?.id,
    'access_employee_referenceContract__policies': (edge: FundaeFinishGroupDatatableDataSourceType) => edge.node.access?.employee?.referenceContract?._policies,
    'access_employee_referenceContract_esEducationLevelId': (edge: FundaeFinishGroupDatatableDataSourceType) => edge.node.access?.employee?.referenceContract?.esEducationLevelId,
    'access_employee_referenceContract_esEducationLevelName': (edge: FundaeFinishGroupDatatableDataSourceType) => edge.node.access?.employee?.referenceContract?.esEducationLevelName,
    'access_employee_referenceContract_esProfessionalCategoryId': (edge: FundaeFinishGroupDatatableDataSourceType) => edge.node.access?.employee?.referenceContract?.esProfessionalCategoryId,
    'access_employee_referenceContract_esProfessionalCategoryName': (edge: FundaeFinishGroupDatatableDataSourceType) => edge.node.access?.employee?.referenceContract?.esProfessionalCategoryName,
    'access_employee_id': (edge: FundaeFinishGroupDatatableDataSourceType) => edge.node.access?.employee?.id,
    'access_employee__policies': (edge: FundaeFinishGroupDatatableDataSourceType) => edge.node.access?.employee?._policies,
    'access_employee_email': (edge: FundaeFinishGroupDatatableDataSourceType) => edge.node.access?.employee?.email,
    'access_employee_identifier': (edge: FundaeFinishGroupDatatableDataSourceType) => edge.node.access?.employee?.identifier,
    'access_employee_identifierType': (edge: FundaeFinishGroupDatatableDataSourceType) => edge.node.access?.employee?.identifierType,
    'access_employee_phoneNumber': (edge: FundaeFinishGroupDatatableDataSourceType) => edge.node.access?.employee?.phoneNumber,
    'access_employee_referenceContract': (edge: FundaeFinishGroupDatatableDataSourceType) => edge.node.access?.employee?.referenceContract,
    'access_id': (edge: FundaeFinishGroupDatatableDataSourceType) => edge.node.access?.id,
    'access_avatar': (edge: FundaeFinishGroupDatatableDataSourceType) => edge.node.access?.avatar,
    'access_employee': (edge: FundaeFinishGroupDatatableDataSourceType) => edge.node.access?.employee,
    'access_fullName': (edge: FundaeFinishGroupDatatableDataSourceType) => edge.node.access?.fullName,
    'id': (edge: FundaeFinishGroupDatatableDataSourceType) => edge.node.id,
    'access': (edge: FundaeFinishGroupDatatableDataSourceType) => edge.node.access,
    'certificate': (edge: FundaeFinishGroupDatatableDataSourceType) => edge.node.certificate,
  }
}

export function buildFundaeFinishGroupDatatableFilter(
  source: DataTableSource<FundaeFinishGroupDatatableFields, typeof FundaeFinishGroupDatatableSortableFields[number]>,
  filter: DataTableFilter<TrainingsFundaeFinishGroupFilter>
) {
  return filter
}

export function useFundaeFinishGroupDatatable(
  projections: DataTableProjection<FundaeFinishGroupDatatableFields, typeof FundaeFinishGroupDatatableSortableFields[number]>[],
  options?: {
    variables?: FundaeFinishGroupDatatableQueryVariables
    defaultSort?: typeof FundaeFinishGroupDatatableSortableFields[number]
    identifier?: string
  }
): DataTableSource<FundaeFinishGroupDatatableFields, typeof FundaeFinishGroupDatatableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'FundaeFinishGroupDatatable'

  return {
    identifier,
    query: FundaeFinishGroupDatatableDocument,
    resolver: FundaeFinishGroupDatatableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? FundaeFinishGroupDatatableSortableFields.at(0),
      fields: FundaeFinishGroupDatatableSortableFields,
    },
    variables
  }
}
export const MySessionsDataTableDocument = gql`
query MySessionsDataTable($accessId: Int, $search: String, $trainingId: Int, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: TrainingsSessionFilter) {
  trainings {
    sessionsConnection(
      accessId: $accessId
      search: $search
      trainingId: $trainingId
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          dueDate
          duration
          endsAt
          link
          location
          modality
          name
          schedule
          sessionAttendances {
            id
            _policies {
              edit {
                id
                can
              }
            }
            accessId
            status
          }
          startsAt
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type MySessionsDataTableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<MySessionsDataTableQuery['trainings']>['sessionsConnection']>['edges']
>

const MySessionsDataTableSortableFields = ['id', 'dueDate', 'duration', 'endsAt', 'name', 'startsAt'] as const

interface MySessionsDataTableFields {
  'id': RevealType<['node', 'id'], MySessionsDataTableDataSourceType>,
  'dueDate': RevealType<['node', 'dueDate'], MySessionsDataTableDataSourceType>,
  'duration': RevealType<['node', 'duration'], MySessionsDataTableDataSourceType>,
  'endsAt': RevealType<['node', 'endsAt'], MySessionsDataTableDataSourceType>,
  'link': RevealType<['node', 'link'], MySessionsDataTableDataSourceType>,
  'location': RevealType<['node', 'location'], MySessionsDataTableDataSourceType>,
  'modality': RevealType<['node', 'modality'], MySessionsDataTableDataSourceType>,
  'name': RevealType<['node', 'name'], MySessionsDataTableDataSourceType>,
  'schedule': RevealType<['node', 'schedule'], MySessionsDataTableDataSourceType>,
  'sessionAttendances': RevealType<['node', 'sessionAttendances'], MySessionsDataTableDataSourceType>,
  'startsAt': RevealType<['node', 'startsAt'], MySessionsDataTableDataSourceType>
}

const MySessionsDataTableResolver = {
  dataSource: (data: MySessionsDataTableQuery) => data.trainings.sessionsConnection,
  edges: (data: MySessionsDataTableQuery) => data.trainings.sessionsConnection.edges,
  fields: {
    'id': (edge: MySessionsDataTableDataSourceType) => edge.node.id,
    'dueDate': (edge: MySessionsDataTableDataSourceType) => edge.node.dueDate,
    'duration': (edge: MySessionsDataTableDataSourceType) => edge.node.duration,
    'endsAt': (edge: MySessionsDataTableDataSourceType) => edge.node.endsAt,
    'link': (edge: MySessionsDataTableDataSourceType) => edge.node.link,
    'location': (edge: MySessionsDataTableDataSourceType) => edge.node.location,
    'modality': (edge: MySessionsDataTableDataSourceType) => edge.node.modality,
    'name': (edge: MySessionsDataTableDataSourceType) => edge.node.name,
    'schedule': (edge: MySessionsDataTableDataSourceType) => edge.node.schedule,
    'sessionAttendances': (edge: MySessionsDataTableDataSourceType) => edge.node.sessionAttendances,
    'startsAt': (edge: MySessionsDataTableDataSourceType) => edge.node.startsAt,
  }
}

export function buildMySessionsDataTableFilter(
  source: DataTableSource<MySessionsDataTableFields, typeof MySessionsDataTableSortableFields[number]>,
  filter: DataTableFilter<TrainingsSessionFilter>
) {
  return filter
}

export function useMySessionsDataTable(
  projections: DataTableProjection<MySessionsDataTableFields, typeof MySessionsDataTableSortableFields[number]>[],
  options?: {
    variables?: MySessionsDataTableQueryVariables
    defaultSort?: typeof MySessionsDataTableSortableFields[number]
    identifier?: string
  }
): DataTableSource<MySessionsDataTableFields, typeof MySessionsDataTableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'MySessionsDataTable'

  return {
    identifier,
    query: MySessionsDataTableDocument,
    resolver: MySessionsDataTableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? MySessionsDataTableSortableFields.at(0),
      fields: MySessionsDataTableSortableFields,
    },
    variables
  }
}
export const RemindersDataTableDocument = gql`
query RemindersDataTable($sessionId: Int!, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort) {
  trainings {
    remindersConnection(
      sessionId: $sessionId
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          completed
          content
          name
          scheduledAt
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type RemindersDataTableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<RemindersDataTableQuery['trainings']>['remindersConnection']>['edges']
>

const RemindersDataTableSortableFields = [] as const

interface RemindersDataTableFields {
  'id': RevealType<['node', 'id'], RemindersDataTableDataSourceType>,
  'completed': RevealType<['node', 'completed'], RemindersDataTableDataSourceType>,
  'content': RevealType<['node', 'content'], RemindersDataTableDataSourceType>,
  'name': RevealType<['node', 'name'], RemindersDataTableDataSourceType>,
  'scheduledAt': RevealType<['node', 'scheduledAt'], RemindersDataTableDataSourceType>
}

const RemindersDataTableResolver = {
  dataSource: (data: RemindersDataTableQuery) => data.trainings.remindersConnection,
  edges: (data: RemindersDataTableQuery) => data.trainings.remindersConnection.edges,
  fields: {
    'id': (edge: RemindersDataTableDataSourceType) => edge.node.id,
    'completed': (edge: RemindersDataTableDataSourceType) => edge.node.completed,
    'content': (edge: RemindersDataTableDataSourceType) => edge.node.content,
    'name': (edge: RemindersDataTableDataSourceType) => edge.node.name,
    'scheduledAt': (edge: RemindersDataTableDataSourceType) => edge.node.scheduledAt,
  }
}

export function useRemindersDataTable(
  projections: DataTableProjection<RemindersDataTableFields, typeof RemindersDataTableSortableFields[number]>[],
  options?: {
    variables?: RemindersDataTableQueryVariables
    defaultSort?: typeof RemindersDataTableSortableFields[number]
    identifier?: string
  }
): DataTableSource<RemindersDataTableFields, typeof RemindersDataTableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'RemindersDataTable'

  return {
    identifier,
    query: RemindersDataTableDocument,
    resolver: RemindersDataTableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? RemindersDataTableSortableFields.at(0),
      fields: RemindersDataTableSortableFields,
    },
    variables
  }
}
export const SessionAccessMembershipsDataTableDocument = gql`
query SessionAccessMembershipsDataTable($search: String, $sessionId: Int!, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: TrainingsSessionAccessMembershipFilter) {
  trainings {
    sessionAccessMembershipsConnection(
      search: $search
      sessionId: $sessionId
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          access {
            id
            avatar
            fullName
          }
          firstName
          jobTitle
          lastName
          sessionAttendance {
            id
            status
          }
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type SessionAccessMembershipsDataTableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<SessionAccessMembershipsDataTableQuery['trainings']>['sessionAccessMembershipsConnection']>['edges']
>

const SessionAccessMembershipsDataTableSortableFields = ['id', 'firstName'] as const

interface SessionAccessMembershipsDataTableFields {
  'access_id': RevealType<['node', 'access', 'id'], SessionAccessMembershipsDataTableDataSourceType>,
  'access_avatar': RevealType<['node', 'access', 'avatar'], SessionAccessMembershipsDataTableDataSourceType>,
  'access_fullName': RevealType<['node', 'access', 'fullName'], SessionAccessMembershipsDataTableDataSourceType>,
  'sessionAttendance_id': RevealType<['node', 'sessionAttendance', 'id'], SessionAccessMembershipsDataTableDataSourceType>,
  'sessionAttendance_status': RevealType<['node', 'sessionAttendance', 'status'], SessionAccessMembershipsDataTableDataSourceType>,
  'id': RevealType<['node', 'id'], SessionAccessMembershipsDataTableDataSourceType>,
  'access': RevealType<['node', 'access'], SessionAccessMembershipsDataTableDataSourceType>,
  'firstName': RevealType<['node', 'firstName'], SessionAccessMembershipsDataTableDataSourceType>,
  'jobTitle': RevealType<['node', 'jobTitle'], SessionAccessMembershipsDataTableDataSourceType>,
  'lastName': RevealType<['node', 'lastName'], SessionAccessMembershipsDataTableDataSourceType>,
  'sessionAttendance': RevealType<['node', 'sessionAttendance'], SessionAccessMembershipsDataTableDataSourceType>
}

const SessionAccessMembershipsDataTableResolver = {
  dataSource: (data: SessionAccessMembershipsDataTableQuery) => data.trainings.sessionAccessMembershipsConnection,
  edges: (data: SessionAccessMembershipsDataTableQuery) => data.trainings.sessionAccessMembershipsConnection.edges,
  fields: {
    'access_id': (edge: SessionAccessMembershipsDataTableDataSourceType) => edge.node.access?.id,
    'access_avatar': (edge: SessionAccessMembershipsDataTableDataSourceType) => edge.node.access?.avatar,
    'access_fullName': (edge: SessionAccessMembershipsDataTableDataSourceType) => edge.node.access?.fullName,
    'sessionAttendance_id': (edge: SessionAccessMembershipsDataTableDataSourceType) => edge.node.sessionAttendance?.id,
    'sessionAttendance_status': (edge: SessionAccessMembershipsDataTableDataSourceType) => edge.node.sessionAttendance?.status,
    'id': (edge: SessionAccessMembershipsDataTableDataSourceType) => edge.node.id,
    'access': (edge: SessionAccessMembershipsDataTableDataSourceType) => edge.node.access,
    'firstName': (edge: SessionAccessMembershipsDataTableDataSourceType) => edge.node.firstName,
    'jobTitle': (edge: SessionAccessMembershipsDataTableDataSourceType) => edge.node.jobTitle,
    'lastName': (edge: SessionAccessMembershipsDataTableDataSourceType) => edge.node.lastName,
    'sessionAttendance': (edge: SessionAccessMembershipsDataTableDataSourceType) => edge.node.sessionAttendance,
  }
}

export function buildSessionAccessMembershipsDataTableFilter(
  source: DataTableSource<SessionAccessMembershipsDataTableFields, typeof SessionAccessMembershipsDataTableSortableFields[number]>,
  filter: DataTableFilter<TrainingsSessionAccessMembershipFilter>
) {
  return filter
}

export function useSessionAccessMembershipsDataTable(
  projections: DataTableProjection<SessionAccessMembershipsDataTableFields, typeof SessionAccessMembershipsDataTableSortableFields[number]>[],
  options?: {
    variables?: SessionAccessMembershipsDataTableQueryVariables
    defaultSort?: typeof SessionAccessMembershipsDataTableSortableFields[number]
    identifier?: string
  }
): DataTableSource<SessionAccessMembershipsDataTableFields, typeof SessionAccessMembershipsDataTableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'SessionAccessMembershipsDataTable'

  return {
    identifier,
    query: SessionAccessMembershipsDataTableDocument,
    resolver: SessionAccessMembershipsDataTableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? SessionAccessMembershipsDataTableSortableFields.at(0),
      fields: SessionAccessMembershipsDataTableSortableFields,
    },
    variables
  }
}
export const SessionsDataTableDocument = gql`
query SessionsDataTable($search: String, $trainingIds: [Int!], $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: TrainingsSessionFilter) {
  trainings {
    sessionsConnection(
      search: $search
      trainingIds: $trainingIds
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          duration
          endsAt
          link
          modality
          name
          startsAt
          status
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type SessionsDataTableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<SessionsDataTableQuery['trainings']>['sessionsConnection']>['edges']
>

const SessionsDataTableSortableFields = ['id', 'duration', 'endsAt', 'name', 'startsAt'] as const

interface SessionsDataTableFields {
  'id': RevealType<['node', 'id'], SessionsDataTableDataSourceType>,
  'duration': RevealType<['node', 'duration'], SessionsDataTableDataSourceType>,
  'endsAt': RevealType<['node', 'endsAt'], SessionsDataTableDataSourceType>,
  'link': RevealType<['node', 'link'], SessionsDataTableDataSourceType>,
  'modality': RevealType<['node', 'modality'], SessionsDataTableDataSourceType>,
  'name': RevealType<['node', 'name'], SessionsDataTableDataSourceType>,
  'startsAt': RevealType<['node', 'startsAt'], SessionsDataTableDataSourceType>,
  'status': RevealType<['node', 'status'], SessionsDataTableDataSourceType>
}

const SessionsDataTableResolver = {
  dataSource: (data: SessionsDataTableQuery) => data.trainings.sessionsConnection,
  edges: (data: SessionsDataTableQuery) => data.trainings.sessionsConnection.edges,
  fields: {
    'id': (edge: SessionsDataTableDataSourceType) => edge.node.id,
    'duration': (edge: SessionsDataTableDataSourceType) => edge.node.duration,
    'endsAt': (edge: SessionsDataTableDataSourceType) => edge.node.endsAt,
    'link': (edge: SessionsDataTableDataSourceType) => edge.node.link,
    'modality': (edge: SessionsDataTableDataSourceType) => edge.node.modality,
    'name': (edge: SessionsDataTableDataSourceType) => edge.node.name,
    'startsAt': (edge: SessionsDataTableDataSourceType) => edge.node.startsAt,
    'status': (edge: SessionsDataTableDataSourceType) => edge.node.status,
  }
}

export function buildSessionsDataTableFilter(
  source: DataTableSource<SessionsDataTableFields, typeof SessionsDataTableSortableFields[number]>,
  filter: DataTableFilter<TrainingsSessionFilter>
) {
  return filter
}

export function useSessionsDataTable(
  projections: DataTableProjection<SessionsDataTableFields, typeof SessionsDataTableSortableFields[number]>[],
  options?: {
    variables?: SessionsDataTableQueryVariables
    defaultSort?: typeof SessionsDataTableSortableFields[number]
    identifier?: string
  }
): DataTableSource<SessionsDataTableFields, typeof SessionsDataTableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'SessionsDataTable'

  return {
    identifier,
    query: SessionsDataTableDocument,
    resolver: SessionsDataTableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? SessionsDataTableSortableFields.at(0),
      fields: SessionsDataTableSortableFields,
    },
    variables
  }
}
export const TrainingClassMembershipsDatatableDocument = gql`
query TrainingClassMembershipsDatatable($ids: [Int!], $search: String, $trainingClassId: Int!, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: TrainingsTrainingClassMembershipFilter) {
  trainings {
    trainingClassMembershipsConnection(
      ids: $ids
      search: $search
      trainingClassId: $trainingClassId
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          access {
            id
            avatar
            employee {
              id
              preferredName
              referenceContract {
                id
                jobTitle
              }
            }
            fullName
          }
          trainingClassId
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type TrainingClassMembershipsDatatableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<TrainingClassMembershipsDatatableQuery['trainings']>['trainingClassMembershipsConnection']>['edges']
>

const TrainingClassMembershipsDatatableSortableFields = ['id', 'id', 'id'] as const

interface TrainingClassMembershipsDatatableFields {
  'access_employee_referenceContract_id': RevealType<['node', 'access', 'employee', 'referenceContract', 'id'], TrainingClassMembershipsDatatableDataSourceType>,
  'access_employee_referenceContract_jobTitle': RevealType<['node', 'access', 'employee', 'referenceContract', 'jobTitle'], TrainingClassMembershipsDatatableDataSourceType>,
  'access_employee_id': RevealType<['node', 'access', 'employee', 'id'], TrainingClassMembershipsDatatableDataSourceType>,
  'access_employee_preferredName': RevealType<['node', 'access', 'employee', 'preferredName'], TrainingClassMembershipsDatatableDataSourceType>,
  'access_employee_referenceContract': RevealType<['node', 'access', 'employee', 'referenceContract'], TrainingClassMembershipsDatatableDataSourceType>,
  'access_id': RevealType<['node', 'access', 'id'], TrainingClassMembershipsDatatableDataSourceType>,
  'access_avatar': RevealType<['node', 'access', 'avatar'], TrainingClassMembershipsDatatableDataSourceType>,
  'access_employee': RevealType<['node', 'access', 'employee'], TrainingClassMembershipsDatatableDataSourceType>,
  'access_fullName': RevealType<['node', 'access', 'fullName'], TrainingClassMembershipsDatatableDataSourceType>,
  'id': RevealType<['node', 'id'], TrainingClassMembershipsDatatableDataSourceType>,
  'access': RevealType<['node', 'access'], TrainingClassMembershipsDatatableDataSourceType>,
  'trainingClassId': RevealType<['node', 'trainingClassId'], TrainingClassMembershipsDatatableDataSourceType>
}

const TrainingClassMembershipsDatatableResolver = {
  dataSource: (data: TrainingClassMembershipsDatatableQuery) => data.trainings.trainingClassMembershipsConnection,
  edges: (data: TrainingClassMembershipsDatatableQuery) => data.trainings.trainingClassMembershipsConnection.edges,
  fields: {
    'access_employee_referenceContract_id': (edge: TrainingClassMembershipsDatatableDataSourceType) => edge.node.access?.employee?.referenceContract?.id,
    'access_employee_referenceContract_jobTitle': (edge: TrainingClassMembershipsDatatableDataSourceType) => edge.node.access?.employee?.referenceContract?.jobTitle,
    'access_employee_id': (edge: TrainingClassMembershipsDatatableDataSourceType) => edge.node.access?.employee?.id,
    'access_employee_preferredName': (edge: TrainingClassMembershipsDatatableDataSourceType) => edge.node.access?.employee?.preferredName,
    'access_employee_referenceContract': (edge: TrainingClassMembershipsDatatableDataSourceType) => edge.node.access?.employee?.referenceContract,
    'access_id': (edge: TrainingClassMembershipsDatatableDataSourceType) => edge.node.access?.id,
    'access_avatar': (edge: TrainingClassMembershipsDatatableDataSourceType) => edge.node.access?.avatar,
    'access_employee': (edge: TrainingClassMembershipsDatatableDataSourceType) => edge.node.access?.employee,
    'access_fullName': (edge: TrainingClassMembershipsDatatableDataSourceType) => edge.node.access?.fullName,
    'id': (edge: TrainingClassMembershipsDatatableDataSourceType) => edge.node.id,
    'access': (edge: TrainingClassMembershipsDatatableDataSourceType) => edge.node.access,
    'trainingClassId': (edge: TrainingClassMembershipsDatatableDataSourceType) => edge.node.trainingClassId,
  }
}

export function buildTrainingClassMembershipsDatatableFilter(
  source: DataTableSource<TrainingClassMembershipsDatatableFields, typeof TrainingClassMembershipsDatatableSortableFields[number]>,
  filter: DataTableFilter<TrainingsTrainingClassMembershipFilter>
) {
  return filter
}

export function useTrainingClassMembershipsDatatable(
  projections: DataTableProjection<TrainingClassMembershipsDatatableFields, typeof TrainingClassMembershipsDatatableSortableFields[number]>[],
  options?: {
    variables?: TrainingClassMembershipsDatatableQueryVariables
    defaultSort?: typeof TrainingClassMembershipsDatatableSortableFields[number]
    identifier?: string
  }
): DataTableSource<TrainingClassMembershipsDatatableFields, typeof TrainingClassMembershipsDatatableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'TrainingClassMembershipsDatatable'

  return {
    identifier,
    query: TrainingClassMembershipsDatatableDocument,
    resolver: TrainingClassMembershipsDatatableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? TrainingClassMembershipsDatatableSortableFields.at(0),
      fields: TrainingClassMembershipsDatatableSortableFields,
    },
    variables
  }
}
export const TrainingSessionsByEmployeeDataTableDocument = gql`
query TrainingSessionsByEmployeeDataTable($accessId: Int!, $search: String, $trainingClassIds: [String!], $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: TrainingsSessionFilter) {
  trainings {
    sessionsConnection(
      accessId: $accessId
      search: $search
      trainingClassIds: $trainingClassIds
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          endsAt
          link
          location
          sessionAttendances {
            id
            accessId
            employeeId
            status
          }
          startsAt
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type TrainingSessionsByEmployeeDataTableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<TrainingSessionsByEmployeeDataTableQuery['trainings']>['sessionsConnection']>['edges']
>

const TrainingSessionsByEmployeeDataTableSortableFields = ['id', 'endsAt', 'startsAt'] as const

interface TrainingSessionsByEmployeeDataTableFields {
  'id': RevealType<['node', 'id'], TrainingSessionsByEmployeeDataTableDataSourceType>,
  'endsAt': RevealType<['node', 'endsAt'], TrainingSessionsByEmployeeDataTableDataSourceType>,
  'link': RevealType<['node', 'link'], TrainingSessionsByEmployeeDataTableDataSourceType>,
  'location': RevealType<['node', 'location'], TrainingSessionsByEmployeeDataTableDataSourceType>,
  'sessionAttendances': RevealType<['node', 'sessionAttendances'], TrainingSessionsByEmployeeDataTableDataSourceType>,
  'startsAt': RevealType<['node', 'startsAt'], TrainingSessionsByEmployeeDataTableDataSourceType>
}

const TrainingSessionsByEmployeeDataTableResolver = {
  dataSource: (data: TrainingSessionsByEmployeeDataTableQuery) => data.trainings.sessionsConnection,
  edges: (data: TrainingSessionsByEmployeeDataTableQuery) => data.trainings.sessionsConnection.edges,
  fields: {
    'id': (edge: TrainingSessionsByEmployeeDataTableDataSourceType) => edge.node.id,
    'endsAt': (edge: TrainingSessionsByEmployeeDataTableDataSourceType) => edge.node.endsAt,
    'link': (edge: TrainingSessionsByEmployeeDataTableDataSourceType) => edge.node.link,
    'location': (edge: TrainingSessionsByEmployeeDataTableDataSourceType) => edge.node.location,
    'sessionAttendances': (edge: TrainingSessionsByEmployeeDataTableDataSourceType) => edge.node.sessionAttendances,
    'startsAt': (edge: TrainingSessionsByEmployeeDataTableDataSourceType) => edge.node.startsAt,
  }
}

export function buildTrainingSessionsByEmployeeDataTableFilter(
  source: DataTableSource<TrainingSessionsByEmployeeDataTableFields, typeof TrainingSessionsByEmployeeDataTableSortableFields[number]>,
  filter: DataTableFilter<TrainingsSessionFilter>
) {
  return filter
}

export function useTrainingSessionsByEmployeeDataTable(
  projections: DataTableProjection<TrainingSessionsByEmployeeDataTableFields, typeof TrainingSessionsByEmployeeDataTableSortableFields[number]>[],
  options?: {
    variables?: TrainingSessionsByEmployeeDataTableQueryVariables
    defaultSort?: typeof TrainingSessionsByEmployeeDataTableSortableFields[number]
    identifier?: string
  }
): DataTableSource<TrainingSessionsByEmployeeDataTableFields, typeof TrainingSessionsByEmployeeDataTableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'TrainingSessionsByEmployeeDataTable'

  return {
    identifier,
    query: TrainingSessionsByEmployeeDataTableDocument,
    resolver: TrainingSessionsByEmployeeDataTableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? TrainingSessionsByEmployeeDataTableSortableFields.at(0),
      fields: TrainingSessionsByEmployeeDataTableSortableFields,
    },
    variables
  }
}
export const TrainingMembershipsDataTableDocument = gql`
query TrainingMembershipsDataTable($ids: [Int!], $search: String, $trainingId: Int!, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: TrainingsTrainingMembershipFilter) {
  trainings {
    trainingMembershipsConnection(
      ids: $ids
      search: $search
      trainingId: $trainingId
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          accessId
          employee {
            id
            avatar {
              id
              url
            }
            fullName
            preferredName
          }
          status
          trainingCompletedAt
          trainingDueDate
          trainingId
          trainingMembershipFiles {
            id
            contentType
            fileId
            filename
            trainingMembershipId
            url
          }
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type TrainingMembershipsDataTableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<TrainingMembershipsDataTableQuery['trainings']>['trainingMembershipsConnection']>['edges']
>

const TrainingMembershipsDataTableSortableFields = ['id', 'fullName', 'id', 'accessId', 'status', 'trainingCompletedAt', 'trainingDueDate', 'trainingId'] as const

interface TrainingMembershipsDataTableFields {
  'employee_avatar_id': RevealType<['node', 'employee', 'avatar', 'id'], TrainingMembershipsDataTableDataSourceType>,
  'employee_avatar_url': RevealType<['node', 'employee', 'avatar', 'url'], TrainingMembershipsDataTableDataSourceType>,
  'employee_id': RevealType<['node', 'employee', 'id'], TrainingMembershipsDataTableDataSourceType>,
  'employee_avatar': RevealType<['node', 'employee', 'avatar'], TrainingMembershipsDataTableDataSourceType>,
  'employee_fullName': RevealType<['node', 'employee', 'fullName'], TrainingMembershipsDataTableDataSourceType>,
  'employee_preferredName': RevealType<['node', 'employee', 'preferredName'], TrainingMembershipsDataTableDataSourceType>,
  'id': RevealType<['node', 'id'], TrainingMembershipsDataTableDataSourceType>,
  'accessId': RevealType<['node', 'accessId'], TrainingMembershipsDataTableDataSourceType>,
  'employee': RevealType<['node', 'employee'], TrainingMembershipsDataTableDataSourceType>,
  'status': RevealType<['node', 'status'], TrainingMembershipsDataTableDataSourceType>,
  'trainingCompletedAt': RevealType<['node', 'trainingCompletedAt'], TrainingMembershipsDataTableDataSourceType>,
  'trainingDueDate': RevealType<['node', 'trainingDueDate'], TrainingMembershipsDataTableDataSourceType>,
  'trainingId': RevealType<['node', 'trainingId'], TrainingMembershipsDataTableDataSourceType>,
  'trainingMembershipFiles': RevealType<['node', 'trainingMembershipFiles'], TrainingMembershipsDataTableDataSourceType>
}

const TrainingMembershipsDataTableResolver = {
  dataSource: (data: TrainingMembershipsDataTableQuery) => data.trainings.trainingMembershipsConnection,
  edges: (data: TrainingMembershipsDataTableQuery) => data.trainings.trainingMembershipsConnection.edges,
  fields: {
    'employee_avatar_id': (edge: TrainingMembershipsDataTableDataSourceType) => edge.node.employee?.avatar?.id,
    'employee_avatar_url': (edge: TrainingMembershipsDataTableDataSourceType) => edge.node.employee?.avatar?.url,
    'employee_id': (edge: TrainingMembershipsDataTableDataSourceType) => edge.node.employee?.id,
    'employee_avatar': (edge: TrainingMembershipsDataTableDataSourceType) => edge.node.employee?.avatar,
    'employee_fullName': (edge: TrainingMembershipsDataTableDataSourceType) => edge.node.employee?.fullName,
    'employee_preferredName': (edge: TrainingMembershipsDataTableDataSourceType) => edge.node.employee?.preferredName,
    'id': (edge: TrainingMembershipsDataTableDataSourceType) => edge.node.id,
    'accessId': (edge: TrainingMembershipsDataTableDataSourceType) => edge.node.accessId,
    'employee': (edge: TrainingMembershipsDataTableDataSourceType) => edge.node.employee,
    'status': (edge: TrainingMembershipsDataTableDataSourceType) => edge.node.status,
    'trainingCompletedAt': (edge: TrainingMembershipsDataTableDataSourceType) => edge.node.trainingCompletedAt,
    'trainingDueDate': (edge: TrainingMembershipsDataTableDataSourceType) => edge.node.trainingDueDate,
    'trainingId': (edge: TrainingMembershipsDataTableDataSourceType) => edge.node.trainingId,
    'trainingMembershipFiles': (edge: TrainingMembershipsDataTableDataSourceType) => edge.node.trainingMembershipFiles,
  }
}

export function buildTrainingMembershipsDataTableFilter(
  source: DataTableSource<TrainingMembershipsDataTableFields, typeof TrainingMembershipsDataTableSortableFields[number]>,
  filter: DataTableFilter<TrainingsTrainingMembershipFilter>
) {
  return filter
}

export function useTrainingMembershipsDataTable(
  projections: DataTableProjection<TrainingMembershipsDataTableFields, typeof TrainingMembershipsDataTableSortableFields[number]>[],
  options?: {
    variables?: TrainingMembershipsDataTableQueryVariables
    defaultSort?: typeof TrainingMembershipsDataTableSortableFields[number]
    identifier?: string
  }
): DataTableSource<TrainingMembershipsDataTableFields, typeof TrainingMembershipsDataTableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'TrainingMembershipsDataTable'

  return {
    identifier,
    query: TrainingMembershipsDataTableDocument,
    resolver: TrainingMembershipsDataTableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? TrainingMembershipsDataTableSortableFields.at(0),
      fields: TrainingMembershipsDataTableSortableFields,
    },
    variables
  }
}
export const TrainingsDataTableDocument = gql`
query TrainingsDataTable($catalog: Boolean, $search: String, $status: String, $withExpiredMemberships: Boolean, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: TrainingsTrainingFilter) {
  trainings {
    trainingsConnection(
      catalog: $catalog
      returnExpiredMemberships: true
      search: $search
      status: $status
      withExpiredMemberships: $withExpiredMemberships
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          _policies {
            edit {
              id
              can
            }
            read {
              id
              can
            }
          }
          authorId
          catalog
          categories {
            id
            name
          }
          code
          competencies {
            id
            name
          }
          costDecimal
          description
          external
          externalProvider
          fundaeSubsidized
          name
          numberOfExpiredParticipants
          sessions {
            id
            endsAt
            modality
            name
            startsAt
          }
          status
          subsidized
          subsidizedCostDecimal
          totalCostDecimal
          totalParticipants
          year
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type TrainingsDataTableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<TrainingsDataTableQuery['trainings']>['trainingsConnection']>['edges']
>

const TrainingsDataTableSortableFields = ['catalog', 'description', 'externalProvider', 'name', 'numberOfExpiredParticipants', 'status', 'totalParticipants', 'year'] as const

interface TrainingsDataTableFields {
  '_policies_edit_id': RevealType<['node', '_policies', 'edit', 'id'], TrainingsDataTableDataSourceType>,
  '_policies_edit_can': RevealType<['node', '_policies', 'edit', 'can'], TrainingsDataTableDataSourceType>,
  '_policies_read_id': RevealType<['node', '_policies', 'read', 'id'], TrainingsDataTableDataSourceType>,
  '_policies_read_can': RevealType<['node', '_policies', 'read', 'can'], TrainingsDataTableDataSourceType>,
  '_policies_edit': RevealType<['node', '_policies', 'edit'], TrainingsDataTableDataSourceType>,
  '_policies_read': RevealType<['node', '_policies', 'read'], TrainingsDataTableDataSourceType>,
  'id': RevealType<['node', 'id'], TrainingsDataTableDataSourceType>,
  '_policies': RevealType<['node', '_policies'], TrainingsDataTableDataSourceType>,
  'authorId': RevealType<['node', 'authorId'], TrainingsDataTableDataSourceType>,
  'catalog': RevealType<['node', 'catalog'], TrainingsDataTableDataSourceType>,
  'categories': RevealType<['node', 'categories'], TrainingsDataTableDataSourceType>,
  'code': RevealType<['node', 'code'], TrainingsDataTableDataSourceType>,
  'competencies': RevealType<['node', 'competencies'], TrainingsDataTableDataSourceType>,
  'costDecimal': RevealType<['node', 'costDecimal'], TrainingsDataTableDataSourceType>,
  'description': RevealType<['node', 'description'], TrainingsDataTableDataSourceType>,
  'external': RevealType<['node', 'external'], TrainingsDataTableDataSourceType>,
  'externalProvider': RevealType<['node', 'externalProvider'], TrainingsDataTableDataSourceType>,
  'fundaeSubsidized': RevealType<['node', 'fundaeSubsidized'], TrainingsDataTableDataSourceType>,
  'name': RevealType<['node', 'name'], TrainingsDataTableDataSourceType>,
  'numberOfExpiredParticipants': RevealType<['node', 'numberOfExpiredParticipants'], TrainingsDataTableDataSourceType>,
  'sessions': RevealType<['node', 'sessions'], TrainingsDataTableDataSourceType>,
  'status': RevealType<['node', 'status'], TrainingsDataTableDataSourceType>,
  'subsidized': RevealType<['node', 'subsidized'], TrainingsDataTableDataSourceType>,
  'subsidizedCostDecimal': RevealType<['node', 'subsidizedCostDecimal'], TrainingsDataTableDataSourceType>,
  'totalCostDecimal': RevealType<['node', 'totalCostDecimal'], TrainingsDataTableDataSourceType>,
  'totalParticipants': RevealType<['node', 'totalParticipants'], TrainingsDataTableDataSourceType>,
  'year': RevealType<['node', 'year'], TrainingsDataTableDataSourceType>
}

const TrainingsDataTableResolver = {
  dataSource: (data: TrainingsDataTableQuery) => data.trainings.trainingsConnection,
  edges: (data: TrainingsDataTableQuery) => data.trainings.trainingsConnection.edges,
  fields: {
    '_policies_edit_id': (edge: TrainingsDataTableDataSourceType) => edge.node._policies?.edit?.id,
    '_policies_edit_can': (edge: TrainingsDataTableDataSourceType) => edge.node._policies?.edit?.can,
    '_policies_read_id': (edge: TrainingsDataTableDataSourceType) => edge.node._policies?.read?.id,
    '_policies_read_can': (edge: TrainingsDataTableDataSourceType) => edge.node._policies?.read?.can,
    '_policies_edit': (edge: TrainingsDataTableDataSourceType) => edge.node._policies?.edit,
    '_policies_read': (edge: TrainingsDataTableDataSourceType) => edge.node._policies?.read,
    'id': (edge: TrainingsDataTableDataSourceType) => edge.node.id,
    '_policies': (edge: TrainingsDataTableDataSourceType) => edge.node._policies,
    'authorId': (edge: TrainingsDataTableDataSourceType) => edge.node.authorId,
    'catalog': (edge: TrainingsDataTableDataSourceType) => edge.node.catalog,
    'categories': (edge: TrainingsDataTableDataSourceType) => edge.node.categories,
    'code': (edge: TrainingsDataTableDataSourceType) => edge.node.code,
    'competencies': (edge: TrainingsDataTableDataSourceType) => edge.node.competencies,
    'costDecimal': (edge: TrainingsDataTableDataSourceType) => edge.node.costDecimal,
    'description': (edge: TrainingsDataTableDataSourceType) => edge.node.description,
    'external': (edge: TrainingsDataTableDataSourceType) => edge.node.external,
    'externalProvider': (edge: TrainingsDataTableDataSourceType) => edge.node.externalProvider,
    'fundaeSubsidized': (edge: TrainingsDataTableDataSourceType) => edge.node.fundaeSubsidized,
    'name': (edge: TrainingsDataTableDataSourceType) => edge.node.name,
    'numberOfExpiredParticipants': (edge: TrainingsDataTableDataSourceType) => edge.node.numberOfExpiredParticipants,
    'sessions': (edge: TrainingsDataTableDataSourceType) => edge.node.sessions,
    'status': (edge: TrainingsDataTableDataSourceType) => edge.node.status,
    'subsidized': (edge: TrainingsDataTableDataSourceType) => edge.node.subsidized,
    'subsidizedCostDecimal': (edge: TrainingsDataTableDataSourceType) => edge.node.subsidizedCostDecimal,
    'totalCostDecimal': (edge: TrainingsDataTableDataSourceType) => edge.node.totalCostDecimal,
    'totalParticipants': (edge: TrainingsDataTableDataSourceType) => edge.node.totalParticipants,
    'year': (edge: TrainingsDataTableDataSourceType) => edge.node.year,
  }
}

export function buildTrainingsDataTableFilter(
  source: DataTableSource<TrainingsDataTableFields, typeof TrainingsDataTableSortableFields[number]>,
  filter: DataTableFilter<TrainingsTrainingFilter>
) {
  return filter
}

export function useTrainingsDataTable(
  projections: DataTableProjection<TrainingsDataTableFields, typeof TrainingsDataTableSortableFields[number]>[],
  options?: {
    variables?: TrainingsDataTableQueryVariables
    defaultSort?: typeof TrainingsDataTableSortableFields[number]
    identifier?: string
  }
): DataTableSource<TrainingsDataTableFields, typeof TrainingsDataTableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'TrainingsDataTable'

  return {
    identifier,
    query: TrainingsDataTableDocument,
    resolver: TrainingsDataTableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? TrainingsDataTableSortableFields.at(0),
      fields: TrainingsDataTableSortableFields,
    },
    variables
  }
}
export const MyTrainingsCatalogSessionsDataTableDocument = gql`
query MyTrainingsCatalogSessionsDataTable($search: String, $startsAfter: String, $trainingId: Int, $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: TrainingsSessionFilter) {
  trainings {
    sessionsConnection(
      search: $search
      startAfter: $startsAfter
      trainingId: $trainingId
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          dueDate
          duration
          endsAt
          link
          location
          modality
          name
          schedule
          sessionAttendances {
            id
            _policies {
              edit {
                id
                can
              }
            }
            accessId
            status
          }
          startsAt
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type MyTrainingsCatalogSessionsDataTableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<MyTrainingsCatalogSessionsDataTableQuery['trainings']>['sessionsConnection']>['edges']
>

const MyTrainingsCatalogSessionsDataTableSortableFields = ['id', 'dueDate', 'duration', 'endsAt', 'name', 'startsAt'] as const

interface MyTrainingsCatalogSessionsDataTableFields {
  'id': RevealType<['node', 'id'], MyTrainingsCatalogSessionsDataTableDataSourceType>,
  'dueDate': RevealType<['node', 'dueDate'], MyTrainingsCatalogSessionsDataTableDataSourceType>,
  'duration': RevealType<['node', 'duration'], MyTrainingsCatalogSessionsDataTableDataSourceType>,
  'endsAt': RevealType<['node', 'endsAt'], MyTrainingsCatalogSessionsDataTableDataSourceType>,
  'link': RevealType<['node', 'link'], MyTrainingsCatalogSessionsDataTableDataSourceType>,
  'location': RevealType<['node', 'location'], MyTrainingsCatalogSessionsDataTableDataSourceType>,
  'modality': RevealType<['node', 'modality'], MyTrainingsCatalogSessionsDataTableDataSourceType>,
  'name': RevealType<['node', 'name'], MyTrainingsCatalogSessionsDataTableDataSourceType>,
  'schedule': RevealType<['node', 'schedule'], MyTrainingsCatalogSessionsDataTableDataSourceType>,
  'sessionAttendances': RevealType<['node', 'sessionAttendances'], MyTrainingsCatalogSessionsDataTableDataSourceType>,
  'startsAt': RevealType<['node', 'startsAt'], MyTrainingsCatalogSessionsDataTableDataSourceType>
}

const MyTrainingsCatalogSessionsDataTableResolver = {
  dataSource: (data: MyTrainingsCatalogSessionsDataTableQuery) => data.trainings.sessionsConnection,
  edges: (data: MyTrainingsCatalogSessionsDataTableQuery) => data.trainings.sessionsConnection.edges,
  fields: {
    'id': (edge: MyTrainingsCatalogSessionsDataTableDataSourceType) => edge.node.id,
    'dueDate': (edge: MyTrainingsCatalogSessionsDataTableDataSourceType) => edge.node.dueDate,
    'duration': (edge: MyTrainingsCatalogSessionsDataTableDataSourceType) => edge.node.duration,
    'endsAt': (edge: MyTrainingsCatalogSessionsDataTableDataSourceType) => edge.node.endsAt,
    'link': (edge: MyTrainingsCatalogSessionsDataTableDataSourceType) => edge.node.link,
    'location': (edge: MyTrainingsCatalogSessionsDataTableDataSourceType) => edge.node.location,
    'modality': (edge: MyTrainingsCatalogSessionsDataTableDataSourceType) => edge.node.modality,
    'name': (edge: MyTrainingsCatalogSessionsDataTableDataSourceType) => edge.node.name,
    'schedule': (edge: MyTrainingsCatalogSessionsDataTableDataSourceType) => edge.node.schedule,
    'sessionAttendances': (edge: MyTrainingsCatalogSessionsDataTableDataSourceType) => edge.node.sessionAttendances,
    'startsAt': (edge: MyTrainingsCatalogSessionsDataTableDataSourceType) => edge.node.startsAt,
  }
}

export function buildMyTrainingsCatalogSessionsDataTableFilter(
  source: DataTableSource<MyTrainingsCatalogSessionsDataTableFields, typeof MyTrainingsCatalogSessionsDataTableSortableFields[number]>,
  filter: DataTableFilter<TrainingsSessionFilter>
) {
  return filter
}

export function useMyTrainingsCatalogSessionsDataTable(
  projections: DataTableProjection<MyTrainingsCatalogSessionsDataTableFields, typeof MyTrainingsCatalogSessionsDataTableSortableFields[number]>[],
  options?: {
    variables?: MyTrainingsCatalogSessionsDataTableQueryVariables
    defaultSort?: typeof MyTrainingsCatalogSessionsDataTableSortableFields[number]
    identifier?: string
  }
): DataTableSource<MyTrainingsCatalogSessionsDataTableFields, typeof MyTrainingsCatalogSessionsDataTableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'MyTrainingsCatalogSessionsDataTable'

  return {
    identifier,
    query: MyTrainingsCatalogSessionsDataTableDocument,
    resolver: MyTrainingsCatalogSessionsDataTableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? MyTrainingsCatalogSessionsDataTableSortableFields.at(0),
      fields: MyTrainingsCatalogSessionsDataTableSortableFields,
    },
    variables
  }
}
export const TrainingSessionsDataTableDocument = gql`
query TrainingSessionsDataTable($search: String, $trainingClassIds: [String!], $projections: [Projection!], $format: String, $fileName: String, $first: Int, $last: Int, $offsetPage: Int, $before: String, $after: String, $sortOrder: Sort, $filter: TrainingsSessionFilter) {
  trainings {
    sessionsConnection(
      search: $search
      trainingClassIds: $trainingClassIds
      first: $first
      last: $last
      offsetPage: $offsetPage
      before: $before
      after: $after
      sortOrder: $sortOrder
      filter: $filter
    ) @dataSource(format: $format, fileName: $fileName, projections: $projections) {
      edges {
        node {
          id
          dueDate
          duration
          endsAt
          link
          location
          modality
          name
          sessionAttendances {
            id
            accessId
            status
          }
          startsAt
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`

type TrainingSessionsDataTableDataSourceType = RemoveArrayAndNull<
  RemoveArrayAndNull<RemoveArrayAndNull<TrainingSessionsDataTableQuery['trainings']>['sessionsConnection']>['edges']
>

const TrainingSessionsDataTableSortableFields = ['id', 'dueDate', 'duration', 'endsAt', 'name', 'startsAt'] as const

interface TrainingSessionsDataTableFields {
  'id': RevealType<['node', 'id'], TrainingSessionsDataTableDataSourceType>,
  'dueDate': RevealType<['node', 'dueDate'], TrainingSessionsDataTableDataSourceType>,
  'duration': RevealType<['node', 'duration'], TrainingSessionsDataTableDataSourceType>,
  'endsAt': RevealType<['node', 'endsAt'], TrainingSessionsDataTableDataSourceType>,
  'link': RevealType<['node', 'link'], TrainingSessionsDataTableDataSourceType>,
  'location': RevealType<['node', 'location'], TrainingSessionsDataTableDataSourceType>,
  'modality': RevealType<['node', 'modality'], TrainingSessionsDataTableDataSourceType>,
  'name': RevealType<['node', 'name'], TrainingSessionsDataTableDataSourceType>,
  'sessionAttendances': RevealType<['node', 'sessionAttendances'], TrainingSessionsDataTableDataSourceType>,
  'startsAt': RevealType<['node', 'startsAt'], TrainingSessionsDataTableDataSourceType>
}

const TrainingSessionsDataTableResolver = {
  dataSource: (data: TrainingSessionsDataTableQuery) => data.trainings.sessionsConnection,
  edges: (data: TrainingSessionsDataTableQuery) => data.trainings.sessionsConnection.edges,
  fields: {
    'id': (edge: TrainingSessionsDataTableDataSourceType) => edge.node.id,
    'dueDate': (edge: TrainingSessionsDataTableDataSourceType) => edge.node.dueDate,
    'duration': (edge: TrainingSessionsDataTableDataSourceType) => edge.node.duration,
    'endsAt': (edge: TrainingSessionsDataTableDataSourceType) => edge.node.endsAt,
    'link': (edge: TrainingSessionsDataTableDataSourceType) => edge.node.link,
    'location': (edge: TrainingSessionsDataTableDataSourceType) => edge.node.location,
    'modality': (edge: TrainingSessionsDataTableDataSourceType) => edge.node.modality,
    'name': (edge: TrainingSessionsDataTableDataSourceType) => edge.node.name,
    'sessionAttendances': (edge: TrainingSessionsDataTableDataSourceType) => edge.node.sessionAttendances,
    'startsAt': (edge: TrainingSessionsDataTableDataSourceType) => edge.node.startsAt,
  }
}

export function buildTrainingSessionsDataTableFilter(
  source: DataTableSource<TrainingSessionsDataTableFields, typeof TrainingSessionsDataTableSortableFields[number]>,
  filter: DataTableFilter<TrainingsSessionFilter>
) {
  return filter
}

export function useTrainingSessionsDataTable(
  projections: DataTableProjection<TrainingSessionsDataTableFields, typeof TrainingSessionsDataTableSortableFields[number]>[],
  options?: {
    variables?: TrainingSessionsDataTableQueryVariables
    defaultSort?: typeof TrainingSessionsDataTableSortableFields[number]
    identifier?: string
  }
): DataTableSource<TrainingSessionsDataTableFields, typeof TrainingSessionsDataTableSortableFields[number]> {
  const variables = options?.variables || {}
  const identifier = options?.identifier ?? 'TrainingSessionsDataTable'

  return {
    identifier,
    query: TrainingSessionsDataTableDocument,
    resolver: TrainingSessionsDataTableResolver,
    projections,
    sort: {
      default: options?.defaultSort ?? TrainingSessionsDataTableSortableFields.at(0),
      fields: TrainingSessionsDataTableSortableFields,
    },
    variables
  }
}

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockApprovalGroupEmployeesDataTableQuery(
 *   ({ query, variables }) => {
 *     const { approvalGroupId, search } = variables;
 *     return HttpResponse.json({
 *       data: { approvals }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockApprovalGroupEmployeesDataTableQuery = (resolver: GraphQLResponseResolver<ApprovalGroupEmployeesDataTableQuery, ApprovalGroupEmployeesDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ApprovalGroupEmployeesDataTableQuery, ApprovalGroupEmployeesDataTableQueryVariables>(
    'ApprovalGroupEmployeesDataTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCandidatesDataTableQuery(
 *   ({ query, variables }) => {
 *     const { active, archived, atsTagIds, consent, emails, jobPostingIds, locationIds, minimumAverageRating, rejectionReasonIds, search, sourceIds, talentPool, teamIds } = variables;
 *     return HttpResponse.json({
 *       data: { ats }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCandidatesDataTableQuery = (resolver: GraphQLResponseResolver<CandidatesDataTableQuery, CandidatesDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<CandidatesDataTableQuery, CandidatesDataTableQueryVariables>(
    'CandidatesDataTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockApplicationsDataTableQuery(
 *   ({ query, variables }) => {
 *     const { atsAnswers, atsApplicationPhaseId, atsJobPostingId, atsTagIds, qualified, search } = variables;
 *     return HttpResponse.json({
 *       data: { ats }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockApplicationsDataTableQuery = (resolver: GraphQLResponseResolver<ApplicationsDataTableQuery, ApplicationsDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ApplicationsDataTableQuery, ApplicationsDataTableQueryVariables>(
    'ApplicationsDataTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCardPaymentsDataTableQuery(
 *   ({ query, variables }) => {
 *     const { accountIds, cardIds, search } = variables;
 *     return HttpResponse.json({
 *       data: { banking }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCardPaymentsDataTableQuery = (resolver: GraphQLResponseResolver<CardPaymentsDataTableQuery, CardPaymentsDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<CardPaymentsDataTableQuery, CardPaymentsDataTableQueryVariables>(
    'CardPaymentsDataTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockPaymentExecutionTransfersDataTableQuery(
 *   ({ query, variables }) => {
 *     const { paymentExecutionId, search } = variables;
 *     return HttpResponse.json({
 *       data: { banking }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockPaymentExecutionTransfersDataTableQuery = (resolver: GraphQLResponseResolver<PaymentExecutionTransfersDataTableQuery, PaymentExecutionTransfersDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<PaymentExecutionTransfersDataTableQuery, PaymentExecutionTransfersDataTableQueryVariables>(
    'PaymentExecutionTransfersDataTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockPaymentsDataTableQuery(
 *   ({ query, variables }) => {
 *     const { search } = variables;
 *     return HttpResponse.json({
 *       data: { banking }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockPaymentsDataTableQuery = (resolver: GraphQLResponseResolver<PaymentsDataTableQuery, PaymentsDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<PaymentsDataTableQuery, PaymentsDataTableQueryVariables>(
    'PaymentsDataTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockTransfersDataTableQuery(
 *   ({ query, variables }) => {
 *     const { onlyPending, search } = variables;
 *     return HttpResponse.json({
 *       data: { banking }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockTransfersDataTableQuery = (resolver: GraphQLResponseResolver<TransfersDataTableQuery, TransfersDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<TransfersDataTableQuery, TransfersDataTableQueryVariables>(
    'TransfersDataTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCardsDataTableQuery(
 *   ({ query, variables }) => {
 *     const { bankAccountIds, companyId } = variables;
 *     return HttpResponse.json({
 *       data: { banking }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCardsDataTableQuery = (resolver: GraphQLResponseResolver<CardsDataTableQuery, CardsDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<CardsDataTableQuery, CardsDataTableQueryVariables>(
    'CardsDataTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockReconciliationInvoicesDataTableQuery(
 *   ({ query, variables }) => {
 *     const { companyId, currency, reconcilable, search } = variables;
 *     return HttpResponse.json({
 *       data: { finance }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockReconciliationInvoicesDataTableQuery = (resolver: GraphQLResponseResolver<ReconciliationInvoicesDataTableQuery, ReconciliationInvoicesDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ReconciliationInvoicesDataTableQuery, ReconciliationInvoicesDataTableQueryVariables>(
    'ReconciliationInvoicesDataTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockReconciliationTransactionDataTableQuery(
 *   ({ query, variables }) => {
 *     const { accountIds, currency, description, status } = variables;
 *     return HttpResponse.json({
 *       data: { banking }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockReconciliationTransactionDataTableQuery = (resolver: GraphQLResponseResolver<ReconciliationTransactionDataTableQuery, ReconciliationTransactionDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ReconciliationTransactionDataTableQuery, ReconciliationTransactionDataTableQueryVariables>(
    'ReconciliationTransactionDataTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockTransactionDataTableQuery(
 *   ({ query, variables }) => {
 *     const { accountIds, description, status } = variables;
 *     return HttpResponse.json({
 *       data: { banking }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockTransactionDataTableQuery = (resolver: GraphQLResponseResolver<TransactionDataTableQuery, TransactionDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<TransactionDataTableQuery, TransactionDataTableQueryVariables>(
    'TransactionDataTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockBookkeepersManagementIncidenceDataTableQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { bookkeepersManagement }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockBookkeepersManagementIncidenceDataTableQuery = (resolver: GraphQLResponseResolver<BookkeepersManagementIncidenceDataTableQuery, BookkeepersManagementIncidenceDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<BookkeepersManagementIncidenceDataTableQuery, BookkeepersManagementIncidenceDataTableQueryVariables>(
    'BookkeepersManagementIncidenceDataTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockBookkeepersManagementPayrollResultsDataTableQuery(
 *   ({ query, variables }) => {
 *     const { companyIds, periodEndsOn, periodStartsOn, status } = variables;
 *     return HttpResponse.json({
 *       data: { payroll }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockBookkeepersManagementPayrollResultsDataTableQuery = (resolver: GraphQLResponseResolver<BookkeepersManagementPayrollResultsDataTableQuery, BookkeepersManagementPayrollResultsDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<BookkeepersManagementPayrollResultsDataTableQuery, BookkeepersManagementPayrollResultsDataTableQueryVariables>(
    'BookkeepersManagementPayrollResultsDataTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockWorkingConditionsVersionEmployeesQuery(
 *   ({ query, variables }) => {
 *     const { versionId } = variables;
 *     return HttpResponse.json({
 *       data: { workingConditions }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockWorkingConditionsVersionEmployeesQuery = (resolver: GraphQLResponseResolver<WorkingConditionsVersionEmployeesQuery, WorkingConditionsVersionEmployeesQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<WorkingConditionsVersionEmployeesQuery, WorkingConditionsVersionEmployeesQueryVariables>(
    'WorkingConditionsVersionEmployees',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDocumentsDataTableQuery(
 *   ({ query, variables }) => {
 *     const { byTrashBin, byWithoutFolder, employeeId, folderId, search, space } = variables;
 *     return HttpResponse.json({
 *       data: { documents }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockDocumentsDataTableQuery = (resolver: GraphQLResponseResolver<DocumentsDataTableQuery, DocumentsDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<DocumentsDataTableQuery, DocumentsDataTableQueryVariables>(
    'DocumentsDataTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDatevLaudsEmployeesDataTableQuery(
 *   ({ query, variables }) => {
 *     const { employeeImportId, employeeType } = variables;
 *     return HttpResponse.json({
 *       data: { integrationsDatevLauds }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockDatevLaudsEmployeesDataTableQuery = (resolver: GraphQLResponseResolver<DatevLaudsEmployeesDataTableQuery, DatevLaudsEmployeesDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<DatevLaudsEmployeesDataTableQuery, DatevLaudsEmployeesDataTableQueryVariables>(
    'DatevLaudsEmployeesDataTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockErroredEmployeesDataTableQuery(
 *   ({ query, variables }) => {
 *     const { employeeImportId, employeeType } = variables;
 *     return HttpResponse.json({
 *       data: { integrationsDatevLauds }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockErroredEmployeesDataTableQuery = (resolver: GraphQLResponseResolver<ErroredEmployeesDataTableQuery, ErroredEmployeesDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ErroredEmployeesDataTableQuery, ErroredEmployeesDataTableQueryVariables>(
    'ErroredEmployeesDataTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockValidEmployeesDataTableQuery(
 *   ({ query, variables }) => {
 *     const { employeeImportId, employeeType } = variables;
 *     return HttpResponse.json({
 *       data: { integrationsDatevLauds }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockValidEmployeesDataTableQuery = (resolver: GraphQLResponseResolver<ValidEmployeesDataTableQuery, ValidEmployeesDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ValidEmployeesDataTableQuery, ValidEmployeesDataTableQueryVariables>(
    'ValidEmployeesDataTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEmployeePulseEmployeeDatatableQuery(
 *   ({ query, variables }) => {
 *     const { from, to, withTags } = variables;
 *     return HttpResponse.json({
 *       data: { engagement, teams }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEmployeePulseEmployeeDatatableQuery = (resolver: GraphQLResponseResolver<EmployeePulseEmployeeDatatableQuery, EmployeePulseEmployeeDatatableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<EmployeePulseEmployeeDatatableQuery, EmployeePulseEmployeeDatatableQueryVariables>(
    'EmployeePulseEmployeeDatatable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSignedInvoicesDataTableQuery(
 *   ({ query, variables }) => {
 *     const { invoiceState, omitSignedDocuments, receiverLegalEntityId, signedForOrganization } = variables;
 *     return HttpResponse.json({
 *       data: { companies, expenses }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSignedInvoicesDataTableQuery = (resolver: GraphQLResponseResolver<SignedInvoicesDataTableQuery, SignedInvoicesDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SignedInvoicesDataTableQuery, SignedInvoicesDataTableQueryVariables>(
    'signedInvoicesDataTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockExpensesSubscriptionMembersDatatableQuery(
 *   ({ query, variables }) => {
 *     const { accessIds, companyId } = variables;
 *     return HttpResponse.json({
 *       data: { features }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockExpensesSubscriptionMembersDatatableQuery = (resolver: GraphQLResponseResolver<ExpensesSubscriptionMembersDatatableQuery, ExpensesSubscriptionMembersDatatableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ExpensesSubscriptionMembersDatatableQuery, ExpensesSubscriptionMembersDatatableQueryVariables>(
    'ExpensesSubscriptionMembersDatatable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockExpensablesDataTableQuery(
 *   ({ query, variables }) => {
 *     const { companyId, employeeIds, from, groupIds, includeManualDrafts, search, to } = variables;
 *     return HttpResponse.json({
 *       data: { expenses }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockExpensablesDataTableQuery = (resolver: GraphQLResponseResolver<ExpensablesDataTableQuery, ExpensablesDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ExpensablesDataTableQuery, ExpensablesDataTableQueryVariables>(
    'ExpensablesDataTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockMyGroupedExpensablesDataTableQuery(
 *   ({ query, variables }) => {
 *     const { employeeIds, from, groupIds, includeManualDrafts, search, to } = variables;
 *     return HttpResponse.json({
 *       data: { expenses }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockMyGroupedExpensablesDataTableQuery = (resolver: GraphQLResponseResolver<MyGroupedExpensablesDataTableQuery, MyGroupedExpensablesDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<MyGroupedExpensablesDataTableQuery, MyGroupedExpensablesDataTableQueryVariables>(
    'MyGroupedExpensablesDataTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockExpensableGroupsDataTableQuery(
 *   ({ query, variables }) => {
 *     const { companyId, employeeIds, from, includeDrafts, search, to } = variables;
 *     return HttpResponse.json({
 *       data: { expenses }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockExpensableGroupsDataTableQuery = (resolver: GraphQLResponseResolver<ExpensableGroupsDataTableQuery, ExpensableGroupsDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ExpensableGroupsDataTableQuery, ExpensableGroupsDataTableQueryVariables>(
    'ExpensableGroupsDataTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockExpensablesByCategoryTotalsQuery(
 *   ({ query, variables }) => {
 *     const { companyId, filters, from, to } = variables;
 *     return HttpResponse.json({
 *       data: { expenses }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockExpensablesByCategoryTotalsQuery = (resolver: GraphQLResponseResolver<ExpensablesByCategoryTotalsQuery, ExpensablesByCategoryTotalsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ExpensablesByCategoryTotalsQuery, ExpensablesByCategoryTotalsQueryVariables>(
    'ExpensablesByCategoryTotals',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockExpensablesByTeamQuery(
 *   ({ query, variables }) => {
 *     const { companyId, filters, from, to } = variables;
 *     return HttpResponse.json({
 *       data: { expenses }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockExpensablesByTeamQuery = (resolver: GraphQLResponseResolver<ExpensablesByTeamQuery, ExpensablesByTeamQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ExpensablesByTeamQuery, ExpensablesByTeamQueryVariables>(
    'ExpensablesByTeam',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockExpensesByCostCenterDatatableQuery(
 *   ({ query, variables }) => {
 *     const { companyId, filters, from, to } = variables;
 *     return HttpResponse.json({
 *       data: { expenses }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockExpensesByCostCenterDatatableQuery = (resolver: GraphQLResponseResolver<ExpensesByCostCenterDatatableQuery, ExpensesByCostCenterDatatableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ExpensesByCostCenterDatatableQuery, ExpensesByCostCenterDatatableQueryVariables>(
    'ExpensesByCostCenterDatatable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockExpensesByEmployeeDatatableQuery(
 *   ({ query, variables }) => {
 *     const { companyId, filters, from, to } = variables;
 *     return HttpResponse.json({
 *       data: { expenses }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockExpensesByEmployeeDatatableQuery = (resolver: GraphQLResponseResolver<ExpensesByEmployeeDatatableQuery, ExpensesByEmployeeDatatableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ExpensesByEmployeeDatatableQuery, ExpensesByEmployeeDatatableQueryVariables>(
    'ExpensesByEmployeeDatatable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockRateConfigurationsDatatableQuery(
 *   ({ query, variables }) => {
 *     const { archivedOnly, companyId, resourceType, search } = variables;
 *     return HttpResponse.json({
 *       data: { expenses }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockRateConfigurationsDatatableQuery = (resolver: GraphQLResponseResolver<RateConfigurationsDatatableQuery, RateConfigurationsDatatableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<RateConfigurationsDatatableQuery, RateConfigurationsDatatableQueryVariables>(
    'RateConfigurationsDatatable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockRateConfigurationAssigneesQuery(
 *   ({ query, variables }) => {
 *     const { rateIds, search } = variables;
 *     return HttpResponse.json({
 *       data: { expenses }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockRateConfigurationAssigneesQuery = (resolver: GraphQLResponseResolver<RateConfigurationAssigneesQuery, RateConfigurationAssigneesQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<RateConfigurationAssigneesQuery, RateConfigurationAssigneesQueryVariables>(
    'RateConfigurationAssignees',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockLedgerAccountsDataTableQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { finance }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockLedgerAccountsDataTableQuery = (resolver: GraphQLResponseResolver<LedgerAccountsDataTableQuery, LedgerAccountsDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<LedgerAccountsDataTableQuery, LedgerAccountsDataTableQueryVariables>(
    'LedgerAccountsDataTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockMissingAgreementDataTableQuery(
 *   ({ query, variables }) => {
 *     const { costCenterIds, formattedEndDate, formattedStartDate, includeFuturePeriods, legalEntityIds, locationIds, managerIds, period } = variables;
 *     return HttpResponse.json({
 *       data: { financialWorkspace }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockMissingAgreementDataTableQuery = (resolver: GraphQLResponseResolver<MissingAgreementDataTableQuery, MissingAgreementDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<MissingAgreementDataTableQuery, MissingAgreementDataTableQueryVariables>(
    'MissingAgreementDataTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockInvoicesDataTableQuery(
 *   ({ query, variables }) => {
 *     const { companyId, documentTypes, operationTypes, search, vendorId } = variables;
 *     return HttpResponse.json({
 *       data: { finance }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockInvoicesDataTableQuery = (resolver: GraphQLResponseResolver<InvoicesDataTableQuery, InvoicesDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<InvoicesDataTableQuery, InvoicesDataTableQueryVariables>(
    'InvoicesDataTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockJournalDraftEntryDatableQuery(
 *   ({ query, variables }) => {
 *     const { companyId, legalEntityIds } = variables;
 *     return HttpResponse.json({
 *       data: { finance }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockJournalDraftEntryDatableQuery = (resolver: GraphQLResponseResolver<JournalDraftEntryDatableQuery, JournalDraftEntryDatableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<JournalDraftEntryDatableQuery, JournalDraftEntryDatableQueryVariables>(
    'JournalDraftEntryDatable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockJournalEntryDatableQuery(
 *   ({ query, variables }) => {
 *     const { companyId, legalEntityIds } = variables;
 *     return HttpResponse.json({
 *       data: { finance }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockJournalEntryDatableQuery = (resolver: GraphQLResponseResolver<JournalEntryDatableQuery, JournalEntryDatableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<JournalEntryDatableQuery, JournalEntryDatableQueryVariables>(
    'JournalEntryDatable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockLedgerAccountDetailDataTableQuery(
 *   ({ query, variables }) => {
 *     const { ledgerAccountId } = variables;
 *     return HttpResponse.json({
 *       data: { finance }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockLedgerAccountDetailDataTableQuery = (resolver: GraphQLResponseResolver<LedgerAccountDetailDataTableQuery, LedgerAccountDetailDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<LedgerAccountDetailDataTableQuery, LedgerAccountDetailDataTableQueryVariables>(
    'LedgerAccountDetailDataTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockReconciliationJournalLinesDataTableQuery(
 *   ({ query, variables }) => {
 *     const { allowedJournalEntryTypes, balanceTypes, bySuspenseAccount, currency, description, excludingJournalEntryTypes, reconcilable } = variables;
 *     return HttpResponse.json({
 *       data: { finance }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockReconciliationJournalLinesDataTableQuery = (resolver: GraphQLResponseResolver<ReconciliationJournalLinesDataTableQuery, ReconciliationJournalLinesDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ReconciliationJournalLinesDataTableQuery, ReconciliationJournalLinesDataTableQueryVariables>(
    'ReconciliationJournalLinesDataTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockReconciliationBankJournalLinesDataTableQuery(
 *   ({ query, variables }) => {
 *     const { bankAccountIds, description } = variables;
 *     return HttpResponse.json({
 *       data: { finance }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockReconciliationBankJournalLinesDataTableQuery = (resolver: GraphQLResponseResolver<ReconciliationBankJournalLinesDataTableQuery, ReconciliationBankJournalLinesDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ReconciliationBankJournalLinesDataTableQuery, ReconciliationBankJournalLinesDataTableQueryVariables>(
    'ReconciliationBankJournalLinesDataTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockTaxTypeDatableQuery(
 *   ({ query, variables }) => {
 *     const { search } = variables;
 *     return HttpResponse.json({
 *       data: { finance }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockTaxTypeDatableQuery = (resolver: GraphQLResponseResolver<TaxTypeDatableQuery, TaxTypeDatableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<TaxTypeDatableQuery, TaxTypeDatableQueryVariables>(
    'TaxTypeDatable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockBudgetMovementsDatatableQuery(
 *   ({ query, variables }) => {
 *     const { id, periodEnd, periodStart, search } = variables;
 *     return HttpResponse.json({
 *       data: { finance }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockBudgetMovementsDatatableQuery = (resolver: GraphQLResponseResolver<BudgetMovementsDatatableQuery, BudgetMovementsDatatableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<BudgetMovementsDatatableQuery, BudgetMovementsDatatableQueryVariables>(
    'BudgetMovementsDatatable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockBudgetEmployeesDatatableQuery(
 *   ({ query, variables }) => {
 *     const { id, periodEnd, periodStart, search } = variables;
 *     return HttpResponse.json({
 *       data: { finance }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockBudgetEmployeesDatatableQuery = (resolver: GraphQLResponseResolver<BudgetEmployeesDatatableQuery, BudgetEmployeesDatatableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<BudgetEmployeesDatatableQuery, BudgetEmployeesDatatableQueryVariables>(
    'BudgetEmployeesDatatable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockFinanceDimensionValuesDataTableQuery(
 *   ({ query, variables }) => {
 *     const { dimensionId, tenant } = variables;
 *     return HttpResponse.json({
 *       data: { finance }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockFinanceDimensionValuesDataTableQuery = (resolver: GraphQLResponseResolver<FinanceDimensionValuesDataTableQuery, FinanceDimensionValuesDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<FinanceDimensionValuesDataTableQuery, FinanceDimensionValuesDataTableQueryVariables>(
    'FinanceDimensionValuesDataTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockPerformanceGoalsMetricGroupDataTableQuery(
 *   ({ query, variables }) => {
 *     const { cycleIds, noCycle, search } = variables;
 *     return HttpResponse.json({
 *       data: { goals }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockPerformanceGoalsMetricGroupDataTableQuery = (resolver: GraphQLResponseResolver<PerformanceGoalsMetricGroupDataTableQuery, PerformanceGoalsMetricGroupDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<PerformanceGoalsMetricGroupDataTableQuery, PerformanceGoalsMetricGroupDataTableQueryVariables>(
    'PerformanceGoalsMetricGroupDataTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockPerformanceGoalsPeopleDataTableQuery(
 *   ({ query, variables }) => {
 *     const { cycleIds, noCycle, onlyDirectReports, search } = variables;
 *     return HttpResponse.json({
 *       data: { goals }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockPerformanceGoalsPeopleDataTableQuery = (resolver: GraphQLResponseResolver<PerformanceGoalsPeopleDataTableQuery, PerformanceGoalsPeopleDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<PerformanceGoalsPeopleDataTableQuery, PerformanceGoalsPeopleDataTableQueryVariables>(
    'PerformanceGoalsPeopleDataTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockInsightsHeadcountDataTableQuery(
 *   ({ query, variables }) => {
 *     const { contractDate, employeeIds } = variables;
 *     return HttpResponse.json({
 *       data: { employees }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockInsightsHeadcountDataTableQuery = (resolver: GraphQLResponseResolver<InsightsHeadcountDataTableQuery, InsightsHeadcountDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<InsightsHeadcountDataTableQuery, InsightsHeadcountDataTableQueryVariables>(
    'InsightsHeadcountDataTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockTaskDataTableQuery(
 *   ({ query, variables }) => {
 *     const { meetingIds } = variables;
 *     return HttpResponse.json({
 *       data: { oneOnOnes }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockTaskDataTableQuery = (resolver: GraphQLResponseResolver<TaskDataTableQuery, TaskDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<TaskDataTableQuery, TaskDataTableQueryVariables>(
    'TaskDataTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockPerformanceInsightsSummaryDatatableQuery(
 *   ({ query, variables }) => {
 *     const { pulseFrom, pulseTo } = variables;
 *     return HttpResponse.json({
 *       data: { performance }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockPerformanceInsightsSummaryDatatableQuery = (resolver: GraphQLResponseResolver<PerformanceInsightsSummaryDatatableQuery, PerformanceInsightsSummaryDatatableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<PerformanceInsightsSummaryDatatableQuery, PerformanceInsightsSummaryDatatableQueryVariables>(
    'PerformanceInsightsSummaryDatatable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockPerformanceCyclesDataTableQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { performanceCycles }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockPerformanceCyclesDataTableQuery = (resolver: GraphQLResponseResolver<PerformanceCyclesDataTableQuery, PerformanceCyclesDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<PerformanceCyclesDataTableQuery, PerformanceCyclesDataTableQueryVariables>(
    'PerformanceCyclesDataTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockPerformanceProcessPendingReviewersDataTableQuery(
 *   ({ query, variables }) => {
 *     const { ids } = variables;
 *     return HttpResponse.json({
 *       data: { apiCore }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockPerformanceProcessPendingReviewersDataTableQuery = (resolver: GraphQLResponseResolver<PerformanceProcessPendingReviewersDataTableQuery, PerformanceProcessPendingReviewersDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<PerformanceProcessPendingReviewersDataTableQuery, PerformanceProcessPendingReviewersDataTableQueryVariables>(
    'PerformanceProcessPendingReviewersDataTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockProcessTargetDataTableQuery(
 *   ({ query, variables }) => {
 *     const { agreementCompletionStatus, employeeIds, evaluationsCompletionStatus, finalScores, legalEntityIds, managedByFilter, performanceReviewProcessIds, searchValue, teamIds, tenureDates, workplaceIds } = variables;
 *     return HttpResponse.json({
 *       data: { performance }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockProcessTargetDataTableQuery = (resolver: GraphQLResponseResolver<ProcessTargetDataTableQuery, ProcessTargetDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ProcessTargetDataTableQuery, ProcessTargetDataTableQueryVariables>(
    'ProcessTargetDataTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockProcessTargetForPeerAssignmentDataTableQuery(
 *   ({ query, variables }) => {
 *     const { performanceReviewProcessIds, searchValue } = variables;
 *     return HttpResponse.json({
 *       data: { performance }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockProcessTargetForPeerAssignmentDataTableQuery = (resolver: GraphQLResponseResolver<ProcessTargetForPeerAssignmentDataTableQuery, ProcessTargetForPeerAssignmentDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ProcessTargetForPeerAssignmentDataTableQuery, ProcessTargetForPeerAssignmentDataTableQueryVariables>(
    'ProcessTargetForPeerAssignmentDataTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockPastCoursesDatatableQuery(
 *   ({ query, variables }) => {
 *     const { accessId } = variables;
 *     return HttpResponse.json({
 *       data: { trainings }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockPastCoursesDatatableQuery = (resolver: GraphQLResponseResolver<PastCoursesDatatableQuery, PastCoursesDatatableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<PastCoursesDatatableQuery, PastCoursesDatatableQueryVariables>(
    'PastCoursesDatatable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockTargetGroupDataTableQuery(
 *   ({ query, variables }) => {
 *     const { id, searchValue } = variables;
 *     return HttpResponse.json({
 *       data: { performance }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockTargetGroupDataTableQuery = (resolver: GraphQLResponseResolver<TargetGroupDataTableQuery, TargetGroupDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<TargetGroupDataTableQuery, TargetGroupDataTableQueryVariables>(
    'TargetGroupDataTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockPerformanceReviewsDataTableQuery(
 *   ({ query, variables }) => {
 *     const { ids, includeParticipation, search } = variables;
 *     return HttpResponse.json({
 *       data: { performance }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockPerformanceReviewsDataTableQuery = (resolver: GraphQLResponseResolver<PerformanceReviewsDataTableQuery, PerformanceReviewsDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<PerformanceReviewsDataTableQuery, PerformanceReviewsDataTableQueryVariables>(
    'PerformanceReviewsDataTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockTemplateTargetGroupDataTableQuery(
 *   ({ query, variables }) => {
 *     const { customTemplateId, searchValue } = variables;
 *     return HttpResponse.json({
 *       data: { performance }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockTemplateTargetGroupDataTableQuery = (resolver: GraphQLResponseResolver<TemplateTargetGroupDataTableQuery, TemplateTargetGroupDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<TemplateTargetGroupDataTableQuery, TemplateTargetGroupDataTableQueryVariables>(
    'TemplateTargetGroupDataTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCustomTemplatesDataTableQuery(
 *   ({ query, variables }) => {
 *     const { ids, search } = variables;
 *     return HttpResponse.json({
 *       data: { performance }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCustomTemplatesDataTableQuery = (resolver: GraphQLResponseResolver<CustomTemplatesDataTableQuery, CustomTemplatesDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<CustomTemplatesDataTableQuery, CustomTemplatesDataTableQueryVariables>(
    'CustomTemplatesDataTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockPredefinedTemplatesDataTableQuery(
 *   ({ query, variables }) => {
 *     const { ids, search } = variables;
 *     return HttpResponse.json({
 *       data: { performance }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockPredefinedTemplatesDataTableQuery = (resolver: GraphQLResponseResolver<PredefinedTemplatesDataTableQuery, PredefinedTemplatesDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<PredefinedTemplatesDataTableQuery, PredefinedTemplatesDataTableQueryVariables>(
    'PredefinedTemplatesDataTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockTargetProcessesDataTableQuery(
 *   ({ query, variables }) => {
 *     const { accessIds } = variables;
 *     return HttpResponse.json({
 *       data: { performance }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockTargetProcessesDataTableQuery = (resolver: GraphQLResponseResolver<TargetProcessesDataTableQuery, TargetProcessesDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<TargetProcessesDataTableQuery, TargetProcessesDataTableQueryVariables>(
    'TargetProcessesDataTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockMandatoryProcessTasksQuery(
 *   ({ query, variables }) => {
 *     const { category, mandatory, processId, search } = variables;
 *     return HttpResponse.json({
 *       data: { tasks }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockMandatoryProcessTasksQuery = (resolver: GraphQLResponseResolver<MandatoryProcessTasksQuery, MandatoryProcessTasksQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<MandatoryProcessTasksQuery, MandatoryProcessTasksQueryVariables>(
    'MandatoryProcessTasks',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockMaterializedProcessesDataTableQuery(
 *   ({ query, variables }) => {
 *     const { ids, includeItemsCount, materializedTasksAccessId, processId, search } = variables;
 *     return HttpResponse.json({
 *       data: { processes }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockMaterializedProcessesDataTableQuery = (resolver: GraphQLResponseResolver<MaterializedProcessesDataTableQuery, MaterializedProcessesDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<MaterializedProcessesDataTableQuery, MaterializedProcessesDataTableQueryVariables>(
    'MaterializedProcessesDataTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockProcurementPurchaseOrdersInvoicesDatatableQuery(
 *   ({ query, variables }) => {
 *     const { companyId, ids } = variables;
 *     return HttpResponse.json({
 *       data: { finance }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockProcurementPurchaseOrdersInvoicesDatatableQuery = (resolver: GraphQLResponseResolver<ProcurementPurchaseOrdersInvoicesDatatableQuery, ProcurementPurchaseOrdersInvoicesDatatableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ProcurementPurchaseOrdersInvoicesDatatableQuery, ProcurementPurchaseOrdersInvoicesDatatableQueryVariables>(
    'ProcurementPurchaseOrdersInvoicesDatatable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockProcurementPurchaseOrdersDatatableQuery(
 *   ({ query, variables }) => {
 *     const { companyId, search, status, vendorId } = variables;
 *     return HttpResponse.json({
 *       data: { procurement }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockProcurementPurchaseOrdersDatatableQuery = (resolver: GraphQLResponseResolver<ProcurementPurchaseOrdersDatatableQuery, ProcurementPurchaseOrdersDatatableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ProcurementPurchaseOrdersDatatableQuery, ProcurementPurchaseOrdersDatatableQueryVariables>(
    'ProcurementPurchaseOrdersDatatable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockProcurementMyPurchaseRequestsDatatableQuery(
 *   ({ query, variables }) => {
 *     const { companyId, requesterEmployeeIds } = variables;
 *     return HttpResponse.json({
 *       data: { procurement }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockProcurementMyPurchaseRequestsDatatableQuery = (resolver: GraphQLResponseResolver<ProcurementMyPurchaseRequestsDatatableQuery, ProcurementMyPurchaseRequestsDatatableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ProcurementMyPurchaseRequestsDatatableQuery, ProcurementMyPurchaseRequestsDatatableQueryVariables>(
    'ProcurementMyPurchaseRequestsDatatable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockProcurementPurchaseRequestsDatatableQuery(
 *   ({ query, variables }) => {
 *     const { companyId, onlyMyPendingApprovals, search } = variables;
 *     return HttpResponse.json({
 *       data: { procurement }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockProcurementPurchaseRequestsDatatableQuery = (resolver: GraphQLResponseResolver<ProcurementPurchaseRequestsDatatableQuery, ProcurementPurchaseRequestsDatatableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ProcurementPurchaseRequestsDatatableQuery, ProcurementPurchaseRequestsDatatableQueryVariables>(
    'ProcurementPurchaseRequestsDatatable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockProjectTasksDataTableQuery(
 *   ({ query, variables }) => {
 *     const { projectIds, search } = variables;
 *     return HttpResponse.json({
 *       data: { projectManagement }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockProjectTasksDataTableQuery = (resolver: GraphQLResponseResolver<ProjectTasksDataTableQuery, ProjectTasksDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ProjectTasksDataTableQuery, ProjectTasksDataTableQueryVariables>(
    'ProjectTasksDataTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetExpensesDatatableExportQuery(
 *   ({ query, variables }) => {
 *     const { endDate, projectIds, startDate } = variables;
 *     return HttpResponse.json({
 *       data: { projectManagement }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetExpensesDatatableExportQuery = (resolver: GraphQLResponseResolver<GetExpensesDatatableExportQuery, GetExpensesDatatableExportQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetExpensesDatatableExportQuery, GetExpensesDatatableExportQueryVariables>(
    'GetExpensesDatatableExport',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetProjectsDatatableExportQuery(
 *   ({ query, variables }) => {
 *     const { companyId, dateGroup, endDate, includeClient, includeDate, includeEmployeesWithoutTimeTracked, includeSubprojects, projectIds, startDate, timeFormat } = variables;
 *     return HttpResponse.json({
 *       data: { projectManagement }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetProjectsDatatableExportQuery = (resolver: GraphQLResponseResolver<GetProjectsDatatableExportQuery, GetProjectsDatatableExportQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetProjectsDatatableExportQuery, GetProjectsDatatableExportQueryVariables>(
    'GetProjectsDatatableExport',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetShiftsDatatableExportQuery(
 *   ({ query, variables }) => {
 *     const { employeeIds, endDate, includeSubprojects, sortByEmployee, startDate, timeFormat } = variables;
 *     return HttpResponse.json({
 *       data: { projectManagement }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetShiftsDatatableExportQuery = (resolver: GraphQLResponseResolver<GetShiftsDatatableExportQuery, GetShiftsDatatableExportQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetShiftsDatatableExportQuery, GetShiftsDatatableExportQueryVariables>(
    'GetShiftsDatatableExport',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetTasksDatatableExportQuery(
 *   ({ query, variables }) => {
 *     const { endDate, projectIds, startDate } = variables;
 *     return HttpResponse.json({
 *       data: { projectManagement }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetTasksDatatableExportQuery = (resolver: GraphQLResponseResolver<GetTasksDatatableExportQuery, GetTasksDatatableExportQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetTasksDatatableExportQuery, GetTasksDatatableExportQueryVariables>(
    'GetTasksDatatableExport',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEmployeesMembershipDataTableQuery(
 *   ({ query, variables }) => {
 *     const { search, softwareSetupIds } = variables;
 *     return HttpResponse.json({
 *       data: { softwareManagement }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEmployeesMembershipDataTableQuery = (resolver: GraphQLResponseResolver<EmployeesMembershipDataTableQuery, EmployeesMembershipDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<EmployeesMembershipDataTableQuery, EmployeesMembershipDataTableQueryVariables>(
    'EmployeesMembershipDataTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSoftwarePaymentsDataTableQuery(
 *   ({ query, variables }) => {
 *     const { companyId, softwareSetupId } = variables;
 *     return HttpResponse.json({
 *       data: { softwareManagement }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSoftwarePaymentsDataTableQuery = (resolver: GraphQLResponseResolver<SoftwarePaymentsDataTableQuery, SoftwarePaymentsDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SoftwarePaymentsDataTableQuery, SoftwarePaymentsDataTableQueryVariables>(
    'SoftwarePaymentsDataTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEmployeeListForSoftwareDataTableQuery(
 *   ({ query, variables }) => {
 *     const { onlyTerminated, search, softwareSetupIds, withSoftware } = variables;
 *     return HttpResponse.json({
 *       data: { softwareManagement }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEmployeeListForSoftwareDataTableQuery = (resolver: GraphQLResponseResolver<EmployeeListForSoftwareDataTableQuery, EmployeeListForSoftwareDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<EmployeeListForSoftwareDataTableQuery, EmployeeListForSoftwareDataTableQueryVariables>(
    'EmployeeListForSoftwareDataTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetBookingsDataTableQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { spaceControl }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetBookingsDataTableQuery = (resolver: GraphQLResponseResolver<GetBookingsDataTableQuery, GetBookingsDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetBookingsDataTableQuery, GetBookingsDataTableQueryVariables>(
    'GetBookingsDataTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetTasksDataTableQuery(
 *   ({ query, variables }) => {
 *     const { assigneeId, authorId, identifier, ids, involveeId, search, status, taskStatus } = variables;
 *     return HttpResponse.json({
 *       data: { tasks }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetTasksDataTableQuery = (resolver: GraphQLResponseResolver<GetTasksDataTableQuery, GetTasksDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetTasksDataTableQuery, GetTasksDataTableQueryVariables>(
    'GetTasksDataTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockTrainingsCategoriesDataTableQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { trainings }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockTrainingsCategoriesDataTableQuery = (resolver: GraphQLResponseResolver<TrainingsCategoriesDataTableQuery, TrainingsCategoriesDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<TrainingsCategoriesDataTableQuery, TrainingsCategoriesDataTableQueryVariables>(
    'TrainingsCategoriesDataTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockMyTrainingsDatatableQuery(
 *   ({ query, variables }) => {
 *     const { accessId, next, onlyAssigned, search, status } = variables;
 *     return HttpResponse.json({
 *       data: { trainings }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockMyTrainingsDatatableQuery = (resolver: GraphQLResponseResolver<MyTrainingsDatatableQuery, MyTrainingsDatatableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<MyTrainingsDatatableQuery, MyTrainingsDatatableQueryVariables>(
    'MyTrainingsDatatable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockMyTrainingRequestsDatatableQuery(
 *   ({ query, variables }) => {
 *     const { authorId, companyId, employeeIds, employeesOrAuthor, search, status } = variables;
 *     return HttpResponse.json({
 *       data: { trainings }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockMyTrainingRequestsDatatableQuery = (resolver: GraphQLResponseResolver<MyTrainingRequestsDatatableQuery, MyTrainingRequestsDatatableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<MyTrainingRequestsDatatableQuery, MyTrainingRequestsDatatableQueryVariables>(
    'MyTrainingRequestsDatatable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockTrainingRequestsDatatableQuery(
 *   ({ query, variables }) => {
 *     const { authorId, employeeIds, employeesOrAuthor, search } = variables;
 *     return HttpResponse.json({
 *       data: { trainings }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockTrainingRequestsDatatableQuery = (resolver: GraphQLResponseResolver<TrainingRequestsDatatableQuery, TrainingRequestsDatatableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<TrainingRequestsDatatableQuery, TrainingRequestsDatatableQueryVariables>(
    'TrainingRequestsDatatable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockTrainingFormsDatatableQuery(
 *   ({ query, variables }) => {
 *     const { resourceId, search } = variables;
 *     return HttpResponse.json({
 *       data: { forms }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockTrainingFormsDatatableQuery = (resolver: GraphQLResponseResolver<TrainingFormsDatatableQuery, TrainingFormsDatatableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<TrainingFormsDatatableQuery, TrainingFormsDatatableQueryVariables>(
    'TrainingFormsDatatable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockFundaeFinishGroupDatatableQuery(
 *   ({ query, variables }) => {
 *     const { search, trainingClassId } = variables;
 *     return HttpResponse.json({
 *       data: { contracts, trainings }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockFundaeFinishGroupDatatableQuery = (resolver: GraphQLResponseResolver<FundaeFinishGroupDatatableQuery, FundaeFinishGroupDatatableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<FundaeFinishGroupDatatableQuery, FundaeFinishGroupDatatableQueryVariables>(
    'FundaeFinishGroupDatatable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockMySessionsDataTableQuery(
 *   ({ query, variables }) => {
 *     const { accessId, search, trainingId } = variables;
 *     return HttpResponse.json({
 *       data: { trainings }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockMySessionsDataTableQuery = (resolver: GraphQLResponseResolver<MySessionsDataTableQuery, MySessionsDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<MySessionsDataTableQuery, MySessionsDataTableQueryVariables>(
    'MySessionsDataTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockRemindersDataTableQuery(
 *   ({ query, variables }) => {
 *     const { sessionId } = variables;
 *     return HttpResponse.json({
 *       data: { trainings }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockRemindersDataTableQuery = (resolver: GraphQLResponseResolver<RemindersDataTableQuery, RemindersDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<RemindersDataTableQuery, RemindersDataTableQueryVariables>(
    'RemindersDataTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSessionAccessMembershipsDataTableQuery(
 *   ({ query, variables }) => {
 *     const { search, sessionId } = variables;
 *     return HttpResponse.json({
 *       data: { trainings }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSessionAccessMembershipsDataTableQuery = (resolver: GraphQLResponseResolver<SessionAccessMembershipsDataTableQuery, SessionAccessMembershipsDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SessionAccessMembershipsDataTableQuery, SessionAccessMembershipsDataTableQueryVariables>(
    'SessionAccessMembershipsDataTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSessionsDataTableQuery(
 *   ({ query, variables }) => {
 *     const { search, trainingIds } = variables;
 *     return HttpResponse.json({
 *       data: { trainings }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSessionsDataTableQuery = (resolver: GraphQLResponseResolver<SessionsDataTableQuery, SessionsDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SessionsDataTableQuery, SessionsDataTableQueryVariables>(
    'SessionsDataTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockTrainingClassMembershipsDatatableQuery(
 *   ({ query, variables }) => {
 *     const { ids, search, trainingClassId } = variables;
 *     return HttpResponse.json({
 *       data: { trainings }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockTrainingClassMembershipsDatatableQuery = (resolver: GraphQLResponseResolver<TrainingClassMembershipsDatatableQuery, TrainingClassMembershipsDatatableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<TrainingClassMembershipsDatatableQuery, TrainingClassMembershipsDatatableQueryVariables>(
    'TrainingClassMembershipsDatatable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockTrainingSessionsByEmployeeDataTableQuery(
 *   ({ query, variables }) => {
 *     const { accessId, search, trainingClassIds } = variables;
 *     return HttpResponse.json({
 *       data: { trainings }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockTrainingSessionsByEmployeeDataTableQuery = (resolver: GraphQLResponseResolver<TrainingSessionsByEmployeeDataTableQuery, TrainingSessionsByEmployeeDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<TrainingSessionsByEmployeeDataTableQuery, TrainingSessionsByEmployeeDataTableQueryVariables>(
    'TrainingSessionsByEmployeeDataTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockTrainingMembershipsDataTableQuery(
 *   ({ query, variables }) => {
 *     const { ids, search, trainingId } = variables;
 *     return HttpResponse.json({
 *       data: { trainings }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockTrainingMembershipsDataTableQuery = (resolver: GraphQLResponseResolver<TrainingMembershipsDataTableQuery, TrainingMembershipsDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<TrainingMembershipsDataTableQuery, TrainingMembershipsDataTableQueryVariables>(
    'TrainingMembershipsDataTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockTrainingsDataTableQuery(
 *   ({ query, variables }) => {
 *     const { catalog, search, status, withExpiredMemberships } = variables;
 *     return HttpResponse.json({
 *       data: { trainings }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockTrainingsDataTableQuery = (resolver: GraphQLResponseResolver<TrainingsDataTableQuery, TrainingsDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<TrainingsDataTableQuery, TrainingsDataTableQueryVariables>(
    'TrainingsDataTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockMyTrainingsCatalogSessionsDataTableQuery(
 *   ({ query, variables }) => {
 *     const { search, startsAfter, trainingId } = variables;
 *     return HttpResponse.json({
 *       data: { trainings }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockMyTrainingsCatalogSessionsDataTableQuery = (resolver: GraphQLResponseResolver<MyTrainingsCatalogSessionsDataTableQuery, MyTrainingsCatalogSessionsDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<MyTrainingsCatalogSessionsDataTableQuery, MyTrainingsCatalogSessionsDataTableQueryVariables>(
    'MyTrainingsCatalogSessionsDataTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockTrainingSessionsDataTableQuery(
 *   ({ query, variables }) => {
 *     const { search, trainingClassIds } = variables;
 *     return HttpResponse.json({
 *       data: { trainings }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockTrainingSessionsDataTableQuery = (resolver: GraphQLResponseResolver<TrainingSessionsDataTableQuery, TrainingSessionsDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<TrainingSessionsDataTableQuery, TrainingSessionsDataTableQueryVariables>(
    'TrainingSessionsDataTable',
    resolver,
    options
  )
